import { cloneDeep, compact, deburr, defaultTo, dropRightWhile, findLast, findLastIndex, first, get, groupBy, has, intersection, intersectionBy, invert, isArray, isBoolean, isDate, isEmpty, isEqual, isEqualWith, isFinite, isNaN, isNil, isNumber, isPlainObject, isUndefined, last, mapValues, max, maxBy, merge, mergeWith, min, minBy, omit, omitBy, partition, pick, pickBy, range, round, set, sortBy, sum, times, unescape, uniq, uniqBy, unset } from "lodash";
import { CloneRest, CloneType, FormatRegistry, Kind, Never, Strict, TemplateLiteralToUnion, Type, TypeBoxError, TypeGuard, TypeRegistry, Unsafe } from "@sinclair/typebox";
import { SheetFormatters, addressFormatter, booleanGermanYesNoFormatter, booleanYesNoFormatter, createLocaleNumberFormatters, currency, formatDate, formatDateArray, formatFloor, intlDateFormat, localNumberFormat, mapArrayToYesNo, mapArrayWithLookup, multiple, perSquareMeter, percent, percentage, spreadsheetDateToJsDate, squareMeter, toTitleCase } from "@condo/formatters";
import { BaseError, DateFormats, EMPTY_VAL, ErrorSeverity, ErrorTag, NonRetriableError, RetriableError, arePeriodsOverlapping, calculatePartialMonthRatio, compressResponse, days360, decompressResponse, deepOmitBy, extractDate, firstFiniteNumber, firstNonEmptyString, floatBiggerThan, floatEquals, formatDate as formatDate$1, getAddressLine, getPrefixSumArrayWithInflation, isBefore, isPresent, round as round$1, roundByBankersMethod, roundUpToNearest, safeDifference, safeMul, safeSum, sameDay, serializeError, sortByDate, transposeObjects, undefinedWhenEmpty } from "@condo/helpers";
import unidecode from "unidecode";
import _isArray from "lodash/isArray.js";
import _isEmpty from "lodash/isEmpty.js";
import _isPlainObject from "lodash/isPlainObject.js";
import { Check, Value } from "@sinclair/typebox/value";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter.js";
import dayjsTimezone from "dayjs/plugin/timezone.js";
import dayjsUtc from "dayjs/plugin/utc.js";
import Decimal$1, { Decimal } from "decimal.js";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore.js";
import localeDe from "dayjs/locale/de.js";
import isBetween from "dayjs/plugin/isBetween.js";
import _get from "lodash/get.js";
import _set from "lodash/set.js";
import _maxBy from "lodash/maxBy.js";
import _omit from "lodash/omit.js";
import _pick from "lodash/pick.js";
import minMax from "dayjs/plugin/minMax.js";
import { TypeCompiler } from "@sinclair/typebox/compiler";
import customParseFormat from "dayjs/plugin/customParseFormat.js";
import { SupportedVersions } from "@condo/sdk/calcengine";
import { satisfies } from "semver";
import stc from "string-to-color";
import Ajv from "ajv";
import addFormats from "ajv-formats";
import clamp from "lodash/clamp.js";
import deburr$1 from "lodash/deburr.js";
import { convert } from "html-to-text";
import _filter from "lodash/filter.js";
import { RateInterval, convertRate, xirr } from "node-irr";
//#region \0rolldown/runtime.js
var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", {
	value,
	configurable: true
});
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __esmMin = (fn, res, err) => () => {
	if (err) throw err[0];
	try {
		return fn && (res = fn(fn = 0)), res;
	} catch (e) {
		throw err = [e], e;
	}
};
var __exportAll = (all, no_symbols) => {
	let target = {};
	for (var name in all) __defProp(target, name, {
		get: all[name],
		enumerable: true
	});
	if (!no_symbols) __defProp(target, Symbol.toStringTag, { value: "Module" });
	return target;
};
var __copyProps = (to, from, except, desc) => {
	if (from && typeof from === "object" || typeof from === "function") for (var keys = __getOwnPropNames(from), i = 0, n = keys.length, key; i < n; i++) {
		key = keys[i];
		if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
			get: ((k) => from[k]).bind(null, key),
			enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
		});
	}
	return to;
};
var __toCommonJS = (mod) => __hasOwnProp.call(mod, "module.exports") ? mod["module.exports"] : __copyProps(__defProp({}, "__esModule", { value: true }), mod);
//#endregion
//#region src/lib/context.ts
var init_context = __esmMin((() => {}));
//#endregion
//#region src/lib/env-config.ts
var EnvironmentName, mapNodeEnvToShortEnvironmentName;
var init_env_config = __esmMin((() => {
	EnvironmentName = /* @__PURE__ */ function(EnvironmentName) {
		EnvironmentName["Prod"] = "prod";
		EnvironmentName["Dev"] = "dev";
		EnvironmentName["Staging"] = "stg";
		EnvironmentName["Local"] = "local";
		EnvironmentName["Preview"] = "prev";
		return EnvironmentName;
	}({});
	mapNodeEnvToShortEnvironmentName = (nodeEnv = process.env.NODE_ENV) => {
		switch (nodeEnv) {
			case "production": return "prod";
			case "development": return "dev";
			case "staging": return "stg";
			case "preview": return "prev";
			case "local":
			case "test": return "local";
			default: throw new Error(`Unknown node-environment, refusing to map env: ${nodeEnv}`);
		}
	};
}));
//#endregion
//#region src/__unsorted/legacy-events.ts
var FilterableEventType, CondoEventSource, CondoEvents;
var init_legacy_events = __esmMin((() => {
	FilterableEventType = /* @__PURE__ */ function(FilterableEventType) {
		FilterableEventType["Invoice"] = "Invoice";
		FilterableEventType["Portfolio"] = "Portfolio";
		FilterableEventType["Defect"] = "Defect";
		FilterableEventType["ConstructionPlan"] = "ConstructionPlan";
		FilterableEventType["Investment"] = "Investment";
		FilterableEventType["Task"] = "Task";
		FilterableEventType["Document"] = "Document";
		FilterableEventType["Note"] = "Note";
		FilterableEventType["SalesPackage"] = "SalesPackage";
		FilterableEventType["MFH"] = "MFH";
		FilterableEventType["MFHBuilding"] = "MFHBuilding";
		FilterableEventType["MFHPortfolio"] = "MFHPortfolio";
		FilterableEventType["MFHRenovationProject"] = "MFHRenovationProject";
		FilterableEventType["MFHRenovationProjectPlanningModule"] = "MFHRenovationProjectPlanningModule";
		FilterableEventType["MFHRenovationProjectPosition"] = "MFHRenovationProjectPosition";
		FilterableEventType["MFHRenovationProjectCostBreakdown"] = "MFHRenovationProjectCostBreakdown";
		FilterableEventType["MFHRenovationProjectLot"] = "MFHRenovationProjectLot";
		FilterableEventType["SignOffEnvelope"] = "SignOffEnvelope";
		FilterableEventType["SignOffDocument"] = "SignOffDocument";
		FilterableEventType["SignOffComment"] = "SignOffComment";
		FilterableEventType["Addendum"] = "Addendum";
		return FilterableEventType;
	}({});
	CondoEventSource = /* @__PURE__ */ function(CondoEventSource) {
		CondoEventSource["User"] = "User";
		CondoEventSource["System"] = "System";
		return CondoEventSource;
	}({});
	CondoEvents = /* @__PURE__ */ function(CondoEvents) {
		CondoEvents["EstateAdded"] = "EstateAdded";
		CondoEvents["NoteAdded"] = "NoteAdded";
		CondoEvents["Restored"] = "Restored";
		CondoEvents["DocumentAdded"] = "DocumentAdded";
		CondoEvents["DocumentDeleted"] = "DocumentDeleted";
		CondoEvents["Cancel"] = "Cancel";
		CondoEvents["Reset"] = "Reset";
		CondoEvents["Restart"] = "Restart";
		CondoEvents["ListingRemoved"] = "ListingRemoved";
		CondoEvents["ExportedToPartner"] = "ExportedToPartner";
		CondoEvents["EstateUpdated"] = "EstateUpdated";
		CondoEvents["InspectionDone"] = "InspectionDone";
		CondoEvents["EstateMarkedAsDuplicate"] = "EstateMarkedAsDuplicate";
		CondoEvents["ReScore"] = "ReScore";
		CondoEvents["AppointmentScheduled"] = "AppointmentScheduled";
		CondoEvents["Recalculation"] = "Recalculation";
		CondoEvents["OfferRejected"] = "OfferRejected";
		CondoEvents["OfferAccepted"] = "OfferAccepted";
		CondoEvents["RegenerateOffer"] = "RegenerateOffer";
		CondoEvents["Cancelled"] = "Cancelled";
		CondoEvents["ProcessStarted"] = "ProcessStarted";
		CondoEvents["StateMachineStart"] = "StateMachineStart";
		CondoEvents["OfferMade"] = "OfferMade";
		CondoEvents["PreliminaryOfferMade"] = "PreliminaryOfferMade";
		CondoEvents["TaskDone"] = "TaskDone";
		CondoEvents["TaskAdded"] = "TaskAdded";
		CondoEvents["FinalStateReached"] = "FinalStateReached";
		CondoEvents["EstateUpdatedManually"] = "EstateUpdatedManually";
		CondoEvents["ManualScore"] = "ManualScore";
		CondoEvents["SellerContacted"] = "SellerContacted";
		CondoEvents["UserAssigned"] = "UserAssigned";
		CondoEvents["UserUnAssigned"] = "UserUnAssigned";
		CondoEvents["DocumentsProvided"] = "DocumentsProvided";
		CondoEvents["PurchaseInvoicePaid"] = "PurchaseInvoicePaid";
		CondoEvents["EventTriggered"] = "EventTriggered";
		CondoEvents["NotaryProvidedDraft"] = "NotaryProvidedDraft";
		CondoEvents["NotaryDraftValidated"] = "NotaryDraftValidated";
		CondoEvents["NotaryVisited"] = "NotaryVisited";
		CondoEvents["NotificationOfMaturity"] = "NotificationOfMaturity";
		CondoEvents["KeyReceived"] = "KeyReceived";
		CondoEvents["ScreeningDone"] = "ScreeningDone";
		CondoEvents["Rollback"] = "Rollback";
		CondoEvents["Start"] = "Start";
		CondoEvents["Recalculated"] = "Recalculated";
		CondoEvents["InvestmentCreated"] = "InvestmentCreated";
		CondoEvents["InvestmentApproved"] = "InvestmentApproved";
		CondoEvents["InvestmentUnApproved"] = "InvestmentUnApproved";
		CondoEvents["InvestmentUpdated"] = "InvestmentUpdated";
		CondoEvents["TaxesPaid"] = "TaxesPaid";
		CondoEvents["HandoverDone"] = "HandoverDone";
		CondoEvents["Modelled"] = "Modelled";
		CondoEvents["Measured"] = "Measured";
		CondoEvents["ConstructionPaused"] = "ConstructionPaused";
		CondoEvents["RenovationResumed"] = "RenovationResumed";
		CondoEvents["HandoverScheduled"] = "HandoverScheduled";
		CondoEvents["RenovationBriefingDone"] = "RenovationBriefingDone";
		CondoEvents["RenovationPlanningVisit"] = "RenovationPlanningVisit";
		CondoEvents["RenovationPlanningVerified"] = "RenovationPlanningVerified";
		CondoEvents["RenovationPrepared"] = "RenovationPrepared";
		CondoEvents["PlanningApprovedByTransactions"] = "PlanningApprovedByTransactions";
		CondoEvents["FloorPlanAndBathPlanned"] = "FloorPlanAndBathPlanned";
		CondoEvents["ConstructionChecked"] = "ConstructionChecked";
		CondoEvents["QualityCheck"] = "QualityCheck";
		CondoEvents["NoDefectsIdentified"] = "NoDefectsIdentified";
		CondoEvents["ConstructionPlanCreated"] = "ConstructionPlanCreated";
		CondoEvents["ConstructionPlanUpdated"] = "ConstructionPlanUpdated";
		CondoEvents["ConstructionPlanStructureChanged"] = "ConstructionPlanStructureChanged";
		CondoEvents["ConstructionPlanSent"] = "ConstructionPlanSent";
		CondoEvents["Revert"] = "Revert";
		CondoEvents["PreparedForSend"] = "PreparedForSend";
		CondoEvents["DefectsFixRequested"] = "DefectsFixRequested";
		CondoEvents["DefectsChecked"] = "DefectsChecked";
		CondoEvents["DefectAdded"] = "DefectAdded";
		CondoEvents["DefectReopened"] = "DefectReopened";
		CondoEvents["DefectUpdated"] = "DefectUpdated";
		CondoEvents["DefectDeleted"] = "DefectDeleted";
		CondoEvents["DefectClosed"] = "DefectClosed";
		CondoEvents["DefectsFixed"] = "DefectsFixed";
		CondoEvents["ManualReject"] = "ManualReject";
		CondoEvents["RentingListingPrepared"] = "RentingListingPrepared";
		CondoEvents["TestRentingListingPrepared"] = "TestRentingListingPrepared";
		CondoEvents["PicturesAndVideoPrepared"] = "PicturesAndVideoPrepared";
		CondoEvents["ListedOnPortals"] = "ListedOnPortals";
		CondoEvents["LeadsScreened"] = "LeadsScreened";
		CondoEvents["LeadsDeclined"] = "LeadsDeclined";
		CondoEvents["LeadsContacted"] = "LeadsContacted";
		CondoEvents["TenantChosen"] = "TenantChosen";
		CondoEvents["TenantNotNeeded"] = "TenantNotNeeded";
		CondoEvents["RentingStopped"] = "RentingStopped";
		CondoEvents["ContractSent"] = "ContractSent";
		CondoEvents["ContractReturned"] = "ContractReturned";
		CondoEvents["ContractSigned"] = "ContractSigned";
		CondoEvents["KeysHandedOver"] = "KeysHandedOver";
		CondoEvents["InspectionRequested"] = "InspectionRequested";
		CondoEvents["ViewingScheduled"] = "ViewingScheduled";
		CondoEvents["ViewingDone"] = "ViewingDone";
		CondoEvents["SellingPartnerChosen"] = "SellingPartnerChosen";
		CondoEvents["SellingPartnershipEnded"] = "SellingPartnershipEnded";
		CondoEvents["SellingPartnerChanged"] = "SellingPartnerChanged";
		CondoEvents["SellingDocumentsPassed"] = "SellingDocumentsPassed";
		CondoEvents["BuyingOfferReceived"] = "BuyingOfferReceived";
		CondoEvents["RevertedToOfferReceived"] = "RevertedToOfferReceived";
		CondoEvents["PlacedOnMarket"] = "PlacedOnMarket";
		CondoEvents["OfferEvaluated"] = "OfferEvaluated";
		CondoEvents["NotaryDraftReceived"] = "NotaryDraftReceived";
		CondoEvents["DraftEvaluated"] = "DraftEvaluated";
		CondoEvents["PurchasePriceReceived"] = "PurchasePriceReceived";
		CondoEvents["SellingOfferAccepted"] = "SellingOfferAccepted";
		CondoEvents["InterCompanyTransferRequested"] = "InterCompanyTransferRequested";
		CondoEvents["SellingPrepared"] = "SellingPrepared";
		CondoEvents["PlacedOnOpenMarket"] = "PlacedOnOpenMarket";
		CondoEvents["RenovationStarted"] = "RenovationStarted";
		CondoEvents["RenovationCompleted"] = "RenovationCompleted";
		CondoEvents["FloorPlanApproved"] = "FloorPlanApproved";
		CondoEvents["Briefed"] = "Briefed";
		CondoEvents["DemolitionChecked"] = "DemolitionChecked";
		CondoEvents["RenovationInspectionCompleted"] = "RenovationInspectionCompleted";
		CondoEvents["SignOffReadyForCreation"] = "SignOffReadyForCreation";
		CondoEvents["SignOffEnvelopeCreated"] = "SignOffEnvelopeCreated";
		CondoEvents["SignOffEnvelopeCompleted"] = "SignOffEnvelopeCompleted";
		CondoEvents["SignOffEnvelopeCancelled"] = "SignOffEnvelopeCancelled";
		CondoEvents["ProcessUpdated"] = "ProcessUpdated";
		CondoEvents["IFCFilesProvided"] = "IFCFilesProvided";
		CondoEvents["HSEAndBricklayerChecked"] = "HSEAndBricklayerChecked";
		CondoEvents["InternalAcceptanceCheck"] = "InternalAcceptanceCheck";
		CondoEvents["ApprovedWithContractor"] = "ApprovedWithContractor";
		CondoEvents["PortfolioUpdated"] = "PortfolioUpdated";
		CondoEvents["DocumentsGenerated"] = "DocumentsGenerated";
		CondoEvents["LoanApplicationCreated"] = "LoanApplicationCreated";
		CondoEvents["LoanOfferCreated"] = "LoanOfferCreated";
		CondoEvents["LoanOfferAccepted"] = "LoanOfferAccepted";
		CondoEvents["LoanOfferUpdated"] = "LoanOfferUpdated";
		CondoEvents["PortfolioStatusUpdate"] = "PortfolioStatusUpdate";
		CondoEvents["PortfolioStatusRevert"] = "PortfolioStatusRevert";
		CondoEvents["LoanOfferDeleted"] = "LoanOfferDeleted";
		CondoEvents["LoanApplicationDeleted"] = "LoanApplicationDeleted";
		CondoEvents["DrawdownCreated"] = "DrawdownCreated";
		CondoEvents["DrawdownUpdated"] = "DrawdownUpdated";
		CondoEvents["DrawdownSent"] = "DrawdownSent";
		CondoEvents["DrawdownStatusUpdated"] = "DrawdownStatusUpdated";
		CondoEvents["DrawdownDeleted"] = "DrawdownDeleted";
		CondoEvents["ContactRequested"] = "ContactRequested";
		CondoEvents["RentingListingCreated"] = "RentingListingCreated";
		CondoEvents["RentingListingPrePublished"] = "RentingListingPrePublished";
		CondoEvents["RentingListingPublished"] = "RentingListingPublished";
		CondoEvents["RentingListingUnPublished"] = "RentingListingUnPublished";
		CondoEvents["RentingListingDeleted"] = "RentingListingDeleted";
		CondoEvents["RentingListingUpdated"] = "RentingListingUpdated";
		CondoEvents["CalendarUpdated"] = "CalendarUpdated";
		CondoEvents["CalendarEventCompleted"] = "CalendarEventCompletedAttended";
		CondoEvents["MFHCalendarUpdated"] = "MFHCalendarUpdated";
		CondoEvents["InvestmentCaseApproved"] = "InvestmentCaseApproved";
		CondoEvents["EstateOwnerShareCalculated"] = "EstateOwnerShareCalculated";
		CondoEvents["EstateOwnerShareNotCalculated"] = "EstateOwnerShareNotCalculated";
		CondoEvents["SalesPackagePrepared"] = "SalesPackagePrepared";
		CondoEvents["SalesPackageActivated"] = "SalesPackageActivated";
		CondoEvents["SalesPackageSold"] = "SalesPackageSold";
		CondoEvents["SalesPackageClosed"] = "SalesPackageClosed";
		CondoEvents["EstateAddedToSalesPackage"] = "EstateAddedToSalesPackage";
		CondoEvents["EstateRemovedFromSalesPackage"] = "EstateRemovedFromSalesPackage";
		CondoEvents["RentingLeadApproved"] = "RentingLeadApproved";
		CondoEvents["RentingLeadDisapproved"] = "RentingLeadDisapproved";
		CondoEvents["PutOnHold"] = "PutOnHold";
		CondoEvents["Resume"] = "Resume";
		/** MFH investment case: append-only input change history (per path since snapshot). */
		CondoEvents["MfhInvestmentCaseInputsChanged"] = "MfhInvestmentCaseInputsChanged";
		/** MFH investment case: inputs synced from config/MFH (shown in event timeline). */
		CondoEvents["MfhInvestmentCaseInputsSynced"] = "MfhInvestmentCaseInputsSynced";
		/** MFH investment case: created by user (prepare finished). */
		CondoEvents["MfhInvestmentCaseCreated"] = "MfhInvestmentCaseCreated";
		return CondoEvents;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/document/document-annotation-transfer.model.ts
var DocumentAnnotationCoreSchema, DocumentAnnotationTransferItemSchema;
var init_document_annotation_transfer_model = __esmMin((() => {
	DocumentAnnotationCoreSchema = Type.Object({
		id: Type.String(),
		created: Type.String(),
		authorUid: Type.String(),
		author: Type.String()
	}, { additionalProperties: true });
	DocumentAnnotationTransferItemSchema = Type.Object({ annotation: DocumentAnnotationCoreSchema }, { additionalProperties: true });
}));
//#endregion
//#region src/domains/cross-cutting/document/document-annotation-transfer.helpers.ts
/** Stable id for matching persisted EmbedPDF transfer items (nested `annotation.id`). */
function getDocumentAnnotationTransferItemId(item) {
	const nested = item.annotation;
	if (!nested || typeof nested !== "object") return null;
	if (typeof nested.id === "string") return nested.id;
	if (typeof nested.id === "number") return String(nested.id);
	return null;
}
var init_document_annotation_transfer_helpers = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/document/document-annotations.request.ts
var CreateDocumentAnnotationParamsSchema, CreateDocumentAnnotationBodySchema, UpdateDocumentAnnotationParamsSchema, UpdateDocumentAnnotationBodySchema, DeleteDocumentAnnotationParamsSchema;
var init_document_annotations_request = __esmMin((() => {
	init_document_annotation_transfer_model();
	CreateDocumentAnnotationParamsSchema = Type.Object({ documentId: Type.Number() });
	CreateDocumentAnnotationBodySchema = Type.Object({ annotation: DocumentAnnotationTransferItemSchema });
	UpdateDocumentAnnotationParamsSchema = Type.Object({
		documentId: Type.Number(),
		annotationId: Type.String()
	});
	UpdateDocumentAnnotationBodySchema = Type.Object({ annotation: DocumentAnnotationTransferItemSchema });
	DeleteDocumentAnnotationParamsSchema = Type.Object({
		documentId: Type.Number(),
		annotationId: Type.String()
	});
}));
//#endregion
//#region src/domains/cross-cutting/document/data-room.model.ts
var init_data_room_model = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/document/document-generation.model.ts
var init_document_generation_model = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/document/document-process.model.ts
var DocumentProcessStatus, DocumentProcessEntity, documentProcessStatusMapping;
var init_document_process_model = __esmMin((() => {
	DocumentProcessStatus = /* @__PURE__ */ function(DocumentProcessStatus) {
		DocumentProcessStatus["NotPresent"] = "NotPresent";
		DocumentProcessStatus["Uploaded"] = "Uploaded";
		DocumentProcessStatus["Requested"] = "Requested";
		DocumentProcessStatus["NotNeeded"] = "NotNeeded";
		DocumentProcessStatus["Needed"] = "Needed";
		return DocumentProcessStatus;
	}({});
	DocumentProcessEntity = /* @__PURE__ */ function(DocumentProcessEntity) {
		DocumentProcessEntity["Estate"] = "Estate";
		DocumentProcessEntity["MFH"] = "MFH";
		return DocumentProcessEntity;
	}({});
	documentProcessStatusMapping = {
		["NotPresent"]: {
			icon: "circle-minus",
			color: "is-blue-light",
			title: "Not Present"
		},
		["Requested"]: {
			icon: "hourglass-half",
			color: "is-orange-dark",
			title: "Requested"
		},
		["NotNeeded"]: {
			icon: "circle-check",
			color: "is-light-gray",
			title: "Not Needed"
		},
		["Uploaded"]: {
			icon: "circle-check",
			color: "is-olive-dark",
			title: "Uploaded"
		},
		["Needed"]: {
			icon: "triangle-exclamation",
			color: "is-warning",
			title: "Needed"
		}
	};
}));
//#endregion
//#region src/domains/cross-cutting/errors/error-codes.ts
var ErrorCode;
var init_error_codes = __esmMin((() => {
	ErrorCode = /* @__PURE__ */ function(ErrorCode) {
		ErrorCode["SalesPackageExportFailed"] = "SALES_PACKAGE_EXPORT_FAILED";
		ErrorCode["NetsuiteSyncFailed"] = "NETSUITE_SYNC_FAILED";
		ErrorCode["Multiple"] = "MULTIPLE";
		ErrorCode["SideEffectNotAllowed"] = "SIDE_EFFECT_NOT_ALLOWED";
		ErrorCode["RetriesExceeded"] = "RETRIES_EXCEEDED";
		ErrorCode["Timeout"] = "TIMEOUT";
		ErrorCode["MachineFailure"] = "MACHINE_FAILURE";
		ErrorCode["Is24Validation"] = "IS24_VALIDATION";
		ErrorCode["Forbidden"] = "FORBIDDEN";
		ErrorCode["Unauthorized"] = "UNAUTHORIZED";
		ErrorCode["Validation"] = "VALIDATION";
		ErrorCode["Unsupported"] = "UNSUPPORTED";
		ErrorCode["Invariant"] = "INVARIANT";
		ErrorCode["D2GSheetMappingMalformed"] = "D2G_SHEET_MAPPING_MALFORMED";
		ErrorCode["D2GSheetMissingDatapoint"] = "D2G_SHEET_MISSING_DATAPOINT";
		ErrorCode["D2GSheetDatapointNotMappable"] = "D2G_SHEET_DATAPOINT_NOT_MAPPABLE";
		ErrorCode["MFHInvestmentCaseOtherCasesOverlapping"] = "MFH_INVESTMENT_CASE_OTHER_CASES_OVERLAPPING";
		ErrorCode["RentRollVersionReferencedByInvestmentCases"] = "RENT_ROLL_VERSION_REFERENCED_BY_INVESTMENT_CASES";
		ErrorCode["InvalidState"] = "INVALID_STATE";
		ErrorCode["Conflict"] = "CONFLICT";
		ErrorCode["ExternalServiceFailed"] = "EXTERNAL_SERVICE_FAILED";
		ErrorCode["InvalidStateTransition"] = "INVALID_STATE_TRANSITION";
		ErrorCode["EntityNotFound"] = "ENTITY_NOT_FOUND";
		ErrorCode["Internal"] = "INTERNAL";
		ErrorCode["EbicsResponseCodeNonZero"] = "EBICS_RESPONSE_CODE_NON_ZERO";
		ErrorCode["EbicsKeysNotComplete"] = "EBICS_KEYS_NOT_COMPLETE";
		ErrorCode["EbicsKeysNotFound"] = "EBICS_KEYS_NOT_FOUND";
		ErrorCode["IniDocumentNotGenerated"] = "INI_DOCUMENT_NOT_GENERATED";
		ErrorCode["ConcurrentJobRunning"] = "CONCURRENT_JOB_RUNNING";
		ErrorCode["DocumentGenerationFailed"] = "DOCUMENT_GENERATION_FAILED";
		ErrorCode["DocumentGenerationInvalidParams"] = "DOCUMENT_GENERATION_INVALID_PARAMS";
		ErrorCode["DocumentGenerationRequiredKeysMissing"] = "DOCUMENT_GENERATION_REQUIRED_KEYS_MISSING";
		ErrorCode["ContentTooLarge"] = "CONTENT_TOO_LARGE";
		ErrorCode["RelationMissing"] = "RELATION_MISSING";
		ErrorCode["Calculation"] = "CALCULATION";
		ErrorCode["ServiceMisconfigured"] = "SERVICE_MISCONFIGURED";
		ErrorCode["SchemaValidation"] = "SCHEMA_VALIDATION";
		ErrorCode["CDCSchemaFetchFailed"] = "CDC_SCHEMA_FETCH_FAILED";
		ErrorCode["SchemaMissingId"] = "SCHEMA_MISSING_ID";
		ErrorCode["InvalidParams"] = "INVALID_PARAMS";
		ErrorCode["UserConfirmationRejectedOrTimeout"] = "USER_CONFIRMATION_REJECTED_OR_TIMEOUT";
		ErrorCode["InvalidRule"] = "INVALID_RULE";
		ErrorCode["ExpandOptsTooDeep"] = "EXPAND_OPTS_TOO_DEEP";
		ErrorCode["ExpandTooManyNestedRelations"] = "EXPAND_TOO_MANY_NESTED_RELATIONS";
		ErrorCode["ReconcilerRuleOverlapping"] = "RECONCILER_RULE_OVERLAPPING";
		ErrorCode["ReconcilerRuleMissingData"] = "RECONCILER_RULE_MISSING_DATA";
		ErrorCode["LookerNoEmbedUrlGenerated"] = "LOOKER_NO_EMBED_URL_GENERATED";
		ErrorCode["ExternalRequiredResourceMissing"] = "EXTERNAL_REQUIRED_RESOURCE_MISSING";
		ErrorCode["PreconditionFailed"] = "PRECONDITION_FAILED";
		ErrorCode["CashflowEntityNotFound"] = "CASHFLOW_ENTITY_NOT_FOUND";
		ErrorCode["NotImplemented"] = "NOT_IMPLEMENTED";
		ErrorCode["DuplicateInvoice"] = "DUPLICATE_INVOICE";
		ErrorCode["PromotionExposeGenerationFailed"] = "PROMOTION_EXPOSE_GENERATION_FAILED";
		ErrorCode["IBANLookupFailed"] = "IBAN_LOOKUP_FAILED";
		ErrorCode["InvalidEvent"] = "INVALID_EVENT";
		ErrorCode["E2EScenarioSanityCheck"] = "E2E_SCENARIO_SANITY_CHECK";
		ErrorCode["E2EScenario"] = "E2E_SCENARIO";
		ErrorCode["NetSuiteUUIDExportFailed"] = "NET_SUITE_UUID_EXPORT_FAILED";
		ErrorCode["NetSuiteInvoiceExportFailed"] = "NET_SUITE_INVOICE_EXPORT_FAILED";
		ErrorCode["NotRentableUnitProcess"] = "NOT_RENTABLE_UNIT_PROCESS";
		ErrorCode["TerminationAlreadyScheduled"] = "TERMINATION_ALREADY_SCHEDULED";
		ErrorCode["FinanceInvalidCategoryBookingOnBankAccountError"] = "FINANCE_INVALID_CATEGORY_BOOKING_ON_BANK_ACCOUNT_ERROR";
		ErrorCode["FinanceBankTransactionConflictingReference"] = "FINANCE_BANK_TRANSACTION_CONFLICTING_REFERENCE";
		ErrorCode["NotificationSendout"] = "NOTIFICATION_SENDOUT";
		ErrorCode["JobFailed"] = "JOB_FAILED";
		ErrorCode["ResourceNotShared"] = "RESOURCE_NOT_SHARED";
		ErrorCode["EstarcoreImportFailed"] = "ESTARCORE_IMPORT_FAILED";
		ErrorCode["CandidateAssetPartnerInCandidatePortfolio"] = "CANDIDATE_ASSET_PARTNER_IN_CANDIDATE_PORTFOLIO";
		return ErrorCode;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/errors/base-errors.ts
var base_errors_exports = /* @__PURE__ */ __exportAll({
	ApplicationError: () => ApplicationError,
	AuthorizationMisconfiguredError: () => AuthorizationMisconfiguredError,
	AuthorizationRoleBindingsMissingRequiredPermissionsError: () => AuthorizationRoleBindingsMissingRequiredPermissionsError,
	AuthzPermissionResolutionError: () => AuthzPermissionResolutionError,
	AuthzPermissionsMissingError: () => AuthzPermissionsMissingError,
	CDCSchemaFetchFailedError: () => CDCSchemaFetchFailedError,
	CalculationError: () => CalculationError,
	CandidateAssetPartnerInCandidatePortfolioError: () => CandidateAssetPartnerInCandidatePortfolioError,
	CashflowRequiredEntityMissingError: () => CashflowRequiredEntityMissingError,
	ConflictError: () => ConflictError,
	ContentTooLargeError: () => ContentTooLargeError,
	DocumentCopyError: () => DocumentCopyError,
	DocumentGenerationFailedError: () => DocumentGenerationFailedError,
	DocumentGenerationInvalidParamsError: () => DocumentGenerationInvalidParamsError,
	DocumentGenerationRequiredKeysMissingError: () => DocumentGenerationRequiredKeysMissingError,
	E2EScenarioSanityCheckFailedError: () => E2EScenarioSanityCheckFailedError,
	E2EScenarioScenarioFailedError: () => E2EScenarioScenarioFailedError,
	EntityNotFoundError: () => EntityNotFoundError,
	EstarcoreImportFailedError: () => EstarcoreImportFailedError,
	ExpandOptsTooDeepError: () => ExpandOptsTooDeepError,
	ExpandOptsTooManyNestedRelationsError: () => ExpandOptsTooManyNestedRelationsError,
	ExternalRequiredResourceMissingError: () => ExternalRequiredResourceMissingError,
	ExternalServiceFailedError: () => ExternalServiceFailedError,
	ExternalServiceSchemaFailedError: () => ExternalServiceSchemaFailedError,
	IBANLookupFailedError: () => IBANLookupFailedError,
	InvalidEventError: () => InvalidEventError,
	InvalidParamsError: () => InvalidParamsError,
	InvalidRuleError: () => InvalidRuleError,
	InvalidStateError: () => InvalidStateError,
	InvalidStateTransitionError: () => InvalidStateTransitionError,
	InvariantError: () => InvariantError,
	LookerNoEmbedUrlGeneratedError: () => LookerNoEmbedUrlGeneratedError,
	MFHInvestmentCaseOverlappingApprovedCasesError: () => MFHInvestmentCaseOverlappingApprovedCasesError,
	MachineFailureError: () => MachineFailureError,
	MultiError: () => MultiError,
	NetSuiteInvoiceExportFailedError: () => NetSuiteInvoiceExportFailedError,
	NetSuiteUUIDExportFailedError: () => NetSuiteUUIDExportFailedError,
	NotImplementedError: () => NotImplementedError,
	PreconditionFailedError: () => PreconditionFailedError,
	ReconcilerRuleMissingDataError: () => ReconcilerRuleMissingDataError,
	ReconcilerRuleOverlappingError: () => ReconcilerRuleOverlappingError,
	RelationNotPresentOnEntity: () => RelationNotPresentOnEntity,
	RentRollVersionReferencedByInvestmentCasesError: () => RentRollVersionReferencedByInvestmentCasesError,
	RequestTimeoutError: () => RequestTimeoutError,
	ResourceNotSharedError: () => ResourceNotSharedError,
	RetriesExceededError: () => RetriesExceededError,
	SalesPackageExportFailedError: () => SalesPackageExportFailedError,
	SchemaFailedError: () => SchemaFailedError,
	SchemaMissingIdError: () => SchemaMissingIdError,
	ServiceMisconfiguredError: () => ServiceMisconfiguredError,
	SideEffectNotAllowedError: () => SideEffectNotAllowedError,
	TimeoutError: () => TimeoutError,
	UnauthorizedError: () => UnauthorizedError,
	UnsupportedError: () => UnsupportedError,
	ValidationFailedError: () => ValidationFailedError
});
var serializeBinding, AuthzPermissionsMissingError, AuthorizationMisconfiguredError, AuthorizationRoleBindingsMissingRequiredPermissionsError, AuthzPermissionResolutionError, CalculationError, RelationNotPresentOnEntity, MultiError, ContentTooLargeError, RetriesExceededError, SideEffectNotAllowedError, SchemaFailedError, CDCSchemaFetchFailedError, ExternalServiceSchemaFailedError, ServiceMisconfiguredError, SchemaMissingIdError, EntityNotFoundError, ExpandOptsTooDeepError, ExpandOptsTooManyNestedRelationsError, InvalidRuleError, SalesPackageExportFailedError, ReconcilerRuleOverlappingError, ReconcilerRuleMissingDataError, LookerNoEmbedUrlGeneratedError, ExternalRequiredResourceMissingError, InvariantError, MFHInvestmentCaseOverlappingApprovedCasesError, RentRollVersionReferencedByInvestmentCasesError, InvalidStateError, CashflowRequiredEntityMissingError, NotImplementedError, UnauthorizedError, DocumentGenerationInvalidParamsError, DocumentGenerationFailedError, DocumentGenerationRequiredKeysMissingError, IBANLookupFailedError, ValidationFailedError, E2EScenarioSanityCheckFailedError, E2EScenarioScenarioFailedError, NetSuiteUUIDExportFailedError, NetSuiteInvoiceExportFailedError, PreconditionFailedError, CandidateAssetPartnerInCandidatePortfolioError, InvalidParamsError, ConflictError, UnsupportedError, InvalidStateTransitionError, InvalidEventError, RequestTimeoutError, TimeoutError, ApplicationError, ExternalServiceFailedError, MachineFailureError, DocumentCopyError, ResourceNotSharedError, EstarcoreImportFailedError;
var init_base_errors = __esmMin((() => {
	serializeBinding = (binding) => `${binding.role?.name} (binding#${binding.roleBindingId})`;
	AuthzPermissionsMissingError = class extends NonRetriableError {
		userUid;
		message;
		missingPermissions;
		resolvedRoleBinding;
		severity = ErrorSeverity.LOW;
		assignedRoles = [];
		resolvedRoleBindings = {
			evaluated: [],
			partiallyEvaluated: []
		};
		constructor(userUid, message, missingPermissions, resolvedRoleBinding) {
			super(message, "AUTHZ_PERMISSIONS_MISSING");
			this.userUid = userUid;
			this.message = message;
			this.missingPermissions = missingPermissions;
			this.resolvedRoleBinding = resolvedRoleBinding;
			this.formatAssignedRoles(resolvedRoleBinding);
			this.formatResolvedRoleBindings(resolvedRoleBinding);
		}
		formatResolvedRoleBindings(resolvedRoleBinding) {
			if (!resolvedRoleBinding) return;
			this.resolvedRoleBindings = {
				evaluated: resolvedRoleBinding.evaluated.map(serializeBinding),
				partiallyEvaluated: resolvedRoleBinding.partiallyEvaluated.map(serializeBinding)
			};
		}
		formatAssignedRoles(resolvedRoleBinding) {
			const allRoleBindings = [...resolvedRoleBinding?.partiallyEvaluated ?? [], ...resolvedRoleBinding?.evaluated ?? []];
			if (!allRoleBindings.length) this.assignedRoles = `(unknown)`;
			this.assignedRoles = allRoleBindings?.map((role) => {
				const name = `role='${role.role?.name}'`;
				if (role.conditions?.length) return `${name}, conditions='${role.conditions.map((cond) => `${cond.resourceType}.${cond.resourceProperty} ${cond.comparator} ${cond.value.constant}`).join(` ${role.conditionCombination ?? "AND"} `)}'`;
				return name;
			});
		}
	};
	AuthorizationMisconfiguredError = class extends NonRetriableError {
		message;
		constructor(message) {
			super(message, "AUTHZ_MISCONFIGURED");
			this.message = message;
		}
	};
	AuthorizationRoleBindingsMissingRequiredPermissionsError = class extends NonRetriableError {
		message;
		missingPermissions;
		constructor(message, missingPermissions) {
			super(message, "AUTHZ_ROLE_BINDING_MISSING_REQUIRED_PERMISSIONS");
			this.message = message;
			this.missingPermissions = missingPermissions;
		}
	};
	AuthzPermissionResolutionError = class extends NonRetriableError {
		message;
		constructor(message) {
			super(message, "AUTHZ_PERM_RESOLUTION_FAILED");
			this.message = message;
		}
	};
	CalculationError = class extends NonRetriableError {
		calculation;
		hint;
		constructor(calculation, hint) {
			super(`Could not calculate '${calculation}': ${hint}`, "CALCULATION");
			this.calculation = calculation;
			this.hint = hint;
		}
	};
	RelationNotPresentOnEntity = class extends NonRetriableError {
		relation;
		entity;
		constructor(relation, entity) {
			super(`Need to have ${relation} attached to ${entity} or did not find any`, "RELATION_MISSING");
			this.relation = relation;
			this.entity = entity;
		}
	};
	MultiError = class extends NonRetriableError {
		errors;
		constructor(errors) {
			const errorMessages = errors.map((e) => e.message).filter(Boolean);
			const message = errors.length === 1 ? errorMessages[0] : `MultiError: ${errorMessages.map((m) => `"${m}"`).join(", ")}`;
			super(message, "MULTIPLE");
			this.errors = errors;
		}
	};
	ContentTooLargeError = class extends NonRetriableError {
		message;
		constructor(message) {
			super(message, "CONTENT_TOO_LARGE");
			this.message = message;
		}
	};
	RetriesExceededError = class extends NonRetriableError {
		message;
		innerError;
		constructor(message, innerError) {
			super(innerError?.message ?? message, "RETRIES_EXCEEDED", { cause: innerError });
			this.message = message;
			this.innerError = innerError;
		}
	};
	SideEffectNotAllowedError = class extends NonRetriableError {
		property;
		protoName;
		constructor(property, protoName) {
			super(`Method '${property.toString()}' on ${protoName} is not enabled in this environment`, "SIDE_EFFECT_NOT_ALLOWED");
			this.property = property;
			this.protoName = protoName;
		}
	};
	SchemaFailedError = class extends NonRetriableError {
		constructor(message = "Schema validation failed", cause, severity) {
			super(message, "SCHEMA_VALIDATION", { cause }, severity);
		}
	};
	CDCSchemaFetchFailedError = class extends NonRetriableError {
		registry;
		cause;
		constructor(registry, cause) {
			super(`Failed to fetch schema-informaiton from registry: ${registry}`, "CDC_SCHEMA_FETCH_FAILED", { cause });
			this.registry = registry;
			this.cause = cause;
		}
	};
	ExternalServiceSchemaFailedError = class extends NonRetriableError {
		message;
		innerError;
		constructor(message = "External service validation failed", innerError) {
			super(message, "SCHEMA_VALIDATION");
			this.message = message;
			this.innerError = innerError;
		}
	};
	ServiceMisconfiguredError = class extends NonRetriableError {
		message;
		constructor(message = "Service misconfigured") {
			super(message, "SERVICE_MISCONFIGURED", void 0, ErrorSeverity.FATAL);
			this.message = message;
		}
	};
	SchemaMissingIdError = class extends NonRetriableError {
		schema;
		message;
		constructor(schema, message = "Provided schema has no attached $id") {
			super(message, "SCHEMA_MISSING_ID");
			this.schema = schema;
			this.message = message;
		}
	};
	EntityNotFoundError = class extends NonRetriableError {
		message;
		meta;
		constructor(message = "Entity not found", meta, data) {
			super(message, "ENTITY_NOT_FOUND", data, ErrorSeverity.LOW);
			this.message = message;
			this.meta = meta;
		}
	};
	ExpandOptsTooDeepError = class extends NonRetriableError {
		constructor(walkedPath, entity, maxDepth) {
			super(`Expand path "${walkedPath}" on ${entity} is deeper than ${maxDepth}`, "EXPAND_OPTS_TOO_DEEP", {
				entity,
				walkedPath,
				maxDepth
			});
		}
	};
	ExpandOptsTooManyNestedRelationsError = class extends NonRetriableError {
		constructor(nestedRelations, allowedDepth) {
			super(`Tried to query for too many nested many/one-to-many relations.`, "EXPAND_TOO_MANY_NESTED_RELATIONS", {
				allowedDepth,
				nestedRelations
			});
		}
	};
	InvalidRuleError = class extends NonRetriableError {
		message;
		constructor(message) {
			super(message, "INVALID_RULE");
			this.message = message;
		}
	};
	SalesPackageExportFailedError = class extends NonRetriableError {
		salesPackageId;
		innerErrors;
		constructor(salesPackageId, innerErrors) {
			super(`Failed to export sales-package ${salesPackageId}:\n${innerErrors.join("\n")}`, "SALES_PACKAGE_EXPORT_FAILED");
			this.salesPackageId = salesPackageId;
			this.innerErrors = innerErrors;
		}
	};
	ReconcilerRuleOverlappingError = class extends NonRetriableError {
		message;
		overlappingRules;
		placement;
		overlappingColValues;
		constructor(message, overlappingRules, placement, overlappingColValues) {
			super(message, "RECONCILER_RULE_OVERLAPPING");
			this.message = message;
			this.overlappingRules = overlappingRules;
			this.placement = placement;
			this.overlappingColValues = overlappingColValues;
		}
	};
	ReconcilerRuleMissingDataError = class extends NonRetriableError {
		message;
		missingFields;
		constructor(message, missingFields) {
			super(message, "RECONCILER_RULE_MISSING_DATA");
			this.message = message;
			this.missingFields = missingFields;
		}
	};
	LookerNoEmbedUrlGeneratedError = class extends NonRetriableError {
		embedUrl;
		constructor(embedUrl) {
			super(`Could not generate an embedding url for looker-dashboard ${embedUrl}`, "LOOKER_NO_EMBED_URL_GENERATED");
			this.embedUrl = embedUrl;
		}
	};
	ExternalRequiredResourceMissingError = class extends NonRetriableError {
		missingResources;
		constructor(missingResources) {
			super(`Some required external resources are not present`, "EXTERNAL_REQUIRED_RESOURCE_MISSING");
			this.missingResources = missingResources;
		}
	};
	InvariantError = class extends NonRetriableError {
		message;
		constructor(message, data) {
			super(message, "INVARIANT", data);
			this.message = message;
		}
	};
	MFHInvestmentCaseOverlappingApprovedCasesError = class extends NonRetriableError {
		selfId;
		otherInvestmentCases;
		constructor(selfId, otherInvestmentCases) {
			super(`Other investment-cases are already approved. They need to be reverted before approving the case ${selfId}`, "MFH_INVESTMENT_CASE_OTHER_CASES_OVERLAPPING");
			this.selfId = selfId;
			this.otherInvestmentCases = otherInvestmentCases;
		}
	};
	RentRollVersionReferencedByInvestmentCasesError = class extends NonRetriableError {
		rentRollVersionId;
		mfhInvestmentCases;
		constructor(rentRollVersionId, mfhInvestmentCases) {
			super(`Cannot delete rent-roll-version ${rentRollVersionId}: it is referenced by ${mfhInvestmentCases.length} investment case(s)`, "RENT_ROLL_VERSION_REFERENCED_BY_INVESTMENT_CASES");
			this.rentRollVersionId = rentRollVersionId;
			this.mfhInvestmentCases = mfhInvestmentCases;
		}
	};
	InvalidStateError = class extends NonRetriableError {
		message;
		constructor(message, data) {
			super(message, "INVALID_STATE", data);
			this.message = message;
		}
	};
	CashflowRequiredEntityMissingError = class extends NonRetriableError {
		message;
		constructor(message) {
			super(message, "CASHFLOW_ENTITY_NOT_FOUND");
			this.message = message;
		}
	};
	NotImplementedError = class extends NonRetriableError {
		message;
		constructor(message) {
			super(message, "NOT_IMPLEMENTED");
			this.message = message;
		}
	};
	UnauthorizedError = class extends NonRetriableError {
		message;
		constructor(message, data) {
			super(message, "UNAUTHORIZED", data, ErrorSeverity.LOW);
			this.message = message;
		}
	};
	DocumentGenerationInvalidParamsError = class extends NonRetriableError {
		documentType;
		fieldErrors;
		constructor(documentType, fieldErrors) {
			const paths = fieldErrors.map((e) => `- ${e.path.length ? e.path.join(".") : "<root>"} (must be ${e.type})`).join("\n");
			super(`Resolved document-generation params are invalid for document ${documentType} for fields\n ${paths}`, "DOCUMENT_GENERATION_INVALID_PARAMS");
			this.documentType = documentType;
			this.fieldErrors = fieldErrors;
		}
	};
	DocumentGenerationFailedError = class extends NonRetriableError {
		message;
		constructor(message, data) {
			super(message, "DOCUMENT_GENERATION_FAILED", data);
			this.message = message;
		}
	};
	DocumentGenerationRequiredKeysMissingError = class extends NonRetriableError {
		template;
		missingKeys;
		constructor(template, missingKeys, causeError) {
			super(`Some required keys for template ${template} where missing: ${missingKeys.join(",")}`, "DOCUMENT_GENERATION_REQUIRED_KEYS_MISSING", { cause: causeError });
			this.template = template;
			this.missingKeys = missingKeys;
		}
	};
	IBANLookupFailedError = class extends NonRetriableError {
		iban;
		status;
		constructor(iban, status) {
			const addon = typeof status === "number" ? ` (status = ${status})` : "";
			super(`Lookup of iban ${iban} failed${addon}`, "IBAN_LOOKUP_FAILED");
			this.iban = iban;
			this.status = status;
		}
	};
	ValidationFailedError = class extends NonRetriableError {
		message;
		constructor(message, data) {
			super(message, "VALIDATION", data, ErrorSeverity.LOW);
			this.message = message;
		}
	};
	E2EScenarioSanityCheckFailedError = class extends NonRetriableError {
		scenario;
		constructor(scenario, hint) {
			super(`E2E-scenario '${scenario}' sanity-check failed: ${hint} `, "E2E_SCENARIO_SANITY_CHECK");
			this.scenario = scenario;
		}
	};
	E2EScenarioScenarioFailedError = class extends NonRetriableError {
		scenarioName;
		stageResults;
		constructor(scenarioName, stageResults) {
			super(`E2E-scenario '${scenarioName}' failed`, "E2E_SCENARIO");
			this.scenarioName = scenarioName;
			this.stageResults = stageResults;
		}
	};
	NetSuiteUUIDExportFailedError = class extends NonRetriableError {
		validationErrors;
		exportErrors;
		constructor(validationErrors, exportErrors) {
			super(`Failed to export uuids to netsuite`, "NET_SUITE_UUID_EXPORT_FAILED");
			this.validationErrors = validationErrors;
			this.exportErrors = exportErrors;
		}
	};
	NetSuiteInvoiceExportFailedError = class extends NonRetriableError {
		validationErrors;
		exportErrors;
		constructor(validationErrors, exportErrors) {
			super(`Failed to export invoices to netsuite`, "NET_SUITE_INVOICE_EXPORT_FAILED");
			this.validationErrors = validationErrors;
			this.exportErrors = exportErrors;
		}
	};
	PreconditionFailedError = class extends NonRetriableError {
		message;
		constructor(message) {
			super(message, "PRECONDITION_FAILED");
			this.message = message;
		}
	};
	CandidateAssetPartnerInCandidatePortfolioError = class extends NonRetriableError {
		candidatePortfolioId;
		constructor(candidatePortfolioId) {
			super(`Can't remove candidate asset partner, as the asset is part of its portfolio w ID: ${candidatePortfolioId}. Please remove it first.`, "CANDIDATE_ASSET_PARTNER_IN_CANDIDATE_PORTFOLIO");
			this.candidatePortfolioId = candidatePortfolioId;
		}
	};
	InvalidParamsError = class extends NonRetriableError {
		message;
		constructor(message, data) {
			super(message, "INVALID_PARAMS", data);
			this.message = message;
		}
	};
	ConflictError = class extends NonRetriableError {
		message;
		constructor(message, data) {
			super(message, "CONFLICT", data);
			this.message = message;
		}
	};
	UnsupportedError = class extends NonRetriableError {
		message;
		constructor(message, data) {
			super(message, "UNSUPPORTED", data);
			this.message = message;
		}
	};
	InvalidStateTransitionError = class extends NonRetriableError {
		message;
		constructor(message) {
			super(message, "CONFLICT");
			this.message = message;
		}
	};
	InvalidEventError = class extends NonRetriableError {
		message;
		constructor(message) {
			super("InvalidEvent", "INVALID_EVENT");
			this.message = message;
		}
	};
	RequestTimeoutError = class extends RetriableError {
		constructor(endpoint, timeout) {
			super("Request timeout", "TIMEOUT", {
				endpoint,
				timeout
			});
		}
	};
	TimeoutError = class extends RetriableError {
		message;
		constructor(message, data) {
			super(message || "Timeout", "TIMEOUT", data);
			this.message = message;
		}
	};
	ApplicationError = class extends BaseError {
		message;
		extra;
		constructor(message, extra) {
			super(message, "INVARIANT", extra, ErrorSeverity.FATAL);
			this.message = message;
			this.extra = extra;
		}
	};
	ExternalServiceFailedError = class extends BaseError {
		message;
		cause;
		constructor(message, cause, data) {
			super(message, "EXTERNAL_SERVICE_FAILED", {
				cause,
				...data
			});
			this.message = message;
			this.cause = cause;
		}
	};
	MachineFailureError = class MachineFailureError extends BaseError {
		machineError;
		message;
		constructor(machineError, message) {
			super(message, "MACHINE_FAILURE", { cause: machineError });
			this.machineError = machineError;
			this.message = message;
		}
		static create(machineError, errorMessage) {
			const msg = errorMessage ?? (machineError instanceof Error ? machineError.message : machineError);
			const error = machineError instanceof Error ? machineError : new Error(machineError);
			return new MachineFailureError(error, msg);
		}
	};
	DocumentCopyError = class extends BaseError {
		message;
		cause;
		constructor(message, cause, data) {
			super(message, "EXTERNAL_SERVICE_FAILED", {
				cause,
				...data
			});
			this.message = message;
			this.cause = cause;
		}
	};
	ResourceNotSharedError = class extends NonRetriableError {
		message;
		constructor(message, data) {
			super(message, "RESOURCE_NOT_SHARED", data, ErrorSeverity.LOW);
			this.message = message;
		}
	};
	EstarcoreImportFailedError = class extends BaseError {
		message;
		cause;
		constructor(message, cause, data) {
			super(message, "ESTARCORE_IMPORT_FAILED", {
				cause,
				...data
			});
			this.message = message;
			this.cause = cause;
		}
	};
}));
//#endregion
//#region src/domains/cross-cutting/errors/condo-living/system-errors.ts
var SystemError;
var init_system_errors = __esmMin((() => {
	SystemError = class extends Error {};
}));
//#endregion
//#region src/domains/cross-cutting/errors/condo-living/domain-errors.ts
var CondoLivingError, UserNotCreatedError;
var init_domain_errors$1 = __esmMin((() => {
	CondoLivingError = class extends Error {
		APPLICATION = "CondoLiving";
	};
	UserNotCreatedError = class extends CondoLivingError {
		CODE = "E0001";
	};
}));
//#endregion
//#region src/domains/cross-cutting/errors/condo-living/index.ts
var init_condo_living$1 = __esmMin((() => {
	init_system_errors();
	init_domain_errors$1();
}));
//#endregion
//#region src/domains/cross-cutting/errors/renting/index.ts
var InvestmentCaseNotApprovedError, NotRentableUnitProcessError, TerminationAlreadyScheduledError;
var init_renting$2 = __esmMin((() => {
	InvestmentCaseNotApprovedError = class extends Error {
		message;
		innerError;
		constructor(message, innerError) {
			super(innerError?.message ?? message);
			this.message = message;
			this.innerError = innerError;
		}
	};
	NotRentableUnitProcessError = class extends NonRetriableError {
		constructor(processId) {
			super(`Rentable unit process not found (processId: ${processId})`, "NOT_RENTABLE_UNIT_PROCESS");
		}
	};
	TerminationAlreadyScheduledError = class extends NonRetriableError {
		constructor(processId, message, data) {
			super(message ?? `Cannot schedule termination. Rentable unit process termination is already scheduled (processId: ${processId})`, "TERMINATION_ALREADY_SCHEDULED", data);
		}
	};
}));
//#endregion
//#region src/domains/cross-cutting/errors/investment-case/index.ts
var RentableUnitCaseMismatchError;
var init_investment_case = __esmMin((() => {
	RentableUnitCaseMismatchError = class extends Error {
		message;
		investmentCaseId;
		rentableUnitCases;
		innerError;
		timestamp = Date.now();
		constructor(message, investmentCaseId, rentableUnitCases, innerError) {
			super(innerError?.message ?? message);
			this.message = message;
			this.investmentCaseId = investmentCaseId;
			this.rentableUnitCases = rentableUnitCases;
			this.innerError = innerError;
		}
	};
}));
//#endregion
//#region src/domains/cross-cutting/errors/cross-cutting/durable-job.errors.ts
var UserConfirmationRejectedOrTimeoutError;
var init_durable_job_errors = __esmMin((() => {
	UserConfirmationRejectedOrTimeoutError = class extends NonRetriableError {
		userConfirmation;
		constructor(userConfirmation) {
			super(`User-confirmation for task ${userConfirmation.task} ended in ${userConfirmation.status}`, "USER_CONFIRMATION_REJECTED_OR_TIMEOUT");
			this.userConfirmation = userConfirmation;
		}
	};
}));
//#endregion
//#region src/domains/cross-cutting/errors/selling/index.ts
var PromotionExposeGenerationFailedError;
var init_selling$1 = __esmMin((() => {
	PromotionExposeGenerationFailedError = class extends BaseError {
		message;
		constructor(message) {
			super(message, "PROMOTION_EXPOSE_GENERATION_FAILED");
			this.message = message;
		}
	};
}));
//#endregion
//#region src/domains/cross-cutting/errors/finance/bank-transaction-errors.ts
var BankTransactionReferenceConflictingInfosError;
var init_bank_transaction_errors = __esmMin((() => {
	BankTransactionReferenceConflictingInfosError = class extends NonRetriableError {
		constructor(transactionId, conflictingInfos) {
			super(`The provided parsed reference has conflicting infos, please validate the reference for correctness`, "FINANCE_BANK_TRANSACTION_CONFLICTING_REFERENCE", {
				conflictingInfos,
				transactionId
			});
		}
	};
}));
//#endregion
//#region src/domains/cross-cutting/errors/index.ts
var init_errors = __esmMin((() => {
	init_error_codes();
	init_base_errors();
	init_base_errors();
	init_condo_living$1();
	init_renting$2();
	init_investment_case();
	init_durable_job_errors();
	init_selling$1();
	init_bank_transaction_errors();
}));
//#endregion
//#region src/domains/cross-cutting/processes/property-management/property-management.model.ts
var PropertyManagementGroup, PropertyManagementStates, PropertyManagementEvents, PropertyManagementEventsGrouped;
var init_property_management_model = __esmMin((() => {
	PropertyManagementGroup = /* @__PURE__ */ function(PropertyManagementGroup) {
		PropertyManagementGroup["Estate"] = "Estate";
		PropertyManagementGroup["SEV"] = "SEV";
		PropertyManagementGroup["Tenant"] = "Tenant";
		return PropertyManagementGroup;
	}({});
	PropertyManagementStates = /* @__PURE__ */ function(PropertyManagementStates) {
		PropertyManagementStates["NotStarted"] = "NotStarted";
		PropertyManagementStates["Completed"] = "Completed";
		PropertyManagementStates["Onboarding"] = "Onboarding";
		PropertyManagementStates["Onboarded"] = "Onboarded";
		PropertyManagementStates["Offboarding"] = "Offboarding";
		PropertyManagementStates["General"] = "General";
		PropertyManagementStates["Regular"] = "Regular";
		PropertyManagementStates["Termination"] = "Termination";
		PropertyManagementStates["Terminated"] = "Terminated";
		PropertyManagementStates["EstateOnboarding"] = "EstateOnboarding";
		PropertyManagementStates["EstateOnboarded"] = "EstateOnboarded";
		PropertyManagementStates["InProgress"] = "InProgress";
		PropertyManagementStates["Absent"] = "Absent";
		return PropertyManagementStates;
	}({});
	PropertyManagementEvents = /* @__PURE__ */ function(PropertyManagementEvents) {
		PropertyManagementEvents["Estate_OnboardingStarted"] = "Estate_OnboardingStarted";
		PropertyManagementEvents["Estate_OnboardingDone"] = "Estate_OnboardingDone";
		PropertyManagementEvents["Estate_OffboardingStarted"] = "Estate_OffboardingStarted";
		PropertyManagementEvents["Estate_OffboardingDone"] = "Estate_OffboardingDone";
		PropertyManagementEvents["Estate_Completed"] = "Estate_Completed";
		PropertyManagementEvents["Tenant_OnboardingStarted"] = "Tenant_OnboardingStarted";
		PropertyManagementEvents["Tenant_OnboardingDone"] = "Tenant_OnboardingDone";
		PropertyManagementEvents["Tenant_OffboardingStarted"] = "Tenant_OffboardingStarted";
		PropertyManagementEvents["Tenant_OffboardingDone"] = "Tenant_OffboardingDone";
		PropertyManagementEvents["Tenant_TerminationStarted"] = "Tenant_TerminationStarted";
		PropertyManagementEvents["Tenant_TerminationDone"] = "Tenant_TerminationDone";
		PropertyManagementEvents["Tenant_Completed"] = "Tenant_Completed";
		PropertyManagementEvents["SEV_OnboardingStarted"] = "SEV_OnboardingStarted";
		PropertyManagementEvents["SEV_OnboardingDone"] = "SEV_OnboardingDone";
		PropertyManagementEvents["SEV_OffboardingStarted"] = "SEV_OffboardingStarted";
		PropertyManagementEvents["SEV_OffboardingDone"] = "SEV_OffboardingDone";
		PropertyManagementEvents["SEV_Completed"] = "SEV_Completed";
		PropertyManagementEvents["PurchasingNotarized"] = "PurchasingNotarized";
		PropertyManagementEvents["SellingOfferAccepted"] = "SellingOfferAccepted";
		PropertyManagementEvents["SellingOfferPaid"] = "SellingOfferPaid";
		PropertyManagementEvents["RentingTenantChosen"] = "RentingTenantChosen";
		return PropertyManagementEvents;
	}({});
	PropertyManagementEventsGrouped = {
		["Estate"]: [
			"PurchasingNotarized",
			"Estate_OnboardingDone",
			"SellingOfferAccepted",
			"SellingOfferPaid",
			"Estate_OffboardingDone"
		],
		["Tenant"]: [
			"SellingOfferAccepted",
			"RentingTenantChosen",
			"Estate_OnboardingDone",
			"Tenant_OnboardingDone",
			"SellingOfferPaid",
			"Tenant_OffboardingStarted",
			"Tenant_OffboardingDone",
			"Tenant_TerminationStarted",
			"Tenant_TerminationDone",
			"Tenant_OnboardingStarted"
		],
		["SEV"]: [
			"Estate_OnboardingDone",
			"SellingOfferAccepted",
			"SEV_OnboardingDone",
			"SEV_OffboardingStarted",
			"SEV_OffboardingDone",
			"Tenant_TerminationDone"
		]
	};
}));
//#endregion
//#region src/domains/cross-cutting/processes/property-management/estate-meter.opts.ts
var init_estate_meter_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/processes/property-management/estate-meter.model.ts
var EstateMeterType, MeterReadingType, MeterStatus;
var init_estate_meter_model = __esmMin((() => {
	EstateMeterType = /* @__PURE__ */ function(EstateMeterType) {
		EstateMeterType["ColdWater"] = "ColdWater";
		EstateMeterType["HotWater"] = "HotWater";
		EstateMeterType["Gas"] = "Gas";
		EstateMeterType["Electric"] = "Electric";
		EstateMeterType["Heating"] = "Heating";
		return EstateMeterType;
	}({});
	MeterReadingType = /* @__PURE__ */ function(MeterReadingType) {
		MeterReadingType["Cancellation"] = "Cancellation";
		MeterReadingType["Registration"] = "Registration";
		MeterReadingType["Regular"] = "Regular";
		return MeterReadingType;
	}({});
	MeterStatus = /* @__PURE__ */ function(MeterStatus) {
		MeterStatus["Present"] = "Present";
		MeterStatus["Removed"] = "Removed";
		MeterStatus["Replaced"] = "Replaced";
		return MeterStatus;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/processes/process.base.ts
var ProcessType, CondoProcess;
var init_process_base = __esmMin((() => {
	ProcessType = /* @__PURE__ */ function(ProcessType) {
		ProcessType["Sourcing"] = "Sourcing";
		ProcessType["Purchasing"] = "Purchasing";
		ProcessType["Renovation"] = "Renovation";
		ProcessType["Renting"] = "Renting";
		ProcessType["RentableUnit"] = "RentableUnit";
		ProcessType["Selling"] = "Selling";
		ProcessType["PropertyManagement"] = "PropertyManagement";
		ProcessType["EstateManagement"] = "EstateManagement";
		ProcessType["OwnerManagement"] = "OwnerManagement";
		ProcessType["TenantManagement"] = "TenantManagement";
		return ProcessType;
	}({});
	CondoProcess = class {
		processId;
		estateId;
		processType = "Sourcing";
		processState;
		uuid;
		finishedAt;
		startedBy;
		estate;
		tasks = [];
		events = [];
		calendarEvents = [];
		notes = [];
		documents = [];
		investment;
		renovation;
		constructor(props) {
			Object.assign(this, props);
		}
	};
}));
//#endregion
//#region src/lib/typebox/types/string-date.ts
var TStringDate;
var init_string_date = __esmMin((() => {
	TStringDate = (format = "date-time") => Type.Unsafe({
		type: "string",
		format
	});
	TypeRegistry.Set("TStringDate", (schema, value) => Check(schema, value));
}));
//#endregion
//#region src/lib/typebox/types/uint8-array.ts
var TBuffer;
var init_uint8_array = __esmMin((() => {
	TBuffer = Type.Unsafe({ type: "object" });
	TypeRegistry.Set("TUint8Array", (schema, value) => Check(schema, value));
}));
//#endregion
//#region src/lib/typebox/types/one-of-union.ts
function TOneOfUnion(oneOf, options = {}) {
	if (TypeGuard.IsTemplateLiteral(oneOf)) return TemplateLiteralToUnion(oneOf);
	if (oneOf.length === 0) return Never(options);
	if (oneOf.length === 1) return CloneType(oneOf[0], options);
	const clonedOneOf = CloneRest(oneOf);
	return Unsafe({
		...options,
		[Kind]: "OneOfUnion",
		oneOf: clonedOneOf
	});
}
var init_one_of_union = __esmMin((() => {
	TypeRegistry.Set("OneOfUnion", (schema, value) => {
		return schema.oneOf.map((s) => Value.Check(s, value)).filter(Boolean).length === 1;
	});
}));
//#endregion
//#region src/lib/typebox/types/index.ts
var init_types = __esmMin((() => {
	init_string_date();
	init_uint8_array();
	init_one_of_union();
}));
//#endregion
//#region src/lib/typebox/index.ts
var init_typebox = __esmMin((() => {
	init_types();
}));
//#endregion
//#region src/lib/shared-schemas.ts
var PG_INTEGER_MAX, TDate, TEnum, TStringEnum, TNullable, TDecimal, TNullableObject, TAnyDict, StringDateSchema, RequiredStringDateSchema, BaseCreatedDeletedAttributesSchema, OrderSchema, PaginationParamsSchema, ExpandSchema, EntityIdSchema, TPartialBy, getExpandSelectSchema, BaseEntityAttributesSchema;
var init_shared_schemas = __esmMin((() => {
	init_typebox();
	PG_INTEGER_MAX = 2147483647;
	TDate = TStringDate();
	TEnum = (items, options) => {
		if (_isEmpty(items) || !_isArray(items) && !_isPlainObject(items)) throw new TypeBoxError("Enum items must be a strings array or an object");
		return Type.Unsafe({
			...options,
			type: "string",
			enum: Array.isArray(items) ? items : Object.values(items)
		});
	};
	TStringEnum = (items, options) => {
		if (_isEmpty(items) || !_isArray(items)) throw new TypeBoxError("Enum items must be a strings array");
		return Type.Unsafe({
			...options,
			type: "string",
			enum: items
		});
	};
	TNullable = (schema, defaultNull = false) => {
		if (TypeGuard.IsRef(schema) || TypeGuard.IsUnion(schema) || schema.type === "string" && !!schema.enum) return Type.Union([schema, Type.Null()], { default: defaultNull ? null : void 0 });
		return Type.Unsafe({
			...schema,
			nullable: true,
			default: defaultNull ? null : void 0
		});
	};
	TDecimal = Type.String({
		pattern: "^-?\\d+(\\.\\d+)?$",
		description: "Decimal string for precise financial values"
	});
	TNullableObject = (schema) => {
		const object = schema;
		const properties = {};
		for (const [key, prop] of Object.entries(object.properties)) properties[key] = Type.Optional(TNullable(prop));
		return Type.Object(properties, { additionalProperties: object.additionalProperties });
	};
	TAnyDict = Type.Record(Type.String(), Type.Any());
	StringDateSchema = Type.Union([TNullable(TStringDate()), TNullable(Type.String())]);
	RequiredStringDateSchema = Type.Union([TStringDate(), Type.String()]);
	BaseCreatedDeletedAttributesSchema = Type.Object({
		createdAt: Type.Optional(StringDateSchema),
		deletedAt: Type.Optional(StringDateSchema),
		updatedAt: Type.Optional(StringDateSchema)
	});
	OrderSchema = Type.Optional(Type.Union([Type.Literal("ASC"), Type.Literal("DESC")]));
	PaginationParamsSchema = Type.Object({
		order: OrderSchema,
		orderBy: Type.Optional(Type.String()),
		page: Type.Number({
			minimum: 1,
			default: 1
		}),
		size: Type.Number({
			minimum: 1,
			default: 50
		})
	});
	ExpandSchema = Type.Recursive((Self) => Type.Object({
		select: Type.Optional(Type.Array(Type.String())),
		expand: Type.Optional(Type.Record(Type.String(), Type.Object({
			select: Type.Optional(Type.Array(Type.String())),
			expand: Type.Optional(Self)
		}, { additionalProperties: true })))
	}, { $id: "expand" }));
	EntityIdSchema = Type.Integer({
		minimum: 1,
		maximum: PG_INTEGER_MAX
	});
	TPartialBy = (schema, keys) => {
		return Type.Intersect([Type.Omit(schema, keys), Type.Partial(Type.Pick(schema, keys))]);
	};
	getExpandSelectSchema = (baseSchema) => {
		if (!TypeGuard.IsObject(baseSchema)) throw new Error(`"${baseSchema.$id}" baseSchema must be an object`);
		return Type.Union([Type.Array(TEnum(Object.keys(baseSchema.properties))), Type.Array(Type.Literal("*"), { maxItems: 1 })]);
	};
	BaseEntityAttributesSchema = Type.Object({
		createdAt: Type.Optional(StringDateSchema),
		deletedAt: Type.Optional(StringDateSchema),
		updatedAt: Type.Optional(StringDateSchema)
	}, { $id: "BaseEntityAttributes" });
}));
//#endregion
//#region src/domains/renting/renting.model.ts
var RentingStates, RentingEvents, almostOrAlreadyRentedRentingStates, vacantRentingStates, immutableEntitiesRentingStates, deletableRentingStates, finalRentingStates, RentingStatesOrder;
var init_renting_model = __esmMin((() => {
	RentingStates = /* @__PURE__ */ function(RentingStates) {
		RentingStates["Identified"] = "Identified";
		RentingStates["ListedByTenant"] = "ListedByTenant";
		RentingStates["Prepared"] = "Prepared";
		RentingStates["Listed"] = "Listed";
		RentingStates["Livings"] = "Livings";
		RentingStates["ViewingScheduled"] = "ViewingScheduled";
		RentingStates["Viewed"] = "Viewed";
		RentingStates["TenantChosen"] = "TenantChosen";
		RentingStates["SigningScheduled"] = "SigningScheduled";
		RentingStates["ContractSent"] = "ContractSent";
		RentingStates["ContractSigned"] = "ContractSigned";
		RentingStates["HandoverScheduled"] = "HandoverScheduled";
		RentingStates["HandoverDone"] = "HandoverDone";
		RentingStates["Completed"] = "Completed";
		RentingStates["OwnerOccupied"] = "OwnerOccupied";
		RentingStates["Blocked"] = "Blocked";
		return RentingStates;
	}({});
	RentingEvents = /* @__PURE__ */ function(RentingEvents) {
		RentingEvents["Blocked"] = "Blocked";
		RentingEvents["Identified"] = "Identified";
		RentingEvents["RentingListingPrepared"] = "RentingListingPrepared";
		RentingEvents["RentingLeadApproved"] = "RentingLeadApproved";
		RentingEvents["RentingLeadDisapproved"] = "RentingLeadDisapproved";
		RentingEvents["TenantFound"] = "TenantFound";
		RentingEvents["TenantNotFound"] = "TenantNotFound";
		RentingEvents["NoRentingNeeded"] = "NoRentingNeeded";
		RentingEvents["ListedByTenant"] = "ListedByTenant";
		RentingEvents["ScheduleSigningAtOffice"] = "ScheduleSigningAtOffice";
		RentingEvents["InternalHandoverDone"] = "InternalHandoverDone";
		RentingEvents["HandoverTakesPlace"] = "HandoverTakesPlace";
		RentingEvents["ContractNotSignedWithAlternativeTenantAvailable"] = "ContractNotSignedWithAlternativeTenantAvailable";
		RentingEvents["ContractNotSignedWithoutAlternativeTenantAvailable"] = "ContractNotSignedWithoutAlternativeTenantAvailable";
		RentingEvents["HandoverScheduled"] = "HandoverScheduled";
		RentingEvents["Livings"] = "Livings";
		RentingEvents["OwnerOccupied"] = "OwnerOccupied";
		RentingEvents["Resume"] = "Resume";
		return RentingEvents;
	}({});
	almostOrAlreadyRentedRentingStates = [
		"ContractSigned",
		"HandoverScheduled",
		"HandoverDone",
		"Completed"
	];
	vacantRentingStates = [
		"Identified",
		"Prepared",
		"Listed",
		"Livings",
		"ViewingScheduled",
		"Viewed",
		"TenantChosen",
		"SigningScheduled",
		"ContractSent",
		"ContractSigned",
		"HandoverScheduled",
		"HandoverDone",
		"Blocked"
	];
	immutableEntitiesRentingStates = [
		"ContractSigned",
		"HandoverScheduled",
		"HandoverDone",
		"Completed"
	];
	deletableRentingStates = [
		"Identified",
		"ListedByTenant",
		"Prepared",
		"Listed",
		"Livings",
		"ViewingScheduled",
		"Viewed",
		"TenantChosen",
		"SigningScheduled"
	];
	finalRentingStates = ["Completed", "OwnerOccupied"];
	RentingStatesOrder = [
		"Completed",
		"OwnerOccupied",
		"Identified",
		"ListedByTenant",
		"Prepared",
		"Listed",
		"Livings",
		"ViewingScheduled",
		"Viewed",
		"TenantChosen",
		"SigningScheduled",
		"ContractSent",
		"ContractSigned",
		"HandoverScheduled",
		"HandoverDone",
		"Blocked"
	];
}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh-process.base.ts
var MFHProcessType, MFHEvents, MFHSourcingState, EligibleMfhSourcingStates, MfhInPipelineSourcingStates, ExternalMfhInPipelineSourcingStates, MfhSourcingStatesForAssetsNotInPipeline, MfhSourcingStatesInAcquisitionPlanningPhase, MfhSourcingStatesInAcquisitionReservationPhase, MfhSourcingStatesInAcquisitionIgnoredPhase, MFHSubsidyFinancingState, MFHEstateManagementState, MFHProcessStateMapping, MFHProcessState, mfhSourcingMachineOrder;
var init_mfh_process_base = __esmMin((() => {
	MFHProcessType = /* @__PURE__ */ function(MFHProcessType) {
		MFHProcessType["Sourcing"] = "MFHSourcing";
		MFHProcessType["SubsidyFinancing"] = "MFHSubsidyFinancing";
		MFHProcessType["EstateManagement"] = "MFHEstateManagement";
		return MFHProcessType;
	}({});
	MFHEvents = /* @__PURE__ */ function(MFHEvents) {
		MFHEvents["NotInScope"] = "NotInScope";
		MFHEvents["Restart"] = "Restart";
		MFHEvents["Revert"] = "Revert";
		MFHEvents["ManualReject"] = "ManualReject";
		MFHEvents["ManualStart"] = "ManualStart";
		MFHEvents["PreApproved"] = "PreApproved";
		MFHEvents["PurchaseInvoicePaid"] = "PurchaseInvoicePaid";
		MFHEvents["HandoverDone"] = "HandoverDone";
		MFHEvents["Restored"] = "Restored";
		MFHEvents["Unpublished"] = "Unpublished";
		MFHEvents["Added"] = "Added";
		MFHEvents["ManuallyAdded"] = "ManuallyAdded";
		MFHEvents["StartDataCollection"] = "StartDataCollection";
		MFHEvents["Updated"] = "Updated";
		MFHEvents["InspectionScheduled"] = "InspectionScheduled";
		MFHEvents["Inspected"] = "Inspected";
		MFHEvents["ExpertAssigned"] = "ExpertAssigned";
		MFHEvents["EvidenceReportCreated"] = "EvidenceReportCreated";
		MFHEvents["BzaGenerated"] = "BzaGenerated";
		MFHEvents["BzaUploadedToSubsidy"] = "BzaUploadedToSubsidy";
		MFHEvents["SubsidyNotificationReceived"] = "SubsidyNotificationReceived";
		MFHEvents["SubsidyGranted"] = "SubsidyGranted";
		MFHEvents["SubsidyRejected"] = "SubsidyRejected";
		MFHEvents["FinalReportGenerated"] = "FinalReportGenerated";
		MFHEvents["ZueGenerated"] = "ZueGenerated";
		MFHEvents["ImplementationConfirmed"] = "ImplementationConfirmed";
		MFHEvents["SubmittedToBank"] = "SubmittedToBank";
		MFHEvents["DuplicationReset"] = "DuplicationReset";
		MFHEvents["DDStarted"] = "DDStarted";
		MFHEvents["InvestmentDecisionPending"] = "InvestmentDecisionPending";
		MFHEvents["DealClosingPending"] = "DealClosingPending";
		MFHEvents["Finished"] = "Finished";
		MFHEvents["Onboarded"] = "Onboarded";
		MFHEvents["Onboarding"] = "Onboarding";
		MFHEvents["Sold"] = "Sold";
		MFHEvents["Regular"] = "Regular";
		MFHEvents["Start"] = "Start";
		MFHEvents["ReadyForEvaluation"] = "ReadyForEvaluation";
		MFHEvents["ReadyForPotentialCalculations"] = "ReadyForPotentialCalculations";
		MFHEvents["ExternalAdvance"] = "ExternalAdvance";
		MFHEvents["ExternalReject"] = "ExternalReject";
		MFHEvents["ReadyForDueDiligence"] = "ReadyForDueDiligence";
		MFHEvents["FullPotentialCalaculationFinished"] = "FullPotentialCalaculationFinished";
		/** Placement → Placement: re-confirm buy-box, create a new placement row, replace candidate partners. */
		MFHEvents["BuyBoxReconfirmed"] = "BuyBoxReconfirmed";
		MFHEvents["ReadyForSigning"] = "ReadyForSigning";
		MFHEvents["ReadyForClosing"] = "ReadyForClosing";
		MFHEvents["ReadyForClosed"] = "ReadyForClosed";
		MFHEvents["Cancelled"] = "Cancelled";
		return MFHEvents;
	}({});
	MFHSourcingState = /* @__PURE__ */ function(MFHSourcingState) {
		MFHSourcingState["New"] = "New";
		MFHSourcingState["Validation"] = "Validation";
		MFHSourcingState["NotInScope"] = "NotInScope";
		MFHSourcingState["Duplicate"] = "Duplicate";
		MFHSourcingState["Unpublished"] = "Unpublished";
		MFHSourcingState["Screening"] = "Screening";
		MFHSourcingState["Evaluation"] = "Evaluation";
		MFHSourcingState["Placement"] = "Placement";
		MFHSourcingState["DueDiligence"] = "DueDiligence";
		MFHSourcingState["Closing"] = "Closing";
		MFHSourcingState["Closed"] = "Closed";
		MFHSourcingState["Rejected"] = "Rejected";
		return MFHSourcingState;
	}({});
	EligibleMfhSourcingStates = [
		"Screening",
		"Evaluation",
		"Placement",
		"DueDiligence",
		"Closing",
		"Closed"
	];
	MfhInPipelineSourcingStates = [
		"Screening",
		"Evaluation",
		"Placement",
		"DueDiligence",
		"Closing",
		"Closed"
	];
	ExternalMfhInPipelineSourcingStates = [
		"Placement",
		"DueDiligence",
		"Closing",
		"Closed"
	];
	MfhSourcingStatesForAssetsNotInPipeline = Object.values(omit(MFHSourcingState, [
		...MfhInPipelineSourcingStates,
		"New",
		"Validation"
	]));
	MfhSourcingStatesInAcquisitionPlanningPhase = [
		"Screening",
		"Evaluation",
		"Placement"
	];
	MfhSourcingStatesInAcquisitionReservationPhase = ["DueDiligence", "Closing"];
	MfhSourcingStatesInAcquisitionIgnoredPhase = [
		"NotInScope",
		"Duplicate",
		"Unpublished",
		"Rejected"
	];
	MFHSubsidyFinancingState = /* @__PURE__ */ function(MFHSubsidyFinancingState) {
		MFHSubsidyFinancingState["Identified"] = "Identified";
		MFHSubsidyFinancingState["ExpertAssigned"] = "ExpertAssigned";
		MFHSubsidyFinancingState["InspectionScheduled"] = "InspectionScheduled";
		MFHSubsidyFinancingState["Inspected"] = "Inspected";
		MFHSubsidyFinancingState["EvidenceReportCreated"] = "EvidenceReportCreated";
		MFHSubsidyFinancingState["BzaGenerated"] = "BzaGenerated";
		MFHSubsidyFinancingState["BzaUploadedToSubsidy"] = "BzaUploadedToSubsidy";
		MFHSubsidyFinancingState["SubsidyNotificationReceived"] = "SubsidyNotificationReceived";
		MFHSubsidyFinancingState["SubsidyGranted"] = "SubsidyGranted";
		MFHSubsidyFinancingState["SubsidyRejected"] = "SubsidyRejected";
		MFHSubsidyFinancingState["FinalReportGenerated"] = "FinalReportGenerated";
		MFHSubsidyFinancingState["ZueGenerated"] = "ZueGenerated";
		MFHSubsidyFinancingState["ImplementationConfirmed"] = "ImplementationConfirmed";
		MFHSubsidyFinancingState["Completed"] = "Completed";
		MFHSubsidyFinancingState["Cancelled"] = "Cancelled";
		return MFHSubsidyFinancingState;
	}({});
	MFHEstateManagementState = /* @__PURE__ */ function(MFHEstateManagementState) {
		MFHEstateManagementState["PreOnboarding"] = "PreOnboarding";
		MFHEstateManagementState["Onboarding"] = "Onboarding";
		MFHEstateManagementState["Stabilization"] = "Stabilization";
		MFHEstateManagementState["Cancelled"] = "Cancelled";
		return MFHEstateManagementState;
	}({});
	MFHProcessStateMapping = {
		["MFHSourcing"]: omit(MFHSourcingState, ["New", "Validation"]),
		["MFHSubsidyFinancing"]: MFHSubsidyFinancingState,
		["MFHEstateManagement"]: MFHEstateManagementState
	};
	MFHProcessState = {
		...MFHSourcingState,
		...MFHSubsidyFinancingState,
		...MFHEstateManagementState
	};
	mfhSourcingMachineOrder = [
		"New",
		"Validation",
		"NotInScope",
		"Duplicate",
		"Unpublished",
		"Rejected",
		"Screening",
		"Evaluation",
		"Placement",
		"DueDiligence",
		"Closing",
		"Closed"
	];
}));
//#endregion
//#region src/domains/cross-cutting/processes/estate-management.model.ts
var EstateManagementStates, EstateManagementEvents, EstateManagementChecklistItems;
var init_estate_management_model = __esmMin((() => {
	EstateManagementStates = /* @__PURE__ */ function(EstateManagementStates) {
		EstateManagementStates["Identified"] = "Identified";
		EstateManagementStates["Onboarded"] = "Onboarded";
		EstateManagementStates["Sold"] = "Sold";
		EstateManagementStates["Completed"] = "Completed";
		EstateManagementStates["Cancelled"] = "Cancelled";
		return EstateManagementStates;
	}({});
	EstateManagementEvents = /* @__PURE__ */ function(EstateManagementEvents) {
		EstateManagementEvents["Start"] = "Start";
		EstateManagementEvents["Identified"] = "Identified";
		EstateManagementEvents["Onboarded"] = "Onboarded";
		EstateManagementEvents["Sold"] = "Sold";
		EstateManagementEvents["Completed"] = "Completed";
		return EstateManagementEvents;
	}({});
	EstateManagementChecklistItems = /* @__PURE__ */ function(EstateManagementChecklistItems) {
		EstateManagementChecklistItems["Meters"] = "meters";
		EstateManagementChecklistItems["WEG"] = "weg";
		EstateManagementChecklistItems["SEPA"] = "sepa";
		return EstateManagementChecklistItems;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/processes/owner-management.model.ts
var OwnerManagementStates, OwnerManagementEvents;
var init_owner_management_model = __esmMin((() => {
	OwnerManagementStates = /* @__PURE__ */ function(OwnerManagementStates) {
		OwnerManagementStates["Identified"] = "Identified";
		OwnerManagementStates["Regular"] = "Regular";
		OwnerManagementStates["Cancelled"] = "Cancelled";
		OwnerManagementStates["Completed"] = "Completed";
		return OwnerManagementStates;
	}({});
	OwnerManagementEvents = /* @__PURE__ */ function(OwnerManagementEvents) {
		OwnerManagementEvents["Started"] = "Started";
		OwnerManagementEvents["Regular"] = "Regular";
		OwnerManagementEvents["SEVContractCancelled"] = "SEVContractCancelled";
		OwnerManagementEvents["Completed"] = "Completed";
		return OwnerManagementEvents;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/processes/rentable-unit.model.ts
var RentableUnitStates, RentableUnitEvents, RentableUnitProcessEventsToStatesMap, RentableUnitPausedStates, RentableUnitAllRentedOrNoRentingNeeded;
var init_rentable_unit_model$1 = __esmMin((() => {
	RentableUnitStates = /* @__PURE__ */ function(RentableUnitStates) {
		RentableUnitStates["Vacant"] = "Vacant";
		RentableUnitStates["Occupied"] = "Occupied";
		RentableUnitStates["OwnerOccupied"] = "OwnerOccupied";
		RentableUnitStates["PartiallyOccupied"] = "PartiallyOccupied";
		RentableUnitStates["BlockedByPm"] = "BlockedByPm";
		RentableUnitStates["BlockedByRenovation"] = "BlockedByRenovation";
		return RentableUnitStates;
	}({});
	RentableUnitEvents = /* @__PURE__ */ function(RentableUnitEvents) {
		RentableUnitEvents["Vacant"] = "Vacant";
		RentableUnitEvents["Occupied"] = "Occupied";
		RentableUnitEvents["OwnerOccupied"] = "OwnerOccupied";
		RentableUnitEvents["PartiallyOccupied"] = "PartiallyOccupied";
		RentableUnitEvents["BlockedByPm"] = "BlockedByPm";
		RentableUnitEvents["BlockedByRenovation"] = "BlockedByRenovation";
		RentableUnitEvents["Resume"] = "Resume";
		return RentableUnitEvents;
	}({});
	RentableUnitProcessEventsToStatesMap = {
		["Vacant"]: "Vacant",
		["Occupied"]: "Occupied",
		["OwnerOccupied"]: "OwnerOccupied",
		["PartiallyOccupied"]: "PartiallyOccupied",
		["BlockedByPm"]: "BlockedByPm",
		["BlockedByRenovation"]: "BlockedByRenovation"
	};
	RentableUnitPausedStates = ["BlockedByPm", "BlockedByRenovation"];
	RentableUnitAllRentedOrNoRentingNeeded = ["Occupied", "OwnerOccupied"];
}));
//#endregion
//#region src/domains/cross-cutting/processes/tenant-management.model.ts
var TenantManagementStates, TenantManagementEvents;
var init_tenant_management_model = __esmMin((() => {
	TenantManagementStates = /* @__PURE__ */ function(TenantManagementStates) {
		TenantManagementStates["Initiated"] = "Initiated";
		TenantManagementStates["Onboarding"] = "Onboarding";
		TenantManagementStates["Active"] = "Active";
		TenantManagementStates["RentReduction"] = "RentReduction";
		TenantManagementStates["Cancelled"] = "Cancelled";
		TenantManagementStates["TerminationNoticeReceived"] = "TerminationNoticeReceived";
		TenantManagementStates["TerminationAccepted"] = "TerminationAccepted";
		TenantManagementStates["TerminationInitiated"] = "TerminationInitiated";
		TenantManagementStates["HandoverScheduled"] = "HandoverScheduled";
		TenantManagementStates["HandoverDone"] = "HandoverDone";
		TenantManagementStates["Terminated"] = "Terminated";
		TenantManagementStates["Closed"] = "Closed";
		return TenantManagementStates;
	}({});
	TenantManagementEvents = /* @__PURE__ */ function(TenantManagementEvents) {
		TenantManagementEvents["UtilityDeregistered"] = "UtilityDeregistered";
		TenantManagementEvents["KeysGiven"] = "KeysGiven";
		TenantManagementEvents["Cancel"] = "Cancel";
		TenantManagementEvents["TempRentCreated"] = "TempRentCreated";
		TenantManagementEvents["ActiveRentRestored"] = "ActiveRentRestored";
		TenantManagementEvents["CancelledBeforeMovingIn"] = "CancelledBeforeMovingIn";
		TenantManagementEvents["TenantRequestedTermination"] = "TenantRequestedTermination";
		TenantManagementEvents["TerminationStarted"] = "TerminationStarted";
		TenantManagementEvents["TerminationVerified"] = "TerminationVerified";
		TenantManagementEvents["TerminationRejected"] = "TerminationRejected";
		TenantManagementEvents["HandoverScheduled"] = "HandoverScheduled";
		TenantManagementEvents["HandoverComplete"] = "HandoverComplete";
		TenantManagementEvents["BKAPaidAndDepositReturned"] = "BKAPaidAndDepositReturned";
		TenantManagementEvents["TerminationInitiated"] = "TerminationInitiated";
		TenantManagementEvents["Terminated"] = "Terminated";
		return TenantManagementEvents;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/processes/process.model.ts
var MeterType, FinancingPortfolio, RentingAttributesSchema, SourcingPriority, BaseProcessSchema, BaseRentingProcessExtraPropsSchema, RentingProcessExtraPropsSchema, BaseRentingProcessSchema, RentingProcessSchema, rentingProcessSchemas, PhotoProcessStatus, getPhotoProcessStatusStr, SellingPartner, PurchasingState, EligibleEstatePurchasingStates, RenovationStates, RenovationInspectionType, OngoingRenovation, RenovationInPlanningStates, RenovationInFixingStates, RenovationInRenovationStates, SellingStates, SellingStatesEstateAvailableForSelling, SellingStatesEstateReservedForSelling, SellingStatesEstateSold, SalesPackageEstateSellingStatesGrouped, SellingAvailability, SourcingStates, shortlistExcludedProcesses, ProcessStateMapping, ProcessStateUnion, ProcessEventUnion, sourcingStatesToReScore, sourcingStatesEstateInsideOfTheOperationsTeamFunnel, omittedSourcingStates, isSellingProcess, isRenovationProcess, isPurchasingProcess, isSourcingProcess, isRentableUnitProcess, isTenantManagementProcess, ManualProcessRejectionReason, processStateToRejectionsMap, statesAlternativeNames, mfhStatesAlternativeNames, mfhBuildingStatesAlternativeNames, mfhPortfolioStatesAlternativeNames, mfhRenovationProjectStatesPlanningModuleAlternativeNames, mfhRenovationProjectLotStatesAlternativeNames, mfhRenovationProjectCostBreakdownStatesAlternativeNames, mfhRenovationProjectStatesAlternativeNames, tenderingProcessStatesAlternativeNames, stateToHuman, mfhStateToHuman, mfhBuildingStateToHuman, mfhPortfolioStateToHuman, mfhRenovationProjectLotStateToHuman, mfhRenovationProjectCostBreakdownStateToHuman, tenderingProcessStateToHuman, mfhRenovationProjectPlanningModuleStateToHuman, mfhRenovationProjectStateToHuman;
var init_process_model = __esmMin((() => {
	init_shared_schemas();
	init_legacy_events();
	init_renting_model();
	init_mfh_process_base();
	init_estate_management_model();
	init_owner_management_model();
	init_process_base();
	init_property_management_model();
	init_rentable_unit_model$1();
	init_tenant_management_model();
	MeterType = /* @__PURE__ */ function(MeterType) {
		MeterType["Water"] = "Water";
		MeterType["Gas"] = "Gas";
		MeterType["Electro"] = "Electro";
		MeterType["Heating"] = "Heating";
		return MeterType;
	}({});
	FinancingPortfolio = /* @__PURE__ */ function(FinancingPortfolio) {
		FinancingPortfolio["HASPA_1"] = "HASPA_1";
		FinancingPortfolio["HASPA_2"] = "HASPA_2";
		FinancingPortfolio["HASPA_3"] = "HASPA_3";
		FinancingPortfolio["SPARLUNE_1"] = "SPAR.LÜNE_1";
		FinancingPortfolio["SPARWH_1"] = "SPAR.WH_1";
		return FinancingPortfolio;
	}({});
	RentingAttributesSchema = Type.Object({
		listingDate: Type.Optional(StringDateSchema),
		onHoldReason: Type.Optional(Type.String()),
		beforeOnHoldState: Type.Optional(Type.Any()),
		terminationJobId: Type.Optional(Type.String()),
		terminationJobDate: Type.Optional(StringDateSchema),
		rentalContractId: Type.Optional(Type.Number()),
		draftRentalContractDocumentId: Type.Optional(TNullable(Type.Number())),
		signedRentalContractDocumentId: Type.Optional(Type.Number())
	}, { $id: "RentingAttributes" });
	SourcingPriority = /* @__PURE__ */ function(SourcingPriority) {
		SourcingPriority[SourcingPriority["One"] = 1] = "One";
		SourcingPriority[SourcingPriority["Two"] = 2] = "Two";
		return SourcingPriority;
	}({});
	BaseProcessSchema = Type.Object({
		processId: Type.Number(),
		estateId: Type.Number(),
		processType: Type.Enum(ProcessType),
		processState: Type.Object({
			state: Type.Any(),
			time: Type.Optional(StringDateSchema)
		}),
		uuid: Type.Optional(Type.String()),
		lastError: Type.Optional(Type.Record(Type.String(), Type.Any())),
		finishedAt: Type.Optional(StringDateSchema),
		startedBy: Type.Optional(Type.String()),
		createdAt: Type.Optional(StringDateSchema),
		updatedAt: Type.Optional(StringDateSchema),
		deletedAt: Type.Optional(StringDateSchema)
	}, { $id: "BaseProcess" });
	BaseRentingProcessExtraPropsSchema = Type.Object({ attributes: Type.Optional(Type.Ref(RentingAttributesSchema)) }, { $id: "BaseRentingProcessExtraProps" });
	RentingProcessExtraPropsSchema = Type.Intersect([Type.Ref(BaseRentingProcessExtraPropsSchema), Type.Object({
		rupId: Type.Optional(Type.Number()),
		sellingInvestmentCase: Type.Optional(Type.Any()),
		rentingPartner: Type.Optional(Type.Any()),
		terminationNoticeReceivedAt: Type.Optional(StringDateSchema),
		terminatedAt: Type.Optional(StringDateSchema),
		rentingPartnerMandated: Type.Optional(Type.Boolean()),
		rentingPartnerContactId: Type.Optional(Type.Number())
	})], { $id: "RentingProcessExtraProps" });
	BaseRentingProcessSchema = Type.Intersect([Type.Ref(BaseProcessSchema), Type.Ref(BaseRentingProcessExtraPropsSchema)], { $id: "BaseRentingProcess" });
	RentingProcessSchema = Type.Intersect([Type.Ref(BaseProcessSchema), Type.Ref(RentingProcessExtraPropsSchema)], { $id: "RentingProcess" });
	rentingProcessSchemas = {
		RentingAttributesSchema,
		BaseProcessSchema,
		BaseRentingProcessExtraPropsSchema,
		RentingProcessExtraPropsSchema,
		BaseRentingProcessSchema,
		RentingProcessSchema
	};
	PhotoProcessStatus = /* @__PURE__ */ function(PhotoProcessStatus) {
		PhotoProcessStatus["No"] = "No";
		PhotoProcessStatus["Mandated"] = "Mandated";
		PhotoProcessStatus["Yes"] = "Yes";
		return PhotoProcessStatus;
	}({});
	getPhotoProcessStatusStr = (status) => status ? `✅ Ja` : `❌ Nein`;
	SellingPartner = /* @__PURE__ */ function(SellingPartner) {
		SellingPartner["G_B"] = "G&B";
		SellingPartner["HIH"] = "HIH";
		SellingPartner["Tecis"] = "Tecis";
		SellingPartner["PlanetHome"] = "PlanetHome";
		SellingPartner["NoPartner"] = "NoPartner";
		return SellingPartner;
	}({});
	PurchasingState = /* @__PURE__ */ function(PurchasingState) {
		PurchasingState["OfferAccepted"] = "OfferAccepted";
		PurchasingState["OfferRejected"] = "OfferRejected";
		PurchasingState["DraftReceived"] = "DraftReceived";
		PurchasingState["DraftApproved"] = "DraftApproved";
		PurchasingState["Notarized"] = "Notarized";
		PurchasingState["KeysHandedOver"] = "KeysHandedOver";
		PurchasingState["FmReceived"] = "FmReceived";
		PurchasingState["Paid"] = "Paid";
		PurchasingState["HandoverDone"] = "HandoverDone";
		PurchasingState["Cancelled"] = "Cancelled";
		PurchasingState["Completed"] = "Completed";
		return PurchasingState;
	}({});
	EligibleEstatePurchasingStates = Object.values(PurchasingState).filter((st) => st !== "OfferRejected");
	RenovationStates = /* @__PURE__ */ function(RenovationStates) {
		RenovationStates["Identified"] = "Identified";
		RenovationStates["Measured"] = "Measured";
		RenovationStates["Modelled"] = "Modelled";
		RenovationStates["Briefed"] = "Briefed";
		RenovationStates["Planned"] = "Planned";
		RenovationStates["Prepared"] = "Prepared";
		RenovationStates["CapturedWithContractor"] = "CapturedWithContractor";
		RenovationStates["RenovationStarted"] = "RenovationStarted";
		RenovationStates["InRenovation"] = "InRenovation";
		RenovationStates["OnHold"] = "OnHold";
		RenovationStates["InWarranty"] = "InWarranty";
		RenovationStates["CompletionRequested"] = "CompletionRequested";
		RenovationStates["Completed"] = "Completed";
		RenovationStates["DefectsPending"] = "DefectsPending";
		RenovationStates["Cancelled"] = "Cancelled";
		return RenovationStates;
	}({});
	RenovationInspectionType = /* @__PURE__ */ function(RenovationInspectionType) {
		RenovationInspectionType["General"] = "General";
		RenovationInspectionType["RenovationStart"] = "RenovationStart";
		RenovationInspectionType["PlanningVerification"] = "PlanningVerification";
		RenovationInspectionType["BasicInstallationCheck"] = "BasicInstallationCheck";
		RenovationInspectionType["SealingCheck"] = "SealingCheck";
		RenovationInspectionType["GroundLevelingCheck"] = "GroundLevelingCheck";
		RenovationInspectionType["InternalAcceptance"] = "InternalAcceptance";
		RenovationInspectionType["ExternalAcceptance"] = "ExternalAcceptance";
		return RenovationInspectionType;
	}({});
	OngoingRenovation = ["InRenovation"];
	RenovationInPlanningStates = [
		"Identified",
		"Measured",
		"Modelled",
		"Briefed",
		"Planned",
		"CapturedWithContractor"
	];
	RenovationInFixingStates = ["DefectsPending", "InWarranty"];
	RenovationInRenovationStates = ["InRenovation", "OnHold"];
	SellingStates = /* @__PURE__ */ function(SellingStates) {
		SellingStates["OnHold"] = "OnHold";
		SellingStates["Identified"] = "Identified";
		SellingStates["Prepared"] = "Prepared";
		SellingStates["SellingPartnerMandated"] = "SellingPartnerMandated";
		SellingStates["SellingPartnerPrepared"] = "SellingPartnerPrepared";
		SellingStates["OnMarket"] = "OnMarket";
		SellingStates["OnOpenMarket"] = "OnOpenMarket";
		SellingStates["OfferReceived"] = "OfferReceived";
		SellingStates["OfferAccepted"] = "OfferAccepted";
		SellingStates["NotaryDraftReceived"] = "NotaryDraftReceived";
		SellingStates["DraftApproved"] = "DraftApproved";
		SellingStates["NotarizationScheduled"] = "NotarizationScheduled";
		SellingStates["Notarized"] = "Notarized";
		SellingStates["FMReceived"] = "FMReceived";
		SellingStates["Paid"] = "Paid";
		SellingStates["HandoverDone"] = "HandoverDone";
		SellingStates["Completed"] = "Completed";
		SellingStates["Cancelled"] = "Cancelled";
		return SellingStates;
	}({});
	SellingStatesEstateAvailableForSelling = [
		"Identified",
		"SellingPartnerMandated",
		"SellingPartnerPrepared",
		"OnMarket",
		"OnOpenMarket"
	];
	SellingStatesEstateReservedForSelling = [
		"OfferReceived",
		"OfferAccepted",
		"NotaryDraftReceived",
		"DraftApproved",
		"NotarizationScheduled"
	];
	SellingStatesEstateSold = [
		"Notarized",
		"FMReceived",
		"Paid",
		"HandoverDone"
	];
	SalesPackageEstateSellingStatesGrouped = {
		["Prepared"]: [
			"Prepared",
			"SellingPartnerMandated",
			"SellingPartnerPrepared"
		],
		["OnMarket"]: ["OnMarket", "OnOpenMarket"],
		["OfferReceived"]: ["OfferReceived"],
		["OfferAccepted"]: [
			"NotarizationScheduled",
			"OfferAccepted",
			"NotaryDraftReceived",
			"DraftApproved"
		],
		["Notarized"]: [
			"Notarized",
			"FMReceived",
			"Paid",
			"HandoverDone"
		],
		["Completed"]: ["Completed"]
	};
	SellingAvailability = /* @__PURE__ */ function(SellingAvailability) {
		SellingAvailability["Available"] = "Available";
		SellingAvailability["Reserved"] = "Reserved";
		SellingAvailability["Sold"] = "Sold";
		return SellingAvailability;
	}({});
	SourcingStates = /* @__PURE__ */ function(SourcingStates) {
		SourcingStates["PreApproved"] = "PreApproved";
		SourcingStates["ExportedToPartner"] = "ExportedToPartner";
		SourcingStates["Contacted"] = "Contacted";
		SourcingStates["InspectionScheduled"] = "InspectionScheduled";
		SourcingStates["Inspected"] = "Inspected";
		SourcingStates["OfferMade"] = "OfferMade";
		SourcingStates["PreliminaryOfferMade"] = "PreliminaryOfferMade";
		SourcingStates["OfferRejected"] = "OfferRejected";
		SourcingStates["Completed"] = "Completed";
		SourcingStates["Rejected"] = "Rejected";
		SourcingStates["Cancelled"] = "Cancelled";
		SourcingStates["Unpublished"] = "Unpublished";
		SourcingStates["NotInScope"] = "NotInScope";
		SourcingStates["Duplicate"] = "Duplicate";
		SourcingStates["New"] = "New";
		SourcingStates["DataValidation"] = "DataValidation";
		SourcingStates["Processing"] = "Processing";
		SourcingStates["ManualReview"] = "ManualReview";
		SourcingStates["Offer"] = "Offer";
		SourcingStates["PreliminaryOffer"] = "PreliminaryOffer";
		SourcingStates["Prediction"] = "Prediction";
		SourcingStates["PredictionFailed"] = "PredictionFailed";
		SourcingStates["ExternalDataCollection"] = "ExternalDataCollection";
		SourcingStates["ProfitabilityCheck"] = "ProfitabilityCheck";
		SourcingStates["Accepted"] = "Accepted";
		SourcingStates["Waiting"] = "Waiting";
		SourcingStates["ContactRequested"] = "ContactRequested";
		SourcingStates["ManualRejected"] = "ManualRejected";
		SourcingStates["InspectionRequested"] = "InspectionRequested";
		return SourcingStates;
	}({});
	shortlistExcludedProcesses = { sourcing: [
		"Rejected",
		"Cancelled",
		"Unpublished",
		"NotInScope",
		"Duplicate",
		"OfferRejected",
		"New",
		"DataValidation",
		"Processing",
		"Offer",
		"PreliminaryOffer",
		"Prediction",
		"ExternalDataCollection",
		"ProfitabilityCheck",
		"Accepted",
		"Waiting"
	] };
	ProcessStateMapping = {
		["Sourcing"]: SourcingStates,
		["Purchasing"]: PurchasingState,
		["Renovation"]: RenovationStates,
		["Renting"]: RentingStates,
		["Selling"]: SellingStates,
		["PropertyManagement"]: PropertyManagementStates,
		["TenantManagement"]: TenantManagementStates,
		["OwnerManagement"]: OwnerManagementStates,
		["EstateManagement"]: EstateManagementStates,
		["RentableUnit"]: RentableUnitStates
	};
	ProcessStateUnion = {
		...SourcingStates,
		...PurchasingState,
		...RenovationStates,
		...RentingStates,
		...SellingStates,
		...PropertyManagementStates,
		...TenantManagementStates,
		...OwnerManagementStates,
		...EstateManagementStates,
		...RentableUnitStates
	};
	ProcessEventUnion = {
		...RentingEvents,
		...PropertyManagementEvents,
		...TenantManagementEvents,
		...OwnerManagementEvents,
		...EstateManagementEvents,
		...RentableUnitEvents,
		...CondoEvents
	};
	sourcingStatesToReScore = ["Waiting", "PredictionFailed"];
	sourcingStatesEstateInsideOfTheOperationsTeamFunnel = [
		"Cancelled",
		"Contacted",
		"Completed",
		"Inspected",
		"InspectionScheduled",
		"OfferMade",
		"OfferRejected"
	];
	omittedSourcingStates = [
		"Processing",
		"Prediction",
		"Accepted",
		"ProfitabilityCheck",
		"Offer"
	];
	isSellingProcess = (process) => process.processType === "Selling";
	isRenovationProcess = (process) => process.processType === "Renovation";
	isPurchasingProcess = (process) => process.processType === "Purchasing";
	isSourcingProcess = (process) => process.processType === "Sourcing";
	isRentableUnitProcess = (process) => process.processType === "RentableUnit";
	isTenantManagementProcess = (process) => process.processType === "TenantManagement";
	ManualProcessRejectionReason = /* @__PURE__ */ function(ManualProcessRejectionReason) {
		ManualProcessRejectionReason["Offline"] = "Offline";
		ManualProcessRejectionReason["Other"] = "Other";
		ManualProcessRejectionReason["Location"] = "Location";
		ManualProcessRejectionReason["Profitability"] = "Profitability";
		ManualProcessRejectionReason["NotInScope"] = "NotInScope";
		ManualProcessRejectionReason["OwnersRightOfResidence"] = "OwnersRightOfResidence";
		ManualProcessRejectionReason["Fake"] = "Fake";
		ManualProcessRejectionReason["UnrealisticRent"] = "UnrealisticRent";
		ManualProcessRejectionReason["NotAvailable"] = "NotAvailable";
		ManualProcessRejectionReason["ViewingImpossible"] = "ViewingImpossible";
		ManualProcessRejectionReason["PriceTooHigh"] = "PriceTooHigh";
		ManualProcessRejectionReason["SaleWithdrawn"] = "SaleWithdrawn";
		ManualProcessRejectionReason["RealtorNoFinalDeal"] = "RealtorNoFinalDeal";
		ManualProcessRejectionReason["EstateInsufficient"] = "EstateInsufficient";
		ManualProcessRejectionReason["Documents"] = "Documents";
		ManualProcessRejectionReason["OfferTooLow"] = "OfferTooLow";
		ManualProcessRejectionReason["OtherBuyer"] = "OtherBuyer";
		ManualProcessRejectionReason["CommercialBuyer"] = "CommercialBuyer";
		return ManualProcessRejectionReason;
	}({});
	processStateToRejectionsMap = {
		[ProcessStateUnion.PreApproved]: {
			targetState: [ProcessStateUnion.Rejected, ProcessStateUnion.ManualRejected],
			rejectionReasons: [
				"Offline",
				"Location",
				"Profitability",
				"NotInScope",
				"OwnersRightOfResidence",
				"Fake",
				"Other"
			]
		},
		[ProcessStateUnion.Contacted]: {
			targetState: ProcessStateUnion.Cancelled,
			rejectionReasons: [
				"NotInScope",
				"UnrealisticRent",
				"NotAvailable",
				"ViewingImpossible",
				"PriceTooHigh",
				"SaleWithdrawn",
				"OwnersRightOfResidence",
				"Other"
			]
		},
		[ProcessStateUnion.InspectionScheduled]: {
			targetState: ProcessStateUnion.Cancelled,
			rejectionReasons: [
				"NotAvailable",
				"Documents",
				"Other"
			]
		},
		[ProcessStateUnion.Inspected]: {
			targetState: ProcessStateUnion.Cancelled,
			rejectionReasons: [
				"RealtorNoFinalDeal",
				"EstateInsufficient",
				"Documents",
				"PriceTooHigh",
				"OwnersRightOfResidence",
				"Other"
			]
		},
		[ProcessStateUnion.PreliminaryOfferMade]: {
			targetState: ProcessStateUnion.OfferRejected,
			rejectionReasons: [
				"OfferTooLow",
				"OtherBuyer",
				"CommercialBuyer",
				"Other"
			]
		},
		[ProcessStateUnion.OfferMade]: {
			targetState: ProcessStateUnion.OfferRejected,
			rejectionReasons: [
				"OfferTooLow",
				"OtherBuyer",
				"CommercialBuyer",
				"Other"
			]
		},
		[ProcessStateUnion.OfferAccepted]: {
			targetState: ProcessStateUnion.OfferRejected,
			rejectionReasons: [
				"OfferTooLow",
				"OtherBuyer",
				"CommercialBuyer",
				"Other"
			]
		},
		[ProcessStateUnion.ExportedToPartner]: {
			targetState: ProcessStateUnion.Cancelled,
			rejectionReasons: [
				"NotInScope",
				"Offline",
				"Location",
				"Profitability",
				"OwnersRightOfResidence",
				"Fake",
				"Other"
			]
		},
		[ProcessStateUnion.DraftReceived]: {
			targetState: ProcessStateUnion.OfferRejected,
			rejectionReasons: [
				"OfferTooLow",
				"OtherBuyer",
				"CommercialBuyer",
				"Other"
			]
		}
	};
	statesAlternativeNames = {
		["Purchasing"]: { ["FmReceived"]: "Payment Notice Received" },
		["Selling"]: {
			["NotaryDraftReceived"]: "Draft Received",
			["FMReceived"]: "Payment Notice Received"
		},
		["Sourcing"]: {
			["Inspected"]: "Viewed",
			["InspectionScheduled"]: "Viewing Scheduled",
			["InspectionRequested"]: "Viewing Requested",
			["PreliminaryOfferMade"]: "Pre-Offer Made"
		},
		["Renovation"]: { ["CapturedWithContractor"]: "Contractor Mandated" },
		["RentableUnit"]: {
			["Vacant"]: "Vacant",
			["Occupied"]: "Occupied",
			["OwnerOccupied"]: "Owner Occupied",
			["BlockedByPm"]: "Blocked By PM",
			["BlockedByRenovation"]: "Blocked By Renovation"
		}
	};
	mfhStatesAlternativeNames = { ["MFHSubsidyFinancing"]: {
		["BzaGenerated"]: "BZA Generated",
		["BzaUploadedToSubsidy"]: "BZA Uploaded To Subsidy",
		["ZueGenerated"]: "ZUE Generated"
	} };
	mfhBuildingStatesAlternativeNames = {};
	mfhPortfolioStatesAlternativeNames = {};
	mfhRenovationProjectStatesPlanningModuleAlternativeNames = {};
	mfhRenovationProjectLotStatesAlternativeNames = {};
	mfhRenovationProjectCostBreakdownStatesAlternativeNames = {};
	mfhRenovationProjectStatesAlternativeNames = {};
	tenderingProcessStatesAlternativeNames = {};
	stateToHuman = (value, type) => get(statesAlternativeNames, [type, value], toTitleCase(value));
	mfhStateToHuman = (value, type) => get(mfhStatesAlternativeNames, [type, value], toTitleCase(value));
	mfhBuildingStateToHuman = (value, type) => get(mfhBuildingStatesAlternativeNames, [type, value], toTitleCase(value));
	mfhPortfolioStateToHuman = (value, type) => get(mfhPortfolioStatesAlternativeNames, [type, value], toTitleCase(value));
	mfhRenovationProjectLotStateToHuman = (value) => get(mfhRenovationProjectLotStatesAlternativeNames, value, toTitleCase(value));
	mfhRenovationProjectCostBreakdownStateToHuman = (value) => get(mfhRenovationProjectCostBreakdownStatesAlternativeNames, value, toTitleCase(value));
	tenderingProcessStateToHuman = (value) => get(tenderingProcessStatesAlternativeNames, value, toTitleCase(value));
	mfhRenovationProjectPlanningModuleStateToHuman = (value) => get(mfhRenovationProjectStatesPlanningModuleAlternativeNames, value, toTitleCase(value));
	mfhRenovationProjectStateToHuman = (value) => get(mfhRenovationProjectStatesAlternativeNames, value, toTitleCase(value));
}));
//#endregion
//#region src/domains/cross-cutting/calendar-event.model.ts
var CalendarType, CalendarStagesUnsorted, CalendarStages, CalendarResponseStatus;
var init_calendar_event_model = __esmMin((() => {
	CalendarType = /* @__PURE__ */ function(CalendarType) {
		CalendarType["General"] = "General";
		CalendarType["Sourcing"] = "Sourcing";
		CalendarType["Purchasing"] = "Purchasing";
		CalendarType["Renovation"] = "Renovation";
		CalendarType["Renting"] = "Renting";
		CalendarType["Selling"] = "Selling";
		CalendarType["PropertyManagement"] = "PropertyManagement";
		CalendarType["RentableUnit"] = "RentableUnit";
		return CalendarType;
	}({});
	CalendarStagesUnsorted = /* @__PURE__ */ function(CalendarStagesUnsorted) {
		CalendarStagesUnsorted["Notarization"] = "Notarization";
		CalendarStagesUnsorted["Handover"] = "Handover";
		CalendarStagesUnsorted["Pictures"] = "Pictures";
		CalendarStagesUnsorted["Measurements"] = "Measurements";
		CalendarStagesUnsorted["Inspection"] = "Inspection";
		CalendarStagesUnsorted["RenovationStart"] = "RenovationStart";
		CalendarStagesUnsorted["KickOff"] = "KickOff";
		CalendarStagesUnsorted["BasicInstallationCheck"] = "BasicInstallationCheck";
		CalendarStagesUnsorted["SealingCheck"] = "SealingCheck";
		CalendarStagesUnsorted["GroundLevelingCheck"] = "GroundLevelingCheck";
		CalendarStagesUnsorted["EBKDelivery"] = "EBKDelivery";
		CalendarStagesUnsorted["EBKAssembly"] = "EBKAssembly";
		CalendarStagesUnsorted["PreliminaryAcceptance"] = "PreliminaryAcceptance";
		CalendarStagesUnsorted["Acceptance"] = "Acceptance";
		CalendarStagesUnsorted["FinalAcceptance"] = "FinalAcceptance";
		CalendarStagesUnsorted["ProjectMonitoring"] = "ProjectMonitoring";
		CalendarStagesUnsorted["ContractSign"] = "ContractSign";
		CalendarStagesUnsorted["SalesPartnerInspection"] = "SalesPartnerInspection";
		CalendarStagesUnsorted["RenovationAcceptanceAndWarranty"] = "RenovationAcceptanceAndWarranty";
		CalendarStagesUnsorted["PaymentDue"] = "PaymentDue";
		CalendarStagesUnsorted["HKVInstallation"] = "HKVInstallation";
		CalendarStagesUnsorted["RWMInstallation"] = "RWMInstallation";
		CalendarStagesUnsorted["HKVAndRWMInstallation"] = "HKVAndRWMInstallation";
		CalendarStagesUnsorted["RWMMaintenance"] = "RWMMaintenance";
		CalendarStagesUnsorted["HKVReading"] = "HKVReading";
		CalendarStagesUnsorted["ApartmentTour"] = "ApartmentTour";
		CalendarStagesUnsorted["HandoverNewTenant"] = "HandoverNewTenant";
		CalendarStagesUnsorted["PreAcceptance"] = "PreAcceptance";
		CalendarStagesUnsorted["HandoverFormerTenant"] = "HandoverFormerTenant";
		return CalendarStagesUnsorted;
	}({});
	CalendarStages = {
		["Sourcing"]: ["Inspection"],
		["Purchasing"]: [
			"Notarization",
			"Handover",
			"Pictures",
			"PaymentDue"
		],
		["Renovation"]: [
			"Measurements",
			"Inspection",
			"RenovationStart",
			"KickOff",
			"BasicInstallationCheck",
			"SealingCheck",
			"GroundLevelingCheck",
			"EBKDelivery",
			"EBKAssembly",
			"PreliminaryAcceptance",
			"Acceptance",
			"FinalAcceptance",
			"ProjectMonitoring"
		],
		["Renting"]: [
			"Pictures",
			"ApartmentTour",
			"ContractSign",
			"HandoverNewTenant",
			"PreAcceptance",
			"HandoverFormerTenant"
		],
		["Selling"]: [
			"Inspection",
			"Notarization",
			"Handover",
			"SalesPartnerInspection",
			"RenovationAcceptanceAndWarranty",
			"PaymentDue"
		],
		["PropertyManagement"]: [
			"HKVInstallation",
			"RWMInstallation",
			"HKVAndRWMInstallation",
			"RWMMaintenance",
			"HKVReading"
		]
	};
	CalendarResponseStatus = /* @__PURE__ */ function(CalendarResponseStatus) {
		CalendarResponseStatus["NeedsAction"] = "needsAction";
		CalendarResponseStatus["Declined"] = "declined";
		CalendarResponseStatus["Tentative"] = "tentative";
		CalendarResponseStatus["Accepted"] = "accepted";
		return CalendarResponseStatus;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/processes/purchasing.class.ts
var PurchasingProcess;
var init_purchasing_class = __esmMin((() => {
	init_process_base();
	PurchasingProcess = class PurchasingProcess extends CondoProcess {
		attributes;
		purchasingEntityId;
		purchasingEntity;
		portfolioId;
		portfolio;
		profit;
		totalCosts;
		totalFinancingCosts;
		purchasingPrice;
		handoverDate;
		paidAt;
		totalPurchasingPrice;
		constructor(props) {
			super(props);
			Object.assign(this, props);
			this.profit = this.investment?.listedPriceNoOperationReturn;
			this.totalCosts = (this.investment?.purchasingPrice ?? 0) + (this.investment?.renovationCosts ?? 0) + (this.investment?.auxiliaryCosts ?? 0);
			this.totalFinancingCosts = this.totalCosts + (this.investment?.financingCosts ?? 0);
			this.purchasingPrice = (this.investment?.purchasingPrice ?? 0) + (this.investment?.parkingSpacePurchasePrice ?? 0);
			this.totalPurchasingPrice = this.investment ? (this.investment.purchasingPrice || 0) + (this.investment.parkingSpacePurchasePrice || 0) : void 0;
			const [event] = this.events?.filter((event) => event.stage === "Handover") || [];
			if (event?.start) this.handoverDate = new Date(event?.start);
		}
		static createFromEstate(estate) {
			if (!estate.purchasing) throw new Error("Need to have purchasing-properties on estate to create PurchasingProcess");
			return new PurchasingProcess({
				...estate.purchasing,
				events: estate.calendarEvents,
				investment: estate.executedInvestmentCase
			});
		}
		get condoUuid() {
			return this.estate?.condoUuid || "No Uuid";
		}
		get purchasingEntityName() {
			return this.purchasingEntity?.shortName;
		}
		get hasPortfolio() {
			return Boolean(this.portfolioId) || Boolean(this.attributes?.financingPortfolio);
		}
		get expectedSalesPrice() {
			return this.investment?.expectedSalesPrice;
		}
		getEquity(juniorDebtRatio) {
			return this.totalFinancingCosts * juniorDebtRatio;
		}
	};
}));
//#endregion
//#region src/domains/cross-cutting/user.model.ts
var UserRoles, CompanyDepartment, CompanyFunction, departmentCompanyFunctions, companyFunctionDepartment, UserRelationRoles;
var init_user_model = __esmMin((() => {
	UserRoles = /* @__PURE__ */ function(UserRoles) {
		UserRoles["INVOICE_SUPERVISOR"] = "invoice-supervisor";
		UserRoles["INVOICE_ASSIGNMENT"] = "invoice-assignment";
		return UserRoles;
	}({});
	CompanyDepartment = /* @__PURE__ */ function(CompanyDepartment) {
		CompanyDepartment["CLevel"] = "CLevel";
		CompanyDepartment["Construction"] = "Construction";
		CompanyDepartment["Engineering"] = "Engineering";
		CompanyDepartment["Finance"] = "Finance";
		CompanyDepartment["AssetManagement"] = "AssetManagement";
		CompanyDepartment["InvestmentManagement"] = "InvestmentManagement";
		CompanyDepartment["PropertyManagement"] = "PropertyManagement";
		CompanyDepartment["RenovationManagement"] = "RenovationManagement";
		CompanyDepartment["TransactionManagement"] = "TransactionManagement";
		return CompanyDepartment;
	}({});
	CompanyFunction = /* @__PURE__ */ function(CompanyFunction) {
		CompanyFunction["Admin"] = "Admin";
		CompanyFunction["BusinessDevelopment"] = "BusinessDevelopment";
		CompanyFunction["HR"] = "HR";
		CompanyFunction["CTO"] = "CTO";
		CompanyFunction["PM"] = "PM";
		CompanyFunction["SoftwareEngineer"] = "SoftwareEngineer";
		CompanyFunction["DataScientist"] = "DataScientist";
		CompanyFunction["CDO"] = "CDO";
		CompanyFunction["TechnicalProjectLead"] = "TechnicalProjectLead";
		CompanyFunction["ProjectLeadConstruction"] = "ProjectLeadConstruction";
		CompanyFunction["TLRenovation"] = "TLRenovation";
		CompanyFunction["PLRenovation"] = "PLRenovation";
		CompanyFunction["RenovationPlanner"] = "RenovationPlanner";
		CompanyFunction["Architect"] = "Architect";
		CompanyFunction["CFO"] = "CFO";
		CompanyFunction["FinanceManager"] = "FinanceManager";
		CompanyFunction["Accountant"] = "Accountant";
		CompanyFunction["COO"] = "COO";
		CompanyFunction["HOTGermany"] = "HOTGermany";
		CompanyFunction["HOTCity"] = "HOTCity";
		CompanyFunction["TransactionManager"] = "TransactionManager";
		CompanyFunction["TransactionBackoffice"] = "TransactionBackoffice";
		CompanyFunction["RentingManager"] = "RentingManager";
		CompanyFunction["PropertyManager"] = "PropertyManager";
		CompanyFunction["DealCaptain"] = "DealCaptain";
		CompanyFunction["InvestmentManager"] = "InvestmentManager";
		CompanyFunction["AssetManager"] = "AssetManager";
		CompanyFunction["AssetManagementBackoffice"] = "AssetManagementBackoffice";
		CompanyFunction["ManagingDirector"] = "ManagingDirector";
		CompanyFunction["EnergyEfficiencyConsultant"] = "EnergyEfficiencyConsultant";
		return CompanyFunction;
	}({});
	departmentCompanyFunctions = {
		["CLevel"]: [
			"COO",
			"CTO",
			"CFO",
			"COO"
		],
		["Engineering"]: [
			"SoftwareEngineer",
			"DataScientist",
			"PM"
		],
		["Finance"]: ["FinanceManager", "Accountant"],
		["AssetManagement"]: ["AssetManager", "AssetManagementBackoffice"],
		["InvestmentManagement"]: ["DealCaptain", "InvestmentManager"],
		["PropertyManagement"]: ["PropertyManager", "RentingManager"],
		["Construction"]: [
			"Architect",
			"TechnicalProjectLead",
			"ProjectLeadConstruction"
		],
		["RenovationManagement"]: [
			"TLRenovation",
			"PLRenovation",
			"RenovationPlanner"
		],
		["TransactionManagement"]: [
			"TransactionManager",
			"TransactionBackoffice",
			"HOTCity",
			"HOTGermany"
		]
	};
	companyFunctionDepartment = Object.fromEntries(Object.entries(departmentCompanyFunctions).flatMap(([department, functions]) => functions.map((fn) => [fn, department])));
	UserRelationRoles = /* @__PURE__ */ function(UserRelationRoles) {
		UserRelationRoles["TransactionManager"] = "TransactionManager";
		UserRelationRoles["RenovationSupervisor"] = "RenovationSupervisor";
		UserRelationRoles["Architect"] = "Architect";
		UserRelationRoles["GeneralConstructor"] = "GeneralConstructor";
		UserRelationRoles["RealEstateAgent"] = "RealEstateAgent";
		return UserRelationRoles;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/processes/renovation.model.ts
var RenovationOnHoldReason, OvershootPermissions;
var init_renovation_model = __esmMin((() => {
	init_user_model();
	RenovationOnHoldReason = /* @__PURE__ */ function(RenovationOnHoldReason) {
		RenovationOnHoldReason["Materiallieferung"] = "Materiallieferung";
		RenovationOnHoldReason["Asbest"] = "Asbest";
		RenovationOnHoldReason["Verwaltungsthemen"] = "Verwaltungsthemen";
		RenovationOnHoldReason["Wasserschaden"] = "Wasserschaden";
		RenovationOnHoldReason["Other"] = "Other";
		return RenovationOnHoldReason;
	}({});
	OvershootPermissions = [{
		from: .01,
		to: Number.POSITIVE_INFINITY,
		companyFunctions: ["Admin", "BusinessDevelopment"]
	}];
}));
//#endregion
//#region src/domains/cross-cutting/processes/renting.ts
var RentingProcess;
var init_renting$1 = __esmMin((() => {
	init_renting_model();
	init_process_base();
	RentingProcess = class extends CondoProcess {
		attributes;
		sellingInvestmentCase;
		rentingPartner;
		rentingPartnerMandated;
		rentingPartnerContactId;
		handoverDate;
		constructor(props) {
			super({
				...props,
				processType: "Renting"
			});
			Object.assign(this, props);
			const handoverEvent = this.events?.find((event) => event.calendarType === "Renting" && event.stage === "Handover");
			if (handoverEvent?.start) this.handoverDate = new Date(handoverEvent?.start);
		}
		get condoUuid() {
			return this.estate?.condoUuid || "No Uuid";
		}
		get listingDate() {
			return this.attributes?.listingDate;
		}
		static latestActiveProcess(rentingProcesses) {
			if (!rentingProcesses?.length) return void 0;
			return rentingProcesses.toSorted((a, b) => RentingStatesOrder.indexOf(b.processState.state) - RentingStatesOrder.indexOf(a.processState.state))[0];
		}
	};
}));
//#endregion
//#region src/domains/cross-cutting/processes/selling.ts
var SellingProcess;
var init_selling = __esmMin((() => {
	init_process_base();
	SellingProcess = class SellingProcess extends CondoProcess {
		attributes = { photoProcessStatus: false };
		sellingInvestmentCase;
		handoverDate;
		notarizationDate;
		paidAt;
		sellingPartnerId;
		sellingPartner;
		constructor(props) {
			super({
				...props,
				processType: "Selling"
			});
			Object.assign(this, props);
		}
		static createFromEstate(estate) {
			if (!estate.selling) throw new Error("Need to have selling-properties on estate to create SellingProcess");
			return new SellingProcess({
				...estate.selling,
				events: estate.calendarEvents
			});
		}
		get condoUuid() {
			return this.estate?.condoUuid || "No Uuid";
		}
		get hasNotaryDate() {
			return Boolean(this.notarizationDate);
		}
		get hasHandoverDate() {
			return Boolean(this.handoverDate);
		}
	};
}));
//#endregion
//#region src/domains/cross-cutting/processes/process.request.ts
var init_process_request = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/processes/index.ts
var init_processes = __esmMin((() => {
	init_property_management_model();
	init_estate_meter_opts();
	init_estate_meter_model();
	init_process_base();
	init_process_model();
	init_purchasing_class();
	init_renovation_model();
	init_renting$1();
	init_selling();
	init_tenant_management_model();
	init_owner_management_model();
	init_estate_management_model();
	init_rentable_unit_model$1();
	init_process_request();
}));
//#endregion
//#region src/domains/cross-cutting/estates/estate.base.ts
var Condition, PredictionType, EstateCategory, EstateChannelName, EstateChannelType, EstateSource, EstateType, ListingType, ApartmentType, InteriorQuality, ExecutedInteriorQualities, ApartmentSize, determineApartmentSize, AlignmentBalcony, Flooring, ParkingSpaceCategory, ParkingSpaceType, FreeFromCategory, FloorLocation, StoreRoomType, CommonRoomType, EstateLeadType, BuildingLocationType, BuildingLocationTypeDescription;
var init_estate_base = __esmMin((() => {
	Condition = /* @__PURE__ */ function(Condition) {
		Condition["FirstTimeUseAfterRefurbishment"] = "FirstTimeUseAfterRefurbishment";
		Condition["NoInformation"] = "NoInformation";
		Condition["FirstTimeUse"] = "FirstTimeUse";
		Condition["WellKept"] = "WellKept";
		Condition["Modernized"] = "Modernized";
		Condition["MintCondition"] = "MintCondition";
		Condition["FullyRenovated"] = "FullyRenovated";
		Condition["Refurbished"] = "Refurbished";
		Condition["NeedOfRenovation"] = "NeedOfRenovation";
		Condition["Negotiable"] = "Negotiable";
		Condition["RipeForDemolition"] = "RipeForDemolition";
		return Condition;
	}({});
	PredictionType = /* @__PURE__ */ function(PredictionType) {
		PredictionType["RentPrice"] = "RentPrice";
		PredictionType["SalePrice"] = "SalePrice";
		PredictionType["ParkingSpaceRentPrice"] = "ParkingSpaceRentPrice";
		PredictionType["ParkingSpaceSalePrice"] = "ParkingSpaceSalePrice";
		return PredictionType;
	}({});
	EstateCategory = /* @__PURE__ */ function(EstateCategory) {
		EstateCategory["LongStanding"] = "LongStanding";
		EstateCategory["NewLead"] = "NewLead";
		EstateCategory["PrivateDropOut"] = "PrivateDropOut";
		EstateCategory["RealtorSearch"] = "RealtorSearch";
		EstateCategory["PublicMarketplace"] = "PublicMarketplace";
		EstateCategory["InstantOffer"] = "InstantOffer";
		return EstateCategory;
	}({});
	EstateChannelName = /* @__PURE__ */ function(EstateChannelName) {
		EstateChannelName["IMMO24"] = "IMMO24";
		EstateChannelName["GEOMAP"] = "GEOMAP";
		EstateChannelName["PRICEHUBBLE"] = "PRICEHUBBLE";
		EstateChannelName["TRANSACTION_TEAM"] = "TRANSACTION_TEAM";
		EstateChannelName["GPT"] = "GPT";
		EstateChannelName["SAAS"] = "SAAS";
		return EstateChannelName;
	}({});
	EstateChannelType = /* @__PURE__ */ function(EstateChannelType) {
		EstateChannelType["AGENT"] = "AGENT";
		EstateChannelType["DIRECT"] = "DIRECT";
		EstateChannelType["PLATFORM"] = "PLATFORM";
		return EstateChannelType;
	}({});
	EstateSource = /* @__PURE__ */ function(EstateSource) {
		/** @deprecated */
		EstateSource["PAPI"] = "PAPI";
		EstateSource["COCKPIT"] = "COCKPIT";
		EstateSource["DISCOVERER"] = "DISCOVERER";
		EstateSource["IMPORT"] = "IMPORT";
		EstateSource["EXTERNAL"] = "EXTERNAL";
		return EstateSource;
	}({});
	EstateType = /* @__PURE__ */ function(EstateType) {
		EstateType["Apartment"] = "Apartment";
		EstateType["House"] = "House";
		EstateType["Office"] = "Office";
		return EstateType;
	}({});
	ListingType = /* @__PURE__ */ function(ListingType) {
		ListingType["Rent"] = "Rent";
		ListingType["Buy"] = "Buy";
		return ListingType;
	}({});
	ApartmentType = /* @__PURE__ */ function(ApartmentType) {
		ApartmentType["Apartment"] = "Apartment";
		ApartmentType["HalfBasement"] = "HalfBasement";
		ApartmentType["NoInformation"] = "NoInformation";
		ApartmentType["GroundFloor"] = "GroundFloor";
		ApartmentType["Maisonette"] = "Maisonette";
		ApartmentType["Penthouse"] = "Penthouse";
		ApartmentType["TerracedFlat"] = "TerracedFlat";
		ApartmentType["RoofStorey"] = "RoofStorey";
		ApartmentType["RaisedGroundFloor"] = "RaisedGroundFloor";
		ApartmentType["Loft"] = "Loft";
		ApartmentType["Farm"] = "Farm";
		ApartmentType["TwoFamilyHouse"] = "TwoFamilyHouse";
		ApartmentType["ApartmentBuilding"] = "ApartmentBuilding";
		ApartmentType["OtherHouse"] = "OtherHouse";
		ApartmentType["TerracedHouse"] = "TerracedHouse";
		ApartmentType["Commercial"] = "Commercial";
		ApartmentType["Residential"] = "Residential";
		ApartmentType["Office"] = "Office";
		ApartmentType["Gastronomy"] = "Gastronomy";
		ApartmentType["Parking"] = "Parking";
		ApartmentType["Other"] = "Other";
		ApartmentType["CommercialOther"] = "CommercialOther";
		ApartmentType["Shop"] = "Shop";
		ApartmentType["Cellar"] = "Cellar";
		ApartmentType["UndergroundParking"] = "UndergroundParking";
		ApartmentType["OutdoorParking"] = "OutdoorParking";
		ApartmentType["Garage"] = "Garage";
		return ApartmentType;
	}({});
	InteriorQuality = /* @__PURE__ */ function(InteriorQuality) {
		InteriorQuality["NoInformation"] = "NoInformation";
		InteriorQuality["NA"] = "NA";
		InteriorQuality["Simple"] = "Simple";
		InteriorQuality["Normal"] = "Normal";
		InteriorQuality["Sophisticated"] = "Sophisticated";
		InteriorQuality["Luxury"] = "Luxury";
		return InteriorQuality;
	}({});
	ExecutedInteriorQualities = [
		"Simple",
		"Normal",
		"Sophisticated",
		"Luxury"
	];
	ApartmentSize = /* @__PURE__ */ function(ApartmentSize) {
		ApartmentSize["S"] = "S";
		ApartmentSize["M"] = "M";
		ApartmentSize["L"] = "L";
		ApartmentSize["XL"] = "XL";
		return ApartmentSize;
	}({});
	determineApartmentSize = (apartmentSizes, livingSpace) => {
		if (!(apartmentSizes?.S && apartmentSizes?.M && apartmentSizes?.L)) return;
		if (livingSpace <= apartmentSizes.S) return "S";
		if (livingSpace > apartmentSizes.S && livingSpace <= apartmentSizes.M) return "M";
		if (livingSpace > apartmentSizes.M && livingSpace <= apartmentSizes.L) return "L";
		return "XL";
	};
	AlignmentBalcony = /* @__PURE__ */ function(AlignmentBalcony) {
		AlignmentBalcony["North"] = "North";
		AlignmentBalcony["East"] = "East";
		AlignmentBalcony["West"] = "West";
		AlignmentBalcony["South"] = "South";
		AlignmentBalcony["NorthEast"] = "NorthEast";
		AlignmentBalcony["NorthWest"] = "NorthWest";
		AlignmentBalcony["SouthEast"] = "SouthEast";
		AlignmentBalcony["SouthWest"] = "SouthWest";
		return AlignmentBalcony;
	}({});
	Flooring = /* @__PURE__ */ function(Flooring) {
		Flooring["Titles"] = "Titles";
		Flooring["Stone"] = "Stone";
		Flooring["Parquet"] = "Parquet";
		Flooring["Laminate"] = "Laminate";
		Flooring["Bath"] = "Bath";
		Flooring["Plastic"] = "Plastic";
		Flooring["DoubleBottom"] = "DoubleBottom";
		Flooring["Linoleum"] = "Linoleum";
		Flooring["Marble"] = "Marble";
		Flooring["Terrakotta"] = "Terrakotta";
		Flooring["Granit"] = "Granit";
		return Flooring;
	}({});
	ParkingSpaceCategory = /* @__PURE__ */ function(ParkingSpaceCategory) {
		ParkingSpaceCategory["NoInformation"] = "NoInformation";
		ParkingSpaceCategory["NA"] = "NA";
		ParkingSpaceCategory["Public"] = "Public";
		ParkingSpaceCategory["PublicPaid"] = "PublicPaid";
		ParkingSpaceCategory["PrivatePaid"] = "PrivatePaid";
		ParkingSpaceCategory["PaidUnknown"] = "PaidUnknown";
		return ParkingSpaceCategory;
	}({});
	ParkingSpaceType = /* @__PURE__ */ function(ParkingSpaceType) {
		ParkingSpaceType["UndergroundGarage"] = "UndergroundGarage";
		ParkingSpaceType["Garage"] = "Garage";
		ParkingSpaceType["NoInformation"] = "NoInformation";
		ParkingSpaceType["StreetParking"] = "StreetParking";
		ParkingSpaceType["CarPark"] = "CarPark";
		ParkingSpaceType["NA"] = "NA";
		ParkingSpaceType["Carport"] = "Carport";
		ParkingSpaceType["Duplex"] = "Duplex";
		ParkingSpaceType["Outside"] = "Outside";
		return ParkingSpaceType;
	}({});
	FreeFromCategory = /* @__PURE__ */ function(FreeFromCategory) {
		FreeFromCategory["ASAP"] = "ASAP";
		FreeFromCategory["Less Then A Three Months"] = "1<X<3";
		FreeFromCategory["Up To Six Months"] = "3<X<6";
		FreeFromCategory["More Then Half A Yeaer"] = "X>6";
		FreeFromCategory["By Agreement"] = "ByAgreement";
		return FreeFromCategory;
	}({});
	FloorLocation = /* @__PURE__ */ function(FloorLocation) {
		FloorLocation["R"] = "R";
		FloorLocation["MR"] = "MR";
		FloorLocation["M"] = "M";
		FloorLocation["ML"] = "ML";
		FloorLocation["L"] = "L";
		FloorLocation["TG"] = "TG";
		FloorLocation["Garage"] = "Garage";
		FloorLocation["OpenAir"] = "OpenAir";
		FloorLocation["HP"] = "HP";
		return FloorLocation;
	}({});
	StoreRoomType = /* @__PURE__ */ function(StoreRoomType) {
		StoreRoomType["Basement"] = "Basement";
		StoreRoomType["Attic"] = "Attic";
		StoreRoomType["InsideApartment"] = "InsideApartment";
		return StoreRoomType;
	}({});
	CommonRoomType = /* @__PURE__ */ function(CommonRoomType) {
		CommonRoomType["BikeRoom"] = "BikeRoom";
		CommonRoomType["LaundryRoom"] = "LaundryRoom";
		CommonRoomType["DryingRoom"] = "DryingRoom";
		return CommonRoomType;
	}({});
	EstateLeadType = /* @__PURE__ */ function(EstateLeadType) {
		EstateLeadType["Basic"] = "Basic";
		EstateLeadType["Full"] = "Full";
		return EstateLeadType;
	}({});
	BuildingLocationType = /* @__PURE__ */ function(BuildingLocationType) {
		BuildingLocationType["SF"] = "SF";
		BuildingLocationType["SF_R"] = "SF_R";
		BuildingLocationType["SF_L"] = "SF_L";
		BuildingLocationType["HG"] = "HG";
		BuildingLocationType["VH"] = "VH";
		BuildingLocationType["HH"] = "HH";
		BuildingLocationType["QG"] = "QG";
		return BuildingLocationType;
	}({});
	BuildingLocationTypeDescription = {
		["SF"]: "Seitenflügel",
		["SF_R"]: "Seitenflügel rechts",
		["SF_L"]: "Seitenflügel links",
		["HG"]: "Hauptgebäude",
		["VH"]: "Vorderhaus",
		["HH"]: "Hinterhaus",
		["QG"]: "Quergebäude"
	};
}));
//#endregion
//#region src/domains/renting/rentable-unit/rentable-unit.model.ts
var RentableUnitType, RentableUnitAvailabilityStatus;
var init_rentable_unit_model = __esmMin((() => {
	RentableUnitType = /* @__PURE__ */ function(RentableUnitType) {
		RentableUnitType["Estate"] = "Estate";
		RentableUnitType["Room"] = "Room";
		RentableUnitType["Parking"] = "Parking";
		return RentableUnitType;
	}({});
	RentableUnitAvailabilityStatus = /* @__PURE__ */ function(RentableUnitAvailabilityStatus) {
		RentableUnitAvailabilityStatus["Available"] = "Available";
		RentableUnitAvailabilityStatus["Occupied"] = "Occupied";
		RentableUnitAvailabilityStatus["All"] = "All";
		return RentableUnitAvailabilityStatus;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/estates/estate.helpers.ts
var inferStateFromEstate, generateEstateFolderName, generateCondoUUID, isMFH, isCondominium, condoUUIDCompressor, calculateEstateRentingState;
var init_estate_helpers = __esmMin((() => {
	init_errors();
	init_processes();
	inferStateFromEstate = (estate) => {
		if (estate.location?.state) return estate.location.state;
		throw new Error("Estate location does not have any property to extract the state");
	};
	generateEstateFolderName = (estate) => `${estate.condoUuid ?? estate.estateId} (${estate.location?.street ?? ""} ${estate.location?.houseNumber ?? ""})`;
	generateCondoUUID = (estate, nextEstateSeqNumber, uuidReference) => {
		if (!estate.location) throw new InvariantError("Need to have location associated to a given estate");
		const regionShort = estate.location.region?.shortName;
		const estateYear = new Date(estate.purchasing?.createdAt ?? /* @__PURE__ */ new Date()).getFullYear().toString().substr(-2);
		const street = unidecode(estate?.location?.street || "XXX").replace(/( )/g, "")?.substring(0, 3).toUpperCase();
		const houseNumber = estate?.location?.houseNumber?.replace(/( )/g, "").toUpperCase() || "00";
		const isSaasEstate = estate.channelName === "SAAS";
		return `${regionShort}${estateYear}_${street}${houseNumber}${isSaasEstate ? `_${estate.channelName.toUpperCase()}` : ""}${uuidReference ? `_${uuidReference.toUpperCase()}` : ""}${estate.propertyManagementOnly ? `_PM` : ""}${!isSaasEstate ? `_${nextEstateSeqNumber}` : ""}`;
	};
	isMFH = (estate) => {
		const apartmentType = estate?.attributes?.apartmentType ?? estate.apartmentType;
		return estate.estateType === "House" && apartmentType === "ApartmentBuilding";
	};
	isCondominium = (estate) => {
		return estate.estateType === "Apartment";
	};
	condoUUIDCompressor = {
		compress(data) {
			return compressResponse(data, (r) => {
				const addressPart = addressFormatter(r.location);
				const floorPart = formatFloor(r.attributes);
				const apartmentPart = r.attributes?.apartmentNumber ? ` [Wg: ${r.attributes.apartmentNumber}]` : "";
				const labelExtended = [addressPart, floorPart].filter(Boolean).join(", ") + apartmentPart;
				return [
					r.estateId,
					r.condoUuid ?? EMPTY_VAL,
					addressPart.length ? addressPart.toUpperCase() : EMPTY_VAL,
					labelExtended.length ? labelExtended : EMPTY_VAL,
					r.salesPackage ? [r.salesPackage.title ?? r.salesPackage.salesPackageUuid ?? r.salesPackage.salesPackageId, r.salesPackageUnitNumber].join(": #") : EMPTY_VAL,
					r.selling?.processState.state ?? EMPTY_VAL
				];
			});
		},
		decompress(data) {
			return decompressResponse(data, (d) => {
				const [estateId, condoUuid, searchStack, labelExtended, labelSp, selling] = d;
				return {
					estateId: Number(estateId),
					condoUuid: condoUuid === EMPTY_VAL ? "" : condoUuid,
					searchStack: searchStack === EMPTY_VAL ? "" : searchStack,
					labelExtended: labelExtended === EMPTY_VAL ? "" : labelExtended,
					labelSp: labelSp === EMPTY_VAL ? "" : labelSp,
					selling: selling === EMPTY_VAL ? void 0 : selling
				};
			});
		}
	};
	calculateEstateRentingState = (estate) => {
		const estateUnitsRUPs = estate?.rentableUnits?.filter((unit) => unit.type === "Estate").map((unit) => unit.rentableUnitProcess).filter(Boolean) ?? [];
		if (estateUnitsRUPs.length === 0) return estate?.rentableUnitProcess?.processState?.state ?? void 0;
		const vacantStateUnits = estateUnitsRUPs.filter((process) => process?.processState.state === "Vacant");
		const blockedStateUnits = estateUnitsRUPs.filter((process) => RentableUnitPausedStates.includes(process?.processState.state));
		const finalStateUnits = estateUnitsRUPs.filter((process) => RentableUnitAllRentedOrNoRentingNeeded.includes(process?.processState.state));
		if (vacantStateUnits.length === estateUnitsRUPs.length) return "Vacant";
		if (finalStateUnits.length === estateUnitsRUPs.length) return finalStateUnits.some((process) => process.processState.state === "OwnerOccupied") ? "OwnerOccupied" : "Occupied";
		if (blockedStateUnits.length === estateUnitsRUPs.length) return blockedStateUnits.some((process) => process.processState.state === "BlockedByPm") ? "BlockedByPm" : "BlockedByRenovation";
		return "PartiallyOccupied";
	};
}));
//#endregion
//#region src/domains/cross-cutting/document/document.model.ts
var DocumentCategory, DocumentSource, DocumentType, documentCategoryMap, purchasingRequiredDocuments, pmDocumentsColumnFields, sellingDocumentsColumnFields, DocumentUploadStatus, DocumentTypesAvailableForDocumentGenerationByPreview, GeneratedDocumentTypesMapping, NonDownloadableDocument, DocumentPDFTemplates, DocumentXLSTemplates, DocumentsForPreparedRenovationState, DocumentsOfMfhEstateForPreparedRenovationState, TenantPortalDocuments, InvestorPortalDocuments, DefaultInvestorDocuments, DocumentsOwnerPropertyManagement, DocumentCategoriesMfh, DocumentCategoriesEstate, DocumentTypeRentArrearRelated, CustomizedExposeExcludableDocumentTypes, additionalDocumentTypesWhenFiltered;
var init_document_model = __esmMin((() => {
	DocumentCategory = /* @__PURE__ */ function(DocumentCategory) {
		DocumentCategory["General"] = "General";
		DocumentCategory["Sourcing"] = "Sourcing";
		DocumentCategory["Purchasing"] = "Purchasing";
		DocumentCategory["Renovation"] = "Renovation";
		DocumentCategory["Marketing"] = "Marketing";
		DocumentCategory["PortfolioManagement"] = "PortfolioManagement";
		DocumentCategory["PropertyManagement"] = "PropertyManagement";
		DocumentCategory["Accounting"] = "Accounting";
		DocumentCategory["PostRenovation"] = "PostRenovation";
		DocumentCategory["Renting"] = "Renting";
		DocumentCategory["Selling"] = "Selling";
		DocumentCategory["Orientation"] = "Orientation";
		DocumentCategory["Livings"] = "Livings";
		DocumentCategory["SalesPackage"] = "SalesPackage";
		DocumentCategory["SellingRegion"] = "SellingRegion";
		/** MFH https://condo-group.atlassian.net/browse/KO-5559 */
		DocumentCategory["Land"] = "Land";
		DocumentCategory["Building"] = "Building";
		DocumentCategory["RentalContract"] = "RentalContract";
		DocumentCategory["ObjectManagement"] = "ObjectManagement";
		DocumentCategory["PurchasingContract"] = "PurchasingContract";
		DocumentCategory["DueDiligence"] = "DueDiligence";
		DocumentCategory["MfhOther"] = "MfhOther";
		DocumentCategory["Taxes"] = "Taxes";
		DocumentCategory["GeneralCompany"] = "GeneralCompany";
		DocumentCategory["ShareholderAndStatutes"] = "ShareholderAndStatutes";
		DocumentCategory["CompanyContracts"] = "CompanyContracts";
		DocumentCategory["Financing"] = "Financing";
		DocumentCategory["KYC"] = "KYC";
		return DocumentCategory;
	}({});
	DocumentSource = /* @__PURE__ */ function(DocumentSource) {
		DocumentSource["Email"] = "Email";
		DocumentSource["DocumentGenerator"] = "DocumentGenerator";
		return DocumentSource;
	}({});
	DocumentType = /* @__PURE__ */ function(DocumentType) {
		DocumentType["EbicsAuthorizationLetter"] = "EbicsAuthorizationLetter";
		DocumentType["PaymentOrder"] = "PaymentOrder";
		DocumentType["LoanOfferTermSheet"] = "LoanOfferTermSheet";
		DocumentType["LoanContract"] = "LoanContract";
		DocumentType["PortfolioInvestmentPlan"] = "PortfolioInvestmentPlan";
		DocumentType["PurchasingDrawdownRequest"] = "PurchasingDrawdownRequest";
		DocumentType["InvoicesDrawdownRequest"] = "InvoicesDrawdownRequest";
		DocumentType["RenovationAcceptanceReport"] = "RenovationAcceptanceReport";
		DocumentType["ConstructionSiteReport"] = "ConstructionSiteReport";
		DocumentType["GeneratedInvoiceSubscriptionInvoice"] = "GeneratedInvoiceSubscriptionInvoice";
		DocumentType["InvoiceApprovalSlip"] = "InvoiceApprovalSlip";
		DocumentType["InvoiceInXML"] = "InvoiceInXML";
		DocumentType["InvoiceInPDF"] = "InvoiceInPDF";
		DocumentType["InvoiceOutPDF"] = "InvoiceOutPDF";
		/** @deprecated use InvoiceInPDF instead */
		DocumentType["Invoice"] = "Invoice";
		DocumentType["SubscriptionContract"] = "SubscriptionContract";
		DocumentType["ProtocolArchived"] = "ProtocolArchived";
		DocumentType["Protocol2024"] = "Protocol2024";
		DocumentType["Protocol2025"] = "Protocol2025";
		DocumentType["Protocol2026"] = "Protocol2026";
		DocumentType["ArchiveOfResolutions"] = "ArchiveOfResolutions";
		DocumentType["InvitationETV"] = "InvitationETV";
		DocumentType["AnnualStatement"] = "AnnualStatement";
		DocumentType["EconomicPlan"] = "EconomicPlan";
		DocumentType["HomeOwnerFeeStatement"] = "HomeOwnerFeeStatement";
		DocumentType["BuildingInsurance"] = "BuildingInsurance";
		DocumentType["EnergyCertificate"] = "EnergyCertificate";
		DocumentType["PropertyTaxNotice"] = "PropertyTaxNotice";
		DocumentType["ConstructionBurdenStatement"] = "ConstructionBurdenStatement";
		DocumentType["AbstractOfTitle"] = "AbstractOfTitle";
		DocumentType["DeclarationOfCondominium"] = "DeclarationOfCondominium";
		DocumentType["AmendmentToDeclarationOfDivision"] = "AmendmentToDeclarationOfDivision";
		DocumentType["AllowanceOfEntrySectionII"] = "AllowanceOfEntrySectionII";
		DocumentType["SeparationDeclaration"] = "SeparationDeclaration";
		DocumentType["PartitionPlan"] = "PartitionPlan";
		DocumentType["Floorplans"] = "Floorplans";
		DocumentType["ViewsAndSections"] = "ViewsAndSections";
		DocumentType["LivingSpaceCalculation"] = "LivingSpaceCalculation";
		DocumentType["ConstructionDescriptionBuilding"] = "ConstructionDescriptionBuilding";
		DocumentType["HouseRules"] = "HouseRules";
		DocumentType["LandRegisterMap"] = "LandRegisterMap";
		DocumentType["ManagementAgreement"] = "ManagementAgreement";
		DocumentType["SpecialAssessments"] = "SpecialAssessments";
		DocumentType["Other"] = "Other";
		DocumentType["EstateMedia"] = "EstateMedia";
		DocumentType["BuildingPermit"] = "BuildingPermit";
		DocumentType["Expose"] = "Expose";
		DocumentType["ExposeExternal"] = "ExposeExternal";
		DocumentType["ContractDraft"] = "ContractDraft";
		DocumentType["ContractNotarized"] = "ContractNotarized";
		DocumentType["LandCharge"] = "LandCharge";
		DocumentType["PaymentNotice"] = "PaymentNotice";
		DocumentType["RegistrationNotice"] = "RegistrationNotice";
		DocumentType["NotaryCorrespondence"] = "NotaryCorrespondence";
		DocumentType["AdministrationCorrespondence"] = "AdministrationCorrespondence";
		DocumentType["NotaryRegistrationReservation"] = "NotaryRegistrationReservation";
		DocumentType["SEPAMandateHomeOwnersFee"] = "SEPAMandateHomeOwnersFee";
		DocumentType["PurchasingHandoverProtocol"] = "PurchasingHandoverProtocol";
		DocumentType["ProofOfPayment"] = "ProofOfPayment";
		DocumentType["SellingExpose"] = "SellingExpose";
		DocumentType["PromotionExpose"] = "PromotionExpose";
		DocumentType["CustomizedSellingExpose"] = "CustomizedSellingExpose";
		DocumentType["SellingExposeSlip"] = "SellingExposeSlip";
		DocumentType["SellingCalculations"] = "SellingCalculations";
		DocumentType["SellingCalculationsSlip"] = "SellingCalculationsSlip";
		DocumentType["SellingContractDraft"] = "SellingContractDraft";
		DocumentType["SellingContractSummary"] = "SellingContractSummary";
		DocumentType["SellingContractNotarized"] = "SellingContractNotarized";
		DocumentType["SellingPaymentNotice"] = "SellingPaymentNotice";
		DocumentType["SellingRenovationAcceptanceProtocol"] = "SellingRenovationAcceptanceProtocol";
		DocumentType["SellingRegistrationNotice"] = "SellingRegistrationNotice";
		DocumentType["SellingNotaryCorrespondence"] = "SellingNotaryCorrespondence";
		DocumentType["SellingAdministrationCorrespondence"] = "SellingAdministrationCorrespondence";
		DocumentType["SellingDataSheet"] = "SellingDataSheet";
		DocumentType["SellingNotaryRegistrationReservation"] = "SellingNotaryRegistrationReservation";
		DocumentType["SellingHandoverProtocol"] = "SellingHandoverProtocol";
		DocumentType["SellingExpertReportWithCapEx"] = "SellingExpertReportWithCapEx";
		DocumentType["SellingExpertReport"] = "SellingExpertReport";
		DocumentType["SellingResidualValueCertificate"] = "SellingResidualValueCertificate";
		DocumentType["BuildingModernizationMeasures"] = "BuildingModernizationMeasures";
		DocumentType["SellingExposeLocation"] = "SellingExposeLocation";
		DocumentType["SellingAbstractOfTitle"] = "SellingAbstractOfTitle";
		DocumentType["NotaryCertification"] = "NotaryCertification";
		DocumentType["SellingProofOfPayment"] = "SellingProofOfPayment";
		DocumentType["LandRegisterParkingSpace"] = "LandRegisterParkingSpace";
		DocumentType["BuildingAcceptancePowerOfAttorney"] = "BuildingAcceptancePowerOfAttorney";
		DocumentType["LocationProfile"] = "LocationProfile";
		DocumentType["BuildingInformationModel"] = "BuildingInformationModel";
		DocumentType["FloorPlanSketch"] = "FloorPlanSketch";
		DocumentType["DimensionedFloorPlan"] = "DimensionedFloorPlan";
		DocumentType["DimensionedFloorPlanPlanned"] = "DimensionedFloorPlanPlanned";
		DocumentType["CadFile"] = "CadFile";
		DocumentType["CadFilePlanned"] = "CadFilePlanned";
		DocumentType["LV"] = "LV";
		DocumentType["LongLV"] = "LongLV";
		DocumentType["Kitchen"] = "Kitchen";
		DocumentType["KitchenContracted"] = "KitchenContracted";
		DocumentType["Inspection"] = "Inspection";
		DocumentType["ConstructionContract"] = "ConstructionContract";
		DocumentType["ContractorOffer"] = "ContractorOffer";
		DocumentType["RevisionDocumentation"] = "RevisionDocumentation";
		DocumentType["ReportsCalculationsAppraisals"] = "ReportsCalculationsAppraisals";
		DocumentType["ConstructionGuarantee"] = "ConstructionGuarantee";
		DocumentType["BathPlan"] = "BathPlan";
		DocumentType["StructuredLvSheet"] = "StructuredLvSheet";
		DocumentType["RenovationCostTrackingSheet"] = "RenovationCostTrackingSheet";
		DocumentType["MfhConstructionPlan"] = "MfhConstructionPlan";
		DocumentType["ConstructionDescriptionRenovation"] = "ConstructionDescriptionRenovation";
		DocumentType["PostRenovationDimensionedFloorPlan"] = "PostRenovationDimensionedFloorPlan";
		DocumentType["SalesPartnerFloorPlan"] = "SalesPartnerFloorPlan";
		DocumentType["LivingSpaceCalculations"] = "LivingSpaceCalculations";
		DocumentType["BeforeAfterPictures"] = "BeforeAfterPictures";
		DocumentType["PostRenovationAcceptanceProtocol"] = "PostRenovationAcceptanceProtocol";
		DocumentType["RoomVolumeCalculation"] = "RoomVolumeCalculation";
		DocumentType["RentContract"] = "RentContract";
		DocumentType["RentIncrease"] = "RentIncrease";
		DocumentType["AcceptanceProtocol"] = "AcceptanceProtocol";
		DocumentType["HeatingBill"] = "HeatingBill";
		DocumentType["Correspondence"] = "Correspondence";
		DocumentType["SelfAssessmentSheet"] = "SelfAssessmentSheet";
		DocumentType["ID"] = "ID";
		DocumentType["SalaryInformation"] = "SalaryInformation";
		DocumentType["SchufaReport"] = "SchufaReport";
		DocumentType["Deposit"] = "Deposit";
		DocumentType["HousingProviderConfirmation"] = "HousingProviderConfirmation";
		DocumentType["SEVContract"] = "SEVContract";
		DocumentType["SEVContractWithFee"] = "SEVContractWithFee";
		DocumentType["SEVContractWithoutFee"] = "SEVContractWithoutFee";
		DocumentType["SEVPoA"] = "SEVPoA";
		DocumentType["DkbInvestorVerification"] = "DkbInvestorVerification";
		DocumentType["SEVCoverLetter"] = "SEVCoverLetter";
		DocumentType["GDPRTenant"] = "GDPRTenant";
		DocumentType["GDPROwner"] = "GDPROwner";
		DocumentType["PersonalIDOwner"] = "PersonalIDOwner";
		DocumentType["SEPAManadateHouseGeld"] = "SEPAManadateHouseGeld";
		DocumentType["SEPATenant"] = "SEPATenant";
		DocumentType["WithdrawlInstructionTenant"] = "WithdrawlInstructionTenant";
		DocumentType["WithdrawlInstructionOwner"] = "WithdrawlInstructionOwner";
		DocumentType["TenantCorrespondence"] = "TenantCorrespondence";
		DocumentType["OwnerCorrespondence"] = "OwnerCorrespondence";
		DocumentType["UtilitiesCorrespondence"] = "UtilitiesCorrespondence";
		DocumentType["CancellationLease"] = "CancellationLease";
		DocumentType["CancellationLeaseConfirmation"] = "CancellationLeaseConfirmation";
		DocumentType["CancellationSEVContract"] = "CancellationSEVContract";
		DocumentType["CancellationSEVContractConfirmation"] = "CancellationSEVContractConfirmation";
		DocumentType["CondoTerminationAgreement"] = "CondoTerminationAgreement";
		DocumentType["LegalDisputes"] = "LegalDisputes";
		DocumentType["EstateInvestorShare"] = "EstateInvestorShare";
		DocumentType["EstateAggregatedInvestorShare"] = "EstateAggregatedInvestorShare";
		DocumentType["WEGAnnualStatement"] = "WEGAnnualStatement";
		DocumentType["InvoicesPropertyManagement"] = "InvoicesPropertyManagement";
		/** @deprecated : document generation no longer exists for this document, revert commit to bring back  */
		DocumentType["EstateRentReport"] = "EstateRentReport";
		DocumentType["CorrespondencePropertyManagement"] = "CorrespondencePropertyManagement";
		DocumentType["SalutationWEG"] = "SalutationWEG";
		DocumentType["InvestorPayout"] = "InvestorPayout";
		DocumentType["InvestorYearlyPayout"] = "InvestorYearlyPayout";
		DocumentType["InvestorYearlyPayoutLegacy"] = "InvestorYearlyPayoutLegacy";
		DocumentType["RentArrearNotice"] = "RentArrearNotice";
		DocumentType["RentGuarantee"] = "RentGuarantee";
		DocumentType["DunningNotice"] = "DunningNotice";
		DocumentType["EnforcementNotice"] = "EnforcementNotice";
		DocumentType["BKAStatement"] = "BKAStatement";
		DocumentType["BKAHeatingStatement"] = "BKAHeatingStatement";
		DocumentType["BKAAllocationCalculation"] = "BKAAllocationCalculation";
		DocumentType["BKAHouseholdCosts"] = "BKAHouseholdCosts";
		DocumentType["BKADeposit"] = "BKADeposit";
		DocumentType["SelfDeclarationTenant"] = "SelfDeclarationTenant";
		DocumentType["QuestionnaireTenant"] = "QuestionnaireTenant";
		DocumentType["RentalContractDraft"] = "RentalContractDraft";
		DocumentType["SalaryRecordPropesctiveTenant"] = "SalaryRecordPropesctiveTenant";
		DocumentType["SchufaProspectiveTenant"] = "SchufaProspectiveTenant";
		DocumentType["AnnualServiceChargeCalculation"] = "AnnualServiceChargeCalculation";
		DocumentType["PersonalIDProspectiveTenant"] = "PersonalIDProspectiveTenant";
		DocumentType["Safe"] = "Safe";
		DocumentType["Estate"] = "Estate";
		DocumentType["BasementRoom"] = "BasementRoom";
		DocumentType["AtticRoom"] = "AtticRoom";
		DocumentType["CommonRoom"] = "CommonRoom";
		DocumentType["Parking"] = "Parking";
		DocumentType["FurniturePlanPdf"] = "FurniturePlanPdf";
		DocumentType["FurniturePlanDwg"] = "FurniturePlanDwg";
		DocumentType["RequestedOrderLists"] = "RequestedOrderLists";
		DocumentType["ContractedOrderLists"] = "ContractedOrderLists";
		DocumentType["PartnerBrochure"] = "PartnerBrochure";
		DocumentType["InvoicesFittings"] = "InvoicesFittings";
		DocumentType["InvoicesServiceProvider"] = "InvoicesServiceProvider";
		DocumentType["Internet"] = "Internet";
		DocumentType["LivingsAcceptanceProtocol"] = "LivingsAcceptanceProtocol";
		DocumentType["PortfolioInspectionSheet"] = "PortfolioInspectionSheet";
		DocumentType["CreditLineCashflowPredictions"] = "CreditLineCashflowPredictions";
		DocumentType["CreditLineBudgetCosts"] = "CreditLineBudgetCosts";
		DocumentType["EstateInvestorCashflow"] = "EstateInvestorCashflow";
		DocumentType["SalesPackageFinalSheet"] = "SalesPackageFinalSheet";
		DocumentType["SalesPackageDataSheet"] = "SalesPackageDataSheet";
		DocumentType["SalesPackageNotarySheet"] = "SalesPackageNotarySheet";
		DocumentType["SalesPackageChecklist"] = "SalesPackageChecklist";
		DocumentType["SalesPackageSellingCompanies"] = "SalesPackageSellingCompanies";
		DocumentType["PurchasingDocumentsSheet"] = "PurchasingDocumentsSheet";
		DocumentType["SellingDocumentsSheet"] = "SellingDocumentsSheet";
		DocumentType["SellingDataChecklist"] = "SellingDataChecklist";
		DocumentType["SellingEstatesDataSheet"] = "SellingEstatesDataSheet";
		DocumentType["CashflowStatementSheet"] = "CashflowStatementSheet";
		DocumentType["InvestorPaymentSlip"] = "InvestorPaymentSlip";
		DocumentType["InvestorPayoutStatement"] = "InvestorPayoutStatement";
		DocumentType["DefectReport"] = "DefectReport";
		DocumentType["SalesPackageUserUploadedPriceList"] = "SalesPackageUserUploadedPriceList";
		DocumentType["SalesPackageUserUploadedDataSheet"] = "SalesPackageUserUploadedDataSheet";
		DocumentType["SalesPackageUserUploadedChecklist"] = "SalesPackageUserUploadedChecklist";
		DocumentType["SalesPackageUserUploadedPhotoAlbum"] = "SalesPackageUserUploadedPhotoAlbum";
		DocumentType["SellingRegionBrochure"] = "SellingRegionBrochure";
		DocumentType["TransferRecurrentPaymentsSEPAXmlList"] = "TransferRecurrentPaymentsSEPAXmlList";
		/** Sales portal selling example **/
		DocumentType["CondoSellingPresentation"] = "CondoSellingPresentation";
		DocumentType["SalesPartnerFlyer"] = "SalesPartnerFlyer";
		DocumentType["PropertyManagementOwnerBrochure"] = "PropertyManagementOwnerBrochure";
		/** Sales portal marketing example **/
		DocumentType["ModelPurchaseContract"] = "ModelPurchaseContract";
		DocumentType["ModelRentalContract"] = "ModelRentalContract";
		DocumentType["ModelPropertyManagementContractWithFee"] = "ModelPropertyManagementContractWithFee";
		DocumentType["ModelPropertyManagementLawOfAttorney"] = "ModelPropertyManagementLawOfAttorney";
		DocumentType["ModelPropertyManagementGDPR"] = "ModelPropertyManagementGDPR";
		/** MFH https://condo-group.atlassian.net/browse/KO-5559 */
		DocumentType["CurrentLandRegisterExtract"] = "CurrentLandRegisterExtract";
		DocumentType["EncumbranceBasisInDeptII"] = "EncumbranceBasisInDeptII";
		DocumentType["CurrentParcelMap"] = "CurrentParcelMap";
		DocumentType["CurrentPlanningRights"] = "CurrentPlanningRights";
		DocumentType["InformationUrbanRenewalArea"] = "InformationUrbanRenewalArea";
		DocumentType["InformationUrbanConservationArea"] = "InformationUrbanConservationArea";
		DocumentType["InformationMonumentProtection"] = "InformationMonumentProtection";
		DocumentType["SocialPreservationOrdinance"] = "SocialPreservationOrdinance";
		DocumentType["InformationBuildingChargeRegister"] = "InformationBuildingChargeRegister";
		DocumentType["ExtractContaminatedSitesRegister"] = "ExtractContaminatedSitesRegister";
		DocumentType["ExtractDevelopmentAndExpansionContributions"] = "ExtractDevelopmentAndExpansionContributions";
		DocumentType["UrbanDevelopmentContracts"] = "UrbanDevelopmentContracts";
		DocumentType["SoilReportOrContaminatedSites"] = "SoilReportOrContaminatedSites";
		DocumentType["GroundLease"] = "GroundLease";
		DocumentType["VerificationOfExplosiveOrdnance"] = "VerificationOfExplosiveOrdnance";
		DocumentType["OngoingLegalDisputesRegardingProperty"] = "OngoingLegalDisputesRegardingProperty";
		DocumentType["BuildingEnergyCertificate"] = "BuildingEnergyCertificate";
		DocumentType["SectionDrawingsBuildingElevations"] = "SectionDrawingsBuildingElevations";
		DocumentType["FloorPlansIncludingAreaCalculation"] = "FloorPlansIncludingAreaCalculation";
		DocumentType["BuildingApplicationOrBuildingPermit"] = "BuildingApplicationOrBuildingPermit";
		DocumentType["WarrantyGuarantees"] = "WarrantyGuarantees";
		DocumentType["OverviewOfPastOngoingAndPlannedModernization"] = "OverviewOfPastOngoingAndPlannedModernization";
		DocumentType["InsuranceClaimsLast5Years"] = "InsuranceClaimsLast5Years";
		DocumentType["ModernizationsOfIndividualApartments"] = "ModernizationsOfIndividualApartments";
		DocumentType["DeclarationOfDivisionIfDivided"] = "DeclarationOfDivisionIfDivided";
		DocumentType["OngoingLegalDisputesRegardingObject"] = "OngoingLegalDisputesRegardingObject";
		DocumentType["TenantList"] = "TenantList";
		DocumentType["RentIncreaseLetters"] = "RentIncreaseLetters";
		DocumentType["RentalAgreements"] = "RentalAgreements";
		DocumentType["ListOfExistingRentalDeposits"] = "ListOfExistingRentalDeposits";
		DocumentType["OperatingCostStatement"] = "OperatingCostStatement";
		DocumentType["TenantHandoverProtocols"] = "TenantHandoverProtocols";
		DocumentType["ListOfCurrentDefectComplaintsReductionsArrears"] = "ListOfCurrentDefectComplaintsReductionsArrears";
		DocumentType["OngoingLegalDisputesWithTenants"] = "OngoingLegalDisputesWithTenants";
		DocumentType["ManagementContracts"] = "ManagementContracts";
		DocumentType["MaintenanceProtocols"] = "MaintenanceProtocols";
		DocumentType["ListOfAgeOfInstallations"] = "ListOfAgeOfInstallations";
		DocumentType["InsurancesMainlyCurrentBuildingInsurance"] = "InsurancesMainlyCurrentBuildingInsurance";
		DocumentType["PropertyTaxAssessmentAndUnitValueNotice"] = "PropertyTaxAssessmentAndUnitValueNotice";
		DocumentType["ListOfCraftsmen"] = "ListOfCraftsmen";
		DocumentType["PurchaseContractDraft"] = "PurchaseContractDraft";
		DocumentType["AttachmentsToPurchaseContract"] = "AttachmentsToPurchaseContract";
		DocumentType["PowersOfAttorney"] = "PowersOfAttorney";
		DocumentType["MfhExpose"] = "MfhExpose";
		DocumentType["SuperStructures"] = "SuperStructures";
		DocumentType["LandValueMap"] = "LandValueMap";
		DocumentType["CommercialOwnerRegisterExtract"] = "CommercialOwnerRegisterExtract";
		DocumentType["NeighbourhoodAgreements"] = "NeighbourhoodAgreements";
		DocumentType["LandUsePlan"] = "LandUsePlan";
		DocumentType["OtherPermits"] = "OtherPermits";
		DocumentType["OfficialCertificates"] = "OfficialCertificates";
		DocumentType["BuildingInventoryPlans"] = "BuildingInventoryPlans";
		DocumentType["BuildingSections"] = "BuildingSections";
		DocumentType["BuildingStatics"] = "BuildingStatics";
		DocumentType["BuildingHeating"] = "BuildingHeating";
		DocumentType["BuildingVentilation"] = "BuildingVentilation";
		DocumentType["BuildingAirConditioning"] = "BuildingAirConditioning";
		DocumentType["BuildingSanitary"] = "BuildingSanitary";
		DocumentType["BuildingElectrical"] = "BuildingElectrical";
		DocumentType["FireProtection"] = "FireProtection";
		DocumentType["SpecialistPlannerContracts"] = "SpecialistPlannerContracts";
		DocumentType["SpecialRealEstateAdditionalInformation"] = "SpecialRealEstateAdditionalInformation";
		DocumentType["BuildingAdditonalInformation"] = "BuildingAdditonalInformation";
		DocumentType["Terminations"] = "Terminations";
		DocumentType["TaxAssessmentNotices"] = "TaxAssessmentNotices";
		DocumentType["TaxOtherMunicipalCharges"] = "TaxOtherMunicipalCharges";
		DocumentType["TaxCorrectionBalancesAndPeriods"] = "TaxCorrectionBalancesAndPeriods";
		DocumentType["TaxValueAddTenants"] = "TaxValueAddTenants";
		DocumentType["TaxValueAddSellers"] = "TaxValueAddSellers";
		DocumentType["TaxOptionRatesAndAreaKeys"] = "TaxOptionRatesAndAreaKeys";
		DocumentType["CompanyOverview"] = "CompanyOverview";
		DocumentType["CommercialRegisterExtract"] = "CommercialRegisterExtract";
		DocumentType["TransferOfShares"] = "TransferOfShares";
		DocumentType["RegisterExcerpts"] = "RegisterExcerpts";
		DocumentType["ShareRegister"] = "ShareRegister";
		DocumentType["ListOfShareholders"] = "ListOfShareholders";
		DocumentType["ArticlesOfAssociation"] = "ArticlesOfAssociation";
		DocumentType["ArticlesOfAssociationResolutionAmmendments"] = "ArticlesOfAssociationResolutionAmmendments";
		DocumentType["ArticlesOfAssociationResolutions"] = "ArticlesOfAssociationResolutions";
		DocumentType["DistributionOfProfitsResolutions"] = "DistributionOfProfitsResolutions";
		DocumentType["CapitalEndowmentResolutions"] = "CapitalEndowmentResolutions";
		DocumentType["OtherResolutions"] = "OtherResolutions";
		DocumentType["ManagingDirectorResolutions"] = "ManagingDirectorResolutions";
		DocumentType["Minutes"] = "Minutes";
		DocumentType["AgreementsWithManagement"] = "AgreementsWithManagement";
		DocumentType["CompanyAccountant"] = "CompanyAccountant";
		DocumentType["CompanyAuditor"] = "CompanyAuditor";
		DocumentType["CompanyTaxConsultant"] = "CompanyTaxConsultant";
		DocumentType["CompanyOtherContracts"] = "CompanyOtherContracts";
		DocumentType["LoanAgreement"] = "LoanAgreement";
		DocumentType["LandChargeDeed"] = "LandChargeDeed";
		DocumentType["DeclarationOfSecurityPurpose"] = "DeclarationOfSecurityPurpose";
		DocumentType["DeclarationOfAssignment"] = "DeclarationOfAssignment";
		DocumentType["Pledges"] = "Pledges";
		DocumentType["PurchasingTerminationDocuments"] = "PurchasingTerminationDocuments";
		DocumentType["FinancialAnnualStatements"] = "FinancialAnnualStatements";
		DocumentType["FinancialTaxes"] = "FinancialTaxes";
		DocumentType["FinancialManagementReporting"] = "FinancialManagementReporting";
		DocumentType["FinancialLiabilities"] = "FinancialLiabilities";
		DocumentType["FinancialCurrentBalances"] = "FinancialCurrentBalances";
		DocumentType["FinancialOtherInformation"] = "FinancialOtherInformation";
		DocumentType["FoundationReport"] = "FoundationReport";
		DocumentType["ImportantCorrespondence"] = "ImportantCorrespondence";
		DocumentType["AdditionalCostsInvoice"] = "AdditionalCostsInvoice";
		DocumentType["MFHSummary"] = "MFHSummary";
		DocumentType["MFHInvestmentCaseExportableSheet"] = "MFHInvestmentCaseExportableSheet";
		DocumentType["AssetPipelineSheet"] = "AssetPipelineSheet";
		DocumentType["ExternalInvoiceExport"] = "ExternalInvoiceExport";
		DocumentType["AssetTenderingProcess"] = "AssetTenderingProcess";
		/** Due Diligence **/
		DocumentType["DueDiligenceOnSiteInspection"] = "DueDiligenceOnSiteInspection";
		DocumentType["TechnicalDD"] = "TechnicalDD";
		DocumentType["LegalDD"] = "LegalDD";
		DocumentType["CommercialDD"] = "CommercialDD";
		DocumentType["EnergyConsultation"] = "EnergyConsultation";
		DocumentType["Vicinity"] = "Vicinity";
		DocumentType["ZoningPlan"] = "ZoningPlan";
		DocumentType["DevelopmentPlanOrdinance"] = "DevelopmentPlanOrdinance";
		DocumentType["OtherPlanningLaw"] = "OtherPlanningLaw";
		DocumentType["ExtractLandChargeRegister"] = "ExtractLandChargeRegister";
		DocumentType["ExtractTreeInventoryRegister"] = "ExtractTreeInventoryRegister";
		DocumentType["FloodRiskMap"] = "FloodRiskMap";
		DocumentType["GroundwaterPlans"] = "GroundwaterPlans";
		DocumentType["ProtectedAreaMap"] = "ProtectedAreaMap";
		DocumentType["LiabilityInsuranceForBuildingAndProperty"] = "LiabilityInsuranceForBuildingAndProperty";
		DocumentType["LiabilityInsuranceForWaterPollutionDamage"] = "LiabilityInsuranceForWaterPollutionDamage";
		DocumentType["MaintenanceContracts"] = "MaintenanceContracts";
		DocumentType["PreliminaryBuildingPermit"] = "PreliminaryBuildingPermit";
		DocumentType["SoilPollutantReportsAndSoilDecontaminationReceipts"] = "SoilPollutantReportsAndSoilDecontaminationReceipts";
		DocumentType["ConstructionAcceptanceCertificate"] = "ConstructionAcceptanceCertificate";
		DocumentType["ReportTechnicalDueDiligence"] = "ReportTechnicalDueDiligence";
		DocumentType["PurchasingOffer"] = "PurchasingOffer";
		DocumentType["CourtageAgreement"] = "CourtageAgreement";
		DocumentType["ExclusivityAgreement"] = "ExclusivityAgreement";
		DocumentType["BillingOrInvoices"] = "BillingOrInvoices";
		DocumentType["InvestmentProposal"] = "InvestmentProposal";
		DocumentType["KYCDraft"] = "KYCDraft";
		DocumentType["IDSeller"] = "IDSeller";
		/** Addenda */
		DocumentType["AddendumContractDraft"] = "AddendumContractDraft";
		DocumentType["AddendumContract"] = "AddendumContract";
		/** Renovation */
		DocumentType["Auftragsempfehlung"] = "Auftragsempfehlung";
		DocumentType["Entscheidungsvorlage"] = "Entscheidungsvorlage";
		DocumentType["Werkvertrag"] = "Werkvertrag";
		DocumentType["Planervertrag"] = "Planervertrag";
		return DocumentType;
	}({});
	documentCategoryMap = {
		["General"]: [
			"ProtocolArchived",
			"Protocol2024",
			"Protocol2025",
			"Protocol2026",
			"ArchiveOfResolutions",
			"InvitationETV",
			"AnnualStatement",
			"EconomicPlan",
			"HomeOwnerFeeStatement",
			"BuildingInsurance",
			"EnergyCertificate",
			"PropertyTaxNotice",
			"ConstructionBurdenStatement",
			"DeclarationOfCondominium",
			"AmendmentToDeclarationOfDivision",
			"AllowanceOfEntrySectionII",
			"SeparationDeclaration",
			"PartitionPlan",
			"Floorplans",
			"ViewsAndSections",
			"LivingSpaceCalculation",
			"ConstructionDescriptionBuilding",
			"BuildingPermit",
			"HouseRules",
			"LandRegisterMap",
			"ManagementAgreement",
			"SpecialAssessments",
			"Other"
		],
		["Purchasing"]: [
			"Expose",
			"ContractDraft",
			"ContractNotarized",
			"AbstractOfTitle",
			"LandCharge",
			"PaymentNotice",
			"ProofOfPayment",
			"RegistrationNotice",
			"NotaryCorrespondence",
			"AdministrationCorrespondence",
			"NotaryRegistrationReservation",
			"PurchasingHandoverProtocol",
			"SEPAMandateHomeOwnersFee",
			"Other"
		],
		["Selling"]: [
			"SellingExpose",
			"SellingCalculations",
			"ExposeExternal",
			"SellingExposeLocation",
			"SellingContractDraft",
			"SellingContractNotarized",
			"SellingAbstractOfTitle",
			"LandRegisterParkingSpace",
			"NotaryCertification",
			"BuildingAcceptancePowerOfAttorney",
			"SellingPaymentNotice",
			"SellingProofOfPayment",
			"SellingRenovationAcceptanceProtocol",
			"SellingRegistrationNotice",
			"SellingNotaryCorrespondence",
			"SellingAdministrationCorrespondence",
			"SellingDataSheet",
			"SellingNotaryRegistrationReservation",
			"SellingHandoverProtocol",
			"SellingExpertReportWithCapEx",
			"SellingExpertReport",
			"SellingResidualValueCertificate",
			"BuildingModernizationMeasures",
			"SellingEstatesDataSheet",
			"Other"
		],
		["Renovation"]: [
			"BuildingInformationModel",
			"FloorPlanSketch",
			"DimensionedFloorPlan",
			"DimensionedFloorPlanPlanned",
			"CadFile",
			"CadFilePlanned",
			"LV",
			"Kitchen",
			"KitchenContracted",
			"Inspection",
			"ConstructionContract",
			"ContractorOffer",
			"ConstructionSiteReport",
			"RevisionDocumentation",
			"ReportsCalculationsAppraisals",
			"ConstructionGuarantee",
			"BathPlan",
			"DefectReport",
			"MfhConstructionPlan",
			"Other",
			"Auftragsempfehlung",
			"Entscheidungsvorlage",
			"Werkvertrag",
			"Planervertrag"
		],
		["PostRenovation"]: [
			"PostRenovationAcceptanceProtocol",
			"ConstructionDescriptionRenovation",
			"PostRenovationDimensionedFloorPlan",
			"SalesPartnerFloorPlan",
			"LivingSpaceCalculations",
			"RoomVolumeCalculation",
			"BeforeAfterPictures",
			"Other"
		],
		["PropertyManagement"]: [
			"RentContract",
			"CancellationLease",
			"CancellationLeaseConfirmation",
			"RentIncrease",
			"AcceptanceProtocol",
			"BKAStatement",
			"BKAHeatingStatement",
			"BKAAllocationCalculation",
			"BKAHouseholdCosts",
			"HeatingBill",
			"Correspondence",
			"SelfAssessmentSheet",
			"ID",
			"SalaryInformation",
			"SchufaReport",
			"Deposit",
			"BKADeposit",
			"HousingProviderConfirmation",
			"SEVContractWithFee",
			"SEVContractWithoutFee",
			"SEVPoA",
			"DkbInvestorVerification",
			"SEVCoverLetter",
			"CancellationSEVContract",
			"CancellationSEVContractConfirmation",
			"CondoTerminationAgreement",
			"GDPRTenant",
			"GDPROwner",
			"PersonalIDOwner",
			"SalutationWEG",
			"SEPAManadateHouseGeld",
			"SEPATenant",
			"WithdrawlInstructionTenant",
			"WithdrawlInstructionOwner",
			"TenantCorrespondence",
			"OwnerCorrespondence",
			"UtilitiesCorrespondence",
			"CorrespondencePropertyManagement",
			"CashflowStatementSheet",
			"InvestorPaymentSlip",
			"InvestorPayoutStatement",
			"WEGAnnualStatement",
			"InvoicesPropertyManagement",
			"InvestorPayout",
			"InvestorYearlyPayout",
			"RentGuarantee",
			"RentArrearNotice",
			"DunningNotice",
			"EnforcementNotice",
			"Other",
			"LegalDisputes"
		],
		["Renting"]: [
			"SelfDeclarationTenant",
			"QuestionnaireTenant",
			"RentalContractDraft",
			"SalaryRecordPropesctiveTenant",
			"SchufaProspectiveTenant",
			"PersonalIDProspectiveTenant",
			"AnnualServiceChargeCalculation",
			"Other"
		],
		["Orientation"]: [
			"Safe",
			"Estate",
			"BasementRoom",
			"AtticRoom",
			"CommonRoom",
			"Parking",
			"Other"
		],
		["Livings"]: [
			"FurniturePlanPdf",
			"FurniturePlanDwg",
			"RequestedOrderLists",
			"ContractedOrderLists",
			"PartnerBrochure",
			"InvoicesFittings",
			"InvoicesServiceProvider",
			"Internet",
			"LivingsAcceptanceProtocol",
			"Other"
		],
		["SalesPackage"]: [
			"SalesPackageUserUploadedPriceList",
			"SalesPackageUserUploadedDataSheet",
			"SalesPackageUserUploadedChecklist",
			"SalesPackageUserUploadedPhotoAlbum",
			"Other"
		],
		["SellingRegion"]: ["SellingRegionBrochure", "Other"],
		["Land"]: [
			"CurrentLandRegisterExtract",
			"EncumbranceBasisInDeptII",
			"CurrentParcelMap",
			"CurrentPlanningRights",
			"InformationUrbanRenewalArea",
			"InformationUrbanConservationArea",
			"InformationMonumentProtection",
			"SocialPreservationOrdinance",
			"InformationBuildingChargeRegister",
			"ExtractContaminatedSitesRegister",
			"ExtractDevelopmentAndExpansionContributions",
			"UrbanDevelopmentContracts",
			"SoilReportOrContaminatedSites",
			"GroundLease",
			"VerificationOfExplosiveOrdnance",
			"OngoingLegalDisputesRegardingProperty",
			"SuperStructures",
			"CommercialOwnerRegisterExtract",
			"LandValueMap",
			"LandUsePlan",
			"NeighbourhoodAgreements",
			"OfficialCertificates",
			"FoundationReport",
			"Other"
		],
		["Building"]: [
			"BuildingEnergyCertificate",
			"SectionDrawingsBuildingElevations",
			"FloorPlansIncludingAreaCalculation",
			"BuildingApplicationOrBuildingPermit",
			"WarrantyGuarantees",
			"OverviewOfPastOngoingAndPlannedModernization",
			"InsuranceClaimsLast5Years",
			"ModernizationsOfIndividualApartments",
			"DeclarationOfDivisionIfDivided",
			"OngoingLegalDisputesRegardingObject",
			"BuildingInventoryPlans",
			"BuildingSections",
			"BuildingStatics",
			"BuildingHeating",
			"BuildingVentilation",
			"BuildingAirConditioning",
			"BuildingSanitary",
			"BuildingElectrical",
			"FireProtection",
			"SpecialistPlannerContracts",
			"SpecialRealEstateAdditionalInformation",
			"BuildingAdditonalInformation",
			"OtherPermits",
			"Other"
		],
		["RentalContract"]: [
			"TenantList",
			"RentIncreaseLetters",
			"RentalAgreements",
			"ListOfExistingRentalDeposits",
			"OperatingCostStatement",
			"TenantHandoverProtocols",
			"ListOfCurrentDefectComplaintsReductionsArrears",
			"OngoingLegalDisputesWithTenants",
			"Terminations",
			"ImportantCorrespondence",
			"AdditionalCostsInvoice",
			"Other"
		],
		["ObjectManagement"]: [
			"ManagementContracts",
			"MaintenanceProtocols",
			"ListOfAgeOfInstallations",
			"InsurancesMainlyCurrentBuildingInsurance",
			"PropertyTaxAssessmentAndUnitValueNotice",
			"ListOfCraftsmen",
			"Other"
		],
		["PurchasingContract"]: [
			"PurchaseContractDraft",
			"AttachmentsToPurchaseContract",
			"PowersOfAttorney",
			"LoanAgreement",
			"LandChargeDeed",
			"DeclarationOfSecurityPurpose",
			"DeclarationOfAssignment",
			"Pledges",
			"PurchasingTerminationDocuments",
			"PurchasingOffer",
			"CourtageAgreement",
			"ExclusivityAgreement",
			"Other"
		],
		["MfhOther"]: [
			"MfhExpose",
			"InvestmentProposal",
			"Other"
		],
		["Taxes"]: [
			"TaxAssessmentNotices",
			"TaxOtherMunicipalCharges",
			"TaxCorrectionBalancesAndPeriods",
			"TaxValueAddTenants",
			"TaxValueAddSellers",
			"TaxOptionRatesAndAreaKeys",
			"Other"
		],
		["GeneralCompany"]: [
			"CompanyOverview",
			"CommercialRegisterExtract",
			"TransferOfShares",
			"RegisterExcerpts",
			"ShareRegister",
			"ListOfShareholders",
			"Other"
		],
		["ShareholderAndStatutes"]: [
			"ArticlesOfAssociation",
			"ArticlesOfAssociationResolutionAmmendments",
			"ArticlesOfAssociationResolutions",
			"DistributionOfProfitsResolutions",
			"CapitalEndowmentResolutions",
			"OtherResolutions",
			"ManagingDirectorResolutions",
			"Minutes",
			"AgreementsWithManagement",
			"Other"
		],
		["CompanyContracts"]: [
			"CompanyAccountant",
			"CompanyAuditor",
			"CompanyTaxConsultant",
			"CompanyOtherContracts",
			"Other"
		],
		["Financing"]: [
			"FinancialAnnualStatements",
			"FinancialTaxes",
			"FinancialManagementReporting",
			"FinancialLiabilities",
			"FinancialCurrentBalances",
			"FinancialOtherInformation",
			"Other"
		],
		["DueDiligence"]: [
			"TechnicalDD",
			"LegalDD",
			"CommercialDD",
			"EnergyConsultation",
			"Vicinity",
			"ZoningPlan",
			"DevelopmentPlanOrdinance",
			"OtherPlanningLaw",
			"ExtractLandChargeRegister",
			"ExtractTreeInventoryRegister",
			"FloodRiskMap",
			"GroundwaterPlans",
			"ProtectedAreaMap",
			"LiabilityInsuranceForBuildingAndProperty",
			"LiabilityInsuranceForWaterPollutionDamage",
			"MaintenanceContracts",
			"PreliminaryBuildingPermit",
			"SoilPollutantReportsAndSoilDecontaminationReceipts",
			"ConstructionAcceptanceCertificate",
			"ReportTechnicalDueDiligence",
			"Other"
		],
		["Accounting"]: ["BillingOrInvoices", "Other"],
		["KYC"]: [
			"KYCDraft",
			"IDSeller",
			"Other"
		]
	};
	purchasingRequiredDocuments = [
		"Protocol2024",
		"Protocol2025",
		"Protocol2026",
		"ArchiveOfResolutions",
		"AnnualStatement",
		"EconomicPlan",
		"HomeOwnerFeeStatement",
		"BuildingInsurance",
		"EnergyCertificate",
		"ConstructionBurdenStatement",
		"AbstractOfTitle",
		"DeclarationOfCondominium",
		"AmendmentToDeclarationOfDivision",
		"AllowanceOfEntrySectionII",
		"SeparationDeclaration",
		"PartitionPlan",
		"LivingSpaceCalculation",
		"Floorplans",
		"ConstructionDescriptionBuilding",
		"LandRegisterMap"
	];
	pmDocumentsColumnFields = [
		"ProtocolArchived",
		"Protocol2024",
		"Protocol2025",
		"Protocol2026",
		"ArchiveOfResolutions",
		"InvitationETV",
		"EconomicPlan",
		"HomeOwnerFeeStatement",
		"EnergyCertificate",
		"PropertyTaxNotice",
		"DeclarationOfCondominium",
		"ManagementAgreement",
		"SEVContractWithFee",
		"SEVContractWithoutFee",
		"RentContract",
		"AcceptanceProtocol",
		"BKAStatement",
		"BKAHeatingStatement",
		"BKAAllocationCalculation",
		"BKAHouseholdCosts",
		"SelfAssessmentSheet",
		"ID",
		"SalaryInformation",
		"SchufaReport",
		"Deposit",
		"DkbInvestorVerification",
		"GDPRTenant",
		"GDPROwner",
		"WithdrawlInstructionTenant",
		"WithdrawlInstructionOwner",
		"PersonalIDOwner",
		"WEGAnnualStatement",
		"InvestorYearlyPayout"
	];
	sellingDocumentsColumnFields = [
		"Protocol2024",
		"Protocol2025",
		"Protocol2026",
		"ArchiveOfResolutions",
		"AnnualStatement",
		"EconomicPlan",
		"HomeOwnerFeeStatement",
		"BuildingInsurance",
		"EnergyCertificate",
		"ConstructionBurdenStatement",
		"AbstractOfTitle",
		"DeclarationOfCondominium",
		"AmendmentToDeclarationOfDivision",
		"AllowanceOfEntrySectionII",
		"SeparationDeclaration",
		"PartitionPlan",
		"SellingContractNotarized",
		"LandRegisterParkingSpace",
		"SellingExpertReportWithCapEx",
		"SellingExpertReport",
		"SellingResidualValueCertificate",
		"ConstructionDescriptionRenovation",
		"PostRenovationDimensionedFloorPlan",
		"LivingSpaceCalculations",
		"BeforeAfterPictures",
		"SellingRenovationAcceptanceProtocol",
		"SellingExpose",
		"SellingCalculations"
	];
	DocumentUploadStatus = /* @__PURE__ */ function(DocumentUploadStatus) {
		DocumentUploadStatus["New"] = "New";
		DocumentUploadStatus["Duplicate"] = "Duplicate";
		return DocumentUploadStatus;
	}({});
	DocumentTypesAvailableForDocumentGenerationByPreview = [
		"SEVContractWithFee",
		"SEVCoverLetter",
		"SEVPoA",
		"WithdrawlInstructionOwner",
		"SEVContractWithoutFee",
		"GDPROwner",
		"GDPRTenant",
		"CancellationLeaseConfirmation",
		"ConstructionDescriptionRenovation",
		"PartnerBrochure",
		"SalutationWEG",
		"SEPAMandateHomeOwnersFee",
		"SEPAManadateHouseGeld",
		"DkbInvestorVerification",
		"SellingExposeLocation",
		"RentIncrease"
	];
	GeneratedDocumentTypesMapping = { ["SellingExposeLocation"]: "LocationProfile" };
	NonDownloadableDocument = ["PartnerBrochure"];
	DocumentPDFTemplates = ["DkbInvestorVerification"];
	DocumentXLSTemplates = [];
	DocumentsForPreparedRenovationState = [
		"LV",
		"DimensionedFloorPlanPlanned",
		"ConstructionDescriptionRenovation",
		"LivingSpaceCalculations",
		"Kitchen"
	];
	DocumentsOfMfhEstateForPreparedRenovationState = [
		"LV",
		"DimensionedFloorPlanPlanned",
		"LivingSpaceCalculations",
		"Kitchen"
	];
	TenantPortalDocuments = [
		"RentContract",
		"AcceptanceProtocol",
		"GDPRTenant",
		"SEPATenant",
		"HousingProviderConfirmation",
		"BKAStatement",
		"BKAHeatingStatement",
		"BKAHouseholdCosts",
		"HeatingBill"
	];
	InvestorPortalDocuments = [
		"RentContract",
		"SEVContractWithFee",
		"SEVContractWithoutFee",
		"SEVPoA",
		"WEGAnnualStatement",
		"GDPROwner",
		"WithdrawlInstructionOwner",
		"InvoicesPropertyManagement",
		"EconomicPlan",
		"InvitationETV",
		"ArchiveOfResolutions",
		"AnnualStatement",
		"HomeOwnerFeeStatement",
		"BuildingInsurance",
		"PropertyTaxNotice",
		"RentIncrease",
		"AcceptanceProtocol",
		"BKAStatement",
		"BKAHeatingStatement",
		"BKAAllocationCalculation",
		"BKAHouseholdCosts",
		"HeatingBill",
		"Correspondence",
		"OwnerCorrespondence",
		"CashflowStatementSheet",
		"InvestorPaymentSlip",
		"InvestorPayoutStatement",
		"InvestorPayout",
		"InvestorYearlyPayout",
		`Protocol${(/* @__PURE__ */ new Date()).getFullYear()}`
	];
	DefaultInvestorDocuments = [
		"SEVContractWithFee",
		"SEVContractWithoutFee",
		"SEVPoA",
		"GDPROwner",
		"WithdrawlInstructionOwner",
		"InvoicesPropertyManagement",
		"EconomicPlan",
		`Protocol${(/* @__PURE__ */ new Date()).getFullYear()}`
	];
	DocumentsOwnerPropertyManagement = [
		"SEVContractWithFee",
		"SEVPoA",
		"GDPROwner",
		"WithdrawlInstructionOwner",
		"InvoicesPropertyManagement"
	];
	DocumentCategoriesMfh = [
		"Land",
		"Building",
		"GeneralCompany",
		"CompanyContracts",
		"ShareholderAndStatutes",
		"DueDiligence",
		"MfhOther",
		"Taxes",
		"Financing",
		"PurchasingContract",
		"ObjectManagement",
		"RentalContract",
		"Accounting",
		"KYC",
		"Renovation"
	];
	DocumentCategoriesEstate = [...Object.keys(documentCategoryMap).filter((category) => !DocumentCategoriesMfh.includes(category)), "Renovation"];
	DocumentTypeRentArrearRelated = [
		"RentArrearNotice",
		"EnforcementNotice",
		"DunningNotice"
	];
	CustomizedExposeExcludableDocumentTypes = ["BuildingModernizationMeasures", "SellingExposeLocation"];
	additionalDocumentTypesWhenFiltered = {
		["SellingExpose"]: ["CustomizedSellingExpose", "PromotionExpose"],
		["LV"]: ["LongLV"]
	};
}));
//#endregion
//#region src/domains/cross-cutting/document/document.i18n.ts
var documentCategoryTranslationsMap, documentTranslationsMap, investorPortalDocumentTranslationsOverride, translateDocument, documentTypeToDescriptionMap, translateDocumentCategory;
var init_document_i18n = __esmMin((() => {
	init_document_model();
	documentCategoryTranslationsMap = {
		["Land"]: "Grundstückssituation",
		["Building"]: "Gebäudeunterlagen",
		["RentalContract"]: "Angaben zu Mietverträgen",
		["ObjectManagement"]: "Objektbewirtschaftung- und verwaltung",
		["PurchasingContract"]: "Kaufvertrag",
		["MfhOther"]: "Sonstiges",
		["Taxes"]: "Steuern",
		["GeneralCompany"]: "Allgemeines Unternehmen",
		["CompanyContracts"]: "Verträge der Gesellschaft",
		["ShareholderAndStatutes"]: "Aktionär und Statuten",
		["DueDiligence"]: "Due Diligence",
		["Financing"]: "Finanzierung",
		["Accounting"]: "Buchhaltung",
		["KYC"]: "KYC",
		["PropertyManagement"]: "Property Management"
	};
	documentTranslationsMap = {
		["ProtocolArchived"]: "Protokoll (alt)",
		["Protocol2024"]: "Protokoll 2024",
		["Protocol2025"]: "Protokoll 2025",
		["Protocol2026"]: "Protokoll 2026",
		["AnnualStatement"]: "Rücklagenabrechnung",
		["EconomicPlan"]: "Wirtschaftsplan",
		["HomeOwnerFeeStatement"]: "Wohngeldeinzelabrechnung",
		["BuildingInsurance"]: "Gebäudeversicherungsnachweis",
		["EnergyCertificate"]: "Energieausweis",
		["ConstructionBurdenStatement"]: "Baulastenauszug",
		["AbstractOfTitle"]: "Grundbuchauszug",
		["DeclarationOfCondominium"]: "Teilungserklärung",
		["PartitionPlan"]: "Aufteilungspläne",
		["ViewsAndSections"]: "Ansichten und Schnitte",
		["LivingSpaceCalculation"]: "Wohnflächenberechnung (Bestand)",
		["ContractDraft"]: "Kaufvertrag (Entwurf)",
		["ContractNotarized"]: "Kaufvertrag (beurkundet)",
		["LandRegisterMap"]: "Amtlicher Lageplan (Flurkarte)",
		["Expose"]: "Exposé",
		["ExposeExternal"]: "Exposé External",
		["HouseRules"]: "Hausordnung",
		["BuildingInformationModel"]: "3D Modell (ifc)",
		["FloorPlanSketch"]: "Grundriss Planung Skizze (pdf)",
		["DimensionedFloorPlan"]: "Bemaßter Grundriss Bestand (pdf)",
		["DimensionedFloorPlanPlanned"]: "Bemaßter Grundriss Planung (pdf)",
		["CadFile"]: "CAD Datei Bestand (dwg)",
		["CadFilePlanned"]: "CAD Datei Planung (dwg)",
		["LV"]: "Leistungsverzeichnis",
		["LongLV"]: "Leistungsverzeichnis",
		["Kitchen"]: "Einbauküche Angebot",
		["KitchenContracted"]: "Einbauküche Beauftragt",
		["Inspection"]: "Inspections",
		["ConstructionContract"]: "Bauvertrag",
		["ContractorOffer"]: "Angebote",
		["RevisionDocumentation"]: "Revisionsunterlagen",
		["ReportsCalculationsAppraisals"]: "Berichte/Berechnung/Gutachten",
		["ConstructionSiteReport"]: "Baustellenbericht",
		["PostRenovationAcceptanceProtocol"]: "Baustellenbericht (nach Renovierung)",
		["PropertyTaxNotice"]: "Grundsteuerbescheid",
		["RentContract"]: "Mietvertrag",
		["RentIncrease"]: "Mieterhöhung",
		["AcceptanceProtocol"]: "Abnahme-/Übergabeprotokoll",
		["HeatingBill"]: "Heizkostenabrechnung",
		["Correspondence"]: "Schriftverkehr",
		["SelfAssessmentSheet"]: "Selbstauskunft",
		["ID"]: "Personalausweis",
		["SalaryInformation"]: "Gehaltsabrechnung",
		["SchufaReport"]: "Schufa-Auskunft",
		["DkbInvestorVerification"]: "DKB Verifizierung Treuhandkonto",
		["Deposit"]: "Kautionsunterlagen",
		["PaymentNotice"]: "Fälligkeitsmitteilung",
		["InvitationETV"]: "Einladung ETV",
		["Floorplans"]: "Grundrisse (Bestand)",
		["ConstructionDescriptionBuilding"]: "Baubeschreibung Gebäude (Bestand)",
		["RegistrationNotice"]: "Eintragungsmitteilungen",
		["ProofOfPayment"]: "Zahlungsbeleg",
		["NotaryCorrespondence"]: "Schriftverkehr Notar",
		["AdministrationCorrespondence"]: "Schriftverkehr Verwaltung",
		["NotaryRegistrationReservation"]: "Notaranmeldung / Reservierung",
		["SellingExpose"]: "Exposé",
		["SellingCalculations"]: "Beispielhafte Berechnung",
		["PromotionExpose"]: "Exposé",
		["CustomizedSellingExpose"]: "Customized Exposé",
		["SellingContractDraft"]: "Kaufvertrag (Entwurf)",
		["SellingContractNotarized"]: "Kaufvertrag (beurkundet)",
		["SellingAbstractOfTitle"]: "Grundbuchauszug",
		["NotaryCertification"]: "Rangbescheinigung",
		["SellingPaymentNotice"]: "Fälligkeitsmitteilung",
		["SellingProofOfPayment"]: "Zahlungsbeleg",
		["SellingRegistrationNotice"]: "Eintragungsmitteilungen",
		["SellingNotaryCorrespondence"]: "Schriftverkehr Notar",
		["SellingAdministrationCorrespondence"]: "Schriftverkehr Verwaltung",
		["SellingDataSheet"]: "Datenblatt (PDF)",
		["SellingNotaryRegistrationReservation"]: "Notaranmeldung / Reservierung",
		["ConstructionGuarantee"]: "Bürgschaft",
		["MfhConstructionPlan"]: "Bauplan",
		["BathPlan"]: "Badplanung",
		["ConstructionDescriptionRenovation"]: "Baubeschreibung Renovierung (Neu)",
		["PostRenovationDimensionedFloorPlan"]: "Bemaßter Grundriss (Neu)",
		["SalesPartnerFloorPlan"]: "Vermarktungsgrundriss",
		["LivingSpaceCalculations"]: "Wohnflächenberechnung (Neu)",
		["RoomVolumeCalculation"]: "Rauminhaltsberechnung",
		["BeforeAfterPictures"]: "Vorher-Nachher Bilder (pdf)",
		["HousingProviderConfirmation"]: "Wohnungsgeberbestätigung",
		["SEVContractWithFee"]: "SEV-Vertrag (mit Gebühr)",
		["SEVContractWithoutFee"]: "SEV-Vertrag (ohne Gebühr)",
		["SEVPoA"]: "SEV-Vollmacht",
		["SEVCoverLetter"]: "Anschreiben SEV Vertrag",
		["GDPRTenant"]: "Datenschutzblatt Mieter",
		["GDPROwner"]: "Datenschutzblatt Eigentümer",
		["PersonalIDOwner"]: "Personalausweis Eigentümer",
		["SalutationWEG"]: "Anschreiben WEG",
		["SEPAManadateHouseGeld"]: "SEPA-Mandat Wohngeld",
		["SEPATenant"]: "SEPA-Mandat Mieter",
		["WithdrawlInstructionOwner"]: "Widerrufsbelehrung Eigentümer",
		["DunningNotice"]: "Mahnbescheid",
		["EnforcementNotice"]: "Vollstreckung",
		["WithdrawlInstructionTenant"]: "Widerrufsbelehrung Mieter",
		["TenantCorrespondence"]: "Schriftverkehr Mieter",
		["OwnerCorrespondence"]: "Schriftverkehr Eigentümer",
		["UtilitiesCorrespondence"]: "Schriftverkehr Versorger",
		["SelfDeclarationTenant"]: "Selbstauskünfte (Mietinteressenten)",
		["QuestionnaireTenant"]: "Fragebögen (Mietinteressenten)",
		["RentalContractDraft"]: "Mietvertragsentwurf",
		["SalaryRecordPropesctiveTenant"]: "Gehaltsnachweis (Mietinteressenten)",
		["SchufaProspectiveTenant"]: "Schufa-Auskunft (Mietinteressenten)",
		["PersonalIDProspectiveTenant"]: "Personalausweis (Mietinteressenten)",
		["Safe"]: "Tresor",
		["Estate"]: "Wohnung",
		["BasementRoom"]: "Kellerraum",
		["AtticRoom"]: "Dachbodenraum",
		["CommonRoom"]: "Gemeinschaftsräume",
		["Parking"]: "Stellplatz",
		["Other"]: "Sonstiges",
		["LandCharge"]: "Grundschuldbestellung",
		["PurchasingHandoverProtocol"]: "Übergabeprotokoll",
		["SellingHandoverProtocol"]: "Übergabeprotokoll",
		["SellingRenovationAcceptanceProtocol"]: "Bauabnahmeprotokoll",
		["ManagementAgreement"]: "Verwaltervertrag",
		["SpecialAssessments"]: "Sonderumlagen",
		["ArchiveOfResolutions"]: "Beschlusssammlung",
		["SeparationDeclaration"]: "Abgeschlossenheitsbescheinigung",
		["SEPAMandateHomeOwnersFee"]: "SEPA-Mandat Wohngeld",
		["AnnualServiceChargeCalculation"]: "Nebenkostenkalkulation",
		["CancellationLease"]: "Kündigung Mietvertrag",
		["CancellationLeaseConfirmation"]: "Kündigungsbestätigung Mietvertrag",
		["CancellationSEVContract"]: "Kündigung SEV-Vertrag",
		["CancellationSEVContractConfirmation"]: "Kündigungsbestätigung SEV-Vertrag",
		["CondoTerminationAgreement"]: "Aufhebungsvertrag Condo",
		["LegalDisputes"]: "Rechtsstreitigkeiten",
		["AmendmentToDeclarationOfDivision"]: "Nachträge zur Teilungserklärung",
		["AllowanceOfEntrySectionII"]: "Eintragungsbewilligung Abt. II",
		["SellingExpertReportWithCapEx"]: "Gutachten Gemeinschaftseigentum mit CapEx",
		["SellingExpertReport"]: "Gutachten Gemeinschaftseigentum",
		["BuildingModernizationMeasures"]: "Modernisierungsmaßnahmen",
		["CorrespondencePropertyManagement"]: "Schriftverkehr Verwaltung",
		["SellingExposeLocation"]: "Standortprofil",
		["FurniturePlanPdf"]: "Möblierungsplan (pdf)",
		["FurniturePlanDwg"]: "Möblierungsplan (dwg)",
		["RequestedOrderLists"]: "Bestelllisten angefragt",
		["ContractedOrderLists"]: "Bestelllisten beauftragt",
		["PartnerBrochure"]: "Partner Broschüre",
		["InvoicesFittings"]: "Rechnungen Ausstattung",
		["InvoicesServiceProvider"]: "Rechnungen Dienstleister",
		["Internet"]: "Internet",
		["LivingsAcceptanceProtocol"]: "Abnahmeprotokoll",
		["CashflowStatementSheet"]: "Kontoauszug Excel",
		["InvestorPaymentSlip"]: "Kontoauszug PDF",
		["InvestorPayoutStatement"]: "Investor Payment Slip",
		["DefectReport"]: "Defect Protocoll",
		["WEGAnnualStatement"]: "WEG Jahresabrechnung",
		["InvoicesPropertyManagement"]: "Rechnungen",
		["BuildingPermit"]: "Baugenehmigung (Bestand)",
		["LandRegisterParkingSpace"]: "Grundbuch Stellplatz",
		["BuildingAcceptancePowerOfAttorney"]: "Bauabnahme-Vollmacht",
		["SellingResidualValueCertificate"]: "Restwertgutachten",
		["RenovationCostTrackingSheet"]: "Renovation Cost Tracking Sheet",
		["InvestorPayout"]: "Mietüberschuss Erklärung",
		["InvestorYearlyPayout"]: "SEV Jahresabrechnung",
		["RentArrearNotice"]: "Mietrückstandsanzeige",
		["RentGuarantee"]: "Mietgarantie/Mietminderung Erstattung",
		["BKAAllocationCalculation"]: "BKA Aufteilungsberechnung",
		["BKAHeatingStatement"]: "Aufteilung Heizkostenabrechnung nach Gradtagszahlen",
		["BKAStatement"]: "Betriebskostenabrechnung",
		["BKAHouseholdCosts"]: "Aufwendungen für haushaltsnahe Dienstleistungen",
		["BKADeposit"]: "Kautionsabrechnung",
		["CurrentLandRegisterExtract"]: "Aktuelle Grundbuchauszug",
		["EncumbranceBasisInDeptII"]: "Bei Lasten in Abteilung II",
		["CurrentParcelMap"]: "Aktuelle Flurkarte",
		["CurrentPlanningRights"]: "Aktuell geltendes Planungsrecht",
		["InformationUrbanRenewalArea"]: "Auskunft Sanierungs- und Entwicklungsgebiet",
		["InformationUrbanConservationArea"]: "Auskunft städtebauliche Erhaltungsgebiet",
		["InformationMonumentProtection"]: "Auskunft Denkmalschutz",
		["SocialPreservationOrdinance"]: "Soziale Erhaltungsverordnung / Milieuschutz",
		["InformationBuildingChargeRegister"]: "Auskunft Baulastenverzeichnis",
		["ExtractContaminatedSitesRegister"]: "Auszug Altlastenkataster",
		["ExtractDevelopmentAndExpansionContributions"]: "Auszug Erschließungs- und Ausbaubeiträge",
		["UrbanDevelopmentContracts"]: "Städtebauliche Verträge",
		["SoilReportOrContaminatedSites"]: "Bodengutachten bzw. Altlasten",
		["GroundLease"]: "Erbbaurecht",
		["VerificationOfExplosiveOrdnance"]: "Überprüfung der Kampfmittelbelastung",
		["OngoingLegalDisputesRegardingProperty"]: "Laufende Rechtsstreitigkeiten zum Grundstück",
		["BuildingEnergyCertificate"]: "Energieausweis",
		["SectionDrawingsBuildingElevations"]: "Schnittzeichnungen / Ansichten Gebäude",
		["FloorPlansIncludingAreaCalculation"]: "Grundrisse inkl. Flächenberechnung",
		["BuildingApplicationOrBuildingPermit"]: "Bauantrag / Baugenehmigung",
		["WarrantyGuarantees"]: "Gewährleistungsbürgschaften",
		["OverviewOfPastOngoingAndPlannedModernization"]: "Übersicht der durchgeführten, laufenden und geplanten Modernisierung",
		["InsuranceClaimsLast5Years"]: "Versicherungsschäden der letzten 5 Jahre",
		["ModernizationsOfIndividualApartments"]: "Modernisierungen der einzelnen Wohnungen",
		["DeclarationOfDivisionIfDivided"]: "Teilungserklärung (falls aufgeteilt)",
		["OngoingLegalDisputesRegardingObject"]: "Laufende Rechtsstreitigkeiten zum Objekt",
		["TenantList"]: "Mieterliste",
		["RentIncreaseLetters"]: "Mieterhöhungsschreiben",
		["RentalAgreements"]: "Mietverträge",
		["ListOfExistingRentalDeposits"]: "Aufstellung der vorhandenen Mietsicherheiten",
		["OperatingCostStatement"]: "Betriebskostenabrechnung",
		["TenantHandoverProtocols"]: "Mieterübergabeprotokolle",
		["ListOfCurrentDefectComplaintsReductionsArrears"]: "Aufstellung aktueller Mängelrügen / Minderungen / Rückstände",
		["OngoingLegalDisputesWithTenants"]: "Laufende Rechtsstreitigkeiten mit Mietern",
		["ManagementContracts"]: "Bewirtschaftungsverträge",
		["MaintenanceProtocols"]: "Wartungsprotokolle und Prüfberichte",
		["ListOfAgeOfInstallations"]: "Auflistung zum Alter der Anlagen",
		["InsurancesMainlyCurrentBuildingInsurance"]: "Versicherungen",
		["PropertyTaxAssessmentAndUnitValueNotice"]: "Grundsteuermess- & Einheitswertbescheid",
		["ListOfCraftsmen"]: "Liste der Handwerker",
		["PurchaseContractDraft"]: "Kaufvertragsentwurf",
		["AttachmentsToPurchaseContract"]: "Anlagen zum Kaufvertrag",
		["PowersOfAttorney"]: "Vertretungsvollmachten",
		["MfhExpose"]: "Exposé",
		["SuperStructures"]: "Überbauungen",
		["LandValueMap"]: "Bodenrichtwertkarte",
		["CommercialOwnerRegisterExtract"]: "Handelsregisterauszug des eingetragenen Eigentümers",
		["NeighbourhoodAgreements"]: "Nachbarschaftsverträge",
		["LandUsePlan"]: "Flächennutzungsplan",
		["OtherPermits"]: "Andere Genehmigungen",
		["OfficialCertificates"]: "Behördliche Bescheinigungen",
		["BuildingInventoryPlans"]: "Gebäude",
		["BuildingSections"]: "Schnitte",
		["BuildingStatics"]: "Statik",
		["BuildingHeating"]: "Heizung",
		["BuildingVentilation"]: "Lüftung",
		["BuildingAirConditioning"]: "Klima",
		["BuildingSanitary"]: "Sanitär",
		["BuildingElectrical"]: "Elektro",
		["FireProtection"]: "Brandschutz",
		["SpecialistPlannerContracts"]: "Fachplaner Verträge",
		["SpecialRealEstateAdditionalInformation"]: "Zusatzinformationen für Spezialimmobilien",
		["BuildingAdditonalInformation"]: "Sonstige Dokumente / Verträge / Vereinbarungen",
		["Terminations"]: "Kündigungen",
		["TaxAssessmentNotices"]: "Einheitswertbescheide/Einheitswerterklärungen",
		["TaxOtherMunicipalCharges"]: "Sonstige Kommunalabgaben",
		["TaxCorrectionBalancesAndPeriods"]: "Berichtigungsbestände und laufende Berichtigungszeiträume",
		["TaxValueAddTenants"]: "Umsatzsteuer (Mieter)",
		["TaxValueAddSellers"]: "Umsatzsteuer (Verkäufer)",
		["TaxOptionRatesAndAreaKeys"]: "Optionssätze/Flächenschlüssel",
		["CompanyOverview"]: "Übersicht",
		["CommercialRegisterExtract"]: "Handelsregisterauszug",
		["TransferOfShares"]: "Übertragung von Gesellschaftsanteilen",
		["RegisterExcerpts"]: "Registerauszüge/Anmeldungen",
		["ShareRegister"]: "Aktienbuch",
		["ListOfShareholders"]: "Gesellschafterliste",
		["ArticlesOfAssociation"]: "Satzung",
		["ArticlesOfAssociationResolutionAmmendments"]: "satzungsändernde Beschlüsse",
		["ArticlesOfAssociationResolutions"]: "Beschlüsse betreffend die Satzung",
		["DistributionOfProfitsResolutions"]: "Gewinnverteilungsbeschlüsse",
		["CapitalEndowmentResolutions"]: "Kapitalausstattungsbeschlüsse",
		["OtherResolutions"]: "Sonstige Beschlüsse",
		["ManagingDirectorResolutions"]: "Geschäftsführerbeschlüsse",
		["Minutes"]: "Protokolle",
		["AgreementsWithManagement"]: "Vereinbarungen mit der Geschäftsführung",
		["CompanyAccountant"]: "Buchhaltung",
		["CompanyAuditor"]: "Wirtschaftsprüfer",
		["CompanyTaxConsultant"]: "Steuerberater",
		["CompanyOtherContracts"]: "Sonstige Verträge",
		["LoanAgreement"]: "Dahrlehensvertrag",
		["LandChargeDeed"]: "Grundschuldbestellungsurkunde",
		["DeclarationOfSecurityPurpose"]: "Sicherungszweckerklärung",
		["DeclarationOfAssignment"]: "Abtretungserklärung",
		["Pledges"]: "Verpfändungen",
		["PurchasingTerminationDocuments"]: "Kündigungsdokumente",
		["FinancialAnnualStatements"]: "Jahresabschlüsse",
		["FinancialTaxes"]: "Steuern",
		["FinancialManagementReporting"]: "Management Reporting",
		["FinancialLiabilities"]: "(incl. off-balance sheet)  Verbindlichkeiten (inkl. off-balance)",
		["FinancialCurrentBalances"]: "Aktuelle Salden",
		["FinancialOtherInformation"]: "Sonstige Finanzinformationen",
		["FoundationReport"]: "Gründungs/Baugrundgutachten",
		["AdditionalCostsInvoice"]: "Nebenkostenabrechnung",
		["ImportantCorrespondence"]: "Wichtiger Schriftverkehr",
		["TechnicalDD"]: "Technical DD",
		["LegalDD"]: "Legal DD",
		["CommercialDD"]: "Commercial DD",
		["EnergyConsultation"]: "Energieberatung",
		["Vicinity"]: "Umfeld",
		["ZoningPlan"]: "Bebauungsplan",
		["DevelopmentPlanOrdinance"]: "Bebauungsplan-Satzung",
		["OtherPlanningLaw"]: "Sonstiges Planungsrecht",
		["ExtractLandChargeRegister"]: "Auszug Lastenverzeichnis",
		["ExtractTreeInventoryRegister"]: "Baumkatasterauszug",
		["FloodRiskMap"]: "Hochwassergefahrenkarte",
		["GroundwaterPlans"]: "Grundwasserpläne",
		["ProtectedAreaMap"]: "Schutzgebietskarte",
		["LiabilityInsuranceForBuildingAndProperty"]: "Haftpflichtversicherung Gebäude und Grundstück",
		["LiabilityInsuranceForWaterPollutionDamage"]: "Gewässerschadenhaftpflicht",
		["MaintenanceContracts"]: "Wartungsverträge",
		["PreliminaryBuildingPermit"]: "Bauvorbescheid",
		["SoilPollutantReportsAndSoilDecontaminationReceipts"]: "Schadstoffgutachten und Entsorgungnachweise",
		["ConstructionAcceptanceCertificate"]: "Schlussabnahmeschein",
		["ReportTechnicalDueDiligence"]: "Bericht technische Due Diligence",
		["PurchasingOffer"]: "Kaufpreisgebot",
		["CourtageAgreement"]: "Provisionsvereinbarung",
		["ExclusivityAgreement"]: "Exklusitivitätsvereinbarung",
		["BillingOrInvoices"]: "Abrechnung/Rechnungen",
		["InvestmentProposal"]: "Investment Proposal",
		["KYCDraft"]: "KYC-Entwurf",
		["IDSeller"]: "ID Verkäufer",
		["MFHInvestmentCaseExportableSheet"]: "MFH Investment Case Exportable Sheet"
	};
	investorPortalDocumentTranslationsOverride = {
		["SEVContractWithFee"]: "SEV-Vertrag",
		["SEVContractWithoutFee"]: "SEV-Vertrag"
	};
	translateDocument = (docType) => documentTranslationsMap[docType] ?? docType;
	documentTypeToDescriptionMap = {
		["EbicsAuthorizationLetter"]: "Authorization letter for EBICS (Electronic Banking Internet Communication Standard) system access, required for secure electronic banking transactions.",
		["PaymentOrder"]: "Official payment instruction document that authorizes the transfer of funds for property-related transactions.",
		["LoanOfferTermSheet"]: "Preliminary loan agreement document outlining the key terms and conditions for financing before final contract signing.",
		["LoanContract"]: "Legally binding agreement between lender and borrower detailing loan terms, interest rates, and repayment schedules.",
		["PortfolioInvestmentPlan"]: "Strategic document outlining investment strategy and portfolio management approach for real estate investments.",
		["PurchasingDrawdownRequest"]: "Formal request to release loan funds for property purchase, typically submitted to the lender.",
		["InvoicesDrawdownRequest"]: "Request to release loan funds specifically for covering renovation or construction invoice payments.",
		["RenovationAcceptanceReport"]: "Official documentation confirming completion and acceptance of renovation work by all parties involved.",
		["ConstructionSiteReport"]: "Regular progress report documenting construction activities, milestones, and any issues encountered during building work.",
		["GeneratedInvoiceSubscriptionInvoice"]: "Automatically generated invoice for subscription-based services related to property management.",
		["InvoiceApprovalSlip"]: "Document confirming approval of an invoice for payment processing.",
		["Invoice"]: "Standard billing document requesting payment for goods or services provided.",
		["InvoiceInPDF"]: "Standard billing document requesting payment for goods or services provided.",
		["InvoiceInXML"]: "Billing document requesting payment for goods or services provided. XML format, e-invoice",
		["InvoiceOutPDF"]: "Generated PDF document out of invoice entity",
		["SubscriptionContract"]: "Agreement for ongoing services with regular billing cycles.",
		["ProtocolArchived"]: "Historical meeting minutes and decisions from previous years, stored for legal and reference purposes.",
		["Protocol2024"]: "Official meeting minutes and resolutions from the year 2024, documenting important decisions made by property owners.",
		["Protocol2025"]: "Official meeting minutes and resolutions from the year 2025, documenting important decisions made by property owners.",
		["Protocol2026"]: "Official meeting minutes and resolutions from the year 2026, documenting important decisions made by property owners.",
		["ArchiveOfResolutions"]: "Comprehensive collection of all historical decisions and resolutions made by the property owners association.",
		["InvitationETV"]: "Invitation letter for the annual general meeting (ETV) of property owners to discuss important matters.",
		["AnnualStatement"]: "Yearly financial report showing income, expenses, and reserve fund status for the property.",
		["EconomicPlan"]: "Financial planning document outlining expected income and expenses for the upcoming year.",
		["HomeOwnerFeeStatement"]: "Detailed breakdown of individual homeowner fees and charges for the property.",
		["BuildingInsurance"]: "Insurance policy documentation covering the building against damage, fire, and other risks.",
		["EnergyCertificate"]: "Official energy efficiency rating document required by law, showing the building's energy consumption and efficiency class.",
		["PropertyTaxNotice"]: "Official tax assessment document from the municipality showing property tax obligations.",
		["ConstructionBurdenStatement"]: "Legal document listing any building restrictions or encumbrances that affect the property.",
		["AbstractOfTitle"]: "Official land registry extract showing current ownership and any liens or encumbrances on the property.",
		["DeclarationOfCondominium"]: "Legal document establishing the condominium structure and defining individual unit ownership.",
		["AmendmentToDeclarationOfDivision"]: "Legal modification to the original condominium declaration, updating ownership structure.",
		["AllowanceOfEntrySectionII"]: "Legal authorization allowing entry into Section II of the land registry for specific purposes.",
		["SeparationDeclaration"]: "Official certificate confirming that a property unit is completely separated and independently usable.",
		["PartitionPlan"]: "Detailed architectural drawings showing how the building is divided into individual units and common areas.",
		["Floorplans"]: "Architectural drawings showing the layout and dimensions of each floor in the building.",
		["ViewsAndSections"]: "Architectural drawings showing building elevations and cross-sections for construction reference.",
		["LivingSpaceCalculation"]: "Official calculation of the usable living area of a property unit according to legal standards.",
		["ConstructionDescriptionBuilding"]: "Detailed technical description of the building's construction, materials, and systems.",
		["HouseRules"]: "Set of rules and regulations governing behavior and use of common areas in the building.",
		["LandRegisterMap"]: "Official cadastral map showing the exact boundaries and location of the property.",
		["ManagementAgreement"]: "Contract between property owners and management company outlining management services and fees.",
		["SpecialAssessments"]: "Documents related to special assessments (Sonderumlagen) levied by the property owners association.",
		["Other"]: "Miscellaneous documents that don't fit into other specific categories.",
		["EstateMedia"]: "Photographs, videos, or other media files documenting the property's appearance and condition.",
		["BuildingPermit"]: "Official authorization from local authorities allowing construction or renovation work to proceed.",
		["Expose"]: "Marketing document providing detailed information about a property for sale, including photos and specifications.",
		["ExposeExternal"]: "Public marketing document for external distribution to potential buyers.",
		["ContractDraft"]: "Preliminary version of the purchase contract before notarization and final signing.",
		["ContractNotarized"]: "Legally binding purchase contract that has been officially notarized and signed by all parties.",
		["LandCharge"]: "Legal encumbrance on the property securing a loan or other financial obligation.",
		["PaymentNotice"]: "Official notification of payment due dates and amounts for property-related transactions.",
		["RegistrationNotice"]: "Document confirming registration of ownership changes or other legal matters in the land registry.",
		["NotaryCorrespondence"]: "All communication and documents exchanged with the notary during the purchase process.",
		["AdministrationCorrespondence"]: "All communication with property administration regarding management matters.",
		["NotaryRegistrationReservation"]: "Reservation of a notary appointment for contract signing and registration.",
		["SEPAMandateHomeOwnersFee"]: "Authorization for automatic electronic payment of homeowner fees through the SEPA system.",
		["PurchasingHandoverProtocol"]: "Documentation of the property handover process from seller to buyer.",
		["ProofOfPayment"]: "Receipt or bank statement confirming that a payment has been made.",
		["SellingExpose"]: "Marketing document created for selling a property, including detailed information and photos.",
		["PromotionExpose"]: "Marketing materials designed to promote and advertise a property for sale.",
		["CustomizedSellingExpose"]: "Personalized marketing document tailored to specific buyer requirements or market segments.",
		["SellingExposeSlip"]: "Summary or overview document accompanying the main selling exposé.",
		["SellingCalculations"]: "Financial calculations showing potential returns, costs, and investment analysis for buyers.",
		["SellingCalculationsSlip"]: "Summary of financial calculations for the selling process.",
		["SellingContractDraft"]: "Preliminary version of the sales contract before notarization.",
		["SellingContractSummary"]: "Summary document outlining key terms of the sales contract.",
		["SellingContractNotarized"]: "Legally binding sales contract that has been officially notarized.",
		["SellingPaymentNotice"]: "Notification of payment requirements and deadlines for the sales transaction.",
		["SellingRenovationAcceptanceProtocol"]: "Documentation of renovation work acceptance during the sales process.",
		["SellingRegistrationNotice"]: "Confirmation of registration of the sales transaction in official records.",
		["SellingNotaryCorrespondence"]: "All communication with the notary during the sales process.",
		["SellingAdministrationCorrespondence"]: "All administrative communication related to the sales process.",
		["SellingDataSheet"]: "Comprehensive data sheet with all relevant property information for potential buyers.",
		["SellingNotaryRegistrationReservation"]: "Reservation of notary appointment for sales contract signing.",
		["SellingHandoverProtocol"]: "Documentation of the property handover process during sale.",
		["SellingExpertReportWithCapEx"]: "Professional assessment report including capital expenditure analysis for the property.",
		["SellingExpertReport"]: "Professional evaluation report assessing the property's condition and value.",
		["SellingResidualValueCertificate"]: "Expert assessment of the property's remaining value after depreciation.",
		["BuildingModernizationMeasures"]: "Documentation of modernization work performed on the building.",
		["SellingExposeLocation"]: "Marketing document focusing on the property's location and neighborhood features.",
		["SellingAbstractOfTitle"]: "Land registry extract prepared specifically for the sales process.",
		["NotaryCertification"]: "Official certification from the notary confirming the legal status of documents.",
		["SellingProofOfPayment"]: "Documentation confirming receipt of payment for the sales transaction.",
		["LandRegisterParkingSpace"]: "Land registry documentation specifically for parking spaces associated with the property.",
		["BuildingAcceptancePowerOfAttorney"]: "Legal authorization allowing someone to accept building work on behalf of the owner.",
		["LocationProfile"]: "Detailed analysis of the property's location, including infrastructure, amenities, and market factors.",
		["BuildingInformationModel"]: "Digital 3D model of the building containing detailed information about construction elements and systems.",
		["FloorPlanSketch"]: "Preliminary hand-drawn or basic floor plan showing renovation planning concepts.",
		["DimensionedFloorPlan"]: "Detailed floor plan with exact measurements and dimensions of existing spaces.",
		["DimensionedFloorPlanPlanned"]: "Detailed floor plan showing planned renovations with exact measurements and dimensions.",
		["CadFile"]: "Computer-aided design file containing detailed technical drawings of the existing building.",
		["CadFilePlanned"]: "Computer-aided design file showing planned renovation work and modifications.",
		["LV"]: "Detailed specification document (Leistungsverzeichnis) listing all renovation work to be performed.",
		["LongLV"]: "Comprehensive specification document with detailed descriptions of all renovation work.",
		["Kitchen"]: "Design and specification documents for kitchen renovation or installation.",
		["KitchenContracted"]: "Contract documentation for kitchen work that has been officially awarded to a contractor.",
		["Inspection"]: "Site inspection reports documenting the condition of the property before, during, or after renovation.",
		["ConstructionContract"]: "Legally binding agreement with contractors for renovation or construction work.",
		["ContractorOffer"]: "Formal proposal from contractors for renovation work, including pricing and specifications.",
		["RevisionDocumentation"]: "Documentation of any changes or revisions made to the original renovation plans.",
		["ReportsCalculationsAppraisals"]: "Technical reports, calculations, and professional appraisals related to renovation work.",
		["ConstructionGuarantee"]: "Guarantee or warranty documentation for construction work performed.",
		["BathPlan"]: "Detailed design and specification documents for bathroom renovation or installation.",
		["StructuredLvSheet"]: "Organized specification document with structured format for easy reference.",
		["RenovationCostTrackingSheet"]: "Spreadsheet or document tracking all costs associated with renovation work.",
		["MfhConstructionPlan"]: "Construction plan document for multi-family housing renovation projects, subject to approval workflow.",
		["ConstructionDescriptionRenovation"]: "Detailed technical description of all renovation work performed on the building.",
		["PostRenovationDimensionedFloorPlan"]: "Updated floor plan showing the building layout after renovation work is completed.",
		["SalesPartnerFloorPlan"]: "Floor plan specifically designed for marketing purposes and sales partner use.",
		["LivingSpaceCalculations"]: "Updated calculation of living space after renovation work has been completed.",
		["BeforeAfterPictures"]: "Photographic documentation showing the property before and after renovation work.",
		["PostRenovationAcceptanceProtocol"]: "Official documentation confirming acceptance of completed renovation work.",
		["RoomVolumeCalculation"]: "Calculation of room volumes for heating and ventilation system design.",
		["RentContract"]: "Legally binding rental agreement between landlord and tenant outlining terms and conditions.",
		["RentIncrease"]: "Official notification of rent increase with justification and legal basis.",
		["AcceptanceProtocol"]: "Documentation of property handover between landlord and tenant, noting condition and any issues.",
		["HeatingBill"]: "Detailed billing for heating costs, typically calculated based on consumption.",
		["Correspondence"]: "General communication between property management and tenants or owners.",
		["SelfAssessmentSheet"]: "Form completed by tenants providing information about their financial situation and background.",
		["ID"]: "Copy of tenant's or owner's identification document for verification purposes.",
		["SalaryInformation"]: "Documentation of tenant's income and employment status for rental qualification.",
		["SchufaReport"]: "Credit report from Schufa (German credit agency) showing tenant's credit history.",
		["Deposit"]: "Documentation related to security deposits, including receipts and return conditions.",
		["HousingProviderConfirmation"]: "Confirmation document from previous landlord or housing provider.",
		["SEVContract"]: "Property management contract (SEV) between owner and management company.",
		["SEVContractWithFee"]: "Property management contract including management fees and service charges.",
		["SEVContractWithoutFee"]: "Property management contract without additional management fees.",
		["SEVPoA"]: "Power of attorney authorizing the management company to act on behalf of the owner.",
		["DkbInvestorVerification"]: "Verification document from DKB bank confirming investor account status.",
		["SEVCoverLetter"]: "Cover letter accompanying the SEV property management contract.",
		["GDPRTenant"]: "Data protection information and consent form for tenants under GDPR regulations.",
		["GDPROwner"]: "Data protection information and consent form for property owners under GDPR regulations.",
		["PersonalIDOwner"]: "Copy of property owner's identification document for verification purposes.",
		["SEPAManadateHouseGeld"]: "Authorization for automatic payment of property fees through the SEPA system.",
		["SEPATenant"]: "Authorization for automatic payment of rent through the SEPA system.",
		["WithdrawlInstructionTenant"]: "Instructions for tenant regarding withdrawal rights and procedures.",
		["WithdrawlInstructionOwner"]: "Instructions for property owner regarding withdrawal rights and procedures.",
		["TenantCorrespondence"]: "All communication between property management and tenants.",
		["OwnerCorrespondence"]: "All communication between property management and property owners.",
		["UtilitiesCorrespondence"]: "Communication with utility companies regarding services and billing.",
		["CancellationLease"]: "Official notice of lease termination from either landlord or tenant.",
		["CancellationLeaseConfirmation"]: "Confirmation document acknowledging receipt of lease cancellation notice.",
		["CancellationSEVContract"]: "Official notice of termination of the property management contract.",
		["CancellationSEVContractConfirmation"]: "Confirmation of property management contract termination.",
		["CondoTerminationAgreement"]: "Termination agreement (Aufhebungsvertrag) for condo units under Condo property management.",
		["LegalDisputes"]: "Legal dispute documents under property management.",
		["EstateInvestorShare"]: "Documentation showing individual investor's share in the property.",
		["EstateAggregatedInvestorShare"]: "Aggregated documentation of all investor shares in the property.",
		["WEGAnnualStatement"]: "Annual financial statement for the property owners association (WEG).",
		["InvoicesPropertyManagement"]: "All invoices related to property management services and expenses.",
		["EstateRentReport"]: "Report documenting rental income and occupancy status of the property.",
		["CorrespondencePropertyManagement"]: "All correspondence related to property management activities.",
		["SalutationWEG"]: "Cover letter or introduction document for WEG (property owners association) communications.",
		["InvestorPayout"]: "Documentation of profit distribution to property investors.",
		["InvestorYearlyPayout"]: "Annual profit distribution documentation for property investors.",
		["InvestorYearlyPayoutLegacy"]: "Legacy format of annual profit distribution documentation.",
		["RentArrearNotice"]: "Official notice to tenant regarding overdue rent payments.",
		["RentGuarantee"]: "Guarantee or insurance documentation covering rental income.",
		["DunningNotice"]: "Official warning notice regarding overdue payments, typically the first step in debt collection.",
		["EnforcementNotice"]: "Legal enforcement document for collecting overdue payments through court procedures.",
		["BKAAllocationCalculation"]: "Ownership change cost apportionment.",
		["BKAHeatingStatement"]: "Heating cost allocation statement based on degree days calculation.",
		["BKAStatement"]: "Yearly breakdown of operating costs and service charges for tenants.",
		["BKAHouseholdCosts"]: "Household-related costs breakdown.",
		["BKADeposit"]: "Tenant deposit reconciliation for annual service charge settlement.",
		["SelfDeclarationTenant"]: "Form completed by prospective tenants declaring their financial and personal information.",
		["QuestionnaireTenant"]: "Questionnaire completed by prospective tenants providing additional information for rental qualification.",
		["RentalContractDraft"]: "Preliminary version of the rental agreement before final signing.",
		["SalaryRecordPropesctiveTenant"]: "Documentation of prospective tenant's income and employment status.",
		["SchufaProspectiveTenant"]: "Credit report for prospective tenant from German credit agency.",
		["AnnualServiceChargeCalculation"]: "Calculation of expected service charges for the upcoming year.",
		["PersonalIDProspectiveTenant"]: "Copy of prospective tenant's identification document.",
		["Safe"]: "Documentation related to safe installation or access in the property.",
		["Estate"]: "General documentation about the property unit itself.",
		["BasementRoom"]: "Documentation specific to basement storage rooms or spaces.",
		["AtticRoom"]: "Documentation specific to attic storage rooms or spaces.",
		["CommonRoom"]: "Documentation related to shared common areas in the building.",
		["Parking"]: "Documentation related to parking spaces associated with the property.",
		["FurniturePlanPdf"]: "Furniture layout plan in PDF format showing placement of furniture and fittings.",
		["FurniturePlanDwg"]: "Furniture layout plan in CAD format for technical specifications.",
		["RequestedOrderLists"]: "Lists of furniture and fittings requested by tenants or owners.",
		["ContractedOrderLists"]: "Lists of furniture and fittings that have been officially ordered and contracted.",
		["PartnerBrochure"]: "Marketing brochure from furniture or service partners.",
		["InvoicesFittings"]: "Invoices for furniture, fittings, and interior items.",
		["InvoicesServiceProvider"]: "Invoices from service providers for various property-related services.",
		["Internet"]: "Documentation related to internet service installation and contracts.",
		["LivingsAcceptanceProtocol"]: "Documentation of acceptance of furnished apartments or living spaces.",
		["PortfolioInspectionSheet"]: "Standardized form for inspecting and documenting portfolio properties.",
		["CreditLineCashflowPredictions"]: "Financial projections showing expected cash flow from credit lines.",
		["CreditLineBudgetCosts"]: "Budget documentation for costs associated with credit line management.",
		["EstateInvestorCashflow"]: "Detailed cash flow analysis showing income and expenses for property investors.",
		["SalesPackageFinalSheet"]: "Final comprehensive document package prepared for property sales.",
		["SalesPackageDataSheet"]: "Data sheet containing all relevant property information for sales package.",
		["SalesPackageNotarySheet"]: "Documentation prepared specifically for notary review during sales process.",
		["SalesPackageChecklist"]: "Checklist ensuring all required documents are included in the sales package.",
		["SalesPackageSellingCompanies"]: "Documentation related to companies involved in the selling process.",
		["PurchasingDocumentsSheet"]: "Comprehensive sheet containing all documents related to property purchase.",
		["SellingDocumentsSheet"]: "Comprehensive sheet containing all documents related to property sale.",
		["SellingDataChecklist"]: "Checklist ensuring all required data is included for the selling process.",
		["SellingEstatesDataSheet"]: "Data sheet containing information about multiple estates being sold.",
		["CashflowStatementSheet"]: "Detailed statement showing cash flow for property investments.",
		["InvestorPaymentSlip"]: "Documentation of individual payments made to property investors.",
		["InvestorPayoutStatement"]: "Statement showing payout amounts and calculations for property investors.",
		["DefectReport"]: "Report documenting any defects or issues found in the property.",
		["SalesPackageUserUploadedPriceList"]: "Price list uploaded by users for inclusion in sales package.",
		["SalesPackageUserUploadedDataSheet"]: "Data sheet uploaded by users for inclusion in sales package.",
		["SalesPackageUserUploadedChecklist"]: "Checklist uploaded by users for inclusion in sales package.",
		["SalesPackageUserUploadedPhotoAlbum"]: "Photo album uploaded by users for inclusion in sales package.",
		["SellingRegionBrochure"]: "Marketing brochure focusing on the region where properties are being sold.",
		["TransferRecurrentPaymentsSEPAXmlList"]: "XML file containing SEPA payment instructions for recurring transfers.",
		["CondoSellingPresentation"]: "Presentation materials for selling condominium properties.",
		["SalesPartnerFlyer"]: "Marketing flyer from sales partners promoting properties.",
		["PropertyManagementOwnerBrochure"]: "Brochure explaining property management services to owners.",
		["ModelPurchaseContract"]: "Template or model purchase contract for reference and use.",
		["ModelRentalContract"]: "Template or model rental contract for reference and use.",
		["ModelPropertyManagementContractWithFee"]: "Template property management contract including fee structure.",
		["ModelPropertyManagementLawOfAttorney"]: "Template power of attorney for property management purposes.",
		["ModelPropertyManagementGDPR"]: "Template GDPR compliance documents for property management.",
		["CurrentLandRegisterExtract"]: "Up-to-date extract from the land registry showing current ownership and encumbrances.",
		["EncumbranceBasisInDeptII"]: "Documentation of legal encumbrances listed in Section II of the land registry.",
		["CurrentParcelMap"]: "Current cadastral map showing the exact boundaries of the land parcel.",
		["CurrentPlanningRights"]: "Documentation of current zoning and planning rights affecting the property.",
		["InformationUrbanRenewalArea"]: "Information about whether the property is located in an urban renewal area.",
		["InformationUrbanConservationArea"]: "Information about whether the property is in an urban conservation area.",
		["InformationMonumentProtection"]: "Information about whether the property is under monument protection.",
		["SocialPreservationOrdinance"]: "Information about social preservation ordinances affecting the property.",
		["InformationBuildingChargeRegister"]: "Information from the building charge register about any building restrictions.",
		["ExtractContaminatedSitesRegister"]: "Extract from the contaminated sites register showing environmental status.",
		["ExtractDevelopmentAndExpansionContributions"]: "Information about development and expansion contributions required.",
		["UrbanDevelopmentContracts"]: "Contracts related to urban development agreements affecting the property.",
		["SoilReportOrContaminatedSites"]: "Geological report or information about contaminated sites on the property.",
		["GroundLease"]: "Lease agreement for the land underlying the building (Erbbaurecht).",
		["VerificationOfExplosiveOrdnance"]: "Report verifying whether the property is free from explosive ordnance.",
		["OngoingLegalDisputesRegardingProperty"]: "Documentation of any ongoing legal disputes affecting the property.",
		["SuperStructures"]: "Documentation of any structures built above the main building.",
		["LandValueMap"]: "Map showing land values in the area for assessment purposes.",
		["CommercialOwnerRegisterExtract"]: "Extract from the commercial register for the property owner.",
		["NeighbourhoodAgreements"]: "Agreements with neighboring properties or landowners.",
		["LandUsePlan"]: "Official land use plan showing zoning and permitted uses.",
		["OfficialCertificates"]: "Various official certificates from government authorities.",
		["FoundationReport"]: "Geotechnical report about the building foundation and soil conditions.",
		["BuildingEnergyCertificate"]: "Energy efficiency certificate for the building showing consumption and efficiency rating.",
		["SectionDrawingsBuildingElevations"]: "Technical drawings showing building cross-sections and elevations.",
		["FloorPlansIncludingAreaCalculation"]: "Floor plans with detailed area calculations for each space.",
		["BuildingApplicationOrBuildingPermit"]: "Building permit application or the actual building permit.",
		["WarrantyGuarantees"]: "Warranty and guarantee documentation for building work and systems.",
		["OverviewOfPastOngoingAndPlannedModernization"]: "Comprehensive overview of all modernization work past, present, and planned.",
		["InsuranceClaimsLast5Years"]: "Documentation of insurance claims made in the last 5 years.",
		["ModernizationsOfIndividualApartments"]: "Documentation of modernization work performed on individual apartments.",
		["DeclarationOfDivisionIfDivided"]: "Declaration of division if the building has been subdivided.",
		["OngoingLegalDisputesRegardingObject"]: "Documentation of ongoing legal disputes related to the building itself.",
		["BuildingInventoryPlans"]: "Plans showing the current inventory and condition of building systems.",
		["BuildingSections"]: "Technical drawings showing building sections and structural details.",
		["BuildingStatics"]: "Structural engineering documentation and calculations.",
		["BuildingHeating"]: "Documentation of heating systems and equipment.",
		["BuildingVentilation"]: "Documentation of ventilation systems and equipment.",
		["BuildingAirConditioning"]: "Documentation of air conditioning systems and equipment.",
		["BuildingSanitary"]: "Documentation of sanitary systems and plumbing.",
		["BuildingElectrical"]: "Documentation of electrical systems and installations.",
		["FireProtection"]: "Documentation of fire protection systems and safety measures.",
		["SpecialistPlannerContracts"]: "Contracts with specialist planners for various building systems.",
		["SpecialRealEstateAdditionalInformation"]: "Additional information specific to special types of real estate.",
		["BuildingAdditonalInformation"]: "Additional information about the building not covered in other categories.",
		["OtherPermits"]: "Various permits required for building operation or modifications.",
		["TenantList"]: "List of all current tenants in the building with contact information.",
		["RentIncreaseLetters"]: "Letters sent to tenants notifying them of rent increases.",
		["RentalAgreements"]: "All rental agreements for units in the building.",
		["ListOfExistingRentalDeposits"]: "List of all rental deposits currently held for tenants.",
		["OperatingCostStatement"]: "Statement of operating costs for the building.",
		["TenantHandoverProtocols"]: "Protocols documenting the handover process between tenants.",
		["ListOfCurrentDefectComplaintsReductionsArrears"]: "List of current defect complaints, rent reductions, and payment arrears.",
		["OngoingLegalDisputesWithTenants"]: "Documentation of ongoing legal disputes with tenants.",
		["Terminations"]: "Documentation of lease terminations and related correspondence.",
		["ImportantCorrespondence"]: "Important correspondence related to tenant and building management.",
		["AdditionalCostsInvoice"]: "Invoices for additional costs beyond basic rent.",
		["ManagementContracts"]: "Contracts with property management companies.",
		["MaintenanceProtocols"]: "Protocols documenting maintenance work and inspections.",
		["ListOfAgeOfInstallations"]: "List showing the age and condition of building installations.",
		["InsurancesMainlyCurrentBuildingInsurance"]: "Insurance documentation, primarily current building insurance.",
		["PropertyTaxAssessmentAndUnitValueNotice"]: "Property tax assessment and unit value determination.",
		["ListOfCraftsmen"]: "List of craftsmen and service providers used for the building.",
		["PurchaseContractDraft"]: "Draft version of the purchase contract for the building.",
		["AttachmentsToPurchaseContract"]: "All attachments and appendices to the purchase contract.",
		["PowersOfAttorney"]: "Powers of attorney related to the purchase transaction.",
		["LoanAgreement"]: "Loan agreement for financing the building purchase.",
		["LandChargeDeed"]: "Deed establishing land charges for financing.",
		["DeclarationOfSecurityPurpose"]: "Declaration explaining the purpose of security arrangements.",
		["DeclarationOfAssignment"]: "Declaration assigning rights or claims to third parties.",
		["Pledges"]: "Documentation of pledges and security arrangements.",
		["PurchasingTerminationDocuments"]: "Documents related to termination of purchase agreements.",
		["PurchasingOffer"]: "Offer made for purchasing the building.",
		["CourtageAgreement"]: "Agreement with real estate agents regarding commission.",
		["ExclusivityAgreement"]: "Agreement granting exclusive rights for property sale.",
		["MfhExpose"]: "Marketing exposé specifically for multi-family housing (MFH) properties.",
		["InvestmentProposal"]: "Proposal document outlining investment opportunities in the property.",
		["TaxAssessmentNotices"]: "Official tax assessment notices for the property.",
		["TaxOtherMunicipalCharges"]: "Other municipal charges and taxes affecting the property.",
		["TaxCorrectionBalancesAndPeriods"]: "Tax correction balances and adjustment periods.",
		["TaxValueAddTenants"]: "Value-added tax information related to tenants.",
		["TaxValueAddSellers"]: "Value-added tax information related to sellers.",
		["TaxOptionRatesAndAreaKeys"]: "Tax option rates and area calculation keys.",
		["CompanyOverview"]: "Overview of the company structure and organization.",
		["CommercialRegisterExtract"]: "Extract from the commercial register for the company.",
		["TransferOfShares"]: "Documentation of share transfers in the company.",
		["RegisterExcerpts"]: "Excerpts from various official registers.",
		["ShareRegister"]: "Register of company shares and shareholders.",
		["ListOfShareholders"]: "List of all shareholders in the company.",
		["ArticlesOfAssociation"]: "Company articles of association and bylaws.",
		["ArticlesOfAssociationResolutionAmmendments"]: "Resolutions amending the articles of association.",
		["ArticlesOfAssociationResolutions"]: "Resolutions related to the articles of association.",
		["DistributionOfProfitsResolutions"]: "Resolutions regarding profit distribution.",
		["CapitalEndowmentResolutions"]: "Resolutions regarding capital contributions.",
		["OtherResolutions"]: "Other company resolutions not covered in other categories.",
		["ManagingDirectorResolutions"]: "Resolutions made by the managing director.",
		["Minutes"]: "Minutes of company meetings and decisions.",
		["AgreementsWithManagement"]: "Agreements with company management.",
		["CompanyAccountant"]: "Contracts and agreements with the company accountant.",
		["CompanyAuditor"]: "Contracts and agreements with the company auditor.",
		["CompanyTaxConsultant"]: "Contracts and agreements with the company tax consultant.",
		["CompanyOtherContracts"]: "Other contracts related to company operations.",
		["FinancialAnnualStatements"]: "Annual financial statements for the company.",
		["FinancialTaxes"]: "Tax documentation and returns for the company.",
		["FinancialManagementReporting"]: "Management reporting and financial analysis.",
		["FinancialLiabilities"]: "Documentation of financial liabilities and obligations.",
		["FinancialCurrentBalances"]: "Current financial balances and account statements.",
		["FinancialOtherInformation"]: "Other financial information and documentation.",
		["DueDiligenceOnSiteInspection"]: "On-site inspection report as part of due diligence process.",
		["TechnicalDD"]: "Technical due diligence report assessing building condition and systems.",
		["LegalDD"]: "Legal due diligence report assessing legal status and compliance.",
		["CommercialDD"]: "Commercial due diligence report assessing market and financial aspects.",
		["EnergyConsultation"]: "Energy consultation report and recommendations.",
		["Vicinity"]: "Analysis of the property's vicinity and neighborhood.",
		["ZoningPlan"]: "Zoning / development plan (Bebauungsplan) for the property area.",
		["DevelopmentPlanOrdinance"]: "Development plan ordinance (Bebauungsplan-Satzung) governing permitted use and construction.",
		["OtherPlanningLaw"]: "Other planning-law documents not covered by zoning or development-plan ordinance.",
		["ExtractLandChargeRegister"]: "Extract from the land charge / encumbrance register (Lastenverzeichnis).",
		["ExtractTreeInventoryRegister"]: "Extract from the official tree inventory register (Baumkataster).",
		["FloodRiskMap"]: "Official flood risk / flood hazard map for the property location.",
		["GroundwaterPlans"]: "Groundwater plans and related hydrogeological documentation.",
		["ProtectedAreaMap"]: "Map of protected areas affecting the property (nature, water, or similar).",
		["LiabilityInsuranceForBuildingAndProperty"]: "Liability insurance covering the building and property.",
		["LiabilityInsuranceForWaterPollutionDamage"]: "Liability insurance for water pollution / Gewässerschadenhaftpflicht.",
		["MaintenanceContracts"]: "Maintenance contracts for building systems and installations.",
		["PreliminaryBuildingPermit"]: "Preliminary building permit / Bauvorbescheid from the authority.",
		["SoilPollutantReportsAndSoilDecontaminationReceipts"]: "Soil pollutant reports and receipts documenting soil decontamination or disposal.",
		["ConstructionAcceptanceCertificate"]: "Official construction acceptance certificate (Schlussabnahmeschein) from the authority.",
		["ReportTechnicalDueDiligence"]: "Technical due diligence report covering building condition, systems, and CAPEX.",
		["BillingOrInvoices"]: "Billing documentation and invoices for various services.",
		["KYCDraft"]: "Draft Know Your Customer documentation for compliance purposes.",
		["IDSeller"]: "Identification documents for the property seller.",
		["MFHSummary"]: "Summary document providing overview of the multi-family housing property.",
		["AssetPipelineSheet"]: "Documentation tracking the property in the investment pipeline.",
		["ExternalInvoiceExport"]: "Export of invoices for external processing or analysis.",
		["AssetTenderingProcess"]: "Tendering process tendering form.",
		["MFHInvestmentCaseExportableSheet"]: "Reviewed and approved Excel export of MFH investment case for external sharing with asset partners.",
		["AddendumContractDraft"]: "Draft version of the addendum contract for the renovation project.",
		["AddendumContract"]: "Final version of the addendum contract for the renovation project.",
		["Auftragsempfehlung"]: "Recommendation for the renovation project.",
		["Entscheidungsvorlage"]: "Decision template for the renovation project.",
		["Werkvertrag"]: "Contract for the renovation project.",
		["Planervertrag"]: "Plan contract for the renovation project."
	};
	translateDocumentCategory = (category) => documentCategoryTranslationsMap[category] ?? category;
}));
//#endregion
//#region src/domains/cross-cutting/document/document.helpers.ts
/**
* Validates a filename against the naming convention rules
*/
function validateDocumentName(filename, options = {
	checkForSpaces: true,
	allowDashes: true,
	asciiOnly: false
}) {
	const nameWithoutExtension = filename.includes(".") ? filename.substring(0, filename.lastIndexOf(".")) : filename;
	if (options.checkForSpaces && nameWithoutExtension.includes(" ")) return {
		isValid: false,
		errorMessage: `Filename cannot contain spaces.${options.allowDashes ? ` Use dashes (-) instead.` : ""}`
	};
	if (new RegExp(`[()~!@#$%^&*+=|\\[\\]{};:"'<>,.?/${options.allowDashes ? "" : "-"}]`).test(nameWithoutExtension)) return {
		isValid: false,
		errorMessage: `Filename cannot contain special characters except ${options.allowDashes ? `'-' and ` : ""}'_'.`
	};
	if (options.asciiOnly && !/^[\u0000-\u007F]*$/.test(nameWithoutExtension)) return {
		isValid: false,
		errorMessage: "Filename must contain only latin characters without umlauts."
	};
	const parts = nameWithoutExtension.split("_");
	if (parts.length < 3 || parts.length > 6) return {
		isValid: false,
		errorMessage: "Filename must follow the naming convention."
	};
	if (options.allowDashes) {
		const dashedPart = parts.find((part) => /(?:^-|-$)/.test(part));
		if (dashedPart) return {
			isValid: false,
			errorMessage: `Part ${dashedPart} cannot start or end with a dash (-).`
		};
	}
	const docType = parts.shift();
	const normalizedDocType = docType?.normalize("NFC").toLocaleLowerCase();
	if (normalizedDocType && !validDocTypesDeburredNormalized.includes(normalizedDocType)) return {
		isValid: false,
		errorMessage: `Invalid document type: ${docType}.`
	};
	if (parts.length < 4) return validateNonObjectRelatedDocument(parts);
	return validateObjectRelatedDocument(parts);
}
/**
* Validates an object-related document filename (part without document type)
* Format: CityCode_Street_Content_YYYYMMDD[_suffix]
* Example: BE_Steglitzer-Damm-19_Mustermann_20250401
*/
function validateObjectRelatedDocument(parts) {
	const [cityCode, street, content, date, suffix] = parts;
	if (!/^[A-ZÄÖÜ]{1,3}$/.test(cityCode)) return {
		isValid: false,
		errorMessage: `Doesn't look like city/state code: ${cityCode}.`
	};
	if (street.length === 0) return {
		isValid: false,
		errorMessage: "Street cannot be empty."
	};
	if (content.length === 0) return {
		isValid: false,
		errorMessage: "Content cannot be empty."
	};
	if (suffix !== void 0) {
		if (suffix.length === 0) return {
			isValid: false,
			errorMessage: "Suffix cannot be empty."
		};
	}
	return validateDate(date);
}
/**
* Validates a non-object-related document filename (part without document type)
* Format: Content_YYYYMMDD[_suffix]
* Example: Plus1GrundbesitzSarl_20240101_v01
*/
function validateNonObjectRelatedDocument(parts) {
	const [content, date, suffix] = parts;
	if (content.length === 0) return {
		isValid: false,
		errorMessage: "Content cannot be empty."
	};
	if (suffix) {
		if (suffix.length === 0) return {
			isValid: false,
			errorMessage: "Suffix cannot be empty."
		};
	}
	return validateDate(date);
}
function validateDate(dateString) {
	if (!/^(?:\d{8}|x{8}|x{6})$/i.test(dateString)) return {
		isValid: false,
		errorMessage: `Part "${dateString}" doesn't look like a valid date. Use YYYYMMDD or 'xxxxxxxx' for missing dates.`
	};
	return { isValid: true };
}
var docTypesEng, docTypesGer, validDocTypes, validDocTypesDeburredNormalized, protectedDocumentFolderPaths, normalizeDocumentFolderPath, isProtectedDocumentFolderPath, generateDocumentFileName, documentTypeToCategory, getDriveId;
var init_document_helpers = __esmMin((() => {
	init_estate_helpers();
	init_document_i18n();
	init_document_model();
	docTypesEng = Object.keys(documentTranslationsMap);
	docTypesGer = Object.values(documentTranslationsMap);
	validDocTypes = [
		...docTypesEng.map((type) => type.replace(/[^0-9a-zäöüß\s]/gi, "").replace(/\s+/g, "-")),
		...docTypesGer.map((type) => type.replace(/[^0-9a-zäöüß\s]/gi, "").replace(/\s+/g, "-")),
		...docTypesEng.map((type) => type.replace(/[^0-9a-zäöüß]+/gi, "")),
		...docTypesGer.map((type) => type.replace(/[^0-9a-zäöüß]+/gi, ""))
	];
	validDocTypesDeburredNormalized = [...validDocTypes, ...validDocTypes.map((type) => deburr(type))].map((type) => type.normalize("NFC").toLocaleLowerCase());
	protectedDocumentFolderPaths = ["Approval Envelopes/"];
	normalizeDocumentFolderPath = (folderPath) => {
		const normalizedPath = folderPath.split("/").map((part) => part.trim()).filter(Boolean).join("/");
		return normalizedPath ? `${normalizedPath}/` : "";
	};
	isProtectedDocumentFolderPath = (folderPath) => {
		if (!folderPath) return false;
		const normalizedPath = normalizeDocumentFolderPath(folderPath);
		return protectedDocumentFolderPaths.some((protectedPath) => normalizedPath.startsWith(normalizeDocumentFolderPath(protectedPath)));
	};
	generateDocumentFileName = (estate, document) => {
		const estateFolderName = generateEstateFolderName(estate);
		if (document.filename.startsWith(estateFolderName)) return document.filename;
		const filenameParts = document.filename.split(".");
		const ext = filenameParts.length === 2 ? `.${filenameParts[1]}` : "";
		const filename = filenameParts.length === 2 ? filenameParts[0] : document.filename;
		const fileNameWithoutUUid = estate.condoUuid ? filename.replace(`#${estate.condoUuid}`, "").replace(estate.condoUuid, "").split("_").filter((p) => p.length > 0).join("_") : filename;
		return `${generateEstateFolderName(estate)}_${fileNameWithoutUUid}${ext}`;
	};
	documentTypeToCategory = (docType) => {
		if (docType === "Other") return "General";
		const categoryTypeMap = {
			...documentCategoryMap,
			["Renovation"]: [...documentCategoryMap["Renovation"], "ConstructionSiteReport"]
		};
		const [documentCategory] = Object.entries(categoryTypeMap).find(([, types]) => types.includes(docType)) ?? ["General"];
		return documentCategory;
	};
	getDriveId = (document) => {
		const viewRegex = /\/d\/([^/]+)\/view/;
		const openRegex = /open\?id=([^&]+)/;
		let match = document.path.match(viewRegex) || document.path.match(openRegex);
		let driveId = null;
		if (match) driveId = match[1];
		else {
			match = document.link.match(viewRegex) || document.link.match(openRegex);
			if (match) driveId = match[1];
		}
		return driveId;
	};
}));
//#endregion
//#region src/domains/cross-cutting/document/document.opts.ts
var init_document_opts = __esmMin((() => {}));
//#endregion
//#region src/__unsorted/base.ts
var VAT, CondoFileSchema, condoFileSlug, BaseClassAttributes, BaseEntity, EntityType, EntityTableName;
var init_base = __esmMin((() => {
	VAT = 1.19;
	CondoFileSchema = Type.Object({
		name: Type.Optional(Type.String()),
		fileBuffer: Type.Optional(Type.Any()),
		hash: Type.Optional(Type.String()),
		byteLength: Type.Optional(Type.Number()),
		uuid: Type.String(),
		path: Type.String(),
		link: Type.String(),
		mimeType: Type.String(),
		size: Type.Optional(Type.Number())
	}, { $id: "CondoFile" });
	condoFileSlug = (fileName, fileRelations) => {
		if (!fileRelations) return crypto.randomUUID();
		if (fileRelations.mfhId) {
			const cleanFileName = fileName ? deburr(fileName).replace(/[/\\]/g, "_") : null;
			return `mfhs/${fileRelations.mfhId}/${cleanFileName ?? crypto.randomUUID()}`;
		}
		return crypto.randomUUID();
	};
	BaseClassAttributes = class {
		createdAt;
		updatedAt;
		constructor(props) {
			Object.assign(this, props);
		}
	};
	BaseEntity = class extends BaseClassAttributes {};
	EntityType = /* @__PURE__ */ function(EntityType) {
		EntityType["User"] = "user";
		EntityType["ImageSet"] = "image-set";
		EntityType["Defect"] = "defect";
		EntityType["Estate"] = "estate";
		EntityType["MfhBuilding"] = "mfh-building";
		EntityType["Mfh"] = "mfh";
		EntityType["MfhPortfolio"] = "mfh-portfolio";
		EntityType["PreprocessedEstate"] = "preprocessed-estate";
		EntityType["SourcingEstate"] = "sourcing-estate";
		EntityType["DiscovererEstate"] = "discoverer-estate";
		EntityType["SourcingProcess"] = "sourcing-process";
		EntityType["PurchasingProcess"] = "purchasing-process";
		EntityType["RenovationProcess"] = "renovation-process";
		EntityType["RentingProcess"] = "renting-process";
		EntityType["SellingProcess"] = "selling-process";
		EntityType["PropertyManagementProcess"] = "property-management-process";
		EntityType["ConstructionProgress"] = "construction-progress";
		EntityType["CalendarEvent"] = "calendar-event";
		EntityType["Company"] = "company";
		EntityType["ConstructionPlan"] = "construction-plan";
		EntityType["PredictionResult"] = "prediction-result";
		EntityType["InvestmentCase"] = "investment-case";
		EntityType["Contact"] = "contact";
		/** @deprecated  Use ContactPersonRelation */
		EntityType["UserRelation"] = "user-relation";
		EntityType["ContactPersonRelation"] = "contact-person-relation";
		EntityType["Invoice"] = "invoice";
		EntityType["EbicsOrder"] = "ebics-order";
		EntityType["BankOwnerAccount"] = "bank-owner-account";
		EntityType["BankStatement"] = "bank-statement";
		EntityType["ReviewProcess"] = "review-process";
		EntityType["ReviewRequest"] = "review-request";
		EntityType["Task"] = "task";
		EntityType["Note"] = "note";
		EntityType["SignOffEnvelope"] = "sign-off-envelope";
		EntityType["SignOffDocument"] = "sign-off-document";
		EntityType["SignOffComment"] = "sign-off-comment";
		EntityType["SignOffTemplate"] = "sign-off-template";
		EntityType["SignOffDocumentSignature"] = "sign-off-document-signature";
		EntityType["SignOffDocumentApproval"] = "sign-off-document-approval";
		return EntityType;
	}({});
	EntityTableName = /* @__PURE__ */ function(EntityTableName) {
		EntityTableName["Estate"] = "estate";
		EntityTableName["RentingListing"] = "renting_listings";
		EntityTableName["Company"] = "company";
		EntityTableName["Contact"] = "contact";
		EntityTableName["InvestmentCase"] = "investment_case";
		EntityTableName["PurchasingProcess"] = "purchasing_process";
		EntityTableName["RenovationProcess"] = "renovation_process";
		EntityTableName["SellingProcess"] = "selling_process";
		EntityTableName["SourcingProcess"] = "sourcing_process";
		EntityTableName["RentingProcess"] = "renting_process";
		EntityTableName["PropertyManagementProcess"] = "property_management_process";
		EntityTableName["Portfolio"] = "portfolio";
		EntityTableName["DocumentInspection"] = "document_inspection";
		EntityTableName["Invoice"] = "invoice";
		EntityTableName["ConstructionPlan"] = "construction_plan";
		EntityTableName["RenovationInspection"] = "renovation_inspection";
		EntityTableName["ReviewRequest"] = "review_request";
		EntityTableName["Defect"] = "defect";
		EntityTableName["Mfh"] = "mfh";
		EntityTableName["DdQuestion"] = "dd_question";
		EntityTableName["MfhInvestmentCase"] = "mfh_investment_case";
		EntityTableName["RentTenancy"] = "rent_tenancy";
		EntityTableName["InvestorInfo"] = "investor_info";
		EntityTableName["MfhPortfolio"] = "mfh_portfolio";
		EntityTableName["RentableUnitProcess"] = "rentable_unit_process";
		EntityTableName["TenantManagementProcess"] = "tenant_management_process";
		EntityTableName["OwnerManagementProcess"] = "owner_management_process";
		EntityTableName["EstateManagementProcess"] = "estate_management_process";
		EntityTableName["MfhSourcingProcess"] = "mfh_sourcing_process";
		EntityTableName["MfhPortfolioFinancingProcess"] = "mfh_portfolio_financing_process";
		EntityTableName["MfhPortfolioPurchasingProcess"] = "mfh_portfolio_purchasing_process";
		EntityTableName["MfhSubsidyFinancingProcess"] = "mfh_subsidy_financing_process";
		EntityTableName["MfhEstateManagementProcess"] = "mfh_estate_management_process";
		EntityTableName["MfhRenovationProject"] = "mfh_renovation_project";
		EntityTableName["MfhRenovationProjectPosition"] = "mfh_renovation_project_position";
		EntityTableName["MfhRenovationProjectPlanningModule"] = "mfh_renovation_project_planning_module";
		EntityTableName["MfhRenovationProjectLot"] = "mfh_renovation_project_lot";
		EntityTableName["SalesPackage"] = "sales_package";
		EntityTableName["Inspection"] = "inspection";
		EntityTableName["PaymentNoticeSummary"] = "payment_notice_summary";
		EntityTableName["CatalogueItem"] = "catalogue_item";
		EntityTableName["RentalContract"] = "rental_contract";
		EntityTableName["ServiceChargeStatement"] = "annual_service_charge_statement";
		EntityTableName["MfhBuilding"] = "mfh_building";
		EntityTableName["MonthlyInvestorShare"] = "monthly_investor_share";
		EntityTableName["RentRollVersion"] = "rent_roll_version";
		EntityTableName["Task"] = "task";
		EntityTableName["MFHProjectPlanActivity"] = "mfh_project_plan_activity";
		EntityTableName["Addendum"] = "Addendum";
		EntityTableName["Contract"] = "contract";
		EntityTableName["MfhConstructionPlan"] = "mfh_construction_plan";
		EntityTableName["MfhConstructionPlanVersion"] = "mfh_construction_plan_version";
		EntityTableName["MfhConstructionPlanApproval"] = "mfh_construction_plan_approval";
		return EntityTableName;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/document/document.schema.ts
var DocumentCategorySchema, DocumentTypeSchema, BaseDocumentSchema, documentSchemas;
var init_document_schema = __esmMin((() => {
	init_base();
	init_shared_schemas();
	init_document_annotation_transfer_model();
	init_document_model();
	DocumentCategorySchema = TEnum(DocumentCategory, { $id: "DocumentCategory" });
	DocumentTypeSchema = TEnum(DocumentType, { $id: "DocumentType" });
	BaseDocumentSchema = Type.Intersect([Type.Intersect([BaseCreatedDeletedAttributesSchema, CondoFileSchema]), Type.Object({
		documentId: Type.Number(),
		documentCategory: Type.Optional(Type.Ref(DocumentCategorySchema)),
		documentType: Type.Ref(DocumentTypeSchema),
		source: Type.Optional(Type.String()),
		filename: Type.String(),
		userId: Type.Optional(Type.String()),
		folderId: Type.Optional(TNullable(Type.Number())),
		createdByUserId: Type.Optional(TNullable(Type.String())),
		isExternalLink: Type.Optional(Type.Boolean()),
		documentAnnotations: Type.Optional(TNullable(Type.Array(DocumentAnnotationTransferItemSchema)))
	})], { $id: "BaseDocument" });
	documentSchemas = {
		BaseDocumentSchema,
		DocumentCategorySchema,
		DocumentTypeSchema
	};
}));
//#endregion
//#region src/domains/cross-cutting/document/folder.model.ts
var init_folder_model = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/document/folder.request.ts
var init_folder_request = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/document/request.ts
var init_request$2 = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/document/index.ts
var init_document = __esmMin((() => {
	init_document_annotation_transfer_model();
	init_document_annotation_transfer_helpers();
	init_document_annotations_request();
	init_data_room_model();
	init_document_generation_model();
	init_document_process_model();
	init_document_helpers();
	init_document_i18n();
	init_document_model();
	init_document_opts();
	init_document_schema();
	init_folder_model();
	init_folder_request();
	init_request$2();
}));
//#endregion
//#region src/domains/finance/sales-package/sales-package.model.ts
var SalesPackageEligibleEstateSellingStates, SalesPackageEligibleEstatePurchasingStates, SalesPackageExludedEstatePurchasingStates, SalesPackageState, ExclusiveOrHybridSalesPackageUpdatableStates, SalesPackageRemoveEstateAllowedStates, SalesPackageExport, SalesPackageEvents, lastThreeYearsDocProtocolTypes, NotariatDocumentTypes, SalesPackageDocumentChecklist, SalesPackageExportMode, SalesPackageExportFolders;
var init_sales_package_model = __esmMin((() => {
	init_document();
	init_processes();
	SalesPackageEligibleEstateSellingStates = [
		"Identified",
		"Prepared",
		"OnOpenMarket"
	];
	SalesPackageEligibleEstatePurchasingStates = [
		"Completed",
		"FmReceived",
		"Paid",
		"HandoverDone",
		"KeysHandedOver"
	];
	SalesPackageExludedEstatePurchasingStates = ["OfferRejected"];
	SalesPackageState = /* @__PURE__ */ function(SalesPackageState) {
		SalesPackageState["Draft"] = "Draft";
		SalesPackageState["Review"] = "Review";
		SalesPackageState["Approved"] = "Approved";
		SalesPackageState["Rejected"] = "Rejected";
		SalesPackageState["Prepared"] = "Prepared";
		SalesPackageState["Active"] = "Active";
		SalesPackageState["Sold"] = "Sold";
		SalesPackageState["Closed"] = "Closed";
		return SalesPackageState;
	}({});
	ExclusiveOrHybridSalesPackageUpdatableStates = ["Draft"];
	SalesPackageRemoveEstateAllowedStates = [
		"Approved",
		"Prepared",
		"Active"
	];
	SalesPackageExport = /* @__PURE__ */ function(SalesPackageExport) {
		SalesPackageExport["InvestorCashflow"] = "InvestorCashflow";
		SalesPackageExport["ExportFolder"] = "ExportFolder";
		return SalesPackageExport;
	}({});
	SalesPackageEvents = /* @__PURE__ */ function(SalesPackageEvents) {
		SalesPackageEvents["SalesPackageCreated"] = "SalesPackageCreated";
		SalesPackageEvents["SalesPackagePrepared"] = "SalesPackagePrepared";
		SalesPackageEvents["SalesPackageActivated"] = "SalesPackageActivated";
		SalesPackageEvents["SalesPackageSold"] = "SalesPackageSold";
		SalesPackageEvents["SalesPackageClosed"] = "SalesPackageClosed";
		SalesPackageEvents["SalesPackageUpdated"] = "SalesPackageUpdated";
		SalesPackageEvents["SalesPackageEstateAdded"] = "SalesPackageEstateAdded";
		return SalesPackageEvents;
	}({});
	lastThreeYearsDocProtocolTypes = Object.values(DocumentType).filter((t) => t.startsWith("Protocol20")).sort().reverse().slice(0, 3);
	NotariatDocumentTypes = ["ContractNotarized", "KitchenContracted"];
	SalesPackageDocumentChecklist = [
		{
			types: ["AbstractOfTitle"],
			label: documentTranslationsMap["AbstractOfTitle"]
		},
		{
			types: ["AllowanceOfEntrySectionII"],
			label: documentTranslationsMap["AllowanceOfEntrySectionII"]
		},
		{
			types: ["SellingExpertReport"],
			label: documentTranslationsMap["SellingExpertReport"]
		},
		{
			types: ["SellingResidualValueCertificate"],
			label: documentTranslationsMap["SellingResidualValueCertificate"]
		},
		{
			types: ["DeclarationOfCondominium"],
			label: documentTranslationsMap["DeclarationOfCondominium"]
		},
		{
			types: ["PartitionPlan"],
			label: documentTranslationsMap["PartitionPlan"]
		},
		{
			types: ["SeparationDeclaration"],
			label: documentTranslationsMap["SeparationDeclaration"]
		},
		{
			types: ["ConstructionBurdenStatement"],
			label: documentTranslationsMap["ConstructionBurdenStatement"]
		},
		{
			types: lastThreeYearsDocProtocolTypes,
			label: "Protokolle der letzten 3 Jahre"
		},
		{
			types: ["HomeOwnerFeeStatement"],
			label: documentTranslationsMap["HomeOwnerFeeStatement"]
		},
		{
			types: ["EconomicPlan"],
			label: documentTranslationsMap["EconomicPlan"]
		},
		{
			types: ["LivingSpaceCalculations"],
			label: documentTranslationsMap["LivingSpaceCalculations"]
		},
		{
			types: ["PostRenovationDimensionedFloorPlan"],
			label: documentTranslationsMap["PostRenovationDimensionedFloorPlan"]
		},
		{
			types: ["LandRegisterMap"],
			label: documentTranslationsMap["LandRegisterMap"]
		},
		{
			types: ["EnergyCertificate"],
			label: documentTranslationsMap["EnergyCertificate"]
		},
		{
			types: ["ArchiveOfResolutions"],
			label: documentTranslationsMap["ArchiveOfResolutions"]
		},
		{
			types: ["BuildingInsurance"],
			label: documentTranslationsMap["BuildingInsurance"]
		},
		{
			types: ["AmendmentToDeclarationOfDivision"],
			label: documentTranslationsMap["AmendmentToDeclarationOfDivision"]
		},
		{
			types: ["ConstructionDescriptionRenovation"],
			label: documentTranslationsMap["ConstructionDescriptionRenovation"]
		},
		{
			types: ["ContractNotarized"],
			label: documentTranslationsMap["ContractNotarized"]
		},
		{
			types: ["KitchenContracted"],
			label: documentTranslationsMap["KitchenContracted"]
		}
	];
	SalesPackageExportMode = /* @__PURE__ */ function(SalesPackageExportMode) {
		SalesPackageExportMode["Full"] = "Full";
		SalesPackageExportMode["SellingOnly"] = "SellingOnly";
		SalesPackageExportMode["NotaryOnly"] = "NotaryOnly";
		return SalesPackageExportMode;
	}({});
	SalesPackageExportFolders = {
		root: "SALES_PACKAGE_{SALES_PACKAGE_ID}",
		output: "Output",
		exteriorPictures: "Außenfotos",
		mediaFiles: "Media Files",
		documents: "Documents",
		sellingPartners: "Selling Partners",
		notaryPartners: "Notary Partners",
		generalInformation: "Allgemeine Informationen"
	};
}));
//#endregion
//#region src/lib/event-helpers.ts
var extractEventDate, reconcileSalesPackageEventsOfEstate;
var init_event_helpers = __esmMin((() => {
	init_sales_package_model();
	extractEventDate = (event) => {
		const date = event?.eventTime ?? event?.payload?.time ?? event?.payload?.eventDate ?? event?.createdAt;
		return date ? new Date(date) : void 0;
	};
	reconcileSalesPackageEventsOfEstate = (condoEvents) => {
		const salesPackageEventsToConsider = ["EstateAddedToSalesPackage", "EstateRemovedFromSalesPackage"];
		const salesPackageStatesToConsider = [
			"Active",
			"Sold",
			"Closed"
		];
		const sortedEvents = sortBy(condoEvents.filter((condoEvent) => salesPackageEventsToConsider.includes(condoEvent.eventName) && salesPackageStatesToConsider.includes(condoEvent.salesPackage?.state) && condoEvent.estateId && condoEvent.salesPackageId), [
			"estateId",
			"salesPackageId",
			"eventTime"
		]);
		const resultArray = [];
		for (let i = 0; i < sortedEvents.length;) {
			const first = sortedEvents[i];
			const second = i === sortedEvents.length - 1 ? void 0 : sortedEvents[i + 1];
			const base = {
				estateId: first.estateId,
				salesPackageId: first.salesPackageId,
				salesPackagePartner: first.salesPackage?.distributionPartner?.name,
				salesPackageTitle: first?.salesPackage?.title
			};
			if (second && first.estateId === second.estateId && first.salesPackageId === second.salesPackageId && first.eventName === "EstateAddedToSalesPackage" && second.eventName === "EstateRemovedFromSalesPackage") {
				resultArray.push({
					...base,
					estateAddedToSalesPackageDate: first.eventTime,
					estateRemovedFromSalesPackageDate: second.eventTime
				});
				i += 2;
			} else {
				const estateAddedToSalesPackageDate = first.eventName === "EstateAddedToSalesPackage" ? first.eventTime : void 0;
				const estateRemovedFromSalesPackageDate = first.eventName === "EstateRemovedFromSalesPackage" ? first.eventTime : void 0;
				resultArray.push({
					...base,
					...estateAddedToSalesPackageDate ? { estateAddedToSalesPackageDate } : {},
					...estateRemovedFromSalesPackageDate ? { estateRemovedFromSalesPackageDate } : {}
				});
				i += 1;
			}
		}
		return resultArray;
	};
}));
//#endregion
//#region src/lib/get-expected-months-of-rent-paid.ts
var getExpectedMonthsOfRentPaid, getMonthDiff;
var init_get_expected_months_of_rent_paid = __esmMin((() => {
	getExpectedMonthsOfRentPaid = (startDate, endDate, now = /* @__PURE__ */ new Date()) => {
		const start = dayjs(startDate).tz("Europe/Berlin").startOf("day");
		const end = endDate ? dayjs(endDate).tz("Europe/Berlin").endOf("day") : void 0;
		const current = dayjs(now).tz("Europe/Berlin");
		let totalMonths = end?.isBefore(current) ? getMonthDiff(start, end) : getMonthDiff(start, current);
		const shouldPayHalfRentForInitialMonth = start.date() >= 15;
		totalMonths += shouldPayHalfRentForInitialMonth ? .5 : 1;
		if (end && end.date() <= 15 && end.isBefore(current.endOf("month"))) totalMonths -= .5;
		return totalMonths;
	};
	getMonthDiff = (startDate, endDate) => {
		return endDate.set("date", 1).diff(startDate.set("date", 1), "month");
	};
}));
//#endregion
//#region src/lib/helpers.ts
var maybeLog, defaultLogger;
var init_helpers$4 = __esmMin((() => {
	maybeLog = (...args) => {
		if (process.env.NODE_ENV === "test") return;
		console.log(...args);
	};
	defaultLogger = {
		trace(obj, msg, ...args) {
			maybeLog(obj, msg, ...args);
		},
		debug(obj, msg, ...args) {
			maybeLog(obj, msg, ...args);
		},
		error(obj, msg, ...args) {
			maybeLog(obj, msg, ...args);
		},
		info(obj, msg, ...args) {
			maybeLog(obj, msg, ...args);
		},
		warn(obj, msg, ...args) {
			maybeLog(obj, msg, ...args);
		}
	};
}));
//#endregion
//#region src/lib/orm.ts
var init_orm = __esmMin((() => {}));
//#endregion
//#region src/lib/service-uid.ts
var ServiceUid;
var init_service_uid = __esmMin((() => {
	ServiceUid = /* @__PURE__ */ function(ServiceUid) {
		ServiceUid["LISTING_PERSISTER"] = "listing-persister";
		ServiceUid["PAPI"] = "discoverer";
		ServiceUid["SOURCING_STORAGE"] = "sourcing-storage";
		ServiceUid["BASECAMP"] = "basecamp";
		ServiceUid["CDC_TRANSFORMER"] = "cdc-transformer";
		ServiceUid["DOCUMENT_GENERATOR"] = "document-generator";
		ServiceUid["SALES_PORTAL"] = "sales-portal";
		ServiceUid["INVESTOR_PORTAL"] = "investor-portal";
		ServiceUid["CONDO_LIVING"] = "condo-living";
		ServiceUid["SYSTEM_TESTER"] = "system-tester";
		ServiceUid["RAAS"] = "raas";
		ServiceUid["ESTATE_PREPROCESSOR"] = "estate_preprocessor";
		ServiceUid["PROPX"] = "propx";
		ServiceUid["DISCOVERER"] = "discoverer";
		ServiceUid["BANKING"] = "banking";
		ServiceUid["AI_GATEWAY"] = "ai-gateway";
		ServiceUid["AI_HUB"] = "ai-hub";
		ServiceUid["EXTERNAL_API"] = "external-api";
		ServiceUid["PIPELINE_AUDIT_PERSISTER"] = "pipeline-audit-persister";
		ServiceUid["ESTATE_AGGREGATOR"] = "estate-aggregator";
		ServiceUid["COVERAGE_AGGREGATOR"] = "coverage-aggregator";
		ServiceUid["NOTIFICATION_PROCESSOR"] = "notification-processor";
		ServiceUid["PERMISSION_NAGGER"] = "permission-nagger";
		return ServiceUid;
	}({});
}));
//#endregion
//#region src/domains/renting/renting-listing.model.ts
var RentingListingState, RentingListingProvider, RentingListingHeatingType, EnergySource;
var init_renting_listing_model = __esmMin((() => {
	RentingListingState = /* @__PURE__ */ function(RentingListingState) {
		RentingListingState["Created"] = "Created";
		RentingListingState["Prepublished"] = "Prepublished";
		RentingListingState["Published"] = "Published";
		return RentingListingState;
	}({});
	RentingListingProvider = /* @__PURE__ */ function(RentingListingProvider) {
		RentingListingProvider["IS24"] = "IS24";
		RentingListingProvider["Immomio"] = "Immomio";
		return RentingListingProvider;
	}({});
	RentingListingHeatingType = /* @__PURE__ */ function(RentingListingHeatingType) {
		RentingListingHeatingType["NoInformation"] = "NoInformation";
		RentingListingHeatingType["SelfContainedCentralHeating"] = "SelfContainedCentralHeating";
		RentingListingHeatingType["StoveHeating"] = "StoveHeating";
		RentingListingHeatingType["CentralHeating"] = "CentralHeating";
		RentingListingHeatingType["CombinedHeatAndPowerPlant"] = "CombinedHeatAndPowerPlant";
		RentingListingHeatingType["ElectricHeating"] = "ElectricHeating";
		RentingListingHeatingType["DistrictHeating"] = "DistrictHeating";
		RentingListingHeatingType["FloorHeating"] = "FloorHeating";
		RentingListingHeatingType["GasHeating"] = "GasHeating";
		RentingListingHeatingType["WoodPelletHeating"] = "WoodPelletHeating";
		RentingListingHeatingType["NightStorageHeater"] = "NightStorageHeater";
		RentingListingHeatingType["OilHeating"] = "OilHeating";
		RentingListingHeatingType["SolarHeating"] = "SolarHeating";
		RentingListingHeatingType["HeatPump"] = "HeatPump";
		return RentingListingHeatingType;
	}({});
	EnergySource = /* @__PURE__ */ function(EnergySource) {
		EnergySource["NO_INFORMATION"] = "NO_INFORMATION";
		EnergySource["GEOTHERMAL"] = "GEOTHERMAL";
		EnergySource["SOLAR_HEATING"] = "SOLAR_HEATING";
		EnergySource["PELLET_HEATING"] = "PELLET_HEATING";
		EnergySource["GAS"] = "GAS";
		EnergySource["OIL"] = "OIL";
		EnergySource["DISTRICT_HEATING"] = "DISTRICT_HEATING";
		EnergySource["ELECTRICITY"] = "ELECTRICITY";
		EnergySource["COAL"] = "COAL";
		EnergySource["ACID_GAS"] = "ACID_GAS";
		EnergySource["SOUR_GAS"] = "SOUR_GAS";
		EnergySource["LIQUID_GAS"] = "LIQUID_GAS";
		EnergySource["STEAM_DISTRICT_HEATING"] = "STEAM_DISTRICT_HEATING";
		EnergySource["WOOD"] = "WOOD";
		EnergySource["WOOD_CHIPS"] = "WOOD_CHIPS";
		EnergySource["COAL_COKE"] = "COAL_COKE";
		EnergySource["LOCAL_HEATING"] = "LOCAL_HEATING";
		EnergySource["HEAT_SUPPLY"] = "HEAT_SUPPLY";
		EnergySource["BIO_ENERGY"] = "BIO_ENERGY";
		EnergySource["WIND_ENERGY"] = "WIND_ENERGY";
		EnergySource["HYDRO_ENERGY"] = "HYDRO_ENERGY";
		EnergySource["ENVIRONMENTAL_THERMAL_ENERGY"] = "ENVIRONMENTAL_THERMAL_ENERGY";
		EnergySource["COMBINED_HEAT_AND_POWER_FOSSIL_FUELS"] = "COMBINED_HEAT_AND_POWER_FOSSIL_FUELS";
		EnergySource["COMBINED_HEAT_AND_POWER_RENEWABLE_ENERGY"] = "COMBINED_HEAT_AND_POWER_RENEWABLE_ENERGY";
		EnergySource["COMBINED_HEAT_AND_POWER_REGENERATIVE_ENERGY"] = "COMBINED_HEAT_AND_POWER_REGENERATIVE_ENERGY";
		EnergySource["COMBINED_HEAT_AND_POWER_BIO_ENERGY"] = "COMBINED_HEAT_AND_POWER_BIO_ENERGY";
		return EnergySource;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/energy-efficiency/energy-efficiency.model.ts
var EnergyConsumptionCategory, OtherEnergyConsumptionCategory, BuildingEnergyRating, EnergyCertificateCreationDate;
var init_energy_efficiency_model = __esmMin((() => {
	EnergyConsumptionCategory = /* @__PURE__ */ function(EnergyConsumptionCategory) {
		EnergyConsumptionCategory["A+"] = "A+";
		EnergyConsumptionCategory["A"] = "A";
		EnergyConsumptionCategory["B"] = "B";
		EnergyConsumptionCategory["C"] = "C";
		EnergyConsumptionCategory["D"] = "D";
		EnergyConsumptionCategory["E"] = "E";
		EnergyConsumptionCategory["F"] = "F";
		EnergyConsumptionCategory["G"] = "G";
		EnergyConsumptionCategory["H"] = "H";
		return EnergyConsumptionCategory;
	}({});
	OtherEnergyConsumptionCategory = /* @__PURE__ */ function(OtherEnergyConsumptionCategory) {
		OtherEnergyConsumptionCategory["NotAvailable"] = "Nicht vorhanden";
		OtherEnergyConsumptionCategory["NotNeeded"] = "Nicht Benötigt";
		return OtherEnergyConsumptionCategory;
	}({});
	BuildingEnergyRating = /* @__PURE__ */ function(BuildingEnergyRating) {
		BuildingEnergyRating["NoInformation"] = "NO_INFORMATION";
		BuildingEnergyRating["EnergyRequired"] = "ENERGY_REQUIRED";
		BuildingEnergyRating["EnergyConsumption"] = "ENERGY_CONSUMPTION";
		return BuildingEnergyRating;
	}({});
	EnergyCertificateCreationDate = /* @__PURE__ */ function(EnergyCertificateCreationDate) {
		EnergyCertificateCreationDate["NotApplicable"] = "NOT_APPLICABLE";
		EnergyCertificateCreationDate["Before01May2014"] = "BEFORE_01_MAY_2014";
		EnergyCertificateCreationDate["From01May2014"] = "FROM_01_MAY_2014";
		return EnergyCertificateCreationDate;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/energy-efficiency/energy-consumption-category.helpers.ts
var MaxKwhPerEnergyConsumptionCategory, convertEnergyConsumptionToEnergyConsumptionCategory;
var init_energy_consumption_category_helpers = __esmMin((() => {
	MaxKwhPerEnergyConsumptionCategory = {
		["A+"]: 30,
		["A"]: 50,
		["B"]: 75,
		["C"]: 100,
		["D"]: 130,
		["E"]: 160,
		["F"]: 200,
		["G"]: 250,
		["H"]: Number.POSITIVE_INFINITY
	};
	convertEnergyConsumptionToEnergyConsumptionCategory = (energyConsumption) => {
		const categories = Object.keys(MaxKwhPerEnergyConsumptionCategory);
		for (let i = 0; i < categories.length; i++) {
			const category = categories[i];
			if (energyConsumption <= MaxKwhPerEnergyConsumptionCategory[category]) return category;
		}
	};
}));
//#endregion
//#region src/domains/cross-cutting/energy-efficiency/heating.model.ts
/** Resolve the calculator energy source for a stored heating-type string (best-effort; unknown → null). */
function inferHeatingSource(heatingType) {
	if (heatingType == null) return null;
	return HEATING_TYPE_TO_SOURCE[heatingType] ?? null;
}
var HeatingSource, HeatingType, HEATING_TYPE_TO_SOURCE;
var init_heating_model = __esmMin((() => {
	HeatingSource = /* @__PURE__ */ function(HeatingSource) {
		HeatingSource["NaturalGas"] = "NaturalGas";
		HeatingSource["HeatingOil"] = "HeatingOil";
		HeatingSource["DistrictHeating"] = "DistrictHeating";
		HeatingSource["Electricity"] = "Electricity";
		HeatingSource["Pellets"] = "Pellets";
		/** Hard coal. Own carrier so the CAPEX config can set its primary energy factor. */
		HeatingSource["Coal"] = "Coal";
		return HeatingSource;
	}({});
	HeatingType = /* @__PURE__ */ function(HeatingType) {
		HeatingType["Coal"] = "Coal";
		HeatingType["PelletHeating"] = "PelletHeating";
		HeatingType["NaturalGasHeavy"] = "NaturalGasHeavy";
		HeatingType["SteamDistrictHeating"] = "SteamDistrictHeating";
		HeatingType["BioEnergy"] = "BioEnergy";
		HeatingType["DistrictHeating"] = "DistrictHeating";
		HeatingType["Electricity"] = "Electricity";
		HeatingType["CombinedHeatAndPowerFossilFuels"] = "CombinedHeatAndPowerFossilFuels";
		HeatingType["HydroEnergy"] = "HydroEnergy";
		HeatingType["Gas"] = "Gas";
		HeatingType["CombinedHeatAndPowerRenewableEnergy"] = "CombinedHeatAndPowerRenewableEnergy";
		HeatingType["NaturalGasLight"] = "NaturalGasLight";
		HeatingType["WindEnergy"] = "WindEnergy";
		HeatingType["CombinedHeatAndPowerRegenerativeEnergy"] = "CombinedHeatAndPowerRegenerativeEnergy";
		HeatingType["LiquidGas"] = "LiquidGas";
		HeatingType["EnvironmentalThermalEnergy"] = "EnvironmentalThermalEnergy";
		HeatingType["HeatSupply"] = "HeatSupply";
		HeatingType["Geothermal"] = "Geothermal";
		HeatingType["LocalHeating"] = "LocalHeating";
		HeatingType["Wood"] = "Wood";
		HeatingType["CombinedHeatAndPowerBioEnergy"] = "CombinedHeatAndPowerBioEnergy";
		HeatingType["SolarHeating"] = "SolarHeating";
		HeatingType["Oil"] = "Oil";
		HeatingType["WoodChips"] = "WoodChips";
		HeatingType["NoInformation"] = "NoInformation";
		return HeatingType;
	}({});
	HEATING_TYPE_TO_SOURCE = {
		["Gas"]: "NaturalGas",
		["NaturalGasHeavy"]: "NaturalGas",
		["NaturalGasLight"]: "NaturalGas",
		["Oil"]: "HeatingOil",
		["Electricity"]: "Electricity",
		["DistrictHeating"]: "DistrictHeating",
		["LocalHeating"]: "DistrictHeating",
		["SteamDistrictHeating"]: "DistrictHeating",
		["HeatSupply"]: "DistrictHeating",
		["PelletHeating"]: "Pellets",
		["Coal"]: "Coal"
	};
}));
//#endregion
//#region src/domains/cross-cutting/energy-efficiency/index.ts
var init_energy_efficiency = __esmMin((() => {
	init_energy_efficiency_model();
	init_energy_consumption_category_helpers();
	init_heating_model();
}));
//#endregion
//#region src/domains/cross-cutting/estates/estate-attributes.ts
var AttributesDTOSchema, DiscovererAttributesDTOSchema, getEnergyConsumptionCategory, getValueProportionLand, CommercialApartmentTypes, ParkingApartmentTypes, UnitOverviewApartmentTypes, ResidentialApartmentTypes;
var init_estate_attributes = __esmMin((() => {
	init_shared_schemas();
	init_renting_listing_model();
	init_energy_efficiency();
	init_estate_base();
	AttributesDTOSchema = Type.Object({
		attrId: Type.Optional(Type.Number()),
		estateUuid: Type.Optional(Type.String()),
		livingSpace: Type.Number(),
		buildingSpace: Type.Optional(Type.Number()),
		apartmentSize: Type.Optional(Type.Enum(ApartmentSize)),
		rooms: Type.Number(),
		interiorQuality: Type.Enum(InteriorQuality),
		condition: Type.Optional(Type.Enum(Condition)),
		bedrooms: Type.Optional(Type.Number()),
		numberOfBathRooms: Type.Optional(Type.Number()),
		builtInKitchen: Type.Optional(Type.Boolean()),
		guestToilet: Type.Optional(Type.Boolean()),
		yearsSinceRenovation: Type.Optional(Type.Number()),
		primaryHeatingType: Type.Optional(Type.String()),
		freeFromCategory: Type.Optional(Type.Enum(FreeFromCategory)),
		descriptionNote: Type.Optional(Type.String()),
		apartmentType: Type.Enum(ApartmentType),
		constructionYear: Type.Optional(Type.Number()),
		remainingUsefulLife: Type.Optional(Type.Number()),
		buildingAge: Type.Optional(Type.Number()),
		categoryName: Type.Optional(Type.String()),
		floor: Type.Optional(Type.Number()),
		floorLocation: Type.Optional(Type.Union([TEnum(FloorLocation), TNullable(Type.String())])),
		buildingLocationType: Type.Optional(Type.Enum(BuildingLocationType)),
		numberOfFloors: Type.Optional(Type.Number()),
		avgSpacePerRoom: Type.Optional(Type.Number()),
		furnished: Type.Optional(Type.Boolean()),
		restaurantTerrace: Type.Optional(Type.Boolean()),
		bikeRoom: Type.Optional(Type.Boolean()),
		lift: Type.Optional(Type.Boolean()),
		numberOfWindows: Type.Optional(Type.Number()),
		balcony: Type.Optional(Type.Boolean()),
		alignmentBalcony: Type.Optional(Type.String()),
		garden: Type.Optional(Type.Boolean()),
		cellar: Type.Optional(Type.Boolean()),
		flooring: Type.Optional(Type.Union([Type.String(), Type.Enum(Flooring)])),
		heatingType: Type.Optional(TEnum(HeatingType)),
		secondaryHeatingType: Type.Optional(Type.String()),
		tertiaryHeatingType: Type.Optional(Type.String()),
		heatingCostsInServiceCharge: Type.Optional(Type.Boolean()),
		energySource: Type.Optional(Type.Enum(EnergySource)),
		energyConsumptionCategory: Type.Optional(Type.Enum(EnergyConsumptionCategory)),
		energyConsumption: Type.Optional(Type.Number()),
		energyCertificateAvailability: Type.Optional(Type.Boolean()),
		energyCertificateCreationDate: Type.Optional(Type.Enum(EnergyCertificateCreationDate)),
		energyCertificateExpiryDate: Type.Optional(StringDateSchema),
		energyConsumptionContainsWarmWater: Type.Optional(Type.Boolean()),
		energyPerformanceCertificate: Type.Optional(Type.Boolean()),
		buildingEnergyRating: Type.Optional(Type.Enum(BuildingEnergyRating)),
		handicappedAccessible: Type.Optional(Type.Boolean()),
		assistedLiving: Type.Optional(Type.Boolean()),
		lastRefurbishment: Type.Optional(Type.Number()),
		washingMachineRoom: Type.Optional(Type.Boolean()),
		isHeritageBuilding: Type.Optional(Type.Boolean()),
		isEligibleForSubsidising: Type.Optional(Type.Boolean()),
		isVacationHome: Type.Optional(Type.Boolean()),
		fireplace: Type.Optional(Type.Boolean()),
		freeFrom: Type.Optional(Type.String()),
		petsAllowed: Type.Optional(Type.Boolean()),
		furnishingNote: Type.Optional(Type.String()),
		locationNote: Type.Optional(Type.String()),
		otherNote: Type.Optional(Type.String()),
		districtCourt: Type.Optional(Type.String()),
		registryOfDeeds: Type.Optional(Type.String()),
		titleRegisterBand: Type.Optional(Type.Number()),
		titleRegisterPage: Type.Optional(Type.Number()),
		apartmentNumber: Type.Optional(Type.String()),
		buildingBasementPresent: Type.Optional(Type.Boolean()),
		facadeType: Type.Optional(Type.String()),
		facadeRenovationType: Type.Optional(Type.String()),
		facadeRenovationDate: Type.Optional(StringDateSchema),
		roofType: Type.Optional(Type.String()),
		roofRenovationType: Type.Optional(Type.String()),
		roofRenovationDate: Type.Optional(StringDateSchema),
		windowType: Type.Optional(Type.String()),
		windowRenovationType: Type.Optional(Type.String()),
		windowRenovationDate: Type.Optional(StringDateSchema),
		heatingRenovationType: Type.Optional(Type.String()),
		heatingRenovationDate: Type.Optional(StringDateSchema),
		otherRenovations: Type.Optional(Type.String()),
		otherRenovationsDate: Type.Optional(StringDateSchema),
		storeRooms: Type.Optional(Type.Array(Type.Enum(StoreRoomType))),
		commonRooms: Type.Optional(Type.Array(Type.Enum(CommonRoomType))),
		purchasingNotaryCertificateNumber: Type.Optional(Type.String()),
		sellingNotaryCertificateNumber: Type.Optional(Type.String()),
		isRedevelopmentArea: Type.Optional(Type.Boolean()),
		isEnvironmentalProtectionArea: Type.Optional(Type.Boolean()),
		isResettlementApartment: Type.Optional(Type.Boolean()),
		standardLandValue: Type.Optional(Type.Number()),
		landArea: Type.Optional(Type.Number()),
		partialOwnershipOfLand: Type.Optional(Type.Number()),
		totalOwnershipOfLand: Type.Optional(Type.Number()),
		totalLandValue: Type.Optional(Type.Number()),
		partialOwnershipOfLandPercent: Type.Optional(Type.Number()),
		partialLandValue: Type.Optional(Type.Number()),
		rentalIncomeActual: Type.Optional(Type.Number()),
		rentableSpace: Type.Optional(Type.Number()),
		commercialSpace: Type.Optional(Type.Number()),
		totalFloorSpace: Type.Optional(Type.Number()),
		plotArea: Type.Optional(Type.Number()),
		additionalArea: Type.Optional(Type.Number()),
		additionalCosts: Type.Optional(Type.Number()),
		otherCosts: Type.Optional(Type.Number()),
		distanceToAirport: Type.Optional(Type.Number()),
		distanceToFM: Type.Optional(Type.Number()),
		distanceToPT: Type.Optional(Type.Number()),
		distanceToMRS: Type.Optional(Type.Number()),
		priceMultiplier: Type.Optional(Type.Number()),
		buildingObligation: Type.Optional(Type.Boolean())
	}, { $id: "AttributesDTO" });
	DiscovererAttributesDTOSchema = Type.Intersect([AttributesDTOSchema, Type.Object({
		numberOfParkingSpaces: Type.Optional(Type.Number()),
		parkingSpaceType: Type.Optional(Type.Enum(ParkingSpaceType)),
		parkingSpacePrice: Type.Optional(Type.Number()),
		parkingTitleRegisterBand: Type.Optional(Type.Number()),
		parkingTitleRegisterPage: Type.Optional(Type.Number()),
		parkingRegisterNumber: Type.Optional(Type.String())
	})], { $id: "DiscovererAttributesDTO" });
	getEnergyConsumptionCategory = (attributes) => {
		if (!attributes) return;
		if (!attributes.energyConsumption) return "Nicht vorhanden";
		return convertEnergyConsumptionToEnergyConsumptionCategory(attributes.energyConsumption);
	};
	getValueProportionLand = (attributes, investmentOrPrediction) => {
		const partialLandValue = attributes?.partialLandValue;
		if (!isNil(partialLandValue) && !isNil(investmentOrPrediction?.expectedSalesPrice)) return partialLandValue / investmentOrPrediction.expectedSalesPrice;
	};
	CommercialApartmentTypes = [
		"Commercial",
		"CommercialOther",
		"Farm",
		"Gastronomy",
		"Office",
		"Shop"
	];
	ParkingApartmentTypes = [
		"Parking",
		"UndergroundParking",
		"OutdoorParking",
		"Garage"
	];
	UnitOverviewApartmentTypes = [
		"Apartment",
		"Commercial",
		"UndergroundParking",
		"OutdoorParking",
		"Parking",
		"Cellar"
	];
	ResidentialApartmentTypes = [
		"Apartment",
		"ApartmentBuilding",
		"Cellar",
		"GroundFloor",
		"HalfBasement",
		"Loft",
		"Maisonette",
		"NoInformation",
		"Other",
		"OtherHouse",
		"Penthouse",
		"RaisedGroundFloor",
		"Residential",
		"RoofStorey",
		"TerracedFlat",
		"TerracedHouse",
		"TwoFamilyHouse"
	];
}));
//#endregion
//#region src/domains/finance/common.ts
var FALLBACK_BIC, Currency, FeeType, LedgerEntryDrawdownType, RepaymentType, LedgerEntryPaymentType, OtherLedgerEntryType, RevenueEntryType, LedgerPropertyManagementType, AssetLedgerEntryType, BusinessLine;
var init_common = __esmMin((() => {
	FALLBACK_BIC = "BROKEN_BIC_FIX_ME";
	Currency = /* @__PURE__ */ function(Currency) {
		Currency["EUR"] = "EUR";
		Currency["USD"] = "USD";
		Currency["GBP"] = "GBP";
		Currency["CHF"] = "CHF";
		return Currency;
	}({});
	FeeType = /* @__PURE__ */ function(FeeType) {
		FeeType["Processing"] = "Processing";
		FeeType["Interest"] = "Interest";
		FeeType["Commitment"] = "Commitment";
		FeeType["Combined"] = "Combined";
		return FeeType;
	}({});
	LedgerEntryDrawdownType = /* @__PURE__ */ function(LedgerEntryDrawdownType) {
		LedgerEntryDrawdownType["PurchasingPrice"] = "PurchasingPrice";
		LedgerEntryDrawdownType["Invoice"] = "Invoice";
		LedgerEntryDrawdownType["Correction"] = "Correction";
		LedgerEntryDrawdownType["JuniorDebt"] = "JuniorDebt";
		LedgerEntryDrawdownType["Intergroup"] = "Intergroup";
		return LedgerEntryDrawdownType;
	}({});
	RepaymentType = /* @__PURE__ */ function(RepaymentType) {
		RepaymentType["Interest"] = "Interest";
		RepaymentType["Principal"] = "Principal";
		RepaymentType["Commitment"] = "Commitment";
		RepaymentType["Processing"] = "Processing";
		return RepaymentType;
	}({});
	LedgerEntryPaymentType = /* @__PURE__ */ function(LedgerEntryPaymentType) {
		LedgerEntryPaymentType["Invoice"] = "Invoice";
		LedgerEntryPaymentType["PurchasingPrice"] = "PurchasingPrice";
		return LedgerEntryPaymentType;
	}({});
	OtherLedgerEntryType = /* @__PURE__ */ function(OtherLedgerEntryType) {
		OtherLedgerEntryType["Service"] = "ServiceCharge";
		OtherLedgerEntryType["Other"] = "Other";
		OtherLedgerEntryType["Storno"] = "Storno";
		OtherLedgerEntryType["OwnFunds"] = "OwnFunds";
		OtherLedgerEntryType["Tranche"] = "Tranche";
		OtherLedgerEntryType["LoanAmortization"] = "LoanAmortization";
		return OtherLedgerEntryType;
	}({});
	RevenueEntryType = /* @__PURE__ */ function(RevenueEntryType) {
		RevenueEntryType["Selling"] = "Selling";
		RevenueEntryType["Commission"] = "Commission";
		return RevenueEntryType;
	}({});
	LedgerPropertyManagementType = /* @__PURE__ */ function(LedgerPropertyManagementType) {
		LedgerPropertyManagementType["Rent"] = "Rent";
		LedgerPropertyManagementType["ReturnDebit"] = "ReturnDebit";
		LedgerPropertyManagementType["ReturnDebitFee"] = "ReturnDebitFee";
		LedgerPropertyManagementType["ManagementFee"] = "ManagementFee";
		LedgerPropertyManagementType["InvestorIncome"] = "InvestorIncome";
		LedgerPropertyManagementType["PropertyTax"] = "PropertyTax";
		LedgerPropertyManagementType["BankFee"] = "BankFee";
		LedgerPropertyManagementType["BankFeeCompensation"] = "BankFeeCompensation";
		LedgerPropertyManagementType["AncillaryCosts"] = "AncillaryCosts";
		LedgerPropertyManagementType["RentGuarantee"] = "RentGuarantee";
		LedgerPropertyManagementType["HouseGeldDealPayback"] = "HouseGeldDealPayback";
		LedgerPropertyManagementType["OtherCost"] = "OtherCost";
		LedgerPropertyManagementType["LiquidityReserve"] = "LiquidityReserve";
		LedgerPropertyManagementType["HOAFee"] = "HOAFee";
		LedgerPropertyManagementType["HOAFeeSubsidy"] = "HOAFeeSubsidy";
		LedgerPropertyManagementType["HOAFeeSettlement"] = "HOAFeeSettlement";
		LedgerPropertyManagementType["ColdRent"] = "ColdRent";
		LedgerPropertyManagementType["Utilities"] = "Utilities";
		LedgerPropertyManagementType["Heating"] = "Heating";
		LedgerPropertyManagementType["Parking"] = "Parking";
		LedgerPropertyManagementType["SettlementResult"] = "SettlementResult";
		LedgerPropertyManagementType["RentArrearFee"] = "RentArrearFee";
		LedgerPropertyManagementType["RentReduction"] = "RentReduction";
		LedgerPropertyManagementType["AnnualServiceChargeStatement"] = "AnnualServiceChargeStatement";
		return LedgerPropertyManagementType;
	}({});
	AssetLedgerEntryType = /* @__PURE__ */ function(AssetLedgerEntryType) {
		AssetLedgerEntryType["Bank"] = "Bank";
		AssetLedgerEntryType["InputTaxOpt"] = "InputTaxOpt";
		AssetLedgerEntryType["Banking"] = "Banking";
		AssetLedgerEntryType["AnnualStatement"] = "AnnualStatement";
		AssetLedgerEntryType["Invoice"] = "Invoice";
		AssetLedgerEntryType["ColdRent"] = "ColdRent";
		AssetLedgerEntryType["Utilities"] = "Utilities";
		AssetLedgerEntryType["Heating"] = "Heating";
		AssetLedgerEntryType["Parking"] = "Parking";
		AssetLedgerEntryType["RentReduction"] = "RentReduction";
		AssetLedgerEntryType["OtherCost"] = "OtherCost";
		return AssetLedgerEntryType;
	}({});
	BusinessLine = /* @__PURE__ */ function(BusinessLine) {
		BusinessLine["RETAIL"] = "RETAIL";
		BusinessLine["INSTI"] = "INSTI";
		return BusinessLine;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/estates/estate-price.ts
var RentPriceDTOSchema, BuyPriceDTOSchema, PriceDTOSchema, isBuyPriceDTO, isRentPriceDTO, checkIfFutureHouseGeldStartDateRequiresProcessing, priceComputedProps;
var init_estate_price = __esmMin((() => {
	init_shared_schemas();
	init_common();
	dayjs.extend(isSameOrAfter);
	RentPriceDTOSchema = Type.Object({
		currency: Type.Enum(Currency),
		totalRent: Type.Number(),
		baseRent: Type.Number(),
		serviceCharge: Type.Number(),
		deposit: Type.Optional(Type.Number())
	}, { $id: "RentPriceDTO" });
	BuyPriceDTOSchema = Type.Object({
		currency: Type.Enum(Currency),
		courtage: Type.Optional(Type.String()),
		parkingSpacePrice: Type.Optional(Type.Number()),
		courtageMultiplier: Type.Optional(Type.Number()),
		courtageMultiplierWithoutVat: Type.Optional(Type.Number()),
		vat: Type.Optional(Type.Number()),
		houseGeld: Type.Optional(TNullable(Type.Number())),
		houseGeldTransferable: Type.Optional(Type.Number()),
		houseGeldNonTransferable: Type.Optional(Type.Number()),
		houseGeldReserve: Type.Optional(Type.Number()),
		futureHouseGeld: Type.Optional(Type.Number()),
		estateMaintenanceReserve: Type.Optional(Type.Number()),
		totalMaintenanceReserve: Type.Optional(Type.Number()),
		billingDate: Type.Optional(StringDateSchema),
		referralFeePercent: Type.Optional(Type.Number()),
		purchasePriceGross: Type.Optional(Type.Number()),
		purchasePriceNett: Type.Number(),
		rentalIncome: Type.Optional(Type.Number())
	}, { $id: "BuyPriceDTO" });
	PriceDTOSchema = Type.Union([RentPriceDTOSchema, BuyPriceDTOSchema], { $id: "PriceDTO" });
	isBuyPriceDTO = (price, zeroPriceAllowed = false) => zeroPriceAllowed ? typeof price.purchasePriceNett !== "undefined" : Boolean(price.purchasePriceNett);
	isRentPriceDTO = (price) => Boolean(price.baseRent) || Boolean(price.totalRent);
	checkIfFutureHouseGeldStartDateRequiresProcessing = (startDate) => {
		const futureHouseGeldStartDate = dayjs(startDate).startOf("day");
		const today = dayjs().startOf("day");
		const threeMonthsAhead = today.add(3, "month");
		const isInThePast = futureHouseGeldStartDate.isBefore(today, "day");
		const isTodayOrInNextThreeMonths = futureHouseGeldStartDate.isSameOrAfter(today, "day") && futureHouseGeldStartDate.isBefore(threeMonthsAhead, "day");
		return {
			shouldApplyFutureHouseGeld: isInThePast,
			shouldRecalculateNonApprovedInvestmentCasesAndCashflows: isInThePast || isTodayOrInNextThreeMonths
		};
	};
	priceComputedProps = ["pricePerSQM"];
}));
//#endregion
//#region src/domains/cross-cutting/estates/estate.model.ts
var EstateDTOSchema, LocationRating, locationRatingTransalations, CondoUuidRegex, ESTATE_PROPS_REQUIRING_CASHFLOW_RECALCULATION_AND_EXPOSE_REGENERATION_ON_CHANGE, ESTATE_PROPS_REQUIRING_FUTURE_HOUSE_GELD_PROCESSING;
var init_estate_model = __esmMin((() => {
	init_shared_schemas();
	init_estate_base();
	EstateDTOSchema = Type.Object({
		estateId: Type.Optional(Type.Number()),
		estateType: Type.Enum(EstateType),
		leadType: Type.Enum(EstateLeadType),
		channelType: Type.Enum(EstateChannelType),
		channelName: Type.Enum(EstateChannelName),
		source: Type.Enum(EstateSource),
		category: Type.Enum(EstateCategory),
		title: Type.Optional(Type.String()),
		adPublishingDate: StringDateSchema,
		adModificationDate: StringDateSchema,
		isRented: Type.Optional(Type.Boolean()),
		isSold: Type.Optional(Type.Boolean()),
		originalId: Type.String(),
		titlePicUrl: Type.Optional(Type.String()),
		propertyManagementOnly: Type.Optional(Type.Boolean())
	}, { $id: "EstateDTO" });
	LocationRating = /* @__PURE__ */ function(LocationRating) {
		LocationRating["VeryGood"] = "VeryGood";
		LocationRating["GoodToVeryGood"] = "GoodToVeryGood";
		LocationRating["Good"] = "Good";
		LocationRating["AverageToGood"] = "AverageToGood";
		LocationRating["Average"] = "Average";
		LocationRating["SimpleToAverage"] = "SimpleToAverage";
		LocationRating["Other"] = "Other";
		return LocationRating;
	}({});
	locationRatingTransalations = {
		["VeryGood"]: "sehr gut",
		["GoodToVeryGood"]: "gut bis sehr gut",
		["Good"]: "gut",
		["AverageToGood"]: "durchschnittlich bis gut",
		["Average"]: "durchschnittlich",
		["SimpleToAverage"]: "einfach bis durchschnittlich",
		["Other"]: "einfach"
	};
	CondoUuidRegex = /([A-Z]{1,3}\d{2})_([A-ZÄÖÜß]{3}[A-Z\d]+)_?(?:_RAAS)?_(\d+)/;
	ESTATE_PROPS_REQUIRING_CASHFLOW_RECALCULATION_AND_EXPOSE_REGENERATION_ON_CHANGE = ["attributes.remainingUsefulLife"];
	ESTATE_PROPS_REQUIRING_FUTURE_HOUSE_GELD_PROCESSING = [
		"price.futureHouseGeld",
		"price.futureHouseGeldTransferable",
		"price.futureHouseGeldNonTransferable",
		"price.futureHouseGeldReserve"
	];
}));
//#endregion
//#region src/domains/cross-cutting/estates/estate-overview.model.ts
var init_estate_overview_model = __esmMin((() => {}));
//#endregion
//#region src/domains/transaction/external-data/external-data.model.ts
var ExternalDataSource, ExternalDataTypes;
var init_external_data_model = __esmMin((() => {
	ExternalDataSource = /* @__PURE__ */ function(ExternalDataSource) {
		ExternalDataSource["Sprengnetter"] = "Sprengnetter";
		ExternalDataSource["GPT"] = "GPT";
		ExternalDataSource["Infas360"] = "Infas360";
		ExternalDataSource["Syte"] = "Syte";
		return ExternalDataSource;
	}({});
	ExternalDataTypes = /* @__PURE__ */ function(ExternalDataTypes) {
		ExternalDataTypes["Attributes"] = "Attributes";
		ExternalDataTypes["PurchaseValuation"] = "PurchaseValuation";
		ExternalDataTypes["PurchaseValuationNewBuilding"] = "PurchaseValuationNewBuilding";
		ExternalDataTypes["PurchasePriceDevelopment"] = "PurchasePriceDevelopment";
		ExternalDataTypes["RentValuation"] = "RentValuation";
		ExternalDataTypes["RentValuationNewBuilding"] = "RentValuationNewBuilding";
		ExternalDataTypes["RentPriceDevelopment"] = "RentPriceDevelopment";
		ExternalDataTypes["GPTRentalContract"] = "GPTRentalContract";
		ExternalDataTypes["GPTExpose"] = "GPTExpose";
		ExternalDataTypes["SyteBuilding"] = "SyteBuilding";
		return ExternalDataTypes;
	}({});
}));
//#endregion
//#region src/domains/transaction/external-data/external-data.opts.ts
var init_external_data_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/transaction/external-data/external-link.model.ts
var ExternalLinkStatus, ExternalLinkType, ExternalLinkDTOSchema;
var init_external_link_model = __esmMin((() => {
	init_shared_schemas();
	ExternalLinkStatus = /* @__PURE__ */ function(ExternalLinkStatus) {
		ExternalLinkStatus["ACTIVE"] = "ACTIVE";
		ExternalLinkStatus["OUTDATED"] = "OUTDATED";
		return ExternalLinkStatus;
	}({});
	ExternalLinkType = /* @__PURE__ */ function(ExternalLinkType) {
		ExternalLinkType["IS24"] = "IS24";
		ExternalLinkType["Other"] = "Other";
		return ExternalLinkType;
	}({});
	ExternalLinkDTOSchema = Type.Object({
		externalLinkId: Type.Optional(Type.Number()),
		url: Type.String(),
		domain: Type.String(),
		status: Type.Enum(ExternalLinkStatus),
		updatedAt: Type.Optional(StringDateSchema)
	}, { $id: "ExternalLinkDTO" });
}));
//#endregion
//#region src/domains/transaction/external-data/external-link.opts.ts
var init_external_link_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/transaction/external-data/requests.ts
var init_requests$4 = __esmMin((() => {}));
//#endregion
//#region src/domains/transaction/external-data/index.ts
var init_external_data = __esmMin((() => {
	init_external_data_model();
	init_external_data_opts();
	init_external_link_model();
	init_external_link_opts();
	init_requests$4();
}));
//#endregion
//#region src/domains/cross-cutting/location/location.model.ts
var GermanyStateCode, STATE_CODE_MAPPINGS, MAPPED_CODE_TO_STATE, getGermanyStateCode, LocationDTOSchema, LocationTeir;
var init_location_model = __esmMin((() => {
	init_lib();
	GermanyStateCode = /* @__PURE__ */ function(GermanyStateCode) {
		GermanyStateCode["BW"] = "BW";
		GermanyStateCode["BY"] = "BY";
		GermanyStateCode["BE"] = "BE";
		GermanyStateCode["BB"] = "BB";
		GermanyStateCode["HB"] = "HB";
		GermanyStateCode["HH"] = "HH";
		GermanyStateCode["HE"] = "HE";
		GermanyStateCode["MV"] = "MV";
		GermanyStateCode["NI"] = "NI";
		GermanyStateCode["NW"] = "NW";
		GermanyStateCode["RP"] = "RP";
		GermanyStateCode["SL"] = "SL";
		GermanyStateCode["SN"] = "SN";
		GermanyStateCode["ST"] = "ST";
		GermanyStateCode["SH"] = "SH";
		GermanyStateCode["TH"] = "TH";
		return GermanyStateCode;
	}({});
	STATE_CODE_MAPPINGS = {
		"Baden-Württemberg": "BW",
		"Baden-Wurttemberg": "BW",
		Bayern: "BY",
		Bavaria: "BY",
		Berlin: "BE",
		Brandenburg: "BB",
		Bremen: "HB",
		Hamburg: "HH",
		Hessen: "HE",
		Hesse: "HE",
		"Mecklenburg-Vorpommern": "MV",
		Niedersachsen: "NI",
		"Lower-Saxony": "NI",
		"Nordrhein-Westfalen": "NW",
		"North-Rhine-Westphalia": "NW",
		"Rheinland-Pfalz": "RP",
		"Rhineland-Palatinate": "RP",
		Saarland: "SL",
		Sachsen: "SN",
		Saxony: "SN",
		"Sachsen-Anhalt": "ST",
		"Schleswig-Holstein": "SH",
		Thüringen: "TH",
		Thuringia: "TH"
	};
	MAPPED_CODE_TO_STATE = invert(STATE_CODE_MAPPINGS);
	getGermanyStateCode = (state) => {
		if (!state) return;
		return STATE_CODE_MAPPINGS[state] ?? GermanyStateCode[state];
	};
	LocationDTOSchema = Type.Object({
		locationId: Type.Optional(Type.Number()),
		refUuid: Type.Optional(Type.String()),
		street: Type.Optional(Type.String()),
		addressLine2: Type.Optional(TNullable(Type.String())),
		houseNumber: Type.Optional(Type.String()),
		latitude: Type.Optional(Type.Number()),
		longitude: Type.Optional(Type.Number()),
		zipcode: Type.Optional(Type.String()),
		quarter: Type.Optional(Type.String()),
		city: Type.String(),
		county: Type.Optional(Type.String()),
		state: Type.Optional(Type.String()),
		country: Type.Optional(Type.String()),
		scoring: Type.Optional(Type.Object({
			queryScore: Type.Number(),
			fieldScore: Type.Object({
				city: Type.Optional(Type.Number()),
				streets: Type.Optional(Type.Array(Type.Number())),
				houseNumber: Type.Optional(Type.Number()),
				postalCode: Type.Optional(Type.Number())
			})
		}))
	}, { $id: "LocationDTO" });
	LocationTeir = /* @__PURE__ */ function(LocationTeir) {
		LocationTeir["A"] = "A";
		LocationTeir["B"] = "B";
		LocationTeir["C"] = "C";
		return LocationTeir;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/location/location.opts.ts
var init_location_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh.helpers.ts
var getCandidateLocationForMfh, getCandidateLocationAddress, getMergedMFHLocation, createAbbreviation, getRentIndexForPreAndPostRenovation, getRentIndexMetricsForArea, fromICOrMFHAttribute, candidateMfhPortfoliosFromRelations, maybeGetMFHProcessedFields, isMfhAcquisitionBlockedForThisPartner;
var init_mfh_helpers = __esmMin((() => {
	getCandidateLocationForMfh = (mfh) => {
		const loc = mfh.candidateLocation;
		if (loc) return loc;
		return (mfh.buildings?.[0])?.location;
	};
	getCandidateLocationAddress = (mfh) => {
		const loc = getCandidateLocationForMfh(mfh);
		if (!loc) return null;
		return addressFormatter({
			street: loc.street,
			houseNumber: loc.houseNumber,
			city: loc.city,
			zipcode: loc.zipcode
		});
	};
	getMergedMFHLocation = (mfh) => {
		const locations = mfh.buildings?.map((b) => b.location)?.filter((loc) => !!loc) ?? [];
		const minLocation = minBy(locations ?? [], "locationId");
		const groupedByStreetInEveryCity = Object.values(locations?.reduce((acc, obj) => {
			const key = `${obj.city}-${obj.street}`;
			if (!acc[key]) acc[key] = [];
			acc[key].push(obj);
			return acc;
		}, {}) ?? {});
		const streets = groupedByStreetInEveryCity?.map((l) => l[0].street).filter(Boolean).join(", ");
		const houseNumbers = groupedByStreetInEveryCity?.map((ls) => ls.map((l) => l.houseNumber).filter(Boolean).join(", ")).filter(Boolean).join(" ; ");
		return {
			street: streets.length ? streets : void 0,
			houseNumber: houseNumbers.length ? houseNumbers : void 0,
			zipcode: minLocation?.zipcode != null ? String(minLocation.zipcode) : void 0,
			city: minLocation?.city,
			latitude: minLocation?.latitude,
			longitude: minLocation?.longitude,
			regionName: minLocation?.region?.regionName,
			state: minLocation?.state,
			county: minLocation?.county,
			quarter: minLocation?.quarter
		};
	};
	createAbbreviation = (street, houseNumber) => {
		return `${unidecode(street || "XXX").replace(/( )/g, "")?.substring(0, 3).toUpperCase()}${houseNumber?.replace(/( )/g, "").toUpperCase() || "00"}`;
	};
	getRentIndexForPreAndPostRenovation = (rentIndexMetrics) => {
		return {
			rentIndexPreRenovation: rentIndexMetrics?.median,
			rentIndexPostRenovation: rentIndexMetrics?.max ? 1.1 * rentIndexMetrics?.max : void 0
		};
	};
	getRentIndexMetricsForArea = (rows, area) => {
		if (!rows.length || area == null) return;
		const row = rows.find((candidate) => area >= (candidate.areaMin ?? 0) && area < (candidate.areaMax ?? Number.POSITIVE_INFINITY));
		if (!row) return;
		return {
			min: row.minPrice,
			median: row.midPrice,
			max: row.maxPrice
		};
	};
	fromICOrMFHAttribute = (mfh, ic, icAttr, mfhAttr) => {
		return get(ic, icAttr) ?? get(mfh, mfhAttr);
	};
	candidateMfhPortfoliosFromRelations = (relations) => {
		if (!relations?.length) return [];
		return relations.flatMap((relation) => {
			const portfolio = relation.candidatePortfolio;
			if (!portfolio?.mfhPortfolioId) return [];
			return [{
				mfhPortfolioId: portfolio.mfhPortfolioId,
				...omitBy({
					name: portfolio.name,
					assetPartnerId: portfolio.assetPartnerId,
					isReserved: relation.isReserved,
					isPrimary: relation.isPrimary,
					blockedByPortfolioId: relation.blockedByPortfolioId
				}, isUndefined)
			}];
		});
	};
	maybeGetMFHProcessedFields = (mfh, source) => {
		if (!source) return mfh.processedFields;
		const processedFields = ["attributes", "price"].reduce((acc, path) => {
			const attr = get(mfh, path);
			if (!attr) return acc;
			return Object.assign({}, acc, Object.entries(attr).reduce((attrAcc, [key, val]) => {
				attrAcc[`${path}.${key}`] = Object.assign({}, mfh.processedFields?.[`${path}.${key}`], { [source]: val });
				return attrAcc;
			}, {}));
		}, {});
		return Object.assign({}, mfh.processedFields, processedFields);
	};
	isMfhAcquisitionBlockedForThisPartner = (mfh) => {
		const [candidatePipelineMfhPortfolio] = mfh.candidateMfhPortfolios ?? [];
		const [candidateMfhPortfolio] = mfh.candidateMfhPortfolios ?? [];
		const [mfhCandidatePortfolioRelation] = mfh.mfhCandidatePortfolioRelations ?? [];
		const mfhSummaryPortfolioPurchasing = mfh.processes?.portfolioPurchasing;
		return !!candidatePipelineMfhPortfolio && !!candidatePipelineMfhPortfolio.blockedByPortfolioId || !!candidateMfhPortfolio && !!candidateMfhPortfolio.mfhCandidatePortfolioRelations?.find((relation) => relation.mfhId === mfh.mfhId && relation.blockedByPortfolioId) || !!mfhCandidatePortfolioRelation && !!mfhCandidatePortfolioRelation.blockedByPortfolioId || !!mfhSummaryPortfolioPurchasing && !!mfhSummaryPortfolioPurchasing.blockedByPortfolioId;
	};
}));
//#endregion
//#region src/domains/cross-cutting/maps/maps.helpers.ts
var prepareGMAPLink, prepareLocationGMAPLink, STATIC_MAP_SIZES, DEFAULT_STATIC_MAP_SIZE, STATIC_MAP_TYPE, DEFAULT_SINGLE_MARKER_ZOOM, DEFAULT_CENTERED_MARKER_COLOR, DEFAULT_STATIC_MAP_SCALE, withStaticGMapsSize, hasCoordinates, createStaticGMapsLink, createStaticGMapsCenteredLink;
var init_maps_helpers = __esmMin((() => {
	init_errors();
	init_mfh_helpers();
	prepareGMAPLink = (location) => {
		if (location?.street && location?.houseNumber) return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(addressFormatter(location))}`;
	};
	prepareLocationGMAPLink = (location) => {
		if (location?.street && location?.houseNumber) return `https://www.google.com/maps?hl=de&layer=hybrid&q=${encodeURIComponent(addressFormatter(location))}`;
	};
	STATIC_MAP_SIZES = {
		cockpit: "900x480",
		ram: "900x630",
		icTeaserGermany: "400x300",
		icTeaserCity: "400x300"
	};
	DEFAULT_STATIC_MAP_SIZE = STATIC_MAP_SIZES.cockpit;
	STATIC_MAP_TYPE = "roadmap";
	DEFAULT_SINGLE_MARKER_ZOOM = 18;
	DEFAULT_CENTERED_MARKER_COLOR = "red";
	DEFAULT_STATIC_MAP_SCALE = 2;
	withStaticGMapsSize = (staticMapUrl, size) => {
		const url = new URL(staticMapUrl);
		if (!url.pathname.includes("/maps/api/staticmap")) throw new InvalidParamsError("URL is not a Google Static Maps API link");
		url.searchParams.set("size", size);
		return url.toString();
	};
	hasCoordinates = (loc) => loc.latitude != null && loc.longitude != null;
	createStaticGMapsLink = (mfhAddress, locations, staticMapsApiKey, options) => {
		if (!mfhAddress?.length || !locations?.length) throw new InvalidParamsError(`Need to provide a valid MFH address and at least one building-address to create static GMaps Link`);
		const geocodedLocations = locations.filter(hasCoordinates);
		if (!geocodedLocations.length) throw new InvalidParamsError(`Need at least one building with coordinates to create static GMaps Link`);
		const mapSize = options?.size ?? DEFAULT_STATIC_MAP_SIZE;
		const urlParams = new URLSearchParams();
		urlParams.append("size", mapSize);
		urlParams.append("maptype", STATIC_MAP_TYPE);
		if (geocodedLocations.length === 1) {
			const { latitude, longitude } = geocodedLocations[0];
			urlParams.append("center", `${latitude},${longitude}`);
			urlParams.append("zoom", String(DEFAULT_SINGLE_MARKER_ZOOM));
		} else urlParams.append("visible", geocodedLocations.map((loc) => `${loc.latitude},${loc.longitude}`).join("|"));
		for (const loc of geocodedLocations) urlParams.append("markers", `color:blue|label:${createAbbreviation(loc.street, loc.houseNumber)}|${loc.latitude},${loc.longitude}`);
		urlParams.append("key", staticMapsApiKey);
		return `https://maps.googleapis.com/maps/api/staticmap?${urlParams.toString()}`;
	};
	createStaticGMapsCenteredLink = (params) => {
		const { latitude, longitude, apiKey, zoom, visible, centerLatitude, centerLongitude, size, markerColor, scale, language, styles, omitMarker } = params;
		if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) throw new InvalidParamsError("Need finite latitude and longitude to create centered static GMaps link");
		if (!apiKey?.length) throw new InvalidParamsError("Need a Static Maps API key to create centered static GMaps link");
		if (zoom == null && visible == null) throw new InvalidParamsError("Need either zoom or visible bounds to create centered static GMaps link");
		if (visible != null) {
			const { south, west, north, east } = visible;
			if (![
				south,
				west,
				north,
				east
			].every(Number.isFinite)) throw new InvalidParamsError("Visible bounds must be finite numbers");
			if (south >= north || west >= east) throw new InvalidParamsError("Visible bounds must have south < north and west < east");
		}
		if ((centerLatitude != null || centerLongitude != null) && (!Number.isFinite(centerLatitude) || !Number.isFinite(centerLongitude))) throw new InvalidParamsError("Map center latitude and longitude must both be finite when provided");
		const urlParams = new URLSearchParams();
		urlParams.append("size", size ?? DEFAULT_STATIC_MAP_SIZE);
		urlParams.append("maptype", STATIC_MAP_TYPE);
		urlParams.append("scale", String(scale ?? DEFAULT_STATIC_MAP_SCALE));
		if (!omitMarker) urlParams.append("markers", `color:${markerColor ?? DEFAULT_CENTERED_MARKER_COLOR}|${latitude},${longitude}`);
		if (language) urlParams.append("language", language);
		for (const style of styles ?? []) urlParams.append("style", style);
		if (visible != null) urlParams.append("visible", `${visible.south},${visible.west}|${visible.north},${visible.east}`);
		else {
			const mapCenterLat = centerLatitude ?? latitude;
			const mapCenterLng = centerLongitude ?? longitude;
			urlParams.append("center", `${mapCenterLat},${mapCenterLng}`);
			urlParams.append("zoom", String(zoom));
		}
		urlParams.append("key", apiKey);
		return `https://maps.googleapis.com/maps/api/staticmap?${urlParams.toString()}`;
	};
}));
//#endregion
//#region src/domains/cross-cutting/maps/places.types.ts
var PlacesRankPreference;
var init_places_types = __esmMin((() => {
	PlacesRankPreference = /* @__PURE__ */ function(PlacesRankPreference) {
		PlacesRankPreference["Popularity"] = "POPULARITY";
		PlacesRankPreference["Distance"] = "DISTANCE";
		return PlacesRankPreference;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/maps/routing.types.ts
var RouteTravelMode, RouteMatrixEntryStatus;
var init_routing_types = __esmMin((() => {
	RouteTravelMode = /* @__PURE__ */ function(RouteTravelMode) {
		RouteTravelMode["Car"] = "car";
		RouteTravelMode["Pedestrian"] = "pedestrian";
		RouteTravelMode["Bicycle"] = "bicycle";
		return RouteTravelMode;
	}({});
	RouteMatrixEntryStatus = /* @__PURE__ */ function(RouteMatrixEntryStatus) {
		RouteMatrixEntryStatus["Ok"] = "ok";
		RouteMatrixEntryStatus["NotFound"] = "not_found";
		RouteMatrixEntryStatus["Error"] = "error";
		return RouteMatrixEntryStatus;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/maps/index.ts
var init_maps = __esmMin((() => {
	init_maps_helpers();
	init_places_types();
	init_routing_types();
}));
//#endregion
//#region src/domains/cross-cutting/location/location-analysis.model.ts
var LOCATION_ANALYSIS_CATEGORY_KEYS, DEFAULT_LOCATION_ANALYSIS_RADIUS_METERS, MAX_LOCATION_ANALYSIS_RADIUS_METERS, LOCATION_ANALYSIS_REVIEW_NOTICE, LocationAnalysisCategorySchema, LocationAnalysisCoordinatesSchema, LocationAnalysisSubjectSchema, LocationAnalysisRouteSchema, LocationAnalysisAccessibilityLocationSchema, LocationAnalysisAccessibilityCategorySchema, LocationAnalysisRoutingSchema, LocationAnalysisAccessibilitySchema, LocationAnalysisSourceSchema, LocationAnalysisContextSchema, LocationAssessmentChipSchema, LocationAssessmentBlockSchema, LocationMicroAssessmentBlockSchema, LocationNarrativeSchema, LocationAnalysisGeneratedAssessmentSchema, LocationAnalysisFailedAssessmentSchema, LocationAnalysisResponseSchema, MfhLocationAnalysisRequestSchema, MfhLocationAnalysisRunningStateSchema, MfhLocationAnalysisCompletedStateSchema, MfhLocationAnalysisFailedStateSchema, MfhLocationAnalysisStateSchema, GenerateMfhLocationAnalysisParamsSchema, GenerateMfhLocationAnalysisResultSchema, ComputeMfhLocationRouteBodySchema, ComputeMfhLocationRouteParamsSchema;
var init_location_analysis_model = __esmMin((() => {
	init_maps();
	LOCATION_ANALYSIS_CATEGORY_KEYS = [
		"school",
		"restaurants",
		"supermarket",
		"public_transport",
		"healthcare",
		"park",
		"city_centre",
		"airport"
	];
	DEFAULT_LOCATION_ANALYSIS_RADIUS_METERS = 2500;
	MAX_LOCATION_ANALYSIS_RADIUS_METERS = 5e4;
	LOCATION_ANALYSIS_REVIEW_NOTICE = "Model output, analyst review required";
	LocationAnalysisCategorySchema = Type.Union([
		Type.Literal("school"),
		Type.Literal("restaurants"),
		Type.Literal("supermarket"),
		Type.Literal("public_transport"),
		Type.Literal("healthcare"),
		Type.Literal("park"),
		Type.Literal("city_centre"),
		Type.Literal("airport")
	]);
	LocationAnalysisCoordinatesSchema = Type.Object({
		latitude: Type.Number(),
		longitude: Type.Number()
	});
	LocationAnalysisSubjectSchema = Type.Object({
		coordinates: LocationAnalysisCoordinatesSchema,
		radiusMeters: Type.Number({ exclusiveMinimum: 0 })
	});
	LocationAnalysisRouteSchema = Type.Object({
		status: Type.Enum(RouteMatrixEntryStatus),
		distanceMeters: Type.Optional(Type.Integer({ minimum: 0 })),
		durationSeconds: Type.Optional(Type.Integer({ minimum: 0 })),
		travelMode: Type.Enum(RouteTravelMode)
	});
	LocationAnalysisAccessibilityLocationSchema = Type.Object({
		name: Type.String(),
		formattedAddress: Type.Optional(Type.String()),
		location: LocationAnalysisCoordinatesSchema,
		googleRating: Type.Optional(Type.Number()),
		types: Type.Array(Type.String()),
		category: LocationAnalysisCategorySchema,
		route: Type.Optional(LocationAnalysisRouteSchema)
	});
	LocationAnalysisAccessibilityCategorySchema = Type.Object({
		category: LocationAnalysisCategorySchema,
		status: Type.Union([
			Type.Literal("found"),
			Type.Literal("not_found"),
			Type.Literal("error")
		]),
		locationCount: Type.Integer({ minimum: 0 }),
		error: Type.Optional(Type.String())
	});
	LocationAnalysisRoutingSchema = Type.Object({
		status: Type.Union([
			Type.Literal("complete"),
			Type.Literal("partial"),
			Type.Literal("error")
		]),
		travelModes: Type.Array(Type.Enum(RouteTravelMode)),
		routedLocationCount: Type.Integer({ minimum: 0 }),
		totalLocationCount: Type.Integer({ minimum: 0 }),
		error: Type.Optional(Type.String())
	});
	LocationAnalysisAccessibilitySchema = Type.Object({
		status: Type.Union([
			Type.Literal("complete"),
			Type.Literal("partial"),
			Type.Literal("error")
		]),
		locations: Type.Array(LocationAnalysisAccessibilityLocationSchema),
		categories: Type.Array(LocationAnalysisAccessibilityCategorySchema, {
			minItems: LOCATION_ANALYSIS_CATEGORY_KEYS.length,
			maxItems: LOCATION_ANALYSIS_CATEGORY_KEYS.length
		}),
		routing: LocationAnalysisRoutingSchema
	});
	LocationAnalysisSourceSchema = Type.Object({
		id: Type.String(),
		label: Type.String()
	});
	LocationAnalysisContextSchema = Type.Object({
		subject: LocationAnalysisSubjectSchema,
		accessibility: LocationAnalysisAccessibilitySchema,
		sources: Type.Array(LocationAnalysisSourceSchema),
		errors: Type.Array(Type.String())
	});
	LocationAssessmentChipSchema = Type.Object({
		label: Type.String({ minLength: 1 }),
		sentiment: Type.Union([
			Type.Literal("positive"),
			Type.Literal("neutral"),
			Type.Literal("negative")
		])
	});
	LocationAssessmentBlockSchema = Type.Object({
		paragraphs: Type.Array(Type.String({ minLength: 1 }), {
			minItems: 1,
			maxItems: 2
		}),
		chips: Type.Array(LocationAssessmentChipSchema, {
			minItems: 4,
			maxItems: 8
		})
	});
	LocationMicroAssessmentBlockSchema = Type.Object({
		paragraphs: Type.Array(Type.String({ minLength: 1 }), {
			minItems: 1,
			maxItems: 2
		}),
		chips: Type.Array(LocationAssessmentChipSchema, {
			minItems: 4,
			maxItems: 8
		})
	});
	LocationNarrativeSchema = Type.Object({
		macro: LocationAssessmentBlockSchema,
		micro: LocationMicroAssessmentBlockSchema
	});
	LocationAnalysisGeneratedAssessmentSchema = Type.Object({
		status: Type.Literal("generated"),
		macro: LocationAssessmentBlockSchema,
		micro: LocationMicroAssessmentBlockSchema
	});
	LocationAnalysisFailedAssessmentSchema = Type.Object({
		status: Type.Literal("error"),
		macro: Type.Null(),
		micro: Type.Null(),
		error: Type.String()
	});
	LocationAnalysisResponseSchema = Type.Object({
		status: Type.Literal("partial"),
		generatedAt: Type.String({ format: "date-time" }),
		model: Type.String(),
		reviewNotice: Type.Literal(LOCATION_ANALYSIS_REVIEW_NOTICE),
		subject: LocationAnalysisSubjectSchema,
		assessment: Type.Union([LocationAnalysisGeneratedAssessmentSchema, LocationAnalysisFailedAssessmentSchema]),
		accessibility: LocationAnalysisAccessibilitySchema,
		sources: Type.Array(LocationAnalysisSourceSchema),
		errors: Type.Array(Type.String())
	});
	MfhLocationAnalysisRequestSchema = Type.Object({
		generationId: Type.String({ format: "uuid" }),
		requestedAt: Type.String({ format: "date-time" }),
		requestedBy: Type.String({ minLength: 1 }),
		radiusMeters: Type.Number({ exclusiveMinimum: 0 })
	});
	MfhLocationAnalysisRunningStateSchema = Type.Composite([Type.Object({ status: Type.Literal("running") }), MfhLocationAnalysisRequestSchema]);
	MfhLocationAnalysisCompletedStateSchema = Type.Composite([Type.Object({
		status: Type.Literal("completed"),
		completedAt: Type.String({ format: "date-time" }),
		result: LocationAnalysisResponseSchema
	}), MfhLocationAnalysisRequestSchema]);
	MfhLocationAnalysisFailedStateSchema = Type.Composite([Type.Object({
		status: Type.Literal("failed"),
		failedAt: Type.String({ format: "date-time" }),
		error: Type.String({ minLength: 1 })
	}), MfhLocationAnalysisRequestSchema]);
	MfhLocationAnalysisStateSchema = Type.Union([
		MfhLocationAnalysisRunningStateSchema,
		MfhLocationAnalysisCompletedStateSchema,
		MfhLocationAnalysisFailedStateSchema
	]);
	GenerateMfhLocationAnalysisParamsSchema = Type.Object({
		mfhId: Type.Integer({ minimum: 1 }),
		generationId: Type.String({ format: "uuid" }),
		requestedBy: Type.String({ minLength: 1 }),
		radiusMeters: Type.Number({
			exclusiveMinimum: 0,
			maximum: MAX_LOCATION_ANALYSIS_RADIUS_METERS
		}),
		policy: Type.Union([Type.Literal("force"), Type.Literal("ifAbsent")])
	});
	GenerateMfhLocationAnalysisResultSchema = Type.Object({
		generationId: Type.String({ format: "uuid" }),
		outcome: Type.Union([
			Type.Literal("completed"),
			Type.Literal("failed"),
			Type.Literal("superseded"),
			Type.Literal("skipped")
		]),
		state: Type.Union([MfhLocationAnalysisStateSchema, Type.Null()])
	});
	ComputeMfhLocationRouteBodySchema = Type.Object({
		category: LocationAnalysisCategorySchema,
		origin: LocationAnalysisCoordinatesSchema,
		destination: LocationAnalysisCoordinatesSchema
	});
	ComputeMfhLocationRouteParamsSchema = Type.Composite([Type.Object({ mfhId: Type.Integer({ minimum: 1 }) }), ComputeMfhLocationRouteBodySchema]);
}));
//#endregion
//#region src/domains/cross-cutting/location/index.ts
var init_location = __esmMin((() => {
	init_location_model();
	init_location_opts();
	init_location_analysis_model();
}));
//#endregion
//#region src/domains/cross-cutting/media-file/media-file.opts.ts
var init_media_file_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/media-file/media-file.base.ts
var MediaFileCategory, MediaFileVariant, PreDefinedTag, MfhMediaPredfinedTags, InternalTag, ExposeMediaTags, ExposeMediaTagsFallbackTemplates;
var init_media_file_base = __esmMin((() => {
	MediaFileCategory = /* @__PURE__ */ function(MediaFileCategory) {
		MediaFileCategory["Listing"] = "Listing";
		MediaFileCategory["Inspection"] = "Inspection";
		MediaFileCategory["PreRenovation"] = "PreRenovation";
		MediaFileCategory["PostRenovation"] = "PostRenovation";
		MediaFileCategory["Renovation"] = "Renovation";
		MediaFileCategory["Avatar"] = "Avatar";
		MediaFileCategory["Other"] = "Other";
		MediaFileCategory["PropertyManagement"] = "PropertyManagement";
		MediaFileCategory["Livings"] = "Livings";
		MediaFileCategory["TechnicalDDInspection"] = "TechnicalDDInspection";
		return MediaFileCategory;
	}({});
	MediaFileVariant = /* @__PURE__ */ function(MediaFileVariant) {
		MediaFileVariant["Thumb"] = "Thumb";
		MediaFileVariant["Listing"] = "Listing";
		return MediaFileVariant;
	}({});
	PreDefinedTag = /* @__PURE__ */ function(PreDefinedTag) {
		PreDefinedTag["Defect"] = "defect";
		PreDefinedTag["Publish"] = "publish";
		PreDefinedTag["ConstructionPlan"] = "construction-plan";
		PreDefinedTag["Inspection"] = "inspection";
		PreDefinedTag["BeforeAfter"] = "before-after";
		PreDefinedTag["ExposeBuilding"] = "expose-building";
		PreDefinedTag["ExposeKitchen"] = "expose-kitchen";
		PreDefinedTag["ExposeLivingRoom"] = "expose-living-room";
		PreDefinedTag["ExposeBathroom"] = "expose-bathroom";
		PreDefinedTag["Summary"] = "summary";
		PreDefinedTag["ExposeRoom1"] = "expose-room-1";
		PreDefinedTag["ExposeRoom2"] = "expose-room-2";
		PreDefinedTag["ExposeRoom3"] = "expose-room-3";
		PreDefinedTag["Parking"] = "parking";
		PreDefinedTag["KeyLocker"] = "key-locker";
		PreDefinedTag["BuildingEntrance"] = "building-entrance";
		PreDefinedTag["ApartmentDoor"] = "apartment-door";
		PreDefinedTag["TemplateExposeBathroom"] = "template-expose-bathroom";
		PreDefinedTag["TemplateExposeKitchen"] = "template-expose-kitchen";
		PreDefinedTag["TemplateExposeLivingRoom"] = "template-expose-living-room";
		PreDefinedTag["TemplateExposeRoom1"] = "template-expose-room-1";
		PreDefinedTag["TemplateExposeRoom2"] = "template-expose-room-2";
		PreDefinedTag["TemplateExposeRoom3"] = "template-expose-room-3";
		PreDefinedTag["RentingManagement"] = "renting-management";
		PreDefinedTag["ExteriorViews"] = "exterior-views";
		PreDefinedTag["Apartments"] = "apartments";
		PreDefinedTag["CommercialProperties"] = "commercial-properties";
		PreDefinedTag["Marketing"] = "marketing";
		PreDefinedTag["MainPhotoPreRenovation"] = "main-photo-pre-renovation";
		PreDefinedTag["MainPhotoPostRenovation"] = "main-photo-post-renovation";
		return PreDefinedTag;
	}({});
	MfhMediaPredfinedTags = [
		"summary",
		"exterior-views",
		"apartments",
		"commercial-properties",
		"marketing",
		"main-photo-pre-renovation",
		"main-photo-post-renovation"
	];
	InternalTag = /* @__PURE__ */ function(InternalTag) {
		InternalTag["ListingTitle"] = "listing-title";
		InternalTag["FloorPlan"] = "floor-plan";
		return InternalTag;
	}({});
	ExposeMediaTags = [
		"expose-kitchen",
		"expose-living-room",
		"expose-bathroom",
		"expose-building",
		"expose-room-1",
		"expose-room-2",
		"expose-room-3"
	];
	ExposeMediaTagsFallbackTemplates = [
		"template-expose-bathroom",
		"template-expose-kitchen",
		"template-expose-living-room",
		"template-expose-room-1",
		"template-expose-room-2",
		"template-expose-room-3"
	];
}));
//#endregion
//#region src/domains/cross-cutting/media-file/media-file.model.ts
function isMediaFile(possibleMediaFile) {
	return Boolean(possibleMediaFile.mediaFileId);
}
var MediaFileDTOSchema, TECHNICAL_DD_EXTERNAL_MEDIA_CATEGORIES;
var init_media_file_model = __esmMin((() => {
	init_media_file_base();
	MediaFileDTOSchema = Type.Object({
		url: Type.String(),
		type: Type.Union([
			Type.Literal("common:Picture"),
			Type.Literal("common:Link"),
			Type.Literal("common:StreamingVideo"),
			Type.Literal("common:PDFDocument"),
			Type.Literal("geomap:Media")
		]),
		originalId: Type.Optional(Type.String()),
		title: Type.Optional(Type.String()),
		isFloorPlan: Type.Boolean(),
		isTitlePicture: Type.Boolean(),
		hash: Type.Optional(Type.String()),
		uuid: Type.Optional(Type.String()),
		path: Type.Optional(Type.String()),
		link: Type.Optional(Type.String()),
		mimeType: Type.Optional(Type.String()),
		filename: Type.Optional(Type.String()),
		tags: Type.Optional(Type.Union([Type.Array(Type.Enum(PreDefinedTag)), Type.Array(Type.String())])),
		category: Type.Optional(Type.Enum(MediaFileCategory)),
		internalTags: Type.Optional(Type.Array(Type.Enum(InternalTag)))
	}, { $id: "MediaFileDTO" });
	TECHNICAL_DD_EXTERNAL_MEDIA_CATEGORIES = [
		"Listing",
		"Inspection",
		"TechnicalDDInspection"
	];
}));
//#endregion
//#region src/domains/cross-cutting/media-file/media-file.i18n.ts
var MediaFileCategoryTranslations;
var init_media_file_i18n = __esmMin((() => {
	MediaFileCategoryTranslations = {
		["Listing"]: "Listing",
		["Inspection"]: "Viewing",
		["PreRenovation"]: "Pre-Renovation",
		["PostRenovation"]: "Post-Renovation",
		["Renovation"]: "Renovation",
		["Avatar"]: "Avatar",
		["Other"]: "Other",
		["PropertyManagement"]: "Property Management",
		["Livings"]: "Livings",
		["TechnicalDDInspection"]: "Technical DD Inspection"
	};
}));
//#endregion
//#region src/domains/cross-cutting/media-file/index.ts
var init_media_file = __esmMin((() => {
	init_media_file_opts();
	init_media_file_model();
	init_media_file_base();
	init_media_file_i18n();
}));
//#endregion
//#region src/domains/cross-cutting/estates/discoverer-estate.model.ts
var DiscovererEstateProviders, RawProviderDataSchema, DiscovererEstateSchema;
var init_discoverer_estate_model = __esmMin((() => {
	init_external_data();
	init_location();
	init_media_file();
	init_estate_attributes();
	init_estate_price();
	init_estate_model();
	DiscovererEstateProviders = /* @__PURE__ */ function(DiscovererEstateProviders) {
		DiscovererEstateProviders["IS24"] = "is24";
		DiscovererEstateProviders["GEOMAP"] = "geomap";
		DiscovererEstateProviders["PRICEHUBBLE"] = "pricehubble";
		DiscovererEstateProviders["SAAS"] = "saas";
		return DiscovererEstateProviders;
	}({});
	RawProviderDataSchema = Type.Object({
		provider: Type.Enum(DiscovererEstateProviders),
		data: Type.Object({})
	}, { $id: "RawProviderData" });
	DiscovererEstateSchema = Type.Intersect([EstateDTOSchema, Type.Object({
		price: PriceDTOSchema,
		location: LocationDTOSchema,
		attributes: DiscovererAttributesDTOSchema,
		externalLink: Type.Array(ExternalLinkDTOSchema),
		media: Type.Array(MediaFileDTOSchema),
		contacts: Type.Array(Type.Any()),
		rawProviderData: Type.Optional(RawProviderDataSchema),
		processedFields: Type.Optional(Type.Record(Type.String(), Type.Record(Type.Union([
			Type.Literal("geomap"),
			Type.Literal("is24"),
			Type.Literal("gpt"),
			Type.Literal("infas"),
			Type.Literal("computed"),
			Type.Literal("manual")
		]), Type.Any())))
	})], { $id: "DiscovererEstate" });
}));
//#endregion
//#region src/domains/cross-cutting/estates/sourcing-estate.model.ts
var SourcingEstateStatus, SourcingEstateIgnoredUpdatePaths, ensureIntValue, transformSourcingEstateToDiscovererEstate;
var init_sourcing_estate_model = __esmMin((() => {
	SourcingEstateStatus = /* @__PURE__ */ function(SourcingEstateStatus) {
		SourcingEstateStatus["Active"] = "active";
		SourcingEstateStatus["Inactive"] = "inactive";
		return SourcingEstateStatus;
	}({});
	SourcingEstateIgnoredUpdatePaths = [
		"id",
		"status",
		"_status",
		"adModificationDate",
		"adPublishingDate",
		"createdAt",
		"updatedAt",
		"rawProviderData",
		"checksum",
		"originalId",
		"areaId",
		"community",
		"region",
		"cityShort"
	];
	ensureIntValue = (val) => {
		if (typeof val === "number") return val | 0;
		if (typeof val === "string") return Number(val);
		if (!val) return;
		return Number.parseInt(val.toString(), 10);
	};
	transformSourcingEstateToDiscovererEstate = (estate) => {
		const location = {
			quarter: estate.quarter,
			street: estate.street,
			houseNumber: estate.houseNumber,
			latitude: estate.latitude,
			longitude: estate.longitude,
			country: estate.country,
			zipcode: estate.zipcode,
			city: estate.city
		};
		const price = {
			currency: estate.currency,
			purchasePriceNett: estate.purchasePriceNett,
			purchasePriceGross: estate.purchasePriceGross,
			courtage: estate.courtage,
			courtageMultiplier: estate.courtageMultiplier,
			houseGeld: estate.houseGeld,
			parkingSpacePrice: estate.parkingSpacePrice,
			referralFeePercent: estate.referralFeePercent,
			rentalIncome: estate.rentalIncome
		};
		const attributes = {
			livingSpace: estate.livingSpace,
			rooms: ensureIntValue(estate.rooms),
			interiorQuality: estate.interiorQuality,
			condition: estate.condition,
			bedrooms: ensureIntValue(estate.bedrooms),
			numberOfBathRooms: ensureIntValue(estate.numberOfBathRooms),
			numberOfParkingSpaces: ensureIntValue(estate.numberOfParkingSpaces),
			yearsSinceRenovation: ensureIntValue(estate.yearsSinceRenovation),
			primaryHeatingType: estate.primaryHeatingType,
			freeFromCategory: estate.freeFromCategory,
			descriptionNote: estate.descriptionNote,
			apartmentType: estate.apartmentType,
			constructionYear: ensureIntValue(estate.constructionYear),
			buildingAge: ensureIntValue(estate.buildingAge),
			categoryName: estate.categoryName,
			floor: ensureIntValue(estate.floor),
			floorLocation: estate.floorLocation,
			numberOfFloors: ensureIntValue(estate.numberOfFloors),
			numberOfWindows: ensureIntValue(estate.numberOfWindows),
			alignmentBalcony: estate.alignmentBalcony,
			flooring: estate.flooring,
			heatingType: estate.heatingType,
			secondaryHeatingType: estate.secondaryHeatingType,
			tertiaryHeatingType: estate.tertiaryHeatingType,
			energyConsumptionCategory: estate.energyConsumptionCategory,
			energyConsumption: estate.energyConsumption,
			energyCertificateCreationDate: estate.energyCertificateCreationDate,
			freeFrom: estate.freeFrom,
			furnishingNote: estate.furnishingNote,
			locationNote: estate.locationNote,
			otherNote: estate.otherNote,
			districtCourt: estate.districtCourt,
			parkingSpaceType: estate.parkingSpaceType,
			parkingSpacePrice: estate.parkingSpacePrice,
			isEligibleForSubsidising: estate.isEligibleForSubsidising ?? false,
			isHeritageBuilding: estate.isHeritageBuilding ?? false,
			energyPerformanceCertificate: estate.energyPerformanceCertificate ?? false,
			energyConsumptionContainsWarmWater: estate.energyConsumptionContainsWarmWater ?? false,
			heatingCostsInServiceCharge: estate.heatingCostsInServiceCharge ?? false,
			restaurantTerrace: estate.restaurantTerrace ?? false,
			builtInKitchen: estate.builtInKitchen ?? false,
			guestToilet: estate.guestToilet ?? false,
			furnished: estate.furnished ?? false,
			bikeRoom: estate.bikeRoom ?? false,
			lift: estate.lift ?? false,
			balcony: estate.balcony ?? false,
			garden: estate.garden ?? false,
			cellar: estate.cellar ?? false,
			buildingBasementPresent: estate.cellar ?? void 0,
			energyCertificateAvailability: estate.energyCertificateAvailability ?? false,
			handicappedAccessible: estate.handicappedAccessible ?? false,
			assistedLiving: estate.assistedLiving ?? false,
			lastRefurbishment: estate.lastRefurbishment,
			washingMachineRoom: estate.washingMachineRoom ?? false,
			isVacationHome: estate.isVacationHome ?? false,
			fireplace: estate.fireplace ?? false,
			petsAllowed: estate.petsAllowed ?? false,
			avgSpacePerRoom: estate.avgSpacePerRoom
		};
		const externalLink = estate.externalLink ?? [];
		const media = estate.media ?? [];
		const contacts = estate.contacts ?? [];
		return {
			...omit(estate, Object.keys({
				...location,
				...price,
				...attributes,
				...externalLink,
				...media,
				...contacts
			})),
			price,
			attributes,
			location,
			externalLink,
			media,
			contacts
		};
	};
}));
//#endregion
//#region src/domains/cross-cutting/estates/preprocessed-estate.model.ts
var DuplicationCategory;
var init_preprocessed_estate_model = __esmMin((() => {
	DuplicationCategory = /* @__PURE__ */ function(DuplicationCategory) {
		DuplicationCategory["LINK_FOUND"] = "LINK_FOUND";
		DuplicationCategory["ADDRESS_FOUND"] = "ADDRESS_FOUND";
		DuplicationCategory["ATTRIBUTES_FOUND"] = "ATTRIBUTES_FOUND";
		DuplicationCategory["TITLE_MATCH"] = "TITLE_MATCH";
		return DuplicationCategory;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/estates/parking-space.model.ts
var init_parking_space_model = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/estates/estate-credential.model.ts
var init_estate_credential_model = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/estates/estate.opts.ts
var init_estate_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/estates/inspection.model.ts
var InspectionState, InspectionCategory;
var init_inspection_model = __esmMin((() => {
	InspectionState = /* @__PURE__ */ function(InspectionState) {
		InspectionState["Draft"] = "Draft";
		InspectionState["Completed"] = "Completed";
		InspectionState["Review"] = "Review";
		InspectionState["Submitted"] = "Submitted";
		return InspectionState;
	}({});
	InspectionCategory = /* @__PURE__ */ function(InspectionCategory) {
		InspectionCategory["Sourcing"] = "Sourcing";
		InspectionCategory["Purchasing"] = "Purchasing";
		return InspectionCategory;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/estates/inspection.opts.ts
var init_inspection_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/estates/estate-attributes.opts.ts
var init_estate_attributes_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/estates/e2e-estate.model.ts
var E2EScenarioName;
var init_e2e_estate_model = __esmMin((() => {
	E2EScenarioName = /* @__PURE__ */ function(E2EScenarioName) {
		E2EScenarioName["SOURCING_PREAPPROVED_ESTATE"] = "SOURCING_PREAPPROVED_ESTATE";
		E2EScenarioName["SOURCING_MOVE_PREAPPROVED_TO_INSPECTED"] = "SOURCING_MOVE_PREAPPROVED_TO_INSPECTED";
		E2EScenarioName["SOURCING_FINALIZE_INSPECTED_ESTATE"] = "SOURCING_FINALIZE_INSPECTED_ESTATE";
		E2EScenarioName["PURCHASING_FINALIZE_OFFER_ACCEPTED_ESTATE"] = "PURCHASING_FINALIZE_OFFER_ACCEPTED_ESTATE";
		E2EScenarioName["RENOVATION_IDENTIFIED_TO_BRIEFED"] = "RENOVATION_IDENTIFIED_TO_BRIEFED";
		E2EScenarioName["RENOVATION_BRIEFED_TO_IN_RENOVATION"] = "RENOVATION_BRIEFED_TO_IN_RENOVATION";
		E2EScenarioName["RENOVATION_IN_RENOVATION_TO_COMPLETED"] = "RENOVATION_IN_RENOVATION_TO_COMPLETED";
		E2EScenarioName["SELLING_IDENTIFIED_EXPOSE"] = "SELLING_IDENTIFIED_EXPOSE";
		E2EScenarioName["SELLING_FRF_OFFER_ACCEPTED"] = "SELLING_FRF_OFFER_ACCEPTED";
		E2EScenarioName["SELLING_OFFER_ACCEPTED_TO_COMPLETE"] = "SELLING_OFFER_ACCEPTED_TO_COMPLETE";
		E2EScenarioName["PM_INIT_OWNER"] = "PM_INIT_OWNER";
		E2EScenarioName["PM_CREATE_RENTING_LEAD"] = "PM_CREATE_RENTING_LEAD";
		E2EScenarioName["PM_CREATE_DRAFT_RENTAL_CONTRACT"] = "PM_CREATE_DRAFT_RENTAL_CONTRACT";
		E2EScenarioName["PM_CREATE_APPROVED_RENTAL_CONTRACT"] = "PM_CREATE_APPROVED_RENTAL_CONTRACT";
		E2EScenarioName["PM_CREATE_SIGNED_RENTAL_CONTRACT"] = "PM_CREATE_SIGNED_RENTAL_CONTRACT";
		return E2EScenarioName;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/estates/index.ts
var init_estates = __esmMin((() => {
	init_estate_attributes();
	init_estate_price();
	init_estate_model();
	init_estate_overview_model();
	init_estate_base();
	init_estate_helpers();
	init_discoverer_estate_model();
	init_sourcing_estate_model();
	init_preprocessed_estate_model();
	init_parking_space_model();
	init_estate_credential_model();
	init_estate_opts();
	init_inspection_model();
	init_inspection_opts();
	init_estate_attributes_opts();
	init_e2e_estate_model();
}));
//#endregion
//#region src/lib/should-share-with-partner.ts
var shouldShareWithPartner;
var init_should_share_with_partner = __esmMin((() => {
	init_estates();
	shouldShareWithPartner = (condition) => !condition || condition && ![
		"FirstTimeUseAfterRefurbishment",
		"FirstTimeUse",
		"Modernized",
		"MintCondition",
		"FullyRenovated",
		"Refurbished"
	].includes(condition);
}));
//#endregion
//#region src/lib/type-helpers.ts
function enumOrderedValues(_enumType, values) {
	return values;
}
var AllKeys;
var init_type_helpers = __esmMin((() => {
	AllKeys = () => (keys) => keys;
}));
//#endregion
//#region src/lib/table-formatters.ts
var tableAnchorLink, withTableCellFormat, getTableCellFormat, tableCellFormatter, fromTabularData;
var init_table_formatters = __esmMin((() => {
	tableAnchorLink = (name, l) => l?.length ? `<a class="text-blue-400 font-semibold" href="${l}" target="_blank">${name}</a>` : void 0;
	withTableCellFormat = (format, formatter) => Object.assign(formatter, { format });
	getTableCellFormat = (formatter) => {
		if (typeof formatter !== "function" && typeof formatter !== "object" || formatter === null) return;
		const format = formatter.format;
		switch (format) {
			case "number":
			case "squareMeter":
			case "multiple":
			case "percent":
			case "currency":
			case "currencyPerSquareMeter": return format;
			default: return;
		}
	};
	tableCellFormatter = {
		numeric: withTableCellFormat("number", (v) => {
			if (isNil(v)) return "";
			return localNumberFormat(v, 0, 2);
		}),
		sqm: withTableCellFormat("squareMeter", (v) => {
			if (isNil(v)) return "";
			return `${localNumberFormat(round$1(v, 2), 0, 2)} m²`;
		}),
		multiple: withTableCellFormat("multiple", (v) => {
			if (isNil(v)) return "";
			return multiple(localNumberFormat(v, 0, 2));
		}),
		percent: withTableCellFormat("percent", (v) => {
			if (isNil(v)) return "";
			return percentage(v, 2);
		}),
		currency: withTableCellFormat("currency", (v, threshold = 100) => {
			if (isNil(v)) return "";
			const digits = Math.abs(v) >= threshold ? 0 : 2;
			return currency(v, digits, digits, "EUR", false);
		}),
		currencySqm: withTableCellFormat("currencyPerSquareMeter", (v, threshold = 100) => {
			if (isNil(v)) return "";
			if (Math.abs(v) >= threshold) return perSquareMeter(currency(v, 0, 2));
			return perSquareMeter(currency(v, 2, 2));
		})
	};
	fromTabularData = (tabData, prop, opts) => {
		if (!tabData || !tabData.rows[prop]) return {};
		return Object.entries(tabData.rows[prop]).reduce((acc, [rowKey, rowValue]) => {
			if (opts?.allowedKeys?.length && !opts.allowedKeys.includes(rowKey)) return acc;
			if (isNil(rowValue) || rowValue === "") {
				acc[rowKey] = "-";
				return acc;
			}
			const formatter = opts?.formatter?.[rowKey] ?? opts?.defaultFormatter;
			acc[rowKey] = formatter ? {
				value: rowValue,
				formatted: formatter(rowValue),
				format: getTableCellFormat(formatter)
			} : rowValue;
			return acc;
		}, {});
	};
}));
//#endregion
//#region src/lib/index.ts
var init_lib = __esmMin((() => {
	init_context();
	init_env_config();
	init_event_helpers();
	init_get_expected_months_of_rent_paid();
	init_helpers$4();
	init_orm();
	init_service_uid();
	init_shared_schemas();
	init_should_share_with_partner();
	init_type_helpers();
	init_typebox();
	init_table_formatters();
}));
//#endregion
//#region src/__unsorted/pagination.ts
var PaginationFieldsSchema, Pagination;
var init_pagination = __esmMin((() => {
	init_errors();
	init_lib();
	PaginationFieldsSchema = Type.Object({
		order: Type.Optional(TStringEnum(["ASC", "DESC"])),
		orderBy: Type.Optional(Type.String()),
		multiOrder: Type.Optional(Type.Array(Type.Tuple([Type.String(), TStringEnum(["ASC", "DESC"])]))),
		size: Type.Optional(Type.Number({ minimum: 1 })),
		page: Type.Optional(Type.Number({ minimum: 0 }))
	});
	Pagination = class {
		size;
		page;
		total;
		hasNextPage;
		hasPreviousPage;
		totalPages;
		constructor(total, paginationParams) {
			if (isNil(paginationParams.page) || isNil(paginationParams.size)) throw new InvalidParamsError("Pagination Params should be provided.");
			this.total = total;
			this.size = paginationParams.size;
			this.page = paginationParams.page;
			this.hasNextPage = (this.page + 1) * this.size < this.total;
			this.hasPreviousPage = this.page > 0;
			this.totalPages = Math.ceil(this.total / this.size);
		}
	};
}));
//#endregion
//#region src/domains/transaction/cashflow-prediction/cashflow-prediction.base.ts
var CashflowMilestone, orderedCashflowMilestonesForPredictions, CoreCashflowMilestones, ExpenseOnlyMilestones, CashflowPredictionDayRecordType, CashflowPredictionGroup, CreditLineICTDirection, soldSellingStates, isEstateSoldToExternalParty, getCreditLineICTDirection, getPreviousMilestoneType;
var init_cashflow_prediction_base = __esmMin((() => {
	init_errors();
	init_processes();
	CashflowMilestone = /* @__PURE__ */ function(CashflowMilestone) {
		CashflowMilestone["PurchasingOfferAccepted"] = "PurchasingOfferAccepted";
		CashflowMilestone["PurchasingNotarized"] = "PurchasingNotarized";
		CashflowMilestone["PurchasingAgencyFeePaid"] = "PurchasingAgencyFeePaid";
		CashflowMilestone["PurchasingFMreceived"] = "PurchasingFMreceived";
		CashflowMilestone["PurchasingPaid"] = "PurchasingPaid";
		CashflowMilestone["RenovationStarted"] = "RenovationStarted";
		CashflowMilestone["RenovationKitchenCompleted"] = "RenovationKitchenCompleted";
		CashflowMilestone["PropertyFeesPaid"] = "PropertyFeesPaid";
		CashflowMilestone["RenovationCompleted"] = "RenovationCompleted";
		CashflowMilestone["SellingOfferAccepted"] = "SellingOfferAccepted";
		CashflowMilestone["SellingNotarized"] = "SellingNotarized";
		CashflowMilestone["SellingFMreceived"] = "SellingFMreceived";
		CashflowMilestone["SellingCompleted"] = "SellingCompleted";
		CashflowMilestone["OtherCosts"] = "OtherCosts";
		return CashflowMilestone;
	}({});
	orderedCashflowMilestonesForPredictions = [
		"PurchasingOfferAccepted",
		"PurchasingNotarized",
		"PurchasingAgencyFeePaid",
		"PurchasingFMreceived",
		"PurchasingPaid",
		"PropertyFeesPaid",
		"RenovationStarted",
		"RenovationKitchenCompleted",
		"RenovationCompleted",
		"SellingOfferAccepted",
		"SellingNotarized",
		"SellingFMreceived",
		"SellingCompleted"
	];
	CoreCashflowMilestones = Object.values(CashflowMilestone).filter((ms) => !["OtherCosts"].includes(ms));
	ExpenseOnlyMilestones = [
		"OtherCosts",
		"PurchasingAgencyFeePaid",
		"RenovationKitchenCompleted",
		"PropertyFeesPaid",
		"RenovationCompleted"
	];
	CashflowPredictionDayRecordType = /* @__PURE__ */ function(CashflowPredictionDayRecordType) {
		CashflowPredictionDayRecordType["Original"] = "Original";
		CashflowPredictionDayRecordType["Adjusted"] = "Adjusted";
		CashflowPredictionDayRecordType["Paid"] = "Paid";
		return CashflowPredictionDayRecordType;
	}({});
	CashflowPredictionGroup = /* @__PURE__ */ function(CashflowPredictionGroup) {
		CashflowPredictionGroup["Month"] = "Month";
		CashflowPredictionGroup["Week"] = "Week";
		return CashflowPredictionGroup;
	}({});
	CreditLineICTDirection = /* @__PURE__ */ function(CreditLineICTDirection) {
		CreditLineICTDirection["In"] = "In";
		CreditLineICTDirection["Out"] = "Out";
		return CreditLineICTDirection;
	}({});
	soldSellingStates = [...SellingStatesEstateSold, "Completed"];
	isEstateSoldToExternalParty = (estate) => {
		return soldSellingStates.includes(estate.selling?.processState?.state);
	};
	getCreditLineICTDirection = (estate, creditLineConfig) => {
		const allowedPurchasingEntityIds = creditLineConfig.allowedPurchasingEntityIds;
		if (!allowedPurchasingEntityIds) throw new InvariantError("Cannot determine ICT Direction because Missing estate.config.configRow.CreditLine.config.allowedPurchasingEntityIds is missing");
		if (estate.executedIctInvestmentCase?.ictExecution) {
			const fromPurchasingEntityId = estate.executedIctInvestmentCase.ictExecution.fromPurchasingEntityId;
			const toPurchasingEntityId = estate.executedIctInvestmentCase.ictExecution.toPurchasingEntityId;
			if (!allowedPurchasingEntityIds.includes(fromPurchasingEntityId) && allowedPurchasingEntityIds.includes(toPurchasingEntityId))
 /**
			* Non-CreditLine Estate was bought by a CreditLine company
			*/
			return "In";
			if (allowedPurchasingEntityIds.includes(fromPurchasingEntityId) && !allowedPurchasingEntityIds.includes(toPurchasingEntityId)) {
				if (isEstateSoldToExternalParty(estate)) return;
				/**
				* CreditLine Estate was bought by company outside CreditLine
				*/
				return "Out";
			}
		}
	};
	getPreviousMilestoneType = (milestone) => {
		switch (milestone) {
			case "PurchasingNotarized": return "PurchasingOfferAccepted";
			case "PurchasingAgencyFeePaid": return "PurchasingNotarized";
			case "PurchasingFMreceived": return "PurchasingNotarized";
			case "PurchasingPaid": return "PurchasingFMreceived";
			case "PropertyFeesPaid": return "PurchasingPaid";
			case "RenovationStarted": return "PurchasingPaid";
			case "RenovationKitchenCompleted": return "RenovationStarted";
			case "RenovationCompleted": return "RenovationStarted";
			case "SellingOfferAccepted": return "PurchasingPaid";
			case "SellingNotarized": return "SellingOfferAccepted";
			case "SellingFMreceived": return "SellingNotarized";
			case "SellingCompleted": return "SellingFMreceived";
			default: throw new InvariantError(`Can't find previous milestone type for ${milestone}`);
		}
	};
}));
//#endregion
//#region src/domains/transaction/cashflow-prediction/cashflow-prediction.model.ts
var init_cashflow_prediction_model = __esmMin((() => {}));
//#endregion
//#region src/domains/transaction/cashflow-prediction/cashflow-prediction.opts.ts
var init_cashflow_prediction_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/transaction/cashflow-prediction/index.ts
var init_cashflow_prediction = __esmMin((() => {
	init_cashflow_prediction_base();
	init_cashflow_prediction_model();
	init_cashflow_prediction_opts();
}));
//#endregion
//#region src/__unsorted/ccs-routes/ccs-routes.ts
var CCSRouteMap, resolveRoutePath, getStrippedCCSRoutes, encodeReturnRoute, decodeReturnRoute, getReturnRoute, createRouteWithReturn;
var init_ccs_routes$1 = __esmMin((() => {
	CCSRouteMap = {
		calendar: {
			path: "/calendar",
			name: "calendar",
			description: "Displays a general calendar view for all relevant events."
		},
		"all.estates": {
			path: "/all-estates",
			name: "all.estates",
			description: "Shows a comprehensive list of all individual estates or properties."
		},
		"all.mfh": {
			path: "/all-mfhs",
			name: "all.mfh",
			description: "Provides a list of all multi-family homes (MFHs)."
		},
		"all.sign-off-envelopes": {
			path: "/sign-off-envelopes",
			name: "all.sign-off-envelopes",
			description: "Shows sign-off approvals overview for all MFH assets."
		},
		"all.sign-off-envelopes.create": {
			path: "/sign-off-envelopes/create",
			name: "all.sign-off-envelopes.create",
			description: "Creates a new general sign-off envelope."
		},
		"one.mfh": {
			path: "/mfhs/:mfhId",
			name: "one.mfh",
			description: "Base route for viewing a single multi-family home, identified by its mfhId."
		},
		"one.mfh.summary": {
			path: "/mfhs/:mfhId/summary",
			name: "one.mfh.summary",
			description: "Shows a summary or dashboard for a specific MFH."
		},
		"one.mfh.detail": {
			rootPath: "/mfhs/:mfhId",
			path: "detail",
			name: "one.mfh.detail",
			description: "Displays detailed information about a specific MFH (RAM iframe when F_EMBED_MFH_DETAIL_PAGE is enabled)."
		},
		"one.mfh.tasks": {
			path: "/mfhs/:mfhId/tasks",
			name: "one.mfh.tasks",
			description: "Lists all tasks associated with a specific MFH."
		},
		"one.mfh.task-milestones": {
			path: "/mfhs/:mfhId/task-milestones",
			name: "one.mfh.task-milestones",
			description: "Shows task milestone report for a specific MFH."
		},
		"one.mfh.project-plan": {
			path: "/mfhs/:mfhId/project-plan",
			name: "one.mfh.project-plan",
			description: "Shows Gantt chart project plan for a specific MFH."
		},
		"one.mfh.controlling": {
			path: "/mfhs/:mfhId/controlling",
			name: "one.mfh.controlling",
			description: "The controlling or financial oversight section for a specific MFH."
		},
		"one.mfh-by-building.detail": {
			path: "/mfhs/building-id/:mfhBuildingId",
			name: "one.mfh-by-building.detail",
			description: "Displays details of an MFH by its building ID instead of its own ID."
		},
		"one.mfh.media": {
			path: "/mfhs/:mfhId/media",
			name: "one.mfh.media",
			description: "Manages media files (images, videos) for a specific MFH."
		},
		"one.mfh.contacts": {
			path: "/mfhs/:mfhId/contacts",
			name: "one.mfh.contacts",
			description: "Shows all contacts related to a specific MFH."
		},
		"one.mfh.calendar-events": {
			path: "/mfhs/:mfhId/calendar-events",
			name: "one.mfh.calendar-events",
			description: "Displays calendar events specific to a single MFH."
		},
		"one.mfh.documents": {
			path: "/mfhs/:mfhId/documents",
			name: "one.mfh.documents",
			description: "Manages and displays documents for a specific MFH."
		},
		"one.mfh.ai-imports": {
			path: "/mfhs/:mfhId/ai-imports",
			name: "one.mfh.ai-imports",
			description: "Handles AI-based data imports for a specific MFH."
		},
		"one.mfh.estates": {
			path: "/mfhs/:mfhId/estates",
			name: "one.mfh.estates",
			description: "Lists all individual estates belonging to a specific MFH."
		},
		"one.mfh.renovation-projects": {
			path: "/mfhs/:mfhId/renovation-projects",
			name: "one.mfh.renovation-projects",
			description: "Shows all renovation projects for a specific MFH."
		},
		"one.mfh.renovation-projects-cost-controlling": {
			path: "/mfhs/:mfhId/renovation-projects-cost-controlling",
			name: "one.mfh.renovation-projects-cost-controlling",
			description: "Shows the cost controlling for all renovation projects of a specific MFH"
		},
		"one.mfh.renovation-project-tendering-process-list": {
			path: "/mfhs/:mfhId/renovation-projects/:mfhRenovationProjectId/tendering-process-list",
			name: "one.mfh.renovation-project-tendering-process-list",
			description: "Displays a list of tendering processes for a specific renovation project"
		},
		"one.mfh.renovation-project-tendering-process-details": {
			path: "/mfhs/:mfhId/renovation-projects/:mfhRenovationProjectId/tendering-process/:tenderingProcessId",
			name: "one.mfh.renovation-project-tendering-process-details",
			description: "Displays a specific tendering process"
		},
		"one.mfh.renovation-project-tendering-process-tenderer-details": {
			path: "/mfhs/:mfhId/renovation-projects/:mfhRenovationProjectId/tendering-process/:tenderingProcessId/tenderer/:tenderingProcessTendererId",
			name: "one.mfh.renovation-project-tendering-process-tenderer-details",
			description: "Displays a specific tenderer details"
		},
		"one.mfh.renovation-project-contract-details": {
			path: "/mfhs/:mfhId/renovation-projects/:mfhRenovationProjectId/contracts/:contractId",
			name: "one.mfh.renovation-project-contract-details",
			description: "Displays a specific contract details"
		},
		"one.mfh.renovation-projects-history": {
			path: "/mfhs/:mfhId/renovation-projects-history",
			name: "one.mfh.renovation-projects-history",
			description: "Shows all history of a mfh renovation"
		},
		"one.mfh.addenda": {
			path: "/mfhs/:mfhId/addenda",
			name: "one.mfh.addenda",
			description: "Displays the addenda management view for a specific MFH, rendered via RAM iframe."
		},
		"one.mfh.construction-plan": {
			path: "/mfhs/:mfhId/construction-plan",
			name: "one.mfh.construction-plan",
			description: "Displays the construction plan management view for a specific MFH, rendered via RAM iframe."
		},
		"one.mfh.capex-ee-calculator": {
			path: "/mfhs/:mfhId/capex-ee-calculator",
			name: "one.mfh.capex-ee-calculator",
			description: "Displays the CapEx energy-efficiency calculator for a specific MFH, rendered via RAM iframe."
		},
		"one.mfh.transformation-contracts": {
			path: "/mfhs/:mfhId/transformation-contracts",
			name: "one.mfh.transformation-contracts",
			description: "Renovation / transformation contract management for a specific MFH, rendered via RAM iframe."
		},
		"one.mfh.renovation-project-cost-breakdowns": {
			path: "/mfhs/:mfhId/renovation-projects/:mfhRenovationProjectId/cost-breakdowns",
			name: "one.mfh.renovation-project-cost-breakdowns",
			description: "Displays a specific renovation project cost breakdowns."
		},
		"one.mfh.renovation-project-tendering-process-final-offers-evaluation": {
			path: "/mfhs/:mfhId/renovation-projects/:mfhRenovationProjectId/tendering-process/:tenderingProcessId/final-offers-evaluation",
			name: "one.mfh.renovation-project-tendering-process-final-offers-evaluation",
			description: "Evaluates the final offers for a specific tendering process"
		},
		"one.mfh.timeline": {
			path: "/mfhs/:mfhId/timeline",
			name: "one.mfh.timeline",
			description: "Displays a timeline of events and activities for a specific MFH."
		},
		"one.mfh.elements": {
			path: "/mfhs/:mfhId/elements",
			name: "one.mfh.elements",
			description: "Manages various elements or components of an MFH."
		},
		"one.mfh.onsite-technical-dd": {
			path: "/mfhs/:mfhId/onsite-technical-dd",
			name: "one.mfh.onsite-technical-dd",
			description: "Manages the on-site technical due diligence process for an MFH."
		},
		"one.mfh.asset-management.accounting": {
			path: "/mfhs/:mfhId/asset-management",
			name: "one.mfh.asset-management.accounting",
			description: "Provides a view on the asset management ledger for a given MFH."
		},
		"one.mfh.sourcing.overview": {
			path: "/mfhs/:mfhId/sourcing/:processId",
			name: "one.mfh.sourcing.overview",
			description: "Provides an overview of the sourcing process for a specific MFH."
		},
		"one.mfh.subsidy-financing.overview": {
			path: "/mfhs/:mfhId/subsidy-financing/:processId",
			name: "one.mfh.subsidy-financing.overview",
			description: "Overview of the subsidy and financing process for an MFH."
		},
		"one.mfh.estate-management.overview": {
			path: "/mfhs/:mfhId/asset-management/:processId",
			name: "one.mfh.estate-management.overview",
			description: "Provides an overview of the estate management process for an MFH."
		},
		"one.mfh.purchasing.investment-case-overview": {
			path: "/mfhs/:mfhId/purchasing/investment-cases",
			name: "one.mfh.purchasing.investment-case-overview",
			description: "Shows an overview of all investment cases related to the purchasing of an MFH."
		},
		"one.mfh.asset-management-investment-cases.overview": {
			path: "/mfhs/:mfhId/asset-management/investment-cases",
			name: "one.mfh.asset-management-investment-cases.overview",
			description: "Shows an overview of all investment cases related to the asset management of an MFH."
		},
		"one.mfh.asset-management-investment-cases.detail": {
			path: "/mfhs/:mfhId/asset-management/investment-cases/:mfhInvestmentCaseId",
			name: "one.mfh.asset-management-investment-cases.detail",
			description: "Displays the details of a specific asset management investment case for an MFH."
		},
		"one.mfh.purchasing.investment-case-detail": {
			path: "/mfhs/:mfhId/purchasing/investment-cases/:mfhInvestmentCaseId",
			name: "one.mfh.purchasing.investment-case-detail",
			description: "Displays the details of a specific investment case for an MFH."
		},
		"one.mfh.purchasing.base-investment-case-configure": {
			path: "/mfhs/:mfhId/purchasing/base-investment-cases/:mfhInvestmentCaseId/configure",
			name: "one.mfh.purchasing.base-investment-case-configure",
			description: "Configures the shared inputs of a base investment-case draft before fanning out one case per asset-partner profile."
		},
		"one.mfh.dd": {
			path: "/mfhs/:mfhId/dd",
			name: "one.mfh.dd",
			description: "Due diligence section for an MFH."
		},
		"one.mfh.dd.rent-roll-versions-overview": {
			path: "/mfhs/:mfhId/dd/rent-roll-versions",
			name: "one.mfh.dd.rent-roll-versions-overview",
			description: "Shows an overview of different versions of the rent roll for an MFH."
		},
		"one.mfh.dd.rent-roll-versions-details": {
			path: "/mfhs/:mfhId/dd/rent-roll-versions/:rentRollVersionId",
			name: "one.mfh.dd.rent-roll-versions-details",
			description: "Displays details of a specific version of the rent roll for an MFH."
		},
		"one.mfh.dd.placement": {
			path: "/mfhs/:mfhId/dd/placement",
			name: "one.mfh.dd.placement",
			description: "Placement section for an MFH (RAM embed)."
		},
		"one.mfh.renting-overview": {
			path: "/mfhs/:mfhId/renting-overview",
			name: "one.mfh.renting-overview",
			description: "Provides an overview of the renting status and activities for a specific MFH."
		},
		"one.mfh.renting-overview.import-estarcore": {
			rootPath: "/mfhs/:mfhId/renting-overview",
			path: "import-estarcore",
			name: "one.mfh.renting-overview.import-estarcore",
			description: "Allows importing rented units from EstarCore."
		},
		"one.mfh.renting-overview.external-units": {
			rootPath: "/mfhs/:mfhId/renting-overview",
			path: "external-units",
			name: "one.mfh.renting-overview.external-units",
			description: "Shows units available in EstarCore."
		},
		"one.mfh.renting-overview.estar-core": {
			rootPath: "/mfhs/:mfhId/renting-overview",
			path: "estar-core",
			name: "one.mfh.renting-overview.estar-core",
			description: "Integration point with Estar Core for renting overview data of an MFH."
		},
		defects: {
			path: "/defects",
			name: "defects",
			description: "A global list of all defects across all properties."
		},
		selling: {
			path: "/selling",
			name: "selling",
			description: "A general section for all selling-related activities."
		},
		renting: {
			path: "/renting",
			name: "renting",
			description: "A general section for all renting-related activities."
		},
		"sourcing.estates": {
			path: "/sourcing/estates",
			name: "sourcing.estates",
			description: "A list of estates currently in the sourcing pipeline."
		},
		"sourcing.mfhs": {
			path: "/sourcing/mfhs",
			name: "sourcing.mfhs",
			description: "A list of MFHs currently in the sourcing pipeline."
		},
		"sourcing.pipeline": {
			path: "/sourcing/pipeline",
			name: "sourcing.pipeline",
			description: "The main dashboard for the sourcing pipeline."
		},
		"sourcing.map-view": {
			path: "/sourcing/map-view",
			name: "sourcing.map-view",
			description: "Map view for sourcing assets."
		},
		"renting.mfhs": {
			path: "/renting/mfhs",
			name: "renting.mfhs",
			description: "A list of MFHs available for rent."
		},
		"sourcing.eligible-assets": {
			path: "/sourcing/eligible-assets",
			name: "sourcing.eligible-assets",
			description: "A list of assets that are eligible for sourcing."
		},
		"sourcing.mfh-portfolios": {
			path: "/sourcing/mfh-portfolios",
			name: "sourcing.mfh-portfolios",
			description: "Manages portfolios of MFHs during the sourcing phase."
		},
		"one.mfh-building": {
			path: "/mfh-buildings/:mfhBuildingId",
			name: "one.mfh-building",
			description: "The base route for viewing a single MFH building."
		},
		"one.mfh-building.detail": {
			path: "/mfh-buildings/:mfhBuildingId/detail",
			name: "one.mfh-building.detail",
			description: "Displays detailed information about a specific MFH building."
		},
		"one.mfh-building.timeline": {
			path: "/mfhs-buildings/:mfhBuildingId/timeline",
			name: "one.mfh-building.timeline",
			description: "Displays a timeline of events for a specific MFH building."
		},
		"one.mfh-portfolio": {
			path: "/mfh-portfolios/:mfhPortfolioId",
			name: "one.mfh-portfolio",
			description: "Base route for viewing a single MFH portfolio."
		},
		"one.mfh-portfolio.detail": {
			path: "/mfh-portfolios/:mfhPortfolioId/detail",
			name: "one.mfh-portfolio.detail",
			description: "Displays detailed information about a specific MFH portfolio."
		},
		"one.mfh-portfolio.contacts": {
			path: "/mfh-portfolios/:mfhPortfolioId/contacts",
			name: "one.mfh-portfolio.contacts",
			description: "Shows all contacts related to a specific MFH portfolio."
		},
		"one.mfh-portfolio.tasks": {
			path: "/mfh-portfolios/:mfhPortfolioId/tasks",
			name: "one.mfh-portfolio.tasks",
			description: "Lists all tasks for a specific MFH portfolio."
		},
		"one.mfh-portfolio.timeline": {
			path: "/mfhs-portfolios/:mfhPortfolioId/timeline",
			name: "one.mfh-portfolio.timeline",
			description: "Displays a timeline of events for a specific MFH portfolio."
		},
		"one.mfh-portfolio.financing.overview": {
			path: "/mfh-portfolios/:mfhPortfolioId/financing/:processId",
			name: "one.mfh-portfolio.financing.overview",
			description: "Overview of the financing process for an MFH portfolio."
		},
		"one.mfh-portfolio.purchasing.overview": {
			path: "/mfh-portfolios/:mfhPortfolioId/purchasing/:processId",
			name: "one.mfh-portfolio.purchasing.overview",
			description: "Overview of the purchasing process for an MFH portfolio."
		},
		"one.mfh-portfolio.sign-off-envelopes.overview": {
			path: "/mfh-portfolios/:mfhPortfolioId/sign-off-envelopes",
			name: "one.mfh-portfolio.sign-off-envelopes.overview",
			description: "Shows sign-off approvals overview for a specific MFH portfolio."
		},
		"one.mfh-portfolio.sign-off-envelope-create": {
			path: "/mfh-portfolios/:mfhPortfolioId/sign-off-envelope-create",
			name: "one.mfh-portfolio.sign-off-envelope-create",
			description: "Creating sign off envelopes for MFH portfolios."
		},
		"one.mfh-portfolio.sign-off-envelope.details": {
			path: "/mfh-portfolios/:mfhPortfolioId/sign-off-envelopes/:signOffEnvelopeId",
			name: "one.mfh-portfolio.sign-off-envelope.details",
			description: "Details for a specific MFH portfolio sign-off envelope within portfolio context."
		},
		"one.mfh-portfolio.sheet-embedding": {
			path: "/mfh-portfolios/:mfhPortfolioId/sheet-embedding",
			name: "one.mfh-portfolio.sheet-embedding",
			description: "Portfolio viewer list and IC selection for an MFH portfolio."
		},
		"one.mfh-portfolio.sheet-embedding.viewer": {
			path: "/mfh-portfolios/:mfhPortfolioId/sheet-embedding/:mfhSheetEmbeddingId",
			name: "one.mfh-portfolio.sheet-embedding.viewer",
			description: "Portfolio viewer tab for a specific sheet embedding on an MFH portfolio."
		},
		tasks: {
			path: "/tasks",
			name: "tasks",
			description: "A global view of all tasks across the system."
		},
		"tasks.upcoming": {
			path: "/tasks/upcoming",
			name: "tasks.upcoming",
			description: "Upcoming tasks grouped by MFH property."
		},
		"finance.eligible.estates": {
			path: "/portfolio/eligible-estates",
			name: "finance.eligible.estates",
			description: "A list of estates eligible for financing."
		},
		"selling.eligible-estates": {
			path: "/selling/eligible-estates",
			name: "selling.eligible-estates",
			description: "A list of estates that are eligible for selling."
		},
		"selling.sales-packages": {
			path: "/selling/sales-packages",
			name: "selling.sales-packages",
			description: "Manages sales packages for selling properties."
		},
		"sales-package.one": {
			path: "/sales-packages/:salesPackageId",
			name: "sales.package.one",
			description: "Base route for viewing a single sales package."
		},
		"sales-package.overview": {
			rootPath: "/sales-packages/:salesPackageId",
			path: "overview",
			name: "sales-package.overview",
			description: "Provides an overview of a specific sales package."
		},
		"sales-package.history": {
			rootPath: "/sales-packages/:salesPackageId",
			path: "history",
			name: "sales-package.history",
			description: "Shows the history and changes of a sales package."
		},
		"sales-package.checklist": {
			rootPath: "/sales-packages/:salesPackageId",
			path: "checklist",
			name: "sales-package.checklist",
			description: "A checklist for managing a sales package."
		},
		"sales-package.notary-sheet": {
			rootPath: "/sales-packages/:salesPackageId",
			path: "notary-sheet",
			name: "sales-package.notary-sheet",
			description: "Displays the notary sheet for a sales package."
		},
		"sales-package.data-sheet": {
			rootPath: "/sales-packages/:salesPackageId",
			path: "data-sheet",
			name: "sales-package.data-sheet",
			description: "Shows the data sheet for a sales package."
		},
		"sales-package.final-sheet": {
			rootPath: "/sales-packages/:salesPackageId",
			path: "final-sheet",
			name: "sales-package.final-sheet",
			description: "Displays the final compiled sheet for a sales package."
		},
		"sales-package.edit": {
			rootPath: "/sales-packages/:salesPackageId",
			path: "edit",
			name: "sales-package.edit",
			description: "Allows editing a sales package."
		},
		"sales-package.documents": {
			rootPath: "/sales-packages",
			path: "documents",
			name: "sales-package.documents",
			description: "Manages all documents related to sales packages."
		},
		"portfolio.list": {
			path: "/portfolio/list",
			name: "portfolio.list",
			description: "Shows a list of all portfolios."
		},
		"save.portfolio": {
			path: "/save-portfolio/:portfolioId?",
			name: "save.portfolio",
			description: "Page to create or edit a portfolio."
		},
		"one.portfolio": {
			path: "/portfolio/:portfolioId",
			name: "one.portfolio",
			description: "Base route for viewing a single portfolio."
		},
		"portfolio.documents": {
			rootPath: "/portfolio/:portfolioId",
			path: "documents",
			name: "portfolio.documents",
			description: "Manages documents for a specific portfolio."
		},
		"portfolio.tendering": {
			rootPath: "/portfolio/:portfolioId",
			path: "tendering",
			name: "portfolio.tendering",
			description: "Manages the tendering process for a portfolio."
		},
		"portfolio.drawdowns": {
			rootPath: "/portfolio/:portfolioId",
			path: "drawdowns",
			name: "portfolio.drawdowns",
			description: "Tracks drawdowns for a specific portfolio."
		},
		"portfolio.loan": {
			rootPath: "/portfolio/:portfolioId",
			path: "loan",
			name: "portfolio.loan",
			description: "Manages loan information for a portfolio."
		},
		"portfolio.tasks": {
			rootPath: "/portfolio/:portfolioId",
			path: "tasks",
			name: "portfolio.tasks",
			description: "Lists all tasks for a specific portfolio."
		},
		"portfolio.history": {
			rootPath: "/portfolio/:portfolioId",
			path: "history",
			name: "portfolio.history",
			description: "Shows the history of a portfolio."
		},
		purchasing: {
			path: "/purchasing",
			name: "purchasing",
			description: "A general section for all purchasing-related activities."
		},
		contacts: {
			path: "/contacts",
			name: "contacts",
			description: "A list of all contacts in the system."
		},
		companies: {
			path: "/companies",
			name: "companies",
			description: "A list of all companies in the system."
		},
		"user.jobs": {
			path: "/users/:uid/jobs",
			name: "user.jobs",
			description: "Displays all jobs assigned to a specific user."
		},
		contactDetail: {
			path: "/contacts/:contactId",
			name: "contactDetail",
			description: "Base route for viewing a single contact."
		},
		"contactDetail.info": {
			rootPath: "/contacts/:contactId",
			path: "info",
			name: "contactDetail.info",
			description: "Shows detailed information about a contact."
		},
		"contactDetail.jobs": {
			rootPath: "/contacts/:contactId",
			path: "jobs",
			name: "contactDetail.jobs",
			description: "Lists jobs associated with a contact."
		},
		"contactDetail.estates": {
			rootPath: "/contacts/:contactId",
			path: "estates",
			name: "contactDetail.estates",
			description: "Lists estates associated with a contact."
		},
		"contactDetail.documents": {
			rootPath: "/contacts/:contactId",
			path: "documents",
			name: "contactDetail.documents",
			description: "Manages documents related to a contact."
		},
		"contactDetail.invoices": {
			rootPath: "/contacts/:contactId",
			path: "invoices",
			name: "contactDetail.invoices",
			description: "Shows invoices associated with a contact."
		},
		"contactDetail.calendar": {
			rootPath: "/contacts/:contactId",
			path: "calendar",
			name: "contactDetail.calendar",
			description: "Displays calendar events related to a contact."
		},
		"contactDetail.tasks": {
			rootPath: "/contacts/:contactId",
			path: "tasks",
			name: "contactDetail.tasks",
			description: "Lists tasks associated with a contact."
		},
		"contactDetail.reviewRequests": {
			rootPath: "/contacts/:contactId",
			path: "review-requests",
			name: "contactDetail.reviewRequests",
			description: "Manages review requests for a contact."
		},
		"contactDetail.reviewProcesses": {
			rootPath: "/contacts/:contactId",
			path: "review-processes",
			name: "contactDetail.reviewProcesses",
			description: "Shows review processes involving a contact."
		},
		"contactDetail.notificationSettings": {
			rootPath: "/contacts/:contactId",
			path: "notification-settings",
			name: "contactDetail.notificationSettings",
			description: "Manages notification settings for a contact."
		},
		"one.company": {
			path: "/companies/:companyId",
			name: "one.company",
			description: "Base route for viewing a single company."
		},
		"company.details": {
			rootPath: "/companies/:companyId",
			path: "details",
			name: "company.details",
			description: "Shows detailed information about a company."
		},
		"company.mfhs": {
			rootPath: "/companies/:companyId",
			path: "mfhs",
			name: "company.mfhs",
			description: "Lists all MFHs associated with a company."
		},
		"company.documents": {
			rootPath: "/companies/:companyId",
			path: "documents",
			name: "company.documents",
			description: "Manages documents for a company."
		},
		"company.invoices": {
			rootPath: "/companies/:companyId",
			path: "invoices",
			name: "company.invoices",
			description: "Shows all invoices for a company."
		},
		"company.subcompanies-estates-contacts": {
			rootPath: "/companies/:companyId",
			path: "subcompanies-estates-contacts",
			name: "company.subcompanies-estates-contacts",
			description: "Displays sub-companies, estates, and contacts related to a company."
		},
		"company.contractor-capacity": {
			rootPath: "/companies/:companyId",
			path: "contractor-capacity",
			name: "company.contractor-capacity",
			description: "Manages the capacity of a contractor company."
		},
		"company.contractor-pricing": {
			rootPath: "/companies/:companyId",
			path: "contractor-pricing",
			name: "company.contractor-pricing",
			description: "Manages the pricing models for a contractor company."
		},
		"company.history": {
			rootPath: "/companies/:companyId",
			path: "history",
			name: "company.history",
			description: "Shows the history of a company."
		},
		renovation: {
			path: "/renovation",
			name: "renovation",
			description: "A general section for all renovation activities."
		},
		"external-renovation": {
			path: "/renovation/external",
			name: "external-renovation",
			description: "Manages renovation projects handled by external contractors."
		},
		"document-requests": {
			path: "/document-requests",
			name: "document-requests",
			description: "A list of all document requests."
		},
		"contractor-capacity-overview": {
			path: "/renovation/contractor-capacity",
			name: "contractor-capacity-overview",
			description: "An overview of the capacity of all contractors."
		},
		accounting: {
			path: "/accounting",
			name: "accounting",
			description: "The main section for all accounting tasks."
		},
		invoices: {
			rootPath: "/accounting",
			path: "invoices",
			name: "invoices",
			description: "A list of all invoices."
		},
		subscriptions: {
			rootPath: "/accounting",
			path: "subscriptions",
			name: "subscriptions",
			description: "Manages all subscriptions."
		},
		"subscription.details": {
			rootPath: "/accounting",
			path: "subscriptions/:subscriptionId",
			name: "subscription.details",
			description: "Shows the details of a specific subscription."
		},
		"invoice.details": {
			rootPath: "/accounting",
			path: "invoices/:invoiceId",
			name: "invoice.details",
			description: "Shows the details of a specific invoice."
		},
		"accounting.payment-forecast": {
			rootPath: "/accounting",
			path: "payment-forecast",
			name: "accounting.payment-forecast",
			description: "Construction payment forecast across all assets."
		},
		propertyManagement: {
			path: "/property-management",
			name: "property-anagement",
			description: "The main section for property management."
		},
		"property-management.estate-management": {
			path: "/property-management/estate-management",
			name: "property-management.estate-management",
			description: "Dashboard for overall estate management within property management."
		},
		"property-management.tenancy-overview": {
			path: "/property-management/tenancy-overview",
			name: "property-management.tenancy-overview",
			description: "An overview of all tenancies."
		},
		"property-management.investor-data": {
			rootPath: "/estates/:estateId",
			path: "property-management/investor-data",
			name: "property-management.investor-data",
			description: "Manages investor-related data for a specific estate."
		},
		"property-management.tenants-overview": {
			path: "/property-management/tenants-overview",
			name: "property-management.tenants-overview",
			description: "An overview of all tenants."
		},
		"property-management.monthly-investor-share": {
			path: "/property-management/investor-share",
			name: "property-management.monthly-investor-share",
			description: "Manages the monthly share distribution to investors."
		},
		"property-management.monthly-rent-guarantees": {
			path: "/property-management/monthly-rent-guarantees",
			name: "property-management.monthly-rent-guarantees",
			description: "Manages monthly rent guarantees."
		},
		"property-management.investor-share-batch-review": {
			path: "/property-management/investor-share-batch-review/:estateId",
			name: "property-management.investor-share-batch-review",
			description: "Allows for batch review of investor shares for an estate."
		},
		"property-management.annual-service-charge-statement-overview": {
			path: "/property-management/annual-service-charge-statements",
			name: "property-management.annual-service-charge-statement-overview",
			description: "An overview of all annual service charge statements."
		},
		"cashflow.list": {
			path: "/cashflow",
			name: "cashflow",
			description: "A list of all cashflow records."
		},
		"bank.accounts.list": {
			path: "/bank-accounts",
			name: "bank.accounts.list",
			description: "A list of all bank accounts."
		},
		config: {
			path: "/admin",
			name: "admin",
			description: "The main administration and configuration panel."
		},
		"purchasing-regions": {
			rootPath: "/admin",
			path: "regions",
			name: "purchasing-regions",
			description: "Manages purchasing regions in the admin panel."
		},
		"selling-regions": {
			rootPath: "/admin",
			path: "selling-regions",
			name: "selling-regions",
			description: "Manages selling regions in the admin panel."
		},
		"region-detail": {
			rootPath: "/admin",
			path: "regions/:regionId",
			name: "region-detail",
			description: "Shows the details of a specific region."
		},
		"renovation.catalogue": {
			rootPath: "/admin",
			path: "renovation-catalogue",
			name: "renovation.catalogue",
			description: "Manages the catalogue of renovation items."
		},
		"renovation.catalogue.pricing": {
			rootPath: "/admin",
			path: "renovation-catalogue-pricing",
			name: "renovation.catalogue.pricing",
			description: "Manages the pricing for the renovation catalogue."
		},
		"loan.accounts.list": {
			rootPath: "/admin",
			path: "loan-accounts",
			name: "loan.accounts.list",
			description: "A list of all loan accounts in the admin panel."
		},
		"rules.editor": {
			rootPath: "/admin",
			path: "rules",
			name: "rules.editor",
			description: "An editor for managing business rules."
		},
		"permissions.roles.editor": {
			rootPath: "/admin",
			path: "permissions/roles",
			name: "permissions.roles.editor",
			description: "Editor for user roles and their permissions."
		},
		"permissions.users.editor": {
			rootPath: "/admin",
			path: "permissions/users",
			name: "permissions.users.editor",
			description: "Editor for managing users and their permissions."
		},
		"admin.cache.management": {
			rootPath: "/admin",
			path: "caches",
			name: "admin.cache.management",
			description: "A panel for managing system caches."
		},
		"admin.general": {
			rootPath: "/admin",
			path: "general",
			name: "admin.general",
			description: "General administrative settings."
		},
		"admin.debezium-snapshots": {
			rootPath: "/admin",
			path: "debezium-snapshots",
			name: "admin.debezium-snapshots",
			description: "Debezium snapshot management for CDC (Change Data Capture)."
		},
		"admin.search-engine-sync": {
			rootPath: "/admin",
			path: "search-engine-sync",
			name: "admin.search-engine-sync",
			description: "Search engine reindexing and synchronization management."
		},
		"admin.audit-log": {
			rootPath: "/admin",
			path: "audit",
			name: "admin.audit-log",
			description: "Displays a log of all system activities for auditing."
		},
		"admin.pipeline-audit-events": {
			rootPath: "/admin",
			path: "pipeline-audit-events",
			name: "admin.pipeline-audit-events",
			description: "Shows audit events related to pipelines."
		},
		"admin.estate-seeds": {
			rootPath: "/admin",
			path: "estate-seeds",
			name: "admin.estate-seeds",
			description: "Manages estates seeds"
		},
		"admin.email-templates": {
			rootPath: "/admin",
			path: "email-templates",
			name: "admin.email-templates",
			description: "Manages email templates used by the system."
		},
		"admin.notification-settings": {
			rootPath: "/admin",
			path: "notification-settings",
			name: "admin.notification-settings",
			description: "Configures system-wide notification settings."
		},
		"admin.invoice-settings": {
			rootPath: "/admin",
			path: "invoice-settings",
			name: "admin.invoice-settings",
			description: "Configures settings related to invoicing."
		},
		"admin.mfh-assets-config": {
			rootPath: "/admin",
			path: "mfh-assets-config",
			name: "admin.mfh-assets-config",
			description: "Manages MFH assets configuration settings (root config only)."
		},
		"admin.mfh-asset-partner-profiles": {
			rootPath: "/admin",
			path: "mfh-asset-partner-profiles",
			name: "admin.mfh-asset-partner-profiles",
			description: "Manages named IC profiles per asset partner (buy box, investor assumptions, best-fit weights)."
		},
		"admin.capex-ee-config": {
			path: "/capex-ee-config",
			name: "capex-ee-config",
			description: "Manages global CAPEX & Energy Efficiency calculator configuration (RAM embed)."
		},
		"admin.task-templates": {
			rootPath: "/admin",
			path: "task-templates",
			name: "admin.task-templates",
			description: "Manages templates for recurring tasks."
		},
		"admin.externally-visible-contacts": {
			rootPath: "/admin",
			path: "externally-visible-contacts",
			name: "admin.externally-visible-contacts",
			description: "Manages contacts that are visible to external applications."
		},
		"one.bank.accounts": {
			rootPath: "/admin",
			path: "bank-accounts/:bankAccountId",
			name: "one.bank.accounts",
			description: "Details of a single bank account (potentially legacy or duplicate)."
		},
		"inspection.checklist": {
			rootPath: "/admin",
			path: "inspection-checklist",
			name: "inspection.checklist",
			description: "Manages the master checklist for inspections."
		},
		"renovation.catalogue.detail": {
			rootPath: "/admin",
			path: "renovation-catalogue/:catalogueItemId",
			name: "renovation.catalogue.detail",
			description: "Shows the details of a specific item in the renovation catalogue."
		},
		"renovation.construction-templates": {
			rootPath: "/admin",
			path: "renovation-construction-templates",
			name: "renovation.construction-templates",
			description: "Manages templates for construction projects."
		},
		"renovation.cost-tracking": {
			path: "/renovation/cost-tracking",
			name: "renovation.cost-tracking",
			description: "Tracks costs for all renovation projects."
		},
		"mfh-renovation.position-config": {
			rootPath: "/admin",
			path: "mfh-renovation-position-config",
			name: "mfh-renovation.position-config",
			description: "Manages default attributes config for positions of renovation projects."
		},
		"estate.renovation.cost-tracking": {
			path: "/estates/:estateId/renovation-cost-tracking",
			name: "estate.renovation-cost-tracking",
			description: "Tracks renovation costs for a specific estate."
		},
		"estate.root": {
			path: "/estates/:estateId",
			name: "estate.root",
			description: "The root or entry point for a single estate view."
		},
		oneEstate: {
			rootPath: "/estates/:estateId",
			path: "details",
			name: "oneEstate",
			description: "Displays the main details of a single estate."
		},
		oneEstateByCondoUuid: {
			path: "/estates/condo-uuid/:condoUuid/:redirect*",
			name: "oneEstateByCondoUuid",
			description: "Retrieves an estate by its condo UUID and redirects."
		},
		oneEstateByOriginalId: {
			path: "/estates/originalId/:originalId/:redirect*",
			name: "oneEstateByOriginalId",
			description: "Retrieves an estate by its original ID and redirects."
		},
		"estate.payment-notice-summary": {
			rootPath: "/estates/:estateId",
			path: "payment-notice-summary",
			name: "estate.payment-notice-summary",
			description: "A summary of payment notices for a specific estate."
		},
		marketDetails: {
			rootPath: "/estates/:estateId",
			path: "market-details",
			name: "marketDetails",
			description: "Shows market details and analysis for an estate."
		},
		prediction: {
			rootPath: "/estates/:estateId",
			path: "prediction",
			name: "prediction",
			description: "Displays predictive analytics for an estate."
		},
		"estate-contacts": {
			rootPath: "/estates/:estateId",
			path: "estate-contacts",
			name: "estate-contacts",
			description: "Manages all contacts associated with an estate."
		},
		"investment.list": {
			rootPath: "/estates/:estateId",
			path: "investment",
			name: "investment.list",
			description: "Lists all investment records for an estate."
		},
		"selling.cashflow.list": {
			rootPath: "/estates/:estateId",
			path: "selling-cashflows",
			name: "selling.cashflow.list",
			description: "Lists cashflows related to the selling process of an estate."
		},
		"selling.cashflow.one": {
			rootPath: "/estates/:estateId",
			path: "selling-cashflows/:investorCashflowId",
			name: "selling.cashflow.one",
			description: "Details of a specific investor cashflow during selling."
		},
		"selling.investment.list": {
			rootPath: "/estates/:estateId",
			path: "selling-investment",
			name: "selling.investment.list",
			description: "Lists investment details related to the selling of an estate."
		},
		"property-management.overview": {
			rootPath: "/estates/:estateId",
			path: "property-management/overview",
			name: "property-management.overview",
			description: "An overview of property management activities for an estate."
		},
		"property-management.financial-data": {
			rootPath: "/estates/:estateId",
			path: "property-management/financial-data",
			name: "property-management.financial-data",
			description: "Displays financial data for an estate under property management."
		},
		"property-management.tasks": {
			rootPath: "/estates/:estateId",
			path: "property-management/tasks",
			name: "property-management.tasks",
			description: "Lists property management tasks for a specific estate."
		},
		"property-management.investor-info": {
			rootPath: "/estates/:estateId",
			path: "property-management/investor-info/:investorInfoId",
			name: "property-management.investor-info",
			description: "Shows information about a specific investor in an estate."
		},
		"property-management.rent-tenancy": {
			rootPath: "/estates/:estateId",
			path: "property-management/tenancies",
			name: "property-management.rent-tenancy",
			description: "Manages rent and tenancy agreements for an estate."
		},
		"property-management.annual-service-charge-statement": {
			rootPath: "/estates/:estateId",
			path: "property-management/rental-contracts/:rentalContractId/annual-service-charge-statement/:annualServiceChargeStatementId?",
			name: "property-management.annual-service-charge-statement",
			description: "Manages the annual service charge statement for a rental contract."
		},
		"property-management.investor-yearly-payout": {
			rootPath: "/estates/:estateId",
			path: "property-management/investor-yearly-payouts/:investorYearlyPayoutId",
			name: "property-management.investor-yearly-payout",
			description: "Details of the yearly payout to an investor."
		},
		"property-management.estate": {
			rootPath: "/estates/:estateId",
			path: "property-management/estate",
			name: "property-management.estate",
			description: "Manages estate-specific details within property management."
		},
		"property-management.history": {
			rootPath: "/estates/:estateId",
			path: "property-management/history",
			name: "property-management.history",
			description: "The history of property management for an estate."
		},
		"property-management.sev": {
			rootPath: "/estates/:estateId",
			path: "property-management/sev",
			name: "property-management.sev",
			description: "Manages SEV (Sondereigentumsverwaltung) for an estate."
		},
		"property-management.tenant": {
			rootPath: "/estates/:estateId",
			path: "property-management/tenant",
			name: "property-management.tenant",
			description: "Manages tenant-specific details within property management."
		},
		"owner-management": {
			rootPath: "/estates/:estateId",
			path: "owner-management",
			name: "owner-management",
			description: "Section for managing owner-related aspects of an estate."
		},
		"owner-management.overview": {
			rootPath: "/estates/:estateId",
			path: "owner-management/overview",
			name: "owner-management.overview",
			description: "An overview of owner management for an estate."
		},
		"property-management.all-tasks": {
			rootPath: "/estates/:estateId",
			path: "property-management/all-tasks",
			name: "property-management.all-tasks",
			description: "A comprehensive list of all tasks under property management for an estate."
		},
		"owner-management.tasks": {
			rootPath: "/estates/:estateId",
			path: "owner-management/tasks",
			name: "owner-management.tasks",
			description: "Lists owner management tasks for an estate."
		},
		"owner-management.investor-share-history": {
			rootPath: "/estates/:estateId",
			path: "owner-management/investor-share-history",
			name: "owner-management.investor-share-history",
			description: "History of investor share distributions for an estate."
		},
		"estate-management": {
			rootPath: "/estates/:estateId",
			path: "estate-management",
			name: "estate-management",
			description: "Section for managing the estate itself."
		},
		"estate-management.defects": {
			rootPath: "/estates/:estateId",
			path: "estate-management/defects",
			name: "estate-management.defects",
			description: "Manages defects found in an estate."
		},
		"estate-management.sepa-mandates": {
			rootPath: "/estates/:estateId",
			path: "property-management/sepa-mandates",
			name: "estate-management.sepa-mandates",
			description: "Manages SEPA mandates for an estate."
		},
		"estate-management.overview": {
			rootPath: "/estates/:estateId",
			path: "estate-management/overview",
			name: "estate-management.overview",
			description: "An overview of estate management activities."
		},
		"estate-management.tasks": {
			rootPath: "/estates/:estateId",
			path: "estate-management/tasks",
			name: "estate-management.tasks",
			description: "Lists estate management tasks for a specific estate."
		},
		"investment.edit": {
			rootPath: "/estates/:estateId",
			path: "investment/:investmentId",
			name: "investment.edit",
			description: "Page to edit a specific investment record of an estate."
		},
		inspections: {
			rootPath: "/estates/:estateId",
			path: "checks",
			name: "inspections",
			description: "Manages all inspections and checks for an estate."
		},
		"inspections.purchasing": {
			rootPath: "/estates/:estateId",
			path: "purchasing-inspection",
			name: "inspections.purchasing",
			description: "Manages the purchasing inspection for an estate."
		},
		"inspections.document": {
			rootPath: "/estates/:estateId",
			path: "inspections/document/:documentId",
			name: "inspections.document",
			description: "Views a specific document related to an inspection."
		},
		documents: {
			rootPath: "/estates/:estateId",
			path: "documents",
			name: "documents",
			description: "Manages all documents for a specific estate."
		},
		"to-do": {
			rootPath: "/estates/:estateId",
			path: "to-do",
			name: "to-do",
			description: "A to-do list for a specific estate."
		},
		timeline: {
			rootPath: "/estates/:estateId",
			path: "timeline",
			name: "timeline",
			description: "A timeline of all events for a specific estate."
		},
		elements: {
			rootPath: "/estates/:estateId",
			path: "elements",
			name: "elements",
			description: "Manages various elements or components of an estate."
		},
		calendarEvents: {
			rootPath: "/estates/:estateId",
			path: "calendar-events",
			name: "calendarEvents",
			description: "Lists calendar events specific to an estate."
		},
		"sourcing.current": {
			rootPath: "/estates/:estateId",
			path: "sourcing/:processId",
			name: "sourcing.current",
			description: "The current sourcing process for an estate."
		},
		"purchasing.current": {
			rootPath: "/estates/:estateId",
			path: "purchasing/:processId",
			name: "purchasing.current",
			description: "The current purchasing process for an estate."
		},
		"purchasing.documents": {
			path: "/purchasing/documents",
			name: "purchasing.documents",
			description: "A collection of documents related to all purchasing activities."
		},
		"renting.current": {
			rootPath: "/estates/:estateId",
			path: "renting/:processId",
			name: "renting.current",
			description: "The current renting process for an estate."
		},
		"renting.rentable-units": {
			rootPath: "/estates/:estateId",
			path: "rentable-units",
			name: "renting.rentable-units",
			description: "Manages the rentable units within an estate."
		},
		"renting.history": {
			rootPath: "/estates/:estateId",
			path: "renting-history/:processId",
			name: "renting.history",
			description: "The history of renting processes for an estate."
		},
		"renting.mfh": {
			path: "/renting-mfh",
			name: "renting.mfh",
			description: "Section for renting activities related to MFHs."
		},
		"renting.livings": {
			path: "/renting-livings",
			name: "renting.livings",
			description: "Section for managing the renting of living spaces."
		},
		"renting.rental-contracts": {
			path: "/rental-contracts",
			name: "renting.rental-contracts",
			description: "A list of all rental contracts."
		},
		"estate.livingsCheck": {
			rootPath: "/estates/:estateId",
			path: "livings-check",
			name: "estate.livingsCheck",
			description: "A check or inspection of living spaces in an estate."
		},
		"estate.furnishing": {
			rootPath: "/estates/:estateId",
			path: "furnishing",
			name: "estate.furnishing",
			description: "Manages the furnishing of an estate."
		},
		"estate.livingsCostTracking": {
			rootPath: "/estates/:estateId",
			path: "livings-cost-tracking",
			name: "estate.livingsCostTracking",
			description: "Tracks costs related to living spaces in an estate."
		},
		"selling.current": {
			rootPath: "/estates/:estateId",
			path: "selling/:processId",
			name: "selling.current",
			description: "The current selling process for an estate."
		},
		"selling.data-checklist": {
			path: "/selling/data-checklist",
			name: "selling.data-checklist",
			description: "A checklist for data required for selling."
		},
		"selling.estates-data": {
			path: "/selling/data",
			name: "selling.estates-data",
			description: "Manages data for estates that are being sold."
		},
		"selling.documents": {
			path: "/selling/documents",
			name: "selling.documents",
			description: "A collection of documents for all selling activities."
		},
		"property-management.documents": {
			path: "/property-management/documents",
			name: "property-management.documents",
			description: "A collection of documents for all property management activities."
		},
		"renovation.current": {
			rootPath: "/estates/:estateId",
			path: "renovation/:processId",
			name: "renovation.current",
			description: "The current renovation process for an estate."
		},
		"renovation.floor-plan": {
			rootPath: "/estates/:estateId",
			path: "renovation/:processId/floor-plan",
			name: "renovation.floor-plan",
			description: "Manages the floor plan for a renovation project."
		},
		"renovation.project.plan": {
			rootPath: "/estates/:estateId",
			path: "renovation/:processId/construction-plans",
			name: "renovation.project.plan",
			description: "Manages construction plans for a renovation project."
		},
		"renovation.inspection-grid": {
			rootPath: "/estates/:estateId",
			path: "renovation/:processId/renovation-inspections",
			name: "renovation.inspection-grid",
			description: "A grid view of all inspections for a renovation project."
		},
		"renovation.progress.tracking": {
			rootPath: "/estates/:estateId",
			path: "renovation/:processId/progress-tracking",
			name: "renovation.progress.tracking",
			description: "Tracks the progress of a renovation project."
		},
		"renovation.project.one.plan": {
			rootPath: "/estates/:estateId",
			path: "renovation/construction-plans/:planId",
			name: "renovation.project.one.plan",
			description: "Views a single, specific construction plan for a renovation."
		},
		"renovation.inspection": {
			rootPath: "/estates/:estateId",
			path: "renovation/:processId/inspection/:renovationInspectionId",
			name: "renovation.inspection",
			description: "Details of a specific renovation inspection."
		},
		"renovation.inspection.crafts": {
			rootPath: "/estates/:estateId",
			path: "renovation/:processId/inspection/:renovationInspectionId/crafts",
			name: "renovation.inspection.crafts",
			description: "Manages the different construction crafts (e.g., plumbing, electrical) for an inspection."
		},
		"renovation.inspection.craft-details": {
			rootPath: "/estates/:estateId",
			path: "renovation/:processId/inspection/:renovationInspectionId/crafts/:constructionCraft",
			name: "renovation.inspection.craft-details",
			description: "Details for a specific craft within a renovation inspection."
		},
		"estate.sign-off-envelopes.overview": {
			rootPath: "/estates/:estateId",
			path: "sign-off-envelope",
			name: "estate.sign-off-envelopes.overview",
			description: "Manages sign off envelopes institutional estates."
		},
		"estate.sign-off-envelope-create": {
			rootPath: "/estates/:estateId",
			path: "sign-off-envelope-create",
			name: "estate.sign-off-envelope-create",
			description: "Creating sign off envelopes for institutional estates."
		},
		"estate.sign-off-envelope.details": {
			rootPath: "/estates/:estateId",
			path: "sign-off-envelope/:signOffEnvelopeId",
			name: "estate.sign-off-envelope.details",
			description: "Details for a specific estate sign-off envelope within estate context."
		},
		"sign-off-envelope.details": {
			path: "/sign-off-envelope/:signOffEnvelopeId",
			name: "sign-off-envelope.details",
			description: "Standalone details for a specific sign-off envelope."
		},
		"sign-off-envelope.additional-document": {
			path: "/sign-off-envelope/:signOffEnvelopeId/additional-document",
			name: "sign-off-envelope.additional-document",
			description: "Additional document for a specific sign-off envelope."
		},
		"sign-off-templates.overview": {
			path: "/sign-off-templates",
			name: "sign-off-templates.overview",
			description: "Overview of all sign-off templates for approval processes."
		},
		"renovation.defects": {
			rootPath: "/estates/:estateId",
			path: "renovation-defects",
			name: "renovation.defects",
			description: "Manages defects found during or after a renovation."
		},
		"renovation.defects.one": {
			rootPath: "/estates/:estateId",
			path: "renovation-defects/:defectId",
			name: "renovation.defects.one",
			description: "Details of a single renovation defect."
		},
		"one-estate.controlling": {
			rootPath: "/estates/:estateId",
			path: "controlling",
			name: "one-estate.controlling",
			description: "The controlling or financial oversight section for an estate."
		},
		"one-estate.media": {
			rootPath: "/estates/:estateId",
			path: "media",
			name: "one-estate.media",
			description: "Manages media files for a specific estate."
		},
		"one-estate.invoice.details": {
			rootPath: "/estates/:estateId",
			path: "invoices/:invoiceId",
			name: "one-estate.invoice.details",
			description: "Shows the details of a specific invoice related to an estate."
		},
		"one.bank.account": {
			path: "/bank-accounts/:bankAccountId",
			name: "one.bank.account",
			description: "Base route for viewing a single bank account."
		},
		"one.bank.account.transactions": {
			path: "transactions",
			rootPath: "/bank-accounts/:bankAccountId",
			name: "one.bank.account.transactions",
			description: "Lists all transactions for a specific bank account."
		},
		"one.bank.account.balance-records": {
			path: "balance-records",
			rootPath: "/bank-accounts/:bankAccountId",
			name: "one.bank.account.balance-records",
			description: "Shows balance records over time for a bank account."
		},
		"one.bank.account.ledger-entries": {
			path: "ledger-entries",
			rootPath: "/bank-accounts/:bankAccountId",
			name: "one.bank.account.ledger-entries",
			description: "Displays ledger entries for a specific bank account."
		},
		"finance.payment-notices.list": {
			path: "/finance/payment-notices",
			name: "finance.payment-notices",
			description: "A list of all payment notices in the finance section."
		},
		"credit-line-portfolio.one": {
			path: "/credit-line-portfolio/:creditLinePortfolioId",
			name: "credit-line-portfolio.one",
			description: "Base route for a single credit line portfolio."
		},
		"credit-line-portfolio.overview": {
			rootPath: "/credit-line-portfolio/:creditLinePortfolioId",
			path: "overview",
			name: "credit-line-portfolio.overview",
			description: "An overview of a specific credit line portfolio."
		},
		"credit-line-portfolio.predictions": {
			rootPath: "/credit-line-portfolio/:creditLinePortfolioId",
			path: "cashflow-predictions",
			name: "credit-line-portfolio.predictions",
			description: "Shows cashflow predictions for a credit line portfolio."
		},
		"credit-line-portfolio.budget-costs": {
			rootPath: "/credit-line-portfolio/:creditLinePortfolioId",
			path: "budget-costs",
			name: "credit-line-portfolio.budget-costs",
			description: "Manages budget costs for a credit line portfolio."
		},
		"construction-templates.one": {
			path: "/construction-templates/:constructionTemplateId",
			name: "construction-templates.one",
			description: "Displays a single, specific construction template."
		},
		"operation.list.monitoring": {
			path: "/operation/list/monitoring",
			name: "operation.list.monitoring",
			description: "A list for monitoring ongoing operations."
		},
		notification: {
			path: "/notification",
			name: "notification",
			description: "Displays user notifications."
		},
		"document.description": {
			path: "/document-description",
			name: "document.description",
			description: "Displays document descriptions."
		},
		"mfh.sign-off-envelope-create": {
			rootPath: "/mfhs/:mfhId",
			path: "sign-off-envelope-create",
			name: "mfh.sign-off-envelope-create",
			description: "Creating sign off envelopes for MFHs."
		},
		"mfh.sign-off-envelopes.estates-overview": {
			rootPath: "/mfhs/:mfhId",
			path: "sign-off-estates-envelopes",
			name: "mfh.sign-off-envelopes.estates-overview",
			description: "Shows sign-off approvals overview for a specific MFH estates."
		},
		"mfh.sign-off-envelopes.overview": {
			rootPath: "/mfhs/:mfhId",
			path: "sign-off-envelopes",
			name: "mfh.sign-off-envelopes.overview",
			description: "Shows sign-off approvals overview for a specific MFH."
		},
		"mfh.sign-off-envelope.details": {
			rootPath: "/mfhs/:mfhId",
			path: "sign-off-envelopes/:signOffEnvelopeId",
			name: "mfh.sign-off-envelope.details",
			description: "Details for a specific mfh sign-off envelope within mfh context."
		},
		"mfh.sign-off-envelope.additional-document": {
			rootPath: "/mfhs/:mfhId",
			path: "sign-off-envelopes/:signOffEnvelopeId/additional-document",
			name: "mfh.sign-off-envelope.additional-document",
			description: "Add additional documents to an MFH sign-off envelope (RAM iframe when F_EMBED_SIGN_OFF_ENVELOPES_PAGE is enabled)."
		}
	};
	resolveRoutePath = (route, { params, baseUrl, hash, query } = {}) => {
		let path = route.rootPath ? `${baseUrl ?? ""}${route.rootPath}/${route.path}` : `${baseUrl ?? ""}${route.path}`;
		for (const [key, val] of Object.entries(params ?? {})) path = path.replaceAll(`:${key}`, String(val));
		const queryParts = [];
		for (const [key, val] of Object.entries(query ?? {})) if (key && val) queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(val)}`);
		if (queryParts.length > 0) path += `?${queryParts.join("&")}`;
		if (hash) path += `#${hash}`;
		return path;
	};
	getStrippedCCSRoutes = () => {
		return Object.entries(CCSRouteMap).reduce((acc, [key, value]) => {
			acc[key] = omit(value, "rootPath");
			return acc;
		}, {});
	};
	encodeReturnRoute = (route) => {
		try {
			return btoa(JSON.stringify(route));
		} catch (error) {
			console.warn("Failed to encode return route:", error);
			return "";
		}
	};
	decodeReturnRoute = (encodedRoute) => {
		try {
			return JSON.parse(atob(encodedRoute));
		} catch (error) {
			console.warn("Failed to decode return route:", error);
			return null;
		}
	};
	getReturnRoute = (currentRoute, fallback) => {
		if (!currentRoute.query) return fallback;
		const returnTo = currentRoute.query.returnTo;
		if (!returnTo) return fallback;
		return decodeReturnRoute(returnTo) ?? fallback;
	};
	createRouteWithReturn = (targetRoute, currentRoute) => {
		const returnRoute = {
			name: currentRoute.name,
			...currentRoute.params && Object.keys(currentRoute.params).length > 0 ? { params: currentRoute.params } : {},
			...currentRoute.query && Object.keys(currentRoute.query).length > 0 ? { query: currentRoute.query } : {}
		};
		return {
			...targetRoute,
			query: {
				...targetRoute.query,
				returnTo: encodeReturnRoute(returnRoute)
			}
		};
	};
}));
//#endregion
//#region src/__unsorted/ccs-routes/index.ts
var init_ccs_routes = __esmMin((() => {
	init_ccs_routes$1();
}));
//#endregion
//#region src/__unsorted/document-export/document-export.model.ts
var DocumentExportType;
var init_document_export_model = __esmMin((() => {
	DocumentExportType = /* @__PURE__ */ function(DocumentExportType) {
		DocumentExportType["EstateAggregatedInvestorShare"] = "EstateAggregatedInvestorShare";
		DocumentExportType["EstateRentReport"] = "EstateRentReport";
		DocumentExportType["SellingEstatesDataSheet"] = "SellingEstatesDataSheet";
		return DocumentExportType;
	}({});
}));
//#endregion
//#region src/__unsorted/document-export/index.ts
var init_document_export = __esmMin((() => {
	init_document_export_model();
}));
//#endregion
//#region src/domains/renovation/construction.base.ts
var ConstructionPlanTemplate, ConstructionPlanState, ConstructionPlanType, ConstructionPlanStructureType, ConstructionPlanClassification, ConstructionPlanDurationsEnum, constructionPlanThatCanHaveMultipleActivePlans, BudgetOrigin;
var init_construction_base = __esmMin((() => {
	ConstructionPlanTemplate = /* @__PURE__ */ function(ConstructionPlanTemplate) {
		ConstructionPlanTemplate["Normal"] = "Normal";
		ConstructionPlanTemplate["Sophisticated"] = "Sophisticated";
		ConstructionPlanTemplate["Luxury"] = "Luxury";
		ConstructionPlanTemplate["HistoricSophisticated"] = "HistoricSophisticated";
		ConstructionPlanTemplate["HistoricLuxury"] = "HistoricLuxury";
		ConstructionPlanTemplate["HeatingSanitaryNormal"] = "HeatingSanitaryNormal";
		ConstructionPlanTemplate["HeatingSanitarySophisticated"] = "HeatingSanitarySophisticated";
		ConstructionPlanTemplate["Kitchen"] = "Kitchen";
		ConstructionPlanTemplate["Demolition"] = "Demolition";
		ConstructionPlanTemplate["Cleaning"] = "Cleaning";
		ConstructionPlanTemplate["Order"] = "Order";
		return ConstructionPlanTemplate;
	}({});
	ConstructionPlanState = /* @__PURE__ */ function(ConstructionPlanState) {
		ConstructionPlanState["New"] = "New";
		ConstructionPlanState["Draft"] = "Draft";
		ConstructionPlanState["Review"] = "Review";
		ConstructionPlanState["Approved"] = "Approved";
		ConstructionPlanState["Rejected"] = "Rejected";
		ConstructionPlanState["Completed"] = "Completed";
		return ConstructionPlanState;
	}({});
	ConstructionPlanType = /* @__PURE__ */ function(ConstructionPlanType) {
		ConstructionPlanType["Measurements"] = "Measurements";
		ConstructionPlanType["General"] = "General";
		ConstructionPlanType["Kitchen"] = "Kitchen";
		ConstructionPlanType["Cleaning"] = "Cleaning";
		ConstructionPlanType["Electricity"] = "Electricity";
		ConstructionPlanType["Material"] = "Material";
		ConstructionPlanType["Other"] = "Other";
		ConstructionPlanType["Replacement"] = "Replacement";
		ConstructionPlanType["IndividualContract"] = "IndividualContract";
		ConstructionPlanType["Light"] = "Light";
		return ConstructionPlanType;
	}({});
	ConstructionPlanStructureType = /* @__PURE__ */ function(ConstructionPlanStructureType) {
		ConstructionPlanStructureType["Complete"] = "Complete";
		ConstructionPlanStructureType["Partial"] = "Partial";
		return ConstructionPlanStructureType;
	}({});
	ConstructionPlanClassification = /* @__PURE__ */ function(ConstructionPlanClassification) {
		ConstructionPlanClassification["Contract"] = "Contract";
		ConstructionPlanClassification["Addendum"] = "Addendum";
		return ConstructionPlanClassification;
	}({});
	ConstructionPlanDurationsEnum = /* @__PURE__ */ function(ConstructionPlanDurationsEnum) {
		ConstructionPlanDurationsEnum[ConstructionPlanDurationsEnum["FourWeeks"] = 4] = "FourWeeks";
		ConstructionPlanDurationsEnum[ConstructionPlanDurationsEnum["FiveWeeks"] = 5] = "FiveWeeks";
		ConstructionPlanDurationsEnum[ConstructionPlanDurationsEnum["SixWeeks"] = 6] = "SixWeeks";
		ConstructionPlanDurationsEnum[ConstructionPlanDurationsEnum["SevenWeeks"] = 7] = "SevenWeeks";
		ConstructionPlanDurationsEnum[ConstructionPlanDurationsEnum["EightWeeks"] = 8] = "EightWeeks";
		return ConstructionPlanDurationsEnum;
	}({});
	constructionPlanThatCanHaveMultipleActivePlans = [
		"Replacement",
		"IndividualContract",
		"Other"
	];
	BudgetOrigin = /* @__PURE__ */ function(BudgetOrigin) {
		BudgetOrigin["EnergyEfficiency"] = "EnergyEfficiency";
		BudgetOrigin["Interior"] = "Interior";
		BudgetOrigin["InteriorCommercial"] = "InteriorCommercial";
		BudgetOrigin["GeneralCapex"] = "GeneralCapex";
		BudgetOrigin["CapexExpansion"] = "CapexExpansion";
		return BudgetOrigin;
	}({});
}));
//#endregion
//#region src/domains/transaction/form-question/form-question.model.ts
var FormQuestionType, FormQuestionGuard, FormQuestion, questionShouldBeEvaluated;
var init_form_question_model = __esmMin((() => {
	FormQuestionType = /* @__PURE__ */ function(FormQuestionType) {
		FormQuestionType["Banner"] = "banner";
		FormQuestionType["Label"] = "label";
		FormQuestionType["Header"] = "header";
		FormQuestionType["Switch"] = "switch";
		FormQuestionType["Toggle"] = "toggle";
		FormQuestionType["Text"] = "text";
		FormQuestionType["TextArea"] = "textarea";
		FormQuestionType["TextAreaNote"] = "textareanote";
		FormQuestionType["SelectBox"] = "selectbox";
		FormQuestionType["MultiSelectBox"] = "multiselectbox";
		FormQuestionType["YearSelectBox"] = "yearselectbox";
		FormQuestionType["AsyncSelectBox"] = "asyncselectbox";
		FormQuestionType["Upload"] = "upload";
		FormQuestionType["Number"] = "number";
		FormQuestionType["File"] = "file";
		FormQuestionType["Radio"] = "radio";
		FormQuestionType["Date"] = "datepicker";
		FormQuestionType["DateRange"] = "daterange";
		FormQuestionType["MultipleAnswer"] = "MultipleAnswer";
		return FormQuestionType;
	}({});
	FormQuestionGuard = class {
		name;
		value;
		constructor(name, value) {
			this.name = name;
			this.value = value;
		}
		isValid(answers) {
			if (Array.isArray(this.value)) return this.value.includes(answers[this.name]);
			return answers[this.name] === this.value || this.value === "exists" && !isNil(answers[this.name]);
		}
	};
	FormQuestion = class {
		name;
		title;
		type;
		format;
		values = [];
		mimeTypes;
		required = false;
		guards = [];
		entityField;
		hintValueEntityField;
		tooltip;
		valueOnClear;
		hint;
		hintTemplate;
		constructor(formQuestion) {
			Object.assign(this, formQuestion);
			if (formQuestion.guards?.length) this.guards = formQuestion.guards.map((g) => Array.isArray(g) ? g.map((i) => new FormQuestionGuard(i.name, i.value)) : new FormQuestionGuard(g.name, g.value));
		}
		areAnswersValid(answers) {
			const value = answers[this.name];
			if (this.required && this.guards.every((g) => Array.isArray(g) ? g.some((i) => i.isValid(answers)) : g.isValid(answers))) return isPresent(value);
			return true;
		}
	};
	questionShouldBeEvaluated = (question, allQuestions, answers) => {
		const guardIsValid = (guard) => allQuestions.some((questionToMatch) => {
			if (questionToMatch.name !== guard.name) return false;
			if (Array.isArray(guard.value)) return guard.value.includes(answers[questionToMatch.name]);
			return answers[questionToMatch.name] === guard.value || guard.value === "exists" && !isNil(answers[questionToMatch.name]);
		});
		return !question.guards || question.guards.every((g) => Array.isArray(g) ? g.some((i) => guardIsValid(i)) : guardIsValid(g));
	};
}));
//#endregion
//#region src/domains/transaction/form-question/form-question.factory.ts
var FormQuestionFactory;
var init_form_question_factory = __esmMin((() => {
	init_form_question_model();
	FormQuestionFactory = class FormQuestionFactory {
		static Banner(title, name, guards = []) {
			return {
				title,
				name,
				type: "banner",
				guards,
				values: []
			};
		}
		static Switch({ title, name, values, required = false, entityField, tooltip, guards = [], withTextInputField = false }) {
			return {
				title,
				name,
				type: "switch",
				required,
				entityField,
				tooltip,
				guards,
				values,
				withTextInputField
			};
		}
		static SwitchWithTextInputField({ title, name, values, required = false, entityField, tooltip, guards = [] }) {
			return FormQuestionFactory.Switch({
				title,
				name,
				required,
				entityField,
				tooltip,
				guards,
				values,
				withTextInputField: true
			});
		}
		static Text({ title, name, required = false, entityField, tooltip, format, guards = [] }) {
			return {
				title,
				name,
				type: "text",
				format,
				required,
				entityField,
				tooltip,
				guards
			};
		}
		static TextInput({ title, name, required = false, entityField, tooltip, format, guards = [] }) {
			return {
				title,
				name,
				type: "textarea",
				format,
				required,
				entityField,
				tooltip,
				guards
			};
		}
		static TextInputNote({ title, name, required = false, entityField, tooltip, format, guards = [] }) {
			return {
				title,
				name,
				type: "textareanote",
				format,
				required,
				entityField,
				tooltip,
				guards
			};
		}
		static Number({ title, name, required = false, entityField, tooltip, format, guards = [], defaultValue, min, max, step, minimumFractionDigits, maximumFractionDigits, isToggled = false, hintValueEntityField, hintTemplate, hint }) {
			return {
				title,
				name,
				type: "number",
				format,
				defaultValue,
				min,
				max,
				step,
				minimumFractionDigits,
				maximumFractionDigits,
				required,
				isToggled,
				entityField,
				tooltip,
				guards,
				hintValueEntityField,
				hintTemplate,
				hint
			};
		}
		static YesNoSwitch({ title, name, required = false, entityField, tooltip, guards = [] }) {
			return FormQuestionFactory.Switch({
				title,
				name,
				required,
				entityField,
				tooltip,
				guards,
				values: ["Ja", "Nein"]
			});
		}
		static Toggle({ title, name, format, required = false, defaultValue = false, entityField, tooltip, guards = [], hidden = false, hintValueEntityField, hintTemplate, hint }) {
			return {
				title,
				name,
				format,
				required,
				defaultValue,
				entityField,
				tooltip,
				guards,
				hidden,
				type: "toggle",
				hintValueEntityField,
				hintTemplate,
				hint
			};
		}
		static Note({ name, required = false, entityField, tooltip, guards = [] }) {
			return FormQuestionFactory.TextInputNote({
				title: "Anmerkungen",
				name,
				required,
				entityField,
				tooltip,
				guards
			});
		}
		static Upload({ title, name, required = false, entityField, tooltip, guards = [] }) {
			return {
				title,
				name,
				type: "upload",
				required,
				entityField,
				tooltip,
				guards
			};
		}
		static AsyncSelectBox({ title, name, required = false, entityField, tooltip, guards = [], values }) {
			return {
				title,
				name,
				type: "asyncselectbox",
				required,
				entityField,
				tooltip,
				guards,
				values
			};
		}
		static SelectBox({ title, name, required = false, tooltip, guards = [], values, isToggled = false, allowAdditionalValues = false, format, hintValueEntityField, hintTemplate, hint }) {
			return {
				title,
				name,
				type: "selectbox",
				required,
				isToggled,
				allowAdditionalValues,
				tooltip,
				guards,
				values,
				format,
				hintValueEntityField,
				hintTemplate,
				hint
			};
		}
		static MultiSelectBox({ title, name, required = false, tooltip, guards = [], values, format }) {
			return {
				title,
				name,
				type: "multiselectbox",
				required,
				tooltip,
				guards,
				values,
				format
			};
		}
		static YearSelectBox({ title, name, required = false, tooltip, guards = [], multiple = false, min, max }) {
			return {
				title,
				name,
				type: "yearselectbox",
				required,
				tooltip,
				guards,
				multiple,
				min,
				max
			};
		}
		static Date({ title, name, required = false, valueOnClear = "", entityField, tooltip, format, guards = [], hintValueEntityField, hintTemplate, hint }) {
			return {
				title,
				name,
				type: "datepicker",
				format,
				required,
				valueOnClear,
				entityField,
				tooltip,
				guards,
				hintValueEntityField,
				hintTemplate,
				hint
			};
		}
		static DateRange({ title, name, required = false, entityField, tooltip, guards = [] }) {
			return {
				title,
				name,
				type: "daterange",
				required,
				entityField,
				tooltip,
				guards
			};
		}
		static Label({ title, name, required = false, tooltip, guards = [] }) {
			return {
				title,
				name,
				type: "label",
				required,
				tooltip,
				guards
			};
		}
		static Header({ title, name, headerLevel, guards = [] }) {
			return {
				title,
				name,
				headerLevel,
				type: "header",
				guards
			};
		}
		static MultipleAnswer({ title, name, questions, required, guards = [] }) {
			return {
				title,
				name,
				questions,
				type: "MultipleAnswer",
				required,
				guards
			};
		}
	};
}));
//#endregion
//#region src/domains/transaction/form-question/estate-inspection-questions.ts
var EstateInspectionQuestions;
var init_estate_inspection_questions = __esmMin((() => {
	EstateInspectionQuestions = [
		["Umgebung", [["Viertel/Lage", [
			{
				title: "Wie gut ist die Lage des Objekts? (CONDO Sicht)",
				title_style: "header",
				title_position: "top",
				type: "selectbox",
				mandatory_input: true,
				values: [
					"Einfach",
					"Mittel",
					"Gut"
				],
				source: "own research",
				db: "new",
				name: "surroundings_area_evaluation",
				dependent_on: ""
			},
			{
				title_style: "header",
				title_position: "top",
				title: "In welcher Lage befindet sich das Objekt?",
				mandatory_input: true,
				values: [
					"Citylage",
					"Randlage",
					"Grünlage",
					"Sozialer Brennpunkt",
					"Wohnpark",
					"Villenlage",
					"Einfamilenhauslage"
				],
				name: "surroundings_area_detail",
				type: "multiselectbox"
			},
			{
				title: "Anmerkungen etc.",
				title_style: "form_input",
				title_position: "inside",
				type: "textarea",
				mandatory_input: false,
				values: [""],
				source: "own research",
				db: "",
				name: "surroundings_area_evaluation_textInput",
				dependent_on: ""
			}
		]], ["Unmittelbare Umgebung", [
			{
				title: "Gibt es unmittelbare Störfaktoren (z.B. Bahn, große Straße, lauter Platz)?",
				title_style: "header",
				title_position: "top",
				type: "switch",
				mandatory_input: true,
				values: ["Ja", "Nein"],
				source: "own research",
				db: "new",
				name: "surroundings_close_isNoise",
				dependent_on: ""
			},
			{
				title: "Anmerkungen etc.",
				title_style: "form_input",
				title_position: "inside",
				type: "textarea",
				mandatory_input: false,
				values: [""],
				source: "own research",
				db: "",
				name: "surroundings_close_isNoise_textInput",
				dependent_on: ""
			},
			{
				title: "Wie ist die Parksituation in der unmittelbaren Umgebung?",
				title_style: "header",
				title_position: "top",
				type: "selectbox",
				mandatory_input: true,
				values: [
					"Gut",
					"Normal",
					"Angespannt"
				],
				source: "own research",
				db: "new",
				name: "surroundings_close_parking",
				dependent_on: ""
			},
			{
				title: "Anmerkungen etc.",
				title_style: "form_input",
				title_position: "inside",
				type: "textarea",
				mandatory_input: false,
				values: [""],
				source: "own research",
				db: "",
				name: "surroundings_close_parking_textInput",
				dependent_on: ""
			},
			{
				title: "Welche ÖPNV-Anbindung gibt es in einem Umkreis von 500m?",
				title_style: "header",
				title_position: "top",
				type: "multiselectbox",
				mandatory_input: false,
				values: [
					"Bus",
					"U-Bahn",
					"S-Bahn",
					"Fernverkehr",
					"Straßenbahn",
					"Fähre"
				],
				source: "own research",
				db: "new",
				name: "surroundings_close_publicTransport",
				dependent_on: ""
			},
			{
				title: "Anmerkungen etc.",
				title_style: "form_input",
				title_position: "inside",
				type: "textarea",
				mandatory_input: false,
				values: [""],
				source: "own research",
				db: "",
				name: "surroundings_close_publicTransport_textInput",
				dependent_on: ""
			}
		]]]],
		["Gebäude", [
			["Allgemein", [
				{
					title: "Bauart des Hauses?",
					title_style: "header",
					title_position: "top",
					type: "selectbox",
					mandatory_input: false,
					values: [
						"Altbau",
						"Fachwerk",
						"Nachkriegsbau",
						"60er/70er",
						"80er/90er",
						"ab 2000er"
					],
					source: "own research",
					db: "new",
					name: "building_general_constructionType",
					dependent_on: ""
				},
				{
					title: "Wie gepflegt ist der Gesamterscheinungsbild des Hauses?",
					title_style: "form_input",
					title_position: "inside",
					type: "selectbox",
					values: [
						"Sehr gut",
						"Gut",
						"Befriedigend",
						"Unbefriedigend"
					],
					mandatory_input: false,
					source: "seller",
					db: "",
					name: "building_outside_door_condition",
					dependent_on: ""
				},
				{
					title: "Anmerkungen etc.",
					title_style: "form_input",
					title_position: "inside",
					type: "textarea",
					mandatory_input: false,
					source: "seller",
					db: "",
					name: "building_outside_door_condition_notes",
					dependent_on: ""
				}
			]],
			["Außen", [
				{
					title: "Wie ist die Fassade beschaffen?",
					title_style: "header",
					title_position: "top",
					type: "selectbox",
					mandatory_input: true,
					values: [
						"Klinkerfassade",
						"Holzfassade",
						"Putzfassade",
						"Fachwerk",
						"Massivfassade",
						"Verschalung",
						"WDVS"
					],
					source: "own research",
					db: "new",
					name: "building_outside_faceType",
					dependent_on: "",
					entityField: {
						entity: "estate",
						attributePath: "attributes.facadeType"
					}
				},
				{
					title: "Wie ist der Zustand der Fassade?",
					title_style: "header",
					title_position: "top",
					type: "selectbox",
					mandatory_input: true,
					values: [
						"Sehr gut",
						"Gut",
						"Befriedigend",
						"Unbefriedigend"
					],
					source: "own research",
					db: "new",
					name: "building_outside_faceCondition",
					dependent_on: ""
				},
				{
					title: "Wann fanden die letzten Sanierungsmaßnahmen an der Fassade statt?",
					title_style: "header",
					title_position: "top",
					type: "datepicker",
					mandatory_input: false,
					source: "own research",
					db: "new",
					name: "attributes_facade_renovation_date",
					dependent_on: "",
					entityField: {
						entity: "estate",
						attributePath: "attributes.facadeRenovationDate"
					}
				},
				{
					title: "Anmerkungen etc.",
					title_style: "form_input",
					title_position: "inside",
					type: "textarea",
					mandatory_input: false,
					values: [""],
					source: "own research",
					db: "",
					name: "building_outside_face_condition_textInput",
					dependent_on: ""
				},
				{
					title: "Was ist der Dach Typ?",
					title_style: "header",
					title_position: "top",
					type: "selectbox",
					values: [
						"Flachdach",
						"Satteldach",
						"Walmdach",
						"Krüppelwalmdach",
						"Pultdach"
					],
					mandatory_input: true,
					source: "seller",
					db: "new",
					name: "attributes_roof_type",
					dependent_on: "",
					entityField: {
						entity: "estate",
						attributePath: "attributes.roofType"
					}
				},
				{
					title: "Wie ist der aktuelle Zustand des Dachs?",
					title_style: "header",
					title_position: "top",
					type: "selectbox",
					mandatory_input: true,
					values: [
						"Sehr gut",
						"Gut",
						"Befriedigend",
						"Unbefriedigend",
						"Keine Informationen"
					],
					source: "seller",
					db: "new",
					name: "building_outside_roofCondition",
					dependent_on: ""
				},
				{
					title: "Wann fanden die letzten Sanierungsmaßnahmen statt?",
					title_style: "header",
					title_position: "top",
					type: "datepicker",
					mandatory_input: false,
					source: "seller",
					db: "new",
					name: "attributes_roof_renovation_date",
					dependent_on: "",
					entityField: {
						entity: "estate",
						attributePath: "attributes.roofRenovationDate"
					}
				},
				{
					title: "Anmerkungen etc.",
					title_style: "form_input",
					title_position: "inside",
					type: "textarea",
					mandatory_input: false,
					values: [""],
					source: "seller",
					db: "",
					name: "building_outside_renovationDate_textInput",
					dependent_on: ""
				}
			]],
			["Innen", [{
				title: "Gibt es einen Aufzug?",
				title_style: "header",
				title_position: "top",
				type: "switch",
				mandatory_input: true,
				values: ["Ja", "Nein"],
				source: "own research",
				db: "attributes.lift",
				name: "building_inside_isLift",
				dependent_on: ""
			}, {
				title: "Anmerkungen etc.",
				title_style: "form_input",
				title_position: "inside",
				type: "textarea",
				mandatory_input: false,
				values: [""],
				source: "own research",
				db: "",
				name: "building_inside_isLift_textInput",
				dependent_on: ""
			}]],
			["Keller", [
				{
					title: "Ist das Gebäude unterkellert?",
					title_style: "header",
					title_position: "top",
					type: "switch",
					mandatory_input: true,
					values: ["Ja", "Nein"],
					db: "new",
					name: "building_is_basement",
					dependent_on: ""
				},
				{
					title: "Sind die allgemeinen Keller-Räumlichkeiten feucht (Wände, Boden, Decken)?",
					title_style: "header",
					title_position: "top",
					type: "switch",
					mandatory_input: false,
					values: ["Ja", "Nein"],
					source: "own research",
					db: "new",
					name: "building_basement_isWet",
					dependent_on: "",
					guards: [{
						name: "building_is_basement",
						value: "Ja"
					}]
				},
				{
					title: "Gibt es Gemeinschaftsräume?",
					title_style: "header",
					title_position: "top",
					type: "multiselectbox",
					mandatory_input: false,
					values: [
						"Fahrradraum",
						"Trockenraum",
						"Waschküche",
						"Schwimmbad",
						"Sauna",
						"Fitnessraum",
						"Partyraum",
						"Sonstiges"
					],
					source: "seller",
					db: "",
					name: "are_there_common_rooms",
					dependent_on: ""
				},
				{
					title: "Anmerkungen etc.",
					title_style: "form_input",
					title_position: "inside",
					type: "textarea",
					mandatory_input: false,
					values: [""],
					source: "own research",
					db: "",
					name: "are_there_common_rooms_textInput",
					dependent_on: ""
				}
			]],
			["Heizung", [
				{
					title: "Was ist der Heizung Typ?",
					title_style: "header",
					title_position: "top",
					type: "selectbox",
					values: [
						"Gas-Zentral",
						"Gas-Etage",
						"Fernwärme",
						"Öl-Heizung",
						"Pallet-Heizung",
						"Solar",
						"Nachtspeicher-Storm",
						"Ofen",
						"Sonstiges"
					],
					mandatory_input: true,
					source: "seller",
					db: "new",
					name: "attributes_heating_type",
					dependent_on: "",
					entityField: {
						entity: "estate",
						attributePath: "attributes.heatingType"
					}
				},
				{
					title: "Anmerkungen etc.",
					title_style: "form_input",
					title_position: "inside",
					type: "textarea",
					mandatory_input: false,
					values: [""],
					source: "own research",
					db: "",
					name: "heating_type_textInput",
					dependent_on: ""
				},
				{
					title: "Baujahr der Heizung?",
					title_style: "header",
					title_position: "top",
					type: "datepicker",
					mandatory_input: true,
					source: "seller",
					db: "new",
					name: "heater_construction_year",
					dependent_on: ""
				},
				{
					title: "Wann fanden die letzten Sanierungsmaßnahmen an der Heizung statt?",
					title_style: "header",
					title_position: "top",
					type: "datepicker",
					mandatory_input: false,
					source: "seller",
					db: "new",
					name: "attributes_heating_renovation_date",
					dependent_on: "",
					entityField: {
						entity: "estate",
						attributePath: "attributes.heatingRenovationDate"
					}
				},
				{
					title: "Welche Sanierungsmaßnahmen wurden durchgeführt?",
					title_style: "header",
					title_position: "top",
					type: "textarea",
					mandatory_input: false,
					source: "seller",
					db: "new",
					name: "attributes_heating_renovation",
					dependent_on: "",
					entityField: {
						entity: "estate",
						attributePath: "attributes.heatingRenovationType"
					},
					guards: [{
						name: "attributes_heating_renovation_date",
						value: "exists"
					}]
				}
			]],
			["Sonstiges", [
				{
					db: "",
					name: "attributes_other_renovations_performed",
					type: "switch",
					title: "Wurden sonstige große Sanierungsmaßnahmen durchgeführt? (z.B. Fahrstuhl, Stränge, Treppenhaus, Balkone, Fenster, Keller)",
					values: ["Ja", "Nein"],
					title_style: "header",
					dependent_on: "",
					title_position: "top",
					mandatory_input: true
				},
				{
					db: "new",
					name: "attributes_other_renovations",
					type: "textarea",
					title: "Art der Sanierungsmaßnahmen",
					guards: [{
						name: "attributes_other_renovations_performed",
						value: "Ja"
					}],
					entityField: {
						entity: "estate",
						attributePath: "attributes.otherRenovations"
					},
					title_style: "header",
					dependent_on: "attributes_other_renovations_performed",
					title_position: "top",
					mandatory_input: true
				},
				{
					db: "new",
					name: "attributes_other_renovations_date",
					type: "datepicker",
					title: "Jahr der Sanierungsmaßnahmen",
					guards: [{
						name: "attributes_other_renovations_performed",
						value: "Ja"
					}],
					field_opts: { year_only: true },
					entityField: {
						entity: "estate",
						attributePath: "attributes.otherRenovationsDate"
					},
					title_style: "header",
					dependent_on: "attributes_other_renovations_performed",
					title_position: "top",
					mandatory_input: true
				}
			]]
		]],
		["Wohnung", [
			["Allgemein", [
				{
					title: "In welcher Etage befindet sich die Wohnung",
					title_style: "header",
					title_position: "top",
					type: "selectbox",
					mandatory_input: true,
					values: [
						"Souterrain",
						"Erdgeschoss",
						"Hochparterre",
						"1",
						"2",
						"3",
						"4",
						"5",
						"6",
						"7",
						"8",
						"9",
						"10",
						"11",
						"12",
						"13",
						"14",
						"15",
						"16",
						"17",
						"18",
						"19",
						"20",
						"21",
						"22",
						"23",
						"24",
						"25"
					],
					source: "own research",
					db: "attributes.floor",
					name: "apartment_general_floor",
					dependent_on: ""
				},
				{
					title: "Wo befindet sich die Wohnung auf der Etage?",
					title_style: "header",
					title_position: "top",
					type: "selectbox",
					mandatory_input: true,
					values: [
						"R",
						"MR",
						"M",
						"ML",
						"L",
						"Other"
					],
					source: "own research",
					db: "attributes.floor",
					name: "apartment_floor_location",
					dependent_on: "",
					entityField: {
						entity: "estate",
						attributePath: "attributes.floorLocation"
					}
				},
				{
					title: "Anmerkungen etc.",
					title_style: "form_input",
					title_position: "inside",
					type: "textarea",
					mandatory_input: false,
					values: [""],
					source: "own research",
					db: "",
					name: "apartment_floor_location_textInput",
					dependent_on: "",
					guards: [{
						name: "apartment_floor_location",
						value: "Other"
					}]
				},
				{
					title: "Um welchen Wohnungstyp handelt es sich?",
					title_style: "header",
					title_position: "top",
					type: "selectbox",
					mandatory_input: false,
					values: [
						"Souterrain",
						"Erdgeschoss",
						"Hochparterre",
						"Etagenwohnung",
						"Loft",
						"Maisonette",
						"Terassenwohnung",
						"Penthouse",
						"Dachgeschoss",
						"Sonstige"
					],
					source: "own research",
					db: "attributes.apartment_type",
					name: "apartment_general_type",
					dependent_on: ""
				},
				{
					title: "Hat die Wohnung einen eigenen Abstellraum?",
					title_style: "header",
					title_position: "top",
					type: "multiselectbox",
					mandatory_input: true,
					values: [
						"Keller",
						"Dachgeschoss",
						"Treppenhaus",
						"In der Wohnung",
						"Nein"
					],
					source: "seller",
					db: "new",
					name: "apartment_general_storage",
					dependent_on: ""
				},
				{
					title: "Blick/Aussicht vom Balkon / Wohnzimmer",
					title_style: "header",
					title_position: "top",
					type: "label",
					source: "own research",
					db: "",
					name: "apartment_general_isViewConstraints",
					dependent_on: ""
				},
				{
					title: "Ins Grüne?",
					title_style: "header",
					title_position: "top",
					type: "switch",
					mandatory_input: true,
					values: ["Ja", "Nein"],
					source: "seller",
					db: "new",
					name: "apartment_view_isCountrySide",
					dependent_on: ""
				},
				{
					title: "In den Hinterhof?",
					title_style: "header",
					title_position: "top",
					type: "switch",
					mandatory_input: true,
					values: ["Ja", "Nein"],
					source: "seller",
					db: "new",
					name: "apartment_view_isBackyard",
					dependent_on: ""
				},
				{
					title: "Auf die Strasse?",
					title_style: "header",
					title_position: "top",
					type: "switch",
					mandatory_input: true,
					values: ["Ja", "Nein"],
					source: "seller",
					db: "new",
					name: "apartment_view_isOnTheStreet",
					dependent_on: ""
				},
				{
					title: "Weitblick?",
					title_style: "header",
					title_position: "top",
					type: "switch",
					mandatory_input: true,
					values: ["Ja", "Nein"],
					source: "seller",
					db: "new",
					name: "apartment_view_isForesight",
					dependent_on: ""
				},
				{
					title: "Auf Hochhäuser?",
					title_style: "header",
					title_position: "top",
					type: "switch",
					mandatory_input: true,
					values: ["Ja", "Nein"],
					source: "seller",
					db: "new",
					name: "apartment_view_isOnHighBuildings",
					dependent_on: ""
				},
				{
					title: "Anmerkungen etc.",
					title_style: "form_input",
					title_position: "inside",
					type: "textarea",
					mandatory_input: false,
					values: [""],
					source: "own research",
					db: "",
					name: "apartment_general_isViewConstraints_textInput",
					dependent_on: ""
				},
				{
					title: "Wie ist der Geräuschpegel in der Wohnung (offene und geschlossene Fenster)?",
					title_style: "header",
					title_position: "top",
					type: "selectbox",
					mandatory_input: true,
					values: [
						"Sehr Leise",
						"Leise",
						"Normal",
						"Eher Laut",
						"Sehr Laut"
					],
					source: "own research",
					db: "new",
					name: "apartment_general_noise",
					dependent_on: ""
				},
				{
					title: "Anmerkungen etc.",
					title_style: "form_input",
					title_position: "inside",
					type: "textarea",
					mandatory_input: false,
					values: [""],
					source: "own research",
					db: "",
					name: "apartment_general_noise_textInput",
					dependent_on: ""
				}
			]],
			["Sonderthemen", [
				{
					title: "Gehört ein Stellplatz zur Wohnung?",
					title_style: "header",
					title_position: "top",
					type: "switch",
					mandatory_input: true,
					values: ["Ja", "Nein"],
					source: "seller",
					db: "",
					name: "apartment_other_isParking",
					dependent_on: ""
				},
				{
					title: "Anzahl Garagen-Stellplätze?",
					title_style: "header",
					title_position: "top",
					type: "number",
					mandatory_input: true,
					values: [""],
					source: "own research",
					db: "garage_parking_spaces",
					name: "garage_parking_spaces",
					dependent_on: "",
					guards: [{
						name: "apartment_other_isParking",
						value: "Ja"
					}]
				},
				{
					title: "Anzahl Außenstellplätze?",
					title_style: "header",
					title_position: "top",
					type: "number",
					mandatory_input: true,
					values: [""],
					source: "own research",
					db: "outdoor_parking_spaces",
					name: "outdoor_parking_spaces",
					dependent_on: "",
					guards: [{
						name: "apartment_other_isParking",
						value: "Ja"
					}]
				},
				{
					title: "Anzahl Tiefgaragen-Stellplätze?",
					title_style: "header",
					title_position: "top",
					type: "number",
					mandatory_input: true,
					values: [""],
					source: "own research",
					db: "underground_parking_spaces",
					name: "underground_parking_spaces",
					dependent_on: "",
					guards: [{
						name: "apartment_other_isParking",
						value: "Ja"
					}]
				},
				{
					title: "Anmerkungen etc.",
					title_style: "form_input",
					title_position: "inside",
					type: "textarea",
					mandatory_input: false,
					values: [""],
					source: "own research",
					db: "",
					name: "apartment_other_isParking_textInput",
					dependent_on: ""
				},
				{
					title: "Gibt es andere Sondernutzungsrechte für diese Wohnnung (z.B. Garten, Dachterasse)?",
					title_style: "header",
					title_position: "top",
					type: "switch",
					mandatory_input: false,
					values: ["Ja", "Nein"],
					source: "seller",
					db: "new",
					name: "apartment_other_isOtherUses",
					dependent_on: ""
				},
				{
					title: "Anmerkungen etc.",
					title_style: "form_input",
					title_position: "inside",
					type: "textarea",
					mandatory_input: false,
					values: [""],
					source: "own research",
					db: "",
					name: "apartment_other_isOtherUses_textInput",
					dependent_on: ""
				}
			]],
			["Gesamtzustand", [{
				title: "Besteht eine Asbestgefahr?",
				title_style: "header",
				title_position: "top",
				type: "switch",
				mandatory_input: true,
				values: ["Ja", "Nein"],
				name: "has_asbestos_risk",
				dependent_on: ""
			}]],
			["Küche", [
				{
					title: "Ist eine Einbauküche vorhanden?",
					title_style: "header",
					title_position: "top",
					type: "switch",
					mandatory_input: false,
					values: ["Ja", "Nein"],
					source: "own research",
					db: "attributes.built_in_kitchen",
					name: "apartment_kitchen_isKitchen",
					dependent_on: ""
				},
				{
					title: "Wie findet aktuell die Warmwasserversorgung statt?",
					title_style: "header",
					title_position: "top",
					type: "selectbox",
					mandatory_input: false,
					values: [
						"Heizung",
						"Durchlauferhitzer",
						"Boiler"
					],
					source: "seller",
					db: "new",
					name: "apartment_kitchen_waterType",
					dependent_on: ""
				},
				{
					title: "Sind Stock- oder Schimmelflecken zu erkennen (insb. an den Fenstern)?",
					title_style: "header",
					title_position: "top",
					type: "switch",
					mandatory_input: false,
					values: ["Ja", "Nein"],
					source: "own research",
					db: "new",
					name: "apartment_kitchen_isMold",
					dependent_on: ""
				},
				{
					title: "Anmerkungen etc.",
					title_style: "form_input",
					title_position: "inside",
					type: "textarea",
					mandatory_input: false,
					values: [""],
					source: "own research",
					db: "",
					name: "apartment_kitchen_isMold_textInput",
					dependent_on: ""
				}
			]],
			["Bad/WC", [
				{
					title: "Gibt es ein seperates Gäste-WC bzw. ist das WC vom Bad räumlich getrennt?",
					title_style: "header",
					title_position: "top",
					type: "switch",
					mandatory_input: false,
					values: ["Ja", "Nein"],
					source: "own research",
					db: "attributes.guest_toilet",
					name: "apartment_bath_isGuestToilet",
					dependent_on: "",
					entityField: {
						entity: "estate",
						attributePath: "attributes.guestToilet"
					}
				},
				{
					title: "Wie findet aktuell die Warmwasserversorgung statt?",
					title_style: "header",
					title_position: "top",
					type: "selectbox",
					mandatory_input: false,
					values: [
						"Heizung",
						"Durchlauferhitzer",
						"Boiler"
					],
					source: "seller",
					db: "new",
					name: "apartment_bath_waterType",
					dependent_on: ""
				},
				{
					title: "Gibt es ein Fenster?",
					title_style: "header",
					title_position: "top",
					type: "switch",
					mandatory_input: false,
					values: ["Ja", "Nein"],
					source: "own research",
					db: "new",
					name: "apartment_bath_is_there_window",
					dependent_on: ""
				},
				{
					title: "Anmerkungen etc.",
					title_style: "form_input",
					title_position: "inside",
					type: "textarea",
					mandatory_input: false,
					values: [""],
					source: "own research",
					db: "",
					name: "apartment_bath_overallFeedback_textInput",
					dependent_on: ""
				}
			]],
			["Fenster", [
				{
					title: "Wann fanden die letzten Sanierungsmaßnahmen statt?",
					title_style: "header",
					title_position: "top",
					type: "datepicker",
					mandatory_input: false,
					source: "seller",
					db: "new",
					name: "attributes_windows_renovation_date",
					dependent_on: "",
					entityField: {
						entity: "estate",
						attributePath: "attributes.windowRenovationDate"
					}
				},
				{
					title: "Welche Sanierungsmaßnahmen wurden durchgeführt?",
					title_style: "header",
					title_position: "top",
					type: "textarea",
					mandatory_input: false,
					source: "seller",
					db: "new",
					name: "attributes_windows_renovation",
					dependent_on: "",
					entityField: {
						entity: "estate",
						attributePath: "attributes.windowRenovationType"
					},
					guards: [{
						name: "attributes_windows_renovation_date",
						value: "exists"
					}]
				},
				{
					title: "Aus welchem Material bestehen die Fenster?",
					title_style: "header",
					title_position: "top",
					type: "multiselectbox",
					mandatory_input: false,
					values: [
						"Kunststoff",
						"Holz",
						"Metall"
					],
					source: "own research",
					db: "new",
					name: "apartment_windows_type",
					format: "string",
					dependent_on: "",
					entityField: {
						entity: "estate",
						attributePath: "attributes.windowType"
					}
				},
				{
					title: "Welchen Zustand haben die Fenster?",
					title_style: "header",
					title_position: "top",
					type: "selectbox",
					mandatory_input: false,
					values: [
						"Sehr gut",
						"Gut",
						"Befriedigend",
						"Unbefriedigend"
					],
					source: "own research",
					db: "new",
					name: "apartment_windows_condition",
					dependent_on: ""
				},
				{
					title: "Baujahr der Fenster?",
					title_style: "header",
					title_position: "top",
					type: "datepicker",
					mandatory_input: false,
					values: [""],
					source: "own research",
					db: "new",
					name: "apartment_windows_year",
					dependent_on: ""
				},
				{
					title: "Art der Verglasung?",
					title_style: "header",
					title_position: "top",
					type: "multiselectbox",
					mandatory_input: false,
					values: [
						"1-fach",
						"2-fach",
						"3-fach"
					],
					source: "own research",
					db: "new",
					name: "apartment_windows_vitrification",
					dependent_on: ""
				}
			]],
			["BALKON/TERRASSE", [
				{
					title: "Gibt es einen Balkon oder eine Terrasse?",
					title_style: "header",
					title_position: "top",
					type: "switch",
					mandatory_input: false,
					values: ["Ja", "Nein"],
					source: "own research",
					db: "new",
					name: "apartment_balcony_isBalcony",
					dependent_on: ""
				},
				{
					title: "In welchem Zustand ist der Balkon/die Terrasse?",
					title_style: "sub_header",
					title_position: "top",
					type: "selectbox",
					mandatory_input: false,
					values: [
						"Sehr gut",
						"Gut",
						"Befriedigend",
						"Unbefriedigend"
					],
					source: "own research",
					db: "",
					name: "apartment_balcony_condition",
					dependent_on: "apartment_balcony_isBalcony"
				},
				{
					title: "Anmerkungen etc.",
					title_style: "form_input",
					title_position: "inside",
					type: "textarea",
					mandatory_input: false,
					values: [""],
					source: "own research",
					db: "",
					name: "apartment_balcony_condition_textInput",
					dependent_on: "apartment_balcony_isBalcony"
				}
			]]
		]],
		["Weiteres", [["Mehr", [{
			title: "Weitere Anmerkungen",
			title_style: "form_input",
			title_position: "inside",
			type: "textarea",
			mandatory_input: false,
			values: [""],
			source: "seller",
			db: "new",
			name: "other_more_input",
			dependent_on: ""
		}]]]]
	];
}));
//#endregion
//#region src/domains/transaction/form-question/index.ts
var init_form_question = __esmMin((() => {
	init_form_question_model();
	init_form_question_factory();
	init_estate_inspection_questions();
}));
//#endregion
//#region src/domains/renovation/document-strategy/document-strategy.base.ts
var DocumentStrategy;
var init_document_strategy_base = __esmMin((() => {
	DocumentStrategy = /* @__PURE__ */ function(DocumentStrategy) {
		DocumentStrategy["ConstructionDescriptionRenovationForEnvironmentalProtectionArea"] = "ConstructionDescriptionRenovationForEnvironmentalProtectionArea";
		DocumentStrategy["ConstructionDescriptionRenovationForSimpleInteriorQuality"] = "ConstructionDescriptionRenovationForSimpleInteriorQuality";
		DocumentStrategy["ConstructionDescriptionRenovationForNormalInteriorQuality"] = "ConstructionDescriptionRenovationForNormalInteriorQuality";
		DocumentStrategy["ConstructionDescriptionRenovationForSophisticatedInteriorQuality"] = "ConstructionDescriptionRenovationForSophisticatedInteriorQuality";
		DocumentStrategy["ConstructionDescriptionRenovationForLuxuryInteriorQuality"] = "ConstructionDescriptionRenovationForLuxuryInteriorQuality";
		DocumentStrategy["LV"] = "LV";
		DocumentStrategy["AssetLV"] = "AssetLV";
		DocumentStrategy["LongLV"] = "LongLV";
		DocumentStrategy["LongAssetLV"] = "LongAssetLV";
		return DocumentStrategy;
	}({});
}));
//#endregion
//#region src/domains/renovation/document-strategy/document-strategy.helpers.ts
var generateOutdoorSpaceDetails;
var init_document_strategy_helpers = __esmMin((() => {
	generateOutdoorSpaceDetails = ({ balconyCount = 0, terraceCount = 0, loggiaCount = 0 }) => {
		const countWords = [
			"einer",
			"zwei",
			"drei"
		];
		const availableSpaces = [];
		let outdoorSpaceDetails = "";
		if (balconyCount > 0 && balconyCount <= 3) availableSpaces.push(balconyCount === 1 ? `einem Balkon` : `${countWords[balconyCount - 1]} Balkonen`);
		if (terraceCount > 0 && terraceCount <= 3) availableSpaces.push(`${countWords[terraceCount - 1]} ${terraceCount === 1 ? "Terrasse" : "Terrassen"}`);
		if (loggiaCount > 0 && loggiaCount <= 3) availableSpaces.push(`${countWords[loggiaCount - 1]} ${loggiaCount === 1 ? "Loggia" : "Loggien"}`);
		if (availableSpaces.length === 3) outdoorSpaceDetails = `${availableSpaces[0]}, ${availableSpaces[1]} und ${availableSpaces[2]}`;
		else if (availableSpaces.length === 2) outdoorSpaceDetails = `${availableSpaces[0]} und ${availableSpaces[1]}`;
		else if (availableSpaces.length === 1) outdoorSpaceDetails = availableSpaces[0];
		return outdoorSpaceDetails;
	};
}));
//#endregion
//#region src/domains/renovation/document-strategy/strategies/construction-description-renovation/construction-description-renovation.strategy.ts
var ConstructionDescriptionRenovationStrategy;
var init_construction_description_renovation_strategy = __esmMin((() => {
	init_document();
	init_errors();
	ConstructionDescriptionRenovationStrategy = class {
		documentType = "ConstructionDescriptionRenovation";
		resolveDocumentParams(params) {
			const preDefinedParams = this.getPreDefinedParams(params);
			const missingParams = Object.entries(preDefinedParams).filter(([, value]) => isNil(value)).map(([key]) => key);
			if (missingParams.length) throw new InvariantError(`Missing params: ${missingParams.join(", ")}`);
			return {
				...preDefinedParams,
				...this.getUserDefinedParams(params)
			};
		}
		provideDocumentData(params) {
			return omit(params, "estate");
		}
	};
}));
//#endregion
//#region src/domains/renovation/document-strategy/strategies/construction-description-renovation/environmental-protection-area.strategy.ts
var EnvironmentalProtectionAreaStrategy;
var init_environmental_protection_area_strategy = __esmMin((() => {
	init_form_question();
	init_document_strategy_helpers();
	init_construction_description_renovation_strategy();
	EnvironmentalProtectionAreaStrategy = class extends ConstructionDescriptionRenovationStrategy {
		documentStrategy = "ConstructionDescriptionRenovationForEnvironmentalProtectionArea";
		getPreDefinedParams(params) {
			const estate = params.estate;
			const floorDetails = params.includesFloorCoveringRenovation ? "Vinyl-Designbelag" : "Aufarbeitung des historischen Dielenbodens";
			return {
				estate,
				estateId: estate.estateId,
				estateUuid: estate.condoUuid,
				street: estate?.location?.street,
				houseNumber: estate?.location?.houseNumber,
				zipCode: estate?.location?.zipcode,
				city: estate?.location?.city,
				floor: isNumber(estate?.attributes?.floor) ? formatFloor({
					floor: estate?.attributes?.floor,
					shouldAbbreviateFloorDesignation: false
				}) : void 0,
				floorLocation: estate?.attributes?.floorLocation,
				purchasingEntityName: estate.purchasing?.purchasingEntity?.name,
				generalContractorName: estate.constructionPlans?.find((p) => p.active && p.state === "Approved" && p.planType === "General")?.contractor?.name,
				postRenovationRoomsCount: estate.postRenovationAttributes?.rooms,
				constructionYear: estate?.attributes?.constructionYear,
				postRenovationLivingSpace: estate.postRenovationAttributes?.livingSpace,
				includesStoreRoom: (estate.postRenovationAttributes?.storeRooms?.length ?? 0) > 0,
				floorDetails,
				kitchenFloorDetails: floorDetails
			};
		}
		getUserDefinedParams(params) {
			const userDefinedParams = {
				balconyCount: params.balconyCount ?? 0,
				terraceCount: params.terraceCount ?? 0,
				loggiaCount: params.loggiaCount ?? 0,
				facadeDetails: params.facadeDetails ?? "",
				includesFloorCoveringRenovation: params.includesFloorCoveringRenovation ?? false,
				includesLoweredCeiling: params.includesLoweredCeiling ?? false,
				washingMachineSpaceLocation: params.washingMachineSpaceLocation ?? "",
				doorDetails: params.doorDetails ?? "",
				includesBathtub: params.includesBathtub ?? false,
				includesBathtubDoor: params.includesBathtubDoor ?? false,
				includesShower: params.includesShower ?? false,
				showerDetails: params.showerDetails ?? "",
				includesBigMirrorInBathRoom: params.includesBigMirrorInBathRoom ?? false,
				kitchenDoorDetails: params.kitchenDoorDetails ?? "",
				mediaConnectionDetails: params.mediaConnectionDetails ?? "",
				mediaConnectionLocation: params.mediaConnectionLocation ?? ""
			};
			return {
				...userDefinedParams,
				outdoorSpaceDetails: generateOutdoorSpaceDetails(pick(userDefinedParams, [
					"balconyCount",
					"terraceCount",
					"loggiaCount"
				]))
			};
		}
		getQuestions() {
			return [
				FormQuestionFactory.Header({
					name: "stockDescription",
					title: "1. Bestandsbeschreibung",
					headerLevel: 2
				}),
				FormQuestionFactory.Number({
					name: "balconyCount",
					title: "Balkonanzahl",
					min: 0,
					max: 3,
					defaultValue: 0,
					required: true
				}),
				FormQuestionFactory.Number({
					name: "terraceCount",
					title: "Terrassenanzahl",
					min: 0,
					max: 3,
					defaultValue: 0,
					required: true
				}),
				FormQuestionFactory.Number({
					name: "loggiaCount",
					title: "Loggia-Anzahl",
					min: 0,
					max: 3,
					defaultValue: 0,
					required: true
				}),
				FormQuestionFactory.SelectBox({
					name: "facadeDetails",
					title: "Fassade",
					values: [
						"Ziegeln verklinkert",
						"WDVS verputzt",
						"Nichts"
					],
					required: true
				}),
				FormQuestionFactory.Header({
					name: "renovationScope",
					title: "2. Sanierungsumfang allgemein",
					headerLevel: 2
				}),
				FormQuestionFactory.Toggle({
					name: "includesFloorCoveringRenovation",
					title: "Bodenbeläge erneuert ändern",
					required: true
				}),
				FormQuestionFactory.Header({
					name: "equipmentAndFinishes",
					title: "3. Ausstattung und Oberflächen",
					headerLevel: 2
				}),
				FormQuestionFactory.Header({
					name: "generalRoomsDescription",
					title: "3.1 Wohn und Schlafzimmer, Flur- und Abstellflächen",
					headerLevel: 3
				}),
				FormQuestionFactory.Toggle({
					name: "includesStoreRoom",
					title: "includesStoreRoom",
					hidden: true
				}),
				FormQuestionFactory.Toggle({
					name: "includesLoweredCeiling",
					title: "Abstellraum abgehängt",
					required: true,
					guards: [{
						name: "includesStoreRoom",
						value: true
					}]
				}),
				FormQuestionFactory.SelectBox({
					name: "washingMachineSpaceLocation",
					title: "Aufstellfläche für Waschmaschine",
					values: [
						"Keine",
						"Abstellraum",
						"Bad",
						"Küche"
					],
					required: true
				}),
				FormQuestionFactory.Header({
					name: "bathRoomDetails",
					title: "3.2 Bad",
					headerLevel: 3
				}),
				FormQuestionFactory.SelectBox({
					name: "doorDetails",
					title: "Türdetails",
					values: ["Röhrenspan-Tür CPL-beschichtet mit Edelstahldrücker Hoppe Amsterdam", "Aufarbeitung der historischen Türen"],
					required: true
				}),
				FormQuestionFactory.Toggle({
					name: "includesBathtub",
					title: "Badewanne",
					required: true
				}),
				FormQuestionFactory.Toggle({
					name: "includesBathtubDoor",
					title: "Glas-Pendeltür als Spritzwasserschutz auf der Badewanne",
					guards: [{
						name: "includesBathtub",
						value: true
					}],
					required: true
				}),
				FormQuestionFactory.Toggle({
					name: "includesShower",
					title: "Dusche",
					required: true
				}),
				FormQuestionFactory.SelectBox({
					name: "showerDetails",
					title: "Duschdetails",
					values: [
						"als Walk-In Dusche mit freistehender Glastrennwand",
						"inkl. Duschkabine mit Eckeinstieg",
						"inkl. Duschkabine mit Festfeld und Pendeltür",
						"inkl. Duschkabine und Pendeltür"
					],
					guards: [{
						name: "includesShower",
						value: true
					}],
					required: true
				}),
				FormQuestionFactory.Toggle({
					name: "includesBigMirrorInBathRoom",
					title: "Aufmaßspiegel ist deckenhoch?",
					required: true
				}),
				FormQuestionFactory.Header({
					name: "kitchenDetails",
					title: "3.3 Küche",
					headerLevel: 3
				}),
				FormQuestionFactory.SelectBox({
					name: "kitchenDoorDetails",
					title: "Details zur Küchentür",
					values: [
						"Durchgang",
						"Röhrenspan-Tür CPL-beschichtet mit Edelstahldrücker Hoppe Amsterdam",
						"Aufarbeitung der historischen Tür"
					],
					required: true
				}),
				FormQuestionFactory.Header({
					name: "electricalSystemDetails",
					title: "3.4 Elektrische Anlage",
					headerLevel: 3
				}),
				FormQuestionFactory.SelectBox({
					name: "mediaConnectionDetails",
					title: "Details zur Medienverbindung",
					values: ["Multimediaverteiler", "Media- Anschlussleiste"],
					required: true
				}),
				FormQuestionFactory.SelectBox({
					name: "mediaConnectionLocation",
					title: "Standort der Medienverbindung",
					values: ["Flur", "Abstellraum"],
					required: true
				})
			];
		}
	};
}));
//#endregion
//#region src/domains/renovation/document-strategy/strategies/construction-description-renovation/simple-interior-quality.strategy.ts
var SimpleInteriorQualityStrategy;
var init_simple_interior_quality_strategy = __esmMin((() => {
	init_form_question();
	init_document_strategy_helpers();
	init_construction_description_renovation_strategy();
	SimpleInteriorQualityStrategy = class extends ConstructionDescriptionRenovationStrategy {
		documentStrategy = "ConstructionDescriptionRenovationForSimpleInteriorQuality";
		getPreDefinedParams(params) {
			const estate = params.estate;
			const floorDetails = params.includesFloorCoveringRenovation ? "Vinyl-Designbelag" : "Aufarbeitung des historischen Dielenbodens";
			const generalContractorName = estate.constructionPlans?.find((p) => p.active && p.state === "Approved" && p.planType === "General")?.contractor?.name ?? "";
			const kitchenContractorName = estate.constructionPlans?.find((p) => p.active && p.state === "Approved" && p.planType === "Kitchen")?.contractor?.name ?? "";
			return {
				estate,
				estateId: estate.estateId,
				estateUuid: estate.condoUuid,
				street: estate?.location?.street,
				houseNumber: estate?.location?.houseNumber,
				zipCode: estate?.location?.zipcode,
				city: estate?.location?.city,
				floor: isNumber(estate?.attributes?.floor) ? formatFloor({
					floor: estate?.attributes?.floor,
					shouldAbbreviateFloorDesignation: false
				}) : "",
				floorLocation: estate?.attributes?.floorLocation ?? "",
				purchasingEntityName: estate.purchasing?.purchasingEntity?.name ?? "",
				generalContractorName,
				kitchenContractorName,
				postRenovationRoomsCount: estate.postRenovationAttributes?.rooms,
				constructionYear: estate?.attributes?.constructionYear,
				postRenovationLivingSpace: estate.postRenovationAttributes?.livingSpace,
				floorDetails,
				kitchenFloorDetails: floorDetails
			};
		}
		getUserDefinedParams(params) {
			const userDefinedParams = {
				balconyCount: params.balconyCount ?? 0,
				terraceCount: params.terraceCount ?? 0,
				loggiaCount: params.loggiaCount ?? 0,
				facadeDetails: params.facadeDetails ?? "",
				includesFloorCoveringRenovation: params.includesFloorCoveringRenovation ?? false,
				floorPlanChangeDetails: params.floorPlanChangeDetails ?? "",
				generalRoomsDoorDetails: params.generalRoomsDoorDetails ?? "",
				washingMachineSpaceLocation: params.washingMachineSpaceLocation ?? "",
				bathRoomDoorDetails: params.bathRoomDoorDetails ?? "",
				includesBathtub: params.includesBathtub ?? false,
				includesShower: params.includesShower ?? false,
				showerDetails: params.showerDetails ?? "",
				includesBigMirrorInBathRoom: params.includesBigMirrorInBathRoom ?? false,
				freezerDetails: params.freezerDetails ?? "",
				includesDishWasher: params.includesDishWasher ?? false,
				includesCookerHood: params.includesCookerHood ?? false,
				kitchenDoorDetails: params.kitchenDoorDetails ?? ""
			};
			return {
				...userDefinedParams,
				outdoorSpaceDetails: generateOutdoorSpaceDetails(pick(userDefinedParams, [
					"balconyCount",
					"terraceCount",
					"loggiaCount"
				]))
			};
		}
		getQuestions() {
			return [
				FormQuestionFactory.Header({
					name: "stockDescription",
					title: "1. Bestandsbeschreibung",
					headerLevel: 2
				}),
				FormQuestionFactory.Number({
					name: "balconyCount",
					title: "Balkonanzahl",
					min: 0,
					max: 3,
					defaultValue: 0,
					required: true
				}),
				FormQuestionFactory.Number({
					name: "terraceCount",
					title: "Terrassenanzahl",
					min: 0,
					max: 3,
					defaultValue: 0,
					required: true
				}),
				FormQuestionFactory.Number({
					name: "loggiaCount",
					title: "Loggia-Anzahl",
					min: 0,
					max: 3,
					defaultValue: 0,
					required: true
				}),
				FormQuestionFactory.SelectBox({
					name: "facadeDetails",
					title: "Fassade",
					values: [
						"Ziegeln verklinkert",
						"WDVS verputzt",
						"Nichts"
					],
					required: true
				}),
				FormQuestionFactory.Header({
					name: "renovationScope",
					title: "2. Sanierungsumfang allgemein",
					headerLevel: 2
				}),
				FormQuestionFactory.Toggle({
					name: "includesFloorCoveringRenovation",
					title: "Bodenbeläge erneuert ändern",
					required: true
				}),
				FormQuestionFactory.TextInputNote({
					name: "floorPlanChangeDetails",
					title: "Was wurde am Grundriss verändert?",
					required: true
				}),
				FormQuestionFactory.Header({
					name: "equipmentAndFinishes",
					title: "3. Ausstattung und Oberflächen",
					headerLevel: 2
				}),
				FormQuestionFactory.Header({
					name: "generalRoomsDescription",
					title: "3.1 Wohn und Schlafzimmer, Flur- und Abstellflächen",
					headerLevel: 3
				}),
				FormQuestionFactory.SelectBox({
					name: "generalRoomsDoorDetails",
					title: "Türdetails",
					values: ["Wabenkern-Tür CPL-beschichtet mit Edelstahl Drücker Hoppe Amsterdam", "Aufarbeitung der historischen Türen"],
					required: true
				}),
				FormQuestionFactory.SelectBox({
					name: "washingMachineSpaceLocation",
					title: "Aufstellfläche für Waschmaschine",
					values: [
						"Keine",
						"Abstellraum",
						"Bad",
						"Küche"
					],
					required: true
				}),
				FormQuestionFactory.Header({
					name: "bathRoomDetails",
					title: "3.2 Bad",
					headerLevel: 3
				}),
				FormQuestionFactory.SelectBox({
					name: "bathRoomDoorDetails",
					title: "Türdetails",
					values: ["Wabenkern-Tür CPL-beschichtet mit Edelstahl Drücker Hoppe Amsterdam", "Aufarbeitung der historischen Türen"],
					required: true
				}),
				FormQuestionFactory.Toggle({
					name: "includesBathtub",
					title: "Badewanne",
					required: true
				}),
				FormQuestionFactory.Toggle({
					name: "includesShower",
					title: "Dusche",
					required: true
				}),
				FormQuestionFactory.SelectBox({
					name: "showerDetails",
					title: "Duschdetails",
					values: [
						"als Walk-In Dusche mit freistehender Glastrennwand",
						"inkl. Duschkabine mit Eckeinstieg",
						"inkl. Duschkabine mit Festfeld und Pendeltür",
						"inkl. Duschkabine und Pendeltür"
					],
					guards: [{
						name: "includesShower",
						value: true
					}],
					required: true
				}),
				FormQuestionFactory.Toggle({
					name: "includesBigMirrorInBathRoom",
					title: "Aufmaß-Spiegel",
					required: true
				}),
				FormQuestionFactory.Header({
					name: "kitchenDetails",
					title: "3.3 Küche",
					headerLevel: 3
				}),
				FormQuestionFactory.SelectBox({
					name: "freezerDetails",
					title: "Einzelheiten zum Gefrierschrank",
					values: [
						"Kühl- Gefrierkombination von Blaupunkt o. glw",
						"Unterbaukühlschrank mit Gefrierfach von h-tech o. glw",
						"Einbaukühlschrank mit Gefrierfach von h-tech o. glw."
					],
					required: true
				}),
				FormQuestionFactory.Toggle({
					name: "includesDishWasher",
					title: "Geschirrspülmaschine",
					required: true
				}),
				FormQuestionFactory.Toggle({
					name: "includesCookerHood",
					title: "Dunstabzugshaube",
					required: true
				}),
				FormQuestionFactory.SelectBox({
					name: "kitchenDoorDetails",
					title: "Details zur Küchentür",
					values: [
						"Durchgang",
						"Wabenkern-Tür CPL-beschichtet mit Edelstahl Drücker Hoppe Amsterdam",
						"Aufarbeitung der historischen Tür"
					],
					required: true
				})
			];
		}
	};
}));
//#endregion
//#region src/domains/renovation/document-strategy/strategies/construction-description-renovation/normal-interior-quality.strategy.ts
var NormalInteriorQualityStrategy;
var init_normal_interior_quality_strategy = __esmMin((() => {
	init_form_question();
	init_document_strategy_helpers();
	init_construction_description_renovation_strategy();
	NormalInteriorQualityStrategy = class extends ConstructionDescriptionRenovationStrategy {
		documentStrategy = "ConstructionDescriptionRenovationForNormalInteriorQuality";
		getPreDefinedParams(params) {
			const estate = params.estate;
			const floorDetails = params.includesFloorCoveringRenovation ? "Vinyl-Designbelag" : "Aufarbeitung des historischen Dielenbodens";
			const generalContractorName = estate.constructionPlans?.find((p) => p.active && p.state === "Approved" && p.planType === "General")?.contractor?.name ?? "";
			const kitchenContractorName = estate.constructionPlans?.find((p) => p.active && p.state === "Approved" && p.planType === "Kitchen")?.contractor?.name ?? "";
			return {
				estate,
				estateId: estate.estateId,
				estateUuid: estate.condoUuid,
				street: estate?.location?.street,
				houseNumber: estate?.location?.houseNumber,
				zipCode: estate?.location?.zipcode,
				city: estate?.location?.city,
				floor: isNumber(estate?.attributes?.floor) ? formatFloor({
					floor: estate?.attributes?.floor,
					shouldAbbreviateFloorDesignation: false
				}) : "",
				floorLocation: estate?.attributes?.floorLocation ?? "",
				purchasingEntityName: estate.purchasing?.purchasingEntity?.name ?? "",
				generalContractorName,
				kitchenContractorName,
				postRenovationRoomsCount: estate.postRenovationAttributes?.rooms,
				constructionYear: estate?.attributes?.constructionYear,
				postRenovationLivingSpace: estate.postRenovationAttributes?.livingSpace,
				includesStoreRoom: (estate.postRenovationAttributes?.storeRooms?.length ?? 0) > 0,
				floorDetails,
				kitchenFloorDetails: floorDetails
			};
		}
		getUserDefinedParams(params) {
			const userDefinedParams = {
				balconyCount: params.balconyCount ?? 0,
				terraceCount: params.terraceCount ?? 0,
				loggiaCount: params.loggiaCount ?? 0,
				facadeDetails: params.facadeDetails ?? "",
				includesFloorCoveringRenovation: params.includesFloorCoveringRenovation ?? false,
				floorPlanChangeDetails: params.floorPlanChangeDetails ?? "",
				includesLoweredCeiling: params.includesLoweredCeiling ?? false,
				generalRoomsDoorDetails: params.generalRoomsDoorDetails ?? "",
				washingMachineSpaceLocation: params.washingMachineSpaceLocation ?? "",
				bathRoomDoorDetails: params.bathRoomDoorDetails ?? "",
				includesBathtub: params.includesBathtub ?? false,
				includesBathtubDoor: params.includesBathtubDoor ?? false,
				includesShower: params.includesShower ?? false,
				showerDetails: params.showerDetails ?? "",
				includesBigMirrorInBathRoom: params.includesBigMirrorInBathRoom ?? false,
				freezerDetails: params.freezerDetails ?? "",
				includesDishWasher: params.includesDishWasher ?? false,
				includesOven: params.includesOven ?? false,
				includesCookerHood: params.includesCookerHood ?? false,
				kitchenDoorDetails: params.kitchenDoorDetails ?? "",
				mediaConnectionDetails: params.mediaConnectionDetails ?? "",
				mediaConnectionLocation: params.mediaConnectionLocation ?? "",
				isEco: params.isEco ?? false,
				ecoControlPanelPosition: params.ecoControlPanelPosition ?? "",
				hasBathroomWindows: params.hasBathroomWindows ?? false,
				hasKitchenWindows: params.hasKitchenWindows ?? false,
				hasKitchenRadiator: params.hasKitchenRadiator ?? false
			};
			return {
				...userDefinedParams,
				outdoorSpaceDetails: generateOutdoorSpaceDetails(pick(userDefinedParams, [
					"balconyCount",
					"terraceCount",
					"loggiaCount"
				]))
			};
		}
		getQuestions() {
			return [
				FormQuestionFactory.Header({
					name: "stockDescription",
					title: "1. Bestandsbeschreibung",
					headerLevel: 2
				}),
				FormQuestionFactory.Toggle({
					title: "Is Eco?",
					name: "isEco",
					required: true
				}),
				FormQuestionFactory.SelectBox({
					name: "ecoControlPanelPosition",
					title: "Position der Steuerzentrale",
					values: ["Flur", "Abstellraum"],
					guards: [{
						name: "isEco",
						value: true
					}],
					required: true
				}),
				FormQuestionFactory.Toggle({
					title: "Hat das Bad ein Fenster?",
					name: "hasBathroomWindows",
					guards: [{
						name: "isEco",
						value: true
					}],
					required: true
				}),
				FormQuestionFactory.Toggle({
					title: "Hat die Küche ein Fenster?",
					name: "hasKitchenWindows",
					guards: [{
						name: "isEco",
						value: true
					}],
					required: true
				}),
				FormQuestionFactory.Number({
					name: "balconyCount",
					title: "Balkonanzahl",
					min: 0,
					max: 3,
					defaultValue: 0,
					required: true
				}),
				FormQuestionFactory.Number({
					name: "terraceCount",
					title: "Terrassenanzahl",
					min: 0,
					max: 3,
					defaultValue: 0,
					required: true
				}),
				FormQuestionFactory.Number({
					name: "loggiaCount",
					title: "Loggia-Anzahl",
					min: 0,
					max: 3,
					defaultValue: 0,
					required: true
				}),
				FormQuestionFactory.SelectBox({
					name: "facadeDetails",
					title: "Fassade",
					values: [
						"Ziegeln verklinkert",
						"WDVS verputzt",
						"Nichts"
					],
					required: true,
					allowAdditionalValues: true
				}),
				FormQuestionFactory.Header({
					name: "renovationScope",
					title: "2. Sanierungsumfang allgemein",
					headerLevel: 2
				}),
				FormQuestionFactory.Toggle({
					name: "includesFloorCoveringRenovation",
					title: "Bodenbeläge erneuert",
					required: true
				}),
				FormQuestionFactory.TextInputNote({
					name: "floorPlanChangeDetails",
					title: "Was wurde am Grundriss verändert?",
					required: false
				}),
				FormQuestionFactory.Header({
					name: "equipmentAndFinishes",
					title: "3. Ausstattung und Oberflächen",
					headerLevel: 2
				}),
				FormQuestionFactory.Header({
					name: "generalRoomsDescription",
					title: "3.1 Wohn und Schlafzimmer, Flur- und Abstellflächen",
					headerLevel: 3
				}),
				FormQuestionFactory.Toggle({
					name: "includesLoweredCeiling",
					title: "Abstellraum abgehängt",
					required: true
				}),
				FormQuestionFactory.SelectBox({
					name: "generalRoomsDoorDetails",
					title: "Türdetails",
					values: ["Röhrenspan-Tür CPL-beschichtet mit Edelstahldrücker Hoppe Amsterdam", "Aufarbeitung der historischen Türen"],
					required: true
				}),
				FormQuestionFactory.SelectBox({
					name: "washingMachineSpaceLocation",
					title: "Aufstellfläche für Waschmaschine",
					values: [
						"Keine",
						"Abstellraum",
						"Bad",
						"Küche"
					],
					required: true
				}),
				FormQuestionFactory.Header({
					name: "bathRoomDetails",
					title: "3.2 Bad",
					headerLevel: 3
				}),
				FormQuestionFactory.SelectBox({
					name: "bathRoomDoorDetails",
					title: "Türdetails",
					values: ["Röhrenspan-Tür CPL-beschichtet mit Edelstahldrücker Hoppe Amsterdam", "Aufarbeitung der historischen Türen"],
					required: true
				}),
				FormQuestionFactory.Toggle({
					name: "includesBathtub",
					title: "Badewanne",
					required: true
				}),
				FormQuestionFactory.Toggle({
					name: "includesBathtubDoor",
					title: "Glas-Pendeltür als Spritzwasserschutz auf der Badewanne",
					guards: [{
						name: "includesBathtub",
						value: true
					}],
					required: true
				}),
				FormQuestionFactory.Toggle({
					name: "includesShower",
					title: "Dusche",
					required: true
				}),
				FormQuestionFactory.SelectBox({
					name: "showerDetails",
					title: "Duschdetails",
					values: [
						"als Walk-In Dusche mit freistehender Glastrennwand",
						"inkl. Duschkabine mit Eckeinstieg",
						"inkl. Duschkabine mit Festfeld und Pendeltür",
						"inkl. Duschkabine und Pendeltür"
					],
					guards: [{
						name: "includesShower",
						value: true
					}],
					required: true
				}),
				FormQuestionFactory.Toggle({
					name: "includesBigMirrorInBathRoom",
					title: "Aufmaßspiegel ist deckenhoch?",
					required: true
				}),
				FormQuestionFactory.Header({
					name: "kitchenDetails",
					title: "3.3 Küche",
					headerLevel: 3
				}),
				FormQuestionFactory.SelectBox({
					name: "freezerDetails",
					title: "Einzelheiten zum Gefrierschrank",
					values: [
						"Kühl- Gefrierkombination",
						"Unterbaukühlschrank mit Gefrierfach",
						"Einbaukühlschrank mit Gefrierfach"
					],
					required: true
				}),
				FormQuestionFactory.Toggle({
					name: "includesDishWasher",
					title: "Geschirrspülmaschine",
					required: true
				}),
				FormQuestionFactory.Toggle({
					name: "includesOven",
					title: "Einbaubackofen",
					required: true
				}),
				FormQuestionFactory.Toggle({
					name: "includesCookerHood",
					title: "Dunstabzugshaube",
					required: true
				}),
				FormQuestionFactory.Toggle({
					name: "hasKitchenRadiator",
					title: "Hat die Küche eine Heizung",
					required: true
				}),
				FormQuestionFactory.SelectBox({
					name: "kitchenDoorDetails",
					title: "Details zur Küchentür",
					values: [
						"Durchgang",
						"Röhrenspan-Tür CPL-beschichtet mit Edelstahldrücker Hoppe Amsterdam",
						"Aufarbeitung der historischen Tür"
					],
					required: true
				}),
				FormQuestionFactory.Header({
					name: "electricalSystemDetails",
					title: "3.4 Elektrische Anlage",
					headerLevel: 3
				}),
				FormQuestionFactory.SelectBox({
					name: "mediaConnectionDetails",
					title: "Details zur Medienverbindung",
					values: ["Multimediaverteiler", "Media- Anschlussleiste"],
					required: true
				}),
				FormQuestionFactory.SelectBox({
					name: "mediaConnectionLocation",
					title: "Standort der Medienverbindung",
					values: ["Flur", "Abstellraum"],
					required: true
				})
			];
		}
	};
}));
//#endregion
//#region src/domains/renovation/document-strategy/strategies/construction-description-renovation/sophisticated-interior-quality.strategy.ts
var SophisticatedInteriorQualityStrategy;
var init_sophisticated_interior_quality_strategy = __esmMin((() => {
	init_form_question();
	init_document_strategy_helpers();
	init_construction_description_renovation_strategy();
	SophisticatedInteriorQualityStrategy = class extends ConstructionDescriptionRenovationStrategy {
		documentStrategy = "ConstructionDescriptionRenovationForSophisticatedInteriorQuality";
		getPreDefinedParams(params) {
			const estate = params.estate;
			const floorDetails = params.includesFloorCoveringRenovation ? "Vinyl-Designbelag" : "Aufarbeitung des historischen Dielenbodens";
			const generalContractorName = estate.constructionPlans?.find((p) => p.active && p.state === "Approved" && p.planType === "General")?.contractor?.name ?? "";
			const kitchenContractorName = estate.constructionPlans?.find((p) => p.active && p.state === "Approved" && p.planType === "Kitchen")?.contractor?.name ?? "";
			return {
				estate,
				estateId: estate.estateId,
				estateUuid: estate.condoUuid,
				street: estate?.location?.street,
				houseNumber: estate?.location?.houseNumber,
				zipCode: estate?.location?.zipcode,
				city: estate?.location?.city,
				floor: isNumber(estate?.attributes?.floor) ? formatFloor({
					floor: estate?.attributes?.floor,
					shouldAbbreviateFloorDesignation: false
				}) : "",
				floorLocation: estate?.attributes?.floorLocation ?? "",
				purchasingEntityName: estate.purchasing?.purchasingEntity?.name ?? "",
				generalContractorName,
				kitchenContractorName,
				postRenovationRoomsCount: estate.postRenovationAttributes?.rooms,
				constructionYear: estate?.attributes?.constructionYear,
				postRenovationLivingSpace: estate.postRenovationAttributes?.livingSpace,
				includesStoreRoom: (estate.postRenovationAttributes?.storeRooms?.length ?? 0) > 0,
				floorDetails,
				kitchenFloorDetails: floorDetails
			};
		}
		getUserDefinedParams(params) {
			const userDefinedParams = {
				balconyCount: params.balconyCount ?? 0,
				terraceCount: params.terraceCount ?? 0,
				loggiaCount: params.loggiaCount ?? 0,
				facadeDetails: params.facadeDetails ?? "",
				includesFloorCoveringRenovation: params.includesFloorCoveringRenovation ?? false,
				floorPlanChangeDetails: params.floorPlanChangeDetails ?? "",
				generalRoomsDoorDetails: params.generalRoomsDoorDetails ?? "",
				washingMachineSpaceLocation: params.washingMachineSpaceLocation ?? "",
				includesCeilingMoldings: params.includesCeilingMoldings ?? false,
				bathRoomDoorDetails: params.bathRoomDoorDetails ?? "",
				includesBathtub: params.includesBathtub ?? false,
				includesBathtubDoor: params.includesBathtubDoor ?? false,
				includesShower: params.includesShower ?? false,
				showerDetails: params.showerDetails ?? "",
				includesBigMirrorInBathRoom: params.includesBigMirrorInBathRoom ?? false,
				ovenAndHobDetails: params.ovenAndHobDetails ?? "",
				includesKitchenCeilingWithLED: params.includesKitchenCeilingWithLED ?? false,
				kitchenDoorDetails: params.kitchenDoorDetails ?? "",
				mediaConnectionLocation: params.mediaConnectionLocation ?? ""
			};
			return {
				...userDefinedParams,
				outdoorSpaceDetails: generateOutdoorSpaceDetails(pick(userDefinedParams, [
					"balconyCount",
					"terraceCount",
					"loggiaCount"
				]))
			};
		}
		getQuestions() {
			return [
				FormQuestionFactory.Header({
					name: "stockDescription",
					title: "1. Bestandsbeschreibung",
					headerLevel: 2
				}),
				FormQuestionFactory.Number({
					name: "balconyCount",
					title: "Balkonanzahl",
					min: 0,
					max: 3,
					defaultValue: 0,
					required: true
				}),
				FormQuestionFactory.Number({
					name: "terraceCount",
					title: "Terrassenanzahl",
					min: 0,
					max: 3,
					defaultValue: 0,
					required: true
				}),
				FormQuestionFactory.Number({
					name: "loggiaCount",
					title: "Loggia-Anzahl",
					min: 0,
					max: 3,
					defaultValue: 0,
					required: true
				}),
				FormQuestionFactory.SelectBox({
					name: "facadeDetails",
					title: "Fassade",
					values: [
						"Ziegeln verklinkert",
						"WDVS verputzt",
						"Nichts"
					],
					required: true
				}),
				FormQuestionFactory.Header({
					name: "renovationScope",
					title: "2. Sanierungsumfang allgemein",
					headerLevel: 2
				}),
				FormQuestionFactory.Toggle({
					name: "includesFloorCoveringRenovation",
					title: "Bodenbeläge erneuert ändern",
					required: true
				}),
				FormQuestionFactory.TextInputNote({
					name: "floorPlanChangeDetails",
					title: "Was wurde am Grundriss verändert?",
					required: true
				}),
				FormQuestionFactory.Header({
					name: "equipmentAndFinishes",
					title: "3. Ausstattung und Oberflächen",
					headerLevel: 2
				}),
				FormQuestionFactory.Header({
					name: "generalRoomsDescription",
					title: "3.1 Wohn und Schlafzimmer, Flur- und Abstellflächen",
					headerLevel: 3
				}),
				FormQuestionFactory.SelectBox({
					name: "generalRoomsDoorDetails",
					title: "Türdetails",
					values: ["Wabenkern-Tür CPL-beschichtet mit Edelstahl Drücker Hoppe Amsterdam", "Aufarbeitung der historischen Türen"],
					required: true
				}),
				FormQuestionFactory.SelectBox({
					name: "washingMachineSpaceLocation",
					title: "Aufstellfläche für Waschmaschine",
					values: [
						"Keine",
						"Abstellraum",
						"Bad",
						"Küche"
					],
					required: true
				}),
				FormQuestionFactory.Toggle({
					name: "includesCeilingMoldings",
					title: "Stuck- Deckenprofilleisten in den Zimmern",
					required: true
				}),
				FormQuestionFactory.Header({
					name: "bathRoomDetails",
					title: "3.2 Bad",
					headerLevel: 3
				}),
				FormQuestionFactory.SelectBox({
					name: "bathRoomDoorDetails",
					title: "Türdetails",
					values: ["Vollspan-Profiltür CK4 mit Edelstahldrücker Hoppe Amsterdam", "Aufarbeitung der historischen Türen"],
					required: true
				}),
				FormQuestionFactory.Toggle({
					name: "includesBathtub",
					title: "Badewanne",
					required: true
				}),
				FormQuestionFactory.Toggle({
					name: "includesBathtubDoor",
					title: "Glas-Pendeltür als Spritzwasserschutz auf der Badewanne",
					guards: [{
						name: "includesBathtub",
						value: true
					}],
					required: true
				}),
				FormQuestionFactory.Toggle({
					name: "includesShower",
					title: "Dusche",
					required: true
				}),
				FormQuestionFactory.SelectBox({
					name: "showerDetails",
					title: "Duschdetails",
					values: [
						"als Walk-In Dusche mit freistehender Glastrennwand",
						"inkl. Duschkabine mit Eckeinstieg",
						"inkl. Duschkabine mit Festfeld und Pendeltür",
						"inkl. Duschkabine und Pendeltür"
					],
					guards: [{
						name: "includesShower",
						value: true
					}],
					required: true
				}),
				FormQuestionFactory.Toggle({
					name: "includesBigMirrorInBathRoom",
					title: "Aufmaßspiegel ist deckenhoch?",
					required: true
				}),
				FormQuestionFactory.Header({
					name: "kitchenDetails",
					title: "3.3 Küche",
					headerLevel: 3
				}),
				FormQuestionFactory.SelectBox({
					name: "ovenAndHobDetails",
					title: "Ofen- und Kochfelddetails",
					values: ["Backofen und Cerankochfeld mit 4 Kochstellen und Unterbau- Flachschirmhaube von Bosch o.glw.", "Backofen und Induktionskochfeld mit integriertem Dunstabzug von Bosch o.glw."],
					required: true
				}),
				FormQuestionFactory.Toggle({
					name: "includesKitchenCeilingWithLED",
					title: "Küchendecke abgehängt mit LED- Einbauspots",
					required: true
				}),
				FormQuestionFactory.SelectBox({
					name: "kitchenDoorDetails",
					title: "Details zur Küchentür",
					values: [
						"Durchgang",
						"Vollspan-Profiltür CK4 mit Edelstahldrücker FSB 1144",
						"Aufarbeitung der historischen Tür"
					],
					required: true
				}),
				FormQuestionFactory.Header({
					name: "electricalSystemDetails",
					title: "3.4 Elektrische Anlage",
					headerLevel: 3
				}),
				FormQuestionFactory.SelectBox({
					name: "mediaConnectionLocation",
					title: "Standort der Medienverbindung",
					values: ["Flur", "Abstellraum"],
					required: true
				})
			];
		}
	};
}));
//#endregion
//#region src/domains/renovation/document-strategy/strategies/construction-description-renovation/luxury-interior-quality.strategy.ts
var LuxuryInteriorQualityStrategy;
var init_luxury_interior_quality_strategy = __esmMin((() => {
	init_form_question();
	init_document_strategy_helpers();
	init_construction_description_renovation_strategy();
	LuxuryInteriorQualityStrategy = class extends ConstructionDescriptionRenovationStrategy {
		documentStrategy = "ConstructionDescriptionRenovationForLuxuryInteriorQuality";
		getPreDefinedParams(params) {
			const estate = params.estate;
			const floorDetails = params.includesFloorCoveringRenovation ? "Vinyl-Designbelag" : "Aufarbeitung des historischen Dielenbodens";
			const generalContractorName = estate.constructionPlans?.find((p) => p.active && p.state === "Approved" && p.planType === "General")?.contractor?.name ?? "";
			const kitchenContractorName = estate.constructionPlans?.find((p) => p.active && p.state === "Approved" && p.planType === "Kitchen")?.contractor?.name ?? "";
			return {
				estate,
				estateId: estate.estateId,
				estateUuid: estate.condoUuid,
				street: estate?.location?.street,
				houseNumber: estate?.location?.houseNumber,
				zipCode: estate?.location?.zipcode,
				city: estate?.location?.city,
				floor: isNumber(estate?.attributes?.floor) ? formatFloor({
					floor: estate?.attributes?.floor,
					shouldAbbreviateFloorDesignation: false
				}) : "",
				floorLocation: estate?.attributes?.floorLocation ?? "",
				purchasingEntityName: estate.purchasing?.purchasingEntity?.name ?? "",
				generalContractorName,
				kitchenContractorName,
				postRenovationRoomsCount: estate.postRenovationAttributes?.rooms,
				constructionYear: estate?.attributes?.constructionYear,
				postRenovationLivingSpace: estate.postRenovationAttributes?.livingSpace,
				includesStoreRoom: (estate.postRenovationAttributes?.storeRooms?.length ?? 0) > 0,
				floorDetails,
				kitchenFloorDetails: floorDetails
			};
		}
		getUserDefinedParams(params) {
			const userDefinedParams = {
				balconyCount: params.balconyCount ?? 0,
				terraceCount: params.terraceCount ?? 0,
				loggiaCount: params.loggiaCount ?? 0,
				facadeDetails: params.facadeDetails ?? "",
				includesFloorCoveringRenovation: params.includesFloorCoveringRenovation ?? false,
				floorPlanChangeDetails: params.floorPlanChangeDetails ?? "",
				generalRoomsDoorDetails: params.generalRoomsDoorDetails ?? "",
				washingMachineSpaceLocation: params.washingMachineSpaceLocation ?? "",
				includesCeilingMoldings: params.includesCeilingMoldings ?? false,
				bathRoomDoorDetails: params.bathRoomDoorDetails ?? "",
				includesBathtub: params.includesBathtub ?? false,
				includesBathtubDoor: params.includesBathtubDoor ?? false,
				includesShower: params.includesShower ?? false,
				showerDetails: params.showerDetails ?? "",
				includesBigMirrorInBathRoom: params.includesBigMirrorInBathRoom ?? false,
				ovenAndHobDetails: params.ovenAndHobDetails ?? "",
				includesKitchenCeilingWithLED: params.includesKitchenCeilingWithLED ?? false,
				kitchenDoorDetails: params.kitchenDoorDetails ?? "",
				mediaConnectionLocation: params.mediaConnectionLocation ?? ""
			};
			return {
				...userDefinedParams,
				outdoorSpaceDetails: generateOutdoorSpaceDetails(pick(userDefinedParams, [
					"balconyCount",
					"terraceCount",
					"loggiaCount"
				]))
			};
		}
		getQuestions() {
			return [
				FormQuestionFactory.Header({
					name: "stockDescription",
					title: "1. Bestandsbeschreibung",
					headerLevel: 2
				}),
				FormQuestionFactory.Number({
					name: "balconyCount",
					title: "Balkonanzahl",
					min: 0,
					max: 3,
					defaultValue: 0,
					required: true
				}),
				FormQuestionFactory.Number({
					name: "terraceCount",
					title: "Terrassenanzahl",
					min: 0,
					max: 3,
					defaultValue: 0,
					required: true
				}),
				FormQuestionFactory.Number({
					name: "loggiaCount",
					title: "Loggia-Anzahl",
					min: 0,
					max: 3,
					defaultValue: 0,
					required: true
				}),
				FormQuestionFactory.SelectBox({
					name: "facadeDetails",
					title: "Fassade",
					values: [
						"Ziegeln verklinkert",
						"WDVS verputzt",
						"Nichts"
					],
					required: true
				}),
				FormQuestionFactory.Header({
					name: "renovationScope",
					title: "2. Sanierungsumfang allgemein",
					headerLevel: 2
				}),
				FormQuestionFactory.Toggle({
					name: "includesFloorCoveringRenovation",
					title: "Bodenbeläge erneuert ändern",
					required: true
				}),
				FormQuestionFactory.TextInputNote({
					name: "floorPlanChangeDetails",
					title: "Was wurde am Grundriss verändert?",
					required: true
				}),
				FormQuestionFactory.Header({
					name: "equipmentAndFinishes",
					title: "3. Ausstattung und Oberflächen",
					headerLevel: 2
				}),
				FormQuestionFactory.Header({
					name: "generalRoomsDescription",
					title: "3.1 Wohn und Schlafzimmer, Flur- und Abstellflächen",
					headerLevel: 3
				}),
				FormQuestionFactory.SelectBox({
					name: "generalRoomsDoorDetails",
					title: "Türdetails",
					values: ["Wabenkern-Tür CPL-beschichtet mit Edelstahl Drücker Hoppe Amsterdam", "Aufarbeitung der historischen Türen"],
					required: true
				}),
				FormQuestionFactory.SelectBox({
					name: "washingMachineSpaceLocation",
					title: "Aufstellfläche für Waschmaschine",
					values: [
						"Keine",
						"Abstellraum",
						"Bad",
						"Küche"
					],
					required: true
				}),
				FormQuestionFactory.Toggle({
					name: "includesCeilingMoldings",
					title: "Stuck- Deckenprofilleisten in den Zimmern",
					required: true
				}),
				FormQuestionFactory.Header({
					name: "bathRoomDetails",
					title: "3.2 Bad",
					headerLevel: 3
				}),
				FormQuestionFactory.SelectBox({
					name: "bathRoomDoorDetails",
					title: "Türdetails",
					values: ["Vollspan-Profiltür CK4 mit Edelstahldrücker FSB 1144", "Aufarbeitung der historischen Türen"],
					required: true
				}),
				FormQuestionFactory.Toggle({
					name: "includesBathtub",
					title: "Badewanne",
					required: true
				}),
				FormQuestionFactory.Toggle({
					name: "includesBathtubDoor",
					title: "Glas-Pendeltür als Spritzwasserschutz auf der Badewanne",
					guards: [{
						name: "includesBathtub",
						value: true
					}],
					required: true
				}),
				FormQuestionFactory.Toggle({
					name: "includesShower",
					title: "Dusche",
					required: true
				}),
				FormQuestionFactory.SelectBox({
					name: "showerDetails",
					title: "Duschdetails",
					values: [
						"als Walk-In Dusche mit freistehender Glastrennwand",
						"inkl. Duschkabine mit Eckeinstieg",
						"inkl. Duschkabine mit Festfeld und Pendeltür",
						"inkl. Duschkabine und Pendeltür"
					],
					guards: [{
						name: "includesShower",
						value: true
					}],
					required: true
				}),
				FormQuestionFactory.Toggle({
					name: "includesBigMirrorInBathRoom",
					title: "Aufmaßspiegel ist deckenhoch?",
					required: true
				}),
				FormQuestionFactory.Header({
					name: "kitchenDetails",
					title: "3.3 Küche",
					headerLevel: 3
				}),
				FormQuestionFactory.SelectBox({
					name: "ovenAndHobDetails",
					title: "Ofen- und Kochfelddetails",
					values: ["Backofen und Cerankochfeld mit 4 Kochstellen und Unterbau- Flachschirmhaube von Bosch o.glw.", "Backofen und Induktionskochfeld mit integriertem Dunstabzug von Bosch o.glw."],
					required: true
				}),
				FormQuestionFactory.Toggle({
					name: "includesKitchenCeilingWithLED",
					title: "Küchendecke abgehängt mit LED- Einbauspots",
					required: true
				}),
				FormQuestionFactory.SelectBox({
					name: "kitchenDoorDetails",
					title: "Details zur Küchentür",
					values: [
						"Durchgang",
						"Vollspan-Profiltür CK4 mit Edelstahldrücker FSB 1144",
						"Aufarbeitung der historischen Tür"
					],
					required: true
				}),
				FormQuestionFactory.Header({
					name: "electricalSystemDetails",
					title: "3.4 Elektrische Anlage",
					headerLevel: 3
				}),
				FormQuestionFactory.SelectBox({
					name: "mediaConnectionLocation",
					title: "Standort der Medienverbindung",
					values: ["Flur", "Abstellraum"],
					required: true
				})
			];
		}
	};
}));
//#endregion
//#region src/domains/renovation/document-strategy/strategies/construction-description-renovation/index.ts
var init_construction_description_renovation = __esmMin((() => {
	init_environmental_protection_area_strategy();
	init_simple_interior_quality_strategy();
	init_normal_interior_quality_strategy();
	init_sophisticated_interior_quality_strategy();
	init_luxury_interior_quality_strategy();
}));
//#endregion
//#region src/domains/renovation/document-strategy/strategy-factories/construction-description-renovation-strategy.factory.ts
var ConstructionDescriptionRenovationStrategyFactory;
var init_construction_description_renovation_strategy_factory = __esmMin((() => {
	init_errors();
	init_construction_description_renovation();
	ConstructionDescriptionRenovationStrategyFactory = class {
		create({ estate }) {
			const { attributes, constructionPlans } = estate;
			if (!attributes || !constructionPlans) throw new InvalidParamsError("Estate attributes and construction-plans should be provided");
			if (attributes.isEnvironmentalProtectionArea) return new EnvironmentalProtectionAreaStrategy();
			const approvedGeneralConstructionPlan = constructionPlans.find((plan) => plan.active && plan.state === "Approved" && plan.planType === "General");
			if (!approvedGeneralConstructionPlan) throw new InvariantError("Estate has no approved general construction plan");
			switch (approvedGeneralConstructionPlan.interiorQuality) {
				case "Simple": return new SimpleInteriorQualityStrategy();
				case "Normal": return new NormalInteriorQualityStrategy();
				case "Sophisticated": return new SophisticatedInteriorQualityStrategy();
				case "Luxury": return new LuxuryInteriorQualityStrategy();
				default: throw new UnsupportedError(`${approvedGeneralConstructionPlan.interiorQuality} interior-quality is not supported`);
			}
		}
	};
}));
//#endregion
//#region src/domains/renovation/document-strategy/strategies/construction-plan/construction-plan.strategy.ts
var ConstructionPlanStrategy;
var init_construction_plan_strategy = __esmMin((() => {
	init_document();
	ConstructionPlanStrategy = class {
		documentType = "LV";
	};
}));
//#endregion
//#region src/domains/renovation/document-strategy/strategies/construction-plan/lv.strategy.ts
var LVStrategy;
var init_lv_strategy = __esmMin((() => {
	init_construction_plan_strategy();
	LVStrategy = class extends ConstructionPlanStrategy {
		documentStrategy = "LV";
	};
}));
//#endregion
//#region src/domains/renovation/document-strategy/strategies/construction-plan/asset-lv.strategy.ts
var AssetLVStrategy;
var init_asset_lv_strategy = __esmMin((() => {
	init_construction_plan_strategy();
	AssetLVStrategy = class extends ConstructionPlanStrategy {
		documentStrategy = "AssetLV";
	};
}));
//#endregion
//#region src/domains/renovation/document-strategy/strategies/construction-plan/index.ts
var init_construction_plan$1 = __esmMin((() => {
	init_lv_strategy();
	init_asset_lv_strategy();
}));
//#endregion
//#region src/domains/renovation/document-strategy/strategy-factories/construction-plan-strategy.factory.ts
var ConstructionPlanStrategyFactory;
var init_construction_plan_strategy_factory = __esmMin((() => {
	init_construction_plan$1();
	ConstructionPlanStrategyFactory = class {
		create({ estate }) {
			return estate.mfhBuildingId ? new AssetLVStrategy() : new LVStrategy();
		}
	};
}));
//#endregion
//#region src/domains/renovation/document-strategy/strategies/long-construction-plan/long-construction-plan.strategy.ts
var LongConstructionPlanStrategy;
var init_long_construction_plan_strategy = __esmMin((() => {
	init_document();
	LongConstructionPlanStrategy = class {
		documentType = "LongLV";
	};
}));
//#endregion
//#region src/domains/renovation/document-strategy/strategies/long-construction-plan/long-lv.strategy.ts
var LongLvStrategy;
var init_long_lv_strategy = __esmMin((() => {
	init_long_construction_plan_strategy();
	LongLvStrategy = class extends LongConstructionPlanStrategy {
		documentStrategy = "LongLV";
	};
}));
//#endregion
//#region src/domains/renovation/document-strategy/strategies/long-construction-plan/long-asset-lv.strategy.ts
var LongAssetLvStrategy;
var init_long_asset_lv_strategy = __esmMin((() => {
	init_long_construction_plan_strategy();
	LongAssetLvStrategy = class extends LongConstructionPlanStrategy {
		documentStrategy = "LongAssetLV";
	};
}));
//#endregion
//#region src/domains/renovation/document-strategy/strategies/long-construction-plan/index.ts
var init_long_construction_plan = __esmMin((() => {
	init_long_lv_strategy();
	init_long_asset_lv_strategy();
}));
//#endregion
//#region src/domains/renovation/document-strategy/strategy-factories/long-construction-plan-strategy.factory.ts
var LongConstructionPlanStrategyFactory;
var init_long_construction_plan_strategy_factory = __esmMin((() => {
	init_long_construction_plan();
	LongConstructionPlanStrategyFactory = class {
		create({ estate }) {
			return estate.mfhBuildingId ? new LongAssetLvStrategy() : new LongLvStrategy();
		}
	};
}));
//#endregion
//#region src/domains/renovation/document-strategy/strategy-factories/index.ts
var init_strategy_factories = __esmMin((() => {
	init_construction_description_renovation_strategy_factory();
	init_construction_plan_strategy_factory();
	init_long_construction_plan_strategy_factory();
}));
//#endregion
//#region src/domains/renovation/document-strategy/document-strategy-super.factory.ts
var DocumentStrategySuperFactory;
var init_document_strategy_super_factory = __esmMin((() => {
	init_document();
	init_strategy_factories();
	DocumentStrategySuperFactory = class {
		static create(documentType, params) {
			switch (documentType) {
				case "ConstructionDescriptionRenovation": return new ConstructionDescriptionRenovationStrategyFactory().create(params);
				case "LV": return new ConstructionPlanStrategyFactory().create(params);
				case "LongLV": return new LongConstructionPlanStrategyFactory().create(params);
				default: return;
			}
		}
	};
}));
//#endregion
//#region src/domains/renovation/document-strategy/index.ts
var init_document_strategy = __esmMin((() => {
	init_document_strategy_super_factory();
	init_document_strategy_base();
}));
//#endregion
//#region src/domains/transaction/document-inspection/document-inspection.errors.ts
var InspectionNotCompletedError;
var init_document_inspection_errors = __esmMin((() => {
	init_errors();
	InspectionNotCompletedError = class extends BaseError {
		constructor() {
			super("inspection answers are not complete", "INVALID_STATE");
		}
	};
}));
//#endregion
//#region src/domains/transaction/document-inspection/document-inspection.model.ts
var DocumentInspectionState, DocumentInspection, EligibleInspectionDocumentTypes, MergedDocumentInspections, DocumentsWithAllowedAnswerGroupAddition, ExportableDocumentInspectionsTypeMap;
var init_document_inspection_model = __esmMin((() => {
	init_document();
	init_form_question_model();
	dayjs.extend(dayjsUtc);
	dayjs.extend(dayjsTimezone);
	DocumentInspectionState = /* @__PURE__ */ function(DocumentInspectionState) {
		DocumentInspectionState["Open"] = "Open";
		DocumentInspectionState["InProgress"] = "InProgress";
		DocumentInspectionState["Completed"] = "Completed";
		return DocumentInspectionState;
	}({});
	DocumentInspection = class {
		documentInspectionId;
		documentId;
		userId;
		questions = [[]];
		notes = [];
		answers = [{}];
		allowAnswerGroupAddition;
		state = "Open";
		createdAt;
		updatedAt;
		document;
		constructor(documentInspection) {
			Object.assign(this, documentInspection);
			if (documentInspection.questions?.length) this.questions = documentInspection.questions.map((qArr) => qArr.map((q) => new FormQuestion(q)));
		}
		areAnswersValid(answers) {
			return this.questions.every((questionGroup, idx) => {
				const areRequiredQuestionsAnswered = questionGroup.reduce((result, question) => {
					return result && question.areAnswersValid(answers[idx]);
				}, true);
				const areCustomValidatorsValid = this.evaluateCustomValidations(answers[idx]);
				return areRequiredQuestionsAnswered && areCustomValidatorsValid;
			});
		}
		evaluateCustomValidations(answers) {
			switch (this.document?.documentType) {
				case "EconomicPlan": {
					const { future_housegeld, future_housegeld_transferable, future_housegeld_non_transferable, future_housegeld_reserve } = answers;
					return floatEquals(Number.parseFloat(Number(future_housegeld).toFixed(3)), Number.parseFloat((Number(future_housegeld_transferable) + Number(future_housegeld_non_transferable) + Number(future_housegeld_reserve)).toFixed(3)));
				}
				default: return true;
			}
		}
		setUser(user) {
			this.userId = user.uid;
		}
		setAnswersAndValidate(value) {
			if (this.areAnswersValid(value)) this.state = "Completed";
			else this.state = "InProgress";
			this.answers = value;
		}
		prepareForEstateUpdate() {
			switch (this.document?.documentType) {
				case "EconomicPlan": {
					const [answers] = this.answers;
					const futureHouseGeldStartDate = answers.future_housegeld_start_date;
					this.answers = [{
						...omit(answers, [
							"housegeld",
							"housegeld_transferable",
							"housegeld_non_transferable",
							"housegeld_reserve"
						]),
						future_housegeld_start_date: dayjs(futureHouseGeldStartDate).tz("Europe/Berlin").toDate()
					}];
					break;
				}
				default:
			}
		}
	};
	EligibleInspectionDocumentTypes = [
		"DeclarationOfCondominium",
		"AnnualStatement",
		"EconomicPlan",
		"Protocol2024",
		"Protocol2025",
		"Protocol2026",
		"AbstractOfTitle",
		"ContractDraft",
		"ArchiveOfResolutions"
	];
	MergedDocumentInspections = {
		["AnnualStatement"]: {
			name: "Abrechnungen",
			mergeTypes: ["AnnualStatement", "HomeOwnerFeeStatement"]
		},
		["HomeOwnerFeeStatement"]: {
			name: "Abrechnungen",
			mergeTypes: ["HomeOwnerFeeStatement", "AnnualStatement"]
		}
	};
	DocumentsWithAllowedAnswerGroupAddition = ["ArchiveOfResolutions"];
	ExportableDocumentInspectionsTypeMap = { ["ArchiveOfResolutions"]: {
		documentType: "BuildingModernizationMeasures",
		documentCategory: "Selling"
	} };
}));
//#endregion
//#region src/domains/transaction/document-inspection/document-inspection.opts.ts
var init_document_inspection_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/transaction/document-inspection/document-inspection.helpers.ts
var getFutureHouseGeldValuesFromEconomicPlanDocumentInspectionIfApplicable;
var init_document_inspection_helpers = __esmMin((() => {
	init_document();
	init_estates();
	init_document_inspection_model();
	getFutureHouseGeldValuesFromEconomicPlanDocumentInspectionIfApplicable = (estate) => {
		const [latestEconomicPlanDocumentInspection] = estate.documentRelation?.map((dr) => dr.document)?.filter((doc) => doc?.documentInspection && doc.documentType === "EconomicPlan" && doc.documentInspection.state === "Completed" && doc.documentInspection.answers.some((a) => a.future_housegeld))?.map((doc) => doc.documentInspection)?.sort(({ updatedAt: a }, { updatedAt: b }) => dayjs(b).diff(dayjs(a))) ?? [];
		if (latestEconomicPlanDocumentInspection) {
			const [answers] = latestEconomicPlanDocumentInspection.answers;
			const { future_housegeld_start_date: futureHouseGeldStartDate, future_housegeld: futureHouseGeld, future_housegeld_transferable: futureHouseGeldTransferable, future_housegeld_non_transferable: futureHouseGeldNonTransferable, future_housegeld_reserve: futureHouseGeldReserve } = answers;
			if (futureHouseGeldStartDate) {
				const { shouldRecalculateNonApprovedInvestmentCasesAndCashflows } = checkIfFutureHouseGeldStartDateRequiresProcessing(futureHouseGeldStartDate);
				if (shouldRecalculateNonApprovedInvestmentCasesAndCashflows) return {
					futureHouseGeld,
					futureHouseGeldTransferable,
					futureHouseGeldNonTransferable,
					futureHouseGeldReserve
				};
			}
		}
	};
}));
//#endregion
//#region src/domains/transaction/document-inspection/index.ts
var init_document_inspection = __esmMin((() => {
	init_document_inspection_errors();
	init_document_inspection_model();
	init_document_inspection_opts();
	init_document_inspection_helpers();
}));
//#endregion
//#region src/domains/finance/accounting.model.ts
var AccountingPaymentTerm;
var init_accounting_model = __esmMin((() => {
	AccountingPaymentTerm = {
		IMMEDIATE: 0,
		FOUR_DAYS: 4,
		FIVE_DAYS: 5,
		SEVEN_DAYS: 7,
		EIGHT_DAYS: 8,
		TEN_DAYS: 10,
		FOURTEEN_DAYS: 14,
		FIFTEEN_DAYS: 15,
		TWENTY_DAYS: 20,
		TWENTY_ONE_DAYS: 21,
		THIRTY_DAYS: 30
	};
}));
//#endregion
//#region src/domains/finance/accounting.i18n.ts
var AccountingPaymentTermTranslation;
var init_accounting_i18n = __esmMin((() => {
	init_accounting_model();
	AccountingPaymentTermTranslation = {
		[AccountingPaymentTerm.IMMEDIATE]: "Sofort",
		[AccountingPaymentTerm.FOUR_DAYS]: "4 Tage",
		[AccountingPaymentTerm.FIVE_DAYS]: "5 Tage",
		[AccountingPaymentTerm.SEVEN_DAYS]: "7 Tage",
		[AccountingPaymentTerm.EIGHT_DAYS]: "8 Tage",
		[AccountingPaymentTerm.TEN_DAYS]: "10 Tage",
		[AccountingPaymentTerm.FOURTEEN_DAYS]: "14 Tage",
		[AccountingPaymentTerm.FIFTEEN_DAYS]: "15 Tage",
		[AccountingPaymentTerm.TWENTY_DAYS]: "20 Tage",
		[AccountingPaymentTerm.TWENTY_ONE_DAYS]: "21 Tage",
		[AccountingPaymentTerm.THIRTY_DAYS]: "30 Tage"
	};
}));
//#endregion
//#region src/domains/finance/accounting.opts.ts
var init_accounting_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/finance/bank-account/bank-account-reconciler-rule.ts
var init_bank_account_reconciler_rule = __esmMin((() => {}));
//#endregion
//#region src/domains/finance/banking/banking.base.ts
var EbicsOrder, EbicsOrderStatus, BankOwnerAccountAction, BankOwnerAccountStates, BankOwnerAccountEvents, TransactionRunState, BookingKey, ALL_BOOKING_KEYS, Subtag;
var init_banking_base = __esmMin((() => {
	EbicsOrder = /* @__PURE__ */ function(EbicsOrder) {
		EbicsOrder["HIA"] = "HIA";
		EbicsOrder["INI"] = "INI";
		EbicsOrder["HPB"] = "HPB";
		EbicsOrder["STA"] = "STA";
		EbicsOrder["HAA"] = "HAA";
		EbicsOrder["HKD"] = "HKD";
		EbicsOrder["HPD"] = "HPD";
		EbicsOrder["HTD"] = "HTD";
		EbicsOrder["AZV"] = "AZV";
		EbicsOrder["C52"] = "C52";
		EbicsOrder["C53"] = "C53";
		EbicsOrder["CCS"] = "CCS";
		EbicsOrder["CCT"] = "CCT";
		EbicsOrder["CD1"] = "CD1";
		EbicsOrder["CDB"] = "CDB";
		EbicsOrder["CDD"] = "CDD";
		EbicsOrder["CDS"] = "CDS";
		EbicsOrder["DKI"] = "DKI";
		EbicsOrder["HAC"] = "HAC";
		EbicsOrder["PTK"] = "PTK";
		EbicsOrder["VMK"] = "VMK";
		EbicsOrder["XCT"] = "XCT";
		EbicsOrder["XE3"] = "XE3";
		EbicsOrder["XG1"] = "XG1";
		EbicsOrder["Z53"] = "Z53";
		return EbicsOrder;
	}({});
	EbicsOrderStatus = /* @__PURE__ */ function(EbicsOrderStatus) {
		EbicsOrderStatus["Succeeded"] = "Succeeded";
		EbicsOrderStatus["Failed"] = "Failed";
		return EbicsOrderStatus;
	}({});
	BankOwnerAccountAction = /* @__PURE__ */ function(BankOwnerAccountAction) {
		BankOwnerAccountAction["GeneratePublicKeys"] = "generate-public-keys";
		BankOwnerAccountAction["GenerateVerificationDocument"] = "generate-verification-document";
		BankOwnerAccountAction["CheckVerificationStatus"] = "check-verification-status";
		return BankOwnerAccountAction;
	}({});
	BankOwnerAccountStates = /* @__PURE__ */ function(BankOwnerAccountStates) {
		BankOwnerAccountStates["Created"] = "Created";
		BankOwnerAccountStates["ReadyForValidation"] = "ReadyForValidation";
		BankOwnerAccountStates["PublicKeysSent"] = "PublicKeysSent";
		BankOwnerAccountStates["ManualDocumentValidation"] = "ManualDocumentValidation";
		BankOwnerAccountStates["Validated"] = "Validated";
		return BankOwnerAccountStates;
	}({});
	BankOwnerAccountEvents = /* @__PURE__ */ function(BankOwnerAccountEvents) {
		BankOwnerAccountEvents["CredentialsUpdated"] = "CredentialsUpdated";
		BankOwnerAccountEvents["AuthorizationStarted"] = "AuthorizationStarted";
		BankOwnerAccountEvents["PublicKeysSent"] = "PublicKeysSent";
		BankOwnerAccountEvents["INIDocumentSent"] = "INIDocumentSent";
		BankOwnerAccountEvents["KeysValidated"] = "KeysValidated";
		return BankOwnerAccountEvents;
	}({});
	TransactionRunState = /* @__PURE__ */ function(TransactionRunState) {
		TransactionRunState["Skipped"] = "Skipped";
		TransactionRunState["Executed"] = "Executed";
		TransactionRunState["Failed"] = "Failed";
		return TransactionRunState;
	}({});
	BookingKey = /* @__PURE__ */ function(BookingKey) {
		BookingKey["DirectDebit"] = "DDT";
		BookingKey["ChargesExpenses"] = "CHG";
		return BookingKey;
	}({});
	ALL_BOOKING_KEYS = [
		{
			code: "RTI",
			description: "Returned item"
		},
		{
			code: "SAL",
			description: "Securities Related Item - Sale (including STIF and Time deposits)"
		},
		{
			code: "SEC",
			description: "Securities (used when entering a principal amount)"
		},
		{
			code: "SLE",
			description: "Securities Related Item - Securities lending related"
		},
		{
			code: "STO",
			description: "Standing order"
		},
		{
			code: "STP",
			description: "Securities Related Item - Stamp duty"
		},
		{
			code: "SUB",
			description: "Securities Related Item - Subscription"
		},
		{
			code: "SWP",
			description: "Securities Related Item - SWAP payment"
		},
		{
			code: "TAX",
			description: "Securities Related Item - Withholding tax payment"
		},
		{
			code: "TCK",
			description: "Travellers cheques"
		},
		{
			code: "TCM",
			description: "Securities Related Item - Tripartite collateral management"
		},
		{
			code: "TRA",
			description: "Securities Related Item - Internal transfer for own account"
		},
		{
			code: "TRF",
			description: "Transfer"
		},
		{
			code: "TRN",
			description: "Securities Related Item - Transaction fee"
		},
		{
			code: "UWC",
			description: "Securities Related Item - Underwriting commission"
		},
		{
			code: "VDA",
			description: "Value date adjustment (used with an entry made to withdraw an incorrectly dated entry – it will be followed by the correct entry with the relevant code)"
		},
		{
			code: "WAR",
			description: "Securities Related Item - Warrant"
		},
		{
			code: "CLR",
			description: "Cash letters/Cheques remittance"
		},
		{
			code: "CMI",
			description: "Cash management item - No detail"
		},
		{
			code: "CMN",
			description: "Cash management item - Notional pooling"
		},
		{
			code: "CMP",
			description: "Compensation claims"
		},
		{
			code: "CMS",
			description: "Cash management item - Sweeping"
		},
		{
			code: "CMT",
			description: "Cash management item -Topping"
		},
		{
			code: "CMZ",
			description: "Cash management item - Zero balancing"
		},
		{
			code: "COL",
			description: "Collections (used when entering a principal amount)"
		},
		{
			code: "COM",
			description: "Commission"
		},
		{
			code: "CPN",
			description: "Securities Related Item - Coupon payments"
		},
		{
			code: "DCR",
			description: "Documentary credit (used when entering a principal amount)"
		},
		{
			code: "DDT",
			description: "Direct Debit Item"
		},
		{
			code: "DIS",
			description: "Securities Related Item - Gains disbursement"
		},
		{
			code: "DIV",
			description: "Securities Related Item - Dividends"
		},
		{
			code: "EQA",
			description: "Equivalent amount"
		},
		{
			code: "EXT",
			description: "Securities Related Item - External transfer for own account"
		},
		{
			code: "FEX",
			description: "Foreign exchange"
		},
		{
			code: "INT",
			description: "Interest"
		},
		{
			code: "LBX",
			description: "Lock box"
		},
		{
			code: "LDP",
			description: "Loan deposit"
		},
		{
			code: "MAR",
			description: "Securities Related Item - Margin payments/Receipts"
		},
		{
			code: "MAT",
			description: "Securities Related Item - Maturity"
		},
		{
			code: "MGT",
			description: "Securities Related Item - Management fees"
		},
		{
			code: "MSC",
			description: "Miscellaneous"
		},
		{
			code: "NWI",
			description: "Securities Related Item - New issues distribution"
		},
		{
			code: "ODC",
			description: "Overdraft charge"
		},
		{
			code: "OPT",
			description: "Securities Related Item - Options"
		},
		{
			code: "PCH",
			description: "Securities Related Item - Purchase (including STIF and Time deposits)"
		},
		{
			code: "POP",
			description: "Securities Related Item - Pair-off proceeds"
		},
		{
			code: "PRN",
			description: "Securities Related Item - Principal pay-down/pay-up"
		},
		{
			code: "REC",
			description: "Securities Related Item - Tax reclaim"
		},
		{
			code: "RED",
			description: "Securities Related Item - Redemption/Withdrawal"
		},
		{
			code: "RIG",
			description: "Securities Related Item - Rights"
		},
		{
			code: "BNK",
			description: "Securities Related Item - Bank fees"
		},
		{
			code: "BOE",
			description: "Bill of exchange"
		},
		{
			code: "BRF",
			description: "Brokerage fee"
		},
		{
			code: "CAR",
			description: "Securities Related Item - Corporate Actions Related (Should only be used when no specific corporate action event code is available)"
		},
		{
			code: "CAS",
			description: "Securities Related Item - Cash in Lieu"
		},
		{
			code: "CHG",
			description: "Charges and other expenses"
		},
		{
			code: "CHK",
			description: "Cheques"
		}
	];
	Subtag = /* @__PURE__ */ function(Subtag) {
		Subtag["DebtorIban"] = "DebtorIban";
		Subtag["DebtorBic"] = "DebtorBic";
		Subtag["Bookingtext"] = "Bookingtext";
		Subtag["EndToEndReference"] = "EndToEndReference";
		Subtag["MandateReference"] = "MandateReference";
		Subtag["CustomerReference"] = "CustomerReference";
		Subtag["DebtorIdentifier"] = "DebtorIdentifier";
		Subtag["CreditorIdentifier"] = "CreditorIdentifier";
		Subtag["SepaRefererenceNumber"] = "SepaRefererenceNumber";
		Subtag["UltimateDebtor"] = "UltimateDebtor";
		Subtag["UltimateCreditor"] = "UltimateCreditor";
		Subtag["PrimanoteNumber"] = "PrimanoteNumber";
		Subtag["Reference"] = "Reference";
		Subtag["AdditionalPurpose"] = "AdditionalPurpose";
		Subtag["Bic"] = "Bic";
		Subtag["Iban"] = "Iban";
		Subtag["Debtor"] = "Debtor";
		Subtag["Creditor"] = "Creditor";
		Subtag["ReasonCode"] = "ReasonCode";
		Subtag["Unknown"] = "Unknown";
		return Subtag;
	}({});
}));
//#endregion
//#region src/domains/finance/banking/transaction.model.ts
var BalanceInfoSchema, ParsedSubtagSchema, TransactionSchema, StatementSchema;
var init_transaction_model = __esmMin((() => {
	init_banking_base();
	init_lib();
	BalanceInfoSchema = Type.Object({
		isCredit: Type.Boolean(),
		date: Type.String(),
		currency: Type.String(),
		value: Type.Number()
	}, { $id: "BalanceInfo" });
	ParsedSubtagSchema = Type.Object({
		type: Type.Enum(Subtag),
		value: Type.String(),
		code: Type.Optional(Type.String())
	}, { $id: "ParsedSubtag" });
	TransactionSchema = Type.Object({
		id: Type.String(),
		code: Type.String(),
		fundsCode: Type.String(),
		isCredit: Type.Boolean(),
		isExpense: Type.Boolean(),
		currency: Type.String(),
		description: Type.String(),
		amount: Type.Number(),
		valueDate: Type.String(),
		entryDate: Type.String(),
		customerReference: Type.String(),
		bankReference: Type.String(),
		subtags: Type.Array(ParsedSubtagSchema),
		sourceIban: Type.Optional(Type.String()),
		iban: Type.Optional(Type.String()),
		accountId: Type.Optional(Type.String()),
		codes: Type.Optional(Type.Object({
			trxDomainCode: Type.String(),
			trxDomainCodeFamily: Type.String(),
			trxDomainCodeSubFamily: Type.String(),
			transactionType: Type.Optional(TNullable(Type.String())),
			processingCode: Type.Optional(TNullable(Type.String())),
			detailsCode: Type.Optional(TNullable(Type.String())),
			qualifier: Type.Optional(TNullable(Type.String())),
			returnReasonCode: Type.Optional(TNullable(Type.String())),
			returnInfo: Type.Optional(TNullable(Type.String()))
		})),
		amountDetails: Type.Optional(Type.Object({
			originalAmount: Type.Optional(Type.Number()),
			feeAmount: Type.Optional(Type.Number()),
			feeType: Type.Optional(Type.String()),
			feeAgentBic: Type.Optional(Type.String())
		}))
	}, { $id: "Transaction" });
	StatementSchema = Type.Object({
		iban: Type.Optional(Type.String()),
		transactions: Type.Array(TransactionSchema),
		referenceNumber: Type.Optional(Type.String()),
		relatedReferenceNumber: Type.Optional(Type.String()),
		accountId: Type.Optional(Type.String()),
		number: Type.Optional(Type.String()),
		openingBalance: Type.Optional(Type.Any()),
		closingBalance: Type.Optional(Type.Any()),
		closingAvailableBalance: Type.Optional(Type.Any()),
		forwardAvailableBalance: Type.Optional(Type.Any()),
		additionalInformation: Type.Optional(Type.String()),
		orderType: Type.Optional(Type.Enum(EbicsOrder))
	}, { $id: "Statement" });
}));
//#endregion
//#region src/domains/finance/invoice/invoice-subscription.model.ts
var SubscriptionFrequency, SubscriptionState, SubscriptionPaymentType, SubscriptionFrequencyType, firstInvoiceOrPermanentInvoice, INVOICE_SUBSCRIPTION_SAME_FIELDS, REQUIRED_PERMANENT_INVOICE_FIELDS;
var init_invoice_subscription_model = __esmMin((() => {
	SubscriptionFrequency = /* @__PURE__ */ function(SubscriptionFrequency) {
		SubscriptionFrequency["Weekly"] = "Weekly";
		SubscriptionFrequency["Monthly"] = "Monthly";
		SubscriptionFrequency["Quarterly"] = "Quarterly";
		SubscriptionFrequency["Yearly"] = "Yearly";
		return SubscriptionFrequency;
	}({});
	SubscriptionState = /* @__PURE__ */ function(SubscriptionState) {
		SubscriptionState["Active"] = "Active";
		SubscriptionState["Inactive"] = "Inactive";
		return SubscriptionState;
	}({});
	SubscriptionPaymentType = /* @__PURE__ */ function(SubscriptionPaymentType) {
		SubscriptionPaymentType["DirectDebit"] = "DirectDebit";
		SubscriptionPaymentType["StandingOrder"] = "StandingOrder";
		SubscriptionPaymentType["Manual"] = "Manual";
		return SubscriptionPaymentType;
	}({});
	SubscriptionFrequencyType = /* @__PURE__ */ function(SubscriptionFrequencyType) {
		SubscriptionFrequencyType["MasterTemplate"] = "MasterTemplate";
		SubscriptionFrequencyType["PeriodicIncoming"] = "PeriodicIncoming";
		return SubscriptionFrequencyType;
	}({});
	firstInvoiceOrPermanentInvoice = (subscription) => subscription.permanentInvoice ?? subscription.invoices?.[0];
	INVOICE_SUBSCRIPTION_SAME_FIELDS = [
		"estateId",
		"costType",
		"creditorAccountingId",
		"debtorAccountingId"
	];
	REQUIRED_PERMANENT_INVOICE_FIELDS = [
		"creditorAccountingId",
		"debtorAccountingId",
		"costType",
		"iban",
		"amount",
		"payoutAmount"
	];
}));
//#endregion
//#region src/domains/finance/invoice/invoice.base.ts
var Debtors, PeaksideDebtors, allowedDomainsForInvoiceAssignees, CostTypes, costTypeTranslations, costTypesGrouped, costTypeGroups, InvoiceStates, internalToExternalInvoiceStatesMap, externalInvoicesStates, FinalPartialCheckInvoicesStatesList, InvoiceEvents, InvoiceSource, InvoiceVATClass, InvoiceVATClassValue, DebtorsPayingVAT, DebtAllocation, InvoiceType, ALLOWED_INVOICE_TYPES_FOR_UI, ALLOWED_INVOICE_VAT_CLASSES_FOR_UI, DuplicateInvoiceError;
var init_invoice_base = __esmMin((() => {
	init_errors();
	Debtors = /* @__PURE__ */ function(Debtors) {
		Debtors["CondoGroupGmbH"] = "Condo Group GmbH";
		Debtors["ReneoAssetManagementGmbH"] = "Reneo Asset Management GmbH";
		Debtors["CondoTechnologiesGmbH"] = "Condo Technologies GmbH";
		Debtors["CondoAssetManagementGmbH"] = "Condo Asset Management GmbH";
		Debtors["CondoAssetManagementSEV"] = "Condo Asset Management (SEV)";
		Debtors["HHLG2"] = "Hamburger Liegenschaftsgesellschaft 2 mbH";
		Debtors["HHLG"] = "Hamburger Liegenschaftsgesellschaft mbH";
		Debtors["DLG"] = "Deutsche Liegenschaftsgesellschaft mbH";
		Debtors["ReneoGroupGmbH"] = "Reneo Group GmbH";
		Debtors["LivingsGmbH"] = "Livings GmbH";
		Debtors["ReneoServicesGmbH"] = "Reneo Services GmbH";
		return Debtors;
	}({});
	PeaksideDebtors = /* @__PURE__ */ function(PeaksideDebtors) {
		PeaksideDebtors["Plus1"] = "Plus 1 Grundbesitz S.à.r.l.";
		PeaksideDebtors["Plus2"] = "Plus 2 Grundbesitz S.à.r.l.";
		PeaksideDebtors["Plus3"] = "Plus 3 Grundbesitz S.à.r.l.";
		PeaksideDebtors["Pref4"] = "PREF IV Logistics Five S.à.r.l.";
		PeaksideDebtors["Plus4"] = "Plus 4 Grundbesitz S.à.r.l.";
		return PeaksideDebtors;
	}({});
	allowedDomainsForInvoiceAssignees = [
		"hh-lg.de",
		"reneo.de",
		"condogroup.de"
	];
	CostTypes = /* @__PURE__ */ function(CostTypes) {
		CostTypes["Notary"] = "Notary";
		CostTypes["LandTransferTaxes"] = "LandTransferTaxes";
		CostTypes["AgencyFee"] = "AgencyFee";
		CostTypes["PropertyRegistration"] = "PropertyRegistration";
		CostTypes["ReferralFee"] = "ReferralFee";
		CostTypes["OtherAncillaryCost"] = "OtherAncillaryCost";
		CostTypes["AgencyFeeSelling"] = "AgencyFeeSelling";
		CostTypes["OtherAncillaryCostSelling"] = "OtherAncillaryCostSelling";
		CostTypes["GeneralRenovationCost"] = "GeneralRenovationCost";
		CostTypes["KitchenCost"] = "KitchenCost";
		CostTypes["OtherRenovationCost"] = "OtherRenovationCost";
		CostTypes["HomeOwnersFee"] = "HomeOwnersFee";
		CostTypes["Utilities"] = "Utilities";
		CostTypes["PropertyTax"] = "PropertyTax";
		CostTypes["Internal"] = "Internal";
		CostTypes["HomeSpecialFee"] = "HomeSpecialFee";
		CostTypes["PropertyRelatedExpenses"] = "PropertyRelatedExpenses";
		CostTypes["PropertyValuation"] = "PropertyValuation";
		CostTypes["RecruitingExpenses"] = "RecruitingExpenses";
		CostTypes["OfficeExpenses"] = "OfficeExpenses";
		CostTypes["MarketingExpenses"] = "MarketingExpenses";
		CostTypes["EquipmentExpensesAndDA"] = "EquipmentExpensesAndDA";
		CostTypes["TechnologyAndAnalytics"] = "TechnologyAndAnalytics";
		CostTypes["TravelExpenses"] = "TravelExpenses";
		CostTypes["OtherAdministrativeCosts"] = "OtherAdministrativeCosts";
		CostTypes["ExternalLabourCosts"] = "ExternalLabourCosts";
		CostTypes["Training"] = "Training";
		CostTypes["TeamEvent"] = "TeamEvent";
		CostTypes["OtherLabourRelatedCosts"] = "OtherLabourRelatedCosts";
		CostTypes["OfficeRent"] = "OfficeRent";
		CostTypes["CarAndLeasingCosts"] = "CarAndLeasingCosts";
		CostTypes["LegalCosts"] = "LegalCosts";
		CostTypes["ConsultancyCosts"] = "ConsultancyCosts";
		CostTypes["AdvertisingCosts"] = "AdvertisingCosts";
		CostTypes["SplitInvoice"] = "SplitInvoice";
		CostTypes["CarRelatedCosts"] = "CarRelatedCosts";
		CostTypes["AuditAndTax"] = "AuditAndTax";
		CostTypes["Payroll"] = "Payroll";
		CostTypes["VoluntarySocialExpenses"] = "VoluntarySocialExpenses";
		CostTypes["RepairAndMaintenance"] = "RepairAndMaintenance";
		CostTypes["RepairAndMaintenanceRecoverable"] = "RepairAndMaintenanceRecoverable";
		CostTypes["RentReduction"] = "RentReduction";
		CostTypes["DepositRefund"] = "DepositRefund";
		CostTypes["UtilitiesRefund"] = "UtilitiesRefund";
		CostTypes["UtilitiesAdditionalPayment"] = "UtilitiesAdditionalPayment";
		CostTypes["RepairCosts"] = "RepairCosts";
		CostTypes["RentGuarantee"] = "RentGuarantee";
		CostTypes["Livings"] = "Livings";
		CostTypes["LivingsEquipment"] = "LivingsEquipment";
		CostTypes["LivingsCleaningCosts"] = "LivingsCleaningCosts";
		CostTypes["LivingsTelephoneCosts"] = "LivingsTelephoneCosts";
		CostTypes["LivingsUtilities"] = "LivingsUtilities";
		CostTypes["LivingsOther"] = "LivingsOther";
		CostTypes["LivingsAgencyFeesRenting"] = "LivingsAgencyFeesRenting";
		CostTypes["NonRecsMaintenance"] = "NonRecsMaintenance";
		CostTypes["RenovationCostsEnergyEfficiency"] = "RenovationCostsEnergyEfficiency";
		CostTypes["RenovationCostsInteriorResidential"] = "RenovationCostsInteriorResidential";
		CostTypes["RenovationCostsInteriorCommercial"] = "RenovationCostsInteriorCommercial";
		CostTypes["RenovationCostsGeneralCapex"] = "RenovationCostsGeneralCapex";
		CostTypes["RenovationCostsExpansion"] = "RenovationCostsExpansion";
		CostTypes["RenovationCostsRoofConversionCapex"] = "RenovationCostsRoofConversionCapex";
		CostTypes["RenovationCostsRoofExtensionCapex"] = "RenovationCostsRoofExtensionCapex";
		CostTypes["RenovationCostsSeparateNewBuildingCapex"] = "RenovationCostsSeparateNewBuildingCapex";
		CostTypes["LettingFees"] = "LettingFees";
		CostTypes["OperatingPartnerFee"] = "OperatingPartnerFee";
		CostTypes["OperatingPartnerFeeAcquisition"] = "OperatingPartnerFeeAcquisition";
		CostTypes["OperatingPartnerFeeCapexTIManagement"] = "OperatingPartnerFeeCapexTIManagement";
		CostTypes["OperatingPartnerFeePropertyManagement"] = "OperatingPartnerFeePropertyManagement";
		CostTypes["OperatingPartnerFeeAssetManagement"] = "OperatingPartnerFeeAssetManagement";
		CostTypes["OperatingPartnerFeeDisposition"] = "OperatingPartnerFeeDisposition";
		CostTypes["TechnicalDD"] = "TechnicalDD";
		CostTypes["LegalDD"] = "LegalDD";
		CostTypes["OperationalRecs"] = "OperationalRecs";
		CostTypes["ExternalServiceProvider"] = "ExternalServiceProvider";
		CostTypes["ExternalServiceProviderReneo"] = "ExternalServiceProviderReneo";
		CostTypes["EnergyConsultancyCosts"] = "EnergyConsultancyCosts";
		CostTypes["PlanningCosts"] = "PlanningCosts";
		CostTypes["InstiLandTransferTaxes"] = "InstiLandTransferTaxes";
		CostTypes["InstiNotary"] = "InstiNotary";
		CostTypes["InstiPropertyRegistration"] = "InstiPropertyRegistration";
		CostTypes["InstiAgencyFeePurchasing"] = "InstiAgencyFeePurchasing";
		CostTypes["InstiAgencyFeeSelling"] = "InstiAgencyFeeSelling";
		CostTypes["InstiOtherCostSelling"] = "InstiOtherCostSelling";
		CostTypes["OutsourcedPropertyManagementCost"] = "OutsourcedPropertyManagementCost";
		CostTypes["OutsourcedPlanningCosts"] = "OutsourcedPlanningCosts";
		CostTypes["DueDiligenceCosts"] = "DueDiligenceCosts";
		CostTypes["GERAccountingFees"] = "GERAccountingFees";
		CostTypes["GERLegalFees"] = "GERLegalFees";
		CostTypes["GERTaxAdvisoryFees"] = "GERTaxAdvisoryFees";
		CostTypes["GEROtherStructureCosts"] = "GEROtherStructureCosts";
		CostTypes["GEROtherExtraordinaryIncome"] = "GEROtherExtraordinaryIncome";
		CostTypes["GEROtherExtraordinaryExpenses"] = "GEROtherExtraordinaryExpenses";
		CostTypes["LUXAccountingFees"] = "LUXAccountingFees";
		CostTypes["LUXLegalFees"] = "LUXLegalFees";
		CostTypes["LUXTaxAdvisoryFees"] = "LUXTaxAdvisoryFees";
		CostTypes["LUXPeaksideFees"] = "LUXPeaksideFees";
		CostTypes["LUXAuditFees"] = "LUXAuditFees";
		CostTypes["LUXOtherStructureCosts"] = "LUXOtherStructureCosts";
		CostTypes["LUXOtherExtraordinaryIncome"] = "LUXOtherExtraordinaryIncome";
		CostTypes["LUXOtherExtraordinaryExpenses"] = "LUXOtherExtraordinaryExpenses";
		return CostTypes;
	}({});
	costTypeTranslations = {
		["Notary"]: "Retail Notary",
		["LandTransferTaxes"]: "Retail Land Transfer Taxes",
		["AgencyFee"]: "Retail Agency Fee (Purchasing)",
		["PropertyRegistration"]: "Retail Property Registration",
		["ReferralFee"]: "Retail Referral Fee",
		["OtherAncillaryCost"]: "Retail Other Cost (Purchasing)",
		["GeneralRenovationCost"]: "Retail General Renovation Cost",
		["KitchenCost"]: "Retail Kitchen Cost",
		["OtherRenovationCost"]: "Retail Other Renovation Cost",
		["HomeOwnersFee"]: "Retail Home Owners' Fee",
		["HomeSpecialFee"]: "Retail Home Special Fee",
		["SplitInvoice"]: "Split Invoice",
		["Utilities"]: "Retail Utilities",
		["RecruitingExpenses"]: "Recruiting Expenses",
		["OfficeExpenses"]: "Office Expenses",
		["ExternalLabourCosts"]: "External Labour Costs",
		["TravelExpenses"]: "Travel Expenses",
		["OtherAdministrativeCosts"]: "Other Administrative Costs",
		["Training"]: "Training",
		["TeamEvent"]: "Team Event",
		["OtherLabourRelatedCosts"]: "Other Labour related Costs",
		["OfficeRent"]: "Office Rent",
		["CarAndLeasingCosts"]: "Car & Leasing Costs",
		["LegalCosts"]: "Legal Costs",
		["ConsultancyCosts"]: "Consultancy Costs",
		["AdvertisingCosts"]: "Advertising Costs",
		["MarketingExpenses"]: "Marketing Expenses",
		["EquipmentExpensesAndDA"]: "D&A and Equipment Expenses",
		["TechnologyAndAnalytics"]: "Technology & Analytics",
		["AgencyFeeSelling"]: "Retail Agency Fee (Selling)",
		["OtherAncillaryCostSelling"]: "Retail Other Cost (Selling)",
		["PropertyTax"]: "Retail Property Tax",
		["Internal"]: "Retail Internal",
		["Livings"]: "General - Livings",
		["LivingsEquipment"]: "Equipment (Furniture etc) - Livings",
		["LivingsCleaningCosts"]: "Cleaning Costs - Livings",
		["LivingsTelephoneCosts"]: "Telephone Costs - Livings",
		["LivingsUtilities"]: "Utilities - Livings",
		["LivingsOther"]: "Other - Livings",
		["LivingsAgencyFeesRenting"]: "Agency Fees Renting - Livings",
		["RepairAndMaintenance"]: "Retail Repair & Maintenance",
		["RentReduction"]: "Retail Rent Reduction",
		["DepositRefund"]: "Retail Deposit Refund",
		["UtilitiesRefund"]: "Retail Utilities Refund",
		["UtilitiesAdditionalPayment"]: "Retail Utilities Additional Payment",
		["RepairCosts"]: "Retail Repair Costs",
		["RepairAndMaintenanceRecoverable"]: "Retail Repair & Maintenance Recoverable",
		["NonRecsMaintenance"]: "Non-Recs / Maintenance",
		["RenovationCostsEnergyEfficiency"]: "Renovation Costs – Energy efficiency",
		["RenovationCostsInteriorResidential"]: "Renovation Costs – TI interior residential",
		["RenovationCostsInteriorCommercial"]: "Renovation Costs – TI interior commercial",
		["RenovationCostsGeneralCapex"]: "Renovation Costs – General capex",
		["RenovationCostsExpansion"]: "Renovation Costs – Expansion",
		["RenovationCostsRoofConversionCapex"]: "Renovation Costs – Roof Conversion (Expansion) Capex",
		["RenovationCostsRoofExtensionCapex"]: "Renovation Costs – Roof Extension (Expansion) Capex",
		["RenovationCostsSeparateNewBuildingCapex"]: "Renovation Costs – Separate New Building (Expansion) Capex",
		["LettingFees"]: "Letting Fees (Resi / Commercial)",
		["OperatingPartnerFee"]: "Operating Partner Fee",
		["OperatingPartnerFeeAcquisition"]: "Operating Partner Fee – Acquisition Fee",
		["OperatingPartnerFeeCapexTIManagement"]: "Operating Partner Fee – Capex & TI Management Fee",
		["OperatingPartnerFeePropertyManagement"]: "Operating Partner Fee – Property Management Fee",
		["OperatingPartnerFeeAssetManagement"]: "Operating Partner Fee – Asset Management Fee",
		["OperatingPartnerFeeDisposition"]: "Operating Partner Fee – Disposition Fee",
		["TechnicalDD"]: "Technical DD",
		["LegalDD"]: "Legal DD",
		["OperationalRecs"]: "Operational Recs",
		["ExternalServiceProvider"]: "External Service Provider",
		["EnergyConsultancyCosts"]: "Energy consultancy costs",
		["PlanningCosts"]: "Planning Costs",
		["InstiLandTransferTaxes"]: "Land Transfer Taxes",
		["InstiNotary"]: "Notary",
		["InstiPropertyRegistration"]: "Property Registration",
		["InstiAgencyFeePurchasing"]: "Agency Fee – Purchasing",
		["InstiAgencyFeeSelling"]: "Agency Fee – Selling",
		["InstiOtherCostSelling"]: "Other Cost – Selling",
		["OutsourcedPropertyManagementCost"]: "Outsourced Property Management cost",
		["OutsourcedPlanningCosts"]: "Outsourced Planning Costs",
		["DueDiligenceCosts"]: "Due diligence costs",
		["GERAccountingFees"]: "GER Accounting fees",
		["GERLegalFees"]: "GER Legal fees",
		["GERTaxAdvisoryFees"]: "GER Tax advisory fees",
		["GEROtherStructureCosts"]: "GER Other Structure costs",
		["GEROtherExtraordinaryIncome"]: "GER Other extra-ordinary income",
		["GEROtherExtraordinaryExpenses"]: "GER Other extra-ordinary expenses",
		["LUXAccountingFees"]: "LUX Accounting fees",
		["LUXLegalFees"]: "LUX Legal fees",
		["LUXTaxAdvisoryFees"]: "LUX Tax advisory fees",
		["LUXPeaksideFees"]: "LUX Peakside fees",
		["LUXAuditFees"]: "LUX Audit fees",
		["LUXOtherStructureCosts"]: "LUX Other Structure costs",
		["LUXOtherExtraordinaryIncome"]: "LUX Other extra-ordinary income",
		["LUXOtherExtraordinaryExpenses"]: "LUX Other extra-ordinary expenses",
		["CarRelatedCosts"]: "Car Related Costs",
		["AuditAndTax"]: "Audit & Tax",
		["Payroll"]: "Payroll",
		["VoluntarySocialExpenses"]: "Labour related costs - voluntary social expenses",
		["ExternalServiceProviderReneo"]: "External Service Provider (Reneo)",
		["PropertyValuation"]: "Retail Property Valuation",
		["PropertyRelatedExpenses"]: "Retail Property Related Expenses",
		["RentGuarantee"]: "Retail Rent Guarantee"
	};
	costTypesGrouped = {
		InstitutionalBusinessLine: {
			InstitutionalCost: [
				"RenovationCostsGeneralCapex",
				"RenovationCostsEnergyEfficiency",
				"RenovationCostsExpansion",
				"RenovationCostsRoofConversionCapex",
				"RenovationCostsRoofExtensionCapex",
				"RenovationCostsSeparateNewBuildingCapex",
				"RenovationCostsInteriorResidential",
				"RenovationCostsInteriorCommercial",
				"LettingFees",
				"NonRecsMaintenance",
				"OperationalRecs",
				"OperatingPartnerFee",
				"OperatingPartnerFeeAcquisition",
				"OperatingPartnerFeeCapexTIManagement",
				"OperatingPartnerFeePropertyManagement",
				"OperatingPartnerFeeAssetManagement",
				"OperatingPartnerFeeDisposition",
				"ExternalServiceProvider",
				"ExternalServiceProviderReneo",
				"PlanningCosts"
			],
			InstitutionalTransactionCostsPurchasing: [
				"TechnicalDD",
				"LegalDD",
				"EnergyConsultancyCosts",
				"InstiLandTransferTaxes",
				"InstiNotary",
				"InstiPropertyRegistration",
				"InstiAgencyFeePurchasing"
			],
			InstitutionalTransactionCostsSelling: ["InstiAgencyFeeSelling", "InstiOtherCostSelling"],
			InstitutionalCostsCorporateReneo: [
				"OutsourcedPropertyManagementCost",
				"OutsourcedPlanningCosts",
				"DueDiligenceCosts"
			],
			InstitutionalCostsCorporate: [
				"GERAccountingFees",
				"GERLegalFees",
				"GERTaxAdvisoryFees",
				"GEROtherStructureCosts",
				"GEROtherExtraordinaryIncome",
				"GEROtherExtraordinaryExpenses",
				"LUXAccountingFees",
				"LUXLegalFees",
				"LUXTaxAdvisoryFees",
				"LUXPeaksideFees",
				"LUXAuditFees",
				"LUXOtherStructureCosts",
				"LUXOtherExtraordinaryIncome",
				"LUXOtherExtraordinaryExpenses"
			]
		},
		RetailBusinessLine: {
			RetailTransactionCostsPurchasing: [
				"Notary",
				"LandTransferTaxes",
				"AgencyFee",
				"PropertyRegistration",
				"ReferralFee",
				"OtherAncillaryCost"
			],
			RetailTransactionCostsSelling: ["AgencyFeeSelling", "OtherAncillaryCostSelling"],
			RetailRenovationCosts: [
				"GeneralRenovationCost",
				"KitchenCost",
				"OtherRenovationCost"
			],
			RetailOtherCosts: [
				"HomeOwnersFee",
				"Utilities",
				"PropertyTax",
				"Internal",
				"HomeSpecialFee",
				"PropertyRelatedExpenses",
				"PropertyValuation"
			],
			RetailPropertyManagementCosts: [
				"RepairAndMaintenance",
				"RepairAndMaintenanceRecoverable",
				"RentReduction",
				"DepositRefund",
				"UtilitiesRefund",
				"UtilitiesAdditionalPayment",
				"RepairCosts"
			],
			RetailLivingCosts: [
				"Livings",
				"LivingsEquipment",
				"LivingsCleaningCosts",
				"LivingsTelephoneCosts",
				"LivingsUtilities",
				"LivingsOther",
				"LivingsAgencyFeesRenting"
			]
		},
		Reneo: { ReneoOverheadCosts: [
			"RecruitingExpenses",
			"OfficeExpenses",
			"MarketingExpenses",
			"EquipmentExpensesAndDA",
			"TechnologyAndAnalytics",
			"TravelExpenses",
			"OtherAdministrativeCosts",
			"ExternalLabourCosts",
			"Training",
			"TeamEvent",
			"OtherLabourRelatedCosts",
			"OfficeRent",
			"CarAndLeasingCosts",
			"LegalCosts",
			"ConsultancyCosts",
			"AdvertisingCosts",
			"SplitInvoice",
			"AuditAndTax",
			"Payroll",
			"VoluntarySocialExpenses",
			"CarRelatedCosts"
		] }
	};
	costTypeGroups = () => {
		return Object.entries(costTypesGrouped).flatMap(([_bucket, groups]) => Object.entries(groups).flatMap(([group, costs]) => ({
			group,
			costs
		})));
	};
	InvoiceStates = /* @__PURE__ */ function(InvoiceStates) {
		InvoiceStates["New"] = "New";
		InvoiceStates["Assigned"] = "Assigned";
		InvoiceStates["WaitingForAuthorization"] = "WaitingForAuthorization";
		InvoiceStates["ManualReview"] = "ManualReview";
		InvoiceStates["Approved"] = "Approved";
		InvoiceStates["ReadyForPayment"] = "ReadyForPayment";
		InvoiceStates["FailedToExport"] = "FailedToExport";
		InvoiceStates["Paid"] = "Paid";
		InvoiceStates["PartiallyPaid"] = "PartiallyPaid";
		InvoiceStates["ManuallyPaid"] = "ManuallyPaid";
		InvoiceStates["ReadyForDrawdown"] = "ReadyForDrawdown";
		InvoiceStates["DrawdownCompleted"] = "DrawdownCompleted";
		InvoiceStates["InDispute"] = "InDispute";
		InvoiceStates["Rejected"] = "Rejected";
		InvoiceStates["Reimbursed"] = "Reimbursed";
		InvoiceStates["Duplicated"] = "Duplicated";
		InvoiceStates["ReadyForBooking"] = "ReadyForBooking";
		InvoiceStates["Authorized"] = "Authorized";
		InvoiceStates["WaitingForDrawdown"] = "WaitingForDrawdown";
		InvoiceStates["WaitingForExternalReview"] = "WaitingForExternalReview";
		return InvoiceStates;
	}({});
	internalToExternalInvoiceStatesMap = {
		["Assigned"]: "Assigned",
		["WaitingForAuthorization"]: "ReadyForBooking",
		["ManualReview"]: "Assigned",
		["Approved"]: "Assigned",
		["ReadyForPayment"]: "ReadyForBooking",
		["Paid"]: "Paid",
		["PartiallyPaid"]: "Paid",
		["ManuallyPaid"]: "Paid",
		["ReadyForDrawdown"]: "ReadyForBooking",
		["DrawdownCompleted"]: "Paid",
		["InDispute"]: "Assigned",
		["Reimbursed"]: "Paid",
		["ReadyForBooking"]: "ReadyForBooking",
		["Authorized"]: "ReadyForBooking",
		["WaitingForDrawdown"]: "ReadyForBooking",
		["WaitingForExternalReview"]: "WaitingForExternalReview"
	};
	externalInvoicesStates = uniq(Object.values(internalToExternalInvoiceStatesMap));
	FinalPartialCheckInvoicesStatesList = [
		"Assigned",
		"WaitingForAuthorization",
		"ManualReview",
		"Approved",
		"ReadyForPayment",
		"FailedToExport",
		"Paid",
		"PartiallyPaid",
		"ManuallyPaid",
		"ReadyForDrawdown",
		"DrawdownCompleted",
		"InDispute",
		"Reimbursed",
		"ReadyForBooking",
		"Authorized",
		"WaitingForDrawdown",
		"WaitingForExternalReview"
	];
	InvoiceEvents = /* @__PURE__ */ function(InvoiceEvents) {
		InvoiceEvents["Verified"] = "Verified";
		InvoiceEvents["Assign"] = "Assign";
		InvoiceEvents["Approve"] = "Approve";
		InvoiceEvents["Transition"] = "Transition";
		InvoiceEvents["Booked"] = "Booked";
		InvoiceEvents["Authorize"] = "Authorize";
		InvoiceEvents["ManualReview"] = "ManualReview";
		InvoiceEvents["ReadyForPayment"] = "ReadyForPayment";
		InvoiceEvents["FailedToExport"] = "FailedToExport";
		InvoiceEvents["SuccessfullyExported"] = "SuccessfullyExported";
		InvoiceEvents["Paid"] = "Paid";
		InvoiceEvents["PaymentOrderAdded"] = "PaymentOrderAdded";
		InvoiceEvents["PartiallyPaid"] = "PartiallyPaid";
		InvoiceEvents["ManuallyPaid"] = "ManuallyPaid";
		InvoiceEvents["Reimbursed"] = "Reimbursed";
		InvoiceEvents["Reject"] = "Reject";
		InvoiceEvents["Revert"] = "Revert";
		InvoiceEvents["Reset"] = "Reset";
		InvoiceEvents["ForceReject"] = "ForceReject";
		InvoiceEvents["DrawdownRequested"] = "DrawdownRequested";
		InvoiceEvents["PrepareForBooking"] = "PrepareForBooking";
		InvoiceEvents["CreatedFromDocument"] = "CreatedFromDocument";
		InvoiceEvents["ManuallyEnterNetSuiteLinkData"] = "ManuallyEnterNetSuiteLinkData";
		InvoiceEvents["IncompleteInvoiceData"] = "IncompleteInvoiceData";
		InvoiceEvents["DuplicatedInvoice"] = "DuplicatedInvoice";
		InvoiceEvents["DrawdownReceived"] = "DrawdownReceived";
		return InvoiceEvents;
	}({});
	InvoiceSource = /* @__PURE__ */ function(InvoiceSource) {
		InvoiceSource["Upload"] = "Upload";
		InvoiceSource["Email"] = "Email";
		return InvoiceSource;
	}({});
	InvoiceVATClass = /* @__PURE__ */ function(InvoiceVATClass) {
		InvoiceVATClass["StandardRate"] = "StandardRate";
		InvoiceVATClass["LuxembourgStandardRate"] = "LuxembourgStandardRate";
		InvoiceVATClass["ReducedRate"] = "ReducedRate";
		InvoiceVATClass["ReverseCharge"] = "ReverseCharge";
		InvoiceVATClass["ImportTax"] = "ImportTax";
		/** @deprecated Removed from invoice mask; kept for existing invoices. */
		InvoiceVATClass["ThirdCountriesOutsideEU"] = "ThirdCountriesOutsideEU";
		/** @deprecated Removed from invoice mask; kept for existing invoices. */
		InvoiceVATClass["TaxFreeEEUPurchases"] = "TaxFreeEEUPurchases";
		/** @deprecated Removed from invoice mask; kept for existing invoices. */
		InvoiceVATClass["EUPurchases"] = "EUPurchases";
		InvoiceVATClass["Exempt"] = "Exempt";
		InvoiceVATClass["VATZero"] = "VATZero";
		InvoiceVATClass["ReverseChargeThirdCountry"] = "ReverseChargeThirdCountry";
		InvoiceVATClass["ReverseChargeEU"] = "ReverseChargeEU";
		InvoiceVATClass["IntraCommunityAcquisition"] = "IntraCommunityAcquisition";
		return InvoiceVATClass;
	}({});
	InvoiceVATClassValue = {
		["StandardRate"]: .19,
		["LuxembourgStandardRate"]: .17,
		["ReducedRate"]: .07,
		["ReverseCharge"]: 0,
		["ImportTax"]: 0,
		["ThirdCountriesOutsideEU"]: 0,
		["TaxFreeEEUPurchases"]: 0,
		["EUPurchases"]: 0,
		["Exempt"]: 0,
		["VATZero"]: 0,
		["ReverseChargeThirdCountry"]: 0,
		["ReverseChargeEU"]: 0,
		["IntraCommunityAcquisition"]: 0
	};
	DebtorsPayingVAT = [
		"Reneo Group GmbH",
		"Reneo Asset Management GmbH",
		"Reneo Services GmbH",
		"Livings GmbH",
		...Object.values(PeaksideDebtors)
	];
	DebtAllocation = /* @__PURE__ */ function(DebtAllocation) {
		DebtAllocation["Junior"] = "Junior";
		DebtAllocation["Senior"] = "Senior";
		return DebtAllocation;
	}({});
	InvoiceType = /* @__PURE__ */ function(InvoiceType) {
		InvoiceType["Normal"] = "Normal";
		InvoiceType["PaymentReminder"] = "PaymentReminder";
		InvoiceType["CreditNote"] = "CreditNote";
		InvoiceType["RenovationGuarantee"] = "RenovationGuarantee";
		InvoiceType["RecurrentPayment"] = "RecurrentPayment";
		InvoiceType["MasterTemplate"] = "MasterTemplate";
		InvoiceType["Consolidated"] = "Consolidated";
		InvoiceType["Other"] = "Other";
		return InvoiceType;
	}({});
	ALLOWED_INVOICE_TYPES_FOR_UI = [
		"Normal",
		"CreditNote",
		"Consolidated"
	];
	ALLOWED_INVOICE_VAT_CLASSES_FOR_UI = [
		"StandardRate",
		"LuxembourgStandardRate",
		"ReducedRate",
		"ReverseCharge",
		"ImportTax",
		"Exempt",
		"VATZero",
		"ReverseChargeThirdCountry",
		"ReverseChargeEU",
		"IntraCommunityAcquisition"
	];
	DuplicateInvoiceError = class extends BaseError {
		invoiceDuplicateIds;
		duplicateOf;
		constructor(invoiceDuplicateIds) {
			super(`Invoice is a duplicate of Invoice #${invoiceDuplicateIds.join(", ")}`, "DUPLICATE_INVOICE");
			this.invoiceDuplicateIds = invoiceDuplicateIds;
			this.duplicateOf = invoiceDuplicateIds[0];
		}
	};
}));
//#endregion
//#region src/domains/finance/third-party/klippa/index.ts
var BarcodeTypeEnum, BulkUserDataSetRecordActionFormActionEnum, BulkUserDataSetRecordResultActionEnum, BulkUserDataSetRecordResultResultEnum, CreateUserDataSetFormTypeEnum, GetFieldTypeEnum, GetFieldSubtypeTypeEnum, ReceiptDocumentTypeEnum, ReceiptInvoiceTypeEnum, ReceiptPaymentmethodEnum;
var init_klippa = __esmMin((() => {
	BarcodeTypeEnum = /* @__PURE__ */ function(BarcodeTypeEnum) {
		BarcodeTypeEnum["Empty"] = "";
		BarcodeTypeEnum["EAN2"] = "EAN2";
		BarcodeTypeEnum["EAN5"] = "EAN5";
		BarcodeTypeEnum["EAN8"] = "EAN8";
		BarcodeTypeEnum["UPCE"] = "UPCE";
		BarcodeTypeEnum["ISBN10"] = "ISBN10";
		BarcodeTypeEnum["UPCA"] = "UPCA";
		BarcodeTypeEnum["EAN13"] = "EAN13";
		BarcodeTypeEnum["ISBN13"] = "ISBN13";
		BarcodeTypeEnum["COMPOSITE"] = "COMPOSITE";
		BarcodeTypeEnum["I25"] = "I25";
		BarcodeTypeEnum["DATABAR"] = "DATABAR";
		BarcodeTypeEnum["DATABAREXP"] = "DATABAR_EXP";
		BarcodeTypeEnum["CODABAR"] = "CODABAR";
		BarcodeTypeEnum["CODE39"] = "CODE39";
		BarcodeTypeEnum["PDF417"] = "PDF417";
		BarcodeTypeEnum["QRCODE"] = "QRCODE";
		BarcodeTypeEnum["CODE93"] = "CODE93";
		BarcodeTypeEnum["CODE128"] = "CODE128";
		return BarcodeTypeEnum;
	}({});
	BulkUserDataSetRecordActionFormActionEnum = /* @__PURE__ */ function(BulkUserDataSetRecordActionFormActionEnum) {
		BulkUserDataSetRecordActionFormActionEnum["Create"] = "create";
		BulkUserDataSetRecordActionFormActionEnum["Update"] = "update";
		BulkUserDataSetRecordActionFormActionEnum["Upsert"] = "upsert";
		BulkUserDataSetRecordActionFormActionEnum["Delete"] = "delete";
		return BulkUserDataSetRecordActionFormActionEnum;
	}({});
	BulkUserDataSetRecordResultActionEnum = /* @__PURE__ */ function(BulkUserDataSetRecordResultActionEnum) {
		BulkUserDataSetRecordResultActionEnum["Create"] = "create";
		BulkUserDataSetRecordResultActionEnum["Update"] = "update";
		BulkUserDataSetRecordResultActionEnum["Upsert"] = "upsert";
		BulkUserDataSetRecordResultActionEnum["Delete"] = "delete";
		return BulkUserDataSetRecordResultActionEnum;
	}({});
	BulkUserDataSetRecordResultResultEnum = /* @__PURE__ */ function(BulkUserDataSetRecordResultResultEnum) {
		BulkUserDataSetRecordResultResultEnum["Created"] = "created";
		BulkUserDataSetRecordResultResultEnum["Updated"] = "updated";
		BulkUserDataSetRecordResultResultEnum["Deleted"] = "deleted";
		BulkUserDataSetRecordResultResultEnum["NoChange"] = "no-change";
		BulkUserDataSetRecordResultResultEnum["Failure"] = "failure";
		return BulkUserDataSetRecordResultResultEnum;
	}({});
	CreateUserDataSetFormTypeEnum = /* @__PURE__ */ function(CreateUserDataSetFormTypeEnum) {
		CreateUserDataSetFormTypeEnum["Relation"] = "relation";
		CreateUserDataSetFormTypeEnum["Transaction"] = "transaction";
		CreateUserDataSetFormTypeEnum["Product"] = "product";
		CreateUserDataSetFormTypeEnum["Building"] = "building";
		CreateUserDataSetFormTypeEnum["PurchaseOrder"] = "purchase_order";
		return CreateUserDataSetFormTypeEnum;
	}({});
	GetFieldTypeEnum = /* @__PURE__ */ function(GetFieldTypeEnum) {
		GetFieldTypeEnum["Bool"] = "bool";
		GetFieldTypeEnum["String"] = "string";
		GetFieldTypeEnum["Uint"] = "uint";
		GetFieldTypeEnum["Int"] = "int";
		GetFieldTypeEnum["Int64"] = "int64";
		GetFieldTypeEnum["Float"] = "float";
		GetFieldTypeEnum["Float64"] = "float64";
		GetFieldTypeEnum["Array"] = "array";
		GetFieldTypeEnum["Map"] = "map";
		GetFieldTypeEnum["KeyValue"] = "key_value";
		GetFieldTypeEnum["Any"] = "any";
		return GetFieldTypeEnum;
	}({});
	GetFieldSubtypeTypeEnum = /* @__PURE__ */ function(GetFieldSubtypeTypeEnum) {
		GetFieldSubtypeTypeEnum["Bool"] = "bool";
		GetFieldSubtypeTypeEnum["String"] = "string";
		GetFieldSubtypeTypeEnum["Uint"] = "uint";
		GetFieldSubtypeTypeEnum["Int"] = "int";
		GetFieldSubtypeTypeEnum["Int64"] = "int64";
		GetFieldSubtypeTypeEnum["Float"] = "float";
		GetFieldSubtypeTypeEnum["Float64"] = "float64";
		GetFieldSubtypeTypeEnum["Array"] = "array";
		GetFieldSubtypeTypeEnum["Map"] = "map";
		GetFieldSubtypeTypeEnum["KeyValue"] = "key_value";
		GetFieldSubtypeTypeEnum["Any"] = "any";
		return GetFieldSubtypeTypeEnum;
	}({});
	ReceiptDocumentTypeEnum = /* @__PURE__ */ function(ReceiptDocumentTypeEnum) {
		ReceiptDocumentTypeEnum["Empty"] = "";
		ReceiptDocumentTypeEnum["Invoice"] = "invoice";
		ReceiptDocumentTypeEnum["Receipt"] = "receipt";
		ReceiptDocumentTypeEnum["BankTransaction"] = "bank_transaction";
		ReceiptDocumentTypeEnum["BankOverview"] = "bank_overview";
		ReceiptDocumentTypeEnum["Parking"] = "parking";
		ReceiptDocumentTypeEnum["Petrol"] = "petrol";
		ReceiptDocumentTypeEnum["Ticket"] = "ticket";
		ReceiptDocumentTypeEnum["BoardingPass"] = "boarding_pass";
		ReceiptDocumentTypeEnum["Other"] = "other";
		return ReceiptDocumentTypeEnum;
	}({});
	ReceiptInvoiceTypeEnum = /* @__PURE__ */ function(ReceiptInvoiceTypeEnum) {
		ReceiptInvoiceTypeEnum["Empty"] = "";
		ReceiptInvoiceTypeEnum["Invoice"] = "invoice";
		ReceiptInvoiceTypeEnum["CreditInvoice"] = "credit_invoice";
		return ReceiptInvoiceTypeEnum;
	}({});
	ReceiptPaymentmethodEnum = /* @__PURE__ */ function(ReceiptPaymentmethodEnum) {
		ReceiptPaymentmethodEnum["Empty"] = "";
		ReceiptPaymentmethodEnum["Cash"] = "cash";
		ReceiptPaymentmethodEnum["Creditcard"] = "creditcard";
		ReceiptPaymentmethodEnum["Pin"] = "pin";
		ReceiptPaymentmethodEnum["Bank"] = "bank";
		return ReceiptPaymentmethodEnum;
	}({});
}));
//#endregion
//#region src/domains/finance/third-party/klippa/klippa.model.ts
var BarcodeTypeEnumSchema, ReceiptDocumentTypeEnumSchema, ReceiptInvoiceTypeEnumSchema, ReceiptPaymentmethodEnumSchema, BarcodeSchema, MatchedKeywordSchema, ReceiptLineItemItemSchema, ReceiptLineItemSchema, MatchedLineItemItemSchema, ReceiptVATSchema, ReceiptSchema;
var init_klippa_model = __esmMin((() => {
	init_klippa();
	BarcodeTypeEnumSchema = Type.Enum(BarcodeTypeEnum, { $id: "BarcodeTypeEnum" });
	ReceiptDocumentTypeEnumSchema = Type.Enum(ReceiptDocumentTypeEnum, { $id: "ReceiptDocumentTypeEnum" });
	ReceiptInvoiceTypeEnumSchema = Type.Enum(ReceiptInvoiceTypeEnum, { $id: "ReceiptInvoiceTypeEnum" });
	ReceiptPaymentmethodEnumSchema = Type.Enum(ReceiptPaymentmethodEnum, { $id: "ReceiptPaymentmethodEnum" });
	BarcodeSchema = Type.Object({
		type: Type.Optional(BarcodeTypeEnumSchema),
		value: Type.Optional(Type.String())
	}, { $id: "Barcode" });
	MatchedKeywordSchema = Type.Object({
		count: Type.Optional(Type.Number()),
		id: Type.Optional(Type.String()),
		matches: Type.Optional(Type.Array(Type.String()))
	}, { $id: "MatchedKeyword" });
	ReceiptLineItemItemSchema = Type.Object({
		amount: Type.Optional(Type.Number()),
		amount_each: Type.Optional(Type.Number()),
		amount_ex_vat: Type.Optional(Type.Number()),
		description: Type.Optional(Type.String()),
		quantity: Type.Optional(Type.Number()),
		sku: Type.Optional(Type.String()),
		title: Type.Optional(Type.String()),
		vat_amount: Type.Optional(Type.Number()),
		vat_code: Type.Optional(Type.String()),
		vat_percentage: Type.Optional(Type.Number())
	});
	ReceiptLineItemSchema = Type.Object({
		description: Type.Optional(Type.String()),
		lineitems: Type.Optional(Type.Array(ReceiptLineItemItemSchema))
	}, { $id: "ReceiptLineItem" });
	MatchedLineItemItemSchema = Type.Object({
		id: Type.Optional(Type.String()),
		lineitems: Type.Optional(Type.Array(ReceiptLineItemItemSchema))
	}, { $id: "MatchedLineItemItem" });
	ReceiptVATSchema = Type.Object({
		amount: Type.Optional(Type.Number()),
		amount_excl_vat: Type.Optional(Type.Number()),
		amount_incl_excl_vat_estimated: Type.Optional(Type.Boolean()),
		amount_incl_vat: Type.Optional(Type.Number()),
		code: Type.Optional(Type.String()),
		percentage: Type.Optional(Type.Number())
	}, { $id: "ReceiptVAT" });
	ReceiptSchema = Type.Object({
		amount: Type.Optional(Type.Number()),
		amount_change: Type.Optional(Type.Number()),
		amountexvat: Type.Optional(Type.Number()),
		barcodes: Type.Optional(Type.Array(BarcodeSchema)),
		currency: Type.Optional(Type.String()),
		customer_address: Type.Optional(Type.String()),
		customer_bank_account_number: Type.Optional(Type.String()),
		customer_bank_account_number_bic: Type.Optional(Type.String()),
		customer_city: Type.Optional(Type.String()),
		customer_coc_number: Type.Optional(Type.String()),
		customer_country: Type.Optional(Type.String()),
		customer_email: Type.Optional(Type.String()),
		customer_house_number: Type.Optional(Type.String()),
		customer_municipality: Type.Optional(Type.String()),
		customer_name: Type.Optional(Type.String()),
		customer_number: Type.Optional(Type.String()),
		customer_phone: Type.Optional(Type.String()),
		customer_province: Type.Optional(Type.String()),
		customer_reference: Type.Optional(Type.String()),
		customer_street_name: Type.Optional(Type.String()),
		customer_vat_number: Type.Optional(Type.String()),
		customer_website: Type.Optional(Type.String()),
		customer_zipcode: Type.Optional(Type.String()),
		date: Type.Optional(Type.String()),
		document_subject: Type.Optional(Type.String()),
		document_type: Type.Optional(ReceiptDocumentTypeEnumSchema),
		hash: Type.Optional(Type.String()),
		hash_duplicate: Type.Optional(Type.Boolean()),
		invoice_number: Type.Optional(Type.String()),
		invoice_type: Type.Optional(ReceiptInvoiceTypeEnumSchema),
		lines: Type.Optional(Type.Array(ReceiptLineItemSchema)),
		matched_keywords: Type.Optional(Type.Array(MatchedKeywordSchema)),
		matched_lineitems: Type.Optional(Type.Array(MatchedLineItemItemSchema)),
		matched_purchase_order_id: Type.Optional(Type.String()),
		merchant_address: Type.Optional(Type.String()),
		merchant_bank_account_number: Type.Optional(Type.String()),
		merchant_bank_account_number_bic: Type.Optional(Type.String()),
		merchant_bank_domestic_account_number: Type.Optional(Type.String()),
		merchant_bank_domestic_bank_code: Type.Optional(Type.String()),
		merchant_chain_liability_bank_account_number: Type.Optional(Type.String()),
		merchant_city: Type.Optional(Type.String()),
		merchant_coc_number: Type.Optional(Type.String()),
		merchant_country: Type.Optional(Type.String()),
		merchant_country_code: Type.Optional(Type.String()),
		merchant_email: Type.Optional(Type.String()),
		merchant_house_number: Type.Optional(Type.String()),
		merchant_id: Type.Optional(Type.String()),
		merchant_main_activity_code: Type.Optional(Type.String()),
		merchant_municipality: Type.Optional(Type.String()),
		merchant_name: Type.Optional(Type.String()),
		merchant_phone: Type.Optional(Type.String()),
		merchant_province: Type.Optional(Type.String()),
		merchant_street_name: Type.Optional(Type.String()),
		merchant_vat_number: Type.Optional(Type.String()),
		merchant_website: Type.Optional(Type.String()),
		merchant_zipcode: Type.Optional(Type.String()),
		order_number: Type.Optional(Type.String()),
		package_number: Type.Optional(Type.String()),
		payment_auth_code: Type.Optional(Type.String()),
		payment_card_account_number: Type.Optional(Type.String()),
		payment_card_bank: Type.Optional(Type.String()),
		payment_card_issuer: Type.Optional(Type.String()),
		payment_card_number: Type.Optional(Type.String()),
		payment_due_date: Type.Optional(Type.String()),
		payment_slip_code: Type.Optional(Type.String()),
		payment_slip_customer_number: Type.Optional(Type.String()),
		payment_slip_reference_number: Type.Optional(Type.String()),
		paymentmethod: Type.Optional(ReceiptPaymentmethodEnumSchema),
		purchasedate: Type.Optional(Type.String()),
		purchasetime: Type.Optional(Type.String()),
		raw_text: Type.Optional(Type.String()),
		receipt_number: Type.Optional(Type.String()),
		server: Type.Optional(Type.String()),
		shop_number: Type.Optional(Type.String()),
		table_group: Type.Optional(Type.String()),
		table_number: Type.Optional(Type.String()),
		terminal_number: Type.Optional(Type.String()),
		transaction_number: Type.Optional(Type.String()),
		transaction_reference: Type.Optional(Type.String()),
		vat_context: Type.Optional(Type.String()),
		vatamount: Type.Optional(Type.Number()),
		vatitems: Type.Optional(Type.Array(ReceiptVATSchema))
	}, { $id: "Receipt" });
}));
//#endregion
//#region src/domains/finance/third-party/einvoice/einvoice.model.ts
var EInvoiceItemSchema, EInvoiceTaxBreakdownSchema, EInvoicePartyToSchema, EInvoicePartyFromSchema, EInvoicePaymentInformationSchema, EInvoiceBusinessReferencesSchema, EInvoiceMetadataExtensionsSchema, EInvoiceMetadataSchema, EInvoicePayeeFinancialAccountSchema, EInvoicePaymentMeansSchema, EInvoiceRawDataSchema, EInvoiceSchema;
var init_einvoice_model = __esmMin((() => {
	EInvoiceItemSchema = Type.Object({
		vatPercentage: Type.Optional(Type.Number()),
		unitQuantity: Type.Optional(Type.Number()),
		unitNetPrice: Type.Optional(Type.Number())
	}, { $id: "EInvoiceItem" });
	EInvoiceTaxBreakdownSchema = Type.Object({
		taxAmount: Type.Optional(Type.Number()),
		netAmount: Type.Optional(Type.Number())
	}, { $id: "EInvoiceTaxBreakdown" });
	EInvoicePartyToSchema = Type.Object({
		name: Type.Optional(Type.String()),
		email: Type.Optional(Type.String()),
		address: Type.Optional(Type.Any())
	}, { $id: "EInvoicePartyTo" });
	EInvoicePartyFromSchema = Type.Object({
		name: Type.Optional(Type.String()),
		email: Type.Optional(Type.String()),
		address: Type.Optional(Type.Any())
	}, { $id: "EInvoicePartyFrom" });
	EInvoicePaymentInformationSchema = Type.Object({ iban: Type.Optional(Type.String()) }, { $id: "EInvoicePaymentInformation" });
	EInvoiceBusinessReferencesSchema = Type.Object({
		buyerReference: Type.Optional(Type.String()),
		orderReference: Type.Optional(Type.String())
	}, { $id: "EInvoiceBusinessReferences" });
	EInvoiceMetadataExtensionsSchema = Type.Object({
		paymentInformation: Type.Optional(EInvoicePaymentInformationSchema),
		businessReferences: Type.Optional(EInvoiceBusinessReferencesSchema)
	}, { $id: "EInvoiceMetadataExtensions" });
	EInvoiceMetadataSchema = Type.Object({ extensions: Type.Optional(EInvoiceMetadataExtensionsSchema) }, { $id: "EInvoiceMetadata" });
	EInvoicePayeeFinancialAccountSchema = Type.Object({ id: Type.Optional(Type.Union([Type.String(), Type.Object({ value: Type.Optional(Type.String()) })])) }, { $id: "EInvoicePayeeFinancialAccount" });
	EInvoicePaymentMeansSchema = Type.Object({ payeeFinancialAccount: Type.Optional(EInvoicePayeeFinancialAccountSchema) }, { $id: "EInvoicePaymentMeans" });
	EInvoiceRawDataSchema = Type.Object({ xmlString: Type.Optional(Type.String()) }, { $id: "EInvoiceRawData" });
	EInvoiceSchema = Type.Object({
		id: Type.Optional(Type.String()),
		accountingDocId: Type.Optional(Type.String()),
		accountingDocType: Type.Optional(Type.String()),
		date: Type.Optional(Type.Number()),
		issueDate: Type.Optional(Type.Number()),
		dueDate: Type.Optional(Type.Number()),
		dueInDays: Type.Optional(Type.Number()),
		currency: Type.Optional(Type.String()),
		amount: Type.Optional(Type.Number()),
		taxInclusiveAmount: Type.Optional(Type.Number()),
		payableAmount: Type.Optional(Type.Number()),
		reverseCharge: Type.Optional(Type.Boolean()),
		items: Type.Optional(Type.Array(EInvoiceItemSchema)),
		taxBreakdown: Type.Optional(Type.Array(EInvoiceTaxBreakdownSchema)),
		from: Type.Optional(EInvoicePartyFromSchema),
		to: Type.Optional(EInvoicePartyToSchema),
		subject: Type.Optional(Type.String()),
		note: Type.Optional(Type.String()),
		reference: Type.Optional(Type.String()),
		iban: Type.Optional(Type.String()),
		paymentMeans: Type.Optional(EInvoicePaymentMeansSchema),
		metadata: Type.Optional(EInvoiceMetadataSchema),
		xmlString: Type.Optional(Type.String()),
		rawData: Type.Optional(EInvoiceRawDataSchema)
	}, { $id: "EInvoice" });
}));
//#endregion
//#region src/domains/finance/third-party/einvoice/index.ts
var init_einvoice = __esmMin((() => {
	init_einvoice_model();
}));
//#endregion
//#region src/domains/finance/invoice/invoice.model.ts
var CurrencySchema, VatClassSchema, InvoiceTypeSchema, DebtAllocationSchema, CostTypesSchema, InvoiceStatesSchema, InvoiceSourceSchema, CostSplitItemSchema, CostSplitSchema, BaseInvoiceSchema, InvoiceSchema, InvoiceFetchType, EXPORTABLE_INVOICE_FETCH_TYPES, EXPORTABLE_INVOICE_STATES, EXTERNAL_APP_EXCLUDED_INVOICE_STATES, PAID_INVOICE_STATES;
var init_invoice_model = __esmMin((() => {
	init_lib();
	init_common();
	init_klippa_model();
	init_einvoice();
	init_invoice_base();
	CurrencySchema = TEnum(Currency, { $id: "Currency" });
	VatClassSchema = TEnum(InvoiceVATClass, { $id: "VatClass" });
	InvoiceTypeSchema = TEnum(InvoiceType, { $id: "InvoiceType" });
	DebtAllocationSchema = TEnum(DebtAllocation, { $id: "DebtAllocation" });
	CostTypesSchema = TEnum(CostTypes, { $id: "CostTypes" });
	InvoiceStatesSchema = TEnum(InvoiceStates, { $id: "InvoiceStates" });
	InvoiceSourceSchema = TEnum(InvoiceSource, { $id: "InvoiceSource" });
	CostSplitItemSchema = Type.Object({
		debtorAccountingId: Type.Number(),
		estateId: Type.Optional(Type.Number()),
		mfhId: Type.Optional(Type.Number()),
		mfhPortfolioId: Type.Optional(Type.Number()),
		mfhBuildingId: Type.Optional(Type.Number()),
		contractId: Type.Optional(Type.Number()),
		costType: Type.Ref(CostTypesSchema),
		costCenter: Type.Optional(Type.String()),
		amount: Type.Number(),
		doubleBooking: Type.Optional(Type.Boolean()),
		comment: Type.Optional(Type.String())
	});
	CostSplitSchema = Type.Object({
		list: Type.Array(CostSplitItemSchema),
		inMigration: Type.Optional(Type.Boolean()),
		migratedBy: Type.Optional(Type.String()),
		migratedAt: Type.Optional(StringDateSchema)
	});
	BaseInvoiceSchema = Type.Object({
		invoiceId: Type.Number(),
		estateId: Type.Optional(Type.Number()),
		mfhId: Type.Optional(Type.Number()),
		mfhPortfolioId: Type.Optional(Type.Number()),
		mfhBuildingId: Type.Optional(Type.Number()),
		contractId: Type.Optional(TNullable(Type.Number())),
		subscriptionId: Type.Optional(Type.Number()),
		investorInfoId: Type.Optional(Type.Number()),
		rentTenancyId: Type.Optional(Type.Number()),
		assignee: Type.Optional(Type.String()),
		amount: Type.Optional(Type.Number()),
		currency: CurrencySchema,
		payoutAmount: Type.Optional(Type.Number()),
		iban: Type.Optional(TNullable(Type.String())),
		skipPayment: Type.Boolean(),
		skipExternalReview: Type.Boolean(),
		constructionPlanCostOvershootPercentage: Type.Optional(Type.Number()),
		creditorAccountingId: Type.Optional(Type.Number()),
		debtorAccountingId: Type.Optional(Type.Number()),
		reference: Type.Optional(Type.String()),
		invoiceNumber: Type.Optional(Type.String()),
		vat: Type.Optional(Type.Number()),
		vatClass: Type.Optional(VatClassSchema),
		invoiceType: Type.Optional(InvoiceTypeSchema),
		skonto: Type.Optional(Type.Number()),
		note: Type.Optional(Type.String()),
		rejectionReason: Type.Optional(Type.String()),
		costSplit: Type.Optional(CostSplitSchema),
		exportError: Type.Optional(Type.String()),
		loanDrawdownId: Type.Optional(TNullable(Type.Number())),
		isReimbursed: Type.Boolean(),
		isSkonto: Type.Boolean(),
		isDispute: Type.Boolean(),
		isUrgent: Type.Boolean(),
		isCreditCard: Type.Boolean(),
		isPartial: Type.Boolean(),
		isDirectDebit: Type.Boolean(),
		duplicateOf: Type.Optional(TNullable(Type.Number())),
		debtAllocation: Type.Optional(TNullable(DebtAllocationSchema)),
		parentId: Type.Optional(TNullable(Type.Number())),
		regionId: Type.Optional(Type.Number()),
		rawData: TNullable(Type.Union([
			ReceiptSchema,
			EInvoiceSchema,
			TAnyDict
		])),
		shortUuid: Type.String(),
		assignedAt: StringDateSchema,
		authorizedAt: StringDateSchema,
		approvedAt: StringDateSchema,
		authorizedBy: Type.Optional(Type.String()),
		approvedBy: Type.Optional(Type.String()),
		uploadedById: Type.Optional(Type.String()),
		resetAt: StringDateSchema,
		resetBy: Type.Optional(Type.String()),
		seniorDebtAmount: Type.Number(),
		juniorDebtAmount: Type.Number(),
		costType: Type.Optional(Type.Ref(CostTypesSchema)),
		costCenter: Type.Optional(Type.String()),
		state: InvoiceStatesSchema,
		source: InvoiceSourceSchema,
		receiptDate: Type.Optional(StringDateSchema),
		isRetrospective: Type.Optional(Type.Boolean()),
		invoiceDate: Type.Optional(StringDateSchema),
		dueDate: Type.Optional(StringDateSchema),
		paidAt: Type.Optional(StringDateSchema),
		bookedAt: Type.Optional(StringDateSchema)
	}, { $id: "BaseInvoiceSchema" });
	InvoiceSchema = Type.Intersect([BaseInvoiceSchema, BaseEntityAttributesSchema], { $id: "InvoiceSchema" });
	InvoiceFetchType = /* @__PURE__ */ function(InvoiceFetchType) {
		InvoiceFetchType["All"] = "All";
		InvoiceFetchType["ExportableInvoicesNetSuite"] = "ExportableInvoicesNetSuite";
		InvoiceFetchType["ExportableInvoices"] = "ExportableInvoices";
		InvoiceFetchType["ExportableSevInvoices"] = "ExportableSevInvoices";
		InvoiceFetchType["TransferRecurrentPayments"] = "TransferRecurrentPayments";
		InvoiceFetchType["ExternalAppInvoicesForExport"] = "ExternalAppInvoicesForExport";
		return InvoiceFetchType;
	}({});
	EXPORTABLE_INVOICE_FETCH_TYPES = [
		"ExportableInvoicesNetSuite",
		"ExportableInvoices",
		"ExportableSevInvoices",
		"TransferRecurrentPayments"
	];
	EXPORTABLE_INVOICE_STATES = ["ReadyForBooking", "ManuallyPaid"];
	EXTERNAL_APP_EXCLUDED_INVOICE_STATES = [
		"New",
		"FailedToExport",
		"Rejected",
		"Duplicated"
	];
	PAID_INVOICE_STATES = ["Paid", "ManuallyPaid"];
}));
//#endregion
//#region src/domains/finance/invoice/invoice.helpers.ts
function getInvoiceNetAmountAfterVat(invoice) {
	return new Decimal(invoice.payoutAmount ?? invoice.amount ?? 0).div(new Decimal(invoice.vat ?? 0).plus(1));
}
/**
* Net total used as the basis for consolidated invoice cost-split rows (amounts stored per split are net).
* Rounded to 2 decimals for cent alignment with UI and validation.
*/
function getConsolidatedCostSplitNetTotal(invoice) {
	return getInvoiceNetAmountAfterVat(invoice).toDecimalPlaces(2, Decimal.ROUND_HALF_UP).toNumber();
}
/**
* Gross (incl. VAT) for one split line given its net amount and the invoice VAT rate (decimal, e.g. 0.19).
* When VAT is missing or invalid, returns the net amount (gross = net).
*/
function getCostSplitGrossFromNet(netAmount, vatRate) {
	if (vatRate == null || !Number.isFinite(vatRate) || vatRate < 0) return netAmount;
	return new Decimal(netAmount).times(new Decimal(vatRate).plus(1)).toDecimalPlaces(2, Decimal.ROUND_HALF_UP).toNumber();
}
var getSepaRemittanceInfo, makeSEPAId, getAllInternalInvoiceStates, extractCompanyOrContactRecordName, getExternalAppAllowedInvoiceStates;
var init_invoice_helpers = __esmMin((() => {
	init_invoice_base();
	init_invoice_model();
	getSepaRemittanceInfo = (invoice) => `${unidecode(invoice.reference ?? "").replace(/_/g, " ")}`;
	makeSEPAId = (id) => `${dayjs().format("YYYYMMDDHHmmssSSS")}-${id}`.substring(0, 29);
	getAllInternalInvoiceStates = (externalInvoiceStates) => {
		return Object.entries(internalToExternalInvoiceStatesMap).filter(([, value]) => externalInvoiceStates.includes(value)).map(([key]) => key);
	};
	extractCompanyOrContactRecordName = (owner) => owner?.company ? owner?.company?.shortName || owner?.company?.name : owner?.contact ? `${owner?.contact.firstname} ${owner.contact.lastname}` : "";
	getExternalAppAllowedInvoiceStates = () => Object.values(InvoiceStates).filter((state) => !EXTERNAL_APP_EXCLUDED_INVOICE_STATES.includes(state));
}));
//#endregion
//#region src/domains/finance/invoice/invoice.class.ts
var Invoice, toCents;
var init_invoice_class = __esmMin((() => {
	init_base();
	init_errors();
	init_user_model();
	init_common();
	init_invoice_base();
	init_invoice_helpers();
	Invoice = class Invoice extends BaseClassAttributes {
		invoiceId;
		estateId;
		mfhId;
		mfhPortfolioId;
		mfhBuildingId;
		subscriptionId;
		investorInfoId;
		rentTenancyId;
		assignee;
		/**
		* Original Amount specified on invoice
		* @type {number}
		*/
		amount;
		currency;
		/**
		* Amount to be paid now
		* @type {number}
		*/
		payoutAmount;
		iban;
		skipPayment;
		isDirectDebit;
		skipExternalReview;
		/**
		* Free text name + legacy behavior
		* Can't be deprecated since OCR can return some records and we should not pre-create record for such cases
		* @type {string}
		*/
		creditor;
		creditorAccountingId;
		debtorAccountingId;
		reference;
		invoiceNumber;
		vat;
		vatClass;
		netsuite;
		invoiceType;
		skonto;
		note;
		rejectionReason;
		costSplit;
		exportError;
		loanDrawdownId;
		isReimbursed;
		isSkonto;
		isDispute;
		isUrgent;
		isCreditCard;
		isPartial;
		duplicateOf;
		debtAllocation;
		contractId;
		parentId;
		regionId;
		rawData;
		shortUuid;
		assignedAt;
		authorizedAt;
		approvedAt;
		authorizedBy;
		approvedBy;
		uploadedById;
		resetAt;
		resetBy;
		/**
		* How much of senior debt was used to pay this invoice
		* @type {number}
		*/
		seniorDebtAmount;
		/**
		* How much of junior amount was used to pay
		* @type {number}
		*/
		juniorDebtAmount;
		costType;
		costCenter;
		state;
		source;
		receiptDate;
		isRetrospective;
		invoiceDate;
		dueDate;
		paidAt;
		bookedAt;
		estate;
		mfh;
		mfhPortfolio;
		mfhBuilding;
		reviewProcess;
		drawdown;
		files;
		notes;
		region;
		subscription;
		permanentSubscription;
		parentInvoice;
		childInvoices;
		creditorAccounting;
		debtorAccounting;
		contract;
		static APPROVED_AUTOMATICALLY = "system";
		/**
		* Returns the cost split list. costSplit is always null or object.
		*/
		getCostSplitList() {
			return Invoice.getCostSplitList(this);
		}
		/**
		* Returns the cost split list from an invoice or costSplit holder. costSplit is always null or object.
		*/
		static getCostSplitList(invoice) {
			return invoice?.costSplit?.list ?? [];
		}
		constructor(invoice) {
			super(invoice);
			Object.assign(this, invoice);
		}
		get isAssigned() {
			return this.state === "Assigned";
		}
		get isNew() {
			return this.state === "New";
		}
		get isEditable() {
			return [
				"New",
				"Assigned",
				"WaitingForAuthorization",
				"ManualReview"
			].includes(this.state);
		}
		get isReadyForDrawdown() {
			return ["ReadyForDrawdown"].includes(this.state);
		}
		get isPaid() {
			return !!this.paidAt;
		}
		get isReadyForExport() {
			return !this.bookedAt && !!this.authorizedAt && !!this.debtorAccountingId && !!this.creditorAccountingId && (this.invoiceType === "RecurrentPayment" || !!this?.files?.length);
		}
		get debtorName() {
			if (!this.debtorAccounting?.company) throw new InvariantError("Debtor Accounting record is required when getting debtorName");
			return this.debtorAccounting?.company.name;
		}
		get isDeletable() {
			return [
				"New",
				"Duplicated",
				"Rejected"
			].includes(this.state);
		}
		get creditorName() {
			if (!this.creditorAccounting) throw new InvariantError("Creditor Accounting record is required when getting creditorName");
			if (!this.creditorAccounting?.company && !this.creditorAccounting?.contact) throw new InvariantError("Either company or contact is missing for creditor accounting record");
			if (this.creditorAccounting.company) return this.creditorAccounting.company.name;
			return `${this.creditorAccounting.contact?.fullname}`;
		}
		get regionName() {
			return this.region?.regionName ?? this.estate?.location?.region?.regionName ?? "";
		}
		static getDefaultDueDate(createdDate) {
			return dayjs(createdDate).add(14, "day").toDate();
		}
		static createFromInvoice(invoice, changeableFields) {
			return new Invoice({
				...invoice,
				...changeableFields || {}
			});
		}
		static reviewableInvoiceStatesForUser(userRole) {
			switch (userRole) {
				case "invoice-assignment": return ["Assigned"];
				case "invoice-supervisor": return ["Assigned", "WaitingForAuthorization"];
				default: return [];
			}
		}
		static createFromDocument(document, source, uploadedById) {
			return new Invoice({
				costType: void 0,
				source,
				uploadedById,
				files: [{ document }],
				state: "New",
				isReimbursed: false,
				isDispute: false,
				isUrgent: false,
				isSkonto: false,
				rawData: {}
			});
		}
		static createFromReceipt(receipt, document, source, uploadedById) {
			const amount = receipt.amount ? receipt.amount / 100 : receipt.amount;
			const invoiceReference = receipt.customer_reference || receipt.payment_slip_reference_number;
			const invoiceNumber = receipt.invoice_number;
			return new Invoice({
				costType: void 0,
				amount,
				source,
				uploadedById,
				reference: invoiceReference?.replace(/\s+/g, ""),
				creditor: receipt.merchant_name,
				invoiceDate: receipt.date ? new Date(receipt.date) : /* @__PURE__ */ new Date(),
				dueDate: receipt.payment_due_date || Invoice.getDefaultDueDate(/* @__PURE__ */ new Date()),
				files: [{ document }],
				iban: receipt.merchant_bank_account_number?.replace(/\s/g, ""),
				invoiceNumber: invoiceNumber?.replace(/\s+/g, ""),
				vat: Invoice.getVat(receipt),
				state: "New",
				isReimbursed: false,
				isDispute: false,
				isUrgent: false,
				isSkonto: false,
				isCreditCard: receipt.paymentmethod === "creditcard",
				rawData: receipt
			});
		}
		static createFromList(invoices) {
			if (!invoices) return [];
			return invoices.map((invoice) => new Invoice(invoice));
		}
		static getVat(receipt) {
			return receipt.vatitems?.reduce((vat, currentValue) => {
				if (!currentValue.percentage) return vat;
				vat = currentValue.percentage / 1e4;
				return vat;
			}, void 0);
		}
		getOriginalInvoicePdfFile() {
			if (!this.files || this.files.length === 0) return null;
			return this.files.sort((a, b) => (a?.document?.documentId ?? 0) - (b?.document?.documentId ?? 0)).find((file) => file.document?.mimeType === "application/pdf") ?? null;
		}
		/**
		* Fallback XML parsing helper to extract values when parsing library returns empty results
		* Parses raw XML string to extract IBAN, VAT, invoice number, and amount using regex
		* Works in both Node.js and browser environments
		*/
		static parseXmlFallback(xmlString) {
			if (!xmlString || typeof xmlString !== "string") return {};
			try {
				const result = {};
				let cleanedXmlString = xmlString.replace(/<ram:ID[^>]*>[^<]*(?:eu:en16931|urn:)[^<]*<\/ram:ID>/gi, "");
				cleanedXmlString = cleanedXmlString.replace(/<ID[^>]*>[^<]*(?:eu:en16931|urn:)[^<]*<\/ID>/gi, "");
				const exchangedDocumentBlockMatch = cleanedXmlString.match(/<rsm:ExchangedDocument[^>]*>([\s\S]*?)<\/rsm:ExchangedDocument>/i) || cleanedXmlString.match(/<ExchangedDocument[^>]*>([\s\S]*?)<\/ExchangedDocument>/i);
				let invoiceId;
				if (exchangedDocumentBlockMatch && exchangedDocumentBlockMatch[1]) {
					const exchangedDocumentContent = exchangedDocumentBlockMatch[1];
					const idMatch = exchangedDocumentContent.match(/^\s*<ram:ID[^>]*>([^<]+)<\/ram:ID>/im) || exchangedDocumentContent.match(/^\s*<ID[^>]*>([^<]+)<\/ID>/im);
					if (idMatch && idMatch[1]) invoiceId = idMatch[1].trim();
					else {
						const fallbackMatch = exchangedDocumentContent.match(/<ram:ID[^>]*>([^<]+)<\/ram:ID>/i) || exchangedDocumentContent.match(/<ID[^>]*>([^<]+)<\/ID>/i);
						if (fallbackMatch && fallbackMatch[1]) invoiceId = fallbackMatch[1].trim();
					}
				} else {
					const exchangedDocumentMatch = cleanedXmlString.match(/<rsm:ExchangedDocument[^>]*>\s*<ram:ID[^>]*>([^<]+)<\/ram:ID>/i) || cleanedXmlString.match(/<ExchangedDocument[^>]*>\s*<ID[^>]*>([^<]+)<\/ID>/i);
					if (exchangedDocumentMatch && exchangedDocumentMatch[1]) invoiceId = exchangedDocumentMatch[1].trim();
				}
				if (invoiceId) result.invoiceNumber = invoiceId;
				else {
					const invoiceIdMatch = cleanedXmlString.match(/<ram:ID[^>]*>([^<]+)<\/ram:ID>/i) || cleanedXmlString.match(/<ID[^>]*>([^<]+)<\/ID>/i);
					if (invoiceIdMatch && invoiceIdMatch[1]) result.invoiceNumber = invoiceIdMatch[1].trim();
				}
				const ibanMatch = xmlString.match(/<ram:IBANID[^>]*>([^<]+)<\/ram:IBANID>/i) || xmlString.match(/<IBANID[^>]*>([^<]+)<\/IBANID>/i);
				if (ibanMatch && ibanMatch[1]) {
					const ibanValue = ibanMatch[1].trim();
					if (ibanValue) result.iban = ibanValue.replace(/\s/g, "");
				}
				const vatRateMatch = xmlString.match(/<ram:RateApplicablePercent[^>]*>([^<]+)<\/ram:RateApplicablePercent>/i) || xmlString.match(/<RateApplicablePercent[^>]*>([^<]+)<\/RateApplicablePercent>/i);
				if (vatRateMatch && vatRateMatch[1]) {
					const vatRateText = vatRateMatch[1].trim();
					const vatRate = parseFloat(vatRateText);
					if (!Number.isNaN(vatRate)) {
						result.vat = vatRate / 100;
						result.vatClass = Object.entries(InvoiceVATClassValue).find(([_, value]) => Math.abs(value - result.vat) < .001)?.[0];
					}
				}
				const grandTotalMatch = xmlString.match(/<ram:GrandTotalAmount[^>]*>([^<]+)<\/ram:GrandTotalAmount>/i) || xmlString.match(/<GrandTotalAmount[^>]*>([^<]+)<\/GrandTotalAmount>/i);
				const duePayableMatch = xmlString.match(/<ram:DuePayableAmount[^>]*>([^<]+)<\/ram:DuePayableAmount>/i) || xmlString.match(/<DuePayableAmount[^>]*>([^<]+)<\/DuePayableAmount>/i);
				if (grandTotalMatch && grandTotalMatch[1]) {
					const amountText = grandTotalMatch[1].trim();
					const amountValue = parseFloat(amountText);
					if (!Number.isNaN(amountValue)) result.amount = amountValue;
				} else if (duePayableMatch && duePayableMatch[1]) {
					const amountText = duePayableMatch[1].trim();
					const amountValue = parseFloat(amountText);
					if (!Number.isNaN(amountValue)) result.amount = amountValue;
				}
				const buyerReferenceMatch = xmlString.match(/<ram:BuyerReference[^>]*>([^<]+)<\/ram:BuyerReference>/i) || xmlString.match(/<BuyerReference[^>]*>([^<]+)<\/BuyerReference>/i);
				const orderReferenceMatch = xmlString.match(/<ram:OrderReference[^>]*>([^<]+)<\/ram:OrderReference>/i) || xmlString.match(/<OrderReference[^>]*>([^<]+)<\/OrderReference>/i);
				if (orderReferenceMatch && orderReferenceMatch[1]) {
					const referenceValue = orderReferenceMatch[1].trim();
					if (referenceValue) result.reference = referenceValue;
				} else if (buyerReferenceMatch && buyerReferenceMatch[1]) {
					const referenceValue = buyerReferenceMatch[1].trim();
					if (referenceValue) result.reference = referenceValue;
				}
				return result;
			} catch (error) {
				return {};
			}
		}
		/**
		* Creates an Invoice from an EInvoice (XML-based electronic invoice)
		* @param einvoice - Domain IEInvoice interface
		* @param document - Document associated with the invoice
		* @param source - Source of the invoice
		* @param uploadedById - Optional user ID who uploaded the invoice
		* @param xmlContent - Optional raw XML content for fallback parsing when parsed values are missing
		*/
		static createFromEInvoice(einvoice, document, source, uploadedById, xmlContent) {
			const invoiceDate = einvoice.date ? new Date(einvoice.date) : einvoice.issueDate ? new Date(einvoice.issueDate) : /* @__PURE__ */ new Date();
			const xmlString = xmlContent || einvoice.xmlString || einvoice.rawData?.xmlString;
			const xmlFallback = Invoice.parseXmlFallback(xmlString);
			let invoiceNumber = einvoice.accountingDocId || einvoice.id;
			const dateString = String(einvoice.date);
			if (String(einvoice.accountingDocId).includes(dateString)) invoiceNumber = xmlFallback.invoiceNumber || einvoice.accountingDocId || einvoice.id;
			let dueDate;
			if (einvoice.dueInDays && invoiceDate) dueDate = dayjs(invoiceDate).add(einvoice.dueInDays, "day").toDate();
			else if (einvoice.dueDate) dueDate = new Date(einvoice.dueDate);
			else dueDate = Invoice.getDefaultDueDate(invoiceDate);
			const currency = einvoice.currency && Object.values(Currency).includes(einvoice.currency) ? einvoice.currency : "EUR";
			let vat;
			if (einvoice.items && Array.isArray(einvoice.items) && einvoice.items.length > 0) {
				const vatPercentage = einvoice.items[0]?.vatPercentage;
				if (typeof vatPercentage === "number") vat = vatPercentage / 100;
			}
			let amount;
			if (einvoice.taxInclusiveAmount !== void 0) amount = einvoice.taxInclusiveAmount;
			else if (einvoice.payableAmount !== void 0) amount = einvoice.payableAmount;
			else if (einvoice.amount !== void 0) amount = einvoice.amount;
			else if (einvoice.items && Array.isArray(einvoice.items) && einvoice.items.length > 0) {
				const netAmount = einvoice.items.reduce((sum, item) => {
					return sum + (item.unitQuantity || 0) * (item.unitNetPrice || 0);
				}, 0);
				if (vat !== void 0 && typeof vat === "number") amount = netAmount * (1 + vat);
				else amount = netAmount;
			}
			if (!vat && xmlFallback.vat !== void 0) vat = xmlFallback.vat;
			if (!amount && xmlFallback.amount !== void 0) amount = xmlFallback.amount;
			const creditor = einvoice.from?.name;
			let iban;
			if (einvoice.metadata?.extensions?.paymentInformation?.iban) iban = einvoice.metadata.extensions.paymentInformation.iban;
			else if (einvoice.metadata?.paymentInformation?.iban) iban = einvoice.metadata.paymentInformation.iban;
			else if (einvoice.paymentMeans?.payeeFinancialAccount?.id) {
				const accountId = einvoice.paymentMeans.payeeFinancialAccount.id;
				if (typeof accountId === "string") iban = accountId;
				else if (accountId?.value) iban = accountId.value;
			} else if (einvoice.iban) iban = einvoice.iban;
			if ((!iban || iban.trim() === "") && xmlFallback.iban) iban = xmlFallback.iban;
			iban = iban?.replace(/\s/g, "");
			let vatClass;
			if (einvoice.reverseCharge === true) vatClass = "ReverseCharge";
			else if (typeof vat === "number") vatClass = Object.entries(InvoiceVATClassValue).find(([_, value]) => Math.abs(value - vat) < .001)?.[0];
			if (!vatClass && xmlFallback.vatClass) vatClass = xmlFallback.vatClass;
			const note = einvoice.subject || einvoice.note;
			const reference = einvoice.metadata?.extensions?.businessReferences?.buyerReference || einvoice.metadata?.extensions?.businessReferences?.orderReference || einvoice.metadata?.businessReferences?.buyerReference || einvoice.metadata?.businessReferences?.orderReference || einvoice.reference;
			let invoiceType;
			if (einvoice.accountingDocType) {
				const docType = einvoice.accountingDocType.toLowerCase();
				if (docType === "creditnote" || docType === "credit-note") invoiceType = "CreditNote";
				else if (docType === "invoice" || docType === "debitnote" || docType === "debit-note") invoiceType = "Normal";
			}
			return new Invoice({
				costType: void 0,
				amount,
				currency,
				source,
				uploadedById,
				reference: reference?.replace(/\s+/g, ""),
				creditor,
				invoiceDate,
				dueDate,
				iban,
				invoiceNumber: invoiceNumber?.replace(/\s+/g, ""),
				vat,
				vatClass,
				invoiceType,
				note,
				state: "New",
				isReimbursed: false,
				isDispute: false,
				isUrgent: false,
				isSkonto: false,
				isCreditCard: false,
				rawData: einvoice
			});
		}
		hasCompleteData() {
			return !!(this.amount && this.creditorAccountingId && this.debtorAccountingId && this.dueDate && this.iban && this.reference && this.invoiceNumber);
		}
		totalAmount() {
			let baseAmount = this.amount || 0;
			if (this.skonto && this.skonto > 0 && this.isSkonto) baseAmount *= 1 - this.skonto;
			return this.childInvoices?.reduce((acc, childInvoice) => acc + (childInvoice.amount || 0), baseAmount) || baseAmount;
		}
		generateUuid() {
			this.shortUuid = `${this.invoiceNumber} CID_${this.invoiceId}`;
		}
		deleteUuid() {
			this.shortUuid = "";
		}
		dataValidForTransition(event) {
			const dataPresent = (event === "Assign" ? true : !!this.costType) && !!this.amount && !!this.payoutAmount && !!this.assignee && (!!this.iban || this.skipPayment);
			const amountMakeSense = this.amount >= this.payoutAmount;
			return dataPresent && amountMakeSense;
		}
		getEntityAttribution() {
			if (this.estateId) return "estate";
			if (this.mfhBuildingId) return "mfh-building";
			if (this.mfhPortfolioId) return "mfh-portfolio";
			if (this.mfhId) return "mfh";
			return "invoice";
		}
		static isEntityRequiredForCostType(costType) {
			if (!costType) return false;
			return !costTypesGrouped.Reneo.ReneoOverheadCosts.includes(costType) && !costTypesGrouped.RetailBusinessLine.RetailLivingCosts.includes(costType) && !["PropertyValuation", "PropertyRelatedExpenses"].includes(costType) && !costTypesGrouped.InstitutionalBusinessLine.InstitutionalCostsCorporate.includes(costType);
		}
		validateCostSplitItems(list) {
			if (this.invoiceType !== "Consolidated" || this.isNew) return true;
			if (!list || list.length === 0) return false;
			if (!list.every((split, index) => this.isCostSplitEntryComplete(split, index))) return false;
			const invoiceNetTotal = getConsolidatedCostSplitNetTotal(this);
			const invoiceNetTotalCents = toCents(invoiceNetTotal);
			return list.reduce((sum, split) => {
				if (split.doubleBooking) return sum;
				return sum + (typeof split.amount === "number" ? toCents(split.amount) : 0);
			}, 0) === invoiceNetTotalCents;
		}
		isCostSplitEntryComplete(entry, index) {
			const hasAttachedEntity = (entry) => {
				return typeof entry?.estateId === "number" || typeof entry?.mfhId === "number" || typeof entry?.mfhPortfolioId === "number" || typeof entry?.mfhBuildingId === "number";
			};
			const hasAmount = typeof entry?.amount === "number" && !Number.isNaN(entry.amount) && entry.amount >= 0;
			const hasDebtor = typeof entry?.debtorAccountingId === "number";
			const hasEntity = hasAttachedEntity(entry) || !Invoice.isEntityRequiredForCostType(entry?.costType ?? null);
			const seqNumber = index + 1;
			if (!hasDebtor) throw new Error(`Cost split ${seqNumber} is missing debtor`);
			if (!hasEntity) throw new Error(`Cost split ${seqNumber} must have at least one entity (unit, asset, portfolio, or building)`);
			if (!entry?.costType) throw new Error(`Cost split ${seqNumber} is missing costType`);
			if (!hasAmount) throw new Error(`Cost split ${seqNumber} is missing or has an invalid amount`);
			return true;
		}
		toRequest() {
			return {
				invoiceId: this.invoiceId,
				estateId: this.estateId,
				mfhId: this.mfhId,
				mfhPortfolioId: this.mfhPortfolioId,
				mfhBuildingId: this.mfhBuildingId,
				amount: this.amount,
				iban: !this.skipPayment ? this.iban : null,
				creditor: this.creditor,
				creditorAccountingId: this.creditorAccountingId,
				skipPayment: this.skipPayment,
				skipExternalReview: this.skipExternalReview,
				debtorAccountingId: this.debtorAccountingId,
				reference: this.reference,
				note: this.note,
				rejectionReason: this.rejectionReason,
				loanDrawdownId: this.loanDrawdownId,
				source: this.source,
				invoiceDate: this.invoiceDate,
				dueDate: this.dueDate,
				costType: this.costType,
				costCenter: this.costCenter,
				costSplit: this.costSplit,
				bookedAt: this.bookedAt,
				isDispute: this.isDispute,
				isCreditCard: this.isCreditCard,
				isUrgent: this.isUrgent,
				isSkonto: this.isSkonto,
				skonto: this.skonto,
				assignee: this.assignee,
				vat: this.vat,
				vatClass: this.vatClass,
				receiptDate: this.receiptDate,
				invoiceNumber: this.invoiceNumber,
				payoutAmount: this.payoutAmount,
				isRetrospective: this.isRetrospective,
				isReimbursed: this.isReimbursed,
				isPartial: this.isPartial,
				invoiceType: this.invoiceType
			};
		}
	};
	toCents = (value) => Math.round(value * 100);
}));
//#endregion
//#region src/domains/finance/invoice/invoice.i18n.ts
var costTypeDomainLabels, InvoiceVATClassLabel;
var init_invoice_i18n = __esmMin((() => {
	init_invoice_base();
	costTypeDomainLabels = {
		InstitutionalBusinessLine: "Institutional",
		RetailBusinessLine: "Retail",
		Reneo: "Reneo"
	};
	InvoiceVATClassLabel = {
		["StandardRate"]: "Standard Rate 19%",
		["LuxembourgStandardRate"]: "Luxembourg Standard Rate 17%",
		["ReducedRate"]: "Reduced Rate 7%",
		["ReverseCharge"]: "Reverse Charge (DE) (0%)",
		["ImportTax"]: "Import Tax 0%",
		["ThirdCountriesOutsideEU"]: "Third Countries Outside EU 0%",
		["TaxFreeEEUPurchases"]: "Tax Free EEU Purchases 0%",
		["EUPurchases"]: "EU Purchases 0%",
		["Exempt"]: "Exempt 0%",
		["VATZero"]: "VAT 0%",
		["ReverseChargeThirdCountry"]: "Reverse Charge (Third Country) 0%",
		["ReverseChargeEU"]: "Reverse Charge EU (0%)",
		["IntraCommunityAcquisition"]: "Innergem. Erwerb (0%)"
	};
}));
//#endregion
//#region src/domains/finance/invoice/request.ts
var init_request$1 = __esmMin((() => {}));
//#endregion
//#region src/domains/finance/invoice/index.ts
var init_invoice = __esmMin((() => {
	init_invoice_subscription_model();
	init_invoice_base();
	init_invoice_class();
	init_invoice_model();
	init_invoice_i18n();
	init_invoice_helpers();
	init_request$1();
	init_einvoice();
}));
//#endregion
//#region src/domains/finance/bank-transaction.model.ts
var BankTransactionCategory, BankTransactionCategoryType, BankTransactionCategoryToTypeMapping, BankTransactionSource, BankTransactionState, TransactionReconciliationType, ReconciliationTags, BankTransactionWarning, DirectDebitReasonCodes, errorReasonCodes, BaseBankTransactionSchema, BankTransactionSchema, bankTransactionSchemas;
var init_bank_transaction_model = __esmMin((() => {
	init_shared_schemas();
	init_transaction_model();
	init_invoice();
	BankTransactionCategory = /* @__PURE__ */ function(BankTransactionCategory) {
		BankTransactionCategory["Drawdown"] = "Drawdown";
		BankTransactionCategory["Fee"] = "Fee";
		BankTransactionCategory["Transfer"] = "Transfer";
		BankTransactionCategory["Booking"] = "Booking";
		BankTransactionCategory["PropertyManagement"] = "PropertyManagement";
		BankTransactionCategory["Storno"] = "Storno";
		BankTransactionCategory["ServiceCharges"] = "ServiceCharges";
		BankTransactionCategory["Operational"] = "Operational";
		BankTransactionCategory["Revenue"] = "Revenue";
		BankTransactionCategory["DirectDebit"] = "DirectDebit";
		BankTransactionCategory["Unknown"] = "Unknown";
		return BankTransactionCategory;
	}({});
	BankTransactionCategoryType = /* @__PURE__ */ function(BankTransactionCategoryType) {
		BankTransactionCategoryType["Interest"] = "Interest";
		BankTransactionCategoryType["Commitment"] = "Commitment";
		BankTransactionCategoryType["Combined"] = "Combined";
		BankTransactionCategoryType["Processing"] = "Processing";
		BankTransactionCategoryType["Invoice"] = "Invoice";
		BankTransactionCategoryType["PurchasingPrice"] = "PurchasingPrice";
		BankTransactionCategoryType["JuniorDebt"] = "JuniorDebt";
		BankTransactionCategoryType["Intergroup"] = "Intergroup";
		BankTransactionCategoryType["OwnFunds"] = "OwnFunds";
		BankTransactionCategoryType["Rent"] = "Rent";
		BankTransactionCategoryType["ManagementFee"] = "ManagementFee";
		BankTransactionCategoryType["InvestorIncome"] = "InvestorIncome";
		BankTransactionCategoryType["PropertyTax"] = "PropertyTax";
		BankTransactionCategoryType["AncillaryCosts"] = "AncillaryCosts";
		BankTransactionCategoryType["RentGuarantee"] = "RentGuarantee";
		BankTransactionCategoryType["OtherCost"] = "OtherCost";
		BankTransactionCategoryType["HouseGeldDealPayback"] = "HouseGeldDealPayback";
		BankTransactionCategoryType["RepaymentSubsidy"] = "RepaymentSubsidy";
		BankTransactionCategoryType["RentDeposit"] = "RentDeposit";
		BankTransactionCategoryType["AnnualServiceChargeStatement"] = "AnnualServiceChargeStatement";
		BankTransactionCategoryType["HouseGeld"] = "HouseGeld";
		BankTransactionCategoryType["HOAFeeSettlement"] = "HOAFeeSettlement";
		BankTransactionCategoryType["Selling"] = "Selling";
		BankTransactionCategoryType["Commission"] = "Commission";
		BankTransactionCategoryType["ReturnDebit"] = "ReturnDebit";
		BankTransactionCategoryType["ReturnDebitFee"] = "ReturnDebitFee";
		BankTransactionCategoryType["Storno"] = "Storno";
		BankTransactionCategoryType["BankFee"] = "BankFee";
		BankTransactionCategoryType["BankFeeCompensation"] = "BankFeeCompensation";
		BankTransactionCategoryType["ParkingIncome"] = "ParkingIncome";
		BankTransactionCategoryType["RefundManagementFee"] = "RefundManagementFee";
		BankTransactionCategoryType["BadDebts"] = "BadDebts";
		BankTransactionCategoryType["LiquidityReserve"] = "LiquidityReserve";
		BankTransactionCategoryType["Other"] = "Other";
		BankTransactionCategoryType["Unknown"] = "Unknown";
		return BankTransactionCategoryType;
	}({});
	BankTransactionCategoryToTypeMapping = {
		["Booking"]: [],
		["DirectDebit"]: ["Other"],
		["Fee"]: [
			"Interest",
			"Commitment",
			"Processing",
			"Combined"
		],
		["Operational"]: ["Other"],
		["PropertyManagement"]: [
			"Rent",
			"ReturnDebit",
			"ReturnDebitFee",
			"ManagementFee",
			"InvestorIncome",
			"Invoice",
			"PropertyTax",
			"BankFee",
			"BankFeeCompensation",
			"AncillaryCosts",
			"RentGuarantee",
			"OtherCost",
			"HouseGeldDealPayback",
			"RepaymentSubsidy",
			"RentDeposit",
			"AnnualServiceChargeStatement",
			"LiquidityReserve"
		],
		["Revenue"]: ["Selling", "Commission"],
		["ServiceCharges"]: ["HouseGeld", "HOAFeeSettlement"],
		["Storno"]: ["Storno"],
		["Transfer"]: [
			"Invoice",
			"PurchasingPrice",
			"OwnFunds"
		],
		["Drawdown"]: [
			"Invoice",
			"PurchasingPrice",
			"JuniorDebt",
			"Intergroup"
		],
		["Unknown"]: ["Unknown"]
	};
	BankTransactionSource = /* @__PURE__ */ function(BankTransactionSource) {
		BankTransactionSource["System"] = "System";
		BankTransactionSource["User"] = "User";
		return BankTransactionSource;
	}({});
	BankTransactionState = /* @__PURE__ */ function(BankTransactionState) {
		BankTransactionState["Pending"] = "Pending";
		BankTransactionState["Reconciled"] = "Reconciled";
		BankTransactionState["Incomplete"] = "Incomplete";
		BankTransactionState["Error"] = "Error";
		BankTransactionState["Storno"] = "Storno";
		return BankTransactionState;
	}({});
	TransactionReconciliationType = /* @__PURE__ */ function(TransactionReconciliationType) {
		TransactionReconciliationType["Automatic"] = "Automatic";
		TransactionReconciliationType["Manual"] = "Manual";
		return TransactionReconciliationType;
	}({});
	ReconciliationTags = /* @__PURE__ */ function(ReconciliationTags) {
		ReconciliationTags["ManualRun"] = "ManualRun";
		ReconciliationTags["Vague"] = "Rule";
		return ReconciliationTags;
	}({});
	BankTransactionWarning = /* @__PURE__ */ function(BankTransactionWarning) {
		BankTransactionWarning["Unknown"] = "Unknown";
		BankTransactionWarning["NoTenancyInfo"] = "NoTenancyInfo";
		BankTransactionWarning["NoActiveRentTenancy"] = "NoActiveRentTenancy";
		BankTransactionWarning["NoInvestorInfo"] = "NoInvestorInfo";
		BankTransactionWarning["NoAnnualServiceChargeStatement"] = "NoAnnualServiceChargeStatement";
		BankTransactionWarning["NoEstateForEscrowAccount"] = "NoEstateForEscrowAccount";
		BankTransactionWarning["NoInvestorInfoAttachedIssuer"] = "NoInvestorInfoAttachedIssuer";
		BankTransactionWarning["NoInvestorInfoAttachedTarget"] = "NoInvestorInfoAttachedTarget";
		BankTransactionWarning["NoInvoiceAttached"] = "NoInvoiceAttached";
		BankTransactionWarning["InvalidPaymentReferenceCode"] = "InvalidPaymentReferenceCode";
		BankTransactionWarning["InvalidPaymentReferenceEstateUUID"] = "InvalidPaymentReferenceEstateUUID";
		BankTransactionWarning["FundsReturnIsNotDirectDebit"] = "FundsReturnIsNotDirectDebit";
		BankTransactionWarning["TransactionConflictingReference"] = "TransactionConflictingReference";
		BankTransactionWarning["TransactionIncompleteStatement"] = "TransactionIncompleteStatement";
		return BankTransactionWarning;
	}({});
	DirectDebitReasonCodes = /* @__PURE__ */ function(DirectDebitReasonCodes) {
		DirectDebitReasonCodes["NoValidMandate"] = "909";
		DirectDebitReasonCodes["IncorrectMandateData"] = "910";
		DirectDebitReasonCodes["CustomerRefund"] = "912";
		DirectDebitReasonCodes["AccountHolderDeceased"] = "913";
		DirectDebitReasonCodes["UnknownOrWrongAmount"] = "914";
		DirectDebitReasonCodes["InsufficientFunds"] = "906";
		DirectDebitReasonCodes["MissingDebtorInformation"] = "917";
		DirectDebitReasonCodes["AccountClosed"] = "902";
		DirectDebitReasonCodes["FirstOrRecurringDirectDebit"] = "993";
		DirectDebitReasonCodes["FirstDirectDebit"] = "991";
		DirectDebitReasonCodes["ChangeOfDDMandate"] = "990";
		return DirectDebitReasonCodes;
	}({});
	errorReasonCodes = [
		"913",
		"914",
		"909",
		"910",
		"912",
		"906",
		"917",
		"902"
	];
	BaseBankTransactionSchema = Type.Object({
		bankTransactionId: Type.Optional(Type.Number()),
		referenceId: Type.String(),
		category: Type.Enum(BankTransactionCategory),
		categoryType: Type.Enum(BankTransactionCategoryType),
		amount: Type.Number(),
		bankTransactionState: Type.Enum(BankTransactionState),
		entryDate: StringDateSchema,
		valueDate: StringDateSchema,
		description: Type.String(),
		meta: Type.Object({ transaction: TransactionSchema }),
		userId: Type.Optional(Type.String()),
		transactionSource: Type.Enum(BankTransactionSource),
		isCredit: Type.Boolean(),
		issuerBankAccountId: Type.Optional(Type.Number()),
		investorInfoId: Type.Optional(TNullable(Type.Number())),
		rentTenancyId: Type.Optional(TNullable(Type.Number())),
		invoiceId: Type.Optional(TNullable(Type.Number())),
		bankAccountId: Type.Number(),
		/** @deprecated Orphaned audit id from dropped reconciler_rule table; static rules do not set this. */
		appliedRuleId: Type.Optional(Type.Number()),
		serviceChargeStatementId: Type.Optional(TNullable(Type.Number())),
		parentBankTransactionId: Type.Optional(TNullable(Type.Number())),
		appliedPaymentReference: Type.Optional(Type.Any())
	}, { $id: "BaseBankTransaction" });
	BankTransactionSchema = Type.Intersect([
		Type.Ref(BaseBankTransactionSchema),
		Type.Ref(BaseEntityAttributesSchema),
		Type.Object({ invoice: Type.Optional(Type.Ref(InvoiceSchema)) })
	], { $id: "BankTransaction" });
	bankTransactionSchemas = {
		BaseBankTransactionSchema,
		BankTransactionSchema
	};
}));
//#endregion
//#region src/domains/finance/bank-account/bank-account-reconciler-rule.helpers.ts
var sanityCheckRuleAssignment;
var init_bank_account_reconciler_rule_helpers = __esmMin((() => {
	init_bank_transaction_model();
	sanityCheckRuleAssignment = (assignment) => {
		if (!assignment.categoryType) return false;
		if (["RentDeposit"].includes(assignment.categoryType) && !assignment.rentTenancyId) return false;
		if (["Rent"].includes(assignment.categoryType) && !assignment.rentTenancyId) return false;
		if (["AnnualServiceChargeStatement"].includes(assignment.categoryType)) return false;
		if ([
			"InvestorIncome",
			"ManagementFee",
			"HouseGeld",
			"RepaymentSubsidy",
			"RentGuarantee",
			"HouseGeldDealPayback"
		].includes(assignment.categoryType) && !assignment.investorInfoId) return false;
		return true;
	};
}));
//#endregion
//#region src/domains/finance/bank-account/bank-account.base.ts
var BankAccountType, NamedAccount;
var init_bank_account_base = __esmMin((() => {
	BankAccountType = /* @__PURE__ */ function(BankAccountType) {
		BankAccountType["Other"] = "Other";
		BankAccountType["Business"] = "Business";
		BankAccountType["Loan"] = "Loan";
		BankAccountType["Tenant"] = "Tenant";
		BankAccountType["Escrow"] = "Escrow";
		BankAccountType["RentDeposit"] = "RentDeposit";
		BankAccountType["Investor"] = "Investor";
		BankAccountType["BankServiceAccount"] = "BankServiceAccount";
		BankAccountType["TenantOwned"] = "TenantOwned";
		return BankAccountType;
	}({});
	NamedAccount = /* @__PURE__ */ function(NamedAccount) {
		NamedAccount["Livings"] = "livings";
		return NamedAccount;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/contact/contact.base.ts
var SchufaState, AcademicRank, Salutation, InternalContactTag, ContactType, ONELOGIN_DEPARTMENT_MAPPINGS, ONELOGIN_COMPANY_UNIT_MAPPINGS, ContactSource;
var init_contact_base = __esmMin((() => {
	SchufaState = /* @__PURE__ */ function(SchufaState) {
		SchufaState["Good"] = "Good";
		SchufaState["Bad"] = "Bad";
		return SchufaState;
	}({});
	AcademicRank = /* @__PURE__ */ function(AcademicRank) {
		AcademicRank["Dr"] = "Dr.";
		AcademicRank["Prof"] = "Prof.";
		AcademicRank["DiplIng"] = "Dipl. Ing.";
		AcademicRank["Ing"] = "Ing.";
		return AcademicRank;
	}({});
	Salutation = /* @__PURE__ */ function(Salutation) {
		Salutation["Mr"] = "Mr";
		Salutation["Ms"] = "Ms";
		return Salutation;
	}({});
	InternalContactTag = /* @__PURE__ */ function(InternalContactTag) {
		InternalContactTag["ExternalReportingViewer"] = "external-reporting-viewer";
		return InternalContactTag;
	}({});
	ContactType = /* @__PURE__ */ function(ContactType) {
		ContactType["User"] = "User";
		ContactType["PurchasingEntityDirector"] = "PurchasingEntityDirector";
		ContactType["Seller"] = "Seller";
		ContactType["Buyer"] = "Buyer";
		ContactType["RealEstateAgent"] = "RealEstateAgent";
		ContactType["Banker"] = "Banker";
		ContactType["Notary"] = "Notary";
		ContactType["GeneralContractor"] = "GeneralContractor";
		ContactType["KitchenSupplier"] = "KitchenSupplier";
		ContactType["MeasurementProvider"] = "MeasurementProvider";
		ContactType["WEGVerwaltung"] = "WEGVerwaltung";
		ContactType["IndividualPropertyManagement"] = "IndividualPropertyManagement";
		ContactType["Tenant"] = "Tenant";
		ContactType["RentingLead"] = "RentingLead";
		ContactType["Generic"] = "Generic";
		ContactType["Neighbor"] = "Neighbor";
		ContactType["Craftsman"] = "Craftsman";
		ContactType["SellingNotary"] = "SellingNotary";
		ContactType["SalesRepresentative"] = "SalesRepresentative";
		ContactType["BankAccountOwner"] = "BankAccountOwner";
		ContactType["MaterialSupplier"] = "MaterialSupplier";
		ContactType["EnergyEfficiencyConsultant"] = "EnergyEfficiencyConsultant";
		ContactType["TechnicalDDExpert"] = "TechnicalDDExpert";
		ContactType["LegalDDExpert"] = "LegalDDExpert";
		ContactType["RentingPartner"] = "RentingPartner";
		ContactType["AssetPartner"] = "AssetPartner";
		ContactType["TaxDDConsultant"] = "TaxDDConsultant";
		ContactType["ExternalAuditor"] = "ExternalAuditor";
		return ContactType;
	}({});
	ONELOGIN_DEPARTMENT_MAPPINGS = {
		Finance: ["Accountant"],
		Engineering: ["admin"],
		"Transaction-HHLG": ["Transaction/Renting Manager Global Rules", "Transaction Manager Regional Rules"],
		Transaction: ["Transaction/Renting Manager Global Rules", "Transaction Manager Regional Rules"],
		Renovation: ["Viewer"],
		Other: ["Viewer"]
	};
	ONELOGIN_COMPANY_UNIT_MAPPINGS = {
		AssetManagement: [],
		BusinessDevelopment: [],
		Develop2Green: [],
		Development: [],
		EngineeringData: [],
		Finance: [],
		Investment: [],
		CLevel: [],
		OfficeManagement: [],
		PeopleCulture: [],
		PropertyManagement: [],
		Renovation: [],
		Sales: [],
		Transactions: []
	};
	ContactSource = /* @__PURE__ */ function(ContactSource) {
		ContactSource["Estarcore"] = "Estarcore";
		return ContactSource;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/company/company.base.ts
var CompanyType, CorporateForm, CompanyOrContactRelation, assignableRelationsForTaskTemplates;
var init_company_base = __esmMin((() => {
	CompanyType = /* @__PURE__ */ function(CompanyType) {
		CompanyType["Bank"] = "Bank";
		CompanyType["Realtor"] = "Realtor";
		CompanyType["DistributionPartner"] = "DistributionPartner";
		CompanyType["Notary"] = "Notary";
		CompanyType["PurchasingEntity"] = "PurchasingEntity";
		CompanyType["General"] = "General";
		CompanyType["KitchenSupplier"] = "KitchenSupplier";
		CompanyType["MeasurementsProvider"] = "MeasurementsProvider";
		CompanyType["ContractorGeneral"] = "ContractorGeneral";
		CompanyType["ContractorCleaning"] = "ContractorCleaning";
		CompanyType["ContractorElectricity"] = "ContractorElectricity";
		CompanyType["GeneralPropertyManagement"] = "GeneralPropertyManagement";
		CompanyType["IndividualPropertyManager"] = "IndividualPropertyManager";
		CompanyType["DistrictCourt"] = "DistrictCourt";
		CompanyType["ConstructionAuthority"] = "ConstructionAuthority";
		CompanyType["WaterProvider"] = "WaterProvier";
		CompanyType["ElectricityProvider"] = "ElectricityProvider";
		CompanyType["GasProvider"] = "GasProvider";
		CompanyType["FacilityManagement"] = "FacilityManagement";
		CompanyType["ServiceProvider"] = "ServiceProvider";
		CompanyType["SellingNotary"] = "SellingNotary";
		CompanyType["MaterialSupplier"] = "MaterialSupplier";
		CompanyType["TaxOffice"] = "TaxOffice";
		CompanyType["AssetManagement"] = "AssetManagement";
		CompanyType["HrCompany"] = "HrCompany";
		CompanyType["OfficeSupplier"] = "OfficeSupplier";
		CompanyType["TravelProvider"] = "TravelProvider";
		CompanyType["RentalCarCompany"] = "RentalCarCompany";
		CompanyType["MarketingCompany"] = "MarketingCompany";
		CompanyType["HardwareProvider"] = "HardwareProvider";
		CompanyType["SoftwareCompany"] = "SoftwareCompany";
		CompanyType["Seller"] = "Seller";
		CompanyType["Buyer"] = "Buyer";
		CompanyType["AssetPartner"] = "AssetPartner";
		CompanyType["Tenant"] = "Tenant";
		CompanyType["RentingLead"] = "RentingLead";
		CompanyType["AuditingFirm"] = "AuditingFirm";
		CompanyType["Planning"] = "Planning";
		CompanyType["PlanningAndConstructions"] = "PlanningAndConstructions";
		CompanyType["Proptech"] = "Proptech";
		return CompanyType;
	}({});
	CorporateForm = /* @__PURE__ */ function(CorporateForm) {
		CorporateForm["GbR"] = "GbR";
		CorporateForm["OHG"] = "OHG";
		CorporateForm["KG"] = "KG";
		CorporateForm["AG"] = "AG";
		CorporateForm["GmbH"] = "GmbH";
		CorporateForm["mbH"] = "mbH";
		CorporateForm["UG"] = "UG";
		CorporateForm["GmbHCoKg"] = "GmbH & Co. KG.";
		CorporateForm["KGAa"] = "KG aA";
		CorporateForm["eG"] = "eG";
		CorporateForm["eK"] = "e.K.";
		CorporateForm["KdöR"] = "KdöR";
		CorporateForm["ev"] = "e.V.";
		CorporateForm["SpZoo"] = "Sp. z o.o.";
		return CorporateForm;
	}({});
	CompanyOrContactRelation = /* @__PURE__ */ function(CompanyOrContactRelation) {
		CompanyOrContactRelation["Seller"] = "Seller";
		CompanyOrContactRelation["Realtor"] = "Realtor";
		CompanyOrContactRelation["Notary"] = "Notary";
		CompanyOrContactRelation["Bank"] = "Bank";
		CompanyOrContactRelation["DistrictCourt"] = "DistrictCourt";
		CompanyOrContactRelation["ConstructionAuthority"] = "ConstructionAuthority";
		CompanyOrContactRelation["ExecutionNotary"] = "ExecutionNotary";
		CompanyOrContactRelation["DocumentingNotary"] = "DocumentingNotary";
		CompanyOrContactRelation["MeasurementProvider"] = "MeasurementProvider";
		CompanyOrContactRelation["GeneralContractor"] = "GeneralContractor";
		CompanyOrContactRelation["KitchenSupplier"] = "KitchenSupplier";
		CompanyOrContactRelation["DistributionPartner"] = "DistributionPartner";
		CompanyOrContactRelation["SellingNotary"] = "SellingNotary";
		CompanyOrContactRelation["Buyer"] = "Buyer";
		CompanyOrContactRelation["SellingExecutionNotary"] = "SellingExecutionNotary";
		CompanyOrContactRelation["SellingDocumentingNotary"] = "SellingDocumentingNotary";
		CompanyOrContactRelation["ServiceProvider"] = "ServiceProvider";
		CompanyOrContactRelation["FacilityManagement"] = "FacilityManagement";
		CompanyOrContactRelation["GasProvider"] = "GasProvider";
		CompanyOrContactRelation["ElectricityProvider"] = "ElectricityProvider";
		CompanyOrContactRelation["WaterProvider"] = "WaterProvider";
		CompanyOrContactRelation["GeneralPropertyManagement"] = "GeneralPropertyManagement";
		CompanyOrContactRelation["Tenant"] = "Tenant";
		CompanyOrContactRelation["SalesRepresentative"] = "SalesRepresentative";
		CompanyOrContactRelation["FinancingAdvisor"] = "FinancingAdvisor";
		CompanyOrContactRelation["Craftsman"] = "Craftsman";
		CompanyOrContactRelation["Neighbor"] = "Neighbor";
		CompanyOrContactRelation["EnergyEfficiencyConsultant"] = "EnergyEfficiencyConsultant";
		CompanyOrContactRelation["TechnicalDDExpert"] = "TechnicalDDExpert";
		CompanyOrContactRelation["LegalDDExpert"] = "LegalDDExpert";
		CompanyOrContactRelation["RentingPartner"] = "RentingPartner";
		CompanyOrContactRelation["TaxDDConsultant"] = "TaxDDConsultant";
		CompanyOrContactRelation["AssetPartner"] = "AssetPartner";
		CompanyOrContactRelation["CandidateAssetPartner"] = "CandidateAssetPartner";
		CompanyOrContactRelation["TechnicalProjectLead"] = "TechnicalProjectLead";
		CompanyOrContactRelation["PurchasingEntity"] = "PurchasingEntity";
		CompanyOrContactRelation["General"] = "General";
		CompanyOrContactRelation["ContractorGeneral"] = "ContractorGeneral";
		CompanyOrContactRelation["ContractorCleaning"] = "ContractorCleaning";
		CompanyOrContactRelation["ContractorElectricity"] = "ContractorElectricity";
		CompanyOrContactRelation["IndividualPropertyManager"] = "IndividualPropertyManager";
		CompanyOrContactRelation["MaterialSupplier"] = "MaterialSupplier";
		CompanyOrContactRelation["TaxOffice"] = "TaxOffice";
		CompanyOrContactRelation["AssetManagement"] = "AssetManagement";
		CompanyOrContactRelation["HrCompany"] = "HrCompany";
		CompanyOrContactRelation["OfficeSupplier"] = "OfficeSupplier";
		CompanyOrContactRelation["TravelProvider"] = "TravelProvider";
		CompanyOrContactRelation["RentalCarCompany"] = "RentalCarCompany";
		CompanyOrContactRelation["MarketingCompany"] = "MarketingCompany";
		CompanyOrContactRelation["HardwareProvider"] = "HardwareProvider";
		CompanyOrContactRelation["SoftwareCompany"] = "SoftwareCompany";
		CompanyOrContactRelation["RentingLead"] = "RentingLead";
		CompanyOrContactRelation["AuditingFirm"] = "AuditingFirm";
		CompanyOrContactRelation["Planning"] = "Planning";
		CompanyOrContactRelation["PlanningAndConstructions"] = "PlanningAndConstructions";
		CompanyOrContactRelation["Proptech"] = "Proptech";
		return CompanyOrContactRelation;
	}({});
	assignableRelationsForTaskTemplates = [
		"EnergyEfficiencyConsultant",
		"TechnicalDDExpert",
		"LegalDDExpert",
		"TaxDDConsultant",
		"AssetPartner"
	];
}));
//#endregion
//#region src/domains/cross-cutting/contact/contact.model.ts
var contactToRelationName, ContactPersonSchema, ContactRelationSchema;
var init_contact_model = __esmMin((() => {
	init_lib();
	init_company_base();
	init_contact_base();
	contactToRelationName = {
		["Seller"]: "Seller",
		["RealEstateAgent"]: "Realtor",
		["Banker"]: "Bank",
		["MeasurementProvider"]: "MeasurementProvider",
		["GeneralContractor"]: "GeneralContractor",
		["KitchenSupplier"]: "KitchenSupplier",
		["Tenant"]: "Tenant",
		["WEGVerwaltung"]: "GeneralPropertyManagement",
		["Craftsman"]: "Craftsman",
		["Neighbor"]: "Neighbor",
		["Buyer"]: "Buyer",
		["Notary"]: "Notary",
		["SellingNotary"]: "SellingNotary",
		["SalesRepresentative"]: "SalesRepresentative",
		["IndividualPropertyManagement"]: "GeneralPropertyManagement",
		["EnergyEfficiencyConsultant"]: "EnergyEfficiencyConsultant",
		["TechnicalDDExpert"]: "TechnicalDDExpert",
		["LegalDDExpert"]: "LegalDDExpert"
	};
	ContactPersonSchema = Type.Object({
		contactId: Type.Optional(TNullable(Type.Number())),
		uuid: Type.Optional(TNullable(Type.String({ format: "uuid" }))),
		contactType: Type.Optional(TNullable(TEnum(ContactType))),
		salutation: Type.Optional(TNullable(Type.String())),
		firstname: Type.Optional(TNullable(Type.String())),
		lastname: Type.Optional(TNullable(TNullable(Type.String()))),
		fullname: Type.Optional(TNullable(Type.String())),
		phoneNumber: Type.Optional(TNullable(Type.String())),
		faxNumber: Type.Optional(TNullable(Type.String())),
		title: Type.Optional(TNullable(Type.String())),
		email: Type.Optional(TNullable(Type.String())),
		contactHours: Type.Optional(TNullable(Type.String())),
		homepageUrl: Type.Optional(TNullable(Type.String())),
		rentingLeadId: Type.Optional(TNullable(Type.Number())),
		birthday: Type.Optional(StringDateSchema),
		userId: Type.Optional(TNullable(Type.String())),
		personalInfoId: Type.Optional(TNullable(Type.Number())),
		locationId: Type.Optional(TNullable(Type.Number())),
		avatarMediaFileId: Type.Optional(TNullable(Type.Number())),
		registeredToPortal: Type.Optional(TNullable(Type.Boolean())),
		invitedToPortal: Type.Optional(TNullable(Type.Boolean())),
		createdAt: Type.Optional(StringDateSchema)
	}, { $id: "ContactPerson" });
	ContactRelationSchema = Type.Object({
		contactRelationId: Type.Optional(Type.Number()),
		mfhId: Type.Optional(Type.Number()),
		contactId: Type.Optional(Type.Number()),
		companyFunction: Type.Optional(TNullable(Type.String())),
		relationName: Type.Optional(TNullable(Type.Enum(CompanyOrContactRelation))),
		contact: Type.Optional(TNullable(Type.Ref(ContactPersonSchema)))
	}, { $id: "ContactRelation" });
}));
//#endregion
//#region src/domains/cross-cutting/company/company.model.ts
var SubCompany, CompanySource, CompanyRole, DETAILED_COMPANY_RELATIONS, companyToContactTypeMapper, contactTypeToCompanyMapper, companyTypeToCostTypeMapping, condoCompanyNameRegexMap, companyToEstateRelationName, BaseCompanySchema, CompanyEmploymentRelationSchema, CompanySchema, CompanyRelationSchema;
var init_company_model = __esmMin((() => {
	init_lib();
	init_invoice_base();
	init_contact_model();
	init_location_model();
	init_process_model();
	init_company_base();
	SubCompany = /* @__PURE__ */ function(SubCompany) {
		SubCompany["Immobilienaufbau"] = "Immobilienaufbau";
		return SubCompany;
	}({});
	CompanySource = /* @__PURE__ */ function(CompanySource) {
		CompanySource["Estarcore"] = "Estarcore";
		return CompanySource;
	}({});
	CompanyRole = /* @__PURE__ */ function(CompanyRole) {
		CompanyRole["Employee"] = "Employee";
		CompanyRole["ManagingDirector"] = "ManagingDirector";
		return CompanyRole;
	}({});
	DETAILED_COMPANY_RELATIONS = [
		"ownedBankAccounts",
		"ownedBankAccounts.bank",
		"location",
		"location.region",
		"employees",
		"employees.contactPerson",
		"accounting"
	];
	companyToContactTypeMapper = {
		["Bank"]: "Banker",
		["Realtor"]: "RealEstateAgent",
		["DistributionPartner"]: "Generic",
		["Notary"]: "Notary",
		["PurchasingEntity"]: "PurchasingEntityDirector",
		["General"]: "Generic",
		["KitchenSupplier"]: "KitchenSupplier",
		["MeasurementsProvider"]: "MeasurementProvider",
		["ContractorGeneral"]: "GeneralContractor",
		["ContractorCleaning"]: "GeneralContractor",
		["ContractorElectricity"]: "GeneralContractor",
		["GeneralPropertyManagement"]: "WEGVerwaltung",
		["IndividualPropertyManager"]: "IndividualPropertyManagement",
		["DistrictCourt"]: "Generic",
		["ConstructionAuthority"]: "Generic",
		["WaterProvier"]: "Craftsman",
		["ElectricityProvider"]: "Craftsman",
		["GasProvider"]: "Craftsman",
		["FacilityManagement"]: "Craftsman",
		["ServiceProvider"]: "Craftsman",
		["SellingNotary"]: "SellingNotary",
		["MaterialSupplier"]: "MaterialSupplier",
		["TaxOffice"]: "Generic",
		["AssetManagement"]: "Generic",
		["HrCompany"]: "Generic",
		["OfficeSupplier"]: "Generic",
		["TravelProvider"]: "Generic",
		["RentalCarCompany"]: "Generic",
		["MarketingCompany"]: "Generic",
		["HardwareProvider"]: "Generic",
		["SoftwareCompany"]: "Generic",
		["Seller"]: "Seller",
		["Buyer"]: "Buyer",
		["AssetPartner"]: "AssetPartner",
		["Tenant"]: "Tenant",
		["RentingLead"]: "RentingLead",
		["AuditingFirm"]: "ExternalAuditor",
		["Planning"]: "Generic",
		["PlanningAndConstructions"]: "Generic",
		["Proptech"]: "Generic"
	};
	contactTypeToCompanyMapper = {
		["Banker"]: ["Bank"],
		["RealEstateAgent"]: ["Realtor"],
		["Generic"]: [
			"DistributionPartner",
			"General",
			"DistrictCourt",
			"ConstructionAuthority",
			"TaxOffice",
			"AssetManagement",
			"HrCompany",
			"OfficeSupplier",
			"TravelProvider",
			"RentalCarCompany",
			"MarketingCompany",
			"HardwareProvider",
			"SoftwareCompany"
		],
		["Notary"]: ["Notary"],
		["PurchasingEntityDirector"]: ["PurchasingEntity"],
		["KitchenSupplier"]: ["KitchenSupplier"],
		["MeasurementProvider"]: ["MeasurementsProvider"],
		["GeneralContractor"]: [
			"ContractorGeneral",
			"ContractorCleaning",
			"ContractorElectricity"
		],
		["WEGVerwaltung"]: ["GeneralPropertyManagement"],
		["IndividualPropertyManagement"]: ["IndividualPropertyManager"],
		["Craftsman"]: [
			"WaterProvier",
			"ElectricityProvider",
			"GasProvider",
			"FacilityManagement",
			"ServiceProvider"
		],
		["SellingNotary"]: ["SellingNotary"],
		["MaterialSupplier"]: ["MaterialSupplier"],
		["Seller"]: ["Seller"],
		["Buyer"]: ["Buyer"],
		["AssetPartner"]: ["AssetPartner"],
		["Tenant"]: ["Tenant"],
		["RentingLead"]: ["RentingLead"],
		["ExternalAuditor"]: ["AuditingFirm", "AssetPartner"]
	};
	companyTypeToCostTypeMapping = {
		["Realtor"]: "AgencyFee",
		["DistributionPartner"]: "AgencyFeeSelling",
		["Notary"]: "Notary",
		["General"]: "OtherAdministrativeCosts",
		["KitchenSupplier"]: "KitchenCost",
		["MeasurementsProvider"]: "OtherRenovationCost",
		["ContractorGeneral"]: "GeneralRenovationCost",
		["ContractorCleaning"]: "OtherRenovationCost",
		["ContractorElectricity"]: "GeneralRenovationCost",
		["GeneralPropertyManagement"]: "HomeOwnersFee",
		["DistrictCourt"]: "PropertyRegistration",
		["ConstructionAuthority"]: "OtherRenovationCost",
		["WaterProvier"]: "Utilities",
		["ElectricityProvider"]: "Utilities",
		["GasProvider"]: "Utilities",
		["FacilityManagement"]: "Utilities",
		["SellingNotary"]: "OtherAncillaryCostSelling",
		["MaterialSupplier"]: "GeneralRenovationCost",
		["TaxOffice"]: "PropertyTax",
		["HrCompany"]: "RecruitingExpenses",
		["OfficeSupplier"]: "OfficeExpenses",
		["TravelProvider"]: "TravelExpenses",
		["RentalCarCompany"]: "CarAndLeasingCosts",
		["MarketingCompany"]: "MarketingExpenses",
		["HardwareProvider"]: "EquipmentExpensesAndDA",
		["SoftwareCompany"]: "TechnologyAndAnalytics"
	};
	condoCompanyNameRegexMap = {
		"Hamburger Liegenschaftsgesellschaft mbH": /^(?=.*hamburg)(?:(?=.*1)(?:(?!\d).)*|(?:(?!\d).)*$)/i,
		"Hamburger Liegenschaftsgesellschaft 2 mbH": /^(?=.*hamburg)(?=.*2).*$/i,
		"Hamburger Liegenschaftsgesellschaft 3 mbH": /^(?=.*hamburg)(?=.*3).*$/i,
		"Deutsche Liegenschaftsgesellschaft mbH": /^(?=.*deutsch)(?:(?=.*1)(?:(?!\d).)*|(?:(?!\d).)*$)/i,
		"DLG Deutsche Liegenschaftsgesellschaft 2 mbH": /^(?=.*deutsch)(?=.*2).*$/i,
		"Condo Asset Management GmbH": /(?=.*asset)/i,
		"Condo Group GmbH": /(?=.*group)/i,
		"Reneo GmbH": /(?=.*reneo)/i,
		"Livings GmbH": /(?=.*living)/i,
		"Investable GmbH": /(?=.*investable)(?!.*\d)(?!.*verwaltung)/i,
		"Investable Verwaltungsgesellschaft mbH": /(?=.*investable)(?=.*verwaltung)/i,
		"Investable HH 4 GmbH & Co. KG": /^(?=.*[iI][nN][vV][eE][sS][tT][aA][bB][lL][eE])(?=.*HH)(?=.*4).*$/,
		"Investable HH 5 GmbH & Co. KG": /^(?=.*[iI][nN][vV][eE][sS][tT][aA][bB][lL][eE])(?=.*HH)(?=.*5).*$/,
		"Investable Emissionsgesellschaft B 1 mbH & Co. KG": /^(?=.*[iI][nN][vV][eE][sS][tT][aA][bB][lL][eE])(?=.*[eE][mM][iI][sS][sS][iI][oO][nN])(?=.*B)(?=.*1).*$/,
		"Investable Emissionsgesellschaft HH1 mbH & Co. KG": /^(?=.*[iI][nN][vV][eE][sS][tT][aA][bB][lL][eE])(?=.*[eE][mM][iI][sS][sS][iI][oO][nN])(?=.*HH)(?:(?=.*1)(?:(?!\d).)*|(?:(?!\d).)*$)/,
		"Investable Emissionsgesellschaft HH 2": /^(?=.*[iI][nN][vV][eE][sS][tT][aA][bB][lL][eE])(?=.*[eE][mM][iI][sS][sS][iI][oO][nN])(?=.*HH)(?=.*2).*$/,
		"Investable Emissionsgesellschaft HH 3 mbH & Co. KG": /^(?=.*[iI][nN][vV][eE][sS][tT][aA][bB][lL][eE])(?=.*[eE][mM][iI][sS][sS][iI][oO][nN])(?=.*HH)(?=.*3).*$/
	};
	companyToEstateRelationName = {
		["Seller"]: "Seller",
		["Realtor"]: "Realtor",
		["Notary"]: "Notary",
		["Bank"]: "Bank",
		["DistrictCourt"]: "DistrictCourt",
		["ConstructionAuthority"]: "ConstructionAuthority",
		["MeasurementsProvider"]: "MeasurementProvider",
		["ContractorGeneral"]: "GeneralContractor",
		["KitchenSupplier"]: "KitchenSupplier",
		["ServiceProvider"]: "ServiceProvider",
		["FacilityManagement"]: "FacilityManagement",
		["GasProvider"]: "GasProvider",
		["ElectricityProvider"]: "ElectricityProvider",
		["WaterProvier"]: "WaterProvider",
		["GeneralPropertyManagement"]: "GeneralPropertyManagement",
		["Buyer"]: "Buyer",
		["SellingNotary"]: "SellingNotary"
	};
	BaseCompanySchema = Type.Object({
		companyId: Type.Optional(TNullable(Type.Number())),
		name: Type.Optional(TNullable(Type.String())),
		isExternalInvoiceApprover: Type.Optional(Type.Boolean()),
		invoiceExternalApprovalConfig: Type.Optional(TNullable(Type.Object({
			enabled: Type.Boolean(),
			isOrdered: Type.Boolean(),
			companyIds: Type.Array(Type.Number()),
			payoutAmountThreshold: Type.Optional(TNullable(Type.Number()))
		}))),
		mfhRenovationProjectApprovalConfig: Type.Optional(Type.Object({
			enabled: Type.Boolean(),
			companyIds: Type.Array(Type.Number()),
			isOrdered: Type.Boolean()
		})),
		contacts: Type.Optional(Type.Array(Type.Object({
			contactId: Type.Number(),
			companyId: Type.Number()
		}))),
		assetPartnerId: Type.Optional(TNullable(Type.Number())),
		sellingPartner: Type.Optional(TNullable(TEnum(SellingPartner))),
		rentingLeadId: Type.Optional(TNullable(Type.Number())),
		createdAt: Type.Optional(StringDateSchema),
		updatedAt: Type.Optional(StringDateSchema),
		type: Type.Optional(TNullable(Type.Enum(CompanyType))),
		isHeadquarter: Type.Optional(TNullable(Type.Boolean())),
		corporateForm: Type.Optional(TNullable(Type.String())),
		shortName: Type.Optional(TNullable(Type.String())),
		commercialRegistryCode: Type.Optional(TNullable(Type.String())),
		homepage: Type.Optional(TNullable(Type.String())),
		email: Type.Optional(TNullable(Type.String())),
		parentCompanyId: Type.Optional(TNullable(Type.Number())),
		phoneNumber: Type.Optional(TNullable(Type.String())),
		locationId: Type.Optional(TNullable(Type.Number())),
		isCondoCompany: Type.Optional(TNullable(Type.Boolean())),
		isInactive: Type.Optional(TNullable(Type.Boolean())),
		excludeFromIC: Type.Optional(TNullable(Type.Boolean())),
		location: Type.Optional(TNullable(Type.Ref(LocationDTOSchema))),
		partnerPreviewAccountUid: Type.Optional(TNullable(Type.String()))
	}, { $id: "BaseCompany" });
	CompanyEmploymentRelationSchema = Type.Intersect([BaseCreatedDeletedAttributesSchema, Type.Object({
		contactPersonId: Type.Number(),
		companyId: Type.Number(),
		companyRole: Type.Optional(TEnum(CompanyRole)),
		companyTeam: Type.Optional(Type.String()),
		isMainContact: Type.Optional(Type.Boolean()),
		contactPerson: Type.Optional(Type.Ref(ContactPersonSchema))
	})], { $id: "CompanyEmploymentRelation" });
	CompanySchema = Type.Intersect([Type.Ref(BaseCompanySchema), Type.Object({
		employees: Type.Optional(Type.Array(Type.Ref(CompanyEmploymentRelationSchema))),
		assetPartner: Type.Optional(Type.Ref(BaseCompanySchema)),
		location: Type.Optional(Type.Ref(LocationDTOSchema))
	})], { $id: "Company" });
	CompanyRelationSchema = Type.Object({
		companyMfhRelationId: Type.Optional(Type.Number()),
		mfhId: Type.Optional(Type.Number()),
		companyId: Type.Optional(Type.Number()),
		relationName: Type.Optional(TNullable(Type.String())),
		company: Type.Optional(TNullable(Type.Ref(CompanySchema)))
	}, { $id: "CompanyRelation" });
}));
//#endregion
//#region src/domains/cross-cutting/company/contractor-capacity.model.ts
var init_contractor_capacity_model = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/company/company.helpers.ts
var matchToCondoCompanyName, getCompanyName, getCompanyShortName;
var init_company_helpers = __esmMin((() => {
	init_company_model();
	matchToCondoCompanyName = (str) => {
		const [companyName] = Object.entries(condoCompanyNameRegexMap).find(([_, regex]) => new RegExp(regex).exec(str)) ?? [];
		return companyName;
	};
	getCompanyName = (company) => {
		return company.name;
	};
	getCompanyShortName = (company) => {
		return company.shortName || company.name;
	};
}));
//#endregion
//#region src/domains/cross-cutting/company/company.opts.ts
var init_company_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/company/index.ts
var init_company = __esmMin((() => {
	init_company_base();
	init_company_model();
	init_contractor_capacity_model();
	init_company_helpers();
	init_company_opts();
}));
//#endregion
//#region src/domains/cross-cutting/contact/contact.helpers.ts
/**
* Two-character uppercase initials for user avatars from a display name.
* Uses first letter of the first and last whitespace-separated tokens; a single token uses its first two characters; otherwise `?`.
*/
function getPersonAvatarInitials(fullname) {
	const name = defaultTo(fullname, "").trim();
	if (!name) return "?";
	const parts = name.split(/\s+/);
	const firstName = first(parts);
	const lastName = last(parts);
	if (parts.length >= 2 && firstName && lastName) return `${firstName[0]}${lastName[0]}`.toUpperCase();
	return name.slice(0, 2).toUpperCase();
}
var getContactDisplayName, getContactShortName, getContactEmailGreeting, isInternalEmail;
var init_contact_helpers = __esmMin((() => {
	getContactDisplayName = (contact, { withSalutation = false, withEmployment = true } = {}) => {
		if (!contact) return "";
		let displayName;
		if (contact.firstname || contact.lastname) displayName = `${contact.firstname ?? ""}${contact.lastname ? ` ${contact.lastname}` : ""}`;
		else displayName = contact.email ?? "";
		if (contact?.employment?.company?.name) displayName = `${displayName} ${withEmployment ? ` | ${contact.employment.company?.name}` : ""}`;
		if (withSalutation) return `${contact.salutation ? `${contact.salutation} ` : ""}${contact.lastname ? `${contact.lastname} ` : ""}${displayName ?? ""}`;
		return displayName;
	};
	getContactShortName = (contact) => {
		if (!contact) return "";
		let displayName = "";
		if (contact.firstname) displayName = `${contact.firstname.charAt(0)}.`;
		if (contact.lastname) displayName = `${displayName} ${contact.lastname}`;
		return displayName;
	};
	getContactEmailGreeting = (contact) => {
		const { fullname, salutation } = contact ?? {};
		if (!fullname || salutation === "COMPANY") return `Sehr geehrte Damen und Herren`;
		if (salutation && [
			"Herr",
			"Mr",
			"MALE"
		].includes(salutation)) return `Sehr geehrter Herr ${fullname}`;
		if (salutation && [
			"Frau",
			"Mrs",
			"Ms",
			"FEMALE"
		].includes(salutation)) return `Sehr geehrte Frau ${fullname}`;
		if (salutation === "Divers") return `Sehr geehrte(r) Divers ${fullname}`;
		return `Sehr geehrte(r) Frau/Herr ${fullname}`;
	};
	isInternalEmail = (email) => email.endsWith("@reneo.de") || email.endsWith("@hh-lg.de") || email.endsWith("@condogroup.de") || email.endsWith("@livings.de");
}));
//#endregion
//#region src/domains/cross-cutting/contact/external-contact.model.ts
var ExternalDDContactTypes, ExternalContactTypes, getDocumentCategoriesForExternalContact, getExcludedDocumentTypesForExternalContact;
var init_external_contact_model = __esmMin((() => {
	init_document();
	ExternalDDContactTypes = [
		"EnergyEfficiencyConsultant",
		"TechnicalDDExpert",
		"LegalDDExpert",
		"TaxDDConsultant"
	];
	ExternalContactTypes = [
		...ExternalDDContactTypes,
		"AssetPartner",
		"ExternalAuditor"
	];
	getDocumentCategoriesForExternalContact = (contactType) => {
		const documentCategories = [
			"Land",
			"Building",
			"ObjectManagement",
			"MfhOther",
			"DueDiligence"
		];
		if (contactType === "LegalDDExpert") return [
			...documentCategories,
			"RentalContract",
			"PurchasingContract"
		];
		return documentCategories;
	};
	getExcludedDocumentTypesForExternalContact = (_contactType) => {
		return [
			"InvestmentProposal",
			"OperatingCostStatement",
			"AdditionalCostsInvoice",
			"PowersOfAttorney",
			"LoanAgreement",
			"LandChargeDeed",
			"DeclarationOfSecurityPurpose",
			"DeclarationOfAssignment",
			"Pledges",
			"PurchasingTerminationDocuments",
			"PurchasingOffer",
			"CourtageAgreement",
			"ExclusivityAgreement",
			"CommercialDD"
		];
	};
}));
//#endregion
//#region src/domains/cross-cutting/contact/external-contact.helpers.ts
var isUserAssetPartnerEmployee, authzExternalContactEmploymentExpandOpts;
var init_external_contact_helpers = __esmMin((() => {
	init_company();
	init_errors();
	isUserAssetPartnerEmployee = (contact, allowedContactTypes) => {
		if (!allowedContactTypes.includes(contact.contactType)) return false;
		const employmentCompany = contact.employment?.company;
		if (!employmentCompany || employmentCompany.type !== "AssetPartner") throw new UnauthorizedError(`User has no employment company or is not associated to an 'AssetPartner'-company`);
		if (!employmentCompany.companyId) throw new InvariantError("companyId is expected on employmentCompany");
		return true;
	};
	authzExternalContactEmploymentExpandOpts = {
		select: [
			"contactId",
			"fullname",
			"email",
			"contactType",
			"userId"
		],
		expand: { employment: {
			select: ["companyId", "contactPersonId"],
			expand: { company: { select: [
				"companyId",
				"name",
				"type",
				"parentCompanyId"
			] } }
		} }
	};
}));
//#endregion
//#region src/domains/cross-cutting/contact/contact.opts.ts
var init_contact_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/contact/index.ts
var init_contact = __esmMin((() => {
	init_contact_helpers();
	init_contact_base();
	init_contact_model();
	init_external_contact_model();
	init_external_contact_helpers();
	init_contact_opts();
}));
//#endregion
//#region src/domains/cross-cutting/party/party.helpers.ts
var getPartyDisplayName, getPartyShortName;
var init_party_helpers = __esmMin((() => {
	init_company();
	init_contact();
	getPartyDisplayName = (party, { withSalutation = false, withEmployment = true } = {}) => {
		if ((!party?.contact || !Object.keys(party?.contact).length) && (!party?.company || !Object.keys(party?.company).length)) return "";
		const { contact, company } = party;
		if (company?.name) return getCompanyName(company);
		return getContactDisplayName(contact, {
			withSalutation,
			withEmployment
		});
	};
	getPartyShortName = (party) => {
		if ((!party?.contact || !Object.keys(party?.contact).length) && (!party?.company || !Object.keys(party?.company).length)) return "";
		const { contact, company } = party;
		if (company?.name || company?.shortName) return getCompanyShortName(company);
		return getContactShortName(contact);
	};
}));
//#endregion
//#region src/domains/cross-cutting/party/index.ts
var init_party = __esmMin((() => {
	init_party_helpers();
}));
//#endregion
//#region src/domains/finance/banking/bank-account-secret.model.ts
var BankAccountSecretSchema;
var init_bank_account_secret_model = __esmMin((() => {
	BankAccountSecretSchema = Type.Unsafe(Type.Object({
		id: Type.Optional(Type.Number()),
		keyfilePath: Type.Optional(Type.String()),
		value: Type.String(),
		kmsKeyName: Type.String(),
		bankOwnerAccountId: Type.Optional(Type.Number()),
		bankOwnerAccount: Type.Optional(Type.Ref("BankOwnerAccount"))
	}, { $id: "BankAccountSecret" }));
}));
//#endregion
//#region src/domains/finance/banking/bank-owner-account.model.ts
var BankOwnerAccountSchema;
var init_bank_owner_account_model = __esmMin((() => {
	init_banking_base();
	BankOwnerAccountSchema = Type.Unsafe(Type.Object({
		id: Type.Optional(Type.Number()),
		state: Type.Enum(BankOwnerAccountStates),
		ebicsUrl: Type.Optional(Type.String()),
		partnerId: Type.Optional(Type.String()),
		userId: Type.Optional(Type.String()),
		hostId: Type.Optional(Type.String()),
		ownerName: Type.Optional(Type.String()),
		bankName: Type.Optional(Type.String()),
		ibans: Type.Optional(Type.Array(Type.String())),
		verificationDocumentPath: Type.Optional(Type.String()),
		isSuspended: Type.Optional(Type.Boolean()),
		bankAccountSecrets: Type.Optional(Type.Array(Type.Ref("BankAccountSecret"))),
		events: Type.Optional(Type.Array(Type.Any())),
		topicIdentifier: Type.String(),
		transactionRuns: Type.Optional(Type.Array(Type.Ref("TransactionRun")))
	}, { $id: "BankOwnerAccount" }));
}));
//#endregion
//#region src/domains/finance/banking/transaction-run.model.ts
var BankJobSchema, TransactionRunSchema;
var init_transaction_run_model = __esmMin((() => {
	init_shared_schemas();
	init_banking_base();
	BankJobSchema = Type.Unsafe(Type.Object({
		id: Type.String(),
		name: Type.String(),
		state: Type.Union([
			Type.Literal("created"),
			Type.Literal("retry"),
			Type.Literal("active"),
			Type.Literal("completed"),
			Type.Literal("expired"),
			Type.Literal("cancelled"),
			Type.Literal("failed")
		]),
		retrylimit: Type.Number(),
		retrycount: Type.Number(),
		retrydelay: Type.Number(),
		retrybackoff: Type.Boolean(),
		startafter: Type.Optional(StringDateSchema),
		startedon: Type.Optional(StringDateSchema),
		createdon: Type.Optional(StringDateSchema),
		data: Type.Array(Type.Ref("Statement"))
	}, { $id: "BankJob" }));
	TransactionRunSchema = Type.Unsafe(Type.Object({
		id: Type.Optional(Type.Number()),
		createdAt: Type.Optional(StringDateSchema),
		startDate: StringDateSchema,
		jobId: Type.Optional(Type.String()),
		state: Type.Enum(TransactionRunState),
		endDate: StringDateSchema,
		meta: Type.Optional(Type.Record(Type.String(), Type.Any())),
		statements: Type.Array(Type.Ref("Statement")),
		bankOwnerAccountId: Type.Number(),
		bankOwnerAccount: Type.Optional(Type.Ref("BankOwnerAccount")),
		job: Type.Optional(Type.Ref("BankJob"))
	}, { $id: "TransactionRun" }));
}));
//#endregion
//#region src/domains/finance/banking/banking.model.ts
var init_banking_model = __esmMin((() => {}));
//#endregion
//#region src/domains/finance/banking/banking.helpers.ts
var isCompleteGuard, isValidated, isReadyForValidation, isReadyForLetterSendout, getStatementId;
var init_banking_helpers = __esmMin((() => {
	init_base_errors();
	isCompleteGuard = ({ bankOwnerAccount }) => [
		"ebicsUrl",
		"partnerId",
		"userId",
		"hostId",
		"ownerName"
	].every((k) => !!bankOwnerAccount[k]);
	isValidated = (bankOwnerAccount) => isCompleteGuard({ bankOwnerAccount }) && bankOwnerAccount.state === "Validated";
	isReadyForValidation = (bankOwnerAccount) => isCompleteGuard({ bankOwnerAccount }) && bankOwnerAccount.state === "ReadyForValidation";
	isReadyForLetterSendout = (bankOwnerAccount) => isCompleteGuard({ bankOwnerAccount }) && bankOwnerAccount.state === "PublicKeysSent" && !!bankOwnerAccount.bankName;
	getStatementId = (statement) => {
		if (!statement.iban || !statement.number) throw new InvalidParamsError(`Need to provide iban AND number to generate statement-id`);
		return `${statement.iban}/${statement.number}`;
	};
}));
//#endregion
//#region src/domains/finance/banking/sepa-mandates.base.ts
var SEPADirectDebitSource, SEPADirectDebitType, SEPADirectDebitStatus;
var init_sepa_mandates_base = __esmMin((() => {
	SEPADirectDebitSource = /* @__PURE__ */ function(SEPADirectDebitSource) {
		SEPADirectDebitSource["Tenant"] = "Tenant";
		SEPADirectDebitSource["Escrow"] = "Escrow";
		return SEPADirectDebitSource;
	}({});
	SEPADirectDebitType = /* @__PURE__ */ function(SEPADirectDebitType) {
		SEPADirectDebitType["Rent"] = "Rent";
		SEPADirectDebitType["WEG"] = "WEG";
		SEPADirectDebitType["AncillaryCosts"] = "AncillaryCosts";
		SEPADirectDebitType["Electricity"] = "Electricity";
		SEPADirectDebitType["Gas"] = "Gas";
		SEPADirectDebitType["PropertyTax"] = "PropertyTax";
		return SEPADirectDebitType;
	}({});
	SEPADirectDebitStatus = /* @__PURE__ */ function(SEPADirectDebitStatus) {
		SEPADirectDebitStatus["Active"] = "Active";
		SEPADirectDebitStatus["Cancelled"] = "Cancelled";
		SEPADirectDebitStatus["Expired"] = "Expired";
		return SEPADirectDebitStatus;
	}({});
}));
//#endregion
//#region src/domains/finance/banking/sepa-mandate.opts.ts
var init_sepa_mandate_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/finance/banking/sepa-mandate.model.ts
var init_sepa_mandate_model = __esmMin((() => {}));
//#endregion
//#region src/domains/finance/banking/sepa-mandates.schemas.ts
var IBaseSEPAMandateSchema, ISEPAMandateSchema, sepaMandateSchemas;
var init_sepa_mandates_schemas = __esmMin((() => {
	init_lib();
	init_sepa_mandates_base();
	IBaseSEPAMandateSchema = Type.Object({
		createdAt: Type.Optional(StringDateSchema),
		updatedAt: Type.Optional(StringDateSchema),
		sepaMandateId: Type.Optional(Type.Number()),
		estateId: Type.Number(),
		mandateReference: Type.String(),
		startDate: TStringDate("date"),
		endDate: TNullable(TStringDate("date")),
		amountLimit: TNullable(Type.Number()),
		source: Type.Enum(SEPADirectDebitSource, { $id: "SEPADirectDebitSource" }),
		mandateType: TEnum(SEPADirectDebitType, { $id: "SEPADirectDebitType" }),
		status: TEnum(SEPADirectDebitStatus, { $id: "SEPADirectDebitStatus" }),
		rentTenancyId: TNullable(Type.Number()),
		companyId: TNullable(Type.Number()),
		bankAccountId: TNullable(Type.Number())
	}, { $id: "SEPAMandateDTO" });
	ISEPAMandateSchema = Type.Intersect([IBaseSEPAMandateSchema, Type.Object({
		rentTenancy: Type.Optional(Type.Unsafe(Type.Any())),
		company: Type.Optional(Type.Unsafe(Type.Any())),
		bankTransactions: Type.Optional(Type.Array(Type.Unsafe(Type.Any()))),
		documents: Type.Optional(Type.Array(Type.Unsafe(Type.Any()))),
		bankAccount: Type.Optional(Type.Unsafe(Type.Any()))
	})], { $id: "SEPAMandateFullDTO" });
	sepaMandateSchemas = {
		IBaseSEPAMandateSchema,
		ISEPAMandateSchema
	};
}));
//#endregion
//#region src/domains/finance/investment/investment-case.model.ts
var InvestmentCaseEvents, InvestmentCaseState, InvestmentCaseType, RentCase, InvestmentCaseOriginFeature, InvestmentCasePickingReason;
var init_investment_case_model = __esmMin((() => {
	InvestmentCaseEvents = /* @__PURE__ */ function(InvestmentCaseEvents) {
		InvestmentCaseEvents["InvestmentUpdated"] = "InvestmentUpdated";
		InvestmentCaseEvents["InvestmentReverted"] = "InvestmentReverted";
		return InvestmentCaseEvents;
	}({});
	InvestmentCaseState = /* @__PURE__ */ function(InvestmentCaseState) {
		InvestmentCaseState["New"] = "New";
		InvestmentCaseState["Submitted"] = "Submitted";
		InvestmentCaseState["Approved"] = "Approved";
		InvestmentCaseState["Rejected"] = "Rejected";
		InvestmentCaseState["Reverted"] = "Reverted";
		InvestmentCaseState["Executed"] = "Executed";
		InvestmentCaseState["Review"] = "Review";
		return InvestmentCaseState;
	}({});
	InvestmentCaseType = /* @__PURE__ */ function(InvestmentCaseType) {
		InvestmentCaseType["Purchasing"] = "Purchasing";
		InvestmentCaseType["Selling"] = "Selling";
		InvestmentCaseType["ICT"] = "ICT";
		return InvestmentCaseType;
	}({});
	RentCase = /* @__PURE__ */ function(RentCase) {
		RentCase["FurnishedApartment"] = "FurnishedApartment";
		RentCase["FlatShare"] = "FlatShare";
		RentCase["Normal"] = "Normal";
		return RentCase;
	}({});
	InvestmentCaseOriginFeature = /* @__PURE__ */ function(InvestmentCaseOriginFeature) {
		InvestmentCaseOriginFeature["SalesPackageBulkCreation"] = "SalesPackageBulkCreation";
		return InvestmentCaseOriginFeature;
	}({});
	InvestmentCasePickingReason = /* @__PURE__ */ function(InvestmentCasePickingReason) {
		InvestmentCasePickingReason["MostProfitable"] = "Most Profitable";
		InvestmentCasePickingReason["BetterLocation"] = "FRF besser geeignet in der Lage, als FFF (Kaufpreise bei FFF sehr optimistisch dargestellt)";
		InvestmentCasePickingReason["DifferentRoomSize"] = "Andere Zimmergröße als besser geeignet für die Lage betrachtet";
		InvestmentCasePickingReason["StandardSufficient"] = "Ausbaustandard FFF für absolut ausreichend angesehen und weiteres Mietpotential bei NOR hat dies dann zum besten Case gemacht";
		InvestmentCasePickingReason["HighStandardAppeal"] = "Fokus auf Ausbaustandard NOR, da die Erfahrung gezeigt hat, dass damit auch anspruchsvolle Zielgruppen angesprochen werden können";
		InvestmentCasePickingReason["KitchensAlwaysConsidered"] = "Küchen sollten erfahrungsgemäß immer berücksichtigt werden, im RM Gebiet";
		return InvestmentCasePickingReason;
	}({});
}));
//#endregion
//#region src/domains/finance/ledger/ledger-entry/ledger-entry.model.ts
var LedgerEntryGroup, accountTypeMap, LedgerEntryAccountCode, LedgerEntryGroupType, LedgerEntryType;
var init_ledger_entry_model = __esmMin((() => {
	init_common();
	LedgerEntryGroup = /* @__PURE__ */ function(LedgerEntryGroup) {
		LedgerEntryGroup["Fee"] = "Fee";
		LedgerEntryGroup["Drawdown"] = "Drawdown";
		LedgerEntryGroup["Repayment"] = "Repayment";
		LedgerEntryGroup["Transfer"] = "Transfer";
		LedgerEntryGroup["Booking"] = "Booking";
		LedgerEntryGroup["Operation"] = "Operation";
		LedgerEntryGroup["PropertyManagement"] = "PropertyManagement";
		LedgerEntryGroup["Storno"] = "Storno";
		LedgerEntryGroup["Tranche"] = "Tranche";
		/**
		* Investor ledger
		*/
		LedgerEntryGroup["Revenue"] = "Revenue";
		LedgerEntryGroup["Asset"] = "Asset";
		LedgerEntryGroup["Liability"] = "Liability";
		LedgerEntryGroup["Expense"] = "Expense";
		LedgerEntryGroup["Equity"] = "Equity";
		/**
		* MFH Asset Ledger
		*/
		LedgerEntryGroup["AssetManagement"] = "AssetManagement";
		return LedgerEntryGroup;
	}({});
	accountTypeMap = {
		["Asset"]: "debit",
		["Expense"]: "debit",
		["Liability"]: "credit",
		["Revenue"]: "credit",
		["Equity"]: "credit",
		["PropertyManagement"]: "credit"
	};
	LedgerEntryAccountCode = /* @__PURE__ */ function(LedgerEntryAccountCode) {
		/**
		* Receivables (MFH)
		*/
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhRentAndLeaseReceivablesVAT"] = 12e3] = "MfhRentAndLeaseReceivablesVAT";
		/**
		* Input Tax (MFH)
		*/
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhInputTaxAllocation"] = 14100] = "MfhInputTaxAllocation";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhInputTax7Percent"] = 14112] = "MfhInputTax7Percent";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhInputTax19Percent"] = 14162] = "MfhInputTax19Percent";
		/**
		* Assets (Debit normal)
		*/
		LedgerEntryAccountCode[LedgerEntryAccountCode["AssetCash"] = 1e3] = "AssetCash";
		LedgerEntryAccountCode[LedgerEntryAccountCode["AssetRentExpected"] = 1100] = "AssetRentExpected";
		LedgerEntryAccountCode[LedgerEntryAccountCode["AssetRentGuarantee"] = 1110] = "AssetRentGuarantee";
		LedgerEntryAccountCode[LedgerEntryAccountCode["AssetLiquidityReserve"] = 1200] = "AssetLiquidityReserve";
		LedgerEntryAccountCode[LedgerEntryAccountCode["AssetHOAFeeSubsidy"] = 1300] = "AssetHOAFeeSubsidy";
		LedgerEntryAccountCode[LedgerEntryAccountCode["AssetPropertyTaxSubsidy"] = 1400] = "AssetPropertyTaxSubsidy";
		LedgerEntryAccountCode[LedgerEntryAccountCode["AssetBankFeeSubsidy"] = 1500] = "AssetBankFeeSubsidy";
		LedgerEntryAccountCode[LedgerEntryAccountCode["AssetLoanAmortizationSubsidy"] = 1600] = "AssetLoanAmortizationSubsidy";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhRentCollectionAccount102"] = 102] = "MfhRentCollectionAccount102";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhRentCollectionAccount103"] = 103] = "MfhRentCollectionAccount103";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhRentCollectionAccount205"] = 205] = "MfhRentCollectionAccount205";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhRentCollectionAccount224"] = 224] = "MfhRentCollectionAccount224";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhRentCollectionAccount225"] = 225] = "MfhRentCollectionAccount225";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhRentCollectionAccount506"] = 506] = "MfhRentCollectionAccount506";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhRentCollectionAccount"] = 18e3] = "MfhRentCollectionAccount";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhSecurityDepositAccount"] = 18100] = "MfhSecurityDepositAccount";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhOperatingAccount"] = 18200] = "MfhOperatingAccount";
		/**
		* Liabilities (Credit normal)
		*/
		LedgerEntryAccountCode[LedgerEntryAccountCode["LiabilityManagementFee"] = 2e3] = "LiabilityManagementFee";
		LedgerEntryAccountCode[LedgerEntryAccountCode["LiabilityHOAFee"] = 2100] = "LiabilityHOAFee";
		LedgerEntryAccountCode[LedgerEntryAccountCode["LiabilityPropertyTax"] = 2200] = "LiabilityPropertyTax";
		LedgerEntryAccountCode[LedgerEntryAccountCode["LiabilityInvoice"] = 2300] = "LiabilityInvoice";
		LedgerEntryAccountCode[LedgerEntryAccountCode["LiabilityLoanAmortization"] = 2400] = "LiabilityLoanAmortization";
		LedgerEntryAccountCode[LedgerEntryAccountCode["LiabilityBankFee"] = 2500] = "LiabilityBankFee";
		LedgerEntryAccountCode[LedgerEntryAccountCode["LiabilityInvestorPayout"] = 2600] = "LiabilityInvestorPayout";
		LedgerEntryAccountCode[LedgerEntryAccountCode["EquityLiquidityReserve"] = 2700] = "EquityLiquidityReserve";
		LedgerEntryAccountCode[LedgerEntryAccountCode["LiabilityAnnualServiceChargeStatement"] = 2800] = "LiabilityAnnualServiceChargeStatement";
		/**
		* MFH Liabilities
		*/
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhBankLoans"] = 31500] = "MfhBankLoans";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhTradePayables19VAT"] = 33e3] = "MfhTradePayables19VAT";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhVATPayable"] = 38e3] = "MfhVATPayable";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhVATPayable19Percent"] = 38062] = "MfhVATPayable19Percent";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhVATPrepayments"] = 38200] = "MfhVATPrepayments";
		/**
		* Clearing/Liability (MFH Credit normal)
		*/
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhDeferredIncome"] = 39e3] = "MfhDeferredIncome";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhSecurityDepositsHeld"] = 35500] = "MfhSecurityDepositsHeld";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhGeneralClearing"] = 36300] = "MfhGeneralClearing";
		/**
		* Expenses (Debit normal)
		*/
		LedgerEntryAccountCode[LedgerEntryAccountCode["ExpenseManagementFee"] = 5e3] = "ExpenseManagementFee";
		LedgerEntryAccountCode[LedgerEntryAccountCode["ExpenseHOAFee"] = 5100] = "ExpenseHOAFee";
		LedgerEntryAccountCode[LedgerEntryAccountCode["ExpenseHOAFeeSettlement"] = 5110] = "ExpenseHOAFeeSettlement";
		LedgerEntryAccountCode[LedgerEntryAccountCode["ExpensePropertyTax"] = 5200] = "ExpensePropertyTax";
		LedgerEntryAccountCode[LedgerEntryAccountCode["ExpenseInvoice"] = 5300] = "ExpenseInvoice";
		LedgerEntryAccountCode[LedgerEntryAccountCode["ExpenseLoanAmortization"] = 5400] = "ExpenseLoanAmortization";
		LedgerEntryAccountCode[LedgerEntryAccountCode["ExpenseBankFee"] = 5500] = "ExpenseBankFee";
		LedgerEntryAccountCode[LedgerEntryAccountCode["ExpenseInvestorPayout"] = 5600] = "ExpenseInvestorPayout";
		LedgerEntryAccountCode[LedgerEntryAccountCode["ExpenseLiquidityReserve"] = 5700] = "ExpenseLiquidityReserve";
		LedgerEntryAccountCode[LedgerEntryAccountCode["ExpenseAnnualServiceChargeStatement"] = 5800] = "ExpenseAnnualServiceChargeStatement";
		/**
		* Expenses (MFH Special Accounts)
		*/
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhSmallDifferences"] = 62500] = "MfhSmallDifferences";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhBankingFees"] = 68550] = "MfhBankingFees";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhElectricityRecoverable"] = 63253] = "MfhElectricityRecoverable";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhElectricityPriorYear"] = 63254] = "MfhElectricityPriorYear";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhHeatingSystemPower"] = 63001] = "MfhHeatingSystemPower";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhVacancyElectricity"] = 63006] = "MfhVacancyElectricity";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhPestControl"] = 63310] = "MfhPestControl";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhWasteCollection"] = 63390] = "MfhWasteCollection";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhWasteCollectionPriorYear"] = 63391] = "MfhWasteCollectionPriorYear";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhBuyerSettlement"] = 18600] = "MfhBuyerSettlement";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhEnergySupplies"] = 51900] = "MfhEnergySupplies";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhMeterInstallation"] = 52011] = "MfhMeterInstallation";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhTenantImprovements"] = 52013] = "MfhTenantImprovements";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhNonDeductibleTax"] = 56e3] = "MfhNonDeductibleTax";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhDepreciation"] = 62e3] = "MfhDepreciation";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhOtherOperatingExpenses"] = 63e3] = "MfhOtherOperatingExpenses";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhOtherRegularOperatingExpensesNonRecoverable"] = 63040] = "MfhOtherRegularOperatingExpensesNonRecoverable";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhEquipmentRental"] = 63110] = "MfhEquipmentRental";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhPropertyTax"] = 63190] = "MfhPropertyTax";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhPropertyTaxNonRecoverable"] = 65600] = "MfhPropertyTaxNonRecoverable";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhGasOilHeating"] = 63200] = "MfhGasOilHeating";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhHeatingSettlementPriorYear"] = 63202] = "MfhHeatingSettlementPriorYear";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhWater"] = 63250] = "MfhWater";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhWastewater"] = 63251] = "MfhWastewater";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhRainwater"] = 63252] = "MfhRainwater";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhGasOilPriorYear"] = 63255] = "MfhGasOilPriorYear";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhInvoicesPriorYear"] = 63258] = "MfhInvoicesPriorYear";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhStreetCleaning"] = 63260] = "MfhStreetCleaning";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhCaretaker"] = 63270] = "MfhCaretaker";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhBuildingCleaning"] = 63300] = "MfhBuildingCleaning";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhKeyManagement"] = 63340] = "MfhKeyManagement";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhWinterServices"] = 63370] = "MfhWinterServices";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhLandscaping"] = 63380] = "MfhLandscaping";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhInsurance"] = 64e3] = "MfhInsurance";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhLiabilityInsurance"] = 64050] = "MfhLiabilityInsurance";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhEmergencyElevatorPhone"] = 64120] = "MfhEmergencyElevatorPhone";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhElevatorMaintenance"] = 64130] = "MfhElevatorMaintenance";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhPlumbingMaintenance"] = 64132] = "MfhPlumbingMaintenance";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhSmokeDetectionMaintenance"] = 64134] = "MfhSmokeDetectionMaintenance";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhRoofStructureMaintenance"] = 64141] = "MfhRoofStructureMaintenance";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhHeatingMaintenance"] = 64142] = "MfhHeatingMaintenance";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhPropertyManagementFee"] = 64310] = "MfhPropertyManagementFee";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhChimneySweep"] = 64390] = "MfhChimneySweep";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhCaretakerServices"] = 64418] = "MfhCaretakerServices";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhFacilityManagement"] = 64419] = "MfhFacilityManagement";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhGeneralRepairs"] = 64460] = "MfhGeneralRepairs";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhElectricalRepairs"] = 64461] = "MfhElectricalRepairs";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhCaretakerMaterials"] = 64470] = "MfhCaretakerMaterials";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhEmergencyServices"] = 64480] = "MfhEmergencyServices";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhSecuritySystemRepairs"] = 64500] = "MfhSecuritySystemRepairs";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhElevatorRepairs"] = 64520] = "MfhElevatorRepairs";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhPlumbingRepairs"] = 64530] = "MfhPlumbingRepairs";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhHeatingRepairs"] = 64600] = "MfhHeatingRepairs";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhOtherEquipmentRepairs"] = 64850] = "MfhOtherEquipmentRepairs";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhRoofStructureRepairs"] = 65530] = "MfhRoofStructureRepairs";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhInsuranceClaims"] = 65529] = "MfhInsuranceClaims";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhGeneralRepairsNonRecoverable"] = 65531] = "MfhGeneralRepairsNonRecoverable";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhPrepaidTenantCosts"] = 65534] = "MfhPrepaidTenantCosts";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhRepairsPriorYearProvision"] = 65550] = "MfhRepairsPriorYearProvision";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhLegalCostsRentClaims"] = 68251] = "MfhLegalCostsRentClaims";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhOperatingSupplies"] = 68500] = "MfhOperatingSupplies";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhExtraordinaryExpenses"] = 69690] = "MfhExtraordinaryExpenses";
		/**
		* Balance Carry-Forward (MFH)
		*/
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhOpeningBalanceGL"] = 9e4] = "MfhOpeningBalanceGL";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhOpeningBalanceAR"] = 90080] = "MfhOpeningBalanceAR";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhOpeningBalanceAP"] = 90090] = "MfhOpeningBalanceAP";
		/**
		* Revenues (Credit normal)
		*/
		LedgerEntryAccountCode[LedgerEntryAccountCode["RevenueRent"] = 4e3] = "RevenueRent";
		LedgerEntryAccountCode[LedgerEntryAccountCode["RevenueRentGuarantee"] = 4010] = "RevenueRentGuarantee";
		LedgerEntryAccountCode[LedgerEntryAccountCode["RevenueLoanAmortizationSubsidy"] = 4100] = "RevenueLoanAmortizationSubsidy";
		LedgerEntryAccountCode[LedgerEntryAccountCode["RevenueHOAFeeSubsidy"] = 4200] = "RevenueHOAFeeSubsidy";
		LedgerEntryAccountCode[LedgerEntryAccountCode["RevenueHOAFeeSettlement"] = 4210] = "RevenueHOAFeeSettlement";
		LedgerEntryAccountCode[LedgerEntryAccountCode["RevenuePropertyTaxSubsidy"] = 4300] = "RevenuePropertyTaxSubsidy";
		LedgerEntryAccountCode[LedgerEntryAccountCode["RevenueBankFeeSubsidy"] = 4400] = "RevenueBankFeeSubsidy";
		LedgerEntryAccountCode[LedgerEntryAccountCode["RevenueAnnualServiceChargeStatement"] = 4500] = "RevenueAnnualServiceChargeStatement";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhStorageRentTaxable"] = 4e4] = "MfhStorageRentTaxable";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhOfficeRentVATFree"] = 41001] = "MfhOfficeRentVATFree";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhResidentialRent"] = 41004] = "MfhResidentialRent";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhStorageRent"] = 41005] = "MfhStorageRent";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhParkingRent"] = 41008] = "MfhParkingRent";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhOperatingCostsVATFree"] = 41032] = "MfhOperatingCostsVATFree";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhOperatingCostsFlat"] = 41034] = "MfhOperatingCostsFlat";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhHeatingCostsVATFree"] = 41035] = "MfhHeatingCostsVATFree";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhRentReduction"] = 41040] = "MfhRentReduction";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhManagementFeeIncome"] = 41150] = "MfhManagementFeeIncome";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhOfficeRentVAT"] = 44001] = "MfhOfficeRentVAT";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhRechargeVAT"] = 44031] = "MfhRechargeVAT";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhStorageRentVAT"] = 44005] = "MfhStorageRentVAT";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhParkingRentVAT"] = 44008] = "MfhParkingRentVAT";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhOperatingCostsVAT"] = 44032] = "MfhOperatingCostsVAT";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhOperatingCostsFlatVAT"] = 44033] = "MfhOperatingCostsFlatVAT";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhOtherOperatingCostsVAT"] = 44034] = "MfhOtherOperatingCostsVAT";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhHeatingCostsVAT"] = 44035] = "MfhHeatingCostsVAT";
		LedgerEntryAccountCode[LedgerEntryAccountCode["MfhManagementFeeVAT"] = 44150] = "MfhManagementFeeVAT";
		return LedgerEntryAccountCode;
	}({});
	LedgerEntryGroupType = {
		...FeeType,
		...LedgerEntryDrawdownType,
		...RepaymentType,
		...LedgerEntryPaymentType,
		...OtherLedgerEntryType,
		...LedgerPropertyManagementType,
		...RevenueEntryType,
		...AssetLedgerEntryType
	};
	LedgerEntryType = /* @__PURE__ */ function(LedgerEntryType) {
		LedgerEntryType["Accrual"] = "Accrual";
		LedgerEntryType["Cash"] = "Cash";
		return LedgerEntryType;
	}({});
}));
//#endregion
//#region src/domains/finance/ledger/ledger-entry/ledger-entry.class.ts
var manualEntryGroup, LedgerEntry;
var init_ledger_entry_class = __esmMin((() => {
	init_base();
	init_ledger_entry_model();
	manualEntryGroup = [
		"Fee",
		"Revenue",
		"Storno",
		"Repayment",
		"Tranche"
	];
	LedgerEntry = class LedgerEntry extends BaseClassAttributes {
		/**
		* Defines if there were any mutations on the record
		* Can be used to determine if the record should be saved
		* @todo: find a better way to track mutations
		*/
		isTouched = false;
		isManual = false;
		ledgerEntryId;
		debit = 0;
		credit = 0;
		entryGroup;
		entryGroupType;
		accountCode;
		rentalContractId;
		externalId;
		source;
		entryDate;
		/**
		* Most important date as it used to perform critical calculations
		* @type {Date}
		*/
		valueDate;
		/**
		* Records added each day as preliminary calculations have type Accrual.
		* Records which are added as result of the bank transactions would have Cash type
		* @type {LedgerEntryType}
		*/
		entryType;
		/**
		* Link to records which is corrected
		* @type {number}
		*/
		parentId;
		generalLedgerId;
		bankTransactionId;
		investorInfoId;
		drawdownId;
		invoiceId;
		estateId;
		userId;
		mfhId;
		/**
		* Entries which corrects current record. Total sum of current record and corrections brings correct amount
		* @type {LedgerEntry[]}
		*/
		children = [];
		/**
		* The same relation from other side
		* @type {LedgerEntry}
		*/
		parent;
		/**
		* Ledger entity which holds this entry
		* @type {GeneralLedger}
		*/
		generalLedger;
		/**
		* Bank transaction which triggered adding this entry
		* @type {BankTransaction}
		*/
		bankTransaction;
		loanDrawdown;
		estate;
		/**
		* data can provide additional context depending on the ledger type
		* E.g. at Property Management Account ledger, data provides allocation relations
		*/
		data = null;
		targetLoanAccountId;
		rentalContractIds = [];
		_fieldsId;
		constructor(props) {
			super(props);
			Object.assign(this, props);
			this.debit = props.debit ?? 0;
			this.credit = props.credit ?? 0;
			if (props?.children?.length) this.children = props.children.map((le) => new LedgerEntry(le));
			this._fieldsId = this.calculateFieldsId();
		}
		get fieldsId() {
			return this._fieldsId;
		}
		/**
		* Calculate amount of current records and all corrections connected to it
		*/
		get totalAmount() {
			const credit = this.credit ?? 0;
			const debit = this.debit ?? 0;
			const balanceAmount = this.isDebitNormal ? debit - credit : credit - debit;
			return round$1((this.children?.reduce((sum, child) => {
				const childAccountType = accountTypeMap[child.entryGroup] || "credit";
				const childCredit = child.credit ?? 0;
				const childDebit = child.debit ?? 0;
				return sum + (childAccountType === "credit" ? childCredit - childDebit : childDebit - childCredit);
			}, 0) ?? 0) + balanceAmount || 0, 2);
		}
		get isDrawdown() {
			return this.entryGroup === "Drawdown";
		}
		get isTransfer() {
			return this.entryGroup === "Drawdown";
		}
		get isInvoiceTransfer() {
			return this.isTransfer && this.isInvoice;
		}
		get isTranche() {
			return this.entryGroup === "Tranche";
		}
		get isInvoice() {
			return this.entryGroupType === LedgerEntryGroupType.Invoice;
		}
		get isPurchasingPrice() {
			return this.entryGroupType === LedgerEntryGroupType.PurchasingPrice;
		}
		get isRepayment() {
			return this.entryGroup === "Repayment";
		}
		get isFee() {
			return this.entryGroup === "Fee";
		}
		get isPrincipalRecord() {
			return this.isDrawdown || this.isRepayment;
		}
		get isInterestType() {
			return this.entryGroupType === "Interest";
		}
		get isCommitmentType() {
			return this.entryGroupType === "Commitment";
		}
		get isProcessingFeeType() {
			return this.entryGroupType === "Processing";
		}
		get isProcessingFeeEntry() {
			return this.entryGroup === "Fee" && this.isProcessingFeeType;
		}
		get isCommitmentFeeEntry() {
			return this.entryGroup === "Fee" && this.isCommitmentType;
		}
		get isInterestFeeEntry() {
			return this.entryGroup === "Fee" && this.isInterestType;
		}
		get isDebitNormal() {
			return accountTypeMap[this.entryGroup] === "debit";
		}
		get isCompensated() {
			if (!this.children.length) return false;
			const debit = this.debit ?? 0;
			const credit = this.credit ?? 0;
			const amount = this.isDebitNormal ? debit - credit : credit - debit;
			return this.totalAmount !== round$1(amount);
		}
		calculateFieldsId() {
			return [
				"entryGroup",
				"entryGroupType",
				"entryType",
				"valueDate",
				"credit",
				"debit",
				"generalLedgerId",
				"parentId",
				"estateId",
				"bankTransactionId",
				"investorInfoId",
				"estateId",
				"accountCode",
				"mfhId",
				"rentalContractId",
				"externalId",
				"entryDate"
			].map((prop) => prop === "valueDate" && this[prop] ? extractDate(this[prop]) : this[prop] ?? "").join("|");
		}
		static getAdjustmentAmount(originalAmount, newAmount) {
			const absX = Math.abs(originalAmount);
			const absY = Math.abs(newAmount);
			if (originalAmount < 0 && newAmount < 0) {
				const diff = Math.min(absX, absY) - Math.max(absX, absY);
				return originalAmount < newAmount ? diff * -1 : diff;
			}
			if (Math.sign(originalAmount) !== Math.sign(newAmount)) return absX + absY;
			return -(originalAmount - newAmount);
		}
		/**
		* For any calculations we would use only records which has value less than day of calculations
		* @param {Date} date
		* @returns {boolean}
		*/
		isInDateScope(date) {
			return dayjs(this.valueDate).isBefore(date, "d");
		}
		addAdjustment(children) {
			const adjustmentAmount = round$1(LedgerEntry.getAdjustmentAmount(this.totalAmount, (children.credit ?? 0) - (children.debit ?? 0)), 2);
			if (adjustmentAmount !== 0) {
				const accountType = accountTypeMap[this.entryGroup] || "credit";
				children.debit = accountType === "debit" && adjustmentAmount > 0 ? Math.abs(adjustmentAmount) : 0;
				children.credit = accountType === "credit" && adjustmentAmount > 0 ? Math.abs(adjustmentAmount) : 0;
				this.addChildren(children);
			}
		}
		addChildren(children) {
			children.parentId = this.ledgerEntryId;
			children.generalLedgerId = this.generalLedgerId;
			const entry = children instanceof LedgerEntry ? children : new LedgerEntry(children);
			entry.isTouched = true;
			this.children?.push(entry);
		}
		copy(override = {}) {
			return new LedgerEntry({
				...this,
				ledgerEntryId: null,
				parentId: null,
				children: [],
				valueDate: null,
				createdAt: void 0,
				updatedAt: void 0,
				isTouched: true,
				...override
			});
		}
	};
}));
//#endregion
//#region src/domains/finance/ledger/ledger-entry/ledger-entry.i18n.ts
var LedgerAccountCodeLabel;
var init_ledger_entry_i18n = __esmMin((() => {
	init_ledger_entry_model();
	LedgerAccountCodeLabel = {
		[1e3]: "Cash/Bank",
		[1100]: "Accounts Receivable (Rent Expected)",
		[1110]: "Accounts Receivable (Rent Guarantee)",
		[1200]: "Liquidity Reserve",
		[1300]: "Accounts Receivable (HOA Fees Subsidy)",
		[1400]: "Accounts Receivable (Property Tax Subsidy)",
		[1500]: "Accounts Receivable (Bank Fee Subsidy)",
		[1600]: "Accounts Receivable (Amortization Subsidy)",
		[2e3]: "Accrued Management Fees",
		[2100]: "Accrued HOA Fees",
		[2200]: "Accrued Property Tax",
		[2300]: "Accrued Invoices",
		[2400]: "Accrued Loan Amortization",
		[2500]: "Accrued Bank Fees",
		[2600]: "Accrued Investor Payout",
		[2800]: "Accrued BKA",
		[2700]: "Liquidity Reserve",
		[5e3]: "Management Fee Expense",
		[5100]: "HOA Fees Expense",
		[5200]: "Property Tax Expense",
		[5300]: "Maintenance Expense (Invoices)",
		[5400]: "Loan Amortization",
		[5500]: "Bank Fees Expense",
		[5600]: "Investor Payout ",
		[5700]: "Liquidity Reserve",
		[5800]: "BKA Expense",
		[5110]: "HOA Fee Settlement (Expense)",
		[4e3]: "Rent Revenue",
		[4010]: "Rent Guarantee Revenue",
		[4100]: "Loan Amortization Subsidy",
		[4200]: "HOA Fees Subsidy",
		[4300]: "Property Tax Subsidy",
		[4400]: "Bank Fee Subsidy",
		[4500]: "BKA Income",
		[4210]: "HOA Fee Settlement (Revenue)",
		[102]: "Rent Collection Account (102)",
		[103]: "Rent Collection Account (103)",
		[205]: "Rent Collection Account (205)",
		[224]: "Rent Collection Account (224)",
		[225]: "Rent Collection Account (225)",
		[506]: "Rent Collection Account (506)",
		[18e3]: "Rent Collection Account",
		[18100]: "Security Deposit Account",
		[18200]: "Operating Account",
		[39e3]: "Deferred Income",
		[35500]: "Security Deposits Held",
		[36300]: "General Clearing",
		[62500]: "Small Differences",
		[68550]: "Banking Fees",
		[63253]: "Electricity (Recoverable)",
		[63254]: "Electricity (Prior Year)",
		[63001]: "Heating System Power",
		[63006]: "Vacancy Electricity",
		[63310]: "Pest Control",
		[63390]: "Waste Collection",
		[63391]: "Waste Collection (Prior Year)",
		[63258]: "Invoices (Prior Year)",
		[52013]: "Tenant Improvements",
		[64141]: "Roof and Structure Maintenance",
		[65529]: "Insurance Claims/Compensation",
		[65550]: "Repairs Prior Year (Provision)",
		[65600]: "Property Tax (Non-Recoverable)",
		[68251]: "Legal Costs: Rent Claims",
		[41001]: "Office Rent (VAT-free)",
		[41004]: "Residential Rent",
		[41005]: "Storage Rent",
		[41008]: "Parking Rent",
		[41032]: "Operating Costs (VAT-free)",
		[41035]: "Heating Costs (VAT-free)",
		[44001]: "Office Rent (with VAT)",
		[44031]: "Recharge (19% VAT)",
		[44032]: "Operating Costs (with VAT)",
		[44035]: "Heating Costs (with VAT)",
		[12e3]: "Rental Receivables (with VAT)",
		[14100]: "Input Tax Allocation",
		[14112]: "Input Tax (7%)",
		[14162]: "Input Tax (19%)",
		[31500]: "Bank Loans Payable",
		[33e3]: "Trade Payables (19% VAT)",
		[38e3]: "VAT Payable",
		[38062]: "VAT Payable (19%)",
		[38200]: "VAT Prepayments",
		[18600]: "Buyer Settlement",
		[4e4]: "Storage Rent (Taxable)",
		[41034]: "Operating Costs (Flat, VAT-free)",
		[41040]: "Rent Reduction",
		[41150]: "Management Fee Income",
		[44005]: "Storage Rent (with VAT)",
		[44008]: "Parking Rent (with VAT)",
		[44033]: "Operating Costs (Flat, with VAT)",
		[44034]: "Other Operating Costs (with VAT)",
		[44150]: "Management Fee (with VAT)",
		[51900]: "Energy Supplies",
		[52011]: "Meter Installation/Renovation",
		[56e3]: "Non-Deductible VAT",
		[62e3]: "Depreciation",
		[63e3]: "Other Operating Expenses",
		[63040]: "Other Regular Operating Expenses (Non-Recoverable)",
		[63110]: "Equipment Rental",
		[63190]: "Property Tax",
		[63200]: "Gas, Oil, District Heating",
		[63202]: "Heating Settlement (Prior Year)",
		[63250]: "Water",
		[63251]: "Wastewater",
		[63252]: "Rainwater",
		[63255]: "Gas, Oil (Prior Year)",
		[63260]: "Street Cleaning",
		[63270]: "Caretaker",
		[63300]: "Building Cleaning",
		[63340]: "Key Management",
		[63370]: "Winter Services",
		[63380]: "Landscaping",
		[64e3]: "Insurance",
		[64050]: "Liability Insurance",
		[64120]: "Emergency Elevator Phone",
		[64130]: "Elevator Maintenance",
		[64132]: "Plumbing Maintenance",
		[64134]: "Smoke Detection Maintenance",
		[64142]: "Heating Maintenance",
		[64310]: "Property Management Fee",
		[64390]: "Chimney Sweep",
		[64418]: "Caretaker Services",
		[64419]: "Facility Management",
		[64460]: "General Repairs",
		[64461]: "Electrical Repairs",
		[64470]: "Caretaker Materials",
		[64480]: "Emergency Services",
		[64500]: "Security System Repairs",
		[64520]: "Elevator Repairs",
		[64530]: "Plumbing Repairs",
		[64600]: "Heating Repairs",
		[64850]: "Other Equipment Repairs",
		[65530]: "Roof Structure Repairs",
		[65531]: "General Repairs (Non-Recoverable)",
		[65534]: "Prepaid Tenant Costs",
		[68500]: "Operating Supplies",
		[69690]: "Extraordinary Expenses",
		[9e4]: "Opening Balance (General Ledger)",
		[90080]: "Opening Balance (Accounts Receivable)",
		[90090]: "Opening Balance (Accounts Payable)"
	};
}));
//#endregion
//#region src/domains/finance/ledger/ledger-entry/index.ts
var init_ledger_entry = __esmMin((() => {
	init_ledger_entry_class();
	init_ledger_entry_model();
	init_ledger_entry_i18n();
}));
//#endregion
//#region src/domains/finance/ledger/investor-ledger-statement/investor-ledger-statement.model.ts
var InvestorLedgerStatementIncomeValuesSchema, InvestorLedgerStatementCashflowValuesSchema, InvestorLedgerStatementBalanceValuesSchema, BaseInvestorLedgerStatementSchema, InvestorLedgerStatementSchema;
var init_investor_ledger_statement_model = __esmMin((() => {
	init_lib();
	InvestorLedgerStatementIncomeValuesSchema = Type.Object({
		rentRevenue: Type.Number({ default: 0 }),
		rentalGuarantee: Type.Number({ default: 0 }),
		loanAmortizationSubsidy: Type.Number({ default: 0 }),
		hoaFeeSubsidy: Type.Number({ default: 0 }),
		propertyTaxSubsidy: Type.Number({ default: 0 }),
		bankFeeSubsidy: Type.Number({ default: 0 }),
		bkaIncome: Type.Number({ default: 0 }),
		otherRevenues: Type.Number({ default: 0 }),
		hoaFeeSettlementRevenue: Type.Number({ default: 0 }),
		managementFeeExpense: Type.Number({ default: 0 }),
		hoaFeeExpense: Type.Number({ default: 0 }),
		propertyTaxExpense: Type.Number({ default: 0 }),
		invoiceExpense: Type.Number({ default: 0 }),
		bankFeesExpense: Type.Number({ default: 0 }),
		liquidityReserve: Type.Number({ default: 0 }),
		investorPayout: Type.Number({ default: 0 }),
		bkaExpense: Type.Number({ default: 0 }),
		hoaFeeSettlementExpense: Type.Number({ default: 0 }),
		otherExpenses: Type.Number({ default: 0 })
	}, { $id: "InvestorLedgerStatementIncomeValues" });
	InvestorLedgerStatementCashflowValuesSchema = Type.Object({
		rentalIncome: Type.Number({ default: 0 }),
		parkingIncome: Type.Number({ default: 0 }),
		rentalGuarantee: Type.Number({ default: 0 }),
		loanAmortizationSubsidy: Type.Number({ default: 0 }),
		hoaFeeSubsidy: Type.Number({ default: 0 }),
		hoaFeeSettlement: Type.Number({ default: 0 }),
		bankFeeSubsidy: Type.Number({ default: 0 }),
		hoaFee: Type.Number({ default: 0 }),
		managementFee: Type.Number({ default: 0 }),
		badDebts: Type.Number({ default: 0 }),
		otherCashflow: Type.Number({ default: 0 }),
		propertyTax: Type.Number({ default: 0 }),
		bankFees: Type.Number({ default: 0 }),
		invoices: Type.Number({ default: 0 }),
		bka: Type.Number({ default: 0 }),
		investorIncome: Type.Number({ default: 0 }),
		returnDebit: Type.Number({ default: 0 }),
		cashAtBeginningOfPeriod: Type.Number({ default: 0 })
	}, { $id: "InvestorLedgerStatementCashflowValues" });
	InvestorLedgerStatementBalanceValuesSchema = Type.Object({
		assetCash: Type.Number({ default: 0 }),
		receivableRentExpected: Type.Number({ default: 0 }),
		receivableRentGuarantee: Type.Number({ default: 0 }),
		receivableHoaFeeSubsidy: Type.Number({ default: 0 }),
		receivablePropertyTaxSubsidy: Type.Number({ default: 0 }),
		receivableBankFeeSubsidy: Type.Number({ default: 0 }),
		receivableLoanAmortizationSubsidy: Type.Number({ default: 0 }),
		accruedManagementFee: Type.Number({ default: 0 }),
		accruedHoaFee: Type.Number({ default: 0 }),
		accruedPropertyTax: Type.Number({ default: 0 }),
		accruedInvoice: Type.Number({ default: 0 }),
		accruedBankFee: Type.Number({ default: 0 }),
		accruedBKA: Type.Number({ default: 0 }),
		accruedInvestorPayout: Type.Number({ default: 0 }),
		deferredRevenue: Type.Number({ default: 0 }),
		equityLiquidityReserve: Type.Number({ default: 0 })
	}, { $id: "InvestorLedgerStatementBalanceValues" });
	BaseInvestorLedgerStatementSchema = Type.Object({
		investorLedgerStatementId: Type.Optional(Type.Number()),
		month: StringDateSchema,
		investorInfoId: Type.Number(),
		estateId: Type.Number(),
		incomeValues: Type.Ref(InvestorLedgerStatementIncomeValuesSchema),
		cashflowValues: Type.Ref(InvestorLedgerStatementCashflowValuesSchema),
		balanceValues: Type.Ref(InvestorLedgerStatementBalanceValuesSchema),
		createdAt: Type.Optional(StringDateSchema),
		updatedAt: Type.Optional(StringDateSchema)
	}, { $id: "BaseInvestorLedgerStatement" });
	InvestorLedgerStatementSchema = Type.Intersect([Type.Ref(BaseInvestorLedgerStatementSchema), Type.Object({
		estate: Type.Optional(Type.Unsafe(Type.Any())),
		investorInfo: Type.Optional(Type.Unsafe(Type.Any()))
	})], { $id: "InvestorLedgerStatement" });
}));
//#endregion
//#region src/domains/finance/ledger/investor-ledger-statement/investor-ledger-statement.class.ts
var regularInvestorLedgerExpenses, sortValuesBy, InvestorLedgerStatement;
var init_investor_ledger_statement_class = __esmMin((() => {
	init_base();
	init_rent_helpers();
	init_ledger_entry();
	init_investor_ledger_statement_model();
	regularInvestorLedgerExpenses = [
		"managementFeeExpense",
		"hoaFeeExpense",
		"hoaFeeSettlementExpense"
	];
	sortValuesBy = (values, fields) => {
		return values.sort((a, b) => {
			return fields.indexOf(a[0]) - fields.indexOf(b[0]);
		});
	};
	InvestorLedgerStatement = class InvestorLedgerStatement extends BaseEntity {
		static revenueFields = [
			"rentRevenue",
			"rentalGuarantee",
			"loanAmortizationSubsidy",
			"hoaFeeSubsidy",
			"hoaFeeSettlementRevenue",
			"propertyTaxSubsidy",
			"bankFeeSubsidy",
			"bkaIncome",
			"otherRevenues"
		];
		static expenseFields = [
			"managementFeeExpense",
			"hoaFeeExpense",
			"hoaFeeSettlementExpense",
			"propertyTaxExpense",
			"invoiceExpense",
			"bankFeesExpense",
			"bkaExpense",
			"otherExpenses"
		];
		static cashflowFields = [
			"rentalIncome",
			"parkingIncome",
			"rentalGuarantee",
			"loanAmortizationSubsidy",
			"hoaFeeSubsidy",
			"hoaFee",
			"hoaFeeSettlement",
			"managementFee",
			"badDebts",
			"propertyTax",
			"bankFees",
			"bankFeeSubsidy",
			"investorIncome",
			"returnDebit",
			"invoices",
			"bka",
			"otherCashflow"
		];
		investorLedgerStatementId;
		month;
		investorInfoId;
		estateId;
		incomeValues;
		cashflowValues;
		balanceValues;
		constructor(props) {
			super(props);
			Object.assign(this, props);
			this.incomeValues = Value.Default(InvestorLedgerStatementIncomeValuesSchema, Value.Clone(props.incomeValues ?? {}));
			this.cashflowValues = Value.Default(InvestorLedgerStatementCashflowValuesSchema, Value.Clone(props.cashflowValues ?? {}));
			this.balanceValues = Value.Default(InvestorLedgerStatementBalanceValuesSchema, Value.Clone(props.balanceValues ?? {}));
		}
		get totalRevenues() {
			const values = _pick(this.incomeValues, InvestorLedgerStatement.revenueFields);
			return safeSum(...Object.values(values));
		}
		get totalExpenses() {
			const values = _pick(this.incomeValues, InvestorLedgerStatement.expenseFields);
			return safeSum(...Object.values(values));
		}
		get investorResultBeforePayout() {
			return this.totalRevenues - this.totalExpenses;
		}
		get investorResultAfterPayout() {
			return this.investorResultBeforePayout - this.incomeValues.investorPayout - this.incomeValues.liquidityReserve;
		}
		get netChangeInCash() {
			return InvestorLedgerStatement.getNetChangeInCash(this.cashflowValues);
		}
		static getNetChangeInCash(cashflowValues) {
			return safeSum(...Object.values(_omit(cashflowValues, [
				"cashAtBeginningOfPeriod",
				"cashAtEndOfPeriod",
				"netChangeInCash"
			])));
		}
		get cashAtEndOfPeriod() {
			return this.cashflowValues.cashAtBeginningOfPeriod + this.netChangeInCash;
		}
		get totalAssets() {
			const { assetCash: availableFunds, receivableRentExpected, receivableRentGuarantee, receivableHoaFeeSubsidy, receivablePropertyTaxSubsidy, receivableBankFeeSubsidy, receivableLoanAmortizationSubsidy } = this.balanceValues;
			return availableFunds + receivableRentExpected + receivableRentGuarantee + receivableHoaFeeSubsidy + receivablePropertyTaxSubsidy + receivableBankFeeSubsidy + receivableLoanAmortizationSubsidy;
		}
		get totalLiabilities() {
			const { accruedManagementFee, accruedHoaFee, accruedPropertyTax, accruedInvoice, accruedBankFee, accruedInvestorPayout } = this.balanceValues;
			return accruedManagementFee + accruedHoaFee + accruedPropertyTax + accruedInvoice + accruedBankFee + accruedInvestorPayout;
		}
		get totalEquityAndLiabilities() {
			return this.totalLiabilities + this.balanceValues.equityLiquidityReserve + this.balanceValues.deferredRevenue;
		}
		static createNew(props) {
			return new InvestorLedgerStatement({
				...props,
				incomeValues: {},
				cashflowValues: {},
				balanceValues: {}
			});
		}
		verifyValues() {
			return {
				cashflowVsBalance: round$1(this.cashAtEndOfPeriod, 2) - round$1(this.balanceValues.assetCash, 2),
				balanceCheck: round$1(this.totalAssets, 2) - round$1(this.totalEquityAndLiabilities, 2),
				negativeEquityAndLiabilities: this.totalEquityAndLiabilities < 0
			};
		}
		static getDefaultValues({ incomeValues = {}, cashflowValues = {}, balanceValues = {} } = {}) {
			return {
				incomeValues: Value.Default(InvestorLedgerStatementIncomeValuesSchema, incomeValues),
				cashflowValues: Value.Default(InvestorLedgerStatementCashflowValuesSchema, cashflowValues),
				balanceValues: Value.Default(InvestorLedgerStatementBalanceValuesSchema, balanceValues)
			};
		}
		calculateValues(month, entries, previousMonthStatement) {
			if (typeof previousMonthStatement === "undefined") throw new Error(`Previous month statement is required (provided: ${extractDate(month)})`);
			const monthEntries = entries.filter((entry) => dayjs(entry.valueDate).isSame(month, "month") && !!entry.accountCode);
			const { incomeValues, cashflowValues, balanceValues } = InvestorLedgerStatement.getDefaultValues();
			cashflowValues.cashAtBeginningOfPeriod = previousMonthStatement?.cashAtEndOfPeriod ?? 0;
			balanceValues.assetCash = previousMonthStatement?.balanceValues.assetCash ?? 0;
			balanceValues.receivableRentExpected = previousMonthStatement?.balanceValues.receivableRentExpected ?? 0;
			balanceValues.receivableRentGuarantee = previousMonthStatement?.balanceValues.receivableRentGuarantee ?? 0;
			balanceValues.receivableHoaFeeSubsidy = previousMonthStatement?.balanceValues.receivableHoaFeeSubsidy ?? 0;
			balanceValues.receivablePropertyTaxSubsidy = previousMonthStatement?.balanceValues.receivablePropertyTaxSubsidy ?? 0;
			balanceValues.receivableBankFeeSubsidy = previousMonthStatement?.balanceValues.receivableBankFeeSubsidy ?? 0;
			balanceValues.receivableLoanAmortizationSubsidy = previousMonthStatement?.balanceValues.receivableLoanAmortizationSubsidy ?? 0;
			balanceValues.accruedManagementFee = previousMonthStatement?.balanceValues.accruedManagementFee ?? 0;
			balanceValues.accruedHoaFee = previousMonthStatement?.balanceValues.accruedHoaFee ?? 0;
			balanceValues.accruedPropertyTax = previousMonthStatement?.balanceValues.accruedPropertyTax ?? 0;
			balanceValues.accruedInvoice = previousMonthStatement?.balanceValues.accruedInvoice ?? 0;
			balanceValues.accruedBankFee = previousMonthStatement?.balanceValues.accruedBankFee ?? 0;
			balanceValues.accruedInvestorPayout = previousMonthStatement?.balanceValues.accruedInvestorPayout ?? 0;
			balanceValues.equityLiquidityReserve = previousMonthStatement?.balanceValues.equityLiquidityReserve ?? 0;
			balanceValues.accruedBKA = previousMonthStatement?.balanceValues.accruedBKA ?? 0;
			monthEntries.forEach((entry) => {
				switch (entry.accountCode) {
					/**
					* Income statement related amounts
					*/
					case 4e3:
						incomeValues.rentRevenue += entry.totalAmount;
						break;
					case 4010:
						incomeValues.rentalGuarantee += entry.totalAmount;
						break;
					case 4100:
						incomeValues.loanAmortizationSubsidy += entry.totalAmount;
						break;
					case 4200:
						incomeValues.hoaFeeSubsidy += entry.totalAmount;
						break;
					case 4300:
						incomeValues.propertyTaxSubsidy += entry.totalAmount;
						break;
					case 4400:
						incomeValues.bankFeeSubsidy += entry.totalAmount;
						break;
					case 4500:
						incomeValues.bkaIncome += entry.totalAmount;
						break;
					case 4210:
						incomeValues.hoaFeeSettlementRevenue += entry.totalAmount;
						break;
					case 5e3:
						incomeValues.managementFeeExpense += entry.totalAmount;
						break;
					case 5100:
						incomeValues.hoaFeeExpense += entry.totalAmount;
						break;
					case 5200:
						incomeValues.propertyTaxExpense += entry.totalAmount;
						break;
					case 5300:
						incomeValues.invoiceExpense += entry.totalAmount;
						break;
					case 5800:
						incomeValues.bkaExpense += entry.totalAmount;
						break;
					case 5110:
						incomeValues.hoaFeeSettlementExpense += entry.totalAmount;
						break;
					case 5500:
						incomeValues.bankFeesExpense += entry.totalAmount;
						break;
					case 5600:
						incomeValues.investorPayout += entry.totalAmount;
						break;
					case 5700:
						incomeValues.liquidityReserve += entry.totalAmount;
						break;
					/**
					* Cashflow statement related amounts
					*/
					case 1e3:
						balanceValues.assetCash += entry.totalAmount;
						switch (entry.entryGroupType) {
							case LedgerEntryGroupType.Rent:
								cashflowValues.rentalIncome += entry.totalAmount;
								break;
							case LedgerEntryGroupType.RentGuarantee:
								cashflowValues.rentalGuarantee += entry.totalAmount;
								break;
							case LedgerEntryGroupType.Parking:
								cashflowValues.parkingIncome += entry.totalAmount;
								break;
							case LedgerEntryGroupType.LoanAmortization:
								cashflowValues.loanAmortizationSubsidy += entry.totalAmount;
								break;
							case LedgerEntryGroupType.HOAFeeSubsidy:
								cashflowValues.hoaFeeSubsidy += entry.totalAmount;
								break;
							case LedgerEntryGroupType.HOAFee:
								cashflowValues.hoaFee += entry.totalAmount;
								break;
							case LedgerEntryGroupType.HOAFeeSettlement:
								cashflowValues.hoaFeeSettlement += entry.totalAmount;
								break;
							case LedgerEntryGroupType.ManagementFee:
								cashflowValues.managementFee += entry.totalAmount;
								break;
							case LedgerEntryGroupType.PropertyTax:
								cashflowValues.propertyTax += entry.totalAmount;
								break;
							case LedgerEntryGroupType.BankFee:
							case LedgerEntryGroupType.ReturnDebitFee:
								cashflowValues.bankFees += entry.totalAmount;
								break;
							case LedgerEntryGroupType.BankFeeCompensation:
								cashflowValues.bankFeeSubsidy += entry.totalAmount;
								break;
							case LedgerEntryGroupType.InvestorIncome:
								cashflowValues.investorIncome += entry.totalAmount;
								break;
							case LedgerEntryGroupType.ReturnDebit:
								cashflowValues.returnDebit += entry.totalAmount;
								break;
							case LedgerEntryGroupType.Invoice:
								cashflowValues.invoices += entry.totalAmount;
								break;
							case LedgerEntryGroupType.AnnualServiceChargeStatement:
								cashflowValues.bka += entry.totalAmount;
								break;
							default:
								cashflowValues.otherCashflow += entry.totalAmount;
								if (entry.totalAmount > 0) incomeValues.otherRevenues += entry.totalAmount;
								else incomeValues.otherExpenses += Math.abs(entry.totalAmount);
								break;
						}
						break;
					/**
					* Balance statement related amounts
					*/
					case 1100:
						balanceValues.receivableRentExpected += entry.totalAmount;
						break;
					case 1110:
						balanceValues.receivableRentGuarantee += entry.totalAmount;
						break;
					case 1300:
						balanceValues.receivableHoaFeeSubsidy += entry.totalAmount;
						break;
					case 1400:
						balanceValues.receivablePropertyTaxSubsidy += entry.totalAmount;
						break;
					case 1500:
						balanceValues.receivableBankFeeSubsidy += entry.totalAmount;
						break;
					case 1600:
						balanceValues.receivableLoanAmortizationSubsidy += entry.totalAmount;
						break;
					case 2e3:
						balanceValues.accruedManagementFee += entry.totalAmount;
						break;
					case 2100:
						balanceValues.accruedHoaFee += entry.totalAmount;
						break;
					case 2200:
						balanceValues.accruedPropertyTax += entry.totalAmount;
						break;
					case 2300:
						balanceValues.accruedInvoice += entry.totalAmount;
						break;
					case 2500:
						balanceValues.accruedBankFee += entry.totalAmount;
						break;
					case 2600:
						balanceValues.accruedInvestorPayout += entry.totalAmount;
						break;
					case 2700:
						balanceValues.equityLiquidityReserve += entry.totalAmount;
						break;
				}
			});
			this.incomeValues = incomeValues;
			this.cashflowValues = cashflowValues;
			this.balanceValues = balanceValues;
			balanceValues.deferredRevenue = (previousMonthStatement?.balanceValues.deferredRevenue ?? 0) + this.investorResultAfterPayout;
		}
		/**
		* It's important to provide statements for 2 subsequent years (current + previous)
		*/
		static calculateGlobalTotals(allStatements, year) {
			const result = {
				incomeValues: {},
				cashflowValues: {},
				balanceValues: {}
			};
			if (!allStatements?.length) return result;
			const statements = allStatements.filter((s) => dayjs(s.month).year() === year);
			const previousYearLastStatement = _maxBy(allStatements.filter((s) => dayjs(s.month).year() === year - 1), (item) => new Date(item.month).getTime());
			const incomeValues = Value.Default(InvestorLedgerStatementIncomeValuesSchema, {});
			const cashflowValues = Value.Default(InvestorLedgerStatementCashflowValuesSchema, {});
			const balanceValues = Value.Default(InvestorLedgerStatementBalanceValuesSchema, {});
			const lastStatement = _maxBy(statements, (item) => new Date(item.month).getTime());
			result.incomeValues.totalRevenues = statements.reduce((acc, s) => safeSum(acc, s.totalRevenues), 0);
			result.incomeValues.totalExpenses = statements.reduce((acc, s) => safeSum(acc, s.totalExpenses), 0);
			result.incomeValues.investorResultBeforePayout = statements.reduce((acc, s) => safeSum(acc, s.investorResultBeforePayout), 0);
			Object.keys(incomeValues).forEach((key) => {
				result.incomeValues[key] = statements.reduce((acc, statement) => safeSum(acc, statement.incomeValues[key]), 0);
			});
			result.incomeValues.investorResultAfterPayout = result.incomeValues.investorResultBeforePayout - result.incomeValues.investorPayout - result.incomeValues.liquidityReserve;
			Object.keys(cashflowValues).forEach((key) => {
				result.cashflowValues[key] = statements.reduce((acc, statement) => safeSum(acc, statement.cashflowValues[key]), 0);
			});
			result.cashflowValues.netChangeInCash = InvestorLedgerStatement.getNetChangeInCash(result.cashflowValues);
			result.cashflowValues.cashAtBeginningOfPeriod = previousYearLastStatement?.cashAtEndOfPeriod ?? 0;
			result.cashflowValues.cashAtEndOfPeriod = result.cashflowValues.cashAtBeginningOfPeriod + result.cashflowValues.netChangeInCash;
			Object.keys(balanceValues).forEach((key) => {
				result.balanceValues[key] = (lastStatement?.balanceValues)?.[key] ?? 0;
			});
			[
				"totalAssets",
				"totalLiabilities",
				"totalEquityAndLiabilities"
			].forEach((key) => {
				result.balanceValues[key] = lastStatement?.[key] ?? 0;
			});
			return result;
		}
		getCurrentTheoreticalInvestorPayout(investorInfo) {
			if (!investorInfo.hasBankAccountSubsidy) return this.totalRevenues - this.totalExpenses - this.incomeValues.liquidityReserve;
			return this.totalRevenues - this.incomeValues.bankFeeSubsidy - (this.totalExpenses - this.incomeValues.bankFeesExpense) - this.incomeValues.liquidityReserve;
		}
		getCurrentCashInvestorPayout(investorInfo, escrowAccountBalance, manualOperations, skipSecurityCalculation = false) {
			const result = {
				revenues: {},
				expenses: {},
				liquidityReserve: 0,
				totalRevenueExpected: 0,
				totalRevenueActual: 0,
				totalExpenseExpected: 0,
				totalExpenseActual: 0,
				payoutExpected: 0,
				payoutActual: 0
			};
			const excludedIncomeKeys = ["investorIncome"];
			if (investorInfo.hasBankAccountSubsidy) excludedIncomeKeys.push("bankFeeSubsidy", "bankFees", "bankFeesExpense");
			Object.entries(this.incomeValues).forEach(([key, amount]) => {
				if (excludedIncomeKeys.includes(key)) return;
				if (InvestorLedgerStatement.revenueFields.includes(key)) {
					const mappedKey = key === "rentalGuarantee" ? "rentRevenue" : key;
					this.ensureBreakdownValue(result.revenues, mappedKey);
					result.revenues[mappedKey].expect += amount;
				}
				if (InvestorLedgerStatement.expenseFields.includes(key)) {
					this.ensureBreakdownValue(result.expenses, key);
					result.expenses[key].expect = regularInvestorLedgerExpenses.includes(key) ? amount : 0;
				}
			});
			Object.entries(this.cashflowValues).forEach(([key, amount]) => {
				if (excludedIncomeKeys.includes(key)) return;
				switch (key) {
					case "rentalIncome":
					case "parkingIncome":
					case "rentalGuarantee":
						result.revenues.rentRevenue.actual += amount;
						break;
					case "loanAmortizationSubsidy":
						result.revenues.loanAmortizationSubsidy.actual += amount;
						break;
					case "hoaFeeSubsidy":
						result.revenues.hoaFeeSubsidy.actual += amount;
						break;
					case "bka":
						if (amount > 0) result.revenues.bkaIncome.actual += amount;
						else result.expenses.bkaExpense.actual += amount;
						break;
					case "hoaFee":
						result.expenses.hoaFeeExpense.actual += amount;
						break;
					case "managementFee":
						result.expenses.managementFeeExpense.actual += amount;
						break;
					case "propertyTax":
						result.expenses.propertyTaxExpense.actual += amount;
						break;
					case "bankFees":
					case "bankFeeSubsidy":
						result.expenses.bankFeesExpense.actual += amount;
						break;
					case "invoices":
						result.expenses.invoiceExpense.actual += amount;
						break;
					case "investorIncome": break;
					case "otherCashflow":
						if (amount > 0) result.revenues.otherRevenues.actual += amount;
						else result.expenses.otherExpenses.actual += amount;
						break;
				}
			});
			if (manualOperations?.length) applyManualAdjustments(manualOperations, result);
			Object.values(result.expenses).forEach((val) => {
				result.totalExpenseExpected += val.expect ?? 0;
				result.totalExpenseActual += val.actual ?? 0;
			});
			Object.values(result.revenues).forEach((val) => {
				result.totalRevenueExpected += val.expect ?? 0;
				result.totalRevenueActual += val.actual ?? 0;
			});
			result.payoutExpected = round$1(result.totalRevenueExpected - result.totalExpenseExpected, 2);
			result.payoutActual = round$1(result.totalRevenueActual + result.totalExpenseActual, 2);
			let availableCash = this.cashflowValues.cashAtBeginningOfPeriod + this.netChangeInCash - this.cashflowValues.investorIncome;
			if (investorInfo.hasBankAccountSubsidy) availableCash = availableCash - this.cashflowValues.bankFeeSubsidy - this.cashflowValues.bankFees;
			if (!skipSecurityCalculation) {
				const expectedLiquidityReserve = investorInfo.security ?? 0;
				const cashAfterLiquidityReserve = Math.max(round$1(escrowAccountBalance - expectedLiquidityReserve, 2), 0);
				const deductToLiquidityReserve = cashAfterLiquidityReserve > 0 ? Math.max(round$1(result.payoutActual - cashAfterLiquidityReserve, 2), 0) : result.payoutActual;
				if (deductToLiquidityReserve) {
					result.liquidityReserve -= deductToLiquidityReserve;
					if (result.liquidityReserve) {
						result.payoutActual -= deductToLiquidityReserve;
						result.totalExpenseActual -= deductToLiquidityReserve;
					}
				}
			}
			return result;
		}
		ensureBreakdownValue(value, key) {
			if (!value[key]) value[key] = {
				expect: 0,
				actual: 0
			};
		}
		static getBreakdownValueSign(value) {
			const roundedExpect = round$1(value.expect ?? 0, 2);
			const roundedActual = round$1(value.actual ?? 0, 2);
			return (!roundedExpect || roundedExpect < 0) && roundedActual <= 0 ? "-" : "+";
		}
	};
}));
//#endregion
//#region src/domains/finance/ledger/investor-ledger-statement/investor-ledger-statement.opts.ts
var init_investor_ledger_statement_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/finance/ledger/investor-ledger-statement/investor-ledger-statement.i18n.ts
var investorLedgerStatementLabel;
var init_investor_ledger_statement_i18n = __esmMin((() => {
	investorLedgerStatementLabel = {
		/**
		* Income
		*/
		rentRevenue: "Rent Revenue",
		loanAmortizationSubsidy: "Loan Amortization Subsidy",
		hoaFeeSubsidy: "HOA Fee Subsidy",
		propertyTaxSubsidy: "Property Tax Subsidy",
		bankFeeSubsidy: "Bank Fee Subsidy",
		managementFeeExpense: "Management Fee Expense",
		hoaFeeExpense: "HOA Fee Expense",
		propertyTaxExpense: "Property Tax Expense",
		invoiceExpense: "Maintenance/Invoice Expense",
		bankFeesExpense: "Bank Fees Expense",
		liquidityReserve: "Liquidity Reserve",
		investorPayout: "Investor Payout",
		otherExpenses: "Other Expenses",
		otherRevenues: "Other Revenues",
		bkaIncome: "BKA Income",
		bkaExpense: "BKA Expense",
		hoaFeeSettlementRevenue: "HOA Fee Settlement",
		hoaFeeSettlementExpense: "HOA Fee Settlement",
		/**
		* Cashflow
		*/
		rentalIncome: "Rental Income",
		parkingIncome: "Parking Income",
		rentalGuarantee: "Rental Guarantee",
		hoaFee: "HOA Fee (non-recoverable)",
		managementFee: "Management Fee",
		badDebts: "Bad Debts",
		otherCashflow: "Other",
		propertyTax: "Property Tax",
		bankFees: "Bank Fees",
		investorIncome: "Investor Income",
		returnDebit: "Return Debit",
		invoices: "Invoices",
		bka: "BKA",
		hoaFeeSettlement: "HOA Fee Settlement",
		cashAtBeginningOfPeriod: "Cash at Beginning of Period",
		/**
		* Balance
		*/
		assetCash: "Cash/Bank",
		receivableRentExpected: "A/R (Rent Expected)",
		receivableRentGuarantee: "A/R (Rent Guarantee)",
		receivableHoaFeeSubsidy: "A/R (HOA Fee Subsidy)",
		receivablePropertyTaxSubsidy: "A/R (Property Tax Subsidy)",
		receivableBankFeeSubsidy: "A/R (Bank Fee Subsidy)",
		receivableLoanAmortizationSubsidy: "A/R (Loan Amortization Subsidy)",
		accruedManagementFee: "Accrued Management Fee",
		accruedHoaFee: "Accrued HOA Fee",
		accruedPropertyTax: "Accrued Property Tax",
		accruedInvoice: "Accrued Invoice",
		accruedBankFee: "Accrued Bank Fee",
		accruedInvestorPayout: "Accrued Investor Payout",
		accruedBKA: "Accrued BKA",
		deferredRevenue: "Deferred Revenue",
		equityLiquidityReserve: "Liquidity Reserve"
	};
}));
//#endregion
//#region src/domains/finance/ledger/investor-ledger-statement/index.ts
var init_investor_ledger_statement = __esmMin((() => {
	init_investor_ledger_statement_class();
	init_investor_ledger_statement_model();
	init_investor_ledger_statement_opts();
	init_investor_ledger_statement_i18n();
}));
//#endregion
//#region src/domains/renting/monthly-investor-share/monthly-investor-share.class.ts
var MonthlyInvestorShare;
var init_monthly_investor_share_class = __esmMin((() => {
	init_investor_ledger_statement();
	MonthlyInvestorShare = class {
		monthlyInvestorShareId;
		investorInfoId;
		month;
		investorShare;
		theoreticalInvestorShare;
		realInvestorShare;
		excludedFromPayment;
		operations;
		investorShareHistory;
		checked;
		tenantBankAccountAdjustmentFees;
		otherOutgoingCosts;
		otherIncomingCosts;
		previousInvestorSharePaymentAmount;
		previousInvestorSharePaidAt;
		investorSharePaymentAmount;
		investorSharePaidAt;
		rentPaymentAmount;
		rentPaidAt;
		managementFeePaymentAmount;
		managementFeePaidAt;
		managementFee;
		homeOwnerFeePaymentAmount;
		homeOwnersFeePaidAt;
		homeOwnerFee;
		security;
		balanceRecordTotalBalance;
		rentalIncome;
		rentBalance;
		startDate;
		deviation;
		excludedReason;
		payslipSentAt;
		payslipNote;
		statementValues;
		payoutDate;
		investorInfo;
		specialDealAdjustments;
		documentId;
		bankTransactionId;
		createdAt;
		status;
		constructor(props) {
			Object.assign(this, props);
		}
		getPayoutBreakdown(investorInfo, skipSecurityCalculation = false) {
			return new InvestorLedgerStatement({
				month: new Date(this.month),
				investorInfoId: this.investorInfoId,
				...this.statementValues
			}).getCurrentCashInvestorPayout(investorInfo, this.balanceRecordTotalBalance ?? 0, this.operations?.operationRows, skipSecurityCalculation);
		}
	};
}));
//#endregion
//#region src/domains/renting/monthly-investor-share/monthly-investor-share.model.ts
var InvestorShareOperator, PaymentOrderFileName, MonthlyInvestorShareStatus, InvestorShareOperationEnumKey, MonthlyInvestorShareExcludedReason, adjustmentToBreakdownMapping;
var init_monthly_investor_share_model = __esmMin((() => {
	InvestorShareOperator = /* @__PURE__ */ function(InvestorShareOperator) {
		InvestorShareOperator["Add"] = "Add";
		InvestorShareOperator["Sub"] = "Sub";
		return InvestorShareOperator;
	}({});
	PaymentOrderFileName = /* @__PURE__ */ function(PaymentOrderFileName) {
		PaymentOrderFileName["InvestorShare"] = "InvestorSharePayment";
		PaymentOrderFileName["Sev"] = "SevPayment";
		return PaymentOrderFileName;
	}({});
	MonthlyInvestorShareStatus = /* @__PURE__ */ function(MonthlyInvestorShareStatus) {
		MonthlyInvestorShareStatus["New"] = "New";
		MonthlyInvestorShareStatus["ReadyToGenerate"] = "ReadyToGenerate";
		MonthlyInvestorShareStatus["ReadyToSend"] = "ReadyToSend";
		MonthlyInvestorShareStatus["Sent"] = "Sent";
		MonthlyInvestorShareStatus["Delivered"] = "Delivered";
		return MonthlyInvestorShareStatus;
	}({});
	InvestorShareOperationEnumKey = /* @__PURE__ */ function(InvestorShareOperationEnumKey) {
		InvestorShareOperationEnumKey["Rent"] = "Rent";
		InvestorShareOperationEnumKey["RentGuarantee"] = "RentGuarantee";
		InvestorShareOperationEnumKey["RentReduction"] = "RentReduction";
		InvestorShareOperationEnumKey["Housegeld"] = "Housegeld";
		InvestorShareOperationEnumKey["ReimbursementNonAllocatableHousegeld"] = "ReimbursementNonAllocatableHousegeld";
		InvestorShareOperationEnumKey["ManagementFee"] = "ManagementFee";
		InvestorShareOperationEnumKey["ReimbursementManagementFee"] = "ReimbursementManagementFee";
		InvestorShareOperationEnumKey["BankFee"] = "BankFee";
		InvestorShareOperationEnumKey["BankFeeSubsidy"] = "BankFeeSubsidy";
		InvestorShareOperationEnumKey["RepaymentSubsidy"] = "RepaymentSubsidy";
		InvestorShareOperationEnumKey["HoaFeeSubsidy"] = "HoaFeeSubsidy";
		InvestorShareOperationEnumKey["Invoice"] = "Invoice";
		InvestorShareOperationEnumKey["PropertyTax"] = "PropertyTax";
		InvestorShareOperationEnumKey["BkaIncome"] = "BkaIncome";
		InvestorShareOperationEnumKey["BkaExpense"] = "BkaExpense";
		InvestorShareOperationEnumKey["AccountingResult"] = "AccountingResult";
		InvestorShareOperationEnumKey["RecalculationOfWP"] = "RecalculationOfWP";
		InvestorShareOperationEnumKey["SpecialAllocation"] = "SpecialAllocation";
		InvestorShareOperationEnumKey["BuildingLiquidityReserves"] = "BuildingLiquidityReserves";
		InvestorShareOperationEnumKey["LiquidityReserve"] = "LiquidityReserve";
		InvestorShareOperationEnumKey["AccountFundsNotSufficient"] = "AccountFundsNotSufficient";
		InvestorShareOperationEnumKey["OtherRevenue"] = "OtherRevenue";
		InvestorShareOperationEnumKey["OtherExpense"] = "OtherExpense";
		InvestorShareOperationEnumKey["Other"] = "Other";
		return InvestorShareOperationEnumKey;
	}({});
	MonthlyInvestorShareExcludedReason = /* @__PURE__ */ function(MonthlyInvestorShareExcludedReason) {
		MonthlyInvestorShareExcludedReason["NoOwnersAssigned"] = "NoOwnersAssigned";
		MonthlyInvestorShareExcludedReason["InvestorLedgerNotFound"] = "InvestorLedgerNotFound";
		MonthlyInvestorShareExcludedReason["LowCashReserve"] = "LowCashReserve";
		MonthlyInvestorShareExcludedReason["Other"] = "Other";
		return MonthlyInvestorShareExcludedReason;
	}({});
	adjustmentToBreakdownMapping = {
		Rent: "revenues.rentRevenue",
		RentGuarantee: "revenues.rentalGuarantee",
		RentReduction: "revenues.rentRevenue",
		Housegeld: "expenses.hoaFeeExpense",
		ReimbursementNonAllocatableHousegeld: "expenses.hoaFeeExpense",
		ManagementFee: "expenses.managementFeeExpense",
		ReimbursementManagementFee: "expenses.managementFeeExpense",
		RepaymentSubsidy: "revenues.loanAmortizationSubsidy",
		HoaFeeSubsidy: "revenues.hoaFeeSubsidy",
		Invoice: "expenses.invoiceExpense",
		PropertyTax: "expenses.propertyTaxExpense",
		BuildingLiquidityReserves: "liquidityReserve",
		LiquidityReserve: "liquidityReserve",
		BankFee: "expenses.bankFeesExpense",
		BankFeeSubsidy: "expenses.bankFeeSubsidy",
		BkaIncome: "revenues.bkaIncome",
		BkaExpense: "expenses.bkaExpense",
		OtherRevenue: "revenues.otherRevenues",
		OtherExpense: "expenses.otherExpenses",
		AccountingResult: "expenses.AccountingResult"
	};
}));
//#endregion
//#region src/domains/renting/monthly-investor-share/monthly-investor-share.i18n.ts
var InvestorShareOperationNote, InvestorShareBreakdownLabels, MonthlyInvestorShareExcludedReasonLabels;
var init_monthly_investor_share_i18n = __esmMin((() => {
	InvestorShareOperationNote = {
		Rent: "Miete",
		RentGuarantee: "Mietgarantie",
		RentReduction: "Mietminderung",
		Housegeld: "Hausgeld",
		ReimbursementNonAllocatableHousegeld: "Erstattung nicht umlagef. Hausgeld",
		ManagementFee: "Verwaltergebühr",
		ReimbursementManagementFee: "Erstattung Verwaltergebühr",
		RepaymentSubsidy: "Tilgungszuschuss",
		HoaFeeSubsidy: "Hausgeld Deal Payback",
		Invoice: "Rechnung",
		PropertyTax: "Grundsteuer",
		BkaIncome: "Betriebskostenabrechnung (Einnahmen)",
		BkaExpense: "Betriebskostenabrechnung (Ausgaben)",
		BankFee: "Bankgebühren",
		BankFeeSubsidy: "Erstattung Bankgebühr",
		AccountingResult: "Abrechnungsergebnis",
		RecalculationOfWP: "Nachberechnung WP",
		SpecialAllocation: "Sonderumlage",
		BuildingLiquidityReserves: "Aufbau Liquiditätsreserve",
		LiquidityReserve: "Liquiditätsrücklage",
		AccountFundsNotSufficient: "Konto nicht ausreichend gedeckt",
		OtherRevenue: "Sonstige Einnahmen",
		OtherExpense: "Sonstige Kosten",
		Other: "Sonstige"
	};
	InvestorShareBreakdownLabels = {
		rentRevenue: "Mieteinnahmen",
		rentalGuarantee: "Mietgarantie",
		loanAmortizationSubsidy: "Tilgungszuschuss",
		hoaFeeSubsidy: "Hausgeld Deal Payback",
		propertyTaxSubsidy: "Grundsteuer Deal Payback",
		bankFeeSubsidy: "Erstattung Bankgebühr",
		otherRevenues: "Sonstige Einnahmen",
		managementFeeExpense: "Verwaltergebühr",
		hoaFeeExpense: "Hausgeld",
		hoaFeeSettlementRevenue: "Hausgeldabrechnung",
		hoaFeeSettlementExpense: "Hausgeldabrechnung",
		propertyTaxExpense: "Grundsteuer",
		invoiceExpense: "Instandhaltungsrechnung / Kosten",
		bankFeesExpense: "Bankgebühren",
		otherExpenses: "Sonstige Kosten",
		bkaIncome: "Betriebskostenabrechnung",
		bkaExpense: "Betriebskostenabrechnung"
	};
	MonthlyInvestorShareExcludedReasonLabels = {
		["LowCashReserve"]: "Not sufficient fund on escrow account (min. 600 EUR)",
		["InvestorLedgerNotFound"]: "Unable to calculate the payout amounts due to missing investor ledge data",
		["NoOwnersAssigned"]: `Current owner doesn't have any person/company assigned`,
		["Other"]: "Excluded for other reason"
	};
}));
//#endregion
//#region src/domains/renting/monthly-investor-share/monthly-investor-share.opts.ts
var init_monthly_investor_share_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/renting/monthly-investor-share/index.ts
var init_monthly_investor_share = __esmMin((() => {
	init_monthly_investor_share_class();
	init_monthly_investor_share_i18n();
	init_monthly_investor_share_model();
	init_monthly_investor_share_opts();
}));
//#endregion
//#region src/domains/renting/rent-helpers.ts
function resolveEndDate(startDate, years) {
	if (!years) return null;
	return dayjs(startDate).add(years, "years").subtract(1, "day").toDate();
}
function applyManualAdjustments(operations, result) {
	operations.forEach((row) => {
		const isExpense = row.operator === "Sub";
		const amount = row.amount * (isExpense ? -1 : 1);
		const path = row.key && adjustmentToBreakdownMapping[row.key];
		const subKey = row.isExpectedValue ? "expect" : "actual";
		if (path) {
			if (path === "liquidityReserve") _set(result, path, _get(result, path, 0) + amount);
			else {
				if (row.note) _set(result, `${path}.label`, row.note);
				_set(result, `${path}.${subKey}`, _get(result, `${path}.${subKey}`, 0) + amount);
				_set(result, `${path}.isManual`, true);
			}
			if (row.key === "Rent" && "periods" in _get(result, path, {})) {
				const periods = _get(result, `${path}.periods`, {});
				const firstPeriodKey = Object.keys(periods)[0];
				if (firstPeriodKey) _set(result, `${path}.periods["${firstPeriodKey}"].${subKey}`, _get(result, `${path}.periods["${firstPeriodKey}"].${subKey}`, 0) + amount);
			}
		} else {
			const path = `${isExpense ? "expenses" : "revenues"}.${row.key || row.note?.replace(/[^a-zA-Z0-9]/g, "_") || "other"}`;
			_set(result, `${path}.${subKey}`, amount);
			_set(result, `${path}.isManual`, true);
			if (row.note) _set(result, `${path}.label`, row.note);
		}
	});
}
function sameMonth(date1, date2) {
	return dayjs(date1).isSame(date2, "month");
}
function getPeriodLabel(start, end) {
	return `${formatDate$1(start, DateFormats.SimpleDate, localeDe)} - ${formatDate$1(end, DateFormats.SimpleDate, localeDe)}`;
}
function daysInPeriod(start, end) {
	return Math.round(dayjs(end).diff(dayjs(start), "day"));
}
var isActivePeriod, getHalfMonthRatio, getRatioForMonth, isActiveAtDate, isActiveForMonth, isActiveForYear, getDateRangeLabel, generateRandomString, RentCaseTranslations, translateRentCase, RentableUnitStatesTranslations, sortObject;
var init_rent_helpers = __esmMin((() => {
	init_monthly_investor_share();
	dayjs.extend(isBetween);
	dayjs.extend(isSameOrAfter);
	dayjs.extend(dayjsUtc);
	isActivePeriod = ({ startDate, endDate }, date) => {
		if (!startDate) return void 0;
		const now = date ? dayjs(date).utc() : dayjs.utc();
		if (!endDate) return now.isSameOrAfter(startDate ?? null, "d");
		return now.isBetween(startDate ?? null, endDate ?? null, "d", "[]");
	};
	getHalfMonthRatio = (date, dateKind) => {
		const day = dayjs(date).date();
		if (dateKind === "start") return day >= 15 ? .5 : 1;
		return day <= 15 ? .5 : 1;
	};
	getRatioForMonth = ({ startDate, endDate }, date) => {
		if (!startDate) throw new Error("Start date is required when calculating ratio for month");
		const isCursorOnStartDate = sameMonth(date, new Date(startDate));
		const isCursorOnEndDate = !!endDate && sameMonth(date, new Date(endDate));
		if (isCursorOnStartDate) return getHalfMonthRatio(new Date(startDate), "start");
		if (isCursorOnEndDate) return getHalfMonthRatio(new Date(endDate), "end");
		return 1;
	};
	isActiveAtDate = (date, { startDate, endDate }) => {
		if (!startDate) return false;
		const now = dayjs(date);
		if (!endDate) return now.isSameOrAfter(startDate, "d");
		return now.isBetween(startDate, endDate ?? null, "d", "[]");
	};
	isActiveForMonth = (date, { startDate, endDate }) => {
		if (!startDate) return false;
		const inputDate = dayjs(date);
		if (!endDate) return inputDate.isSameOrAfter(startDate, "month");
		return inputDate.isBetween(startDate, endDate ?? null, "month", "[]");
	};
	isActiveForYear = (year, period) => {
		const startOfYear = `${year}-01-01`;
		const endOfYear = `${year}-12-31`;
		if (!period.startDate || !year) return false;
		const endDate = period.endDate ?? /* @__PURE__ */ new Date();
		return dayjs(period.startDate).isBetween(startOfYear, endOfYear, "year", "[]") || dayjs(endDate).isBetween(startOfYear, endOfYear, "year", "[]") || dayjs(startOfYear).isBetween(period.startDate, endDate, "year", "[]") || dayjs(endOfYear).isBetween(period.startDate, endDate, "year", "[]");
	};
	getDateRangeLabel = (startDate, endDate) => {
		return `${startDate ? dayjs(startDate).format("DD.MM.YY") : "n/a"} - ${endDate ? dayjs(endDate).format("DD.MM.YY") : "∞"}`;
	};
	generateRandomString = () => {
		const charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
		let result = "";
		for (let i = 0; i < 8; i++) {
			const randomIndex = Math.floor(Math.random() * 36);
			result += charset[randomIndex];
		}
		return result;
	};
	RentCaseTranslations = {
		["FlatShare"]: "WG",
		["FurnishedApartment"]: "Möbliert",
		["Normal"]: "Normal"
	};
	translateRentCase = (type) => type ? RentCaseTranslations[type] : "Eigennutzer";
	RentableUnitStatesTranslations = {
		["Vacant"]: "Im Vermietungsprozess",
		["PartiallyOccupied"]: "Im Vermietungsprozess",
		["Occupied"]: "Vermietet",
		["BlockedByPm"]: "Im Vermietungsprozess",
		["BlockedByRenovation"]: "Im Vermietungsprozess",
		["OwnerOccupied"]: "Eigennutzung"
	};
	sortObject = (array, order = "asc", nullLast = false) => {
		return array.toSorted((a, b) => {
			if (!a.startDate || !b.startDate) return nullLast ? -1 : 0;
			const comparison = new Date(a.startDate).getTime() - new Date(b.startDate).getTime();
			return order === "asc" ? comparison : -comparison;
		});
	};
}));
//#endregion
//#region src/domains/renting/base-period.class.ts
var BasePeriodClass;
var init_base_period_class = __esmMin((() => {
	init_base();
	init_rent_helpers();
	BasePeriodClass = class extends BaseEntity {
		startDate;
		endDate;
		/**
		* @returns `boolean` if it was possible to calculate the date range
		* @returns `undefined` date range could not be calculated (**e.g. missing start date**)
		*/
		get isActive() {
			return isActivePeriod({
				startDate: this.startDate,
				endDate: this.endDate
			});
		}
		static isActive({ startDate, endDate }) {
			return isActivePeriod({
				startDate,
				endDate
			});
		}
		get isInFuture() {
			return this.getIsFuture(/* @__PURE__ */ new Date());
		}
		get isInPast() {
			return this.getIsInPast(/* @__PURE__ */ new Date());
		}
		isActiveInMonth(month) {
			const startOfCurrentMonth = dayjs(month).startOf("month");
			const endOfCurrentMonth = dayjs(month).endOf("month");
			if (!this.endDate) return endOfCurrentMonth.isSameOrAfter(this.startDate ?? null, "d");
			return endOfCurrentMonth.isSameOrAfter(this.startDate ?? null, "d") && dayjs(this.endDate ?? null).isSameOrAfter(startOfCurrentMonth);
		}
		getIsActive(date) {
			return isActivePeriod({
				startDate: this.startDate,
				endDate: this.endDate
			}, date);
		}
		getIsFuture(date) {
			return dayjs(date).utc().isBefore(this.startDate ?? null, "d");
		}
		getIsInPast(date) {
			return dayjs(date).utc().isAfter(this.endDate ?? null, "d");
		}
		get dateRangeLabel() {
			return getDateRangeLabel(this.startDate, this.endDate);
		}
		getDurationInMonths(excludeLastMonth = false) {
			return dayjs.utc(this.endDate ?? /* @__PURE__ */ new Date()).diff(this.startDate, "month") + (excludeLastMonth ? 0 : 1);
		}
	};
}));
//#endregion
//#region src/domains/renting/rent-tenancy.model.ts
var TenancyType, RentApartmentCondition, CondoSalesCondition, TenancyTypeEnumSchema, BaseRentTenancySchema, TenantSupportCategory, TenantFaqCategory, tenantFaqCategoryIconMapper, TenantFaqQuestion, tenantFaqQuestionMapper, TenantSupportSubCategory, TenantSupportSubCategoryMap;
var init_rent_tenancy_model = __esmMin((() => {
	init_lib();
	TenancyType = /* @__PURE__ */ function(TenancyType) {
		TenancyType["MainTenancy"] = "MainTenancy";
		TenancyType["SubTenancy"] = "SubTenancy";
		TenancyType["ParkingTenancy"] = "ParkingTenancy";
		return TenancyType;
	}({});
	RentApartmentCondition = /* @__PURE__ */ function(RentApartmentCondition) {
		RentApartmentCondition["Refurbished"] = "Refurbished";
		RentApartmentCondition["Old"] = "Old";
		RentApartmentCondition["Rentable"] = "Rentable";
		return RentApartmentCondition;
	}({});
	CondoSalesCondition = /* @__PURE__ */ function(CondoSalesCondition) {
		CondoSalesCondition["EEOnly"] = "EEOnly";
		CondoSalesCondition["EEOnlyPlusTI"] = "EEOnlyPlusTI";
		CondoSalesCondition["EEOnlyPlusTIGuarantee"] = "EEOnlyPlusTIGuarantee";
		return CondoSalesCondition;
	}({});
	TenancyTypeEnumSchema = TEnum(TenancyType, { $id: "TenancyTypeEnum" });
	BaseRentTenancySchema = Type.Object({
		rentTenancyId: Type.Number(),
		creatorId: Type.Optional(TNullable(Type.Number())),
		dunningStatusLevel: Type.Optional(Type.Number()),
		latestDunningNoticeDate: Type.Optional(StringDateSchema),
		rentBalance: Type.Optional(Type.Number()),
		tenantBankAccountId: Type.Optional(Type.Number()),
		transactionReferenceId: Type.Optional(Type.String()),
		estarCoreTenantId: Type.Optional(Type.String())
	}, { $id: "BaseRentTenancy" });
	TenantSupportCategory = /* @__PURE__ */ function(TenantSupportCategory) {
		TenantSupportCategory["RepairApartment"] = "RepairApartment";
		TenantSupportCategory["QuestionAboutApartment"] = "QuestionAboutApartment";
		TenantSupportCategory["Contract"] = "Contract";
		TenantSupportCategory["Payments"] = "Payments";
		TenantSupportCategory["Invoices"] = "Invoices";
		return TenantSupportCategory;
	}({});
	TenantFaqCategory = /* @__PURE__ */ function(TenantFaqCategory) {
		TenantFaqCategory["RepairApartment"] = "RepairApartment";
		TenantFaqCategory["QuestionAboutApartment"] = "QuestionAboutApartment";
		TenantFaqCategory["Contract"] = "Contract";
		TenantFaqCategory["Payments"] = "Payments";
		TenantFaqCategory["Invoices"] = "Invoices";
		TenantFaqCategory["PropertyManagement"] = "PropertyManagement";
		return TenantFaqCategory;
	}({});
	tenantFaqCategoryIconMapper = {
		["RepairApartment"]: "fa-hammer",
		["QuestionAboutApartment"]: "fa-house",
		["Contract"]: "fa-file-signature",
		["Payments"]: "fa-money-check-pen",
		["Invoices"]: "fa-file-invoice-dollar",
		["PropertyManagement"]: "fa-house-user"
	};
	TenantFaqQuestion = /* @__PURE__ */ function(TenantFaqQuestion) {
		TenantFaqQuestion["HousingProviderConfirmation"] = "HousingProviderConfirmation";
		TenantFaqQuestion["RentDebtFreeCertificate"] = "RentDebtFreeCertificate";
		TenantFaqQuestion["ContractCopy"] = "ContractCopy";
		TenantFaqQuestion["KeyLost"] = "KeyLost";
		TenantFaqQuestion["SmokeDetectorsAndHeatCostsAllocators"] = "SmokeDetectorsAndHeatCostsAllocators";
		TenantFaqQuestion["Handover"] = "Handover";
		TenantFaqQuestion["RentAmountChange"] = "RentAmountChange";
		TenantFaqQuestion["BankAccountChange"] = "BankAccountChange";
		TenantFaqQuestion["ExtraCosts"] = "ExtraCosts";
		TenantFaqQuestion["RentPayment"] = "RentPayment";
		TenantFaqQuestion["RegisterUtilities"] = "RegisterUtilities";
		TenantFaqQuestion["AncillaryCostStatement"] = "AncillaryCostStatement";
		TenantFaqQuestion["ProblemNeighbour"] = "ProblemNeighbour";
		TenantFaqQuestion["ThirdParties"] = "ThirdParties";
		TenantFaqQuestion["AppartmentChanges"] = "AppartmentChanges";
		TenantFaqQuestion["Sublease"] = "Sublease";
		TenantFaqQuestion["Pets"] = "Pets";
		TenantFaqQuestion["CloggedSink"] = "CloggedSink";
		TenantFaqQuestion["HeatingBroken"] = "HeatingBroken";
		TenantFaqQuestion["HouseholdInsurance"] = "HouseholdInsurance";
		TenantFaqQuestion["SmallRepairs"] = "SmallRepairs";
		TenantFaqQuestion["BeautyRepairs"] = "BeautyRepairs";
		TenantFaqQuestion["WaterDamage"] = "WaterDamage";
		return TenantFaqQuestion;
	}({});
	tenantFaqQuestionMapper = {
		["RepairApartment"]: [
			"CloggedSink",
			"HeatingBroken",
			"HouseholdInsurance",
			"SmallRepairs",
			"BeautyRepairs",
			"WaterDamage"
		],
		["QuestionAboutApartment"]: [
			"KeyLost",
			"SmokeDetectorsAndHeatCostsAllocators",
			"Handover"
		],
		["Contract"]: [
			"RentDebtFreeCertificate",
			"HousingProviderConfirmation",
			"ContractCopy"
		],
		["Payments"]: [
			"RentAmountChange",
			"BankAccountChange",
			"ExtraCosts",
			"RentPayment"
		],
		["Invoices"]: ["RegisterUtilities", "AncillaryCostStatement"],
		["PropertyManagement"]: [
			"ProblemNeighbour",
			"ThirdParties",
			"AppartmentChanges",
			"Sublease",
			"Pets"
		]
	};
	TenantSupportSubCategory = /* @__PURE__ */ function(TenantSupportSubCategory) {
		TenantSupportSubCategory["Other"] = "Other";
		TenantSupportSubCategory["Interior"] = "Interior";
		TenantSupportSubCategory["WaterOrHeatingOrSanitary"] = "WaterOrHeatingOrSanitary";
		TenantSupportSubCategory["Electric"] = "Electric";
		TenantSupportSubCategory["InternetOrCableOrTV"] = "InternetOrCableOrTV";
		TenantSupportSubCategory["HumidityOrMold"] = "HumidityOrMold";
		TenantSupportSubCategory["PaintingOrWalls"] = "PaintingOrWalls";
		TenantSupportSubCategory["SmokeDetectorOrHeatCostAllocator"] = "SmokeDetectorOrHeatCostAllocator";
		TenantSupportSubCategory["DoorbellOrLetterbox"] = "DoorbellOrLetterbox";
		TenantSupportSubCategory["DoorsOrWindows"] = "DoorsOrWindows";
		TenantSupportSubCategory["Handover"] = "Handover";
		TenantSupportSubCategory["Keys"] = "Keys";
		TenantSupportSubCategory["MeterReadings"] = "MeterReadings";
		TenantSupportSubCategory["BalconyOrTerrace"] = "BalconyOrTerrace";
		TenantSupportSubCategory["Cellar"] = "Cellar";
		TenantSupportSubCategory["Parking"] = "Parking";
		TenantSupportSubCategory["RentalContract"] = "RentalContract";
		TenantSupportSubCategory["HandoverProtocol"] = "HandoverProtocol";
		TenantSupportSubCategory["Termination"] = "Termination";
		TenantSupportSubCategory["LandlordConfirmation"] = "LandlordConfirmation";
		TenantSupportSubCategory["RentPayments"] = "RentPayments";
		TenantSupportSubCategory["AncillaryCostBilling"] = "AncillaryCostBilling";
		TenantSupportSubCategory["IBANChange"] = "IBANChange";
		return TenantSupportSubCategory;
	}({});
	TenantSupportSubCategoryMap = {
		["RepairApartment"]: [
			"Other",
			"Interior",
			"WaterOrHeatingOrSanitary",
			"Electric",
			"InternetOrCableOrTV",
			"HumidityOrMold",
			"PaintingOrWalls",
			"SmokeDetectorOrHeatCostAllocator",
			"DoorbellOrLetterbox",
			"DoorsOrWindows"
		],
		["QuestionAboutApartment"]: [
			"Other",
			"Handover",
			"Keys",
			"MeterReadings",
			"BalconyOrTerrace",
			"Cellar",
			"Parking"
		],
		["Contract"]: [
			"Other",
			"RentalContract",
			"HandoverProtocol",
			"Termination",
			"LandlordConfirmation"
		],
		["Payments"]: [
			"Other",
			"RentPayments",
			"IBANChange"
		],
		["Invoices"]: ["Other", "AncillaryCostBilling"]
	};
}));
//#endregion
//#region src/domains/cross-cutting/config.model.ts
function isRootConfigRecord(record) {
	return record.type === "Root";
}
var ConfigSerializerVersion, configSerializers, ConfigSection, configurableCostCenters, ConfigRecordType;
var init_config_model = __esmMin((() => {
	init_invoice();
	init_errors();
	ConfigSerializerVersion = /* @__PURE__ */ function(ConfigSerializerVersion) {
		ConfigSerializerVersion["v1"] = "v1";
		return ConfigSerializerVersion;
	}({});
	configSerializers = { ["v1"]: {
		serialize: (configIds) => {
			if (!configIds.length) throw new InvalidParamsError("Need to at least have one config when serializing");
			return `v1:${configIds.join("_")}`;
		},
		deserialize: (encodedIds) => encodedIds.split(`v1:`)[1].split("_").map((numLike) => Number.parseInt(numLike, 10))
	} };
	ConfigSection = /* @__PURE__ */ function(ConfigSection) {
		ConfigSection["General"] = "General";
		ConfigSection["Limits"] = "Limits";
		ConfigSection["Inputs"] = "Inputs";
		ConfigSection["LookupTable"] = "LookupTable";
		ConfigSection["CashflowPrediction"] = "CashflowPrediction";
		ConfigSection["MLPrediction"] = "MLPrediction";
		ConfigSection["CreditLine"] = "CreditLine";
		ConfigSection["CostTypesMapping"] = "CostTypesMapping";
		ConfigSection["CostTypesDetailsMapping"] = "CostTypesDetailsMapping";
		ConfigSection["CostCentersMapping"] = "CostCentersMapping";
		ConfigSection["MFH"] = "MFH";
		ConfigSection["PurchasingInspection"] = "PurchasingInspection";
		ConfigSection["ExternallyVisibleContacts"] = "ExternallyVisibleContacts";
		ConfigSection["InvoiceAssigneeSupervisors"] = "InvoiceAssigneeSupervisors";
		return ConfigSection;
	}({});
	configurableCostCenters = [
		"Reneo Group GmbH",
		"Condo Asset Management GmbH",
		"Reneo Asset Management GmbH",
		"Livings GmbH"
	];
	ConfigRecordType = /* @__PURE__ */ function(ConfigRecordType) {
		ConfigRecordType["Root"] = "Root";
		ConfigRecordType["Child"] = "Child";
		return ConfigRecordType;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/config/config-record.class.ts
function boxConfig(value) {
	return { config: value };
}
function objectToRow(obj) {
	return {
		["Inputs"]: boxConfig(obj["Inputs"]),
		["LookupTable"]: boxConfig(obj["LookupTable"]),
		["Limits"]: boxConfig(obj["Limits"]),
		["General"]: boxConfig(obj["General"]),
		["CashflowPrediction"]: boxConfig(obj["CashflowPrediction"]),
		["CreditLine"]: boxConfig(obj["CreditLine"]),
		["MLPrediction"]: boxConfig(obj["MLPrediction"]),
		["CostTypesMapping"]: boxConfig(obj["CostTypesMapping"]),
		["CostTypesDetailsMapping"]: boxConfig(obj["CostTypesDetailsMapping"]),
		["CostCentersMapping"]: boxConfig(obj["CostCentersMapping"]),
		["MFH"]: boxConfig(obj["MFH"]),
		["PurchasingInspection"]: boxConfig(obj["PurchasingInspection"]),
		["ExternallyVisibleContacts"]: boxConfig(obj["ExternallyVisibleContacts"]),
		["InvoiceAssigneeSupervisors"]: boxConfig(obj["InvoiceAssigneeSupervisors"])
	};
}
var CONFIG_RESOLUTION_ORDER, mergeCustomizer, isNotBranch, hasChildren, buildAttributePathFromParams, getSearchParams, withAttributePath, getMaxCreatedAt, configLeafToBranch, configLeafToBranchByParent, findConfigLeafs, ConfigRecord;
var init_config_record_class = __esmMin((() => {
	init_config_model();
	CONFIG_RESOLUTION_ORDER = [
		"source",
		"channelType",
		"channelName",
		"category",
		"region",
		"county",
		"city"
	];
	mergeCustomizer = (objValue, srcValue) => {
		if (Array.isArray(objValue)) return srcValue;
	};
	isNotBranch = (configs) => {
		return configs[0].type === "Child";
	};
	hasChildren = (all, leaf) => all.some((otherConfig) => otherConfig.parentId === leaf.configId);
	buildAttributePathFromParams = (searchParams, props = CONFIG_RESOLUTION_ORDER) => {
		return props.map((prop) => {
			if (!searchParams[prop]) return;
			return `${prop}/${searchParams[prop]}`;
		}).filter(Boolean).join(".");
	};
	getSearchParams = (configRecordProps) => omitBy({
		source: configRecordProps.source,
		channelType: configRecordProps.channelType,
		channelName: configRecordProps.channelName,
		category: configRecordProps.category,
		region: configRecordProps.region,
		county: configRecordProps.county,
		city: configRecordProps.city
	}, isNil);
	withAttributePath = (record) => {
		return {
			...record,
			attributePath: buildAttributePathFromParams(getSearchParams(record))
		};
	};
	getMaxCreatedAt = (configs) => maxBy(configs, (configRecord) => configRecord.createdAt ? new Date(configRecord.createdAt).getTime() : Number.NEGATIVE_INFINITY)?.createdAt;
	configLeafToBranch = (all) => (leaf) => {
		let hasParent = false;
		let current = leaf;
		const orderedNodes = [current];
		do {
			const parent = all.find((conf) => conf.configId === current.parentId);
			hasParent = Boolean(parent);
			if (hasParent) {
				orderedNodes.unshift(parent);
				current = parent;
			}
		} while (hasParent);
		return orderedNodes;
	};
	configLeafToBranchByParent = (leaf) => {
		if (isRootConfigRecord(leaf)) return [leaf];
		return [...configLeafToBranchByParent(leaf.parentConfig), leaf];
	};
	findConfigLeafs = (all) => {
		const activeRoot = all.find((c) => c.type === "Root" && c.active);
		if (!activeRoot) throw new Error("Did not find an active root-config, this should never happen");
		return all.filter((node) => !hasChildren(all, node)).map(configLeafToBranch(all)).map((branch) => {
			if (isNotBranch(branch)) return ConfigRecord.mergeConfigObjects([activeRoot, ...branch], getMaxCreatedAt(branch));
			return ConfigRecord.mergeConfigObjects(branch);
		});
	};
	ConfigRecord = class ConfigRecord {
		configId;
		encodedIdPath;
		createdAt;
		configRow;
		parentId;
		active;
		type;
		attributePath;
		parentConfig;
		source;
		channelType;
		channelName;
		category;
		region;
		county;
		city;
		parent;
		constructor(props) {
			Object.assign(this, props);
			if (props.parentConfig) this.parent = new ConfigRecord(props.parentConfig);
		}
		/**
		* Creates a config-record by merging multiple config-records into one. The
		* order of the provided configRecords must be correct, this method does not verify the orderings.
		*
		* For all merged config-records, a path is encoded, given a serializer identified by its version.
		* In order to (roughly) sort configs later in the UI, this method takes the latest createdAt timestamp
		* of all config-records and sets it for the merged-config
		*
		* Set includeRootConfigDate = true when the root-config should be taken into account for the createdAt-field.
		* Typically this is set to false whenever legacy configs without a root-config are merged
		*/
		static mergeConfigObjects(configRecords, createdAt = getMaxCreatedAt(configRecords)) {
			const config = mergeWith({}, ...configRecords, mergeCustomizer);
			return new ConfigRecord({
				...config,
				encodedIdPath: configSerializers["v1"].serialize(configRecords.map((c) => c.configId)),
				createdAt
			});
		}
		get inputs() {
			return this.configRow["Inputs"].config;
		}
		get generalConfig() {
			return this.configRow["General"].config;
		}
		get isRoot() {
			return this.type === "Root";
		}
		getConfigObject() {
			const configData = this.getConfigData();
			return {
				configId: this.configId,
				encodedIdPath: this.encodedIdPath,
				createdAt: this.createdAt.toString(),
				active: this.active,
				type: this.type,
				attributePath: this.attributePath,
				...configData
			};
		}
		getConfigData() {
			const copy = JSON.parse(JSON.stringify(this.configRow));
			return {
				["Inputs"]: copy["Inputs"]?.config,
				["LookupTable"]: copy["LookupTable"]?.config,
				["Limits"]: copy["Limits"]?.config,
				["General"]: copy["General"]?.config,
				["CashflowPrediction"]: copy["CashflowPrediction"]?.config,
				["CreditLine"]: copy["CreditLine"]?.config,
				["MLPrediction"]: copy["MLPrediction"]?.config,
				["CostTypesMapping"]: copy["CostTypesMapping"]?.config,
				["CostTypesDetailsMapping"]: copy["CostTypesDetailsMapping"]?.config,
				["CostCentersMapping"]: copy["CostCentersMapping"]?.config,
				["MFH"]: copy["MFH"]?.config,
				["PurchasingInspection"]: copy["PurchasingInspection"]?.config,
				["ExternallyVisibleContacts"]: copy["ExternallyVisibleContacts"]?.config,
				["InvoiceAssigneeSupervisors"]: copy["InvoiceAssigneeSupervisors"]?.config ?? []
			};
		}
	};
}));
//#endregion
//#region src/domains/finance/investment/cashflow/investor-cashflow.base.ts
var InvestorCashflowType, DISCOUNT_PERIOD_IN_YEARS, AUTOMATIC_SUBSIDY_DEFAULT_EQUITY_PERCENT, AUTOMATIC_SUBSIDY_DISCOUNT_PERIOD_IN_YEARS, DISCOUNTABLE_INPUTS;
var init_investor_cashflow_base = __esmMin((() => {
	InvestorCashflowType = /* @__PURE__ */ function(InvestorCashflowType) {
		InvestorCashflowType["SalesPackage"] = "SalesPackage";
		InvestorCashflowType["Prediction"] = "Prediction";
		InvestorCashflowType["Investment"] = "Investment";
		return InvestorCashflowType;
	}({});
	DISCOUNT_PERIOD_IN_YEARS = 2;
	AUTOMATIC_SUBSIDY_DEFAULT_EQUITY_PERCENT = .5;
	AUTOMATIC_SUBSIDY_DISCOUNT_PERIOD_IN_YEARS = 3;
	DISCOUNTABLE_INPUTS = [
		"discountablePropertyManagementMonthlyCosts",
		"discountableNotaryCostsRate",
		"discountablePropertyRegistrationRate",
		"discountableTaxRate",
		"discountableHomeOwnersFeeNonTransferableMonth",
		"discountableMaintenanceMonth"
	];
}));
//#endregion
//#region src/domains/finance/special-deal/special-deal.base.ts
var SpecialDealStandaloneFlags, SpecialDealInputs, SpecialDealFlags, SpecialDealFlagsAndInputs, SpecialDealFlagNames, SPECIAL_DEAL_DISCOUNTS_UPON_COMPLETION_OF_PURCHASE, SPECIAL_DEAL_DISCOUNTS_FOR_FIRST_X_YEARS;
var init_special_deal_base = __esmMin((() => {
	SpecialDealStandaloneFlags = [
		"shouldExemptNotaryCostsRate",
		"shouldExemptPropertyRegistrationRate",
		"shouldExemptTaxRate",
		"shouldExemptMaintenanceReserveMonth",
		"shouldExemptPropertyManagementMonthlyCosts"
	];
	SpecialDealInputs = {
		shouldExemptMaintenanceReserveMonth: ["maintenanceReserveMonthDiscountPeriod"],
		shouldExemptPropertyManagementMonthlyCosts: ["propertyManagementMonthlyCostsDiscountPeriod"],
		hasRepaymentSubsidy: ["repaymentSubsidyRate", "repaymentSubsidyDiscountPeriod"],
		hasAutomaticSubsidy: ["automaticSubsidyEquityPercentOrEuro", "automaticSubsidyDiscountPeriod"]
	};
	SpecialDealFlags = [...SpecialDealStandaloneFlags, ...Object.keys(SpecialDealInputs)];
	SpecialDealFlagsAndInputs = [...SpecialDealFlags, ...Object.values(SpecialDealInputs)].flat();
	SpecialDealFlagNames = {
		shouldExemptNotaryCostsRate: "Notarkosten",
		shouldExemptPropertyRegistrationRate: "Gerichtskosten",
		shouldExemptTaxRate: "Grunderwerbsteuer",
		shouldExemptMaintenanceReserveMonth: "Wohngeld",
		shouldExemptPropertyManagementMonthlyCosts: "SEV",
		hasRepaymentSubsidy: "Tilgungszuschuss",
		hasAutomaticSubsidy: "Schlusverkauf Sonderaktion"
	};
	SPECIAL_DEAL_DISCOUNTS_UPON_COMPLETION_OF_PURCHASE = [
		"shouldExemptNotaryCostsRate",
		"shouldExemptPropertyRegistrationRate",
		"shouldExemptTaxRate"
	];
	SPECIAL_DEAL_DISCOUNTS_FOR_FIRST_X_YEARS = [
		"shouldExemptMaintenanceReserveMonth",
		"shouldExemptPropertyManagementMonthlyCosts",
		"hasRepaymentSubsidy",
		"hasAutomaticSubsidy"
	];
}));
//#endregion
//#region src/domains/finance/special-deal/special-deal.class.ts
var SpecialDeal;
var init_special_deal_class = __esmMin((() => {
	init_base();
	init_investor_cashflow_base();
	init_special_deal_base();
	SpecialDeal = class extends BaseClassAttributes {
		specialDealId;
		salesPackageId;
		name;
		note;
		startDate;
		endDate;
		isActive;
		estateLockSellingState;
		shouldApplyOverrides = false;
		shouldExemptNotaryCostsRate = false;
		shouldExemptPropertyRegistrationRate = false;
		shouldExemptTaxRate = false;
		shouldExemptMaintenanceReserveMonth = false;
		maintenanceReserveMonthDiscountPeriod;
		shouldExemptPropertyManagementMonthlyCosts = false;
		propertyManagementMonthlyCostsDiscountPeriod;
		hasRepaymentSubsidy = false;
		repaymentSubsidyRate = null;
		repaymentSubsidyDiscountPeriod;
		hasAutomaticSubsidy = false;
		automaticSubsidyEquityPercentOrEuro = null;
		automaticSubsidyDiscountPeriod;
		consecutiveDealId = null;
		estates;
		salesPackage;
		constructor(specialDeal) {
			super(specialDeal);
			Object.assign(this, specialDeal);
		}
		getInvestorCashflowInputOverrides(estate) {
			const inputOverrides = {
				maintenanceReserveMonthDiscountPeriod: 0,
				propertyManagementMonthlyCostsDiscountPeriod: 0,
				repaymentSubsidyDiscountPeriod: 0,
				repaymentSubsidyRate: 0,
				automaticSubsidyEquityPercentOrEuro: 0,
				automaticSubsidyDiscountPeriod: 0
			};
			if (this.isActiveForEstate(estate)) {
				if (this.shouldExemptNotaryCostsRate) inputOverrides.discountableNotaryCostsRate = 0;
				if (this.shouldExemptPropertyRegistrationRate) inputOverrides.discountablePropertyRegistrationRate = 0;
				if (this.shouldExemptTaxRate) inputOverrides.discountableTaxRate = 0;
				if (this.shouldExemptMaintenanceReserveMonth) {
					inputOverrides.discountableHomeOwnersFeeNonTransferableMonth = 0;
					inputOverrides.discountableMaintenanceMonth = 0;
					inputOverrides.maintenanceReserveMonthDiscountPeriod = this.maintenanceReserveMonthDiscountPeriod ?? 2;
				}
				if (this.shouldExemptPropertyManagementMonthlyCosts) {
					inputOverrides.discountablePropertyManagementMonthlyCosts = 0;
					inputOverrides.propertyManagementMonthlyCostsDiscountPeriod = this.propertyManagementMonthlyCostsDiscountPeriod ?? 2;
				}
				if (this.hasRepaymentSubsidy) {
					inputOverrides.repaymentSubsidyRate = this.repaymentSubsidyRate ?? void 0;
					inputOverrides.repaymentSubsidyDiscountPeriod = this.repaymentSubsidyDiscountPeriod ?? 2;
				}
				if (this.hasAutomaticSubsidy) {
					inputOverrides.automaticSubsidyEquityPercentOrEuro = this.automaticSubsidyEquityPercentOrEuro ?? .5;
					inputOverrides.automaticSubsidyDiscountPeriod = this.automaticSubsidyDiscountPeriod ?? 3;
				}
			}
			return inputOverrides;
		}
		getInvestmentCalculationOptsOverrides(estate) {
			const calculationOptsOverrides = {
				addSellingNotaryCost: false,
				addSellingPropertyRegistration: false,
				addSellingTaxes: false
			};
			if (this.isActiveForEstate(estate)) {
				if (this.shouldExemptNotaryCostsRate) calculationOptsOverrides.addSellingNotaryCost = true;
				if (this.shouldExemptPropertyRegistrationRate) calculationOptsOverrides.addSellingPropertyRegistration = true;
				if (this.shouldExemptTaxRate) calculationOptsOverrides.addSellingTaxes = true;
			}
			return calculationOptsOverrides;
		}
		getInvestmentCalculationValsOverrides(estate) {
			const calculationValsOverrides = { repaymentSubsidyRate: void 0 };
			if (this.isActiveForEstate(estate)) {
				if (this.hasRepaymentSubsidy) calculationValsOverrides.repaymentSubsidyRate = this.repaymentSubsidyRate ?? void 0;
			}
			return calculationValsOverrides;
		}
		resetFlags() {
			this.shouldExemptNotaryCostsRate = false;
			this.shouldExemptPropertyRegistrationRate = false;
			this.shouldExemptTaxRate = false;
			this.shouldExemptMaintenanceReserveMonth = false;
			this.shouldExemptPropertyManagementMonthlyCosts = false;
			this.hasRepaymentSubsidy = false;
			this.hasAutomaticSubsidy = false;
		}
		isActiveForEstate(estate) {
			return this.isActive || estate?.isSpecialDealLocked;
		}
		getDiscountDetailsStr() {
			const discountDetailsArr = [];
			const discountsUponCompletionOfPurchase = Object.entries(pick(this, SPECIAL_DEAL_DISCOUNTS_UPON_COMPLETION_OF_PURCHASE)).filter(([, v]) => v);
			if (discountsUponCompletionOfPurchase.length) discountDetailsArr.push(`Übernahme bei Kaufabschluss: ${discountsUponCompletionOfPurchase.map(([k]) => SpecialDealFlagNames[k]).join(", ")}`);
			const discountsForFirstXYears = Object.entries(pick(this, SPECIAL_DEAL_DISCOUNTS_FOR_FIRST_X_YEARS)).filter(([, v]) => v);
			if (discountsForFirstXYears.length) discountDetailsArr.push(`Übernahme: ${discountsForFirstXYears.map(([k]) => {
				const discount = SpecialDealFlagNames[k];
				const discountPeriod = `${this.getDiscountPeriod(k)} Jahre`;
				if (k === "hasRepaymentSubsidy") return `${discount} ${percent(this.repaymentSubsidyRate, 2)} p.a. (${discountPeriod})`;
				else if (k === "hasAutomaticSubsidy") return `${discount}${this.automaticSubsidyEquityPercentOrEuro <= 1 ? ` ${percent(this.automaticSubsidyEquityPercentOrEuro)} / ${percent(1 - this.automaticSubsidyEquityPercentOrEuro)}` : ""}`;
				else return `${discount} (${discountPeriod})`;
			}).join(", ")}`);
			return discountDetailsArr.join(" & ");
		}
		getDiscountPeriod(discountType) {
			if (!this[discountType]) return null;
			switch (discountType) {
				case "shouldExemptMaintenanceReserveMonth": return this.maintenanceReserveMonthDiscountPeriod ?? 2;
				case "shouldExemptPropertyManagementMonthlyCosts": return this.propertyManagementMonthlyCostsDiscountPeriod ?? 2;
				case "hasRepaymentSubsidy": return this.repaymentSubsidyDiscountPeriod ?? 2;
				case "hasAutomaticSubsidy": return this.automaticSubsidyDiscountPeriod ?? 3;
				default: return null;
			}
		}
	};
}));
//#endregion
//#region src/domains/finance/investment/profitability-calculations/calculations/helpers.ts
var returnOrKeepCalculationValues, maybeMakeZeroCosts, mcalc, multiCalc, financingCostJuniorDebt, financingCostSenior, financingCostJuniorDebtDaily, financingCostSeniorDaily, seniorWacc, juniorWacc, waccTotal, calculateTimeOnBooks;
var init_helpers$3 = __esmMin((() => {
	returnOrKeepCalculationValues = (calculatedValues, opts) => {
		if (!opts?.keepableResults || !opts.previousResult) return calculatedValues;
		return merge({}, calculatedValues, pick(opts.previousResult, opts.keepableResults));
	};
	maybeMakeZeroCosts = (values, makeZero) => {
		if (makeZero) return Object.keys(values).reduce((acc, key) => {
			return {
				...acc,
				[key]: 0
			};
		}, {});
		return values;
	};
	mcalc = (key, opts, calcFn) => {
		if (!opts?.keepableResults || !opts.previousResult) return calcFn();
		const prevVal = get(opts.previousResult, key);
		if (opts.keepableResults.includes(key) && !isNil(prevVal)) return prevVal;
		return calcFn();
	};
	multiCalc = (keys, opts, calcFn) => {
		if (!opts?.keepableResults || !opts.previousResult) return calcFn();
		const allCalculations = calcFn();
		return keys.reduce((acc, key) => {
			const prevVal = get(opts.previousResult, key);
			if (opts.keepableResults.includes(key) && !isNil(prevVal)) return {
				...acc,
				[key]: prevVal
			};
			return {
				...acc,
				[key]: allCalculations[key]
			};
		}, {});
	};
	financingCostJuniorDebt = (inputs, price, renovationCosts, timeOnBooks) => {
		const { juniorDebtInterest, juniorDebtRatio } = inputs.financingCosts;
		const { salePeriod } = inputs.investing;
		return round$1(juniorDebtInterest * juniorDebtRatio / 12 * (salePeriod * renovationCosts + timeOnBooks * price), 2);
	};
	financingCostSenior = (inputs, price, renovationCosts, timeOnBooks) => {
		const { seniorDebtInterest, seniorDebtRatio } = inputs.financingCosts;
		const { salePeriod } = inputs.investing;
		return round$1(seniorDebtInterest * seniorDebtRatio / 12 * (salePeriod * renovationCosts + timeOnBooks * price), 2);
	};
	financingCostJuniorDebtDaily = (inputs, price, renovationCosts, timeOnBooksDays) => {
		const { juniorDebtInterest, juniorDebtRatio } = inputs.financingCosts;
		const interestCostsPerDay = juniorDebtInterest * juniorDebtRatio / 360;
		const { salePeriod, renovationDuration } = inputs.investing;
		const salePeriodDay = timeOnBooksDays * salePeriod / (salePeriod + renovationDuration);
		return round$1(interestCostsPerDay * (timeOnBooksDays * price + renovationCosts * salePeriodDay), 2);
	};
	financingCostSeniorDaily = (inputs, price, renovationCosts, timeOnBooksDays) => {
		const { seniorDebtInterest, seniorDebtRatio } = inputs.financingCosts;
		const interestCostsDay = seniorDebtInterest * seniorDebtRatio / 360;
		const { salePeriod, renovationDuration } = inputs.investing;
		const salePeriodDay = timeOnBooksDays * salePeriod / (salePeriod + renovationDuration);
		return round$1(interestCostsDay * (timeOnBooksDays * price + renovationCosts * salePeriodDay), 2);
	};
	seniorWacc = (seniorDebtInterest, seniorDebtProcessingFee, sumDuration) => {
		const interestCostsMonthWithFee = seniorDebtInterest * sumDuration / 12 + seniorDebtProcessingFee;
		return round$1(interestCostsMonthWithFee / (1 - interestCostsMonthWithFee), 4);
	};
	juniorWacc = (juniorDebtInterest, sumDuration) => {
		const interestCostsMonth = juniorDebtInterest * sumDuration / 12;
		return round$1(interestCostsMonth / (1 - interestCostsMonth), 4);
	};
	waccTotal = (seniorDebtInterest, seniorDebtProcessingFee, juniorDebtInterest, juniorDebtRatio, timeOnBooks) => {
		const seniorDebtRatio = 1 - juniorDebtRatio;
		const seniorWaccVal = seniorWacc(seniorDebtInterest, seniorDebtProcessingFee, timeOnBooks);
		const juniorWaccVal = juniorWacc(juniorDebtInterest, timeOnBooks);
		return round$1(seniorDebtRatio * seniorWaccVal + juniorDebtRatio * juniorWaccVal, 4);
	};
	calculateTimeOnBooks = (purchasing, selling) => {
		if (!purchasing?.paidAt) return null;
		if (selling?.paidAt) return dayjs(selling.paidAt).diff(purchasing.paidAt, "d");
		return dayjs().diff(purchasing.paidAt, "d");
	};
}));
//#endregion
//#region src/domains/finance/investment/profitability-calculations/calculations/base-calculations.ts
var calculateBaseValues;
var init_base_calculations$1 = __esmMin((() => {
	init_errors();
	init_helpers$3();
	calculateBaseValues = ({ inputs, val, isFRF }, opts) => {
		const { notaryCost: notaryCostPercent, taxesByState, taxes, propertyRegistration } = inputs.investing.ancillaryCost;
		const { renovationDuration, salePeriod } = inputs.investing;
		const taxesPercent = taxesByState?.[val.state] || taxes;
		if (!taxesPercent) throw new ApplicationError(`Did not find tax-information for state ${val.state}, cannot calculate profitability`);
		const timeOnBooks = renovationDuration + salePeriod;
		const defaultRentalReturnTarget = inputs.expectedReturn.rentalReturnTarget;
		const condoReturnTarget = inputs.expectedReturn.condoReturnTarget;
		const allAncillaryCostsPercents = notaryCostPercent + taxesPercent + propertyRegistration;
		const monthlyRent = isFRF ? val.monthlyRent ?? val.baseRentPerSquareMeter * val.livingSpace : 0;
		const parkingSpacePurchasePrice = val.parkingSpacePurchasePrice ?? 0;
		const totalPurchasePrice = val.purchasingPrice + parkingSpacePurchasePrice;
		return returnOrKeepCalculationValues({
			defaultRentalReturnTarget,
			condoReturnTarget,
			renovationDuration,
			salePeriod,
			timeOnBooks,
			allAncillaryCostsPercents,
			monthlyRent,
			marketPricePurchasingPrice: val.marketPricePurchasingPrice ?? null,
			parkingSpacePurchasePrice,
			totalPurchasePrice,
			salesKickBack: val.salesKickBack ?? 0,
			extraCost: val.extraCost ?? 0,
			bonus: val.bonus ?? 0,
			pmIncentive: val.pmIncentive ?? 0,
			specialAgreements: val.specialAgreements ?? 0
		}, opts);
	};
}));
//#endregion
//#region src/domains/finance/investment/profitability-calculations/calculations/base-return-calculations.ts
var calculateBaseReturnValues;
var init_base_return_calculations = __esmMin((() => {
	init_helpers$3();
	calculateBaseReturnValues = (params, opts) => {
		const grossInvestmentCosts = params.totalPurchasePrice + params.transactionCosts + params.renovationCosts + params.otherCosts;
		const totalExpenses = grossInvestmentCosts + params.operatingCosts + params.distributionMarketingCosts;
		const listedPriceNoOperationReturn = params.totalCondoIncome - grossInvestmentCosts;
		const netContributionMargin = params.totalCondoIncome - grossInvestmentCosts - params.distributionMarketingCosts;
		const listedPriceOverallReturn = params.totalCondoIncome - totalExpenses;
		const listedOverallMargin = round$1(listedPriceOverallReturn / params.expectedSalesPrice, 4);
		const netContributionMarginPercent = round$1(netContributionMargin / params.expectedSalesPrice, 4);
		const listedMarginNoOperation = round$1(listedPriceNoOperationReturn / params.expectedSalesPrice, 4);
		return returnOrKeepCalculationValues({
			grossInvestmentCosts,
			totalExpenses,
			listedPriceOverallReturn: round$1(listedPriceOverallReturn, 2),
			listedPriceNoOperationReturn,
			listedOverallMargin,
			listedMarginNoOperation,
			listedPriceTotalExpenses: totalExpenses,
			netContributionMargin,
			netContributionMarginPercent
		}, opts);
	};
}));
//#endregion
//#region src/domains/finance/investment/profitability-calculations/calculations/common-expenses-calculations.ts
var calculateCommonExpenses;
var init_common_expenses_calculations = __esmMin((() => {
	init_errors();
	init_helpers$3();
	calculateCommonExpenses = ({ VAT, isFRF, val, inputs, bonus, pmIncentive, totalPurchasePrice, specialAgreements, investorIncome, skipAgencyFee }, opts) => {
		const taxesPercent = inputs.investing.ancillaryCost.taxesByState?.[val.state];
		if (!taxesPercent) throw new InvalidParamsError(`Provided config state-tax for state '${val.state}' should not be null or undefined. Please choose a different config`);
		const rentalReturnTarget = mcalc("rentalReturnTarget", opts, () => isFRF ? val.rentalReturnTarget ?? inputs.expectedReturn.rentalReturnTarget : 0);
		const expectedSalesPrice = mcalc("expectedSalesPrice", opts, () => val.expectedSalesPrice ?? round$1(investorIncome / rentalReturnTarget));
		const getMaklerFeeCalculations = (salesPrice) => multiCalc(["maklerFee", "maklerFeeMoney"], opts, () => {
			let mFee = 0;
			let mFeeMoney = 0;
			if (!isNil(val.maklerFee)) if (val.maklerFee < 100) {
				if (val.maklerFee < 1) mFee = val.maklerFee;
				else mFee = val.maklerFee / 100;
				mFeeMoney = salesPrice * mFee;
			} else mFeeMoney = val.maklerFee;
			else mFeeMoney = salesPrice * inputs.selling.maklerFee;
			return {
				maklerFee: mFee,
				maklerFeeMoney: mFeeMoney
			};
		});
		const { maklerFeeMoney } = getMaklerFeeCalculations(expectedSalesPrice);
		const sellingCosts = mcalc("sellingCosts", opts, () => round$1(maklerFeeMoney, 2));
		const sellingNotaryCost = opts?.addSellingNotaryCost ? mcalc("sellingNotaryCost", opts, () => expectedSalesPrice * inputs.investing.ancillaryCost.notaryCost) : 0;
		const sellingTaxes = opts?.addSellingTaxes ? mcalc("sellingTaxes", opts, () => expectedSalesPrice * taxesPercent) : 0;
		const sellingPropertyRegistration = opts?.addSellingPropertyRegistration ? mcalc("sellingPropertyRegistration", opts, () => expectedSalesPrice * inputs.investing.ancillaryCost.propertyRegistration) : 0;
		const sellingRepaymentSubsidy = mcalc("sellingRepaymentSubsidy", opts, () => expectedSalesPrice * (val.repaymentSubsidyRate ?? 0));
		const bonusAddition = bonus <= 1 ? expectedSalesPrice * bonus : bonus;
		const pmIncentiveAddition = sellingRepaymentSubsidy + (pmIncentive <= 1 ? expectedSalesPrice * pmIncentive : pmIncentive);
		const specialAgreementsAddition = mcalc("specialAgreementsAddition", opts, () => sellingNotaryCost + sellingTaxes + sellingPropertyRegistration + (specialAgreements <= 1 ? expectedSalesPrice * specialAgreements : specialAgreements));
		const notaryCost = mcalc("notaryCost", opts, () => totalPurchasePrice * inputs.investing.ancillaryCost.notaryCost);
		const taxes = mcalc("taxes", opts, () => totalPurchasePrice * taxesPercent);
		const propertyRegistration = mcalc("propertyRegistration", opts, () => totalPurchasePrice * inputs.investing.ancillaryCost.propertyRegistration);
		const { agencyFee, agencyFeePercent } = skipAgencyFee ? {
			agencyFee: 0,
			agencyFeePercent: 0
		} : multiCalc(["agencyFee", "agencyFeePercent"], opts, () => {
			let agFee = 0;
			let agFeePercent = 0;
			if (val.agencyFee) switch (true) {
				case val.agencyFee < 1:
					agFee = totalPurchasePrice * val.agencyFee;
					agFeePercent = val.agencyFee;
					break;
				case val.agencyFee > 1 && val.agencyFee < 100:
					agFee = totalPurchasePrice * (val.agencyFee / 100);
					agFeePercent = val.agencyFee / 100;
					break;
				default:
					agFee = val.agencyFee;
					agFeePercent = round$1(agFee / totalPurchasePrice, 4);
			}
			return {
				agencyFee: agFee,
				agencyFeePercent: agFeePercent
			};
		});
		const { referralFeePercent, referralFee } = multiCalc(["referralFeePercent", "referralFee"], opts, () => {
			const refFeePercent = val.referralFeePercent ?? 0;
			let refFee = 0;
			if (refFeePercent) refFee = round$1(refFeePercent * totalPurchasePrice, 4);
			return {
				referralFeePercent: refFeePercent,
				referralFee: refFee
			};
		});
		return returnOrKeepCalculationValues({
			sellingNotaryCost,
			sellingPropertyRegistration,
			sellingTaxes,
			sellingRepaymentSubsidy,
			specialAgreementsAddition,
			bonusAddition,
			pmIncentiveAddition,
			rentalReturnTarget,
			expectedSalesPrice,
			sellingCosts,
			sellingCommission: mcalc("sellingCommission", opts, () => isFRF ? 0 : round$1(maklerFeeMoney / VAT, 2)),
			notaryCost,
			taxes,
			propertyRegistration,
			agencyFee,
			agencyFeePercent,
			referralFeePercent,
			referralFee,
			auxiliaryCosts: mcalc("auxiliaryCosts", opts, () => notaryCost + taxes + propertyRegistration + agencyFee + referralFee)
		}, opts);
	};
}));
//#endregion
//#region src/domains/finance/investment/profitability-calculations/calculations/distressed-thresholds-calculations.ts
var calculateSensitiveDistressedCaseValues;
var init_distressed_thresholds_calculations = __esmMin((() => {
	init_helpers$3();
	calculateSensitiveDistressedCaseValues = (params, opts) => {
		const { juniorDebtRatio, juniorDebtInterest, seniorDebtInterest, seniorDebtProcessingFee } = params.inputs.financingCosts;
		const totalFinancingFee = waccTotal(seniorDebtInterest, seniorDebtProcessingFee, juniorDebtInterest, juniorDebtRatio, params.timeOnBooks);
		const zeroMarginPurchasingPrice = Math.trunc((params.totalCondoIncome / 1 - (params.operationCosts - params.financingCosts) - (1 + totalFinancingFee) * params.totalReimbursableCosts) / (1 + (params.allAncillaryCostsPercents + params.agencyFeePercent + params.referralFeePercent) + totalFinancingFee + totalFinancingFee * (params.allAncillaryCostsPercents + params.agencyFeePercent + params.referralFeePercent)));
		const zeroMarginAuxiliaryCosts = Math.trunc((params.allAncillaryCostsPercents + params.agencyFeePercent + params.referralFeePercent) * zeroMarginPurchasingPrice);
		const zeroMarginFinancingCosts = Math.trunc((zeroMarginPurchasingPrice + zeroMarginAuxiliaryCosts + params.totalReimbursableCosts) * totalFinancingFee);
		let sensitivityMinimumRentBreakEven = 0;
		let sensitivityRentPriceDeviation = 0;
		let sensitivityMaxInvestorReturnDeviation = 0;
		let sensitivityMaximumInvestorReturn = 0;
		if (params.isFRF) {
			const rentPerSqm = params.val.baseRentPerSquareMeter ?? round$1(params.monthlyRent / params.val.livingSpace, 2);
			sensitivityMinimumRentBreakEven = +((zeroMarginPurchasingPrice * params.rentalReturnTarget - params.yearParkingLotIncome) / (params.val.livingSpace * 12)).toFixed(2);
			sensitivityMaximumInvestorReturn = round$1((params.investorIncome - params.nonTransferableYear) / (params.totalPurchasePrice + params.totalReimbursableCosts + params.operationCosts + params.auxiliaryCosts - params.sellingCommission - params.homeOwnersFeeTenant - params.rentalIncomeDuringHold), 7);
			sensitivityRentPriceDeviation = rentPerSqm > 0 ? round$1(sensitivityMinimumRentBreakEven / rentPerSqm - 1, 4) : 0;
			sensitivityMaxInvestorReturnDeviation = round$1(sensitivityMaximumInvestorReturn / params.rentalReturnTarget - 1, 4);
		}
		const sensitivityMaximumCostOvershoot = params.expectedSalesPrice + params.homeOwnersFeeTenant + params.sellingCommission + params.rentalIncomeDuringHold - params.totalPurchasePrice - params.totalReimbursableCosts - params.operationCosts - params.auxiliaryCosts;
		const sensitivityMaximumCostOvershootDeviation = round$1(sensitivityMaximumCostOvershoot / (params.operationCosts + params.totalReimbursableCosts + params.auxiliaryCosts), 4);
		const supplementalIncomes = safeSum(params.rentalIncomeDuringHold, params.serviceCharge, params.sellingCommission);
		const profThresholdCM1SalesPrice = params.grossInvestmentCosts * (1 + params.condoReturnTarget) - supplementalIncomes;
		const profThresholdCM1SalesPriceRounded = roundUpToNearest(profThresholdCM1SalesPrice, 1e3);
		const profThresholdCM2SalesPrice = params.totalExpenses * (1 + params.condoReturnTarget) - supplementalIncomes;
		const profThresholdCM2SalesPriceRounded = roundUpToNearest(profThresholdCM2SalesPrice, 1e3);
		const sellingThresholdOperatingReturnCM1 = profThresholdCM1SalesPriceRounded + supplementalIncomes - params.grossInvestmentCosts;
		const sellingThresholdOperatingReturnCM2 = profThresholdCM2SalesPriceRounded + supplementalIncomes - params.grossInvestmentCosts;
		const sellingThresholdCM1 = sellingThresholdOperatingReturnCM2 / params.grossInvestmentCosts;
		const sellingThresholdTotalReturnCM1 = profThresholdCM1SalesPriceRounded + supplementalIncomes - params.totalExpenses;
		const sellingThresholdTotalReturnCM2 = profThresholdCM2SalesPriceRounded + supplementalIncomes - params.totalExpenses;
		const sellingThresholdCM2 = sellingThresholdTotalReturnCM1 / params.totalExpenses;
		let sellingMarketPriceOperatingReturn;
		let sellingMarketPriceTotalReturn;
		let sellingMarketPriceCM1;
		let sellingMarketPriceCM2;
		if (params.val.marketPricePurchasingPrice) {
			sellingMarketPriceOperatingReturn = params.val.marketPricePurchasingPrice + supplementalIncomes - params.grossInvestmentCosts;
			sellingMarketPriceTotalReturn = params.val.marketPricePurchasingPrice + params.rentalIncomeDuringHold + params.serviceCharge + params.sellingCommission - params.marketPriceTotalExpenses;
			sellingMarketPriceCM1 = sellingMarketPriceOperatingReturn / params.grossInvestmentCosts;
			sellingMarketPriceCM2 = sellingMarketPriceTotalReturn / params.marketPriceTotalExpenses;
		}
		return returnOrKeepCalculationValues({
			sellingMarketPriceOperatingReturn,
			sellingMarketPriceTotalReturn,
			sellingMarketPriceCM1,
			sellingMarketPriceCM2,
			sellingThresholdTotalReturnCM2,
			sellingThresholdTotalReturnCM1,
			sellingThresholdCM1,
			sellingThresholdCM2,
			sellingThresholdOperatingReturnCM2,
			sellingThresholdOperatingReturnCM1,
			profThresholdCM1SalesPrice,
			profThresholdCM1SalesPriceRounded,
			profThresholdCM2SalesPrice,
			profThresholdCM2SalesPriceRounded,
			zeroMarginPurchasingPrice,
			zeroMarginAuxiliaryCosts,
			zeroMarginFinancingCosts,
			sensitivityMinimumRentBreakEven,
			sensitivityRentPriceDeviation,
			sensitivityMaxInvestorReturnDeviation,
			sensitivityMaximumInvestorReturn,
			sensitivityMaximumCostOvershoot,
			sensitivityMaximumCostOvershootDeviation
		}, opts);
	};
}));
//#endregion
//#region src/domains/finance/investment/profitability-calculations/calculations/financing-calculations.ts
var calculateFinancingCosts;
var init_financing_calculations = __esmMin((() => {
	init_helpers$3();
	calculateFinancingCosts = (params, opts) => {
		const { salePeriod } = params.inputs.investing;
		const { laborCosts } = params.inputs.transformation;
		const totalReimbursableCosts = params.otherCosts + params.renovationCosts;
		const totalPrice = params.totalPurchasePrice + params.auxiliaryCosts + params.otherCosts;
		const parkingLotPrice = params.val.parkingSpacePrice || 0;
		const skipFinancingCosts = !!params.skipFinancingCosts;
		const financingCostsSeniorDebt = skipFinancingCosts ? 0 : mcalc("financingCostsSeniorDebt", opts, () => financingCostSenior(params.inputs, totalPrice, params.renovationCosts, params.timeOnBooks));
		const financingCostsJuniorDebt = skipFinancingCosts ? 0 : mcalc("financingCostsJuniorDebt", opts, () => financingCostJuniorDebt(params.inputs, totalPrice, params.renovationCosts, params.timeOnBooks));
		const financingCosts = skipFinancingCosts ? 0 : mcalc("financingCosts", opts, () => financingCostsJuniorDebt + financingCostsSeniorDebt);
		const totalLaborCosts = skipFinancingCosts ? 0 : mcalc("totalLaborCosts", opts, () => {
			return laborCosts.combinedLaborCosts ? round$1(laborCosts.combinedLaborCosts, 2) : round$1(laborCosts.purchaser + laborCosts.constructionSupervisor + laborCosts.supervisingArchitect + laborCosts.propertyManager, 2);
		});
		const operationCosts = skipFinancingCosts ? 0 : mcalc("operationCosts", opts, () => financingCosts + totalLaborCosts);
		const serviceCharge = skipFinancingCosts || !params.tenantPresent ? 0 : mcalc("serviceCharge", opts, () => params.transferable * salePeriod);
		const rentalIncomeDuringHold = skipFinancingCosts ? 0 : mcalc("rentalIncomeDuringHold", opts, () => {
			return params.tenantPresentAndFRF ? round$1(params.monthlyRent * salePeriod + parkingLotPrice * salePeriod + params.sellingCommission, 2) : 0;
		});
		return returnOrKeepCalculationValues({
			serviceCharge,
			rentalIncomeDuringHold,
			totalReimbursableCosts,
			financingCostsSeniorDebt,
			financingCostsJuniorDebt,
			financingCosts,
			totalLaborCosts,
			operationCosts,
			totalCondoIncome: mcalc("totalCondoIncome", opts, () => safeSum(params.expectedSalesPrice, rentalIncomeDuringHold, serviceCharge, params.salesKickBack))
		}, opts);
	};
}));
//#endregion
//#region src/domains/finance/investment/profitability-calculations/calculations/income-calculations.ts
var calculateIncomeParams;
var init_income_calculations = __esmMin((() => {
	init_helpers$3();
	calculateIncomeParams = (params, opts) => {
		const parkingLotPrice = params.val.parkingSpacePrice || 0;
		const yearRentalIncome = params.isFRF ? round$1(params.monthlyRent * 12, 2) : 0;
		const yearParkingLotIncome = params.isFRF ? parkingLotPrice * 12 : 0;
		return returnOrKeepCalculationValues({
			yearRentalIncome,
			yearParkingLotIncome,
			investorIncome: yearRentalIncome + yearParkingLotIncome
		}, opts);
	};
}));
//#endregion
//#region src/domains/finance/investment/profitability-calculations/calculations/market-price-calculations.ts
var calculateMarketPrice;
var init_market_price_calculations = __esmMin((() => {
	init_base_return_calculations();
	init_helpers$3();
	calculateMarketPrice = (params, opts) => {
		const { marketPricePurchasingPrice, allAncillaryCostsPercents, agencyFeePercent, referralFeePercent, renovationCosts, otherCosts, totalCondoIncome, financingCosts, operatingCosts, distributionMarketingCosts, ...baseParams } = params;
		if (!marketPricePurchasingPrice) return;
		const marketPriceAuxiliaryCosts = (allAncillaryCostsPercents + agencyFeePercent + referralFeePercent) * marketPricePurchasingPrice;
		const totalMarketPrice = marketPricePurchasingPrice + marketPriceAuxiliaryCosts + otherCosts + renovationCosts;
		const marketPriceFinancingCostsSeniorDebt = financingCostSenior(baseParams.inputs, totalMarketPrice, params.renovationCosts, params.timeOnBooks);
		const marketPriceFinancingCostsJuniorDebt = financingCostJuniorDebt(baseParams.inputs, totalMarketPrice, params.renovationCosts, params.timeOnBooks);
		const marketPriceFinancingCosts = marketPriceFinancingCostsSeniorDebt + marketPriceFinancingCostsJuniorDebt;
		/**
		* since the original operatingCosts are depending on financing a different purchase-price, this adjusts the operating costs to
		* take into account the senior-/junior-debt financing costs of the market-price
		*/
		const adjustedOperatingCosts = operatingCosts - financingCosts + marketPriceFinancingCosts;
		const marketPriceReturnValues = calculateBaseReturnValues({
			...baseParams,
			totalCondoIncome,
			totalPurchasePrice: marketPricePurchasingPrice,
			operatingCosts: adjustedOperatingCosts,
			transactionCosts: marketPriceAuxiliaryCosts,
			renovationCosts,
			otherCosts,
			distributionMarketingCosts
		});
		return returnOrKeepCalculationValues({
			marketPriceAuxiliaryCosts,
			marketPriceFinancingCostsSeniorDebt,
			marketPriceFinancingCostsJuniorDebt,
			marketPriceFinancingCosts,
			marketPriceOverallReturn: marketPriceReturnValues.listedPriceOverallReturn,
			marketPriceNoOperationReturn: marketPriceReturnValues.listedPriceNoOperationReturn,
			marketPriceOverallMargin: marketPriceReturnValues.listedOverallMargin,
			marketPriceNoOperationMargin: marketPriceReturnValues.listedMarginNoOperation,
			marketPriceTotalExpenses: marketPriceReturnValues.listedPriceTotalExpenses
		}, opts);
	};
}));
//#endregion
//#region src/domains/finance/investment/profitability-calculations/calculations/other-costs-calculations.ts
var calculateOtherCosts;
var init_other_costs_calculations = __esmMin((() => {
	init_helpers$3();
	calculateOtherCosts = (params, opts) => {
		const { livingSpace } = params.val;
		const extraCosts = params.extraCost ?? 0;
		const ifcScanCosts = mcalc("ifcScanCosts", opts, () => params.inputs.operationCosts?.ifcScanCosts || 0);
		const takingPictures = mcalc("takingPictures", opts, () => params.inputs.operationCosts?.takingPictures || 0);
		const utilities = mcalc("utilities", opts, () => (params.inputs.operationCosts?.utilities ?? 25) * params.timeOnBooks);
		const totalAdditionalCost = mcalc("totalAdditionalCost", opts, () => params.totalAdditionalCost ?? 0);
		return returnOrKeepCalculationValues(maybeMakeZeroCosts({
			ifcScanCosts,
			takingPictures,
			cleaningPrice: mcalc("cleaningPrice", opts, () => (params.inputs.operationCosts?.cleaning ?? 0) * livingSpace),
			utilities,
			otherCosts: mcalc("otherCosts", opts, () => round$1(totalAdditionalCost + ifcScanCosts + takingPictures + utilities + extraCosts, 2))
		}, !!params.skipOtherCosts), opts);
	};
}));
//#endregion
//#region src/domains/finance/investment/profitability-calculations/calculations/profitability-calculations.ts
var calculateProfitableDiscountPercent, calculateReturnTargetProfitability;
var init_profitability_calculations$1 = __esmMin((() => {
	calculateProfitableDiscountPercent = (params) => {
		const { expectedSalesPrice, distributionMarketingCosts, renovationCosts, otherCosts, purchasingPrice, condoReturnTarget, allAncillaryCostsPercents, agencyFeePercent, referralFeePercent } = params;
		const transactionCostPercent = allAncillaryCostsPercents + agencyFeePercent + referralFeePercent;
		const profitableDiscountPercent = 1 - (expectedSalesPrice - renovationCosts - otherCosts - distributionMarketingCosts - expectedSalesPrice * condoReturnTarget) / (1 + transactionCostPercent) / purchasingPrice;
		return profitableDiscountPercent && profitableDiscountPercent > 0 ? profitableDiscountPercent : void 0;
	};
	calculateReturnTargetProfitability = (params) => {
		const isProfitable = params.netContributionMarginPercent ? params.netContributionMarginPercent >= params.condoReturnTarget : false;
		return {
			isProfitable,
			profitableDiscountPercent: isProfitable ? void 0 : calculateProfitableDiscountPercent(params)
		};
	};
}));
//#endregion
//#region src/domains/finance/investment/profitability-calculations/calculations/renovation-calculations.ts
var calculateRenovationCosts;
var init_renovation_calculations = __esmMin((() => {
	init_errors();
	init_helpers$3();
	calculateRenovationCosts = ({ tables, val }, opts) => {
		const { kitchenApartmentSizeCosts, toiletApartmentSizeCosts, guestToiletCosts, roomChangeCosts, generalRenovationApartmentSizeCosts, specialRenovationCosts } = tables;
		const generalCost = generalRenovationApartmentSizeCosts?.[val.apartmentSize]?.[val.newInteriorQuality];
		if (!generalCost) throw new ApplicationError(`Cannot find general renovation cost for apartment with size ${val.apartmentSize} and interior quality ${val.newInteriorQuality} in the current config?`);
		const roofStoreyAddition = ["Penthouse", "RoofStorey"].includes(val.apartmentType) ? specialRenovationCosts.roofStoreyAdditionCoef * generalCost : 0;
		const asbestosAddition = val.asbestosAdditionCalculated ? specialRenovationCosts.asbestosAdditionCoef : 0;
		const prefabricatedAddition = val.prefabricatedAdditionCalculated ? specialRenovationCosts.prefabricatedAdditionCoef : 0;
		const newFloorHistoricAddition = val.newFloorHistoricAdditionCalculated ? specialRenovationCosts.newFloorHistoricAdditionCoef : 0;
		const storeyHeightAddition = val.storeyHeightAdditionCalculated ? specialRenovationCosts.storeyHeightAdditionCoef : 0;
		const historicDoorsAddition = val.historicDoors ? val.historicDoors * specialRenovationCosts.historicDoorsAdditionCoef : 0;
		const gasBoilerAddition = val.gasBoilerAdditionCalculated ? specialRenovationCosts.gasBoilerAdditionPrice : 0;
		const maisonetteAddition = val.maisonetteAdditionCalculated ? specialRenovationCosts.maisonetteAdditionPrice : 0;
		const heatingPipesAddition = val.heatingPipesAdditionCalculated ? specialRenovationCosts.heatingPipesAdditionPrice : 0;
		const specialRenovationCostsSum = mcalc("specialRenovationCostsSum", opts, () => {
			if (!isNil(val.approvedGeneralRenovationCost)) return 0;
			return val.skipRenovationCosts ? 0 : (asbestosAddition + prefabricatedAddition + newFloorHistoricAddition + storeyHeightAddition) * val.livingSpace + historicDoorsAddition + gasBoilerAddition + maisonetteAddition + heatingPipesAddition;
		});
		const generalRenovationCosts = mcalc("generalRenovationCosts", opts, () => {
			if (!isNil(val.approvedGeneralRenovationCost)) return val.approvedGeneralRenovationCost;
			return val.skipRenovationCosts ? 0 : (generalCost + roofStoreyAddition) * val.livingSpace;
		});
		const kitchenCost = mcalc("kitchenCost", opts, () => {
			if (!isNil(val.approvedKitchenCost)) return val.approvedKitchenCost;
			return val.buildInKitchen && !val.skipRenovationCosts ? kitchenApartmentSizeCosts[val.apartmentSize]?.[val.newInteriorQuality] ?? 0 : 0;
		});
		const toiletPrice = mcalc("toiletPrice", opts, () => {
			if (!isNil(val.approvedGeneralRenovationCost)) return 0;
			return val.skipRenovationCosts ? 0 : toiletApartmentSizeCosts[val.apartmentSize]?.[val.newInteriorQuality] ?? 0;
		});
		const guestToiletPrice = mcalc("guestToiletPrice", opts, () => {
			if (!isNil(val.approvedGeneralRenovationCost)) return 0;
			return val.guestToiletPresent && !val.skipRenovationCosts ? val.guestToilet ? guestToiletCosts.yes[val.newInteriorQuality] || 0 : guestToiletCosts.no[val.newInteriorQuality] || 0 : 0;
		});
		const renovationExtraCost = mcalc("renovationExtraCost", opts, () => {
			if (!isNil(val.approvedRenovationExtraCost) && !val.skipRenovationCosts) return val.approvedRenovationExtraCost;
			return val.skipRenovationCosts ? 0 : val.renovationExtraCost ?? 0;
		});
		const roomsChangePrice = mcalc("roomsChangePrice", opts, () => {
			if (!isNil(val.approvedGeneralRenovationCost)) return 0;
			let price = 0;
			if (val.currentlyRooms !== val.targetRooms) {
				const diffKey = Math.abs(val.currentlyRooms - val.targetRooms);
				price = roomChangeCosts[diffKey] ?? 0;
			}
			return price;
		});
		const calculatedRenovationCosts = safeSum(generalRenovationCosts, kitchenCost, toiletPrice, guestToiletPrice, roomsChangePrice);
		const renovationCostAdjustments = mcalc("renovationCostAdjustments", opts, () => val.renovationCostAdjustments ?? 0);
		return returnOrKeepCalculationValues({
			specialRenovationCostsSum,
			generalRenovationCosts,
			kitchenCost,
			toiletPrice,
			guestToiletPrice,
			renovationExtraCost,
			roomsChangePrice,
			renovationCostAdjustments,
			renovationCosts: mcalc("renovationCosts", opts, () => safeSum(calculatedRenovationCosts, specialRenovationCostsSum, renovationCostAdjustments, renovationExtraCost)),
			calculatedRenovationCosts
		}, opts);
	};
}));
//#endregion
//#region src/domains/finance/investment/profitability-calculations/calculations/thresholds-calculations.ts
var calculateThresholds;
var init_thresholds_calculations = __esmMin((() => {
	init_helpers$3();
	calculateThresholds = (params, opts) => {
		const thresholdCasePurchasePrice = (params.totalCondoIncome / (1 + params.condoReturnTarget) - params.totalReimbursableCosts) / (1 + params.allAncillaryCostsPercents + params.agencyFeePercent + params.referralFeePercent);
		const thresholdCasePurchasePriceRounded = roundUpToNearest(thresholdCasePurchasePrice, 1e3);
		const thresholdDeltaToPrice = round$1(thresholdCasePurchasePriceRounded / params.totalPurchasePrice - 1, 4);
		const thresholdAuxiliaryCosts = Math.trunc((params.allAncillaryCostsPercents + params.agencyFeePercent + params.referralFeePercent) * thresholdCasePurchasePriceRounded);
		const totalThresholdPrice = thresholdCasePurchasePriceRounded + thresholdAuxiliaryCosts + params.totalReimbursableCosts;
		const thresholdFinancingSeniorDebt = financingCostSenior(params.inputs, totalThresholdPrice, params.renovationCosts, params.timeOnBooks);
		const thresholdFinancingJuniorDebt = financingCostJuniorDebt(params.inputs, totalThresholdPrice, params.renovationCosts, params.timeOnBooks);
		const thresholdFinancingCosts = thresholdFinancingSeniorDebt + thresholdFinancingJuniorDebt;
		const thresholdTotalOtherCosts = params.operationCosts - params.financingCosts + thresholdFinancingCosts;
		const thresholdExpectedReturn = round$1(params.totalCondoIncome - thresholdCasePurchasePriceRounded - params.totalReimbursableCosts - thresholdTotalOtherCosts - thresholdAuxiliaryCosts, 2);
		const thresholdOverallMargin = thresholdExpectedReturn / (thresholdCasePurchasePriceRounded + thresholdAuxiliaryCosts + params.totalReimbursableCosts + thresholdTotalOtherCosts);
		const thresholdNoOperationReturn = params.totalCondoIncome - (thresholdCasePurchasePriceRounded + params.totalReimbursableCosts + thresholdAuxiliaryCosts);
		return returnOrKeepCalculationValues({
			thresholdCasePurchasePrice,
			thresholdCasePurchasePriceRounded,
			thresholdDeltaToPrice,
			thresholdAuxiliaryCosts,
			thresholdFinancingSeniorDebt,
			thresholdFinancingJuniorDebt,
			thresholdFinancingCosts,
			thresholdExpectedReturn,
			thresholdOverallMargin,
			thresholdNoOperationReturn,
			thresholdNoOperationMargin: round$1(thresholdNoOperationReturn / (thresholdCasePurchasePriceRounded + thresholdAuxiliaryCosts + params.totalReimbursableCosts), 4),
			thresholdTotalExpenses: thresholdCasePurchasePriceRounded + thresholdAuxiliaryCosts + params.totalReimbursableCosts + params.operationCosts - params.financingCosts + thresholdFinancingCosts
		}, opts);
	};
}));
//#endregion
//#region src/domains/finance/investment/profitability-calculations/calculations/transferable-calculations.ts
var houseGeldOrCalculated, calculateHouseGeld, calculateHouseGeldTransferable, calculateHouseGeldNonTransferable, calculateHouseGeldReserve, calculateTransferableNonTransferableCosts;
var init_transferable_calculations = __esmMin((() => {
	init_helpers$3();
	houseGeldOrCalculated = ({ estate, inputs }) => {
		return estate.price?.houseGeld ?? (estate.attributes?.livingSpace ? calculateHouseGeld({
			livingSpace: estate.attributes.livingSpace,
			inputs
		}) : null);
	};
	calculateHouseGeld = ({ livingSpace, inputs }) => livingSpace * inputs.transformation.defaultTransferableMultiplier;
	calculateHouseGeldTransferable = ({ houseGeld, inputs }) => houseGeld * inputs.transformation.houseGeldTransferablePercent;
	calculateHouseGeldNonTransferable = ({ houseGeld, inputs }) => houseGeld * inputs.transformation.houseGeldNonTransferablePercent;
	calculateHouseGeldReserve = ({ houseGeld, houseGeldTransferable, houseGeldNonTransferable }) => houseGeld - houseGeldTransferable - houseGeldNonTransferable;
	calculateTransferableNonTransferableCosts = (params, opts) => {
		/**
		* Logic is following - if we received from API or Investment `houseGeld` than we use it and we also
		* then would have transferable with it either calculated or entered.
		* We should not have potentially situation when we have houseGeld and don't have it transferable
		*/
		const { val, inputs, isFRF, salePeriod, timeOnBooks } = params;
		const houseGeld = val.houseGeld ? val.houseGeld : calculateHouseGeld({
			livingSpace: val.livingSpace,
			inputs
		});
		const houseGeldCalculated = isFRF ? houseGeld !== val.houseGeld : null;
		const transferable = isFRF ? val.transferable ?? calculateHouseGeldTransferable({
			houseGeld,
			inputs
		}) : 0;
		const homeOwnersFeeTenant = round$1(transferable * salePeriod, 2);
		const nonTransferable = val.nonTransferableMonth ?? calculateHouseGeldNonTransferable({
			houseGeld,
			inputs
		});
		const nonTransferableMonth = isFRF ? nonTransferable : houseGeld;
		return returnOrKeepCalculationValues({
			nonTransferableMonth,
			nonTransferableYear: nonTransferableMonth * 12,
			houseGeld,
			houseGeldCalculated,
			transferable,
			homeOwnersFeeTenant,
			totalAdditionalCost: round$1(houseGeld * timeOnBooks, 2),
			additionalCostsTransferable: round$1(transferable * timeOnBooks, 2),
			additionalCostsNonTransferable: round$1(nonTransferable * timeOnBooks, 2)
		}, opts);
	};
}));
//#endregion
//#region src/domains/finance/investment/profitability-calculations/calculations/models.ts
var init_models = __esmMin((() => {}));
//#endregion
//#region src/domains/finance/investment/profitability-calculations/calculations/index.ts
var init_calculations$1 = __esmMin((() => {
	init_base_calculations$1();
	init_base_return_calculations();
	init_common_expenses_calculations();
	init_distressed_thresholds_calculations();
	init_financing_calculations();
	init_income_calculations();
	init_market_price_calculations();
	init_other_costs_calculations();
	init_profitability_calculations$1();
	init_renovation_calculations();
	init_thresholds_calculations();
	init_transferable_calculations();
	init_models();
	init_helpers$3();
}));
//#endregion
//#region src/domains/finance/investment/profitability-calculations/calculations/distribution-marketing-costs.ts
var calculateDistributionMarketingCosts;
var init_distribution_marketing_costs = __esmMin((() => {
	init_helpers$3();
	calculateDistributionMarketingCosts = (params, opts) => {
		const propertyRelatedCosts = params.val.propertyRelatedCosts ?? params.inputs.operationCosts.propertyRelatedCosts ?? 0;
		return returnOrKeepCalculationValues({
			propertyRelatedCosts,
			distributionMarketingCosts: safeSum(params.sellingCosts, propertyRelatedCosts, params.specialAgreementsAddition, params.bonusAddition, params.pmIncentiveAddition)
		}, opts);
	};
}));
//#endregion
//#region src/domains/finance/investment/profitability-calculations/profitability-calculations.model.ts
var DistributionType;
var init_profitability_calculations_model = __esmMin((() => {
	DistributionType = /* @__PURE__ */ function(DistributionType) {
		DistributionType["FFF"] = "FFF";
		DistributionType["FRF"] = "FRF";
		return DistributionType;
	}({});
}));
//#endregion
//#region src/domains/finance/investment/profitability-calculations/profitability-calculations-v2.ts
var calculateV2;
var init_profitability_calculations_v2 = __esmMin((() => {
	init_base();
	init_base_calculations$1();
	init_base_return_calculations();
	init_common_expenses_calculations();
	init_distressed_thresholds_calculations();
	init_distribution_marketing_costs();
	init_financing_calculations();
	init_income_calculations();
	init_market_price_calculations();
	init_other_costs_calculations();
	init_profitability_calculations$1();
	init_renovation_calculations();
	init_thresholds_calculations();
	init_transferable_calculations();
	calculateV2 = (val, inputs, tables, opts) => {
		if (val.interiorQuality === "NA" || val.interiorQuality === "NoInformation") val.interiorQuality = "Normal";
		if (!val.newInteriorQuality || ["NA", "NoInformation"].includes(val.newInteriorQuality)) val.newInteriorQuality = "Normal";
		const distributionType = val.distributionType ?? "FRF";
		const tenantPresent = distributionType === "FFF" ? false : val.tenantPresent ?? false;
		const baseParams = {
			val,
			inputs,
			tables,
			VAT,
			tenantPresent,
			isFRF: distributionType === "FRF",
			tenantPresentAndFRF: tenantPresent && distributionType === "FRF"
		};
		const baseValues = calculateBaseValues(baseParams, opts);
		const incomeParams = calculateIncomeParams({
			...baseParams,
			monthlyRent: baseValues.monthlyRent
		}, opts);
		const commonExpenses = calculateCommonExpenses({
			...baseParams,
			totalPurchasePrice: baseValues.totalPurchasePrice,
			investorIncome: incomeParams.investorIncome,
			bonus: baseValues.bonus,
			pmIncentive: baseValues.pmIncentive,
			specialAgreements: baseValues.specialAgreements,
			skipAgencyFee: val.skipAgencyFee
		}, opts);
		const renovationCosts = calculateRenovationCosts(baseParams, opts);
		const transferableCosts = calculateTransferableNonTransferableCosts({
			...baseParams,
			timeOnBooks: baseValues.timeOnBooks,
			salePeriod: inputs.investing.salePeriod
		}, opts);
		const otherCosts = calculateOtherCosts({
			...baseParams,
			totalAdditionalCost: transferableCosts.totalAdditionalCost,
			extraCost: baseValues.extraCost,
			timeOnBooks: baseValues.timeOnBooks,
			skipOtherCosts: val.skipOtherCosts
		}, opts);
		const financingCosts = calculateFinancingCosts({
			...baseParams,
			otherCosts: otherCosts.otherCosts,
			transactionCosts: commonExpenses.auxiliaryCosts,
			totalAdditionalCost: transferableCosts.totalAdditionalCost,
			totalPurchasePrice: baseValues.totalPurchasePrice,
			auxiliaryCosts: commonExpenses.auxiliaryCosts,
			monthlyRent: baseValues.monthlyRent,
			expectedSalesPrice: commonExpenses.expectedSalesPrice,
			transferable: transferableCosts.transferable,
			sellingCommission: commonExpenses.sellingCommission,
			salesKickBack: baseValues.salesKickBack,
			renovationCosts: renovationCosts.renovationCosts,
			timeOnBooks: baseValues.timeOnBooks,
			skipFinancingCosts: val.skipFinancingCosts
		}, opts);
		const distributionMarketingCosts = calculateDistributionMarketingCosts({
			...baseParams,
			sellingCosts: commonExpenses.sellingCosts,
			specialAgreementsAddition: commonExpenses.specialAgreementsAddition,
			bonusAddition: commonExpenses.bonusAddition,
			pmIncentiveAddition: commonExpenses.pmIncentiveAddition
		}, opts);
		const baseReturnValues = calculateBaseReturnValues({
			...baseParams,
			totalCondoIncome: financingCosts.totalCondoIncome,
			totalPurchasePrice: baseValues.totalPurchasePrice,
			renovationCosts: renovationCosts.renovationCosts,
			otherCosts: otherCosts.otherCosts,
			transactionCosts: commonExpenses.auxiliaryCosts,
			operatingCosts: financingCosts.operationCosts,
			distributionMarketingCosts: distributionMarketingCosts.distributionMarketingCosts,
			expectedSalesPrice: commonExpenses.expectedSalesPrice
		}, opts);
		const marketPriceValues = calculateMarketPrice({
			...baseParams,
			marketPricePurchasingPrice: baseValues.marketPricePurchasingPrice,
			allAncillaryCostsPercents: baseValues.allAncillaryCostsPercents,
			agencyFeePercent: commonExpenses.agencyFeePercent,
			referralFeePercent: commonExpenses.referralFeePercent,
			renovationCosts: renovationCosts.renovationCosts,
			otherCosts: otherCosts.otherCosts,
			totalCondoIncome: financingCosts.totalCondoIncome,
			financingCosts: financingCosts.financingCosts,
			operatingCosts: financingCosts.operationCosts,
			distributionMarketingCosts: distributionMarketingCosts.distributionMarketingCosts,
			timeOnBooks: baseValues.timeOnBooks,
			expectedSalesPrice: commonExpenses.expectedSalesPrice
		}, opts);
		const thresholds = calculateThresholds({
			...baseParams,
			totalCondoIncome: financingCosts.totalCondoIncome,
			condoReturnTarget: baseValues.condoReturnTarget,
			totalReimbursableCosts: financingCosts.totalReimbursableCosts,
			allAncillaryCostsPercents: baseValues.allAncillaryCostsPercents,
			agencyFeePercent: commonExpenses.agencyFeePercent,
			referralFeePercent: commonExpenses.referralFeePercent,
			totalPurchasePrice: baseValues.totalPurchasePrice,
			financingCosts: financingCosts.financingCosts,
			operationCosts: financingCosts.operationCosts,
			renovationCosts: renovationCosts.renovationCosts,
			timeOnBooks: baseValues.timeOnBooks
		}, opts);
		const sensitiveDistressedValues = calculateSensitiveDistressedCaseValues({
			...baseParams,
			totalCondoIncome: financingCosts.totalCondoIncome,
			operationCosts: financingCosts.operationCosts,
			financingCosts: financingCosts.financingCosts,
			totalReimbursableCosts: financingCosts.totalReimbursableCosts,
			allAncillaryCostsPercents: baseValues.allAncillaryCostsPercents,
			agencyFeePercent: commonExpenses.agencyFeePercent,
			referralFeePercent: commonExpenses.referralFeePercent,
			monthlyRent: baseValues.monthlyRent,
			rentalReturnTarget: commonExpenses.rentalReturnTarget,
			yearParkingLotIncome: incomeParams.yearParkingLotIncome,
			investorIncome: incomeParams.investorIncome,
			totalPurchasePrice: baseValues.totalPurchasePrice,
			auxiliaryCosts: commonExpenses.auxiliaryCosts,
			sellingCommission: commonExpenses.sellingCommission,
			homeOwnersFeeTenant: transferableCosts.homeOwnersFeeTenant,
			rentalIncomeDuringHold: financingCosts.rentalIncomeDuringHold,
			expectedSalesPrice: commonExpenses.expectedSalesPrice,
			nonTransferableYear: transferableCosts.nonTransferableYear,
			serviceCharge: financingCosts.serviceCharge,
			totalExpenses: baseReturnValues.totalExpenses,
			grossInvestmentCosts: baseReturnValues.grossInvestmentCosts,
			condoReturnTarget: baseValues.condoReturnTarget,
			marketPriceTotalExpenses: marketPriceValues?.marketPriceTotalExpenses,
			timeOnBooks: baseValues.timeOnBooks
		}, opts);
		const returnTargetProfitability = calculateReturnTargetProfitability({
			expectedSalesPrice: commonExpenses.expectedSalesPrice,
			distributionMarketingCosts: distributionMarketingCosts.distributionMarketingCosts,
			netContributionMarginPercent: baseReturnValues.netContributionMarginPercent,
			renovationCosts: renovationCosts.renovationCosts,
			otherCosts: otherCosts.otherCosts,
			purchasingPrice: baseValues.totalPurchasePrice,
			condoReturnTarget: baseValues.condoReturnTarget,
			allAncillaryCostsPercents: baseValues.allAncillaryCostsPercents,
			agencyFeePercent: commonExpenses.agencyFeePercent,
			referralFeePercent: commonExpenses.referralFeePercent
		});
		return {
			...baseValues,
			...incomeParams,
			...commonExpenses,
			...renovationCosts,
			...transferableCosts,
			...otherCosts,
			...financingCosts,
			...distributionMarketingCosts,
			...baseReturnValues,
			...marketPriceValues,
			...thresholds,
			...sensitiveDistressedValues,
			...returnTargetProfitability,
			tenantPresent,
			distributionType,
			totalOtherCosts: financingCosts.operationCosts,
			listedPricePurchasingPrice: baseValues.totalPurchasePrice,
			thresholdOverallReturn: thresholds.thresholdExpectedReturn
		};
	};
}));
//#endregion
//#region src/domains/finance/investment/profitability-calculations/profitability-calculations.class.ts
var recalculateProfitability, ProfitabilityCalculationsClass;
var init_profitability_calculations_class = __esmMin((() => {
	init_helpers$4();
	init_calculations$1();
	init_helpers$3();
	init_profitability_calculations_v2();
	recalculateProfitability = (val, inputs, tables, opts, previousResult) => {
		if (val.interiorQuality === "NA" || val.interiorQuality === "NoInformation") val.interiorQuality = "Normal";
		if (!val.newInteriorQuality || ["NA", "NoInformation"].includes(val.newInteriorQuality)) val.newInteriorQuality = "Normal";
		return calculateV2(val, inputs, tables, opts ? {
			...opts,
			previousResult
		} : void 0);
	};
	ProfitabilityCalculationsClass = class ProfitabilityCalculationsClass {
		cashFlow;
		additionalCostsNonTransferable;
		salePeriod;
		renovationDuration;
		timeOnBooks;
		additionalCostsTransferable;
		agencyFee;
		auxiliaryCosts;
		cleaningPrice;
		expectedSalesPrice;
		financingCosts;
		generalRenovationCosts;
		houseGeld;
		houseGeldCalculated;
		kitchenCost;
		propertyRelatedCosts;
		distributionMarketingCosts;
		listedMarginNoOperation;
		listedOverallMargin;
		listedPriceNoOperationReturn;
		netContributionMargin;
		netContributionMarginPercent;
		listedPriceOverallReturn;
		listedPricePurchasingPrice;
		listedPriceTotalExpenses;
		marketPriceAuxiliaryCosts;
		marketPriceFinancingCosts;
		marketPriceNoOperationMargin;
		marketPriceNoOperationReturn;
		marketPriceOverallMargin;
		marketPriceOverallReturn;
		marketPricePurchasingPrice;
		marketPriceTotalExpenses;
		grossInvestmentCosts;
		notaryCost;
		operationCosts;
		parkingSpacePurchasePrice;
		propertyRegistration;
		referralFee;
		referralFeePercent;
		renovationCosts;
		calculatedRenovationCosts;
		renovationExtraCost;
		approvedGeneralRenovationCost;
		approvedKitchenCost;
		approvedRenovationExtraCost;
		renovationCostAdjustments;
		specialAgreements;
		sellingThresholdTotalReturnCM2;
		sellingThresholdTotalReturnCM1;
		sellingThresholdCM1;
		sellingThresholdCM2;
		sellingThresholdOperatingReturnCM2;
		sellingThresholdOperatingReturnCM1;
		profThresholdCM1SalesPrice;
		profThresholdCM1SalesPriceRounded;
		profThresholdCM2SalesPrice;
		profThresholdCM2SalesPriceRounded;
		sellingMarketPriceOperatingReturn;
		sellingMarketPriceTotalReturn;
		sellingMarketPriceCM1;
		sellingMarketPriceCM2;
		bonus;
		pmIncentive;
		extraCost;
		salesKickBack;
		rentalIncomeDuringHold;
		roomsChangePrice;
		sellingCosts;
		sensitivityMaxInvestorReturnDeviation;
		sensitivityMaximumCostOvershoot;
		sensitivityMaximumCostOvershootDeviation;
		sensitivityMaximumInvestorReturn;
		sensitivityMinimumRentBreakEven;
		sensitivityRentPriceDeviation;
		taxes;
		thresholdAuxiliaryCosts;
		thresholdCasePurchasePrice;
		thresholdCasePurchasePriceRounded;
		thresholdDeltaToPrice;
		thresholdExpectedReturn;
		thresholdFinancingCosts;
		thresholdNoOperationMargin;
		thresholdNoOperationReturn;
		thresholdOverallMargin;
		thresholdOverallReturn;
		thresholdTotalExpenses;
		toiletPrice;
		guestToiletPrice;
		totalAdditionalCost;
		totalCondoIncome;
		totalLaborCosts;
		totalOtherCosts;
		transferable;
		serviceCharge;
		yearParkingLotIncome;
		yearRentalIncome;
		zeroMarginAuxiliaryCosts;
		zeroMarginFinancingCosts;
		zeroMarginPurchasingPrice;
		specialAgreementsAddition = 0;
		bonusAddition = 0;
		pmIncentiveAddition = 0;
		agencyFeePercent;
		investorIncome;
		totalPurchasePrice;
		allAncillaryCostsPercents;
		nonTransferableYear;
		nonTransferableMonth;
		sellingCommission;
		financingCostsSeniorDebt;
		financingCostsJuniorDebt;
		marketPriceFinancingCostsSeniorDebt;
		marketPriceFinancingCostsJuniorDebt;
		thresholdFinancingSeniorDebt;
		thresholdFinancingJuniorDebt;
		otherCosts;
		ifcScanCosts;
		takingPictures;
		utilities;
		logger;
		tenantPresent;
		monthlyRent;
		rentalReturnTarget;
		asbestosAdditionCalculated;
		prefabricatedAdditionCalculated;
		newFloorHistoricAdditionCalculated;
		storeyHeightAdditionCalculated;
		historicDoors;
		gasBoilerAdditionCalculated;
		maisonetteAdditionCalculated;
		heatingPipesAdditionCalculated;
		asbestosAndPrefabricatedSum;
		specialRenovationCostsSum;
		distributionType;
		type;
		configId;
		configRecord;
		condoReturnTarget;
		defaultRentalReturnTarget;
		calculationType = "prediction";
		constructor(props, logger = defaultLogger) {
			ProfitabilityCalculationsClass.prototype.logger = logger;
			if (props) Object.assign(this, props);
			this.initializeDefaultValues();
		}
		initializeDefaultValues() {
			this.distributionType = this.distributionType ?? this.type;
			const isFRF = this.distributionType === "FRF";
			this.tenantPresent = this.tenantPresent && isFRF;
			const inputs = this.configRecord?.configRow?.Inputs?.config;
			this.nonTransferableMonth = this.nonTransferableMonth ?? (!isNil(this.houseGeld) && isFRF) ? !isNil(inputs) ? calculateHouseGeldNonTransferable({
				houseGeld: this.houseGeld,
				inputs
			}) : this.houseGeld - (this.transferable ?? 0) : 0;
			this.nonTransferableYear = this.nonTransferableMonth * 12;
		}
		get targetReturnCm1() {
			return this.condoReturnTarget;
		}
		get rentalParkingLotIncomeMonth() {
			return this.yearParkingLotIncome / 12;
		}
		get estatePurchasePrice() {
			return this.listedPricePurchasingPrice - (this.parkingSpacePurchasePrice ?? 0);
		}
		get houseGeldYear() {
			return this.houseGeld * 12;
		}
		get maklerFeePercent() {
			return round$1(this.sellingCosts / this.expectedSalesPrice, 4);
		}
		get targetReturn() {
			if (this.distributionType === "FRF") return this.rentalReturnTarget || this.defaultRentalReturnTarget;
			return 0;
		}
		get transferableYear() {
			if (this.tenantPresent) return this.transferable * 12;
			return 0;
		}
		get incomeYear() {
			if (this.distributionType === "FRF") return this.yearRentalIncome + (this.yearParkingLotIncome ?? 0);
			return 0;
		}
		static seniorWacc(seniorDebtInterest, seniorDebtProcessingFee, sumDuration) {
			return seniorWacc(seniorDebtInterest, seniorDebtProcessingFee, sumDuration);
		}
		static juniorWacc(juniorDebtInterest, sumDuration) {
			return juniorWacc(juniorDebtInterest, sumDuration);
		}
		static waccTotal(seniorDebtInterest, seniorDebtProcessingFee, juniorDebtInterest, juniorDebtRatio, timeOnBooks) {
			return waccTotal(seniorDebtInterest, seniorDebtProcessingFee, juniorDebtInterest, juniorDebtRatio, timeOnBooks);
		}
		static tenantPresentAndFRF(val, baseTenantPresent) {
			const tenantPresent = isNil(val.tenantPresent) ? baseTenantPresent : val.tenantPresent;
			return ProfitabilityCalculationsClass.isFRF(val) && tenantPresent;
		}
		static isFRF(val) {
			return (val.distributionType ?? "FRF") === "FRF";
		}
		get isCM1_5Achieved() {
			return this.netContributionMarginPercent >= (this.configRecord?.configRow?.Inputs?.config?.expectedReturn?.condoReturnTarget ?? 0);
		}
		calculate(val, inputs, tables, opts) {
			const calculatedValues = recalculateProfitability(val, inputs, tables, opts, this);
			Object.assign(this, calculatedValues);
			return this;
		}
	};
}));
//#endregion
//#region src/domains/finance/investment/prediction-result.class.ts
var PredictionResultClass;
var init_prediction_result_class = __esmMin((() => {
	init_config_record_class();
	init_profitability_calculations_class();
	PredictionResultClass = class PredictionResultClass extends ProfitabilityCalculationsClass {
		baseRentPerSquareMeter;
		createdAt;
		estate;
		estateConfiguration;
		estateId;
		externalData;
		isProfitable;
		modelName;
		modelVersion;
		predictionId;
		rawResponse;
		requestUuid;
		uuid;
		/** @deprecated use config.inputs/tables */
		fixedCostsConfiguration;
		vectorizerName;
		calculationVersionRef;
		predictionValues = {};
		constructor(props) {
			super(props);
			if (props) Object.assign(this, props);
		}
		copy() {
			return new PredictionResultClass(this);
		}
		setConfigRecord(configRecord) {
			if (configRecord.encodedIdPath !== this.configId) throw new Error(`Provided config-record does not match config-id ${this.configId}`);
			this.configRecord = configRecord instanceof ConfigRecord ? configRecord : new ConfigRecord(configRecord);
		}
		get targetReturn() {
			return super.targetReturn || this.configRecord?.configRow?.Inputs?.config?.expectedReturn?.rentalReturnTarget;
		}
		get targetReturnCm1() {
			return super.targetReturnCm1 || this.configRecord?.configRow?.Inputs?.config?.expectedReturn?.condoReturnTarget;
		}
		get ancillaryCostsPerSquareMeter() {
			return this.auxiliaryCosts / this.estateConfiguration.livingSpace;
		}
		get purchasePricePerSquareMeter() {
			return this.estatePurchasePrice / this.estateConfiguration.livingSpace;
		}
		get renovationCostsPerSquareMeter() {
			return this.renovationCosts / this.estateConfiguration.livingSpace;
		}
		get homeOwnerPerSqM() {
			return this.totalAdditionalCost / this.estateConfiguration.livingSpace;
		}
		get salesPricePerSquareMeter() {
			return round$1(this.expectedSalesPrice / this.estateConfiguration.livingSpace, 2);
		}
		get incomeMonth() {
			return this.baseRentPerSquareMeter * this.estateConfiguration.livingSpace + this.yearParkingLotIncome / 12;
		}
		get rentalIncome() {
			return this.baseRentPerSquareMeter * this.estateConfiguration.livingSpace;
		}
		get isCM1Achieved() {
			return this.listedMarginNoOperation >= (this.configRecord?.configRow?.Inputs?.config?.expectedReturn?.condoReturnTarget ?? 0);
		}
		get isCM2Achieved() {
			return this.listedOverallMargin >= (this.configRecord?.configRow?.Inputs?.config?.expectedReturn?.condoReturnTargetOverall ?? 0);
		}
		get coldRentPerSquareMeter() {
			return this.baseRentPerSquareMeter;
		}
	};
}));
//#endregion
//#region src/domains/cross-cutting/authz/authz.model.ts
var extractRoleBindingDtoFromRolebindingGroup, fromRoleBindingsToRoleBindingDtos, fromRoleBindingDtosToRoleBindings, RoleBindingCombination;
var init_authz_model = __esmMin((() => {
	init_errors();
	extractRoleBindingDtoFromRolebindingGroup = (roleBindings) => {
		return {
			roleId: roleBindings[0].roleId,
			role: roleBindings[0].role,
			userUid: roleBindings[0].userUid,
			roleBindings: roleBindings.map((roleBinding) => {
				if (!roleBinding.conditions?.length) return { roleBindingId: roleBinding.roleBindingId };
				if (!roleBinding.conditions.every((cond) => (cond.value?.ref)?.resourceType === "region")) throw new ApplicationError("Every resource-conditions need to be of resourceType region for now");
				const roleBindingRegionIds = uniq(roleBinding.conditions.map((cond) => (cond.value?.ref)?.resourceId).filter(Boolean));
				if (roleBindingRegionIds.length !== 1) throw new ApplicationError(`Encountered different values for regionIds within a role-binding condition for id ${roleBinding.roleBindingId}`);
				return {
					roleBindingId: roleBinding.roleBindingId,
					conditionRegionId: roleBindingRegionIds[0]
				};
			})
		};
	};
	fromRoleBindingsToRoleBindingDtos = (roleBindings) => {
		if (!roleBindings.length) return [];
		if (uniq(roleBindings.map((rb) => rb.userUid)).length > 1) throw new ApplicationError("Cannot have more than one userUid for a given role-binding, refusing to convert");
		return Object.values(mapValues(groupBy(roleBindings, (role) => role.roleId), extractRoleBindingDtoFromRolebindingGroup));
	};
	fromRoleBindingDtosToRoleBindings = (roleBindingDtos) => {
		if (!roleBindingDtos.length) return [];
		if (uniq(roleBindingDtos.map((rb) => rb.userUid)).length > 1) throw new ApplicationError("Cannot have more than one userUid for a given role-binding, refusing to convert");
		return roleBindingDtos.flatMap((roleBindingDto) => {
			if (!roleBindingDto.roleBindings?.length) return {
				userUid: roleBindingDto.userUid,
				roleId: roleBindingDto.roleId,
				role: roleBindingDto.role,
				conditions: []
			};
			return roleBindingDto.roleBindings.map(({ roleBindingId, conditionRegionId }) => {
				if (!conditionRegionId) return {
					roleBindingId,
					userUid: roleBindingDto.userUid,
					roleId: roleBindingDto.roleId,
					role: roleBindingDto.role,
					conditions: []
				};
				return {
					roleBindingId,
					userUid: roleBindingDto.userUid,
					roleId: roleBindingDto.roleId,
					role: roleBindingDto.role,
					conditions: [{
						resourceType: "estate",
						resourceProperty: "location.region.regionName",
						comparator: "IS",
						value: { ref: {
							resourceId: conditionRegionId,
							resourceType: "region",
							resourceProperty: "regionName"
						} }
					}, {
						resourceType: "invoice",
						resourceProperty: "region.regionName",
						comparator: "IS",
						value: { ref: {
							resourceId: conditionRegionId,
							resourceType: "region",
							resourceProperty: "regionName"
						} }
					}],
					conditionCombination: "OR"
				};
			});
		});
	};
	RoleBindingCombination = /* @__PURE__ */ function(RoleBindingCombination) {
		RoleBindingCombination["AND"] = "AND";
		RoleBindingCombination["OR"] = "OR";
		return RoleBindingCombination;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/authz/permissions.ts
var WildcardPermission, Permission;
var init_permissions = __esmMin((() => {
	WildcardPermission = {
		All: "*.*.*",
		Admin: "*.*.*",
		EstateAll: "estate.*.*",
		EstateContactsAll: "estate.contacts.*",
		EstateDocumentsAll: "estate.documents.*",
		EstateMediaAll: "estate.media.*",
		EstateTasksAll: "estate.tasks.*",
		EstateCalendar: "estate.calendar.*",
		MFHCaledar: "mfh.calendar.*"
	};
	Permission = {
		AgentChatViewAny: "agent.chat.view-any",
		AgentFeedbackManage: "agent.feedback.manage",
		AgentModelsManage: "agent.models.manage",
		SpotlightManage: "spotlight.catalogue.manage",
		SpotlightReportView: "spotlight.report.view",
		EstateEstateView: "estate.estate.view",
		EstateEstateEdit: "estate.estate.edit",
		EstateEstateCreate: "estate.estate.create",
		EstateEstateDelete: "estate.estate.delete",
		EstateAttributesView: "estate.attributes.view",
		EstateAttributesEdit: "estate.attributes.edit",
		EstateNotesView: "estate.notes.view",
		EstateNotesCreate: "estate.notes.create",
		EstateNotesEdit: "estate.notes.edit",
		EstateNotesDelete: "estate.notes.delete",
		EstateLocationView: "estate.location.view",
		EstateLocationEdit: "estate.location.edit",
		EstateContactsView: "estate.contacts.view",
		EstateContactsCreate: "estate.contacts.create",
		EstateContactsDelete: "estate.contacts.delete",
		EstateCredentialsView: "estate.credentials.view",
		EstateCredentialsCreate: "estate.credentials.create",
		EstateCredentialsDelete: "estate.credentials.delete",
		EstateDocumentView: "estate.document.view",
		EstateDocumentUpload: "estate.document.upload",
		EstateDocumentDownload: "estate.document.download",
		EstateDocumentEdit: "estate.document.edit",
		EstateDocumentsDelete: "estate.documents.delete",
		EstateDocumentsCreate: "estate.documents.create",
		EstateDocumentsSend: "estate.documents.send",
		DataRoomCreate: "core.data-room.create",
		DataRoomEdit: "core.data-room.edit",
		DataRoomDelete: "core.data-room.delete",
		DataRoomView: "core.data-room.view",
		EstateMediaView: "estate.media.view",
		EstateMediaEdit: "estate.media.edit",
		EstateMediaCreate: "estate.media.create",
		EstateMediaDelete: "estate.media.delete",
		EstateTasksView: "estate.tasks.view",
		EstateTasksEdit: "estate.tasks.edit",
		EstateTasksCreate: "estate.tasks.create",
		EstateTasksDelete: "estate.tasks.delete",
		EstateFindTransactionMonitoringEstatesView: "estate.find-transaction-monitoring-estates.view",
		EstateControllingView: "estate.controlling.view",
		EstateCalendarView: "estate.calendar.view",
		EstateCalendarEdit: "estate.calendar.edit",
		EstateCalendarCreate: "estate.calendar.create",
		EstateCalendarDelete: "estate.calendar.delete",
		EstateEventsView: "estate.events.view",
		EstatePredictionRecalculate: "estate.prediction.recalculate",
		MfhContactsList: "mfh.contacts.list",
		MfhContactsCreate: "mfh.contacts.create",
		MFHImpersonateAssetPartner: "mfh.impersonate.asset-partner",
		MFHMFHView: "mfh.mfh.view",
		MFHMFHEdit: "mfh.mfh.edit",
		MFHMFHDelete: "mfh.mfh.delete",
		MFHMFHCreate: "mfh.mfh.create",
		MFHMFHBulkCreate: "mfh.mfh.bulk-create",
		MFHCapexEeConfigView: "mfh.capex-ee-config.view",
		MFHCapexEeConfigCreate: "mfh.capex-ee-config.create",
		MFHCapexEeConfigEdit: "mfh.capex-ee-config.edit",
		MFHCapexEeConfigDelete: "mfh.capex-ee-config.delete",
		MFHCapexEeScenarioView: "mfh.capex-ee-scenario.view",
		MFHCapexEeScenarioEdit: "mfh.capex-ee-scenario.edit",
		MFHCapexEeScenarioCreate: "mfh.capex-ee-scenario.create",
		MFHCapexEeScenarioDelete: "mfh.capex-ee-scenario.delete",
		MFHEstarCoreIdEdit: "mfh.estar-core-id.edit",
		MFHEventsView: "mfh.events.view",
		MFHAttributesView: "mfh.attributes.view",
		MFHAttributesEdit: "mfh.attributes.edit",
		MFHRenovationAttributesEdit: "mfh.renovation-attributes.edit",
		MFHLocationView: "mfh.location.view",
		MFHLocationEdit: "mfh.location.edit",
		MFHTasksView: "mfh.tasks.view",
		MFHTasksEdit: "mfh.tasks.edit",
		MFHTasksCreate: "mfh.tasks.create",
		MFHTasksDelete: "mfh.tasks.delete",
		MFHProjectPlanningView: "mfh.project-planning.view",
		MFHProjectPlanningEdit: "mfh.project-planning.edit",
		MFHProjectPlanningCreate: "mfh.project-planning.create",
		MFHProjectPlanningDelete: "mfh.project-planning.delete",
		MFHCalendarView: "mfh.calendar.view",
		MFHCalendarEdit: "mfh.calendar.edit",
		MFHCalendarCreate: "mfh.calendar.create",
		MFHCalendarDelete: "mfh.calendar.delete",
		MFHDocumentView: "mfh.document.view",
		MFHDocumentEdit: "mfh.document.edit",
		MFHDocumentUpload: "mfh.document.upload",
		MFHDocumentDelete: "mfh.document.delete",
		MFHRenovationProjectConfigEdit: "mfh.renovation-project-config.edit",
		MFHRenovationProjectCreate: "mfh.renovation-project.create",
		MFHRenovationProjectView: "mfh.renovation-project.view",
		MFHRenovationProjectEdit: "mfh.renovation-project.edit",
		MFHRenovationProjectDelete: "mfh.renovation-project.delete",
		MFHRenovationProjectReviewProcessCreate: "mfh.renovation-project.review-process.create",
		MFHRenovationProjectReviewProcessView: "mfh.renovation-project.review-process.view",
		MFHRenovationProjectReviewProcessEdit: "mfh.renovation-project.review-process.edit",
		MFHRenovationProjectReviewProcessProcess: "mfh.renovation-project.review-process.process",
		MFHRenovationProjectPlanningModuleDelete: "mfh.renovation-project-planning-module.delete",
		MFHRenovationProjectPositionDelete: "mfh.renovation-project-position.delete",
		MFHRenovationEventHistoryView: "mfh.renovation-event.history.view",
		MFHRenovationProjectLotDelete: "mfh.renovation-project-lot.delete",
		MFHElementsCreate: "mfh.elements.create",
		MFHElementsEdit: "mfh.elements.edit",
		MFHElementsView: "mfh.elements.view",
		MFHElementsDelete: "mfh.elements.delete",
		MFHMediaView: "mfh.media.view",
		MFHMediaEdit: "mfh.media.edit",
		MFHNotesView: "mfh.notes.view",
		MFHNotesCreate: "mfh.notes.create",
		MFHNotesEdit: "mfh.notes.edit",
		MFHNotesDelete: "mfh.notes.delete",
		MFHDDView: "mfh.dd.view",
		MFHDDEdit: "mfh.dd.edit",
		MFHInfasFetch: "mfh.infas.fetch",
		MFHSyteFetch: "mfh.syte.fetch",
		MFHSyteDebug: "mfh.syte.debug",
		MFHInvestmentCaseView: "mfh.investment-case.view",
		MFHInvestmentCaseCreate: "mfh.investment-case.create",
		MFHInvestmentCaseEdit: "mfh.investment-case.edit",
		MFHInvestmentCaseExport: "mfh.investment-case.export",
		MFHInvestmentCaseUpload: "mfh.investment-case.upload",
		MFHInvestmentCaseDelete: "mfh.investment-case.delete",
		MFHInvestmentCaseRestore: "mfh.investment-case.restore",
		MFHInvestmentCaseAdminInputEdit: "mfh.investment-case-admin-input.edit",
		MFHAssetAnalyzerView: "mfh.asset-analyzer.view",
		/** Edit any Asset Analyzer session, including ones the user did not create. */
		MFHAssetAnalyzerEditAny: "mfh.asset-analyzer.edit-any",
		/** Admin/debug: copy investment case (+ optional rent roll) as JSON transfer payload. */
		MFHInvestmentCaseCopyAsJson: "mfh.investment-case.copy-as-json",
		/** Admin/debug: paste/import investment case from JSON transfer payload. */
		MFHInvestmentCasePasteAsJson: "mfh.investment-case.paste-as-json",
		MFHInvestmentCaseReviewProcessCreate: "mfh.investment-case-review-process.create",
		MFHInvestmentCaseReviewProcessView: "mfh.investment-case-review-process.view",
		MFHInvestmentCaseReviewProcessEdit: "mfh.investment-case-review-process.edit",
		MFHInvestmentCaseReviewProcessProcess: "mfh.investment-case-review-process.process",
		MFHPortfolioProcessTrigger: "mfh-portfolio.process.trigger",
		MFHPortfolioReviewProcessCreate: "mfh.portfolio-review-process.create",
		MFHPortfolioReviewProcessView: "mfh.portfolio-review-process.view",
		MFHPortfolioReviewProcessEdit: "mfh.portfolio-review-process.edit",
		MFHPortfolioReviewProcessProcess: "mfh.portfolio-review-process.process",
		MFHPortfolioTasksView: "mfh-portfolio.tasks.view",
		MFHPortfolioTasksEdit: "mfh-portfolio.tasks.edit",
		MFHPortfolioTasksCreate: "mfh-portfolio.tasks.create",
		MFHPortfolioTasksDelete: "mfh-portfolio.tasks.delete",
		MFHPredictionView: "mfh.prediction.view",
		MFHPredictionCreate: "mfh.prediction.create",
		MFHPredictionEdit: "mfh.prediction.edit",
		MFHPredictionDelete: "mfh.prediction.delete",
		MFHRentRollImport: "mfh.rent-roll.import",
		MFHRentRollVersionView: "mfh.rent-roll-version.view",
		MFHRentRollVersionCreate: "mfh.rent-roll-version.create",
		MFHRentRollVersionEdit: "mfh.rent-roll-version.edit",
		MFHRentRollVersionDelete: "mfh.rent-roll-version.delete",
		MFHPlacementView: "mfh.placement.view",
		MFHPlacementCreate: "mfh.placement.create",
		MFHPlacementEdit: "mfh.placement.edit",
		SignOffEnvelopeCreate: "core.sign-off-envelope.create",
		SignOffEnvelopeCancel: "core.sign-off-envelope.cancel",
		SignOffEnvelopeView: "core.sign-off-envelope.view",
		SignOffEnvelopeDelete: "core.sign-off-envelope.delete",
		SignOffEnvelopeList: "core.sign-off-envelope.list",
		SignOffEnvelopeEdit: "core.sign-off-envelope.edit",
		SignOffEnvelopeTrigger: "core.sign-off-envelope.trigger",
		SignOffCommentCreate: "core.sign-off-comment.create",
		SignOffCommentView: "core.sign-off-comment.view",
		SignOffCommentEdit: "core.sign-off-comment.edit",
		SignOffCommentDelete: "core.sign-off-comment.delete",
		SignOffTemplateCreate: "core.sign-off-template.create",
		SignOffTemplateEdit: "core.sign-off-template.edit",
		TenderingProcessView: "renovation.tendering-process.view",
		TenderingProcessCreate: "renovation.tendering-process.create",
		TenderingProcessEdit: "renovation.tendering-process.edit",
		TenderingProcessDelete: "renovation.tendering-process.delete",
		AddendumCreate: "renovation.addendum.create",
		AddendumView: "renovation.addendum.view",
		AddendumEdit: "renovation.addendum.edit",
		ConstructionPlanView: "mfh.construction-plan.view",
		ConstructionPlanEdit: "mfh.construction-plan.edit",
		ConstructionPlanApprovalMatrixEdit: "mfh.construction-plan-approval-matrix.edit",
		ConstructionPlanApprove: "mfh.construction-plan.approve",
		ConstructionPlanCreate: "mfh.construction-plan.create",
		ConstructionPlanDelete: "mfh.construction-plan.delete",
		ConstructionPlanArchive: "mfh.construction-plan.archive",
		DocumentAnnotationCreate: "document.annotation.create",
		DocumentAnnotationUpdate: "document.annotation.update",
		DocumentAnnotationUpdateAny: "document.annotation.update-any",
		DocumentAnnotationDelete: "document.annotation.delete",
		DocumentAnnotationDeleteAny: "document.annotation.delete-any",
		PositionCostAllocationCreate: "renovation.position-cost-allocation.create",
		PositionCostAllocationView: "renovation.position-cost-allocation.view",
		RenovationContractView: "renovation.contract.view",
		RenovationContractCreate: "renovation.contract.create",
		RenovationContractEdit: "renovation.contract.edit",
		RenovationContractDelete: "renovation.contract.delete",
		RentalContractReviewProcessCreate: "rental.rental-contract-review-process.create",
		RentalContractView: "rental.rental-contract.view",
		RentalContractCreate: "rental.rental-contract.create",
		RentalContractEdit: "rental.rental-contract.edit",
		RentalContractDelete: "rental.rental-contract.delete",
		EstateSourcingView: "estate.sourcing.view",
		EstateInspectionReviewProcessView: "estate.inspection.review-process.view",
		EstateInspectionReviewProcessCreate: "estate.inspection.review-process.create",
		EstateInspectionReviewProcessEdit: "estate.inspection.review-process.edit",
		EstateSourcingInspectionView: "estate.sourcing-inspection.view",
		EstateSourcingInspectionCreate: "estate.sourcing-inspection.create",
		EstateSourcingInspectionEdit: "estate.sourcing-inspection.edit",
		EstateSourcingInspectionDelete: "estate.sourcing-inspection.delete",
		EstateSourcingDocumentInspectionView: "estate.sourcing-document-inspection.view",
		EstateSourcingDocumentInspectionCreate: "estate.sourcing-document-inspection.create",
		EstateSourcingDocumentInspectionEdit: "estate.sourcing-document-inspection.edit",
		EstateSourcingDocumentInspectionDelete: "estate.sourcing-document-inspection.delete",
		EstateMarketDetailsView: "estate.market-details.view",
		EstateMarketDetailsEdit: "estate.market-details.edit",
		EstatePredictionsView: "estate.predictions.view",
		EstateSourcingInvestmentCaseView: "estate.sourcing-investmentcase.view",
		EstateSourcingInvestmentCaseCreate: "estate.sourcing-investmentcase.create",
		EstateSourcingInvestmentCaseEdit: "estate.sourcing-investmentcase.edit",
		EstateSourcingInvestmentCaseDelete: "estate.sourcing-investmentcase.delete",
		EstateSourcingCalendarView: "estate.sourcing-calendar.view",
		EstateSourcingCalendarCreate: "estate.sourcing-calendar.create",
		EstateSourcingCalendarEdit: "estate.sourcing-calendar.edit",
		EstateSourcingCalendarDelete: "estate.sourcing-calendar.delete",
		EstateSourcingProcessReset: "estate.sourcing-process.reset",
		EstateSourcingProcessView: "estate.sourcing-process.view",
		EstateSourcingProcessEdit: "estate.sourcing-process.edit",
		EstatePurchasingView: "estate.purchasing.view",
		EstatePurchasingNotesView: "estate.purchasing-notes.view",
		EstatePurchasingNotesEdit: "estate.purchasing-notes.edit",
		EstatePurchasingNotesCreate: "estate.purchasing-notes.create",
		EstatePurchasingNotesDelete: "estate.purchasing-notes.delete",
		EstatePurchasingCalendarView: "estate.purchasing-calendar.view",
		EstatePurchasingCalendarEdit: "estate.purchasing-calendar.edit",
		EstatePurchasingCalendarCreate: "estate.purchasing-calendar.create",
		EstatePurchasingCalendarDelete: "estate.purchasing-calendar.delete",
		EstatePurchasingFinancingInfoView: "estate.purchasing-financing-info.view",
		EstatePurchasingFinancingInfoEdit: "estate.purchasing-financing-info.edit",
		EstatePurchasingHistoryView: "estate.purchasing-history.view",
		EstatePurchasingEventsView: "estate.purchasing-events.view",
		EstatePurchasingProcessView: "estate.purchasing-process.view",
		EstatePurchasingProcessEdit: "estate.purchasing-process.edit",
		EstateRenovationView: "estate.renovation.view",
		EstateRenovationSummaryView: "estate.renovation-summary.view",
		EstateRenovationInspectionView: "estate.renovation-inspection.view",
		EstateRenovationInspectionEdit: "estate.renovation-inspection.edit",
		EstateRenovationInspectionCreate: "estate.renovation-inspection.create",
		EstateRenovationInspectionSend: "estate.renovation-inspection.send",
		EstateRenovationInspectionPdfGenerate: "estate.renovation-inspection.pdf-generate",
		EstateRenovationInspectionDelete: "estate.renovation-inspection.delete",
		EstateRenovationInspectionNotesView: "estate.renovation-inspection-notes.view",
		EstateRenovationInspectionNotesEdit: "estate.renovation-inspection-notes.edit",
		EstateRenovationInspectionNotesCreate: "estate.renovation-inspection-notes.create",
		EstateRenovationInspectionNotesDelete: "estate.renovation-inspection-notes.delete",
		EstateRenovationCraftNotesView: "estate.renovation-craft-notes.view",
		EstateRenovationCraftNotesEdit: "estate.renovation-craft-notes.edit",
		EstateRenovationCraftNotesCreate: "estate.renovation-craft-notes.create",
		EstateRenovationCraftNotesDelete: "estate.renovation-craft-notes.delete",
		EstateRenovationCatalogueView: "estate.renovation-catalogue.view",
		EstateRenovationCatalogueEdit: "estate.renovation-catalogue.edit",
		EstateRenovationCatalogueCreate: "estate.renovation-catalogue.create",
		EstateRenovationCatalogueDelete: "estate.renovation-catalogue.delete",
		EstateRenovationCataloguePricingView: "estate.renovation-catalogue-pricing.view",
		EstateRenovationCataloguePricingCreate: "estate.renovation-catalogue-pricing.create",
		EstateRenovationCataloguePricingEdit: "estate.renovation-catalogue-pricing.edit",
		EstateRenovationCataloguePricingDelete: "estate.renovation-catalogue-pricing.delete",
		EstateRenovationContractorsView: "estate.renovation-contractors.view",
		EstateRenovationMilestonesView: "estate.renovation-milestones.view",
		EstateRenovationMilestonesEdit: "estate.renovation-milestones.edit",
		EstateRenovationCalendarView: "estate.renovation-calendar.view",
		EstateRenovationCalendarEdit: "estate.renovation-calendar.edit",
		EstateRenovationCalendarCreate: "estate.renovation-calendar.create",
		EstateRenovationCalendarDelete: "estate.renovation-calendar.delete",
		EstateRenovationDatesView: "estate.renovation-dates.view",
		EstateRenovationHistoryView: "estate.renovation-history.view",
		EstateRenovationEventsView: "estate.renovation-events.view",
		EstateRenovationElementsView: "estate.renovation-elements.view",
		EstateRenovationElementsEdit: "estate.renovation-elements.edit",
		EstateRenovationElementsCreate: "estate.renovation-elements.create",
		EstateRenovationElementsDelete: "estate.renovation-elements.delete",
		EstateRenovationElementsCreateFromIfc: "estate.renovation-elements.create-from-ifc",
		EstateRenovationElementsCreateFromPred: "estate.renovation-elements.create-from-pred",
		EstateRenovationIfcView: "estate.renovation-ifc.view",
		EstateRenovationConstructionPlanView: "estate.renovation-constructionplan.view",
		EstateRenovationConstructionPlanEdit: "estate.renovation-constructionplan.edit",
		EstateRenovationConstructionPlanCreate: "estate.renovation-constructionplan.create",
		EstateRenovationConstructionPlanEditBudgetOrigin: "estate.renovation-constructionplan.edit-budget-origin",
		EstateRenovationConstructionPlanActionsAll: "estate.renovation-constructionplan.actions-all",
		EstateRenovationConstructionPlanDelete: "estate.renovation-constructionplan.delete",
		EstateRenovationConstructionPlanPdfGenerate: "estate.renovation-constructionplan.pdf-generate",
		EstateRenovationConstructionPlanSend: "estate.renovation-constructionplan.send",
		EstateRenovationConstructionPlanOvershootEdit: "estate.renovation-constructionplan-overshoot.edit",
		EstateConstructionProgressEdit: "estate.construction-progress.edit",
		EstateConstructionProgressCreate: "estate.construction-progress.create",
		EstateConstructionProgressView: "estate.construction-progress.view",
		EstateRenovationDefectsView: "estate.renovation-defects.view",
		EstateRenovationDefectsEdit: "estate.renovation-defects.edit",
		EstateRenovationDefectsCreate: "estate.renovation-defects.create",
		EstateRenovationDefectsDelete: "estate.renovation-defects.delete",
		EstateRenovationDefectHistoryView: "estate.renovation-defect-history.view",
		EstateRenovationProcessView: "estate.renovation-process.view",
		EstateRenovationProcessEdit: "estate.renovation-process.edit",
		EstateRenovationPositionView: "estate.renovation-position.view",
		EstateRenovationPositionEdit: "estate.renovation-position.edit",
		EstateRenovationPositionCreate: "estate.renovation-position.create",
		EstateRenovationPositionDelete: "estate.renovation-position.delete",
		EstateRenovationPositionHistory: "estate.renovation-position.history",
		EstateRentingView: "estate.renting.view",
		EstateRentingDatesView: "estate.renting-dates.view",
		EstateRentingCalendarView: "estate.renting-calendar.view",
		EstateRentingCalendarEdit: "estate.renting-calendar.edit",
		EstateRentingCalendarCreate: "estate.renting-calendar.create",
		EstateRentingCalendarDelete: "estate.renting-calendar.delete",
		EstateRentingHistoryView: "estate.renting-history.view",
		EstateRentingListingView: "estate.renting-listing.view",
		EstateRentingListingCreate: "estate.renting-listing.create",
		EstateRentingListingEdit: "estate.renting-listing.edit",
		EstateRentingListingDelete: "estate.renting-listing.delete",
		EstateRentingListingPrepublish: "estate.renting-listing.prepublish",
		EstateRentingListingPublish: "estate.renting-listing.publish",
		EstateRentingListingUnpublish: "estate.renting-listing.unpublish",
		EstateRentingListingOpenImmoDownload: "estate.renting-listing.open-immo-download",
		EstateRentingLeadView: "estate.renting-lead.view",
		EstateRentingLeadCreate: "estate.renting-lead.create",
		EstateRentingLeadEdit: "estate.renting-lead.edit",
		EstateRentingLeadDelete: "estate.renting-lead.delete",
		EstateRentingEventsView: "estate.renting-events.view",
		EstateRentingProcessView: "estate.renting-process.view",
		EstateRentingProcessEdit: "estate.renting-process.edit",
		EstateRentingContractApprove: "estate.renting-contract.approve",
		LivingsCheckView: "estate.livings-check.view",
		LivingsCheckEdit: "estate.livings-check.edit",
		LivingsCheckCreate: "estate.livings-check.create",
		EstateSellingView: "estate.selling.view",
		EstateSellingEdit: "estate.selling.edit",
		EstateSellingDatesView: "estate.selling-dates.view",
		EstateSellingDocumentsCreate: "estate.selling-documents.create",
		EstateSellingNotesView: "estate.selling-notes.view",
		EstateSellingNotesCreate: "estate.selling-notes.create",
		EstateSellingNotesEdit: "estate.selling-notes.edit",
		EstateSellingNotesDelete: "estate.selling-notes.delete",
		EstateSellingCalendarView: "estate.selling-calendar.view",
		EstateSellingCalendarEdit: "estate.selling-calendar.edit",
		EstateSellingCalendarCreate: "estate.selling-calendar.create",
		EstateSellingCalendarDelete: "estate.selling-calendar.delete",
		EstateSellingHistoryView: "estate.selling-history.view",
		EstateSellingEventsView: "estate.selling-events.view",
		EstateSellingInvestmentCaseView: "estate.selling-investmentcase.view",
		EstateSellingInvestmentCaseCreate: "estate.selling-investmentcase.create",
		EstateSellingInvestmentCaseEdit: "estate.selling-investmentcase.edit",
		EstateSellingInvestmentCaseDelete: "estate.selling-investmentcase.delete",
		EstateInvestmentCaseEdit: "estate.investmentcase.edit",
		EstateICTInvestmentCaseView: "estate.ict-investmentcase.view",
		EstateICTInvestmentCaseCreate: "estate.ict-investmentcase.create",
		EstateICTInvestmentCaseExecute: "estate.ict-investmentcase.execute",
		EstateICTInvestmentCaseEdit: "estate.ict-investmentcase.edit",
		EstateICTInvestmentCaseDelete: "estate.ict-investmentcase.delete",
		EstateSellingProcessView: "estate.selling-process.view",
		EstateSellingProcessEdit: "estate.selling-process.edit",
		EstateSellingProcessPaid: "estate.selling-process.paid",
		EstatePropertyManagementView: "estate.property-management.view",
		EstatePropertyManagementEdit: "estate.property-management.edit",
		EstatePropertyManagementDelete: "estate.property-management.delete",
		EstatePropertyManagementRentView: "estate.property-management-rent.view",
		EstatePropertyManagementRentEdit: "estate.property-management-rent.edit",
		EstatePropertyManagementActivePastRentEdit: "estate.propertymanagement-active-past-rent.edit",
		EstatePropertyManagementRentCreate: "estate.property-management-rent.create",
		EstatePropertyManagementRentDelete: "estate.property-management-rent.delete",
		EstatePropertyManagementTenancyView: "estate.propertymanagement-tenancy.view",
		EstatePropertyManagementTenancyEdit: "estate.propertymanagement-tenancy.edit",
		EstatePropertyManagementActivePastTenancyEdit: "estate.propertymanagement-active-past-tenancy.edit",
		EstatePropertyManagementTenancyCreate: "estate.propertymanagement-tenancy.create",
		EstatePropertyManagementTenancyDelete: "estate.propertymanagement-tenancy.delete",
		EstatePropertyManagementOwnerView: "estate.propertymanagement-owner.view",
		EstatePropertyManagementOwnerCreate: "estate.propertymanagement-owner.create",
		EstatePropertyManagementOwnerEdit: "estate.propertymanagement-owner.edit",
		EstatePropertyManagementOwnerAnnualStatementView: "estate.propertymanagement-owner-annual-statement.view",
		EstatePropertyManagementOwnerAnnualStatementCreate: "estate.propertymanagement-owner-annual-statement.create",
		EstatePropertyManagementOwnerAnnualStatementEdit: "estate.propertymanagement-owner-annual-statement.edit",
		EstatePropertyManagementOwnerAnnualStatementDelete: "estate.propertymanagement-owner-annual-statement.delete",
		EstatePropertyManagementAnnualServiceChargesView: "estate.propertymanagement-annual-service-charges.view",
		EstatePropertyManagementAnnualServiceChargesCreate: "estate.propertymanagement-annual-service-charges.create",
		EstatePropertyManagementAnnualServiceChargesEdit: "estate.propertymanagement-annual-service-charges.edit",
		EstatePropertyManagementAnnualServiceChargesDelete: "estate.propertymanagement-annual-service-charges.delete",
		EstatePropertyManagementNotesView: "estate.property-management-notes.view",
		EstatePropertyManagementNotesEdit: "estate.property-management-notes.edit",
		EstatePropertyManagementNotesCreate: "estate.property-management-notes.create",
		EstatePropertyManagementNotesDelete: "estate.property-management-notes.delete",
		EstatePropertyManagementMetersView: "estate.propertymanagement-meters.view",
		EstatePropertyManagementMetersCreate: "estate.propertymanagement-meters.create",
		EstatePropertyManagementMetersEdit: "estate.propertymanagement-meters.edit",
		EstatePropertyManagementMetersDelete: "estate.propertymanagement-meters.delete",
		EstatePropertyManagementCalendarView: "estate.propertymanagement-calendar.view",
		EstatePropertyManagementCalendarCreate: "estate.propertymanagement-calendar.create",
		EstatePropertyManagementCalendarEdit: "estate.propertymanagement-calendar.edit",
		EstatePropertyManagementCalendarDelete: "estate.propertymanagement-calendar.delete",
		EstatePropertyManagementHoaFeeView: "estate.propertymanagement-hoa-fee.view",
		EstatePropertyManagementHoaFeeCreate: "estate.propertymanagement-hoa-fee.create",
		EstatePropertyManagementHoaFeeEdit: "estate.propertymanagement-hoa-fee.edit",
		EstatePropertyManagementHoaFeeDelete: "estate.propertymanagement-hoa-fee.delete",
		EstatePropertyManagementProcessView: "estate.propertymanagement-process.view",
		EstatePropertyManagementProcessEdit: "estate.propertymanagement-process.edit",
		EstatePropertyManagementMeterReadingCreate: "estate.propertymanagement-meter-reading.create",
		EstatePropertyManagementMeterReadingDelete: "estate.propertymanagement-meter-reading.delete",
		EstatePropertyManagementTasksView: "estate.propertymanagement-tasks.view",
		EstatePropertyManagementTasksEdit: "estate.propertymanagement-tasks.edit",
		EstatePropertyManagementEventsView: "estate.property-management-events.view",
		EstatePropertyManagementProcessFutureHouseGeld: "estate.property-management-process.future-house-geld",
		EstateTenantManagementProcessCreate: "estate.tenant-management-process.create",
		EstateTenantManagementProcessView: "estate.tenant-management-process.view",
		EstateTenantManagementProcessEdit: "estate.tenant-management-process.edit",
		EstateTenantManagementProcessDelete: "estate.tenant-management-process.delete",
		EstateTenantManagementProcessEventsView: "estate.tenant-management-process-events.view",
		EstateTenantManagementInvestorInfoSpecialDealEdit: "estate.tenant-management-investor-info-special-deal.edit",
		EstateTenantManagementMonthlyInvestorInfoEdit: "estate.tenant-management-monthly-investor-info.edit",
		EstateOwnerManagementProcessCreate: "estate.owner-management-process.create",
		EstateOwnerManagementProcessView: "estate.owner-management-process.view",
		EstateOwnerManagementProcessEdit: "estate.owner-management-process.edit",
		EstateOwnerManagementProcessDelete: "estate.owner-management-process.delete",
		EstateOwnerManagementProcessEventsView: "estate.owner-management-process-events.view",
		EstateManagementProcessCreate: "estate.estate-management-process.create",
		EstateManagementProcessView: "estate.estate-management-process.view",
		EstateManagementProcessEdit: "estate.estate-management-process.edit",
		EstateManagementProcessDelete: "estate.estate-management-process.delete",
		EstateManagementProcessEventsView: "estate.estate-management-process-events.view",
		EstatePaymentNoticeSummaryCreate: "estate.payment-notice-summary.create",
		EstatePaymentNoticeSummaryEdit: "estate.payment-notice-summary.edit",
		EstatePaymentNoticeSummaryView: "estate.payment-notice-summary.view",
		FinanceGeneralLedgerEntriesView: "finance.general-ledger-entries.view",
		FinanceGeneralLedgerEntriesEdit: "finance.general-ledger-entries.edit",
		FinanceGeneralLedgerEntriesCreate: "finance.general-ledger-entries.create",
		FinanceGeneralLedgerEntriesDelete: "finance.general-ledger-entries.delete",
		FinanceGeneralLedgerEntriesRecover: "finance.general-ledger-entries.recover",
		FinanceGeneralLedgerStatementsView: "finance.general-ledger-statements.view",
		FinanceGeneralLedgerStatementsCreate: "finance.general-ledger-statements.create",
		FinanceSepaMandateView: "finance.sepa-mandate.view",
		FinanceSepaMandateEdit: "finance.sepa-mandate.edit",
		FinanceSepaMandateCreate: "finance.sepa-mandate.create",
		FinanceSepaMandateDelete: "finance.sepa-mandate.delete",
		FinancePaymentOrderExport: "finance.payment-order.export",
		FinancePaymentOrderView: "finance.payment-order.view",
		FinancePaymentOrderUpdate: "finance.payment-order.update",
		FinancePaymentOrderCreate: "finance.payment-order.create",
		FinanceEligibleEstatesList: "finance.eligible-estates.list",
		FinancePortfolioList: "finance.portfolio.list",
		FinancePortfolioView: "finance.portfolio.view",
		FinancePortfolioCreate: "finance.portfolio.create",
		FinancePortfolioEdit: "finance.portfolio.edit",
		FinancePortfolioDelete: "finance.portfolio.delete",
		FinancePortfolioSummaryView: "finance.portfolio-summary.view",
		FinancePortfolioActionsPrepared: "finance.portfolio.prepared",
		FinancePortfolioActionsRevert: "finance.portfolio.revert",
		FinancePortfolioActionsOfferAccepted: "finance.portfolio.offer-accepted",
		FinancePortfolioActionsLoanCreated: "finance.portfolio.loan-created",
		FinancePortfolioActionsAll: "finance.portfolio.actions-all",
		FinancePortfolioDocumentCreate: "finance.portfolio-document.create",
		FinancePortfolioDocumentsView: "finance.portfolio-documents.view",
		FinancePortfolioDocumentFolderGenerate: "finance.portfolio-document-folder.generate",
		FinancePortfolioFinancingBanksList: "finance.portfolio-financing-banks.list",
		FinancePortfolioEligibleEstatesList: "finance.portfolio-eligible-estates.list",
		FinancePortfolioLoanOfferView: "finance.portfolio-loan-offer.view",
		FinancePortfolioLoanOfferCreate: "finance.portfolio-loan-offer.create",
		FinancePortfolioLoanOfferEdit: "finance.portfolio-loan-offer.edit",
		FinancePortfolioLoanOfferDelete: "finance.portfolio-loan-offer.delete",
		FinancePortfolioLoanOfferAccept: "finance.portfolio-loan-offer.accept",
		FinancePortfolioNotesView: "finance.portfolio-notes.view",
		FinancePortfolioNotesCreate: "finance.portfolio-notes.create",
		FinancePortfolioNotesDelete: "finance.portfolio-notes.delete",
		FinanceLoanApplicationCreate: "finance.loan-application.create",
		FinanceLoanAccountBalanceRecalculate: "finance.loan-account-balance.recalculate",
		FinanceTenderingProcessView: "finance.tendering.view",
		FinanceTenderingProcessEdit: "finance.tendering.edit",
		FinanceTenderingProcessDelete: "finance.tendering.delete",
		FinancePortfolioHistoryView: "finance.portfolio-history.view",
		FinanceInvoiceHistoryView: "finance.invoice-history.view",
		FinanceInvoiceExport: "finance.invoice.export",
		FinanceInvoiceList: "finance.invoice.list",
		FinanceInvoiceView: "finance.invoice.view",
		FinanceInvoiceViewRecurrentPayments: "finance.invoice.view.recurrent-payments",
		FinanceInvoiceViewAll: "finance.invoice.view-all",
		FinanceInvoiceViewLivings: "finance.invoice.view-livings",
		FinanceInvoiceCreate: "finance.invoice.create",
		FinanceInvoiceReminderCreate: "finance.invoice-reminder.create",
		FinanceInvoiceEdit: "finance.invoice.edit",
		FinanceInvoiceDelete: "finance.invoice.delete",
		FinanceInvoiceAssign: "finance.invoice.assign",
		FinanceInvoiceApprove: "finance.invoice.approve",
		FinanceInvoiceAuthorize: "finance.invoice.authorize",
		FinanceInvoiceReject: "finance.invoice.reject",
		FinanceInvoiceActionsAll: "finance.invoice.actions-all",
		FinanceInvoiceReset: "finance.invoice.reset",
		FinanceInvoiceForceReject: "finance.invoice.force-reject",
		FinanceInvoiceNotesView: "finance.invoice-notes.view",
		FinanceInvoiceNotesCreate: "finance.invoice-notes.create",
		FinanceInvoiceNotesEdit: "finance.invoice-notes.edit",
		FinanceInvoiceNotesDelete: "finance.invoice-notes.delete",
		FinanceInvoiceOverwrite: "finance.invoice.overwrite",
		FinanceInvoiceReviewProcessView: "finance.invoice.review-process.view",
		FinanceInvoiceReviewProcessCreate: "finance.invoice.review-process.create",
		FinanceInvoiceReviewProcessEdit: "finance.invoice.review-process.edit",
		FinanceInvoiceSubscriptionList: "finance.invoice-subscription.list",
		FinanceInvoiceSubscriptionView: "finance.invoice-subscription.view",
		FinanceInvoiceSubscriptionCreate: "finance.invoice-subscription.create",
		FinanceInvoiceSubscriptionEdit: "finance.invoice-subscription.edit",
		FinanceInvoiceSubscriptionDelete: "finance.invoice-subscription.delete",
		FinanceInvoiceSubscriptionDocumentCreate: "finance.invoice-subscription-document.create",
		FinanceInvoiceSubscriptionInvoicesGenerate: "finance.invoice-subscription-invoices.generate",
		FinanceBankTransactionList: "finance.bank-transaction.list",
		FinanceBankTransactionView: "finance.bank-transaction.view",
		FinanceBankTransactionEdit: "finance.bank-transaction.edit",
		FinanceBankTransactionDelete: "finance.bank-transaction.delete",
		FinanceBankTransactionBook: "finance.bank-transaction.book",
		FinanceCreditLinePortfolioCreate: "finance.credit-line-portfolio.create",
		FinanceCreditLinePortfolioView: "finance.credit-line-portfolio.view",
		FinanceCreditLinePortfolioEdit: "finance.credit-line-portfolio.edit",
		FinanceCreditLinePortfolioDelete: "finance.credit-line-portfolio.delete",
		FinanceCashflowPredictionsCreate: "finance.cash-flow-predictions.create",
		FinanceInvestorCashflowView: "finance.investor-cashflow.view",
		FinanceInvestorCashflowCreate: "finance.investor-cashflow.create",
		FinanceInvestorCashflowEdit: "finance.investor-cashflow.edit",
		FinanceSalesPackageCreate: "finance.sales-package.create",
		FinanceSalesPackageView: "finance.sales-package.view",
		FinanceSalesPackageEdit: "finance.sales-package.edit",
		FinanceSalesPackageEstateAdd: "finance.sales-package-estate.add",
		FinanceSalesPackageEstateDelete: "finance.sales-package-estate.delete",
		FinanceSalesPackageReviewProcessCreate: "finance.sales-package-review-process.create",
		FinanceSalesPackageReviewProcessView: "finance.sales-package-review-process.view",
		FinanceSalesPackageNotesCreate: "finance.sales-package-notes.create",
		FinanceSalesPackageNotesDelete: "finance.sales-package-notes.delete",
		FinanceSalesPackageNotesView: "finance.sales-package-notes.view",
		FinanceSalesPackageHistoryView: "finance.sales-package-history.view",
		FinancePaymentNoticeSummaryApprove: "finance.payment-notice-summary.approve",
		FinancePaymentNoticeSummarySetAsReadyForReview: "finance.payment-notice-summary.set-as-ready-for-review",
		FinanceSpecialDealView: "finance.special-deal.view",
		FinanceSpecialDealCreate: "finance.special-deal.create",
		FinanceSpecialDealEdit: "finance.special-deal.edit",
		FinanceEstateEditSpecialDealLock: "finance.estate.edit.is-special-deal-locked",
		CoreDocumentView: "core.document.view",
		CoreAccountingView: "core.accounting.view",
		CoreContactView: "core.contact.view",
		CoreContactList: "core.contact.list",
		CoreContactCreate: "core.contact.create",
		CoreContactEdit: "core.contact.edit",
		CoreContactDelete: "core.contact.delete",
		CoreContactMerge: "core.contact.merge",
		CoreContactEstatesView: "core.contact-estates.view",
		CoreContactDocumentsView: "core.contact-documents.view",
		CoreContactDocumentUpload: "core.contact-document.upload",
		CoreContactDocumentEdit: "core.contact-documents.edit",
		CoreContactDocumentDelete: "core.contact-document.delete",
		CoreContactInvoicesView: "core.contact-invoices.view",
		CoreContactNotesCreate: "core.contact-notes.create",
		CoreContactNotesView: "core.contact-notes.view",
		CoreContactNotesDelete: "core.contact-notes.delete",
		CoreContactBankAccountsView: "core.contact-bank-accounts.view",
		CoreContactBankAccountCreate: "core.contact-bank-account.create",
		CoreContactAccountingEdit: "core.contact-accounting.edit",
		CoreCompanyView: "core.company.view",
		CoreCompanyList: "core.company.list",
		CoreCompanyPurchasingEntityList: "core.company-purchasing-entity.list",
		CoreCompanyDistributionPartnerList: "core.company-distribution-partner.list",
		CoreCompanyBankList: "core.company-bank.list",
		CoreCompanyCreate: "core.company.create",
		CoreCompanyEdit: "core.company.edit",
		CoreCompanyDelete: "core.company.delete",
		CoreCompanyEstatesView: "core.company-estates.view",
		CoreCompanyContactsView: "core.company-contacts.view",
		CoreCompanyContactsCreate: "core.company-contacts.create",
		CoreCompanyContactsEdit: "core.company-contacts.edit",
		CoreCompanyContactsDelete: "core.company-contacts.delete",
		CoreCompanyContractorCapacityView: "core.company-contractor-capacity.view",
		CoreCompanyContractorCapacityEdit: "core.company-contractor-capacity.edit",
		CoreCompanyContractorAgreedCapacityEdit: "core.company-contractor-agreed-capacity.edit",
		CoreCompanyDocumentsView: "core.company-documents.view",
		CoreCompanyDocumentUpload: "core.company-document.upload",
		CoreCompanyDocumentEdit: "core.company-document.edit",
		CoreCompanyDocumentDelete: "core.company-document.delete",
		CoreCompanyInvoicesView: "core.company-invoices.view",
		CoreCompanyNotesView: "core.company-notes.view",
		CoreCompanyNotesCreate: "core.company-notes.create",
		CoreCompanyNotesDelete: "core.company-notes.delete",
		CoreCompanyBankAccountsView: "core.company-bank-accounts.view",
		CoreCompanyBankAccountCreate: "core.company-bank-account.create",
		CoreCompanyAccountingEdit: "core.company-accounting.edit",
		CoreProcessView: "core.process.view",
		CoreProcessList: "core.process.list",
		CoreProcessEdit: "core.process.edit",
		CoreProcessCreate: "core.process.create",
		CoreCompanyEmploymentCreate: "core.company-employment.create",
		CoreCompanyEmploymentDelete: "core.company-employment.delete",
		CoreTaskList: "core.task.list",
		CoreTaskEdit: "core.task.edit",
		CoreTaskCreate: "core.task.create",
		CoreTaskDelete: "core.task.delete",
		CoreTaskTemplateList: "core.task-template.list",
		CoreTaskTemplateEdit: "core.task-template.edit",
		CoreTaskTemplateCreate: "core.task-template.create",
		CoreTaskTemplateDelete: "core.task-template.delete",
		CoreFileGet: "core.file.get",
		CoreCalendarView: "core.calendar.view",
		CoreCalendarSubscribeAll: "core.calendar.subscribe-all",
		CoreCalendarSubscribeSourcing: "core.calendar.subscribe-sourcing",
		CoreCalendarSubscribePurchasing: "core.calendar.subscribe-purchasing",
		CoreCalendarSubscribeRenovation: "core.calendar.subscribe-renovation",
		CoreCalendarSubscribeRenting: "core.calendar.subscribe-renting",
		CoreCalendarSubscribeSelling: "core.calendar.subscribe-selling",
		CoreCalendarSubscribePropertyManagement: "core.calendar.subscribe-propertymanagement",
		CoreBasecampMaintenanceRun: "core.basecamp-maintenance.run",
		CoreBasecampEstateExport: "core.basecamp-maintenance.estate-export",
		CoreReviewProcessCreate: "core.review-process.create",
		CoreReviewProcessView: "core.review-process.view",
		CoreReviewProcessEdit: "core.review-process.edit",
		CoreReviewProcessDelete: "core.review-process.delete",
		CoreReviewProcessProcess: "core.review-process.process",
		PortfolioReviewProcessCreate: "portfolio.review-process.create",
		PortfolioReviewProcessView: "portfolio.review-process.view",
		PortfolioReviewProcessEdit: "portfolio.review-process.edit",
		PortfolioReviewProcessDelete: "portfolio.review-process.delete",
		PortfolioReviewProcessProcess: "portfolio.review-process.process",
		InvestmentCaseReviewProcessCreate: "investment-case.review-process.create",
		InvestmentCaseReviewProcessView: "investment-case.review-process.view",
		InvestmentCaseReviewProcessEdit: "investment-case.review-process.edit",
		InvestmentCaseReviewProcessDelete: "investment-case.review-process.delete",
		InvestmentCaseReviewProcessProcess: "investment-case.review-process.process",
		ConstructionPlanReviewProcessCreate: "construction-plan.review-process.create",
		ConstructionPlanReviewProcessView: "construction-plan.review-process.view",
		ConstructionPlanReviewProcessEdit: "construction-plan.review-process.edit",
		ConstructionPlanReviewProcessDelete: "construction-plan.review-process.delete",
		ConstructionPlanReviewProcessProcess: "construction-plan.review-process.process",
		AuthzPermissionView: "authz.permission.view",
		AuthzRoleBindingView: "authz.role-binding.view",
		AuthzRoleBindingEdit: "authz.role-binding.edit",
		AuthzRoleBindingCreate: "authz.role-binding.create",
		AuthzRoleBindingDelete: "authz.role-binding.delete",
		AuthzRoleBindingImpersonate: "authz.role-binding.impersonate",
		AuthzRoleEdit: "authz.role.edit",
		AuthzRoleCreate: "authz.role.create",
		AuthzRoleDelete: "authz.role.delete",
		AuthzUserView: "authz.user.view",
		AuthzUserEdit: "authz.user.edit",
		AuthzUserCreate: "authz.user.create",
		AuthzUserDelete: "authz.user.delete",
		ExternalDashboardView: "external.dashboard.view",
		AdministrationInternalUserCreate: "administration.internal-user.create",
		AdministrationExternalUserCreate: "administration.external-user.create",
		AdministrationRulesView: "administration.rules.view",
		AdministrationRulesEdit: "administration.rules.edit",
		AdministrationRulesDelete: "administration.rules.delete",
		AdministrationRulesCreate: "administration.rules.create",
		AdministrationUserCompanyFunctionsView: "administration.user-company-functions.view",
		AdministrationUserCompanyFunctionsEdit: "administration.user-company-functions.edit",
		AdministrationUserCompanyFunctionsDelete: "administration.user-company-functions.delete",
		AdministrationLocationView: "administration.location.view",
		AdministrationLocationEdit: "administration.location.edit",
		AdministrationLocationCreate: "administration.location.create",
		AdministrationLocationProfileEdit: "administration.location-profile.edit",
		AdministrationLocationProfileDelete: "administration.location-profile.delete",
		AdministrationLedgerView: "administration.ledger.view",
		AdministrationLedgerEntryCreate: "administration.ledger-entry.create",
		AdministrationLedgerRecover: "administration.ledger.recover",
		AdministrationRenovationInspectionQuestionsCreate: "administration.renovation-inspection-questions.create",
		AdministrationRenovationInspectionQuestionsEdit: "administration.renovation-inspection-questions.edit",
		AdministrationRenovationInspectionQuestionsDelete: "administration.renovation-inspection-questions.delete",
		AdministrationLoanAccountEdit: "administration.loan-account.edit",
		AdministrationLoanAccountDelete: "administration.loan-account.delete",
		AdministrationLoanAccountView: "administration.loan-account.view",
		AdministrationLoanAccountCreate: "administration.loan-account.create",
		AdministrationBankAccountEdit: "administration.bank-account.edit",
		AdministrationBankAccountDelete: "administration.bank-account.delete",
		AdministrationBankAccountView: "administration.bank-account.view",
		AdministrationBankAccountCreate: "administration.bank-account.create",
		AdministrationBankAccountTransactionCreate: "administration.bank-account-transaction.create",
		AdministrationBankAccountTransactionDelete: "administration.bank-account-transaction.delete",
		AdministrationLoanAccountDrawdownCreate: "administration.loan-account-drawdown.create",
		AdministrationLoanAccountDrawdownDelete: "administration.loan-account-drawdown.delete",
		AdministrationLoanAccountDrawdownReceive: "administration.loan-account-drawdown.receive",
		AdministrationInvestorStatementCreate: "administration.investor-statement.create"
	};
}));
//#endregion
//#region src/domains/cross-cutting/authz/permissions.helpers.ts
var checkPermissions;
var init_permissions_helpers = __esmMin((() => {
	checkPermissions = (presentedPermissions, requiredPermissions) => {
		if (requiredPermissions.length === 0) return true;
		return intersection(presentedPermissions, requiredPermissions).length === requiredPermissions.length;
	};
}));
//#endregion
//#region src/domains/cross-cutting/authz/index.ts
var init_authz = __esmMin((() => {
	init_authz_model();
	init_permissions();
	init_permissions_helpers();
}));
//#endregion
//#region src/domains/cross-cutting/calendar-event.opts.ts
var init_calendar_event_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/config.opts.ts
var init_config_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/dictionaries.model.ts
var init_dictionaries_model = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh.model.ts
function isManualMfhChannel(channelName) {
	return MFH_MANUAL_CHANNEL_NAMES.includes(channelName);
}
function isProviderMfhChannel(channelName) {
	return MFH_PROVIDER_CHANNEL_NAMES.includes(channelName);
}
function formatMfhChannelName(channelName, abbreviated = false) {
	if (!channelName) return "-";
	return (abbreviated ? MfhChannelNameAbbreviations : MfhChannelNameLabels)[channelName] ?? String(channelName);
}
/**
* Map upstream EstateChannelName (discoverer / providers) onto MFH channel for persistence.
* Legacy GPT / TRANSACTION_TEAM collapse to OTHER; unknown values also become OTHER.
*/
function mapEstateChannelToMfhChannel(estateChannel) {
	switch (estateChannel) {
		case "IMMO24":
		case "IMMO24": return "IMMO24";
		case "GEOMAP":
		case "GEOMAP": return "GEOMAP";
		case "PRICEHUBBLE":
		case "PRICEHUBBLE": return "PRICEHUBBLE";
		default: return "OTHER";
	}
}
var mfhPriceComputedProps, MfhFieldSource, MfhChannelName, MFH_MANUAL_CHANNEL_NAMES, MFH_PROVIDER_CHANNEL_NAMES, MfhChannelNameLabels, MfhChannelNameAbbreviations, MFH_MANUAL_CHANNEL_OPTIONS, ExternalIdType, mfhComputedProps, MfhTags;
var init_mfh_model = __esmMin((() => {
	mfhPriceComputedProps = ["pricePerSQM"];
	MfhFieldSource = /* @__PURE__ */ function(MfhFieldSource) {
		MfhFieldSource["GEOMAP"] = "geomap";
		MfhFieldSource["IS24"] = "is24";
		MfhFieldSource["GPT"] = "gpt";
		MfhFieldSource["MANUAL"] = "manual";
		MfhFieldSource["INFAS"] = "infas";
		MfhFieldSource["COMPUTED"] = "computed";
		MfhFieldSource["SYTE"] = "syte";
		return MfhFieldSource;
	}({});
	MfhChannelName = /* @__PURE__ */ function(MfhChannelName) {
		MfhChannelName["OTHER_ONLINE_PORTAL"] = "OTHER_ONLINE_PORTAL";
		MfhChannelName["BROKER_OPEN_MANDATE"] = "BROKER_OPEN_MANDATE";
		MfhChannelName["BROKER_EXCLUSIVE_ACCESS"] = "BROKER_EXCLUSIVE_ACCESS";
		MfhChannelName["DIRECT_OWNER_APPROACH"] = "DIRECT_OWNER_APPROACH";
		MfhChannelName["NETWORK_REFERRAL"] = "NETWORK_REFERRAL";
		MfhChannelName["M_AND_A_PROCESS"] = "M_AND_A_PROCESS";
		MfhChannelName["INSOLVENCY_PROCESS"] = "INSOLVENCY_PROCESS";
		MfhChannelName["OTHER"] = "OTHER";
		MfhChannelName["IMMO24"] = "IMMO24";
		MfhChannelName["GEOMAP"] = "GEOMAP";
		MfhChannelName["PRICEHUBBLE"] = "PRICEHUBBLE";
		return MfhChannelName;
	}({});
	MFH_MANUAL_CHANNEL_NAMES = [
		"OTHER_ONLINE_PORTAL",
		"BROKER_OPEN_MANDATE",
		"BROKER_EXCLUSIVE_ACCESS",
		"DIRECT_OWNER_APPROACH",
		"NETWORK_REFERRAL",
		"M_AND_A_PROCESS",
		"INSOLVENCY_PROCESS",
		"OTHER"
	];
	MFH_PROVIDER_CHANNEL_NAMES = [
		"IMMO24",
		"GEOMAP",
		"PRICEHUBBLE"
	];
	MfhChannelNameLabels = {
		["OTHER_ONLINE_PORTAL"]: "Other Online Portal",
		["BROKER_OPEN_MANDATE"]: "Broker Open Mandate",
		["BROKER_EXCLUSIVE_ACCESS"]: "Broker Exclusive Access",
		["DIRECT_OWNER_APPROACH"]: "Direct Owner Approach",
		["NETWORK_REFERRAL"]: "Network Referral",
		["M_AND_A_PROCESS"]: "M&A Process",
		["INSOLVENCY_PROCESS"]: "Insolvency Process",
		["OTHER"]: "Other",
		["IMMO24"]: "IMMO24",
		["GEOMAP"]: "GEOMAP",
		["PRICEHUBBLE"]: "PRICEHUBBLE"
	};
	MfhChannelNameAbbreviations = {
		["OTHER_ONLINE_PORTAL"]: "Other Online Portal",
		["BROKER_OPEN_MANDATE"]: "Broker Open Mandate",
		["BROKER_EXCLUSIVE_ACCESS"]: "Broker Exclusive Access",
		["DIRECT_OWNER_APPROACH"]: "Direct Owner Approach",
		["NETWORK_REFERRAL"]: "Network Referral",
		["M_AND_A_PROCESS"]: "M&A Process",
		["INSOLVENCY_PROCESS"]: "Insolvency Process",
		["OTHER"]: "Other",
		["IMMO24"]: "IS24",
		["GEOMAP"]: "GMP",
		["PRICEHUBBLE"]: "PRCH"
	};
	MFH_MANUAL_CHANNEL_OPTIONS = MFH_MANUAL_CHANNEL_NAMES.map((value) => ({
		value,
		label: MfhChannelNameLabels[value]
	}));
	ExternalIdType = /* @__PURE__ */ function(ExternalIdType) {
		ExternalIdType["ESTARCORE"] = "ESTARCORE";
		return ExternalIdType;
	}({});
	mfhComputedProps = [
		"config",
		"candidateLocation",
		"estates",
		"locations",
		"lastActiveDDPhase",
		"agency",
		"expose",
		"candidateInvestmentCases"
	];
	MfhTags = /* @__PURE__ */ function(MfhTags) {
		MfhTags["GENERATED_AUTOMATICALLY"] = "automatic";
		return MfhTags;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh.base.ts
var MFHDocumentTypes, BalconyState;
var init_mfh_base = __esmMin((() => {
	init_document_model();
	MFHDocumentTypes = [
		"CurrentLandRegisterExtract",
		"EncumbranceBasisInDeptII",
		"CurrentParcelMap",
		"CurrentPlanningRights",
		"InformationUrbanRenewalArea",
		"InformationUrbanConservationArea",
		"InformationMonumentProtection",
		"SocialPreservationOrdinance",
		"InformationBuildingChargeRegister",
		"ExtractContaminatedSitesRegister",
		"ExtractDevelopmentAndExpansionContributions",
		"UrbanDevelopmentContracts",
		"SoilReportOrContaminatedSites",
		"GroundLease",
		"VerificationOfExplosiveOrdnance",
		"OngoingLegalDisputesRegardingProperty",
		"BuildingEnergyCertificate",
		"SectionDrawingsBuildingElevations",
		"FloorPlansIncludingAreaCalculation",
		"BuildingApplicationOrBuildingPermit",
		"WarrantyGuarantees",
		"OverviewOfPastOngoingAndPlannedModernization",
		"InsuranceClaimsLast5Years",
		"ModernizationsOfIndividualApartments",
		"DeclarationOfDivisionIfDivided",
		"OngoingLegalDisputesRegardingObject",
		"TenantList",
		"RentIncreaseLetters",
		"RentalAgreements",
		"ListOfExistingRentalDeposits",
		"OperatingCostStatement",
		"TenantHandoverProtocols",
		"ListOfCurrentDefectComplaintsReductionsArrears",
		"OngoingLegalDisputesWithTenants",
		"ManagementContracts",
		"MaintenanceProtocols",
		"ListOfAgeOfInstallations",
		"InsurancesMainlyCurrentBuildingInsurance",
		"PropertyTaxAssessmentAndUnitValueNotice",
		"ListOfCraftsmen",
		"PurchaseContractDraft",
		"AttachmentsToPurchaseContract",
		"PowersOfAttorney",
		"MfhExpose",
		"TechnicalDD",
		"LegalDD",
		"CommercialDD",
		"EnergyConsultation",
		"Vicinity",
		"ZoningPlan",
		"DevelopmentPlanOrdinance",
		"OtherPlanningLaw",
		"ExtractLandChargeRegister",
		"ExtractTreeInventoryRegister",
		"FloodRiskMap",
		"GroundwaterPlans",
		"ProtectedAreaMap",
		"LiabilityInsuranceForBuildingAndProperty",
		"LiabilityInsuranceForWaterPollutionDamage",
		"MaintenanceContracts",
		"PreliminaryBuildingPermit",
		"SoilPollutantReportsAndSoilDecontaminationReceipts",
		"ConstructionAcceptanceCertificate",
		"ReportTechnicalDueDiligence",
		"PurchasingOffer",
		"CourtageAgreement",
		"ExclusivityAgreement",
		"BillingOrInvoices",
		"InvestmentProposal",
		"KYCDraft",
		"IDSeller",
		"BuildingInformationModel"
	];
	BalconyState = /* @__PURE__ */ function(BalconyState) {
		BalconyState["Renovated"] = "Renovated";
		BalconyState["NotRenovated"] = "NotRenovated";
		BalconyState["NoBalconies"] = "NoBalconies";
		return BalconyState;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh.opts.ts
var init_mfh_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh-process.model.ts
var MfhManualProcessRejectionReason;
var init_mfh_process_model = __esmMin((() => {
	MfhManualProcessRejectionReason = /* @__PURE__ */ function(MfhManualProcessRejectionReason) {
		MfhManualProcessRejectionReason["AlreadySold"] = "AlreadySold";
		MfhManualProcessRejectionReason["OfferInactive"] = "OfferInactive";
		MfhManualProcessRejectionReason["Location"] = "Location";
		MfhManualProcessRejectionReason["EPCRating"] = "EPCRating";
		MfhManualProcessRejectionReason["CommercialShare"] = "CommercialShare";
		MfhManualProcessRejectionReason["AssetSize"] = "AssetSize";
		MfhManualProcessRejectionReason["AverageUnitSize"] = "AverageUnitSize";
		MfhManualProcessRejectionReason["Leasehold"] = "Leasehold";
		MfhManualProcessRejectionReason["RedevelopmentArea"] = "RedevelopmentArea";
		MfhManualProcessRejectionReason["Building"] = "Building";
		MfhManualProcessRejectionReason["ACQPriceTooHigh"] = "ACQPriceTooHigh";
		MfhManualProcessRejectionReason["CapExTooHigh"] = "CapExTooHigh";
		MfhManualProcessRejectionReason["Other"] = "Other";
		MfhManualProcessRejectionReason["PreservationAreaUrbanCharacter"] = "PreservationAreaUrbanCharacter";
		MfhManualProcessRejectionReason["PreservationAreaCompositionResidentialPopulation"] = "PreservationAreaCompositionResidentialPopulation";
		MfhManualProcessRejectionReason["LimitedRentalUpside"] = "LimitedRentalUpside";
		MfhManualProcessRejectionReason["MonumentProtection"] = "MonumentProtection";
		MfhManualProcessRejectionReason["RentControlOrRentSubsidy"] = "RentControlOrRentSubsidy";
		return MfhManualProcessRejectionReason;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh-process.opts.ts
var MfhManualProcessRejectionReasonTranslation;
var init_mfh_process_opts = __esmMin((() => {
	MfhManualProcessRejectionReasonTranslation = {
		AlreadySold: "Bereits verkauft",
		OfferInactive: "Vermarktung eingestellt",
		Location: "Lage",
		EPCRating: "Energieeffizienz",
		CommercialShare: "Gewerbeanteil",
		AssetSize: "Objektgröße",
		AverageUnitSize: "Durchschnittliche Wohnungsgröße",
		Leasehold: "Erbpacht",
		RedevelopmentArea: "Sanierungsgebiet",
		Building: "Gebäude",
		ACQPriceTooHigh: "Kaufpreis zu hoch",
		CapExTooHigh: "CapEx zu hoch",
		Other: "Andere",
		PreservationAreaUrbanCharacter: "Erhaltungsgebiet - Städtebaulichen Eigenart",
		PreservationAreaCompositionResidentialPopulation: "Erhaltungsgebiet - Zusammensetzung der Wohnbevölkerung",
		LimitedRentalUpside: "Limitiertes Mietsteigerungspotential",
		MonumentProtection: "Denkmalschutz",
		RentControlOrRentSubsidy: "Mietpreisbindung / Mietförderung"
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh-calendar-event.model.ts
var MFHCalendarType;
var init_mfh_calendar_event_model = __esmMin((() => {
	MFHCalendarType = /* @__PURE__ */ function(MFHCalendarType) {
		MFHCalendarType["Sourcing"] = "Sourcing";
		MFHCalendarType["Renovation"] = "Renovation";
		MFHCalendarType["SubsidyFinancing"] = "SubsidyFinancing";
		MFHCalendarType["EstateManagement"] = "EstateManagement";
		MFHCalendarType["General"] = "General";
		return MFHCalendarType;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/mfh/infas/infas-attributes.ts
var InfasVariableMapping;
var init_infas_attributes = __esmMin((() => {
	InfasVariableMapping = {};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/infas/infas-attribute-map.ts
var infasAttributeMap, infasResponseToSheetKey;
var init_infas_attribute_map = __esmMin((() => {
	infasAttributeMap = {
		ID: {
			description: "numerical ID",
			attributeValueMap: {}
		},
		AGS2: {
			description: "federal state (Official Municipality Key 2-digit)",
			attributeValueMap: {}
		},
		AGS3: {
			description: "administrative district (Official Municipality Key 3-digit)",
			attributeValueMap: {}
		},
		AGS5: {
			description: "region (Official Municipality Key 5-digit)",
			attributeValueMap: {}
		},
		AGS8: {
			description: "municipality (Official Municipality Key 8-digit)",
			attributeValueMap: {}
		},
		AGS11: {
			description: "district (Official Municipality Key 11-digit)",
			attributeValueMap: {}
		},
		AGS13: {
			description: "municipality / postcode (Official Municipality Key 13-digit)",
			attributeValueMap: {}
		},
		AGS16: {
			description: "postcode selective districts (Official Municipality Key 16-digit)",
			attributeValueMap: {}
		},
		AGS20: {
			description: "settlement block (Official Municipality Key 20-digit)",
			attributeValueMap: {}
		},
		AGS22: {
			description: "street sections (Official Municipality Key 22-digit)",
			attributeValueMap: {}
		},
		AGS24: {
			description: "building (Official Municipality Key 24-digit)",
			attributeValueMap: {}
		},
		AGS27: {
			description: "address (Official Municipality Key 27-digit)",
			attributeValueMap: {}
		},
		OI: {
			description: "official object-ID (alternatively for AGS27)",
			attributeValueMap: {}
		},
		GITTER_ID_100m: {
			description: "grid-identifier  (Grid_ETRS89-LAEA_100m)",
			attributeValueMap: {}
		},
		GITTER_ID_1km: {
			description: "grid-identifier (Grid_ETRS89-LAEA_1km)",
			attributeValueMap: {}
		},
		PLZ: {
			description: "postcode",
			attributeValueMap: {}
		},
		ORT: {
			description: "post town name",
			attributeValueMap: {}
		},
		ORTZ: {
			description: "post town name addition",
			attributeValueMap: {}
		},
		OT1: {
			description: "alternative district name",
			attributeValueMap: {}
		},
		OT2: {
			description: "alternative district name 2",
			attributeValueMap: {}
		},
		STN: {
			description: "street name",
			attributeValueMap: {}
		},
		HNR: {
			description: "house number",
			attributeValueMap: {}
		},
		HNRZ: {
			description: "house number affix",
			attributeValueMap: {}
		},
		CASA_VORWAHL: {
			description: "phone code",
			attributeValueMap: {}
		},
		ip_WGS84Long: {
			description: "X-Coordinate WGS84",
			attributeValueMap: {}
		},
		ip_WGS84Lat: {
			description: "Y-Coordinate WGS84",
			attributeValueMap: {}
		},
		ip_GK3East: {
			description: "X-Coordinate GK3",
			attributeValueMap: {}
		},
		ip_GK3North: {
			description: "Y-Coordinate GK3",
			attributeValueMap: {}
		},
		ip_UTM32East: {
			description: "X-Coordinate UTM32",
			attributeValueMap: {}
		},
		ip_UTM32North: {
			description: "Y-Coordinate UTM32",
			attributeValueMap: {}
		},
		CASA_N: {
			description: "building use",
			attributeValueMap: {
				"1": "private",
				"2": "mixed use",
				"3": "commercial",
				"-99": "not specified"
			}
		},
		CASA_NGEW: {
			description: "building use commercial",
			attributeValueMap: {
				"1": "commercial - industry",
				"2": "commercial - services and administration",
				"3": "commercial - trade",
				"4": "agriculture",
				"5": "public institution (e. g. school, museum, department)",
				"6": "Other (mining, energy generation, transport, logistics, public facilities)",
				"7": "mixed",
				"-99": "not specified"
			}
		},
		CASA_POI_1: {
			description: "number of POIs - education",
			attributeValueMap: {}
		},
		CASA_POI_2: {
			description: "number of POIs - shopping",
			attributeValueMap: {}
		},
		CASA_POI_3: {
			description: "number of POIs - leisure",
			attributeValueMap: {}
		},
		CASA_POI_4: {
			description: "number of POIs - tourism",
			attributeValueMap: {}
		},
		CASA_POI_5: {
			description: "number of POIs - food & drink",
			attributeValueMap: {}
		},
		CASA_POI_6: {
			description: "number of POIs - public institution",
			attributeValueMap: {}
		},
		CASA_POI_7: {
			description: "number of POIs - traffic",
			attributeValueMap: {}
		},
		CASA_POI_8: {
			description: "number of POIs - health",
			attributeValueMap: {}
		},
		CASA_POI_9: {
			description: "number of POIs - business",
			attributeValueMap: {}
		},
		CASA_MALL: {
			description: "building use as shopping centre",
			attributeValueMap: {
				"0": "no",
				"1": "yes",
				"-99": "not specified"
			}
		},
		CASA_MALL_ID: {
			description: "ID of the shopping centre",
			attributeValueMap: {}
		},
		CASA_WFL: {
			description: "living space per household (only buildings for private use)",
			attributeValueMap: {}
		},
		CASA_WFL_KL: {
			description: "average living space in classes per household ",
			attributeValueMap: {
				"1": "up to 70 sqm",
				"2": "over 70 sqm up to 85 sqm",
				"3": "over 85 sqm up to 115 sqm",
				"4": "over 115 sqm up to 140 sqm",
				"5": "over 140 sqm",
				"-99": "not specified"
			}
		},
		CASA_HOEHE_KL: {
			description: "building height in classes ",
			attributeValueMap: {
				"1": "up to 3 m",
				"2": "over 3 m up to 5 m",
				"3": "over 5 m up to 7 m",
				"4": "over 7 m up to 9 m",
				"5": "over 9 m up to 13 m",
				"6": "over 13 m up top 17 m",
				"7": "over 17 m up to 22 m",
				"8": "over 22 m up to 30 m",
				"9": "over 30 m up to 50 m",
				"10": "over 50 m",
				"-99": "not specified"
			}
		},
		CASA_VOL: {
			description: "building volume (in cubic meter)",
			attributeValueMap: {}
		},
		CASA_VOL_KL: {
			description: "building volume in classes",
			attributeValueMap: {
				"1": "up to 545 cbm",
				"2": "over 545  cbm up to 755  cbm",
				"3": "over 755 cbm up to 1045 cbm",
				"4": "over 1045 cbm up to 1645 cbm",
				"5": "over 1645 cbm",
				"-99": "not specified"
			}
		},
		CASA_DACHFL_KL: {
			description: "roof area in classes",
			attributeValueMap: {
				"1": "under 97 sqm",
				"2": "97 sqm up to below 135 sqm",
				"3": "135 sqm up to below 185 sqm",
				"4": "185 sqm up to below 255 sqm",
				"5": "255 sqm up to below 1000 sqm",
				"6": "over 1000 sqm",
				"-99": "not specified"
			}
		},
		CASA_DACHAR: {
			description: "roof orientation in degree",
			attributeValueMap: {
				"0": "south exposure",
				"45": "sout west exposure",
				"90": "west exposure",
				"-90": "east exposure",
				"-45": "south east exposure"
			}
		},
		CASA_GARTEN_KL: {
			description: "size of the garden / of the undeveloped plot area",
			attributeValueMap: {
				"0": "no garden",
				"1": "small",
				"2": "medium",
				"3": "big",
				"-99": "not specified"
			}
		},
		CASA_GRUNDST_KL: {
			description: "plot size per building in classes",
			attributeValueMap: {
				"1": "up to 450 sqm",
				"2": "over 450 sqm up to 650 sqm",
				"3": "over 650 sqm up to 800 sqm",
				"4": "over 800 sqm up to 1000 sqm",
				"5": "over 1000 sqm",
				"-99": "not specified"
			}
		},
		CASA_GRUNDFL_KL: {
			description: "base area in classes",
			attributeValueMap: {
				"1": "up to 81 sqm",
				"2": "over 81 sqm up to 111  sqm",
				"3": "over 111 sqm up to 155 sqm",
				"4": "over 155 sqm up to 218 sqm",
				"5": "over 218 sqm up to 1000 sqm",
				"6": "over 1000 sqm",
				"-99": "not specified"
			}
		},
		CASA_GRUNDFL: {
			description: "base area",
			attributeValueMap: {}
		},
		CASA_TYP: {
			description: "Basic building typology based on official criteria",
			attributeValueMap: {
				"1": "1a1 detached one- to two-party house, small",
				"2": "1a2 one- to two-party house with residents, small",
				"3": "1b1 detached one- to two-party house, medium",
				"4": "1b2 one- to two-party house with residents, medium",
				"5": "1c1 detached one- to two-party house, big",
				"6": "1c2 one- to two-party house with residents, big",
				"7": "1d1 detached villa",
				"8": "1f1 classic semi-detached house, small",
				"9": "1g1 classic semi-detached house, medium",
				"10": "1h1 classic semi-detached house, big",
				"11": "1j1 terraced house, small",
				"12": "1k1 terraced house, medium",
				"13": "1l1 terraced house, big",
				"14": "2a1 detached multi-party house, small",
				"15": "2a2 multi-party house with residents, small",
				"16": "2a3 multi-party house en bloc, small",
				"17": "2b1 detached multi-party house, medium",
				"18": "2b2 multi-party house with residents, medium",
				"19": "2b3 multi-party house en bloc, medium",
				"20": "2c1 detached multi-party house, big",
				"21": "2c2 multi-party house with residents, big",
				"22": "2c3 multi-party house en bloc, big",
				"23": "2d1 multi-party semi-detached house, small",
				"24": "2e1 multi-party semi-detached house, medium",
				"25": "2f1 multi-party semi-detached house, big",
				"26": "3a row construction",
				"27": "3b mulit-family complex",
				"28": "3c high-rise",
				"-97": "4 special type",
				"-98": "5 industry",
				"-99": "not specified"
			}
		},
		CASA_BASISTYP: {
			description: "building typology in rough classes",
			attributeValueMap: {
				"1": "1a detached one- to two-party house",
				"2": "1b detached villa",
				"3": "1c one- to two-party house with residents",
				"4": "1d classic semi-detached house",
				"5": "1e terraced house",
				"6": "2a detached multi-party house",
				"7": "2b multi-party semi-detached house",
				"8": "2c multi-party house with residents",
				"9": "2d multi-party house en bloc",
				"10": "3a row construction",
				"11": "3b multi-family complex",
				"12": "3c high rise",
				"-97": "4 special type",
				"-98": "5 predominantly industrial",
				"-99": "not classified"
			}
		},
		CASA_GEBPRETYP: {
			description: "Basic building typology based on official criteria",
			attributeValueMap: {
				"1": "single building small",
				"2": "single building medium",
				"3": "single building large",
				"4": "multistory building",
				"5": "double building, similar, small",
				"6": "double building, similar, medium",
				"7": "double building, similar, large",
				"8": "single building with neighbour, small",
				"9": "single building with neighbour, medium",
				"10": "single building with neighbour, large",
				"11": "elongated building",
				"12": "terraced buildings (\"triplets\")",
				"13": "terraced buildings (\"quadruplets\")",
				"14": "terraced buildings with 5 to 8 buildings",
				"15": "building in block",
				"16": "building complex",
				"17": "small group of buildings",
				"18": "multistory building complex",
				"19": "special type with no specific identification",
				"-99": "classification not possible"
			}
		},
		CASA_GEBTYP_PRIV: {
			description: "private basic building typology",
			attributeValueMap: {
				"1": "detached one- to two-party house",
				"2": "classic semi-detached house with one to two parties",
				"3": "one- to two-party house with residents",
				"4": "one- to two-party house in small group",
				"5": "terraced house",
				"6": "row construction",
				"7": "detached multi-party house",
				"8": "semi-detached house with multiple parties",
				"9": "multi-party house with residents",
				"10": "multi-party house in small group",
				"11": "multi-party house in block",
				"12": "high rise",
				"-97": "special type",
				"-98": "dominant industrial",
				"-99": "not classified"
			}
		},
		CASA_BJ_KL: {
			description: "year of construction in classes ",
			attributeValueMap: {
				"1": "1919  and earlier",
				"2": "1920 until 1949",
				"3": "1950 until 1959",
				"4": "1960 until 1969",
				"5": "1970 until 1979",
				"6": "1980 until 1989",
				"7": "1990 until 1999",
				"8": "2000 until 2009",
				"9": "2010 and later",
				"-99": "year of construction unknown"
			}
		},
		CASA_GARAGE: {
			description: "garage available",
			attributeValueMap: {
				"0": "no",
				"1": "yes"
			}
		},
		CASA_STOCK_ANZ: {
			description: "number of floors",
			attributeValueMap: {}
		},
		CASA_NEUBAU: {
			description: "is building a new construction",
			attributeValueMap: {
				"0": "no",
				"1": "yes"
			}
		},
		CASA_NEUBAU_JR: {
			description: "year of the new construction",
			attributeValueMap: {}
		},
		CASA_WH_PREIS_KL: {
			description: "price classes per accommodation unit (for single-family houses and flats)",
			attributeValueMap: {
				"1": "up to 75.000 €",
				"2": "over 75.000 € up to",
				"3": "over 100.000 € up to 125.000 €",
				"4": "over 125.000 € up to 150.000 €",
				"5": "over 150.000 € up to 175.000 €",
				"6": "over 175.000 € up to 200.000 €",
				"7": "over 200.000 € up to 250.000 €",
				"8": "over 250.000 € up to 300.000 €",
				"9": "over 300.000 € up to 400.000 €",
				"10": "over 400.000 € up to 500.000  €",
				"11": "over 500.000 € up to 700.000 €",
				"12": "over 700.000 €",
				"-99": "not specified"
			}
		},
		CASA_WH_PREIS_INDEX: {
			description: "house price index of the region (100 = average of the region)",
			attributeValueMap: {}
		},
		CASA_EXKL: {
			description: "exclusivity of the accommodation unit",
			attributeValueMap: {
				"1": "very exclusive",
				"2": "exclusive",
				"3": "upscale",
				"4": "medium",
				"5": "sufficient",
				"6": "simple",
				"7": "very simple",
				"-99": "not specified"
			}
		},
		CASA_ORTSLAGE: {
			description: "location of the house within the municipality",
			attributeValueMap: {
				"1": "location within the town centre",
				"2": "location within another town centre",
				"3": "central location",
				"4": "decentralized location",
				"5": "location at the town border",
				"-99": "not specified"
			}
		},
		CASA_WOLAGE: {
			description: "quality of the area of the house",
			attributeValueMap: {
				"1": "very good",
				"9": "very simple"
			}
		},
		CASA_KOMPL: {
			description: "degree of complexity of the design of the house",
			attributeValueMap: {
				"1": "very simple",
				"2": "simple",
				"3": "medium",
				"4": "complex",
				"5": "very complex",
				"-99": "not specified"
			}
		},
		CASA_NVI: {
			description: "local supply index",
			attributeValueMap: {}
		},
		CASA_OPNV_IDX: {
			description: "index on the availability of public transport",
			attributeValueMap: {
				"0": "very bad",
				"100": "very good"
			}
		},
		CASA_DIST_BUSH: {
			description: "distance to the next bus stop (in metres)",
			attributeValueMap: {}
		},
		CASA_DIST_BHF: {
			description: "distance to the next station (in metres)",
			attributeValueMap: {}
		},
		CASA_DIST_OPNV: {
			description: "distance to the next public transport stop (in metres)",
			attributeValueMap: {}
		},
		CASA_DIST_USTRAB: {
			description: "distance to the next metro (in metres)",
			attributeValueMap: {}
		},
		CASA_STR_TYP: {
			description: "type of street which borders the building",
			attributeValueMap: {
				"1": "main road",
				"2": "country road",
				"3": "district road",
				"4": "arterial road",
				"5": "collecting road",
				"6": "service road / side street / residential street",
				"7": "traffic-calmed sector",
				"8": "pedestrian zone",
				"9": "footpath",
				"-99": "not specified"
			}
		},
		CASA_WASSER: {
			description: "Location quality of the address in relation to the nearest waters",
			attributeValueMap: {
				"1": "unobstructed view of water (up to 500m)",
				"2": "restricted view (one building at most inside field of vision, up to 500m)",
				"3": "no view of water but in close proximity (up to 500m)",
				"4": "other, more than 500m away from water"
			}
		},
		CASA_WAHLKR: {
			description: "constituency",
			attributeValueMap: {}
		},
		SB_EG_ANT: {
			description: "owner share",
			attributeValueMap: {}
		},
		SB_FLAECHE: {
			description: "area of the settlement block (in square metres)",
			attributeValueMap: {}
		},
		SB_BDICHTE_KL: {
			description: "density of constructions (in classes)",
			attributeValueMap: {
				"1": "very low",
				"5": "very high",
				"-99": "not specified"
			}
		},
		SB_BLOCK_TYP: {
			description: "type of settlement block",
			attributeValueMap: {
				"1": "residential area",
				"2": "mixed area",
				"3": "commercial area",
				"4": "other settlement type",
				"5": "traffic",
				"6": "vegetation",
				"7": "waters"
			}
		},
		SB_OBJART: {
			description: "settlement function",
			attributeValueMap: {}
		},
		SB_KAUF: {
			description: "purchase index (€/square metre)",
			attributeValueMap: {}
		},
		SB_MIET: {
			description: "rent index (€/square metre)",
			attributeValueMap: {}
		},
		SB_STRUKTUR_KL: {
			description: "predominant type of building",
			attributeValueMap: {
				"1": "predominantly single- to two-family housing development",
				"2": "predominantly terraced housing development",
				"3": "predominantly multi-party housing development (small)",
				"4": "predominantly multi-family house with an attached building",
				"5": "predominantly block development",
				"6": "predominantly row construction",
				"7": "predominantly high-rise development",
				"8": "predominantly special types",
				"9": "predominantly commercial buildings",
				"10": "mixed development",
				"-99": "not specified"
			}
		},
		SB_SEKTOR_BE_KL: {
			description: "economic sector by dominance of employees",
			attributeValueMap: {
				"1": "agriculture, forestry and fisheries",
				"2": "raw material extraction",
				"3": "building industry",
				"4": "manufacturing industry",
				"5": "traffic and energy",
				"6": "trade",
				"7": "financial and insurance services",
				"8": "service",
				"9": "public administration",
				"10": "mixed",
				"-98": "pure residential settlement block",
				"-99": "not specified"
			}
		},
		SB_SEKTOR_FI_KL: {
			description: "economic sector by dominance of companies",
			attributeValueMap: {
				"1": "agriculture, forestry and fisheries",
				"2": "raw material extraction",
				"3": "building industry",
				"4": "manufacturing industry",
				"5": "traffic and energy",
				"6": "trade",
				"7": "financial and insurance services",
				"8": "service",
				"9": "public administration",
				"10": "mixed",
				"-98": "pure residential settlement block",
				"-99": "not specified"
			}
		},
		OT_OPNV_IDX: {
			description: "index on the availability of public transport",
			attributeValueMap: {}
		},
		OT_OPNV_IDX_KL: {
			description: "index on the availability of public transport in classes",
			attributeValueMap: {
				"0": "no stops in district",
				"1": "very low",
				"2": "low",
				"3": "medium",
				"4": "high",
				"5": "very high"
			}
		},
		OT_NACHFRAGE_KL: {
			description: "demand frequency for objects of purchase and rental properties",
			attributeValueMap: {
				"1": "low",
				"2": "medium",
				"3": "high",
				"-99": "not specified"
			}
		},
		OT_KAUF: {
			description: "purchase index (€/square metre)",
			attributeValueMap: {}
		},
		OT_MIET: {
			description: "rent index (€/square metre)",
			attributeValueMap: {}
		},
		OT_FLAECHE: {
			description: "area of district (in square metres)",
			attributeValueMap: {}
		},
		OT_NUTZ1: {
			description: "use of district - residential building area (in %)",
			attributeValueMap: {}
		},
		OT_NUTZ2: {
			description: "use of district - industrial and commercial area (in %)",
			attributeValueMap: {}
		},
		OT_NUTZ3: {
			description: "use of district - heap (in %)",
			attributeValueMap: {}
		},
		OT_NUTZ4: {
			description: "use of district - mining operation (in %)",
			attributeValueMap: {}
		},
		OT_NUTZ5: {
			description: "use of district - opencast mine, pit, quarry (in %)",
			attributeValueMap: {}
		},
		OT_NUTZ6: {
			description: "use of district - mixed use (in %)",
			attributeValueMap: {}
		},
		OT_NUTZ7: {
			description: "use of district - area of special funcional character (in %)",
			attributeValueMap: {}
		},
		OT_NUTZ8: {
			description: "use of district - sports, leisure and recreation (in %)",
			attributeValueMap: {}
		},
		OT_NUTZ9: {
			description: "use of district - cemetary (in %)",
			attributeValueMap: {}
		},
		OT_NUTZ10: {
			description: "use of district - traffic (in %)",
			attributeValueMap: {}
		},
		OT_NUTZ11: {
			description: "use of district - place (in %)",
			attributeValueMap: {}
		},
		OT_NUTZ12: {
			description: "use of district - rail traffic (in %)",
			attributeValueMap: {}
		},
		OT_NUTZ13: {
			description: "use of district - aviation (in %)",
			attributeValueMap: {}
		},
		OT_NUTZ14: {
			description: "use of district - shipping (in %)",
			attributeValueMap: {}
		},
		OT_NUTZ15: {
			description: "use of district - agriculture (in %)",
			attributeValueMap: {}
		},
		OT_NUTZ16: {
			description: "use of district - forest (in %)",
			attributeValueMap: {}
		},
		OT_NUTZ17: {
			description: "use of district - wood (in %)",
			attributeValueMap: {}
		},
		OT_NUTZ18: {
			description: "use of district - heath (in %)",
			attributeValueMap: {}
		},
		OT_NUTZ19: {
			description: "use of district - moor (in %)",
			attributeValueMap: {}
		},
		OT_NUTZ20: {
			description: "use of district - sump (in %)",
			attributeValueMap: {}
		},
		OT_NUTZ21: {
			description: "use of district - wasteland, area without vegetation (in %)",
			attributeValueMap: {}
		},
		OT_NUTZ22: {
			description: "use of district - not specified (in %)",
			attributeValueMap: {}
		},
		OT_NUTZ23: {
			description: "use of district - running waters (in %)",
			attributeValueMap: {}
		},
		OT_NUTZ24: {
			description: "use of district - basin (in %)",
			attributeValueMap: {}
		},
		OT_NUTZ25: {
			description: "use of district - standing waters (in %)",
			attributeValueMap: {}
		},
		OT_NUTZ26: {
			description: "use of district - ocean (in %)",
			attributeValueMap: {}
		},
		CASA_NEI_PROZ: {
			description: "slope (in percent)",
			attributeValueMap: {}
		},
		CASA_NEI_GRAD: {
			description: "slope (in degrees)",
			attributeValueMap: {}
		},
		CASA_DGM200: {
			description: "absolute value of base height above sea level (in metres)",
			attributeValueMap: {}
		},
		CASA_EW: {
			description: "number of inhabitants",
			attributeValueMap: {}
		},
		CASA_HH: {
			description: "number of private households",
			attributeValueMap: {}
		},
		CASA_HH_1P: {
			description: "number of one-person households",
			attributeValueMap: {}
		},
		CASA_HH_2P: {
			description: "number of two-person households",
			attributeValueMap: {}
		},
		CASA_HH_3P: {
			description: "number of three-person households",
			attributeValueMap: {}
		},
		CASA_HH_4P: {
			description: "number of four-person households",
			attributeValueMap: {}
		},
		CASA_HH_5P: {
			description: "number of households with five or more persons",
			attributeValueMap: {}
		},
		CASA_HH_KIND: {
			description: "number of households with children ",
			attributeValueMap: {}
		},
		CASA_HH_EINK_KL1: {
			description: "number of housholds with average monthly net income of less than 1000 €",
			attributeValueMap: {}
		},
		CASA_HH_EINK_KL2: {
			description: "number of housholds with average monthly net income from 1000 € to less than 1500 €",
			attributeValueMap: {}
		},
		CASA_HH_EINK_KL3: {
			description: "number of housholds with average monthly net income from 1500 € to less than 2500 €",
			attributeValueMap: {}
		},
		CASA_HH_EINK_KL4: {
			description: "number of housholds with average monthly net income from 2500 € to less than 3500 €",
			attributeValueMap: {}
		},
		CASA_HH_EINK_KL5: {
			description: "number of housholds with average monthly net income from 3500 € to less than 5000 €",
			attributeValueMap: {}
		},
		CASA_HH_EINK_KL6: {
			description: "number of housholds with average monthly net income of 5000 € or more ",
			attributeValueMap: {}
		},
		CASA_HH_EINK_KL: {
			description: "average monthly net income per address",
			attributeValueMap: {
				"1": "< 1000€",
				"2": "1001€ up to 1500€",
				"3": "1501€ up to 2500€",
				"4": "2501€ up to 3500€",
				"5": "3501€ up to 5000€",
				"6": "5001€ and more",
				"-99": "not specified"
			}
		},
		CASA_SOZ_SCH: {
			description: "dominant walk of life in the house",
			attributeValueMap: {
				"1": "upper class",
				"2": "upper-middle class",
				"3": "middle class",
				"4": "lower middle class",
				"5": "lower class",
				"-99": "not specified"
			}
		},
		CASA_ALTER_KL: {
			description: "dominant age structure in the house",
			attributeValueMap: {
				"1": "18 up to 29 years",
				"2": "30 up to 39 years",
				"3": "40 up to 49 years",
				"4": "50 up to 59 years",
				"5": "60 years and older",
				"-99": "not specified"
			}
		},
		CASA_SOHOS: {
			description: "number of small home offices",
			attributeValueMap: {}
		},
		CASA_ANZ_WOHNEINHEITEN: {
			description: "number of theoretically possible living units",
			attributeValueMap: {}
		},
		SB_EW_AUSL_ANZ: {
			description: "number of foreigners",
			attributeValueMap: {}
		},
		SB_EW_AUSL_ANT: {
			valueType: "percentage",
			description: "share of foreigners",
			attributeValueMap: {}
		},
		SB_AUSL_EURO27_ANZ: {
			description: "number of foreigners from EU27 countries",
			attributeValueMap: {}
		},
		SB_AUSL_EUSONST_ANZ: {
			description: "number of foreigners from non EU27 countries in Europe",
			attributeValueMap: {}
		},
		SB_AUSL_WELT_ANZ: {
			description: "number of foreigners from non EU countries",
			attributeValueMap: {}
		},
		SB_AUSL_SONST_ANZ: {
			description: "number of foreigners from other",
			attributeValueMap: {}
		},
		SB_EW_M: {
			description: "number of men",
			attributeValueMap: {}
		},
		SB_EW_W: {
			description: "number of women",
			attributeValueMap: {}
		},
		SB_EW_ANZ: {
			description: "number of inhabitants in the settlement block",
			attributeValueMap: {}
		},
		SB_EW_00U03_ANZ: {
			description: "number of inhabitants <3 years",
			attributeValueMap: {}
		},
		SB_EW_03U06_ANZ: {
			description: "number of inhabitants >=3 up to <6 years",
			attributeValueMap: {}
		},
		SB_EW_06U10_ANZ: {
			description: "number of inhabitants >=6 up to <10 years",
			attributeValueMap: {}
		},
		SB_EW_10U15_ANZ: {
			description: "number of inhabitants >=10 up to <15 years",
			attributeValueMap: {}
		},
		SB_EW_15U18_ANZ: {
			description: "number of inhabitants >=15 up to <18 years",
			attributeValueMap: {}
		},
		SB_EW_00U18_ANZ: {
			description: "number of inhabitants <18 years",
			attributeValueMap: {}
		},
		SB_EW_18U30_ANZ: {
			description: "number of inhabitants >=18 up to <30 years",
			attributeValueMap: {}
		},
		SB_EW_30U45_ANZ: {
			description: "number of inhabitants >=30 up to <45 years",
			attributeValueMap: {}
		},
		SB_EW_45U60_ANZ: {
			description: "number of inhabitants >=45 up to <60 years",
			attributeValueMap: {}
		},
		SB_EW_60U65_ANZ: {
			description: "number of inhabitants >=60 up to <65 years",
			attributeValueMap: {}
		},
		SB_EW_65_ANZ: {
			description: "number of inhabitants >=65 years",
			attributeValueMap: {}
		},
		SB_EW_65U75_ANZ: {
			description: "number of inhabitants >=65 up to <75 years",
			attributeValueMap: {}
		},
		SB_EW_75_ANZ: {
			description: "number of inhabitants >=75 years",
			attributeValueMap: {}
		},
		SB_EW_00U03_ANT: {
			valueType: "percentage",
			description: "share of inhabitants <3 years",
			attributeValueMap: {}
		},
		SB_EW_03U06_ANT: {
			valueType: "percentage",
			description: "share of inhabitants >=3 up to <6 years",
			attributeValueMap: {}
		},
		SB_EW_06U10_ANT: {
			valueType: "percentage",
			description: "share of inhabitants >=6 up to <10 years",
			attributeValueMap: {}
		},
		SB_EW_10U15_ANT: {
			valueType: "percentage",
			description: "share of inhabitants >=10 up to <15 years",
			attributeValueMap: {}
		},
		SB_EW_15U18_ANT: {
			valueType: "percentage",
			description: "share of inhabitants >=15 up to <18 years",
			attributeValueMap: {}
		},
		SB_EW_00U18_ANT: {
			valueType: "percentage",
			description: "share of inhabitants  <18 years",
			attributeValueMap: {}
		},
		SB_EW_18U30_ANT: {
			valueType: "percentage",
			description: "share of inhabitants  >=18  up to <30 years",
			attributeValueMap: {}
		},
		SB_EW_30U45_ANT: {
			valueType: "percentage",
			description: "share of inhabitants  >=30  up to <45 years",
			attributeValueMap: {}
		},
		SB_EW_45U60_ANT: {
			valueType: "percentage",
			description: "share of inhabitants  >=45  up to <60 years",
			attributeValueMap: {}
		},
		SB_EW_60U65_ANT: {
			valueType: "percentage",
			description: "share of inhabitants  >=60  up to <65 years",
			attributeValueMap: {}
		},
		SB_EW_65_ANT: {
			valueType: "percentage",
			description: "share of inhabitants  >=65 years",
			attributeValueMap: {}
		},
		SB_EW_65U75_ANT: {
			valueType: "percentage",
			description: "share of inhabitants >=65 up to <75 years",
			attributeValueMap: {}
		},
		SB_EW_75_ANT: {
			valueType: "percentage",
			description: "share of inhabitants >=75 years",
			attributeValueMap: {}
		},
		SB_RENTNER_ANZ: {
			description: "number of pensioner",
			attributeValueMap: {}
		},
		SB_EW_LEDIG18: {
			description: "number of inhabitants with marital status single and under 18 years",
			attributeValueMap: {}
		},
		SB_EW_LEDIG: {
			description: "number of inhabitants with marital status single and from 18 years",
			attributeValueMap: {}
		},
		SB_EW_VERH: {
			description: "number of inhabitants with marital status married",
			attributeValueMap: {}
		},
		SB_EW_VERW: {
			description: "number of inhabitants with marital status widowed",
			attributeValueMap: {}
		},
		SB_EW_GESCH: {
			description: "number of inhabitants with marital status divorced",
			attributeValueMap: {}
		},
		SB_EW_LEBPAR: {
			description: "number of inhabitants with marital status partnership/ dissolved partnership/ life partner deceased",
			attributeValueMap: {}
		},
		SB_PROM_KL: {
			valueType: "percentage",
			description: "share of graduates per settlement block (in classes)",
			attributeValueMap: {
				"1": "up to 0,5%",
				"2": "0,5% to 1,5%",
				"3": "1,5% to 2,5%",
				"4": "more than 2,5%",
				"-99": "not specified"
			}
		},
		SB_HH_K_00U03: {
			description: "number of households with children with dominating age  up to 2 years",
			attributeValueMap: {}
		},
		SB_HH_K_03U06: {
			description: "number of households with children with dominating age from 3 to 5 years",
			attributeValueMap: {}
		},
		SB_HH_K_06U10: {
			description: "number of households with children with dominating age from 6 to 9 years",
			attributeValueMap: {}
		},
		SB_HH_K_10U15: {
			description: "number of households with children with dominating age from 10 to 14 years",
			attributeValueMap: {}
		},
		SB_HH_K_15U18: {
			description: "number of households with children with dominating age from 15 to 18 years",
			attributeValueMap: {}
		},
		SB_HH_DINKS: {
			description: "number of double earner households without children",
			attributeValueMap: {}
		},
		SB_HH_EINK_KL1: {
			description: "number of households with a monthly net income between 0 and  €1000",
			attributeValueMap: {}
		},
		SB_HH_EINK_KL2: {
			description: "number of households with a monthly net income of more than 1000 up to €1500 ",
			attributeValueMap: {}
		},
		SB_HH_EINK_KL3: {
			description: "number of households with a monthly net income of more than 1500 up to  €2500",
			attributeValueMap: {}
		},
		SB_HH_EINK_KL4: {
			description: "number of households with a monthly net income of more than 2500 up to  €3500",
			attributeValueMap: {}
		},
		SB_HH_EINK_KL5: {
			description: "number of households with a monthly net income of more than 3500 up to  €5000",
			attributeValueMap: {}
		},
		SB_HH_EINK_KL6: {
			description: "number of households with a monthly net income of more than  €5000",
			attributeValueMap: {}
		},
		STR_KK_EW: {
			description: "purchasing power per inhabitant in € per year",
			attributeValueMap: {}
		},
		STR_KK_HH: {
			description: "purchasing power per household in € per year",
			attributeValueMap: {}
		},
		SB_KK_EW: {
			description: "purchasing power per inhabitant in € per year",
			attributeValueMap: {}
		},
		SB_KK_HH: {
			description: "purchasing power per household in € per year",
			attributeValueMap: {}
		},
		SB_KK_VOL: {
			description: "purchasing power per settlement block in € per year",
			attributeValueMap: {}
		},
		SB_KK_EW_IDX_KR: {
			description: "index of purchasing power per person (100 = average of region) ",
			attributeValueMap: {}
		},
		SB_KK_HH_IDX_KR: {
			description: "index of purchasing power per household (100 = average of region) ",
			attributeValueMap: {}
		},
		SB_KK_EW_IDX_BRD: {
			description: "index of purchasing power per person (100 = average of country) ",
			attributeValueMap: {}
		},
		SB_KK_HH_IDX_BRD: {
			description: "index of purchasing power per household (100 = average of country) ",
			attributeValueMap: {}
		},
		SB_EW_DICHTE_KL: {
			description: "population density (in classes) ",
			attributeValueMap: {
				"0": "no inhabitants",
				"1": "very low",
				"2": "low",
				"3": "medium",
				"4": "high",
				"5": "very high",
				"-99": "not defined"
			}
		},
		SB_REL1_KL: {
			valueType: "percentage",
			description: "share of persons with the religion \"Roman Catholic Church\" in classes",
			attributeValueMap: {
				"1": "very low",
				"2": "low",
				"3": "medium",
				"4": "high",
				"5": "very high",
				"-99": "not specified"
			}
		},
		SB_REL2_KL: {
			valueType: "percentage",
			description: "share of persons with the religion \"Protestant Church\" in classes",
			attributeValueMap: {}
		},
		SB_REL3_KL: {
			valueType: "percentage",
			description: "share of persons with the religion \"other, no, without specification\" in classes",
			attributeValueMap: {}
		},
		SB_GKV: {
			description: "number of persons with statutory health insurance",
			attributeValueMap: {}
		},
		SB_PKV: {
			description: "number of persons with private health insurance",
			attributeValueMap: {}
		},
		STR_LEER_ANT: {
			valueType: "percentage",
			description: "Share of vacant apartments per street section",
			attributeValueMap: {}
		},
		OT_KK_EW: {
			description: "purchasing power per inhabitant in € per year",
			attributeValueMap: {}
		},
		OT_KK_HH: {
			description: "purchasing power per household in € per year",
			attributeValueMap: {}
		},
		OT_ALO_Q: {
			valueType: "percentage",
			description: "unemployment rate (of the dependent civil labour force)",
			attributeValueMap: {}
		},
		OT_ERWT_AO: {
			description: "Number of employed persons at the place of work",
			attributeValueMap: {}
		},
		OT_ERWT_AO_B01: {
			description: "Number of employed persons in 'agriculture, forestry and fisheries' at the place of work ",
			attributeValueMap: {}
		},
		OT_ERWT_AO_B02: {
			description: "Number of employed persons in 'raw material extraction' at the place of work ",
			attributeValueMap: {}
		},
		OT_ERWT_AO_B03: {
			description: "Number of employed persons in 'building industry' at the place of work ",
			attributeValueMap: {}
		},
		OT_ERWT_AO_B04: {
			description: "Number of employed persons in ' manufacturing industry' at the place of work ",
			attributeValueMap: {}
		},
		OT_ERWT_AO_B05: {
			description: "Number of employed persons in 'traffic and energy' at the place of work ",
			attributeValueMap: {}
		},
		OT_ERWT_AO_B06: {
			description: "Number of employed persons in 'trade' at the place of work ",
			attributeValueMap: {}
		},
		OT_ERWT_AO_B07: {
			description: "Number of employed persons in 'financial and insurance services' at the place of work ",
			attributeValueMap: {}
		},
		OT_ERWT_AO_B08: {
			description: "Number of employed persons in 'service' at the place of work ",
			attributeValueMap: {}
		},
		OT_ERWT_AO_B09: {
			description: "Number of employed persons in 'public administration' at the place of work ",
			attributeValueMap: {}
		},
		OT_ERWT_AO_B99: {
			description: "Number of employed persons in 'unknown' at the place of work ",
			attributeValueMap: {}
		},
		OT_ERWPERS: {
			description: "number of dependent civilian working people at the place of residence",
			attributeValueMap: {}
		},
		OT_BE_AO: {
			description: "number of employees subject to social insurance requirements at the workplace",
			attributeValueMap: {}
		},
		OT_BE_AO_VZ: {
			description: "number of employees subject to social insurance requirements at the workplace",
			attributeValueMap: {}
		},
		OT_BE_AO_TZ: {
			description: "number of employees subject to social insurance requirements at the workplace",
			attributeValueMap: {}
		},
		OT_BE_WO: {
			description: "number of employees subject to social insurance requirements at the place of residence",
			attributeValueMap: {}
		},
		OT_BE_WO_VZ: {
			description: "number of employees subject to social insurance requirements at the place of residence",
			attributeValueMap: {}
		},
		OT_BE_WO_TZ: {
			description: "number of employees subject to social insurance requirements at the place of residence",
			attributeValueMap: {}
		},
		OT_SELBST: {
			description: "number of self-employed persons / freelancers at the workplace",
			attributeValueMap: {}
		},
		OT_MITHFAM: {
			description: "number of family workers at the workplace",
			attributeValueMap: {}
		},
		OT_SCHUELER: {
			description: "number of pupils at the place of residence",
			attributeValueMap: {}
		},
		OT_EINP_AO: {
			description: "number of commuter at workin place",
			attributeValueMap: {}
		},
		OT_STUDENT: {
			description: "number of pupils at the place of residence",
			attributeValueMap: {}
		},
		OT_AZUBI: {
			description: "number of apprentices at the place of residence",
			attributeValueMap: {}
		},
		OT_BEAMTE: {
			description: "number of officials (judges and soldiers included) at the place of residence",
			attributeValueMap: {}
		},
		OT_SCHUL_KEIN: {
			description: "persons aged 15 and above by the highest school-leaving qualification - without or not yet any school-leaving qualification",
			attributeValueMap: {}
		},
		OT_SCHUL_HAUPT: {
			description: "persons aged 15 and above by the highest school-leaving qualification - lower secondary school qualification",
			attributeValueMap: {}
		},
		OT_SCHUL_MITTL: {
			description: "persons aged 15 and above by the highest school-leaving qualification - secondary school certificate and upper classes",
			attributeValueMap: {}
		},
		OT_SCHUL_HOCH: {
			description: "persons aged 15 and above by the highest school-leaving qualification - advanced technical college entrance qualification,  general or subject-linked higher education entrance qualification (Abitur)",
			attributeValueMap: {}
		},
		OT_BERUF_KEIN: {
			description: "persons aged 15 and above by the highest professional qualification - without or not yet any professional qualification",
			attributeValueMap: {}
		},
		OT_BERUF_LEHRE: {
			description: "persons aged 15 and above by the highest professional qualification - apprenticeship, vocational training in the dual system",
			attributeValueMap: {}
		},
		OT_BERUF_FACHSCHUL: {
			description: "persons aged 15 and above by the highest professional qualification - professional school certificate, professional or vocational academy qualification",
			attributeValueMap: {}
		},
		OT_BERUF_HOCHSCHUL: {
			description: "persons aged 15 and above by the highest professional qualification - polytechnic degree, university degree",
			attributeValueMap: {}
		},
		OT_BERUF_PROM: {
			description: "persons aged 15 and above by the highest professional qualification - doctorate",
			attributeValueMap: {}
		},
		OT_ABSOL_GES: {
			description: "number of general and vocational school graduates - altogether",
			attributeValueMap: {}
		},
		OT_ABSOL_HAUPT: {
			description: "number of general and vocational school graduates - lower secondary school qualification",
			attributeValueMap: {}
		},
		OT_ABSOL_REAL: {
			description: "number of general and vocational school graduates - secondary school certificate and upper classes",
			attributeValueMap: {}
		},
		OT_ABSOL_FACH: {
			description: "number of general and vocational school graduates - advanced technical college entrance qualification",
			attributeValueMap: {}
		},
		OT_ABSOL_HOCH: {
			description: "number of general and vocational school graduates -  general higher education entrance qualification (Abitur)",
			attributeValueMap: {}
		},
		ANZ_GEB_EIG_1: {
			description: "number of buildings with living space with form of ownership of the building \"community of homeowners\"",
			attributeValueMap: {}
		},
		ANZ_GEB_EIG_2: {
			description: "number of buildings with living space with form of ownership of the building \"private persons\"",
			attributeValueMap: {}
		},
		ANZ_GEB_EIG_3: {
			description: "number of buildings with living space with form of ownership of the building \"housing association\"",
			attributeValueMap: {}
		},
		ANZ_GEB_EIG_4: {
			description: "number of buildings with living space with form of ownership of the building \"municipality or municipal housing companies\"",
			attributeValueMap: {}
		},
		ANZ_GEB_EIG_5: {
			description: "number of buildings with living space with form of ownership of the building \"private housing company\"",
			attributeValueMap: {}
		},
		ANZ_GEB_EIG_6: {
			description: "number of buildings with living space with form of ownership of the building \"other private company\"",
			attributeValueMap: {}
		},
		ANZ_GEB_EIG_7: {
			description: "number of buildings with living space with form of ownership of the building \"Federation or Land\"",
			attributeValueMap: {}
		},
		ANZ_GEB_EIG_8: {
			description: "number of buildings with living space with form of ownership of the building \"non-profit organisation (e. g. church)\"",
			attributeValueMap: {}
		},
		ANZ_GEB_HEIZTYP_1: {
			description: "number of buildings with living space with heating type \"district heating (district heat)\"",
			attributeValueMap: {}
		},
		ANZ_GEB_HEIZTYP_2: {
			description: "number of buildings with living space with heating type \"self-contained central heating\"",
			attributeValueMap: {}
		},
		ANZ_GEB_HEIZTYP_3: {
			description: "number of buildings with living space with heating type \"block heater\"",
			attributeValueMap: {}
		},
		ANZ_GEB_HEIZTYP_4: {
			description: "number of buildings with living space with heating type \"central heating\"",
			attributeValueMap: {}
		},
		ANZ_GEB_HEIZTYP_5: {
			description: "number of buildings with living space with heating type \"single-/multi-room ovens (also night storage heating)\"",
			attributeValueMap: {}
		},
		ANZ_GEB_HEIZTYP_6: {
			description: "number of buildings with living space with heating type \"without heating in the building or in the flats\"",
			attributeValueMap: {}
		},
		ANZ_WHG_NUTZ_1: {
			description: "flats in buildings with living space and the type of use \"occupied by owners\"                                                                                                                                                                                                     (without diplomat flats/ flats of foreign forces and without commercially used units)",
			attributeValueMap: {}
		},
		ANZ_WHG_NUTZ_2: {
			description: "flats in buildings with living space and the type of use \"rented for residential purposes (also rent-free)\"                                                                                                                                                                                                     (without diplomat flats/ flats of foreign forces and without commercially used units)",
			attributeValueMap: {}
		},
		ANZ_WHG_NUTZ_3: {
			description: "flats in buildings with living space and the type of use \"holiday home\"                                                                                                                                                                                                     (without diplomat flats/ flats of foreign forces and without commercially used units)",
			attributeValueMap: {}
		},
		ANZ_WHG_NUTZ_4: {
			description: "flats in buildings with living space and the type of use \"vacant\"                                                                                                                                                                                                     (without diplomat flats/ flats of foreign forces and without commercially used units)",
			attributeValueMap: {}
		},
		ANZ_FAM_FAMTYP_1: {
			description: "number of families with the type of family nucleus \"couples without child(ren)\"",
			attributeValueMap: {}
		},
		ANZ_FAM_FAMTYP_2: {
			description: "number of families with the type of family nucleus \"couples with child(ren)\"",
			attributeValueMap: {}
		},
		ANZ_FAM_FAMTYP_3: {
			description: "number of families with the type of family nucleus \"single parents\"",
			attributeValueMap: {}
		},
		ANZ_PERS_FAMSTAND_1: {
			description: "number of persons with the marital status \"unmarried\"",
			attributeValueMap: {}
		},
		ANZ_PERS_FAMSTAND_2: {
			description: "number of persons with the marital status \"married\"",
			attributeValueMap: {}
		},
		ANZ_PERS_FAMSTAND_3: {
			description: "number of persons with the marital status \"widowed\"",
			attributeValueMap: {}
		},
		ANZ_PERS_FAMSTAND_4: {
			description: "number of persons with the marital status \"divorced\"",
			attributeValueMap: {}
		},
		ANZ_PERS_FAMSTAND_5: {
			description: "number of persons with the marital status \"registered civil partnership\"",
			attributeValueMap: {}
		},
		ANZ_PERS_FAMSTAND_6: {
			description: "number of persons with the marital status \"other\"",
			attributeValueMap: {}
		},
		ANZ_PERS_RELI_1: {
			description: "number of persons with the religion \"Roman Catholic Church (under public law)\"",
			attributeValueMap: {}
		},
		ANZ_PERS_RELI_2: {
			description: "number of persons with the religion \"Protestant Church (under public law)\"",
			attributeValueMap: {}
		},
		ANZ_PERS_RELI_3: {
			description: "number of persons with the religion \"other, no, without specification\"",
			attributeValueMap: {}
		},
		ANZ_PERS_STAATSANG_1: {
			description: "number of persons with the nationality \"Germany\"",
			attributeValueMap: {}
		},
		ANZ_PERS_STAATSANG_2: {
			description: "number of persons with the nationality \"EU27-country\"",
			attributeValueMap: {}
		},
		ANZ_PERS_STAATSANG_3: {
			description: "number of persons with the nationality \"rest of Europe\"",
			attributeValueMap: {}
		},
		ANZ_PERS_STAATSANG_4: {
			description: "number of persons with the nationality \"rest of the world\"",
			attributeValueMap: {}
		},
		ANZ_PERS_STAATSANG_5: {
			description: "number of persons with the nationality \"other\"",
			attributeValueMap: {}
		},
		OT_MIGR_ANT: {
			valueType: "percentage",
			description: "migration share (based on inhabitants)",
			attributeValueMap: {}
		},
		OT_DT_ANT: {
			valueType: "percentage",
			description: "share of persons without any migrant background  (based on inhabitants)",
			attributeValueMap: {}
		},
		OT_TK_ANT: {
			valueType: "percentage",
			description: "share of persons with a Turkish migrant background  (based on inhabitants)",
			attributeValueMap: {}
		},
		OT_PL_ANT: {
			valueType: "percentage",
			description: "share of persons with a Polish migrant background  (based on inhabitants)",
			attributeValueMap: {}
		},
		OT_IT_ANT: {
			valueType: "percentage",
			description: "share of persons with an Italian migrant background  (based on inhabitants)",
			attributeValueMap: {}
		},
		OT_SOW_ANT: {
			valueType: "percentage",
			description: "share of persons with a Soviet migrant background  (based on inhabitants)",
			attributeValueMap: {}
		},
		OT_JUG_ANT: {
			valueType: "percentage",
			description: "share of persons with a Yugoslavian migrant background  (based on inhabitants)",
			attributeValueMap: {}
		},
		OT_MUS_ANT: {
			valueType: "percentage",
			description: "share of persons with a Muslim migrant background  (based on inhabitants)",
			attributeValueMap: {}
		},
		OT_SO_ANT: {
			valueType: "percentage",
			description: "share of persons with another migrant background  (based on inhabitants)",
			attributeValueMap: {}
		},
		SB_MIGR_KL: {
			description: "migration share in classes",
			attributeValueMap: {
				"1": "very low",
				"2": "low",
				"3": "medium",
				"4": "high",
				"5": "very high",
				"-99": "not specified"
			}
		},
		SB_DT_KL: {
			valueType: "percentage",
			description: "share of persons without any migrant background in classes (based on the distribution in the region)",
			attributeValueMap: {}
		},
		SB_TK_KL: {
			valueType: "percentage",
			description: "share of persons with a Turkish migrant background in classes (based on the distribution in the region)",
			attributeValueMap: {}
		},
		SB_PL_KL: {
			valueType: "percentage",
			description: "share of persons with a Polish migrant background in classes (based on the distribution in the region)",
			attributeValueMap: {}
		},
		SB_IT_KL: {
			valueType: "percentage",
			description: "share of persons with an Italian migrant background in classes (based on the distribution in the region)",
			attributeValueMap: {}
		},
		SB_SOW_KL: {
			valueType: "percentage",
			description: "share of persons with a Soviet migrant background in classes (based on the distribution in the region)",
			attributeValueMap: {}
		},
		SB_JUG_KL: {
			valueType: "percentage",
			description: "share of persons with a Yugoslavian migrant background in classes (based on the distribution in the region)",
			attributeValueMap: {}
		},
		SB_MUS_KL: {
			valueType: "percentage",
			description: "share of persons with a Muslim migrant background in classes (based on the distribution in the region)",
			attributeValueMap: {}
		},
		SB_SO_KL: {
			valueType: "percentage",
			description: "share of persons with another migrant background in classes (based on the distribution in the region)",
			attributeValueMap: {}
		},
		SB_MIGR_KL_BRD: {
			valueType: "percentage",
			description: "share of persons with a migrant background in classes (based on the distribution in the FRG)",
			attributeValueMap: {
				"1": "very low",
				"2": "low",
				"3": "medium",
				"4": "high",
				"5": "very high",
				"-99": "not specified"
			}
		},
		SB_DT_KL_BRD: {
			valueType: "percentage",
			description: "share of persons without any migrant background in classes (based on the distribution in the FRG)",
			attributeValueMap: {}
		},
		SB_TK_KL_BRD: {
			valueType: "percentage",
			description: "share of persons with a Turkish migrant background in classes (based on the distribution in the FRG)",
			attributeValueMap: {}
		},
		SB_PL_KL_BRD: {
			valueType: "percentage",
			description: "share of persons with a Polish migrant background in classes (based on the distribution in the FRG)",
			attributeValueMap: {}
		},
		SB_IT_KL_BRD: {
			valueType: "percentage",
			description: "share of persons with an Italian migrant background in classes (based on the distribution in the FRG",
			attributeValueMap: {}
		},
		SB_SOW_KL_BRD: {
			valueType: "percentage",
			description: "share of persons with a Soviet migrant background in classes (based on the distribution in the FRG)",
			attributeValueMap: {}
		},
		SB_JUG_KL_BRD: {
			valueType: "percentage",
			description: "share of persons with a Yugoslavian migrant background in classes (based on the distribution in the FRG)",
			attributeValueMap: {}
		},
		SB_MUS_KL_BRD: {
			valueType: "percentage",
			description: "share of persons with a Muslim migrant background in classes (based on the distribution in the FRG)",
			attributeValueMap: {}
		},
		SB_SO_KL_BRD: {
			valueType: "percentage",
			description: "share of persons with another migrant background in classes (based on the distribution in the FRG)",
			attributeValueMap: {}
		},
		CASA_EV_KL: {
			description: "Yearly energy consumption for heating and hot water in kWh per square meter of living space (in classes)",
			attributeValueMap: {
				"1": "up to 30 kWh/m²",
				"2": "over 30 up to 50 kWh/m²",
				"3": "over 50 up to 75 kWh/m²",
				"4": "over 75 up to 100 kWh/m²",
				"5": "over 100 up to 130 kWh/m²",
				"6": "over 130 up to 160 kWh/m²",
				"7": "over 160 up to 200 kWh/m²",
				"8": "over 200 up to 250 kWh/m²",
				"9": "over 250 kWh/m²",
				"-98": "no residential building",
				"-99": "not specified"
			}
		},
		CASA_EB_KL: {
			description: "Yearly energy demand for heating and hot water in kWh per square meter of living space (in classes)",
			attributeValueMap: {
				"1": "up to 30 kWh/m²",
				"2": "over 30 up to 50 kWh/m²",
				"3": "over 50 up to 75 kWh/m²",
				"4": "over 75 up to 100 kWh/m²",
				"5": "over 100 up to 130 kWh/m²",
				"6": "over 130 up to 160 kWh/m²",
				"7": "over 160 up to 200 kWh/m²",
				"8": "over 200 up to 250 kWh/m²",
				"9": "over 250 kWh/m²",
				"-98": "no residential building",
				"-99": "not specified"
			}
		},
		CASA_SOLAR: {
			description: "solar system available ",
			attributeValueMap: {
				"0": "no",
				"1": "yes"
			}
		},
		CASA_SOL_JR: {
			description: "commissioning year of the solar system",
			attributeValueMap: {}
		},
		CASA_SOL_NL: {
			description: "rated power of the solar system",
			attributeValueMap: {}
		},
		CASA_SOL_KL: {
			description: "rated power of the solar system in classes",
			attributeValueMap: {
				"1": "up to 4 kWp_el",
				"2": "over 4 kWp_el up to 6 kWp_el",
				"3": "over 6 kWp_el up to 10 kWp_el",
				"4": "over 10 kWp_el up to 24 kWp_el",
				"5": "over 24 kWp_el up to 40000 kWp_el",
				"6": "over 40000 kWp_el",
				"-99": "not specified"
			}
		},
		CASA_SO_SCORE: {
			description: "solar affinity",
			attributeValueMap: {
				"1": "no affinity",
				"9": "very high affinity",
				"-99": "not specified"
			}
		},
		CASA_HEIZ_SCORE: {
			description: "heating modernisation affinity",
			attributeValueMap: {
				"1": "no affinity",
				"9": "very high affinity",
				"-99": "not specified"
			}
		},
		CASA_NSP: {
			description: "night storage available ",
			attributeValueMap: {
				"0": "no",
				"1": "yes",
				"-99": "not specified"
			}
		},
		CASA_GAS: {
			description: "gas connection available ",
			attributeValueMap: {
				"1": "real case address",
				"2": "real case building",
				"3": "distributed over building ensemble",
				"4": "distributed over building ensemble",
				"5": "distributed over street name",
				"6": "gas network available",
				"-99": "not specified"
			}
		},
		CASA_FERN: {
			description: "district heat available ",
			attributeValueMap: {
				"1": "real case address",
				"2": "real case building",
				"3": "distributed over building ensemble",
				"4": "distributed over building ensemble",
				"5": "distributed over street name",
				"-99": "not specified"
			}
		},
		CASA_OEL: {
			description: "oil heating available ",
			attributeValueMap: {
				"1": "real case address",
				"4": "distributed over building ensemble",
				"-99": "not specified"
			}
		},
		CASA_SONST: {
			description: "other energy type",
			attributeValueMap: {
				"1": "real case address",
				"4": "distributed over building ensemble",
				"-99": "not specified"
			}
		},
		CASA_ENCL_KL: {
			description: "dominant energy cluster per address",
			attributeValueMap: {
				"1": "in need of energy",
				"2": "innovative and efficient",
				"3": "sustainable",
				"4": "freedom-loving",
				"5": "efficient",
				"6": "hedonistic",
				"7": "independent and sustainable",
				"8": "mixed",
				"-99": "not specified"
			}
		},
		CASA_HH_EA1: {
			description: "number of households with energy cluster 'in need of energy' per address",
			attributeValueMap: {}
		},
		CASA_HH_EA2: {
			description: "number of households with energy cluster 'innovative and efficient' per address",
			attributeValueMap: {}
		},
		CASA_HH_EA3: {
			description: "number of households with energy cluster 'sustainable' per address",
			attributeValueMap: {}
		},
		CASA_HH_EA4: {
			description: "number of households with energy cluster 'freedom-loving' per address",
			attributeValueMap: {}
		},
		CASA_HH_EA5: {
			description: "number of households with energy cluster 'efficient' per address",
			attributeValueMap: {}
		},
		CASA_HH_EA6: {
			description: "number of households with energy cluster 'hedonistic' per address",
			attributeValueMap: {}
		},
		CASA_HH_EA7: {
			description: "number of households with energy cluster 'independent and sustainable' per address",
			attributeValueMap: {}
		},
		CASA_ANZ_FIRM: {
			description: "number of companies (including companies with missing number of employees)",
			attributeValueMap: {}
		},
		CASA_ANZ_FIRM_B01: {
			description: "number of companies by industry: agriculture, forestry and fishing",
			attributeValueMap: {}
		},
		CASA_ANZ_FIRM_B02: {
			description: "number of companies by industry: mining and quarrying",
			attributeValueMap: {}
		},
		CASA_ANZ_FIRM_B03: {
			description: "number of companies by industry: manufacturing",
			attributeValueMap: {}
		},
		CASA_ANZ_FIRM_B04: {
			description: "number of companies by industry: electricity, gas, steam and air conditioning supply",
			attributeValueMap: {}
		},
		CASA_ANZ_FIRM_B05: {
			description: "number of companies by industry: water supply; sewerage, waste management and remediation activities",
			attributeValueMap: {}
		},
		CASA_ANZ_FIRM_B06: {
			description: "number of companies by industry: construction",
			attributeValueMap: {}
		},
		CASA_ANZ_FIRM_B07: {
			description: "number of companies by industry: wholesale and retail trade; repair of motor vehicles and motorcycles",
			attributeValueMap: {}
		},
		CASA_ANZ_FIRM_B08: {
			description: "number of companies by industry: transportation and storage",
			attributeValueMap: {}
		},
		CASA_ANZ_FIRM_B09: {
			description: "number of companies by industry: accommodation and food service activities",
			attributeValueMap: {}
		},
		CASA_ANZ_FIRM_B10: {
			description: "number of companies by industry: information and communication",
			attributeValueMap: {}
		},
		CASA_ANZ_FIRM_B11: {
			description: "number of companies by industry: financial and insurance activities",
			attributeValueMap: {}
		},
		CASA_ANZ_FIRM_B12: {
			description: "number of companies by industry: real estate activities",
			attributeValueMap: {}
		},
		CASA_ANZ_FIRM_B13: {
			description: "number of companies by industry: professional, scientific and technical activities",
			attributeValueMap: {}
		},
		CASA_ANZ_FIRM_B14: {
			description: "number of companies by industry: other economical activities",
			attributeValueMap: {}
		},
		CASA_ANZ_FIRM_B15: {
			description: "number of companies by industry: public administration and defence; compulsory social security",
			attributeValueMap: {}
		},
		CASA_ANZ_FIRM_B16: {
			description: "number of companies by industry: education",
			attributeValueMap: {}
		},
		CASA_ANZ_FIRM_B17: {
			description: "number of companies by industry: human health and social work activities",
			attributeValueMap: {}
		},
		CASA_ANZ_FIRM_B18: {
			description: "number of companies by industry: arts, entertainment and recreation",
			attributeValueMap: {}
		},
		CASA_ANZ_FIRM_B19: {
			description: "number of companies by industry: other community, social and personal service activities",
			attributeValueMap: {}
		},
		CASA_ANZ_FIRM_B20: {
			description: "number of companies by industry: activities of households as employers; undifferentiated goods- and services-producing activities of households for own use",
			attributeValueMap: {}
		},
		CASA_ANZ_FIRM_B21: {
			description: "number of companies by industry: activities of extraterritorial organizations and bodies",
			attributeValueMap: {}
		},
		CASA_ANZ_FIRM_B99: {
			description: "Number of companies in unknown economic sector",
			attributeValueMap: {}
		},
		CASA_ANZ_SHOPS: {
			description: "number of branches belonging to chains",
			attributeValueMap: {}
		},
		CASA_ANZ_GEWERBE: {
			description: "sum of companies and branches corresponds to the number of commercial units",
			attributeValueMap: {}
		},
		CASA_FIRM_C: {
			description: "number of marketing able companies with 1 up to 4 employees",
			attributeValueMap: {}
		},
		CASA_FIRM_B: {
			description: "number of marketing able companies with 5 up to 49 employees",
			attributeValueMap: {}
		},
		CASA_FIRM_A: {
			description: "number of marketing able companies with 50 up to 499 employees",
			attributeValueMap: {}
		},
		CASA_FIRM_T: {
			description: "number of marketing able companies with 500 employees or more",
			attributeValueMap: {}
		},
		CASA_FIRM_U01: {
			description: "number of companies with revenue up to 499.999 Euro",
			attributeValueMap: {}
		},
		CASA_FIRM_U02: {
			description: "number of companies with revenue from 500.000 Euro to less than 5 M. Euro",
			attributeValueMap: {}
		},
		CASA_FIRM_U03: {
			description: "number of companies with revenue from 5 M. Euro to less than 50 M. Euro",
			attributeValueMap: {}
		},
		CASA_FIRM_U04: {
			description: "number of companies with revenue starting from 50 M. Euro",
			attributeValueMap: {}
		},
		CASA_CSD_ID: {
			description: "centre identification Shopping District",
			attributeValueMap: {}
		},
		CASA_CSD_KL: {
			description: "classification of the Shopping District",
			attributeValueMap: {
				"1": "small centre",
				"2": "sub-centre",
				"3": "medium centre",
				"4": "regional centre",
				"5": "mega centre",
				"-99": "is not located in any Shopping District"
			}
		},
		CASA_CSDI: {
			description: "Central Shopping District Index (1-1000)",
			attributeValueMap: {}
		},
		CASA_CSI: {
			description: "Central Street Index (1-100 within)\n(based on environmental factors of modern passenger frequency relevant to the retail trade)",
			attributeValueMap: {}
		},
		CASA_NCSI: {
			description: "National Central Street Index (1-1000 nationwide)\n(based on environmental factors of modern passenger frequency relevant to the retail trade)",
			attributeValueMap: {}
		},
		CASA_OZ_ID: {
			description: "ID of the regional centre to which refers the distance",
			attributeValueMap: {}
		},
		CASA_OZ_DIST: {
			description: "distance to the next regional centre (in metres)",
			attributeValueMap: {
				"0": "is located in the regional centre",
				"over 0": "distance to the next regional centre"
			}
		},
		CASA_MZ_ID: {
			description: "ID of the medium centre to which refers the distance",
			attributeValueMap: {}
		},
		CASA_MZ_DIST: {
			description: "distance to the next medium centre (in metres)",
			attributeValueMap: {
				"0": "is located in the medium centre",
				"over 0": "distance to the next medium centre"
			}
		},
		CASA_UZ_ID: {
			description: "ID of the sub-centre to which refers the distance",
			attributeValueMap: {}
		},
		CASA_UZ_DIST: {
			description: "distance to the next sub-centre (in metres)",
			attributeValueMap: {
				"0": "is located in the sub-centre",
				"over 0": "distance to the next sub-centre"
			}
		},
		CASA_CSD_DIST: {
			description: "distance to the next centre (in metres)",
			attributeValueMap: {}
		},
		CBD_ID: {
			description: "ID of the Business District",
			attributeValueMap: {}
		},
		CBD_KL: {
			description: "classification of the Business District",
			attributeValueMap: {
				"1": "weak",
				"2": "rather weak",
				"3": "medium",
				"4": "rather strong",
				"5": "strong",
				"-99": "is not located in any Business District"
			}
		},
		CBDI: {
			description: "Central Business District Index (1-100)",
			attributeValueMap: {}
		},
		CBD_FLAECHE: {
			description: "area of the Central Business District",
			attributeValueMap: {}
		},
		CBD_ANZMA: {
			description: "number of employees of the Central Business District",
			attributeValueMap: {}
		},
		CBD_FIRM: {
			description: "number of companies of the Central Business District",
			attributeValueMap: {}
		},
		IGG_ID: {
			description: "ID of the industrial and commercial area",
			attributeValueMap: {}
		},
		IGG_KL: {
			description: "classification of the industrial and commercial area",
			attributeValueMap: {
				"1": "weak",
				"2": "rather weak",
				"3": "medium",
				"4": "rather strong",
				"5": "strong",
				"-99": "is not located in any industrial / commercial area"
			}
		},
		IGG_INDEX: {
			description: "index value of the classification (0-1000)",
			attributeValueMap: {}
		},
		IGG_BE_KL: {
			description: "number of employees in the industrial and commercial area (in classes)",
			attributeValueMap: {
				"1": "upt to 100 employees",
				"2": "over 100 up to 250 employees",
				"3": "over 250 up to 500 employees",
				"4": "over 500 up to 1.000 employees",
				"5": "over 1.000 employees",
				"-99": "is not located in any industrial / commercial area"
			}
		},
		IGG_FIRMEN: {
			description: "number of companies in the industrial and commercial area",
			attributeValueMap: {}
		},
		IGG_FILIALEN: {
			description: "number of stores in the industrial and commercial area",
			attributeValueMap: {}
		},
		IGG_GEWERBE: {
			description: "number of commercial units in the industrial and commercial area",
			attributeValueMap: {}
		},
		IGG_FLAECHE: {
			description: "area of the industrial and commercial area (in square metres)",
			attributeValueMap: {}
		},
		IGG_BE_MAIN_BR: {
			description: "predominant industry of the industrial and commercial area (referring to employees)",
			attributeValueMap: {
				"1": "agriculture, forestry and fisheries",
				"2": "raw material extraction",
				"3": "building industry",
				"4": "manufacturing industry",
				"5": "traffic and energy",
				"6": "trade",
				"7": "financial and insurance services",
				"8": "service",
				"9": "public administration",
				"10": "mixed",
				"99": "not specified",
				"-99": "is not located in any industrial / commercial area"
			}
		},
		IGG_BE_BR_01: {
			valueType: "percentage",
			description: "share (referring to employees) (referring to employees) of industry 'agriculture, forestry and fisheries' in the industrial and commercial area",
			attributeValueMap: {}
		},
		IGG_BE_BR_02: {
			valueType: "percentage",
			description: "share (referring to employees) (referring to employees) of industry 'raw material extraction' in the industrial and commercial area",
			attributeValueMap: {}
		},
		IGG_BE_BR_03: {
			valueType: "percentage",
			description: "share (referring to employees) of industry 'building industry' in the industrial and commercial area",
			attributeValueMap: {}
		},
		IGG_BE_BR_04: {
			valueType: "percentage",
			description: "share (referring to employees) of industry ' manufacturing industry' in the industrial and commercial area",
			attributeValueMap: {}
		},
		IGG_BE_BR_05: {
			valueType: "percentage",
			description: "share (referring to employees) of industry 'traffic and energy' in the industrial and commercial area",
			attributeValueMap: {}
		},
		IGG_BE_BR_06: {
			valueType: "percentage",
			description: "share (referring to employees) of industry 'trade' in the industrial and commercial area",
			attributeValueMap: {}
		},
		IGG_BE_BR_07: {
			valueType: "percentage",
			description: "share (referring to employees) of industry 'financial and insurance services' in the industrial and commercial area",
			attributeValueMap: {}
		},
		IGG_BE_BR_08: {
			valueType: "percentage",
			description: "share (referring to employees) of industry 'service' in the industrial and commercial area",
			attributeValueMap: {}
		},
		IGG_BE_BR_09: {
			valueType: "percentage",
			description: "share (referring to employees) of industry 'public administration' in the industrial and commercial area",
			attributeValueMap: {}
		},
		IGG_BE_BR_99: {
			valueType: "percentage",
			description: "share (referring to employees) of industry 'unknown'  in the industrial and commercial area",
			attributeValueMap: {}
		},
		IGG_FI_MAIN_BR: {
			description: "predominant industry of the industrial and commercial area (referring to companies)",
			attributeValueMap: {
				"1": "agriculture, forestry and fisheries",
				"2": "raw material extraction",
				"3": "building industry",
				"4": "manufacturing industry",
				"5": "traffic and energy",
				"6": "trade",
				"7": "financial and insurance services",
				"8": "service",
				"9": "public administration",
				"10": "mixed",
				"11": "branches belonging to chains",
				"99": "not specified",
				"-99": "is not located in any industrial / commercial area"
			}
		},
		IGG_FI_BR_01: {
			valueType: "percentage",
			description: "share (referring to companies) of industry 'agriculture, forestry and fisheries' in the industrial and commercial area",
			attributeValueMap: {}
		},
		IGG_FI_BR_02: {
			valueType: "percentage",
			description: "share (referring to companies) of industry 'raw material extraction' in the industrial and commercial area",
			attributeValueMap: {}
		},
		IGG_FI_BR_03: {
			valueType: "percentage",
			description: "share (referring to companies) of industry 'building industry' in the industrial and commercial area",
			attributeValueMap: {}
		},
		IGG_FI_BR_04: {
			valueType: "percentage",
			description: "share (referring to companies) of industry ' manufacturing industry' in the industrial and commercial area ",
			attributeValueMap: {}
		},
		IGG_FI_BR_05: {
			valueType: "percentage",
			description: "share (referring to companies) of industry 'traffic and energy' in the industrial and commercial area",
			attributeValueMap: {}
		},
		IGG_FI_BR_06: {
			valueType: "percentage",
			description: "share (referring to companies) of industry 'trade' in the industrial and commercial area",
			attributeValueMap: {}
		},
		IGG_FI_BR_07: {
			valueType: "percentage",
			description: "share (referring to companies) of industry 'financial and insurance services' in the industrial and commercial area",
			attributeValueMap: {}
		},
		IGG_FI_BR_08: {
			valueType: "percentage",
			description: "share (referring to companies) of industry 'service' in the industrial and commercial area",
			attributeValueMap: {}
		},
		IGG_FI_BR_09: {
			valueType: "percentage",
			description: "share (referring to companies) of industry 'public administration' in the industrial and commercial area",
			attributeValueMap: {}
		},
		IGG_FI_BR_99: {
			valueType: "percentage",
			description: "share (referring to companies) of industry 'unknown'  in the industrial and commercial area",
			attributeValueMap: {}
		},
		CASA_EG_SCORE: {
			description: "unbekannt",
			attributeValueMap: {
				"1": "no probability",
				"9": "very high probability",
				"-99": "not specified"
			}
		},
		CASA_GAME_SCORE: {
			description: "gamers",
			attributeValueMap: {
				"1": "no affinity",
				"9": "very high affinity",
				"-99": "not specified"
			}
		},
		CASA_SMHOME_SCORE: {
			description: "smart home users",
			attributeValueMap: {
				"1": "no affinity",
				"9": "very high affinity",
				"-99": "not specified"
			}
		},
		CASA_STREAM_SCORE: {
			description: "streamers ",
			attributeValueMap: {
				"1": "no affinity",
				"9": "very high affinity",
				"-99": "not specified"
			}
		},
		CASA_ONLINE_SCORE: {
			description: "online shoppers",
			attributeValueMap: {
				"1": "no affinity",
				"9": "very high affinity",
				"-99": "not specified"
			}
		},
		CASA_OFFLINE_SCORE: {
			description: "offline shoppers",
			attributeValueMap: {
				"1": "no affinity",
				"9": "very high affinity",
				"-99": "not specified"
			}
		},
		CASA_KATALOG_SCORE: {
			description: "catalogue shoppers",
			attributeValueMap: {
				"1": "no affinity",
				"9": "very high affinity",
				"-99": "not specified"
			}
		},
		CASA_TV_SCORE: {
			description: "TV shoppers",
			attributeValueMap: {
				"1": "no affinity",
				"9": "very high affinity",
				"-99": "not specified"
			}
		},
		CASA_ONLNAHR_SCORE: {
			description: "food online shoppers",
			attributeValueMap: {
				"1": "no affinity",
				"9": "very high affinity",
				"-99": "not specified"
			}
		},
		CASA_EAUTO_SCORE: {
			description: "electric vehicle",
			attributeValueMap: {
				"1": "no affinity",
				"9": "very high affinity",
				"-99": "not specified"
			}
		},
		CASA_CARSH_SCORE: {
			description: "car sharing",
			attributeValueMap: {
				"1": "no affinity",
				"9": "very high affinity",
				"-99": "not specified"
			}
		},
		CASA_EBIKE_SCORE: {
			description: "e-bike",
			attributeValueMap: {
				"1": "no affinity",
				"9": "very high affinity",
				"-99": "not specified"
			}
		},
		CASA_KAUF_PREIS_SCORE: {
			description: "price affinity with purchase decisions",
			attributeValueMap: {
				"1": "no affinity",
				"9": "very high affinity",
				"-99": "not specified"
			}
		},
		CASA_KAUF_MARKE_SCORE: {
			description: "brand affinity with purchase decisions",
			attributeValueMap: {
				"1": "no affinity",
				"9": "very high affinity",
				"-99": "not specified"
			}
		},
		CASA_KAUF_REGIO_SCORE: {
			description: "affinity for regionality with purchase decisions",
			attributeValueMap: {
				"1": "no affinity",
				"9": "very high affinity",
				"-99": "not specified"
			}
		},
		CASA_KAUF_NACHHALTIG_SCORE: {
			description: "affinity for sustainability with purchase decisions",
			attributeValueMap: {
				"1": "no affinity",
				"9": "very high affinity",
				"-99": "not specified"
			}
		},
		CASA_STRMWECHSL_SCORE: {
			description: "affinity for switching electric providers",
			attributeValueMap: {
				"1": "no affinity",
				"9": "very high affinity",
				"-99": "not specified"
			}
		},
		CASA_STRMWECHSLHFKT: {
			description: "affinity for frequently switching electric providers",
			attributeValueMap: {
				"1": "no affinity",
				"3": "very high affinity",
				"-99": "not specified"
			}
		},
		CASA_ERNENE_SCORE: {
			description: "Renewable energy",
			attributeValueMap: {
				"1": "no affinity",
				"3": "very high affinity",
				"-99": "not specified"
			}
		},
		CASA_NACHHAL_SCORE: {
			description: "Sustainability",
			attributeValueMap: {
				"1": "no affinity",
				"9": "very high affinity",
				"-99": "not specified"
			}
		},
		CASA_SANABS_SCORE: {
			description: "Restructuring",
			attributeValueMap: {
				"1": "no affinity",
				"9": "very high affinity",
				"-99": "not specified"
			}
		},
		CASA_FITNESS_SCORE: {
			description: "Fitness",
			attributeValueMap: {
				"1": "no affinity",
				"9": "very high affinity",
				"-99": "not specified"
			}
		},
		CASA_ONLTIER_SCORE: {
			description: "buying pet food and nonfood online",
			attributeValueMap: {
				"1": "no affinity",
				"9": "very high affinity",
				"-99": "not specified"
			}
		},
		CASA_OFFTIER_SCORE: {
			description: "buying pet food and nonfood offline",
			attributeValueMap: {
				"1": "no affinity",
				"9": "very high affinity",
				"-99": "not specified"
			}
		},
		CASA_WK_DOM: {
			description: "dominant concept of living",
			attributeValueMap: {
				"1": "demanding",
				"2": "modest",
				"3": "functional",
				"4": "domestic",
				"5": "communicative",
				"6": "conventional",
				"7": "gemischt",
				"-99": "not specified"
			}
		},
		CASA_WK1_ANT: {
			description: "probability for beeing a demanding concept of living",
			attributeValueMap: {}
		},
		CASA_WK2_ANT: {
			description: "probability for beeing a modest concept of living",
			attributeValueMap: {}
		},
		CASA_WK3_ANT: {
			description: "probability for beeing a functional concept of living",
			attributeValueMap: {}
		},
		CASA_WK4_ANT: {
			description: "probability for beeing a domestic concept of living",
			attributeValueMap: {}
		},
		CASA_WK5_ANT: {
			description: "probability for beeing a communivative concept of living",
			attributeValueMap: {}
		},
		CASA_WK6_ANT: {
			description: "probability for beeing a conventional concept of living",
			attributeValueMap: {}
		},
		CASA_NACHHAL_DOM: {
			description: "dominant sustainability segment",
			attributeValueMap: {
				"1": "low sustainability, low to medium income, big city",
				"2": "medium to low sustainability, medium to high income, medium city",
				"3": "high sustainability, medium to high income, medium city",
				"4": "low sustainability, medium to high income, small city",
				"5": "high sustainability, low to medium income, big city",
				"6": "mixed",
				"-99": "not specified"
			}
		},
		CASA_LIMBIC_DOM: {
			description: "dominant limbic type",
			attributeValueMap: {
				"1": "harmoniser",
				"2": "traditionalist",
				"3": "disciplinrf",
				"4": "open",
				"5": "hedonist",
				"6": "performer",
				"7": "adventurer"
			}
		},
		CASA_LIMBIC1_ANT: {
			description: "probability for beeing a harmonising limbic type",
			attributeValueMap: {}
		},
		CASA_LIMBIC2_ANT: {
			description: "probability for beeing a traditionalistic limbic type",
			attributeValueMap: {}
		},
		CASA_LIMBIC3_ANT: {
			description: "probability for beeing a disciplined limbic type",
			attributeValueMap: {}
		},
		CASA_LIMBIC4_ANT: {
			description: "probability for beeing a open limbic type",
			attributeValueMap: {}
		},
		CASA_LIMBIC5_ANT: {
			description: "probability for beeing a hedonistic limbic type",
			attributeValueMap: {}
		},
		CASA_LIMBIC6_ANT: {
			description: "probability for beeing a performing limbic type",
			attributeValueMap: {}
		},
		CASA_LIMBIC7_ANT: {
			description: "probability for beeing a adventuring limbic type",
			attributeValueMap: {}
		},
		BBFG_ANZ_ANS: {
			description: "number of connections",
			attributeValueMap: {}
		},
		BBFG_AS: {
			description: "applicant of broadband support area",
			attributeValueMap: {}
		},
		BBFG_BEV: {
			description: "population of municipality/city",
			attributeValueMap: {}
		},
		BBFG_BEVDENS: {
			description: "population density of municipality/city",
			attributeValueMap: {}
		},
		BBFG_FLAE: {
			description: "area of broadband support area in km²",
			attributeValueMap: {}
		},
		BBFG_FM: {
			description: "support model",
			attributeValueMap: {
				"1": "expansion with operator model",
				"2": "covering an economical gap",
				"-99": "not specified"
			}
		},
		BBFG_FS: {
			description: "state payment amount",
			attributeValueMap: {}
		},
		BBFG_ID: {
			description: "unique id of broadband support area",
			attributeValueMap: {}
		},
		BBFG_PROF: {
			description: "benefiting municipality/city of broadband support area",
			attributeValueMap: {}
		},
		BBFG_ST: {
			description: "status",
			attributeValueMap: {
				"1": "in operation",
				"2": "application",
				"3": "building phase",
				"-99": "not specified"
			}
		},
		BBFG_TECH: {
			description: "technology",
			attributeValueMap: {
				"1": "FTTB/H",
				"2": "Vectoring",
				"3": "FTTB/H and Vectoring",
				"4": "CATV",
				"-99": "not specified"
			}
		},
		BBFG_ZSG: {
			description: "contractor",
			attributeValueMap: {}
		},
		CASA_VERF_ALLTECH_1000MBIT: {
			description: "private broadband availability in % of households - all technologies >= 1000 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_ALLTECH_100MBIT: {
			description: "private broadband availability in % of households - all technologies >= 100 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_ALLTECH_10MBIT: {
			description: "private broadband availability in % of households - all technologies >= 10 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_ALLTECH_16MBIT: {
			description: "private broadband availability in % of households - all technologies >= 16 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_ALLTECH_200MBIT: {
			description: "private broadband availability in % of households - all technologies >= 200 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_ALLTECH_30MBIT: {
			description: "private broadband availability in % of households - all technologies >= 30 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_ALLTECH_400MBIT: {
			description: "private broadband availability in % of households - all technologies >= 400 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_ALLTECH_50MBIT: {
			description: "private broadband availability in % of households - all technologies >= 50 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_BUNDF_GEB: {
			description: "Federal funding (regions) State 2020.03.06",
			attributeValueMap: { "1": "yes" }
		},
		CASA_VERF_CATV_1000MBIT: {
			description: "private broadband availability in % of households - CATV >= 1000 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_CATV_100MBIT: {
			description: "private broadband availability in % of households - CATV >= 100 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_CATV_10MBIT: {
			description: "private broadband availability in % of households - CATV >= 10 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_CATV_16MBIT: {
			description: "private broadband availability in % of households - CATV >= 16 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_CATV_200MBIT: {
			description: "private broadband availability in % of households - CATV >= 200 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_CATV_30MBIT: {
			description: "private broadband availability in % of households - CATV >= 30 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_CATV_400MBIT: {
			description: "private broadband availability in % of households - CATV >= 400 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_CATV_50MBIT: {
			description: "private broadband availability in % of households - CATV >= 50 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_FTTH_B: {
			description: "private broadband availability in % of households - FFTH / FFTB >= 1000 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_GEW_AREA_STATUS: {
			description: "commercial area connected to glass fiber",
			attributeValueMap: {
				"0": "not connected",
				"1": "connected",
				"-99": "not specified"
			}
		},
		CASA_VERF_GEW_CATV_1000MBIT: {
			description: "private broadband availability in % of households - Cable TV >= 1000 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_GEW_CATV_100MBIT: {
			description: "private broadband availability in % of households - Cable TV >= 100 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_GEW_CATV_10MBIT: {
			description: "private broadband availability in % of households - Cable TV >= 10 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_GEW_CATV_16MBIT: {
			description: "private broadband availability in % of households - Cable TV >= 16 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_GEW_CATV_200MBIT: {
			description: "private broadband availability in % of households - Cable TV >= 200 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_GEW_CATV_30MBIT: {
			description: "private broadband availability in % of households - Cable TV >= 30 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_GEW_CATV_400MBIT: {
			description: "private broadband availability in % of households - Cable TV >= 400 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_GEW_CATV_50MBIT: {
			description: "private broadband availability in % of households - Cable TV >= 50 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_GEW_GLAS_1000MBIT: {
			description: "commercial broadband availability - glass fiber >= 1000 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_GEW_KABEL_1000MBIT: {
			description: "commercial broadband availability - cable >= 1000 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_GEW_KABEL_100MBIT: {
			description: "commercial broadband availability - cable >= 100 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_GEW_KABEL_10MBIT: {
			description: "commercial broadband availability - cable >= 10 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_GEW_KABEL_16MBIT: {
			description: "commercial broadband availability - cable >= 16 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_GEW_KABEL_200MBIT: {
			description: "commercial broadband availability - cable >= 200 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_GEW_KABEL_30MBIT: {
			description: "commercial broadband availability - cable >= 30 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_GEW_KABEL_400MBIT: {
			description: "commercial broadband availability - cable >= 400 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_GEW_KABEL_50MBIT: {
			description: "commercial broadband availability - cable >= 50 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_GEW_STANDARD_100MBIT: {
			description: "commercial broadband availability - DSL >= 100 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_GEW_STANDARD_10MBIT: {
			description: "commercial broadband availability - DSL >= 10 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_GEW_STANDARD_16MBIT: {
			description: "commercial broadband availability - DSL >= 16 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_GEW_STANDARD_200MBIT: {
			description: "commercial broadband availability - DSL >= 200 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_GEW_STANDARD_30MBIT: {
			description: "commercial broadband availability - DSL >= 30 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_GEW_STANDARD_50MBIT: {
			description: "commercial broadband availability - DSL >= 50 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_KABEL_1000MBIT: {
			description: "private broadband availability in % of households - wired >= 1000 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_KABEL_100MBIT: {
			description: "private broadband availability in % of households - wired >= 100 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_KABEL_10MBIT: {
			description: "private broadband availability in % of households - wired >= 10 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_KABEL_16MBIT: {
			description: "private broadband availability in % of households - wired >= 16 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_KABEL_200MBIT: {
			description: "private broadband availability in % of households - wired >= 200 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_KABEL_30MBIT: {
			description: "private broadband availability in % of households - wired >= 30 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_KABEL_400MBIT: {
			description: "private broadband availability in % of households - wired >= 400 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_KABEL_50MBIT: {
			description: "private broadband availability in % of households - wired >= 50 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_MOB_2G_ANB_FL: {
			description: "Number of 2G providers, layer of aggregation: area",
			attributeValueMap: {}
		},
		CASA_VERF_MOB_2G_ANB_TN: {
			description: "Number of 2G providers, layer of aggregation: member related",
			attributeValueMap: {}
		},
		CASA_VERF_MOB_2G_FL: {
			description: "Availability 2G, layer of aggregation: area",
			attributeValueMap: {
				"0": "not availale",
				"1": "available"
			}
		},
		CASA_VERF_MOB_2G_TN: {
			description: "Availability 2G, layer of aggregation: member related",
			attributeValueMap: {
				"0": "not availale",
				"1": "available"
			}
		},
		CASA_VERF_MOB_5G_ANB_FL: {
			description: "Number of 5G providers, layer of aggregation: area",
			attributeValueMap: {}
		},
		CASA_VERF_MOB_5G_ANB_TN: {
			description: "Number of 5G providers, layer of aggregation: member related",
			attributeValueMap: {}
		},
		CASA_VERF_MOB_5G_DSS_ANB_FL: {
			description: "Number of 5G_DSS providers, layer of aggregation: area",
			attributeValueMap: {}
		},
		CASA_VERF_MOB_5G_DSS_ANB_TN: {
			description: "Number of 5G_DSS providers, layer of aggregation: member related",
			attributeValueMap: {}
		},
		CASA_VERF_MOB_5G_DSS_FL: {
			description: "Availability 5G_DSS, layer of aggregation: area",
			attributeValueMap: {
				"0": "not availale",
				"1": "available"
			}
		},
		CASA_VERF_MOB_5G_DSS_TN: {
			description: "Availability 5G_DSS, layer of aggregation: member related",
			attributeValueMap: {
				"0": "not availale",
				"1": "available"
			}
		},
		CASA_VERF_MOB_5G_FL: {
			description: "Availability 5G, layer of aggregation: area",
			attributeValueMap: {
				"0": "not availale",
				"1": "available"
			}
		},
		CASA_VERF_MOB_5G_TN: {
			description: "Availability 5G, layer of aggregation: member related",
			attributeValueMap: {
				"0": "not availale",
				"1": "available"
			}
		},
		CASA_VERF_MOB_LTE_ANB_FL: {
			description: "Number of LTE providers, layer of aggregation: area",
			attributeValueMap: {}
		},
		CASA_VERF_MOB_LTE_ANB_TN: {
			description: "Number of LTE providers, layer of aggregation: member related",
			attributeValueMap: {}
		},
		CASA_VERF_MOB_LTE_FL: {
			description: "Availability LTE, layer of aggregation: area",
			attributeValueMap: {
				"0": "not availale",
				"1": "available"
			}
		},
		CASA_VERF_MOB_LTE_TN: {
			description: "Availability LTE, layer of aggregation: member related",
			attributeValueMap: {
				"0": "not availale",
				"1": "available"
			}
		},
		CASA_VERF_STANDARD_100MBIT: {
			description: "private broadband availability in % of households - DSL >= 100 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_STANDARD_10MBIT: {
			description: "private broadband availability in % of households - DSL >= 10 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_STANDARD_16MBIT: {
			description: "private broadband availability in % of households - DSL >= 16 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_STANDARD_200MBIT: {
			description: "private broadband availability in % of households - DSL >= 200 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_STANDARD_30MBIT: {
			description: "private broadband availability in % of households - DSL >= 30 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		CASA_VERF_STANDARD_50MBIT: {
			description: "private broadband availability in % of households - DSL >= 50 Mbit/s",
			attributeValueMap: {
				"1": "up to 10%",
				"2": "over 10% up to 50%%",
				"3": "over 50% up to 75%",
				"4": "over 75% up to 95%",
				"5": "over 95% up to 100%",
				"-99": "not specified"
			}
		},
		"Anbieter_***": {
			description: "available broadband providers",
			attributeValueMap: {}
		},
		"Technologie_***": {
			description: "available technologies",
			attributeValueMap: {}
		},
		STR_PKW_DICHTE: {
			description: "car density by households",
			attributeValueMap: {
				0: "no cars",
				1: "low",
				2: "medium",
				3: "high",
				"-99": "not specified"
			}
		},
		KR_SDMS: {
			description: "monthly total sunshine duration",
			attributeValueMap: {}
		},
		PLZ5_SQ_AW: {
			valueType: "percentage",
			description: "renovation rate per year - outer wall insulation",
			attributeValueMap: {}
		},
		PLZ5_SQ_DD: {
			valueType: "percentage",
			description: "renovation rate per year - heating",
			attributeValueMap: {}
		},
		PLZ5_SQ_EH: {
			valueType: "percentage",
			description: "renovation rate per year - roof insulation",
			attributeValueMap: {}
		},
		PLZ5_SQ_FT: {
			valueType: "percentage",
			description: "renovation rate per year - windows and doors",
			attributeValueMap: {}
		},
		STR_KBA_KR3: {
			description: "portfolio -  private cars with fuel type “electric”",
			attributeValueMap: {}
		},
		STR_PKW_ANZ: {
			description: "portfolio -  private cars",
			attributeValueMap: {}
		},
		GEM_EW25_ANZ: {
			description: "population forecast - inhabitants in the year 2025",
			attributeValueMap: {}
		},
		GEM_EW30_ANZ: {
			description: "population forecast - inhabitants in the year 2030",
			attributeValueMap: {}
		},
		GEM_EW35_ANZ: {
			description: "population forecast - inhabitants in the year 2035",
			attributeValueMap: {}
		},
		GEM_EW40_ANZ: {
			description: "population forecast - inhabitants in the year 2040",
			attributeValueMap: {}
		},
		STR_KBA_SEG1: {
			description: "portfolio segment cars - minis",
			attributeValueMap: {}
		},
		STR_KBA_SEG2: {
			description: "portfolio segment cars - small cars",
			attributeValueMap: {}
		},
		STR_KBA_SEG3: {
			description: "portfolio segment cars - compact cars",
			attributeValueMap: {}
		},
		STR_KBA_SEG4: {
			description: "portfolio segment cars - mid-range cars",
			attributeValueMap: {}
		},
		STR_KBA_SEG5: {
			description: "portfolio segment cars - mid-size executive cars",
			attributeValueMap: {}
		},
		STR_KBA_SEG6: {
			description: "portfolio segment cars - large executive cars",
			attributeValueMap: {}
		},
		STR_KBA_SEG7: {
			description: "portfolio segment cars - SUV",
			attributeValueMap: {}
		},
		STR_KBA_SEG8: {
			description: "portfolio segment cars  - off-road vehicles",
			attributeValueMap: {}
		},
		STR_KBA_SEG9: {
			description: "portfolio segment cars - sports cars",
			attributeValueMap: {}
		},
		STR_KBA_SEG10: {
			description: "portfolio segment cars - mini-vans",
			attributeValueMap: {}
		},
		STR_KBA_SEG11: {
			description: "portfolio segment cars - large-sized vans",
			attributeValueMap: {}
		},
		STR_KBA_SEG12: {
			description: "portfolio segment cars - utilities",
			attributeValueMap: {}
		}
	};
	infasResponseToSheetKey = {
		Id: "ID",
		Oi: "OI",
		Hnr: "HNR",
		Ort: "ORT",
		Ot1: "OT1",
		Ot2: "OT2",
		Plz: "PLZ",
		Stn: "STN",
		Ags2: "AGS2",
		Ags3: "AGS3",
		Ags5: "AGS5",
		Ags8: "AGS8",
		Hnrz: "HNRZ",
		Ortz: "ORTZ",
		TkOi: "TK_OI",
		Ags11: "AGS11",
		Ags13: "AGS13",
		Ags16: "AGS16",
		Ags20: "AGS20",
		Ags22: "AGS22",
		Ags24: "AGS24",
		Ags27: "AGS27",
		CasaEw: "CASA_EW",
		CasaHh: "CASA_HH",
		KrSdms: "KR_SDMS",
		OtAloQ: "OT_ALO_Q",
		OtKauf: "OT_KAUF",
		OtMiet: "OT_MIET",
		SbKauf: "SB_KAUF",
		SbMiet: "SB_MIET",
		CasaGas: "CASA_GAS",
		CasaNsp: "CASA_NSP",
		CasaNvi: "CASA_NVI",
		CasaOel: "CASA_OEL",
		CasaTyp: "CASA_TYP",
		CasaVol: "CASA_VOL",
		CasaWfl: "CASA_WFL",
		StrKkEw: "STR_KK_EW",
		StrKkHh: "STR_KK_HH",
		CasaBjKl: "CASA_BJ_KL",
		CasaEbKl: "CASA_EB_KL",
		CasaEvKl: "CASA_EV_KL",
		CasaFern: "CASA_FERN",
		CasaHhEa1: "CASA_HH_EA1",
		CasaHhEa2: "CASA_HH_EA2",
		CasaHhEa3: "CASA_HH_EA3",
		CasaHhEa4: "CASA_HH_EA4",
		CasaHhEa5: "CASA_HH_EA5",
		CasaHhEa6: "CASA_HH_EA6",
		CasaHhEa7: "CASA_HH_EA7",
		CasaSolJr: "CASA_SOL_JR",
		CasaSolNl: "CASA_SOL_NL",
		CasaSolar: "CASA_SOLAR",
		CasaSonst: "CASA_SONST",
		CasaWflKl: "CASA_WFL_KL",
		StrKbaKr3: "STR_KBA_KR3",
		CasaDachar: "CASA_DACHAR",
		CasaEnclKl: "CASA_ENCL_KL",
		CasaGarage: "CASA_GARAGE",
		CasaHhKind: "CASA_HH_KIND",
		CasaSozSch: "CASA_SOZ_SCH",
		CasaStrTyp: "CASA_STR_TYP",
		CasaWk1Ant: "CASA_WK1_ANT",
		CasaWk2Ant: "CASA_WK2_ANT",
		CasaWk3Ant: "CASA_WK3_ANT",
		CasaWk4Ant: "CASA_WK4_ANT",
		CasaWk5Ant: "CASA_WK5_ANT",
		CasaWk6Ant: "CASA_WK6_ANT",
		CasaWolage: "CASA_WOLAGE",
		StrLeerAnt: "STR_LEER_ANT",
		CasaAlterKl: "CASA_ALTER_KL",
		CasaGrundfl: "CASA_GRUNDFL",
		CasaHoeheKl: "CASA_HOEHE_KL",
		CasaOpnvIdx: "CASA_OPNV_IDX",
		CasaSoScore: "CASA_SO_SCORE",
		SbEwAuslAnt: "SB_EW_AUSL_ANT",
		SbEwAuslAnz: "SB_EW_AUSL_ANZ",
		CasaDachflKl: "CASA_DACHFL_KL",
		CasaGartenKl: "CASA_GARTEN_KL",
		CasaStockAnz: "CASA_STOCK_ANZ",
		CasaGrundflKl: "CASA_GRUNDFL_KL",
		CasaGrundstKl: "CASA_GRUNDST_KL",
		CasaHeizScore: "CASA_HEIZ_SCORE",
		CasaHhEinkKl1: "CASA_HH_EINK_KL1",
		CasaHhEinkKl2: "CASA_HH_EINK_KL2",
		CasaHhEinkKl3: "CASA_HH_EINK_KL3",
		CasaHhEinkKl4: "CASA_HH_EINK_KL4",
		CasaHhEinkKl5: "CASA_HH_EINK_KL5",
		CasaHhEinkKl6: "CASA_HH_EINK_KL6",
		CasaLimbicDom: "CASA_LIMBIC_DOM",
		OtNachfrageKl: "OT_NACHFRAGE_KL",
		SbAuslWeltAnz: "SB_AUSL_WELT_ANZ",
		CasaEautoScore: "CASA_EAUTO_SCORE",
		CasaLimbic1Ant: "CASA_LIMBIC1_ANT",
		CasaLimbic2Ant: "CASA_LIMBIC2_ANT",
		CasaLimbic3Ant: "CASA_LIMBIC3_ANT",
		CasaLimbic4Ant: "CASA_LIMBIC4_ANT",
		CasaLimbic5Ant: "CASA_LIMBIC5_ANT",
		CasaLimbic6Ant: "CASA_LIMBIC6_ANT",
		CasaLimbic7Ant: "CASA_LIMBIC7_ANT",
		SbAuslSonstAnz: "SB_AUSL_SONST_ANZ",
		CasaErneneScore: "CASA_ERNENE_SCORE",
		CasaSanabsScore: "CASA_SANABS_SCORE",
		CasaSmhomeScore: "CASA_SMHOME_SCORE",
		SbAuslEuro27Anz: "SB_AUSL_EURO27_ANZ",
		CasaNachhalScore: "CASA_NACHHAL_SCORE",
		SbAuslEusonstAnz: "SB_AUSL_EUSONST_ANZ",
		CasaHh1p: "CASA_HH_1P",
		CasaHh2p: "CASA_HH_2P",
		CasaHh3p: "CASA_HH_3P",
		CasaHh4p: "CASA_HH_4P",
		CasaHh5p: "CASA_HH_5P",
		AnzGebHeiztyp1: "ANZ_GEB_HEIZTYP_1",
		CasaAnzWohneinheit: "CASA_ANZ_WOHNEINHEITEN",
		Plz5SqAw: "PLZ5_SQ_AW",
		Plz5SqDd: "PLZ5_SQ_DD",
		Plz5SqEh: "PLZ5_SQ_EH",
		Plz5SqFt: "PLZ5_SQ_FT",
		STR_KBA_KR3: "STR_KBA_KR3",
		StrPkwAnz: "STR_PKW_ANZ",
		GemEw25Anz: "GEM_EW25_ANZ",
		GemEw30Anz: "GEM_EW30_ANZ",
		GemEw35Anz: "GEM_EW35_ANZ",
		GemEw40Anz: "GEM_EW40_ANZ",
		StrKbaSeg1: "STR_KBA_SEG1",
		StrKbaSeg2: "STR_KBA_SEG2",
		StrKbaSeg3: "STR_KBA_SEG3",
		StrKbaSeg4: "STR_KBA_SEG4",
		StrKbaSeg5: "STR_KBA_SEG5",
		StrKbaSeg6: "STR_KBA_SEG6",
		StrKbaSeg7: "STR_KBA_SEG7",
		StrKbaSeg8: "STR_KBA_SEG8",
		StrKbaSeg9: "STR_KBA_SEG9",
		StrKbaSeg10: "STR_KBA_SEG10",
		StrKbaSeg11: "STR_KBA_SEG11",
		StrKbaSeg12: "STR_KBA_SEG12",
		StrPkwDichte: "STR_PKW_DICHTE",
		CasaOnlineScore: "CASA_ONLINE_SCORE",
		CasaOnlnahrScore: "CASA_ONLNAHR_SCORE",
		CasaStrmwechslScore: "CASA_STRMWECHSL_SCORE",
		CasaKaufNachhaltigScore: "CASA_KAUF_NACHHALTIG_SCORE",
		CasaWhPreisKl: "CASA_WH_PREIS_KL",
		CasaAnzGewerbe: "CASA_ANZ_GEWERBE",
		CasaAnzShops: "CASA_ANZ_SHOPS",
		CasaBasistyp: "CASA_BASISTYP",
		CasaDistBush: "CASA_DIST_BUSH",
		CasaHhEinkKl: "CASA_HH_EINK_KL",
		CasaOrtslage: "CASA_ORTSLAGE",
		CasaDistBhf: "CASA_DIST_BHF",
		CasaAnzFirm: "CASA_ANZ_FIRM"
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/infas/infas-attribute.helper.ts
var getInfasParamDetailFromResponseKey, getFormattedValueFromInfasResponseKey, getInfasExternalData;
var init_infas_attribute_helper = __esmMin((() => {
	init_external_data();
	init_infas_attribute_map();
	getInfasParamDetailFromResponseKey = (key) => {
		const sheetKey = infasResponseToSheetKey[key];
		return {
			sheetKey,
			description: infasAttributeMap[sheetKey]?.description ?? "",
			attributeValueMap: infasAttributeMap[sheetKey]?.attributeValueMap ?? {},
			valueType: infasAttributeMap[sheetKey]?.valueType ?? "number"
		};
	};
	getFormattedValueFromInfasResponseKey = (key, value) => {
		const { attributeValueMap, valueType } = getInfasParamDetailFromResponseKey(key);
		if (valueType === "percentage") return `${value}%`;
		if (!isEmpty(attributeValueMap)) {
			const attributeValue = attributeValueMap[value];
			return attributeValue !== void 0 ? attributeValue : value;
		}
		return value;
	};
	getInfasExternalData = (externalData = []) => externalData.find((data) => data.source === "Infas360" && data.type === "Attributes");
}));
//#endregion
//#region src/domains/cross-cutting/mfh/area-quality.model.ts
var init_area_quality_model = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/open-question/open-question.model.ts
var OpenQuestionStatus, OpenQuestionTopic, OpenQuestionPriority;
var init_open_question_model = __esmMin((() => {
	OpenQuestionStatus = /* @__PURE__ */ function(OpenQuestionStatus) {
		OpenQuestionStatus["Open"] = "Open";
		OpenQuestionStatus["Asked"] = "Asked";
		OpenQuestionStatus["AnswerReceived"] = "AnswerReceived";
		OpenQuestionStatus["AnswerReviewed"] = "AnswerReviewed";
		OpenQuestionStatus["ReviewedCritical"] = "ReviewedCritical";
		OpenQuestionStatus["ReviewedPendingClarification"] = "ReviewedPendingClarification";
		return OpenQuestionStatus;
	}({});
	OpenQuestionTopic = /* @__PURE__ */ function(OpenQuestionTopic) {
		OpenQuestionTopic["LandSituation"] = "LandSituation";
		OpenQuestionTopic["BuildingDocuments"] = "BuildingDocuments";
		OpenQuestionTopic["RentalContractDocuments"] = "RentalContractDocuments";
		OpenQuestionTopic["ObjectManagement"] = "ObjectManagement";
		OpenQuestionTopic["Litigation"] = "Litigation";
		OpenQuestionTopic["Authorities"] = "Authorities";
		OpenQuestionTopic["Tax"] = "Tax";
		OpenQuestionTopic["PurchasingContract"] = "PurchasingContract";
		OpenQuestionTopic["Other"] = "Other";
		return OpenQuestionTopic;
	}({});
	OpenQuestionPriority = /* @__PURE__ */ function(OpenQuestionPriority) {
		OpenQuestionPriority["Low"] = "Low";
		OpenQuestionPriority["Medium"] = "Medium";
		OpenQuestionPriority["High"] = "High";
		return OpenQuestionPriority;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/mfh/open-question/request.ts
var init_request = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/form/form-schema.model.ts
var FormSchema;
var init_form_schema_model = __esmMin((() => {
	FormSchema = /* @__PURE__ */ function(FormSchema) {
		FormSchema["DDOverview"] = "DDOverview";
		FormSchema["MfhDocumentChecklist"] = "MfhDocumentChecklist";
		FormSchema["SourcingTasksDD"] = "SourcingTasksDD";
		FormSchema["ObjectExaminationDD"] = "ObjectExaminationDD";
		FormSchema["VicinityExaminationDD"] = "VicinityExaminationDD";
		FormSchema["RentDD"] = "RentDD";
		FormSchema["TechnicalDD"] = "TechnicalDD";
		FormSchema["TechnicalOnSiteDD"] = "TechnicalOnSiteDD";
		FormSchema["LegalDD"] = "LegalDD";
		FormSchema["CommercialDD"] = "CommercialDD";
		FormSchema["DealClosingDD"] = "DealClosingDD";
		FormSchema["MfhDDv2"] = "MfhDDv2";
		return FormSchema;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/form/form-schema.opts.ts
var FormSchemaTranslation;
var init_form_schema_opts = __esmMin((() => {
	FormSchemaTranslation = {
		["DDOverview"]: "DD Overview",
		["MfhDocumentChecklist"]: "Documents Checklist",
		["SourcingTasksDD"]: "Sourcing Checklist",
		["ObjectExaminationDD"]: "Object Checklist",
		["VicinityExaminationDD"]: "Vicinity Checklist",
		["RentDD"]: "Rent Checklist",
		["TechnicalDD"]: "Technical Checklist",
		["TechnicalOnSiteDD"]: "Technical On Site Checklist",
		["LegalDD"]: "Legal Checklist",
		["CommercialDD"]: "Commercial Checklist",
		["DealClosingDD"]: "Deal Closing Checklist",
		["MfhDDv2"]: "Due Diligence"
	};
}));
//#endregion
//#region src/domains/cross-cutting/form/index.ts
var init_form = __esmMin((() => {
	init_form_schema_opts();
	init_form_schema_model();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/due-diligence/dd-answer-suggestion.model.ts
var DDAnswerSuggestionStatus, DDAnswerSuggestionConfidence, DDAnswerSuggestionCitationSchema, DDv2AiSourceSchema;
var init_dd_answer_suggestion_model = __esmMin((() => {
	DDAnswerSuggestionStatus = /* @__PURE__ */ function(DDAnswerSuggestionStatus) {
		DDAnswerSuggestionStatus["Pending"] = "Pending";
		DDAnswerSuggestionStatus["Accepted"] = "Accepted";
		DDAnswerSuggestionStatus["Dismissed"] = "Dismissed";
		return DDAnswerSuggestionStatus;
	}({});
	DDAnswerSuggestionConfidence = /* @__PURE__ */ function(DDAnswerSuggestionConfidence) {
		DDAnswerSuggestionConfidence["High"] = "high";
		DDAnswerSuggestionConfidence["Medium"] = "medium";
		DDAnswerSuggestionConfidence["Low"] = "low";
		return DDAnswerSuggestionConfidence;
	}({});
	DDAnswerSuggestionCitationSchema = Type.Object({
		page: Type.Number(),
		endPage: Type.Number(),
		quote: Type.String()
	}, { additionalProperties: false });
	DDv2AiSourceSchema = Type.Object({
		suggestionId: Type.Number(),
		documentId: Type.Number(),
		confidence: Type.Enum(DDAnswerSuggestionConfidence),
		citations: Type.Array(DDAnswerSuggestionCitationSchema),
		acceptedAt: Type.String(),
		acceptedBy: Type.Optional(Type.Union([Type.String(), Type.Null()])),
		/** The assessment as written on acceptance. Compared with the current one, it shows the answer was edited since. */
		acceptedAssessment: Type.String()
	}, { additionalProperties: false });
}));
//#endregion
//#region src/domains/cross-cutting/mfh/due-diligence/dd.generic.model.ts
var DocumentSchema, ContactSchema, genericDDAnswerSchema;
var init_dd_generic_model = __esmMin((() => {
	DocumentSchema = Type.Object({
		documentId: Type.Integer(),
		filename: Type.String(),
		link: Type.Optional(Type.String()),
		path: Type.Optional(Type.String())
	}, {
		required: ["documentId", "fileName"],
		additionalProperties: false,
		$id: "DocumentSchema"
	});
	ContactSchema = Type.Object({
		contactId: Type.Number(),
		salutation: Type.Optional(Type.Union([Type.String(), Type.Null()])),
		firstname: Type.Optional(Type.Union([Type.String(), Type.Null()])),
		lastname: Type.Optional(Type.Union([Type.String(), Type.Null()]))
	});
	genericDDAnswerSchema = Type.Object({
		start: Type.Optional(Type.Union([Type.String(), Type.Null()])),
		end: Type.Optional(Type.Union([Type.String(), Type.Null()])),
		status: Type.Optional(Type.Union([Type.String(), Type.Null()])),
		owner: Type.Optional(Type.Union([ContactSchema, Type.Null()])),
		documents: Type.Optional(Type.Union([Type.Array(DocumentSchema), Type.Null()])),
		source: Type.Optional(Type.Union([Type.String(), Type.Null()])),
		ddResult: Type.Optional(Type.Union([Type.String(), Type.Null()])),
		details: Type.Optional(Type.Union([Type.String(), Type.Null()])),
		risk: Type.Optional(Type.Union([Type.String(), Type.Null()])),
		purchasePriceReduction: Type.Optional(Type.Union([Type.String(), Type.Null()])),
		purchaseContractClause: Type.Optional(Type.Union([Type.String(), Type.Null()])),
		note: Type.Optional(Type.Union([Type.String(), Type.Null()])),
		externalNote: Type.Optional(Type.Union([Type.String(), Type.Null()]))
	}, { additionalProperties: false });
}));
//#endregion
//#region src/domains/cross-cutting/mfh/due-diligence/dd-v2.model.ts
var DDVersion, DDv2Category, DDv2Subcategory, DDv2Priority, DDv2BankabilityRelevance, DDv2DocumentCategory, DDv2AnswerStatus, DDv2ChecklistStatus, DDv2Risk, DDv2ActionPointTrack, DDv2ActionPointParty, ddV2ActionPointParties, TechDDCategory, DDv2CategoryTranslation, DDv2SubcategoryTranslation, DDv2PriorityTranslation, DDv2BankabilityRelevanceTranslation, DDv2DocumentCategoryTranslation, TechDDCategoryTranslation, DDv2AnswerStatusTranslation, DDv2ChecklistStatusTranslation, DDv2RiskTranslation, DDv2ActionPointTrackTranslation, DDv2ActionPointPartyTranslation, DDv2ActionPointSchema, DDv2AnswerDocumentSchema, mfhDDv2AnswerSchema;
var init_dd_v2_model = __esmMin((() => {
	init_document();
	init_dd_answer_suggestion_model();
	init_dd_generic_model();
	DDVersion = /* @__PURE__ */ function(DDVersion) {
		DDVersion[DDVersion["V1"] = 1] = "V1";
		DDVersion[DDVersion["V2"] = 2] = "V2";
		return DDVersion;
	}({});
	DDv2Category = /* @__PURE__ */ function(DDv2Category) {
		DDv2Category["Land"] = "Land";
		DDv2Category["Location"] = "Location";
		DDv2Category["Building"] = "Building";
		DDv2Category["Rent"] = "Rent";
		DDv2Category["ObjectManagement"] = "ObjectManagement";
		DDv2Category["Commercial"] = "Commercial";
		DDv2Category["LegalDueDiligence"] = "LegalDueDiligence";
		return DDv2Category;
	}({});
	DDv2Subcategory = /* @__PURE__ */ function(DDv2Subcategory) {
		DDv2Subcategory["General"] = "General";
		DDv2Subcategory["Technical"] = "Technical";
		DDv2Subcategory["Legal"] = "Legal";
		return DDv2Subcategory;
	}({});
	DDv2Priority = /* @__PURE__ */ function(DDv2Priority) {
		DDv2Priority["PreApproval"] = "PreApproval";
		DDv2Priority["FullPotentialCalculation"] = "FullPotentialCalculation";
		DDv2Priority["DueDiligence"] = "DueDiligence";
		return DDv2Priority;
	}({});
	DDv2BankabilityRelevance = /* @__PURE__ */ function(DDv2BankabilityRelevance) {
		DDv2BankabilityRelevance["CriticalRequired"] = "CriticalRequired";
		DDv2BankabilityRelevance["Desirable"] = "Desirable";
		DDv2BankabilityRelevance["NotRequired"] = "NotRequired";
		return DDv2BankabilityRelevance;
	}({});
	DDv2DocumentCategory = /* @__PURE__ */ function(DDv2DocumentCategory) {
		DDv2DocumentCategory["Land"] = "Land";
		DDv2DocumentCategory["Location"] = "Location";
		DDv2DocumentCategory["Building"] = "Building";
		DDv2DocumentCategory["ObjectManagement"] = "ObjectManagement";
		DDv2DocumentCategory["RentalContract"] = "RentalContract";
		DDv2DocumentCategory["MfhOther"] = "MfhOther";
		return DDv2DocumentCategory;
	}({});
	DDv2AnswerStatus = /* @__PURE__ */ function(DDv2AnswerStatus) {
		DDv2AnswerStatus["ReadyForReview"] = "ReadyForReview";
		DDv2AnswerStatus["Reviewed"] = "Reviewed";
		DDv2AnswerStatus["NotFeasible"] = "NotFeasible";
		/** Closed without review. Kept apart from `Reviewed` so an approval trail exists only where someone approved. */
		DDv2AnswerStatus["Done"] = "Done";
		return DDv2AnswerStatus;
	}({});
	DDv2ChecklistStatus = /* @__PURE__ */ function(DDv2ChecklistStatus) {
		DDv2ChecklistStatus["Open"] = "Open";
		DDv2ChecklistStatus["InProgress"] = "InProgress";
		DDv2ChecklistStatus["InReview"] = "InReview";
		DDv2ChecklistStatus["Done"] = "Done";
		return DDv2ChecklistStatus;
	}({});
	DDv2Risk = /* @__PURE__ */ function(DDv2Risk) {
		DDv2Risk["None"] = "None";
		DDv2Risk["Low"] = "Low";
		DDv2Risk["Medium"] = "Medium";
		DDv2Risk["High"] = "High";
		return DDv2Risk;
	}({});
	DDv2ActionPointTrack = /* @__PURE__ */ function(DDv2ActionPointTrack) {
		DDv2ActionPointTrack["Acquisition"] = "Acquisition";
		DDv2ActionPointTrack["ValueAdd"] = "ValueAdd";
		return DDv2ActionPointTrack;
	}({});
	DDv2ActionPointParty = /* @__PURE__ */ function(DDv2ActionPointParty) {
		DDv2ActionPointParty["TDD"] = "TDD";
		DDv2ActionPointParty["EDD"] = "EDD";
		DDv2ActionPointParty["LDD"] = "LDD";
		DDv2ActionPointParty["AM"] = "AM";
		DDv2ActionPointParty["FI"] = "FI";
		DDv2ActionPointParty["CON"] = "CON";
		DDv2ActionPointParty["Seller"] = "Seller";
		return DDv2ActionPointParty;
	}({});
	ddV2ActionPointParties = {
		["Acquisition"]: [
			"TDD",
			"EDD",
			"LDD",
			"AM",
			"FI",
			"CON",
			"Seller"
		],
		["ValueAdd"]: [
			"AM",
			"CON",
			"FI"
		]
	};
	TechDDCategory = /* @__PURE__ */ function(TechDDCategory) {
		TechDDCategory["KeyFacts"] = "KeyFacts";
		TechDDCategory["BuildingLawAndRegisters"] = "BuildingLawAndRegisters";
		TechDDCategory["ExistingBuildingPlans"] = "ExistingBuildingPlans";
		TechDDCategory["BuildingCondition"] = "BuildingCondition";
		TechDDCategory["StructuralSystem"] = "StructuralSystem";
		TechDDCategory["BuildingServices"] = "BuildingServices";
		TechDDCategory["EnergyEfficiency"] = "EnergyEfficiency";
		TechDDCategory["FireProtection"] = "FireProtection";
		TechDDCategory["MaintenanceAndRepair"] = "MaintenanceAndRepair";
		TechDDCategory["Potential"] = "Potential";
		TechDDCategory["Reports"] = "Reports";
		TechDDCategory["Tdd"] = "Tdd";
		return TechDDCategory;
	}({});
	DDv2CategoryTranslation = {
		["Land"]: "Grundstück",
		["Location"]: "Lage",
		["Building"]: "Gebäude",
		["Rent"]: "Miete",
		["ObjectManagement"]: "Objektverwaltung",
		["Commercial"]: "Kaufmännisch",
		["LegalDueDiligence"]: "Legal Due Diligence"
	};
	DDv2SubcategoryTranslation = {
		["General"]: "Allgemein",
		["Technical"]: "Technisch",
		["Legal"]: "Rechtlich"
	};
	DDv2PriorityTranslation = {
		["PreApproval"]: "Pre-Approval",
		["FullPotentialCalculation"]: "Full Potential Calculation",
		["DueDiligence"]: "Due Diligence"
	};
	DDv2BankabilityRelevanceTranslation = {
		["CriticalRequired"]: "Kritisch - erforderlich",
		["Desirable"]: "Wünschenswert",
		["NotRequired"]: "Nicht erforderlich"
	};
	DDv2DocumentCategoryTranslation = {
		["Land"]: "Grundstück",
		["Location"]: "Lage",
		["Building"]: "Gebäude",
		["ObjectManagement"]: "Objektverwaltung",
		["RentalContract"]: "Mietvertrag",
		["MfhOther"]: "Sonstiges"
	};
	TechDDCategoryTranslation = {
		["KeyFacts"]: "Key Facts",
		["BuildingLawAndRegisters"]: "Baurecht, Grundbuch & Auskünfte",
		["ExistingBuildingPlans"]: "Bestandsplanung",
		["BuildingCondition"]: "Bauzustand",
		["StructuralSystem"]: "Tragwerk/Struktur",
		["BuildingServices"]: "TGA",
		["EnergyEfficiency"]: "Energieeffizienz",
		["FireProtection"]: "Brandschutz",
		["MaintenanceAndRepair"]: "Wartung und Instandhaltung",
		["Potential"]: "Potenzial",
		["Reports"]: "Gutachten",
		["Tdd"]: "TDD"
	};
	DDv2AnswerStatusTranslation = {
		["ReadyForReview"]: "Bereit zur Prüfung",
		["Reviewed"]: "Geprüft",
		["NotFeasible"]: "Nicht durchführbar",
		["Done"]: "Erledigt"
	};
	DDv2ChecklistStatusTranslation = {
		["Open"]: "Offen",
		["InProgress"]: "In Bearbeitung",
		["InReview"]: "In Prüfung",
		["Done"]: "Erledigt"
	};
	DDv2RiskTranslation = {
		["None"]: "Keines",
		["Low"]: "Niedrig",
		["Medium"]: "Mittel",
		["High"]: "Hoch"
	};
	DDv2ActionPointTrackTranslation = {
		["Acquisition"]: "Ankauf",
		["ValueAdd"]: "Value Add"
	};
	DDv2ActionPointPartyTranslation = {
		["TDD"]: "Technische DD",
		["EDD"]: "Umwelt-DD",
		["LDD"]: "Rechtliche DD",
		["AM"]: "Asset Management",
		["FI"]: "Finanzierung",
		["CON"]: "Bau",
		["Seller"]: "Verkäufer"
	};
	DDv2ActionPointSchema = Type.Object({
		id: Type.String(),
		track: Type.Enum(DDv2ActionPointTrack),
		party: Type.Enum(DDv2ActionPointParty),
		instruction: Type.String(),
		createdAt: Type.String(),
		createdBy: Type.Optional(Type.Union([Type.String(), Type.Null()]))
	}, { additionalProperties: false });
	DDv2AnswerDocumentSchema = Type.Object({
		...DocumentSchema.properties,
		workroomDocumentType: Type.Optional(Type.Enum(DocumentType))
	}, { additionalProperties: false });
	mfhDDv2AnswerSchema = Type.Object({
		assessmentResult: Type.Optional(Type.Union([Type.String(), Type.Null()])),
		documents: Type.Optional(Type.Union([Type.Array(DDv2AnswerDocumentSchema), Type.Null()])),
		internalNotes: Type.Optional(Type.Union([Type.String(), Type.Null()])),
		externalNotes: Type.Optional(Type.Union([Type.String(), Type.Null()])),
		riskManagement: Type.Optional(Type.Union([Type.String(), Type.Null()])),
		actionPoints: Type.Optional(Type.Union([Type.Array(DDv2ActionPointSchema), Type.Null()])),
		aiSource: Type.Optional(Type.Union([DDv2AiSourceSchema, Type.Null()]))
	}, { additionalProperties: false });
}));
//#endregion
//#region src/domains/cross-cutting/mfh/due-diligence/dd.opts.ts
function getDDFormType(formSchema) {
	return formSchemaToDDFormType[formSchema];
}
function getDDStatusConfig(formSchema) {
	const formType = getDDFormType(formSchema);
	return ddStatusConfigs[formType];
}
function getDDStatusTranslation(formSchema, status) {
	return getDDStatusConfig(formSchema).translations[status] ?? status;
}
function getDDStatusColor(formSchema, status) {
	return getDDStatusConfig(formSchema).colorMap[status] ?? "#808080";
}
function getDDStatusValues(formSchema) {
	const formType = getDDFormType(formSchema);
	if (formType === "Workflow") return Object.values(WorkflowDDStatus);
	if (formType === "ChecklistV2") return Object.values(DDv2AnswerStatus);
	return Object.values(DDStatus);
}
var RequirementLevel, TechnicalOnSiteDDStatus, RequirementLevelTranslation, TechnicalOnSiteDDStatusTranslation, DDStage, DDPhase, DDPhaseTranslation, DDStageTranslation, DDFormType, DDStatus, WorkflowDDStatus, DDStatusTranslation, WorkflowDDStatusTranslation, assessmentDDStatusConfig, workflowDDStatusConfig, checklistV2DDStatusConfig, ddStatusConfigs, formSchemaToDDFormType, DDRisks;
var init_dd_opts = __esmMin((() => {
	init_form();
	init_dd_v2_model();
	RequirementLevel = /* @__PURE__ */ function(RequirementLevel) {
		RequirementLevel["None"] = "na";
		RequirementLevel["Optional"] = "opt";
		RequirementLevel["Mandatory"] = "m";
		return RequirementLevel;
	}({});
	TechnicalOnSiteDDStatus = /* @__PURE__ */ function(TechnicalOnSiteDDStatus) {
		TechnicalOnSiteDDStatus["Open"] = "open";
		TechnicalOnSiteDDStatus["Closed"] = "closed";
		return TechnicalOnSiteDDStatus;
	}({});
	RequirementLevelTranslation = {
		["na"]: "Nicht Anwendbar",
		["opt"]: "Nach Bedarf",
		["m"]: "Zwingend Erforderlich"
	};
	TechnicalOnSiteDDStatusTranslation = {
		["open"]: "Offen",
		["closed"]: "Geschlossen"
	};
	DDStage = /* @__PURE__ */ function(DDStage) {
		DDStage["D2GCalculator"] = "D2GCalculator";
		DDStage["RiskPosition"] = "RiskPosition";
		DDStage["LongLeadTime"] = "LongLeadTime";
		DDStage["StageGate1"] = "StageGate1";
		DDStage["StageGate2"] = "StageGate2";
		DDStage["StageGate3"] = "StageGate3";
		DDStage["StageGate4"] = "StageGate4";
		DDStage["StageGate5"] = "StageGate5";
		return DDStage;
	}({});
	DDPhase = /* @__PURE__ */ function(DDPhase) {
		DDPhase["New"] = "New";
		DDPhase["AssetViability"] = "AssetViability";
		DDPhase["FullPotentialCalcNoOnSiteVisit"] = "FullPotentialCalcNoOnSiteVisit";
		DDPhase["FullPotentialCalcFirstOnSiteVisit"] = "FullPotentialCalcFirstOnSiteVisit";
		DDPhase["OnSiteAssessment"] = "OnSiteAssessment";
		DDPhase["InvestmentDecision"] = "InvestmentDecision";
		DDPhase["DealClosing"] = "DealClosing";
		return DDPhase;
	}({});
	DDPhaseTranslation = {
		["New"]: "0 - New",
		["AssetViability"]: "1 - Asset Viability",
		["FullPotentialCalcNoOnSiteVisit"]: "2A - Full Potential Calc. & No on-site Visit",
		["FullPotentialCalcFirstOnSiteVisit"]: "2B - Full Potential Calc. & First on-site",
		["OnSiteAssessment"]: "3 - On-site Assessment",
		["InvestmentDecision"]: "4- Investment Decision",
		["DealClosing"]: "5- Deal Closing"
	};
	DDStageTranslation = {
		["D2GCalculator"]: "D2G Calculator",
		["RiskPosition"]: "Risikoposition",
		["LongLeadTime"]: "Lange Vorlaufzeit",
		["StageGate1"]: "Stage Gate 1",
		["StageGate2"]: "Stage Gate 2",
		["StageGate3"]: "Stage Gate 3",
		["StageGate4"]: "Stage Gate 4",
		["StageGate5"]: "Stage Gate 5"
	};
	DDFormType = /* @__PURE__ */ function(DDFormType) {
		DDFormType["Assessment"] = "Assessment";
		DDFormType["Workflow"] = "Workflow";
		DDFormType["ChecklistV2"] = "ChecklistV2";
		return DDFormType;
	}({});
	DDStatus = /* @__PURE__ */ function(DDStatus) {
		DDStatus["InformationIsMissingClarificationNeeded"] = "InformationIsMissingClarificationNeeded";
		DDStatus["CannotBeChecked"] = "CannotBeChecked";
		DDStatus["CheckedOk"] = "CheckedOk";
		DDStatus["InformationIsMissingOk"] = "InformationIsMissingOk";
		DDStatus["InProgress"] = "InProgress";
		DDStatus["NotApplicable"] = "NotApplicable";
		DDStatus["Open"] = "Open";
		DDStatus["ExternalExaminationRequired"] = "ExternalExaminationRequired";
		DDStatus["CheckedCritical"] = "CheckedCritical";
		return DDStatus;
	}({});
	WorkflowDDStatus = /* @__PURE__ */ function(WorkflowDDStatus) {
		WorkflowDDStatus["Completed"] = "Completed";
		WorkflowDDStatus["Open"] = "Open";
		WorkflowDDStatus["InProgressOnTrack"] = "InProgressOnTrack";
		WorkflowDDStatus["Paused"] = "Paused";
		WorkflowDDStatus["InProgressDelayed"] = "InProgressDelayed";
		WorkflowDDStatus["ActionNeeded"] = "ActionNeeded";
		return WorkflowDDStatus;
	}({});
	DDStatusTranslation = {
		["InformationIsMissingClarificationNeeded"]: "Auskunft fehlt - Klärungsbedarf",
		["CannotBeChecked"]: "Kann nicht geprüft werden",
		["CheckedOk"]: "Geprüft - in Ordnung",
		["InformationIsMissingOk"]: "Auskunft fehlt - in Ordnung",
		["InProgress"]: "In Bearbeitung",
		["NotApplicable"]: "Nicht zutreffend",
		["Open"]: "Offen",
		["ExternalExaminationRequired"]: "Prüfung Extern erforderlich",
		["CheckedCritical"]: "Geprüft - kritisch"
	};
	WorkflowDDStatusTranslation = {
		["Completed"]: "Erledigt",
		["Open"]: "Offen",
		["InProgressOnTrack"]: "In Bearbeitung - on track",
		["Paused"]: "Pausiert",
		["InProgressDelayed"]: "In Bearbeitung - verzögert",
		["ActionNeeded"]: "Action needed / Klärungsbedarf"
	};
	assessmentDDStatusConfig = {
		translations: DDStatusTranslation,
		colorMap: {
			["CannotBeChecked"]: "#FFA500",
			["CheckedCritical"]: "#f04438",
			["CheckedOk"]: "#12b76a",
			["ExternalExaminationRequired"]: "#FFA500",
			["InProgress"]: "#0000FF",
			["InformationIsMissingClarificationNeeded"]: "#FFFF00",
			["InformationIsMissingOk"]: "#12b76a",
			["NotApplicable"]: "#12b76a",
			["Open"]: "#808080"
		}
	};
	workflowDDStatusConfig = {
		translations: WorkflowDDStatusTranslation,
		colorMap: {
			["Completed"]: "#13734b",
			["Open"]: "#ffe59f",
			["InProgressOnTrack"]: "#d4edbd",
			["Paused"]: "#ffcfca",
			["InProgressDelayed"]: "#ffe59f",
			["ActionNeeded"]: "#b10202"
		}
	};
	checklistV2DDStatusConfig = {
		translations: DDv2AnswerStatusTranslation,
		colorMap: {
			["ReadyForReview"]: "#FFA500",
			["Reviewed"]: "#12b76a",
			["NotFeasible"]: "#808080",
			["Done"]: "#12b76a"
		}
	};
	ddStatusConfigs = {
		["Assessment"]: assessmentDDStatusConfig,
		["Workflow"]: workflowDDStatusConfig,
		["ChecklistV2"]: checklistV2DDStatusConfig
	};
	formSchemaToDDFormType = {
		["DDOverview"]: "Assessment",
		["MfhDocumentChecklist"]: "Assessment",
		["SourcingTasksDD"]: "Assessment",
		["ObjectExaminationDD"]: "Assessment",
		["VicinityExaminationDD"]: "Assessment",
		["RentDD"]: "Assessment",
		["TechnicalDD"]: "Assessment",
		["TechnicalOnSiteDD"]: "Assessment",
		["LegalDD"]: "Assessment",
		["CommercialDD"]: "Workflow",
		["DealClosingDD"]: "Workflow",
		["MfhDDv2"]: "ChecklistV2"
	};
	DDRisks = [
		"Hoch - potenzielles K.O. Kriterium",
		"Hoch - widerlegbar",
		"Hoch - Rückstellung bilden",
		"Hoch - im Kaufvertrag regeln",
		"Mittel - Rückstellung bilden",
		"Mittel - im Kaufvertrag regeln",
		"Niedrig - beobachten",
		"Keins"
	];
}));
//#endregion
//#region src/domains/cross-cutting/mfh/due-diligence/dd-overview.model.ts
var overviewDDAnswerSchema, overviewDDQuestions;
var init_dd_overview_model = __esmMin((() => {
	overviewDDAnswerSchema = Type.Object({});
	overviewDDQuestions = [
		{
			number: 1,
			stage: "1"
		},
		{
			number: 2,
			stage: "2"
		},
		{
			number: 3,
			stage: "3"
		},
		{
			number: 4,
			stage: "4"
		},
		{
			number: 5,
			stage: "5"
		}
	];
}));
//#endregion
//#region src/domains/cross-cutting/mfh/due-diligence/document-checklist-dd.model.ts
var MfhDocumentCheckStatus, MfhDocumentCheckBankNoteNecessaryStatus, mfhDocumentCheckStatusTranslation, mfhDocumentCheckBankNoteNecessaryStatusTranslation, documentChecklistAnswerSchema, documentChecklistQuestions;
var init_document_checklist_dd_model = __esmMin((() => {
	init_document();
	init_document_model();
	init_dd_generic_model();
	MfhDocumentCheckStatus = /* @__PURE__ */ function(MfhDocumentCheckStatus) {
		MfhDocumentCheckStatus["Open"] = "Open";
		MfhDocumentCheckStatus["PresentInComplete"] = "PresentInComplete";
		MfhDocumentCheckStatus["AvailableChecked"] = "AvailableChecked";
		MfhDocumentCheckStatus["AvailablePendingCheck"] = "AvailablePendingCheck";
		MfhDocumentCheckStatus["RequestedPendingResponse"] = "RequestedPendingResponse";
		MfhDocumentCheckStatus["RequestNotAvailable"] = "RequestNotAvailable";
		MfhDocumentCheckStatus["NotApplicable"] = "NotApplicable";
		return MfhDocumentCheckStatus;
	}({});
	MfhDocumentCheckBankNoteNecessaryStatus = /* @__PURE__ */ function(MfhDocumentCheckBankNoteNecessaryStatus) {
		MfhDocumentCheckBankNoteNecessaryStatus["YesMandatory"] = "YesMandatory";
		MfhDocumentCheckBankNoteNecessaryStatus["YesHelpful"] = "YesHelpful";
		MfhDocumentCheckBankNoteNecessaryStatus["No"] = "No";
		return MfhDocumentCheckBankNoteNecessaryStatus;
	}({});
	mfhDocumentCheckStatusTranslation = {
		["Open"]: "Offen",
		["PresentInComplete"]: "Vorhanden - unvollständig",
		["AvailableChecked"]: "Vorhanden - geprüft",
		["AvailablePendingCheck"]: "Vorhanden - zu prüfen",
		["RequestedPendingResponse"]: "Angefragt - Antwort ausstehend",
		["RequestNotAvailable"]: "Angefragt - nicht verfügbar",
		["NotApplicable"]: "Unzutreffend"
	};
	mfhDocumentCheckBankNoteNecessaryStatusTranslation = {
		["YesMandatory"]: "Ja - Zwingend",
		["YesHelpful"]: "Ja - Hilfreich",
		["No"]: "Nein"
	};
	FormatRegistry.Set("date", (value) => /^\d{4}-\d{2}-\d{2}$/.test(value));
	documentChecklistAnswerSchema = Type.Object({
		status: Type.Optional(Type.String()),
		note: Type.Optional(Type.String()),
		externalNote: Type.Optional(Type.String()),
		documents: Type.Optional(Type.Array(DocumentSchema)),
		criticalFor: Type.Optional(Type.Union([ContactSchema, Type.Null()])),
		addedBy: Type.Optional(Type.Union([ContactSchema, Type.Null()])),
		addedOn: Type.Optional(Type.Union([Type.String({ format: "date" }), Type.Literal("")])),
		lastUpdatedOn: Type.Optional(Type.Union([Type.String({ format: "date" }), Type.Literal("")])),
		sentOn: Type.Optional(Type.Union([Type.String({ format: "date" }), Type.Literal("")])),
		personInCharge: Type.Optional(Type.Union([ContactSchema, Type.Null()]))
	}, { additionalProperties: false });
	documentChecklistQuestions = [
		{
			number: 1,
			documentCategory: documentTypeToCategory("CurrentLandRegisterExtract"),
			documentType: "CurrentLandRegisterExtract",
			bankNoteNecessary: "YesMandatory"
		},
		{
			number: 2,
			documentCategory: documentTypeToCategory("EncumbranceBasisInDeptII"),
			documentType: "EncumbranceBasisInDeptII",
			bankNoteNecessary: "YesMandatory"
		},
		{
			number: 3,
			documentCategory: documentTypeToCategory("CurrentParcelMap"),
			documentType: "CurrentParcelMap",
			bankNoteNecessary: "YesMandatory"
		},
		{
			number: 4,
			documentCategory: documentTypeToCategory("CurrentPlanningRights"),
			documentType: "CurrentPlanningRights",
			bankNoteNecessary: "YesHelpful"
		},
		{
			number: 5,
			documentCategory: documentTypeToCategory("InformationUrbanRenewalArea"),
			documentType: "InformationUrbanRenewalArea",
			bankNoteNecessary: "No"
		},
		{
			number: 6,
			documentCategory: documentTypeToCategory("InformationUrbanConservationArea"),
			documentType: "InformationUrbanConservationArea",
			bankNoteNecessary: "YesHelpful"
		},
		{
			number: 7,
			documentCategory: documentTypeToCategory("InformationMonumentProtection"),
			documentType: "InformationMonumentProtection",
			bankNoteNecessary: "YesMandatory"
		},
		{
			number: 8,
			documentCategory: documentTypeToCategory("SocialPreservationOrdinance"),
			documentType: "SocialPreservationOrdinance",
			bankNoteNecessary: "YesHelpful"
		},
		{
			number: 9,
			documentCategory: documentTypeToCategory("InformationBuildingChargeRegister"),
			documentType: "InformationBuildingChargeRegister",
			bankNoteNecessary: "YesMandatory"
		},
		{
			number: 10,
			documentCategory: documentTypeToCategory("ExtractContaminatedSitesRegister"),
			documentType: "ExtractContaminatedSitesRegister",
			bankNoteNecessary: "YesMandatory"
		},
		{
			number: 11,
			documentCategory: documentTypeToCategory("ExtractDevelopmentAndExpansionContributions"),
			documentType: "ExtractDevelopmentAndExpansionContributions",
			bankNoteNecessary: "YesMandatory"
		},
		{
			number: 12,
			documentCategory: documentTypeToCategory("UrbanDevelopmentContracts"),
			documentType: "UrbanDevelopmentContracts",
			bankNoteNecessary: "No"
		},
		{
			number: 13,
			documentCategory: documentTypeToCategory("SoilReportOrContaminatedSites"),
			documentType: "SoilReportOrContaminatedSites",
			bankNoteNecessary: "No"
		},
		{
			number: 14,
			documentCategory: documentTypeToCategory("GroundLease"),
			documentType: "GroundLease",
			bankNoteNecessary: "No"
		},
		{
			number: 15,
			documentCategory: documentTypeToCategory("VerificationOfExplosiveOrdnance"),
			documentType: "VerificationOfExplosiveOrdnance",
			bankNoteNecessary: "No"
		},
		{
			number: 16,
			documentCategory: documentTypeToCategory("OngoingLegalDisputesRegardingProperty"),
			documentType: "OngoingLegalDisputesRegardingProperty",
			bankNoteNecessary: "No"
		},
		{
			number: 17,
			documentCategory: documentTypeToCategory("BuildingEnergyCertificate"),
			documentType: "BuildingEnergyCertificate",
			bankNoteNecessary: "YesMandatory"
		},
		{
			number: 18,
			documentCategory: documentTypeToCategory("SectionDrawingsBuildingElevations"),
			documentType: "SectionDrawingsBuildingElevations",
			bankNoteNecessary: "YesMandatory"
		},
		{
			number: 19,
			documentCategory: documentTypeToCategory("FloorPlansIncludingAreaCalculation"),
			documentType: "FloorPlansIncludingAreaCalculation",
			bankNoteNecessary: "YesMandatory"
		},
		{
			number: 20,
			documentCategory: documentTypeToCategory("BuildingApplicationOrBuildingPermit"),
			documentType: "BuildingApplicationOrBuildingPermit",
			bankNoteNecessary: "YesMandatory"
		},
		{
			number: 21,
			documentCategory: documentTypeToCategory("WarrantyGuarantees"),
			documentType: "WarrantyGuarantees",
			bankNoteNecessary: "No"
		},
		{
			number: 22,
			documentCategory: documentTypeToCategory("OverviewOfPastOngoingAndPlannedModernization"),
			documentType: "OverviewOfPastOngoingAndPlannedModernization",
			bankNoteNecessary: "YesHelpful"
		},
		{
			number: 23,
			documentCategory: documentTypeToCategory("InsuranceClaimsLast5Years"),
			documentType: "InsuranceClaimsLast5Years",
			bankNoteNecessary: "No"
		},
		{
			number: 24,
			documentCategory: documentTypeToCategory("ModernizationsOfIndividualApartments"),
			documentType: "ModernizationsOfIndividualApartments",
			bankNoteNecessary: "No"
		},
		{
			number: 25,
			documentCategory: documentTypeToCategory("DeclarationOfDivisionIfDivided"),
			documentType: "DeclarationOfDivisionIfDivided",
			bankNoteNecessary: "YesMandatory"
		},
		{
			number: 26,
			documentCategory: documentTypeToCategory("OngoingLegalDisputesRegardingObject"),
			documentType: "OngoingLegalDisputesRegardingObject",
			bankNoteNecessary: "No"
		},
		{
			number: 27,
			documentCategory: documentTypeToCategory("TenantList"),
			documentType: "TenantList",
			bankNoteNecessary: "YesMandatory"
		},
		{
			number: 28,
			documentCategory: documentTypeToCategory("RentIncreaseLetters"),
			documentType: "RentIncreaseLetters",
			bankNoteNecessary: "No"
		},
		{
			number: 29,
			documentCategory: documentTypeToCategory("RentalAgreements"),
			documentType: "RentalAgreements",
			bankNoteNecessary: "YesMandatory"
		},
		{
			number: 30,
			documentCategory: documentTypeToCategory("ListOfExistingRentalDeposits"),
			documentType: "ListOfExistingRentalDeposits",
			bankNoteNecessary: "No"
		},
		{
			number: 31,
			documentCategory: documentTypeToCategory("OperatingCostStatement"),
			documentType: "OperatingCostStatement",
			bankNoteNecessary: "No"
		},
		{
			number: 32,
			documentCategory: documentTypeToCategory("TenantHandoverProtocols"),
			documentType: "TenantHandoverProtocols",
			bankNoteNecessary: "No"
		},
		{
			number: 33,
			documentCategory: documentTypeToCategory("ListOfCurrentDefectComplaintsReductionsArrears"),
			documentType: "ListOfCurrentDefectComplaintsReductionsArrears",
			bankNoteNecessary: "No"
		},
		{
			number: 34,
			documentCategory: documentTypeToCategory("OngoingLegalDisputesWithTenants"),
			documentType: "OngoingLegalDisputesWithTenants",
			bankNoteNecessary: "No"
		},
		{
			number: 35,
			documentCategory: documentTypeToCategory("ManagementContracts"),
			documentType: "ManagementContracts",
			bankNoteNecessary: "No"
		},
		{
			number: 36,
			documentCategory: documentTypeToCategory("MaintenanceProtocols"),
			documentType: "MaintenanceProtocols",
			bankNoteNecessary: "No"
		},
		{
			number: 37,
			documentCategory: documentTypeToCategory("ListOfAgeOfInstallations"),
			documentType: "ListOfAgeOfInstallations",
			bankNoteNecessary: "No"
		},
		{
			number: 38,
			documentCategory: documentTypeToCategory("InsurancesMainlyCurrentBuildingInsurance"),
			documentType: "InsurancesMainlyCurrentBuildingInsurance",
			bankNoteNecessary: "No"
		},
		{
			number: 39,
			documentCategory: documentTypeToCategory("PropertyTaxAssessmentAndUnitValueNotice"),
			documentType: "PropertyTaxAssessmentAndUnitValueNotice",
			bankNoteNecessary: "No"
		},
		{
			number: 40,
			documentCategory: documentTypeToCategory("ListOfCraftsmen"),
			documentType: "ListOfCraftsmen",
			bankNoteNecessary: "No"
		},
		{
			number: 41,
			documentCategory: documentTypeToCategory("PurchaseContractDraft"),
			documentType: "PurchaseContractDraft",
			bankNoteNecessary: "YesMandatory"
		},
		{
			number: 42,
			documentCategory: documentTypeToCategory("AttachmentsToPurchaseContract"),
			documentType: "AttachmentsToPurchaseContract",
			bankNoteNecessary: "No"
		},
		{
			number: 43,
			documentCategory: documentTypeToCategory("PowersOfAttorney"),
			documentType: "PowersOfAttorney",
			bankNoteNecessary: "No"
		}
	];
}));
//#endregion
//#region src/domains/cross-cutting/mfh/due-diligence/sourcing-tasks-dd.model.ts
var sourcingTasksDDAnswerSchema, sourcingTasksDDQuestions, SourcingTasksDDEvaluation, sourcingTasksDDEvaluationTranslation;
var init_sourcing_tasks_dd_model = __esmMin((() => {
	init_dd_generic_model();
	init_dd_opts();
	sourcingTasksDDAnswerSchema = Type.Object({
		evaluation: Type.Optional(Type.String()),
		documents: Type.Optional(Type.Array(DocumentSchema)),
		details: Type.Optional(Type.String()),
		note: Type.Optional(Type.String()),
		externalNote: Type.Optional(Type.String())
	}, { additionalProperties: false });
	sourcingTasksDDQuestions = [
		{
			number: 1,
			stream: "Buy-Box",
			check: "Asset Type",
			testCriterion: "MFH Bestandsgebäude",
			priority: "StageGate1"
		},
		{
			number: 2,
			stream: "Buy-Box",
			check: "Asset Type",
			testCriterion: "<20% Gewerbeanteil (Fläche)",
			priority: "StageGate1"
		},
		{
			number: 3,
			stream: "Buy-Box",
			check: "Size",
			testCriterion: ">500m2",
			priority: "D2GCalculator"
		},
		{
			number: 4,
			stream: "Buy-Box",
			check: "Size",
			testCriterion: ">5 Apartments",
			priority: "D2GCalculator"
		},
		{
			number: 5,
			stream: "Buy-Box",
			check: "Price Range",
			testCriterion: "1-30m EUR",
			priority: "D2GCalculator"
		},
		{
			number: 6,
			stream: "Buy-Box",
			check: "Price Range",
			testCriterion: "€1,000 – €4,000/ m2",
			priority: "StageGate1"
		},
		{
			number: 7,
			stream: "Buy-Box",
			check: "Entry Rent",
			testCriterion: "€7.00 – €12.00/ m2 p.m.",
			priority: "D2GCalculator"
		},
		{
			number: 8,
			stream: "Buy-Box",
			check: "Entry Yield / Multiple",
			testCriterion: "5.00% – 6.50% (15x – 20x)",
			priority: "StageGate1"
		},
		{
			number: 9,
			stream: "Buy-Box",
			check: "Asset Condition",
			testCriterion: "Baujahr 1900-1980",
			priority: "D2GCalculator"
		},
		{
			number: 10,
			stream: "Buy-Box",
			check: "Asset Condition",
			testCriterion: "Energetisch unrenoviert",
			priority: "StageGate1"
		},
		{
			number: 11,
			stream: "Buy-Box",
			check: "Asset Condition",
			testCriterion: "Einfache Bautypologie",
			priority: "StageGate1"
		},
		{
			number: 12,
			stream: "Buy-Box",
			check: "Asset Condition",
			testCriterion: "Erhöhter Leerstand",
			priority: "StageGate1"
		},
		{
			number: 13,
			stream: "Buy-Box",
			check: "Asset Condition",
			testCriterion: "Keine Schützenswerte Fassade",
			priority: "StageGate1"
		},
		{
			number: 14,
			stream: "Buy-Box",
			check: "Energy efficiency",
			testCriterion: "D-H (>130 kWh/m2*a)",
			priority: "D2GCalculator"
		},
		{
			number: 15,
			stream: "Buy-Box",
			check: "Exclusions",
			testCriterion: "Keine Gerichtsverfahren",
			priority: "StageGate1"
		},
		{
			number: 16,
			stream: "Buy-Box",
			check: "Exclusions",
			testCriterion: "Kein Erbpacht",
			priority: "StageGate1"
		},
		{
			number: 17,
			stream: "Buy-Box",
			check: "Exclusions",
			testCriterion: "Kein Nießbrauch",
			priority: "StageGate1"
		},
		{
			number: 18,
			stream: "Buy-Box",
			check: "Exclusions",
			testCriterion: "Kein Denkmalschutz",
			priority: "StageGate1"
		},
		{
			number: 19,
			stream: "Buy-Box",
			check: "Exclusions",
			testCriterion: "Kein Sanierungsgebiet",
			priority: "StageGate1"
		},
		{
			number: 20,
			stream: "Buy-Box",
			check: "Exclusions",
			testCriterion: "Kein Milieuschutz",
			priority: "StageGate1"
		},
		{
			number: 21,
			stream: "Investment Strategie",
			check: "Micro factors",
			testCriterion: "Core+ Stadtviertel",
			priority: "StageGate1"
		},
		{
			number: 22,
			stream: "Investment Strategie",
			check: "Micro factors",
			testCriterion: "Fernwärmenetz in Umgebung",
			priority: "D2GCalculator"
		},
		{
			number: 23,
			stream: "Investment Strategie",
			check: "Micro factors",
			testCriterion: "öffentlichen Verkehrsmitteln (U- / S-Bahn)",
			priority: "StageGate1"
		},
		{
			number: 24,
			stream: "Investment Strategie",
			check: "DG Ausbau",
			testCriterion: "DG Ausbau möglich",
			priority: "D2GCalculator"
		},
		{
			number: 25,
			stream: "Investment Strategie",
			check: "Aufstockung",
			testCriterion: "Aufstockung möglich",
			priority: "D2GCalculator"
		},
		{
			number: 26,
			stream: "Investment Strategie",
			check: "Aufteilung",
			testCriterion: "Aufteilung möglich",
			priority: "D2GCalculator"
		}
	];
	SourcingTasksDDEvaluation = /* @__PURE__ */ function(SourcingTasksDDEvaluation) {
		SourcingTasksDDEvaluation["Yes"] = "Yes";
		SourcingTasksDDEvaluation["Partially"] = "Partially";
		SourcingTasksDDEvaluation["No"] = "No";
		SourcingTasksDDEvaluation["NotChecked"] = "NotChecked";
		return SourcingTasksDDEvaluation;
	}({});
	sourcingTasksDDEvaluationTranslation = {
		["Yes"]: "Ja",
		["Partially"]: "Teilweise",
		["No"]: "Nein",
		["NotChecked"]: "Nicht geprüft"
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/due-diligence/technical-on-site-dd.model.ts
var technicalOnSiteDDAnswerSchema, technicalOnSiteChecklistGroups, technicalOnSiteDDQuestions;
var init_technical_on_site_dd_model = __esmMin((() => {
	init_dd_opts();
	technicalOnSiteDDAnswerSchema = Type.Object({
		number: Type.Optional(Type.Number()),
		question: Type.Optional(Type.String()),
		mandatory: Type.Optional(Type.Boolean()),
		photoEvidenceRequired: Type.Optional(Type.Union([
			Type.Literal("na"),
			Type.Literal("opt"),
			Type.Literal("m")
		])),
		picture: Type.Optional(Type.Optional(Type.String())),
		media: Type.Optional(Type.Array(Type.Object({
			filename: Type.Optional(Type.String()),
			link: Type.Optional(Type.String()),
			mediaFileId: Type.Optional(Type.Number()),
			path: Type.Optional(Type.String())
		}))),
		documentation: Type.Optional(Type.String()),
		location: Type.Optional(Type.String()),
		group: Type.Optional(Type.Array(Type.String(), { minItems: 1 })),
		status: Type.Optional(Type.String()),
		energyConsultantAssesment: Type.Optional(Type.String()),
		otherNotes: Type.Optional(Type.String()),
		internalNotes: Type.Optional(Type.String())
	}, {
		if: { properties: { photoEvidenceRequired: { const: "m" } } },
		then: { required: ["picture"] },
		additionalProperties: false
	});
	technicalOnSiteChecklistGroups = {
		a: {
			group: ["Bau", "Strukturelle Bewertung"],
			groupOrder: 1
		},
		b: {
			group: ["Bau", "Zustand des Gebäudes außen"],
			groupOrder: 2
		},
		c: {
			group: [
				"Bau",
				"Zustand des Gebäudes innen",
				"Kellergeschoss vollständig beheizt oder teilweise beheizt"
			],
			groupOrder: 3
		},
		d: {
			group: [
				"Bau",
				"Zustand des Gebäudes innen",
				"Kellergeschoss unbeheizter Teil"
			],
			groupOrder: 4
		},
		e: {
			group: [
				"Bau",
				"Zustand des Gebäudes innen",
				"Außenwand"
			],
			groupOrder: 5
		},
		f: {
			group: [
				"Bau",
				"Zustand des Gebäudes innen",
				"Rollladenkästen"
			],
			groupOrder: 6
		},
		g: {
			group: [
				"Bau",
				"Zustand des Gebäudes innen",
				"Fenster"
			],
			groupOrder: 7
		},
		h: {
			group: [
				"Bau",
				"Zustand des Gebäudes innen",
				"Dachgeschoss (beheizter Teil)",
				"Dachfläche"
			],
			groupOrder: 8
		},
		i: {
			group: [
				"Bau",
				"Zustand des Gebäudes innen",
				"Dachgeschoss (beheizter Teil)",
				"Außenwand Dachgeschoss"
			],
			groupOrder: 9
		},
		j: {
			group: [
				"Bau",
				"Zustand des Gebäudes innen",
				"Dachgeschoss (beheizter Teil)",
				"Wand gegen unbeheizten Dachraum / Abseitenwand"
			],
			groupOrder: 10
		},
		k: {
			group: [
				"Bau",
				"Zustand des Gebäudes innen",
				"Dachgeschoss (beheizter Teil)",
				"Gauben + Loggien"
			],
			groupOrder: 11
		},
		l: {
			group: [
				"Bau",
				"Zustand des Gebäudes innen",
				"Dachgeschoss (unbeheizter Teil)",
				"Oberste Geschossdecke"
			],
			groupOrder: 12
		},
		m: {
			group: ["Bau", "Besondere Baumerkmale"],
			groupOrder: 13
		},
		n: {
			group: ["Bau", "Technische Anlagen"],
			groupOrder: 14
		},
		o: {
			group: [
				"Bau",
				"Technische Anlagen",
				"Sanitär Bestand"
			],
			groupOrder: 15
		},
		p: {
			group: [
				"Bau",
				"Technische Anlagen",
				"Starkstrom Bestand"
			],
			groupOrder: 16
		},
		q: {
			group: [
				"Bau",
				"Technische Anlagen",
				"Förderanlagen Bestand"
			],
			groupOrder: 17
		},
		r: {
			group: [
				"Bau",
				"Technische Anlagen",
				"Wärmeerzeuger Bestand"
			],
			groupOrder: 18
		},
		s: {
			group: [
				"Bau",
				"Technische Anlagen",
				"Lüftungsanlage"
			],
			groupOrder: 19
		},
		t: {
			group: ["Bau", "Energieeffizienz"],
			groupOrder: 20
		},
		u: {
			group: ["Bau", "Schadstoffe"],
			groupOrder: 21
		},
		v: {
			group: ["Bau", "Behördliche Auflagen / Konformitätsprüfung"],
			groupOrder: 22
		},
		w: {
			group: ["Bau", "Zusätzliche Beobachtungen"],
			groupOrder: 23
		},
		x: {
			group: ["Wohnungen", "Zustand der Wohnung"],
			groupOrder: 24
		},
		y: {
			group: ["Wohnungen", "Erhaltenswerte Bauteile im Altbau"],
			groupOrder: 25
		}
	};
	technicalOnSiteDDQuestions = [
		{
			number: 1,
			question: "Baujahr des Gebäudes",
			mandatory: true,
			photoEvidenceRequired: "na",
			group: technicalOnSiteChecklistGroups.a.group,
			groupOrder: technicalOnSiteChecklistGroups.a.groupOrder,
			questionOrder: 1
		},
		{
			number: 2,
			question: "Modernisierungs-/Sanierungsmaßnahmen geplant bzw. bekannt? Gibt es hierzu Eigentümerversammlung/Protokolle?",
			mandatory: true,
			photoEvidenceRequired: "na",
			group: technicalOnSiteChecklistGroups.a.group,
			groupOrder: technicalOnSiteChecklistGroups.a.groupOrder,
			questionOrder: 2
		},
		{
			number: 3,
			question: "Bausubstanz (außen) in einem guten Zustand, ggf. Mängel ersichtlich?",
			mandatory: true,
			photoEvidenceRequired: "opt",
			picture: "ajslfkjasl;fd",
			group: technicalOnSiteChecklistGroups.a.group,
			groupOrder: technicalOnSiteChecklistGroups.a.groupOrder,
			questionOrder: 3
		},
		{
			number: 4,
			question: "Art des Tragwertsystems (Holz, Stahl, Beton)",
			mandatory: true,
			photoEvidenceRequired: "m",
			group: technicalOnSiteChecklistGroups.a.group,
			groupOrder: technicalOnSiteChecklistGroups.a.groupOrder,
			questionOrder: 4
		},
		{
			number: 100,
			question: "Vollständigkeit Bestandsunterlagen",
			mandatory: true,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.a.group,
			groupOrder: technicalOnSiteChecklistGroups.a.groupOrder,
			questionOrder: 5
		},
		{
			number: 101,
			question: "Technische Prüfprotokolle und Wartungsnachweise",
			mandatory: true,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.a.group,
			groupOrder: technicalOnSiteChecklistGroups.a.groupOrder,
			questionOrder: 6
		},
		{
			number: 102,
			question: "Genehmigungsrelevante Themen und Grunddienstbarkeiten",
			mandatory: true,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.a.group,
			groupOrder: technicalOnSiteChecklistGroups.a.groupOrder,
			questionOrder: 7
		},
		{
			number: 5,
			question: "Fundament und tragende Elemente: Zustand",
			mandatory: true,
			photoEvidenceRequired: "m",
			group: technicalOnSiteChecklistGroups.b.group,
			groupOrder: technicalOnSiteChecklistGroups.b.groupOrder,
			questionOrder: 1
		},
		{
			number: 6,
			question: "Dach: Material, Form (Schrägdach, Flachdach, Angabe Neigung, Gemischt, Mansarde), Zustand, Typ, Letzte Sanierung (Jahr und Umfang), Gauben vorhanden (ja/nein, falls ja Anzahl), Himmelsrichtung Dachausrichtung",
			mandatory: true,
			photoEvidenceRequired: "m",
			group: technicalOnSiteChecklistGroups.b.group,
			groupOrder: technicalOnSiteChecklistGroups.b.groupOrder,
			questionOrder: 2
		},
		{
			number: 7,
			question: "Fassade: Material, Zustand, Typ, Letzte Sanierung (Jahr und Umfang)",
			mandatory: true,
			photoEvidenceRequired: "m",
			group: technicalOnSiteChecklistGroups.b.group,
			groupOrder: technicalOnSiteChecklistGroups.b.groupOrder,
			questionOrder: 3
		},
		{
			number: 8,
			question: "Fenster und Türen (inkl. Rahmen, Verglasung, Dichtungen): Material, Zustand, Typ, Letzte Sanierung (Jahr und Umfang)",
			mandatory: true,
			photoEvidenceRequired: "m",
			group: technicalOnSiteChecklistGroups.b.group,
			groupOrder: technicalOnSiteChecklistGroups.b.groupOrder,
			questionOrder: 4
		},
		{
			number: 9,
			question: "Keller (Kellerdecke, Kellerbode, Bodenplatte): Zustand, Typ, Letzte Sanierung (Jahr und Umfang)",
			mandatory: true,
			photoEvidenceRequired: "m",
			group: technicalOnSiteChecklistGroups.b.group,
			groupOrder: technicalOnSiteChecklistGroups.b.groupOrder,
			questionOrder: 5
		},
		{
			number: 10,
			question: "Balkon(e): Zustand, Typ, Letzte Sanierung (Jahr und Umfang)",
			mandatory: true,
			photoEvidenceRequired: "m",
			group: technicalOnSiteChecklistGroups.b.group,
			groupOrder: technicalOnSiteChecklistGroups.b.groupOrder,
			questionOrder: 6
		},
		{
			number: 11,
			question: "Zustand sonstige relevante Bauteile (z.B. Rolllädenkästen, Heizkörpernischen)",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.b.group,
			groupOrder: technicalOnSiteChecklistGroups.b.groupOrder,
			questionOrder: 7
		},
		{
			number: 12,
			question: "Höhe der Erde, Angabe über Höhe und Eigenschaften",
			mandatory: true,
			photoEvidenceRequired: "m",
			group: technicalOnSiteChecklistGroups.b.group,
			groupOrder: technicalOnSiteChecklistGroups.b.groupOrder,
			questionOrder: 8
		},
		{
			number: 13,
			question: "Nachbargebäude Versätze berücksichtigen",
			mandatory: true,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.b.group,
			groupOrder: technicalOnSiteChecklistGroups.b.groupOrder,
			questionOrder: 9
		},
		{
			number: 14,
			question: "Schwachstellen des Gebäudes (z.B. Feuchtigkeit Fassade / Dach / Fenster / Haustür), Risse",
			mandatory: true,
			photoEvidenceRequired: "m",
			group: technicalOnSiteChecklistGroups.b.group,
			groupOrder: technicalOnSiteChecklistGroups.b.groupOrder,
			questionOrder: 10
		},
		{
			number: 103,
			question: "Hindernisse Zuwegung Gebäude, Außenanlagen",
			mandatory: true,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.b.group,
			groupOrder: technicalOnSiteChecklistGroups.b.groupOrder,
			questionOrder: 11
		},
		{
			number: 104,
			question: "Mögliche Aufstellflächen Außeneinheit Wärmepumpen",
			mandatory: true,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.b.group,
			groupOrder: technicalOnSiteChecklistGroups.b.groupOrder,
			questionOrder: 12
		},
		{
			number: 105,
			question: "Zustand Außenanlagen Allgemein und Technische Anlagen",
			mandatory: true,
			photoEvidenceRequired: "m",
			group: technicalOnSiteChecklistGroups.b.group,
			groupOrder: technicalOnSiteChecklistGroups.b.groupOrder,
			questionOrder: 13
		},
		{
			number: 15,
			question: "Merkmale Fußboden gegen Erdreich (Material, Ausführung, nachträgliche Dämmung, Feuchteschäden)",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.c.group,
			groupOrder: technicalOnSiteChecklistGroups.c.groupOrder,
			questionOrder: 1
		},
		{
			number: 16,
			question: "Merkmale Kelleraußenwand (Material, Ausführung, nachträgliche Dämmung, Feuchteschäden)",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.c.group,
			groupOrder: technicalOnSiteChecklistGroups.c.groupOrder,
			questionOrder: 2
		},
		{
			number: 17,
			question: "Wand gegen unbeheizten Keller? (Material, Wandstärke, Nachträgliche Dämmung, Feuchteschäden)",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.c.group,
			groupOrder: technicalOnSiteChecklistGroups.c.groupOrder,
			questionOrder: 3
		},
		{
			number: 18,
			question: "Lichte Raumhöhe Keller, Nutzung bei Dämmung gewährleistet?",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.d.group,
			groupOrder: technicalOnSiteChecklistGroups.d.groupOrder,
			questionOrder: 1
		},
		{
			number: 19,
			question: "Kellerdecke: Art (Holzbalkendecke, Ziegeldecke, Kappendecke, Stahlbetondecke), Material / Stärke, Dämmung, Feuchteschäden",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.d.group,
			groupOrder: technicalOnSiteChecklistGroups.d.groupOrder,
			questionOrder: 2
		},
		{
			number: 20,
			question: "Abgang zum unbeheizten Keller",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.d.group,
			groupOrder: technicalOnSiteChecklistGroups.d.groupOrder,
			questionOrder: 3
		},
		{
			number: 21,
			question: "Fußboden gegen Erdreich",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.d.group,
			groupOrder: technicalOnSiteChecklistGroups.d.groupOrder,
			questionOrder: 4
		},
		{
			number: 22,
			question: "Decke nach unten (z. B. an Außenraum, Durchfahrt, auskragende Geschosse)",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.d.group,
			groupOrder: technicalOnSiteChecklistGroups.d.groupOrder,
			questionOrder: 5
		},
		{
			number: 23,
			question: "Rechtliche Vorgaben, was darf noch zum Nachbarhaus gedämmt werden",
			mandatory: false,
			photoEvidenceRequired: "na",
			group: technicalOnSiteChecklistGroups.e.group,
			groupOrder: technicalOnSiteChecklistGroups.e.groupOrder,
			questionOrder: 1
		},
		{
			number: 24,
			question: "Wandstärke Aufbau",
			mandatory: false,
			photoEvidenceRequired: "na",
			group: technicalOnSiteChecklistGroups.e.group,
			groupOrder: technicalOnSiteChecklistGroups.e.groupOrder,
			questionOrder: 2
		},
		{
			number: 25,
			question: "Vor der Fassade, Im Sturzbereich des Fensters, Gedämmt, Dämmung möglich?",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.f.group,
			groupOrder: technicalOnSiteChecklistGroups.f.groupOrder,
			questionOrder: 1
		},
		{
			number: 26,
			question: "Fenster Bauart überall gleich? Material / Ausführung",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.g.group,
			groupOrder: technicalOnSiteChecklistGroups.g.groupOrder,
			questionOrder: 1
		},
		{
			number: 27,
			question: "Dämmung möglich? Laibungsdämmung, Überdämmung Blendrahmen",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.g.group,
			groupOrder: technicalOnSiteChecklistGroups.g.groupOrder,
			questionOrder: 2
		},
		{
			number: 28,
			question: "Verglasungsart (Einfach, Doppelt, ISO, WSV, SSV, Kasten)?",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.g.group,
			groupOrder: technicalOnSiteChecklistGroups.g.groupOrder,
			questionOrder: 3
		},
		{
			number: 29,
			question: "Besonderheiten (Scheibenzwischenraum, Undichtigkeiten?",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.g.group,
			groupOrder: technicalOnSiteChecklistGroups.g.groupOrder,
			questionOrder: 4
		},
		{
			number: 30,
			question: "Erneuerungen notwendig?",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.g.group,
			groupOrder: technicalOnSiteChecklistGroups.g.groupOrder,
			questionOrder: 5
		},
		{
			number: 31,
			question: "Material / Bauteilstärke",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.h.group,
			groupOrder: technicalOnSiteChecklistGroups.h.groupOrder,
			questionOrder: 1
		},
		{
			number: 32,
			question: "Sparren b / h und Sparrenabstand",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.h.group,
			groupOrder: technicalOnSiteChecklistGroups.h.groupOrder,
			questionOrder: 2
		},
		{
			number: 33,
			question: "Nachträgliche Dämmung?",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.h.group,
			groupOrder: technicalOnSiteChecklistGroups.h.groupOrder,
			questionOrder: 3
		},
		{
			number: 34,
			question: "Luftdichte Ebene?",
			mandatory: false,
			photoEvidenceRequired: "na",
			group: technicalOnSiteChecklistGroups.h.group,
			groupOrder: technicalOnSiteChecklistGroups.h.groupOrder,
			questionOrder: 4
		},
		{
			number: 35,
			question: "Innenverkleidung",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.h.group,
			groupOrder: technicalOnSiteChecklistGroups.h.groupOrder,
			questionOrder: 5
		},
		{
			number: 36,
			question: "Unterdach vorhanden?",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.h.group,
			groupOrder: technicalOnSiteChecklistGroups.h.groupOrder,
			questionOrder: 6
		},
		{
			number: 37,
			question: "Material / Bauteilstärke",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.i.group,
			groupOrder: technicalOnSiteChecklistGroups.i.groupOrder,
			questionOrder: 1
		},
		{
			number: 38,
			question: "Nachträgliche Dämmung vorhanden? Angaben über Baujahr, Eigenschaften und Material",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.i.group,
			groupOrder: technicalOnSiteChecklistGroups.i.groupOrder,
			questionOrder: 2
		},
		{
			number: 39,
			question: "Zustand Innenputz / verkleidung",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.i.group,
			groupOrder: technicalOnSiteChecklistGroups.i.groupOrder,
			questionOrder: 3
		},
		{
			number: 40,
			question: "Material / Bauteilstärke",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.j.group,
			groupOrder: technicalOnSiteChecklistGroups.j.groupOrder,
			questionOrder: 1
		},
		{
			number: 41,
			question: "Nachträgliche Dämmung?",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.j.group,
			groupOrder: technicalOnSiteChecklistGroups.j.groupOrder,
			questionOrder: 2
		},
		{
			number: 42,
			question: "Flächenaufnahme, Material, Bauteilstärke",
			mandatory: false,
			photoEvidenceRequired: "na",
			group: technicalOnSiteChecklistGroups.k.group,
			groupOrder: technicalOnSiteChecklistGroups.k.groupOrder,
			questionOrder: 1
		},
		{
			number: 43,
			question: "Deckenstärke",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.l.group,
			groupOrder: technicalOnSiteChecklistGroups.l.groupOrder,
			questionOrder: 1
		},
		{
			number: 44,
			question: "Material / Ausführung",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.l.group,
			groupOrder: technicalOnSiteChecklistGroups.l.groupOrder,
			questionOrder: 2
		},
		{
			number: 45,
			question: "Nachträgliche Dämmung",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.l.group,
			groupOrder: technicalOnSiteChecklistGroups.l.groupOrder,
			questionOrder: 3
		},
		{
			number: 46,
			question: "Denkmalpflegerische oder denkmalschutzrechtliche Auffäliggkeiten / Eigenschaften",
			mandatory: true,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.m.group,
			groupOrder: technicalOnSiteChecklistGroups.m.groupOrder,
			questionOrder: 1
		},
		{
			number: 47,
			question: "Erhaltenswerte Elemente? (Innendämmung erforderlich? Ausschlusskriterium zu prüfen)",
			mandatory: true,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.m.group,
			groupOrder: technicalOnSiteChecklistGroups.m.groupOrder,
			questionOrder: 2
		},
		{
			number: 48,
			question: "Brandschutzrechtliche Besonderheiten / Auffälligkeiten?",
			mandatory: true,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.m.group,
			groupOrder: technicalOnSiteChecklistGroups.m.groupOrder,
			questionOrder: 3
		},
		{
			number: 49,
			question: "Bauliche Besonderheiten? (Auskragende Bauteile, Vor- / Rücksprünge, Wintergarten etc.)",
			mandatory: true,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.m.group,
			groupOrder: technicalOnSiteChecklistGroups.m.groupOrder,
			questionOrder: 4
		},
		{
			number: 50,
			question: "Art, Alter und Zustand der Heizungsanlage",
			mandatory: true,
			photoEvidenceRequired: "m",
			group: technicalOnSiteChecklistGroups.n.group,
			groupOrder: technicalOnSiteChecklistGroups.n.groupOrder,
			questionOrder: 1
		},
		{
			number: 107,
			question: "Verortung Heizzentrale, Zuwegung Heizzentrale, Zustand Heizzentrale",
			mandatory: true,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.n.group,
			groupOrder: technicalOnSiteChecklistGroups.n.groupOrder,
			questionOrder: 2
		},
		{
			number: 108,
			question: "Anzahl Heizungszentralen je Objekt?",
			mandatory: true,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.n.group,
			groupOrder: technicalOnSiteChecklistGroups.n.groupOrder,
			questionOrder: 3
		},
		{
			number: 109,
			question: "Versorgungsbereich der Heizungsanlage (zentral, dezentral)",
			mandatory: true,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.n.group,
			groupOrder: technicalOnSiteChecklistGroups.n.groupOrder,
			questionOrder: 4
		},
		{
			number: 51,
			question: "Verteilung Raumwärme (Zweirohr, Einrohr, Sonstige)",
			mandatory: true,
			photoEvidenceRequired: "m",
			group: technicalOnSiteChecklistGroups.n.group,
			groupOrder: technicalOnSiteChecklistGroups.n.groupOrder,
			questionOrder: 5
		},
		{
			number: 110,
			question: "Zustand, Typ vorhandene Wärmedämmung an Rohrleitungen",
			mandatory: true,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.n.group,
			groupOrder: technicalOnSiteChecklistGroups.n.groupOrder,
			questionOrder: 6
		},
		{
			number: 111,
			question: "Verteilungsart (Strangsystem, Etagenverteilung, Kombination Strang und Etagenverteilung)",
			mandatory: true,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.n.group,
			groupOrder: technicalOnSiteChecklistGroups.n.groupOrder,
			questionOrder: 7
		},
		{
			number: 112,
			question: "Zugänglichkeit Schachtverteilung",
			mandatory: true,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.n.group,
			groupOrder: technicalOnSiteChecklistGroups.n.groupOrder,
			questionOrder: 8
		},
		{
			number: 113,
			question: "Abgasführung vorhanden, Zustand? (Muss Abgasanlage zurückgebaut werden?)",
			mandatory: true,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.n.group,
			groupOrder: technicalOnSiteChecklistGroups.n.groupOrder,
			questionOrder: 9
		},
		{
			number: 114,
			question: "Materialart Rohrleitung, Zustand Rohrleitung und Dämmung",
			mandatory: true,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.n.group,
			groupOrder: technicalOnSiteChecklistGroups.n.groupOrder,
			questionOrder: 10
		},
		{
			number: 115,
			question: "Art der Verbrauchserfassung (keine, Heizkostenverteiler, Wärmemengenzähler)",
			mandatory: true,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.n.group,
			groupOrder: technicalOnSiteChecklistGroups.n.groupOrder,
			questionOrder: 11
		},
		{
			number: 52,
			question: "Wärmeabgabe des Systems (Standardheizlörper, Fussbodenheizung, Niedertemperaturheizkörper, Sonstige), nach Raum",
			mandatory: false,
			photoEvidenceRequired: "m",
			group: technicalOnSiteChecklistGroups.n.group,
			groupOrder: technicalOnSiteChecklistGroups.n.groupOrder,
			questionOrder: 12
		},
		{
			number: 53,
			question: "Regelung der Wärmeübergabe (Handventile, Thermostatventile, Einzelraumregelung, Elektrische Regelung) nach Raum und Einbaujahr",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.n.group,
			groupOrder: technicalOnSiteChecklistGroups.n.groupOrder,
			questionOrder: 13
		},
		{
			number: 54,
			question: "Ist nach der letzten Änderung im Heizsystem ein hydraulischer Abgleich vorgenommen worden? (Ja, unbekannt, nein, Abgleich über Thermostate, Abgleich über Strangeregulierung)",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.n.group,
			groupOrder: technicalOnSiteChecklistGroups.n.groupOrder,
			questionOrder: 14
		},
		{
			number: 116,
			question: "Zustand Einrichtungsgegenstände",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.o.group,
			groupOrder: technicalOnSiteChecklistGroups.o.groupOrder,
			questionOrder: 1
		},
		{
			number: 117,
			question: "Zustand Rohrleitungsinstallation Trinkwasser, Schmutzwasser, Regenwasser",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.o.group,
			groupOrder: technicalOnSiteChecklistGroups.o.groupOrder,
			questionOrder: 2
		},
		{
			number: 118,
			question: "Zustand Sanitär Sonstiges",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.o.group,
			groupOrder: technicalOnSiteChecklistGroups.o.groupOrder,
			questionOrder: 3
		},
		{
			number: 119,
			question: "Zustand Hausanschluss und Hauptverteilung",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.p.group,
			groupOrder: technicalOnSiteChecklistGroups.p.groupOrder,
			questionOrder: 1
		},
		{
			number: 120,
			question: "Zustand Allgemeininstallation",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.p.group,
			groupOrder: technicalOnSiteChecklistGroups.p.groupOrder,
			questionOrder: 2
		},
		{
			number: 121,
			question: "Zustand Wohnungsinstallation",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.p.group,
			groupOrder: technicalOnSiteChecklistGroups.p.groupOrder,
			questionOrder: 3
		},
		{
			number: 122,
			question: "Zustand Kabine und Portale",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.q.group,
			groupOrder: technicalOnSiteChecklistGroups.q.groupOrder,
			questionOrder: 1
		},
		{
			number: 123,
			question: "Zustand Antrieb und Schachtinstallation",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.q.group,
			groupOrder: technicalOnSiteChecklistGroups.q.groupOrder,
			questionOrder: 2
		},
		{
			number: 55,
			question: "Wärmeerzeuger (Nah- / Fernwärmeanschluss, Wärmepumpe, Mit Übergabestation)",
			mandatory: true,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.r.group,
			groupOrder: technicalOnSiteChecklistGroups.r.groupOrder,
			questionOrder: 1
		},
		{
			number: 56,
			question: "Bauart",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.r.group,
			groupOrder: technicalOnSiteChecklistGroups.r.groupOrder,
			questionOrder: 2
		},
		{
			number: 57,
			question: "Typ-Bezeichnung",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.r.group,
			groupOrder: technicalOnSiteChecklistGroups.r.groupOrder,
			questionOrder: 3
		},
		{
			number: 58,
			question: "Hersteller",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.r.group,
			groupOrder: technicalOnSiteChecklistGroups.r.groupOrder,
			questionOrder: 4
		},
		{
			number: 59,
			question: "Anzahl",
			mandatory: false,
			photoEvidenceRequired: "na",
			group: technicalOnSiteChecklistGroups.r.group,
			groupOrder: technicalOnSiteChecklistGroups.r.groupOrder,
			questionOrder: 5
		},
		{
			number: 60,
			question: "Baujahr",
			mandatory: false,
			photoEvidenceRequired: "na",
			group: technicalOnSiteChecklistGroups.r.group,
			groupOrder: technicalOnSiteChecklistGroups.r.groupOrder,
			questionOrder: 6
		},
		{
			number: 61,
			question: "Energeieträger",
			mandatory: false,
			photoEvidenceRequired: "na",
			group: technicalOnSiteChecklistGroups.r.group,
			groupOrder: technicalOnSiteChecklistGroups.r.groupOrder,
			questionOrder: 7
		},
		{
			number: 62,
			question: "Standort (innerhalb / außerhalb thermischer Hülle)",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.r.group,
			groupOrder: technicalOnSiteChecklistGroups.r.groupOrder,
			questionOrder: 8
		},
		{
			number: 63,
			question: "Betriebsweise (Raumheizung, Warmwasser, beides)",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.r.group,
			groupOrder: technicalOnSiteChecklistGroups.r.groupOrder,
			questionOrder: 9
		},
		{
			number: 64,
			question: "Effizienzklasse",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.r.group,
			groupOrder: technicalOnSiteChecklistGroups.r.groupOrder,
			questionOrder: 10
		},
		{
			number: 65,
			question: "Typ (Abluftanlage, Zu- und Abluftanlage (dezentral), Zu- und Abluftanlage (zentral), keine)",
			mandatory: true,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.s.group,
			groupOrder: technicalOnSiteChecklistGroups.s.groupOrder,
			questionOrder: 1
		},
		{
			number: 124,
			question: "Typ Wohnraumlüftung (Fenster, Fensterfalz)",
			mandatory: true,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.s.group,
			groupOrder: technicalOnSiteChecklistGroups.s.groupOrder,
			questionOrder: 2
		},
		{
			number: 66,
			question: "Wärmerückgewinnungsgrad",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.s.group,
			groupOrder: technicalOnSiteChecklistGroups.s.groupOrder,
			questionOrder: 3
		},
		{
			number: 67,
			question: "Belüftete Räume und Regelung (Einzelraum mit/ohne zentrale Vorregelung)",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.s.group,
			groupOrder: technicalOnSiteChecklistGroups.s.groupOrder,
			questionOrder: 4
		},
		{
			number: 68,
			question: "Ventilator (Gleichstrom, Wechselstrom)",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.s.group,
			groupOrder: technicalOnSiteChecklistGroups.s.groupOrder,
			questionOrder: 5
		},
		{
			number: 69,
			question: "Wärmetauscher (ja/nein, Kreuzstromwärmetauscher/Gegenstromwärmetauscher)	",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.s.group,
			groupOrder: technicalOnSiteChecklistGroups.s.groupOrder,
			questionOrder: 6
		},
		{
			number: 70,
			question: "Verteilung (Innerhalb/außerhalb der thermischen Hülle)",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.s.group,
			groupOrder: technicalOnSiteChecklistGroups.s.groupOrder,
			questionOrder: 7
		},
		{
			number: 71,
			question: "Anordnung der Luftauslässe (Innen-/Außenwand)",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.s.group,
			groupOrder: technicalOnSiteChecklistGroups.s.groupOrder,
			questionOrder: 8
		},
		{
			number: 72,
			question: "Alter und Zustand der Sanitäranlagen",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.s.group,
			groupOrder: technicalOnSiteChecklistGroups.s.groupOrder,
			questionOrder: 9
		},
		{
			number: 73,
			question: "Kapazität und Zustand des Elektrosystems",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.s.group,
			groupOrder: technicalOnSiteChecklistGroups.s.groupOrder,
			questionOrder: 10
		},
		{
			number: 74,
			question: "Unterverteilung mit FI-SChutzschalter vorhanden?",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.s.group,
			groupOrder: technicalOnSiteChecklistGroups.s.groupOrder,
			questionOrder: 10
		},
		{
			number: 75,
			question: "E-Check (Prüfsiegel für die Unterverteilung) vorhanden?",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.s.group,
			groupOrder: technicalOnSiteChecklistGroups.s.groupOrder,
			questionOrder: 11
		},
		{
			number: 76,
			question: "Gibt es Informationen über die Qualität der Zu- und Abwasserleitungen? Abwasserdichtheitsprüfung klären",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.s.group,
			groupOrder: technicalOnSiteChecklistGroups.s.groupOrder,
			questionOrder: 12
		},
		{
			number: 77,
			question: "Dämmung: Jahr des Einbaus, Bauteil, Zustand, Material, Stärke",
			mandatory: true,
			photoEvidenceRequired: "m",
			group: technicalOnSiteChecklistGroups.t.group,
			groupOrder: technicalOnSiteChecklistGroups.t.groupOrder,
			questionOrder: 1
		},
		{
			number: 78,
			question: "Restiktionen für die Außenwanddämmung (z.B. Grenzbebauung, Dachüberstand etc.)",
			mandatory: true,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.t.group,
			groupOrder: technicalOnSiteChecklistGroups.t.groupOrder,
			questionOrder: 2
		},
		{
			number: 79,
			question: "Wärmebrücken (Decken, Fenster, Balkon/Terrasse), Anzahl",
			mandatory: true,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.t.group,
			groupOrder: technicalOnSiteChecklistGroups.t.groupOrder,
			questionOrder: 3
		},
		{
			number: 80,
			question: "Leitungsführung Gas unter Decke sichtbar/vorhanden?",
			mandatory: true,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.t.group,
			groupOrder: technicalOnSiteChecklistGroups.t.groupOrder,
			questionOrder: 4
		},
		{
			number: 81,
			question: "Heizungsleitung/-rohre in den Räumen auf Putz verlegt?",
			mandatory: true,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.t.group,
			groupOrder: technicalOnSiteChecklistGroups.t.groupOrder,
			questionOrder: 5
		},
		{
			number: 82,
			question: "Effizienz der aktuellen Heizungs- und Kühlsysteme",
			mandatory: true,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.t.group,
			groupOrder: technicalOnSiteChecklistGroups.t.groupOrder,
			questionOrder: 6
		},
		{
			number: 83,
			question: "Vorhandene Beleuchtungssysteme und deren Energieverbrauch",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.t.group,
			groupOrder: technicalOnSiteChecklistGroups.t.groupOrder,
			questionOrder: 7
		},
		{
			number: 84,
			question: "Wassernutzung und -konservierungssysteme",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.t.group,
			groupOrder: technicalOnSiteChecklistGroups.t.groupOrder,
			questionOrder: 8
		},
		{
			number: 85,
			question: "Vorhandene erneuerbare Energiesysteme (z. B. Solaranlagen)",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.t.group,
			groupOrder: technicalOnSiteChecklistGroups.t.groupOrder,
			questionOrder: 9
		},
		{
			number: 86,
			question: "Besteht der Verdacht auf Schadstoffe bzw. traten Fälle bereits im Gebäude/Nachbarwohnungen auf? z.B. Asbest, Blei, Hausschwamm, Legionellen?",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.u.group,
			groupOrder: technicalOnSiteChecklistGroups.u.groupOrder,
			questionOrder: 1
		},
		{
			number: 87,
			question: "Bestehen behördliche Auflagen bzgl. Denkmalschutz, Milieuschutz, soziale Erhaltungsgebiet, Sanierungsgebiet etc.",
			mandatory: false,
			photoEvidenceRequired: "na",
			group: technicalOnSiteChecklistGroups.v.group,
			groupOrder: technicalOnSiteChecklistGroups.v.groupOrder,
			questionOrder: 1
		},
		{
			number: 88,
			question: "Einhaltung der Zugänglichkeitsstandards",
			mandatory: false,
			photoEvidenceRequired: "na",
			group: technicalOnSiteChecklistGroups.v.group,
			groupOrder: technicalOnSiteChecklistGroups.v.groupOrder,
			questionOrder: 2
		},
		{
			number: 89,
			question: "Jeder sofortige Reparaturbedarf",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.w.group,
			groupOrder: technicalOnSiteChecklistGroups.w.groupOrder,
			questionOrder: 1
		},
		{
			number: 90,
			question: "Detaillierte Notizen zu Anomalien oder Bedenken",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.w.group,
			groupOrder: technicalOnSiteChecklistGroups.w.groupOrder,
			questionOrder: 2
		},
		{
			number: 91,
			question: "Vor Ort erstellte Skizzen oder zusätzliche Messungen",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.w.group,
			groupOrder: technicalOnSiteChecklistGroups.w.groupOrder,
			questionOrder: 3
		},
		{
			number: 92,
			question: "Feuchtigkeitsschäden an den Außenwänden erkennbar? Schimmel, Leckage etc.",
			mandatory: true,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.x.group,
			groupOrder: technicalOnSiteChecklistGroups.x.groupOrder,
			questionOrder: 1
		},
		{
			number: 93,
			question: "Rissbildung in Wänden erkennbar?",
			mandatory: true,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.x.group,
			groupOrder: technicalOnSiteChecklistGroups.x.groupOrder,
			questionOrder: 2
		},
		{
			number: 94,
			question: "Deckenhöhe der Räume im Standard?<br />Lichtes Maß zwischen 2,30 bis 2,50m",
			mandatory: true,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.x.group,
			groupOrder: technicalOnSiteChecklistGroups.x.groupOrder,
			questionOrder: 3
		},
		{
			number: 95,
			question: "Türhöhen und -breiten im Standard?<br />Höhe: Die gängigsten Türmaße in Millimeter (mm):<br />● 1985 mm<br />● 2110 mm<br />Breite: Die gängigsten Türmaße in Millimeter (mm):<br />● 610 mm<br />● 735 mm<br />● 860 mm<br />● 985 mm",
			mandatory: true,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.x.group,
			groupOrder: technicalOnSiteChecklistGroups.x.groupOrder,
			questionOrder: 4
		},
		{
			number: 96,
			question: "Nebenraum (Keller oder Dachboden) vorhanden?",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.x.group,
			groupOrder: technicalOnSiteChecklistGroups.x.groupOrder,
			questionOrder: 5
		},
		{
			number: 97,
			question: "Zustand Terrasse / Balkon?",
			mandatory: false,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.x.group,
			groupOrder: technicalOnSiteChecklistGroups.x.groupOrder,
			questionOrder: 6
		},
		{
			number: 98,
			question: "Sofern Altbau:<br />In welchem Zustand sind die Böden?<br />Besonderheiten, wie z.B. Dielenböden.<br />Sollen diese erhalten bleiben?",
			mandatory: true,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.y.group,
			groupOrder: technicalOnSiteChecklistGroups.y.groupOrder,
			questionOrder: 1
		},
		{
			number: 99,
			question: "Sofern Altbau:<br />In welchem Zustand sind die Türen? Sollen diese erhalten bleiben?",
			mandatory: true,
			photoEvidenceRequired: "opt",
			group: technicalOnSiteChecklistGroups.y.group,
			groupOrder: technicalOnSiteChecklistGroups.y.groupOrder,
			questionOrder: 2
		}
	];
}));
//#endregion
//#region src/domains/cross-cutting/mfh/due-diligence/dd-answer.model.ts
var MfhDDAnswerSchemas, isDDAnswerCompleted, isDDAnswerCritical;
var init_dd_answer_model = __esmMin((() => {
	init_errors();
	init_form();
	init_dd_overview_model();
	init_dd_v2_model();
	init_dd_generic_model();
	init_dd_opts();
	init_document_checklist_dd_model();
	init_sourcing_tasks_dd_model();
	init_technical_on_site_dd_model();
	MfhDDAnswerSchemas = {
		["DDOverview"]: overviewDDAnswerSchema,
		["MfhDocumentChecklist"]: documentChecklistAnswerSchema,
		["SourcingTasksDD"]: sourcingTasksDDAnswerSchema,
		["ObjectExaminationDD"]: genericDDAnswerSchema,
		["VicinityExaminationDD"]: genericDDAnswerSchema,
		["RentDD"]: genericDDAnswerSchema,
		["TechnicalDD"]: genericDDAnswerSchema,
		["TechnicalOnSiteDD"]: technicalOnSiteDDAnswerSchema,
		["LegalDD"]: genericDDAnswerSchema,
		["CommercialDD"]: genericDDAnswerSchema,
		["DealClosingDD"]: genericDDAnswerSchema,
		["MfhDDv2"]: mfhDDv2AnswerSchema
	};
	isDDAnswerCompleted = (question, ans) => {
		if (isDDAnswerCritical(question, ans)) return true;
		switch (question.type) {
			case "DDOverview": return true;
			case "MfhDocumentChecklist": return ans?.status === "AvailableChecked";
			case "SourcingTasksDD": return [
				"Yes",
				"Partially",
				"No"
			].includes(ans?.status);
			case "TechnicalOnSiteDD": return ans?.status === "closed";
			case "ObjectExaminationDD":
			case "VicinityExaminationDD":
			case "RentDD":
			case "TechnicalDD":
			case "LegalDD": return [
				"NotApplicable",
				"CannotBeChecked",
				"CheckedOk",
				"InformationIsMissingOk"
			].includes(ans?.status);
			case "MfhDDv2": return ans?.status === "Reviewed" || ans?.status === "Done";
			case "CommercialDD":
			case "DealClosingDD": return ans?.status === "Completed";
			default:
				question.type;
				throw new InvariantError(`dd answer completion check missing for type: ${question.type}`);
		}
	};
	isDDAnswerCritical = (question, ans) => {
		switch (question.type) {
			case "DDOverview":
			case "MfhDocumentChecklist":
			case "SourcingTasksDD":
			case "TechnicalOnSiteDD": return false;
			case "ObjectExaminationDD":
			case "VicinityExaminationDD":
			case "RentDD":
			case "TechnicalDD":
			case "LegalDD": return ans?.status === "CheckedCritical";
			case "MfhDDv2": return false;
			case "CommercialDD":
			case "DealClosingDD": return ans?.status === "ActionNeeded";
			default:
				question.type;
				throw new InvariantError(`dd answer critical check missing for type: ${question.type}`);
		}
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/due-diligence/dd-question.model.ts
var init_dd_question_model = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/due-diligence/dd-v2.helpers.ts
var ddV2DocumentCategoryToDocumentCategory, getDDv2DocumentCategoryLabel, isActiveDDv2Question, groupDDv2QuestionsByDocumentType, getDDv2ChecklistStatus, isDDv2AssessmentEmpty, normalizeDDv2Assessment, canApproveDDv2Question;
var init_dd_v2_helpers = __esmMin((() => {
	init_document();
	init_dd_v2_model();
	ddV2DocumentCategoryToDocumentCategory = {
		["Land"]: "Land",
		["Location"]: null,
		["Building"]: "Building",
		["ObjectManagement"]: "ObjectManagement",
		["RentalContract"]: "RentalContract",
		["MfhOther"]: "MfhOther"
	};
	getDDv2DocumentCategoryLabel = (category) => {
		const documentCategory = ddV2DocumentCategoryToDocumentCategory[category];
		return (documentCategory && documentCategoryTranslationsMap[documentCategory]) ?? DDv2DocumentCategoryTranslation[category];
	};
	isActiveDDv2Question = (question) => question.data?.basedOnDocument != null;
	groupDDv2QuestionsByDocumentType = (questions) => {
		const byDocumentType = /* @__PURE__ */ new Map();
		const withoutDocument = [];
		for (const question of questions) {
			const documentTypes = question.data?.document?.documentTypes ?? [];
			if (!documentTypes.length) {
				withoutDocument.push(question);
				continue;
			}
			for (const documentType of documentTypes) {
				let group = byDocumentType.get(documentType);
				if (!group) {
					group = {
						documentType,
						category: null,
						categoryLabel: null,
						documentLabel: documentTranslationsMap[documentType] ?? documentType,
						questions: []
					};
					byDocumentType.set(documentType, group);
				}
				if (!group.category) {
					const [category] = question.data.document.categories;
					if (category) {
						group.category = category;
						group.categoryLabel = getDDv2DocumentCategoryLabel(category);
					}
				}
				group.questions.push(question);
			}
		}
		return {
			groups: [...byDocumentType.values()].sort((a, b) => (a.categoryLabel ?? "").localeCompare(b.categoryLabel ?? "") || a.documentLabel.localeCompare(b.documentLabel)),
			withoutDocument
		};
	};
	getDDv2ChecklistStatus = (answer) => {
		if (answer?.status === "Reviewed" || answer?.status === "Done") return "Done";
		if (answer?.status === "ReadyForReview" || answer?.status === "NotFeasible") return "InReview";
		return isDDv2AssessmentEmpty(answer?.data?.assessmentResult) ? "Open" : "InProgress";
	};
	isDDv2AssessmentEmpty = (assessment) => !assessment?.replace(/<[^>]*>/g, "").replace(/&nbsp;|\u00a0/g, " ").trim();
	normalizeDDv2Assessment = (assessment) => isDDv2AssessmentEmpty(assessment) ? null : assessment;
	canApproveDDv2Question = (question, companyFunction) => companyFunction != null && (question.approvers ?? []).includes(companyFunction);
}));
//#endregion
//#region src/domains/cross-cutting/mfh/due-diligence/object-examination-dd.model.ts
var objectExaminationDDQuestions;
var init_object_examination_dd_model = __esmMin((() => {
	init_dd_opts();
	objectExaminationDDQuestions = [
		{
			number: 1,
			group: ["Grundstücksdaten"],
			task: "Initiale Begehung zur S/W Risikoprüfung",
			priority: "StageGate2",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 2,
			group: ["Grundstücksdaten"],
			task: "Grundstücksgröße",
			priority: "StageGate4",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 3,
			group: ["Grundstücksdaten"],
			task: "Gemarkung, Flurstücknummer",
			priority: "StageGate4",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 4,
			group: ["Grundstücksdaten"],
			task: "Katasterauszug (amtlicher Lageplan)",
			priority: "StageGate4",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 5,
			group: ["Grundstücksdaten"],
			task: "Aktuell geltendes Planungsrecht",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 6,
			group: ["Grundstücksdaten"],
			task: "Lasten in Abt. II (inkl. Eintragungsgrundlagen)",
			priority: "RiskPosition",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 7,
			group: ["Grundstücksdaten"],
			task: "Altlastengutachten",
			priority: "RiskPosition",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 8,
			group: ["Grundstücksdaten"],
			task: "Altlastenkatasterauszug",
			priority: "StageGate4",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 9,
			group: ["Grundstücksdaten"],
			task: "Baulasten",
			priority: "RiskPosition",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 10,
			group: ["Grundstücksdaten"],
			task: "Städtebauliche Verträge",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 11,
			group: ["Grundstücksdaten"],
			task: "Nachbarschaftsvereinbarungen",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 12,
			group: ["Grundstücksdaten"],
			task: "Erschließungs- und Ausbaubeiträge",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 13,
			group: ["Grundstücksdaten"],
			task: "Informationen zum Bebauungsplan (z.B. Baunutzungsverordnung, zulässige Geschosshöhe)",
			priority: "LongLeadTime",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 14,
			group: ["Grundstücksdaten"],
			task: "Umgebungsbebauung (z.B. Wohnbebauung, Gewerbegebiet, Grünflächen)",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 15,
			group: ["Grundstücksdaten"],
			task: "Verkehrsanbindung (z.B. ÖPNV, Autobahnen)",
			priority: "StageGate3",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 16,
			group: ["Grundstücksdaten"],
			task: "Eigentumsverhältnisse",
			priority: "StageGate3",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 17,
			group: ["Grundstücksdaten"],
			task: "Erbbaurecht",
			priority: "RiskPosition",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 18,
			group: ["Grundstücksdaten"],
			task: "Denkmalschutz",
			priority: "RiskPosition",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 19,
			group: ["Grundstücksdaten"],
			task: "Sanierungsgebiet",
			priority: "RiskPosition",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 20,
			group: ["Grundstücksdaten"],
			task: "Soziales Erhaltungsgebiet / Milieuschutzgebiet",
			priority: "RiskPosition",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 21,
			group: ["Grundstücksdaten"],
			task: "Städtebauliches Erhaltungsgbiet",
			priority: "RiskPosition",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 22,
			group: ["Grundstücksdaten"],
			task: "Baugrund-/Gründungsgutachten",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 23,
			group: ["Gebäudedaten"],
			task: "Baujahr",
			priority: "D2GCalculator",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 24,
			group: ["Gebäudedaten"],
			task: "Anzahl der Gebäude",
			priority: "D2GCalculator",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 25,
			group: ["Gebäudedaten"],
			task: "Anzahl der Residential Einheiten",
			priority: "D2GCalculator",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 26,
			group: ["Gebäudedaten"],
			task: "Anzahl der Commercial Einheiten",
			priority: "D2GCalculator",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 27,
			group: ["Gebäudedaten"],
			task: "Anzahl PKW Stellplätze",
			priority: "D2GCalculator",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 28,
			group: ["Gebäudedaten"],
			task: "Ausbau- & Aufstockungspotenzial",
			priority: "D2GCalculator",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 29,
			group: ["Gebäudedaten"],
			task: "PKW Ausbaupotenzial",
			priority: "D2GCalculator",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 30,
			group: ["Gebäudedaten"],
			task: "Grundrisse",
			priority: "StageGate3",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 31,
			group: ["Gebäudedaten"],
			task: "Energieträger",
			priority: "D2GCalculator",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 32,
			group: ["Gebäudedaten"],
			task: "Fernwärmeanschluss vorhanden / möglich",
			priority: "D2GCalculator",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 33,
			group: ["Gebäudedaten"],
			task: "Thermische Hülle (Dach, Keller, Balkone)",
			priority: "D2GCalculator",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 34,
			group: ["Gebäudedaten"],
			task: "Flächenberechnungen nach DIN 277 / gif",
			priority: "StageGate3",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 35,
			group: ["Gebäudedaten"],
			task: "Flächenberechnungen nach WoFlV",
			priority: "D2GCalculator",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 36,
			group: ["Gebäudedaten"],
			task: "Bauweise (z.B. Massivbau, Holzbau)",
			priority: "D2GCalculator",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 37,
			group: ["Gebäudedaten"],
			task: "Energieausweis (Verbrauchsausweis/Bedarfsausweis, Energieeffizienzklasse)",
			priority: "D2GCalculator",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 38,
			group: ["Gebäudedaten"],
			task: "Versicherungsschäden der letzten 5 Jahre",
			priority: "StageGate4",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 39,
			group: ["Wohnungsdaten"],
			task: "Zustand der einzelnen Wohnungen",
			priority: "StageGate3",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 40,
			group: ["Wohnungsdaten"],
			task: "Aufteilung erfolgt",
			priority: "StageGate3",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 41,
			group: ["Wohnungsdaten"],
			task: "Gibt es Teilungserklärung",
			priority: "StageGate3",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 42,
			group: ["Genehmigungen"],
			task: "Baugenehmigung (inkl. Dachgeschoss)",
			priority: "RiskPosition",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 43,
			group: ["Genehmigungen"],
			task: "Schlussabnahmeschein der Behörde",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 44,
			group: ["Genehmigungen"],
			task: "Bauvorbescheid",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 45,
			group: ["Genehmigungen"],
			task: "Bauantrag inkl. Stellplatznachweis",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 46,
			group: ["Genehmigungen"],
			task: "Baubeschreibung",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 47,
			group: ["Genehmigungen"],
			task: "Nutzungsgenehmigung",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 48,
			group: ["Genehmigungen"],
			task: "Spielplatz / Sportplatz o.ä. im Innenhof",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 49,
			group: ["Genehmigungen"],
			task: "Genehmigung für Stellplätze im Außenbereich",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 50,
			group: ["Genehmigungen"],
			task: "Überprüfung von Genehmigungsverfahren, Bauvorschriften und potenziellen Hindernissen für die Flächenerweiterung",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 51,
			group: ["Verträge mit Dritten"],
			task: "Hausverwaltung",
			priority: "StageGate4",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 52,
			group: ["Verträge mit Dritten"],
			task: "Dienstleister (z.B. Strom, Wasser, Gas, Abfallentsorgung)",
			priority: "StageGate4",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 53,
			group: ["Verträge mit Dritten"],
			task: "Wartungsverträge",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 54,
			group: ["Verträge mit Dritten"],
			task: "Wartungsprotokolle / Prüfberichte",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 55,
			group: ["Verträge mit Dritten"],
			task: "Wohngebäudeversicherung",
			priority: "StageGate4",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 56,
			group: ["Verträge mit Dritten"],
			task: "Haus- und Grundbesitzerhaftpflicht",
			priority: "StageGate4",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 57,
			group: ["Verträge mit Dritten"],
			task: "Gewässerschadenhaftpflichtversicherung (Öltanks)",
			priority: "StageGate4",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 58,
			group: ["Verträge mit Dritten"],
			task: "Prüfung Schornsteinfeger (Abgasanlage, bzw. Fettabluftanlage)",
			priority: "StageGate4",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 59,
			group: ["Rechtstreitigkeiten"],
			task: "Rechtstreitigkeiten (Nachbarn, Behörden etc.)",
			priority: "StageGate4",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		}
	];
}));
//#endregion
//#region src/domains/cross-cutting/mfh/due-diligence/commercial-dd.model.ts
var commercialDDQuestions;
var init_commercial_dd_model = __esmMin((() => {
	init_dd_opts();
	commercialDDQuestions = [
		{
			number: 1,
			group: ["CAPEX"],
			task: "CAPEX Flächenerweiterungen",
			priority: "StageGate4",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 2,
			group: ["CAPEX"],
			task: "CAPEX Energetische Ertüchtigung",
			priority: "StageGate4",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 3,
			group: ["CAPEX"],
			task: "CAPEX Wohnungssanierungen",
			priority: "StageGate4",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 4,
			group: ["CAPEX"],
			task: "Einschätzung Machbarkeit & Rentabilität Flächenerweiterungen + Umbauten",
			priority: "StageGate4",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 5,
			group: ["Fördermittel"],
			task: "BZA Voraussetzungen",
			priority: "StageGate4",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 6,
			group: ["Fördermittel"],
			task: "Machbarkeit Fördermittel",
			priority: "StageGate4",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 7,
			group: ["Fördermittel"],
			task: "Berechnung Fördermittel inkl. Anzahl BZA",
			priority: "StageGate4",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 8,
			group: ["Finanzierung"],
			task: "Finanzierungspartner",
			priority: "StageGate4",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 9,
			group: ["Finanzierung"],
			task: "Hausbank für KfW Abwicklung",
			priority: "StageGate4",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 10,
			group: ["Investment Proposal & Decision"],
			task: "Erstellung Investment Proposal",
			priority: "StageGate4",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 11,
			group: ["Investment Proposal & Decision"],
			task: "Exit Comps Recherche",
			priority: "StageGate4",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 12,
			group: ["Investment Proposal & Decision"],
			task: "Business Case Sensitivitäten prüfen",
			priority: "StageGate4",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 13,
			group: ["Investment Proposal & Decision"],
			task: "Approval",
			priority: "StageGate4",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 14,
			group: ["Investment Proposal & Decision"],
			task: "Erstes Kaufangebot abgeben",
			priority: "StageGate4",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 15,
			group: ["Investment Proposal & Decision"],
			task: "Exklusivität sichern",
			priority: "StageGate4",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 16,
			group: ["Investment Proposal & Decision"],
			task: "Finales Kaufangebot abgeben",
			priority: "StageGate4",
			requiredDocumentsSeller: "Nicht erforderlich"
		}
	];
}));
//#endregion
//#region src/domains/cross-cutting/mfh/due-diligence/vicinity-examination-dd.model.ts
var vicinityExaminationDDQuestions;
var init_vicinity_examination_dd_model = __esmMin((() => {
	init_dd_opts();
	vicinityExaminationDDQuestions = [
		{
			number: 1,
			group: ["Umwelttechnische Prüfung"],
			task: "Lärmbelastung",
			priority: "StageGate2",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 2,
			group: ["Umwelttechnische Prüfung"],
			task: "Kampfmittelbelastung",
			priority: "LongLeadTime",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 3,
			group: ["Umwelttechnische Prüfung"],
			task: "Luftqualität",
			priority: "StageGate3",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 4,
			group: ["Umwelttechnische Prüfung"],
			task: "Gewässerschutz",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 5,
			group: ["Lageeinschätzung"],
			task: "Umgebungsbebauung",
			priority: "StageGate3",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 6,
			group: ["Lageeinschätzung"],
			task: "Parken Umgebung",
			priority: "StageGate2",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 7,
			group: ["Lageeinschätzung"],
			task: "Nahversorgung",
			priority: "StageGate2",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 8,
			group: ["Lageeinschätzung"],
			task: "Soziale Infrastruktur",
			priority: "StageGate2",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 9,
			group: ["Lageeinschätzung"],
			task: "Image des Quartiers",
			priority: "StageGate2",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 10,
			group: ["Lageeinschätzung"],
			task: "ÖPNV",
			priority: "StageGate2",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 11,
			group: ["Lageeinschätzung"],
			task: "Klingelschilder / Mieterschichten",
			priority: "StageGate2",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 12,
			group: ["Lageeinschätzung"],
			task: "Stärken",
			priority: "StageGate2",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 13,
			group: ["Lageeinschätzung"],
			task: "Schwächen",
			priority: "StageGate2",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 14,
			group: ["Lageeinschätzung"],
			task: "Opportunitäten",
			priority: "StageGate2",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 15,
			group: ["Lageeinschätzung"],
			task: "Risiken",
			priority: "StageGate2",
			requiredDocumentsSeller: "Nicht erforderlich"
		}
	];
}));
//#endregion
//#region src/domains/cross-cutting/mfh/due-diligence/rent-dd.model.ts
var rentDDQuestions;
var init_rent_dd_model = __esmMin((() => {
	init_dd_opts();
	rentDDQuestions = [
		{
			number: 1,
			group: ["Mieter"],
			task: "Mieterliste (Nettokaltmiete, Fläche, Zimmeranzahl, Betriebskostenvorauszahlungen, Einzugsdatum, Mieterhöhungen)",
			priority: "LongLeadTime",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 2,
			group: ["Mieter"],
			task: "Vollständige Mietverträge (Wohnungen, Gewerbe, Stellplätze)",
			priority: "LongLeadTime",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 3,
			group: ["Mieter"],
			task: "Laufzeiten (Gewerbemietverträge)",
			priority: "StageGate4",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 4,
			group: ["Mieter"],
			task: "Möglicher Auszug von Mietern",
			priority: "StageGate4",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 5,
			group: ["Mieter"],
			task: "Mietenniveau",
			priority: "D2GCalculator",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 6,
			group: ["Mieter"],
			task: "Staffelmieten",
			priority: "StageGate4",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 7,
			group: ["Mieter"],
			task: "Indexmieten",
			priority: "StageGate4",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 8,
			group: ["Mieter"],
			task: "Mieten nach BGB §558",
			priority: "StageGate4",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 9,
			group: ["Mieter"],
			task: "Kündigungsfristen",
			priority: "StageGate4",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 10,
			group: ["Mieter"],
			task: "Mietsteigerungspotenzial (Gewerbe)",
			priority: "D2GCalculator",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 11,
			group: ["Mieter"],
			task: "Mietsteigerungspotenzial (Wohnen)",
			priority: "D2GCalculator",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 12,
			group: ["Mieter"],
			task: "Letzte Mieterhöhung / Datum letzte Mieterhöhung",
			priority: "StageGate4",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 13,
			group: ["Mieter"],
			task: "Widersprüche zur Mieterhöung",
			priority: "StageGate4",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 14,
			group: ["Mieter"],
			task: "Mieten unter / über 7 EUR",
			priority: "D2GCalculator",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 15,
			group: ["Mieter"],
			task: "Vermietete Speicher im Dachgeschoss",
			priority: "StageGate4",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 16,
			group: ["Mieter"],
			task: "Vermietete Stellplätze / Garagen",
			priority: "D2GCalculator",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 17,
			group: ["Mieter"],
			task: "Vermietete Keller",
			priority: "StageGate4",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 18,
			group: ["Mieter"],
			task: "Aufstellung der vorhandenen Mietsicherheiten",
			priority: "LongLeadTime",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 19,
			group: ["Mieter"],
			task: "Aufstellung der aktuellen Mietminderungen",
			priority: "LongLeadTime",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 20,
			group: ["Mieter"],
			task: "Aufstellung der Mietrückstände",
			priority: "LongLeadTime",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 21,
			group: ["Mieter"],
			task: "Alternativwohnungen der DG Mieter (Ausbau)",
			priority: "StageGate4",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 22,
			group: ["Mieter"],
			task: "Aufstellung (außer)gerichtlichen Rechtstreitigkeiten",
			priority: "StageGate4",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 23,
			group: ["Mieter"],
			task: "Ausbau- und Aufstockungspotential",
			priority: "D2GCalculator",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 24,
			group: ["Betriebskosten"],
			task: "Umlagefähige Kosten (Betriebs- und Heizkosten)",
			priority: "StageGate4",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 25,
			group: ["Betriebskosten"],
			task: "Nicht umlagefähige Kosten",
			priority: "StageGate4",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 26,
			group: ["Mietspiegel"],
			task: "Vergleichbare Wohnungen",
			priority: "D2GCalculator",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 27,
			group: ["Mietspiegel"],
			task: "Mietspiegel Lagenanalyse",
			priority: "StageGate4",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 28,
			group: ["Mietspiegel"],
			task: "Marktmiete",
			priority: "D2GCalculator",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 29,
			group: ["Leerstandsquote"],
			task: "Vermietungsstand / Leerstand Objekt",
			priority: "D2GCalculator",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 30,
			group: ["Leerstandsquote"],
			task: "Leerstandsrisiko",
			priority: "StageGate4",
			requiredDocumentsSeller: "Nicht erforderlich"
		}
	];
}));
//#endregion
//#region src/domains/cross-cutting/mfh/due-diligence/technical-dd.model.ts
var technicalDDQuestions;
var init_technical_dd_model = __esmMin((() => {
	init_dd_opts();
	technicalDDQuestions = [
		{
			number: 1,
			group: ["Bauwerk & Baukonstruktion"],
			task: "Tragwerk",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 2,
			group: ["Bauwerk & Baukonstruktion"],
			task: "Baustatik",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 3,
			group: ["Bauwerk & Baukonstruktion"],
			task: "Gebäudesubstanz",
			priority: "StageGate3",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 4,
			group: ["Bauwerk & Baukonstruktion"],
			task: "Zustand Dämmung Innenbereich",
			priority: "StageGate3",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 5,
			group: ["Bauwerk & Baukonstruktion"],
			task: "Feuchtigkeitsschäden",
			priority: "StageGate3",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 6,
			group: ["Bauwerk & Baukonstruktion"],
			task: "Schimmelpilzbefall",
			priority: "StageGate3",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 7,
			group: ["Bauwerk & Baukonstruktion"],
			task: "Schadstoffe (z.B. Asbest, PCB)",
			priority: "RiskPosition",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 8,
			group: ["Bauwerk & Baukonstruktion"],
			task: "Standsicherheit",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 9,
			group: ["Bauwerk & Baukonstruktion"],
			task: "Dach",
			priority: "StageGate3",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 10,
			group: ["Bauwerk & Baukonstruktion"],
			task: "Fassade",
			priority: "StageGate3",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 11,
			group: ["Bauwerk & Baukonstruktion"],
			task: "Fenster",
			priority: "StageGate3",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 12,
			group: ["Bauwerk & Baukonstruktion"],
			task: "Türen",
			priority: "StageGate3",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 13,
			group: ["Bauwerk & Baukonstruktion"],
			task: "Balkone",
			priority: "StageGate3",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 14,
			group: ["Bauwerk & Baukonstruktion"],
			task: "Kellerräume",
			priority: "StageGate3",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 15,
			group: ["Bauwerk & Baukonstruktion"],
			task: "Tiefgarage",
			priority: "StageGate3",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 16,
			group: ["Bauwerk & Baukonstruktion"],
			task: "Hygieneprüfung Trinkwasser",
			priority: "RiskPosition",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 17,
			group: ["Bauwerk & Baukonstruktion"],
			task: "Dichtigkeitsprüfungen bzw. Kamerabefahrungen SW & RW Erdreich",
			priority: "RiskPosition",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 18,
			group: ["Bauwerk & Baukonstruktion"],
			task: "Wartungsnachweise / Wartungsplan",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 19,
			group: ["Bauwerk & Baukonstruktion"],
			task: "Schallschutzgutachten Innen / Außen",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 20,
			group: ["Bauwerk & Baukonstruktion"],
			task: "Bauwerksgutachten (z.B. Tiefgarage, Fassade, Lüftung etc.)",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 21,
			group: ["Bauwerk & Baukonstruktion"],
			task: "Gutachten Gebäudeschadstoffe",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 22,
			group: ["Brandschutz"],
			task: "Brandschutzkonzept / -gutachten, Pläne, Protokolle Feuerwehr",
			priority: "RiskPosition",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 23,
			group: ["Brandschutz"],
			task: "Konformitätsbescheinigung des Brandschutzsachverständigen",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 24,
			group: ["Brandschutz"],
			task: "Nachweis Fahrrad- und Kinderwagenstellplätze sowie Kinderspielplatzflächen.",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 25,
			group: ["Brandschutz"],
			task: "Auflistung Baumbestand, der unter Naturschutz steht.",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 26,
			group: ["Brandschutz"],
			task: "Auflistung der Stellplätze im Außenbereich.",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 27,
			group: ["Technische Gebäudeausrüstung"],
			task: "Haustechnik (z.B. Heizung, Lüftung, Sanitär, Elektrik) inkl. jeweilige Baujahre der Technik in den Wohneinheiten",
			priority: "StageGate3",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 28,
			group: ["Technische Gebäudeausrüstung"],
			task: "Aufzüge",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 29,
			group: ["Technische Gebäudeausrüstung"],
			task: "Prüfberichte von Sachverständigen (z.B. TÜV)",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 30,
			group: ["Technische Gebäudeausrüstung"],
			task: "Wartungsverträge für technische Anlagen",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 31,
			group: ["Technische Gebäudeausrüstung"],
			task: "Gefährdungsbeurteilung Förderanlagen",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 32,
			group: ["Technische Gebäudeausrüstung"],
			task: "Hygieneprüfung Lüftungsanlagen",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 33,
			group: ["Technische Gebäudeausrüstung"],
			task: "Aufstellung Heizflächen bzw. Heizkörper",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 34,
			group: ["Technische Gebäudeausrüstung"],
			task: "TGA-Pläne Sanitär, Feuerlösch, Heizung, RLT, Kälte, Elektro, Fernmelde- und informationstechnische Anlagen, Aufzüge, Gebäudeautomation Bestand (Grundrisse in M1:50, Schnitte, Details) jeweils nach Gewerk / Anlage getrennt",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 35,
			group: ["Technische Gebäudeausrüstung"],
			task: "TGA-Schemata für Sanitär, Feuerlösch, Heizung, RLT, Kälte, Elektro, Fernmelde- und informationstechnische Anlagen, Aufzüge, Gebäudeautomation",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 36,
			group: ["Technische Gebäudeausrüstung"],
			task: "Leistungsbilanzen / Bedarfsberechnungen / Dimensionierung / Inbetriebnahme- und Einstellprotokolle für Sanitär, Feuerlösch, Heizung, RLT, Kälte, Elektro, Fernmelde- und informations-technische Anlagen, Aufzüge, Gebäudeautomation",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 37,
			group: ["Unterhaltungszustand"],
			task: "Liste wesentl. Instandhaltungs-/Instandsetzungsmaßnahmen",
			priority: "StageGate4",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 38,
			group: ["Unterhaltungszustand"],
			task: "Modernisierungstand",
			priority: "StageGate3",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 39,
			group: ["Unterhaltungszustand"],
			task: "Protokolle der Sachverständigen- bzw. Sachkundigenprüfung für prüfpflichtige Anlagen",
			priority: "StageGate4",
			requiredDocumentsSeller: "Wünschenswert"
		},
		{
			number: 40,
			group: ["Unterhaltungszustand"],
			task: "Aufstellung bestehender Gewährleistungsansprüche / -fristen",
			priority: "StageGate4",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		}
	];
}));
//#endregion
//#region src/domains/cross-cutting/mfh/due-diligence/deal-closing-dd.model.ts
var dealClosingDDQuestions;
var init_deal_closing_dd_model = __esmMin((() => {
	init_dd_opts();
	dealClosingDDQuestions = [
		{
			number: 1,
			group: ["Notartermin"],
			task: "Kaufvertrag anfordern",
			priority: "StageGate5",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 2,
			group: ["Notartermin"],
			task: "Notartermin Terminierung",
			priority: "StageGate5",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 3,
			group: ["Notartermin"],
			task: "Vertretungsvollmachten einholen",
			priority: "StageGate5",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 4,
			group: ["Notartermin"],
			task: "Abstimmung Kaufvertrag",
			priority: "StageGate5",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 5,
			group: ["Notartermin"],
			task: "Finanzierungsunterlagen bereitstellen",
			priority: "StageGate5",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 6,
			group: ["Conditions Precedent"],
			task: "Beurkundung",
			priority: "StageGate5",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 7,
			group: ["Conditions Precedent"],
			task: "Bewilligte Grundbuchrichtigstellung ist eingetragen",
			priority: "StageGate5",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 8,
			group: ["Conditions Precedent"],
			task: "Bewilligte Vormerkung ist eingetragen",
			priority: "StageGate5",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 9,
			group: ["Conditions Precedent"],
			task: "Verzichtserklärung oder Negativzeugnisse zu Vorkaufsrechten liegen vor",
			priority: "StageGate5",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 10,
			group: ["Conditions Precedent"],
			task: "Mitteilung der Gläubiger zu nicht übernommenen Grundbuchbelastungen",
			priority: "StageGate5",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 11,
			group: ["Conditions Precedent"],
			task: "Fälligkeitsmitteilung",
			priority: "StageGate5",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 12,
			group: ["Conditions Precedent"],
			task: "Abwicklung der Zahlungen",
			priority: "StageGate5",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 13,
			group: ["Handover"],
			task: "Archivierung aller finaler Dokumente",
			priority: "StageGate5",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 14,
			group: ["Handover"],
			task: "Kick-Off Construction Handover",
			priority: "StageGate5",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 15,
			group: ["Handover"],
			task: "Hausverwaltung übernehmen",
			priority: "StageGate5",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 16,
			group: ["Handover"],
			task: "Mieterkommunikation vorbereiten",
			priority: "StageGate5",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 17,
			group: ["Handover"],
			task: "Versicherungen übernehmen/ändern",
			priority: "StageGate5",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 18,
			group: ["Finanzierung"],
			task: "Banken Teaser Erstellen",
			priority: "StageGate5",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 19,
			group: ["Finanzierung"],
			task: "Reach-Out Long List",
			priority: "StageGate5",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 20,
			group: ["Finanzierung"],
			task: "Verhandlung mit Short-List",
			priority: "StageGate5",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 21,
			group: ["Finanzierung"],
			task: "Senior- und Non-Subsidized Debt Finanzierung sichern",
			priority: "StageGate5",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 22,
			group: ["Finanzierung"],
			task: "Business Case Aktualisieren (Finanzkonditionen)",
			priority: "StageGate5",
			requiredDocumentsSeller: "Nicht erforderlich"
		}
	];
}));
//#endregion
//#region src/domains/cross-cutting/mfh/due-diligence/legal-dd.model.ts
var RequiredDocumentsSeller, legalDDQuestions;
var init_legal_dd_model = __esmMin((() => {
	init_dd_opts();
	RequiredDocumentsSeller = /* @__PURE__ */ function(RequiredDocumentsSeller) {
		RequiredDocumentsSeller["notRequired"] = "Nicht erforderlich";
		RequiredDocumentsSeller["criticalRequired"] = "Kritisch - erforderlich";
		return RequiredDocumentsSeller;
	}({});
	legalDDQuestions = [
		{
			number: 1,
			group: ["Kaufvertrag"],
			task: "Kaufpreis",
			priority: "StageGate4",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 2,
			group: ["Kaufvertrag"],
			task: "Zahlungskonditionen",
			priority: "StageGate4",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 3,
			group: ["Kaufvertrag"],
			task: "Übergabemodalitäten",
			priority: "StageGate4",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 4,
			group: ["Kaufvertrag"],
			task: "Gewährleistung / Garantien",
			priority: "StageGate4",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 5,
			group: ["Kaufvertrag"],
			task: "Rücktrittsrechte",
			priority: "StageGate4",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 6,
			group: ["Kaufvertrag"],
			task: "Due Diligence Klauseln",
			priority: "StageGate4",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 7,
			group: ["Kaufvertrag"],
			task: "Aufschiebende Bedingung",
			priority: "StageGate4",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 8,
			group: ["Kaufvertrag"],
			task: "KYC Check",
			priority: "StageGate4",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 9,
			group: ["Kaufvertrag"],
			task: "AML Check",
			priority: "StageGate4",
			requiredDocumentsSeller: "Kritisch - erforderlich"
		},
		{
			number: 10,
			group: ["Kaufvertrag"],
			task: "Kaufvertragsentwurf prüfen",
			priority: "StageGate4",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 11,
			group: ["Mietrecht"],
			task: "Juristische Prüfung der Gewerbemietverträge",
			priority: "StageGate4",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 12,
			group: ["Mietrecht"],
			task: "Juristische Prüfung der Wohnraummietverträge",
			priority: "StageGate4",
			requiredDocumentsSeller: "Nicht erforderlich"
		},
		{
			number: 13,
			group: ["Mietrecht"],
			task: "Prüfung der Rent-Roll Mieterhöhungen",
			priority: "StageGate4",
			requiredDocumentsSeller: "Nicht erforderlich"
		}
	];
}));
//#endregion
//#region src/domains/cross-cutting/review-process/review-process-requests.ts
var init_review_process_requests = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/review-process/review-process.base.ts
var ReviewProcessEvents, ReviewRequestState, ReviewProcessState, ReviewProcessType;
var init_review_process_base = __esmMin((() => {
	ReviewProcessEvents = /* @__PURE__ */ function(ReviewProcessEvents) {
		ReviewProcessEvents["CreateReviewProcess"] = "CreateReviewProcess";
		ReviewProcessEvents["ReviewRequestUpdated"] = "ReviewRequestUpdated";
		ReviewProcessEvents["CancelReviewProcess"] = "CancelReviewProcess";
		ReviewProcessEvents["ResetReviewProcess"] = "ResetReviewProcess";
		ReviewProcessEvents["ReviewProcessUpdated"] = "ReviewProcessUpdated";
		return ReviewProcessEvents;
	}({});
	ReviewRequestState = /* @__PURE__ */ function(ReviewRequestState) {
		ReviewRequestState["Pending"] = "Pending";
		ReviewRequestState["Requested"] = "Requested";
		ReviewRequestState["Rejected"] = "Rejected";
		ReviewRequestState["Approved"] = "Approved";
		ReviewRequestState["Cancelled"] = "Cancelled";
		return ReviewRequestState;
	}({});
	ReviewProcessState = /* @__PURE__ */ function(ReviewProcessState) {
		ReviewProcessState["Requested"] = "Requested";
		ReviewProcessState["Cancelled"] = "Cancelled";
		ReviewProcessState["Approved"] = "Approved";
		ReviewProcessState["Rejected"] = "Rejected";
		return ReviewProcessState;
	}({});
	ReviewProcessType = /* @__PURE__ */ function(ReviewProcessType) {
		ReviewProcessType["Portfolio"] = "Portfolio";
		ReviewProcessType["ConstructionPlan"] = "ConstructionPlan";
		ReviewProcessType["InvestmentCase"] = "InvestmentCase";
		return ReviewProcessType;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/review-process/review-request.class.ts
var ReviewRequest;
var init_review_request_class = __esmMin((() => {
	init_base();
	ReviewRequest = class ReviewRequest extends BaseClassAttributes {
		reviewRequestId;
		reviewProcessId;
		uuid;
		userUid;
		companyId;
		reviewRequestState = "Requested";
		reviewDate;
		userContact;
		company;
		notes = [];
		reviewProcess;
		constructor(review) {
			super(review);
			Object.assign(this, review);
		}
		clone() {
			return new ReviewRequest(this);
		}
		get isRequested() {
			return this.reviewRequestState === "Requested";
		}
		get isRejected() {
			return this.reviewRequestState === "Rejected";
		}
		get isCancelled() {
			return this.reviewRequestState === "Cancelled";
		}
		get isResettable() {
			return !this.reviewProcess?.isFinished && !this.reviewProcess?.isCancelled && !this.isRequested;
		}
		get isReviewable() {
			return !this.isCancelled && !this.reviewProcess?.isFinished && !this.reviewProcess?.isCancelled;
		}
		get isApproved() {
			return this.reviewRequestState === "Approved";
		}
		get isPending() {
			return this.reviewRequestState === "Pending";
		}
	};
}));
//#endregion
//#region src/domains/cross-cutting/review-process/review-process.class.ts
var DEFAULT_REVIEWERS_NUMBER, ReviewProcess;
var init_review_process_class = __esmMin((() => {
	init_base();
	init_errors();
	init_review_request_class();
	DEFAULT_REVIEWERS_NUMBER = 1;
	ReviewProcess = class ReviewProcess extends BaseClassAttributes {
		reviewProcessId;
		reviewProcessState = "Requested";
		requiredApprovals = 1;
		requestedByUserUid;
		investmentCaseId;
		mfhInvestmentCaseId;
		mfhRenovationProjectCostBreakdownId;
		mfhPortfolioId;
		constructionPlanId;
		portfolioId;
		salesPackageId;
		floorPlanId;
		rentalContractId;
		inspectionId;
		invoiceId;
		reviewRequestsOrder;
		requestedByUser;
		portfolio;
		constructionPlan;
		investmentCase;
		mfhInvestmentCase;
		mfhRenovationProjectCostBreakdown;
		mfhPortfolio;
		salesPackage;
		floorPlan;
		rentalContract;
		inspection;
		reviewsRequests = [];
		assignees;
		constructor(reviewProcess) {
			super(reviewProcess);
			if (reviewProcess) Object.assign(this, reviewProcess);
			this.assignReviewRequests(reviewProcess);
		}
		assignReviewRequests(reviewProcess) {
			if (reviewProcess?.reviewsRequests) {
				const reviewsRequests = reviewProcess.reviewsRequests.map((r) => new ReviewRequest({
					...r,
					reviewProcess: this.clone(omit(this, "reviewsRequests"))
				}));
				if (this.reviewRequestsOrder?.length) reviewsRequests.sort((a, b) => {
					return (this.reviewRequestsOrder?.indexOf(a.uuid) ?? Number.POSITIVE_INFINITY) - (this.reviewRequestsOrder?.indexOf(b.uuid) ?? Number.POSITIVE_INFINITY);
				});
				this.reviewsRequests = reviewsRequests;
			}
		}
		clone(base = this) {
			const reviewsRequests = base.reviewsRequests?.map((r) => r.clone());
			return new ReviewProcess({
				...base,
				reviewsRequests
			});
		}
		get isCancelled() {
			return this.reviewProcessState === "Cancelled";
		}
		get isRequested() {
			return this.reviewProcessState === "Requested";
		}
		get isFinished() {
			return this.isApproved || this.isRejected;
		}
		get isApproved() {
			return this.reviewProcessState === "Approved";
		}
		get isRejected() {
			return this.reviewProcessState === "Rejected";
		}
		get estate() {
			return this.constructionPlan?.estate ?? this.investmentCase?.estate ?? this.floorPlan?.documentRelation?.[0]?.estate ?? this.rentalContract?.estate ?? this.inspection?.estate;
		}
		get mfh() {
			return this.mfhInvestmentCase?.mfh;
		}
		get isOrdered() {
			return Array.isArray(this.reviewRequestsOrder);
		}
		cancelReviewProcess() {
			this.reviewsRequests = this.reviewsRequests.map((r) => new ReviewRequest({
				...r,
				reviewRequestState: "Cancelled",
				reviewProcess: this.clone(omit(this, "reviewsRequests"))
			}));
		}
		resetReviewProcess() {
			this.reviewProcessState = "Requested";
			if (this.reviewRequestsOrder?.length) {
				this.reviewsRequests = this.reviewsRequests.map((r) => new ReviewRequest({
					...r,
					reviewRequestState: "Pending",
					userUid: r.companyId ? null : r.userUid,
					reviewProcess: this.clone(omit(this, "reviewsRequests"))
				}));
				this.maybeActivatePendingRequests();
			} else this.reviewsRequests = this.reviewsRequests.map((r) => new ReviewRequest({
				...r,
				reviewRequestState: "Requested",
				userUid: r.companyId ? null : r.userUid,
				reviewProcess: this.clone(omit(this, "reviewsRequests"))
			}));
		}
		hasEnoughApprovals() {
			return this.reviewsRequests.filter((r) => r.reviewRequestState === "Approved").length === this.requiredApprovals;
		}
		hasAnyRejections() {
			return this.reviewsRequests.some((r) => r.reviewRequestState === "Rejected");
		}
		isAllReviewGiven() {
			return this.countReviews() === this.requiredApprovals;
		}
		countReviews() {
			return this.reviewsRequests.filter((r) => !["Requested", "Pending"].includes(r.reviewRequestState)).length;
		}
		maybeActivatePendingRequests() {
			if (!this.reviewRequestsOrder?.length) return;
			for (const requestUuid of this.reviewRequestsOrder) {
				const request = this.reviewsRequests.find((r) => r.uuid === requestUuid);
				if (!request) throw new EntityNotFoundError("review request in order list but not found in review process");
				if (request.isRequested || request.isCancelled || request.isRejected) return;
				if (request.isPending) {
					request.reviewRequestState = "Requested";
					return;
				}
			}
		}
	};
}));
//#endregion
//#region src/domains/cross-cutting/review-process/review-process.model.ts
var BaseReviewProcessSchema;
var init_review_process_model = __esmMin((() => {
	init_lib();
	init_review_process_base();
	BaseReviewProcessSchema = Type.Object({
		reviewProcessId: Type.Number(),
		reviewProcessState: Type.Optional(TEnum(ReviewProcessState)),
		requiredApprovals: Type.Optional(Type.Number()),
		requestedByUserUid: Type.Optional(Type.String()),
		investmentCaseId: Type.Optional(Type.Number()),
		mfhInvestmentCaseId: Type.Optional(Type.Number()),
		mfhPortfolioId: Type.Optional(Type.Number()),
		constructionPlanId: Type.Optional(Type.Number()),
		portfolioId: Type.Optional(Type.Number()),
		salesPackageId: Type.Optional(Type.Number()),
		floorPlanId: Type.Optional(Type.Number()),
		rentalContractId: Type.Optional(Type.Number()),
		inspectionId: Type.Optional(Type.Number()),
		invoiceId: Type.Optional(Type.Number()),
		mfhRenovationProjectCostBreakdownId: Type.Optional(Type.Number()),
		reviewRequestsOrder: Type.Optional(TNullable(Type.Array(Type.String()))),
		assignees: Type.Optional(Type.Array(Type.String())),
		createdAt: Type.Optional(StringDateSchema),
		updatedAt: Type.Optional(StringDateSchema)
	}, { $id: "BaseReviewProcess" });
}));
//#endregion
//#region src/domains/cross-cutting/review-process/review-request.model.ts
var init_review_request_model = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/review-process/index.ts
var init_review_process = __esmMin((() => {
	init_review_process_requests();
	init_review_process_base();
	init_review_process_class();
	init_review_process_model();
	init_review_request_class();
	init_review_request_model();
}));
//#endregion
//#region src/domains/renting/rental-contract-unit/rental-contract-unit.model.ts
var BaseRentalContractUnitSchema, RentalContractUnitSchema;
var init_rental_contract_unit_model = __esmMin((() => {
	init_lib();
	BaseRentalContractUnitSchema = Type.Object({
		rentalContractUnitId: Type.Number(),
		rentalContractId: Type.Optional(TNullable(Type.Number())),
		rentableUnitId: Type.Number(),
		rentingProcessId: Type.Number()
	}, { $id: "BaseRentalContractUnit" });
	RentalContractUnitSchema = Type.Intersect([Type.Ref(BaseRentalContractUnitSchema), Type.Object({
		rentalContract: Type.Optional(Type.Ref("BaseRentalContract")),
		rentableUnit: Type.Optional(Type.Ref("RentableUnit")),
		rentingProcess: Type.Optional(Type.Ref("RentingProcess")),
		rents: Type.Optional(Type.Array(Type.Ref("BaseRent")))
	})], { $id: "RentalContractUnitSchema" });
}));
//#endregion
//#region src/domains/renting/rental-contract/rental-contract.model.ts
var RentalContractRentIncreaseType, RentalContractStatus, RentalContractType, RentIncreaseFormula, FRIIncreaseAmountType, RentTenancyRentIncreaseTypeEnumSchema, RentIncreaseFormulaEnumSchema, FriIncreaseAmountTypeEnumSchema, RentApartmentConditionEnumSchema, CondoSalesConditionEnumSchema, RentalContractStatusEnumSchema, RentalContractTypeEnumSchema, BaseRentalContractSchema, RentalContractSchema, rentalContractSchemas;
var init_rental_contract_model = __esmMin((() => {
	init_lib();
	init_document();
	init_review_process();
	init_rent_tenancy_model();
	init_rental_contract_unit_model();
	RentalContractRentIncreaseType = /* @__PURE__ */ function(RentalContractRentIncreaseType) {
		RentalContractRentIncreaseType["NO_INCREASE"] = "NO_INCREASE";
		RentalContractRentIncreaseType["MANUAL"] = "MANUAL";
		RentalContractRentIncreaseType["IRI"] = "IRI";
		RentalContractRentIncreaseType["FRI"] = "FRI";
		return RentalContractRentIncreaseType;
	}({});
	RentalContractStatus = /* @__PURE__ */ function(RentalContractStatus) {
		RentalContractStatus["Draft"] = "Draft";
		RentalContractStatus["Approved"] = "Approved";
		RentalContractStatus["Cancelled"] = "Cancelled";
		RentalContractStatus["Signed"] = "Signed";
		return RentalContractStatus;
	}({});
	RentalContractType = /* @__PURE__ */ function(RentalContractType) {
		RentalContractType["Regular"] = "Regular";
		RentalContractType["Addendum"] = "Addendum";
		RentalContractType["Sublease"] = "Sublease";
		return RentalContractType;
	}({});
	RentIncreaseFormula = /* @__PURE__ */ function(RentIncreaseFormula) {
		RentIncreaseFormula["FRI"] = "FRI";
		RentIncreaseFormula["BasicIRI"] = "BasicIRI";
		RentIncreaseFormula["IRIMinCap"] = "IRIMinCap";
		RentIncreaseFormula["IRIMaxCap"] = "IRIMaxCap";
		RentIncreaseFormula["IRIAveraged"] = "IRIAveraged";
		return RentIncreaseFormula;
	}({});
	FRIIncreaseAmountType = /* @__PURE__ */ function(FRIIncreaseAmountType) {
		FRIIncreaseAmountType["Percentage"] = "Percentage";
		FRIIncreaseAmountType["Fixed"] = "Fixed";
		return FRIIncreaseAmountType;
	}({});
	RentTenancyRentIncreaseTypeEnumSchema = TEnum(RentalContractRentIncreaseType, { $id: "RentTenancyRentIncreaseTypeEnum" });
	RentIncreaseFormulaEnumSchema = TEnum(RentIncreaseFormula, { $id: "RentIncreaseFormulaEnum" });
	FriIncreaseAmountTypeEnumSchema = TEnum(FRIIncreaseAmountType, { $id: "FriIncreaseAmountTypeEnum" });
	RentApartmentConditionEnumSchema = TEnum(RentApartmentCondition, { $id: "RentApartmentConditionEnum" });
	CondoSalesConditionEnumSchema = TEnum(CondoSalesCondition, { $id: "CondoSalesConditionEnum" });
	RentalContractStatusEnumSchema = TEnum(RentalContractStatus, { $id: "RentalContractStatusEnum" });
	RentalContractTypeEnumSchema = TEnum(RentalContractType, { $id: "RentalContractTypeEnum" });
	BaseRentalContractSchema = Type.Object({
		rentalContractId: Type.Optional(Type.Number()),
		status: Type.Ref(RentalContractStatusEnumSchema, { default: "Draft" }),
		type: Type.Ref(RentalContractTypeEnumSchema, { default: "Regular" }),
		estateId: Type.Number(),
		rentTenancyId: Type.Optional(TNullable(Type.Number())),
		documentId: Type.Optional(TNullable(Type.Number())),
		estarCoreRentalContractId: Type.Optional(TNullable(Type.String())),
		parentTenancyId: Type.Optional(TNullable(Type.Number())),
		parentId: Type.Optional(TNullable(Type.Number())),
		startDate: Type.Optional(Type.Union([StringDateSchema, Type.Null()])),
		endDate: Type.Optional(Type.Union([StringDateSchema, Type.Null()])),
		coldRent: Type.Optional(TNullable(Type.Number())),
		heatingCost: Type.Optional(TNullable(Type.Number())),
		utilityCost: Type.Optional(TNullable(Type.Number())),
		monthlyAdditionalRent: Type.Optional(TNullable(Type.Number())),
		parkingSpaceRent: Type.Optional(TNullable(Type.Number())),
		hasParkingSpace: Type.Optional(TNullable(Type.Boolean())),
		isColdRentWithParking: Type.Boolean(),
		isJobCenter: Type.Optional(TNullable(Type.Boolean())),
		isSecondaryRent: Type.Optional(TNullable(Type.Boolean())),
		numberOfTenantsAtViewing: Type.Optional(TNullable(Type.Number())),
		/**
		* @deprecated Use rentingLeadId instead
		*/
		tenantsWithNetIncome: Type.Optional(TNullable(Type.Array(Type.Union([Type.Object({
			tenantId: Type.Number(),
			netIncome: Type.Optional(TNullable(Type.Number()))
		}), Type.Object({ tenantCompanyId: Type.Number() })]), { minItems: 0 }))),
		updateRentOnApproval: Type.Optional(Type.Boolean()),
		livingSpace: Type.Optional(TNullable(Type.Number())),
		isLivings: Type.Optional(Type.Boolean()),
		isFlatshare: Type.Optional(Type.Boolean()),
		isFurnished: Type.Optional(Type.Boolean()),
		rentIncreaseType: Type.Optional(Type.Union([Type.Ref(RentTenancyRentIncreaseTypeEnumSchema), Type.Null()], { default: null })),
		rentIncreaseFormula: Type.Optional(Type.Union([Type.Ref(RentIncreaseFormulaEnumSchema), Type.Null()], { default: null })),
		rentIncreaseInterval: Type.Optional(TNullable(Type.Number())),
		friIncreaseAmount: Type.Optional(TNullable(Type.Number())),
		friIncreaseAmountType: Type.Optional(Type.Union([Type.Ref(FriIncreaseAmountTypeEnumSchema), Type.Null()], { default: null })),
		friIncreaseCycles: Type.Optional(TNullable(Type.Number())),
		iriMinCap: Type.Optional(TNullable(Type.Number())),
		iriMaxCap: Type.Optional(TNullable(Type.Number())),
		rentalFreePeriod: Type.Optional(TNullable(Type.Number())),
		rentFreePeriodInMonths: Type.Optional(TNullable(Type.Number())),
		ancillaryCostFreeStartDate: Type.Optional(Type.Union([StringDateSchema, Type.Null()])),
		ancillaryCostFreeEndDate: Type.Optional(Type.Union([StringDateSchema, Type.Null()])),
		rentDeposit: Type.Optional(TNullable(Type.Number())),
		depositReturnDate: Type.Optional(Type.Union([StringDateSchema, Type.Null()])),
		depositReturnAmount: Type.Optional(TNullable(Type.Number())),
		paidRentDeposit: Type.Optional(TNullable(Type.Number())),
		trackDepositAutomatically: Type.Optional(TNullable(Type.Boolean())),
		numberOfInstallments: Type.Optional(TNullable(Type.Number())),
		coldRentChurnPerSQM: Type.Optional(TNullable(Type.Number())),
		commercialVATDamage: Type.Optional(TNullable(Type.Number())),
		commercialRentIndexIncrease: Type.Optional(TNullable(Type.Number())),
		reletDelayInMonths: Type.Optional(TNullable(Type.Number())),
		rentIncreaseEndDate: Type.Optional(Type.Union([StringDateSchema, Type.Null()])),
		isRefurbishedByCurrentOwner: Type.Optional(TNullable(Type.Boolean())),
		apartmentCondition: Type.Optional(Type.Union([Type.Ref(RentApartmentConditionEnumSchema), Type.Null()], { default: null })),
		condoSalesCondition: Type.Optional(Type.Union([Type.Ref(CondoSalesConditionEnumSchema), Type.Null()], { default: null })),
		condoRefurbishmentCostsPerSQM: Type.Optional(TNullable(Type.Number())),
		rentBeforeIncrease: Type.Optional(TNullable(Type.Number())),
		securityDeposit: Type.Optional(TNullable(Type.Number())),
		vat: Type.Optional(TNullable(Type.Number())),
		lastRentIncreaseDate: Type.Optional(Type.Union([StringDateSchema, Type.Null()])),
		valueOfLastRentIncrease: Type.Optional(TNullable(Type.Number())),
		percentageOfLastRentIncrease: Type.Optional(TNullable(Type.Number())),
		isStorageRoomInAtticIsRented: Type.Optional(TNullable(Type.Boolean())),
		equipmentFeatures: Type.Optional(TNullable(Type.String())),
		option: Type.Optional(TNullable(Type.String())),
		otherAgreements: Type.Optional(TNullable(Type.String())),
		isRentalContractSigned: Type.Optional(TNullable(Type.Boolean())),
		isRentIncreaseSigned: Type.Optional(TNullable(Type.Boolean())),
		isRentalContractChecked: Type.Optional(TNullable(Type.Boolean())),
		otherNote: Type.Optional(TNullable(Type.String())),
		regulationOfRentIncreaseNote: Type.Optional(TNullable(Type.String())),
		rentingLeadId: Type.Optional(TNullable(Type.Number())),
		rentingProcessId: Type.Optional(TNullable(Type.Number())),
		signedDocumentId: Type.Optional(TNullable(Type.Number())),
		createdAt: Type.Optional(StringDateSchema),
		updatedAt: Type.Optional(StringDateSchema)
	}, { $id: "BaseRentalContract" });
	RentalContractSchema = Type.Intersect([Type.Ref(BaseRentalContractSchema), Type.Object({
		documents: Type.Optional(TNullable(Type.Array(Type.Ref(BaseDocumentSchema)))),
		rentTenancy: Type.Optional(TNullable(Type.Ref("RentTenancy"))),
		rentalContractUnits: Type.Optional(TNullable(Type.Array(Type.Ref(RentalContractUnitSchema)))),
		rentableUnit: Type.Optional(TNullable(Type.Ref("BaseRentableUnit"))),
		reviewProcess: Type.Optional(TNullable(BaseReviewProcessSchema)),
		estate: Type.Optional(TNullable(Type.Object({
			estateId: Type.Number(),
			condoUuid: Type.Optional(TNullable(Type.String()))
		})))
	})], { $id: "RentalContract" });
	Type.Pick(BaseRentalContractSchema, [
		"rentIncreaseType",
		"rentIncreaseFormula",
		"rentIncreaseInterval",
		"iriMinCap",
		"iriMaxCap",
		"friIncreaseAmountType",
		"friIncreaseAmount",
		"friIncreaseCycles"
	]);
	rentalContractSchemas = {
		BaseRentalContractSchema,
		RentalContractSchema,
		CondoSalesConditionEnumSchema,
		RentApartmentConditionEnumSchema,
		RentTenancyRentIncreaseTypeEnumSchema,
		RentIncreaseFormulaEnumSchema,
		FriIncreaseAmountTypeEnumSchema,
		RentalContractStatusEnumSchema,
		RentalContractTypeEnumSchema
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/due-diligence/rent-roll-dd.base.ts
var RENT_ROLL_SHEET_TITLE, RENT_ROLL_IMPORT_SHEET_TITLE_CANDIDATES, RentRollStatus, rentRollStatusLabels, rentRollStatusColorMap, rentRollToRentRollStatus, floorLocationToRentRoll, rentRollToBuildingLocationType, rentRollToFloorLocation, apartmentTypeToRentRoll, rentRollToApartmentType, apartmentConditionToRentRoll, rentRollToApartmentCondition, condoSalesConditionToRentRoll, rentRollToCondoSalesCondition, rentIncreaseTypeToRentRoll, rentRollToRentIncreaseType, RentRollVersionStatus, RentRollVersionEvents;
var init_rent_roll_dd_base = __esmMin((() => {
	init_rent_tenancy_model();
	init_rental_contract_model();
	init_estates();
	RENT_ROLL_SHEET_TITLE = "Default";
	RENT_ROLL_IMPORT_SHEET_TITLE_CANDIDATES = [RENT_ROLL_SHEET_TITLE];
	RentRollStatus = /* @__PURE__ */ function(RentRollStatus) {
		RentRollStatus["RentedUnlimited"] = "RentedUnlimited";
		RentRollStatus["RentedLimited"] = "RentedLimited";
		RentRollStatus["NotRented"] = "NotRented";
		RentRollStatus["NotRentable"] = "NotRentable";
		return RentRollStatus;
	}({});
	rentRollStatusLabels = {
		["RentedUnlimited"]: "Vermietet - unbefristet",
		["RentedLimited"]: "Vermietet - befristet/gekündigt",
		["NotRented"]: "Unvermietet",
		["NotRentable"]: "Nicht vermietbar"
	};
	rentRollStatusColorMap = {
		["RentedUnlimited"]: "is-success",
		["RentedLimited"]: "is-success",
		["NotRented"]: "is-clink",
		["NotRentable"]: "is-clink"
	};
	rentRollToRentRollStatus = invert(rentRollStatusLabels);
	floorLocationToRentRoll = {
		["R"]: "re.",
		["MR"]: "mi. re.",
		["M"]: "mi.",
		["ML"]: "mi. li.",
		["L"]: "li.",
		["TG"]: "th.",
		["HP"]: "Hochparterre",
		["OpenAir"]: "Außen",
		["Garage"]: "Garage"
	};
	rentRollToBuildingLocationType = {
		"vo.": "VH",
		"sfl.": "SF_L",
		"sfr.": "SF_R",
		"sf.": "SF",
		"hi.": "HH",
		"ha.": "HG",
		"qu.": "QG",
		vo: "VH",
		sfl: "SF_L",
		sfr: "SF_R",
		sf: "SF",
		hi: "HH",
		ha: "HG",
		qu: "QG",
		vorne: "VH",
		hinten: "HH",
		vorderhaus: "VH",
		hinterhaus: "HH",
		seitenflügel: "SF",
		hintergebäude: "HG",
		quergebäude: "QG",
		vorn: "VH"
	};
	rentRollToFloorLocation = {
		"li.": "L",
		li: "L",
		links: "L",
		"re.": "R",
		re: "R",
		rechts: "R",
		"mi.": "M",
		mi: "M",
		mitte: "M",
		"mitte links": "ML",
		"mi. re.": "MR",
		"re. mi.": "MR",
		"mi re": "MR",
		"re mi": "MR",
		mire: "MR",
		"mitte rechts": "MR",
		"mi. li.": "ML",
		"li. mi.": "ML",
		"mi li": "ML",
		"li mi": "ML",
		mili: "ML",
		"th.": "TG",
		th: "TG",
		außen: "OpenAir",
		garage: "Garage",
		turmgebäude: "TG",
		Außen: "OpenAir",
		AUSSEN: "OpenAir",
		Garage: "Garage",
		HP: "HP"
	};
	apartmentTypeToRentRoll = {
		["Apartment"]: "Wohnen",
		["HalfBasement"]: "Souterrain",
		["NoInformation"]: "Keine Angabe",
		["GroundFloor"]: "Erdgeschoss",
		["Maisonette"]: "Maisonette",
		["Penthouse"]: "Penthouse",
		["TerracedFlat"]: "Terrassenwohnung",
		["RoofStorey"]: "Dachgeschoss",
		["RaisedGroundFloor"]: "Hochparterre",
		["Loft"]: "Loft",
		["Farm"]: "Bauernhaus",
		["TwoFamilyHouse"]: "Zweifamilienhaus",
		["ApartmentBuilding"]: "Mehrfamilienhaus",
		["OtherHouse"]: "Sonstiges Haus",
		["TerracedHouse"]: "Reihenhaus",
		["Commercial"]: "Gewerbe",
		["Residential"]: "Wohnraum",
		["Office"]: "Gewerbe - Büro",
		["Gastronomy"]: "Gewerbe - Gastro",
		["Parking"]: "Parkplatz",
		["Shop"]: "Gewerbe - Laden",
		["Other"]: "Sonstiges",
		["CommercialOther"]: "Gewerbe - Sonstiges",
		["Cellar"]: "Keller",
		["UndergroundParking"]: "Tiefgarage",
		["OutdoorParking"]: "Aussenstellplatz",
		["Garage"]: "Garage"
	};
	rentRollToApartmentType = invert(apartmentTypeToRentRoll);
	apartmentConditionToRentRoll = {
		["Refurbished"]: "sanierter Zustand",
		["Old"]: "Altbestand",
		["Rentable"]: "vermietbarer Zustand"
	};
	rentRollToApartmentCondition = invert(apartmentConditionToRentRoll);
	condoSalesConditionToRentRoll = {
		["EEOnly"]: "EE only",
		["EEOnlyPlusTI"]: "EE + TI",
		["EEOnlyPlusTIGuarantee"]: "EE + TI guarantee"
	};
	rentRollToCondoSalesCondition = invert(condoSalesConditionToRentRoll);
	rentIncreaseTypeToRentRoll = {
		["FRI"]: "Staffel",
		["IRI"]: "Index",
		["MANUAL"]: "Manual",
		["NO_INCREASE"]: "None"
	};
	rentRollToRentIncreaseType = invert(rentIncreaseTypeToRentRoll);
	RentRollVersionStatus = /* @__PURE__ */ function(RentRollVersionStatus) {
		RentRollVersionStatus["New"] = "New";
		RentRollVersionStatus["Draft"] = "Draft";
		RentRollVersionStatus["Approved"] = "Approved";
		return RentRollVersionStatus;
	}({});
	RentRollVersionEvents = /* @__PURE__ */ function(RentRollVersionEvents) {
		RentRollVersionEvents["ReadyForInvestment"] = "ReadyForInvestment";
		RentRollVersionEvents["RentRollAdded"] = "RentRollAdded";
		RentRollVersionEvents["Revert"] = "Revert";
		return RentRollVersionEvents;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/mfh/due-diligence/rent-roll-dd.model.ts
var BaseRentRollVersionSchema, RentRollImportResultSchema, RentRollSchema, EstateRentRollSchema, RequiredRentRollSchema, rentRollRequiredValidator, EstarCoreEstateSchema;
var init_rent_roll_dd_model = __esmMin((() => {
	init_shared_schemas();
	init_rent_tenancy_model();
	init_rental_contract_model();
	init_estate_base();
	init_review_process();
	init_rent_roll_dd_base();
	BaseRentRollVersionSchema = Type.Object({
		rentRollVersionId: Type.Number(),
		name: Type.String(),
		status: TEnum(RentRollVersionStatus),
		mfhId: Type.Number(),
		createdAt: StringDateSchema,
		updatedAt: StringDateSchema,
		sharedWithAssetPartner: Type.Optional(Type.Boolean())
	});
	RentRollImportResultSchema = Type.Union([Type.Object({
		outcome: Type.Literal("validated"),
		rowCount: Type.Integer()
	}), Type.Object({
		outcome: Type.Literal("written"),
		rentRollVersion: Type.Pick(BaseRentRollVersionSchema, [
			"rentRollVersionId",
			"name",
			"mfhId"
		], { additionalProperties: false })
	})]);
	RentRollSchema = Type.Object({
		rentRollId: Type.Number(),
		rentRollVersionId: Type.Number(),
		apartmentNumber: Type.Integer(),
		rentingState: Type.Optional(Type.Union([
			Type.Null(),
			Type.Enum(RentRollStatus),
			Type.String()
		])),
		mfhBuildingId: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
		locationInBuilding: Type.Optional(Type.Union([Type.Null(), Type.String()])),
		apartmentType: Type.Optional(Type.Union([Type.Null(), Type.Enum(ApartmentType)])),
		tenantName: Type.Optional(Type.Union([Type.Null(), Type.String()])),
		tenantBirthYear: Type.Optional(Type.Union([Type.Null(), Type.Integer({
			minimum: 1900,
			maximum: (/* @__PURE__ */ new Date()).getFullYear()
		})])),
		rooms: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
		livingSpace: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
		measuredLivingSpace: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
		coldRent: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
		vat: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
		securityDeposit: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
		utilityCost: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
		heatingCost: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
		parkingSpaceRent: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
		parkingSpaceRegisterNumber: Type.Optional(Type.Union([Type.Null(), Type.String()])),
		rentalContractStartDate: Type.Optional(Type.Union([Type.Null(), StringDateSchema])),
		rentalContractEndDate: Type.Optional(Type.Union([Type.Null(), StringDateSchema])),
		rentalContractOption: Type.Optional(Type.Union([Type.Null(), Type.String()])),
		lastRentIncreaseDate: Type.Optional(Type.Union([Type.Null(), StringDateSchema])),
		vpiLastIncrease: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
		isRentIncreaseSigned: Type.Optional(Type.Union([Type.Boolean(), Type.Null()])),
		rentBeforeIncrease: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
		coldRentChurnPerSQM: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
		commercialRentAfterChurnPerSqm: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
		isStorageRoomInAtticIsRented: Type.Optional(Type.Union([Type.Boolean(), Type.Null()])),
		rentIncreaseType: Type.Optional(Type.Union([Type.Null(), Type.Enum(RentalContractRentIncreaseType)])),
		rentIncreaseEndDate: Type.Optional(Type.Union([Type.Null(), StringDateSchema])),
		friIncreaseAmount: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
		equipmentFeatures: Type.Optional(Type.Union([Type.Null(), Type.String()])),
		isRentalContractSigned: Type.Optional(Type.Union([Type.Boolean(), Type.Null()])),
		hasParkingSpace: Type.Optional(Type.Union([Type.Boolean(), Type.Null()])),
		otherAgreements: Type.Optional(Type.Union([Type.Null(), Type.String()])),
		isRentalContractChecked: Type.Boolean(),
		note: Type.Optional(Type.Union([Type.Null(), Type.String()])),
		regulationOfRentIncreaseNote: Type.Optional(Type.Union([Type.Null(), Type.String()])),
		commercialVATDamage: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
		commercialRentIndexIncrease: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
		annualIndexUpdateMonthEndOf: Type.Optional(Type.Union([Type.Integer(), Type.Null()])),
		indexationHurdle: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
		minIntervalForIndexIncreaseInMonths: Type.Optional(Type.Union([Type.Integer(), Type.Null()])),
		indexOfCommercialActivityPreRelet: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
		indexOfCommercialActivityPostRelet: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
		indexationHurdlePostRelet: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
		minIntervalForIndexIncreaseInMonthsPostRelet: Type.Optional(Type.Union([Type.Integer(), Type.Null()])),
		reletDelayInMonths: Type.Optional(Type.Union([Type.Integer(), Type.Null()])),
		notRentableFrom: Type.Optional(Type.Union([Type.Null(), StringDateSchema])),
		isRefurbishedByCurrentOwner: Type.Optional(Type.Union([Type.Boolean(), Type.Null()])),
		apartmentCondition: Type.Optional(Type.Union([Type.Null(), Type.Enum(RentApartmentCondition)])),
		condoSalesCondition: Type.Optional(Type.Union([Type.Null(), Type.Enum(CondoSalesCondition)])),
		condoRefurbishmentCostsPerSQM: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
		createdAt: Type.Optional(Type.Union([Type.Null(), StringDateSchema])),
		updatedAt: Type.Optional(Type.Union([Type.Null(), StringDateSchema]))
	});
	EstateRentRollSchema = Type.Intersect([Type.Partial(RentRollSchema), Type.Partial(Type.Object({
		estateId: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
		estarCoreUnitId: Type.Optional(Type.Union([Type.Null(), Type.String()])),
		condoUuid: Type.Optional(Type.Union([Type.Null(), Type.String()])),
		street: Type.Optional(Type.Union([Type.Null(), Type.String()])),
		houseNumber: Type.Optional(Type.Union([Type.Null(), Type.String()])),
		parkingSpaceId: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
		attrId: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
		rentalContractId: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
		rentalContractReviewProcessState: Type.Optional(Type.Union([Type.Null(), Type.Enum(ReviewProcessState)])),
		tenantContactId: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
		tenantCompanyId: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
		rentingProcessId: Type.Optional(Type.Union([Type.Number(), Type.Null()]))
	}))]);
	RequiredRentRollSchema = Type.Object({
		mfhBuildingId: Type.Number(),
		apartmentNumber: Type.Integer()
	});
	rentRollRequiredValidator = TypeCompiler.Compile(RequiredRentRollSchema);
	EstarCoreEstateSchema = Type.Object({
		estarCoreMfhId: Type.Union([Type.Null(), Type.String()]),
		estarCoreTenantId: Type.Union([Type.Null(), Type.String()]),
		estarCoreUnitId: Type.Union([Type.Null(), Type.String()]),
		estarCoreRentalContractId: Type.Union([Type.Null(), Type.String()]),
		fullLocation: Type.Union([Type.Null(), Type.String()]),
		tenantName: Type.Union([Type.Null(), Type.String()]),
		floorLocation: Type.Union([Type.Null(), Type.String()])
	});
}));
//#endregion
//#region src/domains/cross-cutting/mfh/due-diligence/rent-roll-date.constants.ts
var RENT_ROLL_IMPORT_DATE_YEAR_MIN, RENT_ROLL_IMPORT_DATE_YEAR_MAX;
var init_rent_roll_date_constants = __esmMin((() => {
	RENT_ROLL_IMPORT_DATE_YEAR_MIN = 1e3;
	RENT_ROLL_IMPORT_DATE_YEAR_MAX = 9999;
}));
//#endregion
//#region src/domains/cross-cutting/mfh/due-diligence/rent-roll-dd.helpers.ts
function assertRentRollDateFieldsYearAtMost9999(row) {
	for (const field of RENT_ROLL_DATE_FIELDS) {
		const raw = row[field];
		if (raw === null || raw === void 0 || raw === "") continue;
		const value = raw instanceof Date ? raw.toISOString().slice(0, 10) : String(raw).trim();
		const match = /^(\d{4,})-(\d{2})-(\d{2})$/.exec(value);
		if (!match) throw new InvalidParamsError(`Invalid date for field "${field}": "${value}"`);
		const year = Number.parseInt(match[1], 10);
		if (year < 1e3 || year > 9999) throw new InvalidParamsError(`Date field "${field}" year out of range: "${value}"`);
		const parsed = /* @__PURE__ */ new Date(`${match[1]}-${match[2]}-${match[3]}T00:00:00Z`);
		if (Number.isNaN(parsed.getTime()) || parsed.getUTCFullYear() !== year || parsed.getUTCMonth() + 1 !== Number.parseInt(match[2], 10) || parsed.getUTCDate() !== Number.parseInt(match[3], 10)) throw new InvalidParamsError(`Invalid date for field "${field}": "${value}"`);
	}
}
var RENT_ROLL_DATE_FIELDS, isCommercialRentRoll, isRentRollMatching;
var init_rent_roll_dd_helpers = __esmMin((() => {
	init_base_errors();
	init_rent_roll_date_constants();
	RENT_ROLL_DATE_FIELDS = [
		"rentalContractStartDate",
		"rentalContractEndDate",
		"lastRentIncreaseDate",
		"rentIncreaseEndDate",
		"notRentableFrom"
	];
	isCommercialRentRoll = (data) => !["Apartment", "Parking"].includes(data.apartmentType);
	isRentRollMatching = (a, b) => {
		if (isNil(a.apartmentNumber) || isNil(b.apartmentNumber)) return false;
		return a.apartmentNumber === b.apartmentNumber;
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/due-diligence/rent-roll-sheet-parsing.ts
/**
* Rent-roll numeric cell. A real number is kept as-is.
* Text uses the last separator as the decimal mark:
* `1.234,5` and `1.234,50 m²` → 1234.5, `113,45` → 113.45, `1,234.5` → 1234.5.
* Dot-only groups of three (`1.234`) are thousands. `113.45` stays a decimal.
*/
function parseRentRollNumericCell(v) {
	if (isNil(v) || v === "") return null;
	if (typeof v === "number") return Number.isFinite(v) ? v : null;
	const compact = String(v).replace(/[^\d,.\-−]/g, "").replace(/−/g, "-");
	if (!compact || compact === "-") return null;
	const negative = compact.startsWith("-");
	const unsigned = negative ? compact.slice(1) : compact;
	if (!unsigned || unsigned.includes("-")) return null;
	const normalized = normalizeRentRollNumericText(unsigned);
	if (normalized == null) return null;
	const parsed = Number(normalized);
	if (!Number.isFinite(parsed)) return null;
	return negative ? -parsed : parsed;
}
function normalizeRentRollNumericText(unsigned) {
	const lastComma = unsigned.lastIndexOf(",");
	const lastDot = unsigned.lastIndexOf(".");
	if (lastComma === -1 && lastDot === -1) return /^\d+$/.test(unsigned) ? unsigned : null;
	if (lastComma > lastDot) {
		const intPart = unsigned.slice(0, lastComma).replace(/[.,]/g, "");
		const decPart = unsigned.slice(lastComma + 1).replace(/[.,]/g, "");
		if (!/^\d*$/.test(intPart) || !/^\d+$/.test(decPart)) return null;
		return `${intPart === "" ? "0" : intPart}.${decPart}`;
	}
	if (unsigned.includes(",")) {
		const intPart = unsigned.slice(0, lastDot).replace(/[.,]/g, "");
		const decPart = unsigned.slice(lastDot + 1);
		if (!/^\d+$/.test(intPart) || !/^\d+$/.test(decPart)) return null;
		return `${intPart}.${decPart}`;
	}
	if (/^\d{1,3}(\.\d{3})+$/.test(unsigned)) return unsigned.replace(/\./g, "");
	const intPart = unsigned.slice(0, lastDot);
	const decPart = unsigned.slice(lastDot + 1);
	if (intPart.includes(".") || !/^\d+$/.test(intPart) || !/^\d+$/.test(decPart)) return null;
	return `${intPart}.${decPart}`;
}
function assertRentRollDateYearRange(d, sourceValue) {
	const year = d.year();
	if (year < 1e3 || year > 9999) throw new InvalidParamsError(`Rent roll import date year must be between ${RENT_ROLL_IMPORT_DATE_YEAR_MIN} and ${RENT_ROLL_IMPORT_DATE_YEAR_MAX}. Got "${sourceValue}"`);
}
function parseRentRollTemplateDateCell(v) {
	if (isNil(v) || v === "") return null;
	if (v instanceof Date) {
		const parsed = dayjs(v);
		if (!parsed.isValid()) throw new InvalidParamsError(`Invalid rent roll import date value "${String(v)}"`);
		assertRentRollDateYearRange(parsed, String(v));
		return parsed.toDate();
	}
	if (typeof v === "number" && Number.isFinite(v)) {
		const parsedDate = spreadsheetDateToJsDate(v);
		if (!parsedDate) return null;
		const parsed = dayjs(parsedDate);
		if (!parsed.isValid()) throw new InvalidParamsError(`Invalid rent roll import date value "${String(v)}"`);
		assertRentRollDateYearRange(parsed, String(v));
		return parsed.toDate();
	}
	if (typeof v === "string") {
		const trimmed = v.trim();
		if (!trimmed) return null;
		for (const fmt of RENT_ROLL_TEMPLATE_DATE_STRING_FORMATS) {
			const d = dayjs(trimmed, fmt, true);
			if (d.isValid()) {
				assertRentRollDateYearRange(d, trimmed);
				return d.toDate();
			}
		}
		const isoPrefix = /^(\d{4}-\d{2}-\d{2})/.exec(trimmed);
		if (isoPrefix) {
			const d = dayjs(isoPrefix[1], "YYYY-MM-DD", true);
			if (d.isValid()) {
				assertRentRollDateYearRange(d, trimmed);
				return d.toDate();
			}
		}
		throw new InvalidParamsError(`Invalid rent roll import date value "${trimmed}"`);
	}
	throw new InvalidParamsError(`Invalid rent roll import date value "${String(v)}"`);
}
function parseD2gVersionFromIcSpreadsheetTitle(title) {
	if (!title?.trim()) return null;
	const normalizedTitle = title.trim().replace(/\s*\[read-copy\]\s*$/i, "");
	const duplicatedSheetTitleMatch = normalizedTitle.match(/^D2G_(.+?)_MFH_\d+_IC_\d+$/);
	if (duplicatedSheetTitleMatch?.[1]) return duplicatedSheetTitleMatch[1].trim();
	return normalizedTitle.match(/^D2G_(v?\d+\.\d+\.\d+\s\((.*)\))$/)?.[1] ?? null;
}
var pString$2, TRUTHY_VALUES, FALSY_VALUES, pBoolean, pNumber$2, RENT_ROLL_TEMPLATE_DATE_STRING_FORMATS, TENANT_BIRTH_YEAR_MIN, getTenantBirthYearMax, pYear, pRentRollStatus, pApartmentType, pRentIncreaseType, pApartmentCondition, pCondoSalesCondition, parseFloorLocation, RentRollColumnPathMapping, pRentRollStatusFromLabel, pApartmentTypeFromLabel, pRentIncreaseTypeFromLabel, pApartmentConditionFromLabel, pCondoSalesConditionFromLabel, pDateFromString, pPercentage, pCurrency, RentRollD2GMappings, RentRollD2GMappingsV540, getRentRollD2GMappings;
var init_rent_roll_sheet_parsing = __esmMin((() => {
	init_base_errors();
	init_estate_base();
	init_rent_roll_dd_base();
	init_rent_roll_date_constants();
	dayjs.extend(customParseFormat);
	pString$2 = /* @__PURE__ */ __name((v) => {
		if (isNil(v)) return null;
		return String(v).trim();
	}, "pString");
	TRUTHY_VALUES = [
		"ja",
		"yes",
		"true"
	];
	FALSY_VALUES = [
		"nein",
		"no",
		"false"
	];
	pBoolean = (v) => {
		if (isNil(v) || v === "") return null;
		if (typeof v === "boolean") return v;
		const normalized = String(v).toLowerCase().trim();
		if (TRUTHY_VALUES.includes(normalized)) return true;
		if (FALSY_VALUES.includes(normalized)) return false;
		return null;
	};
	pNumber$2 = parseRentRollNumericCell;
	RENT_ROLL_TEMPLATE_DATE_STRING_FORMATS = Object.values(DateFormats);
	TENANT_BIRTH_YEAR_MIN = 1900;
	getTenantBirthYearMax = () => (/* @__PURE__ */ new Date()).getFullYear();
	pYear = (v) => {
		if (isNil(v) || v === "") return null;
		const maxYear = getTenantBirthYearMax();
		if (typeof v === "number") {
			if (v >= TENANT_BIRTH_YEAR_MIN && v <= maxYear) return Math.floor(v);
			return null;
		}
		if (v instanceof Date) {
			const year = v.getFullYear();
			return year >= TENANT_BIRTH_YEAR_MIN && year <= maxYear ? year : null;
		}
		const date = new Date(v);
		if (!Number.isNaN(date.getTime())) {
			const year = date.getFullYear();
			return year >= TENANT_BIRTH_YEAR_MIN && year <= maxYear ? year : null;
		}
		const numMatch = String(v).match(/\d{4}/)?.[0];
		if (numMatch) {
			const year = Number.parseInt(numMatch, 10);
			return year >= TENANT_BIRTH_YEAR_MIN && year <= maxYear ? year : null;
		}
		return null;
	};
	pRentRollStatus = (v) => v ? rentRollToRentRollStatus[v] ?? null : null;
	pApartmentType = (v) => v ? rentRollToApartmentType[v] ?? null : null;
	pRentIncreaseType = (v) => v ? rentRollToRentIncreaseType[v] ?? null : null;
	pApartmentCondition = (v) => v ? rentRollToApartmentCondition[v] ?? null : null;
	pCondoSalesCondition = (v) => v ? rentRollToCondoSalesCondition[v] ?? null : null;
	parseFloorLocation = (term) => {
		const lowerCaseTerm = term.toLowerCase();
		const findEnumValue = (enumObject, searchTerm) => {
			return Object.values(enumObject).find((value) => searchTerm.toLowerCase().includes(value.toLowerCase()));
		};
		const findMappedValue = (mapping, searchTerm) => {
			const foundKey = Object.keys(mapping).sort((a, b) => b.length - a.length).find((key) => searchTerm.toLowerCase().includes(key.toLowerCase()));
			return foundKey ? mapping[foundKey] : null;
		};
		let floorLocation = findMappedValue(rentRollToFloorLocation, lowerCaseTerm);
		if (!floorLocation) floorLocation = findEnumValue(FloorLocation, lowerCaseTerm);
		let buildingLocationType = findMappedValue(rentRollToBuildingLocationType, lowerCaseTerm);
		if (!buildingLocationType) buildingLocationType = findEnumValue(BuildingLocationType, lowerCaseTerm);
		let floor;
		if (/\beg\b/i.test(term)) floor = 0;
		else for (const pattern of [
			/(\d+)\.?\s*og/i,
			/(\d+)\.?\s*stock/i,
			/(\d+)\.?\s*etage/i,
			/(\d+)\.?\s*/i
		]) {
			const match = term.match(pattern);
			if (match) {
				floor = Number.parseInt(match[1], 10);
				break;
			}
		}
		return {
			...floorLocation ? { floorLocation } : {},
			...buildingLocationType ? { buildingLocationType } : {},
			floor
		};
	};
	RentRollColumnPathMapping = [
		{
			colIdx: 1,
			path: "rentingState",
			parse: pRentRollStatus
		},
		{
			colIdx: 2,
			path: "mfhBuildingId",
			parse: pString$2
		},
		{
			colIdx: 3,
			path: "locationInBuilding",
			parse: pString$2
		},
		{
			colIdx: 4,
			path: "apartmentType",
			parse: pApartmentType
		},
		{
			colIdx: 5,
			path: "tenantName",
			parse: pString$2
		},
		{
			colIdx: 6,
			path: "tenantBirthYear",
			parse: pYear
		},
		{
			colIdx: 7,
			path: "rooms",
			parse: pNumber$2
		},
		{
			colIdx: 8,
			path: "livingSpace",
			parse: pNumber$2
		},
		{
			colIdx: 9,
			path: "measuredLivingSpace",
			parse: pNumber$2
		},
		{
			colIdx: 10,
			path: "coldRent",
			parse: pNumber$2
		},
		{
			colIdx: 11,
			path: "vat",
			parse: pNumber$2
		},
		{
			colIdx: 12,
			path: "securityDeposit",
			parse: pNumber$2
		},
		{
			colIdx: 13,
			path: "utilityCost",
			parse: pNumber$2
		},
		{
			colIdx: 14,
			path: "heatingCost",
			parse: pNumber$2
		},
		{
			colIdx: 15,
			path: "parkingSpaceRent",
			parse: pNumber$2
		},
		{
			colIdx: 16,
			path: "parkingSpaceRegisterNumber",
			parse: pString$2
		},
		{
			colIdx: 17,
			path: "rentalContractStartDate",
			parse: parseRentRollTemplateDateCell
		},
		{
			colIdx: 18,
			path: "rentalContractEndDate",
			parse: parseRentRollTemplateDateCell
		},
		{
			colIdx: 19,
			path: "rentalContractOption",
			parse: pString$2
		},
		{
			colIdx: 20,
			path: "lastRentIncreaseDate",
			parse: parseRentRollTemplateDateCell
		},
		{
			colIdx: 21,
			path: "vpiLastIncrease",
			parse: pNumber$2
		},
		{
			colIdx: 22,
			path: "isRentIncreaseSigned",
			parse: pBoolean
		},
		{
			colIdx: 23,
			path: "rentBeforeIncrease",
			parse: pNumber$2
		},
		{
			colIdx: 24,
			path: "coldRentChurnPerSQM",
			parse: pNumber$2
		},
		{
			colIdx: 25,
			path: "commercialRentAfterChurnPerSqm",
			parse: pNumber$2
		},
		{
			colIdx: 26,
			path: "isStorageRoomInAtticIsRented",
			parse: pBoolean
		},
		{
			colIdx: 27,
			path: "rentIncreaseType",
			parse: pRentIncreaseType
		},
		{
			colIdx: 28,
			path: "rentIncreaseEndDate",
			parse: parseRentRollTemplateDateCell
		},
		{
			colIdx: 29,
			path: "friIncreaseAmount",
			parse: pNumber$2
		},
		{
			colIdx: 30,
			path: "equipmentFeatures",
			parse: pString$2
		},
		{
			colIdx: 31,
			path: "isRentalContractSigned",
			parse: pBoolean
		},
		{
			colIdx: 32,
			path: "hasParkingSpace",
			parse: pBoolean
		},
		{
			colIdx: 33,
			path: "otherAgreements",
			parse: pString$2
		},
		{
			colIdx: 34,
			path: "isRentalContractChecked",
			parse: pBoolean
		},
		{
			colIdx: 35,
			path: "note",
			parse: pString$2
		},
		{
			colIdx: 36,
			path: "regulationOfRentIncreaseNote",
			parse: pString$2
		},
		{
			colIdx: 37,
			path: "commercialVATDamage",
			parse: pNumber$2
		},
		{
			colIdx: 38,
			path: "commercialRentIndexIncrease",
			parse: pNumber$2
		},
		{
			colIdx: 39,
			path: "indexOfCommercialActivityPreRelet",
			parse: pNumber$2
		},
		{
			colIdx: 40,
			path: "indexOfCommercialActivityPostRelet",
			parse: pNumber$2
		},
		{
			colIdx: 41,
			path: "annualIndexUpdateMonthEndOf",
			parse: pNumber$2
		},
		{
			colIdx: 42,
			path: "indexationHurdle",
			parse: pNumber$2
		},
		{
			colIdx: 43,
			path: "indexationHurdlePostRelet",
			parse: pNumber$2
		},
		{
			colIdx: 44,
			path: "minIntervalForIndexIncreaseInMonths",
			parse: pNumber$2
		},
		{
			colIdx: 45,
			path: "minIntervalForIndexIncreaseInMonthsPostRelet",
			parse: pNumber$2
		},
		{
			colIdx: 46,
			path: "reletDelayInMonths",
			parse: pNumber$2
		},
		{
			colIdx: 47,
			path: "notRentableFrom",
			parse: parseRentRollTemplateDateCell
		},
		{
			colIdx: 48,
			path: "isRefurbishedByCurrentOwner",
			parse: pBoolean
		},
		{
			colIdx: 49,
			path: "apartmentCondition",
			parse: pApartmentCondition
		},
		{
			colIdx: 50,
			path: "condoSalesCondition",
			parse: pCondoSalesCondition
		},
		{
			colIdx: 51,
			path: "condoRefurbishmentCostsPerSQM",
			parse: pNumber$2
		}
	];
	pRentRollStatusFromLabel = (v) => {
		if (!v) return null;
		const normalized = String(v).trim();
		const statusEntry = Object.entries(rentRollStatusLabels).find(([, label]) => label === normalized);
		return statusEntry ? statusEntry[0] : null;
	};
	pApartmentTypeFromLabel = (v) => {
		if (!v) return null;
		const normalized = String(v).trim();
		const typeEntry = Object.entries(apartmentTypeToRentRoll).find(([, label]) => label === normalized);
		return typeEntry ? typeEntry[0] : null;
	};
	pRentIncreaseTypeFromLabel = (v) => {
		if (!v) return null;
		const normalized = String(v).trim();
		const typeEntry = Object.entries(rentIncreaseTypeToRentRoll).find(([, label]) => label === normalized);
		return typeEntry ? typeEntry[0] : null;
	};
	pApartmentConditionFromLabel = (v) => {
		if (!v) return null;
		const normalized = String(v).trim();
		const conditionEntry = Object.entries(apartmentConditionToRentRoll).find(([, label]) => label === normalized);
		return conditionEntry ? conditionEntry[0] : null;
	};
	pCondoSalesConditionFromLabel = (v) => {
		if (!v) return null;
		const normalized = String(v).trim();
		const conditionEntry = Object.entries(condoSalesConditionToRentRoll).find(([, label]) => label === normalized);
		return conditionEntry ? conditionEntry[0] : null;
	};
	pDateFromString = (v) => {
		if (isNil(v) || v === "") return null;
		if (typeof v === "number") return spreadsheetDateToJsDate(v);
		if (v instanceof Date) return v;
		const parsed = dayjs(v, "MM/DD/YYYY");
		return parsed.isValid() ? parsed.toDate() : null;
	};
	pPercentage = (v) => {
		if (isNil(v) || v === "") return null;
		if (typeof v === "number") return v;
		const str = String(v).trim().replace("%", "");
		const num = Number.parseFloat(str);
		return Number.isNaN(num) ? null : num / 100;
	};
	pCurrency = (v) => {
		if (isNil(v) || v === "") return null;
		if (typeof v === "number") return v;
		const str = String(v).replace(/[€,\s]/g, "").trim();
		const num = Number.parseFloat(str);
		return Number.isNaN(num) ? null : num;
	};
	RentRollD2GMappings = [
		{
			getter: (rentRoll) => rentRoll.apartmentNumber ?? "",
			colIdx: 0,
			path: "apartmentNumber",
			parse: () => null
		},
		{
			getter: (rentRoll) => rentRoll.rentingState ? rentRollStatusLabels[rentRoll.rentingState] : "",
			colIdx: 1,
			path: "rentingState",
			parse: pRentRollStatusFromLabel
		},
		{
			getter: (rentRoll) => {
				const location = rentRoll.mfhBuilding?.location;
				return location ? `${location.street} ${location.houseNumber}, ${location.zipcode} ${location.city}` : "";
			},
			colIdx: 2,
			path: "mfhBuildingId",
			parse: pString$2
		},
		{
			colIdx: 3,
			path: "locationInBuilding",
			parse: pString$2
		},
		{
			getter: (rentRoll) => {
				return rentRoll.apartmentType ? apartmentTypeToRentRoll[rentRoll.apartmentType] : "";
			},
			colIdx: 4,
			path: "apartmentType",
			parse: pApartmentTypeFromLabel
		},
		{
			colIdx: 5,
			path: "tenantName",
			parse: pString$2
		},
		{
			getter: (rentRoll) => {
				if (isNil(rentRoll.tenantBirthYear)) return null;
				return typeof rentRoll.tenantBirthYear === "number" ? rentRoll.tenantBirthYear : null;
			},
			colIdx: 6,
			path: "tenantBirthYear",
			parse: pYear
		},
		{
			colIdx: 7,
			path: "rooms",
			parse: pNumber$2
		},
		{
			colIdx: 9,
			format: SheetFormatters.meterSquared,
			path: "livingSpace",
			parse: pNumber$2
		},
		{
			colIdx: 10,
			format: SheetFormatters.meterSquared,
			path: "measuredLivingSpace",
			parse: pNumber$2
		},
		{
			colIdx: 13,
			format: SheetFormatters.euroCurrency,
			path: "coldRent",
			parse: pCurrency
		},
		{
			colIdx: 15,
			format: SheetFormatters.euroCurrency,
			path: "vat",
			parse: pCurrency
		},
		{
			colIdx: 17,
			format: SheetFormatters.euroCurrency,
			path: "securityDeposit",
			parse: pCurrency
		},
		{
			colIdx: 18,
			format: SheetFormatters.euroCurrency,
			path: "utilityCost",
			parse: pCurrency
		},
		{
			colIdx: 20,
			format: SheetFormatters.euroCurrency,
			path: "heatingCost",
			parse: pCurrency
		},
		{
			colIdx: 22,
			format: SheetFormatters.euroCurrency,
			path: "parkingSpaceRent",
			parse: pCurrency
		},
		{
			colIdx: 23,
			path: "parkingSpaceRegisterNumber",
			parse: pString$2
		},
		{
			getter: (rentRoll) => isDate(rentRoll.rentalContractStartDate) ? rentRoll.rentalContractStartDate.toDateString() : rentRoll.rentalContractStartDate,
			colIdx: 24,
			format: SheetFormatters.date,
			path: "rentalContractStartDate",
			parse: pDateFromString
		},
		{
			getter: (rentRoll) => isDate(rentRoll.rentalContractEndDate) ? rentRoll.rentalContractEndDate.toDateString() : rentRoll.rentalContractEndDate,
			colIdx: 26,
			format: SheetFormatters.date,
			path: "rentalContractEndDate",
			parse: pDateFromString
		},
		{
			colIdx: 29,
			path: "rentalContractOption",
			parse: pString$2
		},
		{
			getter: (rentRoll) => isDate(rentRoll.lastRentIncreaseDate) ? rentRoll.lastRentIncreaseDate.toDateString() : rentRoll.lastRentIncreaseDate,
			colIdx: 30,
			format: SheetFormatters.date,
			path: "lastRentIncreaseDate",
			parse: pDateFromString
		},
		{
			colIdx: 31,
			path: "vpiLastIncrease",
			parse: pNumber$2
		},
		{
			getter: (rentRoll) => rentRoll.isRentIncreaseSigned === true ? "Ja" : rentRoll.isRentIncreaseSigned === false ? "Nein" : "",
			colIdx: 32,
			path: "isRentIncreaseSigned",
			parse: pBoolean
		},
		{
			colIdx: 33,
			format: SheetFormatters.euroCurrency,
			path: "rentBeforeIncrease",
			parse: pCurrency
		},
		{
			colIdx: 39,
			format: SheetFormatters.euroCurrency,
			path: "coldRentChurnPerSQM",
			parse: pCurrency
		},
		{
			colIdx: 40,
			format: SheetFormatters.euroCurrency,
			path: "commercialRentAfterChurnPerSqm",
			parse: pCurrency
		},
		{
			getter: (rentRoll) => rentRoll.isStorageRoomInAtticIsRented === true ? "Ja" : rentRoll.isStorageRoomInAtticIsRented === false ? "Nein" : "",
			colIdx: 41,
			path: "isStorageRoomInAtticIsRented",
			parse: pBoolean
		},
		{
			getter: (rentRoll) => rentRoll.rentIncreaseType ? rentIncreaseTypeToRentRoll[rentRoll.rentIncreaseType] : "",
			colIdx: 42,
			path: "rentIncreaseType",
			parse: pRentIncreaseTypeFromLabel
		},
		{
			getter: (rentRoll) => isDate(rentRoll.rentIncreaseEndDate) ? rentRoll.rentIncreaseEndDate.toDateString() : rentRoll.rentIncreaseEndDate,
			colIdx: 43,
			format: SheetFormatters.date,
			path: "rentIncreaseEndDate",
			parse: pDateFromString
		},
		{
			colIdx: 44,
			format: SheetFormatters.euroCurrency,
			path: "friIncreaseAmount",
			parse: pCurrency
		},
		{
			colIdx: 45,
			path: "equipmentFeatures",
			parse: pString$2
		},
		{
			getter: (rentRoll) => rentRoll.isRentalContractSigned === true ? "Ja" : rentRoll.isRentalContractSigned === false ? "Nein" : "",
			colIdx: 46,
			path: "isRentalContractSigned",
			parse: pBoolean
		},
		{
			getter: (rentRoll) => rentRoll.hasParkingSpace === true ? "Ja" : rentRoll.hasParkingSpace === false ? "Nein" : "",
			colIdx: 47,
			path: "hasParkingSpace",
			parse: pBoolean
		},
		{
			colIdx: 48,
			path: "otherAgreements",
			parse: pString$2
		},
		{
			getter: (rentRoll) => isNil(rentRoll.isRentalContractChecked) ? false : rentRoll.isRentalContractChecked,
			colIdx: 49,
			format: SheetFormatters.booleanCheckbox,
			path: "isRentalContractChecked",
			parse: pBoolean
		},
		{
			colIdx: 50,
			path: "note",
			parse: pString$2
		},
		{
			colIdx: 51,
			path: "regulationOfRentIncreaseNote",
			parse: pString$2
		},
		{
			colIdx: 52,
			format: SheetFormatters.percentage,
			path: "commercialVATDamage",
			parse: pPercentage
		},
		{
			colIdx: 53,
			format: SheetFormatters.percentage,
			path: "commercialRentIndexIncrease",
			parse: pPercentage
		},
		{
			colIdx: 54,
			path: "annualIndexUpdateMonthEndOf",
			parse: pNumber$2
		},
		{
			colIdx: 55,
			format: SheetFormatters.percentage,
			path: "indexationHurdle",
			parse: pPercentage
		},
		{
			colIdx: 56,
			path: "minIntervalForIndexIncreaseInMonths",
			parse: pNumber$2
		},
		{
			colIdx: 57,
			path: "reletDelayInMonths",
			parse: pNumber$2
		},
		{
			getter: (rentRoll) => isDate(rentRoll.notRentableFrom) ? rentRoll.notRentableFrom.toDateString() : rentRoll.notRentableFrom,
			colIdx: 59,
			format: SheetFormatters.date,
			path: "notRentableFrom",
			parse: pDateFromString
		},
		{
			getter: (rentRoll) => rentRoll.isRefurbishedByCurrentOwner === true ? "Ja" : rentRoll.isRefurbishedByCurrentOwner === false ? "Nein" : "",
			colIdx: 62,
			path: "isRefurbishedByCurrentOwner",
			parse: pBoolean
		},
		{
			getter: (rentRoll) => rentRoll.apartmentCondition ? apartmentConditionToRentRoll[rentRoll.apartmentCondition] : "",
			colIdx: 63,
			path: "apartmentCondition",
			parse: pApartmentConditionFromLabel
		},
		{
			getter: (rentRoll) => rentRoll.condoSalesCondition ? condoSalesConditionToRentRoll[rentRoll.condoSalesCondition] : "",
			colIdx: 64,
			path: "condoSalesCondition",
			parse: pCondoSalesConditionFromLabel
		},
		{
			colIdx: 65,
			format: SheetFormatters.euroCurrency,
			path: "condoRefurbishmentCostsPerSQM",
			parse: pCurrency
		}
	];
	RentRollD2GMappingsV540 = [
		{
			getter: (rentRoll) => rentRoll.apartmentNumber ?? "",
			colIdx: 0,
			path: "apartmentNumber",
			parse: () => null
		},
		{
			getter: (rentRoll) => rentRoll.rentingState ? rentRollStatusLabels[rentRoll.rentingState] : "",
			colIdx: 1,
			path: "rentingState",
			parse: pRentRollStatusFromLabel
		},
		{
			getter: (rentRoll) => {
				const location = rentRoll.mfhBuilding?.location;
				return location ? `${location.street} ${location.houseNumber}, ${location.zipcode} ${location.city}` : "";
			},
			colIdx: 2,
			path: "mfhBuildingId",
			parse: pString$2
		},
		{
			colIdx: 3,
			path: "locationInBuilding",
			parse: pString$2
		},
		{
			getter: (rentRoll) => {
				return rentRoll.apartmentType ? apartmentTypeToRentRoll[rentRoll.apartmentType] : "";
			},
			colIdx: 4,
			path: "apartmentType",
			parse: pApartmentTypeFromLabel
		},
		{
			colIdx: 5,
			path: "tenantName",
			parse: pString$2
		},
		{
			getter: (rentRoll) => {
				if (isNil(rentRoll.tenantBirthYear)) return null;
				return typeof rentRoll.tenantBirthYear === "number" ? rentRoll.tenantBirthYear : null;
			},
			colIdx: 6,
			path: "tenantBirthYear",
			parse: pYear
		},
		{
			colIdx: 7,
			path: "rooms",
			parse: pNumber$2
		},
		{
			colIdx: 9,
			format: SheetFormatters.meterSquared,
			path: "livingSpace",
			parse: pNumber$2
		},
		{
			colIdx: 10,
			format: SheetFormatters.meterSquared,
			path: "measuredLivingSpace",
			parse: pNumber$2
		},
		{
			colIdx: 13,
			format: SheetFormatters.euroCurrency,
			path: "coldRent",
			parse: pCurrency
		},
		{
			colIdx: 15,
			format: SheetFormatters.euroCurrency,
			path: "vat",
			parse: pCurrency
		},
		{
			colIdx: 17,
			format: SheetFormatters.euroCurrency,
			path: "securityDeposit",
			parse: pCurrency
		},
		{
			colIdx: 18,
			format: SheetFormatters.euroCurrency,
			path: "utilityCost",
			parse: pCurrency
		},
		{
			colIdx: 20,
			format: SheetFormatters.euroCurrency,
			path: "heatingCost",
			parse: pCurrency
		},
		{
			colIdx: 22,
			format: SheetFormatters.euroCurrency,
			path: "parkingSpaceRent",
			parse: pCurrency
		},
		{
			colIdx: 23,
			path: "parkingSpaceRegisterNumber",
			parse: pString$2
		},
		{
			getter: (rentRoll) => isDate(rentRoll.rentalContractStartDate) ? rentRoll.rentalContractStartDate.toDateString() : rentRoll.rentalContractStartDate,
			colIdx: 24,
			format: SheetFormatters.date,
			path: "rentalContractStartDate",
			parse: pDateFromString
		},
		{
			getter: (rentRoll) => isDate(rentRoll.rentalContractEndDate) ? rentRoll.rentalContractEndDate.toDateString() : rentRoll.rentalContractEndDate,
			colIdx: 26,
			format: SheetFormatters.date,
			path: "rentalContractEndDate",
			parse: pDateFromString
		},
		{
			colIdx: 29,
			path: "rentalContractOption",
			parse: pString$2
		},
		{
			getter: (rentRoll) => isDate(rentRoll.lastRentIncreaseDate) ? rentRoll.lastRentIncreaseDate.toDateString() : rentRoll.lastRentIncreaseDate,
			colIdx: 30,
			format: SheetFormatters.date,
			path: "lastRentIncreaseDate",
			parse: pDateFromString
		},
		{
			colIdx: 31,
			path: "vpiLastIncrease",
			parse: pNumber$2
		},
		{
			getter: (rentRoll) => rentRoll.isRentIncreaseSigned === true ? "Ja" : rentRoll.isRentIncreaseSigned === false ? "Nein" : "",
			colIdx: 32,
			path: "isRentIncreaseSigned",
			parse: pBoolean
		},
		{
			colIdx: 33,
			format: SheetFormatters.euroCurrency,
			path: "rentBeforeIncrease",
			parse: pCurrency
		},
		{
			colIdx: 39,
			format: SheetFormatters.euroCurrency,
			path: "coldRentChurnPerSQM",
			parse: pCurrency
		},
		{
			colIdx: 40,
			format: SheetFormatters.euroCurrency,
			path: "commercialRentAfterChurnPerSqm",
			parse: pCurrency
		},
		{
			getter: (rentRoll) => rentRoll.isStorageRoomInAtticIsRented === true ? "Ja" : rentRoll.isStorageRoomInAtticIsRented === false ? "Nein" : "",
			colIdx: 41,
			path: "isStorageRoomInAtticIsRented",
			parse: pBoolean
		},
		{
			getter: (rentRoll) => rentRoll.rentIncreaseType ? rentIncreaseTypeToRentRoll[rentRoll.rentIncreaseType] : "",
			colIdx: 42,
			path: "rentIncreaseType",
			parse: pRentIncreaseTypeFromLabel
		},
		{
			getter: (rentRoll) => isDate(rentRoll.rentIncreaseEndDate) ? rentRoll.rentIncreaseEndDate.toDateString() : rentRoll.rentIncreaseEndDate,
			colIdx: 43,
			format: SheetFormatters.date,
			path: "rentIncreaseEndDate",
			parse: pDateFromString
		},
		{
			colIdx: 44,
			format: SheetFormatters.euroCurrency,
			path: "friIncreaseAmount",
			parse: pCurrency
		},
		{
			colIdx: 45,
			path: "equipmentFeatures",
			parse: pString$2
		},
		{
			getter: (rentRoll) => rentRoll.isRentalContractSigned === true ? "Ja" : rentRoll.isRentalContractSigned === false ? "Nein" : "",
			colIdx: 46,
			path: "isRentalContractSigned",
			parse: pBoolean
		},
		{
			getter: (rentRoll) => rentRoll.hasParkingSpace === true ? "Ja" : rentRoll.hasParkingSpace === false ? "Nein" : "",
			colIdx: 47,
			path: "hasParkingSpace",
			parse: pBoolean
		},
		{
			colIdx: 48,
			path: "otherAgreements",
			parse: pString$2
		},
		{
			getter: (rentRoll) => isNil(rentRoll.isRentalContractChecked) ? false : rentRoll.isRentalContractChecked,
			colIdx: 49,
			format: SheetFormatters.booleanCheckbox,
			path: "isRentalContractChecked",
			parse: pBoolean
		},
		{
			colIdx: 50,
			path: "note",
			parse: pString$2
		},
		{
			colIdx: 51,
			path: "regulationOfRentIncreaseNote",
			parse: pString$2
		},
		{
			colIdx: 52,
			format: SheetFormatters.percentage,
			path: "commercialVATDamage",
			parse: pPercentage
		},
		{
			colIdx: 53,
			format: SheetFormatters.percentage,
			path: "indexOfCommercialActivityPreRelet",
			parse: pPercentage
		},
		{
			colIdx: 54,
			format: SheetFormatters.percentage,
			path: "indexOfCommercialActivityPostRelet",
			parse: pPercentage
		},
		{
			colIdx: 55,
			path: "annualIndexUpdateMonthEndOf",
			parse: pNumber$2
		},
		{
			colIdx: 56,
			format: SheetFormatters.percentage,
			path: "indexationHurdle",
			parse: pPercentage
		},
		{
			colIdx: 57,
			format: SheetFormatters.percentage,
			path: "indexationHurdlePostRelet",
			parse: pPercentage
		},
		{
			colIdx: 58,
			path: "minIntervalForIndexIncreaseInMonths",
			parse: pNumber$2
		},
		{
			colIdx: 59,
			path: "minIntervalForIndexIncreaseInMonthsPostRelet",
			parse: pNumber$2
		},
		{
			colIdx: 60,
			path: "reletDelayInMonths",
			parse: pNumber$2
		},
		{
			getter: (rentRoll) => isDate(rentRoll.notRentableFrom) ? rentRoll.notRentableFrom.toDateString() : rentRoll.notRentableFrom,
			colIdx: 62,
			format: SheetFormatters.date,
			path: "notRentableFrom",
			parse: pDateFromString
		},
		{
			getter: (rentRoll) => rentRoll.isRefurbishedByCurrentOwner === true ? "Ja" : rentRoll.isRefurbishedByCurrentOwner === false ? "Nein" : "",
			colIdx: 65,
			path: "isRefurbishedByCurrentOwner",
			parse: pBoolean
		},
		{
			getter: (rentRoll) => rentRoll.apartmentCondition ? apartmentConditionToRentRoll[rentRoll.apartmentCondition] : "",
			colIdx: 66,
			path: "apartmentCondition",
			parse: pApartmentConditionFromLabel
		},
		{
			getter: (rentRoll) => rentRoll.condoSalesCondition ? condoSalesConditionToRentRoll[rentRoll.condoSalesCondition] : "",
			colIdx: 67,
			path: "condoSalesCondition",
			parse: pCondoSalesConditionFromLabel
		},
		{
			colIdx: 68,
			format: SheetFormatters.euroCurrency,
			path: "condoRefurbishmentCostsPerSQM",
			parse: pCurrency
		}
	];
	getRentRollD2GMappings = (d2gVersion) => d2gVersion.startsWith("5.4") ? RentRollD2GMappingsV540 : RentRollD2GMappings;
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/calculations/d2g/calcengine-error-compact.ts
var DEFAULT_MAX_COMPACT_MESSAGE_LENGTH, compactCalcengineErrorMessage, resolveCalcengineErrorMessageForPersistence;
var init_calcengine_error_compact = __esmMin((() => {
	DEFAULT_MAX_COMPACT_MESSAGE_LENGTH = 400;
	compactCalcengineErrorMessage = (message, maxLength = DEFAULT_MAX_COMPACT_MESSAGE_LENGTH) => {
		let text = message.split("\n", 1)[0]?.trim() ?? message;
		const parts = text.split(/\s*->\s*/).map((part) => part.trim()).filter(Boolean);
		if (parts.length > 4) text = [
			parts[0],
			"...",
			...parts.slice(-2)
		].join(" -> ");
		if (text.length > maxLength) return `${text.slice(0, maxLength - 3)}...`;
		return text;
	};
	resolveCalcengineErrorMessageForPersistence = (message, options) => {
		return options?.persistFullStacks ? message : compactCalcengineErrorMessage(message);
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/calculations/d2g/d2g-errors.ts
var D2GCalculationNodeError, D2GCalculationServiceError, D2GCalcEngineGlobalCalculationError, D2GCalcEngineUnsupportedVersionError, D2GSheetMissingDatapointError, D2GDatapointWithoutConfigError, D2GSheetMissingDatapointsError, D2GSheetDatapointNotMappableError, D2GSheetMappingMalformedError, D2GMissingVersionError, D2GMissingMappingsForVersionError, D2GVersionDisabledError, SpreadsheetVectorError, SpreadsheetMatrixError;
var init_d2g_errors = __esmMin((() => {
	init_errors();
	init_calcengine_error_compact();
	D2GCalculationNodeError = class extends NonRetriableError {
		errorType;
		persistFullStacks;
		constructor(message, calculationNode, errorType, options) {
			const persistFullStacks = options?.persistFullStacks === true;
			const resolvedMessage = resolveCalcengineErrorMessageForPersistence(message, { persistFullStacks });
			super(resolvedMessage, "D2G_CALCULATION_NODE", {
				calculationNode,
				errorType
			});
			this.errorType = errorType;
			this.message = resolvedMessage;
			this.persistFullStacks = persistFullStacks;
		}
		/**
		* Compact JSON for jsonb / Inngest persistence unless constructed with `persistFullStacks: true`.
		*/
		toJSON() {
			if (this.persistFullStacks) return serializeError(this);
			return {
				code: this.code,
				name: this.name,
				message: this.message,
				data: this.data,
				errorType: this.errorType
			};
		}
	};
	D2GCalculationServiceError = class extends NonRetriableError {
		cause;
		constructor(cause) {
			super(`Unable to calculate investment-case via calculation-engine`, "D2G_CALCULATION_SERVICE", { cause });
			this.cause = cause;
		}
	};
	D2GCalcEngineGlobalCalculationError = class extends NonRetriableError {
		errors;
		constructor(errors) {
			super(`CalcEngine calculation failed: ${errors.join(", ")}`, "D2G_GLOBAL_ERROR");
			this.errors = errors;
		}
	};
	D2GCalcEngineUnsupportedVersionError = class extends NonRetriableError {
		availableVersions;
		constructor(d2gVersion, availableVersions) {
			super(`Provided version ${d2gVersion} is not supported by calcengine`, "D2G_UNSUPPORTED_VERSION");
			this.availableVersions = availableVersions;
		}
	};
	D2GSheetMissingDatapointError = class extends NonRetriableError {
		field;
		constructor(field, data) {
			super(`Missing datapoint ${field} in resolved d2g-inputs`, "D2G_SHEET_MISSING_DATAPOINT", data);
			this.field = field;
		}
	};
	D2GDatapointWithoutConfigError = class extends NonRetriableError {
		field;
		constructor(field, data) {
			super(`Tried to write datapoint '${field}' without any config`, "D2G_DATAPOINT_WITHOUT_CONFIG", data);
			this.field = field;
		}
	};
	D2GSheetMissingDatapointsError = class extends NonRetriableError {
		missingFields;
		tags = [ErrorTag.FRONTEND_SILENT];
		constructor(missingFields, data) {
			super(`Missing datapoints ${missingFields.map((f) => f.target).join(",")} in resolved d2g-inputs`, "D2G_SHEET_MISSING_DATAPOINT", data, ErrorSeverity.LOW);
			this.missingFields = missingFields;
		}
	};
	D2GSheetDatapointNotMappableError = class extends NonRetriableError {
		field;
		originalFieldValue;
		constructor(field, originalFieldValue, data) {
			super(`Datapoint ${field} is not mappable ("${originalFieldValue ?? "[not-present]"}")`, "D2G_SHEET_DATAPOINT_NOT_MAPPABLE", data);
			this.field = field;
			this.originalFieldValue = originalFieldValue;
		}
	};
	D2GSheetMappingMalformedError = class extends NonRetriableError {
		message;
		sheetId;
		constructor(message, sheetId, data) {
			super(message, "D2G_SHEET_MAPPING_MALFORMED", data);
			this.message = message;
			this.sheetId = sheetId;
		}
	};
	D2GMissingVersionError = class extends NonRetriableError {
		constructor() {
			super("Missing d2g version", "D2G_MISSING_VERSION");
		}
	};
	D2GMissingMappingsForVersionError = class extends NonRetriableError {
		selfVersion;
		constructor(selfVersion) {
			super(`Missing version-compliant mappings for version ${selfVersion}`, "D2G_MISSING_MAPPINGS");
			this.selfVersion = selfVersion;
		}
	};
	D2GVersionDisabledError = class extends NonRetriableError {
		d2gVersion;
		constructor(d2gVersion) {
			super(`D2G version "${d2gVersion}" has been disabled`, "D2G_VERSION_DISABLED");
			this.d2gVersion = d2gVersion;
		}
	};
	SpreadsheetVectorError = class extends D2GCalculationNodeError {
		positions;
		constructor(message, calculationNode, errorType, positions, options) {
			super(message, calculationNode, errorType, options);
			this.positions = positions;
		}
		toJSON() {
			return {
				...super.toJSON(),
				positions: this.positions
			};
		}
	};
	SpreadsheetMatrixError = class extends D2GCalculationNodeError {
		positions;
		constructor(message, calculationNode, errorType, positions, options) {
			super(message, calculationNode, errorType, options);
			this.positions = positions;
		}
		toJSON() {
			return {
				...super.toJSON(),
				positions: this.positions
			};
		}
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh-attributes.base.ts
var MFHRIWISLocation, AdjoiningBuilding, CellarHeating, ExitType, Restrictions, RoofOrientation, RoofShape, RoofUse, SplitStatus, WaterHeating, WindowGlazing, InvestmentRiskProfile, InvestmentStrategy, MandateType;
var init_mfh_attributes_base = __esmMin((() => {
	MFHRIWISLocation = /* @__PURE__ */ function(MFHRIWISLocation) {
		MFHRIWISLocation["Simple"] = "Simple";
		MFHRIWISLocation["SimpleToAverage"] = "SimpleToAverage";
		MFHRIWISLocation["Average"] = "Average";
		MFHRIWISLocation["AverageToGood"] = "AverageToGood";
		MFHRIWISLocation["Good"] = "Good";
		MFHRIWISLocation["GoodToVeryGood"] = "GoodToVeryGood";
		MFHRIWISLocation["VeryGood"] = "VeryGood";
		MFHRIWISLocation["NoInputNeeded"] = "NoInputNeeded";
		MFHRIWISLocation["PleaseFillOut"] = "PleaseFillOut";
		return MFHRIWISLocation;
	}({});
	AdjoiningBuilding = /* @__PURE__ */ function(AdjoiningBuilding) {
		AdjoiningBuilding["OneSide"] = "OneSide";
		AdjoiningBuilding["TwoSide"] = "TwoSide";
		AdjoiningBuilding["Absent"] = "Absent";
		return AdjoiningBuilding;
	}({});
	CellarHeating = /* @__PURE__ */ function(CellarHeating) {
		CellarHeating["Heated"] = "Heated";
		CellarHeating["PartiallyHeated"] = "PartiallyHeated";
		CellarHeating["NotHeated"] = "NotHeated";
		return CellarHeating;
	}({});
	ExitType = /* @__PURE__ */ function(ExitType) {
		ExitType["MFH"] = "MFH";
		ExitType["SingleUnit"] = "SingleUnit";
		ExitType["MFHSingleUnit"] = "MFHSingleUnit";
		return ExitType;
	}({});
	Restrictions = /* @__PURE__ */ function(Restrictions) {
		Restrictions["UrbanisticQuirk"] = "UrbanisticQuirk";
		Restrictions["CompositionOfTheResidentPopulation"] = "CompositionOfTheResidentPopulation";
		Restrictions["RedevelopmentArea"] = "RedevelopmentArea";
		Restrictions["HeritageBuilding"] = "HeritageBuilding";
		Restrictions["GroundLease"] = "GroundLease";
		Restrictions["RentControlOrRentSubsidy"] = "RentControlOrRentSubsidy";
		Restrictions["ZoningPlan"] = "ZoningPlan";
		Restrictions["Other"] = "Other";
		Restrictions["None"] = "None";
		return Restrictions;
	}({});
	RoofOrientation = /* @__PURE__ */ function(RoofOrientation) {
		RoofOrientation["N"] = "N";
		RoofOrientation["NE"] = "NE";
		RoofOrientation["E"] = "E";
		RoofOrientation["SE"] = "SE";
		RoofOrientation["S"] = "S";
		RoofOrientation["SW"] = "SW";
		RoofOrientation["W"] = "W";
		RoofOrientation["NW"] = "NW";
		return RoofOrientation;
	}({});
	RoofShape = /* @__PURE__ */ function(RoofShape) {
		RoofShape["Hipped"] = "Hipped";
		RoofShape["Saddle"] = "Saddle";
		RoofShape["Pitched"] = "Pitched";
		RoofShape["Flat"] = "Flat";
		RoofShape["Mansard"] = "Mansard";
		return RoofShape;
	}({});
	RoofUse = /* @__PURE__ */ function(RoofUse) {
		RoofUse["FacadeWorthPreserving"] = "FacadeWorthPreserving";
		RoofUse["SingleSkinMasonry"] = "SingleSkinMasonry";
		RoofUse["DoubleSkinMasonry"] = "DoubleSkinMasonry";
		return RoofUse;
	}({});
	SplitStatus = /* @__PURE__ */ function(SplitStatus) {
		SplitStatus["ToBeSplit"] = "ToBeSplit";
		SplitStatus["AlreadySplit"] = "AlreadySplit";
		SplitStatus["PleaseFillOut"] = "PleaseFillOut";
		SplitStatus["NoInputNeeded"] = "NoInputNeeded";
		return SplitStatus;
	}({});
	WaterHeating = /* @__PURE__ */ function(WaterHeating) {
		WaterHeating["Boiler"] = "Boiler";
		WaterHeating["ViaHeating"] = "ViaHeating";
		return WaterHeating;
	}({});
	WindowGlazing = /* @__PURE__ */ function(WindowGlazing) {
		WindowGlazing["One"] = "One";
		WindowGlazing["Two"] = "Two";
		WindowGlazing["Three"] = "Three";
		WindowGlazing["BoxWindows"] = "BoxWindows";
		return WindowGlazing;
	}({});
	InvestmentRiskProfile = /* @__PURE__ */ function(InvestmentRiskProfile) {
		InvestmentRiskProfile["CorePlus"] = "CorePlus";
		InvestmentRiskProfile["ValueAdd"] = "ValueAdd";
		return InvestmentRiskProfile;
	}({});
	InvestmentStrategy = /* @__PURE__ */ function(InvestmentStrategy) {
		InvestmentStrategy["DevelopToGreen"] = "DevelopToGreen";
		InvestmentStrategy["HoldAndStabilize"] = "HoldAndStabilize";
		InvestmentStrategy["Exit"] = "Exit";
		return InvestmentStrategy;
	}({});
	MandateType = /* @__PURE__ */ function(MandateType) {
		MandateType["Investment"] = "Investment";
		MandateType["Management"] = "Management";
		return MandateType;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/mfh-investment-case.base.ts
var D2GFeatureSet, D2G_SHEET_MAPPINGS, D2G_SHEET_MAPPING_LOOKUP, isD2GSheetId, MFHD2GPromoteType, MFHMarketChannel, MFHD2GRentIndexSelection, MFHD2GReLetScenario, MFHD2GStrategicVacancy, MFHD2GCashTrap, MFHD2GTaxEngineType, MFHD2GSettingBAFA, MFHD2GSettingBegEmSubsidies, MFHD2GSettingScenario, MFHD2GSettingCapex, MFHD2GSettingChurn, MFHD2GSettingVAT, MFHD2GSettingFinancing, MFHD2GSettingLTV, MFHD2GSettingExpansion, MFHD2GSettingRentIncrease, MFHD2GSettingKfWStandard, MFHD2GSettingIRRRange, MFHD2GSettingGradualSale, MFHD2GSettingRentRoll, MODCatchUpAfterStaffel, MFHD2GSettingIRRType, MFHD2GSettingExitApproach, MFHD2GSettingIFBStandard, MFHD2GSettingEKDrawFirst, MFHD2GSettingEKDrawFirstExt, MFHD2GSettingRentIncreaseDependentOnDataQuality, MFHD2GSettingMonumentProtection, MFHD2GSettingRentIncreaseAnnualOnly, MFHD2GSettingNetGross, MFHInvestmentCaseStatus, MFHInvestmentCaseType, DISABLED_MFH_IC_STATUS, MFHOutputErrorKind, SHEET_ERROR_MAPPINGS, MFHInputFieldVisible, getMFHInvestmentCaseInputConfigForPath, isMFHInvestmentCaseInputActiveForVersion, getMFHInvestmentCaseEnumSource, isMFHInvestmentCaseInputRequired, mfhAssetPartnerBuyBoxInputsFormConfig, mfhAssetPartnerBuyBoxInputFields, mfhInvestmentCaseInputsFormConfig, mfhInvestmentCaseAssetPartnerInputsFormConfig;
var init_mfh_investment_case_base = __esmMin((() => {
	init_mfh_attributes_base();
	init_mfh_model();
	D2GFeatureSet = /* @__PURE__ */ function(D2GFeatureSet) {
		D2GFeatureSet["RentIndex"] = "RentIndex";
		D2GFeatureSet["InvestorAssumptionsInSheet"] = "InvestorAssumptionsInSheet";
		D2GFeatureSet["D2GRentRollImport"] = "D2GRentRollImport";
		D2GFeatureSet["LegacyXLSXExportable"] = "LegacyXLSXExportable";
		D2GFeatureSet["XLSXExportable"] = "XLSXExportable";
		D2GFeatureSet["BlockBasedParser"] = "BlockBasedParser";
		D2GFeatureSet["BlockBasedWriter"] = "BlockBasedWriter";
		D2GFeatureSet["TypedCalcEngineOutputs"] = "TypedCalcEngineOutputs";
		D2GFeatureSet["FullConversion"] = "FullConversion";
		D2GFeatureSet["InvestmentCaseVersioning"] = "InvestmentCaseVersioning";
		D2GFeatureSet["SheetOverrides"] = "SheetOverrides";
		return D2GFeatureSet;
	}({});
	D2G_SHEET_MAPPINGS = {
		"1A_OUT: Invest. Memo": "a_out_invest_memo",
		"1B_OUT: IC Charts": "b_out_ic_charts",
		"2A_CAL: CF Engine": "a_cal_cf_engine",
		"2B_CAL: GRI": "b_cal_gri",
		"2C_CAL: P&L+Tax Engine": "c_cal_p_l_tax_engine",
		"2D_CAL: Promote and IRR": "d_cal_promote_and_irr",
		"2E_CAL: Output Rent Roll": "e_cal_output_rent_roll",
		"2F_CAL: Input Rent Roll": "f_cal_input_rent_roll",
		"2G_CAL: Sensitivity": "g_cal_sensitivity",
		"2H_CAL: Subsidies": "h_cal_subsidies",
		"3A_CRM_INPUT": "a_crm_input",
		"3B_CRM_CONSOLE": "b_crm_console",
		"2I_OUT: RCS Outputs": "i_out_rcs_outputs"
	};
	D2G_SHEET_MAPPING_LOOKUP = invert(D2G_SHEET_MAPPINGS);
	isD2GSheetId = (sheetId) => has(D2G_SHEET_MAPPING_LOOKUP, sheetId);
	MFHD2GPromoteType = /* @__PURE__ */ function(MFHD2GPromoteType) {
		MFHD2GPromoteType["AllCFAboveHurdleShared"] = "Type 1: All CF Above Hurdle Shared";
		MFHD2GPromoteType["OnlyCFUntilThresholdShared"] = "Type 2: Only CF Until Threshold Shared";
		return MFHD2GPromoteType;
	}({});
	MFHMarketChannel = /* @__PURE__ */ function(MFHMarketChannel) {
		MFHMarketChannel["OnMarket"] = "On-Market";
		MFHMarketChannel["OffMarket"] = "Off-Market";
		return MFHMarketChannel;
	}({});
	MFHD2GRentIndexSelection = /* @__PURE__ */ function(MFHD2GRentIndexSelection) {
		MFHD2GRentIndexSelection["Upper"] = "Rent Index - Upper";
		MFHD2GRentIndexSelection["Lower"] = "Rent Index - Lower";
		MFHD2GRentIndexSelection["Mid"] = "Rent Index - Mid";
		MFHD2GRentIndexSelection["MidBetweenUpperAndMid"] = "Rent Index - Mid between Upper and Mid";
		MFHD2GRentIndexSelection["MidBetweenLowerAndMid"] = "Rent Index - Mid between Lower and Mid";
		return MFHD2GRentIndexSelection;
	}({});
	MFHD2GReLetScenario = /* @__PURE__ */ function(MFHD2GReLetScenario) {
		MFHD2GReLetScenario["MarketRent"] = "Market Rent";
		MFHD2GReLetScenario["RentIndex"] = "Rent-Index";
		MFHD2GReLetScenario["RentIndexWithPremium"] = "Rent-Index with Premium";
		return MFHD2GReLetScenario;
	}({});
	MFHD2GStrategicVacancy = /* @__PURE__ */ function(MFHD2GStrategicVacancy) {
		MFHD2GStrategicVacancy["On"] = "On";
		MFHD2GStrategicVacancy["Off"] = "Off";
		return MFHD2GStrategicVacancy;
	}({});
	MFHD2GCashTrap = /* @__PURE__ */ function(MFHD2GCashTrap) {
		MFHD2GCashTrap["On"] = "On";
		MFHD2GCashTrap["Off"] = "Off";
		return MFHD2GCashTrap;
	}({});
	MFHD2GTaxEngineType = /* @__PURE__ */ function(MFHD2GTaxEngineType) {
		MFHD2GTaxEngineType["NonLuxCo"] = "Non LuxCo";
		MFHD2GTaxEngineType["LuxCoMultiEntity"] = "LuxCo Multi Entity";
		return MFHD2GTaxEngineType;
	}({});
	MFHD2GSettingBAFA = /* @__PURE__ */ function(MFHD2GSettingBAFA) {
		MFHD2GSettingBAFA["Off"] = "OFF";
		MFHD2GSettingBAFA["SingleMeasureGrants"] = "Single Measure Grants";
		return MFHD2GSettingBAFA;
	}({});
	MFHD2GSettingBegEmSubsidies = /* @__PURE__ */ function(MFHD2GSettingBegEmSubsidies) {
		MFHD2GSettingBegEmSubsidies["IndividualMeasureShellHeatingMeasure"] = "Individual measure shell + heating measure";
		MFHD2GSettingBegEmSubsidies["IndividualMeasureShellSystemsWithEH55Standard"] = "Individual measure shell/systems with EH 55 standard";
		MFHD2GSettingBegEmSubsidies["IndividualMeasureShellSystemsWithoutEHStandard"] = "Individual measure shell/systems without EH standard";
		MFHD2GSettingBegEmSubsidies["IndividualHeatingMeasure"] = "Individual heating measure";
		MFHD2GSettingBegEmSubsidies["Off"] = "OFF";
		return MFHD2GSettingBegEmSubsidies;
	}({});
	MFHD2GSettingScenario = /* @__PURE__ */ function(MFHD2GSettingScenario) {
		MFHD2GSettingScenario["Worst"] = "Worst";
		MFHD2GSettingScenario["Base"] = "Base";
		MFHD2GSettingScenario["Best"] = "Best";
		return MFHD2GSettingScenario;
	}({});
	MFHD2GSettingCapex = /* @__PURE__ */ function(MFHD2GSettingCapex) {
		MFHD2GSettingCapex["BottomUp"] = "Bottom-Up CAPEX";
		MFHD2GSettingCapex["TopDown"] = "Top-Down CAPEX";
		return MFHD2GSettingCapex;
	}({});
	MFHD2GSettingChurn = /* @__PURE__ */ function(MFHD2GSettingChurn) {
		MFHD2GSettingChurn["Annual"] = "Based on annual churn";
		MFHD2GSettingChurn["Fixed"] = "Based on fixed assumption";
		return MFHD2GSettingChurn;
	}({});
	MFHD2GSettingVAT = /* @__PURE__ */ function(MFHD2GSettingVAT) {
		MFHD2GSettingVAT["OnTop"] = "VAT On Top";
		MFHD2GSettingVAT["Off"] = "VAT Off";
		return MFHD2GSettingVAT;
	}({});
	MFHD2GSettingFinancing = /* @__PURE__ */ function(MFHD2GSettingFinancing) {
		MFHD2GSettingFinancing["BulletLoan"] = "Bullet loan";
		MFHD2GSettingFinancing["Annuity"] = "Annuity";
		return MFHD2GSettingFinancing;
	}({});
	MFHD2GSettingLTV = /* @__PURE__ */ function(MFHD2GSettingLTV) {
		MFHD2GSettingLTV["FixedLTV"] = "Fixed LTV";
		MFHD2GSettingLTV["DebtYield"] = "Debt Yield";
		return MFHD2GSettingLTV;
	}({});
	MFHD2GSettingExpansion = /* @__PURE__ */ function(MFHD2GSettingExpansion) {
		MFHD2GSettingExpansion["Included"] = "Included";
		MFHD2GSettingExpansion["Excluded"] = "Excluded";
		return MFHD2GSettingExpansion;
	}({});
	MFHD2GSettingRentIncrease = /* @__PURE__ */ function(MFHD2GSettingRentIncrease) {
		MFHD2GSettingRentIncrease["PriorToIndex"] = "Prior to Index Level";
		MFHD2GSettingRentIncrease["NoPrior"] = "No Prior Increase";
		return MFHD2GSettingRentIncrease;
	}({});
	MFHD2GSettingKfWStandard = /* @__PURE__ */ function(MFHD2GSettingKfWStandard) {
		MFHD2GSettingKfWStandard["KfW55"] = "KfW 55";
		MFHD2GSettingKfWStandard["KfW70"] = "KfW 70";
		MFHD2GSettingKfWStandard["KfW85"] = "KfW 85";
		MFHD2GSettingKfWStandard["NoKfW"] = "No KfW";
		return MFHD2GSettingKfWStandard;
	}({});
	MFHD2GSettingIRRRange = /* @__PURE__ */ function(MFHD2GSettingIRRRange) {
		MFHD2GSettingIRRRange["IRR11"] = "IRR 11%";
		MFHD2GSettingIRRRange["IRR15"] = "IRR 15%";
		MFHD2GSettingIRRRange["IRR20"] = "IRR 20%";
		MFHD2GSettingIRRRange["IRR25"] = "IRR 25%";
		return MFHD2GSettingIRRRange;
	}({});
	MFHD2GSettingGradualSale = /* @__PURE__ */ function(MFHD2GSettingGradualSale) {
		MFHD2GSettingGradualSale["Off"] = "OFF";
		MFHD2GSettingGradualSale["On"] = "On";
		return MFHD2GSettingGradualSale;
	}({});
	MFHD2GSettingRentRoll = /* @__PURE__ */ function(MFHD2GSettingRentRoll) {
		MFHD2GSettingRentRoll["Off"] = "OFF";
		MFHD2GSettingRentRoll["On"] = "On";
		return MFHD2GSettingRentRoll;
	}({});
	MODCatchUpAfterStaffel = /* @__PURE__ */ function(MODCatchUpAfterStaffel) {
		MODCatchUpAfterStaffel[MODCatchUpAfterStaffel["Zero"] = 0] = "Zero";
		MODCatchUpAfterStaffel[MODCatchUpAfterStaffel["One"] = 1] = "One";
		return MODCatchUpAfterStaffel;
	}({});
	MFHD2GSettingIRRType = /* @__PURE__ */ function(MFHD2GSettingIRRType) {
		MFHD2GSettingIRRType["LeveredPreTaxPrePromote"] = "Levered IRR (pre-tax pre-promote)";
		MFHD2GSettingIRRType["LeveredPostTaxPrePromote"] = "Levered IRR (post-tax pre-promote)";
		MFHD2GSettingIRRType["LeveredPostTaxPostPromote"] = "Levered IRR (post-tax post-promote)";
		MFHD2GSettingIRRType["UnleveredPostTax"] = "Unlevered IRR (post-tax)";
		return MFHD2GSettingIRRType;
	}({});
	MFHD2GSettingExitApproach = /* @__PURE__ */ function(MFHD2GSettingExitApproach) {
		MFHD2GSettingExitApproach["MfhSale"] = "MFH Sale";
		MFHD2GSettingExitApproach["SingleApt3rdPartyDivided"] = "Single Apartment Sale - 3rd Party & Already Divided";
		MFHD2GSettingExitApproach["SingleAptCondoPartyDivided"] = "Single Apartment Sale - CONDO Books & Already Divided";
		MFHD2GSettingExitApproach["SingleApt3rdPartyNotDivided"] = "Single Apartment Sale - 3rd Party & Not Yet Divided";
		MFHD2GSettingExitApproach["SingleAptCondoPartyNotDivided"] = "Single Apartment Sale - CONDO Books & Not Yet Divided";
		return MFHD2GSettingExitApproach;
	}({});
	MFHD2GSettingIFBStandard = /* @__PURE__ */ function(MFHD2GSettingIFBStandard) {
		MFHD2GSettingIFBStandard["NoIFB"] = "No IFB";
		MFHD2GSettingIFBStandard["IFB75kwh"] = "IFB<75";
		MFHD2GSettingIFBStandard["IFB70"] = "IFB70";
		MFHD2GSettingIFBStandard["IFB55"] = "IFB55";
		MFHD2GSettingIFBStandard["IFB40"] = "IFB40";
		MFHD2GSettingIFBStandard["IFB90Kwh"] = "IFB<90";
		return MFHD2GSettingIFBStandard;
	}({});
	MFHD2GSettingEKDrawFirst = /* @__PURE__ */ function(MFHD2GSettingEKDrawFirst) {
		MFHD2GSettingEKDrawFirst["Off"] = "OFF";
		MFHD2GSettingEKDrawFirst["On"] = "On";
		return MFHD2GSettingEKDrawFirst;
	}({});
	MFHD2GSettingEKDrawFirstExt = /* @__PURE__ */ function(MFHD2GSettingEKDrawFirstExt) {
		MFHD2GSettingEKDrawFirstExt["Off"] = "OFF";
		MFHD2GSettingEKDrawFirstExt["OnContributeTotalEquityAtAcquisition"] = "On - Contribute total equity at acquisition";
		MFHD2GSettingEKDrawFirstExt["OnOnlyNonSubsidizedCapEx"] = "On - Only Non-Subsidized CapEx";
		return MFHD2GSettingEKDrawFirstExt;
	}({});
	MFHD2GSettingRentIncreaseDependentOnDataQuality = /* @__PURE__ */ function(MFHD2GSettingRentIncreaseDependentOnDataQuality) {
		MFHD2GSettingRentIncreaseDependentOnDataQuality["Increase"] = "BGB rent increase when the date of the last increase is missing";
		MFHD2GSettingRentIncreaseDependentOnDataQuality["NoIncrease"] = "No BGB rent increase when the date of the last increase is missing";
		return MFHD2GSettingRentIncreaseDependentOnDataQuality;
	}({});
	MFHD2GSettingMonumentProtection = /* @__PURE__ */ function(MFHD2GSettingMonumentProtection) {
		MFHD2GSettingMonumentProtection["Yes"] = "Yes";
		MFHD2GSettingMonumentProtection["No"] = "No";
		return MFHD2GSettingMonumentProtection;
	}({});
	MFHD2GSettingRentIncreaseAnnualOnly = /* @__PURE__ */ function(MFHD2GSettingRentIncreaseAnnualOnly) {
		MFHD2GSettingRentIncreaseAnnualOnly["Off"] = "OFF";
		MFHD2GSettingRentIncreaseAnnualOnly["On"] = "On";
		return MFHD2GSettingRentIncreaseAnnualOnly;
	}({});
	MFHD2GSettingNetGross = /* @__PURE__ */ function(MFHD2GSettingNetGross) {
		MFHD2GSettingNetGross["net"] = "net";
		MFHD2GSettingNetGross["gross"] = "gross";
		return MFHD2GSettingNetGross;
	}({});
	MFHInvestmentCaseStatus = /* @__PURE__ */ function(MFHInvestmentCaseStatus) {
		MFHInvestmentCaseStatus["Creating"] = "Creating";
		MFHInvestmentCaseStatus["Created"] = "Created";
		MFHInvestmentCaseStatus["Error"] = "Error";
		MFHInvestmentCaseStatus["Review"] = "Review";
		MFHInvestmentCaseStatus["Approved"] = "Approved";
		MFHInvestmentCaseStatus["Reverted"] = "Reverted";
		MFHInvestmentCaseStatus["Rejected"] = "Rejected";
		return MFHInvestmentCaseStatus;
	}({});
	MFHInvestmentCaseType = /* @__PURE__ */ function(MFHInvestmentCaseType) {
		MFHInvestmentCaseType["Acquisition"] = "Acquisition";
		MFHInvestmentCaseType["AssetManagement"] = "AssetManagement";
		return MFHInvestmentCaseType;
	}({});
	DISABLED_MFH_IC_STATUS = [
		"Error",
		"Creating",
		"Rejected",
		"Approved",
		"Reverted",
		"Review"
	];
	MFHOutputErrorKind = /* @__PURE__ */ function(MFHOutputErrorKind) {
		MFHOutputErrorKind["EMPTY"] = "EMPTY";
		MFHOutputErrorKind["NUMERIC"] = "NUMERIC";
		MFHOutputErrorKind["REF"] = "REF";
		MFHOutputErrorKind["FORMULA"] = "FORMULA";
		MFHOutputErrorKind["NAME"] = "NAME";
		MFHOutputErrorKind["N_A"] = "N_A";
		MFHOutputErrorKind["DIV_BY_ZERO"] = "DIV_BY_ZERO";
		return MFHOutputErrorKind;
	}({});
	SHEET_ERROR_MAPPINGS = {
		"#NULL!": "EMPTY",
		"#NAME?": "NAME",
		"#REF!": "REF",
		"#VALUE!": "FORMULA",
		"#ERROR!": "FORMULA",
		"#N/A": "N_A",
		"#NUM!": "NUMERIC",
		"#DIV/0!": "DIV_BY_ZERO"
	};
	MFHInputFieldVisible = /* @__PURE__ */ function(MFHInputFieldVisible) {
		MFHInputFieldVisible["CONFIG"] = "CONFIG";
		MFHInputFieldVisible["IC"] = "IC";
		return MFHInputFieldVisible;
	}({});
	getMFHInvestmentCaseInputConfigForPath = (path) => {
		if (!path?.length) return;
		if (path.includes("investorAssumptions.")) return get(mfhInvestmentCaseAssetPartnerInputsFormConfig, path.replace("investorAssumptions.", ""));
		return get(mfhInvestmentCaseInputsFormConfig, path);
	};
	isMFHInvestmentCaseInputActiveForVersion = (inputConfig, version) => {
		if (!inputConfig) return false;
		return !inputConfig.versionCompat || version == null || satisfies(version, inputConfig.versionCompat);
	};
	getMFHInvestmentCaseEnumSource = (inputConfig, version) => {
		if (!inputConfig || !("source" in inputConfig)) return;
		return (inputConfig.versionedSources?.find((sourceConfig) => version != null && satisfies(version, sourceConfig.versionCompat)))?.source ?? inputConfig.source;
	};
	isMFHInvestmentCaseInputRequired = (inputConfig, ic, version) => {
		if (!inputConfig) return false;
		if (!isMFHInvestmentCaseInputActiveForVersion(inputConfig, version)) return false;
		if (inputConfig.requiredVersionCompat && !(version != null && satisfies(version, inputConfig.requiredVersionCompat))) return false;
		if (inputConfig.required) return true;
		if (!inputConfig.requiredForAssetPartners?.length || !ic) return false;
		const assetPartnerName = ic.assetPartner?.name ?? ic.caseInputs?.d2gSettings?.investor;
		if (!assetPartnerName) return false;
		const normalizedAssetPartnerName = assetPartnerName.trim().toLowerCase();
		return inputConfig.requiredForAssetPartners.some((requiredPartner) => normalizedAssetPartnerName.includes(requiredPartner.trim().toLowerCase()));
	};
	mfhAssetPartnerBuyBoxInputsFormConfig = {
		totalApetite: {
			visibleIn: ["CONFIG"],
			required: true,
			type: "scalar",
			format: "currency"
		},
		irrPercentageThreshold: {
			visibleIn: ["CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		cocPercentageThreshold: {
			visibleIn: ["CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		mocMultiplierThreshold: {
			visibleIn: ["CONFIG"],
			required: true,
			type: "scalar",
			format: "number"
		},
		investmentVolumeThreshold: {
			visibleIn: ["CONFIG"],
			required: true,
			type: "scalar",
			format: "currency"
		},
		purchasePriceDiscountThreshold: {
			visibleIn: ["CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		commercialShareThreshold: {
			visibleIn: ["CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		preferredLocationsThreshold: {
			visibleIn: ["CONFIG"],
			required: true,
			type: "select",
			format: "string"
		}
	};
	mfhAssetPartnerBuyBoxInputFields = Object.entries(mfhAssetPartnerBuyBoxInputsFormConfig).map(([field, config]) => ({
		field,
		...config
	}));
	mfhInvestmentCaseInputsFormConfig = {
		$root: {
			rentRollVersionId: {
				versionCompat: ">=5.3.2",
				visibleIn: ["IC"],
				required: false,
				type: "select",
				format: "number"
			},
			assetPartnerProfile: { name: {
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "string"
			} }
		},
		general: {
			assetName: {
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "string"
			},
			sourcingStatus: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "string"
			},
			transferToD2G: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "boolean"
			},
			signoffState: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "string"
			},
			sourcingDate: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "string"
			},
			sourcingChannel: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: true,
				type: "enum",
				source: MfhChannelName
			},
			sellerName: {
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "string"
			},
			salesReason: {
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "string"
			},
			exitApproach: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: false,
				type: "enum",
				source: MFHD2GSettingExitApproach
			},
			ownerLead: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "string"
			},
			mfhLink: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "string"
			},
			exposeeLink: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "string"
			},
			dataRoomLink: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "string"
			},
			splitStatus: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "string"
			}
		},
		agent: {
			courtageExclVat: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			agencyName: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "string"
			},
			lastname: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "string"
			},
			email: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "string"
			},
			phoneNumber: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "string"
			}
		},
		location: {
			restrictions: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: true,
				multiple: true,
				type: "enum",
				source: Restrictions
			},
			googleMapsLink: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "string"
			},
			riwisLocation: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "string"
			},
			comment: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "string"
			},
			streetNames: {
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "string"
			},
			houseNo: {
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "string"
			},
			postcode: {
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "string"
			},
			city: {
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "string"
			},
			region: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "string"
			},
			state: {
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "string"
			},
			districtHeatingPossible: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "string"
			}
		},
		overview: {
			askingPrice: {
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "currency"
			},
			parkingSpacesExpansion: {
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "number",
				integer: true
			},
			expansionPotentialSqm: {
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "number"
			},
			avgSizeResidentialSqm: {
				readonlyOnVersionIncompat: true,
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "number",
				computed: true
			},
			avgSizeCommercialSqm: {
				readonlyOnVersionIncompat: true,
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "number",
				computed: true
			},
			shareOfCommercialSpacePercent: {
				readonlyOnVersionIncompat: true,
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "percent",
				computed: true
			},
			rentResidentialCurrent: {
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			rentResidentialCurrentSqm: {
				readonlyOnVersionIncompat: true,
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency",
				computed: true
			},
			askingPriceSqm: {
				readonlyOnVersionIncompat: true,
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "currency",
				computed: true
			},
			factorOnAskingPrice: {
				readonlyOnVersionIncompat: true,
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "number",
				computed: true
			},
			resiSpaceSqm: {
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "number"
			},
			resiUnits: {
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "number",
				integer: true
			},
			commercialSpaceSqm: {
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "number"
			},
			commercialSpacePriceSqm: {
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency",
				computed: true
			},
			resiSpacePriceSqm: {
				visibleIn: ["IC"],
				required: false,
				computed: true,
				type: "scalar",
				format: "currency"
			},
			commercialUnits: {
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "number",
				integer: true
			},
			parkingSpaces: {
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "number",
				integer: true
			}
		},
		buildingTechnical: {
			constructionYear: {
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "number"
			},
			brickFacade: {
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "boolean"
			},
			brickFacadeSqm: {
				versionCompat: ">=4",
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "number"
			},
			fassadeInsulation: {
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			primaryEnergyDemandKWhSqm: {
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "number"
			},
			endEnergyConsumptionKWhSqm: {
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "number"
			},
			endEnergyConsumptionClass: {
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "string",
				computed: true
			},
			endEnergyConsumptionClassPostRenovation: {
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "string",
				computed: true
			},
			districtHeatingAsPrimaryEnergySource: {
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "boolean"
			},
			numberOfApartmentsInHeatedArea: {
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "number",
				integer: true
			},
			numBuildings: {
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "number",
				integer: true
			}
		},
		rent: {
			rentIndexPreEe: {
				versionCompat: ">=5.5.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "enum",
				source: MFHD2GRentIndexSelection
			},
			rentIndexPostEe: {
				versionCompat: ">=5.5.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "enum",
				source: MFHD2GRentIndexSelection
			},
			rentIndex: {
				requiredVersionCompat: ">=5.5.0",
				visibleIn: ["IC"],
				required: true,
				type: "table",
				format: "number"
			},
			jnkmTotalCurrent: {
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency",
				computed: true
			},
			jnkmCommercialCurrent: {
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			jnkmParkingSpacesCurrent: {
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			resiOccupancyActual: {
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "percent"
			},
			commercialOccupancyActual: {
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "percent"
			},
			parkingOccupancyActual: {
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "percent"
			},
			rentRollSheetsId: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "string"
			},
			appliedRentResidential: {
				versionCompat: ">=3",
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "currency"
			},
			appliedRentCommercial: {
				versionCompat: ">=3",
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "currency"
			},
			appliedRentCarpark: {
				versionCompat: ">=3",
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "currency"
			},
			adjustedTargetRentLt50Sqm: {
				versionCompat: ">=4",
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			adjustedTargetRent50To75Sqm: {
				versionCompat: ">=4",
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			adjustedTargetRent75To100Sqm: {
				versionCompat: ">=4",
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			adjustedTargetRentGt100Sqm: {
				versionCompat: ">=4",
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "percent"
			}
		},
		rentPredictions: {
			manualExpandedSpace: {
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "currency"
			},
			condoSophisticated: {
				readonlyOnVersionIncompat: true,
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			condoLuxury: {
				readonlyOnVersionIncompat: true,
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			sprengSophisticated: {
				readonlyOnVersionIncompat: true,
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			sprengLuxury: {
				readonlyOnVersionIncompat: true,
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			sprengCommercial: {
				readonlyOnVersionIncompat: true,
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			condoCarpark: {
				readonlyOnVersionIncompat: true,
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			manualCommercial: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			manualResidentialPostTI: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			manualCarpark: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency"
			}
		},
		d2gSettings: {
			cashTrap: {
				versionCompat: ">=5.5.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "enum",
				source: MFHD2GCashTrap
			},
			reLetScenario: {
				versionCompat: ">=5.5.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "enum",
				source: MFHD2GReLetScenario
			},
			strategicVacancy: {
				versionCompat: ">=5.5.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "enum",
				source: MFHD2GStrategicVacancy
			},
			taxEngineType: {
				versionCompat: ">=5.5.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "enum",
				source: MFHD2GTaxEngineType
			},
			d2gScenario: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "enum",
				source: MFHD2GSettingScenario
			},
			bafa: {
				versionCompat: "<5.1.1",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "enum",
				source: MFHD2GSettingBAFA
			},
			begEmSubsidies: {
				versionCompat: ">=5.1.1",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "enum",
				source: MFHD2GSettingBegEmSubsidies
			},
			capex: {
				visibleIn: ["IC", "CONFIG"],
				versionCompat: ">=1 <3",
				required: true,
				type: "enum",
				source: MFHD2GSettingCapex
			},
			investor: {
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "string"
			},
			churnVsFixed: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "enum",
				source: MFHD2GSettingChurn
			},
			vat: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "enum",
				source: MFHD2GSettingVAT
			},
			financing: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "enum",
				source: MFHD2GSettingFinancing
			},
			LTV: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "enum",
				source: MFHD2GSettingLTV
			},
			expansion: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "enum",
				source: MFHD2GSettingExpansion
			},
			rentIncrease: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "enum",
				source: MFHD2GSettingRentIncrease
			},
			kfwStandard: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "enum",
				source: MFHD2GSettingKfWStandard
			},
			exitApproach: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC"],
				required: true,
				type: "enum",
				source: MFHD2GSettingExitApproach
			},
			IRRRange: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "enum",
				source: MFHD2GSettingIRRRange
			},
			IRRType: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "enum",
				source: MFHD2GSettingIRRType
			},
			gradualSale: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "enum",
				source: MFHD2GSettingGradualSale
			},
			rentRoll: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "enum",
				source: MFHD2GSettingRentRoll
			},
			ifbStandard: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "enum",
				source: MFHD2GSettingIFBStandard
			},
			ekDrawFirst: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "enum",
				source: MFHD2GSettingEKDrawFirst,
				versionedSources: [{
					versionCompat: "<5.5.0",
					source: MFHD2GSettingEKDrawFirst
				}, {
					versionCompat: ">=5.5.0",
					source: MFHD2GSettingEKDrawFirstExt
				}]
			},
			rentIncreaseDependentOnDataQuality: {
				versionCompat: ">=5.2.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "enum",
				source: MFHD2GSettingRentIncreaseDependentOnDataQuality
			},
			monumentProtection: {
				versionCompat: ">=5.2.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "enum",
				source: MFHD2GSettingMonumentProtection
			},
			rentIncreaseAnnualOnly: {
				versionCompat: ">=5.2.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "enum",
				source: MFHD2GSettingRentIncreaseAnnualOnly
			}
		},
		assumptions: {
			minJnkmForCt: {
				type: "scalar",
				versionCompat: ">=5.5.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				format: "number"
			},
			qrtForCtRelease: {
				type: "scalar",
				versionCompat: ">=5.5.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				format: "number"
			},
			allowedOpexForCt: {
				type: "scalar",
				versionCompat: ">=5.5.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				format: "percent"
			},
			ctMaxLtv: {
				type: "scalar",
				versionCompat: ">=5.5.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				format: "percent"
			},
			workingCapitalForEquityFirstNonSubsidizedCapex: {
				type: "scalar",
				versionCompat: ">=5.5.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				format: "number"
			},
			acquisitionType: {
				versionCompat: ">=5.5.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "enum",
				source: MFHMarketChannel
			},
			exitType: {
				versionCompat: ">=5.5.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "enum",
				source: MFHMarketChannel
			},
			expectedExitVolume: {
				versionCompat: ">=5.5.0",
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "currency"
			},
			rett: {
				versionCompat: ">=3",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "percent"
			},
			assetOwned: {
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "boolean"
			},
			assetViewed: {
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "date",
				computed: true
			},
			entryDate: {
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "date",
				computed: true
			},
			expectedPurchaseDiscount: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			rentIndexPreRenovation: {
				versionCompat: "<5.5.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "currency"
			},
			rentIndexPostEeRenovation: {
				versionCompat: "<5.5.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "currency"
			},
			durationInMonths: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number",
				integer: true
			},
			ddContingency: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			landValueAsPercentOfGpp: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			energyEfficiencyStart: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			energyEfficiencyEnd: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			generalStart: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			generalEnd: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			expansionStart: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			expansionEnd: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			shareOfEeCapexAttributableForSubsidies: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			shareOfExtensionCapexAttributableForSubsidies: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			shareOfExtensionCapexAttributableForModLevy: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			modCatchUpAfterStaffel: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "enum",
				source: MODCatchUpAfterStaffel
			},
			timingCommercialCarparkRentIncreaseMonth: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number",
				integer: true
			},
			annualChurnCommercial: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			annualChurnCarPark: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			firstBgbRentIncreaseTiming: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			firstBgbRentIncreaseSize: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			secondBgbRentIncreaseTiming: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			secondBgbRentIncreaseSize: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			thirdBgbRentIncreaseTiming: {
				versionCompat: ">=4",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			thirdBgbRentIncreaseSize: {
				versionCompat: ">=4",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			fourthBgbRentIncreaseTiming: {
				versionCompat: ">=5.5.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number",
				integer: true
			},
			fourthBgbRentIncreaseSize: {
				versionCompat: ">=5.5.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			bgbRentIncreaseToMidOfLowAndMedium: {
				versionCompat: ">=4 <5.5.0",
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "boolean"
			},
			lettingFeesResidential: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			lettingFeesCommercial: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			vatDamageMaintenance: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			vatDamageCommercialTIS: {
				versionCompat: ">=4",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			vatDamagePurchaseCosts: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			vatDamagePartnerFees: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			vatDamageModernizationcapex: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			vatDamageExpansionApartment: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			notaryCosts: {
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency",
				computed: true
			},
			ltvSubsidizedLoanKfWPercent: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			appliedEETopUp: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "currency"
			},
			appliedEETopUpForIndex: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "currency"
			},
			bafaSingleMeasureGrant: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			renovationObligationPerSqmWithoutTIs: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "currency"
			},
			expandedSalesStart: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			expandedSalesEnd: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			salesDelayAfterTIsCompleted: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			bankInterestRate: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "percent"
			},
			inflationRate: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "percent"
			},
			allowedAnnualRentIncreaseEe: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "percent"
			},
			provisionVacancyLossSqm: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			rentIncreaseEnergyEfficiencyOnly: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			rentIncreaseEEOnlyBefore_7: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			annualRentGrowthWhgRenovation: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "percent"
			},
			annualRentGrowthNonWhgRenovation: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "percent"
			},
			reletDelayMonths: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "number",
				integer: true
			},
			startLettingInitialVacancyMonth: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "number",
				integer: true
			},
			endLettingInitialVacancyMonth: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "number",
				integer: true
			},
			shareMaintenanceRenovationCapex: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "percent"
			},
			co2FactorKwhElectricity: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "number"
			},
			co2FactorKwhHeating: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "number"
			},
			avgHeatingCostPerKwh: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			avgElectricityConsumptionUnitPreRenovation: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "number"
			},
			avgElectricityConsumptionUnitPostRenovation: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "number"
			},
			nonRecsMaintenance: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			subsidisedInterestRateBulletLoan: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "percent"
			},
			subsidisedCommitmentFee: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "percent"
			},
			stateSubsidiesBafaKfwPayoutMonth: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "number",
				integer: true
			},
			kfw_55RepaymentSubsidyPercentPerUnit: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "percent"
			},
			kfw_70RepaymentSubsidyPercentPerUnit: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "percent"
			},
			kfw_85RepaymentSubsidyPercentPerUnit: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "percent"
			},
			kfw_55EEMaxAmountPerUnit: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			kfw_70EEMaxAmountPerUnit: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			kfw_85EEMaxAmountPerUnit: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			kfw_55MaxAmountPerUnit: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			kfw_70MaxAmountPerUnit: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			kfw_85MaxAmountPerUnit: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			kfwEERepaymentSubsidyPercentPerUnit: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "percent"
			},
			kfwMfhConstructionSupervisionPerUnit: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			kfwMfhConstructionSupervisionMaxPerProject: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			kfwWorstPerformingBonus: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "percent"
			},
			kfwWpbThreshold: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "number"
			},
			kfwWpbEEMaxAmountPerUnit: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			kfwWpbNonEEMaxAmountPerUnit: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			kfwLoanEEClass: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			kfwLoanNonEEClass: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			ifbBasisfoerderungPerUnit: {
				versionCompat: "<5.2.0",
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			ifbEnergieberatung: {
				versionCompat: "<5.2.0",
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			ifbQualityAssuranceEnergy: {
				versionCompat: "<5.2.0",
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			ifbEfficiencyHouse_55StockPerKwhA: {
				versionCompat: "<5.2.0",
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			ifbEfficiencyHouse_70StockPerKwhA: {
				versionCompat: "<5.2.0",
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			ifbEfficiencyHouse_85StockPerKwhA: {
				versionCompat: "<5.2.0",
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			ifbBrickFacade: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			ifbSubsidyCap: {
				versionCompat: ">=5.4.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			ibbSubsidizedInterestRate: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "percent"
			},
			dusSubsidyQuote: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "percent"
			},
			dusEfficiencyHouseStandardSubsidyMaxPerUnit: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			dusEENhClassSubsidyMaxPerUnit: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			dusSubsidyMaxPerRecipient: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			citRate27: {
				versionCompat: ">=5.5.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			citRate28: {
				versionCompat: ">=5.5.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			citRate29: {
				versionCompat: ">=5.5.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			citRate30: {
				versionCompat: ">=5.5.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			citRate31: {
				versionCompat: ">=5.5.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			citRate32ongoing: {
				versionCompat: ">=5.5.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			tlcfDeductiblePercentAboveBaseAmount: {
				versionCompat: ">=5.5.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			tradeTax: {
				versionCompat: ">=5.5.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			contingency: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "percent"
			},
			disposalCosts: {
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "percent"
			},
			capexNonSubsidizedDebtUpfrontFee: {
				versionCompat: ">=5.1.1",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			capexNonSubsidizedDebtRunningAm: {
				versionCompat: ">=5.1.1",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			capexNonSubsidizedDebtAMStartMonth: {
				versionCompat: ">=5.1.1",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number",
				integer: true
			},
			fkgIndividualMeasureGrant: {
				versionCompat: ">=5.1.1",
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "percent"
			},
			fkgHeatingReplacementSubsidy: {
				versionCompat: ">=5.1.1",
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "percent"
			},
			fkgEfficiencyHouse55Subsidy: {
				versionCompat: ">=5.1.1",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			fkg1Funding: {
				versionCompat: ">=5.1.1",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			bafaIsfpBonus: {
				versionCompat: ">=5.1.1",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			kfWIndividualMeasureHeatGeneration: {
				versionCompat: ">=5.1.1",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			bafaEligibleExpenditureCapPerResidentialUnitWithoutIsfp: {
				versionCompat: ">=5.1.1",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "currency"
			},
			bafaEligibleExpenditureCapPerResidentialUnitWithIsfp: {
				versionCompat: ">=5.1.1",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "currency"
			},
			bafaSpecialistPlanningAndConstructionSupport: {
				versionCompat: ">=5.1.1",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			bafaSpecialistPlanningAndConstructionSupportCap: {
				versionCompat: ">=5.1.1",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "currency"
			},
			bafaSpecialistPlanningAndConstructionSupervisionPerResidentialUnit: {
				versionCompat: ">=5.1.1",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "currency"
			},
			kfw459FirstResidentialUnit: {
				versionCompat: ">=5.1.1",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "currency"
			},
			kfw459SecondToSixthResidentialUnits: {
				versionCompat: ">=5.1.1",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "currency"
			},
			kfw459SeventhPlusResidentialUnits: {
				versionCompat: ">=5.1.1",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "currency"
			},
			fkgB1CapWithoutEnergyStandard: {
				versionCompat: ">=5.1.1",
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			fkgB1CapEnergyStandard: {
				versionCompat: ">=5.1.1",
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			fkgB1PerResidentialUnitWithoutEnergyStandard: {
				versionCompat: ">=5.1.1",
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			fkgB1PerResidentialUnitWithEnergyStandard: {
				versionCompat: ">=5.1.1",
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			fkgBafaTotalFundingCap: {
				versionCompat: ">=5.1.1",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			fkgBafaPaymentAfterConstructionCompletion: {
				versionCompat: ">=5.1.1",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			isfpPlanning: {
				versionCompat: ">=5.1.1",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "boolean"
			},
			heatingReplacement: {
				versionCompat: ">=5.1.1 <5.3.1",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "boolean"
			},
			heatingReplacementCostsPerSqm: {
				versionCompat: ">=5.1.1",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "currency"
			},
			numberOfResidentialUnitsForIndividualMeasure: {
				versionCompat: ">=5.1.1",
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "number",
				integer: true,
				computed: true
			},
			annualIndexUpdateMonthEndOf: {
				versionCompat: ">=5.2.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number",
				integer: true
			},
			modUmlageDelayPostEeCapex: {
				versionCompat: ">=5.2.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			vpiGoingIn: {
				versionCompat: ">=5.2.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			rentClass1UpperLimit: {
				versionCompat: ">=5.2.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			rentClass2UpperLimit: {
				versionCompat: ">=5.2.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			rentClass3UpperLimit: {
				versionCompat: ">=5.2.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			commercialIndexationThreshold: {
				versionCompat: ">=5.2.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			indexationHurdle: {
				versionCompat: ">=5.2.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			minIntervalIndexIncrease: {
				versionCompat: ">=5.2.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number",
				integer: true
			},
			condoLettingFeesResi: {
				versionCompat: ">=5.2.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			condoLettingFeesCommercial: {
				versionCompat: ">=5.2.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			capexSubsidizedDebtUpfrontFee: {
				versionCompat: ">=5.2.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			ifbLt90kwh: {
				versionCompat: ">=5.2.0",
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			ifbLt75kwh: {
				versionCompat: ">=5.2.0",
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			ifb70EH: {
				versionCompat: ">=5.2.0",
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			ifb55EH: {
				versionCompat: ">=5.2.0",
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			ifb40EH: {
				versionCompat: ">=5.2.0",
				visibleIn: ["IC", "CONFIG"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			ifbJointRepairHighCost: {
				versionCompat: ">=5.2.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "currency"
			},
			landRegistry: {
				versionCompat: ">=5.4.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			exitMultipleRunningResiSpace: {
				versionCompat: ">=5.4.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			exitMultipleReletResiSpace: {
				versionCompat: ">=5.4.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			exitMultipleExpansionSpace: {
				versionCompat: ">=5.4.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			exitMultipleCommercial: {
				versionCompat: ">=5.4.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			exitMultipleParking: {
				versionCompat: ">=5.4.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			tIsClass1UpperLimit: {
				versionCompat: ">=5.4.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			tIsClass2UpperLimit: {
				versionCompat: ">=5.4.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			tIsClass3UpperLimit: {
				versionCompat: ">=5.4.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			targetTIsAdjCat1: {
				versionCompat: ">=5.4.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			targetTIsAdjCat2: {
				versionCompat: ">=5.4.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			targetTIsAdjCat3: {
				versionCompat: ">=5.4.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			targetTIsAdjCat4: {
				versionCompat: ">=5.4.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			startSubsidizedCommittmentFee: {
				versionCompat: ">=5.4.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			startNonSubsidizedCommittmentFee: {
				versionCompat: ">=5.4.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			startExpansionLetting: {
				versionCompat: ">=5.5.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number",
				integer: true
			},
			endExpansionLetting: {
				versionCompat: ">=5.5.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number",
				integer: true
			},
			rentIndexPremium: {
				versionCompat: ">=5.5.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			lightCapexLeaseCutoff: {
				versionCompat: ">=5.5.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "date"
			},
			monthUntilStrategicVacancy: {
				versionCompat: ">=5.5.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number",
				integer: true
			},
			tiCapexLight: {
				versionCompat: ">=5.5.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "currency"
			},
			strategicVacantSpaceLeaseUpPeriod: {
				versionCompat: ">=5.5.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number",
				integer: true
			},
			subsidizedCapexLoanMaturityDate: {
				versionCompat: ">=5.6.0",
				visibleIn: ["IC"],
				required: true,
				type: "scalar",
				format: "date"
			},
			nextBuyerTransactionCosts: {
				versionCompat: ">=5.6.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			}
		},
		bestWorst: {
			exitMultiple: {
				versionCompat: "<5.4.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "worstBaseBest",
				format: "number"
			},
			annunalTenantChurn: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "worstBaseBest",
				format: "percent"
			},
			averageExpandedUnitSize: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "worstBaseBest",
				format: "number"
			},
			renovationCostEnergyEfficiencySqm: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "worstBaseBest",
				format: "currency"
			},
			renovationCostInteriorCommercialSqm: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "worstBaseBest",
				format: "currency"
			},
			renovationCostInteriorSqm: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "worstBaseBest",
				format: "currency"
			},
			expansionCostSqm: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "worstBaseBest",
				format: "currency"
			},
			percentageOfSqmWithInteriorRenovation: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "worstBaseBest",
				format: "percent"
			},
			generalCapexSqm: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "worstBaseBest",
				format: "currency"
			},
			epcRatingInKWHPostRenovation: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "worstBaseBest",
				format: "number"
			},
			singleApartmentsExitMultipleEEOnly: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "worstBaseBest",
				format: "number"
			},
			singleApartmentsExitMultipleEEWithTIs: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "worstBaseBest",
				format: "number"
			},
			initialHOAReserveSqm: {
				versionCompat: ">=1 <3",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "worstBaseBest",
				format: "currency"
			}
		},
		compensationTenantsResi: {
			compensationResiChurnSqm: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "currency"
			},
			compensationResiChurnTimingMonths: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number",
				integer: true
			},
			compensationTenantsLiving: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "worstBaseBest",
				format: "currency"
			}
		},
		compensationTenantsCommercial: {
			compensationTenantsCommercial: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "worstBaseBest",
				format: "currency"
			},
			compensationCommercialChurnSqm: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "currency"
			},
			compensationCommercialTimingMonths: {
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number",
				integer: true
			}
		},
		singleApartmentAssumptions: {
			maxInvestorCashflowContributionEeTIsPMUnit: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			maxInvestorCashflowContributionEePMUnit: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			interestRateInvestor: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			repaymentRate: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			taxRateInvestor: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			proportionOfBuilding: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			amortizationRate: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			amortizationNewBuilt6Years: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			amortizationNewBuiltLinearOnwards: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			SEVFee: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "currency"
			},
			financingLTV: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			transferTax: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			HOAFeeMonthSqm: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "currency"
			},
			HOAFeeNonTransferrablePercentageOfTotal: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			HOAFeeReservePercentageOfTotal: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			sellingFeeResidential: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "currency"
			},
			sellingFeeCommercial: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "currency"
			},
			marketingCosts: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "currency"
			},
			measurementCostsPerUnit: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "currency"
			},
			architectCostsDivisionPlanPerUnit: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "currency"
			},
			completionCertificatePerUnit: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			landRegistryOfficePerUnit: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			salesSubsidyLengthYears: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			condoWACC: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "currency"
			},
			bankLTV: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			rentPoolRentSqm: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			rentPoolDurationYears: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			salesPriceSqmRentPoolUnit: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "currency"
			},
			salesPriceExpandedSqm: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "currency"
			},
			vacancyPool: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number"
			},
			financingPeriodInMonthsFull: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number",
				integer: true
			},
			holdingPeriodIncomeInMonths: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "number",
				integer: true
			},
			anualTenantChurn: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC", "CONFIG"],
				required: true,
				type: "scalar",
				format: "percent"
			},
			singleApartmentSalesExitMultipleEeOnly: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "number"
			},
			singleApartmentSalesExitMultipleEeAndTIs: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "number"
			},
			combinedAvgEffectiveMultiple: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "number"
			},
			salesSupportForInvestors: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			HOASplitSetUpCosts: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			marketingSalesCosts: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			HOAContribution: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			notaryCostsPercentageOfGAV: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "percent"
			},
			singleApartmentCompensationTenantsLiving: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			singleApartmentCompensationTenantsCommercial: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			initialHOAReserveEurSQM: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			GAV: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			salesPriceSqmRentPoolImpliedYieldDuringRentPool: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			salesPriceSqmRentPoolImpliedYieldDuringAfterRentPoolUnrenovated: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			salesPriceSqmRentPoolImpliedYieldDuringAfterRentPoolRenovated: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			salesPriceExpandedImpliedYieldDuringRentPool: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			salesPriceExpandedImpliedYieldDuringAfterRentPool: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			renovationCostsEnergyEfficiencySqm: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			generalCapex: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			renovationCostsInteriorSqm: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			singleApartmentExpansionCostSqm: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency"
			},
			rentIncreasePossibleThroughModernizationLevy: {
				versionCompat: "<3.1.0",
				visibleIn: ["IC"],
				required: false,
				type: "scalar",
				format: "currency"
			}
		}
	};
	mfhInvestmentCaseAssetPartnerInputsFormConfig = {
		...mfhAssetPartnerBuyBoxInputsFormConfig,
		condoPurchasingServiceFee: {
			versionCompat: "<5.5.0",
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		condoPurchasingServiceFeeWithBroker: {
			versionCompat: "<5.5.0",
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		condoPurchasingServiceFeeNoBroker: {
			versionCompat: "<5.5.0",
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		reneoPurchasingServiceFee: {
			versionCompat: ">=5.5.0",
			visibleIn: ["IC"],
			required: false,
			type: "scalar",
			format: "percent",
			computed: true
		},
		reneoSalesFee: {
			versionCompat: ">=5.5.0",
			visibleIn: ["IC"],
			required: false,
			type: "scalar",
			format: "percent",
			computed: true
		},
		condoRenovationServiceFee: {
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		renovationFeeNetOrGrossOfCapex: {
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "enum",
			source: MFHD2GSettingNetGross
		},
		condoSalesFeeNoBroker: {
			versionCompat: "<5.2.0",
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		condoSalesFeeWithBroker: {
			versionCompat: "<5.2.0",
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		condoSalesFeeWithBroker_gt75m: {
			versionCompat: "<5.2.0",
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		condoSalesFeeNoBroker_gt75m: {
			versionCompat: "<5.2.0",
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		condoSalesFeeWithBroker_gt25m: {
			versionCompat: "<5.2.0",
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		condoSalesFeeNoBroker_gt25m: {
			versionCompat: "<5.2.0",
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		condoSalesFeeWithBroker_lt25m: {
			versionCompat: "<5.2.0",
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		condoSalesFeeNoBroker_lt25m: {
			versionCompat: "<5.2.0",
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		acquisitionFeeOnMarket_lt25m: {
			versionCompat: ">=5.5.0",
			visibleIn: [],
			required: false,
			type: "scalar",
			format: "percent"
		},
		acquisitionFeeOnMarket_gt25m: {
			versionCompat: ">=5.5.0",
			visibleIn: [],
			required: false,
			type: "scalar",
			format: "percent"
		},
		acquisitionFeeOnMarket_gt75m: {
			versionCompat: ">=5.5.0",
			visibleIn: [],
			required: false,
			type: "scalar",
			format: "percent"
		},
		acquisitionFeeOffMarket_lt25m: {
			versionCompat: ">=5.5.0",
			visibleIn: [],
			required: false,
			type: "scalar",
			format: "percent"
		},
		acquisitionFeeOffMarket_gt25m: {
			versionCompat: ">=5.5.0",
			visibleIn: [],
			required: false,
			type: "scalar",
			format: "percent"
		},
		acquisitionFeeOffMarket_gt75m: {
			versionCompat: ">=5.5.0",
			visibleIn: [],
			required: false,
			type: "scalar",
			format: "percent"
		},
		salesFeeOnMarket_lt25m: {
			versionCompat: ">=5.5.0",
			visibleIn: [],
			required: false,
			type: "scalar",
			format: "percent"
		},
		salesFeeOnMarket_gt25m: {
			versionCompat: ">=5.5.0",
			visibleIn: [],
			required: false,
			type: "scalar",
			format: "percent"
		},
		salesFeeOnMarket_gt75m: {
			versionCompat: ">=5.5.0",
			visibleIn: [],
			required: false,
			type: "scalar",
			format: "percent"
		},
		salesFeeOffMarket_lt25m: {
			versionCompat: ">=5.5.0",
			visibleIn: [],
			required: false,
			type: "scalar",
			format: "percent"
		},
		salesFeeOffMarket_gt25m: {
			versionCompat: ">=5.5.0",
			visibleIn: [],
			required: false,
			type: "scalar",
			format: "percent"
		},
		salesFeeOffMarket_gt75m: {
			versionCompat: ">=5.5.0",
			visibleIn: [],
			required: false,
			type: "scalar",
			format: "percent"
		},
		condoPropertyManagementFeeFlatMonth: {
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "currency"
		},
		condoPropertyManagementFeeCommercialUnitSqmMonth: {
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "currency"
		},
		condoAssetManagementFeeOfGav: {
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		condoAssetManagementFeeAlternativeMinOf: {
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "currency"
		},
		IRRHurdle1: {
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		promote1: {
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		IRRHurdle2: {
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		promote2: {
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		IRRHurdle3: {
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		promote3: {
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		CITRate: {
			versionCompat: "<5.5.0",
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		standardRentLossInOfNRI: {
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		developmentRentLossInPercentageNRI: {
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		interestAvailableForUse: {
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "currency"
		},
		interestThresholdEBITDAWithFloorRule: {
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		VATRate: {
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		annualAssetDepreciation: {
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		taxableIncomeUtilizationOfLossPool: {
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		subsidisedNonSubsidizedDebtRunningAM: {
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		subsidisedNonSubsidizedDebtAMStartMonth: {
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "number",
			integer: true
		},
		seniorDebtLTV: {
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		capexNonSubsidizedDebtLTV: {
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		seniorDebtInterestRate: {
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		capexNonSubsidizedDebtInterestRate: {
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		seniorCapexNonSubsidizedDebtInterestRate: {
			versionCompat: "<5.1.1",
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		seniorCapexNonSubsidizedDebtUpfrontFee: {
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		seniorCapexNonSubsidizedDebtCommitmentFee: {
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		seniorCapexNonSubsidizedDebtRunninAM: {
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		seniorCapexNonSubsidizedDebtAmStartMonth: {
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "number",
			integer: true
		},
		assumedNRILeakageForBanks: {
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		targetDebtYield: {
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		},
		shareholderPPLLoanPercentOfEquity: {
			versionCompat: ">=4",
			visibleIn: ["IC", "CONFIG"],
			required: false,
			type: "scalar",
			format: "percent"
		},
		shareholderPPLLoanInterest: {
			versionCompat: ">=4",
			visibleIn: ["IC", "CONFIG"],
			required: false,
			type: "scalar",
			format: "percent"
		},
		shareholderReimbursementMonth: {
			versionCompat: ">=4",
			visibleIn: ["IC", "CONFIG"],
			required: true,
			requiredVersionCompat: ">=5.5.0",
			type: "scalar",
			format: "number",
			integer: true
		},
		thirtyLuxCos: {
			versionCompat: ">=4",
			visibleIn: ["IC", "CONFIG"],
			required: false,
			requiredForAssetPartners: ["peakside"],
			type: "scalar",
			format: "boolean"
		},
		transferToLuxMonth: {
			versionCompat: ">=4",
			visibleIn: ["IC", "CONFIG"],
			required: false,
			requiredForAssetPartners: ["peakside"],
			type: "scalar",
			format: "number",
			integer: true
		},
		deductibleAmountPerLuxCompany: {
			versionCompat: ">=4",
			visibleIn: ["IC", "CONFIG"],
			required: false,
			requiredForAssetPartners: ["peakside"],
			type: "scalar",
			format: "currency"
		},
		numberOfLuxCos: {
			versionCompat: ">=4",
			visibleIn: ["IC", "CONFIG"],
			required: false,
			requiredForAssetPartners: ["peakside"],
			type: "scalar",
			format: "number",
			integer: true
		},
		deductiblePercentOfTLCFGained: {
			versionCompat: ">=4",
			visibleIn: ["IC", "CONFIG"],
			required: false,
			type: "scalar",
			format: "percent"
		},
		promoteType: {
			versionCompat: ">=5.4.0",
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "enum",
			source: MFHD2GPromoteType
		},
		reneoFinancingFee: {
			versionCompat: ">=5.4.0",
			visibleIn: ["IC", "CONFIG"],
			required: true,
			type: "scalar",
			format: "percent"
		}
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/calculations/d2g/d2g-calcengine.model.ts
var CompressedTripleKind, compressedTripleKinds, isCompressedTriple;
var init_d2g_calcengine_model = __esmMin((() => {
	CompressedTripleKind = /* @__PURE__ */ function(CompressedTripleKind) {
		CompressedTripleKind[CompressedTripleKind["Scalar"] = 1] = "Scalar";
		CompressedTripleKind[CompressedTripleKind["Vector"] = 2] = "Vector";
		CompressedTripleKind[CompressedTripleKind["Matrix"] = 3] = "Matrix";
		CompressedTripleKind[CompressedTripleKind["Error"] = 4] = "Error";
		return CompressedTripleKind;
	}({});
	compressedTripleKinds = /* @__PURE__ */ new Set([
		1,
		2,
		3,
		4
	]);
	isCompressedTriple = (val) => {
		if (!Array.isArray(val) || val.length !== 3) return false;
		const kind = val[0];
		return typeof kind === "number" && compressedTripleKinds.has(kind);
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/calculations/d2g/parser-helpers.ts
function asCalcEngineString(value) {
	if (typeof value === "string") {
		const trimmed = value.trim();
		return trimmed === "" ? void 0 : trimmed;
	}
	if (typeof value === "number" && Number.isFinite(value)) return String(value);
}
var detectValueType, safeParseNumLike, parseNumLike, maybeInferErrorFromValue, transformValueObjectToCompressedTriples, transformParsedSpreadsheetObjectToCompressedTriples, CALC_KEY_PREFIX_TO_SHEET, extractCalcEngineNumber, extractCalcEngineString, asFiniteNumber, extractCalcEngineVector, extractCalcEngineRawVector;
var init_parser_helpers = __esmMin((() => {
	init_mfh_investment_case_base();
	init_d2g_calcengine_model();
	init_d2g_errors();
	detectValueType = (value) => {
		if (Array.isArray(value)) {
			if (Array.isArray(value[0])) return "matrix";
			return "vector";
		}
		return "scalar";
	};
	safeParseNumLike = (value) => {
		if (value === void 0 || value === null) return value ?? null;
		if (typeof value === "number" || typeof value === "string" && Number.isNaN(Number(value))) return value;
		const conv = Number.parseFloat(value);
		return Number.isNaN(conv) ? value : conv;
	};
	parseNumLike = (value) => {
		if (isNil(value)) return value ?? void 0;
		if (typeof value === "number") return value;
		if (typeof value === "string" && Number.isNaN(Number(value))) return;
		const conv = Number.parseFloat(value);
		return Number.isNaN(conv) ? void 0 : conv;
	};
	maybeInferErrorFromValue = (value, fieldName, options) => {
		if (typeof value === "string" && value in SHEET_ERROR_MAPPINGS) {
			const errorKind = SHEET_ERROR_MAPPINGS[value];
			return new D2GCalculationNodeError(`Calculation node value error${fieldName ? ` at ${fieldName}` : ""}: ${value}`, fieldName ?? "unknown", errorKind, options);
		}
	};
	transformValueObjectToCompressedTriples = (rawData) => {
		return Object.entries(rawData).reduce((result, [key, value]) => {
			const type = detectValueType(value);
			if (type === "matrix") result[key] = [
				3,
				void 0,
				value
			];
			else if (type === "vector") result[key] = [
				2,
				void 0,
				value
			];
			else result[key] = [
				1,
				void 0,
				value
			];
			return result;
		}, {});
	};
	transformParsedSpreadsheetObjectToCompressedTriples = (rawData, options) => {
		return Object.entries(rawData).reduce((result, [key, value]) => {
			const type = detectValueType(value);
			if (type === "matrix") {
				const matrixErrors = [];
				const matrixValues = [];
				let hasError = false;
				for (let row = 0; row < value.length; row++) {
					const rowValues = [];
					for (let col = 0; col < (value[row]?.length || 0); col++) {
						const cellValue = value[row]?.[col];
						if (maybeInferErrorFromValue(cellValue, `${key}[${row}][${col}]`, options)) {
							matrixErrors.push({
								row,
								col
							});
							hasError = true;
						}
						rowValues.push(cellValue);
					}
					matrixValues.push(rowValues);
				}
				if (hasError) result[key] = [
					4,
					new SpreadsheetMatrixError(`Matrix calculation error at ${key}`, key, "unknown", matrixErrors, options),
					void 0
				];
				else result[key] = [
					3,
					void 0,
					matrixValues
				];
			} else if (type === "vector") {
				const vectorErrors = [];
				const vectorValues = [];
				let hasError = false;
				for (let index = 0; index < value.length; index++) {
					const element = value[index];
					if (maybeInferErrorFromValue(element, `${key}[${index}]`, options)) {
						vectorErrors.push(index);
						hasError = true;
					}
					vectorValues.push(element);
				}
				if (hasError) result[key] = [
					4,
					new SpreadsheetVectorError(`Vector calculation error at ${key}`, key, "unknown", vectorErrors, options),
					void 0
				];
				else result[key] = [
					2,
					void 0,
					vectorValues
				];
			} else {
				const error = maybeInferErrorFromValue(value, key, options);
				if (error) result[key] = [
					4,
					error,
					void 0
				];
				else result[key] = [
					1,
					void 0,
					value
				];
			}
			return result;
		}, {});
	};
	CALC_KEY_PREFIX_TO_SHEET = {
		a_cal_cf_engine: "sheetsCfEngine",
		b_out_ic_charts: "sheetsICCharts",
		b_cal_gri: "sheetsGri",
		a_out_invest_memo: "sheetsInvestMemo",
		h_cal_subsidies: "sheetsSubsidies",
		f_cal_input_rent_roll: "sheetsInputRentRoll"
	};
	extractCalcEngineNumber = (result, options) => {
		if (!result || !isCompressedTriple(result)) return;
		const [, error] = result;
		if (error) return;
		const arrayIndex = options?.arrayIndex ?? 0;
		switch (result[0]) {
			case 1: {
				const value = result[2];
				return typeof value === "number" ? value : void 0;
			}
			case 2: {
				const value = result[2]?.[arrayIndex];
				return typeof value === "number" ? value : void 0;
			}
			case 3: {
				const value = result[2]?.flat()[arrayIndex];
				return typeof value === "number" ? value : void 0;
			}
			case 4: return;
			default: return result;
		}
	};
	extractCalcEngineString = (result, options) => {
		if (!result || !isCompressedTriple(result)) return;
		const [, error] = result;
		if (error) return;
		const arrayIndex = options?.arrayIndex ?? 0;
		switch (result[0]) {
			case 1: return asCalcEngineString(result[2]);
			case 2: return asCalcEngineString(result[2]?.[arrayIndex]);
			case 3: return asCalcEngineString(result[2]?.flat()[arrayIndex]);
			case 4: return;
			default: return result;
		}
	};
	asFiniteNumber = (value) => {
		if (typeof value === "number") return Number.isFinite(value) ? value : void 0;
		if (typeof value === "string" && value.trim() !== "") {
			const parsed = Number(value);
			return Number.isFinite(parsed) ? parsed : void 0;
		}
		if (isCompressedTriple(value)) return extractCalcEngineNumber(value);
	};
	extractCalcEngineVector = (result) => {
		if (!result || !isCompressedTriple(result)) return;
		const [, error] = result;
		if (error) return;
		if (result[0] !== 2 || result[2] == null) return;
		return result[2].map((value) => typeof value === "number" ? value : null);
	};
	extractCalcEngineRawVector = (result) => {
		if (!result || !isCompressedTriple(result)) return;
		const [, error] = result;
		if (error) return;
		if (result[0] !== 2 || result[2] == null) return;
		return result[2];
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/calculations/d2g/input-formatters.ts
var locationCityFormatter, locationStateFormatter, locationRegionFormatter;
var init_input_formatters = __esmMin((() => {
	init_location_model();
	locationCityFormatter = (cityName) => {
		if (!cityName) return cityName;
		return cityName === "Munich" ? "München" : cityName;
	};
	locationStateFormatter = (value) => {
		if (!value) return value;
		return STATE_CODE_MAPPINGS[value] ?? value;
	};
	locationRegionFormatter = (value) => {
		if (!value) return value;
		return {
			Berlin: "Berlin",
			Hamburg: "Hamburg",
			Frankfurt: "Frankfurt",
			Leipzig: "Leipzig",
			Dresden: "Dresden"
		}[value] ?? "Other";
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/calculations/d2g/versions/5.0.0/calculations.helpers.ts
var calcEngineInputsV5_0_0;
var init_calculations_helpers$9 = __esmMin((() => {
	init_input_formatters();
	calcEngineInputsV5_0_0 = {
		a_crm_input__share_of_ee_capex_attributable_for_subsidies: { key: "assumptions.shareOfEeCapexAttributableForSubsidies" },
		a_crm_input__kfw_ee_repayment_subsidy_in_percent_per_ru: { key: "assumptions.kfwEERepaymentSubsidyPercentPerUnit" },
		a_crm_input__vat_damage_modernisation_scapex: { key: "assumptions.vatDamageModernizationcapex" },
		a_crm_input__kfw_70_repayment_subsidy_in_percent_per_ru: { key: "assumptions.kfw_70RepaymentSubsidyPercentPerUnit" },
		a_crm_input__kfw_55_max_amount_per_ru: { key: "assumptions.kfw_55MaxAmountPerUnit" },
		a_crm_input__dus_efficiency_house_standard_maximum_subsidy_per_ru: { key: "assumptions.dusEfficiencyHouseStandardSubsidyMaxPerUnit" },
		a_out_invest_memo__header_bafa: { key: "d2gSettings.bafa" },
		h_cal_subsidies__external_inputs_current_district_heating: {
			key: "buildingTechnical.districtHeatingAsPrimaryEnergySource",
			formatter: booleanYesNoFormatter
		},
		a_crm_input__brick_facades_sqm: { key: "buildingTechnical.brickFacadeSqm" },
		a_crm_input__kfw_wpb_non_ee_max_amount_per_ru: { key: "assumptions.kfwWpbNonEEMaxAmountPerUnit" },
		a_crm_input__ifb_brick_facades: { key: "assumptions.ifbBrickFacade" },
		a_crm_input__state: {
			key: "location.state",
			formatter: locationStateFormatter
		},
		a_crm_input__base_j: { key: "bestWorst.epcRatingInKWHPostRenovation.base" },
		a_crm_input__facade_insulation: { key: "buildingTechnical.fassadeInsulation" },
		a_crm_input__dus_maximum_funding_per_recipient: { key: "assumptions.dusSubsidyMaxPerRecipient" },
		a_crm_input__ifb_efficiency_house_55_in_existing_buildings_per_kwhper_year: { key: "assumptions.ifbEfficiencyHouse_55StockPerKwhA" },
		a_crm_input__kfw_wpb_threshold: { key: "assumptions.kfwWpbThreshold" },
		a_crm_input__city: {
			key: "location.city",
			formatter: locationCityFormatter
		},
		a_crm_input__renovation_fee_net_or_gross_of_capex: { key: "investorAssumptions.renovationFeeNetOrGrossOfCapex" },
		a_crm_input__ifb_efficiency_house_70_in_existing_buildings_per_kwhper_year: { key: "assumptions.ifbEfficiencyHouse_70StockPerKwhA" },
		a_crm_input__condo_renovation_service_fee: { key: "investorAssumptions.condoRenovationServiceFee" },
		a_crm_input__vat_damage_partner_fees: { key: "assumptions.vatDamagePartnerFees" },
		a_crm_input__vat_damage_expansion_tis_apartments: { key: "assumptions.vatDamageExpansionApartment" },
		a_crm_input__kfw_loan_non_ee_class: { key: "assumptions.kfwLoanNonEEClass" },
		a_crm_input__brick_facade: {
			key: "buildingTechnical.brickFacade",
			formatter: booleanYesNoFormatter
		},
		a_crm_input__kfw_70_max_amount_per_ru: { key: "assumptions.kfw_70MaxAmountPerUnit" },
		a_crm_input__kfw_85_max_amount_per_ru: { key: "assumptions.kfw_85MaxAmountPerUnit" },
		a_crm_input__kfw_85_ee_max_amount_per_ru: { key: "assumptions.kfw_85EEMaxAmountPerUnit" },
		a_crm_input__kfw_70_ee_max_amount_per_ru: { key: "assumptions.kfw_70EEMaxAmountPerUnit" },
		a_crm_input__ifb_basic_funding_per_ru: { key: "assumptions.ifbBasisfoerderungPerUnit" },
		a_out_invest_memo__header_ifb_standard: { key: "d2gSettings.ifbStandard" },
		a_crm_input__construction_year: { key: "buildingTechnical.constructionYear" },
		a_crm_input__kfw_worst_performing_bonus: { key: "assumptions.kfwWorstPerformingBonus" },
		a_crm_input__vat_rate: { key: "investorAssumptions.VATRate" },
		a_crm_input__kfw_85_repayment_subsidy_in_percent_per_ru: { key: "assumptions.kfw_85RepaymentSubsidyPercentPerUnit" },
		a_crm_input__kfw_55_repayment_subsidy_in_percent_per_ru: { key: "assumptions.kfw_55RepaymentSubsidyPercentPerUnit" },
		a_crm_input__kfw_wpb_ee_max_amount_per_ru: { key: "assumptions.kfwWpbEEMaxAmountPerUnit" },
		a_crm_input__resi_space_sqm: { key: "overview.resiSpaceSqm" },
		a_crm_input__ifb_efficiency_house_85_in_existing_buildings_per_kwhper_year: { key: "assumptions.ifbEfficiencyHouse_85StockPerKwhA" },
		a_crm_input__bafa_single_measure_grant: { key: "assumptions.bafaSingleMeasureGrant" },
		a_crm_input__share_of_extension_capex_attributable_for_subsidies: { key: "assumptions.shareOfExtensionCapexAttributableForSubsidies" },
		a_crm_input__dus_ee_nh_class_funding_max_per_ru: { key: "assumptions.dusEENhClassSubsidyMaxPerUnit" },
		a_crm_input__ifb_energy_consulting: { key: "assumptions.ifbEnergieberatung" },
		a_crm_input__kfw_mfh_construction_supervision_max_per_project: { key: "assumptions.kfwMfhConstructionSupervisionMaxPerProject" },
		a_crm_input__commercial_space_sqm: { key: "overview.commercialSpaceSqm" },
		a_crm_input__dus_funding_rate: { key: "assumptions.dusSubsidyQuote" },
		a_crm_input__base_d: { key: "bestWorst.renovationCostEnergyEfficiencySqm.base" },
		a_crm_input__base_g: { key: "bestWorst.expansionCostSqm.base" },
		a_crm_input__num_of_of_new_we_in_heated_area: { key: "buildingTechnical.numberOfApartmentsInHeatedArea" },
		a_out_invest_memo__header_expansion: { key: "d2gSettings.expansion" },
		a_crm_input__end_energy_consumption_kwh_sqm_a: { key: "buildingTechnical.endEnergyConsumptionKWhSqm" },
		a_crm_input__ltv_subsidized_loan_kfw: { key: "assumptions.ltvSubsidizedLoanKfWPercent" },
		a_crm_input__expansion_potential_sqm: { key: "overview.expansionPotentialSqm" },
		a_crm_input__kfw_55_ee_max_amount_per_ru: { key: "assumptions.kfw_55EEMaxAmountPerUnit" },
		a_out_invest_memo__header_kfw_standard: { key: "d2gSettings.kfwStandard" },
		a_crm_input__ifb_quality_assurance_energy: { key: "assumptions.ifbQualityAssuranceEnergy" },
		a_crm_input__num_of_resi_units: { key: "overview.resiUnits" },
		a_crm_input__kfw_loan_ee_class: { key: "assumptions.kfwLoanEEClass" }
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/calculations/d2g/versions/5.0.0/index.ts
var init__5_0_0 = __esmMin((() => {
	init_calculations_helpers$9();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/calculations/d2g/versions/5.1.1/calculations.helpers.ts
var calcEngineInputsV5_1_1;
var init_calculations_helpers$8 = __esmMin((() => {
	init_calculations_helpers$9();
	calcEngineInputsV5_1_1 = {
		...omit(calcEngineInputsV5_0_0, "a_out_invest_memo__header_bafa"),
		a_crm_input__i_sfp_planning: { key: "assumptions.isfpPlanning" },
		a_crm_input__bafa_eligible_expenditure_cap_per_ru_with_i_sfp: { key: "assumptions.bafaEligibleExpenditureCapPerResidentialUnitWithIsfp" },
		a_crm_input__bafa_eligible_expenditure_cap_per_ru_without_i_sfp: { key: "assumptions.bafaEligibleExpenditureCapPerResidentialUnitWithoutIsfp" },
		a_crm_input__number_of_ru_for_individual_measure: { key: "assumptions.numberOfResidentialUnitsForIndividualMeasure" },
		a_crm_input__bafa_i_sfp_bonus: { key: "assumptions.bafaIsfpBonus" },
		a_crm_input__kfw_individual_measure_heat_generation: { key: "assumptions.kfWIndividualMeasureHeatGeneration" },
		a_crm_input__bafa_specialist_planning_and_construction_support_cap: { key: "assumptions.bafaSpecialistPlanningAndConstructionSupportCap" },
		a_crm_input__bafa_specialist_planning_and_construction_supervision_per_ru: { key: "assumptions.bafaSpecialistPlanningAndConstructionSupervisionPerResidentialUnit" },
		a_crm_input__bafa_specialist_planning_and_construction_support: { key: "assumptions.bafaSpecialistPlanningAndConstructionSupport" },
		a_crm_input__fkg_bafa_total_funding_cap: { key: "assumptions.fkgBafaTotalFundingCap" },
		a_crm_input__heating_replacement: { key: "assumptions.heatingReplacement" },
		a_crm_input__kfw_459_first_ru: { key: "assumptions.kfw459FirstResidentialUnit" },
		a_crm_input__kfw_459_2_6_ru: { key: "assumptions.kfw459SecondToSixthResidentialUnits" },
		a_crm_input__kfw_459_7_ru: { key: "assumptions.kfw459SeventhPlusResidentialUnits" },
		a_crm_input__heating_replacement_costs_per_sqm: { key: "assumptions.heatingReplacementCostsPerSqm" },
		a_crm_input__fkg_heating_replacement_subsidy: { key: "assumptions.fkgHeatingReplacementSubsidy" },
		a_crm_input__fkg_individual_measure_grant: { key: "assumptions.fkgIndividualMeasureGrant" },
		a_out_invest_memo__header_beg_em_subsidies: { key: "d2gSettings.begEmSubsidies" },
		a_crm_input__fkg_b_1_cap_energy_standard: { key: "assumptions.fkgB1CapEnergyStandard" },
		a_crm_input__fkg_b_1_cap_without_energy_standard: { key: "assumptions.fkgB1CapWithoutEnergyStandard" },
		a_crm_input__fkg_b_1_per_ru_with_energy_standard: { key: "assumptions.fkgB1PerResidentialUnitWithEnergyStandard" },
		a_crm_input__fkg_b_1_per_ru_without_energy_standard: { key: "assumptions.fkgB1PerResidentialUnitWithoutEnergyStandard" },
		a_crm_input__epc_rating_going_in: { key: "buildingTechnical.endEnergyConsumptionClass" }
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/calculations/d2g/versions/5.1.1/index.ts
var init__5_1_1 = __esmMin((() => {
	init_calculations_helpers$8();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/calculations/d2g/versions/5.1.2/calculations.helpers.ts
var calcEngineInputsV5_1_2;
var init_calculations_helpers$7 = __esmMin((() => {
	init_calculations_helpers$8();
	calcEngineInputsV5_1_2 = calcEngineInputsV5_1_1;
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/calculations/d2g/versions/5.1.2/index.ts
var init__5_1_2 = __esmMin((() => {
	init_calculations_helpers$7();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/calculations/d2g/versions/5.1.3/calculations.helpers.ts
var calcEngineInputsV5_1_3;
var init_calculations_helpers$6 = __esmMin((() => {
	init__5_1_2();
	calcEngineInputsV5_1_3 = calcEngineInputsV5_1_2;
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/calculations/d2g/versions/5.1.3/index.ts
var init__5_1_3 = __esmMin((() => {
	init_calculations_helpers$6();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/calculations/d2g/versions/5.3.1/calculations.helpers.ts
var calcEngineInputsV5_3_1;
var init_calculations_helpers$5 = __esmMin((() => {
	init__5_1_3();
	calcEngineInputsV5_3_1 = {
		...omit(calcEngineInputsV5_1_3, "a_crm_input__base_j", "a_crm_input__ifb_efficiency_house_85_in_existing_buildings_per_kwhper_year", "a_crm_input__ifb_efficiency_house_70_in_existing_buildings_per_kwhper_year", "a_crm_input__ifb_efficiency_house_55_in_existing_buildings_per_kwhper_year", "a_crm_input__ifb_energy_consulting", "a_crm_input__ifb_basic_funding_per_ru", "a_crm_input__ifb_quality_assurance_energy", "a_crm_input__heating_replacement"),
		a_crm_input__ifb_joint_repair_high_cost: { key: "assumptions.ifbJointRepairHighCost" },
		a_crm_input__monument_protection: {
			key: "d2gSettings.monumentProtection",
			formatter: booleanYesNoFormatter
		},
		a_crm_input__ifb_90_kwh: { key: "assumptions.ifbLt90kwh" },
		a_crm_input__ifb_75_kwh: { key: "assumptions.ifbLt75kwh" },
		a_crm_input__ifb_70_eh: { key: "assumptions.ifb70EH" },
		a_crm_input__ifb_55_eh: { key: "assumptions.ifb55EH" },
		a_crm_input__ifb_40_eh: { key: "assumptions.ifb40EH" }
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/calculations/d2g/versions/5.3.1/index.ts
var init__5_3_1 = __esmMin((() => {
	init_calculations_helpers$5();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/calculations/d2g/versions/5.3.2/calculations.helpers.ts
var calcEngineInputsV5_3_2, spreadsheetRentRollAdditionalInputsV5_3_2, spreadsheetInputsV5_3_2;
var init_calculations_helpers$4 = __esmMin((() => {
	init__5_3_1();
	init_due_diligence();
	init_rent_roll_dd_base();
	calcEngineInputsV5_3_2 = {
		...calcEngineInputsV5_3_1,
		a_crm_input__annual_index_update_month_end_of: { key: "assumptions.annualIndexUpdateMonthEndOf" },
		a_crm_input__mod_umlage_delay_post_ee_capex: { key: "assumptions.modUmlageDelayPostEeCapex" },
		a_crm_input__vpi_going_in: { key: "assumptions.vpiGoingIn" },
		a_crm_input__rent_class_1_upper_limit: { key: "assumptions.rentClass1UpperLimit" },
		a_crm_input__rent_class_2_upper_limit: { key: "assumptions.rentClass2UpperLimit" },
		a_crm_input__rent_class_3_upper_limit: { key: "assumptions.rentClass3UpperLimit" },
		b_crm_console__rent_increase_dependent_on_data_quality: { key: "d2gSettings.rentIncreaseDependentOnDataQuality" },
		a_crm_input__annual_rent_growth_non_whg_renovation: { key: "assumptions.annualRentGrowthNonWhgRenovation" },
		a_crm_input__bgb_rent_increase_to_mid_of_low_and_medium: { key: "assumptions.bgbRentIncreaseToMidOfLowAndMedium" },
		a_crm_input__rent_increase_energy_efficiency_only: { key: "assumptions.rentIncreaseEnergyEfficiencyOnly" },
		a_crm_input__rent_increase_ee_only_when_before_7: { key: "assumptions.rentIncreaseEEOnlyBefore_7" },
		b_crm_console__rent_increase_annual_only: { key: "d2gSettings.rentIncreaseAnnualOnly" },
		a_crm_input__applied_ee_top_up_for_index: { key: "assumptions.appliedEETopUpForIndex" },
		a_crm_input__applied_rent_residential: { key: "rent.appliedRentResidential" },
		a_crm_input__bank_interest_rate: { key: "assumptions.bankInterestRate" },
		a_crm_input__duration_in_months: { key: "assumptions.durationInMonths" },
		a_crm_input__energy_efficiency_end: { key: "assumptions.energyEfficiencyEnd" },
		a_crm_input__entry_date: {
			key: "assumptions.entryDate",
			formatter: (value) => formatDate(value, DateFormats.ISO8601)
		},
		a_crm_input__first_bgb_rent_increase_size: { key: "assumptions.firstBgbRentIncreaseSize" },
		a_crm_input__first_bgb_rent_increase_timing: { key: "assumptions.firstBgbRentIncreaseTiming" },
		a_crm_input__inflation: { key: "assumptions.inflationRate" },
		a_crm_input__modernization_catch_up_after_tiered_increase: { key: "assumptions.modCatchUpAfterStaffel" },
		a_crm_input__second_bgb_rent_increase_size: { key: "assumptions.secondBgbRentIncreaseSize" },
		a_crm_input__second_bgb_rent_increase_timing: { key: "assumptions.secondBgbRentIncreaseTiming" },
		a_crm_input__share_of_extension_capex_attributable_for_mod_umlage: { key: "assumptions.shareOfExtensionCapexAttributableForModLevy" },
		a_crm_input__share_of_maintenance_in_renovation_capex_for_rent_calc: { key: "assumptions.shareMaintenanceRenovationCapex" },
		a_crm_input__subsidized_interest_rate_bullet_loan: { key: "assumptions.subsidisedInterestRateBulletLoan" },
		a_crm_input__target_rent_adj_cat_1: { key: "rent.adjustedTargetRentLt50Sqm" },
		a_crm_input__target_rent_adj_cat_2: { key: "rent.adjustedTargetRent50To75Sqm" },
		a_crm_input__target_rent_adj_cat_3: { key: "rent.adjustedTargetRent75To100Sqm" },
		a_crm_input__target_rent_adj_cat_4: { key: "rent.adjustedTargetRentGt100Sqm" },
		b_crm_console__rent_roll: { key: "d2gSettings.rentRoll" },
		a_crm_input__third_bgb_rent_increase_size: { key: "assumptions.thirdBgbRentIncreaseSize" },
		a_crm_input__third_bgb_rent_increase_timing: { key: "assumptions.thirdBgbRentIncreaseTiming" },
		f_cal_input_rent_roll__rent_roll_main_inputs_nr: { key: "rentRoll.apartmentNumber" },
		f_cal_input_rent_roll__rent_roll_main_inputs_status: {
			key: "rentRoll.rentingState",
			formatter: mapArrayWithLookup(rentRollStatusLabels)
		},
		f_cal_input_rent_roll__rent_roll_main_inputs_house_address: { key: "rentRoll.houseAddress" },
		f_cal_input_rent_roll__rent_roll_main_inputs_lage_im_haus: { key: "rentRoll.locationInBuilding" },
		f_cal_input_rent_roll__rent_roll_main_inputs_nutzung: {
			key: "rentRoll.apartmentType",
			formatter: mapArrayWithLookup(apartmentTypeToRentRoll)
		},
		f_cal_input_rent_roll__rent_roll_main_inputs_year_of_birth_of_tenant: { key: "rentRoll.tenantBirthYear" },
		f_cal_input_rent_roll__rent_roll_main_inputs_flache: { key: "rentRoll.livingSpace" },
		f_cal_input_rent_roll__rent_roll_main_inputs_wf_invoice_team_condo: { key: "rentRoll.measuredLivingSpace" },
		f_cal_input_rent_roll__rent_roll_main_inputs_additional_costs_rent_per_month: { key: "rentRoll.coldRent" },
		f_cal_input_rent_roll__rent_roll_main_inputs_mw_st: { key: "rentRoll.vat" },
		f_cal_input_rent_roll__rent_roll_main_inputs_operating_costs_per_month: { key: "rentRoll.utilityCost" },
		f_cal_input_rent_roll__rent_roll_main_inputs_heating_costs_per_month: { key: "rentRoll.heatingCost" },
		f_cal_input_rent_roll__rent_roll_main_inputs_start_of_tenancy: {
			key: "rentRoll.rentalContractStartDate",
			formatter: (values) => formatDateArray(values, DateFormats.ISO8601)
		},
		f_cal_input_rent_roll__rent_roll_main_inputs_tenant_end_if_unrented_entry_date: {
			key: "rentRoll.rentalContractEndDate",
			formatter: (values) => formatDateArray(values, DateFormats.ISO8601)
		},
		f_cal_input_rent_roll__rent_roll_main_inputs_last_rent_increase: {
			key: "rentRoll.lastRentIncreaseDate",
			formatter: (values) => formatDateArray(values, DateFormats.ISO8601)
		},
		f_cal_input_rent_roll__rent_roll_main_inputs_vpi_last_increase_commercial_only_override: { key: "rentRoll.vpiLastIncrease" },
		f_cal_input_rent_roll__rent_roll_main_inputs_net_rent_before_rent_increase: { key: "rentRoll.rentBeforeIncrease" },
		f_cal_input_rent_roll__rent_roll_main_inputs_resi_rent_according_to_churn_eur_sqm_override: { key: "rentRoll.coldRentChurnPerSQM" },
		f_cal_input_rent_roll__rent_roll_main_inputs_commercial_rent_rent_according_to_churn_eur_sqm_override: { key: "rentRoll.commercialRentAfterChurnPerSqm" },
		f_cal_input_rent_roll__rent_roll_main_inputs_index_or_tiered: {
			key: "rentRoll.rentIncreaseType",
			formatter: mapArrayWithLookup(rentIncreaseTypeToRentRoll)
		},
		f_cal_input_rent_roll__rent_roll_main_inputs_end_of_tiered_period: {
			key: "rentRoll.rentIncreaseEndDate",
			formatter: (values) => formatDateArray(values, DateFormats.ISO8601)
		},
		f_cal_input_rent_roll__rent_roll_main_inputs_tiered_amount_in_eur_per_year: { key: "rentRoll.friIncreaseAmount" },
		f_cal_input_rent_roll__rent_roll_main_inputs_vat_damage_business_override: { key: "rentRoll.commercialVATDamage" },
		f_cal_input_rent_roll__rent_roll_main_inputs_commercial_index_level_override: { key: "rentRoll.commercialRentIndexIncrease" },
		f_cal_input_rent_roll__rent_roll_main_inputs_relet_delay_commercial_in_months_override: { key: "rentRoll.reletDelayInMonths" },
		f_cal_input_rent_roll__rent_roll_main_inputs_annual_index_update_month_end_of_override: { key: "rentRoll.annualIndexUpdateMonthEndOf" },
		f_cal_input_rent_roll__rent_roll_main_inputs_indexation_hurdle_override: { key: "rentRoll.indexationHurdle" },
		f_cal_input_rent_roll__rent_roll_main_inputs_min_interval_for_index_increase_in_months_override: { key: "rentRoll.minIntervalForIndexIncreaseInMonths" },
		f_cal_input_rent_roll__rent_roll_main_inputs_not_available_for_rent_ab: {
			key: "rentRoll.notRentableFrom",
			formatter: (values) => formatDateArray(values, DateFormats.ISO8601)
		},
		f_cal_input_rent_roll__rent_roll_main_inputs_renovation_costs_for_condo_per_sqm_override: { key: "rentRoll.condoRefurbishmentCostsPerSQM" },
		f_cal_input_rent_roll__rent_roll_rent_index_from: { key: "rentIndex.areaMin" },
		f_cal_input_rent_roll__rent_roll_rent_index_lower_span: { key: "rentIndex.minPrice" },
		f_cal_input_rent_roll__rent_roll_rent_index_mean: { key: "rentIndex.midPrice" },
		f_cal_input_rent_roll__rent_roll_rent_index_rent_index_tier: { key: "rentIndex.rentIndexTier" },
		f_cal_input_rent_roll__rent_roll_rent_index_upper_span: { key: "rentIndex.maxPrice" },
		a_crm_input__indexation_hurdle: { key: "assumptions.indexationHurdle" },
		a_crm_input__min_interval_for_index_increase_in_months: { key: "assumptions.minIntervalIndexIncrease" },
		a_crm_input__vat_damage_commercial_tis: { key: "assumptions.vatDamageCommercialTIS" },
		a_crm_input__percentage_limit_indexation_business: { key: "assumptions.commercialIndexationThreshold" },
		a_crm_input__base_e: { key: "bestWorst.renovationCostInteriorCommercialSqm.base" },
		a_crm_input__base_f: { key: "bestWorst.renovationCostInteriorSqm.base" },
		a_crm_input__applied_commercial: { key: "rent.appliedRentCommercial" }
	};
	spreadsheetRentRollAdditionalInputsV5_3_2 = {
		f_cal_input_rent_roll__rent_roll_main_inputs_mieter: { key: "rentRoll.tenantName" },
		f_cal_input_rent_roll__rent_roll_main_inputs_number_of_rooms: { key: "rentRoll.rooms" },
		f_cal_input_rent_roll__rent_roll_main_inputs_kaution: { key: "rentRoll.securityDeposit" },
		f_cal_input_rent_roll__rent_roll_main_inputs_parking_space_rental_per_month: { key: "rentRoll.parkingSpaceRent" },
		f_cal_input_rent_roll__rent_roll_main_inputs_parking_space_no_garage: { key: "rentRoll.parkingSpaceRegisterNumber" },
		f_cal_input_rent_roll__rent_roll_main_inputs_option: { key: "rentRoll.rentalContractOption" },
		f_cal_input_rent_roll__rent_roll_main_inputs_signed_consent: {
			key: "rentRoll.isRentIncreaseSigned",
			formatter: mapArrayToYesNo
		},
		f_cal_input_rent_roll__rent_roll_main_inputs_is_the_storage_room_in_the_attic_rented_out: {
			key: "rentRoll.isStorageRoomInAtticIsRented",
			formatter: mapArrayToYesNo
		},
		f_cal_input_rent_roll__rent_roll_main_inputs_features: { key: "rentRoll.equipmentFeatures" },
		f_cal_input_rent_roll__rent_roll_main_inputs_lease_agreement_signed: {
			key: "rentRoll.isRentalContractSigned",
			formatter: mapArrayToYesNo
		},
		f_cal_input_rent_roll__rent_roll_main_inputs_is_the_parking_space_included_in_the_rental: {
			key: "rentRoll.hasParkingSpace",
			formatter: mapArrayToYesNo
		},
		f_cal_input_rent_roll__rent_roll_main_inputs_other_agreement: { key: "rentRoll.otherAgreements" },
		f_cal_input_rent_roll__rent_roll_main_inputs_lease_agreement_checked: { key: "rentRoll.isRentalContractChecked" },
		f_cal_input_rent_roll__rent_roll_main_inputs_kommentar: { key: "rentRoll.note" },
		f_cal_input_rent_roll__rent_roll_main_inputs_regulation_on_the_increase_of_lease_agreement_commercial: { key: "rentRoll.regulationOfRentIncreaseNote" },
		f_cal_input_rent_roll__rent_roll_main_inputs_renovated_by_the_current_owner: {
			key: "rentRoll.isRefurbishedByCurrentOwner",
			formatter: mapArrayToYesNo
		},
		f_cal_input_rent_roll__rent_roll_main_inputs_category_apartment_condition: {
			key: "rentRoll.apartmentCondition",
			formatter: mapArrayWithLookup(apartmentConditionToRentRoll)
		},
		f_cal_input_rent_roll__rent_roll_main_inputs_condo_sale_condition: {
			key: "rentRoll.condoSalesCondition",
			formatter: mapArrayWithLookup(condoSalesConditionToRentRoll)
		}
	};
	spreadsheetInputsV5_3_2 = {
		...calcEngineInputsV5_3_2,
		...spreadsheetRentRollAdditionalInputsV5_3_2
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/calculations/d2g/versions/5.3.2/index.ts
var init__5_3_2 = __esmMin((() => {
	init_calculations_helpers$4();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/calculations/d2g/versions/5.4.0/calculations.helpers.ts
var EXCLUDED_FROM_V5_4_0$1, calcEngineInputsV5_4_0, spreadsheetInputsV5_4_0;
var init_calculations_helpers$3 = __esmMin((() => {
	init__5_3_2();
	EXCLUDED_FROM_V5_4_0$1 = [
		"f_cal_input_rent_roll__rent_roll_main_inputs_commercial_index_level_override",
		"a_crm_input__base_e",
		"f_cal_input_rent_roll__rent_roll_main_inputs_commercial_rent_rent_according_to_churn_eur_sqm_override"
	];
	calcEngineInputsV5_4_0 = {
		...omit(calcEngineInputsV5_3_2, ...EXCLUDED_FROM_V5_4_0$1),
		a_crm_input__ifb_subsidy_cap: { key: "assumptions.ifbSubsidyCap" },
		a_crm_input__tis_class_1_upper_limit: { key: "assumptions.tIsClass1UpperLimit" },
		a_crm_input__tis_class_2_upper_limit: { key: "assumptions.tIsClass2UpperLimit" },
		a_crm_input__tis_class_3_upper_limit: { key: "assumptions.tIsClass3UpperLimit" },
		a_crm_input__target_tis_adj_cat_1: { key: "assumptions.targetTIsAdjCat1" },
		a_crm_input__target_tis_adj_cat_2: { key: "assumptions.targetTIsAdjCat2" },
		a_crm_input__target_tis_adj_cat_3: { key: "assumptions.targetTIsAdjCat3" },
		a_crm_input__target_tis_adj_cat_4: { key: "assumptions.targetTIsAdjCat4" },
		f_cal_input_rent_roll__rent_roll_main_inputs_resi_rent_according_to_churn_eur_sqm_override: { key: "rentRoll.coldRentChurnPerSQM" },
		f_cal_input_rent_roll__rent_roll_main_inputs_commercial_market_rent_at_entry_eur_sqm_override: { key: "rentRoll.commercialRentAfterChurnPerSqm" },
		f_cal_input_rent_roll__rent_roll_main_inputs_vat_damage_business_override: { key: "rentRoll.commercialVATDamage" },
		f_cal_input_rent_roll__rent_roll_main_inputs_index_of_commercial_activity_pre_relet_override: { key: "rentRoll.indexOfCommercialActivityPreRelet" },
		f_cal_input_rent_roll__rent_roll_main_inputs_index_of_commercial_activity_post_relet_override: { key: "rentRoll.indexOfCommercialActivityPostRelet" },
		f_cal_input_rent_roll__rent_roll_main_inputs_indexation_hurdle_post_relet_override: { key: "rentRoll.indexationHurdlePostRelet" },
		f_cal_input_rent_roll__rent_roll_main_inputs_min_interval_for_index_increase_in_months_post_relet_override: { key: "rentRoll.minIntervalForIndexIncreaseInMonthsPostRelet" }
	};
	spreadsheetInputsV5_4_0 = {
		...calcEngineInputsV5_4_0,
		...spreadsheetRentRollAdditionalInputsV5_3_2,
		f_cal_input_rent_roll__rent_roll_rent_index_to: { key: "rentIndex.areaMax" }
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/calculations/d2g/versions/5.4.0/index.ts
var init__5_4_0 = __esmMin((() => {
	init_calculations_helpers$3();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/calculations/d2g/versions/5.4.1/calculations.helpers.ts
var EXCLUDED_FROM_V5_4_0, calcEngineInputsV5_4_1, spreadsheetInputsV5_4_1;
var init_calculations_helpers$2 = __esmMin((() => {
	init__5_4_0();
	EXCLUDED_FROM_V5_4_0 = ["h_cal_subsidies__external_inputs_current_district_heating"];
	calcEngineInputsV5_4_1 = {
		...omit(calcEngineInputsV5_4_0, ...EXCLUDED_FROM_V5_4_0),
		a_crm_input__brokerage_fee_excluding_vat: { key: "agent.courtageExclVat" },
		a_crm_input__asking_price: { key: "overview.askingPrice" },
		a_crm_input__num_of_parking_spaces: { key: "overview.parkingSpaces" },
		a_crm_input__num_of_parking_spaces_expansion: { key: "overview.parkingSpacesExpansion" },
		a_crm_input__jnkm_total_current: { key: "rent.jnkmTotalCurrent" },
		a_crm_input__jnkm_commercial_ist: { key: "rent.jnkmCommercialCurrent" },
		a_crm_input__jnkm_parking_spaces_current: { key: "rent.jnkmParkingSpacesCurrent" },
		a_crm_input__resi_occupancy_actual: { key: "rent.resiOccupancyActual" },
		a_crm_input__commercial_occupancy_actual: { key: "rent.commercialOccupancyActual" },
		a_crm_input__parking_occupancy_actual: { key: "rent.parkingOccupancyActual" },
		a_crm_input__notary_costs: { key: "assumptions.notaryCosts" },
		a_crm_input__expected_purchase_discount: { key: "assumptions.expectedPurchaseDiscount" },
		a_crm_input__asset_owned: { key: "assumptions.assetOwned" },
		a_crm_input__rent_index_pre_renovation: { key: "assumptions.rentIndexPreRenovation" },
		a_crm_input__rent_index_post_ee_renovation: { key: "assumptions.rentIndexPostEeRenovation" },
		a_crm_input__dd_contingency: { key: "assumptions.ddContingency" },
		a_crm_input__energy_efficiency_start: { key: "assumptions.energyEfficiencyStart" },
		a_crm_input__general_start: { key: "assumptions.generalStart" },
		a_crm_input__general_end: { key: "assumptions.generalEnd" },
		a_crm_input__expansion_start: { key: "assumptions.expansionStart" },
		a_crm_input__expansion_end: { key: "assumptions.expansionEnd" },
		a_crm_input__timing_commercial_car_park_rent_increase_month: { key: "assumptions.timingCommercialCarparkRentIncreaseMonth" },
		a_crm_input__applied_ee_top_up: { key: "assumptions.appliedEETopUp" },
		a_crm_input__annual_churn_commercial: { key: "assumptions.annualChurnCommercial" },
		a_crm_input__annual_churn_car_park: { key: "assumptions.annualChurnCarPark" },
		a_crm_input__letting_fees_residential_external: { key: "assumptions.lettingFeesResidential" },
		a_crm_input__letting_fees_commercial_external: { key: "assumptions.lettingFeesCommercial" },
		a_crm_input__vat_damage_purchase_costs: { key: "assumptions.vatDamagePurchaseCosts" },
		a_crm_input__base_b: { key: "bestWorst.annunalTenantChurn.base" },
		a_crm_input__base_c: { key: "bestWorst.averageExpandedUnitSize.base" },
		a_crm_input__base_h: { key: "bestWorst.percentageOfSqmWithInteriorRenovation.base" },
		a_crm_input__base_i: { key: "bestWorst.generalCapexSqm.base" },
		a_crm_input__base_e: { key: "bestWorst.renovationCostInteriorCommercialSqm.base" },
		a_crm_input__resi_compensated_churn_sqm: { key: "compensationTenantsResi.compensationResiChurnSqm" },
		a_crm_input__resi_compensated_churn_timing_month: { key: "compensationTenantsResi.compensationResiChurnTimingMonths" },
		a_crm_input__base_m: { key: "compensationTenantsResi.compensationTenantsLiving.base" },
		a_crm_input__comm_compensated_churn_sqm: { key: "compensationTenantsCommercial.compensationCommercialChurnSqm" },
		a_crm_input__comm_compensated_churn_timing_month: { key: "compensationTenantsCommercial.compensationCommercialTimingMonths" },
		a_crm_input__base_n: { key: "compensationTenantsCommercial.compensationTenantsCommercial.base" },
		a_crm_input__manual_expanded_space: { key: "rentPredictions.manualExpandedSpace" },
		a_crm_input__condo_purchasing_service_fee: { key: "investorAssumptions.condoPurchasingServiceFee" },
		a_crm_input__condo_disposition_fee: { key: "investorAssumptions.condoPurchasingServiceFeeWithBroker" },
		a_crm_input__condo_property_management_fee_flat_month: { key: "investorAssumptions.condoPropertyManagementFeeFlatMonth" },
		a_crm_input__condo_property_management_fee_commercial_unit_sqm_month: { key: "investorAssumptions.condoPropertyManagementFeeCommercialUnitSqmMonth" },
		a_crm_input__condo_asset_management_fee_of_gav: { key: "investorAssumptions.condoAssetManagementFeeOfGav" },
		a_crm_input__standard_rent_loss_in_percent_of_nri: { key: "investorAssumptions.standardRentLossInOfNRI" },
		a_crm_input__development_rent_loss_in_percent_of_nri: { key: "investorAssumptions.developmentRentLossInPercentageNRI" },
		a_crm_input__subsidized_debt_running_am: { key: "investorAssumptions.subsidisedNonSubsidizedDebtRunningAM" },
		a_crm_input__subsidized_debt_am_start_month: { key: "investorAssumptions.subsidisedNonSubsidizedDebtAMStartMonth" },
		a_crm_input__senior_debt_ltv: { key: "investorAssumptions.seniorDebtLTV" },
		a_crm_input__capex_non_subsidized_debt_ltv: { key: "investorAssumptions.capexNonSubsidizedDebtLTV" },
		a_crm_input__senior_debt_interest_rate: { key: "investorAssumptions.seniorDebtInterestRate" },
		a_crm_input__capex_non_subsidized_debt_interest_rate: { key: "investorAssumptions.capexNonSubsidizedDebtInterestRate" },
		a_crm_input__senior_debt_upfront_fee: { key: "investorAssumptions.seniorCapexNonSubsidizedDebtUpfrontFee" },
		a_crm_input__capex_non_subsidized_debt_commitment_fee: { key: "investorAssumptions.seniorCapexNonSubsidizedDebtCommitmentFee" },
		a_crm_input__senior_debt_running_am: { key: "investorAssumptions.seniorCapexNonSubsidizedDebtRunninAM" },
		a_crm_input__senior_debt_am_start_month: { key: "investorAssumptions.seniorCapexNonSubsidizedDebtAmStartMonth" },
		a_crm_input__capex_non_subsidized_debt_upfront_fee: { key: "assumptions.capexNonSubsidizedDebtUpfrontFee" },
		a_crm_input__capex_non_subsidized_debt_running_am: { key: "assumptions.capexNonSubsidizedDebtRunningAm" },
		a_crm_input__capex_non_subsidized_debt_am_start_month: { key: "assumptions.capexNonSubsidizedDebtAMStartMonth" },
		a_crm_input__assumed_nri_leakage_for_banks: { key: "investorAssumptions.assumedNRILeakageForBanks" },
		a_crm_input__target_debt_yield: { key: "investorAssumptions.targetDebtYield" },
		a_crm_input__rett: { key: "assumptions.rett" },
		a_crm_input__applied_rent_carpark: { key: "rent.appliedRentCarpark" },
		a_crm_input__provision_for_vacancy_loss_sqm: { key: "assumptions.provisionVacancyLossSqm" },
		a_crm_input__annual_rent_growth_whg_renovation: { key: "assumptions.annualRentGrowthWhgRenovation" },
		a_crm_input__re_let_delay_in_months: { key: "assumptions.reletDelayMonths" },
		a_crm_input__start_letting_of_initial_vacancy_month: { key: "assumptions.startLettingInitialVacancyMonth" },
		a_crm_input__end_of_letting_of_initial_vacany_month: { key: "assumptions.endLettingInitialVacancyMonth" },
		a_crm_input__non_recs_maintenance: { key: "assumptions.nonRecsMaintenance" },
		a_crm_input__subsidised_commitment_fee: { key: "assumptions.subsidisedCommitmentFee" },
		a_crm_input__state_subsidies_kfw_payout_month: { key: "assumptions.stateSubsidiesBafaKfwPayoutMonth" },
		a_crm_input__disposal_costs: { key: "assumptions.disposalCosts" },
		a_crm_input__bafa_fkg_payment_after_completion_of_construction: { key: "assumptions.fkgBafaPaymentAfterConstructionCompletion" },
		a_crm_input__capex_subsidized_debt_upfront_fee: { key: "assumptions.capexSubsidizedDebtUpfrontFee" },
		a_crm_input__condo_letting_fees_resi: { key: "assumptions.condoLettingFeesResi" },
		a_crm_input__condo_letting_fees_commercial: { key: "assumptions.condoLettingFeesCommercial" },
		a_crm_input__start_subsidized_commitment_fee: { key: "assumptions.startSubsidizedCommittmentFee" },
		a_crm_input__start_non_subsidized_committment_fee: { key: "assumptions.startNonSubsidizedCommittmentFee" },
		a_crm_input__reneo_financing_fee: { key: "investorAssumptions.reneoFinancingFee" },
		a_crm_input__exit_multiple_running_resi_space: { key: "assumptions.exitMultipleRunningResiSpace" },
		a_crm_input__exit_multiple_re_let_resi_space: { key: "assumptions.exitMultipleReletResiSpace" },
		a_crm_input__exit_multiple_expansion_space: { key: "assumptions.exitMultipleExpansionSpace" },
		a_crm_input__exit_multiple_commercial: { key: "assumptions.exitMultipleCommercial" },
		a_crm_input__exit_multiple_parking: { key: "assumptions.exitMultipleParking" },
		a_crm_input__tis_class_1_upper_limit: { key: "assumptions.tIsClass1UpperLimit" },
		a_crm_input__tis_class_2_upper_limit: { key: "assumptions.tIsClass2UpperLimit" },
		a_crm_input__tis_class_3_upper_limit: { key: "assumptions.tIsClass3UpperLimit" },
		a_crm_input__target_tis_adj_cat_1: { key: "assumptions.targetTIsAdjCat1" },
		a_crm_input__target_tis_adj_cat_2: { key: "assumptions.targetTIsAdjCat2" },
		a_crm_input__target_tis_adj_cat_3: { key: "assumptions.targetTIsAdjCat3" },
		a_crm_input__target_tis_adj_cat_4: { key: "assumptions.targetTIsAdjCat4" },
		a_crm_input__land_registry: { key: "assumptions.landRegistry" },
		b_crm_console__expansion: { key: "d2gSettings.expansion" },
		b_crm_console__rent_roll: { key: "d2gSettings.rentRoll" },
		b_crm_console__kfw_standard: { key: "d2gSettings.kfwStandard" },
		b_crm_console__ifb_standard: { key: "d2gSettings.ifbStandard" },
		b_crm_console__financing: { key: "d2gSettings.financing" },
		b_crm_console__ltv: { key: "d2gSettings.LTV" },
		b_crm_console__ek_draw_first: { key: "d2gSettings.ekDrawFirst" },
		b_crm_console__churn_vs_fixed: { key: "d2gSettings.churnVsFixed" },
		a_crm_input__primary_energy_source: { key: "buildingTechnical.districtHeatingAsPrimaryEnergySource" }
	};
	spreadsheetInputsV5_4_1 = {
		...spreadsheetInputsV5_4_0,
		...calcEngineInputsV5_4_1
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/calculations/d2g/versions/5.4.1/index.ts
var init__5_4_1 = __esmMin((() => {
	init_calculations_helpers$2();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/calculations/d2g/versions/5.5.0/calculations.helpers.ts
var EXCLUDED_FROM_V5_5_0, calcEngineInputsV5_5_0, spreadsheetInputsV5_5_0;
var init_calculations_helpers$1 = __esmMin((() => {
	init__5_4_1();
	EXCLUDED_FROM_V5_5_0 = [
		"a_crm_input__rent_index_pre_renovation",
		"a_crm_input__rent_index_post_ee_renovation",
		"a_crm_input__bgb_rent_increase_to_mid_of_low_and_medium"
	];
	calcEngineInputsV5_5_0 = {
		..._omit(calcEngineInputsV5_4_1, ...EXCLUDED_FROM_V5_5_0),
		a_crm_input__condo_purchasing_service_fee: { key: "investorAssumptions.reneoPurchasingServiceFee" },
		a_crm_input__condo_disposition_fee: { key: "investorAssumptions.reneoSalesFee" },
		a_crm_input__4th_bgb_rent_increase_size: { key: "assumptions.fourthBgbRentIncreaseSize" },
		a_crm_input__4th_bgb_rent_increase_timing: { key: "assumptions.fourthBgbRentIncreaseTiming" },
		a_crm_input__start_expansion_letting: { key: "assumptions.startExpansionLetting" },
		a_crm_input__end_expansion_letting: { key: "assumptions.endExpansionLetting" },
		a_crm_input__rent_index_pre_ee: { key: "rent.rentIndexPreEe" },
		a_crm_input__rent_index_post_ee: { key: "rent.rentIndexPostEe" },
		a_crm_input__re_let_scenario: { key: "d2gSettings.reLetScenario" },
		a_crm_input__strategic_vacancy: { key: "d2gSettings.strategicVacancy" },
		a_crm_input__rent_index_premium: { key: "assumptions.rentIndexPremium" },
		a_crm_input__light_capex_lease_cutoff: {
			key: "assumptions.lightCapexLeaseCutoff",
			formatter: (value) => formatDate(value, DateFormats.ISO8601)
		},
		a_crm_input__month_until_strategic_vacancy: { key: "assumptions.monthUntilStrategicVacancy" },
		a_crm_input__strategic_vacant_space_lease_up_period: { key: "assumptions.strategicVacantSpaceLeaseUpPeriod" },
		a_crm_input__ti_capex_light: { key: "assumptions.tiCapexLight" },
		a_crm_input__cit_rate_27: { key: "assumptions.citRate27" },
		a_crm_input__cit_rate_28: { key: "assumptions.citRate28" },
		a_crm_input__cit_rate_29: { key: "assumptions.citRate29" },
		a_crm_input__cit_rate_30: { key: "assumptions.citRate30" },
		a_crm_input__cit_rate_31: { key: "assumptions.citRate31" },
		a_crm_input__cit_rate_32_o: { key: "assumptions.citRate32ongoing" },
		a_crm_input__tax_engine_type: { key: "d2gSettings.taxEngineType" },
		a_crm_input__tlcf_deductible_percent_above_base_amount: { key: "assumptions.tlcfDeductiblePercentAboveBaseAmount" },
		a_crm_input__trade_tax: { key: "assumptions.tradeTax" },
		a_crm_input__annual_asset_depreciation: { key: "investorAssumptions.annualAssetDepreciation" },
		a_crm_input__irr_hurdle_1: { key: "investorAssumptions.IRRHurdle1" },
		a_crm_input__irr_hurdle_2: { key: "investorAssumptions.IRRHurdle2" },
		a_crm_input__irr_hurdle_3: { key: "investorAssumptions.IRRHurdle3" },
		a_crm_input__promote_1: { key: "investorAssumptions.promote1" },
		a_crm_input__promote_2: { key: "investorAssumptions.promote2" },
		a_crm_input__promote_3: { key: "investorAssumptions.promote3" },
		a_crm_input__promote_type: { key: "investorAssumptions.promoteType" },
		a_crm_input__30_lux_cos: { key: "investorAssumptions.thirtyLuxCos" },
		a_crm_input__sh_ppl_loan_as_percent_of_equity: { key: "investorAssumptions.shareholderPPLLoanPercentOfEquity" },
		a_crm_input__sh_ppl_loan_interest: { key: "investorAssumptions.shareholderPPLLoanInterest" },
		a_crm_input__shl_reimbursement_month: { key: "investorAssumptions.shareholderReimbursementMonth" },
		a_crm_input__transfer_to_lux: { key: "investorAssumptions.transferToLuxMonth" },
		a_crm_input__deductible_amount_per_lux_company: { key: "investorAssumptions.deductibleAmountPerLuxCompany" },
		a_crm_input__num_of_of_lux_cos: { key: "investorAssumptions.numberOfLuxCos" },
		a_crm_input__deductible_percent_of_tlcf_gained: { key: "investorAssumptions.deductiblePercentOfTLCFGained" },
		a_crm_input__land_value_as_percent_of_gpp: { key: "assumptions.landValueAsPercentOfGpp" },
		a_crm_input__ebitda_limit_interest_rate_barrier: { key: "investorAssumptions.interestThresholdEBITDAWithFloorRule" },
		a_crm_input__interest_limit_interest_rate_barrier: { key: "investorAssumptions.interestAvailableForUse" },
		a_out_invest_memo__header_rent_increase_annual_only: { key: "d2gSettings.rentIncreaseAnnualOnly" },
		a_crm_input__allowed_opex_for_ct: { key: "assumptions.allowedOpexForCt" },
		a_crm_input__cash_trap: { key: "d2gSettings.cashTrap" },
		a_crm_input__ct_max_ltv: { key: "assumptions.ctMaxLtv" },
		a_crm_input__min_jnkm_for_ct_release: { key: "assumptions.minJnkmForCt" },
		a_crm_input__num_of_qrt_for_ct_release: { key: "assumptions.qrtForCtRelease" },
		a_crm_input__working_capital_for_equity_first_non_subsidized_capex: { key: "assumptions.workingCapitalForEquityFirstNonSubsidizedCapex" }
	};
	spreadsheetInputsV5_5_0 = {
		...spreadsheetInputsV5_4_1,
		...calcEngineInputsV5_5_0
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/calculations/d2g/versions/5.5.0/index.ts
var init__5_5_0 = __esmMin((() => {
	init_calculations_helpers$1();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/calculations/d2g/versions/5.6.0/calculations.helpers.ts
var calcEngineInputsV5_6_0, spreadsheetInputsV5_6_0, buildSourcesUsesOutput, buildReturnsOutput, buildGoingInOutOutput, buildValueBridgeOutput, buildRentalIncomeOutput, buildRentalAreaOutput, buildBpAssumptionsOutput, calcEngineOutputsToLegacyOutputFields_V5_6_0;
var init_calculations_helpers = __esmMin((() => {
	init__5_5_0();
	init_parser_helpers();
	init_rent_roll_dd_base();
	calcEngineInputsV5_6_0 = {
		...omit(calcEngineInputsV5_5_0, [
			"a_out_invest_memo__header_expansion",
			"a_out_invest_memo__header_ifb_standard",
			"a_out_invest_memo__header_rent_increase_annual_only",
			"a_out_invest_memo__header_kfw_standard",
			"a_out_invest_memo__header_beg_em_subsidies",
			"a_crm_input__30_lux_cos",
			"a_crm_input__annual_asset_depreciation",
			"a_crm_input__base_b",
			"a_crm_input__base_d",
			"a_crm_input__base_e",
			"a_crm_input__base_f",
			"a_crm_input__base_g",
			"a_crm_input__base_i",
			"a_crm_input__applied_commercial",
			"a_crm_input__applied_rent_carpark",
			"a_crm_input__applied_rent_residential",
			"a_crm_input__asking_price",
			"a_crm_input__assumed_nri_leakage_for_banks",
			"a_crm_input__bank_interest_rate",
			"a_crm_input__brokerage_fee_excluding_vat",
			"a_crm_input__capex_non_subsidized_debt_am_start_month",
			"a_crm_input__capex_non_subsidized_debt_commitment_fee",
			"a_crm_input__capex_non_subsidized_debt_ltv",
			"a_crm_input__capex_non_subsidized_debt_running_am",
			"a_crm_input__capex_non_subsidized_debt_upfront_fee",
			"a_crm_input__commercial_space_sqm",
			"a_crm_input__dd_contingency",
			"a_crm_input__deductible_amount_per_lux_company",
			"a_crm_input__deductible_percent_of_tlcf_gained",
			"a_crm_input__development_rent_loss_in_percent_of_nri",
			"a_crm_input__disposal_costs",
			"a_crm_input__duration_in_months",
			"a_crm_input__ebitda_limit_interest_rate_barrier",
			"a_crm_input__end_of_letting_of_initial_vacany_month",
			"a_crm_input__energy_efficiency_end",
			"a_crm_input__energy_efficiency_start",
			"a_crm_input__entry_date",
			"a_crm_input__exit_multiple_commercial",
			"a_crm_input__exit_multiple_expansion_space",
			"a_crm_input__exit_multiple_parking",
			"a_crm_input__exit_multiple_re_let_resi_space",
			"a_crm_input__exit_multiple_running_resi_space",
			"a_crm_input__expansion_end",
			"a_crm_input__expansion_potential_sqm",
			"a_crm_input__expansion_start",
			"a_crm_input__expected_purchase_discount",
			"a_crm_input__first_bgb_rent_increase_size",
			"a_crm_input__first_bgb_rent_increase_timing",
			"a_crm_input__general_end",
			"a_crm_input__general_start",
			"a_crm_input__inflation",
			"a_crm_input__interest_limit_interest_rate_barrier",
			"a_crm_input__land_value_as_percent_of_gpp",
			"a_crm_input__letting_fees_commercial_external",
			"a_crm_input__letting_fees_residential_external",
			"a_crm_input__ltv_subsidized_loan_kfw",
			"a_crm_input__manual_expanded_space",
			"a_crm_input__modernization_catch_up_after_tiered_increase",
			"a_crm_input__non_recs_maintenance",
			"a_crm_input__notary_costs",
			"a_crm_input__num_of_of_lux_cos",
			"a_crm_input__num_of_parking_spaces",
			"a_crm_input__num_of_parking_spaces_expansion",
			"a_crm_input__provision_for_vacancy_loss_sqm",
			"a_crm_input__re_let_delay_in_months",
			"a_crm_input__resi_space_sqm",
			"a_crm_input__rett",
			"a_crm_input__second_bgb_rent_increase_size",
			"a_crm_input__second_bgb_rent_increase_timing",
			"a_crm_input__senior_debt_am_start_month",
			"a_crm_input__senior_debt_interest_rate",
			"a_crm_input__senior_debt_ltv",
			"a_crm_input__senior_debt_running_am",
			"a_crm_input__sh_ppl_loan_as_percent_of_equity",
			"a_crm_input__sh_ppl_loan_interest",
			"a_crm_input__share_of_ee_capex_attributable_for_subsidies",
			"a_crm_input__share_of_extension_capex_attributable_for_mod_umlage",
			"a_crm_input__share_of_extension_capex_attributable_for_subsidies",
			"a_crm_input__share_of_maintenance_in_renovation_capex_for_rent_calc",
			"a_crm_input__standard_rent_loss_in_percent_of_nri",
			"a_crm_input__start_letting_of_initial_vacancy_month",
			"a_crm_input__start_non_subsidized_committment_fee",
			"a_crm_input__start_subsidized_commitment_fee",
			"a_crm_input__subsidized_debt_am_start_month",
			"a_crm_input__subsidized_debt_running_am",
			"a_crm_input__subsidized_interest_rate_bullet_loan",
			"a_crm_input__target_debt_yield",
			"a_crm_input__target_tis_adj_cat_1",
			"a_crm_input__target_tis_adj_cat_2",
			"a_crm_input__target_tis_adj_cat_3",
			"a_crm_input__target_tis_adj_cat_4",
			"a_crm_input__third_bgb_rent_increase_size",
			"a_crm_input__third_bgb_rent_increase_timing",
			"a_crm_input__tis_class_1_upper_limit",
			"a_crm_input__tis_class_2_upper_limit",
			"a_crm_input__tis_class_3_upper_limit",
			"a_crm_input__transfer_to_lux",
			"a_crm_input__num_of_of_new_we_in_heated_area",
			"a_crm_input__subsidised_commitment_fee"
		]),
		a_crm_input__ibb_subsidized_interest_rate: { key: "assumptions.ibbSubsidizedInterestRate" },
		a_crm_input__next_buyer_transaction_costs: { key: "assumptions.nextBuyerTransactionCosts" },
		a_crm_input__subsidized_capex_loan_maturity: {
			key: "assumptions.subsidizedCapexLoanMaturityDate",
			formatter: (value) => formatDate(value, DateFormats.ISO8601)
		},
		b_crm_console__expansion: { key: "d2gSettings.expansion" },
		b_crm_console__ifb_standard: { key: "d2gSettings.ifbStandard" },
		b_crm_console__rent_increase_annual_only: { key: "d2gSettings.rentIncreaseAnnualOnly" },
		b_crm_console__kfw_standard: { key: "d2gSettings.kfwStandard" },
		b_crm_console__beg_em_subsidies: { key: "d2gSettings.begEmSubsidies" },
		b_crm_console__30_lux_cos: { key: "investorAssumptions.thirtyLuxCos" },
		b_crm_console__annual_asset_depreciation: { key: "investorAssumptions.annualAssetDepreciation" },
		b_crm_console__annual_tenant_churn: { key: "bestWorst.annunalTenantChurn.base" },
		b_crm_console__renovation_costs_energy_efficiency: { key: "bestWorst.renovationCostEnergyEfficiencySqm.base" },
		b_crm_console__renovation_costs_commercial: { key: "bestWorst.renovationCostInteriorCommercialSqm.base" },
		b_crm_console__renovation_costs_residential_tis: { key: "bestWorst.renovationCostInteriorSqm.base" },
		b_crm_console__expansion_costs: { key: "bestWorst.expansionCostSqm.base" },
		b_crm_console__general_capex: { key: "bestWorst.generalCapexSqm.base" },
		b_crm_console__applied_rent_commercial: { key: "rent.appliedRentCommercial" },
		b_crm_console__applied_rent_carpark: { key: "rent.appliedRentCarpark" },
		b_crm_console__applied_rent_residential: { key: "rent.appliedRentResidential" },
		b_crm_console__asking_price: { key: "overview.askingPrice" },
		b_crm_console__assumed_nri_leakage_for_banks: { key: "investorAssumptions.assumedNRILeakageForBanks" },
		b_crm_console__bank_interest_rate: { key: "assumptions.bankInterestRate" },
		b_crm_console__brokerage_fee_excl_vat: { key: "agent.courtageExclVat" },
		b_crm_console__capex_non_subsidized_debt_am_start_month: { key: "assumptions.capexNonSubsidizedDebtAMStartMonth" },
		b_crm_console__capex_non_subsidized_debt_commitment_fee: { key: "investorAssumptions.seniorCapexNonSubsidizedDebtCommitmentFee" },
		b_crm_console__capex_non_subsized_debt_ltv: { key: "investorAssumptions.capexNonSubsidizedDebtLTV" },
		b_crm_console__capex_non_subsidized_debt_running_am: { key: "assumptions.capexNonSubsidizedDebtRunningAm" },
		b_crm_console__capex_non_subsidized_debt_upfront_fee: { key: "assumptions.capexNonSubsidizedDebtUpfrontFee" },
		b_crm_console__commercial_space: { key: "overview.commercialSpaceSqm" },
		b_crm_console__dd_contingency: { key: "assumptions.ddContingency" },
		b_crm_console__deductible_amount_per_lux_company: { key: "investorAssumptions.deductibleAmountPerLuxCompany" },
		b_crm_console__deductible_percent_tlcg_gained: { key: "investorAssumptions.deductiblePercentOfTLCFGained" },
		b_crm_console__development_rent_loss: { key: "investorAssumptions.developmentRentLossInPercentageNRI" },
		b_crm_console__disposal_costs: { key: "assumptions.disposalCosts" },
		b_crm_console__duration: { key: "assumptions.durationInMonths" },
		b_crm_console__ebitda_limit_interest_barrier: { key: "investorAssumptions.interestThresholdEBITDAWithFloorRule" },
		b_crm_console__end_letting_of_initial_vacancy: { key: "assumptions.endLettingInitialVacancyMonth" },
		b_crm_console__energy_efficiency_end: { key: "assumptions.energyEfficiencyEnd" },
		b_crm_console__energy_efficiency_start: { key: "assumptions.energyEfficiencyStart" },
		b_crm_console__entry_date: {
			key: "assumptions.entryDate",
			formatter: (value) => formatDate(value, DateFormats.ISO8601)
		},
		b_crm_console__exit_multiple_commercial: { key: "assumptions.exitMultipleCommercial" },
		b_crm_console__exit_multiple_expansion_space: { key: "assumptions.exitMultipleExpansionSpace" },
		b_crm_console__exit_multiple_parking: { key: "assumptions.exitMultipleParking" },
		b_crm_console__exit_multiple_re_let_resi_space: { key: "assumptions.exitMultipleReletResiSpace" },
		b_crm_console__exit_multiple_running_resi_space: { key: "assumptions.exitMultipleRunningResiSpace" },
		b_crm_console__expansion_end: { key: "assumptions.expansionEnd" },
		b_crm_console__expansion_potential: { key: "overview.expansionPotentialSqm" },
		b_crm_console__expansion_start: { key: "assumptions.expansionStart" },
		b_crm_console__expected_purchase_discount: { key: "assumptions.expectedPurchaseDiscount" },
		b_crm_console__first_bgb_rent_increase_size: { key: "assumptions.firstBgbRentIncreaseSize" },
		b_crm_console__first_bgb_rent_increase_timing: { key: "assumptions.firstBgbRentIncreaseTiming" },
		b_crm_console__general_end: { key: "assumptions.generalEnd" },
		b_crm_console__general_start: { key: "assumptions.generalStart" },
		b_crm_console__inflation: { key: "assumptions.inflationRate" },
		b_crm_console__interest_limit_interest_barrier: { key: "investorAssumptions.interestAvailableForUse" },
		b_crm_console__land_value: { key: "assumptions.landValueAsPercentOfGpp" },
		b_crm_console__letting_fees_commercial: { key: "assumptions.lettingFeesCommercial" },
		b_crm_console__letting_fees_residential: { key: "assumptions.lettingFeesResidential" },
		b_crm_console__ltv_subsidized_loan_kfw: { key: "assumptions.ltvSubsidizedLoanKfWPercent" },
		b_crm_console__manual_expanded_space: { key: "rentPredictions.manualExpandedSpace" },
		b_crm_console__modernization_catch_up_after_tiered_increase: { key: "assumptions.modCatchUpAfterStaffel" },
		b_crm_console__non_recs_maintenance: { key: "assumptions.nonRecsMaintenance" },
		b_crm_console__notary_costs: { key: "assumptions.notaryCosts" },
		b_crm_console__lux_cos: { key: "investorAssumptions.numberOfLuxCos" },
		b_crm_console__parking_spaces: { key: "overview.parkingSpaces" },
		b_crm_console__parking_space_expansion: { key: "overview.parkingSpacesExpansion" },
		b_crm_console__provision_for_vacancy_loss: { key: "assumptions.provisionVacancyLossSqm" },
		b_crm_console__re_let_delay: { key: "assumptions.reletDelayMonths" },
		b_crm_console__resi_space: { key: "overview.resiSpaceSqm" },
		b_crm_console__rett: { key: "assumptions.rett" },
		b_crm_console__second_bgb_rent_increase_size: { key: "assumptions.secondBgbRentIncreaseSize" },
		b_crm_console__second_bgb_rent_increase_timing: { key: "assumptions.secondBgbRentIncreaseTiming" },
		b_crm_console__senior_debt_am_start_month: { key: "investorAssumptions.seniorCapexNonSubsidizedDebtAmStartMonth" },
		b_crm_console__senior_debt_interest_rate: { key: "investorAssumptions.seniorDebtInterestRate" },
		b_crm_console__senior_debt_ltv: { key: "investorAssumptions.seniorDebtLTV" },
		b_crm_console__senior_debt_running_am: { key: "investorAssumptions.seniorCapexNonSubsidizedDebtRunninAM" },
		b_crm_console__sh_ppl_loan_as_percent_of_equity: { key: "investorAssumptions.shareholderPPLLoanPercentOfEquity" },
		b_crm_console__sh_ppl_loan_interest: { key: "investorAssumptions.shareholderPPLLoanInterest" },
		b_crm_console__share_of_ee_capex_attributable_for_subsidies: { key: "assumptions.shareOfEeCapexAttributableForSubsidies" },
		b_crm_console__share_of_expansion_capex_attributable_for_mod_levy: { key: "assumptions.shareOfExtensionCapexAttributableForModLevy" },
		b_crm_console__share_of_expansion_capex_attributable_for_subsidies: { key: "assumptions.shareOfExtensionCapexAttributableForSubsidies" },
		b_crm_console__share_of_maintenance_in_renovation_capex_for_rent_calc: { key: "assumptions.shareMaintenanceRenovationCapex" },
		b_crm_console__standard_rent_loss: { key: "investorAssumptions.standardRentLossInOfNRI" },
		b_crm_console__start_letting_of_initial_vacancy: { key: "assumptions.startLettingInitialVacancyMonth" },
		b_crm_console__start_non_subsidized_committment_fee: { key: "assumptions.startNonSubsidizedCommittmentFee" },
		b_crm_console__start_subsidized_commitment_fee: { key: "assumptions.startSubsidizedCommittmentFee" },
		b_crm_console__subsidized_debt_am_start_month: { key: "investorAssumptions.subsidisedNonSubsidizedDebtAMStartMonth" },
		b_crm_console__subsidized_debt_running_am: { key: "investorAssumptions.subsidisedNonSubsidizedDebtRunningAM" },
		b_crm_console__subsidized_interest_rate_bullet_loan: { key: "assumptions.subsidisedInterestRateBulletLoan" },
		b_crm_console__target_debt_yield: { key: "investorAssumptions.targetDebtYield" },
		b_crm_console__target_tis_adj_cat_1: { key: "assumptions.targetTIsAdjCat1" },
		b_crm_console__target_tis_adj_cat_2: { key: "assumptions.targetTIsAdjCat2" },
		b_crm_console__target_tis_adj_cat_3: { key: "assumptions.targetTIsAdjCat3" },
		b_crm_console__target_tis_adj_cat_4: { key: "assumptions.targetTIsAdjCat4" },
		b_crm_console__third_bgb_rent_increase_size: { key: "assumptions.thirdBgbRentIncreaseSize" },
		b_crm_console__third_bgb_rent_increase_timing: { key: "assumptions.thirdBgbRentIncreaseTiming" },
		b_crm_console__tis_class_1_upper_limit: { key: "assumptions.tIsClass1UpperLimit" },
		b_crm_console__tis_class_2_upper_limit: { key: "assumptions.tIsClass2UpperLimit" },
		b_crm_console__tis_class_3_upper_limit: { key: "assumptions.tIsClass3UpperLimit" },
		b_crm_console__transfer_to_lux: { key: "investorAssumptions.transferToLuxMonth" },
		b_crm_console__apartments_in_heated_area: { key: "buildingTechnical.numberOfApartmentsInHeatedArea" },
		b_crm_console__subsidized_commitment_fee: { key: "assumptions.subsidisedCommitmentFee" }
	};
	spreadsheetInputsV5_6_0 = {
		...spreadsheetInputsV5_5_0,
		b_crm_console__asset: { key: "general.assetName" },
		b_crm_console__bgb_rent_increase_to_mid_of_low_and_medium: { key: "assumptions.bgbRentIncreaseToMidOfLowAndMedium" },
		b_crm_console__cit_rate: { key: "investorAssumptions.CITRate" },
		b_crm_console__taxable_income_utilization_of_loss_pool: { key: "investorAssumptions.taxableIncomeUtilizationOfLossPool" },
		a_crm_input__asset_name: { key: "general.assetName" },
		a_crm_input__seller_name: { key: "general.sellerName" },
		a_crm_input__sales_reason: { key: "general.salesReason" },
		a_crm_input__street_name_s: { key: "location.streetNames" },
		a_crm_input__house_no: { key: "location.houseNo" },
		a_crm_input__postcode: { key: "location.postcode" },
		a_crm_input__district_heating_possible: { key: "location.districtHeatingPossible" },
		a_crm_input__num_of_commercial_units: { key: "overview.commercialUnits" },
		a_crm_input__num_of_buildings: { key: "buildingTechnical.numBuildings" },
		a_crm_input__primary_energy_demand_kwh_sqm_a: { key: "buildingTechnical.primaryEnergyDemandKWhSqm" },
		a_crm_input__rent_index_pre_renovation: { key: "assumptions.rentIndexPreRenovation" },
		a_crm_input__rent_index_post_ee_renovation: { key: "assumptions.rentIndexPostEeRenovation" },
		a_crm_input__asset_viewed: {
			key: "assumptions.assetViewed",
			formatter: (value) => formatDate(value, DateFormats.ISO8601)
		},
		a_crm_input__vat_damage_maintenance: { key: "assumptions.vatDamageMaintenance" },
		a_crm_input__base_j: { key: "bestWorst.epcRatingInKWHPostRenovation.base" },
		a_crm_input__reneo_purchasing_service_fee_no_broker: { key: "investorAssumptions.condoPurchasingServiceFeeNoBroker" },
		a_crm_input__condo_asset_management_fee_alternative_min_of: { key: "investorAssumptions.condoAssetManagementFeeAlternativeMinOf" },
		a_crm_input__allowed_annual_rent_increase_ee: { key: "assumptions.allowedAnnualRentIncreaseEe" },
		a_crm_input__co_2_factor_per_kwh_electricity: { key: "assumptions.co2FactorKwhElectricity" },
		a_crm_input__co_2_factor_per_kwh_heating: { key: "assumptions.co2FactorKwhHeating" },
		a_crm_input__avg_heating_cost_per_kwh: { key: "assumptions.avgHeatingCostPerKwh" },
		a_crm_input__avg_electricity_consumption_per_unit_pre_renovation: { key: "assumptions.avgElectricityConsumptionUnitPreRenovation" },
		a_crm_input__avg_electricity_consumption_per_unit_post_renovation: { key: "assumptions.avgElectricityConsumptionUnitPostRenovation" },
		a_crm_input__kfw_mfh_construction_supervision_per_ru: { key: "assumptions.kfwMfhConstructionSupervisionPerUnit" },
		a_crm_input__epc_rating_going_out: { key: "buildingTechnical.endEnergyConsumptionClassPostRenovation" },
		a_crm_input__fkg_efficiency_house_55_subsidy: { key: "assumptions.fkgEfficiencyHouse55Subsidy" },
		a_crm_input__fkg_b_1_funding: { key: "assumptions.fkg1Funding" },
		f_cal_input_rent_roll__rent_roll_main_inputs_reneo_sale_condition: {
			key: "rentRoll.condoSalesCondition",
			formatter: mapArrayWithLookup(condoSalesConditionToRentRoll)
		}
	};
	buildSourcesUsesOutput = (r) => ({
		header: ["euro", "percent"],
		rows: {
			sourcesDebtSenior: {
				euro: parseNumLike(r.a_cal_cf_engine__unlevered_deal_cf_pre_tax_draw_down_acq_total?.[1]) ?? parseNumLike(r.b_out_ic_charts__ic_s_u_debt_senior_percent?.[1]),
				percent: parseNumLike(r.b_out_ic_charts__ic_s_u_debt_senior_percent?.[1])
			},
			sourcesDebtCapexTiNonSubsidized: {
				euro: parseNumLike(r.a_cal_cf_engine__levered_deal_cf_post_senior_debt_pre_tax_draw_down_acq_total?.[1]) ?? parseNumLike(r.b_out_ic_charts__ic_s_u_debt_capex_ti_non_subsidized_percent?.[1]),
				percent: parseNumLike(r.b_out_ic_charts__ic_s_u_debt_capex_ti_non_subsidized_percent?.[1])
			},
			sourcesDebtCapexSubsidizedInclGrant: {
				euro: parseNumLike(r.a_cal_cf_engine__levered_deal_cf_post_senior_and_capex_non_subsidized_debt_pre_tax_committed_capex_debt_subsidized_total?.[1]) ?? parseNumLike(r.b_out_ic_charts__ic_s_u_debt_capex_subsidized_incl_grant_percent?.[1]),
				percent: parseNumLike(r.b_out_ic_charts__ic_s_u_debt_capex_subsidized_incl_grant_percent?.[1])
			},
			sourcesEquity: {
				euro: parseNumLike(r.a_cal_cf_engine__levered_deal_cf_post_tax_post_promote_total_contributions?.[1]) ?? parseNumLike(r.b_out_ic_charts__ic_s_u_equity_percent?.[1]),
				percent: parseNumLike(r.b_out_ic_charts__ic_s_u_equity_percent?.[1])
			},
			sourcesCashCollectedNoi: {
				euro: parseNumLike(r.b_out_ic_charts__ic_s_u_cash_collected_noi_euro?.[1]),
				percent: parseNumLike(r.b_out_ic_charts__ic_s_u_cash_collected_noi_percent?.[1])
			},
			sourcesTotal: {
				euro: parseNumLike(r.b_out_ic_charts__ic_s_u_total_euro?.[1]) ?? parseNumLike(r.b_out_ic_charts__ic_uses_total_euro?.[1]),
				percent: parseNumLike(r.b_out_ic_charts__ic_s_u_total_percent?.[1]) ?? parseNumLike(r.b_out_ic_charts__ic_uses_total_percent?.[1])
			},
			usesNetPurchasePrice: {
				euro: parseNumLike(r.b_out_ic_charts__ic_uses_net_purchase_price_euro?.[1]),
				percent: parseNumLike(r.b_out_ic_charts__ic_uses_net_purchase_price_percent?.[1])
			},
			usesClosingCostsExclFinancing: {
				euro: parseNumLike(r.b_out_ic_charts__ic_uses_closing_costs_excl_financing_euro?.[1]),
				percent: parseNumLike(r.b_out_ic_charts__ic_uses_closing_costs_excl_financing_percent?.[1])
			},
			usesTIsLCsTenantCompensations: {
				euro: parseNumLike(r.b_out_ic_charts__ic_uses_tis_l_cs_tenant_compensations_euro?.[1]),
				percent: parseNumLike(r.b_out_ic_charts__ic_uses_tis_l_cs_tenant_compensations_percent?.[1])
			},
			usesCAPEXEe: {
				euro: parseNumLike(r.b_out_ic_charts__ic_uses_capex_ee_euro?.[1]),
				percent: parseNumLike(r.b_out_ic_charts__ic_uses_capex_ee_percent?.[1])
			},
			usesCAPEXExpansion: {
				euro: parseNumLike(r.b_out_ic_charts__ic_uses_capex_expansion_euro?.[1]),
				percent: parseNumLike(r.b_out_ic_charts__ic_uses_capex_expansion_percent?.[1])
			},
			usesCAPEXGeneral: {
				euro: parseNumLike(r.b_out_ic_charts__ic_uses_capex_general_euro?.[1]),
				percent: parseNumLike(r.b_out_ic_charts__ic_uses_capex_general_percent?.[1])
			},
			usesPartnerFees: {
				euro: parseNumLike(r.b_out_ic_charts__ic_uses_partner_fees_euro?.[1]),
				percent: parseNumLike(r.b_out_ic_charts__ic_uses_partner_fees_percent?.[1])
			},
			usesFinancingCosts: {
				euro: parseNumLike(r.b_out_ic_charts__ic_uses_financing_costs_euro?.[1]),
				percent: parseNumLike(r.b_out_ic_charts__ic_uses_financing_costs_percent?.[1])
			},
			usesVAT: {
				euro: parseNumLike(r.b_out_ic_charts__ic_uses_vat_euro?.[1]),
				percent: parseNumLike(r.b_out_ic_charts__ic_uses_vat_percent?.[1])
			},
			usesTotal: {
				euro: parseNumLike(r.b_out_ic_charts__ic_uses_total_euro?.[1]) ?? parseNumLike(r.b_out_ic_charts__ic_s_u_total_euro?.[1]),
				percent: parseNumLike(r.b_out_ic_charts__ic_uses_total_percent?.[1]) ?? parseNumLike(r.b_out_ic_charts__ic_s_u_total_percent?.[1])
			},
			usesCAPEXEeCapexExpansion: {
				euro: void 0,
				percent: void 0
			}
		}
	});
	buildReturnsOutput = (r) => ({
		header: [
			"profit",
			"irr",
			"moC"
		],
		rows: {
			preTaxUnlevered: {
				profit: parseNumLike(r.a_cal_cf_engine__unlevered_deal_cf_pre_tax_unleveraged_deal_cf_pre_tax_total?.[1]),
				irr: parseNumLike(r.a_cal_cf_engine__unlevered_deal_cf_pre_tax_irr?.[1]),
				moC: parseNumLike(r.a_cal_cf_engine__unlevered_deal_cf_pre_tax_moc?.[1])
			},
			preTaxLevered: {
				profit: parseNumLike(r.a_cal_cf_engine__levered_deal_cf_post_all_debt_pre_tax_leveraged_deal_cf_post_all_debt_pre_tax_total?.[1]),
				irr: void 0,
				moC: void 0
			},
			postTaxLevered: {
				profit: parseNumLike(r.a_cal_cf_engine__levered_deal_cf_post_all_debt_pre_tax_leveraged_deal_cf_post_tax_pre_promote_total?.[1]),
				irr: parseNumLike(r.a_cal_cf_engine__levered_deal_cf_post_tax_pre_promote_irr?.[1]),
				moC: parseNumLike(r.a_cal_cf_engine__levered_deal_cf_post_tax_pre_promote_moc?.[1])
			},
			postTaxPostPromote: {
				profit: parseNumLike(r.a_cal_cf_engine__levered_deal_cf_post_tax_post_promote_total?.[1]),
				irr: parseNumLike(r.a_cal_cf_engine__levered_deal_cf_post_tax_post_promote_irr?.[1]),
				moC: parseNumLike(r.a_cal_cf_engine__levered_deal_cf_post_tax_post_promote_moc?.[1])
			}
		}
	});
	buildGoingInOutOutput = (r) => ({
		header: [
			"entry",
			"exit",
			"delta"
		],
		rows: {
			NLA: {
				entry: parseNumLike(r.b_out_ic_charts__ic_entry_exit_nla?.[1]?.[0]),
				exit: parseNumLike(r.b_out_ic_charts__ic_entry_exit_nla?.[1]?.[1]),
				delta: parseNumLike(r.b_out_ic_charts__ic_entry_exit_nla?.[1]?.[2])
			},
			NPPVsGrossDisposalPrice: {
				entry: parseNumLike(r.b_out_ic_charts__ic_entry_exit_npp_vs_gross_disposal_price?.[1]?.[0]),
				exit: parseNumLike(r.b_out_ic_charts__ic_entry_exit_npp_vs_gross_disposal_price?.[1]?.[1]),
				delta: parseNumLike(r.b_out_ic_charts__ic_entry_exit_npp_vs_gross_disposal_price?.[1]?.[2])
			},
			netPriceSqm: {
				entry: parseNumLike(r.b_out_ic_charts__ic_entry_exit_npp_vs_gross_disposal_price_psm?.[1]?.[0]),
				exit: parseNumLike(r.b_out_ic_charts__ic_entry_exit_npp_vs_gross_disposal_price_psm?.[1]?.[1]),
				delta: parseNumLike(r.b_out_ic_charts__ic_entry_exit_npp_vs_gross_disposal_price_psm?.[1]?.[2])
			},
			NRIMultiple: {
				entry: parseNumLike(r.b_out_ic_charts__ic_entry_exit_nri_multiple?.[1]?.[0]),
				exit: parseNumLike(r.b_out_ic_charts__ic_entry_exit_nri_multiple?.[1]?.[1]),
				delta: parseNumLike(r.b_out_ic_charts__ic_entry_exit_nri_multiple?.[1]?.[2])
			},
			NRIYield: {
				entry: parseNumLike(r.b_out_ic_charts__ic_entry_exit_nri_yield?.[1]?.[0]),
				exit: parseNumLike(r.b_out_ic_charts__ic_entry_exit_nri_yield?.[1]?.[1]),
				delta: parseNumLike(r.b_out_ic_charts__ic_entry_exit_nri_yield?.[1]?.[2])
			},
			nriYearlyExclVacancyRent: {
				entry: parseNumLike(r.b_out_ic_charts__ic_entry_exit_nri_per_year_excl_vacancy_rent?.[1]?.[0]),
				exit: parseNumLike(r.b_out_ic_charts__ic_entry_exit_nri_per_year_excl_vacancy_rent?.[1]?.[1]),
				delta: parseNumLike(r.b_out_ic_charts__ic_entry_exit_nri_per_year_excl_vacancy_rent?.[1]?.[2])
			},
			nriYearlyInclVacancyRent: {
				entry: parseNumLike(r.b_out_ic_charts__ic_entry_exit_nri_per_year_incl_vacancy_rent?.[1]?.[0]),
				exit: parseNumLike(r.b_out_ic_charts__ic_entry_exit_nri_per_year_incl_vacancy_rent?.[1]?.[1]),
				delta: parseNumLike(r.b_out_ic_charts__ic_entry_exit_nri_per_year_incl_vacancy_rent?.[1]?.[2])
			},
			NRIMonthlySqm: {
				entry: parseNumLike(r.b_out_ic_charts__ic_entry_exit_nri_p_m_psqm_resi?.[1]?.[0]),
				exit: parseNumLike(r.b_out_ic_charts__ic_entry_exit_nri_p_m_psqm_resi?.[1]?.[1]),
				delta: parseNumLike(r.b_out_ic_charts__ic_entry_exit_nri_p_m_psqm_resi?.[1]?.[2])
			},
			vacancy: {
				entry: parseNumLike(r.b_out_ic_charts__ic_entry_exit_vacancy?.[1]?.[0]),
				exit: parseNumLike(r.b_out_ic_charts__ic_entry_exit_vacancy?.[1]?.[1]),
				delta: parseNumLike(r.b_out_ic_charts__ic_entry_exit_vacancy?.[1]?.[2])
			},
			vacancySqm: {
				entry: parseNumLike(r.b_out_ic_charts__ic_entry_exit_vacancy_in_sqm?.[1]?.[0]),
				exit: parseNumLike(r.b_out_ic_charts__ic_entry_exit_vacancy_in_sqm?.[1]?.[1]),
				delta: parseNumLike(r.b_out_ic_charts__ic_entry_exit_vacancy_in_sqm?.[1]?.[2])
			},
			NOIYearly: {
				entry: parseNumLike(r.b_out_ic_charts__ic_entry_exit_noi_per_year?.[1]?.[0]),
				exit: parseNumLike(r.b_out_ic_charts__ic_entry_exit_noi_per_year?.[1]?.[1]),
				delta: parseNumLike(r.b_out_ic_charts__ic_entry_exit_noi_per_year?.[1]?.[2])
			},
			NRILeakage: {
				entry: parseNumLike(r.b_out_ic_charts__ic_entry_exit_nri_leakage?.[1]?.[0]),
				exit: parseNumLike(r.b_out_ic_charts__ic_entry_exit_nri_leakage?.[1]?.[1]),
				delta: parseNumLike(r.b_out_ic_charts__ic_entry_exit_nri_leakage?.[1]?.[2])
			},
			capRateNoiNpp: {
				entry: parseNumLike(r.b_out_ic_charts__ic_entry_exit_cap_rate_noi_npp?.[1]?.[0]),
				exit: parseNumLike(r.b_out_ic_charts__ic_entry_exit_cap_rate_noi_npp?.[1]?.[1]),
				delta: parseNumLike(r.b_out_ic_charts__ic_entry_exit_cap_rate_noi_npp?.[1]?.[2])
			},
			grossPriceNextBuyerView: {
				entry: parseNumLike(r.b_out_ic_charts__ic_entry_exit_gross_price_next_buyer_view?.[1]?.[0]),
				exit: parseNumLike(r.b_out_ic_charts__ic_entry_exit_gross_price_next_buyer_view?.[1]?.[1]),
				delta: parseNumLike(r.b_out_ic_charts__ic_entry_exit_gross_price_next_buyer_view?.[1]?.[2])
			},
			netYieldNoiGpp: {
				entry: parseNumLike(r.b_out_ic_charts__ic_entry_exit_net_yield_noi_gpp?.[1]?.[0]),
				exit: parseNumLike(r.b_out_ic_charts__ic_entry_exit_net_yield_noi_gpp?.[1]?.[1]),
				delta: parseNumLike(r.b_out_ic_charts__ic_entry_exit_net_yield_noi_gpp?.[1]?.[2])
			},
			GPPVsNetDisposalProceeds: {
				entry: parseNumLike(r.b_out_ic_charts__ic_entry_exit_gpp_vs_net_disposal_proceeds?.[1]?.[0]),
				exit: parseNumLike(r.b_out_ic_charts__ic_entry_exit_gpp_vs_net_disposal_proceeds?.[1]?.[1]),
				delta: parseNumLike(r.b_out_ic_charts__ic_entry_exit_gpp_vs_net_disposal_proceeds?.[1]?.[2])
			},
			NRIYearly: {
				entry: void 0,
				exit: void 0,
				delta: void 0
			}
		}
	});
	buildValueBridgeOutput = (r) => ({
		header: [
			"total",
			"m2Entry",
			"m2Exit"
		],
		rows: {
			netDisposalProceeds: {
				total: parseNumLike(r.b_out_ic_charts__ic_entry_exit_gpp_vs_net_disposal_proceeds?.[1]?.[1]),
				m2Entry: void 0,
				m2Exit: parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_w_grant_net_disposal_proceeds_sqm_exit?.[1]) ?? parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_net_disposal_proceeds_sqm_exit?.[1])
			},
			AIC: {
				total: parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_w_grant_aic_post_grant_total?.[1]) ?? parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_aic_excl_financing_total?.[1]),
				m2Entry: void 0,
				m2Exit: parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_w_grant_aic_sqm_exit?.[1]) ?? parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_aic_sqm_exit?.[1])
			},
			tradingProfit: {
				total: parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_w_grant_trading_profit_total?.[1]) ?? parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_trading_profit_total?.[1]),
				m2Entry: void 0,
				m2Exit: parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_w_grant_trading_profit_sqm_exit?.[1]) ?? parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_trading_profit_sqm_exit?.[1])
			},
			NOICollected: {
				total: parseNumLike(r.a_cal_cf_engine__net_operating_income_net_operating_income_total?.[1]) ?? parseNumLike(r.b_out_ic_charts__annual_cashflow_net_operating_income_at_actual_leakage_total?.[1]),
				m2Entry: void 0,
				m2Exit: parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_w_grant_noi_collected_sqm_exit?.[1]) ?? parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_noi_collected_sqm_exit?.[1])
			},
			grossProfit: {
				total: parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_w_grant_big_profit_total?.[1]) ?? parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_big_profit_total?.[1]),
				m2Entry: void 0,
				m2Exit: parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_w_grant_big_profit_sqm_exit?.[1]) ?? parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_big_profit_sqm_exit?.[1])
			},
			netPurchasePrice: {
				total: parseNumLike(r.b_out_ic_charts__ic_entry_exit_npp_vs_gross_disposal_price?.[1]?.[0]),
				m2Entry: parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_net_purchase_price_sqm_entry?.[1]),
				m2Exit: void 0
			},
			transactionCosts: {
				total: parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_transaction_costs_total?.[1]),
				m2Entry: parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_transaction_costs_sqm_entry?.[1]),
				m2Exit: void 0
			},
			grossPurchasePrice: {
				total: parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_gross_purchase_price_total?.[1]),
				m2Entry: parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_gross_purchase_price_sqm_entry?.[1]),
				m2Exit: void 0
			},
			capexEnergyEfficency: {
				total: parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_capex_energy_efficiency_total?.[1]),
				m2Entry: parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_capex_energy_efficiency_sqm_entry?.[1]),
				m2Exit: parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_capex_energy_efficiency_sqm_exit?.[1])
			},
			capexGeneral: {
				total: parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_capex_general_total?.[1]),
				m2Entry: parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_capex_general_sqm_entry?.[1]),
				m2Exit: parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_capex_general_sqm_exit?.[1])
			},
			capexExpansion: {
				total: parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_capex_expansion_total?.[1]),
				m2Entry: parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_capex_expansion_sqm_entry?.[1]),
				m2Exit: parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_capex_expansion_sqm_exit?.[1])
			},
			tenantImprovements: {
				total: parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_tenant_improvements_total?.[1]),
				m2Entry: parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_tenant_improvements_sqm_entry?.[1]),
				m2Exit: void 0
			},
			leasingCommissionTenantCompensations: {
				total: parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_leasing_commission_tenant_compensations_total?.[1]),
				m2Entry: parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_leasing_commission_tenant_compensations_sqm_entry?.[1]),
				m2Exit: void 0
			},
			partnerFees: {
				total: parseNumLike(r.b_out_ic_charts__ic_uses_partner_fees_euro?.[1]),
				m2Entry: parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_partner_fees_sqm_entry?.[1]),
				m2Exit: void 0
			},
			VATLoss: {
				total: parseNumLike(r.b_out_ic_charts__ic_uses_vat_euro?.[1]),
				m2Entry: parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_vat_loss_sqm_entry?.[1]),
				m2Exit: void 0
			},
			AICExclFinancing: {
				total: parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_aic_excl_financing_total?.[1]),
				m2Entry: parseNumLike(r.b_out_ic_charts__value_bridge_pre_lever_tax_aic_excl_financing_sqm_entry?.[1]),
				m2Exit: void 0
			},
			capitalExpenditures: {
				total: void 0,
				m2Entry: void 0,
				m2Exit: void 0
			}
		}
	});
	buildRentalIncomeOutput = (r) => ({
		header: [
			"goingInNriPA",
			"goingInPsm",
			"goingInMarketRentPsmPM",
			"goingOutNriPA",
			"goingOutPsm"
		],
		rows: {
			resiExisting: {
				goingInNriPA: parseNumLike(r.b_out_ic_charts__bp_rent_buy_residential_stock?.[1]?.[0]),
				goingInPsm: parseNumLike(r.b_out_ic_charts__bp_rent_buy_residential_stock?.[1]?.[1]),
				goingInMarketRentPsmPM: parseNumLike(r.b_out_ic_charts__bp_rent_buy_residential_stock?.[1]?.[2]),
				goingOutNriPA: parseNumLike(r.b_out_ic_charts__bp_rent_sell_residential_stock?.[1]?.[0]),
				goingOutPsm: parseNumLike(r.b_out_ic_charts__bp_rent_sell_residential_stock?.[1]?.[1])
			},
			resiAdditional: {
				goingInNriPA: parseNumLike(r.b_out_ic_charts__bp_rent_buy_residential_expansion?.[1]?.[0]),
				goingInPsm: parseNumLike(r.b_out_ic_charts__bp_rent_buy_residential_expansion?.[1]?.[1]),
				goingInMarketRentPsmPM: parseNumLike(r.b_out_ic_charts__bp_rent_buy_residential_expansion?.[1]?.[2]),
				goingOutNriPA: parseNumLike(r.b_out_ic_charts__bp_rent_sell_residential_expansion?.[1]?.[0]),
				goingOutPsm: parseNumLike(r.b_out_ic_charts__bp_rent_sell_residential_expansion?.[1]?.[1])
			},
			commercial: {
				goingInNriPA: parseNumLike(r.b_out_ic_charts__bp_rent_buy_business?.[1]?.[0]),
				goingInPsm: parseNumLike(r.b_out_ic_charts__bp_rent_buy_business?.[1]?.[1]),
				goingInMarketRentPsmPM: parseNumLike(r.b_out_ic_charts__bp_rent_buy_business?.[1]?.[2]),
				goingOutNriPA: parseNumLike(r.b_out_ic_charts__bp_rent_sell_business?.[1]?.[0]),
				goingOutPsm: parseNumLike(r.b_out_ic_charts__bp_rent_sell_business?.[1]?.[1])
			},
			subtotal: {
				goingInNriPA: parseNumLike(r.b_out_ic_charts__bp_rent_buy_subtotal?.[1]?.[0]),
				goingInPsm: parseNumLike(r.b_out_ic_charts__bp_rent_buy_subtotal?.[1]?.[1]),
				goingInMarketRentPsmPM: parseNumLike(r.b_out_ic_charts__bp_rent_buy_subtotal?.[1]?.[2]),
				goingOutNriPA: parseNumLike(r.b_out_ic_charts__bp_rent_sell_subtotal?.[1]?.[0]),
				goingOutPsm: parseNumLike(r.b_out_ic_charts__bp_rent_sell_subtotal?.[1]?.[1])
			},
			parking: {
				goingInNriPA: parseNumLike(r.b_out_ic_charts__bp_rent_buy_park?.[1]?.[0]),
				goingInPsm: parseNumLike(r.b_out_ic_charts__bp_rent_buy_park?.[1]?.[1]),
				goingInMarketRentPsmPM: parseNumLike(r.b_out_ic_charts__bp_rent_buy_park?.[1]?.[2]),
				goingOutNriPA: parseNumLike(r.b_out_ic_charts__bp_rent_sell_park?.[1]?.[0]),
				goingOutPsm: parseNumLike(r.b_out_ic_charts__bp_rent_sell_park?.[1]?.[1])
			},
			total: {
				goingInNriPA: parseNumLike(r.b_out_ic_charts__bp_rent_buy_total?.[1]?.[0]),
				goingInPsm: parseNumLike(r.b_out_ic_charts__bp_rent_buy_total?.[1]?.[1]),
				goingInMarketRentPsmPM: parseNumLike(r.b_out_ic_charts__bp_rent_buy_total?.[1]?.[2]),
				goingOutNriPA: parseNumLike(r.b_out_ic_charts__bp_rent_sell_total?.[1]?.[0]),
				goingOutPsm: parseNumLike(r.b_out_ic_charts__bp_rent_sell_total?.[1]?.[1])
			}
		}
	});
	buildRentalAreaOutput = (r) => ({
		header: [
			"goingInTotal",
			"goingInLet",
			"goingInOccup",
			"goingOutTotal",
			"goingOutLet",
			"goingOutOccup"
		],
		rows: {
			resiExisting: {
				goingInTotal: parseNumLike(r.b_out_ic_charts__bp_area_buy_residential_stock?.[1]?.[0]),
				goingInLet: parseNumLike(r.b_out_ic_charts__bp_area_buy_residential_stock?.[1]?.[1]),
				goingInOccup: parseNumLike(r.b_out_ic_charts__bp_area_buy_residential_stock?.[1]?.[2]),
				goingOutTotal: parseNumLike(r.b_out_ic_charts__bp_area_sell_residential_stock?.[1]?.[0]),
				goingOutLet: parseNumLike(r.b_out_ic_charts__bp_area_sell_residential_stock?.[1]?.[1]),
				goingOutOccup: parseNumLike(r.b_out_ic_charts__bp_area_sell_residential_stock?.[1]?.[2])
			},
			resiAdditional: {
				goingInTotal: parseNumLike(r.b_out_ic_charts__bp_area_buy_residential_expansion?.[1]?.[0]),
				goingInLet: parseNumLike(r.b_out_ic_charts__bp_area_buy_residential_expansion?.[1]?.[1]),
				goingInOccup: parseNumLike(r.b_out_ic_charts__bp_area_buy_residential_expansion?.[1]?.[2]),
				goingOutTotal: parseNumLike(r.b_out_ic_charts__bp_area_sell_residential_expansion?.[1]?.[0]),
				goingOutLet: parseNumLike(r.b_out_ic_charts__bp_area_sell_residential_expansion?.[1]?.[1]),
				goingOutOccup: parseNumLike(r.b_out_ic_charts__bp_area_sell_residential_expansion?.[1]?.[2])
			},
			commercial: {
				goingInTotal: parseNumLike(r.b_out_ic_charts__bp_area_buy_business?.[1]?.[0]),
				goingInLet: parseNumLike(r.b_out_ic_charts__bp_area_buy_business?.[1]?.[1]),
				goingInOccup: parseNumLike(r.b_out_ic_charts__bp_area_buy_business?.[1]?.[2]),
				goingOutTotal: parseNumLike(r.b_out_ic_charts__bp_area_sell_business?.[1]?.[0]),
				goingOutLet: parseNumLike(r.b_out_ic_charts__bp_area_sell_business?.[1]?.[1]),
				goingOutOccup: parseNumLike(r.b_out_ic_charts__bp_area_sell_business?.[1]?.[2])
			},
			subtotal: {
				goingInTotal: parseNumLike(r.b_out_ic_charts__bp_area_buy_subtotal?.[1]?.[0]),
				goingInLet: parseNumLike(r.b_out_ic_charts__bp_area_buy_subtotal?.[1]?.[1]),
				goingInOccup: parseNumLike(r.b_out_ic_charts__bp_area_buy_subtotal?.[1]?.[2]),
				goingOutTotal: parseNumLike(r.b_out_ic_charts__bp_area_sell_subtotal?.[1]?.[0]),
				goingOutLet: parseNumLike(r.b_out_ic_charts__bp_area_sell_subtotal?.[1]?.[1]),
				goingOutOccup: parseNumLike(r.b_out_ic_charts__bp_area_sell_subtotal?.[1]?.[2])
			},
			parking: {
				goingInTotal: parseNumLike(r.b_out_ic_charts__bp_area_buy_park?.[1]?.[0]),
				goingInLet: parseNumLike(r.b_out_ic_charts__bp_area_buy_park?.[1]?.[1]),
				goingInOccup: parseNumLike(r.b_out_ic_charts__bp_area_buy_park?.[1]?.[2]),
				goingOutTotal: parseNumLike(r.b_out_ic_charts__bp_area_sell_park?.[1]?.[0]),
				goingOutLet: parseNumLike(r.b_out_ic_charts__bp_area_sell_park?.[1]?.[1]),
				goingOutOccup: parseNumLike(r.b_out_ic_charts__bp_area_sell_park?.[1]?.[2])
			},
			total: {
				goingInTotal: void 0,
				goingInLet: void 0,
				goingInOccup: void 0,
				goingOutTotal: void 0,
				goingOutLet: void 0,
				goingOutOccup: void 0
			}
		}
	});
	buildBpAssumptionsOutput = (r, inputs) => ({ rows: {
		generalHoldPeriod: parseNumLike(inputs?.assumptions?.durationInMonths),
		generalVacancyQuarter: parseNumLike(r.b_out_ic_charts__bp_assump_vacancy_upon_re_letting?.[1]),
		generalExitNriMultiple: parseNumLike(r.b_cal_gri__global_nri_total_vacancy_blended_exit_factor_gdp_total?.[1]) ?? parseNumLike(inputs?.assumptions?.exitMultipleRunningResiSpace ?? inputs?.bestWorst?.exitMultiple?.base),
		generalEffectiveTaxRate: parseNumLike(r.a_cal_cf_engine__levered_deal_cf_post_all_debt_pre_tax_coporate_income_tax?.[1]),
		generalVacancyCapitalizedAtExit: true,
		rentGrowthChurn: parseNumLike(inputs?.bestWorst?.annunalTenantChurn?.base),
		rentGrowthFirstRentalIncreaseOfExistingTenants: parseNumLike(inputs?.assumptions?.firstBgbRentIncreaseSize),
		rentGrowthSecondRentalIncreaseOfExistingTenants: parseNumLike(inputs?.assumptions?.secondBgbRentIncreaseSize),
		rentGrowthRentIndexInflation: parseNumLike(inputs?.assumptions?.inflationRate),
		rentGrowthMarketRentGrowth: parseNumLike(inputs?.assumptions?.annualRentGrowthNonWhgRenovation),
		rentGrowthNewLeaseIndexation: parseNumLike(inputs?.assumptions?.annualRentGrowthWhgRenovation)
	} });
	calcEngineOutputsToLegacyOutputFields_V5_6_0 = {
		"transformation.subsidiesPercent": {
			source: "results",
			key: "i_out_rcs_outputs__transformation_percent_subsidies",
			formatter: parseNumLike
		},
		"transformation.totalInvestAfterSubsidies": {
			source: "results",
			key: "a_cal_cf_engine__unlevered_operating_cf_pre_tax_gav_total",
			formatter: parseNumLike
		},
		"postTransformation.targetRentSqmMonthly": {
			source: "results",
			key: "b_out_ic_charts__bp_rent_buy_subtotal",
			offset: [2],
			formatter: parseNumLike
		},
		"postTransformation.salesPriceSqm": {
			source: "results",
			key: "b_out_ic_charts__value_bridge_pre_lever_tax_w_grant_net_disposal_proceeds_sqm_exit",
			formatter: parseNumLike
		},
		"postTransformation.IRRPostTaxPostPromotePercentage": {
			source: "results",
			key: "a_cal_cf_engine__levered_deal_cf_post_tax_post_promote_irr",
			formatter: parseNumLike
		},
		"postTransformation.assetValue": {
			source: "results",
			key: "b_out_ic_charts__ic_uses_net_purchase_price_euro",
			formatter: parseNumLike
		},
		"postTransformation.assetValueIncreasePercent": {
			source: "results",
			key: "i_out_rcs_outputs__post_transformation_asset_value_increase_percent",
			formatter: parseNumLike
		},
		"postTransformation.rentIncreaseInPercent": {
			source: "results",
			key: "i_out_rcs_outputs__post_transformation_rent_increase_percent",
			formatter: parseNumLike
		},
		"postTransformation.GRIPerYear": {
			source: "results",
			offset: [0],
			key: "b_out_ic_charts__bp_rent_sell_total",
			formatter: parseNumLike
		},
		"assumptions.exitMultiple": {
			source: "inputs",
			key: ["assumptions.exitMultipleRunningResiSpace", "bestWorst.exitMultiple.base"],
			formatter: parseNumLike
		},
		"assumptions.annualTenantChurnPercent": {
			source: "inputs",
			key: "bestWorst.annunalTenantChurn.base",
			formatter: parseNumLike
		},
		"assumptions.renovationCostsEESqm": {
			source: "inputs",
			key: "bestWorst.renovationCostEnergyEfficiencySqm.base",
			formatter: parseNumLike
		},
		"assumptions.renovationCostsInteriorSqm": {
			source: "inputs",
			key: "bestWorst.renovationCostInteriorSqm.base",
			formatter: parseNumLike
		},
		"assumptions.expansionCostsSqm": {
			source: "inputs",
			key: "bestWorst.expansionCostSqm.base",
			formatter: parseNumLike
		},
		"assumptions.generalCapexSqm": {
			source: "inputs",
			key: "bestWorst.generalCapexSqm.base",
			formatter: parseNumLike
		},
		"assumptions.expectedAquisitionPrice": {
			source: "results",
			key: "b_out_ic_charts__expected_acquisition_price",
			formatter: parseNumLike
		},
		"assumptions.expectedAquisitionPricePerSqm": {
			source: "results",
			key: "b_out_ic_charts__expected_acquisition_price_sqm_going_in",
			formatter: parseNumLike
		},
		"statusQuo.GRIPerYear": {
			source: "results",
			key: "b_out_ic_charts__bp_rent_buy_total",
			formatter: parseNumLike
		},
		"statusQuo.rentSquareMeterMonth": {
			source: "results",
			offset: [1],
			key: "b_out_ic_charts__bp_rent_buy_residential_stock",
			formatter: parseNumLike
		},
		"investmentCaseOutput.valueBridge": {
			source: "results",
			key: buildValueBridgeOutput
		},
		"investmentCaseOutput.goingInOut": {
			source: "results",
			key: buildGoingInOutOutput
		},
		"investmentCaseOutput.sourcesUses": {
			source: "results",
			key: buildSourcesUsesOutput
		},
		"investmentCaseOutput.returns": {
			source: "results",
			key: buildReturnsOutput
		},
		"investmentCaseOutput.rentalIncome": {
			source: "results",
			key: buildRentalIncomeOutput
		},
		"investmentCaseOutput.rentalArea": {
			source: "results",
			key: buildRentalAreaOutput
		},
		"investmentCaseOutput.bpAssumptions": {
			source: "results",
			key: buildBpAssumptionsOutput
		}
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/calculations/d2g/versions/5.6.0/index.ts
var init__5_6_0 = __esmMin((() => {
	init_calculations_helpers();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/calculations/d2g/versions/5.6.1/index.ts
var calcEngineInputsV5_6_1, spreadsheetInputsV5_6_1, calcEngineOutputsToLegacyOutputFields_V5_6_1;
var init__5_6_1 = __esmMin((() => {
	init__5_6_0();
	calcEngineInputsV5_6_1 = calcEngineInputsV5_6_0;
	spreadsheetInputsV5_6_1 = spreadsheetInputsV5_6_0;
	calcEngineOutputsToLegacyOutputFields_V5_6_1 = calcEngineOutputsToLegacyOutputFields_V5_6_0;
}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh-attributes.helpers.ts
var assertNotNil, assertPositive, assertNotNaN, kfwDueDate, residentialRentYearly, residentialPricePerSQM, totalRentYearly, residentialRentPerSQMYearly, numberOfApartments, numberOfParkingSpaces, numberOfCommercialUnits, livingSpace, commercialSpace, totalRentableSpace, totalNumberOfUnits, avgSizeOfApartment, avgSizeOfCommercial, shareOfCommercialRent, commercialRentPerSQMYearly, commercialSpacePricePerSQM, multiple$1, totalPricePerSQM, expectedPurchaseDiscount, actualPricePerSQM, shareOfCommercialSpace, COMPUTED_MFH_ATTRS;
var init_mfh_attributes_helpers = __esmMin((() => {
	init_errors();
	init_estates();
	assertNotNil = (num, calculation, varName) => {
		if (isNil(num)) throw new CalculationError(calculation, `${varName} is null`);
	};
	assertPositive = (num, calculation, varName) => {
		if (num < 0) throw new CalculationError(calculation, `${varName} < 0`);
	};
	assertNotNaN = (num, calculation, varName) => {
		if (Number.isNaN(num)) throw new CalculationError(calculation, `${varName} is NaN`);
	};
	kfwDueDate = (params) => {
		if (isNil(params.kfwApplicationDate)) return null;
		return dayjs(params.kfwApplicationDate).add(1, "year").toDate();
	};
	residentialRentYearly = (params) => {
		if (isNil(params.yearlyRentTotal)) return null;
		const val = safeDifference(params.yearlyRentTotal, params.yearlyRentCommercial, params.yearlyRentParking);
		assertPositive(val, "residentialRentYearly", "result");
		assertNotNil(val, "residentialRentYearly", "result");
		assertNotNaN(val, "residentialRentYearly", "result");
		return val;
	};
	residentialPricePerSQM = (params) => {
		if (isNil(params?.livingSpace) || isNil(params.askingPrice)) return null;
		if (params.livingSpace === 0) return 0;
		assertPositive(params.livingSpace, "residentialPricePerSQM", "livingSpace");
		assertPositive(params.askingPrice, "residentialPricePerSQM", "askingPrice");
		return params.askingPrice / params.livingSpace;
	};
	totalRentYearly = (params) => {
		if (isNil(params?.residentialRent) && isNil(params.commercialRent) && isNil(params.parkingSpaceRent)) return null;
		if (!isNil(params.totalRent)) return params.totalRent;
		return safeSum(params.residentialRent, params.commercialRent, params.parkingSpaceRent);
	};
	residentialRentPerSQMYearly = (params) => {
		if (isNil(params?.livingSpace) || isNil(params.residentialRent)) return null;
		const divisor = (params.occupancyRate ?? 1) * params.livingSpace;
		if (divisor === 0) return null;
		assertPositive(params.livingSpace, "residentialRentPerSQMYearly", "livingSpace");
		assertPositive(params.residentialRent, "residentialRentPerSQMYearly", "residentialRent");
		return params.residentialRent / divisor;
	};
	numberOfApartments = (params) => {
		if (isNil(params.estimatedNumberOfApartments) && isNil(params.buildings)) return null;
		const residentialEstates = (params.buildings?.flatMap((b) => b.estates ?? []) ?? []).filter((e) => ResidentialApartmentTypes.includes(e.attributes?.apartmentType));
		if (residentialEstates?.length) return residentialEstates.length;
		if (!isNil(params.estimatedNumberOfApartments)) {
			assertPositive(params.estimatedNumberOfApartments, "numberOfApartments", "estimatedNumberOfApartments");
			return params.estimatedNumberOfApartments;
		}
		return null;
	};
	numberOfParkingSpaces = (params) => {
		if (isNil(params.estimatedNumberOfParkingSpaces) && isNil(params.buildings)) return null;
		const parkingEstates = (params.buildings?.flatMap((b) => b.estates ?? []) ?? []).filter((e) => ParkingApartmentTypes.includes(e.attributes?.apartmentType));
		if (parkingEstates?.length) return parkingEstates.length;
		if (!isNil(params.estimatedNumberOfParkingSpaces)) {
			assertPositive(params.estimatedNumberOfParkingSpaces, "numberOfParkingSpaces", "estimatedNumberOfParkingSpaces");
			return params.estimatedNumberOfParkingSpaces;
		}
		return null;
	};
	numberOfCommercialUnits = (params) => {
		if (isNil(params.estimatedNumberOfCommercialUnits) && isNil(params.buildings)) return null;
		const commercialEstates = (params.buildings?.flatMap((b) => b.estates ?? []) ?? []).filter((e) => CommercialApartmentTypes.includes(e.attributes?.apartmentType));
		if (commercialEstates?.length) return commercialEstates.length;
		if (!isNil(params.estimatedNumberOfCommercialUnits)) {
			assertPositive(params.estimatedNumberOfCommercialUnits, "numberOfCommercialUnits", "estimatedNumberOfCommercialUnits");
			return params.estimatedNumberOfCommercialUnits;
		}
		return null;
	};
	livingSpace = (params) => {
		if (isNil(params.estimatedLivingSpace) && isNil(params.buildings)) return null;
		const residentialEstates = (params.buildings?.flatMap((b) => b.estates ?? []) ?? []).filter((e) => ResidentialApartmentTypes.includes(e.attributes?.apartmentType));
		if (residentialEstates?.length) return safeSum(...residentialEstates.map((e) => e.attributes?.livingSpace));
		if (!isNil(params.estimatedLivingSpace)) {
			assertPositive(params.estimatedLivingSpace, "livingSpace", "estimatedLivingSpace");
			return params.estimatedLivingSpace;
		}
		return null;
	};
	commercialSpace = (params) => {
		if (isNil(params.estimatedCommercialSpace) && isNil(params.buildings)) return null;
		const commercialEstates = (params.buildings?.flatMap((b) => b.estates ?? []) ?? []).filter((e) => CommercialApartmentTypes.includes(e.attributes?.apartmentType));
		if (commercialEstates?.length) return safeSum(...commercialEstates.map((e) => e.attributes?.livingSpace));
		if (!isNil(params.estimatedCommercialSpace)) {
			assertPositive(params.estimatedCommercialSpace, "commercialSpace", "estimatedCommercialSpace");
			return params.estimatedCommercialSpace;
		}
		return null;
	};
	totalRentableSpace = (params) => {
		if (isNil(params.commercialSpace) && isNil(params.residentialSpace)) return null;
		return (params.commercialSpace ?? 0) + (params.residentialSpace ?? 0);
	};
	totalNumberOfUnits = (params) => {
		if (isNil(params.numberOfResidentialUnits) && isNil(params.numberOfCommercialUnits)) return null;
		return (params.numberOfResidentialUnits ?? 0) + (params.numberOfCommercialUnits ?? 0);
	};
	avgSizeOfApartment = (params) => {
		if (isNil(params.livingSpace) || isNil(params.buildings) && isNil(params.estimatedNumberOfApartments)) return null;
		const numApartments = params.buildings?.reduce((sum, b) => sum + (b.estates?.filter((e) => ResidentialApartmentTypes.includes(e.attributes?.apartmentType))?.length ?? 0), 0) || params.estimatedNumberOfApartments;
		if (isNil(numApartments) || numApartments === 0) return null;
		assertPositive(numApartments, "avgSizeOfApartment", "numberOfApartments");
		return params?.livingSpace / numApartments;
	};
	avgSizeOfCommercial = (params) => {
		if (isNil(params.commercialSpaceSqm) || isNil(params.commercialUnits) || params.commercialUnits === 0) return null;
		if (params.commercialSpaceSqm === 0) return 0;
		assertPositive(params.commercialUnits, "avgSizeOfCommercial", "commercialUnits");
		assertPositive(params.commercialSpaceSqm, "avgSizeOfCommercial", "commercialSpaceSqm");
		return params.commercialSpaceSqm / params.commercialUnits;
	};
	shareOfCommercialRent = (params) => {
		if (isNil(params.yearlyRentCommercial) || isNil(params.yearlyRentTotal) && isNil(params.yearlyRentCommercial) && isNil(params.yearlyRentParking)) return null;
		if (params.yearlyRentCommercial === 0) return 0;
		const val = params.yearlyRentCommercial / safeSum(params.yearlyRentTotal, params.yearlyRentCommercial, params.yearlyRentParking);
		assertPositive(val, "shareOfCommercialRent", "result");
		assertNotNil(val, "shareOfCommercialRent", "result");
		assertNotNaN(val, "shareOfCommercialRent", "result");
		return val;
	};
	commercialRentPerSQMYearly = (params) => {
		if (isNil(params.yearlyRentCommercial) || isNil(params.commercialSpace) || params.commercialSpace === 0) return null;
		if (params.yearlyRentCommercial === 0) return 0;
		assertPositive(params.yearlyRentCommercial, "commercialRentPerSQM", "yearlyRentCommercial");
		assertPositive(params.commercialSpace, "commercialRentPerSQM", "commercialSpace");
		return params.yearlyRentCommercial / params.commercialSpace / 12;
	};
	commercialSpacePricePerSQM = (params) => {
		if (isNil(params.askingPrice) || isNil(params.commercialSpace)) return null;
		if (params.askingPrice === 0 || params.commercialSpace === 0) return 0;
		assertPositive(params.askingPrice, "commercialSpacePricePerSQM", "askingPrice");
		assertPositive(params.commercialSpace, "commercialSpacePricePerSQM", "commercialSpace");
		return params.askingPrice / params.commercialSpace;
	};
	multiple$1 = /* @__PURE__ */ __name((params) => {
		if (isNil(params.yearlyRentTotal) || isNil(params.askingPrice) || params.yearlyRentTotal === 0) return null;
		if (params.askingPrice === 0) return 0;
		assertPositive(params.askingPrice, "multiple", "askingPrice");
		assertPositive(params.yearlyRentTotal, "multiple", "yearlyRentTotal");
		return params.askingPrice / params.yearlyRentTotal;
	}, "multiple");
	totalPricePerSQM = (params) => {
		if (isNil(params.askingPrice) || isNil(params.residentialSpace) && isNil(params.commercialSpace)) return null;
		if (params.askingPrice === 0) return 0;
		assertPositive(params.askingPrice, "totalPricePerSQM", "askingPrice");
		const divisor = safeSum(params.residentialSpace, params.commercialSpace);
		assertPositive(divisor, "totalPricePerSQM", "result");
		return params.askingPrice / divisor;
	};
	expectedPurchaseDiscount = (params) => {
		if (isNil(params.actualPrice) || isNil(params.askingPrice)) return null;
		if (params.askingPrice === 0) return null;
		assertPositive(params.askingPrice, "expectedPurchaseDiscount", "askingPrice");
		return 1 - params.actualPrice / params.askingPrice;
	};
	actualPricePerSQM = (params) => {
		if (isNil(params.actualPrice) || isNil(params.residentialSpace) && isNil(params.commercialSpace)) return null;
		if (params.actualPrice === 0) return 0;
		assertPositive(params.actualPrice, "actualPricePerSQM", "actualPrice");
		const divisor = safeSum(params.residentialSpace, params.commercialSpace);
		assertPositive(divisor, "actualPricePerSQM", "result");
		return params.actualPrice / divisor;
	};
	shareOfCommercialSpace = (params) => {
		if (isNil(params.commercialSpace) || isNil(params.commercialSpace) && isNil(params.livingSpace)) return null;
		if (params.commercialSpace === 0) return 0;
		const divisor = safeSum(params.commercialSpace, params.livingSpace);
		if (divisor === 0) return null;
		assertPositive(params.commercialSpace, "shareOfCommercialSpace", "commercialSpace");
		assertPositive(divisor, "shareOfCommercialSpace", "result");
		return params.commercialSpace / divisor;
	};
	COMPUTED_MFH_ATTRS = {
		kfwDueDate: {
			dependentFields: ["attributes.kfwApplicationDate"],
			fromMFH: (mfh) => {
				return kfwDueDate({ kfwApplicationDate: mfh.attributes?.kfwApplicationDate ? new Date(mfh.attributes.kfwApplicationDate) : null });
			},
			fn: kfwDueDate
		},
		totalRentYearly: {
			dependentFields: [
				"attributes.commercialRentalIncomeActual",
				"attributes.rentalParkingSpaceIncome",
				"attributes.rentalIncomeActual"
			],
			fromMFH: (mfh) => {
				const residentialRent = residentialRentYearly({
					yearlyRentCommercial: mfh.attributes?.commercialRentalIncomeActual,
					yearlyRentParking: mfh.attributes?.rentalParkingSpaceIncome,
					yearlyRentTotal: mfh.attributes?.rentalIncomeActual
				});
				if (mfh.attributes?.rentalIncomeActual) return;
				return totalRentYearly({
					residentialRent,
					commercialRent: mfh.attributes?.commercialRentalIncomeActual,
					parkingSpaceRent: mfh.attributes?.rentalParkingSpaceIncome,
					totalRent: mfh.attributes?.rentalIncomeActual
				});
			},
			fn: totalRentYearly
		},
		residentialPricePerSQM: {
			dependentFields: ["attributes.estimatedLivingSpace", "buildings.*.estates.*.attributes.livingSpace"],
			fromMFH: (mfh) => {
				const totalLivingSpace = mfh.attributes?.livingSpace ?? livingSpace({
					estimatedLivingSpace: mfh.attributes?.estimatedLivingSpace,
					buildings: mfh.buildings?.map((b) => ({ estates: b.estates?.map((e) => pick(e, "attributes.livingSpace")) ?? [] }))
				});
				return residentialPricePerSQM({
					askingPrice: mfh.price?.purchasePriceNett,
					livingSpace: totalLivingSpace
				});
			},
			fn: residentialPricePerSQM
		},
		residentialRentYearly: {
			dependentFields: [
				"attributes.commercialRentalIncomeActual",
				"attributes.rentalParkingSpaceIncome",
				"attributes.rentalIncomeActual"
			],
			fromMFH: (mfh) => residentialRentYearly({
				yearlyRentCommercial: mfh.attributes?.commercialRentalIncomeActual,
				yearlyRentParking: mfh.attributes?.rentalParkingSpaceIncome,
				yearlyRentTotal: mfh.attributes?.rentalIncomeActual
			}),
			fn: residentialRentYearly
		},
		residentialRentPerSQMYearly: {
			dependentFields: ["attributes.estimatedLivingSpace", "buildings.*.estates.*.attributes.livingSpace"],
			fromMFH: (mfh) => {
				const totalLivingSpace = mfh.attributes?.livingSpace ?? livingSpace({
					estimatedLivingSpace: mfh.attributes?.estimatedLivingSpace,
					buildings: mfh.buildings?.map((b) => ({ estates: b.estates?.map((e) => pick(e, "attributes.livingSpace")) ?? [] }))
				});
				const totalResidentialRent = residentialRentYearly({
					yearlyRentCommercial: mfh.attributes?.commercialRentalIncomeActual,
					yearlyRentParking: mfh.attributes?.rentalParkingSpaceIncome,
					yearlyRentTotal: mfh.attributes?.rentalIncomeActual
				});
				return residentialRentPerSQMYearly({
					livingSpace: totalLivingSpace,
					residentialRent: totalResidentialRent,
					occupancyRate: mfh.attributes?.residentialOccupancyRate
				});
			},
			fn: residentialRentPerSQMYearly
		},
		numberOfApartments: {
			dependentFields: [
				"attributes.estimatedNumberOfApartments",
				"buildings.*.estates.*.attributes.livingSpace",
				"buildings.*.estates.*.attributes.apartmentType"
			],
			fromMFH: (mfh) => {
				return numberOfApartments({
					buildings: mfh.buildings,
					estimatedNumberOfApartments: mfh.attributes?.estimatedNumberOfApartments
				});
			},
			fn: numberOfApartments
		},
		numberOfParkingSpaces: {
			dependentFields: ["attributes.estimatedNumberOfParkingSpaces", "buildings.*.estates.*.attributes.apartmentType"],
			fromMFH: (mfh) => {
				return numberOfParkingSpaces({
					buildings: mfh.buildings,
					estimatedNumberOfParkingSpaces: mfh.attributes?.estimatedNumberOfParkingSpaces
				});
			},
			fn: numberOfParkingSpaces
		},
		numberOfCommercialUnits: {
			dependentFields: [
				"attributes.estimatedNumberOfCommercialUnits",
				"buildings.*.estates.*.attributes.livingSpace",
				"buildings.*.estates.*.attributes.apartmentType"
			],
			fromMFH: (mfh) => {
				return numberOfCommercialUnits({
					buildings: mfh.buildings,
					estimatedNumberOfCommercialUnits: mfh.attributes?.estimatedNumberOfCommercialUnits
				});
			},
			fn: numberOfCommercialUnits
		},
		livingSpace: {
			dependentFields: [
				"attributes.estimatedLivingSpace",
				"buildings.*.estates.*.attributes.livingSpace",
				"buildings.*.estates.*.attributes.apartmentType"
			],
			fromMFH: (mfh) => {
				return livingSpace({
					estimatedLivingSpace: mfh.attributes?.estimatedLivingSpace,
					buildings: mfh.buildings?.map((b) => ({ estates: b.estates?.map((e) => pick(e, ["attributes.livingSpace", "attributes.apartmentType"])) ?? [] }))
				});
			},
			fn: livingSpace
		},
		commercialSpace: {
			dependentFields: [
				"attributes.estimatedCommercialSpace",
				"buildings.*.estates.*.attributes.livingSpace",
				"buildings.*.estates.*.attributes.apartmentType"
			],
			fromMFH: (mfh) => {
				return commercialSpace({
					estimatedCommercialSpace: mfh.attributes?.estimatedCommercialSpace,
					buildings: mfh.buildings?.map((b) => ({ estates: b.estates?.map((e) => pick(e, ["attributes.livingSpace", "attributes.apartmentType"])) ?? [] }))
				});
			},
			fn: commercialSpace
		},
		totalRentableSpace: {
			dependentFields: [
				"attributes.estimatedLivingSpace",
				"attributes.estimatedCommercialSpace",
				"buildings.*.estates.*.attributes.livingSpace",
				"buildings.*.estates.*.attributes.apartmentType"
			],
			fromMFH: (mfh) => {
				const buildings = mfh.buildings?.map((b) => ({ estates: b.estates?.map((e) => pick(e, ["attributes.livingSpace", "attributes.apartmentType"])) ?? [] }));
				const totalResidentialSpace = mfh.attributes?.livingSpace ?? livingSpace({
					estimatedLivingSpace: mfh.attributes?.estimatedLivingSpace,
					buildings
				});
				const totalCommercialSpace = mfh.attributes?.commercialSpace ?? commercialSpace({
					estimatedCommercialSpace: mfh.attributes?.estimatedCommercialSpace,
					buildings
				});
				return totalRentableSpace({
					residentialSpace: totalResidentialSpace,
					commercialSpace: totalCommercialSpace
				});
			},
			fn: totalRentableSpace
		},
		totalNumberOfUnits: {
			dependentFields: [
				"attributes.estimatedNumberOfApartments",
				"attributes.estimatedNumberOfCommercialUnits",
				"buildings.*.estates.*.attributes.apartmentType"
			],
			fromMFH: (mfh) => {
				const totalNumberOfResidentialUnits = mfh.attributes?.numberOfApartments ?? numberOfApartments({
					estimatedNumberOfApartments: mfh.attributes?.estimatedNumberOfApartments,
					buildings: mfh.buildings
				});
				const totalNumberOfCommercialUnits = mfh.attributes?.numberOfCommercialUnits ?? numberOfCommercialUnits({
					estimatedNumberOfCommercialUnits: mfh.attributes?.estimatedNumberOfCommercialUnits,
					buildings: mfh.buildings
				});
				return totalNumberOfUnits({
					numberOfResidentialUnits: totalNumberOfResidentialUnits,
					numberOfCommercialUnits: totalNumberOfCommercialUnits
				});
			},
			fn: totalNumberOfUnits
		},
		avgSizeOfApartment: {
			dependentFields: [
				"attributes.estimatedLivingSpace",
				"attributes.estimatedNumberOfApartments",
				"buildings.*.estates.*.attributes.livingSpace",
				"buildings.*.estates.*.attributes.apartmentType"
			],
			fromMFH: (mfh) => {
				const totalLivingSpace = mfh.attributes?.livingSpace ?? livingSpace({
					estimatedLivingSpace: mfh.attributes?.estimatedLivingSpace,
					buildings: mfh.buildings?.map((b) => ({ estates: b.estates?.map((e) => pick(e, ["attributes.livingSpace", "attributes.apartmentType"])) ?? [] }))
				});
				return avgSizeOfApartment({
					livingSpace: totalLivingSpace,
					buildings: mfh.buildings?.map((b) => ({ estates: b.estates })),
					estimatedNumberOfApartments: mfh.attributes?.estimatedNumberOfApartments
				});
			},
			fn: avgSizeOfApartment
		},
		avgSizeOfCommercial: {
			dependentFields: [
				"attributes.estimatedCommercialSpace",
				"attributes.estimatedNumberOfCommercialUnits",
				"buildings.*.estates.*.attributes.livingSpace",
				"buildings.*.estates.*.attributes.apartmentType"
			],
			fromMFH: (mfh) => {
				const totalCommercialSpace = mfh.attributes?.commercialSpace ?? commercialSpace({
					estimatedCommercialSpace: mfh.attributes?.estimatedCommercialSpace,
					buildings: mfh.buildings?.map((b) => ({ estates: b.estates?.map((e) => pick(e, ["attributes.livingSpace", "attributes.apartmentType"])) ?? [] }))
				});
				const totalCommercialUnits = numberOfCommercialUnits({
					estimatedNumberOfCommercialUnits: mfh.attributes?.estimatedNumberOfCommercialUnits,
					buildings: mfh.buildings
				});
				return avgSizeOfCommercial({
					commercialSpaceSqm: totalCommercialSpace,
					commercialUnits: totalCommercialUnits
				});
			},
			fn: avgSizeOfCommercial
		},
		shareOfCommercialRent: {
			dependentFields: [
				"attributes.commercialRentalIncomeActual",
				"attributes.rentalParkingSpaceIncome",
				"attributes.rentalIncomeActual"
			],
			fromMFH: (mfh) => {
				return shareOfCommercialRent({
					yearlyRentCommercial: mfh.attributes?.commercialRentalIncomeActual,
					yearlyRentParking: mfh.attributes?.rentalParkingSpaceIncome,
					yearlyRentTotal: mfh.attributes?.rentalIncomeActual
				});
			},
			fn: shareOfCommercialRent
		},
		commercialSpacePricePerSQM: {
			dependentFields: [
				"price.purchasePriceNett",
				"buildings.*.estates.*.attributes.livingSpace",
				"buildings.*.estates.*.attributes.apartmentType"
			],
			fromMFH: (mfh) => {
				const totalCommercialSpace = mfh.attributes?.commercialSpace ?? commercialSpace({
					estimatedCommercialSpace: mfh.attributes?.estimatedCommercialSpace,
					buildings: mfh.buildings?.map((b) => ({ estates: b.estates?.map((e) => pick(e, ["attributes.livingSpace", "attributes.apartmentType"])) ?? [] }))
				});
				return commercialSpacePricePerSQM({
					askingPrice: mfh.price?.purchasePriceNett,
					commercialSpace: totalCommercialSpace
				});
			},
			fn: commercialSpacePricePerSQM
		},
		commercialRentPerSQMYearly: {
			dependentFields: [
				"attributes.commercialRentalIncomeActual",
				"buildings.*.estates.*.attributes.livingSpace",
				"buildings.*.estates.*.attributes.apartmentType"
			],
			fromMFH: (mfh) => {
				const totalCommercialSpace = mfh.attributes?.commercialSpace ?? commercialSpace({
					estimatedCommercialSpace: mfh.attributes?.estimatedCommercialSpace,
					buildings: mfh.buildings?.map((b) => ({ estates: b.estates?.map((e) => pick(e, ["attributes.livingSpace", "attributes.apartmentType"])) ?? [] }))
				});
				return commercialRentPerSQMYearly({
					yearlyRentCommercial: mfh.attributes?.commercialRentalIncomeActual,
					commercialSpace: totalCommercialSpace
				});
			},
			fn: commercialRentPerSQMYearly
		},
		multiple: {
			dependentFields: ["attributes.rentalIncomeActual", "attributes.purchasePriceNett"],
			fromMFH: (mfh) => {
				return multiple$1({
					yearlyRentTotal: mfh.attributes?.rentalIncomeActual,
					askingPrice: mfh.price?.purchasePriceNett
				});
			},
			fn: multiple$1
		},
		totalPricePerSQM: {
			dependentFields: [
				"attributes.estimatedLivingSpace",
				"buildings.*.estates.*.attributes.livingSpace",
				"buildings.*.estates.*.attributes.apartmentType"
			],
			fromMFH: (mfh) => {
				const buildings = mfh.buildings?.map((b) => ({ estates: b.estates?.map((e) => pick(e, ["attributes.livingSpace", "attributes.apartmentType"])) ?? [] }));
				const totalResidentialSpace = mfh.attributes?.livingSpace ?? livingSpace({
					estimatedLivingSpace: mfh.attributes?.estimatedLivingSpace,
					buildings
				});
				const totalCommercialSpace = mfh.attributes?.commercialSpace ?? commercialSpace({
					estimatedCommercialSpace: mfh.attributes?.estimatedCommercialSpace,
					buildings
				});
				return totalPricePerSQM({
					askingPrice: mfh.price?.purchasePriceNett,
					residentialSpace: totalResidentialSpace,
					commercialSpace: totalCommercialSpace
				});
			},
			fn: totalPricePerSQM
		},
		expectedPurchaseDiscount: {
			dependentFields: ["sourcing.attributes.actualPrice", "price.purchasePriceNett"],
			fromMFH: (mfh) => {
				return expectedPurchaseDiscount({
					actualPrice: mfh.sourcing?.attributes?.actualPrice,
					askingPrice: mfh.price?.purchasePriceNett
				});
			},
			fn: expectedPurchaseDiscount
		},
		actualPricePerSQM: {
			dependentFields: [
				"sourcing.attributes.actualPrice",
				"attributes.estimatedLivingSpace",
				"buildings.*.estates.*.attributes.livingSpace",
				"buildings.*.estates.*.attributes.apartmentType"
			],
			fromMFH: (mfh) => {
				const buildings = mfh.buildings?.map((b) => ({ estates: b.estates?.map((e) => pick(e, ["attributes.livingSpace", "attributes.apartmentType"])) ?? [] }));
				const totalResidentialSpace = mfh.attributes?.livingSpace ?? livingSpace({
					estimatedLivingSpace: mfh.attributes?.estimatedLivingSpace,
					buildings
				});
				const totalCommercialSpace = mfh.attributes?.commercialSpace ?? commercialSpace({
					estimatedCommercialSpace: mfh.attributes?.estimatedCommercialSpace,
					buildings
				});
				return actualPricePerSQM({
					actualPrice: mfh.sourcing?.attributes?.actualPrice,
					residentialSpace: totalResidentialSpace,
					commercialSpace: totalCommercialSpace
				});
			},
			fn: actualPricePerSQM
		},
		shareOfCommercialSpace: {
			dependentFields: [
				"attributes.estimatedLivingSpace",
				"buildings.*.estates.*.attributes.livingSpace",
				"buildings.*.estates.*.attributes.apartmentType"
			],
			fromMFH: (mfh) => {
				const buildings = mfh.buildings?.map((b) => ({ estates: b.estates?.map((e) => pick(e, ["attributes.livingSpace", "attributes.apartmentType"])) ?? [] }));
				const totalResidentialSpace = mfh.attributes?.livingSpace ?? livingSpace({
					estimatedLivingSpace: mfh.attributes?.estimatedLivingSpace,
					buildings
				});
				const totalCommercialSpace = mfh.attributes?.commercialSpace ?? commercialSpace({
					estimatedCommercialSpace: mfh.attributes?.estimatedCommercialSpace,
					buildings
				});
				return shareOfCommercialSpace({
					livingSpace: totalResidentialSpace,
					commercialSpace: totalCommercialSpace
				});
			},
			fn: shareOfCommercialSpace
		}
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/mfh-investment-case.model.ts
var D2GRentIndexLookupAreaQuality, D2GRentIndexCityEastWest, LocationThreshold, MappingType, MFHInvestmentCaseReadCopySyncStatus;
var init_mfh_investment_case_model = __esmMin((() => {
	D2GRentIndexLookupAreaQuality = /* @__PURE__ */ function(D2GRentIndexLookupAreaQuality) {
		D2GRentIndexLookupAreaQuality["Simple"] = "simple";
		D2GRentIndexLookupAreaQuality["Normal"] = "normal";
		D2GRentIndexLookupAreaQuality["Good"] = "good";
		return D2GRentIndexLookupAreaQuality;
	}({});
	D2GRentIndexCityEastWest = /* @__PURE__ */ function(D2GRentIndexCityEastWest) {
		D2GRentIndexCityEastWest["West"] = "west";
		D2GRentIndexCityEastWest["East"] = "east";
		D2GRentIndexCityEastWest["WestEast"] = "west & east";
		return D2GRentIndexCityEastWest;
	}({});
	LocationThreshold = /* @__PURE__ */ function(LocationThreshold) {
		LocationThreshold["TopCity"] = "TopCity";
		LocationThreshold["BCity"] = "BCity";
		LocationThreshold["MetroArea"] = "MetroArea";
		return LocationThreshold;
	}({});
	MappingType = /* @__PURE__ */ function(MappingType) {
		MappingType[MappingType["SCALAR"] = 1] = "SCALAR";
		MappingType[MappingType["TABLE"] = 2] = "TABLE";
		return MappingType;
	}({});
	MFHInvestmentCaseReadCopySyncStatus = /* @__PURE__ */ function(MFHInvestmentCaseReadCopySyncStatus) {
		MFHInvestmentCaseReadCopySyncStatus["Syncing"] = "SYNCING";
		MFHInvestmentCaseReadCopySyncStatus["Synced"] = "SYNCED";
		MFHInvestmentCaseReadCopySyncStatus["Failed"] = "FAILED";
		return MFHInvestmentCaseReadCopySyncStatus;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/mfh-fee-tiers.helpers.ts
var MFH_FEE_TIER_LOWER_THRESHOLD, MFH_FEE_TIER_UPPER_THRESHOLD, resolveMFHFeeTier, pickTierFee, resolveMFHFeeTierInputPath;
var init_mfh_fee_tiers_helpers = __esmMin((() => {
	init_mfh_investment_case_base();
	MFH_FEE_TIER_LOWER_THRESHOLD = 25e6;
	MFH_FEE_TIER_UPPER_THRESHOLD = 75e6;
	resolveMFHFeeTier = (amount) => {
		if (amount < 25e6) return "lt25m";
		if (amount < 75e6) return "gt25m";
		return "gt75m";
	};
	pickTierFee = (channel, amount, tiers) => {
		if (isNil(channel) || isNil(amount) || amount < 0) return;
		const tier = resolveMFHFeeTier(amount);
		return (channel === "On-Market" ? tiers.onMarket : tiers.offMarket)[tier] ?? void 0;
	};
	resolveMFHFeeTierInputPath = (channel, amount, prefixes) => {
		if (isNil(channel) || isNil(amount) || amount < 0) return;
		return `${channel === "On-Market" ? prefixes.onMarket : prefixes.offMarket}_${resolveMFHFeeTier(amount)}`;
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/mfh-investment-case.helpers.ts
function unpackMapping(mapping) {
	const type = mapping[0];
	if (!isNumber(type) || type === 1) {
		if (isNumber(type)) {
			const [type, field, targetSheetId, colIdx, rowIdx] = mapping;
			return {
				type,
				field,
				targetSheetId,
				colIdx,
				rowIdx
			};
		}
		const [field, targetSheetId, colIdx, rowIdx] = mapping;
		return {
			type: 1,
			field,
			targetSheetId,
			colIdx,
			rowIdx
		};
	}
	if (type === 2) {
		const [type, field, targetSheetId, startColIdx, endColIdx, rowIdx] = mapping;
		return {
			type,
			field,
			targetSheetId,
			startColIdx,
			endColIdx,
			rowIdx
		};
	}
	throw new InvariantError(`Unknown mapping-type passed: ${type}`);
}
var MFH_INVESTMENT_CASE_RENT_INDEX_INPUT_PATH, isMFHInvestmentCaseRentIndexMissingField, hasMFHInvestmentCaseRentIndexRows, MFH_INVESTMENT_CASE_WORST_BASE_BEST_SUFFIX_PATTERN, normalizeMFHInvestmentCaseInputPath, isMFHInvestmentCaseComputedInputPath, hasMFHInvestmentCaseComputedInputOverride, decodeVersion, packScalarMapping, packTableMapping, calculateNotaryFees, coerceTakeoverValue, mapSensitivityOutputsToCaseInputs, getMFHInvestmentCaseValueByPath, pickCandidateMfhInvestmentCase;
var init_mfh_investment_case_helpers = __esmMin((() => {
	init_errors();
	init_versions();
	init_helpers$2();
	init_mfh_investment_case_base();
	init_mfh_fee_tiers_helpers();
	MFH_INVESTMENT_CASE_RENT_INDEX_INPUT_PATH = "rent.rentIndex";
	isMFHInvestmentCaseRentIndexMissingField = (source, target) => source.startsWith("rentIndex.") || target?.includes("rent_roll_rent_index") === true;
	hasMFHInvestmentCaseRentIndexRows = (caseInputs) => Array.isArray(caseInputs?.rent?.rentIndex) && caseInputs.rent.rentIndex.length > 0;
	MFH_INVESTMENT_CASE_WORST_BASE_BEST_SUFFIX_PATTERN = /\.(base|best|worst)$/;
	normalizeMFHInvestmentCaseInputPath = (path) => path.replace(MFH_INVESTMENT_CASE_WORST_BASE_BEST_SUFFIX_PATTERN, "");
	isMFHInvestmentCaseComputedInputPath = (path) => Boolean(getMFHInvestmentCaseInputConfigForPath(normalizeMFHInvestmentCaseInputPath(path))?.computed);
	hasMFHInvestmentCaseComputedInputOverride = (path, computedOverrides) => computedOverrides.has(path) || computedOverrides.has(normalizeMFHInvestmentCaseInputPath(path));
	decodeVersion = (d2gVersion) => {
		const [versionPart, datePart] = d2gVersion.replace("v", "").split(" ");
		const [major, minor, patch] = versionPart.split(".");
		return {
			version: versionPart,
			major: +major,
			minor: +minor,
			patch: +patch,
			date: dayjs(datePart, "DD.MM.YY").toDate()
		};
	};
	packScalarMapping = (mapping) => {
		return [
			1,
			mapping.field,
			mapping.targetSheetId,
			mapping.colIdx,
			mapping.rowIdx
		];
	};
	packTableMapping = (mapping) => {
		return [
			2,
			mapping.field,
			mapping.targetSheetId,
			mapping.startColIdx,
			mapping.endColIdx,
			mapping.rowIdx
		];
	};
	calculateNotaryFees = (askingPrice, discount, multiplicator = 3, fixedCosts = 2549, minCosts = 20) => {
		if (askingPrice <= 0) throw new InvariantError(`Asking price must be greater than 0, cannot calculate notary-fees`);
		if (discount < 0 || discount > 1) throw new InvariantError(`Discount must be between 0.0 and 1.0, cannot calculate notary-fees`);
		const ranges = [
			[
				0,
				1,
				0,
				15
			],
			[
				501,
				500,
				4,
				15
			],
			[
				2001,
				1e3,
				6,
				27
			],
			[
				10001,
				3e3,
				8,
				75
			],
			[
				25001,
				5e3,
				10,
				115
			],
			[
				50001,
				15e3,
				27,
				165
			],
			[
				200001,
				3e4,
				50,
				435
			],
			[
				500001,
				5e4,
				80,
				935
			],
			[
				5000001,
				2e5,
				130,
				8135
			],
			[
				10000001,
				25e4,
				150,
				11385
			],
			[
				20000001,
				5e5,
				280,
				17385
			],
			[
				30000001,
				1e6,
				120,
				22985
			],
			[
				60000001,
				1,
				0,
				26585
			]
		];
		const amount = askingPrice * (1 - discount);
		if (amount <= 0) throw new InvariantError(`Amount is <= 0, cannot calculate notary-fees`);
		let n = 15;
		let oneRowValue;
		for (let index = 0; index <= ranges.length - 1; index++) if (amount >= ranges[index][0]) n = Math.ceil((amount - ranges[index][0] + 1) / ranges[index][1]) * ranges[index][2] + ranges[index][3];
		oneRowValue = n * multiplicator;
		if (oneRowValue < 20) oneRowValue = minCosts;
		return oneRowValue + fixedCosts;
	};
	coerceTakeoverValue = (config, value) => {
		if (value == null || !config || !("format" in config)) return value;
		switch (config.format) {
			case "boolean": {
				if (typeof value === "boolean") return value;
				const normalized = String(value).trim().toLowerCase();
				if (normalized === "true" || normalized === "yes") return true;
				if (normalized === "false" || normalized === "no") return false;
				return value;
			}
			case "number":
			case "percent":
			case "currency": {
				const parsed = typeof value === "number" ? value : Number(String(value).trim());
				if (!Number.isFinite(parsed)) return value;
				return config.integer ? Math.round(parsed) : parsed;
			}
			default: return typeof value === "string" ? value : String(value);
		}
	};
	mapSensitivityOutputsToCaseInputs = (version, currentCaseInputs, outputs) => {
		const caseInputs = cloneDeep(currentCaseInputs);
		const mappedInputs = [];
		const computedOutputPaths = new Set(Object.values(mfhInvestmentCaseComputedFields).map((def) => def.outputPath));
		for (const [calcengineKey, rawValue] of Object.entries(outputs)) {
			const path = getCalcEngineInputFieldPath(version, calcengineKey);
			if (!path) continue;
			const normalizedPath = normalizeMFHInvestmentCaseInputPath(path);
			const config = getMFHInvestmentCaseInputConfigForPath(normalizedPath);
			const value = coerceTakeoverValue(config, rawValue);
			mappedInputs.push({
				calcengineKey,
				path,
				value
			});
			set(caseInputs, path, value);
			if (computedOutputPaths.has(normalizedPath)) caseInputs.$computedOverrides = uniq([...caseInputs.$computedOverrides ?? [], normalizedPath]);
		}
		return {
			caseInputs,
			mappedInputs
		};
	};
	getMFHInvestmentCaseValueByPath = (ic, path) => {
		if (path.startsWith("$root.")) return get(ic, path.replace("$root.", ""));
		return get(ic.caseInputs, path);
	};
	pickCandidateMfhInvestmentCase = (candidateInvestmentCases, assetPartnerId) => {
		const relevantInvestmentCases = assetPartnerId == null ? candidateInvestmentCases : candidateInvestmentCases?.filter((ic) => ic.assetPartnerId === assetPartnerId);
		return maxBy(relevantInvestmentCases?.filter((ic) => ic.status === "Approved"), "mfhInvestmentCaseId") ?? relevantInvestmentCases?.find((ic) => ic.isPrimaryCase);
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/calculations/helpers.ts
var resolveCondoAcquisitionServiceFee, shouldClearCondoAcquisitionServiceFee, resolverReneoSalesFee, shouldClearReneoSalesFee, mfhInvestmentCaseComputedFields;
var init_helpers$2 = __esmMin((() => {
	init_energy_efficiency();
	init_mfh_attributes_helpers();
	init_mfh_investment_case_helpers();
	init_mfh_fee_tiers_helpers();
	resolveCondoAcquisitionServiceFee = (ci) => {
		const ia = ci.investorAssumptions;
		return pickTierFee(ci.assumptions?.acquisitionType, ci.overview?.askingPrice, {
			onMarket: {
				lt25m: ia?.acquisitionFeeOnMarket_lt25m,
				gt25m: ia?.acquisitionFeeOnMarket_gt25m,
				gt75m: ia?.acquisitionFeeOnMarket_gt75m
			},
			offMarket: {
				lt25m: ia?.acquisitionFeeOffMarket_lt25m,
				gt25m: ia?.acquisitionFeeOffMarket_gt25m,
				gt75m: ia?.acquisitionFeeOffMarket_gt75m
			}
		});
	};
	shouldClearCondoAcquisitionServiceFee = (ci) => !isNil(resolveMFHFeeTierInputPath(ci.assumptions?.acquisitionType, ci.overview?.askingPrice, {
		onMarket: "investorAssumptions.acquisitionFeeOnMarket",
		offMarket: "investorAssumptions.acquisitionFeeOffMarket"
	})) && isNil(resolveCondoAcquisitionServiceFee(ci));
	resolverReneoSalesFee = (ci) => {
		const ia = ci.investorAssumptions;
		return pickTierFee(ci.assumptions?.exitType, ci.assumptions?.expectedExitVolume, {
			onMarket: {
				lt25m: ia?.salesFeeOnMarket_lt25m,
				gt25m: ia?.salesFeeOnMarket_gt25m,
				gt75m: ia?.salesFeeOnMarket_gt75m
			},
			offMarket: {
				lt25m: ia?.salesFeeOffMarket_lt25m,
				gt25m: ia?.salesFeeOffMarket_gt25m,
				gt75m: ia?.salesFeeOffMarket_gt75m
			}
		});
	};
	shouldClearReneoSalesFee = (ci) => !isNil(resolveMFHFeeTierInputPath(ci.assumptions?.exitType, ci.assumptions?.expectedExitVolume, {
		onMarket: "investorAssumptions.salesFeeOnMarket",
		offMarket: "investorAssumptions.salesFeeOffMarket"
	})) && isNil(resolverReneoSalesFee(ci));
	mfhInvestmentCaseComputedFields = {
		combinedAddress: {
			deps: [
				"location.streetNames",
				"location.houseNo",
				"location.postcode",
				"location.city"
			],
			fn: (ci) => ({
				value: `${ci.location?.streetNames} ${ci.location?.houseNo}, ${ci.location?.postcode} ${ci.location?.city}`,
				isFormula: false
			})
		},
		assetViewed: {
			deps: ["assumptions.assetViewed"],
			outputPath: "assumptions.assetViewed",
			fn: (ci) => !isNil(ci.assumptions?.assetViewed) ? {
				value: dayjs(ci.assumptions.assetViewed).startOf("day").toDate(),
				isFormula: false,
				numberFormat: { type: "DATE" }
			} : {
				value: dayjs().startOf("day").toDate(),
				isFormula: false,
				numberFormat: { type: "DATE" }
			}
		},
		entryDate: {
			deps: ["assumptions.entryDate"],
			outputPath: "assumptions.entryDate",
			fn: (ci) => !isNil(ci.assumptions?.entryDate) ? {
				value: dayjs(ci.assumptions.entryDate).startOf("day").toDate(),
				isFormula: false,
				numberFormat: { type: "DATE" }
			} : {
				value: dayjs().add(3, "month").endOf("month").startOf("day").toDate(),
				isFormula: false,
				numberFormat: { type: "DATE" }
			}
		},
		notaryCosts: {
			deps: ["assumptions.expectedPurchaseDiscount", "overview.askingPrice"],
			outputPath: "assumptions.notaryCosts",
			fn: (ci) => {
				if (!isNil(ci.assumptions?.expectedPurchaseDiscount) && !isNil(ci.overview?.askingPrice)) return {
					value: calculateNotaryFees(ci.overview.askingPrice, ci.assumptions.expectedPurchaseDiscount),
					isFormula: false
				};
				return {
					value: "",
					isFormula: false
				};
			}
		},
		reneoPurchasingServiceFee: {
			deps: [
				"overview.askingPrice",
				"assumptions.acquisitionType",
				"investorAssumptions.acquisitionFeeOnMarket_lt25m",
				"investorAssumptions.acquisitionFeeOnMarket_gt25m",
				"investorAssumptions.acquisitionFeeOnMarket_gt75m",
				"investorAssumptions.acquisitionFeeOffMarket_lt25m",
				"investorAssumptions.acquisitionFeeOffMarket_gt25m",
				"investorAssumptions.acquisitionFeeOffMarket_gt75m"
			],
			outputPath: "investorAssumptions.reneoPurchasingServiceFee",
			shouldRecalculate: (ci) => !isNil(resolveCondoAcquisitionServiceFee(ci)),
			shouldClear: shouldClearCondoAcquisitionServiceFee,
			fn: (ci) => {
				return {
					value: resolveCondoAcquisitionServiceFee(ci),
					isFormula: false
				};
			}
		},
		reneoSalesFee: {
			deps: [
				"assumptions.expectedExitVolume",
				"assumptions.exitType",
				"investorAssumptions.salesFeeOnMarket_lt25m",
				"investorAssumptions.salesFeeOnMarket_gt25m",
				"investorAssumptions.salesFeeOnMarket_gt75m",
				"investorAssumptions.salesFeeOffMarket_lt25m",
				"investorAssumptions.salesFeeOffMarket_gt25m",
				"investorAssumptions.salesFeeOffMarket_gt75m"
			],
			outputPath: "investorAssumptions.reneoSalesFee",
			shouldRecalculate: (ci) => !isNil(resolverReneoSalesFee(ci)),
			shouldClear: shouldClearReneoSalesFee,
			fn: (ci) => {
				return {
					value: resolverReneoSalesFee(ci),
					isFormula: false
				};
			}
		},
		askingPriceSqm: {
			deps: [
				"overview.commercialSpaceSqm",
				"overview.resiSpaceSqm",
				"overview.askingPrice"
			],
			outputPath: "overview.askingPriceSqm",
			fn: (ci) => {
				return {
					value: COMPUTED_MFH_ATTRS.totalPricePerSQM.fn({
						askingPrice: ci.overview?.askingPrice,
						residentialSpace: ci.overview?.resiSpaceSqm,
						commercialSpace: ci.overview?.commercialSpaceSqm
					}),
					isFormula: false
				};
			}
		},
		commercialSpacePriceSqm: {
			deps: ["overview.askingPrice", "overview.commercialSpaceSqm"],
			outputPath: "overview.commercialSpacePriceSqm",
			fn: (ci) => {
				return {
					value: COMPUTED_MFH_ATTRS.commercialSpacePricePerSQM.fn({
						askingPrice: ci.overview?.askingPrice,
						commercialSpace: ci.overview?.commercialSpaceSqm
					}),
					isFormula: false
				};
			}
		},
		resiSpacePriceSqm: {
			deps: ["overview.askingPrice", "overview.resiSpaceSqm"],
			outputPath: "overview.resiSpacePriceSqm",
			fn: (ci) => {
				return {
					value: COMPUTED_MFH_ATTRS.residentialPricePerSQM.fn({
						askingPrice: ci.overview?.askingPrice,
						livingSpace: ci.overview?.resiSpaceSqm
					}),
					isFormula: false
				};
			}
		},
		jnkmTotalCurrent: {
			deps: [
				"rent.jnkmCommercialCurrent",
				"rent.jnkmParkingSpacesCurrent",
				"overview.rentResidentialCurrent"
			],
			outputPath: "rent.jnkmTotalCurrent",
			fn: (ci) => {
				return {
					value: COMPUTED_MFH_ATTRS.totalRentYearly.fn({
						residentialRent: ci.overview?.rentResidentialCurrent,
						commercialRent: ci.rent?.jnkmCommercialCurrent,
						parkingSpaceRent: ci.rent?.jnkmParkingSpacesCurrent,
						totalRent: void 0
					}),
					isFormula: false
				};
			}
		},
		rentResidentialCurrentSqm: {
			deps: [
				"overview.resiSpaceSqm",
				"overview.rentResidentialCurrent",
				"rent.resiOccupancyActual"
			],
			outputPath: "overview.rentResidentialCurrentSqm",
			fn: (ci) => {
				const value = COMPUTED_MFH_ATTRS.residentialRentPerSQMYearly.fn({
					occupancyRate: ci.rent?.resiOccupancyActual,
					residentialRent: ci.overview?.rentResidentialCurrent,
					livingSpace: ci.overview?.resiSpaceSqm
				});
				return {
					value: isNil(value) ? null : value / 12,
					isFormula: false
				};
			}
		},
		factorOnAskingPrice: {
			deps: ["rent.jnkmTotalCurrent", "overview.askingPrice"],
			outputPath: "overview.factorOnAskingPrice",
			fn: (ci) => {
				return {
					value: COMPUTED_MFH_ATTRS.multiple.fn({
						askingPrice: ci.overview?.askingPrice,
						yearlyRentTotal: ci.rent?.jnkmTotalCurrent
					}),
					isFormula: false
				};
			}
		},
		shareOfCommercialSpacePercent: {
			deps: ["overview.resiSpaceSqm", "overview.commercialSpaceSqm"],
			outputPath: "overview.shareOfCommercialSpacePercent",
			fn: (ci) => {
				return {
					value: COMPUTED_MFH_ATTRS.shareOfCommercialSpace.fn({
						livingSpace: ci.overview?.resiSpaceSqm,
						commercialSpace: ci.overview?.commercialSpaceSqm
					}),
					isFormula: false
				};
			}
		},
		avgSizeResidentialSqm: {
			deps: ["overview.resiUnits", "overview.resiSpaceSqm"],
			outputPath: "overview.avgSizeResidentialSqm",
			fn: (ci) => {
				return {
					value: COMPUTED_MFH_ATTRS.avgSizeOfApartment.fn({
						livingSpace: ci.overview?.resiSpaceSqm,
						estimatedNumberOfApartments: ci.overview?.resiUnits,
						buildings: void 0
					}),
					isFormula: false
				};
			}
		},
		avgSizeCommercialSqm: {
			deps: ["overview.commercialUnits", "overview.commercialSpaceSqm"],
			outputPath: "overview.avgSizeCommercialSqm",
			fn: (ci) => {
				return {
					value: COMPUTED_MFH_ATTRS.avgSizeOfCommercial.fn({
						commercialSpaceSqm: ci.overview?.commercialSpaceSqm,
						commercialUnits: ci.overview?.commercialUnits
					}),
					isFormula: false
				};
			}
		},
		endEnergyConsumptionClass: {
			deps: ["buildingTechnical.endEnergyConsumptionKWhSqm"],
			outputPath: "buildingTechnical.endEnergyConsumptionClass",
			fn: (ci) => {
				return {
					value: !isNil(ci.buildingTechnical?.endEnergyConsumptionKWhSqm) ? convertEnergyConsumptionToEnergyConsumptionCategory(ci.buildingTechnical.endEnergyConsumptionKWhSqm) : void 0,
					isFormula: false
				};
			}
		},
		endEnergyConsumptionClassPostRenovation: {
			deps: ["bestWorst.epcRatingInKWHPostRenovation.base"],
			outputPath: "buildingTechnical.endEnergyConsumptionClassPostRenovation",
			fn: (ci) => {
				return {
					value: !isNil(ci.bestWorst?.epcRatingInKWHPostRenovation?.base) ? convertEnergyConsumptionToEnergyConsumptionCategory(ci.bestWorst?.epcRatingInKWHPostRenovation?.base) : void 0,
					isFormula: false
				};
			}
		},
		numberOfResidentialUnitsForIndividualMeasure: {
			deps: ["overview.resiUnits"],
			outputPath: "assumptions.numberOfResidentialUnitsForIndividualMeasure",
			/** Must not read the output field — otherwise prune/override and sheet `computed.*` resolution see a false "match" to the current cell. */
			fn: (ci) => {
				return {
					value: ci.overview?.resiUnits,
					isFormula: false
				};
			}
		},
		subsidizedCapexLoanMaturityDate: {
			deps: ["assumptions.entryDate", "assumptions.energyEfficiencyStart"],
			outputPath: "assumptions.subsidizedCapexLoanMaturityDate",
			fn: (ci) => {
				if (isNil(ci.assumptions.entryDate) || isNil(ci.assumptions.energyEfficiencyStart)) return {
					value: void 0,
					isFormula: false
				};
				return {
					value: dayjs(ci.assumptions.entryDate).add(10, "years").add(ci.assumptions.energyEfficiencyStart, "months").toDate(),
					isFormula: false
				};
			}
		}
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/asset-partner-ic-profile/asset-partner-ic-profile-schema.ts
var MFH_PARTNER_PROFILE_ASSUMPTIONS_FIELDS, MFH_GLOBAL_INVESTOR_ASSUMPTIONS_FIELDS, PARTNER_PROFILE_ASSUMPTIONS_FIELDS, GLOBAL_INVESTOR_ASSUMPTIONS_FIELDS, isMFHPartnerProfileInputPath, isMFHPartnerIdentityInputPath, isMFHProfileSpecificInputPath, getMFHPartnerProfileInputPath, getMFHPartnerProfileConfigKey, mfhAssetPartnerProfileFormConfig, projectMFHAssetPartnerProfileConfig, mapMFHAssetPartnerProfileConfigToCaseInputs, MFH_INPUT_META_KEYS, partitionMFHInvestmentCaseInputs, withoutStaleMFHPartnerProfileInputs, replaceMFHPartnerProfileInputs;
var init_asset_partner_ic_profile_schema = __esmMin((() => {
	init_mfh_investment_case_base();
	MFH_PARTNER_PROFILE_ASSUMPTIONS_FIELDS = [
		"condoLettingFeesResi",
		"condoLettingFeesCommercial",
		"capexNonSubsidizedDebtUpfrontFee",
		"capexNonSubsidizedDebtRunningAm",
		"capexNonSubsidizedDebtAMStartMonth"
	];
	MFH_GLOBAL_INVESTOR_ASSUMPTIONS_FIELDS = ["standardRentLossInOfNRI", "developmentRentLossInPercentageNRI"];
	PARTNER_PROFILE_ASSUMPTIONS_FIELDS = new Set(MFH_PARTNER_PROFILE_ASSUMPTIONS_FIELDS);
	GLOBAL_INVESTOR_ASSUMPTIONS_FIELDS = new Set(MFH_GLOBAL_INVESTOR_ASSUMPTIONS_FIELDS);
	isMFHPartnerProfileInputPath = (path) => {
		const [section, field] = path.split(".");
		if (!field) return false;
		if (section === "investorAssumptions") return !GLOBAL_INVESTOR_ASSUMPTIONS_FIELDS.has(field);
		if (section === "assumptions") return PARTNER_PROFILE_ASSUMPTIONS_FIELDS.has(field);
		return false;
	};
	isMFHPartnerIdentityInputPath = (path) => path === "d2gSettings.investor" || path.startsWith("$root.assetPartnerProfile");
	isMFHProfileSpecificInputPath = (path) => isMFHPartnerProfileInputPath(path) || isMFHPartnerIdentityInputPath(path);
	getMFHPartnerProfileInputPath = (configKey) => PARTNER_PROFILE_ASSUMPTIONS_FIELDS.has(configKey) ? `assumptions.${configKey}` : `investorAssumptions.${configKey}`;
	getMFHPartnerProfileConfigKey = (path) => path.slice(path.indexOf(".") + 1);
	mfhAssetPartnerProfileFormConfig = {
		...omit(mfhInvestmentCaseAssetPartnerInputsFormConfig, MFH_GLOBAL_INVESTOR_ASSUMPTIONS_FIELDS),
		...pick(mfhInvestmentCaseInputsFormConfig.assumptions, MFH_PARTNER_PROFILE_ASSUMPTIONS_FIELDS)
	};
	projectMFHAssetPartnerProfileConfig = (config) => omit(config, MFH_GLOBAL_INVESTOR_ASSUMPTIONS_FIELDS);
	mapMFHAssetPartnerProfileConfigToCaseInputs = (config) => {
		const projected = projectMFHAssetPartnerProfileConfig(config);
		return {
			investorAssumptions: omit(projected, MFH_PARTNER_PROFILE_ASSUMPTIONS_FIELDS),
			assumptions: pick(projected, MFH_PARTNER_PROFILE_ASSUMPTIONS_FIELDS)
		};
	};
	MFH_INPUT_META_KEYS = ["$inputOrigins", "$computedOverrides"];
	partitionMFHInvestmentCaseInputs = (inputs, isMatch) => {
		const matched = {};
		const rest = {};
		for (const [section, value] of Object.entries(inputs ?? {})) {
			if (MFH_INPUT_META_KEYS.includes(section) || !isPlainObject(value)) {
				rest[section] = value;
				continue;
			}
			const isMatching = (_value, field) => isMatch(`${section}.${field}`);
			const matchedFields = pickBy(value, isMatching);
			const restFields = omitBy(value, isMatching);
			if (!isEmpty(matchedFields)) matched[section] = matchedFields;
			if (!isEmpty(restFields)) rest[section] = restFields;
		}
		return {
			matched,
			rest
		};
	};
	withoutStaleMFHPartnerProfileInputs = (caseInputs, profileInputs) => {
		const kept = pickBy(pick(caseInputs.assumptions ?? {}, MFH_PARTNER_PROFILE_ASSUMPTIONS_FIELDS), (value, field) => !isNil(value) && isNil(profileInputs.assumptions?.[field]));
		const stripped = partitionMFHInvestmentCaseInputs(structuredClone(caseInputs), isMFHPartnerProfileInputPath).rest;
		return Object.keys(kept).length > 0 ? merge(stripped, { assumptions: kept }) : stripped;
	};
	replaceMFHPartnerProfileInputs = (caseInputs, profileInputs) => merge(withoutStaleMFHPartnerProfileInputs(caseInputs, profileInputs), profileInputs);
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/mfh-investment-case-input-origins.ts
var MFHInvestmentCaseInputOrigin, MFH_INVESTMENT_CASE_INPUT_ORIGINS_KEY, MFH_INVESTMENT_CASE_INPUT_META_KEYS, isMFHInvestmentCaseInputOriginPath, collectMFHInvestmentCaseInputPaths, assignMFHInvestmentCaseInputOrigins, buildMFHInvestmentCaseInputOrigins, buildMFHInvestmentCaseSourceOriginLayers, filterMFHInvestmentCaseInputPatchByVersion, applyScenarioPatchToCaseInputs, markEditedMFHInvestmentCaseInputOrigins, collectOverriddenMFHInvestmentCaseInputPaths, clearMFHInvestmentCaseInputOrigins, MFH_INVESTMENT_CASE_INPUT_ORIGIN_BY_ANALYZER_SOURCE, resolveMFHInvestmentCaseInputOriginFromSource, buildOriginBySourcePath, MFH_INVESTMENT_CASE_SCENARIO_ORIGINS, collectMFHInvestmentCaseInputPathsByOrigin, applyMFHInvestmentCaseInputOriginsFromSources, buildOverriddenMFHInvestmentCaseInputOrigins, ANALYZER_SOURCES_ALLOWED_TO_DISPLACE_SCENARIO, buildAnalyzerSourceByPath, withoutMFHInvestmentCaseScenarioOwnedOverrides, pruneMFHInvestmentCaseInputOrigins, getMFHInvestmentCaseInputOrigin;
var init_mfh_investment_case_input_origins = __esmMin((() => {
	init_asset_partner_ic_profile_schema();
	init_mfh_investment_case_base();
	init_mfh_investment_case_helpers();
	MFHInvestmentCaseInputOrigin = /* @__PURE__ */ function(MFHInvestmentCaseInputOrigin) {
		/** Prefilled from the MFH / asset record. */
		MFHInvestmentCaseInputOrigin["Asset"] = "ASSET";
		/** Prefilled from the global section of the investment-case config. */
		MFHInvestmentCaseInputOrigin["GlobalDefault"] = "GLOBAL_DEFAULT";
		/** Prefilled from the asset-partner IC profile (see `isMFHPartnerProfileInputPath`). */
		MFHInvestmentCaseInputOrigin["PartnerProfile"] = "PARTNER_PROFILE";
		/** Pre-defined renovation-strategy scenario (COR-1591). */
		MFHInvestmentCaseInputOrigin["RenovationStrategyScenario"] = "RENOVATION_STRATEGY_SCENARIO";
		/** Calculated CAPEX/EE renovation scenario linked to the case (SKB-1072). */
		MFHInvestmentCaseInputOrigin["CalculatedRenovationScenario"] = "CALCULATED_RENOVATION_SCENARIO";
		/** Model-predicted value (ML rent prediction, accepted analyzer suggestion). */
		MFHInvestmentCaseInputOrigin["Predicted"] = "PREDICTED";
		/** Constant the asset analyzer fell back to because no source produced a value for the path. */
		MFHInvestmentCaseInputOrigin["AnalyzerDefault"] = "ANALYZER_DEFAULT";
		/**
		* Written by the level-1 preoptimization sweep (SKB-1156): the fixed rules screening applies to a
		* case's switches before judging it, and that the automatic Shared Base replays so it states the
		* same settings its children were screened with.
		*/
		MFHInvestmentCaseInputOrigin["Preoptimization"] = "PREOPTIMIZATION";
		/**
		* Applied by the second-order optimization agent: a run the user drove in the Investment Case Agent
		* chat and then confirmed for this case.
		*
		* Unlike {@link MFHInvestmentCaseInputOrigin.Preoptimization}, which screening replays onto the
		* Shared Base and every child, this lands on the single case the chat was pinned to — the sibling
		* children and the base keep whatever they had.
		*/
		MFHInvestmentCaseInputOrigin["Optimization"] = "OPTIMIZATION";
		/** A sensitivity scenario (one-way / two-way row or cell, or an Auto Mode winner) the user took over for this case. */
		MFHInvestmentCaseInputOrigin["Sensitivity"] = "SENSITIVITY";
		/** Entered or overwritten by a user. */
		MFHInvestmentCaseInputOrigin["ManualEdit"] = "MANUAL_EDIT";
		return MFHInvestmentCaseInputOrigin;
	}({});
	MFH_INVESTMENT_CASE_INPUT_ORIGINS_KEY = "$inputOrigins";
	MFH_INVESTMENT_CASE_INPUT_META_KEYS = /* @__PURE__ */ new Set([
		"$root",
		"$computedOverrides",
		MFH_INVESTMENT_CASE_INPUT_ORIGINS_KEY
	]);
	isMFHInvestmentCaseInputOriginPath = (path) => path === "$inputOrigins" || path.startsWith(`\$inputOrigins.`);
	collectMFHInvestmentCaseInputPaths = (inputs) => {
		if (!inputs || typeof inputs !== "object") return [];
		const paths = [];
		for (const [section, sectionValue] of Object.entries(inputs)) {
			if (MFH_INVESTMENT_CASE_INPUT_META_KEYS.has(section) || isNil(sectionValue) || typeof sectionValue !== "object" || Array.isArray(sectionValue)) continue;
			for (const [field, fieldValue] of Object.entries(sectionValue)) {
				if (isNil(fieldValue)) continue;
				paths.push(`${section}.${field}`);
			}
		}
		return paths;
	};
	assignMFHInvestmentCaseInputOrigins = (origins, paths, origin) => {
		const next = { ...origins };
		for (const path of paths) next[path] = origin;
		return next;
	};
	buildMFHInvestmentCaseInputOrigins = (layers, base = {}) => layers.reduce((origins, layer) => assignMFHInvestmentCaseInputOrigins(origins, collectMFHInvestmentCaseInputPaths(layer.inputs), layer.origin), { ...base });
	buildMFHInvestmentCaseSourceOriginLayers = (configInputs, mfhInputs) => {
		const { matched, rest } = partitionMFHInvestmentCaseInputs(configInputs, isMFHPartnerProfileInputPath);
		return [
			{
				origin: "GLOBAL_DEFAULT",
				inputs: rest
			},
			{
				origin: "PARTNER_PROFILE",
				inputs: matched
			},
			{
				origin: "ASSET",
				inputs: mfhInputs
			}
		];
	};
	filterMFHInvestmentCaseInputPatchByVersion = (patch, d2gVersion) => {
		const { version } = decodeVersion(d2gVersion);
		const filtered = structuredClone(patch);
		for (const path of collectMFHInvestmentCaseInputPaths(patch)) {
			const inputConfig = getMFHInvestmentCaseInputConfigForPath(path);
			if (!inputConfig || isMFHInvestmentCaseInputActiveForVersion(inputConfig, version)) continue;
			unset(filtered, path);
		}
		for (const [section, sectionValue] of Object.entries(filtered)) if (isPlainObject(sectionValue) && Object.keys(sectionValue).length === 0) Reflect.deleteProperty(filtered, section);
		return filtered;
	};
	applyScenarioPatchToCaseInputs = (caseInputs, scenarioPatch, origin) => {
		const nextCaseInputs = merge({}, caseInputs, scenarioPatch);
		nextCaseInputs.$inputOrigins = assignMFHInvestmentCaseInputOrigins(nextCaseInputs.$inputOrigins ?? {}, collectMFHInvestmentCaseInputPaths(scenarioPatch), origin);
		return nextCaseInputs;
	};
	markEditedMFHInvestmentCaseInputOrigins = ({ origins, currentInputs, nextInputs, skipPaths, origin = "MANUAL_EDIT" }) => {
		const skipped = new Set(skipPaths ?? []);
		const computedOverrides = new Set((nextInputs?.$computedOverrides ?? []).filter((path) => typeof path === "string"));
		const changedPaths = collectMFHInvestmentCaseInputPaths(nextInputs).filter((path) => !skipped.has(path) && (!isMFHInvestmentCaseComputedInputPath(path) || hasMFHInvestmentCaseComputedInputOverride(path, computedOverrides)) && !isEqual(get(currentInputs, path), get(nextInputs, path)));
		return assignMFHInvestmentCaseInputOrigins(origins, changedPaths, origin);
	};
	collectOverriddenMFHInvestmentCaseInputPaths = (baseline, merged, overrides) => collectMFHInvestmentCaseInputPaths(overrides).filter((path) => !isEqual(get(baseline, path), get(merged, path)));
	clearMFHInvestmentCaseInputOrigins = (origins, paths) => {
		const cleared = new Set(paths);
		return Object.fromEntries(Object.entries(origins).filter(([path]) => !cleared.has(path)));
	};
	MFH_INVESTMENT_CASE_INPUT_ORIGIN_BY_ANALYZER_SOURCE = {
		expose: "ASSET",
		rent_roll: "ASSET",
		energy_certificate: "ASSET",
		syte: "ASSET",
		rental_analysis: "ASSET",
		extracted: "ASSET",
		inferred: "ASSET",
		global_config: "GLOBAL_DEFAULT",
		partner_model: "PARTNER_PROFILE",
		config_strategy: "RENOVATION_STRATEGY_SCENARIO",
		user_strategy: "RENOVATION_STRATEGY_SCENARIO",
		custom_strategy: "CALCULATED_RENOVATION_SCENARIO",
		prediction: "PREDICTED",
		defaulted: "ANALYZER_DEFAULT",
		user: "MANUAL_EDIT"
	};
	resolveMFHInvestmentCaseInputOriginFromSource = (source) => source ? MFH_INVESTMENT_CASE_INPUT_ORIGIN_BY_ANALYZER_SOURCE[source] : void 0;
	buildOriginBySourcePath = (sources) => {
		const originByPath = /* @__PURE__ */ new Map();
		for (const [sourcePath, source] of Object.entries(sources)) {
			const origin = resolveMFHInvestmentCaseInputOriginFromSource(source);
			const path = normalizeMFHInvestmentCaseInputPath(sourcePath);
			originByPath.set(path, originByPath.has(path) && originByPath.get(path) !== origin ? void 0 : origin);
		}
		return originByPath;
	};
	MFH_INVESTMENT_CASE_SCENARIO_ORIGINS = ["RENOVATION_STRATEGY_SCENARIO", "CALCULATED_RENOVATION_SCENARIO"];
	collectMFHInvestmentCaseInputPathsByOrigin = (origins, wanted) => Object.entries(origins ?? {}).flatMap(([path, origin]) => wanted.includes(origin) ? [path] : []);
	applyMFHInvestmentCaseInputOriginsFromSources = (origins, paths, sources) => {
		const originBySourcePath = buildOriginBySourcePath(sources ?? {});
		const next = { ...origins };
		for (const path of paths) {
			const origin = originBySourcePath.get(path) ?? originBySourcePath.get(normalizeMFHInvestmentCaseInputPath(path));
			if (origin) next[path] = origin;
			else Reflect.deleteProperty(next, path);
		}
		return next;
	};
	buildOverriddenMFHInvestmentCaseInputOrigins = (baseline, merged, overrides) => {
		const baseOrigins = baseline?.$inputOrigins ?? {};
		const overriddenPaths = collectOverriddenMFHInvestmentCaseInputPaths(baseline, merged, overrides);
		return {
			...clearMFHInvestmentCaseInputOrigins(baseOrigins, overriddenPaths),
			...overrides?.$inputOrigins ?? {}
		};
	};
	ANALYZER_SOURCES_ALLOWED_TO_DISPLACE_SCENARIO = /* @__PURE__ */ new Set(["user", "user_strategy"]);
	buildAnalyzerSourceByPath = (sources) => {
		const sourceByPath = /* @__PURE__ */ new Map();
		for (const [sourcePath, source] of Object.entries(sources)) {
			const path = normalizeMFHInvestmentCaseInputPath(sourcePath);
			sourceByPath.set(path, sourceByPath.has(path) && sourceByPath.get(path) !== source ? void 0 : source);
		}
		return sourceByPath;
	};
	withoutMFHInvestmentCaseScenarioOwnedOverrides = (overrides, scenarioOwnedPaths, sources) => {
		const sourceByPath = buildAnalyzerSourceByPath(sources ?? {});
		const mayDisplaceScenarioOwned = (path) => {
			const source = sourceByPath.get(path) ?? sourceByPath.get(normalizeMFHInvestmentCaseInputPath(path));
			return source != null && ANALYZER_SOURCES_ALLOWED_TO_DISPLACE_SCENARIO.has(source);
		};
		const dropped = [...scenarioOwnedPaths].filter((path) => has(overrides, path) && !mayDisplaceScenarioOwned(path));
		if (dropped.length === 0) return overrides;
		const filtered = structuredClone(overrides);
		for (const path of dropped) unset(filtered, path);
		for (const [section, sectionValue] of Object.entries(filtered)) if (isPlainObject(sectionValue) && Object.keys(sectionValue).length === 0) Reflect.deleteProperty(filtered, section);
		return filtered;
	};
	pruneMFHInvestmentCaseInputOrigins = (origins, inputs) => {
		const livePaths = new Set(collectMFHInvestmentCaseInputPaths(inputs));
		return Object.fromEntries(Object.entries(origins).filter(([path]) => livePaths.has(path)));
	};
	getMFHInvestmentCaseInputOrigin = (caseInputs, path) => {
		const origins = caseInputs?.$inputOrigins;
		if (!origins) return;
		return origins[path] ?? origins[normalizeMFHInvestmentCaseInputPath(path)];
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/calculations/d2g/index.ts
var init_d2g = __esmMin((() => {
	init_calcengine_error_compact();
	init_d2g_calcengine_model();
	init_d2g_errors();
	init_input_formatters();
	init_parser_helpers();
	init_versions();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/validators/base.validator.ts
var base_validator_exports = /* @__PURE__ */ __exportAll({ validate: () => validate$3 });
function validate$3({ caseInputs }) {
	if (!caseInputs?.overview?.resiSpaceSqm) throw new D2GSheetMissingDatapointError("resiSpaceSqm");
	if (isNil(caseInputs.assumptions?.entryDate)) throw new D2GSheetMissingDatapointError("entryDate");
}
var init_base_validator = __esmMin((() => {
	init_d2g();
	__name(validate$3, "validate");
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/validators/reneo-fee-tier.validator.ts
var reneo_fee_tier_validator_exports = /* @__PURE__ */ __exportAll({
	collectMissingReneoFeeTierInputs: () => collectMissingReneoFeeTierInputs,
	validate: () => validate$2
});
function validate$2({ caseInputs, version, isBaseCase }) {
	if (isBaseCase) return;
	const missingReneoFeeTierInputs = collectMissingReneoFeeTierInputs(caseInputs, version).map(({ source, computedPath }) => ({
		source,
		target: computedPath
	}));
	if (missingReneoFeeTierInputs.length) throw new D2GSheetMissingDatapointsError(missingReneoFeeTierInputs);
}
var RENEO_PURCHASING_SERVICE_FEE_PATH, RENEO_SALES_FEE_PATH, isMFHInvestmentCaseInputPathActiveForVersion, shouldValidateReneoFeeTierInput, collectMissingReneoFeeTierInputs;
var init_reneo_fee_tier_validator = __esmMin((() => {
	init_mfh_fee_tiers_helpers();
	init_d2g_errors();
	init_mfh_investment_case_base();
	RENEO_PURCHASING_SERVICE_FEE_PATH = "investorAssumptions.reneoPurchasingServiceFee";
	RENEO_SALES_FEE_PATH = "investorAssumptions.reneoSalesFee";
	isMFHInvestmentCaseInputPathActiveForVersion = (path, version) => isMFHInvestmentCaseInputActiveForVersion(getMFHInvestmentCaseInputConfigForPath(path), version);
	shouldValidateReneoFeeTierInput = (computedPath, sourcePath, version) => !!sourcePath && isMFHInvestmentCaseInputPathActiveForVersion(computedPath, version) && isMFHInvestmentCaseInputPathActiveForVersion(sourcePath, version);
	collectMissingReneoFeeTierInputs = (caseInputs, version) => {
		const inputSource = caseInputs ?? {};
		const computedOverrides = new Set(inputSource.$computedOverrides ?? []);
		const missingInputs = [];
		const purchasingSource = resolveMFHFeeTierInputPath(inputSource.assumptions?.acquisitionType, inputSource.overview?.askingPrice, {
			onMarket: "investorAssumptions.acquisitionFeeOnMarket",
			offMarket: "investorAssumptions.acquisitionFeeOffMarket"
		});
		if (shouldValidateReneoFeeTierInput(RENEO_PURCHASING_SERVICE_FEE_PATH, purchasingSource, version) && !computedOverrides.has(RENEO_PURCHASING_SERVICE_FEE_PATH) && isNil(get(inputSource, purchasingSource))) missingInputs.push({
			source: purchasingSource,
			computedPath: RENEO_PURCHASING_SERVICE_FEE_PATH
		});
		const salesSource = resolveMFHFeeTierInputPath(inputSource.assumptions?.exitType, inputSource.assumptions?.expectedExitVolume, {
			onMarket: "investorAssumptions.salesFeeOnMarket",
			offMarket: "investorAssumptions.salesFeeOffMarket"
		});
		if (shouldValidateReneoFeeTierInput(RENEO_SALES_FEE_PATH, salesSource, version) && !computedOverrides.has(RENEO_SALES_FEE_PATH) && isNil(get(inputSource, salesSource))) missingInputs.push({
			source: salesSource,
			computedPath: RENEO_SALES_FEE_PATH
		});
		return missingInputs;
	};
	__name(validate$2, "validate");
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/validators/rent-roll.validator.ts
var rent_roll_validator_exports = /* @__PURE__ */ __exportAll({ validate: () => validate$1 });
function validateRentRollInvariants(rentRolls, entryDate) {
	if (!rentRolls?.length) return;
	if (isNil(entryDate)) throw new D2GSheetMissingDatapointError("entryDate");
	for (let i = 0; i < rentRolls.length; i++) {
		const rr = rentRolls[i];
		const expected = i + 1;
		const actual = rr.apartmentNumber;
		if (actual !== expected) throw new InvariantError(`Rent roll apartment numbers must be a gap-free sequence starting at 1, but found apartment number ${actual} at position ${expected}`);
		if (rr.rentalContractEndDate && dayjs(rr.rentalContractEndDate).isBefore(entryDate, "day")) throw new InvariantError(`Rent roll #${rr.apartmentNumber} has rentalContractEndDate (${rr.rentalContractEndDate ? formatDate$1(rr.rentalContractEndDate, DateFormats.SimpleDate) : "[empty]"}) before entry date (${formatDate$1(entryDate, DateFormats.SimpleDate)}) - the apartment would be unrented at acquisition. Please remove it from rent roll`);
		if (rr.lastRentIncreaseDate && dayjs(rr.lastRentIncreaseDate).isAfter(entryDate, "day")) throw new InvariantError(`Rent roll #${rr.apartmentNumber} has lastRentIncreaseDate (${rr.lastRentIncreaseDate ? formatDate$1(rr.lastRentIncreaseDate, DateFormats.SimpleDate) : "[empty]"}) after entry date (${formatDate$1(entryDate, DateFormats.SimpleDate)}) - last rent-increases can only be BEFORE the entry-date. Please adjust it in the rent roll`);
		if (isNil(rr.rentIncreaseType)) throw new InvariantError(`Rent roll #${rr.apartmentNumber} has no rentIncreaseType - this is required. Please adjust it in the rent roll`);
	}
}
function validate$1({ caseInputs, rentRolls }) {
	validateRentRollInvariants(rentRolls, caseInputs?.assumptions?.entryDate);
}
var init_rent_roll_validator = __esmMin((() => {
	init_errors();
	init_src();
	__name(validate$1, "validate");
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/validators/index.ts
function validateMFHInvestmentCaseInputs(caseInputs, version, rentRolls, isBaseCase) {
	for (const validator of validators) validator.validate({
		caseInputs,
		version,
		rentRolls,
		isBaseCase
	});
}
var validators;
var init_validators = __esmMin((() => {
	init_base_validator();
	init_reneo_fee_tier_validator();
	init_rent_roll_validator();
	validators = [
		base_validator_exports,
		rent_roll_validator_exports,
		reneo_fee_tier_validator_exports
	];
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/mfh-investment-case.class.ts
function resolveComputedDefForPath(path) {
	const direct = COMPUTED_DEF_BY_OUTPUT_PATH.get(path);
	if (direct) return direct;
	return COMPUTED_DEF_BY_OUTPUT_PATH.get(normalizeMFHInvestmentCaseInputPath(path));
}
var COMPUTED_DEF_BY_OUTPUT_PATH, MFHInvestmentCase;
var init_mfh_investment_case_class = __esmMin((() => {
	init_errors();
	init_document_model();
	init_helpers$2();
	init_mfh_investment_case_base();
	init_mfh_investment_case_input_origins();
	init_mfh_investment_case_helpers();
	init_validators();
	COMPUTED_DEF_BY_OUTPUT_PATH = new Map(Object.values(mfhInvestmentCaseComputedFields).filter((d) => Boolean(d.outputPath)).map((d) => [d.outputPath, d]));
	MFHInvestmentCase = class MFHInvestmentCase {
		static LEGACY_OUTPUT_FIELDS = [
			"gri",
			"cfEngine",
			"transformation",
			"postTransformation",
			"condoFees",
			"statusQuo",
			"assumptions",
			"irr",
			"debt",
			"investmentCaseOutput",
			"outputErrors"
		];
		static CONVERTED_SHEETS = [
			"sheetsSubsidies",
			"sheetsInputRentRoll",
			"sheetsOutputRentRoll",
			"sheetsGri",
			"sheetsCfEngine",
			"sheetsHelpers",
			"sheetsPromote",
			"sheetsPLTax",
			"sheetsICCharts",
			"sheetsInvestMemo",
			"sheetsRcsOutputs"
		];
		EMBEDDING_BLOCKS_BY_RANGE = {
			AnnualCashflow: {
				">=5.3.0": "BD131:CC199",
				">=5.2.0 <5.3.0": "BE120:CC188",
				">=5.1.3 <5.2.0": "BE121:CC183",
				">=4.0.0 <5.1.3": "BE116:CC177",
				"<4.0.0": "BE111:BS175"
			},
			RentalTables: {
				">=5.3.0": "HK412:JV488",
				">=5.2.0 <5.3.0": "HK401:JV477",
				">=5.1.3 <5.2.0": "HK387:JV463",
				">=4.0.0 <5.1.3": "HK380:JV456",
				"<4.0.0": "GQ378:HN454"
			}
		};
		/**
		* some settings shall never be changed, they are defined on top-level of the IC
		*
		* When merging the configInputs, always have the the fixed-inputs from the getter fixedInputs LAST
		*/
		static FIXED_INPUT_PATHS = ["d2gSettings.exitApproach", "general.exitApproach"];
		/** Paths excluded from input-change events (same as fixed inputs). */
		static getInputChangeIgnoredPaths() {
			return new Set(MFHInvestmentCase.FIXED_INPUT_PATHS);
		}
		static getInputHistoryIgnoredPaths() {
			return MFHInvestmentCase.getInputChangeIgnoredPaths();
		}
		static CALCENGINE_COMPAT_MATRIX = {
			a_out_invest_memo: ">=5.6.0",
			b_out_ic_charts: ">=5.6.0",
			a_cal_cf_engine: ">=5.4.1",
			b_cal_gri: ">=5.4.1",
			c_cal_p_l_tax_engine: ">=5.5.0",
			d_cal_promote_and_irr: ">=5.5.0",
			e_cal_output_rent_roll: ">=5.3.2",
			f_cal_input_rent_roll: ">=5.3.2",
			g_cal_sensitivity: "",
			h_cal_subsidies: ">=5.0.0",
			i_out_rcs_outputs: ">=5.6.0",
			a_crm_input: "",
			b_crm_console: ""
		};
		static FEATURESET_COMPAT_MATRIX = {
			["BlockBasedWriter"]: ">=5.4.0",
			["BlockBasedParser"]: ">=5.3.2",
			["D2GRentRollImport"]: ">=5.3.2",
			["XLSXExportable"]: ">=5.3.0",
			["LegacyXLSXExportable"]: ">3.0.0 <5.3.0",
			["InvestorAssumptionsInSheet"]: "<4.2.0",
			["RentIndex"]: ">=3.0.0",
			["TypedCalcEngineOutputs"]: ">=5.4.1",
			["FullConversion"]: ">=5.6.0",
			["InvestmentCaseVersioning"]: ">=5.6.0",
			["SheetOverrides"]: ">=5.6.0"
		};
		mfhInvestmentCaseId;
		mfhId;
		name;
		mfhPredictionId;
		assetPartnerId;
		assetPartnerProfileId;
		assetPartnerProfileVersionId;
		configId;
		createdBy;
		status;
		d2gVersionId;
		investmentCaseType;
		parentMfhInvestmentCaseId;
		validFrom;
		d2gVersion;
		referenceD2gSheetId;
		selfSheetId;
		publishId;
		readCopySheetId;
		isPrimaryCase;
		isSharedWithAssetPartner;
		/** When true this is a throwaway "base" draft holding only inputs common to a batch; never appears in the normal IC overview. */
		isBaseCase;
		meta;
		sheetInfo;
		readCopySheetInfo;
		rentRollVersionId;
		mfhEnergyEfficiencyScenarioId;
		/**
		* Pinned catalogue renovation strategy. Direct user link when no custom CAPEX EE scenario is linked;
		* the inherited catalogue archetype when {@link mfhEnergyEfficiencyScenarioId} is set (SKB-1151 / SKB-1283).
		*/
		renovationScenarioId;
		/** Config version of {@link renovationScenarioId} applied to this case. */
		renovationScenarioConfigVersion;
		caseInputs;
		caseInputsSnapshot;
		/** Legacy DB field; new revision previews use investment-case versions instead. */
		inputHistory;
		outputErrors;
		icTeaser;
		assetPartner;
		assetPartnerProfile;
		assetPartnerProfileVersion;
		mfh;
		d2gVersionInfo;
		rentRollVersion;
		energyEfficiencyScenario;
		prediction;
		reviewProcess;
		notes;
		documentRelations;
		documents;
		children;
		events;
		config;
		hasErrors;
		updatedAt;
		createdAt;
		lastCalculatedAt;
		calculationInputHash;
		portfolioSheetEmbeddingId;
		gri;
		cfEngine;
		transformation;
		postTransformation;
		condoFees;
		statusQuo;
		assumptions;
		irr;
		debt;
		investmentCaseOutput;
		sheetsSubsidies;
		sheetsRcsOutputs;
		sheetsOutputRentRoll;
		sheetsInputRentRoll;
		sheetsCfEngine;
		sheetsHelpers;
		sheetsGri;
		sheetsPLTax;
		sheetsPromote;
		sheetsInvestMemo;
		sheetsICCharts;
		deletedAt;
		constructor(props) {
			this.updateProps(props);
		}
		updateProps(props) {
			Object.assign(this, omit(props, ["caseOutputs", "hasOutput"]));
		}
		static fromArray(props) {
			return props.map((prop) => new MFHInvestmentCase(prop));
		}
		static computedFieldDeps = uniq(Object.values(mfhInvestmentCaseComputedFields).flatMap((f) => f.deps));
		static computedFieldsRecomputeNeeded = (...affectedPaths) => intersection(affectedPaths, this.computedFieldDeps).length > 0;
		static validateInputs(caseInputs, version, rentRolls, isBaseCase) {
			validateMFHInvestmentCaseInputs(caseInputs, version, rentRolls, isBaseCase);
		}
		/**
		* Removes paths from `$computedOverrides` when the current value is already equal to the formula
		* result (e.g. user turned on override but did not change the value).
		*/
		static pruneRedundantComputedOverrides(nextInputs) {
			const list = nextInputs.$computedOverrides;
			if (!list?.length) return;
			const kept = [];
			for (const path of list) {
				const def = resolveComputedDefForPath(path);
				if (!def) {
					kept.push(path);
					continue;
				}
				if (def.shouldRecalculate?.(nextInputs) === false) {
					kept.push(path);
					continue;
				}
				if (isEqual(get(nextInputs, path), def.fn(nextInputs).value)) continue;
				kept.push(path);
			}
			nextInputs.$computedOverrides = kept;
		}
		static recalculateComputedFields(nextInputs) {
			MFHInvestmentCase.pruneRedundantComputedOverrides(nextInputs);
			const overrides = new Set(nextInputs.$computedOverrides ?? []);
			for (const def of Object.values(mfhInvestmentCaseComputedFields)) {
				if (!def.outputPath || overrides.has(def.outputPath)) continue;
				if (def.shouldRecalculate?.(nextInputs) === false) {
					if (def.shouldClear?.(nextInputs)) unset(nextInputs, def.outputPath);
					continue;
				}
				set(nextInputs, def.outputPath, def.fn(nextInputs).value);
			}
			return nextInputs;
		}
		/** Read-only display value resolved from the asset-partner profile relation. */
		get assetPartnerProfileName() {
			return this.assetPartnerProfile?.name;
		}
		get normalizedCaseInputs() {
			return merge({}, this.caseInputs, { $root: {
				rentRollVersionId: this.rentRollVersionId,
				assetPartnerProfileName: this.assetPartnerProfileName
			} });
		}
		embeddedA1Link = (sheetName, a1Block, target) => {
			const sheetIdsByName = target === "main" ? this.sheetInfo?.sheetIdsByName : this.readCopySheetInfo?.sheetIdsByName;
			const spreadsheetId = target === "main" ? this.selfSheetId : this.readCopySheetId;
			if (!this.publishId || !sheetIdsByName || !spreadsheetId) return;
			const selfVersion = this.decodeVersion().version;
			const a1Range = Object.entries(this.EMBEDDING_BLOCKS_BY_RANGE[a1Block]).find(([versionRange]) => satisfies(selfVersion, versionRange))?.[1];
			if (!a1Range) return;
			const sheetId = this.sheetInfo.sheetIdsByName[sheetName];
			if (isNil(sheetId)) return;
			return `https://docs.google.com/spreadsheets/d/e/${this.publishId}/pubhtml?gid=${sheetId}&rm=minimal&single=true&range=${a1Range}&embedded=true#gid=${sheetId}`;
		};
		spreadSheetLink = (sheetName, target) => {
			const sheetIdsByName = target === "main" ? this.sheetInfo?.sheetIdsByName : this.readCopySheetInfo?.sheetIdsByName;
			const spreadsheetId = target === "main" ? this.selfSheetId : this.readCopySheetId;
			if (!sheetIdsByName || !spreadsheetId) return;
			const sheetId = sheetIdsByName[sheetName] ?? 0;
			return `https://docs.google.com/spreadsheets/d/${spreadsheetId}/edit?gid=${sheetId}#gid=${sheetId}`;
		};
		/**
		* Re-attributes the paths a sync just rewrote, in the merge order `syncMFHInputs` applies: the asset
		* layer wins over the config layer, and linked renovation scenarios win over both for the paths they
		* map. Later scenario layers win, so a custom scenario passes its inherited catalogue layer first and
		* the calculated layer last (SKB-1283). When only a subset was synced, every other path keeps whatever
		* attribution it already had.
		*
		* `changeableFields` are leaf paths (`bestWorst.generalCapexSqm.base`) while origins are row-granular,
		* so they are normalized before lookup — otherwise syncing a single range column would leave the row
		* advertising the source of the value it just replaced.
		*/
		static buildSyncedInputOrigins(origins, configInputs, mfhInputs, changeableFields, scenarioInputs) {
			const syncedOrigins = buildMFHInvestmentCaseInputOrigins([...buildMFHInvestmentCaseSourceOriginLayers(configInputs, mfhInputs), ...scenarioInputs ?? []]);
			const synced = changeableFields?.length ? pick(syncedOrigins, changeableFields.map(normalizeMFHInvestmentCaseInputPath)) : syncedOrigins;
			return {
				...origins,
				...synced
			};
		}
		/**
		* Rebuilds inputs from the sources a case is fed by: the investment-case config (global defaults plus
		* the asset-partner profile), the asset record, and — when the case is linked to one — the renovation
		* scenario it was created from (`scenarioInputs`, in merge order). Scenario layers are merged last,
		* mirroring the create-time order, so a field a scenario owns is never reset to the asset or config
		* value. A later scenario layer wins on a path both layers write.
		*/
		syncMFHInputs(configInputs, mfhInputs, changeableFields, scenarioInputs) {
			const changedInputs = mergeWith({}, configInputs, mfhInputs, ...(scenarioInputs ?? []).map((layer) => layer.inputs ?? {}));
			const changedInputsWithFields = changeableFields?.length ? pick(changedInputs, changeableFields) : changedInputs;
			let nextInputs = mergeWith({}, this.normalizedCaseInputs, this.icAliasInputs, changedInputsWithFields, this.fixedInputs, (objValue, srcValue) => {
				if (isArray(objValue)) return srcValue;
			});
			if (changeableFields?.length && nextInputs.$computedOverrides?.length) {
				const cleared = new Set(changeableFields);
				nextInputs.$computedOverrides = nextInputs.$computedOverrides.filter((p) => !cleared.has(p));
			}
			nextInputs.$inputOrigins = MFHInvestmentCase.buildSyncedInputOrigins(nextInputs.$inputOrigins ?? {}, configInputs, mfhInputs, changeableFields, scenarioInputs);
			nextInputs = MFHInvestmentCase.recalculateComputedFields(nextInputs);
			MFHInvestmentCase.validateInputs(nextInputs, this.decodeVersion().version, void 0, this.isBaseCase);
			this.caseInputs = nextInputs;
			return nextInputs;
		}
		decodeVersion() {
			if (!this.d2gVersion) throw new InvariantError(`Did not find a configured d2g-version in investment-case`);
			return decodeVersion(this.d2gVersion);
		}
		hasCalcengineIntegration(sheet) {
			return MFHInvestmentCase.hasCalcengineIntegrationForVersion(sheet, this.d2gVersion);
		}
		static hasCalcengineIntegrationForVersion(sheet, d2gVersion) {
			const compatRange = MFHInvestmentCase.CALCENGINE_COMPAT_MATRIX[sheet];
			if (!compatRange.length) return false;
			const { version } = decodeVersion(d2gVersion);
			return satisfies(version, compatRange);
		}
		get hasAnyCalcengineIntegration() {
			const { version } = this.decodeVersion();
			return Object.values(MFHInvestmentCase.CALCENGINE_COMPAT_MATRIX).filter((r) => r.length > 0).some((range) => satisfies(version, range));
		}
		hasFeatureSet(featureSet) {
			const { version } = this.decodeVersion();
			return satisfies(version, MFHInvestmentCase.FEATURESET_COMPAT_MATRIX[featureSet]);
		}
		static hasFeatureSet(featureSet, d2gVersion) {
			const [versionPart] = d2gVersion.replace("v", "").split(" ");
			return satisfies(versionPart, MFHInvestmentCase.FEATURESET_COMPAT_MATRIX[featureSet]);
		}
		static getFeatureSetVersion(featureSet) {
			return MFHInvestmentCase.FEATURESET_COMPAT_MATRIX[featureSet];
		}
		hasEveryFeatureSet(...featureSets) {
			const { version } = this.decodeVersion();
			return featureSets.every((featureSet) => satisfies(version, MFHInvestmentCase.FEATURESET_COMPAT_MATRIX[featureSet]));
		}
		hasSomeFeatureSets(...featureSets) {
			const { version } = this.decodeVersion();
			return featureSets.some((featureSet) => satisfies(version, MFHInvestmentCase.FEATURESET_COMPAT_MATRIX[featureSet]));
		}
		applyNewInputs(caseInputs, recalculateComputedFields = true) {
			let nextInputs = mergeWith({}, this.normalizedCaseInputs, this.icAliasInputs, deepOmitBy(caseInputs ?? {}, isUndefined), this.fixedInputs, (objValue, srcValue) => {
				if (isArray(objValue)) return srcValue;
			});
			const incomingInputOrigins = caseInputs?.$inputOrigins;
			if (incomingInputOrigins) nextInputs.$inputOrigins = incomingInputOrigins;
			if (recalculateComputedFields) nextInputs = MFHInvestmentCase.recalculateComputedFields(nextInputs);
			MFHInvestmentCase.validateInputs(nextInputs, this.decodeVersion().version, void 0, this.isBaseCase);
			this.caseInputs = nextInputs;
			return nextInputs;
		}
		/**
		* @note for legacy reasons there were 2 fields for the exit-approach: general.exitApproach and d2gSettings.exitApproach.
		*
		* This got merged into only one exitApproach: d2gSettings.exitApproach. This code makes sure
		* that also the old field general.exitApproach is reflected w/ case-inputs from the settings
		*/
		get icAliasInputs() {
			return { general: { exitApproach: this.caseInputs?.d2gSettings?.exitApproach } };
		}
		get fixedInputs() {
			return pick(this.caseInputs, ...MFHInvestmentCase.FIXED_INPUT_PATHS);
		}
		get needsResync() {
			if (!this.mfh || !this.updatedAt) return false;
			const maxUpdatedAt = maxBy([
				this.mfh.updatedAt,
				this.mfh.attributes?.updatedAt,
				this.mfh.price?.updatedAt
			].filter(Boolean), (date) => new Date(date).getTime());
			if (!maxUpdatedAt) return false;
			return dayjs(maxUpdatedAt).isAfter(this.updatedAt);
		}
		get caseOutputs() {
			return {
				gri: this.gri,
				cfEngine: this.cfEngine,
				transformation: this.transformation,
				postTransformation: this.postTransformation,
				condoFees: this.condoFees,
				statusQuo: this.statusQuo,
				assumptions: this.assumptions,
				irr: this.irr,
				debt: this.debt,
				investmentCaseOutput: this.investmentCaseOutput
			};
		}
		get hasOutput() {
			return !!this.lastCalculatedAt;
		}
		/**
		* Get the reviewed document if it exists.
		*/
		get reviewedDocument() {
			if (!this.documents) return void 0;
			return this.documents.find((doc) => doc.documentType === "MFHInvestmentCaseExportableSheet");
		}
		/**
		* Check if the investment case needs a reviewed document upload.
		*/
		get needsReviewedUpload() {
			if (this.status !== "Approved") return false;
			return !this.reviewedDocument;
		}
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/calculations/d2g/versions/index.ts
function fillDefaultValues(caseInputs) {
	if (!caseInputs) return caseInputs;
	const result = cloneDeep(caseInputs);
	for (const [path, generator] of Object.entries(DEFAULT_FIELD_VALUES)) if (isNil(get(result, path))) set(result, path, generator());
	return result;
}
/**
* Transposes rent index lookup table from IC inputs into arrays for calcengine
* Converts ic.caseInputs.rent.rentIndex[] into vectors for calcengine consumption
*/
function transposeRentIndex(rentIndex) {
	if (!rentIndex || rentIndex.length === 0) return {
		areaMin: [],
		areaMax: [],
		minPrice: [],
		midPrice: [],
		maxPrice: [],
		rentIndexTier: []
	};
	return {
		...transposeObjects(rentIndex),
		rentIndexTier: rentIndex.map((_, idx) => idx)
	};
}
function transposeRentRolls(rentRolls) {
	if (!rentRolls || rentRolls.length === 0) return {
		apartmentNumber: [],
		rentingState: [],
		houseAddress: [],
		locationInBuilding: [],
		apartmentType: [],
		tenantBirthYear: [],
		livingSpace: [],
		measuredLivingSpace: [],
		coldRent: [],
		vat: [],
		utilityCost: [],
		heatingCost: [],
		rentalContractStartDate: [],
		rentalContractEndDate: [],
		lastRentIncreaseDate: [],
		vpiLastIncrease: [],
		rentBeforeIncrease: [],
		coldRentChurnPerSQM: [],
		commercialRentAfterChurnPerSqm: [],
		rentIncreaseType: [],
		rentIncreaseEndDate: [],
		friIncreaseAmount: [],
		commercialVATDamage: [],
		commercialRentIndexIncrease: [],
		reletDelayInMonths: [],
		annualIndexUpdateMonthEndOf: [],
		indexationHurdle: [],
		minIntervalForIndexIncreaseInMonths: [],
		notRentableFrom: [],
		condoRefurbishmentCostsPerSQM: [],
		isRentalContractChecked: [],
		indexOfCommercialActivityPreRelet: [],
		indexOfCommercialActivityPostRelet: [],
		indexationHurdlePostRelet: [],
		minIntervalForIndexIncreaseInMonthsPostRelet: []
	};
	const transposed = transposeObjects(rentRolls, { exclude: EXCLUDED_RENT_ROLL_FIELDS });
	transposed.houseAddress = rentRolls.map((rr) => {
		const location = rr.mfhBuilding?.location;
		return location ? getAddressLine(location) : null;
	});
	return transposed;
}
function parseCalcEngineResults(results, fieldTypes, errorPersistence, isHelper = false) {
	return Object.entries(results).reduce((acc, [key, value]) => {
		const [nodeError, rawValue] = value;
		if (!isNil(nodeError)) acc[key] = [
			4,
			new D2GCalculationNodeError(nodeError.message, key, nodeError.error_type, errorPersistence),
			void 0
		];
		else acc[key] = parseCalcEngineValue(rawValue, isHelper ? "string" : fieldTypes?.[key]);
		return acc;
	}, {});
}
function fromCalcEngineOutputs(calcEngineOutputs, fieldTypes, errorPersistence) {
	return parseCalcEngineResults(calcEngineOutputs.results, fieldTypes, errorPersistence);
}
function fromCalcEngineHelperOutputs(calcEngineOutputs, errorPersistence) {
	return parseCalcEngineResults(calcEngineOutputs.helper_results ?? {}, void 0, errorPersistence, true);
}
function groupCalcEngineOutputTriples(results, helpers) {
	const grouped = Object.entries(results).reduce((acc, [key, value]) => {
		const sheetPrefix = key.split("__")[0];
		const groupKey = CALCENGINE_SHEET_PREFIX_MAP[sheetPrefix] ?? "unknown";
		if (!acc[groupKey]) acc[groupKey] = {};
		acc[groupKey][key] = value;
		return acc;
	}, {});
	if (helpers && Object.keys(helpers).length > 0) grouped.helpers = helpers;
	return grouped;
}
function fromCalcEngineOutputsToGroupedTriples(calcEngineOutputs, fieldTypes, errorPersistence) {
	return groupCalcEngineOutputTriples(fromCalcEngineOutputs(calcEngineOutputs, fieldTypes, errorPersistence), fromCalcEngineHelperOutputs(calcEngineOutputs, errorPersistence));
}
function fromParsedSpreadsheetOutputsToGroupedTriples(spreadsheetOutputs, errorPersistence) {
	return groupCalcEngineOutputTriples(Object.values(spreadsheetOutputs ?? {}).reduce((acc, sheetOutputs) => {
		if (!sheetOutputs) return acc;
		return {
			...acc,
			...transformParsedSpreadsheetObjectToCompressedTriples(sheetOutputs, errorPersistence)
		};
	}, {}));
}
function toNestedMFHInvestmentCaseInputs(caseInputs) {
	if (!caseInputs) return;
	return Object.entries(caseInputs).reduce((acc, [path, value]) => {
		if (path.includes(".")) {
			set(acc, path, value);
			return acc;
		}
		acc[path] = value;
		return acc;
	}, {});
}
function createMergedCaseInputs(ic, rentRolls) {
	const caseInputsWithDefaults = fillDefaultValues(ic.caseInputs);
	const transposedRentRolls = transposeRentRolls(rentRolls || []);
	const transposedRentIndex = transposeRentIndex(caseInputsWithDefaults?.rent?.rentIndex);
	return {
		...caseInputsWithDefaults,
		rentRoll: transposedRentRolls,
		rentIndex: transposedRentIndex
	};
}
function resolveInputsWithMapper(inputMappers, targetKeys, ic, mergedCaseInputs, strict = true) {
	const resolvedInputEntries = Object.entries(inputMappers).filter(([targetKey]) => targetKeys.has(targetKey)).map(([targetKey, mapper]) => {
		const value = get(mergedCaseInputs, mapper.key);
		return [
			targetKey,
			mapper.formatter?.(value) ?? value,
			mapper
		];
	});
	const inputs = Object.fromEntries(resolvedInputEntries.filter(([, value, mapper]) => shouldIncludeInput(value, mapper, ic, strict)).map(([targetKey, value]) => [targetKey, value]));
	const nilFields = resolvedInputEntries.filter(([, value, mapper]) => isNil(value) && isCalcengineInputMandatory(mapper, ic));
	if (strict && nilFields.length) throw new D2GSheetMissingDatapointsError(nilFields.map(([target, , mapper]) => ({
		source: mapper.key,
		target
	})));
	return strict ? inputs : Object.fromEntries(Object.entries(inputs).filter(([, value]) => !isNil(value)));
}
function isCalcengineInputMandatory(mapper, ic) {
	const inputConfig = getMFHInvestmentCaseInputConfigForPath(mapper.key);
	if (inputConfig?.requiredForAssetPartners?.length) return isMFHInvestmentCaseInputRequired(inputConfig, ic);
	return true;
}
function shouldIncludeInput(value, mapper, ic, strict) {
	if (!isNil(value)) return true;
	return strict && isCalcengineInputMandatory(mapper, ic);
}
function getCalcEngineInputFieldPath(version, calculation) {
	return lookupInputMappers(version)[calculation]?.key;
}
function getCalcEngineInputFieldPaths(version) {
	return Object.fromEntries(Object.entries(lookupInputMappers(version)).flatMap(([key, mapper]) => mapper.key ? [[key, mapper.key]] : []));
}
function getCalcEngineInputKeysForPath(version, path) {
	const inputMappers = lookupInputMappers(version);
	return Object.entries(inputMappers).filter(([, mapper]) => mapper.key === path).map(([calcengineKey]) => calcengineKey);
}
function resolveCalcEngineInputKeyForPath(version, path, preferredCalcengineKey) {
	if (preferredCalcengineKey && preferredCalcengineKey !== path && getCalcEngineInputFieldPath(version, preferredCalcengineKey) === path) return preferredCalcengineKey;
	return getCalcEngineInputKeysForPath(version, path)[0];
}
/**
* Any case with D2gFeatureSet.FullConversion needs to fill up legacy spreadsheet outputs from calcengine results
*/
function toLegacySpreadsheetOutputs(ic, version, calcengineResults) {
	const mapper = legacyOutputMappersByVersion[version];
	if (!mapper) throw new D2GCalcEngineUnsupportedVersionError(version);
	return Object.entries(mapper).reduce((acc, [key, mapper]) => {
		if (mapper.source === "results") {
			let value;
			if (typeof mapper.key === "function") value = mapper.key(calcengineResults.results, ic.caseInputs);
			else {
				const baseValue = resolveFirstValueFromKeys(calcengineResults.results, mapper.key, (v) => v?.[1]);
				const valueShape = Array.isArray(baseValue) ? Array.isArray(baseValue[0]) ? "matrix" : "vector" : "scalar";
				if (valueShape === "matrix" && mapper.offset) value = baseValue[mapper.offset[0]]?.[mapper.offset[1]];
				else if (valueShape === "vector" && mapper.offset) value = baseValue[mapper.offset[0]];
				else value = baseValue;
			}
			set(acc, key, mapper.formatter?.(value) ?? value);
		} else if (mapper.source === "inputs") {
			let value;
			if (typeof mapper.key === "function") value = mapper.key(ic.caseInputs ?? {});
			else value = resolveFirstValueFromKeys(ic.caseInputs ?? {}, mapper.key);
			set(acc, key, mapper.formatter?.(value) ?? value);
		}
		return acc;
	}, {});
}
function toCalcEngineInputs(ic, version, rentRolls, strict = true) {
	const inputMappers = lookupInputMappers(version);
	const mergedCaseInputs = createMergedCaseInputs(ic, rentRolls);
	MFHInvestmentCase.validateInputs(ic.caseInputs, version, rentRolls);
	const resolvedInputEntries = Object.entries(inputMappers).map(([targetKey, mapper]) => {
		const value = get(mergedCaseInputs, mapper.key);
		return [
			targetKey,
			mapper.formatter?.(value) ?? value,
			mapper
		];
	});
	const inputs = Object.fromEntries(resolvedInputEntries.filter(([, value, mapper]) => shouldIncludeInput(value, mapper, ic, strict)).map(([targetKey, value]) => [targetKey, value]));
	const nilFields = resolvedInputEntries.filter(([, value, mapper]) => isNil(value) && isCalcengineInputMandatory(mapper, ic));
	if (strict && nilFields.length) throw new D2GSheetMissingDatapointsError(nilFields.map(([target, , mapper]) => ({
		source: mapper.key,
		target
	})));
	return inputs;
}
function toCalcEngineInputsForTargets(ic, version, targetKeys, rentRolls) {
	return resolveInputsWithMapper(lookupInputMappers(version), targetKeys, ic, createMergedCaseInputs(ic, rentRolls), false);
}
function toSpreadsheetInputsForTargets(ic, version, targetKeys, rentRolls) {
	return resolveInputsWithMapper(lookupSpreadsheetInputMappers(version), targetKeys, ic, createMergedCaseInputs(ic, rentRolls), false);
}
function toCalcEngineRequest(ic, version, rentRolls) {
	return { inputs: toCalcEngineInputs(ic, version, rentRolls) };
}
function toCalcEngineRequestFromInvestmentCase(ic, version, rentRolls) {
	return toCalcEngineRequest(ic, version, rentRolls);
}
function collectRentRollFieldToCalcKeys(mapper) {
	const byField = /* @__PURE__ */ new Map();
	for (const [calcKey, def] of Object.entries(mapper)) {
		if (!calcKey.startsWith("f_cal_input_rent_roll__")) continue;
		const path = def.key;
		if (!path.startsWith("rentRoll.")) continue;
		const field = path.slice(9);
		const list = byField.get(field) ?? [];
		if (!list.includes(calcKey)) list.push(calcKey);
		byField.set(field, list);
	}
	return byField;
}
/**
* Maps `IRentRoll` field names (e.g. `coldRent`) to calc placeholder keys from the version-specific
* calcengine + spreadsheet input mappers (e.g. `f_cal_input_rent_roll__...`).
*/
function getRentRollFieldToCalcKeysForVersion(version) {
	const merged = collectRentRollFieldToCalcKeys(lookupInputMappers(version));
	const sheetMapper = spreadsheetInputMappersByVersion[version];
	if (sheetMapper) for (const [calcKey, def] of Object.entries(sheetMapper)) {
		if (!calcKey.startsWith("f_cal_input_rent_roll__")) continue;
		const path = def.key;
		if (!path.startsWith("rentRoll.")) continue;
		const field = path.slice(9);
		const list = merged.get(field) ?? [];
		if (!list.includes(calcKey)) list.push(calcKey);
		merged.set(field, list);
	}
	return merged;
}
/**
* Resolves a semver-like D2G version part (e.g. `5.4.1` from `decodeVersion`) to calcengine `SupportedVersions`.
*/
function normalizeD2GVersionForCalcengine(versionPart) {
	const core = versionPart.trim().replace(/^v/i, "").split(/\s+/)[0];
	for (const sv of Object.values(SupportedVersions)) if (sv.replace(/^v/i, "") === core) return sv;
	throw new D2GCalcEngineUnsupportedVersionError(versionPart, [...Object.values(SupportedVersions)]);
}
var DEFAULT_FIELD_VALUES, EXCLUDED_RENT_ROLL_FIELDS, CALCENGINE_SHEET_PREFIX_MAP, parseCalcEngineValue, calcEngineInputMappersByVersion, spreadsheetInputMappersByVersion, legacyOutputMappersByVersion, lookupInputMappers, lookupSpreadsheetInputMappers, resolveFirstValueFromKeys;
var init_versions = __esmMin((() => {
	init_d2g_errors();
	init_parser_helpers();
	init__5_0_0();
	init__5_1_1();
	init__5_1_2();
	init__5_1_3();
	init__5_3_1();
	init__5_3_2();
	init__5_4_0();
	init__5_4_1();
	init__5_5_0();
	init__5_6_0();
	init__5_6_1();
	init_mfh_investment_case_base();
	init_mfh_investment_case_class();
	DEFAULT_FIELD_VALUES = {
		"assumptions.assetViewed": () => dayjs().startOf("day").format("YYYY-MM-DD"),
		"assumptions.entryDate": () => dayjs().add(3, "month").endOf("month").startOf("day").format("YYYY-MM-DD")
	};
	EXCLUDED_RENT_ROLL_FIELDS = [
		"rentRollId",
		"rentRollVersionId",
		"createdAt",
		"updatedAt",
		"mfhBuilding",
		"rentRollVersion"
	];
	CALCENGINE_SHEET_PREFIX_MAP = {
		index: "index",
		a_out_invest_memo: "investMemo",
		b_out_ic_charts: "icCharts",
		a_cal_cf_engine: "cfEngine",
		b_cal_gri: "gri",
		c_cal_p_l_tax_engine: "pLTaxEngine",
		d_cal_promote_and_irr: "promoteAndIrr",
		e_cal_output_rent_roll: "outputRentRoll",
		f_cal_input_rent_roll: "inputRentRoll",
		g_cal_sensitivity: "sensitivity",
		h_cal_subsidies: "subsidies",
		i_out_rcs_outputs: "rcsOutputs",
		backoffice: "backoffice",
		a_crm_input: "crmInput"
	};
	parseCalcEngineValue = (rawValue, declaredType) => {
		const baseType = declaredType?.replace(/(\[\])+$/, "");
		const skipCoercion = baseType === "string" || baseType === "date";
		const type = detectValueType(rawValue);
		if (type === "matrix") return [
			3,
			void 0,
			rawValue.map((row) => row.map((cell) => {
				if (!skipCoercion && (typeof cell === "string" && !Number.isNaN(Number(cell)) || typeof cell === "number")) return safeParseNumLike(cell);
				return cell;
			}))
		];
		else if (type === "vector") return [
			2,
			void 0,
			rawValue.map((element) => {
				if (!skipCoercion && (typeof element === "string" && !Number.isNaN(Number(element)) || typeof element === "number")) return safeParseNumLike(element);
				return element;
			})
		];
		else {
			if (!skipCoercion && (typeof rawValue === "string" && !Number.isNaN(Number(rawValue)) || typeof rawValue === "number")) return [
				1,
				void 0,
				safeParseNumLike(rawValue)
			];
			return [
				1,
				void 0,
				rawValue
			];
		}
	};
	calcEngineInputMappersByVersion = {
		[SupportedVersions.v5_0_0]: calcEngineInputsV5_0_0,
		[SupportedVersions.v5_1_1]: calcEngineInputsV5_1_1,
		[SupportedVersions.v5_1_2]: calcEngineInputsV5_1_2,
		[SupportedVersions.v5_1_3]: calcEngineInputsV5_1_3,
		[SupportedVersions.v5_3_1]: calcEngineInputsV5_3_1,
		[SupportedVersions.v5_3_2]: calcEngineInputsV5_3_2,
		[SupportedVersions.v5_4_0]: calcEngineInputsV5_4_0,
		[SupportedVersions.v5_4_1]: calcEngineInputsV5_4_1,
		[SupportedVersions.v5_5_0]: calcEngineInputsV5_5_0,
		[SupportedVersions.v5_6_0]: calcEngineInputsV5_6_0,
		[SupportedVersions.v5_6_1]: calcEngineInputsV5_6_1
	};
	spreadsheetInputMappersByVersion = {
		[SupportedVersions.v5_3_2]: spreadsheetInputsV5_3_2,
		[SupportedVersions.v5_4_0]: spreadsheetInputsV5_4_0,
		[SupportedVersions.v5_4_1]: spreadsheetInputsV5_4_1,
		[SupportedVersions.v5_5_0]: spreadsheetInputsV5_5_0,
		[SupportedVersions.v5_6_0]: spreadsheetInputsV5_6_0,
		[SupportedVersions.v5_6_1]: spreadsheetInputsV5_6_1
	};
	legacyOutputMappersByVersion = {
		[SupportedVersions.v5_6_0]: calcEngineOutputsToLegacyOutputFields_V5_6_0,
		[SupportedVersions.v5_6_1]: calcEngineOutputsToLegacyOutputFields_V5_6_1
	};
	lookupInputMappers = (version) => {
		const mapper = calcEngineInputMappersByVersion[version];
		if (!mapper) throw new D2GCalcEngineUnsupportedVersionError(version);
		return mapper;
	};
	lookupSpreadsheetInputMappers = (version) => {
		const mapper = spreadsheetInputMappersByVersion[version];
		if (!mapper) throw new D2GCalcEngineUnsupportedVersionError(version);
		return mapper;
	};
	resolveFirstValueFromKeys = (obj, keyOrKeys, transform) => {
		const keys = Array.isArray(keyOrKeys) ? keyOrKeys : [keyOrKeys];
		for (const key of keys) {
			const value = get(obj, key);
			const v = transform?.(value) ?? value;
			if (!isNil(v)) return v;
		}
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/due-diligence/rent-roll-block-import.ts
function pickCalcKeyFromCandidates(candidates, extracted) {
	if (!candidates?.length) return;
	const present = candidates.filter((k) => Object.prototype.hasOwnProperty.call(extracted, k) && extracted[k] !== void 0);
	if (present.length === 0) return;
	const overrides = present.filter((k) => k.endsWith("_override"));
	if (overrides.length > 0) return overrides[0];
	return present[0];
}
function rethrowCoercionError(error, field, rowIndex) {
	if (!(error instanceof InvalidStateError)) throw error;
	const reason = error.message.replace(/^Rent roll field "[^"]+": /, "");
	throw new InvalidParamsError(`Invalid rent-roll value at row ${rowIndex + 1}, field "${field}": ${reason}`);
}
function getVectorForField(field, fieldToKeys, extracted) {
	const key = pickCalcKeyFromCandidates(fieldToKeys.get(field), extracted);
	if (!key) return null;
	const v = extracted[key];
	if (v === void 0 || v === null) return null;
	if (!Array.isArray(v)) throw new InvalidStateError(`Rent roll field "${field}": expected vector from blocks`);
	return v;
}
function getLastNonEmptyIndex(values) {
	if (!values?.length) return -1;
	for (let i = values.length - 1; i >= 0; i--) {
		const cell = values[i];
		if (cell !== null && cell !== void 0 && cell !== "") return i;
	}
	return -1;
}
function computeRowCount(extracted, fieldToKeys) {
	return getLastNonEmptyIndex(getVectorForField("rentingState", fieldToKeys, extracted)) + 1;
}
function nullIfEmpty(raw) {
	return raw === null || raw === void 0 || raw === "";
}
function coerceFiniteNumber(field, raw) {
	if (nullIfEmpty(raw)) return null;
	if (typeof raw === "number" && Number.isFinite(raw)) return raw;
	throw new InvalidStateError(`Rent roll field "${field}": expected finite number, got ${typeof raw}`);
}
function coerceInt(field, raw) {
	if (nullIfEmpty(raw)) return null;
	if (typeof raw === "number" && Number.isFinite(raw)) return Math.trunc(raw);
	throw new InvalidStateError(`Rent roll field "${field}": expected integer, got ${typeof raw}`);
}
function coerceDateIso(field, raw) {
	if (nullIfEmpty(raw)) return null;
	try {
		const date = parseRentRollTemplateDateCell(raw);
		return date ? date.toISOString().slice(0, 10) : null;
	} catch (error) {
		if (error instanceof InvalidParamsError) throw new InvalidStateError(`Rent roll field "${field}": ${error.message}`);
		throw error;
	}
}
function coerceBooleanCell(field, raw) {
	if (nullIfEmpty(raw)) return null;
	if (typeof raw === "boolean") return raw;
	const s = String(raw).toLowerCase().trim();
	if ([
		"ja",
		"yes",
		"true",
		"1"
	].includes(s)) return true;
	if ([
		"nein",
		"no",
		"false",
		"0"
	].includes(s)) return false;
	throw new InvalidStateError(`Rent roll field "${field}": expected boolean / Ja–Nein, got "${String(raw)}"`);
}
function coerceRentingState(field, raw) {
	if (nullIfEmpty(raw)) return null;
	const s = String(raw).trim();
	const hit = rentRollToRentRollStatus[s];
	if (hit) return hit;
	throw new InvalidStateError(`Rent roll field "${field}": unmapped renting state label "${s}"`);
}
function coerceApartmentType(field, raw) {
	if (nullIfEmpty(raw)) return null;
	const s = String(raw).trim();
	const hit = rentRollToApartmentType[s];
	if (hit) return hit;
	throw new InvalidStateError(`Rent roll field "${field}": unmapped apartment type label "${s}"`);
}
function coerceRentIncreaseType(field, raw) {
	if (nullIfEmpty(raw)) return null;
	const s = String(raw).trim();
	const hit = rentRollToRentIncreaseType[s];
	if (hit) return hit;
	throw new InvalidStateError(`Rent roll field "${field}": unmapped rent increase type label "${s}"`);
}
function coerceApartmentCondition(field, raw) {
	if (nullIfEmpty(raw)) return null;
	const s = String(raw).trim();
	const hit = rentRollToApartmentCondition[s];
	if (hit) return hit;
	throw new InvalidStateError(`Rent roll field "${field}": unmapped apartment condition label "${s}"`);
}
function coerceCondoSalesCondition(field, raw) {
	if (nullIfEmpty(raw)) return null;
	const s = String(raw).trim();
	const hit = rentRollToCondoSalesCondition[s];
	if (hit) return hit;
	throw new InvalidStateError(`Rent roll field "${field}": unmapped condo sales condition label "${s}"`);
}
function coerceString(raw) {
	if (nullIfEmpty(raw)) return null;
	return String(raw).trim();
}
function coerceRentRollFieldStrict(field, raw) {
	switch (field) {
		case "rentingState": return coerceRentingState(field, raw);
		case "apartmentType": return coerceApartmentType(field, raw);
		case "rentIncreaseType": return coerceRentIncreaseType(field, raw);
		case "apartmentCondition": return coerceApartmentCondition(field, raw);
		case "condoSalesCondition": return coerceCondoSalesCondition(field, raw);
		case "isRentIncreaseSigned":
		case "isStorageRoomInAtticIsRented":
		case "isRentalContractSigned":
		case "hasParkingSpace":
		case "isRefurbishedByCurrentOwner": return coerceBooleanCell(field, raw);
		case "isRentalContractChecked": return coerceBooleanCell(field, raw);
		case "rentalContractStartDate":
		case "rentalContractEndDate":
		case "lastRentIncreaseDate":
		case "rentIncreaseEndDate":
		case "notRentableFrom": return coerceDateIso(field, raw);
		case "apartmentNumber": return coerceInt(field, raw);
		case "tenantBirthYear": return coerceInt(field, raw);
		case "annualIndexUpdateMonthEndOf":
		case "minIntervalForIndexIncreaseInMonths":
		case "minIntervalForIndexIncreaseInMonthsPostRelet":
		case "reletDelayInMonths":
		case "vpiLastIncrease":
		case "rooms": return coerceFiniteNumber(field, raw);
		case "tenantName":
		case "locationInBuilding":
		case "parkingSpaceRegisterNumber":
		case "rentalContractOption":
		case "equipmentFeatures":
		case "otherAgreements":
		case "note":
		case "regulationOfRentIncreaseNote": return coerceString(raw);
		default: return coerceFiniteNumber(field, raw);
	}
}
/**
* Builds `IRentRoll` rows from `extractValuesFromBlocks` output for `f_cal_input_rent_roll`.
* Uses version-specific calc / spreadsheet mappers to resolve placeholder keys per field.
*/
function rentRollsFromInputRentRollBlockExtracted(version, extracted) {
	const fieldToKeys = getRentRollFieldToCalcKeysForVersion(version);
	const rowCount = computeRowCount(extracted, fieldToKeys);
	if (rowCount === 0) return {
		rows: [],
		houseAddressLines: []
	};
	const fields = [...fieldToKeys.keys()];
	const fieldVectors = new Map(fields.map((field) => [field, getVectorForField(field, fieldToKeys, extracted)]));
	const houseAddressLines = [];
	const rows = [];
	const rowFields = fields.filter((field) => field !== "houseAddress");
	for (let i = 0; i < rowCount; i++) {
		const houseAddress = fieldVectors.get("houseAddress")?.[i];
		houseAddressLines.push(nullIfEmpty(houseAddress) ? null : String(houseAddress).trim());
		const row = {};
		for (const field of rowFields) {
			const raw = fieldVectors.get(field)?.[i];
			try {
				const coerced = coerceRentRollFieldStrict(field, raw);
				if (coerced !== null && coerced !== void 0) row[field] = coerced;
			} catch (error) {
				rethrowCoercionError(error, field, i);
			}
		}
		rows.push(row);
	}
	return {
		rows,
		houseAddressLines
	};
}
var init_rent_roll_block_import = __esmMin((() => {
	init_errors();
	init_rent_roll_sheet_parsing();
	init_rent_roll_dd_base();
	init_versions();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/due-diligence/rent-roll-dd.opts.ts
var init_rent_roll_dd_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/due-diligence/dd.helpers.ts
var getTaskNameFromDDQuestion;
var init_dd_helpers = __esmMin((() => {
	init_document_i18n();
	getTaskNameFromDDQuestion = (ddQuestion) => {
		const data = ddQuestion?.data;
		if (!data) return "";
		switch (ddQuestion.type) {
			case "MfhDocumentChecklist": return documentTranslationsMap[data.content] ?? data.content;
			case "SourcingTasksDD": return `${data.check} - ${data.testCriterion}`;
			case "TechnicalOnSiteDD": return data.question;
			default: return data.task;
		}
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/due-diligence/index.ts
var init_due_diligence = __esmMin((() => {
	init_dd_opts();
	init_dd_answer_model();
	init_dd_answer_suggestion_model();
	init_dd_question_model();
	init_dd_generic_model();
	init_dd_v2_model();
	init_dd_v2_helpers();
	init_technical_on_site_dd_model();
	init_sourcing_tasks_dd_model();
	init_object_examination_dd_model();
	init_commercial_dd_model();
	init_vicinity_examination_dd_model();
	init_rent_dd_model();
	init_technical_dd_model();
	init_deal_closing_dd_model();
	init_legal_dd_model();
	init_document_checklist_dd_model();
	init_rent_roll_dd_base();
	init_rent_roll_dd_model();
	init_rent_roll_dd_helpers();
	init_rent_roll_sheet_parsing();
	init_rent_roll_block_import();
	init_rent_roll_dd_opts();
	init_dd_overview_model();
	init_dd_helpers();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/rent-index/requests.ts
var RentIndexLookupStatus, RentIndexPriceModel, RentIndexMissingInputCode;
var init_requests$3 = __esmMin((() => {
	RentIndexLookupStatus = /* @__PURE__ */ function(RentIndexLookupStatus) {
		RentIndexLookupStatus["Resolved"] = "resolved";
		RentIndexLookupStatus["Unavailable"] = "unavailable";
		RentIndexLookupStatus["Unsupported"] = "unsupported";
		return RentIndexLookupStatus;
	}({});
	RentIndexPriceModel = /* @__PURE__ */ function(RentIndexPriceModel) {
		RentIndexPriceModel["OfficialRange"] = "official-range";
		RentIndexPriceModel["AdditiveOptimisticMaximum"] = "additive-optimistic-maximum";
		return RentIndexPriceModel;
	}({});
	RentIndexMissingInputCode = /* @__PURE__ */ function(RentIndexMissingInputCode) {
		RentIndexMissingInputCode["Address"] = "ADDRESS";
		RentIndexMissingInputCode["AmbiguousLocation"] = "AMBIGUOUS_LOCATION";
		RentIndexMissingInputCode["AreaQuality"] = "AREA_QUALITY";
		RentIndexMissingInputCode["ConstructionYear"] = "CONSTRUCTION_YEAR";
		RentIndexMissingInputCode["Coordinates"] = "COORDINATES";
		RentIndexMissingInputCode["ExternalService"] = "EXTERNAL_SERVICE";
		RentIndexMissingInputCode["OfficialCell"] = "OFFICIAL_CELL";
		return RentIndexMissingInputCode;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/mfh/portfolio/mfh-portfolio.model.ts
var mfhPortfolioPersistedKeys;
var init_mfh_portfolio_model = __esmMin((() => {
	mfhPortfolioPersistedKeys = [
		"mfhPortfolioId",
		"name",
		"condoUuid",
		"purchasingUnitNumber",
		"assetPartnerId",
		"meta"
	];
}));
//#endregion
//#region src/domains/cross-cutting/mfh/portfolio/mfh-portfolio.request.ts
var init_mfh_portfolio_request = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/portfolio/mfh-portfolio.opts.ts
var init_mfh_portfolio_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/portfolio/mfh-portfolio.helpers.ts
var getAssetsOverlappingCandidateAssetPartners, validateMfhPortfolioMfhCandidateAssetPartners;
var init_mfh_portfolio_helpers = __esmMin((() => {
	init_company();
	init_cross_cutting();
	getAssetsOverlappingCandidateAssetPartners = (assets) => {
		if (!assets.length) return [];
		const allCandidateAssetPartnersLists = assets.map((asset) => asset.companyRelation?.filter((rel) => rel.relationName === "CandidateAssetPartner")?.map((rel) => rel.company)?.filter(Boolean) ?? []);
		if (!allCandidateAssetPartnersLists.every((list) => list.length)) return [];
		if (assets.length === 1) return allCandidateAssetPartnersLists[0];
		return intersectionBy(...allCandidateAssetPartnersLists, "companyId");
	};
	validateMfhPortfolioMfhCandidateAssetPartners = (assets, mfhPortfolioAssetPartnerId) => {
		if (!assets.length) return [];
		if (!assets.every((asset) => asset.companyRelation?.some((rel) => rel.relationName === "CandidateAssetPartner" && rel.companyId === mfhPortfolioAssetPartnerId))) throw new InvalidParamsError("Each asset should have portfolio partner among its candidate asset partners");
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/portfolio/mfh-portfolio-process.base.ts
var MFHPortfolioProcessType, MFHPortfolioEvents, MFHPortfolioFinancingState, MFHPortfolioPurchasingState, mfhPortfolioPurchasingMachineOrder, EligibleMfhPortfolioPurchasingStatesForAddingAssets, MFHPortfolioProcessStateMapping, MFHPortfolioProcessState;
var init_mfh_portfolio_process_base = __esmMin((() => {
	MFHPortfolioProcessType = /* @__PURE__ */ function(MFHPortfolioProcessType) {
		MFHPortfolioProcessType["Financing"] = "MFHPortfolioFinancing";
		MFHPortfolioProcessType["Purchasing"] = "MFHPortfolioPurchasing";
		return MFHPortfolioProcessType;
	}({});
	MFHPortfolioEvents = /* @__PURE__ */ function(MFHPortfolioEvents) {
		MFHPortfolioEvents["PartnerIdentified"] = "PartnerIdentified";
		MFHPortfolioEvents["FinancingInquired"] = "FinancingInquired";
		MFHPortfolioEvents["OfferReceived"] = "OfferReceived";
		MFHPortfolioEvents["OfferAccepted"] = "OfferAccepted";
		MFHPortfolioEvents["ExternalValueAssessed"] = "ExternalValueAssessed";
		MFHPortfolioEvents["NoExternalValueAssessNeeded"] = "NoExternalValueAssessNeeded";
		MFHPortfolioEvents["DocumentsProvided"] = "DocumentsProvided";
		MFHPortfolioEvents["PreApproved"] = "PreApproved";
		MFHPortfolioEvents["ReadyForExclusivity"] = "ReadyForExclusivity";
		MFHPortfolioEvents["ReadyForClosing"] = "ReadyForClosing";
		MFHPortfolioEvents["TransactionRejected"] = "TransactionRejected";
		MFHPortfolioEvents["SellingPrepared"] = "SellingPrepared";
		MFHPortfolioEvents["SellingPartnerChosen"] = "SellingPartnerChosen";
		MFHPortfolioEvents["PlacedOnMarket"] = "PlacedOnMarket";
		MFHPortfolioEvents["SellingOfferReceived"] = "SellingOfferReceived";
		MFHPortfolioEvents["SellingOfferAccepted"] = "SellingOfferAccepted";
		MFHPortfolioEvents["SellingDraftReceived"] = "SellingDraftReceived";
		MFHPortfolioEvents["SellingDraftEvaluated"] = "SellingDraftEvaluated";
		MFHPortfolioEvents["SellingNotarizationScheduled"] = "SellingNotarizationScheduled";
		MFHPortfolioEvents["SellingNotaryVisited"] = "SellingNotaryVisited";
		MFHPortfolioEvents["SellingNotificationOfMaturity"] = "SellingNotificationOfMaturity";
		MFHPortfolioEvents["PurchasePriceReceived"] = "PurchasePriceReceived";
		MFHPortfolioEvents["SellingHandoverDone"] = "SellingHandoverDone";
		MFHPortfolioEvents["AssetSourcingStateChanged"] = "AssetSourcingStateChanged";
		MFHPortfolioEvents["AssetSourcingStateReverted"] = "AssetSourcingStateReverted";
		MFHPortfolioEvents["AssetSourcingStateReset"] = "AssetSourcingStateReset";
		MFHPortfolioEvents["AssetSourcingStateRejected"] = "AssetSourcingStateRejected";
		MFHPortfolioEvents["AssetSourcingStateRevertedFromRejected"] = "AssetSourcingStateRevertedFromRejected";
		MFHPortfolioEvents["AssetsAddedToPortfolio"] = "AssetsAddedToPortfolio";
		MFHPortfolioEvents["AssetRemovedFromPortfolio"] = "AssetRemovedFromPortfolio";
		MFHPortfolioEvents["AssetUnReservedByPortfolio"] = "AssetUnReservedByPortfolio";
		MFHPortfolioEvents["Cancelled"] = "Cancelled";
		MFHPortfolioEvents["Restart"] = "Restart";
		MFHPortfolioEvents["Reverted"] = "Reverted";
		MFHPortfolioEvents["Finished"] = "Finished";
		return MFHPortfolioEvents;
	}({});
	MFHPortfolioFinancingState = /* @__PURE__ */ function(MFHPortfolioFinancingState) {
		MFHPortfolioFinancingState["Identified"] = "Identified";
		MFHPortfolioFinancingState["PartnerIdentified"] = "PartnerIdentified";
		MFHPortfolioFinancingState["FinancingInquired"] = "FinancingInquired";
		MFHPortfolioFinancingState["OfferReceived"] = "OfferReceived";
		MFHPortfolioFinancingState["OfferAccepted"] = "OfferAccepted";
		MFHPortfolioFinancingState["ExternalValueAssessed"] = "ExternalValueAssessed";
		MFHPortfolioFinancingState["Completed"] = "Completed";
		MFHPortfolioFinancingState["Cancelled"] = "Cancelled";
		return MFHPortfolioFinancingState;
	}({});
	MFHPortfolioPurchasingState = /* @__PURE__ */ function(MFHPortfolioPurchasingState) {
		MFHPortfolioPurchasingState["Identified"] = "Identified";
		MFHPortfolioPurchasingState["Screening"] = "Screening";
		MFHPortfolioPurchasingState["Evaluation"] = "Evaluation";
		MFHPortfolioPurchasingState["Placement"] = "Placement";
		MFHPortfolioPurchasingState["DueDiligence"] = "DueDiligence";
		MFHPortfolioPurchasingState["Closing"] = "Closing";
		MFHPortfolioPurchasingState["Completed"] = "Completed";
		MFHPortfolioPurchasingState["Rejected"] = "Rejected";
		MFHPortfolioPurchasingState["RedirectingToMinimumMfhState"] = "RedirectingToMinimumMfhState";
		return MFHPortfolioPurchasingState;
	}({});
	mfhPortfolioPurchasingMachineOrder = [
		"Rejected",
		"Identified",
		"Screening",
		"Evaluation",
		"Placement",
		"DueDiligence",
		"Closing",
		"Completed"
	];
	EligibleMfhPortfolioPurchasingStatesForAddingAssets = Object.values(MFHPortfolioPurchasingState).filter((state) => state !== "Rejected" && state !== "Completed");
	MFHPortfolioProcessStateMapping = {
		["MFHPortfolioFinancing"]: MFHPortfolioFinancingState,
		["MFHPortfolioPurchasing"]: MFHPortfolioPurchasingState
	};
	MFHPortfolioProcessState = {
		...MFHPortfolioFinancingState,
		...MFHPortfolioPurchasingState
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/portfolio/mfh-portfolio-process.model.ts
var init_mfh_portfolio_process_model = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/portfolio/mfh-portfolio-process.opts.ts
var init_mfh_portfolio_process_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/portfolio/index.ts
var init_portfolio$1 = __esmMin((() => {
	init_mfh_portfolio_model();
	init_mfh_portfolio_request();
	init_mfh_portfolio_opts();
	init_mfh_portfolio_helpers();
	init_mfh_portfolio_process_base();
	init_mfh_portfolio_process_model();
	init_mfh_portfolio_process_opts();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/building/mfh-building.request.ts
var init_mfh_building_request = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/building/mfh-building.model.ts
var init_mfh_building_model = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/building/mfh-building.opts.ts
var init_mfh_building_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/building/index.ts
var init_building = __esmMin((() => {
	init_mfh_building_request();
	init_mfh_building_model();
	init_mfh_building_opts();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/mfh-investment-case-versioning/mfh-investment-case-versioning.base.ts
var MFHInvestmentCaseVersionTriggerType, MFHInvestmentCaseVersionStatus;
var init_mfh_investment_case_versioning_base = __esmMin((() => {
	MFHInvestmentCaseVersionTriggerType = /* @__PURE__ */ function(MFHInvestmentCaseVersionTriggerType) {
		MFHInvestmentCaseVersionTriggerType["Initial"] = "initial";
		MFHInvestmentCaseVersionTriggerType["ManualSave"] = "manual_save";
		MFHInvestmentCaseVersionTriggerType["ManualRecalculate"] = "manual_recalculate";
		MFHInvestmentCaseVersionTriggerType["ManualSync"] = "manual_sync";
		MFHInvestmentCaseVersionTriggerType["AutomaticCreate"] = "automatic_create";
		MFHInvestmentCaseVersionTriggerType["AutomaticInputSave"] = "automatic_input_save";
		MFHInvestmentCaseVersionTriggerType["Copy"] = "copy";
		MFHInvestmentCaseVersionTriggerType["CopyPartnerDefault"] = "copy_partner_default";
		MFHInvestmentCaseVersionTriggerType["CopyPartnerPreserveValues"] = "copy_partner_preserve_values";
		MFHInvestmentCaseVersionTriggerType["ChangeAndRecreate"] = "change_and_recreate";
		MFHInvestmentCaseVersionTriggerType["OutputSync"] = "output_sync";
		MFHInvestmentCaseVersionTriggerType["Revert"] = "revert";
		MFHInvestmentCaseVersionTriggerType["OverridesCommitted"] = "overrides_committed";
		MFHInvestmentCaseVersionTriggerType["OverridesReverted"] = "overrides_reverted";
		return MFHInvestmentCaseVersionTriggerType;
	}({});
	MFHInvestmentCaseVersionStatus = /* @__PURE__ */ function(MFHInvestmentCaseVersionStatus) {
		MFHInvestmentCaseVersionStatus["InputsAdded"] = "inputs_added";
		MFHInvestmentCaseVersionStatus["Calculated"] = "calculated";
		return MFHInvestmentCaseVersionStatus;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/mfh-investment-case-versioning/mfh-investment-case-versioning.model.ts
var init_mfh_investment_case_versioning_model = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/mfh-investment-case-versioning/index.ts
var init_mfh_investment_case_versioning = __esmMin((() => {
	init_mfh_investment_case_versioning_base();
	init_mfh_investment_case_versioning_model();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/mfh-investment-case-override/mfh-investment-case-override.model.ts
var init_mfh_investment_case_override_model = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/mfh-investment-case-override/index.ts
var init_mfh_investment_case_override = __esmMin((() => {
	init_mfh_investment_case_override_model();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/asset-partner-ic-profile/asset-partner-ic-profile.model.ts
var init_asset_partner_ic_profile_model = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/asset-partner-ic-profile/asset-partner-ic-profile.opts.ts
var init_asset_partner_ic_profile_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/asset-partner-ic-profile/index.ts
var init_asset_partner_ic_profile = __esmMin((() => {
	init_asset_partner_ic_profile_model();
	init_asset_partner_ic_profile_opts();
	init_asset_partner_ic_profile_schema();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/asset-partner-ic-profile-version.model.ts
var init_asset_partner_ic_profile_version_model = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/erv-breakdown/mfh-erv-breakdown.model.ts
var MFHErvExclusionReason, MFHErvBreakdownStatus;
var init_mfh_erv_breakdown_model = __esmMin((() => {
	MFHErvExclusionReason = /* @__PURE__ */ function(MFHErvExclusionReason) {
		/** Living space is missing, zero or negative. */
		MFHErvExclusionReason["MissingLivingSpace"] = "MissingLivingSpace";
		MFHErvExclusionReason["MissingFloor"] = "MissingFloor";
		/** Floor is not a whole number inside the matrix's floor range (capped at `MFH_ERV_MAX_FLOOR`) — a data error. */
		MFHErvExclusionReason["FloorOutOfRange"] = "FloorOutOfRange";
		MFHErvExclusionReason["BelowFirstLowerBound"] = "BelowFirstLowerBound";
		/** Living space exceeds the inclusive maximum. */
		MFHErvExclusionReason["AboveMaximumArea"] = "AboveMaximumArea";
		MFHErvExclusionReason["NotConfigured"] = "NotConfigured";
		/** The approved investment case has no `postTransformation.targetRentSqmMonthly`. */
		MFHErvExclusionReason["MissingSollErv"] = "MissingSollErv";
		return MFHErvExclusionReason;
	}({});
	MFHErvBreakdownStatus = /* @__PURE__ */ function(MFHErvBreakdownStatus) {
		MFHErvBreakdownStatus["NotConfigured"] = "NotConfigured";
		/** A configuration exists, but there is no Soll ERV to break down. */
		MFHErvBreakdownStatus["MissingSollErv"] = "MissingSollErv";
		MFHErvBreakdownStatus["Calculated"] = "Calculated";
		return MFHErvBreakdownStatus;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/erv-breakdown/mfh-erv-breakdown.calculations.ts
function isPlausibleFloor(value) {
	return typeof value === "number" && Number.isInteger(value) && value >= 0 && value <= 40;
}
function isFiniteNumber$2(value) {
	return typeof value === "number" && Number.isFinite(value);
}
/** Callers may pass unsorted user input. */
function sortedClusters(config) {
	return [...config.clusters].sort((a, b) => a.lowerBoundSqm - b.lowerBoundSqm);
}
/**
* Inclusive display bounds: each cluster ends 1 m² below the next lower bound (`20 – 40` for bounds 20 and 41), the
* last at the maximum. Assignment compares against lower bounds only, so 40,5 m² still lands in `20 – 40`, as in the
* ticket mock.
*/
function resolveMFHErvClusterBounds(config) {
	if (!config || config.clusters.length === 0) return [];
	const clusters = sortedClusters(config);
	return clusters.map((cluster, index) => ({
		clusterIndex: index,
		lowerBoundSqm: cluster.lowerBoundSqm,
		upperBoundSqm: index < clusters.length - 1 ? new Decimal$1(clusters[index + 1].lowerBoundSqm).minus(1).toNumber() : config.maximumAreaSqm
	}));
}
/**
* Index of the highest cluster whose lower bound does not exceed `livingSpaceSqm`, or `null` when the area falls
* below the first bound or above the inclusive maximum.
*/
function assignMFHErvSizeCluster(config, livingSpaceSqm) {
	if (!config || config.clusters.length === 0 || !isFiniteNumber$2(livingSpaceSqm)) return null;
	const clusters = sortedClusters(config);
	const area = new Decimal$1(livingSpaceSqm);
	if (area.lessThan(clusters[0].lowerBoundSqm) || area.greaterThan(config.maximumAreaSqm)) return null;
	for (let index = clusters.length - 1; index >= 0; index -= 1) if (area.greaterThanOrEqualTo(clusters[index].lowerBoundSqm)) return index;
	return null;
}
/** Percentage points for one cell; unset cells are 0 %. */
function getMFHErvCellAdjustmentPercent(config, clusterIndex, floor) {
	if (!config) return 0;
	const value = sortedClusters(config)[clusterIndex]?.floorAdjustmentPercent?.[String(floor)];
	return isFiniteNumber$2(value) ? value : 0;
}
/** €/m²/month for a cell **before** the letting premium. */
function cellRate(sollErv, adjustmentPercent) {
	return sollErv.times(HUNDRED.plus(adjustmentPercent).dividedBy(HUNDRED));
}
/** €/m²/month for a unit **after** the letting premium. */
function unitRate(sollErv, adjustmentPercent, lettingPremiumPercent) {
	return cellRate(sollErv, adjustmentPercent).times(HUNDRED.plus(lettingPremiumPercent).dividedBy(HUNDRED));
}
/** Why a unit could not be placed under a usable configuration. */
function resolveExclusionReason(config, unit, bounds, floorRange) {
	if (!isFiniteNumber$2(unit.livingSpaceSqm) || unit.livingSpaceSqm <= 0) return "MissingLivingSpace";
	if (!isFiniteNumber$2(unit.floor)) return "MissingFloor";
	if (!isPlausibleFloor(unit.floor) || unit.floor < floorRange.minFloor || unit.floor > floorRange.maxFloor) return "FloorOutOfRange";
	if (bounds.length > 0 && new Decimal$1(unit.livingSpaceSqm).lessThan(bounds[0].lowerBoundSqm)) return "BelowFirstLowerBound";
	if (new Decimal$1(unit.livingSpaceSqm).greaterThan(config.maximumAreaSqm)) return "AboveMaximumArea";
	return "BelowFirstLowerBound";
}
function excludedUnit(estateId, unit, reason) {
	return {
		estateId,
		livingSpaceSqm: isFiniteNumber$2(unit.livingSpaceSqm) ? unit.livingSpaceSqm : null,
		floor: isFiniteNumber$2(unit.floor) ? unit.floor : null,
		clusterIndex: null,
		clusterLowerBoundSqm: null,
		clusterUpperBoundSqm: null,
		adjustmentPercent: null,
		ervSqmMonthly: null,
		ervMonthly: null,
		exclusionReason: reason
	};
}
function emptySummary(unitCount) {
	return {
		unitCount,
		includedUnitCount: 0,
		excludedUnitCount: unitCount,
		totalAreaSqm: 0,
		averageUnitSizeSqm: null,
		weightedErvSqmMonthlyBeforePremium: null,
		weightedErvSqmMonthly: null,
		totalErvMonthly: 0,
		deviationSqmMonthly: null,
		reconciles: unitCount === 0
	};
}
/**
* Breaks the asset's Soll ERV down per unit using the size × floor matrix. Everything stays a `Decimal` until the
* output, so the weighted totals carry no per-unit rounding.
*/
function calculateMFHErvBreakdown(params) {
	const { config, sollErvSqmMonthly, units, floorRange } = params;
	const clusterBounds = resolveMFHErvClusterBounds(config);
	const floors = [];
	for (let floor = floorRange.minFloor; floor <= floorRange.maxFloor; floor += 1) floors.push(floor);
	if (!config || clusterBounds.length === 0 || !isFiniteNumber$2(sollErvSqmMonthly)) {
		const reason = !config || clusterBounds.length === 0 ? "NotConfigured" : "MissingSollErv";
		return {
			clusterBounds,
			clusterAggregates: clusterBounds.map((bounds) => ({
				...bounds,
				unitCount: 0,
				totalAreaSqm: 0,
				weightedErvSqmMonthlyBeforePremium: null
			})),
			matrixCells: clusterBounds.flatMap((bounds) => floors.map((floor) => ({
				clusterIndex: bounds.clusterIndex,
				floor,
				unitCount: 0,
				totalAreaSqm: 0,
				adjustmentPercent: getMFHErvCellAdjustmentPercent(config, bounds.clusterIndex, floor),
				ervSqmMonthlyBeforePremium: null
			}))),
			unitResults: units.map((unit) => excludedUnit(unit.estateId, unit, reason)),
			summary: emptySummary(units.length)
		};
	}
	const sollErv = new Decimal$1(sollErvSqmMonthly);
	const premium = config.lettingPremiumPercent;
	const cellCounts = /* @__PURE__ */ new Map();
	const clusterTotals = clusterBounds.map(() => ({
		unitCount: 0,
		totalAreaSqm: new Decimal$1(0)
	}));
	const unitResults = [];
	let includedUnitCount = 0;
	let totalArea = new Decimal$1(0);
	let weightedNumeratorBeforePremium = new Decimal$1(0);
	let totalErvMonthly = new Decimal$1(0);
	for (const unit of units) {
		const clusterIndex = isPlausibleFloor(unit.floor) && unit.floor >= floorRange.minFloor && unit.floor <= floorRange.maxFloor ? assignMFHErvSizeCluster(config, unit.livingSpaceSqm) : null;
		if (clusterIndex == null) {
			unitResults.push(excludedUnit(unit.estateId, unit, resolveExclusionReason(config, unit, clusterBounds, floorRange)));
			continue;
		}
		const floor = unit.floor;
		const area = new Decimal$1(unit.livingSpaceSqm);
		const adjustmentPercent = getMFHErvCellAdjustmentPercent(config, clusterIndex, floor);
		const rateBeforePremium = cellRate(sollErv, adjustmentPercent);
		const rate = unitRate(sollErv, adjustmentPercent, premium);
		const monthly = rate.times(area);
		const cellKey = `${clusterIndex}:${floor}`;
		const cell = cellCounts.get(cellKey) ?? {
			unitCount: 0,
			totalAreaSqm: new Decimal$1(0)
		};
		cellCounts.set(cellKey, {
			unitCount: cell.unitCount + 1,
			totalAreaSqm: cell.totalAreaSqm.plus(area)
		});
		const clusterTotal = clusterTotals[clusterIndex];
		clusterTotal.unitCount += 1;
		clusterTotal.totalAreaSqm = clusterTotal.totalAreaSqm.plus(area);
		includedUnitCount += 1;
		totalArea = totalArea.plus(area);
		weightedNumeratorBeforePremium = weightedNumeratorBeforePremium.plus(rateBeforePremium.times(area));
		totalErvMonthly = totalErvMonthly.plus(monthly);
		unitResults.push({
			estateId: unit.estateId,
			livingSpaceSqm: area.toNumber(),
			floor,
			clusterIndex,
			clusterLowerBoundSqm: clusterBounds[clusterIndex].lowerBoundSqm,
			clusterUpperBoundSqm: clusterBounds[clusterIndex].upperBoundSqm,
			adjustmentPercent,
			ervSqmMonthly: rate.toNumber(),
			ervMonthly: monthly.toNumber(),
			exclusionReason: null
		});
	}
	const matrixCells = clusterBounds.flatMap((bounds) => floors.map((floor) => {
		const adjustmentPercent = getMFHErvCellAdjustmentPercent(config, bounds.clusterIndex, floor);
		const cell = cellCounts.get(`${bounds.clusterIndex}:${floor}`);
		return {
			clusterIndex: bounds.clusterIndex,
			floor,
			unitCount: cell?.unitCount ?? 0,
			totalAreaSqm: cell ? cell.totalAreaSqm.toNumber() : 0,
			adjustmentPercent,
			ervSqmMonthlyBeforePremium: cell ? cellRate(sollErv, adjustmentPercent).toNumber() : null
		};
	}));
	const clusterAggregates = clusterBounds.map((bounds) => {
		const totals = clusterTotals[bounds.clusterIndex];
		let numerator = new Decimal$1(0);
		let denominator = new Decimal$1(0);
		for (const floor of floors) {
			const cell = cellCounts.get(`${bounds.clusterIndex}:${floor}`);
			if (!cell) continue;
			numerator = numerator.plus(cellRate(sollErv, getMFHErvCellAdjustmentPercent(config, bounds.clusterIndex, floor)).times(cell.totalAreaSqm));
			denominator = denominator.plus(cell.totalAreaSqm);
		}
		return {
			...bounds,
			unitCount: totals.unitCount,
			totalAreaSqm: totals.totalAreaSqm.toNumber(),
			weightedErvSqmMonthlyBeforePremium: denominator.isZero() ? null : numerator.dividedBy(denominator).toNumber()
		};
	});
	const weightedBeforePremium = includedUnitCount > 0 && !totalArea.isZero() ? weightedNumeratorBeforePremium.dividedBy(totalArea) : null;
	return {
		clusterBounds,
		clusterAggregates,
		matrixCells,
		unitResults,
		summary: {
			unitCount: units.length,
			includedUnitCount,
			excludedUnitCount: units.length - includedUnitCount,
			totalAreaSqm: totalArea.toNumber(),
			averageUnitSizeSqm: includedUnitCount > 0 ? totalArea.dividedBy(includedUnitCount).toNumber() : null,
			weightedErvSqmMonthlyBeforePremium: weightedBeforePremium?.toNumber() ?? null,
			weightedErvSqmMonthly: weightedBeforePremium?.times(HUNDRED.plus(premium).dividedBy(HUNDRED)).toNumber() ?? null,
			totalErvMonthly: totalErvMonthly.toNumber(),
			deviationSqmMonthly: weightedBeforePremium?.minus(sollErv).toNumber() ?? null,
			reconciles: includedUnitCount === units.length
		}
	};
}
/**
* EG through the highest unit `numberOfFloors`, else `mfh.attributes.floors`, else the highest occupied floor. The
* highest occupied floor also raises the result, so no plausible unit floor falls outside the matrix.
*/
function resolveMFHErvFloorRange(params) {
	const finiteFloorCounts = params.estateNumberOfFloors.filter(isPlausibleFloor);
	const highestOccupiedFloor = (params.estateFloors ?? []).filter(isPlausibleFloor);
	let maxFloor = null;
	let source = "fallback";
	if (finiteFloorCounts.length > 0) {
		maxFloor = Math.max(...finiteFloorCounts);
		source = "estateNumberOfFloors";
	} else if (isPlausibleFloor(params.mfhAttributesFloors)) {
		maxFloor = params.mfhAttributesFloors;
		source = "mfhAttributesFloors";
	} else if (highestOccupiedFloor.length > 0) {
		maxFloor = Math.max(...highestOccupiedFloor);
		source = "estateFloors";
	}
	if (highestOccupiedFloor.length > 0) {
		const occupiedMax = Math.max(...highestOccupiedFloor);
		if (maxFloor == null || occupiedMax > maxFloor) {
			maxFloor = occupiedMax;
			if (source === "fallback") source = "estateFloors";
		}
	}
	return {
		minFloor: 0,
		maxFloor: Math.min(40, Math.max(0, Math.trunc(maxFloor ?? 0))),
		source
	};
}
var MFH_ERV_MIN_FLOOR, MFH_ERV_MAX_FLOOR, HUNDRED;
var init_mfh_erv_breakdown_calculations = __esmMin((() => {
	MFH_ERV_MIN_FLOOR = 0;
	MFH_ERV_MAX_FLOOR = 40;
	HUNDRED = new Decimal$1(100);
	__name(isFiniteNumber$2, "isFiniteNumber");
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/erv-breakdown/mfh-erv-breakdown.validation.ts
function isFiniteNumber$1(value) {
	return typeof value === "number" && Number.isFinite(value);
}
function decimalPlaces(value) {
	const text = String(value);
	if (text.indexOf("e") >= 0) return 3;
	const dotIndex = text.indexOf(".");
	return dotIndex < 0 ? 0 : text.length - dotIndex - 1;
}
/**
* Strictly increasing lower bounds and a maximum above the last one rule out overlaps and gaps, so the ranges need no
* other check. Percentages have no caps because the ticket defines none.
*/
function validateMFHErvBreakdownConfig(config) {
	const issues = [];
	if (!isFiniteNumber$1(config.lettingPremiumPercent) || decimalPlaces(config.lettingPremiumPercent) > 2) issues.push({
		code: "PremiumNotFinite",
		message: `Letting premium must be a finite percentage with at most 2 decimal places.`
	});
	if (!Array.isArray(config.clusters) || config.clusters.length === 0) {
		issues.push({
			code: "NoClusters",
			message: "At least one size range is required."
		});
		return issues;
	}
	config.clusters.forEach((cluster, clusterIndex) => {
		if (!isFiniteNumber$1(cluster.lowerBoundSqm)) {
			issues.push({
				code: "LowerBoundNotFinite",
				clusterIndex,
				message: `Range ${clusterIndex + 1}: lower bound must be a number.`
			});
			return;
		}
		if (cluster.lowerBoundSqm <= 0 || decimalPlaces(cluster.lowerBoundSqm) > 0) issues.push({
			code: "LowerBoundNotPositive",
			clusterIndex,
			message: `Range ${clusterIndex + 1}: lower bound must be a whole number greater than 0.`
		});
		Object.entries(cluster.floorAdjustmentPercent ?? {}).forEach(([floor, adjustment]) => {
			if (!/^-?\d+$/.test(floor)) {
				issues.push({
					code: "AdjustmentFloorNotInteger",
					clusterIndex,
					floor,
					message: `Range ${clusterIndex + 1}: "${floor}" is not a valid floor.`
				});
				return;
			}
			if (!isFiniteNumber$1(adjustment) || decimalPlaces(adjustment) > 1) issues.push({
				code: "AdjustmentNotFinite",
				clusterIndex,
				floor,
				message: `Range ${clusterIndex + 1}, floor ${floor}: adjustment must be a finite percentage with at most 1 decimal place.`
			});
		});
	});
	for (let index = 1; index < config.clusters.length; index += 1) {
		const previous = config.clusters[index - 1].lowerBoundSqm;
		const current = config.clusters[index].lowerBoundSqm;
		if (isFiniteNumber$1(previous) && isFiniteNumber$1(current) && current <= previous) issues.push({
			code: "LowerBoundNotIncreasing",
			clusterIndex: index,
			message: `Range ${index + 1}: lower bound must be greater than the previous one (${previous}).`
		});
	}
	if (!isFiniteNumber$1(config.maximumAreaSqm) || decimalPlaces(config.maximumAreaSqm) > 0) issues.push({
		code: "MaximumAreaNotFinite",
		message: "Max size must be a whole number of square metres."
	});
	else {
		const lastLowerBound = Math.max(...config.clusters.map((cluster) => cluster.lowerBoundSqm).filter(isFiniteNumber$1));
		if (Number.isFinite(lastLowerBound) && config.maximumAreaSqm <= lastLowerBound) issues.push({
			code: "MaximumAreaNotAboveLastLowerBound",
			message: `Max size must be greater than the last lower bound (${lastLowerBound}).`
		});
	}
	return issues;
}
function isMFHErvBreakdownConfigValid(config) {
	return validateMFHErvBreakdownConfig(config).length === 0;
}
var MFHErvConfigValidationCode, MFH_ERV_PREMIUM_MAX_DECIMALS, MFH_ERV_ADJUSTMENT_MAX_DECIMALS, MFH_ERV_AREA_MAX_DECIMALS;
var init_mfh_erv_breakdown_validation = __esmMin((() => {
	MFHErvConfigValidationCode = /* @__PURE__ */ function(MFHErvConfigValidationCode) {
		MFHErvConfigValidationCode["NoClusters"] = "NoClusters";
		MFHErvConfigValidationCode["LowerBoundNotPositive"] = "LowerBoundNotPositive";
		MFHErvConfigValidationCode["LowerBoundNotIncreasing"] = "LowerBoundNotIncreasing";
		MFHErvConfigValidationCode["LowerBoundNotFinite"] = "LowerBoundNotFinite";
		MFHErvConfigValidationCode["MaximumAreaNotAboveLastLowerBound"] = "MaximumAreaNotAboveLastLowerBound";
		MFHErvConfigValidationCode["MaximumAreaNotFinite"] = "MaximumAreaNotFinite";
		MFHErvConfigValidationCode["PremiumNotFinite"] = "PremiumNotFinite";
		MFHErvConfigValidationCode["AdjustmentNotFinite"] = "AdjustmentNotFinite";
		MFHErvConfigValidationCode["AdjustmentFloorNotInteger"] = "AdjustmentFloorNotInteger";
		return MFHErvConfigValidationCode;
	}({});
	MFH_ERV_PREMIUM_MAX_DECIMALS = 2;
	MFH_ERV_ADJUSTMENT_MAX_DECIMALS = 1;
	MFH_ERV_AREA_MAX_DECIMALS = 0;
	__name(isFiniteNumber$1, "isFiniteNumber");
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/erv-breakdown/mfh-erv-breakdown.helpers.ts
/** Canonical form of a configuration: clusters sorted by lower bound, floor keys sorted numerically. */
function normalizeMFHErvBreakdownConfig(config) {
	return {
		lettingPremiumPercent: config.lettingPremiumPercent,
		maximumAreaSqm: config.maximumAreaSqm,
		clusters: [...config.clusters].sort((a, b) => a.lowerBoundSqm - b.lowerBoundSqm).map((cluster) => ({
			lowerBoundSqm: cluster.lowerBoundSqm,
			floorAdjustmentPercent: Object.fromEntries(Object.entries(cluster.floorAdjustmentPercent ?? {}).sort(([a], [b]) => Number(a) - Number(b)))
		}))
	};
}
/** `20 – 40 m²`, or `null` when a bound is unknown. `withUnit: false` where a column header already names the unit. */
function formatMFHErvClusterRange(lowerBoundSqm, upperBoundSqm, { withUnit = true } = {}) {
	if (lowerBoundSqm == null || upperBoundSqm == null) return null;
	return withUnit ? `${lowerBoundSqm} – ${upperBoundSqm} m²` : `${lowerBoundSqm} – ${upperBoundSqm}`;
}
/** `EG`, then `1. OG`, `2. OG`, … */
function formatMFHErvFloorLabel(floor) {
	return floor === 0 ? "EG" : `${floor}. OG`;
}
var init_mfh_erv_breakdown_helpers = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/erv-breakdown/index.ts
var init_erv_breakdown = __esmMin((() => {
	init_mfh_erv_breakdown_model();
	init_mfh_erv_breakdown_calculations();
	init_mfh_erv_breakdown_validation();
	init_mfh_erv_breakdown_helpers();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/mfh-investment-case.opts.ts
var init_mfh_investment_case_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/mfh-investment-case-aggregate.opts.ts
var init_mfh_investment_case_aggregate_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/mfh-investment-case.i18n.ts
var today, eo3MonthFromToday, mfhInvestmentCaseFieldTranslations, mfhInvestmentCaseFieldTranslationsByPath, getCellConfig, createFromIndexToTabularData, translateTableLabel, translatedMetric, translatedHeaders, formatMFHSheetsData, MFHD2GSettingBegEmSubsidiesI18n;
var init_mfh_investment_case_i18n = __esmMin((() => {
	init_lib();
	init_d2g();
	init_mfh_investment_case_base();
	init_base_errors();
	today = dayjs().format("DD.MM.YYYY");
	eo3MonthFromToday = dayjs().add(3, "months").endOf("month").format("DD.MM.YYYY");
	mfhInvestmentCaseFieldTranslations = [
		{
			label: "Restrictions",
			path: "location.restrictions"
		},
		{
			label: "Asset Partner",
			path: "d2gSettings.investor",
			info: "This setting is an investment-case setting, it cannot be changed"
		},
		{
			label: "Asset Partner Profile",
			path: "$root.assetPartnerProfile.name",
			info: "Asset Partner Profile"
		},
		{
			label: "Exit Approach",
			path: "d2gSettings.exitApproach",
			info: "This setting is an investment-case setting, it cannot be changed"
		},
		{
			label: "Duration (months)",
			path: "assumptions.durationInMonths"
		},
		{
			label: "Scenario",
			path: "d2gSettings.d2gScenario"
		},
		{
			label: "CAPEX",
			path: "d2gSettings.capex"
		},
		{
			label: "Churn Vs. Fixed",
			path: "d2gSettings.churnVsFixed"
		},
		{
			label: "VAT",
			path: "d2gSettings.vat"
		},
		{
			label: "Financing",
			path: "d2gSettings.financing"
		},
		{
			label: "LTV",
			path: "d2gSettings.LTV"
		},
		{
			label: "Expansion",
			path: "d2gSettings.expansion"
		},
		{
			label: "Rent Increase",
			path: "d2gSettings.rentIncrease"
		},
		{
			label: "KfW Standard",
			path: "d2gSettings.kfwStandard"
		},
		{
			label: "IRR-Range",
			path: "d2gSettings.IRRRange"
		},
		{
			label: "IRR-Type",
			path: "d2gSettings.IRRType"
		},
		{
			label: "BAFA",
			path: "d2gSettings.bafa"
		},
		{
			label: "BEG EM Subsidies",
			path: "d2gSettings.begEmSubsidies"
		},
		{
			label: "Gradual Sale",
			path: "d2gSettings.gradualSale"
		},
		{
			label: "Use Rent Roll outputs in GRI",
			info: "Set this to ON to use result from output-rent-roll sheet in GRI-sheet instead of average rents",
			path: "d2gSettings.rentRoll"
		},
		{
			label: "IFB Standard",
			path: "d2gSettings.ifbStandard"
		},
		{
			label: "EK Draw First",
			path: "d2gSettings.ekDrawFirst"
		},
		{
			label: "Rent Increase Dependent on Data Quality",
			path: "d2gSettings.rentIncreaseDependentOnDataQuality"
		},
		{
			label: "Monument Protection",
			path: "d2gSettings.monumentProtection"
		},
		{
			label: "Renovation costs Energy Efficiency / m²",
			path: "bestWorst.renovationCostEnergyEfficiencySqm"
		},
		{
			label: "Renovation costs (Commercial) / m²",
			path: "bestWorst.renovationCostInteriorCommercialSqm"
		},
		{
			label: "Renovation costs (Interior) / m²",
			path: "bestWorst.renovationCostInteriorSqm"
		},
		{
			label: "Expansion costs / m²",
			path: "bestWorst.expansionCostSqm"
		},
		{
			label: "General CAPEX / m²",
			path: "bestWorst.generalCapexSqm"
		},
		{
			label: "Energy Efficiency Start",
			path: "assumptions.energyEfficiencyStart"
		},
		{
			label: "Energy Efficiency End",
			path: "assumptions.energyEfficiencyEnd"
		},
		{
			label: "General Start",
			path: "assumptions.generalStart"
		},
		{
			label: "General End",
			path: "assumptions.generalEnd"
		},
		{
			label: "Expansion Start",
			path: "assumptions.expansionStart"
		},
		{
			label: "Expansion End",
			path: "assumptions.expansionEnd"
		},
		{
			label: "Share of EE-CAPEX attributable for subsidies",
			path: "assumptions.shareOfEeCapexAttributableForSubsidies"
		},
		{
			label: "Share of Extension CAPEX attributable for subsidies ",
			path: "assumptions.shareOfExtensionCapexAttributableForSubsidies"
		},
		{
			label: "Share of Extension CAPEX attributable for mod levy",
			path: "assumptions.shareOfExtensionCapexAttributableForModLevy"
		},
		{
			label: "MOD Catch Up After Staffel",
			path: "assumptions.modCatchUpAfterStaffel"
		},
		{
			label: "Bank Interest rate",
			path: "assumptions.bankInterestRate"
		},
		{
			label: "Inflation",
			path: "assumptions.inflationRate"
		},
		{
			label: "Allowed annual rent increase EE",
			path: "assumptions.allowedAnnualRentIncreaseEe"
		},
		{
			label: "Provision for vacancy loss sqm",
			path: "assumptions.provisionVacancyLossSqm"
		},
		{
			label: "Rent increase (energy efficiency only)",
			path: "assumptions.rentIncreaseEnergyEfficiencyOnly"
		},
		{
			label: "Rent increase (EE only when before <7)",
			path: "assumptions.rentIncreaseEEOnlyBefore_7"
		},
		{
			label: "Annual rent growth WHG renovation",
			path: "assumptions.annualRentGrowthWhgRenovation"
		},
		{
			label: "Annual rent growth non-WHG renovation",
			path: "assumptions.annualRentGrowthNonWhgRenovation"
		},
		{
			label: "Re-let delay (in months)",
			path: "assumptions.reletDelayMonths"
		},
		{
			label: "Start letting of initial vacancy (month)",
			path: "assumptions.startLettingInitialVacancyMonth"
		},
		{
			label: "End of letting of initial vacany (month)",
			path: "assumptions.endLettingInitialVacancyMonth"
		},
		{
			label: "Share of maintenance in renovation CAPEX (for rent calc)",
			path: "assumptions.shareMaintenanceRenovationCapex"
		},
		{
			label: "CO2 Factor per kWh electricity",
			path: "assumptions.co2FactorKwhElectricity"
		},
		{
			label: "CO2 Factor per kWh heating",
			path: "assumptions.co2FactorKwhHeating"
		},
		{
			label: "Avg. heating cost per kWh",
			path: "assumptions.avgHeatingCostPerKwh"
		},
		{
			label: "Avg. electricity consumption per unit pre-renovation",
			path: "assumptions.avgElectricityConsumptionUnitPreRenovation"
		},
		{
			label: "Avg. electricity consumption per unit post-renovation",
			path: "assumptions.avgElectricityConsumptionUnitPostRenovation"
		},
		{
			label: "Non-Recs / Maintenance",
			path: "assumptions.nonRecsMaintenance"
		},
		{
			label: "Subsidised Interest Rate (bullet loan)",
			path: "assumptions.subsidisedInterestRateBulletLoan"
		},
		{
			label: "Subsidised Commitment Fee",
			path: "assumptions.subsidisedCommitmentFee"
		},
		{
			label: "State Subsidies (KfW) payout month",
			path: "assumptions.stateSubsidiesBafaKfwPayoutMonth"
		},
		{
			label: "KfW 55 Repayment subsidy in % per unit",
			path: "assumptions.kfw_55RepaymentSubsidyPercentPerUnit"
		},
		{
			label: "KfW 70 Repayment subsidy in % per unit",
			path: "assumptions.kfw_70RepaymentSubsidyPercentPerUnit"
		},
		{
			label: "KfW 85 Repayment subsidy in % per unit",
			path: "assumptions.kfw_85RepaymentSubsidyPercentPerUnit"
		},
		{
			label: "KfW 55EE max. amount per unit",
			path: "assumptions.kfw_55EEMaxAmountPerUnit"
		},
		{
			label: "KfW 70EE max. amount per unit",
			path: "assumptions.kfw_70EEMaxAmountPerUnit"
		},
		{
			label: "KfW 85EE max. amount per unit",
			path: "assumptions.kfw_85EEMaxAmountPerUnit"
		},
		{
			label: "KfW 55 max. amount per unit",
			path: "assumptions.kfw_55MaxAmountPerUnit"
		},
		{
			label: "KfW 70 max. amount per unit",
			path: "assumptions.kfw_70MaxAmountPerUnit"
		},
		{
			label: "KfW 85 max. amount per unit",
			path: "assumptions.kfw_85MaxAmountPerUnit"
		},
		{
			label: "KfW EE Repayment subsidy in % per unit",
			path: "assumptions.kfwEERepaymentSubsidyPercentPerUnit"
		},
		{
			label: "KfW MFH Construction supervision per unit",
			path: "assumptions.kfwMfhConstructionSupervisionPerUnit"
		},
		{
			label: "KfW MFH Construction supervision max per project",
			path: "assumptions.kfwMfhConstructionSupervisionMaxPerProject"
		},
		{
			label: "KfW Worst Performing Building (WPB) Bonus",
			path: "assumptions.kfwWorstPerformingBonus"
		},
		{
			label: "KfW WPB Threshold",
			path: "assumptions.kfwWpbThreshold"
		},
		{
			label: "KfW WPB EE max. amount per unit",
			path: "assumptions.kfwWpbEEMaxAmountPerUnit"
		},
		{
			label: "KfW WPB Non-EE max. amount per unit",
			path: "assumptions.kfwWpbNonEEMaxAmountPerUnit"
		},
		{
			label: "KFW Loan EE class",
			path: "assumptions.kfwLoanEEClass"
		},
		{
			label: "KFW Loan Non-EE class",
			path: "assumptions.kfwLoanNonEEClass"
		},
		{
			label: "IfB Basic funding per unit",
			path: "assumptions.ifbBasisfoerderungPerUnit"
		},
		{
			label: "IfB Energy Consulting",
			path: "assumptions.ifbEnergieberatung"
		},
		{
			label: "IfB Energy quality assurance",
			path: "assumptions.ifbQualityAssuranceEnergy"
		},
		{
			label: "IfB Efficiency House 55 in existing buildings per kWh/a",
			path: "assumptions.ifbEfficiencyHouse_55StockPerKwhA"
		},
		{
			label: "IfB Efficiency House 70 in existing buildings per kWh/a",
			path: "assumptions.ifbEfficiencyHouse_70StockPerKwhA"
		},
		{
			label: "IfB Efficiency House 85 in existing buildings per kWh/a",
			path: "assumptions.ifbEfficiencyHouse_85StockPerKwhA"
		},
		{
			label: "IfB Brick Facades",
			path: "assumptions.ifbBrickFacade"
		},
		{
			label: "IFB<90kwh",
			path: "assumptions.ifbLt90kwh"
		},
		{
			label: "IFB<75kwh",
			path: "assumptions.ifbLt75kwh"
		},
		{
			label: "IFB70EH",
			path: "assumptions.ifb70EH"
		},
		{
			label: "IFB55EH",
			path: "assumptions.ifb55EH"
		},
		{
			label: "IFB40EH",
			path: "assumptions.ifb40EH"
		},
		{
			label: "IFB joint repair high cost",
			path: "assumptions.ifbJointRepairHighCost"
		},
		{
			label: "IBB subsidized interest rate",
			path: "assumptions.ibbSubsidizedInterestRate"
		},
		{
			label: "DUS funding rate",
			path: "assumptions.dusSubsidyQuote"
		},
		{
			label: "DUS efficiency house standard funding max per unit",
			path: "assumptions.dusEfficiencyHouseStandardSubsidyMaxPerUnit"
		},
		{
			label: "DUS EE-/NH Class funding max per unit",
			path: "assumptions.dusEENhClassSubsidyMaxPerUnit"
		},
		{
			label: "DUS Maximum funding per receiver",
			path: "assumptions.dusSubsidyMaxPerRecipient"
		},
		{
			label: "Disposal Costs",
			path: "assumptions.disposalCosts"
		},
		{
			label: "Annual Index Update (Month, end of)",
			path: "assumptions.annualIndexUpdateMonthEndOf"
		},
		{
			label: "ModUmlage Delay post EE Capex",
			path: "assumptions.modUmlageDelayPostEeCapex"
		},
		{
			label: "VPI Going-In",
			path: "assumptions.vpiGoingIn"
		},
		{
			label: "Rent Class 1 Upper Limit",
			path: "assumptions.rentClass1UpperLimit"
		},
		{
			label: "Rent Class 2 Upper Limit",
			path: "assumptions.rentClass2UpperLimit"
		},
		{
			label: "Rent Class 3 Upper Limit",
			path: "assumptions.rentClass3UpperLimit"
		},
		{
			label: "Commercial Indexation Threshold",
			path: "assumptions.commercialIndexationThreshold"
		},
		{
			label: "Indexation Hurdle",
			path: "assumptions.indexationHurdle"
		},
		{
			label: "Min Interval for Index Increase (in months)",
			path: "assumptions.minIntervalIndexIncrease"
		},
		{
			label: "CONDO Letting Fees - Resi",
			path: "assumptions.condoLettingFeesResi"
		},
		{
			label: "CONDO Letting Fees - Commercial",
			path: "assumptions.condoLettingFeesCommercial"
		},
		{
			label: "Capex Subsidized Debt Upfront Fee",
			path: "assumptions.capexSubsidizedDebtUpfrontFee"
		},
		{
			label: "Rent Increase Annual Only",
			path: "d2gSettings.rentIncreaseAnnualOnly"
		},
		{
			label: "Percentage of m² with Interior Renovation",
			path: "bestWorst.percentageOfSqmWithInteriorRenovation"
		},
		{
			label: "EPC-Rating (Kwh, Post-Renovation)",
			path: "bestWorst.epcRatingInKWHPostRenovation"
		},
		{
			label: "Exit Multiple",
			path: "bestWorst.exitMultiple"
		},
		{
			label: "Construction Year",
			path: "buildingTechnical.constructionYear"
		},
		{
			label: "Has Brick Facade",
			path: "buildingTechnical.brickFacade"
		},
		{
			label: "Brick Facades m²",
			path: "buildingTechnical.brickFacadeSqm"
		},
		{
			label: "Fassade Insulation",
			path: "buildingTechnical.fassadeInsulation"
		},
		{
			label: "Primary Energy Demand KWh / m²",
			path: "buildingTechnical.primaryEnergyDemandKWhSqm"
		},
		{
			label: "End Energy Consumption KWh / m²",
			path: "buildingTechnical.endEnergyConsumptionKWhSqm"
		},
		{
			label: "Energy Consumption Class (Going in)",
			path: "buildingTechnical.endEnergyConsumptionClass"
		},
		{
			label: "Energy Consumption Class (Going out)",
			path: "buildingTechnical.endEnergyConsumptionClassPostRenovation"
		},
		{
			label: "District Heating As Primary Energy Source",
			path: "buildingTechnical.districtHeatingAsPrimaryEnergySource"
		},
		{
			label: "# Apartments In Heated Area",
			path: "buildingTechnical.numberOfApartmentsInHeatedArea"
		},
		{
			label: "# Buildings",
			path: "buildingTechnical.numBuildings"
		},
		{
			label: "Asset viewed",
			path: "assumptions.assetViewed",
			info: `When clearing this value, it will be set in spreadsheets to <b>TODAY() → ${today}</b>`
		},
		{
			label: "Entry Date",
			path: "assumptions.entryDate",
			info: `When clearing this value, it will be set in spreadsheets to <b>EOMONTH(TODAY(), 3) → ${eo3MonthFromToday}</b>`
		},
		{
			label: "Asking Price €/m²",
			path: "overview.askingPriceSqm"
		},
		{
			label: "Factor On Asking Price",
			path: "overview.factorOnAskingPrice"
		},
		{
			label: "# Resi Units",
			path: "overview.resiUnits"
		},
		{
			label: "Resi Space m²",
			path: "overview.resiSpaceSqm"
		},
		{
			label: "Ø Size Residential m²",
			path: "overview.avgSizeResidentialSqm"
		},
		{
			label: "Parking Spaces",
			path: "overview.parkingSpaces"
		},
		{
			label: "# Commercial Units",
			path: "overview.commercialUnits"
		},
		{
			label: "Commercial Space m²",
			path: "overview.commercialSpaceSqm"
		},
		{
			label: "Commercial Space € / m²",
			path: "overview.commercialSpacePriceSqm"
		},
		{
			label: "Resi Space € / m²",
			path: "overview.resiSpacePriceSqm"
		},
		{
			label: "Ø Size Commercial m²",
			path: "overview.avgSizeCommercialSqm"
		},
		{
			label: "Share Of Commercial Space",
			path: "overview.shareOfCommercialSpacePercent"
		},
		{
			label: "Average Expanded Unit Size m²",
			path: "bestWorst.averageExpandedUnitSize"
		},
		{
			label: "Parking Space Expansion",
			path: "overview.parkingSpacesExpansion"
		},
		{
			label: "Estimated Expansion Potential m²",
			path: "overview.expansionPotentialSqm"
		},
		{
			label: "Renovation Obligation / m² Without TIs",
			path: "assumptions.renovationObligationPerSqmWithoutTIs"
		},
		{
			label: "Expanded Sales Start",
			path: "assumptions.expandedSalesStart"
		},
		{
			label: "Expanded Sales End",
			path: "assumptions.expandedSalesEnd"
		},
		{
			label: "Sales Delay (After TIs Completed)",
			path: "assumptions.salesDelayAfterTIsCompleted"
		},
		{
			label: "Single Apartments Exit Multiple (EE-Only)",
			path: "bestWorst.singleApartmentsExitMultipleEEOnly"
		},
		{
			label: "Single Apartments Exit Multiple (EE With TIs)",
			path: "bestWorst.singleApartmentsExitMultipleEEWithTIs"
		},
		{
			label: "Initial HOA Reserve m²",
			path: "bestWorst.initialHOAReserveSqm"
		},
		{
			label: "Single Apartment Sales Exit Multiple (EE-Only)",
			path: "singleApartmentAssumptions.singleApartmentSalesExitMultipleEeOnly"
		},
		{
			label: "Single Apartment Sales Exit Multiple (EE And TIs)",
			path: "singleApartmentAssumptions.singleApartmentSalesExitMultipleEeAndTIs"
		},
		{
			label: "Combined Ø Effective Multiple",
			path: "singleApartmentAssumptions.combinedAvgEffectiveMultiple"
		},
		{
			label: "Sales Support For Investors",
			path: "singleApartmentAssumptions.salesSupportForInvestors"
		},
		{
			label: "HOA Split Set Up Costs",
			path: "singleApartmentAssumptions.HOASplitSetUpCosts"
		},
		{
			label: "Marketing Sales Costs",
			path: "singleApartmentAssumptions.marketingSalesCosts"
		},
		{
			label: "HOA Contribution",
			path: "singleApartmentAssumptions.HOAContribution"
		},
		{
			label: "Max Investor Cashflow Contribution (EE TIs Pm-Unit)",
			path: "singleApartmentAssumptions.maxInvestorCashflowContributionEeTIsPMUnit"
		},
		{
			label: "Max Investor Cashflow Contribution (EE Pm-Unit)",
			path: "singleApartmentAssumptions.maxInvestorCashflowContributionEePMUnit"
		},
		{
			label: "Interest Rate Investor",
			path: "singleApartmentAssumptions.interestRateInvestor"
		},
		{
			label: "Repayment Rate",
			path: "singleApartmentAssumptions.repaymentRate"
		},
		{
			label: "Tax Rate Investor",
			path: "singleApartmentAssumptions.taxRateInvestor"
		},
		{
			label: "Proportion Of Building",
			path: "singleApartmentAssumptions.proportionOfBuilding"
		},
		{
			label: "Amortization Rate",
			path: "singleApartmentAssumptions.amortizationRate"
		},
		{
			label: "Amortization New Built (6 Years)",
			path: "singleApartmentAssumptions.amortizationNewBuilt6Years"
		},
		{
			label: "Amortization New Built (Linear Onwards)",
			path: "singleApartmentAssumptions.amortizationNewBuiltLinearOnwards"
		},
		{
			label: "SEV Fee",
			path: "singleApartmentAssumptions.SEVFee"
		},
		{
			label: "Financing LTV",
			path: "singleApartmentAssumptions.financingLTV"
		},
		{
			label: "Transfer Tax",
			path: "singleApartmentAssumptions.transferTax"
		},
		{
			label: "HOA Fee / month / m²",
			path: "singleApartmentAssumptions.HOAFeeMonthSqm"
		},
		{
			label: "HOA Fee Non Transferrable Percentage Of Total",
			path: "singleApartmentAssumptions.HOAFeeNonTransferrablePercentageOfTotal"
		},
		{
			label: "HOA Fee Reserve Percentage Of Total",
			path: "singleApartmentAssumptions.HOAFeeReservePercentageOfTotal"
		},
		{
			label: "Selling Fee Residential",
			path: "singleApartmentAssumptions.sellingFeeResidential"
		},
		{
			label: "Selling Fee Commercial",
			path: "singleApartmentAssumptions.sellingFeeCommercial"
		},
		{
			label: "Marketing Costs",
			path: "singleApartmentAssumptions.marketingCosts"
		},
		{
			label: "Measurement Costs Per Unit",
			path: "singleApartmentAssumptions.measurementCostsPerUnit"
		},
		{
			label: "Architect Costs Division Plan Per Unit",
			path: "singleApartmentAssumptions.architectCostsDivisionPlanPerUnit"
		},
		{
			label: "Notary Costs Percentage Of GAV",
			path: "singleApartmentAssumptions.notaryCostsPercentageOfGAV"
		},
		{
			label: "Completion Certificate Per Unit",
			path: "singleApartmentAssumptions.completionCertificatePerUnit"
		},
		{
			label: "Land Registry Office Per Unit",
			path: "singleApartmentAssumptions.landRegistryOfficePerUnit"
		},
		{
			label: "Single Apartment Compensation Tenants Living",
			path: "singleApartmentAssumptions.singleApartmentCompensationTenantsLiving"
		},
		{
			label: "Single Apartment Compensation Tenants Commercial",
			path: "singleApartmentAssumptions.singleApartmentCompensationTenantsCommercial"
		},
		{
			label: "Initial HOA Reserve EUR / m²",
			path: "singleApartmentAssumptions.initialHOAReserveEurSQM"
		},
		{
			label: "Sales Subsidy Length (Years)",
			path: "singleApartmentAssumptions.salesSubsidyLengthYears"
		},
		{
			label: "Condo WACC",
			path: "singleApartmentAssumptions.condoWACC"
		},
		{
			label: "GAV",
			path: "singleApartmentAssumptions.GAV"
		},
		{
			label: "Bank LTV",
			path: "singleApartmentAssumptions.bankLTV"
		},
		{
			label: "Rent Pool Rent m²",
			path: "singleApartmentAssumptions.rentPoolRentSqm"
		},
		{
			label: "Rent Pool Duration Years",
			path: "singleApartmentAssumptions.rentPoolDurationYears"
		},
		{
			label: "Sales Price / m² Rent Pool Unit",
			path: "singleApartmentAssumptions.salesPriceSqmRentPoolUnit"
		},
		{
			label: "Sales Price / m² Rent Pool Implied Yield During Rent Pool",
			path: "singleApartmentAssumptions.salesPriceSqmRentPoolImpliedYieldDuringRentPool"
		},
		{
			label: "Sales Price / m² Rent Pool Implied Yield During After Rent Pool Unrenovated",
			path: "singleApartmentAssumptions.salesPriceSqmRentPoolImpliedYieldDuringAfterRentPoolUnrenovated"
		},
		{
			label: "Sales Price / m² Rent Pool Implied Yield During After Rent Pool Renovated",
			path: "singleApartmentAssumptions.salesPriceSqmRentPoolImpliedYieldDuringAfterRentPoolRenovated"
		},
		{
			label: "Sales Price Expanded € / m²",
			path: "singleApartmentAssumptions.salesPriceExpandedSqm"
		},
		{
			label: "Sales Price Expanded Implied Yield During Rent Pool",
			path: "singleApartmentAssumptions.salesPriceExpandedImpliedYieldDuringRentPool"
		},
		{
			label: "Sales Price Expanded Implied Yield During After Rent Pool",
			path: "singleApartmentAssumptions.salesPriceExpandedImpliedYieldDuringAfterRentPool"
		},
		{
			label: "Vacancy Pool",
			path: "singleApartmentAssumptions.vacancyPool"
		},
		{
			label: "Financing Period In Months Full",
			path: "singleApartmentAssumptions.financingPeriodInMonthsFull"
		},
		{
			label: "Holding Period Income In Months",
			path: "singleApartmentAssumptions.holdingPeriodIncomeInMonths"
		},
		{
			label: "Anual Tenant Churn",
			path: "singleApartmentAssumptions.anualTenantChurn"
		},
		{
			label: "Renovation Costs Energy Efficiency € / m²",
			path: "singleApartmentAssumptions.renovationCostsEnergyEfficiencySqm"
		},
		{
			label: "General CAPEX",
			path: "singleApartmentAssumptions.generalCapex"
		},
		{
			label: "Renovation Costs Interior € / m²",
			path: "singleApartmentAssumptions.renovationCostsInteriorSqm"
		},
		{
			label: "Single Apartment Expansion Costs € / m",
			path: "singleApartmentAssumptions.singleApartmentExpansionCostSqm"
		},
		{
			label: "Rent Increase Possible Through Modernization Levy",
			path: "singleApartmentAssumptions.rentIncreasePossibleThroughModernizationLevy"
		},
		{
			label: "Manual Expanded Space",
			path: "rentPredictions.manualExpandedSpace"
		},
		{
			label: "Condo Sophisticated",
			path: "rentPredictions.condoSophisticated"
		},
		{
			label: "Condo Luxury",
			path: "rentPredictions.condoLuxury"
		},
		{
			label: "Spreng Sophisticated",
			path: "rentPredictions.sprengSophisticated"
		},
		{
			label: "Spreng Luxury",
			path: "rentPredictions.sprengLuxury"
		},
		{
			label: "Spreng Commercial",
			path: "rentPredictions.sprengCommercial"
		},
		{
			label: "Condo Carpark",
			path: "rentPredictions.condoCarpark"
		},
		{
			label: "Manual Commercial",
			path: "rentPredictions.manualCommercial"
		},
		{
			label: "Manual Residential Post Ti",
			path: "rentPredictions.manualResidentialPostTI"
		},
		{
			label: "Manual Carpark",
			path: "rentPredictions.manualCarpark"
		},
		{
			label: "Courtage Excl. VAT",
			path: "agent.courtageExclVat"
		},
		{
			label: "Asking Price",
			path: "overview.askingPrice"
		},
		{
			label: "Expected Purchase Discount",
			path: "assumptions.expectedPurchaseDiscount"
		},
		{
			label: "Notary costs",
			info: `Calculated based on <a href="https://www.notar.de/themen/notarkosten/gebuehrenrechner" target="_blank">Notary tariff calculator</a>`,
			path: "assumptions.notaryCosts"
		},
		{
			label: "DD-Contingency",
			path: "assumptions.ddContingency"
		},
		{
			label: "Land Value As Percent of GPP",
			path: "assumptions.landValueAsPercentOfGpp"
		},
		{
			label: "Target Rent Adj. Cat 1",
			path: "rent.adjustedTargetRentLt50Sqm"
		},
		{
			label: "Target Rent Adj. Cat 2",
			path: "rent.adjustedTargetRent50To75Sqm"
		},
		{
			label: "Target Rent Adj. Cat 3",
			path: "rent.adjustedTargetRent75To100Sqm"
		},
		{
			label: "Target Rent Adj. Cat 4",
			path: "rent.adjustedTargetRentGt100Sqm"
		},
		{
			label: "Rent Index Table",
			path: "rent.rentIndex"
		},
		{
			label: "Annual net rent - Total",
			path: "rent.jnkmTotalCurrent"
		},
		{
			label: "Rent Roll Version",
			info: "Select a rent roll for calculation. When this field is left blank, any existing rent-roll-data is cleared.",
			path: "$root.rentRollVersionId"
		},
		{
			label: "Annual net rent - Residential",
			path: "overview.rentResidentialCurrent"
		},
		{
			label: "Annual net rent - Commercial",
			path: "rent.jnkmCommercialCurrent"
		},
		{
			label: "Annual net rent - Parking",
			path: "rent.jnkmParkingSpacesCurrent"
		},
		{
			label: "Rent Residential € / month / m²",
			path: "overview.rentResidentialCurrentSqm"
		},
		{
			label: "Resi Occupancy Actual",
			path: "rent.resiOccupancyActual"
		},
		{
			label: "Commercial Occupancy Actual",
			path: "rent.commercialOccupancyActual"
		},
		{
			label: "Parking Occupancy Actual",
			path: "rent.parkingOccupancyActual"
		},
		{
			label: "Rent Roll Sheets Id",
			path: "rent.rentRollSheetsId"
		},
		{
			label: "Rent Index Pre Renovation",
			path: "assumptions.rentIndexPreRenovation"
		},
		{
			label: "Rent Index Post Ee Renovation",
			path: "assumptions.rentIndexPostEeRenovation"
		},
		{
			label: "Timing Commercial Carpark Rent Increase Month",
			path: "assumptions.timingCommercialCarparkRentIncreaseMonth"
		},
		{
			label: "Annual Churn Commercial",
			path: "assumptions.annualChurnCommercial"
		},
		{
			label: "Annual Churn Car Park",
			path: "assumptions.annualChurnCarPark"
		},
		{
			label: "First BGB Rent Increase Timing",
			path: "assumptions.firstBgbRentIncreaseTiming"
		},
		{
			label: "First BGB Rent Increase Size",
			path: "assumptions.firstBgbRentIncreaseSize"
		},
		{
			label: "Second BGB Rent Increase Timing",
			path: "assumptions.secondBgbRentIncreaseTiming"
		},
		{
			label: "Second BGB Rent Increase Size",
			path: "assumptions.secondBgbRentIncreaseSize"
		},
		{
			label: "Third BGB Rent Increase Size",
			path: "assumptions.thirdBgbRentIncreaseSize"
		},
		{
			label: "Third BGB Rent Increase Timing",
			path: "assumptions.thirdBgbRentIncreaseTiming"
		},
		{
			label: "Fourth BGB Rent Increase Size",
			path: "assumptions.fourthBgbRentIncreaseSize"
		},
		{
			label: "Fourth BGB Rent Increase Timing",
			path: "assumptions.fourthBgbRentIncreaseTiming"
		},
		{
			label: "BGB Rent Increase to Mid of Low and Medium",
			path: "assumptions.bgbRentIncreaseToMidOfLowAndMedium"
		},
		{
			label: "Start Expansion Letting",
			path: "assumptions.startExpansionLetting"
		},
		{
			label: "End Expansion Letting",
			path: "assumptions.endExpansionLetting"
		},
		{
			label: "Rent Index Pre EE",
			path: "rent.rentIndexPreEe"
		},
		{
			label: "Rent Index Post EE",
			path: "rent.rentIndexPostEe"
		},
		{
			label: "Re-Let Scenario",
			path: "d2gSettings.reLetScenario"
		},
		{
			label: "Strategic Vacancy",
			path: "d2gSettings.strategicVacancy"
		},
		{
			label: "Rent Index Premium",
			path: "assumptions.rentIndexPremium"
		},
		{
			label: "Light CAPEX Lease Cutoff",
			path: "assumptions.lightCapexLeaseCutoff"
		},
		{
			label: "Month Until Strategic Vacancy",
			path: "assumptions.monthUntilStrategicVacancy"
		},
		{
			label: "Strategic Vacant Space Lease-Up Period",
			path: "assumptions.strategicVacantSpaceLeaseUpPeriod"
		},
		{
			label: "CIT rate (27)",
			path: "assumptions.citRate27"
		},
		{
			label: "CIT rate (28)",
			path: "assumptions.citRate28"
		},
		{
			label: "CIT rate (29)",
			path: "assumptions.citRate29"
		},
		{
			label: "CIT rate (30)",
			path: "assumptions.citRate30"
		},
		{
			label: "CIT rate (31)",
			path: "assumptions.citRate31"
		},
		{
			label: "CIT rate (32 / other)",
			path: "assumptions.citRate32ongoing"
		},
		{
			label: "TLCF Deductible Percent Above Base Amount",
			path: "assumptions.tlcfDeductiblePercentAboveBaseAmount"
		},
		{
			label: "Trade Tax",
			path: "assumptions.tradeTax"
		},
		{
			label: "Min JNKM for CT release",
			path: "assumptions.minJnkmForCt"
		},
		{
			label: "# Qrt for CT release",
			path: "assumptions.qrtForCtRelease"
		},
		{
			label: "Allowed OPEX for CT",
			path: "assumptions.allowedOpexForCt"
		},
		{
			label: "Cash Trap",
			path: "d2gSettings.cashTrap"
		},
		{
			label: "CT Max LTV",
			path: "assumptions.ctMaxLtv"
		},
		{
			label: "Tax Engine Type",
			path: "d2gSettings.taxEngineType"
		},
		{
			info: "# of months of net cold rent paid as commission",
			label: "Letting Fees Residential (external)",
			path: "assumptions.lettingFeesResidential"
		},
		{
			info: "# of months of net cold rent paid as commission",
			label: "Letting Fees Commercial (external)",
			path: "assumptions.lettingFeesCommercial"
		},
		{
			label: "Applied EE Top-Up",
			path: "assumptions.appliedEETopUp"
		},
		{
			label: "Applied EE Top-Up (For Index)",
			path: "assumptions.appliedEETopUpForIndex"
		},
		{
			label: "BAFA Single Measure Grant",
			path: "assumptions.bafaSingleMeasureGrant"
		},
		{
			label: "Annunal Tenant Churn",
			path: "bestWorst.annunalTenantChurn"
		},
		{
			label: "Compensation Resi Churn / m²",
			path: "compensationTenantsResi.compensationResiChurnSqm"
		},
		{
			label: "Compensation Resi Churn Timing Months",
			path: "compensationTenantsResi.compensationResiChurnTimingMonths"
		},
		{
			label: "Compensation Tenants Living",
			path: "compensationTenantsResi.compensationTenantsLiving"
		},
		{
			label: "Compensation Tenants Commercial",
			path: "compensationTenantsCommercial.compensationTenantsCommercial"
		},
		{
			label: "Compensation Commercial Churn / m²",
			path: "compensationTenantsCommercial.compensationCommercialChurnSqm"
		},
		{
			label: "Compensation Commercial Timing Months",
			path: "compensationTenantsCommercial.compensationCommercialTimingMonths"
		},
		{
			label: "Condo Purchasing Service Fee",
			path: "investorAssumptions.condoPurchasingServiceFee"
		},
		{
			label: "Condo Disposition Fee",
			path: "investorAssumptions.condoPurchasingServiceFeeWithBroker"
		},
		{
			label: "Condo Purchasing Service Fee No Broker",
			path: "investorAssumptions.condoPurchasingServiceFeeNoBroker"
		},
		{
			label: "Reneo Purchasing Service Fee",
			path: "investorAssumptions.reneoPurchasingServiceFee"
		},
		{
			label: "Reneo Sales Fee",
			path: "investorAssumptions.reneoSalesFee"
		},
		{
			label: "Condo Renovation Service Fee",
			path: "investorAssumptions.condoRenovationServiceFee"
		},
		{
			label: "Renovation Fee Net Or Gross Of Capex",
			path: "investorAssumptions.renovationFeeNetOrGrossOfCapex"
		},
		{
			label: "Condo Sales Fee No Broker",
			path: "investorAssumptions.condoSalesFeeNoBroker"
		},
		{
			label: "Condo Sales Fee With Broker",
			path: "investorAssumptions.condoSalesFeeWithBroker"
		},
		{
			label: "Condo Sales Fee With Broker >75m",
			path: "investorAssumptions.condoSalesFeeWithBroker_gt75m"
		},
		{
			label: "Condo Sales Fee No Broker >75m",
			path: "investorAssumptions.condoSalesFeeNoBroker_gt75m"
		},
		{
			label: "Condo Sales Fee With Broker >25m",
			path: "investorAssumptions.condoSalesFeeWithBroker_gt25m"
		},
		{
			label: "Condo Sales Fee No Broker >25m",
			path: "investorAssumptions.condoSalesFeeNoBroker_gt25m"
		},
		{
			label: "Condo Sales Fee With Broker <25m",
			path: "investorAssumptions.condoSalesFeeWithBroker_lt25m"
		},
		{
			label: "Condo Sales Fee No Broker <25m",
			path: "investorAssumptions.condoSalesFeeNoBroker_lt25m"
		},
		{
			label: "Acquisition Fee On-Market <25m",
			path: "investorAssumptions.acquisitionFeeOnMarket_lt25m"
		},
		{
			label: "Acquisition Fee On-Market 25m-75m",
			path: "investorAssumptions.acquisitionFeeOnMarket_gt25m"
		},
		{
			label: "Acquisition Fee On-Market >75m",
			path: "investorAssumptions.acquisitionFeeOnMarket_gt75m"
		},
		{
			label: "Acquisition Fee Off-Market <25m",
			path: "investorAssumptions.acquisitionFeeOffMarket_lt25m"
		},
		{
			label: "Acquisition Fee Off-Market 25m-75m",
			path: "investorAssumptions.acquisitionFeeOffMarket_gt25m"
		},
		{
			label: "Acquisition Fee Off-Market >75m",
			path: "investorAssumptions.acquisitionFeeOffMarket_gt75m"
		},
		{
			label: "Exit Fee On-Market <25m",
			path: "investorAssumptions.salesFeeOnMarket_lt25m"
		},
		{
			label: "Exit Fee On-Market 25m-75m",
			path: "investorAssumptions.salesFeeOnMarket_gt25m"
		},
		{
			label: "Exit Fee On-Market >75m",
			path: "investorAssumptions.salesFeeOnMarket_gt75m"
		},
		{
			label: "Exit Fee Off-Market <25m",
			path: "investorAssumptions.salesFeeOffMarket_lt25m"
		},
		{
			label: "Exit Fee Off-Market 25m-75m",
			path: "investorAssumptions.salesFeeOffMarket_gt25m"
		},
		{
			label: "Exit Fee Off-Market >75m",
			path: "investorAssumptions.salesFeeOffMarket_gt75m"
		},
		{
			label: "Condo Property Management Flat-Fee / Month",
			path: "investorAssumptions.condoPropertyManagementFeeFlatMonth"
		},
		{
			label: "Condo Property Management Fee Commercial / Unit / m² / Month",
			path: "investorAssumptions.condoPropertyManagementFeeCommercialUnitSqmMonth"
		},
		{
			label: "Condo Asset Management Fee (Of GAV)",
			path: "investorAssumptions.condoAssetManagementFeeOfGav"
		},
		{
			label: "Condo Asset Management Fee (Alternative Min Of)",
			path: "investorAssumptions.condoAssetManagementFeeAlternativeMinOf"
		},
		{
			label: "IRR Hurdle 1",
			path: "investorAssumptions.IRRHurdle1"
		},
		{
			label: "Promote 1",
			path: "investorAssumptions.promote1"
		},
		{
			label: "IRR Hurdle 2",
			path: "investorAssumptions.IRRHurdle2"
		},
		{
			label: "Promote 2",
			path: "investorAssumptions.promote2"
		},
		{
			label: "IRR Hurdle 3",
			path: "investorAssumptions.IRRHurdle3"
		},
		{
			label: "Promote 3",
			path: "investorAssumptions.promote3"
		},
		{
			label: "CIT Rate",
			path: "investorAssumptions.CITRate"
		},
		{
			label: "Standard Rent Loss In Percentage of NRI",
			path: "investorAssumptions.standardRentLossInOfNRI"
		},
		{
			label: "Development Rent Loss In Percentage of NRI",
			path: "investorAssumptions.developmentRentLossInPercentageNRI"
		},
		{
			label: "EBITDA limit (interest barrier)",
			path: "investorAssumptions.interestThresholdEBITDAWithFloorRule"
		},
		{
			label: "Interest Limit - (Interest barrier)",
			path: "investorAssumptions.interestAvailableForUse"
		},
		{
			label: "VAT Rate",
			path: "investorAssumptions.VATRate"
		},
		{
			label: "Annual Asset Depreciation",
			path: "investorAssumptions.annualAssetDepreciation"
		},
		{
			label: "Taxable Income Utilization of Loss Pool",
			path: "investorAssumptions.taxableIncomeUtilizationOfLossPool"
		},
		{
			label: "Subsidised debt running AM",
			path: "investorAssumptions.subsidisedNonSubsidizedDebtRunningAM"
		},
		{
			label: "Subsidised debt AM start month",
			path: "investorAssumptions.subsidisedNonSubsidizedDebtAMStartMonth"
		},
		{
			label: "Senior Debt LTV",
			path: "investorAssumptions.seniorDebtLTV"
		},
		{
			label: "CAPEX Non Subsidized Debt LTV",
			path: "investorAssumptions.capexNonSubsidizedDebtLTV"
		},
		{
			label: "Senior Debt Interest Rate",
			path: "investorAssumptions.seniorDebtInterestRate"
		},
		{
			label: "Capex non-subsidized debt interest rate",
			path: "investorAssumptions.capexNonSubsidizedDebtInterestRate"
		},
		{
			label: "Senior CAPEX (Non Subsidized Debt Interest Rate)",
			path: "investorAssumptions.seniorCapexNonSubsidizedDebtInterestRate"
		},
		{
			label: "Senior debt upfront fee",
			path: "investorAssumptions.seniorCapexNonSubsidizedDebtUpfrontFee"
		},
		{
			label: "Capex Non Subsidized Debt Commitment Fee",
			path: "investorAssumptions.seniorCapexNonSubsidizedDebtCommitmentFee"
		},
		{
			label: "Senior Debt Running AM",
			path: "investorAssumptions.seniorCapexNonSubsidizedDebtRunninAM"
		},
		{
			label: "Senior Debt AM Start Month",
			path: "investorAssumptions.seniorCapexNonSubsidizedDebtAmStartMonth"
		},
		{
			label: "Assumed NRI Leakage For Banks",
			path: "investorAssumptions.assumedNRILeakageForBanks"
		},
		{
			label: "Target Debt Yield",
			path: "investorAssumptions.targetDebtYield"
		},
		{
			label: "LTV Subsidized Loan KfW",
			path: "assumptions.ltvSubsidizedLoanKfWPercent"
		},
		{
			label: "VAT Damage Commercial TIs",
			path: "assumptions.vatDamageCommercialTIS"
		},
		{
			label: "VAT Damage Maintenance",
			path: "assumptions.vatDamageMaintenance"
		},
		{
			label: "VAT Damage Purchase Costs",
			path: "assumptions.vatDamagePurchaseCosts"
		},
		{
			label: "VAT Damage Partner Fees",
			path: "assumptions.vatDamagePartnerFees"
		},
		{
			label: "VAT Damage Modernizationcapex",
			path: "assumptions.vatDamageModernizationcapex"
		},
		{
			label: "VAT Damage Expansion/TIs Apartments",
			path: "assumptions.vatDamageExpansionApartment"
		},
		{
			label: "RETT",
			info: "Derived from state-taxes found in the linked config",
			path: "assumptions.rett"
		},
		{
			label: "Applied Rent Residential",
			info: "By default uses the maximum value of predicted rent inputs",
			path: "rent.appliedRentResidential"
		},
		{
			label: "Applied Rent Commercial",
			path: "rent.appliedRentCommercial"
		},
		{
			label: "Applied Rent Carpark",
			info: "By default uses the predicted carpark rent",
			path: "rent.appliedRentCarpark"
		},
		{
			label: "SH/PPL Loan as % of equity",
			path: "investorAssumptions.shareholderPPLLoanPercentOfEquity"
		},
		{
			label: "SH/PPL Loan Interest",
			path: "investorAssumptions.shareholderPPLLoanInterest"
		},
		{
			label: "SHL reimbursement month",
			path: "investorAssumptions.shareholderReimbursementMonth"
		},
		{
			label: "[Peakside] 30 LuxCos",
			path: "investorAssumptions.thirtyLuxCos"
		},
		{
			label: "[Peakside] Transfer to Lux",
			path: "investorAssumptions.transferToLuxMonth"
		},
		{
			label: "[Peakside] Deductible amount per Lux Company",
			path: "investorAssumptions.deductibleAmountPerLuxCompany"
		},
		{
			label: "[Peakside] # of LuxCos",
			path: "investorAssumptions.numberOfLuxCos"
		},
		{
			label: "Deductible % of TLCF gained",
			path: "investorAssumptions.deductiblePercentOfTLCFGained"
		},
		{
			label: "Capex Non Subsidized Debt Upfront Fee",
			path: "assumptions.capexNonSubsidizedDebtUpfrontFee"
		},
		{
			label: "Capex Non Subsidized Debt Running AM",
			path: "assumptions.capexNonSubsidizedDebtRunningAm"
		},
		{
			label: "Capex Non Subsidized Debt AM Start Month",
			path: "assumptions.capexNonSubsidizedDebtAMStartMonth"
		},
		{
			label: "FKG Individual Measure Grant",
			path: "assumptions.fkgIndividualMeasureGrant"
		},
		{
			label: "FKG Heating Replacement Subsidy",
			path: "assumptions.fkgHeatingReplacementSubsidy"
		},
		{
			label: "FKG Efficiency House 55 Subsidy",
			path: "assumptions.fkgEfficiencyHouse55Subsidy"
		},
		{
			label: "FKG 1 Funding",
			path: "assumptions.fkg1Funding"
		},
		{
			label: "BAFA iSFP bonus",
			path: "assumptions.bafaIsfpBonus"
		},
		{
			label: "KFW Individual Measure Heat Generation",
			path: "assumptions.kfWIndividualMeasureHeatGeneration"
		},
		{
			label: "BAFA Eligible Expenditure CAP Per Residential Unit Without iSFP",
			path: "assumptions.bafaEligibleExpenditureCapPerResidentialUnitWithoutIsfp"
		},
		{
			label: "BAFA Eligible Expenditure CAP Per Residential Unit With iSFP",
			path: "assumptions.bafaEligibleExpenditureCapPerResidentialUnitWithIsfp"
		},
		{
			label: "BAFA Specialist Planning And Construction Support",
			path: "assumptions.bafaSpecialistPlanningAndConstructionSupport"
		},
		{
			label: "BAFA Specialist Planning And Construction Support CAP",
			path: "assumptions.bafaSpecialistPlanningAndConstructionSupportCap"
		},
		{
			label: "BAFA Specialist Planning And Construction Supervision Per Residential Unit",
			path: "assumptions.bafaSpecialistPlanningAndConstructionSupervisionPerResidentialUnit"
		},
		{
			label: "KFW459 1st Residential Unit",
			path: "assumptions.kfw459FirstResidentialUnit"
		},
		{
			label: "KFW459 2-6 Residential Units",
			path: "assumptions.kfw459SecondToSixthResidentialUnits"
		},
		{
			label: "KFW459 7+ Residential Units",
			path: "assumptions.kfw459SeventhPlusResidentialUnits"
		},
		{
			label: "FKG B1 Cap Without Energy Standard",
			path: "assumptions.fkgB1CapWithoutEnergyStandard"
		},
		{
			label: "FKG B1 Cap Energy Standard",
			path: "assumptions.fkgB1CapEnergyStandard"
		},
		{
			label: "FKG B1 Per Residential Unit Without Energy Standard",
			path: "assumptions.fkgB1PerResidentialUnitWithoutEnergyStandard"
		},
		{
			label: "FKG B1 Per Residential Unit With Energy Standard",
			path: "assumptions.fkgB1PerResidentialUnitWithEnergyStandard"
		},
		{
			label: "FKG/BAFA Total Funding CAP",
			path: "assumptions.fkgBafaTotalFundingCap"
		},
		{
			label: "FKG/BAFA Payment After Construction Completion",
			path: "assumptions.fkgBafaPaymentAfterConstructionCompletion"
		},
		{
			label: "iSFP Planning",
			path: "assumptions.isfpPlanning"
		},
		{
			label: "Heating Replacement",
			path: "assumptions.heatingReplacement"
		},
		{
			info: `These costs are part of the EE CAPEX and are not additive. We allocate this portion of the cost solely for the subsidy calculation`,
			label: "Heating Replacement Costs /m²",
			path: "assumptions.heatingReplacementCostsPerSqm"
		},
		{
			label: "Number Of Residential Units For Individual Measure",
			path: "assumptions.numberOfResidentialUnitsForIndividualMeasure"
		},
		{
			path: "assumptions.tiCapexLight",
			label: "TI CAPEX Light"
		},
		{
			path: "investorAssumptions.promoteType",
			label: "Promote Type"
		},
		{
			path: "investorAssumptions.reneoFinancingFee",
			label: "Reneo Financing Fee"
		},
		{
			path: "investorAssumptions.totalApetite",
			label: "Total Appetite, (EUR)"
		},
		{
			path: "investorAssumptions.irrPercentageThreshold",
			label: "IRR Threshold, %"
		},
		{
			path: "investorAssumptions.cocPercentageThreshold",
			label: "Cash-on-Cash Threshold, %"
		},
		{
			path: "investorAssumptions.mocMultiplierThreshold",
			label: "MoC Threshold (x)"
		},
		{
			path: "investorAssumptions.investmentVolumeThreshold",
			label: "Investment Volume Threshold, (EUR)"
		},
		{
			path: "investorAssumptions.purchasePriceDiscountThreshold",
			label: "Purchase Price Discount Threshold, %"
		},
		{
			path: "investorAssumptions.commercialShareThreshold",
			label: "Commercial Share Threshold, %"
		},
		{
			path: "investorAssumptions.preferredLocationsThreshold",
			label: "Preferred Locations"
		},
		{
			path: "assumptions.landRegistry",
			label: "Land Registry"
		},
		{
			path: "assumptions.exitMultipleRunningResiSpace",
			label: "Exit Multiple Running Resi Space"
		},
		{
			path: "assumptions.exitMultipleReletResiSpace",
			label: "Exit Multiple Relet Resi Space"
		},
		{
			path: "assumptions.exitMultipleExpansionSpace",
			label: "Exit Multiple Expansion Space"
		},
		{
			path: "assumptions.exitMultipleCommercial",
			label: "Exit Multiple Commercial"
		},
		{
			path: "assumptions.exitMultipleParking",
			label: "Exit Multiple Parking"
		},
		{
			path: "assumptions.tIsClass1UpperLimit",
			label: "TIs Class1 Upper Limit"
		},
		{
			path: "assumptions.tIsClass2UpperLimit",
			label: "TIs Class2 Upper Limit"
		},
		{
			path: "assumptions.tIsClass3UpperLimit",
			label: "TIs Class3 Upper Limit"
		},
		{
			path: "assumptions.targetTIsAdjCat1",
			label: "Target TIs Adj. Cat1"
		},
		{
			path: "assumptions.targetTIsAdjCat2",
			label: "Target TIs Adj. Cat2"
		},
		{
			path: "assumptions.targetTIsAdjCat3",
			label: "Target TIs Adj. Cat3"
		},
		{
			path: "assumptions.targetTIsAdjCat4",
			label: "Target TIs Adj. Cat4"
		},
		{
			path: "assumptions.startSubsidizedCommittmentFee",
			label: "Start Subsidized Committment Fee"
		},
		{
			path: "assumptions.startNonSubsidizedCommittmentFee",
			label: "Start Non Subsidized Committment Fee"
		},
		{
			path: "assumptions.ifbSubsidyCap",
			label: "IFB Subsidy Cap"
		},
		{
			path: "assumptions.nextBuyerTransactionCosts",
			label: "Next Buyer Transaction Costs"
		},
		{
			path: "assumptions.acquisitionType",
			label: "Acquisition Type"
		},
		{
			path: "assumptions.exitType",
			label: "Exit (Disposition) Type"
		},
		{
			path: "assumptions.expectedExitVolume",
			label: "Expected Exit Volume"
		},
		{
			label: "Working capital for equity first non-subsidized CAPEX",
			path: "assumptions.workingCapitalForEquityFirstNonSubsidizedCapex"
		},
		{
			path: "assumptions.subsidizedCapexLoanMaturityDate",
			label: "Subsidized CAPEX Loan Maturity"
		}
	];
	mfhInvestmentCaseFieldTranslationsByPath = mfhInvestmentCaseFieldTranslations.reduce((acc, field) => {
		acc[field.path] = field;
		return acc;
	}, {});
	getCellConfig = (key, item, _isCalcEngineResult, formatter) => {
		const format = getTableCellFormat(formatter);
		if (isNil(item)) return {
			key,
			value: null,
			formatted: null,
			format
		};
		if (isCompressedTriple(item)) {
			const [, error, value] = item;
			if (error) return {
				key,
				value: null,
				err: error.message,
				format
			};
			const cellValue = value !== void 0 ? value : null;
			return {
				key,
				value: cellValue,
				formatted: formatter?.(cellValue) ?? cellValue,
				format
			};
		}
		return {
			key,
			value: item,
			formatted: formatter?.(item) ?? item,
			format
		};
	};
	createFromIndexToTabularData = (indexMappings, isCalcEngineResult, defaultFormatters) => (key, kpi, formatters) => {
		if (!kpi) return {};
		let valuesArray = [];
		if (isCompressedTriple(kpi)) {
			const [type, error, value] = kpi;
			if (type === 2 && Array.isArray(value)) valuesArray = value;
			else if (type === 3 && Array.isArray(value)) throw new UnsupportedError(`Matrix-Triple values are not allowed in legacy row-matrixes`);
			else if (type === 1) valuesArray = [value];
			else valuesArray = [error];
		} else if (Array.isArray(kpi)) valuesArray = kpi;
		else valuesArray = [kpi];
		if (!valuesArray.length) return {};
		return indexMappings.reduce((acc, mapping, i) => {
			const formatter = formatters?.[mapping] ?? defaultFormatters?.[mapping];
			const item = valuesArray[i];
			acc[mapping] = getCellConfig(key, item, isCalcEngineResult, formatter);
			return acc;
		}, {});
	};
	translateTableLabel = (translateLabel, key, defaultValue) => translateLabel?.(key, defaultValue) ?? defaultValue;
	translatedMetric = (translateLabel, key, defaultValue) => ({ value: translateTableLabel(translateLabel, `metrics.${key}`, defaultValue) });
	translatedHeaders = (translateLabel, headers) => Object.fromEntries(Object.entries(headers).map(([key, value]) => [key, translateTableLabel(translateLabel, `headers.${key}`, value)]));
	formatMFHSheetsData = {
		subsidies: (ic, target, isCalcEngineResult = true, translateLabel) => {
			const subsidiesFromIndexToTabularData = createFromIndexToTabularData([
				"perProperty",
				"perUnit",
				"perSqm",
				"perKwhYearly",
				"percentTotalSubsidies",
				"subsidyRate"
			], isCalcEngineResult, {
				perProperty: tableCellFormatter.currency,
				perUnit: tableCellFormatter.currency,
				perSqm: tableCellFormatter.currencySqm,
				perKwhYearly: tableCellFormatter.currency,
				percentTotalSubsidies: tableCellFormatter.percent,
				subsidyRate: tableCellFormatter.percent
			});
			return {
				rows: !ic?.sheetsSubsidies?.[target] ? [] : [
					{
						metric: translatedMetric(translateLabel, "kfwRepaymentSubsidyResidentialUnit", "KfW repayment subsidy in % per residential unit"),
						...subsidiesFromIndexToTabularData("h_cal_subsidies__subsidies_table_kfw_repayment_subsidy_in_percent_per_residential_unit_combined", ic.sheetsSubsidies[target].h_cal_subsidies__subsidies_table_kfw_repayment_subsidy_in_percent_per_residential_unit_combined)
					},
					{
						metric: translatedMetric(translateLabel, "kfwMfhConstructionSupervisionResidentialUnit", "KfW MFH construction supervision per residential unit"),
						...subsidiesFromIndexToTabularData("h_cal_subsidies__subsidies_table_kfw_mfh_construction_supervision_per_residential_unit_combined", ic.sheetsSubsidies[target].h_cal_subsidies__subsidies_table_kfw_mfh_construction_supervision_per_residential_unit_combined)
					},
					{
						metric: translatedMetric(translateLabel, "kfwWpbBonusResidentialUnit", "KfW WPB Bonus per residential unit"),
						...subsidiesFromIndexToTabularData("h_cal_subsidies__subsidies_table_kfw_wpb_bonus_per_residential_unit_combined", ic.sheetsSubsidies[target].h_cal_subsidies__subsidies_table_kfw_wpb_bonus_per_residential_unit_combined)
					},
					{
						metric: translatedMetric(translateLabel, "subTotalKfw", "Sub-Total KfW"),
						...subsidiesFromIndexToTabularData("h_cal_subsidies__subsidies_table_sub_total_kfw_combined", ic.sheetsSubsidies[target].h_cal_subsidies__subsidies_table_sub_total_kfw_combined)
					},
					{
						metric: translatedMetric(translateLabel, "ifbBasicSubsidyResidentialUnit", "IfB Basic subsidy per residential unit"),
						...subsidiesFromIndexToTabularData("h_cal_subsidies__subsidies_table_ifb_basic_subsidy_per_residential_unit_combined", ic.sheetsSubsidies[target].h_cal_subsidies__subsidies_table_ifb_basic_subsidy_per_residential_unit_combined)
					},
					{
						metric: translatedMetric(translateLabel, "ifbEnergyConsultancy", "IfB Energy Consultancy"),
						...subsidiesFromIndexToTabularData("h_cal_subsidies__subsidies_table_ifb_energy_consultancy_combined", ic.sheetsSubsidies[target].h_cal_subsidies__subsidies_table_ifb_energy_consultancy_combined)
					},
					{
						metric: translatedMetric(translateLabel, "ifbEnergyQualityAssurance", "IfB Energy quality assurance"),
						...subsidiesFromIndexToTabularData("h_cal_subsidies__subsidies_table_ifb_energy_quality_assurance_combined", ic.sheetsSubsidies[target].h_cal_subsidies__subsidies_table_ifb_energy_quality_assurance_combined)
					},
					{
						metric: translatedMetric(translateLabel, "ifbEfficiencyHouseExistingBuildingsKwhYearly", "IfB Efficiency House in existing buildings per kWh/a"),
						...subsidiesFromIndexToTabularData("h_cal_subsidies__subsidies_table_ifb_efficiency_house_55_in_existing_buildings_per_kwhper_year_combined", ic.sheetsSubsidies[target].h_cal_subsidies__subsidies_table_ifb_efficiency_house_55_in_existing_buildings_per_kwhper_year_combined)
					},
					{
						metric: translatedMetric(translateLabel, "ifbBrickFacades", "IfB Brick facades"),
						...subsidiesFromIndexToTabularData("h_cal_subsidies__subsidies_table_ifb_brick_facades_combined", ic.sheetsSubsidies[target].h_cal_subsidies__subsidies_table_ifb_brick_facades_combined)
					},
					{
						metric: translatedMetric(translateLabel, "ifbBasicSubsidyResiSqm", "IfB Basic subsidy per resi m2"),
						...subsidiesFromIndexToTabularData("h_cal_subsidies__subsidies_table_ifb_basic_subsidy_per_resi_sqm_combined", ic.sheetsSubsidies[target].h_cal_subsidies__subsidies_table_ifb_basic_subsidy_per_resi_sqm_combined)
					},
					{
						metric: translatedMetric(translateLabel, "ifbBrickFacadesMonumentProtection", "IfB Brick facades / monument protection"),
						...subsidiesFromIndexToTabularData("h_cal_subsidies__subsidies_table_ifb_brick_facades_monument_protection_combined", ic.sheetsSubsidies[target].h_cal_subsidies__subsidies_table_ifb_brick_facades_monument_protection_combined)
					},
					{
						metric: translatedMetric(translateLabel, "subTotalIfb", "Sub-Total IfB"),
						...subsidiesFromIndexToTabularData("h_cal_subsidies__subsidies_table_sub_total_ifb_combined", ic.sheetsSubsidies[target].h_cal_subsidies__subsidies_table_sub_total_ifb_combined)
					},
					{
						metric: translatedMetric(translateLabel, "subTotalDus", "Sub-Total DUS"),
						...subsidiesFromIndexToTabularData("h_cal_subsidies__subsidies_table_sub_total_dus_combined", ic.sheetsSubsidies[target].h_cal_subsidies__subsidies_table_sub_total_dus_combined)
					},
					{
						metric: translatedMetric(translateLabel, "totalStateSubsidies", "Total State Subsidies"),
						...subsidiesFromIndexToTabularData("h_cal_subsidies__subsidies_table_total_state_subsidies_combined", ic.sheetsSubsidies[target].h_cal_subsidies__subsidies_table_total_state_subsidies_combined)
					}
				].filter((row) => Object.keys(row).length > 1),
				headers: translatedHeaders(translateLabel, {
					metric: "KPI",
					perProperty: "Per Property",
					perUnit: "Per Unit",
					perSqm: "Per m²",
					perKwhYearly: "Per kWh/a",
					percentTotalSubsidies: "% total subsidies",
					subsidyRate: "Subsidy Rate"
				}),
				extraRows: [{
					label: translateTableLabel(translateLabel, "extraRows.kfwMaxLoan", "KfW Max Loan"),
					...getCellConfig("h_cal_subsidies__max_kfw_loan", ic?.sheetsSubsidies?.[target]?.h_cal_subsidies__max_kfw_loan, isCalcEngineResult, tableCellFormatter.currency)
				}]
			};
		},
		bafaIndividualSubsidies: (ic, target, isCalcEngineResult = true, translateLabel) => {
			const bafaFromIndexToTabularData = createFromIndexToTabularData(["perProperty", "perUnit"], isCalcEngineResult, {
				perProperty: tableCellFormatter.currency,
				perUnit: tableCellFormatter.currency
			});
			return {
				rows: !ic?.sheetsSubsidies?.[target] ? [] : [
					{
						metric: translatedMetric(translateLabel, "bafaEnvelopeSystemsExcludingHeatGeneration", "BAFA Envelope and Systems (excl. Heat Generation)"),
						...bafaFromIndexToTabularData("h_cal_subsidies__subsidies_muc_bafa_individual_measures_on_the_building_envelope_plant_engineering_except_heat_generation", ic.sheetsSubsidies[target].h_cal_subsidies__subsidies_muc_bafa_individual_measures_on_the_building_envelope_plant_engineering_except_heat_generation)
					},
					{
						metric: translatedMetric(translateLabel, "bafaHeatGenerationMeasure", "BAFA Heat Generation Measure"),
						...bafaFromIndexToTabularData("h_cal_subsidies__subsidies_muc_bafa_individual_measure_heat_generation", ic.sheetsSubsidies[target].h_cal_subsidies__subsidies_muc_bafa_individual_measure_heat_generation)
					},
					{
						metric: translatedMetric(translateLabel, "bafaSpecialistPlanningConstructionSupervision", "BAFA Specialist Planning and Construction Supervision"),
						...bafaFromIndexToTabularData("h_cal_subsidies__subsidies_muc_bafa_specialist_planning_and_construction_supervision", ic.sheetsSubsidies[target].h_cal_subsidies__subsidies_muc_bafa_specialist_planning_and_construction_supervision)
					},
					{
						metric: translatedMetric(translateLabel, "bafaTotal", "BAFA Total"),
						...bafaFromIndexToTabularData("h_cal_subsidies__subsidies_muc_bafa_total_beg_individual_measures_subsidy", ic.sheetsSubsidies[target].h_cal_subsidies__subsidies_muc_bafa_total_beg_individual_measures_subsidy)
					}
				],
				headers: translatedHeaders(translateLabel, {
					metric: "KPI",
					perProperty: "Per Property",
					perUnit: "Per Unit"
				}),
				extraRows: []
			};
		},
		munichClimateBuildings: (ic, target, isCalcEngineResult = true, translateLabel) => {
			const fkgFromIndexToTabularData = createFromIndexToTabularData(["perProperty", "perUnit"], isCalcEngineResult, {
				perProperty: tableCellFormatter.currency,
				perUnit: tableCellFormatter.currency
			});
			return {
				rows: !ic?.sheetsSubsidies?.[target] ? [] : [
					{
						metric: translatedMetric(translateLabel, "fkgEnvelopeSystemsExcludingHeatGeneration", "FKG Envelope and Systems (excl. Heat Generation)"),
						...fkgFromIndexToTabularData("h_cal_subsidies__subsidies_muc_fkg_individual_measures_on_the_building_envelope_plant_engineering_except_heat_generation", ic.sheetsSubsidies[target].h_cal_subsidies__subsidies_muc_fkg_individual_measures_on_the_building_envelope_plant_engineering_except_heat_generation)
					},
					{
						metric: translatedMetric(translateLabel, "fkgHeatingReplacement", "FKG Heating Replacement"),
						...fkgFromIndexToTabularData("h_cal_subsidies__subsidies_muc_fkg_individual_measure_heating_replacement", ic.sheetsSubsidies[target].h_cal_subsidies__subsidies_muc_fkg_individual_measure_heating_replacement)
					},
					{
						metric: translatedMetric(translateLabel, "fkgReachEfficiencyStandard", "FKG Reach Efficiency Standard"),
						...fkgFromIndexToTabularData("h_cal_subsidies__subsidies_muc_fkg_achieving_a_rehabilitation_standard", ic.sheetsSubsidies[target].h_cal_subsidies__subsidies_muc_fkg_achieving_a_rehabilitation_standard)
					},
					{
						metric: translatedMetric(translateLabel, "fkgSpecialistPlanningConstructionSupervision", "FKG Specialist Planning and Construction Supervision"),
						...fkgFromIndexToTabularData("h_cal_subsidies__subsidies_muc_fkg_specialist_planning_and_construction_supervision", ic.sheetsSubsidies[target].h_cal_subsidies__subsidies_muc_fkg_specialist_planning_and_construction_supervision)
					},
					{
						metric: translatedMetric(translateLabel, "fkgTotal", "FKG Total"),
						...fkgFromIndexToTabularData("h_cal_subsidies__subsidies_muc_fkg_total_fkg_subsidy", ic.sheetsSubsidies[target].h_cal_subsidies__subsidies_muc_fkg_total_fkg_subsidy)
					}
				],
				headers: translatedHeaders(translateLabel, {
					metric: "KPI",
					perProperty: "Per Property",
					perUnit: "Per Unit"
				}),
				extraRows: []
			};
		},
		heatingExchange: (ic, target, isCalcEngineResult = true, translateLabel) => {
			return {
				rows: !ic?.sheetsSubsidies?.[target] ? [] : [
					{
						metric: translatedMetric(translateLabel, "totalCostsHeatingExchangeOnly", "Total Costs Heating Exchange Only"),
						value: getCellConfig("h_cal_subsidies__muc_kpis_total_costs_heating_exchange_only", ic.sheetsSubsidies[target].h_cal_subsidies__muc_kpis_total_costs_heating_exchange_only, isCalcEngineResult, tableCellFormatter.currency)
					},
					{
						metric: translatedMetric(translateLabel, "heatingExchangeCostsNet", "Heating Exchange Costs Net"),
						value: getCellConfig("h_cal_subsidies__muc_kpis_heating_exchange_costs_net", ic.sheetsSubsidies[target].h_cal_subsidies__muc_kpis_heating_exchange_costs_net, isCalcEngineResult, tableCellFormatter.currency)
					},
					{
						metric: translatedMetric(translateLabel, "condoRenovationFeeNet", "Condo Renovation Fee Net"),
						value: getCellConfig("h_cal_subsidies__muc_kpis_condo_renovation_fee_net", ic.sheetsSubsidies[target].h_cal_subsidies__muc_kpis_condo_renovation_fee_net, isCalcEngineResult, tableCellFormatter.currency)
					},
					{
						metric: translatedMetric(translateLabel, "vatOnCapex", "VAT on CAPEX"),
						value: getCellConfig("h_cal_subsidies__muc_kpis_vat_on_capex", ic.sheetsSubsidies[target].h_cal_subsidies__muc_kpis_vat_on_capex, isCalcEngineResult, tableCellFormatter.currency)
					},
					{
						metric: translatedMetric(translateLabel, "vatOnCondoFee", "VAT on Condo Fee"),
						value: getCellConfig("h_cal_subsidies__muc_kpis_vat_on_condo_fee", ic.sheetsSubsidies[target].h_cal_subsidies__muc_kpis_vat_on_condo_fee, isCalcEngineResult, tableCellFormatter.currency)
					},
					{
						metric: translatedMetric(translateLabel, "subsidyCap", "Subsidy Cap"),
						value: getCellConfig("h_cal_subsidies__muc_kpis_subsidy_cap", ic.sheetsSubsidies[target].h_cal_subsidies__muc_kpis_subsidy_cap, isCalcEngineResult, tableCellFormatter.currency)
					},
					{
						metric: translatedMetric(translateLabel, "subsidyCapWe1", "Subsidy Cap WE 1"),
						value: getCellConfig("h_cal_subsidies__muc_kpis_num_of_we_in_bucket_1_first_we", ic.sheetsSubsidies[target].h_cal_subsidies__muc_kpis_num_of_we_in_bucket_1_first_we, isCalcEngineResult, tableCellFormatter.currency)
					},
					{
						metric: translatedMetric(translateLabel, "subsidyCapWe2To6", "Subsidy Cap WE 2-6"),
						value: getCellConfig("h_cal_subsidies__muc_kpis_num_of_we_in_bucket_2_2_6_we", ic.sheetsSubsidies[target].h_cal_subsidies__muc_kpis_num_of_we_in_bucket_2_2_6_we, isCalcEngineResult, tableCellFormatter.currency)
					},
					{
						metric: translatedMetric(translateLabel, "subsidyCapWe7Plus", "Subsidy Cap WE 7+"),
						value: getCellConfig("h_cal_subsidies__muc_kpis_num_of_we_in_bucket_2_7_we", ic.sheetsSubsidies[target].h_cal_subsidies__muc_kpis_num_of_we_in_bucket_2_7_we, isCalcEngineResult, tableCellFormatter.currency)
					},
					{
						metric: translatedMetric(translateLabel, "totalEligibleCostsEeCapexBafa", "Total Eligible Costs from EE CAPEX BAFA"),
						value: getCellConfig("h_cal_subsidies__muc_kpis_total_eligble_costs_from_ee_capex_for_bafa", ic.sheetsSubsidies[target].h_cal_subsidies__muc_kpis_total_eligble_costs_from_ee_capex_for_bafa, isCalcEngineResult, tableCellFormatter.currency)
					},
					{
						metric: translatedMetric(translateLabel, "totalEligibleCostsEeCapexFkg", "Total Eligible Costs from EE CAPEX FKG"),
						value: getCellConfig("h_cal_subsidies__muc_kpis_total_eligble_costs_from_ee_capex_for_fkg", ic.sheetsSubsidies[target].h_cal_subsidies__muc_kpis_total_eligble_costs_from_ee_capex_for_fkg, isCalcEngineResult, tableCellFormatter.currency)
					}
				],
				headers: translatedHeaders(translateLabel, {
					metric: "KPI",
					value: "Value"
				}),
				extraRows: []
			};
		},
		kfw261: (ic, target, isCalcEngineResult = true, translateLabel) => {
			return {
				rows: !ic?.sheetsSubsidies?.[target] ? [] : [
					{
						metric: translatedMetric(translateLabel, "totalEligibleCostsKfw", "Total Eligible Costs KfW"),
						value: getCellConfig("h_cal_subsidies__kpis_total_eligble_costs", ic.sheetsSubsidies[target].h_cal_subsidies__kpis_total_eligble_costs, isCalcEngineResult, tableCellFormatter.currency)
					},
					{
						metric: translatedMetric(translateLabel, "totalRenovationCostsNet", "Total Renovation Costs Net"),
						value: getCellConfig("h_cal_subsidies__kpis_total_renovation_costs_ee_net", ic.sheetsSubsidies[target].h_cal_subsidies__kpis_total_renovation_costs_ee_net, isCalcEngineResult, tableCellFormatter.currency)
					},
					{
						metric: translatedMetric(translateLabel, "shareOfExtensionAttributableNet", "Share of Extension Attributable Net"),
						value: getCellConfig("h_cal_subsidies__kpis_share_of_extension_attributable_net", ic.sheetsSubsidies[target].h_cal_subsidies__kpis_share_of_extension_attributable_net, isCalcEngineResult, tableCellFormatter.currency)
					},
					{
						metric: translatedMetric(translateLabel, "vatOnCapex", "VAT on CAPEX"),
						value: getCellConfig("h_cal_subsidies__kpis_vat_on_capex", ic.sheetsSubsidies[target].h_cal_subsidies__kpis_vat_on_capex, isCalcEngineResult, tableCellFormatter.currency)
					},
					{
						metric: translatedMetric(translateLabel, "condoRenovationFeeAttributableNet", "Condo Renovation Fee Attributable Net"),
						value: getCellConfig("h_cal_subsidies__kpis_condo_renovation_fee_attributable_net", ic.sheetsSubsidies[target].h_cal_subsidies__kpis_condo_renovation_fee_attributable_net, isCalcEngineResult, tableCellFormatter.currency)
					},
					{
						metric: translatedMetric(translateLabel, "vatOnCondoFee", "VAT on Condo Fee"),
						value: getCellConfig("h_cal_subsidies__kpis_vat_on_condo_fee", ic.sheetsSubsidies[target].h_cal_subsidies__kpis_vat_on_condo_fee, isCalcEngineResult, tableCellFormatter.currency)
					},
					{
						metric: translatedMetric(translateLabel, "numberOfWeRelevantForSubsidyCalculation", "Number of WE Relevant for Subsidy Calculation"),
						value: getCellConfig("h_cal_subsidies__kpis_num_of_of_we_relevant_for_subsidy_calculation", ic.sheetsSubsidies[target].h_cal_subsidies__kpis_num_of_of_we_relevant_for_subsidy_calculation, isCalcEngineResult, tableCellFormatter.numeric)
					},
					{
						metric: translatedMetric(translateLabel, "capForTotalStateSubsidies", "Cap for Total State Subsidies"),
						value: getCellConfig("h_cal_subsidies__kpis_cap_for_total_state_subsidies", ic.sheetsSubsidies[target].h_cal_subsidies__kpis_cap_for_total_state_subsidies, isCalcEngineResult, tableCellFormatter.currency)
					}
				],
				headers: translatedHeaders(translateLabel, {
					metric: "KPI",
					value: "Value"
				}),
				extraRows: []
			};
		}
	};
	MFHD2GSettingBegEmSubsidiesI18n = {
		["Individual measure shell/systems with EH 55 standard"]: "Einzelmaßnahme Hülle/Anlagen mit EH 55 Standard",
		["Individual measure shell/systems without EH standard"]: "Einzelmaßnahme Hülle/Anlagen ohne EH Standard",
		["Individual measure shell + heating measure"]: "Einzelmaßnahme Hülle/Heizung",
		["Individual heating measure"]: "Einzelmaßnahme Heizung",
		["OFF"]: "OFF"
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/mfh-investment-case-kpi-calc-engine-keys/mfh-investment-case-kpi-calc-engine-keys.5_6_0.ts
var MFH_INVESTMENT_CASE_KPI_CALC_ENGINE_KEYS_V5_6_0;
var init_mfh_investment_case_kpi_calc_engine_keys_5_6_0 = __esmMin((() => {
	MFH_INVESTMENT_CASE_KPI_CALC_ENGINE_KEYS_V5_6_0 = {
		irrPercentage: "a_cal_cf_engine__levered_deal_cf_post_tax_post_promote_irr",
		mocMultiplier: "a_cal_cf_engine__levered_deal_cf_post_tax_post_equity_adj_pre_promote_moc",
		mocPostTaxPostPromote: "a_cal_cf_engine__levered_deal_cf_post_tax_post_promote_moc",
		cocPercentage: "b_out_ic_charts__ic_yields_coc_year_1_post_completion",
		investmentVolume: "b_out_ic_charts__value_bridge_pre_lever_tax_w_grant_aic_post_grant_total",
		ltv: "b_out_ic_charts__financing_total_loan_amount_incl_subsidy_loan_as_percent_of_gdp",
		partnerFees: "b_out_ic_charts__ic_uses_partner_fees_euro",
		commercialAreaEntry: "b_out_ic_charts__bp_area_buy_business",
		totalAreaEntry: "b_out_ic_charts__bp_area_buy_subtotal",
		residentialAreaEntry: "b_out_ic_charts__bp_area_buy_residential_stock",
		parkingAreaEntry: "b_out_ic_charts__bp_area_buy_park",
		averageUnitSizeSqm: "b_out_ic_charts__average_unit_size_sqm",
		nlaEntryExit: "b_out_ic_charts__ic_entry_exit_nla",
		holdingPeriodMonths: "b_cal_gri__global_nri_total_vacancy_blended_exit_factor_gdp_total",
		purchasePrice: "b_out_ic_charts__bank_cashflow_net_purchase_price_npp_total",
		capex: "b_out_ic_charts__financing_total_loan_amount_incl_subsidy_capex_excl_vat",
		rentDevelopment: "b_out_ic_charts__bp_assump_implied_nri_uplift_potential",
		disposalPrice: "b_out_ic_charts__bank_cashflow_selling_price_gdp_total",
		nriPerYearEntry: "b_out_ic_charts__ic_entry_exit_nri_per_year_excl_vacancy_rent",
		resiNriPsmPmEntry: "b_out_ic_charts__ic_entry_exit_nri_p_m_psqm_resi",
		resiNriPsmPmExit: "b_out_ic_charts__ic_entry_exit_nri_p_m_psqm_resi",
		commercialRentEntry: "b_out_ic_charts__bp_rent_buy_business",
		parkingRentEntry: "b_out_ic_charts__bp_rent_buy_park",
		nppEntry: "b_out_ic_charts__ic_entry_exit_npp_vs_gross_disposal_price",
		nppPsmEntry: "b_out_ic_charts__ic_entry_exit_npp_vs_gross_disposal_price_psm",
		nriMultipleEntry: "b_out_ic_charts__ic_entry_exit_nri_multiple",
		grossPurchasePrice: "b_out_ic_charts__value_bridge_pre_lever_tax_gross_purchase_price_total",
		tenantImprovementsCapexPsmEntry: "b_out_ic_charts__value_bridge_pre_lever_tax_tenant_improvements_sqm_entry",
		generalCapexPsmEntry: "b_out_ic_charts__value_bridge_pre_lever_tax_capex_general_sqm_entry",
		energyEfficiencyCapexPsmEntry: "b_out_ic_charts__value_bridge_pre_lever_tax_capex_energy_efficiency_sqm_entry",
		expansionCapexPsmEntry: "b_out_ic_charts__value_bridge_pre_lever_tax_capex_expansion_sqm_entry",
		epcRatingGoingIn: "a_crm_input__epc_rating_going_in",
		epcRatingGoingOut: "a_crm_input__epc_rating_going_out",
		expansionPotentialSqm: "b_out_ic_charts__expansion_potential_sqm",
		residentialExpansionAreaEntry: "b_out_ic_charts__bp_area_buy_residential_expansion",
		residentialAreaExit: "b_out_ic_charts__bp_area_sell_residential_stock",
		residentialExpansionAreaExit: "b_out_ic_charts__bp_area_sell_residential_expansion",
		commercialAreaExit: "b_out_ic_charts__bp_area_sell_business",
		modernizationLevyPsmPm: "f_cal_input_rent_roll__capex_helpers_8_percent_increase_per_annum_sqm_monat",
		eeTopUpModernizationLevy: "e_cal_output_rent_roll__rent_development_ee_top_up_approx",
		unrefurbishedResidentialAreaMonthly: "b_out_ic_charts__rental_existing_rent_resi_net_leasable_area_nmf_monthly",
		refurbishedResidentialAreaMonthly: "b_out_ic_charts__rental_new_rentals_resi_renovatiation_empty_apt_nmf_monthly",
		expansionResidentialAreaMonthly: "b_out_ic_charts__rental_new_rentals_resi_shell_space_nmf_monthly",
		existingRentPsmPmMonthly: "b_out_ic_charts__rental_existing_rent_resi_nm_sqm_p_m_monthly",
		refurbishedNewLettingRentPsmPmMonthly: "b_out_ic_charts__rental_new_rentals_resi_renovatiation_empty_apt_nm_sqm_p_m_monthly",
		expansionNewLettingRentPsmPmMonthly: "b_out_ic_charts__rental_new_rentals_resi_shell_space_nm_sqm_p_m_monthly",
		blendedErvPsmPmMonthly: "b_out_ic_charts__rental_new_rentals_resi_shell_space_living_space_o_nm_sqm_p_m_monthly",
		rentalTableDates: "b_out_ic_charts__rental_table_monthly_dates",
		rentalTableQuarters: "b_out_ic_charts__rental_table_quarters",
		parkingAreaExit: "b_out_ic_charts__bp_area_sell_park",
		modernizationLevyAveragePsmPm: "b_cal_gri__ee_top_up_by_component_total",
		grossDisposalProceeds: "a_cal_cf_engine__unlevered_operating_cf_pre_tax_gross_dispo_proceeds_total",
		dcf: {
			yearCounts: "a_cal_cf_engine__year_year_counts",
			unlevered: {
				nri: {
					total: "a_cal_cf_engine__rental_income_rental_income_nri_total",
					yearly: "a_cal_cf_engine__rental_income_rental_income_nri_yearly"
				},
				totalOpexNriLeakage: {
					total: "a_cal_cf_engine__rental_income_total_opex_nri_leakage_total",
					yearly: "a_cal_cf_engine__rental_income_total_opex_nri_leakage_yearly"
				},
				noi: {
					total: "a_cal_cf_engine__net_operating_income_net_operating_income_total",
					yearly: "a_cal_cf_engine__net_operating_income_net_operating_income_yearly"
				},
				capexEeExtensionGeneral: {
					total: "b_out_ic_charts__annual_cashflow_capex_ee_extension_general_total",
					yearly: "b_out_ic_charts__annual_cashflow_capex_ee_extension_general_yearly",
					commentRate: "b_out_ic_charts__annual_cashflow_noi_capex_ee_extension_general_on_acquired_area"
				},
				tis: {
					total: "b_out_ic_charts__annual_cashflow_tis_total",
					yearly: "b_out_ic_charts__annual_cashflow_tis_yearly",
					commentRate: "b_out_ic_charts__annual_cashflow_noi_tis_psm_re_let_area"
				},
				vatLossOnCapexTi: {
					total: "a_cal_cf_engine__net_operating_income_vat_loss_on_capex_total",
					yearly: "a_cal_cf_engine__net_operating_income_vat_loss_on_capex_yearly"
				},
				compensationWantedTenantChurn: {
					total: "b_out_ic_charts__annual_cashflow_compensation_for_wanted_tenant_churn_resi_commercial_total",
					yearly: "b_out_ic_charts__annual_cashflow_compensation_for_wanted_tenant_churn_resi_commercial_yearly"
				},
				stateCashSubsidies: {
					total: "a_cal_cf_engine__net_operating_income_state_cash_subsidies_grants_total",
					yearly: "a_cal_cf_engine__net_operating_income_state_cash_subsidies_grants_yearly"
				},
				acquisitionFee: {
					total: "a_cal_cf_engine__net_operating_income_condo_acquisition_fee_total",
					yearly: "a_cal_cf_engine__net_operating_income_condo_acquisition_fee_yearly",
					commentRate: "a_crm_input__condo_purchasing_service_fee"
				},
				capexTiManagementFee: {
					total: "a_cal_cf_engine__net_operating_income_condo_capex_ti_management_fee_total",
					yearly: "a_cal_cf_engine__net_operating_income_condo_capex_ti_management_fee_yearly",
					commentRate: "a_crm_input__condo_renovation_service_fee"
				},
				propertyManagementFee: {
					total: "a_cal_cf_engine__net_operating_income_condo_property_management_fee_total",
					yearly: "a_cal_cf_engine__net_operating_income_condo_property_management_fee_yearly",
					commentRate: "a_crm_input__condo_property_management_fee_flat_month"
				},
				lettingFees: {
					total: "b_out_ic_charts__annual_cashflow_letting_fees_resi_commercial_total",
					yearly: "b_out_ic_charts__annual_cashflow_letting_fees_resi_commercial_yearly",
					commentRate: "b_out_ic_charts__annual_cashflow_noi_letting_fees_resi_commercial_num_of_monthly_nri"
				},
				assetManagementFee: {
					total: "a_cal_cf_engine__net_operating_income_condo_asset_management_fee_total",
					yearly: "a_cal_cf_engine__net_operating_income_condo_asset_management_fee_yearly",
					commentRate: "a_crm_input__condo_asset_management_fee_of_gav"
				},
				dispositionFee: {
					total: "a_cal_cf_engine__net_operating_income_condo_disposition_fee_total",
					yearly: "a_cal_cf_engine__net_operating_income_condo_disposition_fee_yearly",
					commentRate: "a_crm_input__condo_disposition_fee"
				},
				vatLossOnPartnerFees: {
					total: "a_cal_cf_engine__net_operating_income_vat_damage_partner_fees_total",
					yearly: "a_cal_cf_engine__net_operating_income_vat_damage_partner_fees_yearly"
				},
				npp: {
					total: "a_cal_cf_engine__unlevered_operating_cf_pre_tax_net_purchase_price_total",
					yearly: "a_cal_cf_engine__unlevered_operating_cf_pre_tax_net_purchase_price_yearly",
					commentRate: "b_out_ic_charts__annual_cashflow_noi_npp_nri"
				},
				transactionCosts: {
					total: "b_out_ic_charts__annual_cashflow_transaction_costs_total",
					yearly: "b_out_ic_charts__annual_cashflow_transaction_costs_yearly",
					commentRate: "b_out_ic_charts__annual_cashflow_noi_transaction_costs_on_npp_incl_vat"
				},
				gdp: {
					total: "a_cal_cf_engine__unlevered_operating_cf_pre_tax_gross_dispo_proceeds_total",
					yearly: "a_cal_cf_engine__unlevered_operating_cf_pre_tax_gross_dispo_proceeds_yearly",
					commentRate: "b_cal_gri__global_nri_total_vacancy_blended_exit_factor_gdp_total"
				},
				disposalCosts: {
					total: "a_cal_cf_engine__unlevered_operating_cf_pre_tax_disposal_costs_total",
					yearly: "a_cal_cf_engine__unlevered_operating_cf_pre_tax_disposal_costs_yearly",
					commentRate: "b_out_ic_charts__annual_cashflow_noi_disposal_costs_on_gdp"
				},
				unleveredDealCfPreTax: {
					total: "a_cal_cf_engine__unlevered_deal_cf_pre_tax_unleveraged_deal_cf_pre_tax_total",
					yearly: "a_cal_cf_engine__unlevered_deal_cf_pre_tax_unleveraged_deal_cf_pre_tax_yearly"
				}
			},
			levered: {
				seniorDrawDown: {
					total: "b_out_ic_charts__annual_cashflow_senior_debt_draw_down_total",
					yearly: "a_cal_cf_engine__unlevered_deal_cf_pre_tax_draw_down_acq_yearly"
				},
				seniorInterest: {
					total: "b_out_ic_charts__annual_cashflow_senior_debt_interest_payment_total",
					yearly: "a_cal_cf_engine__unlevered_deal_cf_pre_tax_interest_payment_acq_senior_debt_yearly",
					commentRate: "b_crm_console__senior_debt_interest_rate"
				},
				seniorAmortization: {
					total: "b_out_ic_charts__annual_cashflow_senior_debt_amortization_total",
					yearly: "b_out_ic_charts__annual_cashflow_senior_debt_amortization_yearly"
				},
				seniorFinancingFees: {
					total: "b_out_ic_charts__annual_cashflow_senior_debt_financing_fees_total",
					yearly: "a_cal_cf_engine__unlevered_deal_cf_pre_tax_financing_fees_sen_debt_upfront_fee_yearly",
					commentRate: "a_crm_input__senior_debt_upfront_fee"
				},
				regularCapexTiDrawDown: {
					total: "b_out_ic_charts__annual_cashflow_regular_capex_ti_debt_draw_down_total",
					yearly: "a_cal_cf_engine__levered_deal_cf_post_senior_debt_pre_tax_draw_down_acq_yearly"
				},
				regularCapexTiInterest: {
					total: "b_out_ic_charts__annual_cashflow_regular_capex_ti_debt_interest_payment_total",
					yearly: "a_cal_cf_engine__levered_deal_cf_post_senior_debt_pre_tax_interest_payment_acq_capex_non_subsidized_debt_yearly",
					commentRate: "a_crm_input__capex_non_subsidized_debt_interest_rate"
				},
				regularCapexTiCommitmentFee: {
					total: "b_out_ic_charts__annual_cashflow_regular_capex_ti_debt_commitment_fee_total",
					yearly: "a_cal_cf_engine__levered_deal_cf_post_senior_debt_pre_tax_commitment_fee_on_undrawn_capital_capex_non_subsidized_debt_yearly",
					commentRate: "b_crm_console__capex_non_subsidized_debt_commitment_fee"
				},
				regularCapexTiAmortization: {
					total: "b_out_ic_charts__annual_cashflow_regular_capex_ti_debt_amortization_total",
					yearly: "b_out_ic_charts__annual_cashflow_regular_capex_ti_debt_amortization_yearly"
				},
				regularCapexTiFinancingFees: {
					total: "b_out_ic_charts__annual_cashflow_regular_capex_ti_debt_financing_fees_total",
					yearly: "a_cal_cf_engine__levered_deal_cf_post_senior_debt_pre_tax_financing_fees_upfront_fee_capex_non_subsidized_debt_yearly",
					commentRate: "b_crm_console__capex_non_subsidized_debt_upfront_fee"
				},
				subsidizedDrawDown: {
					total: "b_out_ic_charts__annual_cashflow_subsidized_debt_draw_down_total",
					yearly: "a_cal_cf_engine__levered_deal_cf_post_senior_and_capex_non_subsidized_debt_pre_tax_draw_down_acq_yearly"
				},
				subsidizedInterest: {
					total: "b_out_ic_charts__annual_cashflow_subsidized_debt_interest_payment_total",
					yearly: "a_cal_cf_engine__levered_deal_cf_post_senior_and_capex_non_subsidized_debt_pre_tax_interest_payment_acq_subsidized_yearly",
					commentRate: "b_crm_console__subsidized_interest_rate_bullet_loan"
				},
				subsidizedGrant: {
					total: "b_out_ic_charts__annual_cashflow_subsidized_debt_grant_total",
					yearly: "b_out_ic_charts__annual_cashflow_subsidized_debt_grant_yearly"
				},
				subsidizedAmortizationInclGrant: {
					total: "b_out_ic_charts__annual_cashflow_subsidized_debt_amortization_incl_grant_total",
					yearly: "b_out_ic_charts__annual_cashflow_subsidized_debt_amortization_incl_grant_yearly"
				},
				subsidizedCommitmentFee: {
					total: "b_out_ic_charts__annual_cashflow_subsidized_debt_commitment_fee_total",
					yearly: "a_cal_cf_engine__levered_deal_cf_post_senior_and_capex_non_subsidized_debt_pre_tax_commitment_fee_on_undrawn_capital_subsidized_yearly",
					commentRate: "b_crm_console__subsidized_commitment_fee"
				},
				subsidizedFinancingFees: {
					total: "b_out_ic_charts__annual_cashflow_subsidized_debt_financing_fees_total",
					yearly: "a_cal_cf_engine__levered_deal_cf_post_senior_and_capex_non_subsidized_debt_pre_tax_financing_fees_upfront_fee_capex_subsidized_debt_yearly",
					commentRate: "a_crm_input__capex_subsidized_debt_upfront_fee"
				},
				leveredDealCfPreTax: {
					total: "b_out_ic_charts__annual_cashflow_leveraged_deal_cf_pre_tax_total",
					yearly: "a_cal_cf_engine__levered_deal_cf_post_all_debt_pre_tax_leveraged_deal_cf_post_all_debt_pre_tax_yearly"
				},
				corporateTaxes: {
					total: "b_out_ic_charts__annual_cashflow_corporate_taxes_total",
					yearly: "a_cal_cf_engine__levered_deal_cf_post_all_debt_pre_tax_corporate_income_tax_yearly",
					commentRate: "a_cal_cf_engine__levered_deal_cf_post_all_debt_pre_tax_coporate_income_tax"
				},
				leveredDealCfPostTaxPrePromote: {
					total: "b_out_ic_charts__annual_cashflow_leveraged_deal_cf_post_tax_pre_promote_total",
					yearly: "a_cal_cf_engine__levered_deal_cf_post_all_debt_pre_tax_leveraged_deal_cf_post_tax_pre_promote_yearly"
				},
				promoteToPartner: {
					total: "b_out_ic_charts__annual_cashflow_promote_to_partner_total",
					yearly: "a_cal_cf_engine__promote_to_partner_yearly"
				},
				leveredDealCfPostTaxPostPromote: {
					total: "b_out_ic_charts__annual_cashflow_leveraged_deal_cf_post_tax_post_promote_total",
					yearly: "a_cal_cf_engine__levered_deal_cf_post_tax_post_promote_yearly"
				},
				summary: {
					irr: "a_cal_cf_engine__levered_deal_cf_post_tax_post_promote_irr",
					moc: "a_cal_cf_engine__levered_deal_cf_post_tax_post_promote_moc",
					totalContributions: "a_cal_cf_engine__levered_deal_cf_post_tax_post_promote_total_contributions",
					totalDistributions: "a_cal_cf_engine__levered_deal_cf_post_tax_post_promote_total_distributions",
					totalProfits: "a_cal_cf_engine__levered_deal_cf_post_tax_post_promote_total"
				}
			}
		},
		cashFlow: {
			yearCounts: "a_cal_cf_engine__year_year_counts",
			entryDatesByYear: "b_out_ic_charts__annual_cashflow_entry_dates_by_year",
			leveredDealCfPostTaxPostPromoteYearly: "a_cal_cf_engine__levered_deal_cf_post_tax_post_promote_yearly",
			netOperatingIncomeYearly: "a_cal_cf_engine__net_operating_income_net_operating_income_yearly",
			noiBridge: {
				entryNoi: "b_out_ic_charts__rent_dist_in_place_nri",
				lettingVacantUnits: "b_out_ic_charts__rent_dist_rental_of_vacant_properties",
				rentIncreases: "b_out_ic_charts__rent_dist_rent_increases",
				modernizationLevy: "b_out_ic_charts__rent_dist_modernization_levy",
				newLettingAfterRenovation: "b_out_ic_charts__rent_dist_new_letting_after_renovation",
				additionalResidentialArea: "b_out_ic_charts__rent_dist_additional_residential_area",
				initialVacantCommercialSpaceNewlyLet: "b_out_ic_charts__rent_dist_initial_vacancy_commercial_space_newly_let",
				newCommercialLetting: "b_out_ic_charts__rent_dist_new_commercial_lease",
				vacantParkingLetting: "b_out_ic_charts__rent_dist_free_parking_rental_possible",
				newParkingLetting: "b_out_ic_charts__rent_dist_parking_space_for_new_rental",
				additionalParkingSpaces: "b_out_ic_charts__rent_dist_additional_parking_space",
				exitNoi: "b_out_ic_charts__rent_dist_in_total"
			}
		},
		financing: {
			sourcesUses: {
				usesNetPurchasePrice: {
					euro: "b_out_ic_charts__ic_uses_net_purchase_price_euro",
					percent: "b_out_ic_charts__ic_uses_net_purchase_price_percent"
				},
				usesClosingCostsExclFinancing: {
					euro: "b_out_ic_charts__ic_uses_closing_costs_excl_financing_euro",
					percent: "b_out_ic_charts__ic_uses_closing_costs_excl_financing_percent"
				},
				usesTIsLCsTenantCompensations: {
					euro: "b_out_ic_charts__ic_uses_tis_l_cs_tenant_compensations_euro",
					percent: "b_out_ic_charts__ic_uses_tis_l_cs_tenant_compensations_percent"
				},
				usesCapexEnergyEfficiency: {
					euro: "b_out_ic_charts__ic_uses_capex_ee_euro",
					percent: "b_out_ic_charts__ic_uses_capex_ee_percent"
				},
				usesCapexExpansion: {
					euro: "b_out_ic_charts__ic_uses_capex_expansion_euro",
					percent: "b_out_ic_charts__ic_uses_capex_expansion_percent"
				},
				usesCapexGeneral: {
					euro: "b_out_ic_charts__ic_uses_capex_general_euro",
					percent: "b_out_ic_charts__ic_uses_capex_general_percent"
				},
				usesPartnerFees: {
					euro: "b_out_ic_charts__ic_uses_partner_fees_euro",
					percent: "b_out_ic_charts__ic_uses_partner_fees_percent"
				},
				usesFinancingCosts: {
					euro: "b_out_ic_charts__ic_uses_financing_costs_euro",
					percent: "b_out_ic_charts__ic_uses_financing_costs_percent"
				},
				usesVat: {
					euro: "b_out_ic_charts__ic_uses_vat_euro",
					percent: "b_out_ic_charts__ic_uses_vat_percent"
				},
				usesTotal: {
					euro: "b_out_ic_charts__ic_uses_total_euro",
					percent: "b_out_ic_charts__ic_uses_total_percent"
				},
				sourcesDebtSenior: {
					euro: "a_cal_cf_engine__unlevered_deal_cf_pre_tax_draw_down_acq_total",
					percent: "b_out_ic_charts__ic_s_u_debt_senior_percent"
				},
				sourcesDebtCapexTiNonSubsidized: {
					euro: "a_cal_cf_engine__levered_deal_cf_post_senior_debt_pre_tax_draw_down_acq_total",
					percent: "b_out_ic_charts__ic_s_u_debt_capex_ti_non_subsidized_percent"
				},
				sourcesDebtCapexSubsidizedInclGrant: {
					euro: "a_cal_cf_engine__levered_deal_cf_post_senior_and_capex_non_subsidized_debt_pre_tax_committed_capex_debt_subsidized_total",
					percent: "b_out_ic_charts__ic_s_u_debt_capex_subsidized_incl_grant_percent"
				},
				sourcesEquity: {
					euro: "a_cal_cf_engine__levered_deal_cf_post_tax_post_promote_total_contributions",
					percent: "b_out_ic_charts__ic_s_u_equity_percent"
				},
				sourcesCashCollectedNoi: {
					euro: "b_out_ic_charts__ic_s_u_cash_collected_noi_euro",
					percent: "b_out_ic_charts__ic_s_u_cash_collected_noi_percent"
				},
				sourcesTotal: {
					euro: "b_out_ic_charts__ic_s_u_total_euro",
					percent: "b_out_ic_charts__ic_s_u_total_percent"
				}
			},
			seniorDebt: {
				loanToCost: "a_cal_cf_engine__unlevered_deal_cf_pre_tax_senior_debt_bank_ltv",
				amount: "a_cal_cf_engine__unlevered_deal_cf_pre_tax_draw_down_acq_total",
				interestRate: "b_crm_console__senior_debt_interest_rate",
				amortizationStartQuarter: "b_out_ic_charts__financing_senior_debt_am_start_q",
				upfrontFee: "a_crm_input__senior_debt_upfront_fee",
				runningAmortization: "a_cal_cf_engine__unlevered_deal_cf_pre_tax_senior_debt_running_am"
			},
			capexAndTenantImprovementDebt: {
				loanToCost: "b_crm_console__capex_non_subsized_debt_ltv",
				amount: "a_cal_cf_engine__levered_deal_cf_post_senior_debt_pre_tax_draw_down_acq_total",
				interestRate: "a_crm_input__capex_non_subsidized_debt_interest_rate",
				amortizationStartQuarter: "b_out_ic_charts__financing_capex_ti_debt_am_start_q",
				commitmentFee: "b_crm_console__capex_non_subsidized_debt_commitment_fee",
				upfrontFee: "b_crm_console__capex_non_subsidized_debt_upfront_fee",
				runningAmortization: "a_cal_cf_engine__levered_deal_cf_post_senior_debt_pre_tax_capex_debt_running_am"
			},
			subsidizedDebt: {
				loanToCost: "a_cal_cf_engine__levered_deal_cf_post_senior_and_capex_non_subsidized_debt_pre_tax_ltv",
				amount: "a_cal_cf_engine__levered_deal_cf_post_senior_and_capex_non_subsidized_debt_pre_tax_committed_capex_debt_subsidized_total",
				interestRate: "b_crm_console__subsidized_interest_rate_bullet_loan",
				amortizationStartQuarter: "b_out_ic_charts__financing_subsidized_debt_am_start_q",
				commitmentFee: "b_crm_console__subsidized_commitment_fee",
				upfrontFee: "a_crm_input__capex_subsidized_debt_upfront_fee",
				runningAmortization: "a_cal_cf_engine__levered_deal_cf_post_senior_and_capex_non_subsidized_debt_pre_tax_running_am",
				grantAmount: "b_out_ic_charts__financing_subsidized_debt_grant_amount",
				grantShareOfLoan: "a_cal_cf_engine__levered_deal_cf_post_senior_and_capex_non_subsidized_debt_pre_tax_grant"
			},
			volumeWeightedCombinedInterestRate: "b_out_ic_charts__financing_volume_weighted_combined_interest_rate",
			combinedFinancing: {
				totalLoanAmount: "b_out_ic_charts__financing_total_loan_amount_total_loan_amount",
				totalCostBase: "b_out_ic_charts__financing_total_loan_amount_total_cost_base",
				grossPurchasePrice: "b_out_ic_charts__ic_entry_exit_gpp_vs_net_disposal_proceeds",
				capexExcludingVat: "b_out_ic_charts__financing_total_loan_amount_capex_excl_vat",
				tenantImprovementsAndLeasingCostsExcludingVat: "b_out_ic_charts__financing_total_loan_amount_tis_l_cs_excl_vat_tenant_compensation",
				vatLoss: "b_out_ic_charts__financing_total_loan_amount_vat_loss_on_capex_tis_l_cs",
				partnerCapexFeeIncludingVat: "b_out_ic_charts__financing_total_loan_amount_partner_capex_fee_incl_vat",
				loanToCost: "b_out_ic_charts__financing_total_loan_amount_ltc",
				loanShareOfGrossDisposalPrice: "b_out_ic_charts__financing_total_loan_amount_loan_as_percent_of_gdp"
			},
			combinedFinancingIncludingSubsidyGrant: {
				totalLoanAmount: "b_out_ic_charts__financing_total_loan_amount_incl_subsidy_total_loan_amount_including_subsidy_grant",
				totalCostBase: "b_out_ic_charts__financing_total_loan_amount_incl_subsidy_total_cost_base",
				grossPurchasePrice: "b_out_ic_charts__ic_entry_exit_gpp_vs_net_disposal_proceeds",
				capexExcludingVat: "b_out_ic_charts__financing_total_loan_amount_incl_subsidy_capex_excl_vat",
				tenantImprovementsAndLeasingCostsExcludingVat: "b_out_ic_charts__financing_total_loan_amount_incl_subsidy_tis_l_cs_excl_vat_tenant_compensation",
				vatLoss: "b_out_ic_charts__financing_total_loan_amount_incl_subsidy_vat_loss_on_capex_tis_l_cs",
				partnerCapexFeeIncludingVat: "b_out_ic_charts__financing_total_loan_amount_incl_subsidy_partner_capex_fee_incl_vat",
				loanToCost: "b_out_ic_charts__financing_total_loan_amount_incl_subsidy_ltc",
				loanShareOfGrossDisposalPrice: "b_out_ic_charts__financing_total_loan_amount_incl_subsidy_loan_as_percent_of_gdp"
			}
		},
		subsidies: {
			kfw261: {
				eligibleCosts: "h_cal_subsidies__kpis_total_eligble_costs",
				subsidyRate: "h_cal_subsidies__external_inputs_kfw_tilgungszuschuss_in_percent_je_wohneinheit",
				bonusEe: "b_out_ic_charts__kfw_bonus_ee",
				bonusWpb: "b_out_ic_charts__kfw_bonus_wpb",
				totalSubsidyRateAndGrant: "h_cal_subsidies__subsidies_table_sub_total_kfw",
				subsidizedLoanAfterRepaymentGrant: "b_out_ic_charts__kfw_subsidized_loan_after_repayment_grant",
				interestRate: "b_crm_console__subsidized_interest_rate_bullet_loan",
				repayment: "b_out_ic_charts__kfw_repayment",
				durationInYears: "b_out_ic_charts__kfw_duration_in_y",
				fixedInterestPeriodInYears: "b_out_ic_charts__kfw_fixed_interst_rate_period_in_y"
			},
			bafa: {
				capexBasisExcludingHeating: "b_out_ic_charts__bafa_capex_base_excl_heating",
				capexBasisHeating: "b_out_ic_charts__bafa_capex_base_heating",
				totalFundingRate: "b_out_ic_charts__bafa_total_subsidy_rate",
				totalGrant: "h_cal_subsidies__subsidies_muc_bafa_total_beg_individual_measures_subsidy"
			},
			ifb: {
				eligibleCosts: "b_out_ic_charts__ifb_eligible_costs",
				baseGrant: "h_cal_subsidies__subsidies_table_ifb_basic_subsidy_per_resi_sqm",
				brickFacadeOrMonumentProtectionGrant: "h_cal_subsidies__subsidies_table_ifb_brick_facades_monument_protection",
				totalGrant: "b_out_ic_charts__ifb_total_grants_ifb"
			},
			dus: { totalSubsidyRateAndGrant: "h_cal_subsidies__subsidies_table_sub_total_dus" },
			fkg: {
				capexBasisExcludingHeating: "h_cal_subsidies__muc_kpis_total_eligble_costs_from_ee_capex_for_fkg",
				capexBasisHeating: "h_cal_subsidies__muc_kpis_total_costs_heating_exchange_only",
				totalFundingRate: "b_out_ic_charts__fkg_total_subsidy_rate",
				totalGrant: "h_cal_subsidies__subsidies_muc_fkg_total_fkg_subsidy"
			},
			rateAndGrantVector: {
				grantAmountIndex: 0,
				subsidyRateIndexes: [5, 4]
			}
		},
		returns: {
			ladder: {
				preTaxUnlevered: {
					profit: "a_cal_cf_engine__unlevered_deal_cf_pre_tax_unleveraged_deal_cf_pre_tax_total",
					irr: "a_cal_cf_engine__unlevered_deal_cf_pre_tax_irr",
					moc: "a_cal_cf_engine__unlevered_deal_cf_pre_tax_moc"
				},
				preTaxLevered: { profit: "a_cal_cf_engine__levered_deal_cf_post_all_debt_pre_tax_leveraged_deal_cf_post_all_debt_pre_tax_total" },
				postTaxLevered: {
					profit: "a_cal_cf_engine__levered_deal_cf_post_all_debt_pre_tax_leveraged_deal_cf_post_tax_pre_promote_total",
					irr: "a_cal_cf_engine__levered_deal_cf_post_tax_pre_promote_irr",
					moc: "a_cal_cf_engine__levered_deal_cf_post_tax_pre_promote_moc"
				},
				postTaxPostPromote: {
					profit: "a_cal_cf_engine__levered_deal_cf_post_tax_post_promote_total",
					irr: "a_cal_cf_engine__levered_deal_cf_post_tax_post_promote_irr",
					moc: "a_cal_cf_engine__levered_deal_cf_post_tax_post_promote_moc"
				}
			},
			cashYields: {
				year1PostCompletion: "b_out_ic_charts__ic_yields_coc_year_1_post_completion",
				averagePostCompletionToExit: "b_out_ic_charts__ic_yields_avg_coc_post_completion_exit",
				atExit: "b_out_ic_charts__ic_yields_coc_at_exit",
				averageFullHoldingPeriod: "b_out_ic_charts__ic_yields_avg_coc_full_holding_period"
			},
			goingInOut: {
				nla: "b_out_ic_charts__ic_entry_exit_nla",
				nppVsGrossDisposalPrice: "b_out_ic_charts__ic_entry_exit_npp_vs_gross_disposal_price",
				nppVsGrossDisposalPricePsm: "b_out_ic_charts__ic_entry_exit_npp_vs_gross_disposal_price_psm",
				nriMultiple: "b_out_ic_charts__ic_entry_exit_nri_multiple",
				nriYield: "b_out_ic_charts__ic_entry_exit_nri_yield",
				nriPerYearExclVacancyRent: "b_out_ic_charts__ic_entry_exit_nri_per_year_excl_vacancy_rent",
				nriPerYearInclVacancyRent: "b_out_ic_charts__ic_entry_exit_nri_per_year_incl_vacancy_rent",
				nriPmPsqmResi: "b_out_ic_charts__ic_entry_exit_nri_p_m_psqm_resi",
				vacancy: "b_out_ic_charts__ic_entry_exit_vacancy",
				vacancySqm: "b_out_ic_charts__ic_entry_exit_vacancy_in_sqm",
				noiPerYear: "b_out_ic_charts__ic_entry_exit_noi_per_year",
				nriLeakage: "b_out_ic_charts__ic_entry_exit_nri_leakage",
				capRateNoiNpp: "b_out_ic_charts__ic_entry_exit_cap_rate_noi_npp",
				grossPriceNextBuyerView: "b_out_ic_charts__ic_entry_exit_gross_price_next_buyer_view",
				netYieldNoiGpp: "b_out_ic_charts__ic_entry_exit_net_yield_noi_gpp",
				gppVsNetDisposalProceeds: "b_out_ic_charts__ic_entry_exit_gpp_vs_net_disposal_proceeds"
			},
			valueBridge: {
				netPurchasePrice: {
					total: "b_out_ic_charts__ic_entry_exit_npp_vs_gross_disposal_price",
					perSquareMeter: "b_out_ic_charts__value_bridge_pre_lever_tax_net_purchase_price_sqm_entry",
					totalIndex: 0
				},
				transactionCosts: {
					total: "b_out_ic_charts__value_bridge_pre_lever_tax_transaction_costs_total",
					perSquareMeter: "b_out_ic_charts__value_bridge_pre_lever_tax_transaction_costs_sqm_entry"
				},
				capexEnergyEfficiency: {
					total: "b_out_ic_charts__value_bridge_pre_lever_tax_capex_energy_efficiency_total",
					perSquareMeter: "b_out_ic_charts__value_bridge_pre_lever_tax_capex_energy_efficiency_sqm_entry"
				},
				capexGeneral: {
					total: "b_out_ic_charts__value_bridge_pre_lever_tax_capex_general_total",
					perSquareMeter: "b_out_ic_charts__value_bridge_pre_lever_tax_capex_general_sqm_entry"
				},
				capexExpansion: {
					total: "b_out_ic_charts__value_bridge_pre_lever_tax_capex_expansion_total",
					perSquareMeter: "b_out_ic_charts__value_bridge_pre_lever_tax_capex_expansion_sqm_entry"
				},
				tenantImprovements: {
					total: "b_out_ic_charts__value_bridge_pre_lever_tax_tenant_improvements_total",
					perSquareMeter: "b_out_ic_charts__value_bridge_pre_lever_tax_tenant_improvements_sqm_entry"
				},
				leasingCommissionTenantCompensations: {
					total: "b_out_ic_charts__value_bridge_pre_lever_tax_leasing_commission_tenant_compensations_total",
					perSquareMeter: "b_out_ic_charts__value_bridge_pre_lever_tax_leasing_commission_tenant_compensations_sqm_entry"
				},
				partnerFees: {
					total: "b_out_ic_charts__ic_uses_partner_fees_euro",
					perSquareMeter: "b_out_ic_charts__value_bridge_pre_lever_tax_partner_fees_sqm_entry"
				},
				vatLoss: {
					total: "b_out_ic_charts__ic_uses_vat_euro",
					perSquareMeter: "b_out_ic_charts__value_bridge_pre_lever_tax_vat_loss_sqm_entry"
				},
				netDisposalProceeds: {
					total: "b_out_ic_charts__ic_entry_exit_gpp_vs_net_disposal_proceeds",
					perSquareMeter: "b_out_ic_charts__value_bridge_pre_lever_tax_w_grant_net_disposal_proceeds_sqm_exit",
					totalIndex: 1
				},
				totalGrant: {
					total: "b_out_ic_charts__value_bridge_pre_lever_tax_w_grant_total_grant_total",
					perSquareMeter: "b_out_ic_charts__value_bridge_pre_lever_tax_w_grant_total_grant_sqm_exit"
				},
				noiCollected: {
					total: "a_cal_cf_engine__net_operating_income_net_operating_income_total",
					perSquareMeter: "b_out_ic_charts__value_bridge_pre_lever_tax_w_grant_noi_collected_sqm_exit"
				},
				grossProfit: {
					total: "b_out_ic_charts__value_bridge_pre_lever_tax_w_grant_big_profit_total",
					perSquareMeter: "b_out_ic_charts__value_bridge_pre_lever_tax_w_grant_big_profit_sqm_exit"
				}
			}
		}
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/mfh-investment-case-kpi-calc-engine-keys/mfh-investment-case-kpi-calc-engine-keys.ts
function sheetForCalcEngineKey(investmentCase, key) {
	const sheetProp = CALC_KEY_PREFIX_TO_SHEET[key.split("__")[0]];
	if (!sheetProp) return;
	return investmentCase[sheetProp];
}
var MFH_INVESTMENT_CASE_CALC_ENGINE_KEYS_BY_VERSION, LATEST_MFH_INVESTMENT_CASE_CALC_ENGINE_KEYS, toSupportedD2GVersion, resolveInvestmentCaseKpiCalcEngineKeys, readInvestmentCaseCalcEngineNumber, readInvestmentCaseCalcEngineVector, readInvestmentCaseCalcEngineRawVector, readInvestmentCaseCalcEngineString, readInvestmentCaseSubsidyRateAndGrant;
var init_mfh_investment_case_kpi_calc_engine_keys$1 = __esmMin((() => {
	init_parser_helpers();
	init_mfh_investment_case_kpi_calc_engine_keys_5_6_0();
	MFH_INVESTMENT_CASE_CALC_ENGINE_KEYS_BY_VERSION = {
		[SupportedVersions.v5_6_0]: MFH_INVESTMENT_CASE_KPI_CALC_ENGINE_KEYS_V5_6_0,
		[SupportedVersions.v5_6_1]: MFH_INVESTMENT_CASE_KPI_CALC_ENGINE_KEYS_V5_6_0
	};
	LATEST_MFH_INVESTMENT_CASE_CALC_ENGINE_KEYS = MFH_INVESTMENT_CASE_KPI_CALC_ENGINE_KEYS_V5_6_0;
	toSupportedD2GVersion = (d2gVersion) => {
		if (!d2gVersion) return;
		const candidate = `v${d2gVersion.trim().replace(/^v/i, "").split(/\s+/)[0]}`;
		return Object.values(SupportedVersions).includes(candidate) ? candidate : void 0;
	};
	resolveInvestmentCaseKpiCalcEngineKeys = (d2gVersion) => {
		const version = toSupportedD2GVersion(d2gVersion);
		return (version && MFH_INVESTMENT_CASE_CALC_ENGINE_KEYS_BY_VERSION[version]) ?? LATEST_MFH_INVESTMENT_CASE_CALC_ENGINE_KEYS;
	};
	readInvestmentCaseCalcEngineNumber = (investmentCase, key, arrayIndex = 0) => {
		return extractCalcEngineNumber(sheetForCalcEngineKey(investmentCase, key)?.calcengine?.[key], { arrayIndex });
	};
	readInvestmentCaseCalcEngineVector = (investmentCase, key) => {
		return extractCalcEngineVector(sheetForCalcEngineKey(investmentCase, key)?.calcengine?.[key]);
	};
	readInvestmentCaseCalcEngineRawVector = (investmentCase, key) => {
		return extractCalcEngineRawVector(sheetForCalcEngineKey(investmentCase, key)?.calcengine?.[key]);
	};
	readInvestmentCaseCalcEngineString = (investmentCase, key, arrayIndex = 0) => {
		return extractCalcEngineString(sheetForCalcEngineKey(investmentCase, key)?.calcengine?.[key], { arrayIndex });
	};
	readInvestmentCaseSubsidyRateAndGrant = (investmentCase, key, layout) => {
		const grantAmount = readInvestmentCaseCalcEngineNumber(investmentCase, key, layout.grantAmountIndex);
		let subsidyRate;
		for (const index of layout.subsidyRateIndexes) {
			subsidyRate = readInvestmentCaseCalcEngineNumber(investmentCase, key, index);
			if (subsidyRate != null) break;
		}
		return {
			grantAmount,
			subsidyRate
		};
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/mfh-investment-case-kpi-calc-engine-keys/index.ts
var init_mfh_investment_case_kpi_calc_engine_keys = __esmMin((() => {
	init_mfh_investment_case_kpi_calc_engine_keys$1();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/rent-market-data.model.ts
var MFHRentComparableCondition, MFHRentMarketListedSinceDays, MFH_RENT_MARKET_LISTED_SINCE_DAYS, isMFHRentMarketListedSinceDays, toRentMarketListedSinceQuery, listedSinceDateFromDays, MFHRentMarketRoutingStatus, sortedConditions, rangesEqual, rentAnalysisParametersMatch;
var init_rent_market_data_model = __esmMin((() => {
	MFHRentComparableCondition = /* @__PURE__ */ function(MFHRentComparableCondition) {
		MFHRentComparableCondition["Refurbished"] = "refurbished";
		MFHRentComparableCondition["FirstOccupancy"] = "first_occupancy";
		return MFHRentComparableCondition;
	}({});
	MFHRentMarketListedSinceDays = /* @__PURE__ */ function(MFHRentMarketListedSinceDays) {
		MFHRentMarketListedSinceDays[MFHRentMarketListedSinceDays["Any"] = -1] = "Any";
		MFHRentMarketListedSinceDays[MFHRentMarketListedSinceDays["Last7Days"] = 7] = "Last7Days";
		MFHRentMarketListedSinceDays[MFHRentMarketListedSinceDays["LastMonth"] = 30] = "LastMonth";
		MFHRentMarketListedSinceDays[MFHRentMarketListedSinceDays["Last3Months"] = 90] = "Last3Months";
		MFHRentMarketListedSinceDays[MFHRentMarketListedSinceDays["Last6Months"] = 180] = "Last6Months";
		MFHRentMarketListedSinceDays[MFHRentMarketListedSinceDays["Last12Months"] = 365] = "Last12Months";
		return MFHRentMarketListedSinceDays;
	}({});
	MFH_RENT_MARKET_LISTED_SINCE_DAYS = [
		7,
		30,
		90,
		180,
		365
	];
	isMFHRentMarketListedSinceDays = (value) => MFH_RENT_MARKET_LISTED_SINCE_DAYS.includes(value);
	toRentMarketListedSinceQuery = (listedSince) => listedSince === -1 ? void 0 : listedSince;
	listedSinceDateFromDays = (listedSince, now = /* @__PURE__ */ new Date()) => {
		if (listedSince === -1) return;
		return dayjs(now).subtract(listedSince, "day").format(DateFormats.ISO8601);
	};
	MFHRentMarketRoutingStatus = /* @__PURE__ */ function(MFHRentMarketRoutingStatus) {
		MFHRentMarketRoutingStatus["Complete"] = "complete";
		MFHRentMarketRoutingStatus["Partial"] = "partial";
		MFHRentMarketRoutingStatus["Unavailable"] = "unavailable";
		MFHRentMarketRoutingStatus["Skipped"] = "skipped";
		return MFHRentMarketRoutingStatus;
	}({});
	sortedConditions = (conditions) => [...conditions].sort();
	rangesEqual = (left, right) => (left?.min ?? void 0) === (right?.min ?? void 0) && (left?.max ?? void 0) === (right?.max ?? void 0);
	rentAnalysisParametersMatch = (left, right) => {
		const leftConditions = sortedConditions(left.mfhConditions);
		const rightConditions = sortedConditions(right.mfhConditions);
		return left.radiusInKm === right.radiusInKm && left.listedSince === right.listedSince && leftConditions.length === rightConditions.length && leftConditions.every((condition, index) => condition === rightConditions[index]) && rangesEqual(left.livingSpaceSqm, right.livingSpaceSqm) && rangesEqual(left.rentPerSqm, right.rentPerSqm);
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/mfh-investment-case-result-preview-paths.ts
function buildCellOutputPaths(data, legacySectionKey, rowKeys) {
	return data.rows.reduce((acc, row, rowIndex) => {
		const rowKey = rowKeys[rowIndex];
		if (!rowKey) return acc;
		Array.from(/* @__PURE__ */ new Set([...Object.keys(data.headers), ...Object.keys(row)])).filter((colKey) => colKey !== "metric").forEach((colKey) => {
			acc[cellOutputPathKey(rowIndex, colKey)] = [legacyOutputPath(legacySectionKey, rowKey, colKey)];
		});
		return acc;
	}, {});
}
function getSourcesPreviewRowKeys() {
	return [...SOURCES_PREVIEW_ROW_KEYS];
}
function getUsesPreviewRowKeys(result) {
	return [
		"usesNetPurchasePrice",
		"usesClosingCostsExclFinancing",
		"usesTIsLCsTenantCompensations",
		...hasTabularRowValues$1(result?.rows.usesCAPEXEeCapexExpansion) ? ["usesCAPEXEeCapexExpansion"] : USES_CAPEX_SPLIT_ROW_KEYS,
		"usesPartnerFees",
		"usesFinancingCosts",
		"usesVAT",
		"usesTotal"
	];
}
function getReturnsPreviewRowKeys() {
	return [...RETURNS_PREVIEW_ROW_KEYS];
}
function getGoingInOutPreviewRowKeys(result) {
	return [
		"NLA",
		"NPPVsGrossDisposalPrice",
		"netPriceSqm",
		"NRIMultiple",
		"NRIYield",
		...typeof result?.rows.NRIYearly === "number" ? ["NRIYearly"] : ["nriYearlyExclVacancyRent", "nriYearlyInclVacancyRent"],
		"NRIMonthlySqm",
		"vacancy",
		"vacancySqm",
		"NOIYearly",
		"NRILeakage",
		"capRateNoiNpp",
		"grossPriceNextBuyerView",
		"netYieldNoiGpp",
		"GPPVsNetDisposalProceeds"
	];
}
function getNetDisposalProceedsPreviewRowKeys() {
	return [...NET_DISPOSAL_PROCEEDS_PREVIEW_ROW_KEYS];
}
function getValueBridgePreviewRowKeys(result) {
	return [
		"netPurchasePrice",
		"transactionCosts",
		"grossPurchasePrice",
		...result?.rows.capitalExpenditures ? ["capitalExpenditures"] : VALUE_BRIDGE_CAPEX_SPLIT_ROW_KEYS,
		"tenantImprovements",
		"leasingCommissionTenantCompensations",
		"partnerFees",
		"VATLoss",
		"AICExclFinancing"
	];
}
function getRentalIncomePreviewRowKeys() {
	return [...RENTAL_INCOME_PREVIEW_ROW_KEYS];
}
function getRentalAreaPreviewRowKeys() {
	return [...RENTAL_AREA_PREVIEW_ROW_KEYS];
}
function withPreviewOutputCellPaths(section, data, rowKeys) {
	return {
		...data,
		cellOutputPaths: buildCellOutputPaths(data, LEGACY_SECTION_KEYS[section], rowKeys)
	};
}
var cellOutputPathKey, legacyOutputPath, hasTabularRowValues$1, SOURCES_PREVIEW_ROW_KEYS, USES_CAPEX_SPLIT_ROW_KEYS, RETURNS_PREVIEW_ROW_KEYS, NET_DISPOSAL_PROCEEDS_PREVIEW_ROW_KEYS, VALUE_BRIDGE_CAPEX_SPLIT_ROW_KEYS, RENTAL_INCOME_PREVIEW_ROW_KEYS, RENTAL_AREA_PREVIEW_ROW_KEYS, LEGACY_SECTION_KEYS;
var init_mfh_investment_case_result_preview_paths = __esmMin((() => {
	cellOutputPathKey = (rowIndex, colKey) => `${rowIndex}.${colKey}`;
	legacyOutputPath = (sectionKey, rowKey, colKey) => `investmentCaseOutput.${sectionKey}.rows.${rowKey}.${colKey}`;
	hasTabularRowValues$1 = /* @__PURE__ */ __name((row) => Boolean(row && Object.values(row).some((value) => value != null)), "hasTabularRowValues");
	SOURCES_PREVIEW_ROW_KEYS = [
		"sourcesDebtSenior",
		"sourcesDebtCapexTiNonSubsidized",
		"sourcesDebtCapexSubsidizedInclGrant",
		"sourcesEquity",
		"sourcesCashCollectedNoi",
		"sourcesTotal"
	];
	USES_CAPEX_SPLIT_ROW_KEYS = [
		"usesCAPEXEe",
		"usesCAPEXExpansion",
		"usesCAPEXGeneral"
	];
	RETURNS_PREVIEW_ROW_KEYS = [
		"preTaxUnlevered",
		"preTaxLevered",
		"postTaxLevered",
		"postTaxPostPromote"
	];
	NET_DISPOSAL_PROCEEDS_PREVIEW_ROW_KEYS = [
		"netDisposalProceeds",
		"AIC",
		"tradingProfit",
		"NOICollected",
		"grossProfit"
	];
	VALUE_BRIDGE_CAPEX_SPLIT_ROW_KEYS = [
		"capexEnergyEfficency",
		"capexGeneral",
		"capexExpansion"
	];
	RENTAL_INCOME_PREVIEW_ROW_KEYS = [
		"resiExisting",
		"resiAdditional",
		"commercial",
		"subtotal",
		"parking",
		"total"
	];
	RENTAL_AREA_PREVIEW_ROW_KEYS = [
		"resiExisting",
		"resiAdditional",
		"commercial",
		"subtotal",
		"parking",
		"total"
	];
	LEGACY_SECTION_KEYS = {
		sources: "sourcesUses",
		uses: "sourcesUses",
		returns: "returns",
		"going-in-out": "goingInOut",
		"net-disposal-proceeds": "valueBridge",
		"value-bridge": "valueBridge",
		"rental-income": "rentalIncome",
		"rental-area": "rentalArea"
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/automatic-investment-case-calculation-outputs.ts
var automaticInvestmentCaseCalculationOutputDefinitions;
var init_automatic_investment_case_calculation_outputs = __esmMin((() => {
	automaticInvestmentCaseCalculationOutputDefinitions = [
		{
			key: "preTaxUnleveredReturnsOffset0",
			label: "Pre-Tax Unlevered Returns",
			description: "Asset returns before taxes and before financing effects.",
			group: "returns",
			format: "currency",
			sourceSheet: "cfEngine",
			sourceCalcengineKey: "a_cal_cf_engine__unlevered_deal_cf_pre_tax_unleveraged_deal_cf_pre_tax_total"
		},
		{
			key: "preTaxUnleveredReturnsOffset1",
			label: "Pre-Tax Unlevered IRR",
			description: "Annualized internal rate of return (IRR) before taxes and financing, calculated from dated unlevered monthly deal cash flows.",
			group: "returns",
			format: "percent",
			sourceSheet: "cfEngine",
			sourceCalcengineKey: "a_cal_cf_engine__unlevered_deal_cf_pre_tax_irr"
		},
		{
			key: "preTaxLeveredReturnsOffset0",
			label: "Pre-Tax Levered Returns",
			description: "Asset returns before taxes including financing effects.",
			group: "returns",
			format: "currency",
			sourceSheet: "cfEngine",
			sourceCalcengineKey: "a_cal_cf_engine__levered_deal_cf_post_all_debt_pre_tax_leveraged_deal_cf_post_all_debt_pre_tax_total"
		},
		{
			key: "postTaxLeveredReturnsPrePromoteOffset0",
			label: "Post-Tax Levered Returns Pre-Promote",
			description: "Asset returns after taxes and financing, before promote distribution.",
			group: "returns",
			format: "currency",
			sourceSheet: "cfEngine",
			sourceCalcengineKey: "a_cal_cf_engine__levered_deal_cf_post_all_debt_pre_tax_leveraged_deal_cf_post_tax_pre_promote_total"
		},
		{
			key: "postTaxLeveredReturnsPrePromoteOffset1",
			label: "Post-Tax Levered IRR Pre-Promote",
			description: "Annualized internal rate of return (IRR) after taxes and financing, before promote, calculated from dated levered monthly deal cash flows.",
			group: "returns",
			format: "percent",
			sourceSheet: "cfEngine",
			sourceCalcengineKey: "a_cal_cf_engine__levered_deal_cf_post_tax_pre_promote_irr"
		},
		{
			key: "postTaxPostPromoteLeveredReturnsOffset0",
			label: "Post-Tax Post-Promote Levered Returns",
			description: "Total asset-partner cash-flow return after taxes, financing and promote.",
			group: "returns",
			format: "currency",
			sourceSheet: "cfEngine",
			sourceCalcengineKey: "a_cal_cf_engine__levered_deal_cf_post_tax_post_promote_total"
		},
		{
			key: "postTaxPostPromoteLeveredReturnsOffset1",
			label: "Post-Tax Post-Promote Levered IRR",
			description: "Annualized internal rate of return (IRR) after taxes, financing and promote, calculated from dated levered monthly deal cash flows.",
			group: "returns",
			format: "percent",
			sourceSheet: "cfEngine",
			sourceCalcengineKey: "a_cal_cf_engine__levered_deal_cf_post_tax_post_promote_irr"
		},
		{
			key: "postTaxPostPromoteLeveredMoc",
			label: "Post-Tax Post-Promote MoC",
			description: "Multiple-on-capital (MoC) after taxes, financing and promote: sum of positive monthly deal cash flows divided by the absolute sum of negative monthly deal cash flows.",
			group: "returns",
			format: "multiple",
			sourceSheet: "cfEngine",
			sourceCalcengineKey: "a_cal_cf_engine__levered_deal_cf_post_tax_post_promote_moc"
		},
		{
			key: "equityContribution",
			label: "Equity Contribution",
			description: "Total required equity contribution over the holding period.",
			group: "returns",
			format: "currency",
			unit: "EUR",
			sourceSheet: "cfEngine",
			sourceCalcengineKey: "a_cal_cf_engine__levered_deal_cf_post_tax_post_promote_total_contributions"
		},
		{
			key: "cocYearOnePostCompletionUnlevered",
			label: "CoC Year 1 Post-Completion (Unlevered)",
			description: "Cash-on-cash yield in the first year after completion.",
			group: "returns",
			format: "percent",
			sourceSheet: "icCharts",
			sourceCalcengineKey: "b_out_ic_charts__ic_yields_coc_year_1_post_completion",
			sourceOffset: 0
		},
		{
			key: "cocYearOnePostCompletionLevered",
			label: "CoC Year 1 Post-Completion (Levered)",
			description: "Cash-on-cash yield in the first year after completion.",
			group: "returns",
			format: "percent",
			sourceSheet: "icCharts",
			sourceCalcengineKey: "b_out_ic_charts__ic_yields_coc_year_1_post_completion",
			sourceOffset: 1
		},
		{
			key: "avgCocPostCompletionExitUnlevered",
			label: "Avg. CoC Post-Completion to Exit (Unlevered)",
			description: "Average cash-on-cash yield during the stabilized operating phase.",
			group: "returns",
			format: "percent",
			sourceSheet: "icCharts",
			sourceCalcengineKey: "b_out_ic_charts__ic_yields_avg_coc_post_completion_exit",
			sourceOffset: 0
		},
		{
			key: "avgCocPostCompletionExitLevered",
			label: "Avg. CoC Post-Completion to Exit (Levered)",
			description: "Average cash-on-cash yield during the stabilized operating phase.",
			group: "returns",
			format: "percent",
			sourceSheet: "icCharts",
			sourceCalcengineKey: "b_out_ic_charts__ic_yields_avg_coc_post_completion_exit",
			sourceOffset: 1
		},
		{
			key: "grossDisposalProceeds",
			label: "Gross Disposal Proceeds (Exit Price)",
			description: "Gross sale price at exit.",
			group: "exit",
			format: "currency",
			unit: "EUR",
			sourceSheet: "icCharts",
			sourceCalcengineKey: "b_out_ic_charts__ic_entry_exit_npp_vs_gross_disposal_price",
			sourceOffset: 1
		},
		{
			key: "capValueAtExit",
			label: "Cap Value at Exit",
			description: "Gross sale price per square meter at exit.",
			group: "exit",
			format: "currency",
			unit: "EUR/sqm",
			sourceSheet: "icCharts",
			sourceCalcengineKey: "b_out_ic_charts__ic_entry_exit_npp_vs_gross_disposal_price_psm",
			sourceOffset: 1
		},
		{
			key: "netDisposalProceeds",
			label: "Net Disposal Proceeds",
			description: "Net sales proceeds after disposal costs.",
			group: "exit",
			format: "currency",
			unit: "EUR",
			sourceSheet: "icCharts",
			sourceCalcengineKey: "b_out_ic_charts__ic_entry_exit_gpp_vs_net_disposal_proceeds",
			sourceOffset: 1
		},
		{
			key: "nriYieldGoingIn",
			label: "NRI Yield Going-In",
			description: "Gross initial yield based on net rental income at acquisition.",
			group: "exit",
			format: "percent",
			sourceSheet: "icCharts",
			sourceCalcengineKey: "b_out_ic_charts__ic_entry_exit_nri_yield",
			sourceOffset: 0
		},
		{
			key: "nriYieldGoingOut",
			label: "NRI Yield Going-Out",
			description: "Exit yield based on net rental income.",
			group: "exit",
			format: "percent",
			sourceSheet: "icCharts",
			sourceCalcengineKey: "b_out_ic_charts__ic_entry_exit_nri_yield",
			sourceOffset: 1
		},
		{
			key: "netYieldNoiGppGoingIn",
			label: "Net Yield (NOI/GPP) Going-In",
			description: "Net initial yield based on NOI and gross purchase price.",
			group: "exit",
			format: "percent",
			sourceSheet: "icCharts",
			sourceCalcengineKey: "b_out_ic_charts__ic_entry_exit_net_yield_noi_gpp",
			sourceOffset: 0
		},
		{
			key: "netYieldNoiGppGoingOut",
			label: "Net Yield (NOI/GPP) Going-Out",
			description: "Exit net yield based on NOI and gross purchase price.",
			group: "exit",
			format: "percent",
			sourceSheet: "icCharts",
			sourceCalcengineKey: "b_out_ic_charts__ic_entry_exit_net_yield_noi_gpp",
			sourceOffset: 1
		},
		{
			key: "totalNriGoingIn",
			label: "Total NRI p.a. Going-In",
			description: "Annual net rental income at acquisition.",
			group: "rent",
			format: "currency",
			unit: "EUR/year",
			sourceSheet: "icCharts",
			sourceCalcengineKey: "b_out_ic_charts__bp_rent_buy_total",
			sourceOffset: 0
		},
		{
			key: "totalNriGoingOut",
			label: "Total NRI p.a. Going-Out",
			description: "Annual net rental income at exit.",
			group: "rent",
			format: "currency",
			unit: "EUR/year",
			sourceSheet: "icCharts",
			sourceCalcengineKey: "b_out_ic_charts__bp_rent_sell_total",
			sourceOffset: 0
		},
		{
			key: "nriPsmPmGoingInResi",
			label: "NRI psm pm Going-In (Residential)",
			description: "Average residential rent per sqm per month at acquisition.",
			group: "rent",
			format: "currency",
			unit: "EUR/sqm/month",
			sourceSheet: "icCharts",
			sourceCalcengineKey: "b_out_ic_charts__ic_entry_exit_nri_p_m_psqm_resi",
			sourceOffset: 0
		},
		{
			key: "nriPsmPmGoingOutResi",
			label: "NRI psm pm Going-Out (Residential)",
			description: "Average residential rent per sqm per month at exit.",
			group: "rent",
			format: "currency",
			unit: "EUR/sqm/month",
			sourceSheet: "icCharts",
			sourceCalcengineKey: "b_out_ic_charts__ic_entry_exit_nri_p_m_psqm_resi",
			sourceOffset: 1
		},
		{
			key: "eeTopUpModernizationLevy",
			label: "EE Top Up (Modernization Levy)",
			description: "Energy-efficiency modernization rent top-up per square meter per month.",
			group: "modernizationRent",
			format: "currency",
			unit: "EUR/sqm/month",
			sourceSheet: "outputRentRoll",
			sourceCalcengineKey: "e_cal_output_rent_roll__rent_development_ee_top_up_approx"
		},
		{
			key: "modernizationLevyAtEightPercent",
			label: "Modernization Levy at 8% of Allocable Costs",
			description: "Modernization rent increase if 8% of eligible costs were fully passed through.",
			group: "modernizationRent",
			format: "currency",
			unit: "EUR/sqm/month",
			sourceSheet: "inputRentRoll",
			sourceCalcengineKey: "f_cal_input_rent_roll__capex_helpers_8_percent_increase_per_annum_sqm_monat"
		},
		{
			key: "netCapexEeMeasures",
			label: "Net CapEx EE-Measures",
			description: "Net CapEx for energy-efficiency modernization measures.",
			group: "capexFees",
			format: "currency",
			unit: "EUR",
			sourceSheet: "cfEngine",
			sourceCalcengineKey: "a_cal_cf_engine__net_operating_income_renovation_costs_energy_efficiency_eur_on_total_sqm_total"
		},
		{
			key: "netCapexGeneralMeasures",
			label: "Net CapEx General Measures",
			description: "Net CapEx for general measures such as outdoor areas and staircases.",
			group: "capexFees",
			format: "currency",
			unit: "EUR",
			sourceSheet: "cfEngine",
			sourceCalcengineKey: "a_cal_cf_engine__net_operating_income_renovation_general_capex_total"
		},
		{
			key: "netCapexResidentialTis",
			label: "Net CapEx Residential TIs",
			description: "Net CapEx for residential unit renovations.",
			group: "capexFees",
			format: "currency",
			unit: "EUR",
			sourceSheet: "cfEngine",
			sourceCalcengineKey: "a_cal_cf_engine__net_operating_income_renovation_costs_interior_eur_on_renovatable_sqm_total"
		},
		{
			key: "netCapexCommercialTis",
			label: "Net CapEx Commercial TIs",
			description: "Net CapEx for commercial tenant improvements or tenant incentives.",
			group: "capexFees",
			format: "currency",
			unit: "EUR",
			sourceSheet: "cfEngine",
			sourceCalcengineKey: "a_cal_cf_engine__net_operating_income_renovation_costs_interior_commercial_eur_on_renovatable_sqm_total"
		},
		{
			key: "netCapexExpansion",
			label: "Net CapEx Expansion",
			description: "Net CapEx for expansion such as additional floors, attic conversion, or new construction.",
			group: "capexFees",
			format: "currency",
			unit: "EUR",
			sourceSheet: "cfEngine",
			sourceCalcengineKey: "a_cal_cf_engine__net_operating_income_capex_expansion_eur_per_sqm_expansion_potential_total"
		},
		{
			key: "vatDamageOnCapex",
			label: "VAT Damage on CapEx",
			description: "VAT leakage on CapEx positions, considering partially reduced VAT rates from tenants subject to VAT.",
			group: "capexFees",
			format: "currency",
			unit: "EUR",
			sourceSheet: "cfEngine",
			sourceCalcengineKey: "a_cal_cf_engine__net_operating_income_vat_loss_on_capex_total"
		},
		{
			key: "netCapexFee",
			label: "Net CapEx Fee",
			description: "Net CapEx fee earned by Reneo on the CapEx measures.",
			group: "capexFees",
			format: "currency",
			unit: "EUR",
			sourceSheet: "cfEngine",
			sourceCalcengineKey: "a_cal_cf_engine__net_operating_income_condo_capex_ti_management_fee_total"
		},
		{
			key: "netTotalFeeIncomeExcludingPromote",
			label: "Net Total Fee Income (exkl. Promote)",
			description: "Total net Reneo fee income excluding promote.",
			group: "capexFees",
			format: "currency",
			unit: "EUR",
			sourceSheet: "icCharts",
			sourceCalcengineKey: "b_out_ic_charts__ic_fees_total_euro"
		},
		{
			key: "promote",
			label: "Promote",
			description: "Reneo promote.",
			group: "capexFees",
			format: "currency",
			unit: "EUR",
			sourceSheet: "cfEngine",
			sourceCalcengineKey: "a_cal_cf_engine__promote_to_partner_total"
		},
		{
			key: "seniorDebtVolume",
			label: "Senior Debt Volume",
			description: "Acquisition senior debt volume.",
			group: "financing",
			format: "currency",
			unit: "EUR",
			sourceSheet: "cfEngine",
			sourceCalcengineKey: "a_cal_cf_engine__unlevered_deal_cf_pre_tax_draw_down_acq_total"
		},
		{
			key: "nonSubsidizedDebtVolume",
			label: "Non-Subsidized Debt Volume",
			description: "Debt volume for non-subsidized CapEx costs.",
			group: "financing",
			format: "currency",
			unit: "EUR",
			sourceSheet: "cfEngine",
			sourceCalcengineKey: "a_cal_cf_engine__levered_deal_cf_post_senior_debt_pre_tax_draw_down_acq_total"
		},
		{
			key: "subsidizedDebtVolume",
			label: "Subsidized Debt Volume",
			description: "Debt volume for subsidized CapEx costs.",
			group: "financing",
			format: "currency",
			unit: "EUR",
			sourceSheet: "cfEngine",
			sourceCalcengineKey: "a_cal_cf_engine__levered_deal_cf_post_senior_and_capex_non_subsidized_debt_pre_tax_committed_capex_debt_subsidized_total"
		},
		{
			key: "totalDebtVolumePreGrant",
			label: "Total Debt Volume (Pre-Grant)",
			description: "Total debt volume before subsidy grant deduction.",
			group: "financing",
			format: "currency",
			unit: "EUR",
			sourceSheet: "icCharts",
			sourceCalcengineKey: "b_out_ic_charts__financing_total_loan_amount_total_loan_amount"
		},
		{
			key: "totalDebtVolumePostGrant",
			label: "Total Debt Volume (Post-Grant)",
			description: "Total debt volume after subsidy grant deduction.",
			group: "financing",
			format: "currency",
			unit: "EUR",
			sourceSheet: "icCharts",
			sourceCalcengineKey: "b_out_ic_charts__financing_total_loan_amount_incl_subsidy_total_loan_amount_including_subsidy_grant"
		},
		{
			key: "ltcPreGrant",
			label: "LTC (Pre-Grant)",
			description: "Loan-to-cost before subsidy grant deduction.",
			group: "financing",
			format: "percent",
			sourceSheet: "icCharts",
			sourceCalcengineKey: "b_out_ic_charts__financing_total_loan_amount_ltc"
		},
		{
			key: "ltcPostGrant",
			label: "LTC (Post-Grant)",
			description: "Loan-to-cost after subsidy grant deduction.",
			group: "financing",
			format: "percent",
			sourceSheet: "icCharts",
			sourceCalcengineKey: "b_out_ic_charts__financing_total_loan_amount_incl_subsidy_ltc"
		},
		{
			key: "volumeWeightedCombinedInterestRate",
			label: "Volume-weighted Combined Interest Rate",
			description: "Weighted blended rate across senior, non-subsidized, and subsidized debt.",
			group: "financing",
			format: "percent",
			sourceSheet: "icCharts",
			sourceCalcengineKey: "b_out_ic_charts__financing_volume_weighted_combined_interest_rate"
		},
		{
			key: "totalGrantsKfwRate",
			label: "Total Grants KfW (%)",
			description: "Total KfW repayment subsidy rate.",
			group: "subsidies",
			format: "percent",
			sourceSheet: "subsidies",
			sourceCalcengineKey: "h_cal_subsidies__subsidies_table_sub_total_kfw",
			sourceOffset: 5
		},
		{
			key: "totalGrantsKfwAmount",
			label: "Total Grants KfW",
			description: "Total KfW repayment subsidy amount.",
			group: "subsidies",
			format: "currency",
			unit: "EUR",
			sourceSheet: "subsidies",
			sourceCalcengineKey: "h_cal_subsidies__subsidies_table_sub_total_kfw",
			sourceOffset: 0
		},
		{
			key: "totalGrantsIfbRate",
			label: "Total Grants IFB (%)",
			description: "Total IFB subsidy rate.",
			group: "subsidies",
			format: "percent",
			sourceSheet: "investMemo",
			sourceCalcengineKey: "a_out_invest_memo__subsidies_total_subsidy_rate_ifb_program"
		},
		{
			key: "totalGrantsIfbAmount",
			label: "Total Grants IFB",
			description: "Total IFB subsidy amount.",
			group: "subsidies",
			format: "currency",
			unit: "EUR",
			sourceSheet: "investMemo",
			sourceCalcengineKey: "a_out_invest_memo__subsidies_total_grants_ifb_program"
		},
		{
			key: "totalGrantsBafaRate",
			label: "Total Grants BAFA (%)",
			description: "Total BAFA subsidy rate.",
			group: "subsidies",
			format: "percent",
			sourceSheet: "investMemo",
			sourceCalcengineKey: "a_out_invest_memo__subsidies_total_subsidy_rate_bafa_program"
		},
		{
			key: "totalGrantsBafaAmount",
			label: "Total Grants BAFA",
			description: "Total BAFA subsidy amount.",
			group: "subsidies",
			format: "currency",
			unit: "EUR",
			sourceSheet: "subsidies",
			sourceCalcengineKey: "h_cal_subsidies__subsidies_muc_bafa_total_beg_individual_measures_subsidy",
			sourceOffset: 0
		},
		{
			key: "totalGrantsOverallRate",
			label: "Total Grants Overall (%)",
			description: "Combined total subsidy rate.",
			group: "subsidies",
			format: "percent",
			sourceSheet: "subsidies",
			sourceCalcengineKey: "h_cal_subsidies__subsidies_table_total_state_subsidies_combined",
			sourceOffset: 5
		},
		{
			key: "totalGrantsOverallAmount",
			label: "Total Grants Overall",
			description: "Combined total subsidy amount.",
			group: "subsidies",
			format: "currency",
			unit: "EUR",
			sourceSheet: "subsidies",
			sourceCalcengineKey: "h_cal_subsidies__subsidies_table_total_state_subsidies_combined",
			sourceOffset: 0
		}
	];
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/data/ic-teaser.data.helpers.ts
function isFiniteNumber(value) {
	return typeof value === "number" && isFinite(value);
}
function asDayjs(value) {
	if (isNil(value) || value === "") return null;
	const parsed = dayjs(value);
	return parsed.isValid() ? parsed : null;
}
function addDuration(origin, amount, unit) {
	return origin && isFiniteNumber(amount) ? origin.add(amount, unit) : null;
}
/** Dates of the quarterly IC-charts rental-table columns: sheet dates, else entry + quarter offsets. */
function rentalTableColumnDates(rawDates, quarters, origin) {
	const fromDates = (rawDates ?? []).map(parseRentalTableColumnDate);
	if (fromDates.some((date) => date != null)) return fromDates;
	return (quarters ?? []).map((quarter) => isFiniteNumber(quarter) ? addQuarters(origin, quarter) : null);
}
/** Column date at `index`, falling back to entry + `index` quarters when the sheet has no date for it. */
function rentalTableColumnDateAt(columnDates, index, origin) {
	return columnDates[index] ?? addQuarters(origin, index);
}
function parseRentalTableColumnDate(value) {
	if (value instanceof Date) return asDayjs(value);
	if (typeof value === "string" && value.trim() !== "") {
		const trimmed = value.trim();
		const asNumber = Number(trimmed);
		if (Number.isFinite(asNumber) && trimmed === String(asNumber)) return parseRentalTableColumnDate(asNumber);
		return asDayjs(trimmed);
	}
	if (typeof value === "number" && Number.isFinite(value) && value > EXCEL_SERIAL_MIN$1 && value < EXCEL_SERIAL_MAX$1) return asDayjs(spreadsheetDateToJsDate(value));
	return null;
}
function addQuarters(origin, quarters) {
	return origin ? origin.add(quarters * MONTHS_PER_QUARTER, "month") : null;
}
function mapMedia(media) {
	if (!media.mediaFileId || !media.link) return;
	return {
		mediaFileId: media.mediaFileId,
		url: media.link,
		crop: null
	};
}
function getAddress(location) {
	return {
		street: location?.street ?? null,
		houseNumber: location?.houseNumber != null ? String(location.houseNumber) : null,
		postalCode: location?.zipcode != null ? String(location.zipcode) : null,
		city: location?.city ?? null,
		quarter: location?.quarter || null
	};
}
function isMainPhotoPreRenovation(media) {
	return media.tags?.includes("main-photo-pre-renovation") === true;
}
function findMainPreRenovationPhoto(media) {
	const file = media.find(isMainPhotoPreRenovation);
	return file ? mapMedia(file) ?? null : null;
}
function isMainPhotoPostRenovation(media) {
	return media.tags?.includes("main-photo-post-renovation") === true;
}
var MONTHS_PER_QUARTER, EXCEL_SERIAL_MIN$1, EXCEL_SERIAL_MAX$1;
var init_ic_teaser_data_helpers = __esmMin((() => {
	MONTHS_PER_QUARTER = 3;
	EXCEL_SERIAL_MIN$1 = 2e3;
	EXCEL_SERIAL_MAX$1 = 1e5;
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/ic-teaser.formatters.ts
var IC_TEASER_NUMBER_LOCALE, icTeaserNumberFormatters;
var init_ic_teaser_formatters = __esmMin((() => {
	IC_TEASER_NUMBER_LOCALE = "en-GB";
	icTeaserNumberFormatters = createLocaleNumberFormatters(IC_TEASER_NUMBER_LOCALE);
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/data/ic-teaser-dcf.helpers.ts
function dcfCashflowRowSpec(kind, label, keys, extras) {
	return {
		kind,
		label,
		totalKey: keys.total,
		yearlyKey: keys.yearly,
		commentRateKey: keys.commentRate,
		...extras
	};
}
function currencyCell(value) {
	return {
		value,
		format: "currency"
	};
}
function coerceNumber(value) {
	if (typeof value === "number" && Number.isFinite(value)) return value;
	if (typeof value === "string" && value.trim() !== "") {
		const parsed = Number(value);
		return Number.isFinite(parsed) ? parsed : null;
	}
	return null;
}
function assertNoCalcError(triple, key, tableLabel, d2gVersion) {
	if (!triple || !isCompressedTriple(triple)) return;
	if (triple[0] === 4 || triple[1]) throw new InvariantError(`${tableLabel} key ${key} has a calculation error for D2G ${d2gVersion ?? "unknown"}`);
}
function readTotal(values, key, tableLabel, d2gVersion) {
	const triple = values[key];
	assertNoCalcError(triple, key, tableLabel, d2gVersion);
	if (!triple || !isCompressedTriple(triple)) return null;
	if (triple[0] === 1) return coerceNumber(triple[2]);
	if (triple[0] === 2) return coerceNumber(triple[2]?.[0]);
	return null;
}
function readYearlyValues(values, key, tableLabel, d2gVersion) {
	const triple = values[key];
	assertNoCalcError(triple, key, tableLabel, d2gVersion);
	if (!triple || !isCompressedTriple(triple) || triple[0] !== 2 || !triple[2]) return [];
	return triple[2];
}
function readYearly(values, key, tableLabel, d2gVersion) {
	return readYearlyValues(values, key, tableLabel, d2gVersion).map(coerceNumber);
}
function readScalarRaw(values, key, tableLabel, d2gVersion) {
	const triple = values[key];
	assertNoCalcError(triple, key, tableLabel, d2gVersion);
	if (!triple || !isCompressedTriple(triple)) return;
	if (triple[0] === 1) return triple[2];
	if (triple[0] === 2) return triple[2]?.[0];
}
function readText(values, key, tableLabel, d2gVersion) {
	const raw = readScalarRaw(values, key, tableLabel, d2gVersion);
	if (typeof raw === "string") {
		const trimmed = raw.trim();
		return trimmed === "" ? null : trimmed;
	}
	if (typeof raw === "number" && Number.isFinite(raw)) return String(raw);
	return null;
}
function emptyCommentCell() {
	return {
		value: null,
		format: "text"
	};
}
function formatMultiple(value) {
	return `${localNumberFormat$2(value, 2, 2)}×`;
}
function formatCommentOrMetric(values, key, format, tableLabel, d2gVersion) {
	if (format === "text") return {
		value: readText(values, key, tableLabel, d2gVersion),
		format: "text"
	};
	const numericValue = readTotal(values, key, tableLabel, d2gVersion);
	if (format === "multiple") return {
		value: numericValue == null ? null : formatMultiple(numericValue),
		format: "text"
	};
	return {
		value: numericValue,
		format: format ?? "number"
	};
}
function formatCommentRateText(values, spec, tableLabel, d2gVersion) {
	if (!spec.commentRateKey) return null;
	if (spec.commentRateFormat === "text") return readText(values, spec.commentRateKey, tableLabel, d2gVersion);
	const numericValue = readTotal(values, spec.commentRateKey, tableLabel, d2gVersion);
	if (numericValue == null) return null;
	switch (spec.commentRateFormat) {
		case "multiple": return formatMultiple(numericValue);
		case "percentage": {
			const formatted = percent$1(numericValue, 2);
			return typeof formatted === "string" ? formatted : null;
		}
		case "currency": return currency$2(numericValue);
		case "number":
		case void 0: return localNumberFormat$2(numericValue);
		default: return spec.commentRateFormat;
	}
}
function commentCell(values, spec, tableLabel, d2gVersion) {
	const parts = [formatCommentRateText(values, spec, tableLabel, d2gVersion), spec.commentUnit].filter((part) => Boolean(part));
	if (parts.length === 0) return emptyCommentCell();
	return {
		value: parts.join(" "),
		format: "text"
	};
}
function summaryMetric(values, spec, tableLabel, d2gVersion) {
	const cell = formatCommentOrMetric(values, spec.key, spec.format, tableLabel, d2gVersion);
	return {
		label: spec.label,
		value: cell.value,
		format: cell.format
	};
}
function yearLabels(values, yearWidth, tableLabel, yearCountsKey) {
	const counts = readYearly(values, yearCountsKey, tableLabel);
	return times(yearWidth, (index) => {
		const count = counts[index];
		return count != null ? `Year ${count}` : `Year ${index + 1}`;
	});
}
function trimYearWidth$1(rows, maxYearColumns) {
	const lastPopulated = max(rows.map((row) => findLastIndex(row.cells.slice(3), (cell) => cell?.value != null && cell.value !== "")));
	return Math.min(Math.max((lastPopulated ?? -1) + 1, 0), maxYearColumns);
}
function dcfCommentRateKeys(specs) {
	return specs.flatMap((spec) => spec.commentRateKey ? [spec.commentRateKey] : []);
}
function buildDcfTable(params) {
	const maxYearColumns = params.maxYearColumns ?? 7;
	const values = params.calcengineValues;
	const tableLabel = params.tableLabel;
	const builtRows = params.specs.map((spec) => {
		const yearly = spec.yearlyKey ? readYearly(values, spec.yearlyKey, tableLabel, params.d2gVersion) : [];
		const yearCells = times(maxYearColumns, (index) => currencyCell(yearly[index] ?? null));
		const cells = [
			{
				value: spec.label,
				format: "text"
			},
			commentCell(values, spec, tableLabel, params.d2gVersion),
			currencyCell(spec.totalKey ? readTotal(values, spec.totalKey, tableLabel, params.d2gVersion) : null),
			...yearCells
		];
		return {
			kind: spec.kind,
			cells
		};
	});
	const yearWidth = trimYearWidth$1(builtRows, maxYearColumns);
	const labels = yearLabels(values, yearWidth, tableLabel, params.yearCountsKey);
	const keptCellCount = 3 + yearWidth;
	const table = {
		columns: [
			"",
			"",
			"Total",
			...labels
		],
		columnKinds: [
			"label",
			"comment",
			"total",
			...labels.map(() => "year")
		],
		rows: builtRows.map((row) => ({
			kind: row.kind,
			cells: row.cells.slice(0, keptCellCount)
		}))
	};
	if (!params.summaryMetricSpecs) return table;
	return {
		...table,
		summaryMetrics: params.summaryMetricSpecs.map((spec) => summaryMetric(values, spec, tableLabel, params.d2gVersion))
	};
}
function emptyDcfTable() {
	return {
		columns: [],
		rows: []
	};
}
function asMFHInvestmentCase(investmentCase) {
	return investmentCase instanceof MFHInvestmentCase ? investmentCase : new MFHInvestmentCase(investmentCase);
}
function resolveDcfGate(investmentCase) {
	const dbCase = asMFHInvestmentCase(investmentCase);
	if (!dbCase.d2gVersion || !dbCase.hasCalcengineIntegration("a_cal_cf_engine") || !dbCase.hasCalcengineIntegration("b_out_ic_charts")) return {
		canBuild: false,
		d2gVersion: dbCase.d2gVersion ?? null,
		calculatedAt: dbCase.lastCalculatedAt ?? null
	};
	if (!dbCase.hasOutput) return {
		canBuild: false,
		d2gVersion: dbCase.decodeVersion().version,
		calculatedAt: null
	};
	return {
		canBuild: true,
		d2gVersion: dbCase.decodeVersion().version,
		calculatedAt: dbCase.lastCalculatedAt ?? null
	};
}
function sheetCalcengine(sheet) {
	return sheet?.calcengine ?? {};
}
function collectSheetCalcengineValues(investmentCase) {
	return {
		...sheetCalcengine(investmentCase.sheetsGri),
		...sheetCalcengine(investmentCase.sheetsCfEngine),
		...sheetCalcengine(investmentCase.sheetsPLTax),
		...sheetCalcengine(investmentCase.sheetsICCharts)
	};
}
function collectCrmCommentRateTriples(investmentCase, commentRateKeys) {
	if (!investmentCase.d2gVersion || !investmentCase.caseInputs || commentRateKeys.length === 0) return {};
	return transformValueObjectToCompressedTriples(toCalcEngineInputsForTargets(investmentCase, normalizeD2GVersionForCalcengine(asMFHInvestmentCase(investmentCase).decodeVersion().version), new Set(commentRateKeys)));
}
function collectDcfCalcengineValues(investmentCase, commentRateKeys) {
	return {
		...collectCrmCommentRateTriples(investmentCase, commentRateKeys),
		...collectSheetCalcengineValues(investmentCase)
	};
}
var currency$2, localNumberFormat$2, percent$1, CF_ENGINE_SHEET_KEY, IC_CHARTS_SHEET_KEY, DCF_MAX_YEAR_COLUMNS, DCF_LEADING_CELL_COUNT;
var init_ic_teaser_dcf_helpers = __esmMin((() => {
	init_errors();
	init_d2g_calcengine_model();
	init_parser_helpers();
	init_versions();
	init_mfh_investment_case_class();
	init_ic_teaser_formatters();
	({currency: currency$2, localNumberFormat: localNumberFormat$2, percent: percent$1} = icTeaserNumberFormatters);
	CF_ENGINE_SHEET_KEY = "a_cal_cf_engine";
	IC_CHARTS_SHEET_KEY = "b_out_ic_charts";
	DCF_MAX_YEAR_COLUMNS = 7;
	DCF_LEADING_CELL_COUNT = 3;
	__name(trimYearWidth$1, "trimYearWidth");
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/ic-teaser.kpis.ts
function isNumber$1(value) {
	return typeof value === "number" && isFinite(value);
}
function combinedOccupancy(stockTotal, stockLet, expansionTotal, expansionLet, fallbackOccupancy) {
	const total = (isNumber$1(stockTotal) ? stockTotal : 0) + (isNumber$1(expansionTotal) ? expansionTotal : 0);
	const letArea = (isNumber$1(stockLet) ? stockLet : 0) + (isNumber$1(expansionLet) ? expansionLet : 0);
	if (total > 0) return letArea / total;
	return firstFiniteNumber(fallbackOccupancy);
}
function parseEntryDate(value) {
	if (isNil(value) || value === "") return null;
	const parsed = dayjs(value);
	return parsed.isValid() ? parsed.toDate() : null;
}
var COC_UNLEVERED_INDEX, COC_LEVERED_INDEX, extractICTeaserInvestmentCaseKpis;
var init_ic_teaser_kpis = __esmMin((() => {
	init_mfh_investment_case_kpi_calc_engine_keys();
	COC_UNLEVERED_INDEX = 0;
	COC_LEVERED_INDEX = 1;
	__name(isNumber$1, "isNumber");
	extractICTeaserInvestmentCaseKpis = (investmentCase) => {
		const overview = investmentCase.caseInputs?.overview;
		const rent = investmentCase.caseInputs?.rent;
		const buildingTechnical = investmentCase.caseInputs?.buildingTechnical;
		const bestWorst = investmentCase.caseInputs?.bestWorst;
		const assumptions = investmentCase.caseInputs?.assumptions;
		const output = investmentCase.investmentCaseOutput;
		const kpiKeys = resolveInvestmentCaseKpiCalcEngineKeys(investmentCase.d2gVersion);
		const read = (key, arrayIndex = 0) => readInvestmentCaseCalcEngineNumber(investmentCase, key, arrayIndex);
		const readString = (key, arrayIndex = 0) => readInvestmentCaseCalcEngineString(investmentCase, key, arrayIndex);
		const irrPostTaxLevered = read(kpiKeys.irrPercentage);
		const totalInvestmentVolume = read(kpiKeys.financing.sourcesUses.usesTotal.euro);
		const equityCommitment = read(kpiKeys.financing.sourcesUses.sourcesEquity.euro);
		const cocAtExitUnlevered = read(kpiKeys.returns.cashYields.atExit, COC_UNLEVERED_INDEX);
		const cocAtExitLevered = read(kpiKeys.returns.cashYields.atExit, COC_LEVERED_INDEX);
		const mocPostTaxPostPromote = read(kpiKeys.mocPostTaxPostPromote);
		const totalSpaceNlaEntry = read(kpiKeys.nlaEntryExit, 0);
		const residentialSpaceSqm = firstFiniteNumber(read(kpiKeys.residentialAreaEntry, 0), overview?.resiSpaceSqm);
		const commercialSpaceSqm = firstFiniteNumber(read(kpiKeys.commercialAreaEntry, 0), overview?.commercialSpaceSqm);
		const totalRentableSpaceSqm = firstFiniteNumber(read(kpiKeys.totalAreaEntry, 0), isNumber$1(residentialSpaceSqm) && isNumber$1(commercialSpaceSqm) ? residentialSpaceSqm + commercialSpaceSqm : null);
		const numberOfResidentialUnits = firstFiniteNumber(overview?.resiUnits);
		const numberOfCommercialUnits = firstFiniteNumber(overview?.commercialUnits);
		const numberOfParkingSpaces = firstFiniteNumber(read(kpiKeys.parkingAreaEntry, 0), overview?.parkingSpaces);
		const averageResidentialUnitSizeDerived = isNumber$1(residentialSpaceSqm) && isNumber$1(numberOfResidentialUnits) && numberOfResidentialUnits > 0 ? residentialSpaceSqm / numberOfResidentialUnits : null;
		const netResidentialRentPerSquareMeterPerMonth = firstFiniteNumber(read(kpiKeys.resiNriPsmPmEntry, 0), output?.rentalIncome?.rows?.resiExisting?.goingInPsm);
		return {
			name: investmentCase.name,
			lastCalculatedAt: investmentCase.lastCalculatedAt ? new Date(investmentCase.lastCalculatedAt) : null,
			city: investmentCase.caseInputs?.location?.city ?? null,
			constructionYear: firstFiniteNumber(investmentCase.caseInputs?.buildingTechnical?.constructionYear),
			totalSpaceNlaEntry: totalSpaceNlaEntry ?? null,
			totalInvestmentVolume: totalInvestmentVolume ?? null,
			equityCommitment: equityCommitment ?? null,
			cocAtExitUnlevered: cocAtExitUnlevered ?? null,
			cocAtExitLevered: cocAtExitLevered ?? null,
			mocPostTaxPostPromote: mocPostTaxPostPromote ?? null,
			irrPostTaxLevered: irrPostTaxLevered ?? null,
			residentialSpaceSqm,
			commercialSpaceSqm,
			totalRentableSpaceSqm,
			numberOfResidentialUnits,
			numberOfCommercialUnits,
			numberOfParkingSpaces,
			averageResidentialUnitSize: firstFiniteNumber(read(kpiKeys.averageUnitSizeSqm), overview?.avgSizeResidentialSqm, averageResidentialUnitSizeDerived),
			residentialOccupancy: firstFiniteNumber(read(kpiKeys.residentialAreaEntry, 2), rent?.resiOccupancyActual),
			commercialOccupancy: firstFiniteNumber(read(kpiKeys.commercialAreaEntry, 2), rent?.commercialOccupancyActual),
			parkingOccupancy: firstFiniteNumber(read(kpiKeys.parkingAreaEntry, 2), rent?.parkingOccupancyActual),
			netRentalIncomePerYear: firstFiniteNumber(read(kpiKeys.nriPerYearEntry, 0), output?.rentalIncome?.rows?.total?.goingInNriPA),
			netResidentialRentPerSquareMeterPerMonth,
			netCommercialRentPerSquareMeterPerMonth: firstFiniteNumber(read(kpiKeys.commercialRentEntry, 1), output?.rentalIncome?.rows?.commercial?.goingInPsm),
			netParkingRentPerSpotPerMonth: firstFiniteNumber(read(kpiKeys.parkingRentEntry, 1), output?.rentalIncome?.rows?.parking?.goingInPsm),
			acquisitionPrice: firstFiniteNumber(read(kpiKeys.nppEntry, 0), output?.goingInOut?.rows?.NPPVsGrossDisposalPrice?.entry),
			acquisitionPricePerSquareMeter: firstFiniteNumber(read(kpiKeys.nppPsmEntry, 0), output?.goingInOut?.rows?.netPriceSqm?.entry),
			acquisitionMultiple: firstFiniteNumber(read(kpiKeys.nriMultipleEntry, 0), output?.goingInOut?.rows?.NRIMultiple?.entry),
			grossPurchasePrice: firstFiniteNumber(read(kpiKeys.grossPurchasePrice), output?.valueBridge?.rows?.grossPurchasePrice?.total),
			rentIndexBands: (rent?.rentIndex ?? []).map((band, index) => ({
				label: band.areaMin != null || band.areaMax != null ? `${band.areaMin ?? 0}-${band.areaMax ?? "plus"} m²` : `Band ${index + 1}`,
				minimum: band.minPrice,
				mean: band.midPrice,
				maximum: band.maxPrice
			})),
			inPlaceRentPerSquareMeter: netResidentialRentPerSquareMeterPerMonth,
			targetRentPerSquareMeter: firstFiniteNumber(read(kpiKeys.resiNriPsmPmExit, 1), output?.goingInOut?.rows?.NRIMonthlySqm?.exit),
			appliedRentResidential: firstFiniteNumber(rent?.appliedRentResidential),
			manualExpandedSpace: firstFiniteNumber(investmentCase.caseInputs?.rentPredictions?.manualExpandedSpace),
			returnLadder: output?.returns ?? null,
			goingInOut: output?.goingInOut ?? null,
			valueBridge: output?.valueBridge ?? null,
			/** Capex €/m² as entered in the IC inputs (base case) wins over the calc-engine value-bridge figures. */
			tenantImprovementCapexPerSquareMeter: firstFiniteNumber(bestWorst?.renovationCostInteriorSqm?.base, read(kpiKeys.tenantImprovementsCapexPsmEntry), output?.valueBridge?.rows?.tenantImprovements?.m2Entry),
			generalCapexPerSquareMeter: firstFiniteNumber(bestWorst?.generalCapexSqm?.base, read(kpiKeys.generalCapexPsmEntry), output?.valueBridge?.rows?.capexGeneral?.m2Entry),
			energeticCapexPerSquareMeter: firstFiniteNumber(bestWorst?.renovationCostEnergyEfficiencySqm?.base, read(kpiKeys.energyEfficiencyCapexPsmEntry), output?.valueBridge?.rows?.capexEnergyEfficency?.m2Entry),
			expansionCapexPerSquareMeter: firstFiniteNumber(bestWorst?.expansionCostSqm?.base, read(kpiKeys.expansionCapexPsmEntry), output?.valueBridge?.rows?.capexExpansion?.m2Entry),
			/** IC input first; the calc-engine echo can be stale until the case is recalculated. */
			expansionPotentialSqm: firstFiniteNumber(overview?.expansionPotentialSqm, read(kpiKeys.expansionPotentialSqm)),
			energyEfficiencyRatingEntry: firstNonEmptyString(readString(kpiKeys.epcRatingGoingIn), buildingTechnical?.endEnergyConsumptionClass, investmentCase.statusQuo?.energyEfficiency),
			energyEfficiencyRatingExit: firstNonEmptyString(readString(kpiKeys.epcRatingGoingOut), buildingTechnical?.endEnergyConsumptionClassPostRenovation, investmentCase.postTransformation?.energyEfficiencyClass),
			finalEnergyDemandEntry: firstFiniteNumber(buildingTechnical?.endEnergyConsumptionKWhSqm),
			finalEnergyDemandExit: firstFiniteNumber(bestWorst?.epcRatingInKWHPostRenovation?.base),
			lettableAreaEntry: {
				residentialExisting: firstFiniteNumber(read(kpiKeys.residentialAreaEntry, 0), output?.rentalArea?.rows?.resiExisting?.goingInTotal),
				residentialExpansion: firstFiniteNumber(read(kpiKeys.residentialExpansionAreaEntry, 0), output?.rentalArea?.rows?.resiAdditional?.goingInTotal),
				commercial: firstFiniteNumber(read(kpiKeys.commercialAreaEntry, 0), output?.rentalArea?.rows?.commercial?.goingInTotal)
			},
			lettableAreaExit: {
				residentialExisting: firstFiniteNumber(read(kpiKeys.residentialAreaExit, 0), output?.rentalArea?.rows?.resiExisting?.goingOutTotal),
				residentialExpansion: firstFiniteNumber(read(kpiKeys.residentialExpansionAreaExit, 0), output?.rentalArea?.rows?.resiAdditional?.goingOutTotal),
				commercial: firstFiniteNumber(read(kpiKeys.commercialAreaExit, 0), output?.rentalArea?.rows?.commercial?.goingOutTotal)
			},
			modernizationLevyPerSquareMeterPerMonth: firstFiniteNumber(read(kpiKeys.modernizationLevyPsmPm), assumptions?.appliedEETopUp),
			eeTopUpModernizationLevy: firstFiniteNumber(read(kpiKeys.eeTopUpModernizationLevy), assumptions?.appliedEETopUp),
			modernizationLevyAveragePerSquareMeterPerMonth: firstFiniteNumber(read(kpiKeys.modernizationLevyAveragePsmPm)),
			annualTenantChurn: firstFiniteNumber(bestWorst?.annunalTenantChurn?.base),
			annualMarketRentGrowth: firstFiniteNumber(assumptions?.annualRentGrowthNonWhgRenovation),
			impliedNriUpliftPotential: firstFiniteNumber(read(kpiKeys.rentDevelopment)),
			energyEfficiencyEndMonths: firstFiniteNumber(assumptions?.energyEfficiencyEnd),
			reletDelayMonths: firstFiniteNumber(assumptions?.reletDelayMonths),
			firstBgbRentIncreaseTiming: firstFiniteNumber(assumptions?.firstBgbRentIncreaseTiming),
			secondBgbRentIncreaseTiming: firstFiniteNumber(assumptions?.secondBgbRentIncreaseTiming),
			thirdBgbRentIncreaseTiming: firstFiniteNumber(assumptions?.thirdBgbRentIncreaseTiming),
			fourthBgbRentIncreaseTiming: firstFiniteNumber(assumptions?.fourthBgbRentIncreaseTiming),
			residentialOccupancyExit: combinedOccupancy(read(kpiKeys.residentialAreaExit, 0), read(kpiKeys.residentialAreaExit, 1), read(kpiKeys.residentialExpansionAreaExit, 0), read(kpiKeys.residentialExpansionAreaExit, 1), read(kpiKeys.residentialAreaExit, 2)),
			commercialOccupancyExit: firstFiniteNumber(read(kpiKeys.commercialAreaExit, 2)),
			parkingOccupancyExit: firstFiniteNumber(read(kpiKeys.parkingAreaExit, 2)),
			entryDate: parseEntryDate(assumptions?.entryDate),
			durationInMonths: firstFiniteNumber(assumptions?.durationInMonths),
			subsidizedInterestRate: firstFiniteNumber(assumptions?.subsidisedInterestRateBulletLoan)
		};
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/ic-teaser.location.ts
/** MFH attribute restrictions → teaser presentation rows. */
function buildICTeaserLocationRestrictions(restrictions) {
	const hasRestrictionData = restrictions !== null && restrictions !== void 0;
	const selectedRestrictions = new Set((restrictions ?? []).filter((restriction) => restriction !== "None"));
	return IC_TEASER_LOCATION_RESTRICTION_DEFINITIONS.map((definition) => ({
		name: definition.name,
		description: definition.description,
		applies: hasRestrictionData ? definition.restrictions.some((restriction) => selectedRestrictions.has(restriction)) : null,
		source: hasRestrictionData ? MFH_ATTRIBUTES_RESTRICTION_SOURCE : null
	}));
}
/** Teaser presentation rows → selected MFH restriction enums (lossy for multi-enum groups). */
function selectedRestrictionsFromICTeaserLocationRestrictions(restrictions) {
	const selected = [];
	for (const definition of IC_TEASER_LOCATION_RESTRICTION_DEFINITIONS) {
		if (restrictions.find((item) => item.name === definition.name)?.applies !== true) continue;
		selected.push(...definition.restrictions);
	}
	return selected;
}
function icTeaserLocationPoiKey(location) {
	return [
		location.category,
		location.name,
		location.location.latitude.toFixed(6),
		location.location.longitude.toFixed(6)
	].join(LOCATION_POI_KEY_SEPARATOR);
}
function routeDistanceMeters(location) {
	return location.route?.status === "ok" ? location.route.distanceMeters ?? Number.POSITIVE_INFINITY : Number.POSITIVE_INFINITY;
}
/** Analysis POIs plus manually placed ones; the input for every highlight / map resolve. */
function resolveICTeaserLocationPois(analysis, customLocations) {
	return [...analysis?.accessibility.locations ?? [], ...(customLocations ?? []).filter((location) => location != null)];
}
/** Adds or replaces a manual POI (same key) and selects it for its category. */
function addICTeaserCustomLocation(locations, customLocations, currentKeys, location) {
	const key = icTeaserLocationPoiKey(location);
	const effectiveKeys = effectiveHighlightedLocationKeys(locations, currentKeys);
	return {
		customLocations: [...customLocations.filter((item) => icTeaserLocationPoiKey(item) !== key), location],
		highlightedLocationKeys: effectiveKeys.includes(key) ? effectiveKeys : [...effectiveKeys, key]
	};
}
/** Removes a manual POI and its highlight / primary keys. */
function removeICTeaserCustomLocation(customLocations, highlightedLocationKeys, primaryHighlightedLocationKeys, key) {
	return {
		customLocations: customLocations.filter((item) => icTeaserLocationPoiKey(item) !== key),
		highlightedLocationKeys: highlightedLocationKeys == null ? null : compactHighlightedLocationKeys(highlightedLocationKeys).filter((item) => item !== key),
		primaryHighlightedLocationKeys: primaryHighlightedLocationKeys == null ? null : compactHighlightedLocationKeys(primaryHighlightedLocationKeys).filter((item) => item !== key)
	};
}
/** Default highlight set: up to five POIs per category, nearest first. */
function defaultICTeaserHighlightedLocationKeys(locations) {
	return LOCATION_ANALYSIS_CATEGORY_KEYS.flatMap((category) => sortBy(locations.filter((location) => location.category === category), routeDistanceMeters).slice(0, 5).map(icTeaserLocationPoiKey));
}
function locationPoiKeyPrefix(category) {
	return `${category}${LOCATION_POI_KEY_SEPARATOR}`;
}
function compactHighlightedLocationKeys(keys) {
	return keys.filter((key) => typeof key === "string" && key.length > 0);
}
function isLocationAnalysisCategory(value) {
	return LOCATION_ANALYSIS_CATEGORY_KEYS.includes(value);
}
function categoryFromPoiKey(key) {
	const category = key.split(LOCATION_POI_KEY_SEPARATOR)[0];
	return category != null && isLocationAnalysisCategory(category) ? category : null;
}
/** At most one key per category, last write wins, output in category order. */
function compactICTeaserPrimaryHighlightedLocationKeys(keys) {
	const byCategory = /* @__PURE__ */ new Map();
	for (const key of compactHighlightedLocationKeys(keys)) {
		const category = categoryFromPoiKey(key);
		if (category == null) continue;
		byCategory.set(category, key);
	}
	return LOCATION_ANALYSIS_CATEGORY_KEYS.flatMap((category) => {
		const key = byCategory.get(category);
		return key == null ? [] : [key];
	});
}
function effectiveHighlightedLocationKeys(locations, highlightedLocationKeys) {
	return highlightedLocationKeys == null ? defaultICTeaserHighlightedLocationKeys(locations) : compactHighlightedLocationKeys(highlightedLocationKeys);
}
function selectedLocationsForCategory(locations, selectedKeys, category) {
	return locations.filter((location) => location.category === category && selectedKeys.has(icTeaserLocationPoiKey(location)));
}
function nearestSelectedLocation(selected) {
	if (selected.length === 0) return;
	return selected.reduce((nearest, location) => routeDistanceMeters(location) < routeDistanceMeters(nearest) ? location : nearest);
}
function derivedPrimaryLocation(selected, primaryKey) {
	if (selected.length === 0) return;
	if (primaryKey != null) {
		const primary = selected.find((location) => icTeaserLocationPoiKey(location) === primaryKey);
		if (primary != null) return primary;
	}
	if (selected.length === 1) return selected[0];
	return nearestSelectedLocation(selected);
}
/**
* Persistable primary keys. `null` highlighted keys keep `null` primary (derive at resolve).
* Invalid or dropped primaries are replaced by the single selected POI, else nearest selected.
*/
function reconcileICTeaserPrimaryHighlightedLocationKeys(locations, highlightedLocationKeys, primaryHighlightedLocationKeys) {
	if (highlightedLocationKeys == null) return null;
	const selectedKeys = new Set(compactHighlightedLocationKeys(highlightedLocationKeys));
	const primaryByCategory = /* @__PURE__ */ new Map();
	for (const key of compactICTeaserPrimaryHighlightedLocationKeys(primaryHighlightedLocationKeys ?? [])) {
		const category = categoryFromPoiKey(key);
		if (category != null && selectedKeys.has(key)) primaryByCategory.set(category, key);
	}
	return LOCATION_ANALYSIS_CATEGORY_KEYS.flatMap((category) => {
		const derived = derivedPrimaryLocation(selectedLocationsForCategory(locations, selectedKeys, category), primaryByCategory.get(category));
		return derived == null ? [] : [icTeaserLocationPoiKey(derived)];
	});
}
function normalizeICTeaserVisibleCategories(visibleCategories) {
	if (visibleCategories == null) return null;
	const selected = new Set(visibleCategories);
	return LOCATION_ANALYSIS_CATEGORY_KEYS.filter((category) => selected.has(category));
}
/** Categories rendered on the slide. `null` means every category. */
function resolveICTeaserVisibleCategories(visibleCategories) {
	return normalizeICTeaserVisibleCategories(visibleCategories) ?? [...LOCATION_ANALYSIS_CATEGORY_KEYS];
}
function setICTeaserLocationCategoryVisible(current, category, visible) {
	const effective = new Set(resolveICTeaserVisibleCategories(current));
	if (visible) effective.add(category);
	else effective.delete(category);
	return LOCATION_ANALYSIS_CATEGORY_KEYS.filter((item) => effective.has(item));
}
/** Resolve map/grid rows. Hidden categories are omitted. `null` keys use nearest-per-category. Multiple keys per category are allowed. Ignores primary. */
function resolveICTeaserHighlightedLocationRows(locations, highlightedLocationKeys, visibleCategories) {
	const selectedKeys = new Set(effectiveHighlightedLocationKeys(locations, highlightedLocationKeys));
	return resolveICTeaserVisibleCategories(visibleCategories).flatMap((category) => {
		const selected = selectedLocationsForCategory(locations, selectedKeys, category);
		if (selected.length === 0) return [{ category }];
		return selected.map((location) => ({
			category,
			location
		}));
	});
}
/** Neighborhood text rows: one POI per visible category (primary, else auto). Does not affect map resolve. */
function resolveICTeaserNeighborhoodLocationRows(locations, highlightedLocationKeys, primaryHighlightedLocationKeys, visibleCategories) {
	const selectedKeys = new Set(effectiveHighlightedLocationKeys(locations, highlightedLocationKeys));
	const primaryByCategory = /* @__PURE__ */ new Map();
	for (const key of compactICTeaserPrimaryHighlightedLocationKeys(primaryHighlightedLocationKeys ?? [])) {
		const category = categoryFromPoiKey(key);
		if (category != null) primaryByCategory.set(category, key);
	}
	return resolveICTeaserVisibleCategories(visibleCategories).map((category) => {
		const location = derivedPrimaryLocation(selectedLocationsForCategory(locations, selectedKeys, category), primaryByCategory.get(category));
		return location == null ? { category } : {
			category,
			location
		};
	});
}
function setICTeaserHighlightedLocationKeysForCategory(locations, currentKeys, category, nextKeys) {
	const effectiveKeys = effectiveHighlightedLocationKeys(locations, currentKeys);
	const prefix = locationPoiKeyPrefix(category);
	const withoutCategory = effectiveKeys.filter((key) => !key.startsWith(prefix));
	const selected = nextKeys.filter((key) => key.startsWith(prefix) && key.length > 0);
	return [...withoutCategory, ...selected];
}
function setICTeaserLocationHighlightsForCategory(locations, currentKeys, currentPrimary, category, nextKeys) {
	const highlightedLocationKeys = setICTeaserHighlightedLocationKeysForCategory(locations, currentKeys, category, nextKeys);
	return {
		highlightedLocationKeys,
		primaryHighlightedLocationKeys: reconcileICTeaserPrimaryHighlightedLocationKeys(locations, highlightedLocationKeys, currentPrimary)
	};
}
function setICTeaserHighlightedLocationKeyForCategory(locations, currentKeys, category, nextKey) {
	return setICTeaserHighlightedLocationKeysForCategory(locations, currentKeys, category, nextKey == null || nextKey === "" ? [] : [nextKey]);
}
function setICTeaserPrimaryLocationKeyForCategory(locations, currentKeys, currentPrimary, category, nextKey) {
	const highlightedLocationKeys = effectiveHighlightedLocationKeys(locations, currentKeys);
	const prefix = locationPoiKeyPrefix(category);
	const selectedForCategory = highlightedLocationKeys.filter((key) => key.startsWith(prefix));
	const allowedKey = nextKey != null && selectedForCategory.includes(nextKey) ? nextKey : null;
	const withoutCategory = compactICTeaserPrimaryHighlightedLocationKeys(currentPrimary ?? []).filter((key) => !key.startsWith(prefix));
	return reconcileICTeaserPrimaryHighlightedLocationKeys(locations, highlightedLocationKeys, allowedKey == null ? withoutCategory : [...withoutCategory, allowedKey]);
}
function icTeaserLocationAssessmentParagraphs(analysis, block) {
	if (analysis == null || analysis.assessment.status !== "generated") return [];
	return analysis.assessment[block].paragraphs.map((paragraph) => paragraph.trim()).filter((paragraph) => paragraph.length > 0);
}
/** Stored paragraphs win; otherwise analysis paragraphs. Accepts a legacy single string. */
function resolveICTeaserLocationParagraphs(stored, analysis, block) {
	if (Array.isArray(stored)) return stored.filter((paragraph) => typeof paragraph === "string");
	if (typeof stored === "string") return stored === "" ? [] : [stored];
	return icTeaserLocationAssessmentParagraphs(analysis, block);
}
function icTeaserLocationAssessmentChips(analysis, block) {
	if (analysis == null || analysis.assessment.status !== "generated") return [];
	return persistableLocationChips(analysis.assessment[block].chips);
}
/** Stored chips win; otherwise analysis chips. */
function resolveICTeaserLocationChips(stored, analysis, block) {
	if (stored == null) return icTeaserLocationAssessmentChips(analysis, block);
	return persistableLocationChips(stored);
}
function sanitizeICTeaserLocationChips(chips) {
	return persistableLocationChips(chips);
}
function persistableLocationChips(chips) {
	return chips.flatMap((chip) => {
		const label = chip.label?.trim() ?? "";
		if (label === "") return [];
		switch (chip.sentiment) {
			case "positive":
			case "neutral":
			case "negative": return [{
				label,
				sentiment: chip.sentiment
			}];
			default: return [];
		}
	});
}
var MFH_ATTRIBUTES_RESTRICTION_SOURCE, IC_TEASER_LOCATION_RESTRICTIONS_NOTE_DEFAULT, IC_TEASER_LOCATION_RESTRICTION_DEFINITIONS, LOCATION_POI_KEY_SEPARATOR, IC_TEASER_CUSTOM_LOCATION_TYPE, IC_TEASER_DEFAULT_HIGHLIGHTED_LOCATIONS_PER_CATEGORY;
var init_ic_teaser_location = __esmMin((() => {
	init_location();
	init_maps();
	MFH_ATTRIBUTES_RESTRICTION_SOURCE = "MFH attributes";
	IC_TEASER_LOCATION_RESTRICTIONS_NOTE_DEFAULT = "There are no implications of restrictions affecting the business case.";
	IC_TEASER_LOCATION_RESTRICTION_DEFINITIONS = [
		{
			name: "Urban character preservation",
			description: "Urban character preservation area recorded on the asset.",
			restrictions: ["UrbanisticQuirk"]
		},
		{
			name: "Social preservation",
			description: "Social preservation / Milieuschutz area recorded on the asset.",
			restrictions: ["CompositionOfTheResidentPopulation"]
		},
		{
			name: "Redevelopment area",
			description: "Formal redevelopment area recorded on the asset.",
			restrictions: ["RedevelopmentArea"]
		},
		{
			name: "Monument protection",
			description: "Heritage or monument protection recorded on the asset.",
			restrictions: ["HeritageBuilding"]
		},
		{
			name: "Zoning plan",
			description: "Binding zoning-plan restriction recorded on the asset.",
			restrictions: ["ZoningPlan"]
		},
		{
			name: "Other restrictions",
			description: "Ground lease, rent controls / subsidies, or another restriction recorded on the asset.",
			restrictions: [
				"GroundLease",
				"RentControlOrRentSubsidy",
				"Other"
			]
		}
	];
	LOCATION_POI_KEY_SEPARATOR = "|";
	IC_TEASER_CUSTOM_LOCATION_TYPE = "ic_teaser_custom";
	IC_TEASER_DEFAULT_HIGHLIGHTED_LOCATIONS_PER_CATEGORY = 5;
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/ic-teaser.source.ts
function emptyICTeaserCoverSourceData() {
	return {
		preRenovationPhoto: null,
		address: {
			street: null,
			houseNumber: null,
			postalCode: null,
			city: null,
			quarter: null
		},
		numberOfBuildings: null,
		numberOfUnits: null,
		totalSpaceNlaEntry: null,
		totalInvestmentVolume: null,
		equityCommitment: null,
		cocAtExit: {
			unlevered: null,
			levered: null
		},
		mocPostTaxPostPromote: null,
		irrPostTaxLevered: null
	};
}
function emptyICTeaserExecutiveSummarySourceData() {
	return {
		photo: null,
		additionalBoxes: []
	};
}
function emptyICTeaserAssetOverviewSourceData() {
	return {
		photo: null,
		address: {
			street: null,
			houseNumber: null,
			postalCode: null,
			city: null,
			quarter: null
		},
		coordinates: {
			latitude: null,
			longitude: null
		},
		constructionYear: null,
		energyEfficiencyRatingPreTransformationFrom: null,
		energyEfficiencyRatingPreTransformationTo: null,
		finalEnergyDemandPreTransformationFrom: null,
		finalEnergyDemandPreTransformationTo: null,
		primaryEnergySource: null,
		numberOfBuildings: null,
		totalRentableSpace: null,
		residentialSpace: emptyAmountShare(),
		commercialSpace: emptyAmountShare(),
		numberOfResidentialUnits: null,
		averageResidentialUnitSize: null,
		numberOfCommercialUnits: null,
		numberOfParkingSpaces: null,
		expansionPotentialSqm: null,
		occupancyRate: {
			residential: null,
			commercial: null,
			parking: null
		},
		netRentalIncomePerYear: null,
		netResidentialRentPerSquareMeterPerMonth: null,
		netCommercialRentPerSquareMeterPerMonth: null,
		netParkingRentPerSpotPerMonth: null,
		acquisitionPrice: null,
		acquisitionPricePerSquareMeter: null,
		acquisitionMultiple: null,
		grossPurchasePrice: null,
		germanyMapZoom: null,
		cityMapZoom: null
	};
}
function emptyICTeaserAssetImpressionsSourceData() {
	return { selectedMedia: [] };
}
function emptyICTeaserLocationSourceData() {
	return {
		analysis: null,
		restrictions: [],
		macro: null,
		micro: null,
		visibleCategories: null,
		highlightedLocationKeys: null,
		primaryHighlightedLocationKeys: null,
		restrictionsNote: IC_TEASER_LOCATION_RESTRICTIONS_NOTE_DEFAULT,
		macroChips: null,
		microChips: null,
		mapZoom: null
	};
}
function emptyICTeaserRentAnalysisSourceData() {
	return {
		source: null,
		retrievedAt: null,
		rentIndexBands: [],
		inPlaceRentPerSquareMeter: null,
		targetRentPerSquareMeter: null,
		appliedRentResidential: null,
		manualExpandedSpace: null,
		analysis: null,
		selectedListingIds: null
	};
}
function emptyICTeaserTransformationSourceData() {
	return {
		preRenovationPhoto: null,
		postRenovationPhoto: null,
		tenantImprovementCapexPerSquareMeter: null,
		generalCapexPerSquareMeter: null,
		energeticCapexPerSquareMeter: null,
		expansionCapexPerSquareMeter: null,
		expansionPotentialSqm: null,
		energyEfficiencyRatingEntryFrom: null,
		energyEfficiencyRatingEntryTo: null,
		energyEfficiencyRatingExit: null,
		finalEnergyDemandEntryFrom: null,
		finalEnergyDemandEntryTo: null,
		finalEnergyDemandExit: null,
		lettableAreaEntry: emptyLettableArea(),
		lettableAreaExit: emptyLettableArea(),
		modernizationLevyPerSquareMeterPerMonth: null
	};
}
function emptyICTeaserRentDevelopmentSourceData() {
	return {
		signingDate: null,
		modernizationLevyDate: null,
		exitDate: null,
		chartEndDate: null,
		holdingPeriodYears: null,
		existingRent: [],
		refurbishedNewLettingRent: [],
		expansionNewLettingRent: [],
		averageRent: [],
		rentIncreaseDates: [],
		ervAtPurchase: null,
		ervAtExit: null,
		annualMarketRentGrowth: null,
		annualNewLeaseIndexation: null,
		annualResidentialChurn: null,
		rentIndexIncreaseLimit: null,
		modernizationLevy: null,
		vacancyCapitalizedAtDisposal: null,
		impliedNriUpliftPotential: null,
		occupancy: {
			residential: emptyEntryExit(),
			commercial: emptyEntryExit(),
			parking: emptyEntryExit()
		}
	};
}
function emptyICTeaserProjectDeliverySourceData() {
	return {
		milestones: [],
		refurbishmentDevelopment: [],
		annualRenovatedArea: null,
		annualTenantChurn: null,
		exitYear: null
	};
}
function emptyICTeaserFinancingSourceData() {
	return {
		sourcesUses: null,
		seniorDebt: emptyDebtTranche(),
		capexAndTenantImprovementDebt: emptyDebtTranche(),
		subsidizedDebt: {
			...emptyDebtTranche(),
			grantAmount: null,
			grantShareOfLoan: null
		},
		volumeWeightedCombinedInterestRate: null,
		combinedFinancing: emptyCombinedFinancing(),
		combinedFinancingIncludingSubsidyGrant: emptyCombinedFinancing()
	};
}
function emptyICTeaserKfw261Subsidy() {
	return {
		showOnSlide: true,
		eligibleCosts: null,
		subsidyRate: null,
		bonusEe: null,
		bonusWpb: null,
		bonusSerialRenovation: null,
		totalSubsidyRate: null,
		totalGrant: null,
		subsidizedLoanAfterRepaymentGrant: null,
		interestRate: null,
		repayment: null,
		durationInYears: null,
		fixedInterestPeriodInYears: null
	};
}
function emptyICTeaserBafaSubsidy() {
	return {
		showOnSlide: true,
		capexBasisExcludingHeating: null,
		capexBasisHeating: null,
		totalFundingRate: null,
		totalGrant: null
	};
}
function emptyICTeaserIfbSubsidy() {
	return {
		showOnSlide: false,
		eligibleCosts: null,
		baseGrant: null,
		brickFacadeOrMonumentProtectionGrant: null,
		totalGrant: null
	};
}
function emptyICTeaserDusSubsidy() {
	return {
		showOnSlide: false,
		totalFundingRate: null,
		totalGrant: null
	};
}
function emptyICTeaserFkgSubsidy() {
	return {
		showOnSlide: false,
		capexBasisExcludingHeating: null,
		capexBasisHeating: null,
		totalFundingRate: null,
		totalGrant: null
	};
}
function emptyICTeaserSubsidiesSourceData() {
	return {
		kfw261: emptyICTeaserKfw261Subsidy(),
		bafa: emptyICTeaserBafaSubsidy(),
		ifb: emptyICTeaserIfbSubsidy(),
		dus: emptyICTeaserDusSubsidy(),
		fkg: emptyICTeaserFkgSubsidy()
	};
}
function emptyICTeaserCashFlowSourceData() {
	return {
		yearlyCashFlow: [],
		noiBridge: emptyNoiBridge()
	};
}
function emptyICTeaserDcfSourceData() {
	return {
		unlevered: {
			columns: [],
			rows: []
		},
		levered: {
			columns: [],
			rows: []
		},
		d2gVersion: null,
		calculatedAt: null
	};
}
function emptyICTeaserReturnsSourceData() {
	return {
		returnLadder: {
			preTaxUnlevered: emptyReturnLevel(),
			preTaxLevered: emptyReturnLevel(),
			postTaxLevered: emptyReturnLevel(),
			postTaxPostPromote: emptyReturnLevel()
		},
		cashYields: {
			year1PostCompletion: emptyCashYieldPair(),
			averagePostCompletionToExit: emptyCashYieldPair(),
			atExit: emptyCashYieldPair(),
			averageFullHoldingPeriod: emptyCashYieldPair()
		},
		goingInOut: {
			nla: emptyEntryExitValues(),
			nppVsGrossDisposalPrice: emptyEntryExitValues(),
			nppVsGrossDisposalPricePsm: emptyEntryExitValues(),
			nriMultiple: emptyEntryExitValues(),
			nriYield: emptyEntryExitValues(),
			nriPerYearExclVacancyRent: emptyEntryExitValues(),
			nriPerYearInclVacancyRent: emptyEntryExitValues(),
			nriPmPsqmResi: emptyEntryExitValues(),
			vacancy: emptyEntryExitValues(),
			vacancySqm: emptyEntryExitValues(),
			noiPerYear: emptyEntryExitValues(),
			nriLeakage: emptyEntryExitValues(),
			capRateNoiNpp: emptyEntryExitValues(),
			grossPriceNextBuyerView: emptyEntryExitValues(),
			netYieldNoiGpp: emptyEntryExitValues(),
			gppVsNetDisposalProceeds: emptyEntryExitValues()
		},
		valueBridge: {
			netPurchasePrice: emptyValueBridgeBar(),
			transactionCosts: emptyValueBridgeBar(),
			capexEnergyEfficiency: emptyValueBridgeBar(),
			capexGeneral: emptyValueBridgeBar(),
			capexExpansion: emptyValueBridgeBar(),
			tenantImprovements: emptyValueBridgeBar(),
			leasingCommissionTenantCompensations: emptyValueBridgeBar(),
			partnerFees: emptyValueBridgeBar(),
			vatLoss: emptyValueBridgeBar(),
			netDisposalProceeds: emptyValueBridgeBar(),
			totalGrant: emptyValueBridgeBar(),
			noiCollected: emptyValueBridgeBar(),
			grossProfit: emptyValueBridgeBar()
		}
	};
}
var emptyAmountShare, emptyEntryExit, emptyLettableArea, emptyDebtTranche, emptyCombinedFinancing, emptyNoiBridge, emptyReturnLevel, emptyCashYieldPair, emptyEntryExitValues, emptyValueBridgeBar;
var init_ic_teaser_source = __esmMin((() => {
	init_ic_teaser_location();
	emptyAmountShare = () => ({
		amount: null,
		share: null
	});
	emptyEntryExit = () => ({
		entry: null,
		exit: null
	});
	emptyLettableArea = () => ({
		residentialExisting: null,
		residentialExpansion: null,
		commercial: null
	});
	emptyDebtTranche = () => ({
		amount: null,
		loanToCost: null,
		interestRate: null,
		amortizationStartQuarter: null,
		runningAmortization: null,
		commitmentFee: null,
		upfrontFee: null
	});
	emptyCombinedFinancing = () => ({
		totalLoanAmount: null,
		totalCostBase: null,
		grossPurchasePrice: null,
		capexExcludingVat: null,
		tenantImprovementsAndLeasingCostsExcludingVat: null,
		vatLoss: null,
		partnerCapexFeeIncludingVat: null,
		loanToCost: null,
		loanShareOfGrossDisposalPrice: null
	});
	emptyNoiBridge = () => ({
		entryNoi: null,
		lettingVacantUnits: null,
		rentIncreases: null,
		modernizationLevy: null,
		newLettingAfterRenovation: null,
		additionalResidentialArea: null,
		initialVacantCommercialSpaceNewlyLet: null,
		newCommercialLetting: null,
		vacantParkingLetting: null,
		newParkingLetting: null,
		additionalParkingSpaces: null,
		exitNoi: null
	});
	emptyReturnLevel = () => ({
		profit: null,
		irr: null,
		moC: null
	});
	emptyCashYieldPair = () => ({
		unlevered: null,
		levered: null
	});
	emptyEntryExitValues = () => ({
		entry: null,
		exit: null
	});
	emptyValueBridgeBar = () => ({
		total: null,
		perSquareMeter: null
	});
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/ic-teaser.copy-budget.ts
function slideBodyHeight() {
	return DECK_HEIGHT - SLIDE_PADDING_TOP - SLIDE_PADDING_BOTTOM - SLIDE_HEAD;
}
function slideContentWidth() {
	return DECK_WIDTH - SLIDE_PADDING_X * 2;
}
function charsThatFit(textWidth, textHeight, fontPx, lineHeight, charEm = CHAR_EM, extraLines = 0) {
	if (textWidth <= 0 || textHeight <= 0) return 0;
	const charsPerLine = Math.max(1, Math.floor(textWidth / (fontPx * charEm)));
	const lines = Math.floor(textHeight / (fontPx * lineHeight)) + extraLines;
	return Math.max(0, lines * charsPerLine);
}
function neighborhoodBlockHeight(placeNames) {
	const extraLines = placeNames.reduce((sum, name) => {
		const length = name?.trim().length ?? 0;
		if (length <= LOCATION_NAME_CHARS_PER_LINE) return sum;
		return sum + Math.ceil(length / LOCATION_NAME_CHARS_PER_LINE) - 1;
	}, 0);
	return LOCATION_NEIGHBORHOOD_CHROME + placeNames.length * LOCATION_NEIGHBORHOOD_ROW + extraLines * LOCATION_NAME_EXTRA_LINE;
}
function chipBandHeight(chipCount) {
	if (chipCount <= 0) return 0;
	const rows = Math.ceil(chipCount / LOCATION_CHIPS_PER_ROW);
	return LOCATION_CHIP_BAND_CHROME + rows * LOCATION_CHIP_ROW;
}
/** Plain-text characters that fit in one macro or micro card for this neighborhood layout. */
function icTeaserLocationAssessmentMaxChars(input) {
	const zoningRows = Math.max(input.zoningRowCount, 1);
	const factsHeight = neighborhoodBlockHeight(input.neighborhoodPlaceNames) + LOCATION_FACTS_GAP + LOCATION_ZONING_CHROME + zoningRows * LOCATION_ZONING_ROW + (input.hasRestrictionsNote ? LOCATION_ZONING_NOTE : 0);
	const assessmentHeight = slideBodyHeight() - LOCATION_GRID_GAP - factsHeight;
	const paragraphCount = Math.max(input.paragraphCount, 1);
	const paragraphGaps = Math.max(paragraphCount - 1, 0) * LOCATION_PARAGRAPH_GAP;
	const textHeight = assessmentHeight - LOCATION_ASSESSMENT_CHROME - chipBandHeight(input.chipCount) - paragraphGaps - HEIGHT_SLACK;
	return charsThatFit((slideContentWidth() - LOCATION_GRID_GAP) / 2 - LOCATION_CARD_PADDING_X, textHeight, LOCATION_COPY_FONT, LOCATION_COPY_LINE);
}
/** Even share of a location card. Adding or removing a paragraph changes the share; typing does not. */
function icTeaserLocationParagraphMaxChars(sectionMaxChars, paragraphCount) {
	return Math.floor(Math.max(0, sectionMaxChars) / Math.max(paragraphCount, 1));
}
/** Tight location card: every neighborhood row, max chips, restrictions note, two paragraphs. */
function icTeaserLocationAssessmentWorstCaseParagraphMaxChars() {
	return icTeaserLocationParagraphMaxChars(icTeaserLocationAssessmentMaxChars({
		neighborhoodPlaceNames: LOCATION_ANALYSIS_CATEGORY_KEYS.map(() => "Place"),
		zoningRowCount: IC_TEASER_LOCATION_RESTRICTION_DEFINITIONS.length,
		chipCount: LOCATION_CHIP_MAX,
		paragraphCount: LOCATION_GENERATION_PARAGRAPHS,
		hasRestrictionsNote: true
	}), LOCATION_GENERATION_PARAGRAPHS);
}
function icTeaserExecutiveSummaryBodyMaxChars(columnCount) {
	const columns = Math.max(columnCount, 1);
	const dense = columns > EXECUTIVE_SUMMARY_BASE_COLUMNS;
	const textWidth = (slideContentWidth() - (columns - 1) * EXECUTIVE_SUMMARY_GAP) / columns - (dense ? 28 : 36);
	const fontPx = dense ? 13.5 : 14.5;
	const titleHeight = 9 + (dense ? 16 : 17.5) * 1.25 * 2;
	return charsThatFit(textWidth, slideBodyHeight() - EXECUTIVE_SUMMARY_GRID_PAD_BOTTOM - 43 - titleHeight - 25 - HEIGHT_SLACK, fontPx, 1.5);
}
function icTeaserTransformationCardMaxChars(cardCount, hasFooter) {
	const cards = cardCount === TRANSFORMATION_MAX_CARDS ? TRANSFORMATION_MAX_CARDS : 3;
	const textHeight = (slideBodyHeight() - (cards - 1) * TRANSFORMATION_CARD_GAP) / cards - 24 - 8 - 36 - (hasFooter ? 24 : 0) - 12;
	return charsThatFit(TRANSFORMATION_COLUMN_WIDTH - 28, textHeight, 13, 1.45, CHAR_EM, TRANSFORMATION_EXTRA_LINES);
}
/**
* Green commentary under the two side tables.
* Two rent-assumption labels wrap ("§558 …", "Rent index inflation …"), so those rows are double height.
* Currency and bold KPIs run wider than CHAR_EM, so this card uses a wider em and drops one line of slack.
*/
function icTeaserRentalDevelopmentCommentaryMaxChars() {
	return charsThatFit((slideContentWidth() - 13) / 3 - 26, slideBodyHeight() - 292 - 160 - 22 - 38 - HEIGHT_SLACK, 12.5, 1.5, .7);
}
function icTeaserJCurveCommentaryMaxChars() {
	return charsThatFit((slideContentWidth() - 13) * 3 / 5 - 30, slideBodyHeight() - 26 - 448 - HEIGHT_SLACK, 11.5, 1.52);
}
function icTeaserNoiBridgeCommentaryMaxChars() {
	return charsThatFit((slideContentWidth() - 13) * 2 / 5 - 30, slideBodyHeight() - 26 - 396 - HEIGHT_SLACK, 11.5, 1.52);
}
/** Largest budget for a card body (widest executive-summary cards, three transformation cards). */
function icTeaserCardBodyMaxCharsCeiling(fieldKey) {
	return icTeaserCardBodyMaxChars(fieldKey, WIDEST_CARD_LAYOUT);
}
/**
* Raw-string headroom for tags the card prompt requires.
* `icTeaserCardBodyMaxChars` is visible text; structured-output `.max()` counts tags too.
*/
function icTeaserCardHtmlTagAllowance(fieldKey) {
	const markup = icTeaserCardHtmlMarkup(fieldKey);
	if (markup == null) return 0;
	const paragraphBreaks = Math.max(markup.paragraphs - 1, 0);
	return markup.paragraphs * HTML_PARAGRAPH_CHARS + markup.emphasisPairs * HTML_EMPHASIS_CHARS + paragraphBreaks;
}
function icTeaserCardHtmlMarkup(fieldKey) {
	switch (fieldKey) {
		case "microLocationSummary":
		case "rentPotentialSummary":
		case "energeticModernizationSummary": return {
			paragraphs: 3,
			emphasisPairs: 12
		};
		case "apartmentModernizationSummary":
		case "generalModernizationSummary":
		case "roofExpansionSummary":
		case "energeticModernizationPlanSummary": return {
			paragraphs: 1,
			emphasisPairs: 3
		};
		case "rentalDevelopmentCommentary": return {
			paragraphs: 1,
			emphasisPairs: 4
		};
		case "jCurveCommentary":
		case "noiBridgeCommentary": return {
			paragraphs: 2,
			emphasisPairs: 6
		};
		default: return null;
	}
}
/**
* Structured-output cap for a card body.
* Visible copy stays at `icTeaserCardBodyMaxChars`; this adds the tags that cap must still accept.
* `null` when the field is not card copy.
*/
function icTeaserCardBodyHtmlSchemaMaxChars(fieldKey, layout) {
	const plainMax = icTeaserCardBodyMaxChars(fieldKey, layout);
	if (plainMax == null) return null;
	return plainMax + icTeaserCardHtmlTagAllowance(fieldKey);
}
/** Layout-specific card body cap. `null` when the field is not card copy. */
function icTeaserCardBodyMaxChars(fieldKey, layout) {
	switch (fieldKey) {
		case "microLocationSummary":
		case "rentPotentialSummary":
		case "energeticModernizationSummary": return icTeaserExecutiveSummaryBodyMaxChars(layout.executiveSummaryColumns);
		case "apartmentModernizationSummary":
		case "generalModernizationSummary":
		case "roofExpansionSummary": return icTeaserTransformationCardMaxChars(layout.transformationCardCount, false);
		case "energeticModernizationPlanSummary": return icTeaserTransformationCardMaxChars(layout.transformationCardCount, true);
		case "rentalDevelopmentCommentary": return icTeaserRentalDevelopmentCommentaryMaxChars();
		case "jCurveCommentary": return icTeaserJCurveCommentaryMaxChars();
		case "noiBridgeCommentary": return icTeaserNoiBridgeCommentaryMaxChars();
		default: return null;
	}
}
function icTeaserCardCopyLayoutFromSource(source) {
	const boxes = source?.executiveSummary?.additionalBoxes?.length ?? 0;
	const expansion = source?.transformation?.lettableAreaExit?.residentialExpansion ?? 0;
	return {
		executiveSummaryColumns: EXECUTIVE_SUMMARY_BASE_COLUMNS + boxes,
		transformationCardCount: expansion > 0 ? 4 : 3
	};
}
function teaserHtmlPlainText(html) {
	return html.replace(/<[^>]*>/g, " ").replace(/&nbsp;/gi, " ").replace(/&amp;/gi, "&").replace(/&lt;/gi, "<").replace(/&gt;/gi, ">").replace(/\s+/g, " ").trim();
}
function clampPlainToBudget(plain, maxChars) {
	if (plain.length <= maxChars) return plain;
	if (maxChars <= 0) return "";
	if (maxChars === 1) return "…";
	const room = maxChars - 1;
	let cut = plain.slice(0, room).trimEnd();
	const nextChar = plain.charAt(room);
	if (nextChar !== "" && nextChar !== " ") {
		const space = cut.lastIndexOf(" ");
		if (space > 0) cut = cut.slice(0, space).trimEnd();
	}
	return `${cut}…`;
}
function teaserHtmlHasTag(value) {
	return /<\/?[a-zA-Z][^>]*>/.test(value);
}
function decodeTeaserEntity(entity) {
	switch (entity.toLowerCase()) {
		case "&nbsp;": return " ";
		case "&amp;": return "&";
		case "&lt;": return "<";
		case "&gt;": return ">";
		default: return entity;
	}
}
function parseTeaserTag(raw) {
	const inner = raw.slice(1, -1).trim();
	const isClose = inner.startsWith("/");
	const name = /^\/?\s*([a-zA-Z][\w:-]*)/.exec(inner)?.[1]?.toLowerCase() ?? "";
	const selfClosing = inner.endsWith("/");
	let kind = "void";
	if (name && isClose) kind = "close";
	else if (name && !selfClosing && !TEASER_VOID_TAGS.has(name)) kind = "open";
	return {
		type: "tag",
		raw,
		name,
		kind
	};
}
function tokenizeTeaserHtml(html) {
	const tokens = [];
	const tags = /<[^>]*>/g;
	let last = 0;
	for (const match of html.matchAll(tags)) {
		const index = match.index ?? 0;
		if (index > last) tokens.push({
			type: "text",
			raw: html.slice(last, index),
			name: "",
			kind: "text"
		});
		tokens.push(parseTeaserTag(match[0]));
		last = index + match[0].length;
	}
	if (last < html.length) tokens.push({
		type: "text",
		raw: html.slice(last),
		name: "",
		kind: "text"
	});
	return tokens;
}
function decodedTeaserChars(raw) {
	const chars = [];
	let last = 0;
	for (const match of raw.matchAll(/&nbsp;|&amp;|&lt;|&gt;/gi)) {
		const index = match.index ?? 0;
		for (let cursor = last; cursor < index; cursor += 1) chars.push({
			char: raw.charAt(cursor),
			rawEnd: cursor + 1
		});
		chars.push({
			char: decodeTeaserEntity(match[0]),
			rawEnd: index + match[0].length
		});
		last = index + match[0].length;
	}
	for (let cursor = last; cursor < raw.length; cursor += 1) chars.push({
		char: raw.charAt(cursor),
		rawEnd: cursor + 1
	});
	return chars;
}
/** Same visible string as `teaserHtmlPlainText`, with each character tied back to its token. */
function teaserPlainAtoms(tokens) {
	const atoms = [];
	const push = (char, tokenIndex, rawEnd, fromTag) => {
		if (/\s/.test(char)) {
			if (atoms.length === 0 || /\s/.test(atoms[atoms.length - 1].char)) return;
			atoms.push({
				char: " ",
				tokenIndex,
				rawEnd,
				fromTag
			});
			return;
		}
		atoms.push({
			char,
			tokenIndex,
			rawEnd,
			fromTag
		});
	};
	tokens.forEach((token, tokenIndex) => {
		if (token.type === "tag") {
			push(" ", tokenIndex, 0, true);
			return;
		}
		for (const decoded of decodedTeaserChars(token.raw)) push(decoded.char, tokenIndex, decoded.rawEnd, false);
	});
	while (atoms.length > 0 && /\s/.test(atoms[atoms.length - 1].char)) atoms.pop();
	return atoms;
}
function htmlForPlainPrefix(tokens, atoms, keep) {
	const last = atoms[keep - 1];
	if (!last || last.fromTag) return "";
	const openTags = [];
	let out = "";
	for (let tokenIndex = 0; tokenIndex <= last.tokenIndex; tokenIndex += 1) {
		const token = tokens[tokenIndex];
		if (!token) continue;
		if (token.type === "tag") {
			if (token.kind === "open") openTags.push(token.name);
			else if (token.kind === "close") {
				const openIndex = openTags.lastIndexOf(token.name);
				if (openIndex >= 0) openTags.splice(openIndex, 1);
			}
			out += token.raw;
			continue;
		}
		out += tokenIndex === last.tokenIndex ? token.raw.slice(0, last.rawEnd) : token.raw;
	}
	out += "…";
	for (let index = openTags.length - 1; index >= 0; index -= 1) out += `</${openTags[index]}>`;
	return out;
}
function escapeTeaserTextPreservingEntities(text) {
	return text.replace(/&(?!(?:amp|lt|gt|nbsp);)/gi, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
/**
* Keep HTML that already fits.
* Overflow is cut on a word boundary inside the markup, so `<b>` highlights and entities stay HTML.
* The ellipsis is inserted in the text and open tags are closed after it.
*/
function clampTeaserHtmlToPlainBudget(html, maxChars) {
	const plain = teaserHtmlPlainText(html);
	if (plain.length <= maxChars) return html;
	if (maxChars <= 0) return "";
	const prefix = clampPlainToBudget(plain, maxChars).slice(0, -1);
	if (prefix.length === 0) return teaserHtmlHasTag(html) ? "<p>…</p>" : "…";
	const tokens = tokenizeTeaserHtml(html);
	const truncated = htmlForPlainPrefix(tokens, teaserPlainAtoms(tokens), prefix.length);
	if (truncated && teaserHtmlHasTag(truncated)) return truncated;
	if (!teaserHtmlHasTag(html)) return truncated || "…";
	return `<p>${escapeTeaserTextPreservingEntities(truncated.endsWith("…") ? truncated.slice(0, -1) : truncated)}…</p>`;
}
var DECK_WIDTH, DECK_HEIGHT, SLIDE_PADDING_TOP, SLIDE_PADDING_BOTTOM, SLIDE_PADDING_X, SLIDE_HEAD, HEIGHT_SLACK, CHAR_EM, EXECUTIVE_SUMMARY_BASE_COLUMNS, EXECUTIVE_SUMMARY_GAP, EXECUTIVE_SUMMARY_GRID_PAD_BOTTOM, TRANSFORMATION_COLUMN_WIDTH, TRANSFORMATION_CARD_GAP, TRANSFORMATION_MAX_CARDS, TRANSFORMATION_EXTRA_LINES, LOCATION_GRID_GAP, LOCATION_FACTS_GAP, LOCATION_NEIGHBORHOOD_CHROME, LOCATION_NEIGHBORHOOD_ROW, LOCATION_NAME_CHARS_PER_LINE, LOCATION_NAME_EXTRA_LINE, LOCATION_ZONING_CHROME, LOCATION_ZONING_ROW, LOCATION_ZONING_NOTE, LOCATION_ASSESSMENT_CHROME, LOCATION_COPY_FONT, LOCATION_COPY_LINE, LOCATION_PARAGRAPH_GAP, LOCATION_CARD_PADDING_X, LOCATION_CHIP_ROW, LOCATION_CHIPS_PER_ROW, LOCATION_CHIP_BAND_CHROME, LOCATION_CHIP_MAX, LOCATION_GENERATION_PARAGRAPHS, WIDEST_CARD_LAYOUT, HTML_PARAGRAPH_CHARS, HTML_EMPHASIS_CHARS, TEASER_VOID_TAGS;
var init_ic_teaser_copy_budget = __esmMin((() => {
	init_location();
	init_ic_teaser_location();
	DECK_WIDTH = 1280;
	DECK_HEIGHT = Math.round(DECK_WIDTH * 210 / 297);
	SLIDE_PADDING_TOP = 38;
	SLIDE_PADDING_BOTTOM = 62;
	SLIDE_PADDING_X = 44;
	SLIDE_HEAD = 110;
	HEIGHT_SLACK = 16;
	CHAR_EM = .62;
	EXECUTIVE_SUMMARY_BASE_COLUMNS = 3;
	EXECUTIVE_SUMMARY_GAP = 14;
	EXECUTIVE_SUMMARY_GRID_PAD_BOTTOM = 10;
	TRANSFORMATION_COLUMN_WIDTH = 320;
	TRANSFORMATION_CARD_GAP = 10;
	TRANSFORMATION_MAX_CARDS = 4;
	TRANSFORMATION_EXTRA_LINES = 1;
	LOCATION_GRID_GAP = 10;
	LOCATION_FACTS_GAP = 8;
	LOCATION_NEIGHBORHOOD_CHROME = 54;
	LOCATION_NEIGHBORHOOD_ROW = 28;
	LOCATION_NAME_CHARS_PER_LINE = 42;
	LOCATION_NAME_EXTRA_LINE = 12;
	LOCATION_ZONING_CHROME = 54;
	LOCATION_ZONING_ROW = 18;
	LOCATION_ZONING_NOTE = 22;
	LOCATION_ASSESSMENT_CHROME = 63;
	LOCATION_COPY_FONT = 12.3;
	LOCATION_COPY_LINE = 1.35;
	LOCATION_PARAGRAPH_GAP = .45 * LOCATION_COPY_FONT;
	LOCATION_CARD_PADDING_X = 24;
	LOCATION_CHIP_ROW = 22;
	LOCATION_CHIPS_PER_ROW = 4;
	LOCATION_CHIP_BAND_CHROME = 5;
	LOCATION_CHIP_MAX = 8;
	LOCATION_GENERATION_PARAGRAPHS = 2;
	WIDEST_CARD_LAYOUT = {
		executiveSummaryColumns: EXECUTIVE_SUMMARY_BASE_COLUMNS,
		transformationCardCount: 3
	};
	HTML_PARAGRAPH_CHARS = 7;
	HTML_EMPHASIS_CHARS = 7;
	TEASER_VOID_TAGS = /* @__PURE__ */ new Set([
		"area",
		"base",
		"br",
		"col",
		"embed",
		"hr",
		"img",
		"input",
		"link",
		"meta",
		"source",
		"track",
		"wbr"
	]);
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/ic-teaser.examples.ts
var TEASER_FIELD_EXAMPLES;
var init_ic_teaser_examples = __esmMin((() => {
	TEASER_FIELD_EXAMPLES = {
		executiveSummaryHeader: ["Berlin-Wedding value-add: energetic transformation plus <b>1,000 m²</b> of new lettable area"],
		executiveSummarySubheader: ["Off-market acquisition of a three-building 1928/1954 ensemble at <b>€2,379/m²</b>, repositioned to <b>EPC B</b> with a <b>25%</b> expansion of lettable area over a <b>7.8-year</b> hold."],
		microLocationSummaryHeader: ["Excellent Micro-Location"],
		microLocationSummary: [`<p>The asset sits in the Sprengelkiez in Berlin-Wedding, a fully built-up Wilhelminian block structure with a strongly residential character and a high share of small households — matching the <b>Ø 69.6 m²</b> unit size. Accessibility is the clear strength: U6 Nauener Platz in five minutes’ walk, two supermarkets within <b>300 m</b>, Sparrplatz green space in four minutes and Charité Campus Virchow-Klinikum in twelve.</p>
<p>Berlin remains the deepest residential rental market in Germany, with vacancy in the free-financed stock below <b>1%</b>, completions at roughly half the annual requirement since 2021 and asking rents up at a <b>7.1% CAGR</b> over five years. Exit liquidity in the <b>€20–40m</b> ticket range is good, with 2026 multiples for comparable modernised stock at <b>23–27×</b>.</p>
<p>Critically, the block is <b>not under Milieuschutz</b>, leaving modernisation depth and re-letting uplift unconstrained; the adjacent quarter is covered, so an extension of the ordinance is the main location-level downside. Weaknesses are limited on-street parking and street noise on the Wilhelmstraße frontage (Lden ~61 dB). Overall a core-plus micro location.</p>`],
		rentPotentialSummaryHeader: ["Substantial Rent Development Potential"],
		rentPotentialSummary: ["<p>Berlin-Wedding value-add: energetic transformation plus <b>1,000 m²</b> of new lettable area.</p>"],
		energeticModernizationSummaryHeader: ["Energetic Transformation"],
		energeticModernizationSummary: [`<p>The pricing discount is a compliance exposure: the ensemble is rated <b>EPC F</b> at <b>187 kWh/m²a</b> on gas-fired central heating. Façade and roof insulation, triple glazing and replacement of the boiler with an air-source heat pump plus <b>148 kWp</b> PV take the rating to <b>EPC B</b> at <b>58 kWh/m²a</b> — a <b>69%</b> reduction in final energy demand.</p>
<p>Energetic CAPEX is <b>€2,317,647</b>, or <b>€588/m²</b> of entry lettable area, within total CAPEX of <b>€6.2m</b> excl. VAT deployed over a <b>20-month</b> construction window. The package qualifies for KfW 261 at Effizienzhaus 70 EE: a <b>25%</b> subsidy rate on <b>€3,143,600</b> of eligible costs, giving a non-repayable grant of <b>€785,900</b>.</p>
<p>The modernisation is also what unlocks the §559 levy, so the energetic and rent stories are the same story. Execution risk is concentrated in one place: the roof-conversion building permit is forecast one quarter late under B-Plan 1-64, and Effizienzhaus 70 EE must be confirmed and the KfW application filed before works commence.</p>`],
		assetImpressionsHeader: ["Impressions — sound structure, dated fit-out, unused roof volume"],
		assetImpressionsSubheader: ["Sound Wilhelminian masonry with dated interiors and unused attic volume ready for conversion."],
		apartmentModernizationSummary: ["<p>Units falling vacant are taken to <b>new construction standard</b> — full bathroom and kitchen replacement, new flooring, electrics and smart metering. Budget of €842k covers ~1,027 m² (15 units) at the full standard; the remaining churn units receive cosmetic re-letting works from general CAPEX.</p>"],
		generalModernizationSummary: ["<p>Deferred maintenance cleared in year one: stairwell refurbishment, courtyard resurfacing, bin and bicycle stores, letterbox and entrance systems. €331k total, non-rent-increasing but required for the target letting standard.</p>"],
		energeticModernizationPlanSummary: ["<p>Façade and roof insulation, triple-glazed windows, and replacement of the gas boiler with an <b>air-source heat pump plus 148 kWp PV</b>. Rating moves <b>F → B (187 → 58 kWh/m²a)</b>, qualifying for KfW 261 at Effizienzhaus 70 EE.</p>"],
		roofExpansionSummary: ["<p>Conversion of the unused attic across all three buildings into <b>12 new apartments totalling 1,000 m²</b>, plus two added storeys on the 1954 rear building. €3.53m of expansion CAPEX; let as first-time occupancy, outside Mietspiegel constraints.</p>"],
		rentalDevelopmentCommentary: ["<p>In-place rent steps through sequential §558 Mietspiegel adjustments and the §559 levy after completion, while refurbished and expansion reletting are indexed at target ERV. Blended ERV moves from <b>€10.20/m²</b> at purchase to <b>€14.80/m²</b> at exit as occupancy tightens.</p>"],
		returnsSubheader: ["Returns at four levels, the value bridge from disposal proceeds to gross profit of <b>€18.4m</b>, and entry versus exit on every key metric."]
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/ic-teaser.model.ts
function isICTeaserMedia(value) {
	return value != null && typeof value === "object" && !Array.isArray(value) && typeof value.mediaFileId === "number";
}
function isICTeaserTable(value) {
	if (value == null || typeof value !== "object" || Array.isArray(value)) return false;
	const table = value;
	return Array.isArray(table.columns) && Array.isArray(table.rows);
}
function isICTeaserTableStructuredRow(row) {
	return !Array.isArray(row) && Array.isArray(row.cells) && typeof row.kind === "string";
}
function getICTeaserTableRowCells(row) {
	if (isICTeaserTableStructuredRow(row)) return row.cells;
	return row.map((value) => ({ value }));
}
function getICTeaserTableRowKind(row) {
	if (isICTeaserTableStructuredRow(row)) return row.kind;
	if (row.length === 0) return "data";
	const first = row[0];
	const restEmpty = row.slice(1).every((cell) => cell == null || cell === "");
	if (typeof first === "string" && restEmpty && first === first.toUpperCase()) return "section";
	return "data";
}
/** Edited CAPEX card title, or the default when blank / unset. */
function resolveICTeaserTransformationCardTitle(titles, key) {
	return titles?.[key]?.trim() || IC_TEASER_TRANSFORMATION_CARD_DEFAULT_TITLES[key];
}
function isICTeaserPlaceholderSlide(slide) {
	return slide.key === "placeholder";
}
function isICTeaserRequiredSlide(slide) {
	return slide.key === "header" || slide.key === "finisher";
}
function getICTeaserSlideId(slide) {
	return isICTeaserPlaceholderSlide(slide) ? slide.instanceId : slide.key;
}
function getICTeaserSlideFootnote(slide) {
	return slide.footnote ?? "";
}
function getICTeaserSlideSubtitle(slide) {
	return slide.subtitle ?? "";
}
function emptyICTeaserPlaceholderSlideContent() {
	return {
		name: "",
		title: "",
		subtitle: "",
		footnote: "",
		bodyKind: "text",
		picture: null,
		bodyText: ""
	};
}
function createICTeaserPlaceholderSlide(order, instanceId = crypto.randomUUID()) {
	return {
		key: "placeholder",
		instanceId,
		order,
		isIncluded: true,
		...emptyICTeaserPlaceholderSlideContent()
	};
}
var IC_TEASER_EXECUTIVE_SUMMARY_ADDITIONAL_BOXES_MAX, IC_TEASER_IMPRESSIONS_MAX, IC_TEASER_TRANSFORMATION_CARD_KEYS, IC_TEASER_TRANSFORMATION_CARD_DEFAULT_TITLES, IC_TEASER_MILESTONE_STATUSES, IC_TEASER_MILESTONE_PROGRESS_STATUSES, IC_TEASER_MILESTONE_REPORT_GROUPS, IC_TEASER_FINANCING_TABLE_SECTIONS, TEASER_FIELD_PROMPTS, ALL_TEASER_AI_KEYS, DEFAULT_TEASER_SLIDES;
var init_ic_teaser_model = __esmMin((() => {
	init_ic_teaser_copy_budget();
	init_ic_teaser_examples();
	IC_TEASER_EXECUTIVE_SUMMARY_ADDITIONAL_BOXES_MAX = 2;
	IC_TEASER_IMPRESSIONS_MAX = 8;
	IC_TEASER_TRANSFORMATION_CARD_KEYS = [
		"apartmentModernization",
		"generalModernization",
		"energeticModernization",
		"roofExpansion"
	];
	IC_TEASER_TRANSFORMATION_CARD_DEFAULT_TITLES = {
		apartmentModernization: "Modernization of Vacant (Becoming) Apartments",
		generalModernization: "General Modernization",
		energeticModernization: "Energetic Modernization",
		roofExpansion: "Roof Conversion / Expansion"
	};
	IC_TEASER_MILESTONE_STATUSES = [
		"completed",
		"onTrack",
		"notStarted"
	];
	IC_TEASER_MILESTONE_PROGRESS_STATUSES = [
		"onTrack",
		"atRisk",
		"offTrack",
		"notRequired"
	];
	IC_TEASER_MILESTONE_REPORT_GROUPS = [
		{
			phase: "Acquisition",
			stages: [
				"Opportunity Assessment",
				"Due diligence",
				"Transaction"
			]
		},
		{
			phase: "Value-add",
			stages: ["Planning", "Construction"]
		},
		{
			phase: "Stabilization",
			stages: ["Stabilization"]
		}
	];
	IC_TEASER_FINANCING_TABLE_SECTIONS = [
		"seniorDebt",
		"capexAndTenantImprovementDebt",
		"subsidizedDebt",
		"combinedInterestRate",
		"combinedFinancing",
		"combinedFinancingIncludingSubsidyGrant"
	];
	TEASER_FIELD_PROMPTS = {
		executiveSummaryHeader: {
			key: "executiveSummaryHeader",
			description: "Write the executive-summary slide title. Lead with the investment thesis and its strongest quantified value drivers.",
			maxChars: 190,
			examples: TEASER_FIELD_EXAMPLES.executiveSummaryHeader
		},
		executiveSummarySubheader: {
			key: "executiveSummarySubheader",
			description: "Write the executive-summary slide subtitle. One sentence on the acquisition, transformation, hold, and targeted outcome.",
			maxChars: 340,
			examples: TEASER_FIELD_EXAMPLES.executiveSummarySubheader
		},
		microLocationSummaryHeader: {
			key: "microLocationSummaryHeader",
			description: "Short title for executive-summary card 1 (micro-location). Default: Excellent Micro-Location.",
			maxChars: 80,
			examples: TEASER_FIELD_EXAMPLES.microLocationSummaryHeader
		},
		microLocationSummary: {
			key: "microLocationSummary",
			description: "Pitch the macro and micro location: accessibility, demand, liquidity, and any restrictions or risks that are in the facts.",
			maxChars: icTeaserExecutiveSummaryBodyMaxChars(3),
			examples: TEASER_FIELD_EXAMPLES.microLocationSummary
		},
		rentPotentialSummaryHeader: {
			key: "rentPotentialSummaryHeader",
			description: "Short title for executive-summary card 2 (rent potential). Default: Substantial Rent Development Potential.",
			maxChars: 80,
			examples: TEASER_FIELD_EXAMPLES.rentPotentialSummaryHeader
		},
		rentPotentialSummary: {
			key: "rentPotentialSummary",
			description: "Pitch in-place rent versus reversion: statutory steps, refurbishment re-letting, expansion rent, occupancy, and NRI potential.",
			maxChars: icTeaserExecutiveSummaryBodyMaxChars(3),
			examples: TEASER_FIELD_EXAMPLES.rentPotentialSummary
		},
		energeticModernizationSummaryHeader: {
			key: "energeticModernizationSummaryHeader",
			description: "Short title for executive-summary card 3 (energetic transformation). Default: Energetic Transformation.",
			maxChars: 80,
			examples: TEASER_FIELD_EXAMPLES.energeticModernizationSummaryHeader
		},
		energeticModernizationSummary: {
			key: "energeticModernizationSummary",
			description: "Pitch the energetic transformation: CAPEX, energy-rating improvement, subsidy support, and rent linkage. Include execution risk only when it is in the facts. Use HTML paragraphs; highlight KPIs with <b>.",
			maxChars: icTeaserExecutiveSummaryBodyMaxChars(3),
			examples: TEASER_FIELD_EXAMPLES.energeticModernizationSummary
		},
		assetOverviewHeader: {
			key: "assetOverviewHeader",
			description: "Asset Overview slide title from the strongest acquisition facts: size, occupancy, energy condition, and pricing.",
			maxChars: 190
		},
		assetImpressionsHeader: {
			key: "assetImpressionsHeader",
			description: "Asset Impressions slide title on visible condition and improvement potential — no numbers or technical detail.",
			maxChars: 190,
			examples: TEASER_FIELD_EXAMPLES.assetImpressionsHeader
		},
		assetImpressionsSubheader: {
			key: "assetImpressionsSubheader",
			description: "Write the Asset Impressions slide subtitle: one sentence on visible condition, character, and improvement potential — no numbers or technical detail.",
			maxChars: 340,
			examples: TEASER_FIELD_EXAMPLES.assetImpressionsSubheader
		},
		macroMicroLocationHeader: {
			key: "macroMicroLocationHeader",
			description: "Macro / Micro Location slide title. Lead with location strength; mention a location risk only if it is in the facts.",
			maxChars: 190
		},
		locationRentComparativesHeader: {
			key: "locationRentComparativesHeader",
			description: "Location & Rent Comparables slide title comparing in-place rent, rent-index evidence, and business-plan target rent.",
			maxChars: 190
		},
		transformationHeader: {
			key: "transformationHeader",
			description: "Transformation slide title quantifying CAPEX, energy-rating improvement, and expansion of lettable area.",
			maxChars: 190
		},
		apartmentModernizationSummary: {
			key: "apartmentModernizationSummary",
			description: "Compact pitch for one teaser card. Pitch vacant-apartment modernization and its budget. Call the target new-construction standard only when tenant-improvement CAPEX is at least EUR 750/m²; otherwise call it refurbished standard. Highlight KPIs with <b>.",
			maxChars: icTeaserTransformationCardMaxChars(3, false),
			examples: TEASER_FIELD_EXAMPLES.apartmentModernizationSummary
		},
		generalModernizationSummary: {
			key: "generalModernizationSummary",
			description: "Compact pitch for one teaser card. Pitch general modernization (common parts, façade, services) and its budget as part of the target letting standard. Include programme timing only if dates or phases are in the facts. Highlight KPIs with <b>.",
			maxChars: icTeaserTransformationCardMaxChars(3, false),
			examples: TEASER_FIELD_EXAMPLES.generalModernizationSummary
		},
		energeticModernizationPlanSummary: {
			key: "energeticModernizationPlanSummary",
			description: "Compact pitch for one teaser card. Pitch energetic works, entry-to-exit energy performance, CAPEX, and subsidy qualification. Highlight KPIs with <b>.",
			maxChars: icTeaserTransformationCardMaxChars(3, true),
			examples: TEASER_FIELD_EXAMPLES.energeticModernizationPlanSummary
		},
		roofExpansionSummary: {
			key: "roofExpansionSummary",
			description: "Compact pitch for one teaser card. Pitch roof conversion or expansion: added units and area, CAPEX, and target rent positioning. Mention permit risk only if it is in the facts. Highlight KPIs with <b>.",
			maxChars: icTeaserTransformationCardMaxChars(3, false),
			examples: TEASER_FIELD_EXAMPLES.roofExpansionSummary
		},
		rentalDevelopmentHeader: {
			key: "rentalDevelopmentHeader",
			description: "Rental Development slide title on the main statutory and market-led rent-growth sequence over the hold.",
			maxChars: 190
		},
		rentalDevelopmentCommentary: {
			key: "rentalDevelopmentCommentary",
			description: "Pitch existing-rent steps, refurbished and expansion re-letting, indexation, and blended ERV in one short HTML paragraph. Highlight KPIs with <b>. Include timing only when dates are in the facts.",
			maxChars: icTeaserRentalDevelopmentCommentaryMaxChars(),
			examples: TEASER_FIELD_EXAMPLES.rentalDevelopmentCommentary
		},
		projectDeliveryHeader: {
			key: "projectDeliveryHeader",
			description: "Project Delivery slide title on construction duration, stabilization, refurbishment pace, and critical path — only from present facts.",
			maxChars: 190
		},
		sourcesUsesFinancingHeader: {
			key: "sourcesUsesFinancingHeader",
			description: "Sources & Uses / Financing slide title quantifying debt, tranches, blended rate, equity, and grant impact.",
			maxChars: 190
		},
		subsidiesHeader: {
			key: "subsidiesHeader",
			description: "Subsidies slide title quantifying available grants and distinguishing funded from unfunded CAPEX.",
			maxChars: 190
		},
		cashFlowHeader: {
			key: "cashFlowHeader",
			description: "Cash Flow slide title on equity deployment, cash-flow inflection, exit proceeds, and NOI development.",
			maxChars: 190
		},
		jCurveCommentary: {
			key: "jCurveCommentary",
			description: "Pitch equity outflows, the cumulative trough, operating distributions, break-even, and exit cash flow.",
			maxChars: icTeaserJCurveCommentaryMaxChars()
		},
		noiBridgeCommentary: {
			key: "noiBridgeCommentary",
			description: "Pitch entry-to-exit NOI uplift and quantify the largest positive and negative bridge contributors present in the facts.",
			maxChars: icTeaserNoiBridgeCommentaryMaxChars()
		},
		unleveredDcfHeader: {
			key: "unleveredDcfHeader",
			description: "Unlevered DCF slide title describing the property-level cash-flow extract without financing.",
			maxChars: 190
		},
		leveredDcfHeader: {
			key: "leveredDcfHeader",
			description: "Levered DCF slide title describing equity cash flow after debt drawdown, service, and repayment.",
			maxChars: 190
		},
		returnsHeader: {
			key: "returnsHeader",
			description: "Returns slide title connecting return ladder, cash yields, entry-to-exit change, and value creation.",
			maxChars: 190
		},
		returnsSubheader: {
			key: "returnsSubheader",
			description: "Write the Returns slide subtitle covering the four-level return ladder, the value bridge from disposal proceeds to gross profit, and entry versus exit on key metrics. Quantify only from present facts.",
			maxChars: 340,
			examples: TEASER_FIELD_EXAMPLES.returnsSubheader
		}
	};
	ALL_TEASER_AI_KEYS = Object.keys(TEASER_FIELD_PROMPTS);
	DEFAULT_TEASER_SLIDES = [
		{
			key: "header",
			order: 0,
			isIncluded: true
		},
		{
			key: "executiveSummary",
			order: 1,
			isIncluded: true
		},
		{
			key: "assetOverview",
			order: 2,
			isIncluded: true
		},
		{
			key: "assetImpressions",
			order: 3,
			isIncluded: true
		},
		{
			key: "macroMicroLocation",
			order: 4,
			isIncluded: true
		},
		{
			key: "locationRentComparatives",
			order: 5,
			isIncluded: true
		},
		{
			key: "transformation",
			order: 6,
			isIncluded: true
		},
		{
			key: "rentalDevelopment",
			order: 7,
			isIncluded: true
		},
		{
			key: "projectDelivery",
			order: 8,
			isIncluded: true
		},
		{
			key: "sourcesUsesFinancing",
			order: 9,
			isIncluded: true
		},
		{
			key: "subsidies",
			order: 10,
			isIncluded: true
		},
		{
			key: "cashFlow",
			order: 11,
			isIncluded: true
		},
		{
			key: "unleveredDcf",
			order: 12,
			isIncluded: true
		},
		{
			key: "leveredDcf",
			order: 13,
			isIncluded: true
		},
		{
			key: "returns",
			order: 14,
			isIncluded: true
		},
		{
			key: "finisher",
			order: 15,
			isIncluded: true
		}
	];
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/data/ic-teaser-asset-impressions.data.ts
function buildAssetImpressionsSlideData(ctx) {
	return { selectedMedia: ctx.media.filter((item) => !isMainPhotoPreRenovation(item) && !isMainPhotoPostRenovation(item)).slice(0, 8).map(mapMedia).filter((item) => Boolean(item)) };
}
var init_ic_teaser_asset_impressions_data = __esmMin((() => {
	init_ic_teaser_model();
	init_ic_teaser_data_helpers();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/data/ic-teaser-asset-overview.data.ts
function buildAssetOverviewSlideData(ctx) {
	const { investmentCaseKPIs: kpis, mfh, media } = ctx;
	const attributes = mfh.attributes;
	const location = mfh.candidateLocation;
	const address = {
		...getAddress(location),
		quarter: firstNonEmptyString(location?.quarter)
	};
	const residentialSpace = firstFiniteNumber(kpis.residentialSpaceSqm, attributes?.livingSpace, attributes?.estimatedLivingSpace);
	const commercialSpace = firstFiniteNumber(kpis.commercialSpaceSqm, attributes?.commercialSpace, attributes?.estimatedCommercialSpace);
	const totalRentableSpace = firstFiniteNumber(kpis.totalRentableSpaceSqm, isFiniteNumber(residentialSpace) && isFiniteNumber(commercialSpace) ? residentialSpace + commercialSpace : null, attributes?.totalRentableSpace, attributes?.rentableSpace);
	const energyRating = firstNonEmptyString(kpis.energyEfficiencyRatingEntry, attributes?.energyCertificateClass);
	const finalEnergyDemand = firstFiniteNumber(kpis.finalEnergyDemandEntry, attributes?.endEnergyDemand, attributes?.energyConsumption);
	const numberOfBuildings = firstFiniteNumber(mfh.buildings?.length, attributes?.numberOfBuildings);
	const numberOfResidentialUnits = firstFiniteNumber(kpis.numberOfResidentialUnits, attributes?.numberOfApartments, attributes?.estimatedNumberOfApartments);
	const numberOfCommercialUnits = firstFiniteNumber(kpis.numberOfCommercialUnits, attributes?.numberOfCommercialUnits, attributes?.estimatedNumberOfCommercialUnits);
	const numberOfParkingSpaces = firstFiniteNumber(kpis.numberOfParkingSpaces, attributes?.numberOfParkingSpaces, attributes?.estimatedNumberOfParkingSpaces);
	const averageResidentialUnitSize = firstFiniteNumber(kpis.averageResidentialUnitSize, attributes?.avgSizeOfApartment, isFiniteNumber(residentialSpace) && isFiniteNumber(numberOfResidentialUnits) && numberOfResidentialUnits > 0 ? residentialSpace / numberOfResidentialUnits : null);
	return {
		photo: findMainPreRenovationPhoto(media),
		address,
		coordinates: {
			latitude: firstFiniteNumber(location?.latitude),
			longitude: firstFiniteNumber(location?.longitude)
		},
		constructionYear: firstFiniteNumber(attributes?.constructionYear, kpis.constructionYear),
		energyEfficiencyRatingPreTransformationFrom: energyRating,
		energyEfficiencyRatingPreTransformationTo: energyRating,
		finalEnergyDemandPreTransformationFrom: finalEnergyDemand,
		finalEnergyDemandPreTransformationTo: finalEnergyDemand,
		primaryEnergySource: attributes?.primaryHeatingType ?? null,
		numberOfBuildings,
		totalRentableSpace,
		residentialSpace: {
			amount: residentialSpace,
			share: isFiniteNumber(residentialSpace) && isFiniteNumber(totalRentableSpace) && totalRentableSpace > 0 ? residentialSpace / totalRentableSpace : null
		},
		commercialSpace: {
			amount: commercialSpace,
			share: isFiniteNumber(commercialSpace) && isFiniteNumber(totalRentableSpace) && totalRentableSpace > 0 ? commercialSpace / totalRentableSpace : null
		},
		numberOfResidentialUnits,
		averageResidentialUnitSize,
		numberOfCommercialUnits,
		numberOfParkingSpaces,
		expansionPotentialSqm: kpis.expansionPotentialSqm,
		occupancyRate: {
			residential: firstFiniteNumber(kpis.residentialOccupancy, attributes?.residentialOccupancyRate),
			commercial: firstFiniteNumber(kpis.commercialOccupancy, attributes?.commercialOccupancyRate),
			parking: firstFiniteNumber(kpis.parkingOccupancy, attributes?.parkingOccupancyRate)
		},
		netRentalIncomePerYear: kpis.netRentalIncomePerYear,
		netResidentialRentPerSquareMeterPerMonth: kpis.netResidentialRentPerSquareMeterPerMonth,
		netCommercialRentPerSquareMeterPerMonth: kpis.netCommercialRentPerSquareMeterPerMonth,
		netParkingRentPerSpotPerMonth: kpis.netParkingRentPerSpotPerMonth,
		acquisitionPrice: kpis.acquisitionPrice,
		acquisitionPricePerSquareMeter: kpis.acquisitionPricePerSquareMeter,
		acquisitionMultiple: kpis.acquisitionMultiple,
		grossPurchasePrice: kpis.grossPurchasePrice,
		germanyMapZoom: null,
		cityMapZoom: null
	};
}
var init_ic_teaser_asset_overview_data = __esmMin((() => {
	init_ic_teaser_data_helpers();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/data/ic-teaser-cash-flow.data.ts
function buildCashFlowSlideData(ctx) {
	const gate = resolveDcfGate(ctx.investmentCase);
	if (!gate.canBuild || !gate.d2gVersion) return emptyICTeaserCashFlowSourceData();
	try {
		return extractCashFlowSourceData({
			calcengineValues: collectSheetCalcengineValues(ctx.investmentCase),
			d2gVersion: gate.d2gVersion
		});
	} catch {
		return emptyICTeaserCashFlowSourceData();
	}
}
function extractCashFlowSourceData(params) {
	const keys = resolveInvestmentCaseKpiCalcEngineKeys(params.d2gVersion).cashFlow;
	return {
		yearlyCashFlow: buildYearlyCashFlow(params.calcengineValues, keys, params.d2gVersion),
		noiBridge: buildNoiBridge(params.calcengineValues, keys, params.d2gVersion)
	};
}
function buildYearlyCashFlow(values, keys, d2gVersion) {
	const netCashFlows = readYearly(values, keys.leveredDealCfPostTaxPostPromoteYearly, TABLE_LABEL, d2gVersion);
	const netOperatingIncomes = readYearly(values, keys.netOperatingIncomeYearly, TABLE_LABEL, d2gVersion);
	const years = readCalendarYears(values, keys, d2gVersion);
	const width = trimYearWidth(netCashFlows, netOperatingIncomes, years);
	if (width === 0) return [];
	const rows = [];
	let cumulative = 0;
	for (let index = 0; index < width; index++) {
		const netCashFlow = netCashFlows[index] ?? null;
		cumulative += netCashFlow ?? 0;
		rows.push({
			year: years[index] ?? index + 1,
			netCashFlow,
			cumulativeCashFlow: cumulative,
			netOperatingIncome: netOperatingIncomes[index] ?? null
		});
	}
	return rows;
}
function buildNoiBridge(values, keys, d2gVersion) {
	return {
		entryNoi: readTotal(values, keys.noiBridge.entryNoi, TABLE_LABEL, d2gVersion),
		lettingVacantUnits: readTotal(values, keys.noiBridge.lettingVacantUnits, TABLE_LABEL, d2gVersion),
		rentIncreases: readTotal(values, keys.noiBridge.rentIncreases, TABLE_LABEL, d2gVersion),
		modernizationLevy: readTotal(values, keys.noiBridge.modernizationLevy, TABLE_LABEL, d2gVersion),
		newLettingAfterRenovation: readTotal(values, keys.noiBridge.newLettingAfterRenovation, TABLE_LABEL, d2gVersion),
		additionalResidentialArea: readTotal(values, keys.noiBridge.additionalResidentialArea, TABLE_LABEL, d2gVersion),
		initialVacantCommercialSpaceNewlyLet: readTotal(values, keys.noiBridge.initialVacantCommercialSpaceNewlyLet, TABLE_LABEL, d2gVersion),
		newCommercialLetting: readTotal(values, keys.noiBridge.newCommercialLetting, TABLE_LABEL, d2gVersion),
		vacantParkingLetting: readTotal(values, keys.noiBridge.vacantParkingLetting, TABLE_LABEL, d2gVersion),
		newParkingLetting: readTotal(values, keys.noiBridge.newParkingLetting, TABLE_LABEL, d2gVersion),
		additionalParkingSpaces: readTotal(values, keys.noiBridge.additionalParkingSpaces, TABLE_LABEL, d2gVersion),
		exitNoi: readTotal(values, keys.noiBridge.exitNoi, TABLE_LABEL, d2gVersion)
	};
}
function readCalendarYears(values, keys, d2gVersion) {
	const dateYears = readYearlyValues(values, keys.entryDatesByYear, TABLE_LABEL, d2gVersion).map(coerceYear);
	if (dateYears.some((year) => year != null)) return dateYears;
	return readYearly(values, keys.yearCounts, TABLE_LABEL, d2gVersion);
}
function trimYearWidth(netCashFlows, netOperatingIncomes, years) {
	return findLastIndex(range(0, Math.max(netCashFlows.length, netOperatingIncomes.length, years.length)), (index) => netCashFlows[index] != null || netOperatingIncomes[index] != null) + 1;
}
function yearOf(value) {
	const parsed = dayjs(value);
	return parsed.isValid() ? parsed.year() : null;
}
function coerceYear(value) {
	if (value instanceof Date) return yearOf(value);
	if (typeof value === "string" && value.trim() !== "") {
		const asNumber = Number(value);
		if (Number.isFinite(asNumber)) return coerceYear(asNumber);
		return yearOf(value);
	}
	if (typeof value !== "number" || !Number.isFinite(value)) return null;
	if (Number.isInteger(value) && value >= CALENDAR_YEAR_MIN && value <= CALENDAR_YEAR_MAX) return value;
	if (value > EXCEL_SERIAL_MIN && value < EXCEL_SERIAL_MAX) {
		const date = spreadsheetDateToJsDate(value);
		return date ? yearOf(date) : null;
	}
	if (Number.isInteger(value) && value >= 1) return value;
	return null;
}
var TABLE_LABEL, CALENDAR_YEAR_MIN, CALENDAR_YEAR_MAX, EXCEL_SERIAL_MIN, EXCEL_SERIAL_MAX;
var init_ic_teaser_cash_flow_data = __esmMin((() => {
	init_mfh_investment_case_kpi_calc_engine_keys();
	init_ic_teaser_source();
	init_ic_teaser_dcf_helpers();
	TABLE_LABEL = "Cash flow";
	CALENDAR_YEAR_MIN = 1900;
	CALENDAR_YEAR_MAX = 2100;
	EXCEL_SERIAL_MIN = 2e3;
	EXCEL_SERIAL_MAX = 1e5;
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/data/ic-teaser-executive-summary.data.ts
function buildExecutiveSummarySlideData(ctx) {
	return {
		photo: findMainPreRenovationPhoto(ctx.media),
		additionalBoxes: []
	};
}
var init_ic_teaser_executive_summary_data = __esmMin((() => {
	init_ic_teaser_data_helpers();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/data/ic-teaser-header.data.ts
function buildCoverSlideData(ctx) {
	const { investmentCaseKPIs: kpis, mfh, media } = ctx;
	const address = getAddress(mfh.candidateLocation);
	const numberOfBuildings = mfh.buildings?.length || mfh.attributes?.numberOfBuildings;
	const numberOfUnits = mfh.attributes?.totalNumberOfUnits;
	return {
		preRenovationPhoto: findMainPreRenovationPhoto(media),
		address,
		numberOfBuildings: firstFiniteNumber(numberOfBuildings),
		numberOfUnits: firstFiniteNumber(numberOfUnits),
		totalSpaceNlaEntry: kpis.totalSpaceNlaEntry,
		totalInvestmentVolume: kpis.totalInvestmentVolume,
		equityCommitment: kpis.equityCommitment,
		cocAtExit: {
			unlevered: kpis.cocAtExitUnlevered,
			levered: kpis.cocAtExitLevered
		},
		mocPostTaxPostPromote: kpis.mocPostTaxPostPromote,
		irrPostTaxLevered: kpis.irrPostTaxLevered
	};
}
var init_ic_teaser_header_data = __esmMin((() => {
	init_ic_teaser_data_helpers();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/data/ic-teaser-levered-dcf.data.ts
function buildLeveredDcfRowSpecs(keys) {
	const { levered } = keys;
	return [
		{
			kind: "section",
			label: "Senior Debt"
		},
		dcfCashflowRowSpec("data", "(+) Draw Down", levered.seniorDrawDown),
		dcfCashflowRowSpec("data", "(-) Interest Payment", levered.seniorInterest, { commentRateFormat: "percentage" }),
		dcfCashflowRowSpec("data", "(-) Amortization", levered.seniorAmortization),
		dcfCashflowRowSpec("data", "(-) Financing Fees", levered.seniorFinancingFees, { commentRateFormat: "percentage" }),
		{
			kind: "section",
			label: "Regular Capex & TI Debt"
		},
		dcfCashflowRowSpec("data", "(+) Draw Down", levered.regularCapexTiDrawDown),
		dcfCashflowRowSpec("data", "(-) Interest Payment", levered.regularCapexTiInterest, { commentRateFormat: "percentage" }),
		dcfCashflowRowSpec("data", "(-) Commitment Fee", levered.regularCapexTiCommitmentFee, { commentRateFormat: "percentage" }),
		dcfCashflowRowSpec("data", "(-) Amortization", levered.regularCapexTiAmortization),
		dcfCashflowRowSpec("data", "(-) Financing Fees", levered.regularCapexTiFinancingFees, { commentRateFormat: "percentage" }),
		{
			kind: "section",
			label: "Subsidized Debt"
		},
		dcfCashflowRowSpec("data", "(+) Draw Down", levered.subsidizedDrawDown),
		dcfCashflowRowSpec("data", "(-) Interest Payment", levered.subsidizedInterest, { commentRateFormat: "percentage" }),
		dcfCashflowRowSpec("data", "(+) Grant", levered.subsidizedGrant),
		dcfCashflowRowSpec("data", "(-) Amortization incl. Grant", levered.subsidizedAmortizationInclGrant),
		dcfCashflowRowSpec("data", "(-) Commitment Fee", levered.subsidizedCommitmentFee, { commentRateFormat: "percentage" }),
		dcfCashflowRowSpec("data", "(-) Financing Fees", levered.subsidizedFinancingFees, { commentRateFormat: "percentage" }),
		dcfCashflowRowSpec("total", "Levered Deal CF (Pre Tax)", levered.leveredDealCfPreTax),
		dcfCashflowRowSpec("data", "Corporate Taxes", levered.corporateTaxes, {
			commentRateFormat: "percentage",
			commentUnit: "Effective Tax Rate"
		}),
		dcfCashflowRowSpec("total", "Levered Deal CF (Post Tax, Pre Promote)", levered.leveredDealCfPostTaxPrePromote),
		dcfCashflowRowSpec("data", "Promote to Partner", levered.promoteToPartner),
		dcfCashflowRowSpec("total", "Levered Deal CF (Post Tax, Post Promote)", levered.leveredDealCfPostTaxPostPromote)
	];
}
function buildLeveredDcfSummaryMetricSpecs(keys) {
	const { summary } = keys.levered;
	return [
		{
			label: "IRR",
			key: summary.irr,
			format: "percentage"
		},
		{
			label: "MoC",
			key: summary.moc,
			format: "number"
		},
		{
			label: "Total Contributions",
			key: summary.totalContributions,
			format: "currency"
		},
		{
			label: "Total Distributions",
			key: summary.totalDistributions,
			format: "currency"
		},
		{
			label: "Total Profits",
			key: summary.totalProfits,
			format: "currency"
		}
	];
}
function leveredDcfCommentRateKeys(d2gVersion) {
	return dcfCommentRateKeys(buildLeveredDcfRowSpecs(resolveInvestmentCaseKpiCalcEngineKeys(d2gVersion).dcf));
}
function buildLeveredDcfSlideData(ctx) {
	const gate = resolveDcfGate(ctx.investmentCase);
	if (!gate.canBuild || !gate.d2gVersion) return emptyDcfTable();
	try {
		const keys = resolveInvestmentCaseKpiCalcEngineKeys(gate.d2gVersion).dcf;
		return buildDcfTable({
			specs: buildLeveredDcfRowSpecs(keys),
			calcengineValues: collectDcfCalcengineValues(ctx.investmentCase, leveredDcfCommentRateKeys(gate.d2gVersion)),
			d2gVersion: gate.d2gVersion,
			yearCountsKey: keys.yearCounts,
			tableLabel: "Levered DCF",
			summaryMetricSpecs: buildLeveredDcfSummaryMetricSpecs(keys)
		});
	} catch {
		return emptyDcfTable();
	}
}
var init_ic_teaser_levered_dcf_data = __esmMin((() => {
	init_mfh_investment_case_kpi_calc_engine_keys();
	init_ic_teaser_dcf_helpers();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/ic-teaser.rent.ts
function listingByOfferId(listings) {
	return new Map(listings.map((listing) => [listing.offerId, listing]));
}
function compactListingIds(ids) {
	return compact(ids).filter((id) => id.length > 0);
}
function icTeaserListingHasPhoto(listing) {
	return Boolean(listing.photoUrl);
}
/** Photos first, then nearest. Fill remaining slide slots with listings that have no photo. */
function sortICTeaserRentListingsByPhotoThenDistance(listings) {
	return sortBy(listings, [
		(listing) => icTeaserListingHasPhoto(listing) ? 0 : 1,
		(listing) => listing.distanceMeters ?? Number.POSITIVE_INFINITY,
		(listing) => listing.offerId
	]);
}
/** Default slide set: nearest listings with photos, then nearest without. */
function defaultICTeaserSelectedListingIds(listings) {
	return sortICTeaserRentListingsByPhotoThenDistance(listings).slice(0, 6).map((listing) => listing.offerId);
}
function normalizeICTeaserSelectedListingIds(listings, selectedListingIds) {
	if (selectedListingIds == null) return null;
	const known = listingByOfferId(listings);
	return compactListingIds(selectedListingIds).filter((id) => known.has(id)).slice(0, 6);
}
/** Resolve listings for the slide. `null` ids use the default nearest set. */
function resolveICTeaserSelectedListings(listings, selectedListingIds) {
	const known = listingByOfferId(listings);
	return ((selectedListingIds == null ? defaultICTeaserSelectedListingIds(listings) : normalizeICTeaserSelectedListingIds(listings, selectedListingIds)) ?? []).flatMap((id) => {
		const listing = known.get(id);
		return listing == null ? [] : [listing];
	});
}
function resolveICTeaserSelectedListingIds(listings, selectedListingIds) {
	return resolveICTeaserSelectedListings(listings, selectedListingIds).map((listing) => listing.offerId);
}
function setICTeaserListingSelected(listings, currentIds, offerId, selected) {
	const effective = resolveICTeaserSelectedListingIds(listings, currentIds);
	if (!selected) return effective.filter((id) => id !== offerId);
	if (effective.includes(offerId) || !listings.some((listing) => listing.offerId === offerId)) return effective;
	if (effective.length >= 6) return effective;
	return [...effective, offerId];
}
function moveICTeaserSelectedListing(listings, currentIds, offerId, direction) {
	const effective = resolveICTeaserSelectedListingIds(listings, currentIds);
	const index = effective.indexOf(offerId);
	if (index < 0) return effective;
	const swapWith = direction === "up" ? index - 1 : index + 1;
	if (swapWith < 0 || swapWith >= effective.length) return effective;
	const next = [...effective];
	const current = next[index];
	const other = next[swapWith];
	if (current == null || other == null) return effective;
	next[index] = other;
	next[swapWith] = current;
	return next;
}
function icTeaserRentListingStreet(listing) {
	return [listing.address.street, listing.address.houseNumber].filter((part) => typeof part === "string" && part.trim() !== "").join(" ").trim() || listing.title || "";
}
function icTeaserAverageRentPerSqm(listings, condition) {
	const values = listings.filter((listing) => condition == null ? true : listing.condition === condition).map((listing) => listing.rentPerSqm).filter((value) => typeof value === "number" && Number.isFinite(value));
	if (values.length === 0) return null;
	return values.reduce((sum, value) => sum + value, 0) / values.length;
}
function icTeaserTargetRentWithinComparables(listings, target) {
	if (target == null || !Number.isFinite(target) || listings.length === 0) return null;
	const values = listings.map((listing) => listing.rentPerSqm).filter((value) => typeof value === "number" && Number.isFinite(value));
	if (values.length === 0) return null;
	return target >= Math.min(...values) && target <= Math.max(...values);
}
function icTeaserRentAnalysisSourceLabel(analysis, city) {
	const fromConsiderations = analysis?.dataConsiderations?.source?.trim();
	if (fromConsiderations) return fromConsiderations;
	const trimmedCity = city?.trim();
	if (trimmedCity) return `Rent index for ${trimmedCity}`;
	return null;
}
var IC_TEASER_RENT_COMPARABLES_MAX;
var init_ic_teaser_rent = __esmMin((() => {
	IC_TEASER_RENT_COMPARABLES_MAX = 6;
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/data/ic-teaser-location-rent-comparables.data.ts
function buildLocationRentComparablesSlideData(ctx) {
	const kpis = ctx.investmentCaseKPIs;
	const rentAnalysis = ctx.mfh.attributes?.rentAnalysis;
	const analysis = rentAnalysis?.result ?? null;
	return {
		...emptyICTeaserRentAnalysisSourceData(),
		source: icTeaserRentAnalysisSourceLabel(analysis, kpis.city),
		retrievedAt: rentAnalysis?.generatedAt ?? kpis.lastCalculatedAt,
		rentIndexBands: kpis.rentIndexBands,
		inPlaceRentPerSquareMeter: kpis.inPlaceRentPerSquareMeter,
		targetRentPerSquareMeter: kpis.targetRentPerSquareMeter,
		appliedRentResidential: kpis.appliedRentResidential,
		manualExpandedSpace: kpis.manualExpandedSpace,
		analysis: analysis == null ? null : {
			...analysis,
			listings: sortICTeaserRentListingsByPhotoThenDistance(analysis.listings)
		},
		selectedListingIds: null
	};
}
var init_ic_teaser_location_rent_comparables_data = __esmMin((() => {
	init_ic_teaser_source();
	init_ic_teaser_rent();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/data/ic-teaser-macro-micro-location.data.ts
function buildMacroMicroLocationSlideData(ctx) {
	const attributes = ctx.mfh.attributes;
	const restrictions = buildICTeaserLocationRestrictions(attributes?.restrictions);
	const state = attributes?.locationAnalysis;
	if (!state) return {
		...emptyICTeaserLocationSourceData(),
		restrictions,
		restrictionsNote: IC_TEASER_LOCATION_RESTRICTIONS_NOTE_DEFAULT
	};
	switch (state.status) {
		case "completed": return {
			...emptyICTeaserLocationSourceData(),
			analysis: state.result,
			restrictions
		};
		case "running":
		case "failed": return {
			...emptyICTeaserLocationSourceData(),
			restrictions
		};
		default: return state;
	}
}
var init_ic_teaser_macro_micro_location_data = __esmMin((() => {
	init_ic_teaser_source();
	init_ic_teaser_location();
}));
//#endregion
//#region src/domains/cross-cutting/task/task.model.ts
var TaskSource, TaskRisk, PartnerSetup, TaskStatus, TaskCompletedStatuses, TaskPendingStatuses, isTaskCompleted, TaskMilestone, TaskProgressStatus, MFHTaskMilestoneRecordStatus;
var init_task_model = __esmMin((() => {
	TaskSource = /* @__PURE__ */ function(TaskSource) {
		TaskSource["Internal"] = "Internal";
		TaskSource["External"] = "External";
		return TaskSource;
	}({});
	TaskRisk = /* @__PURE__ */ function(TaskRisk) {
		TaskRisk["NoRisk"] = "NoRisk";
		TaskRisk["LowRisk"] = "LowRisk";
		TaskRisk["MediumRisk"] = "MediumRisk";
		TaskRisk["HighRisk"] = "HighRisk";
		return TaskRisk;
	}({});
	PartnerSetup = /* @__PURE__ */ function(PartnerSetup) {
		PartnerSetup["OldGeneralPlanner"] = "OldGeneralPlanner";
		PartnerSetup["OldDesignBuildContractor"] = "OldDesignBuildContractor";
		PartnerSetup["InternalPlanning"] = "InternalPlanning";
		PartnerSetup["GeneralPlanner"] = "GeneralPlanner";
		PartnerSetup["DesignBuildContractor"] = "DesignBuildContractor";
		return PartnerSetup;
	}({});
	TaskStatus = /* @__PURE__ */ function(TaskStatus) {
		TaskStatus["Opened"] = "Opened";
		TaskStatus["Planned"] = "Planned";
		TaskStatus["WaitingForInput"] = "WaitingForInput";
		TaskStatus["InProgress"] = "InProgress";
		TaskStatus["AwaitingApproval"] = "AwaitingApproval";
		TaskStatus["OnHold"] = "OnHold";
		TaskStatus["Stopped"] = "Stopped";
		TaskStatus["NotRequired"] = "NotRequired";
		TaskStatus["Completed"] = "Completed";
		return TaskStatus;
	}({});
	TaskCompletedStatuses = ["Completed", "NotRequired"];
	TaskPendingStatuses = Object.values(TaskStatus).filter((status) => !TaskCompletedStatuses.includes(status));
	isTaskCompleted = (task) => task?.status && TaskCompletedStatuses.includes(task.status);
	TaskMilestone = /* @__PURE__ */ function(TaskMilestone) {
		TaskMilestone["DataInput"] = "DataInput";
		TaskMilestone["ConfirmedPotential"] = "ConfirmedPotential";
		TaskMilestone["PreApproval"] = "PreApproval";
		TaskMilestone["ExclusivityAgreement"] = "ExclusivityAgreement";
		TaskMilestone["DueDiligence"] = "DueDiligence";
		TaskMilestone["EnergyAssessment"] = "EnergyAssessment";
		TaskMilestone["SubsidyApplication"] = "SubsidyApplication";
		TaskMilestone["SubsidyApproval"] = "SubsidyApproval";
		TaskMilestone["FinancingAgreement"] = "FinancingAgreement";
		TaskMilestone["TransactionSigning"] = "TransactionSigning";
		TaskMilestone["BIMModel"] = "BIMModel";
		TaskMilestone["TransactionClosing"] = "TransactionClosing";
		TaskMilestone["FullFeasibilityStudyRoofConversionAndVerticalExpansion"] = "FullFeasibilityStudyRoofConversionAndVerticalExpansion";
		TaskMilestone["FullFeasibilityStudySeparateNewBuilding"] = "FullFeasibilityStudySeparateNewBuilding";
		TaskMilestone["TargetScopeProjectGoals"] = "TargetScopeProjectGoals";
		TaskMilestone["TechnicalSpecificationFLB"] = "TechnicalSpecificationFLB";
		TaskMilestone["TechnicalSpecificationLVFLB"] = "TechnicalSpecificationLVFLB";
		TaskMilestone["RFQ"] = "RFQ";
		TaskMilestone["ContractAward"] = "ContractAward";
		TaskMilestone["SpecialistPlannersCommission"] = "SpecialistPlannersCommission";
		TaskMilestone["ModernizationNotice"] = "ModernizationNotice";
		TaskMilestone["PermitApplication"] = "PermitApplication";
		TaskMilestone["TechnicalDrawings"] = "TechnicalDrawings";
		TaskMilestone["CostEstimateDIN276"] = "CostEstimateDIN276";
		TaskMilestone["CostCalculationDIN276"] = "CostCalculationDIN276";
		TaskMilestone["PermitApproval"] = "PermitApproval";
		TaskMilestone["ConstructionStart"] = "ConstructionStart";
		TaskMilestone["ScaffoldingConstruction"] = "ScaffoldingConstruction";
		TaskMilestone["RiserReplacement"] = "RiserReplacement";
		TaskMilestone["FacadeInsulation"] = "FacadeInsulation";
		TaskMilestone["Windows"] = "Windows";
		TaskMilestone["Heating"] = "Heating";
		TaskMilestone["Balconies"] = "Balconies";
		TaskMilestone["CellarCeilingInsulation"] = "CellarCeilingInsulation";
		TaskMilestone["RoofInsulation"] = "RoofInsulation";
		TaskMilestone["TotalEnergeticModernization"] = "TotalEnergeticModernization";
		TaskMilestone["RoofDemolition"] = "RoofDemolition";
		TaskMilestone["StructuralReinforcement"] = "StructuralReinforcement";
		TaskMilestone["BuildingExterior"] = "BuildingExterior";
		TaskMilestone["BuildingInterior"] = "BuildingInterior";
		TaskMilestone["TotalVerticalExpansion"] = "TotalVerticalExpansion";
		TaskMilestone["TotalRoofConversion"] = "TotalRoofConversion";
		TaskMilestone["TotalSeparateNewConstruction"] = "TotalSeparateNewConstruction";
		TaskMilestone["FinalCostStatementDIN276"] = "FinalCostStatementDIN276";
		TaskMilestone["FinalInspection"] = "FinalInspection";
		TaskMilestone["ModernizationLevy"] = "ModernizationLevy";
		TaskMilestone["SubsidyPayout"] = "SubsidyPayout";
		return TaskMilestone;
	}({});
	TaskProgressStatus = /* @__PURE__ */ function(TaskProgressStatus) {
		TaskProgressStatus["OnTrack"] = "OnTrack";
		TaskProgressStatus["Delayed"] = "Delayed";
		TaskProgressStatus["OffTrack"] = "OffTrack";
		TaskProgressStatus["NotRequired"] = "NotRequired";
		return TaskProgressStatus;
	}({});
	MFHTaskMilestoneRecordStatus = /* @__PURE__ */ function(MFHTaskMilestoneRecordStatus) {
		MFHTaskMilestoneRecordStatus["NotStarted"] = "NotStarted";
		MFHTaskMilestoneRecordStatus["InProgress"] = "InProgress";
		MFHTaskMilestoneRecordStatus["NotRequired"] = "NotRequired";
		MFHTaskMilestoneRecordStatus["Completed"] = "Completed";
		return MFHTaskMilestoneRecordStatus;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/task/task.i18n.ts
var TaskMilestoneEnglish, TaskMilestoneGerman, TaskProgressStatusTranslation, TaskStatusTranslation;
var init_task_i18n = __esmMin((() => {
	init_task_model();
	TaskMilestoneEnglish = {
		["DataInput"]: "Data input",
		["ConfirmedPotential"]: "Confirmed potential",
		["PreApproval"]: "Pre-approval",
		["ExclusivityAgreement"]: "Exclusivity agreement",
		["DueDiligence"]: "Due diligence",
		["TransactionSigning"]: "Transaction signing",
		["TransactionClosing"]: "Transaction closing",
		["FinancingAgreement"]: "Financing agreement",
		["SubsidyApplication"]: "Subsidy application",
		["SubsidyApproval"]: "Subsidy approval",
		["BIMModel"]: "BIM model",
		["FullFeasibilityStudySeparateNewBuilding"]: "Full feasibility study",
		["EnergyAssessment"]: "Energy assessment",
		["TargetScopeProjectGoals"]: "Target scope",
		["CostEstimateDIN276"]: "Cost estimate (DIN 276)",
		["CostCalculationDIN276"]: "Cost calculation (DIN 276)",
		["PermitApplication"]: "Permit application",
		["PermitApproval"]: "Permit approval",
		["RFQ"]: "RFQ",
		["ContractAward"]: "Contract award",
		["ConstructionStart"]: "Construction start",
		["ScaffoldingConstruction"]: "Scaffolding construction",
		["RiserReplacement"]: "Riser replacement",
		["FacadeInsulation"]: "Facade insulation",
		["Windows"]: "Windows",
		["Heating"]: "Heating",
		["Balconies"]: "Balconies",
		["CellarCeilingInsulation"]: "Cellar ceiling insulation",
		["RoofInsulation"]: "Roof insulation",
		["RoofDemolition"]: "Roof demolition",
		["StructuralReinforcement"]: "Structural reinforcement",
		["BuildingExterior"]: "Building exterior",
		["BuildingInterior"]: "Building interior",
		["TotalVerticalExpansion"]: "Total vertical expansion",
		["TotalRoofConversion"]: "Total loft conversion",
		["TotalEnergeticModernization"]: "Total energetic modernization",
		["TotalSeparateNewConstruction"]: "Total separate new construction",
		["FinalCostStatementDIN276"]: "Final cost statement (DIN 276)",
		["FinalInspection"]: "Final inspection",
		["ModernizationNotice"]: "Modernization notice",
		["ModernizationLevy"]: "Modernization levy",
		["SpecialistPlannersCommission"]: "Specialist planner contract ward",
		["TechnicalDrawings"]: "Technical drawings",
		["TechnicalSpecificationFLB"]: "Technical specification (FLB)",
		["TechnicalSpecificationLVFLB"]: "Technical specification (LV/FLB)",
		["FullFeasibilityStudyRoofConversionAndVerticalExpansion"]: "Full feasibility study",
		["SubsidyPayout"]: "Subsidy payout"
	};
	TaskMilestoneGerman = {
		["DataInput"]: "Daten erfasst",
		["ConfirmedPotential"]: "Potenzial bestätigt",
		["PreApproval"]: "Vorabgenehmigung bestätigt",
		["ExclusivityAgreement"]: "Exklusivitätsvereinbarung",
		["DueDiligence"]: "Due Diligence",
		["TransactionSigning"]: "Kaufvertrag",
		["TransactionClosing"]: "BNL-Wechsel",
		["FinancingAgreement"]: "Vertragsabschluss Finanzierung",
		["SubsidyApplication"]: "Fördermittelantrag",
		["SubsidyApproval"]: "Fördermittelzusage",
		["BIMModel"]: "BIM-Modell",
		["FullFeasibilityStudySeparateNewBuilding"]: "Durchführbarkeitsstudie - MP Separater Neubau",
		["EnergyAssessment"]: "Energetische Bewertung",
		["TargetScopeProjectGoals"]: "Projektziele",
		["CostEstimateDIN276"]: "Kostenschätzung (DIN 276)",
		["CostCalculationDIN276"]: "Kostenberechnung (DIN 276)",
		["PermitApplication"]: "Bauantrag",
		["PermitApproval"]: "Baugenehmigung",
		["RFQ"]: "Ausschreibung Bauvorhaben",
		["ContractAward"]: "Vertragsabschluss Bauvorhaben",
		["ConstructionStart"]: "Baustart",
		["ScaffoldingConstruction"]: "Gerüstaufbau",
		["RiserReplacement"]: "Strangsanierung",
		["FacadeInsulation"]: "Fassadendämmung",
		["Windows"]: "Fenstertausch",
		["Heating"]: "Heizungstausch",
		["Balconies"]: "Balkonsanierung",
		["CellarCeilingInsulation"]: "Kellerdeckendämmung",
		["RoofInsulation"]: "Dachdämmung",
		["RoofDemolition"]: "Rückbau des Dachstuhls",
		["StructuralReinforcement"]: "Statische Ertüchtigung",
		["BuildingExterior"]: "Herstellung der Gebäudehülle",
		["BuildingInterior"]: "Innenausbau",
		["TotalVerticalExpansion"]: "Aufstockung gesamt",
		["TotalEnergeticModernization"]: "Energetische Sanierung gesamt",
		["TotalSeparateNewConstruction"]: "Separater Neubau gesamt",
		["TotalRoofConversion"]: "Dachausbau gesamt",
		["FinalCostStatementDIN276"]: "Kostenfeststellung (DIN 276)",
		["FinalInspection"]: "Bauabnahme",
		["ModernizationNotice"]: "Modernisierungsankündigung",
		["ModernizationLevy"]: "Modernisierungsumlage",
		["SpecialistPlannersCommission"]: "Fachplanerbeauftragung",
		["TechnicalDrawings"]: "Leitdetailzeichnungen",
		["TechnicalSpecificationFLB"]: "Technische Leistungsbeschreibung (FLB)",
		["TechnicalSpecificationLVFLB"]: "Leistungsbeschreibung (LV/FLB)",
		["FullFeasibilityStudyRoofConversionAndVerticalExpansion"]: "Durchführbarkeitsstudie Dachausbau und Aufstockung",
		["SubsidyPayout"]: "Fördermittelauszahlung"
	};
	TaskProgressStatusTranslation = {
		["OnTrack"]: "On track",
		["Delayed"]: "Delayed / at risk",
		["OffTrack"]: "Off track",
		["NotRequired"]: "Not required"
	};
	TaskStatusTranslation = {
		["Opened"]: "Opened",
		["Planned"]: "Planned",
		["WaitingForInput"]: "Awaiting input",
		["InProgress"]: "In progress",
		["AwaitingApproval"]: "Awaiting approval",
		["OnHold"]: "On hold",
		["Stopped"]: "Stopped",
		["NotRequired"]: "Not required",
		["Completed"]: "Completed"
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/data/ic-teaser-project-delivery.data.ts
function icTeaserMilestoneMatchesTimelineGate(name, gate) {
	const key = name?.trim().toLowerCase();
	if (!key) return false;
	if (key === gate.name.toLowerCase()) return true;
	if (key === gate.taskMilestone.toLowerCase()) return true;
	return key === TaskMilestoneEnglish[gate.taskMilestone].toLowerCase();
}
function selectICTeaserProjectTimelineMilestones(milestones) {
	const source = compact(milestones ?? []);
	return compact(IC_TEASER_PROJECT_TIMELINE_GATES.map((gate) => {
		const match = minBy(source.filter((milestone) => icTeaserMilestoneMatchesTimelineGate(milestone.name, gate)), (milestone) => {
			const date = asDayjs(milestone.expectedDate ?? milestone.planDate);
			return date ? date.valueOf() : Number.POSITIVE_INFINITY;
		});
		if (!match) return null;
		return {
			...match,
			name: gate.name,
			phase: gate.phase,
			stage: gate.stage
		};
	}));
}
function buildProjectDeliverySlideData(ctx) {
	const { investmentCase, investmentCaseKPIs: kpis, milestoneRecords } = ctx;
	const kpiKeys = resolveInvestmentCaseKpiCalcEngineKeys(investmentCase.d2gVersion);
	const entryDate = asDayjs(kpis.entryDate);
	const exitDate = addDuration(entryDate, kpis.durationInMonths, "month");
	const annualTenantChurn = kpis.annualTenantChurn;
	const annualRenovatedArea = isFiniteNumber(annualTenantChurn) && isFiniteNumber(kpis.residentialSpaceSqm) ? annualTenantChurn * kpis.residentialSpaceSqm : null;
	const filteredMilestoneRecords = milestoneRecords.filter((record) => record.status !== "NotRequired");
	return {
		...emptyICTeaserProjectDeliverySourceData(),
		milestones: mapMilestoneRecords(filteredMilestoneRecords),
		refurbishmentDevelopment: buildRefurbishmentDevelopment({
			unrefurbishedQuarterly: readInvestmentCaseCalcEngineVector(investmentCase, kpiKeys.unrefurbishedResidentialAreaMonthly),
			refurbishedQuarterly: readInvestmentCaseCalcEngineVector(investmentCase, kpiKeys.refurbishedResidentialAreaMonthly),
			columnDates: rentalTableColumnDates(readInvestmentCaseCalcEngineRawVector(investmentCase, kpiKeys.rentalTableDates), readInvestmentCaseCalcEngineVector(investmentCase, kpiKeys.rentalTableQuarters), entryDate),
			entryDate,
			exitDate
		}),
		annualRenovatedArea,
		annualTenantChurn,
		exitYear: exitDate?.year() ?? null
	};
}
function mapMilestoneRecords(records) {
	return compact(records.map((record, index) => {
		const name = milestoneRecordName(record);
		if (!name) return null;
		const gate = timelineGateForRecord(record, name);
		const planDate = formatDate(record.dueDate);
		const expectedDate = formatDate(record.expectedDate);
		const variance = varianceInQuarters(asDayjs(record.dueDate)?.toDate() ?? null, asDayjs(record.expectedDate)?.toDate() ?? null);
		return {
			id: record.taskId != null ? String(record.taskId) : `milestone-${index}`,
			name,
			phase: gate?.phase ?? record.phase ?? record.phaseLabel ?? null,
			stage: gate?.stage ?? record.stage ?? record.stageLabel ?? null,
			planDate,
			expectedDate,
			status: mapMilestoneStatus(record.status),
			progressStatus: mapMilestoneProgressStatus(record.progressStatus),
			varianceInQuarters: variance == null || variance === 0 ? null : variance,
			showOnTimeline: true
		};
	}));
}
function milestoneRecordName(record) {
	const labelled = record.milestoneEnglishLabel?.trim();
	if (labelled) return labelled;
	const milestone = record.milestone?.trim();
	if (!milestone) return null;
	if (isTaskMilestone(milestone)) return TaskMilestoneEnglish[milestone];
	return milestone;
}
function timelineGateForRecord(record, name) {
	return IC_TEASER_PROJECT_TIMELINE_GATES.find((gate) => record.milestone === gate.taskMilestone || icTeaserMilestoneMatchesTimelineGate(name, gate));
}
function isTaskMilestone(value) {
	return Object.values(TaskMilestone).includes(value);
}
function varianceInQuarters(planDate, forecastDate) {
	if (!planDate || !forecastDate) return null;
	return quarterIndex$1(forecastDate) - quarterIndex$1(planDate);
}
function quarterIndex$1(date) {
	const parsed = asDayjs(date);
	if (!parsed) return 0;
	return parsed.year() * 4 + Math.floor(parsed.month() / 3);
}
/** IC chart area vectors are quarterly (despite the `_monthly` key names): one bar per calendar year from its last quarter up to exit. */
function buildRefurbishmentDevelopment(params) {
	const { unrefurbishedQuarterly, refurbishedQuarterly, columnDates, entryDate, exitDate } = params;
	const quarters = compact(range(0, Math.max(unrefurbishedQuarterly?.length ?? 0, refurbishedQuarterly?.length ?? 0)).map((index) => {
		const date = rentalTableColumnDateAt(columnDates, index, entryDate);
		if (!date || exitDate && date.isAfter(exitDate, "day")) return null;
		const unrefurbishedArea = finiteAt(unrefurbishedQuarterly, index);
		const refurbishedArea = finiteAt(refurbishedQuarterly, index);
		if (unrefurbishedArea == null && refurbishedArea == null) return null;
		return {
			date,
			unrefurbishedArea,
			refurbishedArea
		};
	}));
	return sortBy(compact(Object.values(groupBy(quarters, (quarter) => quarter.date.year())).map((yearQuarters) => maxBy(yearQuarters, (quarter) => quarter.date.valueOf()))), (quarter) => quarter.date.valueOf()).map((quarter) => ({
		year: quarter.date.year(),
		unrefurbishedArea: quarter.unrefurbishedArea,
		refurbishedArea: quarter.refurbishedArea
	}));
}
function mapMilestoneStatus(status) {
	switch (status) {
		case "Completed": return "completed";
		case "InProgress": return "onTrack";
		case "NotStarted":
		case "NotRequired":
		case null:
		case void 0: return "notStarted";
		default: return status;
	}
}
function mapMilestoneProgressStatus(progressStatus) {
	switch (progressStatus) {
		case "OnTrack": return "onTrack";
		case "Delayed": return "atRisk";
		case "OffTrack": return "offTrack";
		case "NotRequired": return "notRequired";
		case null:
		case void 0: return null;
		default: return progressStatus;
	}
}
function finiteAt(values, index) {
	const value = values?.[index];
	return isFiniteNumber(value) ? value : null;
}
var IC_TEASER_PROJECT_TIMELINE_GATES;
var init_ic_teaser_project_delivery_data = __esmMin((() => {
	init_task_i18n();
	init_task_model();
	init_mfh_investment_case_kpi_calc_engine_keys();
	init_ic_teaser_source();
	init_ic_teaser_data_helpers();
	IC_TEASER_PROJECT_TIMELINE_GATES = [
		{
			taskMilestone: "DataInput",
			name: "Identification",
			phase: "Acquisition",
			stage: "Opportunity Assessment",
			major: true
		},
		{
			taskMilestone: "ExclusivityAgreement",
			name: "Exclusivity Agreement",
			phase: "Acquisition",
			stage: "Due Diligence",
			major: false
		},
		{
			taskMilestone: "TransactionSigning",
			name: "Signing",
			phase: "Acquisition",
			stage: "Transaction",
			major: false
		},
		{
			taskMilestone: "TransactionClosing",
			name: "Closing",
			phase: "Transformation",
			stage: "Planning",
			major: true
		},
		{
			taskMilestone: "ModernizationNotice",
			name: "Modernization Notice",
			phase: "Transformation",
			stage: "Construction",
			major: false
		},
		{
			taskMilestone: "FinalCostStatementDIN276",
			name: "Final cost statement",
			phase: "Stabilization",
			stage: "Stabilization",
			major: true
		},
		{
			taskMilestone: "SubsidyPayout",
			name: "Subsidy Payout",
			phase: "Stabilization",
			stage: "Stabilization",
			major: true
		}
	];
	__name(quarterIndex$1, "quarterIndex");
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/data/ic-teaser-rental-development.data.ts
function buildRentalDevelopmentSlideData(ctx) {
	const { investmentCase, investmentCaseKPIs: kpis } = ctx;
	const kpiKeys = resolveInvestmentCaseKpiCalcEngineKeys(investmentCase.d2gVersion);
	const entryDate = asDayjs(kpis.entryDate);
	const exitDate = addDuration(entryDate, kpis.durationInMonths, "month");
	const modernizationLevyDate = addDuration(entryDate, isFiniteNumber(kpis.energyEfficiencyEndMonths) ? kpis.energyEfficiencyEndMonths + (isFiniteNumber(kpis.reletDelayMonths) ? kpis.reletDelayMonths : 0) : null, "month");
	const columnDates = rentalTableColumnDates(readInvestmentCaseCalcEngineRawVector(investmentCase, kpiKeys.rentalTableDates), readInvestmentCaseCalcEngineVector(investmentCase, kpiKeys.rentalTableQuarters), entryDate);
	const existingRent = toRentSeries(readInvestmentCaseCalcEngineVector(investmentCase, kpiKeys.existingRentPsmPmMonthly), columnDates, entryDate);
	const refurbishedNewLettingRent = toRentSeries(readInvestmentCaseCalcEngineVector(investmentCase, kpiKeys.refurbishedNewLettingRentPsmPmMonthly), columnDates, entryDate);
	const expansionNewLettingRent = meaningfulSeries(toRentSeries(readInvestmentCaseCalcEngineVector(investmentCase, kpiKeys.expansionNewLettingRentPsmPmMonthly), columnDates, entryDate));
	const averageRent = toRentSeries(readInvestmentCaseCalcEngineVector(investmentCase, kpiKeys.blendedErvPsmPmMonthly), columnDates, entryDate);
	const lastSeriesDate = lastDatedPoint([
		existingRent,
		refurbishedNewLettingRent,
		expansionNewLettingRent,
		averageRent
	]);
	return {
		...emptyICTeaserRentDevelopmentSourceData(),
		signingDate: formatDate(entryDate),
		modernizationLevyDate: formatDate(modernizationLevyDate),
		exitDate: formatDate(exitDate),
		chartEndDate: formatDate(lastSeriesDate) ?? formatDate(exitDate),
		holdingPeriodYears: isFiniteNumber(kpis.durationInMonths) ? kpis.durationInMonths / 12 : null,
		existingRent,
		refurbishedNewLettingRent,
		expansionNewLettingRent,
		averageRent,
		rentIncreaseDates: bgbIncreaseDates(kpis, entryDate, exitDate),
		ervAtPurchase: firstFiniteNumber(...averageRent.map((point) => point.value)) ?? kpis.netResidentialRentPerSquareMeterPerMonth,
		ervAtExit: kpis.targetRentPerSquareMeter,
		annualMarketRentGrowth: kpis.annualMarketRentGrowth,
		annualNewLeaseIndexation: NEW_LEASE_INDEXATION,
		annualResidentialChurn: kpis.annualTenantChurn,
		rentIndexIncreaseLimit: RENT_INDEX_INCREASE_LIMIT,
		modernizationLevy: firstFiniteNumber(kpis.modernizationLevyAveragePerSquareMeterPerMonth, kpis.modernizationLevyPerSquareMeterPerMonth),
		vacancyCapitalizedAtDisposal: true,
		impliedNriUpliftPotential: kpis.impliedNriUpliftPotential,
		occupancy: {
			residential: {
				entry: kpis.residentialOccupancy,
				exit: kpis.residentialOccupancyExit
			},
			commercial: {
				entry: kpis.commercialOccupancy,
				exit: kpis.commercialOccupancyExit
			},
			parking: {
				entry: kpis.parkingOccupancy,
				exit: kpis.parkingOccupancyExit
			}
		}
	};
}
function bgbIncreaseDates(kpis, origin, exit) {
	return compact([
		kpis.firstBgbRentIncreaseTiming,
		kpis.secondBgbRentIncreaseTiming,
		kpis.thirdBgbRentIncreaseTiming,
		kpis.fourthBgbRentIncreaseTiming
	].map((timing) => {
		if (!isFiniteNumber(timing) || timing <= 0) return null;
		const date = addDuration(origin, timing, "month");
		if (!date?.isValid()) return null;
		if (origin && date.isBefore(origin, "day")) return null;
		if (exit && date.isAfter(exit, "day")) return null;
		return formatDate(date);
	}));
}
function toRentSeries(values, columnDates, origin) {
	if (isNil(values) || values.length === 0) return [];
	const series = dropRightWhile(values, isNil);
	if (series.length === 0) return [];
	return compact(series.map((value, index) => {
		if (!isFiniteNumber(value)) return null;
		const date = rentalTableColumnDateAt(columnDates, index, origin);
		if (!date?.isValid()) return null;
		return {
			date: formatDate(date),
			value
		};
	}));
}
function lastDatedPoint(seriesList) {
	let latest = null;
	for (const series of seriesList) {
		const date = asDayjs(findLast(series, (point) => point.date != null)?.date);
		if (date && (!latest || date.isAfter(latest))) latest = date;
	}
	return latest;
}
function meaningfulSeries(points) {
	return points.some((point) => isFiniteNumber(point.value) && point.value > 0) ? points : [];
}
var RENT_INDEX_INCREASE_LIMIT, NEW_LEASE_INDEXATION;
var init_ic_teaser_rental_development_data = __esmMin((() => {
	init_mfh_investment_case_kpi_calc_engine_keys();
	init_ic_teaser_source();
	init_ic_teaser_data_helpers();
	RENT_INDEX_INCREASE_LIMIT = .15;
	NEW_LEASE_INDEXATION = .02;
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/data/ic-teaser-returns.data.ts
function buildReturnsSlideData(ctx) {
	const { investmentCase, investmentCaseKPIs: kpis } = ctx;
	const keys = resolveInvestmentCaseKpiCalcEngineKeys(investmentCase.d2gVersion).returns;
	const empty = emptyICTeaserReturnsSourceData();
	const valueBridgeRows = kpis.valueBridge?.rows;
	return {
		...empty,
		returnLadder: {
			preTaxUnlevered: readReturnLevel(investmentCase, keys.ladder.preTaxUnlevered, kpis.returnLadder?.rows.preTaxUnlevered),
			preTaxLevered: readReturnLevel(investmentCase, keys.ladder.preTaxLevered, kpis.returnLadder?.rows.preTaxLevered),
			postTaxLevered: readReturnLevel(investmentCase, keys.ladder.postTaxLevered, kpis.returnLadder?.rows.postTaxLevered),
			postTaxPostPromote: readReturnLevel(investmentCase, keys.ladder.postTaxPostPromote, kpis.returnLadder?.rows.postTaxPostPromote)
		},
		cashYields: {
			year1PostCompletion: readCashYieldPair(investmentCase, keys.cashYields.year1PostCompletion),
			averagePostCompletionToExit: readCashYieldPair(investmentCase, keys.cashYields.averagePostCompletionToExit),
			atExit: readCashYieldPair(investmentCase, keys.cashYields.atExit),
			averageFullHoldingPeriod: readCashYieldPair(investmentCase, keys.cashYields.averageFullHoldingPeriod)
		},
		goingInOut: {
			nla: readEntryExit(investmentCase, keys.goingInOut.nla, kpis.goingInOut?.rows.NLA),
			nppVsGrossDisposalPrice: readEntryExit(investmentCase, keys.goingInOut.nppVsGrossDisposalPrice, kpis.goingInOut?.rows.NPPVsGrossDisposalPrice),
			nppVsGrossDisposalPricePsm: readEntryExit(investmentCase, keys.goingInOut.nppVsGrossDisposalPricePsm, kpis.goingInOut?.rows.netPriceSqm),
			nriMultiple: readEntryExit(investmentCase, keys.goingInOut.nriMultiple, kpis.goingInOut?.rows.NRIMultiple),
			nriYield: readEntryExit(investmentCase, keys.goingInOut.nriYield, kpis.goingInOut?.rows.NRIYield),
			nriPerYearExclVacancyRent: readEntryExit(investmentCase, keys.goingInOut.nriPerYearExclVacancyRent, kpis.goingInOut?.rows.nriYearlyExclVacancyRent),
			nriPerYearInclVacancyRent: readEntryExit(investmentCase, keys.goingInOut.nriPerYearInclVacancyRent, kpis.goingInOut?.rows.nriYearlyInclVacancyRent),
			nriPmPsqmResi: readEntryExit(investmentCase, keys.goingInOut.nriPmPsqmResi, kpis.goingInOut?.rows.NRIMonthlySqm),
			vacancy: readEntryExit(investmentCase, keys.goingInOut.vacancy, kpis.goingInOut?.rows.vacancy),
			vacancySqm: readEntryExit(investmentCase, keys.goingInOut.vacancySqm, kpis.goingInOut?.rows.vacancySqm),
			noiPerYear: readEntryExit(investmentCase, keys.goingInOut.noiPerYear, kpis.goingInOut?.rows.NOIYearly),
			nriLeakage: readEntryExit(investmentCase, keys.goingInOut.nriLeakage, kpis.goingInOut?.rows.NRILeakage),
			capRateNoiNpp: readEntryExit(investmentCase, keys.goingInOut.capRateNoiNpp, kpis.goingInOut?.rows.capRateNoiNpp),
			grossPriceNextBuyerView: readEntryExit(investmentCase, keys.goingInOut.grossPriceNextBuyerView, kpis.goingInOut?.rows.grossPriceNextBuyerView),
			netYieldNoiGpp: readEntryExit(investmentCase, keys.goingInOut.netYieldNoiGpp, kpis.goingInOut?.rows.netYieldNoiGpp),
			gppVsNetDisposalProceeds: readEntryExit(investmentCase, keys.goingInOut.gppVsNetDisposalProceeds, kpis.goingInOut?.rows.GPPVsNetDisposalProceeds)
		},
		valueBridge: {
			netPurchasePrice: readValueBridgeBar(investmentCase, keys.valueBridge.netPurchasePrice, {
				total: firstFiniteNumber(valueBridgeRows?.netPurchasePrice?.total, kpis.goingInOut?.rows.NPPVsGrossDisposalPrice?.entry),
				perSquareMeter: valueBridgeRows?.netPurchasePrice?.m2Entry
			}),
			transactionCosts: readValueBridgeBar(investmentCase, keys.valueBridge.transactionCosts, {
				total: valueBridgeRows?.transactionCosts?.total,
				perSquareMeter: valueBridgeRows?.transactionCosts?.m2Entry
			}),
			capexEnergyEfficiency: readValueBridgeBar(investmentCase, keys.valueBridge.capexEnergyEfficiency, {
				total: valueBridgeRows?.capexEnergyEfficency?.total,
				perSquareMeter: firstFiniteNumber(valueBridgeRows?.capexEnergyEfficency?.m2Entry, valueBridgeRows?.capexEnergyEfficency?.m2Exit)
			}),
			capexGeneral: readValueBridgeBar(investmentCase, keys.valueBridge.capexGeneral, {
				total: valueBridgeRows?.capexGeneral?.total,
				perSquareMeter: firstFiniteNumber(valueBridgeRows?.capexGeneral?.m2Entry, valueBridgeRows?.capexGeneral?.m2Exit)
			}),
			capexExpansion: readValueBridgeBar(investmentCase, keys.valueBridge.capexExpansion, {
				total: valueBridgeRows?.capexExpansion?.total,
				perSquareMeter: firstFiniteNumber(valueBridgeRows?.capexExpansion?.m2Entry, valueBridgeRows?.capexExpansion?.m2Exit)
			}),
			tenantImprovements: readValueBridgeBar(investmentCase, keys.valueBridge.tenantImprovements, {
				total: valueBridgeRows?.tenantImprovements?.total,
				perSquareMeter: valueBridgeRows?.tenantImprovements?.m2Entry
			}),
			leasingCommissionTenantCompensations: readValueBridgeBar(investmentCase, keys.valueBridge.leasingCommissionTenantCompensations, {
				total: valueBridgeRows?.leasingCommissionTenantCompensations?.total,
				perSquareMeter: valueBridgeRows?.leasingCommissionTenantCompensations?.m2Entry
			}),
			partnerFees: readValueBridgeBar(investmentCase, keys.valueBridge.partnerFees, {
				total: valueBridgeRows?.partnerFees?.total,
				perSquareMeter: valueBridgeRows?.partnerFees?.m2Entry
			}),
			vatLoss: readValueBridgeBar(investmentCase, keys.valueBridge.vatLoss, {
				total: valueBridgeRows?.VATLoss?.total,
				perSquareMeter: valueBridgeRows?.VATLoss?.m2Entry
			}),
			netDisposalProceeds: readValueBridgeBar(investmentCase, keys.valueBridge.netDisposalProceeds, {
				total: firstFiniteNumber(valueBridgeRows?.netDisposalProceeds?.total, kpis.goingInOut?.rows.GPPVsNetDisposalProceeds?.exit),
				perSquareMeter: valueBridgeRows?.netDisposalProceeds?.m2Exit
			}),
			totalGrant: readValueBridgeBar(investmentCase, keys.valueBridge.totalGrant),
			noiCollected: readValueBridgeBar(investmentCase, keys.valueBridge.noiCollected, {
				total: valueBridgeRows?.NOICollected?.total,
				perSquareMeter: valueBridgeRows?.NOICollected?.m2Exit
			}),
			grossProfit: readValueBridgeBar(investmentCase, keys.valueBridge.grossProfit, {
				total: valueBridgeRows?.grossProfit?.total,
				perSquareMeter: valueBridgeRows?.grossProfit?.m2Exit
			})
		}
	};
}
function readNumber$2(investmentCase, key, arrayIndex = 0) {
	if (!key) return null;
	return firstFiniteNumber(readInvestmentCaseCalcEngineNumber(investmentCase, key, arrayIndex));
}
function readReturnLevel(investmentCase, keys, fallback) {
	return {
		profit: firstFiniteNumber(readNumber$2(investmentCase, keys.profit), fallback?.profit),
		irr: firstFiniteNumber(readNumber$2(investmentCase, keys.irr), fallback?.irr),
		moC: firstFiniteNumber(readNumber$2(investmentCase, keys.moc), fallback?.moC)
	};
}
function readCashYieldPair(investmentCase, key) {
	return {
		unlevered: readNumber$2(investmentCase, key, UNLEVERED_YIELD_INDEX),
		levered: readNumber$2(investmentCase, key, LEVERED_YIELD_INDEX)
	};
}
function readEntryExit(investmentCase, key, fallback) {
	return {
		entry: firstFiniteNumber(readNumber$2(investmentCase, key, ENTRY_INDEX), fallback?.entry),
		exit: firstFiniteNumber(readNumber$2(investmentCase, key, EXIT_INDEX), fallback?.exit)
	};
}
function readValueBridgeBar(investmentCase, keys, fallback) {
	return {
		total: firstFiniteNumber(readNumber$2(investmentCase, keys.total, keys.totalIndex ?? 0), fallback?.total),
		perSquareMeter: firstFiniteNumber(readNumber$2(investmentCase, keys.perSquareMeter), fallback?.perSquareMeter)
	};
}
var ENTRY_INDEX, EXIT_INDEX, UNLEVERED_YIELD_INDEX, LEVERED_YIELD_INDEX;
var init_ic_teaser_returns_data = __esmMin((() => {
	init_mfh_investment_case_kpi_calc_engine_keys();
	init_ic_teaser_source();
	ENTRY_INDEX = 0;
	EXIT_INDEX = 1;
	UNLEVERED_YIELD_INDEX = 0;
	LEVERED_YIELD_INDEX = 1;
	__name(readNumber$2, "readNumber");
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/data/ic-teaser-sources-uses-financing.data.ts
function buildSourcesUsesFinancingSlideData(ctx) {
	const { investmentCase, investmentCaseKPIs: kpis } = ctx;
	if (!investmentCase.sheetsICCharts && !investmentCase.sheetsCfEngine) return emptyICTeaserFinancingSourceData();
	const keys = resolveInvestmentCaseKpiCalcEngineKeys(investmentCase.d2gVersion).financing;
	const empty = emptyICTeaserFinancingSourceData();
	const assumptions = investmentCase.caseInputs?.assumptions;
	const investorAssumptions = investmentCase.caseInputs?.investorAssumptions;
	return {
		...empty,
		sourcesUses: buildSourcesUses(investmentCase, keys),
		seniorDebt: {
			amount: readNumber$1(investmentCase, keys.seniorDebt.amount),
			loanToCost: firstFiniteNumber(readNumber$1(investmentCase, keys.seniorDebt.loanToCost), investorAssumptions?.seniorDebtLTV),
			interestRate: firstFiniteNumber(readNumber$1(investmentCase, keys.seniorDebt.interestRate), investorAssumptions?.seniorDebtInterestRate),
			amortizationStartQuarter: readAmortizationStartQuarter(investmentCase, keys.seniorDebt.amortizationStartQuarter),
			runningAmortization: firstFiniteNumber(readNumber$1(investmentCase, keys.seniorDebt.runningAmortization), investorAssumptions?.seniorCapexNonSubsidizedDebtRunninAM),
			upfrontFee: firstFiniteNumber(readNumber$1(investmentCase, keys.seniorDebt.upfrontFee), investorAssumptions?.seniorCapexNonSubsidizedDebtUpfrontFee)
		},
		capexAndTenantImprovementDebt: {
			amount: readNumber$1(investmentCase, keys.capexAndTenantImprovementDebt.amount),
			loanToCost: firstFiniteNumber(readNumber$1(investmentCase, keys.capexAndTenantImprovementDebt.loanToCost), investorAssumptions?.capexNonSubsidizedDebtLTV),
			interestRate: firstFiniteNumber(readNumber$1(investmentCase, keys.capexAndTenantImprovementDebt.interestRate), investorAssumptions?.capexNonSubsidizedDebtInterestRate),
			amortizationStartQuarter: readAmortizationStartQuarter(investmentCase, keys.capexAndTenantImprovementDebt.amortizationStartQuarter),
			runningAmortization: firstFiniteNumber(readNumber$1(investmentCase, keys.capexAndTenantImprovementDebt.runningAmortization), assumptions?.capexNonSubsidizedDebtRunningAm),
			commitmentFee: firstFiniteNumber(readNumber$1(investmentCase, keys.capexAndTenantImprovementDebt.commitmentFee), investorAssumptions?.seniorCapexNonSubsidizedDebtCommitmentFee),
			upfrontFee: firstFiniteNumber(readNumber$1(investmentCase, keys.capexAndTenantImprovementDebt.upfrontFee), assumptions?.capexNonSubsidizedDebtUpfrontFee)
		},
		subsidizedDebt: {
			amount: readNumber$1(investmentCase, keys.subsidizedDebt.amount),
			loanToCost: firstFiniteNumber(readNumber$1(investmentCase, keys.subsidizedDebt.loanToCost), assumptions?.ltvSubsidizedLoanKfWPercent),
			interestRate: firstFiniteNumber(readNumber$1(investmentCase, keys.subsidizedDebt.interestRate), kpis.subsidizedInterestRate, assumptions?.subsidisedInterestRateBulletLoan),
			amortizationStartQuarter: readAmortizationStartQuarter(investmentCase, keys.subsidizedDebt.amortizationStartQuarter),
			runningAmortization: firstFiniteNumber(readNumber$1(investmentCase, keys.subsidizedDebt.runningAmortization), investorAssumptions?.subsidisedNonSubsidizedDebtRunningAM),
			commitmentFee: firstFiniteNumber(readNumber$1(investmentCase, keys.subsidizedDebt.commitmentFee), assumptions?.subsidisedCommitmentFee),
			upfrontFee: firstFiniteNumber(readNumber$1(investmentCase, keys.subsidizedDebt.upfrontFee), assumptions?.capexSubsidizedDebtUpfrontFee),
			grantAmount: readNumber$1(investmentCase, keys.subsidizedDebt.grantAmount),
			grantShareOfLoan: readNumber$1(investmentCase, keys.subsidizedDebt.grantShareOfLoan)
		},
		volumeWeightedCombinedInterestRate: readNumber$1(investmentCase, keys.volumeWeightedCombinedInterestRate),
		combinedFinancing: readCombinedFinancing(investmentCase, keys.combinedFinancing, kpis.grossPurchasePrice),
		combinedFinancingIncludingSubsidyGrant: readCombinedFinancing(investmentCase, keys.combinedFinancingIncludingSubsidyGrant, kpis.grossPurchasePrice)
	};
}
function buildSourcesUses(investmentCase, keys) {
	const outputRows = investmentCase.investmentCaseOutput?.sourcesUses?.rows;
	const usesTotal = readEuroPercent(investmentCase, keys.sourcesUses.usesTotal);
	const sourcesTotal = readEuroPercent(investmentCase, keys.sourcesUses.sourcesTotal);
	const stackTotal = firstFiniteNumber(usesTotal.euro, sourcesTotal.euro);
	const usesNetPurchasePrice = readUsesEuroPercent(investmentCase, keys.sourcesUses.usesNetPurchasePrice, stackTotal, outputRows?.usesNetPurchasePrice);
	const usesClosingCostsExclFinancing = readUsesEuroPercent(investmentCase, keys.sourcesUses.usesClosingCostsExclFinancing, stackTotal, outputRows?.usesClosingCostsExclFinancing);
	const usesTIsLCsTenantCompensations = readUsesEuroPercent(investmentCase, keys.sourcesUses.usesTIsLCsTenantCompensations, stackTotal, outputRows?.usesTIsLCsTenantCompensations);
	const usesCAPEXEe = readUsesEuroPercent(investmentCase, keys.sourcesUses.usesCapexEnergyEfficiency, stackTotal, outputRows?.usesCAPEXEe);
	const usesCAPEXExpansion = readUsesEuroPercent(investmentCase, keys.sourcesUses.usesCapexExpansion, stackTotal, outputRows?.usesCAPEXExpansion);
	const usesCAPEXGeneral = readUsesEuroPercent(investmentCase, keys.sourcesUses.usesCapexGeneral, stackTotal, outputRows?.usesCAPEXGeneral);
	const usesPartnerFees = readUsesEuroPercent(investmentCase, keys.sourcesUses.usesPartnerFees, stackTotal, outputRows?.usesPartnerFees);
	const usesFinancingCosts = readUsesEuroPercent(investmentCase, keys.sourcesUses.usesFinancingCosts, stackTotal, outputRows?.usesFinancingCosts);
	const usesVAT = readUsesEuroPercent(investmentCase, keys.sourcesUses.usesVat, stackTotal, outputRows?.usesVAT);
	const sourcesDebtSenior = readSourceStackEuroPercent(investmentCase, keys.sourcesUses.sourcesDebtSenior, stackTotal);
	const sourcesDebtCapexTiNonSubsidized = readSourceStackEuroPercent(investmentCase, keys.sourcesUses.sourcesDebtCapexTiNonSubsidized, stackTotal);
	const sourcesDebtCapexSubsidizedInclGrant = readSourceStackEuroPercent(investmentCase, keys.sourcesUses.sourcesDebtCapexSubsidizedInclGrant, stackTotal);
	const sourcesEquity = readSourceStackEuroPercent(investmentCase, keys.sourcesUses.sourcesEquity, stackTotal);
	const sourcesCashCollectedNoi = readUsesEuroPercent(investmentCase, keys.sourcesUses.sourcesCashCollectedNoi, stackTotal, outputRows?.sourcesCashCollectedNoi);
	if (![
		usesNetPurchasePrice,
		usesClosingCostsExclFinancing,
		usesTIsLCsTenantCompensations,
		usesCAPEXEe,
		usesCAPEXExpansion,
		usesCAPEXGeneral,
		usesPartnerFees,
		usesFinancingCosts,
		usesVAT,
		usesTotal,
		sourcesDebtSenior,
		sourcesDebtCapexTiNonSubsidized,
		sourcesDebtCapexSubsidizedInclGrant,
		sourcesEquity,
		sourcesCashCollectedNoi,
		sourcesTotal
	].some((row) => row.euro != null || row.percent != null)) return null;
	return {
		header: ["euro", "percent"],
		rows: {
			sourcesDebtSenior,
			sourcesDebtCapexTiNonSubsidized,
			sourcesDebtCapexSubsidizedInclGrant,
			sourcesEquity,
			sourcesCashCollectedNoi,
			sourcesTotal,
			usesNetPurchasePrice,
			usesClosingCostsExclFinancing,
			usesTIsLCsTenantCompensations,
			usesCAPEXEe,
			usesCAPEXExpansion,
			usesCAPEXGeneral,
			usesPartnerFees,
			usesFinancingCosts,
			usesVAT,
			usesTotal,
			usesCAPEXEeCapexExpansion: summedEuroPercent(usesCAPEXEe, usesCAPEXExpansion)
		}
	};
}
function readCombinedFinancing(investmentCase, keys, grossPurchasePriceFallback) {
	return {
		totalLoanAmount: readNumber$1(investmentCase, keys.totalLoanAmount),
		totalCostBase: readNumber$1(investmentCase, keys.totalCostBase),
		grossPurchasePrice: firstFiniteNumber(readNumber$1(investmentCase, keys.grossPurchasePrice, GPP_ENTRY_INDEX), grossPurchasePriceFallback),
		capexExcludingVat: readNumber$1(investmentCase, keys.capexExcludingVat),
		tenantImprovementsAndLeasingCostsExcludingVat: readNumber$1(investmentCase, keys.tenantImprovementsAndLeasingCostsExcludingVat),
		vatLoss: readNumber$1(investmentCase, keys.vatLoss),
		partnerCapexFeeIncludingVat: readNumber$1(investmentCase, keys.partnerCapexFeeIncludingVat),
		loanToCost: readNumber$1(investmentCase, keys.loanToCost),
		loanShareOfGrossDisposalPrice: readNumber$1(investmentCase, keys.loanShareOfGrossDisposalPrice)
	};
}
function readEuroPercent(investmentCase, keys) {
	return {
		euro: readNumber$1(investmentCase, keys.euro) ?? void 0,
		percent: readNumber$1(investmentCase, keys.percent) ?? void 0
	};
}
/** Uses / cash-collected NOI: dedicated IC-charts euro, else share of total, else D2G uses output. */
function readUsesEuroPercent(investmentCase, keys, stackTotal, outputRow) {
	const percent = firstFiniteNumber(readNumber$1(investmentCase, keys.percent), outputRow?.percent);
	return {
		euro: firstFiniteNumber(firstFiniteNumber(readNumber$1(investmentCase, keys.euro), outputRow?.euro), shareOfTotal(stackTotal, percent)) ?? void 0,
		percent: percent ?? void 0
	};
}
/**
* Source stack rows have IC-charts percents only. CF-engine euro keys are tranche drawdowns, not the
* sources/uses stack — derive euro as total × percent so the bridge matches the IC-charts split.
*/
function readSourceStackEuroPercent(investmentCase, keys, stackTotal) {
	const percent = readNumber$1(investmentCase, keys.percent);
	return {
		euro: firstFiniteNumber(shareOfTotal(stackTotal, percent), readNumber$1(investmentCase, keys.euro)) ?? void 0,
		percent: percent ?? void 0
	};
}
function shareOfTotal(total, percent) {
	if (total == null || percent == null) return null;
	return total * percent;
}
function summedEuroPercent(left, right) {
	const euro = sumNullable(left.euro, right.euro);
	const percent = sumNullable(left.percent, right.percent);
	return {
		euro: euro ?? void 0,
		percent: percent ?? void 0
	};
}
function sumNullable(left, right) {
	if (left == null && right == null) return null;
	return (left ?? 0) + (right ?? 0);
}
function readAmortizationStartQuarter(investmentCase, key) {
	const numeric = readInvestmentCaseCalcEngineNumber(investmentCase, key);
	if (numeric != null && Number.isFinite(numeric)) return String(numeric);
	const asString = readInvestmentCaseCalcEngineString(investmentCase, key);
	if (asString == null) return null;
	const trimmed = asString.trim();
	return trimmed === "" ? null : trimmed;
}
function readNumber$1(investmentCase, key, arrayIndex = 0) {
	return firstFiniteNumber(readInvestmentCaseCalcEngineNumber(investmentCase, key, arrayIndex));
}
var GPP_ENTRY_INDEX;
var init_ic_teaser_sources_uses_financing_data = __esmMin((() => {
	init_mfh_investment_case_kpi_calc_engine_keys$1();
	init_ic_teaser_source();
	GPP_ENTRY_INDEX = 0;
	__name(readNumber$1, "readNumber");
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/data/ic-teaser-subsidies.data.ts
function buildSubsidiesSlideData(ctx) {
	const { investmentCase, investmentCaseKPIs: kpis, mfh } = ctx;
	const keys = resolveInvestmentCaseKpiCalcEngineKeys(investmentCase.d2gVersion).subsidies;
	const empty = emptyICTeaserSubsidiesSourceData();
	const city = mfh.candidateLocation?.city ?? null;
	const kfw261 = readKfw(investmentCase, keys.kfw261, keys.rateAndGrantVector, kpis.subsidizedInterestRate);
	const bafa = readBafa(investmentCase, keys.bafa);
	const ifb = readIfb(investmentCase, keys.ifb, city);
	const dus = readDus(investmentCase, keys.dus, keys.rateAndGrantVector, city);
	const fkg = readFkg(investmentCase, keys.fkg, city);
	return {
		...empty,
		kfw261,
		bafa,
		ifb,
		dus,
		fkg
	};
}
function readKfw(investmentCase, keys, rateAndGrantVector, subsidizedInterestRate) {
	const subsidyRate = readNumber(investmentCase, keys.subsidyRate);
	const bonusEe = readNumber(investmentCase, keys.bonusEe);
	const bonusWpb = readNumber(investmentCase, keys.bonusWpb);
	const combined = readRateAndGrant(investmentCase, keys.totalSubsidyRateAndGrant, rateAndGrantVector);
	return {
		showOnSlide: true,
		eligibleCosts: readNumber(investmentCase, keys.eligibleCosts),
		subsidyRate,
		bonusEe,
		bonusWpb,
		/** D2G exports no serielle-Sanierung rate; left empty for manual entry. */
		bonusSerialRenovation: null,
		totalSubsidyRate: combined.subsidyRate,
		totalGrant: combined.grantAmount,
		subsidizedLoanAfterRepaymentGrant: readNumber(investmentCase, keys.subsidizedLoanAfterRepaymentGrant),
		interestRate: firstFiniteNumber(readNumber(investmentCase, keys.interestRate), subsidizedInterestRate),
		repayment: readInvestmentCaseCalcEngineString(investmentCase, keys.repayment) ?? null,
		durationInYears: readNumber(investmentCase, keys.durationInYears),
		fixedInterestPeriodInYears: readNumber(investmentCase, keys.fixedInterestPeriodInYears)
	};
}
function readBafa(investmentCase, keys) {
	return {
		showOnSlide: true,
		capexBasisExcludingHeating: readNumber(investmentCase, keys.capexBasisExcludingHeating),
		capexBasisHeating: readNumber(investmentCase, keys.capexBasisHeating),
		totalFundingRate: readNumber(investmentCase, keys.totalFundingRate),
		totalGrant: readNumber(investmentCase, keys.totalGrant)
	};
}
function readIfb(investmentCase, keys, city) {
	return {
		showOnSlide: isCityMatch(city, HAMBURG_CITY_ALIASES),
		eligibleCosts: readNumber(investmentCase, keys.eligibleCosts),
		baseGrant: readNumber(investmentCase, keys.baseGrant),
		brickFacadeOrMonumentProtectionGrant: readNumber(investmentCase, keys.brickFacadeOrMonumentProtectionGrant),
		totalGrant: readNumber(investmentCase, keys.totalGrant)
	};
}
function readDus(investmentCase, keys, rateAndGrantVector, city) {
	const combined = readRateAndGrant(investmentCase, keys.totalSubsidyRateAndGrant, rateAndGrantVector);
	return {
		showOnSlide: isCityMatch(city, DUSSELDORF_CITY_ALIASES),
		totalFundingRate: combined.subsidyRate,
		totalGrant: combined.grantAmount
	};
}
function readFkg(investmentCase, keys, city) {
	return {
		showOnSlide: isCityMatch(city, MUNICH_CITY_ALIASES),
		capexBasisExcludingHeating: readNumber(investmentCase, keys.capexBasisExcludingHeating),
		capexBasisHeating: readNumber(investmentCase, keys.capexBasisHeating),
		totalFundingRate: readNumber(investmentCase, keys.totalFundingRate),
		totalGrant: readNumber(investmentCase, keys.totalGrant)
	};
}
function isCityMatch(city, aliases) {
	if (city == null) return false;
	const folded = deburr(city).toLowerCase().trim();
	return aliases.some((alias) => alias === folded);
}
function isICTeaserSubsidyProgrammeVisible(programme) {
	return programme != null && programme.showOnSlide !== false && (programme.totalGrant ?? 0) > 0;
}
function readNumber(investmentCase, key) {
	return firstFiniteNumber(readInvestmentCaseCalcEngineNumber(investmentCase, key));
}
function readRateAndGrant(investmentCase, key, layout) {
	const combined = readInvestmentCaseSubsidyRateAndGrant(investmentCase, key, layout);
	return {
		grantAmount: firstFiniteNumber(combined.grantAmount),
		subsidyRate: firstFiniteNumber(combined.subsidyRate)
	};
}
var HAMBURG_CITY_ALIASES, DUSSELDORF_CITY_ALIASES, MUNICH_CITY_ALIASES;
var init_ic_teaser_subsidies_data = __esmMin((() => {
	init_mfh_investment_case_kpi_calc_engine_keys();
	init_ic_teaser_source();
	HAMBURG_CITY_ALIASES = ["hamburg"];
	DUSSELDORF_CITY_ALIASES = ["dusseldorf", "duesseldorf"];
	MUNICH_CITY_ALIASES = [
		"munchen",
		"muenchen",
		"munich"
	];
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/data/ic-teaser-transformation.data.ts
function buildTransformationSlideData(ctx) {
	const { investmentCaseKPIs: kpis, mfh, media } = ctx;
	const attributes = mfh.attributes;
	const preRenovationFile = media.find(isMainPhotoPreRenovation);
	const postRenovationFile = media.find(isMainPhotoPostRenovation);
	const energyRating = firstNonEmptyString(kpis.energyEfficiencyRatingEntry, attributes?.energyCertificateClass);
	const finalEnergyDemand = firstFiniteNumber(kpis.finalEnergyDemandEntry, attributes?.endEnergyDemand, attributes?.energyConsumption);
	return {
		preRenovationPhoto: (preRenovationFile ? mapMedia(preRenovationFile) : void 0) ?? null,
		postRenovationPhoto: (postRenovationFile ? mapMedia(postRenovationFile) : void 0) ?? null,
		tenantImprovementCapexPerSquareMeter: kpis.tenantImprovementCapexPerSquareMeter,
		generalCapexPerSquareMeter: kpis.generalCapexPerSquareMeter,
		energeticCapexPerSquareMeter: kpis.energeticCapexPerSquareMeter,
		expansionCapexPerSquareMeter: kpis.expansionCapexPerSquareMeter,
		expansionPotentialSqm: firstFiniteNumber(kpis.expansionPotentialSqm, attributes?.expansionPotential),
		energyEfficiencyRatingEntryFrom: energyRating,
		energyEfficiencyRatingEntryTo: energyRating,
		energyEfficiencyRatingExit: kpis.energyEfficiencyRatingExit,
		finalEnergyDemandEntryFrom: finalEnergyDemand,
		finalEnergyDemandEntryTo: finalEnergyDemand,
		finalEnergyDemandExit: kpis.finalEnergyDemandExit,
		lettableAreaEntry: {
			residentialExisting: firstFiniteNumber(kpis.lettableAreaEntry.residentialExisting, attributes?.livingSpace, attributes?.estimatedLivingSpace),
			residentialExpansion: kpis.lettableAreaEntry.residentialExpansion,
			commercial: firstFiniteNumber(kpis.lettableAreaEntry.commercial, attributes?.commercialSpace, attributes?.estimatedCommercialSpace)
		},
		lettableAreaExit: kpis.lettableAreaExit,
		modernizationLevyPerSquareMeterPerMonth: kpis.eeTopUpModernizationLevy
	};
}
var init_ic_teaser_transformation_data = __esmMin((() => {
	init_ic_teaser_data_helpers();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/data/ic-teaser-unlevered-dcf.data.ts
function buildUnleveredDcfRowSpecs(keys) {
	const { unlevered } = keys;
	return [
		dcfCashflowRowSpec("total", "Net Rental Income", unlevered.nri),
		dcfCashflowRowSpec("data", "(-) Total Opex (NRI Leakage)", unlevered.totalOpexNriLeakage),
		dcfCashflowRowSpec("total", "Net Operating Income", unlevered.noi),
		dcfCashflowRowSpec("data", "(-) Capex (EE, Extension, General)", unlevered.capexEeExtensionGeneral, {
			commentRateFormat: "currency",
			commentUnit: "on Acquired Area"
		}),
		dcfCashflowRowSpec("data", "(-) TIs", unlevered.tis, {
			commentRateFormat: "currency",
			commentUnit: "per sqm Re-Let Area"
		}),
		dcfCashflowRowSpec("data", "(-) VAT Loss on Capex & TI", unlevered.vatLossOnCapexTi),
		dcfCashflowRowSpec("data", "(-) Compensation for wanted tenant move-out - Resi & Commercial", unlevered.compensationWantedTenantChurn),
		dcfCashflowRowSpec("data", "(+) State Cash Subsidies/Grants", unlevered.stateCashSubsidies),
		dcfCashflowRowSpec("data", "(-) Acquisition Fee", unlevered.acquisitionFee, {
			commentRateFormat: "percentage",
			commentUnit: "of NPP"
		}),
		dcfCashflowRowSpec("data", "(-) Capex & TI Management Fee", unlevered.capexTiManagementFee, {
			commentRateFormat: "percentage",
			commentUnit: "of CAPEX & TIs invested"
		}),
		dcfCashflowRowSpec("data", "(-) Property Management Fee", unlevered.propertyManagementFee, {
			commentRateFormat: "currency",
			commentUnit: "of € per unit p.m."
		}),
		dcfCashflowRowSpec("data", "(-) Letting Fees - Resi/Commercial", unlevered.lettingFees, {
			commentRateFormat: "text",
			commentUnit: "[# monthly NRI]"
		}),
		dcfCashflowRowSpec("data", "(-) Asset Management Fee", unlevered.assetManagementFee, {
			commentRateFormat: "percentage",
			commentUnit: "of GAV p.a."
		}),
		dcfCashflowRowSpec("data", "(-) Disposition Fee", unlevered.dispositionFee, {
			commentRateFormat: "percentage",
			commentUnit: "of Gross Disposal Price (GDP)"
		}),
		dcfCashflowRowSpec("data", "(-) VAT Loss on Partner Fees", unlevered.vatLossOnPartnerFees),
		dcfCashflowRowSpec("subtotal", "NPP", unlevered.npp, {
			commentRateFormat: "multiple",
			commentUnit: "NRI"
		}),
		dcfCashflowRowSpec("data", "(-) Transaction Costs", unlevered.transactionCosts, {
			commentRateFormat: "percentage",
			commentUnit: "on NPP (incl. VAT)"
		}),
		dcfCashflowRowSpec("subtotal", "GDP", unlevered.gdp, {
			commentRateFormat: "multiple",
			commentUnit: "NRI incl. ERV"
		}),
		dcfCashflowRowSpec("data", "(-) Disposal Costs", unlevered.disposalCosts, {
			commentRateFormat: "percentage",
			commentUnit: "on Gross Disposal Price (GDP)"
		}),
		dcfCashflowRowSpec("total", "Unlevered Deal CF (pre Tax)", unlevered.unleveredDealCfPreTax)
	];
}
function unleveredDcfCommentRateKeys(d2gVersion) {
	return dcfCommentRateKeys(buildUnleveredDcfRowSpecs(resolveInvestmentCaseKpiCalcEngineKeys(d2gVersion).dcf));
}
function buildUnleveredDcfSlideData(ctx) {
	const gate = resolveDcfGate(ctx.investmentCase);
	if (!gate.canBuild || !gate.d2gVersion) return emptyDcfTable();
	try {
		const keys = resolveInvestmentCaseKpiCalcEngineKeys(gate.d2gVersion).dcf;
		return buildDcfTable({
			specs: buildUnleveredDcfRowSpecs(keys),
			calcengineValues: collectDcfCalcengineValues(ctx.investmentCase, unleveredDcfCommentRateKeys(gate.d2gVersion)),
			maxYearColumns: void 0,
			d2gVersion: gate.d2gVersion,
			yearCountsKey: keys.yearCounts,
			tableLabel: "Unlevered DCF"
		});
	} catch {
		return emptyDcfTable();
	}
}
var init_ic_teaser_unlevered_dcf_data = __esmMin((() => {
	init_mfh_investment_case_kpi_calc_engine_keys();
	init_ic_teaser_dcf_helpers();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/data/ic-teaser.source-data.ts
function buildICTeaserSourceData(input) {
	const ctx = {
		...input,
		investmentCaseKPIs: extractICTeaserInvestmentCaseKpis(input.investmentCase)
	};
	return {
		generatedAt: /* @__PURE__ */ new Date(),
		investmentCaseId: input.investmentCaseId,
		investmentCaseName: ctx.investmentCaseKPIs.name,
		investmentCaseVersionId: input.investmentCaseVersionId,
		investmentCaseVersionNumber: input.investmentCaseVersionNumber,
		assetId: input.assetId,
		cover: buildCoverSlideData(ctx),
		executiveSummary: buildExecutiveSummarySlideData(ctx),
		assetOverview: buildAssetOverviewSlideData(ctx),
		assetImpressions: buildAssetImpressionsSlideData(ctx),
		location: buildMacroMicroLocationSlideData(ctx),
		rentAnalysis: buildLocationRentComparablesSlideData(ctx),
		transformation: buildTransformationSlideData(ctx),
		rentDevelopment: buildRentalDevelopmentSlideData(ctx),
		projectDelivery: buildProjectDeliverySlideData(ctx),
		financing: buildSourcesUsesFinancingSlideData(ctx),
		subsidies: buildSubsidiesSlideData(ctx),
		cashFlow: buildCashFlowSlideData(ctx),
		dcf: buildDcfSourceData(ctx),
		returns: buildReturnsSlideData(ctx)
	};
}
function buildDcfSourceData(ctx) {
	const gate = resolveDcfGate(ctx.investmentCase);
	return {
		...emptyICTeaserDcfSourceData(),
		unlevered: buildUnleveredDcfSlideData(ctx),
		levered: buildLeveredDcfSlideData(ctx),
		d2gVersion: gate.d2gVersion,
		calculatedAt: gate.calculatedAt
	};
}
var init_ic_teaser_source_data = __esmMin((() => {
	init_ic_teaser_kpis();
	init_ic_teaser_source();
	init_ic_teaser_asset_impressions_data();
	init_ic_teaser_asset_overview_data();
	init_ic_teaser_cash_flow_data();
	init_ic_teaser_dcf_helpers();
	init_ic_teaser_executive_summary_data();
	init_ic_teaser_header_data();
	init_ic_teaser_levered_dcf_data();
	init_ic_teaser_location_rent_comparables_data();
	init_ic_teaser_macro_micro_location_data();
	init_ic_teaser_project_delivery_data();
	init_ic_teaser_rental_development_data();
	init_ic_teaser_returns_data();
	init_ic_teaser_sources_uses_financing_data();
	init_ic_teaser_subsidies_data();
	init_ic_teaser_transformation_data();
	init_ic_teaser_unlevered_dcf_data();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/data/index.ts
var init_data = __esmMin((() => {
	init_ic_teaser_data_helpers();
	init_ic_teaser_dcf_helpers();
	init_ic_teaser_source_data();
	init_ic_teaser_asset_impressions_data();
	init_ic_teaser_asset_overview_data();
	init_ic_teaser_cash_flow_data();
	init_ic_teaser_executive_summary_data();
	init_ic_teaser_header_data();
	init_ic_teaser_levered_dcf_data();
	init_ic_teaser_location_rent_comparables_data();
	init_ic_teaser_macro_micro_location_data();
	init_ic_teaser_project_delivery_data();
	init_ic_teaser_rental_development_data();
	init_ic_teaser_returns_data();
	init_ic_teaser_sources_uses_financing_data();
	init_ic_teaser_subsidies_data();
	init_ic_teaser_transformation_data();
	init_ic_teaser_unlevered_dcf_data();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/ic-teaser.document.ts
function createICTeaserDocument(sourceData, generationResult, now = /* @__PURE__ */ new Date()) {
	return {
		sourceData,
		generated: generationResult.fields,
		slides: DEFAULT_TEASER_SLIDES.map((slide) => ({ ...slide })),
		generation: {
			createdAt: now,
			updatedAt: now,
			lastGeneratedAt: now,
			model: generationResult.model
		}
	};
}
/** Deep-merge source patches; arrays, DCF tables, and whole-slide blobs are replaced when provided. */
function mergeICTeaserSourceData(base, patch) {
	return mergeWith(cloneDeep(base), patch, (_objectValue, sourceValue, key) => {
		if (Array.isArray(sourceValue) || isICTeaserTable(sourceValue) || key === "sourcesUses" || key === "returns" || key === "analysis") return sourceValue;
	});
}
function updateICTeaserDocument(teaser, patch, now = /* @__PURE__ */ new Date()) {
	return {
		...teaser,
		sourceData: patch.sourceData ? mergeICTeaserSourceData(teaser.sourceData, patch.sourceData) : teaser.sourceData,
		generated: {
			...teaser.generated,
			...patch.fields
		},
		slides: patch.slides?.map((slide) => ({ ...slide })) ?? teaser.slides,
		generation: {
			...teaser.generation,
			updatedAt: now
		}
	};
}
function regenerateICTeaserDocument(teaser, sourceData, generationResult, now = /* @__PURE__ */ new Date(), options) {
	const generated = options?.replaceAll ?? true ? { ...generationResult.fields } : {
		...teaser.generated,
		...generationResult.fields
	};
	return {
		...teaser,
		sourceData,
		generated,
		generation: {
			...teaser.generation,
			updatedAt: now,
			lastGeneratedAt: now,
			model: generationResult.model
		}
	};
}
var init_ic_teaser_document = __esmMin((() => {
	init_ic_teaser_model();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/ic-teaser.card-titles.ts
function teaserNarrativePlainText(value) {
	if (value == null) return "";
	return value.replace(/<[^>]*>/g, " ").replace(/&nbsp;/gi, " ").replace(/\s+/g, " ").trim();
}
function isICTeaserExecutiveSummaryCardTitleKey(key) {
	return IC_TEASER_EXECUTIVE_SUMMARY_CARD_TITLE_KEYS.includes(key);
}
/** Slide + form: stored empty/blank HTML still shows the default card title. */
function resolveICTeaserExecutiveSummaryCardTitle(key, value) {
	return teaserNarrativePlainText(value) || IC_TEASER_EXECUTIVE_SUMMARY_CARD_TITLE_DEFAULTS[key];
}
var IC_TEASER_EXECUTIVE_SUMMARY_CARD_TITLE_KEYS, IC_TEASER_EXECUTIVE_SUMMARY_CARD_TITLE_DEFAULTS;
var init_ic_teaser_card_titles = __esmMin((() => {
	IC_TEASER_EXECUTIVE_SUMMARY_CARD_TITLE_KEYS = [
		"microLocationSummaryHeader",
		"rentPotentialSummaryHeader",
		"energeticModernizationSummaryHeader"
	];
	IC_TEASER_EXECUTIVE_SUMMARY_CARD_TITLE_DEFAULTS = {
		microLocationSummaryHeader: "Excellent Micro-Location",
		rentPotentialSummaryHeader: "Substantial Rent Development Potential",
		energeticModernizationSummaryHeader: "Energetic Transformation"
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/ic-teaser.fields.ts
function isICTeaserSlideLiveSourceSyncEnabled(slideKey) {
	return IC_TEASER_SLIDE_LIVE_SOURCE_SYNC_ENABLED[slideKey];
}
function getICTeaserSlideSubtitleAiKey(slideKey) {
	if (slideKey === "executiveSummary" || slideKey === "assetImpressions" || slideKey === "returns") return IC_TEASER_SLIDE_SUBTITLE_AI_KEY[slideKey];
}
function isICTeaserSlideTitleAiKey(key) {
	return SLIDE_TITLE_AI_KEY_SET.has(key);
}
function isICTeaserSlideSubtitleAiKey(key) {
	return SLIDE_SUBTITLE_AI_KEY_SET.has(key);
}
function isICTeaserSlideSubtitleEditable(slideKey) {
	return IC_TEASER_SLIDE_SUBTITLE_EDITABLE[slideKey];
}
/** Editable section roots for a slide that participate in live sync (amber rail). */
function getICTeaserSlideEditableSourceRoots(slideKey) {
	if (!isICTeaserSlideLiveSourceSyncEnabled(slideKey)) return [];
	const roots = /* @__PURE__ */ new Set();
	for (const path of IC_TEASER_SLIDE_SOURCE_FIELDS[slideKey]) {
		const root = path.split(".")[0];
		if (root && EDITABLE_SOURCE_ROOTS.has(root)) roots.add(root);
	}
	return [...roots];
}
/** Roots excluded from sync-all / drift counts (belong only to slides with sync disabled). */
function getICTeaserLiveSourceSyncExcludedRoots() {
	const roots = /* @__PURE__ */ new Set();
	for (const slideKey of Object.keys(IC_TEASER_SLIDE_SOURCE_FIELDS)) {
		if (isICTeaserSlideLiveSourceSyncEnabled(slideKey)) continue;
		for (const path of IC_TEASER_SLIDE_SOURCE_FIELDS[slideKey]) {
			const root = path.split(".")[0];
			if (root && EDITABLE_SOURCE_ROOTS.has(root)) roots.add(root);
		}
	}
	return [...roots];
}
var IC_TEASER_SLIDE_SOURCE_FIELDS, IC_TEASER_EXECUTIVE_SUMMARY_AI_KEYS, IC_TEASER_SLIDE_AI_KEYS, IC_TEASER_SLIDE_LIVE_SOURCE_SYNC_ENABLED, IC_TEASER_SLIDE_TITLE_AI_KEYS, IC_TEASER_SLIDE_SUBTITLE_AI_KEY, IC_TEASER_SLIDE_SUBTITLE_AI_KEYS, SLIDE_TITLE_AI_KEY_SET, SLIDE_SUBTITLE_AI_KEY_SET, IC_TEASER_SLIDE_SUBTITLE_EDITABLE, EDITABLE_SOURCE_ROOTS;
var init_ic_teaser_fields = __esmMin((() => {
	init_ic_teaser_card_titles();
	IC_TEASER_SLIDE_SOURCE_FIELDS = {
		header: [
			"cover.address.street",
			"cover.address.houseNumber",
			"cover.address.postalCode",
			"cover.address.city",
			"cover.numberOfBuildings",
			"cover.numberOfUnits",
			"cover.totalSpaceNlaEntry",
			"cover.totalInvestmentVolume",
			"cover.equityCommitment",
			"cover.cocAtExit.unlevered",
			"cover.cocAtExit.levered",
			"cover.mocPostTaxPostPromote",
			"cover.irrPostTaxLevered",
			"cover.preRenovationPhoto.url"
		],
		executiveSummary: ["executiveSummary.photo.url"],
		assetOverview: [
			"assetOverview.address.street",
			"assetOverview.address.houseNumber",
			"assetOverview.address.postalCode",
			"assetOverview.address.city",
			"assetOverview.constructionYear",
			"assetOverview.numberOfBuildings",
			"assetOverview.totalRentableSpace",
			"assetOverview.residentialSpace.amount",
			"assetOverview.residentialSpace.share",
			"assetOverview.commercialSpace.amount",
			"assetOverview.commercialSpace.share",
			"assetOverview.numberOfResidentialUnits",
			"assetOverview.averageResidentialUnitSize",
			"assetOverview.numberOfCommercialUnits",
			"assetOverview.numberOfParkingSpaces",
			"assetOverview.expansionPotentialSqm",
			"assetOverview.occupancyRate.residential",
			"assetOverview.occupancyRate.commercial",
			"assetOverview.occupancyRate.parking",
			"assetOverview.netRentalIncomePerYear",
			"assetOverview.netResidentialRentPerSquareMeterPerMonth",
			"assetOverview.netCommercialRentPerSquareMeterPerMonth",
			"assetOverview.netParkingRentPerSpotPerMonth",
			"assetOverview.acquisitionPrice",
			"assetOverview.acquisitionPricePerSquareMeter",
			"assetOverview.acquisitionMultiple",
			"assetOverview.grossPurchasePrice",
			"assetOverview.energyEfficiencyRatingPreTransformationFrom",
			"assetOverview.energyEfficiencyRatingPreTransformationTo",
			"assetOverview.finalEnergyDemandPreTransformationFrom",
			"assetOverview.finalEnergyDemandPreTransformationTo",
			"assetOverview.primaryEnergySource",
			"assetOverview.coordinates.latitude",
			"assetOverview.coordinates.longitude",
			"assetOverview.photo.url"
		],
		assetImpressions: ["assetImpressions.selectedMedia"],
		macroMicroLocation: ["location.analysis", "location.restrictions"],
		locationRentComparatives: [
			"rentAnalysis.analysis",
			"rentAnalysis.inPlaceRentPerSquareMeter",
			"rentAnalysis.targetRentPerSquareMeter",
			"rentAnalysis.appliedRentResidential",
			"rentAnalysis.manualExpandedSpace"
		],
		transformation: [
			"transformation.preRenovationPhoto.url",
			"transformation.postRenovationPhoto.url",
			"transformation.tenantImprovementCapexPerSquareMeter",
			"transformation.generalCapexPerSquareMeter",
			"transformation.energeticCapexPerSquareMeter",
			"transformation.expansionCapexPerSquareMeter",
			"transformation.energyEfficiencyRatingEntryFrom",
			"transformation.energyEfficiencyRatingEntryTo",
			"transformation.energyEfficiencyRatingExit",
			"transformation.finalEnergyDemandEntryFrom",
			"transformation.finalEnergyDemandEntryTo",
			"transformation.finalEnergyDemandExit",
			"transformation.lettableAreaEntry.residentialExisting",
			"transformation.lettableAreaExit.residentialExisting",
			"transformation.lettableAreaExit.residentialExpansion",
			"transformation.modernizationLevyPerSquareMeterPerMonth"
		],
		rentalDevelopment: [
			"rentDevelopment.existingRent",
			"rentDevelopment.refurbishedNewLettingRent",
			"rentDevelopment.averageRent",
			"rentDevelopment.rentIncreaseDates",
			"rentDevelopment.signingDate",
			"rentDevelopment.modernizationLevyDate",
			"rentDevelopment.exitDate",
			"rentDevelopment.chartEndDate",
			"rentDevelopment.holdingPeriodYears",
			"rentDevelopment.ervAtPurchase",
			"rentDevelopment.ervAtExit",
			"rentDevelopment.annualMarketRentGrowth",
			"rentDevelopment.annualNewLeaseIndexation",
			"rentDevelopment.annualResidentialChurn",
			"rentDevelopment.rentIndexIncreaseLimit",
			"rentDevelopment.modernizationLevy",
			"rentDevelopment.impliedNriUpliftPotential",
			"rentDevelopment.occupancy.residential.entry",
			"rentDevelopment.occupancy.residential.exit",
			"rentDevelopment.occupancy.commercial.entry",
			"rentDevelopment.occupancy.commercial.exit",
			"rentDevelopment.occupancy.parking.entry",
			"rentDevelopment.occupancy.parking.exit"
		],
		projectDelivery: [
			"projectDelivery.annualRenovatedArea",
			"projectDelivery.annualTenantChurn",
			"projectDelivery.exitYear",
			"projectDelivery.milestones",
			"projectDelivery.refurbishmentDevelopment"
		],
		sourcesUsesFinancing: [
			"financing.sourcesUses",
			"financing.volumeWeightedCombinedInterestRate",
			"financing.seniorDebt.amount",
			"financing.seniorDebt.loanToCost",
			"financing.seniorDebt.interestRate",
			"financing.seniorDebt.amortizationStartQuarter",
			"financing.seniorDebt.upfrontFee",
			"financing.seniorDebt.runningAmortization",
			"financing.capexAndTenantImprovementDebt.amount",
			"financing.capexAndTenantImprovementDebt.loanToCost",
			"financing.capexAndTenantImprovementDebt.interestRate",
			"financing.capexAndTenantImprovementDebt.amortizationStartQuarter",
			"financing.capexAndTenantImprovementDebt.commitmentFee",
			"financing.capexAndTenantImprovementDebt.upfrontFee",
			"financing.capexAndTenantImprovementDebt.runningAmortization",
			"financing.subsidizedDebt.amount",
			"financing.subsidizedDebt.loanToCost",
			"financing.subsidizedDebt.interestRate",
			"financing.subsidizedDebt.amortizationStartQuarter",
			"financing.subsidizedDebt.commitmentFee",
			"financing.subsidizedDebt.upfrontFee",
			"financing.subsidizedDebt.runningAmortization",
			"financing.subsidizedDebt.grantAmount",
			"financing.subsidizedDebt.grantShareOfLoan",
			"financing.combinedFinancing.totalLoanAmount",
			"financing.combinedFinancing.totalCostBase",
			"financing.combinedFinancing.grossPurchasePrice",
			"financing.combinedFinancing.capexExcludingVat",
			"financing.combinedFinancing.tenantImprovementsAndLeasingCostsExcludingVat",
			"financing.combinedFinancing.vatLoss",
			"financing.combinedFinancing.partnerCapexFeeIncludingVat",
			"financing.combinedFinancing.loanToCost",
			"financing.combinedFinancing.loanShareOfGrossDisposalPrice",
			"financing.combinedFinancingIncludingSubsidyGrant.totalLoanAmount",
			"financing.combinedFinancingIncludingSubsidyGrant.totalCostBase",
			"financing.combinedFinancingIncludingSubsidyGrant.grossPurchasePrice",
			"financing.combinedFinancingIncludingSubsidyGrant.capexExcludingVat",
			"financing.combinedFinancingIncludingSubsidyGrant.tenantImprovementsAndLeasingCostsExcludingVat",
			"financing.combinedFinancingIncludingSubsidyGrant.vatLoss",
			"financing.combinedFinancingIncludingSubsidyGrant.partnerCapexFeeIncludingVat",
			"financing.combinedFinancingIncludingSubsidyGrant.loanToCost",
			"financing.combinedFinancingIncludingSubsidyGrant.loanShareOfGrossDisposalPrice"
		],
		subsidies: [
			"subsidies.kfw261.showOnSlide",
			"subsidies.kfw261.totalGrant",
			"subsidies.kfw261.eligibleCosts",
			"subsidies.bafa.showOnSlide",
			"subsidies.bafa.totalGrant",
			"subsidies.bafa.totalFundingRate",
			"subsidies.ifb.showOnSlide",
			"subsidies.dus.showOnSlide",
			"subsidies.fkg.showOnSlide"
		],
		cashFlow: [
			"cashFlow.yearlyCashFlow",
			"cashFlow.noiBridge.entryNoi",
			"cashFlow.noiBridge.exitNoi"
		],
		unleveredDcf: ["dcf.unlevered.rows"],
		leveredDcf: ["dcf.levered.rows"],
		returns: [
			"returns.returnLadder.preTaxUnlevered.profit",
			"returns.returnLadder.postTaxPostPromote.irr",
			"returns.returnLadder.postTaxPostPromote.moC",
			"returns.cashYields.year1PostCompletion.unlevered",
			"returns.goingInOut.nla.entry",
			"returns.goingInOut.nla.exit",
			"returns.valueBridge.netPurchasePrice.total",
			"returns.valueBridge.netDisposalProceeds.total",
			"returns.valueBridge.grossProfit.total"
		],
		finisher: [],
		placeholder: []
	};
	IC_TEASER_EXECUTIVE_SUMMARY_AI_KEYS = [
		"executiveSummaryHeader",
		"executiveSummarySubheader",
		"microLocationSummary",
		"rentPotentialSummary",
		"energeticModernizationSummary"
	];
	IC_TEASER_SLIDE_AI_KEYS = {
		header: [],
		executiveSummary: IC_TEASER_EXECUTIVE_SUMMARY_AI_KEYS,
		assetOverview: ["assetOverviewHeader"],
		assetImpressions: ["assetImpressionsHeader", "assetImpressionsSubheader"],
		macroMicroLocation: ["macroMicroLocationHeader"],
		locationRentComparatives: ["locationRentComparativesHeader"],
		transformation: [
			"transformationHeader",
			"apartmentModernizationSummary",
			"generalModernizationSummary",
			"energeticModernizationPlanSummary",
			"roofExpansionSummary"
		],
		rentalDevelopment: ["rentalDevelopmentHeader", "rentalDevelopmentCommentary"],
		projectDelivery: ["projectDeliveryHeader"],
		sourcesUsesFinancing: ["sourcesUsesFinancingHeader"],
		subsidies: ["subsidiesHeader"],
		cashFlow: [
			"cashFlowHeader",
			"jCurveCommentary",
			"noiBridgeCommentary"
		],
		unleveredDcf: ["unleveredDcfHeader"],
		leveredDcf: ["leveredDcfHeader"],
		returns: ["returnsHeader", "returnsSubheader"],
		finisher: [],
		placeholder: []
	};
	IC_TEASER_SLIDE_LIVE_SOURCE_SYNC_ENABLED = {
		header: true,
		executiveSummary: true,
		assetOverview: true,
		assetImpressions: false,
		macroMicroLocation: false,
		locationRentComparatives: true,
		transformation: true,
		rentalDevelopment: true,
		projectDelivery: true,
		sourcesUsesFinancing: true,
		subsidies: true,
		cashFlow: true,
		unleveredDcf: true,
		leveredDcf: true,
		returns: true,
		finisher: true,
		placeholder: false
	};
	IC_TEASER_SLIDE_TITLE_AI_KEYS = [
		"executiveSummaryHeader",
		"assetOverviewHeader",
		"assetImpressionsHeader",
		"macroMicroLocationHeader",
		"locationRentComparativesHeader",
		"transformationHeader",
		"rentalDevelopmentHeader",
		"projectDeliveryHeader",
		"sourcesUsesFinancingHeader",
		"subsidiesHeader",
		"cashFlowHeader",
		"unleveredDcfHeader",
		"leveredDcfHeader",
		"returnsHeader"
	];
	IC_TEASER_SLIDE_SUBTITLE_AI_KEY = {
		executiveSummary: "executiveSummarySubheader",
		assetImpressions: "assetImpressionsSubheader",
		returns: "returnsSubheader"
	};
	IC_TEASER_SLIDE_SUBTITLE_AI_KEYS = [
		IC_TEASER_SLIDE_SUBTITLE_AI_KEY.executiveSummary,
		IC_TEASER_SLIDE_SUBTITLE_AI_KEY.assetImpressions,
		IC_TEASER_SLIDE_SUBTITLE_AI_KEY.returns
	];
	SLIDE_TITLE_AI_KEY_SET = new Set(IC_TEASER_SLIDE_TITLE_AI_KEYS);
	SLIDE_SUBTITLE_AI_KEY_SET = new Set(IC_TEASER_SLIDE_SUBTITLE_AI_KEYS);
	IC_TEASER_SLIDE_SUBTITLE_EDITABLE = {
		header: false,
		executiveSummary: true,
		assetOverview: true,
		assetImpressions: true,
		macroMicroLocation: true,
		locationRentComparatives: true,
		transformation: true,
		rentalDevelopment: true,
		projectDelivery: true,
		sourcesUsesFinancing: true,
		subsidies: true,
		cashFlow: true,
		unleveredDcf: true,
		leveredDcf: true,
		returns: true,
		finisher: false,
		placeholder: false
	};
	EDITABLE_SOURCE_ROOTS = /* @__PURE__ */ new Set([
		"cover",
		"executiveSummary",
		"assetImpressions",
		"assetOverview",
		"transformation",
		"rentDevelopment",
		"projectDelivery",
		"financing",
		"subsidies",
		"cashFlow",
		"dcf",
		"returns",
		"location",
		"rentAnalysis"
	]);
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/ic-teaser.subtitles.ts
function escapeXml(value) {
	return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function subtitlePlainText(html) {
	return html.replace(/<[^>]*>/g, " ").replace(/&nbsp;/gi, " ").replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/\s+/g, " ").trim();
}
function subtitleHasContent(html) {
	return subtitlePlainText(html) !== "";
}
/**
* Text plus inline formatting, ignoring paragraph wrappers, attributes, whitespace and
* entity spelling, so a TipTap round-trip of a prefill stays equal but bold/italic/superscript changes do not.
*/
function subtitleFormattedSignature(html) {
	return unescape(html.replace(/<\/?p(\s[^>]*)?>/gi, " ").replace(/<br\s*\/?>/gi, "<br>").replace(/<(\/?)([a-z0-9]+)(\s[^>]*)?>/gi, (_match, slash, tag) => {
		const name = tag.toLowerCase();
		return `<${slash}${SUBTITLE_TAG_ALIASES[name] ?? name}>`;
	}).replace(/&nbsp;/gi, " ").replace(/\s+/g, " ").trim());
}
function subtitlesEquivalent(left, right) {
	return left === right || subtitleFormattedSignature(left) === subtitleFormattedSignature(right);
}
function wrapSubtitleHtml(text) {
	const trimmed = text.trim();
	if (trimmed === "") return "";
	return `<p>${escapeXml(trimmed)}</p>`;
}
function formatCoverAddress(address) {
	if (!address.street || !address.houseNumber || !address.postalCode || !address.city) return "";
	return addressFormatter({
		street: address.street,
		houseNumber: address.houseNumber,
		zipcode: address.postalCode,
		city: address.city
	});
}
function isFiniteAmount(value) {
	return value != null && Number.isFinite(value);
}
function isMilestoneAtRisk(milestone) {
	if (milestone.progressStatus === "atRisk" || milestone.progressStatus === "offTrack") return true;
	return milestone.progressStatus == null;
}
function rentalDevelopmentSubtitle(sourceData) {
	const { ervAtPurchase, ervAtExit, expansionNewLettingRent } = sourceData.rentDevelopment;
	if (ervAtPurchase == null || ervAtExit == null) return "Blended ERV development across the holding period.";
	const streams = expansionNewLettingRent.length > 0 ? "three distinct rent streams" : "existing and refurbished rent streams";
	return `Blended ERV moves from ${currencyPerSquareMeter(ervAtPurchase)} at purchase to ${currencyPerSquareMeter(ervAtExit)} at exit, split across ${streams}.`;
}
function projectDeliverySubtitle(sourceData) {
	const atRisk = sourceData.projectDelivery.milestones.filter((milestone) => milestone.showOnTimeline !== false).filter(isMilestoneAtRisk).length;
	const asAt = intlDateFormat(sourceData.generatedAt);
	if (atRisk <= 0) return `Timeline and milestone status as at ${asAt}.`;
	if (atRisk === 1) return `Timeline and milestone status as at ${asAt}. One milestone currently forecast late.`;
	return `Timeline and milestone status as at ${asAt}. ${atRisk} milestones currently forecast late.`;
}
function locationSubtitle(sourceData) {
	const suffix = "Macro / micro assessment · accessibility · zoning & site factors";
	const address = formatCoverAddress(sourceData.cover.address);
	return address === "" ? suffix : `${address} · ${suffix}`;
}
function rentComparablesSubtitle(sourceData) {
	const radiusInKm = sourceData.rentAnalysis.analysis?.radiusInKm ?? sourceData.rentAnalysis.analysis?.filters.radiusInKm ?? null;
	const base = `Rent index bands for the refurbished vintage, benchmarked against 6 comparable estates`;
	if (radiusInKm == null) return `${base}.`;
	return `${base} within a ${localNumberFormat$1(radiusInKm, 0, 1)} km radius.`;
}
function cashFlowSubtitle(sourceData) {
	const { entryNoi, exitNoi } = sourceData.cashFlow.noiBridge;
	if (!isFiniteAmount(entryNoi) || !isFiniteAmount(exitNoi)) return "When cash moves — and how operating profit gets from entry to exit NOI p.a.";
	return `When cash moves — and how operating profit gets from ${currency$1(entryNoi, 0, 0)} to ${currency$1(exitNoi, 0, 0)} p.a.`;
}
/** Plain-text subtitle currently shown on the slide when none is stored. */
function defaultICTeaserSlideSubtitle(slideKey, sourceData) {
	switch (slideKey) {
		case "assetOverview": return "Facts & figures at acquisition";
		case "macroMicroLocation": return locationSubtitle(sourceData);
		case "locationRentComparatives": return rentComparablesSubtitle(sourceData);
		case "transformation": return "Develop-to-Green programme and roof conversion — the mechanisms that convert purchase price into rent.";
		case "rentalDevelopment": return rentalDevelopmentSubtitle(sourceData);
		case "projectDelivery": return projectDeliverySubtitle(sourceData);
		case "sourcesUsesFinancing": return "Capital in, capital out — and the tranche terms behind it.";
		case "subsidies": return "BAFA / BEG EM is an alternative to KfW 261 on the same cost items, not an addition. Regional programmes appear when the asset city qualifies.";
		case "cashFlow": return cashFlowSubtitle(sourceData);
		case "unleveredDcf": return "Unlevered deal cash flow from the investment case · pre-tax.";
		case "leveredDcf": return "Levered deal cash flow from the investment case · post-tax post-promote.";
		case "header":
		case "executiveSummary":
		case "assetImpressions":
		case "returns":
		case "finisher":
		case "placeholder": return "";
		default: return slideKey;
	}
}
/** Stored overwrite wins; else AI subtitle; else the displayed default as TipTap HTML. */
function resolveICTeaserEditorSubtitle(stored, slideKey, sourceData, generated) {
	if (subtitleHasContent(stored)) return stored;
	const aiKey = getICTeaserSlideSubtitleAiKey(slideKey);
	const aiValue = aiKey == null ? null : generated?.[aiKey];
	if (typeof aiValue === "string" && subtitleHasContent(aiValue)) return aiValue;
	return wrapSubtitleHtml(defaultICTeaserSlideSubtitle(slideKey, sourceData));
}
/**
* Editor prefills with AI / computed defaults. Persist a slide subtitle only when
* the user changed that prefill, so live defaults and regenerated subheaders keep winning.
* Unchanged editor values keep the original stored subtitle (often empty).
*/
function persistableICTeaserEditorSubtitle(editorValue, slideKey, baselineEditorValue, storedSubtitle, sourceData, generated) {
	if (!subtitleHasContent(editorValue)) return "";
	if (subtitlesEquivalent(editorValue, baselineEditorValue)) return storedSubtitle;
	if (subtitlesEquivalent(editorValue, resolveICTeaserEditorSubtitle("", slideKey, sourceData, generated))) return "";
	return editorValue;
}
var currency$1, currencyPerSquareMeter, localNumberFormat$1, SUBTITLE_TAG_ALIASES;
var init_ic_teaser_subtitles = __esmMin((() => {
	init_ic_teaser_fields();
	init_ic_teaser_formatters();
	init_ic_teaser_rent();
	({currency: currency$1, currencyPerSquareMeter, localNumberFormat: localNumberFormat$1} = icTeaserNumberFormatters);
	SUBTITLE_TAG_ALIASES = {
		b: "strong",
		i: "em"
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/ic-teaser.editable.ts
function toEditableICTeaserMedia(media) {
	if (!media?.mediaFileId || !media.url) return null;
	return {
		mediaFileId: media.mediaFileId,
		url: media.url,
		crop: media.crop ? { ...media.crop } : null
	};
}
function nullableNumber(value, decimals) {
	if (value == null || Number.isNaN(Number(value))) return null;
	const numeric = Number(value);
	return decimals == null ? numeric : round$1(numeric, decimals);
}
function amountNumber(value) {
	return nullableNumber(value, AMOUNT_DECIMALS);
}
function persistLocationChips(chips) {
	return sanitizeICTeaserLocationChips(chips);
}
function yearNumber(value) {
	if (value == null || Number.isNaN(Number(value))) return null;
	return Math.round(Number(value));
}
function editableCashFlowYear(year) {
	return {
		year: yearNumber(year.year),
		netCashFlow: amountNumber(year.netCashFlow),
		cumulativeCashFlow: amountNumber(year.cumulativeCashFlow),
		netOperatingIncome: amountNumber(year.netOperatingIncome)
	};
}
function editableReturnLevel(level) {
	return {
		profit: amountNumber(level?.profit),
		irr: rateNumber(level?.irr),
		moC: amountNumber(level?.moC)
	};
}
function editableCashYieldPair(pair) {
	return {
		unlevered: rateNumber(pair?.unlevered),
		levered: rateNumber(pair?.levered)
	};
}
function editableEntryExit(row, kind) {
	const roundValue = kind === "rate" ? rateNumber : amountNumber;
	return {
		entry: roundValue(row?.entry),
		exit: roundValue(row?.exit)
	};
}
function editableValueBridgeBar(bar) {
	return {
		total: amountNumber(bar?.total),
		perSquareMeter: amountNumber(bar?.perSquareMeter)
	};
}
function editableReturns(returns) {
	return {
		returnLadder: {
			preTaxUnlevered: editableReturnLevel(returns?.returnLadder?.preTaxUnlevered),
			preTaxLevered: editableReturnLevel(returns?.returnLadder?.preTaxLevered),
			postTaxLevered: editableReturnLevel(returns?.returnLadder?.postTaxLevered),
			postTaxPostPromote: editableReturnLevel(returns?.returnLadder?.postTaxPostPromote)
		},
		cashYields: {
			year1PostCompletion: editableCashYieldPair(returns?.cashYields?.year1PostCompletion),
			averagePostCompletionToExit: editableCashYieldPair(returns?.cashYields?.averagePostCompletionToExit),
			atExit: editableCashYieldPair(returns?.cashYields?.atExit),
			averageFullHoldingPeriod: editableCashYieldPair(returns?.cashYields?.averageFullHoldingPeriod)
		},
		goingInOut: {
			nla: editableEntryExit(returns?.goingInOut?.nla, "amount"),
			nppVsGrossDisposalPrice: editableEntryExit(returns?.goingInOut?.nppVsGrossDisposalPrice, "amount"),
			nppVsGrossDisposalPricePsm: editableEntryExit(returns?.goingInOut?.nppVsGrossDisposalPricePsm, "amount"),
			nriMultiple: editableEntryExit(returns?.goingInOut?.nriMultiple, "amount"),
			nriYield: editableEntryExit(returns?.goingInOut?.nriYield, "rate"),
			nriPerYearExclVacancyRent: editableEntryExit(returns?.goingInOut?.nriPerYearExclVacancyRent, "amount"),
			nriPerYearInclVacancyRent: editableEntryExit(returns?.goingInOut?.nriPerYearInclVacancyRent, "amount"),
			nriPmPsqmResi: editableEntryExit(returns?.goingInOut?.nriPmPsqmResi, "amount"),
			vacancy: editableEntryExit(returns?.goingInOut?.vacancy, "rate"),
			vacancySqm: editableEntryExit(returns?.goingInOut?.vacancySqm, "amount"),
			noiPerYear: editableEntryExit(returns?.goingInOut?.noiPerYear, "amount"),
			nriLeakage: editableEntryExit(returns?.goingInOut?.nriLeakage, "rate"),
			capRateNoiNpp: editableEntryExit(returns?.goingInOut?.capRateNoiNpp, "rate"),
			grossPriceNextBuyerView: editableEntryExit(returns?.goingInOut?.grossPriceNextBuyerView, "amount"),
			netYieldNoiGpp: editableEntryExit(returns?.goingInOut?.netYieldNoiGpp, "rate"),
			gppVsNetDisposalProceeds: editableEntryExit(returns?.goingInOut?.gppVsNetDisposalProceeds, "amount")
		},
		valueBridge: {
			netPurchasePrice: editableValueBridgeBar(returns?.valueBridge?.netPurchasePrice),
			transactionCosts: editableValueBridgeBar(returns?.valueBridge?.transactionCosts),
			capexEnergyEfficiency: editableValueBridgeBar(returns?.valueBridge?.capexEnergyEfficiency),
			capexGeneral: editableValueBridgeBar(returns?.valueBridge?.capexGeneral),
			capexExpansion: editableValueBridgeBar(returns?.valueBridge?.capexExpansion),
			tenantImprovements: editableValueBridgeBar(returns?.valueBridge?.tenantImprovements),
			leasingCommissionTenantCompensations: editableValueBridgeBar(returns?.valueBridge?.leasingCommissionTenantCompensations),
			partnerFees: editableValueBridgeBar(returns?.valueBridge?.partnerFees),
			vatLoss: editableValueBridgeBar(returns?.valueBridge?.vatLoss),
			netDisposalProceeds: editableValueBridgeBar(returns?.valueBridge?.netDisposalProceeds),
			totalGrant: editableValueBridgeBar(returns?.valueBridge?.totalGrant),
			noiCollected: editableValueBridgeBar(returns?.valueBridge?.noiCollected),
			grossProfit: editableValueBridgeBar(returns?.valueBridge?.grossProfit)
		}
	};
}
function editableNoiBridge(bridge) {
	return {
		entryNoi: amountNumber(bridge.entryNoi),
		lettingVacantUnits: amountNumber(bridge.lettingVacantUnits),
		rentIncreases: amountNumber(bridge.rentIncreases),
		modernizationLevy: amountNumber(bridge.modernizationLevy),
		newLettingAfterRenovation: amountNumber(bridge.newLettingAfterRenovation),
		additionalResidentialArea: amountNumber(bridge.additionalResidentialArea),
		initialVacantCommercialSpaceNewlyLet: amountNumber(bridge.initialVacantCommercialSpaceNewlyLet),
		newCommercialLetting: amountNumber(bridge.newCommercialLetting),
		vacantParkingLetting: amountNumber(bridge.vacantParkingLetting),
		newParkingLetting: amountNumber(bridge.newParkingLetting),
		additionalParkingSpaces: amountNumber(bridge.additionalParkingSpaces),
		exitNoi: amountNumber(bridge.exitNoi)
	};
}
function rateNumber(value) {
	return nullableNumber(value, RATE_DECIMALS);
}
function occupancyNumber(value) {
	return nullableNumber(value, OCCUPANCY_DECIMALS);
}
function editableDebtTranche(tranche) {
	return {
		amount: amountNumber(tranche?.amount),
		loanToCost: rateNumber(tranche?.loanToCost),
		interestRate: rateNumber(tranche?.interestRate),
		amortizationStartQuarter: nullableString(tranche?.amortizationStartQuarter),
		runningAmortization: rateNumber(tranche?.runningAmortization),
		commitmentFee: rateNumber(tranche?.commitmentFee),
		upfrontFee: rateNumber(tranche?.upfrontFee)
	};
}
function debtTranchePatch(tranche) {
	return {
		amount: amountNumber(tranche.amount),
		loanToCost: rateNumber(tranche.loanToCost),
		interestRate: rateNumber(tranche.interestRate),
		amortizationStartQuarter: nullableString(tranche.amortizationStartQuarter),
		runningAmortization: rateNumber(tranche.runningAmortization),
		commitmentFee: rateNumber(tranche.commitmentFee),
		upfrontFee: rateNumber(tranche.upfrontFee)
	};
}
function editableCombinedFinancing(combined) {
	return {
		totalLoanAmount: amountNumber(combined?.totalLoanAmount),
		totalCostBase: amountNumber(combined?.totalCostBase),
		grossPurchasePrice: amountNumber(combined?.grossPurchasePrice),
		capexExcludingVat: amountNumber(combined?.capexExcludingVat),
		tenantImprovementsAndLeasingCostsExcludingVat: amountNumber(combined?.tenantImprovementsAndLeasingCostsExcludingVat),
		vatLoss: amountNumber(combined?.vatLoss),
		partnerCapexFeeIncludingVat: amountNumber(combined?.partnerCapexFeeIncludingVat),
		loanToCost: rateNumber(combined?.loanToCost),
		loanShareOfGrossDisposalPrice: rateNumber(combined?.loanShareOfGrossDisposalPrice)
	};
}
function combinedFinancingPatch(combined) {
	return {
		totalLoanAmount: amountNumber(combined.totalLoanAmount),
		totalCostBase: amountNumber(combined.totalCostBase),
		grossPurchasePrice: amountNumber(combined.grossPurchasePrice),
		capexExcludingVat: amountNumber(combined.capexExcludingVat),
		tenantImprovementsAndLeasingCostsExcludingVat: amountNumber(combined.tenantImprovementsAndLeasingCostsExcludingVat),
		vatLoss: amountNumber(combined.vatLoss),
		partnerCapexFeeIncludingVat: amountNumber(combined.partnerCapexFeeIncludingVat),
		loanToCost: rateNumber(combined.loanToCost),
		loanShareOfGrossDisposalPrice: rateNumber(combined.loanShareOfGrossDisposalPrice)
	};
}
function nullableString(value) {
	if (value == null) return null;
	const trimmed = value.trim();
	return trimmed === "" ? null : trimmed;
}
function editableAddress(address) {
	return {
		street: address.street ?? "",
		houseNumber: address.houseNumber ?? "",
		postalCode: address.postalCode ?? "",
		city: address.city ?? "",
		quarter: address.quarter ?? ""
	};
}
function editableDate(value) {
	if (value == null) return null;
	if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value.toISOString();
	const trimmed = String(value).trim();
	return trimmed === "" ? null : trimmed;
}
function editableRentIndexBand(band) {
	return {
		label: band.label ?? "",
		minimum: amountNumber(band.minimum),
		mean: amountNumber(band.mean),
		maximum: amountNumber(band.maximum)
	};
}
function quarterIndex(date) {
	const parsed = dayjs(date);
	return parsed.year() * 4 + Math.floor(parsed.month() / 3);
}
function varianceInQuartersFromIso(planDate, expectedDate) {
	if (planDate == null || expectedDate == null) return null;
	const plan = dayjs(planDate);
	const expected = dayjs(expectedDate);
	if (!plan.isValid() || !expected.isValid()) return null;
	return quarterIndex(expected.toDate()) - quarterIndex(plan.toDate());
}
function editableMilestoneStatus(value) {
	switch (value) {
		case "completed":
		case "onTrack":
		case "notStarted": return value;
		default: return "notStarted";
	}
}
function editableMilestoneProgressStatus(value) {
	switch (value) {
		case "onTrack":
		case "atRisk":
		case "offTrack":
		case "notRequired": return value;
		default: return null;
	}
}
function emptyICTeaserEditableProjectMilestone(id) {
	return {
		id,
		name: "",
		phase: null,
		stage: null,
		planDate: null,
		expectedDate: null,
		actualDate: null,
		status: "notStarted",
		progressStatus: null,
		varianceInQuarters: null,
		showOnTimeline: false
	};
}
function editableMilestones(milestones) {
	return (milestones ?? []).map((milestone, index) => ({
		id: nullableString(milestone.id) ?? `milestone-${index}`,
		name: milestone.name ?? "",
		phase: nullableString(milestone.phase),
		stage: nullableString(milestone.stage),
		planDate: formatDate(milestone.planDate),
		expectedDate: formatDate(milestone.expectedDate),
		actualDate: formatDate(milestone.actualDate),
		status: editableMilestoneStatus(milestone.status),
		progressStatus: editableMilestoneProgressStatus(milestone.progressStatus),
		varianceInQuarters: nullableNumber(milestone.varianceInQuarters, 0),
		showOnTimeline: milestone.showOnTimeline === true
	}));
}
function editableRefurbishmentYears(rows) {
	return (rows ?? []).map((row) => ({
		year: nullableNumber(row.year, 0),
		unrefurbishedArea: amountNumber(row.unrefurbishedArea),
		refurbishedArea: amountNumber(row.refurbishedArea)
	}));
}
function editableTimeSeries(points) {
	return (points ?? []).map((point) => ({
		date: formatDate(point.date),
		value: amountNumber(point.value)
	}));
}
function formatDates(values) {
	return compact((values ?? []).map((value) => formatDate(value)));
}
function editableBoolean(value) {
	return isBoolean(value) ? value : null;
}
function transformationCardTitles(value) {
	return mapValues(IC_TEASER_TRANSFORMATION_CARD_DEFAULT_TITLES, (_, key) => resolveICTeaserTransformationCardTitle(value, key));
}
/** Persist only titles that differ from the default, so default copy changes still reach old teasers. */
function transformationCardTitleOverrides(value) {
	return pickBy(transformationCardTitles(value), (title, key) => title !== IC_TEASER_TRANSFORMATION_CARD_DEFAULT_TITLES[key]);
}
function financingHiddenTableSections(value) {
	return IC_TEASER_FINANCING_TABLE_SECTIONS.filter((section) => value?.includes(section) === true);
}
/** Editorial slide visibility: missing flag uses fallback so old teasers keep previous show/hide behaviour. */
function visibilityFlag(value, fallback) {
	return isBoolean(value) ? value : fallback;
}
function timeSeriesPatch(points) {
	return compact((points ?? []).map((point) => {
		const date = formatDate(point.date);
		const value = amountNumber(point.value);
		if (date == null || value == null) return null;
		return {
			date,
			value
		};
	}));
}
function milestonePatch(milestone, index) {
	const planDate = formatDate(milestone.planDate);
	const expectedDate = formatDate(milestone.expectedDate);
	const variance = varianceInQuartersFromIso(planDate, expectedDate);
	return {
		id: nullableString(milestone.id) ?? `milestone-${index}`,
		name: milestone.name.trim(),
		phase: nullableString(milestone.phase),
		stage: nullableString(milestone.stage),
		planDate,
		expectedDate,
		actualDate: formatDate(milestone.actualDate),
		status: editableMilestoneStatus(milestone.status),
		progressStatus: editableMilestoneProgressStatus(milestone.progressStatus),
		...variance == null || variance === 0 ? {} : { varianceInQuarters: variance },
		showOnTimeline: milestone.showOnTimeline === true
	};
}
function refurbishmentYearPatch(row) {
	return {
		year: nullableNumber(row.year, 0) ?? 0,
		unrefurbishedArea: amountNumber(row.unrefurbishedArea) ?? 0,
		refurbishedArea: amountNumber(row.refurbishedArea) ?? 0
	};
}
function editableDcfTable(table) {
	const columns = (table?.columns ?? []).flatMap((column) => typeof column === "string" ? [column] : []);
	const columnKinds = (table?.columnKinds ?? []).flatMap((kind) => kind === "label" || kind === "comment" || kind === "total" || kind === "year" ? [kind] : []);
	const rows = (table?.rows ?? []).flatMap((row) => row == null ? [] : [row]);
	return {
		columns,
		...columnKinds.length > 0 ? { columnKinds } : {},
		rows,
		...Array.isArray(table?.summaryMetrics) ? { summaryMetrics: table.summaryMetrics.flatMap((metric) => metric == null || typeof metric.label !== "string" ? [] : [{
			label: metric.label,
			value: metric.value ?? null,
			format: metric.format ?? void 0
		}]) } : {}
	};
}
function addressPatch(address) {
	return {
		street: nullableString(address.street),
		houseNumber: nullableString(address.houseNumber),
		postalCode: nullableString(address.postalCode),
		city: nullableString(address.city),
		quarter: nullableString(address.quarter)
	};
}
/** Persist → editable: pick curated roots, clean media, cap impressions, default strings for inputs. */
function buildEditableSourceValues(teaser) {
	const { cover, assetImpressions, assetOverview, transformation, rentDevelopment, projectDelivery, financing, subsidies, cashFlow, dcf, returns, location, rentAnalysis } = teaser.sourceData;
	return {
		cover: {
			address: editableAddress(cover.address),
			numberOfBuildings: amountNumber(cover.numberOfBuildings),
			numberOfUnits: amountNumber(cover.numberOfUnits),
			totalSpaceNlaEntry: amountNumber(cover.totalSpaceNlaEntry),
			totalInvestmentVolume: amountNumber(cover.totalInvestmentVolume),
			equityCommitment: amountNumber(cover.equityCommitment),
			cocAtExit: editableCashYieldPair(cover.cocAtExit),
			mocPostTaxPostPromote: amountNumber(cover.mocPostTaxPostPromote),
			irrPostTaxLevered: rateNumber(cover.irrPostTaxLevered),
			preRenovationPhoto: toEditableICTeaserMedia(cover.preRenovationPhoto)
		},
		executiveSummary: {
			photo: toEditableICTeaserMedia(teaser.sourceData.executiveSummary?.photo),
			additionalBoxes: (teaser.sourceData.executiveSummary?.additionalBoxes ?? []).map((box) => ({
				id: box.id ?? "",
				title: box.title ?? "",
				body: box.body ?? ""
			}))
		},
		assetImpressions: { selectedMedia: (assetImpressions.selectedMedia ?? []).map((media) => toEditableICTeaserMedia(media)).filter((media) => media != null).slice(0, 8) },
		assetOverview: {
			photo: toEditableICTeaserMedia(assetOverview.photo),
			address: editableAddress(assetOverview.address),
			coordinates: {
				latitude: assetOverview.coordinates.latitude,
				longitude: assetOverview.coordinates.longitude
			},
			constructionYear: yearNumber(assetOverview.constructionYear),
			energyEfficiencyRatingPreTransformationFrom: assetOverview.energyEfficiencyRatingPreTransformationFrom ?? "",
			energyEfficiencyRatingPreTransformationTo: firstNonEmptyString(assetOverview.energyEfficiencyRatingPreTransformationTo, assetOverview.energyEfficiencyRatingPreTransformationFrom) ?? "",
			finalEnergyDemandPreTransformationFrom: amountNumber(assetOverview.finalEnergyDemandPreTransformationFrom),
			finalEnergyDemandPreTransformationTo: amountNumber(assetOverview.finalEnergyDemandPreTransformationTo) ?? amountNumber(assetOverview.finalEnergyDemandPreTransformationFrom),
			primaryEnergySource: assetOverview.primaryEnergySource ?? "",
			numberOfBuildings: amountNumber(assetOverview.numberOfBuildings),
			totalRentableSpace: amountNumber(assetOverview.totalRentableSpace),
			residentialSpace: {
				amount: amountNumber(assetOverview.residentialSpace.amount),
				share: rateNumber(assetOverview.residentialSpace.share)
			},
			commercialSpace: {
				amount: amountNumber(assetOverview.commercialSpace.amount),
				share: rateNumber(assetOverview.commercialSpace.share)
			},
			numberOfResidentialUnits: amountNumber(assetOverview.numberOfResidentialUnits),
			averageResidentialUnitSize: amountNumber(assetOverview.averageResidentialUnitSize),
			numberOfCommercialUnits: amountNumber(assetOverview.numberOfCommercialUnits),
			numberOfParkingSpaces: amountNumber(assetOverview.numberOfParkingSpaces),
			expansionPotentialSqm: amountNumber(assetOverview.expansionPotentialSqm),
			occupancyRate: {
				residential: occupancyNumber(assetOverview.occupancyRate.residential),
				commercial: occupancyNumber(assetOverview.occupancyRate.commercial),
				parking: occupancyNumber(assetOverview.occupancyRate.parking)
			},
			netRentalIncomePerYear: amountNumber(assetOverview.netRentalIncomePerYear),
			netResidentialRentPerSquareMeterPerMonth: amountNumber(assetOverview.netResidentialRentPerSquareMeterPerMonth),
			netCommercialRentPerSquareMeterPerMonth: amountNumber(assetOverview.netCommercialRentPerSquareMeterPerMonth),
			netParkingRentPerSpotPerMonth: amountNumber(assetOverview.netParkingRentPerSpotPerMonth),
			acquisitionPrice: amountNumber(assetOverview.acquisitionPrice),
			acquisitionPricePerSquareMeter: amountNumber(assetOverview.acquisitionPricePerSquareMeter),
			acquisitionMultiple: amountNumber(assetOverview.acquisitionMultiple),
			grossPurchasePrice: amountNumber(assetOverview.grossPurchasePrice),
			germanyMapZoom: assetOverview.germanyMapZoom,
			cityMapZoom: assetOverview.cityMapZoom
		},
		transformation: {
			cardTitles: transformationCardTitles(transformation.cardTitles),
			preRenovationPhoto: toEditableICTeaserMedia(transformation.preRenovationPhoto),
			postRenovationPhoto: toEditableICTeaserMedia(transformation.postRenovationPhoto),
			tenantImprovementCapexPerSquareMeter: amountNumber(transformation.tenantImprovementCapexPerSquareMeter),
			generalCapexPerSquareMeter: amountNumber(transformation.generalCapexPerSquareMeter),
			energeticCapexPerSquareMeter: amountNumber(transformation.energeticCapexPerSquareMeter),
			expansionCapexPerSquareMeter: amountNumber(transformation.expansionCapexPerSquareMeter),
			expansionPotentialSqm: amountNumber(transformation.expansionPotentialSqm),
			energyEfficiencyRatingEntryFrom: transformation.energyEfficiencyRatingEntryFrom ?? "",
			energyEfficiencyRatingEntryTo: firstNonEmptyString(transformation.energyEfficiencyRatingEntryTo, transformation.energyEfficiencyRatingEntryFrom) ?? "",
			energyEfficiencyRatingExit: transformation.energyEfficiencyRatingExit ?? "",
			finalEnergyDemandEntryFrom: amountNumber(transformation.finalEnergyDemandEntryFrom),
			finalEnergyDemandEntryTo: amountNumber(transformation.finalEnergyDemandEntryTo) ?? amountNumber(transformation.finalEnergyDemandEntryFrom),
			finalEnergyDemandExit: amountNumber(transformation.finalEnergyDemandExit),
			lettableAreaEntry: { residentialExisting: amountNumber(transformation.lettableAreaEntry.residentialExisting) },
			lettableAreaExit: {
				residentialExisting: amountNumber(transformation.lettableAreaExit.residentialExisting),
				residentialExpansion: amountNumber(transformation.lettableAreaExit.residentialExpansion)
			},
			modernizationLevyPerSquareMeterPerMonth: amountNumber(transformation.modernizationLevyPerSquareMeterPerMonth)
		},
		rentDevelopment: {
			signingDate: formatDate(rentDevelopment.signingDate),
			modernizationLevyDate: formatDate(rentDevelopment.modernizationLevyDate),
			exitDate: formatDate(rentDevelopment.exitDate),
			chartEndDate: formatDate(rentDevelopment.chartEndDate),
			holdingPeriodYears: amountNumber(rentDevelopment.holdingPeriodYears),
			existingRent: editableTimeSeries(rentDevelopment.existingRent),
			refurbishedNewLettingRent: editableTimeSeries(rentDevelopment.refurbishedNewLettingRent),
			expansionNewLettingRent: editableTimeSeries(rentDevelopment.expansionNewLettingRent),
			averageRent: editableTimeSeries(rentDevelopment.averageRent),
			rentIncreaseDates: formatDates(rentDevelopment.rentIncreaseDates),
			ervAtPurchase: amountNumber(rentDevelopment.ervAtPurchase),
			ervAtExit: amountNumber(rentDevelopment.ervAtExit),
			annualMarketRentGrowth: rateNumber(rentDevelopment.annualMarketRentGrowth),
			annualNewLeaseIndexation: rateNumber(rentDevelopment.annualNewLeaseIndexation),
			annualResidentialChurn: rateNumber(rentDevelopment.annualResidentialChurn),
			rentIndexIncreaseLimit: rateNumber(rentDevelopment.rentIndexIncreaseLimit),
			modernizationLevy: amountNumber(rentDevelopment.modernizationLevy),
			vacancyCapitalizedAtDisposal: editableBoolean(rentDevelopment.vacancyCapitalizedAtDisposal),
			impliedNriUpliftPotential: rateNumber(rentDevelopment.impliedNriUpliftPotential),
			occupancy: {
				residential: {
					entry: occupancyNumber(rentDevelopment.occupancy?.residential?.entry),
					exit: occupancyNumber(rentDevelopment.occupancy?.residential?.exit)
				},
				commercial: {
					entry: occupancyNumber(rentDevelopment.occupancy?.commercial?.entry),
					exit: occupancyNumber(rentDevelopment.occupancy?.commercial?.exit)
				},
				parking: {
					entry: occupancyNumber(rentDevelopment.occupancy?.parking?.entry),
					exit: occupancyNumber(rentDevelopment.occupancy?.parking?.exit)
				}
			}
		},
		projectDelivery: {
			annualRenovatedArea: amountNumber(projectDelivery.annualRenovatedArea),
			annualTenantChurn: rateNumber(projectDelivery.annualTenantChurn),
			exitYear: nullableNumber(projectDelivery.exitYear, 0),
			milestones: editableMilestones(projectDelivery.milestones),
			refurbishmentDevelopment: editableRefurbishmentYears(projectDelivery.refurbishmentDevelopment)
		},
		financing: {
			sourcesUses: financing.sourcesUses ?? null,
			volumeWeightedCombinedInterestRate: rateNumber(financing.volumeWeightedCombinedInterestRate),
			seniorDebt: editableDebtTranche(financing.seniorDebt),
			capexAndTenantImprovementDebt: editableDebtTranche(financing.capexAndTenantImprovementDebt),
			subsidizedDebt: {
				...editableDebtTranche(financing.subsidizedDebt),
				grantAmount: amountNumber(financing.subsidizedDebt.grantAmount),
				grantShareOfLoan: rateNumber(financing.subsidizedDebt.grantShareOfLoan)
			},
			combinedFinancing: editableCombinedFinancing(financing.combinedFinancing),
			combinedFinancingIncludingSubsidyGrant: editableCombinedFinancing(financing.combinedFinancingIncludingSubsidyGrant),
			hiddenTableSections: financingHiddenTableSections(financing.hiddenTableSections)
		},
		subsidies: {
			kfw261: {
				showOnSlide: visibilityFlag(subsidies.kfw261.showOnSlide, true),
				note: subsidies.kfw261.note ?? "",
				eligibleCosts: amountNumber(subsidies.kfw261.eligibleCosts),
				subsidyRate: rateNumber(subsidies.kfw261.subsidyRate),
				bonusEe: rateNumber(subsidies.kfw261.bonusEe),
				bonusWpb: rateNumber(subsidies.kfw261.bonusWpb),
				bonusSerialRenovation: rateNumber(subsidies.kfw261.bonusSerialRenovation),
				totalSubsidyRate: rateNumber(subsidies.kfw261.totalSubsidyRate),
				totalGrant: amountNumber(subsidies.kfw261.totalGrant),
				subsidizedLoanAfterRepaymentGrant: amountNumber(subsidies.kfw261.subsidizedLoanAfterRepaymentGrant),
				interestRate: rateNumber(subsidies.kfw261.interestRate),
				repayment: nullableString(subsidies.kfw261.repayment),
				durationInYears: yearNumber(subsidies.kfw261.durationInYears),
				fixedInterestPeriodInYears: yearNumber(subsidies.kfw261.fixedInterestPeriodInYears)
			},
			bafa: {
				showOnSlide: visibilityFlag(subsidies.bafa.showOnSlide, true),
				note: subsidies.bafa.note ?? "",
				capexBasisExcludingHeating: amountNumber(subsidies.bafa.capexBasisExcludingHeating),
				capexBasisHeating: amountNumber(subsidies.bafa.capexBasisHeating),
				totalFundingRate: rateNumber(subsidies.bafa.totalFundingRate),
				totalGrant: amountNumber(subsidies.bafa.totalGrant)
			},
			ifb: {
				showOnSlide: visibilityFlag(subsidies.ifb?.showOnSlide, subsidies.ifb != null),
				note: subsidies.ifb?.note ?? "",
				eligibleCosts: amountNumber(subsidies.ifb?.eligibleCosts),
				baseGrant: amountNumber(subsidies.ifb?.baseGrant),
				brickFacadeOrMonumentProtectionGrant: amountNumber(subsidies.ifb?.brickFacadeOrMonumentProtectionGrant),
				totalGrant: amountNumber(subsidies.ifb?.totalGrant)
			},
			dus: {
				showOnSlide: visibilityFlag(subsidies.dus?.showOnSlide, subsidies.dus != null),
				note: subsidies.dus?.note ?? "",
				totalFundingRate: rateNumber(subsidies.dus?.totalFundingRate),
				totalGrant: amountNumber(subsidies.dus?.totalGrant)
			},
			fkg: {
				showOnSlide: visibilityFlag(subsidies.fkg?.showOnSlide, subsidies.fkg != null),
				note: subsidies.fkg?.note ?? "",
				capexBasisExcludingHeating: amountNumber(subsidies.fkg?.capexBasisExcludingHeating),
				capexBasisHeating: amountNumber(subsidies.fkg?.capexBasisHeating),
				totalFundingRate: rateNumber(subsidies.fkg?.totalFundingRate),
				totalGrant: amountNumber(subsidies.fkg?.totalGrant)
			}
		},
		cashFlow: {
			yearlyCashFlow: (cashFlow.yearlyCashFlow ?? []).map(editableCashFlowYear),
			noiBridge: editableNoiBridge(cashFlow.noiBridge)
		},
		dcf: {
			unlevered: editableDcfTable(dcf.unlevered),
			levered: editableDcfTable(dcf.levered),
			d2gVersion: dcf.d2gVersion ?? null,
			calculatedAt: editableDate(dcf.calculatedAt)
		},
		returns: editableReturns(returns),
		location: {
			analysis: location.analysis,
			restrictions: selectedRestrictionsFromICTeaserLocationRestrictions(location.restrictions),
			macro: resolveICTeaserLocationParagraphs(location.macro, location.analysis, "macro"),
			micro: resolveICTeaserLocationParagraphs(location.micro, location.analysis, "micro"),
			visibleCategories: normalizeICTeaserVisibleCategories(location.visibleCategories),
			highlightedLocationKeys: location.highlightedLocationKeys == null ? null : compact(location.highlightedLocationKeys),
			primaryHighlightedLocationKeys: location.primaryHighlightedLocationKeys == null ? null : compactICTeaserPrimaryHighlightedLocationKeys(location.primaryHighlightedLocationKeys),
			restrictionsNote: location.restrictionsNote ?? "There are no implications of restrictions affecting the business case.",
			macroChips: resolveICTeaserLocationChips(location.macroChips, location.analysis, "macro"),
			microChips: resolveICTeaserLocationChips(location.microChips, location.analysis, "micro"),
			mapZoom: location.mapZoom,
			customLocations: compact(location.customLocations ?? [])
		},
		rentAnalysis: {
			source: rentAnalysis.source ?? "",
			retrievedAt: editableDate(rentAnalysis.retrievedAt),
			rentIndexBands: (rentAnalysis.rentIndexBands ?? []).map(editableRentIndexBand),
			inPlaceRentPerSquareMeter: amountNumber(rentAnalysis.inPlaceRentPerSquareMeter),
			targetRentPerSquareMeter: amountNumber(rentAnalysis.targetRentPerSquareMeter),
			appliedRentResidential: amountNumber(rentAnalysis.appliedRentResidential),
			manualExpandedSpace: amountNumber(rentAnalysis.manualExpandedSpace),
			analysis: rentAnalysis.analysis ?? null,
			selectedListingIds: rentAnalysis.selectedListingIds == null ? null : compact(rentAnalysis.selectedListingIds)
		}
	};
}
function buildICTeaserEditorValues(teaser) {
	return {
		fields: ALL_TEASER_AI_KEYS.reduce((values, key) => {
			const stored = teaser.generated[key] ?? "";
			values[key] = isICTeaserExecutiveSummaryCardTitleKey(key) ? resolveICTeaserExecutiveSummaryCardTitle(key, stored) : stored;
			return values;
		}, {}),
		sourceData: buildEditableSourceValues(teaser),
		footnotes: collectICTeaserFootnotes(teaser.slides),
		subtitles: collectICTeaserSubtitles(teaser),
		placeholders: collectICTeaserPlaceholders(teaser.slides)
	};
}
function collectICTeaserFootnotes(slides) {
	const footnotes = {};
	for (const slide of slides) {
		if (isICTeaserPlaceholderSlide(slide)) continue;
		footnotes[slide.key] = getICTeaserSlideFootnote(slide);
	}
	return footnotes;
}
function collectICTeaserSubtitles(teaser) {
	const subtitles = {};
	for (const slide of teaser.slides) {
		if (isICTeaserPlaceholderSlide(slide)) continue;
		subtitles[slide.key] = resolveICTeaserEditorSubtitle(getICTeaserSlideSubtitle(slide), slide.key, teaser.sourceData, teaser.generated);
	}
	return subtitles;
}
function collectICTeaserPlaceholders(slides) {
	const placeholders = {};
	for (const slide of slides) {
		if (!isICTeaserPlaceholderSlide(slide)) continue;
		placeholders[slide.instanceId] = {
			name: slide.name ?? "",
			title: slide.title,
			subtitle: slide.subtitle,
			footnote: slide.footnote,
			bodyKind: slide.bodyKind,
			picture: toEditableICTeaserMedia(slide.picture),
			bodyText: slide.bodyText
		};
	}
	return placeholders;
}
function applyICTeaserEditorSlideFieldsToSlides(slides, values, slideFields) {
	const baselineSubtitles = collectICTeaserSubtitles(slideFields.baselineTeaser);
	return slides.map((slide) => {
		if (isICTeaserPlaceholderSlide(slide)) {
			const content = values.placeholders[slide.instanceId] ?? emptyICTeaserPlaceholderSlideContent();
			return {
				...slide,
				name: content.name ?? "",
				title: content.title,
				subtitle: content.subtitle,
				footnote: content.footnote,
				bodyKind: content.bodyKind,
				picture: toEditableICTeaserMedia(content.picture),
				bodyText: content.bodyText
			};
		}
		return {
			...slide,
			footnote: values.footnotes[slide.key] ?? slide.footnote ?? "",
			subtitle: persistableICTeaserEditorSubtitle(values.subtitles[slide.key] ?? "", slide.key, baselineSubtitles[slide.key] ?? "", getICTeaserSlideSubtitle(slide), slideFields.sourceData, slideFields.generated)
		};
	});
}
function buildICTeaserFieldsPatch(values, dirtyFieldKeys) {
	return dirtyFieldKeys.reduce((patch, key) => {
		const value = values.fields[key];
		if (value === void 0) return patch;
		patch[key] = value.trim() === "" ? null : value.trim();
		return patch;
	}, {});
}
/** Editable → persist patch: same nesting; coerce empty strings / NaN. */
function buildICTeaserSourceDataPatch(values) {
	return {
		cover: {
			address: addressPatch(values.cover.address),
			numberOfBuildings: amountNumber(values.cover.numberOfBuildings),
			numberOfUnits: amountNumber(values.cover.numberOfUnits),
			totalSpaceNlaEntry: amountNumber(values.cover.totalSpaceNlaEntry),
			totalInvestmentVolume: amountNumber(values.cover.totalInvestmentVolume),
			equityCommitment: amountNumber(values.cover.equityCommitment),
			cocAtExit: editableCashYieldPair(values.cover.cocAtExit),
			mocPostTaxPostPromote: amountNumber(values.cover.mocPostTaxPostPromote),
			irrPostTaxLevered: rateNumber(values.cover.irrPostTaxLevered),
			preRenovationPhoto: values.cover.preRenovationPhoto
		},
		executiveSummary: {
			photo: values.executiveSummary.photo,
			additionalBoxes: values.executiveSummary.additionalBoxes.map((box) => ({ ...box }))
		},
		assetImpressions: { selectedMedia: values.assetImpressions.selectedMedia },
		assetOverview: {
			photo: values.assetOverview.photo,
			address: addressPatch(values.assetOverview.address),
			coordinates: {
				latitude: nullableNumber(values.assetOverview.coordinates.latitude),
				longitude: nullableNumber(values.assetOverview.coordinates.longitude)
			},
			constructionYear: yearNumber(values.assetOverview.constructionYear),
			energyEfficiencyRatingPreTransformationFrom: nullableString(values.assetOverview.energyEfficiencyRatingPreTransformationFrom),
			energyEfficiencyRatingPreTransformationTo: nullableString(values.assetOverview.energyEfficiencyRatingPreTransformationTo) ?? nullableString(values.assetOverview.energyEfficiencyRatingPreTransformationFrom),
			finalEnergyDemandPreTransformationFrom: amountNumber(values.assetOverview.finalEnergyDemandPreTransformationFrom),
			finalEnergyDemandPreTransformationTo: amountNumber(values.assetOverview.finalEnergyDemandPreTransformationTo) ?? amountNumber(values.assetOverview.finalEnergyDemandPreTransformationFrom),
			primaryEnergySource: nullableString(values.assetOverview.primaryEnergySource),
			numberOfBuildings: amountNumber(values.assetOverview.numberOfBuildings),
			totalRentableSpace: amountNumber(values.assetOverview.totalRentableSpace),
			residentialSpace: {
				amount: amountNumber(values.assetOverview.residentialSpace.amount),
				share: rateNumber(values.assetOverview.residentialSpace.share)
			},
			commercialSpace: {
				amount: amountNumber(values.assetOverview.commercialSpace.amount),
				share: rateNumber(values.assetOverview.commercialSpace.share)
			},
			numberOfResidentialUnits: amountNumber(values.assetOverview.numberOfResidentialUnits),
			averageResidentialUnitSize: amountNumber(values.assetOverview.averageResidentialUnitSize),
			numberOfCommercialUnits: amountNumber(values.assetOverview.numberOfCommercialUnits),
			numberOfParkingSpaces: amountNumber(values.assetOverview.numberOfParkingSpaces),
			expansionPotentialSqm: amountNumber(values.assetOverview.expansionPotentialSqm),
			occupancyRate: {
				residential: occupancyNumber(values.assetOverview.occupancyRate.residential),
				commercial: occupancyNumber(values.assetOverview.occupancyRate.commercial),
				parking: occupancyNumber(values.assetOverview.occupancyRate.parking)
			},
			netRentalIncomePerYear: amountNumber(values.assetOverview.netRentalIncomePerYear),
			netResidentialRentPerSquareMeterPerMonth: amountNumber(values.assetOverview.netResidentialRentPerSquareMeterPerMonth),
			netCommercialRentPerSquareMeterPerMonth: amountNumber(values.assetOverview.netCommercialRentPerSquareMeterPerMonth),
			netParkingRentPerSpotPerMonth: amountNumber(values.assetOverview.netParkingRentPerSpotPerMonth),
			acquisitionPrice: amountNumber(values.assetOverview.acquisitionPrice),
			acquisitionPricePerSquareMeter: amountNumber(values.assetOverview.acquisitionPricePerSquareMeter),
			acquisitionMultiple: amountNumber(values.assetOverview.acquisitionMultiple),
			grossPurchasePrice: amountNumber(values.assetOverview.grossPurchasePrice),
			germanyMapZoom: nullableNumber(values.assetOverview.germanyMapZoom),
			cityMapZoom: nullableNumber(values.assetOverview.cityMapZoom)
		},
		transformation: {
			cardTitles: transformationCardTitleOverrides(values.transformation.cardTitles),
			preRenovationPhoto: values.transformation.preRenovationPhoto,
			postRenovationPhoto: values.transformation.postRenovationPhoto,
			tenantImprovementCapexPerSquareMeter: amountNumber(values.transformation.tenantImprovementCapexPerSquareMeter),
			generalCapexPerSquareMeter: amountNumber(values.transformation.generalCapexPerSquareMeter),
			energeticCapexPerSquareMeter: amountNumber(values.transformation.energeticCapexPerSquareMeter),
			expansionCapexPerSquareMeter: amountNumber(values.transformation.expansionCapexPerSquareMeter),
			expansionPotentialSqm: amountNumber(values.transformation.expansionPotentialSqm),
			energyEfficiencyRatingEntryFrom: nullableString(values.transformation.energyEfficiencyRatingEntryFrom),
			energyEfficiencyRatingEntryTo: nullableString(values.transformation.energyEfficiencyRatingEntryTo) ?? nullableString(values.transformation.energyEfficiencyRatingEntryFrom),
			energyEfficiencyRatingExit: nullableString(values.transformation.energyEfficiencyRatingExit),
			finalEnergyDemandEntryFrom: amountNumber(values.transformation.finalEnergyDemandEntryFrom),
			finalEnergyDemandEntryTo: amountNumber(values.transformation.finalEnergyDemandEntryTo) ?? amountNumber(values.transformation.finalEnergyDemandEntryFrom),
			finalEnergyDemandExit: amountNumber(values.transformation.finalEnergyDemandExit),
			lettableAreaEntry: { residentialExisting: amountNumber(values.transformation.lettableAreaEntry.residentialExisting) },
			lettableAreaExit: {
				residentialExisting: amountNumber(values.transformation.lettableAreaExit.residentialExisting),
				residentialExpansion: amountNumber(values.transformation.lettableAreaExit.residentialExpansion)
			},
			modernizationLevyPerSquareMeterPerMonth: amountNumber(values.transformation.modernizationLevyPerSquareMeterPerMonth)
		},
		rentDevelopment: {
			signingDate: formatDate(values.rentDevelopment.signingDate),
			modernizationLevyDate: formatDate(values.rentDevelopment.modernizationLevyDate),
			exitDate: formatDate(values.rentDevelopment.exitDate),
			chartEndDate: formatDate(values.rentDevelopment.chartEndDate),
			holdingPeriodYears: amountNumber(values.rentDevelopment.holdingPeriodYears),
			existingRent: timeSeriesPatch(values.rentDevelopment.existingRent),
			refurbishedNewLettingRent: timeSeriesPatch(values.rentDevelopment.refurbishedNewLettingRent),
			expansionNewLettingRent: timeSeriesPatch(values.rentDevelopment.expansionNewLettingRent),
			averageRent: timeSeriesPatch(values.rentDevelopment.averageRent),
			rentIncreaseDates: formatDates(values.rentDevelopment.rentIncreaseDates),
			ervAtPurchase: amountNumber(values.rentDevelopment.ervAtPurchase),
			ervAtExit: amountNumber(values.rentDevelopment.ervAtExit),
			annualMarketRentGrowth: rateNumber(values.rentDevelopment.annualMarketRentGrowth),
			annualNewLeaseIndexation: rateNumber(values.rentDevelopment.annualNewLeaseIndexation),
			annualResidentialChurn: rateNumber(values.rentDevelopment.annualResidentialChurn),
			rentIndexIncreaseLimit: rateNumber(values.rentDevelopment.rentIndexIncreaseLimit),
			modernizationLevy: amountNumber(values.rentDevelopment.modernizationLevy),
			vacancyCapitalizedAtDisposal: editableBoolean(values.rentDevelopment.vacancyCapitalizedAtDisposal),
			impliedNriUpliftPotential: rateNumber(values.rentDevelopment.impliedNriUpliftPotential),
			occupancy: {
				residential: {
					entry: occupancyNumber(values.rentDevelopment.occupancy.residential.entry),
					exit: occupancyNumber(values.rentDevelopment.occupancy.residential.exit)
				},
				commercial: {
					entry: occupancyNumber(values.rentDevelopment.occupancy.commercial.entry),
					exit: occupancyNumber(values.rentDevelopment.occupancy.commercial.exit)
				},
				parking: {
					entry: occupancyNumber(values.rentDevelopment.occupancy.parking.entry),
					exit: occupancyNumber(values.rentDevelopment.occupancy.parking.exit)
				}
			}
		},
		projectDelivery: {
			annualRenovatedArea: amountNumber(values.projectDelivery.annualRenovatedArea),
			annualTenantChurn: rateNumber(values.projectDelivery.annualTenantChurn),
			exitYear: nullableNumber(values.projectDelivery.exitYear, 0),
			milestones: values.projectDelivery.milestones.map(milestonePatch),
			refurbishmentDevelopment: values.projectDelivery.refurbishmentDevelopment.map(refurbishmentYearPatch)
		},
		financing: {
			sourcesUses: values.financing.sourcesUses,
			volumeWeightedCombinedInterestRate: rateNumber(values.financing.volumeWeightedCombinedInterestRate),
			seniorDebt: debtTranchePatch(values.financing.seniorDebt),
			capexAndTenantImprovementDebt: debtTranchePatch(values.financing.capexAndTenantImprovementDebt),
			subsidizedDebt: {
				...debtTranchePatch(values.financing.subsidizedDebt),
				grantAmount: amountNumber(values.financing.subsidizedDebt.grantAmount),
				grantShareOfLoan: rateNumber(values.financing.subsidizedDebt.grantShareOfLoan)
			},
			combinedFinancing: combinedFinancingPatch(values.financing.combinedFinancing),
			combinedFinancingIncludingSubsidyGrant: combinedFinancingPatch(values.financing.combinedFinancingIncludingSubsidyGrant),
			hiddenTableSections: financingHiddenTableSections(values.financing.hiddenTableSections)
		},
		subsidies: {
			kfw261: {
				showOnSlide: visibilityFlag(values.subsidies.kfw261.showOnSlide, true),
				note: nullableString(values.subsidies.kfw261.note),
				eligibleCosts: amountNumber(values.subsidies.kfw261.eligibleCosts),
				subsidyRate: rateNumber(values.subsidies.kfw261.subsidyRate),
				bonusEe: rateNumber(values.subsidies.kfw261.bonusEe),
				bonusWpb: rateNumber(values.subsidies.kfw261.bonusWpb),
				bonusSerialRenovation: rateNumber(values.subsidies.kfw261.bonusSerialRenovation),
				totalSubsidyRate: rateNumber(values.subsidies.kfw261.totalSubsidyRate),
				totalGrant: amountNumber(values.subsidies.kfw261.totalGrant),
				subsidizedLoanAfterRepaymentGrant: amountNumber(values.subsidies.kfw261.subsidizedLoanAfterRepaymentGrant),
				interestRate: rateNumber(values.subsidies.kfw261.interestRate),
				repayment: nullableString(values.subsidies.kfw261.repayment),
				durationInYears: yearNumber(values.subsidies.kfw261.durationInYears),
				fixedInterestPeriodInYears: yearNumber(values.subsidies.kfw261.fixedInterestPeriodInYears)
			},
			bafa: {
				showOnSlide: visibilityFlag(values.subsidies.bafa.showOnSlide, true),
				note: nullableString(values.subsidies.bafa.note),
				capexBasisExcludingHeating: amountNumber(values.subsidies.bafa.capexBasisExcludingHeating),
				capexBasisHeating: amountNumber(values.subsidies.bafa.capexBasisHeating),
				totalFundingRate: rateNumber(values.subsidies.bafa.totalFundingRate),
				totalGrant: amountNumber(values.subsidies.bafa.totalGrant)
			},
			ifb: {
				showOnSlide: visibilityFlag(values.subsidies.ifb?.showOnSlide, values.subsidies.ifb != null),
				note: nullableString(values.subsidies.ifb?.note),
				eligibleCosts: amountNumber(values.subsidies.ifb?.eligibleCosts),
				baseGrant: amountNumber(values.subsidies.ifb?.baseGrant),
				brickFacadeOrMonumentProtectionGrant: amountNumber(values.subsidies.ifb?.brickFacadeOrMonumentProtectionGrant),
				totalGrant: amountNumber(values.subsidies.ifb?.totalGrant)
			},
			dus: {
				showOnSlide: visibilityFlag(values.subsidies.dus?.showOnSlide, values.subsidies.dus != null),
				note: nullableString(values.subsidies.dus?.note),
				totalFundingRate: rateNumber(values.subsidies.dus?.totalFundingRate),
				totalGrant: amountNumber(values.subsidies.dus?.totalGrant)
			},
			fkg: {
				showOnSlide: visibilityFlag(values.subsidies.fkg?.showOnSlide, values.subsidies.fkg != null),
				note: nullableString(values.subsidies.fkg?.note),
				capexBasisExcludingHeating: amountNumber(values.subsidies.fkg?.capexBasisExcludingHeating),
				capexBasisHeating: amountNumber(values.subsidies.fkg?.capexBasisHeating),
				totalFundingRate: rateNumber(values.subsidies.fkg?.totalFundingRate),
				totalGrant: amountNumber(values.subsidies.fkg?.totalGrant)
			}
		},
		cashFlow: {
			yearlyCashFlow: (values.cashFlow.yearlyCashFlow ?? []).map(editableCashFlowYear),
			noiBridge: editableNoiBridge(values.cashFlow.noiBridge)
		},
		dcf: {
			unlevered: values.dcf.unlevered,
			levered: values.dcf.levered,
			d2gVersion: nullableString(values.dcf.d2gVersion),
			calculatedAt: nullableString(values.dcf.calculatedAt)
		},
		returns: editableReturns(values.returns),
		location: {
			analysis: values.location.analysis,
			restrictions: buildICTeaserLocationRestrictions(values.location.restrictions),
			macro: values.location.macro,
			micro: values.location.micro,
			visibleCategories: normalizeICTeaserVisibleCategories(values.location.visibleCategories),
			highlightedLocationKeys: values.location.highlightedLocationKeys == null ? null : compact(values.location.highlightedLocationKeys),
			primaryHighlightedLocationKeys: values.location.primaryHighlightedLocationKeys == null ? null : compactICTeaserPrimaryHighlightedLocationKeys(values.location.primaryHighlightedLocationKeys),
			restrictionsNote: nullableString(values.location.restrictionsNote),
			macroChips: persistLocationChips(values.location.macroChips),
			microChips: persistLocationChips(values.location.microChips),
			mapZoom: nullableNumber(values.location.mapZoom),
			customLocations: values.location.customLocations
		},
		rentAnalysis: {
			source: nullableString(values.rentAnalysis.source),
			retrievedAt: nullableString(values.rentAnalysis.retrievedAt),
			rentIndexBands: values.rentAnalysis.rentIndexBands.map(editableRentIndexBand),
			inPlaceRentPerSquareMeter: amountNumber(values.rentAnalysis.inPlaceRentPerSquareMeter),
			targetRentPerSquareMeter: amountNumber(values.rentAnalysis.targetRentPerSquareMeter),
			appliedRentResidential: amountNumber(values.rentAnalysis.appliedRentResidential),
			manualExpandedSpace: amountNumber(values.rentAnalysis.manualExpandedSpace),
			analysis: values.rentAnalysis.analysis ?? null,
			selectedListingIds: values.rentAnalysis.selectedListingIds == null ? null : compact(values.rentAnalysis.selectedListingIds)
		}
	};
}
function buildICTeaserUpdatePatch(values, dirtyFieldKeys, sourceDataDirty, slides, slideFields) {
	const fieldsPatch = buildICTeaserFieldsPatch(values, dirtyFieldKeys);
	const nextSlides = slides ? applyICTeaserEditorSlideFieldsToSlides(slides, values, slideFields) : void 0;
	return {
		...Object.keys(fieldsPatch).length > 0 ? { fields: fieldsPatch } : {},
		...sourceDataDirty ? { sourceData: buildICTeaserSourceDataPatch(values.sourceData) } : {},
		...nextSlides ? { slides: nextSlides } : {}
	};
}
/** What changed in the editor since the last committed (saved) snapshot. */
function diffICTeaserEditorSnapshots(current, committed) {
	const dirtyFieldKeys = ALL_TEASER_AI_KEYS.filter((key) => (current.values.fields[key] ?? "") !== (committed.values.fields[key] ?? ""));
	const sourceDataDirty = !isEqual(current.values.sourceData, committed.values.sourceData);
	const slidesDirty = !isEqual(current.slides, committed.slides) || !isEqual(current.values.footnotes, committed.values.footnotes) || !isEqual(current.values.subtitles, committed.values.subtitles) || !isEqual(current.values.placeholders, committed.values.placeholders);
	return {
		dirtyFieldKeys,
		sourceDataDirty,
		slidesDirty,
		isDirty: dirtyFieldKeys.length > 0 || sourceDataDirty || slidesDirty
	};
}
/**
* Copies the persisted subtitle / footnote of saved slides onto the editor slide list, keeping its order and
* inclusion. Subtitle persistence compares against the slide's stored value, so it must track the last save.
*/
function mergeSavedICTeaserSlideFields(slides, savedSlides) {
	const savedById = new Map(savedSlides.map((slide) => [getICTeaserSlideId(slide), slide]));
	return slides.map((slide) => {
		const saved = savedById.get(getICTeaserSlideId(slide));
		if (!saved || isICTeaserPlaceholderSlide(slide) || isICTeaserPlaceholderSlide(saved)) return slide;
		return {
			...slide,
			subtitle: saved.subtitle,
			footnote: saved.footnote
		};
	});
}
var AMOUNT_DECIMALS, RATE_DECIMALS, OCCUPANCY_DECIMALS;
var init_ic_teaser_editable = __esmMin((() => {
	init_ic_teaser_location();
	init_ic_teaser_model();
	init_ic_teaser_card_titles();
	init_ic_teaser_subtitles();
	AMOUNT_DECIMALS = 2;
	RATE_DECIMALS = 4;
	OCCUPANCY_DECIMALS = 2;
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/ic-teaser.energy-range.ts
function isEmptyRangeBound(value) {
	return value == null || value === "";
}
function renameRecordKeys(record, pairs) {
	let changed = false;
	for (const [from, to] of pairs) {
		if (!Object.hasOwn(record, from)) continue;
		if (!Object.hasOwn(record, to)) record[to] = record[from];
		delete record[from];
		changed = true;
	}
	return changed;
}
function prefillToFromFrom(record, pairs) {
	let changed = false;
	for (const [fromKey, toKey] of pairs) {
		const from = record[fromKey];
		if (isEmptyRangeBound(from) || !isEmptyRangeBound(record[toKey])) continue;
		record[toKey] = from;
		changed = true;
	}
	return changed;
}
function asRecord(value) {
	return isPlainObject(value) ? value : null;
}
/**
* Rename stored IC teaser energy range keys `…` / `…High` → `…From` / `…To`,
* then copy From into empty To so both bounds start equal.
* Mutates `teaser` in place. Idempotent when already migrated.
*/
function migrateICTeaserEnergyRangeFieldNames(teaser) {
	const document = asRecord(teaser);
	if (document == null) return false;
	const source = asRecord(document.sourceData);
	if (source == null) return false;
	let changed = false;
	const assetOverview = asRecord(source.assetOverview);
	if (assetOverview != null) {
		changed = renameRecordKeys(assetOverview, ASSET_OVERVIEW_ENERGY_RANGE_RENAMES) || changed;
		changed = prefillToFromFrom(assetOverview, ASSET_OVERVIEW_ENERGY_RANGE_TO_PREFILL) || changed;
	}
	const transformation = asRecord(source.transformation);
	if (transformation != null) {
		changed = renameRecordKeys(transformation, TRANSFORMATION_ENERGY_RANGE_RENAMES) || changed;
		changed = prefillToFromFrom(transformation, TRANSFORMATION_ENERGY_RANGE_TO_PREFILL) || changed;
	}
	return changed;
}
var ASSET_OVERVIEW_ENERGY_RANGE_RENAMES, TRANSFORMATION_ENERGY_RANGE_RENAMES, ASSET_OVERVIEW_ENERGY_RANGE_TO_PREFILL, TRANSFORMATION_ENERGY_RANGE_TO_PREFILL;
var init_ic_teaser_energy_range = __esmMin((() => {
	ASSET_OVERVIEW_ENERGY_RANGE_RENAMES = [
		["energyEfficiencyRatingPreTransformation", "energyEfficiencyRatingPreTransformationFrom"],
		["energyEfficiencyRatingPreTransformationHigh", "energyEfficiencyRatingPreTransformationTo"],
		["finalEnergyDemandPreTransformation", "finalEnergyDemandPreTransformationFrom"],
		["finalEnergyDemandPreTransformationHigh", "finalEnergyDemandPreTransformationTo"]
	];
	TRANSFORMATION_ENERGY_RANGE_RENAMES = [
		["energyEfficiencyRatingEntry", "energyEfficiencyRatingEntryFrom"],
		["energyEfficiencyRatingEntryHigh", "energyEfficiencyRatingEntryTo"],
		["finalEnergyDemandEntry", "finalEnergyDemandEntryFrom"],
		["finalEnergyDemandEntryHigh", "finalEnergyDemandEntryTo"]
	];
	ASSET_OVERVIEW_ENERGY_RANGE_TO_PREFILL = [["energyEfficiencyRatingPreTransformationFrom", "energyEfficiencyRatingPreTransformationTo"], ["finalEnergyDemandPreTransformationFrom", "finalEnergyDemandPreTransformationTo"]];
	TRANSFORMATION_ENERGY_RANGE_TO_PREFILL = [["energyEfficiencyRatingEntryFrom", "energyEfficiencyRatingEntryTo"], ["finalEnergyDemandEntryFrom", "finalEnergyDemandEntryTo"]];
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/ic-teaser.completeness.ts
function isEmptyTeaserString(value) {
	return value.replace(/<[^>]*>/g, " ").replace(/&nbsp;/gi, " ").trim() === "";
}
function isICTeaserValueMissing(value) {
	if (value == null) return true;
	if (typeof value === "string" && isEmptyTeaserString(value)) return true;
	if (Array.isArray(value)) {
		if (value.length === 0) return true;
		if (value.every((item) => item == null || isICTeaserMedia(item))) return value.every((item) => !isICTeaserMedia(item) || isICTeaserValueMissing(item.url));
	}
	return false;
}
function storedCatalogSlideSubtitle(slideKey, slides) {
	const slide = slides?.find((candidate) => candidate.key === slideKey);
	if (slide == null || isICTeaserPlaceholderSlide(slide)) return "";
	return getICTeaserSlideSubtitle(slide);
}
/** Subtitle AI keys are edited via `slide.subtitle`; stored overwrite or generated text both count. */
function isICTeaserSlideSubtitleMissing(slideKey, key, input) {
	if (!isICTeaserValueMissing(storedCatalogSlideSubtitle(slideKey, input.slides))) return false;
	return isICTeaserValueMissing(input.generated[key]);
}
function slideHasMissingICTeaserData(slideKey, input) {
	for (const key of IC_TEASER_SLIDE_AI_KEYS[slideKey]) {
		if (isICTeaserSlideSubtitleAiKey(key)) {
			if (isICTeaserSlideSubtitleMissing(slideKey, key, input)) return true;
			continue;
		}
		if (isICTeaserValueMissing(input.generated[key])) return true;
	}
	for (const path of IC_TEASER_SLIDE_SOURCE_FIELDS[slideKey]) if (isICTeaserValueMissing(get(input.sourceData, path))) return true;
	return false;
}
function getMissingICTeaserSlideKeys(input) {
	const missing = /* @__PURE__ */ new Set();
	for (const slideKey of Object.keys(IC_TEASER_SLIDE_SOURCE_FIELDS)) if (slideHasMissingICTeaserData(slideKey, input)) missing.add(slideKey);
	return missing;
}
function buildICTeaserCompletenessInputFromDocument(teaser) {
	return {
		sourceData: teaser.sourceData,
		generated: teaser.generated,
		slides: teaser.slides
	};
}
var init_ic_teaser_completeness = __esmMin((() => {
	init_ic_teaser_fields();
	init_ic_teaser_model();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/ic-teaser.drift.ts
/** Editable vs live: deep equal; media by mediaFileId only (signed URLs rotate); numbers by a few ULPs. */
function isICTeaserEditableValueDrifted(current, live) {
	return !isEqualWith(current, live, (left, right) => {
		if (left == null && right == null) return true;
		if (isICTeaserMedia(left) || isICTeaserMedia(right)) {
			if (!isICTeaserMedia(left) || !isICTeaserMedia(right)) return false;
			return left.mediaFileId === right.mediaFileId;
		}
		if (typeof left === "number" && typeof right === "number") return areTeaserNumbersEqual(left, right);
		const leftDate = toComparableIsoDate(left);
		const rightDate = toComparableIsoDate(right);
		if (leftDate != null && rightDate != null) return leftDate === rightDate;
		if (isPlainObject(left) && isPlainObject(right)) {
			const leftRecord = omit(left, FORM_ARRAY_KEY);
			const rightRecord = omit(right, FORM_ARRAY_KEY);
			if (FORM_ARRAY_KEY in left || FORM_ARRAY_KEY in right) return !isICTeaserEditableValueDrifted(leftRecord, rightRecord);
		}
	});
}
function toComparableIsoDate(value) {
	if (value instanceof Date) {
		if (Number.isNaN(value.getTime())) return null;
		return value.toISOString().slice(0, 10);
	}
	if (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}/.test(value)) return null;
	return value.slice(0, 10);
}
function areTeaserNumbersEqual(left, right) {
	if (Object.is(left, right)) return true;
	if (!Number.isFinite(left) || !Number.isFinite(right)) return false;
	const scale = Math.max(Math.abs(left), Math.abs(right), 1);
	return Math.abs(left - right) <= scale * Number.EPSILON * 32;
}
function toICTeaserEditablePath(formName) {
	return formName.startsWith(SOURCE_DATA_PREFIX) ? formName.slice(11) : formName;
}
function getICTeaserLiveEditableValue(liveEditable, formName) {
	return get(liveEditable, toICTeaserEditablePath(formName));
}
function isICTeaserEditablePathLiveSourceSyncEnabled(formName) {
	const root = toICTeaserEditablePath(formName).split(".")[0];
	if (!root) return true;
	return !getICTeaserLiveSourceSyncExcludedRoots().includes(root);
}
function withCurrentPresentationValues(next, current) {
	const merged = cloneDeep(next);
	for (const path of IC_TEASER_PRESENTATION_PATHS) set(merged, path, get(current, path));
	return merged;
}
/** Live media carries no crop; keep the current crop wherever the live value is the same media file. */
function preserveICTeaserMediaCrops(live, current) {
	if (isICTeaserMedia(live)) return isICTeaserMedia(current) && current.mediaFileId === live.mediaFileId && current.crop ? {
		...live,
		crop: current.crop
	} : live;
	if (Array.isArray(live)) return live.map((item, index) => preserveICTeaserMediaCrops(item, Array.isArray(current) ? current[index] : void 0));
	if (isPlainObject(live) && isPlainObject(current)) return mapValues(live, (value, key) => preserveICTeaserMediaCrops(value, current[key]));
	return live;
}
/**
* Applies live source onto the current editable snapshot, preserving roots for slides with live sync disabled,
* presentation settings and image crops of unchanged media.
*/
function mergeICTeaserLiveEditableSync(current, live) {
	const next = withCurrentPresentationValues(preserveICTeaserMediaCrops({ ...live }, current), current);
	for (const root of getICTeaserLiveSourceSyncExcludedRoots()) next[root] = current[root];
	if (isICTeaserSlideLiveSourceSyncEnabled("locationRentComparatives")) next.rentAnalysis = {
		...live.rentAnalysis,
		selectedListingIds: normalizeICTeaserSelectedListingIds(live.rentAnalysis.analysis?.listings ?? [], current.rentAnalysis.selectedListingIds)
	};
	return next;
}
function countICTeaserEditableDrifts(current, live) {
	const currentSynced = mergeICTeaserLiveEditableSync(current, current);
	const liveSynced = mergeICTeaserLiveEditableSync(current, live);
	if (!isICTeaserEditableValueDrifted(currentSynced, liveSynced)) return 0;
	return countDriftedLeaves(currentSynced, liveSynced);
}
function toICTeaserEditableDriftPath(path) {
	return path.endsWith(".url") ? path.slice(0, -4) : path;
}
function getDriftedICTeaserSlideKeys(current, live) {
	const drifted = /* @__PURE__ */ new Set();
	for (const slideKey of Object.keys(IC_TEASER_SLIDE_SOURCE_FIELDS)) {
		const roots = getICTeaserSlideEditableSourceRoots(slideKey);
		if (roots.length === 0) continue;
		for (const path of IC_TEASER_SLIDE_SOURCE_FIELDS[slideKey]) {
			const driftPath = toICTeaserEditableDriftPath(path);
			const root = driftPath.split(".")[0];
			if (!root || !roots.includes(root)) continue;
			if (isICTeaserEditableValueDrifted(get(current, driftPath), get(live, driftPath))) {
				drifted.add(slideKey);
				break;
			}
		}
	}
	return drifted;
}
function countDriftedLeaves(current, live) {
	if (isICTeaserMedia(current) || isICTeaserMedia(live) || Array.isArray(current) || Array.isArray(live) || !isPlainObject(current) || !isPlainObject(live)) return isICTeaserEditableValueDrifted(current, live) ? 1 : 0;
	const currentRecord = current;
	const liveRecord = live;
	const keys = /* @__PURE__ */ new Set([...Object.keys(currentRecord), ...Object.keys(liveRecord)]);
	let total = 0;
	for (const key of keys) total += countDriftedLeaves(currentRecord[key], liveRecord[key]);
	return total;
}
var SOURCE_DATA_PREFIX, FORM_ARRAY_KEY, IC_TEASER_PRESENTATION_PATHS;
var init_ic_teaser_drift = __esmMin((() => {
	init_ic_teaser_fields();
	init_ic_teaser_model();
	init_ic_teaser_rent();
	SOURCE_DATA_PREFIX = "sourceData.";
	FORM_ARRAY_KEY = "fieldId";
	IC_TEASER_PRESENTATION_PATHS = [
		"assetOverview.germanyMapZoom",
		"assetOverview.cityMapZoom",
		"location.mapZoom",
		"executiveSummary.additionalBoxes",
		"financing.hiddenTableSections",
		"transformation.cardTitles",
		"subsidies.kfw261.note",
		"subsidies.bafa.note",
		"subsidies.ifb.note",
		"subsidies.dus.note",
		"subsidies.fkg.note"
	];
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/ic-teaser/index.ts
var init_ic_teaser = __esmMin((() => {
	init_data();
	init_ic_teaser_model();
	init_ic_teaser_copy_budget();
	init_ic_teaser_document();
	init_ic_teaser_source();
	init_ic_teaser_location();
	init_ic_teaser_rent();
	init_ic_teaser_kpis();
	init_ic_teaser_editable();
	init_ic_teaser_fields();
	init_ic_teaser_energy_range();
	init_ic_teaser_completeness();
	init_ic_teaser_drift();
	init_ic_teaser_subtitles();
	init_ic_teaser_formatters();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/finance/mfh-investment-case-json-transfer.model.ts
/**
* Build the admin/debug clipboard payload for investment-case (+ optional rent roll) round-trip.
* Sheet / read-copy identifiers are never included.
*/
function buildInvestmentCaseJsonTransferPayload(investmentCase, rentRollVersion) {
	if (investmentCase.assetPartnerId == null) throw new InvalidParamsError("Investment case is missing assetPartnerId");
	if (investmentCase.assetPartnerProfileId == null) throw new InvalidParamsError("Investment case is missing assetPartnerProfileId");
	const d2gVersionId = investmentCase.d2gVersionId ?? investmentCase.d2gVersionInfo?.d2gVersionId;
	if (d2gVersionId == null) throw new InvalidParamsError("Investment case is missing d2gVersionId");
	if (investmentCase.d2gVersion == null || investmentCase.d2gVersion.length === 0) throw new InvalidParamsError("Investment case is missing d2gVersion");
	const rootCaseInputs = {
		...investmentCase.caseInputs?.$root ?? {},
		rentRollVersionId: rentRollVersion?.rentRollVersionId ?? null
	};
	const payload = { investmentCase: {
		name: investmentCase.name,
		d2gVersion: investmentCase.d2gVersion,
		d2gVersionId,
		assetPartnerId: investmentCase.assetPartnerId,
		assetPartnerProfileId: investmentCase.assetPartnerProfileId,
		caseInputs: {
			...investmentCase.caseInputs ?? {},
			$root: rootCaseInputs
		}
	} };
	if (rentRollVersion?.rentRolls?.length) payload.rentRollVersion = {
		name: rentRollVersion.name,
		rentRolls: rentRollVersion.rentRolls.map(toTransferRentRollRow)
	};
	return sanitizeInvestmentCaseJsonTransferPayload(payload);
}
/**
* Strip sheet / read-copy identity fields from a transfer payload before paste/import.
* Tolerates hand-edited JSON that may include extra IC fields.
*/
function sanitizeInvestmentCaseJsonTransferPayload(payload) {
	const rawIc = payload.investmentCase;
	const cleanedIc = omit(rawIc, [...SHEET_IDENTITY_KEYS]);
	if (cleanedIc.meta != null && typeof cleanedIc.meta === "object") {
		const nextMeta = omit(cleanedIc.meta, "readCopySync");
		if (Object.keys(nextMeta).length === 0) delete cleanedIc.meta;
		else cleanedIc.meta = nextMeta;
	}
	return {
		investmentCase: {
			name: cleanedIc.name,
			d2gVersion: cleanedIc.d2gVersion,
			d2gVersionId: cleanedIc.d2gVersionId,
			assetPartnerId: cleanedIc.assetPartnerId,
			assetPartnerProfileId: cleanedIc.assetPartnerProfileId,
			caseInputs: cleanedIc.caseInputs
		},
		...payload.rentRollVersion != null ? { rentRollVersion: payload.rentRollVersion } : {}
	};
}
function toTransferRentRollRow(row) {
	return omit(row, RENT_ROLL_OMIT_KEYS);
}
var SHEET_IDENTITY_KEYS, RENT_ROLL_OMIT_KEYS;
var init_mfh_investment_case_json_transfer_model = __esmMin((() => {
	init_errors();
	SHEET_IDENTITY_KEYS = [
		"readCopySheetId",
		"readCopySheetInfo",
		"selfSheetId",
		"sheetInfo",
		"publishId",
		"referenceD2gSheetId"
	];
	RENT_ROLL_OMIT_KEYS = [
		"rentRollId",
		"rentRollVersionId",
		"createdAt",
		"updatedAt",
		"mfhBuilding",
		"rentRollVersion"
	];
}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh-prediction.model.ts
var init_mfh_prediction_model = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh.openkm.ts
var MFH_OPENKM_DROOM_CONFIG;
var init_mfh_openkm = __esmMin((() => {
	init_document();
	MFH_OPENKM_DROOM_CONFIG = [{
		level: 1,
		label: "Liegenschaftsbezogene Unterlagen",
		children: [
			{
				level: 1,
				label: "Einleitung",
				children: [{
					level: 1,
					label: "Objektbeschreibung (z.B. Exposés, Prospekte, Fotos, Standortinformationen)",
					documentTypes: ["MfhExpose"]
				}]
			},
			{
				level: 2,
				label: "Grundstück",
				children: [
					{
						level: 1,
						label: "Flurkarte-Kataster-amtlicher Lageplan",
						documentTypes: ["DeclarationOfDivisionIfDivided"]
					},
					{
						level: 2,
						label: "Überbauungen",
						documentTypes: ["SuperStructures"]
					},
					{
						level: 3,
						label: "Umwelt (z.B. Altlasten, Kampfmittel, Gebäudeschadstoffe)",
						documentTypes: ["ExtractContaminatedSitesRegister", "VerificationOfExplosiveOrdnance"]
					},
					{
						level: 4,
						label: "Gründungs-Baugrundgutachten",
						documentTypes: ["FoundationReport"]
					},
					{
						level: 5,
						label: "Bodenrichtwertkarte",
						documentTypes: ["LandValueMap"]
					}
				]
			},
			{
				level: 3,
				label: "Eigentum",
				children: [
					{
						level: 1,
						label: "Handelsregisterauszug des eingetragenen Eigentümers",
						documentTypes: ["CommercialOwnerRegisterExtract"]
					},
					{
						level: 2,
						label: "Grundbuchauszug",
						documentTypes: ["CurrentLandRegisterExtract"]
					},
					{
						level: 3,
						label: "Erbbaurechtsverträge",
						documentTypes: ["EncumbranceBasisInDeptII", "GroundLease"]
					},
					{
						level: 4,
						label: "Nachbarschaftsverträge",
						documentTypes: ["NeighbourhoodAgreements"]
					}
				]
			},
			{
				level: 4,
				label: "Bauplanungsrecht",
				children: [
					{
						level: 1,
						label: "Flächennutzungsplan",
						documentTypes: ["LandUsePlan"]
					},
					{
						level: 2,
						label: "Bebauungsplan",
						documentTypes: ["CurrentPlanningRights"]
					},
					{
						level: 3,
						label: "Denkmalschutz (z.B. Eintragung in Denkmalliste, Bescheide, Auflagen)",
						documentTypes: ["InformationMonumentProtection"]
					},
					{
						level: 4,
						label: "Erschließung",
						documentTypes: ["ExtractDevelopmentAndExpansionContributions"]
					},
					{
						level: 5,
						label: "Städtebauliche Verträge",
						documentTypes: ["InformationUrbanConservationArea"]
					},
					{
						level: 6,
						label: "Umlegungs-, Sanierungs- oder Entwicklungsgebiet-Erhaltungssatzung",
						documentTypes: ["InformationUrbanRenewalArea", "SocialPreservationOrdinance"]
					},
					{
						level: 7,
						label: "Behördliche Bescheinigungen (z.B. Grenzberichtigungen, Enteignungen)",
						documentTypes: ["OfficialCertificates"]
					}
				]
			},
			{
				level: 5,
				label: "Bauordnungsrecht",
				children: [{
					level: 1,
					label: "Baugenehmigungsunterlagen",
					documentTypes: ["BuildingApplicationOrBuildingPermit"]
				}, {
					level: 2,
					label: "Andere Genehmigungen (z.B. Denkmalschutz-, Naturschutz-, Wasserrecht-, Betriebsgenehmigung)",
					documentTypes: ["OtherPermits"]
				}]
			},
			{
				level: 6,
				label: "Gebäude (Bewirtschaftung technisch)",
				documentTypes: ["BuildingInventoryPlans"],
				children: [
					{
						level: 1,
						label: "Bestandspläne",
						children: [
							{
								level: 1,
								label: "Grundriss",
								documentTypes: ["FloorPlansIncludingAreaCalculation"]
							},
							{
								level: 2,
								label: "Ansichten",
								documentTypes: ["SectionDrawingsBuildingElevations"]
							},
							{
								level: 3,
								label: "Schnitte",
								documentTypes: ["BuildingSections"]
							},
							{
								level: 4,
								label: "Statik",
								documentTypes: ["BuildingStatics"]
							},
							{
								level: 5,
								label: "Heizung",
								documentTypes: ["BuildingHeating"]
							},
							{
								level: 6,
								label: "Lüftung",
								documentTypes: ["BuildingVentilation"]
							},
							{
								level: 7,
								label: "Klima",
								documentTypes: ["BuildingAirConditioning"]
							},
							{
								level: 8,
								label: "Sanitär",
								documentTypes: ["BuildingSanitary"]
							},
							{
								level: 9,
								label: "Elektro",
								documentTypes: ["BuildingElectrical"]
							}
						]
					},
					{
						level: 2,
						label: "Flächenaufmaß",
						documentTypes: ["FloorPlansIncludingAreaCalculation"]
					},
					{
						level: 3,
						label: "Baubeschreibung",
						documentTypes: ["SectionDrawingsBuildingElevations"]
					},
					{
						level: 4,
						label: "Gebäude-Bauzustandsanalyse",
						documentTypes: ["BuildingApplicationOrBuildingPermit"]
					},
					{
						level: 5,
						label: "Brandschutz (z.B. Konzept, Brandschauprotokolle)",
						documentTypes: ["FireProtection"]
					},
					{
						level: 6,
						label: "Fachplaner Verträge (z.B. Architekten)",
						documentTypes: ["SpecialistPlannerContracts"]
					},
					{
						level: 7,
						label: "Bauerrichtung",
						documentTypes: ["OverviewOfPastOngoingAndPlannedModernization"],
						children: [
							{
								level: 1,
								label: "Gewährleistungsspiegel",
								documentTypes: ["WarrantyGuarantees"]
							},
							{
								level: 2,
								label: "Gewerk",
								documentTypes: ["ListOfCraftsmen"]
							},
							{
								level: 3,
								label: "Wartungsprotokolle, Revisionsunterlagen, Bedienungsanleitungen",
								documentTypes: ["MaintenanceProtocols"]
							},
							{
								level: 4,
								label: "Nachhaltigkeit (inkl. Energieausweise)",
								documentTypes: ["BuildingEnergyCertificate"]
							}
						]
					}
				]
			},
			{
				level: 7,
				label: "Mieter",
				children: [
					{
						level: 1,
						label: "Übersicht Mietverhältnisse - Nutzungsverhältnisse",
						documentTypes: ["TenantList"]
					},
					{
						level: 2,
						label: "Mietverträge (inkl. aller Nachträge)",
						documentTypes: ["RentalAgreements"]
					},
					{
						level: 3,
						label: "Mietsicherheiten",
						documentTypes: ["ListOfExistingRentalDeposits"]
					},
					{
						level: 4,
						label: "Mietrückstände",
						documentTypes: ["ListOfCurrentDefectComplaintsReductionsArrears"]
					},
					{
						level: 5,
						label: "Übergabeprotokolle",
						documentTypes: ["TenantHandoverProtocols"]
					},
					{
						level: 6,
						label: "Mietanpassungen-Dauermietrechnung",
						documentTypes: ["RentIncreaseLetters"]
					},
					{
						level: 7,
						label: "Kündigungen",
						documentTypes: ["Terminations"]
					},
					{
						level: 8,
						label: "Nebenkostenabrechnung",
						documentTypes: ["AdditionalCostsInvoice"]
					},
					{
						level: 9,
						label: "Wichtiger Schriftverkehr",
						documentTypes: ["ImportantCorrespondence"]
					}
				]
			},
			{
				level: 8,
				label: "Bewirtschaftung (kaufmännisch)",
				children: [
					{
						level: 1,
						label: "Bewirtschaftungsverträge (z.B. Hausverwaltervertrag, Facility Management, Contracting)",
						documentTypes: ["ManagementContracts"]
					},
					{
						level: 2,
						label: "Versicherungsnachweise (z.B. Police, Verträge)",
						documentTypes: ["InsurancesMainlyCurrentBuildingInsurance", "InsuranceClaimsLast5Years"]
					},
					{
						level: 3,
						label: "Betriebskostenaufstellung",
						documentTypes: ["OperatingCostStatement"]
					}
				]
			},
			{
				level: 9,
				label: "Steuern",
				children: [
					{
						level: 1,
						label: "Grundsteuerbescheide-Grundbesitzabgabenbescheide",
						documentTypes: ["PropertyTaxAssessmentAndUnitValueNotice"]
					},
					{
						level: 2,
						label: "Einheitswertbescheide-Einheitswerterklärungen",
						documentTypes: ["TaxAssessmentNotices"]
					},
					{
						level: 3,
						label: "Sonstige Kommunalabgaben (z.B. Sanierungsausgleichbeträge, Sondernutzungsgebühren, Anliegerbeiträge)",
						documentTypes: ["TaxOtherMunicipalCharges"]
					},
					{
						level: 4,
						label: "Berichtigungsbestände und laufende Berichtigungszeiträume",
						documentTypes: ["TaxCorrectionBalancesAndPeriods"]
					},
					{
						level: 5,
						label: "Umsatzsteuer",
						children: [{
							level: 1,
							label: "Mieter",
							documentTypes: ["TaxValueAddTenants"]
						}, {
							level: 2,
							label: "Verkäufer",
							documentTypes: ["TaxValueAddSellers"]
						}]
					},
					{
						level: 6,
						label: "Optionssätze-Flächenschlüssel",
						documentTypes: ["TaxOptionRatesAndAreaKeys"]
					}
				]
			},
			{
				level: 10,
				label: "Rechtsstreitigkeiten",
				documentTypes: [
					"OngoingLegalDisputesRegardingProperty",
					"OngoingLegalDisputesRegardingObject",
					"OngoingLegalDisputesWithTenants"
				],
				children: [
					{
						level: 1,
						label: "Objektbezogene Arbeitsverträge",
						documentTypes: ["ListOfCraftsmen"]
					},
					{
						level: 2,
						label: "Zusatzinformationen für Spezialimmobilien (z.B. Einzelhandel, Wohnen, Logistik, Hotel)",
						documentTypes: ["SpecialRealEstateAdditionalInformation"]
					},
					{
						level: 2,
						label: "Sonstige Dokumente - Verträge - Vereinbarungen",
						documentTypes: ["BuildingAdditonalInformation"]
					}
				]
			}
		]
	}, {
		level: 2,
		label: "Gesellschaftsbezogen Unterlagen",
		children: [
			{
				level: 1,
				label: "Gesellschaft",
				children: [
					{
						level: 1,
						label: "Übersicht",
						documentTypes: ["CompanyOverview"]
					},
					{
						level: 2,
						label: "Handelsregisterauszug",
						documentTypes: ["CommercialRegisterExtract"]
					},
					{
						level: 3,
						label: "Übertragung von Gesellschaftsanteilen",
						documentTypes: ["TransferOfShares"]
					},
					{
						level: 4,
						label: "Registerauszüge-Anmeldungen",
						documentTypes: ["RegisterExcerpts"]
					},
					{
						level: 5,
						label: "Aktienbuch",
						documentTypes: ["ShareRegister"]
					},
					{
						level: 6,
						label: "Gesellschafterliste",
						documentTypes: ["ListOfShareholders"]
					}
				]
			},
			{
				level: 2,
				label: "Satzung",
				children: [{
					level: 1,
					label: "Satzung",
					documentTypes: ["ArticlesOfAssociation"]
				}, {
					level: 2,
					label: "satzungsändernde Beschlüsse",
					documentTypes: ["ArticlesOfAssociationResolutionAmmendments"]
				}]
			},
			{
				level: 3,
				label: "Gesellschafterbeschlüsse",
				children: [
					{
						level: 1,
						label: "Beschlüsse betreffend die Satzung",
						documentTypes: ["ArticlesOfAssociationResolutions"]
					},
					{
						level: 2,
						label: "Gewinnverteilungsbeschlüsse",
						documentTypes: ["DistributionOfProfitsResolutions"]
					},
					{
						level: 3,
						label: "Kapitalausstattungsbeschlüsse",
						documentTypes: ["CapitalEndowmentResolutions"]
					},
					{
						level: 4,
						label: "Sonstige Beschlüsse",
						documentTypes: ["OtherResolutions"]
					}
				]
			},
			{
				level: 4,
				label: "Geschäftsführung",
				children: [
					{
						level: 1,
						label: "Geschäftsführerbeschlüsse",
						documentTypes: ["ManagingDirectorResolutions"]
					},
					{
						level: 2,
						label: "Protokolle",
						documentTypes: ["Minutes"]
					},
					{
						level: 3,
						label: "Vereinbarungen mit der Geschäftsführung",
						documentTypes: ["AgreementsWithManagement"]
					}
				]
			},
			{
				level: 5,
				label: "Gesellschaftsbezogene Verträge",
				children: [
					{
						level: 1,
						label: "Buchhaltung",
						documentTypes: ["CompanyAccountant"]
					},
					{
						level: 2,
						label: "Wirtschaftsprüfer",
						documentTypes: ["CompanyAuditor"]
					},
					{
						level: 3,
						label: "Steuerberater",
						documentTypes: ["CompanyTaxConsultant"]
					},
					{
						level: 4,
						label: "Sonstige Verträge",
						documentTypes: ["CompanyOtherContracts"]
					}
				]
			},
			{
				level: 6,
				label: "Grundstückskaufvertrag (Ankauf) (z.B. Dahrlehensvertrag, Grundschuldbestellungsurkunde, Sicherungszweckerklärung, Abtretungserklärung, Verpfändungen, Kündigungsdokumente)",
				documentTypes: [
					"LoanAgreement",
					"LandChargeDeed",
					"DeclarationOfSecurityPurpose",
					"DeclarationOfAssignment",
					"Pledges",
					"PurchasingTerminationDocuments"
				]
			},
			{
				level: 7,
				label: "Finanzen",
				children: [
					{
						level: 1,
						label: "Jahresabschlüsse",
						documentTypes: ["FinancialAnnualStatements"]
					},
					{
						level: 2,
						label: "Steuern",
						documentTypes: ["FinancialTaxes"]
					},
					{
						level: 3,
						label: "Management Reporting",
						documentTypes: ["FinancialManagementReporting"]
					},
					{
						level: 4,
						label: "Verbindlichkeiten (inkl. off-balance)",
						documentTypes: ["FinancialLiabilities"]
					},
					{
						level: 5,
						label: "Aktuelle Salden",
						documentTypes: ["FinancialCurrentBalances"]
					},
					{
						level: 6,
						label: "Sonstige Finanzinformationen",
						documentTypes: ["FinancialOtherInformation"]
					}
				]
			}
		]
	}];
}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh-uuid.helpers.ts
var generateMfhPortfolioUuid, generateMfhUuid, generateMfhBuildingUuid, generateMfhEstateUuid;
var init_mfh_uuid_helpers = __esmMin((() => {
	init_mfh();
	init_errors();
	init_review_process();
	generateMfhPortfolioUuid = (mfhPortfolio, nextSeqNumber) => {
		if (!mfhPortfolio.reviewProcess) throw new InvariantError("No review process found, impossible to generate UUID for MFH Transaction");
		if (!new ReviewProcess(mfhPortfolio.reviewProcess).hasEnoughApprovals()) throw new InvariantError("The MFH Transaction needs approved review to generate a UUID");
		const approvedReviewRequests = mfhPortfolio.reviewProcess?.reviewsRequests?.filter?.((r) => r.reviewRequestState === "Approved");
		const approvalDate = maxBy(approvedReviewRequests, (reviewRequest) => reviewRequest.reviewDate ? new Date(reviewRequest.reviewDate).getTime() : -1)?.reviewDate;
		if (!approvalDate) throw new InvariantError(`Couldn't find approval date for MFH Portfolio to generate a UUID`);
		return `TR${dayjs(approvalDate).format("YY")}_${String(nextSeqNumber).padStart(3, "0")}`;
	};
	generateMfhUuid = (mfh, nextSeqNumber) => {
		if (!mfh.candidateLocation?.region?.shortName) throw new InvariantError("Need to have region associated to a given mfh");
		if (!mfh.sourcing?.createdAt) throw new InvariantError("Need to have sourcing process associated to given mfh");
		return `${mfh.candidateLocation.region?.shortName}${dayjs(mfh.sourcing?.createdAt ?? /* @__PURE__ */ new Date()).format("YY")}_${nextSeqNumber}`;
	};
	generateMfhBuildingUuid = (location, mfhUuid) => {
		if (!location?.street || !location?.houseNumber) throw new InvariantError("Need to have location with street and house number to generate a building UUID");
		const locationAbbreviation = createAbbreviation(location.street, location.houseNumber);
		return mfhUuid ? `${mfhUuid}-${locationAbbreviation}` : locationAbbreviation;
	};
	generateMfhEstateUuid = (mfhBuildingUuid, nextSeqNumber) => {
		return `${mfhBuildingUuid}-${String(nextSeqNumber).padStart(2, "0")}`;
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/summary/mfh-summary.i18n.ts
function normalizeSummaryOptions(optionsOrTranslation) {
	return typeof optionsOrTranslation === "function" ? { t: optionsOrTranslation } : optionsOrTranslation ?? {};
}
function formatSummaryNumerical(value, type, options, fallback) {
	return options.formatNumerical ? options.formatNumerical(value, type) : fallback(value);
}
function formatSummaryLink(content, href, options) {
	if (!href) return content;
	return options.formatLink ? options.formatLink(content, href) : typeof content === "string" ? tableAnchorLink(content, href) : content;
}
var MFH_SUMMARY_LABELS, mfhSummaryLabel, hasTabularRowValues, formatMFHSummaryTabularData, formatMFHSummaryCardData, formatMFHSummaryData;
var init_mfh_summary_i18n = __esmMin((() => {
	init_lib();
	MFH_SUMMARY_LABELS = {
		aic: "(-) AIC",
		aicExclFinancing: "(=) AIC (excl. Financing)",
		breakDownEuro: "Break Down in €",
		breakdownEuro: "Breakdown in €",
		capRateNoiNpp: "Cap Rate (NOI/NPP)",
		capexEe: "Capex EE",
		capexEeCapexExpansion: "Capex (EE, Capex, Expansion)",
		capexEnergyEfficiency: "(+) CAPEX Energy Efficiency",
		capexExpansion: "Capex Expansion",
		capexGeneral: "Capex General",
		capitalExpenditures: "(+) Capital Expenditures",
		cashCollectedNoi: "Cash Collected (NOI)",
		churn: "Churn",
		civilCodeRentalIncreaseExistingTenants1: "Civil Code - Rental Increase of existing tenants No. 1",
		civilCodeRentalIncreaseExistingTenants2: "Civil Code - Rental Increase of existing tenants No. 2",
		closingCostsExclFinancing: "Closing Costs (excl. Financing)",
		commercial: "Commercial",
		dealLevelReturns: "Deal Level Returns",
		debtCapexSubsidizedInclGrant: "Debt: Capex Subsidized (incl. Grant)",
		debtCapexTiNonSubsidized: "Debt: Capex & TI Non-Subsidized",
		debtSenior: "Debt: Senior",
		delta: "Delta",
		entry: "<i class=\"fa-solid fa-arrow-right-to-bracket\"></i> Entry",
		entryMarketRentPsmMonthly: "<i class=\"fa-solid fa-arrow-right-to-bracket\"></i> Entry Market Rent/m² p.m",
		entryNriYearly: "<i class=\"fa-solid fa-arrow-right-to-bracket\"></i> Entry NRI p.a",
		entryOccupancy: "<i class=\"fa-solid fa-arrow-right-to-bracket\"></i> Entry Occup.",
		entryPsm: "<i class=\"fa-solid fa-arrow-right-to-bracket\"></i> Entry €/m²",
		entryTotal: "<i class=\"fa-solid fa-arrow-right-to-bracket\"></i> Entry Total",
		equity: "Equity:",
		euro: "Euro",
		exit: "<i class=\"fa-solid fa-arrow-right-from-bracket\"></i> Exit",
		exitM2: "<i class=\"fa-solid fa-arrow-right-from-bracket\"></i> /m² Exit",
		exitNriYearly: "<i class=\"fa-solid fa-arrow-right-from-bracket\"></i> Exit NRI p.a",
		exitOccupancy: "<i class=\"fa-solid fa-arrow-right-from-bracket\"></i> Exit Occup.",
		exitPsm: "<i class=\"fa-solid fa-arrow-right-from-bracket\"></i> Exit €/m²",
		exitTotal: "<i class=\"fa-solid fa-arrow-right-from-bracket\"></i> Exit Total",
		financingCosts: "Financing Costs",
		gppVsNetDisposalProceeds: "GPP vs. Net Disposal Proceeds",
		grossPriceNextBuyerView: "Gross Price (Next Buyer View)",
		grossProfit: "(=) Gross Profit",
		grossPurchasePrice: "(=) Gross Purchase Price",
		irr: "IRR",
		leasingCommissionTenantCompensations: "(+) Leasing Commission & Tenant Compensations",
		marketRentGrowth: "Market Rent Growth",
		metric: "Metric",
		m2Entry: "<i class=\"fa-solid fa-arrow-right-to-bracket\"></i> /m² Entry",
		m2Exit: "<i class=\"fa-solid fa-arrow-right-from-bracket\"></i> /m² Exit",
		moC: "MoC",
		netDisposalProceeds: "Net Disposal Proceeds",
		netPricePsm: "Net Price psm",
		netPurchasePrice: "Net Purchase Price",
		netYieldNoiGpp: "Net Yield (NOI/GPP)",
		newLeaseIndexation: "New Lease Indexation",
		nla: "NLA",
		noiCollected: "(+) NOI Collected",
		noiYearly: "NOI p.a.",
		nppVsGrossDisposalPrice: "NPP vs Gross Disposal Price",
		nriLeakage: "NRI Leakage",
		nriMonthlyPsm: "NRI p.m. psm",
		nriMultiple: "NRI Multiple",
		nriYield: "NRI Yield",
		nriYearly: "NRI p.a.",
		nriYearlyExclVacancyRent: "NRI p.a. excl. vacancy rent",
		nriYearlyInclVacancyRent: "NRI p.a. incl. vacancy rent",
		parking: "Parking",
		partnerFees: "(+) Partner Fees",
		partnerFeesPlain: "Partner Fees",
		percent: "Percent",
		postTaxLevered: "Post-Tax Levered",
		postTaxPostPromote: "Post-Tax, Post-Promote",
		preTaxLevered: "Pre-Tax Levered",
		preTaxUnlevered: "Pre-Tax Unlevered",
		profit: "Profit",
		rentGrowth: "Rent Growth",
		rentIndexInflation: "Rent Index Inflation",
		resiAdditional: "Resi Additional",
		resiExisting: "Resi Existing",
		sources: "Sources",
		subtotal: "Subtotal",
		tenantImprovements: "(+) Tenant Improvements",
		tisLcsTenantCompensations: "TIs & LCs, Tenant Compensations",
		total: "Total",
		tradingProfit: "(=) Trading Profit",
		transactionCosts: "(+) Transaction Costs",
		useType: "Use type",
		uses: "Uses",
		vat: "VAT",
		vatLoss: "(+) VAT Loss",
		vacancy: "Vacancy",
		vacancySqm: "Vacancy in sqm"
	};
	mfhSummaryLabel = (key, t) => t?.(`investmentCase.results.summary.${key}`) ?? MFH_SUMMARY_LABELS[key];
	hasTabularRowValues = (row) => Boolean(row && Object.values(row).some((value) => value != null));
	formatMFHSummaryTabularData = {
		netDisposalProceeds: (result, t) => ({
			rows: result ? [
				{
					metric: mfhSummaryLabel("netDisposalProceeds", t),
					...fromTabularData(result, "netDisposalProceeds", {
						allowedKeys: ["total", "m2Exit"],
						formatter: {
							total: tableCellFormatter.currency,
							m2Exit: tableCellFormatter.currency
						}
					})
				},
				{
					metric: mfhSummaryLabel("aic", t),
					...fromTabularData(result, "AIC", {
						allowedKeys: ["total", "m2Exit"],
						formatter: {
							total: tableCellFormatter.currency,
							m2Exit: tableCellFormatter.currency
						}
					})
				},
				{
					metric: mfhSummaryLabel("tradingProfit", t),
					...fromTabularData(result, "tradingProfit", {
						allowedKeys: ["total", "m2Exit"],
						formatter: {
							total: tableCellFormatter.currency,
							m2Exit: tableCellFormatter.currency
						}
					})
				},
				{
					metric: mfhSummaryLabel("noiCollected", t),
					...fromTabularData(result, "NOICollected", {
						allowedKeys: ["total", "m2Exit"],
						formatter: {
							total: tableCellFormatter.currency,
							m2Exit: tableCellFormatter.currency
						}
					})
				},
				{
					metric: mfhSummaryLabel("grossProfit", t),
					...fromTabularData(result, "grossProfit", {
						allowedKeys: ["total", "m2Exit"],
						formatter: {
							total: tableCellFormatter.currency,
							m2Exit: tableCellFormatter.currency
						}
					})
				}
			] : [],
			headers: {
				metric: mfhSummaryLabel("breakDownEuro", t),
				total: mfhSummaryLabel("total", t),
				m2Exit: mfhSummaryLabel("exitM2", t)
			}
		}),
		valueBridge: (result, t) => ({
			rows: result ? [
				{
					metric: mfhSummaryLabel("netPurchasePrice", t),
					...fromTabularData(result, "netPurchasePrice", { formatter: {
						total: tableCellFormatter.currency,
						m2Entry: tableCellFormatter.currency,
						m2Exit: tableCellFormatter.currency
					} })
				},
				{
					metric: mfhSummaryLabel("transactionCosts", t),
					...fromTabularData(result, "transactionCosts", { formatter: {
						total: tableCellFormatter.currency,
						m2Entry: tableCellFormatter.currency,
						m2Exit: tableCellFormatter.currency
					} })
				},
				{
					metric: mfhSummaryLabel("grossPurchasePrice", t),
					...fromTabularData(result, "grossPurchasePrice", { formatter: {
						total: tableCellFormatter.currency,
						m2Entry: tableCellFormatter.currency,
						m2Exit: tableCellFormatter.currency
					} })
				},
				...result.rows.capitalExpenditures ? [{
					metric: mfhSummaryLabel("capitalExpenditures", t),
					...fromTabularData(result, "capitalExpenditures", { formatter: {
						total: tableCellFormatter.currency,
						m2Entry: tableCellFormatter.currency,
						m2Exit: tableCellFormatter.currency
					} })
				}] : [
					{
						metric: mfhSummaryLabel("capexEnergyEfficiency", t),
						...fromTabularData(result, "capexEnergyEfficency", { formatter: {
							total: tableCellFormatter.currency,
							m2Entry: tableCellFormatter.currency,
							m2Exit: tableCellFormatter.currency
						} })
					},
					{
						metric: mfhSummaryLabel("capexGeneral", t),
						...fromTabularData(result, "capexGeneral", { formatter: {
							total: tableCellFormatter.currency,
							m2Entry: tableCellFormatter.currency,
							m2Exit: tableCellFormatter.currency
						} })
					},
					{
						metric: mfhSummaryLabel("capexExpansion", t),
						...fromTabularData(result, "capexExpansion", { formatter: {
							total: tableCellFormatter.currency,
							m2Entry: tableCellFormatter.currency,
							m2Exit: tableCellFormatter.currency
						} })
					}
				],
				{
					metric: mfhSummaryLabel("tenantImprovements", t),
					...fromTabularData(result, "tenantImprovements", { formatter: {
						total: tableCellFormatter.currency,
						m2Entry: tableCellFormatter.currency,
						m2Exit: tableCellFormatter.currency
					} })
				},
				{
					metric: mfhSummaryLabel("leasingCommissionTenantCompensations", t),
					...fromTabularData(result, "leasingCommissionTenantCompensations", { formatter: {
						total: tableCellFormatter.currency,
						m2Entry: tableCellFormatter.currency,
						m2Exit: tableCellFormatter.currency
					} })
				},
				{
					metric: mfhSummaryLabel("partnerFees", t),
					...fromTabularData(result, "partnerFees", { formatter: {
						total: tableCellFormatter.currency,
						m2Entry: tableCellFormatter.currency,
						m2Exit: tableCellFormatter.currency
					} })
				},
				{
					metric: mfhSummaryLabel("vatLoss", t),
					...fromTabularData(result, "VATLoss", { formatter: {
						total: tableCellFormatter.currency,
						m2Entry: tableCellFormatter.currency,
						m2Exit: tableCellFormatter.currency
					} })
				},
				{
					metric: mfhSummaryLabel("aicExclFinancing", t),
					...fromTabularData(result, "AICExclFinancing", { formatter: {
						total: tableCellFormatter.currency,
						m2Entry: tableCellFormatter.currency,
						m2Exit: tableCellFormatter.currency
					} })
				}
			] : [],
			headers: {
				metric: mfhSummaryLabel("breakdownEuro", t),
				total: mfhSummaryLabel("total", t),
				m2Entry: mfhSummaryLabel("m2Entry", t),
				m2Exit: mfhSummaryLabel("m2Exit", t)
			}
		}),
		goingInOut: (result, t) => ({
			rows: result ? [
				{
					metric: mfhSummaryLabel("nla", t),
					...fromTabularData(result, "NLA", { formatter: {
						entry: tableCellFormatter.sqm,
						exit: tableCellFormatter.sqm,
						delta: tableCellFormatter.percent
					} })
				},
				{
					metric: mfhSummaryLabel("nppVsGrossDisposalPrice", t),
					...fromTabularData(result, "NPPVsGrossDisposalPrice", { formatter: {
						entry: tableCellFormatter.currency,
						exit: tableCellFormatter.currency,
						delta: tableCellFormatter.percent
					} })
				},
				{
					metric: mfhSummaryLabel("netPricePsm", t),
					...fromTabularData(result, "netPriceSqm", { formatter: {
						entry: tableCellFormatter.currency,
						exit: tableCellFormatter.currency,
						delta: tableCellFormatter.percent
					} })
				},
				{
					metric: mfhSummaryLabel("nriMultiple", t),
					...fromTabularData(result, "NRIMultiple", { formatter: { delta: tableCellFormatter.percent } })
				},
				{
					metric: mfhSummaryLabel("nriYield", t),
					...fromTabularData(result, "NRIYield", { formatter: {
						entry: tableCellFormatter.percent,
						exit: tableCellFormatter.percent,
						delta: tableCellFormatter.percent
					} })
				},
				...typeof result.rows.NRIYearly === "number" ? [{
					metric: mfhSummaryLabel("nriYearly", t),
					...fromTabularData(result, "NRIYearly", { formatter: {
						entry: tableCellFormatter.currency,
						exit: tableCellFormatter.currency,
						delta: tableCellFormatter.percent
					} })
				}] : [{
					metric: mfhSummaryLabel("nriYearlyExclVacancyRent", t),
					...fromTabularData(result, "nriYearlyExclVacancyRent", { formatter: {
						entry: tableCellFormatter.currency,
						exit: tableCellFormatter.currency,
						delta: tableCellFormatter.percent
					} })
				}, {
					metric: mfhSummaryLabel("nriYearlyInclVacancyRent", t),
					...fromTabularData(result, "nriYearlyInclVacancyRent", { formatter: {
						entry: tableCellFormatter.currency,
						exit: tableCellFormatter.currency,
						delta: tableCellFormatter.percent
					} })
				}],
				{
					metric: mfhSummaryLabel("nriMonthlyPsm", t),
					...fromTabularData(result, "NRIMonthlySqm", { formatter: {
						entry: tableCellFormatter.currency,
						exit: tableCellFormatter.currency,
						delta: tableCellFormatter.percent
					} })
				},
				{
					metric: mfhSummaryLabel("vacancy", t),
					...fromTabularData(result, "vacancy", { formatter: {
						entry: tableCellFormatter.percent,
						exit: tableCellFormatter.percent,
						delta: tableCellFormatter.percent
					} })
				},
				{
					metric: mfhSummaryLabel("vacancySqm", t),
					...fromTabularData(result, "vacancySqm", { formatter: { delta: tableCellFormatter.percent } })
				},
				{
					metric: mfhSummaryLabel("noiYearly", t),
					...fromTabularData(result, "NOIYearly", { formatter: {
						entry: tableCellFormatter.currency,
						exit: tableCellFormatter.currency,
						delta: tableCellFormatter.percent
					} })
				},
				{
					metric: mfhSummaryLabel("nriLeakage", t),
					...fromTabularData(result, "NRILeakage", { formatter: {
						entry: tableCellFormatter.percent,
						exit: tableCellFormatter.percent,
						delta: tableCellFormatter.percent
					} })
				},
				{
					metric: mfhSummaryLabel("capRateNoiNpp", t),
					...fromTabularData(result, "capRateNoiNpp", { formatter: {
						entry: tableCellFormatter.percent,
						exit: tableCellFormatter.percent,
						delta: tableCellFormatter.percent
					} })
				},
				{
					metric: mfhSummaryLabel("grossPriceNextBuyerView", t),
					...fromTabularData(result, "grossPriceNextBuyerView", { formatter: {
						entry: tableCellFormatter.currency,
						exit: tableCellFormatter.currency,
						delta: tableCellFormatter.percent
					} })
				},
				{
					metric: mfhSummaryLabel("netYieldNoiGpp", t),
					...fromTabularData(result, "netYieldNoiGpp", { formatter: {
						entry: tableCellFormatter.percent,
						exit: tableCellFormatter.percent,
						delta: tableCellFormatter.percent
					} })
				},
				{
					metric: mfhSummaryLabel("gppVsNetDisposalProceeds", t),
					...fromTabularData(result, "GPPVsNetDisposalProceeds", { formatter: {
						entry: tableCellFormatter.currency,
						exit: tableCellFormatter.currency,
						delta: tableCellFormatter.percent
					} })
				}
			] : [],
			headers: {
				metric: mfhSummaryLabel("metric", t),
				entry: mfhSummaryLabel("entry", t),
				exit: mfhSummaryLabel("exit", t),
				delta: mfhSummaryLabel("delta", t)
			}
		}),
		rentalIncome: (result, t) => ({
			rows: result ? [
				{
					metric: mfhSummaryLabel("resiExisting", t),
					...fromTabularData(result, "resiExisting", { defaultFormatter: tableCellFormatter.currency })
				},
				{
					metric: mfhSummaryLabel("resiAdditional", t),
					...fromTabularData(result, "resiAdditional", { defaultFormatter: tableCellFormatter.currency })
				},
				{
					metric: mfhSummaryLabel("commercial", t),
					...fromTabularData(result, "commercial", { defaultFormatter: tableCellFormatter.currency })
				},
				{
					metric: mfhSummaryLabel("subtotal", t),
					...fromTabularData(result, "subtotal", { defaultFormatter: tableCellFormatter.currency })
				},
				{
					metric: mfhSummaryLabel("parking", t),
					...fromTabularData(result, "parking", { defaultFormatter: tableCellFormatter.currency })
				},
				{
					metric: mfhSummaryLabel("total", t),
					...fromTabularData(result, "total", { defaultFormatter: tableCellFormatter.currency })
				}
			] : [],
			headers: {
				metric: mfhSummaryLabel("useType", t),
				goingInNriPA: mfhSummaryLabel("entryNriYearly", t),
				goingInPsm: mfhSummaryLabel("entryPsm", t),
				goingInMarketRentPsmPM: mfhSummaryLabel("entryMarketRentPsmMonthly", t),
				goingOutNriPA: mfhSummaryLabel("exitNriYearly", t),
				goingOutPsm: mfhSummaryLabel("exitPsm", t)
			}
		}),
		returns: (result, t) => ({
			rows: result ? [
				{
					metric: mfhSummaryLabel("preTaxUnlevered", t),
					...fromTabularData(result, "preTaxUnlevered", { formatter: {
						profit: tableCellFormatter.currency,
						irr: tableCellFormatter.percent,
						moC: tableCellFormatter.multiple
					} })
				},
				{
					metric: mfhSummaryLabel("preTaxLevered", t),
					...fromTabularData(result, "preTaxLevered", { formatter: {
						profit: tableCellFormatter.currency,
						irr: tableCellFormatter.percent,
						moC: tableCellFormatter.multiple
					} })
				},
				{
					metric: mfhSummaryLabel("postTaxLevered", t),
					...fromTabularData(result, "postTaxLevered", { formatter: {
						profit: tableCellFormatter.currency,
						irr: tableCellFormatter.percent,
						moC: tableCellFormatter.multiple
					} })
				},
				{
					metric: mfhSummaryLabel("postTaxPostPromote", t),
					...fromTabularData(result, "postTaxPostPromote", { formatter: {
						profit: tableCellFormatter.currency,
						irr: tableCellFormatter.percent,
						moC: tableCellFormatter.multiple
					} })
				}
			] : [],
			headers: {
				metric: mfhSummaryLabel("dealLevelReturns", t),
				profit: mfhSummaryLabel("profit", t),
				irr: mfhSummaryLabel("irr", t),
				moC: mfhSummaryLabel("moC", t)
			}
		}),
		rentalArea: (result, t) => ({
			rows: result ? [
				{
					metric: mfhSummaryLabel("resiExisting", t),
					...fromTabularData(result, "resiExisting", {
						allowedKeys: [
							"goingInTotal",
							"goingInOccup",
							"goingOutTotal",
							"goingOutOccup"
						],
						defaultFormatter: tableCellFormatter.sqm,
						formatter: {
							goingInOccup: tableCellFormatter.percent,
							goingOutOccup: tableCellFormatter.percent
						}
					})
				},
				{
					metric: mfhSummaryLabel("resiAdditional", t),
					...fromTabularData(result, "resiAdditional", {
						allowedKeys: [
							"goingInTotal",
							"goingInOccup",
							"goingOutTotal",
							"goingOutOccup"
						],
						defaultFormatter: tableCellFormatter.sqm,
						formatter: {
							goingInOccup: tableCellFormatter.percent,
							goingOutOccup: tableCellFormatter.percent
						}
					})
				},
				{
					metric: mfhSummaryLabel("commercial", t),
					...fromTabularData(result, "commercial", {
						allowedKeys: [
							"goingInTotal",
							"goingInOccup",
							"goingOutTotal",
							"goingOutOccup"
						],
						defaultFormatter: tableCellFormatter.sqm,
						formatter: {
							goingInOccup: tableCellFormatter.percent,
							goingOutOccup: tableCellFormatter.percent
						}
					})
				},
				{
					metric: mfhSummaryLabel("subtotal", t),
					...fromTabularData(result, "subtotal", {
						allowedKeys: [
							"goingInTotal",
							"goingInOccup",
							"goingOutTotal",
							"goingOutOccup"
						],
						defaultFormatter: tableCellFormatter.sqm,
						formatter: {
							goingInOccup: tableCellFormatter.percent,
							goingOutOccup: tableCellFormatter.percent
						}
					})
				},
				{
					metric: mfhSummaryLabel("parking", t),
					...fromTabularData(result, "parking", {
						allowedKeys: [
							"goingInTotal",
							"goingInOccup",
							"goingOutTotal",
							"goingOutOccup"
						],
						defaultFormatter: tableCellFormatter.numeric,
						formatter: {
							goingInOccup: tableCellFormatter.percent,
							goingOutOccup: tableCellFormatter.percent
						}
					})
				},
				{
					metric: mfhSummaryLabel("total", t),
					...fromTabularData(result, "total", {
						allowedKeys: [
							"goingInTotal",
							"goingInOccup",
							"goingOutTotal",
							"goingOutOccup"
						],
						defaultFormatter: tableCellFormatter.sqm,
						formatter: {
							goingInOccup: tableCellFormatter.percent,
							goingOutOccup: tableCellFormatter.percent
						}
					})
				}
			] : [],
			headers: {
				metric: mfhSummaryLabel("useType", t),
				goingInTotal: mfhSummaryLabel("entryTotal", t),
				goingInOccup: mfhSummaryLabel("entryOccupancy", t),
				goingOutTotal: mfhSummaryLabel("exitTotal", t),
				goingOutOccup: mfhSummaryLabel("exitOccupancy", t)
			}
		}),
		bpAssumptions: (result, t) => ({
			rows: result ? [
				{
					metric: mfhSummaryLabel("churn", t),
					value: tableCellFormatter.percent(result?.rows.rentGrowthChurn)
				},
				{
					metric: mfhSummaryLabel("civilCodeRentalIncreaseExistingTenants1", t),
					value: tableCellFormatter.percent(result?.rows.rentGrowthFirstRentalIncreaseOfExistingTenants)
				},
				{
					metric: mfhSummaryLabel("civilCodeRentalIncreaseExistingTenants2", t),
					value: tableCellFormatter.percent(result?.rows.rentGrowthSecondRentalIncreaseOfExistingTenants)
				},
				{
					metric: mfhSummaryLabel("rentIndexInflation", t),
					value: tableCellFormatter.percent(result?.rows.rentGrowthRentIndexInflation)
				},
				{
					metric: mfhSummaryLabel("marketRentGrowth", t),
					value: tableCellFormatter.percent(result?.rows.rentGrowthMarketRentGrowth)
				},
				{
					metric: mfhSummaryLabel("newLeaseIndexation", t),
					value: tableCellFormatter.percent(result?.rows.rentGrowthNewLeaseIndexation)
				}
			] : [],
			headers: {
				metric: mfhSummaryLabel("rentGrowth", t),
				value: ""
			}
		}),
		icSources: (result, t) => ({
			rows: result ? [
				{
					metric: mfhSummaryLabel("debtSenior", t),
					...fromTabularData(result, "sourcesDebtSenior", { formatter: {
						euro: tableCellFormatter.currency,
						percent: tableCellFormatter.percent
					} })
				},
				{
					metric: mfhSummaryLabel("debtCapexTiNonSubsidized", t),
					...fromTabularData(result, "sourcesDebtCapexTiNonSubsidized", { formatter: {
						euro: tableCellFormatter.currency,
						percent: tableCellFormatter.percent
					} })
				},
				{
					metric: mfhSummaryLabel("debtCapexSubsidizedInclGrant", t),
					...fromTabularData(result, "sourcesDebtCapexSubsidizedInclGrant", { formatter: {
						euro: tableCellFormatter.currency,
						percent: tableCellFormatter.percent
					} })
				},
				{
					metric: mfhSummaryLabel("equity", t),
					...fromTabularData(result, "sourcesEquity", { formatter: {
						euro: tableCellFormatter.currency,
						percent: tableCellFormatter.percent
					} })
				},
				{
					metric: mfhSummaryLabel("cashCollectedNoi", t),
					...fromTabularData(result, "sourcesCashCollectedNoi", { formatter: {
						euro: tableCellFormatter.currency,
						percent: tableCellFormatter.percent
					} })
				},
				{
					metric: mfhSummaryLabel("total", t),
					...fromTabularData(result, "sourcesTotal", { formatter: {
						euro: tableCellFormatter.currency,
						percent: tableCellFormatter.percent
					} })
				}
			] : [],
			headers: {
				metric: mfhSummaryLabel("metric", t),
				euro: mfhSummaryLabel("euro", t),
				percent: mfhSummaryLabel("percent", t)
			}
		}),
		icUses: (result, t) => ({
			rows: result ? [
				{
					metric: mfhSummaryLabel("netPurchasePrice", t),
					...fromTabularData(result, "usesNetPurchasePrice", { formatter: {
						euro: tableCellFormatter.currency,
						percent: tableCellFormatter.percent
					} })
				},
				{
					metric: mfhSummaryLabel("closingCostsExclFinancing", t),
					...fromTabularData(result, "usesClosingCostsExclFinancing", { formatter: {
						euro: tableCellFormatter.currency,
						percent: tableCellFormatter.percent
					} })
				},
				{
					metric: mfhSummaryLabel("tisLcsTenantCompensations", t),
					...fromTabularData(result, "usesTIsLCsTenantCompensations", { formatter: {
						euro: tableCellFormatter.currency,
						percent: tableCellFormatter.percent
					} })
				},
				...hasTabularRowValues(result.rows.usesCAPEXEeCapexExpansion) ? [{
					metric: mfhSummaryLabel("capexEeCapexExpansion", t),
					...fromTabularData(result, "usesCAPEXEeCapexExpansion", { formatter: {
						euro: tableCellFormatter.currency,
						percent: tableCellFormatter.percent
					} })
				}] : [
					{
						metric: mfhSummaryLabel("capexEe", t),
						...fromTabularData(result, "usesCAPEXEe", { formatter: {
							euro: tableCellFormatter.currency,
							percent: tableCellFormatter.percent
						} })
					},
					{
						metric: mfhSummaryLabel("capexExpansion", t),
						...fromTabularData(result, "usesCAPEXExpansion", { formatter: {
							euro: tableCellFormatter.currency,
							percent: tableCellFormatter.percent
						} })
					},
					{
						metric: mfhSummaryLabel("capexGeneral", t),
						...fromTabularData(result, "usesCAPEXGeneral", { formatter: {
							euro: tableCellFormatter.currency,
							percent: tableCellFormatter.percent
						} })
					}
				],
				{
					metric: mfhSummaryLabel("partnerFeesPlain", t),
					...fromTabularData(result, "usesPartnerFees", { formatter: {
						euro: tableCellFormatter.currency,
						percent: tableCellFormatter.percent
					} })
				},
				{
					metric: mfhSummaryLabel("financingCosts", t),
					...fromTabularData(result, "usesFinancingCosts", { formatter: {
						euro: tableCellFormatter.currency,
						percent: tableCellFormatter.percent
					} })
				},
				{
					metric: mfhSummaryLabel("vat", t),
					...fromTabularData(result, "usesVAT", { formatter: {
						euro: tableCellFormatter.currency,
						percent: tableCellFormatter.percent
					} })
				},
				{
					metric: mfhSummaryLabel("total", t),
					...fromTabularData(result, "usesTotal", { formatter: {
						euro: tableCellFormatter.currency,
						percent: tableCellFormatter.percent
					} })
				}
			] : [],
			headers: {
				metric: mfhSummaryLabel("metric", t),
				euro: mfhSummaryLabel("euro", t),
				percent: mfhSummaryLabel("percent", t)
			}
		})
	};
	formatMFHSummaryCardData = {
		sourcingInfo: (summary, isExternal, isRAM, options) => [
			{
				label: "Seller",
				labelI18nKey: "asset:summary.overview.labels.seller",
				value: summary.contacts.find((c) => c.type === "Seller")?.value
			},
			{
				label: "Asset Partner",
				labelI18nKey: "asset:summary.overview.labels.assetPartner",
				value: summary.contacts.find((c) => c.type === "AssetPartner")?.value
			},
			{
				label: "Broker",
				labelI18nKey: "asset:summary.overview.labels.broker",
				value: summary.contacts.find((c) => c.type === "Broker")?.value
			},
			{
				label: "Deal Captain",
				labelI18nKey: "asset:summary.overview.labels.dealCaptain",
				value: summary.contacts.find((c) => c.type === "DealCaptain")?.value
			},
			{
				label: "Link to Exposé",
				labelI18nKey: "asset:summary.overview.labels.linkToExpose",
				value: formatSummaryLink("Exposé", summary.links.find((l) => l.type === "Exposee")?.value, options)
			},
			{
				label: "Link to Investment Case",
				labelI18nKey: "asset:summary.overview.labels.linkToInvestmentCase",
				value: formatSummaryLink(summary.investmentCaseName || "Investment-Case", summary.links.find((l) => l.type === (isExternal ? "ExternalInvestmentCase" : isRAM ? "InvestmentCaseRAM" : "InvestmentCase"))?.value, options)
			}
		],
		asset: (summary, options) => [
			{
				label: "Address",
				labelI18nKey: "asset:summary.overview.labels.address",
				value: summary.address
			},
			{
				label: "Construction year",
				labelI18nKey: "asset:summary.overview.labels.constructionYear",
				value: summary.constructionYear != null ? String(summary.constructionYear) : void 0
			},
			{
				label: "Source",
				labelI18nKey: "asset:summary.overview.labels.source",
				value: summary.source
			},
			{
				label: "Investment Risk Profile",
				labelI18nKey: "asset:summary.overview.labels.investmentRiskProfile",
				value: toTitleCase(summary.investmentRiskProfile)
			}
		],
		building: (summary, options) => [
			[{
				label: "Number of buildings",
				labelI18nKey: "asset:summary.overview.labels.numberOfBuildings",
				value: formatSummaryNumerical(summary.numBuildings, "number", options, tableCellFormatter.numeric)
			}, {
				label: "# of residential units",
				labelI18nKey: "asset:summary.overview.labels.residentialUnits",
				value: formatSummaryNumerical(summary.numResidentialUnits, "number", options, tableCellFormatter.numeric)
			}],
			[{
				label: "Total size",
				labelI18nKey: "asset:summary.overview.labels.totalSize",
				value: formatSummaryNumerical(summary.totalSize, "squareMeter", options, tableCellFormatter.sqm)
			}, {
				label: "Average residential unit size",
				labelI18nKey: "asset:summary.overview.labels.averageResidentialUnitSize",
				value: formatSummaryNumerical(summary.averageResidentalUnitSize, "squareMeter", options, tableCellFormatter.sqm)
			}],
			[{
				label: "Residential size",
				labelI18nKey: "asset:summary.overview.labels.residentialSize",
				value: formatSummaryNumerical(summary.residentalSize, "squareMeter", options, tableCellFormatter.sqm)
			}, {
				label: "# of commercial units",
				labelI18nKey: "asset:summary.overview.labels.commercialUnits",
				value: formatSummaryNumerical(summary.numCommercialUnits, "number", options, tableCellFormatter.numeric)
			}],
			[{
				label: "Commercial size",
				labelI18nKey: "asset:summary.overview.labels.commercialSize",
				value: formatSummaryNumerical(summary.commercialSize, "squareMeter", options, tableCellFormatter.sqm)
			}, {
				label: "# of parking spaces (rentable)",
				labelI18nKey: "asset:summary.overview.labels.rentableParkingSpaces",
				value: formatSummaryNumerical(summary.numRentableParkingSpaces, "number", options, tableCellFormatter.numeric)
			}],
			[{}, {
				label: "Estimated expansion potential (m²)",
				labelI18nKey: "asset:summary.overview.labels.expansionPotential",
				value: formatSummaryNumerical(summary.expansionPotential, "squareMeter", options, tableCellFormatter.sqm)
			}]
		],
		rent: (summary, isExternal, options) => {
			const rentRollHref = summary.approvedMfhRentRollVersionId ? isExternal ? `/mfhs/${summary.mfhId}/rent-roll-reporting` : `/mfhs/${summary.mfhId}/dd/rent-roll-versions/${summary.approvedMfhRentRollVersionId}` : void 0;
			return [
				{
					label: "Vacancy rate",
					labelI18nKey: "asset:summary.overview.labels.vacancyRate",
					value: formatSummaryNumerical(summary?.vacanyRate, "percent", options, tableCellFormatter.percent)
				},
				{
					label: "Net rental income p.a",
					labelI18nKey: "asset:summary.overview.labels.netRentalIncomePa",
					value: formatSummaryNumerical(summary?.netRentalIncomeYearly, "currency", options, tableCellFormatter.currency)
				},
				{
					label: "Residential Rent p.m",
					labelI18nKey: "asset:summary.overview.labels.residentialRentPm",
					value: formatSummaryNumerical(summary?.residentalRentSqmMonthly, "currencyPerSquareMeter", options, tableCellFormatter.currencySqm)
				},
				{
					label: "Commercial Rent p.m",
					labelI18nKey: "asset:summary.overview.labels.commercialRentPm",
					value: formatSummaryNumerical(summary?.commercialRentSqmMonthly, "currencyPerSquareMeter", options, tableCellFormatter.currencySqm)
				},
				{
					label: "Share of residential NRI",
					labelI18nKey: "asset:summary.overview.labels.shareOfResidentialNri",
					value: formatSummaryNumerical(summary?.shareOfResidentialNRI, "percent", options, tableCellFormatter.percent)
				},
				{
					label: "Number of index-linked rental contracts",
					labelI18nKey: "asset:summary.overview.labels.indexLinkedRentalContracts",
					value: formatSummaryLink(formatSummaryNumerical(summary?.amountOfIndexRentalContracts, "number", options, tableCellFormatter.numeric), rentRollHref, options)
				}
			];
		},
		acquisition: (summary, options) => [
			{
				label: "Asking price",
				labelI18nKey: "asset:summary.overview.labels.askingPrice",
				value: formatSummaryNumerical(summary?.acquisitionPrice, "currency", options, tableCellFormatter.currency)
			},
			{
				label: "Asking price / m²",
				labelI18nKey: "asset:summary.overview.labels.askingPricePerSqm",
				value: formatSummaryNumerical(summary?.acquisitionPriceSqm, "currencyPerSquareMeter", options, tableCellFormatter.currencySqm)
			},
			{
				label: "Net Purchase Price",
				labelI18nKey: "asset:summary.overview.labels.netPurchasePrice",
				value: formatSummaryNumerical(summary?.sourcesUses?.rows?.usesNetPurchasePrice?.euro, "currency", options, tableCellFormatter.currency)
			},
			{
				label: "Purchase discount",
				labelI18nKey: "asset:summary.overview.labels.purchaseDiscount",
				value: formatSummaryNumerical(summary?.purchaseDiscount, "percent", options, tableCellFormatter.percent)
			},
			{
				label: "Asking multiple",
				labelI18nKey: "asset:summary.overview.labels.askingMultiple",
				value: formatSummaryNumerical(summary?.acquisitionMultiple, "multiple", options, tableCellFormatter.multiple)
			},
			{
				label: "Signing date (actual)",
				labelI18nKey: "asset:summary.overview.labels.signingDateActual",
				value: summary?.signingDate ? formatDate$1(summary?.signingDate, DateFormats.SimpleDate) : ""
			},
			{
				label: summary.actualClosingDate ? "Closing date (actual)" : "Closing date (expected)",
				labelI18nKey: summary.actualClosingDate ? "asset:summary.overview.labels.closingDateActual" : "asset:summary.overview.labels.closingDateExpected",
				value: summary.actualClosingDate ? formatDate$1(summary.actualClosingDate, DateFormats.SimpleDate) : summary?.expectedClosingDate ? formatDate$1(summary.expectedClosingDate, DateFormats.SimpleDate) : ""
			}
		]
	};
	formatMFHSummaryData = (summary, isExternal, isRAM, optionsOrTranslation) => {
		const options = normalizeSummaryOptions(optionsOrTranslation);
		const t = options.t;
		return {
			netDisposalProceeds: formatMFHSummaryTabularData.netDisposalProceeds(summary.valueBridge, t),
			valueBridge: formatMFHSummaryTabularData.valueBridge(summary.valueBridge, t),
			rentalIncome: formatMFHSummaryTabularData.rentalIncome(summary.rentalIncome, t),
			rentalArea: formatMFHSummaryTabularData.rentalArea(summary.rentalArea, t),
			bpAssumptions: formatMFHSummaryTabularData.bpAssumptions(summary.bpAssumptions, t),
			dealLevelReturn: formatMFHSummaryTabularData.returns(summary.returns, t),
			goingInOut: formatMFHSummaryTabularData.goingInOut(summary.goingInOut, t),
			sourcingInfo: formatMFHSummaryCardData.sourcingInfo(summary, isExternal, isRAM, options),
			asset: formatMFHSummaryCardData.asset(summary, options),
			building: formatMFHSummaryCardData.building(summary, options),
			rent: formatMFHSummaryCardData.rent(summary, isExternal, options),
			acquisition: formatMFHSummaryCardData.acquisition(summary, options),
			icUses: formatMFHSummaryTabularData.icUses(summary.sourcesUses, t),
			icSources: formatMFHSummaryTabularData.icSources(summary.sourcesUses, t)
		};
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/summary/mfh-summary.model.ts
var init_mfh_summary_model = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/summary/mfh-summary.helpers.ts
var getMFHSummaryData;
var init_mfh_summary_helpers = __esmMin((() => {
	init_ccs_routes();
	init_document_model();
	init_energy_efficiency();
	init_maps();
	init_user_model();
	init_mfh_investment_case_base();
	init_mfh_process_base();
	init_mfh_attributes_helpers();
	init_mfh_helpers();
	init_rental_contract_model();
	getMFHSummaryData = (mfh, _events, ccsBaseUrl, staticMapsApiKey, candidateAssetPartnerId, options) => {
		const { attributes, buildings, candidateLocation, contactRelation, companyRelation, documents, investmentCases, price } = mfh;
		const galleryImages = mfh.media?.map((m) => m.link).slice(0, 6) ?? [];
		const effectiveAssetPartnerId = candidateAssetPartnerId ?? mfh.attributes?.assetPartnerId;
		const relevantInvestmentCases = investmentCases?.filter((ic) => !effectiveAssetPartnerId || ic.assetPartnerId === effectiveAssetPartnerId);
		const investmentCase = relevantInvestmentCases?.find((ic) => ic.status === "Approved") ?? relevantInvestmentCases?.find((ic) => ic.isPrimaryCase) ?? investmentCases?.find((ic) => ic.status === "Approved") ?? investmentCases?.find((ic) => ic.isPrimaryCase);
		const effectiveAssetPartnerName = candidateAssetPartnerId ? companyRelation?.find((cr) => cr.relationName === "CandidateAssetPartner" && cr.company?.companyId === candidateAssetPartnerId)?.company?.name : mfh.attributes?.assetPartner?.name;
		const approvedMfhRentRollVersion = mfh.rentRollVersions?.find((rv) => rv.rentRollVersionId === investmentCase?.rentRollVersionId);
		const exposeLink = maxBy(documents?.filter((d) => d.documentType === "MfhExpose"), "documentId")?.link;
		const entryMultiple = COMPUTED_MFH_ATTRS.multiple.fromMFH({
			price,
			attributes,
			buildings
		});
		const companySeller = companyRelation?.find((el) => el?.relationName === "Seller")?.company?.name;
		const companyRealtor = companyRelation?.find((el) => el?.relationName === "Realtor")?.company?.name;
		const contactSeller = contactRelation?.find((el) => el?.relationName === "Seller")?.contact?.fullname;
		const contactRealtor = contactRelation?.find((el) => el?.relationName === "Realtor")?.contact?.fullname;
		const seller = companySeller ?? contactSeller;
		const realtor = companyRealtor ?? contactRealtor;
		const dealCaptain = contactRelation?.find((el) => el?.companyFunction === "DealCaptain")?.contact?.fullname;
		const allLocations = buildings ? [...buildings.map((b) => b.location).filter((l) => !!l)] : [];
		const mapsLink = allLocations?.[0] ? prepareGMAPLink(allLocations?.[0]) : void 0;
		const address = addressFormatter(candidateLocation, ["country"]);
		const staticMapsLink = allLocations?.length ? createStaticGMapsLink(address, allLocations ?? [], staticMapsApiKey, { size: options?.staticMapSize }) : void 0;
		const closingDate = mfh.sourcing?.finishedAt;
		const base = {
			mfhId: mfh.mfhId,
			condoUuid: mfh.condoUuid,
			title: mfh.title,
			assetPartnerId: effectiveAssetPartnerId,
			processes: {
				portfolioPurchasing: mfh.candidateMfhPortfolios?.[0]?.purchasing ? {
					portfolioId: mfh.candidateMfhPortfolios[0].mfhPortfolioId,
					porfolioUuid: mfh.candidateMfhPortfolios[0].condoUuid,
					processId: mfh.candidateMfhPortfolios[0].purchasing.processId,
					processState: mfh.candidateMfhPortfolios[0].purchasing.processState,
					blockedByPortfolioId: mfh.candidateMfhPortfolios[0].mfhCandidatePortfolioRelations?.[0]?.blockedByPortfolioId
				} : void 0,
				sourcing: mfh.sourcing ? {
					processId: mfh.sourcing.processId,
					processState: mfh.sourcing.processState
				} : void 0,
				subsidyFinancing: mfh.subsidyFinancing ? {
					processId: mfh.subsidyFinancing.processId,
					processState: mfh.subsidyFinancing.processState
				} : void 0,
				estateManagement: mfh.estateManagement ? {
					processId: mfh.estateManagement.processId,
					processState: mfh.estateManagement.processState
				} : void 0
			},
			markerLocations: allLocations.map((l) => ({
				label: createAbbreviation(l?.street, l?.houseNumber),
				position: {
					lat: l.latitude,
					lng: l.longitude
				},
				color: stc(l.locationId)
			})),
			galleryImages,
			investmentCaseName: investmentCase?.name,
			links: [
				staticMapsLink ? {
					type: "StaticGMaps",
					value: staticMapsLink
				} : null,
				mapsLink ? {
					type: "GMaps",
					value: mapsLink
				} : null,
				exposeLink ? {
					type: "Exposee",
					value: exposeLink
				} : null,
				investmentCase?.mfhInvestmentCaseId ? {
					type: "InvestmentCase",
					value: resolveRoutePath(CCSRouteMap["one.mfh.purchasing.investment-case-detail"], {
						params: {
							mfhInvestmentCaseId: String(investmentCase.mfhInvestmentCaseId),
							mfhId: String(mfh.mfhId)
						},
						baseUrl: ccsBaseUrl
					})
				} : null,
				investmentCase?.mfhInvestmentCaseId ? {
					type: "ExternalInvestmentCase",
					value: resolveRoutePath({
						rootPath: "/mfhs/:mfhId",
						path: "investment-cases/:mfhInvestmentCaseId",
						name: ""
					}, {
						params: {
							mfhInvestmentCaseId: String(investmentCase.mfhInvestmentCaseId),
							mfhId: String(mfh.mfhId)
						},
						baseUrl: ccsBaseUrl
					})
				} : null,
				investmentCase?.mfhInvestmentCaseId ? {
					type: "InvestmentCaseRAM",
					value: `/assets/${mfh.mfhId}/investment-cases/${investmentCase.mfhInvestmentCaseId}`
				} : null
			].filter(Boolean),
			contacts: [
				seller ? {
					type: "Seller",
					value: seller
				} : null,
				realtor ? {
					type: "Broker",
					value: realtor
				} : null,
				dealCaptain ? {
					type: "DealCaptain",
					value: dealCaptain
				} : null,
				effectiveAssetPartnerName ? {
					type: "AssetPartner",
					value: effectiveAssetPartnerName
				} : null
			].filter(Boolean),
			address,
			constructionYear: mfh.attributes?.constructionYear,
			source: mfh.channelName,
			investmentRiskProfile: mfh.attributes?.investmentRiskProfile,
			numBuildings: buildings?.length,
			totalSize: mfh.attributes?.totalFloorSpace,
			residentalSize: mfh.attributes?.livingSpace,
			commercialSize: mfh.attributes?.commercialSpace,
			numResidentialUnits: mfh.attributes?.numberOfApartments,
			icResidentialUnits: investmentCase?.caseInputs?.overview?.resiUnits,
			icNewResidentialUnitsInHeatedArea: investmentCase?.caseInputs?.buildingTechnical?.numberOfApartmentsInHeatedArea,
			averageResidentalUnitSize: mfh.attributes?.avgSizeOfApartment,
			numCommercialUnits: mfh.attributes?.numberOfCommercialUnits,
			numRentableParkingSpaces: mfh.attributes?.numberOfParkingSpaces,
			expansionPotential: mfh.attributes?.expansionPotential,
			vacanyRate: mfh.attributes?.residentialOccupancyRate ? 1 - mfh.attributes?.residentialOccupancyRate : void 0,
			netRentalIncomeYearly: mfh.attributes?.rentResidential,
			residentalRentSqmMonthly: mfh.attributes?.residentialRentPerSQM,
			commercialRentSqmMonthly: mfh.attributes?.commercialRentPerSQM,
			shareOfResidentialNRI: mfh.attributes?.rentResidential && mfh.attributes.rentalIncomeActual ? mfh.attributes.rentResidential / mfh.attributes.rentalIncomeActual : void 0,
			amountOfIndexRentalContracts: approvedMfhRentRollVersion?.rentRolls?.filter((rr) => rr.rentIncreaseType === "IRI").length || mfh.attributes?.amountOfIndexRentalContracts || 0,
			approvedMfhRentRollVersionId: approvedMfhRentRollVersion?.rentRollVersionId,
			purchaseDiscount: investmentCase?.caseInputs?.assumptions.expectedPurchaseDiscount ?? mfh.attributes?.expectedPurchaseDiscount,
			acquisitionPrice: investmentCase?.caseInputs?.overview.askingPrice ?? mfh.price?.purchasePriceNett,
			acquisitionPriceSqm: investmentCase?.caseInputs?.overview.askingPriceSqm ?? mfh.price?.pricePerSQM,
			acquisitionMultiple: entryMultiple ?? void 0,
			actualClosingDate: closingDate,
			preEnergyDemand: investmentCase?.caseInputs?.buildingTechnical?.endEnergyConsumptionKWhSqm,
			preEnergyClass: investmentCase?.caseInputs?.buildingTechnical?.endEnergyConsumptionKWhSqm ? convertEnergyConsumptionToEnergyConsumptionCategory(investmentCase.caseInputs.buildingTechnical.endEnergyConsumptionKWhSqm) : void 0,
			postEnergyDemand: investmentCase?.postTransformation?.energyEfficiencyClass ? MaxKwhPerEnergyConsumptionCategory[investmentCase.postTransformation.energyEfficiencyClass] : void 0,
			postEnergyClass: investmentCase?.postTransformation?.energyEfficiencyClass,
			isVisibleInExternalPortal: ExternalMfhInPipelineSourcingStates.includes(mfh.sourcing?.processState),
			caseOutputsPresent: !!investmentCase?.investmentCaseOutput,
			goingInOut: investmentCase?.investmentCaseOutput?.goingInOut,
			returns: investmentCase?.investmentCaseOutput?.returns,
			valueBridge: investmentCase?.investmentCaseOutput?.valueBridge,
			rentalArea: investmentCase?.investmentCaseOutput?.rentalArea,
			rentalIncome: investmentCase?.investmentCaseOutput?.rentalIncome,
			bpAssumptions: investmentCase?.investmentCaseOutput?.bpAssumptions,
			sourcesUses: investmentCase?.investmentCaseOutput?.sourcesUses
		};
		base.caseOutputsPresent = !!base.goingInOut && !!base.returns && !!base.valueBridge && !!base.rentalArea && !!base.rentalIncome && !!base.bpAssumptions;
		return base;
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh.request.ts
var init_mfh_request = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh.jobs.ts
var TNullableString, TNullableNumber, TNullableBoolean, MfhExposeParseResultSchema, MfhRentalContractParseResultSchema, MfhAttributesParseResultSchema;
var init_mfh_jobs = __esmMin((() => {
	init_shared_schemas();
	init_energy_efficiency();
	init_estate_base();
	TNullableString = (opts) => Type.Union([Type.String(), Type.Null()], {
		default: null,
		...opts
	});
	TNullableNumber = (opts) => Type.Union([Type.Number(), Type.Null()], {
		default: null,
		...opts
	});
	TNullableBoolean = (opts) => Type.Union([Type.Boolean(opts), Type.Null()], {
		default: null,
		...opts
	});
	MfhExposeParseResultSchema = Type.Object({
		confidence: Type.Number({
			minimum: 0,
			maximum: 1,
			default: 0,
			description: "A numerical confidence score whether the provided document contains an exposé for a multi-family-house between 0 and 1"
		}),
		estateType: Type.Union([TEnum(EstateType, { description: "Kind of the estate" }), Type.Null()], { default: null }),
		street: TNullableString({ description: "Street WITHOUT house-number of the estates' location" }),
		houseNumber: TNullableString({ description: "House-number of the estates' location" }),
		zipcode: TNullableString({ description: "Zipcode of the estates' location" }),
		quarter: TNullableString({ description: "Quarter within the city of the estates' location" }),
		city: TNullableString({ description: "City of the estates' location" }),
		livingSpace: TNullableNumber({
			description: "Total living-space of the whole estate",
			default: 0
		}),
		numberOfParkingSpaces: TNullableNumber({ description: "Amount of included parking-spaces" }),
		constructionYear: TNullableNumber({ description: "Construction year of the estate" }),
		floors: TNullableNumber({ description: "Amount of floors in the estate" }),
		garden: TNullableBoolean({ description: "Boolean to describe whether there is private garden attached to the estate" }),
		cellar: TNullableBoolean({ description: "Boolean to describe whether there is a cellar" }),
		energyConsumption: TNullableNumber({ description: "A numeric value for the average energy-consumption per year of the estate" }),
		isHeritageBuilding: TNullableBoolean({ description: "Boolean to indicate whether there are specific monument/heritage protections for this estate" }),
		energyConsumptionCategory: TNullableString({ description: "A score for the energy-consumption-category, starting from A to A+, to H" }),
		primaryHeatingType: TNullableString({ description: "Primary energy-source used for heating" }),
		secondaryHeatingType: TNullableString({ description: "Secondary energy-source for heating" }),
		energyCertificateAvailability: TNullableBoolean({ description: "Boolean to indicate whether an energy-certificate is available" }),
		energyCertificateCreationDate: TNullableString({ description: "Creation-date of the energy-certificate" }),
		energyCertificateExpiryDate: TNullableString({ description: "Expiration-Date of the energy-certificate" }),
		buildingEnergyRating: Type.Union([TEnum(BuildingEnergyRating), Type.Null()], { default: null }),
		facadeType: TNullableString({ description: "The main facade-type of all outer building walls" }),
		facadeRenovationType: TNullableString({ description: "Freetext for kind of the last performed facade-renovation. Empty if no renovation was performed" }),
		facadeRenovationDate: TNullableString({ description: "Date of the last renovation of the facade" }),
		roofType: TNullableString({ description: "Type/Shape of the roof" }),
		roofRenovationType: TNullableString({ description: "Freetext for kind of the last performed roof-renovation. Empty if no renovation was performed" }),
		roofRenovationDate: TNullableString({ description: "Date of the last renovation of the roof" }),
		storeRooms: Type.Union([Type.Array(TEnum(StoreRoomType, { description: "Kind of available storage-rooms for tenants" })), Type.Null()], { default: null }),
		commonRooms: Type.Union([Type.Array(TEnum(CommonRoomType, { description: "Kind of extra commonly usable rooms for tenants" })), Type.Null()], { default: null }),
		heatingInstallationYear: TNullableNumber({ description: "Year of the last performed heating-installation. Empty if no installation/renovation was performed" }),
		numberOfApartments: TNullableNumber({ description: "Amount of included, independent rentable apartment-units within the estate" }),
		windowType: TNullableString({ description: "Type of equipped windows for all apartments." }),
		windowRenovationType: TNullableString({ description: "Last known renovation-date of all windows. Empty if no installation/renovation was performed" }),
		co2EmissionPerYear: TNullableNumber({ description: "Total Co2-Emissions per year in tons" }),
		buildingSize: TNullableNumber({ description: "Total size of building in square-meters" }),
		rentalIncomeActual: TNullableNumber({ description: "The current paid rent for all tenants in the estate" }),
		propertyLandSize: TNullableNumber({ description: "Total size of the property, including the garden (if any)" }),
		rentableSpace: TNullableNumber({ description: "Amount of rentable space for private  units in square-meters" }),
		commercialSpace: TNullableNumber({ description: "Amount of rentable space for commercial units in square-meters" }),
		insulationOfExteriorWalls: TNullableBoolean({ description: "Boolean indicating if the exterior walls of the estate are insulated" }),
		insulationOfCellar: TNullableBoolean({ description: "Boolean indicating if the cellar of the estate is insulated" }),
		totalFloorSpace: TNullableNumber({ description: "Total floor space of the estate in square meters" }),
		plotArea: TNullableNumber({ description: "Total area of the estate plot in square meters" }),
		additionalCosts: TNullableNumber({ description: "Amount of additional costs, potentially including maintenance or service fees" }),
		distanceToAirport: TNullableNumber({ description: "Distance in km to the nearest airport" }),
		distanceToFM: TNullableNumber({ description: "Travel time to the nearest highway" }),
		distanceToPT: TNullableNumber({ description: "Travel time to the nearest public transport station" }),
		distanceToMRS: TNullableNumber({ description: "Travel time to the nearest Railway station" }),
		rentalParkingSpaceIncome: TNullableNumber({ description: "Yearly rental income from all the parking spaces" }),
		agency: Type.Object({
			name: TNullableString({ description: "Name of the realtor agency company" }),
			email: TNullableString({ description: "Email of the realtor agency company" }),
			phoneNumber: TNullableString({ description: "Phone number of the realtor agency company" })
		}),
		estates: Type.Union([Type.Array(Type.Object({
			rentStartDate: TNullableString({ description: "Start-date of the rent-tenancy" }),
			livingSpace: TNullableNumber({
				description: "Living-space for assigned apartment",
				default: 0
			}),
			apartmentType: Type.Union([TEnum(ApartmentType, { description: "Kind of the apartment" }), Type.Null()], { default: null }),
			floor: TNullableNumber({ description: "Floor of the apartment" }),
			floorLocation: Type.Union([TEnum(FloorLocation, { description: "Location of the floor" }), Type.Null()], { default: null })
		})), Type.Null()], {
			default: null,
			description: "List of the estates inside the apartment building"
		})
	}, { additionalProperties: false });
	MfhRentalContractParseResultSchema = Type.Object({
		confidence: Type.Number({
			description: "Confidence level of the parsed data, between 0 and 1",
			minimum: 0,
			maximum: 1,
			default: 0
		}),
		apartmentSize: TNullableNumber({
			description: "Total size of the apartment in square meters",
			default: 0
		}),
		rentPerSqm: TNullableNumber({ description: "Rent cost per square meter" }),
		startDate: TNullableString({ description: "Start date of the rental contract" }),
		endDate: TNullableString({ description: "End date of the rental contract" }),
		monthlyAdditionalRent: TNullableNumber({ description: "Additional monthly rent costs not included in the cold rent" }),
		coldRent: TNullableNumber({ description: "Monthly rent excluding heating and other costs" }),
		utilityCost: TNullableNumber({ description: "Monthly utility costs" }),
		utilityCostPerSqm: TNullableNumber({ description: "Monthly utility costs per square meter" }),
		heatingCost: TNullableNumber({ description: "Monthly heating cost" }),
		heatingCostPerSqm: TNullableNumber({ description: "Monthly heating cost per square meter" }),
		securityDeposit: TNullableNumber({ description: "Rental security deposit" }),
		vat: TNullableNumber({ description: "Value Added Tax" }),
		lastRentIncreaseDate: TNullableString({ description: "Date of the last rent increase" }),
		rentBeforeIncrease: TNullableNumber({ description: "Rent before the last increase" }),
		valueOfLastRentIncrease: TNullableNumber({ description: "Value of the last rent increase" }),
		percentageOfLastRentIncrease: TNullableNumber({ description: "Percentage of the last rent increase" }),
		isRentIncreaseSigned: TNullableBoolean({ description: "Boolean indicating whether the rent increase is signed" }),
		isRentalContractSigned: TNullableBoolean({ description: "Boolean indicating whether the rental agreement is signed" }),
		parkingSpaceNumber: TNullableString({ description: "Parking space number + garage" }),
		isStorageRoomInAtticIsRented: TNullableBoolean({ description: "Boolean indicating whether the storage room in the attic is rented" }),
		isIndexIncrease: TNullableBoolean({ description: "Boolean indicating whether the rent is indexed" }),
		isGradualIncrease: TNullableBoolean({ description: "Boolean indicating whether the rent is gradually increased" }),
		parkingSpaceRent: TNullableNumber({ description: "Monthly rent for the parking space" }),
		hasParkingSpace: TNullableBoolean({ description: "Boolean indicating whether a parking space is included" }),
		numberOfRooms: TNullableNumber({ description: "Total number of rooms in the apartment" }),
		numberOfBathrooms: TNullableNumber({ description: "Total number of bathrooms in the apartment" }),
		numberOfKitchens: TNullableNumber({ description: "Total number of kitchens in the apartment" }),
		numberOfParkingSpaces: TNullableNumber({ description: "Total number of parking spaces included with the apartment" }),
		floorNumber: TNullableNumber({ description: "Floor number on which the apartment is located" }),
		floorLocation: Type.Union([TEnum(FloorLocation), Type.Null()], {
			default: null,
			description: "Location of the apartment within the building e.g., basement, ground floor"
		}),
		apartmentNumber: TNullableString({ description: "Designated number of the apartment within the building" }),
		tenants: Type.Union([Type.Array(Type.Object({
			firstName: TNullableString({ description: "First name of the tenant" }),
			lastName: TNullableString({ description: "Last name of the tenant" }),
			birthDate: TNullableString({ description: "Birth date of the tenant" })
		})), Type.Null()], {
			default: null,
			description: "Array of tenants residing in the apartment"
		})
	}, { additionalProperties: false });
	MfhAttributesParseResultSchema = Type.Object({
		estateType: Type.Union([TEnum(EstateType, { description: "Kind of the estate" }), Type.Null()], { default: null }),
		street: TNullableString({ description: "Street WITHOUT house-number of the estates' location" }),
		houseNumber: TNullableString({ description: "House-number of the estates' location" }),
		zipcode: TNullableString({ description: "Zipcode of the estates' location" }),
		quarter: TNullableString({ description: "Quarter within the city of the estates' location" }),
		city: TNullableString({ description: "City of the estates' location" }),
		livingSpace: TNullableNumber({
			description: "Total living-space of the whole estate",
			default: 0
		}),
		numberOfParkingSpaces: TNullableNumber({ description: "Amount of included parking-spaces" }),
		constructionYear: TNullableNumber({ description: "Construction year of the estate" }),
		floors: TNullableNumber({ description: "Amount of floors in the estate" }),
		garden: TNullableBoolean({ description: "Boolean to describe whether there is private garden attached to the estate" }),
		cellar: TNullableBoolean({ description: "Boolean to describe whether there is a cellar" }),
		energyConsumption: TNullableNumber({ description: "A numeric value for the average energy-consumption per year of the estate" }),
		isHeritageBuilding: TNullableBoolean({ description: "Boolean to indicate whether there are specific monument/heritage protections for this estate" }),
		energyConsumptionCategory: TNullableString({ description: "A score for the energy-consumption-category, starting from A to A+, to H" }),
		primaryHeatingType: TNullableString({ description: "Primary energy-source used for heating" }),
		secondaryHeatingType: TNullableString({ description: "Secondary energy-source for heating" }),
		energyCertificateAvailability: TNullableBoolean({ description: "Boolean to indicate whether an energy-certificate is available" }),
		energyCertificateCreationDate: TNullableString({ description: "Creation-date of the energy-certificate" }),
		energyCertificateExpiryDate: TNullableString({ description: "Expiration-Date of the energy-certificate" }),
		buildingEnergyRating: Type.Union([TEnum(BuildingEnergyRating), Type.Null()], { default: null }),
		facadeType: TNullableString({ description: "The main facade-type of all outer building walls" }),
		facadeRenovationType: TNullableString({ description: "Freetext for kind of the last performed facade-renovation. Empty if no renovation was performed" }),
		facadeRenovationDate: TNullableString({ description: "Date of the last renovation of the facade" }),
		roofType: TNullableString({ description: "Type/Shape of the roof" }),
		roofRenovationType: TNullableString({ description: "Freetext for kind of the last performed roof-renovation. Empty if no renovation was performed" }),
		roofRenovationDate: TNullableString({ description: "Date of the last renovation of the roof" }),
		storeRooms: Type.Union([Type.Array(TEnum(StoreRoomType, { description: "Kind of available storage-rooms for tenants" })), Type.Null()], { default: null }),
		commonRooms: Type.Union([Type.Array(TEnum(CommonRoomType, { description: "Kind of extra commonly usable rooms for tenants" })), Type.Null()], { default: null }),
		heatingInstallationYear: TNullableNumber({ description: "Year of the last performed heating-installation. Empty if no installation/renovation was performed" }),
		numberOfApartments: TNullableNumber({ description: "Amount of included, independent rentable apartment-units within the estate" }),
		windowType: TNullableString({ description: "Type of equipped windows for all apartments." }),
		windowRenovationType: TNullableString({ description: "Last known renovation-date of all windows. Empty if no installation/renovation was performed" }),
		co2EmissionPerYear: TNullableNumber({ description: "Total Co2-Emissions per year in tons" }),
		buildingSize: TNullableNumber({ description: "Total size of building in square-meters" }),
		rentalIncomeActual: TNullableNumber({ description: "The current paid rent for all tenants in the estate" }),
		propertyLandSize: TNullableNumber({ description: "Total size of the property, including the garden (if any)" }),
		rentableSpace: TNullableNumber({ description: "Amount of rentable space for private  units in square-meters" }),
		commercialSpace: TNullableNumber({ description: "Amount of rentable space for commercial units in square-meters" }),
		insulationOfExteriorWalls: TNullableBoolean({ description: "Boolean indicating if the exterior walls of the estate are insulated" }),
		insulationOfCellar: TNullableBoolean({ description: "Boolean indicating if the cellar of the estate is insulated" }),
		totalFloorSpace: TNullableNumber({ description: "Total floor space of the estate in square meters" }),
		plotArea: TNullableNumber({ description: "Total area of the estate plot in square meters" }),
		additionalCosts: TNullableNumber({ description: "Amount of additional costs, potentially including maintenance or service fees" }),
		distanceToAirport: TNullableNumber({ description: "Distance in km to the nearest airport" }),
		distanceToFM: TNullableNumber({ description: "Travel time to the nearest highway" }),
		distanceToPT: TNullableNumber({ description: "Travel time to the nearest public transport station" }),
		distanceToMRS: TNullableNumber({ description: "Travel time to the nearest Railway station" }),
		rentalParkingSpaceIncome: TNullableNumber({ description: "Yearly rental income from all the parking spaces" })
	}, { additionalProperties: false });
}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh-attributes.model.ts
var mfhAttributesComputedProps, mfhAttributesSystemManagedProps;
var init_mfh_attributes_model = __esmMin((() => {
	mfhAttributesComputedProps = [
		"residentialRentPerSQM",
		"avgSizeOfApartment",
		"numberOfApartments",
		"numberOfParkingSpaces",
		"livingSpace",
		"multiple",
		"shareOfCommercialSpace",
		"shareOfCommercialRent",
		"commercialRentPerSQM",
		"rentResidential",
		"totalRentableSpace",
		"totalNumberOfUnits",
		"commercialSpace",
		"numberOfCommercialUnits",
		"kfwDueDate"
	];
	mfhAttributesSystemManagedProps = [
		"locationAnalysis",
		"rentAnalysis",
		"ervConfig"
	];
}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh-element.model.ts
var MFHElementType, pString$1, pNumber$1, MFHElementSheetImport;
var init_mfh_element_model = __esmMin((() => {
	MFHElementType = /* @__PURE__ */ function(MFHElementType) {
		MFHElementType["Window"] = "Window";
		MFHElementType["ExteriorWall"] = "ExteriorWall";
		MFHElementType["Door"] = "Door";
		MFHElementType["StairwellInnerWallArea"] = "StairwellInnerWallArea";
		MFHElementType["NetRoomArea"] = "NetRoomArea";
		MFHElementType["GrossRoomArea"] = "GrossRoomArea";
		return MFHElementType;
	}({});
	pString$1 = /* @__PURE__ */ __name((v) => v ? String(v).trim() : null, "pString");
	pNumber$1 = /* @__PURE__ */ __name((v) => {
		if (isNil(v) || v === "") return null;
		if (typeof v === "number") return v;
		const withoutUnits = String(v).trim().replace(/\s*(m²|m|cm|mm|€|%|°C).*$/i, "").trim();
		if (!withoutUnits) return null;
		const normalized = withoutUnits.replace(",", ".");
		const parsed = parseFloat(normalized);
		return Number.isNaN(parsed) ? null : parsed;
	}, "pNumber");
	MFHElementSheetImport = {
		["Window"]: [
			{
				sheetLabel: "Haus Nr.",
				path: "houseNumber",
				parse: pString$1,
				sheetType: "string"
			},
			{
				sheetLabel: "Ebene",
				path: "level",
				parse: pString$1,
				sheetType: "string"
			},
			{
				sheetLabel: "Ordnungszahl",
				path: "number",
				parse: pString$1,
				sheetType: "string"
			},
			{
				sheetLabel: "Aus Raum: Name",
				path: "room",
				parse: pString$1,
				sheetType: "string"
			},
			{
				sheetLabel: "Breite",
				path: "width",
				parse: pNumber$1,
				sheetType: "number"
			},
			{
				sheetLabel: "Höhe",
				path: "height",
				parse: pNumber$1,
				sheetType: "number"
			},
			{
				sheetLabel: "Fensterfläche",
				path: "area",
				parse: pNumber$1,
				sheetType: "number"
			},
			{
				sheetLabel: "Typenkommentare",
				path: "typeComments",
				parse: pString$1,
				sheetType: "string"
			}
		],
		["ExteriorWall"]: [
			{
				sheetLabel: "Abhängigkeit unten",
				path: "dependency",
				parse: pString$1,
				sheetType: "string"
			},
			{
				sheetLabel: "Typ",
				path: "type",
				parse: pString$1,
				sheetType: "string"
			},
			{
				sheetLabel: "Breite",
				path: "width",
				parse: pNumber$1,
				sheetType: "number"
			},
			{
				sheetLabel: "Fläche",
				path: "area",
				parse: pNumber$1,
				sheetType: "number"
			},
			{
				sheetLabel: "Sockel",
				path: "base",
				parse: pString$1,
				sheetType: "string"
			}
		],
		["Door"]: [
			{
				sheetLabel: "Haus Nr.",
				path: "houseNumber",
				parse: pString$1,
				sheetType: "string"
			},
			{
				sheetLabel: "Ebene",
				path: "level",
				parse: pString$1,
				sheetType: "string"
			},
			{
				sheetLabel: "Ordnungszahl",
				path: "number",
				parse: pString$1,
				sheetType: "string"
			},
			{
				sheetLabel: "Aus Raum: Name",
				path: "room",
				parse: pString$1,
				sheetType: "string"
			},
			{
				sheetLabel: "Breite",
				path: "width",
				parse: pNumber$1,
				sheetType: "number"
			},
			{
				sheetLabel: "Höhe",
				path: "height",
				parse: pNumber$1,
				sheetType: "number"
			},
			{
				sheetLabel: "Türfläche",
				path: "area",
				parse: pNumber$1,
				sheetType: "number"
			},
			{
				sheetLabel: "Typenkommentare",
				path: "typeComments",
				parse: pString$1,
				sheetType: "string"
			}
		],
		["StairwellInnerWallArea"]: [
			{
				sheetLabel: "Haus Nr.",
				path: "houseNumber",
				parse: pString$1,
				sheetType: "string"
			},
			{
				sheetLabel: "Ebene",
				path: "level",
				parse: pString$1,
				sheetType: "string"
			},
			{
				sheetLabel: "Ordnungszahl",
				path: "number",
				parse: pString$1,
				sheetType: "string"
			},
			{
				sheetLabel: "Name",
				path: "name",
				parse: pString$1,
				sheetType: "string"
			},
			{
				sheetLabel: "Lichte Höhe",
				path: "clearHeight",
				parse: pNumber$1,
				sheetType: "number"
			},
			{
				sheetLabel: "Umfang",
				path: "perimeter",
				parse: pNumber$1,
				sheetType: "number"
			},
			{
				sheetLabel: "Innenwandfläche",
				path: "interiorWallArea",
				parse: pNumber$1,
				sheetType: "number"
			}
		],
		["NetRoomArea"]: [
			{
				sheetLabel: "Haus Nr.",
				path: "houseNumber",
				parse: pString$1,
				sheetType: "string"
			},
			{
				sheetLabel: "Ebene",
				path: "level",
				parse: pString$1,
				sheetType: "string"
			},
			{
				sheetLabel: "Anz. Zimmer",
				path: "numberOfRooms",
				parse: pNumber$1,
				sheetType: "number"
			},
			{
				sheetLabel: "Abteilung",
				path: "section",
				parse: pString$1,
				sheetType: "string"
			},
			{
				sheetLabel: "DIN 277, m²",
				path: "din277Measure",
				parse: pNumber$1,
				sheetType: "number"
			}
		],
		["GrossRoomArea"]: [
			{
				sheetLabel: "Name",
				path: "name",
				parse: pString$1,
				sheetType: "string"
			},
			{
				sheetLabel: "Ebene",
				path: "level",
				parse: pString$1,
				sheetType: "string"
			},
			{
				sheetLabel: "Umfang",
				path: "perimeter",
				parse: pNumber$1,
				sheetType: "number"
			},
			{
				sheetLabel: "Fläche",
				path: "area",
				parse: pNumber$1,
				sheetType: "number"
			}
		]
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh-element.i18n.ts
var MFHElementTypeTranslation;
var init_mfh_element_i18n = __esmMin((() => {
	init_mfh_element_model();
	MFHElementTypeTranslation = {
		["Window"]: "Fenster",
		["ExteriorWall"]: "Außenwand",
		["Door"]: "Tür",
		["StairwellInnerWallArea"]: "Treppenhaus Innenwandfläche",
		["NetRoomArea"]: "NRF",
		["GrossRoomArea"]: "BGF"
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh-element.opts.ts
var init_mfh_element_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh-attributes.i18n.ts
var ExitTypeTranslation, RestrictionsTranslation, normalizeRestrictionLabel, RESTRICTION_LABEL_ALIASES, RESTRICTION_LABEL_LOOKUP, mapPaRestrictionLabel, mapPaRestrictionLabels;
var init_mfh_attributes_i18n = __esmMin((() => {
	init_mfh_attributes_base();
	ExitTypeTranslation = {
		["MFH"]: "MFH",
		["SingleUnit"]: "Single unit",
		["MFHSingleUnit"]: "MFH / Single unit"
	};
	RestrictionsTranslation = {
		["CompositionOfTheResidentPopulation"]: "Erhaltungsgebiet - Zusammensetzung der Wohnbevölkerung",
		["HeritageBuilding"]: "Denkmalschutz",
		["UrbanisticQuirk"]: "Erhaltungsgebiet - Städtebauliche Eigenart",
		["RedevelopmentArea"]: "Sanierungsgebiet",
		["RentControlOrRentSubsidy"]: "Mietpreisbindung / Mietförderung",
		["GroundLease"]: "Erbpacht",
		["ZoningPlan"]: "Bebauungsplan",
		["Other"]: "Andere",
		["None"]: "Nichts"
	};
	normalizeRestrictionLabel = (raw) => raw.trim().toLowerCase().replace(/ß/g, "ss").replace(/ä/g, "ae").replace(/ö/g, "oe").replace(/ü/g, "ue").replace(/[^a-z0-9]+/g, "");
	RESTRICTION_LABEL_ALIASES = {
		monumentprotection: "HeritageBuilding",
		denkmal: "HeritageBuilding",
		bauddenkmal: "HeritageBuilding",
		urbancharacterpreservation: "UrbanisticQuirk",
		socialpreservation: "CompositionOfTheResidentPopulation",
		milieuschutz: "CompositionOfTheResidentPopulation",
		milieuschutzgebiet: "CompositionOfTheResidentPopulation",
		redevelopmentarea: "RedevelopmentArea",
		zoningplan: "ZoningPlan",
		groundlease: "GroundLease",
		rentcontrol: "RentControlOrRentSubsidy",
		rentcontrolorrentsubsidy: "RentControlOrRentSubsidy",
		mietpreisbindung: "RentControlOrRentSubsidy",
		otherrestrictions: "Other"
	};
	RESTRICTION_LABEL_LOOKUP = (() => {
		const lookup = /* @__PURE__ */ new Map();
		for (const value of Object.values(Restrictions)) {
			lookup.set(normalizeRestrictionLabel(value), value);
			lookup.set(normalizeRestrictionLabel(RestrictionsTranslation[value]), value);
		}
		for (const [alias, value] of Object.entries(RESTRICTION_LABEL_ALIASES)) lookup.set(alias, value);
		return lookup;
	})();
	mapPaRestrictionLabel = (raw) => RESTRICTION_LABEL_LOOKUP.get(normalizeRestrictionLabel(raw));
	mapPaRestrictionLabels = (raw) => {
		const mapped = [];
		for (const label of raw) {
			const restriction = mapPaRestrictionLabel(label);
			if (restriction && !mapped.includes(restriction)) mapped.push(restriction);
		}
		return mapped;
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh-energy-efficiency-colors.ts
function getMfhEnergyConsumptionCategoryColor(category) {
	return MfhColorPerEnergyConsumptionCategory[category];
}
function getMfhEnergyEfficiencyBadgeColors(category) {
	const backgroundColor = getMfhEnergyConsumptionCategoryColor(category);
	if (!backgroundColor) return;
	return {
		backgroundColor,
		borderColor: backgroundColor,
		color: MfhEnergyConsumptionCategoryLabelColor
	};
}
var MfhEnergyConsumptionCategoryLabelColor, MfhColorPerEnergyConsumptionCategory;
var init_mfh_energy_efficiency_colors = __esmMin((() => {
	init_energy_efficiency();
	MfhEnergyConsumptionCategoryLabelColor = "#FFFFFF";
	MfhColorPerEnergyConsumptionCategory = {
		["A+"]: "#00A651",
		["A"]: "#57B741",
		["B"]: "#8DC63F",
		["C"]: "#C6D92F",
		["D"]: "#FFF200",
		["E"]: "#FDB913",
		["F"]: "#F7941D",
		["G"]: "#ED1C24",
		["H"]: "#BE1622"
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh-pipeline.model.ts
var PIPELINE_MFH_LEGACY_FLAT_IC_KEYS;
var init_mfh_pipeline_model = __esmMin((() => {
	PIPELINE_MFH_LEGACY_FLAT_IC_KEYS = [
		"icName",
		"icId",
		"icStatus",
		"icAssetPartnerId",
		"expectedPurchaseDiscount",
		"purchasePrice",
		"askingPriceSqm",
		"currentRentTotal",
		"currentRentSqmMonthly",
		"targetRentTotal",
		"assetValuePostRenovation",
		"assetValueIncrease",
		"rentIncreasePostRenovation",
		"multiple",
		"shareOfCommercialNri",
		"ticAfterSubsidies",
		"subsidiesPercent",
		"targetRentSqmMonthly",
		"salesPriceSqm",
		"irrPostTaxPostPromote",
		"exitMultiple",
		"annualTenantChurn",
		"renovationCostsEeSqm",
		"renovationCostsInteriorSqm",
		"expansionCostsSqm",
		"generalCapexSqm",
		"partnerFees",
		"NPPVsGrossDisposalPrice"
	];
}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh-pipeline.helpers.ts
var getShareOfCommercialNRI;
var init_mfh_pipeline_helpers = __esmMin((() => {
	getShareOfCommercialNRI = (mfh, ic) => {
		if (ic?.caseInputs) return ic.caseInputs.rent.jnkmCommercialCurrent && ic.caseInputs.rent.jnkmTotalCurrent ? ic.caseInputs.rent.jnkmCommercialCurrent / ic.caseInputs.rent.jnkmTotalCurrent : null;
		return mfh.attributes?.commercialRentalIncomeActual && mfh.attributes?.rentalIncomeActual ? mfh.attributes.commercialRentalIncomeActual / mfh.attributes.rentalIncomeActual : null;
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh-folder-structure.ts
var mfhFolderStructure;
var init_mfh_folder_structure = __esmMin((() => {
	mfhFolderStructure = [
		`0 Akquisition/Angebot, Exklusivität & NDA`,
		`0 Akquisition/D2G Kalkulationen`,
		`0 Akquisition/Due Diligence/0-Exposé & Sourcing`,
		`0 Akquisition/Due Diligence/1-Object DD`,
		`0 Akquisition/Due Diligence/1-Object DD/1.1-Grundstück/1.1.1-Flurkarte Kataster amtlicher Lageplan`,
		`0 Akquisition/Due Diligence/1-Object DD/1.1-Grundstück/1.1.2-Überbauungen`,
		`0 Akquisition/Due Diligence/1-Object DD/1.1-Grundstück/1.1.3-Umwelt`,
		`0 Akquisition/Due Diligence/1-Object DD/1.1-Grundstück/1.1.4-Gründungs- und Baugrundgutachten`,
		`0 Akquisition/Due Diligence/1-Object DD/1.1-Grundstück/1.1.5-Bodenrichtwertkarte`,
		`0 Akquisition/Due Diligence/1-Object DD/1.1-Grundstück`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)/1.2.1-Bestandspläne/1.2.1.1-Grundriss`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)/1.2.1-Bestandspläne/1.2.1.2-Ansichten`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)/1.2.1-Bestandspläne/1.2.1.3-Schnitte`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)/1.2.1-Bestandspläne/1.2.1.4-Statik`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)/1.2.1-Bestandspläne/1.2.1.5-Heizung`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)/1.2.1-Bestandspläne/1.2.1.6-Lüftung`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)/1.2.1-Bestandspläne/1.2.1.7-Klima`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)/1.2.1-Bestandspläne/1.2.1.8-Sanitär`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)/1.2.1-Bestandspläne/1.2.1.9-Elektro`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)/1.2.1-Bestandspläne`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)/1.2.2-Flächenaufmaß`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)/1.2.3-Baubeschreibung`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)/1.2.4-Gebäude Bauzustandsanalyse`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)/1.2.5-Brandschutz`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)/1.2.6-Fachplaner Verträge`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)/1.2.7-Bauerrichtung/1.2.7.1-Gewähr`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)/1.2.7-Bauerrichtung/1.2.7.2-Gewerk`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)/1.2.7-Bauerrichtung/1.2.7.3-Wartungs`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)/1.2.7-Bauerrichtung/1.2.7.4-Nachhaltig`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)/1.2.7-Bauerrichtung`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)/1.2.8-Development/1.2.8.1-Projektorganisation/1.2.8.1.1-Kosten`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)/1.2.8-Development/1.2.8.1-Projektorganisation/1.2.8.1.2-Termine`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)/1.2.8-Development/1.2.8.1-Projektorganisation/1.2.8.1.3-Gutachten u. Berichte`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)/1.2.8-Development/1.2.8.1-Projektorganisation/1.2.8.1.4-Entscheidungsvorlagen`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)/1.2.8-Development/1.2.8.1-Projektorganisation/1.2.8.1.5-Meetings`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)/1.2.8-Development/1.2.8.1-Projektorganisation`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)/1.2.8-Development/1.2.8.2-Planung LPH 1-5/1.2.8.2.1-Entwurfsplanung LPH 1-3`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)/1.2.8-Development/1.2.8.2-Planung LPH 1-5/1.2.8.2.2-Genehmigungsplanung LPH 4`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)/1.2.8-Development/1.2.8.2-Planung LPH 1-5`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)/1.2.8-Development/1.2.8.3-Ausschreibung u. Vergabe LPH 6-7`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)/1.2.8-Development/1.2.8.4-Ausführung LPH 8`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)/1.2.8-Development`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)/1.2.9-Energieausweis`,
		`0 Akquisition/Due Diligence/1-Object DD/1.2-Gebäude (Bewirtschaftung technisch)`,
		`0 Akquisition/Due Diligence/1-Object DD/1.3-Wohnungen`,
		`0 Akquisition/Due Diligence/1-Object DD/1.4-Genehmigungen/1.4.1-Baugenehmigungsunterlagen`,
		`0 Akquisition/Due Diligence/1-Object DD/1.4-Genehmigungen/1.4.2-Andere Genehmigungen`,
		`0 Akquisition/Due Diligence/1-Object DD/1.4-Genehmigungen`,
		`0 Akquisition/Due Diligence/1-Object DD/1.5-Verträge/1.5.1-Bewirtschaftungsverträge`,
		`0 Akquisition/Due Diligence/1-Object DD/1.5-Verträge/1.5.2-Versicherungsnachweise`,
		`0 Akquisition/Due Diligence/1-Object DD/1.5-Verträge/1.5.3-Betriebskostenaufstellung`,
		`0 Akquisition/Due Diligence/1-Object DD/1.5-Verträge`,
		`0 Akquisition/Due Diligence/1-Object DD/1.6-Rechtsstreitigkeiten`,
		`0 Akquisition/Due Diligence/1-Object DD/1.7-Fotos`,
		`0 Akquisition/Due Diligence/2-Vicinity DD/2.1-Lage`,
		`0 Akquisition/Due Diligence/2-Vicinity DD`,
		`0 Akquisition/Due Diligence/3-Rent DD/3.1-Mieterliste`,
		`0 Akquisition/Due Diligence/3-Rent DD/3.2-Mietverträge`,
		`0 Akquisition/Due Diligence/3-Rent DD/3.3-Kautionen`,
		`0 Akquisition/Due Diligence/3-Rent DD/3.4-Neben- & Betriebskosten`,
		`0 Akquisition/Due Diligence/3-Rent DD/3.5-Sonstiges`,
		`0 Akquisition/Due Diligence/3-Rent DD`,
		`0 Akquisition/Due Diligence/4-Technical DD/4.1-Bauwerk & Baukonstruktion`,
		`0 Akquisition/Due Diligence/4-Technical DD/4.2-Technische Gebäudeausrüstung`,
		`0 Akquisition/Due Diligence/4-Technical DD/4.3-Unterhaltungszustand`,
		`0 Akquisition/Due Diligence/4-Technical DD/4.4-Technical On-Site`,
		`0 Akquisition/Due Diligence/4-Technical DD/4.5-CAPEX`,
		`0 Akquisition/Due Diligence/4-Technical DD/4.6-DD-Berichte`,
		`0 Akquisition/Due Diligence/4-Technical DD/4.7-Red Flag Berichte`,
		`0 Akquisition/Due Diligence/4-Technical DD/4.8-Tiefgaragengutachten`,
		`0 Akquisition/Due Diligence/4-Technical DD`,
		`0 Akquisition/Due Diligence/5-Legal DD/5.1-Kaufvertrag_`,
		`0 Akquisition/Due Diligence/5-Legal DD/5.2-Mietrecht`,
		`0 Akquisition/Due Diligence/5-Legal DD`,
		`0 Akquisition/Due Diligence/6-Commercial DD/6.1-Marktberichte`,
		`0 Akquisition/Due Diligence/6-Commercial DD/6.2-Comparables`,
		`0 Akquisition/Due Diligence/6-Commercial DD`,
		`0 Akquisition/Due Diligence/7-Energy DD`,
		`0 Akquisition/Due Diligence/8-KYC`,
		`0 Akquisition/Due Diligence`,
		`0 Akquisition/Financing /Fördermittel`,
		`0 Akquisition/Financing`,
		`0 Akquisition/Investment Proposals /1-Final Version`,
		`0 Akquisition/Investment Proposals /2-Current Version`,
		`0 Akquisition/Investment Proposals /3-Past versions`,
		`0 Akquisition/Investment Proposals`,
		`0 Akquisition/SPA & Deal Closing`,
		`0 Akquisition`,
		`1 Liegenschaftsbezogene Unterlagen/1.1 Einleitung/1.1.1 Objektbeschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.1 Einleitung`,
		`1 Liegenschaftsbezogene Unterlagen/1.10 Rechtsstreitigkeiten`,
		`1 Liegenschaftsbezogene Unterlagen/1.11 Objektbezogene Arbeitsverträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.12 Zusatzinformationen für Spezialimmobilien`,
		`1 Liegenschaftsbezogene Unterlagen/1.13 Sonstige Dokumente_Verträge_Vereinbarungen`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.1 Management und Reporting/1.14.1.1 Reporting Investoren`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.1 Management und Reporting/1.14.1.2 Monthly Portfolio Update`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.1 Management und Reporting/1.14.1.3 Reporting (Finanzdienstleister)`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.1 Management und Reporting/1.14.1.4 Archiv`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.1 Management und Reporting`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.2 Projektorganisation/1.14.2.1 Projektbeteiligte`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.2 Projektorganisation/1.14.2.2 Projekthandbuch`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.2 Projektorganisation/1.14.2.3 Organigramme`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.2 Projektorganisation/1.14.2.4 Workflows`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.2 Projektorganisation/1.14.2.5 Projektvorlagen`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.2 Projektorganisation/1.14.2.6 Austausch Investment`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.2 Projektorganisation/1.14.2.7 Austausch Asset Management`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.2 Projektorganisation/1.14.2.8 Meeting Intern`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.2 Projektorganisation/1.14.2.9 MOD-Ankündigung & -Umlage`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.2 Projektorganisation/1.14.2.10 Archiv`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.2 Projektorganisation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.3 Bauherr-Investor/1.14.3.1 Geschäftsbesorgungsvertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.3 Bauherr-Investor/1.14.3.2 Bauherrnstruktur`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.3 Bauherr-Investor/1.14.3.3 Investment Committee (IC)`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.3 Bauherr-Investor/1.14.3.4 Präsentationen`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.3 Bauherr-Investor/1.14.3.5 Entscheidungsvorlagen`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.3 Bauherr-Investor/1.14.3.6 Auftragsempfehlungen`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.3 Bauherr-Investor/1.14.3.7 Vollmachten`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.3 Bauherr-Investor/1.14.3.8 Archiv`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.3 Bauherr-Investor`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.4 Bestandsunterlagen/1.14.4.1 TDD u. Datenraum Ankauf_`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.4 Bestandsunterlagen/1.14.4.2 Grundbuch`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.4 Bestandsunterlagen/1.14.4.3 Kataster- u. Lagepläne`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.4 Bestandsunterlagen/1.14.4.4 Altlasten`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.4 Bestandsunterlagen/1.14.4.5 Leitungsauskünfte`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.4 Bestandsunterlagen/1.14.4.6 Bestandsplanung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.4 Bestandsunterlagen/1.14.4.7 Nachbarn_`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.4 Bestandsunterlagen/1.14.4.8 Archiv`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.4 Bestandsunterlagen`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.5 Budget-Kosten/1.14.5.1 Gesamtbudget`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.5 Budget-Kosten/1.14.5.2 Construction/1.14.5.2.1 Kostenrahmen TDD`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.5 Budget-Kosten/1.14.5.2 Construction/1.14.5.2.2 Kostenschätzung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.5 Budget-Kosten/1.14.5.2 Construction/1.14.5.2.3 Kostenberechnung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.5 Budget-Kosten/1.14.5.2 Construction/1.14.5.2.4 Kostenanschlag_`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.5 Budget-Kosten/1.14.5.2 Construction/1.14.5.2.5 Kostenfeststellung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.5 Budget-Kosten/1.14.5.2 Construction`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.5 Budget-Kosten/1.14.5.3 MOD-Kostenermittlung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.5 Budget-Kosten/1.14.5.4 Liquiditätsplanung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.5 Budget-Kosten/1.14.5.5 Archiv`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.5 Budget-Kosten`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.6 Termine/1.14.6.1 Rahmenterminplan`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.6 Termine/1.14.6.2 Planung der Planung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.6 Termine/1.14.6.3 Ausführungsterminplan`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.6 Termine/1.14.6.4 Projektfortschrittsberichte`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.6 Termine/1.14.6.5 Archiv`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.6 Termine`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.1 Machbarkeitsstudie/1.14.7.1.1.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.1 Machbarkeitsstudie/1.14.7.1.1.2 Angebote + Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.1 Machbarkeitsstudie/1.14.7.1.1.3 Vertrag_`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.1 Machbarkeitsstudie/1.14.7.1.1.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.1 Machbarkeitsstudie/1.14.7.1.1.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.1 Machbarkeitsstudie/1.14.7.1.1.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.1 Machbarkeitsstudie`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.2 Architekturwettbewerb/1.14.7.1.2.1 Aussschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.2 Architekturwettbewerb/1.14.7.1.2.2 Angebote+Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.2 Architekturwettbewerb/1.14.7.1.2.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.2 Architekturwettbewerb/1.14.7.1.2.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.2 Architekturwettbewerb/1.14.7.1.2.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.2 Architekturwettbewerb/1.14.7.1.2.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.2 Architekturwettbewerb`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.3 B-Planverfahren/1.14.7.1.3.1 Aussschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.3 Bauherr-Investor/1.14.3.1 Geschäftsbesorgungsvertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.3 B-Planverfahren/1.14.7.1.3.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.3 B-Planverfahren/1.14.7.1.3.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.3 B-Planverfahren/1.14.7.1.3.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.3 B-Planverfahren/1.14.7.1.3.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.3 B-Planverfahren`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.4 Generalplaner/1.14.7.1.4.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.4 Generalplaner/1.14.7.1.4.2 Angebote+Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.4 Generalplaner/1.14.7.1.4.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.4 Generalplaner/1.14.7.1.4.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.4 Generalplaner/1.14.7.1.4.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.4 Generalplaner/1.14.7.1.4.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.4 Generalplaner`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.5 Designarchitekt LP 1-4/1.14.7.1.5.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.5 Designarchitekt LP 1-4/1.14.7.1.5.2 Angebote+Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.5 Designarchitekt LP 1-4/1.14.7.1.5.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.5 Designarchitekt LP 1-4/1.14.7.1.5.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.5 Designarchitekt LP 1-4/1.14.7.1.5.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.5 Designarchitekt LP 1-4/1.14.7.1.5.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.5 Designarchitekt LP 1-4`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.6 Objektplanung LP5/1.14.7.1.6.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.6 Objektplanung LP5/1.14.7.1.6.2 Angebote+Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.6 Objektplanung LP5/1.14.7.1.6.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.6 Objektplanung LP5/1.14.7.1.6.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.6 Objektplanung LP5/1.14.7.1.6.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.6 Objektplanung LP5/1.14.7.1.6.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.6 Objektplanung LP5`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.7 Technisch wirtschaftlicher Architekt 6-8 (Bauleitung)/1.14.7.1.7.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.7 Technisch wirtschaftlicher Architekt 6-8 (Bauleitung)/1.14.7.1.7.2 Angebote+Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.7 Technisch wirtschaftlicher Architekt 6-8 (Bauleitung)/1.14.7.1.7.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.7 Technisch wirtschaftlicher Architekt 6-8 (Bauleitung)/1.14.7.1.7.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.7 Technisch wirtschaftlicher Architekt 6-8 (Bauleitung)/1.14.7.1.7.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.7 Technisch wirtschaftlicher Architekt 6-8 (Bauleitung)/1.14.7.1.7.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.7 Technisch wirtschaftlicher Architekt 6-8 (Bauleitung)`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.8 Projektsteuerung/1.14.7.1.8.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.8 Projektsteuerung/1.14.7.1.8.2 Angebote+Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.8 Projektsteuerung/1.14.7.1.8.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.8 Projektsteuerung/1.14.7.1.8.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.8 Projektsteuerung/1.14.7.1.8.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.8 Projektsteuerung/1.14.7.1.8.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.8 Projektsteuerung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.9 Tragwerksplanung/1.14.7.1.9.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.9 Tragwerksplanung/1.14.7.1.9.2 Angebote+Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.9 Tragwerksplanung/1.14.7.1.9.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.9 Tragwerksplanung/1.14.7.1.9.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.9 Tragwerksplanung/1.14.7.1.9.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.9 Tragwerksplanung/1.14.7.1.9.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.9 Tragwerksplanung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.10 TGA Planung/1.14.7.1.10.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.10 TGA Planung/1.14.7.1.10.2 Angebote+Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.10 TGA Planung/1.14.7.1.10.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.10 TGA Planung/1.14.7.1.10.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.10 TGA Planung/1.14.7.1.10.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.10 TGA Planung/1.14.7.1.10.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.10 TGA Planung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.11 Energieberatung/1.14.7.1.11.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.11 Energieberatung/1.14.7.1.11.2 Angebote+Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.11 Energieberatung/1.14.7.1.11.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.11 Energieberatung/1.14.7.1.11.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.11 Energieberatung/1.14.7.1.11.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.11 Energieberatung/1.14.7.1.11.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.11 Energieberatung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.12 Brandschutzplanung/1.14.7.1.12.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.12 Brandschutzplanung/1.14.7.1.12.2 Angebote+Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.12 Brandschutzplanung/1.14.7.1.12.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.12 Brandschutzplanung/1.14.7.1.12.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.12 Brandschutzplanung/1.14.7.1.12.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.12 Brandschutzplanung/1.14.7.1.12.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.12 Brandschutzplanung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.13 Landschaftsarchitekt/1.14.7.1.13.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.13 Landschaftsarchitekt/1.14.7.1.13.2 Angebote+Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.13 Landschaftsarchitekt/1.14.7.1.13.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.13 Landschaftsarchitekt/1.14.7.1.13.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.13 Landschaftsarchitekt/1.14.7.1.13.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.13 Landschaftsarchitekt/1.14.7.1.13.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.13 Landschaftsarchitekt`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.14 Vermessung/1.14.7.1.14.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.14 Vermessung/1.14.7.1.14.2 Angebote+Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.14 Vermessung/1.14.7.1.14.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.14 Vermessung/1.14.7.1.14.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.14 Vermessung/1.14.7.1.14.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.14 Vermessung/1.14.7.1.14.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.14 Vermessung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.15 Fassadenplanung/1.14.7.1.15.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.15 Fassadenplanung/1.14.7.1.15.2 Angebote + Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.15 Fassadenplanung/1.14.7.1.15.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.15 Fassadenplanung/1.14.7.1.15.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.15 Fassadenplanung/1.14.7.1.15.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.15 Fassadenplanung/1.14.7.1.15.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.15 Fassadenplanung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.16 BIM-Koordinator/1.14.7.1.16.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.16 BIM-Koordinator/1.14.7.1.16.2 Angebote + Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.16 BIM-Koordinator/1.14.7.1.16.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.16 BIM-Koordinator/1.14.7.1.16.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.16 BIM-Koordinator/1.14.7.1.16.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.16 BIM-Koordinator/1.14.7.1.16.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.16 BIM-Koordinator`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.17 FM-Berater/1.14.7.1.17.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.17 FM-Berater/1.14.7.1.17.2 Angebote + Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.17 FM-Berater/1.14.7.1.17.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.17 FM-Berater/1.14.7.1.17.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.17 FM-Berater/1.14.7.1.17.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.17 FM-Berater/1.14.7.1.17.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.17 FM-Berater`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.18 Sonderlichtplaner/1.14.7.1.18.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.18 Sonderlichtplaner/1.14.7.1.18.2 Angebote + Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.18 Sonderlichtplaner/1.14.7.1.18.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.18 Sonderlichtplaner/1.14.7.1.18.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.18 Sonderlichtplaner/1.14.7.1.18.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.18 Sonderlichtplaner/1.14.7.1.18.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.18 Sonderlichtplaner`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.19 SiGeKo/1.14.7.1.19.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.19 SiGeKo/1.14.7.1.19.2 Angebote + Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.19 SiGeKo/1.14.7.1.19.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.19 SiGeKo/1.14.7.1.19.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.19 SiGeKo/1.14.7.1.19.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.19 SiGeKo/1.14.7.1.19.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.19 SiGeKo`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.20 Zertifizierung/1.14.7.1.20.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.20 Zertifizierung/1.14.7.1.20.2 Angebote + Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.20 Zertifizierung/1.14.7.1.20.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.20 Zertifizierung/1.14.7.1.20.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.20 Zertifizierung/1.14.7.1.20.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.20 Zertifizierung/1.14.7.1.20.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.20 Zertifizierung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.21 Innenarchitekt/1.14.7.1.21.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.21 Innenarchitekt/1.14.7.1.21.2 Angebote + Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.21 Innenarchitekt/1.14.7.1.21.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.21 Innenarchitekt/1.14.7.1.21.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.21 Innenarchitekt/1.14.7.1.21.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.21 Innenarchitekt/1.14.7.1.21.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.21 Innenarchitekt`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.22 Küchenplaner/1.14.7.1.22.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.22 Küchenplaner/1.14.7.1.22.2 Angebote + Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.22 Küchenplaner/1.14.7.1.22.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.22 Küchenplaner/1.14.7.1.22.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.22 Küchenplaner/1.14.7.1.22.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.22 Küchenplaner/1.14.7.1.22.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.22 Küchenplaner`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.23 Projektsoftware/1.14.7.1.23.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.23 Projektsoftware/1.14.7.1.23.2 Angebote + Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.23 Projektsoftware/1.14.7.1.23.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.23 Projektsoftware/1.14.7.1.23.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.23 Projektsoftware/1.14.7.1.23.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.23 Projektsoftware/1.14.7.1.23.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.23 Projektsoftware`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.24 Verkehrsplaner/1.14.7.1.24.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.24 Verkehrsplaner/1.14.7.1.24.2 Angebote + Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.24 Verkehrsplaner/1.14.7.1.24.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.24 Verkehrsplaner/1.14.7.1.24.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.24 Verkehrsplaner/1.14.7.1.24.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.24 Verkehrsplaner/1.14.7.1.24.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.24 Verkehrsplaner`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.25 Logistikplaner/1.14.7.1.25.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.25 Logistikplaner/1.14.7.1.25.2 Angebote + Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.25 Logistikplaner/1.14.7.1.25.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.25 Logistikplaner/1.14.7.1.25.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.25 Logistikplaner/1.14.7.1.25.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.25 Logistikplaner/1.14.7.1.25.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.25 Logistikplaner`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.26 Baulogistik/1.14.7.1.26.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.26 Baulogistik/1.14.7.1.26.2 Angebote + Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.26 Baulogistik/1.14.7.1.26.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.26 Baulogistik/1.14.7.1.26.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.26 Baulogistik/1.14.7.1.26.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.26 Baulogistik/1.14.7.1.26.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.26 Baulogistik`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.27 Reprodienstleistung/1.14.7.1.27.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.27 Reprodienstleistung/1.14.7.1.27.2 Angebote + Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.27 Reprodienstleistung/1.14.7.1.27.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.27 Reprodienstleistung/1.14.7.1.27.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.27 Reprodienstleistung/1.14.7.1.27.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.27 Reprodienstleistung/1.14.7.1.27.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.27 Reprodienstleistung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.28 Leitbeschilderung/1.14.7.1.28.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.28 Leitbeschilderung/1.14.7.1.28.2 Angebote + Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.28 Leitbeschilderung/1.14.7.1.28.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.28 Leitbeschilderung/1.14.7.1.28.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.28 Leitbeschilderung/1.14.7.1.28.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.28 Leitbeschilderung/1.14.7.1.28.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.28 Leitbeschilderung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.29 Wasserbau/1.14.7.1.29.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.29 Wasserbau/1.14.7.1.29.2 Angebote + Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.29 Wasserbau/1.14.7.1.29.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.29 Wasserbau/1.14.7.1.29.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.29 Wasserbau/1.14.7.1.29.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.29 Wasserbau/1.14.7.1.29.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.29 Wasserbau`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.30 Regenwasser/1.14.7.1.30.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.30 Regenwasser/1.14.7.1.30.2 Angebote + Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.30 Regenwasser/1.14.7.1.30.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.30 Regenwasser/1.14.7.1.30.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.30 Regenwasser/1.14.7.1.30.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.30 Regenwasser/1.14.7.1.30.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.30 Regenwasser`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.31 Abfallmanagement/1.14.7.1.31.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.31 Abfallmanagement/1.14.7.1.31.2 Angebote + Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.31 Abfallmanagement/1.14.7.1.31.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.31 Abfallmanagement/1.14.7.1.31.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.31 Abfallmanagement/1.14.7.1.31.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.31 Abfallmanagement/1.14.7.1.31.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.31 Abfallmanagement`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.32 Nachhaltigkeit/1.14.7.1.32.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.32 Nachhaltigkeit/1.14.7.1.32.2 Angebote + Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.32 Nachhaltigkeit/1.14.7.1.32.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.32 Nachhaltigkeit/1.14.7.1.32.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.32 Nachhaltigkeit/1.14.7.1.32.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.32 Nachhaltigkeit/1.14.7.1.32.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.32 Nachhaltigkeit`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.33 Bauphysik`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.34 SV, Gutachter und Berater/1.14.7.1.34.1 Schadstoffe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.34 SV, Gutachter und Berater/1.14.7.1.34.2 Boden & Baugrund`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.34 SV, Gutachter und Berater/1.14.7.1.34.3 Prüfstatiker`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.34 SV, Gutachter und Berater/1.14.7.1.34.4 SV Brandschutz`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.34 SV, Gutachter und Berater/1.14.7.1.34.5 Schallschutz`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.34 SV, Gutachter und Berater/1.14.7.1.34.6 Artenschutz`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung/1.14.7.1.34 SV, Gutachter und Berater`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.1 Planung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.1 GU/1.14.7.2.1.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.1 GU/1.14.7.2.1.2 Angebote+Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.1 GU/1.14.7.2.1.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.1 GU/1.14.7.2.1.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.1 GU/1.14.7.2.1.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.1 GU/1.14.7.2.1.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.1 GU`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.2 Infrastruktur+Erschließung/1.14.7.2.2.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.2 Infrastruktur+Erschließung/1.14.7.2.2.2 Angebote+Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.2 Infrastruktur+Erschließung/1.14.7.2.2.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.2 Infrastruktur+Erschließung/1.14.7.2.2.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.2 Infrastruktur+Erschließung/1.14.7.2.2.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.2 Infrastruktur+Erschließung/1.14.7.2.2.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.2 Infrastruktur+Erschließung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.3 Logistik/1.14.7.2.3.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.3 Logistik/1.14.7.2.3.2 Angebote+Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.3 Logistik/1.14.7.2.3.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.3 Logistik/1.14.7.2.3.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.3 Logistik/1.14.7.2.3.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.3 Logistik/1.14.7.2.3.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.3 Logistik`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.4 Bauzaun/1.14.7.2.4.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.4 Bauzaun/1.14.7.2.4.2 Angebote+Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.4 Bauzaun/1.14.7.2.4.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.4 Bauzaun/1.14.7.2.4.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.4 Bauzaun/1.14.7.2.4.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.4 Bauzaun/1.14.7.2.4.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.4 Bauzaun`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.5 Baustellenüberwachung/1.14.7.2.5.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.5 Baustellenüberwachung/1.14.7.2.5.2 Angebote+Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.5 Baustellenüberwachung/1.14.7.2.5.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.5 Baustellenüberwachung/1.14.7.2.5.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.5 Baustellenüberwachung/1.14.7.2.5.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.5 Baustellenüberwachung/1.14.7.2.5.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.5 Baustellenüberwachung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.6 Abbruch/1.14.7.2.6.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.6 Abbruch/1.14.7.2.6.2 Angebote+Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.6 Abbruch/1.14.7.2.6.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.6 Abbruch/1.14.7.2.6.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.6 Abbruch/1.14.7.2.6.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.6 Abbruch/1.14.7.2.6.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.6 Abbruch`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.7 Tiefbau/1.14.7.2.7.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.7 Tiefbau/1.14.7.2.7.2 Angebote+Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.7 Tiefbau/1.14.7.2.7.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.7 Tiefbau/1.14.7.2.7.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.7 Tiefbau/1.14.7.2.7.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.7 Tiefbau/1.14.7.2.7.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.7 Tiefbau`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.8 Rohbau/1.14.7.2.8.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.8 Rohbau/1.14.7.2.8.2 Angebote+Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.8 Rohbau/1.14.7.2.8.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.8 Rohbau/1.14.7.2.8.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.8 Rohbau/1.14.7.2.8.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.8 Rohbau/1.14.7.2.8.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.8 Rohbau`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.9 Dach/1.14.7.2.9.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.9 Dach/1.14.7.2.9.2 Angebote+Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.9 Dach/1.14.7.2.9.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.9 Dach/1.14.7.2.9.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.9 Dach/1.14.7.2.9.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.9 Dach/1.14.7.2.9.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.9 Dach`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.10 Fassade/1.14.7.2.10.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.10 Fassade/1.14.7.2.10.2 Angebote+Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.10 Fassade/1.14.7.2.10.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.10 Fassade/1.14.7.2.10.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.10 Fassade/1.14.7.2.10.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.10 Fassade/1.14.7.2.10.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.10 Fassade`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.11 Innenausbau/1.14.7.2.11.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.11 Innenausbau/1.14.7.2.11.2 Angebote+Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.11 Innenausbau/1.14.7.2.11.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.11 Innenausbau/1.14.7.2.11.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.11 Innenausbau/1.14.7.2.11.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.11 Innenausbau/1.14.7.2.11.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.11 Innenausbau`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.12 Heizung+Sanitär/1.14.7.2.12.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.12 Heizung+Sanitär/1.14.7.2.12.2 Angebote+Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.12 Heizung+Sanitär/1.14.7.2.12.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.12 Heizung+Sanitär/1.14.7.2.12.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.12 Heizung+Sanitär/1.14.7.2.12.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.12 Heizung+Sanitär/1.14.7.2.12.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.12 Heizung+Sanitär`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.13 Lüftung+Kälte/1.14.7.2.13.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.13 Lüftung+Kälte/1.14.7.2.13.2 Angebote+Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.13 Lüftung+Kälte/1.14.7.2.13.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.13 Lüftung+Kälte/1.14.7.2.13.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.13 Lüftung+Kälte/1.14.7.2.13.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.13 Lüftung+Kälte/1.14.7.2.13.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.13 Lüftung+Kälte`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.14 Elektro/1.14.7.2.14.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.14 Elektro/1.14.7.2.14.2 Angebote+Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.14 Elektro/1.14.7.2.14.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.14 Elektro/1.14.7.2.14.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.14 Elektro/1.14.7.2.14.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.14 Elektro/1.14.7.2.14.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.14 Elektro`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.15 Gebäudeautomation/1.14.7.2.15.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.15 Gebäudeautomation/1.14.7.2.15.2 Angebote+Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.15 Gebäudeautomation/1.14.7.2.15.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.15 Gebäudeautomation/1.14.7.2.15.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.15 Gebäudeautomation/1.14.7.2.15.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.15 Gebäudeautomation/1.14.7.2.15.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.15 Gebäudeautomation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.16 Förderanlagen/1.14.7.2.16.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.16 Förderanlagen/1.14.7.2.16.2 Angebote+Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.16 Förderanlagen/1.14.7.2.16.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.16 Förderanlagen/1.14.7.2.16.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.16 Förderanlagen/1.14.7.2.16.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.16 Förderanlagen/1.14.7.2.16.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.16 Förderanlagen`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.17 Leitbeschilderung/1.14.7.2.17.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.17 Leitbeschilderung/1.14.7.2.17.2 Angebote+Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.17 Leitbeschilderung/1.14.7.2.17.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.17 Leitbeschilderung/1.14.7.2.17.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.17 Leitbeschilderung/1.14.7.2.17.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.17 Leitbeschilderung/1.14.7.2.17.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.17 Leitbeschilderung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.18 Freianlagen/1.14.7.2.18.1 Ausschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.18 Freianlagen/1.14.7.2.18.2 Angebote+Vergabe`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.18 Freianlagen/1.14.7.2.18.3 Vertrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.18 Freianlagen/1.14.7.2.18.4 Nachträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.18 Freianlagen/1.14.7.2.18.5 Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.18 Freianlagen/1.14.7.2.18.6 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung/1.14.7.2.18 Freianlagen`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.2 Ausführung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors/1.14.7.3 Archiv`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.7 Contractors`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.1 Gutachten und Berichte`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.2 Machbarkeitsstudie`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.3 Behördenkorrespondenz`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.4 Vorplanung/1.14.8.4.1 Planung inhouse`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.4 Vorplanung/1.14.8.4.2 Generalplaner`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.4 Vorplanung/1.14.8.4.3 Architektur`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.4 Vorplanung/1.14.8.4.4 TGA`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.4 Vorplanung/1.14.8.4.5 Tragwerksplanung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.4 Vorplanung/1.14.8.4.6 Bauphysik`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.4 Vorplanung/1.14.8.4.7 LA`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.4 Vorplanung/1.14.8.4.8 Brandschutz`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.4 Vorplanung/1.14.8.4.9 Verkehrsplaner`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.4 Vorplanung/1.14.8.4.10 Nachhaltigkeit+Artenschutz`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.4 Vorplanung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.5 Entwurfsplanung/1.14.8.5.1 Planung inhouse`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.5 Entwurfsplanung/1.14.8.5.2 Generalplaner`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.5 Entwurfsplanung/1.14.8.5.3 Architektur`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.5 Entwurfsplanung/1.14.8.5.4 TGA`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.5 Entwurfsplanung/1.14.8.5.5 Tragwerksplanung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.5 Entwurfsplanung/1.14.8.5.6 Bauphysik`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.5 Entwurfsplanung/1.14.8.5.7 LA`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.5 Entwurfsplanung/1.14.8.5.8 Brandschutz`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.5 Entwurfsplanung/1.14.8.5.9 Verkehrsplaner`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.5 Entwurfsplanung/1.14.8.5.10 Nachhaltigkeit+Artenschutz`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.5 Entwurfsplanung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.6 Baugenehmigung/1.14.8.6.1 Genehmigungsplanung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.6 Baugenehmigung/1.14.8.6.2 Bauantrag`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.6 Baugenehmigung/1.14.8.6.3 Genehmigung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.6 Baugenehmigung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.7 Ausführungsplanung/1.14.8.7.1 Planung inhouse`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.7 Ausführungsplanung/1.14.8.7.2 Generalplaner`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.7 Ausführungsplanung/1.14.8.7.3 Architektur`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.7 Ausführungsplanung/1.14.8.7.4 TGA`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.7 Ausführungsplanung/1.14.8.7.5 Tragwerksplanung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.7 Ausführungsplanung/1.14.8.7.6 Bauphysik`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.7 Ausführungsplanung/1.14.8.7.7 LA`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.7 Ausführungsplanung/1.14.8.7.8 Brandschutz`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.7 Ausführungsplanung/1.14.8.7.9 Verkehrsplaner`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.7 Ausführungsplanung/1.14.8.7.10 Nachhaltigkeit+Artenschutz`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.7 Ausführungsplanung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.8 Baubeschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.9 Konzepte`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.10 Energieassessment`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung/1.14.8.11 Archiv`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.8 Planung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.9 Projektrealisierung/1.14.9.1 Baukommunikation intern`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.9 Projektrealisierung/1.14.9.2 Baukommunikation extern`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.9 Projektrealisierung/1.14.9.3 Baubesprechungen`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.9 Projektrealisierung/1.14.9.4 Baustellendokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.9 Projektrealisierung/1.14.9.5 Rechnungsprüfung/01 Re eingegangen`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.9 Projektrealisierung/1.14.9.5 Rechnungsprüfung/02 Re geprüft`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.9 Projektrealisierung/1.14.9.5 Rechnungsprüfung/03 Re freigegeben`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.9 Projektrealisierung/1.14.9.5 Rechnungsprüfung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.9 Projektrealisierung/1.14.9.6 SiGeKo-Unterlagen`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.9 Projektrealisierung/1.14.9.7 Archiv`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.9 Projektrealisierung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.10 Projektabschluss/1.14.10.1 Abnahmeprotokolle`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.10 Projektabschluss/1.14.10.2 Mängelmanagement u. Gewährleistung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.10 Projektabschluss/1.14.10.3 Revisionsunterlagen`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.10 Projektabschluss/1.14.10.4 Projektabschlussbericht`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.10 Projektabschluss/1.14.10.5 Lessons Learned`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.10 Projektabschluss/1.14.10.6 Archiv`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.10 Projektabschluss`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.11 Betrieb/1.14.11.1 Dienstleister`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.11 Betrieb/1.14.11.2 Versorger`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.11 Betrieb/1.14.11.3 Nebenkosten`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.11 Betrieb/1.14.11.4 Zertifizierungen`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.11 Betrieb/1.14.11.5 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.11 Betrieb/1.14.11.6 Archiv`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.11 Betrieb`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.12 Leerwohnungssanierung/Vom Team _Renovation_ zu strukturieren`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.12 Leerwohnungssanierung`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development/1.14.13 Bilder & Baudokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.14 Development`,
		`1 Liegenschaftsbezogene Unterlagen/1.2 Grundstück/1.2.1 Flurkarte_Kataster_amtlicher Lageplan`,
		`1 Liegenschaftsbezogene Unterlagen/1.2 Grundstück/1.2.2 Überbauungen`,
		`1 Liegenschaftsbezogene Unterlagen/1.2 Grundstück/1.2.3 Umwelt`,
		`1 Liegenschaftsbezogene Unterlagen/1.2 Grundstück/1.2.4 Gründungs- und Baugrundgutachten`,
		`1 Liegenschaftsbezogene Unterlagen/1.2 Grundstück/1.2.5 Bodenrichtwertkarte`,
		`1 Liegenschaftsbezogene Unterlagen/1.2 Grundstück`,
		`1 Liegenschaftsbezogene Unterlagen/1.3 Eigentum/1.3.1 Handelsregisterauszug des eingetragenen Eigentümers`,
		`1 Liegenschaftsbezogene Unterlagen/1.3 Eigentum/1.3.2 Grundbuchauszug`,
		`1 Liegenschaftsbezogene Unterlagen/1.3 Eigentum/1.3.3 Erbbaurechtsverträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.3 Eigentum/1.3.4 Nachbarschaftsverträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.3 Eigentum/1.3.5 Teileigentum`,
		`1 Liegenschaftsbezogene Unterlagen/1.3 Eigentum`,
		`1 Liegenschaftsbezogene Unterlagen/1.4 Bauplanungsrecht/1.4.1 Flächennutzungsplan`,
		`1 Liegenschaftsbezogene Unterlagen/1.4 Bauplanungsrecht/1.4.2 Bebauungsplan`,
		`1 Liegenschaftsbezogene Unterlagen/1.4 Bauplanungsrecht/1.4.3 Denkmalschutz`,
		`1 Liegenschaftsbezogene Unterlagen/1.4 Bauplanungsrecht/1.4.4 Erschließung`,
		`1 Liegenschaftsbezogene Unterlagen/1.4 Bauplanungsrecht/1.4.5 Städtebauliche Verträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.4 Bauplanungsrecht/1.4.6 Umlegungs, Sanierungs, Entwickl., Erhaltungssatzung`,
		`1 Liegenschaftsbezogene Unterlagen/1.4 Bauplanungsrecht/1.4.7 Behördliche Bescheinigungen`,
		`1 Liegenschaftsbezogene Unterlagen/1.4 Bauplanungsrecht`,
		`1 Liegenschaftsbezogene Unterlagen/1.5 Bauordnungsrecht/1.5.1 Baugenehmigungsunterlagen`,
		`1 Liegenschaftsbezogene Unterlagen/1.5 Bauordnungsrecht/1.5.2 Andere Genehmigungen`,
		`1 Liegenschaftsbezogene Unterlagen/1.5 Bauordnungsrecht`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.1 Projektorganisation/1.6.1.1 Projektbeteiligte`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.1 Projektorganisation/1.6.1.2 Projekthandbuch`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.1 Projektorganisation/1.6.1.3 MOD-Ankündigung u. -umlage`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.1 Projektorganisation`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.2 Bauherr - Investor/1.6.2.1 Entscheidungsvorlagen`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.2 Bauherr - Investor/1.6.2.2 Auftragsempfehlungen`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.2 Bauherr - Investor/1.6.2.3 sonstige Informationen`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.2 Bauherr - Investor`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.3 Bestandspläne/1.6.3.1 Grundrisse`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.3 Bestandspläne/1.6.3.2 Ansichten`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.3 Bestandspläne/1.6.3.3 Schnitte`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.3 Bestandspläne/1.6.3.4 Statik`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.3 Bestandspläne/1.6.3.5 Heizung`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.3 Bestandspläne/1.6.3.6 Lüftung`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.3 Bestandspläne/1.6.3.7 Sanitär`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.3 Bestandspläne/1.6.3.8 Elektro`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.3 Bestandspläne`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.4 Bestandsaufmaß`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.5 Bestandsanalyse/1.6.5.1 Schadstoffgutachten`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.5 Bestandsanalyse/1.6.5.2 Bauteiluntersuchungen`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.5 Bestandsanalyse/1.6.5.3 sonstige Untersuchungen`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.5 Bestandsanalyse`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.6 Planung/1.6.6.1 Gutachten und Berichte`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.6 Planung/1.6.6.2 Machbarkeitsstudie`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.6 Planung/1.6.6.3 Behördenkorrespondenzen`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.6 Planung/1.6.6.4 Vorplanung`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.6 Planung/1.6.6.5 Entwurfsplanung`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.6 Planung/1.6.6.6 Bauantrag & - genehmigung`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.6 Planung/1.6.6.7 Ausführungsplanung`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.6 Planung/1.6.6.8 Baubeschreibung`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.6 Planung/1.6.6.9 Konzepte`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.6 Planung/1.6.6.10 Energieassessment`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.6 Planung`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.7 Projektrealisierung/1.6.7.1 Baukommunikation extern`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.7 Projektrealisierung/1.6.7.2 Baubesprechungen`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.7 Projektrealisierung/1.6.7.3 Baustellendokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.7 Projektrealisierung`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.8 Projektabschluss/1.6.8.1 Abnahmeprotokolle`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.8 Projektabschluss/1.6.8.2 Mängelmanagement u. Gewährleistung`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.8 Projektabschluss/1.6.8.3 Revisionsunterlagen`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.8 Projektabschluss/1.6.8.4 Dokumentation`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.8 Projektabschluss/1.6.8.5 Projektabschlussbericht`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.8 Projektabschluss`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.9 Wohnungssanierung`,
		`1 Liegenschaftsbezogene Unterlagen/1.6 Gebäude (technische Bewirtschaftung)/1.6.10 Fachplaner & Contractor`,
		`1 Liegenschaftsbezogene Unterlagen/1.7 Mieter/1.7.1 Übersicht Mietverhältnisse _Nutzungsverhältnisse`,
		`1 Liegenschaftsbezogene Unterlagen/1.7 Mieter/1.7.2 Mietverträge (inklusive aller Nachträge)`,
		`1 Liegenschaftsbezogene Unterlagen/1.7 Mieter/1.7.3 Mietsicherheiten`,
		`1 Liegenschaftsbezogene Unterlagen/1.7 Mieter/1.7.4 Mietrückstände`,
		`1 Liegenschaftsbezogene Unterlagen/1.7 Mieter/1.7.5 Übergabeprotokolle`,
		`1 Liegenschaftsbezogene Unterlagen/1.7 Mieter/1.7.6 Mietanpassungen_Dauermietrechnung`,
		`1 Liegenschaftsbezogene Unterlagen/1.7 Mieter/1.7.7 Kündigungen`,
		`1 Liegenschaftsbezogene Unterlagen/1.7 Mieter/1.7.8 Nebenkostenabrechnung`,
		`1 Liegenschaftsbezogene Unterlagen/1.7 Mieter/1.7.9 Wichtiger Schriftverkehr`,
		`1 Liegenschaftsbezogene Unterlagen/1.7 Mieter`,
		`1 Liegenschaftsbezogene Unterlagen/1.8 Bewirtschaftung (kaufmännisch)/1.8.1 Bewirtschaftungsverträge`,
		`1 Liegenschaftsbezogene Unterlagen/1.8 Bewirtschaftung (kaufmännisch)/1.8.2 Versicherungsnachweise`,
		`1 Liegenschaftsbezogene Unterlagen/1.8 Bewirtschaftung (kaufmännisch)/1.8.3 Betriebskostenaufstellung`,
		`1 Liegenschaftsbezogene Unterlagen/1.8 Bewirtschaftung (kaufmännisch)`,
		`1 Liegenschaftsbezogene Unterlagen/1.9 Steuern/1.9.1 Grundsteuerbescheide_Grundbesitzabgabenbescheide`,
		`1 Liegenschaftsbezogene Unterlagen/1.9 Steuern/1.9.2 Einheitswertbescheide_Einheitswerterklärungen`,
		`1 Liegenschaftsbezogene Unterlagen/1.9 Steuern/1.9.3 Sonstige Kommunalabgaben`,
		`1 Liegenschaftsbezogene Unterlagen/1.9 Steuern/1.9.4 Berichtigungsbestände und laufende Berichtigungszeiträume`,
		`1 Liegenschaftsbezogene Unterlagen/1.9 Steuern/1.9.5 Umsatzsteuer/1.9.5.1 Mieter`,
		`1 Liegenschaftsbezogene Unterlagen/1.9 Steuern/1.9.5 Umsatzsteuer/1.9.5.2 Verkäufer`,
		`1 Liegenschaftsbezogene Unterlagen/1.9 Steuern/1.9.5 Umsatzsteuer`,
		`1 Liegenschaftsbezogene Unterlagen/1.9 Steuern/1.9.6 Optionssätze_Flächenschlüssel`,
		`1 Liegenschaftsbezogene Unterlagen/1.9 Steuern`,
		`1 Liegenschaftsbezogene Unterlagen`,
		`2 Gesellschaftsbezogene Unterlagen/2.1 Gesellschaft/2.1.1 Übersicht`,
		`2 Gesellschaftsbezogene Unterlagen/2.1 Gesellschaft/2.1.2 Handelsregisterauszug`,
		`2 Gesellschaftsbezogene Unterlagen/2.1 Gesellschaft/2.1.3 Übertragung von Gesellschaftsanteilen`,
		`2 Gesellschaftsbezogene Unterlagen/2.1 Gesellschaft/2.1.4 Registerauszüge_Anmeldungen`,
		`2 Gesellschaftsbezogene Unterlagen/2.1 Gesellschaft/2.1.5 Aktienbuch`,
		`2 Gesellschaftsbezogene Unterlagen/2.1 Gesellschaft/2.1.6 Gesellschafterliste`,
		`2 Gesellschaftsbezogene Unterlagen/2.1 Gesellschaft`,
		`2 Gesellschaftsbezogene Unterlagen/2.2 Satzung/2.2.1 Satzung`,
		`2 Gesellschaftsbezogene Unterlagen/2.2 Satzung/2.2.2 Satzungsändernde Beschlüsse`,
		`2 Gesellschaftsbezogene Unterlagen/2.2 Satzung`,
		`2 Gesellschaftsbezogene Unterlagen/2.3 Gesellschafterbeschlüsse/2.3.1 Beschlüsse betreffend die Satzung`,
		`2 Gesellschaftsbezogene Unterlagen/2.3 Gesellschafterbeschlüsse/2.3.2 Gewinnverteilungsbeschlüsse`,
		`2 Gesellschaftsbezogene Unterlagen/2.3 Gesellschafterbeschlüsse/2.3.3 Kapitalausstattungsbeschlüsse`,
		`2 Gesellschaftsbezogene Unterlagen/2.3 Gesellschafterbeschlüsse/2.3.4 Sonstige Beschlüsse`,
		`2 Gesellschaftsbezogene Unterlagen/2.3 Gesellschafterbeschlüsse`,
		`2 Gesellschaftsbezogene Unterlagen/2.4 Geschäftsführung/2.4.1 Geschäftsführerbeschlüsse`,
		`2 Gesellschaftsbezogene Unterlagen/2.4 Geschäftsführung/2.4.2 Protokolle`,
		`2 Gesellschaftsbezogene Unterlagen/2.4 Geschäftsführung/2.4.3 Vereinbarungen mit der Geschäftsführung`,
		`2 Gesellschaftsbezogene Unterlagen/2.4 Geschäftsführung`,
		`2 Gesellschaftsbezogene Unterlagen/2.5 Gesellschaftsbezogene Verträge/2.5.1 Buchhaltung`,
		`2 Gesellschaftsbezogene Unterlagen/2.5 Gesellschaftsbezogene Verträge/2.5.2 Wirtschaftsprüfer`,
		`2 Gesellschaftsbezogene Unterlagen/2.5 Gesellschaftsbezogene Verträge/2.5.3 Steuerberater`,
		`2 Gesellschaftsbezogene Unterlagen/2.5 Gesellschaftsbezogene Verträge/2.5.4 Sonstige Verträge`,
		`2 Gesellschaftsbezogene Unterlagen/2.5 Gesellschaftsbezogene Verträge`,
		`2 Gesellschaftsbezogene Unterlagen/2.6 Grundstückskaufvertrag (Ankauf)`,
		`2 Gesellschaftsbezogene Unterlagen/2.7 Finanzen/2.7.1 Jahresabschlüsse`,
		`2 Gesellschaftsbezogene Unterlagen/2.7 Finanzen/2.7.2 Steuern`,
		`2 Gesellschaftsbezogene Unterlagen/2.7 Finanzen/2.7.3 Management Reporting`,
		`2 Gesellschaftsbezogene Unterlagen/2.7 Finanzen/2.7.4 Verbindlichkeiten (inkl. off-balance)`,
		`2 Gesellschaftsbezogene Unterlagen/2.7 Finanzen/2.7.5 Aktuelle Salden`,
		`2 Gesellschaftsbezogene Unterlagen/2.7 Finanzen/2.7.6 Sonstige Finanzinformationen`,
		`2 Gesellschaftsbezogene Unterlagen/2.7 Finanzen`,
		`2 Gesellschaftsbezogene Unterlagen`,
		`3 Controlling & Reporting/3.1 Reporting/3.1.1 Reporting_AM_Buchhaltung`,
		`3 Controlling & Reporting/3.1 Reporting/3.1.2 Kontoauszüge`,
		`3 Controlling & Reporting/3.1 Reporting/3.1.3 BKA Hochrechnung`,
		`3 Controlling & Reporting/3.1 Reporting/3.1.4 Rückstellungsspiegel`,
		`3 Controlling & Reporting/3.1 Reporting/3.1.5 Business Plan_Budget`,
		`3 Controlling & Reporting/3.1 Reporting`,
		`3 Controlling & Reporting/3.2 Rechnungen/3.2.1 Zahlungsvorschlagsliste/2021/KW 1`,
		`3 Controlling & Reporting/3.2 Rechnungen/3.2.1 Zahlungsvorschlagsliste/2021/KW 2`,
		`3 Controlling & Reporting/3.2 Rechnungen/3.2.1 Zahlungsvorschlagsliste/2021`,
		`3 Controlling & Reporting/3.2 Rechnungen/3.2.1 Zahlungsvorschlagsliste`,
		`3 Controlling & Reporting/3.2 Rechnungen/3.2.2 Posteingang`,
		`3 Controlling & Reporting/3.2 Rechnungen/3.2.3 Rechnungen zurückgewiesen`,
		`3 Controlling & Reporting/3.2 Rechnungen/3.2.4 Kreditoren`,
		`3 Controlling & Reporting/3.2 Rechnungen`,
		`3 Controlling & Reporting/3.3 Angebote`,
		`3 Controlling & Reporting`
	];
}));
//#endregion
//#region src/domains/cross-cutting/mfh/renovation-project/addendum/addendum.model.ts
var AddendumStatus, ADDENDUM_ESTABLISHED_STATUS, AddendumReason, BaseAddendumSchema, Addendum;
var init_addendum_model = __esmMin((() => {
	init_shared_schemas();
	AddendumStatus = /* @__PURE__ */ function(AddendumStatus) {
		AddendumStatus["PendingInitialReview"] = "PendingInitialReview";
		AddendumStatus["PendingClarification"] = "PendingClarification";
		AddendumStatus["PendingNegotiation"] = "PendingNegotiation";
		AddendumStatus["PendingContractUpload"] = "PendingContractUpload";
		AddendumStatus["PendingApproval"] = "PendingApproval";
		AddendumStatus["Rejected"] = "Rejected";
		AddendumStatus["Completed"] = "Completed";
		return AddendumStatus;
	}({});
	ADDENDUM_ESTABLISHED_STATUS = ["Completed"];
	AddendumReason = /* @__PURE__ */ function(AddendumReason) {
		AddendumReason["ConstructionHindrance"] = "ConstructionHindrance";
		AddendumReason["AccelerationMeasures"] = "AccelerationMeasures";
		AddendumReason["QuantityChange"] = "QuantityChange";
		AddendumReason["ScopeChange"] = "ScopeChange";
		AddendumReason["AdditionalScope"] = "AdditionalScope";
		AddendumReason["RemovedScope"] = "RemovedScope";
		AddendumReason["Other"] = "Other";
		return AddendumReason;
	}({});
	BaseAddendumSchema = Type.Object({
		addendumId: Type.Number(),
		name: Type.String(),
		addendumNumber: Type.Number(),
		formattedAddendumNumber: Type.Optional(TNullable(Type.String())),
		mfhId: Type.Number(),
		mfhRenovationProjectId: Type.Number(),
		contractorCompanyId: Type.Number(),
		contractorCompanyContactId: TNullable(Type.Number()),
		reviewerContactId: Type.Number(),
		contractId: TNullable(Type.Number()),
		description: Type.String(),
		reason: Type.String(),
		netAmountRequest: TDecimal,
		netAmountActual: TNullable(TDecimal),
		scheduleImpact: TNullable(Type.String()),
		status: TNullable(Type.Enum(AddendumStatus)),
		negotiationDate: TNullable(StringDateSchema),
		negotiationResults: TNullable(Type.String()),
		scheduleImpactUpdate: TNullable(Type.String()),
		rejectionReason: TNullable(Type.String()),
		isApprovalSkipped: Type.Boolean(),
		createdAt: Type.Optional(StringDateSchema),
		updatedAt: Type.Optional(StringDateSchema)
	});
	Addendum = class {
		mfh;
		mfhRenovationProject;
		contractorCompany;
		contractorCompanyContact;
		contract;
		reviewerContact;
		signOffEnvelopes;
		documents;
		constructor(props) {
			Object.assign(this, props);
			this.negotiationDate = props.negotiationDate != null ? new Date(props.negotiationDate) : null;
			this.netAmountRequest = props.netAmountRequest != null ? new Decimal(props.netAmountRequest) : null;
			this.netAmountActual = props.netAmountActual != null ? new Decimal(props.netAmountActual) : null;
			this.isApprovalSkipped = props.isApprovalSkipped ?? false;
		}
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/renovation-project/addendum/addendum.opts.ts
var init_addendum_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/renovation-project/addendum/addendum.i18n.ts
var addendumReasonTranslationMap, AddendumStatusTranslation;
var init_addendum_i18n = __esmMin((() => {
	init_addendum_model();
	addendumReasonTranslationMap = {
		["ConstructionHindrance"]: "Behinderung auf dem Bau",
		["AccelerationMeasures"]: "Beschleunigungsmaßnahmen",
		["QuantityChange"]: "Mengenänderung",
		["ScopeChange"]: "Leistungsänderung",
		["AdditionalScope"]: "Zusatzleistung",
		["RemovedScope"]: "Entfallende Leistung",
		["Other"]: "Sonstige"
	};
	AddendumStatusTranslation = {
		["PendingInitialReview"]: "Pending Initial Review",
		["PendingClarification"]: "Pending Clarification",
		["PendingNegotiation"]: "Pending Negotiation",
		["PendingContractUpload"]: "Pending Contract Upload",
		["PendingApproval"]: "Pending Approval",
		["Rejected"]: "Rejected",
		["Completed"]: "Completed"
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/renovation-project/addendum/addendum-process.base.ts
var AddendumEvent;
var init_addendum_process_base = __esmMin((() => {
	AddendumEvent = /* @__PURE__ */ function(AddendumEvent) {
		AddendumEvent["SubmitForInitialReview"] = "SubmitForInitialReview";
		AddendumEvent["ClarificationRequested"] = "ClarificationRequested";
		AddendumEvent["NegotiationStarted"] = "NegotiationStarted";
		AddendumEvent["NegotiationFinished"] = "NegotiationFinished";
		AddendumEvent["ApprovalRequested"] = "ApprovalRequested";
		AddendumEvent["Approved"] = "Approved";
		AddendumEvent["ApprovalNotRequired"] = "ApprovalNotRequired";
		AddendumEvent["Rejected"] = "Rejected";
		return AddendumEvent;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/mfh/renovation-project/addendum/index.ts
var init_addendum = __esmMin((() => {
	init_addendum_model();
	init_addendum_opts();
	init_addendum_i18n();
	init_addendum_process_base();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/renovation-project/mfh-renovation-project-cost-breakdown-process.base.ts
var MFHRenovationProjectCostBreakdownReviewState, MFHRenovationProjectCostBreakdownEvent, MFHRenovationProjectCostBreakdownProcessType, MFHRenovationProjectCostBreakdownProcessStateMapping, MFHRenovationProjectCostBreakdownState;
var init_mfh_renovation_project_cost_breakdown_process_base = __esmMin((() => {
	MFHRenovationProjectCostBreakdownReviewState = /* @__PURE__ */ function(MFHRenovationProjectCostBreakdownReviewState) {
		MFHRenovationProjectCostBreakdownReviewState["Draft"] = "Draft";
		MFHRenovationProjectCostBreakdownReviewState["Review"] = "Review";
		MFHRenovationProjectCostBreakdownReviewState["Approved"] = "Approved";
		MFHRenovationProjectCostBreakdownReviewState["Rejected"] = "Rejected";
		return MFHRenovationProjectCostBreakdownReviewState;
	}({});
	MFHRenovationProjectCostBreakdownEvent = /* @__PURE__ */ function(MFHRenovationProjectCostBreakdownEvent) {
		MFHRenovationProjectCostBreakdownEvent["RequestReview"] = "RequestReview";
		MFHRenovationProjectCostBreakdownEvent["Revert"] = "Revert";
		return MFHRenovationProjectCostBreakdownEvent;
	}({});
	MFHRenovationProjectCostBreakdownProcessType = /* @__PURE__ */ function(MFHRenovationProjectCostBreakdownProcessType) {
		MFHRenovationProjectCostBreakdownProcessType["Review"] = "MFHRenovationProjectCostBreakdownReview";
		return MFHRenovationProjectCostBreakdownProcessType;
	}({});
	MFHRenovationProjectCostBreakdownProcessStateMapping = { ["MFHRenovationProjectCostBreakdownReview"]: MFHRenovationProjectCostBreakdownReviewState };
	MFHRenovationProjectCostBreakdownState = { ...MFHRenovationProjectCostBreakdownReviewState };
}));
//#endregion
//#region src/domains/cross-cutting/mfh/renovation-project/mfh-renovation-project.model.ts
var MFHRenovationProjectPlanningModuleEvents, MFHRenovationProjectEvents, MFHRenovationProjectMeasuresPackage, MFHRenovationProjectLotEvents, MfhRenovationProjectState, MFHRenovationProjectProcessType, MFHRenovationProjectProcessStateMapping, BaseMFHRenovationProjectSchema, MfhRenovationProjectPlanningSetup, MFHRenovationProjectBudgetType, BaseMFHRenovationProjectBudgetSchema, MfhRenovationProjectMeasuresPackageBudgetsSchema, BaseMFHRenovationProjectCostBreakdownSchema, getMeasurePackageBudgetComponents;
var init_mfh_renovation_project_model = __esmMin((() => {
	init_shared_schemas();
	init_mfh_renovation_project_cost_breakdown_process_base();
	MFHRenovationProjectPlanningModuleEvents = /* @__PURE__ */ function(MFHRenovationProjectPlanningModuleEvents) {
		MFHRenovationProjectPlanningModuleEvents["BasicEvaluationFinished"] = "BasicEvaluationFinished";
		MFHRenovationProjectPlanningModuleEvents["PlanningTenderingFinished"] = "PlanningTenderingFinished";
		MFHRenovationProjectPlanningModuleEvents["PlanningAndConstructionTenderingFinished"] = "PlanningAndConstructionTenderingFinished";
		MFHRenovationProjectPlanningModuleEvents["PreliminaryPlanningFinished"] = "PreliminaryPlanningFinished";
		MFHRenovationProjectPlanningModuleEvents["DesignPlanningFinished"] = "DesignPlanningFinished";
		MFHRenovationProjectPlanningModuleEvents["PermitPlanningFinished"] = "PermitPlanningFinished";
		MFHRenovationProjectPlanningModuleEvents["ExecutionPlanningFinished"] = "ExecutionPlanningFinished";
		MFHRenovationProjectPlanningModuleEvents["TenderPreparationConstructionFinished"] = "TenderPreparationConstructionFinished";
		MFHRenovationProjectPlanningModuleEvents["Revert"] = "Revert";
		return MFHRenovationProjectPlanningModuleEvents;
	}({});
	MFHRenovationProjectEvents = /* @__PURE__ */ function(MFHRenovationProjectEvents) {
		MFHRenovationProjectEvents["Identified"] = "Identified";
		MFHRenovationProjectEvents["DDSupportCompleted"] = "DDSupportCompleted";
		MFHRenovationProjectEvents["BasicEvaluationFinished"] = "BasicEvaluationFinished";
		MFHRenovationProjectEvents["ConstructionFinished"] = "BasicEvaluationFinished";
		MFHRenovationProjectEvents["Revert"] = "Revert";
		return MFHRenovationProjectEvents;
	}({});
	MFHRenovationProjectMeasuresPackage = /* @__PURE__ */ function(MFHRenovationProjectMeasuresPackage) {
		MFHRenovationProjectMeasuresPackage["GeneralEnergetic"] = "GeneralEnergetic";
		MFHRenovationProjectMeasuresPackage["GeneralCapex"] = "GeneralCapex";
		MFHRenovationProjectMeasuresPackage["RoofConversion"] = "RoofConversion";
		MFHRenovationProjectMeasuresPackage["VerticalExpansion"] = "VerticalExpansion";
		MFHRenovationProjectMeasuresPackage["SeparateNewBuilding"] = "SeparateNewBuilding";
		MFHRenovationProjectMeasuresPackage["VacantApartmentRenovation"] = "VacantApartmentRenovation";
		return MFHRenovationProjectMeasuresPackage;
	}({});
	MFHRenovationProjectLotEvents = /* @__PURE__ */ function(MFHRenovationProjectLotEvents) {
		MFHRenovationProjectLotEvents["TenderPreparationConstructionFinished"] = "TenderPreparationConstructionFinished";
		MFHRenovationProjectLotEvents["TenderExecutionConstructionFinished"] = "TenderExecutionConstructionFinished";
		MFHRenovationProjectLotEvents["ExecutionPlanningFinished"] = "ExecutionPlanningFinished";
		MFHRenovationProjectLotEvents["ConstructionFinished"] = "ConstructionFinished";
		MFHRenovationProjectLotEvents["Revert"] = "Revert";
		return MFHRenovationProjectLotEvents;
	}({});
	MfhRenovationProjectState = /* @__PURE__ */ function(MfhRenovationProjectState) {
		MfhRenovationProjectState["Identification"] = "Identification";
		MfhRenovationProjectState["DDSupport"] = "DDSupport";
		MfhRenovationProjectState["Construction"] = "Construction";
		MfhRenovationProjectState["StabilizationSupport"] = "StabilizationSupport";
		return MfhRenovationProjectState;
	}({});
	MFHRenovationProjectProcessType = /* @__PURE__ */ function(MFHRenovationProjectProcessType) {
		MFHRenovationProjectProcessType["MFHRenovationProject"] = "MFHRenovationProject";
		return MFHRenovationProjectProcessType;
	}({});
	MFHRenovationProjectProcessStateMapping = { ["MFHRenovationProject"]: MfhRenovationProjectState };
	BaseMFHRenovationProjectSchema = Type.Object({
		mfhRenovationProjectId: Type.Number(),
		mfhId: Type.Number(),
		isPrimaryRenovationProject: Type.Boolean(),
		name: Type.String(),
		status: Type.Enum(MfhRenovationProjectState),
		measuresPackages: Type.Array(Type.Enum(MFHRenovationProjectMeasuresPackage)),
		isPotentialBudget: Type.Boolean(),
		createdAt: StringDateSchema,
		updatedAt: StringDateSchema,
		deletedAt: StringDateSchema
	});
	MfhRenovationProjectPlanningSetup = /* @__PURE__ */ function(MfhRenovationProjectPlanningSetup) {
		MfhRenovationProjectPlanningSetup["OldGeneralPlanner"] = "OldGeneralPlanner";
		MfhRenovationProjectPlanningSetup["OldDesignBuildContractor"] = "OldDesignBuildContractor";
		MfhRenovationProjectPlanningSetup["NewGeneralPlanner"] = "NewGeneralPlanner";
		MfhRenovationProjectPlanningSetup["NewDesignBuildContractor"] = "NewDesignBuildContractor";
		MfhRenovationProjectPlanningSetup["NewInternalPlanning"] = "NewInternalPlanning";
		return MfhRenovationProjectPlanningSetup;
	}({});
	MFHRenovationProjectBudgetType = /* @__PURE__ */ function(MFHRenovationProjectBudgetType) {
		MFHRenovationProjectBudgetType["Internal"] = "Internal";
		MFHRenovationProjectBudgetType["External"] = "External";
		return MFHRenovationProjectBudgetType;
	}({});
	BaseMFHRenovationProjectBudgetSchema = Type.Object({
		mfhRenovationProjectBudgetId: Type.Number(),
		mfhRenovationProjectId: Type.Number(),
		budgetType: Type.Enum(MFHRenovationProjectBudgetType),
		createdAt: StringDateSchema,
		/** @deprecated use budgets from cost breakdown instead */
		measuresPackageBudgets: Type.Unsafe(Type.Any()),
		/** @deprecated use mfhRenovationProjectId instead */
		mfhRenovationProjectPlanningModuleId: Type.Optional(Type.Number())
	});
	MfhRenovationProjectMeasuresPackageBudgetsSchema = Type.Partial(Type.Record(Type.Enum(MFHRenovationProjectMeasuresPackage), Type.Number()));
	BaseMFHRenovationProjectCostBreakdownSchema = Type.Object({
		mfhRenovationProjectCostBreakdownId: Type.Number(),
		mfhRenovationProjectId: Type.Number(),
		name: Type.String(),
		state: TEnum(MFHRenovationProjectCostBreakdownReviewState),
		/** @deprecated  */
		measuresPackageBudgets: MfhRenovationProjectMeasuresPackageBudgetsSchema,
		assetPartnerFeePercentage: Type.Optional(TNullable(Type.Number())),
		createdAt: StringDateSchema,
		updatedAt: StringDateSchema,
		/** @deprecated use mfhRenovationProjectId instead */
		mfhRenovationProjectPlanningModuleId: Type.Optional(Type.Number())
	});
	getMeasurePackageBudgetComponents = (totalBudget, assetPartnerFees = 0) => {
		const internalCostShareThreshold = .25;
		const externalBudget = totalBudget / (assetPartnerFees + 1);
		return {
			internalBudget: (totalBudget - externalBudget) * internalCostShareThreshold,
			externalBudget
		};
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/renovation-project/mfh-renovation-project.i18n.ts
var MFHRenovationProjectMeasuresPackageTranslations, MfhRenovationProjectPlanningSetupTranslations, MFHRenovationPositionCategoryTranslations, MFHRenovationPositionTranslations, MFHRenovationPositionStatusTranslations, MFHRenovationProjectStateTranslations, MFHRenovationProjectPlanningModuleStatusTranslations;
var init_mfh_renovation_project_i18n = __esmMin((() => {
	init_mfh_renovation_project_model();
	MFHRenovationProjectMeasuresPackageTranslations = {
		["GeneralEnergetic"]: "Energetische Effizienz",
		["GeneralCapex"]: "Allgemeine Instandsetzung",
		["RoofConversion"]: "Dachgeschoss Ausbau",
		["VerticalExpansion"]: "Aufstockung",
		["SeparateNewBuilding"]: "Separater Neubau",
		["VacantApartmentRenovation"]: "Leerwohnungssanierung"
	};
	MfhRenovationProjectPlanningSetupTranslations = {
		["OldGeneralPlanner"]: "OLD General Planner",
		["OldDesignBuildContractor"]: "Old Design & Build Contractor",
		["NewInternalPlanning"]: "Internal Planning",
		["NewGeneralPlanner"]: "General Planner",
		["NewDesignBuildContractor"]: "Design & Build Contractor"
	};
	MFHRenovationPositionCategoryTranslations = {
		"100": "Grundstück",
		"200": "Herrichten und Erschließen",
		"300": "Bauwerk und Baukonstruktionen",
		"400": "Bauwerk und Technische Anlagen",
		"500": "Außenanlagen",
		"600": "Ausstattung und Kunstwerke",
		"700": "Baunebenkosten",
		"800": "Unvorhergesehenes",
		RENEO: "RENEO DIN"
	};
	MFHRenovationPositionTranslations = {
		"100": "Grundstück",
		"110": "Grundstückswert",
		"120": "Grundstücksnebenkosten",
		"121": "Vermessungsgebühren",
		"122": "Gerichtsgebühren",
		"123": "Notargebühren",
		"124": "Grunderwerbsteuer",
		"125": "Untersuchungen",
		"126": "Wertermittlungen",
		"127": "Genehmigungsgebühren",
		"128": "Bodenordnung 1",
		"129": "Sonstiges zur KG 120",
		"130": "Rechte Dritter",
		"131": "Abfindungen",
		"132": "Ablösen dinglicher Rechte",
		"139": "Sonstiges zur KG 13",
		"190": "Sonstige Maßnahmen",
		"200": "Herrichten und Erschließen",
		"210": "Herrichten",
		"211": "Sicherungsmaßnahmen",
		"212": "Abbruchmaßnahmen",
		"213": "Altlastenbeseitigung",
		"214": "Herrichten der Geländeoberfläche",
		"215": "Kampfmittelräumung",
		"216": "Kulturhistorische Funde",
		"219": "Sonstiges zur KG 210",
		"220": "Öffentliche Erschließung",
		"221": "Abwasserentsorgung",
		"222": "Wasserversorgung",
		"223": "Gasversorgung",
		"224": "Fernwärmeversorgung",
		"225": "Stromversorgung",
		"226": "Telekommunikation",
		"227": "Verkehrserschließung",
		"228": "Abfallentsorgung",
		"229": "Sonstiges zur KG 220",
		"230": "Nichtöffentliche Erschließung",
		"240": "Ausgleichsmaßnahmen und -abgaben",
		"241": "Ausgleichsmaßnahmen",
		"242": "Ausgleichsabgaben",
		"249": "Sonstiges zur KG 240",
		"250": "Übergangsmaßnahmen",
		"252": "Organisatorische Maßnahmen",
		"259": "Sonstiges zur KG 250",
		"290": "Sonstige Maßnahmen",
		"300": "Bauwerk und Baukonstruktionen",
		"310": "Baugrube/Erdbau",
		"311": "Herstellung",
		"312": "Umschließung",
		"313": "Wasserhaltung",
		"314": "Vortrieb",
		"319": "Sonstiges zur KG 310",
		"320": "Gründung, Unterbau",
		"321": "Baugrundverbesserung",
		"322": "Flachgründungen und Bodenplatten",
		"323": "Tiefgründungen",
		"324": "Gründungsbeläge",
		"325": "Abdichtungen und Bekleidungen",
		"326": "Dränagen",
		"329": "Sonstiges zur KG 320",
		"330": "Außenwände/Vertikale Baukonstruktionen, außen",
		"331": "Tragende Außenwände",
		"332": "Nichttragende Außenwände",
		"333": "Außenstützen",
		"334": "Außenwandöffnungen",
		"335": "Außenwandbekleidungen, außen",
		"336": "Außenwandbekleidungen, innen",
		"337": "Elementierte Außenwandkonstruktionen",
		"338": "Lichtschutz zur KG 330",
		"339": "Sonstiges zur KG 330",
		"340": "Innenwände/Vertikale Baukonstruktionen, innen",
		"350": "Decken",
		"351": "Deckenkonstruktionen",
		"352": "Deckenöffnungen",
		"353": "Deckenbeläge",
		"354": "Deckenbekleidungen",
		"355": "Elementierte Deckenkonstruktionen",
		"359": "Sonstiges zur KG 350",
		"360": "Dächer",
		"361": "Dachkonstruktionen",
		"362": "Dachöffnungen",
		"363": "Dachbeläge",
		"364": "Dachbekleidungen",
		"365": "Elementierte Dachkonstruktionen",
		"366": "Lichtschutz zur KG 360",
		"369": "Sonstiges zur KG 360",
		"370": "Infrastrukturanlagen",
		"371": "Anlagen für den Straßenverkehr",
		"372": "Anlagen für den Schienenverkehr",
		"373": "Anlagen für den Flugverkehr",
		"374": "Anlagen des Wasserbaus",
		"375": "Anlagen der Abwasserentsorgung",
		"376": "Anlagen der Wasserversorgung",
		"377": "Anlagen der Energie- und Informationsversorgung",
		"378": "Anlagen der Abfallentsorgung",
		"379": "Sonstiges zur KG 370",
		"380": "Baukonstruktive Einbauten",
		"381": "Allgemeine Einbauten",
		"382": "Besondere Einbauten",
		"383": "Landschaftsgestalterische Einbauten",
		"384": "Mechanische Einbauten",
		"385": "Einbauten in Konstruktionen des Ingenieurbaus",
		"386": "Orientierungs- und Informationssysteme",
		"387": "Schutzeinbauten",
		"389": "Sonstiges zur KG 380",
		"390": "Sonstige Maßnahmen für Baukonstruktionen",
		"391": "Baustelleneinrichtung",
		"392": "Gerüste",
		"393": "Sicherungsmaßnahmen",
		"394": "Abbruchmaßnahmen",
		"395": "Instandsetzungen",
		"396": "Materialentsorgung",
		"397": "Zusätzliche Maßnahmen",
		"398": "Provisorische Baukonstruktionen",
		"399": "Sonstiges zur KG 390",
		"400": "Bauwerk und Technische Anlagen",
		"410": "Abwasser-, Wasser-, Gasanlagen",
		"411": "Abwasseranlagen",
		"412": "Wasseranlagen",
		"413": "Gasanlagen",
		"419": "Sonstiges zur KG 410",
		"420": "Wärmeversorgungsanlagen",
		"421": "Wärmeerzeugungsanlagen",
		"422": "Wärmeverteilnetze",
		"423": "Raumheizflächen",
		"424": "Verkehrsheizflächen",
		"429": "Sonstiges zur KG 420",
		"430": "Raumlufttechnische Anlagen",
		"431": "Lüftungsanlagen",
		"432": "Teilklimaanlagen",
		"433": "Klimaanlagen",
		"434": "Kälteanlagen",
		"439": "Sonstiges zur KG 430",
		"440": "Elektrische Anlagen",
		"441": "Hoch- und Mittelspannungsanlagen",
		"442": "Eigenstromversorgungsanlagen",
		"443": "Niederspannungsschaltanlagen",
		"444": "Niederspannungsinstallationsanlagen",
		"445": "Beleuchtungsanlagen",
		"446": "Blitzschutz- und Erdungsanlagen",
		"447": "Fahrleitungssysteme",
		"449": "Sonstiges zur KG 440",
		"450": "Kommunikations-, sicherheits- und informationstechnische Anlagen",
		"451": "Telekommunikationsanlagen",
		"452": "Such- und Signalanlagen",
		"453": "Zeitdienstanlagen",
		"454": "Elektroakustische Anlagen",
		"455": "Audiovisuelle Medien- und Antennenanlagen",
		"456": "Gefahrenmelde- und Alarmanlagen",
		"457": "Datenübertragungsnetze",
		"458": "Verkehrsbeeinflussungsanlagen",
		"459": "Sonstiges zur KG 450",
		"460": "Förderanlagen",
		"461": "Aufzugsanlagen",
		"462": "Fahrtreppen, Fahrsteige",
		"463": "Befahranlagen",
		"464": "Transportanlagen",
		"465": "Krananlagen",
		"466": "Hydraulikanlagen",
		"469": "Sonstiges zur KG 460",
		"470": "Nutzungsspezifische und verfahrenstechnische Anlagen",
		"471": "Küchentechnische Anlagen",
		"472": "Wäscherei-, Reinigungs- und badetechnische Anlagen",
		"473": "Medienversorgungsanlagen, Medizin- und labortechnische Anlagen",
		"474": "Feuerlöschanlagen",
		"475": "Prozesswärme-, kälte- und -luftanlagen",
		"476": "Weitere nutzungsspezifische Anlagen",
		"477": "Verfahrenstechnische Anlagen, Wasser, Abwasser und Gase",
		"478": "Verfahrenstechnische Anlagen, Feststoffe, Wertstoffe und Abfälle",
		"479": "Sonstiges zur KG 470",
		"480": "Gebäude- und Anlagenautomation",
		"481": "Automationseinrichtungen",
		"482": "Schaltschränke, Automationsschwerpunkte",
		"483": "Automationsmanagement",
		"484": "Kabel, Leitungen und Verlegesysteme",
		"485": "Datenübertragungsnetze",
		"489": "Sonstiges zur KG 480",
		"490": "Sonstige Maßnahmen für technische Anlagen",
		"491": "Baustelleneinrichtung",
		"492": "Gerüste",
		"493": "Sicherungsmaßnahmen",
		"494": "Abbruchmaßnahmen",
		"495": "Instandsetzungen",
		"496": "Materialentsorgung",
		"497": "Zusätzliche Maßnahmen",
		"498": "Provisorische technische Anlagen",
		"499": "Sonstiges zur KG 490",
		"500": "Außenanlagen",
		"510": "Erdbau",
		"511": "Herstellung",
		"512": "Umschließung",
		"513": "Wasserhaltung",
		"514": "Vortrieb",
		"519": "Sonstiges zur KG 510",
		"520": "Gründung, Unterbau",
		"521": "Baugrundverbesserung",
		"522": "Gründungen und Bodenplatten",
		"523": "Gründungsbeläge",
		"524": "Abdichtungen und Bekleidungen",
		"525": "Dränagen",
		"529": "Sonstiges zur KG 520",
		"530": "Oberbau, Deckschichten",
		"531": "Wege",
		"532": "Straßen",
		"533": "Plätze, Höfe, Terrassen",
		"534": "Stellplätze",
		"535": "Sportplatzflächen",
		"536": "Spielplatzflächen",
		"537": "Gleisanlagen",
		"538": "Flugplatzflächen",
		"539": "Sonstiges zur KG 530",
		"540": "Baukonstruktionen",
		"541": "Einfriedungen",
		"542": "Schutzkonstruktionen",
		"543": "Wandkonstruktionen",
		"544": "Rampen, Treppen, Tribünen",
		"545": "Überdachungen",
		"546": "Stege",
		"547": "Kanal- und Schachtkonstruktionen",
		"548": "Wasserbecken",
		"549": "Sonstiges zur KG 540",
		"550": "Technische Anlagen",
		"551": "Abwasseranlagen",
		"552": "Wasseranlagen",
		"553": "Anlagen für Gase und Flüssigkeiten",
		"554": "Wärmeversorgungsanlagen",
		"555": "Raumlufttechnische Anlagen",
		"556": "Elektrische Anlagen",
		"557": "Kommunikations-, sicherheits- und informationstechnische Anlagen, Automation",
		"558": "Nutzungsspezifische Anlagen",
		"559": "Sonstiges zur KG 550",
		"560": "Einbauten in Außenanlagen und Freiflächen",
		"561": "Allgemeine Einbauten",
		"562": "Besondere Einbauten",
		"563": "Orientierungs- und Informationssysteme",
		"569": "Sonstiges zur KG 560",
		"580": "Wasserflächen",
		"581": "Befestigungen",
		"582": "Abdichtungen",
		"583": "Bepflanzungen",
		"589": "Sonstiges zur KG 580",
		"570": "Vegetationsflächen",
		"571": "Vegetationstechnische Bodenbearbeitung",
		"572": "Sicherungsbauweisen",
		"573": "Pflanzflächen",
		"574": "Rasen- und Saatflächen",
		"579": "Sonstiges zur KG 570",
		"590": "Sonstige Maßnahmen für Außenanlagen und Freiflächen",
		"591": "Baustelleneinrichtung",
		"592": "Gerüste",
		"593": "Sicherungsmaßnahmen",
		"594": "Abbruchmaßnahmen",
		"595": "Instandsetzungen",
		"596": "Materialentsorgung",
		"597": "Zusätzliche Maßnahmen",
		"598": "Provisorische Außenanlagen und Freiflächen",
		"599": "Sonstiges zur KG 590",
		"600": "Ausstattung und Kunstwerke",
		"610": "Allgemeine Ausstattung",
		"620": "Besondere Ausstattung",
		"630": "Informationstechnische Ausstattung",
		"690": "Sonstige Ausstattung",
		"640": "Künstlerische Ausstattung",
		"641": "Kunstobjekte",
		"642": "Künstlerische Gestaltung des Bauwerks",
		"643": "Künstlerische Gestaltung der Außenanlagen und Freiflächen",
		"649": "Sonstiges zur KG 640",
		"700": "Baunebenkosten",
		"710": "Bauherrenaufgaben",
		"711": "Projektleitung",
		"712": "Bedarfsplanung 7",
		"713": "Projektsteuerung",
		"714": "Sicherheits- und Gesundheitsschutzkoordination",
		"715": "Vergabeverfahren",
		"719": "Sonstiges zur KG 710",
		"720": "Vorbereitung der Objektplanung",
		"721": "Untersuchungen",
		"722": "Wertermittlungen",
		"723": "Städtebauliche Leistungen",
		"724": "Landschaftsplanerische Leistungen",
		"725": "Wettbewerbe",
		"729": "Sonstiges zur KG 720",
		"730": "Objektplanung",
		"731": "Gebäude und Innenräume",
		"732": "Freianlagen",
		"733": "Ingenieurbauwerke",
		"734": "Verkehrsanlagen",
		"741": "Tragwerksplanung",
		"742": "Technische Ausrüstung",
		"739": "Sonstiges zur KG 730",
		"740": "Fachplanung",
		"743": "Bauphysik",
		"744": "Geotechnik",
		"745": "Ingenieurvermessung",
		"746": "Lichttechnik, Tageslichttechnik",
		"747": "Brandschutz",
		"748": "Altlasten, Kampfmittel, kulturhistorische Funde",
		"749": "Sonstiges zur KG 740",
		"750": "Künstlerische Leistungen",
		"751": "Kunstwettbewerbe",
		"752": "Honorare",
		"759": "Sonstiges zur KG 750",
		"760": "Allgemeine Baunebenkosten",
		"761": "Gutachten und Beratung",
		"762": "Prüfungen, Genehmigungen, Abnahmen",
		"763": "Bewirtschaftungskosten",
		"764": "Bemusterungskosten",
		"765": "Betriebskosten nach der Abnahme",
		"766": "Versicherungen",
		"769": "Sonstiges zur KG 760",
		"790": "Sonstige Baunebenkosten",
		"791": "Bestandsdokumentation",
		"799": "Sonstiges zur KG 790",
		"800": "Unvorhergesehenes",
		"810": "Finanzierungsnebenkosten",
		"820": "Fremdkapitalzinsen",
		"830": "Eigenkapitalzinsen",
		"840": "Bürgschaften",
		"890": "Sonstige Finanzierungskosten",
		SKW: "Sanierungskosten Wohneinheiten",
		SKG: "Sanierungskosten Gewerbeeinheiten"
	};
	MFHRenovationPositionStatusTranslations = {
		Budget: "Budget",
		CostEstimate: "Kostenschätzung",
		CostCalculation: "Kostenberechnung",
		CostForecast: "Kostenvoranschlag",
		ContractValue: "Auftragssumme",
		Billed: "Abgerechnet"
	};
	MFHRenovationProjectStateTranslations = {
		Identification: "Identification",
		DDSupport: "DD Support",
		Construction: "Construction",
		StabilizationSupport: "Stabilization Support"
	};
	MFHRenovationProjectPlanningModuleStatusTranslations = {
		BasicEvaluation: "Basic Evaluation",
		PlanningTendering: "Planning Tendering",
		PlanningAndConstructionTendering: "Planning And Construction Tendering",
		PreliminaryPlanning: "Preliminary Planning",
		DesignPlanning: "Design Planning",
		PermitPlanning: "Permit Planning",
		ExecutionPlanning: "Execution Planning",
		TenderPreparationConstruction: "Tender Preparation Construction",
		Completed: "Completed"
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/renovation-project/mfh-renovation-position-code.model.ts
/**
* Extracted to avoid circular dependency between mfh-renovation-project-position.model
* and position-cost-allocation.model.
*/
var MFHRenovationPositionCodeSchema;
var init_mfh_renovation_position_code_model = __esmMin((() => {
	MFHRenovationPositionCodeSchema = Type.Union([
		Type.Literal("100"),
		Type.Literal("110"),
		Type.Literal("120"),
		Type.Literal("121"),
		Type.Literal("122"),
		Type.Literal("123"),
		Type.Literal("124"),
		Type.Literal("125"),
		Type.Literal("126"),
		Type.Literal("127"),
		Type.Literal("128"),
		Type.Literal("129"),
		Type.Literal("130"),
		Type.Literal("131"),
		Type.Literal("132"),
		Type.Literal("139"),
		Type.Literal("190"),
		Type.Literal("200"),
		Type.Literal("210"),
		Type.Literal("211"),
		Type.Literal("212"),
		Type.Literal("213"),
		Type.Literal("214"),
		Type.Literal("215"),
		Type.Literal("216"),
		Type.Literal("219"),
		Type.Literal("220"),
		Type.Literal("221"),
		Type.Literal("222"),
		Type.Literal("223"),
		Type.Literal("224"),
		Type.Literal("225"),
		Type.Literal("226"),
		Type.Literal("227"),
		Type.Literal("228"),
		Type.Literal("229"),
		Type.Literal("230"),
		Type.Literal("240"),
		Type.Literal("241"),
		Type.Literal("242"),
		Type.Literal("249"),
		Type.Literal("250"),
		Type.Literal("252"),
		Type.Literal("259"),
		Type.Literal("290"),
		Type.Literal("300"),
		Type.Literal("310"),
		Type.Literal("311"),
		Type.Literal("312"),
		Type.Literal("313"),
		Type.Literal("314"),
		Type.Literal("319"),
		Type.Literal("320"),
		Type.Literal("321"),
		Type.Literal("322"),
		Type.Literal("323"),
		Type.Literal("324"),
		Type.Literal("325"),
		Type.Literal("326"),
		Type.Literal("329"),
		Type.Literal("330"),
		Type.Literal("331"),
		Type.Literal("332"),
		Type.Literal("333"),
		Type.Literal("334"),
		Type.Literal("335"),
		Type.Literal("336"),
		Type.Literal("337"),
		Type.Literal("338"),
		Type.Literal("339"),
		Type.Literal("340"),
		Type.Literal("350"),
		Type.Literal("351"),
		Type.Literal("352"),
		Type.Literal("353"),
		Type.Literal("354"),
		Type.Literal("355"),
		Type.Literal("359"),
		Type.Literal("360"),
		Type.Literal("361"),
		Type.Literal("362"),
		Type.Literal("363"),
		Type.Literal("364"),
		Type.Literal("365"),
		Type.Literal("366"),
		Type.Literal("369"),
		Type.Literal("370"),
		Type.Literal("371"),
		Type.Literal("372"),
		Type.Literal("373"),
		Type.Literal("374"),
		Type.Literal("375"),
		Type.Literal("376"),
		Type.Literal("377"),
		Type.Literal("378"),
		Type.Literal("379"),
		Type.Literal("380"),
		Type.Literal("381"),
		Type.Literal("382"),
		Type.Literal("383"),
		Type.Literal("384"),
		Type.Literal("385"),
		Type.Literal("386"),
		Type.Literal("387"),
		Type.Literal("389"),
		Type.Literal("390"),
		Type.Literal("391"),
		Type.Literal("392"),
		Type.Literal("393"),
		Type.Literal("394"),
		Type.Literal("395"),
		Type.Literal("396"),
		Type.Literal("397"),
		Type.Literal("398"),
		Type.Literal("399"),
		Type.Literal("400"),
		Type.Literal("410"),
		Type.Literal("411"),
		Type.Literal("412"),
		Type.Literal("413"),
		Type.Literal("419"),
		Type.Literal("420"),
		Type.Literal("421"),
		Type.Literal("422"),
		Type.Literal("423"),
		Type.Literal("424"),
		Type.Literal("429"),
		Type.Literal("430"),
		Type.Literal("431"),
		Type.Literal("432"),
		Type.Literal("433"),
		Type.Literal("434"),
		Type.Literal("439"),
		Type.Literal("440"),
		Type.Literal("441"),
		Type.Literal("442"),
		Type.Literal("443"),
		Type.Literal("444"),
		Type.Literal("445"),
		Type.Literal("446"),
		Type.Literal("447"),
		Type.Literal("449"),
		Type.Literal("450"),
		Type.Literal("451"),
		Type.Literal("452"),
		Type.Literal("453"),
		Type.Literal("454"),
		Type.Literal("455"),
		Type.Literal("456"),
		Type.Literal("457"),
		Type.Literal("458"),
		Type.Literal("459"),
		Type.Literal("460"),
		Type.Literal("461"),
		Type.Literal("462"),
		Type.Literal("463"),
		Type.Literal("464"),
		Type.Literal("465"),
		Type.Literal("466"),
		Type.Literal("469"),
		Type.Literal("470"),
		Type.Literal("471"),
		Type.Literal("472"),
		Type.Literal("473"),
		Type.Literal("474"),
		Type.Literal("475"),
		Type.Literal("476"),
		Type.Literal("477"),
		Type.Literal("478"),
		Type.Literal("479"),
		Type.Literal("480"),
		Type.Literal("481"),
		Type.Literal("482"),
		Type.Literal("483"),
		Type.Literal("484"),
		Type.Literal("485"),
		Type.Literal("489"),
		Type.Literal("490"),
		Type.Literal("491"),
		Type.Literal("492"),
		Type.Literal("493"),
		Type.Literal("494"),
		Type.Literal("495"),
		Type.Literal("496"),
		Type.Literal("497"),
		Type.Literal("498"),
		Type.Literal("499"),
		Type.Literal("500"),
		Type.Literal("510"),
		Type.Literal("511"),
		Type.Literal("512"),
		Type.Literal("513"),
		Type.Literal("514"),
		Type.Literal("519"),
		Type.Literal("520"),
		Type.Literal("521"),
		Type.Literal("522"),
		Type.Literal("523"),
		Type.Literal("524"),
		Type.Literal("525"),
		Type.Literal("529"),
		Type.Literal("530"),
		Type.Literal("531"),
		Type.Literal("532"),
		Type.Literal("533"),
		Type.Literal("534"),
		Type.Literal("535"),
		Type.Literal("536"),
		Type.Literal("537"),
		Type.Literal("538"),
		Type.Literal("539"),
		Type.Literal("540"),
		Type.Literal("541"),
		Type.Literal("542"),
		Type.Literal("543"),
		Type.Literal("544"),
		Type.Literal("545"),
		Type.Literal("546"),
		Type.Literal("547"),
		Type.Literal("548"),
		Type.Literal("549"),
		Type.Literal("550"),
		Type.Literal("551"),
		Type.Literal("552"),
		Type.Literal("553"),
		Type.Literal("554"),
		Type.Literal("555"),
		Type.Literal("556"),
		Type.Literal("557"),
		Type.Literal("558"),
		Type.Literal("559"),
		Type.Literal("560"),
		Type.Literal("561"),
		Type.Literal("562"),
		Type.Literal("563"),
		Type.Literal("569"),
		Type.Literal("580"),
		Type.Literal("581"),
		Type.Literal("582"),
		Type.Literal("583"),
		Type.Literal("589"),
		Type.Literal("570"),
		Type.Literal("571"),
		Type.Literal("572"),
		Type.Literal("573"),
		Type.Literal("574"),
		Type.Literal("579"),
		Type.Literal("590"),
		Type.Literal("591"),
		Type.Literal("592"),
		Type.Literal("593"),
		Type.Literal("594"),
		Type.Literal("595"),
		Type.Literal("596"),
		Type.Literal("597"),
		Type.Literal("598"),
		Type.Literal("599"),
		Type.Literal("600"),
		Type.Literal("610"),
		Type.Literal("620"),
		Type.Literal("630"),
		Type.Literal("640"),
		Type.Literal("641"),
		Type.Literal("642"),
		Type.Literal("643"),
		Type.Literal("649"),
		Type.Literal("690"),
		Type.Literal("700"),
		Type.Literal("710"),
		Type.Literal("711"),
		Type.Literal("712"),
		Type.Literal("713"),
		Type.Literal("714"),
		Type.Literal("715"),
		Type.Literal("719"),
		Type.Literal("720"),
		Type.Literal("721"),
		Type.Literal("722"),
		Type.Literal("723"),
		Type.Literal("724"),
		Type.Literal("725"),
		Type.Literal("729"),
		Type.Literal("730"),
		Type.Literal("731"),
		Type.Literal("732"),
		Type.Literal("733"),
		Type.Literal("734"),
		Type.Literal("741"),
		Type.Literal("742"),
		Type.Literal("739"),
		Type.Literal("740"),
		Type.Literal("743"),
		Type.Literal("744"),
		Type.Literal("745"),
		Type.Literal("746"),
		Type.Literal("747"),
		Type.Literal("748"),
		Type.Literal("749"),
		Type.Literal("750"),
		Type.Literal("751"),
		Type.Literal("752"),
		Type.Literal("759"),
		Type.Literal("760"),
		Type.Literal("761"),
		Type.Literal("762"),
		Type.Literal("763"),
		Type.Literal("764"),
		Type.Literal("765"),
		Type.Literal("766"),
		Type.Literal("769"),
		Type.Literal("790"),
		Type.Literal("791"),
		Type.Literal("799"),
		Type.Literal("800"),
		Type.Literal("810"),
		Type.Literal("820"),
		Type.Literal("830"),
		Type.Literal("840"),
		Type.Literal("890"),
		Type.Literal("SKW"),
		Type.Literal("SKG")
	]);
}));
//#endregion
//#region src/domains/cross-cutting/mfh/renovation-project/position-cost-allocation/position-cost-allocation.model.ts
var PositionCostAllocationCostType, BasePositionCostAllocationSchema, isAddendumClass, PositionCostAllocation, decimalAmount, decimalExternalCostShare, PositionCostAllocationCalculations;
var init_position_cost_allocation_model = __esmMin((() => {
	init_base();
	init_shared_schemas();
	init_mfh_renovation_position_code_model();
	init_mfh_renovation_project_model();
	init_addendum();
	PositionCostAllocationCostType = /* @__PURE__ */ function(PositionCostAllocationCostType) {
		PositionCostAllocationCostType["Concern"] = "Concern";
		PositionCostAllocationCostType["Addendum"] = "Addendum";
		PositionCostAllocationCostType["ContractValue"] = "ContractValue";
		PositionCostAllocationCostType["Rejected"] = "Rejected";
		return PositionCostAllocationCostType;
	}({});
	BasePositionCostAllocationSchema = Type.Object({
		positionCostAllocationId: Type.Number(),
		entityId: Type.Number(),
		entityType: Type.Enum(EntityTableName),
		mfhRenovationProjectId: Type.Number(),
		measurePackage: Type.Enum(MFHRenovationProjectMeasuresPackage),
		positionCode: MFHRenovationPositionCodeSchema,
		amount: TDecimal,
		paidAmount: TDecimal,
		costType: Type.Enum(PositionCostAllocationCostType),
		title: Type.Optional(Type.Union([Type.String(), Type.Null()])),
		externalCostAttributionPercentage: TDecimal
	});
	isAddendumClass = (obj) => obj instanceof Addendum;
	PositionCostAllocation = class {
		constructor(props) {
			Object.assign(this, props);
			this.amount = props.amount != null ? new Decimal(props.amount) : null;
			this.paidAmount = props.paidAmount != null ? new Decimal(props.paidAmount) : null;
			this.title = props.title ?? null;
			this.addendum = props.addendum != null ? isAddendumClass(props.addendum) ? props.addendum : new Addendum(props.addendum) : void 0;
			this.contract = props.contract != null ? props.contract : void 0;
			this.adjustedContractValue = new Decimal(0);
			this.externalCostAttributionPercentage = props.externalCostAttributionPercentage != null ? new Decimal(props.externalCostAttributionPercentage) : null;
			if (this.costType === "ContractValue" || this.costType === "Addendum") this.adjustedContractValue = this.amount;
		}
	};
	decimalAmount = (allocation) => new Decimal(allocation.amount ?? 0);
	decimalExternalCostShare = (allocation) => new Decimal(allocation.externalCostAttributionPercentage ?? 1);
	PositionCostAllocationCalculations = {
		addendumCostType: (status) => {
			if (status != null && ADDENDUM_ESTABLISHED_STATUS.includes(status)) return "Addendum";
			if (status === "Rejected") return "Rejected";
			return "Concern";
		},
		countedAllocations: (allocations) => allocations.filter((allocation) => allocation.costType !== "Rejected"),
		approvedAddenda: (addenda) => addenda.filter((allocation) => allocation.costType === "Addendum"),
		aggregateAddendaWeightedExternalCost: (addenda) => addenda.reduce((acc, allocation) => {
			const amount = decimalAmount(allocation);
			return {
				addendaValue: acc.addendaValue.plus(amount),
				addendaWeightedExternalCost: acc.addendaWeightedExternalCost.plus(amount.times(decimalExternalCostShare(allocation)))
			};
		}, {
			addendaValue: new Decimal(0),
			addendaWeightedExternalCost: new Decimal(0)
		}),
		committedValue: (contractValue, addenda) => contractValue.plus(PositionCostAllocationCalculations.aggregateAddendaWeightedExternalCost(addenda).addendaValue),
		contractCommittedCost: (contractAllocations, addenda, addendaAllocations) => {
			const allocationsByAddendumId = groupBy(addendaAllocations, "entityId");
			const establishedAddenda = addenda.filter((addendum) => addendum.status != null && ADDENDUM_ESTABLISHED_STATUS.includes(addendum.status)).map((addendum) => ({
				addendum,
				value: PositionCostAllocationCalculations.aggregateAddendaWeightedExternalCost(allocationsByAddendumId[addendum.addendumId] ?? []).addendaValue
			}));
			const contractValue = contractAllocations.reduce((sum, allocation) => sum.plus(decimalAmount(allocation)), new Decimal(0));
			const addendaValue = establishedAddenda.reduce((sum, { value }) => sum.plus(value), new Decimal(0));
			return {
				contractValue,
				addendaValue,
				establishedAddenda,
				committedValue: contractValue.plus(addendaValue)
			};
		},
		/**
		* Externer Kostenanteil — weighted external cost attribution share for a position's committed cost:
		* (contractValue × contractExternalCostShare + Σ addendaWeightedExternalCost) / (contractValue + Σ addendaValue).
		* Returns `null` when the committed value is 0 (nothing to attribute).
		*/
		committedExternalCostShare: (contractValue, contractExternalCostShare, addenda) => {
			const { addendaValue, addendaWeightedExternalCost } = PositionCostAllocationCalculations.aggregateAddendaWeightedExternalCost(addenda);
			const committedValue = contractValue.plus(addendaValue);
			if (committedValue.isZero()) return null;
			const contractShare = contractExternalCostShare ?? new Decimal(1);
			return contractValue.times(contractShare).plus(addendaWeightedExternalCost).div(committedValue);
		}
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/renovation-project/mfh-renovation-project-position.model.ts
function carryOverCostValue(position, fromState, toState) {
	const fromColumn = MFHRenovationPositionStatusToCostColumnMap[fromState];
	const toColumn = MFHRenovationPositionStatusToCostColumnMap[toState];
	if (!fromColumn || !toColumn) return {};
	const fromValue = position[fromColumn];
	const toValue = position[toColumn];
	const isCarryOverApplicable = CARRY_OVER_APPLICABLE_TO_STATES.includes(toState);
	if (fromValue && typeof fromValue === "number" && isNil(toValue) && isCarryOverApplicable) return { [toColumn]: fromValue };
	return {};
}
var ajv, MFHRenovationPositionStatus, MfhRenovationInvoicesBilledSchema, CostAmendmentOperationSchema, MFHRenovationPositionCategoryCodeSchema, MFHRenovationProjectCategoryPositions, mfhRenovationProjectPositionComputedProps, BaseMFHRenovationProjectPositionSchema, CreateMFHRenovationProjectPositionSchema, UpdateRenovationProjectPositionSchema, validate, validateCreateMFHRenovationPositionsData, getAssetPartnerFeePercent, RenovationProjectPositionCalculations, getPositionCategoryCode, sheetToMeasuresPackage, pString, pPositionCode, pNumber, pRenovationMeasuresPackage, MFHRenovationPositionStatusToCostColumnMap, MFHRenovationPositionStatusOrder, isValidSequentialTransition, CARRY_OVER_APPLICABLE_TO_STATES, MFHRenovationProjectPositionSheetColumnMappings;
var init_mfh_renovation_project_position_model = __esmMin((() => {
	init_shared_schemas();
	init_mfh_renovation_project_i18n();
	init_mfh_renovation_project_model();
	init_mfh_renovation_position_code_model();
	init_position_cost_allocation_model();
	ajv = new Ajv({
		allErrors: true,
		strictSchema: false,
		strictTypes: false
	});
	addFormats(ajv);
	MFHRenovationPositionStatus = /* @__PURE__ */ function(MFHRenovationPositionStatus) {
		MFHRenovationPositionStatus["Budget"] = "Budget";
		MFHRenovationPositionStatus["CostEstimate"] = "CostEstimate";
		MFHRenovationPositionStatus["CostCalculation"] = "CostCalculation";
		MFHRenovationPositionStatus["CostForecast"] = "CostForecast";
		MFHRenovationPositionStatus["ContractValue"] = "ContractValue";
		MFHRenovationPositionStatus["Billed"] = "Billed";
		return MFHRenovationPositionStatus;
	}({});
	MfhRenovationInvoicesBilledSchema = Type.Object({
		invoiceId: Type.Optional(Type.Number()),
		amount: Type.Number(),
		description: Type.Optional(Type.String({ maxLength: 500 })),
		createdByUserId: Type.String(),
		createdAt: RequiredStringDateSchema
	});
	CostAmendmentOperationSchema = Type.Object({
		amount: Type.Number(),
		description: Type.Optional(Type.String({ maxLength: 500 })),
		createdByUserId: Type.String(),
		createdAt: RequiredStringDateSchema
	});
	MFHRenovationPositionCategoryCodeSchema = Type.Union([
		Type.Literal("100"),
		Type.Literal("200"),
		Type.Literal("300"),
		Type.Literal("400"),
		Type.Literal("500"),
		Type.Literal("600"),
		Type.Literal("700"),
		Type.Literal("800"),
		Type.Literal("RENEO")
	]);
	MFHRenovationProjectCategoryPositions = {
		"100": [
			"100",
			"110",
			"120",
			"121",
			"122",
			"123",
			"124",
			"125",
			"126",
			"127",
			"128",
			"129",
			"130",
			"131",
			"132",
			"139",
			"190"
		],
		"200": [
			"200",
			"210",
			"211",
			"212",
			"213",
			"214",
			"215",
			"216",
			"219",
			"220",
			"221",
			"222",
			"223",
			"224",
			"225",
			"226",
			"227",
			"228",
			"229",
			"230",
			"240",
			"241",
			"242",
			"249",
			"250",
			"252",
			"290"
		],
		"300": [
			"300",
			"310",
			"311",
			"312",
			"313",
			"314",
			"319",
			"320",
			"321",
			"322",
			"323",
			"324",
			"325",
			"326",
			"329",
			"330",
			"331",
			"332",
			"333",
			"334",
			"335",
			"336",
			"337",
			"338",
			"339",
			"340",
			"350",
			"351",
			"352",
			"353",
			"354",
			"355",
			"359",
			"360",
			"361",
			"362",
			"363",
			"364",
			"365",
			"366",
			"369",
			"370",
			"371",
			"372",
			"373",
			"374",
			"375",
			"376",
			"377",
			"378",
			"379",
			"380",
			"381",
			"382",
			"383",
			"384",
			"385",
			"386",
			"387",
			"389",
			"390",
			"391",
			"392",
			"393",
			"394",
			"395",
			"396",
			"397",
			"398",
			"399"
		],
		"400": [
			"400",
			"410",
			"411",
			"412",
			"413",
			"419",
			"420",
			"421",
			"422",
			"423",
			"424",
			"429",
			"430",
			"431",
			"432",
			"433",
			"434",
			"439",
			"440",
			"441",
			"442",
			"443",
			"444",
			"445",
			"446",
			"447",
			"449",
			"450",
			"451",
			"452",
			"453",
			"454",
			"455",
			"456",
			"457",
			"458",
			"459",
			"460",
			"461",
			"462",
			"463",
			"464",
			"465",
			"466",
			"469",
			"470",
			"471",
			"472",
			"473",
			"474",
			"475",
			"476",
			"477",
			"478",
			"479",
			"480",
			"481",
			"482",
			"483",
			"484",
			"485",
			"489",
			"490",
			"491",
			"492",
			"493",
			"494",
			"495",
			"496",
			"497",
			"498",
			"499"
		],
		"500": [
			"500",
			"510",
			"511",
			"512",
			"513",
			"514",
			"519",
			"520",
			"521",
			"522",
			"523",
			"524",
			"525",
			"529",
			"530",
			"531",
			"532",
			"533",
			"534",
			"535",
			"536",
			"537",
			"538",
			"539",
			"540",
			"541",
			"542",
			"543",
			"544",
			"545",
			"546",
			"547",
			"548",
			"549",
			"550",
			"551",
			"552",
			"553",
			"554",
			"555",
			"556",
			"557",
			"558",
			"559",
			"560",
			"561",
			"562",
			"563",
			"569",
			"580",
			"581",
			"582",
			"583",
			"589",
			"570",
			"571",
			"572",
			"573",
			"574",
			"579",
			"590",
			"591",
			"592",
			"593",
			"594",
			"595",
			"596",
			"597",
			"598",
			"599"
		],
		"600": [
			"600",
			"610",
			"620",
			"630",
			"690",
			"640",
			"641",
			"642",
			"643",
			"649"
		],
		"700": [
			"700",
			"710",
			"711",
			"712",
			"713",
			"714",
			"715",
			"719",
			"720",
			"721",
			"722",
			"723",
			"724",
			"725",
			"729",
			"730",
			"731",
			"732",
			"733",
			"734",
			"741",
			"742",
			"739",
			"740",
			"743",
			"744",
			"745",
			"746",
			"747",
			"748",
			"749",
			"750",
			"751",
			"752",
			"759",
			"760",
			"761",
			"762",
			"763",
			"764",
			"765",
			"766",
			"769",
			"790",
			"791",
			"799"
		],
		"800": [
			"800",
			"810",
			"820",
			"830",
			"840",
			"890"
		],
		RENEO: ["SKW", "SKG"]
	};
	mfhRenovationProjectPositionComputedProps = [
		"externalCostAttributionPercentage",
		"adjustedContractValue",
		"prognosis",
		"uncommittedCost",
		"costAmendmentTotal",
		"costConcern",
		"invoicesBilledTotal"
	];
	BaseMFHRenovationProjectPositionSchema = Type.Object({
		mfhRenovationProjectPositionId: Type.Number(),
		mfhRenovationProjectCostBreakdownId: Type.Number(),
		measuresPackage: Type.Enum(MFHRenovationProjectMeasuresPackage),
		positionCode: MFHRenovationPositionCodeSchema,
		status: Type.Enum(MFHRenovationPositionStatus),
		budget: TNullable(Type.Number({ minimum: 0 })),
		/** @deprecated use budget instead */
		costFramework: TNullable(Type.Number({ minimum: 0 })),
		costEstimate: TNullable(Type.Number({ minimum: 0 })),
		costCalculation: TNullable(Type.Number({ minimum: 0 })),
		costForecast: TNullable(Type.Number({ minimum: 0 })),
		quote: TNullable(Type.Number({ minimum: 0 })),
		estimatedExternalCostAttributionPercentage: Type.Number(),
		eligibleForSubsidiesPercentage: Type.Number(),
		eligibleForRentAllocationPercentage: Type.Number(),
		feePercentage: Type.Number(),
		note: Type.String(),
		createdAt: StringDateSchema,
		updatedAt: StringDateSchema
	});
	CreateMFHRenovationProjectPositionSchema = Type.Intersect([Type.Pick(BaseMFHRenovationProjectPositionSchema, ["measuresPackage", "positionCode"]), Type.Partial(Type.Omit(BaseMFHRenovationProjectPositionSchema, [
		"measuresPackage",
		"positionCode",
		"mfhRenovationProjectPositionId"
	]))]);
	UpdateRenovationProjectPositionSchema = Type.Partial(Type.Pick(BaseMFHRenovationProjectPositionSchema, [
		"status",
		"costEstimate",
		"note",
		"estimatedExternalCostAttributionPercentage",
		"eligibleForSubsidiesPercentage",
		"eligibleForRentAllocationPercentage",
		"budget",
		"costCalculation",
		"costForecast",
		"mfhRenovationProjectLotId"
	]));
	validate = ajv.compile(CreateMFHRenovationProjectPositionSchema);
	validateCreateMFHRenovationPositionsData = (data) => {
		if (validate(data)) return {
			valid: true,
			errors: []
		};
		const validationErrors = [];
		(validate.errors || []).forEach((err) => {
			validationErrors.push({
				path: err.instancePath,
				message: err.message || "Unknown error"
			});
		});
		return {
			valid: false,
			errors: validationErrors
		};
	};
	getAssetPartnerFeePercent = (assetPartnerConfig, assetPartnerName) => {
		if (isNil(assetPartnerConfig?.condoRenovationServiceFee)) throw new Error(`No renovation service configuration found for asset partner ${assetPartnerName ?? ""}`);
		return assetPartnerConfig.condoRenovationServiceFee;
	};
	RenovationProjectPositionCalculations = {
		externalCostAttributionPercentage: (allAllocations) => {
			const costAllocations = PositionCostAllocationCalculations.countedAllocations(allAllocations);
			const weightedExternalCostShareSum = costAllocations.reduce((sum, r) => sum.plus(new Decimal$1(r.amount ?? 0).times(new Decimal$1(r.externalCostAttributionPercentage ?? 1))), new Decimal$1(0));
			const allocatedAmount = costAllocations.reduce((sum, r) => sum.plus(new Decimal$1(r.amount ?? 0)), new Decimal$1(0));
			return allocatedAmount.gt(0) ? weightedExternalCostShareSum.div(allocatedAmount) : null;
		},
		costAmendmentTotal: (costAllocations) => {
			return costAllocations.filter((allocation) => allocation.costType === "Addendum").reduce((total, allocation) => total.plus(allocation.amount ?? 0), new Decimal$1(0));
		},
		invoicesBilledTotal: (costAllocations) => {
			return costAllocations.reduce((total, allocation) => total.plus(allocation.paidAmount ?? 0), new Decimal$1(0));
		},
		adjustedContractValue: (costAllocations) => {
			return costAllocations.reduce((total, costAllocation) => total.plus(costAllocation.adjustedContractValue ?? 0), new Decimal$1(0));
		},
		costConcern: (costAllocations) => {
			return costAllocations.filter((allocation) => allocation.costType === "Concern").reduce((total, allocation) => total.plus(allocation.amount ?? 0), new Decimal$1(0));
		},
		prognosis: (position, costAllocations) => {
			switch (position.status) {
				case "Budget": return new Decimal$1(position.budget ?? 0);
				case "CostEstimate": return new Decimal$1(position.costEstimate ?? 0);
				case "CostCalculation": return new Decimal$1(position.costCalculation ?? 0);
				case "CostForecast": return new Decimal$1(position.costForecast ?? 0);
				case "ContractValue": return RenovationProjectPositionCalculations.adjustedContractValue(costAllocations);
				case "Billed": return RenovationProjectPositionCalculations.invoicesBilledTotal(costAllocations) ?? 0;
				default: return new Decimal$1(0);
			}
		},
		uncommittedCost: (position, costAllocations) => {
			return new Decimal$1(position.budget ?? 0).minus(RenovationProjectPositionCalculations.adjustedContractValue(costAllocations)).toDecimalPlaces(2);
		}
	};
	getPositionCategoryCode = (code) => {
		for (const [key, value] of Object.entries(MFHRenovationProjectCategoryPositions)) if (value.includes(code)) return key;
	};
	sheetToMeasuresPackage = invert(MFHRenovationProjectMeasuresPackageTranslations);
	pString = (v) => String(v).trim() || void 0;
	pPositionCode = (v) => v != null && v !== "" ? String(v).trim() : void 0;
	pNumber = (v) => isNil(v) || v === "" ? void 0 : +v;
	pRenovationMeasuresPackage = (v) => v ? sheetToMeasuresPackage[v] ?? void 0 : void 0;
	MFHRenovationPositionStatusToCostColumnMap = {
		["Budget"]: null,
		["CostEstimate"]: "costEstimate",
		["CostCalculation"]: "costCalculation",
		["CostForecast"]: "costForecast",
		["ContractValue"]: null,
		["Billed"]: null
	};
	MFHRenovationPositionStatusOrder = [
		"Budget",
		"CostEstimate",
		"CostCalculation",
		"CostForecast",
		"ContractValue",
		"Billed"
	];
	isValidSequentialTransition = (fromState, toState) => {
		const fromIndex = MFHRenovationPositionStatusOrder.indexOf(fromState);
		return MFHRenovationPositionStatusOrder.indexOf(toState) - fromIndex === 1;
	};
	CARRY_OVER_APPLICABLE_TO_STATES = [
		"CostEstimate",
		"CostCalculation",
		"CostForecast"
	];
	MFHRenovationProjectPositionSheetColumnMappings = [
		{
			colIdx: 0,
			label: "Measure Package",
			path: "measuresPackage",
			parse: pRenovationMeasuresPackage,
			serialize: (p) => MFHRenovationProjectMeasuresPackageTranslations[p.measuresPackage],
			validation: {
				getOptions: () => Object.values(MFHRenovationProjectMeasuresPackageTranslations),
				strict: true
			}
		},
		{
			colIdx: 1,
			label: "DIN",
			path: "positionCode",
			parse: pPositionCode,
			validation: {
				getOptions: () => Object.values(MFHRenovationProjectCategoryPositions).flat().map(String),
				strict: true
			}
		},
		{
			colIdx: 2,
			label: "Bemerkungen",
			path: "note",
			parse: pString
		},
		{
			colIdx: 3,
			label: "Budget",
			format: SheetFormatters.euroCurrency,
			path: "budget",
			parse: pNumber
		},
		{
			colIdx: 4,
			label: "Kostenschätzung",
			format: SheetFormatters.euroCurrency,
			path: "costEstimate",
			parse: pNumber
		},
		{
			colIdx: 5,
			label: "Kostenberechnung",
			format: SheetFormatters.euroCurrency,
			path: "costCalculation",
			parse: pNumber
		},
		{
			colIdx: 6,
			label: "Kostenvoranschlag",
			format: SheetFormatters.euroCurrency,
			path: "costForecast",
			parse: pNumber
		},
		{
			colIdx: 7,
			label: "Est. External Cost Share",
			path: "estimatedExternalCostAttributionPercentage",
			format: SheetFormatters.percentage,
			parse: pNumber
		},
		{
			colIdx: 8,
			label: "Eligible for Subsidies",
			path: "eligibleForSubsidiesPercentage",
			format: SheetFormatters.percentage,
			parse: pNumber
		},
		{
			colIdx: 9,
			label: "Eligible for Rent Allocation",
			path: "eligibleForRentAllocationPercentage",
			format: SheetFormatters.percentage,
			parse: pNumber
		}
	];
}));
//#endregion
//#region src/domains/cross-cutting/mfh/renovation-project/mfh-renovation-project.opts.ts
var init_mfh_renovation_project_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/renovation-project/mfh-renovation-project.helpers.ts
var getMfhRenovationProjectCostBreakdownBudget;
var init_mfh_renovation_project_helpers = __esmMin((() => {
	init_mfh_renovation_project_model();
	getMfhRenovationProjectCostBreakdownBudget = (positions, budgetType) => {
		return positions.reduce((posTotal, pos) => {
			if (!pos) return posTotal;
			let costAttributionPercentage = 1;
			if (budgetType === "External") costAttributionPercentage = pos.estimatedExternalCostAttributionPercentage;
			else if (budgetType === "Internal") costAttributionPercentage = 1 - pos.estimatedExternalCostAttributionPercentage;
			return posTotal.plus(pos.prognosis.mul(costAttributionPercentage));
		}, new Decimal$1(0)).toDecimalPlaces(2).toNumber() ?? 0;
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/renovation-project/tendering-process/tendering-process.model.ts
var TenderingProcessStatus, BaseTenderingProcessSchema;
var init_tendering_process_model = __esmMin((() => {
	init_typebox();
	TenderingProcessStatus = /* @__PURE__ */ function(TenderingProcessStatus) {
		TenderingProcessStatus["Pending"] = "Pending";
		TenderingProcessStatus["Completed"] = "Completed";
		TenderingProcessStatus["Cancelled"] = "Cancelled";
		return TenderingProcessStatus;
	}({});
	BaseTenderingProcessSchema = Type.Object({
		tenderingProcessId: Type.Number(),
		mfhRenovationProjectId: Type.Number(),
		name: Type.String(),
		description: Type.String(),
		status: Type.Enum(TenderingProcessStatus),
		createdAt: TStringDate(),
		updatedAt: TStringDate()
	});
}));
//#endregion
//#region src/domains/cross-cutting/mfh/renovation-project/tendering-process/tendering-process-offer.model.ts
var BaseTenderingProcessOfferSchema;
var init_tendering_process_offer_model = __esmMin((() => {
	init_typebox();
	init_mfh_renovation_project_position_model();
	init_mfh_renovation_project_model();
	BaseTenderingProcessOfferSchema = Type.Object({
		tenderingProcessOfferId: Type.Number(),
		tenderingProcessTendererId: Type.Number(),
		contactId: Type.Number(),
		positions: Type.Array(Type.Object({
			measuresPackage: Type.Enum(MFHRenovationProjectMeasuresPackage),
			positionCode: MFHRenovationPositionCodeSchema,
			price: Type.Number({ minimum: 0 }),
			vat: Type.Number(),
			mfhRenovationProjectPositionId: Type.Number(),
			comment: Type.Optional(Type.String())
		})),
		internalAssessment: Type.Optional(Type.String()),
		isFinal: Type.Boolean(),
		createdAt: TStringDate(),
		updatedAt: TStringDate()
	});
}));
//#endregion
//#region src/domains/cross-cutting/mfh/renovation-project/tendering-process/tendering-process-tenderer.model.ts
var TenderingProcessTendererStatus, TenderingProcessTendererEvents, BaseTenderingProcessTendererSchema;
var init_tendering_process_tenderer_model = __esmMin((() => {
	init_typebox();
	TenderingProcessTendererStatus = /* @__PURE__ */ function(TenderingProcessTendererStatus) {
		TenderingProcessTendererStatus["Invited"] = "Invited";
		TenderingProcessTendererStatus["OfferReceived"] = "OfferReceived";
		TenderingProcessTendererStatus["FinalOfferReceived"] = "FinalOfferReceived";
		TenderingProcessTendererStatus["Selected"] = "Selected";
		TenderingProcessTendererStatus["Winner"] = "Winner";
		return TenderingProcessTendererStatus;
	}({});
	TenderingProcessTendererEvents = /* @__PURE__ */ function(TenderingProcessTendererEvents) {
		TenderingProcessTendererEvents["TendererInvited"] = "TendererInvited";
		TenderingProcessTendererEvents["OfferImported"] = "OfferImported";
		TenderingProcessTendererEvents["OfferMarkedAsFinal"] = "OfferMarkedAsFinal";
		TenderingProcessTendererEvents["OfferUnmarkedAsFinal"] = "OfferUnmarkedAsFinal";
		TenderingProcessTendererEvents["MarkedAsWinner"] = "MarkedAsWinner";
		TenderingProcessTendererEvents["UnmarkedAsWinner"] = "UnmarkedAsWinner";
		TenderingProcessTendererEvents["OfferRemoved"] = "OfferRemoved";
		return TenderingProcessTendererEvents;
	}({});
	BaseTenderingProcessTendererSchema = Type.Object({
		tenderingProcessTendererId: Type.Number(),
		tenderingProcessId: Type.Number(),
		companyId: Type.Number(),
		status: Type.Enum(TenderingProcessTendererStatus),
		createdAt: TStringDate(),
		updatedAt: TStringDate()
	});
}));
//#endregion
//#region src/domains/cross-cutting/mfh/renovation-project/tendering-process/tendering-process.opts.ts
var init_tendering_process_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/renovation-project/tendering-process/index.ts
var init_tendering_process = __esmMin((() => {
	init_tendering_process_model();
	init_tendering_process_offer_model();
	init_tendering_process_tenderer_model();
	init_tendering_process_opts();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/renovation-project/contract/contract.model.ts
var ContractStatus, BaseContractSchema;
var init_contract_model = __esmMin((() => {
	init_shared_schemas();
	init_typebox();
	ContractStatus = /* @__PURE__ */ function(ContractStatus) {
		ContractStatus["PendingServiceFulfillment"] = "PendingServiceFulfillment";
		ContractStatus["PendingFinalInspection"] = "PendingFinalInspection";
		ContractStatus["Billed"] = "Billed";
		ContractStatus["Closed"] = "Closed";
		return ContractStatus;
	}({});
	BaseContractSchema = Type.Object({
		contractId: Type.Number(),
		mfhRenovationProjectId: Type.Number(),
		mfhId: Type.Optional(Type.Number()),
		companyId: Type.Number(),
		name: Type.String(),
		contractNumber: TNullable(Type.Number()),
		formattedContractNumber: Type.Optional(TNullable(Type.String())),
		description: TNullable(Type.String()),
		agreedValue: Type.String(),
		startDate: TNullable(Type.Union([Type.String(), TStringDate()])),
		endDate: TNullable(Type.Union([Type.String(), TStringDate()])),
		status: Type.Enum(ContractStatus),
		createdAt: TStringDate(),
		updatedAt: TStringDate()
	});
}));
//#endregion
//#region src/domains/cross-cutting/mfh/renovation-project/contract/contract.opts.ts
var init_contract_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/renovation-project/contract/index.ts
var init_contract = __esmMin((() => {
	init_contract_model();
	init_contract_opts();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/renovation-project/payment-event/payment-event.model.ts
var BasePaymentEventSchema, PaymentEvent;
var init_payment_event_model = __esmMin((() => {
	init_shared_schemas();
	init_typebox();
	BasePaymentEventSchema = Type.Object({
		paymentEventId: Type.Number(),
		contractId: Type.Number(),
		invoiceId: Type.Optional(TNullable(Type.Number())),
		name: Type.Optional(Type.Union([Type.Null(), Type.String()])),
		expectedPaymentDate: Type.Union([Type.String(), TStringDate()]),
		expectedPaymentAmount: TDecimal,
		createdAt: Type.Optional(StringDateSchema),
		updatedAt: Type.Optional(StringDateSchema)
	});
	PaymentEvent = class {
		contract;
		invoice;
		constructor(props) {
			Object.assign(this, props);
			this.expectedPaymentAmount = props.expectedPaymentAmount != null ? new Decimal(props.expectedPaymentAmount) : new Decimal(0);
		}
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/renovation-project/payment-event/payment-schedule.builder.ts
function resolveAccountingName(accounting) {
	if (accounting?.company?.name) return accounting.company.name;
	if (accounting?.contact) {
		const { fullname, firstname, lastname } = accounting.contact;
		if (fullname) return fullname;
		if (firstname && lastname) return `${firstname} ${lastname}`;
		if (lastname) return lastname;
	}
	return null;
}
function sortByExpectedPaymentDate(a, b) {
	const aDate = a.expectedPaymentDate ? new Date(a.expectedPaymentDate.toString()).getTime() : Number.MAX_SAFE_INTEGER;
	const bDate = b.expectedPaymentDate ? new Date(b.expectedPaymentDate.toString()).getTime() : Number.MAX_SAFE_INTEGER;
	if (aDate !== bDate) return aDate - bDate;
	return (a.paymentEventId ?? 0) - (b.paymentEventId ?? 0);
}
/**
* Canonical order of payment events within a contract's payment schedule: by expected payment
* date, then id. Shared so any consumer (schedule table, payment-event dropdown) numbers and
* orders events identically.
*/
function orderPaymentEventsForSchedule(paymentEvents) {
	return paymentEvents.toSorted(sortByExpectedPaymentDate);
}
function deriveSortDate(pe, inv) {
	if (inv) {
		if (PAID_INVOICE_STATES.includes(inv.state) && inv.paidAt) return inv.paidAt.toString();
		if (inv.invoiceDate) return inv.invoiceDate.toString();
	}
	return pe.expectedPaymentDate?.toString() ?? null;
}
function sortBySortDateAsc(a, b) {
	if (!a.sortDate && b.sortDate) return 1;
	if (a.sortDate && !b.sortDate) return -1;
	return (a.sortDate ? new Date(a.sortDate).getTime() : 0) - (b.sortDate ? new Date(b.sortDate).getTime() : 0);
}
/**
* Build a contract payment schedule from its payment events.
*
* Each payment event may carry a manually linked invoice (`pe.invoice`, many events
* per invoice via `payment_event.invoice_id`). The expected cost is shown until an
* invoice is linked; once linked, the invoice surfaces alongside it.
*/
function buildPaymentSchedule(paymentEvents, agreedValue) {
	const agreedDecimal = new Decimal(agreedValue);
	const seenInvoiceIds = /* @__PURE__ */ new Set();
	return orderPaymentEventsForSchedule(paymentEvents).map((pe) => {
		const inv = pe.invoice;
		const invoiceAmount = inv ? getInvoiceNetAmountAfterVat(inv).toDecimalPlaces(2, Decimal.ROUND_HALF_UP).toNumber() : null;
		const isFirstOccurrence = inv != null && !seenInvoiceIds.has(inv.invoiceId);
		if (inv != null) seenInvoiceIds.add(inv.invoiceId);
		let expectedPaymentPercentage = null;
		if (pe.expectedPaymentAmount != null && !agreedDecimal.isZero()) expectedPaymentPercentage = new Decimal(pe.expectedPaymentAmount).div(agreedDecimal).mul(100).toDecimalPlaces(2).toNumber();
		return {
			paymentEventId: pe.paymentEventId ?? null,
			paymentEventName: pe.name ?? null,
			expectedPaymentDate: pe.expectedPaymentDate?.toString() ?? null,
			expectedPaymentAmount: pe.expectedPaymentAmount?.toString() ?? null,
			expectedPaymentPercentage,
			invoiceId: inv?.invoiceId ?? null,
			invoiceType: inv?.invoiceType ?? null,
			invoiceStatus: inv?.state ?? null,
			invoiceDebtorName: inv ? resolveAccountingName(inv.debtorAccounting) : null,
			invoiceCreditorName: inv ? resolveAccountingName(inv.creditorAccounting) : null,
			invoiceAmount,
			invoiceAmountCountable: isFirstOccurrence ? invoiceAmount : null,
			invoicePaidAt: inv?.paidAt?.toString() ?? null,
			sortDate: deriveSortDate(pe, inv)
		};
	});
}
/**
* Lean per-contract schedule for the cross-asset forecast: dates/amounts only,
* driven entirely by payment events and their linked invoices.
*/
function buildAssetPaymentSchedule(paymentEvents) {
	const seenInvoiceIds = /* @__PURE__ */ new Set();
	return orderPaymentEventsForSchedule(paymentEvents).map((pe) => {
		const inv = pe.invoice;
		const invoiceAmount = inv ? getInvoiceNetAmountAfterVat(inv).toNumber() : null;
		const isFirstOccurrence = inv != null && !seenInvoiceIds.has(inv.invoiceId);
		if (inv != null) seenInvoiceIds.add(inv.invoiceId);
		return {
			expectedPaymentDate: pe.expectedPaymentDate?.toString() ?? null,
			expectedPaymentAmount: pe.expectedPaymentAmount?.toString() ?? null,
			invoiceId: inv?.invoiceId ?? null,
			invoiceAmount,
			invoiceAmountCountable: isFirstOccurrence ? invoiceAmount : null,
			invoicePaidAt: inv?.paidAt?.toString() ?? null,
			sortDate: deriveSortDate(pe, inv)
		};
	}).toSorted(sortBySortDateAsc);
}
var init_payment_schedule_builder = __esmMin((() => {
	init_invoice_helpers();
	init_invoice_model();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/renovation-project/payment-event/index.ts
var init_payment_event = __esmMin((() => {
	init_payment_event_model();
	init_payment_schedule_builder();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/renovation-project/mfh-renovation-project-planning-module.model.ts
var MFHRenovationProjectPlanningModuleProcessType, MFHRenovationProjectPlanningModuleStatus, MFHRenovationProjectPlanningModuleProcessStateMapping, BaseMFHRenovationProjectPlanningModuleSchema;
var init_mfh_renovation_project_planning_module_model = __esmMin((() => {
	init_shared_schemas();
	init_mfh_renovation_project_model();
	MFHRenovationProjectPlanningModuleProcessType = /* @__PURE__ */ function(MFHRenovationProjectPlanningModuleProcessType) {
		MFHRenovationProjectPlanningModuleProcessType["PlanningModule"] = "PlanningModule";
		return MFHRenovationProjectPlanningModuleProcessType;
	}({});
	MFHRenovationProjectPlanningModuleStatus = /* @__PURE__ */ function(MFHRenovationProjectPlanningModuleStatus) {
		MFHRenovationProjectPlanningModuleStatus["BasicEvaluation"] = "BasicEvaluation";
		MFHRenovationProjectPlanningModuleStatus["PlanningTendering"] = "PlanningTendering";
		MFHRenovationProjectPlanningModuleStatus["PlanningAndConstructionTendering"] = "PlanningAndConstructionTendering";
		MFHRenovationProjectPlanningModuleStatus["PreliminaryPlanning"] = "PreliminaryPlanning";
		MFHRenovationProjectPlanningModuleStatus["DesignPlanning"] = "DesignPlanning";
		MFHRenovationProjectPlanningModuleStatus["PermitPlanning"] = "PermitPlanning";
		MFHRenovationProjectPlanningModuleStatus["ExecutionPlanning"] = "ExecutionPlanning";
		MFHRenovationProjectPlanningModuleStatus["TenderPreparationConstruction"] = "TenderPreparationConstruction";
		MFHRenovationProjectPlanningModuleStatus["Completed"] = "Completed";
		return MFHRenovationProjectPlanningModuleStatus;
	}({});
	MFHRenovationProjectPlanningModuleProcessStateMapping = { ["PlanningModule"]: MFHRenovationProjectPlanningModuleStatus };
	BaseMFHRenovationProjectPlanningModuleSchema = Type.Object({
		mfhRenovationProjectPlanningModuleId: Type.Number(),
		mfhRenovationProjectId: Type.Number(),
		name: Type.String(),
		status: Type.Enum(MFHRenovationProjectPlanningModuleStatus),
		mfhRenovationProjectPlanningSetup: Type.Optional(Type.Enum(MfhRenovationProjectPlanningSetup)),
		measuresPackages: Type.Array(Type.Enum(MFHRenovationProjectMeasuresPackage)),
		createdAt: StringDateSchema,
		updatedAt: StringDateSchema,
		deletedAt: StringDateSchema,
		/** @deprecated moved to mfhRenovationProject */
		isPotentialBudget: Type.Optional(Type.Boolean())
	});
}));
//#endregion
//#region src/domains/cross-cutting/mfh/renovation-project/mfh-renovation-project-lot.model.ts
var MfhRenovationProjectLotState, MfhRenovationProjectLotProcessType, MfhRenovationProjectLotProcessStateMapping, BaseMFHRenovationProjectLotSchema;
var init_mfh_renovation_project_lot_model = __esmMin((() => {
	init_shared_schemas();
	init_mfh_renovation_project_model();
	MfhRenovationProjectLotState = /* @__PURE__ */ function(MfhRenovationProjectLotState) {
		MfhRenovationProjectLotState["TenderPreparationConstruction"] = "TenderPreparationConstruction";
		MfhRenovationProjectLotState["TenderExecutionConstruction"] = "TenderExecutionConstruction";
		MfhRenovationProjectLotState["ExecutionPlanning"] = "ExecutionPlanning";
		MfhRenovationProjectLotState["Construction"] = "Construction";
		MfhRenovationProjectLotState["Completed"] = "Completed";
		return MfhRenovationProjectLotState;
	}({});
	MfhRenovationProjectLotProcessType = /* @__PURE__ */ function(MfhRenovationProjectLotProcessType) {
		MfhRenovationProjectLotProcessType["MfhRenovationProjectLot"] = "MfhRenovationProjectLot";
		return MfhRenovationProjectLotProcessType;
	}({});
	MfhRenovationProjectLotProcessStateMapping = { ["MfhRenovationProjectLot"]: MfhRenovationProjectLotState };
	BaseMFHRenovationProjectLotSchema = Type.Object({
		mfhRenovationProjectLotId: Type.Number(),
		tenderingProcessId: Type.Optional(Type.Number()),
		mfhRenovationProjectId: Type.Number(),
		name: Type.String(),
		status: Type.Enum(MfhRenovationProjectLotState),
		mfhRenovationProjectPlanningSetup: Type.Optional(Type.Enum(MfhRenovationProjectPlanningSetup)),
		measuresPackages: Type.Array(Type.Enum(MFHRenovationProjectMeasuresPackage)),
		createdAt: StringDateSchema,
		updatedAt: StringDateSchema
	});
}));
//#endregion
//#region src/domains/cross-cutting/mfh/renovation-project/position-cost-allocation/position-cost-allocation.opts.ts
var init_position_cost_allocation_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/renovation-project/position-cost-allocation/position-cost-allocation.i18n.ts
var PositionCostAllocationCostTypeTranslations;
var init_position_cost_allocation_i18n = __esmMin((() => {
	init_position_cost_allocation_model();
	PositionCostAllocationCostTypeTranslations = {
		["Concern"]: "Weitere Erwartete Kosten",
		["Addendum"]: "Nachträge",
		["ContractValue"]: "Auftragssumme",
		["Rejected"]: "Abgelehnte Nachträge"
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/renovation-project/position-cost-allocation/index.ts
var init_position_cost_allocation = __esmMin((() => {
	init_position_cost_allocation_model();
	init_position_cost_allocation_opts();
	init_position_cost_allocation_i18n();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/renovation-project/index.ts
var init_renovation_project = __esmMin((() => {
	init_addendum();
	init_mfh_renovation_project_model();
	init_mfh_renovation_project_position_model();
	init_mfh_renovation_project_i18n();
	init_mfh_renovation_project_opts();
	init_mfh_renovation_project_helpers();
	init_mfh_renovation_project_cost_breakdown_process_base();
	init_tendering_process();
	init_contract();
	init_payment_event();
	init_mfh_renovation_project_planning_module_model();
	init_mfh_renovation_project_lot_model();
	init_position_cost_allocation();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh-external-unit.model.ts
var MFHExternalUnitStatus, MFHExternalUnitStatusTranslation, MFHExternalUnitSchema;
var init_mfh_external_unit_model = __esmMin((() => {
	init_shared_schemas();
	MFHExternalUnitStatus = /* @__PURE__ */ function(MFHExternalUnitStatus) {
		MFHExternalUnitStatus["New"] = "NEW";
		MFHExternalUnitStatus["ProcessingError"] = "PROCESSING_ERROR";
		MFHExternalUnitStatus["Reconciled"] = "RECONCILED";
		MFHExternalUnitStatus["PendingManualLinking"] = "PENDING_MANUAL_LINKING";
		MFHExternalUnitStatus["ErrorAssetNotFound"] = "ERROR_ASSET_NOT_FOUND";
		MFHExternalUnitStatus["ErrorManyAssetsFound"] = "ERROR_MANY_ASSETS_FOUND";
		MFHExternalUnitStatus["ErrorNoMatchingMFHBuildingFound"] = "ERROR_NO_MATCHING_MFH_BUILDING_FOUND";
		MFHExternalUnitStatus["ErrorEmptyUnitWithActiveRentalContract"] = "ERROR_EMPTY_UNIT_WITH_ACTIVE_RENTAL_CONTRACT";
		return MFHExternalUnitStatus;
	}({});
	MFHExternalUnitStatusTranslation = {
		["NEW"]: "Neu",
		["PROCESSING_ERROR"]: "Fehler beim Verarbeiten",
		["RECONCILED"]: "Abgeglichen",
		["PENDING_MANUAL_LINKING"]: "Manuelle Verknüpfung ausstehend",
		["ERROR_ASSET_NOT_FOUND"]: "Fehler: Asset nicht gefunden",
		["ERROR_MANY_ASSETS_FOUND"]: "Fehler: Mehrere Assets gefunden",
		["ERROR_NO_MATCHING_MFH_BUILDING_FOUND"]: "Fehler: Kein passendes MFH Building gefunden",
		["ERROR_EMPTY_UNIT_WITH_ACTIVE_RENTAL_CONTRACT"]: "Fehler: Leere Einheit mit aktivem Mietvertrag"
	};
	MFHExternalUnitSchema = Type.Object({
		mfhExternalUnitId: Type.Number(),
		estacoreUnitId: Type.String(),
		mfhId: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
		estateId: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
		status: TEnum(MFHExternalUnitStatus),
		statusMessage: Type.Optional(Type.Union([Type.String(), Type.Null()])),
		hash: Type.Optional(Type.Union([Type.String(), Type.Null()])),
		currentData: Type.Optional(Type.Union([
			Type.Unsafe(),
			Type.Null(),
			Type.Undefined()
		])),
		dataHistory: Type.Optional(Type.Union([
			Type.Record(Type.String(), Type.Object({
				hash: Type.String(),
				data: Type.Unsafe(),
				status: TEnum(MFHExternalUnitStatus),
				statusMessage: Type.Optional(Type.Union([Type.String(), Type.Null()]))
			})),
			Type.Null(),
			Type.Undefined()
		])),
		lastSync: Type.Optional(Type.Union([StringDateSchema, Type.Null()])),
		linkedAt: Type.Optional(Type.Union([StringDateSchema, Type.Null()])),
		createdAt: StringDateSchema,
		updatedAt: StringDateSchema
	});
}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh-external-unit.class.ts
/**
* Simple hash implementation fo data integrity purposes
*/
function fastHash(str) {
	let hash = 0;
	for (let i = 0; i < str.length; i++) {
		hash = (hash << 5) - hash + str.charCodeAt(i);
		hash |= 0;
	}
	return hash >>> 0;
}
function hash(data) {
	return fastHash(data).toString(16).padStart(8, "0");
}
var MFHExternalUnit;
var init_mfh_external_unit_class = __esmMin((() => {
	init_mfh_external_unit_model();
	MFHExternalUnit = class MFHExternalUnit {
		mfhExternalUnitId;
		estacoreUnitId;
		mfhId;
		estateId;
		status;
		statusMessage;
		hash;
		currentData;
		dataHistory;
		lastSync;
		linkedAt;
		createdAt;
		updatedAt;
		static importFields = [
			"tenantName",
			"plotDescription",
			"floorLocation",
			"areaUsageType",
			"propertyDescription",
			"floor",
			"searchName",
			"contractStartDate",
			"contractEndDate",
			"name1",
			"name2",
			"name3",
			"netRent",
			"netServiceCharges",
			"areaInSquareMeters",
			"rentPerParkingSpot",
			"depositAmount",
			"unitDescription",
			"location",
			"primaryMobile",
			"mobile",
			"phone",
			"primaryEmail",
			"email",
			"vat",
			"propertyId",
			"unitNumber",
			"estarCoreUnitId",
			"estarCoreRentalContractId",
			"tenantNumber",
			"estarCoreTenantId"
		];
		constructor(mfhExternalUnit) {
			this.mfhExternalUnitId = mfhExternalUnit.mfhExternalUnitId;
			this.estacoreUnitId = mfhExternalUnit.estacoreUnitId;
			this.mfhId = mfhExternalUnit.mfhId;
			this.estateId = mfhExternalUnit.estateId;
			this.status = mfhExternalUnit.status;
			this.statusMessage = mfhExternalUnit.statusMessage;
			this.hash = mfhExternalUnit.hash;
			this.currentData = mfhExternalUnit.currentData;
			this.dataHistory = mfhExternalUnit.dataHistory;
			this.lastSync = mfhExternalUnit.lastSync;
			this.linkedAt = mfhExternalUnit.linkedAt;
			this.createdAt = mfhExternalUnit.createdAt;
			this.updatedAt = mfhExternalUnit.updatedAt;
			Object.assign(this, mfhExternalUnit);
		}
		get operationDate() {
			return this.lastSync instanceof Date ? this.lastSync.toISOString() : this.lastSync ?? (/* @__PURE__ */ new Date()).toISOString();
		}
		ensureCurrentDataIsInHistory() {
			const operationDate = this.operationDate;
			if (!this.currentData) return;
			if (!this.dataHistory) {
				this.dataHistory = { [operationDate]: {
					hash: this.hash ?? MFHExternalUnit.hash(this.currentData),
					data: this.currentData,
					status: this.status,
					statusMessage: this.statusMessage
				} };
				return;
			}
			if (!Object.values(this.dataHistory).find((history) => history?.hash === this.hash)) this.dataHistory[operationDate] = {
				hash: this.hash ?? MFHExternalUnit.hash(this.currentData),
				data: this.currentData,
				status: this.status,
				statusMessage: this.statusMessage
			};
		}
		setCurrentData(estarcoreTenancy, status, statusMessage) {
			this.currentData = estarcoreTenancy;
			this.hash = MFHExternalUnit.hash(estarcoreTenancy);
			this.status = status;
			this.statusMessage = statusMessage;
			this.lastSync = /* @__PURE__ */ new Date();
		}
		update(estarcoreTenancy, status, statusMessage) {
			this.ensureCurrentDataIsInHistory();
			this.setCurrentData(estarcoreTenancy, status, statusMessage);
			this.ensureCurrentDataIsInHistory();
			return this;
		}
		differs(estarcoreTenancy) {
			return this.hash !== MFHExternalUnit.hash(estarcoreTenancy);
		}
		static hash(estarcoreTenancy) {
			return hash(JSON.stringify(pick(estarcoreTenancy, MFHExternalUnit.importFields)));
		}
		static create({ estarcoreTenancy, mfhId, estateId, status, statusMessage }) {
			const _status = status ?? "NEW";
			const _hash = MFHExternalUnit.hash(estarcoreTenancy);
			const _lastSync = /* @__PURE__ */ new Date();
			return new MFHExternalUnit({
				mfhExternalUnitId: void 0,
				createdAt: void 0,
				updatedAt: void 0,
				estacoreUnitId: estarcoreTenancy.estarCoreUnitId,
				mfhId,
				estateId,
				status: _status,
				hash: _hash,
				statusMessage,
				currentData: estarcoreTenancy,
				dataHistory: { [_lastSync.toISOString()]: {
					data: estarcoreTenancy,
					hash: _hash,
					status: _status,
					statusMessage
				} },
				lastSync: _lastSync,
				linkedAt: null
			});
		}
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/asset-rent-roll.model.ts
var AssetRentRollSchema;
var init_asset_rent_roll_model = __esmMin((() => {
	init_lib();
	init_rentable_unit_model$1();
	AssetRentRollSchema = Type.Object({
		estateId: TNullable(Type.Number()),
		estateCondoUuid: TNullable(Type.String()),
		mfhBuildingId: TNullable(Type.Number()),
		mfhId: TNullable(Type.Number()),
		rentalContractId: TNullable(Type.Number()),
		rentableUnitState: TNullable(Type.Enum(RentableUnitStates)),
		renovationState: TNullable(Type.String()),
		apartmentNumber: TNullable(Type.String()),
		buildingAddress: TNullable(Type.String()),
		floorLocation: TNullable(Type.String()),
		apartmentType: TNullable(Type.String()),
		tenant: TNullable(Type.String()),
		contractStartDate: TNullable(Type.String()),
		area: TNullable(Type.Number()),
		netColdRent: TNullable(Type.Number()),
		rentPerSQM: TNullable(Type.Number()),
		utilityCosts: TNullable(Type.Number()),
		heatingCosts: TNullable(Type.Number()),
		annualNetColdRent: TNullable(Type.Number()),
		vat: TNullable(Type.Number())
	}, { $id: "AssetRentRoll" });
}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh-project-plan.model.ts
function ganttDataToCsv(ganttData) {
	const taskMap = new Map(ganttData.data.map((t) => [t.id, t]));
	const buildHierarchy = (task) => {
		const row = [
			"",
			"",
			"",
			""
		];
		if (task.parent && task.parent !== "0") {
			const parent = taskMap.get(task.parent);
			if (parent) {
				const parentRow = buildHierarchy(parent);
				for (let i = 0; i < 4; i++) row[i] = parentRow[i];
			}
		}
		switch (task.rowType) {
			case "phase":
				row[0] = task.text;
				break;
			case "stage":
				row[1] = task.text;
				break;
			case "measurePackage":
				row[2] = task.text;
				break;
			case "activityGroup": {
				const parts = task.text.trim().split(" ");
				if (parts.length < 3) row[4] = task.text;
				else {
					const [letters, code, ...rest] = parts;
					const activityId = `${letters} ${code}`;
					const activityName = rest.join(" ");
					row[3] = activityId;
					row[4] = activityName;
				}
				break;
			}
		}
		return row;
	};
	const headers = [
		"Phase",
		"Stage",
		"Measure Package",
		"Activity ID",
		"Activity Name",
		"Start Date",
		"End Date",
		"Milestones",
		"Milestone Dates"
	];
	const hiearchyHeaderCount = headers.length - 4;
	const rows = ganttData.data.filter((task) => task.rowType === "activityGroup").flatMap((task) => {
		const hierarchy = buildHierarchy(task);
		const milestones = task.milestones;
		if (milestones && milestones.length > 0) {
			const [firstMilestone, ...restMilestones] = milestones;
			return [[
				...hierarchy,
				task.startDate ? dayjs(task.startDate).format("YY-MM-DD") : "",
				task.endDate ? dayjs(task.endDate).format("YY-MM-DD") : "",
				firstMilestone.name || "",
				firstMilestone.date ? dayjs(firstMilestone.date).format("YY-MM-DD") : "TBD"
			], ...restMilestones.map((milestone) => [
				...new Array(hiearchyHeaderCount).fill(""),
				task.startDate ? dayjs(task.startDate).format("YY-MM-DD") : "",
				task.endDate ? dayjs(task.endDate).format("YY-MM-DD") : "",
				milestone.name || "",
				milestone.date ? dayjs(milestone.date).format("YY-MM-DD") : "TBD"
			])];
		}
		return [[
			...hierarchy,
			task.startDate ? dayjs(task.startDate).format("YY-MM-DD") : "",
			task.endDate ? dayjs(task.endDate).format("YY-MM-DD") : ""
		]];
	});
	return [headers.join(","), ...rows.map((row) => row.map((cell) => `"${cell}"`).join(","))].join("\n");
}
var init_mfh_project_plan_model = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh-project-plan.opts.ts
var init_mfh_project_plan_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/sheet-embedding/mfh-sheet-embedding.model.ts
var MFHSheetEmbeddingMode, MFHPrecacheSliceStatus, MFHPrecacheSliceFailureReason;
var init_mfh_sheet_embedding_model = __esmMin((() => {
	MFHSheetEmbeddingMode = /* @__PURE__ */ function(MFHSheetEmbeddingMode) {
		MFHSheetEmbeddingMode["Portfolio"] = "portfolio";
		MFHSheetEmbeddingMode["D2G"] = "d2g";
		return MFHSheetEmbeddingMode;
	}({});
	MFHPrecacheSliceStatus = /* @__PURE__ */ function(MFHPrecacheSliceStatus) {
		MFHPrecacheSliceStatus["None"] = "none";
		MFHPrecacheSliceStatus["Pending"] = "pending";
		MFHPrecacheSliceStatus["Deferred"] = "deferred";
		MFHPrecacheSliceStatus["Ready"] = "ready";
		MFHPrecacheSliceStatus["Failed"] = "failed";
		return MFHPrecacheSliceStatus;
	}({});
	MFHPrecacheSliceFailureReason = /* @__PURE__ */ function(MFHPrecacheSliceFailureReason) {
		MFHPrecacheSliceFailureReason["RenderedWithErrors"] = "rendered_with_errors";
		MFHPrecacheSliceFailureReason["Unreachable"] = "unreachable";
		MFHPrecacheSliceFailureReason["Timeout"] = "timeout";
		MFHPrecacheSliceFailureReason["RenderFailed"] = "render_failed";
		return MFHPrecacheSliceFailureReason;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/mfh/sheet-embedding/mfh-sheet-embedding.opts.ts
var init_mfh_sheet_embedding_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/sheet-embedding/mfh-portfolio-viewer-sheet.opts.ts
var MFH_PORTFOLIO_VIEWER_VERSIONS;
var init_mfh_portfolio_viewer_sheet_opts = __esmMin((() => {
	MFH_PORTFOLIO_VIEWER_VERSIONS = {
		"v2.0.0": {
			d2gVersionRange: "=2.0.0",
			sheetIdsByName: {
				Config: 2059743476,
				"Portfolio CF Engine - Quarter": 343715493,
				"Portfolio CF Engine": 310045352,
				"Portfolio GRI": 214581471,
				"Portfolio IC Charts": 697254746
			},
			mfhSheetEmbeddingConfigPresetItems: [
				{
					name: "Investment Returns & Value Bridge",
					a1Range: "N10:AE39",
					sheetId: 697254746,
					height: 660
				},
				{
					name: "Debt Structure & Combined Financing",
					a1Range: "AF40:AK80",
					sheetId: 697254746,
					height: 902
				},
				{
					name: "BP Assumptions & Metrics by Use Type",
					a1Range: "AL81:BD110",
					sheetId: 697254746,
					height: 660
				},
				{
					name: "Annual Levered & Unlevered Cash Flow",
					a1Range: "BE111:BS175",
					sheetId: 697254746,
					height: 1400
				},
				{
					name: "Portfolio Key Deal & Asset Level Metrics",
					a1Range: "BT176:CO191",
					sheetId: 697254746,
					height: 370
				},
				{
					name: "Banking Version – Annual Cash Flow (incl. VAT)",
					a1Range: "CP192:DD253",
					sheetId: 697254746,
					height: 1325
				},
				{
					name: "Banking Investment Case – Sources, Exit & Value Bridge",
					a1Range: "DE254:DV276",
					sheetId: 697254746,
					height: 506
				},
				{
					name: "Banking – Debt Structure & Combined Financing",
					a1Range: "DW277:EB313",
					sheetId: 697254746,
					height: 800
				},
				{
					name: "Banking – Rental Income Bridge",
					a1Range: "EC314:EV334",
					sheetId: 697254746,
					height: 462
				},
				{
					name: "Banking – Rental Income Bridge (Stabilized)",
					a1Range: "EW335:FP355",
					sheetId: 697254746,
					height: 462
				},
				{
					name: "Banking – Value Bridge (AIC to Net Profit)",
					a1Range: "FQ356:GP377",
					sheetId: 697254746,
					height: 484
				},
				{
					name: "Banking – Portfolio Annual Cash Flow (incl. VAT)",
					a1Range: "GQ378:HS438",
					sheetId: 697254746,
					height: 1270
				},
				{
					name: "Portfolio Asset Overview – Size, Acquisition & Rent Metrics",
					a1Range: "HT439:IT490",
					sheetId: 697254746,
					height: 1060
				}
			],
			icUrlSheetName: "Config",
			icUrlStartCell: "D3"
		},
		"v4.3.0": {
			d2gVersionRange: "=4.1.0",
			sheetIdsByName: {
				Config: 2059743476,
				"Portfolio CF Engine - Quarter": 343715493,
				"Portfolio IC Charts": 697254746,
				"Fund Vehicle Chart": 1637014204,
				"Portfolio CF Engine": 310045352,
				"Portfolio GRI": 214581471
			},
			mfhSheetEmbeddingConfigPresetItems: [
				{
					name: "Investment Returns & Value Bridge",
					a1Range: "N10:AE39",
					sheetId: 697254746,
					height: 660
				},
				{
					name: "Debt Structure & Combined Financing",
					a1Range: "AF40:AK80",
					sheetId: 697254746,
					height: 902
				},
				{
					name: "BP Assumptions & Metrics by Use Type",
					a1Range: "AL81:BD110",
					sheetId: 697254746,
					height: 660
				},
				{
					name: "Annual Levered & Unlevered Cash Flow",
					a1Range: "BE111:CC175",
					sheetId: 697254746,
					height: 1400
				},
				{
					name: "Portfolio Key Deal & Asset Level Metrics",
					a1Range: "CD176:CY191",
					sheetId: 697254746,
					height: 370
				},
				{
					name: "Banking Version – Annual Cash Flow (incl. VAT)",
					a1Range: "CZ192:DX253",
					sheetId: 697254746,
					height: 1325
				},
				{
					name: "Banking Investment Case – Sources, Exit & Value Bridge",
					a1Range: "DY254:EP276",
					sheetId: 697254746,
					height: 506
				},
				{
					name: "Banking – Debt Structure & Combined Financing",
					a1Range: "FV277:GA313",
					sheetId: 697254746,
					height: 800
				},
				{
					name: "Banking – Rental Income Bridge",
					a1Range: "GB314:GU334",
					sheetId: 697254746,
					height: 462
				},
				{
					name: "Banking – Rental Income Bridge (Stabilized)",
					a1Range: "GV335:HO355",
					sheetId: 697254746,
					height: 462
				},
				{
					name: "Banking – Value Bridge (AIC to Net Profit)",
					a1Range: "HP356:IO377",
					sheetId: 697254746,
					height: 484
				},
				{
					name: "Banking – Portfolio Annual Cash Flow (incl. VAT)",
					a1Range: "IP378:JR438",
					sheetId: 697254746,
					height: 1270
				},
				{
					name: "Portfolio Asset Overview – Size, Acquisition & Rent Metrics",
					a1Range: "JS439:KS491",
					sheetId: 697254746,
					height: 1060
				}
			],
			icUrlSheetName: "Config",
			icUrlStartCell: "E3"
		},
		"v5.1.0": {
			d2gVersionRange: "=4.9.3",
			sheetIdsByName: {
				Config: 2059743476,
				"Portfolio CF Engine - Quarter": 343715493,
				"Portfolio IC Charts": 697254746,
				"Fund Vehicle Chart": 430459522,
				"Portfolio CF Engine": 310045352,
				"Portfolio GRI": 214581471
			},
			mfhSheetEmbeddingConfigPresetItems: [
				{
					name: "Investment Returns & Value Bridge",
					a1Range: "N10:AE39",
					sheetId: 697254746,
					height: 660
				},
				{
					name: "Debt Structure & Combined Financing",
					a1Range: "AF40:AK80",
					sheetId: 697254746,
					height: 902
				},
				{
					name: "BP Assumptions & Metrics by Use Type",
					a1Range: "AL81:BD110",
					sheetId: 697254746,
					height: 660
				},
				{
					name: "Annual Levered & Unlevered Cash Flow",
					a1Range: "BE111:CC175",
					sheetId: 697254746,
					height: 1400
				},
				{
					name: "Portfolio Key Deal & Asset Level Metrics",
					a1Range: "CD176:CY191",
					sheetId: 697254746,
					height: 370
				},
				{
					name: "Banking Version – Annual Cash Flow (incl. VAT)",
					a1Range: "CZ192:DX253",
					sheetId: 697254746,
					height: 1325
				},
				{
					name: "Banking Investment Case – Sources, Exit & Value Bridge",
					a1Range: "DY254:EP276",
					sheetId: 697254746,
					height: 506
				},
				{
					name: "Banking – Debt Structure & Combined Financing",
					a1Range: "FV277:GA313",
					sheetId: 697254746,
					height: 800
				},
				{
					name: "Banking – Rental Income Bridge",
					a1Range: "GB314:GU334",
					sheetId: 697254746,
					height: 462
				},
				{
					name: "Banking – Rental Income Bridge (Stabilized)",
					a1Range: "GV335:HO355",
					sheetId: 697254746,
					height: 462
				},
				{
					name: "Banking – Value Bridge (AIC to Net Profit)",
					a1Range: "HP356:IO377",
					sheetId: 697254746,
					height: 484
				},
				{
					name: "Banking – Portfolio Annual Cash Flow (incl. VAT)",
					a1Range: "IP378:JR438",
					sheetId: 697254746,
					height: 1270
				},
				{
					name: "Portfolio Asset Overview – Size, Acquisition & Rent Metrics",
					a1Range: "JS439:KS491",
					sheetId: 697254746,
					height: 1060
				}
			],
			icUrlSheetName: "Config",
			icUrlStartCell: "E3"
		},
		"v5.3.1": {
			d2gVersionRange: ">=5.3.1 <=5.3.2",
			sheetIdsByName: {
				Config: 2059743476,
				"Portfolio IC Charts": 697254746,
				"Fund Vehicle Chart": 430459522,
				"Mieterlisten Output": 546214648,
				"Portfolio CF Engine - Quarter": 343715493,
				"Portfolio CF Engine": 310045352,
				"Portfolio GRI": 214581471
			},
			mfhSheetEmbeddingConfigPresetItems: [
				{
					name: "Investment Returns & Value Bridge",
					a1Range: "N10:AE56",
					sheetId: 697254746,
					height: 1007
				},
				{
					name: "Debt Structure & Combined Financing",
					a1Range: "AF57:AK100",
					sheetId: 697254746,
					height: 955
				},
				{
					name: "BP Assumptions & Metrics by Use Type",
					a1Range: "AL101:BD130",
					sheetId: 697254746,
					height: 660
				},
				{
					name: "Annual Levered & Unlevered Cash Flow",
					a1Range: "BE131:CC199",
					sheetId: 697254746,
					height: 1480
				},
				{
					name: "Portfolio Key Deal & Asset Level Metrics",
					a1Range: "CD200:CY215",
					sheetId: 697254746,
					height: 370
				},
				{
					name: "Banking Version – Annual Cash Flow (incl. VAT)",
					a1Range: "CZ223:DX286",
					sheetId: 697254746,
					height: 1380
				},
				{
					name: "Banking Investment Case – Sources, Exit & Value Bridge",
					a1Range: "DY287:EP309",
					sheetId: 697254746,
					height: 506
				},
				{
					name: "Banking – Debt Structure & Combined Financing",
					a1Range: "FW310:GB347",
					sheetId: 697254746,
					height: 825
				},
				{
					name: "Banking – Rental Income Bridge",
					a1Range: "GC348:GV368",
					sheetId: 697254746,
					height: 462
				},
				{
					name: "Banking – Rental Income Bridge (Stabilized)",
					a1Range: "GW369:HP389",
					sheetId: 697254746,
					height: 462
				},
				{
					name: "Banking – Value Bridge (AIC to Net Profit)",
					a1Range: "HQ390:IP411",
					sheetId: 697254746,
					height: 484
				},
				{
					name: "Banking – Portfolio Annual Cash Flow (incl. VAT)",
					a1Range: "IQ412:KC474",
					sheetId: 697254746,
					height: 1386
				},
				{
					name: "Portfolio Asset Overview – Size, Acquisition & Rent Metrics",
					a1Range: "KD475:LN527",
					sheetId: 697254746,
					height: 1100
				},
				{
					name: "Rental Tables – Resi, Commercial & Parking NMI",
					a1Range: "LO528:NZ604",
					sheetId: 697254746,
					height: 1640
				}
			],
			icUrlSheetName: "Config",
			icUrlStartCell: "E3"
		},
		"v5.4.0": {
			d2gVersionRange: "=5.4.0",
			sheetIdsByName: {
				Config: 2059743476,
				"Portfolio IC Charts": 697254746,
				"Fund Vehicle Chart": 430459522,
				"Portfolio CF Engine - Quarter": 343715493,
				"Portfolio CF Engine": 310045352,
				"Portfolio GRI": 214581471
			},
			mfhSheetEmbeddingConfigPresetItems: [
				{
					name: "Investment Returns & Value Bridge",
					a1Range: "N10:AE56",
					sheetId: 697254746,
					height: 1007
				},
				{
					name: "Debt Structure & Combined Financing",
					a1Range: "AF57:AK100",
					sheetId: 697254746,
					height: 955
				},
				{
					name: "BP Assumptions & Metrics by Use Type",
					a1Range: "AL101:BD130",
					sheetId: 697254746,
					height: 660
				},
				{
					name: "Annual Levered & Unlevered Cash Flow",
					a1Range: "BE131:CC199",
					sheetId: 697254746,
					height: 1480
				},
				{
					name: "Portfolio Key Deal & Asset Level Metrics",
					a1Range: "CD200:CY215",
					sheetId: 697254746,
					height: 370
				},
				{
					name: "Banking Version – Annual Cash Flow (incl. VAT)",
					a1Range: "CZ223:DX286",
					sheetId: 697254746,
					height: 1380
				},
				{
					name: "Banking Investment Case – Sources, Exit & Value Bridge",
					a1Range: "DY287:EP309",
					sheetId: 697254746,
					height: 506
				},
				{
					name: "Banking – Debt Structure & Combined Financing",
					a1Range: "FW310:GB347",
					sheetId: 697254746,
					height: 825
				},
				{
					name: "Banking – Rental Income Bridge",
					a1Range: "GC348:GV368",
					sheetId: 697254746,
					height: 462
				},
				{
					name: "Banking – Rental Income Bridge (Stabilized)",
					a1Range: "GW369:HP389",
					sheetId: 697254746,
					height: 462
				},
				{
					name: "Banking – Value Bridge (AIC to Net Profit)",
					a1Range: "HQ390:IP411",
					sheetId: 697254746,
					height: 484
				},
				{
					name: "Banking – Portfolio Annual Cash Flow (incl. VAT)",
					a1Range: "IQ412:KC474",
					sheetId: 697254746,
					height: 1386
				},
				{
					name: "Portfolio Asset Overview – Size, Acquisition & Rent Metrics",
					a1Range: "KD475:LN527",
					sheetId: 697254746,
					height: 1100
				},
				{
					name: "Rental Tables – Resi, Commercial & Parking NMI",
					a1Range: "LO528:NZ604",
					sheetId: 697254746,
					height: 1640
				}
			],
			icUrlSheetName: "Config",
			icUrlStartCell: "E3"
		}
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/sheet-embedding/mfh-portfolio-viewer-sheet.helpers.ts
var MFH_PORTFOLIO_DRIVE_NAMES;
var init_mfh_portfolio_viewer_sheet_helpers = __esmMin((() => {
	MFH_PORTFOLIO_DRIVE_NAMES = {
		portfolioViewerTemplate: (version) => `MFH_Portfolio_Viewer_${version}`,
		portfolioViewerSheet: (mfhPortfolio) => `${mfhPortfolio.name ?? `Portfolio ${mfhPortfolio.condoUuid ?? mfhPortfolio.mfhPortfolioId}`} [viewer]`,
		portfolioOutputDir: (mfhPortfolio) => mfhPortfolio.name ?? `Portfolio ${mfhPortfolio.condoUuid ?? mfhPortfolio.mfhPortfolioId}`
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/sheet-embedding/mfh-sheet-embedding-precache.helpers.ts
function buildEmbeddingPrecacheArtifactObjectPathFromHtmlObjectPath(htmlObjectPath, extension) {
	if (htmlObjectPath.endsWith(".html")) return `${htmlObjectPath.slice(0, -5)}.${extension}`;
	return `${htmlObjectPath}.${extension}`;
}
function buildEmbeddingPrecacheArtifactGsUriFromHtmlGsUri(htmlGsUri, extension) {
	const trimmed = htmlGsUri.trim();
	if (!trimmed.startsWith("gs://")) return null;
	const withoutScheme = trimmed.slice(5);
	const slashIndex = withoutScheme.indexOf("/");
	if (slashIndex === -1) return null;
	const bucket = withoutScheme.slice(0, slashIndex);
	const objectPath = withoutScheme.slice(slashIndex + 1);
	if (!objectPath.endsWith(".html")) return null;
	return `gs://${bucket}/${buildEmbeddingPrecacheArtifactObjectPathFromHtmlObjectPath(objectPath, extension)}`;
}
function buildEmbeddingPrecacheArtifactDownloadFilename(htmlGsUri, configName, extension) {
	const objectPathMatch = htmlGsUri.trim().match(/\/([^/]+)\.html$/);
	if (objectPathMatch?.[1]) return `${objectPathMatch[1]}.${extension}`;
	return `${configName.trim().replace(/[^a-zA-Z0-9._-]+/g, "_") || "sheet-embedding"}.${extension}`;
}
function buildEmbeddingPrecachePdfArtifactObjectPathFromHtmlObjectPath(htmlObjectPath) {
	return buildEmbeddingPrecacheArtifactObjectPathFromHtmlObjectPath(htmlObjectPath, "pdf");
}
function buildEmbeddingPrecachePngArtifactObjectPathFromHtmlObjectPath(htmlObjectPath) {
	return buildEmbeddingPrecacheArtifactObjectPathFromHtmlObjectPath(htmlObjectPath, "png");
}
function buildEmbeddingPrecachePdfArtifactGsUriFromHtmlGsUri(htmlGsUri) {
	return buildEmbeddingPrecacheArtifactGsUriFromHtmlGsUri(htmlGsUri, "pdf");
}
function buildEmbeddingPrecachePngArtifactGsUriFromHtmlGsUri(htmlGsUri) {
	return buildEmbeddingPrecacheArtifactGsUriFromHtmlGsUri(htmlGsUri, "png");
}
function buildEmbeddingPrecachePdfArtifactDownloadFilename(htmlGsUri, configName) {
	return buildEmbeddingPrecacheArtifactDownloadFilename(htmlGsUri, configName, "pdf");
}
function buildEmbeddingPrecachePngArtifactDownloadFilename(htmlGsUri, configName) {
	return buildEmbeddingPrecacheArtifactDownloadFilename(htmlGsUri, configName, "png");
}
var init_mfh_sheet_embedding_precache_helpers = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/sheet-embedding/index.ts
var init_sheet_embedding = __esmMin((() => {
	init_mfh_sheet_embedding_model();
	init_mfh_sheet_embedding_opts();
	init_mfh_portfolio_viewer_sheet_opts();
	init_mfh_portfolio_viewer_sheet_helpers();
	init_mfh_sheet_embedding_precache_helpers();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/construction-plan/mfh-construction-plan.model.ts
/** Joins selected section planes into the single string stored in `cuttingPlan` and embedded in the generated name. */
function joinConstructionPlanSectionPlanes(planes) {
	if (!planes.length) return null;
	return planes.join(SECTION_PLANE_JOIN);
}
/** Splits a stored / parsed `cuttingPlan` string back into individual section planes. */
function splitConstructionPlanSectionPlanes(cuttingPlan) {
	if (cuttingPlan == null) return [];
	return cuttingPlan.split(SECTION_PLANE_JOIN).map((p) => p.trim()).filter(Boolean);
}
/** condoUuid uses `_` (e.g. `BY24_5`) which collides with the name token separator, so encode it as `-` inside the asset segment. */
function encodeConstructionPlanAssetUuid(assetUuid) {
	return assetUuid.trim().replace(/_/g, "-");
}
/** Reverse of {@link encodeConstructionPlanAssetUuid}: restores the original condoUuid from a parsed asset segment. */
function decodeConstructionPlanAssetUuid(encoded) {
	return encoded.replace(/-/g, "_");
}
/**
* Builds the asset segment of a generated name: `A{condoUuid}` (underscores encoded as `-`) when a UUID is given,
* otherwise the legacy `A{mfhId}` fallback.
*/
function buildConstructionPlanAssetSegment(mfhId, assetUuid) {
	const uuid = assetUuid?.trim();
	if (uuid) return `A${encodeConstructionPlanAssetUuid(uuid)}`;
	return `A${mfhId}`;
}
/**
* Generates a construction plan name following the convention:
* {UploadDate}_{AssetUUID}_{Bauteil}_{LP}_{Blueprint}_{PlanType}[_{Conditional}][_{Version}]
*
* Conditional value is Geschoss (floor), Schnittebene (cuttingPlan), or
* Format:
* *Rules:*
* UploadDate: Format YYYYMMDD
* AssetUUID: `A` + asset condoUuid (underscores replaced with `-` so the segment stays a single token). Falls back to `A{mfhId}` when no UUID is supplied.
* Bauteil: As selected (e.g., A, B, Alle)
* LeistungsphaseCode: The 3-character prefix (e.g., LP3)
* PlangewerkCode: The 3-character code (e.g., ARC)
* PlanartCode: The 3-character code (e.g., GRU)
* ConditionalValue: Geschoss, Schnittebene, or Ausrichtung — included only if the Planart requires it
* Version: Appended only for V02 and later (V01 is implicit)
* Examples:
* Grundriss with Geschoss, version 2 (condoUuid BY24_5): 20260214_ABY24-5_A_LP3_ARC_GRU_EG1_V02
* Schnitt with Schnittebene, version 1 (no UUID → mfhId fallback): 20260214_A123_B_LP3_ARC_SCH_A-A
* Schnitt, Bauteil "Alle": 20260214_ABY24-5_Alle_LP3_ARC_SCH_A-A
*/
function generateConstructionPlanVersionName(plan, versionNumber, assetUuid) {
	const date = plan.createdAt ? new Date(plan.createdAt) : /* @__PURE__ */ new Date();
	const uploadDate = `${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, "0")}${String(date.getDate()).padStart(2, "0")}`;
	const sortedComponents = plan.components?.toSorted((a, b) => Object.values(MfhConstructionPlanComponents).indexOf(a) - Object.values(MfhConstructionPlanComponents).indexOf(b));
	const parts = [
		uploadDate,
		buildConstructionPlanAssetSegment(plan.mfhId, assetUuid),
		sortedComponents?.join("_"),
		plan.performancePhase,
		plan.blueprint,
		plan.planType
	];
	const conditionalKind = plan.planType ? getConstructionPlanConditionalFieldKind(plan.planType) : null;
	const conditionalValue = conditionalKind === "floor" && plan.floor != null ? formatConstructionPlanFloorToken(plan.floor) : conditionalKind === "cuttingPlan" ? plan.cuttingPlan : conditionalKind === "orientation" ? plan.orientation : null;
	if (!isNil(conditionalValue)) parts.push(conditionalValue.toString());
	if (versionNumber != null && versionNumber > 1) parts.push(`V${String(versionNumber).padStart(2, "0")}`);
	return parts.filter(Boolean).join("_");
}
function formatConstructionPlanFloorToken(floor) {
	if (floor === 0) return "EG1";
	if (floor < 0) return `UG${Math.abs(floor)}`;
	if (floor > 100) return `DG${floor - 100}`;
	return `OG${floor}`;
}
function parseConstructionPlanFloorToken(value) {
	const trimmed = value.trim();
	if (GROUND_FLOOR_TOKEN_PATTERN.exec(trimmed)) return 0;
	const undergroundMatch = UNDERGROUND_FLOOR_TOKEN_PATTERN.exec(trimmed);
	if (undergroundMatch) return -Number(undergroundMatch[1]);
	const upperMatch = UPPER_FLOOR_TOKEN_PATTERN.exec(trimmed);
	if (upperMatch) return Number(upperMatch[1]);
	const roofMatch = ROOF_FLOOR_TOKEN_PATTERN.exec(trimmed);
	if (roofMatch) return 100 + Number(roofMatch[1]);
	return Number(trimmed);
}
/**
* Which conditional field applies for a given plan type (matches {@link resolveConstructionPlanConditionalByPlanType} / name parsing).
* Empty or unknown `planType` returns `null`.
*/
function getConstructionPlanConditionalFieldKind(planType) {
	if (!planType) return null;
	const pt = planType;
	if (SECTION_PLAN_TYPES.has(pt)) return "cuttingPlan";
	if (VIEW_PLAN_TYPES.has(pt)) return "orientation";
	return "floor";
}
/**
* Maps a single conditional value onto `floor`, `cuttingPlan`, or `orientation` according to plan type (same rules as {@link parseConstructionPlanName}).
*/
function resolveConstructionPlanConditionalByPlanType(planType, value) {
	if (SECTION_PLAN_TYPES.has(planType)) return {
		cuttingPlan: value,
		floor: null,
		orientation: null
	};
	if (VIEW_PLAN_TYPES.has(planType)) return {
		orientation: value,
		floor: null,
		cuttingPlan: null
	};
	return {
		floor: parseConstructionPlanFloorToken(value),
		cuttingPlan: null,
		orientation: null
	};
}
/** Sorts Bauteil letters (and `Alle`) in the same order as {@link generateConstructionPlanVersionName}. */
function sortConstructionPlanComponentLettersForName(letters) {
	return [...letters].sort((a, b) => componentOrder.indexOf(a) - componentOrder.indexOf(b));
}
function normalizeConstructionPlanConditionalString(value) {
	if (value == null) return null;
	const trimmed = value.trim();
	return trimmed === "" ? null : trimmed;
}
/** Order-independent equality of `components` arrays (same multiset of Bauteil letters). */
function constructionPlanComponentsEqual(a, b) {
	const byEnumOrder = (x, y) => componentOrder.indexOf(x) - componentOrder.indexOf(y);
	const sa = [...a].sort(byEnumOrder);
	const sb = [...b].sort(byEnumOrder);
	if (sa.length !== sb.length) return false;
	for (let i = 0; i < sa.length; i++) if (sa[i] !== sb[i]) return false;
	return true;
}
/**
* Whether two {@link IMfhConstructionPlan} values match on identity fields: same asset (`mfhId`), building section (`components`),
* service phase, blueprint (trade), plan type, and the conditional segment (floor, cutting plane, or orientation)
* required for that plan type per {@link getConstructionPlanConditionalFieldKind}.
*
* Returns `false` if either side is missing a required identity column (`mfhId`, `components`, `performancePhase`, `blueprint`, `planType`).
* Uses only these structured fields — not {@link generateConstructionPlanVersionName} / `generatedName` / filename parsing.
*/
function areMfhConstructionPlanIdentityCriteriaEqual(a, b) {
	if (a.mfhId == null || b.mfhId == null || a.components == null || b.components == null || a.performancePhase == null || b.performancePhase == null || a.blueprint == null || b.blueprint == null || a.planType == null || b.planType == null) return false;
	if (a.mfhId !== b.mfhId) return false;
	if (a.performancePhase !== b.performancePhase) return false;
	if (a.blueprint !== b.blueprint) return false;
	if (a.planType !== b.planType) return false;
	if (!constructionPlanComponentsEqual(a.components, b.components)) return false;
	const kind = getConstructionPlanConditionalFieldKind(a.planType);
	if (kind === null) return true;
	return (kind === "floor" ? a.floor : kind === "cuttingPlan" ? normalizeConstructionPlanConditionalString(a.cuttingPlan) : normalizeConstructionPlanConditionalString(a.orientation)) === (kind === "floor" ? b.floor : kind === "cuttingPlan" ? normalizeConstructionPlanConditionalString(b.cuttingPlan) : normalizeConstructionPlanConditionalString(b.orientation));
}
/**
* Reverse of {@link generateConstructionPlanVersionName} — parses a generated name back into a partial plan and an optional version string.
* After `planType`, remaining segments are optional `{conditional}` then optional `{version}`; version is only recognized when it is the **final** token
* matching `V` + digits (e.g. `V02`). Anything before that token is joined with `_` as the conditional value.
* Returns `null` if `name` is not a well-formed canonical plan name (wrong shape, unknown enums, or missing required segments).
*/
function parseConstructionPlanName(name) {
	const tokens = name.replace(/\.[^._]+$/, "").trim().split("_").filter(Boolean);
	if (tokens.length < 6) return null;
	let i = 0;
	const dateStr = tokens[i++];
	if (!/^\d{8}$/.test(dateStr)) return null;
	const createdAt = `${dateStr.slice(0, 4)}-${dateStr.slice(4, 6)}-${dateStr.slice(6, 8)}`;
	const assetToken = tokens[i++];
	let mfhId;
	let assetUuid = null;
	if (LEGACY_ASSET_SEGMENT_PATTERN.test(assetToken)) {
		const parsedId = Number(assetToken.slice(1));
		if (!Number.isFinite(parsedId) || parsedId < 0) return null;
		mfhId = parsedId;
	} else if (UUID_ASSET_SEGMENT_PATTERN.test(assetToken)) assetUuid = decodeConstructionPlanAssetUuid(assetToken.slice(1));
	else return null;
	const components = [];
	while (i < tokens.length && componentValues.has(tokens[i]) && !performancePhaseValues.has(tokens[i])) components.push(tokens[i++]);
	const performancePhase = tokens[i++];
	const blueprint = tokens[i++];
	const planType = tokens[i++];
	if (performancePhase == null || blueprint == null || planType == null) return null;
	if (!performancePhaseValues.has(String(performancePhase))) return null;
	if (!blueprintValues.has(String(blueprint))) return null;
	if (!planTypeValues.has(String(planType))) return null;
	const pt = planType;
	const remaining = tokens.slice(i);
	let version = null;
	let conditionalTokens = remaining;
	const last = remaining.at(-1);
	if (last != null && VERSION_PATTERN.test(last)) {
		version = last;
		conditionalTokens = remaining.slice(0, -1);
	}
	const plan = {
		...mfhId != null ? { mfhId } : {},
		components,
		performancePhase,
		blueprint,
		planType: pt,
		createdAt,
		floor: null,
		cuttingPlan: null,
		orientation: null
	};
	if (conditionalTokens.length > 0) {
		const conditionalValue = conditionalTokens.join("_");
		Object.assign(plan, resolveConstructionPlanConditionalByPlanType(pt, conditionalValue));
	}
	return {
		plan,
		version,
		assetUuid
	};
}
var MfhConstructionPlanPerformancePhase, MfhConstructionPlanBluePrint, MfhConstructionPlanType, MfhConstructionPlanScale, MfhConstructionPlanComponents, MfhConstructionPlanOrientation, MfhConstructionPlanSectionPlane, SECTION_PLANE_JOIN, MFH_CONSTRUCTION_PLAN_STRUCTURAL_COMPONENTS, BaseMfhConstructionPlanSchema, LEGACY_ASSET_SEGMENT_PATTERN, UUID_ASSET_SEGMENT_PATTERN, componentValues, performancePhaseValues, blueprintValues, planTypeValues, VERSION_PATTERN, MFH_CONSTRUCTION_PLAN_SECTION_PLAN_TYPES, MFH_CONSTRUCTION_PLAN_VIEW_PLAN_TYPES, SECTION_PLAN_TYPES, VIEW_PLAN_TYPES, UNDERGROUND_FLOOR_TOKEN_PATTERN, GROUND_FLOOR_TOKEN_PATTERN, UPPER_FLOOR_TOKEN_PATTERN, ROOF_FLOOR_TOKEN_PATTERN, componentOrder;
var init_mfh_construction_plan_model = __esmMin((() => {
	init_shared_schemas();
	MfhConstructionPlanPerformancePhase = /* @__PURE__ */ function(MfhConstructionPlanPerformancePhase) {
		MfhConstructionPlanPerformancePhase["LP1"] = "LP1";
		MfhConstructionPlanPerformancePhase["LP2"] = "LP2";
		MfhConstructionPlanPerformancePhase["LP3"] = "LP3";
		MfhConstructionPlanPerformancePhase["LP4"] = "LP4";
		MfhConstructionPlanPerformancePhase["LP5"] = "LP5";
		MfhConstructionPlanPerformancePhase["LP6"] = "LP6";
		MfhConstructionPlanPerformancePhase["LP7"] = "LP7";
		MfhConstructionPlanPerformancePhase["LP8"] = "LP8";
		MfhConstructionPlanPerformancePhase["LP9"] = "LP9";
		return MfhConstructionPlanPerformancePhase;
	}({});
	MfhConstructionPlanBluePrint = /* @__PURE__ */ function(MfhConstructionPlanBluePrint) {
		MfhConstructionPlanBluePrint["VER"] = "VER";
		MfhConstructionPlanBluePrint["ARC"] = "ARC";
		MfhConstructionPlanBluePrint["ENG"] = "ENG";
		MfhConstructionPlanBluePrint["BRS"] = "BRS";
		MfhConstructionPlanBluePrint["BSP"] = "BSP";
		MfhConstructionPlanBluePrint["STK"] = "STK";
		MfhConstructionPlanBluePrint["STP"] = "STP";
		MfhConstructionPlanBluePrint["ELT"] = "ELT";
		MfhConstructionPlanBluePrint["HLS"] = "HLS";
		MfhConstructionPlanBluePrint["BPH"] = "BPH";
		MfhConstructionPlanBluePrint["AAN"] = "AAN";
		MfhConstructionPlanBluePrint["BER"] = "BER";
		MfhConstructionPlanBluePrint["IAR"] = "IAR";
		MfhConstructionPlanBluePrint["KUE"] = "KUE";
		MfhConstructionPlanBluePrint["BAD"] = "BAD";
		MfhConstructionPlanBluePrint["SIG"] = "SIG";
		MfhConstructionPlanBluePrint["SGU"] = "SGU";
		MfhConstructionPlanBluePrint["SFA"] = "SFA";
		MfhConstructionPlanBluePrint["TGA"] = "TGA";
		return MfhConstructionPlanBluePrint;
	}({});
	MfhConstructionPlanType = /* @__PURE__ */ function(MfhConstructionPlanType) {
		MfhConstructionPlanType["GRU"] = "GRU";
		MfhConstructionPlanType["GRA"] = "GRA";
		MfhConstructionPlanType["ANS"] = "ANS";
		MfhConstructionPlanType["ANA"] = "ANA";
		MfhConstructionPlanType["SCH"] = "SCH";
		MfhConstructionPlanType["SCA"] = "SCA";
		MfhConstructionPlanType["LAG"] = "LAG";
		MfhConstructionPlanType["LAA"] = "LAA";
		MfhConstructionPlanType["SCM"] = "SCM";
		MfhConstructionPlanType["DAA"] = "DAA";
		MfhConstructionPlanType["DES"] = "DES";
		MfhConstructionPlanType["DET"] = "DET";
		MfhConstructionPlanType["REN"] = "REN";
		MfhConstructionPlanType["BER"] = "BER";
		MfhConstructionPlanType["RAB"] = "RAB";
		MfhConstructionPlanType["TUL"] = "TUL";
		MfhConstructionPlanType["FEL"] = "FEL";
		MfhConstructionPlanType["BML"] = "BML";
		MfhConstructionPlanType["FLL"] = "FLL";
		MfhConstructionPlanType["SON"] = "SON";
		MfhConstructionPlanType["FUS"] = "FUS";
		MfhConstructionPlanType["STS"] = "STS";
		MfhConstructionPlanType["INP"] = "INP";
		MfhConstructionPlanType["TRP"] = "TRP";
		MfhConstructionPlanType["SDP"] = "SDP";
		MfhConstructionPlanType["KOP"] = "KOP";
		return MfhConstructionPlanType;
	}({});
	MfhConstructionPlanScale = /* @__PURE__ */ function(MfhConstructionPlanScale) {
		MfhConstructionPlanScale["Scale_1_5"] = "1:5";
		MfhConstructionPlanScale["Scale_1_10"] = "1:10";
		MfhConstructionPlanScale["Scale_1_25"] = "1:25";
		MfhConstructionPlanScale["Scale_1_50"] = "1:50";
		MfhConstructionPlanScale["Scale_1_100"] = "1:100";
		MfhConstructionPlanScale["Scale_1_200"] = "1:200";
		return MfhConstructionPlanScale;
	}({});
	MfhConstructionPlanComponents = /* @__PURE__ */ function(MfhConstructionPlanComponents) {
		MfhConstructionPlanComponents["A"] = "A";
		MfhConstructionPlanComponents["B"] = "B";
		MfhConstructionPlanComponents["C"] = "C";
		MfhConstructionPlanComponents["D"] = "D";
		MfhConstructionPlanComponents["E"] = "E";
		MfhConstructionPlanComponents["F"] = "F";
		MfhConstructionPlanComponents["G"] = "G";
		MfhConstructionPlanComponents["H"] = "H";
		MfhConstructionPlanComponents["I"] = "I";
		MfhConstructionPlanComponents["J"] = "J";
		MfhConstructionPlanComponents["Alle"] = "Alle";
		return MfhConstructionPlanComponents;
	}({});
	MfhConstructionPlanOrientation = /* @__PURE__ */ function(MfhConstructionPlanOrientation) {
		MfhConstructionPlanOrientation["N"] = "N";
		MfhConstructionPlanOrientation["NO"] = "NO";
		MfhConstructionPlanOrientation["O"] = "O";
		MfhConstructionPlanOrientation["SO"] = "SO";
		MfhConstructionPlanOrientation["S"] = "S";
		MfhConstructionPlanOrientation["SW"] = "SW";
		MfhConstructionPlanOrientation["W"] = "W";
		MfhConstructionPlanOrientation["NW"] = "NW";
		return MfhConstructionPlanOrientation;
	}({});
	MfhConstructionPlanSectionPlane = /* @__PURE__ */ function(MfhConstructionPlanSectionPlane) {
		MfhConstructionPlanSectionPlane["A_A"] = "A-A";
		MfhConstructionPlanSectionPlane["B_B"] = "B-B";
		MfhConstructionPlanSectionPlane["C_C"] = "C-C";
		MfhConstructionPlanSectionPlane["D_D"] = "D-D";
		MfhConstructionPlanSectionPlane["E_E"] = "E-E";
		MfhConstructionPlanSectionPlane["F_F"] = "F-F";
		MfhConstructionPlanSectionPlane["G_G"] = "G-G";
		MfhConstructionPlanSectionPlane["H_H"] = "H-H";
		MfhConstructionPlanSectionPlane["I_I"] = "I-I";
		MfhConstructionPlanSectionPlane["J_J"] = "J-J";
		MfhConstructionPlanSectionPlane["K_K"] = "K-K";
		MfhConstructionPlanSectionPlane["L_L"] = "L-L";
		MfhConstructionPlanSectionPlane["M_M"] = "M-M";
		MfhConstructionPlanSectionPlane["N_N"] = "N-N";
		MfhConstructionPlanSectionPlane["O_O"] = "O-O";
		MfhConstructionPlanSectionPlane["P_P"] = "P-P";
		MfhConstructionPlanSectionPlane["Q_Q"] = "Q-Q";
		MfhConstructionPlanSectionPlane["R_R"] = "R-R";
		MfhConstructionPlanSectionPlane["S_S"] = "S-S";
		MfhConstructionPlanSectionPlane["T_T"] = "T-T";
		MfhConstructionPlanSectionPlane["U_U"] = "U-U";
		MfhConstructionPlanSectionPlane["V_V"] = "V-V";
		MfhConstructionPlanSectionPlane["W_W"] = "W-W";
		MfhConstructionPlanSectionPlane["X_X"] = "X-X";
		MfhConstructionPlanSectionPlane["Y_Y"] = "Y-Y";
		MfhConstructionPlanSectionPlane["Z_Z"] = "Z-Z";
		return MfhConstructionPlanSectionPlane;
	}({});
	SECTION_PLANE_JOIN = "+";
	MFH_CONSTRUCTION_PLAN_STRUCTURAL_COMPONENTS = Object.values(MfhConstructionPlanComponents).filter((c) => c !== "Alle");
	BaseMfhConstructionPlanSchema = Type.Object({
		mfhConstructionPlanId: Type.Number(),
		mfhId: Type.Number(),
		components: Type.Array(Type.Enum(MfhConstructionPlanComponents)),
		companyId: Type.Number(),
		companyContactId: Type.Number(),
		contractId: TNullable(Type.Number()),
		createdByContactId: Type.Number(),
		description: Type.String(),
		performancePhase: Type.Enum(MfhConstructionPlanPerformancePhase),
		blueprint: Type.Enum(MfhConstructionPlanBluePrint),
		planType: Type.Enum(MfhConstructionPlanType),
		scale: TNullable(Type.Enum(MfhConstructionPlanScale)),
		floor: TNullable(Type.Number()),
		cuttingPlan: TNullable(Type.String()),
		orientation: TNullable(Type.Enum(MfhConstructionPlanOrientation)),
		createdAt: Type.Optional(StringDateSchema),
		updatedAt: Type.Optional(StringDateSchema)
	});
	LEGACY_ASSET_SEGMENT_PATTERN = /^A\d+$/i;
	UUID_ASSET_SEGMENT_PATTERN = /^A(?=[A-Za-z0-9-]*[A-Za-z-])[A-Za-z0-9-]+$/;
	componentValues = new Set(Object.values(MfhConstructionPlanComponents));
	performancePhaseValues = new Set(Object.values(MfhConstructionPlanPerformancePhase));
	blueprintValues = new Set(Object.values(MfhConstructionPlanBluePrint));
	planTypeValues = new Set(Object.values(MfhConstructionPlanType));
	VERSION_PATTERN = /^V\d{2,}$/;
	MFH_CONSTRUCTION_PLAN_SECTION_PLAN_TYPES = [
		"SCH",
		"SCA",
		"SCM"
	];
	MFH_CONSTRUCTION_PLAN_VIEW_PLAN_TYPES = ["ANS", "ANA"];
	SECTION_PLAN_TYPES = new Set(MFH_CONSTRUCTION_PLAN_SECTION_PLAN_TYPES);
	VIEW_PLAN_TYPES = new Set(MFH_CONSTRUCTION_PLAN_VIEW_PLAN_TYPES);
	UNDERGROUND_FLOOR_TOKEN_PATTERN = /^UG\s*(\d+)$/i;
	GROUND_FLOOR_TOKEN_PATTERN = /^EG\s*(\d+)?$/i;
	UPPER_FLOOR_TOKEN_PATTERN = /^OG\s*(\d+)$/i;
	ROOF_FLOOR_TOKEN_PATTERN = /^DG\s*(\d+)$/i;
	componentOrder = Object.values(MfhConstructionPlanComponents);
}));
//#endregion
//#region src/domains/cross-cutting/mfh/construction-plan/mfh-construction-plan.opts.ts
var init_mfh_construction_plan_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/construction-plan/mfh-construction-plan-approval.model.ts
var MfhConstructionPlanApprovalStatus, MfhConstructionPlanApprovalType, BaseMfhConstructionPlanApprovalSchema, MfhConstructionPlanApprovalConfigurationSchema, BaseMfhConstructionPlanApprovalConfigSchema;
var init_mfh_construction_plan_approval_model = __esmMin((() => {
	init_shared_schemas();
	init_mfh_construction_plan_model();
	MfhConstructionPlanApprovalStatus = /* @__PURE__ */ function(MfhConstructionPlanApprovalStatus) {
		MfhConstructionPlanApprovalStatus["Pending"] = "Pending";
		MfhConstructionPlanApprovalStatus["ApprovedWithoutObjections"] = "ApprovedWithoutObjections";
		MfhConstructionPlanApprovalStatus["ApprovedWithObjections"] = "ApprovedWithObjections";
		MfhConstructionPlanApprovalStatus["NotApproved"] = "NotApproved";
		return MfhConstructionPlanApprovalStatus;
	}({});
	MfhConstructionPlanApprovalType = /* @__PURE__ */ function(MfhConstructionPlanApprovalType) {
		MfhConstructionPlanApprovalType["SpecialistPlanner"] = "SpecialistPlanner";
		MfhConstructionPlanApprovalType["GeneralPlanner"] = "GeneralPlanner";
		MfhConstructionPlanApprovalType["ProjectLead"] = "ProjectLead";
		MfhConstructionPlanApprovalType["AssetPartner"] = "AssetPartner";
		return MfhConstructionPlanApprovalType;
	}({});
	BaseMfhConstructionPlanApprovalSchema = Type.Object({
		mfhConstructionPlanApprovalId: Type.Number(),
		mfhConstructionPlanVersionId: Type.Number(),
		approvalType: Type.Enum(MfhConstructionPlanApprovalType),
		approverContactId: Type.Number(),
		status: Type.Enum(MfhConstructionPlanApprovalStatus),
		comment: TNullable(Type.String()),
		createdAt: Type.Optional(StringDateSchema),
		updatedAt: Type.Optional(StringDateSchema)
	});
	MfhConstructionPlanApprovalConfigurationSchema = Type.Record(Type.Enum(MfhConstructionPlanType), Type.Record(Type.Enum(MfhConstructionPlanApprovalType), Type.Array(Type.Number())));
	BaseMfhConstructionPlanApprovalConfigSchema = Type.Object({
		mfhConstructionPlanApprovalConfigId: Type.Number(),
		mfhId: Type.Number(),
		configuration: Type.Any()
	});
}));
//#endregion
//#region src/domains/cross-cutting/mfh/construction-plan/mfh-construction-plan-process.base.ts
var MfhConstructionPlanVersionEvent;
var init_mfh_construction_plan_process_base = __esmMin((() => {
	MfhConstructionPlanVersionEvent = /* @__PURE__ */ function(MfhConstructionPlanVersionEvent) {
		MfhConstructionPlanVersionEvent["Submit"] = "Submit";
		MfhConstructionPlanVersionEvent["ReviewVerdictSet"] = "ReviewVerdictSet";
		/** Auto-archive when a newer version becomes live (superseded). */
		MfhConstructionPlanVersionEvent["Archive"] = "Archive";
		/** Explicit user-initiated archive (distinct terminal status). */
		MfhConstructionPlanVersionEvent["ManuallyArchive"] = "ManuallyArchive";
		return MfhConstructionPlanVersionEvent;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/mfh/construction-plan/mfh-construction-plan-version.model.ts
function isArchivedMfhConstructionPlanVersionStatus(status) {
	return status === "Archived" || status === "ManuallyArchived";
}
var MfhConstructionPlanVersionStatus, MFH_CONSTRUCTION_PLAN_ARCHIVED_STATUSES, BaseMfhConstructionPlanVersionSchema;
var init_mfh_construction_plan_version_model = __esmMin((() => {
	init_shared_schemas();
	MfhConstructionPlanVersionStatus = /* @__PURE__ */ function(MfhConstructionPlanVersionStatus) {
		MfhConstructionPlanVersionStatus["Created"] = "Created";
		MfhConstructionPlanVersionStatus["PendingApprovalSpecialistPlanner"] = "PendingApprovalSpecialistPlanner";
		MfhConstructionPlanVersionStatus["PendingApprovalGeneralPlanner"] = "PendingApprovalGeneralPlanner";
		MfhConstructionPlanVersionStatus["PendingApprovalProjectLead"] = "PendingApprovalProjectLead";
		MfhConstructionPlanVersionStatus["PendingApprovalAssetPartner"] = "PendingApprovalAssetPartner";
		MfhConstructionPlanVersionStatus["Approved"] = "Approved";
		MfhConstructionPlanVersionStatus["ConditionallyApproved"] = "ConditionallyApproved";
		MfhConstructionPlanVersionStatus["Blocked"] = "Blocked";
		MfhConstructionPlanVersionStatus["Archived"] = "Archived";
		MfhConstructionPlanVersionStatus["ManuallyArchived"] = "ManuallyArchived";
		return MfhConstructionPlanVersionStatus;
	}({});
	MFH_CONSTRUCTION_PLAN_ARCHIVED_STATUSES = ["Archived", "ManuallyArchived"];
	BaseMfhConstructionPlanVersionSchema = Type.Object({
		mfhConstructionPlanVersionId: Type.Number(),
		generatedName: Type.String(),
		mfhConstructionPlanId: Type.Number(),
		documentId: TNullable(Type.Number()),
		createdByContactId: Type.Number(),
		status: Type.Enum(MfhConstructionPlanVersionStatus),
		statusBeforeArchive: Type.Optional(TNullable(Type.Enum(MfhConstructionPlanVersionStatus))),
		changeDescription: TNullable(Type.String()),
		isApprovalSkipped: Type.Boolean(),
		liveStartDate: Type.Optional(StringDateSchema),
		liveEndDate: Type.Optional(StringDateSchema),
		createdAt: Type.Optional(StringDateSchema),
		updatedAt: Type.Optional(StringDateSchema)
	});
}));
//#endregion
//#region src/domains/cross-cutting/mfh/construction-plan/mfh-construction-plan.requests.ts
var ConstructionPlanDocumentSchema, FindMfhConstructionPlanListOrderBySchema, FindMfhConstructionPlansQuerySchema, GetMfhConstructionPlanParamsSchema, GetMfhConstructionPlanQuerySchema, CreateMfhConstructionPlanBodySchema, UpdateMfhConstructionPlanParamsSchema, UpdateMfhConstructionPlanBodySchema, CreateMfhConstructionPlanVersionBodySchema, BulkCreateMfhConstructionPlansBodySchema, ProcessVersionEventParamsSchema, ProcessVersionEventBodySchema, ApprovalVerdictParamsSchema, ApprovalVerdictBodySchema, GetApprovalConfigParamsSchema, UpdateApprovalConfigParamsSchema, UpdateApprovalConfigBodySchema, CompareMfhConstructionPlanVersionsParamsSchema, CompareMfhConstructionPlanVersionsBodySchema, ListMfhConstructionPlanComparisonReportsParamsSchema, ListMfhConstructionPlanComparisonReportsQuerySchema;
var init_mfh_construction_plan_requests = __esmMin((() => {
	init_shared_schemas();
	init_mfh_construction_plan_approval_model();
	init_mfh_construction_plan_process_base();
	init_mfh_construction_plan_version_model();
	init_mfh_construction_plan_model();
	ConstructionPlanDocumentSchema = Type.Object({
		filename: Type.String(),
		bucketFilename: Type.String()
	});
	FindMfhConstructionPlanListOrderBySchema = Type.Union([
		Type.Literal("mfhConstructionPlanId"),
		Type.Literal("generatedName"),
		Type.Literal("components"),
		Type.Literal("performancePhase"),
		Type.Literal("blueprint"),
		Type.Literal("floor"),
		Type.Literal("cuttingPlan"),
		Type.Literal("orientation"),
		Type.Literal("scale"),
		Type.Literal("versionIndex"),
		Type.Literal("status"),
		Type.Literal("statusDate"),
		Type.Literal("isLive")
	]);
	FindMfhConstructionPlansQuerySchema = Type.Object({
		mfhId: Type.Number(),
		companyId: Type.Optional(Type.Number()),
		mfhConstructionPlanIds: Type.Optional(Type.Array(Type.Number())),
		page: Type.Optional(Type.Number()),
		size: Type.Optional(Type.Number()),
		expand: Type.Optional(ExpandSchema),
		search: Type.Optional(Type.String()),
		performancePhases: Type.Optional(Type.Array(TEnum(MfhConstructionPlanPerformancePhase))),
		blueprints: Type.Optional(Type.Array(TEnum(MfhConstructionPlanBluePrint))),
		planTypes: Type.Optional(Type.Array(TEnum(MfhConstructionPlanType))),
		scales: Type.Optional(Type.Array(TEnum(MfhConstructionPlanScale))),
		statuses: Type.Optional(Type.Array(TEnum(MfhConstructionPlanVersionStatus))),
		components: Type.Optional(Type.Array(Type.String())),
		floors: Type.Optional(Type.Array(Type.Number())),
		cuttingPlan: Type.Optional(Type.String()),
		orientation: Type.Optional(Type.String()),
		liveOnly: Type.Optional(Type.Boolean()),
		orderBy: Type.Optional(FindMfhConstructionPlanListOrderBySchema),
		order: Type.Optional(TStringEnum(["ASC", "DESC"]))
	});
	GetMfhConstructionPlanParamsSchema = Type.Object({ mfhConstructionPlanId: Type.Number() });
	GetMfhConstructionPlanQuerySchema = Type.Object({ expand: Type.Optional(ExpandSchema) });
	CreateMfhConstructionPlanBodySchema = Type.Object({
		mfhId: Type.Number(),
		companyId: Type.Number(),
		companyContactId: Type.Number(),
		contractId: Type.Optional(Type.Number()),
		description: Type.String(),
		performancePhase: TEnum(MfhConstructionPlanPerformancePhase),
		blueprint: TEnum(MfhConstructionPlanBluePrint),
		planType: TEnum(MfhConstructionPlanType),
		scale: Type.Optional(TEnum(MfhConstructionPlanScale)),
		floor: Type.Optional(Type.Number()),
		cuttingPlan: Type.Optional(Type.String()),
		orientation: Type.Optional(TEnum(MfhConstructionPlanOrientation)),
		components: Type.Array(TEnum(MfhConstructionPlanComponents)),
		initialVersion: Type.Object({
			document: ConstructionPlanDocumentSchema,
			isApprovalSkipped: Type.Optional(Type.Boolean())
		})
	});
	UpdateMfhConstructionPlanParamsSchema = Type.Object({ mfhConstructionPlanId: Type.Number() });
	UpdateMfhConstructionPlanBodySchema = Type.Object({
		companyId: Type.Optional(Type.Number()),
		companyContactId: Type.Optional(Type.Number()),
		contractId: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
		description: Type.Optional(Type.String()),
		performancePhase: Type.Optional(TEnum(MfhConstructionPlanPerformancePhase)),
		blueprint: Type.Optional(TEnum(MfhConstructionPlanBluePrint)),
		planType: Type.Optional(TEnum(MfhConstructionPlanType)),
		scale: Type.Optional(Type.Union([TEnum(MfhConstructionPlanScale), Type.Null()])),
		floor: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
		cuttingPlan: Type.Optional(Type.Union([Type.String(), Type.Null()])),
		orientation: Type.Optional(Type.Union([TEnum(MfhConstructionPlanOrientation), Type.Null()])),
		components: Type.Optional(Type.Array(TEnum(MfhConstructionPlanComponents)))
	});
	CreateMfhConstructionPlanVersionBodySchema = Type.Object({
		mfhConstructionPlanId: Type.Number(),
		document: ConstructionPlanDocumentSchema,
		changeDescription: Type.Optional(Type.String()),
		isApprovalSkipped: Type.Optional(Type.Boolean())
	});
	BulkCreateMfhConstructionPlansBodySchema = Type.Object({
		plans: Type.Array(CreateMfhConstructionPlanBodySchema),
		versions: Type.Array(CreateMfhConstructionPlanVersionBodySchema)
	});
	ProcessVersionEventParamsSchema = Type.Object({ mfhConstructionPlanVersionId: Type.Number() });
	ProcessVersionEventBodySchema = Type.Object({
		event: TEnum(MfhConstructionPlanVersionEvent),
		data: Type.Optional(Type.Record(Type.String(), Type.Unknown()))
	});
	ApprovalVerdictParamsSchema = Type.Object({ mfhConstructionPlanApprovalId: Type.Number() });
	ApprovalVerdictBodySchema = Type.Object({
		status: TEnum(MfhConstructionPlanApprovalStatus, { description: "One of: ApprovedWithoutObjections, ApprovedWithObjections, NotApproved" }),
		comment: Type.Optional(Type.String())
	});
	GetApprovalConfigParamsSchema = Type.Object({ mfhId: Type.Number() });
	UpdateApprovalConfigParamsSchema = Type.Object({ mfhId: Type.Number() });
	UpdateApprovalConfigBodySchema = Type.Object({ configuration: MfhConstructionPlanApprovalConfigurationSchema });
	CompareMfhConstructionPlanVersionsParamsSchema = Type.Object({ mfhConstructionPlanId: Type.Number() });
	CompareMfhConstructionPlanVersionsBodySchema = Type.Object({
		sourceMfhConstructionPlanVersionId: Type.Number(),
		targetMfhConstructionPlanVersionId: Type.Number()
	});
	ListMfhConstructionPlanComparisonReportsParamsSchema = Type.Object({ mfhConstructionPlanId: Type.Number() });
	ListMfhConstructionPlanComparisonReportsQuerySchema = Type.Object({
		sourceMfhConstructionPlanVersionId: Type.Number(),
		targetMfhConstructionPlanVersionId: Type.Number()
	});
}));
//#endregion
//#region src/domains/cross-cutting/mfh/construction-plan/mfh-construction-plan-version.opts.ts
var init_mfh_construction_plan_version_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/construction-plan/mfh-construction-plan-approval.opts.ts
var init_mfh_construction_plan_approval_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/construction-plan/mfh-construction-plan-approval-workflow.ts
/** Which approval role is currently actionable for the version workflow (strict sequence). */
function getMfhConstructionPlanActiveApprovalType(status) {
	switch (status) {
		case "PendingApprovalSpecialistPlanner": return "SpecialistPlanner";
		case "PendingApprovalGeneralPlanner": return "GeneralPlanner";
		case "PendingApprovalProjectLead": return "ProjectLead";
		case "PendingApprovalAssetPartner": return "AssetPartner";
		default: return null;
	}
}
var init_mfh_construction_plan_approval_workflow = __esmMin((() => {
	init_mfh_construction_plan_approval_model();
	init_mfh_construction_plan_version_model();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/construction-plan/mfh-construction-plan-comparison-report.model.ts
function isMfhConstructionPlanChangeCategory(value) {
	return typeof value === "string" && MFH_CONSTRUCTION_PLAN_CHANGE_CATEGORY_SET.has(value);
}
var MfhConstructionPlanChangeCategory, MFH_CONSTRUCTION_PLAN_CHANGE_CATEGORY_SET;
var init_mfh_construction_plan_comparison_report_model = __esmMin((() => {
	MfhConstructionPlanChangeCategory = /* @__PURE__ */ function(MfhConstructionPlanChangeCategory) {
		MfhConstructionPlanChangeCategory["Structural"] = "structural";
		MfhConstructionPlanChangeCategory["Dimensional"] = "dimensional";
		MfhConstructionPlanChangeCategory["Annotation"] = "annotation";
		MfhConstructionPlanChangeCategory["TechnicalSystems"] = "technical_systems";
		MfhConstructionPlanChangeCategory["Materials"] = "materials";
		MfhConstructionPlanChangeCategory["TitleBlock"] = "title_block";
		MfhConstructionPlanChangeCategory["Legend"] = "legend";
		MfhConstructionPlanChangeCategory["Graphical"] = "graphical";
		MfhConstructionPlanChangeCategory["Addition"] = "addition";
		MfhConstructionPlanChangeCategory["Removal"] = "removal";
		MfhConstructionPlanChangeCategory["Relocation"] = "relocation";
		return MfhConstructionPlanChangeCategory;
	}({});
	MFH_CONSTRUCTION_PLAN_CHANGE_CATEGORY_SET = new Set(Object.values(MfhConstructionPlanChangeCategory));
}));
//#endregion
//#region src/domains/cross-cutting/mfh/construction-plan/index.ts
var init_construction_plan = __esmMin((() => {
	init_mfh_construction_plan_model();
	init_mfh_construction_plan_opts();
	init_mfh_construction_plan_requests();
	init_mfh_construction_plan_version_model();
	init_mfh_construction_plan_version_opts();
	init_mfh_construction_plan_approval_model();
	init_mfh_construction_plan_approval_opts();
	init_mfh_construction_plan_approval_workflow();
	init_mfh_construction_plan_process_base();
	init_mfh_construction_plan_comparison_report_model();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/subsidies/subsidy-result.model.ts
var SubsidyProgramCode, SubsidyFundingType, SubsidyEligibilityStatus, SubsidyRuleOutcome, SubsidyRuleReasonCode, SubsidyEligibilityRuleCode, SubsidyRuleValueUnit, SubsidyRuleValueSchema, SubsidyRuleReasonSchema, SubsidyRuleOutcomeSchema, SubsidyEfficiencyHouseStage, SubsidyEfficiencyHouseTrack, IfbModernisationStage, IfbModernisationStageCriterion, Kfw261SubsidyVariantSchema, BafaBegEmSubsidyVariantSchema, Kfw459SubsidyVariantSchema, Kfw359SubsidyVariantSchema, IfbModernisierungASubsidyVariantSchema, FkgMunichModule, FkgMunichSubsidyVariantSchema, SubsidyVariantSchema, DirectGrantComponentCode, DirectGrantComponentSchema, DirectGrantBenefitSchema, LoanWithRepaymentGrantBenefitSchema, SubsidyVariantAssessmentStatus, FkgMunichEligibleCostSource, Kfw261CalculationBreakdownSchema, Kfw359CalculationBreakdownSchema, BafaBegEmCalculationBreakdownSchema, Kfw459CalculationBreakdownSchema, FkgMunichCalculationBreakdownSchema, IfbModernisierungACalculationBreakdownSchema, SubsidyCalculationBreakdownSchema, SubsidyEfficiencyHouseStageAssessmentSchema, InterestRateAdvantageBenefitSchema, SubsidyBenefitSchema, BafaBegEmVariantAssessmentSchema, Kfw359VariantAssessmentSchema, IfbModernisationStageAssessmentSchema, FkgMunichModuleAssessmentSchema, SubsidyVariantAssessmentSchema, SubsidyConsideredMeasureSchema, SubsidyWarningCode, SubsidyMissingInputCode, SubsidyProgramResultSchema, MatchedSubsidyProgramSchema;
var init_subsidy_result_model = __esmMin((() => {
	SubsidyProgramCode = /* @__PURE__ */ function(SubsidyProgramCode) {
		SubsidyProgramCode["KFW_261"] = "KFW_261";
		SubsidyProgramCode["BAFA_BEG_EM"] = "BAFA_BEG_EM";
		SubsidyProgramCode["KFW_459"] = "KFW_459";
		SubsidyProgramCode["KFW_359"] = "KFW_359";
		SubsidyProgramCode["IFB_MODERNISIERUNG_A"] = "IFB_MODERNISIERUNG_A";
		SubsidyProgramCode["FKG_MUNICH"] = "FKG_MUNICH";
		return SubsidyProgramCode;
	}({});
	SubsidyFundingType = /* @__PURE__ */ function(SubsidyFundingType) {
		SubsidyFundingType["DirectGrant"] = "direct_grant";
		SubsidyFundingType["LoanWithRepaymentGrant"] = "loan_with_repayment_grant";
		SubsidyFundingType["InterestRateAdvantage"] = "interest_rate_advantage";
		return SubsidyFundingType;
	}({});
	SubsidyEligibilityStatus = /* @__PURE__ */ function(SubsidyEligibilityStatus) {
		SubsidyEligibilityStatus["Eligible"] = "eligible";
		SubsidyEligibilityStatus["Ineligible"] = "ineligible";
		SubsidyEligibilityStatus["Indeterminate"] = "indeterminate";
		return SubsidyEligibilityStatus;
	}({});
	SubsidyRuleOutcome = /* @__PURE__ */ function(SubsidyRuleOutcome) {
		SubsidyRuleOutcome["Passed"] = "passed";
		SubsidyRuleOutcome["Failed"] = "failed";
		SubsidyRuleOutcome["Indeterminate"] = "indeterminate";
		return SubsidyRuleOutcome;
	}({});
	SubsidyRuleReasonCode = /* @__PURE__ */ function(SubsidyRuleReasonCode) {
		SubsidyRuleReasonCode["EfficiencyHouseStageNotReached"] = "efficiency_house_stage_not_reached";
		SubsidyRuleReasonCode["EfficiencyHouseStageInputsMissing"] = "efficiency_house_stage_inputs_missing";
		SubsidyRuleReasonCode["EfficiencyHouseStageReached"] = "efficiency_house_stage_reached";
		SubsidyRuleReasonCode["RenewableEnergyClassReached"] = "renewable_energy_class_reached";
		SubsidyRuleReasonCode["RenewableEnergyClassNotReached"] = "renewable_energy_class_not_reached";
		SubsidyRuleReasonCode["WorstPerformanceBuildingBonusDoesNotApply"] = "worst_performance_building_bonus_does_not_apply";
		SubsidyRuleReasonCode["WorstPerformanceBuildingBonusIndeterminate"] = "worst_performance_building_bonus_indeterminate";
		SubsidyRuleReasonCode["WorstPerformanceBuildingBonusApplies"] = "worst_performance_building_bonus_applies";
		SubsidyRuleReasonCode["SerialRenovationBonusDoesNotApply"] = "serial_renovation_bonus_does_not_apply";
		SubsidyRuleReasonCode["SerialRenovationBonusApplies"] = "serial_renovation_bonus_applies";
		SubsidyRuleReasonCode["MonumentProtectionRequired"] = "monument_protection_required";
		SubsidyRuleReasonCode["MonumentProtectionMissing"] = "monument_protection_missing";
		SubsidyRuleReasonCode["EligibleIndividualMeasureSelected"] = "eligible_individual_measure_selected";
		SubsidyRuleReasonCode["NoEligibleIndividualMeasureSelected"] = "no_eligible_individual_measure_selected";
		SubsidyRuleReasonCode["NoMeasureMeetsTechnicalRequirements"] = "no_measure_meets_technical_requirements";
		SubsidyRuleReasonCode["AtLeastOneMeasureMeetsTechnicalRequirements"] = "at_least_one_measure_meets_technical_requirements";
		SubsidyRuleReasonCode["MeasureTechnicalRequirementsIndeterminate"] = "measure_technical_requirements_indeterminate";
		SubsidyRuleReasonCode["NoHeatingReplacementSelected"] = "no_heating_replacement_selected";
		SubsidyRuleReasonCode["EligibleHeatingSystemSelected"] = "eligible_heating_system_selected";
		SubsidyRuleReasonCode["UnsupportedHeatingSystemSelected"] = "unsupported_heating_system_selected";
		SubsidyRuleReasonCode["EligibleUnderlyingProgramExists"] = "eligible_underlying_program_exists";
		SubsidyRuleReasonCode["UnderlyingProgramsIneligible"] = "underlying_programs_ineligible";
		SubsidyRuleReasonCode["UnderlyingProgramsIndeterminate"] = "underlying_programs_indeterminate";
		SubsidyRuleReasonCode["NotLocatedInHamburg"] = "not_located_in_hamburg";
		SubsidyRuleReasonCode["CityMissing"] = "city_missing";
		SubsidyRuleReasonCode["LocatedInHamburg"] = "located_in_hamburg";
		SubsidyRuleReasonCode["NotLocatedInMunich"] = "not_located_in_munich";
		SubsidyRuleReasonCode["LocatedInMunich"] = "located_in_munich";
		SubsidyRuleReasonCode["MinimumSavingsNotReached"] = "minimum_savings_not_reached";
		SubsidyRuleReasonCode["SavingsInputsMissing"] = "savings_inputs_missing";
		SubsidyRuleReasonCode["MinimumSavingsReached"] = "minimum_savings_reached";
		SubsidyRuleReasonCode["IfbStageNotReached"] = "ifb_stage_not_reached";
		SubsidyRuleReasonCode["IfbStageInputsMissing"] = "ifb_stage_inputs_missing";
		SubsidyRuleReasonCode["IfbStageReached"] = "ifb_stage_reached";
		SubsidyRuleReasonCode["EligibleFederalProgramExists"] = "eligible_federal_program_exists";
		SubsidyRuleReasonCode["FederalProgramsIneligible"] = "federal_programs_ineligible";
		SubsidyRuleReasonCode["FederalProgramsIndeterminate"] = "federal_programs_indeterminate";
		SubsidyRuleReasonCode["EfficiencyHouseStageBelowMinimum"] = "efficiency_house_stage_below_minimum";
		SubsidyRuleReasonCode["PreRenovationEnergyClassEligible"] = "pre_renovation_energy_class_eligible";
		SubsidyRuleReasonCode["PreRenovationEnergyClassIneligible"] = "pre_renovation_energy_class_ineligible";
		SubsidyRuleReasonCode["PreRenovationEnergyClassInputsMissing"] = "pre_renovation_energy_class_inputs_missing";
		return SubsidyRuleReasonCode;
	}({});
	SubsidyEligibilityRuleCode = /* @__PURE__ */ function(SubsidyEligibilityRuleCode) {
		SubsidyEligibilityRuleCode["Kfw261EfficiencyHouseStage"] = "E261-1";
		SubsidyEligibilityRuleCode["Kfw261RenewableEnergyClass"] = "E261-2";
		SubsidyEligibilityRuleCode["Kfw261RenewableEnergyClassEe"] = "E261-2-EE";
		SubsidyEligibilityRuleCode["Kfw261RenewableEnergyClassNh"] = "E261-2-NH";
		SubsidyEligibilityRuleCode["Kfw261WorstPerformanceBuilding"] = "E261-3";
		SubsidyEligibilityRuleCode["Kfw261SerialRenovation"] = "E261-3-SERSAN";
		SubsidyEligibilityRuleCode["BafaEligibleMeasure"] = "EEM-1";
		SubsidyEligibilityRuleCode["BafaTechnicalMinimumRequirement"] = "EEM-2";
		SubsidyEligibilityRuleCode["Kfw459EligibleHeatingSystem"] = "EHZ-1";
		SubsidyEligibilityRuleCode["Kfw359UnderlyingProgram"] = "E359-1";
		SubsidyEligibilityRuleCode["IfbModernisationLocation"] = "EIFB-1";
		SubsidyEligibilityRuleCode["IfbModernisationMinimumSavings"] = "EIFB-2";
		SubsidyEligibilityRuleCode["IfbModernisationStage"] = "EIFB-3";
		SubsidyEligibilityRuleCode["FkgMunichLocation"] = "EFKG-1";
		SubsidyEligibilityRuleCode["FkgMunichEligibleFederalProgram"] = "EFKG-2";
		SubsidyEligibilityRuleCode["FkgMunichMinimumEfficiencyHouseStage"] = "EFKG-3";
		SubsidyEligibilityRuleCode["FkgMunichPreRenovationEnergyClass"] = "EFKG-4";
		return SubsidyEligibilityRuleCode;
	}({});
	SubsidyRuleValueUnit = /* @__PURE__ */ function(SubsidyRuleValueUnit) {
		SubsidyRuleValueUnit["Boolean"] = "boolean";
		SubsidyRuleValueUnit["Count"] = "count";
		SubsidyRuleValueUnit["Euro"] = "euro";
		SubsidyRuleValueUnit["EuroPerSquareMeter"] = "euro_per_square_meter";
		SubsidyRuleValueUnit["KilowattHourPerSquareMeterYear"] = "kilowatt_hour_per_square_meter_year";
		SubsidyRuleValueUnit["Percent"] = "percent";
		SubsidyRuleValueUnit["SquareMeter"] = "square_meter";
		SubsidyRuleValueUnit["WattPerSquareMeterKelvin"] = "watt_per_square_meter_kelvin";
		SubsidyRuleValueUnit["Year"] = "year";
		return SubsidyRuleValueUnit;
	}({});
	SubsidyRuleValueSchema = Type.Object({
		key: Type.String(),
		value: Type.Union([
			Type.Number(),
			Type.Boolean(),
			Type.String(),
			Type.Null()
		]),
		unit: Type.Optional(Type.Enum(SubsidyRuleValueUnit))
	});
	SubsidyRuleReasonSchema = Type.Object({
		code: Type.Enum(SubsidyRuleReasonCode),
		parameters: Type.Array(SubsidyRuleValueSchema)
	});
	SubsidyRuleOutcomeSchema = Type.Object({
		ruleCode: Type.Enum(SubsidyEligibilityRuleCode),
		blocking: Type.Boolean(),
		outcome: Type.Enum(SubsidyRuleOutcome),
		observedValues: Type.Array(SubsidyRuleValueSchema),
		comparedConfigValues: Type.Array(SubsidyRuleValueSchema),
		reason: SubsidyRuleReasonSchema
	});
	SubsidyEfficiencyHouseStage = /* @__PURE__ */ function(SubsidyEfficiencyHouseStage) {
		SubsidyEfficiencyHouseStage["EfficiencyHouse40"] = "EFFICIENCY_HOUSE_40";
		SubsidyEfficiencyHouseStage["EfficiencyHouse55"] = "EFFICIENCY_HOUSE_55";
		SubsidyEfficiencyHouseStage["EfficiencyHouse70"] = "EFFICIENCY_HOUSE_70";
		SubsidyEfficiencyHouseStage["EfficiencyHouse85"] = "EFFICIENCY_HOUSE_85";
		SubsidyEfficiencyHouseStage["Monument"] = "EFFICIENCY_HOUSE_MONUMENT";
		return SubsidyEfficiencyHouseStage;
	}({});
	SubsidyEfficiencyHouseTrack = /* @__PURE__ */ function(SubsidyEfficiencyHouseTrack) {
		SubsidyEfficiencyHouseTrack["EnergyEfficiency"] = "EE";
		SubsidyEfficiencyHouseTrack["Sustainability"] = "NH";
		return SubsidyEfficiencyHouseTrack;
	}({});
	IfbModernisationStage = /* @__PURE__ */ function(IfbModernisationStage) {
		IfbModernisationStage["Stage1"] = "IFB_STAGE_1";
		IfbModernisationStage["Stage2"] = "IFB_STAGE_2";
		IfbModernisationStage["Stage3"] = "IFB_STAGE_3";
		IfbModernisationStage["Stage4"] = "IFB_STAGE_4";
		IfbModernisationStage["Stage5"] = "IFB_STAGE_5";
		return IfbModernisationStage;
	}({});
	IfbModernisationStageCriterion = /* @__PURE__ */ function(IfbModernisationStageCriterion) {
		IfbModernisationStageCriterion["FinalEnergyDemand"] = "FINAL_ENERGY_DEMAND";
		IfbModernisationStageCriterion["EfficiencyHouseStage"] = "EFFICIENCY_HOUSE_STAGE";
		return IfbModernisationStageCriterion;
	}({});
	Kfw261SubsidyVariantSchema = Type.Object({
		programCode: Type.Literal("KFW_261"),
		efficiencyHouseStage: Type.Enum(SubsidyEfficiencyHouseStage),
		track: Type.Enum(SubsidyEfficiencyHouseTrack),
		hasRenewableEnergyClass: Type.Union([Type.Boolean(), Type.Null()]),
		hasWorstPerformanceBuildingBonus: Type.Union([Type.Boolean(), Type.Null()]),
		hasSerialRenovationBonus: Type.Union([Type.Boolean(), Type.Null()])
	});
	BafaBegEmSubsidyVariantSchema = Type.Object({
		programCode: Type.Literal("BAFA_BEG_EM"),
		hasIndividualRenovationRoadmap: Type.Boolean()
	});
	Kfw459SubsidyVariantSchema = Type.Object({
		programCode: Type.Literal("KFW_459"),
		isBaseHeatingGrant: Type.Literal(true)
	});
	Kfw359SubsidyVariantSchema = Type.Object({
		programCode: Type.Literal("KFW_359"),
		isStandardRateLoan: Type.Literal(true),
		underlyingProgramCode: Type.Union([Type.Literal("BAFA_BEG_EM"), Type.Literal("KFW_459")])
	});
	IfbModernisierungASubsidyVariantSchema = Type.Object({
		programCode: Type.Literal("IFB_MODERNISIERUNG_A"),
		stage: Type.Enum(IfbModernisationStage)
	});
	FkgMunichModule = /* @__PURE__ */ function(FkgMunichModule) {
		FkgMunichModule["EfficiencyHouseExisting"] = "EFFICIENCY_HOUSE_EXISTING";
		FkgMunichModule["IndividualMeasures"] = "INDIVIDUAL_MEASURES";
		FkgMunichModule["HeatingReplacement"] = "HEATING_REPLACEMENT";
		return FkgMunichModule;
	}({});
	FkgMunichSubsidyVariantSchema = Type.Object({
		programCode: Type.Literal("FKG_MUNICH"),
		module: Type.Enum(FkgMunichModule)
	});
	SubsidyVariantSchema = Type.Union([
		Kfw261SubsidyVariantSchema,
		BafaBegEmSubsidyVariantSchema,
		Kfw459SubsidyVariantSchema,
		Kfw359SubsidyVariantSchema,
		IfbModernisierungASubsidyVariantSchema,
		FkgMunichSubsidyVariantSchema
	]);
	DirectGrantComponentCode = /* @__PURE__ */ function(DirectGrantComponentCode) {
		DirectGrantComponentCode["MainGrant"] = "main_grant";
		DirectGrantComponentCode["PlanningAndSupervision"] = "planning_and_supervision";
		DirectGrantComponentCode["QualityAssurance"] = "quality_assurance";
		DirectGrantComponentCode["BrickFacade"] = "brick_facade";
		return DirectGrantComponentCode;
	}({});
	DirectGrantComponentSchema = Type.Object({
		code: Type.Enum(DirectGrantComponentCode),
		amount: Type.Number({ minimum: 0 })
	});
	DirectGrantBenefitSchema = Type.Object({
		type: Type.Literal("direct_grant"),
		eligibleCosts: Type.Number({ minimum: 0 }),
		grantRate: Type.Union([Type.Number({ minimum: 0 }), Type.Null()]),
		totalGrant: Type.Number({ minimum: 0 }),
		components: Type.Array(DirectGrantComponentSchema)
	});
	LoanWithRepaymentGrantBenefitSchema = Type.Object({
		type: Type.Literal("loan_with_repayment_grant"),
		eligibleCosts: Type.Number({ minimum: 0 }),
		cappedEligibleCosts: Type.Number({ minimum: 0 }),
		mainLoanAmount: Type.Number({ minimum: 0 }),
		supervisionLoanAmount: Type.Number({ minimum: 0 }),
		certificationLoanAmount: Type.Number({ minimum: 0 }),
		loanAmount: Type.Number({ minimum: 0 }),
		repaymentGrantRate: Type.Number({ minimum: 0 }),
		mainRepaymentGrant: Type.Number({ minimum: 0 }),
		supervisionRepaymentGrantRate: Type.Number({ minimum: 0 }),
		supervisionRepaymentGrant: Type.Number({ minimum: 0 }),
		certificationRepaymentGrant: Type.Number({ minimum: 0 }),
		totalRepaymentGrant: Type.Number({ minimum: 0 }),
		/**
		* Annual interest advantage using KfW 359 screening/subsidized rates when supplied.
		* Present on KfW 261 so one benefit contributes to both cash and interest hero buckets.
		*/
		annualInterestAdvantage: Type.Number({ minimum: 0 }),
		subsidizedInterestRate: Type.Union([Type.Number({ minimum: 0 }), Type.Null()]),
		bankInterestRate: Type.Union([Type.Number({ minimum: 0 }), Type.Null()])
	});
	SubsidyVariantAssessmentStatus = /* @__PURE__ */ function(SubsidyVariantAssessmentStatus) {
		SubsidyVariantAssessmentStatus["Achieved"] = "achieved";
		SubsidyVariantAssessmentStatus["NotAchieved"] = "not_achieved";
		SubsidyVariantAssessmentStatus["Indeterminate"] = "indeterminate";
		SubsidyVariantAssessmentStatus["Disabled"] = "disabled";
		return SubsidyVariantAssessmentStatus;
	}({});
	FkgMunichEligibleCostSource = /* @__PURE__ */ function(FkgMunichEligibleCostSource) {
		FkgMunichEligibleCostSource["FederalProgram"] = "federal_program";
		FkgMunichEligibleCostSource["ScenarioEnergeticCapex"] = "scenario_energetic_capex";
		return FkgMunichEligibleCostSource;
	}({});
	Kfw261CalculationBreakdownSchema = Type.Object({
		programCode: Type.Literal("KFW_261"),
		energeticCapexBase: Type.Number({ minimum: 0 }),
		energeticEligibleShare: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		expansionCapexBase: Type.Number({ minimum: 0 }),
		expansionEligibleShare: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		loanCeiling: Type.Number({ minimum: 0 }),
		baseRepaymentGrantRate: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		worstPerformanceBuildingBonusRate: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		serialRenovationBonusRate: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		maximumRepaymentGrantRate: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		supervisionEligibleCosts: Type.Number({ minimum: 0 }),
		supervisionLoanCeiling: Type.Number({ minimum: 0 }),
		certificationCost: Type.Number({ minimum: 0 }),
		certificationLoanCeiling: Type.Number({ minimum: 0 })
	});
	Kfw359CalculationBreakdownSchema = Type.Object({
		programCode: Type.Literal("KFW_359"),
		underlyingProgramCode: Type.Union([Type.Literal("BAFA_BEG_EM"), Type.Literal("KFW_459")]),
		loanCeiling: Type.Number({ minimum: 0 })
	});
	BafaBegEmCalculationBreakdownSchema = Type.Object({
		programCode: Type.Literal("BAFA_BEG_EM"),
		uncappedEligibleMeasureCosts: Type.Number({ minimum: 0 }),
		annualCostCeiling: Type.Number({ minimum: 0 }),
		minimumInvestmentVolume: Type.Number({ minimum: 0 }),
		baseGrantRate: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		individualRenovationRoadmapBonusRate: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		planningCosts: Type.Number({ minimum: 0 }),
		planningEligibleCostCap: Type.Number({ minimum: 0 }),
		planningAndSupervisionGrantRate: Type.Number({
			minimum: 0,
			maximum: 1
		})
	});
	Kfw459CalculationBreakdownSchema = Type.Object({
		programCode: Type.Literal("KFW_459"),
		heatingSystemCosts: Type.Number({ minimum: 0 }),
		costCeiling: Type.Number({ minimum: 0 })
	});
	FkgMunichCalculationBreakdownSchema = Type.Object({
		programCode: Type.Literal("FKG_MUNICH"),
		module: Type.Enum(FkgMunichModule),
		federalProgramCode: Type.Union([
			Type.Literal("KFW_261"),
			Type.Literal("BAFA_BEG_EM"),
			Type.Literal("KFW_459"),
			Type.Null()
		]),
		eligibleCostSource: Type.Enum(FkgMunichEligibleCostSource),
		federalEligibleCosts: Type.Number({ minimum: 0 }),
		baseGrantRate: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		energyClassBonusRate: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		multiUnitBonusRate: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		grantUncapped: Type.Number({ minimum: 0 }),
		federalFundingCapApplied: Type.Boolean()
	});
	IfbModernisierungACalculationBreakdownSchema = Type.Object({
		programCode: Type.Literal("IFB_MODERNISIERUNG_A"),
		mainGrant: Type.Number({ minimum: 0 }),
		supplementaryGrant: Type.Number({ minimum: 0 })
	});
	SubsidyCalculationBreakdownSchema = Type.Union([
		Kfw261CalculationBreakdownSchema,
		Kfw359CalculationBreakdownSchema,
		BafaBegEmCalculationBreakdownSchema,
		Kfw459CalculationBreakdownSchema,
		FkgMunichCalculationBreakdownSchema,
		IfbModernisierungACalculationBreakdownSchema
	]);
	SubsidyEfficiencyHouseStageAssessmentSchema = Type.Object({
		programCode: Type.Literal("KFW_261"),
		stage: Type.Enum(SubsidyEfficiencyHouseStage),
		track: Type.Enum(SubsidyEfficiencyHouseTrack),
		status: Type.Enum(SubsidyVariantAssessmentStatus),
		eligibilityStatus: Type.Enum(SubsidyEligibilityStatus),
		isEnabled: Type.Boolean(),
		primaryEnergyDemandPercentOfReference: Type.Union([Type.Number({ minimum: 0 }), Type.Null()]),
		maximumPrimaryEnergyDemandPercentOfReference: Type.Number({ minimum: 0 }),
		primaryEnergyDemandGapToThreshold: Type.Union([Type.Number({ minimum: 0 }), Type.Null()]),
		transmissionHeatLossPercentOfReference: Type.Union([Type.Number({ minimum: 0 }), Type.Null()]),
		maximumTransmissionHeatLossPercentOfReference: Type.Union([Type.Number({ minimum: 0 }), Type.Null()]),
		transmissionHeatLossGapToThreshold: Type.Union([Type.Number({ minimum: 0 }), Type.Null()]),
		baseRepaymentGrantRate: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		worstPerformanceBuildingBonusRate: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		serialRenovationBonusRate: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		totalRepaymentGrantRate: Type.Union([Type.Number({
			minimum: 0,
			maximum: 1
		}), Type.Null()]),
		hasRenewableEnergyClass: Type.Boolean(),
		hasWorstPerformanceBuildingBonus: Type.Union([Type.Boolean(), Type.Null()]),
		hasSerialRenovationBonus: Type.Union([Type.Boolean(), Type.Null()]),
		potentialBenefit: Type.Union([LoanWithRepaymentGrantBenefitSchema, Type.Null()]),
		potentialBreakdown: Type.Optional(Type.Union([Kfw261CalculationBreakdownSchema, Type.Null()]))
	});
	InterestRateAdvantageBenefitSchema = Type.Object({
		type: Type.Literal("interest_rate_advantage"),
		eligibleCosts: Type.Number({ minimum: 0 }),
		loanAmount: Type.Number({ minimum: 0 }),
		subsidizedInterestRate: Type.Number({ minimum: 0 }),
		bankInterestRate: Type.Number({ minimum: 0 }),
		annualInterestRateAdvantage: Type.Number(),
		annualInterestAdvantage: Type.Number()
	});
	SubsidyBenefitSchema = Type.Union([
		DirectGrantBenefitSchema,
		LoanWithRepaymentGrantBenefitSchema,
		InterestRateAdvantageBenefitSchema
	]);
	BafaBegEmVariantAssessmentSchema = Type.Object({
		programCode: Type.Literal("BAFA_BEG_EM"),
		hasIndividualRenovationRoadmap: Type.Boolean(),
		status: Type.Enum(SubsidyVariantAssessmentStatus),
		eligibilityStatus: Type.Enum(SubsidyEligibilityStatus),
		costCeiling: Type.Number({ minimum: 0 }),
		grantRate: Type.Union([Type.Number({
			minimum: 0,
			maximum: 1
		}), Type.Null()]),
		potentialBenefit: Type.Union([DirectGrantBenefitSchema, Type.Null()]),
		potentialBreakdown: Type.Optional(Type.Union([BafaBegEmCalculationBreakdownSchema, Type.Null()]))
	});
	Kfw359VariantAssessmentSchema = Type.Object({
		programCode: Type.Literal("KFW_359"),
		status: Type.Enum(SubsidyVariantAssessmentStatus),
		eligibilityStatus: Type.Enum(SubsidyEligibilityStatus),
		underlyingProgramCode: Type.Union([Type.Literal("BAFA_BEG_EM"), Type.Literal("KFW_459")]),
		potentialBenefit: Type.Union([InterestRateAdvantageBenefitSchema, Type.Null()]),
		potentialBreakdown: Type.Optional(Type.Union([Kfw359CalculationBreakdownSchema, Type.Null()]))
	});
	IfbModernisationStageAssessmentSchema = Type.Object({
		programCode: Type.Literal("IFB_MODERNISIERUNG_A"),
		stage: Type.Enum(IfbModernisationStage),
		status: Type.Enum(SubsidyVariantAssessmentStatus),
		eligibilityStatus: Type.Enum(SubsidyEligibilityStatus),
		criterion: Type.Enum(IfbModernisationStageCriterion),
		maximumFinalEnergyDemandPerSquareMeter: Type.Union([Type.Number({ minimum: 0 }), Type.Null()]),
		requiredEfficiencyHouseStage: Type.Union([Type.Enum(SubsidyEfficiencyHouseStage), Type.Null()]),
		actualFinalEnergyDemandPerSquareMeter: Type.Union([Type.Number({ minimum: 0 }), Type.Null()]),
		actualEfficiencyHouseStage: Type.Union([Type.Enum(SubsidyEfficiencyHouseStage), Type.Null()]),
		isHeatPumpEligible: Type.Boolean(),
		isHeatPumpCompatible: Type.Boolean(),
		grantRatePerSquareMeter: Type.Number({ minimum: 0 }),
		potentialBenefit: Type.Union([DirectGrantBenefitSchema, Type.Null()]),
		potentialBreakdown: Type.Optional(Type.Union([IfbModernisierungACalculationBreakdownSchema, Type.Null()]))
	});
	FkgMunichModuleAssessmentSchema = Type.Object({
		programCode: Type.Literal("FKG_MUNICH"),
		module: Type.Enum(FkgMunichModule),
		status: Type.Enum(SubsidyVariantAssessmentStatus),
		eligibilityStatus: Type.Enum(SubsidyEligibilityStatus),
		grantRate: Type.Union([Type.Number({
			minimum: 0,
			maximum: 1
		}), Type.Null()]),
		federalProgramCode: Type.Union([
			Type.Literal("KFW_261"),
			Type.Literal("BAFA_BEG_EM"),
			Type.Literal("KFW_459"),
			Type.Null()
		]),
		federalFundingCapApplied: Type.Boolean(),
		potentialBenefit: Type.Union([DirectGrantBenefitSchema, Type.Null()]),
		potentialBreakdown: Type.Optional(Type.Union([FkgMunichCalculationBreakdownSchema, Type.Null()]))
	});
	SubsidyVariantAssessmentSchema = Type.Union([
		SubsidyEfficiencyHouseStageAssessmentSchema,
		BafaBegEmVariantAssessmentSchema,
		Kfw359VariantAssessmentSchema,
		IfbModernisationStageAssessmentSchema,
		FkgMunichModuleAssessmentSchema
	]);
	SubsidyConsideredMeasureSchema = Type.Object({
		componentCode: Type.String(),
		catalogId: Type.String(),
		outcome: Type.Enum(SubsidyRuleOutcome),
		eligibleCosts: Type.Union([Type.Number({ minimum: 0 }), Type.Null()])
	});
	SubsidyWarningCode = /* @__PURE__ */ function(SubsidyWarningCode) {
		SubsidyWarningCode["IsolatedResult"] = "ISOLATED_RESULT";
		SubsidyWarningCode["Kfw261HeatingCostsNotExcluded"] = "KFW_261_HEATING_COSTS_NOT_EXCLUDED";
		SubsidyWarningCode["BafaAnnualCostCeiling"] = "BAFA_ANNUAL_COST_CEILING";
		SubsidyWarningCode["Kfw459CostCeilingDegression"] = "KFW_459_COST_CEILING_DEGRESSION";
		SubsidyWarningCode["Kfw459OwnerOccupierAlternative"] = "KFW_459_OWNER_OCCUPIER_ALTERNATIVE";
		SubsidyWarningCode["Kfw459EuHeatPumpRulesNotCalculated"] = "KFW_459_EU_HEAT_PUMP_RULES_NOT_CALCULATED";
		SubsidyWarningCode["Kfw359ApprovedGrantRequired"] = "KFW_359_APPROVED_GRANT_REQUIRED";
		SubsidyWarningCode["Kfw359GrantMustNotBePaidOut"] = "KFW_359_GRANT_MUST_NOT_BE_PAID_OUT";
		SubsidyWarningCode["IfbSixYearBindingPeriod"] = "IFB_SIX_YEAR_BINDING_PERIOD";
		SubsidyWarningCode["IfbStateAidCumulationNotCalculated"] = "IFB_STATE_AID_CUMULATION_NOT_CALCULATED";
		SubsidyWarningCode["IfbBuildingAgeNotVerified"] = "IFB_BUILDING_AGE_NOT_VERIFIED";
		SubsidyWarningCode["IfbEnergyConsultantRequired"] = "IFB_ENERGY_CONSULTANT_REQUIRED";
		SubsidyWarningCode["IfbAirtightnessMeasurementNotCalculated"] = "IFB_AIRTIGHTNESS_MEASUREMENT_NOT_CALCULATED";
		SubsidyWarningCode["IfbOwnerOccupierLoanAlternative"] = "IFB_OWNER_OCCUPIER_LOAN_ALTERNATIVE";
		SubsidyWarningCode["FkgFederalFundingCapCouldNotBeApplied"] = "FKG_FEDERAL_FUNDING_CAP_COULD_NOT_BE_APPLIED";
		SubsidyWarningCode["FkgIndividualRenovationRoadmapRecommended"] = "FKG_INDIVIDUAL_RENOVATION_ROADMAP_RECOMMENDED";
		SubsidyWarningCode["FkgFederalFundingCapApplies"] = "FKG_FEDERAL_FUNDING_CAP_APPLIES";
		SubsidyWarningCode["FkgApplicationBeforeOrderPlacement"] = "FKG_APPLICATION_BEFORE_ORDER_PLACEMENT";
		return SubsidyWarningCode;
	}({});
	SubsidyMissingInputCode = /* @__PURE__ */ function(SubsidyMissingInputCode) {
		SubsidyMissingInputCode["City"] = "CITY";
		SubsidyMissingInputCode["ResidentialUnits"] = "RESIDENTIAL_UNITS";
		SubsidyMissingInputCode["NumberOfBuildings"] = "NUMBER_OF_BUILDINGS";
		SubsidyMissingInputCode["GrossFloorArea"] = "GROSS_FLOOR_AREA";
		SubsidyMissingInputCode["TotalRentableArea"] = "TOTAL_RENTABLE_AREA";
		SubsidyMissingInputCode["BrickFacadeArea"] = "BRICK_FACADE_AREA";
		SubsidyMissingInputCode["YearBuilt"] = "YEAR_BUILT";
		SubsidyMissingInputCode["FacadeInsulationRate"] = "FACADE_INSULATION_RATE";
		SubsidyMissingInputCode["CurrentFinalEnergyConsumption"] = "CURRENT_FINAL_ENERGY_CONSUMPTION";
		SubsidyMissingInputCode["CurrentFinalEnergyDemandPerSquareMeter"] = "CURRENT_FINAL_ENERGY_DEMAND_PER_SQUARE_METER";
		SubsidyMissingInputCode["PostFinalEnergyDemandPerSquareMeter"] = "POST_FINAL_ENERGY_DEMAND_PER_SQUARE_METER";
		SubsidyMissingInputCode["PrePrimaryEnergyDemand"] = "PRE_PRIMARY_ENERGY_DEMAND";
		SubsidyMissingInputCode["PostPrimaryEnergyDemandBeforePv"] = "POST_PRIMARY_ENERGY_DEMAND_BEFORE_PV";
		SubsidyMissingInputCode["PrimaryEnergySavingBeforePv"] = "PRIMARY_ENERGY_SAVING_BEFORE_PV";
		SubsidyMissingInputCode["FinalEnergySaving"] = "FINAL_ENERGY_SAVING";
		SubsidyMissingInputCode["HeatDemandSaving"] = "HEAT_DEMAND_SAVING";
		SubsidyMissingInputCode["TransmissionHeatLossPercentOfReference"] = "TRANSMISSION_HEAT_LOSS_PERCENT_OF_REFERENCE";
		SubsidyMissingInputCode["PrimaryEnergyDemandInclExpansionInclPvPercentOfReference"] = "PRIMARY_ENERGY_DEMAND_INCL_EXPANSION_INCL_PV_PERCENT_OF_REFERENCE";
		SubsidyMissingInputCode["PrimaryEnergyDemandInclExpansionExclPvPercentOfReference"] = "PRIMARY_ENERGY_DEMAND_INCL_EXPANSION_EXCL_PV_PERCENT_OF_REFERENCE";
		SubsidyMissingInputCode["ComponentPostState"] = "COMPONENT_POST_STATE";
		SubsidyMissingInputCode["ComponentPostUValue"] = "COMPONENT_POST_U_VALUE";
		SubsidyMissingInputCode["ComponentQuantity"] = "COMPONENT_QUANTITY";
		SubsidyMissingInputCode["ComponentEligibleCosts"] = "COMPONENT_ELIGIBLE_COSTS";
		SubsidyMissingInputCode["IndividualRenovationRoadmap"] = "INDIVIDUAL_RENOVATION_ROADMAP";
		SubsidyMissingInputCode["PreRenovationEnergyClass"] = "PRE_RENOVATION_ENERGY_CLASS";
		return SubsidyMissingInputCode;
	}({});
	SubsidyProgramResultSchema = Type.Object({
		programCode: Type.Enum(SubsidyProgramCode),
		programLongName: Type.String(),
		programShortName: Type.String(),
		institutionShortName: Type.String(),
		institutionLongName: Type.String(),
		fundingType: Type.Enum(SubsidyFundingType),
		eligibilityStatus: Type.Enum(SubsidyEligibilityStatus),
		ruleOutcomes: Type.Array(SubsidyRuleOutcomeSchema),
		selectedVariant: Type.Union([SubsidyVariantSchema, Type.Null()]),
		benefit: Type.Union([SubsidyBenefitSchema, Type.Null()]),
		breakdown: Type.Optional(Type.Union([SubsidyCalculationBreakdownSchema, Type.Null()])),
		variantAssessments: Type.Optional(Type.Array(SubsidyVariantAssessmentSchema)),
		consideredMeasures: Type.Optional(Type.Array(SubsidyConsideredMeasureSchema)),
		warningCodes: Type.Array(Type.Enum(SubsidyWarningCode)),
		missingInputs: Type.Array(Type.Enum(SubsidyMissingInputCode))
	});
	MatchedSubsidyProgramSchema = SubsidyProgramResultSchema;
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/subsidies/subsidy-config.model.ts
var SubsidyHeatingSystem, SubsidyRegion, SubsidyProgramMetadataSchema, NullableNonnegativeNumberSchema, SubsidyEfficiencyHouseStageConfigSchema, Kfw261SubsidyConfigSchema, BafaBegEmTechnicalRequirementsSchema, BafaBegEmResidentialUnitCostCeilingBandSchema, BafaBegEmSubsidyConfigSchema, Kfw459ResidentialUnitCostCeilingBandSchema, Kfw459SubsidyConfigSchema, Kfw359SubsidyConfigSchema, IfbModernisationFinalEnergyStageConfigSchema, IfbModernisationEfficiencyHouseStageConfigSchema, IfbModernisationStageConfigSchema, IfbModernisierungASubsidyConfigSchema, FkgMunichSubsidyConfigSchema, MfhEnergyEfficiencySubsidyConfigSchema;
var init_subsidy_config_model = __esmMin((() => {
	init_energy_efficiency();
	init_subsidy_result_model();
	SubsidyHeatingSystem = /* @__PURE__ */ function(SubsidyHeatingSystem) {
		SubsidyHeatingSystem["HeatPump"] = "HEAT_PUMP";
		SubsidyHeatingSystem["Pellets"] = "PELLETS";
		SubsidyHeatingSystem["DistrictHeating"] = "DISTRICT_HEATING";
		SubsidyHeatingSystem["SolarThermal"] = "SOLAR_THERMAL";
		return SubsidyHeatingSystem;
	}({});
	SubsidyRegion = /* @__PURE__ */ function(SubsidyRegion) {
		SubsidyRegion["Hamburg"] = "HAMBURG";
		SubsidyRegion["Munich"] = "MÜNCHEN";
		return SubsidyRegion;
	}({});
	SubsidyProgramMetadataSchema = Type.Object({
		programLongName: Type.String(),
		programShortName: Type.String(),
		institutionShortName: Type.String(),
		institutionLongName: Type.String()
	});
	NullableNonnegativeNumberSchema = Type.Unsafe({
		type: ["number", "null"],
		minimum: 0
	});
	SubsidyEfficiencyHouseStageConfigSchema = Type.Object({
		stage: Type.Enum(SubsidyEfficiencyHouseStage),
		track: Type.Enum(SubsidyEfficiencyHouseTrack),
		maximumPrimaryEnergyDemandPercentOfReference: Type.Number({ minimum: 0 }),
		maximumTransmissionHeatLossPercentOfReference: NullableNonnegativeNumberSchema,
		baseRepaymentGrantRate: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		worstPerformanceBuildingBonusRate: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		serialRenovationBonusRate: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		isEnabled: Type.Boolean()
	});
	Kfw261SubsidyConfigSchema = Type.Object({
		programCode: Type.Literal("KFW_261"),
		fundingType: Type.Literal("loan_with_repayment_grant"),
		metadata: SubsidyProgramMetadataSchema,
		warningCodes: Type.Array(Type.Enum(SubsidyWarningCode)),
		worstPerformanceBuildingMinimumFinalEnergyDemandPerSquareMeter: Type.Number({ minimum: 0 }),
		worstPerformanceBuildingMaximumConstructionYear: Type.Integer(),
		worstPerformanceBuildingMaximumFacadeInsulationRate: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		renewableEnergyClassMinimumHeatDemandCoverageRate: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		renewableEnergyClassHeatingSystems: Type.Array(Type.Enum(SubsidyHeatingSystem)),
		loanCeilingPerResidentialUnit: Type.Number({ minimum: 0 }),
		maximumRepaymentGrantRate: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		eligibleEnergeticCapexShare: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		eligibleExpansionCapexShare: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		/** Shared ceiling for supervision (Baubegleitung) and NH certification loans. */
		supervisionLoanCeilingPerResidentialUnit: Type.Number({ minimum: 0 }),
		/** Shared absolute ceiling for supervision and NH certification loans. */
		supervisionLoanAbsoluteCeiling: Type.Number({ minimum: 0 }),
		/** Shared repayment-grant rate for supervision and NH certification loans. */
		supervisionRepaymentGrantRate: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		certificationCost: Type.Number({ minimum: 0 })
	});
	BafaBegEmTechnicalRequirementsSchema = Type.Object({
		externalWallInsulationMaximumUValue: Type.Number({ minimum: 0 }),
		roofInsulationMaximumUValue: Type.Number({ minimum: 0 }),
		topFloorCeilingInsulationMaximumUValue: Type.Number({ minimum: 0 }),
		cellarCeilingInsulationMaximumUValue: Type.Number({ minimum: 0 }),
		windowsMaximumUValue: Type.Number({ minimum: 0 })
	});
	BafaBegEmResidentialUnitCostCeilingBandSchema = Type.Object({
		minResidentialUnit: Type.Integer({ minimum: 1 }),
		maxResidentialUnit: Type.Union([Type.Integer({ minimum: 1 }), Type.Null()]),
		valueWithISFP: Type.Number({ minimum: 0 }),
		valueWithoutISFP: Type.Number({ minimum: 0 })
	});
	BafaBegEmSubsidyConfigSchema = Type.Object({
		programCode: Type.Literal("BAFA_BEG_EM"),
		fundingType: Type.Literal("direct_grant"),
		metadata: SubsidyProgramMetadataSchema,
		warningCodes: Type.Array(Type.Enum(SubsidyWarningCode)),
		residentialUnitCostCeilings: Type.Array(BafaBegEmResidentialUnitCostCeilingBandSchema, { minItems: 1 }),
		baseGrantRate: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		individualRenovationRoadmapBonusRate: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		planningAndSupervisionGrantRate: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		planningAndSupervisionCeilingPerResidentialUnit: Type.Number({ minimum: 0 }),
		planningAndSupervisionAbsoluteCeiling: Type.Number({ minimum: 0 }),
		planningAndSupervisionSmallBuildingAbsoluteCeiling: Type.Number({ minimum: 0 }),
		technicalRequirements: BafaBegEmTechnicalRequirementsSchema
	});
	Kfw459ResidentialUnitCostCeilingBandSchema = Type.Object({
		minResidentialUnit: Type.Integer({ minimum: 1 }),
		maxResidentialUnit: Type.Union([Type.Integer({ minimum: 1 }), Type.Null()]),
		amount: Type.Number({ minimum: 0 })
	});
	Kfw459SubsidyConfigSchema = Type.Object({
		programCode: Type.Literal("KFW_459"),
		fundingType: Type.Literal("direct_grant"),
		metadata: SubsidyProgramMetadataSchema,
		warningCodes: Type.Array(Type.Enum(SubsidyWarningCode)),
		eligibleHeatingSystems: Type.Array(Type.Enum(SubsidyHeatingSystem)),
		residentialUnitCostCeilings: Type.Array(Kfw459ResidentialUnitCostCeilingBandSchema, { minItems: 1 }),
		grantRate: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		degressionStartDate: Type.String({ format: "date" }),
		degressionIntervalMonths: Type.Integer({ minimum: 1 }),
		degressionAmountPerInterval: Type.Number({ minimum: 0 })
	});
	Kfw359SubsidyConfigSchema = Type.Object({
		programCode: Type.Literal("KFW_359"),
		fundingType: Type.Literal("interest_rate_advantage"),
		metadata: SubsidyProgramMetadataSchema,
		warningCodes: Type.Array(Type.Enum(SubsidyWarningCode)),
		loanCeilingPerResidentialUnit: Type.Number({ minimum: 0 }),
		subsidizedInterestRate: Type.Number({ minimum: 0 }),
		screeningBankInterestRate: Type.Number({ minimum: 0 })
	});
	IfbModernisationFinalEnergyStageConfigSchema = Type.Object({
		stage: Type.Union([Type.Literal("IFB_STAGE_1"), Type.Literal("IFB_STAGE_2")]),
		criterion: Type.Literal("FINAL_ENERGY_DEMAND"),
		maximumFinalEnergyDemandPerSquareMeter: Type.Number({ minimum: 0 }),
		grantRatePerSquareMeter: Type.Number({ minimum: 0 }),
		isHeatPumpEligible: Type.Boolean()
	});
	IfbModernisationEfficiencyHouseStageConfigSchema = Type.Object({
		stage: Type.Union([
			Type.Literal("IFB_STAGE_3"),
			Type.Literal("IFB_STAGE_4"),
			Type.Literal("IFB_STAGE_5")
		]),
		criterion: Type.Literal("EFFICIENCY_HOUSE_STAGE"),
		efficiencyHouseStage: Type.Enum(SubsidyEfficiencyHouseStage),
		grantRatePerSquareMeter: Type.Number({ minimum: 0 }),
		isHeatPumpEligible: Type.Boolean()
	});
	IfbModernisationStageConfigSchema = Type.Union([IfbModernisationFinalEnergyStageConfigSchema, IfbModernisationEfficiencyHouseStageConfigSchema]);
	IfbModernisierungASubsidyConfigSchema = Type.Object({
		programCode: Type.Literal("IFB_MODERNISIERUNG_A"),
		fundingType: Type.Literal("direct_grant"),
		metadata: SubsidyProgramMetadataSchema,
		warningCodes: Type.Array(Type.Enum(SubsidyWarningCode)),
		eligibleRegion: Type.Literal("HAMBURG"),
		minimumPrimaryEnergySavingRateBeforePv: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		minimumFinalEnergySavingRate: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		minimumHeatDemandSavingRate: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		livingSpaceCeilingPerResidentialUnit: Type.Number({ minimum: 0 }),
		stages: Type.Array(IfbModernisationStageConfigSchema),
		qualityAssuranceGrantPerBuilding: Type.Number({ minimum: 0 }),
		brickFacadeGrantPerSquareMeter: Type.Number({ minimum: 0 })
	});
	FkgMunichSubsidyConfigSchema = Type.Object({
		programCode: Type.Literal("FKG_MUNICH"),
		fundingType: Type.Literal("direct_grant"),
		metadata: SubsidyProgramMetadataSchema,
		warningCodes: Type.Array(Type.Enum(SubsidyWarningCode)),
		eligibleRegion: Type.Literal("MÜNCHEN"),
		baseGrantRate: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		energyClassBonusRate: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		energyClassBonusClasses: Type.Array(Type.Enum(EnergyConsumptionCategory)),
		multiUnitBonusRate: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		multiUnitBonusMinimumResidentialUnits: Type.Integer({ minimum: 1 }),
		federalFundingCapFactor: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		heatingReplacementGrantRate: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		minimumEfficiencyHouseStage: Type.Enum(SubsidyEfficiencyHouseStage),
		eligiblePreRenovationEnergyClasses: Type.Array(Type.Enum(EnergyConsumptionCategory))
	});
	MfhEnergyEfficiencySubsidyConfigSchema = Type.Object({
		efficiencyHouseStages: Type.Array(SubsidyEfficiencyHouseStageConfigSchema, {
			minItems: 10,
			maxItems: 10
		}),
		programs: Type.Object({
			kfw261: Kfw261SubsidyConfigSchema,
			bafaBegEm: BafaBegEmSubsidyConfigSchema,
			kfw459: Kfw459SubsidyConfigSchema,
			kfw359: Kfw359SubsidyConfigSchema,
			ifbModernisierungA: IfbModernisierungASubsidyConfigSchema,
			fkgMunich: FkgMunichSubsidyConfigSchema
		})
	});
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/subsidies/subsidy-inputs.model.ts
/**
* Ensures all subsidy input keys exist. Legacy persisted JSON may only have
* `hasIndividualRenovationRoadmap`; spreading that into a toggle update omits required NH/SerSan fields.
*/
function normalizeMfhEnergyEfficiencySubsidyInputs(inputs) {
	return {
		hasIndividualRenovationRoadmap: inputs?.hasIndividualRenovationRoadmap ?? DEFAULT_MFH_ENERGY_EFFICIENCY_SUBSIDY_INPUTS.hasIndividualRenovationRoadmap,
		hasSustainabilityCertificate: inputs?.hasSustainabilityCertificate ?? DEFAULT_MFH_ENERGY_EFFICIENCY_SUBSIDY_INPUTS.hasSustainabilityCertificate,
		hasSerialRenovation: inputs?.hasSerialRenovation ?? DEFAULT_MFH_ENERGY_EFFICIENCY_SUBSIDY_INPUTS.hasSerialRenovation
	};
}
var MfhEnergyEfficiencySubsidyInputsSchema, DEFAULT_MFH_ENERGY_EFFICIENCY_SUBSIDY_INPUTS;
var init_subsidy_inputs_model = __esmMin((() => {
	MfhEnergyEfficiencySubsidyInputsSchema = Type.Object({
		/**
		* BAFA iSFP fact. Creation services supply the default (`true`); the domain contract deliberately
		* carries no schema default so omitted persistence values remain distinguishable during rollout.
		*/
		hasIndividualRenovationRoadmap: Type.Boolean(),
		/**
		* KfW 261 Nachhaltigkeit (NH / QNG-Plus) track toggle. Defaults to `false` in Basecamp/RAM.
		*/
		hasSustainabilityCertificate: Type.Boolean(),
		/**
		* KfW 261 serial renovation (Serielle Sanierung) bonus toggle. Defaults to `false` in Basecamp/RAM.
		*/
		hasSerialRenovation: Type.Boolean()
	});
	DEFAULT_MFH_ENERGY_EFFICIENCY_SUBSIDY_INPUTS = {
		hasIndividualRenovationRoadmap: true,
		hasSustainabilityCertificate: false,
		hasSerialRenovation: false
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/capex-ee-calculator.model.ts
/**
* Effective budget bucket for a component row: per-scenario override when set, otherwise
* {@link DEFAULT_BUDGET_BUCKET_BY_COMPONENT}.
*/
function resolveMfhCapexBudgetBucket(component, bucket) {
	return bucket ?? DEFAULT_BUDGET_BUCKET_BY_COMPONENT[component];
}
/**
* Area (m²) used as the €/m² denominator for each D2G budget pot, plus the total CAPEX area.
*
* - General / Energetic: {@link MfhEnergyEfficiencyInputs.totalRentableArea} (pre-renovation)
* - Expansion: sum of selected development-measure rentable areas (roof conversion + roof
*   expansion + separate new building `measureNetFloorArea`)
* - Total: pre-renovation rentable area + all three expansion areas
*/
function deriveMfhCapexBudgetBucketAreas(inputs, componentInputs) {
	const preRentable = inputs.totalRentableArea ?? null;
	const expansionArea = sumDevelopmentMeasureRentableAreas(componentInputs);
	return {
		buckets: {
			["generalCapex"]: preRentable,
			["energeticCapex"]: preRentable,
			["expansionCapex"]: expansionArea
		},
		total: preRentable == null && expansionArea == null ? null : (preRentable ?? 0) + (expansionArea ?? 0)
	};
}
/** Sum of rentable areas (NGF) across selected development measures; null when none are selected. */
function sumDevelopmentMeasureRentableAreas(componentInputs) {
	let sum = 0;
	let hasAny = false;
	for (const input of componentInputs) {
		if (input.postCatalogId == null || input.component !== "RoofConversion" && input.component !== "RoofExpansion" && input.component !== "SeparateNewBuild") continue;
		const area = input.measureNetFloorArea;
		if (area == null) continue;
		hasAny = true;
		sum += area;
	}
	return hasAny ? sum : null;
}
/**
* Risk-adjusted CAPEX ÷ area, rounded to whole euros; null when area is missing or ≤ 0.
* 0 € CAPEX is 0 €/m² regardless of area: a null €/m² makes the IC fall back to the global default (SKB-1283).
*/
function roundMfhCapexEuroPerM2(capex, area) {
	if (capex === 0) return 0;
	if (area == null || area <= 0 || Number.isNaN(capex)) return null;
	return Math.round(capex / area);
}
/** Rules whose quantity formula reads {@link MfhMeasureComponentPrefill.value}. */
function mfhMeasureComponentPrefillRuleNeedsValue(rule) {
	switch (rule) {
		case "FootprintAreaTimesStoreys":
		case "CustomValue": return true;
		case "GrossFloorArea":
		case "NetFacadeArea":
		case "ThermalBridgeArea":
		case "WindowArea":
		case "FootprintArea":
		case "RoofArea":
		case "PvRoofKwp":
		case "SolarThermalArea":
		case "NumberOfBuildings":
		case "ResidentialPlusCommercial":
		case "NumberOfBalconies":
		case "UndergroundParkingSpaces":
		case "VentilationQuantity": return false;
		default: return rule;
	}
}
/** Drop `value` for rules that do not read it. Null clears the pre-fill. */
function normalizeMfhMeasureComponentPrefill(prefill) {
	if (prefill == null) return null;
	if (!mfhMeasureComponentPrefillRuleNeedsValue(prefill.rule)) return { rule: prefill.rule };
	return prefill;
}
/** Pin a catalogue row's values into a snapshot for embedding on a scenario component row. */
function catalogueItemToSnapshot(item) {
	return {
		catalogId: item.catalogId,
		flags: item.flags,
		unit: item.unit,
		capexUnit: item.capexUnit,
		liveMin: item.liveMin,
		liveAvg: item.liveAvg,
		liveMax: item.liveMax,
		isEnergy: item.isEnergy,
		modelType: item.modelType,
		performance: item.performance,
		energyParams: item.energyParams,
		notes: item.notes
	};
}
/**
* Join `componentInputs` (selections) with `componentCatalogue` (scenario-owned catalogue) into the
* resolved {@link MfhEnergyEfficiencyScenarioComponent} shape the calculation modules consume. Pure —
* no live catalogue lookup, preserving reproducibility.
*
* Throws {@link MfhScenarioCatalogueDuplicateError} when the catalogue has duplicate catalogIds, and
* {@link MfhScenarioCatalogueUnresolvedError} when a selection points at a catalogId absent from the
* catalogue (e.g. after a catalogue refresh dropped a still-selected entry).
*/
function resolveScenarioComponents(componentCatalogue, componentInputs) {
	const byCatalogId = /* @__PURE__ */ new Map();
	const duplicates = [];
	for (const entry of componentCatalogue) {
		if (byCatalogId.has(entry.catalogId)) duplicates.push(entry.catalogId);
		byCatalogId.set(entry.catalogId, entry);
	}
	if (duplicates.length > 0) throw new MfhScenarioCatalogueDuplicateError([...new Set(duplicates)]);
	const unresolved = [];
	const components = componentInputs.map((input) => {
		const preEntry = resolveEntry(byCatalogId, input.preCatalogId, unresolved);
		const postEntry = resolveEntry(byCatalogId, input.postCatalogId, unresolved);
		const pre = preEntry ? catalogueItemToSnapshot(preEntry) : null;
		const post = postEntry ? {
			...catalogueItemToSnapshot(postEntry),
			quantity: input.quantity,
			...input.bucket != null ? { bucket: input.bucket } : {}
		} : null;
		return {
			component: input.component,
			pre,
			post
		};
	});
	if (unresolved.length > 0) throw new MfhScenarioCatalogueUnresolvedError([...new Set(unresolved)]);
	return components;
}
/** Look up a selected catalogId; records misses (not null selections) in `unresolved`. */
function resolveEntry(byCatalogId, catalogId, unresolved) {
	if (catalogId == null) return null;
	const entry = byCatalogId.get(catalogId);
	if (!entry) {
		unresolved.push(catalogId);
		return null;
	}
	return entry;
}
/**
* Split legacy embedded {@link MfhEnergyEfficiencyScenarioComponent} rows into the
* `componentCatalogue` + `componentInputs` shape.
*
* `baseCatalogue` provides the full catalogue starting point (e.g. the latest global catalogue during
* migration). Each embedded pre/post snapshot is overlaid on top of the matching base entry by
* catalogId so scenario-specific edits (e.g. an overridden U-value) survive. Catalogue identity and
* timestamps remain the exact values from the global copy. A selected catalogId absent from the global
* catalogue remains only in `componentInputs`, making the scenario invalid until the selection is fixed.
*/
function splitLegacyScenarioComponents(components, baseCatalogue) {
	const catalogueByCatalogId = new Map(baseCatalogue.map((entry) => [entry.catalogId, entry]));
	const overlay = (snapshot) => {
		const base = catalogueByCatalogId.get(snapshot.catalogId);
		if (base) catalogueByCatalogId.set(snapshot.catalogId, {
			...base,
			...snapshot
		});
	};
	const componentInputs = components.map((row) => {
		if (row.pre) overlay(row.pre);
		if (row.post) overlay(row.post);
		return {
			component: row.component,
			preCatalogId: row.pre?.catalogId ?? null,
			postCatalogId: row.post?.catalogId ?? null,
			quantity: row.post?.quantity ?? null,
			...row.post?.bucket != null ? { bucket: row.post.bucket } : {}
		};
	});
	return {
		componentCatalogue: [...catalogueByCatalogId.values()],
		componentInputs
	};
}
var DEFAULT_WINDOW_TO_FACADE_RATIO, MfhMeasureComponent, DEFAULT_MEASURE_COMPONENTS, MfhMeasureComponentFlag, MfhMeasureComponentUnit, MfhBuildingType, MfhBuildingClass, MfhMeasureComponentEnergyModelType, MfhMeasureComponentGroupId, MfhMeasureComponentGroupSchema, MfhCapexBudgetBucket, CAPEX_BUDGET_BUCKET_ORDER, DEFAULT_BUDGET_BUCKET_BY_COMPONENT, MfhEnvelopeSurface, MfhReferenceBuildingParamsSchema, MfhCostMarkupsSchema, MfhEnergyEfficiencyCalculationConfigSchema, MfhEnergyEfficiencyWarningType, MfhEnergyEfficiencyWarningCode, MfhEnergyEfficiencyWarningSchema, MfhMeasureComponentEnergyParamsSchema, MfhMeasureComponentPrefillRule, MfhMeasureComponentPrefillSchema, MfhMeasureComponentCatalogueItemSchema, MfhEnergyEfficiencyInputsSchema, MfhEnergyEfficiencyComponentSnapshotSchema, MfhEnergyEfficiencyScenarioPostComponentSchema, MfhEnergyEfficiencyScenarioComponentSchema, MfhEnergyEfficiencyComponentInputSchema, MfhScenarioCatalogueDuplicateError, MfhScenarioCatalogueUnresolvedError, MfhEnergyEfficiencyOutputSchema, MfhEnergyEfficiencyScenarioStatus, MfhEnergyEfficiencyScenarioSchema;
var init_capex_ee_calculator_model = __esmMin((() => {
	init_shared_schemas();
	init_lib();
	init_energy_efficiency();
	init_base_errors();
	init_mfh_attributes_base();
	init_subsidy_config_model();
	init_subsidy_inputs_model();
	init_subsidy_result_model();
	DEFAULT_WINDOW_TO_FACADE_RATIO = .22;
	MfhMeasureComponent = /* @__PURE__ */ function(MfhMeasureComponent) {
		/** Cross-cutting / overhead measures not tied to a specific building part (group 0). */
		MfhMeasureComponent["General"] = "General";
		MfhMeasureComponent["FacadeInsulation"] = "FacadeInsulation";
		/** Thermal-bridge optimisation — an envelope measure whose useful-heat-demand saving is a share of the demand left after the standard envelope measures (no own U-value). */
		MfhMeasureComponent["ThermalBridge"] = "ThermalBridge";
		MfhMeasureComponent["Windows"] = "Windows";
		MfhMeasureComponent["TopFloorCeiling"] = "TopFloorCeiling";
		MfhMeasureComponent["CellarCeilingInsulation"] = "CellarCeilingInsulation";
		/** Roof conversion / expansion — value-creation measure, no energy effect (group 5). */
		MfhMeasureComponent["RoofConversion"] = "RoofConversion";
		/** Roof expansion — value-creation measure (same group as roof conversion), no energy effect. */
		MfhMeasureComponent["RoofExpansion"] = "RoofExpansion";
		MfhMeasureComponent["RoofInsulation"] = "RoofInsulation";
		MfhMeasureComponent["RoofEnergyProduction"] = "RoofEnergyProduction";
		MfhMeasureComponent["HeatingSystem"] = "HeatingSystem";
		/** Hydraulic balancing — a heating-side measure that raises the heating system's final-system efficiency (no heat-demand reduction and no own U-value). */
		MfhMeasureComponent["HydraulicBalancing"] = "HydraulicBalancing";
		/** Heating pipeline insulation — a heating-side measure that raises the heating system's final-system efficiency (no heat-demand reduction and no own U-value). */
		MfhMeasureComponent["HeatingPipelineInsulation"] = "HeatingPipelineInsulation";
		MfhMeasureComponent["Ventilation"] = "Ventilation";
		/** Separate new build / extension — value-creation measure, no energy effect (group 6). */
		MfhMeasureComponent["SeparateNewBuild"] = "SeparateNewBuild";
		/** Pipe renovation (Strangsanierung) — general CAPEX, no energy effect. */
		MfhMeasureComponent["PipeRenovation"] = "PipeRenovation";
		/** Exterior doors — general CAPEX, no energy effect. */
		MfhMeasureComponent["Doors"] = "Doors";
		/** Balcony slab refurbishment — general CAPEX, no energy effect. */
		MfhMeasureComponent["Balconies"] = "Balconies";
		/** Underground garage refurbishment — general CAPEX, no energy effect. */
		MfhMeasureComponent["UndergroundGarage"] = "UndergroundGarage";
		return MfhMeasureComponent;
	}({});
	DEFAULT_MEASURE_COMPONENTS = [
		"CellarCeilingInsulation",
		"FacadeInsulation",
		"RoofInsulation",
		"TopFloorCeiling",
		"Ventilation",
		"Windows",
		"ThermalBridge"
	];
	MfhMeasureComponentFlag = /* @__PURE__ */ function(MfhMeasureComponentFlag) {
		MfhMeasureComponentFlag["Pre"] = "Pre";
		MfhMeasureComponentFlag["Post"] = "Post";
		MfhMeasureComponentFlag["Measure"] = "Measure";
		return MfhMeasureComponentFlag;
	}({});
	MfhMeasureComponentUnit = /* @__PURE__ */ function(MfhMeasureComponentUnit) {
		MfhMeasureComponentUnit["MSquaredFacade"] = "MSquaredFacade";
		MfhMeasureComponentUnit["MSquaredEnvelope"] = "MSquaredEnvelope";
		MfhMeasureComponentUnit["MSquaredInternalWalls"] = "MSquaredInternalWall";
		MfhMeasureComponentUnit["MSquaredCeiling"] = "MSquaredCeiling";
		MfhMeasureComponentUnit["MSquaredCellarCeiling"] = "MSquaredCellarCeiling";
		MfhMeasureComponentUnit["MSquaredWindow"] = "MSquaredWindow";
		MfhMeasureComponentUnit["MSquaredRoof"] = "MSquaredRoof";
		MfhMeasureComponentUnit["MSquaredHeating"] = "MSquaredHeating";
		MfhMeasureComponentUnit["MSquaredVentilation"] = "MSquaredVentilation";
		MfhMeasureComponentUnit["KiloWattPerResidentialUnit"] = "KiloWattPerResidentialUnit";
		MfhMeasureComponentUnit["ResidentialUnit"] = "ResidentialUnit";
		MfhMeasureComponentUnit["KiloWattPerConnection"] = "KiloWattPerConnection";
		MfhMeasureComponentUnit["LinearMeter"] = "LinearMeter";
		MfhMeasureComponentUnit["KiloWatt"] = "KiloWatt";
		MfhMeasureComponentUnit["MeterSquaredAffected"] = "MeterSquaredAffected";
		MfhMeasureComponentUnit["MeterSquaredNewLivingArea"] = "MeterSquaredNewLivingArea";
		MfhMeasureComponentUnit["KiloWattPeak"] = "KiloWattPeak";
		MfhMeasureComponentUnit["MeterSquaredCollector"] = "MeterSquaredCollector";
		MfhMeasureComponentUnit["EuroPerMeterSquared"] = "EuroPerMeterSquared";
		MfhMeasureComponentUnit["EuroPerBuilding"] = "EuroPerBuilding";
		MfhMeasureComponentUnit["EuroPerLinearMeter"] = "EuroPerLinearMeter";
		MfhMeasureComponentUnit["EuroPerKiloWattPeak"] = "EuroPerKiloWattPeak";
		MfhMeasureComponentUnit["EuroPerResidentialUnit"] = "EuroPerResidentialUnit";
		/** Count of units that are not specifically residential (e.g. residential + commercial, or one per building). */
		MfhMeasureComponentUnit["Unit"] = "Unit";
		MfhMeasureComponentUnit["EuroPerUnit"] = "EuroPerUnit";
		MfhMeasureComponentUnit["ParkingSpace"] = "ParkingSpace";
		MfhMeasureComponentUnit["EuroPerParkingSpace"] = "EuroPerParkingSpace";
		MfhMeasureComponentUnit["KiloWattHourPerYear"] = "KiloWattHourPerYear";
		MfhMeasureComponentUnit["KiloWattHourPerMeterSquaredPerYear"] = "KiloWattHourPerMeterSquaredPerYear";
		MfhMeasureComponentUnit["NA"] = "NA";
		return MfhMeasureComponentUnit;
	}({});
	MfhBuildingType = /* @__PURE__ */ function(MfhBuildingType) {
		MfhBuildingType["MFH"] = "MFH";
		MfhBuildingType["Office"] = "Office";
		MfhBuildingType["MixedUse"] = "MixedUse";
		MfhBuildingType["Retail"] = "Retail";
		return MfhBuildingType;
	}({});
	MfhBuildingClass = /* @__PURE__ */ function(MfhBuildingClass) {
		MfhBuildingClass["MfhStandard"] = "MfhStandard";
		MfhBuildingClass["MfhPremium"] = "MfhPremium";
		MfhBuildingClass["Plattenbau"] = "Plattenbau";
		MfhBuildingClass["Gruenderzeit"] = "Gruenderzeit";
		MfhBuildingClass["GrosswohnsiedlungPlattenbau"] = "GrosswohnsiedlungPlattenbau";
		MfhBuildingClass["Heritage"] = "Heritage";
		return MfhBuildingClass;
	}({});
	MfhMeasureComponentEnergyModelType = /* @__PURE__ */ function(MfhMeasureComponentEnergyModelType) {
		MfhMeasureComponentEnergyModelType["UValueDelta"] = "UValueDelta";
		MfhMeasureComponentEnergyModelType["SystemEfficiencyDelta"] = "SystemEfficiencyDelta";
		MfhMeasureComponentEnergyModelType["SPF"] = "SPF";
		/**
		* Thermal-bridge uplift: the useful-heat-demand saving is `performance` (a saving factor)
		* times the useful heat demand remaining after the standard U-value envelope measures, rather
		* than a per-component U-value delta. See {@link MfhMeasureComponent.ThermalBridge}.
		*/
		MfhMeasureComponentEnergyModelType["ThermalBridgeUplift"] = "ThermalBridgeUplift";
		/**
		* Hydraulic-balancing uplift: `performance` is an additive efficiency uplift (e.g. +0.03) applied
		* to the heating system's base final-system efficiency (post-state heating efficiency when a
		* heating replacement is selected, otherwise the pre-state efficiency). The measure's final-energy
		* saving is the post-renovation useful heat demand run through the base vs. the uplifted efficiency;
		* it does not reduce the useful heat demand. See {@link MfhMeasureComponent.HydraulicBalancing}.
		*/
		MfhMeasureComponentEnergyModelType["HydraulicBalancingUplift"] = "HydraulicBalancingUplift";
		/**
		* Pipe-insulation uplift: same shape as {@link HydraulicBalancingUplift} — `performance` is an
		* additive efficiency uplift (e.g. +0.02) on the heating system's base final-system efficiency,
		* with no useful-heat-demand reduction. See {@link MfhMeasureComponent.HeatingPipelineInsulation}.
		*/
		MfhMeasureComponentEnergyModelType["PipeInsulationUplift"] = "PipeInsulationUplift";
		/**
		* Ventilation baseline (pre-state, SKB-1060): the existing free-window ventilation. Carries only a
		* `ventilation_loss_share` in {@link MfhMeasureComponentCatalogueItemSchema.energyParams}; it has no
		* heat saving and no CAPEX, and defines the ventilation-loss share of the useful heat demand that a
		* {@link VentilationDelta} measure can recover. See {@link MfhMeasureComponent.Ventilation}.
		*/
		MfhMeasureComponentEnergyModelType["VentilationBaseline"] = "VENTILATION_BASELINE";
		/**
		* Ventilation delta (measure/post-state, SKB-1060): a mechanical ventilation measure whose heat
		* saving is a share of the baseline ventilation heat loss recovered via heat recovery, and which
		* consumes auxiliary electricity. Uses the structured
		* {@link MfhMeasureComponentCatalogueItemSchema.energyParams} (`ventilation_loss_share`,
		* `served_area_share`, `heat_recovery_efficiency`, `aux_electricity_kwh_per_we_a`) rather than the
		* single `performance` scalar. See {@link MfhMeasureComponent.Ventilation}.
		*/
		MfhMeasureComponentEnergyModelType["VentilationDelta"] = "VENTILATION_DELTA";
		/**
		* Rooftop PV generation (SKB-1060): on-site electricity generation. Quantity is installed peak power
		* (kWp); the generation is derived from the regional specific yield and the roof-type yield factor.
		* PV does not change the gross post final energy demand — it reduces the post *primary* energy demand
		* only, via avoided grid electricity (capped at 30% without battery storage). See
		* {@link MfhMeasureComponent.RoofEnergyProduction}.
		*/
		MfhMeasureComponentEnergyModelType["PvGeneration"] = "PV_GENERATION";
		/**
		* Roof-expansion final energy demand (SKB-1060): the newly created floor area adds final energy
		* demand on the post-state heating carrier. The `performance` scalar carries the per-m² final energy
		* demand (kWh/m²a); multiplied by the new floor area quantity it is an *additional* demand (a negative
		* saving). See {@link MfhMeasureComponent.RoofExpansion}.
		*/
		MfhMeasureComponentEnergyModelType["FinalEnergyDemandPerM2"] = "FINAL_ENERGY_DEMAND_PER_M2";
		return MfhMeasureComponentEnergyModelType;
	}({});
	MfhMeasureComponentGroupId = /* @__PURE__ */ function(MfhMeasureComponentGroupId) {
		MfhMeasureComponentGroupId["General"] = "general";
		MfhMeasureComponentGroupId["Shell"] = "shell";
		MfhMeasureComponentGroupId["Heating"] = "heating";
		MfhMeasureComponentGroupId["Ventilation"] = "ventilation";
		MfhMeasureComponentGroupId["Energy"] = "energy";
		/** Roof conversion / expansion (value-creation measures). */
		MfhMeasureComponentGroupId["Roof"] = "roof";
		MfhMeasureComponentGroupId["NewBuild"] = "newBuild";
		return MfhMeasureComponentGroupId;
	}({});
	MfhMeasureComponentGroupSchema = Type.Object({
		id: Type.Enum(MfhMeasureComponentGroupId),
		label: Type.String(),
		color: Type.String(),
		components: Type.Array(Type.Enum(MfhMeasureComponent))
	});
	MfhCapexBudgetBucket = /* @__PURE__ */ function(MfhCapexBudgetBucket) {
		MfhCapexBudgetBucket["GeneralCapex"] = "generalCapex";
		MfhCapexBudgetBucket["EnergeticCapex"] = "energeticCapex";
		MfhCapexBudgetBucket["ExpansionCapex"] = "expansionCapex";
		return MfhCapexBudgetBucket;
	}({});
	CAPEX_BUDGET_BUCKET_ORDER = [
		"generalCapex",
		"energeticCapex",
		"expansionCapex"
	];
	DEFAULT_BUDGET_BUCKET_BY_COMPONENT = {
		["General"]: "generalCapex",
		["FacadeInsulation"]: "energeticCapex",
		["ThermalBridge"]: "energeticCapex",
		["Windows"]: "energeticCapex",
		["TopFloorCeiling"]: "energeticCapex",
		["CellarCeilingInsulation"]: "energeticCapex",
		["RoofInsulation"]: "energeticCapex",
		["HeatingSystem"]: "energeticCapex",
		["HydraulicBalancing"]: "energeticCapex",
		["HeatingPipelineInsulation"]: "energeticCapex",
		["Ventilation"]: "energeticCapex",
		["RoofEnergyProduction"]: "energeticCapex",
		["RoofConversion"]: "expansionCapex",
		["RoofExpansion"]: "expansionCapex",
		["SeparateNewBuild"]: "expansionCapex",
		["PipeRenovation"]: "generalCapex",
		["Doors"]: "generalCapex",
		["Balconies"]: "generalCapex",
		["UndergroundGarage"]: "generalCapex"
	};
	MfhEnvelopeSurface = /* @__PURE__ */ function(MfhEnvelopeSurface) {
		MfhEnvelopeSurface["FacadeFreestanding"] = "FacadeFreestanding";
		MfhEnvelopeSurface["FacadeNonFreestanding"] = "FacadeNonFreestanding";
		MfhEnvelopeSurface["Windows"] = "Windows";
		MfhEnvelopeSurface["Roof"] = "Roof";
		MfhEnvelopeSurface["TopFloorCeiling"] = "TopFloorCeiling";
		MfhEnvelopeSurface["CellarCeiling"] = "CellarCeiling";
		MfhEnvelopeSurface["ThermalBridge"] = "ThermalBridge";
		return MfhEnvelopeSurface;
	}({});
	MfhReferenceBuildingParamsSchema = Type.Object({
		/** Reference heat transfer coefficient for the facade, W/(m²·K). GEG default 0.28. */
		facadeUValue: Type.Number({ minimum: 0 }),
		/** Reference heat transfer coefficient for the roof / top-floor ceiling, W/(m²·K). GEG default 0.20. */
		roofUValue: Type.Number({ minimum: 0 }),
		/** Reference heat transfer coefficient for the cellar ceiling, W/(m²·K). GEG default 0.35. */
		cellarCeilingUValue: Type.Number({ minimum: 0 }),
		/** Reference heat transfer coefficient for the windows, W/(m²·K). GEG default 1.30. */
		windowsUValue: Type.Number({ minimum: 0 }),
		/** Reference thermal-bridge supplement U-value, W/(m²·K). GEG default 0.05. */
		thermalBridgeSupplement: Type.Number({ minimum: 0 }),
		/** Reference base heating system efficiency (Gas-Etagenheizung). GEG default 0.82. */
		baseSystemEfficiencyGas: Type.Number({ minimum: 0 }),
		/** Reference hydraulic-balancing efficiency uplift (additive). GEG default 0.03. */
		hydraulicBalancingUplift: Type.Number({ minimum: 0 }),
		/** Reference solar hot-water coverage fraction (0–1). GEG default 0.55. */
		solarHotWaterCoverageFraction: Type.Number({
			minimum: 0,
			maximum: 1
		}),
		/** Reference ventilation loss as a ratio of the annual transmission heat losses. Default 0.3. */
		referenceVentilationToTransmissionRatio: Type.Number({ minimum: 0 }),
		/** Solar auxiliary electricity per living area, kWh/(m²·a) — electricity to run the solar hot-water system. Default 1.5. */
		solarAuxiliaryElectricityPerLivingArea: Type.Number({ minimum: 0 }),
		/** Primary energy factor for natural gas. GEG default 1.1. */
		primaryEnergyFactorGas: Type.Number({ minimum: 0 }),
		/** Primary energy factor for electricity. GEG default 1.8. */
		primaryEnergyFactorElectricity: Type.Number({ minimum: 0 }),
		/** Hot water heat demand per living area, kWh/(m²·a). DIN V 18599 residential standard 12.5. */
		hotWaterHeatDemandPerLivingArea: Type.Number({ minimum: 0 })
	});
	MfhCostMarkupsSchema = Type.Object({
		/** General contractor surcharge (Generalunternehmer-Zuschlag), fraction of raw risk-adjusted CAPEX. */
		gcSurcharge: Type.Number({ minimum: 0 }),
		/** Ancillary construction costs (Baunebenkosten / BNK), fraction of the subtotal incl. GC surcharge. */
		ancillaryConstruction: Type.Number({ minimum: 0 }),
		/** Contingency buffer (Puffer), fraction of the subtotal incl. GC surcharge + ancillary costs. */
		contingencyBuffer: Type.Number({ minimum: 0 })
	});
	MfhEnergyEfficiencyCalculationConfigSchema = Type.Object({
		mfhEnergyEfficienyCalculationConfigId: Type.Number(),
		/**
		* Per-building-age-class risk multipliers applied to raw CAPEX. Each entry carries a `factors`
		* map holding one multiplier per {@link MfhMeasureComponent}; a measure's raw CAPEX is scaled by
		* `factors[component]` for the age class matching the building's construction year (missing entries
		* fall back to 1.0). Every configured component contributes to the risk-adjusted CAPEX.
		*/
		riskFactorConfig: Type.Array(Type.Object({
			ageClassStart: Type.Number(),
			ageClassEnd: Type.Number(),
			designation: Type.String(),
			factors: Type.Partial(Type.Record(Type.Enum(MfhMeasureComponent), Type.Number({ minimum: 0 })))
		})),
		heatingDegreeHoursPerCity: Type.Record(Type.String(), Type.Number({ minimum: 0 })),
		energyCostPerCarrier: Type.Partial(Type.Record(Type.Enum(HeatingSource), Type.Number({ minimum: 0 }))),
		co2FactorsPerCarrier: Type.Partial(Type.Record(Type.Enum(HeatingSource), Type.Number({ minimum: 0 }))),
		/**
		* Primary energy factor per carrier (SKB-1012). Multiplied with the total final energy
		* saving (valued against the post-state heating carrier) to derive the primary energy
		* saving KPI. Editable per carrier in the Parameters config UI.
		*/
		primaryEnergyFactorPerCarrier: Type.Partial(Type.Record(Type.Enum(HeatingSource), Type.Number({ minimum: 0 }))),
		/**
		* Per-component plausibility caps (fraction of pre-state demand). Each measure's saving is
		* capped at `componentPlausibilityCaps[component].max` before whole-group caps are applied.
		* Editable per component in the Parameters config UI.
		*/
		componentPlausibilityCaps: Type.Partial(Type.Record(Type.Enum(MfhMeasureComponent), Type.Object({ max: Type.Number({ minimum: 0 }) }))),
		/**
		* Plausibility caps applied to a whole {@link MfhMeasureComponentGroupId} (the combined effect of
		* every measure in the group), as a fraction of the pre-construction demand. Editable in the
		* Parameters config UI. Two caps are consumed by the calculator:
		* - {@link MfhMeasureComponentGroupId.Shell} ("Building Envelope"): bounds the combined
		*   heat-demand saving of all envelope measures (the whole-envelope cap).
		* - {@link MfhMeasureComponentGroupId.Heating} ("Heating"): bounds the combined final-energy
		*   saving of all heating-side efficiency measures (heating swap, hydraulic balancing, pipe
		*   insulation) as a fraction of the pre-state final energy demand.
		*
		* Both caps must always be present in the config (seeded + backfilled by data migration); the
		* calculator does not fall back to a hardcoded default.
		*/
		componentGroupPlausibilityCaps: Type.Partial(Type.Record(Type.Enum(MfhMeasureComponentGroupId), Type.Object({ max: Type.Number({
			minimum: 0,
			maximum: 1
		}) }))),
		defaultMeasureComponent: Type.Array(Type.Object({
			yearStart: Type.Number(),
			yearEnd: Type.Number(),
			components: Type.Array(Type.Object({
				component: Type.Enum(MfhMeasureComponent),
				defaultCatalogId: Type.String()
			}))
		})),
		/** Editable thematic grouping of measure components used by the dashboard + config UI. */
		componentGroups: Type.Array(MfhMeasureComponentGroupSchema),
		/**
		* Roof area factor (pre-set based on roof shape): the ratio of roof area to building
		* footprint area. Used to derive `roofArea = footprintArea × factor`. Editable per
		* {@link RoofShape} in the Parameters config UI.
		*/
		roofAreaFactorPerShape: Type.Record(Type.Enum(RoofShape), Type.Number({ minimum: 0 })),
		/**
		* PV rooftop factors per {@link RoofShape} (SKB-1060). `usableRoofAreaFactor` is the share (0–1) of
		* the roof area usable for PV modules (drives the kWp pre-fill), and `yieldFactor` (0–1) derates the
		* regional specific yield for the roof geometry / orientation. Optional for backward compatibility;
		* when absent the PV generation / pre-fill treat both factors as 1.
		*/
		pvRoofTypeFactorPerShape: Type.Optional(Type.Record(Type.Enum(RoofShape), Type.Object({
			usableRoofAreaFactor: Type.Number({ minimum: 0 }),
			yieldFactor: Type.Number({ minimum: 0 })
		}))),
		/**
		* PV regional specific yield (kWh/kWp·a) keyed by city string (SKB-1060), plus a single Germany-wide
		* fallback scalar (975 kWh/kWp·a) used when a scenario's city is not present in the per-city table.
		* Both optional for backward compatibility.
		*/
		pvSpecificYieldPerCity: Type.Optional(Type.Record(Type.String(), Type.Number({ minimum: 0 }))),
		pvSpecificYieldFallback: Type.Optional(Type.Number({ minimum: 0 })),
		/**
		* Temperature Correction Factor per heat-transferring envelope surface (SKB-1075). Multiplied with
		* each surface's U-value × area in the specific transmission heat loss calculation. Optional for
		* backward compatibility; seeded + backfilled by data migration with the GEG defaults (freestanding
		* facade 1.0, non-freestanding facade 0.5, windows 1.0, roof 1.0, top-floor ceiling 0.5, cellar
		* ceiling 0.5, thermal bridge 1.0).
		*/
		temperatureCorrectionFactorPerSurface: Type.Optional(Type.Record(Type.Enum(MfhEnvelopeSurface), Type.Number({ minimum: 0 }))),
		/**
		* Per-component multiplier applied to useful-heat-demand savings, PV generation and ventilation
		* savings (SKB-1090). Missing entries fall back to 1 so historical scenario snapshots remain
		* reproducible after rollout.
		*/
		componentCorrectionFactorPerComponent: Type.Optional(Type.Partial(Type.Record(Type.Enum(MfhMeasureComponent), Type.Number({ minimum: 0 })))),
		/**
		* Reference-building parameters (SKB-1075) used by the separate reference-building run to derive the
		* subsidy `*_percent_of_reference` ratios. Optional for backward compatibility; seeded + backfilled
		* by data migration with the GEG / Anlage 1 defaults. See {@link MfhReferenceBuildingParamsSchema}.
		*/
		referenceBuildingParams: Type.Optional(MfhReferenceBuildingParamsSchema),
		/**
		* Sequential cost markups (SKB-1079) applied on top of the risk-adjusted CAPEX to arrive at the
		* total project cost. Each markup is a fraction (e.g. 0.225 = +22.5 %) applied multiplicatively to
		* the running subtotal in a fixed order:
		*  1. {@link MfhCostMarkupsSchema.gcSurcharge} — general contractor surcharge on the raw (risk-adjusted) CAPEX
		*  2. {@link MfhCostMarkupsSchema.ancillaryConstruction} — ancillary construction costs (Baunebenkosten) on the subtotal incl. GC surcharge
		*  3. {@link MfhCostMarkupsSchema.contingencyBuffer} — contingency buffer (Puffer) on the subtotal incl. GC surcharge + ancillary costs
		*
		* Optional for backward compatibility; when absent the calculator applies no markups (all factors
		* treated as 0). Seeded + backfilled with the spec defaults (0.225 / 0.18 / 0.10).
		*/
		costMarkups: Type.Optional(MfhCostMarkupsSchema),
		/**
		* Funding-program / subsidy evaluation parameters. Always present on the live active config and on
		* every scenario `config` snapshot after create / copy / resync / data migration. Typed optional
		* only so SQL remains nullable across migration ordering; use cases assert it is present.
		*/
		subsidyConfig: Type.Optional(MfhEnergyEfficiencySubsidyConfigSchema),
		createdAt: TStringDate(),
		updatedAt: TStringDate()
	});
	MfhEnergyEfficiencyWarningType = /* @__PURE__ */ function(MfhEnergyEfficiencyWarningType) {
		MfhEnergyEfficiencyWarningType["Config"] = "Config";
		MfhEnergyEfficiencyWarningType["EnergyCalculation"] = "EnergyCalculation";
		return MfhEnergyEfficiencyWarningType;
	}({});
	MfhEnergyEfficiencyWarningCode = /* @__PURE__ */ function(MfhEnergyEfficiencyWarningCode) {
		MfhEnergyEfficiencyWarningCode["MissingFinalEnergyBaseline"] = "MissingFinalEnergyBaseline";
		MfhEnergyEfficiencyWarningCode["NoCityProvided"] = "NoCityProvided";
		MfhEnergyEfficiencyWarningCode["NoHeatingDegreeHoursForCity"] = "NoHeatingDegreeHoursForCity";
		MfhEnergyEfficiencyWarningCode["NoEnergySourceProvided"] = "NoEnergySourceProvided";
		MfhEnergyEfficiencyWarningCode["NoEnergyCostForSource"] = "NoEnergyCostForSource";
		MfhEnergyEfficiencyWarningCode["MeasureNoLivePrice"] = "MeasureNoLivePrice";
		MfhEnergyEfficiencyWarningCode["MeasureInvalidQuantity"] = "MeasureInvalidQuantity";
		MfhEnergyEfficiencyWarningCode["NoLivePriceConfigured"] = "NoLivePriceConfigured";
		MfhEnergyEfficiencyWarningCode["NoRiskFactorForYear"] = "NoRiskFactorForYear";
		MfhEnergyEfficiencyWarningCode["NoPreStateHeatingSnapshot"] = "NoPreStateHeatingSnapshot";
		MfhEnergyEfficiencyWarningCode["PreStateHeatingNoUsableEfficiency"] = "PreStateHeatingNoUsableEfficiency";
		MfhEnergyEfficiencyWarningCode["PreStateHeatingEfficiencyInvalid"] = "PreStateHeatingEfficiencyInvalid";
		MfhEnergyEfficiencyWarningCode["NoPreStateUValue"] = "NoPreStateUValue";
		MfhEnergyEfficiencyWarningCode["NoPostStateUValue"] = "NoPostStateUValue";
		MfhEnergyEfficiencyWarningCode["PostUValueNotLowerThanPre"] = "PostUValueNotLowerThanPre";
		MfhEnergyEfficiencyWarningCode["NoThermalBridgeSavingFactor"] = "NoThermalBridgeSavingFactor";
		MfhEnergyEfficiencyWarningCode["ThermalBridgeSavingFactorCapped"] = "ThermalBridgeSavingFactorCapped";
		MfhEnergyEfficiencyWarningCode["NoFinalEnergyBaselineAllSkipped"] = "NoFinalEnergyBaselineAllSkipped";
		MfhEnergyEfficiencyWarningCode["NoHeatingDegreeHoursForCityUValueSkipped"] = "NoHeatingDegreeHoursForCityUValueSkipped";
		MfhEnergyEfficiencyWarningCode["NoCityUValueSavingsSkipped"] = "NoCityUValueSavingsSkipped";
		MfhEnergyEfficiencyWarningCode["HeatingDegreeHoursUnavailableSavingZero"] = "HeatingDegreeHoursUnavailableSavingZero";
		MfhEnergyEfficiencyWarningCode["EnergySavingCapped"] = "EnergySavingCapped";
		MfhEnergyEfficiencyWarningCode["TotalHeatDemandSavingCapped"] = "TotalHeatDemandSavingCapped";
		MfhEnergyEfficiencyWarningCode["NoUsableHeatingSystemEfficiencyFinalEnergy"] = "NoUsableHeatingSystemEfficiencyFinalEnergy";
		MfhEnergyEfficiencyWarningCode["FinalHeatingEfficiencyInvalid"] = "FinalHeatingEfficiencyInvalid";
		MfhEnergyEfficiencyWarningCode["NoEfficiencyUpliftInSnapshot"] = "NoEfficiencyUpliftInSnapshot";
		MfhEnergyEfficiencyWarningCode["NoUsableHeatingEfficiencyForLabel"] = "NoUsableHeatingEfficiencyForLabel";
		MfhEnergyEfficiencyWarningCode["NoUsableHeatingEfficiencyForHeatingMeasure"] = "NoUsableHeatingEfficiencyForHeatingMeasure";
		MfhEnergyEfficiencyWarningCode["HeatDemandUnavailableForLabel"] = "HeatDemandUnavailableForLabel";
		MfhEnergyEfficiencyWarningCode["PreRenovationHeatDemandUnavailable"] = "PreRenovationHeatDemandUnavailable";
		MfhEnergyEfficiencyWarningCode["VentilationNeedsPreHeatDemand"] = "VentilationNeedsPreHeatDemand";
		MfhEnergyEfficiencyWarningCode["NoVentilationLossShare"] = "NoVentilationLossShare";
		MfhEnergyEfficiencyWarningCode["NoFinalEnergyDemandPerM2Expansion"] = "NoFinalEnergyDemandPerM2Expansion";
		MfhEnergyEfficiencyWarningCode["NoNewFloorAreaQuantity"] = "NoNewFloorAreaQuantity";
		MfhEnergyEfficiencyWarningCode["NoPvPeakPowerQuantity"] = "NoPvPeakPowerQuantity";
		MfhEnergyEfficiencyWarningCode["NoPvSpecificYield"] = "NoPvSpecificYield";
		MfhEnergyEfficiencyWarningCode["NoPrimaryEnergyFactorElectricityPv"] = "NoPrimaryEnergyFactorElectricityPv";
		MfhEnergyEfficiencyWarningCode["PvNoBatteryCreditCap"] = "PvNoBatteryCreditCap";
		MfhEnergyEfficiencyWarningCode["NoFinalEnergyBaselineScenarioTotal"] = "NoFinalEnergyBaselineScenarioTotal";
		MfhEnergyEfficiencyWarningCode["PostHeatDemandUnavailableScenarioTotal"] = "PostHeatDemandUnavailableScenarioTotal";
		MfhEnergyEfficiencyWarningCode["PostFinalEnergyCappedAtPre"] = "PostFinalEnergyCappedAtPre";
		MfhEnergyEfficiencyWarningCode["NoFactorForPreStateCarrier"] = "NoFactorForPreStateCarrier";
		MfhEnergyEfficiencyWarningCode["NoFactorForPostStateCarrier"] = "NoFactorForPostStateCarrier";
		MfhEnergyEfficiencyWarningCode["NoEnvelopeSurfaceArea"] = "NoEnvelopeSurfaceArea";
		MfhEnergyEfficiencyWarningCode["NoHeatingDegreeHoursForCityReferenceSkipped"] = "NoHeatingDegreeHoursForCityReferenceSkipped";
		MfhEnergyEfficiencyWarningCode["NoCityReferencePrimaryEnergySkipped"] = "NoCityReferencePrimaryEnergySkipped";
		MfhEnergyEfficiencyWarningCode["ReferenceFinalSystemEfficiencyInvalid"] = "ReferenceFinalSystemEfficiencyInvalid";
		return MfhEnergyEfficiencyWarningCode;
	}({});
	MfhEnergyEfficiencyWarningSchema = Type.Object({
		errorCode: Type.Enum(MfhEnergyEfficiencyWarningCode),
		type: Type.Enum(MfhEnergyEfficiencyWarningType),
		payload: Type.Record(Type.String(), Type.Unknown())
	});
	MfhMeasureComponentEnergyParamsSchema = Type.Partial(Type.Object({
		/** Share (0–1) of the useful heat demand attributable to ventilation losses (ventilation baseline + delta). */
		ventilationLossShare: TNullable(Type.Number({ minimum: 0 })),
		/** Share (0–1) of the ventilated area served by the mechanical ventilation with heat recovery (ventilation delta). */
		servedAreaShare: TNullable(Type.Number({ minimum: 0 })),
		/** Heat-recovery efficiency (0–1) of the ventilation unit (ventilation delta). */
		heatRecoveryEfficiency: TNullable(Type.Number({ minimum: 0 })),
		/** Auxiliary electricity consumed per residential unit per year (kWh/WE·a) by the ventilation unit (ventilation delta). */
		auxElectricityKwhPerWeA: TNullable(Type.Number({ minimum: 0 }))
	}));
	MfhMeasureComponentPrefillRule = /* @__PURE__ */ function(MfhMeasureComponentPrefillRule) {
		MfhMeasureComponentPrefillRule["GrossFloorArea"] = "GrossFloorArea";
		MfhMeasureComponentPrefillRule["NetFacadeArea"] = "NetFacadeArea";
		MfhMeasureComponentPrefillRule["ThermalBridgeArea"] = "ThermalBridgeArea";
		MfhMeasureComponentPrefillRule["WindowArea"] = "WindowArea";
		MfhMeasureComponentPrefillRule["FootprintArea"] = "FootprintArea";
		/** Footprint area × {@link MfhMeasureComponentPrefill.value}. */
		MfhMeasureComponentPrefillRule["FootprintAreaTimesStoreys"] = "FootprintAreaTimesStoreys";
		MfhMeasureComponentPrefillRule["RoofArea"] = "RoofArea";
		MfhMeasureComponentPrefillRule["PvRoofKwp"] = "PvRoofKwp";
		MfhMeasureComponentPrefillRule["SolarThermalArea"] = "SolarThermalArea";
		MfhMeasureComponentPrefillRule["NumberOfBuildings"] = "NumberOfBuildings";
		MfhMeasureComponentPrefillRule["ResidentialPlusCommercial"] = "ResidentialPlusCommercial";
		MfhMeasureComponentPrefillRule["NumberOfBalconies"] = "NumberOfBalconies";
		MfhMeasureComponentPrefillRule["UndergroundParkingSpaces"] = "UndergroundParkingSpaces";
		MfhMeasureComponentPrefillRule["VentilationQuantity"] = "VentilationQuantity";
		/** Returns {@link MfhMeasureComponentPrefill.value} directly. Replaces the old fixed one-unit rule. */
		MfhMeasureComponentPrefillRule["CustomValue"] = "CustomValue";
		return MfhMeasureComponentPrefillRule;
	}({});
	MfhMeasureComponentPrefillSchema = Type.Union([
		Type.Object({ rule: TStringEnum([
			"GrossFloorArea",
			"NetFacadeArea",
			"ThermalBridgeArea",
			"WindowArea",
			"FootprintArea",
			"RoofArea",
			"PvRoofKwp",
			"SolarThermalArea",
			"NumberOfBuildings",
			"ResidentialPlusCommercial",
			"NumberOfBalconies",
			"UndergroundParkingSpaces",
			"VentilationQuantity"
		]) }),
		Type.Object({
			rule: TStringEnum(["FootprintAreaTimesStoreys"]),
			value: Type.Number({ exclusiveMinimum: 0 })
		}),
		Type.Object({
			rule: TStringEnum(["CustomValue"]),
			value: Type.Number({ minimum: 0 })
		})
	]);
	MfhMeasureComponentCatalogueItemSchema = Type.Object({
		mfhMeasureComponentCatalogueItemId: Type.Number(),
		component: Type.Enum(MfhMeasureComponent),
		/** Stable string id, e.g. `WIN_TRIPLE_THERMAL`. Immutable once created. */
		catalogId: Type.String(),
		/** User-editable display name (German). Free text; sole source of the display label. */
		label: Type.String(),
		flags: TNullable(Type.Array(Type.Enum(MfhMeasureComponentFlag))),
		unit: TNullable(Type.Enum(MfhMeasureComponentUnit)),
		capexUnit: TNullable(Type.Enum(MfhMeasureComponentUnit)),
		liveMin: TNullable(Type.Number()),
		liveAvg: TNullable(Type.Number()),
		liveMax: TNullable(Type.Number()),
		isEnergy: TNullable(Type.Boolean()),
		modelType: TNullable(Type.Enum(MfhMeasureComponentEnergyModelType)),
		performance: TNullable(Type.Number()),
		/**
		* Structured energy-performance parameters (SKB-1060) used by model types that need more than the
		* single {@link performance} scalar (ventilation, roof expansion). Nullable/optional for backward
		* compatibility — legacy rows leave it null and keep using `performance`.
		*/
		energyParams: Type.Optional(TNullable(MfhMeasureComponentEnergyParamsSchema)),
		/**
		* Quantity pre-fill for this catalogue row. Null or absent means the measure is not prefilled.
		* Optional so scenario catalogues saved before the column still validate.
		*/
		prefillRule: Type.Optional(TNullable(MfhMeasureComponentPrefillSchema)),
		/**
		* Energy source this heating catalogue row represents. Set only on {@link MfhMeasureComponent.HeatingSystem}
		* items; the matching pre-state row is the Heating System prefill for a scenario with that energy source.
		* Optional so catalogues saved before the column still validate.
		*/
		energySource: Type.Optional(TNullable(TEnum(HeatingSource))),
		notes: TNullable(Type.String()),
		createdAt: TStringDate(),
		updatedAt: TStringDate()
	});
	MfhEnergyEfficiencyInputsSchema = Type.Object({
		name: TNullable(Type.String()),
		address: TNullable(Type.String()),
		city: TNullable(Type.String()),
		buildingType: TNullable(TEnum(MfhBuildingType)),
		yearBuilt: Type.Number(),
		lastMajorRefurbishmentYear: TNullable(Type.Number()),
		heritageProtected: TNullable(Type.Boolean()),
		/** Legacy; no longer edited in UI — age class from yearBuilt + config replaces it. */
		buildingClass: TNullable(TEnum(MfhBuildingClass)),
		roofShape: TNullable(TEnum(RoofShape)),
		plotArea: TNullable(Type.Number()),
		footprintArea: TNullable(Type.Number()),
		storiesAboveGround: TNullable(Type.Number()),
		grossFloorArea: TNullable(Type.Number()),
		/**
		* Pre-renovation total rentable area (m²). Prefilled from the asset's Total Rentable Space
		* (`attributes.totalRentableSpace`). Denominator for General / Energetic CAPEX €/m² and part of
		* the Total CAPEX €/m² area.
		*/
		totalRentableArea: Type.Optional(TNullable(Type.Number({ minimum: 0 }))),
		residentialUnits: TNullable(Type.Number()),
		/** Commercial units on the asset. Combined with {@link residentialUnits} for pipe-renovation, ventilation, and air-source heat-pump quantity pre-fill. */
		commercialUnits: TNullable(Type.Number()),
		parkingSpaces: TNullable(Type.Number()),
		/**
		* Units whose apartment type is Underground Parking. Drives TG-Sanierung quantity pre-fill.
		* Distinct from {@link parkingSpaces}, which counts every parking type.
		*/
		undergroundParkingSpaces: Type.Optional(TNullable(Type.Number())),
		/** Number of balconies on the asset. Drives balcony-slab quantity pre-fill. */
		numberOfBalconies: TNullable(Type.Number()),
		/** Number of buildings in the asset. Drives the default quantity for per-building measures (e.g. doors, pellet heating, ground-source heat pumps). */
		numberOfBuildings: TNullable(Type.Number()),
		facadeGrossArea: TNullable(Type.Number()),
		/** Brick facade area eligible for IFB supplementary funding (m²). Kept separate from total facade geometry. */
		brickFacadeArea: Type.Optional(TNullable(Type.Number({ minimum: 0 }))),
		/** Syte: facade_surface_area_lod2_uncovered — free-standing (uncovered) facade gross area (m²). Drives the freestanding vs non-freestanding facade split in the transmission-loss calculation. */
		freeStandingFacadeGrossArea: TNullable(Type.Number()),
		facadeNetArea: TNullable(Type.Number()),
		/** Share (0–1) of the facade already insulated; the remainder drives facade-insulation quantity pre-fill. */
		facadeInsulationRate: TNullable(Type.Number()),
		windowToFacadeRatio: TNullable(Type.Number()),
		windowArea: TNullable(Type.Number()),
		roofFactor: TNullable(Type.Number()),
		roofArea: TNullable(Type.Number()),
		/** Syte: enveloping_surface_area_lod2 — building envelope surface area (m²) */
		envelopeSurfaceArea: TNullable(Type.Number()),
		/** Syte: volume — building volume (m³) */
		volume: TNullable(Type.Number()),
		/** @deprecated Use `volume` instead */
		heatedVolume: TNullable(Type.Number()),
		/** Pre-construction primary energy demand in kWh/a. */
		currentPrimaryEnergyConsumption: TNullable(Type.Number()),
		/** Pre-construction final energy demand in kWh/a. */
		currentFinalEnergyConsumption: TNullable(Type.Number()),
		/** Pre-construction end energy demand in kWh/m²a. Prefilled from the asset `endEnergyDemand`. */
		currentEndEnergyDemandPerSqm: Type.Optional(TNullable(Type.Number())),
		energySource: TNullable(TEnum(HeatingSource)),
		currentHeatingType: TNullable(Type.String())
	});
	MfhEnergyEfficiencyComponentSnapshotSchema = Type.Intersect([Type.Object({ catalogId: Type.String() }), Type.Partial(Type.Omit(MfhMeasureComponentCatalogueItemSchema, [
		"mfhMeasureComponentCatalogueItemId",
		"createdAt",
		"updatedAt",
		"component",
		"catalogId",
		"label",
		"prefillRule",
		"energySource"
	]))]);
	MfhEnergyEfficiencyScenarioPostComponentSchema = Type.Intersect([MfhEnergyEfficiencyComponentSnapshotSchema, Type.Object({
		quantity: TNullable(Type.Number()),
		bucket: Type.Optional(Type.Enum(MfhCapexBudgetBucket))
	})]);
	MfhEnergyEfficiencyScenarioComponentSchema = Type.Object({
		component: Type.Enum(MfhMeasureComponent),
		pre: Type.Union([MfhEnergyEfficiencyComponentSnapshotSchema, Type.Null()]),
		post: Type.Union([MfhEnergyEfficiencyScenarioPostComponentSchema, Type.Null()])
	});
	MfhEnergyEfficiencyComponentInputSchema = Type.Object({
		component: Type.Enum(MfhMeasureComponent),
		preCatalogId: TNullable(Type.String()),
		postCatalogId: TNullable(Type.String()),
		/** Planned quantity for the selected post measure (CAPEX = quantity × entry.liveAvg). */
		quantity: TNullable(Type.Number()),
		/** CAPEX budget bucket the selected post measure rolls up into; falls back to {@link DEFAULT_BUDGET_BUCKET_BY_COMPONENT}. */
		bucket: Type.Optional(Type.Enum(MfhCapexBudgetBucket)),
		/** Number of floors created by a roof conversion, roof expansion, or separate new build. */
		newFloors: Type.Optional(TNullable(Type.Number({ minimum: 0 }))),
		/** New residential units created within the measure's heated area. */
		newApartmentsInHeatedArea: Type.Optional(TNullable(Type.Number({ minimum: 0 }))),
		/** Measure-specific rentable area (NGF), normally prefilled as 82% of quantity/BGF. */
		measureNetFloorArea: Type.Optional(TNullable(Type.Number({ minimum: 0 })))
	});
	MfhScenarioCatalogueDuplicateError = class extends ValidationFailedError {
		catalogIds;
		constructor(catalogIds) {
			super(`MFH scenario catalogue has duplicate catalogIds: ${catalogIds.join(", ")}`, { catalogIds });
			this.catalogIds = catalogIds;
			this.name = "MfhScenarioCatalogueDuplicateError";
		}
	};
	MfhScenarioCatalogueUnresolvedError = class extends ValidationFailedError {
		catalogIds;
		constructor(catalogIds) {
			super(`MFH scenario selection references catalogIds missing from the scenario catalogue: ${catalogIds.join(", ")}`, { catalogIds });
			this.catalogIds = catalogIds;
			this.name = "MfhScenarioCatalogueUnresolvedError";
		}
	};
	MfhEnergyEfficiencyOutputSchema = Type.Object({
		calculatedAt: Type.String(),
		capex: Type.Object({
			totalMin: Type.Number(),
			totalAvg: Type.Number(),
			totalMax: Type.Number(),
			totalRiskAdjustedMin: Type.Number(),
			totalRiskAdjustedAvg: Type.Number(),
			totalRiskAdjustedMax: Type.Number(),
			riskFactorImpactMin: Type.Number(),
			riskFactorImpactAvg: Type.Number(),
			riskFactorImpactMax: Type.Number(),
			splitByComponent: Type.Array(Type.Object({
				component: Type.Enum(MfhMeasureComponent),
				min: Type.Number(),
				avg: Type.Number(),
				max: Type.Number(),
				riskAdjustedMin: Type.Number(),
				riskAdjustedAvg: Type.Number(),
				riskAdjustedMax: Type.Number()
			})),
			/**
			* Sequential cost markups applied on top of the risk-adjusted CAPEX (SKB-1079). Each entry
			* reports the markup fraction and the running subtotal (min / avg / max) after applying it, so
			* the UI can show each intermediate value as its own line. `measuresTotal*` is the base
			* (risk-adjusted CAPEX before any markup) and `total*` is the final project cost after all three
			* markups. `effectiveTotalFactor` is `total / measuresTotal` on the avg tier (≈1.59 with the
			* default 0.225 / 0.18 / 0.10 markups).
			*/
			costMarkups: Type.Object({
				measuresTotalMin: Type.Number(),
				measuresTotalAvg: Type.Number(),
				measuresTotalMax: Type.Number(),
				gcSurchargePct: Type.Number(),
				afterGcSurchargeMin: Type.Number(),
				afterGcSurchargeAvg: Type.Number(),
				afterGcSurchargeMax: Type.Number(),
				ancillaryConstructionPct: Type.Number(),
				afterAncillaryConstructionMin: Type.Number(),
				afterAncillaryConstructionAvg: Type.Number(),
				afterAncillaryConstructionMax: Type.Number(),
				contingencyBufferPct: Type.Number(),
				totalMin: Type.Number(),
				totalAvg: Type.Number(),
				totalMax: Type.Number(),
				effectiveTotalFactor: Type.Number()
			})
		}),
		energy: Type.Object({
			/** Pre-renovation useful heat demand (kWh/a). Roof expansion does not apply to the pre-state. */
			preHeatDemand: TNullable(Type.Number()),
			/** Post-renovation useful heat demand for the existing building (excl. roof expansion), kWh/a. */
			postHeatDemandExclExpansion: TNullable(Type.Number()),
			/** Uncapped useful heat demand saving for the existing building (excl. roof expansion), kWh/a. */
			rawHeatDemandSavingAbsExclExpansion: TNullable(Type.Number()),
			/** Capped useful heat demand saving for the existing building (excl. roof expansion), kWh/a. */
			heatDemandSavingAbsExclExpansion: TNullable(Type.Number()),
			/** Useful heat demand saving share for the existing building (excl. roof expansion). */
			heatDemandSavingPctExclExpansion: TNullable(Type.Number()),
			/** Pre-renovation final energy demand (kWh/a). */
			preFinalEnergyDemand: TNullable(Type.Number()),
			/**
			* Item 5 — existing-building view (EXCLUDES roof expansion). PV does not affect final energy,
			* cost, or CO₂. Primary-energy fields below include an explicit InclPv / ExclPv qualifier.
			*/
			postFinalEnergyDemandExclExpansion: TNullable(Type.Number()),
			finalEnergySavingAbsExclExpansion: TNullable(Type.Number()),
			finalEnergySavingPctExclExpansion: TNullable(Type.Number()),
			annualEnergyCostSavingExclExpansion: TNullable(Type.Number()),
			annualEnergyCostSavingPctExclExpansion: TNullable(Type.Number()),
			/** Pre-renovation CO₂ emissions (kg/a). */
			preCo2: TNullable(Type.Number()),
			postCo2ExclExpansion: TNullable(Type.Number()),
			co2SavingAbsExclExpansion: TNullable(Type.Number()),
			co2SavingPctExclExpansion: TNullable(Type.Number()),
			/** Pre-renovation primary energy demand (kWh primary/a). */
			prePrimaryEnergyDemand: Type.Optional(TNullable(Type.Number())),
			/** Post primary energy before PV credit, existing building only (kWh primary/a). */
			postPrimaryEnergyDemandExclExpansionExclPv: Type.Optional(TNullable(Type.Number())),
			/** Primary energy saving before PV credit, existing building only (kWh primary/a). */
			primaryEnergySavingAbsExclExpansionExclPv: Type.Optional(TNullable(Type.Number())),
			/** Primary energy saving before PV credit as a share of pre primary energy, existing building only. */
			primaryEnergySavingPctExclExpansionExclPv: Type.Optional(TNullable(Type.Number())),
			/** Primary energy saving after PV credit, existing building only (kWh primary/a). */
			primaryEnergySavingAbsExclExpansionInclPv: TNullable(Type.Number()),
			/** Primary energy saving after PV credit as a share of pre primary energy, existing building only. */
			primaryEnergySavingPctExclExpansionInclPv: TNullable(Type.Number()),
			/**
			* Item 5 — existing building + roof expansion (INCLUDES expansion demand on the post heat
			* carrier). Cost / CO₂ use the two-tariff bucket valuation (item 2). Primary-energy fields
			* include an explicit InclPv / ExclPv qualifier.
			*/
			postFinalEnergyDemandInclExpansion: TNullable(Type.Number()),
			finalEnergySavingAbsInclExpansion: TNullable(Type.Number()),
			finalEnergySavingPctInclExpansion: TNullable(Type.Number()),
			annualEnergyCostSavingInclExpansion: TNullable(Type.Number()),
			annualEnergyCostSavingPctInclExpansion: TNullable(Type.Number()),
			postCo2InclExpansion: TNullable(Type.Number()),
			co2SavingAbsInclExpansion: TNullable(Type.Number()),
			co2SavingPctInclExpansion: TNullable(Type.Number()),
			/** Post primary energy after PV credit, including roof expansion (kWh primary/a). */
			postPrimaryEnergyDemandInclExpansionInclPv: TNullable(Type.Number()),
			/** Primary energy saving after PV credit, including roof expansion (kWh primary/a). */
			primaryEnergySavingAbsInclExpansionInclPv: TNullable(Type.Number()),
			/** Primary energy saving after PV credit as a share of pre primary energy, including roof expansion. */
			primaryEnergySavingPctInclExpansionInclPv: TNullable(Type.Number()),
			/** Roof-expansion added final energy demand (kWh/a) on the post heat carrier; 0 when no expansion. */
			expansionFinalEnergyDemand: TNullable(Type.Number()),
			/**
			* Total surface used as the denominator for per-m² KPIs that include expansion (m²):
			* `grossFloorArea + roofExpansion.quantity` (existing gross floor area plus the planned
			* roof-expansion new floor area). Equals {@link referenceFloorArea}. Null when the gross
			* floor area is unavailable.
			*/
			totalFloorAreaInclExpansion: TNullable(Type.Number()),
			/**
			* Per-m² KPI variants. Values including roof expansion use {@link totalFloorAreaInclExpansion};
			* heat-demand saving uses gross floor area excluding expansion. Null when the KPI or its
			* denominator is unavailable.
			*/
			perSqm: Type.Optional(Type.Object({
				/** Risk-adjusted CAPEX (avg) per m² (€/m²), denominator includes expansion floor area. */
				capexRiskAdjustedAvg: TNullable(Type.Number()),
				/** Heat demand saving per m² (kWh/m²a), divided by gross floor area excluding expansion. */
				heatDemandSavingAbsExclExpansion: TNullable(Type.Number()),
				/** Final energy saving per m² incl. roof expansion (kWh/m²a). */
				finalEnergySavingAbsInclExpansion: TNullable(Type.Number()),
				/** Annual energy cost saving per m² incl. roof expansion (€/m²a). */
				annualEnergyCostSavingInclExpansion: TNullable(Type.Number()),
				/** Primary energy saving per m² incl. roof expansion, after PV credit (kWh/m²a). */
				primaryEnergySavingAbsInclExpansionInclPv: TNullable(Type.Number()),
				/** CO2 saving per m² incl. roof expansion (kg/m²a). */
				co2SavingAbsInclExpansion: TNullable(Type.Number())
			})),
			/** Post-state energy carrier used to value cost / CO2 / primary-energy savings. */
			carrier: TNullable(Type.Enum(HeatingSource)),
			/**
			* Gross floor area plus planned roof-expansion floor area (m²); denominator for final-energy
			* intensity and energy-class derivation.
			*/
			referenceFloorArea: TNullable(Type.Number()),
			/**
			* PV renewable-energy production (SKB-1060), populated only when a {@link MfhMeasureComponentEnergyModelType.PvGeneration}
			* measure is selected; otherwise null.
			*/
			/** Estimated gross on-site PV generation (kWh/a): kWp × city yield × roof-type yield. */
			estimatedPvGenerationKwh: TNullable(Type.Number()),
			/** PV generation credited to the building's primary energy (kWh/a of avoided grid electricity), after the 30% no-battery cap. */
			pvCappedKwh: TNullable(Type.Number()),
			/** PV primary-energy credit (kWh primary/a) subtracted from the post primary energy demand: min(generation × PEF(Strom), 30% of post primary energy before PV). */
			pvPrimaryEnergyCreditKwh: TNullable(Type.Number()),
			/**
			* SKB-1075 — subsidy reference data points. Geometry includes planned roof expansion. The
			* scenario post specific transmission heat loss and primary energy demand are compared against
			* a virtual GEG reference building (identical geometry, fixed standard envelope + system
			* spec) to produce the two `*PercentOfReference` ratios consumed by subsidy quantification.
			* Null when geometry / config is insufficient to compute them.
			*/
			/** Scenario hot water heat demand (kWh/a) on living area including planned roof expansion. */
			hotWaterHeatDemandInclExpansion: TNullable(Type.Number()),
			/** Scenario post specific transmission heat loss including expansion geometry, W/(m²·K). */
			specificTransmissionHeatLossInclExpansion: TNullable(Type.Number()),
			/** Reference-building specific transmission heat loss including expansion geometry, W/(m²·K). */
			referenceSpecificTransmissionHeatLossInclExpansion: TNullable(Type.Number()),
			/** Reference-building primary energy demand including expansion geometry, before PV (kWh/a). */
			referencePrimaryEnergyDemandInclExpansionExclPv: TNullable(Type.Number()),
			/** Scenario specific transmission heat loss ÷ reference (both include expansion geometry). */
			transmissionHeatLossPercentOfReference: TNullable(Type.Number()),
			/**
			* Scenario primary energy demand (incl. expansion, after PV credit) ÷ reference primary energy
			* demand. Used for KfW Effizienzhaus-stage assessment.
			*/
			primaryEnergyDemandInclExpansionInclPvPercentOfReference: Type.Optional(TNullable(Type.Number())),
			/**
			* Scenario primary energy demand (incl. expansion, before PV credit) ÷ reference primary energy
			* demand. Used for IFB Effizienzhaus-stage assessment.
			*/
			primaryEnergyDemandInclExpansionExclPvPercentOfReference: Type.Optional(TNullable(Type.Number()))
		}),
		measures: Type.Array(Type.Object({
			catalogId: Type.String(),
			component: Type.Enum(MfhMeasureComponent),
			capexMin: Type.Number(),
			capexAvg: Type.Number(),
			capexMax: Type.Number(),
			riskAdjustedCapexMin: Type.Number(),
			riskAdjustedCapexAvg: Type.Number(),
			riskAdjustedCapexMax: Type.Number(),
			rawHeatDemandSavingKwhPerYear: TNullable(Type.Number()),
			cappedHeatDemandSavingKwhPerYear: TNullable(Type.Number()),
			finalHeatDemandKwhPerYear: TNullable(Type.Number()),
			finalEnergySavingKwhPerYear: TNullable(Type.Number()),
			warnings: Type.Array(MfhEnergyEfficiencyWarningSchema)
		})),
		/** Optional only for persisted pre-SKB-1093 outputs; new calculations always populate all six results once evaluators are wired. */
		matchedSubsidyPrograms: Type.Optional(Type.Array(MatchedSubsidyProgramSchema)),
		warnings: Type.Array(MfhEnergyEfficiencyWarningSchema)
	});
	MfhEnergyEfficiencyScenarioStatus = /* @__PURE__ */ function(MfhEnergyEfficiencyScenarioStatus) {
		MfhEnergyEfficiencyScenarioStatus["Draft"] = "draft";
		MfhEnergyEfficiencyScenarioStatus["Final"] = "final";
		return MfhEnergyEfficiencyScenarioStatus;
	}({});
	MfhEnergyEfficiencyScenarioSchema = Type.Object({
		mfhEnergyEfficiencyScenarioId: Type.Number(),
		mfhId: Type.Number(),
		name: Type.String(),
		description: TNullable(Type.String()),
		status: Type.Enum(MfhEnergyEfficiencyScenarioStatus),
		mfhInputs: Type.Partial(MfhEnergyEfficiencyInputsSchema),
		/**
		* Scenario-owned full copy of the measure catalogue (every entry). Edited on the Config > Measure
		* Catalogue tab; refreshed as a whole by copy / resync "latest catalogue" flows. Decoupled from
		* {@link componentInputs} so catalogue edits never touch selections and vice versa.
		*/
		componentCatalogue: Type.Array(MfhMeasureComponentCatalogueItemSchema),
		/**
		* Per-component selections (pre/post catalogIds + post quantity/bucket). Edited on the
		* Details > Component Selection tab. References entries in {@link componentCatalogue} by catalogId.
		*/
		componentInputs: Type.Array(MfhEnergyEfficiencyComponentInputSchema),
		/**
		* Snapshot copy of the {@link MfhEnergyEfficiencyCalculationConfigSchema} the scenario calculates
		* from. Frozen at creation (and refreshable via the copy / resync flows) so calculation outputs stay
		* reproducible even when the live active config evolves. Always present: create / copy / resync always
		* populate it, and legacy rows were backfilled from the live active config by a data migration, so the
		* calculator reads it directly with no runtime fallback. The DB column stays nullable at the SQL level
		* only for migration ordering (add nullable → backfill → set NOT NULL). Includes
		* {@link MfhEnergyEfficiencyCalculationConfigSchema.subsidyConfig} after the subsidy-config merge.
		*/
		config: MfhEnergyEfficiencyCalculationConfigSchema,
		/** Live subsidy inputs. Optional only until scenario persistence is migrated by SKB-1093. */
		subsidyInputs: Type.Optional(MfhEnergyEfficiencySubsidyInputsSchema),
		/** User-selected programmes for downstream use; preliminary eligibility does not restrict selection. */
		selectedSubsidyProgramCodes: Type.Optional(Type.Array(Type.Enum(SubsidyProgramCode), { uniqueItems: true })),
		/** User-selected what-if variant per subsidy programme. */
		selectedSubsidyVariants: Type.Optional(Type.Array(SubsidyVariantSchema)),
		output: TNullable(MfhEnergyEfficiencyOutputSchema),
		createdAt: TStringDate(),
		updatedAt: TStringDate()
	});
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/capex-ee-calculator.opts.ts
var init_capex_ee_calculator_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/capex-ee-calculator.requests.ts
var FindMfhEnergyEfficiencyScenariosParamsSchema, FindMfhEnergyEfficiencyScenariosQuerySchema, GetMfhEnergyEfficiencyScenarioParamsSchema, GetMfhEnergyEfficiencyScenarioQuerySchema, CreateMfhEnergyEfficiencyScenarioParamsSchema, CreateMfhEnergyEfficiencyScenarioBodySchema, UpdateMfhEnergyEfficiencyScenarioParamsSchema, UpdateMfhEnergyEfficiencyScenarioBodySchema, CopyMfhEnergyEfficiencyScenarioParamsSchema, CopyMfhEnergyEfficiencyScenarioBodySchema, ResyncMfhEnergyEfficiencyScenarioParamsSchema, ResyncMfhEnergyEfficiencyScenarioBodySchema, UpdateMfhEnergyEfficiencyScenarioStatusParamsSchema, UpdateMfhEnergyEfficiencyScenarioStatusBodySchema, DeleteMfhEnergyEfficiencyScenarioParamsSchema, UpdateMfhEnergyEfficiencyCalculationConfigBodySchema, UpdateMfhMeasureComponentCatalogueItemParamsSchema, UpdateMfhMeasureComponentCatalogueItemBodySchema, CreateMfhMeasureComponentCatalogueItemBodySchema, DeleteMfhMeasureComponentCatalogueItemParamsSchema;
var init_capex_ee_calculator_requests = __esmMin((() => {
	init_shared_schemas();
	init_energy_efficiency();
	init_capex_ee_calculator_model();
	init_subsidy_inputs_model();
	init_subsidy_result_model();
	FindMfhEnergyEfficiencyScenariosParamsSchema = Type.Object({ mfhId: Type.Number() });
	FindMfhEnergyEfficiencyScenariosQuerySchema = Type.Object({ expand: Type.Optional(ExpandSchema) });
	GetMfhEnergyEfficiencyScenarioParamsSchema = Type.Object({ mfhEnergyEfficiencyScenarioId: Type.Number() });
	GetMfhEnergyEfficiencyScenarioQuerySchema = Type.Object({ expand: Type.Optional(ExpandSchema) });
	CreateMfhEnergyEfficiencyScenarioParamsSchema = Type.Object({ mfhId: Type.Number() });
	CreateMfhEnergyEfficiencyScenarioBodySchema = Type.Object({
		name: Type.String(),
		description: TNullable(Type.String())
	});
	UpdateMfhEnergyEfficiencyScenarioParamsSchema = Type.Object({ mfhEnergyEfficiencyScenarioId: Type.Number() });
	UpdateMfhEnergyEfficiencyScenarioBodySchema = Type.Object({
		name: Type.Optional(Type.String()),
		description: Type.Optional(TNullable(Type.String())),
		mfhInputs: Type.Optional(Type.Partial(MfhEnergyEfficiencyInputsSchema)),
		/**
		* Scenario-owned catalogue snapshot (Config > Measure Catalogue edits). Persisted independently of
		* {@link componentInputs}; present only when the catalogue changed. Never mutates the global catalogue.
		*/
		componentCatalogue: Type.Optional(Type.Array(MfhMeasureComponentCatalogueItemSchema)),
		/**
		* Per-component selections (Details > Component Selection edits). Persisted independently of
		* {@link componentCatalogue}; present only when a selection / quantity / bucket changed.
		*/
		componentInputs: Type.Optional(Type.Array(MfhEnergyEfficiencyComponentInputSchema)),
		/**
		* Edited snapshot of the calculation config stored on the scenario. When present it overwrites the
		* scenario's `config` snapshot so the next calculation runs from the edited copy (never touches the
		* live active config table). Never null — every scenario always owns a config snapshot; omit the field
		* to leave the existing snapshot untouched.
		*/
		config: Type.Optional(MfhEnergyEfficiencyCalculationConfigSchema),
		subsidyInputs: Type.Optional(MfhEnergyEfficiencySubsidyInputsSchema),
		selectedSubsidyProgramCodes: Type.Optional(Type.Array(Type.Enum(SubsidyProgramCode), { uniqueItems: true })),
		selectedSubsidyVariants: Type.Optional(Type.Array(SubsidyVariantSchema))
	});
	CopyMfhEnergyEfficiencyScenarioParamsSchema = Type.Object({ mfhEnergyEfficiencyScenarioId: Type.Number() });
	CopyMfhEnergyEfficiencyScenarioBodySchema = Type.Object({
		name: Type.String({ minLength: 1 }),
		refreshComponents: Type.Optional(Type.Boolean()),
		refreshConfig: Type.Optional(Type.Boolean())
	});
	ResyncMfhEnergyEfficiencyScenarioParamsSchema = Type.Object({ mfhEnergyEfficiencyScenarioId: Type.Number() });
	ResyncMfhEnergyEfficiencyScenarioBodySchema = Type.Object({
		isConfigResync: Type.Boolean(),
		isComponentsResync: Type.Boolean()
	});
	UpdateMfhEnergyEfficiencyScenarioStatusParamsSchema = Type.Object({ mfhEnergyEfficiencyScenarioId: Type.Number() });
	UpdateMfhEnergyEfficiencyScenarioStatusBodySchema = Type.Object({ status: TEnum(MfhEnergyEfficiencyScenarioStatus) });
	DeleteMfhEnergyEfficiencyScenarioParamsSchema = Type.Object({ mfhEnergyEfficiencyScenarioId: Type.Number() });
	UpdateMfhEnergyEfficiencyCalculationConfigBodySchema = Type.Partial(Type.Omit(MfhEnergyEfficiencyCalculationConfigSchema, [
		"mfhEnergyEfficienyCalculationConfigId",
		"createdAt",
		"updatedAt"
	]));
	UpdateMfhMeasureComponentCatalogueItemParamsSchema = Type.Object({ mfhMeasureComponentCatalogueItemId: Type.Number() });
	UpdateMfhMeasureComponentCatalogueItemBodySchema = Type.Object({
		label: Type.Optional(Type.String({ minLength: 1 })),
		flags: Type.Optional(TNullable(Type.Array(TEnum(MfhMeasureComponentFlag)))),
		isEnergy: Type.Optional(TNullable(Type.Boolean())),
		modelType: Type.Optional(TNullable(TEnum(MfhMeasureComponentEnergyModelType))),
		unit: Type.Optional(TNullable(TEnum(MfhMeasureComponentUnit))),
		capexUnit: Type.Optional(TNullable(TEnum(MfhMeasureComponentUnit))),
		liveMin: Type.Optional(TNullable(Type.Number({ minimum: 0 }))),
		liveAvg: Type.Optional(TNullable(Type.Number({ minimum: 0 }))),
		liveMax: Type.Optional(TNullable(Type.Number({ minimum: 0 }))),
		performance: Type.Optional(TNullable(Type.Number({ minimum: 0 }))),
		energyParams: Type.Optional(TNullable(MfhMeasureComponentEnergyParamsSchema)),
		prefillRule: Type.Optional(TNullable(MfhMeasureComponentPrefillSchema)),
		energySource: Type.Optional(TNullable(TEnum(HeatingSource))),
		notes: Type.Optional(TNullable(Type.String()))
	});
	CreateMfhMeasureComponentCatalogueItemBodySchema = Type.Object({
		component: TEnum(MfhMeasureComponent),
		catalogId: Type.String({ minLength: 1 }),
		label: Type.String({ minLength: 1 }),
		flags: Type.Optional(TNullable(Type.Array(TEnum(MfhMeasureComponentFlag)))),
		isEnergy: Type.Optional(TNullable(Type.Boolean())),
		modelType: Type.Optional(TNullable(TEnum(MfhMeasureComponentEnergyModelType))),
		unit: Type.Optional(TNullable(TEnum(MfhMeasureComponentUnit))),
		capexUnit: Type.Optional(TNullable(TEnum(MfhMeasureComponentUnit))),
		liveMin: Type.Optional(TNullable(Type.Number({ minimum: 0 }))),
		liveAvg: Type.Optional(TNullable(Type.Number({ minimum: 0 }))),
		liveMax: Type.Optional(TNullable(Type.Number({ minimum: 0 }))),
		performance: Type.Optional(TNullable(Type.Number({ minimum: 0 }))),
		energyParams: Type.Optional(TNullable(MfhMeasureComponentEnergyParamsSchema)),
		prefillRule: Type.Optional(TNullable(MfhMeasureComponentPrefillSchema)),
		energySource: Type.Optional(TNullable(TEnum(HeatingSource))),
		notes: Type.Optional(TNullable(Type.String()))
	});
	DeleteMfhMeasureComponentCatalogueItemParamsSchema = Type.Object({ mfhMeasureComponentCatalogueItemId: Type.Number() });
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/calculations/capex.ts
/**
* Calculates raw CAPEX (min / avg / max) per selected measure.
*
* Only components with a selected `post` snapshot and a non-null `post.quantity`
* are included. The CAPEX prices come from the pinned post-state snapshot.
*
* Formula: capex = quantity × live unit cost
*
* If liveMin/liveAvg/liveMax are null on the snapshot (no price configured), the
* capex for that tier is 0 and a warning is emitted at the measure level via the
* caller.
*/
function calculateRawCapexPerMeasure(components) {
	const measures = [];
	for (const c of components) {
		if (c.post == null || c.post.quantity == null) continue;
		measures.push({
			catalogId: c.post.catalogId,
			component: c.component,
			rawMin: safeMul(c.post.quantity, c.post.liveMin),
			rawAvg: safeMul(c.post.quantity, c.post.liveAvg),
			rawMax: safeMul(c.post.quantity, c.post.liveMax)
		});
	}
	return measures;
}
var init_capex = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/calculations/cost-markups.ts
/**
* Applies the three sequential cost markups (SKB-1079) on top of the risk-adjusted CAPEX totals.
*
* The markups are multiplicative and applied in a fixed order, each on the running subtotal:
*  1. GC surcharge on the raw (risk-adjusted) CAPEX
*  2. Ancillary construction costs on the subtotal incl. GC surcharge
*  3. Contingency buffer on the subtotal incl. GC surcharge + ancillary costs
*
* All three tiers (min / avg / max) run through the same factors so the range stays consistent. Missing
* markups (`null`/`undefined`) means no markups are applied and the total equals the measures total.
*/
function calculateCostMarkups(riskAdjusted, markupsConfig) {
	const markups = markupsConfig ?? NO_MARKUPS;
	const gcFactor = 1 + markups.gcSurcharge;
	const ancillaryFactor = 1 + markups.ancillaryConstruction;
	const contingencyFactor = 1 + markups.contingencyBuffer;
	const afterGc = {
		min: riskAdjusted.min * gcFactor,
		avg: riskAdjusted.avg * gcFactor,
		max: riskAdjusted.max * gcFactor
	};
	const afterAncillary = {
		min: afterGc.min * ancillaryFactor,
		avg: afterGc.avg * ancillaryFactor,
		max: afterGc.max * ancillaryFactor
	};
	const total = {
		min: afterAncillary.min * contingencyFactor,
		avg: afterAncillary.avg * contingencyFactor,
		max: afterAncillary.max * contingencyFactor
	};
	const effectiveTotalFactor = gcFactor * ancillaryFactor * contingencyFactor;
	return {
		measuresTotalMin: riskAdjusted.min,
		measuresTotalAvg: riskAdjusted.avg,
		measuresTotalMax: riskAdjusted.max,
		gcSurchargePct: markups.gcSurcharge,
		afterGcSurchargeMin: afterGc.min,
		afterGcSurchargeAvg: afterGc.avg,
		afterGcSurchargeMax: afterGc.max,
		ancillaryConstructionPct: markups.ancillaryConstruction,
		afterAncillaryConstructionMin: afterAncillary.min,
		afterAncillaryConstructionAvg: afterAncillary.avg,
		afterAncillaryConstructionMax: afterAncillary.max,
		contingencyBufferPct: markups.contingencyBuffer,
		totalMin: total.min,
		totalAvg: total.avg,
		totalMax: total.max,
		effectiveTotalFactor
	};
}
/**
* Multiplier from the scenario's calculated cost-markup snapshot (SKB-1321).
* Missing or non-numeric markups (scenarios calculated before SKB-1079) apply no markup.
*/
function resolveMfhCostMarkupFactor(costMarkups) {
	const factor = costMarkups?.effectiveTotalFactor;
	return typeof factor === "number" && Number.isFinite(factor) ? factor : 1;
}
/**
* Project CAPEX after cost markups. Falls back to the risk-adjusted totals when the output
* has no markup snapshot, so older calculations stay unchanged.
*/
function deriveMfhMarkedUpCapexTotals(capex) {
	const markups = capex.costMarkups;
	if (markups == null || typeof markups.totalAvg !== "number") return {
		min: capex.totalRiskAdjustedMin,
		avg: capex.totalRiskAdjustedAvg,
		max: capex.totalRiskAdjustedMax
	};
	return {
		min: markups.totalMin,
		avg: markups.totalAvg,
		max: markups.totalMax
	};
}
var NO_MARKUPS;
var init_cost_markups = __esmMin((() => {
	NO_MARKUPS = {
		gcSurcharge: 0,
		ancillaryConstruction: 0,
		contingencyBuffer: 0
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/calculations/carrier-config.ts
/** Returns a positive carrier factor from config, or null when unset / zero / invalid. */
function getCarrierFactor(factors, source) {
	const value = factors?.[source];
	if (value == null || value <= 0 || Number.isNaN(value)) return null;
	return value;
}
/**
* Resolves the energy carrier used to value the scenario's energy / CO₂ / primary-energy
* savings.
*
* Resolution order:
*  1. Post-state heating system: the Heating row's `post` snapshot mapped via
*     {@link HEATING_CATALOG_CARRIER} (a real system swap, e.g. gas → heat pump).
*  2. Otherwise the pre-state carrier (`inputs.energySource`) — no heating swap, or a
*     heating measure that only improves the existing system (e.g. pipe insulation).
*
* Returns `null` only when neither a known post-state heating system nor a pre-state
* carrier is available.
*/
function resolvePostStateCarrier(components, inputs) {
	const postCatalogId = components.find((c) => c.component === "HeatingSystem" && c.post != null)?.post?.catalogId;
	if (postCatalogId != null && postCatalogId in HEATING_CATALOG_CARRIER) return HEATING_CATALOG_CARRIER[postCatalogId];
	return inputs.energySource ?? null;
}
var HEATING_CATALOG_CARRIER;
var init_carrier_config = __esmMin((() => {
	init_energy_efficiency();
	init_capex_ee_calculator_model();
	HEATING_CATALOG_CARRIER = {
		HEAT_DISTRICT: "DistrictHeating",
		HEAT_GAS_ETAGE: "NaturalGas",
		HEAT_GAS_OLD: "NaturalGas",
		HEAT_OIL_OLD: "HeatingOil",
		HEAT_PELLET: "Pellets",
		HEAT_PUMP_AIR: "Electricity",
		HEAT_PUMP_GROUND: "Electricity"
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/calculations/risk-factors.ts
/**
* Looks up the risk factor multiplier for a given building year and component.
* Falls back to 1.0 if no config row covers the year or the row has no factor for the component.
*/
function lookupRiskFactor(yearBuilt, component, riskFactorConfig) {
	const row = riskFactorConfig.find((r) => yearBuilt >= r.ageClassStart && yearBuilt <= r.ageClassEnd);
	if (!row) return {
		factor: 1,
		found: false
	};
	const factor = row.factors[component];
	if (factor == null) return {
		factor: 1,
		found: false
	};
	return {
		factor,
		found: true
	};
}
/**
* Applies risk factors to raw CAPEX measures and aggregates totals and component splits.
*/
function applyRiskFactors(rawMeasures, yearBuilt, config) {
	const adjustedMeasures = rawMeasures.map((m) => {
		const { factor, found } = lookupRiskFactor(yearBuilt, m.component, config.riskFactorConfig);
		const warnings = [];
		if (!found) warnings.push({
			errorCode: "NoRiskFactorForYear",
			type: "Config",
			payload: {
				catalogId: m.catalogId,
				yearBuilt
			}
		});
		return {
			...m,
			riskFactor: factor,
			riskAdjustedMin: m.rawMin * factor,
			riskAdjustedAvg: m.rawAvg * factor,
			riskAdjustedMax: m.rawMax * factor,
			warnings
		};
	});
	return {
		measures: adjustedMeasures,
		totals: {
			rawMin: safeSum(...adjustedMeasures.map((m) => m.rawMin)),
			rawAvg: safeSum(...adjustedMeasures.map((m) => m.rawAvg)),
			rawMax: safeSum(...adjustedMeasures.map((m) => m.rawMax)),
			riskAdjustedMin: safeSum(...adjustedMeasures.map((m) => m.riskAdjustedMin)),
			riskAdjustedAvg: safeSum(...adjustedMeasures.map((m) => m.riskAdjustedAvg)),
			riskAdjustedMax: safeSum(...adjustedMeasures.map((m) => m.riskAdjustedMax))
		},
		splitByComponent: buildComponentSplits(adjustedMeasures)
	};
}
function buildComponentSplits(measures) {
	const byComponent = /* @__PURE__ */ new Map();
	for (const m of measures) {
		const existing = byComponent.get(m.component) ?? [];
		existing.push(m);
		byComponent.set(m.component, existing);
	}
	return Array.from(byComponent.entries()).map(([component, group]) => ({
		component,
		min: safeSum(...group.map((m) => m.rawMin)),
		avg: safeSum(...group.map((m) => m.rawAvg)),
		max: safeSum(...group.map((m) => m.rawMax)),
		riskAdjustedMin: safeSum(...group.map((m) => m.riskAdjustedMin)),
		riskAdjustedAvg: safeSum(...group.map((m) => m.riskAdjustedAvg)),
		riskAdjustedMax: safeSum(...group.map((m) => m.riskAdjustedMax))
	}));
}
var init_risk_factors = __esmMin((() => {
	init_capex_ee_calculator_model();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/calculations/capex-ee-calculation-helpers.ts
/**
* Computes a ratio: part / whole. Returns null if inputs are missing or whole is 0.
* Result is a 0–1 fraction (e.g. 0.2532 for a 25.32% saving).
*/
function pct(part, whole) {
	if (part == null || whole == null || whole === 0) return null;
	return part / whole;
}
var init_capex_ee_calculation_helpers = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/calculations/component-correction-factor.ts
/** Historical snapshots have no factor map; missing entries preserve previous results with multiplier 1. */
function resolveComponentCorrectionFactor(component, config) {
	return config.componentCorrectionFactorPerComponent?.[component] ?? 1;
}
var MFH_COMPONENT_CORRECTION_FACTOR_COMPONENTS;
var init_component_correction_factor = __esmMin((() => {
	init_capex_ee_calculator_model();
	MFH_COMPONENT_CORRECTION_FACTOR_COMPONENTS = [
		"FacadeInsulation",
		"ThermalBridge",
		"Windows",
		"TopFloorCeiling",
		"CellarCeilingInsulation",
		"RoofInsulation",
		"RoofEnergyProduction",
		"Ventilation"
	];
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/calculations/energy-heat-demand.ts
/** Resolves the Temperature Correction Factor for a U-value measure. */
function resolveTemperatureCorrectionFactor(component, config) {
	const factors = config.temperatureCorrectionFactorPerSurface;
	if (factors == null) return 1;
	const surface = ENVELOPE_SURFACE_BY_COMPONENT[component];
	return surface != null ? factors[surface] ?? 1 : 1;
}
/**
* Derives the pre-construction useful heat demand from the final energy baseline.
*
* The pre-state heating efficiency comes from the Heating component's pinned
* `pre` snapshot. If absent, final energy is used as proxy.
*
* For combustion / district-heating systems:
*   preHeatDemand = preFinalEnergy × preHeatingEfficiency
*/
function derivePreHeatDemand(preFinalEnergyKwh, components) {
	const preHeating = components.find((c) => c.component === "HeatingSystem")?.pre;
	if (!preHeating) return {
		value: preFinalEnergyKwh,
		warnings: [{
			errorCode: "NoPreStateHeatingSnapshot",
			type: "Config",
			payload: {}
		}]
	};
	if (preHeating.modelType !== "SystemEfficiencyDelta" || preHeating.performance == null) return {
		value: preFinalEnergyKwh,
		warnings: [{
			errorCode: "PreStateHeatingNoUsableEfficiency",
			type: "Config",
			payload: {}
		}]
	};
	const efficiency = preHeating.performance;
	if (efficiency <= 0) return {
		value: null,
		warnings: [{
			errorCode: "PreStateHeatingEfficiencyInvalid",
			type: "Config",
			payload: {}
		}]
	};
	return {
		value: preFinalEnergyKwh * efficiency,
		warnings: []
	};
}
/**
* Calculates the useful heat demand saving for a single U_VALUE_DELTA measure.
*
* Formula:
*   saving = quantity × (preU − postU) × heatingDegreeHours / 1000
*            × temperatureCorrectionFactor × componentCorrectionFactor
*
* - preU             = performance of the pinned `pre` snapshot
* - postU            = performance of the pinned `post` snapshot
* - temperatureCorrectionFactor = config.temperatureCorrectionFactorPerSurface for the component
*/
function calculateUValueDeltaSaving(row, heatingDegreeHours, temperatureCorrectionFactor, componentCorrectionFactor) {
	const warnings = [];
	const catalogId = row.post?.catalogId ?? "unknown";
	const preU = row.pre?.performance;
	const postU = row.post?.performance;
	if (preU == null) {
		warnings.push({
			errorCode: "NoPreStateUValue",
			type: "Config",
			payload: { catalogId }
		});
		return {
			saving: null,
			warnings
		};
	}
	if (postU == null) {
		warnings.push({
			errorCode: "NoPostStateUValue",
			type: "Config",
			payload: { catalogId }
		});
		return {
			saving: null,
			warnings
		};
	}
	const quantity = row.post.quantity;
	const delta = preU - postU;
	if (delta <= 0) {
		warnings.push({
			errorCode: "PostUValueNotLowerThanPre",
			type: "EnergyCalculation",
			payload: { catalogId }
		});
		return {
			saving: 0,
			warnings
		};
	}
	return {
		saving: quantity * delta * (heatingDegreeHours / 1e3) * temperatureCorrectionFactor * componentCorrectionFactor,
		warnings
	};
}
/**
* Computes the useful-heat-demand saving for the thermal-bridge uplift measure
* ({@link MfhMeasureComponentEnergyModelType.ThermalBridgeUplift}).
*
* Unlike a U-value delta, the thermal-bridge saving is a share of the useful heat demand left
* after the standard envelope measures — measured against their *plausibility-capped* savings,
* so the uplift acts on the demand that actually survives the caps:
*
*   usefulHeatDemandAfterStandardEnvelope = preHeatDemand − Σ(capped standard envelope savings)
*   thermalBridgeSaving = usefulHeatDemandAfterStandardEnvelope × savingFactor
*
* `savingFactor` is the measure's pinned `performance` (e.g. 0.05). It is clamped to the
* configured plausibility cap for the component (e.g. max 0.08) so the saving can never exceed
* that share of the remaining demand. Because the saving is computed against the already-reduced
* demand (not the pre-state demand), the generic per-component plausibility cap is intentionally
* not re-applied to this measure (see {@link applyPlausibilityCaps}).
*/
function calculateThermalBridgeSaving(row, usefulHeatDemandAfterStandardEnvelope, config) {
	const warnings = [];
	const catalogId = row.post?.catalogId ?? "unknown";
	const savingFactor = row.post?.performance;
	if (savingFactor == null || savingFactor <= 0) {
		warnings.push({
			errorCode: "NoThermalBridgeSavingFactor",
			type: "Config",
			payload: { catalogId }
		});
		return {
			saving: 0,
			warnings
		};
	}
	const correctedSavingFactor = savingFactor * resolveComponentCorrectionFactor("ThermalBridge", config);
	const cap = config.componentPlausibilityCaps["ThermalBridge"];
	const effectiveFactor = cap != null ? clamp(correctedSavingFactor, 0, cap.max) : correctedSavingFactor;
	if (cap != null && correctedSavingFactor > cap.max) warnings.push({
		errorCode: "ThermalBridgeSavingFactorCapped",
		type: "EnergyCalculation",
		payload: {
			catalogId,
			percent: Number((cap.max * 100).toFixed(0))
		}
	});
	return {
		saving: Math.max(0, usefulHeatDemandAfterStandardEnvelope) * effectiveFactor,
		warnings
	};
}
/**
* Calculates heat demand savings across all energy-relevant U_VALUE_DELTA measures
* and derives pre/post heat demand from the pinned pre/post snapshots on each row.
*/
function calculateHeatDemand(inputs, components, config) {
	const warnings = [];
	const preFinalEnergyKwh = normaliseFinalEnergy(inputs);
	if (preFinalEnergyKwh == null) {
		warnings.push({
			errorCode: "NoFinalEnergyBaselineAllSkipped",
			type: "EnergyCalculation",
			payload: {}
		});
		return {
			preHeatDemandKwh: null,
			measures: [],
			totalHeatDemandSavingKwh: null,
			postHeatDemandKwh: null,
			warnings
		};
	}
	const { value: preHeatDemandKwh, warnings: heatDeriveWarnings } = derivePreHeatDemand(preFinalEnergyKwh, components);
	warnings.push(...heatDeriveWarnings);
	const city = inputs.city;
	const heatingDegreeHours = city != null ? config.heatingDegreeHoursPerCity[city] : void 0;
	if (heatingDegreeHours == null) warnings.push(city != null ? {
		errorCode: "NoHeatingDegreeHoursForCityUValueSkipped",
		type: "Config",
		payload: { city }
	} : {
		errorCode: "NoCityUValueSavingsSkipped",
		type: "EnergyCalculation",
		payload: {}
	});
	const measureSavings = [];
	for (const row of components) {
		if (row.post == null || row.post.quantity == null) continue;
		if (!row.post.isEnergy) continue;
		if (row.post.modelType !== "UValueDelta") continue;
		const catalogId = row.post.catalogId;
		const component = row.component;
		if (heatingDegreeHours == null) {
			measureSavings.push({
				catalogId,
				component,
				savingKwhPerYear: 0,
				capped: false,
				warnings: [{
					errorCode: "HeatingDegreeHoursUnavailableSavingZero",
					type: city != null ? "Config" : "EnergyCalculation",
					payload: { catalogId }
				}]
			});
			continue;
		}
		const { saving, warnings: measureWarnings } = calculateUValueDeltaSaving(row, heatingDegreeHours, resolveTemperatureCorrectionFactor(component, config), resolveComponentCorrectionFactor(component, config));
		measureSavings.push({
			catalogId,
			component,
			savingKwhPerYear: saving ?? 0,
			capped: false,
			warnings: measureWarnings
		});
	}
	const totalHeatDemandSavingKwh = safeSum(...measureSavings.map((m) => m.savingKwhPerYear));
	return {
		preHeatDemandKwh,
		measures: measureSavings,
		totalHeatDemandSavingKwh,
		postHeatDemandKwh: preHeatDemandKwh != null ? Math.max(0, preHeatDemandKwh - totalHeatDemandSavingKwh) : null,
		warnings
	};
}
/**
* Layers the thermal-bridge uplift measure ({@link MfhMeasureComponentEnergyModelType.ThermalBridgeUplift})
* on top of an already plausibility-capped heat-demand result.
*
* The thermal-bridge saving is a share of the useful heat demand left after the standard envelope
* measures. Those standard-envelope savings must already be plausibility-capped when this runs, so
* the uplift acts on the demand that survives the caps rather than the raw (pre-cap) envelope
* savings. It therefore runs *after* {@link applyPlausibilityCaps} in the pipeline.
*
* Appends the thermal-bridge measure and recomputes the package total + post heat demand. The
* measure self-clamps its own saving factor (see {@link calculateThermalBridgeSaving}); it is not
* subject to the per-component or total-envelope plausibility caps.
*/
function applyThermalBridgeUplift(heatDemandResult, components, config) {
	const { preHeatDemandKwh, measures } = heatDemandResult;
	if (preHeatDemandKwh == null) return heatDemandResult;
	const usefulHeatDemandAfterStandardEnvelope = preHeatDemandKwh - safeSum(...measures.filter((m) => STANDARD_ENVELOPE_COMPONENTS$1.has(m.component)).map((m) => m.savingKwhPerYear));
	const thermalBridgeRow = components.find((row) => row.post != null && row.post.quantity != null && row.post.isEnergy && row.post.modelType === "ThermalBridgeUplift");
	if (thermalBridgeRow?.post == null) return heatDemandResult;
	const { saving, warnings: measureWarnings } = calculateThermalBridgeSaving(thermalBridgeRow, usefulHeatDemandAfterStandardEnvelope, config);
	const thermalBridgeMeasure = {
		catalogId: thermalBridgeRow.post.catalogId,
		component: thermalBridgeRow.component,
		savingKwhPerYear: saving,
		capped: false,
		warnings: measureWarnings
	};
	const updatedMeasures = [...measures, thermalBridgeMeasure];
	const totalHeatDemandSavingKwh = safeSum(...updatedMeasures.map((m) => m.savingKwhPerYear));
	const postHeatDemandKwh = Math.max(0, preHeatDemandKwh - totalHeatDemandSavingKwh);
	return {
		...heatDemandResult,
		measures: updatedMeasures,
		totalHeatDemandSavingKwh,
		postHeatDemandKwh
	};
}
/** Final energy baseline on the scenario (kWh/a). Used by energy-final.ts. */
function normaliseFinalEnergy(inputs) {
	return inputs.currentFinalEnergyConsumption ?? null;
}
/**
* Returns the post-state heating performance and model type from the pinned
* `post` snapshot. Used by energy-final.ts.
*/
function getPostHeatingParams(components) {
	const heatingRow = components.find((c) => c.component === "HeatingSystem" && c.post != null);
	if (!heatingRow || !heatingRow.post) return {
		modelType: null,
		performance: null
	};
	return {
		modelType: heatingRow.post.modelType ?? null,
		performance: heatingRow.post.performance ?? null
	};
}
/**
* Returns the pre-state heating performance and model type from the pinned `pre`
* snapshot — the system efficiency (SystemEfficiencyDelta) or SPF (heat pumps).
*
* Unlike {@link getPreHeatingEfficiency} (which is SystemEfficiencyDelta-only and used
* for the heat-demand reverse engineering), this returns the performance for any heating
* model type, so the heating measure's final-energy impact can be quantified.
*/
function getPreHeatingParams(components) {
	const heatingRow = components.find((c) => c.component === "HeatingSystem" && c.pre != null);
	if (!heatingRow || !heatingRow.pre) return {
		modelType: null,
		performance: null
	};
	return {
		modelType: heatingRow.pre.modelType ?? null,
		performance: heatingRow.pre.performance ?? null
	};
}
var STANDARD_ENVELOPE_COMPONENTS$1, ENVELOPE_SURFACE_BY_COMPONENT;
var init_energy_heat_demand = __esmMin((() => {
	init_capex_ee_calculator_model();
	init_component_correction_factor();
	STANDARD_ENVELOPE_COMPONENTS$1 = /* @__PURE__ */ new Set([
		"FacadeInsulation",
		"Windows",
		"RoofInsulation",
		"TopFloorCeiling",
		"CellarCeilingInsulation"
	]);
	ENVELOPE_SURFACE_BY_COMPONENT = {
		["Windows"]: "Windows",
		["RoofInsulation"]: "Roof",
		["TopFloorCeiling"]: "TopFloorCeiling",
		["CellarCeilingInsulation"]: "CellarCeiling",
		["FacadeInsulation"]: "FacadeFreestanding"
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/calculations/plausibility.ts
/**
* Resolves the whole-envelope plausibility cap (fraction 0–1) from the config's editable
* {@link MfhMeasureComponentGroupId.Shell} ("Building Envelope") component-group cap. The cap is
* mandatory in config (seeded + backfilled by data migration); there is no hardcoded fallback.
*/
function resolveEnvelopeCapFraction(config) {
	const shellCap = config.componentGroupPlausibilityCaps?.["shell"];
	if (shellCap == null) throw new Error("Missing \"Building Envelope\" (shell) component-group plausibility cap in calculation config");
	return shellCap.max;
}
/**
* Applies plausibility caps to the heat demand savings computed in the heat demand step.
*
* - Per-component: saving for that component is capped at `config.componentPlausibilityCaps[component].max`
*   fraction of the pre-heat demand.
* - Total: the summed package saving (`totalHeatDemandSavingKwh`) is capped at
*   `envelopeCapFraction` of pre-heat demand. The whole-envelope cap is a property of the
*   measure *combination*, so it is applied to the package total only — individual measures keep
*   their component-capped `savingKwhPerYear` values. The cap is the config-driven "Building
*   Envelope" component-group cap (see {@link resolveEnvelopeCapFraction}).
*
* Returns the updated HeatDemandResult with capped savings and warnings attached.
*/
function applyPlausibilityCaps(heatDemandResult, config) {
	const { componentPlausibilityCaps } = config;
	const envelopeCapFraction = resolveEnvelopeCapFraction(config);
	const { preHeatDemandKwh, measures } = heatDemandResult;
	const warnings = [...heatDemandResult.warnings];
	if (preHeatDemandKwh == null || preHeatDemandKwh === 0) return heatDemandResult;
	const cappedMeasures = measures.map((m) => {
		if (m.component === "ThermalBridge") return m;
		const componentCap = componentPlausibilityCaps[m.component];
		if (!componentCap) return m;
		const maxAllowedKwh = preHeatDemandKwh * componentCap.max;
		if (m.savingKwhPerYear > maxAllowedKwh) return {
			...m,
			savingKwhPerYear: maxAllowedKwh,
			capped: true,
			warnings: [...m.warnings, {
				errorCode: "EnergySavingCapped",
				type: "EnergyCalculation",
				payload: {
					catalogId: m.catalogId,
					percent: Number((componentCap.max * 100).toFixed(0)),
					maxAllowedKwh: Number(maxAllowedKwh.toFixed(0))
				}
			}]
		};
		return m;
	});
	const totalSavingAfterComponentCaps = cappedMeasures.reduce((sum, m) => sum + m.savingKwhPerYear, 0);
	const maxTotalAllowedKwh = preHeatDemandKwh * envelopeCapFraction;
	let totalSaving = totalSavingAfterComponentCaps;
	if (totalSavingAfterComponentCaps > maxTotalAllowedKwh) {
		totalSaving = maxTotalAllowedKwh;
		warnings.push({
			errorCode: "TotalHeatDemandSavingCapped",
			type: "EnergyCalculation",
			payload: {
				percent: Number((envelopeCapFraction * 100).toFixed(0)),
				maxAllowedKwh: Number(maxTotalAllowedKwh.toFixed(0))
			}
		});
	}
	const postHeatDemandKwh = clamp(preHeatDemandKwh - totalSaving, 0, preHeatDemandKwh);
	return {
		...heatDemandResult,
		measures: cappedMeasures,
		totalHeatDemandSavingKwh: totalSaving,
		postHeatDemandKwh,
		warnings
	};
}
var init_plausibility = __esmMin((() => {
	init_capex_ee_calculator_model();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/calculations/ventilation-pv-expansion.ts
/**
* Resolves the ventilation loss share (0–1) that a delta measure recovers from. The ticket carries the
* share on both the baseline (pre) row and the delta (measure) row; the delta measure's own
* `energyParams.ventilationLossShare` takes precedence, falling back to the baseline row's share.
*/
function resolveVentilationLossShare(components, deltaShare) {
	if (deltaShare != null && deltaShare > 0) return deltaShare;
	const baselineShare = components.find((c) => c.component === "Ventilation" && c.pre != null)?.pre?.energyParams?.ventilationLossShare;
	return baselineShare != null && baselineShare > 0 ? baselineShare : null;
}
/**
* Computes the whole-scenario ventilation effect (SKB-1060 §1) for the selected ventilation delta
* measure:
*   Baseline Ventilation Heat Loss   = Pre Useful Heat Demand × ventilation_loss_share
*   Ventilation Heat Demand Saving   = Baseline Ventilation Heat Loss × served_area_share
*                                      × heat_recovery_efficiency × component_correction_factor
*   Ventilation Auxiliary Electricity = aux_electricity_kwh_per_we_a × WE (quantity)
*
* `VENT_WINDOW_FREE` (baseline) and a delta measure with no served_area_share / heat_recovery_efficiency
* yield 0 heat saving. Auxiliary electricity is still counted when the measure carries it.
*/
function calculateVentilationEffect(inputs, components, preHeatDemandKwh, config) {
	const warnings = [];
	const row = components.find((c) => c.post != null && c.post.modelType === "VENTILATION_DELTA");
	if (row?.post == null) return {
		baselineVentilationHeatLossKwh: null,
		ventilationHeatDemandSavingKwh: 0,
		auxElectricityKwh: 0,
		catalogId: null,
		warnings
	};
	const params = row.post.energyParams ?? {};
	const catalogId = row.post.catalogId;
	const lossShare = resolveVentilationLossShare(components, params.ventilationLossShare);
	const baselineVentilationHeatLossKwh = preHeatDemandKwh != null && lossShare != null ? preHeatDemandKwh * lossShare : null;
	const servedAreaShare = params.servedAreaShare ?? 0;
	const heatRecoveryEfficiency = params.heatRecoveryEfficiency ?? 0;
	const componentCorrectionFactor = resolveComponentCorrectionFactor("Ventilation", config);
	let ventilationHeatDemandSavingKwh = 0;
	if (baselineVentilationHeatLossKwh != null && servedAreaShare > 0 && heatRecoveryEfficiency > 0) ventilationHeatDemandSavingKwh = baselineVentilationHeatLossKwh * servedAreaShare * heatRecoveryEfficiency * componentCorrectionFactor;
	else if (preHeatDemandKwh == null && (servedAreaShare > 0 || heatRecoveryEfficiency > 0)) warnings.push({
		errorCode: "VentilationNeedsPreHeatDemand",
		type: "EnergyCalculation",
		payload: { catalogId }
	});
	else if (lossShare == null && (servedAreaShare > 0 || heatRecoveryEfficiency > 0)) warnings.push({
		errorCode: "NoVentilationLossShare",
		type: "Config",
		payload: { catalogId }
	});
	const auxPerWe = params.auxElectricityKwhPerWeA ?? 0;
	const we = row.post.quantity ?? 0;
	const auxElectricityKwh = auxPerWe > 0 ? auxPerWe * we : 0;
	return {
		baselineVentilationHeatLossKwh,
		ventilationHeatDemandSavingKwh,
		auxElectricityKwh,
		catalogId,
		warnings
	};
}
/** Planned new living area from the selected roof-expansion measure (m²), or 0 when not selected. */
function deriveRoofExpansionFloorArea(components) {
	const quantity = components.find((c) => c.post != null && c.post.isEnergy === true && c.post.modelType === "FINAL_ENERGY_DEMAND_PER_M2")?.post?.quantity;
	return quantity != null && quantity > 0 ? quantity : 0;
}
/**
* Computes the additional final energy demand from a roof-expansion measure (SKB-1060 §3):
*   Final Energy Demand of Expansion = New Floor Area [m²] × performance [kWh/m²a]
* For the `FINAL_ENERGY_DEMAND_PER_M2` model the `performance` scalar carries the per-m² demand.
* This ADDS demand on the post-state heating carrier (a negative saving).
*/
function calculateExpansionEffect(components) {
	const warnings = [];
	const row = components.find((c) => c.post != null && c.post.isEnergy === true && c.post.modelType === "FINAL_ENERGY_DEMAND_PER_M2");
	if (row?.post == null) return {
		additionalFinalEnergyDemandKwh: 0,
		catalogId: null,
		warnings
	};
	const catalogId = row.post.catalogId;
	const perM2 = row.post.performance ?? null;
	const newFloorArea = deriveRoofExpansionFloorArea(components) || null;
	if (perM2 == null || perM2 <= 0) {
		warnings.push({
			errorCode: "NoFinalEnergyDemandPerM2Expansion",
			type: "Config",
			payload: { catalogId }
		});
		return {
			additionalFinalEnergyDemandKwh: 0,
			catalogId,
			warnings
		};
	}
	if (newFloorArea == null || newFloorArea <= 0) {
		warnings.push({
			errorCode: "NoNewFloorAreaQuantity",
			type: "EnergyCalculation",
			payload: { catalogId }
		});
		return {
			additionalFinalEnergyDemandKwh: 0,
			catalogId,
			warnings
		};
	}
	return {
		additionalFinalEnergyDemandKwh: newFloorArea * perM2,
		catalogId,
		warnings
	};
}
/**
* Resolves the PV specific yield (kWh/kWp·a) for the scenario's city: exact city match, otherwise the
* single Germany-wide fallback scalar (975 kWh/kWp·a) (SKB-1060 §2).
*/
function resolvePvSpecificYield(inputs, config) {
	const city = inputs.city;
	const cityYield = city != null ? config.pvSpecificYieldPerCity?.[city] : void 0;
	if (cityYield != null && cityYield > 0) return cityYield;
	const fallback = config.pvSpecificYieldFallback;
	return fallback != null && fallback > 0 ? fallback : null;
}
/**
* Computes the gross on-site PV generation (SKB-1060 §2):
*   PV Generation = kWp × city specific yield × roof-type yield factor × component correction factor
* Returns null generation when no PV measure is selected.
*/
function calculatePvEffect(inputs, components, config) {
	const warnings = [];
	const row = components.find((c) => c.post != null && c.post.isEnergy === true && c.post.modelType === "PV_GENERATION");
	if (row?.post == null) return {
		estimatedPvGenerationKwh: null,
		catalogId: null,
		warnings
	};
	const catalogId = row.post.catalogId;
	const kwp = row.post.quantity ?? null;
	if (kwp == null || kwp <= 0) {
		warnings.push({
			errorCode: "NoPvPeakPowerQuantity",
			type: "EnergyCalculation",
			payload: { catalogId }
		});
		return {
			estimatedPvGenerationKwh: 0,
			catalogId,
			warnings
		};
	}
	const specificYield = resolvePvSpecificYield(inputs, config);
	if (specificYield == null) {
		warnings.push({
			errorCode: "NoPvSpecificYield",
			type: "Config",
			payload: { catalogId }
		});
		return {
			estimatedPvGenerationKwh: 0,
			catalogId,
			warnings
		};
	}
	const roofShape = inputs.roofShape;
	const yieldFactor = (roofShape != null ? config.pvRoofTypeFactorPerShape?.[roofShape]?.yieldFactor : void 0) ?? 1;
	const componentCorrectionFactor = resolveComponentCorrectionFactor("RoofEnergyProduction", config);
	return {
		estimatedPvGenerationKwh: kwp * specificYield * yieldFactor * componentCorrectionFactor,
		catalogId,
		warnings
	};
}
/**
* Applies the 30% no-battery cap to the PV generation against the post primary energy demand before PV
* (SKB-1060 §2 / §4):
*   PV Primary Energy Credit = min(PV Generation × PEF(Strom), 0.30 × Post Primary Energy (before PV))
*   PV Capped [kWh]          = PV Primary Energy Credit ÷ PEF(Strom)
*/
function calculatePvPrimaryEnergyCredit(pvGenerationKwh, postPrimaryEnergyBeforePvKwh, config) {
	const warnings = [];
	if (pvGenerationKwh == null || pvGenerationKwh <= 0) return {
		pvPrimaryEnergyCreditKwh: 0,
		pvCappedKwh: 0,
		warnings
	};
	const stromPef = getCarrierFactor(config.primaryEnergyFactorPerCarrier, "Electricity");
	if (stromPef == null) return {
		pvPrimaryEnergyCreditKwh: 0,
		pvCappedKwh: 0,
		warnings: [{
			errorCode: "NoPrimaryEnergyFactorElectricityPv",
			type: "Config",
			payload: {}
		}]
	};
	const uncappedCreditKwh = pvGenerationKwh * stromPef;
	const capKwh = postPrimaryEnergyBeforePvKwh != null ? PV_NO_BATTERY_CAP_FRACTION * postPrimaryEnergyBeforePvKwh : uncappedCreditKwh;
	const pvPrimaryEnergyCreditKwh = Math.max(0, Math.min(uncappedCreditKwh, capKwh));
	return {
		pvPrimaryEnergyCreditKwh,
		pvCappedKwh: pvPrimaryEnergyCreditKwh / stromPef,
		warnings
	};
}
var PV_NO_BATTERY_CAP_FRACTION;
var init_ventilation_pv_expansion = __esmMin((() => {
	init_energy_efficiency();
	init_capex_ee_calculator_model();
	init_carrier_config();
	init_component_correction_factor();
	PV_NO_BATTERY_CAP_FRACTION = .3;
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/calculations/standalone-measures.ts
/**
* Returns the additive efficiency uplift (`performance`) of a heating-side uplift measure from the
* given snapshot side (`pre` or `post`), or 0 when the measure / snapshot is absent or carries no
* usable uplift.
*
* Hydraulic-balancing and pipe-insulation uplifts are NOT plausibility-capped: the saving is already
* bounded by the additive uplift factor itself, so a per-component cap can never bind and would only
* add a misleading warning (product decision — no cap needed).
*/
function resolveUplift(component, side, components) {
	const uplift = components.find((c) => c.component === component && c[side] != null)?.[side]?.performance;
	if (uplift == null || uplift <= 0) return 0;
	return uplift;
}
/**
* Pre-state base heating efficiency (η or SPF) from the Heating row's `pre` snapshot, or null when
* none is usable.
*/
function resolvePreBaseEfficiency(components) {
	const { modelType, performance } = getPreHeatingParams(components);
	if (modelType != null && HEATING_EFFICIENCY_MODEL_TYPES.has(modelType) && performance != null && performance > 0) return performance;
	return null;
}
/**
* Post-state base heating efficiency (η or SPF): the Heating row's `post` snapshot when a heating
* replacement is selected, otherwise the pre-state base efficiency. Null when none is usable.
*/
function resolvePostBaseEfficiency(components) {
	const { modelType, performance } = getPostHeatingParams(components);
	if (modelType != null && HEATING_EFFICIENCY_MODEL_TYPES.has(modelType) && performance != null && performance > 0) return performance;
	return resolvePreBaseEfficiency(components);
}
/**
* Pre-state FINAL system efficiency = pre base efficiency + pre hydraulic-balancing uplift + pre
* pipe-insulation uplift. Returns null when no usable pre base efficiency is available.
*/
function resolvePreFinalSystemEfficiency(components, config) {
	const base = resolvePreBaseEfficiency(components);
	if (base == null) return null;
	return base + resolveUplift(HYDRAULIC_BALANCING, "pre", components) + resolveUplift(PIPE_INSULATION, "pre", components);
}
/**
* Post-state FINAL system efficiency = post base efficiency + post hydraulic-balancing uplift +
* post pipe-insulation uplift. Returns null when no usable base efficiency is available.
*/
function resolvePostFinalSystemEfficiency(components, config) {
	const base = resolvePostBaseEfficiency(components);
	if (base == null) return null;
	return base + resolveUplift(HYDRAULIC_BALANCING, "post", components) + resolveUplift(PIPE_INSULATION, "post", components);
}
/**
* Converts an envelope useful-heat-demand saving into a final-energy saving using the pre-state
* final system efficiency: `finalEnergySaving = heatDemandSaving / preFinalSystemEfficiency`. When
* no usable pre-state efficiency exists, the divisor is 1 (the heat demand was a final-energy proxy).
*/
function envelopeFinalEnergySaving(heatDemandSavingKwh, preFinalSystemEfficiency) {
	return heatDemandSavingKwh / (preFinalSystemEfficiency != null && preFinalSystemEfficiency > 0 ? preFinalSystemEfficiency : 1);
}
/**
* Standalone thermal-bridge uplift heat-demand saving: applied to the full pre-construction useful
* heat demand, without subtracting the other envelope measures. The saving factor (`performance`)
* is clamped to the configured plausibility cap.
*/
function thermalBridgeStandaloneSaving(row, preHeatDemandKwh, config) {
	const warnings = [];
	const catalogId = row.post?.catalogId ?? "unknown";
	const savingFactor = row.post?.performance;
	if (savingFactor == null || savingFactor <= 0) {
		warnings.push({
			errorCode: "NoThermalBridgeSavingFactor",
			type: "Config",
			payload: { catalogId }
		});
		return {
			saving: 0,
			warnings
		};
	}
	const correctedSavingFactor = savingFactor * resolveComponentCorrectionFactor("ThermalBridge", config);
	const cap = config.componentPlausibilityCaps["ThermalBridge"];
	const effectiveFactor = cap != null ? clamp(correctedSavingFactor, 0, cap.max) : correctedSavingFactor;
	if (cap != null && correctedSavingFactor > cap.max) warnings.push({
		errorCode: "ThermalBridgeSavingFactorCapped",
		type: "EnergyCalculation",
		payload: {
			catalogId,
			percent: Number((cap.max * 100).toFixed(0))
		}
	});
	return {
		saving: Math.max(0, preHeatDemandKwh) * effectiveFactor,
		warnings
	};
}
/**
* Final-energy saving of a heating-side efficiency-uplift measure (hydraulic balancing or pipe
* insulation):
*
*   saving = PreUsefulHeatDemand  / (PreBaseEfficiency  + PreUplift)
*          − PreHeatDemandKwh / (PreBaseEfficiency + PostUplift)
*
* Uplifts are used as-is (no plausibility cap — product decision, the saving is already bounded by
* the uplift factor). Returns null when no usable base efficiency is available on either side.
*/
function efficiencyUpliftFinalEnergySaving(component, label, preHeatDemandKwh, components) {
	const row = components.find((c) => c.component === component && c.post != null);
	if (!row?.post) return {
		value: null,
		warnings: []
	};
	const catalogId = row.post.catalogId;
	const rawUplift = row.post.performance;
	if (rawUplift == null || rawUplift <= 0) return {
		value: 0,
		warnings: [{
			errorCode: "NoEfficiencyUpliftInSnapshot",
			type: "Config",
			payload: {
				catalogId,
				label
			}
		}]
	};
	const preBase = resolvePreBaseEfficiency(components);
	const postBase = resolvePostBaseEfficiency(components);
	if (preBase == null || postBase == null) return {
		value: null,
		warnings: [{
			errorCode: "NoUsableHeatingEfficiencyForLabel",
			type: "Config",
			payload: {
				catalogId,
				label
			}
		}]
	};
	const preUplift = resolveUplift(component, "pre", components);
	const postUplift = resolveUplift(component, "post", components);
	return {
		value: preHeatDemandKwh / (preBase + preUplift) - preHeatDemandKwh / (preBase + postUplift),
		warnings: []
	};
}
/**
* Final-energy saving of the heating-system measure alone, holding the pre-construction useful heat
* demand constant and running it through the pre base vs post base:
*
*   saving = PreUsefulHeatDemand / preBase − PreUsefulHeatDemand / postBase
*/
function heatingMeasureFinalEnergySaving(preHeatDemandKwh, components, catalogId) {
	const preBase = resolvePreBaseEfficiency(components);
	const postBase = resolvePostBaseEfficiency(components);
	if (preBase == null || postBase == null) return {
		value: null,
		warnings: [{
			errorCode: "NoUsableHeatingEfficiencyForHeatingMeasure",
			type: "Config",
			payload: { catalogId }
		}]
	};
	return {
		value: preHeatDemandKwh / preBase - preHeatDemandKwh / postBase,
		warnings: []
	};
}
/** Builds the standalone result row for a single non-heating-side measure (envelope U-value). */
function buildEnvelopeMeasureRow(raw, capped, preFinalSystemEfficiency) {
	if (capped == null) return null;
	return {
		catalogId: capped.catalogId,
		component: capped.component,
		rawHeatDemandSavingKwhPerYear: raw?.savingKwhPerYear ?? null,
		cappedHeatDemandSavingKwhPerYear: capped.savingKwhPerYear,
		finalHeatDemandKwhPerYear: capped.savingKwhPerYear,
		finalEnergySavingKwhPerYear: envelopeFinalEnergySaving(capped.savingKwhPerYear, preFinalSystemEfficiency),
		warnings: capped.warnings
	};
}
/**
* Calculates the standalone (per-measure) energy results for a scenario.
*
* For every selected measure this returns its heat-demand saving (raw and plausibility-capped),
* its final heat-demand saving, and its final-energy saving. Each measure is treated in isolation —
* the whole-package envelope / heating combination caps are NOT applied here (they live in the
* scenario-total calculation).
*
* Pipeline:
*  1. Raw heat-demand savings per U-value envelope measure (+ derived pre/post heat demand).
*  2. Per-component plausibility caps on those envelope savings.
*  3. Per-measure final-energy savings:
*     - Standard envelope (U-value): capped heat-demand saving ÷ pre-state final system efficiency.
*     - Thermal-bridge uplift: pre-heat demand × capped factor (no subtraction of other envelope
*       measures), then ÷ pre-state final system efficiency.
*     - Hydraulic balancing / pipe insulation: PreUHD ÷ (preBase + preUplift) − PostUHD ÷ (postBase + postUplift).
*     - Heating: PreUHD ÷ pre-state final system efficiency − PreUHD ÷ post-state final system efficiency.
*/
function calculateMfhEnergyEfficiencyStandaloneMeasures(inputs, components, config) {
	const rawHeatDemand = calculateHeatDemand(inputs, components, config);
	const cappedHeatDemand = applyPlausibilityCaps(rawHeatDemand, config);
	const { preHeatDemandKwh, postHeatDemandKwh, totalHeatDemandSavingKwh } = cappedHeatDemand;
	const warnings = [...cappedHeatDemand.warnings];
	const preFinalSystemEfficiency = resolvePreFinalSystemEfficiency(components, config);
	const measures = [];
	for (const component of components) {
		if (!STANDARD_ENVELOPE_COMPONENTS.has(component.component)) continue;
		const capped = cappedHeatDemand.measures.find((m) => m.component === component.component);
		const row = buildEnvelopeMeasureRow(rawHeatDemand.measures.find((m) => m.component === component.component), capped, preFinalSystemEfficiency);
		if (row != null) measures.push(row);
	}
	const thermalBridgeRow = components.find((c) => c.post != null && c.post.isEnergy && c.post.modelType === "ThermalBridgeUplift");
	if (thermalBridgeRow?.post != null && preHeatDemandKwh != null) {
		const { saving, warnings: bridgeWarnings } = thermalBridgeStandaloneSaving(thermalBridgeRow, preHeatDemandKwh, config);
		measures.push({
			catalogId: thermalBridgeRow.post.catalogId,
			component: thermalBridgeRow.component,
			rawHeatDemandSavingKwhPerYear: saving,
			cappedHeatDemandSavingKwhPerYear: saving,
			finalHeatDemandKwhPerYear: saving,
			finalEnergySavingKwhPerYear: envelopeFinalEnergySaving(saving, preFinalSystemEfficiency),
			warnings: bridgeWarnings
		});
	}
	for (const { component, label } of [{
		component: HYDRAULIC_BALANCING,
		label: "hydraulic-balancing"
	}, {
		component: PIPE_INSULATION,
		label: "pipe-insulation"
	}]) {
		const row = components.find((c) => c.component === component && c.post != null);
		if (row?.post == null) continue;
		if (preHeatDemandKwh == null || postHeatDemandKwh == null) {
			measures.push({
				catalogId: row.post.catalogId,
				component,
				rawHeatDemandSavingKwhPerYear: null,
				cappedHeatDemandSavingKwhPerYear: null,
				finalHeatDemandKwhPerYear: null,
				finalEnergySavingKwhPerYear: null,
				warnings: [{
					errorCode: "HeatDemandUnavailableForLabel",
					type: "EnergyCalculation",
					payload: {
						catalogId: row.post.catalogId,
						label
					}
				}]
			});
			continue;
		}
		const { value, warnings: upliftWarnings } = efficiencyUpliftFinalEnergySaving(component, label, preHeatDemandKwh, components);
		measures.push({
			catalogId: row.post.catalogId,
			component,
			rawHeatDemandSavingKwhPerYear: null,
			cappedHeatDemandSavingKwhPerYear: null,
			finalHeatDemandKwhPerYear: null,
			finalEnergySavingKwhPerYear: value,
			warnings: upliftWarnings
		});
	}
	const heatingRow = components.find((c) => c.component === "HeatingSystem" && c.post != null);
	if (heatingRow?.post != null) if (preHeatDemandKwh == null) measures.push({
		catalogId: heatingRow.post.catalogId,
		component: "HeatingSystem",
		rawHeatDemandSavingKwhPerYear: null,
		cappedHeatDemandSavingKwhPerYear: null,
		finalHeatDemandKwhPerYear: null,
		finalEnergySavingKwhPerYear: null,
		warnings: [{
			errorCode: "PreRenovationHeatDemandUnavailable",
			type: "EnergyCalculation",
			payload: { catalogId: heatingRow.post.catalogId }
		}]
	});
	else {
		const { value, warnings: heatingWarnings } = heatingMeasureFinalEnergySaving(preHeatDemandKwh, components, heatingRow.post.catalogId);
		measures.push({
			catalogId: heatingRow.post.catalogId,
			component: "HeatingSystem",
			rawHeatDemandSavingKwhPerYear: null,
			cappedHeatDemandSavingKwhPerYear: null,
			finalHeatDemandKwhPerYear: null,
			finalEnergySavingKwhPerYear: value,
			warnings: heatingWarnings
		});
	}
	const ventilation = calculateVentilationEffect(inputs, components, preHeatDemandKwh, config);
	if (ventilation.catalogId != null) {
		const heatDivisor = preFinalSystemEfficiency != null && preFinalSystemEfficiency > 0 ? preFinalSystemEfficiency : 1;
		const netFinalEnergySaving = ventilation.ventilationHeatDemandSavingKwh / heatDivisor - ventilation.auxElectricityKwh;
		measures.push({
			catalogId: ventilation.catalogId,
			component: "Ventilation",
			rawHeatDemandSavingKwhPerYear: ventilation.ventilationHeatDemandSavingKwh,
			cappedHeatDemandSavingKwhPerYear: ventilation.ventilationHeatDemandSavingKwh,
			finalHeatDemandKwhPerYear: ventilation.ventilationHeatDemandSavingKwh,
			finalEnergySavingKwhPerYear: netFinalEnergySaving,
			warnings: ventilation.warnings
		});
	}
	const expansion = calculateExpansionEffect(components);
	if (expansion.catalogId != null) measures.push({
		catalogId: expansion.catalogId,
		component: "RoofExpansion",
		rawHeatDemandSavingKwhPerYear: null,
		cappedHeatDemandSavingKwhPerYear: null,
		finalHeatDemandKwhPerYear: null,
		finalEnergySavingKwhPerYear: -expansion.additionalFinalEnergyDemandKwh,
		warnings: expansion.warnings
	});
	const pv = calculatePvEffect(inputs, components, config);
	if (pv.catalogId != null) measures.push({
		catalogId: pv.catalogId,
		component: "RoofEnergyProduction",
		rawHeatDemandSavingKwhPerYear: null,
		cappedHeatDemandSavingKwhPerYear: null,
		finalHeatDemandKwhPerYear: null,
		finalEnergySavingKwhPerYear: null,
		warnings: pv.warnings
	});
	return {
		preHeatDemandKwh,
		postHeatDemandKwh,
		totalHeatDemandSavingKwh,
		measures,
		warnings
	};
}
var HEATING_EFFICIENCY_MODEL_TYPES, HYDRAULIC_BALANCING, PIPE_INSULATION, STANDARD_ENVELOPE_COMPONENTS;
var init_standalone_measures = __esmMin((() => {
	init_capex_ee_calculator_model();
	init_energy_heat_demand();
	init_plausibility();
	init_component_correction_factor();
	init_ventilation_pv_expansion();
	HEATING_EFFICIENCY_MODEL_TYPES = /* @__PURE__ */ new Set(["SystemEfficiencyDelta", "SPF"]);
	HYDRAULIC_BALANCING = "HydraulicBalancing";
	PIPE_INSULATION = "HeatingPipelineInsulation";
	STANDARD_ENVELOPE_COMPONENTS = /* @__PURE__ */ new Set([
		"FacadeInsulation",
		"Windows",
		"RoofInsulation",
		"TopFloorCeiling",
		"CellarCeilingInsulation"
	]);
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/calculations/energy-final.ts
/**
* Converts post-renovation useful heat demand to post-final energy demand using the combined
* FINAL system efficiency:
*
*   postFinalEnergy = postHeatDemand / finalSystemEfficiency
*   finalSystemEfficiency = baseEfficiency + pipeInsulationUplift + hydraulicBalancingUplift
*
* `baseEfficiency` is the post-state heating efficiency / SPF when a heating replacement is selected,
* otherwise the pre-state heating efficiency. Pipe-insulation and hydraulic-balancing uplifts are
* each treated as 0 when the respective measure is not selected. Returns null with a warning when no
* usable heating efficiency is available.
*/
function convertHeatToFinalEnergy(postHeatDemandKwh, components, config) {
	const warnings = [];
	const finalSystemEfficiency = resolvePostFinalSystemEfficiency(components, config);
	if (finalSystemEfficiency == null) {
		warnings.push({
			errorCode: "NoUsableHeatingSystemEfficiencyFinalEnergy",
			type: "Config",
			payload: {}
		});
		return {
			postFinalEnergyKwh: null,
			warnings
		};
	}
	if (finalSystemEfficiency <= 0) {
		warnings.push({
			errorCode: "FinalHeatingEfficiencyInvalid",
			type: "Config",
			payload: {}
		});
		return {
			postFinalEnergyKwh: null,
			warnings
		};
	}
	return {
		postFinalEnergyKwh: postHeatDemandKwh / finalSystemEfficiency,
		warnings
	};
}
var init_energy_final = __esmMin((() => {
	init_capex_ee_calculator_model();
	init_standalone_measures();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/calculations/scenario-total.ts
/**
* Calculates the scenario-wide ("§9.4.1" + SKB-1060 §4) total final energy saving and the two-bucket
* primary energy — the figures used to value the cost / CO2 / primary-energy KPIs and the PV output.
*
* The post state is carried in exactly two carrier buckets (SKB-1060 §4):
*  - Heat carrier — post building heating final energy + roof-expansion final energy demand (same
*    heating carrier). When the post heating system is electric (heat pump) the heating carrier is
*    Strom, so the two buckets collapse naturally via each bucket's carrier PEF.
*  - Electricity (Strom) — ventilation auxiliary electricity. PV nets against the primary energy here.
*
* Steps:
*  1.  Baseline final energy demand.
*  2.  Baseline useful heat demand → envelope caps → post heat demand after envelope + thermal bridge.
*  2b. Ventilation heat demand saving folded into the post useful heat demand.
*  3.  Post final energy demand (heating) = post useful heat demand ÷ post final system efficiency.
*  4.  Heat-carrier final energy = post heating final energy + expansion; Electricity final energy =
*      ventilation auxiliary electricity; gross total = sum of both buckets.
*  5.  Primary energy: pre × PEF(pre carrier); post = heat bucket × PEF(heat carrier) + electricity
*      bucket × PEF(Strom); PV credit (30% no-battery cap) reduces the post primary energy only.
*/
function calculateMfhEnergyEfficiencyScenarioTotal(inputs, components, config) {
	const warnings = [];
	const preFinalEnergyKwh = normaliseFinalEnergy(inputs);
	if (preFinalEnergyKwh == null) return {
		...EMPTY_EXTENSIONS,
		preHeatDemandKwh: null,
		postHeatDemandKwh: null,
		rawHeatDemandSavingKwh: null,
		heatDemandSavingKwh: null,
		preFinalEnergyKwh: null,
		postFinalEnergyInclExpansionKwh: null,
		finalEnergySavingInclExpansionKwh: null,
		finalEnergySavingInclExpansionPct: null,
		warnings: [{
			errorCode: "NoFinalEnergyBaselineScenarioTotal",
			type: "EnergyCalculation",
			payload: {}
		}]
	};
	const rawHeatDemand = calculateHeatDemand(inputs, components, config);
	warnings.push(...rawHeatDemand.warnings);
	const cappedHeatDemand = applyPlausibilityCaps(rawHeatDemand, config);
	const rawHeatDemandSavingKwh = applyThermalBridgeUplift(rawHeatDemand, components, config).totalHeatDemandSavingKwh;
	const heatDemand = applyThermalBridgeUplift(cappedHeatDemand, components, config);
	const { preHeatDemandKwh } = heatDemand;
	let { postHeatDemandKwh } = heatDemand;
	const ventilation = calculateVentilationEffect(inputs, components, preHeatDemandKwh, config);
	warnings.push(...ventilation.warnings);
	if (postHeatDemandKwh != null && ventilation.ventilationHeatDemandSavingKwh > 0) postHeatDemandKwh = Math.max(0, postHeatDemandKwh - ventilation.ventilationHeatDemandSavingKwh);
	const totalHeatDemandSavingKwh = preHeatDemandKwh != null && postHeatDemandKwh != null ? preHeatDemandKwh - postHeatDemandKwh : heatDemand.totalHeatDemandSavingKwh;
	if (postHeatDemandKwh == null) return {
		...EMPTY_EXTENSIONS,
		preHeatDemandKwh,
		postHeatDemandKwh: null,
		rawHeatDemandSavingKwh,
		heatDemandSavingKwh: null,
		preFinalEnergyKwh,
		postFinalEnergyInclExpansionKwh: null,
		finalEnergySavingInclExpansionKwh: null,
		finalEnergySavingInclExpansionPct: null,
		warnings: [...warnings, {
			errorCode: "PostHeatDemandUnavailableScenarioTotal",
			type: "EnergyCalculation",
			payload: {}
		}]
	};
	const { postFinalEnergyKwh: convertedHeatingFinalEnergyKwh, warnings: conversionWarnings } = convertHeatToFinalEnergy(postHeatDemandKwh, components, config);
	if (convertedHeatingFinalEnergyKwh == null) return {
		...EMPTY_EXTENSIONS,
		preHeatDemandKwh,
		postHeatDemandKwh,
		rawHeatDemandSavingKwh,
		heatDemandSavingKwh: totalHeatDemandSavingKwh,
		ventilationHeatDemandSavingKwh: ventilation.ventilationHeatDemandSavingKwh,
		preFinalEnergyKwh,
		postFinalEnergyInclExpansionKwh: null,
		finalEnergySavingInclExpansionKwh: null,
		finalEnergySavingInclExpansionPct: null,
		warnings: [...warnings, ...conversionWarnings]
	};
	let postHeatingFinalEnergyKwh = convertedHeatingFinalEnergyKwh;
	if (postHeatingFinalEnergyKwh > preFinalEnergyKwh) {
		warnings.push({
			errorCode: "PostFinalEnergyCappedAtPre",
			type: "EnergyCalculation",
			payload: {}
		});
		postHeatingFinalEnergyKwh = preFinalEnergyKwh;
	}
	const expansion = calculateExpansionEffect(components);
	warnings.push(...expansion.warnings);
	const expansionFinalEnergyDemandKwh = expansion.additionalFinalEnergyDemandKwh;
	const heatCarrierExclExpansionKwh = postHeatingFinalEnergyKwh;
	const electricityFinalEnergyKwh = ventilation.auxElectricityKwh;
	const postFinalEnergyExclExpansionKwh = heatCarrierExclExpansionKwh + electricityFinalEnergyKwh;
	const postFinalEnergyInclExpansionKwh = postFinalEnergyExclExpansionKwh + expansionFinalEnergyDemandKwh;
	const finalEnergySavingExclExpansionKwh = preFinalEnergyKwh - postFinalEnergyExclExpansionKwh;
	const finalEnergySavingInclExpansionKwh = preFinalEnergyKwh - postFinalEnergyInclExpansionKwh;
	const preCarrier = inputs.energySource ?? null;
	const heatCarrier = resolvePostStateCarrier(components, inputs);
	const cost = valueBuckets(preFinalEnergyKwh, heatCarrierExclExpansionKwh, expansionFinalEnergyDemandKwh, electricityFinalEnergyKwh, preCarrier, heatCarrier, config.energyCostPerCarrier, "energy cost");
	warnings.push(...cost.warnings);
	const co2 = valueBuckets(preFinalEnergyKwh, heatCarrierExclExpansionKwh, expansionFinalEnergyDemandKwh, electricityFinalEnergyKwh, preCarrier, heatCarrier, config.co2FactorsPerCarrier, "CO2");
	warnings.push(...co2.warnings);
	const primary = valueBuckets(preFinalEnergyKwh, heatCarrierExclExpansionKwh, expansionFinalEnergyDemandKwh, electricityFinalEnergyKwh, preCarrier, heatCarrier, config.primaryEnergyFactorPerCarrier, "primary energy");
	warnings.push(...primary.warnings);
	const pv = calculatePvEffect(inputs, components, config);
	warnings.push(...pv.warnings);
	const pvCredit = calculatePvPrimaryEnergyCredit(pv.estimatedPvGenerationKwh, primary.postInclExpansion, config);
	warnings.push(...pvCredit.warnings);
	if (pv.estimatedPvGenerationKwh != null) warnings.push({
		errorCode: "PvNoBatteryCreditCap",
		type: "EnergyCalculation",
		payload: {}
	});
	const prePrimaryEnergyKwh = primary.pre;
	const postPrimaryEnergyBeforePvExclExpansionKwh = primary.postExclExpansion;
	const postPrimaryEnergyBeforePvInclExpansionKwh = primary.postInclExpansion;
	const postPrimaryEnergyInclExpansionKwh = postPrimaryEnergyBeforePvInclExpansionKwh != null ? postPrimaryEnergyBeforePvInclExpansionKwh - pvCredit.pvPrimaryEnergyCreditKwh : null;
	const primaryEnergySavingInclExpansionKwh = prePrimaryEnergyKwh != null && postPrimaryEnergyInclExpansionKwh != null ? prePrimaryEnergyKwh - postPrimaryEnergyInclExpansionKwh : null;
	const postPrimaryEnergyExclExpansionKwh = primary.postExclExpansion != null ? primary.postExclExpansion - pvCredit.pvPrimaryEnergyCreditKwh : null;
	const primaryEnergySavingExclExpansionKwh = prePrimaryEnergyKwh != null && postPrimaryEnergyExclExpansionKwh != null ? prePrimaryEnergyKwh - postPrimaryEnergyExclExpansionKwh : null;
	return {
		preHeatDemandKwh,
		postHeatDemandKwh,
		rawHeatDemandSavingKwh,
		heatDemandSavingKwh: totalHeatDemandSavingKwh,
		preFinalEnergyKwh,
		postFinalEnergyInclExpansionKwh,
		finalEnergySavingInclExpansionKwh,
		finalEnergySavingInclExpansionPct: pct(finalEnergySavingInclExpansionKwh, preFinalEnergyKwh),
		postFinalEnergyExclExpansionKwh,
		finalEnergySavingExclExpansionKwh,
		finalEnergySavingExclExpansionPct: pct(finalEnergySavingExclExpansionKwh, preFinalEnergyKwh),
		heatCarrierFinalEnergyKwh: heatCarrierExclExpansionKwh + expansionFinalEnergyDemandKwh,
		electricityFinalEnergyKwh,
		expansionFinalEnergyDemandKwh,
		ventilationHeatDemandSavingKwh: ventilation.ventilationHeatDemandSavingKwh,
		energyCostSavingExclExpansion: cost.savingExclExpansion,
		energyCostSavingInclExpansion: cost.savingInclExpansion,
		energyCostSavingExclExpansionPct: pct(cost.savingExclExpansion, cost.pre),
		energyCostSavingInclExpansionPct: pct(cost.savingInclExpansion, cost.pre),
		preCo2: co2.pre,
		postCo2ExclExpansion: co2.postExclExpansion,
		postCo2InclExpansion: co2.postInclExpansion,
		co2SavingExclExpansion: co2.savingExclExpansion,
		co2SavingInclExpansion: co2.savingInclExpansion,
		prePrimaryEnergyKwh,
		postPrimaryEnergyBeforePvExclExpansionKwh,
		postPrimaryEnergyBeforePvInclExpansionKwh,
		postPrimaryEnergyInclExpansionKwh,
		primaryEnergySavingInclExpansionKwh,
		primaryEnergySavingInclExpansionPct: pct(primaryEnergySavingInclExpansionKwh, prePrimaryEnergyKwh),
		postPrimaryEnergyExclExpansionKwh,
		primaryEnergySavingExclExpansionKwh,
		primaryEnergySavingExclExpansionPct: pct(primaryEnergySavingExclExpansionKwh, prePrimaryEnergyKwh),
		estimatedPvGenerationKwh: pv.estimatedPvGenerationKwh,
		pvCappedKwh: pv.estimatedPvGenerationKwh != null ? pvCredit.pvCappedKwh : null,
		pvPrimaryEnergyCreditKwh: pv.estimatedPvGenerationKwh != null ? pvCredit.pvPrimaryEnergyCreditKwh : null,
		warnings
	};
}
/**
* Values the pre-state and the two post-state carrier buckets against a per-carrier factor table
* (energy-cost, CO2 or primary-energy factors), returning both the "existing building" (excluding
* roof expansion) and "existing building + expansion" views.
*
* Two-tariff rule (item 2): the pre-state is priced at the pre carrier's factor; the post-state heat
* carrier bucket (heating final energy + expansion) is priced at the post heat carrier's factor and
* the electricity bucket (ventilation auxiliary) at the electricity (Strom) factor. When the post
* heating system is a heat pump the heat carrier IS Strom, so both post buckets collapse onto the
* electricity factor naturally.
*
* When a required factor is missing the affected pre/post value is left null and a warning is added,
* so the downstream KPI is skipped rather than reported with a wrong number.
*/
function valueBuckets(preFinalEnergyKwh, heatCarrierExclExpansionKwh, expansionFinalEnergyDemandKwh, electricityFinalEnergyKwh, preCarrier, heatCarrier, factors, label) {
	const warnings = [];
	const preFactor = preCarrier != null ? getCarrierFactor(factors, preCarrier) : null;
	const pre = preFactor != null ? preFinalEnergyKwh * preFactor : null;
	if (preFactor == null) warnings.push({
		errorCode: "NoFactorForPreStateCarrier",
		type: "Config",
		payload: { label }
	});
	const heatFactor = heatCarrier != null ? getCarrierFactor(factors, heatCarrier) : null;
	const stromFactor = getCarrierFactor(factors, "Electricity");
	let postExclExpansion = null;
	let postInclExpansion = null;
	if (heatFactor != null && (electricityFinalEnergyKwh === 0 || stromFactor != null)) {
		const electricityValue = electricityFinalEnergyKwh * (stromFactor ?? 0);
		postExclExpansion = heatCarrierExclExpansionKwh * heatFactor + electricityValue;
		postInclExpansion = postExclExpansion + expansionFinalEnergyDemandKwh * heatFactor;
	} else warnings.push({
		errorCode: "NoFactorForPostStateCarrier",
		type: "Config",
		payload: { label }
	});
	const savingExclExpansion = pre != null && postExclExpansion != null ? pre - postExclExpansion : null;
	const savingInclExpansion = pre != null && postInclExpansion != null ? pre - postInclExpansion : null;
	return {
		pre,
		postExclExpansion,
		postInclExpansion,
		savingExclExpansion,
		savingInclExpansion,
		warnings
	};
}
var EMPTY_EXTENSIONS;
var init_scenario_total = __esmMin((() => {
	init_energy_efficiency();
	init_capex_ee_calculator_model();
	init_capex_ee_calculation_helpers();
	init_carrier_config();
	init_energy_heat_demand();
	init_energy_final();
	init_plausibility();
	init_ventilation_pv_expansion();
	EMPTY_EXTENSIONS = {
		postFinalEnergyExclExpansionKwh: null,
		finalEnergySavingExclExpansionKwh: null,
		finalEnergySavingExclExpansionPct: null,
		heatCarrierFinalEnergyKwh: null,
		electricityFinalEnergyKwh: 0,
		expansionFinalEnergyDemandKwh: 0,
		ventilationHeatDemandSavingKwh: 0,
		energyCostSavingExclExpansion: null,
		energyCostSavingInclExpansion: null,
		energyCostSavingExclExpansionPct: null,
		energyCostSavingInclExpansionPct: null,
		preCo2: null,
		postCo2ExclExpansion: null,
		postCo2InclExpansion: null,
		co2SavingExclExpansion: null,
		co2SavingInclExpansion: null,
		prePrimaryEnergyKwh: null,
		postPrimaryEnergyBeforePvExclExpansionKwh: null,
		postPrimaryEnergyBeforePvInclExpansionKwh: null,
		postPrimaryEnergyInclExpansionKwh: null,
		primaryEnergySavingInclExpansionKwh: null,
		primaryEnergySavingInclExpansionPct: null,
		postPrimaryEnergyExclExpansionKwh: null,
		primaryEnergySavingExclExpansionKwh: null,
		primaryEnergySavingExclExpansionPct: null,
		estimatedPvGenerationKwh: null,
		pvCappedKwh: null,
		pvPrimaryEnergyCreditKwh: null
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/calculations/warnings.ts
/**
* Collects global warnings for missing or inconsistent scenario data that affect
* calculation quality. These are structural/data-quality checks run before the
* calculation pipeline.
*/
function collectPreflightWarnings(inputs, components, config) {
	const warnings = [];
	if (inputs.currentFinalEnergyConsumption == null) warnings.push({
		errorCode: "MissingFinalEnergyBaseline",
		type: "EnergyCalculation",
		payload: {}
	});
	if (inputs.city == null) warnings.push({
		errorCode: "NoCityProvided",
		type: "EnergyCalculation",
		payload: {}
	});
	else if (config.heatingDegreeHoursPerCity[inputs.city] == null) warnings.push({
		errorCode: "NoHeatingDegreeHoursForCity",
		type: "Config",
		payload: { city: inputs.city }
	});
	if (inputs.energySource == null) warnings.push({
		errorCode: "NoEnergySourceProvided",
		type: "EnergyCalculation",
		payload: {}
	});
	else if (getCarrierFactor(config.energyCostPerCarrier, inputs.energySource) == null) warnings.push({
		errorCode: "NoEnergyCostForSource",
		type: "Config",
		payload: { energySource: inputs.energySource }
	});
	for (const c of components) {
		if (c.post == null) continue;
		const catalogId = c.post.catalogId;
		if (c.post.liveMin == null || c.post.liveAvg == null || c.post.liveMax == null) warnings.push({
			errorCode: "MeasureNoLivePrice",
			type: "Config",
			payload: { catalogId }
		});
		if (c.post.quantity == null || c.post.quantity <= 0) warnings.push({
			errorCode: "MeasureInvalidQuantity",
			type: "EnergyCalculation",
			payload: {
				catalogId,
				quantity: c.post.quantity
			}
		});
	}
	return warnings;
}
/**
* Collects per-measure CAPEX warnings after risk-adjusted CAPEX is computed.
* Adds a warning for measures that produced zero CAPEX due to missing prices.
*/
function collectCapexWarnings(capexResult) {
	const perMeasure = {};
	for (const m of capexResult.measures) {
		const measureWarnings = [...m.warnings];
		if (m.rawAvg === 0) measureWarnings.push({
			errorCode: "NoLivePriceConfigured",
			type: "Config",
			payload: { catalogId: m.catalogId }
		});
		if (measureWarnings.length > 0) perMeasure[m.catalogId] = measureWarnings;
	}
	return perMeasure;
}
var init_warnings = __esmMin((() => {
	init_capex_ee_calculator_model();
	init_carrier_config();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/calculations/transmission-loss.ts
/**
* SKB-1075 — Specific Transmission Heat Loss H'_T [W/(m²·K)].
*
* Implements the ticket formula:
*
*   H'_T =
*     ( Σ_surface  TCF[surface] × U[surface] × Area[surface]
*       + ThermalBridgeSupplement × TotalEnvelopeArea )
*     ÷ TotalEnvelopeArea
*
* Two run modes selected via `variant`:
*  - `scenario`: U-values come from each component's pinned post-state snapshot (fallback pre-state);
*    the thermal-bridge supplement is the configured thermal-bridge post (fallback pre) U-value.
*  - `reference`: U-values + thermal-bridge supplement come from {@link MfhReferenceBuildingParams}.
*
* Both variants reuse the same per-surface areas and Temperature Correction Factors. When an expansion
* measure is selected the freestanding facade area and the total envelope area are enlarged by the
* expansion facade area (see {@link deriveExpansionFacadeArea}).
*/
/** Number of new floors encoded in a roof-expansion catalog id (`ROOF_EXPANSION` = 1, `..._2G` = 2, etc.). */
function deriveExpansionFloorCount(components) {
	const catalogId = components.find((c) => c.post != null && c.post.isEnergy === true && c.post.modelType === "FINAL_ENERGY_DEMAND_PER_M2")?.post?.catalogId;
	if (catalogId == null) return 0;
	const match = catalogId.match(/_(\d)G$/);
	if (match) return Number(match[1]);
	return 1;
}
/**
* Additional facade area created by a roof expansion (m²):
*   expansion facade area = (existing facade area / number of existing floors) × number of new floors
* Returns 0 when no expansion is selected or the drivers are missing.
*/
function deriveExpansionFacadeArea(inputs, components) {
	const newFloors = deriveExpansionFloorCount(components);
	if (newFloors <= 0) return 0;
	const facadeGrossArea = inputs.facadeGrossArea;
	const existingFloors = inputs.storiesAboveGround;
	if (facadeGrossArea == null || facadeGrossArea <= 0 || existingFloors == null || existingFloors <= 0) return 0;
	return facadeGrossArea / existingFloors * newFloors;
}
/** Resolves the effective U-value of a component from its post snapshot, falling back to the pre snapshot. */
function resolveComponentUValue(components, component) {
	const row = components.find((c) => c.component === component);
	if (!row) return null;
	return row.post?.performance ?? row.pre?.performance ?? null;
}
/** Whether a top-floor-ceiling component is selected (drives the roof-vs-top-floor-ceiling rule). */
function hasTopFloorCeiling(components) {
	return components.find((c) => c.component === "TopFloorCeiling")?.post != null;
}
/**
* Computes the specific transmission heat loss for the scenario or the reference building.
*/
function calculateSpecificTransmissionHeatLoss(inputs, components, config, variant) {
	const warnings = [];
	const tcf = config.temperatureCorrectionFactorPerSurface;
	if (tcf == null) return {
		value: null,
		totalEnvelopeArea: null,
		warnings
	};
	const reference = variant === "reference" ? config.referenceBuildingParams : void 0;
	if (variant === "reference" && reference == null) return {
		value: null,
		totalEnvelopeArea: null,
		warnings
	};
	const expansionFacadeArea = deriveExpansionFacadeArea(inputs, components);
	const freestandingFacadeArea = (inputs.freeStandingFacadeGrossArea ?? 0) + expansionFacadeArea;
	const nonFreestandingFacadeArea = inputs.facadeGrossArea != null && inputs.freeStandingFacadeGrossArea != null ? Math.max(0, inputs.facadeGrossArea - inputs.freeStandingFacadeGrossArea) : null;
	const windowsArea = inputs.windowArea ?? null;
	const useTopFloorCeiling = hasTopFloorCeiling(components);
	const roofOrCeilingArea = inputs.roofArea ?? null;
	const cellarCeilingArea = inputs.footprintArea ?? null;
	const facadeU = reference != null ? reference.facadeUValue : resolveComponentUValue(components, "FacadeInsulation");
	const windowsU = reference != null ? reference.windowsUValue : resolveComponentUValue(components, "Windows");
	const roofOrCeilingU = reference != null ? reference.roofUValue : useTopFloorCeiling ? resolveComponentUValue(components, "TopFloorCeiling") : resolveComponentUValue(components, "RoofInsulation");
	const cellarU = reference != null ? reference.cellarCeilingUValue : resolveComponentUValue(components, "CellarCeilingInsulation");
	const contributions = [
		{
			surface: "FacadeFreestanding",
			uValue: facadeU,
			area: freestandingFacadeArea
		},
		{
			surface: "FacadeNonFreestanding",
			uValue: facadeU,
			area: nonFreestandingFacadeArea
		},
		{
			surface: "Windows",
			uValue: windowsU,
			area: windowsArea
		},
		{
			surface: useTopFloorCeiling ? "TopFloorCeiling" : "Roof",
			uValue: roofOrCeilingU,
			area: roofOrCeilingArea
		},
		{
			surface: "CellarCeiling",
			uValue: cellarU,
			area: cellarCeilingArea
		}
	];
	let weightedSum = 0;
	for (const { surface, uValue, area } of contributions) {
		if (uValue == null || area == null) continue;
		const factor = tcf[surface] ?? 0;
		weightedSum += factor * uValue * area;
	}
	const baseEnvelopeArea = inputs.envelopeSurfaceArea ?? null;
	if (baseEnvelopeArea == null || baseEnvelopeArea <= 0) return {
		value: null,
		totalEnvelopeArea: null,
		warnings: [...warnings, {
			errorCode: "NoEnvelopeSurfaceArea",
			type: "EnergyCalculation",
			payload: {}
		}]
	};
	const totalEnvelopeArea = baseEnvelopeArea + expansionFacadeArea;
	const thermalBridgeSupplement = reference != null ? reference.thermalBridgeSupplement : resolveComponentUValue(components, "ThermalBridge") ?? 0;
	const thermalBridgeTcf = tcf["ThermalBridge"] ?? 1;
	return {
		value: (weightedSum + thermalBridgeTcf * thermalBridgeSupplement * totalEnvelopeArea) / totalEnvelopeArea,
		totalEnvelopeArea,
		warnings
	};
}
var init_transmission_loss = __esmMin((() => {
	init_capex_ee_calculator_model();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/calculations/reference-building.ts
/**
* SKB-1075 — Hot water heat demand [kWh/a] = Hot Water Heat Demand per Living Area × Living Area.
* Living area is approximated by the gross floor area (incl. roof-expansion floor area handled by the
* caller when relevant). Returns null when the config or living area is unavailable.
*/
function calculateHotWaterHeatDemand(livingArea, config) {
	const perLivingArea = config.referenceBuildingParams?.hotWaterHeatDemandPerLivingArea;
	if (perLivingArea == null || livingArea == null || livingArea <= 0) return null;
	return perLivingArea * livingArea;
}
/**
* SKB-1075 — Separate reference-building run.
*
* The reference building is a virtual twin of the actual building: identical geometry, but with the
* fixed GEG / Anlage 1 standard envelope U-values and system spec (Gas-Etagenheizung + hydraulic
* balancing + solar hot water + ventilation loss) from {@link MfhEnergyEfficiencyCalculationConfig.referenceBuildingParams}.
*
* Sequence (ticket Requirement 3):
*  1. Reference specific transmission heat loss — same formula as the scenario, reference U-values.
*  2. Annual transmission losses [kWh/a] = H'_T × TotalEnvelopeArea × HeatingDegreeHours[kKh/a] ÷ 1000.
*  3. Reference heating demand = annual transmission losses + reference ventilation loss + hot water demand.
*     - Reference ventilation loss = annual transmission losses × referenceVentilationToTransmissionRatio.
*     - Hot water demand = hotWaterHeatDemandPerLivingArea × living area, reduced by solar coverage.
*  4. Final energy = (final energy existing (gas) + final energy (electricity)) + final energy expansion (gas):
*     - Final energy existing (gas) = reference heating demand ÷ (baseSystemEfficiencyGas + hydraulicBalancingUplift).
*     - Final energy (electricity) = solar auxiliary electricity = solarAuxiliaryElectricityPerLivingArea × living area.
*     - Final energy expansion (gas) = expansion quantity × expansion performance value (added final energy demand of a selected roof expansion).
*  5. Primary energy = final energy gas (existing + expansion) × primaryEnergyFactorGas + solar auxiliary electricity × primaryEnergyFactorElectricity.
*
* The result depends only on geometry + config (not on the selected measures, except an expansion
* measure which enlarges the envelope / living area), so it can be cached per building by the caller.
*/
function calculateReferenceBuilding(inputs, components, config) {
	const warnings = [];
	const reference = config.referenceBuildingParams;
	if (reference == null) return {
		specificTransmissionHeatLoss: null,
		primaryEnergyDemand: null,
		warnings
	};
	const transmission = calculateSpecificTransmissionHeatLoss(inputs, components, config, "reference");
	warnings.push(...transmission.warnings);
	if (transmission.value == null || transmission.totalEnvelopeArea == null) return {
		specificTransmissionHeatLoss: null,
		primaryEnergyDemand: null,
		warnings
	};
	const city = inputs.city;
	const heatingDegreeHours = city != null ? config.heatingDegreeHoursPerCity[city] : void 0;
	if (heatingDegreeHours == null) {
		warnings.push(city != null ? {
			errorCode: "NoHeatingDegreeHoursForCityReferenceSkipped",
			type: "Config",
			payload: { city }
		} : {
			errorCode: "NoCityReferencePrimaryEnergySkipped",
			type: "EnergyCalculation",
			payload: {}
		});
		return {
			specificTransmissionHeatLoss: transmission.value,
			primaryEnergyDemand: null,
			warnings
		};
	}
	const annualTransmissionLossesKwh = transmission.value * transmission.totalEnvelopeArea * heatingDegreeHours / 1e3;
	const referenceVentilationLossKwh = annualTransmissionLossesKwh * reference.referenceVentilationToTransmissionRatio;
	const livingArea = inputs.grossFloorArea != null ? inputs.grossFloorArea + deriveRoofExpansionFloorArea(components) : null;
	const hotWaterDemandKwh = (calculateHotWaterHeatDemand(livingArea, config) ?? 0) * (1 - reference.solarHotWaterCoverageFraction);
	const referenceHeatingDemandKwh = annualTransmissionLossesKwh + referenceVentilationLossKwh + hotWaterDemandKwh;
	const finalSystemEfficiency = reference.baseSystemEfficiencyGas + reference.hydraulicBalancingUplift;
	if (finalSystemEfficiency <= 0) {
		warnings.push({
			errorCode: "ReferenceFinalSystemEfficiencyInvalid",
			type: "Config",
			payload: {}
		});
		return {
			specificTransmissionHeatLoss: transmission.value,
			primaryEnergyDemand: null,
			warnings
		};
	}
	const finalEnergyExistingGasKwh = referenceHeatingDemandKwh / finalSystemEfficiency;
	const solarAuxiliaryElectricityKwh = livingArea != null ? reference.solarAuxiliaryElectricityPerLivingArea * livingArea : 0;
	const expansion = calculateExpansionEffect(components);
	warnings.push(...expansion.warnings);
	const primaryEnergyDemand = (finalEnergyExistingGasKwh + expansion.additionalFinalEnergyDemandKwh) * reference.primaryEnergyFactorGas + solarAuxiliaryElectricityKwh * reference.primaryEnergyFactorElectricity;
	return {
		specificTransmissionHeatLoss: transmission.value,
		primaryEnergyDemand,
		warnings
	};
}
var init_reference_building = __esmMin((() => {
	init_capex_ee_calculator_model();
	init_transmission_loss();
	init_ventilation_pv_expansion();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/subsidies/shared/eligible-costs.ts
function getSelectedComponent(context, component) {
	return context.components.find((candidate) => candidate.component === component && candidate.post != null);
}
/** Component row by type (pre and/or post). Unlike {@link getSelectedComponent}, does not require a post selection. */
function getComponent(context, component) {
	return context.components.find((candidate) => candidate.component === component);
}
function getRiskAdjustedMeasureCost(context, component) {
	return context.measureFinancials.find((measure) => measure.component === component)?.riskAdjustedCapexAvg ?? null;
}
function getEnergeticModernisationCosts(context) {
	return context.components.reduce((total, component) => {
		if (component.post == null) return total;
		if (resolveMfhCapexBudgetBucket(component.component, component.post.bucket) !== "energeticCapex") return total;
		return total + (getRiskAdjustedMeasureCost(context, component.component) ?? 0);
	}, 0);
}
function getExpansionCapexCosts(context) {
	return context.components.reduce((total, component) => {
		if (component.post == null) return total;
		if (resolveMfhCapexBudgetBucket(component.component, component.post.bucket) !== "expansionCapex") return total;
		return total + (getRiskAdjustedMeasureCost(context, component.component) ?? 0);
	}, 0);
}
function getKfw261EligibleCosts(context, eligibleEnergeticCapexShare, eligibleExpansionCapexShare) {
	return getEnergeticModernisationCosts(context) * eligibleEnergeticCapexShare + getExpansionCapexCosts(context) * eligibleExpansionCapexShare;
}
function calculateAncillaryConstructionCosts(eligibleCosts, context) {
	return eligibleCosts * (context.costMarkups?.ancillaryConstruction ?? 0);
}
function classifySubsidyHeatingSystem(component) {
	const snapshot = component?.post ?? component?.pre;
	if (snapshot == null) return null;
	if (snapshot.modelType === "SPF") return "HEAT_PUMP";
	const catalogId = snapshot.catalogId.toUpperCase();
	if (catalogId.includes("HEAT_PUMP") || catalogId.includes("WAERMEPUMPE")) return "HEAT_PUMP";
	if (catalogId.includes("PELLET")) return "PELLETS";
	if (catalogId.includes("DISTRICT") || catalogId.includes("FERNWAERME") || catalogId.includes("FERNWARME")) return "DISTRICT_HEATING";
	if (catalogId.includes("SOLAR_THERMAL") || catalogId.includes("SOLARTHERMIE")) return "SOLAR_THERMAL";
	return null;
}
var init_eligible_costs = __esmMin((() => {
	init_capex_ee_calculator_model();
	init_subsidy_config_model();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/subsidies/shared/rule-result.ts
function ruleValue(key, value, unit) {
	return unit == null ? {
		key,
		value
	} : {
		key,
		value,
		unit
	};
}
function createRuleResult(params) {
	return {
		ruleCode: params.ruleCode,
		blocking: params.blocking,
		outcome: params.outcome,
		observedValues: params.observedValues ?? [],
		comparedConfigValues: params.comparedConfigValues ?? [],
		reason: {
			code: params.reasonCode,
			parameters: params.reasonParameters ?? []
		}
	};
}
function createProgramResult(params) {
	const { config } = params;
	return {
		programCode: config.programCode,
		programLongName: config.metadata.programLongName,
		programShortName: config.metadata.programShortName,
		institutionShortName: config.metadata.institutionShortName,
		institutionLongName: config.metadata.institutionLongName,
		fundingType: config.fundingType,
		eligibilityStatus: deriveEligibilityStatus(params.ruleOutcomes),
		ruleOutcomes: params.ruleOutcomes,
		selectedVariant: params.selectedVariant,
		benefit: params.benefit,
		...params.breakdown === void 0 ? {} : { breakdown: params.breakdown },
		...params.variantAssessments == null ? {} : { variantAssessments: params.variantAssessments },
		...params.consideredMeasures == null ? {} : { consideredMeasures: params.consideredMeasures },
		warningCodes: [.../* @__PURE__ */ new Set([
			"ISOLATED_RESULT",
			...config.warningCodes,
			...params.additionalWarningCodes ?? []
		])],
		missingInputs: [...new Set(params.missingInputs)]
	};
}
function deriveEligibilityStatus(ruleOutcomes) {
	if (ruleOutcomes.some((rule) => rule.blocking && rule.outcome === "failed")) return "ineligible";
	if (ruleOutcomes.some((rule) => rule.blocking && rule.outcome === "indeterminate")) return "indeterminate";
	return "eligible";
}
function aggregateAllRequiredRuleOutcomes(outcomes) {
	if (outcomes.length === 0 || outcomes.includes("failed")) return "failed";
	if (outcomes.includes("indeterminate")) return "indeterminate";
	return "passed";
}
function aggregateAnyPassingRuleOutcomes(outcomes) {
	if (outcomes.includes("passed")) return "passed";
	if (outcomes.includes("indeterminate")) return "indeterminate";
	return "failed";
}
function evaluateMaximumThresholdOutcome(actual, maximum) {
	if (maximum == null) return "passed";
	if (actual == null) return "indeterminate";
	return actual <= maximum ? "passed" : "failed";
}
var init_rule_result = __esmMin((() => {
	init_subsidy_result_model();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/subsidies/shared/tiered-residential-unit-ceiling.ts
function residentialUnitIsInInclusiveBand(residentialUnit, minResidentialUnit, maxResidentialUnit) {
	return residentialUnit >= minResidentialUnit && (maxResidentialUnit == null || residentialUnit <= maxResidentialUnit);
}
function countResidentialUnitsInInclusiveBand(residentialUnits, minResidentialUnit, maxResidentialUnit) {
	if (residentialUnits < minResidentialUnit) return 0;
	return Math.max(0, (maxResidentialUnit == null ? residentialUnits : Math.min(residentialUnits, maxResidentialUnit)) - minResidentialUnit + 1);
}
function sumResidentialUnitInclusiveCostBands(residentialUnits, bands) {
	return bands.reduce((total, band) => {
		return total + countResidentialUnitsInInclusiveBand(residentialUnits, band.minResidentialUnit, band.maxResidentialUnit) * band.amount;
	}, 0);
}
var init_tiered_residential_unit_ceiling = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/subsidies/programs/bafa-beg-em.ts
function evaluateBafaBegEm(context, config) {
	const missingInputs = [];
	const candidates = BAFA_ELIGIBLE_COMPONENTS.map((component) => getSelectedComponent(context, component)).filter((component) => component != null);
	const eligibleMeasureRule = evaluateBafaEligibleMeasureRule(candidates);
	const measureEvaluations = candidates.map((candidate) => evaluateMeasure(candidate, context, config));
	const technicalRule = evaluateBafaTechnicalMinimumRequirementRule(measureEvaluations);
	missingInputs.push(...technicalRule.missingInputs);
	const hasIndividualRenovationRoadmap = context.subsidyInputs?.hasIndividualRenovationRoadmap;
	if (hasIndividualRenovationRoadmap == null) missingInputs.push("INDIVIDUAL_RENOVATION_ROADMAP");
	const residentialUnits = context.inputs.residentialUnits;
	if (residentialUnits == null) missingInputs.push("RESIDENTIAL_UNITS");
	const eligibleCosts = technicalRule.passingMeasures.reduce((total, measure) => total + (measure.eligibleCosts ?? 0), 0);
	const benefitCalculation = calculateBafaBenefit(eligibleCosts, residentialUnits, hasIndividualRenovationRoadmap, technicalRule, context, config);
	const variantAssessments = createBafaBegEmVariantAssessments(eligibleCosts, residentialUnits, eligibleMeasureRule.outcome, technicalRule, context, config);
	return createProgramResult({
		config,
		ruleOutcomes: [eligibleMeasureRule, technicalRule.rule],
		missingInputs,
		selectedVariant: hasIndividualRenovationRoadmap == null ? null : {
			programCode: "BAFA_BEG_EM",
			hasIndividualRenovationRoadmap
		},
		benefit: benefitCalculation?.benefit ?? null,
		breakdown: benefitCalculation?.breakdown ?? null,
		variantAssessments,
		consideredMeasures: measureEvaluations.map((measure) => ({
			componentCode: measure.component,
			catalogId: measure.catalogId,
			outcome: measure.outcome,
			eligibleCosts: measure.eligibleCosts
		}))
	});
}
function createBafaBegEmVariantAssessments(eligibleCosts, residentialUnits, eligibleMeasureOutcome, technicalRule, context, config) {
	const eligibilityStatus = resolveBafaVariantEligibility(eligibleMeasureOutcome, technicalRule.outcome);
	const status = resolveBafaVariantAssessmentStatus(eligibilityStatus);
	return [false, true].map((hasIndividualRenovationRoadmap) => {
		const benefitCalculation = calculateBafaBenefit(eligibleCosts, residentialUnits, hasIndividualRenovationRoadmap, technicalRule, context, config);
		const costCeiling = residentialUnits != null && residentialUnits > 0 ? calculateBafaBegEmCostCeiling(residentialUnits, hasIndividualRenovationRoadmap, config) : 0;
		return {
			programCode: "BAFA_BEG_EM",
			hasIndividualRenovationRoadmap,
			status,
			eligibilityStatus,
			costCeiling,
			grantRate: benefitCalculation?.benefit.grantRate ?? null,
			potentialBenefit: benefitCalculation?.benefit ?? null,
			potentialBreakdown: benefitCalculation?.breakdown ?? null
		};
	});
}
function resolveBafaVariantAssessmentStatus(eligibilityStatus) {
	switch (eligibilityStatus) {
		case "eligible": return "achieved";
		case "ineligible": return "not_achieved";
		case "indeterminate": return "indeterminate";
		default: return eligibilityStatus;
	}
}
function evaluateBafaEligibleMeasureRule(candidates) {
	const hasEligibleMeasure = candidates.length > 0;
	return createRuleResult({
		ruleCode: "EEM-1",
		blocking: true,
		outcome: hasEligibleMeasure ? "passed" : "failed",
		reasonCode: hasEligibleMeasure ? "eligible_individual_measure_selected" : "no_eligible_individual_measure_selected",
		observedValues: [ruleValue("eligibleMeasureCount", candidates.length, "count")]
	});
}
function evaluateBafaTechnicalMinimumRequirementRule(measureEvaluations) {
	const outcome = aggregateAnyPassingRuleOutcomes(measureEvaluations.map((measure) => measure.outcome));
	const passingMeasures = measureEvaluations.filter((measure) => measure.outcome === "passed");
	const hasIndeterminateMeasure = measureEvaluations.some((measure) => measure.outcome === "indeterminate");
	const missingInputs = [];
	if (hasIndeterminateMeasure) missingInputs.push("COMPONENT_POST_U_VALUE");
	if (passingMeasures.some((measure) => measure.eligibleCosts == null)) missingInputs.push("COMPONENT_ELIGIBLE_COSTS");
	let reasonCode = "no_measure_meets_technical_requirements";
	if (outcome === "passed") reasonCode = "at_least_one_measure_meets_technical_requirements";
	else if (outcome === "indeterminate") reasonCode = "measure_technical_requirements_indeterminate";
	return {
		outcome,
		measures: measureEvaluations,
		passingMeasures,
		missingInputs,
		rule: createRuleResult({
			ruleCode: "EEM-2",
			blocking: true,
			outcome,
			reasonCode,
			observedValues: measureEvaluations.map((measure) => ruleValue(`${measure.catalogId}.uValue`, measure.uValue, "watt_per_square_meter_kelvin")),
			comparedConfigValues: measureEvaluations.map((measure) => ruleValue(`${measure.catalogId}.maximumUValue`, measure.maximumUValue, "watt_per_square_meter_kelvin"))
		})
	};
}
function resolveBafaVariantEligibility(eligibleMeasureOutcome, technicalOutcome) {
	if (eligibleMeasureOutcome === "failed" || technicalOutcome === "failed") return "ineligible";
	if (eligibleMeasureOutcome === "indeterminate" || technicalOutcome === "indeterminate") return "indeterminate";
	return "eligible";
}
function evaluateMeasure(component, context, config) {
	const post = component.post;
	if (post == null) return {
		component: component.component,
		catalogId: "",
		outcome: "indeterminate",
		uValue: null,
		maximumUValue: null,
		eligibleCosts: null
	};
	const maximumUValue = getMaximumUValue(component.component, config);
	const uValue = maximumUValue == null ? null : post.performance ?? null;
	const outcome = evaluateMaximumThresholdOutcome(uValue, maximumUValue);
	return {
		component: component.component,
		catalogId: post.catalogId,
		outcome,
		uValue,
		maximumUValue,
		eligibleCosts: getRiskAdjustedMeasureCost(context, component.component)
	};
}
function getMaximumUValue(component, config) {
	switch (component) {
		case "FacadeInsulation": return config.technicalRequirements.externalWallInsulationMaximumUValue;
		case "RoofInsulation": return config.technicalRequirements.roofInsulationMaximumUValue;
		case "Windows": return config.technicalRequirements.windowsMaximumUValue;
		case "TopFloorCeiling": return config.technicalRequirements.topFloorCeilingInsulationMaximumUValue;
		case "CellarCeilingInsulation": return config.technicalRequirements.cellarCeilingInsulationMaximumUValue;
		case "HydraulicBalancing":
		case "HeatingPipelineInsulation": return null;
		case "General":
		case "ThermalBridge":
		case "RoofConversion":
		case "RoofExpansion":
		case "RoofEnergyProduction":
		case "HeatingSystem":
		case "Ventilation":
		case "SeparateNewBuild":
		case "PipeRenovation":
		case "Doors":
		case "Balconies":
		case "UndergroundGarage": return null;
		default: throw new Error();
	}
}
function calculateBafaBenefit(eligibleCosts, residentialUnits, hasIndividualRenovationRoadmap, technicalRule, context, config) {
	if (technicalRule.passingMeasures.some((measure) => measure.eligibleCosts == null) || residentialUnits == null || residentialUnits <= 0 || hasIndividualRenovationRoadmap == null) return null;
	const annualCostCeiling = calculateBafaBegEmCostCeiling(residentialUnits, hasIndividualRenovationRoadmap, config);
	const minimumInvestmentVolume = calculateBafaBegEmCostCeiling(residentialUnits, false, config);
	const individualRenovationRoadmapBonusRate = hasIndividualRenovationRoadmap ? config.individualRenovationRoadmapBonusRate : 0;
	const fundedEligibleCosts = Math.min(eligibleCosts, annualCostCeiling);
	const bonusEligibleCosts = hasIndividualRenovationRoadmap ? Math.max(0, fundedEligibleCosts - minimumInvestmentVolume) : 0;
	const mainGrant = fundedEligibleCosts * config.baseGrantRate + bonusEligibleCosts * individualRenovationRoadmapBonusRate;
	const grantRate = fundedEligibleCosts > 0 ? mainGrant / fundedEligibleCosts : null;
	const planningCosts = calculateAncillaryConstructionCosts(eligibleCosts, context);
	const planningEligibleCostCap = calculateBafaPlanningEligibleCostCap(residentialUnits, config);
	const planningAndSupervisionGrant = Math.min(planningCosts, planningEligibleCostCap) * config.planningAndSupervisionGrantRate;
	return {
		benefit: {
			type: "direct_grant",
			eligibleCosts: fundedEligibleCosts,
			grantRate,
			totalGrant: mainGrant + planningAndSupervisionGrant,
			components: [{
				code: "main_grant",
				amount: mainGrant
			}, {
				code: "planning_and_supervision",
				amount: planningAndSupervisionGrant
			}]
		},
		breakdown: {
			programCode: "BAFA_BEG_EM",
			uncappedEligibleMeasureCosts: eligibleCosts,
			annualCostCeiling,
			minimumInvestmentVolume,
			baseGrantRate: config.baseGrantRate,
			individualRenovationRoadmapBonusRate,
			planningCosts,
			planningEligibleCostCap,
			planningAndSupervisionGrantRate: config.planningAndSupervisionGrantRate
		}
	};
}
function calculateBafaBegEmCostCeiling(residentialUnits, hasIndividualRenovationRoadmap, config) {
	return sumResidentialUnitInclusiveCostBands(residentialUnits, config.residentialUnitCostCeilings.map((band) => ({
		minResidentialUnit: band.minResidentialUnit,
		maxResidentialUnit: band.maxResidentialUnit,
		amount: hasIndividualRenovationRoadmap ? band.valueWithISFP : band.valueWithoutISFP
	})));
}
function calculateBafaPlanningEligibleCostCap(residentialUnits, config) {
	if (residentialUnits <= BAFA_PLANNING_SMALL_BUILDING_MAXIMUM_RESIDENTIAL_UNITS) return config.planningAndSupervisionSmallBuildingAbsoluteCeiling;
	return Math.min(config.planningAndSupervisionCeilingPerResidentialUnit * residentialUnits, config.planningAndSupervisionAbsoluteCeiling);
}
var BAFA_PLANNING_SMALL_BUILDING_MAXIMUM_RESIDENTIAL_UNITS, BAFA_ELIGIBLE_COMPONENTS;
var init_bafa_beg_em = __esmMin((() => {
	init_capex_ee_calculator_model();
	init_subsidy_result_model();
	init_eligible_costs();
	init_rule_result();
	init_tiered_residential_unit_ceiling();
	BAFA_PLANNING_SMALL_BUILDING_MAXIMUM_RESIDENTIAL_UNITS = 2;
	BAFA_ELIGIBLE_COMPONENTS = [
		"FacadeInsulation",
		"RoofInsulation",
		"Windows",
		"TopFloorCeiling",
		"CellarCeilingInsulation",
		"HydraulicBalancing",
		"HeatingPipelineInsulation"
	];
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/subsidies/shared/efficiency-house-stage.ts
/**
* Canonical EE-track rows used by IFB / FKG so NH stage rows do not change their stage ordering.
*/
function getCanonicalEeEfficiencyHouseStages(stages) {
	return stages.filter((stage) => stage.track === "EE");
}
function filterEfficiencyHouseStagesByTrack(stages, track) {
	return stages.filter((stage) => stage.track === track);
}
function orderEfficiencyHouseStages(stages) {
	return stages.toSorted((left, right) => {
		const stageDelta = EFFICIENCY_HOUSE_STAGE_PRIORITY[left.stage] - EFFICIENCY_HOUSE_STAGE_PRIORITY[right.stage];
		if (stageDelta !== 0) return stageDelta;
		return left.track === right.track ? 0 : left.track === "EE" ? -1 : 1;
	});
}
function resolveEfficiencyHouseStage(stages, primaryEnergyDemandPercentOfReference, transmissionHeatLossPercentOfReference) {
	if (primaryEnergyDemandPercentOfReference == null) return null;
	const orderedStages = orderEfficiencyHouseStages(stages.filter((stage) => stage.isEnabled));
	return (transmissionHeatLossPercentOfReference == null ? orderedStages.filter((stage) => stage.maximumTransmissionHeatLossPercentOfReference == null) : orderedStages).find((stage) => {
		if (primaryEnergyDemandPercentOfReference > stage.maximumPrimaryEnergyDemandPercentOfReference) return false;
		return stage.maximumTransmissionHeatLossPercentOfReference == null || transmissionHeatLossPercentOfReference != null && transmissionHeatLossPercentOfReference <= stage.maximumTransmissionHeatLossPercentOfReference;
	}) ?? null;
}
function meetsEfficiencyHouseStage(actual, required) {
	return EFFICIENCY_HOUSE_STAGE_PRIORITY[actual] <= EFFICIENCY_HOUSE_STAGE_PRIORITY[required];
}
var EFFICIENCY_HOUSE_STAGE_PRIORITY;
var init_efficiency_house_stage = __esmMin((() => {
	init_subsidy_result_model();
	EFFICIENCY_HOUSE_STAGE_PRIORITY = {
		["EFFICIENCY_HOUSE_40"]: 0,
		["EFFICIENCY_HOUSE_55"]: 1,
		["EFFICIENCY_HOUSE_70"]: 2,
		["EFFICIENCY_HOUSE_85"]: 3,
		["EFFICIENCY_HOUSE_MONUMENT"]: 4
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/subsidies/programs/fkg-munich.ts
function evaluateFkgMunich(context, config, stages, dependencies) {
	const missingInputs = [];
	const locationRule = evaluateFkgMunichLocationRule(context, config);
	missingInputs.push(...locationRule.missingInputs);
	const federalProgramRule = evaluateFkgMunichEligibleFederalProgramRule(dependencies);
	const efficiencyHouseStageRule = evaluateFkgMunichMinimumEfficiencyHouseStageRule(context, stages, config);
	missingInputs.push(...efficiencyHouseStageRule.missingInputs);
	const preRenovationEnergyClassRule = evaluateFkgMunichPreRenovationEnergyClassRule(context, config);
	missingInputs.push(...preRenovationEnergyClassRule.missingInputs);
	if (context.inputs.residentialUnits == null) missingInputs.push("RESIDENTIAL_UNITS");
	const moduleEvaluations = [
		evaluateEfficiencyHouseModule(context, config, dependencies.kfw261, locationRule.outcome, efficiencyHouseStageRule.rule.outcome, preRenovationEnergyClassRule),
		evaluateIndividualMeasuresModule(context, config, dependencies.bafaBegEm, locationRule.outcome),
		evaluateHeatingReplacementModule(context, config, dependencies.kfw459, locationRule.outcome)
	];
	const selectedModule = selectFkgMunichModule(moduleEvaluations);
	const selectedVariant = selectedModule == null ? null : {
		programCode: "FKG_MUNICH",
		module: selectedModule.module
	};
	const benefit = selectedModule?.calculation.benefit ?? null;
	const breakdown = selectedModule?.calculation.breakdown ?? null;
	const additionalWarningCodes = moduleEvaluations.some((module) => module.calculation.federalFundingCapCouldNotBeApplied) ? ["FKG_FEDERAL_FUNDING_CAP_COULD_NOT_BE_APPLIED"] : [];
	return createProgramResult({
		config,
		ruleOutcomes: [
			locationRule.rule,
			federalProgramRule.rule,
			efficiencyHouseStageRule.rule,
			preRenovationEnergyClassRule.rule
		],
		missingInputs,
		selectedVariant,
		benefit,
		breakdown,
		variantAssessments: createFkgMunichModuleAssessments(moduleEvaluations),
		additionalWarningCodes
	});
}
function evaluateFkgMunichLocationRule(context, config) {
	const city = context.inputs.city;
	const isMunich = isMunichCity(city, config.eligibleRegion);
	let outcome = "failed";
	let reasonCode = "not_located_in_munich";
	if (city == null) {
		outcome = "indeterminate";
		reasonCode = "city_missing";
	} else if (isMunich) {
		outcome = "passed";
		reasonCode = "located_in_munich";
	}
	return {
		outcome,
		missingInputs: city == null ? ["CITY"] : [],
		rule: createRuleResult({
			ruleCode: "EFKG-1",
			blocking: true,
			outcome,
			reasonCode,
			observedValues: [ruleValue("city", city ?? null)],
			comparedConfigValues: [ruleValue("eligibleRegion", config.eligibleRegion)]
		})
	};
}
function evaluateFkgMunichEligibleFederalProgramRule(dependencies) {
	const dependencyResults = [
		dependencies.kfw261,
		dependencies.bafaBegEm,
		dependencies.kfw459
	];
	const eligibleProgramCount = dependencyResults.filter((result) => result.eligibilityStatus === "eligible").length;
	const hasIndeterminateDependency = dependencyResults.some((result) => result.eligibilityStatus === "indeterminate");
	let outcome = "failed";
	let reasonCode = "federal_programs_ineligible";
	if (eligibleProgramCount > 0) {
		outcome = "passed";
		reasonCode = "eligible_federal_program_exists";
	} else if (hasIndeterminateDependency) {
		outcome = "indeterminate";
		reasonCode = "federal_programs_indeterminate";
	}
	return {
		outcome,
		rule: createRuleResult({
			ruleCode: "EFKG-2",
			blocking: true,
			outcome,
			reasonCode,
			observedValues: [ruleValue("eligibleFederalProgramCount", eligibleProgramCount, "count")]
		})
	};
}
function evaluateFkgMunichMinimumEfficiencyHouseStageRule(context, stages, config) {
	const primaryRatio = context.energy.primaryEnergyDemandInclExpansionInclPvPercentOfReference;
	const transmissionRatio = context.energy.transmissionHeatLossPercentOfReference;
	const hasStageInputs = primaryRatio != null && transmissionRatio != null;
	const stage = hasStageInputs ? resolveEfficiencyHouseStage(stages, primaryRatio, transmissionRatio) : null;
	const missingInputs = [];
	if (primaryRatio == null) missingInputs.push("PRIMARY_ENERGY_DEMAND_INCL_EXPANSION_INCL_PV_PERCENT_OF_REFERENCE");
	if (transmissionRatio == null) missingInputs.push("TRANSMISSION_HEAT_LOSS_PERCENT_OF_REFERENCE");
	let outcome = "failed";
	let reasonCode = "efficiency_house_stage_below_minimum";
	if (!hasStageInputs) {
		outcome = "indeterminate";
		reasonCode = "efficiency_house_stage_inputs_missing";
	} else if (stage != null && meetsEfficiencyHouseStage(stage.stage, config.minimumEfficiencyHouseStage)) {
		outcome = "passed";
		reasonCode = "efficiency_house_stage_reached";
	}
	return {
		missingInputs: hasStageInputs ? [] : missingInputs,
		rule: createRuleResult({
			ruleCode: "EFKG-3",
			blocking: false,
			outcome,
			reasonCode,
			observedValues: [
				ruleValue("primaryEnergyDemandInclExpansionInclPvPercentOfReference", primaryRatio, "percent"),
				ruleValue("transmissionHeatLossPercentOfReference", transmissionRatio, "percent"),
				ruleValue("efficiencyHouseStage", stage?.stage ?? null)
			],
			comparedConfigValues: [ruleValue("minimumEfficiencyHouseStage", config.minimumEfficiencyHouseStage)]
		})
	};
}
function evaluateFkgMunichPreRenovationEnergyClassRule(context, config) {
	const finalEnergy = context.inputs.currentFinalEnergyConsumption;
	const grossFloorArea = context.inputs.grossFloorArea;
	const finalEnergyPerSquareMeter = finalEnergy != null && grossFloorArea != null && grossFloorArea > 0 ? finalEnergy / grossFloorArea : null;
	const energyClass = finalEnergyPerSquareMeter == null ? null : convertEnergyConsumptionToEnergyConsumptionCategory(finalEnergyPerSquareMeter) ?? null;
	const missingInputs = [];
	if (finalEnergy == null) missingInputs.push("CURRENT_FINAL_ENERGY_CONSUMPTION");
	if (grossFloorArea == null) missingInputs.push("GROSS_FLOOR_AREA");
	if (energyClass == null) missingInputs.push("PRE_RENOVATION_ENERGY_CLASS");
	let outcome = "failed";
	let reasonCode = "pre_renovation_energy_class_ineligible";
	if (energyClass == null) {
		outcome = "indeterminate";
		reasonCode = "pre_renovation_energy_class_inputs_missing";
	} else if (config.eligiblePreRenovationEnergyClasses.includes(energyClass)) {
		outcome = "passed";
		reasonCode = "pre_renovation_energy_class_eligible";
	}
	return {
		outcome,
		energyClass,
		missingInputs: energyClass == null ? missingInputs : [],
		rule: createRuleResult({
			ruleCode: "EFKG-4",
			blocking: false,
			outcome,
			reasonCode,
			observedValues: [ruleValue("preRenovationFinalEnergyDemandPerSquareMeter", finalEnergyPerSquareMeter, "kilowatt_hour_per_square_meter_year"), ruleValue("preRenovationEnergyClass", energyClass)],
			comparedConfigValues: config.eligiblePreRenovationEnergyClasses.map((energyClassValue) => ruleValue("eligiblePreRenovationEnergyClass", energyClassValue))
		})
	};
}
function evaluateEfficiencyHouseModule(context, config, kfw261, locationOutcome, efficiencyHouseStageOutcome, preRenovationEnergyClassRule) {
	const eligibilityStatus = resolveModuleEligibility(locationOutcome, kfw261.eligibilityStatus, [efficiencyHouseStageOutcome, preRenovationEnergyClassRule.outcome]);
	const federalEligibleCosts = getQuantifiableFederalEligibleCosts(kfw261);
	return {
		module: "EFFICIENCY_HOUSE_EXISTING",
		eligibilityStatus,
		federalProgramCode: "KFW_261",
		calculation: calculateCappedModuleGrant({
			module: "EFFICIENCY_HOUSE_EXISTING",
			federalProgramCode: "KFW_261",
			eligibleCostSource: federalEligibleCosts == null ? "scenario_energetic_capex" : "federal_program",
			eligibleCosts: federalEligibleCosts ?? getEnergeticModernisationCosts(context),
			federalGrantAmount: getQuantifiableFederalGrantAmount(kfw261),
			isGrantEligible: isFkgEfficiencyHouseStageEligible(kfw261),
			energyClass: preRenovationEnergyClassRule.energyClass,
			context,
			config
		})
	};
}
function evaluateIndividualMeasuresModule(context, config, bafaBegEm, locationOutcome) {
	const eligibilityStatus = resolveModuleEligibility(locationOutcome, bafaBegEm.eligibilityStatus, []);
	const energyClass = resolvePreRenovationEnergyClass(context);
	return {
		module: "INDIVIDUAL_MEASURES",
		eligibilityStatus,
		federalProgramCode: "BAFA_BEG_EM",
		calculation: calculateCappedModuleGrant({
			module: "INDIVIDUAL_MEASURES",
			federalProgramCode: "BAFA_BEG_EM",
			eligibleCostSource: "federal_program",
			eligibleCosts: getQuantifiableFederalEligibleCosts(bafaBegEm),
			federalGrantAmount: getQuantifiableFederalGrantAmount(bafaBegEm),
			isGrantEligible: true,
			energyClass,
			context,
			config
		})
	};
}
function evaluateHeatingReplacementModule(context, config, kfw459, locationOutcome) {
	const eligibilityStatus = resolveModuleEligibility(locationOutcome, kfw459.eligibilityStatus, []);
	const eligibleCosts = getQuantifiableFederalEligibleCosts(kfw459);
	const grantRate = config.heatingReplacementGrantRate;
	const grantUncapped = eligibleCosts == null ? 0 : eligibleCosts * grantRate;
	return {
		module: "HEATING_REPLACEMENT",
		eligibilityStatus,
		federalProgramCode: "KFW_459",
		calculation: {
			benefit: eligibleCosts == null ? null : {
				type: "direct_grant",
				eligibleCosts,
				grantRate,
				totalGrant: grantUncapped,
				components: [{
					code: "main_grant",
					amount: grantUncapped
				}]
			},
			breakdown: eligibleCosts == null ? null : {
				programCode: "FKG_MUNICH",
				module: "HEATING_REPLACEMENT",
				federalProgramCode: "KFW_459",
				eligibleCostSource: "federal_program",
				federalEligibleCosts: eligibleCosts,
				baseGrantRate: grantRate,
				energyClassBonusRate: 0,
				multiUnitBonusRate: 0,
				grantUncapped,
				federalFundingCapApplied: false
			},
			grantRate,
			federalFundingCapApplied: false,
			federalFundingCapCouldNotBeApplied: false
		}
	};
}
function calculateCappedModuleGrant(params) {
	const { module, federalProgramCode, eligibleCostSource, eligibleCosts, federalGrantAmount, isGrantEligible, energyClass, context, config } = params;
	if (eligibleCosts == null || eligibleCosts <= 0) return {
		benefit: null,
		breakdown: null,
		grantRate: null,
		federalFundingCapApplied: false,
		federalFundingCapCouldNotBeApplied: false
	};
	if (!isGrantEligible) return {
		grantRate: 0,
		federalFundingCapApplied: false,
		federalFundingCapCouldNotBeApplied: false,
		benefit: {
			type: "direct_grant",
			eligibleCosts,
			grantRate: 0,
			totalGrant: 0,
			components: [{
				code: "main_grant",
				amount: 0
			}]
		},
		breakdown: {
			programCode: "FKG_MUNICH",
			module,
			federalProgramCode,
			eligibleCostSource,
			federalEligibleCosts: eligibleCosts,
			baseGrantRate: 0,
			energyClassBonusRate: 0,
			multiUnitBonusRate: 0,
			grantUncapped: 0,
			federalFundingCapApplied: false
		}
	};
	const rateComponents = resolveVariableGrantRateComponents(energyClass, context.inputs.residentialUnits, config);
	const grantRate = rateComponents.baseGrantRate + rateComponents.energyClassBonusRate + rateComponents.multiUnitBonusRate;
	const grantUncapped = eligibleCosts * grantRate;
	const breakdownBase = {
		programCode: "FKG_MUNICH",
		module,
		federalProgramCode,
		eligibleCostSource,
		federalEligibleCosts: eligibleCosts,
		baseGrantRate: rateComponents.baseGrantRate,
		energyClassBonusRate: rateComponents.energyClassBonusRate,
		multiUnitBonusRate: rateComponents.multiUnitBonusRate,
		grantUncapped
	};
	if (federalGrantAmount == null) return {
		grantRate,
		federalFundingCapApplied: false,
		federalFundingCapCouldNotBeApplied: true,
		benefit: {
			type: "direct_grant",
			eligibleCosts,
			grantRate,
			totalGrant: grantUncapped,
			components: [{
				code: "main_grant",
				amount: grantUncapped
			}]
		},
		breakdown: {
			...breakdownBase,
			federalFundingCapApplied: false
		}
	};
	const cappedGrant = Math.max(0, Math.min(grantUncapped, config.federalFundingCapFactor * eligibleCosts - federalGrantAmount));
	return {
		grantRate,
		federalFundingCapApplied: true,
		federalFundingCapCouldNotBeApplied: false,
		benefit: {
			type: "direct_grant",
			eligibleCosts,
			grantRate,
			totalGrant: cappedGrant,
			components: [{
				code: "main_grant",
				amount: cappedGrant
			}]
		},
		breakdown: {
			...breakdownBase,
			federalFundingCapApplied: true
		}
	};
}
function resolveVariableGrantRateComponents(energyClass, residentialUnits, config) {
	return {
		baseGrantRate: config.baseGrantRate,
		energyClassBonusRate: energyClass != null && config.energyClassBonusClasses.includes(energyClass) ? config.energyClassBonusRate : 0,
		multiUnitBonusRate: residentialUnits != null && residentialUnits >= config.multiUnitBonusMinimumResidentialUnits ? config.multiUnitBonusRate : 0
	};
}
function createFkgMunichModuleAssessments(modules) {
	return modules.map((module) => ({
		programCode: "FKG_MUNICH",
		module: module.module,
		status: resolveModuleAssessmentStatus(module),
		eligibilityStatus: module.eligibilityStatus,
		grantRate: module.calculation.grantRate,
		federalProgramCode: module.federalProgramCode,
		federalFundingCapApplied: module.calculation.federalFundingCapApplied,
		potentialBenefit: module.calculation.benefit,
		potentialBreakdown: module.calculation.breakdown
	}));
}
function selectFkgMunichModule(modules) {
	const eligibleModules = modules.filter((module) => module.eligibilityStatus === "eligible" && module.calculation.benefit != null);
	const candidates = eligibleModules.length > 0 ? eligibleModules : modules.filter((module) => module.calculation.benefit != null);
	if (candidates.length === 0) return null;
	return candidates.reduce((best, candidate) => (candidate.calculation.benefit?.totalGrant ?? 0) > (best.calculation.benefit?.totalGrant ?? 0) ? candidate : best);
}
function resolveModuleEligibility(locationOutcome, federalStatus, additionalOutcomes) {
	if (locationOutcome === "failed" || federalStatus === "ineligible" || additionalOutcomes.includes("failed")) return "ineligible";
	if (locationOutcome === "indeterminate" || federalStatus === "indeterminate" || additionalOutcomes.includes("indeterminate")) return "indeterminate";
	return "eligible";
}
function resolveModuleAssessmentStatus(module) {
	if (module.eligibilityStatus === "indeterminate") return "indeterminate";
	if (module.eligibilityStatus === "eligible") return "achieved";
	return "not_achieved";
}
function getQuantifiableFederalEligibleCosts(result) {
	if (result.benefit == null) return null;
	return result.benefit.eligibleCosts;
}
function getQuantifiableFederalGrantAmount(result) {
	if (result.benefit == null) return null;
	if (result.benefit.type === "direct_grant") return result.benefit.totalGrant;
	if (result.benefit.type === "loan_with_repayment_grant") return result.benefit.totalRepaymentGrant;
	return null;
}
function isFkgEfficiencyHouseStageEligible(kfw261) {
	if (kfw261.selectedVariant?.programCode !== "KFW_261") return true;
	return kfw261.selectedVariant.efficiencyHouseStage === "EFFICIENCY_HOUSE_40" || kfw261.selectedVariant.efficiencyHouseStage === "EFFICIENCY_HOUSE_55";
}
function resolvePreRenovationEnergyClass(context) {
	const finalEnergy = context.inputs.currentFinalEnergyConsumption;
	const grossFloorArea = context.inputs.grossFloorArea;
	if (finalEnergy == null || grossFloorArea == null || grossFloorArea <= 0) return null;
	return convertEnergyConsumptionToEnergyConsumptionCategory(finalEnergy / grossFloorArea) ?? null;
}
function isMunichCity(city, eligibleRegion) {
	if (city == null) return false;
	const normalizedCity = deburr(city).trim().toLowerCase();
	return normalizedCity === deburr(eligibleRegion).trim().toLowerCase() || normalizedCity === ENGLISH_MUNICH_CITY;
}
var ENGLISH_MUNICH_CITY;
var init_fkg_munich = __esmMin((() => {
	init_energy_efficiency();
	init_subsidy_result_model();
	init_eligible_costs();
	init_efficiency_house_stage();
	init_rule_result();
	ENGLISH_MUNICH_CITY = "munich";
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/subsidies/programs/ifb-modernisierung-a.ts
function evaluateIfbModernisierungA(context, config, efficiencyHouseStages) {
	const missingInputs = [];
	const locationRule = evaluateIfbModernisationLocationRule(context, config);
	missingInputs.push(...locationRule.missingInputs);
	const savingsRule = evaluateIfbModernisationMinimumSavingsRule(context, config);
	missingInputs.push(...savingsRule.missingInputs);
	const stageResolution = resolveIfbModernisationStage(context, config, efficiencyHouseStages);
	const stageRule = evaluateIfbModernisationStageRule(context, stageResolution);
	missingInputs.push(...stageRule.missingInputs);
	const residentialUnits = context.inputs.residentialUnits;
	const totalRentableArea = context.inputs.totalRentableArea;
	const numberOfBuildings = context.inputs.numberOfBuildings;
	const brickFacadeArea = context.inputs.brickFacadeArea;
	if (residentialUnits == null || residentialUnits <= 0) missingInputs.push("RESIDENTIAL_UNITS");
	if (totalRentableArea == null || totalRentableArea <= 0) missingInputs.push("TOTAL_RENTABLE_AREA");
	if (numberOfBuildings == null || numberOfBuildings <= 0) missingInputs.push("NUMBER_OF_BUILDINGS");
	if (brickFacadeArea == null) missingInputs.push("BRICK_FACADE_AREA");
	const benefitCalculation = calculateIfbModernisierungABenefit(getEnergeticModernisationCosts(context), residentialUnits, totalRentableArea, numberOfBuildings, brickFacadeArea, stageResolution.stage, config);
	const variantAssessments = createIfbModernisationStageAssessments(context, config, efficiencyHouseStages, locationRule.outcome, savingsRule.outcome);
	return createProgramResult({
		config,
		ruleOutcomes: [
			locationRule.rule,
			savingsRule.rule,
			stageRule.rule
		],
		missingInputs,
		selectedVariant: stageResolution.stage == null ? null : {
			programCode: "IFB_MODERNISIERUNG_A",
			stage: stageResolution.stage.stage
		},
		benefit: benefitCalculation?.benefit ?? null,
		breakdown: benefitCalculation?.breakdown ?? null,
		variantAssessments
	});
}
function createIfbModernisationStageAssessments(context, config, efficiencyHouseStages, locationOutcome, savingsOutcome) {
	const totalRentableArea = context.inputs.totalRentableArea;
	const residentialUnits = context.inputs.residentialUnits;
	const numberOfBuildings = context.inputs.numberOfBuildings;
	const brickFacadeArea = context.inputs.brickFacadeArea;
	const postFinalEnergy = context.energy.postFinalEnergyDemandExclExpansion;
	const actualFinalEnergyDemandPerSquareMeter = totalRentableArea != null && totalRentableArea > 0 && postFinalEnergy != null ? postFinalEnergy / totalRentableArea : null;
	const hasEfficiencyHouseInputs = context.energy.primaryEnergyDemandInclExpansionExclPvPercentOfReference != null && context.energy.transmissionHeatLossPercentOfReference != null;
	const actualEfficiencyHouseStage = hasEfficiencyHouseInputs ? resolveEfficiencyHouseStage(efficiencyHouseStages, context.energy.primaryEnergyDemandInclExpansionExclPvPercentOfReference, context.energy.transmissionHeatLossPercentOfReference) : null;
	const isHeatPump = classifySubsidyHeatingSystem(getSelectedComponent(context, "HeatingSystem")) === "HEAT_PUMP";
	const eligibleCosts = getEnergeticModernisationCosts(context);
	return config.stages.toSorted((left, right) => IFB_STAGE_PRIORITY[left.stage] - IFB_STAGE_PRIORITY[right.stage]).map((stage) => {
		const hasCriterionInput = stage.criterion === "FINAL_ENERGY_DEMAND" ? actualFinalEnergyDemandPerSquareMeter != null : hasEfficiencyHouseInputs;
		const isReached = isIfbModernisationStageReached(stage, actualFinalEnergyDemandPerSquareMeter, actualEfficiencyHouseStage, isHeatPump);
		const isHeatPumpCompatible = stage.isHeatPumpEligible || !isHeatPump;
		const benefitCalculation = calculateIfbModernisierungABenefit(eligibleCosts, residentialUnits, totalRentableArea, numberOfBuildings, brickFacadeArea, stage, config);
		return {
			programCode: "IFB_MODERNISIERUNG_A",
			stage: stage.stage,
			status: resolveIfbStageAssessmentStatus(hasCriterionInput, isReached),
			eligibilityStatus: resolveIfbVariantEligibility(locationOutcome, savingsOutcome, hasCriterionInput, isReached),
			criterion: stage.criterion,
			maximumFinalEnergyDemandPerSquareMeter: stage.criterion === "FINAL_ENERGY_DEMAND" ? stage.maximumFinalEnergyDemandPerSquareMeter : null,
			requiredEfficiencyHouseStage: stage.criterion === "EFFICIENCY_HOUSE_STAGE" ? stage.efficiencyHouseStage : null,
			actualFinalEnergyDemandPerSquareMeter,
			actualEfficiencyHouseStage: actualEfficiencyHouseStage?.stage ?? null,
			isHeatPumpEligible: stage.isHeatPumpEligible,
			isHeatPumpCompatible,
			grantRatePerSquareMeter: stage.grantRatePerSquareMeter,
			potentialBenefit: benefitCalculation?.benefit ?? null,
			potentialBreakdown: benefitCalculation?.breakdown ?? null
		};
	});
}
function resolveIfbVariantEligibility(locationOutcome, savingsOutcome, hasCriterionInput, isReached) {
	if (locationOutcome === "failed" || savingsOutcome === "failed" || hasCriterionInput && !isReached) return "ineligible";
	if (locationOutcome === "indeterminate" || savingsOutcome === "indeterminate" || !hasCriterionInput) return "indeterminate";
	return "eligible";
}
function resolveIfbStageAssessmentStatus(hasCriterionInput, isReached) {
	if (!hasCriterionInput) return "indeterminate";
	return isReached ? "achieved" : "not_achieved";
}
function evaluateIfbModernisationLocationRule(context, config) {
	const city = context.inputs.city;
	const isHamburg = city != null && city.trim().toUpperCase() === "HAMBURG";
	let outcome = "failed";
	let reasonCode = "not_located_in_hamburg";
	if (city == null) {
		outcome = "indeterminate";
		reasonCode = "city_missing";
	} else if (isHamburg) {
		outcome = "passed";
		reasonCode = "located_in_hamburg";
	}
	return {
		outcome,
		missingInputs: city == null ? ["CITY"] : [],
		rule: createRuleResult({
			ruleCode: "EIFB-1",
			blocking: true,
			outcome,
			reasonCode,
			observedValues: [ruleValue("city", city ?? null)],
			comparedConfigValues: [ruleValue("eligibleRegion", config.eligibleRegion)]
		})
	};
}
function evaluateIfbModernisationMinimumSavingsRule(context, config) {
	const primaryEnergySaving = context.energy.primaryEnergySavingPctExclExpansionExclPv;
	const finalEnergySaving = context.energy.finalEnergySavingPctExclExpansion;
	const heatDemandSaving = context.energy.heatDemandSavingPctExclExpansion;
	const missingInputs = [];
	if (primaryEnergySaving == null) missingInputs.push("PRIMARY_ENERGY_SAVING_BEFORE_PV");
	if (finalEnergySaving == null) missingInputs.push("FINAL_ENERGY_SAVING");
	if (heatDemandSaving == null) missingInputs.push("HEAT_DEMAND_SAVING");
	let outcome = "failed";
	let reasonCode = "minimum_savings_not_reached";
	if (missingInputs.length > 0) {
		outcome = "indeterminate";
		reasonCode = "savings_inputs_missing";
	} else if (primaryEnergySaving >= config.minimumPrimaryEnergySavingRateBeforePv && finalEnergySaving >= config.minimumFinalEnergySavingRate && heatDemandSaving >= config.minimumHeatDemandSavingRate) {
		outcome = "passed";
		reasonCode = "minimum_savings_reached";
	}
	return {
		outcome,
		missingInputs,
		rule: createRuleResult({
			ruleCode: "EIFB-2",
			blocking: true,
			outcome,
			reasonCode,
			observedValues: [
				ruleValue("primaryEnergySavingPctExclExpansionExclPv", primaryEnergySaving, "percent"),
				ruleValue("finalEnergySavingPctExclExpansion", finalEnergySaving, "percent"),
				ruleValue("heatDemandSavingPctExclExpansion", heatDemandSaving, "percent")
			],
			comparedConfigValues: [
				ruleValue("minimumPrimaryEnergySavingRateBeforePv", config.minimumPrimaryEnergySavingRateBeforePv, "percent"),
				ruleValue("minimumFinalEnergySavingRate", config.minimumFinalEnergySavingRate, "percent"),
				ruleValue("minimumHeatDemandSavingRate", config.minimumHeatDemandSavingRate, "percent")
			]
		})
	};
}
function evaluateIfbModernisationStageRule(context, stageResolution) {
	const missingInputs = [];
	if (stageResolution.finalEnergyDemandPerSquareMeter == null) missingInputs.push("POST_FINAL_ENERGY_DEMAND_PER_SQUARE_METER");
	if (context.energy.primaryEnergyDemandInclExpansionExclPvPercentOfReference == null) missingInputs.push("PRIMARY_ENERGY_DEMAND_INCL_EXPANSION_EXCL_PV_PERCENT_OF_REFERENCE");
	if (context.energy.transmissionHeatLossPercentOfReference == null) missingInputs.push("TRANSMISSION_HEAT_LOSS_PERCENT_OF_REFERENCE");
	let outcome = "failed";
	let reasonCode = "ifb_stage_not_reached";
	if (stageResolution.isIndeterminate) {
		outcome = "indeterminate";
		reasonCode = "ifb_stage_inputs_missing";
	} else if (stageResolution.stage != null) {
		outcome = "passed";
		reasonCode = "ifb_stage_reached";
	}
	return {
		outcome,
		missingInputs,
		rule: createRuleResult({
			ruleCode: "EIFB-3",
			blocking: true,
			outcome,
			reasonCode,
			observedValues: [ruleValue("postFinalEnergyDemandExclExpansionPerSquareMeter", stageResolution.finalEnergyDemandPerSquareMeter, "kilowatt_hour_per_square_meter_year")],
			comparedConfigValues: stageResolution.stage == null ? [] : [ruleValue("ifbModernisationStage", stageResolution.stage.stage)]
		})
	};
}
function resolveIfbModernisationStage(context, config, efficiencyHouseStages) {
	const totalRentableArea = context.inputs.totalRentableArea;
	const postFinalEnergy = context.energy.postFinalEnergyDemandExclExpansion;
	const finalEnergyDemandPerSquareMeter = totalRentableArea != null && totalRentableArea > 0 && postFinalEnergy != null ? postFinalEnergy / totalRentableArea : null;
	const hasEfficiencyHouseInputs = context.energy.primaryEnergyDemandInclExpansionExclPvPercentOfReference != null && context.energy.transmissionHeatLossPercentOfReference != null;
	const efficiencyHouseStage = hasEfficiencyHouseInputs ? resolveEfficiencyHouseStage(efficiencyHouseStages, context.energy.primaryEnergyDemandInclExpansionExclPvPercentOfReference, context.energy.transmissionHeatLossPercentOfReference) : null;
	const isHeatPump = classifySubsidyHeatingSystem(getSelectedComponent(context, "HeatingSystem")) === "HEAT_PUMP";
	const orderedStages = config.stages.toSorted((left, right) => IFB_STAGE_PRIORITY[left.stage] - IFB_STAGE_PRIORITY[right.stage]);
	const stage = orderedStages.find((candidate) => isIfbModernisationStageReached(candidate, finalEnergyDemandPerSquareMeter, efficiencyHouseStage, isHeatPump)) ?? null;
	const hasMissingCriterionInput = orderedStages.some((candidate) => candidate.criterion === "FINAL_ENERGY_DEMAND" ? finalEnergyDemandPerSquareMeter == null : !hasEfficiencyHouseInputs);
	return {
		stage,
		isIndeterminate: stage == null && hasMissingCriterionInput,
		finalEnergyDemandPerSquareMeter
	};
}
function isIfbModernisationStageReached(stage, finalEnergyDemandPerSquareMeter, efficiencyHouseStage, isHeatPump) {
	if (!stage.isHeatPumpEligible && isHeatPump) return false;
	switch (stage.criterion) {
		case "FINAL_ENERGY_DEMAND": return finalEnergyDemandPerSquareMeter != null && finalEnergyDemandPerSquareMeter <= stage.maximumFinalEnergyDemandPerSquareMeter;
		case "EFFICIENCY_HOUSE_STAGE": return efficiencyHouseStage != null && meetsEfficiencyHouseStage(efficiencyHouseStage.stage, stage.efficiencyHouseStage);
		default: throw new Error();
	}
}
function calculateIfbModernisierungABenefit(eligibleCosts, residentialUnits, totalRentableArea, numberOfBuildings, brickFacadeArea, stage, config) {
	if (residentialUnits == null || residentialUnits <= 0 || totalRentableArea == null || totalRentableArea <= 0 || numberOfBuildings == null || numberOfBuildings <= 0 || brickFacadeArea == null || stage == null) return null;
	const fundedArea = Math.min(totalRentableArea, config.livingSpaceCeilingPerResidentialUnit * residentialUnits);
	const mainGrant = stage.grantRatePerSquareMeter * fundedArea;
	const qualityAssuranceGrant = config.qualityAssuranceGrantPerBuilding * numberOfBuildings;
	const brickFacadeGrant = config.brickFacadeGrantPerSquareMeter * brickFacadeArea;
	const supplementaryGrant = qualityAssuranceGrant + brickFacadeGrant;
	return {
		benefit: {
			type: "direct_grant",
			eligibleCosts,
			grantRate: null,
			totalGrant: mainGrant + supplementaryGrant,
			components: [
				{
					code: "main_grant",
					amount: mainGrant
				},
				{
					code: "quality_assurance",
					amount: qualityAssuranceGrant
				},
				{
					code: "brick_facade",
					amount: brickFacadeGrant
				}
			]
		},
		breakdown: {
			programCode: "IFB_MODERNISIERUNG_A",
			mainGrant,
			supplementaryGrant
		}
	};
}
var IFB_STAGE_PRIORITY;
var init_ifb_modernisierung_a = __esmMin((() => {
	init_capex_ee_calculator_model();
	init_subsidy_config_model();
	init_subsidy_result_model();
	init_eligible_costs();
	init_efficiency_house_stage();
	init_rule_result();
	IFB_STAGE_PRIORITY = {
		["IFB_STAGE_5"]: 0,
		["IFB_STAGE_4"]: 1,
		["IFB_STAGE_3"]: 2,
		["IFB_STAGE_2"]: 3,
		["IFB_STAGE_1"]: 4
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/subsidies/programs/kfw-261-eligibility.ts
function resolveActiveEfficiencyHouseTrack(context) {
	return context.subsidyInputs?.hasSustainabilityCertificate === true ? "NH" : "EE";
}
function evaluateKfw261EfficiencyHouseStageRule(context, stages) {
	const track = resolveActiveEfficiencyHouseTrack(context);
	const trackStages = filterEfficiencyHouseStagesByTrack(stages, track);
	const primaryRatio = context.energy.primaryEnergyDemandInclExpansionInclPvPercentOfReference;
	const transmissionRatio = context.energy.transmissionHeatLossPercentOfReference;
	const hasPrimaryInput = primaryRatio != null;
	const resolvedStage = hasPrimaryInput ? resolveEfficiencyHouseStage(trackStages, primaryRatio, transmissionRatio) : null;
	const enabledTrackStages = trackStages.filter((stageRow) => stageRow.isEnabled);
	const couldReachTransmissionBoundStage = primaryRatio != null && transmissionRatio == null && enabledTrackStages.some((stageRow) => stageRow.maximumTransmissionHeatLossPercentOfReference != null && primaryRatio <= stageRow.maximumPrimaryEnergyDemandPercentOfReference);
	const missingInputs = [];
	if (primaryRatio == null) missingInputs.push("PRIMARY_ENERGY_DEMAND_INCL_EXPANSION_INCL_PV_PERCENT_OF_REFERENCE");
	if (couldReachTransmissionBoundStage && (resolvedStage == null || context.inputs.heritageProtected !== true)) missingInputs.push("TRANSMISSION_HEAT_LOSS_PERCENT_OF_REFERENCE");
	let stage = resolvedStage;
	let outcome = "failed";
	let reasonCode = "efficiency_house_stage_not_reached";
	if (!hasPrimaryInput) {
		outcome = "indeterminate";
		reasonCode = "efficiency_house_stage_inputs_missing";
	} else if (resolvedStage != null && resolvedStage.stage === "EFFICIENCY_HOUSE_MONUMENT") if (context.inputs.heritageProtected === true) {
		outcome = "passed";
		reasonCode = "efficiency_house_stage_reached";
	} else if (couldReachTransmissionBoundStage) {
		stage = null;
		outcome = "indeterminate";
		reasonCode = "efficiency_house_stage_inputs_missing";
	} else {
		stage = null;
		outcome = "failed";
		reasonCode = "monument_protection_missing";
	}
	else if (resolvedStage != null) {
		outcome = "passed";
		reasonCode = "efficiency_house_stage_reached";
	} else if (couldReachTransmissionBoundStage) {
		outcome = "indeterminate";
		reasonCode = "efficiency_house_stage_inputs_missing";
	}
	return {
		stage,
		track,
		missingInputs,
		rule: createRuleResult({
			ruleCode: "E261-1",
			blocking: true,
			outcome,
			reasonCode,
			observedValues: [
				ruleValue("primaryEnergyDemandInclExpansionInclPvPercentOfReference", primaryRatio, "percent"),
				ruleValue("transmissionHeatLossPercentOfReference", transmissionRatio, "percent"),
				ruleValue("track", track),
				ruleValue("heritageProtected", context.inputs.heritageProtected ?? null, "boolean")
			],
			comparedConfigValues: stage == null ? [] : [ruleValue("efficiencyHouseStage", stage.stage), ruleValue("track", stage.track)]
		})
	};
}
function evaluateKfw261RenewableEnergyClassRule(context, stage, config) {
	const heatingSystem = classifySubsidyHeatingSystem(getComponent(context, "HeatingSystem"));
	const hasQualifyingHeatingSystem = heatingSystem != null && config.renewableEnergyClassHeatingSystems.includes(heatingSystem);
	const track = stage?.track ?? resolveActiveEfficiencyHouseTrack(context);
	const hasRenewableEnergyClass = hasQualifyingHeatingSystem;
	return {
		heatingRule: createRuleResult({
			ruleCode: "E261-2",
			blocking: true,
			outcome: hasQualifyingHeatingSystem ? "passed" : "failed",
			reasonCode: hasQualifyingHeatingSystem ? "renewable_energy_class_reached" : "renewable_energy_class_not_reached",
			observedValues: [ruleValue("heatingSystem", heatingSystem), ruleValue("hasQualifyingHeatingSystem", hasQualifyingHeatingSystem, "boolean")],
			comparedConfigValues: [ruleValue("minimumRenewableHeatDemandCoverageRate", config.renewableEnergyClassMinimumHeatDemandCoverageRate, "percent")]
		}),
		branchRule: createRuleResult({
			ruleCode: track === "NH" ? "E261-2-NH" : "E261-2-EE",
			blocking: true,
			outcome: hasQualifyingHeatingSystem ? "passed" : "failed",
			reasonCode: hasRenewableEnergyClass ? "renewable_energy_class_reached" : "renewable_energy_class_not_reached",
			observedValues: [ruleValue("track", track)]
		}),
		hasRenewableEnergyClass,
		hasQualifyingHeatingSystem
	};
}
function evaluateKfw261WorstPerformanceBuildingRule(context, stage, config) {
	const building = evaluateWorstPerformanceBuilding(context, config);
	const isBonusStage = stage != null && stage.worstPerformanceBuildingBonusRate > 0;
	const hasBonus = resolveWorstPerformanceBuildingBonus(building.outcome, stage);
	let outcome = "failed";
	let reasonCode = "worst_performance_building_bonus_does_not_apply";
	if (hasBonus == null) {
		outcome = "indeterminate";
		reasonCode = "worst_performance_building_bonus_indeterminate";
	} else if (hasBonus) {
		outcome = "passed";
		reasonCode = "worst_performance_building_bonus_applies";
	}
	return {
		building,
		hasBonus,
		missingInputs: isBonusStage ? building.missingInputs : [],
		rule: createRuleResult({
			ruleCode: "E261-3",
			blocking: false,
			outcome,
			reasonCode
		})
	};
}
function evaluateKfw261SerialRenovationRule(context, stage) {
	const hasBonus = resolveSerialRenovationBonus(context, stage);
	return {
		hasBonus,
		rule: createRuleResult({
			ruleCode: "E261-3-SERSAN",
			blocking: false,
			outcome: hasBonus ? "passed" : "failed",
			reasonCode: hasBonus ? "serial_renovation_bonus_applies" : "serial_renovation_bonus_does_not_apply",
			observedValues: [ruleValue("hasSerialRenovation", context.subsidyInputs?.hasSerialRenovation ?? false, "boolean"), ruleValue("serialRenovationBonusRate", stage?.serialRenovationBonusRate ?? 0, "percent")]
		})
	};
}
function evaluateWorstPerformanceBuilding(context, config) {
	const missingInputs = [];
	const grossFloorArea = context.inputs.grossFloorArea;
	const finalEnergy = context.inputs.currentFinalEnergyConsumption;
	const finalEnergyPerSquareMeter = finalEnergy != null && grossFloorArea != null && grossFloorArea > 0 ? finalEnergy / grossFloorArea : null;
	const energyClass = finalEnergyPerSquareMeter == null ? null : convertEnergyConsumptionToEnergyConsumptionCategory(finalEnergyPerSquareMeter) ?? null;
	const finalEnergyCriterion = finalEnergyPerSquareMeter == null ? null : energyClass === "H" || finalEnergyPerSquareMeter >= config.worstPerformanceBuildingMinimumFinalEnergyDemandPerSquareMeter;
	if (finalEnergyPerSquareMeter == null) missingInputs.push("CURRENT_FINAL_ENERGY_DEMAND_PER_SQUARE_METER");
	const yearBuilt = context.inputs.yearBuilt;
	const facadeInsulationRate = context.inputs.facadeInsulationRate;
	const ageAndFacadeCriterion = resolveAgeAndFacadeWpbCriterion(yearBuilt, facadeInsulationRate, config.worstPerformanceBuildingMaximumConstructionYear, config.worstPerformanceBuildingMaximumFacadeInsulationRate);
	if (yearBuilt == null && ageAndFacadeCriterion == null) missingInputs.push("YEAR_BUILT");
	if (facadeInsulationRate == null && ageAndFacadeCriterion == null) missingInputs.push("FACADE_INSULATION_RATE");
	if (finalEnergyCriterion === true || ageAndFacadeCriterion === true) return {
		outcome: "passed",
		missingInputs: []
	};
	if (finalEnergyCriterion == null || ageAndFacadeCriterion == null) return {
		outcome: "indeterminate",
		missingInputs
	};
	return {
		outcome: "failed",
		missingInputs: []
	};
}
/**
* Age/facade WPB limb: definitively false when a known operand already exceeds its max,
* even if the other operand is missing. Indeterminate only when an unknown operand could still pass.
*/
function resolveAgeAndFacadeWpbCriterion(yearBuilt, facadeInsulationRate, maximumConstructionYear, maximumFacadeInsulationRate) {
	if (yearBuilt != null && yearBuilt > maximumConstructionYear) return false;
	if (facadeInsulationRate != null && facadeInsulationRate > maximumFacadeInsulationRate) return false;
	if (yearBuilt == null || facadeInsulationRate == null) return null;
	return yearBuilt <= maximumConstructionYear && facadeInsulationRate <= maximumFacadeInsulationRate;
}
function resolveWorstPerformanceBuildingBonus(buildingOutcome, stage) {
	if (stage == null || stage.worstPerformanceBuildingBonusRate <= 0) return false;
	if (buildingOutcome === "failed") return false;
	if (buildingOutcome === "indeterminate") return null;
	return true;
}
function resolveSerialRenovationBonus(context, stage) {
	if (stage == null || stage.serialRenovationBonusRate <= 0) return false;
	return context.subsidyInputs?.hasSerialRenovation === true;
}
function resolveTotalRepaymentGrantRate(stage, hasWorstPerformanceBuildingBonus, hasSerialRenovationBonus, maximumRepaymentGrantRate) {
	const uncapped = stage.baseRepaymentGrantRate + (hasWorstPerformanceBuildingBonus ? stage.worstPerformanceBuildingBonusRate : 0) + (hasSerialRenovationBonus ? stage.serialRenovationBonusRate : 0);
	return Math.min(maximumRepaymentGrantRate, uncapped);
}
var init_kfw_261_eligibility = __esmMin((() => {
	init_energy_efficiency();
	init_subsidy_result_model();
	init_eligible_costs();
	init_efficiency_house_stage();
	init_rule_result();
	init_capex_ee_calculator_model();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/subsidies/programs/kfw-261-benefit.ts
function calculateKfw261Benefit(params) {
	const { eligibleCosts, residentialUnits, stage, hasWorstPerformanceBuildingBonus, hasSerialRenovationBonus, applyCertification, context, config, interestRates } = params;
	if (residentialUnits == null || residentialUnits <= 0 || stage == null || !stage.isEnabled) return null;
	const appliesWorstPerformanceBuildingBonus = hasWorstPerformanceBuildingBonus === true;
	const appliesSerialRenovationBonus = hasSerialRenovationBonus === true;
	const loanCeiling = config.loanCeilingPerResidentialUnit * residentialUnits;
	const mainLoanAmount = Math.min(eligibleCosts, loanCeiling);
	const repaymentGrantRate = resolveTotalRepaymentGrantRate(stage, appliesWorstPerformanceBuildingBonus, appliesSerialRenovationBonus, config.maximumRepaymentGrantRate);
	const mainRepaymentGrant = mainLoanAmount * repaymentGrantRate;
	const supervisionEligibleCosts = calculateAncillaryConstructionCosts(eligibleCosts, context);
	const sharedAncillaryLoanCeiling = Math.min(config.supervisionLoanCeilingPerResidentialUnit * residentialUnits, config.supervisionLoanAbsoluteCeiling);
	const supervisionLoanAmount = Math.min(supervisionEligibleCosts, sharedAncillaryLoanCeiling);
	const supervisionRepaymentGrant = supervisionLoanAmount * config.supervisionRepaymentGrantRate;
	const certificationLoanAmount = applyCertification ? Math.min(config.certificationCost, sharedAncillaryLoanCeiling) : 0;
	const certificationRepaymentGrant = certificationLoanAmount * config.supervisionRepaymentGrantRate;
	const loanAmount = mainLoanAmount + supervisionLoanAmount + certificationLoanAmount;
	const interestSpread = interestRates.screeningBankInterestRate - interestRates.subsidizedInterestRate;
	const annualInterestAdvantage = Math.max(0, interestSpread * loanAmount);
	const worstPerformanceBuildingBonusRate = appliesWorstPerformanceBuildingBonus ? stage.worstPerformanceBuildingBonusRate : 0;
	const serialRenovationBonusRate = appliesSerialRenovationBonus ? stage.serialRenovationBonusRate : 0;
	return {
		benefit: {
			type: "loan_with_repayment_grant",
			eligibleCosts,
			cappedEligibleCosts: mainLoanAmount,
			mainLoanAmount,
			supervisionLoanAmount,
			certificationLoanAmount,
			loanAmount,
			repaymentGrantRate,
			mainRepaymentGrant,
			supervisionRepaymentGrantRate: config.supervisionRepaymentGrantRate,
			supervisionRepaymentGrant,
			certificationRepaymentGrant,
			totalRepaymentGrant: mainRepaymentGrant + supervisionRepaymentGrant + certificationRepaymentGrant,
			annualInterestAdvantage,
			subsidizedInterestRate: interestRates.subsidizedInterestRate,
			bankInterestRate: interestRates.screeningBankInterestRate
		},
		breakdown: {
			programCode: "KFW_261",
			energeticCapexBase: getEnergeticModernisationCosts(context),
			energeticEligibleShare: config.eligibleEnergeticCapexShare,
			expansionCapexBase: getExpansionCapexCosts(context),
			expansionEligibleShare: config.eligibleExpansionCapexShare,
			loanCeiling,
			baseRepaymentGrantRate: stage.baseRepaymentGrantRate,
			worstPerformanceBuildingBonusRate,
			serialRenovationBonusRate,
			maximumRepaymentGrantRate: config.maximumRepaymentGrantRate,
			supervisionEligibleCosts,
			supervisionLoanCeiling: sharedAncillaryLoanCeiling,
			certificationCost: applyCertification ? config.certificationCost : 0,
			certificationLoanCeiling: applyCertification ? sharedAncillaryLoanCeiling : 0
		}
	};
}
var init_kfw_261_benefit = __esmMin((() => {
	init_subsidy_result_model();
	init_eligible_costs();
	init_kfw_261_eligibility();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/subsidies/programs/kfw-261.ts
function evaluateKfw261(context, config, stages, interestRates) {
	const stageRule = evaluateKfw261EfficiencyHouseStageRule(context, stages);
	const renewableEnergyClassRule = evaluateKfw261RenewableEnergyClassRule(context, stageRule.stage, config);
	const worstPerformanceBuildingRule = evaluateKfw261WorstPerformanceBuildingRule(context, stageRule.stage, config);
	const serialRenovationRule = evaluateKfw261SerialRenovationRule(context, stageRule.stage);
	const missingInputs = [...stageRule.missingInputs, ...worstPerformanceBuildingRule.missingInputs];
	if (context.inputs.residentialUnits == null) missingInputs.push("RESIDENTIAL_UNITS");
	const ruleOutcomes = [
		stageRule.rule,
		renewableEnergyClassRule.heatingRule,
		renewableEnergyClassRule.branchRule,
		worstPerformanceBuildingRule.rule,
		serialRenovationRule.rule
	];
	const eligibleCosts = getKfw261EligibleCosts(context, config.eligibleEnergeticCapexShare, config.eligibleExpansionCapexShare);
	const applyCertification = stageRule.track === "NH";
	const benefitCalculation = calculateKfw261Benefit({
		eligibleCosts,
		residentialUnits: context.inputs.residentialUnits,
		stage: stageRule.stage,
		hasWorstPerformanceBuildingBonus: worstPerformanceBuildingRule.hasBonus,
		hasSerialRenovationBonus: serialRenovationRule.hasBonus,
		applyCertification,
		context,
		config,
		interestRates
	});
	const variantAssessments = createEfficiencyHouseStageAssessments(context, config, stages, stageRule.track, worstPerformanceBuildingRule.building, renewableEnergyClassRule.hasQualifyingHeatingSystem, eligibleCosts, interestRates);
	return createProgramResult({
		config,
		ruleOutcomes,
		missingInputs,
		selectedVariant: stageRule.stage == null ? null : {
			programCode: "KFW_261",
			efficiencyHouseStage: stageRule.stage.stage,
			track: stageRule.track,
			hasRenewableEnergyClass: renewableEnergyClassRule.hasRenewableEnergyClass,
			hasWorstPerformanceBuildingBonus: worstPerformanceBuildingRule.hasBonus,
			hasSerialRenovationBonus: serialRenovationRule.hasBonus
		},
		benefit: benefitCalculation?.benefit ?? null,
		breakdown: benefitCalculation?.breakdown ?? null,
		variantAssessments
	});
}
function createEfficiencyHouseStageAssessments(context, config, stages, activeTrack, wpbBuilding, hasQualifyingHeatingSystem, eligibleCosts, interestRates) {
	const primaryRatio = context.energy.primaryEnergyDemandInclExpansionInclPvPercentOfReference;
	const transmissionRatio = context.energy.transmissionHeatLossPercentOfReference;
	const residentialUnits = context.inputs.residentialUnits;
	const trackStages = filterEfficiencyHouseStagesByTrack(stages, activeTrack);
	const applyCertification = activeTrack === "NH";
	return orderEfficiencyHouseStages(trackStages).map((stage) => {
		const hasStageInputs = primaryRatio != null && (stage.maximumTransmissionHeatLossPercentOfReference == null || transmissionRatio != null);
		const isReached = hasStageInputs && primaryRatio <= stage.maximumPrimaryEnergyDemandPercentOfReference && (stage.maximumTransmissionHeatLossPercentOfReference == null || transmissionRatio != null && transmissionRatio <= stage.maximumTransmissionHeatLossPercentOfReference) && (stage.stage !== "EFFICIENCY_HOUSE_MONUMENT" || context.inputs.heritageProtected === true);
		const status = resolveStageAssessmentStatus(stage, hasStageInputs, isReached);
		const hasRenewableEnergyClass = hasQualifyingHeatingSystem;
		const hasWorstPerformanceBuildingBonus = resolveWorstPerformanceBuildingBonus(wpbBuilding.outcome, stage);
		const hasSerialRenovationBonus = resolveSerialRenovationBonus(context, stage);
		const totalRepaymentGrantRate = resolveTotalRepaymentGrantRate(stage, hasWorstPerformanceBuildingBonus === true, hasSerialRenovationBonus === true, config.maximumRepaymentGrantRate);
		const benefitCalculation = calculateKfw261Benefit({
			eligibleCosts,
			residentialUnits,
			stage,
			hasWorstPerformanceBuildingBonus,
			hasSerialRenovationBonus,
			applyCertification,
			context,
			config,
			interestRates
		});
		return {
			programCode: "KFW_261",
			stage: stage.stage,
			track: stage.track,
			status,
			eligibilityStatus: resolveKfw261VariantEligibility(stage.isEnabled, hasStageInputs, isReached, hasRenewableEnergyClass),
			isEnabled: stage.isEnabled,
			primaryEnergyDemandPercentOfReference: primaryRatio,
			maximumPrimaryEnergyDemandPercentOfReference: stage.maximumPrimaryEnergyDemandPercentOfReference,
			primaryEnergyDemandGapToThreshold: primaryRatio == null ? null : Math.max(0, primaryRatio - stage.maximumPrimaryEnergyDemandPercentOfReference),
			transmissionHeatLossPercentOfReference: transmissionRatio,
			maximumTransmissionHeatLossPercentOfReference: stage.maximumTransmissionHeatLossPercentOfReference,
			transmissionHeatLossGapToThreshold: transmissionRatio == null || stage.maximumTransmissionHeatLossPercentOfReference == null ? null : Math.max(0, transmissionRatio - stage.maximumTransmissionHeatLossPercentOfReference),
			baseRepaymentGrantRate: stage.baseRepaymentGrantRate,
			worstPerformanceBuildingBonusRate: stage.worstPerformanceBuildingBonusRate,
			serialRenovationBonusRate: stage.serialRenovationBonusRate,
			totalRepaymentGrantRate,
			hasRenewableEnergyClass,
			hasWorstPerformanceBuildingBonus,
			hasSerialRenovationBonus,
			potentialBenefit: benefitCalculation?.benefit ?? null,
			potentialBreakdown: benefitCalculation?.breakdown ?? null
		};
	});
}
function resolveKfw261VariantEligibility(isEnabled, hasStageInputs, isReached, hasRenewableEnergyClass) {
	if (!isEnabled) return "ineligible";
	if (!hasStageInputs) return "indeterminate";
	return isReached && hasRenewableEnergyClass ? "eligible" : "ineligible";
}
function resolveStageAssessmentStatus(stage, hasStageInputs, isReached) {
	if (!stage.isEnabled) return "disabled";
	if (!hasStageInputs) return "indeterminate";
	return isReached ? "achieved" : "not_achieved";
}
var init_kfw_261 = __esmMin((() => {
	init_subsidy_result_model();
	init_eligible_costs();
	init_efficiency_house_stage();
	init_rule_result();
	init_kfw_261_benefit();
	init_kfw_261_eligibility();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/subsidies/programs/kfw-359.ts
function evaluateKfw359(context, config, dependencies) {
	const underlyingProgramRule = evaluateKfw359UnderlyingProgramRule(dependencies);
	const missingInputs = [...underlyingProgramRule.missingInputs];
	const residentialUnits = context.inputs.residentialUnits;
	if (residentialUnits == null || residentialUnits <= 0) missingInputs.push("RESIDENTIAL_UNITS");
	const variantAssessments = [createKfw359VariantAssessment(dependencies.bafaBegEm, "BAFA_BEG_EM", residentialUnits, config), createKfw359VariantAssessment(dependencies.kfw459, "KFW_459", residentialUnits, config)];
	const selectedAssessment = selectKfw359VariantAssessment(variantAssessments);
	return createProgramResult({
		config,
		ruleOutcomes: [underlyingProgramRule.rule],
		missingInputs,
		selectedVariant: selectedAssessment == null ? null : {
			programCode: "KFW_359",
			isStandardRateLoan: true,
			underlyingProgramCode: selectedAssessment.underlyingProgramCode
		},
		benefit: selectedAssessment?.potentialBenefit ?? null,
		breakdown: selectedAssessment?.potentialBreakdown ?? null,
		variantAssessments
	});
}
function evaluateKfw359UnderlyingProgramRule(dependencies) {
	const dependencyResults = [dependencies.bafaBegEm, dependencies.kfw459];
	const eligibleProgramCount = dependencyResults.filter((result) => result.eligibilityStatus === "eligible").length;
	const hasIndeterminateDependency = dependencyResults.some((result) => result.eligibilityStatus === "indeterminate");
	const quantifiableProgramCount = dependencyResults.filter((result) => getQuantifiableUnderlyingProgramEligibleCosts(result) != null).length;
	let outcome = "failed";
	let reasonCode = "underlying_programs_ineligible";
	if (eligibleProgramCount > 0) {
		outcome = "passed";
		reasonCode = "eligible_underlying_program_exists";
	} else if (hasIndeterminateDependency) {
		outcome = "indeterminate";
		reasonCode = "underlying_programs_indeterminate";
	}
	return {
		outcome,
		quantifiableProgramCount,
		missingInputs: [...new Set(dependencyResults.flatMap((result) => result.missingInputs))],
		rule: createRuleResult({
			ruleCode: "E359-1",
			blocking: true,
			outcome,
			reasonCode,
			observedValues: [ruleValue("eligibleUnderlyingProgramCount", eligibleProgramCount, "count"), ruleValue("quantifiableUnderlyingProgramCount", quantifiableProgramCount, "count")]
		})
	};
}
function createKfw359VariantAssessment(dependency, underlyingProgramCode, residentialUnits, config) {
	const benefitCalculation = calculateKfw359Benefit(getQuantifiableUnderlyingProgramEligibleCosts(dependency), residentialUnits, underlyingProgramCode, config);
	return {
		programCode: "KFW_359",
		status: resolveKfw359VariantAssessmentStatus(dependency.eligibilityStatus),
		eligibilityStatus: dependency.eligibilityStatus,
		underlyingProgramCode,
		potentialBenefit: benefitCalculation?.benefit ?? null,
		potentialBreakdown: benefitCalculation?.breakdown ?? null
	};
}
function selectKfw359VariantAssessment(assessments) {
	const eligibleAssessments = assessments.filter((assessment) => assessment.eligibilityStatus === "eligible" && assessment.potentialBenefit != null);
	const candidates = eligibleAssessments.length > 0 ? eligibleAssessments : assessments.filter((assessment) => assessment.potentialBenefit != null);
	if (candidates.length === 0) return null;
	return candidates.reduce((best, candidate) => (candidate.potentialBenefit?.loanAmount ?? 0) > (best.potentialBenefit?.loanAmount ?? 0) ? candidate : best);
}
function resolveKfw359VariantAssessmentStatus(eligibilityStatus) {
	if (eligibilityStatus === "eligible") return "achieved";
	if (eligibilityStatus === "ineligible") return "not_achieved";
	return "indeterminate";
}
function getQuantifiableUnderlyingProgramEligibleCosts(result) {
	if (result.programCode !== "BAFA_BEG_EM" && result.programCode !== "KFW_459" || result.benefit?.type !== "direct_grant") return null;
	return result.benefit.eligibleCosts;
}
function calculateKfw359Benefit(eligibleCosts, residentialUnits, underlyingProgramCode, config) {
	if (eligibleCosts == null || residentialUnits == null || residentialUnits <= 0) return null;
	const loanCeiling = config.loanCeilingPerResidentialUnit * residentialUnits;
	const loanAmount = Math.min(eligibleCosts, loanCeiling);
	const annualInterestRateAdvantage = config.screeningBankInterestRate - config.subsidizedInterestRate;
	return {
		benefit: {
			type: "interest_rate_advantage",
			eligibleCosts,
			loanAmount,
			subsidizedInterestRate: config.subsidizedInterestRate,
			bankInterestRate: config.screeningBankInterestRate,
			annualInterestRateAdvantage,
			annualInterestAdvantage: annualInterestRateAdvantage * loanAmount
		},
		breakdown: {
			programCode: "KFW_359",
			underlyingProgramCode,
			loanCeiling
		}
	};
}
var init_kfw_359 = __esmMin((() => {
	init_subsidy_result_model();
	init_rule_result();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/subsidies/programs/kfw-459.ts
function evaluateKfw459(context, config) {
	const missingInputs = [];
	const heatingRule = evaluateKfw459EligibleHeatingSystemRule(context, config);
	const residentialUnits = context.inputs.residentialUnits;
	if (residentialUnits == null || residentialUnits <= 0) missingInputs.push("RESIDENTIAL_UNITS");
	const heatingCosts = getRiskAdjustedMeasureCost(context, "HeatingSystem");
	if (heatingRule.hasHeatingReplacement && heatingCosts == null) missingInputs.push("COMPONENT_ELIGIBLE_COSTS");
	const benefitCalculation = calculateKfw459Benefit(heatingCosts, residentialUnits, context.evaluationDate, config);
	return createProgramResult({
		config,
		ruleOutcomes: [heatingRule.rule],
		missingInputs,
		selectedVariant: {
			programCode: "KFW_459",
			isBaseHeatingGrant: true
		},
		benefit: benefitCalculation?.benefit ?? null,
		breakdown: benefitCalculation?.breakdown ?? null
	});
}
function evaluateKfw459EligibleHeatingSystemRule(context, config) {
	const heatingComponent = getSelectedComponent(context, "HeatingSystem");
	const heatingSystem = classifySubsidyHeatingSystem(heatingComponent);
	const hasHeatingReplacement = heatingComponent?.post != null;
	const isEligibleHeatingSystem = heatingSystem != null && config.eligibleHeatingSystems.includes(heatingSystem);
	let outcome = "failed";
	let reasonCode = "no_heating_replacement_selected";
	if (hasHeatingReplacement && isEligibleHeatingSystem) {
		outcome = "passed";
		reasonCode = "eligible_heating_system_selected";
	} else if (hasHeatingReplacement) reasonCode = "unsupported_heating_system_selected";
	return {
		outcome,
		hasHeatingReplacement,
		rule: createRuleResult({
			ruleCode: "EHZ-1",
			blocking: true,
			outcome,
			reasonCode,
			observedValues: [ruleValue("heatingSystem", heatingSystem)]
		})
	};
}
function calculateKfw459CostCeiling(residentialUnits, evaluationDate, config) {
	const degression = calculateDegressionIntervals(evaluationDate, config.degressionStartDate, config.degressionIntervalMonths) * config.degressionAmountPerInterval;
	return sumResidentialUnitInclusiveCostBands(residentialUnits, applyFirstResidentialUnitDegression(config.residentialUnitCostCeilings, degression));
}
function applyFirstResidentialUnitDegression(bands, degression) {
	return bands.flatMap((band) => {
		if (degression <= 0 || !residentialUnitIsInInclusiveBand(1, band.minResidentialUnit, band.maxResidentialUnit)) return [{
			minResidentialUnit: band.minResidentialUnit,
			maxResidentialUnit: band.maxResidentialUnit,
			amount: band.amount
		}];
		const degressedFirstUnit = {
			minResidentialUnit: 1,
			maxResidentialUnit: 1,
			amount: Math.max(0, band.amount - degression)
		};
		if (band.minResidentialUnit === 1 && band.maxResidentialUnit === 1) return [degressedFirstUnit];
		return [degressedFirstUnit, {
			minResidentialUnit: Math.max(band.minResidentialUnit, 2),
			maxResidentialUnit: band.maxResidentialUnit,
			amount: band.amount
		}];
	});
}
function calculateDegressionIntervals(evaluationDate, degressionStartDate, intervalMonths) {
	const start = dayjs.utc(degressionStartDate);
	const evaluation = dayjs.utc(evaluationDate);
	if (evaluation.isBefore(start)) return 0;
	const elapsedMonths = evaluation.diff(start, "month");
	return Math.floor(elapsedMonths / intervalMonths) + 1;
}
function calculateKfw459Benefit(heatingCosts, residentialUnits, evaluationDate, config) {
	if (heatingCosts == null || residentialUnits == null || residentialUnits <= 0) return null;
	const costCeiling = calculateKfw459CostCeiling(residentialUnits, evaluationDate, config);
	const eligibleCosts = Math.min(heatingCosts, costCeiling);
	const mainGrant = eligibleCosts * config.grantRate;
	return {
		benefit: {
			type: "direct_grant",
			eligibleCosts,
			grantRate: config.grantRate,
			totalGrant: mainGrant,
			components: [{
				code: "main_grant",
				amount: mainGrant
			}]
		},
		breakdown: {
			programCode: "KFW_459",
			heatingSystemCosts: heatingCosts,
			costCeiling
		}
	};
}
var init_kfw_459 = __esmMin((() => {
	init_capex_ee_calculator_model();
	init_subsidy_result_model();
	init_eligible_costs();
	init_rule_result();
	init_tiered_residential_unit_ceiling();
	dayjs.extend(dayjsUtc);
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/subsidies/evaluate-subsidy-programs.ts
function evaluateSubsidyPrograms(context, config) {
	const eeStages = getCanonicalEeEfficiencyHouseStages(config.efficiencyHouseStages);
	const kfw359InterestRates = {
		subsidizedInterestRate: config.programs.kfw359.subsidizedInterestRate,
		screeningBankInterestRate: config.programs.kfw359.screeningBankInterestRate
	};
	const kfw261 = evaluateKfw261(context, config.programs.kfw261, config.efficiencyHouseStages, kfw359InterestRates);
	const bafaBegEm = evaluateBafaBegEm(context, config.programs.bafaBegEm);
	const kfw459 = evaluateKfw459(context, config.programs.kfw459);
	return [
		kfw261,
		bafaBegEm,
		kfw459,
		evaluateKfw359(context, config.programs.kfw359, {
			bafaBegEm,
			kfw459
		}),
		evaluateIfbModernisierungA(context, config.programs.ifbModernisierungA, eeStages),
		evaluateFkgMunich(context, config.programs.fkgMunich, eeStages, {
			kfw261,
			bafaBegEm,
			kfw459
		})
	];
}
var init_evaluate_subsidy_programs = __esmMin((() => {
	init_bafa_beg_em();
	init_fkg_munich();
	init_ifb_modernisierung_a();
	init_kfw_261();
	init_kfw_359();
	init_kfw_459();
	init_efficiency_house_stage();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/syte/map-syte-heating-system-to-heating-type.ts
/**
* Normalises Syte heating system keys (e.g. `gas`, `district_heating`) or existing
* {@link HeatingType} enum strings for CAPEX EE and asset attributes.
*/
function mapSyteHeatingSystemToHeatingType(syteHeatingSystem) {
	if (syteHeatingSystem == null || syteHeatingSystem === "") return null;
	if (HEATING_TYPE_VALUES.has(syteHeatingSystem)) return syteHeatingSystem;
	return SYTE_HEATING_TO_HEATING_TYPE[syteHeatingSystem.toLowerCase()] ?? null;
}
var SYTE_HEATING_TO_HEATING_TYPE, HEATING_TYPE_VALUES;
var init_map_syte_heating_system_to_heating_type = __esmMin((() => {
	init_energy_efficiency();
	SYTE_HEATING_TO_HEATING_TYPE = {
		coal: "Coal",
		oil: "Oil",
		gas: "Gas",
		heat_pump_air_to_water: "Electricity",
		pellet: "PelletHeating",
		district_heating: "DistrictHeating",
		electricity: "Electricity"
	};
	HEATING_TYPE_VALUES = new Set(Object.values(HeatingType));
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/energy-inputs.ts
/** Maps MFH attribute heating (Syte snake_case or {@link HeatingType}) to CAPEX EE scenario fields. */
function resolveScenarioHeatingFromAsset(primaryHeatingType) {
	const currentHeatingType = mapSyteHeatingSystemToHeatingType(primaryHeatingType);
	return {
		currentHeatingType,
		energySource: currentHeatingType != null ? HEATING_TYPE_TO_SOURCE[currentHeatingType] ?? null : null
	};
}
/**
* Net floor area used as the denominator for final-energy intensity and energy-class derivation:
* gross floor area plus any planned roof-expansion floor area.
*/
function deriveReferenceFloorArea(grossFloorArea, components) {
	if (grossFloorArea == null) return null;
	const expansionFloorArea = deriveRoofExpansionFloorArea(components);
	return expansionFloorArea > 0 ? grossFloorArea + expansionFloorArea : grossFloorArea;
}
/** Converts a per-m²a energy value to kWh/a when gross floor area is known (e.g. MFH asset KPIs on scenario create). */
function energyPerSqmToKwhPerYear(valuePerSqm, grossFloorArea) {
	return valuePerSqm * grossFloorArea;
}
function endEnergySourceDrivesAnnual(source) {
	return source != null && END_ENERGY_SOURCES_THAT_DRIVE_ANNUAL.has(source);
}
/** Normalises primary energy from asset KPI (kWh/m²a) to scenario input (kWh/a). */
function normalisePrimaryEnergyFromAsset(primaryEnergyDemandKwhSqm, grossFloorArea) {
	if (primaryEnergyDemandKwhSqm == null || grossFloorArea == null) return null;
	return energyPerSqmToKwhPerYear(primaryEnergyDemandKwhSqm, grossFloorArea);
}
/** Normalises final energy from asset KPI (kWh/m²a) to scenario input (kWh/a). */
function normaliseFinalEnergyFromAsset(finalEnergyDemandKwhSqm, grossFloorArea) {
	if (finalEnergyDemandKwhSqm == null || grossFloorArea == null) return null;
	return energyPerSqmToKwhPerYear(finalEnergyDemandKwhSqm, grossFloorArea);
}
/** Annual end energy (kWh/a) × the primary energy factor of the baseline energy source. */
function derivePrimaryEnergyFromFactor(annualEndEnergyKwh, energySource, factors) {
	if (annualEndEnergyKwh == null || energySource == null) return null;
	const factor = getCarrierFactor(factors, energySource);
	if (factor == null) return null;
	return annualEndEnergyKwh * factor;
}
/**
* Baseline primary energy (kWh/a). A stored asset primary demand wins, annualised by gross floor area.
* With no asset value, fall back to annual end energy × the factor for the baseline energy source.
*/
function resolveBaselinePrimaryEnergyConsumption(input) {
	if (input.assetPrimaryEnergyDemandKwhSqm != null) return normalisePrimaryEnergyFromAsset(input.assetPrimaryEnergyDemandKwhSqm, input.grossFloorArea);
	return derivePrimaryEnergyFromFactor(input.annualEndEnergyKwh, input.energySource, input.primaryEnergyFactorPerCarrier);
}
/**
* Energy-source edits replace primary energy only while it is empty or still the factor-derived figure
* for the previous source. Asset prefills and manual numbers stay as entered.
*/
function resolveBaselinePrimaryEnergyOnSourceChange(input) {
	const previousDerived = derivePrimaryEnergyFromFactor(input.annualEndEnergyKwh, input.previousEnergySource, input.primaryEnergyFactorPerCarrier);
	return {
		replace: input.currentPrimaryEnergyKwh == null || previousDerived != null && input.currentPrimaryEnergyKwh === previousDerived,
		currentPrimaryEnergyConsumption: derivePrimaryEnergyFromFactor(input.annualEndEnergyKwh, input.nextEnergySource, input.primaryEnergyFactorPerCarrier)
	};
}
var END_ENERGY_SOURCES_THAT_DRIVE_ANNUAL;
var init_energy_inputs = __esmMin((() => {
	init_energy_efficiency();
	init_map_syte_heating_system_to_heating_type();
	init_carrier_config();
	init_ventilation_pv_expansion();
	END_ENERGY_SOURCES_THAT_DRIVE_ANNUAL = /* @__PURE__ */ new Set([
		"expose",
		"energy_certificate",
		"energy",
		"rent_roll",
		"rentroll",
		"extracted",
		"user"
	]);
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/capex-ee-calculator.ts
function isMfhDevelopmentMeasureComponent(component) {
	return component === "RoofConversion" || component === "RoofExpansion" || component === "SeparateNewBuild";
}
function deriveMfhDevelopmentNewFloors(component, catalogId) {
	switch (component) {
		case "RoofConversion": return 1;
		case "RoofExpansion": {
			const match = ROOF_EXPANSION_CATALOG_ID_PATTERN.exec(catalogId);
			return match?.[1] ? Number.parseInt(match[1], 10) : 1;
		}
		case "SeparateNewBuild": return null;
		default: throw new Error();
	}
}
function deriveMfhDevelopmentNetFloorArea(measureGrossFloorArea) {
	return measureGrossFloorArea == null ? null : round(measureGrossFloorArea * MFH_DEVELOPMENT_NET_FLOOR_AREA_FACTOR, 2);
}
function deriveMfhDevelopmentApartmentCount(measureNetFloorArea) {
	return measureNetFloorArea == null ? null : Math.round(measureNetFloorArea / 55);
}
function deriveMfhAverageResidentialUnitArea(measureNetFloorArea, newApartments) {
	return measureNetFloorArea == null || newApartments == null || newApartments <= 0 ? null : round(measureNetFloorArea / newApartments, 2);
}
function prefillMfhDevelopmentComponentInput(input) {
	if (input.postCatalogId == null || !isMfhDevelopmentMeasureComponent(input.component)) return input;
	const measureNetFloorArea = input.measureNetFloorArea ?? deriveMfhDevelopmentNetFloorArea(input.quantity);
	return {
		...input,
		newFloors: input.newFloors ?? deriveMfhDevelopmentNewFloors(input.component, input.postCatalogId),
		newApartmentsInHeatedArea: input.newApartmentsInHeatedArea ?? deriveMfhDevelopmentApartmentCount(measureNetFloorArea),
		measureNetFloorArea
	};
}
function syncMfhDevelopmentComponentInputQuantity(input, quantity) {
	if (!isMfhDevelopmentMeasureComponent(input.component)) return {
		...input,
		quantity
	};
	const measureNetFloorArea = deriveMfhDevelopmentNetFloorArea(quantity);
	const newApartmentsInHeatedArea = deriveMfhDevelopmentApartmentCount(measureNetFloorArea ?? null);
	return {
		...input,
		quantity,
		measureNetFloorArea,
		newApartmentsInHeatedArea
	};
}
/**
* Combines the standalone per-measure energy results with the scenario-wide total to assemble the
* full {@link MfhEnergyEfficiencyOutput}.
*
* Takes a fully-populated scenario snapshot and reads the pinned system configuration from
* {@link MfhEnergyEfficiencyScenario.config} (a required snapshot pinned at create / copy / resync
* time), including {@link MfhEnergyEfficiencyCalculationConfig.subsidyConfig} for funding-program
* evaluation. Component rows are resolved from the scenario-owned catalogue + selections via
* {@link resolveScenarioComponents}, so the calculator does not need a live catalogue argument. The
* function is a pure transform — it does not mutate its inputs.
*
* Pipeline:
*  1. Preflight warnings (data quality checks)
*  2. CAPEX (raw per measure + risk-adjusted by component category and building age)
*  3. Standalone per-measure energy results — {@link calculateMfhEnergyEfficiencyStandaloneMeasures}
*  4. Scenario-wide total final energy saving (§9.4.1) — {@link calculateMfhEnergyEfficiencyScenarioTotal}
*  5. Merge per-measure CAPEX + energy rows
*  6. Assemble the output (CAPEX + energy KPIs + merged per-measure rows + warnings). Cost / CO2 /
*     primary-energy KPIs come from the scenario-total two-tariff bucket valuation (item 2): the
*     pre-state is priced at the pre carrier and the post-state buckets (heating + expansion on the
*     heat carrier, ventilation aux on electricity) at their own carriers. Each KPI is reported for
*     the existing building (excl. roof expansion) and including expansion (item 5).
*  7. Evaluate matched subsidy programs from `scenario.config.subsidyConfig` when present.
*/
function calculateMfhEnergyEfficiency(scenario, evaluationDate = /* @__PURE__ */ new Date()) {
	const { mfhInputs, config } = scenario;
	const components = resolveScenarioComponents(scenario.componentCatalogue, scenario.componentInputs);
	const globalWarnings = collectPreflightWarnings(mfhInputs, components, config);
	const capexResult = applyRiskFactors(calculateRawCapexPerMeasure(components), mfhInputs.yearBuilt ?? 0, config);
	const capexWarningsPerMeasure = collectCapexWarnings(capexResult);
	const standalone = calculateMfhEnergyEfficiencyStandaloneMeasures(mfhInputs, components, config);
	const scenarioTotal = calculateMfhEnergyEfficiencyScenarioTotal(mfhInputs, components, config);
	const measures = mergeCapexAndEnergyMeasures(capexResult, standalone, capexWarningsPerMeasure);
	const carrier = resolvePostStateCarrier(components, mfhInputs);
	const totalFloorAreaInclExpansion = deriveReferenceFloorArea(mfhInputs.grossFloorArea, components);
	const totalFloorAreaExclExpansion = mfhInputs.grossFloorArea ?? null;
	const perM2 = (value) => dividePerM2(value, totalFloorAreaInclExpansion);
	const perM2ExclExpansion = (value) => dividePerM2(value, totalFloorAreaExclExpansion);
	const scenarioTransmission = calculateSpecificTransmissionHeatLoss(mfhInputs, components, config, "scenario");
	const hotWaterHeatDemand = calculateHotWaterHeatDemand(mfhInputs.grossFloorArea != null ? mfhInputs.grossFloorArea + deriveRoofExpansionFloorArea(components) : null, config);
	const referenceBuilding = calculateReferenceBuilding(mfhInputs, components, config);
	const specificTransmissionHeatLossInclExpansion = scenarioTransmission.value;
	const referenceSpecificTransmissionHeatLossInclExpansion = referenceBuilding.specificTransmissionHeatLoss;
	const referencePrimaryEnergyDemandInclExpansionExclPv = referenceBuilding.primaryEnergyDemand;
	const primaryEnergySavingAbsExclExpansionExclPv = scenarioTotal.prePrimaryEnergyKwh != null && scenarioTotal.postPrimaryEnergyBeforePvExclExpansionKwh != null ? scenarioTotal.prePrimaryEnergyKwh - scenarioTotal.postPrimaryEnergyBeforePvExclExpansionKwh : null;
	const transmissionHeatLossPercentOfReference = pct(specificTransmissionHeatLossInclExpansion, referenceSpecificTransmissionHeatLossInclExpansion);
	const primaryEnergyDemandInclExpansionInclPvPercentOfReference = pct(scenarioTotal.postPrimaryEnergyInclExpansionKwh, referencePrimaryEnergyDemandInclExpansionExclPv);
	const primaryEnergyDemandInclExpansionExclPvPercentOfReference = pct(scenarioTotal.postPrimaryEnergyBeforePvInclExpansionKwh, referencePrimaryEnergyDemandInclExpansionExclPv);
	const allGlobalWarnings = [
		...globalWarnings,
		...standalone.warnings,
		...scenarioTotal.warnings,
		...scenarioTransmission.warnings,
		...referenceBuilding.warnings,
		...measures.flatMap((m) => m.warnings)
	];
	const output = {
		calculatedAt: evaluationDate.toISOString(),
		capex: {
			totalMin: capexResult.totals.rawMin,
			totalAvg: capexResult.totals.rawAvg,
			totalMax: capexResult.totals.rawMax,
			totalRiskAdjustedMin: capexResult.totals.riskAdjustedMin,
			totalRiskAdjustedAvg: capexResult.totals.riskAdjustedAvg,
			totalRiskAdjustedMax: capexResult.totals.riskAdjustedMax,
			riskFactorImpactMin: capexResult.totals.riskAdjustedMin - capexResult.totals.rawMin,
			riskFactorImpactAvg: capexResult.totals.riskAdjustedAvg - capexResult.totals.rawAvg,
			riskFactorImpactMax: capexResult.totals.riskAdjustedMax - capexResult.totals.rawMax,
			splitByComponent: capexResult.splitByComponent,
			costMarkups: calculateCostMarkups({
				min: capexResult.totals.riskAdjustedMin,
				avg: capexResult.totals.riskAdjustedAvg,
				max: capexResult.totals.riskAdjustedMax
			}, config.costMarkups)
		},
		energy: {
			preHeatDemand: scenarioTotal.preHeatDemandKwh,
			postHeatDemandExclExpansion: scenarioTotal.postHeatDemandKwh,
			rawHeatDemandSavingAbsExclExpansion: scenarioTotal.rawHeatDemandSavingKwh,
			heatDemandSavingAbsExclExpansion: scenarioTotal.heatDemandSavingKwh,
			heatDemandSavingPctExclExpansion: pct(scenarioTotal.heatDemandSavingKwh, scenarioTotal.preHeatDemandKwh),
			preFinalEnergyDemand: scenarioTotal.preFinalEnergyKwh,
			postFinalEnergyDemandExclExpansion: scenarioTotal.postFinalEnergyExclExpansionKwh,
			finalEnergySavingAbsExclExpansion: scenarioTotal.finalEnergySavingExclExpansionKwh,
			finalEnergySavingPctExclExpansion: scenarioTotal.finalEnergySavingExclExpansionPct,
			annualEnergyCostSavingExclExpansion: scenarioTotal.energyCostSavingExclExpansion,
			annualEnergyCostSavingPctExclExpansion: scenarioTotal.energyCostSavingExclExpansionPct,
			preCo2: scenarioTotal.preCo2,
			postCo2ExclExpansion: scenarioTotal.postCo2ExclExpansion,
			co2SavingAbsExclExpansion: scenarioTotal.co2SavingExclExpansion,
			co2SavingPctExclExpansion: pct(scenarioTotal.co2SavingExclExpansion, scenarioTotal.preCo2),
			prePrimaryEnergyDemand: scenarioTotal.prePrimaryEnergyKwh,
			postPrimaryEnergyDemandExclExpansionExclPv: scenarioTotal.postPrimaryEnergyBeforePvExclExpansionKwh,
			primaryEnergySavingAbsExclExpansionExclPv,
			primaryEnergySavingPctExclExpansionExclPv: pct(primaryEnergySavingAbsExclExpansionExclPv, scenarioTotal.prePrimaryEnergyKwh),
			primaryEnergySavingAbsExclExpansionInclPv: scenarioTotal.primaryEnergySavingExclExpansionKwh,
			primaryEnergySavingPctExclExpansionInclPv: scenarioTotal.primaryEnergySavingExclExpansionPct,
			postFinalEnergyDemandInclExpansion: scenarioTotal.postFinalEnergyInclExpansionKwh,
			finalEnergySavingAbsInclExpansion: scenarioTotal.finalEnergySavingInclExpansionKwh,
			finalEnergySavingPctInclExpansion: scenarioTotal.finalEnergySavingInclExpansionPct,
			annualEnergyCostSavingInclExpansion: scenarioTotal.energyCostSavingInclExpansion,
			annualEnergyCostSavingPctInclExpansion: scenarioTotal.energyCostSavingInclExpansionPct,
			postCo2InclExpansion: scenarioTotal.postCo2InclExpansion,
			co2SavingAbsInclExpansion: scenarioTotal.co2SavingInclExpansion,
			co2SavingPctInclExpansion: pct(scenarioTotal.co2SavingInclExpansion, scenarioTotal.preCo2),
			postPrimaryEnergyDemandInclExpansionInclPv: scenarioTotal.postPrimaryEnergyInclExpansionKwh,
			primaryEnergySavingAbsInclExpansionInclPv: scenarioTotal.primaryEnergySavingInclExpansionKwh,
			primaryEnergySavingPctInclExpansionInclPv: scenarioTotal.primaryEnergySavingInclExpansionPct,
			expansionFinalEnergyDemand: scenarioTotal.expansionFinalEnergyDemandKwh,
			totalFloorAreaInclExpansion,
			perSqm: {
				capexRiskAdjustedAvg: perM2(capexResult.totals.riskAdjustedAvg),
				heatDemandSavingAbsExclExpansion: perM2ExclExpansion(scenarioTotal.heatDemandSavingKwh),
				finalEnergySavingAbsInclExpansion: perM2(scenarioTotal.finalEnergySavingInclExpansionKwh),
				annualEnergyCostSavingInclExpansion: perM2(scenarioTotal.energyCostSavingInclExpansion),
				primaryEnergySavingAbsInclExpansionInclPv: perM2(scenarioTotal.primaryEnergySavingInclExpansionKwh),
				co2SavingAbsInclExpansion: perM2(scenarioTotal.co2SavingInclExpansion)
			},
			carrier,
			referenceFloorArea: deriveReferenceFloorArea(mfhInputs.grossFloorArea, components),
			estimatedPvGenerationKwh: scenarioTotal.estimatedPvGenerationKwh,
			pvCappedKwh: scenarioTotal.pvCappedKwh,
			pvPrimaryEnergyCreditKwh: scenarioTotal.pvPrimaryEnergyCreditKwh,
			hotWaterHeatDemandInclExpansion: hotWaterHeatDemand,
			specificTransmissionHeatLossInclExpansion,
			referenceSpecificTransmissionHeatLossInclExpansion,
			referencePrimaryEnergyDemandInclExpansionExclPv,
			transmissionHeatLossPercentOfReference,
			primaryEnergyDemandInclExpansionInclPvPercentOfReference,
			primaryEnergyDemandInclExpansionExclPvPercentOfReference
		},
		measures,
		matchedSubsidyPrograms: [],
		warnings: allGlobalWarnings
	};
	const subsidyConfig = config.subsidyConfig;
	if (subsidyConfig == null) return output;
	const subsidyContext = {
		inputs: mfhInputs,
		components,
		measureFinancials: measures.map((measure) => ({
			catalogId: measure.catalogId,
			component: measure.component,
			riskAdjustedCapexAvg: measure.riskAdjustedCapexAvg
		})),
		componentGroups: config.componentGroups,
		costMarkups: config.costMarkups,
		energy: {
			preHeatDemand: output.energy.preHeatDemand,
			postHeatDemandExclExpansion: output.energy.postHeatDemandExclExpansion,
			heatDemandSavingPctExclExpansion: output.energy.heatDemandSavingPctExclExpansion,
			preFinalEnergyDemand: output.energy.preFinalEnergyDemand,
			postFinalEnergyDemandExclExpansion: output.energy.postFinalEnergyDemandExclExpansion,
			finalEnergySavingPctExclExpansion: output.energy.finalEnergySavingPctExclExpansion,
			prePrimaryEnergyDemand: output.energy.prePrimaryEnergyDemand ?? null,
			postPrimaryEnergyDemandExclExpansionExclPv: output.energy.postPrimaryEnergyDemandExclExpansionExclPv ?? null,
			primaryEnergySavingPctExclExpansionExclPv: output.energy.primaryEnergySavingPctExclExpansionExclPv ?? null,
			transmissionHeatLossPercentOfReference: output.energy.transmissionHeatLossPercentOfReference,
			primaryEnergyDemandInclExpansionInclPvPercentOfReference: output.energy.primaryEnergyDemandInclExpansionInclPvPercentOfReference ?? null,
			primaryEnergyDemandInclExpansionExclPvPercentOfReference: output.energy.primaryEnergyDemandInclExpansionExclPvPercentOfReference ?? null
		},
		subsidyInputs: scenario.subsidyInputs,
		evaluationDate
	};
	return {
		...output,
		matchedSubsidyPrograms: evaluateSubsidyPrograms(subsidyContext, subsidyConfig)
	};
}
/**
* Merges the risk-adjusted CAPEX measures with the standalone per-measure energy results (matched by
* catalog id) into the output's per-measure rows. CAPEX drives the row set; the standalone energy
* result contributes the heat-demand and final-energy savings (null when the measure has no energy
* effect). Per-measure warnings combine CAPEX warnings and standalone energy warnings.
*/
function mergeCapexAndEnergyMeasures(capexResult, standalone, capexWarningsPerMeasure) {
	return capexResult.measures.map((m) => {
		const energy = standalone.measures.find((e) => e.catalogId === m.catalogId);
		return {
			catalogId: m.catalogId,
			component: m.component,
			capexMin: m.rawMin,
			capexAvg: m.rawAvg,
			capexMax: m.rawMax,
			riskAdjustedCapexMin: m.riskAdjustedMin,
			riskAdjustedCapexAvg: m.riskAdjustedAvg,
			riskAdjustedCapexMax: m.riskAdjustedMax,
			rawHeatDemandSavingKwhPerYear: energy?.rawHeatDemandSavingKwhPerYear ?? null,
			cappedHeatDemandSavingKwhPerYear: energy?.cappedHeatDemandSavingKwhPerYear ?? null,
			finalHeatDemandKwhPerYear: energy?.finalHeatDemandKwhPerYear ?? null,
			finalEnergySavingKwhPerYear: energy?.finalEnergySavingKwhPerYear ?? null,
			warnings: [...capexWarningsPerMeasure[m.catalogId] ?? [], ...energy?.warnings ?? []]
		};
	});
}
/** Divides an absolute KPI by the total surface, or null when either operand is unusable. */
function dividePerM2(value, totalFloorAreaInclExpansion) {
	if (value == null || Number.isNaN(value) || totalFloorAreaInclExpansion == null || totalFloorAreaInclExpansion <= 0) return null;
	return value / totalFloorAreaInclExpansion;
}
var MFH_DEVELOPMENT_NET_FLOOR_AREA_FACTOR, MFH_AVERAGE_RESIDENTIAL_UNIT_AREA, ROOF_EXPANSION_CATALOG_ID_PATTERN;
var init_capex_ee_calculator$1 = __esmMin((() => {
	init_capex_ee_calculator_model();
	init_capex();
	init_cost_markups();
	init_carrier_config();
	init_risk_factors();
	init_scenario_total();
	init_standalone_measures();
	init_warnings();
	init_capex_ee_calculation_helpers();
	init_reference_building();
	init_transmission_loss();
	init_ventilation_pv_expansion();
	init_evaluate_subsidy_programs();
	init_energy_inputs();
	MFH_DEVELOPMENT_NET_FLOOR_AREA_FACTOR = .82;
	MFH_AVERAGE_RESIDENTIAL_UNIT_AREA = 55;
	ROOF_EXPANSION_CATALOG_ID_PATTERN = /^ROOF_EXPANSION(?:_(\d+)G)?$/;
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/map-scenario-to-investment-case-inputs.ts
/**
* Aggregates per-component risk-adjusted CAPEX into the fixed CAPEX budget buckets, then applies
* the scenario's cost-markup factor (SKB-1321). Shared by investment-case input mapping and RAM
* overview / breakdown UI (presentation wraps this).
*/
function aggregateMfhCapexBudgetBuckets(capex, scenario) {
	const factor = resolveMfhCostMarkupFactor(capex.costMarkups);
	const inputByComponent = new Map(scenario.componentInputs.map((input) => [input.component, input]));
	const totals = /* @__PURE__ */ new Map();
	for (const split of capex.splitByComponent) {
		const input = inputByComponent.get(split.component);
		const bucket = resolveMfhCapexBudgetBucket(split.component, input?.bucket);
		totals.set(bucket, (totals.get(bucket) ?? 0) + split.riskAdjustedAvg);
	}
	const { buckets: areas } = deriveMfhCapexBudgetBucketAreas(scenario.mfhInputs, scenario.componentInputs);
	return CAPEX_BUDGET_BUCKET_ORDER.map((bucket) => {
		const value = (totals.get(bucket) ?? 0) * factor;
		const area = areas[bucket];
		return {
			bucket,
			value,
			area,
			euroPerM2: roundMfhCapexEuroPerM2(value, area)
		};
	});
}
function toAssumptionsRangeBase(value) {
	return { base: value };
}
function perArea(value, area) {
	if (value == null || Number.isNaN(value) || area == null || area <= 0 || Number.isNaN(area)) return null;
	return value / area;
}
function deriveLettableExpansion(scenario) {
	let newLettableAreaM2 = 0;
	let newApartments = 0;
	let hasExpansion = false;
	for (const input of scenario.componentInputs) {
		if (input.postCatalogId == null || !isMfhDevelopmentMeasureComponent(input.component)) continue;
		hasExpansion = true;
		newLettableAreaM2 += input.measureNetFloorArea ?? 0;
		newApartments += input.newApartmentsInHeatedArea ?? 0;
	}
	if (!hasExpansion) return {
		newLettableAreaM2: null,
		newApartments: null,
		averageApartmentSizeM2: null
	};
	return {
		newLettableAreaM2,
		newApartments,
		averageApartmentSizeM2: deriveMfhAverageResidentialUnitArea(newLettableAreaM2, newApartments)
	};
}
function findVariant(variants, programCode) {
	return variants?.find((variant) => variant.programCode === programCode);
}
/**
* Resolves the active subsidy variant the same way Results UI does: persisted selection first,
* then the calculator's auto-resolved `selectedVariant` on the matched program.
* Ticking a program without picking a row still stores the achieved stage on output only.
*/
function resolveSelectedSubsidyVariant(scenario, programCode) {
	const fromSelection = findVariant(scenario.selectedSubsidyVariants, programCode);
	if (fromSelection) return fromSelection;
	const calculated = scenario.output?.matchedSubsidyPrograms?.find((program) => program.programCode === programCode)?.selectedVariant;
	return findVariant(calculated == null ? void 0 : [calculated], programCode);
}
function mapBegEmSubsidies(selectedProgramCodes) {
	const codes = new Set(selectedProgramCodes ?? []);
	const hasBafa = codes.has("BAFA_BEG_EM");
	const hasKfw459 = codes.has("KFW_459");
	if (hasBafa && hasKfw459) return "Individual measure shell + heating measure";
	if (hasBafa) return "Individual measure shell/systems without EH standard";
	if (hasKfw459) return "Individual heating measure";
	return "OFF";
}
function mapIfbStandard(scenario) {
	if (!(scenario.selectedSubsidyProgramCodes ?? []).includes("IFB_MODERNISIERUNG_A")) return "No IFB";
	const variant = resolveSelectedSubsidyVariant(scenario, "IFB_MODERNISIERUNG_A");
	if (!variant) return "No IFB";
	switch (variant.stage) {
		case "IFB_STAGE_1": return "IFB<90";
		case "IFB_STAGE_2": return "IFB<75";
		case "IFB_STAGE_3": return "IFB70";
		case "IFB_STAGE_4": return "IFB55";
		case "IFB_STAGE_5": return "IFB40";
		default: return variant.stage;
	}
}
function mapKfwStandard(scenario) {
	if (!(scenario.selectedSubsidyProgramCodes ?? []).includes("KFW_261")) return "No KfW";
	const variant = resolveSelectedSubsidyVariant(scenario, "KFW_261");
	if (!variant) return "No KfW";
	switch (variant.efficiencyHouseStage) {
		case "EFFICIENCY_HOUSE_55": return "KfW 55";
		case "EFFICIENCY_HOUSE_70": return "KfW 70";
		case "EFFICIENCY_HOUSE_85": return "KfW 85";
		case "EFFICIENCY_HOUSE_40":
		case "EFFICIENCY_HOUSE_MONUMENT": return "No KfW";
		default: return variant.efficiencyHouseStage;
	}
}
function resolveIsfpPlanning(scenario) {
	if (!(scenario.selectedSubsidyProgramCodes ?? []).includes("BAFA_BEG_EM")) return;
	const variant = resolveSelectedSubsidyVariant(scenario, "BAFA_BEG_EM");
	if (variant) return variant.hasIndividualRenovationRoadmap;
	return scenario.subsidyInputs?.hasIndividualRenovationRoadmap;
}
function resolveHeatingReplacementCostsPerSqm(scenario) {
	const heatingCapex = scenario.output?.capex.splitByComponent.find((split) => split.component === "HeatingSystem")?.riskAdjustedAvg;
	if (heatingCapex == null) return null;
	return roundMfhCapexEuroPerM2(heatingCapex, scenario.mfhInputs.totalRentableArea);
}
/**
* Maps a calculated CAPEX EE scenario into the MFH investment-case input fields covered by SKB-1072.
* Returns only mapped keys; callers deep-merge this patch onto case inputs. Expansion geometry
* is always present (`0` when the scenario has no development measures) so D2G required keys
* `overview.expansionPotentialSqm` and `buildingTechnical.numberOfApartmentsInHeatedArea` are never omitted.
* When intentional overrides are also present (e.g. fan-out seed from a configured base draft),
* those overrides should win. Range assumptions set `base` only so existing worst/best values survive the merge.
*
* With `d2gVersion` the emitted patch is filtered to the inputs that version accepts, so one mapping
* serves every creatable version (see {@link filterMFHInvestmentCaseInputPatchByVersion}). Every caller
* that writes to an investment case passes it.
*
* Omitting it yields the unfiltered superset, for callers that do not yet know which version the case
* will run on — the asset analyser builds its screening overlay before basecamp picks a D2G version, and
* filtering against a guessed one would drop inputs the chosen version does in fact accept.
*/
function mapMfhEnergyEfficiencyScenarioToInvestmentCaseInputs(scenario, d2gVersion) {
	const output = scenario.output;
	const lettable = deriveLettableExpansion(scenario);
	const expansionIncluded = (lettable.newLettableAreaM2 ?? 0) > 0;
	const patch = { d2gSettings: {
		begEmSubsidies: mapBegEmSubsidies(scenario.selectedSubsidyProgramCodes),
		ifbStandard: mapIfbStandard(scenario),
		kfwStandard: mapKfwStandard(scenario),
		expansion: expansionIncluded ? "Included" : "Excluded"
	} };
	const euroPerM2ByBucket = new Map((output?.capex ? aggregateMfhCapexBudgetBuckets(output.capex, scenario) : []).map((entry) => [entry.bucket, entry.euroPerM2]));
	const general = euroPerM2ByBucket.get("generalCapex") ?? null;
	const energetic = euroPerM2ByBucket.get("energeticCapex") ?? null;
	const expansion = expansionIncluded ? euroPerM2ByBucket.get("expansionCapex") ?? null : 0;
	if (general != null || energetic != null || expansion != null) patch.bestWorst = {
		...general != null ? { generalCapexSqm: toAssumptionsRangeBase(general) } : {},
		...energetic != null ? { renovationCostEnergyEfficiencySqm: toAssumptionsRangeBase(energetic) } : {},
		...expansion != null ? { expansionCostSqm: toAssumptionsRangeBase(expansion) } : {}
	};
	patch.overview = {
		...patch.overview,
		expansionPotentialSqm: lettable.newLettableAreaM2 ?? 0
	};
	patch.buildingTechnical = {
		...patch.buildingTechnical,
		numberOfApartmentsInHeatedArea: lettable.newApartments ?? 0
	};
	if (lettable.averageApartmentSizeM2 != null) patch.bestWorst = {
		...patch.bestWorst,
		averageExpandedUnitSize: toAssumptionsRangeBase(lettable.averageApartmentSizeM2)
	};
	const energy = output?.energy;
	const preArea = scenario.mfhInputs.grossFloorArea ?? null;
	const postArea = energy?.totalFloorAreaInclExpansion ?? energy?.referenceFloorArea ?? preArea;
	const prePrimaryAbs = scenario.mfhInputs.currentPrimaryEnergyConsumption ?? null;
	const preFinalAbs = energy?.preFinalEnergyDemand ?? scenario.mfhInputs.currentFinalEnergyConsumption ?? null;
	const prePrimaryPerM2 = perArea(prePrimaryAbs, preArea);
	const preFinalPerM2 = perArea(preFinalAbs, preArea);
	if (prePrimaryPerM2 != null || preFinalPerM2 != null || scenario.mfhInputs.energySource != null) patch.buildingTechnical = {
		...patch.buildingTechnical,
		...prePrimaryPerM2 != null ? { primaryEnergyDemandKWhSqm: prePrimaryPerM2 } : {},
		...preFinalPerM2 != null ? { endEnergyConsumptionKWhSqm: preFinalPerM2 } : {},
		...scenario.mfhInputs.energySource != null ? { districtHeatingAsPrimaryEnergySource: scenario.mfhInputs.energySource === "DistrictHeating" } : {}
	};
	if (preFinalPerM2 != null) {
		const energyClass = convertEnergyConsumptionToEnergyConsumptionCategory(preFinalPerM2);
		if (energyClass) patch.buildingTechnical = {
			...patch.buildingTechnical,
			endEnergyConsumptionClass: energyClass
		};
	}
	const postFinalPerM2 = perArea(energy?.postFinalEnergyDemandInclExpansion ?? null, postArea);
	if (postFinalPerM2 != null) {
		patch.bestWorst = {
			...patch.bestWorst,
			epcRatingInKWHPostRenovation: toAssumptionsRangeBase(postFinalPerM2)
		};
		const postClass = convertEnergyConsumptionToEnergyConsumptionCategory(postFinalPerM2);
		if (postClass) patch.buildingTechnical = {
			...patch.buildingTechnical,
			endEnergyConsumptionClassPostRenovation: postClass
		};
	}
	const assumptions = {};
	const isfpPlanning = resolveIsfpPlanning(scenario);
	if (isfpPlanning !== void 0) assumptions.isfpPlanning = isfpPlanning;
	const heatingReplacement = resolveHeatingReplacementCostsPerSqm(scenario);
	if (heatingReplacement != null && (scenario.selectedSubsidyProgramCodes ?? []).includes("BAFA_BEG_EM")) assumptions.heatingReplacementCostsPerSqm = heatingReplacement;
	if (Object.keys(assumptions).length > 0) patch.assumptions = assumptions;
	return d2gVersion ? filterMFHInvestmentCaseInputPatchByVersion(patch, d2gVersion) : patch;
}
var init_map_scenario_to_investment_case_inputs = __esmMin((() => {
	init_energy_efficiency();
	init_mfh_investment_case_base();
	init_mfh_investment_case_input_origins();
	init_cost_markups();
	init_capex_ee_calculator$1();
	init_capex_ee_calculator_model();
	init_subsidy_result_model();
}));
//#endregion
//#region src/domains/renovation/strategy-scenario/renovation-scenario-params.model.ts
var Fraction, Money, Month, Positive, StrictObject, ScenarioParamsSchema, ScenarioParamsV1Checker;
var init_renovation_scenario_params_model = __esmMin((() => {
	init_energy_efficiency_model();
	init_mfh_investment_case_base();
	Fraction = Type.Number({
		minimum: 0,
		maximum: 1
	});
	Money = Type.Number({ minimum: 0 });
	Month = Type.Integer({
		minimum: 0,
		maximum: 600
	});
	Positive = Type.Number({ exclusiveMinimum: 0 });
	StrictObject = { additionalProperties: false };
	ScenarioParamsSchema = Type.Object({
		capex: Type.Object({
			generalPerSqm: Money,
			energeticPerSqm: Money,
			heatingReplacementPerSqm: Money,
			expansionPerSqm: Money
		}, StrictObject),
		lettableArea: Type.Object({
			expansionLevels: Type.Integer({
				minimum: 0,
				maximum: 10
			}),
			rentableAreaFactor: Fraction,
			targetAvgUnitSizeSqm: Positive,
			startExpansionLetting: Month,
			endExpansionLetting: Month
		}, StrictObject),
		subsidies: Type.Object({
			kfwStandard: Type.Enum(MFHD2GSettingKfWStandard),
			begEmOption: Type.Enum(MFHD2GSettingBegEmSubsidies),
			ifbStandard: Type.Enum(MFHD2GSettingIFBStandard),
			shareEeCapexSubsidised: Fraction,
			shareExpansionCapexSubsidised: Fraction,
			shareExpansionCapexModLevy: Fraction,
			shareMaintenanceInCapex: Fraction
		}, StrictObject),
		delivery: Type.Object({
			generalStartMonth: Month,
			generalEndMonth: Month,
			energyStartMonth: Month,
			energyEndMonth: Month,
			expansionStartMonth: Month,
			expansionEndMonth: Month
		}, StrictObject),
		energy: Type.Object({ targetEnergyClass: Type.Enum(EnergyConsumptionCategory) }, StrictObject),
		renting: Type.Object({ rentLossDuringConstruction: Fraction }, StrictObject),
		exitMultiples: Type.Object({
			resiRunning: Positive,
			resiRelet: Positive,
			expansion: Positive,
			commercial: Positive,
			parking: Positive
		}, StrictObject)
	}, { additionalProperties: false });
	ScenarioParamsV1Checker = {
		Check(input) {
			return Value.Check(ScenarioParamsSchema, input);
		},
		Errors(input) {
			return [...Value.Errors(ScenarioParamsSchema, input)];
		}
	};
}));
//#endregion
//#region src/domains/renovation/strategy-scenario/renovation-scenario.model.ts
var RenovationScenarioSubsidyScheme, RenovationEnergeticMeasureType, RenovationScenarioExpansionType, RenovationScenarioGroupCode, RenovationScenarioSubsidySchemeSchema, RenovationEnergeticMeasureTypeSchema, RenovationScenarioExpansionTypeSchema, RenovationScenarioGroupCodeSchema, BaseRenovationScenarioSchema, BaseRenovationScenarioConfigSchema, RenovationScenarioSchema, RenovationScenarioConfigSchema, renovationScenarioSchemas;
var init_renovation_scenario_model = __esmMin((() => {
	init_shared_schemas();
	init_renovation_scenario_params_model();
	RenovationScenarioSubsidyScheme = /* @__PURE__ */ function(RenovationScenarioSubsidyScheme) {
		RenovationScenarioSubsidyScheme["KFW_261"] = "KFW_261";
		RenovationScenarioSubsidyScheme["BAFA"] = "BAFA";
		return RenovationScenarioSubsidyScheme;
	}({});
	RenovationEnergeticMeasureType = /* @__PURE__ */ function(RenovationEnergeticMeasureType) {
		RenovationEnergeticMeasureType["SHELL"] = "SHELL";
		RenovationEnergeticMeasureType["HEATING"] = "HEATING";
		RenovationEnergeticMeasureType["FULL"] = "FULL";
		return RenovationEnergeticMeasureType;
	}({});
	RenovationScenarioExpansionType = /* @__PURE__ */ function(RenovationScenarioExpansionType) {
		RenovationScenarioExpansionType["NONE"] = "NONE";
		RenovationScenarioExpansionType["ROOF_ADDITION"] = "ROOF_ADDITION";
		RenovationScenarioExpansionType["ROOF_CONVERSION"] = "ROOF_CONVERSION";
		return RenovationScenarioExpansionType;
	}({});
	RenovationScenarioGroupCode = /* @__PURE__ */ function(RenovationScenarioGroupCode) {
		RenovationScenarioGroupCode["KFW_261_NO_EXPANSION"] = "KFW_261_NO_EXPANSION";
		RenovationScenarioGroupCode["BAFA_NO_EXPANSION"] = "BAFA_NO_EXPANSION";
		RenovationScenarioGroupCode["KFW_261_ROOF_ADDITION"] = "KFW_261_ROOF_ADDITION";
		RenovationScenarioGroupCode["BAFA_ROOF_ADDITION"] = "BAFA_ROOF_ADDITION";
		RenovationScenarioGroupCode["KFW_261_ROOF_CONVERSION"] = "KFW_261_ROOF_CONVERSION";
		RenovationScenarioGroupCode["BAFA_ROOF_CONVERSION"] = "BAFA_ROOF_CONVERSION";
		return RenovationScenarioGroupCode;
	}({});
	RenovationScenarioSubsidySchemeSchema = TEnum(RenovationScenarioSubsidyScheme, { $id: "RenovationScenarioSubsidyScheme" });
	RenovationEnergeticMeasureTypeSchema = TEnum(RenovationEnergeticMeasureType, { $id: "RenovationEnergeticMeasureType" });
	RenovationScenarioExpansionTypeSchema = TEnum(RenovationScenarioExpansionType, { $id: "RenovationScenarioExpansionType" });
	RenovationScenarioGroupCodeSchema = TEnum(RenovationScenarioGroupCode, { $id: "RenovationScenarioGroupCode" });
	BaseRenovationScenarioSchema = Type.Object({
		renovationScenarioId: Type.Number(),
		name: Type.String({
			minLength: 1,
			maxLength: 200
		}),
		description: Type.String(),
		isActive: Type.Boolean(),
		subsidyScheme: Type.Ref(RenovationScenarioSubsidySchemeSchema),
		expansionType: Type.Ref(RenovationScenarioExpansionTypeSchema),
		energeticMeasureType: Type.Ref(RenovationEnergeticMeasureTypeSchema),
		createdAt: Type.String(),
		createdBy: Type.String(),
		updatedAt: TNullable(Type.String()),
		updatedBy: TNullable(Type.String())
	}, { $id: "BaseRenovationScenario" });
	BaseRenovationScenarioConfigSchema = Type.Object({
		renovationScenarioConfigId: Type.Number(),
		renovationScenarioId: Type.Number(),
		version: Type.Number({ minimum: 1 }),
		params: ScenarioParamsSchema,
		valueFingerprint: Type.String(),
		validFrom: Type.String(),
		validTo: TNullable(Type.String()),
		createdAt: Type.String(),
		createdBy: Type.String()
	}, { $id: "BaseRenovationScenarioConfig" });
	RenovationScenarioSchema = Type.Intersect([Type.Ref(BaseRenovationScenarioSchema), Type.Object({
		configs: Type.Optional(Type.Array(Type.Ref(BaseRenovationScenarioConfigSchema))),
		latestConfig: Type.Optional(Type.Ref(BaseRenovationScenarioConfigSchema))
	})], { $id: "RenovationScenario" });
	RenovationScenarioConfigSchema = Type.Intersect([Type.Ref(BaseRenovationScenarioConfigSchema), Type.Object({ scenario: Type.Optional(Type.Ref(BaseRenovationScenarioSchema)) })], { $id: "RenovationScenarioConfig" });
	renovationScenarioSchemas = {
		RenovationScenarioSubsidySchemeSchema,
		RenovationScenarioExpansionTypeSchema,
		RenovationEnergeticMeasureTypeSchema,
		RenovationScenarioGroupCodeSchema,
		BaseRenovationScenarioSchema,
		BaseRenovationScenarioConfigSchema,
		RenovationScenarioSchema,
		RenovationScenarioConfigSchema
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/mfh-scenario-renovation-archetype.ts
/**
* Measure extent from the measures actually selected. Shell and heating membership comes from the
* scenario's pinned component groups, the same groups the calculator uses. Ticked subsidy programs
* never stand in for a missing shell or heating measure.
*/
function resolveSelectedMeasureExtent(componentGroups, selected) {
	const groupComponents = (id) => componentGroups.find((group) => group.id === id)?.components ?? [];
	const hasShell = groupComponents("shell").some((component) => selected.has(component));
	const hasHeating = groupComponents("heating").some((component) => selected.has(component));
	if (hasShell && hasHeating) return "FULL";
	if (hasShell) return "SHELL";
	if (hasHeating) return "HEATING";
	return null;
}
/**
* Roof expansion (Aufstockung) wins over roof conversion (Ausbau). Separate new build and the
* absence of a development measure are both "no catalogue expansion".
*/
function resolveExpansionType(selected) {
	if (selected.has("RoofExpansion")) return "ROOF_ADDITION";
	if (selected.has("RoofConversion")) return "ROOF_CONVERSION";
	return "NONE";
}
function resolveSubsidyScheme(kfwStandard) {
	if (kfwStandard != null && kfwStandard !== "No KfW") return "KFW_261";
	return "BAFA";
}
/**
* Classifies a custom CAPEX EE scenario into exactly one catalogue archetype, or `null` when no
* shell or heating measure is selected (SKB-1283). Callers then skip the inherited layer.
*
* `layer1Patch` is the SKB-1072 mapping of the same scenario: the subsidy path reads the KfW
* standard that mapping already produced, so the two layers cannot disagree.
*/
function classifyMfhScenarioRenovationArchetype(scenario, layer1Patch) {
	const selected = new Set(scenario.componentInputs.filter((input) => input.postCatalogId != null).map((input) => input.component));
	const energeticMeasureType = resolveSelectedMeasureExtent(scenario.config.componentGroups, selected);
	if (energeticMeasureType == null) return null;
	return {
		energeticMeasureType,
		expansionType: resolveExpansionType(selected),
		subsidyScheme: resolveSubsidyScheme(layer1Patch.d2gSettings?.kfwStandard)
	};
}
/**
* The single catalogue scenario matching a classification; callers pass active scenarios only. Zero and
* several matches are both "unresolved": inheriting from a guess would write the wrong delivery and subsidy shares.
*/
function pickRenovationScenarioArchetype(scenarios, classification) {
	const matches = scenarios.filter((scenario) => scenario.subsidyScheme === classification.subsidyScheme && scenario.expansionType === classification.expansionType && scenario.energeticMeasureType === classification.energeticMeasureType);
	return matches.length === 1 ? matches[0] : void 0;
}
var init_mfh_scenario_renovation_archetype = __esmMin((() => {
	init_renovation_scenario_model();
	init_mfh_investment_case_base();
	init_capex_ee_calculator_model();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/roof-shape.ts
/** Roof area factor from calculation config (`roofAreaFactorPerShape`). */
function getRoofFactorForShape(roofShape, roofAreaFactorPerShape) {
	if (roofShape == null) return 1;
	return roofAreaFactorPerShape?.[roofShape] ?? 1;
}
var DEFAULT_ROOF_FACTOR;
var init_roof_shape = __esmMin((() => {
	DEFAULT_ROOF_FACTOR = 1;
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/default-pre-states.ts
/**
* Pre-state Heating System catalogue id for a scenario energy source.
* Null when the source is unset or no pre-state heating item is tagged with it.
* The first matching item in catalogue order wins.
*/
function resolveHeatingPreCatalogId(catalogue, energySource) {
	if (energySource == null) return null;
	return catalogue.find((item) => item.component === "HeatingSystem" && item.flags?.includes("Pre") && item.energySource === energySource)?.catalogId ?? null;
}
/**
* Default pre-state catalogue id per component for a construction year.
* Year-bucket entries come from the calculation config as stored. Heating System is then set from
* {@link resolveHeatingPreCatalogId} when a matching catalogue item exists. Catalogue ids that are
* not in the catalogue are dropped.
*/
function resolveDefaultPreCatalogIds(config, catalogue, yearBuilt, energySource) {
	const bucket = config != null && yearBuilt != null ? config.defaultMeasureComponent.find((range) => yearBuilt >= range.yearStart && yearBuilt <= range.yearEnd) : void 0;
	const defaults = /* @__PURE__ */ new Map();
	for (const entry of bucket?.components ?? []) if (catalogue.some((item) => item.component === entry.component && item.catalogId === entry.defaultCatalogId)) defaults.set(entry.component, entry.defaultCatalogId);
	const heatingCatalogId = resolveHeatingPreCatalogId(catalogue, energySource);
	if (heatingCatalogId != null) defaults.set("HeatingSystem", heatingCatalogId);
	return defaults;
}
var init_default_pre_states = __esmMin((() => {
	init_capex_ee_calculator_model();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/derive-scenario-geometry-inputs.ts
function deriveGrossFloorArea(patch, after) {
	const driversEdited = "footprintArea" in patch || "storiesAboveGround" in patch;
	const { footprintArea, storiesAboveGround } = after;
	if (driversEdited && footprintArea != null && storiesAboveGround != null) return footprintArea * storiesAboveGround;
	return after.grossFloorArea;
}
function round2(value) {
	return Math.round(value * 100) / 100;
}
function deriveRoofFactor(patch, after, roofAreaFactorPerShape) {
	if ("roofShape" in patch) return getRoofFactorForShape(after.roofShape, roofAreaFactorPerShape);
	return after.roofFactor ?? getRoofFactorForShape(after.roofShape, roofAreaFactorPerShape);
}
function deriveRoofArea(patch, after, roofFactor) {
	if (("footprintArea" in patch || "roofShape" in patch) && after.footprintArea != null) return round2(after.footprintArea * roofFactor);
	if (after.roofArea != null) return after.roofArea;
	return after.footprintArea != null ? round2(after.footprintArea * roofFactor) : null;
}
/** Recomputes derived geometry fields on scenario inputs (shared by RAM UI and scenario create prefill). */
function deriveScenarioGeometryInputs(patch, current, roofAreaFactorPerShape) {
	const after = {
		...current,
		...patch
	};
	const grossFloorArea = deriveGrossFloorArea(patch, after);
	const roofFactor = deriveRoofFactor(patch, after, roofAreaFactorPerShape);
	const facadeGrossArea = after.facadeGrossArea ?? null;
	const windowToFacadeRatio = after.windowToFacadeRatio ?? .22;
	const windowArea = facadeGrossArea != null ? round2(facadeGrossArea * windowToFacadeRatio) : null;
	const facadeNetArea = facadeGrossArea != null && windowArea != null ? round2(facadeGrossArea - windowArea) : null;
	const roofArea = deriveRoofArea(patch, after, roofFactor);
	return {
		...patch,
		grossFloorArea: grossFloorArea ?? null,
		roofFactor,
		facadeGrossArea,
		windowToFacadeRatio,
		windowArea,
		facadeNetArea,
		roofArea,
		volume: after.volume ?? null
	};
}
var init_derive_scenario_geometry_inputs = __esmMin((() => {
	init_capex_ee_calculator_model();
	init_roof_shape();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/subsidies/subsidy-evaluation-context.ts
var init_subsidy_evaluation_context = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/subsidies/shared/efficiency-house-stage-matrix.ts
function stageTrackKey(stage, track) {
	return `${stage}:${track}`;
}
/**
* Exactly ten unique stage×track pairs (5 stages × EE/NH). Rejects duplicates and missing pairs.
*/
function hasCompleteEfficiencyHouseStageTrackMatrix(stages) {
	if (stages.length !== REQUIRED_EFFICIENCY_HOUSE_STAGE_COUNT) return false;
	const seen = /* @__PURE__ */ new Set();
	for (const row of stages) {
		const key = stageTrackKey(row.stage, row.track);
		if (seen.has(key)) return false;
		seen.add(key);
	}
	return REQUIRED_EFFICIENCY_HOUSE_STAGE_TRACK_PAIRS.every((pair) => seen.has(stageTrackKey(pair.stage, pair.track)));
}
/**
* Counts valid KfW 261 outcome combinations: stage×track × applicable WPB/SerSan flag sets
* (bonus flags only when the stage config rate is &gt; 0).
*/
function countKfw261ApplicableOutcomeCombinations(stages) {
	return stages.reduce((total, stage) => {
		return total + (stage.worstPerformanceBuildingBonusRate > 0 ? 2 : 1) * (stage.serialRenovationBonusRate > 0 ? 2 : 1);
	}, 0);
}
var REQUIRED_EFFICIENCY_HOUSE_STAGE_TRACK_PAIRS, REQUIRED_EFFICIENCY_HOUSE_STAGE_COUNT, DEFAULT_KFW_261_APPLICABLE_OUTCOME_COMBINATION_COUNT;
var init_efficiency_house_stage_matrix = __esmMin((() => {
	init_subsidy_result_model();
	REQUIRED_EFFICIENCY_HOUSE_STAGE_TRACK_PAIRS = [
		{
			stage: "EFFICIENCY_HOUSE_MONUMENT",
			track: "EE"
		},
		{
			stage: "EFFICIENCY_HOUSE_MONUMENT",
			track: "NH"
		},
		{
			stage: "EFFICIENCY_HOUSE_85",
			track: "EE"
		},
		{
			stage: "EFFICIENCY_HOUSE_85",
			track: "NH"
		},
		{
			stage: "EFFICIENCY_HOUSE_70",
			track: "EE"
		},
		{
			stage: "EFFICIENCY_HOUSE_70",
			track: "NH"
		},
		{
			stage: "EFFICIENCY_HOUSE_55",
			track: "EE"
		},
		{
			stage: "EFFICIENCY_HOUSE_55",
			track: "NH"
		},
		{
			stage: "EFFICIENCY_HOUSE_40",
			track: "EE"
		},
		{
			stage: "EFFICIENCY_HOUSE_40",
			track: "NH"
		}
	];
	REQUIRED_EFFICIENCY_HOUSE_STAGE_COUNT = REQUIRED_EFFICIENCY_HOUSE_STAGE_TRACK_PAIRS.length;
	DEFAULT_KFW_261_APPLICABLE_OUTCOME_COMBINATION_COUNT = 23;
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/subsidies/index.ts
var init_subsidies = __esmMin((() => {
	init_evaluate_subsidy_programs();
	init_bafa_beg_em();
	init_fkg_munich();
	init_ifb_modernisierung_a();
	init_kfw_261();
	init_kfw_359();
	init_kfw_459();
	init_subsidy_config_model();
	init_subsidy_evaluation_context();
	init_subsidy_inputs_model();
	init_subsidy_result_model();
	init_efficiency_house_stage();
	init_efficiency_house_stage_matrix();
	init_rule_result();
	init_tiered_residential_unit_ceiling();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/capex-ee-calculator/index.ts
var init_capex_ee_calculator = __esmMin((() => {
	init_capex_ee_calculator_model();
	init_capex_ee_calculator_opts();
	init_capex_ee_calculator_requests();
	init_capex_ee_calculator$1();
	init_map_scenario_to_investment_case_inputs();
	init_mfh_scenario_renovation_archetype();
	init_roof_shape();
	init_energy_inputs();
	init_default_pre_states();
	init_derive_scenario_geometry_inputs();
	init_subsidies();
	init_energy_heat_demand();
	init_standalone_measures();
	init_scenario_total();
	init_ventilation_pv_expansion();
	init_transmission_loss();
	init_reference_building();
	init_cost_markups();
	init_component_correction_factor();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh-placement.model.ts
var MFHPlacementStatus, MFHPlacementBuyBoxStatus, AssetPartnerPlacementResponseStatus;
var init_mfh_placement_model = __esmMin((() => {
	MFHPlacementStatus = /* @__PURE__ */ function(MFHPlacementStatus) {
		MFHPlacementStatus["BuyBoxConfirmed"] = "BuyBoxConfirmed";
		MFHPlacementStatus["AllocatedToAssetPartner"] = "AllocatedToAssetPartner";
		return MFHPlacementStatus;
	}({});
	MFHPlacementBuyBoxStatus = /* @__PURE__ */ function(MFHPlacementBuyBoxStatus) {
		MFHPlacementBuyBoxStatus["Pass"] = "Pass";
		MFHPlacementBuyBoxStatus["Fail"] = "Fail";
		return MFHPlacementBuyBoxStatus;
	}({});
	AssetPartnerPlacementResponseStatus = /* @__PURE__ */ function(AssetPartnerPlacementResponseStatus) {
		AssetPartnerPlacementResponseStatus["NotApproached"] = "NotApproached";
		AssetPartnerPlacementResponseStatus["InitialOutreachCompleted"] = "InitialOutreachCompleted";
		AssetPartnerPlacementResponseStatus["TeaserSent"] = "TeaserSent";
		AssetPartnerPlacementResponseStatus["NdaSigned"] = "NdaSigned";
		AssetPartnerPlacementResponseStatus["InvestmentMemoSent"] = "InvestmentMemoSent";
		AssetPartnerPlacementResponseStatus["Loi"] = "Loi";
		AssetPartnerPlacementResponseStatus["Commitment"] = "Commitment";
		AssetPartnerPlacementResponseStatus["DeclinedByPartner"] = "DeclinedByPartner";
		AssetPartnerPlacementResponseStatus["ExcludedByReneo"] = "ExcludedByReneo";
		return AssetPartnerPlacementResponseStatus;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh-placement.schema.ts
var MFHPlacementSchema, BuyBoxComparisonSchema, BuyBoxMatrixSchema, MFHPlacementICSchema;
var init_mfh_placement_schema = __esmMin((() => {
	init_lib();
	init_shared_schemas();
	init_location_model();
	init_mfh_placement_model();
	MFHPlacementSchema = Type.Object({
		mfhPlacementId: Type.Number(),
		mfhId: Type.Number(),
		status: TEnum(MFHPlacementStatus),
		apetiteWindowDays: Type.Number(),
		apetiteWindowStartDate: TStringDate(),
		apetiteWindowEndDate: TStringDate(),
		/**
		* Set once the appetite-window reminder digest has been emailed to the Investment Manager, so the daily job never
		* reminds twice for the same placement. Null means "still due once the window has run out".
		*/
		apetiteWindowNotificationSentAt: TNullable(TStringDate()),
		allocatedToAssetPartnerProfileId: TNullable(Type.Number()),
		allocationToAssetPartnerProfileReason: TNullable(Type.String()),
		rankingWeightBestFit: Type.Number(),
		rankingWeightFairness: Type.Number(),
		rankingWeightReneoFit: Type.Number(),
		createdAt: TStringDate(),
		updatedAt: TStringDate()
	});
	BuyBoxComparisonSchema = (T) => Type.Object({
		value: T,
		threshold: T,
		status: TEnum(MFHPlacementBuyBoxStatus)
	});
	BuyBoxMatrixSchema = Type.Object({
		irrPercentage: BuyBoxComparisonSchema(Type.Number()),
		mocMultiplier: BuyBoxComparisonSchema(Type.Number()),
		cocPercentage: BuyBoxComparisonSchema(Type.Number()),
		purchasePrice: Type.Optional(BuyBoxComparisonSchema(Type.Number())),
		purchasePriceDiscount: BuyBoxComparisonSchema(Type.Number()),
		investmentVolume: BuyBoxComparisonSchema(Type.Number()),
		ltv: Type.Optional(BuyBoxComparisonSchema(Type.Number())),
		commercialShare: BuyBoxComparisonSchema(Type.Number()),
		preferredLocations: BuyBoxComparisonSchema(Type.Array(TEnum(LocationTeir)))
	});
	MFHPlacementICSchema = Type.Object({
		mfhPlacementICId: Type.Number(),
		mfhPlacementId: Type.Number(),
		mfhInvestmentCaseId: Type.Number(),
		buyBoxSystemStatus: TEnum(MFHPlacementBuyBoxStatus),
		buyBoxFinalStatus: TEnum(MFHPlacementBuyBoxStatus),
		buyBoxOverrideReason: TNullable(Type.String()),
		buyBoxMatrix: BuyBoxMatrixSchema,
		rank: TNullable(Type.Number()),
		rankedAt: TNullable(TStringDate()),
		rankingBestFitScore: TNullable(Type.Number()),
		rankingFairnessScore: TNullable(Type.Number()),
		rankingReneoFitScore: TNullable(Type.Number()),
		rankingTotalScore: TNullable(Type.Number()),
		rankingReneoFee: TNullable(Type.Number()),
		rankingUtilization: TNullable(Type.Number()),
		assetPartnerPlacementResponseStatus: TEnum(AssetPartnerPlacementResponseStatus),
		assetPartnerPlacementResponseStatusUpdatedAt: TNullable(TStringDate()),
		assetPartnerPlacementResponseResponsibilityContactId: TNullable(Type.Number()),
		assetPartnerPlacementResponseNextStep: TNullable(Type.String()),
		assetPartnerPlacementResponseNote: TNullable(Type.String()),
		createdAt: TStringDate(),
		updatedAt: TStringDate()
	});
}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh-placement.constants.ts
var MFH_PLACEMENT_ALLOCATABLE_RESPONSE_STATUSES, MFH_PLACEMENT_DEFAULT_APETITE_WINDOW_DAYS, MFH_PLACEMENT_DEFAULT_BEST_FIT_WEIGHT, MFH_PLACEMENT_DEFAULT_FAIRNESS_WEIGHT, MFH_PLACEMENT_DEFAULT_RENEO_FIT_WEIGHT, MFH_PLACEMENT_BEST_FIT_KPI_CAPS, MFH_PLACEMENT_DEFAULT_BEST_FIT_SUB_WEIGHT, MFH_PLACEMENT_ALLOCATED_SOURCING_STATES, TOP_7_CITIES, B_CITIES;
var init_mfh_placement_constants = __esmMin((() => {
	init_mfh_process_base();
	MFH_PLACEMENT_ALLOCATABLE_RESPONSE_STATUSES = ["Commitment"];
	MFH_PLACEMENT_DEFAULT_APETITE_WINDOW_DAYS = 28;
	MFH_PLACEMENT_DEFAULT_BEST_FIT_WEIGHT = .5;
	MFH_PLACEMENT_DEFAULT_FAIRNESS_WEIGHT = .4;
	MFH_PLACEMENT_DEFAULT_RENEO_FIT_WEIGHT = .1;
	MFH_PLACEMENT_BEST_FIT_KPI_CAPS = {
		irrPercentage: .2,
		cocPercentage: .04,
		mocMultiplier: 2,
		investmentVolume: 5e7,
		ltv: .2
	};
	MFH_PLACEMENT_DEFAULT_BEST_FIT_SUB_WEIGHT = .2;
	MFH_PLACEMENT_ALLOCATED_SOURCING_STATES = [
		"DueDiligence",
		"Closing",
		"Closed"
	];
	TOP_7_CITIES = [
		"berlin",
		"dusseldorf",
		"frankfurt am main",
		"hamburg",
		"koln",
		"munchen",
		"stuttgart"
	];
	B_CITIES = [
		"bochum",
		"bonn",
		"bremen",
		"dortmund",
		"dresden",
		"duisburg",
		"essen",
		"hannover",
		"karlsruhe",
		"leipzig",
		"mannheim",
		"munster",
		"nurnberg",
		"wiesbaden"
	];
}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh-placement.helpers.ts
var isAllocatablePlacementResponseStatus, extractPlacementInvestmentCaseKpis, EQUITY_PERCENT_CALC_ENGINE_KEY, SOURCES_TOTAL_EURO_CALC_ENGINE_KEY, extractInvestmentCaseEquityEuro;
var init_mfh_placement_helpers = __esmMin((() => {
	init_mfh_investment_case_kpi_calc_engine_keys();
	init_mfh_placement_constants();
	isAllocatablePlacementResponseStatus = (status) => MFH_PLACEMENT_ALLOCATABLE_RESPONSE_STATUSES.includes(status);
	extractPlacementInvestmentCaseKpis = (investmentCase) => {
		const keys = resolveInvestmentCaseKpiCalcEngineKeys(investmentCase.d2gVersion);
		const read = (key, arrayIndex = 0) => readInvestmentCaseCalcEngineNumber(investmentCase, key, arrayIndex);
		const commercialAreaEntry = read(keys.commercialAreaEntry);
		const totalAreaEntry = read(keys.totalAreaEntry);
		const commercialShare = commercialAreaEntry !== void 0 && totalAreaEntry !== void 0 && totalAreaEntry > 0 ? commercialAreaEntry / totalAreaEntry : void 0;
		const purchasePrice = read(keys.purchasePrice);
		return {
			irrPercentage: read(keys.irrPercentage),
			mocMultiplier: read(keys.mocMultiplier),
			cocPercentage: read(keys.cocPercentage, 1),
			investmentVolume: read(keys.investmentVolume),
			ltv: read(keys.ltv),
			partnerFees: read(keys.partnerFees),
			commercialShare,
			holdingPeriodMonths: read(keys.holdingPeriodMonths),
			purchasePrice: purchasePrice === void 0 ? void 0 : Math.abs(purchasePrice),
			purchasePriceDiscount: investmentCase.caseInputs?.assumptions?.expectedPurchaseDiscount,
			capex: read(keys.capex),
			rentDevelopment: read(keys.rentDevelopment),
			disposalPrice: read(keys.disposalPrice),
			grossDisposalProceeds: read(keys.grossDisposalProceeds)
		};
	};
	EQUITY_PERCENT_CALC_ENGINE_KEY = "b_out_ic_charts__ic_s_u_equity_percent";
	SOURCES_TOTAL_EURO_CALC_ENGINE_KEY = "b_out_ic_charts__ic_s_u_total_euro";
	extractInvestmentCaseEquityEuro = (investmentCase) => {
		const equityPercent = readInvestmentCaseCalcEngineNumber(investmentCase, EQUITY_PERCENT_CALC_ENGINE_KEY, 1);
		const totalEuro = readInvestmentCaseCalcEngineNumber(investmentCase, SOURCES_TOTAL_EURO_CALC_ENGINE_KEY, 1);
		if (equityPercent === void 0 || totalEuro === void 0) return;
		return Math.abs(equityPercent) * Math.abs(totalEuro);
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh-placement-metro-area-codes.ts
var METROPOLITAN_AREA_ZIP_CODES;
var init_mfh_placement_metro_area_codes = __esmMin((() => {
	METROPOLITAN_AREA_ZIP_CODES = [
		"10115",
		"10117",
		"10119",
		"10178",
		"10179",
		"10243",
		"10245",
		"10247",
		"10249",
		"10315",
		"10317",
		"10318",
		"10319",
		"10365",
		"10367",
		"10369",
		"10405",
		"10407",
		"10409",
		"10435",
		"10437",
		"10439",
		"10551",
		"10553",
		"10555",
		"10557",
		"10559",
		"10585",
		"10587",
		"10589",
		"10623",
		"10625",
		"10627",
		"10629",
		"10707",
		"10709",
		"10711",
		"10713",
		"10715",
		"10717",
		"10719",
		"10777",
		"10779",
		"10781",
		"10783",
		"10785",
		"10787",
		"10789",
		"10823",
		"10825",
		"10827",
		"10829",
		"10961",
		"10963",
		"10965",
		"10967",
		"10969",
		"10997",
		"10999",
		"12043",
		"12045",
		"12047",
		"12049",
		"12051",
		"12053",
		"12055",
		"12057",
		"12059",
		"12099",
		"12101",
		"12103",
		"12105",
		"12107",
		"12109",
		"12157",
		"12159",
		"12161",
		"12163",
		"12165",
		"12167",
		"12169",
		"12203",
		"12205",
		"12207",
		"12209",
		"12247",
		"12249",
		"12277",
		"12279",
		"12305",
		"12307",
		"12309",
		"12347",
		"12349",
		"12351",
		"12353",
		"12355",
		"12357",
		"12359",
		"12435",
		"12437",
		"12439",
		"12459",
		"12487",
		"12489",
		"12524",
		"12526",
		"12527",
		"12529",
		"12555",
		"12557",
		"12559",
		"12587",
		"12589",
		"12619",
		"12621",
		"12623",
		"12627",
		"12629",
		"12679",
		"12681",
		"12683",
		"12685",
		"12687",
		"12689",
		"13051",
		"13053",
		"13055",
		"13057",
		"13059",
		"13086",
		"13088",
		"13089",
		"13125",
		"13127",
		"13129",
		"13156",
		"13158",
		"13159",
		"13187",
		"13189",
		"13347",
		"13349",
		"13351",
		"13353",
		"13355",
		"13357",
		"13359",
		"13403",
		"13405",
		"13407",
		"13409",
		"13435",
		"13437",
		"13439",
		"13465",
		"13467",
		"13469",
		"13503",
		"13505",
		"13507",
		"13509",
		"13581",
		"13583",
		"13585",
		"13587",
		"13589",
		"13591",
		"13593",
		"13595",
		"13597",
		"13599",
		"13627",
		"13629",
		"14050",
		"14052",
		"14053",
		"14055",
		"14057",
		"14059",
		"14089",
		"14109",
		"14129",
		"14163",
		"14165",
		"14167",
		"14169",
		"14193",
		"14195",
		"14197",
		"14199",
		"14467",
		"14469",
		"14471",
		"14473",
		"14476",
		"14478",
		"14480",
		"14482",
		"14513",
		"14532",
		"14542",
		"14558",
		"14612",
		"14621",
		"14624",
		"14641",
		"14656",
		"14974",
		"15344",
		"15345",
		"15366",
		"15370",
		"15537",
		"15562",
		"15566",
		"15569",
		"15711",
		"15712",
		"15713",
		"15732",
		"15738",
		"15745",
		"15831",
		"16321",
		"16341",
		"16356",
		"16515",
		"16540",
		"16547",
		"16548",
		"16552",
		"16556",
		"16562",
		"16727",
		"16761",
		"16766",
		"16767",
		"20095",
		"20097",
		"20099",
		"20144",
		"20146",
		"20148",
		"20149",
		"20249",
		"20251",
		"20253",
		"20255",
		"20257",
		"20259",
		"20354",
		"20355",
		"20357",
		"20359",
		"20457",
		"20459",
		"20535",
		"20537",
		"20539",
		"21029",
		"21031",
		"21033",
		"21035",
		"21037",
		"21039",
		"21073",
		"21075",
		"21077",
		"21079",
		"21107",
		"21109",
		"21129",
		"21147",
		"21149",
		"21217",
		"21218",
		"21220",
		"21224",
		"21227",
		"21228",
		"21244",
		"21335",
		"21337",
		"21339",
		"21365",
		"21391",
		"21423",
		"21435",
		"21465",
		"21481",
		"21493",
		"21502",
		"21509",
		"21614",
		"21629",
		"21680",
		"21682",
		"21683",
		"21684",
		"22041",
		"22043",
		"22045",
		"22047",
		"22049",
		"22081",
		"22083",
		"22085",
		"22087",
		"22089",
		"22111",
		"22113",
		"22115",
		"22117",
		"22119",
		"22143",
		"22145",
		"22147",
		"22149",
		"22159",
		"22175",
		"22177",
		"22179",
		"22297",
		"22299",
		"22301",
		"22303",
		"22305",
		"22307",
		"22309",
		"22335",
		"22337",
		"22339",
		"22359",
		"22391",
		"22393",
		"22395",
		"22397",
		"22399",
		"22415",
		"22417",
		"22419",
		"22453",
		"22455",
		"22457",
		"22459",
		"22523",
		"22525",
		"22527",
		"22529",
		"22547",
		"22549",
		"22559",
		"22587",
		"22589",
		"22605",
		"22607",
		"22609",
		"22761",
		"22763",
		"22765",
		"22767",
		"22769",
		"22844",
		"22846",
		"22848",
		"22850",
		"22851",
		"22869",
		"22880",
		"22885",
		"22926",
		"22927",
		"22941",
		"22949",
		"24558",
		"25335",
		"25336",
		"25337",
		"25355",
		"25421",
		"25436",
		"25451",
		"25462",
		"25469",
		"25474",
		"25479",
		"25482",
		"25488",
		"25492",
		"25494",
		"25495",
		"25497",
		"25499",
		"80331",
		"80333",
		"80335",
		"80336",
		"80337",
		"80339",
		"80469",
		"80538",
		"80539",
		"80634",
		"80636",
		"80637",
		"80638",
		"80639",
		"80686",
		"80687",
		"80689",
		"80796",
		"80797",
		"80798",
		"80799",
		"80801",
		"80802",
		"80803",
		"80804",
		"80805",
		"80807",
		"80809",
		"80933",
		"80935",
		"80937",
		"80939",
		"80992",
		"80993",
		"80995",
		"80997",
		"80999",
		"81241",
		"81243",
		"81245",
		"81247",
		"81249",
		"81369",
		"81371",
		"81373",
		"81375",
		"81377",
		"81379",
		"81475",
		"81476",
		"81477",
		"81479",
		"81539",
		"81541",
		"81543",
		"81545",
		"81547",
		"81549",
		"81667",
		"81669",
		"81671",
		"81673",
		"81675",
		"81677",
		"81679",
		"81735",
		"81737",
		"81739",
		"81825",
		"81827",
		"81829",
		"81925",
		"81927",
		"81929",
		"82008",
		"82024",
		"82031",
		"82041",
		"82049",
		"82061",
		"82065",
		"82067",
		"82069",
		"82110",
		"82131",
		"82140",
		"82152",
		"82166",
		"82178",
		"82194",
		"82205",
		"82223",
		"82229",
		"82234",
		"82237",
		"82239",
		"82256",
		"82266",
		"82275",
		"82278",
		"82284",
		"82285",
		"82291",
		"82293",
		"82296",
		"82299",
		"82319",
		"82327",
		"82335",
		"82340",
		"82343",
		"82346",
		"82347",
		"82349",
		"82515",
		"82538",
		"83022",
		"83024",
		"83026",
		"83071",
		"83101",
		"83620",
		"83624",
		"84028",
		"84030",
		"84032",
		"84034",
		"84036",
		"85049",
		"85051",
		"85053",
		"85055",
		"85057",
		"85221",
		"85229",
		"85232",
		"85241",
		"85354",
		"85356",
		"85368",
		"85386",
		"85391",
		"85395",
		"85399",
		"85521",
		"85540",
		"85551",
		"85560",
		"85567",
		"85570",
		"85579",
		"85591",
		"85598",
		"85604",
		"85609",
		"85622",
		"85630",
		"85649",
		"85716",
		"85737",
		"85748",
		"85757",
		"85764",
		"85774",
		"86150",
		"86152",
		"86153",
		"86154",
		"86156",
		"86157",
		"86159",
		"86161",
		"86163",
		"86165",
		"86167",
		"86169",
		"86179",
		"86199",
		"55116",
		"55118",
		"55120",
		"55122",
		"55124",
		"55126",
		"55127",
		"55128",
		"55129",
		"55130",
		"55131",
		"55218",
		"55246",
		"55252",
		"55257",
		"55262",
		"60306",
		"60308",
		"60310",
		"60311",
		"60313",
		"60314",
		"60316",
		"60318",
		"60320",
		"60322",
		"60323",
		"60325",
		"60326",
		"60327",
		"60329",
		"60385",
		"60386",
		"60388",
		"60389",
		"60431",
		"60433",
		"60435",
		"60437",
		"60438",
		"60439",
		"60486",
		"60487",
		"60488",
		"60489",
		"60528",
		"60529",
		"60549",
		"60594",
		"60596",
		"60598",
		"60599",
		"61118",
		"61130",
		"61137",
		"61138",
		"61348",
		"61350",
		"61352",
		"61381",
		"61440",
		"61449",
		"61462",
		"61476",
		"61479",
		"63065",
		"63067",
		"63069",
		"63071",
		"63073",
		"63075",
		"63110",
		"63128",
		"63150",
		"63165",
		"63179",
		"63225",
		"63263",
		"63303",
		"63329",
		"63450",
		"63452",
		"63454",
		"63456",
		"63457",
		"63477",
		"63486",
		"63500",
		"64283",
		"64285",
		"64287",
		"64289",
		"64291",
		"64293",
		"64295",
		"64297",
		"64319",
		"64331",
		"64347",
		"64380",
		"64390",
		"64521",
		"64546",
		"64560",
		"64569",
		"64572",
		"65183",
		"65185",
		"65187",
		"65189",
		"65191",
		"65193",
		"65195",
		"65197",
		"65199",
		"65201",
		"65203",
		"65205",
		"65207",
		"65239",
		"65428",
		"65439",
		"65451",
		"65462",
		"65468",
		"65474",
		"65479",
		"65719",
		"65760",
		"65779",
		"65795",
		"65812",
		"65817",
		"65824",
		"65830",
		"65835",
		"65843",
		"65929",
		"65931",
		"65933",
		"65934",
		"65936",
		"41515",
		"41516",
		"41517",
		"41539",
		"41540",
		"41541",
		"41542",
		"42103",
		"42105",
		"42107",
		"42109",
		"42111",
		"42113",
		"42115",
		"42117",
		"42119",
		"42275",
		"42277",
		"42279",
		"42281",
		"42283",
		"42285",
		"42287",
		"42289",
		"42327",
		"42329",
		"42349",
		"42369",
		"42389",
		"42399",
		"42579",
		"42651",
		"42653",
		"42655",
		"42657",
		"42659",
		"42697",
		"42699",
		"42719",
		"42799",
		"42853",
		"42855",
		"42857",
		"42859",
		"42897",
		"42899",
		"50126",
		"50127",
		"50129",
		"50169",
		"50171",
		"50181",
		"50226",
		"50259",
		"50321",
		"50354",
		"50374",
		"50389",
		"50667",
		"50668",
		"50670",
		"50672",
		"50674",
		"50676",
		"50677",
		"50678",
		"50679",
		"50733",
		"50735",
		"50737",
		"50739",
		"50765",
		"50767",
		"50769",
		"50823",
		"50825",
		"50827",
		"50829",
		"50858",
		"50859",
		"50931",
		"50933",
		"50935",
		"50937",
		"50939",
		"50968",
		"50969",
		"50996",
		"50997",
		"50999",
		"51061",
		"51063",
		"51065",
		"51067",
		"51069",
		"51103",
		"51105",
		"51107",
		"51109",
		"51143",
		"51145",
		"51147",
		"51149",
		"51371",
		"51373",
		"51375",
		"51377",
		"51379",
		"51381",
		"51399",
		"51427",
		"51429",
		"51465",
		"51467",
		"51469",
		"51491",
		"51503",
		"51515",
		"51519",
		"53111",
		"53113",
		"53115",
		"53117",
		"53119",
		"53121",
		"53123",
		"53125",
		"53127",
		"53129",
		"53173",
		"53175",
		"53177",
		"53179",
		"53225",
		"53227",
		"53229",
		"53340",
		"53343",
		"53347",
		"53359",
		"53604",
		"53619",
		"53639",
		"53721",
		"53757",
		"53840",
		"53842",
		"53844",
		"40210",
		"40211",
		"40212",
		"40213",
		"40215",
		"40217",
		"40219",
		"40221",
		"40223",
		"40225",
		"40227",
		"40229",
		"40231",
		"40233",
		"40235",
		"40237",
		"40239",
		"40468",
		"40470",
		"40472",
		"40474",
		"40476",
		"40477",
		"40479",
		"40489",
		"40545",
		"40547",
		"40549",
		"40589",
		"40591",
		"40593",
		"40595",
		"40597",
		"40599",
		"40625",
		"40627",
		"40629",
		"40667",
		"40668",
		"40670",
		"40699",
		"40721",
		"40723",
		"40724",
		"40764",
		"40789",
		"40822",
		"40878",
		"40880",
		"40882",
		"40883",
		"40885",
		"41061",
		"41063",
		"41065",
		"41066",
		"41068",
		"41069",
		"41334",
		"41352",
		"41363",
		"41366",
		"41372",
		"41379",
		"41460",
		"41462",
		"41464",
		"41466",
		"41468",
		"41469",
		"41470",
		"41472",
		"41564",
		"41569",
		"41747",
		"41748",
		"41749",
		"41751",
		"42489",
		"42549",
		"42551",
		"42553",
		"42555",
		"42781",
		"45127",
		"45128",
		"45130",
		"45131",
		"45133",
		"45134",
		"45136",
		"45138",
		"45139",
		"45141",
		"45143",
		"45144",
		"45145",
		"45147",
		"45149",
		"45219",
		"45239",
		"45257",
		"45259",
		"45276",
		"45277",
		"45279",
		"45289",
		"45307",
		"45309",
		"45326",
		"45327",
		"45329",
		"45355",
		"45356",
		"45357",
		"45359",
		"45468",
		"45470",
		"45472",
		"45473",
		"45475",
		"45476",
		"45478",
		"45479",
		"45481",
		"45525",
		"45527",
		"45529",
		"45549",
		"46045",
		"46047",
		"46049",
		"46117",
		"46119",
		"46145",
		"46147",
		"46149",
		"46236",
		"46238",
		"46240",
		"46242",
		"46244",
		"47051",
		"47053",
		"47055",
		"47057",
		"47058",
		"47059",
		"47119",
		"47137",
		"47138",
		"47139",
		"47166",
		"47167",
		"47169",
		"47178",
		"47179",
		"47198",
		"47199",
		"47226",
		"47228",
		"47229",
		"47239",
		"47249",
		"47259",
		"47269",
		"47279",
		"47798",
		"47799",
		"47800",
		"47802",
		"47803",
		"47804",
		"47805",
		"47807",
		"47809",
		"47829",
		"47839",
		"47877",
		"47906",
		"47918",
		"70173",
		"70174",
		"70176",
		"70178",
		"70180",
		"70182",
		"70184",
		"70186",
		"70188",
		"70190",
		"70191",
		"70192",
		"70193",
		"70195",
		"70197",
		"70199",
		"70327",
		"70329",
		"70372",
		"70374",
		"70376",
		"70378",
		"70435",
		"70437",
		"70439",
		"70469",
		"70499",
		"70563",
		"70565",
		"70567",
		"70569",
		"70597",
		"70599",
		"70619",
		"70629",
		"70734",
		"70736",
		"70771",
		"70794",
		"70806",
		"70825",
		"70839",
		"71032",
		"71034",
		"71063",
		"71065",
		"71067",
		"71069",
		"71083",
		"71088",
		"71093",
		"71101",
		"71106",
		"71111",
		"71116",
		"71120",
		"71126",
		"71131",
		"71134",
		"71139",
		"71144",
		"71149",
		"71154",
		"71155",
		"71157",
		"71159",
		"71229",
		"71254",
		"71272",
		"71282",
		"71332",
		"71334",
		"71336",
		"71364",
		"71384",
		"71394",
		"71397",
		"71404",
		"71409",
		"71522",
		"71540",
		"71546",
		"71549",
		"71554",
		"71560",
		"71563",
		"71566",
		"71570",
		"71573",
		"71576",
		"71634",
		"71636",
		"71638",
		"71640",
		"71642",
		"71665",
		"71672",
		"71679",
		"71686",
		"71691",
		"71696",
		"71701",
		"71706",
		"71711",
		"71717",
		"71720",
		"71723",
		"71726",
		"71729",
		"71732",
		"71735",
		"71737",
		"71739",
		"72070",
		"72072",
		"72074",
		"72076",
		"72108",
		"72116",
		"72119",
		"72124",
		"72127",
		"72131",
		"72135",
		"72138",
		"72141",
		"72144",
		"72147",
		"72149",
		"72555",
		"72622",
		"72636",
		"72760",
		"72762",
		"72764",
		"72766",
		"72768",
		"72770",
		"72810",
		"72827",
		"73033",
		"73035",
		"73037",
		"73054",
		"73072",
		"73084",
		"73117",
		"73230",
		"73235",
		"73240",
		"73614",
		"73630",
		"73650",
		"73655",
		"73660",
		"73663",
		"73666",
		"73667",
		"73669",
		"73728",
		"73730",
		"73732",
		"73733",
		"73734",
		"73760",
		"73773",
		"73779",
		"74072",
		"74074",
		"74076",
		"74078",
		"74080",
		"74172",
		"74189",
		"74193",
		"74199",
		"74211",
		"74223",
		"74226",
		"74229",
		"74232",
		"74235",
		"74321",
		"74336",
		"74348",
		"75172",
		"75173",
		"75175",
		"75177",
		"75179",
		"75180",
		"75181",
		"75392"
	];
}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh-buy-box.helpers.ts
var BUY_BOX_CRITERION_DIRECTION, computeCommercialUnitShare, computeBuyBoxStatus, asFiniteNumber$1, LOCATION_TIER_VALUES, asLocationTiers, normalizeBuyBoxConfig, evaluateInvestmentCaseBuyBox, listBuyBoxFailingCriteria, failingCriterion, buildMinComparison, buildMaxComparison, buildLocationComparison, classifyCityTiers;
var init_mfh_buy_box_helpers = __esmMin((() => {
	init_location_model();
	init_mfh_placement_constants();
	init_mfh_placement_metro_area_codes();
	BUY_BOX_CRITERION_DIRECTION = {
		irrPercentage: "min",
		mocMultiplier: "min",
		cocPercentage: "min",
		purchasePrice: "min",
		purchasePriceDiscount: "max",
		investmentVolume: "min",
		ltv: "max",
		commercialShare: "max",
		preferredLocations: "includes"
	};
	computeCommercialUnitShare = (commercialUnits, residentialUnits) => {
		const commercial = commercialUnits ?? 0;
		const total = commercial + (residentialUnits ?? 0);
		return total > 0 ? commercial / total : void 0;
	};
	computeBuyBoxStatus = (matrix) => Object.values(matrix).every((comparison) => comparison.status === "Pass") ? "Pass" : "Fail";
	asFiniteNumber$1 = /* @__PURE__ */ __name((value) => typeof value === "number" && Number.isFinite(value) ? value : void 0, "asFiniteNumber");
	LOCATION_TIER_VALUES = new Set(Object.values(LocationTeir));
	asLocationTiers = (value) => {
		if (!Array.isArray(value)) return void 0;
		const tiers = value.filter((item) => typeof item === "string" && LOCATION_TIER_VALUES.has(item));
		return tiers.length > 0 ? tiers : void 0;
	};
	normalizeBuyBoxConfig = (config) => ({
		...config,
		irrPercentageThreshold: asFiniteNumber$1(config.irrPercentageThreshold),
		mocMultiplierThreshold: asFiniteNumber$1(config.mocMultiplierThreshold),
		cocPercentageThreshold: asFiniteNumber$1(config.cocPercentageThreshold),
		purchasePriceThreshold: asFiniteNumber$1(config.purchasePriceThreshold),
		purchasePriceDiscountThreshold: asFiniteNumber$1(config.purchasePriceDiscountThreshold),
		investmentVolumeThreshold: asFiniteNumber$1(config.investmentVolumeThreshold),
		ltvThreshold: asFiniteNumber$1(config.ltvThreshold),
		commercialShareThreshold: asFiniteNumber$1(config.commercialShareThreshold),
		preferredLocationsThreshold: asLocationTiers(config.preferredLocationsThreshold)
	});
	evaluateInvestmentCaseBuyBox = (kpis, config, fallbackCommercialShare, location) => {
		const normalized = normalizeBuyBoxConfig(config);
		const commercialShare = kpis.commercialShare ?? fallbackCommercialShare;
		const buyBoxMatrix = {
			irrPercentage: buildMinComparison(kpis.irrPercentage, normalized.irrPercentageThreshold),
			mocMultiplier: buildMinComparison(kpis.mocMultiplier, normalized.mocMultiplierThreshold),
			cocPercentage: buildMinComparison(kpis.cocPercentage, normalized.cocPercentageThreshold),
			purchasePrice: buildMinComparison(kpis.purchasePrice, normalized.purchasePriceThreshold),
			purchasePriceDiscount: buildMaxComparison(kpis.purchasePriceDiscount, normalized.purchasePriceDiscountThreshold),
			investmentVolume: buildMinComparison(kpis.investmentVolume, normalized.investmentVolumeThreshold),
			ltv: buildMaxComparison(kpis.ltv, normalized.ltvThreshold),
			commercialShare: buildMaxComparison(commercialShare, normalized.commercialShareThreshold),
			preferredLocations: buildLocationComparison(location, normalized.preferredLocationsThreshold)
		};
		return {
			buyBoxMatrix,
			buyBoxStatus: computeBuyBoxStatus(buyBoxMatrix)
		};
	};
	listBuyBoxFailingCriteria = (matrix, kpis, config, fallbackCommercialShare) => {
		const normalized = normalizeBuyBoxConfig(config);
		const commercialShare = kpis.commercialShare ?? fallbackCommercialShare;
		const numericActuals = {
			irrPercentage: kpis.irrPercentage,
			mocMultiplier: kpis.mocMultiplier,
			cocPercentage: kpis.cocPercentage,
			purchasePrice: kpis.purchasePrice,
			purchasePriceDiscount: kpis.purchasePriceDiscount,
			investmentVolume: kpis.investmentVolume,
			ltv: kpis.ltv,
			commercialShare
		};
		const numericThresholds = {
			irrPercentage: normalized.irrPercentageThreshold,
			mocMultiplier: normalized.mocMultiplierThreshold,
			cocPercentage: normalized.cocPercentageThreshold,
			purchasePrice: normalized.purchasePriceThreshold,
			purchasePriceDiscount: normalized.purchasePriceDiscountThreshold,
			investmentVolume: normalized.investmentVolumeThreshold,
			ltv: normalized.ltvThreshold,
			commercialShare: normalized.commercialShareThreshold
		};
		const failing = [];
		for (const key of Object.keys(numericActuals)) {
			const comparison = matrix[key];
			if (!comparison || comparison.status !== "Fail") continue;
			failing.push(failingCriterion(key, numericActuals[key] ?? null, numericThresholds[key], BUY_BOX_CRITERION_DIRECTION[key]));
		}
		if (matrix.preferredLocations.status === "Fail") failing.push(failingCriterion("preferredLocations", matrix.preferredLocations.value, normalized.preferredLocationsThreshold, "includes"));
		return failing;
	};
	failingCriterion = (key, actual, threshold, direction) => ({
		key,
		actual,
		direction,
		...typeof threshold === "number" && Number.isFinite(threshold) || Array.isArray(threshold) ? { threshold } : {}
	});
	buildMinComparison = (value, threshold) => ({
		value: value ?? 0,
		threshold: threshold ?? 0,
		status: threshold === void 0 || value !== void 0 && value >= threshold ? "Pass" : "Fail"
	});
	buildMaxComparison = (value, threshold) => ({
		value: value ?? 0,
		threshold: threshold ?? 0,
		status: threshold === void 0 || value !== void 0 && value <= threshold ? "Pass" : "Fail"
	});
	buildLocationComparison = (location, preferredLocationsThreshold) => {
		const tiers = classifyCityTiers(location);
		const threshold = preferredLocationsThreshold ?? [];
		return {
			value: tiers,
			threshold,
			status: threshold.length === 0 || threshold.some((accepted) => tiers.includes(accepted)) ? "Pass" : "Fail"
		};
	};
	classifyCityTiers = (location) => {
		const tiers = [];
		const city = location?.city;
		const zipcode = location?.zipcode;
		if (city) {
			const normalized = deburr$1(city.trim().toLowerCase());
			if (TOP_7_CITIES.includes(normalized)) tiers.push("A");
			if (B_CITIES.includes(normalized)) tiers.push("B");
		}
		if (zipcode && METROPOLITAN_AREA_ZIP_CODES.includes(zipcode)) tiers.push("C");
		return tiers;
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/screening-check/mfh-screening-check.model.ts
var MFH_MANDATE_RULE_SET_ID, MFH_REGULATORY_CRITERION_IDS, MFH_MANDATE_CRITERION_IDS, MfhScreeningRecommendation;
var init_mfh_screening_check_model = __esmMin((() => {
	MFH_MANDATE_RULE_SET_ID = "aa-mandate-v2";
	MFH_REGULATORY_CRITERION_IDS = [
		"milieuschutz",
		"denkmalschutz",
		"staedtebaulich"
	];
	MFH_MANDATE_CRITERION_IDS = [
		"purchase-price",
		"construction-year",
		"energy-class",
		"price-per-sqm"
	];
	MfhScreeningRecommendation = /* @__PURE__ */ function(MfhScreeningRecommendation) {
		MfhScreeningRecommendation["MoveToEvaluation"] = "moveToEvaluation";
		MfhScreeningRecommendation["Reject"] = "reject";
		/** A regulatory item is unanswered or a mandate criterion could not be evaluated. */
		MfhScreeningRecommendation["CompleteCheck"] = "completeCheck";
		return MfhScreeningRecommendation;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/mfh/screening-check/mfh-screening-check.mandate.ts
var MFH_SCREENING_EDITABLE_MEASUREMENTS, MFH_SCREENING_MIN_CONSTRUCTION_YEAR, ENERGY_CLASSES$1, normalizeMfhScreeningMeasurementsUpdate, deriveMfhMandateScreeningStatus, evaluateMandateRule, evaluateMfhMandateScreening, applyMfhMandateOverrides;
var init_mfh_screening_check_mandate = __esmMin((() => {
	init_energy_efficiency();
	init_base_errors();
	init_mfh_screening_check_model();
	MFH_SCREENING_EDITABLE_MEASUREMENTS = {
		"purchase-price": {
			measurement: "purchasePriceEur",
			fieldPath: "price.purchasePriceNett"
		},
		"construction-year": {
			measurement: "constructionYear",
			fieldPath: "attributes.constructionYear"
		},
		"energy-class": {
			measurement: "energyCertificateClass",
			fieldPath: "attributes.energyCertificateClass"
		}
	};
	MFH_SCREENING_MIN_CONSTRUCTION_YEAR = 1500;
	ENERGY_CLASSES$1 = new Set(Object.values(EnergyConsumptionCategory));
	normalizeMfhScreeningMeasurementsUpdate = (update) => {
		const normalized = {};
		if (update.purchasePriceEur !== void 0) {
			if (!Number.isFinite(update.purchasePriceEur) || update.purchasePriceEur <= 0) throw new ValidationFailedError("Purchase price must be a positive number.");
			normalized.purchasePriceEur = update.purchasePriceEur;
		}
		if (update.constructionYear !== void 0) {
			if (!Number.isInteger(update.constructionYear) || update.constructionYear < 1500) throw new ValidationFailedError(`Construction year must be a whole year from ${MFH_SCREENING_MIN_CONSTRUCTION_YEAR}.`);
			normalized.constructionYear = update.constructionYear;
		}
		if (update.energyCertificateClass !== void 0) {
			const energyClass = update.energyCertificateClass.trim().toUpperCase();
			if (!ENERGY_CLASSES$1.has(energyClass)) throw new ValidationFailedError(`Unknown energy class: ${update.energyCertificateClass}.`);
			normalized.energyCertificateClass = energyClass;
		}
		if (update.regulatoryAnswers && Object.keys(update.regulatoryAnswers).length > 0) {
			for (const [criterionId, answer] of Object.entries(update.regulatoryAnswers)) {
				if (!MFH_REGULATORY_CRITERION_IDS.includes(criterionId)) throw new ValidationFailedError(`Unknown regulatory criterion: ${criterionId}.`);
				if (answer !== "applicable" && answer !== "not_applicable") throw new ValidationFailedError(`Invalid answer for ${criterionId}.`);
			}
			normalized.regulatoryAnswers = { ...update.regulatoryAnswers };
		}
		if (Object.keys(normalized).length === 0) throw new ValidationFailedError("No screening value to update.");
		return normalized;
	};
	deriveMfhMandateScreeningStatus = (criteria) => {
		if (criteria.some((criterion) => criterion.effectiveStatus === "unevaluated")) return "blocked";
		return criteria.some((criterion) => criterion.effectiveStatus === "fail") ? "knocked_out" : "cleared";
	};
	evaluateMandateRule = (rule, measurements) => {
		const base = {
			criterionId: rule.criterionId,
			label: rule.label,
			unit: rule.unit,
			threshold: rule.threshold
		};
		try {
			const measuredValue = rule.measure(measurements);
			if (measuredValue === void 0 || typeof measuredValue === "number" && !Number.isFinite(measuredValue)) return {
				...base,
				measuredValue: null,
				status: "fail",
				effectiveStatus: "fail",
				error: "measurement_missing"
			};
			const status = rule.passes(measuredValue) ? "pass" : "fail";
			return {
				...base,
				measuredValue,
				status,
				effectiveStatus: status
			};
		} catch (error) {
			return {
				...base,
				measuredValue: null,
				status: "unevaluated",
				effectiveStatus: "unevaluated",
				error: error instanceof Error ? error.message : String(error)
			};
		}
	};
	evaluateMfhMandateScreening = (measurements, evaluatedAt, rules) => {
		const criteria = rules.map((rule) => evaluateMandateRule(rule, measurements));
		return {
			ruleSetId: MFH_MANDATE_RULE_SET_ID,
			status: deriveMfhMandateScreeningStatus(criteria),
			criteria,
			evaluatedAt
		};
	};
	applyMfhMandateOverrides = (params) => {
		const criteriaById = new Map(params.screening.criteria.map((criterion) => [criterion.criterionId, criterion]));
		for (const criterionId of Object.keys(params.overrides)) if (!criteriaById.has(criterionId)) throw new ValidationFailedError(`Unknown mandate criterion: ${criterionId}.`);
		const criteria = params.screening.criteria.map((criterion) => {
			const override = params.overrides[criterion.criterionId];
			if (!override) return criterion;
			if (criterion.status === "unevaluated") throw new ValidationFailedError(`Unevaluated criterion ${criterion.criterionId} cannot be overridden.`);
			if (override.reason.trim().length === 0) throw new ValidationFailedError(`Override reason missing for ${criterion.criterionId}.`);
			return {
				...criterion,
				effectiveStatus: override.outcome,
				override: {
					originalStatus: criterion.status,
					outcome: override.outcome,
					reason: override.reason.trim(),
					actor: params.actorId,
					timestamp: params.recordedAt
				}
			};
		});
		return {
			...params.screening,
			status: deriveMfhMandateScreeningStatus(criteria),
			criteria
		};
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/screening-check/mfh-screening-check.regulatory.ts
var MFH_MILIEUSCHUTZ_GEODATA_RESTRICTION, isMfhRegulatoryCriterionId, answerFromRestrictions, suggestMfhRegulatoryAnswers, applyMfhRegulatoryAnswersToRestrictions, applyMfhMilieuschutzGeodataToRestrictions, mfhRegulatoryAnswersFromScreening, isMfhRegulatoryKnockout, applyMfhRegulatoryAttestation;
var init_mfh_screening_check_regulatory = __esmMin((() => {
	init_base_errors();
	init_mfh_screening_check_model();
	MFH_MILIEUSCHUTZ_GEODATA_RESTRICTION = "CompositionOfTheResidentPopulation";
	isMfhRegulatoryCriterionId = (value) => MFH_REGULATORY_CRITERION_IDS.some((criterionId) => criterionId === value);
	answerFromRestrictions = (restrictions, criterion) => criterion.restrictions.some((restriction) => restrictions?.includes(restriction)) ? "applicable" : "not_applicable";
	suggestMfhRegulatoryAnswers = (criteria, restrictions, milieuschutzFromGeodata) => {
		const answers = {};
		for (const criterion of criteria) {
			if (!isMfhRegulatoryCriterionId(criterion.criterionId)) continue;
			answers[criterion.criterionId] = criterion.criterionId === "milieuschutz" && milieuschutzFromGeodata ? milieuschutzFromGeodata : answerFromRestrictions(restrictions, criterion);
		}
		return answers;
	};
	applyMfhRegulatoryAnswersToRestrictions = (criteria, current, answers) => {
		const answered = criteria.filter((criterion) => isMfhRegulatoryCriterionId(criterion.criterionId) && answers[criterion.criterionId] !== void 0);
		const answeredFlags = new Set(answered.flatMap((criterion) => criterion.restrictions));
		const next = (current ?? []).filter((entry) => entry !== "None" && !answeredFlags.has(entry));
		for (const criterion of answered) {
			if (answers[criterion.criterionId] !== "applicable") continue;
			for (const restriction of criterion.restrictions) if (!next.includes(restriction)) next.push(restriction);
		}
		return next;
	};
	applyMfhMilieuschutzGeodataToRestrictions = (current, milieuschutz) => {
		const next = (current ?? []).filter((entry) => entry !== "None" && entry !== MFH_MILIEUSCHUTZ_GEODATA_RESTRICTION);
		return milieuschutz === "applicable" ? [...next, MFH_MILIEUSCHUTZ_GEODATA_RESTRICTION] : next;
	};
	mfhRegulatoryAnswersFromScreening = (screening) => {
		const answers = {};
		for (const attestation of screening.attestations) if (isMfhRegulatoryCriterionId(attestation.criterionId)) answers[attestation.criterionId] = attestation.answer;
		return answers;
	};
	isMfhRegulatoryKnockout = (attestation) => {
		if (attestation.override?.outcome === "pass") return false;
		if (attestation.override?.outcome === "fail") return true;
		return attestation.answer === "applicable";
	};
	applyMfhRegulatoryAttestation = (params) => {
		if (params.noneApply && params.answers) throw new ValidationFailedError("Provide individual regulatory answers or use noneApply, not both.");
		const knownIds = new Set(params.criteria.map((criterion) => criterion.criterionId));
		if (!Object.keys(params.overrides ?? {}).every((criterionId) => knownIds.has(criterionId))) throw new ValidationFailedError("Regulatory overrides contain an unknown criterion.");
		if (!Object.keys(params.answers ?? {}).every((criterionId) => knownIds.has(criterionId))) throw new ValidationFailedError("Regulatory answers contain an unknown criterion.");
		const attestations = params.criteria.map(({ criterionId, label }) => {
			const answer = params.noneApply ? "not_applicable" : params.answers?.[criterionId];
			if (!answer) throw new ValidationFailedError(`Regulatory answer missing for ${criterionId}.`);
			const override = params.overrides?.[criterionId];
			if (override && override.reason.trim().length === 0) throw new ValidationFailedError(`Override reason missing for ${criterionId}.`);
			return {
				criterionId,
				label,
				answer,
				actor: params.actorId,
				timestamp: params.recordedAt,
				...override ? { override: {
					originalStatus: answer === "applicable" ? "fail" : "pass",
					outcome: override.outcome,
					reason: override.reason.trim(),
					actor: params.actorId,
					timestamp: params.recordedAt
				} } : {}
			};
		});
		return {
			status: attestations.some(isMfhRegulatoryKnockout) ? "knocked_out" : "cleared",
			attestations
		};
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/screening-check/mfh-screening-check.helpers.ts
var MFH_SCREENING_CRITERION_REJECTION_REASON, MFH_SCREENING_FALLBACK_REJECTION_REASON, suggestMfhScreeningRejectionReason, evaluateMfhScreeningVerdict, buildMfhScreeningCheckRecord, buildMfhScreeningCheck, buildMfhScreeningCheckSnapshot;
var init_mfh_screening_check_helpers = __esmMin((() => {
	init_base_errors();
	init_mfh_screening_check_mandate();
	init_mfh_screening_check_model();
	init_mfh_screening_check_regulatory();
	MFH_SCREENING_CRITERION_REJECTION_REASON = {
		denkmalschutz: "MonumentProtection",
		milieuschutz: "PreservationAreaCompositionResidentialPopulation",
		staedtebaulich: "PreservationAreaUrbanCharacter",
		"energy-class": "EPCRating",
		"purchase-price": "ACQPriceTooHigh",
		"price-per-sqm": "ACQPriceTooHigh",
		"construction-year": "Building"
	};
	MFH_SCREENING_FALLBACK_REJECTION_REASON = "Other";
	suggestMfhScreeningRejectionReason = (failingCriterionIds) => {
		const [firstFailing] = failingCriterionIds;
		if (!firstFailing) return null;
		return MFH_SCREENING_CRITERION_REJECTION_REASON[firstFailing] ?? MFH_SCREENING_FALLBACK_REJECTION_REASON;
	};
	evaluateMfhScreeningVerdict = (params) => {
		const failingRegulatory = params.regulatoryCriteria.filter(({ criterionId }) => {
			const override = params.overrides[criterionId];
			return override ? override.outcome === "fail" : params.answers[criterionId] === "applicable";
		}).map(({ criterionId }) => criterionId);
		const failingMandate = params.mandateCriteria.filter(({ criterionId, status }) => {
			const override = params.overrides[criterionId];
			return override ? override.outcome === "fail" : status !== "pass";
		}).map(({ criterionId }) => criterionId);
		const failingCriterionIds = [...failingRegulatory, ...failingMandate];
		const isIncomplete = params.regulatoryCriteria.some(({ criterionId }) => !params.answers[criterionId] && !params.overrides[criterionId]) || params.mandateCriteria.some(({ criterionId, status }) => status === "unevaluated" && !params.overrides[criterionId]);
		return {
			outcome: isIncomplete ? "blocked" : failingCriterionIds.length > 0 ? "knocked_out" : "cleared",
			failingCriterionIds,
			recommendation: failingCriterionIds.length > 0 ? "reject" : isIncomplete ? "completeCheck" : "moveToEvaluation",
			suggestedRejectionReason: suggestMfhScreeningRejectionReason(failingCriterionIds)
		};
	};
	buildMfhScreeningCheckRecord = (params) => {
		const actor = params.actorId ?? "unknown";
		const regulatoryOverrides = Object.fromEntries(Object.entries(params.overrides ?? {}).filter(([criterionId]) => isMfhRegulatoryCriterionId(criterionId)));
		const mandateOverrides = Object.fromEntries(Object.entries(params.overrides ?? {}).filter(([criterionId]) => !isMfhRegulatoryCriterionId(criterionId)));
		const knownMandateIds = new Set(params.rules.map((rule) => rule.criterionId));
		for (const criterionId of Object.keys(mandateOverrides)) if (!knownMandateIds.has(criterionId)) throw new ValidationFailedError(`Unknown screening criterion: ${criterionId}.`);
		const regulatoryScreening = applyMfhRegulatoryAttestation({
			criteria: params.regulatoryCriteria,
			actorId: actor,
			answers: params.answers,
			noneApply: params.noneApply,
			overrides: regulatoryOverrides,
			recordedAt: params.recordedAt
		});
		const overrides = {};
		for (const [criterionId, override] of Object.entries(params.overrides ?? {})) {
			const reason = override.reason.trim();
			if (!reason) throw new ValidationFailedError(`Override reason missing for ${criterionId}.`);
			const previous = params.previous?.overrides[criterionId];
			const isUnchanged = previous?.outcome === override.outcome && previous.reason === reason;
			overrides[criterionId] = {
				outcome: override.outcome,
				reason,
				actor: isUnchanged ? previous.actor : params.actorId,
				timestamp: isUnchanged ? previous.timestamp : params.recordedAt
			};
		}
		return {
			ruleSetId: MFH_MANDATE_RULE_SET_ID,
			answers: mfhRegulatoryAnswersFromScreening(regulatoryScreening),
			overrides,
			recordedBy: params.actorId,
			recordedAt: params.recordedAt
		};
	};
	buildMfhScreeningCheck = (params) => {
		const record = params.record ?? null;
		const overrides = record?.overrides ?? {};
		const suggestedAnswers = suggestMfhRegulatoryAnswers(params.regulatoryCriteria, params.restrictions, params.milieuschutzFromGeodata);
		const regulatoryIds = new Set(params.regulatoryCriteria.map((criterion) => criterion.criterionId));
		const storedAnswers = Object.fromEntries(Object.entries(record?.answers ?? {}).filter(([criterionId]) => regulatoryIds.has(criterionId)));
		const answers = {
			...suggestedAnswers,
			...storedAnswers
		};
		const evaluated = evaluateMfhMandateScreening(params.measurements, params.evaluatedAt, params.rules);
		const mandateOverrides = Object.fromEntries(Object.entries(overrides).filter(([criterionId]) => evaluated.criteria.some((criterion) => criterion.criterionId === criterionId && criterion.status !== "unevaluated")));
		const mandateScreening = applyMfhMandateOverrides({
			actorId: record?.recordedBy ?? "unknown",
			overrides: mandateOverrides,
			recordedAt: record?.recordedAt ?? params.evaluatedAt,
			screening: evaluated
		});
		return {
			mfhId: params.mfhId,
			ruleSetId: evaluated.ruleSetId,
			regulatoryCriteria: params.regulatoryCriteria,
			suggestedAnswers,
			answers,
			overrides,
			mandateScreening,
			record,
			...evaluateMfhScreeningVerdict({
				regulatoryCriteria: params.regulatoryCriteria,
				answers,
				mandateCriteria: evaluated.criteria,
				overrides
			})
		};
	};
	buildMfhScreeningCheckSnapshot = (params, check) => ({
		evaluatedAt: params.evaluatedAt,
		measurements: params.measurements,
		restrictions: [...params.restrictions ?? []],
		regulatoryCriteria: params.regulatoryCriteria.map(({ criterionId, label }) => ({
			criterionId,
			label
		})),
		milieuschutzFromGeodata: params.milieuschutzFromGeodata ?? null,
		suggestedAnswers: check.suggestedAnswers,
		mandateCriteria: check.mandateScreening.criteria,
		outcome: check.outcome,
		failingCriterionIds: check.failingCriterionIds,
		recommendation: check.recommendation,
		suggestedRejectionReason: check.suggestedRejectionReason
	});
}));
//#endregion
//#region src/domains/cross-cutting/mfh/screening-check/mfh-sourcing-criteria.ts
var MfhSourcingCriterionMeasurement, MfhSourcingCriterionOperator, NUMBER_OPERATORS, LIST_OPERATORS, MFH_SOURCING_CRITERION_OPERATORS, MEASUREMENT_UNIT, measure, normalizeListValue, passes, OPERATOR_SYMBOL, formatMfhSourcingCriterionThreshold, isMfhRegulatorySourcingCriterion, activeInOrder, buildMfhRegulatoryCriteria, buildMfhMandateRules, findFailingMfhSourcingCriteria, ENERGY_CLASSES, RESTRICTION_FLAGS, normalizeMfhSourcingCriterionUpdates;
var init_mfh_sourcing_criteria = __esmMin((() => {
	init_energy_efficiency();
	init_base_errors();
	init_mfh_attributes_base();
	init_mfh_screening_check_mandate();
	init_mfh_screening_check_regulatory();
	MfhSourcingCriterionMeasurement = /* @__PURE__ */ function(MfhSourcingCriterionMeasurement) {
		MfhSourcingCriterionMeasurement["PurchasePriceEur"] = "purchasePriceEur";
		MfhSourcingCriterionMeasurement["ConstructionYear"] = "constructionYear";
		MfhSourcingCriterionMeasurement["EnergyCertificateClass"] = "energyCertificateClass";
		/** Purchase price divided by living plus commercial area. */
		MfhSourcingCriterionMeasurement["PricePerSqm"] = "pricePerSqm";
		/**
		* The asset's restriction flags: a regulatory criterion (Milieuschutz, Denkmalschutz, städtebaulich). It is answered
		* by a person, prefilled from the flags, and is `applicable` (fails) when the restrictions include a listed flag.
		*/
		MfhSourcingCriterionMeasurement["Restrictions"] = "restrictions";
		return MfhSourcingCriterionMeasurement;
	}({});
	MfhSourcingCriterionOperator = /* @__PURE__ */ function(MfhSourcingCriterionOperator) {
		MfhSourcingCriterionOperator["GreaterThan"] = "gt";
		MfhSourcingCriterionOperator["GreaterThanOrEqual"] = "gte";
		MfhSourcingCriterionOperator["LessThan"] = "lt";
		MfhSourcingCriterionOperator["LessThanOrEqual"] = "lte";
		MfhSourcingCriterionOperator["In"] = "in";
		MfhSourcingCriterionOperator["NotIn"] = "not_in";
		return MfhSourcingCriterionOperator;
	}({});
	NUMBER_OPERATORS = [
		"gt",
		"gte",
		"lt",
		"lte"
	];
	LIST_OPERATORS = ["in", "not_in"];
	MFH_SOURCING_CRITERION_OPERATORS = {
		["purchasePriceEur"]: NUMBER_OPERATORS,
		["constructionYear"]: NUMBER_OPERATORS,
		["energyCertificateClass"]: LIST_OPERATORS,
		["pricePerSqm"]: NUMBER_OPERATORS,
		["restrictions"]: ["not_in"]
	};
	MEASUREMENT_UNIT = {
		["purchasePriceEur"]: "EUR",
		["constructionYear"]: "year",
		["energyCertificateClass"]: "EEK",
		["pricePerSqm"]: "EUR/m²",
		["restrictions"]: "restriction"
	};
	measure = (measurement, measurements) => {
		switch (measurement) {
			case "purchasePriceEur": return measurements.purchasePriceEur;
			case "constructionYear": return measurements.constructionYear;
			case "energyCertificateClass": {
				const value = measurements.energyCertificateClass?.trim();
				return value ? value : void 0;
			}
			case "pricePerSqm": {
				if (measurements.purchasePriceEur === void 0 || measurements.livingAreaSqm === void 0) return void 0;
				const totalArea = measurements.livingAreaSqm + (measurements.commercialAreaSqm ?? 0);
				return totalArea > 0 ? measurements.purchasePriceEur / totalArea : void 0;
			}
			case "restrictions": throw new Error("Restriction criteria are answered by a person, not measured.");
		}
	};
	normalizeListValue = (value) => value.trim().toUpperCase();
	passes = (criterion, measuredValue) => {
		if (Array.isArray(criterion.value)) {
			if (typeof measuredValue !== "string") return false;
			const isListed = criterion.value.map(normalizeListValue).includes(normalizeListValue(measuredValue));
			return criterion.operator === "in" ? isListed : !isListed;
		}
		if (typeof measuredValue !== "number") return false;
		switch (criterion.operator) {
			case "gt": return measuredValue > criterion.value;
			case "gte": return measuredValue >= criterion.value;
			case "lt": return measuredValue < criterion.value;
			case "lte": return measuredValue <= criterion.value;
			default: throw new Error(`Operator ${criterion.operator} needs a list value.`);
		}
	};
	OPERATOR_SYMBOL = {
		["gt"]: ">",
		["gte"]: "≥",
		["lt"]: "<",
		["lte"]: "≤",
		["in"]: "=",
		["not_in"]: "≠"
	};
	formatMfhSourcingCriterionThreshold = (criterion) => {
		const symbol = OPERATOR_SYMBOL[criterion.operator];
		if (Array.isArray(criterion.value)) return `${symbol} ${criterion.value.join(" / ")}`;
		const amount = criterion.value.toLocaleString("en-US", { maximumFractionDigits: 2 });
		switch (criterion.measurement) {
			case "purchasePriceEur": return `${symbol} €${amount}`;
			case "pricePerSqm": return `${symbol} €${amount} / m²`;
			default: return `${symbol} ${criterion.value}`;
		}
	};
	isMfhRegulatorySourcingCriterion = (criterion) => criterion.measurement === "restrictions";
	activeInOrder = (criteria) => criteria.filter((criterion) => criterion.isActive).toSorted((left, right) => left.sortOrder - right.sortOrder);
	buildMfhRegulatoryCriteria = (criteria) => activeInOrder(criteria).filter((criterion) => isMfhRegulatorySourcingCriterion(criterion) && isMfhRegulatoryCriterionId(criterion.criterionId)).map((criterion) => ({
		criterionId: criterion.criterionId,
		label: criterion.label,
		restrictions: Array.isArray(criterion.value) ? criterion.value : []
	}));
	buildMfhMandateRules = (criteria) => activeInOrder(criteria).filter((criterion) => !isMfhRegulatorySourcingCriterion(criterion)).map((criterion) => ({
		criterionId: criterion.criterionId,
		label: criterion.label,
		threshold: formatMfhSourcingCriterionThreshold(criterion),
		unit: MEASUREMENT_UNIT[criterion.measurement],
		measure: (measurements) => measure(criterion.measurement, measurements),
		passes: (measuredValue) => passes(criterion, measuredValue)
	}));
	findFailingMfhSourcingCriteria = (measurements, rules) => evaluateMfhMandateScreening(measurements, (/* @__PURE__ */ new Date()).toISOString(), rules).criteria.filter((criterion) => criterion.status === "fail" && criterion.error === void 0);
	ENERGY_CLASSES = new Set(Object.values(EnergyConsumptionCategory));
	RESTRICTION_FLAGS = new Set(Object.values(Restrictions).filter((restriction) => restriction !== "None"));
	normalizeMfhSourcingCriterionUpdates = (current, updates) => {
		const currentById = new Map(current.map((criterion) => [criterion.criterionId, criterion]));
		const seen = /* @__PURE__ */ new Set();
		return updates.map((update) => {
			const stored = currentById.get(update.criterionId);
			if (!stored) throw new ValidationFailedError(`Unknown sourcing criterion: ${update.criterionId}.`);
			if (seen.has(update.criterionId)) throw new ValidationFailedError(`Sourcing criterion ${update.criterionId} is listed twice.`);
			seen.add(update.criterionId);
			const label = update.label.trim();
			if (!label) throw new ValidationFailedError(`Label missing for ${update.criterionId}.`);
			if (!MFH_SOURCING_CRITERION_OPERATORS[stored.measurement].includes(update.operator)) throw new ValidationFailedError(`Operator ${update.operator} does not fit ${update.criterionId}.`);
			if (LIST_OPERATORS.includes(update.operator)) {
				const rawValues = Array.isArray(update.value) ? update.value.map((value) => value.trim()) : [];
				const values = [...new Set(isMfhRegulatorySourcingCriterion(stored) ? rawValues : rawValues.map(normalizeListValue))];
				if (values.length === 0) throw new ValidationFailedError(`Select at least one value for ${update.criterionId}.`);
				const isRestriction = isMfhRegulatorySourcingCriterion(stored);
				const unknown = values.find((value) => !(isRestriction ? RESTRICTION_FLAGS : ENERGY_CLASSES).has(value));
				if (unknown) throw new ValidationFailedError(`Unknown ${isRestriction ? "restriction" : "energy class"}: ${unknown}.`);
				return {
					criterionId: update.criterionId,
					label,
					operator: update.operator,
					value: values,
					isActive: update.isActive
				};
			}
			if (typeof update.value !== "number" || !Number.isFinite(update.value)) throw new ValidationFailedError(`Value for ${update.criterionId} must be a number.`);
			return {
				criterionId: update.criterionId,
				label,
				operator: update.operator,
				value: update.value,
				isActive: update.isActive
			};
		});
	};
}));
//#endregion
//#region src/domains/cross-cutting/mfh/screening-check/index.ts
var init_screening_check = __esmMin((() => {
	init_mfh_screening_check_model();
	init_mfh_screening_check_mandate();
	init_mfh_screening_check_regulatory();
	init_mfh_screening_check_helpers();
	init_mfh_sourcing_criteria();
}));
//#endregion
//#region src/domains/cross-cutting/mfh/mfh-placement.opts.ts
var init_mfh_placement_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/syte/syte-data.model.ts
var SyteExpansionAssessmentStatus, SyteExpansionAssessmentUnavailableReason;
var init_syte_data_model = __esmMin((() => {
	SyteExpansionAssessmentStatus = /* @__PURE__ */ function(SyteExpansionAssessmentStatus) {
		SyteExpansionAssessmentStatus["Available"] = "available";
		SyteExpansionAssessmentStatus["Unavailable"] = "unavailable";
		return SyteExpansionAssessmentStatus;
	}({});
	SyteExpansionAssessmentUnavailableReason = /* @__PURE__ */ function(SyteExpansionAssessmentUnavailableReason) {
		SyteExpansionAssessmentUnavailableReason["MissingOrInvalidAssetFloorLevel"] = "missing-or-invalid-asset-floor-level";
		SyteExpansionAssessmentUnavailableReason["MissingOrInvalidFootprintArea"] = "missing-or-invalid-footprint-area";
		SyteExpansionAssessmentUnavailableReason["NoEligibleComparator"] = "no-eligible-comparator";
		SyteExpansionAssessmentUnavailableReason["ComparatorMissingOrInvalidFloors"] = "comparator-missing-or-invalid-floors";
		return SyteExpansionAssessmentUnavailableReason;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/mfh/syte/aggregate-heating-system-energy-mix.ts
function normalizeHeatingSystemKey(heatingSystem) {
	return heatingSystem.toLowerCase().replace(/[\s-]+/g, "_");
}
/**
* Extracts raw heating system entries from Syte building properties.
* Resolves the `heatingSystem ?? type` field ambiguity and falls back to the
* point-estimate `heatingSystemEstimate` field.
* Used by both energy-mix aggregation and the display layer.
*/
function extractHeatingSystemEntries(props) {
	const heatingSystems = props.heatingSystemsEstimate;
	if (Array.isArray(heatingSystems) && heatingSystems.length > 0) {
		const entries = [];
		for (const system of heatingSystems) {
			if (typeof system !== "object" || system === null) continue;
			const entry = system;
			const raw = entry.heatingSystem ?? entry.type;
			if (typeof raw !== "string" || raw.length === 0) continue;
			const probability = typeof entry.probability === "number" && !Number.isNaN(entry.probability) ? entry.probability : void 0;
			entries.push({
				heatingSystem: raw,
				probability
			});
		}
		if (entries.length > 0) return entries;
	}
	const pointEstimate = props.heatingSystemEstimate;
	if (typeof pointEstimate === "string" && pointEstimate.length > 0) return [{ heatingSystem: pointEstimate }];
	return [];
}
function buildBuildingHeatingDistribution(props) {
	const rawEntries = extractHeatingSystemEntries(props);
	if (rawEntries.length === 0) return null;
	const probabilitySum = rawEntries.reduce((sum, e) => sum + (e.probability ?? 0), 0);
	if (probabilitySum <= 0) {
		const equalShare = 1 / rawEntries.length;
		return rawEntries.map((e) => ({
			heatingSystem: e.heatingSystem,
			share: equalShare
		}));
	}
	return rawEntries.map((e) => ({
		heatingSystem: e.heatingSystem,
		share: (e.probability ?? 0) / probabilitySum
	}));
}
function derivePrimaryHeatingTypeByBuildingCount(buildingProperties) {
	const heatingTypeCounts = /* @__PURE__ */ new Map();
	for (const props of buildingProperties) {
		const heatingType = props.heatingSystemEstimate;
		if (typeof heatingType === "string" && heatingType.length > 0) heatingTypeCounts.set(heatingType, (heatingTypeCounts.get(heatingType) ?? 0) + 1);
	}
	let primaryHeatingType;
	let maxCount = 0;
	for (const [heatingType, count] of heatingTypeCounts.entries()) if (count > maxCount) {
		maxCount = count;
		primaryHeatingType = heatingType;
	}
	return primaryHeatingType;
}
function aggregateHeatingSystemEnergyMix(buildingProperties) {
	const attributedEnergyByKey = /* @__PURE__ */ new Map();
	let totalAttributedEnergy = 0;
	for (const props of buildingProperties) {
		const energyDemandTotal = props.energyDemandTotal;
		if (typeof energyDemandTotal !== "number" || Number.isNaN(energyDemandTotal) || energyDemandTotal <= 0) continue;
		const distribution = buildBuildingHeatingDistribution(props);
		if (!distribution) continue;
		for (const { heatingSystem, share } of distribution) {
			const attributedEnergy = energyDemandTotal * share;
			totalAttributedEnergy += attributedEnergy;
			const key = normalizeHeatingSystemKey(heatingSystem);
			const existing = attributedEnergyByKey.get(key);
			if (existing) existing.energyDemandTotal += attributedEnergy;
			else attributedEnergyByKey.set(key, {
				heatingSystem,
				energyDemandTotal: attributedEnergy
			});
		}
	}
	if (totalAttributedEnergy <= 0 || attributedEnergyByKey.size === 0) {
		const primaryHeatingType = derivePrimaryHeatingTypeByBuildingCount(buildingProperties);
		if (!primaryHeatingType) return null;
		return { primaryHeatingType };
	}
	const heatingSystemEnergyMix = Array.from(attributedEnergyByKey.values()).map(({ heatingSystem, energyDemandTotal }) => ({
		heatingSystem,
		energyDemandTotal,
		share: energyDemandTotal / totalAttributedEnergy
	})).sort((left, right) => right.share - left.share);
	return {
		heatingSystemEnergyMix,
		primaryHeatingType: heatingSystemEnergyMix[0].heatingSystem
	};
}
var init_aggregate_heating_system_energy_mix = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/syte/derive-reference-floor-space.ts
/**
* Energy reference area (m²) implied by Syte's energy figures: final energy (kWh/y) / end energy (kWh/m²y).
* This is the area Syte divides by to derive intensity — not gross floorspace (BGF).
*/
function deriveReferenceFloorSpaceFromEnergy(energyDemandTotal, energyDemand) {
	if (typeof energyDemandTotal !== "number" || Number.isNaN(energyDemandTotal)) return;
	if (typeof energyDemand !== "number" || Number.isNaN(energyDemand) || energyDemand <= 0) return;
	return energyDemandTotal / energyDemand;
}
/**
* Sums per-building reference floor areas across a property.
* Matches aggregate end-energy derivation in aggregate-building-data.
*/
function aggregateReferenceFloorSpace(buildingProperties) {
	let sum = 0;
	let count = 0;
	for (const props of buildingProperties) {
		const reference = deriveReferenceFloorSpaceFromEnergy(props.energyDemandTotal, props.energyDemand);
		if (reference != null) {
			sum += reference;
			count++;
		}
	}
	return count > 0 ? sum : void 0;
}
var init_derive_reference_floor_space = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/mfh/syte/map-syte-roof-type-to-roof-shape.ts
/**
* Maps any known Syte roof type string (coarse, LOD2, or RoofShape enum) to {@link RoofShape}.
*/
function mapSyteRoofTypeToRoofShape(syteRoofType) {
	if (syteRoofType == null || syteRoofType === "") return null;
	return STRING_TO_ROOF_SHAPE[syteRoofType] ?? null;
}
/**
* Maps {@link RoofShape} back to the coarse Syte roof type label. Multiple MFH shapes map to `Schrägdach`.
*/
function mapRoofShapeToSyteRoofType(roofShape) {
	if (roofShape == null) return null;
	switch (roofShape) {
		case "Flat": return SYTE_ROOF_TYPE.Flachdach;
		case "Hipped":
		case "Saddle":
		case "Pitched":
		case "Mansard": return SYTE_ROOF_TYPE.Schraegdach;
		default: return roofShape;
	}
}
var SYTE_ROOF_TYPE, STRING_TO_ROOF_SHAPE, PITCHED_FAMILY;
var init_map_syte_roof_type_to_roof_shape = __esmMin((() => {
	SYTE_ROOF_TYPE = {
		Schraegdach: "Schrägdach",
		Flachdach: "Flachdach"
	};
	STRING_TO_ROOF_SHAPE = {
		Schrägdach: "Pitched",
		Flachdach: "Flat",
		Satteldach: "Saddle",
		Walmdach: "Hipped",
		Mansarddach: "Mansard",
		Pultdach: "Pitched",
		["Flat"]: "Flat",
		["Pitched"]: "Pitched",
		["Saddle"]: "Saddle",
		["Hipped"]: "Hipped",
		["Mansard"]: "Mansard"
	};
	PITCHED_FAMILY = /* @__PURE__ */ new Set([
		"Pitched",
		"Saddle",
		"Hipped",
		"Mansard"
	]);
}));
//#endregion
//#region src/domains/cross-cutting/mfh/syte/recompute-syte-expansion-assessment.ts
function estimateFloorExpansionLevel(tallestNearbyEntireFloors, assetEntireFloors) {
	return Math.max(0, tallestNearbyEntireFloors - assetEntireFloors);
}
function estimateExpansionPotential(footprintArea, estimatedFloorExpansionLevel) {
	return footprintArea * estimatedFloorExpansionLevel;
}
function isFiniteInteger(value) {
	return typeof value === "number" && Number.isFinite(value) && Number.isInteger(value);
}
function isPositiveFiniteNumber(value) {
	return typeof value === "number" && Number.isFinite(value) && value > 0;
}
function isNonNegativeFiniteNumber(value) {
	return typeof value === "number" && Number.isFinite(value) && value >= 0;
}
function isUsableAssetFloorLevel(value) {
	return isFiniteInteger(value) && value >= 1;
}
function isUsableComparatorLevel(value) {
	return isFiniteInteger(value) && value >= 0;
}
function isSyteUsage(value) {
	if (value === null || typeof value === "string") return true;
	return Array.isArray(value) && value.every((item) => typeof item === "string");
}
function readUsage(value) {
	return isSyteUsage(value) ? value : void 0;
}
function readComparatorRecord(comparator) {
	if (typeof comparator !== "object" || comparator === null || Array.isArray(comparator)) return void 0;
	return comparator;
}
/**
* The only interpreter of `comparator.effectiveLevel`. Persisted JSON stays `{ identifier, distanceMeters, effectiveLevel? }`.
* A usable effective level selects the comparator. Identifier and distance are kept when the payload has them.
*/
function readSyteExpansionComparator(comparator) {
	const record = readComparatorRecord(comparator);
	if (!record) return { status: "none" };
	const identifier = typeof record.identifier === "string" && record.identifier.length > 0 ? record.identifier : void 0;
	const distanceMeters = typeof record.distanceMeters === "number" && Number.isFinite(record.distanceMeters) ? record.distanceMeters : void 0;
	const usage = readUsage(record.usage);
	const evidence = {
		identifier: identifier ?? "",
		distanceMeters: distanceMeters ?? 0,
		...usage !== void 0 ? { usage } : {}
	};
	if (isUsableComparatorLevel(record.effectiveLevel)) return {
		status: "selected",
		evidence: {
			...evidence,
			effectiveLevel: record.effectiveLevel
		}
	};
	if (identifier === void 0 || distanceMeters === void 0) return { status: "none" };
	return {
		status: "missing-floors",
		evidence
	};
}
/**
* Level is `nearby − floors` (floored at 0) unless a non-negative integer override is present.
* Potential is footprint × that level unless a non-negative finite override is present.
* Invalid floors or footprint return unavailable. This function does not pick a fallback footprint.
*/
function deriveSyteExpansion(input) {
	if (!isUsableAssetFloorLevel(input.assetFloors)) return {
		status: "unavailable",
		reason: "missing-or-invalid-asset-floor-level"
	};
	if (!isPositiveFiniteNumber(input.footprintArea)) return {
		status: "unavailable",
		reason: "missing-or-invalid-footprint-area"
	};
	if (!isUsableComparatorLevel(input.nearbyLevel)) return {
		status: "unavailable",
		reason: "comparator-missing-or-invalid-floors"
	};
	const formulaLevel = estimateFloorExpansionLevel(input.nearbyLevel, input.assetFloors);
	const estimatedFloorExpansionLevel = isUsableComparatorLevel(input.levelOverride) ? input.levelOverride : formulaLevel;
	const formulaPotential = estimateExpansionPotential(input.footprintArea, estimatedFloorExpansionLevel);
	return {
		status: "available",
		estimatedFloorExpansionLevel,
		estimatedExpansionPotential: isNonNegativeFiniteNumber(input.potentialOverride) ? input.potentialOverride : formulaPotential
	};
}
function isAttributeSelected(selectedAttributes, attribute) {
	return selectedAttributes == null || selectedAttributes.has(attribute);
}
function syteValueWillBeWritten(selected, manuallySet, force, syteValue) {
	return selected && (!manuallySet || force) && syteValue != null;
}
/**
* Floors and footprint that an apply will store. A selected non-manual Syte value wins.
* Otherwise the current attribute is kept. `null` selected attributes means every field is selected.
*/
function resolveSyteApplyExpansionInputs(params) {
	const writeFloors = syteValueWillBeWritten(isAttributeSelected(params.selectedAttributes, SYTE_APPLY_FLOORS_ATTRIBUTE), params.floorsManuallySet, params.force, params.syteEntireFloors);
	const writeFootprint = syteValueWillBeWritten(isAttributeSelected(params.selectedAttributes, SYTE_APPLY_FOOTPRINT_ATTRIBUTE), params.footprintManuallySet, params.force, params.syteFootprintArea);
	return {
		entireFloors: writeFloors ? params.syteEntireFloors : params.currentFloors,
		footprintArea: writeFootprint ? params.syteFootprintArea : params.currentFootprintArea
	};
}
/**
* Rebuilds an available expansion assessment from the cached nearby-building height and the asset's
* current entire floors. Does not call Syte. A cached unavailable assessment that already recorded
* the tallest nearby building is promoted once floors and footprint are known. Invalid inputs leave
* the cached assessment unchanged.
*/
function recomputeSyteExpansionAssessment(assessment, asset) {
	if (!assessment) return assessment;
	const comparator = readSyteExpansionComparator(assessment.comparator);
	if (comparator.status !== "selected" || !isUsableAssetFloorLevel(asset.entireFloors)) return assessment;
	const footprintArea = isPositiveFiniteNumber(asset.footprintArea) ? asset.footprintArea : isPositiveFiniteNumber(assessment.assetFootprintArea) ? assessment.assetFootprintArea : void 0;
	if (footprintArea === void 0) return assessment;
	const derived = deriveSyteExpansion({
		nearbyLevel: comparator.evidence.effectiveLevel,
		assetFloors: asset.entireFloors,
		footprintArea
	});
	if (derived.status !== "available") return assessment;
	if (assessment.status === "available" && assessment.assetFloorLevel === asset.entireFloors && assessment.assetFootprintArea === footprintArea && assessment.estimatedFloorExpansionLevel === derived.estimatedFloorExpansionLevel && assessment.estimatedExpansionPotential === derived.estimatedExpansionPotential) return assessment;
	return {
		radiusMeters: assessment.radiusMeters,
		neighborhoodResolved: assessment.neighborhoodResolved === true,
		status: "available",
		assetFloorLevel: asset.entireFloors,
		assetFootprintArea: footprintArea,
		comparator: comparator.evidence,
		estimatedFloorExpansionLevel: derived.estimatedFloorExpansionLevel,
		estimatedExpansionPotential: derived.estimatedExpansionPotential
	};
}
var SYTE_APPLY_FLOORS_ATTRIBUTE, SYTE_APPLY_FOOTPRINT_ATTRIBUTE;
var init_recompute_syte_expansion_assessment = __esmMin((() => {
	SYTE_APPLY_FLOORS_ATTRIBUTE = "floors";
	SYTE_APPLY_FOOTPRINT_ATTRIBUTE = "footprintArea";
}));
//#endregion
//#region src/domains/cross-cutting/mfh/index.ts
var init_mfh = __esmMin((() => {
	init_mfh_model();
	init_mfh_base();
	init_mfh_opts();
	init_mfh_process_base();
	init_mfh_process_model();
	init_mfh_process_opts();
	init_mfh_calendar_event_model();
	init_infas_attributes();
	init_infas_attribute_map();
	init_infas_attribute_helper();
	init_area_quality_model();
	init_open_question_model();
	init_request();
	init_due_diligence();
	init_requests$3();
	init_portfolio$1();
	init_building();
	init_d2g();
	init_mfh_investment_case_base();
	init_mfh_investment_case_model();
	init_mfh_investment_case_versioning();
	init_mfh_investment_case_override();
	init_asset_partner_ic_profile();
	init_asset_partner_ic_profile_version_model();
	init_erv_breakdown();
	init_mfh_investment_case_class();
	init_mfh_investment_case_opts();
	init_mfh_investment_case_aggregate_opts();
	init_mfh_investment_case_i18n();
	init_mfh_investment_case_helpers();
	init_mfh_investment_case_input_origins();
	init_mfh_investment_case_kpi_calc_engine_keys();
	init_rent_market_data_model();
	init_mfh_investment_case_result_preview_paths();
	init_automatic_investment_case_calculation_outputs();
	init_ic_teaser();
	init_mfh_investment_case_json_transfer_model();
	init_helpers$2();
	init_mfh_prediction_model();
	init_mfh_helpers();
	init_mfh_openkm();
	init_mfh_uuid_helpers();
	init_mfh_summary_i18n();
	init_mfh_summary_model();
	init_mfh_summary_helpers();
	init_mfh_request();
	init_mfh_jobs();
	init_mfh_attributes_base();
	init_mfh_attributes_model();
	init_mfh_element_model();
	init_mfh_element_i18n();
	init_mfh_element_opts();
	init_mfh_attributes_helpers();
	init_mfh_attributes_i18n();
	init_mfh_energy_efficiency_colors();
	init_mfh_pipeline_model();
	init_mfh_pipeline_helpers();
	init_mfh_folder_structure();
	init_renovation_project();
	init_versions();
	init_mfh_external_unit_model();
	init_mfh_external_unit_class();
	init_asset_rent_roll_model();
	init_mfh_project_plan_model();
	init_mfh_project_plan_opts();
	init_sheet_embedding();
	init_construction_plan();
	init_capex_ee_calculator();
	init_mfh_placement_schema();
	init_mfh_placement_model();
	init_mfh_placement_helpers();
	init_mfh_buy_box_helpers();
	init_screening_check();
	init_mfh_placement_constants();
	init_mfh_placement_opts();
	init_syte_data_model();
	init_aggregate_heating_system_energy_mix();
	init_derive_reference_floor_space();
	init_map_syte_heating_system_to_heating_type();
	init_map_syte_roof_type_to_roof_shape();
	init_recompute_syte_expansion_assessment();
	init_mfh_placement_metro_area_codes();
}));
//#endregion
//#region src/domains/cross-cutting/summary.model.ts
var init_summary_model = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/outbox.model.ts
var OutBoxState;
var init_outbox_model = __esmMin((() => {
	OutBoxState = /* @__PURE__ */ function(OutBoxState) {
		OutBoxState["OUTOFSCOPE"] = "OUTOFSCOPE";
		OutBoxState["DRAFT"] = "DRAFT";
		OutBoxState["SENT"] = "SENT";
		OutBoxState["REPLIED"] = "REPLIED";
		return OutBoxState;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/audit-log/audit-log.model.ts
var AUDIT_LOG_DEFAULT_IGNORABLE_KEYS;
var init_audit_log_model = __esmMin((() => {
	AUDIT_LOG_DEFAULT_IGNORABLE_KEYS = ["updated_at", "created_at"];
}));
//#endregion
//#region src/domains/cross-cutting/audit-log/index.ts
var init_audit_log = __esmMin((() => {
	init_audit_log_model();
}));
//#endregion
//#region src/domains/cross-cutting/appointment.model.ts
var init_appointment_model = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/netsuite-sync-status.model.ts
var NetsuiteSyncState;
var init_netsuite_sync_status_model = __esmMin((() => {
	NetsuiteSyncState = /* @__PURE__ */ function(NetsuiteSyncState) {
		NetsuiteSyncState["Pending"] = "pending";
		NetsuiteSyncState["Success"] = "success";
		NetsuiteSyncState["Error"] = "error";
		return NetsuiteSyncState;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/note/note.model.ts
var NoteType;
var init_note_model = __esmMin((() => {
	NoteType = /* @__PURE__ */ function(NoteType) {
		NoteType["EstateDetails"] = "estate-details";
		NoteType["EstateDefects"] = "estate-defects";
		NoteType["EstateInvestmentCases"] = "estate-investment-cases";
		NoteType["EstateSellingNotary"] = "estate-selling-notary";
		NoteType["MfhDetails"] = "mfh-details";
		NoteType["MfhRenovationProjects"] = "mfh-renovation-projects";
		NoteType["MfhDDOverview"] = "mfh-dd-overview";
		NoteType["MfhBuilding"] = "mfh-building";
		NoteType["RentTenancy"] = "rent-tenancy";
		NoteType["InvestorInfo"] = "investor-info";
		NoteType["OwnerManagement"] = "owner-management";
		NoteType["TenantManagement"] = "tenant-management";
		NoteType["EstateManagement"] = "estate-management";
		NoteType["AnnualServiceChargeStatement"] = "annual-service-charge-statement";
		NoteType["MonthlyInvestorShare"] = "monthly-investor-share";
		NoteType["AddendumInternal"] = "addendum-internal";
		NoteType["AddendumExternal"] = "addendum-external";
		NoteType["MfhConstructionPlan"] = "mfh-construction-plan";
		NoteType["MfhConstructionPlanVersion"] = "mfh-construction-plan-version";
		NoteType["MfhConstructionPlanVersionInternal"] = "mfh-construction-plan-version-internal";
		NoteType["ContractInternal"] = "contract-internal";
		NoteType["ContractExternal"] = "contract-external";
		return NoteType;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/note/note.class.ts
var Note;
var init_note_class = __esmMin((() => {
	init_base();
	Note = class extends BaseClassAttributes {
		noteId;
		uuid;
		userId;
		userName;
		body;
		estateId;
		rentingListingId;
		companyId;
		contactId;
		investmentId;
		mfhId;
		mfhInvestmentCaseId;
		mfhPortfolioId;
		mfhSourcingProcessId;
		mfhPortfolioFinancingProcessId;
		mfhPortfolioPurchasingProcessId;
		mfhSubsidyFinancingProcessId;
		mfhEstateManagementProcessId;
		purchasingProcessId;
		renovationProcessId;
		sellingProcessId;
		sourcingProcessId;
		rentingProcessId;
		propertyManagementProcessId;
		tenantManagementProcessId;
		ownerManagementProcessId;
		investorInfoId;
		rentTenancyId;
		estateManagementProcessId;
		portfolioId;
		documentInspectionId;
		invoiceId;
		salesPackageId;
		paymentNoticeSummaryId;
		constructionPlanId;
		renovationInspectionId;
		constructionCraft;
		reviewRequestId;
		defectId;
		catalogueItemId;
		rentalContractId;
		mfhBuildingId;
		defect;
		catalogueItem;
		reviewRequest;
		estate;
		events;
		investment;
		mfh;
		mfhInvestmentCase;
		mfhPortfolio;
		mfhSourcingProcess;
		mfhPortfolioFinancingProcess;
		mfhPortfolioPurchasingProcess;
		mfhSubsidyFinancingProcess;
		mfhEstateManagementProcess;
		rentingListing;
		purchasingProcess;
		renovationProcess;
		sellingProcess;
		sourcingProcess;
		rentingProcess;
		propertyManagementProcess;
		tenantManagementProcess;
		ownerManagementProcess;
		estateManagementProcess;
		renovationInspection;
		plan;
		portfolio;
		documentInspection;
		invoice;
		salesPackage;
		paymentNoticeSummary;
		company;
		contact;
		rentalContract;
		mentions;
		rentTenancy;
		investorInfo;
		plainTextBody;
		entityType;
		entityId;
		history;
		constructor(note) {
			super(note);
			Object.assign(this, note);
			this.mentions = this.parseMentionsFromBody();
			this.plainTextBody = this.getPlainTextBody();
		}
		getPlainTextBody() {
			return convert(this.body, {
				formatters: { notificationMentionFormatter: () => "" },
				selectors: [{
					selector: "a",
					options: { ignoreHref: true }
				}, {
					selector: "notification-mention",
					format: "notificationMentionFormatter"
				}]
			});
		}
		parseMentionsFromBody() {
			return this.body ? [...this.body.matchAll(/@{(.*?)}/g)].map((match) => match[1]).filter(Boolean) : [];
		}
	};
}));
//#endregion
//#region src/domains/cross-cutting/note/note.opts.ts
var init_note_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/note/note.i18n.ts
var noteTranslationsMap;
var init_note_i18n = __esmMin((() => {
	noteTranslationsMap = {
		["estate-details"]: "Estate Details",
		["estate-defects"]: "Estate Defects",
		["estate-investment-cases"]: "Estate Investment Cases",
		["estate-selling-notary"]: "Estate Selling Notary",
		["mfh-details"]: "MFH Details",
		["mfh-dd-overview"]: "MFH DD Overview",
		["mfh-building"]: "MFH Building",
		["rent-tenancy"]: "Rent Tenancy",
		["investor-info"]: "Investor Info",
		["owner-management"]: "Owner Management",
		["tenant-management"]: "Tenant Management",
		["estate-management"]: "Estate Management",
		["monthly-investor-share"]: "Monthly Investor Share"
	};
}));
//#endregion
//#region src/domains/cross-cutting/note/helper.ts
var legacyEntityTypeMapping, resolvePolymorphicNoteAssociation;
var init_helper = __esmMin((() => {
	init_base();
	legacyEntityTypeMapping = [
		{
			field: "rentingListingId",
			entityType: "renting_listings"
		},
		{
			field: "companyId",
			entityType: "company"
		},
		{
			field: "investmentId",
			entityType: "investment_case"
		},
		{
			field: "mfhInvestmentCaseId",
			entityType: "mfh_investment_case"
		},
		{
			field: "investorInfoId",
			entityType: "investor_info"
		},
		{
			field: "mfhPortfolioId",
			entityType: "mfh_portfolio"
		},
		{
			field: "purchasingProcessId",
			entityType: "purchasing_process"
		},
		{
			field: "renovationProcessId",
			entityType: "renovation_process"
		},
		{
			field: "sellingProcessId",
			entityType: "selling_process"
		},
		{
			field: "sourcingProcessId",
			entityType: "sourcing_process"
		},
		{
			field: "rentingProcessId",
			entityType: "renting_process"
		},
		{
			field: "rentableUnitProcessId",
			entityType: "rentable_unit_process"
		},
		{
			field: "propertyManagementProcessId",
			entityType: "property_management_process"
		},
		{
			field: "tenantManagementProcessId",
			entityType: "tenant_management_process"
		},
		{
			field: "ownerManagementProcessId",
			entityType: "owner_management_process"
		},
		{
			field: "estateManagementProcessId",
			entityType: "estate_management_process"
		},
		{
			field: "mfhSourcingProcessId",
			entityType: "mfh_sourcing_process"
		},
		{
			field: "mfhPortfolioFinancingProcessId",
			entityType: "mfh_portfolio_financing_process"
		},
		{
			field: "mfhPortfolioPurchasingProcessId",
			entityType: "mfh_portfolio_purchasing_process"
		},
		{
			field: "mfhSubsidyFinancingProcessId",
			entityType: "mfh_subsidy_financing_process"
		},
		{
			field: "mfhEstateManagementProcessId",
			entityType: "mfh_estate_management_process"
		},
		{
			field: "portfolioId",
			entityType: "portfolio"
		},
		{
			field: "documentInspectionId",
			entityType: "document_inspection"
		},
		{
			field: "inspectionId",
			entityType: "inspection"
		},
		{
			field: "salesPackageId",
			entityType: "sales_package"
		},
		{
			field: "constructionPlanId",
			entityType: "construction_plan"
		},
		{
			field: "renovationInspectionId",
			entityType: "renovation_inspection"
		},
		{
			field: "reviewRequestId",
			entityType: "review_request"
		},
		{
			field: "paymentNoticeSummaryId",
			entityType: "payment_notice_summary"
		},
		{
			field: "catalogueItemId",
			entityType: "catalogue_item"
		},
		{
			field: "rentalContractId",
			entityType: "rental_contract"
		},
		{
			field: "serviceChargeStatementId",
			entityType: "annual_service_charge_statement"
		},
		{
			field: "ddQuestionId",
			entityType: "dd_question"
		},
		{
			field: "mfhBuildingId",
			entityType: "mfh_building"
		},
		{
			field: "monthlyInvestorShareId",
			entityType: "monthly_investor_share"
		},
		{
			field: "rentTenancyId",
			entityType: "rent_tenancy"
		},
		{
			field: "mfhId",
			entityType: "mfh"
		},
		{
			field: "estateId",
			entityType: "estate"
		}
	];
	resolvePolymorphicNoteAssociation = (note = {}) => {
		if (note.entityType && note.entityId) return note;
		for (const { field, entityType } of legacyEntityTypeMapping) if (note[field] != null) return {
			...note,
			entityId: +note[field],
			entityType
		};
		return note;
	};
}));
//#endregion
//#region src/domains/cross-cutting/note/index.ts
var init_note = __esmMin((() => {
	init_note_model();
	init_note_class();
	init_note_opts();
	init_note_i18n();
	init_helper();
}));
//#endregion
//#region src/domains/cross-cutting/user-confirmation/user-confirmation.model.ts
var UserConfirmationStatus, UserConfirmationTask;
var init_user_confirmation_model = __esmMin((() => {
	UserConfirmationStatus = /* @__PURE__ */ function(UserConfirmationStatus) {
		UserConfirmationStatus["CREATED"] = "CREATED";
		UserConfirmationStatus["APPROVED"] = "APPROVED";
		UserConfirmationStatus["TIMEOUT"] = "TIMEOUT";
		UserConfirmationStatus["ERROR"] = "ERROR";
		UserConfirmationStatus["REJECTED"] = "REJECTED";
		return UserConfirmationStatus;
	}({});
	UserConfirmationTask = /* @__PURE__ */ function(UserConfirmationTask) {
		UserConfirmationTask["CONFIRM_BULK_MFH_IMPORT"] = "CONFIRM_BULK_MFH_IMPORT";
		return UserConfirmationTask;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/user-confirmation/user-confirmation.repository.ts
var init_user_confirmation_repository = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/user-confirmation/user-confirmation.i18n.ts
var userConfirmationTranslations;
var init_user_confirmation_i18n = __esmMin((() => {
	userConfirmationTranslations = { ["CONFIRM_BULK_MFH_IMPORT"]: "Confirm parsed data for bulk MFH import " };
}));
//#endregion
//#region src/domains/cross-cutting/user-confirmation/index.ts
var init_user_confirmation = __esmMin((() => {
	init_user_confirmation_model();
	init_user_confirmation_repository();
	init_user_confirmation_i18n();
}));
//#endregion
//#region src/domains/renovation/catalogue-item-availability.model.ts
var init_catalogue_item_availability_model = __esmMin((() => {}));
/**
* Proposed flow for creating from template:
*
* 1. Select a catalogue-template, which holds a list of ONLY "parent" catalogue items
* 2. Given a construction-plans' interiorQuality, get all estate-elements
* 3. Fetch all catalogueItemAvailability by estateElement, catalogueItemIds AND plan.interiorQuality
*   3.1 When the element is a structure, match by element.parentId = catalogueItemAvailability.estateRoomElementId & element.estateRoomElementId = catalogueItemAvailability.estateStructureElementId
*   3.2.When the element is a room, match by element.estateElementId = catalogueItemAvailability.estateRoomElementId
* 4. Iterate over the catalogue-items  from the template
*   4.1 For each catalogue-item, get the availability of it matching the construction-plans interiorQuality and estateRoomElementId
*   4.2 If none are found, dorp the catalogue-item
*   4.3 If availability is found, collect all requiredSubItemIds (save it in a map by catalogueItemId  to reconcile later)
* 5. Given a set of childItemIds, fetch them from db
* 6. Reconcile childItems to the remaining catalogue-items
* 7. remaining price logic
* 8. Save all items -> become positions

*
* ---------
* Proposed flow for add positions:
* 1. Given a CP.templateId, CP.interorQuality, a craft, a room and a structure, search for catalogue-items matching these params
* 2. Fetch the catalogueItemsAvailability for the resulting items, including required + optional childs (see 3. above)
* 3. Filter as before (4. + 5. + 6.)
*/
//#endregion
//#region src/domains/renovation/catalogue-item.helpers.ts
var findContractorPrice;
var init_catalogue_item_helpers = __esmMin((() => {
	findContractorPrice = (item, contractorPricingId, defaultVal = 0) => {
		if (!item?.prices || isNil(contractorPricingId)) return defaultVal;
		return item.prices.reduce((best, current) => {
			if (current.contractorPricingId !== contractorPricingId) return best;
			if (best === null || current.catalogueItemPricingId > best.catalogueItemPricingId) return current;
			return best;
		}, null)?.price ?? defaultVal;
	};
}));
//#endregion
//#region src/domains/renovation/catalogue-item.model.ts
var UnitName, CatalogueItemType;
var init_catalogue_item_model = __esmMin((() => {
	UnitName = /* @__PURE__ */ function(UnitName) {
		UnitName["Items"] = "Stck.";
		UnitName["M2"] = "m²";
		UnitName["M3"] = "m³";
		UnitName["RunningMeter"] = "Lfm.";
		UnitName["Hours"] = "Std.";
		UnitName["Flat"] = "Psch.";
		UnitName["KW"] = "KW";
		return UnitName;
	}({});
	CatalogueItemType = /* @__PURE__ */ function(CatalogueItemType) {
		CatalogueItemType["SubItem"] = "SubItem";
		CatalogueItemType["Item"] = "Item";
		return CatalogueItemType;
	}({});
}));
//#endregion
//#region src/domains/renovation/catalogue-item.opts.ts
var init_catalogue_item_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/renovation/construction-craft.model.ts
var ConstructionCraft, craftOrdered, constructionCraftTranslationMap, translateCraft, translateCraftToIndex;
var init_construction_craft_model = __esmMin((() => {
	ConstructionCraft = /* @__PURE__ */ function(ConstructionCraft) {
		ConstructionCraft["Demolition"] = "Demolition";
		ConstructionCraft["HSE"] = "HSE";
		ConstructionCraft["Bricklayer"] = "Bricklayer";
		ConstructionCraft["Drywall"] = "Drywall";
		ConstructionCraft["Painting"] = "Painting";
		ConstructionCraft["Tiling"] = "Tiling";
		ConstructionCraft["Flooring"] = "Flooring";
		ConstructionCraft["Carpenter"] = "Carpenter";
		ConstructionCraft["Kitchen"] = "Kitchen";
		ConstructionCraft["Finishing"] = "Finishing";
		ConstructionCraft["Electrical"] = "Electrical";
		ConstructionCraft["Other"] = "Other";
		return ConstructionCraft;
	}({});
	craftOrdered = [
		"Demolition",
		"Bricklayer",
		"Drywall",
		"Tiling",
		"Painting",
		"Flooring",
		"Carpenter",
		"HSE",
		"Electrical",
		"Finishing",
		"Kitchen",
		"Other"
	];
	constructionCraftTranslationMap = {
		["Demolition"]: {
			title: "Abbruch",
			description: "Sämtliche Abbrucharbeiten verstehen sich als Gesamtleistung einschließlich aller dafür erforderlichen Nebenarbeiten sowie einer sach- und fachgerechten Entsorgung gemäß dem Kreislaufwirtschaftsgesetz. Der Nachweis für die ordnungsgemäße Entsorgung ist durch den AN unaufgefordert und in schriftlicher Form zu erbringen."
		},
		["Bricklayer"]: {
			title: "Maurer & Putz",
			description: "Putz- und Maurerarbeiten gelten als Gesamtleistung inklusive der dafür erforderlichen Nebenleistungen. In der Regel handelt es sich um Kleinflächen. Ausführung von Putzarbeiten lot- und fluchtrecht. Es gelten die Ebenheitstoleranzen nach DIN 18202."
		},
		["Drywall"]: {
			title: "Trockenbau",
			description: "Ausschnitte und Löcher sowie dauerelastische Acryl-Versiegelung an angrenzende Bauteile, sind je nach Erfordernis in den Positionen mit enthalten. "
		},
		["Tiling"]: {
			title: "Fliesen",
			description: "Das Herstellen erforderlicher Löcher sowie Bohrungen der Fliesen sind in den Positionen enthalten. Soweit nicht anders angewiesen, erfolgt die Verfugung im Farbton der Fliesen. Die maximale Fugenbreite beträgt 2mm."
		},
		["Painting"]: {
			title: "Maler",
			description: "Abdeck- und Abklebearbeiten sowie die konstruktiv oder optisch erforderliche dauerelastische Acryl- Versiegelung an angrenzende Bauteile sind in den Positionen und damit im Einzelpreis enthalten. Ebenfalls enthalten ist das Reinigen von Griffgarnituren und Griffoliven an zu lackierenden Bauteilen sowie von Glasscheiben. Für die Ausführung der Malerarbeiten sind ausschließlich qualitativ hochwertige Produkte mit Umweltsiegel zu verwenden. Die Umweltverträglichkeit ist im Produktblatt nachzuweisen."
		},
		["Flooring"]: {
			title: "Bodenleger",
			description: "Der Untergrund ist vor Beginn der Verlegearbeiten insbesondere auf Ebenheit und Trockenheit zu prüfen. Der AN ist für die Entscheidung, ob der Belag verlegt werden kann oder nicht, verantwortlich. Besonders zu achten ist auf die Einhaltung der Raumfugen, der zugelassenen Feldfugen sowie der Verlegerichtung. Das Anarbeiten an Zargen, lotrechte Heizungsrohre und dergleichen ist in die Einheitspreise einkalkuliert. Die geforderte Ebenheit des Untergrundes beträgt max. 2mm auf 1m. Sollten zum Erreichen der Ebenheit zusätzliche Spachtelarbeiten notwendig werden, so sind diese im Vorfeld bei der AG anzumelden und auf Nachweis über Stundenlohnarbeiten abzurechnen. Nachträglich eingereichte Regiearbeiten werden nicht anerkannt."
		},
		["Carpenter"]: {
			title: "Tischler",
			description: "Konstruktionsvorschläge wie Mauerwerksanschlüsse, Glas- und Türmaße, größtmögliche Öffnungsflügel, zulässige Gewichte und dergleichen sind vom AN verantwortlich zu ermitteln. "
		},
		["HSE"]: {
			title: "Sanitär & Heizung",
			description: "Die dauerelastische Silikonverfugung aller Sanitärobjekte an angrenzende Bauteile ist ausschließlich in weiß herzustellen und in den Einheitspreisen enthalten. Die maximale Fugenbreite ist 6 mm."
		},
		["Electrical"]: {
			title: "Elektro",
			description: "Der Umfang der Elektro-Ausstattung der einzelnen Räume wird in zwei Ausstattungsvarianten unterschieden. Diese Ausstattungsvarianten sind an die Mindestausstattung nach DIN 18015-2/4 und der Standardausstattung RAL RG 678 angelehnt und in Anlage 2 beschrieben. Die Erneuerung der elektrischen Anlage ist einschließlich Überspannungsschutz nach DIN VDE 0100-443 und -534 sowie der Demontage und fachgerechten Entsorgung der vorhandenen Anlage. Das Verputzen der Schlitze erfolgt über die Malerarbeiten."
		},
		["Finishing"]: { title: "Reinigung" },
		["Kitchen"]: { title: "Einbauküche" },
		["Other"]: { title: "Andere" }
	};
	translateCraft = (enumVal) => constructionCraftTranslationMap[enumVal]?.title ?? enumVal;
	translateCraftToIndex = (enumVal) => (craftOrdered.indexOf(enumVal) + 1).toString().padStart(2, "0");
}));
//#endregion
//#region src/domains/renovation/construction-plan.model.ts
var constructionPlanDurations, ConstructionPlanDefaultNames, getConstructionPlanLineageId, isConstructionPlanAddendum;
var init_construction_plan_model = __esmMin((() => {
	constructionPlanDurations = [
		4,
		5,
		6,
		7,
		8
	];
	ConstructionPlanDefaultNames = /* @__PURE__ */ function(ConstructionPlanDefaultNames) {
		ConstructionPlanDefaultNames["Draft"] = "LV-DRAFT";
		ConstructionPlanDefaultNames["Approved"] = "LV";
		return ConstructionPlanDefaultNames;
	}({});
	getConstructionPlanLineageId = (plan) => plan.rootPlanId ?? plan.constructionPlanId;
	isConstructionPlanAddendum = (plan) => plan.classification === "Addendum";
}));
//#endregion
//#region src/domains/renovation/construction-position.model.ts
var PositionLink, PositionEditType;
var init_construction_position_model = __esmMin((() => {
	PositionLink = /* @__PURE__ */ function(PositionLink) {
		PositionLink["Mandatory"] = "Mandatory";
		PositionLink["Optional"] = "Optional";
		return PositionLink;
	}({});
	PositionEditType = /* @__PURE__ */ function(PositionEditType) {
		PositionEditType["Add"] = "Add";
		PositionEditType["Update"] = "Update";
		PositionEditType["Delete"] = "Delete";
		return PositionEditType;
	}({});
}));
//#endregion
//#region src/domains/renovation/construction-position.class.ts
var ConstructionPosition;
var init_construction_position_class = __esmMin((() => {
	init_base();
	ConstructionPosition = class extends BaseClassAttributes {
		positionId;
		catalogueCode;
		catalogueItemId;
		comment;
		completed;
		constructionPlanId;
		craft;
		estateElementId;
		isCustom;
		isInspectionDiff;
		appliedToId;
		linkType;
		linkedTo;
		name;
		order;
		positionTitle;
		pricePerUnit;
		totalPrice;
		unitName;
		unitNumber;
		uuid;
		editType;
		renovationInspectionId;
		catalogItem;
		estateElement;
		constructionPlan;
		mandatoryDeps = [];
		optionalDeps = [];
		position;
		mediaFiles = [];
		renovationInspection;
		constructor(props) {
			super(props);
			Object.assign(this, props);
			this.calculateTotalPrice();
		}
		get isUpdated() {
			return this.editType === "Update";
		}
		get isDeleted() {
			return this.editType === "Delete";
		}
		get isAdded() {
			return this.editType === "Add";
		}
		getUnitNumber() {
			return this.unitNumber && !Number.isNaN(this.unitNumber) && !this.isDeleted ? this.unitNumber : 0;
		}
		calculateTotalPrice() {
			const pricePerUnit = this.pricePerUnit ?? 0;
			this.totalPrice = round$1(this.getUnitNumber() * pricePerUnit, 2);
			return this;
		}
		/**
		* Comapring 2 positions. Other fields are not considered as changes and do not require new LV generated.
		* @param {IConstructionPosition} orig
		* @returns {boolean}
		*/
		isChanged(orig) {
			return orig.unitNumber !== this.unitNumber || this.positionTitle !== orig.positionTitle || this.pricePerUnit !== orig.pricePerUnit;
		}
	};
}));
//#endregion
//#region src/domains/renovation/construction-plan.class.ts
var ConstructionPlan;
var init_construction_plan_class = __esmMin((() => {
	init_renovation();
	init_process_model();
	init_construction_plan_model();
	init_construction_position_class();
	ConstructionPlan = class ConstructionPlan {
		additionCosts;
		constructionPlanId;
		active;
		version;
		rootPlanId;
		contractorId;
		contractorPricingId;
		description;
		duration;
		estateId;
		interiorQuality;
		investmentId;
		mandatedCosts;
		planName;
		planType;
		plannedEndDate;
		plannedStartDate;
		startDate;
		endDate;
		state;
		structureType;
		templateId;
		totalActualCosts;
		totalCosts;
		userId;
		snapshot = [];
		trackCosts;
		allowedOvershoot;
		currentOvershoot;
		budgetOrigin;
		classification;
		parentPlanId;
		updatedAt;
		createdAt;
		deletedAt;
		defects;
		investment;
		estate;
		architect;
		positions;
		contractor;
		invoices = [];
		notes;
		reviewProcess;
		rootPlan;
		childPlans;
		parentPlan;
		renovationInspections;
		constructor(props) {
			Object.assign(this, props);
			if (props.positions?.length) this.positions = props.positions.map((p) => new ConstructionPosition(p));
			if (props.childPlans) this.childPlans = props.childPlans.map((p) => new ConstructionPlan(p));
			if (props.rootPlan) this.rootPlan = new ConstructionPlan(props.rootPlan);
			if (props.parentPlan) this.parentPlan = new ConstructionPlan(props.parentPlan);
			if (props.renovationInspections) this.renovationInspections = props.renovationInspections;
		}
		get isGeneral() {
			return this.planType === "General";
		}
		get isNew() {
			return this.state === "New";
		}
		get isDraft() {
			return this.state === "Draft";
		}
		get isDeletable() {
			return (this.isDraft || this.isNew) && this.isRoot;
		}
		get isApproved() {
			return this.state === "Approved";
		}
		get isCompleted() {
			return this.state === "Completed";
		}
		get isRoot() {
			return !this.rootPlanId;
		}
		get isChild() {
			return Boolean(this.rootPlanId) && !isNil(this.version);
		}
		get lineageId() {
			return getConstructionPlanLineageId(this);
		}
		get isAddendum() {
			return isConstructionPlanAddendum(this);
		}
		get hasRenovationInspectionExternallyAccepted() {
			return this.renovationInspections?.some((ri) => {
				const isExternalAcceptance = ri.inspectionType === "ExternalAcceptance";
				const isNilOrFullAcceptance = isNil(ri.defectsAcceptanceType) || ri.defectsAcceptanceType === "FullAcceptance";
				return isExternalAcceptance && isNilOrFullAcceptance;
			});
		}
	};
}));
//#endregion
//#region src/domains/renovation/construction-plan.opts.ts
var init_construction_plan_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/renovation/construction-position.opts.ts
var init_construction_position_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/renovation/construction-progress.model.ts
var MilestoneName, ConstructionProgressStatus;
var init_construction_progress_model = __esmMin((() => {
	MilestoneName = /* @__PURE__ */ function(MilestoneName) {
		MilestoneName["Demolition"] = "Demontage";
		MilestoneName["HSE_1"] = "Rohinstallation";
		MilestoneName["Bricklayer"] = "Maurer- und Putzarbeiten";
		MilestoneName["HSE_2"] = "Zwischeninstallation";
		MilestoneName["Drywall_1"] = "Konstruktion";
		MilestoneName["Drywall_2"] = "Wände schliessen";
		MilestoneName["Paint_1"] = "Vorarbeiten";
		MilestoneName["Tiling_1"] = "Abdichtung";
		MilestoneName["Paint_2"] = "Anstrich";
		MilestoneName["Tiling_2"] = "Fliesen";
		MilestoneName["Flooring_1"] = "Bodenausgleich";
		MilestoneName["Flooring_2"] = "Parkett";
		MilestoneName["HSE_3"] = "Endmontage";
		MilestoneName["Carpenter"] = "Türen/Zargen";
		MilestoneName["Kitchen_1"] = "Lieferung";
		MilestoneName["Kitchen_2"] = "Montage";
		MilestoneName["Paint_3"] = "Endanstrich";
		MilestoneName["Cleaning"] = "Feinreinigung";
		MilestoneName["DefectsFixing"] = "Defects Fixing";
		return MilestoneName;
	}({});
	ConstructionProgressStatus = /* @__PURE__ */ function(ConstructionProgressStatus) {
		ConstructionProgressStatus["NotStarted"] = "NotStarted";
		ConstructionProgressStatus["InProgress"] = "InProgress";
		ConstructionProgressStatus["Done"] = "Done";
		return ConstructionProgressStatus;
	}({});
}));
//#endregion
//#region src/domains/renovation/construction-progress.opts.ts
var init_construction_progress_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/renovation/construction-template.model.ts
var init_construction_template_model = __esmMin((() => {}));
//#endregion
//#region src/domains/renovation/contractor-pricing.model.ts
var init_contractor_pricing_model = __esmMin((() => {}));
//#endregion
//#region src/domains/renovation/contractor.helper.ts
var filterContractorsByConstructionPlanType;
var init_contractor_helper = __esmMin((() => {
	init_company();
	filterContractorsByConstructionPlanType = (contractors, constructionPlanType) => {
		switch (constructionPlanType) {
			case "Kitchen": return contractors.filter((c) => c.type === "KitchenSupplier");
			case "Material": return contractors.filter((c) => c.type === "MaterialSupplier");
			case "General": return contractors.filter((c) => c.type === "ContractorGeneral");
			default: return contractors;
		}
	};
}));
//#endregion
//#region src/domains/renovation/contractor.model.ts
var ContractorCompanyType;
var init_contractor_model = __esmMin((() => {
	init_company();
	ContractorCompanyType = [
		"ContractorGeneral",
		"MeasurementsProvider",
		"ContractorCleaning",
		"ContractorElectricity",
		"KitchenSupplier",
		"MaterialSupplier"
	];
}));
//#endregion
//#region src/domains/renovation/defect.model.ts
var DefectStatus, pendingDefectStatuses, finalDefectStatuses, editableDefectStatuses, Priority, DEFECT_USER_PROPS, DEFECT_COMPANY_PROPS, ALL_DEFECT_PROPS, DefectFixVerifiers, editableDefectPropsForStatus, DefectType, DefectMainItem, DefectSubItem, DefectTitleType, DefectDescriptionType;
var init_defect_model = __esmMin((() => {
	DefectStatus = /* @__PURE__ */ function(DefectStatus) {
		DefectStatus["ToDo"] = "ToDo";
		DefectStatus["ContractorContacted"] = "ContractorContacted";
		DefectStatus["AppointmentScheduled"] = "AppointmentScheduled";
		DefectStatus["FixVerified"] = "FixVerified";
		DefectStatus["InProgress"] = "InProgress";
		DefectStatus["Completed"] = "Completed";
		DefectStatus["Rejected"] = "Rejected";
		return DefectStatus;
	}({});
	pendingDefectStatuses = [
		"ToDo",
		"InProgress",
		"ContractorContacted",
		"AppointmentScheduled",
		"FixVerified"
	];
	finalDefectStatuses = ["Completed", "Rejected"];
	editableDefectStatuses = ["ToDo", "InProgress"];
	Priority = /* @__PURE__ */ function(Priority) {
		Priority["High"] = "High";
		Priority["Normal"] = "Normal";
		Priority["Low"] = "Low";
		return Priority;
	}({});
	DEFECT_USER_PROPS = [
		"sourceId",
		"contactId",
		"creatorId",
		"supervisorId",
		"propertyManagerId",
		"infoRecipientId"
	];
	DEFECT_COMPANY_PROPS = ["assigneeId", "substituteAssigneeId"];
	ALL_DEFECT_PROPS = [
		"defectId",
		"type",
		"estateDefectId",
		"uuid",
		"title",
		"description",
		"priority",
		"status",
		"craft",
		"floorPlanLocations",
		"isWarranty",
		"isPostRenovation",
		"isInvestorHandover",
		"isInSubstitute",
		"deadline",
		"appointedAt",
		"estateId",
		"renovationInspectionId",
		"estateElementId",
		"positionId",
		"parentDefectId",
		"defectsLayerId",
		"media",
		"constructionPlanId",
		"sourceId",
		"contactId",
		"creatorId",
		"assigneeId",
		"substituteAssigneeId",
		"supervisorId",
		"propertyManagerId",
		"infoRecipientId"
	];
	DefectFixVerifiers = [
		"Tenant",
		"Investor",
		"Contractor",
		"Renovation Team",
		"Transaction Team",
		"Property Management",
		"Other"
	];
	editableDefectPropsForStatus = {
		["ToDo"]: ALL_DEFECT_PROPS,
		["ContractorContacted"]: [
			"priority",
			"deadline",
			"description",
			"media",
			"assigneeId"
		],
		["AppointmentScheduled"]: [
			"priority",
			"deadline",
			"description",
			"media",
			"assigneeId"
		],
		["FixVerified"]: [
			"priority",
			"deadline",
			"description",
			"media",
			"assigneeId"
		],
		["InProgress"]: [
			"priority",
			"deadline",
			"description",
			"media",
			"assigneeId"
		],
		["Rejected"]: [],
		["Completed"]: []
	};
	DefectType = /* @__PURE__ */ function(DefectType) {
		DefectType["Renovation"] = "Renovation";
		DefectType["PropertyManagement"] = "PropertyManagement";
		return DefectType;
	}({});
	DefectMainItem = /* @__PURE__ */ function(DefectMainItem) {
		DefectMainItem["Other"] = "Other";
		DefectMainItem["Masonry"] = "Masonry";
		DefectMainItem["ShowerBase"] = "ShowerBase";
		DefectMainItem["CornerProtectionStrip"] = "CornerProtectionStrip";
		DefectMainItem["Plaster"] = "Plaster";
		DefectMainItem["SuspendedCeiling"] = "SuspendedCeiling";
		DefectMainItem["Casing"] = "Casing";
		DefectMainItem["Wall"] = "Wall";
		DefectMainItem["DecorativeElements"] = "DecorativeElements";
		DefectMainItem["Leveling"] = "Leveling";
		DefectMainItem["Flooring"] = "Flooring";
		DefectMainItem["Parquet"] = "Parquet";
		DefectMainItem["SkirtingBoard"] = "SkirtingBoard";
		DefectMainItem["Vinyl"] = "Vinyl";
		DefectMainItem["Waterproofing"] = "Waterproofing";
		DefectMainItem["FloorTiles"] = "FloorTiles";
		DefectMainItem["WallTiles"] = "WallTiles";
		DefectMainItem["MaterialSeparationStrip"] = "MaterialSeparationStrip";
		DefectMainItem["BalconyDoor"] = "BalconyDoor";
		DefectMainItem["Window"] = "Window";
		DefectMainItem["InteriorDoor"] = "InteriorDoor";
		DefectMainItem["RollerShutter"] = "RollerShutter";
		DefectMainItem["ApartmentDoor"] = "ApartmentDoor";
		DefectMainItem["Bathtub"] = "Bathtub";
		DefectMainItem["Shower"] = "Shower";
		DefectMainItem["ShowerEnclosure"] = "ShowerEnclosure";
		DefectMainItem["Radiator"] = "Radiator";
		DefectMainItem["SanitaryInstallation"] = "SanitaryInstallation";
		DefectMainItem["ElectricInstallation"] = "ElectricInstallation";
		DefectMainItem["Mirror"] = "Mirror";
		DefectMainItem["WaterHeater"] = "WaterHeater";
		DefectMainItem["Washbasin"] = "Washbasin";
		DefectMainItem["Toilet"] = "Toilet";
		DefectMainItem["SwitchProgram"] = "SwitchProgram";
		DefectMainItem["SubDistributionBoard"] = "SubDistributionBoard";
		DefectMainItem["Countertop"] = "Countertop";
		DefectMainItem["ElectricalDevice"] = "ElectricalDevice";
		DefectMainItem["WallCabinet"] = "WallCabinet";
		DefectMainItem["TallCabinet"] = "TallCabinet";
		DefectMainItem["Sink"] = "Sink";
		DefectMainItem["BaseCabinet"] = "BaseCabinet";
		DefectMainItem["Kitchen"] = "Kitchen";
		DefectMainItem["SkirtingTile"] = "SkirtingTile";
		DefectMainItem["Apartment"] = "Apartment";
		DefectMainItem["Garage"] = "Garage";
		DefectMainItem["Cellar"] = "Cellar";
		DefectMainItem["ParkingSpace"] = "ParkingSpace";
		DefectMainItem["Attic"] = "Attic";
		DefectMainItem["Development"] = "Development";
		DefectMainItem["Ceiling"] = "Ceiling";
		DefectMainItem["MeasuringEquipment"] = "MeasuringEquipment";
		DefectMainItem["SmokeDetector"] = "SmokeDetector";
		return DefectMainItem;
	}({});
	DefectSubItem = /* @__PURE__ */ function(DefectSubItem) {
		DefectSubItem["Other"] = "Other";
		DefectSubItem["ThresholdStrip"] = "ThresholdStrip";
		DefectSubItem["Ceiling"] = "Ceiling";
		DefectSubItem["WindowReveal"] = "WindowReveal";
		DefectSubItem["WindowFrame"] = "WindowFrame";
		DefectSubItem["InteriorDoor"] = "InteriorDoor";
		DefectSubItem["InteriorDoorFrame"] = "InteriorDoorFrame";
		DefectSubItem["RollerShutterBox"] = "RollerShutterBox";
		DefectSubItem["DoorStopper"] = "DoorStopper";
		DefectSubItem["SkirtingBoard"] = "SkirtingBoard";
		DefectSubItem["Wall"] = "Wall";
		DefectSubItem["ApartmentDoor"] = "ApartmentDoor";
		DefectSubItem["Cove"] = "Cove";
		DefectSubItem["Cornice"] = "Cornice";
		DefectSubItem["CeilingRose"] = "CeilingRose";
		DefectSubItem["FloorJoint"] = "FloorJoint";
		DefectSubItem["QuarterRound"] = "QuarterRound";
		DefectSubItem["WallJoint"] = "WallJoint";
		DefectSubItem["TwoColorProof"] = "TwoColorProof";
		DefectSubItem["WaterproofingMembrane"] = "WaterproofingMembrane";
		DefectSubItem["Fitting"] = "Fitting";
		DefectSubItem["Sleeve"] = "Sleeve";
		DefectSubItem["SealingTape"] = "SealingTape";
		DefectSubItem["BathtubSealingTape"] = "BathtubSealingTape";
		DefectSubItem["BathroomFloor"] = "BathroomFloor";
		DefectSubItem["ShowerArea"] = "ShowerArea";
		DefectSubItem["TileJoint"] = "TileJoint";
		DefectSubItem["Slope"] = "Slope";
		DefectSubItem["SiliconeJoint"] = "SiliconeJoint";
		DefectSubItem["ShowerShelf"] = "ShowerShelf";
		DefectSubItem["CorkStrip"] = "CorkStrip";
		DefectSubItem["Seal"] = "Seal";
		DefectSubItem["Wing"] = "Wing";
		DefectSubItem["Handle"] = "Handle";
		DefectSubItem["BalconyDoorFrame"] = "BalconyDoorFrame";
		DefectSubItem["BalconyDoorThreshold"] = "BalconyDoorThreshold";
		DefectSubItem["Board"] = "Board";
		DefectSubItem["Frame"] = "Frame";
		DefectSubItem["HandleSet"] = "HandleSet";
		DefectSubItem["Glass"] = "Glass";
		DefectSubItem["Threshold"] = "Threshold";
		DefectSubItem["DoorLeaf"] = "DoorLeaf";
		DefectSubItem["DoorFrame"] = "DoorFrame";
		DefectSubItem["BeltWinder"] = "BeltWinder";
		DefectSubItem["LetterboxSlot"] = "LetterboxSlot";
		DefectSubItem["LockCylinder"] = "LockCylinder";
		DefectSubItem["SecurityLock"] = "SecurityLock";
		DefectSubItem["Peephole"] = "Peephole";
		DefectSubItem["DoorJamb"] = "DoorJamb";
		DefectSubItem["DrainCover"] = "DrainCover";
		DefectSubItem["Faucet"] = "Faucet";
		DefectSubItem["ShowerSet"] = "ShowerSet";
		DefectSubItem["Bathtub"] = "Bathtub";
		DefectSubItem["SealLip"] = "SealLip";
		DefectSubItem["Profile"] = "Profile";
		DefectSubItem["StabilizingArm"] = "StabilizingArm";
		DefectSubItem["DoorSwing"] = "DoorSwing";
		DefectSubItem["ShutOffValce"] = "ShutOffValce";
		DefectSubItem["Pipe"] = "Pipe";
		DefectSubItem["ReturnValve"] = "ReturnValve";
		DefectSubItem["Thermostat"] = "Thermostat";
		DefectSubItem["PressureTestReport"] = "PressureTestReport";
		DefectSubItem["Ventilation"] = "Ventilation";
		DefectSubItem["AngleValve"] = "AngleValve";
		DefectSubItem["TestCapFitting"] = "TestCapFitting";
		DefectSubItem["ConcealedValce"] = "ConcealedValce";
		DefectSubItem["WashingMachineConnection"] = "WashingMachineConnection";
		DefectSubItem["ShadowGap"] = "ShadowGap";
		DefectSubItem["FluePipe"] = "FluePipe";
		DefectSubItem["ChimneySweepAcceptanceCertificate"] = "ChimneySweepAcceptanceCertificate";
		DefectSubItem["CondensateDrain"] = "CondensateDrain";
		DefectSubItem["RoomThermostat"] = "RoomThermostat";
		DefectSubItem["DrainSet"] = "DrainSet";
		DefectSubItem["Rosette"] = "Rosette";
		DefectSubItem["Siphon"] = "Siphon";
		DefectSubItem["PushPlate"] = "PushPlate";
		DefectSubItem["Ceramic"] = "Ceramic";
		DefectSubItem["Seat"] = "Seat";
		DefectSubItem["ToiletPaperHolder"] = "ToiletPaperHolder";
		DefectSubItem["StoveConnection"] = "StoveConnection";
		DefectSubItem["SmallFan"] = "SmallFan";
		DefectSubItem["Doorbell"] = "Doorbell";
		DefectSubItem["MultimediaConnectionStrip"] = "MultimediaConnectionStrip";
		DefectSubItem["MultimediaDistributionBox"] = "MultimediaDistributionBox";
		DefectSubItem["Intercom"] = "Intercom";
		DefectSubItem["DoorOpener"] = "DoorOpener";
		DefectSubItem["AntennatSocket"] = "AntennatSocket";
		DefectSubItem["Switch"] = "Switch";
		DefectSubItem["ElectricalOutlet"] = "ElectricalOutlet";
		DefectSubItem["TelephoneSocket"] = "TelephoneSocket";
		DefectSubItem["DataSocket"] = "DataSocket";
		DefectSubItem["OccupancyPlan"] = "OccupancyPlan";
		DefectSubItem["ElectricalSafetyInspection"] = "ElectricalSafetyInspection";
		DefectSubItem["ElectricityMeter"] = "ElectricityMeter";
		DefectSubItem["SurgeProtection"] = "SurgeProtection";
		DefectSubItem["Lightning"] = "Lightning";
		DefectSubItem["RangeHood"] = "RangeHood";
		DefectSubItem["Backsplash"] = "Backsplash";
		DefectSubItem["Freezer"] = "Freezer";
		DefectSubItem["Dishwasher"] = "Dishwasher";
		DefectSubItem["Stove"] = "Stove";
		DefectSubItem["FridgeFreezerCombination"] = "FridgeFreezerCombination";
		DefectSubItem["Fridge"] = "Fridge";
		DefectSubItem["LedUnderCabinetLight"] = "LedUnderCabinetLight";
		DefectSubItem["Microwave"] = "Microwave";
		DefectSubItem["Oven"] = "Oven";
		DefectSubItem["ShelfInsert"] = "ShelfInsert";
		DefectSubItem["HandleOrHandleStrip"] = "HandleOrHandleStrip";
		DefectSubItem["CabinetDoor"] = "CabinetDoor";
		DefectSubItem["SidePanel"] = "SidePanel";
		DefectSubItem["Gable"] = "Gable";
		DefectSubItem["Exxentric"] = "Exxentric";
		DefectSubItem["Drawer"] = "Drawer";
		DefectSubItem["CutleryTray"] = "CutleryTray";
		DefectSubItem["Masonry"] = "Masonry";
		DefectSubItem["ShowerBase"] = "ShowerBase";
		DefectSubItem["CornerProtectionStrip"] = "CornerProtectionStrip";
		DefectSubItem["Plaster"] = "Plaster";
		DefectSubItem["SuspendedCeiling"] = "SuspendedCeiling";
		DefectSubItem["Casing"] = "Casing";
		DefectSubItem["DecorativeElements"] = "DecorativeElements";
		DefectSubItem["LevelingCompound"] = "LevelingCompound";
		DefectSubItem["Flooring"] = "Flooring";
		DefectSubItem["Parquet"] = "Parquet";
		DefectSubItem["Waterproofing"] = "Waterproofing";
		DefectSubItem["MaterialSeparationStrip"] = "MaterialSeparationStrip";
		DefectSubItem["BalconyDoor"] = "BalconyDoor";
		DefectSubItem["Window"] = "Window";
		DefectSubItem["RollerShutter"] = "RollerShutter";
		DefectSubItem["Shower"] = "Shower";
		DefectSubItem["ShowerEnclosure"] = "ShowerEnclosure";
		DefectSubItem["SanitaryInstallation"] = "SanitaryInstallation";
		DefectSubItem["Mirror"] = "Mirror";
		DefectSubItem["WaterHeater"] = "WaterHeater";
		DefectSubItem["Washbasin"] = "Washbasin";
		DefectSubItem["Toilet"] = "Toilet";
		DefectSubItem["ElectricInstallation"] = "ElectricInstallation";
		DefectSubItem["SwitchProgram"] = "SwitchProgram";
		DefectSubItem["SubDistributionBoard"] = "SubDistributionBoard";
		DefectSubItem["WallCabinet"] = "WallCabinet";
		DefectSubItem["TallCabinet"] = "TallCabinet";
		DefectSubItem["BaseCabinet"] = "BaseCabinet";
		DefectSubItem["FloorTiles"] = "FloorTiles";
		DefectSubItem["ShutterBelt"] = "ShutterBelt";
		DefectSubItem["ColdWater"] = "ColdWater";
		DefectSubItem["WarmWater"] = "WarmWater";
		DefectSubItem["WashingMachineSiphon"] = "WashingMachineSiphon";
		DefectSubItem["SingleMeterCabinet"] = "SingleMeterCabinet";
		DefectSubItem["MultimediaDistributionCabinet"] = "MultimediaDistributionCabinet";
		DefectSubItem["DistributionCabinet"] = "DistributionCabinet";
		DefectSubItem["Joint"] = "Joint";
		DefectSubItem["FrontWall"] = "FrontWall";
		DefectSubItem["WallTile"] = "WallTile";
		DefectSubItem["OpenEdge"] = "OpenEdge";
		DefectSubItem["SkirtingTile"] = "SkirtingTile";
		DefectSubItem["FallProtection"] = "FallProtection";
		DefectSubItem["SiliconeDisc"] = "SiliconeDisc";
		DefectSubItem["ShutterBeltCover"] = "ShutterBeltCover";
		DefectSubItem["AcrylicJoint"] = "AcrylicJoint";
		DefectSubItem["DoorPanel"] = "DoorPanel";
		DefectSubItem["HeatingPipe"] = "HeatingPipe";
		DefectSubItem["UserInterface"] = "UserInterface";
		DefectSubItem["Boiler"] = "Boiler";
		DefectSubItem["InstantWaterHeater"] = "InstantWaterHeater";
		DefectSubItem["GasHeater"] = "GasHeater";
		DefectSubItem["ConstructionLight"] = "ConstructionLight";
		DefectSubItem["CeilingOutlet"] = "CeilingOutlet";
		DefectSubItem["LedSpots"] = "LedSpots";
		DefectSubItem["CableTvSignal"] = "CableTvSignal";
		DefectSubItem["TelephoneSignal"] = "TelephoneSignal";
		DefectSubItem["Hallway"] = "Hallway";
		DefectSubItem["Bathroom"] = "Bathroom";
		DefectSubItem["Kitchen"] = "Kitchen";
		DefectSubItem["LivingRoom"] = "LivingRoom";
		DefectSubItem["Bedroom"] = "Bedroom";
		DefectSubItem["StorageRoom"] = "StorageRoom";
		DefectSubItem["Balcony"] = "Balcony";
		DefectSubItem["Apartment"] = "Apartment";
		DefectSubItem["Garage"] = "Garage";
		DefectSubItem["Cellar"] = "Cellar";
		DefectSubItem["ParkingSpace"] = "ParkingSpace";
		DefectSubItem["Attic"] = "Attic";
		DefectSubItem["Stairway"] = "Stairway";
		DefectSubItem["Outside"] = "Outside";
		DefectSubItem["Development"] = "Development";
		DefectSubItem["FineFiller"] = "FineFiller";
		DefectSubItem["HeatingAmountCounter"] = "HeatingAmountCounter";
		DefectSubItem["HeatCostAllocator"] = "HeatCostAllocator";
		DefectSubItem["WaterMeter"] = "WaterMeter";
		DefectSubItem["SmokeDetector"] = "SmokeDetector";
		return DefectSubItem;
	}({});
	DefectTitleType = /* @__PURE__ */ function(DefectTitleType) {
		DefectTitleType["Other"] = "Other";
		DefectTitleType["Missing"] = "Missing";
		DefectTitleType["Wrong"] = "Wrong";
		DefectTitleType["Defective"] = "Defective";
		DefectTitleType["AssemblyDefect"] = "AssemblyDefect";
		DefectTitleType["Dirty"] = "Dirty";
		return DefectTitleType;
	}({});
	DefectDescriptionType = /* @__PURE__ */ function(DefectDescriptionType) {
		DefectDescriptionType["Other"] = "Other";
		DefectDescriptionType["MissingPart"] = "MissingPart";
		DefectDescriptionType["MissingTask"] = "MissingTask";
		DefectDescriptionType["WrongProduct"] = "WrongProduct";
		DefectDescriptionType["WrongSize"] = "WrongSize";
		DefectDescriptionType["WrongVersion"] = "WrongVersion";
		DefectDescriptionType["Broken"] = "Broken";
		DefectDescriptionType["WrongAlignment"] = "WrongAlignment";
		DefectDescriptionType["WrongPosition"] = "WrongPosition";
		DefectDescriptionType["WrongColor"] = "WrongColor";
		DefectDescriptionType["Ripped"] = "Ripped";
		DefectDescriptionType["Hollow"] = "Hollow";
		DefectDescriptionType["Uneven"] = "Uneven";
		DefectDescriptionType["Incomplete"] = "Incomplete";
		DefectDescriptionType["NotTight"] = "NotTight";
		DefectDescriptionType["NotCleared"] = "NotCleared";
		DefectDescriptionType["Dirty"] = "Dirty";
		DefectDescriptionType["NotMounted"] = "NotMounted";
		DefectDescriptionType["NotDone"] = "NotDone";
		DefectDescriptionType["NotFullyFunctioning"] = "NotFullyFunctioning";
		DefectDescriptionType["Leaky"] = "Leaky";
		DefectDescriptionType["Defective"] = "Defective";
		DefectDescriptionType["PaintingDefective"] = "PaintingDefective";
		DefectDescriptionType["NotUsable"] = "NotUsable";
		DefectDescriptionType["NotTightlyFitting"] = "NotTightlyFitting";
		return DefectDescriptionType;
	}({});
}));
//#endregion
//#region src/domains/renovation/defect.i18n.ts
var defectMainItemTranslationMap, defectSubItemTranslationMap, defectTitleTypeTranslationMap, defectDescriptionTypeTranslationMap, defectStatusTranslationMap;
var init_defect_i18n = __esmMin((() => {
	defectMainItemTranslationMap = {
		["Other"]: "Individuell",
		["Masonry"]: "Ausmauerung",
		["ShowerBase"]: "Duschpodest",
		["CornerProtectionStrip"]: "Eckschutzschiene",
		["Plaster"]: "Putz",
		["SuspendedCeiling"]: "Abhangdecke",
		["Casing"]: "Verkofferung",
		["Wall"]: "Wand",
		["DecorativeElements"]: "Zierelemente",
		["Leveling"]: "Ausgleich",
		["Flooring"]: "Dielung",
		["Parquet"]: "Parkett",
		["SkirtingBoard"]: "Sockelleiste",
		["Vinyl"]: "Vinyl",
		["Waterproofing"]: "Abdichtung",
		["FloorTiles"]: "Fliesen, Boden",
		["WallTiles"]: "Fliesen, Wand",
		["MaterialSeparationStrip"]: "Materialtrennschiene",
		["BalconyDoor"]: "Balkontür",
		["Window"]: "Fenster",
		["InteriorDoor"]: "Innentür",
		["RollerShutter"]: "Rolladen",
		["ApartmentDoor"]: "Wohnungseingangtür",
		["Bathtub"]: "Badewanne",
		["Shower"]: "Dusche",
		["ShowerEnclosure"]: "Duschtrennwand",
		["Radiator"]: "Heizkörper",
		["SanitaryInstallation"]: "Sanitärinstallation",
		["ElectricInstallation"]: "Elektroinstallation",
		["Mirror"]: "Spiegel",
		["WaterHeater"]: "Warmwassererzeuger",
		["Washbasin"]: "Waschtisch",
		["Toilet"]: "WC",
		["SwitchProgram"]: "Schalterprogramm",
		["SubDistributionBoard"]: "Unterverteiler",
		["Countertop"]: "Arbeitsplatte",
		["ElectricalDevice"]: "Elektrogerät",
		["WallCabinet"]: "Hängeschrank",
		["TallCabinet"]: "Hochschrank",
		["Sink"]: "Spülbecken",
		["BaseCabinet"]: "Unterschrank",
		["Kitchen"]: "Küche",
		["SkirtingTile"]: "Sockelfliese",
		["Apartment"]: "Wohnung",
		["Garage"]: "Garage",
		["Cellar"]: "Keller",
		["ParkingSpace"]: "Parkplatz",
		["Attic"]: "Dachboden",
		["Development"]: "Erschließung",
		["Ceiling"]: "Decke",
		["MeasuringEquipment"]: "Messgeräte",
		["SmokeDetector"]: "Rauchwarnmeldern"
	};
	defectSubItemTranslationMap = {
		["Other"]: "Individuell",
		["ThresholdStrip"]: "Absatzstreifen",
		["Ceiling"]: "Decke",
		["WindowReveal"]: "Fensterlaibung",
		["WindowFrame"]: "Fensterrahmen",
		["InteriorDoor"]: "Innentür",
		["InteriorDoorFrame"]: "Innentürzarge",
		["RollerShutterBox"]: "Rolladenkasten",
		["DoorStopper"]: "Türstopper",
		["SkirtingBoard"]: "Sockelleiste",
		["Wall"]: "Wand",
		["ApartmentDoor"]: "Wohnungseingangstür",
		["Cove"]: "Hohlkehle",
		["Cornice"]: "Stuckleiste",
		["CeilingRose"]: "Stuckrosette",
		["FloorJoint"]: "Bodenfuge",
		["QuarterRound"]: "Viertelstab",
		["WallJoint"]: "Wandfuge",
		["TwoColorProof"]: "2-Farb-Nachweis",
		["WaterproofingMembrane"]: "Abdichtungsvlies",
		["Fitting"]: "Formstück",
		["Sleeve"]: "Manschette",
		["SealingTape"]: "Dichtband",
		["BathtubSealingTape"]: "Wannendichtband",
		["BathroomFloor"]: "Badboden",
		["ShowerArea"]: "Duschbereich",
		["TileJoint"]: "Fliesenfuge",
		["Slope"]: "Gefälle",
		["SiliconeJoint"]: "Silikonfuge",
		["ShowerShelf"]: "Duschablage",
		["CorkStrip"]: "Korkstreifen",
		["Seal"]: "Dichtung",
		["Wing"]: "Flügel",
		["Handle"]: "Griff",
		["BalconyDoorFrame"]: "Balkontürrahmen",
		["BalconyDoorThreshold"]: "Balkontürschwelle",
		["Board"]: "Brett",
		["Frame"]: "Rahmen",
		["HandleSet"]: "Drückergarnitur",
		["Glass"]: "Glas",
		["Threshold"]: "Schwelle",
		["DoorLeaf"]: "Türblatt",
		["DoorFrame"]: "Türzarge",
		["BeltWinder"]: "Gurtwickler",
		["LetterboxSlot"]: "Briefschlitz",
		["LockCylinder"]: "Schliesszylinder",
		["SecurityLock"]: "Sicherheitsschloss",
		["Peephole"]: "Spion",
		["DoorJamb"]: "Zarge",
		["DrainCover"]: "Ablaufabdeckung",
		["Faucet"]: "Armatur",
		["ShowerSet"]: "Duschset",
		["Bathtub"]: "Wanne",
		["SealLip"]: "Dichtlippe",
		["Profile"]: "Profil",
		["StabilizingArm"]: "Stabilisierungsarm",
		["DoorSwing"]: "Türaufschlag",
		["ShutOffValce"]: "Hahnblock",
		["Pipe"]: "Leitung",
		["ReturnValve"]: "Rücklaufventil",
		["Thermostat"]: "Thermostat",
		["PressureTestReport"]: "Abdrückprotokoll",
		["Ventilation"]: "Abluft",
		["AngleValve"]: "Eckventil",
		["TestCapFitting"]: "Messkapselaufnahme",
		["ConcealedValce"]: "UP-Ventil",
		["WashingMachineConnection"]: "Waschgeräteanschluss",
		["ShadowGap"]: "Schattenfuge",
		["FluePipe"]: "Abgasrohr",
		["ChimneySweepAcceptanceCertificate"]: "Abnahmeprotokoll Schornsteinfeger",
		["CondensateDrain"]: "Kondensatablauf",
		["RoomThermostat"]: "Raumthermostat",
		["DrainSet"]: "Ablaufgarnitur",
		["Rosette"]: "Rosetten",
		["Siphon"]: "Siphon",
		["PushPlate"]: "Drückerplatte",
		["Ceramic"]: "Keramik",
		["Seat"]: "Sitz",
		["ToiletPaperHolder"]: "Toilettenpapierhalter",
		["StoveConnection"]: "Herdanschluss",
		["SmallFan"]: "Kleinlüfter",
		["Doorbell"]: "Klingel",
		["MultimediaConnectionStrip"]: "Multimedia-Anschlussleiste",
		["MultimediaDistributionBox"]: "Multimediaverteiler",
		["Intercom"]: "(Gegen-) Sprechanlage",
		["DoorOpener"]: "Türöffner",
		["AntennatSocket"]: "ANT - Dose",
		["Switch"]: "Schalter",
		["ElectricalOutlet"]: "Steckdose",
		["TelephoneSocket"]: "TAE - Dose",
		["DataSocket"]: "UAE - Dose",
		["OccupancyPlan"]: "Belegungsplan",
		["ElectricalSafetyInspection"]: "E-Check",
		["ElectricityMeter"]: "Stromzähler",
		["SurgeProtection"]: "Überspannungsschutz",
		["Lightning"]: "Beleuchtung",
		["RangeHood"]: "Dunstabzug",
		["Backsplash"]: "Nischenrückwand",
		["Freezer"]: "Gefrierschrank",
		["Dishwasher"]: "Geschirrspüler",
		["Stove"]: "Herd",
		["FridgeFreezerCombination"]: "Kühl- / Gefrierkombination",
		["Fridge"]: "Kühlschrank",
		["LedUnderCabinetLight"]: "LED-Unterbauleuchte",
		["Microwave"]: "Mikrowelle",
		["Oven"]: "Ofen",
		["ShelfInsert"]: "Einlegeboden",
		["HandleOrHandleStrip"]: "Griff / Griffleiste",
		["CabinetDoor"]: "Schranktür",
		["SidePanel"]: "Seitenblende",
		["Gable"]: "Wange",
		["Exxentric"]: "Exzenter",
		["Drawer"]: "Auszug",
		["CutleryTray"]: "Besteckeinsatz",
		["Masonry"]: "Ausmauerung",
		["ShowerBase"]: "Duschpodest",
		["CornerProtectionStrip"]: "Eckschutzschiene",
		["Plaster"]: "Putz",
		["SuspendedCeiling"]: "Abhangdecke",
		["Casing"]: "Verkofferung",
		["DecorativeElements"]: "Zierelemente",
		["LevelingCompound"]: "Nivelliermasse",
		["Flooring"]: "Dielung",
		["Parquet"]: "Parkett",
		["Waterproofing"]: "Abdichtung",
		["MaterialSeparationStrip"]: "Materialtrennschiene",
		["BalconyDoor"]: "Balkontür",
		["Window"]: "Fenster",
		["RollerShutter"]: "Rolladen",
		["Shower"]: "Dusche",
		["ShowerEnclosure"]: "Duschtrennwand",
		["SanitaryInstallation"]: "Sanitärinstallation",
		["Mirror"]: "Spiegel",
		["WaterHeater"]: "Warmwassererzeuger",
		["Washbasin"]: "Waschtisch",
		["Toilet"]: "WC",
		["SwitchProgram"]: "Schalterprogramm",
		["SubDistributionBoard"]: "Unterverteilung",
		["WallCabinet"]: "Hängeschrank",
		["TallCabinet"]: "Hochschrank",
		["BaseCabinet"]: "Unterschrank",
		["Joint"]: "Fuge",
		["FrontWall"]: "Vorwand",
		["WallTile"]: "Wandfliesen",
		["OpenEdge"]: "Offene Kante",
		["SkirtingTile"]: "Sockelfliese",
		["FallProtection"]: "Absturzsicherung",
		["SiliconeDisc"]: "Silikon Scheibe",
		["ShutterBeltCover"]: "Gurtwickler-Abdeckung Blende",
		["AcrylicJoint"]: "Acrylfuge",
		["DoorPanel"]: "Türblatt",
		["HeatingPipe"]: "Heizrohr",
		["UserInterface"]: "Bedienmodul",
		["Boiler"]: "Boiler",
		["InstantWaterHeater"]: "Durchlauferhitzer",
		["GasHeater"]: "Gastherme",
		["ConstructionLight"]: "Bauleuchte",
		["CeilingOutlet"]: "Deckenauslass",
		["LedSpots"]: "LED-Spot",
		["CableTvSignal"]: "Kabel-TV Signal",
		["TelephoneSignal"]: "Telefon-Signal",
		["Hallway"]: "Flur",
		["Bathroom"]: "Bad",
		["Kitchen"]: "Küche",
		["LivingRoom"]: "Wohnzimmer",
		["Bedroom"]: "Schlafzimmer",
		["StorageRoom"]: "Abstellkammer",
		["Balcony"]: "Balkon",
		["Apartment"]: "Wohnung",
		["Garage"]: "Garage",
		["Cellar"]: "Keller",
		["ParkingSpace"]: "Parkplatz",
		["Attic"]: "Dachboden",
		["Stairway"]: "Treppenhaus",
		["Outside"]: "Außenbereich",
		["Development"]: "Erschließung",
		["ElectricInstallation"]: "Elektroinstallation",
		["ShutterBelt"]: "Rolladengurt",
		["FloorTiles"]: "Bodenfliesen",
		["ColdWater"]: "Kaltwasser",
		["WarmWater"]: "Warmwasser",
		["WashingMachineSiphon"]: "Waschgerätesiphon",
		["SingleMeterCabinet"]: "Einzelzählerschrank",
		["MultimediaDistributionCabinet"]: "Multimediaverteilerschrank",
		["DistributionCabinet"]: "Verteilerschrank",
		["FineFiller"]: "Feinspachtel",
		["HeatingAmountCounter"]: "Wärmemengenzähler",
		["HeatCostAllocator"]: "Heizkostenverteiler",
		["WaterMeter"]: "Wasserzähler",
		["SmokeDetector"]: "Rauchwarnmelder"
	};
	defectTitleTypeTranslationMap = {
		["Other"]: "individuell",
		["Missing"]: "fehlt",
		["Wrong"]: "falsches Produkt",
		["Defective"]: "mangelhaft",
		["AssemblyDefect"]: "Montage mangelhaft",
		["Dirty"]: "verunreinigt"
	};
	defectDescriptionTypeTranslationMap = {
		["Other"]: "Individuell",
		["MissingPart"]: "fehlendes Bauteil",
		["MissingTask"]: "fehlende Leistung",
		["WrongProduct"]: "falsches Produkt",
		["WrongSize"]: "falsche Größe",
		["WrongVersion"]: "falsche Variante",
		["Broken"]: "beschädigt",
		["WrongAlignment"]: "falsche Ausrichtung",
		["WrongPosition"]: "falsche Position",
		["WrongColor"]: "falscher Farbton",
		["Ripped"]: "gerissen",
		["Hollow"]: "hohl",
		["Uneven"]: "uneben",
		["Incomplete"]: "unvollständig",
		["NotTight"]: "nicht fest sitzend",
		["NotCleared"]: "nicht beräumt",
		["Dirty"]: "verunreinigt",
		["NotMounted"]: "nicht montiert",
		["NotDone"]: "nicht ausgeführt",
		["NotFullyFunctioning"]: "nicht voll funktionstüchtig",
		["Leaky"]: "undicht",
		["Defective"]: "defekt",
		["PaintingDefective"]: "Anstrich mangelhaft",
		["NotUsable"]: "nicht betriebsbereit",
		["NotTightlyFitting"]: "nicht fest sitzend"
	};
	defectStatusTranslationMap = {
		["ToDo"]: "Offen",
		["InProgress"]: "In Bearbeitung",
		["ContractorContacted"]: "Kontaktierter Auftragnehmer",
		["AppointmentScheduled"]: "Geplanter Termin",
		["FixVerified"]: "Fix Verifiziert",
		["Completed"]: "Abgeschlossen",
		["Rejected"]: "Abgelehnt"
	};
}));
//#endregion
//#region src/domains/renovation/defect.opts.ts
var init_defect_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/renovation/estate-element.base.ts
var ElementRenovationStage, ElementRenovationStagesList, RoomType, RoomTypesList, RoomStructureElements, RoomEquipment, RoomOtherElementType, ElementTypeName, EstateElementType, RoomTypesOrderedList;
var init_estate_element_base = __esmMin((() => {
	ElementRenovationStage = /* @__PURE__ */ function(ElementRenovationStage) {
		ElementRenovationStage["PreRenovation"] = "PreRenovation";
		ElementRenovationStage["PostRenovation"] = "PostRenovation";
		return ElementRenovationStage;
	}({});
	ElementRenovationStagesList = Object.values(ElementRenovationStage);
	RoomType = /* @__PURE__ */ function(RoomType) {
		RoomType["General"] = "General";
		RoomType["Hallway"] = "Hallway";
		RoomType["LivingRoom"] = "LivingRoom";
		RoomType["Bedroom"] = "Bedroom";
		RoomType["Bathroom"] = "Bathroom";
		RoomType["GuestWC"] = "GuestWC";
		RoomType["Kitchen"] = "Kitchen";
		RoomType["Kitchenette"] = "Kitchenette";
		RoomType["Storeroom"] = "Storeroom";
		RoomType["Balcony"] = "Balcony";
		RoomType["LivingRoomWithKitchen"] = "LivingRoomWithKitchen";
		RoomType["HallwayWithKitchen"] = "HallwayWithKitchen";
		RoomType["LivingRoomWithHallwayAndKitchen"] = "LivingRoomWithHallwayAndKitchen";
		return RoomType;
	}({});
	RoomTypesList = Object.values(RoomType);
	RoomStructureElements = /* @__PURE__ */ function(RoomStructureElements) {
		RoomStructureElements["Door"] = "Door";
		RoomStructureElements["Window"] = "Window";
		RoomStructureElements["Ceiling"] = "Ceiling";
		RoomStructureElements["Wall"] = "Wall";
		RoomStructureElements["Floor"] = "Floor";
		return RoomStructureElements;
	}({});
	RoomEquipment = /* @__PURE__ */ function(RoomEquipment) {
		RoomEquipment["Sanitary"] = "Sanitary";
		RoomEquipment["Heater"] = "Heater";
		RoomEquipment["Electric"] = "Electric";
		RoomEquipment["EBK"] = "EBK";
		RoomEquipment["Other"] = "Other";
		return RoomEquipment;
	}({});
	RoomOtherElementType = /* @__PURE__ */ function(RoomOtherElementType) {
		RoomOtherElementType["Other"] = "Other";
		return RoomOtherElementType;
	}({});
	ElementTypeName = /* @__PURE__ */ function(ElementTypeName) {
		ElementTypeName["General"] = "General";
		ElementTypeName["Room"] = "Room";
		ElementTypeName["Structure"] = "Structure";
		ElementTypeName["Equipment"] = "Equipment";
		ElementTypeName["Furnishing"] = "Furnishing";
		return ElementTypeName;
	}({});
	EstateElementType = {
		...RoomType,
		...RoomOtherElementType,
		...RoomStructureElements,
		...RoomEquipment
	};
	RoomTypesOrderedList = [
		"LivingRoom",
		"Bedroom",
		"Hallway",
		"Kitchen",
		"Kitchenette",
		"Bathroom",
		"GuestWC",
		"Storeroom",
		"Balcony",
		"LivingRoomWithKitchen",
		"HallwayWithKitchen",
		"LivingRoomWithHallwayAndKitchen"
	];
}));
//#endregion
//#region src/domains/renovation/estate-element.helpers.ts
var compareRooms;
var init_estate_element_helpers = __esmMin((() => {
	init_estate_element_base();
	compareRooms = (a, b) => {
		const roomTypeOrder = RoomTypesOrderedList.indexOf(a.elementType) - RoomTypesOrderedList.indexOf(b.elementType);
		if (roomTypeOrder === 0) return b.area - a.area;
		return roomTypeOrder;
	};
}));
//#endregion
//#region src/domains/renovation/estate-element.model.ts
var init_estate_element_model = __esmMin((() => {}));
//#endregion
//#region src/domains/renovation/estate-element.opts.ts
var init_estate_element_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/renovation/renovation-cost-tracking.helpers.ts
var mapRenovation, mapPlan, fromRenovationsToUIData, isCostOvershooting;
var init_renovation_cost_tracking_helpers = __esmMin((() => {
	mapRenovation = (renovation) => {
		let currentOvershoot;
		if (renovation.renovationProcessAllowedOvershoot) {
			let budget = 0;
			let initialContractValue = 0;
			let currentContractValue = 0;
			for (const p of renovation.plans ?? []) {
				if (["General", "Kitchen"].includes(p.constructionPlanType)) {
					budget += p.budget;
					initialContractValue += p.initialContractValue;
				}
				currentContractValue += p.currentContractValue;
			}
			currentOvershoot = budget > 0 ? currentContractValue / budget : 0;
		}
		return {
			estateId: renovation.estateId,
			condoUuid: renovation.condoUuid || `${renovation.estateId}`,
			street: renovation.street,
			city: renovation.city,
			renovationProcessState: renovation.renovationProcessState,
			renovationProcessId: renovation.renovationProcessId,
			renovationProcessAllowedOvershoot: renovation.renovationProcessAllowedOvershoot,
			renovationProcessCurrentOvershoot: currentOvershoot,
			rooms: `${renovation.rooms ?? "-"}`,
			livingSpace: renovation.livingSpace ? squareMeter(renovation.livingSpace) : "-",
			budget: currency(renovation.budgetTotal),
			initialContractValue: currency(renovation.initialContractTotal),
			currentContractValue: currency(renovation.currentContractTotal),
			billed: currency(renovation.billedTotal),
			forecast: currency(renovation.forecastTotal),
			pricePerSqm: renovation.pricePerSqm ? currency(renovation.pricePerSqm) : "-",
			difference: currency(renovation.difference)
		};
	};
	mapPlan = (estateId, plan, formatMoneyAsCurrency) => ({
		estateId,
		constructionPlanId: plan.constructionPlanId,
		condoUuid: plan.constructionPlanType,
		street: plan.contractor,
		budget: formatMoneyAsCurrency ? currency(plan.budget) : localNumberFormat(plan.budget),
		initialContractValue: formatMoneyAsCurrency ? currency(plan.initialContractValue) : localNumberFormat(plan.initialContractValue),
		currentContractValue: formatMoneyAsCurrency ? currency(plan.currentContractValue) : localNumberFormat(plan.currentContractValue),
		billed: formatMoneyAsCurrency ? currency(plan.billed) : localNumberFormat(plan.billed),
		forecast: formatMoneyAsCurrency ? currency(plan.forecast) : localNumberFormat(plan.forecast)
	});
	fromRenovationsToUIData = (renovations, formatMoneyAsCurrency = true) => renovations.map((renovation) => {
		return {
			...mapRenovation(renovation),
			children: renovation.plans.length ? renovation.plans.map((plan) => mapPlan(renovation.estateId, plan, formatMoneyAsCurrency)) : []
		};
	});
	isCostOvershooting = (allowedOvershoot, currentOvershoot) => {
		if (isNil(allowedOvershoot) || isNil(currentOvershoot)) return false;
		return floatBiggerThan(currentOvershoot, allowedOvershoot + 1);
	};
}));
//#endregion
//#region src/domains/renovation/renovation-cost-tracking.model.ts
var RenovationCostTrackingConstructionPlanTypes, RenovationCostTrackingConstructionPlansOrder;
var init_renovation_cost_tracking_model = __esmMin((() => {
	RenovationCostTrackingConstructionPlanTypes = [
		"General",
		"Kitchen",
		"Material",
		"Electricity",
		"Cleaning",
		"Other"
	];
	RenovationCostTrackingConstructionPlansOrder = {
		["General"]: 1,
		["Kitchen"]: 2,
		["Material"]: 3,
		["Cleaning"]: 4,
		["Other"]: 5
	};
}));
//#endregion
//#region src/domains/renovation/renovation-inspection.model.ts
var RenovationInspectionState, AcceptanceType, QuestionAnswers;
var init_renovation_inspection_model = __esmMin((() => {
	RenovationInspectionState = /* @__PURE__ */ function(RenovationInspectionState) {
		RenovationInspectionState["NEW"] = "NEW";
		RenovationInspectionState["DONE"] = "DONE";
		return RenovationInspectionState;
	}({});
	AcceptanceType = /* @__PURE__ */ function(AcceptanceType) {
		AcceptanceType["FullAcceptance"] = "FullAcceptance";
		AcceptanceType["PartialAcceptance"] = "PartialAcceptance";
		return AcceptanceType;
	}({});
	QuestionAnswers = /* @__PURE__ */ function(QuestionAnswers) {
		QuestionAnswers["Yes"] = "Yes";
		QuestionAnswers["No"] = "No";
		QuestionAnswers["NA"] = "NA";
		QuestionAnswers["Irrelevant"] = "Irrelevant";
		return QuestionAnswers;
	}({});
}));
//#endregion
//#region src/domains/renovation/renovation-inspection.opts.ts
var init_renovation_inspection_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/renovation/renovation-progress.model.ts
var OverAllRenovationStatus;
var init_renovation_progress_model = __esmMin((() => {
	OverAllRenovationStatus = /* @__PURE__ */ function(OverAllRenovationStatus) {
		OverAllRenovationStatus["Ok"] = "Ok";
		OverAllRenovationStatus["AtRisk"] = "AtRisk";
		OverAllRenovationStatus["Delayed"] = "Delayed";
		return OverAllRenovationStatus;
	}({});
}));
//#endregion
//#region src/domains/renovation/renovation-progress.helpers.ts
var getRenovationProgressSummary;
var init_renovation_progress_helpers = __esmMin((() => {
	getRenovationProgressSummary = (progress) => {
		let daysInProgress = null;
		let daysPlanned = null;
		let daysProjected = null;
		let plannedEndDate = null;
		let projectedEndDate = null;
		let startDate = null;
		let overallStatus = "Ok";
		let lateItem = null;
		if (progress?.length) {
			const firstItem = progress[0];
			const lastItem = progress[progress.length - 1];
			const today = /* @__PURE__ */ new Date();
			startDate = firstItem.startDate;
			projectedEndDate = lastItem.endDate;
			plannedEndDate = lastItem.plannedEndDate;
			daysPlanned = dayjs(plannedEndDate).diff(firstItem.plannedStartDate, "day");
			daysProjected = dayjs(projectedEndDate).diff(startDate, "day");
			if (["InProgress", "Done"].includes(firstItem.status)) daysInProgress = dayjs(today).diff(firstItem.startDate, "day");
			lateItem = progress.find((p) => {
				if (p.endDate && p.status !== "Done" && new Date(p.endDate).getTime() < today.getTime()) return p;
			});
			if (lateItem) overallStatus = "AtRisk";
		}
		return {
			nextMilestone: {},
			daysInProgress,
			daysPlanned,
			daysProjected,
			overallStatus,
			plannedEndDate,
			projectedEndDate,
			startDate,
			lateItem
		};
	};
}));
//#endregion
//#region src/domains/renovation/renovation-progress.opts.ts
var init_renovation_progress_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/renovation/strategy-scenario/renovation-scenario-params.rules.ts
function isExpansionScenario(expansionType) {
	return expansionType !== "NONE";
}
function isEmptyExpansionMonth(month) {
	return month === null || month === 0;
}
/** Rentable-area factor is dictated by the expansion type; non-expansion scenarios have no expansion potential. */
function rentableAreaFactorForExpansionType(expansionType) {
	if (expansionType === "NONE") return 0;
	return RENOVATION_SCENARIO_ROOF_FACTOR[expansionType];
}
/**
* Forces the parameters that the expansion type owns: non-expansion scenarios carry no expansion CAPEX,
* levels, factor or timing, expansion scenarios carry the factor fixed for their roof type.
*/
function applyExpansionTypeRules(params, expansionType) {
	if (!isExpansionScenario(expansionType)) return {
		...params,
		capex: {
			...params.capex,
			expansionPerSqm: 0
		},
		lettableArea: {
			...params.lettableArea,
			expansionLevels: 0,
			rentableAreaFactor: 0,
			startExpansionLetting: 0,
			endExpansionLetting: 0
		},
		delivery: {
			...params.delivery,
			expansionStartMonth: 0,
			expansionEndMonth: 0
		}
	};
	return {
		...params,
		lettableArea: {
			...params.lettableArea,
			rentableAreaFactor: rentableAreaFactorForExpansionType(expansionType)
		}
	};
}
function collectNonExpansionIssues(params, add) {
	if (params.capex.expansionPerSqm !== 0) add("capex.expansionPerSqm", "MUST_BE_ZERO_FOR_NON_EXPANSION", "Expansion CAPEX must be 0 when expansion type is NONE");
	if (params.lettableArea.expansionLevels !== 0) add("lettableArea.expansionLevels", "MUST_BE_ZERO_FOR_NON_EXPANSION", "Expansion levels must be 0 when expansion type is NONE");
	if (params.lettableArea.rentableAreaFactor !== 0) add("lettableArea.rentableAreaFactor", "MUST_BE_ZERO_FOR_NON_EXPANSION", "Rentable area factor must be 0 when expansion type is NONE");
	if (!isEmptyExpansionMonth(params.lettableArea.startExpansionLetting)) add("lettableArea.startExpansionLetting", "MUST_BE_ZERO_FOR_NON_EXPANSION", "Start expansion letting must be 0 when expansion type is NONE");
	if (!isEmptyExpansionMonth(params.lettableArea.endExpansionLetting)) add("lettableArea.endExpansionLetting", "MUST_BE_ZERO_FOR_NON_EXPANSION", "End expansion letting must be 0 when expansion type is NONE");
	if (!isEmptyExpansionMonth(params.delivery.expansionStartMonth)) add("delivery.expansionStartMonth", "MUST_BE_ZERO_FOR_NON_EXPANSION", "Expansion start month must be 0 when expansion type is NONE");
	if (!isEmptyExpansionMonth(params.delivery.expansionEndMonth)) add("delivery.expansionEndMonth", "MUST_BE_ZERO_FOR_NON_EXPANSION", "Expansion end month must be 0 when expansion type is NONE");
}
function collectExpansionIssues(params, expansionType, add) {
	if (params.lettableArea.expansionLevels < 1) add("lettableArea.expansionLevels", "REQUIRED_FOR_EXPANSION", "At least one expansion level is required");
	if (isEmptyExpansionMonth(params.delivery.expansionStartMonth)) add("delivery.expansionStartMonth", "REQUIRED_FOR_EXPANSION", "Expansion start month is required");
	if (isEmptyExpansionMonth(params.delivery.expansionEndMonth)) add("delivery.expansionEndMonth", "REQUIRED_FOR_EXPANSION", "Expansion end month is required");
	if (isEmptyExpansionMonth(params.lettableArea.startExpansionLetting)) add("lettableArea.startExpansionLetting", "REQUIRED_FOR_EXPANSION", "Start expansion letting is required");
	if (isEmptyExpansionMonth(params.lettableArea.endExpansionLetting)) add("lettableArea.endExpansionLetting", "REQUIRED_FOR_EXPANSION", "End expansion letting is required");
	const expected = rentableAreaFactorForExpansionType(expansionType);
	if (params.lettableArea.rentableAreaFactor !== expected) add("lettableArea.rentableAreaFactor", "FACTOR_FIXED_BY_EXPANSION_TYPE", `${expansionType} requires a rentable area factor of ${expected}`);
}
/** Cross-field rules that the JSON schema cannot express. Input must already satisfy {@link ScenarioParamsV1Checker}. */
function collectScenarioParamInvariantIssues(params, expansionType) {
	const issues = [];
	const add = (path, code, message) => issues.push({
		path,
		code,
		message
	});
	if (isExpansionScenario(expansionType)) collectExpansionIssues(params, expansionType, add);
	else collectNonExpansionIssues(params, add);
	const { expansionStartMonth, expansionEndMonth } = params.delivery;
	const { startExpansionLetting, endExpansionLetting } = params.lettableArea;
	const windows = [{
		key: "general",
		start: params.delivery.generalStartMonth,
		end: params.delivery.generalEndMonth
	}, {
		key: "energy",
		start: params.delivery.energyStartMonth,
		end: params.delivery.energyEndMonth
	}];
	if (!isEmptyExpansionMonth(expansionStartMonth) && !isEmptyExpansionMonth(expansionEndMonth)) windows.push({
		key: "expansion",
		start: expansionStartMonth,
		end: expansionEndMonth
	});
	for (const { key, start, end } of windows) if (start !== null && end !== null && end < start) add(`delivery.${key}EndMonth`, "END_BEFORE_START", "End month cannot be before start month");
	if (!isEmptyExpansionMonth(startExpansionLetting) && !isEmptyExpansionMonth(endExpansionLetting) && endExpansionLetting < startExpansionLetting) add("lettableArea.endExpansionLetting", "END_BEFORE_START", "End month cannot be before start month");
	return issues;
}
/**
* Single source of truth for scenario parameter validation, shared by the API and the admin UI:
* JSON schema first, then the expansion-type invariants.
*/
function validateScenarioParams(input, expansionType) {
	if (!ScenarioParamsV1Checker.Check(input)) return {
		issues: ScenarioParamsV1Checker.Errors(input).map((error) => ({
			path: error.path.replace(/^\//, "").replaceAll("/", "."),
			code: "SCHEMA_INVALID",
			message: error.message
		})),
		params: null
	};
	const issues = collectScenarioParamInvariantIssues(input, expansionType);
	return {
		issues,
		params: issues.length > 0 ? null : input
	};
}
var ScenarioParamIssueCode, RENOVATION_SCENARIO_EMPTY_MONTH, RENOVATION_SCENARIO_DEFAULT_START_EXPANSION_LETTING, RENOVATION_SCENARIO_DEFAULT_END_EXPANSION_LETTING, RENOVATION_SCENARIO_ROOF_FACTOR;
var init_renovation_scenario_params_rules = __esmMin((() => {
	init_renovation_scenario_params_model();
	init_renovation_scenario_model();
	ScenarioParamIssueCode = /* @__PURE__ */ function(ScenarioParamIssueCode) {
		ScenarioParamIssueCode["SchemaInvalid"] = "SCHEMA_INVALID";
		ScenarioParamIssueCode["MustBeZeroForNonExpansion"] = "MUST_BE_ZERO_FOR_NON_EXPANSION";
		ScenarioParamIssueCode["RequiredForExpansion"] = "REQUIRED_FOR_EXPANSION";
		ScenarioParamIssueCode["FactorFixedByExpansionType"] = "FACTOR_FIXED_BY_EXPANSION_TYPE";
		ScenarioParamIssueCode["EndBeforeStart"] = "END_BEFORE_START";
		return ScenarioParamIssueCode;
	}({});
	RENOVATION_SCENARIO_EMPTY_MONTH = 0;
	RENOVATION_SCENARIO_DEFAULT_START_EXPANSION_LETTING = 25;
	RENOVATION_SCENARIO_DEFAULT_END_EXPANSION_LETTING = 30;
	RENOVATION_SCENARIO_ROOF_FACTOR = {
		["ROOF_ADDITION"]: .8,
		["ROOF_CONVERSION"]: .66
	};
}));
//#endregion
//#region src/domains/renovation/strategy-scenario/map-renovation-scenario-to-investment-case-inputs.ts
/** Only the Hamburg IFB programmes exist, so every other city is ineligible. */
function isIfbEligibleCity(city) {
	return (city ?? "").trim().toLowerCase() === "hamburg";
}
/** IFB Standard is applied for qualifying cities only; elsewhere the IC input is switched off (SKB-1151 AC5). */
function resolveRenovationScenarioIfbStandard(ifbStandard, city) {
	return isIfbEligibleCity(city) ? ifbStandard : "No IFB";
}
/**
* Expansion quantities a scenario implies for a given footprint. Non-expansion scenarios carry no
* expansion potential at all, so all three values collapse to 0.
*/
function deriveRenovationScenarioExpansionGeometry({ expansionType, lettableArea, footprintAreaSqm, expansionAreaSqm: expansionAreaSqmOverride }) {
	if (!isExpansionScenario(expansionType) || footprintAreaSqm <= 0) return {
		expansionAreaSqm: 0,
		apartmentCount: 0,
		averageExpandedUnitSizeSqm: 0
	};
	const expansionAreaSqm = expansionAreaSqmOverride != null && Number.isFinite(expansionAreaSqmOverride) ? expansionAreaSqmOverride : lettableArea.expansionLevels * lettableArea.rentableAreaFactor * footprintAreaSqm;
	if (expansionAreaSqm <= 0 || lettableArea.targetAvgUnitSizeSqm <= 0) return {
		expansionAreaSqm: 0,
		apartmentCount: 0,
		averageExpandedUnitSizeSqm: 0
	};
	const apartmentCount = Math.max(1, Math.round(expansionAreaSqm / lettableArea.targetAvgUnitSizeSqm));
	return {
		expansionAreaSqm,
		apartmentCount,
		averageExpandedUnitSizeSqm: expansionAreaSqm / apartmentCount
	};
}
/**
* Scenario parameters hold one value per input, so a worst/base/best range is applied flat.
* The configs themselves already carry the average of the source sheet's range (SKB-1151 AC4).
*/
function toFlatRange(value) {
	return {
		worst: value,
		base: value,
		best: value
	};
}
/**
* Layer 2 of a renovation scenario: the inputs a custom CAPEX EE scenario does not map, taken from
* the matching catalogue template (SKB-1283). The catalogue mapper composes this, so a custom scenario
* and its equivalent catalogue scenario write the same values.
*
* Expansion start/end and expansion letting are copied 1:1 from the resolved catalogue config, including
* when that catalogue scenario has no expansion (SKB-1283, PO decision). Omitting them would leave the
* investment case on the global defaults instead of the catalogue values.
*/
function mapRenovationScenarioInheritedInputs({ params, d2gVersion }) {
	return filterMFHInvestmentCaseInputPatchByVersion(buildRenovationScenarioInheritedPatch(params), d2gVersion);
}
function buildRenovationScenarioInheritedPatch(params) {
	return {
		assumptions: {
			shareOfEeCapexAttributableForSubsidies: params.subsidies.shareEeCapexSubsidised,
			shareOfExtensionCapexAttributableForSubsidies: params.subsidies.shareExpansionCapexSubsidised,
			shareOfExtensionCapexAttributableForModLevy: params.subsidies.shareExpansionCapexModLevy,
			shareMaintenanceRenovationCapex: params.subsidies.shareMaintenanceInCapex,
			generalStart: params.delivery.generalStartMonth,
			generalEnd: params.delivery.generalEndMonth,
			energyEfficiencyStart: params.delivery.energyStartMonth,
			energyEfficiencyEnd: params.delivery.energyEndMonth,
			expansionStart: params.delivery.expansionStartMonth,
			expansionEnd: params.delivery.expansionEndMonth,
			startExpansionLetting: params.lettableArea.startExpansionLetting,
			endExpansionLetting: params.lettableArea.endExpansionLetting,
			exitMultipleRunningResiSpace: params.exitMultiples.resiRunning,
			exitMultipleReletResiSpace: params.exitMultiples.resiRelet,
			exitMultipleExpansionSpace: params.exitMultiples.expansion,
			exitMultipleCommercial: params.exitMultiples.commercial,
			exitMultipleParking: params.exitMultiples.parking
		},
		investorAssumptions: { developmentRentLossInPercentageNRI: params.renting.rentLossDuringConstruction }
	};
}
/**
* Maps a pre-defined renovation-strategy scenario config into the MFH investment-case input fields.
*
* Returns only mapped keys that the target `d2gVersion` accepts; callers deep-merge this patch onto case
* inputs and attribute the touched paths to `MFHInvestmentCaseInputOrigin.RenovationStrategyScenario`. The
* field mapping mirrors the one the asset analyzer applies when it builds a case from the same catalog, so
* a screened case and a manually linked case end up with identical inputs.
*
* Version-remapped fields are listed on both sides (`d2gSettings.bafa` for `<5.1.1`, `begEmSubsidies` for
* `>=5.1.1`) and the version filter keeps the live one, so this stays a single mapping across versions.
*/
function mapRenovationScenarioToInvestmentCaseInputs({ params, expansionType, subsidyScheme, city, footprintAreaSqm, d2gVersion }) {
	const isExpansion = isExpansionScenario(expansionType);
	const inherited = buildRenovationScenarioInheritedPatch(params);
	const patch = {
		bestWorst: {
			generalCapexSqm: toFlatRange(params.capex.generalPerSqm),
			renovationCostEnergyEfficiencySqm: toFlatRange(params.capex.energeticPerSqm),
			expansionCostSqm: toFlatRange(isExpansion ? params.capex.expansionPerSqm : 0)
		},
		buildingTechnical: { endEnergyConsumptionClassPostRenovation: params.energy.targetEnergyClass },
		d2gSettings: {
			capex: "Top-Down CAPEX",
			expansion: isExpansion ? "Included" : "Excluded",
			bafa: subsidyScheme === "BAFA" ? "Single Measure Grants" : "OFF",
			begEmSubsidies: params.subsidies.begEmOption,
			kfwStandard: params.subsidies.kfwStandard,
			ifbStandard: resolveRenovationScenarioIfbStandard(params.subsidies.ifbStandard, city)
		},
		assumptions: {
			...inherited.assumptions,
			heatingReplacementCostsPerSqm: params.capex.heatingReplacementPerSqm
		},
		investorAssumptions: { ...inherited.investorAssumptions }
	};
	if (footprintAreaSqm != null && footprintAreaSqm > 0) {
		const geometry = deriveRenovationScenarioExpansionGeometry({
			expansionType,
			lettableArea: params.lettableArea,
			footprintAreaSqm
		});
		patch.overview = { expansionPotentialSqm: geometry.expansionAreaSqm };
		patch.buildingTechnical = {
			...patch.buildingTechnical,
			numberOfApartmentsInHeatedArea: geometry.apartmentCount
		};
		if (geometry.averageExpandedUnitSizeSqm > 0) patch.bestWorst = {
			...patch.bestWorst,
			averageExpandedUnitSize: toFlatRange(geometry.averageExpandedUnitSizeSqm)
		};
	}
	return filterMFHInvestmentCaseInputPatchByVersion(patch, d2gVersion);
}
var init_map_renovation_scenario_to_investment_case_inputs = __esmMin((() => {
	init_mfh_investment_case_base();
	init_mfh_investment_case_input_origins();
	init_renovation_scenario_params_rules();
	init_renovation_scenario_model();
}));
//#endregion
//#region src/domains/renovation/strategy-scenario/renovation-scenario-params.parse.ts
/** The only sanctioned way to turn unknown input into ScenarioParams. */
function parseScenarioParams(input, expansionType) {
	const { issues, params } = validateScenarioParams(input, expansionType);
	if (params === null) throw new ValidationFailedError("invalid scenario parameters", { issues });
	return params;
}
var init_renovation_scenario_params_parse = __esmMin((() => {
	init_cross_cutting();
	init_renovation_scenario_params_rules();
}));
//#endregion
//#region src/domains/renovation/strategy-scenario/renovation-scenario.class.ts
var RenovationScenario;
var init_renovation_scenario_class = __esmMin((() => {
	init_errors();
	RenovationScenario = class {
		renovationScenarioId;
		name;
		description;
		isActive;
		subsidyScheme;
		expansionType;
		energeticMeasureType;
		createdAt;
		createdBy;
		updatedAt;
		updatedBy;
		configs;
		latestConfig;
		constructor(props) {
			Object.assign(this, props);
		}
		getParameters() {
			if (!this.latestConfig) throw new RelationNotPresentOnEntity("latestConfig", "renovationScenario");
			return this.latestConfig.params;
		}
		expansionPotentialSqm(footprintAreaSqm) {
			const { expansionLevels, rentableAreaFactor } = this.getParameters().lettableArea;
			return expansionLevels * rentableAreaFactor * footprintAreaSqm;
		}
		apartmentsInHeatedArea(footprintAreaSqm) {
			const expansionAreaSqm = this.expansionPotentialSqm(footprintAreaSqm);
			if (expansionAreaSqm === 0) return 0;
			return Math.max(1, Math.round(expansionAreaSqm / this.getParameters().lettableArea.targetAvgUnitSizeSqm));
		}
		averageExpandedUnitSizeSqm(footprintAreaSqm) {
			const expansionAreaSqm = this.expansionPotentialSqm(footprintAreaSqm);
			const apartmentCount = this.apartmentsInHeatedArea(footprintAreaSqm);
			if (apartmentCount === 0) return 0;
			return expansionAreaSqm / apartmentCount;
		}
		resolveAgainstFootprint(footprintAreaSqm) {
			return {
				footprintAreaSqm,
				expansionAreaSqm: this.expansionPotentialSqm(footprintAreaSqm),
				apartmentCount: this.apartmentsInHeatedArea(footprintAreaSqm),
				averageExpandedUnitSizeSqm: this.averageExpandedUnitSizeSqm(footprintAreaSqm)
			};
		}
	};
}));
//#endregion
//#region src/domains/renovation/strategy-scenario/renovation-scenario.helpers.ts
function deriveScenarioGroupCode(subsidyScheme, expansionType) {
	if (subsidyScheme === "KFW_261") {
		if (expansionType === "NONE") return "KFW_261_NO_EXPANSION";
		if (expansionType === "ROOF_ADDITION") return "KFW_261_ROOF_ADDITION";
		return "KFW_261_ROOF_CONVERSION";
	}
	if (expansionType === "NONE") return "BAFA_NO_EXPANSION";
	if (expansionType === "ROOF_ADDITION") return "BAFA_ROOF_ADDITION";
	return "BAFA_ROOF_CONVERSION";
}
function groupCodeToClassification(group) {
	for (const subsidyScheme of Object.values(RenovationScenarioSubsidyScheme)) for (const expansionType of Object.values(RenovationScenarioExpansionType)) if (deriveScenarioGroupCode(subsidyScheme, expansionType) === group) return {
		subsidyScheme,
		expansionType
	};
	throw new Error(`Unknown renovation scenario group: ${group}`);
}
/** Recursively sort object keys for stable fingerprinting. */
function canonicalizeJson(value) {
	if (value === null || typeof value !== "object") return value;
	if (Array.isArray(value)) return value.map(canonicalizeJson);
	const entries = Object.entries(value).sort(([a], [b]) => a.localeCompare(b));
	const result = {};
	for (const [key, entryValue] of entries) result[key] = canonicalizeJson(entryValue);
	return result;
}
/** Stable change-detection fingerprint (not a security hash). Browser-safe. */
function fingerprintScenarioParams(params) {
	const canonical = JSON.stringify(canonicalizeJson(params));
	let hash = 2166136261;
	for (let i = 0; i < canonical.length; i++) {
		hash ^= canonical.charCodeAt(i);
		hash = Math.imul(hash, 16777619);
	}
	return (hash >>> 0).toString(16).padStart(8, "0");
}
var init_renovation_scenario_helpers = __esmMin((() => {
	init_renovation_scenario_model();
}));
//#endregion
//#region src/domains/renovation/strategy-scenario/index.ts
var init_strategy_scenario = __esmMin((() => {
	init_map_renovation_scenario_to_investment_case_inputs();
	init_renovation_scenario_params_model();
	init_renovation_scenario_params_parse();
	init_renovation_scenario_params_rules();
	init_renovation_scenario_class();
	init_renovation_scenario_helpers();
	init_renovation_scenario_model();
}));
//#endregion
//#region src/domains/renovation/index.ts
var init_renovation = __esmMin((() => {
	init_catalogue_item_availability_model();
	init_catalogue_item_helpers();
	init_catalogue_item_model();
	init_catalogue_item_opts();
	init_construction_craft_model();
	init_construction_plan_class();
	init_construction_plan_model();
	init_construction_plan_opts();
	init_construction_position_class();
	init_construction_position_model();
	init_construction_position_opts();
	init_construction_progress_model();
	init_construction_progress_opts();
	init_construction_template_model();
	init_construction_base();
	init_contractor_pricing_model();
	init_contractor_helper();
	init_contractor_model();
	init_defect_i18n();
	init_defect_model();
	init_defect_opts();
	init_estate_element_base();
	init_estate_element_helpers();
	init_estate_element_model();
	init_estate_element_opts();
	init_renovation_cost_tracking_helpers();
	init_renovation_cost_tracking_model();
	init_renovation_inspection_model();
	init_renovation_inspection_opts();
	init_renovation_progress_helpers();
	init_renovation_progress_model();
	init_renovation_progress_opts();
	init_strategy_scenario();
}));
//#endregion
//#region src/domains/cross-cutting/notification/notification.model.ts
var NotificationChannel, NotificationTemplateRenderer, NotificationTemplate, NotificationReconcilerRuleName, DefaultNotificationRuleTemplate, getUserDefaultNotificationRules, NotificationTemplateMap;
var init_notification_model = __esmMin((() => {
	init_renovation();
	NotificationChannel = /* @__PURE__ */ function(NotificationChannel) {
		NotificationChannel["Slack"] = "Slack";
		NotificationChannel["Email"] = "Email";
		NotificationChannel["CCS"] = "CCS";
		return NotificationChannel;
	}({});
	NotificationTemplateRenderer = /* @__PURE__ */ function(NotificationTemplateRenderer) {
		NotificationTemplateRenderer["Text"] = "text";
		NotificationTemplateRenderer["Html"] = "html";
		NotificationTemplateRenderer["Markdown"] = "markdown";
		return NotificationTemplateRenderer;
	}({});
	NotificationTemplate = /* @__PURE__ */ function(NotificationTemplate) {
		NotificationTemplate["FindTenants"] = "Find Tenants";
		NotificationTemplate["OwnerManagementStarted"] = "Owner Management Started";
		NotificationTemplate["NoteMention"] = "Note Mention";
		NotificationTemplate["ReviewRequest"] = "Review Request";
		NotificationTemplate["RequestApproved"] = "Request Approved";
		NotificationTemplate["NewTask"] = "New Task";
		NotificationTemplate["EstateSourcingPreApproved"] = "Estate Sourcing Pre-Approved";
		NotificationTemplate["EstateOwnerShareMissing"] = "Estate Owner Share Missing";
		NotificationTemplate["EstateRentPaymentMissing"] = "Estate Rent Payment Missing";
		NotificationTemplate["EstateOwnerShareCalculated"] = "Estate Owner Share Calculated";
		NotificationTemplate["EstateOwnerShareNotCalculated"] = "Estate Owner Share Not Calculated";
		NotificationTemplate["PurchasingCompleted"] = "Purchasing Completed";
		NotificationTemplate["PaymentNoticeReadyForReview"] = "Payment Notice Ready for Review";
		NotificationTemplate["EarliestRentChangeReminder"] = "Earliest Rent Change Reminder";
		NotificationTemplate["DefectCompleted"] = "Defect Completed";
		NotificationTemplate["DefectRejected"] = "Defect Rejected";
		NotificationTemplate["DefectDeadlineExceeded"] = "Defect Deadline Exceeded";
		NotificationTemplate["SupervisorAddedToDefect"] = "Supervisor Added to Defect";
		NotificationTemplate["RentTenancyCreated"] = "Rent Tenancy Created";
		NotificationTemplate["DocumentUploaded"] = "Document Uploaded";
		NotificationTemplate["TenantInformationUpdated"] = "Tenant Information Updated";
		NotificationTemplate["DefectStatusUpdated"] = "Defect Status Updated";
		NotificationTemplate["RenovationProcessesCostOvershot"] = "Renovation Processes Cost Overshot";
		NotificationTemplate["TaskDeadlineExceeded"] = "Task Deadline Exceeded";
		NotificationTemplate["RenovationProcessCompleted"] = "Renovation Process Completed";
		NotificationTemplate["RenovationStateUpdated"] = "Renovation Status Updated";
		NotificationTemplate["SellingStateUpdated"] = "Selling Status Updated";
		NotificationTemplate["PurchasingStateUpdated"] = "Purchasing Status Updated";
		NotificationTemplate["RentingStateUpdated"] = "Renting Status Updated";
		NotificationTemplate["SourcingStateUpdated"] = "Sourcing Status Updated";
		NotificationTemplate["PropertyManagementStateUpdated"] = "Property Management Status Updated";
		NotificationTemplate["OwnerManagementStateUpdated"] = "Owner Status Updated";
		NotificationTemplate["TenantManagementStateUpdated"] = "Tenant Status Updated";
		NotificationTemplate["EstateManagementStateUpdated"] = "Estate Status Updated";
		NotificationTemplate["InvestmentCaseApproved"] = "Investment Case Approved";
		NotificationTemplate["DocumentRequestUpdated"] = "Document Request Updated";
		NotificationTemplate["SellingProcessPaid"] = "Selling Process Paid";
		NotificationTemplate["PropertyManagementDefectCreated"] = "Property Management Defect Created";
		NotificationTemplate["PropertyManagementDefectStatusChanged"] = "Property Management Defect Status Changed";
		NotificationTemplate["PropertyManagementDefectNotesAdded"] = "Property Management Defect Notes Added";
		NotificationTemplate["PropertyManagementDefectFileUploaded"] = "Property Management Defect File Uploaded";
		return NotificationTemplate;
	}({});
	NotificationReconcilerRuleName = /* @__PURE__ */ function(NotificationReconcilerRuleName) {
		NotificationReconcilerRuleName["FindTenants"] = "FindTenants";
		NotificationReconcilerRuleName["OwnerManagementStarted"] = "OwnerManagementStarted";
		NotificationReconcilerRuleName["TaskAssignedToMe"] = "TaskAssignedToMe";
		NotificationReconcilerRuleName["TaggedInAComment"] = "TaggedInAComment";
		NotificationReconcilerRuleName["ReviewRequested"] = "ReviewRequested";
		NotificationReconcilerRuleName["ReviewRequestApproved"] = "ReviewRequestApproved";
		NotificationReconcilerRuleName["EstatePreApproved"] = "EstatePreApproved";
		NotificationReconcilerRuleName["EstateOwnerShareMissing"] = "EstateOwnerShareMissing";
		NotificationReconcilerRuleName["EstateRentPaymentMissing"] = "EstateRentPaymentMissing";
		NotificationReconcilerRuleName["EstateOwnerShareCalculated"] = "EstateOwnerShareCalculated";
		NotificationReconcilerRuleName["EstateOwnerShareNotCalculated"] = "EstateOwnerShareNotCalculated";
		NotificationReconcilerRuleName["PurchasingCompleted"] = "PurchasingCompleted";
		NotificationReconcilerRuleName["PaymentNoticeReadyForReview"] = "PaymentNoticeReadyForReview";
		NotificationReconcilerRuleName["EarliestRentChangeReminder"] = "EarliestRentChangeReminder";
		NotificationReconcilerRuleName["DefectCompleted"] = "DefectCompleted";
		NotificationReconcilerRuleName["DefectRejected"] = "DefectRejected";
		NotificationReconcilerRuleName["DefectDeadlineExceeded"] = "DefectDeadlineExceeded";
		NotificationReconcilerRuleName["SupervisorAddedToDefect"] = "SupervisorAddedToDefect";
		NotificationReconcilerRuleName["RentTenancyCreated"] = "RentTenancyCreated";
		NotificationReconcilerRuleName["DocumentUploaded"] = "DocumentUploaded";
		NotificationReconcilerRuleName["TenantInformationUpdated"] = "TenantInformationUpdated";
		NotificationReconcilerRuleName["DefectStatusUpdated"] = "DefectStatusUpdated";
		NotificationReconcilerRuleName["RenovationProcessesCostOvershot"] = "RenovationProcessesCostOvershot";
		NotificationReconcilerRuleName["TaskDeadlineExceeded"] = "TaskDeadlineExceeded";
		NotificationReconcilerRuleName["RenovationProcessCompleted"] = "RenovationProcessCompleted";
		NotificationReconcilerRuleName["RenovationStateUpdated"] = "RenovationStateUpdated";
		NotificationReconcilerRuleName["SellingStateUpdated"] = "SellingStateUpdated";
		NotificationReconcilerRuleName["PurchasingStateUpdated"] = "Purchasing Status Updated";
		NotificationReconcilerRuleName["RentingStateUpdated"] = "Renting Status Updated";
		NotificationReconcilerRuleName["SourcingStateUpdated"] = "Sourcing Status Updated";
		NotificationReconcilerRuleName["PropertyManagementStateUpdated"] = "Property Management Status Updated";
		NotificationReconcilerRuleName["OwnerManagementStateUpdated"] = "Owner Status Updated";
		NotificationReconcilerRuleName["TenantManagementStateUpdated"] = "Tenant Status Updated";
		NotificationReconcilerRuleName["EstateManagementStateUpdated"] = "Estate Status Updated";
		NotificationReconcilerRuleName["InvestmentCaseApproved"] = "Investment Case Approved";
		NotificationReconcilerRuleName["DocumentRequestUpdated"] = "Document Request Updated";
		NotificationReconcilerRuleName["SellingProcessPaid"] = "SellingProcessPaid";
		NotificationReconcilerRuleName["PropertyManagementDefectCreated"] = "PropertyManagementDefectCreated";
		NotificationReconcilerRuleName["PropertyManagementDefectStatusChanged"] = "PropertyManagementDefectStatusChanged";
		NotificationReconcilerRuleName["PropertyManagementDefectNotesAdded"] = "PropertyManagementDefectNotesAdded";
		NotificationReconcilerRuleName["PropertyManagementDefectFileUploaded"] = "PropertyManagementDefectFileUploaded";
		return NotificationReconcilerRuleName;
	}({});
	DefaultNotificationRuleTemplate = /* @__PURE__ */ function(DefaultNotificationRuleTemplate) {
		DefaultNotificationRuleTemplate["FindTenants"] = "find-tenants";
		DefaultNotificationRuleTemplate["OwnerManagementStarted"] = "owner-management-started";
		DefaultNotificationRuleTemplate["NoteMention"] = "note-mention";
		DefaultNotificationRuleTemplate["ReviewRequest"] = "review-request";
		DefaultNotificationRuleTemplate["RequestApproved"] = "request-approved";
		DefaultNotificationRuleTemplate["NewTask"] = "new-task";
		DefaultNotificationRuleTemplate["EstateRegionSourcingPreApproved"] = "estate-region-sourcing-pre-approved";
		DefaultNotificationRuleTemplate["EstateOwnerShareMissing"] = "estate-owner-share-missing";
		DefaultNotificationRuleTemplate["EstateRentPaymentMissing"] = "estate-rent-payment-missing";
		DefaultNotificationRuleTemplate["EstateOwnerShareCalculated"] = "estate-owner-share-calculated";
		DefaultNotificationRuleTemplate["EstateOwnerShareNotCalculated"] = "estate-owner-share-not-calculated";
		DefaultNotificationRuleTemplate["PurchasingCompleted"] = "purchasing-completed";
		DefaultNotificationRuleTemplate["PaymentNoticeReadyForReview"] = "payment-notice-ready-for-review";
		DefaultNotificationRuleTemplate["EarliestRentChangeReminder"] = "earliest-rent-change-reminder";
		DefaultNotificationRuleTemplate["DefectCompleted"] = "defect-completed";
		DefaultNotificationRuleTemplate["DefectRejected"] = "defect-rejected";
		DefaultNotificationRuleTemplate["DefectDeadlineExceeded"] = "defect-deadline-exceeded";
		DefaultNotificationRuleTemplate["SupervisorAddedToDefect"] = "supervisor-added-to-defect";
		DefaultNotificationRuleTemplate["RentTenancyCreated"] = "rent-tenancy-created";
		DefaultNotificationRuleTemplate["DocumentUploaded"] = "document-uploaded";
		DefaultNotificationRuleTemplate["TenantInformationUpdated"] = "tenant-information-updated";
		DefaultNotificationRuleTemplate["DefectStatusUpdated"] = "defect-status-updated";
		DefaultNotificationRuleTemplate["RenovationProcessesCostOvershot"] = "renovation-processes-cost-overshot";
		DefaultNotificationRuleTemplate["TaskDeadlineExceeded"] = "task-deadline-exceeded";
		DefaultNotificationRuleTemplate["RenovationProcessCompleted"] = "renovation-process-completed";
		DefaultNotificationRuleTemplate["RenovationStateUpdated"] = "renovation-state-updated";
		DefaultNotificationRuleTemplate["SellingStateUpdated"] = "selling-state-updated";
		DefaultNotificationRuleTemplate["PurchasingStateUpdated"] = "purchasing-state-updated";
		DefaultNotificationRuleTemplate["RentingStateUpdated"] = "renting-state-updated";
		DefaultNotificationRuleTemplate["SourcingStateUpdated"] = "sourcing-state-updated";
		DefaultNotificationRuleTemplate["PropertyManagementStateUpdated"] = "property-management-state-updated";
		DefaultNotificationRuleTemplate["OwnerManagementStateUpdated"] = "owner-management-state-updated";
		DefaultNotificationRuleTemplate["TenantManagementStateUpdated"] = "tenant-management-state-updated";
		DefaultNotificationRuleTemplate["EstateManagementStateUpdated"] = "estate-management-state-updated";
		DefaultNotificationRuleTemplate["InvestmentCaseApproved"] = "investment-case-approved";
		DefaultNotificationRuleTemplate["DocumentRequestUpdated"] = "document-request-updated";
		DefaultNotificationRuleTemplate["SellingProcessPaid"] = "selling-process-paid";
		DefaultNotificationRuleTemplate["PropertyManagementDefectCreated"] = "property-management-defect-added";
		DefaultNotificationRuleTemplate["PropertyManagementDefectStatusChanged"] = "property-management-defect-status-changed";
		DefaultNotificationRuleTemplate["PropertyManagementDefectNotesAdded"] = "property-management-defect-notes-added";
		DefaultNotificationRuleTemplate["PropertyManagementDefectFileUploaded"] = "property-management-defect-file-uploaded";
		return DefaultNotificationRuleTemplate;
	}({});
	getUserDefaultNotificationRules = (userContactId) => {
		const regions = [
			"Berlin",
			"Leipzig",
			"Hamburg",
			"Dresden",
			"Bremen",
			"Frankfurt",
			"Köln",
			"Stuttgart",
			"Düsseldorf",
			"Nürnberg",
			"Hannover",
			"München"
		];
		const defectStatuses = Object.values(DefectStatus);
		return [
			{
				templateName: "note-mention",
				tokens: {}
			},
			{
				templateName: "review-request",
				tokens: {}
			},
			{
				templateName: "request-approved",
				tokens: {}
			},
			{
				templateName: "new-task",
				tokens: {}
			},
			...regions.map((region) => ({
				templateName: "estate-region-sourcing-pre-approved",
				tokens: { region }
			})),
			...userContactId ? [...[
				"property-management-defect-added",
				"defect-status-updated",
				"property-management-defect-notes-added"
			].map((templateName) => ({
				templateName,
				tokens: {
					userContactId,
					defectStatuses
				}
			})), {
				templateName: "property-management-defect-file-uploaded",
				tokens: {
					userContactId,
					defectStatuses,
					regions
				}
			}] : []
		];
	};
	NotificationTemplateMap = {
		["owner-management-started"]: {
			title: "Owner Management Process Started",
			description: "Notifies you when an estate owner management process is created in the selected region(s) by someone other than themselves."
		},
		["owner-management-state-updated"]: {
			title: "Owner Management Status Updates",
			description: "Notifies you when an estate owner management process in the selected region(s) is created or updated with specific states they're monitoring."
		},
		["renovation-state-updated"]: {
			title: "Renovation Process Status Updates",
			description: "Notifies you when an estate renovation process in the selected region(s) is created or updated with specific states they're monitoring."
		},
		["renting-state-updated"]: {
			title: "Renting Process Status Updates",
			description: "Notifies you when an estate renting process in the selected region(s) is created or updated with specific states they're monitoring."
		},
		["document-uploaded"]: {
			title: "Document Creation",
			description: "Notifies you when specific document types are created for estates or MFHs in the selected region(s)."
		},
		["document-request-updated"]: {
			title: "Document Request Status Updates",
			description: "Notifies you when document requests for estates in the selected region(s) are created or updated with specific status changes they're monitoring."
		},
		["investment-case-approved"]: {
			title: "Investment Case Approval",
			description: "Notifies you when an estate non-ICT investment case in the selected region(s) gets approved."
		},
		["estate-management-state-updated"]: {
			title: "Estate Management Process Status Updates",
			description: "Notifies you when an estate management process in the selected region(s) is created or updated with specific states they're monitoring."
		},
		["selling-state-updated"]: {
			title: "Selling Process Status Updates",
			description: "Notifies you when an estate selling process in the selected region(s) is created or updated with specific states they're monitoring."
		},
		["sourcing-state-updated"]: {
			title: "Sourcing Process Status Updates",
			description: "Notifies you when an estate sourcing process in the selected region(s) is created or updated with specific states they're monitoring."
		},
		["property-management-state-updated"]: {
			title: "Property Management Process Status Updates",
			description: "Notifies you when an estate property management process in the selected region(s) is created or updated with specific states they're monitoring."
		},
		["estate-region-sourcing-pre-approved"]: {
			title: "Estate Sourcing Pre-approved",
			description: "Notifies you when an estate sourcing process in the selected region(s) is pre-approved."
		},
		["purchasing-state-updated"]: {
			title: "Purchasing Process Status Updates",
			description: "Notifies you when an estate purchasing process in the selected region(s) is created or updated with specific states they're monitoring."
		},
		["tenant-management-state-updated"]: {
			title: "Tenant Management Process Status Updates",
			description: "Notifies you when an estate tenant management process in the selected region(s) is created or updated with specific states they're monitoring."
		},
		["property-management-defect-file-uploaded"]: {
			title: "Property Management Defect File Uploads",
			description: "Notifies you when new files are uploaded to a property management defect they're involved with (as property manager, creator, source, or supervisor), provided the defect is in a monitored status."
		},
		["property-management-defect-notes-added"]: {
			title: "Property Management Defect Note Added",
			description: "Notifies you when notes are added to a property management defect they're involved with (as property manager, creator, source, or supervisor)."
		},
		["purchasing-completed"]: {
			title: "Purchasing Process Completion",
			description: "Notifies you when a purchasing process is completed."
		},
		["renovation-process-completed"]: {
			title: "Renovation Process Completion",
			description: "Notifies you when a renovation process is completed."
		},
		["renovation-processes-cost-overshot"]: {
			title: "Renovation Processes Cost Overshot",
			description: "Notifies you when renovation processes exceed their allowed cost overshoot thresholds, showing the current overshoot percentage versus the allowed limit for each affected estate."
		},
		["rent-tenancy-created"]: {
			title: "Rent Tenancy Creation",
			description: "Notifies you when a new rent tenancy is created by someone other than themselves."
		},
		["request-approved"]: {
			title: "Review Request Approvals",
			description: "Notifies you when a review request they are assigned to gets approved."
		},
		["review-request"]: {
			title: "Review Requests",
			description: "Notifies you when they are assigned to review requests."
		},
		["selling-process-paid"]: {
			title: "Selling Process Payment Completion",
			description: "Notifies you when a selling process is paid."
		},
		["supervisor-added-to-defect"]: {
			title: "Defect Supervisor Assignment",
			description: "Notifies you when they are assigned as supervisor to a defect they didn't create."
		},
		["task-deadline-exceeded"]: {
			title: "Task Deadline Exceeded",
			description: "Notifies you when tasks assigned to selected user(s) have exceeded their deadline."
		},
		["tenant-information-updated"]: {
			title: "Tenant Information Updates",
			description: "Notifies you when tenant information is updated."
		},
		["property-management-defect-added"]: {
			title: "Property Management Defect Creation",
			description: "Notifies you when a property management defect is created that you're involved with (as property manager, creator, source, or supervisor)."
		},
		["defect-deadline-exceeded"]: {
			title: "Defect Deadline Exceeded",
			description: "Notifies you when defects you're involved with (as supervisor or creator) have exceeded their deadline."
		},
		["defect-rejected"]: {
			title: "Defect Rejection",
			description: "Notifies you when a defect you created gets rejected."
		},
		["defect-status-updated"]: {
			title: "Property Management Defect Status Updates",
			description: "Notifies you when property management defects you're involved with (as property manager, creator, source, or supervisor) have their status updated to monitored states."
		},
		["earliest-rent-change-reminder"]: {
			title: "Earliest Rent Change Reminder",
			description: "Notifies you when an estate becomes eligible for rent increases, showing the earliest date when rent can be raised."
		},
		["estate-owner-share-calculated"]: {
			title: "Estate Owner Share Calculated",
			description: "Notifies you when investor ownership share calculations are completed for the selected estate."
		},
		["estate-owner-share-missing"]: {
			title: "Estate Owner Share Missing",
			description: "Notifies you when investor ownership share payments are missing for the selected estate."
		},
		["estate-owner-share-not-calculated"]: {
			title: "Estate Owner Share Not Calculated",
			description: "Notifies you when investor ownership share calculations cannot be completed for the selected estate, showing the reasons why."
		},
		["estate-rent-payment-missing"]: {
			title: "Estate Rent Payment Missing",
			description: "Triggers when a rent payment is missing for a specific estate. Sends a notification using the \"Estate Rent Payment Missing\" template with relevant estate details."
		},
		["find-tenants"]: {
			title: "Find Tenants Task Created",
			description: "Triggers when a \"Find Tenants\" task is created by someone other than the current user. Sends a notification with estate and task details using the \"Find Tenants\" template."
		},
		["new-task"]: {
			title: "Task Assigned to Me",
			description: "Triggers when a new task is assigned directly or as a sub-assignment to the current user"
		},
		["note-mention"]: {
			title: "Tagged in a Comment",
			description: "Triggers when the user is mentioned in a newly created note or comment."
		},
		["payment-notice-ready-for-review"]: {
			title: "Payment Notice Ready for Review",
			description: "Triggers when a payment notice becomes available for review."
		},
		["defect-completed"]: {
			title: "Defect Marked as Completed",
			description: "Triggers when a user marks a defect they created as completed."
		}
	};
}));
//#endregion
//#region src/domains/cross-cutting/notification/notification.opts.ts
var init_notification_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/notification/recipient.model.ts
var init_recipient_model = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/notification/recipient.opts.ts
var init_recipient_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/notification/index.ts
var init_notification = __esmMin((() => {
	init_notification_model();
	init_notification_opts();
	init_recipient_model();
	init_recipient_opts();
}));
//#endregion
//#region src/domains/cross-cutting/personal-info/personal-info.opts.ts
var init_personal_info_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/personal-info/personal-info.model.ts
var init_personal_info_model = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/personal-info/index.ts
var init_personal_info = __esmMin((() => {
	init_personal_info_opts();
	init_personal_info_model();
}));
//#endregion
//#region src/domains/cross-cutting/reconciler-rule/rule.model.ts
var RuleType;
var init_rule_model = __esmMin((() => {
	RuleType = /* @__PURE__ */ function(RuleType) {
		RuleType["Business"] = "Business";
		/** Historical rows only; MFH sourcing now uses `IMfhSourcingCriterion` and nothing evaluates these. */
		RuleType["MfhBusiness"] = "MfhBusiness";
		RuleType["PortfolioBusiness"] = "PortfolioBusiness";
		RuleType["Priority"] = "Priority";
		return RuleType;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/reconciler-rule/rule.opts.ts
var init_rule_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/reconciler-rule/rule.helpers.ts
var evaluateChildRule, evaluateRule, flattenRuleAssignments, evaluateReconcilerRule, evaluateReconcilerRules, serializeRulegroup, serializeAssignments, getFieldValues, getMultipleFieldValues, validateRuleAssignmentsNotOverlapping, dangerouslyMergeRuleAssignments, hasDuplicateKeys, findPropInAnyRule, findPropInRuleGroup;
var init_rule_helpers = __esmMin((() => {
	init_errors();
	evaluateChildRule = (childRule, entity) => {
		if (childRule.operator === "equal") return get(entity, childRule.field) === childRule.value;
		if (childRule.operator === "notequal") return get(entity, childRule.field) !== childRule.value;
		if (childRule.kind === "strict") throw new InvalidRuleError(`Tried to evaluate operator '${childRule.operator}' which is not supported on strict-rule-models for field ${String(childRule.field)}`);
		if (childRule.operator === "nil") return isNil(childRule.value);
		if (childRule.operator === "notnil") return !isNil(childRule.value);
		if (childRule.operator === "startswith" && !isNil(childRule.value)) return String(get(entity, childRule.field)).startsWith(String(childRule.value));
		if (childRule.operator === "endswith" && !isNil(childRule.value)) return String(get(entity, childRule.field)).endsWith(String(childRule.value));
		if (childRule.operator === "contains" && !isNil(childRule.value)) return String(get(entity, childRule.field)).includes(String(childRule.value));
		if (childRule.operator === "notequalfield") return get(entity, childRule.field) !== get(entity, childRule.value);
		if (childRule.operator === "greaterthanorequalfield") return +get(entity, childRule.field) >= +get(entity, childRule.value);
		if (childRule.operator === "greaterthanfield") {
			console.log(`greaterthanfield--------------------------------------------------------------------------------------------------------------------------------------------------------------greaterthanfield`, entity, childRule.field, childRule.value, +get(entity, childRule.field), +get(entity, childRule.value));
			return +get(entity, childRule.field) > +get(entity, childRule.value);
		}
		if (childRule.operator === "rule:truthy") return !!childRule.value;
		if (childRule.operator === "rule:falsy") return !childRule.value;
		if (childRule.operator === "greaterthan" && !isNil(childRule.value)) return +get(entity, childRule.field) > +childRule.value;
		if (childRule.operator === "greaterthanorequal" && !isNil(childRule.value)) return +get(entity, childRule.field) >= +childRule.value;
		if (childRule.operator === "lessthan" && !isNil(childRule.value)) return +get(entity, childRule.field) < +childRule.value;
		if (childRule.operator === "lessthanorequal" && !isNil(childRule.value)) return +get(entity, childRule.field) <= +childRule.value;
		if (childRule.operator === "between" && !isNil(childRule.value)) {
			const val = +get(entity, childRule.field);
			if (!Array.isArray(childRule.value) || !childRule.value.every((v) => typeof v === "number")) throw new InvalidRuleError("Cannot use operator between and then not provide an array of numbers");
			return +childRule.value[0] <= +val && +val <= +childRule.value[1];
		}
		if (childRule.operator === "notbetween" && !isNil(childRule.value)) {
			const val = +get(entity, childRule.field);
			if (!Array.isArray(childRule.value) || !childRule.value.every((v) => typeof v === "number")) throw new InvalidRuleError("Cannot use operator notbetween and then not provide an array of numbers");
			return +val < +childRule.value[0] || +val > +childRule.value[1];
		}
		if (childRule.operator === "in") return Boolean(get(entity, childRule.field)?.includes?.(childRule.value));
		if (childRule.operator === "notin") return Boolean(!get(entity, childRule.field)?.includes?.(childRule.value));
		if (childRule.operator === "in:value") return Boolean(childRule.value?.includes?.(get(entity, childRule.field)));
		if (childRule.operator === "notin:value") return Boolean(!childRule.value?.includes?.(get(entity, childRule.field)));
		if (!childRule.operator) return false;
		throw new InvalidRuleError(`Received rule-operator ${childRule.operator} w/ value ${childRule.value}, cannot evaluate`);
	};
	evaluateRule = (rule, entity, logger) => {
		if (rule.condition === "and") return rule?.rules?.every((childRule) => {
			if (childRule.rules) return evaluateRule(childRule, entity, logger);
			const result = evaluateChildRule(childRule, entity);
			logger?.trace({
				rule: childRule,
				result
			}, "Evaluated rule");
			return result;
		}) ?? false;
		return rule?.rules?.some((childRule) => {
			if (childRule.rules) return evaluateRule(childRule, entity, logger);
			const result = evaluateChildRule(childRule, entity);
			logger?.trace({
				rule: childRule,
				result
			}, "Evaluated rule");
			return result;
		}) ?? false;
	};
	flattenRuleAssignments = (rootRule) => {
		const gatherRuleFields = (rule, result = {}) => {
			if (!rule.rules?.length) {
				if (!rule.field || isNil(rule.value)) return result;
				return {
					...result,
					[rule.field]: uniq([...result[rule.field] ?? [], rule.value])
				};
			}
			let childResult = result;
			rule.rules.forEach((childRule) => {
				childResult = gatherRuleFields(childRule, childResult);
			});
			return childResult;
		};
		return gatherRuleFields(rootRule.ruleGroup);
	};
	evaluateReconcilerRule = (rule, entity, logger) => {
		return evaluateRule(rule.ruleGroup, entity, logger);
	};
	evaluateReconcilerRules = (rules, entity, logger) => {
		return rules.filter((rule) => evaluateReconcilerRule(rule, entity, logger));
	};
	serializeRulegroup = (rule, level = 0) => {
		if (!rule) return "";
		const condition = (rule.condition ?? "and") === "and" ? "&&" : "||";
		const fieldVal = rule.field && !isNil(rule.value) ? `${rule.field}=${rule.value}` : "";
		if (!rule.rules?.length) return fieldVal;
		const base = `${fieldVal?.length ? `${fieldVal} ${condition} ` : ""}${rule.rules.map((subRule) => serializeRulegroup(subRule, level + 1)).filter((g) => g.length > 0).join(` ${condition} `)}`;
		return level > 0 ? `(${base})` : base;
	};
	serializeAssignments = (rule) => {
		if (!rule.assignments) return "";
		return rule.assignments.map((assignment) => {
			const stringifiedValues = Object.entries(assignment.values).map(([k, v]) => `${k}=${v}`).join(",");
			return `<b>${assignment.type}</b> ➡️ ${stringifiedValues}`;
		}).join("<br />");
	};
	getFieldValues = (rule, operator) => {
		if (!rule) return {};
		if (!rule.rules?.length) return rule.field && rule.operator === operator ? { [rule.field]: [rule.value] } : {};
		return rule.rules.map((childRule) => getFieldValues(childRule, operator)).reduce((acc, childResult) => Object.entries(childResult).reduce((innerAcc, [fieldName, fieldValue]) => ({
			...innerAcc,
			[fieldName]: uniq([...innerAcc[fieldName] ?? [], ...fieldValue])
		}), acc), {});
	};
	getMultipleFieldValues = (rules, operator) => {
		if (!rules.length) return {};
		return rules.map((rule) => getFieldValues(rule.ruleGroup, operator)).reduce((acc, fieldValue) => {
			return Object.entries(fieldValue).reduce((innerAcc, [fieldName, fieldValue]) => ({
				...innerAcc,
				[fieldName]: uniq([...innerAcc[fieldName] ?? [], ...fieldValue])
			}), acc);
		}, {});
	};
	validateRuleAssignmentsNotOverlapping = (rules, baseRules, placement) => {
		if (!rules.length) return;
		const allRules = uniqBy(baseRules?.length ? [...baseRules, ...rules] : rules, (rule) => rule.reconcilerRuleId);
		if (allRules.length < 2) return;
		const assignmentMap = /* @__PURE__ */ new Map();
		const overlappingRules = /* @__PURE__ */ new Set();
		const overlappingColValues = {};
		allRules.forEach((rule) => {
			rule.assignments?.forEach((assignment) => {
				Object.entries(assignment.values).forEach(([fieldName, fieldValue]) => {
					const rulesByValue = assignmentMap.get(fieldName) ?? {};
					/**
					* this creates a nested map by the fieldName key which holds for each value a list of
					* rules assigning it,
					* e.g.
					* { category: { Rent: [<rule1>, <rule2>], ReturnDebit: [<rule3>] } }
					* -> an overlap is when there are multiple values per fieldName (category), the overlapping,
					* rules are then the merged result of all fieldValue-rules
					*
					*/
					rulesByValue[String(fieldValue)] = [...rulesByValue[String(fieldValue)] ?? [], rule];
					assignmentMap.set(fieldName, rulesByValue);
				});
			});
		});
		assignmentMap.forEach((rules, fieldName) => {
			const ruleAssignments = Object.values(rules);
			const fieldValues = Object.keys(rules);
			if (ruleAssignments.length > 1) {
				overlappingColValues[fieldName] = uniq([...overlappingColValues[fieldName] ?? [], ...fieldValues]);
				ruleAssignments.flat().forEach((rule) => overlappingRules.add(rule));
			}
		});
		if (overlappingRules.size > 0) throw new ReconcilerRuleOverlappingError(`Cannot have other rules with same ${Object.keys(overlappingColValues).join("/")} assignments`, [...overlappingRules], placement, overlappingColValues);
	};
	dangerouslyMergeRuleAssignments = (rules) => {
		return rules.reduce((acc, rule) => {
			return (rule.assignments ?? []).reduce((innerAcc, assignment) => Object.entries(assignment.values).reduce((innerAcc2, [key, val]) => ({
				...innerAcc2,
				[key]: val
			}), innerAcc), acc);
		}, {});
	};
	hasDuplicateKeys = (rule) => {
		if (!rule) return false;
		const condition = rule.condition ?? "and";
		if (!rule.rules || condition === "or") return false;
		return Object.values(groupBy([rule, ...rule.rules].filter((r) => !!r.field), (subRule) => subRule.field)).some((group) => uniqBy(group, (g) => g.value).length > 1);
	};
	findPropInAnyRule = (ruleGroup, prop, operator) => {
		return findPropInRuleGroup(ruleGroup, prop, operator).concat(...findPropInRuleGroup(ruleGroup, `transaction.${prop}`, operator));
	};
	findPropInRuleGroup = (ruleGroup, prop, operator, acc = []) => {
		if (ruleGroup.field === prop && ruleGroup.operator === operator) return uniq([...acc, ruleGroup.value]).filter(Boolean);
		const nestedRuleProps = ruleGroup.rules?.flatMap((rule) => findPropInRuleGroup(rule, prop, operator, acc)) ?? [];
		return uniq([...acc, ...nestedRuleProps]).filter(Boolean);
	};
}));
//#endregion
//#region src/domains/cross-cutting/state-machine.ts
var GenericEvents, DefectEvents, supplementalDataDefectEvents, EnrichableEvents, ConstructionPlanEvents, StateMachineEvents;
var init_state_machine = __esmMin((() => {
	init_legacy_events();
	init_finance();
	init_mfh();
	init_processes();
	init_estate_management_model();
	init_owner_management_model();
	init_tenant_management_model();
	init_review_process();
	GenericEvents = /* @__PURE__ */ function(GenericEvents) {
		GenericEvents["MinutePassed"] = "MinutePassed";
		GenericEvents["HourPassed"] = "HourPassed";
		GenericEvents["DayPassed"] = "DayPassed";
		return GenericEvents;
	}({});
	DefectEvents = /* @__PURE__ */ function(DefectEvents) {
		DefectEvents["DefectAdded"] = "DefectAdded";
		DefectEvents["DefectUpdated"] = "DefectUpdated";
		DefectEvents["DefectMarkedAsValid"] = "DefectMarkedAsValid";
		DefectEvents["DefectMarkedAsInvalid"] = "DefectMarkedAsInvalid";
		DefectEvents["DefectTransfered"] = "DefectTransfered";
		DefectEvents["DefectProgressStarted"] = "DefectProgressStarted";
		DefectEvents["DefectFixed"] = "DefectFixed";
		DefectEvents["DefectNotStarted"] = "DefectNotStarted";
		DefectEvents["DefectNeedsSubstitution"] = "DefectNeedsSubstitution";
		DefectEvents["DefectReopened"] = "DefectReopened";
		DefectEvents["DefectContractorContacted"] = "DefectContractorContacted";
		DefectEvents["DefectAppointmentScheduled"] = "DefectAppointmentScheduled";
		DefectEvents["DefectFixVerified"] = "DefectFixVerified";
		return DefectEvents;
	}({});
	supplementalDataDefectEvents = [
		"DefectNotStarted",
		"DefectReopened",
		"DefectMarkedAsInvalid",
		"DefectTransfered",
		"DefectNeedsSubstitution",
		"DefectAppointmentScheduled",
		"DefectFixVerified"
	];
	EnrichableEvents = ["SellingOfferAccepted", "NotaryVisited"];
	ConstructionPlanEvents = /* @__PURE__ */ function(ConstructionPlanEvents) {
		ConstructionPlanEvents["SetToConstructionPlanDraft"] = "SetToConstructionPlanDraft";
		ConstructionPlanEvents["ApproveConstructionPlan"] = "ApproveConstructionPlan";
		ConstructionPlanEvents["UnapproveConstructionPlan"] = "UnapproveConstructionPlan";
		ConstructionPlanEvents["RejectConstructionPlan"] = "RejectConstructionPlan";
		ConstructionPlanEvents["CompleteConstructionPlan"] = "CompleteConstructionPlan";
		ConstructionPlanEvents["RestartProgress"] = "RestartProgress";
		ConstructionPlanEvents["UpdateConstructionPlan"] = "UpdateConstructionPlan";
		ConstructionPlanEvents["CreateConstructionPlan"] = "CreateConstructionPlan";
		ConstructionPlanEvents["ActivateConstructionPlan"] = "ActivateConstructionPlan";
		ConstructionPlanEvents["DeactivateConstructionPlan"] = "DeactivateConstructionPlan";
		return ConstructionPlanEvents;
	}({});
	StateMachineEvents = {
		...CondoEvents,
		...PropertyManagementEvents,
		...ConstructionPlanEvents,
		...ReviewProcessEvents,
		...SalesPackageEvents,
		...TenantManagementEvents,
		...OwnerManagementEvents,
		...EstateManagementEvents,
		...MFHEvents,
		...RentableUnitEvents,
		...MFHRenovationProjectCostBreakdownEvent,
		...MFHRenovationProjectPlanningModuleEvents,
		...MFHRenovationProjectEvents
	};
}));
//#endregion
//#region src/domains/cross-cutting/task/task-template.model.ts
var TaskTemplateEntity, TaskExternalTouchpoints, TaskInternalTouchpoints, MFHTaskCreationTrigger, portfolioFinancingTriggers, portfolioPurchasingTriggers, renovationProjectTriggers, taskTriggers, templateMatchesMandate, matchModuleOrLot;
var init_task_template_model = __esmMin((() => {
	init_renting_model();
	init_mfh();
	init_mfh_portfolio_process_base();
	init_mfh_renovation_project_model();
	init_mfh_renovation_project_planning_module_model();
	init_mfh_renovation_project_lot_model();
	init_processes();
	init_rentable_unit_model$1();
	init_user_model();
	TaskTemplateEntity = /* @__PURE__ */ function(TaskTemplateEntity) {
		TaskTemplateEntity["mfh_portfolio"] = "mfh_portfolio";
		TaskTemplateEntity["mfh"] = "mfh";
		TaskTemplateEntity["estate"] = "estate";
		TaskTemplateEntity["planning_module"] = "planning_module";
		TaskTemplateEntity["renovation_project"] = "renovation_project";
		TaskTemplateEntity["renovation_project_lot"] = "renovation_project_lot";
		return TaskTemplateEntity;
	}({});
	TaskExternalTouchpoints = /* @__PURE__ */ function(TaskExternalTouchpoints) {
		TaskExternalTouchpoints["Seller"] = "Seller";
		TaskExternalTouchpoints["Broker"] = "Broker";
		TaskExternalTouchpoints["Investor"] = "Investor";
		TaskExternalTouchpoints["ExternalInvestmentCommittee"] = "ExternalInvestmentCommittee";
		TaskExternalTouchpoints["PlanningOffice"] = "PlanningOffice";
		TaskExternalTouchpoints["EnergyConsultant"] = "EnergyConsultant";
		TaskExternalTouchpoints["LegalAndTaxAdvisor"] = "LegalAndTaxAdvisor";
		TaskExternalTouchpoints["Bank"] = "Bank";
		TaskExternalTouchpoints["BuildingAuthorities"] = "BuildingAuthorities";
		TaskExternalTouchpoints["Syte"] = "Syte";
		TaskExternalTouchpoints["BuildingMeasurer"] = "BuildingMeasurer";
		TaskExternalTouchpoints["PubliclyAppointedMeasurer"] = "PubliclyAppointedMeasurer";
		TaskExternalTouchpoints["StructuralEngineer"] = "StructuralEngineer";
		TaskExternalTouchpoints["TechnicalBuildingServicesEngineer"] = "TechnicalBuildingServicesEngineer";
		TaskExternalTouchpoints["FireProtectionSpecialist"] = "FireProtectionSpecialist";
		TaskExternalTouchpoints["PollutantSpecialistEngineer"] = "PollutantSpecialistEngineer";
		TaskExternalTouchpoints["BuildingPhysicsSpecialist"] = "BuildingPhysicsSpecialist";
		TaskExternalTouchpoints["BuildingDiagnostician"] = "BuildingDiagnostician";
		TaskExternalTouchpoints["GeneralPlanner"] = "GeneralPlanner";
		TaskExternalTouchpoints["DesignAndBuildContractor"] = "DesignAndBuildContractor";
		TaskExternalTouchpoints["ArchitecturalObjectPlanner"] = "ArchitecturalObjectPlanner";
		TaskExternalTouchpoints["SpecialistEngineers"] = "SpecialistEngineers";
		TaskExternalTouchpoints["PropertyManagement"] = "PropertyManagement";
		TaskExternalTouchpoints["FacilityManagement"] = "FacilityManagement";
		TaskExternalTouchpoints["Tenant"] = "Tenant";
		return TaskExternalTouchpoints;
	}({});
	TaskInternalTouchpoints = [
		"TLRenovation",
		"PLRenovation",
		"RenovationPlanner",
		"RentingManager",
		"FinanceManager",
		"ManagingDirector",
		"Accountant",
		"DealCaptain",
		"InvestmentManager",
		"AssetManager",
		"AssetManagementBackoffice",
		"InternalInvestmentCommittee",
		"EnergyConsultant",
		"TechnicalProjectLead",
		"Planner"
	];
	MFHTaskCreationTrigger = `MFHSourcing.Screening`;
	portfolioFinancingTriggers = Object.values(MFHPortfolioFinancingState).map((state) => {
		return {
			processType: "MFHPortfolioFinancing",
			processState: state,
			trigger: `MFHPortfolioFinancing.${state}`
		};
	});
	portfolioPurchasingTriggers = Object.values(MFHPortfolioPurchasingState).map((state) => {
		return {
			processType: "MFHPortfolioPurchasing",
			processState: state,
			trigger: `MFHPortfolioPurchasing.${state}`
		};
	});
	renovationProjectTriggers = Object.values(MfhRenovationProjectState).map((state) => {
		return {
			processType: "MFHRenovationProject",
			processState: state,
			trigger: `MFHRenovationProject.${state}`
		};
	});
	taskTriggers = [
		...portfolioFinancingTriggers.map((trigger) => trigger.trigger),
		...portfolioPurchasingTriggers.map((trigger) => trigger.trigger),
		...Object.values(MFHProcessState).map((state) => `MFHSourcing.${state}`),
		...Object.values(MFHSubsidyFinancingState).map((state) => `MFHSubsidyFinancing.${state}`),
		...Object.values(MFHEstateManagementState).map((state) => `MFHEstateManagement.${state}`),
		...Object.values(SourcingStates).map((state) => `Sourcing.${state}`),
		...Object.values(PurchasingState).map((state) => `Purchasing.${state}`),
		...Object.values(RenovationStates).map((state) => `Renovation.${state}`),
		...Object.values(RentingStates).map((state) => `Renting.${state}`),
		...Object.values(SellingStates).map((state) => `Selling.${state}`),
		...Object.values(PropertyManagementStates).map((state) => `PropertyManagement.${state}`),
		...Object.values(EstateManagementStates).map((state) => `EstateManagement.${state}`),
		...Object.values(OwnerManagementStates).map((state) => `OwnerManagement.${state}`),
		...Object.values(TenantManagementStates).map((state) => `TenantManagement.${state}`),
		...Object.values(RentableUnitStates).map((state) => `RentableUnit.${state}`),
		...renovationProjectTriggers.map((trigger) => trigger.trigger),
		...Object.values(MFHRenovationProjectPlanningModuleStatus).map((state) => `PlanningModule.${state}`),
		...Object.values(MfhRenovationProjectLotState).map((state) => `MfhRenovationProjectLot.${state}`)
	];
	templateMatchesMandate = (template, mandateType) => {
		if (!mandateType) return false;
		return (template.mandateTypes ?? []).includes(mandateType);
	};
	matchModuleOrLot = (taskOrTemplate, moduleOrLot) => {
		let planningSetups = [];
		let measuresPackages = [];
		if ("planningSetups" in taskOrTemplate) {
			planningSetups = taskOrTemplate.planningSetups ?? [];
			measuresPackages = taskOrTemplate.measuresPackages ?? [];
		} else if ("taskPlanningSetups" in taskOrTemplate) {
			planningSetups = taskOrTemplate.taskPlanningSetups ?? [];
			measuresPackages = taskOrTemplate.taskMeasuresPackages ?? [];
		}
		if (!planningSetups.length || !measuresPackages.length) return false;
		const hasMatchingMeasurePackage = intersection(measuresPackages, moduleOrLot.measuresPackages ?? []).length > 0;
		const hasMatchingPlanningSetup = !!moduleOrLot.mfhRenovationProjectPlanningSetup && planningSetups.includes(moduleOrLot.mfhRenovationProjectPlanningSetup);
		return hasMatchingMeasurePackage && hasMatchingPlanningSetup;
	};
}));
//#endregion
//#region src/domains/cross-cutting/task/task.helpers.ts
var processTypesForEntity, processStatesForEntity, isGeneralEnergeticOrCapex, getMFHTaskMilestoneRecords, getMFHHierarchySequenceRecords, matchesCustomIdPrefix, sortTasksByCustomId, insertTasksAfter, toMFHMilestoneRow, taskToMilestoneExpectedDate, taskToMilestoneStatus, gatherMFHTasks, gatherTasksByMeasurePackage, gatherMilestones, automaticTaskProgressAssessment, getExpectedProgressStatus, createHierarchyNode, groupTasksByActivityGroup, getMFHHierarchy, gatherTasksForPrefixes, hierarchyToSequenceRecords;
var init_task_helpers = __esmMin((() => {
	init_mfh();
	init_mfh_process_base();
	init_mfh_portfolio_process_base();
	init_process_base();
	init_process_model();
	init_task_template_model();
	init_task_i18n();
	init_task_model();
	processTypesForEntity = (entity) => {
		let processTypes = {};
		switch (entity) {
			case "estate":
				processTypes = ProcessType;
				break;
			case "mfh":
				processTypes = MFHProcessType;
				break;
			case "mfh_portfolio":
				processTypes = MFHPortfolioProcessType;
				break;
			case "planning_module":
				processTypes = MFHRenovationProjectPlanningModuleProcessType;
				break;
			case "renovation_project":
				processTypes = MFHRenovationProjectProcessType;
				break;
			case "renovation_project_lot":
				processTypes = MfhRenovationProjectLotProcessType;
				break;
			default: throw new Error(`[Process Types] Missing implementation for task entity type ${entity}`);
		}
		return processTypes;
	};
	processStatesForEntity = (entity) => {
		switch (entity) {
			case "estate": return ProcessStateMapping;
			case "mfh": return MFHProcessStateMapping;
			case "mfh_portfolio": return MFHPortfolioProcessStateMapping;
			case "planning_module": return MFHRenovationProjectPlanningModuleProcessStateMapping;
			case "renovation_project": return MFHRenovationProjectProcessStateMapping;
			case "renovation_project_lot": return MfhRenovationProjectLotProcessStateMapping;
			default: throw new Error(`[Process States] Missing implementation for task entity type ${entity}`);
		}
	};
	isGeneralEnergeticOrCapex = (measuresPackages) => {
		return (measuresPackages?.includes("GeneralEnergetic") || measuresPackages?.includes("GeneralCapex")) ?? false;
	};
	getMFHTaskMilestoneRecords = (mfh, opts) => {
		const renovationProject = maxBy(mfh.renovationProjects, "mfhRenovationProjectId");
		const allTasks = gatherMFHTasks(mfh, renovationProject);
		const planningModules = (renovationProject?.mfhRenovationProjectPlanningModules ?? []).filter((pm) => !!pm.mfhRenovationProjectPlanningSetup);
		const lots = (renovationProject?.mfhRenovationProjectLots ?? []).filter((lot) => !!lot.mfhRenovationProjectPlanningSetup);
		const [designAndBuildModules, generalPlanningModules] = partition(planningModules, (pm) => ["NewDesignBuildContractor", "OldDesignBuildContractor"].includes(pm.mfhRenovationProjectPlanningSetup));
		const [designAndBuildLots, generalPlanningLots] = partition(lots, (lot) => ["NewDesignBuildContractor", "OldDesignBuildContractor"].includes(lot.mfhRenovationProjectPlanningSetup));
		const tasksByMileStone = groupBy(allTasks, "milestone");
		const taskMilestoneConfiguration = [
			{
				phase: "Acquisition",
				stages: [
					{
						stage: "Opportunity Assessment",
						rows: () => {
							const milestones = [
								"DataInput",
								"ConfirmedPotential",
								"PreApproval",
								"ExclusivityAgreement"
							];
							const overridables = {
								phase: "Acquisition",
								stage: "Opportunity Assessment"
							};
							return milestones.flatMap((milestone) => tasksByMileStone[milestone] ?? []).map((t) => toMFHMilestoneRow(t, overridables));
						}
					},
					{
						stage: "Due diligence",
						rows: () => {
							const milestones = [
								"DueDiligence",
								"EnergyAssessment",
								"SubsidyApplication",
								"SubsidyApproval",
								"FinancingAgreement",
								"TransactionSigning"
							];
							const overridables = {
								phase: "Acquisition",
								stage: "Due diligence"
							};
							return milestones.flatMap((milestone) => tasksByMileStone[milestone] ?? []).map((t) => toMFHMilestoneRow(t, overridables));
						}
					},
					{
						stage: "Transaction",
						rows: () => {
							const milestones = ["BIMModel", "TransactionClosing"];
							const overridables = {
								phase: "Acquisition",
								stage: "Transaction"
							};
							return milestones.flatMap((milestone) => tasksByMileStone[milestone] ?? []).map((t) => toMFHMilestoneRow(t, overridables));
						}
					}
				]
			},
			{
				phase: "Value-add",
				stages: [{
					stage: "Planning",
					rows: () => {
						const res = [];
						const designAndBuildContractorMilestones = [
							"FullFeasibilityStudyRoofConversionAndVerticalExpansion",
							"FullFeasibilityStudySeparateNewBuilding",
							"TargetScopeProjectGoals",
							"TechnicalSpecificationFLB",
							"RFQ",
							"ContractAward",
							"SpecialistPlannersCommission",
							"ModernizationNotice",
							"PermitApplication",
							"PermitApproval",
							"TechnicalDrawings"
						];
						const generalPlanningMilestones = [
							"FullFeasibilityStudyRoofConversionAndVerticalExpansion",
							"FullFeasibilityStudySeparateNewBuilding",
							"TargetScopeProjectGoals",
							"SpecialistPlannersCommission",
							"CostEstimateDIN276",
							"CostCalculationDIN276",
							"PermitApplication",
							"PermitApproval",
							"TechnicalDrawings",
							"TechnicalSpecificationLVFLB"
						];
						const assetModernizationNoticeTasks = (mfh.tasks ?? []).filter((t) => t.milestone === "ModernizationNotice");
						for (const pm of designAndBuildModules) {
							const tasks = pm.tasks ?? [];
							if (assetModernizationNoticeTasks.length && isGeneralEnergeticOrCapex(pm.measuresPackages)) tasks.push(...assetModernizationNoticeTasks);
							const overridables = {
								phase: "Value-add",
								stage: "Planning",
								measurePackage: `${pm.name ?? null}`
							};
							const pmTasks = gatherMilestones(tasks, designAndBuildContractorMilestones, overridables);
							if (pmTasks.length) pmTasks[0].measurePackageLabel = `${pm.name ?? null}`;
							res.push(...pmTasks);
						}
						for (const pm of generalPlanningModules) {
							const tasks = pm.tasks ?? [];
							const overridables = {
								phase: "Value-add",
								stage: "Planning",
								measurePackage: `${pm.name ?? null}`
							};
							const pmTasks = gatherMilestones(tasks, generalPlanningMilestones, overridables);
							if (pmTasks.length) pmTasks[0].measurePackageLabel = `${pm.name ?? null}`;
							res.push(...pmTasks);
						}
						const lotMeasurePackageMilestones = [
							"RFQ",
							"ContractAward",
							"ModernizationNotice"
						];
						for (let i = 0; i < generalPlanningLots.length; i++) {
							const lot = generalPlanningLots[i];
							const tasks = lot.tasks ?? [];
							if (assetModernizationNoticeTasks.length && isGeneralEnergeticOrCapex(lot.measuresPackages)) tasks.push(...assetModernizationNoticeTasks);
							const overridables = {
								phase: "Value-add",
								stage: "Planning",
								measurePackage: `${lot.name ?? null}`
							};
							const lotTasks = gatherMilestones(tasks, lotMeasurePackageMilestones, overridables);
							if (lotTasks.length) lotTasks[0].measurePackageLabel = `${lot.name ?? null}`;
							res.push(...lotTasks);
						}
						return res;
					}
				}, {
					stage: "Construction",
					rows: () => {
						const res = [];
						const lotMilestones1 = ["ConstructionStart", "ScaffoldingConstruction"];
						const lotMeasurePackageMilestones = {
							["GeneralEnergetic"]: [
								"RiserReplacement",
								"FacadeInsulation",
								"Windows",
								"Heating",
								"Balconies",
								"CellarCeilingInsulation",
								"RoofInsulation",
								"TotalEnergeticModernization"
							],
							["RoofConversion"]: [
								"BuildingExterior",
								"BuildingInterior",
								"TotalRoofConversion"
							],
							["VerticalExpansion"]: [
								"RoofDemolition",
								"StructuralReinforcement",
								"BuildingExterior",
								"BuildingInterior",
								"TotalVerticalExpansion"
							],
							["SeparateNewBuilding"]: [
								"BuildingExterior",
								"BuildingInterior",
								"TotalSeparateNewConstruction"
							]
						};
						const lotMilestones2 = ["FinalInspection", "FinalCostStatementDIN276"];
						for (const lot of [...generalPlanningLots, ...designAndBuildLots]) {
							const lotTasks = [];
							const tasks = lot.tasks ?? [];
							const overridables = {
								phase: "Value-add",
								stage: "Construction",
								measurePackage: `${lot.name ?? null}`
							};
							const lotTasks1 = gatherMilestones(tasks, lotMilestones1, overridables);
							lotTasks.push(...lotTasks1);
							const tasksByMeasurePackage = gatherTasksByMeasurePackage(tasks);
							for (const [mp, milestones] of Object.entries(lotMeasurePackageMilestones)) {
								const mpTasks = gatherMilestones(tasksByMeasurePackage[mp], milestones, overridables);
								if (mpTasks.length) mpTasks[0].measurePackageLabel = toTitleCase(mp);
								lotTasks.push(...mpTasks);
							}
							const lotTasks2 = gatherMilestones(tasks, lotMilestones2, overridables);
							lotTasks.push(...lotTasks2);
							if (lotTasks.length) lotTasks[0].measurePackageLabel = lotTasks[0].measurePackageLabel ? `${lot.name ?? null} ${lotTasks[0].measurePackageLabel}` : `${lot.name ?? null}`;
							res.push(...lotTasks);
						}
						return res;
					}
				}]
			},
			{
				phase: "Stabilization",
				stages: [{
					stage: "Stabilization",
					rows: () => {
						const milestones = ["ModernizationLevy", "SubsidyPayout"];
						const overridables = {
							phase: "Stabilization",
							stage: "Stabilization"
						};
						return milestones.flatMap((milestone) => tasksByMileStone[milestone] ?? []).map((t) => toMFHMilestoneRow(t, overridables));
					}
				}]
			}
		];
		const results = [];
		let order = 0;
		let allTasksById = {};
		if (opts?.includeSourceTask) allTasksById = groupBy(allTasks, "taskId");
		for (const phaseConfig of taskMilestoneConfiguration) {
			let isFirstRowInPhase = true;
			for (const stageConfig of phaseConfig.stages) {
				const rows = stageConfig.rows();
				for (let idx = 0; idx < rows.length; idx++) {
					const row = rows[idx];
					const shouldShowPhase = idx === 0 && isFirstRowInPhase;
					const shouldShowStage = idx === 0;
					results.push({
						...row,
						mfhId: mfh.mfhId,
						order: order++,
						...shouldShowStage && {
							...shouldShowPhase && { phaseLabel: phaseConfig.phase },
							stageLabel: stageConfig.stage
						},
						...opts?.includeSourceTask && row.taskId ? { task: allTasksById[row.taskId]?.[0] } : {}
					});
					if (shouldShowPhase) isFirstRowInPhase = false;
				}
			}
		}
		return results;
	};
	getMFHHierarchySequenceRecords = (mfh, opts) => {
		const hierarchy = getMFHHierarchy(mfh);
		return hierarchyToSequenceRecords(hierarchy, mfh.mfhId, opts);
	};
	matchesCustomIdPrefix = (taskCustomId, prefix) => {
		return taskCustomId.trim().toUpperCase().startsWith(prefix.toUpperCase());
	};
	sortTasksByCustomId = (tasks) => {
		return tasks.toSorted((a, b) => {
			if (!a.customId) return 1;
			if (!b.customId) return -1;
			return a.customId.localeCompare(b.customId, void 0, {
				numeric: true,
				sensitivity: "base"
			});
		});
	};
	insertTasksAfter = (tasks, tasksToInsert, afterCustomId) => {
		if (tasksToInsert.length === 0) return tasks;
		const result = [...tasks];
		const index = result.findLastIndex((t) => t.customId?.trim().startsWith(afterCustomId));
		if (index !== -1) result.splice(index + 1, 0, ...tasksToInsert);
		return result;
	};
	toMFHMilestoneRow = (task, overrides) => {
		return {
			taskId: task.taskId,
			taskCustomId: task.customId ?? null,
			milestone: task.milestone,
			milestoneEnglishLabel: TaskMilestoneEnglish[task.milestone],
			milestoneGermanLabel: TaskMilestoneGerman[task.milestone],
			status: task.milestoneStatus,
			progressStatus: task.milestoneProgressStatus ?? null,
			recentProgress: task.milestoneRecentProgress || null,
			nextSteps: task.milestoneNextSteps || null,
			dueDate: task.milestoneDueDate,
			expectedDate: task.milestoneExpectedDate ?? null,
			isSharedWithAssetPartner: task.isSharedWithAssetPartner ?? null,
			...overrides
		};
	};
	taskToMilestoneExpectedDate = (task) => {
		const isCompleted = task.status === "Completed";
		let completedDate = null;
		if (isCompleted && task.statusUpdatedAt) {
			const d = task.statusUpdatedAt["Completed"];
			completedDate = d ? d : null;
		}
		return completedDate ?? task.expectedDate ?? task.dueDate ?? null;
	};
	taskToMilestoneStatus = (status) => {
		switch (status) {
			case "Opened": return "NotStarted";
			case "Planned": return "NotStarted";
			case "WaitingForInput": return "InProgress";
			case "InProgress": return "InProgress";
			case "AwaitingApproval": return "InProgress";
			case "OnHold": return "InProgress";
			case "Stopped": return "InProgress";
			case "NotRequired": return "NotRequired";
			case "Completed": return "Completed";
			default: throw new Error(`[Task Status] Missing implementation for task status ${status}`);
		}
	};
	gatherMFHTasks = (mfh, renovationProject) => {
		const tasks = [];
		tasks.push(...mfh.tasks ?? []);
		mfh.candidateMfhPortfolios?.forEach((candidateMfhPortfolio) => {
			tasks.push(...candidateMfhPortfolio.tasks ?? []);
		});
		if (renovationProject) {
			tasks.push(...renovationProject?.tasks ?? []);
			tasks.push(...renovationProject?.mfhRenovationProjectPlanningModules?.flatMap((pm) => pm.tasks ?? []) ?? []);
			tasks.push(...renovationProject?.mfhRenovationProjectLots?.flatMap((lot) => lot.tasks ?? []) ?? []);
		}
		return tasks;
	};
	gatherTasksByMeasurePackage = (tasks) => {
		return tasks.reduce((acc, task) => {
			for (const mp of task.measuresPackages ?? []) acc[mp].push(task);
			return acc;
		}, {
			["GeneralEnergetic"]: [],
			["GeneralCapex"]: [],
			["RoofConversion"]: [],
			["VerticalExpansion"]: [],
			["SeparateNewBuilding"]: [],
			["VacantApartmentRenovation"]: []
		});
	};
	gatherMilestones = (tasks, milestones, overridables) => {
		if (!tasks.length) return [];
		const result = [];
		const tasksByMilestone = groupBy(tasks, "milestone");
		for (const milestone of milestones) {
			const milestoneTasks = tasksByMilestone[milestone];
			if (milestoneTasks) for (const task of milestoneTasks) result.push(toMFHMilestoneRow(task, overridables));
		}
		return result;
	};
	automaticTaskProgressAssessment = (task) => {
		if (task.status === "Completed") return "OnTrack";
		if (!task.dueDate) return null;
		if (dayjs().isAfter(dayjs(task.dueDate))) return "OffTrack";
		return "OnTrack";
	};
	getExpectedProgressStatus = (task) => {
		if (!task) return null;
		const automaticProgressStatus = automaticTaskProgressAssessment(task);
		if (automaticProgressStatus === "OnTrack") return "OnTrack";
		if (task.progressStatus === "OffTrack" || task.progressStatus === "Delayed") return task.progressStatus;
		if (automaticProgressStatus) return automaticProgressStatus;
		return task.progressStatus;
	};
	createHierarchyNode = (id, type, name, children = [], tasks = []) => ({
		id,
		type,
		name,
		children,
		tasks
	});
	groupTasksByActivityGroup = (tasks, parentId) => {
		const tasksByActivityGroup = groupBy(tasks, (t) => t.activityGroup ?? "Other");
		const activityGroups = [];
		for (const [activityGroup, groupTasks] of Object.entries(tasksByActivityGroup)) {
			const sortedTasks = sortTasksByCustomId(groupTasks);
			activityGroups.push(createHierarchyNode(`${parentId}-ag-${activityGroup}`, "activityGroup", activityGroup, [], sortedTasks));
		}
		return activityGroups;
	};
	getMFHHierarchy = (mfh) => {
		const renovationProject = maxBy(mfh.renovationProjects, "mfhRenovationProjectId");
		const allTasks = gatherMFHTasks(mfh, renovationProject);
		const planningModules = (renovationProject?.mfhRenovationProjectPlanningModules ?? []).filter((pm) => !!pm.mfhRenovationProjectPlanningSetup);
		const lots = (renovationProject?.mfhRenovationProjectLots ?? []).filter((lot) => !!lot.mfhRenovationProjectPlanningSetup);
		const [designAndBuildModules, generalPlanningModules] = partition(planningModules, (pm) => ["NewDesignBuildContractor", "OldDesignBuildContractor"].includes(pm.mfhRenovationProjectPlanningSetup));
		const [designAndBuildLots, generalPlanningLots] = partition(lots, (lot) => ["NewDesignBuildContractor", "OldDesignBuildContractor"].includes(lot.mfhRenovationProjectPlanningSetup));
		let assetModernizationNoticeTasks = (mfh.tasks ?? []).filter((t) => t.customId?.trim().startsWith("AM 2.4"));
		assetModernizationNoticeTasks = sortTasksByCustomId(assetModernizationNoticeTasks);
		const phases = [];
		const acquisitionStages = [];
		const opportunityAssessmentTasks = gatherTasksForPrefixes(allTasks, [
			"IM 1.1",
			"IM 1.2",
			"IM 1.3",
			"IM 1.4"
		]);
		if (opportunityAssessmentTasks.length > 0) {
			const activityGroups = groupTasksByActivityGroup(opportunityAssessmentTasks, "acquisition-opportunity");
			acquisitionStages.push(createHierarchyNode("acquisition-opportunity", "stage", "Opportunity Assessment", activityGroups));
		}
		const dueDiligenceTasks = gatherTasksForPrefixes(allTasks, [
			"IM 2.5",
			"IM 2.6",
			"IM 2.7",
			"CON 1.1",
			"CON 1.2",
			"CON 1.3",
			"CON 1.4",
			"FI 1.1",
			"FI 1.2",
			"FI 1.3",
			"FI 1.4",
			"FI 1.5"
		]);
		if (dueDiligenceTasks.length > 0) {
			const activityGroups = groupTasksByActivityGroup(dueDiligenceTasks, "acquisition-duediligence");
			acquisitionStages.push(createHierarchyNode("acquisition-duediligence", "stage", "Due Diligence", activityGroups));
		}
		const transactionTasks = gatherTasksForPrefixes(allTasks, [
			"IM 3.8",
			"AM 1.1",
			"AM 1.2",
			"CON 2.5",
			"CON 2.6",
			"FI 2.6",
			"FI 2.7"
		]);
		if (transactionTasks.length > 0) {
			const activityGroups = groupTasksByActivityGroup(transactionTasks, "acquisition-transaction");
			acquisitionStages.push(createHierarchyNode("acquisition-transaction", "stage", "Transaction", activityGroups));
		}
		if (acquisitionStages.length > 0) phases.push(createHierarchyNode("acquisition", "phase", "Acquisition", acquisitionStages));
		const valueAddStages = [];
		const planningMeasurePackages = [];
		const onboardingTasks = allTasks.filter((t) => t.customId?.trim().startsWith("AM 2.3"));
		if (onboardingTasks.length > 0) {
			const activityGroups = groupTasksByActivityGroup(onboardingTasks, "valueadd-planning-onboarding");
			planningMeasurePackages.push(createHierarchyNode("valueadd-planning-onboarding", "measurePackage", "Onboarding", activityGroups));
		}
		for (const pm of designAndBuildModules) {
			const pmTasks = (pm.tasks ?? []).filter((t) => t.customId && matchesCustomIdPrefix(t.customId, "CON 3."));
			if (pmTasks.length === 0) continue;
			const sortedTasks = sortTasksByCustomId(pmTasks);
			const tasksWithAM24 = insertTasksAfter(sortedTasks, assetModernizationNoticeTasks, "CON 3.13");
			const pmId = `valueadd-planning-pm-${pm.mfhRenovationProjectPlanningModuleId}`;
			const activityGroups = groupTasksByActivityGroup(tasksWithAM24, pmId);
			planningMeasurePackages.push(createHierarchyNode(pmId, "measurePackage", pm.name ?? "Planning Module", activityGroups));
		}
		for (const pm of generalPlanningModules) {
			const pmTasks = (pm.tasks ?? []).filter((t) => t.customId && matchesCustomIdPrefix(t.customId, "CON 3."));
			if (pmTasks.length === 0) continue;
			const sortedTasks = sortTasksByCustomId(pmTasks);
			const pmId = `valueadd-planning-pm-${pm.mfhRenovationProjectPlanningModuleId}`;
			const activityGroups = groupTasksByActivityGroup(sortedTasks, pmId);
			planningMeasurePackages.push(createHierarchyNode(pmId, "measurePackage", pm.name ?? "Planning Module", activityGroups));
		}
		for (const lot of generalPlanningLots) {
			const lotTasks = (lot.tasks ?? []).filter((t) => t.customId && matchesCustomIdPrefix(t.customId, "CON 3."));
			if (lotTasks.length === 0) continue;
			const sortedTasks = sortTasksByCustomId(lotTasks);
			const tasksWithAM24 = insertTasksAfter(sortedTasks, assetModernizationNoticeTasks, "CON 3.21");
			const lotId = `valueadd-planning-lot-${lot.mfhRenovationProjectLotId}`;
			const activityGroups = groupTasksByActivityGroup(tasksWithAM24, lotId);
			planningMeasurePackages.push(createHierarchyNode(lotId, "measurePackage", lot.name ?? "Lot", activityGroups));
		}
		if (planningMeasurePackages.length > 0) valueAddStages.push(createHierarchyNode("valueadd-planning", "stage", "Planning", planningMeasurePackages));
		const constructionMeasurePackages = [];
		for (const lot of [...generalPlanningLots, ...designAndBuildLots]) {
			const lotTasks = (lot.tasks ?? []).filter((t) => t.customId && matchesCustomIdPrefix(t.customId, "CON 4."));
			if (lotTasks.length === 0) continue;
			const sortedTasks = sortTasksByCustomId(lotTasks);
			const lotId = `valueadd-construction-lot-${lot.mfhRenovationProjectLotId}`;
			const activityGroups = groupTasksByActivityGroup(sortedTasks, lotId);
			constructionMeasurePackages.push(createHierarchyNode(lotId, "measurePackage", lot.name ?? "Lot", activityGroups));
		}
		if (constructionMeasurePackages.length > 0) valueAddStages.push(createHierarchyNode("valueadd-construction", "stage", "Construction", constructionMeasurePackages));
		if (valueAddStages.length > 0) phases.push(createHierarchyNode("valueadd", "phase", "Value-add", valueAddStages));
		const stabilizationStages = [];
		const stabilizationTasks = gatherTasksForPrefixes(allTasks, ["AM 3.5"]);
		if (stabilizationTasks.length > 0) {
			const activityGroups = groupTasksByActivityGroup(stabilizationTasks, "stabilization-stabilization");
			stabilizationStages.push(createHierarchyNode("stabilization-stabilization", "stage", "Stabilization", activityGroups));
		}
		if (stabilizationStages.length > 0) phases.push(createHierarchyNode("stabilization", "phase", "Stabilization", stabilizationStages));
		return phases;
	};
	gatherTasksForPrefixes = (allTasks, prefixes) => {
		const tasks = [];
		for (const prefix of prefixes) {
			const matchingTasks = allTasks.filter((t) => t.customId?.startsWith(prefix));
			tasks.push(...matchingTasks);
		}
		return sortTasksByCustomId(tasks);
	};
	hierarchyToSequenceRecords = (hierarchy, mfhId, opts) => {
		const results = [];
		let order = 0;
		for (const phase of hierarchy) {
			let isFirstRowInPhase = true;
			for (const stage of phase.children) {
				let isFirstRowInStage = true;
				if (stage.children.some((c) => c.type === "measurePackage")) for (const measurePackage of stage.children) {
					let isFirstRowInMeasurePackage = true;
					for (const activityGroup of measurePackage.children) for (const task of activityGroup.tasks) {
						results.push({
							taskId: task.taskId,
							taskCustomId: task.customId ?? null,
							mfhId,
							order: order++,
							phaseLabel: isFirstRowInPhase ? phase.name : null,
							stageLabel: isFirstRowInStage ? stage.name : null,
							phase: phase.name,
							stage: stage.name,
							measurePackageLabel: isFirstRowInMeasurePackage ? measurePackage.name : null,
							measurePackage: measurePackage.name,
							activityGroup: activityGroup.name,
							...opts?.includeSourceTask ? { task } : {}
						});
						if (isFirstRowInPhase) isFirstRowInPhase = false;
						if (isFirstRowInStage) isFirstRowInStage = false;
						if (isFirstRowInMeasurePackage) isFirstRowInMeasurePackage = false;
					}
				}
				else for (const activityGroup of stage.children) for (const task of activityGroup.tasks) {
					results.push({
						taskId: task.taskId,
						taskCustomId: task.customId ?? null,
						mfhId,
						order: order++,
						phaseLabel: isFirstRowInPhase ? phase.name : null,
						stageLabel: isFirstRowInStage ? stage.name : null,
						phase: phase.name,
						stage: stage.name,
						measurePackageLabel: null,
						measurePackage: null,
						activityGroup: activityGroup.name,
						...opts?.includeSourceTask ? { task } : {}
					});
					if (isFirstRowInPhase) isFirstRowInPhase = false;
					if (isFirstRowInStage) isFirstRowInStage = false;
				}
			}
		}
		return results;
	};
}));
//#endregion
//#region src/domains/cross-cutting/task/task.opts.ts
var init_task_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/task/task-template.opts.ts
var init_task_template_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/task/task.request.ts
var init_task_request = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/task/index.ts
var init_task = __esmMin((() => {
	init_task_template_model();
	init_task_helpers();
	init_task_model();
	init_task_opts();
	init_task_template_opts();
	init_task_request();
	init_task_i18n();
}));
//#endregion
//#region src/domains/cross-cutting/user.helpers.ts
var bootstrapDataUserCompressor;
var init_user_helpers$1 = __esmMin((() => {
	bootstrapDataUserCompressor = {
		compress(data) {
			return compressResponse(data, (r) => {
				return [
					r.uid,
					r.email ?? EMPTY_VAL,
					r.displayName ?? EMPTY_VAL,
					r.emailVerified ?? EMPTY_VAL,
					r.disabled ?? EMPTY_VAL,
					r.contact ? JSON.stringify(r.contact) : EMPTY_VAL,
					r.customClaims ? JSON.stringify(r.customClaims) : EMPTY_VAL,
					r.companyFunction ? JSON.stringify(r.companyFunction) : EMPTY_VAL
				];
			});
		},
		decompress(data) {
			return decompressResponse(data, (d) => {
				const [uid, email, displayName, emailVerified, disabled, contact, customClaims, companyFunction] = d;
				return {
					uid,
					email: undefinedWhenEmpty(email, String),
					displayName: undefinedWhenEmpty(displayName, String),
					emailVerified: undefinedWhenEmpty(emailVerified, (v) => v === "true"),
					disabled: undefinedWhenEmpty(disabled, (v) => v === "true"),
					contact: undefinedWhenEmpty(contact, (v) => JSON.parse(v)),
					customClaims: undefinedWhenEmpty(customClaims, (v) => JSON.parse(v)),
					companyFunction: undefinedWhenEmpty(companyFunction, (v) => JSON.parse(v))
				};
			});
		}
	};
}));
//#endregion
//#region src/domains/cross-cutting/durable-jobs/durable-job.model.ts
var DurableJobStatus, JobMetaStatus;
var init_durable_job_model = __esmMin((() => {
	DurableJobStatus = /* @__PURE__ */ function(DurableJobStatus) {
		DurableJobStatus["pending"] = "pending";
		DurableJobStatus["scheduled"] = "scheduled";
		DurableJobStatus["cancelled"] = "cancelled";
		DurableJobStatus["success"] = "success";
		DurableJobStatus["fail"] = "fail";
		DurableJobStatus["action_taken"] = "action_taken";
		return DurableJobStatus;
	}({});
	JobMetaStatus = /* @__PURE__ */ function(JobMetaStatus) {
		JobMetaStatus["running"] = "running";
		JobMetaStatus["success"] = "success";
		JobMetaStatus["fail"] = "fail";
		return JobMetaStatus;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/durable-jobs/durable-job.opts.ts
var init_durable_job_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/durable-jobs/durable-job.helpers.ts
function getDurableJobMetaProgress(job) {
	const raw = job.meta?.progress;
	if (!raw || typeof raw !== "object") return null;
	const { completed, total, label } = raw;
	if (typeof total !== "number" || total <= 0) return null;
	return {
		completed: typeof completed === "number" ? completed : 0,
		total,
		...typeof label === "string" ? { label } : {}
	};
}
function getDurableJobMetaProgressPercent(job) {
	const progress = getDurableJobMetaProgress(job);
	if (!progress) return null;
	return Math.min(100, Math.round(progress.completed / progress.total * 100));
}
var durableJobIsCancellable, durableJobIsRetriggerable, getJobCurrentJobStep, getJobProgress;
var init_durable_job_helpers = __esmMin((() => {
	durableJobIsCancellable = (job) => ["pending", "scheduled"].includes(job.status);
	durableJobIsRetriggerable = (job) => ["fail", "cancelled"].includes(job.status);
	getJobCurrentJobStep = (job) => {
		const jobStep = job.step ? job.step - 1 : 1;
		if (!job.stepMeta) return jobStep;
		const sortedSteps = sortBy(Object.values(job.stepMeta), (j) => j.idx);
		if (sortedSteps.every((step) => step.status === "running")) return 1;
		if (sortedSteps.every((step) => ["fail", "success"].includes(step.status))) return job.totalSteps ?? 1;
		const runningSteps = sortedSteps.filter((step) => step.status === "running");
		/**
		* the minimium still running step dictates the global progress, ie. consider the following cases
		* [   1   ,  2 ,   3   ,   4   ,   5   ,   6   ]
		* ------------------------------------------------
		* [success,fail,running,success,running,running] -> 3
		* [success,fail,running,running,running,running] -> 3
		* [running,fail,success,success,success,success] -> 1
		*/
		if (runningSteps.length) return Math.min(...runningSteps.map((s) => s.idx));
		return jobStep;
	};
	getJobProgress = (job) => {
		const metaPercent = getDurableJobMetaProgressPercent(job);
		if (metaPercent !== null) return Math.max(metaPercent, 3);
		const totalSteps = job.totalSteps ?? 1;
		const step = Math.max(getJobCurrentJobStep(job) - 1, 0);
		return Math.max(step / totalSteps * 100, 3);
	};
}));
//#endregion
//#region src/domains/cross-cutting/durable-jobs/durable-job.repository.ts
var init_durable_job_repository = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/durable-jobs/durable-job.schema.ts
var DurableJobSchema;
var init_durable_job_schema = __esmMin((() => {
	init_lib();
	init_durable_job_model();
	DurableJobSchema = Type.Intersect([BaseCreatedDeletedAttributesSchema, Type.Object({
		id: Type.String(),
		inngestId: Type.Union([Type.String(), Type.Null()]),
		status: TEnum(DurableJobStatus),
		name: Type.String(),
		params: Type.Record(Type.String(), Type.Any()),
		result: Type.Union([Type.Object({
			decision: Type.Union([Type.Object({
				action: Type.Union([
					Type.Literal("update_mfh"),
					Type.Literal("create_mfh"),
					Type.Literal("update_mfh_estate"),
					Type.Literal("create_mfh_estate")
				]),
				params: Type.Record(Type.String(), Type.Any())
			}), Type.Null()]),
			data: Type.Union([Type.Record(Type.String(), Type.Any()), Type.Null()])
		}), Type.Null()]),
		error: Type.Union([Type.Unsafe(Type.Any()), Type.Null()]),
		startedAt: Type.Union([TStringDate(), Type.Null()]),
		finishedAt: Type.Union([TStringDate(), Type.Null()]),
		seenAt: Type.Union([TStringDate(), Type.Null()]),
		createdBy: Type.Union([Type.String(), Type.Null()]),
		step: Type.Union([Type.Number(), Type.Null()]),
		totalSteps: Type.Union([Type.Number(), Type.Null()]),
		stepName: Type.Union([Type.String(), Type.Null()]),
		stepMeta: Type.Union([Type.Record(Type.String(), Type.Any()), Type.Null()]),
		meta: Type.Union([Type.Record(Type.String(), Type.Any()), Type.Null()])
	})]);
}));
//#endregion
//#region src/domains/cross-cutting/durable-jobs/index.ts
var init_durable_jobs = __esmMin((() => {
	init_durable_job_model();
	init_durable_job_opts();
	init_durable_job_helpers();
	init_durable_job_repository();
	init_durable_job_schema();
}));
//#endregion
//#region src/domains/cross-cutting/email-template.model.ts
var init_email_template_model = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/cdc/cdc-event.model.ts
var CDCEventOp;
var init_cdc_event_model = __esmMin((() => {
	CDCEventOp = /* @__PURE__ */ function(CDCEventOp) {
		CDCEventOp["CREATE"] = "c";
		CDCEventOp["UPDATE"] = "u";
		CDCEventOp["DELETE"] = "d";
		CDCEventOp["READ"] = "r";
		CDCEventOp["TRUNCATE"] = "t";
		CDCEventOp["MESSAGE"] = "m";
		return CDCEventOp;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/pipeline-audit-event/pipeline-audit-event.model.ts
var PipelineAuditEventReasonCode, PipelineAuditEventReasonDetail;
var init_pipeline_audit_event_model = __esmMin((() => {
	PipelineAuditEventReasonCode = /* @__PURE__ */ function(PipelineAuditEventReasonCode) {
		PipelineAuditEventReasonCode["DUPLICATED"] = "DUPLICATED";
		PipelineAuditEventReasonCode["IRRELEVANT"] = "IRRELEVANT";
		PipelineAuditEventReasonCode["IGNORED_UPDATE"] = "IGNORED_UPDATE";
		PipelineAuditEventReasonCode["DATA_RETRIEVAL_ERROR"] = "DATA_RETRIEVAL_ERROR";
		PipelineAuditEventReasonCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
		return PipelineAuditEventReasonCode;
	}({});
	PipelineAuditEventReasonDetail = /* @__PURE__ */ function(PipelineAuditEventReasonDetail) {
		PipelineAuditEventReasonDetail["ESTATE_TYPE_NOT_SET_TO_KAUFMIETE"] = "ESTATE_TYPE_NOT_SET_TO_KAUFMIETE";
		PipelineAuditEventReasonDetail["NOT_IN_SUPPORTED_REGION"] = "NOT_IN_SUPPORTED_REGION";
		PipelineAuditEventReasonDetail["GEOCODE_SCORE_BELOW_THRESHOLD"] = "GEOCODE_SCORE_BELOW_THRESHOLD";
		PipelineAuditEventReasonDetail["NO_MFH_NOR_ESTATE"] = "NO_MFH_NOR_ESTATE";
		PipelineAuditEventReasonDetail["CONSTRUCTION_YEAR_IN_FUTURE"] = "CONSTRUCTION_YEAR_IN_FUTURE";
		PipelineAuditEventReasonDetail["NO_ROOMS"] = "NO_ROOMS";
		PipelineAuditEventReasonDetail["ESTATE_TYPE_NOT_SET_TO_BUY"] = "ESTATE_TYPE_NOT_SET_TO_BUY";
		PipelineAuditEventReasonDetail["NO_SIGNIFICANT_CHANGE"] = "NO_SIGNIFICANT_CHANGE";
		PipelineAuditEventReasonDetail["ALREADY_PROCESSED"] = "ALREADY_PROCESSED";
		PipelineAuditEventReasonDetail["FETCH_FAILED"] = "FETCH_FAILED";
		PipelineAuditEventReasonDetail["NOT_UPDATED_SINCE_LAST_PUBLISH"] = "NOT_UPDATED_SINCE_LAST_PUBLISH";
		return PipelineAuditEventReasonDetail;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/pipeline-audit-event/index.ts
var init_pipeline_audit_event = __esmMin((() => {
	init_pipeline_audit_event_model();
}));
//#endregion
//#region src/domains/cross-cutting/sign-off-envelope/sign-off-envelope.model.ts
var SignOffEnvelopeStatus, SignOffEnvelopePriority, SignOffEnvelopeDeletableStatuses, SignOffEnvelopePendingStatuses, BaseSignOffEnvelopeSchema, SignOffEnvelopeEvents, canEditExternalApprovers;
var init_sign_off_envelope_model = __esmMin((() => {
	init_string_date();
	SignOffEnvelopeStatus = /* @__PURE__ */ function(SignOffEnvelopeStatus) {
		SignOffEnvelopeStatus["PendingInternalApproval"] = "PendingInternalApproval";
		SignOffEnvelopeStatus["PendingInternalSignature"] = "PendingInternalSignature";
		SignOffEnvelopeStatus["Pending"] = "Pending";
		SignOffEnvelopeStatus["Approved"] = "Approved";
		SignOffEnvelopeStatus["PendingSignature"] = "PendingSignature";
		SignOffEnvelopeStatus["Completed"] = "Completed";
		SignOffEnvelopeStatus["Rejected"] = "Rejected";
		SignOffEnvelopeStatus["Cancelled"] = "Cancelled";
		return SignOffEnvelopeStatus;
	}({});
	SignOffEnvelopePriority = /* @__PURE__ */ function(SignOffEnvelopePriority) {
		SignOffEnvelopePriority["Normal"] = "Normal";
		SignOffEnvelopePriority["Urgent"] = "Urgent";
		return SignOffEnvelopePriority;
	}({});
	SignOffEnvelopeDeletableStatuses = [
		"Pending",
		"PendingInternalApproval",
		"PendingInternalSignature",
		"Cancelled"
	];
	SignOffEnvelopePendingStatuses = [
		"PendingInternalApproval",
		"PendingInternalSignature",
		"Pending",
		"Approved",
		"PendingSignature"
	];
	BaseSignOffEnvelopeSchema = Type.Object({
		signOffEnvelopeId: Type.Number(),
		estateId: Type.Union([Type.Null(), Type.Number()]),
		mfhId: Type.Union([Type.Null(), Type.Number()]),
		addendumId: Type.Union([Type.Null(), Type.Number()]),
		mfhPortfolioId: Type.Union([Type.Null(), Type.Number()]),
		/** Sub-entity of an Estate envelope: the LV / Construction Plan version this approval belongs to. */
		constructionPlanId: Type.Union([Type.Null(), Type.Number()]),
		signOffTemplateId: Type.Number(),
		name: Type.String(),
		status: Type.Enum(SignOffEnvelopeStatus),
		priority: Type.Enum(SignOffEnvelopePriority),
		isInternalApprovalRequired: Type.Boolean(),
		isSignatureOnly: Type.Boolean(),
		isInternalOnly: Type.Boolean(),
		internalApproverContactIds: Type.Array(Type.Number()),
		internallyApprovedByContactId: Type.Union([Type.Null(), Type.Number()]),
		completedAt: Type.Union([Type.Null(), TStringDate()]),
		cancelledAt: Type.Union([Type.Null(), TStringDate()]),
		cancellationReason: Type.Union([Type.Null(), Type.String()]),
		createdByContactId: Type.Union([Type.Null(), Type.Number()]),
		createdAt: TStringDate(),
		updatedAt: TStringDate(),
		deletedAt: Type.Union([Type.Null(), TStringDate()])
	});
	SignOffEnvelopeEvents = /* @__PURE__ */ function(SignOffEnvelopeEvents) {
		SignOffEnvelopeEvents["Created"] = "Created";
		SignOffEnvelopeEvents["InternalApprovalCompleted"] = "InternalApprovalCompleted";
		SignOffEnvelopeEvents["Cancelled"] = "Cancelled";
		SignOffEnvelopeEvents["Updated"] = "Updated";
		SignOffEnvelopeEvents["Completed"] = "Completed";
		SignOffEnvelopeEvents["DocumentApproved"] = "DocumentApproved";
		SignOffEnvelopeEvents["DocumentInternallySigned"] = "DocumentInternallySigned";
		SignOffEnvelopeEvents["DocumentCompleted"] = "DocumentCompleted";
		SignOffEnvelopeEvents["DocumentRejected"] = "DocumentRejected";
		return SignOffEnvelopeEvents;
	}({});
	canEditExternalApprovers = (status) => {
		return [
			"PendingInternalApproval",
			"PendingInternalSignature",
			"Pending"
		].includes(status);
	};
}));
//#endregion
//#region src/domains/cross-cutting/sign-off-envelope/sign-off-envelope.opts.ts
var init_sign_off_envelope_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/sign-off-envelope/document-approval.model.ts
var DocumentApprovalStatus, BaseDocumentApprovalSchema;
var init_document_approval_model = __esmMin((() => {
	init_lib();
	DocumentApprovalStatus = /* @__PURE__ */ function(DocumentApprovalStatus) {
		DocumentApprovalStatus["Pending"] = "Pending";
		DocumentApprovalStatus["Approved"] = "Approved";
		DocumentApprovalStatus["Rejected"] = "Rejected";
		return DocumentApprovalStatus;
	}({});
	BaseDocumentApprovalSchema = Type.Object({
		documentApprovalId: Type.Number(),
		signOffDocumentId: Type.Number(),
		status: Type.Enum(DocumentApprovalStatus),
		contactId: Type.Number(),
		approvedAt: Type.Union([Type.Null(), TStringDate()]),
		rejectedAt: Type.Union([Type.Null(), TStringDate()]),
		rejectionReason: Type.Union([Type.Null(), Type.String()]),
		createdAt: TStringDate(),
		updatedAt: TStringDate()
	});
}));
//#endregion
//#region src/domains/cross-cutting/sign-off-envelope/document-signature.model.ts
var DocumentSignatureStatus, BaseDocumentSignatureSchema;
var init_document_signature_model = __esmMin((() => {
	init_lib();
	DocumentSignatureStatus = /* @__PURE__ */ function(DocumentSignatureStatus) {
		DocumentSignatureStatus["Pending"] = "Pending";
		DocumentSignatureStatus["InProgress"] = "InProgress";
		DocumentSignatureStatus["Signed"] = "Signed";
		DocumentSignatureStatus["Rejected"] = "Rejected";
		return DocumentSignatureStatus;
	}({});
	BaseDocumentSignatureSchema = Type.Object({
		documentSignatureId: Type.Number(),
		signOffDocumentId: Type.Number(),
		status: Type.Enum(DocumentSignatureStatus),
		isInternalSignature: Type.Boolean(),
		signedDocumentId: Type.Union([Type.Null(), Type.Number()]),
		embeddedSignatureURL: Type.Union([Type.Null(), Type.String()]),
		contactId: Type.Number(),
		userRole: Type.String(),
		userSigningOrder: Type.Union([Type.Null(), Type.Number()]),
		submitterId: Type.Number(),
		signedAt: Type.Union([Type.Null(), TStringDate()]),
		rejectedAt: Type.Union([Type.Null(), TStringDate()]),
		rejectionReason: Type.Union([Type.Null(), Type.String()]),
		createdAt: TStringDate(),
		updatedAt: TStringDate()
	});
}));
//#endregion
//#region src/domains/cross-cutting/sign-off-envelope/sign-off-document.model.ts
var SignOffDocumentStatus, SignOffDocumentApprovedStatuses, SignOffDocumentSignedStatuses, SignOffDocumentTerminalStatuses, BaseSignOffDocumentSchema, isSignOffDocumentApproved, isSignOffDocumentSigned, SignOffDocumentEvents;
var init_sign_off_document_model = __esmMin((() => {
	init_lib();
	SignOffDocumentStatus = /* @__PURE__ */ function(SignOffDocumentStatus) {
		SignOffDocumentStatus["PendingInternalApproval"] = "PendingInternalApproval";
		SignOffDocumentStatus["PendingInternalSignature"] = "PendingInternalSignature";
		SignOffDocumentStatus["InternallySigned"] = "InternallySigned";
		SignOffDocumentStatus["PendingApproval"] = "PendingApproval";
		SignOffDocumentStatus["Approved"] = "Approved";
		SignOffDocumentStatus["PendingSignature"] = "PendingSignature";
		SignOffDocumentStatus["Completed"] = "Completed";
		SignOffDocumentStatus["Voided"] = "Voided";
		SignOffDocumentStatus["Rejected"] = "Rejected";
		return SignOffDocumentStatus;
	}({});
	SignOffDocumentApprovedStatuses = [
		"Approved",
		"PendingSignature",
		"Completed"
	];
	SignOffDocumentSignedStatuses = ["Completed"];
	SignOffDocumentTerminalStatuses = [
		"Completed",
		"Voided",
		"Rejected"
	];
	BaseSignOffDocumentSchema = Type.Object({
		signOffDocumentId: Type.Number(),
		signOffEnvelopeId: Type.Number(),
		documentId: Type.Number(),
		templateId: Type.Union([Type.Null(), Type.Number()]),
		status: Type.Enum(SignOffDocumentStatus),
		completedDocumentId: Type.Union([Type.Number()]),
		auditLogDocumentId: Type.Union([Type.Number()]),
		signatureProvider: Type.Union([Type.Union([Type.Literal("docuseal")])]),
		signatureProviderId: Type.Union([Type.String()]),
		createdAt: TStringDate(),
		updatedAt: TStringDate()
	});
	isSignOffDocumentApproved = (signOffDocument) => {
		return SignOffDocumentApprovedStatuses.includes(signOffDocument.status);
	};
	isSignOffDocumentSigned = (signOffDocument) => {
		return SignOffDocumentSignedStatuses.includes(signOffDocument.status);
	};
	SignOffDocumentEvents = /* @__PURE__ */ function(SignOffDocumentEvents) {
		SignOffDocumentEvents["Created"] = "Created";
		SignOffDocumentEvents["CreatedWithPendingApproval"] = "CreatedWithPendingApproval";
		SignOffDocumentEvents["EnvelopeInternalApprovalCompleted"] = "EnvelopeInternalApprovalCompleted";
		SignOffDocumentEvents["DocumentApproved"] = "DocumentApproved";
		SignOffDocumentEvents["DocumentRejected"] = "DocumentRejected";
		SignOffDocumentEvents["DocumentSigned"] = "DocumentSigned";
		SignOffDocumentEvents["DocumentVoided"] = "DocumentVoided";
		SignOffDocumentEvents["SignatureCollectionStarted"] = "SignatureCollectionStarted";
		SignOffDocumentEvents["ApprovalStarted"] = "ApprovalStarted";
		return SignOffDocumentEvents;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/sign-off-envelope/sign-off-comment.model.ts
var BaseSignOffCommentSchema;
var init_sign_off_comment_model = __esmMin((() => {
	init_lib();
	BaseSignOffCommentSchema = Type.Object({
		signOffCommentId: Type.Number(),
		signOffDocumentId: Type.Optional(Type.Number()),
		signOffEnvelopeId: Type.Optional(Type.Number()),
		content: Type.String(),
		isSharedWithExternal: Type.Boolean({ default: false }),
		createdByContactId: Type.Number(),
		createdAt: TStringDate(),
		updatedAt: TStringDate()
	});
}));
//#endregion
//#region src/domains/cross-cutting/sign-off-envelope/sign-off-template.model.ts
var SignOffTemplateType, BaseSignOffTemplateDocumentSchema, BaseSignOffTemplateSchema;
var init_sign_off_template_model = __esmMin((() => {
	init_lib();
	init_document();
	SignOffTemplateType = /* @__PURE__ */ function(SignOffTemplateType) {
		SignOffTemplateType["System"] = "System";
		SignOffTemplateType["Custom"] = "Custom";
		return SignOffTemplateType;
	}({});
	BaseSignOffTemplateDocumentSchema = Type.Object({
		signOffTemplateDocumentId: Type.Number(),
		signOffTemplateId: Type.Number(),
		documentType: Type.Enum(DocumentType),
		isSignatureRequired: Type.Boolean(),
		isInternalSignatureRequired: Type.Boolean(),
		isRemovable: Type.Boolean(),
		createdAt: TStringDate(),
		updatedAt: TStringDate()
	});
	BaseSignOffTemplateSchema = Type.Object({
		signOffTemplateId: Type.Number(),
		name: Type.String(),
		description: Type.Union([Type.Null(), Type.String()]),
		templateType: Type.Enum(SignOffTemplateType),
		isUnique: Type.Boolean(),
		isActive: Type.Boolean(),
		isMfhRelated: Type.Boolean(),
		isMfhPortfolioRelated: Type.Boolean(),
		isAddendumRelated: Type.Boolean(),
		isEstateRelated: Type.Boolean(),
		isGeneral: Type.Boolean(),
		isInternalApprovalRequired: Type.Boolean(),
		isSignatureOnly: Type.Boolean(),
		isInternalOnly: Type.Boolean(),
		createdByContactId: Type.Union([Type.Null(), Type.Number()]),
		createdAt: TStringDate(),
		updatedAt: TStringDate(),
		signOffTemplateDocuments: Type.Array(BaseSignOffTemplateDocumentSchema)
	});
}));
//#endregion
//#region src/domains/cross-cutting/sign-off-envelope/sign-off-template.opts.ts
var init_sign_off_template_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/sign-off-envelope/sign-off-envelope.i18n.ts
var SignOffDocumentStatusTranslation, SignOffEnvelopeStatusTranslation, DocumentSignatureStatusTranslation, DocumentApprovalStatusTranslation;
var init_sign_off_envelope_i18n = __esmMin((() => {
	init_document_approval_model();
	init_document_signature_model();
	init_sign_off_document_model();
	init_sign_off_envelope_model();
	SignOffDocumentStatusTranslation = {
		["PendingApproval"]: "Pending External Recommendation",
		["PendingInternalApproval"]: "Pending Internal Recommendation",
		["PendingInternalSignature"]: "Pending Internal Signature",
		["InternallySigned"]: "Internally Signed",
		["Approved"]: "Externally Recommended",
		["PendingSignature"]: "Pending External Signature",
		["Completed"]: "Completed",
		["Voided"]: "Voided",
		["Rejected"]: "Rejected"
	};
	SignOffEnvelopeStatusTranslation = {
		["Pending"]: "Pending External Recommendation",
		["PendingInternalApproval"]: "Pending Internal Recommendation",
		["PendingInternalSignature"]: "Pending Internal Signature",
		["PendingSignature"]: "Pending External Signature",
		["Approved"]: "Externally Recommended",
		["Completed"]: "Completed",
		["Rejected"]: "Rejected",
		["Cancelled"]: "Cancelled"
	};
	DocumentSignatureStatusTranslation = {
		["Pending"]: "Pending",
		["InProgress"]: "In Progress",
		["Signed"]: "Signed",
		["Rejected"]: "Rejected"
	};
	DocumentApprovalStatusTranslation = {
		["Pending"]: "Pending",
		["Approved"]: "Recommended",
		["Rejected"]: "Rejected"
	};
}));
//#endregion
//#region src/domains/cross-cutting/sign-off-envelope/sign-off-envelope.relations.ts
var SignOffEnvelopeType, SignOffEnvelopeRelationFieldSchema, SignOffEnvelopeRelationFieldKeys, SignOffEnvelopeSubEntityFieldSchema, SignOffEnvelopeInactiveStatuses, SignOffEnvelopeActiveStatuses, getActiveSubEntityEnvelope, hasRelatedEntity, pickEnvelopeRelationFields, getEnvelopeType, getEntityDisplayName, getEntityCondoUuid, getEntityDisplayId, getEntityAddress, getEntityLabel, getSignOffTemplates;
var init_sign_off_envelope_relations = __esmMin((() => {
	init_type_helpers();
	init_sign_off_envelope_model();
	SignOffEnvelopeType = /* @__PURE__ */ function(SignOffEnvelopeType) {
		SignOffEnvelopeType["Estate"] = "Estate";
		SignOffEnvelopeType["MFH"] = "MFH";
		SignOffEnvelopeType["MFHPortfolio"] = "MFHPortfolio";
		SignOffEnvelopeType["General"] = "General";
		SignOffEnvelopeType["Addendum"] = "Addendum";
		return SignOffEnvelopeType;
	}({});
	SignOffEnvelopeRelationFieldSchema = Type.Object({
		estateId: Type.Optional(Type.Number()),
		mfhId: Type.Optional(Type.Number()),
		mfhPortfolioId: Type.Optional(Type.Number()),
		addendumId: Type.Optional(Type.Number())
	});
	SignOffEnvelopeRelationFieldKeys = AllKeys()([
		"estateId",
		"mfhId",
		"mfhPortfolioId",
		"addendumId"
	]);
	SignOffEnvelopeSubEntityFieldSchema = Type.Object({ constructionPlanId: Type.Optional(Type.Number()) });
	SignOffEnvelopeInactiveStatuses = ["Cancelled", "Rejected"];
	SignOffEnvelopeActiveStatuses = Object.values(SignOffEnvelopeStatus).filter((status) => !SignOffEnvelopeInactiveStatuses.includes(status));
	getActiveSubEntityEnvelope = (envelopes) => {
		return maxBy(envelopes.filter((e) => !SignOffEnvelopeInactiveStatuses.includes(e.status)), (e) => e.signOffEnvelopeId);
	};
	hasRelatedEntity = (envelope) => {
		return SignOffEnvelopeRelationFieldKeys.some((key) => !!envelope[key]);
	};
	pickEnvelopeRelationFields = (obj) => {
		const result = {};
		for (const key of SignOffEnvelopeRelationFieldKeys) if (obj[key] !== void 0 && obj[key] !== null) result[key] = obj[key];
		return result;
	};
	getEnvelopeType = (envelope) => {
		if (envelope.estateId) return "Estate";
		if (envelope.mfhId) return "MFH";
		if (envelope.mfhPortfolioId) return "MFHPortfolio";
		if (envelope.addendumId) return "Addendum";
		return "General";
	};
	getEntityDisplayName = (envelope) => {
		if (envelope.estateId) return "Estate";
		if (envelope.mfhId) return "Asset";
		if (envelope.mfhPortfolioId) return "Asset Transaction";
		if (envelope.addendumId) return "Addendum";
		return "General Envelope";
	};
	getEntityCondoUuid = (envelope) => {
		if (envelope.estate) return envelope.estate.condoUuid ?? null;
		if (envelope.mfh) return envelope.mfh.condoUuid ?? null;
		if (envelope.mfhPortfolio) return envelope.mfhPortfolio.condoUuid ?? null;
		return null;
	};
	getEntityDisplayId = (envelope) => {
		if (envelope.estate?.estateId) return envelope.estate.estateId;
		if (envelope.mfhId) return envelope.mfhId;
		if (envelope.mfhPortfolioId) return envelope.mfhPortfolioId;
		if (envelope.addendumId) return envelope.addendumId;
	};
	getEntityAddress = (envelope) => {
		if (envelope.mfhPortfolioId || envelope.mfhPortfolio) return "-";
		let location;
		if (envelope.estate) location = envelope.estate.location;
		else if (envelope.mfh) location = envelope.mfh.candidateLocation;
		if (!location) return "-";
		return addressFormatter({
			street: location.street,
			houseNumber: location.houseNumber,
			city: location.city
		}) || "-";
	};
	getEntityLabel = (envelope) => {
		if (envelope.estate) return `Unit ${envelope.estate.condoUuid ?? envelope.estate.estateId}`;
		if (envelope.mfh) return `Asset ${envelope.mfh.condoUuid ?? envelope.mfh.mfhId}`;
		if (envelope.mfhPortfolio) return `Transaction ${envelope.mfhPortfolio.name ?? envelope.mfhPortfolio.condoUuid ?? envelope.mfhPortfolioId}`;
		if (envelope.addendum) return `Addendum ${envelope.addendum.addendumId}`;
		return "—";
	};
	getSignOffTemplates = (envelope, signOffTemplates) => {
		if (envelope.estateId) return signOffTemplates.filter((t) => t.isEstateRelated);
		if (envelope.mfhId) return signOffTemplates.filter((t) => t.isMfhRelated);
		if (envelope.mfhPortfolioId) return signOffTemplates.filter((t) => t.isMfhPortfolioRelated);
		if (envelope.addendumId) return signOffTemplates.filter((t) => t.isAddendumRelated);
		return signOffTemplates.filter((t) => t.isGeneral);
	};
}));
//#endregion
//#region src/domains/cross-cutting/sign-off-envelope/sign-off-template.relations.ts
var SignOffTemplateRelationFieldSchema, SignOffTemplateRelationFieldKeys;
var init_sign_off_template_relations = __esmMin((() => {
	init_lib();
	SignOffTemplateRelationFieldSchema = Type.Object({
		isMfhRelated: Type.Optional(Type.Boolean()),
		isMfhPortfolioRelated: Type.Optional(Type.Boolean()),
		isAddendumRelated: Type.Optional(Type.Boolean()),
		isEstateRelated: Type.Optional(Type.Boolean())
	});
	SignOffTemplateRelationFieldKeys = AllKeys()([
		"isMfhRelated",
		"isMfhPortfolioRelated",
		"isAddendumRelated",
		"isEstateRelated"
	]);
}));
//#endregion
//#region src/domains/cross-cutting/sign-off-envelope/external-envelope-access.model.ts
var BaseExternalEnvelopeAccessSchema;
var init_external_envelope_access_model = __esmMin((() => {
	init_string_date();
	BaseExternalEnvelopeAccessSchema = Type.Object({
		accessToken: Type.String(),
		signOffEnvelopeId: Type.Number(),
		contactId: Type.Number(),
		expiresAt: Type.Union([Type.Null(), TStringDate()]),
		createdAt: TStringDate(),
		updatedAt: TStringDate()
	});
}));
//#endregion
//#region src/domains/cross-cutting/sign-off-envelope/index.ts
var init_sign_off_envelope = __esmMin((() => {
	init_sign_off_envelope_model();
	init_sign_off_envelope_opts();
	init_document_approval_model();
	init_document_signature_model();
	init_sign_off_document_model();
	init_sign_off_comment_model();
	init_sign_off_template_model();
	init_sign_off_template_opts();
	init_sign_off_envelope_i18n();
	init_sign_off_envelope_relations();
	init_sign_off_template_relations();
	init_external_envelope_access_model();
}));
//#endregion
//#region src/domains/cross-cutting/process-types.i18n.ts
var ProcessTypeTranslation, processTypesTranslation;
var init_process_types_i18n = __esmMin((() => {
	ProcessTypeTranslation = {
		MFHSourcing: "Asset Acquisition",
		MFHSubsidyFinancing: "Financing",
		MFHPortfolioPurchasing: "Transaction Acquisition",
		MFHPortfolioFinancing: "Transaction Financing",
		MFHEstateManagement: "Asset Management"
	};
	processTypesTranslation = (processType) => {
		if (Object.hasOwn(ProcessTypeTranslation, processType)) return ProcessTypeTranslation[processType];
		return toTitleCase(processType);
	};
}));
//#endregion
//#region src/domains/cross-cutting/events/event-v2.model.ts
var EventV2PayloadType;
var init_event_v2_model = __esmMin((() => {
	EventV2PayloadType = /* @__PURE__ */ function(EventV2PayloadType) {
		EventV2PayloadType["StateMachineEvent"] = "StateMachineEvent";
		EventV2PayloadType["DocumentLinked"] = "DocumentLinked";
		EventV2PayloadType["MFHRenovationProjectCreated"] = "MFHRenovationProjectCreated";
		EventV2PayloadType["MFHRenovationProjectUpdated"] = "MFHRenovationProjectUpdated";
		EventV2PayloadType["MFHRenovationProjectCostBreakdownCreated"] = "MFHRenovationProjectCostBreakdownCreated";
		EventV2PayloadType["MFHRenovationProjectCostBreakdownNewVersionCreated"] = "MFHRenovationProjectCostBreakdownNewVersionCreated";
		EventV2PayloadType["MFHRenovationProjectCostBreakdownUpdated"] = "MFHRenovationProjectCostBreakdownUpdated";
		EventV2PayloadType["MFHRenovationProjectLotCreated"] = "MFHRenovationProjectLotCreated";
		EventV2PayloadType["MFHRenovationProjectLotUpdated"] = "MFHRenovationProjectLotUpdated";
		EventV2PayloadType["MFHRenovationProjectPlanningModuleCreated"] = "MFHRenovationProjectPlanningModuleCreated";
		EventV2PayloadType["MFHRenovationProjectPlanningModuleUpdated"] = "MFHRenovationProjectPlanningModuleUpdated";
		EventV2PayloadType["MFHRenovationProjectPositionCreated"] = "MFHRenovationProjectPositionCreated";
		EventV2PayloadType["MFHRenovationProjectPositionUpdated"] = "MFHRenovationProjectPositionUpdated";
		EventV2PayloadType["SignOffEnvelopeCreated"] = "SignOffEnvelopeCreated";
		EventV2PayloadType["SignOffEnvelopeApproved"] = "SignOffEnvelopeApproved";
		EventV2PayloadType["SignOffEnvelopeInternallyApproved"] = "SignOffEnvelopeInternallyApproved";
		EventV2PayloadType["SignOffDocumentApproved"] = "SignOffDocumentApproved";
		EventV2PayloadType["SignOffDocumentSigned"] = "SignOffDocumentSigned";
		EventV2PayloadType["SignOffDocumentRejected"] = "SignOffDocumentRejected";
		EventV2PayloadType["SignOffCommentCreated"] = "SignOffCommentCreated";
		EventV2PayloadType["SignOffDocumentAdded"] = "SignOffDocumentAdded";
		return EventV2PayloadType;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/events/requests.ts
var init_requests$2 = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/events/machine.ts
var init_machine = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/events/payload.types.ts
var init_payload_types = __esmMin((() => {}));
//#endregion
//#region src/domains/cross-cutting/events/index.ts
var init_events = __esmMin((() => {
	init_event_v2_model();
	init_requests$2();
	init_machine();
	init_payload_types();
}));
//#endregion
//#region src/domains/cross-cutting/user-task/user-task.model.ts
var UserTaskStatus, UserTaskType;
var init_user_task_model = __esmMin((() => {
	UserTaskStatus = /* @__PURE__ */ function(UserTaskStatus) {
		UserTaskStatus["Created"] = "Created";
		UserTaskStatus["Completed"] = "Completed";
		UserTaskStatus["Aborted"] = "Aborted";
		return UserTaskStatus;
	}({});
	UserTaskType = /* @__PURE__ */ function(UserTaskType) {
		UserTaskType["ClassifyDocument"] = "classify_document";
		UserTaskType["AnalyzePortfolio"] = "analyze_portfolio";
		return UserTaskType;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/user-task/payload/document-classifier.model.ts
var DocumentClassifierPayloadStatus, DocumentClassifierSource, departmentDefaultParentFolders, ALLOWED_DOCUMENT_CLASSIFIER_PARENT_FOLDER_NAMES;
var init_document_classifier_model = __esmMin((() => {
	init_user_model();
	DocumentClassifierPayloadStatus = /* @__PURE__ */ function(DocumentClassifierPayloadStatus) {
		DocumentClassifierPayloadStatus["Uploaded"] = "Uploaded";
		DocumentClassifierPayloadStatus["Classified"] = "Classified";
		DocumentClassifierPayloadStatus["Confirmed"] = "Confirmed";
		DocumentClassifierPayloadStatus["Adjusted"] = "Adjusted";
		DocumentClassifierPayloadStatus["Rejected"] = "Rejected";
		return DocumentClassifierPayloadStatus;
	}({});
	DocumentClassifierSource = /* @__PURE__ */ function(DocumentClassifierSource) {
		DocumentClassifierSource["Email"] = "email";
		DocumentClassifierSource["Upload"] = "upload";
		DocumentClassifierSource["Existing"] = "existing";
		return DocumentClassifierSource;
	}({});
	departmentDefaultParentFolders = {
		["InvestmentManagement"]: ["0 Akquisition"],
		["AssetManagement"]: ["1 Liegenschaftsbezogene Unterlagen"],
		["RenovationManagement"]: ["1 Liegenschaftsbezogene Unterlagen"]
	};
	ALLOWED_DOCUMENT_CLASSIFIER_PARENT_FOLDER_NAMES = ["0 Akquisition", "1 Liegenschaftsbezogene Unterlagen"];
}));
//#endregion
//#region src/domains/cross-cutting/user-task/payload/portfolio-analyser.model.ts
var PortfolioAnalyzerConsumer;
var init_portfolio_analyser_model = __esmMin((() => {
	PortfolioAnalyzerConsumer = /* @__PURE__ */ function(PortfolioAnalyzerConsumer) {
		PortfolioAnalyzerConsumer["PortfolioAnalyzer"] = "portfolio-analyzer";
		PortfolioAnalyzerConsumer["AssetAnalyzer"] = "asset-analyzer";
		return PortfolioAnalyzerConsumer;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/user-task/payload/index.ts
var init_payload = __esmMin((() => {
	init_document_classifier_model();
	init_portfolio_analyser_model();
}));
//#endregion
//#region src/domains/cross-cutting/user-task/index.ts
var init_user_task = __esmMin((() => {
	init_user_task_model();
	init_payload();
}));
//#endregion
//#region src/domains/cross-cutting/spotlights/index.ts
var SpotlightAnswerType;
var init_spotlights = __esmMin((() => {
	SpotlightAnswerType = /* @__PURE__ */ function(SpotlightAnswerType) {
		SpotlightAnswerType["MultipleChoice"] = "multiple-choice";
		SpotlightAnswerType["Slider"] = "slider";
		return SpotlightAnswerType;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/agent-feedback.ts
var AgentFeedbackModule, AgentFeedbackRating, AgentFeedbackStatus;
var init_agent_feedback = __esmMin((() => {
	AgentFeedbackModule = /* @__PURE__ */ function(AgentFeedbackModule) {
		AgentFeedbackModule["InvestmentCase"] = "investment-case";
		AgentFeedbackModule["AssetAnalyzer"] = "asset-analyzer";
		return AgentFeedbackModule;
	}({});
	AgentFeedbackRating = /* @__PURE__ */ function(AgentFeedbackRating) {
		AgentFeedbackRating["Good"] = "good";
		AgentFeedbackRating["Mixed"] = "mixed";
		AgentFeedbackRating["Bad"] = "bad";
		return AgentFeedbackRating;
	}({});
	AgentFeedbackStatus = /* @__PURE__ */ function(AgentFeedbackStatus) {
		AgentFeedbackStatus["Open"] = "open";
		AgentFeedbackStatus["Resolved"] = "resolved";
		return AgentFeedbackStatus;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/agent-models.ts
var agentReasoningEfforts, normalizeAgentReasoningDefaults;
var init_agent_models = __esmMin((() => {
	agentReasoningEfforts = [
		"low",
		"medium",
		"high"
	];
	normalizeAgentReasoningDefaults = (defaults, reasoning) => ({
		effort: reasoning?.efforts.includes(defaults.effort) ? defaults.effort : reasoning?.efforts.includes("medium") ? "medium" : reasoning?.efforts[0] ?? "medium",
		extendedThinking: Boolean(reasoning && (!reasoning.canDisable || defaults.extendedThinking))
	});
}));
//#endregion
//#region src/domains/cross-cutting/index.ts
var init_cross_cutting = __esmMin((() => {
	init_authz();
	init_calendar_event_model();
	init_calendar_event_opts();
	init_company();
	init_config_model();
	init_config_opts();
	init_contact();
	init_config_record_class();
	init_dictionaries_model();
	init_document();
	init_energy_efficiency();
	init_errors();
	init_estates();
	init_mfh();
	init_summary_model();
	init_outbox_model();
	init_audit_log();
	init_appointment_model();
	init_form_schema_model();
	init_form_schema_opts();
	init_netsuite_sync_status_model();
	init_note();
	init_user_confirmation();
	init_notification();
	init_personal_info();
	init_processes();
	init_location();
	init_review_process();
	init_rule_model();
	init_rule_opts();
	init_rule_helpers();
	init_state_machine();
	init_task();
	init_user_helpers$1();
	init_user_model();
	init_durable_jobs();
	init_email_template_model();
	init_media_file();
	init_cdc_event_model();
	init_maps();
	init_pipeline_audit_event();
	init_party();
	init_sign_off_envelope();
	init_process_types_i18n();
	init_events();
	init_user_task();
	init_spotlights();
	init_agent_feedback();
	init_agent_models();
}));
//#endregion
//#region src/domains/finance/investment/investment-case.class.ts
var InvestmentCase;
var init_investment_case_class = __esmMin((() => {
	init_lib();
	init_config_record_class();
	init_errors();
	init_estate_helpers();
	init_special_deal_class();
	init_prediction_result_class();
	init_profitability_calculations_class();
	init_cross_cutting();
	InvestmentCase = class InvestmentCase extends ProfitabilityCalculationsClass {
		costOfCapital;
		createdAt;
		estateId;
		investmentId;
		maklerFee;
		name;
		parkingSpacePrice;
		predictionId;
		baseRentPerSquareMeter;
		purchasingPrice;
		serviceChargesDuringRenovation;
		state;
		userId;
		uuid;
		investmentCaseType;
		agencyFeeInput;
		maklerFeeInput;
		propertyRelatedCostsInput;
		parentInvestmentId;
		calculationValues;
		rentCase;
		sellingNotaryCost;
		sellingPropertyRegistration;
		sellingTaxes;
		sellingRepaymentSubsidy;
		shouldApplySpecialDeal;
		investorCashflow;
		parentInvestmentCase;
		estate;
		predictionResult;
		notes;
		reviewProcess;
		rentableUnitCases;
		constructor(props, logger = defaultLogger) {
			super(props, logger);
			Object.assign(this, props);
			this.calculationType = "investmentCase";
			if (!props.predictionResult) throw new InvalidParamsError("Investment-case requires a prior predictionResult");
			this.predictionResult = new PredictionResultClass(props.predictionResult);
			if (props.parentInvestmentCase) this.parentInvestmentCase = new InvestmentCase(props.parentInvestmentCase);
			this.configRecord = this.configRecord ? new ConfigRecord(this.configRecord) : this.configRecord;
			this.rentableUnitCases = props.rentableUnitCases ? cloneDeep(props.rentableUnitCases) : [];
		}
		get coldRentPerSquareMeter() {
			if (this.distributionType === "FFF") return 0;
			return round$1(this.rentalIncome / this.livingSpace, 2);
		}
		get incomeMonth() {
			if (this.distributionType === "FFF") return 0;
			return this.monthlyRent + this.parkingSpacePrice;
		}
		get parkingRentalIncomeMonth() {
			return this.parkingSpacePrice || 0;
		}
		get rentalIncome() {
			if (this.distributionType === "FFF") return 0;
			return this.monthlyRent || 0;
		}
		get operationCostsPerSqm() {
			return this.operationCosts / this.livingSpace;
		}
		get estateConfiguration() {
			return this.predictionResult.estateConfiguration;
		}
		get externalData() {
			return this.predictionResult?.externalData ?? [];
		}
		get requestUuid() {
			return this.predictionResult?.requestUuid;
		}
		get parentPrediction() {
			return this.predictionResult;
		}
		get livingSpace() {
			let livingSpace;
			if (this.isSelling) livingSpace = this.estate?.postRenovationAttributes?.livingSpace;
			return this.isPurchasing || !livingSpace ? this.estate?.attributes?.livingSpace ?? this.estateConfiguration.livingSpace : livingSpace;
		}
		get ancillaryCostsPerSquareMeter() {
			return this.auxiliaryCosts / this.livingSpace;
		}
		get purchasePricePerSquareMeter() {
			return this.estatePurchasePrice / this.livingSpace;
		}
		get renovationCostsPerSquareMeter() {
			return this.renovationCosts / this.livingSpace;
		}
		get salesPricePerSquareMeter() {
			return round$1(this.expectedSalesPrice / this.livingSpace, 2);
		}
		get homeOwnerPerSqM() {
			return this.totalAdditionalCost / this.livingSpace;
		}
		get baseRenovationCosts() {
			return this.parentInvestmentCase ? this.parentInvestmentCase.renovationCosts ?? 0 : this.predictionResult?.renovationCosts ?? 0;
		}
		get isCM1Achieved() {
			return this.listedMarginNoOperation >= (this.configRecord?.configRow?.Inputs?.config?.expectedReturn?.condoReturnTarget ?? 0);
		}
		get isCM2Achieved() {
			return this.listedOverallMargin >= (this.configRecord?.configRow?.Inputs?.config?.expectedReturn?.condoReturnTargetOverall ?? 0);
		}
		get totalPrice() {
			return this.parkingSpacePurchasePrice + this.purchasingPrice;
		}
		get isPurchasing() {
			return this.investmentCaseType === "Purchasing";
		}
		get isSelling() {
			return this.investmentCaseType === "Selling" || this.investmentCaseType === "ICT";
		}
		get isICT() {
			return this.investmentCaseType === "ICT";
		}
		get inputsVals() {
			return {
				purchasingPrice: +this.purchasingPrice,
				parkingSpacePurchasePrice: +this.parkingSpacePurchasePrice,
				rentalReturnTarget: this.rentalReturnTarget ?? .03,
				renovationCosts: +this.renovationCosts,
				renovationExtraCost: this.renovationExtraCost ?? 0,
				renovationCostAdjustments: this.renovationCostAdjustments ?? 0,
				houseGeld: +this.houseGeld,
				maklerFee: +this.maklerFeeInput,
				propertyRelatedCosts: this.propertyRelatedCostsInput,
				agencyFee: +this.agencyFeeInput,
				distributionType: this.distributionType,
				tenantPresent: this.tenantPresent,
				expectedSalesPrice: +this.expectedSalesPrice,
				configId: this.configId,
				specialAgreements: this.specialAgreements ?? 0,
				bonus: this.bonus ?? 0,
				pmIncentive: this.pmIncentive ?? 0,
				extraCost: this.extraCost ?? 0,
				asbestosAdditionCalculated: this.asbestosAdditionCalculated ?? false,
				prefabricatedAdditionCalculated: this.prefabricatedAdditionCalculated ?? false,
				newFloorHistoricAdditionCalculated: this.newFloorHistoricAdditionCalculated ?? false,
				storeyHeightAdditionCalculated: this.storeyHeightAdditionCalculated ?? false,
				gasBoilerAdditionCalculated: this.gasBoilerAdditionCalculated ?? false,
				maisonetteAdditionCalculated: this.maisonetteAdditionCalculated ?? false,
				heatingPipesAdditionCalculated: this.heatingPipesAdditionCalculated ?? false,
				historicDoors: this.historicDoors ?? 0,
				approvedGeneralRenovationCost: this.approvedGeneralRenovationCost,
				approvedKitchenCost: this.approvedKitchenCost,
				approvedRenovationExtraCost: this.approvedRenovationExtraCost,
				rentableUnitCases: this.rentableUnitCases,
				rentCase: this.rentCase ?? "Normal",
				shouldApplySpecialDeal: this.shouldApplySpecialDeal ?? false
			};
		}
		get minSalesPrice() {
			return this.listedPriceTotalExpenses - (this.rentalIncomeDuringHold + this.serviceCharge + this.sellingCommission);
		}
		get minRentPrice() {
			return (this.minSalesPrice * this.effectiveInvestorReturn - this.parkingSpacePrice * 12) / (this.livingSpace * 12);
		}
		get effectiveInvestorReturn() {
			return round$1(this.incomeYear / this.expectedSalesPrice, 6);
		}
		get investorReturnDeviation() {
			return this.maxInvestorReturn / this.effectiveInvestorReturn - 1;
		}
		get maxInvestorReturn() {
			return round$1((this.incomeYear - this.nonTransferableYear) / (this.totalPurchasePrice + this.renovationCosts + (this.parentInvestmentCase?.auxiliaryCosts ?? 0) + (this.parentInvestmentCase?.operationCosts ?? 0) - (this.rentalIncomeDuringHold + this.transferable)), 4);
		}
		get maxCostOvershoot() {
			return this.incomeYear / this.effectiveInvestorReturn + this.rentalIncomeDuringHold - this.totalPurchasePrice - this.renovationCosts - this.operationCosts - this.auxiliaryCosts - this.houseGeldYear;
		}
		get sellingRentalReturnTarget() {
			return round$1(this.incomeYear / this.expectedSalesPrice, 4);
		}
		static getGeneralRenovationCostsAdjusted(investment) {
			return investment.renovationCosts - investment.kitchenCost;
		}
		static verifyInputsCombination(val) {
			return !(val.distributionType === "FFF" && val.tenantPresent);
		}
		copy() {
			return new InvestmentCase(this);
		}
		setConfigRecord(configRecord) {
			if (configRecord.encodedIdPath !== this.configId) throw new Error(`Provided config-record does not match config-id ${this.configId}`);
			this.configRecord = configRecord instanceof ConfigRecord ? configRecord : new ConfigRecord(configRecord);
		}
		getParkingSpacePrice(rentableUnitCases, distributionType) {
			if (distributionType === "FFF") return 0;
			return rentableUnitCases?.reduce((total, ruc) => ruc.rentableUnitType === "Parking" && ruc.checked ? total + ruc.coldRent : total, 0) ?? 0;
		}
		getMonthlyRent(rentableUnitCases, rentCase, distributionType, throwInvariant) {
			if (distributionType === "FFF") return 0;
			if (rentCase === "FlatShare") {
				if (throwInvariant && !rentableUnitCases.find((ruc) => ruc.rentableUnitType === "Room" && ruc.checked)) throw new InvariantError(`IC.getMonthlyRent: Rent case is "FlatShare" but there is no checked RUC of type "Room" (IC: ${this.investmentId}, Estate: ${this.estateId || this.estate?.estateId})`);
				return rentableUnitCases?.reduce((total, ruc) => ruc.rentableUnitType === "Room" && ruc.checked ? total + ruc.coldRent : total, 0) ?? 0;
			}
			if (throwInvariant && !rentableUnitCases.find((ruc) => ruc.rentableUnitType === "Estate" && ruc.checked)) throw new InvariantError(`IC.getMonthlyRent: Rent case is ${rentCase} but there is no checked RUC of type "Estate" (IC: ${this.investmentId}, Estate: ${this.estateId || this.estate?.estateId})`);
			return rentableUnitCases?.reduce((total, ruc) => ruc.rentableUnitType === "Estate" && ruc.checked ? total + ruc.coldRent : total, 0) ?? 0;
		}
		calculateInvestment({ estate, values, inputs, tables }, opts) {
			if (!this.predictionResult) throw new Error("Prediction Results is missing for calculations");
			if (!estate && !this.estate) throw new Error("Estate Object is missing for calculations");
			if (!estate?.attributes) throw new InvariantError("Need to have attributes present for estate");
			if (!estate?.price) throw new InvariantError("Need to have price present for estate");
			const { recalculateExpectedSalesPrice = true } = opts ?? {};
			const estateObj = estate || this.estate;
			const { estateConfiguration } = this.predictionResult;
			const isSaasEstate = estateObj.channelName === "SAAS";
			const marketPricePurchasingPrice = estateObj.externalData?.find((item) => item.source === "Sprengnetter" && item.type === "PurchaseValuation")?.data?.value;
			const investmentInputs = values ?? { ...this.inputsVals };
			let livingSpace;
			if (this.isSelling && estateObj.postRenovationAttributes?.livingSpace) livingSpace = estateObj.postRenovationAttributes?.livingSpace;
			else livingSpace = estateObj.attributes.livingSpace;
			investmentInputs.tenantPresent = investmentInputs.distributionType === "FRF" ? values?.tenantPresent ?? investmentInputs.tenantPresent : false;
			const specialDeal = this.isSelling && !this.isICT && investmentInputs.shouldApplySpecialDeal && estate.specialDeal ? new SpecialDeal(estate.specialDeal) : void 0;
			this.calculationValues = {
				buildInKitchen: estateConfiguration.builtInKitchen,
				guestToilet: !!estateConfiguration.guestToilet,
				newInteriorQuality: estateConfiguration.interiorQuality,
				targetRooms: estateConfiguration.rooms,
				kitchenPresent: !!estateObj.attributes.builtInKitchen,
				guestToiletPresent: !!estateObj.attributes.guestToilet,
				condition: estateObj.attributes.condition,
				livingSpace,
				apartmentSize: estateObj.attributes.apartmentSize,
				apartmentType: estateObj.attributes.apartmentType,
				numberOfFloors: estateObj.attributes.numberOfFloors,
				constructionYear: estateObj.attributes.constructionYear,
				interiorQuality: estateObj.attributes.interiorQuality,
				yearsSinceRenovation: estateObj.attributes.yearsSinceRenovation,
				currentlyRooms: estateObj.attributes.rooms,
				marketPricePurchasingPrice,
				referralFeePercent: estateObj.price.referralFeePercent ?? 0,
				/**
				* ICalculationVals.state -> "Location" state (e.g Hamburg)
				* IInvestment.state -> InvestmentCaseState (e.g "New", "Approved", etc)
				*/
				state: inferStateFromEstate(estateObj),
				...investmentInputs,
				parkingSpacePrice: this.getParkingSpacePrice(investmentInputs.rentableUnitCases, investmentInputs.distributionType),
				monthlyRent: this.getMonthlyRent(investmentInputs.rentableUnitCases, investmentInputs.rentCase, investmentInputs.distributionType, true),
				baseRentPerSquareMeter: 0,
				skipFinancingCosts: opts?.skipFinancingCosts ?? false,
				skipOtherCosts: opts?.skipOtherCosts ?? false,
				skipRenovationCosts: opts?.skipRenovationCosts ?? false,
				skipAgencyFee: opts?.skipAgencyFee ?? false,
				...specialDeal?.getInvestmentCalculationValsOverrides(estate) ?? {}
			};
			this.calculationValues.salesKickBack = investmentInputs.salesKickBack ?? 0;
			if (this.isPurchasing && this.distributionType === "FRF" && recalculateExpectedSalesPrice) delete this.calculationValues.expectedSalesPrice;
			if (isSaasEstate) this.calculationValues.expectedSalesPrice = values?.expectedSalesPrice;
			super.calculate(this.calculationValues, inputs, tables, {
				...opts,
				...specialDeal?.getInvestmentCalculationOptsOverrides(estate) ?? {}
			});
			this.purchasingPrice = this.calculationValues.purchasingPrice;
			this.parkingSpacePrice = this.calculationValues.parkingSpacePrice;
			if (this.isPurchasing) this.rentalReturnTarget = this.calculationValues.rentalReturnTarget;
			else this.rentalReturnTarget = this.sellingRentalReturnTarget;
			this.propertyRelatedCostsInput = this.calculationValues.propertyRelatedCosts;
			this.maklerFeeInput = this.calculationValues.maklerFee;
			this.agencyFeeInput = this.calculationValues.agencyFee;
			this.costOfCapital = this.calculationValues.costOfCapital;
			this.serviceChargesDuringRenovation = inputs.transformation.serviceChargesDuringRenovation ?? this.serviceChargesDuringRenovation;
			this.configId = this.calculationValues.configId;
			this.distributionType = this.calculationValues.distributionType;
			this.tenantPresent = this.calculationValues.tenantPresent;
			this.salesKickBack = this.calculationValues.salesKickBack ?? 0;
			this.extraCost = this.calculationValues.extraCost ?? 0;
			this.renovationExtraCost = this.renovationExtraCost ?? this.calculationValues.renovationExtraCost ?? 0;
			this.asbestosAdditionCalculated = this.calculationValues.asbestosAdditionCalculated ?? false;
			this.newFloorHistoricAdditionCalculated = this.calculationValues.newFloorHistoricAdditionCalculated ?? false;
			this.storeyHeightAdditionCalculated = this.calculationValues.storeyHeightAdditionCalculated ?? false;
			this.gasBoilerAdditionCalculated = this.calculationValues.gasBoilerAdditionCalculated ?? false;
			this.maisonetteAdditionCalculated = this.calculationValues.maisonetteAdditionCalculated ?? false;
			this.heatingPipesAdditionCalculated = this.calculationValues.heatingPipesAdditionCalculated ?? false;
			this.prefabricatedAdditionCalculated = this.calculationValues.prefabricatedAdditionCalculated ?? false;
			this.historicDoors = this.calculationValues.historicDoors ?? 0;
			this.rentableUnitCases = investmentInputs.rentableUnitCases;
			this.rentCase = investmentInputs.rentCase;
			this.baseRentPerSquareMeter = this.coldRentPerSquareMeter;
			this.shouldApplySpecialDeal = investmentInputs.shouldApplySpecialDeal ?? false;
			return this;
		}
	};
}));
//#endregion
//#region src/domains/renting/annual-service-charge-statement/annual-service-charge-distribution.model.ts
var ServiceChargeDistributionKey;
var init_annual_service_charge_distribution_model = __esmMin((() => {
	ServiceChargeDistributionKey = /* @__PURE__ */ function(ServiceChargeDistributionKey) {
		ServiceChargeDistributionKey["TOTAL_AREA_M2"] = "total_area_m2";
		ServiceChargeDistributionKey["COMMERCIAL_AREA_M2"] = "commercial_area_m2";
		ServiceChargeDistributionKey["USABLE_AREA_M2"] = "usable_area_m2";
		ServiceChargeDistributionKey["WEIGHTED_AREA_M2"] = "weighted_area_m2";
		ServiceChargeDistributionKey["LIVING_AREA_M2"] = "living_area_m2";
		ServiceChargeDistributionKey["TOTAL_UNITS"] = "total_units";
		ServiceChargeDistributionKey["RESIDENTIAL_UNITS"] = "residential_units";
		ServiceChargeDistributionKey["COMMERCIAL_UNITS"] = "commercial_units";
		ServiceChargeDistributionKey["REGISTERED_PERSONS"] = "registered_persons";
		ServiceChargeDistributionKey["PERSON_DAYS"] = "person_days";
		ServiceChargeDistributionKey["PERSON_MONTHS"] = "person_months";
		ServiceChargeDistributionKey["ACTUAL_CONSUMPTION"] = "actual_consumption";
		ServiceChargeDistributionKey["HEATING_UNITS"] = "heating_units";
		ServiceChargeDistributionKey["WATER_M3"] = "water_m3";
		ServiceChargeDistributionKey["WARM_WATER_M3"] = "warm_water_m3";
		ServiceChargeDistributionKey["ELECTRICITY_KWH"] = "electricity_kwh";
		ServiceChargeDistributionKey["GAS_M3"] = "gas_m3";
		ServiceChargeDistributionKey["THOUSANDTHS"] = "thousandths";
		ServiceChargeDistributionKey["LAND_REGISTER_SHARE"] = "land_register_share";
		ServiceChargeDistributionKey["FIXED_AMOUNT"] = "fixed_amount";
		ServiceChargeDistributionKey["FIXED_PERCENTAGE"] = "fixed_percentage";
		ServiceChargeDistributionKey["CUSTOM_RATIO"] = "custom_ratio";
		ServiceChargeDistributionKey["CONTRACT_SPECIFIC"] = "contract_specific";
		ServiceChargeDistributionKey["ZERO_ALLOCATION"] = "zero_allocation";
		ServiceChargeDistributionKey["RADIATOR_COUNT"] = "radiator_count";
		ServiceChargeDistributionKey["RADIATOR_UNITS"] = "radiator_units";
		ServiceChargeDistributionKey["SMOKE_DETECTOR_COUNT"] = "smoke_detector_count";
		ServiceChargeDistributionKey["WINDOW_COUNT"] = "window_count";
		ServiceChargeDistributionKey["WINDOW_AREA_M2"] = "window_area_m2";
		ServiceChargeDistributionKey["PARKING_SPACES"] = "parking_spaces";
		ServiceChargeDistributionKey["UNDERGRAUND_PARKING_SPACES"] = "underground_parking_spaces";
		ServiceChargeDistributionKey["BALCONY_AREA_M2"] = "balcony_area_m2";
		ServiceChargeDistributionKey["ROOM_COUNT"] = "room_count";
		ServiceChargeDistributionKey["BATHROOM_COUNT"] = "bathroom_count";
		ServiceChargeDistributionKey["OCCUPANCY_DAYS"] = "occupancy_days";
		ServiceChargeDistributionKey["OCCUPANCY_MONTHS"] = "occupancy_months";
		ServiceChargeDistributionKey["RENTAL_MONTHS"] = "rental_months";
		ServiceChargeDistributionKey["DEGREE_DAYS"] = "degree_days";
		ServiceChargeDistributionKey["FLOOR_LEVEL"] = "floor_level";
		ServiceChargeDistributionKey["STAIRCASE_ASSIGNMENT"] = "staircase_assignment";
		ServiceChargeDistributionKey["INSURANCE"] = "insurance";
		ServiceChargeDistributionKey["BETRIEBSKOSTENSPIEGEL"] = "betriebskostenspiegel";
		ServiceChargeDistributionKey["HEIZKOSTENVERORDNUNG"] = "heizkostenverordnung";
		ServiceChargeDistributionKey["WIRTSCHAFTSEINHEIT"] = "wirtschaftseinheit";
		ServiceChargeDistributionKey["NUTZEINHEIT"] = "nutzeinheit";
		ServiceChargeDistributionKey["TAX_ASSESSMENT_SHARE"] = "tax_assessment_share";
		ServiceChargeDistributionKey["CO_OWNERSHIP_SHARE"] = "co_ownership_share";
		ServiceChargeDistributionKey["RESIDENTIAL_UNITS_HS"] = "residential_units_hs";
		ServiceChargeDistributionKey["TOTAL_UNITS_HS"] = "total_units_hs";
		ServiceChargeDistributionKey["OBJECT_UNITS"] = "object_units";
		ServiceChargeDistributionKey["CABLE_TV_UNITS"] = "cable_tv_units";
		ServiceChargeDistributionKey["EMISSION_MEASUREMENT"] = "emission_measurement";
		ServiceChargeDistributionKey["WASTE_CONTAINER"] = "waste_container";
		ServiceChargeDistributionKey["GARDEN_AREA_M2"] = "garden_area_m2";
		ServiceChargeDistributionKey["BASEMENT_AREA_M2"] = "basement_area_m2";
		ServiceChargeDistributionKey["ELEVATOR_USAGE"] = "elevator_usage";
		ServiceChargeDistributionKey["HOUSEHOLDS"] = "households";
		ServiceChargeDistributionKey["JANITOR_SERVICE"] = "janitor_service";
		ServiceChargeDistributionKey["CLEANING_SERVICE"] = "cleaning_service";
		ServiceChargeDistributionKey["WINTER_SERVICE"] = "winter_service";
		ServiceChargeDistributionKey["GARDEN_MAINTENANCE"] = "garden_maintenance";
		ServiceChargeDistributionKey["SPECIAL_AGREEMENT"] = "special_agreement";
		return ServiceChargeDistributionKey;
	}({});
}));
//#endregion
//#region src/domains/finance/ledger/general-ledger-statement/rent-tenancy-ledger-statement.schema.ts
var RentTenancyLedgerStatementExpectedValuesSchema, RentTenancyLedgerStatementCashflowValuesSchema, RentTenancyLedgerStatementBalanceValuesSchema;
var init_rent_tenancy_ledger_statement_schema = __esmMin((() => {
	RentTenancyLedgerStatementExpectedValuesSchema = Type.Object({
		coldRent: Type.Number({ default: 0 }),
		utilityCost: Type.Number({ default: 0 }),
		heatingCost: Type.Number({ default: 0 }),
		parkingSpaceRent: Type.Number({ default: 0 }),
		invoices: Type.Number({ default: 0 }),
		annualServiceChargeStatement: Type.Number({ default: 0 }),
		returnDebit: Type.Number({ default: 0 }),
		others: Type.Number({ default: 0 })
	}, { $id: "RentTenancyLedgerStatementExpectedValues" });
	RentTenancyLedgerStatementCashflowValuesSchema = Type.Object({
		coldRent: Type.Number({ default: 0 }),
		utilityCost: Type.Number({ default: 0 }),
		heatingCost: Type.Number({ default: 0 }),
		parkingSpaceRent: Type.Number({ default: 0 }),
		invoices: Type.Number({ default: 0 }),
		annualServiceChargeStatement: Type.Number({ default: 0 }),
		returnDebit: Type.Number({ default: 0 }),
		others: Type.Number({ default: 0 })
	}, { $id: "RentTenancyLedgerStatementCashflowValues" });
	RentTenancyLedgerStatementBalanceValuesSchema = Type.Object({
		coldRent: Type.Number({ default: 0 }),
		utilityCost: Type.Number({ default: 0 }),
		heatingCost: Type.Number({ default: 0 }),
		parkingSpaceRent: Type.Number({ default: 0 }),
		invoices: Type.Number({ default: 0 }),
		annualServiceChargeStatement: Type.Number({ default: 0 }),
		returnDebit: Type.Number({ default: 0 }),
		others: Type.Number({ default: 0 })
	}, { $id: "RentTenancyLedgerStatementBalanceValues" });
}));
//#endregion
//#region src/domains/renting/annual-service-charge-statement/annual-service-charge-statement.model.ts
var AnnualServiceChargeStatementStatus, HeatingCostMethod, HeatingCostItemType, HeatingCostItemCostType, DepositRetentionReason, AnnualServiceChargeStatementStatusEnumSchema, HeatingCostMethodSchema, HeatingCostItemTypeSchema, HeatingCostItemCostTypeSchema, ServiceChargeDistributionKeysSchema, OwnerPeriodSchema, OwnershipSplittingSchema, DegreeDayItemSchema, HeatingCostItemSchema, HeatingCostsDataSchema, CorrespondenceAddressSchema, OperatingCostItemSchema, DistributionKeyItemSchema, HouseholdCostItemSchema, OperatingCostsDataSchema, AnnualServiceChargeStatementStatementsSchema, ServiceChargeAdjustmentDataSchema, DepositRetentionDataSchema, BaseAnnualServiceChargeStatementSchema, AnnualServiceChargeStatementSchema, Operator, annualServiceChargeStatementSchemas;
var init_annual_service_charge_statement_model = __esmMin((() => {
	init_lib();
	init_annual_service_charge_distribution_model();
	init_rent_tenancy_ledger_statement_schema();
	AnnualServiceChargeStatementStatus = /* @__PURE__ */ function(AnnualServiceChargeStatementStatus) {
		AnnualServiceChargeStatementStatus["Created"] = "Created";
		AnnualServiceChargeStatementStatus["Prepared"] = "Prepared";
		AnnualServiceChargeStatementStatus["Sent"] = "Sent";
		AnnualServiceChargeStatementStatus["Paid"] = "Paid";
		AnnualServiceChargeStatementStatus["Underpaid"] = "Underpaid";
		AnnualServiceChargeStatementStatus["Overpaid"] = "Overpaid";
		return AnnualServiceChargeStatementStatus;
	}({});
	HeatingCostMethod = /* @__PURE__ */ function(HeatingCostMethod) {
		HeatingCostMethod["DegreeDays"] = "DegreeDays";
		HeatingCostMethod["ManualSplit"] = "ManualSplit";
		HeatingCostMethod["Individual"] = "Individual";
		return HeatingCostMethod;
	}({});
	HeatingCostItemType = /* @__PURE__ */ function(HeatingCostItemType) {
		HeatingCostItemType["Gradtagszahlen"] = "Gradtagszahlen";
		HeatingCostItemType["Nutzungstage"] = "Nutzungstage";
		return HeatingCostItemType;
	}({});
	HeatingCostItemCostType = /* @__PURE__ */ function(HeatingCostItemCostType) {
		HeatingCostItemCostType["Grundkosten"] = "Grundkosten";
		HeatingCostItemCostType["Verbrauchskosten"] = "Verbrauchskosten";
		HeatingCostItemCostType["Gesamt"] = "Gesamt";
		return HeatingCostItemCostType;
	}({});
	DepositRetentionReason = /* @__PURE__ */ function(DepositRetentionReason) {
		DepositRetentionReason["BKAOutstanding"] = "bka-outstanding";
		DepositRetentionReason["Damages"] = "damages";
		DepositRetentionReason["Arrears"] = "arrears";
		DepositRetentionReason["Cleaning"] = "cleaning";
		DepositRetentionReason["Repairs"] = "repairs";
		return DepositRetentionReason;
	}({});
	AnnualServiceChargeStatementStatusEnumSchema = TEnum(AnnualServiceChargeStatementStatus, { $id: "AnnualServiceChargeStatementStatusEnum" });
	HeatingCostMethodSchema = TEnum(HeatingCostMethod, { $id: "HeatingCostMethod" });
	HeatingCostItemTypeSchema = TEnum(HeatingCostItemType, { $id: "HeatingCostItemType" });
	HeatingCostItemCostTypeSchema = TEnum(HeatingCostItemCostType, { $id: "HeatingCostItemCostType" });
	ServiceChargeDistributionKeysSchema = TEnum(ServiceChargeDistributionKey, { $id: "ServiceChargeDistributionKeys" });
	OwnerPeriodSchema = Type.Object({
		start: StringDateSchema,
		end: StringDateSchema,
		days: Type.Number()
	});
	OwnershipSplittingSchema = Type.Object({
		hasOwnershipChange: Type.Boolean(),
		activeOwnerPeriod: TNullable(OwnerPeriodSchema),
		activeOwnerShare: TNullable(Type.Number()),
		activeOwnerName: Type.Optional(TNullable(Type.String())),
		activeInvestorInfoId: Type.Optional(TNullable(Type.Number())),
		expiredOwnerPeriod: Type.Optional(TNullable(OwnerPeriodSchema)),
		expiredOwnerShare: Type.Optional(TNullable(Type.Number())),
		expiredOwnerName: Type.Optional(TNullable(Type.String())),
		apportionmentDocumentGenerated: Type.Optional(TNullable(Type.Boolean()))
	}, { $id: "OwnershipSplitting" });
	DegreeDayItemSchema = Type.Object({
		id: Type.String(),
		month: Type.String(),
		daysInMonth: Type.Number(),
		degreeDaysPerMonth: Type.Number(),
		degreeDaysPerDay: Type.Number(),
		usedDays: Type.Optional(Type.Number()),
		usageAmount: Type.Number()
	}, { $id: "DegreeDayItem" });
	HeatingCostItemSchema = Type.Object({
		costType: Type.Ref(HeatingCostItemCostTypeSchema),
		description: Type.String(),
		amount: Type.Number(),
		value: Type.Number(),
		calculationType: Type.Ref(HeatingCostItemTypeSchema),
		tenantShare: Type.Number()
	}, { $id: "HeatingCostItem" });
	HeatingCostsDataSchema = Type.Object({
		heatingCosts: Type.Array(Type.Ref(HeatingCostItemSchema)),
		degreeDays: Type.Array(Type.Ref(DegreeDayItemSchema)),
		method: Type.Ref(HeatingCostMethodSchema),
		totalHeatingCosts: Type.Number(),
		tenantShare: Type.Number()
	}, { $id: "HeatingCostsData" });
	CorrespondenceAddressSchema = Type.Object({
		name: Type.String(),
		street: Type.String(),
		houseNumber: Type.String(),
		city: Type.String(),
		postalCode: Type.String()
	}, { $id: "CorrespondenceAddress" });
	OperatingCostItemSchema = Type.Object({
		totalAmount: Type.Number(),
		tenantShare: Type.Number(),
		overrideShare: Type.Optional(Type.Number()),
		distributionKey: Type.Optional(Type.String()),
		description: Type.Optional(Type.String())
	}, { $id: "OperatingCostItem" });
	DistributionKeyItemSchema = Type.Object({
		keyType: Type.Union([Type.Ref(ServiceChargeDistributionKeysSchema), Type.String()]),
		description: Type.Optional(Type.String()),
		total: Type.Number(),
		share: Type.Number(),
		isEditable: Type.Optional(Type.Boolean()),
		isPrefilled: Type.Optional(Type.Boolean())
	}, { $id: "DistributionKeyItem" });
	HouseholdCostItemSchema = Type.Object({
		description: Type.String(),
		totalAmount: Type.Number({ default: 0 }),
		tenantShare: Type.Number({ default: 0 })
	}, { $id: "HouseholdCostItem" });
	OperatingCostsDataSchema = Type.Object({
		transferableCosts: Type.Array(Type.Ref(OperatingCostItemSchema)),
		distributionKeys: Type.Array(Type.Ref(DistributionKeyItemSchema)),
		householdCosts: Type.Array(Type.Ref(HouseholdCostItemSchema)),
		totalAmount: Type.Number(),
		tenantShare: Type.Number()
	}, { $id: "OperatingCostsData" });
	AnnualServiceChargeStatementStatementsSchema = Type.Object({
		rentTenancyId: Type.Optional(Type.Number()),
		month: Type.String(),
		expectedValues: Type.Ref(RentTenancyLedgerStatementExpectedValuesSchema),
		cashflowValues: Type.Ref(RentTenancyLedgerStatementCashflowValuesSchema),
		balanceValues: Type.Ref(RentTenancyLedgerStatementBalanceValuesSchema)
	}, { $id: "AnnualServiceChargeStatementStatements" });
	ServiceChargeAdjustmentDataSchema = Type.Object({
		utilityCostIncrease: TNullable(Type.Number()),
		heatingCostIncrease: TNullable(Type.Number()),
		startDate: StringDateSchema,
		rentObjectCreated: Type.Optional(Type.Boolean()),
		isAdjustmentNeeded: Type.Optional(Type.Boolean())
	}, { $id: "ServiceChargeAdjustmentData" });
	DepositRetentionDataSchema = Type.Object({
		withholdDepositAmount: Type.Optional(TNullable(Type.Number())),
		withholdOutstandingBkaAmount: Type.Optional(TNullable(Type.Number()))
	}, { $id: "DepositRetentionData" });
	BaseAnnualServiceChargeStatementSchema = Type.Object({
		serviceChargeStatementId: Type.Optional(Type.Number()),
		rentalContractId: Type.Number(),
		status: Type.Ref(AnnualServiceChargeStatementStatusEnumSchema),
		statusDates: Type.Optional(Type.Record(Type.String(), StringDateSchema)),
		dueDate: Type.Optional(StringDateSchema),
		year: Type.Number(),
		amount: Type.Number(),
		paidAmount: Type.Optional(Type.Number()),
		lastPaidAt: Type.Optional(StringDateSchema),
		createdBy: Type.Optional(TNullable(Type.String())),
		bankTransactionIds: Type.Optional(Type.Array(Type.Number())),
		invoiceId: Type.Optional(TNullable(Type.Number())),
		propertyManagementCompanyId: Type.Optional(Type.Number()),
		billingPeriodStart: Type.Optional(StringDateSchema),
		billingPeriodEnd: Type.Optional(StringDateSchema),
		usagePeriodStart: Type.Optional(StringDateSchema),
		usagePeriodEnd: Type.Optional(StringDateSchema),
		copiedFromId: Type.Optional(TNullable(Type.Number())),
		operatingCostsData: Type.Optional(Type.Ref(OperatingCostsDataSchema)),
		heatingCostsData: Type.Optional(Type.Ref(HeatingCostsDataSchema)),
		serviceChargeAdjustment: Type.Optional(Type.Ref(ServiceChargeAdjustmentDataSchema)),
		depositRetention: Type.Optional(Type.Ref(DepositRetentionDataSchema)),
		ownershipSplitting: Type.Optional(Type.Ref(OwnershipSplittingSchema)),
		emailHistory: Type.Optional(Type.Any()),
		correspondenceAddress: Type.Optional(TNullable(Type.Ref(CorrespondenceAddressSchema))),
		statements: Type.Optional(Type.Array(Type.Intersect([Type.Ref(AnnualServiceChargeStatementStatementsSchema), Type.Object({ isModified: Type.Optional(Type.Boolean()) })]))),
		participatingProperties: Type.Optional(Type.Array(Type.String())),
		createdAt: Type.Optional(StringDateSchema),
		updatedAt: Type.Optional(StringDateSchema)
	}, { $id: "BaseAnnualServiceChargeStatement" });
	AnnualServiceChargeStatementSchema = Type.Intersect([Type.Ref(BaseAnnualServiceChargeStatementSchema), Type.Object({
		rentalContract: Type.Optional(TAnyDict),
		documents: Type.Optional(Type.Array(Type.Any())),
		bankTransactions: Type.Optional(Type.Array(Type.Any())),
		notes: Type.Optional(Type.Array(Type.Any())),
		managementCompany: Type.Optional(Type.Any()),
		copiedContract: Type.Optional(TAnyDict)
	})], { $id: "AnnualServiceChargeStatement" });
	Operator = /* @__PURE__ */ function(Operator) {
		Operator["Add"] = "Add";
		Operator["Sub"] = "Sub";
		return Operator;
	}({});
	annualServiceChargeStatementSchemas = {
		AnnualServiceChargeStatementSchema,
		AnnualServiceChargeStatementStatementsSchema,
		AnnualServiceChargeStatementStatusEnumSchema,
		BaseAnnualServiceChargeStatementSchema,
		CorrespondenceAddressSchema,
		DegreeDayItemSchema,
		DepositRetentionDataSchema,
		DistributionKeyItemSchema,
		HeatingCostItemCostTypeSchema,
		HeatingCostItemSchema,
		HeatingCostItemTypeSchema,
		HeatingCostMethodSchema,
		HeatingCostsDataSchema,
		HouseholdCostItemSchema,
		OperatingCostItemSchema,
		OperatingCostsDataSchema,
		OwnershipSplittingSchema,
		ServiceChargeAdjustmentDataSchema,
		ServiceChargeDistributionKeysSchema
	};
}));
//#endregion
//#region src/domains/renting/annual-service-charge-statement/annual-service-charge-statement.class.ts
var PAYMENT_ADJUSTMENT_THRESHOLD, AnnualServiceChargeStatement;
var init_annual_service_charge_statement_class = __esmMin((() => {
	init_document();
	init_finance();
	init_rental_contract();
	init_annual_service_charge_statement_model();
	init_rent_helpers();
	PAYMENT_ADJUSTMENT_THRESHOLD = 100;
	AnnualServiceChargeStatement = class AnnualServiceChargeStatement {
		serviceChargeStatementId;
		rentalContractId;
		status;
		statusDates;
		dueDate;
		year;
		amount = 0;
		paidAmount = 0;
		lastPaidAt;
		createdBy;
		bankTransactionIds = [];
		createdAt;
		invoiceId;
		copiedFromId;
		documentId;
		propertyManagementCompanyId;
		billingPeriodStart;
		billingPeriodEnd;
		usagePeriodStart;
		usagePeriodEnd;
		operatingCostsData;
		heatingCostsData;
		serviceChargeAdjustment;
		depositRetention;
		ownershipSplitting;
		emailHistory;
		correspondenceAddress;
		statements;
		participatingProperties;
		rentTenancy;
		documents;
		rentalContract;
		notes;
		managementCompany;
		bankTransactions;
		copiedContract;
		constructor(props) {
			Object.assign(this, props);
			if (props.rentalContract) this.rentalContract = new RentalContract(props.rentalContract);
			if (props.copiedContract) this.copiedContract = new RentalContract(props.copiedContract);
			if (props.rentalContract?.rentTenancy) this.rentTenancy = props.rentalContract?.rentTenancy;
			if (props.statements) this.statements = props.statements.sort((a, b) => new Date(a.month).getTime() - new Date(b.month).getTime());
		}
		get title() {
			return `BKA ${this.year} (${this.status})`;
		}
		get statusLabel() {
			if (this.status === "Created") return "In Progress";
			return this.status;
		}
		get usageMonths() {
			return dayjs(this.usagePeriodEnd).diff(dayjs(this.usagePeriodStart), "month") + 1;
		}
		get usageDays() {
			return round(dayjs(this.usagePeriodEnd).diff(dayjs(this.usagePeriodStart), "day", true) + 1);
		}
		get usagePeriodLabel() {
			return getPeriodLabel(this.usagePeriodStart, this.usagePeriodEnd);
		}
		get billingDays() {
			return round(dayjs(this.billingPeriodEnd).diff(dayjs(this.billingPeriodStart), "day", true) + 1);
		}
		get billingPeriodLabel() {
			return getPeriodLabel(this.billingPeriodStart, this.billingPeriodEnd);
		}
		get usageRatio() {
			return this.usageDays / this.billingDays;
		}
		get isEditable() {
			return this.status === "Created";
		}
		get canGenerateDocuments() {
			return ![
				"Sent",
				"Paid",
				"Underpaid",
				"Overpaid"
			].includes(this.status);
		}
		/**
		* @param incomingAmount Amount can be positive or negative
		*/
		resolveStatus(incomingAmount) {
			const newPaidAmount = roundByBankersMethod(this.paidAmount + incomingAmount) || 0;
			const expectedAmount = roundByBankersMethod(this.amount) || 0;
			const isNegative = expectedAmount < 0;
			const balance = round(expectedAmount + newPaidAmount, 2);
			const now = /* @__PURE__ */ new Date();
			if (newPaidAmount === 0) {
				const newStatus = {
					["Paid"]: "Sent",
					["Underpaid"]: "Sent",
					["Overpaid"]: "Sent",
					["Sent"]: "Prepared",
					["Prepared"]: "Created"
				}[this.status] || "Created";
				return {
					status: newStatus,
					statusDate: this.statusDates?.[newStatus] || now
				};
			}
			if (isNegative ? balance < 0 : balance > 0) return {
				status: "Underpaid",
				statusDate: now
			};
			if (isNegative ? balance > 0 : balance < 0) return {
				status: "Overpaid",
				statusDate: now
			};
			return {
				status: "Paid",
				statusDate: now
			};
		}
		getOperatingCosts() {
			return this.operatingCostsData?.transferableCosts || [];
		}
		getDistributionKeys() {
			return this.operatingCostsData?.distributionKeys || [];
		}
		getHouseholdCosts() {
			return this.operatingCostsData?.householdCosts || [];
		}
		getHeatingCosts() {
			return this.heatingCostsData?.heatingCosts || [];
		}
		getDegreeDays() {
			return this.heatingCostsData?.degreeDays || [];
		}
		hasServiceChargeAdjustment() {
			return (!!this.serviceChargeAdjustment?.utilityCostIncrease || !!this.serviceChargeAdjustment?.heatingCostIncrease || !!this.serviceChargeAdjustment?.startDate) && !!this.serviceChargeAdjustment?.isAdjustmentNeeded;
		}
		hasDepositRetention() {
			return !!this.depositRetention?.withholdDepositAmount;
		}
		hasOwnershipSplitting() {
			return !!this.ownershipSplitting?.hasOwnershipChange;
		}
		getGeneratedDocuments() {
			return this.documents ?? [];
		}
		static getGeneratedDocumentTypes() {
			return [
				"BKAStatement",
				"BKAHeatingStatement",
				"BKAAllocationCalculation",
				"BKAHouseholdCosts",
				"BKADeposit"
			];
		}
		getDocuments() {
			return Array.isArray(this.documents) ? this.documents : [];
		}
		addDocument(fileType, file) {
			const currentDocs = this.getDocuments();
			const newDoc = {
				documentId: Date.now() + Math.random(),
				filename: file.name,
				path: "",
				documentType: fileType,
				file
			};
			return new AnnualServiceChargeStatement({
				...this,
				documents: [...currentDocs, newDoc]
			});
		}
		removeDocument(fileType, index) {
			const currentDocs = this.getDocuments();
			let filteredDocs;
			if (index !== void 0) {
				const docToRemove = currentDocs.filter((doc) => doc.documentType === fileType)[index];
				filteredDocs = currentDocs.filter((doc) => doc !== docToRemove);
			} else filteredDocs = currentDocs.filter((doc) => doc.documentType !== fileType);
			return new AnnualServiceChargeStatement({
				...this,
				documents: filteredDocs
			});
		}
		getDocumentsByType(fileType) {
			return this.getDocuments().filter((doc) => doc.documentType === fileType || doc.type === fileType);
		}
		getDistributionHistory() {
			return this.emailHistory ?? null;
		}
		getPaymentHistory() {
			return this.bankTransactions;
		}
		getTenantShare() {
			return roundByBankersMethod(this.operatingCostsData?.tenantShare || 0) || 0;
		}
		getTotalOperatingCosts() {
			return roundByBankersMethod(this.operatingCostsData?.totalAmount || 0) || 0;
		}
		getTotalHeatingCosts() {
			return roundByBankersMethod(this.heatingCostsData?.totalHeatingCosts || 0) || 0;
		}
		getTenantHeatingCosts() {
			return roundByBankersMethod(this.heatingCostsData?.tenantShare || 0) || 0;
		}
		calculateOperatingCostsTotalAmount() {
			return roundByBankersMethod(this.getOperatingCosts().reduce((sum, cost) => sum + cost.totalAmount, 0)) || 0;
		}
		calculateOperatingCostsTotalUnitShare() {
			return roundByBankersMethod(this.getOperatingCosts().reduce((sum, costItem) => sum + this.calculateOperatingCostsTenantShare(costItem, 1).tenantShare, 0)) || 0;
		}
		calculateOperatingCostsTotalTenantShare() {
			return roundByBankersMethod(this.getOperatingCosts().reduce((sum, cost) => {
				return sum + (cost.overrideShare !== void 0 ? cost.overrideShare : cost.tenantShare);
			}, 0)) || 0;
		}
		calculateOperatingCostsTenantShare(costItem, customUsageRatio, updatedDistributionKeys) {
			if (costItem.overrideShare !== void 0) return {
				...costItem,
				tenantShare: costItem.overrideShare
			};
			const usageRatio = customUsageRatio ?? this.usageRatio;
			const distributionKeys = updatedDistributionKeys ?? this.getDistributionKeys();
			if (!costItem.distributionKey) return {
				...costItem,
				tenantShare: round(costItem.totalAmount * usageRatio, 2)
			};
			const matchingDistribution = distributionKeys.find((dist) => dist.keyType === costItem.distributionKey);
			if (matchingDistribution && matchingDistribution.total > 0) {
				const shareRatio = matchingDistribution.share / matchingDistribution.total;
				return {
					...costItem,
					tenantShare: round(costItem.totalAmount * shareRatio * usageRatio, 2)
				};
			}
			return {
				...costItem,
				tenantShare: 0
			};
		}
		getPaymentDue() {
			return roundByBankersMethod(this.amount + this.paidAmount) || 0;
		}
		getTenantName() {
			const tenant = this.rentalContract?.rentTenancy?.tenancyMembers?.[0];
			if (!tenant) return "Unknown Tenant";
			if (tenant.contact) return `${tenant.contact.firstname || ""} ${tenant.contact.lastname || ""}`.trim();
			if (tenant.company) return tenant.company.name || "Unknown Company";
			return "Unknown Tenant";
		}
		getPropertyAddress() {
			const location = this.rentalContract?.estate?.location;
			if (!location) return "Unknown Property";
			const parts = [
				location.street,
				location.houseNumber,
				location.zipcode,
				location.city
			].filter(Boolean);
			return parts.length > 0 ? parts.join(" ") : "Unknown Property";
		}
		getLastRent() {
			if (!this.rentalContract?.rents) return null;
			const overlappingRents = this.rentalContract.rents.filter((rent) => arePeriodsOverlapping(rent, {
				startDate: this.usagePeriodStart ?? /* @__PURE__ */ new Date(`${this.year}-01-01`),
				endDate: this.usagePeriodEnd ?? /* @__PURE__ */ new Date(`${this.year}-12-31`)
			}));
			if (overlappingRents.length === 0) return null;
			return overlappingRents.slice().sort((a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime()).at(-1) || null;
		}
		getRentForBkaServiceChargeAdjustment(referenceDate) {
			if (!this.rentalContract?.rents?.length) return null;
			const asOf = referenceDate ? new Date(referenceDate) : this.createdAt ? new Date(this.createdAt) : /* @__PURE__ */ new Date();
			const activeRent = this.rentalContract.getActiveRentForMonth(asOf);
			if (activeRent) return activeRent;
			return this.rentalContract.getLastRentBefore({ startDate: asOf });
		}
		getFullPrepaymentHistory = () => {
			if (!this.statements?.length) return [];
			return this.statements.map((s) => {
				const statement = new RentTenancyLedgerStatement(s);
				const expectedHeating = statement.expectedValues.heatingCost || 0;
				const expectedUtility = statement.expectedValues.utilityCost || 0;
				const cashflowHeating = statement.cashflowValues.heatingCost || 0;
				const cashflowUtility = statement.cashflowValues.utilityCost || 0;
				const expectedTotal = Math.abs(expectedHeating + expectedUtility);
				const cashflowTotal = cashflowHeating + cashflowUtility;
				const deviation = expectedTotal - cashflowTotal;
				return {
					month: statement.month,
					rentTenancyId: statement.rentTenancyId,
					total: expectedTotal,
					heatingCosts: expectedHeating,
					utilityCosts: expectedUtility,
					actualCosts: cashflowTotal,
					deviation
				};
			});
		};
		getPrepaymentsSummary() {
			if (!this.statements?.length) return [];
			const prepayments = [];
			const sortedStatements = this.statements?.map((s) => {
				const statement = new RentTenancyLedgerStatement(s);
				const expectedHeating = statement.expectedValues.heatingCost || 0;
				const expectedUtility = statement.expectedValues.utilityCost || 0;
				return {
					month: s.month,
					total: expectedHeating + expectedUtility,
					heatingCosts: statement.expectedValues.heatingCost || 0,
					utilityCosts: statement.expectedValues.utilityCost || 0
				};
			}).filter((statement) => statement.total);
			let lastPrepayment = {
				total: sortedStatements[0]?.total ?? 0,
				heatingCosts: sortedStatements[0]?.heatingCosts ?? 0,
				utilityCosts: sortedStatements[0]?.utilityCosts ?? 0,
				usageMonths: 0
			};
			sortedStatements.forEach((statement) => {
				if (statement.total === lastPrepayment.total) lastPrepayment.usageMonths++;
				else {
					prepayments.push(lastPrepayment);
					lastPrepayment = {
						total: statement.total,
						heatingCosts: statement.heatingCosts,
						utilityCosts: statement.utilityCosts,
						usageMonths: 1
					};
				}
			});
			prepayments.push(lastPrepayment);
			return prepayments;
		}
		getTotalPrepayments() {
			const totals = this.getFullPrepaymentHistory().reduce((sum, prepayment) => {
				sum.total += prepayment.total;
				sum.heatingCosts += prepayment.heatingCosts;
				sum.utilityCosts += prepayment.utilityCosts;
				return sum;
			}, {
				total: 0,
				heatingCosts: 0,
				utilityCosts: 0
			});
			return {
				total: Math.abs(totals.total),
				heatingCosts: Math.abs(totals.heatingCosts),
				utilityCosts: Math.abs(totals.utilityCosts)
			};
		}
		getBkaAmountComponents() {
			const totalOperatingCosts = this.getTenantShare();
			const totalHeatingCosts = this.getTenantHeatingCosts();
			return [
				{
					operation: "Add",
					amount: this.getTotalPrepayments().total,
					description: "Prepayments",
					key: "prepayments"
				},
				{
					operation: "Sub",
					amount: totalOperatingCosts,
					description: "Operating Costs",
					key: "operating_costs"
				},
				{
					operation: "Sub",
					amount: totalHeatingCosts,
					description: "Heating Costs",
					key: "heating_costs"
				}
			];
		}
		/**
		* Negative amount represent that tenant owns us money. Positive amount that Reneo should pay back to a tenant
		* @returns The BKA amount
		*/
		calculateBkaAmount(_excludeDepositRetention = false) {
			return round(this.getBkaAmountComponents().reduce((sum, component) => sum + component.amount * (component.operation === "Sub" ? -1 : 1), 0), 2);
		}
		calculateBalanceWithDeposit(withholdDepositAmount, withholdOutstandingBkaAmount) {
			return round(-this.calculateBkaAmount() + (withholdDepositAmount ?? this.depositRetention?.withholdDepositAmount ?? 0) + (withholdOutstandingBkaAmount ?? this.depositRetention?.withholdOutstandingBkaAmount ?? 0), 2);
		}
		calculateOwnershipSplit(newTotalAmount) {
			const expiredOwnerDays = this.ownershipSplitting?.hasOwnershipChange ? this.ownershipSplitting?.expiredOwnerPeriod?.days ?? 0 : 0;
			const activeOwnerDays = this.ownershipSplitting?.activeOwnerPeriod?.days ?? (this.ownershipSplitting?.hasOwnershipChange && this.ownershipSplitting?.expiredOwnerPeriod?.days ? 0 : this.usageDays);
			const expiredOwnerShare = (newTotalAmount ?? this.amount) * expiredOwnerDays / this.usageDays;
			const activeOwnerShare = (newTotalAmount ?? this.amount) * activeOwnerDays / this.usageDays;
			return {
				...this.ownershipSplitting,
				hasOwnershipChange: this.ownershipSplitting?.hasOwnershipChange ?? false,
				activeOwnerPeriod: {
					start: this.ownershipSplitting?.activeOwnerPeriod?.start ?? null,
					end: this.ownershipSplitting?.activeOwnerPeriod?.end ?? null,
					days: this.ownershipSplitting?.activeOwnerPeriod?.days ?? 0
				},
				expiredOwnerShare: round(expiredOwnerShare, 2),
				activeOwnerShare: round(activeOwnerShare, 2)
			};
		}
		isValidStatusTransition(newStatus) {
			if (newStatus === this.status) return true;
			const currentStatus = this.status;
			return ({
				["Created"]: ["Prepared", "Sent"],
				["Prepared"]: ["Created", "Sent"],
				["Sent"]: [
					"Prepared",
					"Paid",
					"Underpaid",
					"Overpaid",
					"Created"
				],
				["Paid"]: [
					"Sent",
					"Underpaid",
					"Overpaid"
				],
				["Underpaid"]: [
					"Sent",
					"Paid",
					"Overpaid"
				],
				["Overpaid"]: [
					"Sent",
					"Paid",
					"Underpaid"
				]
			}[currentStatus] || []).includes(newStatus);
		}
		calculateDegreeDaysData() {
			if (!this.usagePeriodStart || !this.usagePeriodEnd) throw new Error("Usage period start and end are required to calculate degree days config");
			const isLeapYear = this.year % 4 === 0 && this.year % 100 !== 0 || this.year % 400 === 0;
			const usageStart = new Date(this.usagePeriodStart);
			const usageEnd = new Date(this.usagePeriodEnd);
			usageStart.setHours(0, 0, 0, 0);
			usageEnd.setHours(23, 59, 59, 999);
			const config = [
				{
					id: "1",
					month: "Jan.",
					daysInMonth: 31,
					degreeDaysPerMonth: 170,
					degreeDaysPerDay: 5.484,
					usedDays: 0,
					usageAmount: 0
				},
				{
					id: "2",
					month: "Feb.",
					daysInMonth: isLeapYear ? 29 : 28,
					degreeDaysPerMonth: 150,
					degreeDaysPerDay: isLeapYear ? 5.357 : 5.172,
					usedDays: 0,
					usageAmount: 0
				},
				{
					id: "3",
					month: "März",
					daysInMonth: 31,
					degreeDaysPerMonth: 130,
					degreeDaysPerDay: 4.194,
					usedDays: 0,
					usageAmount: 0
				},
				{
					id: "4",
					month: "Apr.",
					daysInMonth: 30,
					degreeDaysPerMonth: 80,
					degreeDaysPerDay: 2.667,
					usedDays: 0,
					usageAmount: 0
				},
				{
					id: "5",
					month: "Mai",
					daysInMonth: 31,
					degreeDaysPerMonth: 40,
					degreeDaysPerDay: 1.29,
					usedDays: 0,
					usageAmount: 0
				},
				{
					id: "6",
					month: "Juni",
					daysInMonth: 30,
					degreeDaysPerMonth: 13.04,
					degreeDaysPerDay: .43,
					usedDays: 0,
					usageAmount: 0
				},
				{
					id: "7",
					month: "Juli",
					daysInMonth: 31,
					degreeDaysPerMonth: 13.48,
					degreeDaysPerDay: .43,
					usedDays: 0,
					usageAmount: 0
				},
				{
					id: "8",
					month: "Aug.",
					daysInMonth: 31,
					degreeDaysPerMonth: 13.48,
					degreeDaysPerDay: .43,
					usedDays: 0,
					usageAmount: 0
				},
				{
					id: "9",
					month: "Sept.",
					daysInMonth: 30,
					degreeDaysPerMonth: 30,
					degreeDaysPerDay: 1,
					usedDays: 0,
					usageAmount: 0
				},
				{
					id: "10",
					month: "Okt.",
					daysInMonth: 31,
					degreeDaysPerMonth: 80,
					degreeDaysPerDay: 2.581,
					usedDays: 0,
					usageAmount: 0
				},
				{
					id: "11",
					month: "Nov.",
					daysInMonth: 30,
					degreeDaysPerMonth: 120,
					degreeDaysPerDay: 4,
					usedDays: 0,
					usageAmount: 0
				},
				{
					id: "12",
					month: "Dez.",
					daysInMonth: 31,
					degreeDaysPerMonth: 160,
					degreeDaysPerDay: 5.161,
					usedDays: 0,
					usageAmount: 0
				}
			];
			config.forEach((monthConfig, monthIndex) => {
				const monthStart = new Date(this.year, monthIndex, 1);
				const monthEnd = new Date(this.year, monthIndex, monthConfig.daysInMonth, 23, 59, 59, 999);
				const overlapStart = new Date(Math.max(usageStart.getTime(), monthStart.getTime()));
				const overlapEnd = new Date(Math.min(usageEnd.getTime(), monthEnd.getTime()));
				if (overlapStart <= overlapEnd) {
					monthConfig.usedDays = round((overlapEnd.getTime() - overlapStart.getTime()) / (1e3 * 60 * 60 * 24));
					monthConfig.usageAmount = Math.min(1, monthConfig.usedDays / monthConfig.daysInMonth);
				} else monthConfig.usageAmount = 0;
				monthConfig.usageAmount = round(monthConfig.usageAmount * monthConfig.degreeDaysPerMonth, 3);
			});
			return config;
		}
	};
}));
//#endregion
//#region src/domains/renting/annual-service-charge-statement/annual-service-charge-statement.i18n.ts
var heatingCostMethodLabels, serviceChargeDistributionKeyLabels, depositRetentionReasonLabels;
var init_annual_service_charge_statement_i18n = __esmMin((() => {
	init_annual_service_charge_statement_model();
	heatingCostMethodLabels = {
		["DegreeDays"]: "Degree Days",
		["ManualSplit"]: "Manual Split",
		["Individual"]: "Individual"
	};
	serviceChargeDistributionKeyLabels = {
		["total_area_m2"]: "Gesamtfläche",
		["commercial_area_m2"]: "Gewerbefläche",
		["usable_area_m2"]: "Nutzfläche",
		["weighted_area_m2"]: "Gewerbefaktor",
		["living_area_m2"]: "Wohnfläche",
		["total_units"]: "Gesamteinheiten",
		["residential_units"]: "Wohneinheiten",
		["commercial_units"]: "Anzahl Gewerbeeinheiten",
		["registered_persons"]: "Personenzahl",
		["person_days"]: "Personentage",
		["person_months"]: "Personenmonate",
		["actual_consumption"]: "Verbrauchseinheiten",
		["heating_units"]: "Heizeinheiten",
		["water_m3"]: "Wasserverbrauch",
		["warm_water_m3"]: "Warmwasserverbrauch",
		["electricity_kwh"]: "Stromverbrauch",
		["gas_m3"]: "Gasverbrauch",
		["thousandths"]: "Tausendstel",
		["land_register_share"]: "Grundbuchanteile",
		["fixed_amount"]: "Festbetrag",
		["fixed_percentage"]: "Prozentual",
		["custom_ratio"]: "Individuelles Verhältnis",
		["contract_specific"]: "Vertragsspezifisch",
		["zero_allocation"]: "Keine Umlage",
		["radiator_count"]: "Heizkörper",
		["radiator_units"]: "Heizeinheiten",
		["smoke_detector_count"]: "Anzahl RWM",
		["window_count"]: "Anzahl Fenster",
		["window_area_m2"]: "Fensterfläche",
		["parking_spaces"]: "Anzahl Stellplätze",
		["underground_parking_spaces"]: "Anzahl TG-Plätze",
		["balcony_area_m2"]: "Balkonfläche",
		["room_count"]: "Anzahl Zimmer",
		["bathroom_count"]: "Anzahl Badezimmer",
		["occupancy_days"]: "Abrechnungs-/Nutzungstage",
		["occupancy_months"]: "Nutzungsmonate",
		["rental_months"]: "Mietmonate",
		["degree_days"]: "Gradtagszahlen",
		["floor_level"]: "Geschosshöhe",
		["staircase_assignment"]: "Treppenhaus Nutzung",
		["insurance"]: "Versicherungen",
		["betriebskostenspiegel"]: "Betriebskostenspiegel",
		["heizkostenverordnung"]: "Heizkostenverordnung",
		["wirtschaftseinheit"]: "Wirtschaftseinheit",
		["nutzeinheit"]: "Nutzeinheit",
		["tax_assessment_share"]: "Steuerbescheid",
		["co_ownership_share"]: "Miteigentumsanteil",
		["residential_units_hs"]: "Wohnungen HS",
		["total_units_hs"]: "Einheiten HS",
		["object_units"]: "Einheiten Objekt",
		["cable_tv_units"]: "Einheit Kabelfernsehen",
		["emission_measurement"]: "Immissionsmessung",
		["waste_container"]: "Mülltonne",
		["garden_area_m2"]: "Gartenfläche",
		["basement_area_m2"]: "Kellerfläche",
		["elevator_usage"]: "Aufzug Nutzung",
		["households"]: "Haushalte",
		["janitor_service"]: "Hausmeister",
		["cleaning_service"]: "Hausreinigung",
		["winter_service"]: "Winterdienst",
		["garden_maintenance"]: "Gartenpflege",
		["special_agreement"]: "Nach Vereinbarung"
	};
	depositRetentionReasonLabels = {
		["bka-outstanding"]: "Outstanding BKA costs",
		["damages"]: "Damage costs",
		["arrears"]: "Rent arrears",
		["cleaning"]: "Final cleaning costs",
		["repairs"]: "Outstanding repair costs"
	};
}));
//#endregion
//#region src/domains/renting/annual-service-charge-statement/annual-service-charge-statement.opts.ts
var init_annual_service_charge_statement_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/renting/annual-service-charge-statement/index.ts
var init_annual_service_charge_statement = __esmMin((() => {
	init_annual_service_charge_distribution_model();
	init_annual_service_charge_statement_class();
	init_annual_service_charge_statement_i18n();
	init_annual_service_charge_statement_model();
	init_annual_service_charge_statement_opts();
}));
//#endregion
//#region src/domains/renting/rent.model.ts
var RentIncreaseType, RentIncreaseTypeEnumSchema, BaseRentSchema, RentSchema, ActiveRentAmountsSchema, rentSchemas;
var init_rent_model = __esmMin((() => {
	init_lib();
	init_bank_transaction_model();
	init_rental_contract_unit_model();
	RentIncreaseType = /* @__PURE__ */ function(RentIncreaseType) {
		RentIncreaseType["Temp"] = "Temp";
		RentIncreaseType["FRI"] = "FRI";
		RentIncreaseType["IRI"] = "IRI";
		return RentIncreaseType;
	}({});
	RentIncreaseTypeEnumSchema = TEnum(RentIncreaseType, { $id: "RentIncreaseTypeEnum" });
	BaseRentSchema = Type.Object({
		rentId: Type.Optional(Type.Number()),
		coldRent: Type.Number(),
		utilityCost: Type.Optional(Type.Number()),
		heatingCost: Type.Optional(Type.Number()),
		parkingSpaceRent: Type.Optional(Type.Number()),
		totalRent: Type.Number(),
		startDate: RequiredStringDateSchema,
		endDate: Type.Optional(StringDateSchema),
		isColdRentWithParking: Type.Optional(Type.Boolean()),
		rentIncreaseType: Type.Optional(Type.Ref(RentIncreaseTypeEnumSchema)),
		cpi: Type.Optional(Type.Number()),
		cpiDate: Type.Optional(StringDateSchema),
		cpiStartDate: Type.Optional(StringDateSchema),
		rentalContractUnitId: Type.Optional(Type.Number()),
		vat: Type.Optional(Type.Number())
	}, { $id: "BaseRent" });
	RentSchema = Type.Intersect([Type.Ref(BaseRentSchema), Type.Object({
		rentalContractUnit: Type.Optional(Type.Ref(RentalContractUnitSchema)),
		transactions: Type.Optional(Type.Array(Type.Ref(BankTransactionSchema)))
	})], { $id: "Rent" });
	ActiveRentAmountsSchema = Type.Object({
		estateId: Type.Number(),
		escrowBankAccountId: Type.Number(),
		rentalContractId: Type.Optional(Type.Number()),
		rentalContractStartDate: RequiredStringDateSchema,
		rentalContractEndDate: Type.Optional(StringDateSchema),
		rentFreePeriodInMonths: Type.Optional(TNullable(Type.Number())),
		ancillaryCostFreeStartDate: Type.Optional(StringDateSchema),
		ancillaryCostFreeEndDate: Type.Optional(StringDateSchema),
		rentTenancyId: Type.Optional(Type.Number()),
		rentalContractUnitId: TNullable(Type.Number()),
		rentStartDate: RequiredStringDateSchema,
		rentEndDate: Type.Optional(StringDateSchema),
		rentId: Type.Number(),
		coldRent: Type.Number(),
		utilityCost: Type.Number(),
		heatingCost: Type.Number(),
		parkingCost: Type.Number()
	}, { $id: "ActiveRentAmounts" });
	rentSchemas = {
		RentSchema,
		ActiveRentAmountsSchema,
		BaseRentSchema,
		RentIncreaseTypeEnumSchema
	};
}));
//#endregion
//#region src/domains/renting/rental-contract/rental-contract.class.ts
var RentalContract;
var init_rental_contract_class = __esmMin((() => {
	init_cross_cutting();
	init_note_class();
	init_review_process_class();
	init_bank_transaction_class();
	init_annual_service_charge_statement();
	init_base_period_class();
	init_rent_helpers();
	init_rent_tenancy_class();
	init_rent_model();
	init_rental_contract_unit_class();
	init_rental_contract_model();
	RentalContract = class RentalContract extends BasePeriodClass {
		rentalContractId;
		status;
		type;
		estateId;
		rentTenancyId = null;
		documentId = null;
		estarCoreRentalContractId = null;
		parentTenancyId = null;
		parentId = null;
		rentingLeadId = null;
		rentingProcessId = null;
		coldRent = null;
		heatingCost = null;
		utilityCost = null;
		monthlyAdditionalRent = null;
		parkingSpaceRent = null;
		hasParkingSpace = null;
		isColdRentWithParking;
		isJobCenter = null;
		isSecondaryRent = null;
		numberOfTenantsAtViewing = null;
		/**
		* @deprecated Use rentingLeadId instead
		*/
		tenantsWithNetIncome = null;
		updateRentOnApproval;
		livingSpace = null;
		isLivings;
		isFlatshare;
		isFurnished;
		rentIncreaseType = null;
		rentIncreaseFormula = null;
		rentIncreaseInterval = null;
		friIncreaseAmount = null;
		friIncreaseAmountType = null;
		friIncreaseCycles = null;
		iriMinCap = null;
		iriMaxCap = null;
		rentalFreePeriod = null;
		rentFreePeriodInMonths = null;
		ancillaryCostFreeStartDate = null;
		ancillaryCostFreeEndDate = null;
		rentDeposit = null;
		depositReturnDate = null;
		depositReturnAmount = null;
		paidRentDeposit = null;
		trackDepositAutomatically = null;
		numberOfInstallments = null;
		coldRentChurnPerSQM = null;
		commercialVATDamage = null;
		commercialRentIndexIncrease = null;
		reletDelayInMonths = null;
		rentIncreaseEndDate = null;
		isRefurbishedByCurrentOwner = null;
		apartmentCondition = null;
		condoSalesCondition = null;
		condoRefurbishmentCostsPerSQM = null;
		rentBeforeIncrease = null;
		securityDeposit = null;
		vat = null;
		lastRentIncreaseDate = null;
		valueOfLastRentIncrease = null;
		percentageOfLastRentIncrease = null;
		isStorageRoomInAtticIsRented = null;
		equipmentFeatures = null;
		option = null;
		otherAgreements = null;
		isRentalContractSigned = null;
		isRentIncreaseSigned = null;
		isRentalContractChecked = null;
		otherNote = null;
		regulationOfRentIncreaseNote = null;
		rentBalance = 0;
		rentTenancy;
		reviewProcess;
		estate;
		document;
		notes;
		rentalContractUnits;
		bankTransactions;
		rentingLead;
		annualServiceChargeStatements;
		parentContract;
		rentingProcess;
		constructor(props) {
			const assignable = omit(props, "rents");
			super(assignable);
			Object.assign(this, assignable);
			if (props?.rentTenancy) this.rentTenancy = new RentTenancy(props.rentTenancy);
			if (props?.reviewProcess) this.reviewProcess = new ReviewProcess(props.reviewProcess);
			if (props?.notes) this.notes = props.notes.map((note) => new Note(note));
			if (props?.rentalContractUnits) this.rentalContractUnits = props.rentalContractUnits.map((rcu) => new RentalContractUnit(rcu));
			if (props?.bankTransactions) this.bankTransactions = props.bankTransactions.map((tx) => new BankTransaction(tx));
			if (props?.annualServiceChargeStatements) this.annualServiceChargeStatements = props.annualServiceChargeStatements.map((ascs) => new AnnualServiceChargeStatement(ascs));
			if (props?.parentContract) this.parentContract = new RentalContract(props.parentContract);
		}
		get title() {
			return `${this.rentalContractId} - ${this.type} [${this.dateRangeLabel}]`;
		}
		get optionLabel() {
			return `${this.rentalContractId}: ${this.type} (${this.dateRangeLabel})${this.isLivings ? ", Livings" : ""}${this.parentId ? `, parent: ${this.parentId}` : ""}`;
		}
		get optionLabelWithRu() {
			const ruSuffix = this.rentalContractUnits?.[0]?.rentableUnit?.type;
			return `${this.optionLabel}, RU: ${ruSuffix}`;
		}
		/**
		* @returns **unique** estateIds bound to this contract - estateIds come from `rentalContract.rentalContractUnits.rentableUnits.estateId`
		*/
		get estateIds() {
			return Array.from(new Set(this.rentableUnits.map((ru) => ru.estateId).filter(Boolean)));
		}
		/**
		* @returns **unique** estates bound to this contract - estates come from `rentalContract.rentalContractUnits.rentableUnits.estate`
		*/
		get estates() {
			return Array.from(new Map(this.rentableUnits.map((ru) => ru.estate).filter(Boolean).map((estate) => [estate.estateId, estate])).values());
		}
		get rentableUnits() {
			return this.rentalContractUnits?.map((rcu) => rcu.rentableUnit).filter(Boolean) ?? [];
		}
		get rents() {
			return this.rentalContractUnits?.flatMap((rcu) => rcu.rents).filter(Boolean) ?? [];
		}
		get totalMonthlyRent() {
			return this.rents?.reduce((sum, rent) => sum + rent.getTotalRent(), 0) || 0;
		}
		get nextRentIncreaseDate() {
			const increaseInterval = this.rentIncreaseInterval ? this.rentIncreaseInterval * 12 : 12;
			if (!this.latestRent) return dayjs(this.startDate).add(increaseInterval, "month").toDate();
			return dayjs(this.latestRent.startDate).add(increaseInterval, "month").toDate();
		}
		get ancillaryCostFreePeriodDateRange() {
			return this.ancillaryCostFreeStartDate && this.ancillaryCostFreeEndDate ? `${formatDate$1(this.ancillaryCostFreeStartDate, DateFormats.SimpleDate)} - ${formatDate$1(this.ancillaryCostFreeEndDate, DateFormats.SimpleDate)}` : `-`;
		}
		get activeRent() {
			return this.rents?.find((rent) => rent.isActive);
		}
		get activeOrMostRecentRent() {
			if (this.activeRent) return this.activeRent;
			if (this.rents?.length) return sortObject(this.rents, "desc")[0];
			return null;
		}
		get latestRent() {
			if (!this.rents || !this.rents?.length) return;
			const sortedRents = sortObject(this.rents, "desc");
			return sortedRents.length ? sortedRents[0] : void 0;
		}
		get latestRentWithRentIncrease() {
			if (!this.rents || !this.rents?.length) return;
			const sortedRents = sortObject(this.rents.filter((r) => r.rentIncreaseType !== "Temp"), "desc");
			return sortedRents.length ? sortedRents[0] : void 0;
		}
		get isDraft() {
			return this.status === "Draft";
		}
		get isCancelled() {
			return this.status === "Cancelled";
		}
		get isApproved() {
			return this.status === "Approved";
		}
		get isSigned() {
			return this.status === "Signed";
		}
		get isEstarCoreContract() {
			return !!this.estarCoreRentalContractId;
		}
		static mutableFieldsWhenActive() {
			return [
				"endDate",
				"numberOfInstallments",
				"paidRentDeposit",
				"depositReturnDate",
				"depositReturnAmount",
				"trackDepositAutomatically"
			];
		}
		isWithinAncillaryCostFreePeriod(date) {
			if (!this.ancillaryCostFreeStartDate || !this.ancillaryCostFreeEndDate) return false;
			return dayjs(date).isBetween(this.ancillaryCostFreeStartDate, this.ancillaryCostFreeEndDate, "day", "[]");
		}
		isEligibleForRentIncrease() {
			if (!this.rentIncreaseType || this.rentIncreaseType === "NO_INCREASE" || this.rentIncreaseType === "MANUAL") return false;
			if (!this.isActive) return false;
			const currentDate = dayjs();
			const increaseInterval = this.rentIncreaseInterval ? this.rentIncreaseInterval * 12 : 12;
			const startDateCondition = dayjs(this.startDate).add(increaseInterval, "month").subtract(2, "months").isBefore(currentDate);
			const latestRent = this.latestRentWithRentIncrease;
			const lastRentStartDateCondition = !!latestRent && dayjs(latestRent.startDate).add(increaseInterval, "month").subtract(2, "months").isBefore(currentDate);
			const nextRentIncreaseDate = latestRent ? dayjs(latestRent.startDate).add(increaseInterval, "month") : dayjs(this.startDate).add(increaseInterval, "month");
			const tenancyDoesNotEndBeforeIncrease = !this.endDate || dayjs(this.endDate).isSameOrAfter(nextRentIncreaseDate);
			return startDateCondition && lastRentStartDateCondition && tenancyDoesNotEndBeforeIncrease;
		}
		getColdRentFreePeriodEndDate() {
			if (!this.rentFreePeriodInMonths) return null;
			const fullMonths = Math.floor(this.rentFreePeriodInMonths);
			const remainingDays = Math.round((this.rentFreePeriodInMonths - fullMonths) * 30) - 1;
			return dayjs(getHalfMonthRatio(new Date(this.startDate), "start") === 1 ? dayjs(this.startDate).startOf("month") : dayjs(this.startDate)).add(fullMonths, "month").add(remainingDays, "day").endOf("day").toDate();
		}
		/**
		* Returns the ratio of the cold rent for the month
		* @param month - the date to calculate the ratio for
		* @returns the ratio of the cold rent for the month
		* 0 - if the month is inside of the rent free period, no rent is paid
		* 0.5 - if the month is in the rent free period and ends in the middle of the month, half of the rent is paid
		* 1 - if the month is in the rent free period and ends at the end of the month, full rent is paid
		*/
		getColdRentFreePeriodRatioForMonth(month) {
			const rentFreeEndDate = this.getColdRentFreePeriodEndDate();
			if (rentFreeEndDate && dayjs(month).isSameOrBefore(rentFreeEndDate, "month")) {
				if (dayjs(month).isSame(rentFreeEndDate, "month") && dayjs(rentFreeEndDate).date() === 15) return .5;
				return 0;
			}
			return 1;
		}
		calculateNextRentIncrease(CPIData, prevRent) {
			let latestRent = prevRent;
			if (!latestRent) latestRent = this.latestRentWithRentIncrease;
			if (!latestRent) return 0;
			let amount = 0;
			switch (this.rentIncreaseType) {
				case "FRI":
					if (!this.friIncreaseAmount) throw new InvalidStateError("Cannot calculate next rent increase without FRI increase amount", { rentTenancyId: this.rentTenancyId });
					switch (this.friIncreaseAmountType) {
						case "Fixed":
							amount = this.calculateBasicFRI(latestRent.coldRent, this.friIncreaseAmount);
							break;
						case "Percentage":
							amount = this.calculateBasicFRI(latestRent.coldRent, this.friIncreaseAmount / 100 * latestRent.coldRent);
							break;
						default: throw new InvalidStateError("Cannot calculate next rent increase without a FRI increase amount type", { rentTenancyId: this.rentTenancyId });
					}
					break;
				case "IRI": {
					if (!CPIData) throw new InvalidStateError("Cannot calculate next rent increase without a selected CPI", { rentTenancyId: this.rentTenancyId });
					const currentCPIPoint = Array.isArray(CPIData) ? sum(CPIData) / CPIData.length : CPIData;
					if (!latestRent.cpi) throw new InvalidStateError("Cannot calculate next rent increase without a base CPI", { rentTenancyId: this.rentTenancyId });
					switch (this.rentIncreaseFormula) {
						case "BasicIRI":
							amount = this.calculateBasicIRI(latestRent.coldRent, latestRent.cpi, currentCPIPoint);
							break;
						case "IRIMinCap":
							if (!this.iriMinCap) throw new InvalidStateError("Cannot calculate next rent increase without a min threshold percentage", { rentTenancyId: this.rentTenancyId });
							amount = this.calculateIRIMinCap(latestRent.coldRent, latestRent.cpi, currentCPIPoint, this.iriMinCap);
							break;
						case "IRIMaxCap":
							if (!this.iriMaxCap) throw new InvalidStateError("Cannot calculate next rent increase without a max threshold percentage", { rentTenancyId: this.rentTenancyId });
							amount = this.calculateIRIMaxCap(latestRent.coldRent, latestRent.cpi, currentCPIPoint, this.iriMaxCap);
							break;
						case "IRIAveraged":
							amount = this.calculateIRIAveraged(latestRent.coldRent, latestRent.cpi, Array.isArray(CPIData) ? CPIData : [CPIData]);
							break;
						default: throw new InvalidStateError("Can't calculate next rent increase without a rent increase formula", { rentTenancyId: this.rentTenancyId });
					}
					break;
				}
				case "NO_INCREASE":
					amount = latestRent.coldRent;
					break;
				default: throw new InvalidStateError("Can't calculate next rent increase without a rent increase type", { rentTenancyId: this.rentTenancyId });
			}
			return round(amount, 2);
		}
		calculateBasicFRI(currentColdRent, increaseAmount) {
			return currentColdRent + increaseAmount;
		}
		calculateBasicIRI(currentColdRent, baseCPI, currentCPI) {
			return currentColdRent * (currentCPI / baseCPI);
		}
		calculateIRIMinCap(currentColdRent, baseCPI, currentCPI, minThresholdPercentage) {
			return (currentCPI - baseCPI) / baseCPI * 100 >= minThresholdPercentage ? this.calculateBasicIRI(currentColdRent, baseCPI, currentCPI) : currentColdRent;
		}
		calculateIRIMaxCap(currentColdRent, baseCPI, currentCPI, maxThresholdPercentage) {
			return Math.min(this.calculateBasicIRI(currentColdRent, baseCPI, currentCPI), currentColdRent * (1 + maxThresholdPercentage / 100));
		}
		calculateIRIAveraged(currentColdRent, baseCPI, multiMonthCPI) {
			const averageCPI = sum(multiMonthCPI) / multiMonthCPI.length;
			return this.calculateBasicIRI(currentColdRent, baseCPI, averageCPI);
		}
		/**
		* migrated from RentTenancy class
		*/
		getActiveRentForMonth(date) {
			const dateFormatted = new Date(date);
			if (this.rents?.length) return sortObject(this.rents, "asc")?.find((rent) => {
				const startDate = new Date(rent.startDate);
				const endDate = rent.endDate ? new Date(rent.endDate) : null;
				return dateFormatted >= startDate && (endDate && dateFormatted <= endDate || !endDate);
			}) ?? null;
			return null;
		}
		getLastRentBefore(rent) {
			if (!this.rents?.length) return null;
			if (!rent.startDate) throw new Error("Cannot get previous rent without current start date");
			return this.rents.filter((r) => r.rentIncreaseType !== "Temp").sort((a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime()).filter((r) => r.endDate && new Date(r.endDate) <= new Date(rent.startDate)).pop() ?? null;
		}
		getExpectedRentPayments() {
			return this?.rents?.reduce((total, rent) => {
				if (new Date(rent.startDate) > /* @__PURE__ */ new Date()) return total;
				total += rent.getExpectedRentToBePaid(this);
				return total;
			}, 0) ?? 0;
		}
		/**
		* Don't consider the ancillary cost free period + rent free period here
		* as investor should receive the full rent amount (Reneo covers the extra costs)
		*/
		getExpectedOwnerRentIncome(month, includeFullMonth = false) {
			const rentComponents = { coldRent: this.getColdRentFreePeriodRatioForMonth(month) };
			return this?.rents?.reduce((total, rent) => {
				return total + rent.getExpectedRentPaymentForMonth(month, rentComponents, includeFullMonth);
			}, 0) ?? 0;
		}
		getRentalTransactions() {
			return this.bankTransactions ?? [];
		}
		getRentsForRentableUnit(rentableUnitId) {
			return this.rents?.filter((rent) => rent.rentalContractUnit?.rentableUnitId === rentableUnitId);
		}
		getRentsForRentalContractUnit(rentalContractUnitId) {
			return this.rents?.filter((rent) => rent.rentalContractUnitId === rentalContractUnitId);
		}
		hasDateOverlap(rentalContracts) {
			if (!this.type) throw new InvariantError("Rental contract type is required to check for date overlaps", { rentalContractId: this.rentalContractId });
			if (!this.startDate) throw new InvariantError("Rental contract start date is required to check for date overlaps", { rentalContractId: this.rentalContractId });
			if (rentalContracts.length === 0 || !this.rentalContractUnits?.length) return false;
			let signedOrApprovedRentalContracts = rentalContracts.filter((rc) => (!this.rentalContractId || rc.rentalContractId !== this.rentalContractId) && ["Signed", "Approved"].includes(rc.status));
			const contractUnitIds = this.rentalContractUnits?.map((rcu) => rcu.rentableUnitId) ?? [];
			signedOrApprovedRentalContracts = signedOrApprovedRentalContracts.filter((rc) => rc.rentalContractUnits?.some((rcu) => contractUnitIds.includes(rcu.rentableUnitId)));
			if (this.type === "Sublease") signedOrApprovedRentalContracts = signedOrApprovedRentalContracts.filter((rc) => !this.parentId || rc.parentId === this.parentId);
			else signedOrApprovedRentalContracts = signedOrApprovedRentalContracts.filter((rc) => rc.type !== "Sublease");
			return signedOrApprovedRentalContracts.some((rc) => arePeriodsOverlapping({
				startDate: rc.startDate,
				endDate: rc.endDate
			}, {
				startDate: this.startDate,
				endDate: this.endDate
			}));
		}
		/**
		* Find rent that matches the transaction valueDate
		*/
		findRentForTransactionDate(valueDate) {
			const allRents = this.rents ?? [];
			if (allRents.length) {
				let rent = allRents.find((rent) => isActiveAtDate(valueDate, rent));
				if (!rent) {
					rent = allRents.filter((rent) => dayjs(rent.startDate).isBefore(valueDate)).pop();
					const firstRent = allRents[0];
					if (!rent && dayjs(valueDate).isSameOrBefore(firstRent?.startDate, "month")) rent = firstRent;
				}
				return rent;
			}
		}
		validateDataReadiness(status) {
			if (status === "Cancelled") return;
			const { isValid, errors } = RentalContract.isValid(this);
			if (!isValid) throw new ValidationFailedError(`Rental contract is not valid. First error: ${errors[0]}`, {
				rentalContractId: this.rentalContractId,
				estateId: this.estateId,
				errors
			});
		}
		static isValid(rentalContract) {
			const errors = [];
			if (!rentalContract.startDate) errors.push("Need to have a start date on rental contract");
			if (!dayjs(rentalContract.startDate).isAfter(/* @__PURE__ */ new Date("1960-01-01"))) errors.push("Rental contract start date should not be earlier than 1960-01-01");
			if (rentalContract.endDate && !dayjs(rentalContract.endDate).isAfter(rentalContract.startDate)) errors.push("Rental contract end date should be after start date");
			if (!(rentalContract.rentalContractUnits?.length === 1 && rentalContract.rentalContractUnits[0].rentableUnit?.type === "Parking")) {
				if (!rentalContract.coldRent) errors.push("Cold rent should be defined in the rental contract");
				if (!rentalContract.rentIncreaseType) errors.push("Need to have rent increase type on rental contract to create rent tenancy");
				if (rentalContract.hasParkingSpace && !rentalContract.parkingSpaceRent) errors.push("Parking space rent should be defined in the rental contract");
				if (!rentalContract.rentDeposit) errors.push("Need to have rent deposit on rental contract");
			}
			if (rentalContract.status === "Signed") {
				if (!rentalContract.rentTenancyId) errors.push("Need to have linked rent tenancy on rental contract to create rents");
			}
			if (rentalContract.type === "Addendum") {
				if (!rentalContract.parentId) errors.push("Need to have linked parent rental contract on addendum");
			}
			if (!rentalContract.isLivings && !rentalContract.rentTenancyId) {
				if (!rentalContract.rentingLeadId) errors.push("Rental contract must renting lead assigned");
				if (rentalContract.rentingLead?.contacts?.length && rentalContract.rentingLead?.companies?.length) errors.push("Rental contract must have only one type of tenants assigned");
			}
			return {
				isValid: errors.length === 0,
				errors
			};
		}
	};
}));
//#endregion
//#region src/domains/renting/rental-contract/rental-contract.opts.ts
var init_rental_contract_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/renting/rental-contract/rental-contract.i18n.ts
var rentIncreaseTypeExplanations, rentIncreaseFormulaExplanations, rentIncreaseFormulaReadableNames;
var init_rental_contract_i18n = __esmMin((() => {
	init_rental_contract_model();
	rentIncreaseTypeExplanations = {
		["MANUAL"]: "Manual Rent Increase, the rent will be increased manually by the user",
		["NO_INCREASE"]: "No Increase is set",
		["IRI"]: "Increase Rent Index, the rent will be increased based on CPI related formula (e.g. Basic IRI, IRI with Min Cap, IRI with Max Cap, IRI Averaged)",
		["FRI"]: "Fixed Rate Increase, the rent will be increased by a fixed amount at predetermined intervals"
	};
	rentIncreaseFormulaExplanations = {
		["FRI"]: "Fixed Rate Increase (FRI increases rent at predetermined intervals according to a fixed schedule outlined in the rental contract.)",
		["BasicIRI"]: "The Basic formula for Rent Adjustment: New Rent = Old Rent * (current CPI/ base CPI (CPI at the start of the tenancy or last adjustment))",
		["IRIMinCap"]: "IRI with Min Cap (Landlords and tenants may agree that rent will only be adjusted if the CPI increases by a minimum percentage (e.g., 3%). This avoids small, frequent increases. The increase is then applied only when this threshold is met.)",
		["IRIMaxCap"]: "IRI with Max Cap (Landlords and tenants may agree to have a cap on how much the rent can increase within a given period, regardless of the change in the CPI. For example, the rent might not be allowed to increase by more than 10% per year, even if the CPI increases significantly.)",
		["IRIAveraged"]: "Instead of using a single month's CPI, the parties can agree to calculate the rent increase based on an average CPI over multiple months or years. This smooths out the volatility in inflation."
	};
	rentIncreaseFormulaReadableNames = {
		["FRI"]: "Fixed Rate Increase",
		["BasicIRI"]: "Basic IRI",
		["IRIMinCap"]: "IRI with Min Cap",
		["IRIMaxCap"]: "IRI with Max Cap",
		["IRIAveraged"]: "IRI Averaged"
	};
}));
//#endregion
//#region src/domains/renting/rental-contract/index.ts
var init_rental_contract = __esmMin((() => {
	init_rental_contract_model();
	init_rental_contract_class();
	init_rental_contract_opts();
	init_rental_contract_i18n();
}));
//#endregion
//#region src/domains/renting/rent.class.ts
var Rent;
var init_rent_class = __esmMin((() => {
	init_investment_case_class();
	init_base_period_class();
	init_rent_helpers();
	init_rental_contract();
	init_rental_contract_unit_class();
	dayjs.extend(isBetween);
	dayjs.extend(minMax);
	dayjs.extend(isSameOrBefore);
	Rent = class Rent extends BasePeriodClass {
		rentId;
		coldRent;
		utilityCost;
		heatingCost;
		parkingSpaceRent;
		totalRent;
		rentIncreaseType;
		cpiStartDate;
		cpiDate;
		cpi;
		isColdRentWithParking;
		rentalContractUnitId;
		rentalContractUnit;
		vat;
		constructor(props) {
			super(props);
			Object.assign(this, props);
			if (props.startDate && !(props.startDate instanceof Date)) this.startDate = dayjs(props.startDate).toDate();
			if (props.endDate && !(props.endDate instanceof Date)) this.endDate = dayjs(props.endDate).toDate();
			if (props.rentalContractUnit) this.rentalContractUnit = new RentalContractUnit(props.rentalContractUnit);
		}
		static createFromListing(rentingListing, approvedSellingInvestmentCase) {
			let coldRent = 0;
			let heatingCost = 0;
			let utilityCost = 0;
			let parkingSpaceRent = 0;
			if (approvedSellingInvestmentCase) parkingSpaceRent = new InvestmentCase(approvedSellingInvestmentCase).parkingSpacePrice ?? 0;
			if (rentingListing) {
				coldRent = rentingListing.monthlyColdRent ?? 0;
				heatingCost = rentingListing.heatingCosts ?? 0;
				utilityCost = rentingListing.serviceCharge ?? 0;
			}
			const totalRent = coldRent + heatingCost + utilityCost + parkingSpaceRent;
			return new Rent({
				coldRent,
				heatingCost,
				utilityCost,
				parkingSpaceRent,
				totalRent
			});
		}
		getTotalRent() {
			return this.coldRent + (this.isColdRentWithParking ? 0 : this.parkingSpaceRent || 0) + (this.heatingCost || 0) + (this.utilityCost || 0);
		}
		getExpectedRentToBePaid(rentalContract) {
			const { ancillaryCostFreeStartDate, ancillaryCostFreeEndDate } = rentalContract;
			const rc = new RentalContract(rentalContract);
			const rentStart = dayjs.max(dayjs("2022.01.01"), dayjs(this.startDate)).toDate();
			const rentEnd = this.endDate ? dayjs(this.endDate) : dayjs();
			const monthCnt = Math.floor(dayjs(rentEnd).diff(dayjs(rentStart).tz("Europe/Berlin"), "month", true)) + (!dayjs(rentStart).isSame(rentEnd) ? 1 : 0);
			let totalRent = 0;
			times(monthCnt).forEach((_, i) => {
				const cursorDate = dayjs(rentStart).add(i, "month").startOf("month");
				const rentFreePeriodRatio = rc.getColdRentFreePeriodRatioForMonth(cursorDate.toDate());
				if (cursorDate.isAfter(dayjs(), "month") || !rentFreePeriodRatio) return;
				const isCursorOnStartDate = cursorDate.isSame(rentStart, "month");
				const isCursorOnEndDate = !!this.endDate && cursorDate.isSame(this.endDate, "month");
				const isCursorOnAncillaryCostFreeEndDate = cursorDate.isSame(ancillaryCostFreeEndDate, "month");
				const halfMonthRatio = isCursorOnStartDate && getHalfMonthRatio(rentStart, "start") || isCursorOnEndDate && getHalfMonthRatio(rentEnd.toDate(), "end") || rentFreePeriodRatio || 1;
				const isWithinAncillaryCostFreePeriod = ancillaryCostFreeStartDate && ancillaryCostFreeEndDate && (cursorDate.isBetween(dayjs(ancillaryCostFreeStartDate).startOf("month"), ancillaryCostFreeEndDate, "month", "[)") || isCursorOnAncillaryCostFreeEndDate && dayjs(ancillaryCostFreeEndDate).endOf("month").isSame(ancillaryCostFreeEndDate, "day"));
				const ancillaryCostRatio = !isWithinAncillaryCostFreePeriod && (isCursorOnStartDate && ancillaryCostFreeStartDate && getHalfMonthRatio(dayjs(ancillaryCostFreeStartDate).toDate(), "start") || (isCursorOnEndDate || isCursorOnAncillaryCostFreeEndDate) && ancillaryCostFreeEndDate && dayjs(ancillaryCostFreeEndDate).date() <= 15) ? .5 : 1;
				let currentMonthRent = this.coldRent + (this.parkingSpaceRent || 0);
				if (!isWithinAncillaryCostFreePeriod) {
					currentMonthRent += this.heatingCost ? this.heatingCost * ancillaryCostRatio : 0;
					currentMonthRent += this.utilityCost ? this.utilityCost * ancillaryCostRatio : 0;
				}
				currentMonthRent *= halfMonthRatio;
				totalRent += currentMonthRent;
			});
			return totalRent;
		}
		/**
		* Returns the expected rent payment for a given month
		* Note: this method doesn't consider the rent free period by its own
		* should be done in conjunction with rent tenancy (see getExpectedOwnerRentIncome)
		*/
		getExpectedRentPaymentForMonth(month, rentComponents, includeFullMonth = false) {
			if (!this.isActiveInMonth(month)) return 0;
			const rentStart = dayjs(this.startDate);
			const rentEnd = this.endDate ? dayjs(this.endDate) : null;
			const startOfMonth = dayjs(month).startOf("month");
			const fifteenthOfMonth = startOfMonth.date(15);
			const endOfMonth = startOfMonth.endOf("month");
			let monthRatio = 1;
			if (!includeFullMonth) {
				let shouldPayHalfRentForCurrentMonth = rentStart.isBetween(fifteenthOfMonth, endOfMonth, "d", "[]");
				if (rentEnd && !shouldPayHalfRentForCurrentMonth) shouldPayHalfRentForCurrentMonth = rentEnd.isBetween(startOfMonth, fifteenthOfMonth, "d", "[]");
				if (shouldPayHalfRentForCurrentMonth) monthRatio = .5;
			}
			let totalRent = this.totalRent;
			const { coldRent = 1, heatingCost = 1, utilityCost = 1, parkingSpaceRent = 1 } = rentComponents ?? {};
			[
				{
					isIncluded: coldRent === 1,
					value: this.coldRent * (coldRent || 1)
				},
				{
					isIncluded: heatingCost === 1,
					value: (this.heatingCost ?? 0) * (heatingCost || 1)
				},
				{
					isIncluded: utilityCost === 1,
					value: (this.utilityCost ?? 0) * (utilityCost || 1)
				},
				{
					isIncluded: parkingSpaceRent === 1,
					value: (this.parkingSpaceRent ?? 0) * (parkingSpaceRent || 1)
				}
			].forEach((component) => {
				if (!component.isIncluded && !includeFullMonth) totalRent -= component.value ?? 0;
			});
			return totalRent * monthRatio;
		}
		get title() {
			return `${this.rentId} - ${this.isActive ? "active" : this.isInFuture ? "scheduled" : "expired"} [${this.dateRangeLabel}]`;
		}
	};
}));
//#endregion
//#region src/domains/renting/rental-contract-unit/rental-contract-unit.class.ts
var RentalContractUnit;
var init_rental_contract_unit_class = __esmMin((() => {
	init_base();
	init_renting$1();
	init_rent_class();
	init_rentable_unit_class();
	init_rental_contract_class();
	RentalContractUnit = class extends BaseClassAttributes {
		rentalContractUnitId;
		rentalContractId;
		rentableUnitId;
		rentingProcessId;
		rentalContract;
		rentableUnit;
		rentingProcess;
		rents;
		constructor(props) {
			super(props);
			Object.assign(this, props);
			this.rentalContractUnitId = props.rentalContractUnitId;
			this.rentalContractId = props.rentalContractId;
			this.rentableUnitId = props.rentableUnitId;
			this.rentingProcessId = props.rentingProcessId;
			if (props.rentalContract) this.rentalContract = new RentalContract(props.rentalContract);
			if (props.rentableUnit) this.rentableUnit = new RentableUnit(props.rentableUnit);
			if (props.rents) this.rents = props.rents.map((rent) => new Rent(rent));
			if (props.rentingProcess) this.rentingProcess = new RentingProcess(props.rentingProcess);
		}
		get activeRent() {
			return this.rents?.find((rent) => rent.isActive);
		}
	};
}));
//#endregion
//#region src/domains/renting/rentable-unit/rentable-unit.class.ts
var RentableUnit;
var init_rentable_unit_class = __esmMin((() => {
	init_processes();
	init_rental_contract_unit_class();
	init_rental_contract_model();
	init_renting_model();
	RentableUnit = class RentableUnit {
		rentableUnitId;
		type;
		estateId;
		rentableUnitProcessId;
		parkingSpaceId;
		estateElementId;
		estate;
		estateElement;
		parkingSpace;
		rentalContractUnits;
		rentingListings;
		rentingLeads;
		/** @deprecated Use rentableUnitProcess instead */
		rentableUnitProcesses;
		rentableUnitProcess;
		calendarEvents;
		updatedAt;
		constructor(props) {
			Object.assign(this, omit(props, [
				"title",
				"livingSpace",
				"coldRent",
				"heatingCost",
				"serviceCharge"
			]));
			if (props.rentalContractUnits) this.rentalContractUnits = props.rentalContractUnits.map((rcu) => new RentalContractUnit(rcu));
		}
		get title() {
			return this.getTitle(true);
		}
		getTitle(withIDs = false) {
			let title = this.type === "Estate" ? "🏠" : this.type === "Parking" ? "🚗" : this.type === "Room" ? "🚪" : "";
			title = `${title} ${this.type === "Estate" ? this.estate?.condoUuid ?? `${this.type}${withIDs ? ` ${this.estateId}` : ""}` : this.type === "Room" ? `${this.estateElement?.name || "Room"}` : this.type === "Parking" ? `${this.type} ${this.parkingSpaceId}${withIDs ? ` (${this.parkingSpace?.parkingSpaceType})` : ""}` : ""}`;
			return title;
		}
		get livingSpace() {
			switch (this.type) {
				case "Room": return this.estateElement?.area ?? null;
				case "Estate": return this.estate?.postRenovationAttributes?.livingSpace ?? this.estate?.attributes?.livingSpace ?? null;
				default: return null;
			}
		}
		get activeRent() {
			return this.rentalContractUnits?.flatMap((rcu) => rcu.rentalContract)?.find((rc) => rc?.isActive)?.activeRent;
		}
		get coldRent() {
			return this.activeRent?.coldRent;
		}
		get heatingCost() {
			return this.activeRent?.heatingCost;
		}
		get serviceCharge() {
			return this.activeRent?.utilityCost;
		}
		get listedColdRent() {
			return this.rentingListings?.[0]?.monthlyColdRent;
		}
		get listedServiceCharge() {
			return this.rentingListings?.[0]?.serviceCharge;
		}
		get listedHeatingCost() {
			return this.rentingListings?.[0]?.heatingCosts;
		}
		get latestRentingProcess() {
			return RentingProcess.latestActiveProcess(this.rentingProcesses);
		}
		get rentingProcesses() {
			return this.rentalContractUnits?.reduce((acc, rcu) => {
				const process = rcu.rentingProcess;
				if (!process) return acc;
				if (process.processId != null && acc.some((p) => p.processId === process.processId)) return acc;
				acc.push(process);
				return acc;
			}, []) ?? [];
		}
		get activeRentingProcesses() {
			return sortByDate(this.rentingProcesses?.filter((p) => !finalRentingStates.includes(p.processState.state)) ?? [], "createdAt", "desc");
		}
		static hasActiveContracts(unit) {
			return unit.rentalContractUnits?.some((contractUnit) => contractUnit.rentalContract?.status?.toString() === "Signed" || contractUnit.rentalContract?.status?.toString() === "Approved") ?? false;
		}
		static sort(list) {
			return list.toSorted((r1, r2) => {
				if (r1.type === r2.type) return 0;
				if (r1.type === "Estate") return -1;
				if (r2.type === "Estate") return 1;
				if (r1.type === "Room") return -1;
				return 1;
			});
		}
		/** Renting states where a new renting process must not be started for the same rentable unit. */
		static immutableStartRentingStates = [
			"ContractSigned",
			"HandoverScheduled",
			"HandoverDone",
			"OwnerOccupied"
		];
		get isRentingOwnerOccupied() {
			return this.latestRentingProcess?.processState?.state === "OwnerOccupied";
		}
		static isEstateUnitOwnerOccupied(rentableUnits) {
			const estateUnit = rentableUnits?.find((unit) => unit.type === "Estate");
			if (!estateUnit) return false;
			return new RentableUnit(estateUnit).isRentingOwnerOccupied;
		}
		canStartRentingProcess(estateRentableUnits) {
			const latestState = this.latestRentingProcess?.processState.state;
			if (latestState && latestState !== "Completed") return false;
			if (["Room", "Parking"].includes(this.type) && RentableUnit.isEstateUnitOwnerOccupied(estateRentableUnits)) return false;
			return true;
		}
		static canStartRentingProcessFor(rentableUnit, estateRentableUnits) {
			return new RentableUnit(rentableUnit).canStartRentingProcess(estateRentableUnits);
		}
	};
}));
//#endregion
//#region src/domains/renting/rentable-unit/rentable-unit.opts.ts
var init_rentable_unit_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/renting/rentable-unit/rentable-unit.schema.ts
var RentableUnitTypeEnumSchema, BaseRentableUnitSchema, RentableUnitSchema, rentableUnitSchemas;
var init_rentable_unit_schema = __esmMin((() => {
	init_shared_schemas();
	init_rentable_unit_model();
	RentableUnitTypeEnumSchema = TEnum(RentableUnitType, { $id: "RentableUnitTypeEnum" });
	BaseRentableUnitSchema = Type.Object({
		rentableUnitId: Type.Optional(Type.Number()),
		type: Type.Ref(RentableUnitTypeEnumSchema),
		estateId: Type.Number(),
		rentableUnitProcessId: Type.Optional(TNullable(Type.Number())),
		parkingSpaceId: Type.Optional(TNullable(Type.Number())),
		estateElementId: Type.Optional(TNullable(Type.Number())),
		estarCoreUnitId: Type.Optional(TNullable(Type.String())),
		createdAt: Type.Optional(StringDateSchema),
		updatedAt: Type.Optional(StringDateSchema),
		deletedAt: Type.Optional(StringDateSchema)
	}, { $id: "BaseRentableUnit" });
	RentableUnitSchema = Type.Intersect([Type.Ref(BaseRentableUnitSchema), Type.Object({ estate: Type.Optional(Type.Any()) })], { $id: "RentableUnit" });
	rentableUnitSchemas = {
		BaseRentableUnitSchema,
		RentableUnitSchema,
		RentableUnitTypeEnumSchema
	};
}));
//#endregion
//#region src/domains/renting/rentable-unit/index.ts
var init_rentable_unit = __esmMin((() => {
	init_rentable_unit_class();
	init_rentable_unit_model();
	init_rentable_unit_opts();
	init_rentable_unit_schema();
}));
//#endregion
//#region src/domains/renting/rent-tenancy.class.ts
var RentTenancy;
var init_rent_tenancy_class = __esmMin((() => {
	init_party();
	init_finance();
	init_bank_account_class();
	init_bank_transaction_class();
	init_base_period_class();
	init_rent_helpers();
	init_rent_tenancy_model();
	init_rentable_unit();
	init_rentable_unit_class();
	init_rental_contract();
	dayjs.extend(isSameOrBefore);
	RentTenancy = class RentTenancy extends BasePeriodClass {
		rentTenancyId;
		rentalContractId;
		estarCoreTenantId;
		rentBalance = 0;
		parentId;
		earliestRentChangeDate;
		latestDunningNoticeDate;
		dunningStatusLevel = 0;
		tenantBankAccountId;
		tenantBankAccount;
		documents;
		rentArrearNotices;
		tenancyMembers = [];
		rentableUnit;
		tenancyType = "MainTenancy";
		transactionReferenceId;
		sepaMandates;
		rentSepaMandate;
		generalLedgerStatements;
		bankTransactions;
		_rentalContracts;
		tenantManagementProcess;
		constructor(props) {
			super(props);
			Object.assign(this, props);
			if (props.tenantBankAccount) this.tenantBankAccount = new BankAccount(props.tenantBankAccount);
			if (props?.bankTransactions?.length) this.bankTransactions = props.bankTransactions.map((tx) => new BankTransaction(tx));
			if (props.rentableUnit) this.rentableUnit = new RentableUnit(props.rentableUnit);
			this.rentSepaMandate = props.sepaMandates?.find((s) => s.mandateType === "Rent" && s.status === "Active") ?? void 0;
			if (props.generalLedgerStatements) this.generalLedgerStatements = props.generalLedgerStatements.map((s) => new RentTenancyLedgerStatement(s));
			if (props.rentalContracts) this.rentalContracts = props.rentalContracts.map((rc) => new RentalContract(rc));
		}
		/**
		* Derive the start and end date of the tenancy from the rental contracts for now
		*/
		deriveDateRangeFromRentalContracts() {
			const startDate = this.rentalContracts?.reduce((min, rc) => dayjs(rc.startDate).isBefore(min) ? rc.startDate : min, null);
			const endDate = this.rentalContracts?.reduce((max, rc) => dayjs(rc.endDate).isAfter(max) ? rc.endDate ?? null : max, null);
			this.startDate = startDate;
			this.endDate = endDate;
		}
		get rentalContracts() {
			return this._rentalContracts ?? [];
		}
		set rentalContracts(value) {
			this._rentalContracts = value;
			this.deriveDateRangeFromRentalContracts();
		}
		get name() {
			const tenantName = this.tenancyMembers.map((tenant) => getPartyDisplayName(tenant)).join(", ");
			return `${this.rentTenancyId}-${tenantName}`;
		}
		get title() {
			return `${this.rentTenancyId} - ${this.tenancyMembers.map((tenant) => getPartyDisplayName(tenant)).join(", ")}`;
		}
		get latestLedgerStatement() {
			return maxBy(this.generalLedgerStatements, "month");
		}
		get latestArrearNotice() {
			return maxBy(this.rentArrearNotices, "lastGeneratedAt");
		}
		get latestRentalContract() {
			const latestRentalContract = maxBy(this.rentalContracts ?? [], (rc) => rc.startDate) ?? null;
			return latestRentalContract ? new RentalContract(latestRentalContract) : null;
		}
		get rentableUnits() {
			return this.rentalContracts?.flatMap((rc) => rc.rentableUnits ?? []) ?? [];
		}
		get estateIds() {
			return Array.from(new Set(this.rentableUnits.map((ru) => ru.estateId))).filter(Boolean);
		}
		get rents() {
			return this.rentalContracts?.flatMap((rc) => rc.rents ?? []) ?? [];
		}
		get stateForDisplay() {
			if (this.isActive) return "Active";
			if (this.isInFuture) return "Future";
			if (this.isInPast) return "Inactive";
			return "";
		}
		get totalBalance() {
			if (!this.generalLedgerStatements || this.generalLedgerStatements?.length === 0) return 0;
			return this.latestLedgerStatement?.totalBalance ?? 0;
		}
		get statementRentBalance() {
			if (!Array.isArray(this.generalLedgerStatements)) throw new Error("Tenancy ledger statements are not fetched");
			return this.latestLedgerStatement?.rentBalance ?? 0;
		}
		getFullNames(withSalutation = false) {
			return this.tenancyMembers.map((t) => getPartyDisplayName(t, {
				withSalutation,
				withEmployment: false
			}));
		}
		getShortNames() {
			if (!this.tenancyMembers.length) return "";
			return this.tenancyMembers.map((t) => getPartyShortName(t)).join(", ");
		}
		getInferredType() {
			const contract = this.latestRentalContract;
			if (contract?.type === "Sublease") return "SubTenancy";
			if (contract?.rentalContractUnits?.length === 1 && contract.rentalContractUnits[0].rentableUnit) switch (contract.rentalContractUnits[0].rentableUnit.type) {
				case "Parking": return "ParkingTenancy";
				case "Room": return "SubTenancy";
				default: return "MainTenancy";
			}
			return this.tenancyType;
		}
		get tenancyState() {
			return this.tenantManagementProcess?.processState.state || null;
		}
		static generateTransactionReferenceId(estateCondoUuid, rentableUnitId, rentTenancyId) {
			const missing = [];
			if (!estateCondoUuid) missing.push("estateCondoUuid");
			if (!rentableUnitId) missing.push("rentableUnitId");
			if (!rentTenancyId) missing.push("rentTenancyId");
			if (missing.length) throw new Error(`Cannot generate transaction reference. Reason: Missing paramater(s) (${missing.join(", ")})`);
			return `${estateCondoUuid}-${rentableUnitId}-${rentTenancyId}-${generateRandomString()}`;
		}
		static isRentTenancyActive(rentTenancy) {
			return rentTenancy instanceof RentTenancy ? !!rentTenancy.isActive : !!new RentTenancy(rentTenancy).isActive;
		}
		static mutableFieldsWhenActive() {
			return [
				"tenantBankAccountId",
				"dunningStatusLevel",
				"tenancyMembers",
				"isTenantCompany"
			];
		}
		getAmountRentPaid() {
			if (!this?.bankTransactions?.length) return 0;
			return this.bankTransactions?.reduce((total, tx) => {
				total += tx.amount * (tx.isCredit ? 1 : -1);
				return total;
			}, 0) ?? 0;
		}
		hasReturnDebitTransaction() {
			return this.bankTransactions?.some((tx) => ["ReturnDebit", "ReturnDebitFee"].includes(tx.categoryType));
		}
		getRentBalanceLegacy() {
			return 0;
		}
		getTenancyTransactions() {
			return this.bankTransactions ?? [];
		}
		update(newValues) {
			if (this.isActive) RentTenancy.mutableFieldsWhenActive().forEach((field) => {
				if (newValues[field] !== void 0) this[field] = newValues[field];
			});
			else Object.assign(this, newValues);
			return this;
		}
	};
}));
//#endregion
//#region src/domains/finance/banking/sepa-mandate.class.ts
var SEPAMandate;
var init_sepa_mandate_class = __esmMin((() => {
	init_base();
	init_rent_tenancy_class();
	init_bank_account_class();
	init_bank_transaction_class();
	SEPAMandate = class extends BaseClassAttributes {
		amountLimit;
		bankTransactions = [];
		company;
		companyId;
		estateId;
		deletedAt;
		endDate;
		mandateReference;
		mandateType;
		rentTenancy;
		rentTenancyId;
		sepaMandateId;
		source;
		startDate;
		status;
		documents;
		bankAccount;
		constructor(props) {
			super(props);
			Object.assign(this, props);
			if (props.bankTransactions) this.bankTransactions = props.bankTransactions?.map((t) => new BankTransaction(t));
			if (props.bankAccount) this.bankAccount = new BankAccount(props.bankAccount);
			if (props.rentTenancy) this.rentTenancy = new RentTenancy(props.rentTenancy);
		}
	};
}));
//#endregion
//#region src/domains/finance/banking/index.ts
var init_banking = __esmMin((() => {
	init_bank_account_secret_model();
	init_bank_owner_account_model();
	init_transaction_run_model();
	init_transaction_model();
	init_banking_model();
	init_banking_helpers();
	init_banking_base();
	init_sepa_mandates_base();
	init_sepa_mandate_opts();
	init_sepa_mandate_model();
	init_sepa_mandates_schemas();
	init_sepa_mandate_class();
}));
//#endregion
//#region src/domains/finance/bank-transaction.class.ts
var BankTransaction;
var init_bank_transaction_class = __esmMin((() => {
	init_base();
	init_errors();
	init_bank_account_class();
	init_bank_transaction_model();
	init_banking();
	init_sepa_mandate_class();
	init_invoice();
	BankTransaction = class BankTransaction extends BaseClassAttributes {
		bankTransactionId;
		/**
		* Parent bank transaction id
		* @type {number}
		*/
		parentBankTransactionId;
		/**
		* Connected bank account id
		* @type {number}
		*/
		bankAccountId;
		/**
		* Original bank ID for transaction
		* @type {string}
		*/
		referenceId;
		/**
		* It is incoming or outgoing transaction
		* @type {BankTransactionCategory}
		*/
		category;
		categoryType;
		/**
		* Amount of course
		* @type {number}
		*/
		amount;
		/**
		* Each transaction added to system should have state which reflects it's reconciliation state
		* @type {BankTransactionState}
		*/
		bankTransactionState;
		/**
		* Date when amount was added to balance
		* @type {Date}
		*/
		entryDate;
		/**
		* Date to use for calculation
		* @type {Date}
		*/
		valueDate;
		/**
		* Transaction description
		* @type {string}
		*/
		description;
		/**
		* Json to store original transaction data
		* @type {Record<string, any>}
		*/
		meta;
		/**
		* For manually added transaction
		* @type {string}
		*/
		userId;
		paymentType;
		invoiceId;
		investorInfoId;
		investorInfo;
		rentTenancyId;
		serviceChargeStatementId;
		parentBankTransaction;
		/**
		* the inverse relation of parentBankTransaction
		*/
		childBankTransaction;
		transactionSource;
		bankAccount;
		ledgerEntries = [];
		statementBankAccountId;
		statementBankAccount;
		issuerBankAccountId;
		issuerBankAccount;
		isCredit;
		/** @deprecated Orphaned audit id from dropped reconciler_rule table; static rules do not set this. */
		appliedRuleId;
		appliedPaymentReference;
		reconciliationType;
		reconciliationMeta;
		transactionComment;
		sepaMandateId;
		sepaMandate;
		rentTenancy;
		issues = [];
		reasonCode;
		mandateReference;
		debtorTag;
		attachedEstate;
		invoice;
		executedBy;
		constructor(props) {
			super(props);
			if (!BankTransactionCategoryToTypeMapping[props.category]?.includes(props.categoryType)) throw new ApplicationError(`Wrong pair of ${props.category} and ${props.categoryType}`);
			Object.assign(this, props);
			if (props.bankAccount) this.bankAccount = new BankAccount(props.bankAccount);
			if (props.issuerBankAccount) this.issuerBankAccount = new BankAccount(props.issuerBankAccount);
			if (props.parentBankTransaction) this.parentBankTransaction = new BankTransaction(props.parentBankTransaction);
			if (props.childBankTransaction) this.childBankTransaction = new BankTransaction(props.childBankTransaction);
			if (props.sepaMandate) this.sepaMandate = new SEPAMandate(props.sepaMandate);
			if (props.invoice) this.invoice = new Invoice(props.invoice);
			this.detectTransactionIssue();
			this.reasonCode = this.meta?.transaction?.subtags?.find((e) => e.type === "ReasonCode")?.value;
			this.mandateReference = this.meta?.transaction?.subtags?.find((e) => e.type === "MandateReference")?.value;
			this.debtorTag = this.meta?.transaction?.subtags?.find((e) => e.type === "Debtor")?.value;
			if (!props.attachedEstate) {
				this.attachedEstate = this.escrowEstate ?? this.investorInfo?.estate;
				if (!this.attachedEstate && this?.rentTenancy?.rentableUnit) this.attachedEstate = { estateId: this?.rentTenancy.rentableUnit.estateId };
			}
		}
		get isSingleFee() {
			return [
				"Interest",
				"Commitment",
				"Processing"
			].includes(this.categoryType);
		}
		get isDrawdown() {
			return this.category === "Drawdown";
		}
		get isInterTransfer() {
			return this.bankAccount?.bankAccountType === "Escrow" && this.issuerBankAccount?.bankAccountType === "Escrow" && this.issuerBankAccountId !== this.bankAccountId;
		}
		get isInvoiceDrawdown() {
			return this.isDrawdown && this.isInvoice;
		}
		get isPurchasingPrice() {
			return this.categoryType === "PurchasingPrice";
		}
		get isInvoice() {
			return this.categoryType === "Invoice" && this.isReconciled;
		}
		get isPurchasingDrawdown() {
			return this.isDrawdown && this.isPurchasingPrice;
		}
		get isTransfer() {
			return this.category === "Transfer" && this.isReconciled;
		}
		get isFee() {
			return this.category === "Fee" && this.isReconciled;
		}
		get isRevenue() {
			return this.category === "Revenue";
		}
		get isBooking() {
			return this.category === "Booking";
		}
		get isGroupedFee() {
			return this.categoryType === "Combined" && this.isReconciled;
		}
		get isInterest() {
			return this.categoryType === "Interest" && this.isReconciled;
		}
		get isCommitment() {
			return this.categoryType === "Commitment" && this.isReconciled;
		}
		get isSellingIncome() {
			return this.isRevenue && this.categoryType === "Selling";
		}
		get isManual() {
			return this.transactionSource === "User";
		}
		get isRemovable() {
			return this.bankTransactionState !== "Reconciled" || this.transactionSource === "User";
		}
		get isEditable() {
			return this.bankTransactionState !== "Reconciled";
		}
		get isStorno() {
			return this.categoryType === "Storno";
		}
		get isPropertyManagementRelated() {
			return BankTransactionCategoryToTypeMapping["PropertyManagement"].includes(this.categoryType);
		}
		get isRent() {
			return this.categoryType === "Rent" && this.isCredit && this.isReconciled;
		}
		get isNegativeRent() {
			return this.categoryType === "Rent" && !this.isCredit && this.isReconciled;
		}
		get isRentGuarantee() {
			return this.categoryType === "RentGuarantee" && this.isReconciled;
		}
		get isBankFee() {
			return this.categoryType === "BankFee" && !this.isCredit && this.isReconciled;
		}
		get isBankFeeCompensation() {
			return this.categoryType === "BankFeeCompensation" && this.isReconciled;
		}
		get isReturnDebit() {
			return this.categoryType === "ReturnDebit" && this.isReconciled;
		}
		get isReturnDebitFee() {
			return this.categoryType === "ReturnDebitFee" && !this.isCredit && this.isReconciled;
		}
		get isHomeOwnerFee() {
			return this.categoryType === "HouseGeld" && !this.isCredit && this.isReconciled;
		}
		get isHomeOwnerFeePayback() {
			return this.categoryType === "HouseGeldDealPayback" && this.isCredit && this.isReconciled;
		}
		get isManagementFee() {
			return this.categoryType === "ManagementFee" && !this.isCredit && this.isReconciled;
		}
		get isOtherCost() {
			return this.categoryType === "OtherCost" && !this.isCredit && this.isReconciled;
		}
		get isPropertyTax() {
			return this.categoryType === "PropertyTax" && !this.isCredit && this.isReconciled;
		}
		get isInvestorIncome() {
			return this.categoryType === "InvestorIncome" && !this.isCredit && this.isReconciled;
		}
		get isAnnualServiceChargeStatement() {
			return this.categoryType === "AnnualServiceChargeStatement" && this.isReconciled;
		}
		get isRepaymentSubsidy() {
			return this.categoryType === "RepaymentSubsidy" && this.isCredit && this.isReconciled;
		}
		get isReconciled() {
			return this.bankTransactionState === "Reconciled";
		}
		get combinedReference() {
			if (!this.meta?.transaction) return "";
			return BankTransaction.combineReferences(this.meta?.transaction);
		}
		get isFeeCategoryType() {
			return BankTransactionCategoryToTypeMapping["Fee"].includes(this.categoryType);
		}
		get escrowEstate() {
			return this.bankAccount?.escrowEstate ?? this.issuerBankAccount?.escrowEstate;
		}
		get isBankingFee() {
			if (!this.issuerBankAccount || !this.bankAccount) return false;
			return this.issuerBankAccount?.isEscrowAccount && this.bankAccount.bankAccountType === "BankServiceAccount";
		}
		get isReturned() {
			return BankTransaction.hasReturnDebit(this);
		}
		get isSepaDD() {
			return !!this.mandateReference && !!this.reasonCode;
		}
		get isMoneyReturn() {
			return !!this.reasonCode && ["906", "902"].includes(this.reasonCode) && !this.mandateReference;
		}
		get isSEPAErrorPayment() {
			return this.reasonCode && errorReasonCodes.includes(`${+this.reasonCode}`);
		}
		static combineReferences(tx) {
			return tx.subtags?.filter((subTag) => [
				"Reference",
				"CustomerReference",
				"MandateReference",
				"EndToEndReference",
				"SepaRefererenceNumber"
			].includes(subTag.type)).map((sb) => sb.value).join(", ") ?? "";
		}
		static hasReturnDebit(tx) {
			return Boolean(tx.parentBankTransactionId);
		}
		detectTransactionIssue() {
			this.issues = [];
			if (this.bankTransactionState === "Pending" || this.categoryType === "Unknown") this.issues.push("Unknown");
			if (this.bankTransactionState === "Incomplete") if (this.meta?.error?.code === "FINANCE_BANK_TRANSACTION_CONFLICTING_REFERENCE") if ((this.meta?.error?.data)?.conflictingInfos?.length) this.issues.push(["TransactionConflictingReference", (this.meta?.error?.data).conflictingInfos]);
			else this.issues.push("TransactionConflictingReference");
			else this.issues.push("TransactionIncompleteStatement");
			if (this.category === "PropertyManagement" && ["AncillaryCosts"].includes(this.categoryType) && !this.rentTenancyId) this.issues.push("NoTenancyInfo");
			if (this.category === "PropertyManagement" && ["Rent", "ReturnDebitFee"].includes(this.categoryType) && !this.rentTenancyId) this.issues.push("NoActiveRentTenancy");
			if (this.categoryType === "Invoice" && !this.invoiceId) this.issues.push("NoInvoiceAttached");
			if (this.categoryType === "ReturnDebit" && !this.isCredit && !this.rentTenancyId) this.issues.push("NoActiveRentTenancy");
			if (this.categoryType === "AnnualServiceChargeStatement" && !this.serviceChargeStatementId) this.issues.push("NoAnnualServiceChargeStatement");
			if (this.category === "PropertyManagement" && [
				"ManagementFee",
				"InvestorIncome",
				"PropertyTax",
				"AncillaryCosts",
				"HouseGeldDealPayback"
			].includes(this.categoryType) && !this.investorInfoId) this.issues.push("NoInvestorInfo");
			if (!!this.reasonCode && ["906", "902"].includes(this.reasonCode) && this.categoryType !== "ReturnDebit") this.issues.push("FundsReturnIsNotDirectDebit");
		}
		getLedgerEntryGroupType() {
			switch (this.category) {
				case "Drawdown":
				case "Fee":
				case "Transfer":
				case "Revenue":
				case "Storno":
				case "PropertyManagement": return this.categoryType;
				default: throw new Error(`Can't determine Ledger Entry Group Type for ${this.categoryType}`);
			}
		}
	};
}));
//#endregion
//#region src/domains/renting/monthly-rent-guarantee.model.ts
var MonthlyRentGuaranteeType;
var init_monthly_rent_guarantee_model = __esmMin((() => {
	MonthlyRentGuaranteeType = /* @__PURE__ */ function(MonthlyRentGuaranteeType) {
		MonthlyRentGuaranteeType["RentGuarantee"] = "RentGuarantee";
		MonthlyRentGuaranteeType["RentFreeTime"] = "RentFreeTime";
		MonthlyRentGuaranteeType["MissingRent"] = "MissingRent";
		return MonthlyRentGuaranteeType;
	}({});
}));
//#endregion
//#region src/domains/renting/investor-info.class.ts
var investor_info_class_exports = /* @__PURE__ */ __exportAll({
	InvestorInfo: () => InvestorInfo,
	OWNER_SPECIAL_DEAL_MAX_DURATION: () => 10
});
var OWNER_SPECIAL_DEAL_MAX_DURATION, InvestorInfo;
var init_investor_info_class = __esmMin((() => {
	init_errors();
	init_party();
	init_bank_account_class();
	init_bank_transaction_class();
	init_bank_transaction_model();
	init_investment_case_class();
	init_base_period_class();
	init_rent_helpers();
	init_rental_contract();
	dayjs.extend(isSameOrBefore);
	dayjs.extend(isSameOrAfter);
	OWNER_SPECIAL_DEAL_MAX_DURATION = 10;
	InvestorInfo = class InvestorInfo extends BasePeriodClass {
		investorInfoId;
		security;
		managementFee;
		investorShareDocumentLink = [];
		investorShare;
		theoreticalInvestorShare;
		realInvestorShare;
		alert;
		isSev;
		isLegacyCondo;
		hasBankAccountSubsidy;
		specialDealShouldExemptMaintenanceReserveMonth;
		specialDealMaintenanceReserveStartDate;
		specialDealMaintenanceReserveEndDate;
		specialDealMaintenanceReserveDuration;
		specialDealShouldExemptPropertyManagementMonthlyCosts;
		specialDealPropertyManagementCostsStartDate;
		specialDealPropertyManagementCostsEndDate;
		specialDealPropertyManagementCostsDuration;
		specialDealHasRepaymentSubsidy;
		specialDealRepaymentSubsidyRate;
		specialDealRepaymentSubsidyStartDate;
		specialDealRepaymentSubsidyEndDate;
		specialDealRepaymentSubsidyDuration;
		specialDealHasAutomaticSubsidy;
		specialDealAutomaticSubsidyEquityPercentOrEuro;
		specialDealAutomaticSubsidyDiscountPeriod;
		estateId;
		estate;
		escrowBankAccountId;
		escrowBankAccount;
		investorBankAccountId;
		investorBankAccount;
		investorInfoOwners;
		investors = [];
		investorTransactions;
		documents;
		monthlyInvestorShares;
		monthlyRentGuarantees;
		rentalContracts;
		investorYearlyPayouts;
		investorAnnualSettlements;
		constructor(props) {
			super(props);
			Object.assign(this, props);
			if (this.investorInfoOwners?.length && !this.investors?.length) this.investors = this.investorInfoOwners.map((rel) => ({
				contact: rel.contact ?? void 0,
				company: rel.company ?? void 0
			}));
			if (props.investorBankAccount) this.investorBankAccount = new BankAccount(props.investorBankAccount);
			if (props.escrowBankAccount) this.escrowBankAccount = new BankAccount(props.escrowBankAccount);
			if (props.rentalContracts) this.rentalContracts = props.rentalContracts.map((contract) => new RentalContract(contract));
			if (props?.investorTransactions?.length) this.investorTransactions = props.investorTransactions.map((tx) => new BankTransaction(tx));
		}
		static createFromEstateData({ estateId, approvedRentingLeads, investors, approvedSellingInvestmentCase, rentingListing, propertyManagementMonthlyCosts, investorBankAccount, escrowBankAccount }) {
			let coldRent;
			let security;
			let homeOwnerFee;
			if (approvedSellingInvestmentCase && rentingListing) {
				const investmentCaseWithCalculations = new InvestmentCase(approvedSellingInvestmentCase);
				coldRent = investmentCaseWithCalculations.incomeMonth ?? 0;
				security = coldRent;
				homeOwnerFee = investmentCaseWithCalculations.houseGeld;
			}
			return {
				investorInfo: {
					startDate: approvedRentingLeads[0]?.movingInDate ?? void 0,
					endDate: null,
					security,
					managementFee: propertyManagementMonthlyCosts,
					estateId,
					investorBankAccountId: investorBankAccount?.bankAccountId,
					escrowBankAccountId: escrowBankAccount?.bankAccountId,
					alert: false,
					isSev: false,
					isLegacyCondo: false,
					hasBankAccountSubsidy: false
				},
				investorInfoOwners: investors,
				rentTenancyContacts: uniqBy(approvedRentingLeads?.map((rentingLead) => rentingLead.contacts?.[0])?.filter(Boolean) ?? [], "contactId"),
				homeOwnerFee
			};
		}
		getExpectedRentPayments() {
			return this?.rentalContracts?.reduce((total, rentalContract) => {
				return total + (rentalContract.isActive ? rentalContract.getExpectedRentPayments() ?? 0 : 0);
			}, 0) ?? 0;
		}
		/**
		* Returns the expected rent income for a given month and the ratio of the month
		* @param Date month
		* @returns [expectedRentIncome, ratio]
		*/
		getExpectedRentIncomeForMonth(month) {
			const rentIncome = this.getRentTenanciesAmountForMonth(month);
			const fullMonthRentIncome = this.getRentTenanciesAmountForMonth(month, true);
			const ratio = calculatePartialMonthRatio(month, this.startDate, this.endDate);
			const amount = Math.min(rentIncome, round$1(fullMonthRentIncome * ratio, 2));
			return [amount, rentIncome && amount === rentIncome ? 1 : round$1(ratio, 4)];
		}
		getRentTenanciesAmountForMonth(month, includeFullMonth = false) {
			return this.rentalContracts?.filter((contract) => contract.isActiveInMonth(month)).reduce((total, rentalContract) => {
				return total + (rentalContract.getExpectedOwnerRentIncome(month, includeFullMonth) ?? 0);
			}, 0) ?? 0;
		}
		getRentalTransactions() {
			return this.rentalContracts?.flatMap((contract) => contract.getRentalTransactions()) ?? [];
		}
		getTransactionFeesTotal() {
			return (this.investorTransactions?.reduce((total, transaction) => {
				if (transaction.categoryType === "BankFee") return total + transaction.amount;
				return total;
			}, 0) ?? 0) - (this.investorTransactions?.reduce((total, transaction) => {
				if (transaction.categoryType === "BankFeeCompensation") return total + transaction.amount;
				return total;
			}, 0) ?? 0);
		}
		hasAnyActiveSpecialDealAtDate(date) {
			return this.isSpecialDealHOAFeeExemptActive(date) || this.isSpecialDealManagementFeeSubsidyActive(date) || this.isSpecialDealRepaymentSubsidyActive(date);
		}
		isSpecialDealHOAFeeExemptActive(date = /* @__PURE__ */ new Date()) {
			return !!this.specialDealShouldExemptMaintenanceReserveMonth && !!this.specialDealMaintenanceReserveStartDate && isActiveForMonth(date, {
				startDate: this.specialDealMaintenanceReserveStartDate,
				endDate: this.specialDealMaintenanceReserveEndDate
			});
		}
		isSpecialDealManagementFeeSubsidyActive(date = /* @__PURE__ */ new Date()) {
			return !!this.specialDealShouldExemptPropertyManagementMonthlyCosts && !!this.specialDealPropertyManagementCostsStartDate && isActiveForMonth(date, {
				startDate: this.specialDealPropertyManagementCostsStartDate,
				endDate: this.specialDealPropertyManagementCostsEndDate
			});
		}
		isSpecialDealRepaymentSubsidyActive(date = /* @__PURE__ */ new Date()) {
			return !!this.specialDealHasRepaymentSubsidy && !!this.specialDealRepaymentSubsidyRate && !!this.specialDealRepaymentSubsidyStartDate && isActiveForMonth(date, {
				startDate: this.specialDealRepaymentSubsidyStartDate,
				endDate: this.specialDealRepaymentSubsidyEndDate
			});
		}
		getResolvedSpecialDeal(date) {
			const specialDeal = {};
			if (!this.hasAnyActiveSpecialDealAtDate(date)) return specialDeal;
			if (this.isSpecialDealHOAFeeExemptActive(date)) {
				if (!this.estate?.price) throw new InvalidStateError("\"estate.price\" is not provided when calculating investor special deal", {
					investorInfoId: this.investorInfoId,
					estateId: this.estateId
				});
				const { price: { houseGeldNonTransferable, houseGeldReserve } } = this.estate;
				if (isNil(houseGeldNonTransferable) || isNil(houseGeldReserve)) throw new InvalidStateError("\"houseGeldNonTransferable\" or \"houseGeldReserve\" are not provided when calculating investor special deal", {
					investorInfoId: this.investorInfoId,
					estateId: this.estateId,
					houseGeldNonTransferable,
					houseGeldReserve
				});
				specialDeal.housegeldExempt = calculatePartialMonthRatio(date, this.specialDealMaintenanceReserveStartDate, this.specialDealMaintenanceReserveEndDate) * (houseGeldNonTransferable + houseGeldReserve);
			}
			if (this.isSpecialDealManagementFeeSubsidyActive(date)) specialDeal.managementFeeSubsidy = calculatePartialMonthRatio(date, this.specialDealPropertyManagementCostsStartDate, this.specialDealPropertyManagementCostsEndDate) * this.managementFee;
			const sellingPrice = this.estate?.executedSellingInvestmentCase?.expectedSalesPrice;
			if (this.isSpecialDealRepaymentSubsidyActive(date) && this.specialDealRepaymentSubsidyRate) {
				if (!sellingPrice) throw new InvalidStateError(`'expectedSalesPrice' not found in executed selling investment-case. This is required for calculating investor special deal`, {
					investorInfoId: this.investorInfoId,
					estateId: this.estateId
				});
				specialDeal.loanAmortizationSubsidy = calculatePartialMonthRatio(date, this.specialDealRepaymentSubsidyStartDate, this.specialDealRepaymentSubsidyEndDate) * round$1(this.specialDealRepaymentSubsidyRate * sellingPrice / 12, 2);
			}
			return specialDeal;
		}
		getActiveRentalContracts() {
			return this.activeRentalContracts;
		}
		getActiveRents(tenancyType) {
			return (tenancyType ? this.getActiveRentalContracts() : this.activeRentalContracts).flatMap((contract) => contract.rentalContractUnits?.flatMap((rcu) => rcu.rents)?.filter((rent) => rent?.isActive) ?? []);
		}
		calculateStartBillingDate() {
			let startBillingDateValue = dayjs(this.startDate).startOf("month");
			if (this.specialDealPropertyManagementCostsStartDate && this.specialDealShouldExemptPropertyManagementMonthlyCosts) startBillingDateValue = dayjs(this.specialDealPropertyManagementCostsEndDate).isSame(dayjs(this.specialDealPropertyManagementCostsEndDate).endOf("month"), "day") ? dayjs(this.specialDealPropertyManagementCostsEndDate).add(1, "month").startOf("month") : dayjs(this.specialDealPropertyManagementCostsEndDate).startOf("month");
			return startBillingDateValue.toDate();
		}
		get activeRentalContracts() {
			return this.rentalContracts?.filter((contract) => contract.isActive) ?? [];
		}
		get futureRentTenancies() {
			return this.rentalContracts?.filter((contract) => dayjs(contract.startDate).isAfter(dayjs())) ?? [];
		}
		get name() {
			return this.investors.map((inv) => getPartyShortName(inv)).join(", ");
		}
		get fullNames() {
			return this.getFullNames();
		}
		get nameWithId() {
			const investorNames = this.investors.map((inv) => getPartyShortName(inv)).join(", ");
			return `${this.investorInfoId}-${investorNames}`;
		}
		get actualRent() {
			return this.sumActiveRents({
				withColdRent: true,
				withParkingSpaceRent: true
			});
		}
		getFullNames() {
			return this.investors.map((inv) => getPartyDisplayName(inv, {
				withSalutation: false,
				withEmployment: false
			})).join(", ");
		}
		/**
		* Returns the sum of all the **active** rents for the rentTenancies found
		* Centralizes rent calculation logic
		*/
		sumActiveRents(opts = { withColdRent: true }) {
			const rentAttributesToSum = [];
			if (opts.withColdRent) rentAttributesToSum.push("coldRent");
			if (opts.withParkingSpaceRent) rentAttributesToSum.push("parkingSpaceRent");
			if (opts.withHeatingCost) rentAttributesToSum.push("heatingCost");
			if (opts.withUtilityCost) rentAttributesToSum.push("utilityCost");
			return this.getActiveRents().reduce((acc, rent) => safeSum(acc, rentAttributesToSum.reduce((acc, rentAttr) => safeSum(acc, rent[rentAttr]), 0)), 0);
		}
		static getActualRent(entitiesWithRentalContracts) {
			return new InvestorInfo({ rentalContracts: entitiesWithRentalContracts.flatMap((entity) => entity.rentalContracts ?? []) }).actualRent;
		}
		static getSumOfActiveRents(entitiesWithRentalContracts, opts) {
			return new InvestorInfo({ rentalContracts: entitiesWithRentalContracts.flatMap((entity) => entity.rentalContracts ?? []) }).sumActiveRents(opts);
		}
		getMonthlyRentGuarantee(month, opts) {
			const allRents = this.rentalContracts?.flatMap((rc) => rc.rents) ?? [];
			const activeRents = allRents.filter((r) => r.getIsActive(month)) ?? [];
			const futureRents = allRents.filter((r) => r.getIsFuture(month)) ?? [];
			const pastRents = allRents.filter((r) => r.getIsInPast(month)) ?? [];
			const rentalTransactions = this.rentalContracts?.flatMap((contract) => contract.bankTransactions)?.filter((tx) => tx?.isRent);
			let reason;
			let amount;
			let type;
			const investmentCase = this.estate?.executedSellingInvestmentCase;
			const rentingListing = this.estate?.rentingListings?.[0];
			const investmentCaseBasedAmount = safeSum(investmentCase?.monthlyRent, investmentCase?.parkingSpacePrice, rentingListing?.heatingCosts, rentingListing?.serviceCharge);
			if (opts?.investmentCaseBasedOnly) {
				if (!investmentCase) {
					if (!this.rentalContracts?.length || this.estate?.propertyManagementOnly) return null;
					throw new InvalidParamsError("investmentCase is required when calculating monthly rent guarantee", {
						investorInfoId: this.investorInfoId,
						estateId: this.estateId
					});
				}
				return {
					amount: investmentCaseBasedAmount,
					type: "RentGuarantee",
					reason: "Mietgarantie"
				};
			}
			if (!activeRents.length && !pastRents.length) {
				const futureRentHavingColdRents = futureRents.filter((r) => r.coldRent);
				if (futureRentHavingColdRents.length) amount = safeSum(...futureRentHavingColdRents.map((r) => r.totalRent));
				else amount = investmentCaseBasedAmount;
				type = "RentGuarantee";
				reason = "Mietgarantie";
			} else if (activeRents.every((r) => !r.coldRent)) {
				amount = safeSum(...futureRents.filter((r) => r.coldRent).map((r) => r.totalRent));
				type = "RentFreeTime";
				reason = "Mietgarantie";
			} else if (!rentalTransactions?.length) {
				amount = safeSum(...activeRents.map((r) => r.totalRent));
				type = "MissingRent";
				reason = "Mietminderung";
			} else return null;
			return {
				type,
				reason,
				amount
			};
		}
	};
}));
//#endregion
//#region src/domains/finance/ledger/balance-record.class.ts
var BalanceRecord;
var init_balance_record_class = __esmMin((() => {
	init_base();
	BalanceRecord = class BalanceRecord extends BaseClassAttributes {
		balanceRecordId;
		generalLedgerId;
		/**
		* Currently pending principal amount
		* @type {number}
		*/
		outstandingPrincipal;
		/**
		* Total Accrued Interest Fee without paid
		* @type {number}
		*/
		accruedInterestFee;
		/**
		* Total Paid Fee up to this date
		* @type {number}
		*/
		paidInterestFee;
		/**
		* Total Accrued Fee up to this date
		* @type {number}
		*/
		accruedCommitmentFee;
		/**
		* Total Paid Commitment Fee up to this date
		* @type {number}
		*/
		paidCommitmentFee;
		/**
		* All Processing Fee Accrued Up To this date
		* @type {number}
		*/
		accruedProcessingFee;
		/**
		* Paid Processing Fee up to this date
		* @type {number}
		*/
		paidProcessingFee;
		/**
		* Balance Date
		* @type {number}
		*/
		balanceDate;
		/**
		* Available amount of junior debt
		* @type {number}
		*/
		juniorDebtAvailable;
		totalBalance;
		drawdownsAmount = 0;
		freeFunds = 0;
		estateId;
		generalLedger;
		constructor(props) {
			super(props);
			Object.assign(this, props);
		}
		static createEmptyRecord(generalLedgerId, overrides) {
			return new BalanceRecord({
				accruedCommitmentFee: 0,
				accruedInterestFee: 0,
				accruedProcessingFee: 0,
				balanceDate: /* @__PURE__ */ new Date(),
				generalLedgerId,
				outstandingPrincipal: 0,
				paidCommitmentFee: 0,
				paidInterestFee: 0,
				paidProcessingFee: 0,
				totalBalance: 0,
				juniorDebtAvailable: 0,
				...overrides
			});
		}
		/**
		* Create new record from previous record
		* @param {Partial<IBalanceRecord>} override
		* @returns {BalanceRecord}
		*/
		copy(override) {
			return new BalanceRecord({
				...this,
				balanceRecordId: null,
				createdAt: void 0,
				updatedAt: void 0,
				...override || {}
			});
		}
	};
}));
//#endregion
//#region src/domains/finance/ledger/general-ledger/general-ledger-base.class.ts
var BaseGeneralLedger;
var init_general_ledger_base_class = __esmMin((() => {
	init_base();
	init_errors();
	init_balance_record_class();
	init_ledger_entry();
	BaseGeneralLedger = class extends BaseClassAttributes {
		generalLedgerId;
		generalLedgerType;
		bankAccountId;
		rentTenancyId;
		/**
		* Details records generated by each transaction
		* @type {LedgerEntry[]}
		*/
		entries = [];
		/**
		* Records which has total numbers for the end of the day
		* @type {BalanceRecord[]}
		*/
		_balanceRecords = /* @__PURE__ */ new Map();
		get balanceRecords() {
			if (!this._balanceRecords?.size) return [];
			return Array.from(this._balanceRecords.values());
		}
		set balanceRecords(list) {
			this._balanceRecords = /* @__PURE__ */ new Map();
			list.forEach((record) => {
				this._balanceRecords.set(extractDate(record.balanceDate), record instanceof BalanceRecord ? record : new BalanceRecord(record));
			});
		}
		constructor(props) {
			super(props);
			Object.assign(this, props);
			this.entries = props.entries?.map((entry) => entry instanceof LedgerEntry ? entry : new LedgerEntry(entry)) ?? [];
		}
		/**
		* Check if there is any entry in the ledger with the same set of fields exists
		* @param entry Entry to check for duplicates
		* @param excludeCompensated Whether to exclude compensated entries from the check
		* @returns boolean indicating if a matching entry exists
		*/
		isSameEntryExists(entry, excludeCompensated) {
			if (this.entries.length === 0) return false;
			return this.entries.some((e) => sameDay(e.valueDate, entry.valueDate) && e.fieldsId === entry.fieldsId && (!excludeCompensated || !e.isCompensated));
		}
		createNewLedgerEntry(data) {
			return new LedgerEntry({
				...data,
				generalLedgerId: this.generalLedgerId,
				isTouched: true
			});
		}
		addLedgerEntry(entry) {
			if (!entry.debit && !entry.credit) return false;
			entry.valueDate = dayjs(entry.valueDate).toDate();
			entry.generalLedgerId = this.generalLedgerId;
			if (entry.parentId) {
				const parent = this.entries.find((e) => e.ledgerEntryId === entry.parentId);
				if (!parent) throw new InvalidStateError(`Parent Ledger entry not found for ${JSON.stringify(entry)}`, {
					ledgerEntryId: entry.ledgerEntryId,
					parentId: entry.parentId
				});
				parent.addChildren(entry);
			} else this.entries.push(entry);
			return true;
		}
		findTransactionEntries(bankTransactionId, excludeCompensated = false) {
			let result = [];
			if (!bankTransactionId) return result;
			this.entries.forEach((entry) => {
				if (entry.bankTransactionId === bankTransactionId) result.push(entry);
			});
			if (excludeCompensated) result = result.filter((e) => e.totalAmount !== 0);
			return result;
		}
	};
}));
//#endregion
//#region src/domains/finance/ledger/general-ledger/general-ledger.model.ts
var GeneralLedgerType;
var init_general_ledger_model = __esmMin((() => {
	GeneralLedgerType = /* @__PURE__ */ function(GeneralLedgerType) {
		GeneralLedgerType["BankAccount"] = "BankAccount";
		GeneralLedgerType["ExternalBankAccount"] = "ExternalBankAccount";
		GeneralLedgerType["LoanAccount"] = "LoanAccount";
		GeneralLedgerType["PropertyManagementAccount"] = "PropertyManagementAccount";
		GeneralLedgerType["InvestorAccount"] = "InvestorAccount";
		GeneralLedgerType["AssetAccount"] = "AssetAccount";
		return GeneralLedgerType;
	}({});
}));
//#endregion
//#region src/domains/finance/ledger/general-ledger/general-ledger.class.ts
var GeneralLedger;
var init_general_ledger_class = __esmMin((() => {
	init_errors();
	init_ledger_entry();
	init_general_ledger_base_class();
	GeneralLedger = class extends BaseGeneralLedger {
		loanAccount;
		bankAccount;
		get isBankAccount() {
			return this.generalLedgerType === "BankAccount";
		}
		bookTransaction() {
			throw new UnsupportedError("Booking transaction is not implemented on Root Ledger Level");
		}
		calculateBalanceForEntry(entry) {
			const entriesThatDay = this.entries.filter((e) => sameDay(e.valueDate, entry.valueDate)).sort(this.sortLedgerEntries);
			let prevDayBalance = this.findDayBalanceRecord(dayjs(entry.valueDate).subtract(1, "day").toDate())?.totalBalance ?? 0;
			for (const e of entriesThatDay) {
				if (e === entry) return prevDayBalance + e.totalAmount;
				prevDayBalance += e.totalAmount;
			}
			return prevDayBalance;
		}
		findDayBalanceRecord(day) {
			return this._balanceRecords.get(this.getDateString(day));
		}
		findLedgerEntry(day, entryGroup, entryGroupType, estateId) {
			return this.entries.find((e) => {
				let matched = sameDay(e.valueDate, day) && e.entryGroup === entryGroup && e.entryGroupType === entryGroupType;
				if (estateId) matched = matched && Boolean(e.estateId) && Number(estateId) === Number(e.estateId);
				else matched = matched && !e.estateId;
				return matched;
			});
		}
		/**
		* Wrapper Method to add repayment fees
		* @param {FeeType | LedgerEntryDrawdownType | RepaymentType | LedgerEntryPaymentType | OtherLedgerEntryType} entryGroupType
		* @param {number} amount
		* @param {Date} valueDate
		* @param {number} bankTransactionId
		*/
		addFeeRepayment({ entryGroupType, amount, valueDate, bankTransactionId }) {
			this.addLedgerEntry(this.createNewLedgerEntry({
				entryType: "Cash",
				entryGroup: "Repayment",
				entryGroupType,
				debit: amount < 0 ? Math.abs(amount) : null,
				credit: amount > 0 ? Math.abs(amount) : null,
				valueDate,
				bankTransactionId
			}));
		}
		recalculateBalance(fromValueDate, tillValueDate) {
			let currentDay = dayjs(fromValueDate);
			const today = /* @__PURE__ */ new Date();
			let tillDate = tillValueDate && this.isSameOrBefore(tillValueDate, today) ? tillValueDate : today;
			if (isBefore(tillDate, fromValueDate)) {
				const lastBalanceDate = this.balanceRecords[this.balanceRecords.length - 1]?.balanceDate;
				tillDate = new Date(Math.max(new Date(fromValueDate).getTime(), (lastBalanceDate ? new Date(lastBalanceDate) : null)?.getTime() || 0));
			}
			while (this.isSameOrBefore(currentDay, tillDate)) {
				this.calculateDayBalance(currentDay.toDate());
				currentDay = currentDay.add(1, "day");
			}
		}
		/**
		* Either add new record to list of balances or update old one
		* @param {BalanceRecord} balanceRecord
		*/
		addBalanceRecord(balanceRecord) {
			const existingRecord = this.findDayBalanceRecord(balanceRecord.balanceDate);
			if (existingRecord) {
				const merged = balanceRecord.copy({ balanceRecordId: existingRecord.balanceRecordId });
				this._balanceRecords.set(this.getDateString(balanceRecord.balanceDate), merged);
			} else this._balanceRecords.set(this.getDateString(balanceRecord.balanceDate), balanceRecord);
		}
		calculateDayBalance(day) {
			throw new Error(`Can't calculate day balance for ${day}. Method is not implemented`);
		}
		calculateDayBalanceFromStatement(statement) {
			throw new Error(`Can't calculate day balance for ${statement?.closingBalance?.date}. Method is not implemented`);
		}
		calculateBalancePerEstate(estateId) {
			return this.entries.reduce((sum, e) => e.isPrincipalRecord && e.estateId === estateId ? sum + Math.abs(e.credit || e.debit || 0) : sum, 0);
		}
		getBalanceByComponents() {
			const balanceByMonth = this.entries.toSorted(this.sortLedgerEntries).reduce((list, entry) => {
				const month = dayjs(entry.valueDate).startOf("month").format("YYYY-MM-DD");
				const monthValues = list.has(month) ? list.get(month) : {};
				if (!list.has(month)) {
					const lastKnownMonth = list.get(Array.from(list.keys()).pop());
					if (lastKnownMonth) Object.keys(lastKnownMonth).forEach((key) => {
						monthValues[key] = lastKnownMonth[key];
					});
				}
				if (!monthValues[entry.entryGroupType]) monthValues[entry.entryGroupType] = 0;
				monthValues[entry.entryGroupType] += entry.totalAmount;
				list.set(month, monthValues);
				return list;
			}, /* @__PURE__ */ new Map());
			const result = {};
			balanceByMonth.forEach((value, key) => {
				result[key] = value;
			});
			return result;
		}
		calculateBalancePerEntry() {
			let lastBalance = 0;
			let cursorMonth = null;
			if (!this.entries.length) return /* @__PURE__ */ new Map();
			const result = this.entries.toSorted(this.sortLedgerEntries).reduce((list, entry) => {
				const entryDate = dayjs(entry.valueDate).format("YYYY-MM-DD");
				if (!cursorMonth || !dayjs(entry.valueDate).isSame(cursorMonth, "month")) {
					if (cursorMonth && !list.has(cursorMonth)) list.set(cursorMonth, lastBalance);
					cursorMonth = dayjs(entry.valueDate).endOf("month").format("YYYY-MM-DD");
				}
				lastBalance += entry.totalAmount;
				list.set(entryDate, lastBalance);
				return list;
			}, /* @__PURE__ */ new Map());
			if (cursorMonth && result.size && !result.has(cursorMonth)) result.set(cursorMonth, lastBalance);
			return result;
		}
		filterTouchedEntries(entries) {
			return entries;
		}
		createAccrualEntries() {
			throw new UnsupportedError("Method is not implemented for this ledger");
		}
		getDateString(date) {
			return dayjs(date).toDate().toISOString().substring(0, 10);
		}
		sortLedgerEntries(a, b) {
			if (a.valueDate && b.valueDate) {
				if (new Date(a.valueDate) > new Date(b.valueDate)) return 1;
				if (new Date(a.valueDate) < new Date(b.valueDate)) return -1;
			}
			if (a.createdAt && b.createdAt) {
				if (new Date(a.createdAt) > new Date(b.createdAt)) return 1;
				if (new Date(a.createdAt) < new Date(b.createdAt)) return -1;
			}
			if (a.ledgerEntryId && b.ledgerEntryId) return a.ledgerEntryId - b.ledgerEntryId;
			return 0;
		}
		isSameOrBefore(d1, d2) {
			return sameDay(d1, d2) || isBefore(d1, d2);
		}
	};
}));
//#endregion
//#region src/domains/finance/ledger/general-ledger/general-ledger.opts.ts
var init_general_ledger_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/finance/ledger/general-ledger/index.ts
var init_general_ledger = __esmMin((() => {
	init_general_ledger_base_class();
	init_general_ledger_class();
	init_general_ledger_model();
	init_general_ledger_opts();
}));
//#endregion
//#region src/domains/finance/ledger/asset-ledger/estarcore-chart-of-accounts.ts
var assetLedgerEntryAccountCodeMap, ESTARCORE_STAMMKONTO_SET, ESTARCORE_DEBITOR_ACCOUNT_RANGE, ESTARCORE_KREDITOR_ACCOUNT_RANGE, isSupportedEstarcoreStammkonto, parseAccountId, isEstarcoreDebitorAccountNumber, isEstarcoreKreditorAccountNumber;
var init_estarcore_chart_of_accounts = __esmMin((() => {
	init_ledger_entry();
	assetLedgerEntryAccountCodeMap = {
		"12000": 12e3,
		"14100": 14100,
		"14112": 14112,
		"14162": 14162,
		"18000": 18e3,
		"18100": 18100,
		"18200": 18200,
		"18600": 18600,
		"31500": 31500,
		"33000": 33e3,
		"39000": 39e3,
		"35500": 35500,
		"36300": 36300,
		"38000": 38e3,
		"38062": 38062,
		"38200": 38200,
		"62500": 62500,
		"68550": 68550,
		"63253": 63253,
		"63001": 63001,
		"63006": 63006,
		"63310": 63310,
		"63390": 63390,
		"51900": 51900,
		"52011": 52011,
		"56000": 56e3,
		"62000": 62e3,
		"63000": 63e3,
		"63040": 63040,
		"63110": 63110,
		"63190": 63190,
		"63200": 63200,
		"63202": 63202,
		"63250": 63250,
		"63251": 63251,
		"63252": 63252,
		"63255": 63255,
		"63260": 63260,
		"63270": 63270,
		"63300": 63300,
		"63340": 63340,
		"63370": 63370,
		"63380": 63380,
		"64000": 64e3,
		"64050": 64050,
		"64120": 64120,
		"64130": 64130,
		"64132": 64132,
		"64134": 64134,
		"64142": 64142,
		"64310": 64310,
		"64390": 64390,
		"64418": 64418,
		"64419": 64419,
		"64460": 64460,
		"64461": 64461,
		"64470": 64470,
		"64480": 64480,
		"64500": 64500,
		"64520": 64520,
		"64530": 64530,
		"64600": 64600,
		"64850": 64850,
		"65530": 65530,
		"65531": 65531,
		"65534": 65534,
		"68500": 68500,
		"69690": 69690,
		"90000": 9e4,
		"90080": 90080,
		"90090": 90090,
		"40000": 4e4,
		"41001": 41001,
		"41004": 41004,
		"41005": 41005,
		"41008": 41008,
		"41032": 41032,
		"41034": 41034,
		"41035": 41035,
		"41040": 41040,
		"41150": 41150,
		"44001": 44001,
		"44005": 44005,
		"44008": 44008,
		"44032": 44032,
		"44033": 44033,
		"44034": 44034,
		"44035": 44035,
		"44150": 44150
	};
	ESTARCORE_STAMMKONTO_SET = new Set(Object.keys(assetLedgerEntryAccountCodeMap));
	ESTARCORE_DEBITOR_ACCOUNT_RANGE = {
		min: 1e4,
		max: 19999
	};
	ESTARCORE_KREDITOR_ACCOUNT_RANGE = {
		min: 7e4,
		max: 79999
	};
	isSupportedEstarcoreStammkonto = (code) => !!code && ESTARCORE_STAMMKONTO_SET.has(code);
	parseAccountId = (accountNumber) => {
		const [, accountId] = accountNumber.split(".");
		if (!accountId) return null;
		const parsed = Number.parseInt(accountId, 10);
		return Number.isNaN(parsed) ? null : parsed;
	};
	isEstarcoreDebitorAccountNumber = (accountNumber) => {
		if (!accountNumber) return false;
		const accountId = parseAccountId(accountNumber);
		if (accountId === null) return false;
		return accountId >= ESTARCORE_DEBITOR_ACCOUNT_RANGE.min && accountId <= ESTARCORE_DEBITOR_ACCOUNT_RANGE.max;
	};
	isEstarcoreKreditorAccountNumber = (accountNumber) => {
		if (!accountNumber) return false;
		const accountId = parseAccountId(accountNumber);
		if (accountId === null) return false;
		return accountId >= ESTARCORE_KREDITOR_ACCOUNT_RANGE.min && accountId <= ESTARCORE_KREDITOR_ACCOUNT_RANGE.max;
	};
}));
//#endregion
//#region src/domains/finance/ledger/asset-ledger/asset-ledger.class.ts
var AssetLedger;
var init_asset_ledger_class = __esmMin((() => {
	init_errors();
	init_general_ledger();
	init_ledger_entry();
	init_estarcore_chart_of_accounts();
	AssetLedger = class AssetLedger extends BaseGeneralLedger {
		/**
		* @example
		* {
		'4': AssetLedgerEntryType.Bank,
		*  '12': AssetLedgerEntryType.Invoice,
		...
		* }
		*/
		static entityGroupTypeMap = {
			"4": "Bank",
			"12": "Invoice",
			"20": "InputTaxOpt",
			"54": "Banking",
			"99": "AnnualStatement",
			"101": "ColdRent",
			"102": "Utilities",
			"103": "Utilities",
			"104": "Heating",
			"105": "Parking",
			"110": "RentReduction",
			"115": "OtherCost",
			"": "OtherCost",
			[void 0]: "OtherCost",
			[null]: "OtherCost"
		};
		static isEligibleForBooking(transaction) {
			throw new UnsupportedError("AssetLedger.isEligibleForBooking is not implemented.", transaction);
		}
		getAccountCodeFromBookingEntry(bookingEntry) {
			if (!bookingEntry.masterAccount) throw new InvalidParamsError("Could not determine LedgerEntryAccountCode for Estarcore booking entry. Reason: \"masterAccount\" is not defined.", bookingEntry);
			if (!isSupportedEstarcoreStammkonto(bookingEntry.masterAccount)) {
				const unknownAccountCode = Number.parseInt(bookingEntry.masterAccount, 10);
				return Number.isNaN(unknownAccountCode) ? void 0 : unknownAccountCode;
			}
			return assetLedgerEntryAccountCodeMap[bookingEntry.masterAccount];
		}
		/**
		* Extracts the external ID from a booking entry.
		* The external ID is a unique identifier for the booking entry, formatted as "<Buchung-Nr>.<Buchung-Pos.>".
		* @param {Estarcore.BookingEntry} bookingEntry - The booking entry from which to extract the external ID.
		* @returns {string} The external ID in the format "<Buchung-Nr>.<Buchung-Pos.>".
		* @throws {InvalidParamsError} If "Buchung-Nr." or "Buchung-Pos." is not defined in the booking entry.
		* @throws {InvalidParamsError} If the booking entry does not contain the required fields to construct the external ID.
		* @example
		* const bookingEntry = {
		*   'Buchung-Nr.': '12345',
		*   'Buchung-Pos.': '1',
		*   // other properties...
		* };
		* const externalId = this.getExternalIdFromBookingEntry(bookingEntry);
		* console.log(externalId); // Outputs: "12345.1"
		*/
		getExternalIdFromBookingEntry(bookingEntry) {
			/**
			* external_id (unique)
			<Buchung-Nr>.<Buchung-Pos.>
			*/
			if (!bookingEntry.bookingNumber) throw new InvalidParamsError("Could not determine external_id for Estarcore booking entry. Reason: \"bookingNumber\" is not defined.", bookingEntry);
			if (!bookingEntry.bookingPosition) throw new InvalidParamsError("Could not determine external_id for Estarcore booking entry. Reason: \"bookingPosition\" is not defined.", bookingEntry);
			return `${bookingEntry.bookingNumber}.${bookingEntry.bookingPosition}`;
		}
		getDataFromBookingEntry(bookingEntry) {
			const accountStammkonto = bookingEntry.accountType === "Sachkonto" ? bookingEntry.masterAccount ?? null : null;
			const counterStammkonto = bookingEntry.counterAccountType === "Sachkonto" ? bookingEntry.counterMasterAccount ?? null : null;
			const taxRate = this.getTaxRateFromBookingEntry(bookingEntry);
			const taxAmount = bookingEntry.tax ?? null;
			return {
				...bookingEntry,
				description: bookingEntry.bookingText,
				accountStammkonto,
				counterStammkonto,
				isAccountStammkontoSupported: isSupportedEstarcoreStammkonto(accountStammkonto),
				isCounterStammkontoSupported: isSupportedEstarcoreStammkonto(counterStammkonto),
				taxRate,
				taxAmount,
				vendor: bookingEntry.accountType === "Kreditor" ? bookingEntry.accountDescription : bookingEntry.counterAccountType === "Kreditor" ? bookingEntry.counterAccountDescription : null,
				vendorCode: bookingEntry.accountType === "Kreditor" ? bookingEntry.accountNumber : bookingEntry.counterAccountType === "Kreditor" ? bookingEntry.counterAccount : null
			};
		}
		getTaxRateFromBookingEntry(bookingEntry) {
			if (!bookingEntry.taxKey && !bookingEntry.taxKeyDescription) return null;
			const rateFromKey = typeof bookingEntry.taxKey === "number" ? bookingEntry.taxKey / 100 : null;
			if (rateFromKey !== null && !Number.isNaN(rateFromKey)) return rateFromKey;
			const raw = bookingEntry.taxKeyDescription?.replace("%", "") ?? null;
			if (!raw) return null;
			const rateFromDescription = Number.parseFloat(raw) / 100;
			return Number.isNaN(rateFromDescription) ? null : rateFromDescription;
		}
		isSameEntryExists(entry) {
			return this.entries.some((e) => e.externalId === entry.externalId);
		}
		/**
		* Books a new entry in the asset ledger based on the provided booking entry.
		* - If `mfhId` is provided, it will be used to set the `mfhId` field of the ledger entry.
		* - If `getMfhId` function is provided, it will be called with the `bookingCircle` (Buchungskreis) to retrieve the `mfhId` asynchronously.
		* - If neither `mfhId` nor `getMfhId` are provided, the entry will be added without an `mfhId` which will then be up to the caller to add it later.
		*/
		bookEntry(bookingEntry, additionalEntryData) {
			const newLedgerEntry = this.createNewLedgerEntry({
				...additionalEntryData,
				entryGroupType: AssetLedger.entityGroupTypeMap[bookingEntry.bookingTypeNumber?.toString()] ?? "OtherCost",
				entryType: bookingEntry.bookingType === "Bank" ? "Cash" : "Accrual",
				debit: bookingEntry.debit || 0,
				credit: bookingEntry.credit || 0,
				valueDate: bookingEntry.documentDate,
				entryDate: bookingEntry.bookingDate,
				createdAt: bookingEntry.recordedAt,
				accountCode: this.getAccountCodeFromBookingEntry(bookingEntry),
				rentalContractId: bookingEntry.rentalContract,
				externalId: this.getExternalIdFromBookingEntry(bookingEntry),
				data: this.getDataFromBookingEntry(bookingEntry),
				generalLedgerId: this.generalLedgerId,
				entryGroup: "AssetManagement",
				source: "Estarcore"
			});
			if (!this.isSameEntryExists(newLedgerEntry)) this.addLedgerEntry(newLedgerEntry);
		}
	};
}));
//#endregion
//#region src/domains/finance/ledger/asset-ledger/index.ts
var init_asset_ledger = __esmMin((() => {
	init_asset_ledger_class();
	init_estarcore_chart_of_accounts();
}));
//#endregion
//#region src/domains/cross-cutting/errors/finance/ledger/domain-errors.ts
var InvalidCategoryBookingOnBankAccountError;
var init_domain_errors = __esmMin((() => {
	InvalidCategoryBookingOnBankAccountError = class extends NonRetriableError {
		constructor(transaction, bankAccount) {
			super(`Booking transaction '${transaction.category}' and '${transaction.categoryType}' is not supported on the current bank-account`, "FINANCE_INVALID_CATEGORY_BOOKING_ON_BANK_ACCOUNT_ERROR", {
				transaction,
				bankAccount
			});
		}
	};
}));
//#endregion
//#region src/domains/finance/ledger/bank-account-ledger.class.ts
var BankAccountLedger;
var init_bank_account_ledger_class = __esmMin((() => {
	init_errors();
	init_domain_errors();
	init_balance_record_class();
	init_general_ledger();
	init_ledger_entry();
	BankAccountLedger = class extends GeneralLedger {
		bookTransaction(transaction, data) {
			switch (true) {
				case transaction.isDrawdown:
				case transaction.isFee:
					if (!data.targetLoanAccountId) throw new ApplicationError("Connected Mezzanine or Intergroup loan is not provided");
					this.addLedgerEntryFromTransaction(transaction, "Drawdown", { targetLoanAccountId: data.targetLoanAccountId });
					break;
				case transaction.isTransfer: {
					const invoice = data.invoice;
					if (transaction.isInvoice) {
						if (!invoice || invoice.paidAt) throw new ApplicationError("Invoice is missing for invoice transfer or is already paid");
						invoice.paidAt = transaction.valueDate;
					}
					if (transaction.isPurchasingPrice && !data.estateId) throw new ApplicationError("Estate ID is missing for purchasing price transfer");
					this.addLedgerEntryFromTransaction(transaction, "Transfer", {
						estateId: data.estateId,
						invoiceId: invoice?.invoiceId
					});
					break;
				}
				case transaction.isRevenue:
					if (!transaction.isSellingIncome) throw new ApplicationError("Only selling estate revenue is supported");
					this.addLedgerEntryFromTransaction(transaction, "Revenue", { estateId: data.estateId });
					break;
				case transaction.isStorno:
					this.addLedgerEntryFromTransaction(transaction, "Storno");
					break;
				case transaction.isPropertyManagementRelated:
					this.addLedgerEntryFromTransaction(transaction, "PropertyManagement");
					break;
				default: throw new InvalidCategoryBookingOnBankAccountError(transaction, transaction.bankAccount);
			}
			this.recalculateBalance(transaction.valueDate);
		}
		/**
		* For Bank Account we calculate only cash amount
		* @param {Date} day
		*/
		calculateDayBalance(day) {
			let todayRecord;
			const balanceRecord = this.findDayBalanceRecord(dayjs(day).subtract(1, "d").toDate());
			if (!balanceRecord) todayRecord = BalanceRecord.createEmptyRecord(this.generalLedgerId, { balanceDate: day });
			else todayRecord = balanceRecord.copy({ balanceDate: day });
			this.entries.filter((entry) => sameDay(entry.valueDate, day)).reduce((balance, entry) => {
				if (entry.isDrawdown && (entry.isInvoice || entry.isPurchasingPrice) || entry.isInvoiceTransfer) balance.drawdownsAmount += entry.totalAmount;
				balance.totalBalance += entry.totalAmount;
				return balance;
			}, todayRecord);
			todayRecord.freeFunds = todayRecord.totalBalance - (todayRecord.drawdownsAmount ?? 0);
			this.addBalanceRecord(todayRecord);
		}
		addLedgerEntryFromTransaction(transaction, entryGroup, data) {
			this.addLedgerEntry(this.createNewLedgerEntry({
				entryType: "Cash",
				entryGroup,
				entryGroupType: transaction.getLedgerEntryGroupType(),
				debit: !transaction.isCredit ? Math.abs(transaction.amount) : 0,
				credit: transaction.isCredit ? Math.abs(transaction.amount) : 0,
				bankTransactionId: transaction.bankTransactionId,
				valueDate: transaction.valueDate,
				...data
			}));
		}
	};
}));
//#endregion
//#region src/domains/finance/ledger/external-bank-account-ledger.class.ts
var ExternalBankAccountLedger;
var init_external_bank_account_ledger_class = __esmMin((() => {
	init_errors();
	init_balance_record_class();
	init_general_ledger();
	ExternalBankAccountLedger = class extends GeneralLedger {
		calculateDayBalanceFromStatement(statement) {
			if ([
				statement.closingBalance,
				statement?.closingBalance?.date,
				statement?.closingBalance?.value
			].some((value) => isNil(value))) throw new InvariantError("Missing closingBalance or -date/-value from statement");
			if ([
				statement.openingBalance,
				statement?.openingBalance?.date,
				statement?.openingBalance?.value
			].some((value) => isNil(value))) throw new InvariantError("Missing openingBalance or -date/-value from statement");
			const lastBalanceRecord = maxBy(this.balanceRecords, "balanceDate");
			const currentBalanceRecord = BalanceRecord.createEmptyRecord(this.generalLedgerId, {
				balanceDate: dayjs(statement.closingBalance.date).toDate(),
				totalBalance: this.getBalanceValue(statement.closingBalance)
			});
			this.addBalanceRecord(currentBalanceRecord);
			if (!lastBalanceRecord) return;
			const statementDay = dayjs(currentBalanceRecord.balanceDate);
			let assumedMissingDate = dayjs(lastBalanceRecord.balanceDate).add(1, "day");
			while (assumedMissingDate.isBefore(statementDay, "day")) {
				const record = currentBalanceRecord.copy({
					balanceDate: assumedMissingDate.toDate(),
					totalBalance: this.getBalanceValue(statement.openingBalance)
				});
				this.addBalanceRecord(record);
				assumedMissingDate = assumedMissingDate.add(1, "day");
			}
		}
		findLedgerEntry() {
			throw new UnsupportedError("method `findLedgerEntry` can not be used with ExternalBankAccountLedger class atm");
		}
		findTransactionEntries() {
			throw new UnsupportedError("method `findTransactionEntries` can not be used with ExternalBankAccountLedger class atm");
		}
		findFirstDrawdown() {
			throw new UnsupportedError("method `findFirstDrawdown` can not be used with ExternalBankAccountLedger class atm");
		}
		getAverageUsedAmount() {
			throw new UnsupportedError("method `getAverageUsedAmount` can not be used with ExternalBankAccountLedger class atm");
		}
		addLedgerEntry() {
			throw new UnsupportedError("method `addLedgerEntry` can not be used with ExternalBankAccountLedger class atm");
		}
		createNewLedgerEntry() {
			throw new UnsupportedError("method `createNewLedgerEntry` can not be used with ExternalBankAccountLedger class atm");
		}
		addFeeRepayment() {
			throw new UnsupportedError("method `addFeeRepayment` can not be used with ExternalBankAccountLedger class atm");
		}
		getBalanceValue(balanceInfo) {
			return balanceInfo.isCredit ? balanceInfo.value : balanceInfo.value * -1;
		}
	};
}));
//#endregion
//#region src/domains/finance/ledger/investor-ledger/investor-ledger.model.ts
var LedgerEventType, BookingEvent, transactionsMap;
var init_investor_ledger_model = __esmMin((() => {
	init_bank_transaction_model();
	LedgerEventType = /* @__PURE__ */ function(LedgerEventType) {
		LedgerEventType["Accrual"] = "Accrual";
		LedgerEventType["Cash"] = "Cash";
		return LedgerEventType;
	}({});
	BookingEvent = /* @__PURE__ */ function(BookingEvent) {
		BookingEvent["Rent"] = "Rent";
		BookingEvent["RentGuarantee"] = "RentGuarantee";
		BookingEvent["ManagementFee"] = "ManagementFee";
		BookingEvent["PropertyTax"] = "PropertyTax";
		BookingEvent["HOAFee"] = "HOAFee";
		BookingEvent["HOAFeeSubsidy"] = "HOAFeeSubsidy";
		BookingEvent["HOAFeeSettlement"] = "HOAFeeSettlement";
		BookingEvent["LoanAmortizationSubsidy"] = "LoanAmortizationSubsidy";
		BookingEvent["InvestorPayout"] = "InvestorPayout";
		BookingEvent["LiquidityReserve"] = "LiquidityReserve";
		BookingEvent["Invoice"] = "Invoice";
		BookingEvent["BankFee"] = "BankFee";
		BookingEvent["BankFeeCompensation"] = "BankFeeCompensation";
		BookingEvent["Other"] = "Other";
		BookingEvent["ReturnDebit"] = "ReturnDebit";
		BookingEvent["ReturnDebitFee"] = "ReturnDebitFee";
		BookingEvent["AnnualServiceChargeStatement"] = "AnnualServiceChargeStatement";
		return BookingEvent;
	}({});
	transactionsMap = () => ({
		["BankFee"]: "BankFee",
		["BankFeeCompensation"]: "BankFeeCompensation",
		["HouseGeld"]: "HOAFee",
		["HouseGeldDealPayback"]: "HOAFeeSubsidy",
		["InvestorIncome"]: "InvestorPayout",
		["Invoice"]: "Invoice",
		["ManagementFee"]: "ManagementFee",
		["PropertyTax"]: "PropertyTax",
		["Rent"]: "Rent",
		["RentGuarantee"]: "RentGuarantee",
		["RepaymentSubsidy"]: "LoanAmortizationSubsidy",
		["AnnualServiceChargeStatement"]: "AnnualServiceChargeStatement",
		["HOAFeeSettlement"]: "HOAFeeSettlement"
	});
}));
//#endregion
//#region src/domains/finance/ledger/investor-ledger/investor-ledger.rules.ts
var assignmentRules;
var init_investor_ledger_rules = __esmMin((() => {
	init_ledger_entry();
	init_ledger_entry_model();
	init_investor_ledger_model();
	assignmentRules = {
		["Rent"]: {
			entryGroupType: LedgerEntryGroupType.Rent,
			on: {
				["Accrual"]: { entries: [{
					accountCode: 1100,
					entryGroup: "Asset"
				}, {
					accountCode: 4e3,
					entryGroup: "Revenue"
				}] },
				["Cash"]: {
					alignAmountSign: (amount, accountCode) => accountCode !== 1e3 ? amount * -1 : amount,
					entries: [{
						accountCode: 1e3,
						entryGroup: "Asset"
					}, {
						accountCode: 1100,
						entryGroup: "Asset"
					}]
				}
			}
		},
		["RentGuarantee"]: {
			entryGroupType: LedgerEntryGroupType.RentGuarantee,
			on: {
				["Accrual"]: { entries: [{
					accountCode: 1110,
					entryGroup: "Asset"
				}, {
					accountCode: 4010,
					entryGroup: "Revenue"
				}] },
				["Cash"]: {
					alignAmountSign: (amount, accountCode) => accountCode !== 1e3 ? amount * -1 : amount,
					entries: [{
						accountCode: 1e3,
						entryGroup: "Asset"
					}, {
						accountCode: 1110,
						entryGroup: "Asset"
					}]
				}
			}
		},
		["ManagementFee"]: {
			entryGroupType: LedgerEntryGroupType.ManagementFee,
			on: {
				["Accrual"]: { entries: [{
					accountCode: 2e3,
					entryGroup: "Liability"
				}, {
					accountCode: 5e3,
					entryGroup: "Expense"
				}] },
				["Cash"]: { entries: [{
					accountCode: 1e3,
					entryGroup: "Asset"
				}, {
					accountCode: 2e3,
					entryGroup: "Liability"
				}] }
			}
		},
		["PropertyTax"]: {
			entryGroupType: LedgerEntryGroupType.PropertyTax,
			on: { ["Cash"]: { entries: [
				{
					accountCode: 2200,
					entryGroup: "Liability",
					entryType: "Accrual"
				},
				{
					accountCode: 5200,
					entryGroup: "Expense",
					entryType: "Accrual"
				},
				{
					accountCode: 1e3,
					entryGroup: "Asset"
				},
				{
					accountCode: 2200,
					entryGroup: "Liability"
				}
			] } }
		},
		["HOAFee"]: {
			entryGroupType: LedgerEntryGroupType.HOAFee,
			on: {
				["Accrual"]: { entries: [{
					accountCode: 2100,
					entryGroup: "Liability"
				}, {
					accountCode: 5100,
					entryGroup: "Expense"
				}] },
				["Cash"]: { entries: [{
					accountCode: 1e3,
					entryGroup: "Asset"
				}, {
					accountCode: 2100,
					entryGroup: "Liability"
				}] }
			}
		},
		["HOAFeeSubsidy"]: {
			entryGroupType: LedgerEntryGroupType.HOAFeeSubsidy,
			on: {
				["Accrual"]: { entries: [{
					accountCode: 1300,
					entryGroup: "Asset"
				}, {
					accountCode: 4200,
					entryGroup: "Revenue"
				}] },
				["Cash"]: {
					alignAmountSign: (amount, accountCode) => accountCode !== 1e3 ? amount * -1 : amount,
					entries: [{
						accountCode: 1e3,
						entryGroup: "Asset"
					}, {
						accountCode: 1300,
						entryGroup: "Asset"
					}]
				}
			}
		},
		["LoanAmortizationSubsidy"]: {
			entryGroupType: LedgerEntryGroupType.LoanAmortization,
			on: {
				["Accrual"]: { entries: [{
					accountCode: 1600,
					entryGroup: "Asset"
				}, {
					accountCode: 4100,
					entryGroup: "Revenue"
				}] },
				["Cash"]: {
					alignAmountSign: (amount, accountCode) => accountCode !== 1e3 ? amount * -1 : amount,
					entries: [
						{
							accountCode: 1e3,
							entryGroup: "Asset"
						},
						{
							accountCode: 1600,
							entryGroup: "Asset"
						},
						{
							accountCode: 2400,
							entryGroup: "Liability"
						}
					]
				}
			}
		},
		["InvestorPayout"]: {
			entryGroupType: LedgerEntryGroupType.InvestorIncome,
			on: {
				["Accrual"]: { entries: [{
					accountCode: 2600,
					entryGroup: "Liability"
				}, {
					accountCode: 5600,
					entryGroup: "Expense"
				}] },
				["Cash"]: { entries: [{
					accountCode: 1e3,
					entryGroup: "Asset"
				}, {
					accountCode: 2600,
					entryGroup: "Liability"
				}] }
			}
		},
		["LiquidityReserve"]: {
			entryGroupType: LedgerEntryGroupType.LiquidityReserve,
			on: { ["Accrual"]: { entries: [{
				accountCode: 2700,
				entryGroup: "Equity"
			}, {
				accountCode: 5700,
				entryGroup: "Expense"
			}] } }
		},
		["Invoice"]: {
			entryGroupType: LedgerEntryGroupType.Invoice,
			on: { ["Cash"]: { entries: [
				{
					accountCode: 2300,
					entryGroup: "Liability",
					entryType: "Accrual"
				},
				{
					accountCode: 5300,
					entryGroup: "Expense",
					entryType: "Accrual"
				},
				{
					accountCode: 1e3,
					entryGroup: "Asset"
				},
				{
					accountCode: 2300,
					entryGroup: "Liability"
				}
			] } }
		},
		["AnnualServiceChargeStatement"]: {
			entryGroupType: LedgerEntryGroupType.AnnualServiceChargeStatement,
			on: { ["Cash"]: { entries: [
				{
					accountCode: 5800,
					entryGroup: "Expense",
					entryType: "Accrual",
					if: (trxAmount) => trxAmount < 0
				},
				{
					accountCode: 4500,
					entryGroup: "Revenue",
					entryType: "Accrual",
					if: (trxAmount) => trxAmount > 0
				},
				{
					accountCode: 1e3,
					entryGroup: "Asset"
				}
			] } }
		},
		["HOAFeeSettlement"]: {
			entryGroupType: LedgerEntryGroupType.HOAFeeSettlement,
			on: { ["Cash"]: { entries: [
				{
					accountCode: 5110,
					entryGroup: "Expense",
					entryType: "Accrual",
					if: (trxAmount) => trxAmount < 0
				},
				{
					accountCode: 4210,
					entryGroup: "Revenue",
					entryType: "Accrual",
					if: (trxAmount) => trxAmount > 0
				},
				{
					accountCode: 1e3,
					entryGroup: "Asset"
				}
			] } }
		},
		["ReturnDebit"]: {
			entryGroupType: LedgerEntryGroupType.ReturnDebit,
			on: { ["Cash"]: { entries: [{
				accountCode: 1e3,
				entryGroup: "Asset"
			}] } }
		},
		["ReturnDebitFee"]: {
			entryGroupType: LedgerEntryGroupType.ReturnDebitFee,
			on: { ["Cash"]: { entries: [
				{
					accountCode: 2500,
					entryGroup: "Liability",
					entryType: "Accrual"
				},
				{
					accountCode: 5500,
					entryGroup: "Expense",
					entryType: "Accrual"
				},
				{
					accountCode: 1e3,
					entryGroup: "Asset"
				},
				{
					accountCode: 2500,
					entryGroup: "Liability"
				}
			] } }
		},
		["BankFee"]: {
			entryGroupType: LedgerEntryGroupType.BankFee,
			on: { ["Cash"]: { entries: [
				{
					accountCode: 2500,
					entryGroup: "Liability",
					entryType: "Accrual"
				},
				{
					accountCode: 5500,
					entryGroup: "Expense",
					entryType: "Accrual"
				},
				{
					accountCode: 1e3,
					entryGroup: "Asset"
				},
				{
					accountCode: 2500,
					entryGroup: "Liability"
				}
			] } }
		},
		["BankFeeCompensation"]: {
			entryGroupType: LedgerEntryGroupType.BankFeeCompensation,
			on: { ["Cash"]: {
				alignAmountSign: (amount, accountCode) => accountCode !== 1e3 ? amount * -1 : amount,
				entries: [
					{
						accountCode: 1500,
						entryGroup: "Asset",
						entryType: "Accrual"
					},
					{
						accountCode: 4400,
						entryGroup: "Revenue",
						entryType: "Accrual"
					},
					{
						accountCode: 1e3,
						entryGroup: "Asset"
					},
					{
						accountCode: 1500,
						entryGroup: "Asset"
					}
				]
			} }
		},
		["Other"]: {
			entryGroupType: LedgerEntryGroupType.Other,
			on: { ["Cash"]: { entries: [{
				accountCode: 1e3,
				entryGroup: "Asset"
			}] } }
		}
	};
}));
//#endregion
//#region src/domains/finance/ledger/investor-ledger/investor-ledger.class.ts
var InvestorLedger;
var init_investor_ledger_class = __esmMin((() => {
	init_errors();
	init_general_ledger();
	init_ledger_entry();
	init_investor_ledger_model();
	init_investor_ledger_rules();
	InvestorLedger = class InvestorLedger extends BaseGeneralLedger {
		static isEligibleForBooking(transaction) {
			return transaction.isReconciled && !!transaction.amount;
		}
		bookTransaction(transaction, data) {
			if (!InvestorLedger.isEligibleForBooking(transaction)) return;
			const investorInfoId = transaction.investorInfoId || data.investorInfo?.investorInfoId || data.investorInfoId;
			if (!investorInfoId) throw new InvalidStateError("Investor Info ID is required for booking investor ledger transaction", {
				estateId: data.estateId,
				bankTransactionId: transaction.bankTransactionId
			});
			if (!data.estateId) throw new InvalidStateError("Estate ID is required for booking investor ledger transaction", { bankTransactionId: transaction.bankTransactionId });
			if (this.findTransactionEntries(transaction.bankTransactionId, true).length) return;
			if (transaction.isReturnDebit) {
				this.bookReturnDebit(transaction, {
					investorInfoId,
					estateId: data.estateId,
					targetBankTransactionId: data.targetBankTransactionId
				});
				return;
			}
			const bookingEvent = this.getBookingEvent(transaction.categoryType);
			if (!bookingEvent) throw new UnsupportedError(`Investor ledger cannot book unsupported transaction category: ${transaction.category}`, {
				estateId: data.estateId,
				bankTransactionId: transaction.bankTransactionId
			});
			this.processEvent("Cash", bookingEvent, {
				investorInfoId,
				amount: transaction.amount * (transaction.isCredit ? 1 : -1),
				valueDate: transaction.valueDate,
				bankTransactionId: transaction.bankTransactionId,
				estateId: data.estateId
			}, { onlyCash: this.isTransactionBeforeInvestorStart(transaction, data.investorInfo) });
		}
		bookAccrual(event, inputEntryProps, opts) {
			if (!inputEntryProps.investorInfoId) throw new ValidationFailedError("Investor Info ID is required for accrual at investor ledger", inputEntryProps);
			if (!inputEntryProps.estateId) throw new ValidationFailedError("Estate ID is required for accrual at investor ledger", inputEntryProps);
			this.processEvent("Accrual", event, inputEntryProps, opts);
		}
		bookReturnDebit(transaction, data) {
			if (!data.targetBankTransactionId) throw new InvalidParamsError("Missing \"targetBankTransactionId\"", {
				bankTransactionId: transaction.bankTransactionId,
				...data
			});
			const originalEntries = this.findTransactionEntries(data.targetBankTransactionId, true);
			if (originalEntries.length) {
				const returnDebtitFeeAmount = originalEntries.filter((e) => e.accountCode === 1e3).reduce((trxAmount, e) => trxAmount - Math.abs(e.credit || e.debit || 0), Math.abs(transaction.amount));
				originalEntries.forEach((e) => {
					const entry = e.copy({
						debit: e.credit || 0,
						credit: e.debit || 0,
						valueDate: transaction.valueDate,
						bankTransactionId: transaction.bankTransactionId,
						data: {
							cancelingTransactionId: data.targetBankTransactionId,
							cancelingEntryId: e.ledgerEntryId,
							description: "Created by ReturnDebit transaction"
						}
					});
					this.addLedgerEntry(entry);
				});
				if (returnDebtitFeeAmount !== 0) this.processEvent("Cash", "ReturnDebitFee", {
					investorInfoId: data.investorInfoId,
					estateId: data.estateId,
					amount: returnDebtitFeeAmount * (transaction.isCredit ? 1 : -1),
					valueDate: transaction.valueDate,
					bankTransactionId: transaction.bankTransactionId,
					data: {
						cancelingTransactionId: data.targetBankTransactionId,
						description: "Return debit fee"
					}
				});
			} else this.processEvent("Cash", "ReturnDebit", {
				investorInfoId: data.investorInfoId,
				estateId: data.estateId,
				amount: transaction.amount * (transaction.isCredit ? 1 : -1),
				valueDate: transaction.valueDate,
				bankTransactionId: transaction.bankTransactionId,
				data: {
					cancelingTransactionId: data.targetBankTransactionId,
					description: "Created by ReturnDebit transaction"
				}
			});
		}
		processEvent(eventType, event, { amount, ...inputEntryProps }, opts) {
			if (!amount) return;
			if (!assignmentRules[event]) throw new UnsupportedError(`Unsupported booking assignment event: ${event}`);
			const eventProps = assignmentRules[event].on[eventType];
			if (!eventProps) throw new UnsupportedError(`Unsupported booking event type: ${event}.${eventType}`);
			const { entries, alignAmountSign } = eventProps;
			entries.forEach((entryProps) => {
				if (entryProps) {
					const entryGroupType = entryProps.entryGroupType || assignmentRules[event].entryGroupType;
					if (!entryGroupType) throw new ServiceMisconfiguredError(`entryGroupType is not defined for event: ${event}`);
					const accountType = accountTypeMap[entryProps.entryGroup];
					if (!accountType) throw new UnsupportedError(`Unsupported entry group type at investor ledger: ${entryProps.entryGroup}`);
					const ifFn = entryProps.if;
					const isAccrual = eventType === "Accrual" || entryProps.entryType === "Accrual";
					const entryAmount = isAccrual ? Math.abs(amount) : alignAmountSign ? alignAmountSign(amount, entryProps.accountCode) : amount;
					if (ifFn && !ifFn(amount)) return;
					const isDebitEntry = accountType === "debit" && entryAmount > 0 || accountType === "credit" && entryAmount < 0;
					const debit = isDebitEntry ? Math.abs(entryAmount) : 0;
					const credit = isDebitEntry ? 0 : Math.abs(entryAmount);
					const newEntry = this.createNewLedgerEntry({
						valueDate: new Date((/* @__PURE__ */ new Date()).setHours(0, 0, 0, 0)),
						entryType: isAccrual ? "Accrual" : "Cash",
						debit,
						credit,
						entryGroupType,
						...inputEntryProps,
						...entryProps
					});
					if (opts?.avoidDuplicates && this.isSameEntryExists(newEntry, true)) return;
					this.addLedgerEntry(newEntry);
				}
			});
		}
		isTransactionBeforeInvestorStart(transaction, investorInfo) {
			if (!investorInfo?.startDate) return false;
			return dayjs(transaction.valueDate).isBefore(investorInfo.startDate, "month");
		}
		getBookingEvent(categoryType) {
			return transactionsMap()[categoryType] || "Other";
		}
		getExpectedEntryGroupType(categoryType) {
			return assignmentRules[this.getBookingEvent(categoryType)].entryGroupType;
		}
	};
}));
//#endregion
//#region src/domains/finance/ledger/investor-ledger/index.ts
var init_investor_ledger = __esmMin((() => {
	init_investor_ledger_class();
	init_investor_ledger_model();
}));
//#endregion
//#region src/domains/finance/ledger/loan-ledger.class.ts
var LoanLedger;
var init_loan_ledger_class = __esmMin((() => {
	init_errors();
	init_balance_record_class();
	init_general_ledger();
	LoanLedger = class extends GeneralLedger {
		/**
		* Outstanding principal is sum of:
		*  - All drawdowns
		*  - All repayments
		*  - All processing fee records
		* @returns {number}
		*/
		outstandingPrincipal(today) {
			return this.entries.filter((entry) => (entry.isPrincipalRecord || entry.isProcessingFeeEntry) && (!today || entry.isInDateScope(today))).reduce((sum, entry) => sum + entry.totalAmount, 0);
		}
		/**
		* Take the previous day as the basis. Take records for current day
		* and calculate balance for current day.
		* @param {Date} day
		*/
		calculateDayBalance(day) {
			let todayRecord;
			const balanceRecord = this.findDayBalanceRecord(dayjs(day).subtract(1, "d").toDate());
			if (!balanceRecord) todayRecord = BalanceRecord.createEmptyRecord(this.generalLedgerId, { balanceDate: day });
			else todayRecord = balanceRecord.copy({ balanceDate: day });
			this.entries.reduce((balance, e) => {
				if (!sameDay(e.valueDate, day)) return balance;
				balance.outstandingPrincipal += e.isPrincipalRecord ? e.totalAmount : 0;
				balance.accruedCommitmentFee += e.isCommitmentFeeEntry ? e.totalAmount : 0;
				balance.paidCommitmentFee += e.isRepayment && e.isCommitmentType ? e.totalAmount : 0;
				balance.paidInterestFee += e.isRepayment && e.isInterestType ? e.totalAmount : 0;
				balance.accruedInterestFee += e.isInterestFeeEntry ? e.totalAmount : 0;
				return balance;
			}, todayRecord);
			todayRecord.accruedCommitmentFee = round$1(todayRecord.accruedCommitmentFee, 2);
			todayRecord.paidCommitmentFee = round$1(todayRecord.paidCommitmentFee, 2);
			todayRecord.paidInterestFee = round$1(todayRecord.paidInterestFee, 2);
			todayRecord.accruedInterestFee = round$1(todayRecord.accruedInterestFee, 2);
			todayRecord.outstandingPrincipal = round$1(todayRecord.outstandingPrincipal, 2);
			this.addBalanceRecord(todayRecord);
		}
		/**
		* Group entries by value (more specifically entity) and some filter function
		* @param {string} field
		* @param {(entry: LedgerEntry) => boolean} filter
		* @returns {LedgerGroupResult}
		*/
		groupEntries(field, filter) {
			return this.entries.filter(filter).reduce((acc, entry) => {
				const value = entry[field];
				return {
					...acc,
					[value]: [...acc[value] || [], entry]
				};
			}, {});
		}
		addLedgerEntry(entry) {
			if ((entry.credit ?? 0) - (entry.debit ?? 0) === 0) return false;
			entry.generalLedgerId = this.generalLedgerId;
			const existingEntry = this.findLedgerEntry(entry.valueDate, entry.entryGroup, entry.entryGroupType, entry.estateId);
			if (entry.parentId) {
				const parent = this.entries.find((e) => e.ledgerEntryId === entry.parentId);
				if (!parent) throw new EntityNotFoundError(`Parent Ledger entry not found for ${JSON.stringify(entry)}`, {
					parentId: entry.parentId,
					ledgerEntryId: entry.ledgerEntryId
				});
				parent.addChildren(entry);
			} else if (entry.isFee && existingEntry) existingEntry.addAdjustment(entry);
			else this.entries.push(entry);
			return true;
		}
	};
}));
//#endregion
//#region src/domains/finance/ledger/property-management-ledger.class.ts
var allocationPriority, PropertyManagementLedger;
var init_property_management_ledger_class = __esmMin((() => {
	init_errors();
	init_balance_record_class();
	init_general_ledger();
	init_ledger_entry();
	dayjs.extend(isSameOrBefore);
	dayjs.extend(isSameOrAfter);
	allocationPriority = new Map([
		LedgerEntryGroupType.Utilities,
		LedgerEntryGroupType.Heating,
		LedgerEntryGroupType.Parking,
		LedgerEntryGroupType.ColdRent,
		LedgerEntryGroupType.ReturnDebitFee
	].map((item, index) => [item, index]));
	PropertyManagementLedger = class PropertyManagementLedger extends GeneralLedger {
		opts;
		lastError;
		static isEligibleForBooking(transaction) {
			return (transaction.isRent || transaction.isInvoice && !!transaction.invoiceId && !!transaction.rentTenancyId || transaction.isNegativeRent || transaction.isAnnualServiceChargeStatement || (transaction.isReturnDebit || transaction.isReturnDebitFee) && !!transaction.rentTenancyId) && !!transaction.amount;
		}
		/**
		* @deprecated
		*/
		calculateDayBalance(day) {
			let todayRecord;
			const balanceRecord = this.findDayBalanceRecord(dayjs(day).subtract(1, "d").toDate());
			if (!balanceRecord) todayRecord = BalanceRecord.createEmptyRecord(this.generalLedgerId, { balanceDate: day });
			else todayRecord = balanceRecord.copy({ balanceDate: day });
			this.entries.filter((entry) => sameDay(entry.valueDate, day) && entry.entryGroup === "PropertyManagement").reduce((balance, entry) => {
				balance.totalBalance = round$1(balance.totalBalance + entry.totalAmount, 2);
				return balance;
			}, todayRecord);
			this.addBalanceRecord(todayRecord);
		}
		maybeGetEntryGroupType(transaction) {
			if (transaction.isReturnDebitFee) return [LedgerEntryGroupType.ReturnDebitFee];
			if (transaction.isInvoice) return [LedgerEntryGroupType.Invoice];
			if (transaction.isAnnualServiceChargeStatement) return [LedgerEntryGroupType.AnnualServiceChargeStatement];
			if (transaction.isRent || transaction.isNegativeRent) return [
				LedgerEntryGroupType.Utilities,
				LedgerEntryGroupType.Heating,
				LedgerEntryGroupType.Parking,
				LedgerEntryGroupType.ColdRent
			];
			return null;
		}
		assertEntryGroupTypes(transaction, expectedEntryGroupType) {
			const actualEntryGroupTypes = this.maybeGetEntryGroupType(transaction);
			if (actualEntryGroupTypes && !actualEntryGroupTypes.includes(expectedEntryGroupType)) throw new ApplicationError("Cannot book transaction with unexpected entry group type", { hint: {
				bankTransactionId: transaction.bankTransactionId,
				expectedEntryGroupType,
				actualEntryGroupTypes
			} });
		}
		bookTransaction(transaction, data) {
			if (!PropertyManagementLedger.isEligibleForBooking(transaction)) {
				this.lastError = new InvalidStateError("Cannot book transaction that is not a rent", { bankTransactionId: transaction.bankTransactionId });
				return false;
			}
			let result = true;
			switch (true) {
				case transaction.isReturnDebit:
					result = this.bookReturnDebit(transaction, data);
					break;
				case transaction.isReturnDebitFee:
					this.assertEntryGroupTypes(transaction, LedgerEntryGroupType.ReturnDebitFee);
					result = this.bookAs(LedgerEntryGroupType.ReturnDebitFee, transaction, data);
					break;
				case transaction.isInvoice:
					if (!transaction.invoiceId) throw new InvalidParamsError("Missing \"invoiceId\"", {
						bankTransactionId: transaction.bankTransactionId,
						data
					});
					this.assertEntryGroupTypes(transaction, LedgerEntryGroupType.Invoice);
					result = this.bookAs(LedgerEntryGroupType.Invoice, transaction, data, { invoiceId: transaction.invoiceId });
					break;
				case transaction.isAnnualServiceChargeStatement:
					if (!transaction.serviceChargeStatementId) throw new InvalidParamsError("Missing \"serviceChargeStatementId\" during entry booking", {
						bankTransactionId: transaction.bankTransactionId,
						data
					});
					this.assertEntryGroupTypes(transaction, LedgerEntryGroupType.AnnualServiceChargeStatement);
					result = this.bookAs(LedgerEntryGroupType.AnnualServiceChargeStatement, transaction, data, { data: { serviceChargeStatementId: transaction.serviceChargeStatementId } });
					break;
				default:
					if (this.findTransactionEntries(transaction.bankTransactionId, true).length) {
						this.lastError = new InvalidStateError("Transaction is already booked", { bankTransactionId: transaction.bankTransactionId });
						return false;
					}
					if (transaction.isCredit) this.bookPositiveAmount(transaction, data);
					else this.bookNegativeAmount(transaction, data);
					break;
			}
			return result;
		}
		getRentAmounts(rent, transaction, isNegative = false) {
			if (!rent) throw new InvalidStateError("Cannot get rent amounts for transaction booking due to missing rent data", { bankTransactionId: transaction.bankTransactionId });
			const ratio = round$1(this.getRentAmountRatioForMonth(rent, transaction.valueDate), 2);
			const utilitiesAmount = (rent.utilityCost ?? 0) * ratio;
			const heatingAmount = (rent.heatingCost ?? 0) * ratio;
			const parkingAmount = (rent.parkingSpaceRent ?? 0) * ratio;
			const coldRentAmount = (rent.coldRent ?? 0) * ratio;
			return [
				{
					entryGroupType: LedgerEntryGroupType.Utilities,
					debit: isNegative ? utilitiesAmount : null,
					credit: isNegative ? null : utilitiesAmount
				},
				{
					entryGroupType: LedgerEntryGroupType.Heating,
					debit: isNegative ? heatingAmount : null,
					credit: isNegative ? null : heatingAmount
				},
				{
					entryGroupType: LedgerEntryGroupType.Parking,
					debit: isNegative ? parkingAmount : null,
					credit: isNegative ? null : parkingAmount
				},
				{
					entryGroupType: LedgerEntryGroupType.ColdRent,
					debit: isNegative ? coldRentAmount : null,
					credit: isNegative ? null : coldRentAmount
				}
			].sort(this.sortByPriority);
		}
		/**
		* Calculates outstanding/surplus amounts for the specified period per component
		* @param {Date} [startDate]
		* @param {Date} [endDate]
		*/
		getTotalAmounts(startDate, endDate) {
			const amounts = this.getPriorityEntriesForPeriod(startDate, endDate, [LedgerEntryGroupType.ReturnDebitFee]).reduce((acc, entry) => {
				if (!acc[entry.entryGroupType]) acc[entry.entryGroupType] = {
					credit: 0,
					debit: 0
				};
				acc[entry.entryGroupType] = {
					credit: safeSum(acc[entry.entryGroupType].credit, entry.credit ?? 0),
					debit: safeSum(acc[entry.entryGroupType].debit, entry.debit ?? 0)
				};
				return acc;
			}, {});
			return Object.keys(amounts).reduce((result, key) => {
				result.push({
					entryGroupType: key,
					...amounts[key]
				});
				return result;
			}, []).sort(this.sortByPriority);
		}
		/**
		* Returns filtered priority entries for specified period
		* Entries: utilities, heating, parking, cold rent
		*/
		getPriorityEntriesForPeriod(startDate, endDate, excludedEntryGroupTypes) {
			return this.entries.filter((entry) => {
				return (!startDate || dayjs(entry.valueDate).isSameOrAfter(startDate, "day")) && (!endDate || dayjs(entry.valueDate).isSameOrBefore(endDate, "day")) && entry.entryGroup === "PropertyManagement" && allocationPriority.has(entry.entryGroupType) && !excludedEntryGroupTypes?.includes(entry.entryGroupType);
			});
		}
		/**
		* Get all accrual entries sorted by priority order and date
		*/
		getAccrualEntries() {
			return this.entries.filter((entry) => entry.entryGroup === "PropertyManagement" && entry.entryType === "Accrual").sort(this.sortByPriority);
		}
		createAccrualEntries(amounts, entry) {
			let created = 0;
			const valueDate = entry.valueDate ?? /* @__PURE__ */ new Date();
			const entriesOfDate = this.entries.filter((e) => sameDay(e.valueDate, valueDate));
			[
				{
					entryGroupType: LedgerEntryGroupType.Utilities,
					debit: Math.abs(amounts.utilityCost),
					credit: 0
				},
				{
					entryGroupType: LedgerEntryGroupType.Heating,
					debit: Math.abs(amounts.heatingCost),
					credit: 0
				},
				{
					entryGroupType: LedgerEntryGroupType.Parking,
					debit: Math.abs(amounts.parkingCost),
					credit: 0
				},
				{
					entryGroupType: LedgerEntryGroupType.ColdRent,
					debit: Math.abs(amounts.coldRent),
					credit: 0
				}
			].forEach((componentData) => {
				const exists = _filter(entriesOfDate, {
					...componentData,
					entryType: "Accrual"
				});
				const allCompensated = exists.every((e) => e.totalAmount === 0);
				if ((!exists.length || allCompensated) && componentData.debit) {
					if (this.addLedgerEntry(this.createNewLedgerEntry({
						...entry,
						...componentData,
						valueDate,
						entryType: "Accrual",
						entryGroup: "PropertyManagement"
					}))) created++;
				}
			});
			return created;
		}
		filterTouchedEntries(entries) {
			return entries.filter((entry) => entry.isTouched);
		}
		getRentBalanceTotals() {
			const totals = this.entries.filter((e) => allocationPriority.has(e.entryGroupType)).reduce((result, entry) => {
				if (entry.entryType === "Accrual") if (entry.isManual) result.manualAdjustmentsTotal += entry.totalAmount;
				else result.expectedRent += entry.totalAmount;
				else if (entry.bankTransactionId || entry.data?.compensateLegacy) result.transactionsTotal += entry.totalAmount;
				else if (entry.isManual) result.manualAdjustmentsTotal += entry.totalAmount;
				else if (!entry.isManual) result.otherCashTotal += entry.totalAmount;
				return result;
			}, {
				transactionsTotal: 0,
				manualAdjustmentsTotal: 0,
				expectedRent: 0,
				otherCashTotal: 0
			});
			return {
				rentBalance: totals.transactionsTotal + totals.manualAdjustmentsTotal - Math.abs(totals.expectedRent) + totals.otherCashTotal,
				...totals
			};
		}
		getRentAmountRatioForMonth(rent, date) {
			const startDateDiff = dayjs(new Date(rent.startDate)).diff(dayjs(new Date(rent.startDate)).startOf("month"), "day");
			const middleOfMonth = startDateDiff > 10 && startDateDiff < 20;
			return dayjs(rent.startDate).isSame(date, "month") && middleOfMonth ? .5 : 1;
		}
		bookAs(entryGroupType, transaction, data, props) {
			this.verifyRelatedTransactionEntries(transaction, data);
			this.addLedgerEntry(this.createNewLedgerEntry({
				valueDate: transaction.valueDate,
				bankTransactionId: transaction.bankTransactionId,
				entryType: "Cash",
				entryGroup: "PropertyManagement",
				entryGroupType,
				debit: !transaction.isCredit ? Math.abs(transaction.amount) : null,
				credit: transaction.isCredit ? Math.abs(transaction.amount) : null,
				estateId: data.estateId,
				rentalContractIds: data.rentalContractId ? [data.rentalContractId] : [],
				...props
			}));
			return true;
		}
		bookReturnDebit(transaction, data) {
			if (!data.targetBankTransactionId) throw new InvalidParamsError("Missing \"targetBankTransactionId\"", {
				bankTransactionId: transaction.bankTransactionId,
				data
			});
			this.verifyRelatedTransactionEntries(transaction, data);
			const nonCompensatedEntries = this.findTransactionEntries(data.targetBankTransactionId, true).map((e) => ({
				credit: e.credit,
				debit: e.debit,
				entryGroupType: e.entryGroupType,
				data: {
					cancelingTransactionId: data.targetBankTransactionId,
					cancelingEntryId: e.ledgerEntryId
				}
			}));
			this.allocateTrxAmountToEntries({
				data,
				transaction,
				entries: nonCompensatedEntries
			}, {
				isNegative: !transaction.isCredit,
				isReturnDebit: true
			});
			return true;
		}
		bookNegativeAmount(transaction, data) {
			if (!data.rent) throw new InvalidStateError("Cannot book rent transaction with negative amount due to missing rent data", { bankTransactionId: transaction.bankTransactionId });
			const uncoveredEntries = this.getRentAmounts(data.rent, transaction).reverse();
			this.allocateTrxAmountToEntries({
				data,
				transaction,
				entries: uncoveredEntries
			}, { isNegative: true });
		}
		bookPositiveAmount(transaction, data) {
			if (!this.getAccrualEntries().length && !data.rent) throw new InvalidStateError("Cannot book rent transaction due to missing accrual entries or rent data", { bankTransactionId: transaction.bankTransactionId });
			const uncoveredAmounts = this.getTotalAmounts(/* @__PURE__ */ new Date("2021-12-31"), new Date(transaction.valueDate));
			const uncoveredEntries = uncoveredAmounts.length ? uncoveredAmounts : this.getRentAmounts(data.rent, transaction, true);
			this.allocateTrxAmountToEntries({
				data,
				transaction,
				entries: uncoveredEntries
			});
		}
		verifyRelatedTransactionEntries(transaction, data) {
			const existingEntries = this.findTransactionEntries(transaction.bankTransactionId);
			if (!existingEntries.every((e) => e.children.every((c) => c.data?.compensated && (c.credit ?? 0) - (c.debit ?? 0) + (e.credit ?? 0) - (e.debit ?? 0) === 0))) throw new InvalidStateError("Cannot book cancelling transaction if all entries have not been compensated", {
				existingEntries: existingEntries.map((e) => e.ledgerEntryId),
				targetBankTransactionId: data.targetBankTransactionId,
				bankTransactionId: transaction.bankTransactionId,
				invoiceId: transaction.invoiceId,
				serviceChargeStatementId: transaction.serviceChargeStatementId
			});
		}
		allocateTrxAmountToEntries({ entries, transaction, data }, opts) {
			const uncoveredEntries = entries[Symbol.iterator]();
			let remainingTxAmount = Math.abs(transaction.amount);
			let currentEntry = uncoveredEntries.next();
			const sign = opts?.isNegative ? -1 : 1;
			const entryDefaultProps = {
				entryGroup: "PropertyManagement",
				estateId: data.estateId,
				valueDate: transaction.valueDate,
				bankTransactionId: transaction.bankTransactionId
			};
			const newEntries = [];
			while (remainingTxAmount > 0 && !currentEntry.done) {
				const totalEntry = currentEntry.value;
				const signedAmount = (totalEntry.credit ?? 0) - (totalEntry.debit ?? 0);
				if (signedAmount && (opts?.isNegative && signedAmount > 0 || !opts?.isNegative && signedAmount < 0)) {
					const amountToCover = Math.min(remainingTxAmount, Math.abs(signedAmount));
					remainingTxAmount -= amountToCover;
					if (remainingTxAmount < 0) throw new InvalidStateError("Remaining amount cannot not be negative after allocation", { bankTransactionId: transaction.bankTransactionId });
					const debit = sign < 0 ? amountToCover : null;
					const credit = sign > 0 ? amountToCover : null;
					newEntries.push(this.createNewLedgerEntry({
						...entryDefaultProps,
						entryType: "Cash",
						entryGroupType: totalEntry.entryGroupType,
						debit,
						credit,
						data: totalEntry.data || null,
						rentalContractIds: data.rentalContractId ? [...totalEntry?.rentalContractIds || [], data.rentalContractId] : []
					}));
				}
				currentEntry = uncoveredEntries.next();
			}
			if (remainingTxAmount > 0) {
				const remainingAmountEntry = this.createNewLedgerEntry({
					...entryDefaultProps,
					entryType: "Cash",
					entryGroupType: opts?.isReturnDebit ? LedgerEntryGroupType.ReturnDebitFee : opts?.isInvoice ? LedgerEntryGroupType.Invoice : LedgerEntryGroupType.ColdRent,
					debit: sign < 0 ? round$1(Math.abs(remainingTxAmount), 2) : 0,
					credit: sign > 0 ? round$1(Math.abs(remainingTxAmount), 2) : 0,
					rentalContractIds: data.rentalContractId ? [data.rentalContractId] : [],
					data: data.targetBankTransactionId ? { cancelingTransactionId: data.targetBankTransactionId } : null
				});
				if (remainingAmountEntry.entryGroupType === LedgerEntryGroupType.ColdRent) {
					const existingCRIdx = newEntries.findIndex((e) => e.entryGroupType === remainingAmountEntry.entryGroupType && e.entryType === remainingAmountEntry.entryType);
					if (existingCRIdx !== -1) {
						newEntries[existingCRIdx].debit = (newEntries[existingCRIdx].debit ?? 0) + (remainingAmountEntry.debit ?? 0);
						newEntries[existingCRIdx].credit = (newEntries[existingCRIdx].credit ?? 0) + (remainingAmountEntry.credit ?? 0);
					} else newEntries.push(remainingAmountEntry);
				} else newEntries.push(remainingAmountEntry);
			}
			newEntries.forEach((entry) => this.addLedgerEntry(entry));
		}
		sortByPriority(a, b) {
			const delta = (allocationPriority.has(a.entryGroupType) ? allocationPriority.get(a.entryGroupType) : Number.POSITIVE_INFINITY) - (allocationPriority.has(b.entryGroupType) ? allocationPriority.get(b.entryGroupType) : Number.POSITIVE_INFINITY);
			if (delta !== 0) return delta;
			if (a.valueDate && b.valueDate) {
				const dateA = new Date(a.valueDate);
				const dateB = new Date(b.valueDate);
				if (dateA < dateB) return -1;
				if (dateA > dateB) return 1;
			}
			return 0;
		}
	};
}));
//#endregion
//#region src/domains/finance/ledger/ledger-factory.class.ts
var LedgerFactory;
var init_ledger_factory_class = __esmMin((() => {
	init_asset_ledger();
	init_bank_account_ledger_class();
	init_external_bank_account_ledger_class();
	init_general_ledger();
	init_investor_ledger();
	init_loan_ledger_class();
	init_property_management_ledger_class();
	LedgerFactory = class {
		static factory(props, type) {
			switch (type ?? props.generalLedgerType) {
				case "BankAccount": return new BankAccountLedger(props);
				case "ExternalBankAccount": return new ExternalBankAccountLedger(props);
				case "LoanAccount": return new LoanLedger(props);
				case "PropertyManagementAccount": return new PropertyManagementLedger(props);
				case "InvestorAccount": return new InvestorLedger(props);
				case "AssetAccount": return new AssetLedger(props);
				default: return new GeneralLedger(props);
			}
		}
	};
}));
//#endregion
//#region src/domains/finance/bank-account/bank-account.class.ts
var BankAccount;
var init_bank_account_class = __esmMin((() => {
	init_base();
	init_investor_info_class();
	init_bank_transaction_class();
	init_ledger_factory_class();
	BankAccount = class BankAccount extends BaseClassAttributes {
		bankAccountId;
		externalEntityId;
		bankId;
		companyId;
		contactPersonId;
		escrowEstateId;
		bankAccountType;
		iban;
		bic;
		shouldUseForInvoices;
		lastBalance;
		lastBalanceDate;
		/**
		* For connection between Business and Loan accounts and potentially any other linking.
		* Link is required because repayment to loan account would always come from main account
		* @type {number}
		*/
		parentId;
		bank;
		company;
		/**
		* For loan account - main account which is used for repayments and drawdowns
		* @type {BankAccount}
		*/
		parentAccount;
		/**
		* For main accounts - list of loan accounts with the same purpose
		* @type {BankAccount[]}
		*/
		linkedAccounts;
		transactions = [];
		issuedTransactions = [];
		loanAccount;
		contactPerson;
		generalLedger;
		investorInfo;
		sepaMandates;
		escrowEstate;
		estates;
		constructor(props) {
			super(props);
			Object.assign(this, props);
			if (props.parentAccount) this.parentAccount = new BankAccount(props.parentAccount);
			if (props?.linkedAccounts?.length) this.linkedAccounts = props.linkedAccounts.map((account) => new BankAccount(account));
			if (props?.generalLedger) this.generalLedger = LedgerFactory.factory(props?.generalLedger);
			if (props?.transactions?.length) this.transactions = props.transactions.map((tx) => new BankTransaction(tx));
			if (props?.issuedTransactions?.length) this.issuedTransactions = props.issuedTransactions.map((tx) => new BankTransaction(tx));
			if (props?.investorInfo?.length) this.investorInfo = props.investorInfo.map((ii) => new InvestorInfo(ii));
		}
		get isLoanBankAccount() {
			return this.bankAccountType === "Loan";
		}
		get isBusinessAccount() {
			return this.bankAccountType === "Business";
		}
		get isBankServiceAccount() {
			return this.bankAccountType === "BankServiceAccount";
		}
		get isRentDeposit() {
			return this.bankAccountType === "RentDeposit";
		}
		get isInvestorAccount() {
			if (this.investorInfo?.[0]?.investorBankAccountId === this.bankAccountId) return true;
			if (this.bankAccountType === "Investor") return true;
			if (this.contactPerson?.contactType === "Buyer") return true;
			return false;
		}
		get investorInfoId() {
			return this.investorInfo?.[0]?.investorInfoId;
		}
		get isEscrowAccount() {
			return this.bankAccountType === "Escrow";
		}
		get isTenantOwned() {
			return this.contactPerson?.contactType === "Tenant";
		}
		get needsGeneralLedger() {
			return this.isBusinessAccount || this.isEscrowAccount;
		}
	};
}));
//#endregion
//#region src/domains/finance/bank-account/bank-account.i18n.ts
var ViewBankAccountType;
var init_bank_account_i18n = __esmMin((() => {
	ViewBankAccountType = /* @__PURE__ */ function(ViewBankAccountType) {
		ViewBankAccountType["WEG"] = "WEG";
		ViewBankAccountType["Investor"] = "Investor";
		ViewBankAccountType["CondoAsset"] = "Condo Asset";
		ViewBankAccountType["Business"] = "Business";
		ViewBankAccountType["Tenant"] = "Tenant";
		ViewBankAccountType["Escrow"] = "Escrow";
		ViewBankAccountType["BankService"] = "Bank Service";
		ViewBankAccountType["Deposit"] = "Deposit";
		return ViewBankAccountType;
	}({});
}));
//#endregion
//#region src/domains/finance/bank-account/bank-account.model.ts
var init_bank_account_model = __esmMin((() => {}));
//#endregion
//#region src/domains/finance/bank-account/bank-account.opts.ts
var init_bank_account_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/finance/bank-transaction-parsing.ts
var CondoPaymentCode, parseCondoReference, CondoPaymentReference;
var init_bank_transaction_parsing = __esmMin((() => {
	init_errors();
	init_bank_transaction_model();
	CondoPaymentCode = {
		["Rent"]: 100,
		["RentDeposit"]: 110,
		["ParkingIncome"]: 120,
		["RepaymentSubsidy"]: 130,
		["RefundManagementFee"]: 140,
		["HouseGeldDealPayback"]: 150,
		["RentGuarantee"]: 160,
		["AnnualServiceChargeStatement"]: 170,
		["HouseGeld"]: 210,
		["ManagementFee"]: 220,
		["BadDebts"]: 230,
		["Other"]: 240,
		["LiquidityReserve"]: 300,
		["InvestorIncome"]: 400,
		["ReturnDebit"]: 500
	};
	parseCondoReference = (reference) => {
		const paymentReferenceMatch = reference.match(/.*XX(\..*?\.)XX/);
		if (!paymentReferenceMatch) return;
		const paymentReference = paymentReferenceMatch[1];
		const estateCondoUuidMatch = paymentReference.match(/E:\s*([A-ZÄÖÜß\d\s-]+?)\s*\./);
		const paymentCodeMatch = paymentReference.match(/C:\s*(\d{3})\s*\./);
		if (!estateCondoUuidMatch || !paymentCodeMatch) return;
		const userContactIdMatch = paymentReference.match(/U:\s*(\d+)\s*\./);
		const rentIdMatch = paymentReference.match(/R:\s*(\d+)\s*\./);
		const tenancyIdMatch = paymentReference.match(/T:\s*(\d+)\s*\./);
		const periodMatch = paymentReference.match(/P:\s*(\d{2}\/\d{2}\/\d{4}|\d{2}\/\d{4})\s*\./);
		const investorInfoIdMatch = paymentReference.match(/I:\s*(\d+)\s*\./);
		let period = null;
		if (periodMatch) {
			const rawPeriod = periodMatch[1];
			const dayjsPeriodFull = dayjs(rawPeriod, "DD/MM/YYYY", true);
			const dayjsPeriodMonthYear = dayjs(rawPeriod, "MM/YYYY", true);
			if (dayjsPeriodFull.isValid()) period = dayjsPeriodFull.toDate();
			else if (dayjsPeriodMonthYear.isValid()) period = dayjsPeriodMonthYear.startOf("month").toDate();
		}
		return {
			estateCondoUuid: estateCondoUuidMatch[1].trim().replace(/\s+|-/g, "_"),
			paymentCode: +paymentCodeMatch[1],
			userContactId: userContactIdMatch ? +userContactIdMatch[1] : null,
			rentId: rentIdMatch ? +rentIdMatch[1] : null,
			rentTenancyId: tenancyIdMatch ? +tenancyIdMatch[1] : null,
			period: period || null,
			investorInfoId: investorInfoIdMatch ? +investorInfoIdMatch[1] : null
		};
	};
	CondoPaymentReference = class {
		_estateCondoUuid;
		_paymentCode;
		_userContactId;
		_rentId;
		_rentTenancyId;
		_period;
		_investorInfoId;
		estateCondoUuid(uuid, separator = " ") {
			this._estateCondoUuid = uuid.trim().replaceAll("_", separator);
			return this;
		}
		paymentCode(code) {
			if (!Object.values(CondoPaymentCode).includes(code)) throw new InvalidParamsError(`Invalid payment code, expected one of  ${Object.values(CondoPaymentCode).join(", ")}`);
			this._paymentCode = code;
			return this;
		}
		userContactId(userContactId) {
			this._userContactId = userContactId.toString();
			return this;
		}
		rentId(rentId) {
			this._rentId = rentId.toString();
			return this;
		}
		rentTenancyId(rentTenancyId) {
			this._rentTenancyId = rentTenancyId.toString();
			return this;
		}
		period(date) {
			this._period = dayjs(date).format("DD/MM/YYYY");
			return this;
		}
		investorInfoId(investorInfoId) {
			this._investorInfoId = investorInfoId.toString();
			return this;
		}
		build() {
			if (!this.estateCondoUuid) throw new InvalidParamsError("Estate UUID is required to generate condo payment reference");
			if (!this.paymentCode) throw new InvalidParamsError("Payment Code is required to generate condo payment reference");
			let result = `XX.E:${this._estateCondoUuid}.C:${this._paymentCode}`;
			if (this._userContactId) result += `.U:${this._userContactId}`;
			if (this._rentId) result += `.R:${this._rentId}`;
			if (this._rentTenancyId) result += `.T:${this._rentTenancyId}`;
			if (this._period) result += `.P:${this._period}`;
			if (this._investorInfoId) result += `.I:${this._investorInfoId}`;
			result += ".XX";
			return result;
		}
	};
}));
//#endregion
//#region src/domains/finance/bank-transaction.i18n.ts
var BankTransactionCategoryTypeTranslations, bankTransactionWarningDescription;
var init_bank_transaction_i18n = __esmMin((() => {
	init_bank_transaction_model();
	BankTransactionCategoryTypeTranslations = {
		["Rent"]: "Mieteinnahmen",
		["RentDeposit"]: "Mietkaution",
		["ParkingIncome"]: "Stellplatzmiete",
		["RepaymentSubsidy"]: "Tilgungszuschuss",
		["RefundManagementFee"]: "Erstattung SEV-Gebühr",
		["HouseGeldDealPayback"]: "Erstattung Hausgeld",
		["AnnualServiceChargeStatement"]: "Betriebskostenabrechnung",
		["RentGuarantee"]: "Erstvermietungsgarantie",
		["HouseGeld"]: "Hausgeld (nicht-umlagefähig)",
		["ManagementFee"]: "SEV-Gebühr",
		["BadDebts"]: "Mietausfall",
		["Other"]: "Sonstige Ausgaben",
		["LiquidityReserve"]: "Liquiditätsrücklage",
		["InvestorIncome"]: "Ausschüttung",
		["ReturnDebit"]: "Ruecklastschrift"
	};
	bankTransactionWarningDescription = {
		["Unknown"]: "Transaction has \"Unknown\" type. Reconcile this transaction",
		["NoTenancyInfo"]: "No Tenancy Information is linked",
		["NoActiveRentTenancy"]: "Rent Tenancy is not assigned. Important for Rent Balance",
		["NoInvestorInfo"]: "No Investor Info assigned. Important for Investor Payout",
		["NoEstateForEscrowAccount"]: "",
		["NoInvestorInfoAttachedIssuer"]: "",
		["NoInvestorInfoAttachedTarget"]: "",
		["NoAnnualServiceChargeStatement"]: "No BKA assigned. Important for BKA payment status",
		["NoInvoiceAttached"]: "No Invoice attached",
		["InvalidPaymentReferenceCode"]: "Invalid Payment Reference",
		["InvalidPaymentReferenceEstateUUID"]: "Estate UUID is not valid in the reference",
		["FundsReturnIsNotDirectDebit"]: "This is Money Return and it has to be marked as Return Debit.",
		["TransactionConflictingReference"]: "Payment reference parsing is incomplete as it contains conflicting information",
		["TransactionIncompleteStatement"]: "Transaction is in incomplete state"
	};
}));
//#endregion
//#region src/domains/finance/bank-transaction.opts.ts
var init_bank_transaction_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/finance/controlling-view/controlling-view-column.model.ts
var init_controlling_view_column_model = __esmMin((() => {}));
//#endregion
//#region src/domains/finance/controlling-view/base-controlling-view-column.class.ts
var BaseControllingViewColumn;
var init_base_controlling_view_column_class = __esmMin((() => {
	BaseControllingViewColumn = class {
		id;
		createdAt;
		updatedAt;
		approvedAt;
		rentPerSqm;
		estateRent;
		parkingRent;
		expectedSalesPrice;
		otherIncome;
		purchasePrice;
		notaryCost;
		taxes;
		propertyRegistration;
		agencyFee;
		referralFee;
		otherAncillaryCost;
		generalRenovationCost;
		kitchenCost;
		otherRenovationCost;
		homeOwnersFee;
		measurements;
		utilities;
		sellingCost;
		otherSellingCost;
		propertyRelatedCost;
		specialAgreements;
		bonus;
		pmIncentive;
		laborCost;
		financingCostSenior;
		financingCostJunior;
		extraCosts;
		constructor() {
			this.id = 0;
			this.createdAt = "";
			this.updatedAt = "";
			this.approvedAt = "";
			this.rentPerSqm = 0;
			this.estateRent = 0;
			this.parkingRent = 0;
			this.expectedSalesPrice = 0;
			this.otherIncome = 0;
			this.purchasePrice = 0;
			this.notaryCost = 0;
			this.taxes = 0;
			this.propertyRegistration = 0;
			this.agencyFee = 0;
			this.referralFee = 0;
			this.otherAncillaryCost = 0;
			this.generalRenovationCost = 0;
			this.kitchenCost = 0;
			this.otherRenovationCost = 0;
			this.homeOwnersFee = 0;
			this.measurements = 0;
			this.utilities = 0;
			this.sellingCost = 0;
			this.otherSellingCost = 0;
			this.propertyRelatedCost = 0;
			this.specialAgreements = 0;
			this.bonus = 0;
			this.pmIncentive = 0;
			this.laborCost = 0;
			this.financingCostSenior = 0;
			this.financingCostJunior = 0;
			this.extraCosts = 0;
		}
		get expenses() {
			return this.purchasePrice + this.transactionCost + this.renovationCost + this.otherCost + this.distributionAndMarketingCost + this.operatingCost;
		}
		get income() {
			return this.expectedSalesPrice + this.otherIncome;
		}
		get transactionCost() {
			return this.notaryCost + this.taxes + this.propertyRegistration + this.agencyFee + this.referralFee + this.otherAncillaryCost;
		}
		get renovationCost() {
			return this.generalRenovationCost + this.kitchenCost + this.otherRenovationCost;
		}
		get otherCost() {
			return this.homeOwnersFee + this.measurements + this.utilities + this.extraCosts;
		}
		get distributionAndMarketingCost() {
			return this.sellingCost + this.otherSellingCost + this.propertyRelatedCost + this.specialAgreements + this.bonus + this.pmIncentive;
		}
		get operatingCost() {
			return this.laborCost + this.financingCostSenior + this.financingCostJunior;
		}
		get operationalCost() {
			return this.purchasePrice + this.transactionCost + this.renovationCost + this.otherCost;
		}
		get operationalReturn() {
			return this.income - this.operationalCost;
		}
		get contributionMargin1() {
			return this.operationalReturn / this.operationalCost;
		}
		get netContributionCost() {
			return this.operationalCost + this.distributionAndMarketingCost;
		}
		get netContributionMargin() {
			return this.income - this.netContributionCost;
		}
		get contributionMargin15() {
			return this.netContributionMargin / this.netContributionCost;
		}
		get totalCost() {
			return this.netContributionCost + this.operatingCost;
		}
		get totalReturn() {
			return this.income - this.totalCost;
		}
		get contributionMargin2() {
			return this.totalReturn / this.totalCost;
		}
		toJSON() {
			return {
				...this,
				expenses: this.expenses,
				income: this.income,
				transactionCost: this.transactionCost,
				renovationCost: this.renovationCost,
				otherCost: this.otherCost,
				distributionAndMarketingCost: this.distributionAndMarketingCost,
				operatingCost: this.operatingCost,
				operationalCost: this.operationalCost,
				operationalReturn: this.operationalReturn,
				contributionMargin1: this.contributionMargin1,
				netContributionCost: this.netContributionCost,
				netContributionMargin: this.netContributionMargin,
				contributionMargin15: this.contributionMargin15,
				totalCost: this.totalCost,
				totalReturn: this.totalReturn,
				contributionMargin2: this.contributionMargin2
			};
		}
	};
}));
//#endregion
//#region src/domains/transaction/selling.model.ts
var SellingPaidStates, SellingOfferAcceptedStates;
var init_selling_model = __esmMin((() => {
	init_processes();
	SellingPaidStates = ["Paid", "Completed"];
	SellingOfferAcceptedStates = [
		"OfferAccepted",
		"NotaryDraftReceived",
		"DraftApproved",
		"Notarized",
		"FMReceived",
		...SellingPaidStates
	];
}));
//#endregion
//#region src/domains/finance/investment/cashflow/calculations/amortization-calculations.ts
var calculateAmortizationValues, calculateInterestPerYear, calculateAmortizationPerYear, calclulateResidualDebtPerYear, getAmortizationPeriodLabel, calculateAmortizationPeriod, calculateAmortizationRatePurchasePrice;
var init_amortization_calculations = __esmMin((() => {
	calculateAmortizationValues = ({ inputs, debtCapitalEuro, annuityPerYear, secondLoanResidualDebt, firstLoanAnnuity, secondLoanAnnuity }) => {
		const residualDebtPerYear = calclulateResidualDebtPerYear({
			inputs,
			debtCapitalEuro,
			firstLoanAnnuity,
			secondLoanAnnuity,
			secondLoanResidualDebt
		});
		const interestPerYear = calculateInterestPerYear({
			inputs,
			debtCapitalEuro,
			residualDebtPerYear
		});
		return {
			residualDebtPerYear,
			interestPerYear,
			amortizationPerYear: calculateAmortizationPerYear({
				inputs,
				debtCapitalEuro,
				interestPerYear,
				annuityPerYear,
				secondLoanResidualDebt
			})
		};
	};
	calculateInterestPerYear = ({ inputs, debtCapitalEuro, residualDebtPerYear }) => {
		const { firstLoanInterestRate, firstLoanPeriod, secondLoanPeriod, secondLoanInterestRate } = inputs;
		return {
			1: debtCapitalEuro * firstLoanInterestRate,
			...range(2, firstLoanPeriod + 1).reduce((acc, year) => ({
				...acc,
				[String(year)]: residualDebtPerYear[year - 1] * firstLoanInterestRate
			}), {}),
			...range(firstLoanPeriod + 1, firstLoanPeriod + secondLoanPeriod + 1).reduce((acc, year) => ({
				...acc,
				[String(year)]: residualDebtPerYear[year - 1] * secondLoanInterestRate
			}), {})
		};
	};
	calculateAmortizationPerYear = ({ secondLoanResidualDebt, inputs, debtCapitalEuro, annuityPerYear, interestPerYear }) => {
		const { firstLoanAmortizationRate, firstLoanPeriod, secondLoanPeriod, secondLoanAmortizationRate } = inputs;
		return {
			0: 0,
			1: debtCapitalEuro * firstLoanAmortizationRate,
			...range(2, firstLoanPeriod + 1).reduce((acc, year) => ({
				...acc,
				[String(year)]: annuityPerYear[year] - interestPerYear[year]
			}), {}),
			[firstLoanPeriod + 1]: secondLoanResidualDebt * secondLoanAmortizationRate,
			...range(firstLoanPeriod + 2, firstLoanPeriod + secondLoanPeriod + 1).reduce((acc, year) => ({
				...acc,
				[String(year)]: annuityPerYear[year] - interestPerYear[year]
			}), {})
		};
	};
	calclulateResidualDebtPerYear = ({ inputs, debtCapitalEuro, firstLoanAnnuity, secondLoanAnnuity, secondLoanResidualDebt }) => {
		const { firstLoanInterestRate, firstLoanPeriod, secondLoanPeriod, secondLoanInterestRate } = inputs;
		return {
			0: 0,
			...range(1, firstLoanPeriod + 1).reduce((acc, year) => {
				const interestPerYear = (1 + firstLoanInterestRate) ** year;
				const minuend = debtCapitalEuro * interestPerYear;
				const subtrahend = firstLoanAnnuity * (interestPerYear - 1) / firstLoanInterestRate;
				return {
					...acc,
					[String(year)]: minuend - subtrahend
				};
			}, {}),
			...range(firstLoanPeriod + 1, firstLoanPeriod + secondLoanPeriod + 1).reduce((acc, year) => {
				const adjustedYear = year - firstLoanPeriod;
				const interestPerYear = (1 + secondLoanInterestRate) ** adjustedYear;
				const minuend = secondLoanResidualDebt * interestPerYear;
				const subtrahend = secondLoanAnnuity * (interestPerYear - 1) / secondLoanInterestRate;
				return {
					...acc,
					[String(year)]: minuend - subtrahend
				};
			}, {})
		};
	};
	getAmortizationPeriodLabel = (remainingUsefulLife, remainingUsefulLifeCommission, remainingUsefulLifeCommissionDate) => {
		if (!isNil(remainingUsefulLife)) return `${remainingUsefulLife} Jahre`;
		switch (remainingUsefulLifeCommission) {
			case true: return `Beauftragt${remainingUsefulLifeCommissionDate ? ` (${formatDate$1(remainingUsefulLifeCommissionDate)})` : ""}`;
			case false: return "In Bearbeitung ";
			default: return "Nicht Erforderlich";
		}
	};
	calculateAmortizationPeriod = (attributes, cashflowDefaultAssumptions) => {
		if (attributes?.remainingUsefulLife) return attributes.remainingUsefulLife;
		if (!attributes.constructionYear || attributes.constructionYear >= 1925) return cashflowDefaultAssumptions.amortizationPeriodSameOrAfter1925;
		return cashflowDefaultAssumptions.amortizationPeriodBefore1925;
	};
	calculateAmortizationRatePurchasePrice = (amortizationPeriod) => amortizationPeriod === 0 ? 0 : +(1 / amortizationPeriod);
}));
//#endregion
//#region src/domains/finance/investment/cashflow/calculations/base-calculations.ts
var calculateBaseValues$1, calculateAutomaticSubsidy, calculateAnnuityPerYear;
var init_base_calculations = __esmMin((() => {
	init_errors();
	calculateBaseValues$1 = /* @__PURE__ */ __name(({ inputs }) => {
		const { proportionPlot, firstLoanPeriod, secondLoanPeriod, firstLoanInterestRate, firstLoanAmortizationRate, secondLoanInterestRate, secondLoanAmortizationRate, totalPurchasePrice, maintenanceMonth, taxRate, discountableTaxRate, agencyFeeRate, agencyFeeTotal, propertyRegistrationRate, discountablePropertyRegistrationRate, notaryCostsRate, discountableNotaryCostsRate, proprietaryCapitalPercent, proprietaryCapitalEuro, kitchenPrice } = inputs;
		if (!Number.isFinite(agencyFeeRate) && !Number.isFinite(agencyFeeTotal)) throw new InvariantError("Must provide either agency-fee as a rate or as total");
		const interestPerPeriod = (1 + firstLoanInterestRate) ** firstLoanPeriod;
		const totalYears = firstLoanPeriod + secondLoanPeriod;
		const proportionBuilding = 1 - proportionPlot;
		const maintenanceYear = maintenanceMonth * 12;
		const taxCostsTotal = (discountableTaxRate ?? taxRate) * (totalPurchasePrice - (kitchenPrice ?? 0));
		const agencyCostsTotal = 0;
		const propertyRegistrationCostsTotal = (discountablePropertyRegistrationRate ?? propertyRegistrationRate) * totalPurchasePrice;
		const notaryCostsTotal = (discountableNotaryCostsRate ?? notaryCostsRate) * totalPurchasePrice;
		const ancillaryCostsTotal = taxCostsTotal + agencyCostsTotal + propertyRegistrationCostsTotal + notaryCostsTotal;
		const totalInvestmentAmount = totalPurchasePrice + ancillaryCostsTotal;
		const { automaticSubsidyRate, automaticSubsidyAmount, automaticSubsidyCashflow, automaticSubsidyEquity } = calculateAutomaticSubsidy(inputs);
		const proprietaryCapital = !isNil(proprietaryCapitalEuro) ? proprietaryCapitalEuro : ancillaryCostsTotal + totalPurchasePrice * proprietaryCapitalPercent;
		const debtCapital = totalInvestmentAmount - proprietaryCapital - (automaticSubsidyEquity ?? 0);
		const debtCapitalEuro = !isNil(proprietaryCapitalEuro) ? totalInvestmentAmount - proprietaryCapitalEuro - (automaticSubsidyEquity ?? 0) : totalPurchasePrice * (1 - proprietaryCapitalPercent) - (automaticSubsidyEquity ?? 0);
		const firstLoanAnnuity = debtCapitalEuro * (firstLoanInterestRate + firstLoanAmortizationRate);
		const secondLoanResidualDebt = totalPurchasePrice * interestPerPeriod - firstLoanAnnuity * (interestPerPeriod - 1) / firstLoanInterestRate;
		const secondLoanAnnuity = secondLoanResidualDebt * (secondLoanInterestRate + secondLoanAmortizationRate);
		return {
			totalInvestmentAmount,
			automaticSubsidyRate,
			automaticSubsidyAmount,
			automaticSubsidyCashflow,
			automaticSubsidyEquity,
			proprietaryCapital,
			debtCapital,
			debtCapitalEuro,
			secondLoanResidualDebt,
			maintenanceYear,
			proportionBuilding,
			firstLoanAnnuity,
			secondLoanAnnuity,
			annuityPerYear: calculateAnnuityPerYear({
				inputs,
				firstLoanAnnuity,
				secondLoanAnnuity
			}),
			totalYears,
			taxCostsTotal,
			agencyCostsTotal,
			propertyRegistrationCostsTotal,
			notaryCostsTotal,
			ancillaryCostsTotal
		};
	}, "calculateBaseValues");
	calculateAutomaticSubsidy = ({ automaticSubsidyEquityPercentOrEuro, automaticSubsidyDiscountPeriod, automaticSubsidyAdditionalRate, totalPurchasePrice }) => {
		const automaticSubsidyDetails = {
			automaticSubsidyRate: 0,
			automaticSubsidyAmount: 0,
			automaticSubsidyEquity: 0,
			automaticSubsidyCashflow: 0
		};
		if (isNil(automaticSubsidyEquityPercentOrEuro) || !automaticSubsidyDiscountPeriod) return automaticSubsidyDetails;
		automaticSubsidyDetails.automaticSubsidyRate = (totalPurchasePrice < 2e5 ? .02 : totalPurchasePrice < 3e5 ? .04 : .06) + (automaticSubsidyAdditionalRate ?? 0);
		automaticSubsidyDetails.automaticSubsidyAmount = totalPurchasePrice * automaticSubsidyDetails.automaticSubsidyRate;
		automaticSubsidyDetails.automaticSubsidyEquity = automaticSubsidyEquityPercentOrEuro <= 1 ? automaticSubsidyDetails.automaticSubsidyAmount * automaticSubsidyEquityPercentOrEuro : automaticSubsidyEquityPercentOrEuro;
		automaticSubsidyDetails.automaticSubsidyCashflow = (automaticSubsidyDetails.automaticSubsidyAmount - automaticSubsidyDetails.automaticSubsidyEquity) / automaticSubsidyDiscountPeriod;
		return automaticSubsidyDetails;
	};
	calculateAnnuityPerYear = ({ inputs, firstLoanAnnuity, secondLoanAnnuity }) => {
		const { firstLoanPeriod, secondLoanPeriod } = inputs;
		return {
			0: 0,
			...range(1, firstLoanPeriod + 1).reduce((acc, year) => ({
				...acc,
				[String(year)]: firstLoanAnnuity
			}), {}),
			...range(firstLoanPeriod + 1, firstLoanPeriod + secondLoanPeriod + 1).reduce((acc, year) => ({
				...acc,
				[String(year)]: secondLoanAnnuity
			}), {})
		};
	};
}));
//#endregion
//#region src/domains/finance/investment/cashflow/calculations/cashflow-calculations.ts
var calculateCashflowValues, calculateEatPerYear, calculatePropertyManagementCostsPerYear, calculateDiscountablePropertyManagementCostsPerYear, calculateEatPerYearMonths, calculateEbitdaPerYear, calculateEbitdaPerYearMonths, calculateDepreciationTransactionCostsPerYear, calculateDepreciationPurchasePricePerYear, calculateDepreciationKitchenPricePerYear, calculateNonTransferableHomeOwnersFeePerYear, calculateDiscountableNonTransferableHomeOwnersFeePerYear, calculateTaxResultsPerYear, calculateTaxBenefitsPerYear, calculateMaintenancePerYear, calculateDiscountableMaintenancePerYear, calculateBaseRepaymentSubsidyPerYear, calculatePaymentsPerYear;
var init_cashflow_calculations = __esmMin((() => {
	calculateCashflowValues = ({ inputs, ancillaryCostsTotal, totalYears, proportionBuilding, annuityPerYear, interestPerYear, taxCostsTotal, agencyCostsTotal, propertyRegistrationCostsTotal, notaryCostsTotal, automaticSubsidyCashflow }) => {
		const maintenancePerYear = calculateMaintenancePerYear({
			inputs,
			totalYears
		});
		const discountableMaintenancePerYear = calculateDiscountableMaintenancePerYear({
			inputs,
			totalYears
		});
		const nonTransferableHomeOwnersFeePerYear = calculateNonTransferableHomeOwnersFeePerYear({
			inputs,
			totalYears
		});
		const discountableNonTransferableHomeOwnersFeePerYear = calculateDiscountableNonTransferableHomeOwnersFeePerYear({
			inputs,
			totalYears
		});
		const propertyManagementCostsPerYear = calculatePropertyManagementCostsPerYear({
			totalYears,
			inputs
		});
		const discountablePropertyManagementCostsPerYear = calculateDiscountablePropertyManagementCostsPerYear({
			totalYears,
			inputs
		});
		const ebitdaPerYear = calculateEbitdaPerYear({
			maintenancePerYear,
			nonTransferableHomeOwnersFeePerYear,
			propertyManagementCostsPerYear,
			ancillaryCostsTotal,
			annuityPerYear,
			totalYears,
			inputs
		});
		const discountableEbitdaPerYear = calculateEbitdaPerYear({
			maintenancePerYear: discountableMaintenancePerYear,
			nonTransferableHomeOwnersFeePerYear: discountableNonTransferableHomeOwnersFeePerYear,
			propertyManagementCostsPerYear: discountablePropertyManagementCostsPerYear,
			ancillaryCostsTotal,
			annuityPerYear,
			totalYears,
			inputs
		});
		const ebitdaPerYearMonths = calculateEbitdaPerYearMonths({
			ebitdaPerYear,
			totalYears
		});
		const discountableEbitdaPerYearMonths = calculateEbitdaPerYearMonths({
			ebitdaPerYear: discountableEbitdaPerYear,
			totalYears
		});
		const depreciationTransactionCostsPerYear = calculateDepreciationTransactionCostsPerYear({
			inputs,
			totalYears,
			taxCostsTotal,
			agencyCostsTotal,
			propertyRegistrationCostsTotal,
			notaryCostsTotal
		});
		const depreciationPurchasePricePerYear = calculateDepreciationPurchasePricePerYear({
			inputs,
			totalYears,
			proportionBuilding
		});
		const depreciationKitchenPricePerYear = calculateDepreciationKitchenPricePerYear({
			inputs,
			totalYears
		});
		const taxResultsPerYear = calculateTaxResultsPerYear({
			inputs,
			totalYears,
			interestPerYear,
			depreciationPurchasePricePerYear,
			depreciationKitchenPricePerYear,
			depreciationTransactionCostsPerYear,
			propertyManagementCostsPerYear,
			nonTransferableHomeOwnersFeePerYear
		});
		const discountableTaxResultsPerYear = calculateTaxResultsPerYear({
			inputs,
			totalYears,
			interestPerYear,
			depreciationPurchasePricePerYear,
			depreciationTransactionCostsPerYear,
			depreciationKitchenPricePerYear,
			propertyManagementCostsPerYear: discountablePropertyManagementCostsPerYear,
			nonTransferableHomeOwnersFeePerYear: discountableNonTransferableHomeOwnersFeePerYear
		});
		const taxBenefitsPerYear = calculateTaxBenefitsPerYear({
			inputs,
			totalYears,
			taxResultsPerYear
		});
		const discountableTaxBenefitsPerYear = calculateTaxBenefitsPerYear({
			inputs,
			totalYears,
			taxResultsPerYear: discountableTaxResultsPerYear
		});
		const eatPerYear = calculateEatPerYear({
			totalYears,
			taxBenefitsPerYear,
			ebitdaPerYear
		});
		const discountableEatPerYear = calculateEatPerYear({
			totalYears,
			taxBenefitsPerYear: discountableTaxBenefitsPerYear,
			ebitdaPerYear: discountableEbitdaPerYear
		});
		const eatPerYearMonths = calculateEatPerYearMonths({
			eatPerYear,
			totalYears
		});
		const discountableEatPerYearMonths = calculateEatPerYearMonths({
			eatPerYear: discountableEatPerYear,
			totalYears
		});
		const baseRepaymentSubsidyPerYear = calculateBaseRepaymentSubsidyPerYear({
			inputs,
			totalYears
		});
		return {
			annuityPerYear,
			ebitdaPerYear,
			discountableEbitdaPerYear,
			ebitdaPerYearMonths,
			discountableEbitdaPerYearMonths,
			depreciationTransactionCostsPerYear,
			depreciationPurchasePricePerYear,
			depreciationKitchenPricePerYear,
			propertyManagementCostsPerYear,
			discountablePropertyManagementCostsPerYear,
			nonTransferableHomeOwnersFeePerYear,
			discountableNonTransferableHomeOwnersFeePerYear,
			taxResultsPerYear,
			discountableTaxResultsPerYear,
			taxBenefitsPerYear,
			discountableTaxBenefitsPerYear,
			eatPerYear,
			discountableEatPerYear,
			eatPerYearMonths,
			discountableEatPerYearMonths,
			maintenancePerYear,
			discountableMaintenancePerYear,
			baseRepaymentSubsidyPerYear,
			paymentsPerYear: calculatePaymentsPerYear({
				inputs,
				discountableEatPerYear,
				baseRepaymentSubsidyPerYear,
				automaticSubsidyCashflow
			})
		};
	};
	calculateEatPerYear = ({ totalYears, taxBenefitsPerYear, ebitdaPerYear }) => {
		return {
			0: 0,
			...range(1, totalYears + 1).reduce((acc, year) => ({
				...acc,
				[String(year)]: -Math.abs(ebitdaPerYear[year] + taxBenefitsPerYear[year])
			}), {})
		};
	};
	calculatePropertyManagementCostsPerYear = ({ totalYears, inputs }) => {
		return [0, ...getPrefixSumArrayWithInflation(inputs.propertyManagementMonthlyCosts * 12, inputs.inflationRate, totalYears)].reduce((acc, propMgmtFee, year) => ({
			...acc,
			[year]: propMgmtFee
		}), {});
	};
	calculateDiscountablePropertyManagementCostsPerYear = ({ totalYears, inputs }) => {
		const discountablePropertyManagementCostsPerYears = getPrefixSumArrayWithInflation(inputs.discountablePropertyManagementMonthlyCosts * 12, inputs.inflationRate, inputs.propertyManagementMonthlyCostsDiscountPeriod ?? 0);
		return [0, ...getPrefixSumArrayWithInflation(inputs.propertyManagementMonthlyCosts * 12, inputs.inflationRate, totalYears, discountablePropertyManagementCostsPerYears)].reduce((acc, propMgmtFee, year) => ({
			...acc,
			[year]: propMgmtFee
		}), {});
	};
	calculateEatPerYearMonths = ({ totalYears, eatPerYear }) => {
		return {
			0: 0,
			...range(1, totalYears + 1).reduce((acc, year) => ({
				...acc,
				[String(year)]: eatPerYear[year] / 12
			}), {})
		};
	};
	calculateEbitdaPerYear = ({ inputs, maintenancePerYear, nonTransferableHomeOwnersFeePerYear, propertyManagementCostsPerYear, ancillaryCostsTotal, totalYears, annuityPerYear }) => {
		const { incomePerMonth, parkingIncomePerMonth } = inputs;
		const totalIncomeYear = (incomePerMonth + parkingIncomePerMonth) * 12;
		return {
			0: ancillaryCostsTotal * -1,
			...range(1, totalYears + 1).reduce((acc, year) => ({
				...acc,
				[String(year)]: totalIncomeYear - (maintenancePerYear[year] + nonTransferableHomeOwnersFeePerYear[year] + propertyManagementCostsPerYear[year]) - annuityPerYear[year]
			}), {})
		};
	};
	calculateEbitdaPerYearMonths = ({ totalYears, ebitdaPerYear }) => {
		return range(0, totalYears + 1).reduce((acc, year) => ({
			...acc,
			[String(year)]: ebitdaPerYear[year] / 12
		}), {});
	};
	calculateDepreciationTransactionCostsPerYear = ({ inputs, totalYears, taxCostsTotal, agencyCostsTotal, propertyRegistrationCostsTotal, notaryCostsTotal }) => {
		const { amortizationPeriod } = inputs;
		const proportionalTransactionCosts = (notaryCostsTotal + taxCostsTotal + agencyCostsTotal) / amortizationPeriod;
		return {
			0: 0,
			1: propertyRegistrationCostsTotal + proportionalTransactionCosts,
			...range(2, totalYears + 1).reduce((acc, year) => ({
				...acc,
				[String(year)]: proportionalTransactionCosts
			}), {})
		};
	};
	calculateDepreciationPurchasePricePerYear = ({ inputs, totalYears, proportionBuilding }) => {
		const { amortizationRatePurchasePrice, totalPurchasePrice, proportionBuildingEuro, kitchenPrice } = inputs;
		const purchasePriceCosts = amortizationRatePurchasePrice * (!isNil(proportionBuildingEuro) ? totalPurchasePrice - kitchenPrice - proportionBuildingEuro : (totalPurchasePrice - kitchenPrice) * proportionBuilding);
		return {
			0: 0,
			...range(1, totalYears + 1).reduce((acc, year) => ({
				...acc,
				[String(year)]: purchasePriceCosts
			}), {})
		};
	};
	calculateDepreciationKitchenPricePerYear = ({ inputs, totalYears }) => {
		const { amortizationPeriodKitchen, kitchenPrice } = inputs;
		const depreciationKitchen = amortizationPeriodKitchen / 100 * kitchenPrice;
		return {
			0: 0,
			...range(1, totalYears + 1).reduce((acc, year) => ({
				...acc,
				[String(year)]: year <= amortizationPeriodKitchen ? depreciationKitchen : 0
			}), {})
		};
	};
	calculateNonTransferableHomeOwnersFeePerYear = ({ inputs, totalYears }) => {
		return [0, ...getPrefixSumArrayWithInflation(inputs.homeOwnersFeeNonTransferableMonth * 12, inputs.inflationRate, totalYears)].reduce((acc, fee, year) => ({
			...acc,
			[year]: fee
		}), {});
	};
	calculateDiscountableNonTransferableHomeOwnersFeePerYear = ({ inputs, totalYears }) => {
		const discountableHomeOwnersFeeNonTransferableRange = getPrefixSumArrayWithInflation(inputs.discountableHomeOwnersFeeNonTransferableMonth * 12, inputs.inflationRate, inputs.maintenanceReserveMonthDiscountPeriod ?? 0);
		return [0, ...getPrefixSumArrayWithInflation(inputs.homeOwnersFeeNonTransferableMonth * 12, inputs.inflationRate, totalYears, discountableHomeOwnersFeeNonTransferableRange)].reduce((acc, fee, year) => ({
			...acc,
			[year]: fee
		}), {});
	};
	calculateTaxResultsPerYear = ({ inputs, totalYears, interestPerYear, depreciationTransactionCostsPerYear, depreciationPurchasePricePerYear, propertyManagementCostsPerYear, depreciationKitchenPricePerYear, nonTransferableHomeOwnersFeePerYear }) => {
		const totalIncomeYear = (inputs.incomePerMonth + inputs.parkingIncomePerMonth) * 12;
		return {
			0: 0,
			...range(1, totalYears + 1).reduce((acc, year) => ({
				...acc,
				[String(year)]: totalIncomeYear - nonTransferableHomeOwnersFeePerYear[year] - propertyManagementCostsPerYear[year] - interestPerYear[year] - depreciationKitchenPricePerYear[year] - depreciationTransactionCostsPerYear[year] - depreciationPurchasePricePerYear[year]
			}), {})
		};
	};
	calculateTaxBenefitsPerYear = ({ inputs, totalYears, taxResultsPerYear }) => {
		const { incomeTaxRate } = inputs;
		return {
			0: 0,
			...range(1, totalYears + 1).reduce((acc, year) => ({
				...acc,
				[String(year)]: taxResultsPerYear[year] * incomeTaxRate * -1
			}), {})
		};
	};
	calculateMaintenancePerYear = ({ inputs, totalYears }) => {
		return [0, ...getPrefixSumArrayWithInflation(inputs.maintenanceMonth * 12, inputs.inflationRate, totalYears)].reduce((acc, maintenance, year) => ({
			...acc,
			[year]: maintenance
		}), {});
	};
	calculateDiscountableMaintenancePerYear = ({ inputs, totalYears }) => {
		const discountableMaintenancePerYear = getPrefixSumArrayWithInflation(inputs.discountableMaintenanceMonth * 12, inputs.inflationRate, inputs.maintenanceReserveMonthDiscountPeriod ?? 0);
		return [0, ...getPrefixSumArrayWithInflation(inputs.maintenanceMonth * 12, inputs.inflationRate, totalYears, discountableMaintenancePerYear)].reduce((acc, maintenance, year) => ({
			...acc,
			[year]: maintenance
		}), {});
	};
	calculateBaseRepaymentSubsidyPerYear = ({ inputs, totalYears }) => {
		const baseRepaymentSubsidyPerYear = { 0: 0 };
		const totalPurchasePrice = inputs.totalPurchasePrice;
		const discountPeriod = inputs.repaymentSubsidyDiscountPeriod ?? 0;
		const repaymentSubsidyRate = inputs.repaymentSubsidyRate ?? 0;
		for (let year = 1; year <= totalYears; year++) baseRepaymentSubsidyPerYear[year] = year <= discountPeriod ? totalPurchasePrice * repaymentSubsidyRate : 0;
		return baseRepaymentSubsidyPerYear;
	};
	calculatePaymentsPerYear = ({ inputs, discountableEatPerYear, baseRepaymentSubsidyPerYear, automaticSubsidyCashflow = 0 }) => {
		const automaticSubsidyDiscountPeriod = inputs.automaticSubsidyDiscountPeriod ?? 0;
		return Object.keys(discountableEatPerYear).reduce((acc, year) => {
			acc[+year] = discountableEatPerYear[+year] + baseRepaymentSubsidyPerYear[+year] + (+year < automaticSubsidyDiscountPeriod ? automaticSubsidyCashflow : 0);
			return acc;
		}, {});
	};
}));
//#endregion
//#region src/domains/finance/investment/cashflow/calculations/output-calculations.ts
var calculateIRR, calculateOutputValues;
var init_output_calculations = __esmMin((() => {
	calculateIRR = ({ inputs, paymentsPerYear, sellingPrice, proprietaryCapital, loanValuta }) => {
		const base = dayjs(`01-01-${inputs.irrStartYear}`, "MM-DD-YYYY").endOf("year");
		const irrPaymentsPerYear = [];
		const totalYears = inputs.propertySoldAfterYears;
		irrPaymentsPerYear.push(-proprietaryCapital + paymentsPerYear[1]);
		for (let i = 2; i < totalYears; i++) irrPaymentsPerYear.push(paymentsPerYear[i]);
		irrPaymentsPerYear.push(paymentsPerYear[totalYears] + sellingPrice + loanValuta);
		const rate = xirr(irrPaymentsPerYear.map((amount, index) => ({
			amount,
			date: base.add(index, "year").toDate()
		})));
		return {
			internalRateOfReturn: Number.isNaN(rate.rate) ? 0 : convertRate(rate.rate, RateInterval.Year),
			irrPaymentsPerYear
		};
	};
	calculateOutputValues = ({ inputs, taxBenefitsPerYear, discountableTaxBenefitsPerYear, amortizationPerYear, interestPerYear, residualDebtPerYear, proprietaryCapital, baseRepaymentSubsidyPerYear, automaticSubsidyCashflow, paymentsPerYear }) => {
		const taxBenefitsMonth = taxBenefitsPerYear[2] / 12;
		const discountableTaxBenefitsMonth = discountableTaxBenefitsPerYear[2] / 12;
		const totalIncomeMonth = inputs.incomePerMonth + inputs.parkingIncomePerMonth;
		const interestMonth = interestPerYear[2] / 12;
		const amortizationMonth = amortizationPerYear[2] / 12;
		const maintenanceReserveMonth = inputs.homeOwnersFeeNonTransferableMonth + inputs.maintenanceMonth;
		const discountableMaintenanceReserveMonth = inputs.discountableHomeOwnersFeeNonTransferableMonth + inputs.discountableMaintenanceMonth;
		const propertyManagementCostsMonth = inputs.propertyManagementMonthlyCosts;
		const discountablePropertyManagementCostsMonth = inputs.discountablePropertyManagementMonthlyCosts;
		const baseRepaymentSubsidyMonth = baseRepaymentSubsidyPerYear[2] / 12;
		const repaymentSubsidyMonth = baseRepaymentSubsidyMonth + (automaticSubsidyCashflow ?? 0) / 12;
		const totalExpensesMonth = interestMonth + amortizationMonth + maintenanceReserveMonth + propertyManagementCostsMonth;
		const discountableTotalExpensesMonth = interestMonth + amortizationMonth + discountableMaintenanceReserveMonth + discountablePropertyManagementCostsMonth;
		const cashflowMonth = totalIncomeMonth + taxBenefitsMonth - totalExpensesMonth;
		const discountableCashflowMonth = totalIncomeMonth + discountableTaxBenefitsMonth - discountableTotalExpensesMonth + repaymentSubsidyMonth;
		const tenYearAverageCashflowMonth = (discountableCashflowMonth * 3 + cashflowMonth * 7) / 10;
		const sellingPrice = inputs.totalPurchasePrice * (1 + inputs.appreciationValuePercent) ** inputs.propertySoldAfterYears;
		const loanValuta = residualDebtPerYear[inputs.propertySoldAfterYears] * -1;
		const sumMonthlyPaymentsUntilSelling = Object.values(paymentsPerYear).slice(1, inputs.propertySoldAfterYears + 1).reduce((acc, val) => acc + val, 0);
		const investorProfit = sellingPrice + loanValuta + sumMonthlyPaymentsUntilSelling - proprietaryCapital;
		const investorProfitTax = inputs.propertySoldAfterYears < 10 ? investorProfit * inputs.incomeTaxRate : 0;
		const netInvestorProfit = investorProfit - investorProfitTax;
		const returnOnEquity = netInvestorProfit / proprietaryCapital;
		const { irrPaymentsPerYear, internalRateOfReturn } = calculateIRR({
			proprietaryCapital,
			inputs,
			paymentsPerYear,
			sellingPrice,
			loanValuta
		});
		return {
			grossRentalReturn: inputs.totalPurchasePrice ? totalIncomeMonth * 12 / inputs.totalPurchasePrice : 0,
			irrPaymentsPerYear,
			internalRateOfReturn,
			returnOnEquity,
			loanValuta,
			investorProfit,
			investorProfitTax,
			netInvestorProfit,
			baseRepaymentSubsidyMonth,
			repaymentSubsidyMonth,
			sumMonthlyPaymentsUntilSelling,
			sellingPrice,
			taxBenefitsMonth,
			discountableTaxBenefitsMonth,
			interestMonth,
			amortizationMonth,
			maintenanceReserveMonth,
			discountableMaintenanceReserveMonth,
			totalExpensesMonth,
			discountableTotalExpensesMonth,
			totalIncomeMonth,
			propertyManagementCostsMonth,
			discountablePropertyManagementCostsMonth,
			cashflowMonth,
			discountableCashflowMonth,
			tenYearAverageCashflowMonth
		};
	};
}));
//#endregion
//#region src/domains/finance/investment/cashflow/calculations/index.ts
var calculateAllCashflowValues;
var init_calculations = __esmMin((() => {
	init_amortization_calculations();
	init_base_calculations();
	init_cashflow_calculations();
	init_output_calculations();
	init_amortization_calculations();
	init_base_calculations();
	init_cashflow_calculations();
	init_output_calculations();
	calculateAllCashflowValues = (inputs) => {
		const baseValues = calculateBaseValues$1({ inputs });
		const amortizationValues = calculateAmortizationValues({
			inputs,
			debtCapitalEuro: baseValues.debtCapitalEuro,
			annuityPerYear: baseValues.annuityPerYear,
			secondLoanAnnuity: baseValues.secondLoanAnnuity,
			firstLoanAnnuity: baseValues.firstLoanAnnuity,
			secondLoanResidualDebt: baseValues.secondLoanResidualDebt
		});
		const cashflowValues = calculateCashflowValues({
			inputs,
			ancillaryCostsTotal: baseValues.ancillaryCostsTotal,
			notaryCostsTotal: baseValues.notaryCostsTotal,
			propertyRegistrationCostsTotal: baseValues.propertyRegistrationCostsTotal,
			agencyCostsTotal: baseValues.agencyCostsTotal,
			taxCostsTotal: baseValues.taxCostsTotal,
			totalYears: baseValues.totalYears,
			proportionBuilding: baseValues.proportionBuilding,
			interestPerYear: amortizationValues.interestPerYear,
			annuityPerYear: baseValues.annuityPerYear,
			automaticSubsidyCashflow: baseValues.automaticSubsidyCashflow
		});
		const outputValues = calculateOutputValues({
			inputs,
			taxBenefitsPerYear: cashflowValues.taxBenefitsPerYear,
			discountableTaxBenefitsPerYear: cashflowValues.discountableTaxBenefitsPerYear,
			amortizationPerYear: amortizationValues.amortizationPerYear,
			proprietaryCapital: baseValues.proprietaryCapital,
			interestPerYear: amortizationValues.interestPerYear,
			residualDebtPerYear: amortizationValues.residualDebtPerYear,
			baseRepaymentSubsidyPerYear: cashflowValues.baseRepaymentSubsidyPerYear,
			automaticSubsidyCashflow: baseValues.automaticSubsidyCashflow,
			paymentsPerYear: cashflowValues.paymentsPerYear
		});
		return {
			inputs,
			...baseValues,
			...amortizationValues,
			...cashflowValues,
			...outputValues
		};
	};
}));
//#endregion
//#region src/domains/finance/investment/cashflow/investor-cashflow.model.ts
var init_investor_cashflow_model = __esmMin((() => {}));
//#endregion
//#region src/domains/finance/special-deal/special-deal.model.ts
var init_special_deal_model = __esmMin((() => {}));
//#endregion
//#region src/domains/finance/special-deal/index.ts
var init_special_deal = __esmMin((() => {
	init_special_deal_model();
	init_special_deal_class();
	init_special_deal_base();
}));
//#endregion
//#region src/domains/finance/investment/profitability-calculations/index.ts
var init_profitability_calculations = __esmMin((() => {
	init_profitability_calculations_class();
	init_profitability_calculations_model();
	init_calculations$1();
	init_profitability_calculations_v2();
}));
//#endregion
//#region src/domains/finance/investment/cashflow/investor-cashflow.class.ts
var InvestorCashflow;
var init_investor_cashflow_class = __esmMin((() => {
	init_base();
	init_config_model();
	init_errors();
	init_estates();
	init_document_inspection();
	init_special_deal();
	init_investment_case_class();
	init_prediction_result_class();
	init_profitability_calculations();
	init_calculations();
	InvestorCashflow = class InvestorCashflow extends BaseClassAttributes {
		investorCashflowId;
		type;
		inputs;
		investmentId;
		investment;
		configId;
		config;
		estateId;
		estate;
		salesPackageId;
		salesPackage;
		predictionId;
		prediction;
		debtCapital;
		firstLoanAnnuity;
		secondLoanAnnuity;
		totalYears;
		proportionBuilding;
		maintenanceYear;
		taxCostsTotal;
		agencyCostsTotal;
		propertyRegistrationCostsTotal;
		notaryCostsTotal;
		ancillaryCostsTotal;
		totalInvestmentAmount;
		proprietaryCapital;
		secondLoanResidualDebt;
		residualDebtPerYear;
		interestPerYear;
		amortizationPerYear;
		annuityPerYear;
		ebitdaPerYear;
		discountableEbitdaPerYear;
		ebitdaPerYearMonths;
		discountableEbitdaPerYearMonths;
		depreciationTransactionCostsPerYear;
		depreciationPurchasePricePerYear;
		depreciationKitchenPricePerYear;
		taxResultsPerYear;
		discountableTaxResultsPerYear;
		taxBenefitsPerYear;
		discountableTaxBenefitsPerYear;
		nonTransferableHomeOwnersFeePerYear;
		discountableNonTransferableHomeOwnersFeePerYear;
		propertyManagementCostsPerYear;
		discountablePropertyManagementCostsPerYear;
		maintenancePerYear;
		discountableMaintenancePerYear;
		eatPerYear;
		discountableEatPerYear;
		eatPerYearMonths;
		discountableEatPerYearMonths;
		loanValuta;
		investorProfit;
		returnOnEquity;
		sumMonthlyPaymentsUntilSelling;
		internalRateOfReturn;
		grossRentalReturn;
		automaticSubsidyRate;
		automaticSubsidyAmount;
		repaymentSubsidyMonth;
		baseRepaymentSubsidyPerYear;
		baseRepaymentSubsidyMonth;
		automaticSubsidyCashflow;
		automaticSubsidyEquity;
		tenYearAverageCashflowMonth;
		paymentsPerYear;
		irrPaymentsPerYear;
		taxBenefitsMonth;
		discountableTaxBenefitsMonth;
		interestMonth;
		amortizationMonth;
		maintenanceReserveMonth;
		discountableMaintenanceReserveMonth;
		totalExpensesMonth;
		discountableTotalExpensesMonth;
		totalIncomeMonth;
		cashflowMonth;
		cashflowMonthForAmortizationFromConfig;
		discountableCashflowMonth;
		discountableCashflowMonthForAmortizationFromConfig;
		propertyManagementCostsMonth;
		discountablePropertyManagementCostsMonth;
		sellingPrice;
		googleDocLink;
		constructor(props = {}) {
			super(props);
			Object.assign(this, props);
			if (this.prediction) this.prediction = omit(this.prediction, "investorCashflow");
		}
		recalculate(inputs) {
			if (this.type === "SalesPackage" && !this.salesPackage) throw new InvariantError("Need to have salesPackage present for calculating cashflow when calling recalculate()");
			if (!this.estate || !this.config || !(!!this.investment || !!this.prediction)) throw new InvariantError("Need to have estate, config, (investment or prediction) present for calculating cashflow");
			this.calculateAllValues({
				estate: this.estate,
				investment: this.investment,
				prediction: this.prediction,
				config: this.config,
				salesPackage: this.salesPackage
			}, inputs);
			return this;
		}
		static createFromSalesPackage(opts, baseInputs) {
			if (!opts.salesPackage || !opts.estate || !opts.config || !opts.investment) throw new InvariantError("Need to have salesPackage, estate, config and investment present for calculating cashflow from sales-package");
			const instance = new InvestorCashflow({
				salesPackageId: opts.salesPackage.salesPackageId,
				estateId: opts.estate.estateId,
				configId: opts.config.encodedIdPath,
				investmentId: opts.investment.investmentId,
				type: "SalesPackage",
				investment: opts.investment,
				salesPackage: omit(opts.salesPackage, "investorCashflows"),
				estate: opts.estate,
				config: opts.config
			});
			const houseGeldInputs = instance.getHouseGeldInputsFromEconomicPlanDocumentInspectionIfPresent(opts.estate);
			instance.calculateAllValues(opts, {
				...baseInputs,
				...houseGeldInputs
			});
			return instance;
		}
		static createFromInvestment(opts, baseInputs) {
			if (!opts.estate || !opts.config || !opts.investment) throw new InvariantError("Need to have estate, config and investment present for calculating cashflow from estate-package");
			const instance = new InvestorCashflow({
				estateId: opts.estate.estateId,
				configId: opts.config.encodedIdPath,
				investmentId: opts.investment.investmentId,
				type: "Investment",
				investment: omit(opts.investment, "investorCashflow"),
				estate: opts.estate,
				config: opts.config
			});
			const houseGeldInputs = instance.getHouseGeldInputsFromEconomicPlanDocumentInspectionIfPresent(opts.estate);
			instance.calculateAllValues(opts, {
				...baseInputs,
				...houseGeldInputs
			});
			return instance;
		}
		static createFromPrediction(opts, baseInputs) {
			if (!opts.estate || !opts.config || !opts.prediction) throw new InvariantError("Need to have estate, config and prediction present for calculating cashflow from estate-package");
			const instance = new InvestorCashflow({
				estateId: opts.estate.estateId,
				configId: opts.config.encodedIdPath,
				predictionId: opts.prediction.predictionId,
				type: "Prediction",
				prediction: omit(opts.prediction, "investorCashflow"),
				estate: opts.estate,
				config: opts.config
			});
			const houseGeldInputs = instance.getHouseGeldInputsFromEconomicPlanDocumentInspectionIfPresent(opts.estate);
			instance.calculateAllValues(opts, {
				...baseInputs,
				...houseGeldInputs
			});
			return instance;
		}
		getInputsFromOpts(opts, baseInputs) {
			const { estate, investment, prediction, config } = opts;
			const { useAmortizationPeriodFromConfig, ...overridableBaseInputs } = omit(baseInputs, [
				"amortizationPeriod",
				"amortizationPeriodFromConfig",
				"amortizationRatePurchasePrice"
			]) ?? {};
			const { salesPackage } = opts;
			const predictionOrInvestment = prediction ?? investment;
			if (!predictionOrInvestment) throw new InvariantError(`Did not find a prediction or investment`);
			if (!estate?.location?.state) throw new InvariantError("Unable to get inputs for sales-package as provided estates location has no 'state'-field");
			if (!estate?.attributes?.constructionYear) throw new InvariantError("Estate missing construction year");
			const defaultAssumptions = config?.configRow.CashflowPrediction?.config?.cashflowCalculationValues;
			const defaultAncillaryCosts = config?.configRow.Inputs?.config?.investing?.ancillaryCost;
			if (!defaultAncillaryCosts) throw new InvariantError("Did not find any investing ancillary-costs values in provided config");
			const taxes = defaultAncillaryCosts.taxesByState?.[estate.location.state];
			if (!taxes) throw new InvariantError(`Did not find a values for one of [state-taxes,notary-taxes,registration-taxes] for estate ${estate.estateId} in state ${estate.location.state}`);
			if (!defaultAssumptions) throw new InvariantError("Did not find any cashflow-assumption values in provided config");
			const predictionOrInvestmentInstance = investment ? new InvestmentCase({
				...investment,
				configRecord: investment.configRecord ?? config
			}) : new PredictionResultClass({
				...prediction,
				configRecord: prediction?.configRecord ?? config
			});
			const predictionOrInvestmentHouseGeldNonTransferable = predictionOrInvestmentInstance.nonTransferableMonth;
			const agencyFee = predictionOrInvestment.agencyFee ?? predictionOrInvestment.agencyFeeInput;
			const homeOwnersFeeNonTransferableMonth = estate.price?.houseGeldNonTransferable ?? predictionOrInvestmentHouseGeldNonTransferable;
			const calcInputs = config?.configRow["Inputs"]?.config;
			const houseGeld = predictionOrInvestmentInstance.houseGeld ?? calculateHouseGeld({
				livingSpace: estate.attributes.livingSpace,
				inputs: calcInputs
			});
			const maintenanceMonth = estate.price?.houseGeldReserve ?? calculateHouseGeldReserve({
				houseGeld,
				houseGeldTransferable: predictionOrInvestmentInstance.transferable ?? calculateHouseGeldTransferable({
					houseGeld,
					inputs: calcInputs
				}),
				houseGeldNonTransferable: predictionOrInvestmentHouseGeldNonTransferable ?? calculateHouseGeldNonTransferable({
					houseGeld,
					inputs: calcInputs
				})
			});
			const propertyManagementMonthlyCosts = defaultAssumptions.propertyManagementMonthlyCosts;
			const notaryCostsRate = defaultAncillaryCosts.notaryCost;
			const propertyRegistrationRate = defaultAncillaryCosts.propertyRegistration;
			const taxRate = taxes;
			const amortizationPeriodFromConfig = calculateAmortizationPeriod({ constructionYear: estate.attributes.constructionYear }, defaultAssumptions);
			const amortizationPeriodFromAttributeOrConfig = calculateAmortizationPeriod(estate.attributes, defaultAssumptions);
			const amortizationPeriodInput = useAmortizationPeriodFromConfig ? amortizationPeriodFromConfig : amortizationPeriodFromAttributeOrConfig;
			const specialDealInputOverrides = this.type === "SalesPackage" && estate.specialDeal ? new SpecialDeal(estate.specialDeal).getInvestorCashflowInputOverrides(estate) : {};
			const valueProportionLand = getValueProportionLand(estate.attributes, ["Investment", "Prediction"].includes(this.type) ? predictionOrInvestment : estate.executedSellingInvestmentCase);
			const kitchenApprovedPlan = estate.constructionPlans?.find((plan) => plan.planType === "Kitchen" && plan.state === "Approved" && plan.active === true);
			const kitchenPrice = kitchenApprovedPlan?.totalActualCosts ? kitchenApprovedPlan.totalActualCosts : defaultAssumptions.defaultKitchenPrice ?? 0;
			const proportionPlot = valueProportionLand ? Math.min(valueProportionLand, defaultAssumptions.proportionPlot) : defaultAssumptions.proportionPlot;
			const inputs = {
				agencyFeeRate: agencyFee > 0 && agencyFee <= 1 ? agencyFee : void 0,
				agencyFeeTotal: agencyFee > 1 ? agencyFee : agencyFee === 0 ? 0 : void 0,
				amortizationPeriod: amortizationPeriodInput,
				amortizationPeriodFromConfig,
				amortizationRatePurchasePrice: calculateAmortizationRatePurchasePrice(amortizationPeriodInput),
				appreciationValuePercent: defaultAssumptions.appreciationValuePercent,
				firstLoanAmortizationRate: salesPackage?.firstLoanAmortizationRate ?? defaultAssumptions.firstLoanAmortizationRate,
				firstLoanInterestRate: salesPackage?.firstLoanInterestRate ?? defaultAssumptions.firstLoanInterestRate,
				firstLoanPeriod: defaultAssumptions.firstLoanPeriod,
				homeOwnersFeeMonth: predictionOrInvestment.houseGeld ?? 0,
				homeOwnersFeeNonTransferableMonth,
				incomePerMonth: predictionOrInvestment.yearRentalIncome ? predictionOrInvestment.yearRentalIncome / 12 : 0,
				incomeTaxRate: defaultAssumptions.incomeTaxRate,
				inflationRate: defaultAssumptions.inflationRate,
				irrStartYear: dayjs().get("year"),
				maintenanceMonth,
				notaryCostsRate,
				parkingIncomePerMonth: predictionOrInvestment.yearParkingLotIncome ? predictionOrInvestment.yearParkingLotIncome / 12 : 0,
				propertyManagementMonthlyCosts,
				propertyRegistrationRate,
				propertySoldAfterYears: defaultAssumptions.propertySoldAfterYears,
				proportionPlot,
				proportionPlotTakenFromEstate: proportionPlot === valueProportionLand,
				proprietaryCapitalPercent: defaultAssumptions.proprietaryCapitalPercent,
				secondLoanAmortizationRate: salesPackage?.secondLoanAmortizationRate ?? defaultAssumptions.secondLoanAmortizationRate,
				secondLoanInterestRate: salesPackage?.secondLoanInterestRate ?? defaultAssumptions.secondLoanInterestRate,
				secondLoanPeriod: defaultAssumptions.secondLoanPeriod,
				taxRate,
				totalPurchasePrice: predictionOrInvestment.expectedSalesPrice,
				amortizationPeriodKitchen: defaultAssumptions.amortizationPeriodKitchen ?? 0,
				kitchenPrice,
				automaticSubsidyAdditionalRate: defaultAssumptions.automaticSubsidyAdditionalRate,
				...overridableBaseInputs ?? {}
			};
			const discountableFallbacks = {
				discountableHomeOwnersFeeNonTransferableMonth: inputs.homeOwnersFeeNonTransferableMonth,
				discountableMaintenanceMonth: inputs.maintenanceMonth,
				discountableNotaryCostsRate: inputs.notaryCostsRate,
				discountablePropertyManagementMonthlyCosts: inputs.propertyManagementMonthlyCosts,
				discountablePropertyRegistrationRate: inputs.propertyRegistrationRate,
				discountableTaxRate: inputs.taxRate
			};
			return {
				...inputs,
				...discountableFallbacks,
				...specialDealInputOverrides
			};
		}
		get changeableInputFields() {
			return [
				"firstLoanPeriod",
				"firstLoanInterestRate",
				"firstLoanAmortizationRate",
				"secondLoanPeriod",
				"secondLoanInterestRate",
				"secondLoanAmortizationRate",
				"incomeTaxRate"
			];
		}
		get inputFields() {
			return pick(this.inputs, this.changeableInputFields);
		}
		get isDiscountable() {
			const { propertyManagementMonthlyCosts, discountablePropertyManagementMonthlyCosts, notaryCostsRate, discountableNotaryCostsRate, propertyRegistrationRate, discountablePropertyRegistrationRate, taxRate, discountableTaxRate, homeOwnersFeeNonTransferableMonth, discountableHomeOwnersFeeNonTransferableMonth, maintenanceMonth, discountableMaintenanceMonth } = this.inputs;
			return !isNil(discountablePropertyManagementMonthlyCosts) && discountablePropertyManagementMonthlyCosts !== propertyManagementMonthlyCosts || !isNil(discountableNotaryCostsRate) && discountableNotaryCostsRate !== notaryCostsRate || !isNil(discountablePropertyRegistrationRate) && discountablePropertyRegistrationRate !== propertyRegistrationRate || !isNil(discountableTaxRate) && discountableTaxRate !== taxRate || !isNil(discountableHomeOwnersFeeNonTransferableMonth) && discountableHomeOwnersFeeNonTransferableMonth !== homeOwnersFeeNonTransferableMonth || !isNil(discountableMaintenanceMonth) && discountableMaintenanceMonth !== maintenanceMonth;
		}
		getAutomaticSubsidyDetailsStr() {
			if (!this.automaticSubsidyAmount || !this.automaticSubsidyRate) return "";
			const automaticSubsidyRate = this.automaticSubsidyRate;
			const automaticSubsidyAmount = this.automaticSubsidyAmount;
			const automaticSubsidyEquity = this.automaticSubsidyEquity;
			const automaticSubsidyEquityPercent = this.inputs.automaticSubsidyEquityPercentOrEuro <= 1 ? this.inputs.automaticSubsidyEquityPercentOrEuro : automaticSubsidyEquity / automaticSubsidyAmount;
			const automaticSubsidyCashflow = this.automaticSubsidyCashflow;
			const automaticSubsidyCashflowPercent = 1 - automaticSubsidyEquityPercent;
			const automaticSubsidyDiscountPeriodMonths = this.inputs.automaticSubsidyDiscountPeriod * 12;
			const automaticSubsidyCashflowMonth = automaticSubsidyCashflow / 12;
			return `Sonderaktion: Die Berechnungen berücksichtigen einen Zuschuss in Höhe von ${percent(automaticSubsidyRate)} (${currency(automaticSubsidyAmount)}) des Kaufpreises. Dieser Zuschuss teilt sich auf in ${currency(automaticSubsidyEquity)} (${percent(automaticSubsidyEquityPercent)}) als einmaligen Zuschuss und ${currency(automaticSubsidyCashflow)} (${percent(automaticSubsidyCashflowPercent)}) als monatlichen Zuschuss. Der monatliche Zuschuss wird über ${automaticSubsidyDiscountPeriodMonths} Monate verteilt und beträgt monatlich ${currency(automaticSubsidyCashflowMonth)}.`;
		}
		getAutomaticSubsidyDistributionStr(baseInputs = {}) {
			const automaticSubsidyEquityPercentOrEuro = baseInputs.automaticSubsidyEquityPercentOrEuro ?? this.inputs.automaticSubsidyEquityPercentOrEuro;
			const automaticSubsidyDiscountPeriod = baseInputs.automaticSubsidyDiscountPeriod ?? this.inputs.automaticSubsidyDiscountPeriod;
			if (isNil(automaticSubsidyEquityPercentOrEuro) || !automaticSubsidyDiscountPeriod) return "";
			const { automaticSubsidyRate, automaticSubsidyAmount, automaticSubsidyCashflow = 0, automaticSubsidyEquity } = calculateAutomaticSubsidy({
				automaticSubsidyEquityPercentOrEuro,
				automaticSubsidyDiscountPeriod,
				totalPurchasePrice: this.inputs.totalPurchasePrice,
				automaticSubsidyAdditionalRate: baseInputs.automaticSubsidyAdditionalRate ?? this.inputs.automaticSubsidyAdditionalRate
			});
			return `Zuschussrate: ${percent(automaticSubsidyRate)} | Zuschuss: ${currency(automaticSubsidyAmount)} | Monatlich: ${currency(automaticSubsidyCashflow / 12)} | Einmalig: ${currency(automaticSubsidyEquity)}`;
		}
		calculateAllValues(opts, baseInputs) {
			Object.assign(this, {
				estate: opts.estate,
				salesPackage: opts.salesPackage,
				investment: opts.investment,
				config: opts.config
			});
			const calculatedValues = calculateAllCashflowValues(this.getInputsFromOpts(opts, baseInputs));
			this.assertNumericValues(calculatedValues);
			Object.assign(this, calculatedValues);
			this.setCashflowForAmortizationFromConfig(opts, baseInputs);
			return calculatedValues;
		}
		setCashflowForAmortizationFromConfig(opts, baseInputs) {
			if (this.type === "SalesPackage" && !this.salesPackage) throw new InvariantError("Need to have salesPackage present for calculating cashflow when calling recalculate()");
			if (!this.estate || !this.config || !(this.investment || this.prediction)) throw new InvariantError("Need to have estate, config, (investment or prediction) present for calculating cashflow");
			if (!this.estate?.attributes?.constructionYear) throw new InvariantError("Estate missing construction year");
			const inputs = this.getInputsFromOpts(opts, {
				...baseInputs,
				useAmortizationPeriodFromConfig: true
			});
			const calculatedValues = calculateAllCashflowValues(inputs);
			this.cashflowMonthForAmortizationFromConfig = calculatedValues.cashflowMonth;
			this.discountableCashflowMonthForAmortizationFromConfig = calculatedValues.discountableCashflowMonth;
			this.inputs.amortizationPeriodFromConfig = inputs.amortizationPeriod;
		}
		assertNumericValues(calculatedValues) {
			const getNanValues = (vals) => Object.entries(vals).reduce((acc, [k, v]) => {
				if (isPlainObject(v)) {
					const nestedNanValues = getNanValues(v);
					return Object.keys(nestedNanValues).length ? {
						...acc,
						[k]: nestedNanValues
					} : acc;
				}
				if (Number.isNaN(v)) return {
					...acc,
					[k]: v
				};
				return acc;
			}, {});
			const nanValues = getNanValues(calculatedValues);
			const nanKeys = Object.keys(nanValues);
			if (nanKeys.length) throw new InvariantError(`Some values were not calculated, please verify ${nanKeys.join(",")} and all inputs (investment, estate, config and sales-package)`);
		}
		getHouseGeldInputsFromEconomicPlanDocumentInspectionIfPresent(estate) {
			const futureHouseGeldInputs = getFutureHouseGeldValuesFromEconomicPlanDocumentInspectionIfApplicable(estate);
			return futureHouseGeldInputs ? {
				homeOwnersFeeMonth: futureHouseGeldInputs.futureHouseGeld,
				homeOwnersFeeNonTransferableMonth: futureHouseGeldInputs.futureHouseGeldNonTransferable
			} : {};
		}
	};
}));
//#endregion
//#region src/domains/finance/investment/cashflow/index.ts
var init_cashflow = __esmMin((() => {
	init_calculations();
	init_investor_cashflow_model();
	init_investor_cashflow_class();
	init_investor_cashflow_model();
	init_investor_cashflow_base();
}));
//#endregion
//#region src/domains/finance/investment/helpers.ts
var ASBESTOS_RANGES, PREFABRICATED_RANGES, PREFABRICATED_FLOORS, isAsbestos, isPrefabricated;
var init_helpers$1 = __esmMin((() => {
	ASBESTOS_RANGES = {
		FROM: 1961,
		TO: 1974
	};
	PREFABRICATED_RANGES = {
		FROM: 1959,
		TO: 1991
	};
	PREFABRICATED_FLOORS = 4;
	isAsbestos = (attributes) => {
		return attributes?.constructionYear && attributes.constructionYear > ASBESTOS_RANGES.FROM && attributes.constructionYear < ASBESTOS_RANGES.TO;
	};
	isPrefabricated = (attributes) => {
		return attributes?.constructionYear && attributes.constructionYear > PREFABRICATED_RANGES.FROM && attributes.constructionYear < PREFABRICATED_RANGES.TO && (attributes.numberOfFloors ?? 0) > PREFABRICATED_FLOORS;
	};
}));
//#endregion
//#region src/domains/finance/investment/investment-case.opts.ts
var init_investment_case_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/finance/investment/prediction-result.model.ts
var init_prediction_result_model = __esmMin((() => {}));
//#endregion
//#region src/domains/finance/investment/prediction-result.opts.ts
var init_prediction_result_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/finance/investment/index.ts
var init_investment = __esmMin((() => {
	init_cashflow();
	init_helpers$1();
	init_investment_case_class();
	init_investment_case_model();
	init_investment_case_opts();
	init_prediction_result_class();
	init_prediction_result_model();
	init_prediction_result_opts();
	init_profitability_calculations();
}));
//#endregion
//#region src/domains/finance/controlling-view/invoices-based-controlling-view-column.class.ts
var InvoicesBasedControllingViewColumn;
var init_invoices_based_controlling_view_column_class = __esmMin((() => {
	init_processes();
	init_selling_model();
	init_investment();
	init_invoice();
	init_base_controlling_view_column_class();
	InvoicesBasedControllingViewColumn = class extends BaseControllingViewColumn {
		constructor({ paidInvoices, purchasingProcess, sellingProcess, purchasingCase, sellingCase, calculationsInputs, rentableUnits, estateAttributes }) {
			super();
			paidInvoices.forEach((invoice) => {
				const invoiceObject = new Invoice(invoice);
				if (invoiceObject.payoutAmount) switch (invoiceObject.costType) {
					case "Notary":
						this.notaryCost += invoiceObject.payoutAmount;
						break;
					case "LandTransferTaxes":
						this.taxes += invoiceObject.payoutAmount;
						break;
					case "PropertyRegistration":
						this.propertyRegistration += invoiceObject.payoutAmount;
						break;
					case "AgencyFee":
						this.agencyFee += invoiceObject.payoutAmount;
						break;
					case "ReferralFee":
						this.referralFee += invoiceObject.payoutAmount;
						break;
					case "GeneralRenovationCost":
						this.generalRenovationCost += invoiceObject.payoutAmount;
						break;
					case "KitchenCost":
						this.kitchenCost += invoiceObject.payoutAmount;
						break;
					case "OtherRenovationCost":
						this.otherRenovationCost += invoiceObject.payoutAmount;
						break;
					case "HomeOwnersFee":
						this.homeOwnersFee += invoiceObject.payoutAmount;
						break;
					case "Utilities":
						this.utilities += invoiceObject.payoutAmount;
						break;
					case "AgencyFeeSelling":
						this.sellingCost += invoiceObject.payoutAmount;
						break;
					case "HomeSpecialFee":
						this.extraCosts += invoiceObject.payoutAmount;
						break;
					default:
				}
			});
			if (sellingProcess && SellingPaidStates.includes(sellingProcess.processState.state) && sellingCase?.expectedSalesPrice) this.expectedSalesPrice = sellingCase.expectedSalesPrice;
			if ([
				"Paid",
				"HandoverDone",
				"Completed"
			].includes(purchasingProcess.processState.state)) this.purchasePrice = (purchasingCase?.listedPricePurchasingPrice ?? 0) + (purchasingCase?.parkingSpacePurchasePrice ?? 0);
			const timeOnBooks = calculateTimeOnBooks(purchasingProcess, sellingProcess);
			/**
			* The logic below partially duplicates logic from places below:
			*  -
			*/
			if (timeOnBooks && calculationsInputs && (sellingCase || purchasingCase)) {
				const sourceInvestmentCase = sellingCase || purchasingCase;
				const totalPrice = safeSum(sourceInvestmentCase.purchasingPrice, sourceInvestmentCase.parkingSpacePurchasePrice, sourceInvestmentCase.otherCosts, sourceInvestmentCase.auxiliaryCosts);
				const renovationCosts = safeSum(safeSum(sourceInvestmentCase.generalRenovationCosts, sourceInvestmentCase.kitchenCost, sourceInvestmentCase.toiletPrice, sourceInvestmentCase.guestToiletPrice, sourceInvestmentCase.roomsChangePrice), sourceInvestmentCase.specialRenovationCostsSum, sourceInvestmentCase.renovationCostAdjustments, sourceInvestmentCase.renovationExtraCost);
				this.financingCostJunior = financingCostJuniorDebtDaily(calculationsInputs, totalPrice, renovationCosts, timeOnBooks);
				this.financingCostSenior = financingCostSeniorDaily(calculationsInputs, totalPrice, renovationCosts, timeOnBooks);
				if (sellingCase) this.laborCost = sellingCase.totalLaborCosts;
			}
			if (rentableUnits?.length) {
				const sumRent = (init_investor_info_class(), __toCommonJS(investor_info_class_exports)).InvestorInfo.getSumOfActiveRents(rentableUnits);
				if (sumRent > 0) {
					this.parkingRent = sellingCase?.parkingSpacePrice ?? 0;
					this.estateRent = sumRent - (this.parkingRent ?? 0);
					if (estateAttributes) this.rentPerSqm = round$1(this.estateRent / estateAttributes.livingSpace, 2);
				}
			}
		}
	};
}));
//#endregion
//#region src/domains/finance/controlling-view/investment-based-controlling-view-column.class.ts
var InvestmentBasedControllingViewColumn;
var init_investment_based_controlling_view_column_class = __esmMin((() => {
	init_investment();
	init_base_controlling_view_column_class();
	InvestmentBasedControllingViewColumn = class extends BaseControllingViewColumn {
		constructor(investmentCase) {
			super();
			const entityObject = new InvestmentCase(investmentCase);
			this.id = entityObject.investmentId;
			this.createdAt = entityObject.createdAt;
			if (investmentCase.updatedAt) this.updatedAt = investmentCase.updatedAt;
			if (investmentCase.reviewProcess?.updatedAt) this.approvedAt = investmentCase.reviewProcess.updatedAt;
			this.rentPerSqm = entityObject.coldRentPerSquareMeter ?? 0;
			this.estateRent = entityObject.rentalIncome ?? 0;
			this.parkingRent = entityObject.rentalParkingLotIncomeMonth ?? 0;
			this.expectedSalesPrice = entityObject.expectedSalesPrice ?? 0;
			this.otherIncome = (entityObject.rentalIncomeDuringHold ?? 0) + (entityObject.serviceCharge ?? 0);
			this.purchasePrice = (entityObject.listedPricePurchasingPrice ?? 0) + (entityObject.parkingSpacePurchasePrice ?? 0);
			this.notaryCost = entityObject.notaryCost ?? 0;
			this.taxes = entityObject.taxes ?? 0;
			this.propertyRegistration = entityObject.propertyRegistration ?? 0;
			this.agencyFee = entityObject.agencyFee ?? 0;
			this.referralFee = entityObject.referralFee ?? 0;
			this.generalRenovationCost = (entityObject.generalRenovationCosts ?? 0) + (entityObject.toiletPrice ?? 0) + (entityObject.renovationCostAdjustments ?? 0);
			this.kitchenCost = entityObject.kitchenCost ?? 0;
			this.otherRenovationCost = (entityObject.toiletPrice ?? 0) + (entityObject.guestToiletPrice ?? 0) + (entityObject.roomsChangePrice ?? 0) + (entityObject.specialRenovationCostsSum ?? 0) + (entityObject.renovationExtraCost ?? 0);
			this.homeOwnersFee = entityObject.totalAdditionalCost ?? 0;
			this.measurements = entityObject.ifcScanCosts ?? 0;
			this.utilities = entityObject.utilities ?? 0;
			this.sellingCost = (entityObject.sellingCosts ?? 0) + (entityObject.takingPictures ?? 0);
			this.propertyRelatedCost = entityObject.propertyRelatedCosts ?? 0;
			this.specialAgreements = entityObject.specialAgreementsAddition ?? 0;
			this.bonus = entityObject.bonusAddition ?? 0;
			this.pmIncentive = entityObject.pmIncentiveAddition ?? 0;
			this.laborCost = entityObject.totalLaborCosts ?? 0;
			this.financingCostSenior = entityObject.financingCostsSeniorDebt ?? 0;
			this.financingCostJunior = entityObject.financingCostsJuniorDebt ?? 0;
		}
	};
}));
//#endregion
//#region src/domains/finance/controlling-view/prediction-based-controlling-view-column.class.ts
var PredictionBasedControllingViewColumn;
var init_prediction_based_controlling_view_column_class = __esmMin((() => {
	init_investment();
	init_base_controlling_view_column_class();
	PredictionBasedControllingViewColumn = class extends BaseControllingViewColumn {
		constructor(prediction) {
			super();
			const entityObject = new PredictionResultClass(prediction);
			this.id = entityObject.predictionId;
			this.createdAt = entityObject.createdAt ?? "";
			this.rentPerSqm = entityObject.coldRentPerSquareMeter ?? 0;
			this.estateRent = entityObject.rentalIncome ?? 0;
			this.parkingRent = entityObject.rentalParkingLotIncomeMonth ?? 0;
			this.expectedSalesPrice = entityObject.expectedSalesPrice ?? 0;
			this.otherIncome = (entityObject.rentalIncomeDuringHold ?? 0) + (entityObject.serviceCharge ?? 0);
			this.purchasePrice = (entityObject.listedPricePurchasingPrice ?? 0) + (entityObject.parkingSpacePurchasePrice ?? 0);
			this.notaryCost = entityObject.notaryCost ?? 0;
			this.taxes = entityObject.taxes ?? 0;
			this.propertyRegistration = entityObject.propertyRegistration ?? 0;
			this.agencyFee = entityObject.agencyFee ?? 0;
			this.referralFee = entityObject.referralFee ?? 0;
			this.generalRenovationCost = (entityObject.generalRenovationCosts ?? 0) + (entityObject.toiletPrice ?? 0) + (entityObject.renovationCostAdjustments ?? 0);
			this.kitchenCost = entityObject.kitchenCost ?? 0;
			this.otherRenovationCost = (entityObject.guestToiletPrice ?? 0) + (entityObject.roomsChangePrice ?? 0);
			this.homeOwnersFee = entityObject.totalAdditionalCost ?? 0;
			this.measurements = entityObject.ifcScanCosts ?? 0;
			this.utilities = entityObject.utilities ?? 0;
			this.sellingCost = (entityObject.sellingCosts ?? 0) + (entityObject.takingPictures ?? 0);
			this.propertyRelatedCost = entityObject.propertyRelatedCosts ?? 0;
			this.specialAgreements = entityObject.specialAgreementsAddition ?? 0;
			this.bonus = entityObject.bonusAddition ?? 0;
			this.pmIncentive = entityObject.pmIncentiveAddition ?? 0;
			this.laborCost = entityObject.totalLaborCosts ?? 0;
			this.financingCostSenior = entityObject.financingCostsSeniorDebt ?? 0;
			this.financingCostJunior = entityObject.financingCostsJuniorDebt ?? 0;
		}
	};
}));
//#endregion
//#region src/domains/finance/controlling-view/remaining-controlling-view-column.class.ts
var RemainingControllingViewColumn;
var init_remaining_controlling_view_column_class = __esmMin((() => {
	RemainingControllingViewColumn = class {
		prediction;
		purchasing;
		selling;
		actuals;
		id;
		createdAt;
		updatedAt;
		approvedAt;
		rentPerSqm;
		estateRent;
		parkingRent;
		expectedSalesPrice;
		otherIncome;
		purchasePrice;
		notaryCost;
		taxes;
		propertyRegistration;
		agencyFee;
		referralFee;
		otherAncillaryCost;
		generalRenovationCost;
		kitchenCost;
		otherRenovationCost;
		homeOwnersFee;
		measurements;
		extraCosts;
		utilities;
		sellingCost;
		otherSellingCost;
		propertyRelatedCost;
		specialAgreements;
		bonus;
		pmIncentive;
		laborCost;
		financingCostSenior;
		financingCostJunior;
		expenses;
		income;
		transactionCost;
		renovationCost;
		otherCost;
		distributionAndMarketingCost;
		operatingCost;
		operationalCost;
		operationalReturn;
		contributionMargin1;
		netContributionCost;
		netContributionMargin;
		contributionMargin15;
		totalCost;
		totalReturn;
		contributionMargin2;
		constructor(prediction, purchasing, selling, actuals) {
			this.prediction = prediction;
			this.purchasing = purchasing;
			this.selling = selling;
			this.actuals = actuals;
		}
		toJSON() {
			return {
				rentPerSqm: this.getRemainingValue("rentPerSqm"),
				estateRent: this.getRemainingValue("estateRent"),
				parkingRent: this.getRemainingValue("parkingRent"),
				expectedSalesPrice: this.getRemainingValue("expectedSalesPrice"),
				otherIncome: this.getRemainingValue("otherIncome"),
				purchasePrice: this.getRemainingValue("purchasePrice"),
				notaryCost: this.getRemainingValue("notaryCost"),
				taxes: this.getRemainingValue("taxes"),
				propertyRegistration: this.getRemainingValue("propertyRegistration"),
				agencyFee: this.getRemainingValue("agencyFee"),
				referralFee: this.getRemainingValue("referralFee"),
				otherAncillaryCost: this.getRemainingValue("otherAncillaryCost"),
				generalRenovationCost: this.getRemainingValue("generalRenovationCost"),
				kitchenCost: this.getRemainingValue("kitchenCost"),
				otherRenovationCost: this.getRemainingValue("otherRenovationCost"),
				homeOwnersFee: this.getRemainingValue("homeOwnersFee"),
				measurements: this.getRemainingValue("measurements"),
				extraCosts: this.getRemainingValue("extraCosts"),
				utilities: this.getRemainingValue("utilities"),
				sellingCost: this.getRemainingValue("sellingCost"),
				otherSellingCost: this.getRemainingValue("otherSellingCost"),
				propertyRelatedCost: this.getRemainingValue("propertyRelatedCost"),
				specialAgreements: this.getRemainingValue("specialAgreements"),
				bonus: this.getRemainingValue("bonus"),
				pmIncentive: this.getRemainingValue("pmIncentive"),
				laborCost: this.getRemainingValue("laborCost"),
				financingCostSenior: this.getRemainingValue("financingCostSenior"),
				financingCostJunior: this.getRemainingValue("financingCostJunior"),
				expenses: this.getRemainingValue("expenses"),
				income: this.getRemainingValue("income"),
				transactionCost: this.getRemainingValue("transactionCost"),
				renovationCost: this.getRemainingValue("renovationCost"),
				otherCost: this.getRemainingValue("otherCost"),
				distributionAndMarketingCost: this.getRemainingValue("distributionAndMarketingCost"),
				operatingCost: this.getRemainingValue("operatingCost"),
				operationalCost: this.getRemainingValue("operationalCost"),
				operationalReturn: this.getRemainingValue("operationalReturn"),
				contributionMargin1: this.getRemainingValue("contributionMargin1"),
				netContributionCost: this.getRemainingValue("netContributionCost"),
				netContributionMargin: this.getRemainingValue("netContributionMargin"),
				contributionMargin15: this.getRemainingValue("contributionMargin15"),
				totalCost: this.getRemainingValue("totalCost"),
				totalReturn: this.getRemainingValue("totalReturn"),
				contributionMargin2: this.getRemainingValue("contributionMargin2")
			};
		}
		getRemainingValue(field) {
			const actual = this.actuals?.[field] ?? 0;
			if (this.selling) return (this.selling[field] ?? 0) - actual;
			if (this.purchasing) return (this.purchasing[field] ?? 0) - actual;
			return (this.prediction[field] ?? 0) - actual;
		}
	};
}));
//#endregion
//#region src/domains/finance/controlling-view/index.ts
var init_controlling_view = __esmMin((() => {
	init_controlling_view_column_model();
	init_base_controlling_view_column_class();
	init_invoices_based_controlling_view_column_class();
	init_investment_based_controlling_view_column_class();
	init_prediction_based_controlling_view_column_class();
	init_remaining_controlling_view_column_class();
}));
//#endregion
//#region src/domains/finance/credit-line-portfolio/credit-line-portfolio.model.ts
var init_credit_line_portfolio_model = __esmMin((() => {}));
//#endregion
//#region src/domains/finance/credit-line-portfolio/index.ts
var init_credit_line_portfolio = __esmMin((() => {
	init_credit_line_portfolio_model();
}));
//#endregion
//#region src/domains/finance/iban-data.model.ts
var init_iban_data_model = __esmMin((() => {}));
//#endregion
//#region src/domains/finance/loan-account.model.ts
var LoanAccountType, LoanAccountState, InterestRateMode, CommitmentRateMode, InterestCalculationMode, InterestCalculationBasis, LoanAllocationStructureType, LoanRepaymentType, RepaymentPeriod, Euribor;
var init_loan_account_model = __esmMin((() => {
	LoanAccountType = /* @__PURE__ */ function(LoanAccountType) {
		LoanAccountType["PortfolioLoan"] = "PortfolioLoan";
		LoanAccountType["Mezzanine"] = "Mezzanine";
		LoanAccountType["IntergroupLoan"] = "IntergroupLoan";
		return LoanAccountType;
	}({});
	LoanAccountState = /* @__PURE__ */ function(LoanAccountState) {
		LoanAccountState["Open"] = "Open";
		LoanAccountState["Closed"] = "Closed";
		return LoanAccountState;
	}({});
	InterestRateMode = /* @__PURE__ */ function(InterestRateMode) {
		InterestRateMode["Year360"] = "Year360";
		InterestRateMode["Year365"] = "Year365";
		return InterestRateMode;
	}({});
	CommitmentRateMode = /* @__PURE__ */ function(CommitmentRateMode) {
		CommitmentRateMode["UnusedCapital"] = "UnusedCapital";
		CommitmentRateMode["TotalCapital"] = "TotalCapital";
		return CommitmentRateMode;
	}({});
	InterestCalculationMode = /* @__PURE__ */ function(InterestCalculationMode) {
		InterestCalculationMode["Normal"] = "Normal";
		InterestCalculationMode["Cumulative"] = "Cumulative";
		return InterestCalculationMode;
	}({});
	InterestCalculationBasis = /* @__PURE__ */ function(InterestCalculationBasis) {
		InterestCalculationBasis["Outstanding"] = "Outstanding";
		InterestCalculationBasis["Average"] = "Average";
		return InterestCalculationBasis;
	}({});
	LoanAllocationStructureType = /* @__PURE__ */ function(LoanAllocationStructureType) {
		LoanAllocationStructureType["Loan"] = "Loan";
		LoanAllocationStructureType["Estate"] = "Estate";
		return LoanAllocationStructureType;
	}({});
	LoanRepaymentType = /* @__PURE__ */ function(LoanRepaymentType) {
		LoanRepaymentType["Estate"] = "Estate";
		LoanRepaymentType["Intermediate"] = "Intermediate";
		LoanRepaymentType["Complete"] = "Complete";
		return LoanRepaymentType;
	}({});
	RepaymentPeriod = /* @__PURE__ */ function(RepaymentPeriod) {
		RepaymentPeriod["Monthly"] = "Monthly";
		RepaymentPeriod["BiMonthly"] = "BiMonthly";
		RepaymentPeriod["Quarterly"] = "Quarterly";
		RepaymentPeriod["EndDate"] = "EndDate";
		return RepaymentPeriod;
	}({});
	Euribor = /* @__PURE__ */ function(Euribor) {
		Euribor["Month3"] = "Month3";
		Euribor["Month6"] = "Month6";
		Euribor["Month12"] = "Month12";
		return Euribor;
	}({});
}));
//#endregion
//#region src/domains/finance/portfolio/interfaces.ts
var init_interfaces = __esmMin((() => {}));
//#endregion
//#region src/domains/finance/portfolio/loan-drawdown.class.ts
var LoanDrawdownStatus, LoanDrawdownType, drawdownDeleteStatuses, badStatuses, purchasingDrawdownDocuments, editStatuses, LoanDrawdown;
var init_loan_drawdown_class = __esmMin((() => {
	init_base();
	init_document();
	init_invoice();
	LoanDrawdownStatus = /* @__PURE__ */ function(LoanDrawdownStatus) {
		LoanDrawdownStatus["Draft"] = "Draft";
		/**
		* Bank Transaction
		* @type {LoanDrawdownStatus.Requested}
		*/
		LoanDrawdownStatus["Requested"] = "Requested";
		/**
		* Amount received matched amount requested
		* @type {LoanDrawdownStatus.Received}
		*/
		LoanDrawdownStatus["Received"] = "Received";
		/**
		* Money received but not in full. Could be fine if bank used part of the junior debt
		* @type {LoanDrawdownStatus.PartiallyReceived}
		*/
		LoanDrawdownStatus["PartiallyReceived"] = "PartiallyReceived";
		/**
		* Bank refused to send drawdown money
		* @type {LoanDrawdownStatus.Rejected}
		*/
		LoanDrawdownStatus["Rejected"] = "Rejected";
		/**
		* Cancelled by Condo Group
		* @type {LoanDrawdownStatus.Cancelled}
		*/
		LoanDrawdownStatus["Cancelled"] = "Cancelled";
		return LoanDrawdownStatus;
	}({});
	LoanDrawdownType = /* @__PURE__ */ function(LoanDrawdownType) {
		LoanDrawdownType["PurchasingPrice"] = "PurchasingPrice";
		LoanDrawdownType["Invoices"] = "Invoices";
		LoanDrawdownType["JuniorDebt"] = "JuniorDebt";
		LoanDrawdownType["Intergroup"] = "Intergroup";
		return LoanDrawdownType;
	}({});
	drawdownDeleteStatuses = [
		"Draft",
		"Rejected",
		"Cancelled",
		"Requested"
	];
	badStatuses = ["Cancelled", "Rejected"];
	purchasingDrawdownDocuments = ["ContractNotarized", "PaymentNotice"];
	editStatuses = ["Draft", "Cancelled"];
	LoanDrawdown = class extends BaseClassAttributes {
		loanDrawdownId;
		portfolioId;
		loanAccountId;
		estateId;
		receivedAmount = 0;
		expectedAmount;
		transactionReference;
		drawdownStatus = "Draft";
		userId;
		message;
		gDriveFolderId;
		drawdownAmount;
		shortUuid;
		drawdownType;
		invoices = [];
		loan;
		portfolio;
		constructor(props) {
			super(props);
			Object.assign(this, props);
			if (props.invoices?.length) this.invoices = props.invoices.map((invoice) => new Invoice(invoice));
		}
		get isUpdateAvailable() {
			return editStatuses.includes(this.drawdownStatus);
		}
		get isInvoice() {
			return this.drawdownType === "Invoices";
		}
		get isPurchasingPrice() {
			return this.drawdownType === "PurchasingPrice";
		}
		get isIntergroup() {
			return this.drawdownType === "Intergroup";
		}
		get isJuniorDebt() {
			return this.drawdownType === "JuniorDebt";
		}
		get invoicesNumber() {
			return this.invoices.length;
		}
		get invoicesIds() {
			return this.invoices.map((i) => i.invoiceId);
		}
		get isRequested() {
			return this.drawdownStatus === "Requested";
		}
		get isPartiallyReceived() {
			return this.drawdownStatus === "PartiallyReceived";
		}
		get isAvailableForSend() {
			return !badStatuses.includes(this.drawdownStatus) && !this.isPurchasingPrice && this.drawdownStatus === "Draft";
		}
		get isReceived() {
			return this.drawdownStatus === "Received" || this.drawdownStatus === "PartiallyReceived";
		}
		get isPossibleToDelete() {
			return drawdownDeleteStatuses.includes(this.drawdownStatus);
		}
		get isNotReceivedInFull() {
			return this.drawdownAmount !== this.receivedAmount;
		}
		static isInvoiceEligible(invoice, loanDrawdownId) {
			return invoice.isReadyForDrawdown && (!invoice.loanDrawdownId || invoice.loanDrawdownId === loanDrawdownId) && !invoice.isReimbursed;
		}
		static getInvoiceFileName(invoice, document) {
			return `I${invoice.invoiceId}_E${invoice.estateId}_D${document.documentId}`;
		}
		addReceivedAmount(amount) {
			this.receivedAmount += amount;
			this.drawdownStatus = this.isNotReceivedInFull ? "PartiallyReceived" : "Received";
		}
		generateUuid(loanAccount) {
			const loanId = `${(loanAccount ?? this.loan)?.loanAccountId}`.padStart(3, "0");
			const loanDrawdownId = `${this.loanDrawdownId}`.padStart(3, "0");
			const typePart = this.isPurchasingPrice ? "PP_" : this.isInvoice ? "IN_" : "DR_";
			const portfolioPart = this.portfolioId ? `PT_${`${this.portfolioId}`.padStart(3, "0")}_` : "";
			const loanAccountType = `LA_${loanId}`;
			this.shortUuid = `${typePart}${`${loanDrawdownId}_`.padStart(3, "0")}${portfolioPart}${loanAccountType}`;
			return this.shortUuid;
		}
		toRequest(update) {
			return {
				...this,
				invoices: void 0,
				portfolio: void 0,
				loan: void 0,
				userId: void 0,
				createdAt: void 0,
				updatedAt: void 0,
				...update
			};
		}
	};
}));
//#endregion
//#region src/domains/finance/portfolio/loan-offer.class.ts
var LoanOfferType, LoanOfferStatus, LoanOffer;
var init_loan_offer_class = __esmMin((() => {
	init_base();
	init_investment();
	LoanOfferType = /* @__PURE__ */ function(LoanOfferType) {
		LoanOfferType["Outgoing"] = "Outgoing";
		LoanOfferType["Incoming"] = "Incoming";
		return LoanOfferType;
	}({});
	LoanOfferStatus = /* @__PURE__ */ function(LoanOfferStatus) {
		LoanOfferStatus["Sent"] = "Sent";
		LoanOfferStatus["Received"] = "Received";
		LoanOfferStatus["Accepted"] = "Accepted";
		return LoanOfferStatus;
	}({});
	LoanOffer = class extends BaseClassAttributes {
		loanOfferId;
		amortizationType;
		equityRatio;
		financingBankId;
		portfolioId;
		timeOnBooks;
		/**
		* Interest rate paid on used amount from the loan
		* @type {number}
		*/
		seniorDebtInterest;
		/**
		* Fixed amount of fee which is charged based on the whole loan amount
		* @type {number}
		*/
		seniorDebtProcessingFee;
		/**
		* Interest rate paid based on NOT-used amount of the loan.
		* @type {number}
		*/
		commitmentInterestRate;
		/**
		* Term sheet document
		* @type {number}
		*/
		documentId;
		/**
		* Offer sent to bank
		* @type {Date | null}
		*/
		sentAt;
		/**
		* Offer received from bank
		* @type {Date | null}
		*/
		receivedAt;
		/**
		* Interacted used id
		* @type {string}
		*/
		sentUserId;
		/**
		* Loan Offer Status
		* @type {LoanOfferStatus}
		*/
		loanOfferStatus;
		/**
		* Incoming or Outgoing offer
		* @type {LoanOfferType}
		*/
		loanOfferType = "Outgoing";
		termSheet;
		loan;
		financingBank;
		portfolio;
		constructor(props) {
			super(props);
			Object.assign(this, props);
			if (!props.loanOfferStatus && props.loanOfferType) this.loanOfferStatus = props.loanOfferType === "Incoming" ? "Received" : "Sent";
		}
		get inputs() {
			return {
				seniorDebtProcessingFee: this.seniorDebtProcessingFee,
				equityRatio: this.equityRatio,
				amortizationType: this.amortizationType,
				seniorDebtInterest: this.seniorDebtInterest,
				timeOnBooks: this.timeOnBooks
			};
		}
		get seniorWacc() {
			return ProfitabilityCalculationsClass.seniorWacc(this.seniorDebtInterest, this.seniorDebtProcessingFee, this.timeOnBooks);
		}
		set date(val) {
			if (this.loanOfferType === "Incoming") {
				this.receivedAt = val;
				this.sentAt = null;
			} else {
				this.sentAt = val;
				this.receivedAt = null;
			}
		}
		toRequest() {
			return {
				...this,
				createdAt: void 0,
				updatedAt: void 0,
				loan: void 0,
				termSheet: void 0
			};
		}
	};
}));
//#endregion
//#region src/domains/finance/portfolio/loan-offer.model.ts
var init_loan_offer_model = __esmMin((() => {}));
//#endregion
//#region src/domains/finance/portfolio/portfolio-estate-plan-collection.class.ts
var rowsDefinition, processStatesDefinition, roundedZeroDecimalCurrency, filterFuncDef, PortfolioEstatePlanCollection;
var init_portfolio_estate_plan_collection_class = __esmMin((() => {
	rowsDefinition = [
		["Wohnfläche", "livingSpace"],
		["Kaufpreis", "purchasingPrice"],
		["Nebenkosten", "ancillaryCosts"],
		["Renovierungskosten", "renovationCosts"],
		["Finanzierungskosten", "financingCosts"],
		["Finanzierungsbedarf Gesamt", "totalFinancingCosts"],
		["davon Eigenmittel", "juniorDebt"],
		["davon Fremdkapital", "seniorDebt"],
		["Zielmiete/ qm/ Monat (kalt)", "rentPerSquareMeter"],
		["Stellplatz", "parkingSpaceRent"],
		["Zielmiete/ Monat", "monthlyIncome"],
		["JNKM", "yearlyIncome"],
		["Verkaufs-Faktor", "sellingFactor"],
		["Verkaufspreis", "sellingPrice"],
		["Verkaufspreis/ qm", "sellingPricePerSquareMeter"],
		["Gewinn", "profit"],
		["Return on Investment", "returnOnInvestment"],
		["Return on Equity", "returnOnEquity"]
	];
	processStatesDefinition = [
		["Sourcing", "sourcingState"],
		["Purchasing", "purchasingState"],
		["Renovation", "renovationState"],
		["Renting", "rentingState"],
		["Selling", "sellingState"]
	];
	roundedZeroDecimalCurrency = (value) => currency(Math.round(value), 0);
	filterFuncDef = {
		livingSpace: {
			value: squareMeter,
			total: squareMeter,
			average: squareMeter
		},
		purchasingPrice: {
			value: roundedZeroDecimalCurrency,
			total: roundedZeroDecimalCurrency,
			average: (v) => perSquareMeter(roundedZeroDecimalCurrency(v))
		},
		ancillaryCosts: {
			value: roundedZeroDecimalCurrency,
			total: roundedZeroDecimalCurrency,
			average: roundedZeroDecimalCurrency
		},
		juniorDebt: {
			value: roundedZeroDecimalCurrency,
			total: roundedZeroDecimalCurrency,
			average: (v) => percent(v, 2)
		},
		returnInvest: {
			value: percent,
			total: percent,
			average: percent
		},
		rentPerSquareMeter: {
			value: currency,
			total: currency,
			average: (v) => perSquareMeter(currency(v))
		}
	};
	filterFuncDef.renovationCosts = filterFuncDef.purchasingPrice;
	filterFuncDef.financingCosts = filterFuncDef.ancillaryCosts;
	filterFuncDef.totalFinancingCosts = filterFuncDef.ancillaryCosts;
	filterFuncDef.parkingSpaceRent = filterFuncDef.ancillaryCosts;
	filterFuncDef.monthlyIncome = filterFuncDef.ancillaryCosts;
	filterFuncDef.yearlyIncome = filterFuncDef.ancillaryCosts;
	filterFuncDef.sellingPrice = filterFuncDef.ancillaryCosts;
	filterFuncDef.profit = filterFuncDef.ancillaryCosts;
	filterFuncDef.seniorDebt = filterFuncDef.juniorDebt;
	filterFuncDef.sellingPricePerSquareMeter = filterFuncDef.purchasingPrice;
	filterFuncDef.returnOnEquity = filterFuncDef.returnInvest;
	filterFuncDef.returnOnInvestment = filterFuncDef.returnInvest;
	PortfolioEstatePlanCollection = class {
		plans;
		totalLivingSpace;
		totalFinancing;
		rows = [];
		constructor(plans) {
			this.plans = plans;
			this.totalLivingSpace = this.getTotal("livingSpace");
			this.totalFinancing = this.getTotal("totalFinancingCosts");
		}
		*[Symbol.iterator]() {
			for (const plan of this.plans) yield plan;
		}
		getTotal(field) {
			return this.plans.reduce((prev, curr) => prev + curr[field], 0);
		}
		getAverage(sum, divider, precision = 2) {
			return round$1(sum / (divider ?? this.plans.length), precision);
		}
		/**
		* Last columns of the transpiled data are total and average. And average is different from row to row.
		* @param field
		* @param func
		*/
		calculateTotal(field, func) {
			const result = {
				sum: "-",
				average: "-"
			};
			let totalSum;
			switch (field) {
				case "livingSpace":
					result.sum = func.total(this.totalLivingSpace);
					result.average = func.average(this.getAverage(this.totalLivingSpace));
					break;
				case "rentPerSquareMeter":
					result.sum = "-";
					result.average = func.average(this.getAverage(this.getTotal("rentPerSquareMeter")));
					break;
				case "sellingFactor":
					result.average = `${this.plans[0].sellingFactor}x`;
					break;
				case "purchasingPrice":
				case "renovationCosts":
					totalSum = this.getTotal(field);
					result.sum = func.total(totalSum);
					result.average = func.average(this.getAverage(totalSum, this.totalLivingSpace));
					break;
				case "juniorDebt":
				case "seniorDebt":
					totalSum = this.getTotal(field);
					result.sum = func.total(totalSum);
					result.average = func.average(this.getAverage(totalSum, this.totalFinancing, 4));
					break;
				case "ancillaryCosts":
				case "financingCosts":
				case "totalFinancingCosts":
				case "parkingSpaceRent":
				case "monthlyIncome":
				case "yearlyIncome":
				case "sellingPrice":
				case "profit":
					totalSum = this.getTotal(field);
					result.sum = func.total(totalSum);
					result.average = func.average(this.getAverage(totalSum));
					break;
				case "sellingPricePerSquareMeter":
				case "returnOnEquity":
				case "returnOnInvestment":
					result.average = func.average(this.getAverage(this.getTotal(field)));
					break;
				default: break;
			}
			return result;
		}
		getOneRow(field, func) {
			const formatter = func?.value ?? null;
			return this.plans.reduce((reduced, plan) => {
				const fieldValue = plan[field];
				reduced[plan.condoUuid] = formatter ? formatter(typeof fieldValue === "string" ? Number.parseFloat(fieldValue) : fieldValue) : plan[field];
				return reduced;
			}, {});
		}
		/**
		* It prepares data to be presented as investment plan and problem around it is - columns and rows swapped,
		* therefore we need to make proper mapping to rows, where first column is always name of the value
		*/
		compileData(withProcessStates = false) {
			const definitions = [...rowsDefinition, ...withProcessStates ? processStatesDefinition : []];
			for (let i = 0; i < definitions.length; i++) {
				const [translation, field] = definitions[i];
				const funcMap = filterFuncDef[field];
				this.rows.push({
					valueName: translation,
					...this.getOneRow(field, funcMap),
					...this.calculateTotal(field, funcMap)
				});
			}
			return this.rows;
		}
		getRows() {
			return this.rows.map((r) => ({ ...r }));
		}
	};
}));
//#endregion
//#region src/domains/finance/portfolio/portfolio-estate-plan.class.ts
var DefaultUtilitiesPerMonth, PortfolioEstatePlan;
var init_portfolio_estate_plan_class = __esmMin((() => {
	init_errors();
	DefaultUtilitiesPerMonth = 25;
	PortfolioEstatePlan = class {
		estateId;
		condoUuid;
		livingSpace;
		purchasingPrice;
		baseRenovationCosts;
		ancillaryCosts;
		financingCosts = 0;
		totalFinancingCosts = 0;
		juniorDebt = 0;
		seniorDebt = 0;
		rentPerSquareMeter;
		coldRent;
		parkingSpaceRent;
		monthlyIncome;
		yearlyIncome;
		sellingFactor = 0;
		sellingPrice;
		sellingPricePerSquareMeter;
		profit = 0;
		returnOnInvestment = 0;
		returnOnEquity = 0;
		renovationCosts = 0;
		totalFinanceAmount = 0;
		totalSeniorDebtFee = 0;
		purchasingEntityId;
		totalOtherCosts = 0;
		totalRenovationCosts = 0;
		utilitiesPerMonth = DefaultUtilitiesPerMonth;
		sourcingState;
		purchasingState;
		renovationState;
		rentingState;
		sellingState;
		constructor(estate, inputs) {
			this._inputs = inputs;
			const rentPerSquareMeter = estate.executedInvestmentCase?.baseRentPerSquareMeter ?? 0;
			this.purchasingPrice = estate.executedInvestmentCase?.purchasingPrice + estate.executedInvestmentCase?.parkingSpacePurchasePrice;
			if (!estate.attributes) throw new InvariantError("Need to have attributes present on estate");
			this.livingSpace = estate.attributes.livingSpace;
			this.rentPerSquareMeter = rentPerSquareMeter;
			this.coldRent = round$1(rentPerSquareMeter * estate.attributes.livingSpace, 2);
			this.parkingSpaceRent = estate.executedInvestmentCase?.parkingSpacePrice ?? 0;
			this.monthlyIncome = round$1(this.coldRent + this.parkingSpaceRent, 2);
			this.yearlyIncome = round$1(this.monthlyIncome * 12, 2);
			this.ancillaryCosts = estate.executedInvestmentCase?.auxiliaryCosts ?? 0;
			this.sellingPrice = estate.executedInvestmentCase?.expectedSalesPrice;
			this.sellingPricePerSquareMeter = round$1(this.sellingPrice / this.livingSpace, 2);
			const baseOtherCosts = estate.executedInvestmentCase?.otherCosts ?? 0;
			const ifcScanCosts = estate.executedInvestmentCase?.ifcScanCosts ?? 0;
			const takingPictures = estate.executedInvestmentCase?.takingPictures ?? 0;
			const totalAdditionalCost = estate.executedInvestmentCase?.totalAdditionalCost ?? 0;
			this.baseRenovationCosts = (estate.executedInvestmentCase?.generalRenovationCosts ?? 0) + (estate.executedInvestmentCase?.kitchenCost ?? 0) + (estate.executedInvestmentCase?.toiletPrice ?? 0) + (estate.executedInvestmentCase?.roomsChangePrice ?? 0);
			this.totalRenovationCosts = estate.executedInvestmentCase?.renovationCosts ?? 0;
			this.utilitiesPerMonth = estate.executedInvestmentCase?.otherCosts ? (baseOtherCosts - ifcScanCosts - takingPictures) / 6 : DefaultUtilitiesPerMonth;
			this.totalOtherCosts = ifcScanCosts + takingPictures + totalAdditionalCost;
			this.condoUuid = estate.condoUuid;
			this.estateId = estate.estateId;
			this.purchasingEntityId = estate.purchasing?.purchasingEntityId;
			this.sourcingState = estate.sourcing?.processState.state;
			this.purchasingState = estate.purchasing?.processState.state;
			this.renovationState = estate.renovation?.processState.state;
			this.rentingState = estate.rentingProcesses?.length ? estate.rentingProcesses[estate.rentingProcesses.length - 1]?.processState.state : void 0;
			this.sellingState = estate.selling?.processState.state;
			this.calculate();
		}
		_inputs;
		set inputs(inputs) {
			this._inputs = inputs;
		}
		calculate(inputs) {
			if (inputs) this._inputs = inputs;
			this.renovationCosts = round$1(this.totalRenovationCosts * (1 + this._inputs.renovationBuffer) + this._inputs.timeOnBooks * this.utilitiesPerMonth + this.totalOtherCosts);
			this.totalFinanceAmount = this.getTotalFinanceAmount();
			this.totalSeniorDebtFee = this.getTotalSeniorDebtFee();
			this.financingCosts = this.getFinancingCosts();
			this.totalFinancingCosts = this.totalFinanceAmount + this.financingCosts;
			this.juniorDebt = round$1(this.totalFinancingCosts * this._inputs.equityRatio, 2);
			this.seniorDebt = round$1(this.totalFinancingCosts * (1 - this._inputs.equityRatio), 2);
			this.profit = round$1(this.sellingPrice - this.totalFinancingCosts, 2);
			this.returnOnInvestment = round$1(this.profit / this.totalFinancingCosts, 2);
			this.returnOnEquity = round$1(this.profit / this.juniorDebt, 2);
			this.sellingFactor = round$1(1 / .03, 1);
			return this;
		}
		getTotalFinanceAmount() {
			return this.purchasingPrice + this.renovationCosts + this.ancillaryCosts;
		}
		getTotalSeniorDebtFee() {
			return this._inputs.seniorDebtInterest * this._inputs.timeOnBooks / 12 + this._inputs.seniorDebtProcessingFee;
		}
		getFinancingCosts() {
			return round$1(this.totalFinanceAmount * (1 - this._inputs.equityRatio) * this.totalSeniorDebtFee / (1 - this.totalSeniorDebtFee), 2);
		}
	};
}));
//#endregion
//#region src/domains/finance/portfolio/portfolio-estate-plan.model.ts
var init_portfolio_estate_plan_model = __esmMin((() => {}));
//#endregion
//#region src/domains/finance/portfolio/portfolio-estate-summary.class.ts
var PortfolioEstateSummaryClass;
var init_portfolio_estate_summary_class = __esmMin((() => {
	init_errors();
	init_invoice();
	PortfolioEstateSummaryClass = class {
		purchasingPrice;
		paidPurchasingPrice;
		purchasingPriceToSumPaid;
		acquisitionCosts;
		paidAcquisitionCosts = 0;
		paidAcquisitionCostsToSumPaid;
		renovationCosts;
		paidRenovationCosts = 0;
		paidRenovationCostsToSumPaid;
		financingCosts;
		sumPlanned;
		sumPaid;
		juniorDebt;
		seniorDebt;
		juniorDebtSpent;
		seniorDebtSpent;
		sumFinancing;
		sumFinancingSpent;
		purchasingPriceDiff;
		renovationCostsDiff;
		acquisitionCostsDiff;
		sumDiff;
		juniorDebtDiff;
		seniorDebtDiff;
		sumFinancingDiff;
		usedJuniorPercentage;
		usedSeniorPercentage;
		constructor({ estate, invoices, portfolio, loanAccount }) {
			const estatePlan = portfolio.getEstatePlan(+estate.estateId);
			if (!estatePlan) throw new EntityNotFoundError(`Estate Plan is not found for ${estate.estateId}`);
			this.purchasingPrice = estatePlan.purchasingPrice;
			const purchasingDrawdown = loanAccount.drawdowns?.find((d) => d.isPurchasingPrice && d.isReceived);
			this.paidPurchasingPrice = purchasingDrawdown?.drawdownAmount ?? 0;
			this.acquisitionCosts = estatePlan.ancillaryCosts;
			this.renovationCosts = estatePlan.renovationCosts;
			this.financingCosts = estatePlan.financingCosts;
			invoices.filter((i) => !!i.authorizedAt).forEach((i) => {
				if (costTypesGrouped.RetailBusinessLine.RetailRenovationCosts.includes(i.costType)) this.paidRenovationCosts += i.payoutAmount;
				else this.paidAcquisitionCosts += i.payoutAmount;
			});
			this.sumPlanned = this.purchasingPrice + this.renovationCosts + this.acquisitionCosts + this.financingCosts;
			this.sumPaid = this.paidPurchasingPrice + this.paidRenovationCosts + this.paidAcquisitionCosts;
			this.purchasingPriceToSumPaid = this.sumPaid ? this.paidPurchasingPrice / this.sumPaid : 0;
			this.paidAcquisitionCostsToSumPaid = this.sumPaid ? this.paidAcquisitionCosts / this.sumPaid : 0;
			this.paidRenovationCostsToSumPaid = this.sumPaid ? this.paidRenovationCosts / this.sumPaid : 0;
			this.juniorDebt = estatePlan.juniorDebt;
			this.seniorDebt = estatePlan.seniorDebt;
			this.sumFinancing = this.juniorDebt + this.seniorDebt;
			const invoicesJuniorAmount = invoices.reduce((sum, i) => sum + (i.paidAt ? i.juniorDebtAmount : 0), 0);
			const purchasingJunior = purchasingDrawdown ? purchasingDrawdown.drawdownAmount - purchasingDrawdown.receivedAmount : 0;
			this.juniorDebtSpent = invoicesJuniorAmount + purchasingJunior;
			this.seniorDebtSpent = loanAccount.drawdowns.reduce((sum, d) => sum + (d.estateId === estate.estateId ? d.receivedAmount ?? 0 : 0), 0);
			this.sumFinancingSpent = this.juniorDebtSpent + this.seniorDebtSpent;
			this.purchasingPriceDiff = this.purchasingPrice - this.paidPurchasingPrice;
			this.renovationCostsDiff = this.renovationCosts - this.paidRenovationCosts;
			this.acquisitionCostsDiff = this.acquisitionCosts - this.paidAcquisitionCosts;
			this.sumDiff = this.sumPlanned - this.sumPaid;
			this.juniorDebtDiff = this.juniorDebt - this.juniorDebtSpent;
			this.seniorDebtDiff = this.seniorDebt - this.seniorDebtSpent;
			this.sumFinancingDiff = this.sumFinancing - this.sumFinancingSpent;
			this.usedJuniorPercentage = round$1(this.juniorDebtSpent / this.juniorDebt, 2);
			this.usedSeniorPercentage = round$1(this.seniorDebtSpent / this.seniorDebt, 2);
		}
	};
}));
//#endregion
//#region src/domains/finance/mezzanine-loan-account.class.ts
var mezzanine_loan_account_class_exports = /* @__PURE__ */ __exportAll({ MezzanineLoanAccount: () => MezzanineLoanAccount });
var MezzanineLoanAccount;
var init_mezzanine_loan_account_class = __esmMin((() => {
	init_loan_account_class();
	MezzanineLoanAccount = class extends LoanAccount {};
}));
//#endregion
//#region src/domains/finance/portfolio-loan-account.class.ts
var portfolio_loan_account_class_exports = /* @__PURE__ */ __exportAll({ PortfolioLoanAccount: () => PortfolioLoanAccount });
var PortfolioLoanAccount;
var init_portfolio_loan_account_class = __esmMin((() => {
	init_errors();
	init_general_ledger();
	init_ledger_entry();
	init_ledger_factory_class();
	init_loan_account_class();
	PortfolioLoanAccount = class extends LoanAccount {
		constructor(props) {
			super(props);
			if (props.ledger) this.ledger = LedgerFactory.factory(props.ledger, "LoanAccount");
		}
		/**
		* Interest since the last date. Caveat here that for dates 31 and 30 of march would not be any interest.
		* @param {Date} start Previous Day
		* @param {Date} end Today date
		* @returns {number}
		*/
		dailyInterest(start, end) {
			const daysDiff = LoanAccount.DAYS360(start, end);
			if (typeof daysDiff === "undefined") throw new ApplicationError(`Diff between ${start} and ${end} can't be calculated`);
			const totalOutstanding = this.ledger.findDayBalanceRecord(start)?.outstandingPrincipal ?? 0;
			const totalDayInterest = Math.abs(round$1(totalOutstanding * this.dailyNormalInterestRate * daysDiff, 2));
			const estateOutstandingGrouped = this.ledger.groupEntries("estateId", (entry) => ["Drawdown", "Repayment"].includes(entry.entryGroup));
			let totalEstateSum = 0;
			const estatesSums = Object.entries(estateOutstandingGrouped).map(([estateId, entries]) => {
				const sum = round$1(entries.reduce((sum, entry) => entry.totalAmount + sum, 0), 2);
				if (sum < 0) totalEstateSum += sum;
				return {
					estateId,
					sum
				};
			}).map((value) => {
				let interest = 0;
				if (value.sum < 0) interest = round$1(round$1(value.sum / totalEstateSum, 4) * totalDayInterest, 2);
				return {
					...value,
					interest
				};
			});
			const totalEstatesInterest = estatesSums.reduce((sum, rec) => round$1(rec.interest + sum, 2), 0);
			const dayToEstateDiff = totalEstatesInterest - totalDayInterest;
			if (Math.abs(dayToEstateDiff) > 2) throw new ApplicationError(`Total estate interest more than loan interest by ${currency(dayToEstateDiff)}`);
			const loanLevelInterest = round$1(totalDayInterest - totalEstatesInterest, 2);
			const common = {
				entryGroup: "Fee",
				entryGroupType: "Interest",
				valueDate: end,
				generalLedgerId: this.ledger.generalLedgerId,
				debit: 0,
				credit: 0,
				entryType: "Accrual"
			};
			this.ledger.addLedgerEntry(new LedgerEntry({
				...common,
				debit: -loanLevelInterest < 0 ? Math.abs(loanLevelInterest) : 0,
				credit: -loanLevelInterest > 0 ? Math.abs(loanLevelInterest) : 0
			}));
			estatesSums.filter((e) => e.sum < 0).forEach((e) => this.ledger.addLedgerEntry(new LedgerEntry({
				...common,
				estateId: e.estateId,
				debit: -e.interest < 0 ? Math.abs(e.interest) : 0,
				credit: -e.interest > 0 ? Math.abs(e.interest) : 0
			})));
			return totalDayInterest;
		}
	};
}));
//#endregion
//#region src/domains/finance/loan-account-factory.class.ts
var LoanAccountFactory;
var init_loan_account_factory_class = __esmMin((() => {
	LoanAccountFactory = class {
		static async factory(props, type) {
			switch (type ?? props.loanAccountType) {
				case "IntergroupLoan": return new (await (Promise.resolve().then(() => (init_intergroup_loan_account_class(), intergroup_loan_account_class_exports)))).IntergroupLoanAccount(props);
				case "Mezzanine": return new (await (Promise.resolve().then(() => (init_mezzanine_loan_account_class(), mezzanine_loan_account_class_exports)))).MezzanineLoanAccount(props);
				case "PortfolioLoan": return new (await (Promise.resolve().then(() => (init_portfolio_loan_account_class(), portfolio_loan_account_class_exports)))).PortfolioLoanAccount(props);
				default: return new (await (Promise.resolve().then(() => (init_loan_account_class(), loan_account_class_exports)))).LoanAccount(props);
			}
		}
	};
}));
//#endregion
//#region src/domains/finance/portfolio/portfolio.class.ts
var portfolio_class_exports = /* @__PURE__ */ __exportAll({
	Portfolio: () => Portfolio,
	PortfolioAmortizationType: () => PortfolioAmortizationType,
	PortfolioEvents: () => PortfolioEvents,
	PortfolioStatus: () => PortfolioStatus,
	portfolioRequiredDocuments: () => portfolioRequiredDocuments,
	statusPath: () => statusPath
});
var PortfolioAmortizationType, PortfolioStatus, statusPath, portfolioRequiredDocuments, PortfolioEvents, Portfolio;
var init_portfolio_class = __esmMin((() => {
	init_base();
	init_document();
	init_estate_helpers();
	init_review_process_class();
	init_loan_account_factory_class();
	init_loan_drawdown_class();
	init_loan_offer_class();
	init_portfolio_estate_plan_class();
	PortfolioAmortizationType = /* @__PURE__ */ function(PortfolioAmortizationType) {
		PortfolioAmortizationType["Complete"] = "Complete";
		PortfolioAmortizationType["Partial"] = "Partial";
		return PortfolioAmortizationType;
	}({});
	PortfolioStatus = /* @__PURE__ */ function(PortfolioStatus) {
		PortfolioStatus["New"] = "New";
		PortfolioStatus["Draft"] = "Draft";
		PortfolioStatus["Ready"] = "Ready";
		PortfolioStatus["Review"] = "Review";
		PortfolioStatus["Approved"] = "Approved";
		PortfolioStatus["Tendering"] = "Tendering";
		PortfolioStatus["Active"] = "Active";
		PortfolioStatus["Closed"] = "Closed";
		return PortfolioStatus;
	}({});
	statusPath = [
		"New",
		"Draft",
		"Ready",
		"Review",
		"Approved",
		"Tendering",
		"Active",
		"Closed"
	];
	portfolioRequiredDocuments = [
		"Expose",
		"LandRegisterMap",
		"AbstractOfTitle",
		"ContractDraft",
		"DeclarationOfCondominium",
		"LivingSpaceCalculation",
		"ConstructionBurdenStatement",
		"ContractNotarized",
		"ConstructionContract",
		"PartitionPlan",
		"Floorplans",
		"BuildingInsurance",
		"RegistrationNotice"
	];
	PortfolioEvents = /* @__PURE__ */ function(PortfolioEvents) {
		PortfolioEvents["Drafted"] = "Drafted";
		PortfolioEvents["PortfolioReady"] = "PortfolioReady";
		PortfolioEvents["Revert"] = "Revert";
		PortfolioEvents["LoanOfferSent"] = "LoanOfferSent";
		PortfolioEvents["LoanOfferAccepted"] = "LoanOfferAccepted";
		PortfolioEvents["Closed"] = "Closed";
		return PortfolioEvents;
	}({});
	Portfolio = class Portfolio extends BaseClassAttributes {
		portfolioId;
		equityRatio;
		seniorDebtInterest;
		seniorDebtProcessingFee;
		amortizationType;
		renovationBuffer;
		timeOnBooks;
		shortUuid;
		reviewProcess;
		/**
		* Resulting junior debt amount after sign
		* @type {number}
		*/
		juniorDebtAmount;
		status;
		createdUserId;
		assignedUserId;
		documentsLink;
		documentLinkDate;
		inspectionSheetLink;
		purchasingEntityId;
		purchasingEntity;
		totalFinancingCosts = 0;
		estates = [];
		offers = [];
		plans = [];
		documents = [];
		drawdowns = [];
		loan;
		constructor(props, loanAccount) {
			super(props);
			Object.assign(this, props);
			if (props.offers) this.offers = props.offers.map((t) => new LoanOffer(t));
			if (props.estates) this.initPlans(props.estates);
			if (loanAccount) this.loan = loanAccount;
			if (props.reviewProcess) this.reviewProcess = new ReviewProcess(props.reviewProcess);
			if (props.drawdowns) this.drawdowns = props.drawdowns.map((d) => new LoanDrawdown(d));
		}
		static async create(props) {
			if (props.loan) {
				const loanAccount = await LoanAccountFactory.factory(props.loan, "PortfolioLoan");
				return new Portfolio(props, loanAccount);
			}
			return new Portfolio(props);
		}
		get totalSeniorDebt() {
			return round$1(this.plans.reduce((acc, curr) => acc + curr.seniorDebt, 0), 0);
		}
		get isRollbackDisabled() {
			return statusPath.indexOf(this.status) === 0;
		}
		get isProceedDisabled() {
			return statusPath.indexOf(this.status) === statusPath.length - 1;
		}
		get nextStatus() {
			return statusPath[statusPath.indexOf(this.status) + 1];
		}
		get drawdownAmount() {
			return this.drawdowns?.reduce((acc, dr) => acc + (dr.isReceived ? dr.receivedAmount : 0), 0);
		}
		get isInTendering() {
			return this.status === "Tendering";
		}
		get isInApproved() {
			return this.status === "Approved";
		}
		get isClosed() {
			return this.status === "Closed";
		}
		get isAccepted() {
			return this.status === "Active";
		}
		get isActive() {
			return this.status === "Active";
		}
		get baseInputs() {
			return {
				renovationBuffer: this.renovationBuffer,
				seniorDebtProcessingFee: this.seniorDebtProcessingFee,
				equityRatio: this.equityRatio,
				amortizationType: this.amortizationType,
				seniorDebtInterest: this.seniorDebtInterest,
				timeOnBooks: this.timeOnBooks
			};
		}
		get estateIds() {
			return this.estates.map((e) => e.estateId);
		}
		get numberOfEstates() {
			return this.estates.length;
		}
		get previousStatus() {
			return statusPath[statusPath.indexOf(this.status) - 1];
		}
		get totalAmount() {
			return this.totalFinancingCosts;
		}
		get editAvailable() {
			return ["New", "Ready"].includes(this.status);
		}
		get empty() {
			return this.estates.length === 0;
		}
		get appliedBanks() {
			return this.offers.map((offer) => ({
				financingBankId: offer.financingBankId,
				bankName: offer.financingBank?.name
			}));
		}
		get acceptedOffer() {
			return this.offers.find((offer) => offer.loanOfferStatus === "Accepted");
		}
		static createDocumentFileName(estate, doc) {
			return generateDocumentFileName(estate, doc);
		}
		static createEstateFolderName(estate) {
			return generateEstateFolderName(estate);
		}
		calculateJuniorDebt() {
			this.juniorDebtAmount = this.plans.reduce((sum, plan) => sum + plan.juniorDebt, 0);
		}
		getEstatePlan(estateId) {
			return this.plans.find((plan) => plan.estateId === estateId);
		}
		initPlans(_estates, inputs) {
			if (!inputs) if (this.isAccepted) {
				const offer = this.findAcceptedLoanOffer();
				if (!offer) throw new Error("Portfolio is missing accepted offer");
				inputs = {
					renovationBuffer: this.renovationBuffer,
					seniorDebtProcessingFee: offer.seniorDebtProcessingFee,
					equityRatio: offer.equityRatio,
					amortizationType: offer.amortizationType,
					seniorDebtInterest: offer.seniorDebtInterest,
					timeOnBooks: offer.timeOnBooks
				};
			} else inputs = {
				renovationBuffer: this.renovationBuffer,
				seniorDebtProcessingFee: this.seniorDebtProcessingFee,
				equityRatio: this.equityRatio,
				amortizationType: this.amortizationType,
				seniorDebtInterest: this.seniorDebtInterest,
				timeOnBooks: this.timeOnBooks
			};
			this.plans = this.calculate(inputs);
			if (this.plans.length) this.totalFinancingCosts = round$1(this.plans.reduce((prev, plan) => prev + plan.totalFinanceAmount, 0), 2);
		}
		calculate(inputs) {
			return this.estates.filter((e) => !!e.location && !!e.attributes).map((e) => new PortfolioEstatePlan(e, inputs));
		}
		updateInputs(inputs) {
			this.renovationBuffer = inputs.renovationBuffer;
			this.seniorDebtProcessingFee = inputs.seniorDebtProcessingFee;
			this.equityRatio = inputs.equityRatio;
			this.amortizationType = inputs.amortizationType;
			this.seniorDebtInterest = inputs.seniorDebtInterest;
		}
		getPortfolioDocumentsFolderName(useShortUuidIfAvailable = true) {
			const id = useShortUuidIfAvailable ? this.shortUuid ?? this.portfolioId : this.portfolioId;
			return `${this.purchasingEntity?.shortName}_${id}_Unterlagen Finanzierungspartner`;
		}
		parseDocuments(documents) {
			const docMap = /* @__PURE__ */ new Map();
			portfolioRequiredDocuments.forEach((d) => docMap.set(d, /* @__PURE__ */ new Set()));
			documents.forEach((doc) => docMap.get(doc.documentType)?.add(doc?.documentRelation?.[0]?.estateId));
			const res = [];
			docMap.forEach((value, key) => res.push({
				documentType: key,
				done: value.size === this.estates.length,
				present: value.size,
				need: this.estates.length
			}));
			return res;
		}
		checkPresentDocument(documents) {
			return this.parseDocuments(documents).reduce((prev, curr) => prev && curr.done, true);
		}
		findAcceptedLoanOffer() {
			return this.offers.find((offer) => offer.loanOfferStatus === "Accepted");
		}
		hasEstate(estateId) {
			return this.estates.some((e) => e.estateId === +estateId || e.condoUuid?.includes(`${estateId}`.toUpperCase()));
		}
		currentBankOffer() {
			return this.offers[this.offers.length - 1];
		}
		findOfferIndexById(loanOfferId) {
			return this.offers.findIndex((offer) => offer.loanOfferId === loanOfferId);
		}
		findOfferById(loanOfferId) {
			const index = this.findOfferIndexById(loanOfferId);
			if (index === -1) return;
			return this.offers[index];
		}
		findBankOffers(financingBankId) {
			return this.offers.filter((offer) => offer.financingBankId === financingBankId);
		}
		removeOffer(loanOfferId) {
			const index = this.findOfferIndexById(loanOfferId);
			if (index === -1) return;
			this.offers.splice(index, 1);
		}
	};
}));
//#endregion
//#region src/domains/finance/portfolio/portfolio.model.ts
var init_portfolio_model = __esmMin((() => {}));
//#endregion
//#region src/domains/finance/portfolio/index.ts
var init_portfolio = __esmMin((() => {
	init_interfaces();
	init_loan_drawdown_class();
	init_loan_offer_class();
	init_loan_offer_model();
	init_portfolio_estate_plan_collection_class();
	init_portfolio_estate_plan_class();
	init_portfolio_estate_plan_model();
	init_portfolio_estate_summary_class();
	init_portfolio_class();
	init_portfolio_model();
}));
//#endregion
//#region src/domains/finance/loan-account.class.ts
var loan_account_class_exports = /* @__PURE__ */ __exportAll({
	InvoiceSplitToleranceAmount: () => InvoiceSplitToleranceAmount,
	LoanAccount: () => LoanAccount
});
var InvoiceSplitToleranceAmount, LoanAccount;
var init_loan_account_class = __esmMin((() => {
	init_base();
	init_errors();
	init_bank_transaction_class();
	init_bank_transaction_model();
	init_ledger_entry();
	init_ledger_factory_class();
	init_portfolio();
	InvoiceSplitToleranceAmount = .4;
	LoanAccount = class LoanAccount extends BaseClassAttributes {
		loanAccountId;
		/**
		* To cover difference type of financing:
		*  - PortfolioLoan - loan for financing part of purchasing
		*  - Mezzanine - Junior Debt loan for financing rest of the amount for purchasing
		*  - IntergroupLoan - internal loans between Condo Group Gmbh and Purchasing Entities Subsidiaries
		* @type {LoanAccountType}
		*/
		loanAccountType;
		loanAccountState;
		/**
		* Number of loan account used externally by bank
		* @type {number}
		*/
		externalLoanAccountId;
		/**
		* Reference to bank financed the loan
		* @type {number}
		*/
		bankId;
		/**
		* Link to BankAccount entity
		* @type {number}
		*/
		bankAccountId;
		portfolioId;
		loanAmount;
		/**
		* Used as the basis for calculations of the balance
		* @type {Date}
		*/
		loanStartDate;
		/**
		* Fee to be paid on total amount once when loan is granted.
		* @type {number}
		*/
		processingFee;
		/**
		* Interest rate per annum.
		* @type {number}
		*/
		interestRate;
		/**
		* Based on different duration of the year
		* @type {InterestRateMode}
		*/
		interestRateMode = "Year360";
		interestCalculationMode = "Normal";
		interestRateBasis = "Outstanding";
		/**
		* Either commitment calculated based on whole line of credit or on used capital
		* @type {CommitmentRateMode}
		*/
		commitmentRateMode = "UnusedCapital";
		/**
		* Fee to be paid on unused loan account
		* @type {number}
		*/
		commitmentInterestRate;
		/**
		* Commitment fee can have grace period. Date specifies when they charged.
		* @type {Date}
		*/
		commitmentStartDate;
		/**
		* Minimum amount to create drawdown
		* @type {number}
		*/
		minDrawdownAmount;
		/**
		* Minimum amount of total fees to be paid in scope of the loan.
		* Example: In LoanAccountType.Mezzanine loans 10% is minimum amount should be paid.
		* @type {number}
		*/
		minimumFeeAmount;
		/**
		* Applicable only for Portfolio loans. Defines if we can use amount of loan regardless of the split between estates.
		* @type {LoanAllocationStructureType}
		*/
		allocationStructureType;
		/**
		* Defines how repayment is done for Portfolio Loan
		* @type {LoanRepaymentType}
		*/
		repaymentType;
		/**
		* When interest rate is repaid - for all options except RepaymentPeriod.EndDate happens regularly
		* @type {RepaymentPeriod}
		*/
		repaymentPeriod;
		/**
		* When first repayment should happen
		* @type {Date}
		*/
		firstRepaymentDate;
		/**
		* In case it is positive it is interest rate which is added on top of the regular interest rate
		* @type {Euribor}
		*/
		euribor;
		/**
		* Date when loan has to be repaid
		* @type {Date}
		*/
		repaymentDate;
		/**
		* Day of full repayment
		* @type {Date}
		*/
		repaidAt;
		/**
		* User who create loan account
		* @type {string}
		*/
		createdUserId;
		portfolio;
		/**
		* Bank which is providing loan
		*/
		bank;
		/**
		* For Intergroup Loans - which entity owns this loan
		* @type {number}
		*/
		purchasingEntityId;
		/**
		* For Mezzanine accounts name of the fund or provider of the loan
		* @type {string}
		*/
		mezzanineSourceName;
		/**
		* All drawdowns which reducing amount of available capital and increasing outstanding principal
		* @type {LoanDrawdown[]}
		*/
		drawdowns = [];
		ledger;
		bankAccount;
		company;
		parentLoanAccountId;
		parentLoanAccount;
		childLoanAccount = [];
		repaidAmount = 0;
		constructor(props, portfolio) {
			super(props);
			Object.assign(this, props);
			this.drawdowns = props.drawdowns?.map((d) => new LoanDrawdown(d)) ?? [];
			if (portfolio) this.portfolio = portfolio;
			if (props.ledger) this.ledger = LedgerFactory.factory(props.ledger);
		}
		get isMezzanine() {
			return this.loanAccountType === "Mezzanine";
		}
		get isIntergroupLoan() {
			return this.loanAccountType === "IntergroupLoan";
		}
		get isPortfolioLoan() {
			return this.loanAccountType === "PortfolioLoan";
		}
		/**
		* Total amount of all received drawdowns
		* @returns {number}
		*/
		get drawnAmount() {
			return this.drawdowns.reduce((sum, drawdown) => drawdown.isReceived ? sum + drawdown.receivedAmount : sum, 0);
		}
		get requestedAmount() {
			return this.drawdowns.reduce((sum, drawdown) => sum + drawdown.drawdownAmount, 0);
		}
		get defaultDrawdownType() {
			switch (true) {
				case this.isMezzanine: return "JuniorDebt";
				case this.isIntergroupLoan: return "Intergroup";
				case this.isPortfolioLoan: return "Invoices";
				default: return "Invoices";
			}
		}
		get yearBasis() {
			return this.interestRateMode === "Year360" ? 360 : 365;
		}
		/**
		* According to logic of 360/60. Standard European formula for daily interest calculations
		* @returns {number}
		*/
		get dailyNormalInterestRate() {
			return round$1(this.interestRate / this.yearBasis, 8);
		}
		/**
		* Daily rate to apply on unused amount of the loan
		* @returns {number}
		*/
		get dailyCommitmentFeeRate() {
			return round$1(this.commitmentInterestRate / 360, 8);
		}
		static async create(props) {
			if (props.portfolio) {
				const mod = await Promise.resolve().then(() => (init_portfolio_class(), portfolio_class_exports));
				return new LoanAccount(props, await mod.Portfolio.create(props.portfolio));
			}
			return new LoanAccount(props);
		}
		static DAYS360(start, end, method = 1) {
			return days360(start, end, method);
		}
		/**
		* Posting balance as the starting point for loan balance
		*/
		start() {
			if (!this.loanAmount || !this.loanStartDate) throw new ApplicationError("Need to provide loanAmount AND loanStartDate");
			this.ledger.addLedgerEntry(new LedgerEntry({
				entryGroup: "Tranche",
				entryGroupType: "Tranche",
				debit: this.loanAmount < 0 ? Math.abs(this.loanAmount) : 0,
				credit: this.loanAmount > 0 ? Math.abs(this.loanAmount) : null,
				valueDate: this.loanStartDate,
				entryType: "Accrual",
				generalLedgerId: this.ledger.generalLedgerId
			}));
		}
		dailyCumulativeInterestRate(start, end) {
			const exponent = round$1(round$1(dayjs(end).diff(start, "d", true), 0) / this.yearBasis, 8);
			return round$1((1 + this.interestRate) ** exponent - 1, 8);
		}
		/**
		* Check if need to re-calculate balance or entries after adjustments
		* @param {Date} valueDate
		*/
		checkAndRecalculate(valueDate) {
			const isToday = dayjs(valueDate).isSame(/* @__PURE__ */ new Date(), "d");
			if (this.ledger.findDayBalanceRecord(valueDate) && isToday || !isToday) {
				const start = dayjs(valueDate).subtract(1, "day").toDate();
				this.performCalculations(start, /* @__PURE__ */ new Date());
			}
		}
		/**
		* We have to calculate fees for date range. In most cases it would be within 1 day range.
		* For cases when we added bank transaction in the past we have to re-calculate for bigger range than 1 day.
		* Then  calculate the range with 1-day step and re-calculate for the last day balance only in case we running end of the day process
		* or we already had it and we still added transaction in the past.
		* @param {Date} startDay
		* @param {Date} endDay
		* @param {boolean} endOfDay
		*/
		performCalculations(startDay, endDay, endOfDay = false) {
			let nextDay = dayjs(startDay).add(1, "day");
			const hasTodayBalance = this.ledger.findDayBalanceRecord(endDay);
			while (nextDay.isSame(endDay, "day") && (endOfDay || hasTodayBalance) || nextDay.isBefore(endDay, "d")) {
				const nextDayDate = nextDay.toDate();
				this.dailyInterest(startDay, nextDayDate);
				this.dailyCommitmentFee(startDay, nextDayDate);
				this.ledger.calculateDayBalance(nextDayDate);
				startDay = dayjs(startDay).add(1, "day").toDate();
				nextDay = nextDay.add(1, "day");
			}
		}
		dailyInterest(start, end) {
			const daysDiff = LoanAccount.DAYS360(start, end);
			if (typeof daysDiff === "undefined") throw new ApplicationError(`Diff between ${start} and ${end} can't be calculated`);
			let baseAmount = 0;
			if (this.interestRateBasis === "Average") baseAmount = this.getAverageUsedAmount(end, true);
			else if (this.interestRateBasis === "Outstanding") baseAmount = this.ledger.findDayBalanceRecord(start)?.outstandingPrincipal ?? 0;
			let dailyInterestRate = 0;
			let totalDayInterest = 0;
			if (this.interestCalculationMode === "Cumulative") {
				const firstDrawdown = this.findFirstDrawdown(end);
				const yesterdayBalanceRecord = this.ledger.findDayBalanceRecord(start);
				if (firstDrawdown) {
					dailyInterestRate = this.dailyCumulativeInterestRate(firstDrawdown.valueDate, end);
					totalDayInterest = round$1(baseAmount * dailyInterestRate, 2);
					if (yesterdayBalanceRecord) totalDayInterest -= round$1(yesterdayBalanceRecord.accruedInterestFee, 2);
				}
			} else if (this.interestCalculationMode === "Normal") {
				dailyInterestRate = this.dailyNormalInterestRate;
				totalDayInterest = round$1(baseAmount * dailyInterestRate * daysDiff, 2);
			}
			if (totalDayInterest === 0) return 0;
			totalDayInterest = round$1(totalDayInterest, 2);
			this.ledger.addLedgerEntry(new LedgerEntry({
				entryGroup: "Fee",
				entryGroupType: "Interest",
				valueDate: end,
				generalLedgerId: this.ledger.generalLedgerId,
				debit: totalDayInterest < 0 ? Math.abs(totalDayInterest) : 0,
				credit: totalDayInterest > 0 ? Math.abs(totalDayInterest) : null,
				entryType: "Accrual"
			}));
			return totalDayInterest;
		}
		/**
		* Calculating and adding fee based on unused amount
		* @param {Date} start
		* @param {Date} end
		* @returns {number}
		*/
		dailyCommitmentFee(start, end) {
			const daysDiff = LoanAccount.DAYS360(start, end);
			if (typeof daysDiff === "undefined") throw new ApplicationError(`Diff between ${start} and ${end} can't be calculated`);
			const totalOutstanding = this.ledger.findDayBalanceRecord(start)?.outstandingPrincipal ?? 0;
			const totalAmount = this.getTrancheTotalOnDate(end);
			const commitmentFee = round$1((this.commitmentRateMode === "UnusedCapital" ? totalAmount - Math.abs(totalOutstanding) : totalAmount) * this.dailyCommitmentFeeRate * daysDiff, 2);
			const signedCommitmentFee = commitmentFee * -1;
			this.ledger.addLedgerEntry(new LedgerEntry({
				entryGroup: "Fee",
				entryGroupType: "Commitment",
				debit: signedCommitmentFee < 0 ? Math.abs(signedCommitmentFee) : 0,
				credit: signedCommitmentFee > 0 ? Math.abs(signedCommitmentFee) : null,
				generalLedgerId: this.ledger.generalLedgerId,
				entryType: "Accrual",
				valueDate: end
			}));
			return commitmentFee;
		}
		getAverageUsedAmount(date, includeToday = false) {
			const amounts = this.ledger.balanceRecords.filter((b) => dayjs(b.balanceDate).isBefore(date, "d")).sort(({ balanceDate: d1 }, { balanceDate: d2 }) => isBefore(d1, d2) ? -1 : sameDay(d1, d2) ? 0 : 1).filter((b) => b.outstandingPrincipal < 0).map((b) => b.outstandingPrincipal);
			if (includeToday) {
				const todayDrawdowns = this.ledger.entries.filter((e) => sameDay(e.valueDate, date) && e.isDrawdown).reduce((s, e) => s + e.totalAmount, 0);
				if (amounts.length) {
					const lastAmount = amounts[amounts.length - 1];
					amounts.push(todayDrawdowns ? todayDrawdowns + lastAmount : lastAmount);
				} else if (todayDrawdowns) amounts.push(todayDrawdowns);
			}
			const sum = amounts.reduce((sum, a) => sum + a, 0);
			return amounts.length ? round$1(sum / amounts.length, 0) : 0;
		}
		getTrancheTotalOnDate(date) {
			return this.ledger.entries.reduce((sum, e) => {
				return sum + (dayjs(e.valueDate).isBefore(date, "d") && e.isTranche ? e.totalAmount : 0);
			}, 0);
		}
		findFirstDrawdown(checkDate) {
			return this.ledger.entries.filter((e) => e.isDrawdown && (isBefore(e.valueDate, checkDate) || sameDay(e.valueDate, checkDate))).sort(({ valueDate: d1 }, { valueDate: d2 }) => isBefore(d1, d2) ? -1 : sameDay(d1, d2) ? 0 : 1)[0];
		}
		findDrawdown(drawdownId) {
			return this.drawdowns.find((drawdown) => drawdown.loanDrawdownId === drawdownId);
		}
		/**
		* Book Transactions for drawdowns:
		*  - Purchasing Price drawdown - we just record ledger entry and update drawdown
		*  - Invoices - we split drawdown for number of records equal to number of invoices connected
		* !!! It is possible that drawdown has amount which is not equal to requested amount. It means that bank pre-calculated amount of
		* junior debt we have to use.
		* @param {IBookLoanLedgerEntryParams} data
		*/
		bookDrawdown({ amount, valueDate, bankTransactionId, estateId, loanDrawdownId }) {
			const drawdownId = loanDrawdownId;
			const drawdown = this.drawdowns.find((drawdown) => drawdown.loanDrawdownId === drawdownId);
			if (!drawdown) throw new EntityNotFoundError("Drawdown was not found or not loaded into loan account");
			switch (true) {
				case drawdown.isPurchasingPrice:
					if (!estateId) throw new InvalidParamsError("estateId is required for booking purchasing price drawdown");
					this.ledger.addLedgerEntry(this.ledger.createNewLedgerEntry({
						debit: -amount < 0 ? Math.abs(amount) : 0,
						credit: -amount > 0 ? Math.abs(amount) : 0,
						entryGroup: "Drawdown",
						entryGroupType: "PurchasingPrice",
						entryType: "Cash",
						valueDate,
						estateId,
						drawdownId,
						bankTransactionId
					}));
					break;
				case drawdown.isIntergroup || drawdown.isJuniorDebt:
					this.ledger.addLedgerEntry(this.ledger.createNewLedgerEntry({
						debit: -amount < 0 ? Math.abs(amount) : 0,
						credit: -amount > 0 ? Math.abs(amount) : 0,
						entryGroup: "Drawdown",
						entryGroupType: drawdown.isIntergroup ? "Intergroup" : "JuniorDebt",
						entryType: "Cash",
						valueDate,
						drawdownId,
						bankTransactionId
					}));
					break;
				case drawdown.isInvoice: {
					let remainingAmount = amount;
					for (const invoice of drawdown.invoices) {
						if (remainingAmount <= 0) break;
						let { payoutAmount } = invoice;
						const { invoiceId, estateId } = invoice;
						if (!estateId) throw new InvariantError(`Invoice ${invoiceId} is missing connected estate`);
						payoutAmount = payoutAmount ?? 0;
						remainingAmount = round$1(remainingAmount - (payoutAmount ?? 0), 2);
						const amount = remainingAmount < 0 ? round$1(payoutAmount + remainingAmount, 2) : payoutAmount;
						invoice.seniorDebtAmount = amount;
						if (invoice.juniorDebtAmount) {
							invoice.juniorDebtAmount = round$1(invoice.juniorDebtAmount - amount, 2);
							invoice.isReimbursed = true;
						}
						this.ledger.addLedgerEntry(this.ledger.createNewLedgerEntry({
							debit: -amount < 0 ? Math.abs(amount) : 0,
							credit: -amount > 0 ? Math.abs(amount) : 0,
							entryGroup: "Drawdown",
							entryGroupType: "Invoice",
							entryType: "Cash",
							valueDate,
							invoiceId,
							estateId,
							drawdownId,
							bankTransactionId
						}));
					}
					if (remainingAmount > .4) throw new InvariantError(`Received amount higher than sum of payout amounts of invoices. Excess amount: "${currency(remainingAmount)}".`);
					break;
				}
				default: throw new Error(`Unsupported drawdown ${JSON.stringify(drawdown)}`);
			}
		}
		/**
		* Proxy Method for booking all transactions
		* @param {BankTransaction} transaction
		* @param {IAddBankTransactionData} data
		* @returns {BankTransaction}
		*/
		bookTransaction(transaction, data) {
			if (!(transaction instanceof BankTransaction)) throw new InvalidParamsError("passed transaction to bookTransaction is not instance of BankTransaction class");
			switch (true) {
				case Boolean(data.loanDrawdownId):
					this.bookDrawdown({
						amount: transaction.amount,
						bankTransactionId: transaction.bankTransactionId,
						estateId: data.estateId,
						loanDrawdownId: data.loanDrawdownId,
						valueDate: transaction.valueDate
					});
					break;
				case transaction.isSellingIncome:
					if (!data.estateId) throw new InvalidParamsError("estateId is required for booking selling price repayment");
					this.bookSellingIncome({
						amount: transaction.amount,
						bankTransactionId: transaction.bankTransactionId,
						estateId: data.estateId,
						valueDate: transaction.valueDate
					});
					break;
				case transaction.isRevenue && transaction.isFeeCategoryType:
					this.bookFeeRepayment({
						amount: transaction.amount,
						bankTransactionId: transaction.bankTransactionId,
						valueDate: transaction.valueDate,
						isGroupedFee: transaction.isGroupedFee,
						isSingleFee: transaction.isSingleFee,
						entryGroupType: transaction.categoryType
					});
					break;
				case transaction.isStorno:
					if (!data.parentTrx) throw new InvalidParamsError("Parent bank transaction is missing for booking storno-transaction");
					this.bookStorno({ parentTrx: data.parentTrx });
					break;
				case transaction.isBooking: break;
				default: throw new Error(`Loan Account can't handle ${transaction.category}`);
			}
			this.checkAndRecalculate(transaction.valueDate);
			transaction.bankTransactionState = "Reconciled";
			return transaction;
		}
		/**
		* We can revert either transaction or loan drawdown or other record.
		* For Storno cases we compensate each transaction with opposite amount
		* @param {BankTransaction | undefined} parentTrx
		* @param {number | undefined} ledgerEntryId
		* @param {number | undefined} loanDrawdownId
		*/
		bookStorno({ parentTrx, ledgerEntryId, loanDrawdownId }) {
			if (!parentTrx && !ledgerEntryId && !loanDrawdownId) throw new InvalidParamsError(`Need to provide either parent-transaction ,ledgerEntryId or loanDrawdownId when booking a storno-transaction`);
			let entriesToCompensate = [];
			if (parentTrx) entriesToCompensate = this.ledger.findTransactionEntries(parentTrx.bankTransactionId);
			else if (ledgerEntryId) {
				const entry = this.ledger.entries.find((e) => e.ledgerEntryId === ledgerEntryId);
				if (!entry) throw new EntityNotFoundError(`Did not find ledger-entry by id ${ledgerEntryId}`);
				entriesToCompensate.push(entry);
			} else if (loanDrawdownId) entriesToCompensate = this.ledger.entries.filter((e) => e.drawdownId === loanDrawdownId);
			entriesToCompensate.forEach((entry) => {
				const signedAmount = entry.totalAmount * -1;
				const newEntry = entry.copy({
					valueDate: entry.valueDate,
					debit: signedAmount < 0 ? Math.abs(signedAmount) : 0,
					credit: signedAmount > 0 ? Math.abs(signedAmount) : 0,
					entryGroup: "Storno",
					entryGroupType: "Storno"
				});
				entry.addChildren(newEntry);
			});
		}
		bookFeeRepayment({ amount, valueDate, bankTransactionId, isGroupedFee, isSingleFee, entryGroupType }) {
			if (!isGroupedFee && !isSingleFee) throw new InvalidParamsError(`Need to provide either isGroupedFee or isSingleFee when booking fee-payment-transaction`);
			if (isGroupedFee) {
				const dayBalanceRecord = this.ledger.findDayBalanceRecord(valueDate);
				if (!dayBalanceRecord) return;
				const commitmentFee = (dayBalanceRecord.accruedCommitmentFee ?? 0) - (dayBalanceRecord.paidCommitmentFee ?? 0);
				const interestFee = (dayBalanceRecord.accruedInterestFee ?? 0) - (dayBalanceRecord.paidInterestFee ?? 0);
				if (commitmentFee + interestFee !== amount) throw new ApplicationError("Amount of accrued fee does not match to transaction amount");
				if (commitmentFee) this.ledger.addFeeRepayment({
					amount,
					entryGroupType: LedgerEntryGroupType.Commitment,
					valueDate,
					bankTransactionId
				});
				if (interestFee) this.ledger.addFeeRepayment({
					amount,
					entryGroupType: LedgerEntryGroupType.Interest,
					valueDate,
					bankTransactionId
				});
			} else if (isSingleFee) {
				if (!entryGroupType) throw new InvalidParamsError(`When providing isSingleFee, you need to provide entryGroupType as well when  booking fee-payment-transaction`);
				this.ledger.addFeeRepayment({
					amount,
					entryGroupType,
					valueDate,
					bankTransactionId
				});
			}
		}
		/**
		*
		* @param {BankTransaction} transaction
		* @param {IAddBankTransactionData} data
		*/
		bookSellingIncome({ amount, valueDate, bankTransactionId, estateId }) {
			this.ledger.addLedgerEntry(this.ledger.createNewLedgerEntry({
				debit: amount < 0 ? Math.abs(amount) : 0,
				credit: amount > 0 ? Math.abs(amount) : 0,
				entryGroup: "Repayment",
				entryGroupType: LedgerEntryGroupType.Principal,
				entryType: "Cash",
				valueDate,
				estateId,
				bankTransactionId
			}));
		}
		toRequest() {
			return {
				...this,
				createdAt: void 0,
				updatedAt: void 0,
				createdUserId: void 0,
				drawdowns: void 0,
				ledger: void 0,
				bankAccount: void 0,
				portfolio: void 0,
				company: void 0,
				parentLoanAccount: void 0,
				childLoanAccount: void 0
			};
		}
	};
}));
//#endregion
//#region src/domains/finance/intergroup-loan-account.class.ts
var intergroup_loan_account_class_exports = /* @__PURE__ */ __exportAll({ IntergroupLoanAccount: () => IntergroupLoanAccount });
var IntergroupLoanAccount;
var init_intergroup_loan_account_class = __esmMin((() => {
	init_loan_account_class();
	IntergroupLoanAccount = class extends LoanAccount {};
}));
//#endregion
//#region src/domains/finance/investment/finance.i18n.en.ts
var rentCaseMapToPlainText;
var init_finance_i18n_en = __esmMin((() => {
	rentCaseMapToPlainText = {
		["FurnishedApartment"]: "Furnished",
		["FlatShare"]: "Shared",
		["Normal"]: "Normal"
	};
}));
//#endregion
//#region src/domains/finance/ledger/balance-record.model.ts
var init_balance_record_model = __esmMin((() => {}));
//#endregion
//#region src/domains/finance/ledger/general-ledger-statement/general-ledger-statement.model.ts
var init_general_ledger_statement_model = __esmMin((() => {}));
//#endregion
//#region src/domains/finance/ledger/general-ledger-statement/rent-tenancy-ledger-statement.class.ts
var fields, rentComponents, RentTenancyLedgerStatement;
var init_rent_tenancy_ledger_statement_class = __esmMin((() => {
	init_base();
	init_ledger_entry();
	init_rent_tenancy_ledger_statement_schema();
	fields = [
		"coldRent",
		"heatingCost",
		"utilityCost",
		"parkingSpaceRent",
		"invoices",
		"returnDebit",
		"annualServiceChargeStatement",
		"others"
	];
	rentComponents = [
		"coldRent",
		"heatingCost",
		"utilityCost",
		"parkingSpaceRent"
	];
	RentTenancyLedgerStatement = class RentTenancyLedgerStatement extends BaseEntity {
		static expectedFields = fields;
		static cashflowFields = fields;
		static balanceFields = fields;
		rentTenancyLedgerStatementId;
		month;
		rentTenancyId;
		generalLedgerId;
		expectedValues;
		cashflowValues;
		balanceValues;
		constructor(props) {
			super(props);
			Object.assign(this, props);
			this.expectedValues = Value.Default(RentTenancyLedgerStatementExpectedValuesSchema, Value.Clone(props.expectedValues ?? {}));
			this.cashflowValues = Value.Default(RentTenancyLedgerStatementCashflowValuesSchema, Value.Clone(props.cashflowValues ?? {}));
			this.balanceValues = Value.Default(RentTenancyLedgerStatementBalanceValuesSchema, Value.Clone(props.balanceValues ?? {}));
		}
		get totalExpected() {
			return RentTenancyLedgerStatement.getTotalExpected(this.expectedValues);
		}
		static getTotalExpected(expectedValues) {
			return safeSum(...Object.values(expectedValues));
		}
		get netChangeInCash() {
			return RentTenancyLedgerStatement.getNetChangeInCash(this.cashflowValues);
		}
		get totalBalance() {
			return RentTenancyLedgerStatement.getTotalBalance(this.balanceValues);
		}
		get rentBalance() {
			return safeSum(...Object.values(_pick(this.balanceValues, [...rentComponents, "returnDebit"])));
		}
		static getNetChangeInCash(cashflowValues) {
			return safeSum(...Object.values(_omit(cashflowValues, [
				"cashAtBeginningOfPeriod",
				"cashAtEndOfPeriod",
				"netChangeInCash"
			])));
		}
		static getTotalBalance(balanceValues) {
			return safeSum(...Object.values(balanceValues));
		}
		static createNew(props) {
			return new RentTenancyLedgerStatement({
				...props,
				expectedValues: {},
				cashflowValues: {},
				balanceValues: {}
			});
		}
		calculateValues(month, entries, previousMonthStatement) {
			if (typeof previousMonthStatement === "undefined") throw new Error(`Previous month statement is required (provided: ${extractDate(month)})`);
			const monthEntries = entries.filter((entry) => dayjs(entry.valueDate).isSame(month, "month"));
			const expectedValues = Value.Default(RentTenancyLedgerStatementExpectedValuesSchema, {});
			const cashflowValues = Value.Default(RentTenancyLedgerStatementCashflowValuesSchema, {});
			const balanceValues = Value.Default(RentTenancyLedgerStatementBalanceValuesSchema, {});
			balanceValues.coldRent = previousMonthStatement?.balanceValues.coldRent ?? 0;
			balanceValues.heatingCost = previousMonthStatement?.balanceValues.heatingCost ?? 0;
			balanceValues.utilityCost = previousMonthStatement?.balanceValues.utilityCost ?? 0;
			balanceValues.parkingSpaceRent = previousMonthStatement?.balanceValues.parkingSpaceRent ?? 0;
			balanceValues.invoices = previousMonthStatement?.balanceValues.invoices ?? 0;
			balanceValues.returnDebit = previousMonthStatement?.balanceValues.returnDebit ?? 0;
			balanceValues.annualServiceChargeStatement = previousMonthStatement?.balanceValues.annualServiceChargeStatement ?? 0;
			balanceValues.others = previousMonthStatement?.balanceValues.others ?? 0;
			monthEntries.forEach((entry) => {
				switch (entry.entryType) {
					case "Accrual":
						switch (entry.entryGroupType) {
							case LedgerEntryGroupType.ColdRent:
								expectedValues.coldRent += entry.totalAmount;
								balanceValues.coldRent += entry.totalAmount;
								break;
							case LedgerEntryGroupType.Utilities:
								expectedValues.utilityCost += entry.totalAmount;
								balanceValues.utilityCost += entry.totalAmount;
								break;
							case LedgerEntryGroupType.Heating:
								expectedValues.heatingCost += entry.totalAmount;
								balanceValues.heatingCost += entry.totalAmount;
								break;
							case LedgerEntryGroupType.Parking:
								expectedValues.parkingSpaceRent += entry.totalAmount;
								balanceValues.parkingSpaceRent += entry.totalAmount;
								break;
							case LedgerEntryGroupType.Invoice:
								expectedValues.invoices += entry.totalAmount;
								balanceValues.invoices += entry.totalAmount;
								break;
							case LedgerEntryGroupType.AnnualServiceChargeStatement:
								expectedValues.annualServiceChargeStatement += entry.totalAmount;
								balanceValues.annualServiceChargeStatement += entry.totalAmount;
								break;
							case LedgerEntryGroupType.ReturnDebit:
							case LedgerEntryGroupType.ReturnDebitFee:
								expectedValues.returnDebit += entry.totalAmount;
								balanceValues.returnDebit += entry.totalAmount;
								break;
							default:
								expectedValues.others += entry.totalAmount;
								balanceValues.others += entry.totalAmount;
								break;
						}
						break;
					case "Cash":
						switch (entry.entryGroupType) {
							case LedgerEntryGroupType.ColdRent:
								cashflowValues.coldRent += entry.totalAmount;
								balanceValues.coldRent += entry.totalAmount;
								break;
							case LedgerEntryGroupType.Utilities:
								cashflowValues.utilityCost += entry.totalAmount;
								balanceValues.utilityCost += entry.totalAmount;
								break;
							case LedgerEntryGroupType.Heating:
								cashflowValues.heatingCost += entry.totalAmount;
								balanceValues.heatingCost += entry.totalAmount;
								break;
							case LedgerEntryGroupType.Parking:
								cashflowValues.parkingSpaceRent += entry.totalAmount;
								balanceValues.parkingSpaceRent += entry.totalAmount;
								break;
							case LedgerEntryGroupType.Invoice:
								cashflowValues.invoices += entry.totalAmount;
								balanceValues.invoices += entry.totalAmount;
								break;
							case LedgerEntryGroupType.AnnualServiceChargeStatement:
								cashflowValues.annualServiceChargeStatement += entry.totalAmount;
								balanceValues.annualServiceChargeStatement += entry.totalAmount;
								break;
							case LedgerEntryGroupType.ReturnDebit:
							case LedgerEntryGroupType.ReturnDebitFee:
								cashflowValues.returnDebit += entry.totalAmount;
								balanceValues.returnDebit += entry.totalAmount;
								break;
							default:
								cashflowValues.others += entry.totalAmount;
								balanceValues.others += entry.totalAmount;
								break;
						}
						break;
				}
			});
			this.expectedValues = expectedValues;
			this.cashflowValues = cashflowValues;
			this.balanceValues = balanceValues;
		}
		static calculateGlobalTotals(allStatements, year) {
			const result = {
				expectedValues: {},
				cashflowValues: {},
				balanceValues: {}
			};
			if (!allStatements?.length) return result;
			const statements = allStatements.filter((s) => dayjs(s.month).year() <= year);
			const expectedValues = Value.Default(RentTenancyLedgerStatementExpectedValuesSchema, {});
			const cashflowValues = Value.Default(RentTenancyLedgerStatementCashflowValuesSchema, {});
			const balanceValues = Value.Default(RentTenancyLedgerStatementBalanceValuesSchema, {});
			const lastStatement = _maxBy(statements, (item) => new Date(item.month).getTime());
			Object.keys(expectedValues).forEach((key) => {
				result.expectedValues[key] = statements.reduce((acc, statement) => safeSum(acc, statement.expectedValues[key]), 0);
			});
			result.expectedValues.totalExpected = RentTenancyLedgerStatement.getTotalBalance({ ...result.expectedValues });
			Object.keys(cashflowValues).forEach((key) => {
				result.cashflowValues[key] = statements.reduce((acc, statement) => safeSum(acc, statement.cashflowValues[key]), 0);
			});
			result.cashflowValues.netChangeInCash = RentTenancyLedgerStatement.getNetChangeInCash(result.cashflowValues);
			Object.keys(balanceValues).forEach((key) => {
				result.balanceValues[key] = lastStatement?.balanceValues[key] ?? 0;
			});
			result.balanceValues.totalBalance = RentTenancyLedgerStatement.getTotalBalance({ ...result.balanceValues });
			return result;
		}
		getRentComponents() {
			return {
				cashflowValues: _pick(this.cashflowValues, rentComponents),
				expectedValues: _pick(this.expectedValues, rentComponents),
				balanceValues: _pick(this.balanceValues, rentComponents)
			};
		}
	};
}));
//#endregion
//#region src/domains/finance/ledger/general-ledger-statement/rent-tenancy-ledger-statement.i18n.ts
var rentTenancyLedgerStatementLabel;
var init_rent_tenancy_ledger_statement_i18n = __esmMin((() => {
	rentTenancyLedgerStatementLabel = {
		coldRent: "Cold Rent",
		utilityCost: "Utility Cost",
		heatingCost: "Heating Cost",
		parkingSpaceRent: "Parking Cost",
		invoices: "Invoices",
		returnDebit: "Return Debit",
		annualServiceChargeStatement: "BKA",
		others: "Others"
	};
}));
//#endregion
//#region src/domains/finance/ledger/general-ledger-statement/general-ledger-statement.opts.ts
var init_general_ledger_statement_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/finance/ledger/general-ledger-statement/index.ts
var init_general_ledger_statement = __esmMin((() => {
	init_general_ledger_statement_model();
	init_rent_tenancy_ledger_statement_class();
	init_rent_tenancy_ledger_statement_i18n();
	init_rent_tenancy_ledger_statement_schema();
	init_general_ledger_statement_opts();
}));
//#endregion
//#region src/domains/finance/ledger/property-management-common.ts
var RecoverPmLedgerAction, LedgerAccountingCheck, LedgerAccountingFix;
var init_property_management_common = __esmMin((() => {
	RecoverPmLedgerAction = /* @__PURE__ */ function(RecoverPmLedgerAction) {
		RecoverPmLedgerAction["RestoreAll"] = "RestoreAll";
		RecoverPmLedgerAction["Restore"] = "Restore";
		RecoverPmLedgerAction["RebookTransactions"] = "RebookTransactions";
		return RecoverPmLedgerAction;
	}({});
	LedgerAccountingCheck = /* @__PURE__ */ function(LedgerAccountingCheck) {
		LedgerAccountingCheck["IsEscrowAccount"] = "IsEscrowAccount";
		LedgerAccountingCheck["EscrowAccountDoesNotBelongToAnyContact"] = "EscrowAccountDoesNotBelongToAnyContact";
		LedgerAccountingCheck["EscrowAccountDoesNotBelongToAnyCompany"] = "EscrowAccountDoesNotBelongToAnyCompany";
		return LedgerAccountingCheck;
	}({});
	LedgerAccountingFix = /* @__PURE__ */ function(LedgerAccountingFix) {
		LedgerAccountingFix["CreateGeneralLedger"] = "CreateGeneralLedger";
		LedgerAccountingFix["TurnEscrowAccountToTenant"] = "TurnEscrowAccountToTenant";
		LedgerAccountingFix["SetLedgerTenancy"] = "SetLedgerTenancy";
		LedgerAccountingFix["SwitchLedgerTenancy"] = "SwitchLedgerTenancy";
		return LedgerAccountingFix;
	}({});
}));
//#endregion
//#region src/domains/finance/loan-account.opts.ts
var init_loan_account_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/finance/loan-drawdown.model.ts
var init_loan_drawdown_model = __esmMin((() => {}));
//#endregion
//#region src/domains/finance/loan-drawdown.opts.ts
var init_loan_drawdown_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/finance/rentable-units/rentable-unit-case.class.ts
var init_rentable_unit_case_class = __esmMin((() => {}));
//#endregion
//#region src/domains/finance/rentable-units/rentable-unit-case.opts.ts
var init_rentable_unit_case_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/finance/sales-package/sales-package.helpers.ts
var isSalesPackageOpenWithNoPartners, checkIfSalesPackageIsUpdatable;
var init_sales_package_helpers = __esmMin((() => {
	init_sales_package_model();
	isSalesPackageOpenWithNoPartners = (salesPackage) => !!salesPackage.isSalesPackageOpen && !salesPackage.distributionPartnerId && !salesPackage.secondaryDistributionPartners?.length;
	checkIfSalesPackageIsUpdatable = (salesPackage) => isSalesPackageOpenWithNoPartners(salesPackage) || ExclusiveOrHybridSalesPackageUpdatableStates.includes(salesPackage.state);
}));
//#endregion
//#region src/domains/finance/sales-package/index.ts
var init_sales_package = __esmMin((() => {
	init_sales_package_model();
	init_sales_package_helpers();
}));
//#endregion
//#region src/domains/finance/index.ts
var init_finance = __esmMin((() => {
	init_accounting_i18n();
	init_accounting_model();
	init_accounting_opts();
	init_bank_account_reconciler_rule();
	init_bank_account_reconciler_rule_helpers();
	init_bank_account_base();
	init_bank_account_class();
	init_bank_account_i18n();
	init_bank_account_model();
	init_bank_account_opts();
	init_bank_transaction_parsing();
	init_bank_transaction_class();
	init_bank_transaction_i18n();
	init_bank_transaction_model();
	init_bank_transaction_opts();
	init_banking();
	init_common();
	init_controlling_view();
	init_credit_line_portfolio();
	init_iban_data_model();
	init_intergroup_loan_account_class();
	init_investment();
	init_finance_i18n_en();
	init_invoice();
	init_balance_record_class();
	init_balance_record_model();
	init_bank_account_ledger_class();
	init_external_bank_account_ledger_class();
	init_general_ledger();
	init_investor_ledger();
	init_investor_ledger_statement();
	init_general_ledger_statement();
	init_ledger_entry();
	init_ledger_factory_class();
	init_loan_ledger_class();
	init_property_management_common();
	init_property_management_ledger_class();
	init_asset_ledger();
	init_loan_account_factory_class();
	init_loan_account_class();
	init_loan_account_model();
	init_loan_account_opts();
	init_loan_drawdown_model();
	init_loan_drawdown_opts();
	init_mezzanine_loan_account_class();
	init_portfolio();
	init_portfolio_loan_account_class();
	init_rentable_unit_case_class();
	init_rentable_unit_case_opts();
	init_sales_package();
	init_special_deal();
}));
//#endregion
//#region src/domains/renting/leads-management.ts
var RentingLeadStatus, LeadImpression, RentingLead, EmploymentContractType;
var init_leads_management = __esmMin((() => {
	init_base();
	init_cross_cutting();
	RentingLeadStatus = /* @__PURE__ */ function(RentingLeadStatus) {
		RentingLeadStatus["New"] = "New";
		RentingLeadStatus["Approved"] = "Approved";
		return RentingLeadStatus;
	}({});
	LeadImpression = /* @__PURE__ */ function(LeadImpression) {
		LeadImpression["Good"] = "Good";
		LeadImpression["Neutral"] = "Neutral";
		LeadImpression["Bad"] = "Bad";
		return LeadImpression;
	}({});
	RentingLead = class RentingLead extends BaseClassAttributes {
		rentingLeadId;
		/** @deprecated */
		estateId;
		addedUserId;
		rentingLeadStatus;
		visitedDate;
		movingInDate;
		leadImpression;
		note;
		rentingProcessId;
		contacts = [];
		companies = [];
		constructor(props) {
			super(props);
			Object.assign(this, props);
		}
		get pets() {
			return this.contacts.some((value) => !!value?.personalInfo?.pets);
		}
		get totalLeadIncome() {
			return this.contacts.reduce((prev, curr) => {
				return prev + (curr.personalInfo?.monthlyNetIncome ?? 0);
			}, 0);
		}
		get isDeletable() {
			return this.rentingLeadStatus !== "Approved";
		}
		get isApproved() {
			return this.rentingLeadStatus === "Approved";
		}
		toggleStatus() {
			this.rentingLeadStatus = this.isApproved ? "New" : "Approved";
		}
		rentPercentage(monthlyRent) {
			return round$1(monthlyRent / this.totalLeadIncome, 4);
		}
		get name() {
			return RentingLead.getRentingLeadName(this);
		}
		static getRentingLeadName(lead) {
			let names = "";
			if (lead.contacts) names += `${lead.contacts.map((contact) => getPartyDisplayName({ contact })).join(", ")} `;
			if (lead.companies) names += `${lead.companies.map((company) => getPartyDisplayName({ company })).join(", ")} `;
			return names;
		}
	};
	EmploymentContractType = /* @__PURE__ */ function(EmploymentContractType) {
		EmploymentContractType["Limited"] = "Limited";
		EmploymentContractType["Unlimited"] = "Unlimited";
		return EmploymentContractType;
	}({});
}));
//#endregion
//#region src/__unsorted/mixed.ts
function translateStoreRooms(commonRoom) {
	return Array.isArray(commonRoom) ? commonRoom.map((r) => StoreRoomTranslations[r]) : StoreRoomTranslations[commonRoom];
}
function translateCommonRooms(commonRoom) {
	return Array.isArray(commonRoom) ? commonRoom.map((r) => CommonRoomTranslations[r]) : CommonRoomTranslations[commonRoom];
}
var StoreRoomTranslations, CommonRoomTranslations, PartnerName, CondoEntity, MachineType, FilterType, FileCategory, BatchActions;
var init_mixed = __esmMin((() => {
	StoreRoomTranslations = {
		["Basement"]: "Kellerraum",
		["Attic"]: "Dachbodenraum",
		["InsideApartment"]: "Abstellraum in der Wohnung"
	};
	CommonRoomTranslations = {
		["BikeRoom"]: "Fahrradraum",
		["LaundryRoom"]: "Waschküche",
		["DryingRoom"]: "Trockenraum"
	};
	PartnerName = /* @__PURE__ */ function(PartnerName) {
		PartnerName["IMMO24"] = "IMMO24";
		return PartnerName;
	}({});
	CondoEntity = /* @__PURE__ */ function(CondoEntity) {
		CondoEntity["Estate"] = "Estate";
		CondoEntity["Process"] = "Process";
		CondoEntity["User"] = "User";
		CondoEntity["Investment"] = "Investment";
		CondoEntity["RentTenancy"] = "RentTenancy";
		return CondoEntity;
	}({});
	MachineType = /* @__PURE__ */ function(MachineType) {
		MachineType["Estate"] = "Estate";
		MachineType["Purchasing"] = "Purchasing";
		MachineType["Renovation"] = "Renovation";
		MachineType["Renting"] = "Renting";
		MachineType["Selling"] = "Selling";
		MachineType["Sourcing"] = "Sourcing";
		MachineType["PropertyManagement"] = "PropertyManagement";
		MachineType["TenantManagement"] = "TenantManagement";
		MachineType["OwnerManagement"] = "OwnerManagement";
		MachineType["EstateManagement"] = "EstateManagement";
		MachineType["RentableUnit"] = "RentableUnit";
		return MachineType;
	}({});
	FilterType = /* @__PURE__ */ function(FilterType) {
		FilterType["Estate"] = "Estate";
		FilterType["AllEstates"] = "AllEstates";
		return FilterType;
	}({});
	FileCategory = /* @__PURE__ */ function(FileCategory) {
		FileCategory["Document"] = "Document";
		FileCategory["MediaFile"] = "MediaFile";
		return FileCategory;
	}({});
	BatchActions = /* @__PURE__ */ function(BatchActions) {
		BatchActions["RevertExportedToPartner"] = "RevertExportedToPartner";
		BatchActions["ReScore"] = "ReScore";
		return BatchActions;
	}({});
}));
//#endregion
//#region src/domains/finance/reconciler-rule.factory.ts
var ReconcilerRuleName, BankFeeRuleAmounts, txIsWithinObjectDateRange, resolveInvestorInfoIdByEscrowAccount, resolveTenancyId, ReconcilerRuleFactory;
var init_reconciler_rule_factory = __esmMin((() => {
	init_bank_transaction_model();
	dayjs.extend(isBetween);
	dayjs.extend(isSameOrAfter);
	ReconcilerRuleName = /* @__PURE__ */ function(ReconcilerRuleName) {
		return ReconcilerRuleName;
	}({});
	BankFeeRuleAmounts = [
		3,
		9,
		27
	];
	txIsWithinObjectDateRange = (pmObject, transaction) => {
		const txDate = dayjs(transaction.valueDate);
		if (pmObject.endDate) return txDate.isBetween(dayjs(pmObject.startDate), dayjs(pmObject.endDate), "d", "[]");
		return txDate.isSameOrAfter(dayjs(pmObject.startDate));
	};
	resolveInvestorInfoIdByEscrowAccount = (bankAccount) => {
		const matchingInvestorInfos = bankAccount.investorInfo?.filter((ii) => ii.escrowBankAccountId === bankAccount.bankAccountId);
		if (matchingInvestorInfos?.length === 1) return matchingInvestorInfos[0].investorInfoId;
	};
	resolveTenancyId = ({ bankAccount, rentTenancies }) => {
		const matchingTenancyIds = rentTenancies?.filter((tenancy) => {
			if (tenancy.tenantBankAccount?.bankAccountId === bankAccount.bankAccountId) return true;
			return tenancy.tenancyMembers?.some(({ contact, company }) => {
				if ((contact?.contactId ? contact?.bankAccounts : company?.ownedBankAccounts)?.some((ba) => ba.bankAccountId === bankAccount.bankAccountId)) return true;
				return false;
			});
		}).map((tenancy) => tenancy.rentTenancyId);
		const uniqueIds = uniq(matchingTenancyIds);
		if (uniqueIds.length !== 1) return;
		return uniqueIds[0];
	};
	ReconcilerRuleFactory = class {
		static create(ruleName, _params) {
			switch (ruleName) {
				default: return;
			}
		}
		static getStaticRules() {
			return [
				{
					name: "static/hoaExpense",
					ruleGroup: {
						kind: "extended",
						condition: "and",
						rules: [
							{
								kind: "extended",
								label: "Transaction is an expense",
								field: "transaction.isCredit",
								type: "boolean",
								operator: "equal",
								value: false
							},
							{
								kind: "extended",
								label: "Issuer-BA is an escrow-account",
								field: "issuerBankAccount.isEscrowAccount",
								type: "boolean",
								operator: "equal",
								value: true
							},
							{
								kind: "extended",
								label: "Transaction is HOA-fee related",
								field: "hints.description.isHOAExpense",
								type: "boolean",
								operator: "equal",
								value: true
							}
						]
					},
					assignments: [{
						type: "transaction-extended",
						values: {
							categoryType: "HouseGeld",
							investorInfoId: (ctx) => {
								let investorInfoId = resolveInvestorInfoIdByEscrowAccount(ctx.statementAccount);
								if (!investorInfoId) {
									const matchingInvestorInfos = ctx.statementAccount.investorInfo?.filter((ii) => txIsWithinObjectDateRange(ii, ctx.transaction) || ii.endDate && dayjs(ii.endDate).isSame(dayjs(ctx.transaction.valueDate), "month"));
									if (matchingInvestorInfos?.length === 1) investorInfoId = matchingInvestorInfos[0].investorInfoId;
								}
								return investorInfoId;
							}
						}
					}]
				},
				{
					name: "static/managementFee",
					ruleGroup: {
						kind: "extended",
						condition: "and",
						rules: [
							{
								kind: "extended",
								label: "Transaction is an expense",
								field: "transaction.isCredit",
								type: "boolean",
								operator: "equal",
								value: false
							},
							{
								kind: "extended",
								label: "Issuer-BA is an escrow-account",
								field: "issuerBankAccount.isEscrowAccount",
								type: "boolean",
								operator: "equal",
								value: true
							},
							{
								kind: "extended",
								label: "Transaction is management-fee related",
								field: "hints.description.isManagementFee",
								type: "boolean",
								operator: "equal",
								value: true
							}
						]
					},
					assignments: [{
						type: "transaction-extended",
						values: {
							categoryType: "ManagementFee",
							investorInfoId: (ctx) => resolveInvestorInfoIdByEscrowAccount(ctx.statementAccount)
						}
					}]
				},
				{
					name: "static/ancillary",
					ruleGroup: {
						kind: "extended",
						condition: "and",
						rules: [{
							kind: "extended",
							label: "Transaction is ancillary-costs related",
							field: "hints.description.isAncillaryCosts",
							type: "boolean",
							operator: "equal",
							value: true
						}]
					},
					assignments: [{
						type: "transaction-extended",
						values: { categoryType: "AncillaryCosts" }
					}]
				},
				{
					name: "static/bankFee",
					ruleGroup: {
						kind: "extended",
						condition: "and",
						rules: [
							{
								kind: "extended",
								label: "Transaction is an expense",
								field: "transaction.isCredit",
								type: "boolean",
								operator: "equal",
								value: false
							},
							{
								kind: "extended",
								label: "Issuer-BA is an escrow-account",
								field: "issuerBankAccount.isEscrowAccount",
								type: "boolean",
								operator: "equal",
								value: true
							},
							{
								kind: "extended",
								label: "Target-BA is a bank-service-account",
								field: "targetBankAccount.isBankServiceAccount",
								type: "boolean",
								operator: "equal",
								value: true
							},
							{
								kind: "extended",
								label: "Transaction is bank-fee related",
								field: "hints.description.isBankFee",
								type: "boolean",
								operator: "equal",
								value: true
							}
						]
					},
					assignments: [{
						type: "transaction-extended",
						values: {
							categoryType: "BankFee",
							investorInfoId: (ctx) => resolveInvestorInfoIdByEscrowAccount(ctx.statementAccount)
						}
					}]
				},
				{
					name: "static/rentDeposit",
					ruleGroup: {
						kind: "extended",
						condition: "and",
						rules: [
							{
								kind: "extended",
								label: "Transaction is credit",
								field: "transaction.isCredit",
								type: "boolean",
								operator: "equal",
								value: true
							},
							{
								kind: "extended",
								label: "Target-BA is an rent-deposit-account",
								field: "targetBankAccount.isRentDeposit",
								type: "boolean",
								operator: "equal",
								value: true
							},
							{
								kind: "extended",
								label: "Transaction is rent-deposit related",
								field: "hints.description.isRentDeposit",
								type: "boolean",
								operator: "equal",
								value: true
							}
						]
					},
					assignments: [{
						type: "transaction-extended",
						values: {
							categoryType: "RentDeposit",
							rentTenancyId: (ctx) => resolveTenancyId({
								statementBankAccount: ctx.statementAccount,
								bankAccount: ctx.issuerBankAccount,
								rentTenancies: ctx.rentTenancies ?? []
							})
						}
					}]
				},
				{
					name: "static/rentTenancy",
					ruleGroup: {
						kind: "extended",
						condition: "and",
						rules: [{
							kind: "extended",
							label: "Transaction is a credit",
							field: "transaction.isCredit",
							type: "boolean",
							operator: "equal",
							value: true
						}, {
							kind: "extended",
							label: "Target-BA is an escrow-account",
							field: "targetBankAccount.isEscrowAccount",
							type: "boolean",
							operator: "equal",
							value: true
						}]
					},
					assignments: [{
						type: "transaction-extended",
						values: { 
						/**
						* we have an incoming transaction to our account (e.g. escrow-account) and, the source is one of the registered
						* tenant's ibans
						*/
rentTenancyId: (ctx) => resolveTenancyId({
							statementBankAccount: ctx.targetBankAccount,
							bankAccount: ctx.issuerBankAccount,
							rentTenancies: ctx.rentTenancies ?? []
						}) }
					}]
				},
				{
					name: "static/rent",
					ruleGroup: {
						kind: "extended",
						condition: "and",
						rules: [
							{
								kind: "extended",
								label: "Transaction is a credit",
								field: "transaction.isCredit",
								type: "boolean",
								operator: "equal",
								value: true
							},
							{
								kind: "extended",
								label: "Target-BA is an escrow-account",
								field: "targetBankAccount.isEscrowAccount",
								type: "boolean",
								operator: "equal",
								value: true
							},
							{
								kind: "extended",
								label: "Transaction is rent related",
								field: "hints.description.isRent",
								type: "boolean",
								operator: "equal",
								value: true
							}
						]
					},
					assignments: [{
						type: "transaction-extended",
						values: { categoryType: "Rent" }
					}]
				},
				{
					name: "static/investorIncome",
					ruleGroup: {
						kind: "extended",
						condition: "and",
						rules: [
							{
								kind: "extended",
								label: "Transaction is an expense",
								field: "transaction.isCredit",
								type: "boolean",
								operator: "equal",
								value: false
							},
							{
								kind: "extended",
								label: "Issuer-BA is an escrow-account",
								field: "issuerBankAccount.isEscrowAccount",
								type: "boolean",
								operator: "equal",
								value: true
							},
							{
								kind: "extended",
								label: "Transaction is investor-income related",
								field: "hints.description.isInvestorIncome",
								type: "boolean",
								operator: "equal",
								value: true
							}
						]
					},
					assignments: [{
						type: "transaction-extended",
						values: {
							categoryType: "InvestorIncome",
							investorInfoId: (ctx) => resolveInvestorInfoIdByEscrowAccount(ctx.statementAccount)
						}
					}]
				},
				{
					name: "static/investorInfo-outgoing",
					ruleGroup: {
						kind: "extended",
						condition: "and",
						rules: [{
							kind: "extended",
							label: "Transaction is a debit",
							field: "transaction.isCredit",
							type: "boolean",
							operator: "equal",
							value: false
						}, {
							kind: "extended",
							label: "Target-BA is an investor-account",
							field: "targetBankAccount.isInvestorAccount",
							type: "boolean",
							operator: "equal",
							value: true
						}]
					},
					assignments: [{
						type: "transaction-extended",
						values: { 
						/**
						* we have an outgoing transaction from our account (e.g. escrow-account) and the target is an investor's account
						* -> take the investorInfoId from the target
						*/
investorInfoId: (ctx) => {
							return (ctx.targetBankAccount.investorInfo?.find((ii) => ii.investorBankAccountId === ctx.targetBankAccount.bankAccountId))?.investorInfoId;
						} }
					}]
				},
				{
					name: "static/investorInfo-incoming",
					ruleGroup: {
						kind: "extended",
						condition: "and",
						rules: [{
							kind: "extended",
							label: "Transaction is a credit",
							field: "transaction.isCredit",
							type: "boolean",
							operator: "equal",
							value: true
						}, {
							kind: "extended",
							label: "Target-BA is an escrow-account",
							field: "targetBankAccount.isEscrowAccount",
							type: "boolean",
							operator: "equal",
							value: true
						}]
					},
					assignments: [{
						type: "transaction-extended",
						values: { 
						/**
						* we have an incoming transaction to our account (e.g. escrow-account)
						* -> take the first-investor-info if there is only one, otherwise we cannot safely infer the correct investor
						*/
investorInfoId: (ctx) => {
							if (ctx.targetBankAccount.investorInfo?.length === 1) return ctx.targetBankAccount.investorInfo[0].investorInfoId;
						} }
					}]
				}
			];
		}
	};
}));
//#endregion
//#region src/domains/renting/renting-listing.class.ts
var RentingListing;
var init_renting_listing_class = __esmMin((() => {
	init_base();
	init_media_file();
	RentingListing = class RentingListing extends BaseClassAttributes {
		rentingListingId;
		estateId;
		rentableUnitId;
		rentingProcessId;
		rentingProcess;
		estate;
		notes;
		title;
		descriptionNote;
		furnishingNote;
		locationNote;
		freeFrom;
		monthlyColdRent;
		serviceCharge;
		heatingCosts;
		externalId;
		providers;
		attachments = [];
		mediaTags = ["publish"];
		constructor(rentingListing) {
			super(rentingListing);
			if (rentingListing) {
				Object.assign(this, rentingListing);
				if (rentingListing.freeFrom) this.freeFrom = new Date(rentingListing.freeFrom);
			}
		}
		get isComplete() {
			return [
				this.title,
				this.descriptionNote,
				this.furnishingNote,
				this.locationNote,
				this.serviceCharge,
				this.heatingCosts,
				this.monthlyColdRent
			].every((p) => !isNil(p));
		}
		get providersWithoutErrors() {
			return this.providers.every((p) => p.dataProblems ? p.dataProblems.length === 0 : true);
		}
		isProviderWithoutErrors(provider) {
			return this.providers.find((p) => p.provider === provider)?.dataProblems?.length === 0;
		}
		get hasFloorplan() {
			return this.attachments.some((attachment) => attachment.internalTags?.some((tag) => tag === "floor-plan"));
		}
		setProviderPreview(provider, missingDataFields, mappedDataFields, uploadedAttachments) {
			const dataProblems = this.hasFloorplan ? missingDataFields : missingDataFields.concat("floorPlanAvailable");
			const dataPreview = this.hasFloorplan ? {
				...mappedDataFields,
				floorPlanAvailable: true
			} : mappedDataFields;
			return {
				...provider,
				dataPreview,
				dataProblems,
				attachments: uploadedAttachments
			};
		}
		extend(overrides) {
			return new RentingListing({
				...this,
				...overrides
			});
		}
		toRequest() {
			return {
				rentingListingId: this.rentingListingId,
				rentableUnitId: this.rentableUnitId,
				estateId: this.estateId,
				title: this.title,
				descriptionNote: this.descriptionNote,
				furnishingNote: this.furnishingNote,
				locationNote: this.locationNote,
				freeFrom: this.freeFrom,
				heatingCosts: this.heatingCosts,
				serviceCharge: this.serviceCharge,
				monthlyColdRent: this.monthlyColdRent,
				mediaTags: this.mediaTags
			};
		}
	};
}));
//#endregion
//#region src/domains/renting/hoaFee/hoa-fee.class.ts
var HoaFee;
var init_hoa_fee_class = __esmMin((() => {
	init_base_period_class();
	dayjs.extend(isBetween);
	dayjs.extend(minMax);
	dayjs.extend(isSameOrBefore);
	HoaFee = class extends BasePeriodClass {
		hoaFeeId;
		estateId;
		amount;
		users;
		constructor(props) {
			super(props);
			Object.assign(this, props);
		}
	};
}));
//#endregion
//#region src/domains/renting/hoaFee/hoa-fee.model.ts
var init_hoa_fee_model = __esmMin((() => {}));
//#endregion
//#region src/domains/renting/hoaFee/hoa-fee.schema.ts
var BaseHoaFeeSchema, hoaFeeSchemas;
var init_hoa_fee_schema = __esmMin((() => {
	init_lib();
	BaseHoaFeeSchema = Type.Object({
		hoaFeeId: Type.Optional(Type.Number()),
		estateId: Type.Number(),
		amount: Type.Number(),
		startDate: RequiredStringDateSchema,
		endDate: Type.Optional(StringDateSchema),
		users: Type.Optional(Type.Partial(Type.Object({
			createdBy: Type.String(),
			updatedBy: Type.String()
		})))
	}, { $id: "BaseHoaFee" });
	hoaFeeSchemas = { BaseHoaFeeSchema };
}));
//#endregion
//#region src/domains/renting/hoaFee/index.ts
var init_hoaFee = __esmMin((() => {
	init_hoa_fee_class();
	init_hoa_fee_model();
	init_hoa_fee_schema();
}));
//#endregion
//#region src/domains/renting/investor-info.i18n.ts
var specialDealHints;
var init_investor_info_i18n = __esmMin((() => {
	specialDealHints = {
		exemptMaintenanceReserve: `Reneo takes over non-transferable Wohngeld + Wohngeld Reserve for the selected duration.
                        Reneo will pay this amount even if it is raised over time.`,
		exemptPropertyManagementMonthlyCosts: `Reneo takes over the payment of SEV fees for the selected duration`,
		specialDealHasRepaymentSubsidy: `Reneo will payback the entered percentage of the purchase price per year.
                        Example: Tilgungszuschuss of 2.4% results in increasing the investor share by 0.2% of purchase price per month.`
	};
}));
//#endregion
//#region src/domains/renting/investor-info.model.ts
var init_investor_info_model = __esmMin((() => {}));
//#endregion
//#region src/domains/renting/investor-info.opts.ts
var init_investor_info_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/renting/investor-share-helpers.ts
var applyInvestorShareOperations;
var init_investor_share_helpers = __esmMin((() => {
	init_errors();
	applyInvestorShareOperations = (investorShareAmount, investorShareOperationRows) => {
		let total = investorShareAmount;
		investorShareOperationRows.forEach((investorShareOperationRow) => {
			if (investorShareOperationRow.operator === "Sub") total -= investorShareOperationRow.amount;
			else if (investorShareOperationRow.operator === "Add") total += investorShareOperationRow.amount;
			else throw new UnsupportedError(`Operation is not supported`);
		});
		return total;
	};
}));
//#endregion
//#region src/domains/renting/investor-yearly-payout/investor-yearly-payout.model.ts
var InvestorYearlyPayoutStatus;
var init_investor_yearly_payout_model = __esmMin((() => {
	InvestorYearlyPayoutStatus = /* @__PURE__ */ function(InvestorYearlyPayoutStatus) {
		InvestorYearlyPayoutStatus["Open"] = "Open";
		InvestorYearlyPayoutStatus["Verified"] = "Verified";
		InvestorYearlyPayoutStatus["Sent"] = "Sent";
		return InvestorYearlyPayoutStatus;
	}({});
}));
//#endregion
//#region src/domains/renting/investor-yearly-payout/investor-yearly-payout.class.ts
var InvestorYearlyPayout;
var init_investor_yearly_payout_class = __esmMin((() => {
	init_errors();
	init_investor_ledger_statement();
	init_investor_info_class();
	init_rent_helpers();
	dayjs.extend(isBetween);
	InvestorYearlyPayout = class {
		investorYearlyPayoutId;
		investorInfoId;
		status;
		year;
		rents = [];
		statementValues = [];
		manualAdjustments = { operations: [] };
		documentId;
		emailNote;
		sentAt;
		createdAt;
		updatedAt;
		investorInfo;
		document;
		constructor(props) {
			Object.assign(this, props);
			if (props.investorInfo) this.investorInfo = new InvestorInfo(props.investorInfo);
		}
		get isOpen() {
			return this.status === "Open";
		}
		get isInProgress() {
			return ["Verified"].includes(this.status);
		}
		get isDone() {
			return ["Sent"].includes(this.status);
		}
		getYearlyBreakdown() {
			if (!this.investorInfo) throw new InvariantError("Investor Info is required to calculate yearly breakdown", { investorYearlyPayoutId: this.investorYearlyPayoutId });
			const startOfYear = /* @__PURE__ */ new Date(`${this.year}-01-01`);
			const endOfYear = /* @__PURE__ */ new Date(`${this.year}-12-31`);
			const result = {
				revenues: {},
				expenses: {},
				investorIncome: {},
				liquidityReserve: 0,
				totalRevenueExpected: 0,
				totalRevenueActual: 0,
				totalExpenseExpected: 0,
				totalExpenseActual: 0,
				totalPayout: 0
			};
			const rentsLabels = this.rents.reduce((list, rent) => {
				const rentStartDates = dayjs(rent.startDate).isBefore(this.investorInfo.startDate, "month") && dayjs(rent.startDate).isSame(this.investorInfo.startDate, "year") ? dayjs(this.investorInfo.startDate).toDate() : dayjs(rent.startDate).isBefore(startOfYear, "year") ? startOfYear : rent.startDate;
				const rentEndDate = this.investorInfo.endDate && rent.endDate && dayjs(rent.endDate).isAfter(this.investorInfo.endDate, "month") && dayjs(rent.endDate).isSame(this.investorInfo.endDate, "year") ? this.investorInfo.endDate : !rent.endDate || dayjs(rent.endDate).isAfter(endOfYear, "year") ? endOfYear : rent.endDate;
				let currentDate = new Date(rentStartDates);
				while (currentDate <= new Date(rentEndDate)) {
					const key = dayjs(currentDate).startOf("month").format("YYYY-MM-DD");
					if (!list[key]) list[key] = this.getRentLabel(rent, {
						startDate: new Date(rentStartDates),
						endDate: new Date(rentEndDate)
					});
					currentDate = new Date(currentDate.setMonth(currentDate.getMonth() + 1));
				}
				return list;
			}, {});
			const excludedKeys = ["liquidityReserve"];
			this.statementValues.filter((s) => dayjs(s.month).isBetween(dayjs(this.investorInfo.startDate), dayjs(this.investorInfo.endDate || endOfYear), "month", "[]")).forEach((statement) => {
				const month = dayjs(statement.month).format("YYYY-MM-DD");
				const periodKey = this.getRentPeriodKey(month, rentsLabels);
				Object.entries(statement.incomeValues).forEach(([key, amount]) => {
					if (excludedKeys.includes(key)) return;
					switch (key) {
						case "rentRevenue":
							this.ensureBreakdownValue(result.revenues, "rentRevenue");
							if (!result.revenues.rentRevenue?.periods) result.revenues.rentRevenue.periods = {};
							if (periodKey) {
								this.ensureBreakdownValue(result.revenues.rentRevenue.periods, periodKey);
								result.revenues.rentRevenue.periods[periodKey].expect += amount;
							}
							result.revenues.rentRevenue.expect += amount;
							break;
						case "investorPayout": break;
						case "hoaFeeSettlementRevenue":
						case "hoaFeeSettlementExpense":
							this.ensureBreakdownValue(result.expenses, "hoaFeeSettlementExpense");
							result.expenses.hoaFeeSettlementExpense.expect += amount * (key === "hoaFeeSettlementRevenue" ? 1 : -1);
							break;
						default:
							if (InvestorLedgerStatement.revenueFields.includes(key)) {
								this.ensureBreakdownValue(result.revenues, key);
								result.revenues[key].expect += amount;
							}
							if (InvestorLedgerStatement.expenseFields.includes(key)) {
								this.ensureBreakdownValue(result.expenses, key);
								result.expenses[key].expect += amount * -1;
							}
							break;
					}
				});
				Object.entries(statement.cashflowValues).forEach(([key, amount]) => {
					if (excludedKeys.includes(key) || !InvestorLedgerStatement.cashflowFields.includes(key)) return;
					switch (key) {
						case "rentalIncome":
						case "parkingIncome":
							if (periodKey) result.revenues.rentRevenue.periods[periodKey].actual += amount;
							result.revenues.rentRevenue.actual += amount;
							break;
						case "rentalGuarantee":
							this.ensureBreakdownValue(result.revenues, "rentalGuarantee");
							result.revenues.rentalGuarantee.actual += amount;
							break;
						case "loanAmortizationSubsidy":
							result.revenues.loanAmortizationSubsidy.actual += amount;
							break;
						case "hoaFeeSubsidy":
							result.revenues.hoaFeeSubsidy.actual += amount;
							break;
						case "hoaFee":
							result.expenses.hoaFeeExpense.actual += amount;
							break;
						case "managementFee":
							result.expenses.managementFeeExpense.actual += amount;
							break;
						case "propertyTax":
							result.expenses.propertyTaxExpense.actual += amount;
							break;
						case "bankFees":
						case "bankFeeSubsidy":
						case "returnDebit":
							result.expenses.bankFeesExpense.actual += amount;
							break;
						case "invoices":
							result.expenses.invoiceExpense.actual += amount;
							break;
						case "investorIncome":
							result.investorIncome[month] = amount * -1;
							break;
						case "hoaFeeSettlement":
							result.expenses.hoaFeeSettlementExpense.actual += amount;
							break;
						default: {
							const fieldsMap = {
								bka: ["bkaIncome", "bkaExpense"],
								otherCashflow: ["otherRevenues", "otherExpenses"]
							};
							const [revenueField, expenseField] = fieldsMap[key] || fieldsMap.otherCashflow;
							if (amount > 0) result.revenues[revenueField].actual += amount;
							else result.expenses[expenseField].actual += amount;
							break;
						}
					}
				});
			});
			if (this.manualAdjustments) {
				if (this.manualAdjustments.operations?.length) applyManualAdjustments(this.manualAdjustments.operations, result);
				if (this.manualAdjustments.excludeOtherExpenses) {
					result.expenses.otherExpenses.expect = 0;
					result.expenses.otherExpenses.actual = 0;
				}
				if (this.manualAdjustments.excludeOtherRevenues) {
					result.revenues.otherRevenues.expect = 0;
					result.revenues.otherRevenues.actual = 0;
				}
			}
			Object.values(result.expenses).forEach((val) => {
				result.totalExpenseExpected += val.expect ?? 0;
				result.totalExpenseActual += val.actual ?? 0;
			});
			Object.values(result.revenues).forEach((val) => {
				result.totalRevenueExpected += val.expect ?? 0;
				result.totalRevenueActual += val.actual ?? 0;
			});
			result.totalPayout = safeSum(...Object.values(result.investorIncome));
			return result;
		}
		getRentLabel(rent, resolvedRentDates) {
			const label = [`${formatDate$1(resolvedRentDates.startDate, DateFormats.SimpleDate)} - ${formatDate$1(resolvedRentDates.endDate, DateFormats.SimpleDate)}`, "mtl."];
			if (rent.coldRent) label.push(`Kaltmiete: ${currency(rent.coldRent)}`);
			if (rent.utilityCost) label.push(`Nebenkosten: ${currency(rent.utilityCost)}`);
			if (rent.heatingCost) label.push(`Heizkosten: ${currency(rent.heatingCost)}`);
			if (rent.parkingSpaceRent) label.push(`Stellplatzmiete: ${currency(rent.parkingSpaceRent)}`);
			return label.join(", ");
		}
		ensureBreakdownValue(value, key) {
			if (!value[key]) value[key] = {
				expect: 0,
				actual: 0
			};
		}
		getRentPeriodKey(month, rentsLabels) {
			let periodKey = rentsLabels[month];
			if (!periodKey) {
				const closestRent = this.findClosestRent(new Date(month));
				if (closestRent) periodKey = rentsLabels[dayjs(closestRent.startDate).format("YYYY-MM-DD")];
			}
			return periodKey;
		}
		findClosestRent(date) {
			const rents = this.rents.sort((a, b) => dayjs(a.startDate).diff(dayjs(b.startDate), "month"));
			if (!rents.length) return null;
			if (dayjs(date).isBefore(dayjs(rents[0].startDate), "month")) return rents[0];
			if (dayjs(date).isAfter(dayjs(rents[rents.length - 1].endDate), "month")) return rents[rents.length - 1];
			let closestRent = rents[0];
			let minDiff = Number.POSITIVE_INFINITY;
			for (const rent of rents) {
				if (dayjs(date).isSame(dayjs(rent.startDate), "month") || dayjs(date).isSame(dayjs(rent.endDate), "month")) return rent;
				if (dayjs(date).isBetween(dayjs(rent.startDate), dayjs(rent.endDate), "month", "[]")) return rent;
				const startDiff = Math.abs(dayjs(date).diff(dayjs(rent.startDate), "month"));
				if (startDiff < minDiff) {
					minDiff = startDiff;
					closestRent = rent;
				}
				const endDiff = Math.abs(dayjs(date).diff(dayjs(rent.endDate), "month"));
				if (endDiff < minDiff) {
					minDiff = endDiff;
					closestRent = rent;
				}
			}
			return closestRent;
		}
	};
}));
//#endregion
//#region src/domains/renting/investor-yearly-payout/investor-yearly-payout.opts.ts
var init_investor_yearly_payout_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/renting/manual-adjustments.schema.ts
var InvestorShareOperationEnumSchema, ManualAdjustmentsRowSchema;
var init_manual_adjustments_schema = __esmMin((() => {
	init_lib();
	init_monthly_investor_share();
	InvestorShareOperationEnumSchema = TEnum(InvestorShareOperationEnumKey, { $id: "InvestorShareOperationEnum" });
	ManualAdjustmentsRowSchema = Type.Object({
		amount: Type.Number(),
		operator: TEnum(InvestorShareOperator),
		note: Type.Optional(Type.String()),
		key: Type.Optional(Type.Ref(InvestorShareOperationEnumSchema)),
		isFreetext: Type.Optional(Type.Boolean()),
		isExpectedValue: Type.Optional(Type.Boolean())
	}, { $id: "ManualAdjustmentsRow" });
}));
//#endregion
//#region src/domains/renting/investor-yearly-payout/investor-yearly-payout.schema.ts
var InvestorYearlyPayoutRentPartialSchema, InvestorYearlyPayoutStatusSchema, ManualAdjustmentsSchema, BaseInvestorYearlyPayoutSchema, InvestorYearlyPayoutSchema;
var init_investor_yearly_payout_schema = __esmMin((() => {
	init_lib();
	init_investor_ledger_statement();
	init_manual_adjustments_schema();
	init_investor_yearly_payout_model();
	InvestorYearlyPayoutRentPartialSchema = Type.Object({
		rentId: Type.Number(),
		startDate: TDate,
		endDate: TDate,
		coldRent: Type.Number(),
		heatingCost: Type.Number(),
		utilityCost: Type.Number(),
		parkingSpaceRent: Type.Number()
	}, { $id: "InvestorYearlyPayoutRentPartial" });
	InvestorYearlyPayoutStatusSchema = TEnum(InvestorYearlyPayoutStatus, { $id: "InvestorYearlyPayoutStatus" });
	ManualAdjustmentsSchema = Type.Object({
		operations: Type.Array(Type.Ref(ManualAdjustmentsRowSchema)),
		excludeOtherExpenses: Type.Optional(Type.Boolean()),
		excludeOtherRevenues: Type.Optional(Type.Boolean())
	}, { $id: "ManualAdjustments" });
	BaseInvestorYearlyPayoutSchema = Type.Object({
		investorYearlyPayoutId: Type.Number(),
		investorInfoId: Type.Number(),
		documentId: Type.Optional(TNullable(Type.Number())),
		status: Type.Ref(InvestorYearlyPayoutStatusSchema),
		year: Type.Integer({
			minimum: 1900,
			maximum: 2100
		}),
		rents: Type.Array(Type.Ref(InvestorYearlyPayoutRentPartialSchema)),
		manualAdjustments: TNullable(Type.Ref(ManualAdjustmentsSchema)),
		statementValues: Type.Array(Type.Object({
			month: TDate,
			cashflowValues: Type.Ref(InvestorLedgerStatementCashflowValuesSchema),
			incomeValues: Type.Ref(InvestorLedgerStatementIncomeValuesSchema)
		})),
		emailNote: Type.Optional(TNullable(Type.String())),
		sentAt: Type.Optional(StringDateSchema),
		createdAt: StringDateSchema,
		updatedAt: Type.Optional(StringDateSchema)
	}, { $id: "BaseInvestorYearlyPayout" });
	InvestorYearlyPayoutSchema = Type.Intersect([Type.Ref(BaseInvestorYearlyPayoutSchema), Type.Object({
		document: Type.Optional(Type.Unsafe(Type.Record(Type.String(), Type.Any()))),
		investorInfo: Type.Optional(Type.Unsafe(Type.Record(Type.String(), Type.Any())))
	})], { $id: "InvestorYearlyPayout" });
}));
//#endregion
//#region src/domains/renting/investor-yearly-payout/index.ts
var init_investor_yearly_payout = __esmMin((() => {
	init_investor_yearly_payout_class();
	init_investor_yearly_payout_model();
	init_investor_yearly_payout_opts();
	init_investor_yearly_payout_schema();
}));
//#endregion
//#region src/domains/renting/monthly-rent-guarantee.opts.ts
var init_monthly_rent_guarantee_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/renting/pm-documents.model.ts
var init_pm_documents_model = __esmMin((() => {}));
//#endregion
//#region src/domains/renting/rent-arrear-notice.model.ts
var init_rent_arrear_notice_model = __esmMin((() => {}));
//#endregion
//#region src/domains/renting/rent-arrear-notice.opts.ts
var init_rent_arrear_notice_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/renting/rent-cpi.class.ts
var RentCPI;
var init_rent_cpi_class = __esmMin((() => {
	RentCPI = class {
		rentCpiId;
		index;
		month;
		year;
		monthChange;
		yearChange;
		constructor(data) {
			Object.assign(this, data);
		}
		get indexDate() {
			return dayjs(`${this.year}-${this.month}-01`).format("YYYY-MM-DD");
		}
	};
}));
//#endregion
//#region src/domains/renting/rent-cpi.model.ts
var init_rent_cpi_model = __esmMin((() => {}));
//#endregion
//#region src/domains/renting/rent-tenancy.i18n.ts
var tenantSupportCategoryTranslation, tenantSupportSubCategoryTranslation;
var init_rent_tenancy_i18n = __esmMin((() => {
	init_rent_tenancy_model();
	tenantSupportCategoryTranslation = {
		["RepairApartment"]: "Reparatur Wohnung",
		["QuestionAboutApartment"]: "Fragen zur Mietsache",
		["Contract"]: "Vertragsverhältnis",
		["Payments"]: "Zahlungen",
		["Invoices"]: "Abrechnung"
	};
	tenantSupportSubCategoryTranslation = {
		["Other"]: "Sonstiges",
		["Interior"]: "Einrichtung",
		["WaterOrHeatingOrSanitary"]: "Wasser/Heizung/Sanitär",
		["Electric"]: "Elektro",
		["InternetOrCableOrTV"]: "Internet/Kabelanschluss/TV",
		["HumidityOrMold"]: "Feuchtigkeit/Schimmel",
		["PaintingOrWalls"]: "Malerarbeiten/Wände",
		["SmokeDetectorOrHeatCostAllocator"]: "Rauchwarnmelder/Heizkostenverteiler",
		["DoorbellOrLetterbox"]: "Klingelanlage/Briefkasten",
		["DoorsOrWindows"]: "Türen/Fenster",
		["Handover"]: "Wohnungsübergabe",
		["Keys"]: "Schlüssel",
		["MeterReadings"]: "Zählerstände",
		["BalconyOrTerrace"]: "Balkon/Terrasse",
		["Cellar"]: "Keller",
		["Parking"]: "Stellplatz/Garage",
		["RentalContract"]: "Mietvertrag",
		["HandoverProtocol"]: "Übergabeprotokoll",
		["Termination"]: "Kündigungen",
		["LandlordConfirmation"]: "Wohnungsgeberbestätigung",
		["RentPayments"]: "Mietzahlungen",
		["AncillaryCostBilling"]: "Nebenkostenabrechnung",
		["IBANChange"]: "IBAN ändern"
	};
}));
//#endregion
//#region src/domains/renting/rent-tenancy.opts.ts
var init_rent_tenancy_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/renting/rent.opts.ts
var init_rent_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/renting/renting-detail.ts
var rentingPriorities;
var init_renting_detail = __esmMin((() => {
	init_processes();
	rentingPriorities = [
		{
			value: 0,
			sellingState: [
				"FMReceived",
				"Paid",
				"HandoverDone",
				"Completed"
			],
			rentableUnitState: ["Vacant", "PartiallyOccupied"],
			tenantManagementState: [
				"TerminationNoticeReceived",
				"TerminationInitiated",
				"TerminationAccepted",
				"Terminated"
			],
			rentCase: [],
			renovationState: []
		},
		{
			value: 1,
			sellingState: ["Notarized"],
			rentableUnitState: ["Vacant", "PartiallyOccupied"],
			tenantManagementState: [
				"TerminationNoticeReceived",
				"TerminationInitiated",
				"TerminationAccepted",
				"Terminated"
			],
			rentCase: [],
			renovationState: []
		},
		{
			value: 2,
			sellingState: ["DraftApproved"],
			rentableUnitState: ["Vacant", "PartiallyOccupied"],
			tenantManagementState: [],
			rentCase: [],
			renovationState: []
		},
		{
			value: 3,
			sellingState: [
				"Identified",
				"SellingPartnerPrepared",
				"SellingPartnerMandated",
				"OnMarket",
				"OfferReceived",
				"OfferAccepted",
				"NotaryDraftReceived"
			],
			rentableUnitState: ["Vacant", "PartiallyOccupied"],
			tenantManagementState: [],
			rentCase: [],
			renovationState: []
		},
		{
			value: 4,
			sellingState: [],
			rentableUnitState: [],
			tenantManagementState: [],
			rentCase: [],
			renovationState: []
		}
	];
}));
//#endregion
//#region src/domains/renting/renting-lead.opts.ts
var init_renting_lead_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/renting/rental-contract-unit/rental-contract-unit.opts.ts
var init_rental_contract_unit_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/renting/rental-contract-unit/index.ts
var init_rental_contract_unit = __esmMin((() => {
	init_rental_contract_unit_model();
	init_rental_contract_unit_opts();
	init_rental_contract_unit_class();
}));
//#endregion
//#region src/domains/renting/rentable-unit-state-from-renting-process.ts
/**
* When {@link RentingStates.Blocked}, map to {@link RentableUnitStates.BlockedByPm} vs {@link RentableUnitStates.BlockedByRenovation}
* using `attributes.onHoldReason` (aligned with `migrate_rup_to_rp.ts` / `calculateRentableUnitStateFromLatestProcess`).
*/
function mapBlockedRentingProcessToRentableUnitState(process) {
	const onHoldReason = process.attributes?.onHoldReason;
	return onHoldReason && RENOVATION_ON_HOLD_REASONS_FOR_RENTING.has(onHoldReason) ? "BlockedByRenovation" : "BlockedByPm";
}
/** Single-unit aggregate from latest renting process (migration / RUP sync semantics). */
function rentableUnitStateFromLatestRentingProcess(latestRentingProcess) {
	if (!latestRentingProcess) return "Vacant";
	const state = latestRentingProcess.processState.state;
	if (finalRentingStates.includes(state)) return state === "OwnerOccupied" ? "OwnerOccupied" : "Occupied";
	if (state === "Blocked") return mapBlockedRentingProcessToRentableUnitState(latestRentingProcess);
	return "Vacant";
}
var RENOVATION_ON_HOLD_REASONS_FOR_RENTING;
var init_rentable_unit_state_from_renting_process = __esmMin((() => {
	init_renovation_model();
	init_renting_model();
	RENOVATION_ON_HOLD_REASONS_FOR_RENTING = new Set(Object.values(RenovationOnHoldReason));
}));
//#endregion
//#region src/domains/renting/index.ts
var init_renting = __esmMin((() => {
	init_annual_service_charge_statement();
	init_hoaFee();
	init_investor_info_class();
	init_investor_info_i18n();
	init_investor_info_model();
	init_investor_info_opts();
	init_investor_share_helpers();
	init_investor_yearly_payout();
	init_manual_adjustments_schema();
	init_monthly_investor_share();
	init_monthly_rent_guarantee_model();
	init_monthly_rent_guarantee_opts();
	init_pm_documents_model();
	init_rent_arrear_notice_model();
	init_rent_arrear_notice_opts();
	init_rent_cpi_class();
	init_rent_cpi_model();
	init_rent_helpers();
	init_rent_tenancy_class();
	init_rent_tenancy_i18n();
	init_rent_tenancy_model();
	init_rent_tenancy_opts();
	init_rent_class();
	init_rent_model();
	init_rent_opts();
	init_rentable_unit();
	init_rental_contract();
	init_renting_detail();
	init_renting_lead_opts();
	init_rental_contract_unit();
	init_rentable_unit_state_from_renting_process();
}));
//#endregion
//#region src/__unsorted/requests.ts
var GoogleSignedUrlConfigVersions, GoogleSignedUrlConfigActions, RenderDocumentResultSchema;
var init_requests$1 = __esmMin((() => {
	init_lib();
	GoogleSignedUrlConfigVersions = /* @__PURE__ */ function(GoogleSignedUrlConfigVersions) {
		GoogleSignedUrlConfigVersions["v2"] = "v2";
		GoogleSignedUrlConfigVersions["v4"] = "v4";
		return GoogleSignedUrlConfigVersions;
	}({});
	GoogleSignedUrlConfigActions = /* @__PURE__ */ function(GoogleSignedUrlConfigActions) {
		GoogleSignedUrlConfigActions["read"] = "read";
		GoogleSignedUrlConfigActions["write"] = "write";
		GoogleSignedUrlConfigActions["delete"] = "delete";
		GoogleSignedUrlConfigActions["resumable"] = "resumable";
		return GoogleSignedUrlConfigActions;
	}({});
	RenderDocumentResultSchema = Type.Object({
		mainDoc: TStringEnum([
			"doc",
			"pdf",
			"xls"
		]),
		docResult: Type.Object({ files: Type.Object({
			doc: Type.Optional(Type.Unsafe(Type.Ref("OutputDocument"))),
			pdf: Type.Optional(Type.Unsafe(Type.Ref("OutputDocument"))),
			xls: Type.Optional(Type.Unsafe(Type.Ref("OutputDocument")))
		}) })
	});
}));
//#endregion
//#region src/domains/transaction/selling-region.model.ts
var init_selling_region_model = __esmMin((() => {}));
//#endregion
//#region src/domains/transaction/payment-notice-summary/payment-notice-summary.model.ts
var PaymentNoticeSummaryState;
var init_payment_notice_summary_model = __esmMin((() => {
	PaymentNoticeSummaryState = /* @__PURE__ */ function(PaymentNoticeSummaryState) {
		PaymentNoticeSummaryState["NotReadyForPayment"] = "NotReadyForPayment";
		PaymentNoticeSummaryState["ReadyForReview"] = "ReadyForReview";
		PaymentNoticeSummaryState["ReadyForPayment"] = "ReadyForPayment";
		return PaymentNoticeSummaryState;
	}({});
}));
//#endregion
//#region src/domains/transaction/payment-notice-summary/payment-notice-summary.class.ts
var PaymentNoticeSummary;
var init_payment_notice_summary_class = __esmMin((() => {
	init_base();
	init_company();
	PaymentNoticeSummary = class PaymentNoticeSummary extends BaseEntity {
		paymentNoticeSummaryId;
		estateId;
		state;
		purchasingPrice;
		specialInterestStart;
		specialInterestAmountPerDay;
		bankInterestAdjustment;
		sellerInterestAdjustment;
		estate;
		paymentOrders;
		constructor(props) {
			super(props);
			Object.assign(this, props);
		}
		static createFromList(paymentNoticeSummaries) {
			return paymentNoticeSummaries.map((pm) => new PaymentNoticeSummary(pm));
		}
		get executionDate() {
			return min(this.paymentOrders?.map((pr) => pr.requestedExecutionDate));
		}
		get specialInterestSum() {
			if (!this.executionDate || !this.specialInterestStart || !this.specialInterestAmountPerDay) return 0;
			const specialInterestSum = (dayjs(this.executionDate).diff(this.specialInterestStart, "day") + 1) * this.specialInterestAmountPerDay;
			return Math.max(0, specialInterestSum);
		}
		getPaymentOrderInterestAdjustment(paymentOrder) {
			switch (this.getPaymentOrderCreditorType(paymentOrder)) {
				case "Bank": return this.bankInterestAdjustment;
				case "Contact":
				case "Company": return this.sellerInterestAdjustment;
				default: return;
			}
		}
		getPaymentOrderCreditorType(paymentOrder) {
			if (paymentOrder.creditorContactId) return "Contact";
			if (paymentOrder.creditorCompany) return paymentOrder.creditorCompany.type === "Bank" ? "Bank" : "Company";
		}
	};
}));
//#endregion
//#region src/domains/transaction/payment-notice-summary/payment-notice-summary.opts.ts
var init_payment_notice_summary_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/transaction/payment-notice-summary/index.ts
var init_payment_notice_summary = __esmMin((() => {
	init_payment_notice_summary_model();
	init_payment_notice_summary_class();
	init_payment_notice_summary_opts();
}));
//#endregion
//#region src/domains/transaction/payment-order/payment-order.model.ts
var PaymentOrderType;
var init_payment_order_model = __esmMin((() => {
	PaymentOrderType = /* @__PURE__ */ function(PaymentOrderType) {
		PaymentOrderType["PaymentNotice"] = "PaymentNotice";
		return PaymentOrderType;
	}({});
}));
//#endregion
//#region src/domains/cross-cutting/errors/payment-order/index.ts
var PaymentOrderWithMultipleCreditorsError, PaymentOrderAccountOwnerCompanyMissingError, PaymentOrderAccountOwnerCompanyIsNotABankError, CreditorAccountOwnerContactNotPresentError;
var init_payment_order$1 = __esmMin((() => {
	PaymentOrderWithMultipleCreditorsError = class extends Error {
		message;
		innerError;
		constructor(message, innerError) {
			super(innerError?.message ?? message);
			this.message = message;
			this.innerError = innerError;
		}
	};
	PaymentOrderAccountOwnerCompanyMissingError = class extends Error {
		message;
		innerError;
		constructor(message, innerError) {
			super(innerError?.message ?? message);
			this.message = message;
			this.innerError = innerError;
		}
	};
	PaymentOrderAccountOwnerCompanyIsNotABankError = class extends Error {
		message;
		innerError;
		constructor(message, innerError) {
			super(innerError?.message ?? message);
			this.message = message;
			this.innerError = innerError;
		}
	};
	CreditorAccountOwnerContactNotPresentError = class extends Error {
		message;
		innerError;
		constructor(message, innerError) {
			super(innerError?.message ?? message);
			this.message = message;
			this.innerError = innerError;
		}
	};
}));
//#endregion
//#region src/domains/transaction/payment-order/payment-order.class.ts
var PaymentOrder;
var init_payment_order_class = __esmMin((() => {
	init_base();
	init_company();
	init_errors();
	init_payment_order$1();
	PaymentOrder = class extends BaseClassAttributes {
		paymentOrderId;
		type;
		estateId;
		paymentNoticeSummaryId;
		creditorContactId;
		creditorCompanyId;
		creditorBankAccountId;
		creditorAccountOwnerContactId;
		debtorCompanyId;
		debtorBankAccountId;
		amount;
		adjustment;
		adjustedAmount;
		currency;
		requestedExecutionDate;
		remittanceInfo;
		isExcludedFromSpecialInterest;
		creditorContact;
		creditorCompany;
		creditorBankAccount;
		creditorAccountOwnerContact;
		debtor;
		debtorBankAccount;
		estate;
		paymentNoticeSummary;
		constructor(props) {
			super(props);
			this.validateProps(props);
			Object.assign(this, props);
		}
		validateProps(props) {
			if (props.creditorCompanyId && props.creditorContactId || !props.creditorCompanyId && !props.creditorContactId) throw new PaymentOrderWithMultipleCreditorsError("PaymentOrder should have one creditor");
			if (props.creditorAccountOwnerContactId && !props.creditorCompanyId) throw new PaymentOrderAccountOwnerCompanyMissingError("PaymentOrder creditor should be a company when creditor accounter owner is present");
			if (props.creditorAccountOwnerContactId && props.creditorCompany && props.creditorCompany.type !== "Bank") throw new PaymentOrderAccountOwnerCompanyIsNotABankError("Only banks should have an creditor account owner");
		}
		get typeShortname() {
			switch (this.type) {
				/**
				* @note the prefix 'FM' comes from the type paymentNotice. In future this has to be extended
				* for more payment-order-types
				*/
				case "PaymentNotice": return "FM";
				default: throw new InvariantError("Unknown payment-order-type. Right now only PaymentNotice is allowed");
			}
		}
		get debtorName() {
			if (!this.debtor?.name) throw new InvariantError("Provided debtor has no name, please fill out missing info");
			return this.debtor.name;
		}
		get creditorName() {
			if (this?.creditorAccountOwnerContact?.contactId && this.creditorCompany?.companyId) {
				if (!this?.creditorAccountOwnerContact) throw new CreditorAccountOwnerContactNotPresentError("Cannot get correct creditorName because creditorAccountOwnerContact relations is not present");
				const contact = this.creditorAccountOwnerContact;
				if (contact.firstname && contact.lastname) return [contact.firstname, contact.lastname].join(" ");
				throw new InvariantError("Provided account owner has no firstname & lastname, please fill out missing info");
			}
			if (this.creditorContact?.contactId) {
				const contact = this.creditorContact;
				if (contact.firstname && contact.lastname) return [contact.firstname, contact.lastname].join(" ");
				throw new InvariantError("Provided contact has no firstname & lastname, please fill out missing info");
			}
			if (this.creditorCompany?.companyId) {
				const company = this.creditorCompany;
				if (company.name) return company.name;
				throw new InvariantError("Provided company has no name, please fill out missing info");
			}
			throw new InvariantError("Was not able to infer creditor-name from payment-order relations");
		}
		getDefaultFileName(estate) {
			return `${this.typeShortname}_${estate.condoUuid ?? estate.estateId}_${this.debtorName}_${this.creditorName}`;
		}
	};
}));
//#endregion
//#region src/domains/transaction/payment-order/payment-order.opts.ts
var init_payment_order_opts = __esmMin((() => {}));
//#endregion
//#region src/domains/transaction/payment-order/index.ts
var init_payment_order = __esmMin((() => {
	init_payment_order_model();
	init_payment_order_class();
	init_payment_order_opts();
}));
//#endregion
//#region src/domains/sales-portal/auth0.ts
var UserState, SalesPortalPartner, SalesPortalUserRole, SalesPortalVisibleFeaturesMetadataOption, salesPortalVisibleFeaturesMetadataOptionLabels;
var init_auth0$1 = __esmMin((() => {
	UserState = /* @__PURE__ */ function(UserState) {
		UserState["SignUp"] = "SignUp";
		UserState["Review"] = "Review";
		UserState["Active"] = "Active";
		return UserState;
	}({});
	SalesPortalPartner = /* @__PURE__ */ function(SalesPortalPartner) {
		SalesPortalPartner["Generic"] = "Generic";
		SalesPortalPartner["SwissLife"] = "SwissLife";
		return SalesPortalPartner;
	}({});
	SalesPortalUserRole = /* @__PURE__ */ function(SalesPortalUserRole) {
		SalesPortalUserRole["Admin"] = "Admin";
		SalesPortalUserRole["Internal"] = "Internal";
		SalesPortalUserRole["External"] = "External";
		return SalesPortalUserRole;
	}({});
	SalesPortalVisibleFeaturesMetadataOption = /* @__PURE__ */ function(SalesPortalVisibleFeaturesMetadataOption) {
		SalesPortalVisibleFeaturesMetadataOption["estateDetailsPageSpecialInfoSection"] = "estateDetailsPageSpecialInfoSection";
		return SalesPortalVisibleFeaturesMetadataOption;
	}({});
	salesPortalVisibleFeaturesMetadataOptionLabels = { ["estateDetailsPageSpecialInfoSection"]: "Sales Package Special Info Section in Estates Details Page" };
}));
//#endregion
//#region src/domains/sales-portal/requests.ts
var init_requests = __esmMin((() => {}));
//#endregion
//#region src/domains/sales-portal/estate.data.ts
var SP_DOCUMENT_TYPES_WITH_MULTIPLE_DOCUMENT_ALLOWED, SALES_PORTAL_ALLOWED_DOCUMENT_TYPES, SALES_PORTAL_SALES_PACKAGE_ALLOWED_DOCUMENT_TYPES, SALES_PORTAL_SELLING_REGION_ALLOWED_DOCUMENT_TYPES, docsSectionsTranslation, isEstateShowingOnSalesPortal;
var init_estate_data = __esmMin((() => {
	init_document();
	init_processes();
	init_finance();
	SP_DOCUMENT_TYPES_WITH_MULTIPLE_DOCUMENT_ALLOWED = [
		"Protocol2024",
		"Protocol2025",
		"ArchiveOfResolutions",
		"InvitationETV",
		"BuildingInsurance",
		"ConstructionBurdenStatement",
		"DeclarationOfCondominium",
		"AmendmentToDeclarationOfDivision",
		"AllowanceOfEntrySectionII",
		"PartitionPlan",
		"ConstructionDescriptionBuilding",
		"BuildingPermit",
		"SellingRegionBrochure"
	];
	SALES_PORTAL_ALLOWED_DOCUMENT_TYPES = {
		["General"]: [
			"SellingExpose",
			"PromotionExpose",
			"SellingCalculations",
			"EnergyCertificate",
			"SellingResidualValueCertificate",
			"SellingExpertReport",
			"SellingAbstractOfTitle",
			"LandRegisterParkingSpace",
			"BuildingInsurance",
			"PropertyTaxNotice",
			"ConstructionBurdenStatement",
			"DeclarationOfCondominium",
			"SeparationDeclaration",
			"PartitionPlan",
			"LandRegisterMap",
			"ArchiveOfResolutions",
			"EconomicPlan",
			"HomeOwnerFeeStatement",
			"AnnualStatement",
			"ManagementAgreement",
			"Protocol2024",
			"Protocol2025",
			"Protocol2026",
			"ProtocolArchived",
			"HouseRules",
			"RentContract",
			"InvitationETV",
			"AmendmentToDeclarationOfDivision",
			"AllowanceOfEntrySectionII",
			"ConstructionDescriptionBuilding",
			"BuildingPermit",
			"ViewsAndSections"
		],
		["Renovation"]: [
			"ConstructionDescriptionRenovation",
			"BeforeAfterPictures",
			"PostRenovationDimensionedFloorPlan",
			"SalesPartnerFloorPlan",
			"LivingSpaceCalculations",
			"KitchenContracted",
			"BathPlan",
			"RoomVolumeCalculation"
		],
		["Marketing"]: []
	};
	SALES_PORTAL_SALES_PACKAGE_ALLOWED_DOCUMENT_TYPES = { ["SalesPackage"]: [
		"SalesPackageUserUploadedPriceList",
		"SalesPackageUserUploadedDataSheet",
		"SalesPackageUserUploadedChecklist",
		"SalesPackageUserUploadedPhotoAlbum"
	] };
	SALES_PORTAL_SELLING_REGION_ALLOWED_DOCUMENT_TYPES = { ["SalesPackage"]: ["SellingRegionBrochure"] };
	docsSectionsTranslation = {
		["General"]: "Objektunterlagen",
		["Renovation"]: "Sanierungsunterlagen",
		["SalesPackage"]: "Paketunterlagen",
		["Marketing"]: "Musterverträge"
	};
	isEstateShowingOnSalesPortal = (estate) => {
		const approvedSellingInvestmentCase = estate.investmentCases?.find((ic) => ic.investmentCaseType === "Selling" && ic.state === "Approved");
		return estate.location?.regionId && estate.salesPackage?.visibleInSalesPortal && estate.selling?.processState?.state !== "Completed" && approvedSellingInvestmentCase?.expectedSalesPrice;
	};
}));
//#endregion
//#region src/domains/sales-portal/user.helpers.ts
var isAdminOrInternalUser, isAdminUser;
var init_user_helpers = __esmMin((() => {
	isAdminOrInternalUser = (user) => ["Admin", "Internal"].some((r) => user?.app_metadata?.role === r);
	isAdminUser = (user) => user?.app_metadata?.role === "Admin";
}));
//#endregion
//#region src/domains/sales-portal/sp-document.model.ts
var SalesPortalDocumentType;
var init_sp_document_model = __esmMin((() => {
	SalesPortalDocumentType = /* @__PURE__ */ function(SalesPortalDocumentType) {
		SalesPortalDocumentType["ProfitabilityCalculationSpreadsheet"] = "ProfitabilityCalculationSpreadsheet";
		return SalesPortalDocumentType;
	}({});
}));
//#endregion
//#region src/domains/sales-portal/document-request.model.ts
var DocumentRequestStatus;
var init_document_request_model = __esmMin((() => {
	DocumentRequestStatus = /* @__PURE__ */ function(DocumentRequestStatus) {
		DocumentRequestStatus["New"] = "New";
		DocumentRequestStatus["InProgress"] = "InProgress";
		DocumentRequestStatus["DoneInternally"] = "DoneInternally";
		DocumentRequestStatus["Completed"] = "Completed";
		return DocumentRequestStatus;
	}({});
}));
//#endregion
//#region src/domains/sales-portal/index.ts
var init_sales_portal = __esmMin((() => {
	init_auth0$1();
	init_requests();
	init_estate_data();
	init_user_helpers();
	init_sp_document_model();
	init_document_request_model();
}));
//#endregion
//#region src/domains/raas/raas-user.model.ts
var RaasUserType;
var init_raas_user_model = __esmMin((() => {
	RaasUserType = /* @__PURE__ */ function(RaasUserType) {
		RaasUserType["Admin"] = "Admin";
		RaasUserType["Employee"] = "Employee";
		RaasUserType["Customer"] = "Customer";
		return RaasUserType;
	}({});
}));
//#endregion
//#region src/domains/raas/renovation-project.model.ts
var RenovationProjectStatus, RenovationProjectPurpose, RenovationProjectSource, RenovationStandard, interiorQualityToStandardMap, RenovationProjectEvents, RENOVATION_PROJECT_DEFAULT_CONSTRUCTION_YEAR;
var init_renovation_project_model = __esmMin((() => {
	init_estates();
	RenovationProjectStatus = /* @__PURE__ */ function(RenovationProjectStatus) {
		RenovationProjectStatus["Created"] = "Created";
		RenovationProjectStatus["PendingPredictions"] = "PendingPredictions";
		RenovationProjectStatus["PredictionRequested"] = "PredictionRequested";
		RenovationProjectStatus["ConsultationScheduled"] = "ConsultationScheduled";
		RenovationProjectStatus["ConsultationDone"] = "ConsultationDone";
		RenovationProjectStatus["InitialOfferMade"] = "InitialOfferMade";
		RenovationProjectStatus["InitialOfferAccepted"] = "InitialOfferAccepted";
		RenovationProjectStatus["FinalOfferMade"] = "FinalOfferMade";
		RenovationProjectStatus["FinalOfferAccepted"] = "FinalOfferAccepted";
		RenovationProjectStatus["InRenovation"] = "InRenovation";
		RenovationProjectStatus["RenovationCompleted"] = "RenovationCompleted";
		RenovationProjectStatus["InvoiceSent"] = "InvoiceSent";
		RenovationProjectStatus["InvoicePaid"] = "InvoicePaid";
		RenovationProjectStatus["Completed"] = "Completed";
		RenovationProjectStatus["Cancelled"] = "Cancelled";
		return RenovationProjectStatus;
	}({});
	RenovationProjectPurpose = /* @__PURE__ */ function(RenovationProjectPurpose) {
		RenovationProjectPurpose["Sale"] = "Sale";
		RenovationProjectPurpose["Rent"] = "Rent";
		return RenovationProjectPurpose;
	}({});
	RenovationProjectSource = /* @__PURE__ */ function(RenovationProjectSource) {
		RenovationProjectSource["Manual"] = "Manual";
		RenovationProjectSource["AppForm"] = "AppForm";
		return RenovationProjectSource;
	}({});
	RenovationStandard = /* @__PURE__ */ function(RenovationStandard) {
		RenovationStandard["Basic"] = "Basic";
		RenovationStandard["Classic"] = "Classic";
		RenovationStandard["Plus"] = "Plus";
		RenovationStandard["Exclusive"] = "Exclusive";
		return RenovationStandard;
	}({});
	interiorQualityToStandardMap = {
		["Simple"]: "Basic",
		["Normal"]: "Classic",
		["Sophisticated"]: "Plus",
		["Luxury"]: "Exclusive"
	};
	RenovationProjectEvents = /* @__PURE__ */ function(RenovationProjectEvents) {
		RenovationProjectEvents["StartPrediction"] = "StartPrediction";
		RenovationProjectEvents["PredictionRequested"] = "PredictionRequested";
		RenovationProjectEvents["ConsultationScheduled"] = "ConsultationScheduled";
		RenovationProjectEvents["ConsultationDone"] = "ConsultationDone";
		RenovationProjectEvents["InitialOfferMade"] = "InitialOfferMade";
		RenovationProjectEvents["InitialOfferAccepted"] = "InitialOfferAccepted";
		RenovationProjectEvents["FinalOfferMade"] = "FinalOfferMade";
		RenovationProjectEvents["FinalOfferAccepted"] = "FinalOfferAccepted";
		RenovationProjectEvents["RenovationStarted"] = "RenovationStarted";
		RenovationProjectEvents["RenovationCompleted"] = "RenovationCompleted";
		RenovationProjectEvents["InvoiceSent"] = "InvoiceSent";
		RenovationProjectEvents["InvoicePaid"] = "InvoicePaid";
		RenovationProjectEvents["Completed"] = "Completed";
		RenovationProjectEvents["Cancelled"] = "Cancelled";
		RenovationProjectEvents["Restart"] = "Restart";
		return RenovationProjectEvents;
	}({});
	RENOVATION_PROJECT_DEFAULT_CONSTRUCTION_YEAR = 1950;
}));
//#endregion
//#region src/domains/raas/renovation-project-lead.model.ts
var init_renovation_project_lead_model = __esmMin((() => {}));
//#endregion
//#region src/domains/raas/construction-case.model.ts
var activeSnapshotIgnoredFields;
var init_construction_case_model = __esmMin((() => {
	activeSnapshotIgnoredFields = [
		"constructionCaseId",
		"renovationProjectPredictionId",
		"documentLinks",
		"activeSnapshot",
		"lastActivatedByUserId",
		"lastActivatedAt",
		"activeSnapshot",
		"constructionDescription",
		"renovationProjectPrediction",
		"activatedRenovationProject",
		"lastActivatedByUser",
		"notes",
		"config"
	];
}));
//#endregion
//#region src/domains/raas/raas-base.model.ts
var RaasBaseClassAttributes;
var init_raas_base_model = __esmMin((() => {
	RaasBaseClassAttributes = class {
		createdAt;
		updatedAt;
		constructor(props) {
			Object.assign(this, props);
		}
	};
}));
//#endregion
//#region src/domains/raas/renovation-project-prediction.class.ts
var RenovationProjectPrediction;
var init_renovation_project_prediction_class = __esmMin((() => {
	init_errors();
	init_estates();
	init_construction_case_class();
	init_raas_base_model();
	init_renovation_project_class();
	RenovationProjectPrediction = class extends RaasBaseClassAttributes {
		renovationProjectPredictionId;
		renovationProjectId;
		salePricePerSqmBefore;
		salePricePerSqmAfter;
		rentPricePerSqmBefore;
		rentPricePerSqmAfter;
		size;
		margin;
		profit;
		calculatedRenovationCosts;
		generalRenovationCosts;
		kitchenRenovationCosts;
		roomChangeCosts;
		bathroomCosts;
		guestToiletCosts;
		electricalCosts;
		electricalCostsBudget;
		strategy;
		interiorQuality;
		numberOfRooms;
		hasKitchen;
		numberOfBathrooms;
		hasStorageRoom;
		hasGuestToilet;
		isLatest;
		raw;
		relativeRenovationCostsPercentage;
		renovationProject;
		constructionCases;
		config;
		regionConfig;
		constructor(renovationProjectPrediction, config) {
			super(renovationProjectPrediction);
			Object.assign(this, {
				margin: config?.profitabilityMargin,
				...renovationProjectPrediction
			});
			if (renovationProjectPrediction.renovationProject) {
				this.renovationProject = new RenovationProject(renovationProjectPrediction.renovationProject);
				if (this.renovationProject.region?.regionConfig) this.regionConfig = this.renovationProject.region.regionConfig;
			}
			if (renovationProjectPrediction.constructionCases) this.constructionCases = renovationProjectPrediction.constructionCases.map((constructionCase) => new ConstructionCase(constructionCase));
			this.config = config;
		}
		calculate() {
			if (!this.config || !this.regionConfig) throw new InvariantError("No config provided to calculate renovation project prediction");
			this.assignRenovationCosts();
			this.assignConstructionCaseFields();
			return this;
		}
		assignRenovationCosts() {
			const apartmentSize = this.getApartmentSize();
			const electricalPercentage = this.getElectricalPercentage();
			const configSizesInSqm = Object.keys(this.regionConfig.generalRenovationCosts).map(Number);
			const minConfigSize = Math.min(...configSizesInSqm);
			const maxConfigSize = Math.max(...configSizesInSqm);
			let apartmentSizeInSqm = Math.round(this.size);
			if (apartmentSizeInSqm < minConfigSize) apartmentSizeInSqm = minConfigSize;
			else if (apartmentSizeInSqm > maxConfigSize) apartmentSizeInSqm = maxConfigSize;
			const configGeneralRenovationCosts = this.regionConfig.generalRenovationCosts[apartmentSizeInSqm][this.interiorQuality] ?? 0;
			if (!configGeneralRenovationCosts) throw new InvariantError(`No general renovation costs found for apartment size ${apartmentSize} and interior quality ${this.interiorQuality}`);
			const baseGeneralRenovationCosts = configGeneralRenovationCosts * this.size;
			this.generalRenovationCosts = baseGeneralRenovationCosts * (1 - electricalPercentage);
			const baseBathroomCosts = (this.regionConfig.bathroomRenovationCosts[apartmentSize][this.interiorQuality] ?? 0) * this.numberOfBathrooms;
			this.bathroomCosts = baseBathroomCosts * (1 - electricalPercentage);
			this.kitchenRenovationCosts = this.hasKitchen ? this.regionConfig.kitchenRenovationCosts[apartmentSize][this.interiorQuality] ?? 0 : 0;
			if (!this.renovationProject) throw new InvariantError("renovation project is expected to exist to calculate prediction values");
			const baseGuestToiletCosts = this.renovationProject.hasGuestToilet ? this.hasGuestToilet ? this.regionConfig.guestToiletCosts.YES[this.interiorQuality] ?? 0 : this.regionConfig.guestToiletCosts.NO[this.interiorQuality] ?? 0 : 0;
			this.guestToiletCosts = baseGuestToiletCosts * (1 - electricalPercentage);
			const currentRooms = this.renovationProject.numberOfRooms;
			const newRooms = this.numberOfRooms;
			if (isNil(currentRooms)) throw new InvariantError("Expected renovationProject.numberOfRooms to be defined");
			this.roomChangeCosts = this.regionConfig.roomChangeCosts[Math.abs(currentRooms - newRooms)] ?? 0;
			this.electricalCostsBudget = safeSum(baseGeneralRenovationCosts, baseBathroomCosts, baseGuestToiletCosts, this.roomChangeCosts) * electricalPercentage;
			const baseRenovationCosts = this.getBaseRenovationCosts();
			let kitchenCostsWithMargin = this.kitchenRenovationCosts;
			if (baseRenovationCosts * this.margin < this.config.marginThreshold) {
				this.calculatedRenovationCosts = safeSum(baseRenovationCosts, this.config.marginThreshold);
				kitchenCostsWithMargin += kitchenCostsWithMargin / baseRenovationCosts * this.config.marginThreshold;
			} else {
				this.calculatedRenovationCosts = baseRenovationCosts * (1 + this.margin);
				kitchenCostsWithMargin *= 1 + this.margin;
			}
			this.electricalCosts = (this.calculatedRenovationCosts - kitchenCostsWithMargin) * electricalPercentage;
		}
		getBaseRenovationCosts() {
			return safeSum(this.generalRenovationCosts, this.kitchenRenovationCosts, this.bathroomCosts, this.guestToiletCosts, this.roomChangeCosts, this.electricalCostsBudget);
		}
		assignConstructionCaseFields() {
			const baseConstructionCase = ConstructionCase.createFromPrediction(this, this.config);
			this.profit = baseConstructionCase.grossReturn;
			this.relativeRenovationCostsPercentage = baseConstructionCase.relativeRenovationCostsPercentage;
		}
		getElectricalPercentage() {
			const apartmentSize = this.getApartmentSize();
			const interiorQuality = this.interiorQuality;
			const configElectricalPercentage = this.regionConfig.electricalPercentages[apartmentSize][interiorQuality];
			if (isNil(configElectricalPercentage)) throw new InvariantError(`expected configElectricalPercentage to exist in region config for apartment size ${apartmentSize} and interior quality ${interiorQuality}`);
			return configElectricalPercentage;
		}
		getApartmentSize() {
			if (this.size <= this.config.apartmentSizes.S) return "S";
			if (this.size > this.config.apartmentSizes.S && this.size <= this.config.apartmentSizes.M) return "M";
			if (this.size > this.config.apartmentSizes.M && this.size <= this.config.apartmentSizes.L) return "L";
			return "XL";
		}
	};
}));
//#endregion
//#region src/domains/raas/construction-case.class.ts
var ConstructionCase;
var init_construction_case_class = __esmMin((() => {
	init_errors();
	init_estates();
	init_construction_case_model();
	init_raas_base_model();
	init_renovation_project_prediction_class();
	init_renovation_project_class();
	init_renovation_project_model();
	ConstructionCase = class ConstructionCase extends RaasBaseClassAttributes {
		constructionCaseId;
		renovationProjectPredictionId;
		salePricePerSqmBefore;
		salePricePerSqmAfter;
		rentPricePerSqmBefore;
		rentPricePerSqmAfter;
		generalRenovationCosts;
		kitchenRenovationCosts;
		roomChangeCosts;
		bathroomCosts;
		guestToiletCosts;
		electricalCosts;
		electricalCostsBudget;
		renovationCostAdjustments;
		renovationCostAdjustmentsMargin;
		size;
		margin;
		taxRate;
		durationInYears;
		rentIncrease;
		wacc;
		hasRoofStoreyCosts;
		hasStoreyHeightCosts;
		hasGasBoilerCosts;
		hasMaisonetteCosts;
		hasPrefabricatedCosts;
		hasNewFloorCosts;
		hasAsbestosCosts;
		hasHeatingPipesCosts;
		historicDoors;
		hasKitchenCosts;
		hasBathroomCosts;
		hasElectricalCosts;
		relativeRenovationCostsPercentage;
		calculatedRenovationCosts;
		specialRenovationCosts;
		adjustedRenovationCosts;
		totalRenovationCosts;
		totalIncome;
		generalRenovationBudget;
		kitchenRenovationBudget;
		baseRenovationBudgetWithAdjustments;
		budgetSpecialRenovationCosts;
		addedMargin;
		totalGrossPrice;
		salePriceTotalBefore;
		salePriceTotalAfter;
		rentPriceTotalBefore;
		rentPriceTotalAfter;
		npv;
		npvPerYear;
		irr;
		initalRentUplift;
		rentUpliftPercentage;
		rentUpliftTotal;
		valueUpliftPercentage;
		valueUpliftTotal;
		discountedValueUpliftTotal;
		rentUpliftPerSqm;
		grossReturn;
		rentCashflowByYear;
		discountedCashflowByYear;
		cummulativeByYear;
		documentLinks;
		activeSnapshot;
		lastActivatedByUserId;
		lastActivatedAt;
		constructionDescription;
		renovationProjectPrediction;
		activatedRenovationProject;
		lastActivatedByUser;
		notes;
		config;
		regionConfig;
		constructor(constructionCase, config) {
			super(constructionCase);
			Object.assign(this, {
				hasRoofStoreyCosts: false,
				hasStoreyHeightCosts: false,
				hasGasBoilerCosts: false,
				hasMaisonetteCosts: false,
				hasPrefabricatedCosts: false,
				hasNewFloorCosts: false,
				hasAsbestosCosts: false,
				hasHeatingPipesCosts: false,
				historicDoors: 0,
				renovationCostAdjustments: 0,
				taxRate: config?.taxRate,
				wacc: config?.wacc,
				durationInYears: config?.durationInYears,
				rentIncrease: config?.rentIncrease,
				...constructionCase
			});
			if (constructionCase.renovationProjectPrediction) {
				this.renovationProjectPrediction = new RenovationProjectPrediction(constructionCase.renovationProjectPrediction);
				if (this.renovationProjectPrediction.renovationProject?.region?.regionConfig) this.regionConfig = this.renovationProjectPrediction.renovationProject.region.regionConfig;
			}
			if (constructionCase.activatedRenovationProject) this.activatedRenovationProject = new RenovationProject(constructionCase.activatedRenovationProject);
			this.config = config;
		}
		calculate() {
			if (!this.config || !this.regionConfig) throw new InvariantError("No config provided to calculate construction case");
			if (!this.renovationProjectPrediction?.renovationProject) throw new InvariantError("Expected to have renovation project prediction and renovation project present");
			this.generalRenovationCosts = this.calculateGeneralRenovationCosts();
			this.kitchenRenovationCosts = this.calculateKitchenCosts();
			this.bathroomCosts = this.calculateBathroomCosts();
			this.guestToiletCosts = this.calculateGuestToiletCosts();
			this.roomChangeCosts = this.calculateRoomChangeCosts();
			this.electricalCostsBudget = this.calculateElectricalCostsBudget();
			const { valueUpliftTotal, valueUpliftPercentage, rentUpliftPercentage, initalRentUplift, rentPriceTotalAfter, rentPriceTotalBefore, salePriceTotalAfter, salePriceTotalBefore, rentUpliftPerSqm } = this.calculateBaseValues();
			this.valueUpliftTotal = valueUpliftTotal;
			this.valueUpliftPercentage = valueUpliftPercentage;
			this.rentUpliftPercentage = rentUpliftPercentage;
			this.initalRentUplift = initalRentUplift;
			this.rentPriceTotalAfter = rentPriceTotalAfter;
			this.rentPriceTotalBefore = rentPriceTotalBefore;
			this.salePriceTotalAfter = salePriceTotalAfter;
			this.salePriceTotalBefore = salePriceTotalBefore;
			this.rentUpliftPerSqm = rentUpliftPerSqm;
			this.discountedValueUpliftTotal = this.calculateDiscountedValueUpliftTotal();
			this.calculatedRenovationCosts = this.calculateCalculatedRenovationCosts();
			this.specialRenovationCosts = this.calculateSpecialRenovationCosts();
			this.adjustedRenovationCosts = this.calculateAdjustedRenovationCosts();
			this.electricalCosts = this.calculateElectricalCosts();
			this.totalRenovationCosts = this.calculateTotalRenovationCosts();
			this.baseRenovationBudgetWithAdjustments = this.calculateBaseRenovationBudgetWithAdjustments();
			this.rentCashflowByYear = this.calculateRentCashflowPerYear();
			this.budgetSpecialRenovationCosts = this.calculateBudgetSpecialRenovationCosts();
			this.addedMargin = this.calculateAddedMargin();
			this.totalGrossPrice = this.calculateTotalGrossPrice();
			this.grossReturn = this.rentCashflowByYear[1] / this.totalRenovationCosts;
			this.rentUpliftTotal = sum(Object.values(this.rentCashflowByYear));
			this.totalIncome = this.rentUpliftTotal + this.valueUpliftTotal;
			this.discountedCashflowByYear = this.calculateDiscountedCashflowPerYear();
			this.cummulativeByYear = this.calculateCummulativeByYear();
			const { kitchenRenovationBudget, generalRenovationBudget, renovationCostAdjustmentsMargin } = this.calculateRenovationBudget();
			this.kitchenRenovationBudget = kitchenRenovationBudget;
			this.generalRenovationBudget = generalRenovationBudget;
			this.renovationCostAdjustmentsMargin = renovationCostAdjustmentsMargin;
			const { npv, npvPerYear } = this.calculateNpv();
			this.npv = npv;
			this.npvPerYear = npvPerYear;
			this.irr = this.calculateCashflowIrr();
			this.relativeRenovationCostsPercentage = this.calculateRelativeRenovationCostsPercentage();
			return this;
		}
		calculateBathroomCosts() {
			const apartmentSize = this.getApartmentSize();
			const interiorQuality = this.renovationProjectPrediction.interiorQuality;
			const configBathroomCosts = interiorQuality ? this.regionConfig.bathroomRenovationCosts[apartmentSize][interiorQuality] ?? 0 : 0;
			const numberOfBathrooms = this.renovationProjectPrediction?.numberOfBathrooms;
			if (isNil(numberOfBathrooms)) throw new InvariantError("numberOfBathrooms is expected to exist to calculate construction case values");
			return configBathroomCosts * numberOfBathrooms * Number(Boolean(this.hasBathroomCosts)) * (1 - this.getElectricalPercentage());
		}
		calculateGuestToiletCosts() {
			const interiorQuality = this.renovationProjectPrediction.interiorQuality;
			const renovationProjectHasGuestToilet = this.renovationProjectPrediction.renovationProject.hasGuestToilet;
			const renovationProjectPredictionHasGuestToilet = this.renovationProjectPrediction.hasGuestToilet;
			return (renovationProjectHasGuestToilet ? renovationProjectPredictionHasGuestToilet ? this.regionConfig.guestToiletCosts.YES[interiorQuality] ?? 0 : this.regionConfig.guestToiletCosts.NO[interiorQuality] ?? 0 : 0) * (1 - this.getElectricalPercentage());
		}
		calculateGeneralRenovationCosts() {
			const apartmentSize = this.getApartmentSize();
			const interiorQuality = this.renovationProjectPrediction.interiorQuality;
			const configSizesInSqm = Object.keys(this.regionConfig.generalRenovationCosts).map(Number);
			const minConfigSize = Math.min(...configSizesInSqm);
			const maxConfigSize = Math.max(...configSizesInSqm);
			let apartmentSizeInSqm = Math.round(this.size);
			if (apartmentSizeInSqm < minConfigSize) apartmentSizeInSqm = minConfigSize;
			else if (apartmentSizeInSqm > maxConfigSize) apartmentSizeInSqm = maxConfigSize;
			const configGeneralRenovationCosts = this.regionConfig.generalRenovationCosts[apartmentSizeInSqm][interiorQuality] ?? 0;
			if (!configGeneralRenovationCosts) throw new InvariantError(`expected generalRenovationCosts to exist in region config for apartment size ${apartmentSize} and interior quality ${interiorQuality}`);
			return configGeneralRenovationCosts * this.size * (1 - this.getElectricalPercentage());
		}
		calculateKitchenCosts() {
			const apartmentSize = this.getApartmentSize();
			const interiorQuality = this.renovationProjectPrediction.interiorQuality;
			return (interiorQuality ? this.regionConfig.kitchenRenovationCosts[apartmentSize][interiorQuality] ?? 0 : 0) * Number(Boolean(this.hasKitchenCosts));
		}
		calculateRoomChangeCosts() {
			const currentRooms = this.renovationProjectPrediction.renovationProject.numberOfRooms;
			const newRooms = this.renovationProjectPrediction.numberOfRooms;
			if (isNil(currentRooms)) throw new InvariantError("Expected renovationProjectPrediction.renovationProject.numberOfRooms to be defined");
			const configElectricalPercentage = this.getElectricalPercentage();
			return (this.regionConfig.roomChangeCosts[Math.abs(currentRooms - newRooms)] ?? 0) * (1 - configElectricalPercentage);
		}
		calculateElectricalCostsBudget() {
			return this.hasElectricalCosts ? this.renovationProjectPrediction.electricalCostsBudget : 0;
		}
		calculateRelativeRenovationCostsPercentage() {
			if (!this.renovationProjectPrediction?.renovationProject?.region) throw new InvariantError("renovation project region is expected to exist to calculate construction case values");
			const { newConstructionPricePerSqm } = this.regionConfig;
			return this.totalRenovationCosts / this.size / newConstructionPricePerSqm;
		}
		calculateBaseValues() {
			const valueUpliftTotal = (this.salePricePerSqmAfter - this.salePricePerSqmBefore) * this.size;
			const valueUpliftPercentage = this.salePricePerSqmAfter / this.salePricePerSqmBefore - 1;
			const rentUpliftPercentage = this.rentPricePerSqmAfter / this.rentPricePerSqmBefore - 1;
			const initalRentUplift = (this.rentPricePerSqmAfter - this.rentPricePerSqmBefore) * this.size * 12;
			const rentUpliftPerSqm = this.rentPricePerSqmAfter - this.rentPricePerSqmBefore;
			return {
				valueUpliftTotal,
				valueUpliftPercentage,
				rentUpliftPercentage,
				initalRentUplift,
				salePriceTotalBefore: this.salePricePerSqmBefore * this.size,
				salePriceTotalAfter: this.salePricePerSqmAfter * this.size,
				rentPriceTotalBefore: this.rentPricePerSqmBefore * this.size,
				rentPriceTotalAfter: this.rentPricePerSqmAfter * this.size,
				rentUpliftPerSqm
			};
		}
		calculateSpecialRenovationCosts() {
			const baseRenovationCosts = this.getBaseRenovationCosts();
			return safeSum(this.hasRoofStoreyCosts ? this.regionConfig.specialRenovationCosts.roofStoreyAdditionCoefficient * baseRenovationCosts : 0, this.hasStoreyHeightCosts ? this.regionConfig.specialRenovationCosts.storeyHeightAdditionCoefficient * this.size : 0, this.hasGasBoilerCosts ? this.regionConfig.specialRenovationCosts.gasBoiler : 0, this.hasMaisonetteCosts ? this.regionConfig.specialRenovationCosts.maisonetteAddition : 0, this.hasPrefabricatedCosts ? this.regionConfig.specialRenovationCosts.prefabricatedCoefficient * this.size : 0, this.hasNewFloorCosts ? this.regionConfig.specialRenovationCosts.newFloorCoefficient * this.size : 0, this.hasAsbestosCosts ? this.regionConfig.specialRenovationCosts.asbestosCoefficient * this.size : 0, this.hasHeatingPipesCosts ? this.regionConfig.specialRenovationCosts.heatingPipesAddition : 0, this.historicDoors ? this.regionConfig.specialRenovationCosts.historicDoorsCoefficient * this.historicDoors : 0) * (1 + this.margin);
		}
		calculateAdjustedRenovationCosts() {
			return safeSum(this.calculatedRenovationCosts, this.renovationCostAdjustments);
		}
		calculateTotalRenovationCosts() {
			return safeSum(this.adjustedRenovationCosts, this.specialRenovationCosts);
		}
		calculateElectricalCosts() {
			if (this.hasElectricalCosts) {
				let kitchenRenovationCostsWithMargin = this.kitchenRenovationCosts;
				const totalRenovationCostsWithoutMargin = this.getBaseRenovationCosts();
				if (totalRenovationCostsWithoutMargin * this.margin < this.config.marginThreshold) kitchenRenovationCostsWithMargin += kitchenRenovationCostsWithMargin / totalRenovationCostsWithoutMargin * this.config.marginThreshold;
				else kitchenRenovationCostsWithMargin *= 1 + this.margin;
				return (this.calculatedRenovationCosts - kitchenRenovationCostsWithMargin) * this.getElectricalPercentage();
			}
			return 0;
		}
		calculateRentCashflowPerYear() {
			return range(2, this.durationInYears + 1).reduce((acc, year) => ({
				...acc,
				[year]: acc[year - 1] + acc[year - 1] * this.rentIncrease
			}), {
				0: 0,
				1: this.initalRentUplift
			});
		}
		calculateDiscountedCashflowPerYear() {
			return range(1, this.durationInYears + 1).reduce((acc, year) => {
				const cashflowWithUplift = this.rentCashflowByYear[year] + (year === this.durationInYears ? this.valueUpliftTotal : 0);
				return {
					...acc,
					[year]: cashflowWithUplift / (1 + this.wacc) ** year
				};
			}, { 0: -this.totalRenovationCosts });
		}
		calculateDiscountedValueUpliftTotal() {
			return this.valueUpliftTotal / (1 + this.wacc) ** this.durationInYears;
		}
		calculateCummulativeByYear() {
			return range(1, this.durationInYears + 1).reduce((acc, year) => ({
				...acc,
				[year]: acc[year - 1] + this.discountedCashflowByYear[year]
			}), { 0: this.discountedCashflowByYear[0] });
		}
		calculateNpv() {
			const npv = this.cummulativeByYear[this.durationInYears];
			return {
				npv,
				npvPerYear: npv / this.durationInYears
			};
		}
		calculateCashflowIrr() {
			const baseDate = dayjs(`01-01-${dayjs().get("year")}`, "MM-DD-YYYY").endOf("year");
			const rate = xirr([
				{
					amount: -this.totalRenovationCosts,
					date: baseDate.toDate()
				},
				...range(1, this.durationInYears).map((year) => ({
					amount: this.rentCashflowByYear[year],
					date: baseDate.add(year, "year").toDate()
				})),
				{
					amount: this.rentCashflowByYear[this.durationInYears] + this.valueUpliftTotal,
					date: baseDate.add(this.durationInYears, "year").toDate()
				}
			]);
			return Number.isNaN(rate.rate) ? 0 : convertRate(rate.rate, RateInterval.Year);
		}
		calculateRenovationBudget() {
			if (this.baseRenovationBudgetWithAdjustments * this.margin >= this.config.marginThreshold) return {
				kitchenRenovationBudget: this.kitchenRenovationCosts,
				generalRenovationBudget: this.totalRenovationCosts / (1 + this.margin) - this.kitchenRenovationCosts,
				renovationCostAdjustmentsMargin: this.renovationCostAdjustments / (1 + this.margin) * this.margin
			};
			return {
				kitchenRenovationBudget: this.kitchenRenovationCosts,
				generalRenovationBudget: this.totalRenovationCosts - this.config.marginThreshold - this.specialRenovationCosts * this.margin - this.kitchenRenovationCosts,
				renovationCostAdjustmentsMargin: 0
			};
		}
		calculateCalculatedRenovationCosts() {
			const baseRenovationCosts = this.getBaseRenovationCosts();
			if (baseRenovationCosts * this.margin + (this.renovationCostAdjustments ?? 0 / (1 + this.margin)) * this.margin < this.config.marginThreshold) return safeSum(baseRenovationCosts, this.config.marginThreshold);
			return baseRenovationCosts * (1 + this.margin);
		}
		getBaseRenovationCosts() {
			return safeSum(this.generalRenovationCosts, this.kitchenRenovationCosts, this.bathroomCosts, this.guestToiletCosts, this.roomChangeCosts, this.electricalCostsBudget);
		}
		get isActive() {
			if (this.activatedRenovationProject === void 0) throw new Error("cannot get isActive without activatedRenovationProject");
			return Boolean(this.activatedRenovationProject);
		}
		get renovationStandard() {
			if (!this.renovationProjectPrediction?.interiorQuality) throw new Error("cannot get renovationStandard without renovationProjectPrediction");
			return interiorQualityToStandardMap[this.renovationProjectPrediction.interiorQuality];
		}
		calculateBaseRenovationBudgetWithAdjustments() {
			if (this.getBaseRenovationCosts() * this.margin + (this.renovationCostAdjustments ?? 0 / (1 + this.margin)) * this.margin >= this.config.marginThreshold) return this.getBaseRenovationCosts() + this.renovationCostAdjustments / (1 + this.margin);
			return this.getBaseRenovationCosts() + this.renovationCostAdjustments;
		}
		calculateBudgetSpecialRenovationCosts() {
			return this.specialRenovationCosts / (1 + this.margin);
		}
		calculateAddedMargin() {
			const marginBaseRenovationBudgetWithAdjustments = this.baseRenovationBudgetWithAdjustments * this.margin;
			const marginSpecialRenovationCosts = this.specialRenovationCosts - this.budgetSpecialRenovationCosts;
			if (marginBaseRenovationBudgetWithAdjustments >= this.config.marginThreshold) return marginSpecialRenovationCosts + marginBaseRenovationBudgetWithAdjustments;
			return marginSpecialRenovationCosts + this.config.marginThreshold;
		}
		calculateTotalGrossPrice() {
			return this.baseRenovationBudgetWithAdjustments + this.budgetSpecialRenovationCosts + this.addedMargin;
		}
		getApartmentSize() {
			if (this.size <= this.config.apartmentSizes.S) return "S";
			if (this.size > this.config.apartmentSizes.S && this.size <= this.config.apartmentSizes.M) return "M";
			if (this.size > this.config.apartmentSizes.M && this.size <= this.config.apartmentSizes.L) return "L";
			return "XL";
		}
		getApplicationResults() {
			if (!this.renovationProjectPrediction) throw new InvariantError("expected to have renovationProjectPrediction");
			const profit = this.grossReturn;
			const calculatedRenovationCosts = this.calculatedRenovationCosts;
			const specialRenovationCosts = this.specialRenovationCosts;
			const rentUpliftPercentage = this.rentUpliftPercentage;
			const rentCashflow = this.rentCashflowByYear[1];
			const hasKitchenCosts = this.hasKitchenCosts;
			const hasBathroomCosts = this.hasBathroomCosts;
			const hasElectricalCosts = this.hasElectricalCosts;
			const interiorQuality = this.renovationProjectPrediction.interiorQuality;
			const totalRenovationCosts = this.totalRenovationCosts;
			const electricalCosts = this.electricalCosts;
			let generalRenovationCosts = this.generalRenovationCosts + this.roomChangeCosts;
			let guestToiletCosts = this.guestToiletCosts;
			let bathroomCosts = this.bathroomCosts;
			let kitchenRenovationCosts = this.kitchenRenovationCosts;
			const totalRenovationCostsWithoutMargin = this.getBaseRenovationCosts();
			if (totalRenovationCostsWithoutMargin * this.margin < this.config.marginThreshold) {
				generalRenovationCosts += generalRenovationCosts / totalRenovationCostsWithoutMargin * this.config.marginThreshold;
				bathroomCosts += bathroomCosts / totalRenovationCostsWithoutMargin * this.config.marginThreshold;
				guestToiletCosts += guestToiletCosts / totalRenovationCostsWithoutMargin * this.config.marginThreshold;
				kitchenRenovationCosts += kitchenRenovationCosts / totalRenovationCostsWithoutMargin * this.config.marginThreshold;
			} else {
				generalRenovationCosts *= 1 + this.margin;
				bathroomCosts *= 1 + this.margin;
				guestToiletCosts *= 1 + this.margin;
				kitchenRenovationCosts *= 1 + this.margin;
			}
			return {
				profit,
				calculatedRenovationCosts,
				totalRenovationCosts,
				rentUpliftPercentage,
				rentCashflow,
				hasKitchenCosts,
				hasBathroomCosts,
				hasElectricalCosts,
				interiorQuality,
				generalRenovationCosts,
				bathroomCosts,
				specialRenovationCosts,
				guestToiletCosts,
				kitchenRenovationCosts,
				electricalCosts
			};
		}
		getElectricalPercentage() {
			const apartmentSize = this.getApartmentSize();
			const interiorQuality = this.renovationProjectPrediction.interiorQuality;
			const configElectricalPercentage = this.regionConfig.electricalPercentages[apartmentSize][interiorQuality];
			if (isNil(configElectricalPercentage)) throw new InvariantError(`expected configElectricalPercentage to exist in region config for apartment size ${apartmentSize} and interior quality ${interiorQuality}`);
			return configElectricalPercentage;
		}
		generateActiveSnapshot() {
			return omit(this, activeSnapshotIgnoredFields);
		}
		static createFromPrediction(prediction, config, overridables) {
			return new ConstructionCase({
				renovationProjectPredictionId: prediction.renovationProjectPredictionId,
				salePricePerSqmBefore: prediction.salePricePerSqmBefore,
				salePricePerSqmAfter: prediction.salePricePerSqmAfter,
				rentPricePerSqmBefore: prediction.rentPricePerSqmBefore,
				rentPricePerSqmAfter: prediction.rentPricePerSqmAfter,
				size: prediction.size,
				margin: prediction.margin,
				hasKitchenCosts: prediction.hasKitchen,
				hasBathroomCosts: prediction.numberOfBathrooms > 0,
				electricalCosts: prediction.electricalCosts,
				hasElectricalCosts: true,
				generalRenovationCosts: prediction.generalRenovationCosts,
				kitchenRenovationCosts: prediction.kitchenRenovationCosts,
				roomChangeCosts: prediction.roomChangeCosts,
				bathroomCosts: prediction.bathroomCosts,
				guestToiletCosts: prediction.guestToiletCosts,
				renovationProjectPrediction: prediction,
				...overridables
			}, config).calculate();
		}
		static createFromCostCalculatorInputs(calculatorInputs, config, regionConfig) {
			const renovationProject = {
				region: { regionConfig },
				hasGuestToilet: calculatorInputs.hasGuestToilet || calculatorInputs.hasStorageRoom,
				numberOfRooms: 0
			};
			const prediction = new RenovationProjectPrediction({
				...pick(calculatorInputs, [
					"interiorQuality",
					"size",
					"numberOfRooms",
					"numberOfBathrooms",
					"hasGuestToilet",
					"hasStorageRoom",
					"hasKitchen"
				]),
				renovationProject
			}, config).calculate();
			return new ConstructionCase({
				hasKitchenCosts: prediction.hasKitchen,
				hasBathroomCosts: prediction.numberOfBathrooms > 0,
				renovationProjectPrediction: prediction,
				...pick(prediction, [
					"bathroomCosts",
					"generalRenovationCosts",
					"guestToiletCosts",
					"kitchenRenovationCosts",
					"margin",
					"roomChangeCosts",
					"size"
				]),
				...pick(calculatorInputs, "hasAsbestosCosts", "hasGasBoilerCosts", "hasHeatingPipesCosts", "hasMaisonetteCosts", "hasNewFloorCosts", "hasPrefabricatedCosts", "hasRoofStoreyCosts", "hasStoreyHeightCosts", "historicDoors", "hasElectricalCosts"),
				salePricePerSqmBefore: 1,
				salePricePerSqmAfter: 1,
				rentPricePerSqmBefore: 1,
				rentPricePerSqmAfter: 1
			}, config).calculate();
		}
	};
}));
//#endregion
//#region src/domains/raas/renovation-project.class.ts
var RenovationProject;
var init_renovation_project_class = __esmMin((() => {
	init_construction_case_class();
	init_raas_base_model();
	init_renovation_project_model();
	RenovationProject = class extends RaasBaseClassAttributes {
		renovationProjectId;
		uuid;
		userId;
		supervisorId;
		activeConstructionCaseId;
		regionId;
		isActive;
		city;
		condition;
		condoUuid;
		hasBalcony;
		hasCellar;
		hasGarden;
		hasGuestToilet;
		hasLift;
		hasBuiltInKitchen;
		houseNumber;
		interiorQuality;
		numberOfBathrooms;
		numberOfRooms;
		purpose;
		size;
		source;
		status;
		street;
		zipCode;
		latitude;
		longitude;
		constructionYear;
		heatingType;
		lastRenovationYear;
		rentPriceTotalBefore;
		renovationStatus;
		floorLocation;
		floorNumber;
		user;
		supervisor;
		predictions;
		activeConstructionCase;
		notes;
		medias;
		region;
		calendarEvents;
		constructor(renovationProject) {
			super(renovationProject);
			Object.assign(this, renovationProject);
			if (renovationProject.activeConstructionCase) this.activeConstructionCase = new ConstructionCase(renovationProject.activeConstructionCase);
		}
		get configuration() {
			return {
				builtInKitchen: this.hasBuiltInKitchen,
				balcony: this.hasBalcony,
				cellar: this.hasCellar,
				garden: this.hasGarden,
				guestToilet: this.hasGuestToilet,
				lift: this.hasLift,
				livingSpace: this.size,
				constructionYear: this.constructionYear,
				rooms: this.numberOfRooms,
				numberOfBathRooms: this.numberOfBathrooms,
				interiorQuality: this.interiorQuality,
				condition: this.condition
			};
		}
		get finalOfferAccepted() {
			return Object.values(RenovationProjectStatus).indexOf(this.status) >= Object.values(RenovationProjectStatus).indexOf("FinalOfferAccepted");
		}
	};
}));
//#endregion
//#region src/domains/raas/renovation-project-prediction.model.ts
var init_renovation_project_prediction_model = __esmMin((() => {}));
//#endregion
//#region src/domains/raas/raas-note.model.ts
var init_raas_note_model = __esmMin((() => {}));
//#endregion
//#region src/domains/raas/raas-media.model.ts
var RaasMediaCategory;
var init_raas_media_model = __esmMin((() => {
	RaasMediaCategory = /* @__PURE__ */ function(RaasMediaCategory) {
		RaasMediaCategory["FromCustomer"] = "FromCustomer";
		RaasMediaCategory["BeforeRenovation"] = "BeforeRenovation";
		RaasMediaCategory["InRenovation"] = "InRenovation";
		RaasMediaCategory["AfterRenovation"] = "AfterRenovation";
		return RaasMediaCategory;
	}({});
}));
//#endregion
//#region src/domains/raas/raas-document.model.ts
var RaasDocumentType, RaasDocumentCategory, raasDocumentTypeCategoryMap;
var init_raas_document_model = __esmMin((() => {
	RaasDocumentType = /* @__PURE__ */ function(RaasDocumentType) {
		RaasDocumentType["ConstructionCaseReport"] = "ConstructionCaseReport";
		RaasDocumentType["ConstructionCaseFinalOffer"] = "ConstructionCaseFinalOffer";
		RaasDocumentType["ConstructionCaseRenovationOffer"] = "ConstructionCaseRenovationOffer";
		RaasDocumentType["ConstructionCaseRenovationOfferWithPositions"] = "ConstructionCaseRenovationOfferWithPositions";
		RaasDocumentType["Other"] = "Other";
		return RaasDocumentType;
	}({});
	RaasDocumentCategory = /* @__PURE__ */ function(RaasDocumentCategory) {
		RaasDocumentCategory["Expose"] = "Expose";
		RaasDocumentCategory["ResultPagePDF"] = "ResultPagePDF";
		RaasDocumentCategory["InitialOffer"] = "InitialOffer";
		RaasDocumentCategory["FinalOffer"] = "FinalOffer";
		RaasDocumentCategory["Invoice"] = "Invoice";
		RaasDocumentCategory["Unsorted"] = "Unsorted";
		return RaasDocumentCategory;
	}({});
	raasDocumentTypeCategoryMap = {
		["ConstructionCaseReport"]: "InitialOffer",
		["ConstructionCaseFinalOffer"]: "FinalOffer",
		["ConstructionCaseRenovationOffer"]: "InitialOffer",
		["ConstructionCaseRenovationOfferWithPositions"]: "InitialOffer",
		["Other"]: "Unsorted"
	};
}));
//#endregion
//#region src/domains/raas/raas-region.model.ts
var init_raas_region_model = __esmMin((() => {}));
//#endregion
//#region src/domains/raas/raas-config.model.ts
var init_raas_config_model = __esmMin((() => {}));
//#endregion
//#region src/domains/raas/renovation-project-state-transition.model.ts
var init_renovation_project_state_transition_model = __esmMin((() => {}));
//#endregion
//#region src/domains/raas/renovation-project-calendar-event.model.ts
var RenovationProjectCalendarEventType;
var init_renovation_project_calendar_event_model = __esmMin((() => {
	RenovationProjectCalendarEventType = /* @__PURE__ */ function(RenovationProjectCalendarEventType) {
		RenovationProjectCalendarEventType["AppForm"] = "AppForm";
		return RenovationProjectCalendarEventType;
	}({});
}));
//#endregion
//#region src/domains/raas/renovation-project-checklist.model.ts
var init_renovation_project_checklist_model = __esmMin((() => {}));
//#endregion
//#region src/domains/raas/cost-calculator-inputs.model.ts
var init_cost_calculator_inputs_model = __esmMin((() => {}));
//#endregion
//#region src/domains/raas/raas-region-config.model.ts
var init_raas_region_config_model = __esmMin((() => {}));
//#endregion
//#region src/domains/raas/verification-request.ts
var VerificationRequestAction;
var init_verification_request = __esmMin((() => {
	VerificationRequestAction = /* @__PURE__ */ function(VerificationRequestAction) {
		VerificationRequestAction["VerifyAppFormContactRequest"] = "verify-app-form-contact-request";
		return VerificationRequestAction;
	}({});
}));
//#endregion
//#region src/domains/raas/static/renovation-project-checklist-questions.ts
var RenovationProjectChecklistQuestions;
var init_renovation_project_checklist_questions = __esmMin((() => {
	init_form_question_factory();
	RenovationProjectChecklistQuestions = [
		{
			title: "Anfrage für",
			questions: [
				FormQuestionFactory.Toggle({
					name: "full_renovation",
					title: "Kernsanierung"
				}),
				FormQuestionFactory.Toggle({
					name: "include_kitchen",
					title: "Einbauküche"
				}),
				FormQuestionFactory.Toggle({
					name: "include_bathroom",
					title: "Bad"
				}),
				FormQuestionFactory.Toggle({
					name: "include_electricity",
					title: "Elektrik"
				})
			]
		},
		{
			title: "Zustand Gebäude",
			questions: [
				FormQuestionFactory.Toggle({
					name: "is_weg",
					title: "Sondereigentum (WEG)?",
					tooltip: "Wenn das gesamte Gebäude nicht im Besitz des Auftraggeber ist bitte anwählen."
				}),
				FormQuestionFactory.Note({ name: "is_weg_notes" }),
				FormQuestionFactory.Toggle({
					name: "modernization_planned",
					title: "Modernisierungs-/ Sanierungsmaßnamen geplant?"
				}),
				FormQuestionFactory.Note({ name: "modernization_planned_notes" }),
				FormQuestionFactory.Toggle({
					name: "modernization_protocol_present",
					title: "Gibt es hierzu Protokolle?",
					guards: [{
						name: "modernization_planned",
						value: true
					}]
				}),
				FormQuestionFactory.Note({
					name: "modernization_protocol_present_notes",
					guards: [{
						name: "modernization_planned",
						value: true
					}]
				}),
				FormQuestionFactory.Toggle({
					name: "building_structure_no_defects",
					title: "Bausubstanz (außen) in gutem Zustand/ keine Mängel ersichtlich?"
				}),
				FormQuestionFactory.Note({ name: "building_structure_no_defects_notes" }),
				FormQuestionFactory.Toggle({
					name: "roof_no_defects",
					title: "Ist das Dach und die Dacheindeckung in einem guten Zustand?"
				}),
				FormQuestionFactory.Note({ name: "roof_no_defects_notes" }),
				FormQuestionFactory.Toggle({
					name: "house_insulated",
					title: "Ist das Haus gedämmt?"
				}),
				FormQuestionFactory.Note({ name: "house_insulated_notes" })
			]
		},
		{
			title: "Zustand der Wohnung",
			questions: [
				FormQuestionFactory.Toggle({
					name: "appartment_moisture_damages",
					title: "Feuchtigkeitsschäden an den Außenwänden erkennbar? Schimmel, Leckage etc."
				}),
				FormQuestionFactory.Note({ name: "appartment_moisture_damages_notes" }),
				FormQuestionFactory.Toggle({
					name: "appartment_wall_cracks",
					title: "Rissbildung in Wänden erkennbar?"
				}),
				FormQuestionFactory.Note({ name: "appartment_wall_cracks_notes" }),
				FormQuestionFactory.Toggle({
					name: "appartment_normal_room_height",
					title: "Deckenhöhe der Räume im Standard? Lichtes Maß zwischen 2,30 bis 2,50m"
				}),
				FormQuestionFactory.Note({ name: "appartment_normal_room_height_notes" }),
				FormQuestionFactory.Toggle({
					name: "appartment_normal_door_size",
					title: "Türhöhen und -breiten im Standard?",
					tooltip: "Die gängigsten Türhöhen: (1985, 2110 mm) Die gängigsten Türbreiten: (610, 735, 860, 985mm)"
				}),
				FormQuestionFactory.Note({ name: "appartment_normal_door_size_notes" }),
				FormQuestionFactory.Label({
					name: "appartment_window_label",
					title: "Aus welchem Material sind die Fenster und wie alt sind diese?"
				}),
				FormQuestionFactory.TextInput({
					name: "appartment_window_material",
					title: "Material"
				}),
				FormQuestionFactory.Number({
					name: "appartment_window_age",
					title: "Alter",
					min: 1,
					max: 100
				}),
				FormQuestionFactory.Toggle({
					name: "appartment_room_change_planned",
					title: "Sind Grundrissänderungen geplant?"
				}),
				FormQuestionFactory.Note({ name: "appartment_room_change_planned_notes" }),
				FormQuestionFactory.Toggle({
					name: "appartment_cellar_attic_exists",
					title: "Nebenraum (Keller oder Dachboden) vorhanden?"
				}),
				FormQuestionFactory.Note({ name: "appartment_cellar_attic_exists_notes" }),
				FormQuestionFactory.TextInput({
					name: "appartment_balcony_terrace_quality",
					title: "Zustand Terrasse / Balkon?"
				})
			]
		},
		{
			title: "Erhaltenswerte Bauteile im Altbau - NUR RELEVANT IM ALTBAU",
			questions: [
				FormQuestionFactory.TextInput({
					name: "appartment_old_building_floor_quality",
					title: "In welchem Zustand sind die Böden? Besonderheiten, wie z.B. Dielenböden."
				}),
				FormQuestionFactory.Toggle({
					name: "appartment_old_building_floor_keep",
					title: "Sollen diese erhalten bleiben?"
				}),
				FormQuestionFactory.TextInput({
					name: "appartment_old_building_door_quality",
					title: "In welchem Zustand sind die Türen?"
				}),
				FormQuestionFactory.Toggle({
					name: "appartment_old_building_door_keep",
					title: "Sollen diese erhalten bleiben?"
				})
			]
		},
		{
			title: "Technische Anlagen",
			questions: [
				FormQuestionFactory.Toggle({
					name: "appartment_technical_electricity_good_condition",
					title: "Ist die elektrische Anlage in einem guten Zustand?"
				}),
				FormQuestionFactory.Note({ name: "appartment_technical_electricity_good_condition_notes" }),
				FormQuestionFactory.Toggle({
					name: "appartment_technical_electricity_fi_exists",
					title: "Unterverteilung mit FI-Schutzschalter vorhanden?"
				}),
				FormQuestionFactory.Toggle({
					name: "appartment_technical_electricity_echeck_exists",
					title: "E-Check (Prüfsiegel für die Unterverteilung) vorhanden?"
				}),
				FormQuestionFactory.Note({ name: "appartment_technical_electricity_echeck_exists_notes" }),
				FormQuestionFactory.TextInput({
					name: "appartment_technical_water_quality",
					title: "Gibt es Informationen über die Qualität der Zu- und Abwasserleitungen?"
				}),
				FormQuestionFactory.TextInput({
					name: "appartment_technical_water_hot_water_processing_in_appartment",
					title: "Wie erfolgt die Warmwasseraufbereitung für die Wohnung?"
				}),
				FormQuestionFactory.Toggle({
					name: "appartment_technical_water_hot_water_processing_central",
					title: "Zentrale Warmwasseraufbereitung?"
				}),
				FormQuestionFactory.Toggle({
					name: "appartment_technical_heating_central",
					title: "Zentrale Beheizung?"
				}),
				FormQuestionFactory.Note({ name: "appartment_technical_heating_central_notes" }),
				FormQuestionFactory.Toggle({
					name: "appartment_technical_heating_gas_heater",
					title: "Gastherme verbaut?",
					guards: [{
						name: "appartment_technical_heating_central",
						value: false
					}]
				}),
				FormQuestionFactory.Number({
					name: "appartment_technical_heating_gas_heater_age",
					title: "Baujahr Gastherme",
					min: 1,
					max: (/* @__PURE__ */ new Date()).getFullYear(),
					guards: [{
						name: "appartment_technical_heating_gas_heater",
						value: true
					}]
				}),
				FormQuestionFactory.Toggle({
					name: "appartment_technical_heating_gas_pipes_under_ceiling",
					title: "Leitungsführung Gas unter Decke sichtbar/vorhanden?"
				}),
				FormQuestionFactory.Note({ name: "appartment_technical_heating_gas_pipes_under_ceiling_notes" }),
				FormQuestionFactory.Toggle({
					name: "appartment_technical_heating_heating_pipes_visible",
					title: "Heizungsleitung/-rohre in den Räumen auf Putz verlegt?"
				}),
				FormQuestionFactory.Note({ name: "appartment_technical_heating_heating_pipes_visible_notes" })
			]
		},
		{
			title: "Schadstoffe",
			questions: [FormQuestionFactory.Toggle({
				name: "pollutants_risk",
				title: "Besteht der Verdacht auf Schadstoffe bzw. traten Fälle bereits im Gebäude/Nachbarwohnungen auf? z.B. Asbest, Blei, Hausschwamm, Legionellen?"
			}), FormQuestionFactory.Note({ name: "pollutants_risk_notes" })]
		},
		{
			title: "Fazit",
			questions: [FormQuestionFactory.Toggle({
				name: "renovation_on_site_needed",
				title: "Besichtigung mit TL zur Einschätzung und Erstellung des verbindlichen Angebots erforderlich?"
			})]
		}
	];
}));
//#endregion
//#region src/domains/raas/static/privacy-policy-content.ts
var ConsentTextContent;
var init_privacy_policy_content = __esmMin((() => {
	ConsentTextContent = { AppFormContact: `Hiermit willige ich ein, dass die reneo GmbH mir Neuigkeiten über die Erweiterung Ihrer Regionen sendet. Hierfür werden meine Adresse und E-Mail Adresse gespeichert Die Einwilligung kann jederzeit über datenschutz@reneo.green widerrufen werden.` };
}));
//#endregion
//#region src/domains/raas/static/index.ts
var init_static = __esmMin((() => {
	init_renovation_project_checklist_questions();
	init_privacy_policy_content();
}));
//#endregion
//#region src/domains/raas/index.ts
var init_raas = __esmMin((() => {
	init_raas_user_model();
	init_renovation_project_model();
	init_renovation_project_lead_model();
	init_renovation_project_class();
	init_renovation_project_prediction_model();
	init_renovation_project_prediction_class();
	init_construction_case_model();
	init_construction_case_class();
	init_raas_note_model();
	init_raas_media_model();
	init_raas_document_model();
	init_raas_region_model();
	init_raas_config_model();
	init_renovation_project_state_transition_model();
	init_renovation_project_calendar_event_model();
	init_renovation_project_checklist_model();
	init_cost_calculator_inputs_model();
	init_raas_region_config_model();
	init_verification_request();
	init_static();
}));
//#endregion
//#region src/domains/condo-living/auth0.ts
var CondoLivingUserState;
var init_auth0 = __esmMin((() => {
	CondoLivingUserState = /* @__PURE__ */ function(CondoLivingUserState) {
		CondoLivingUserState["SignUp"] = "SignUp";
		CondoLivingUserState["Review"] = "Review";
		CondoLivingUserState["Active"] = "Active";
		return CondoLivingUserState;
	}({});
}));
//#endregion
//#region src/domains/condo-living/livings.common.ts
var livingsCheckQuestions;
var init_livings_common = __esmMin((() => {
	init_form_question();
	livingsCheckQuestions = [
		FormQuestionFactory.SwitchWithTextInputField({
			name: "parkingSuitableForVan",
			title: "Ist der Parkplatz für einen Transporter geeignet?",
			values: [
				"Ja",
				"Nein (Bitte spezifizieren)",
				"Kein Parkplatz vorhanden"
			],
			required: true
		}),
		FormQuestionFactory.Upload({
			name: "parkingLotPicture",
			title: "Bilder Parkplatz",
			required: false
		}),
		FormQuestionFactory.Upload({
			name: "pictureOfKeyLocker",
			title: "Ist ein Bild vom Tresor vorhanden? Falls nicht, Foto aufnehmen!",
			required: false
		}),
		FormQuestionFactory.TextInput({
			name: "tresorCode",
			title: "Wie ist der Tresor Code?",
			required: true
		}),
		FormQuestionFactory.TextInput({
			name: "infoOfKeysInVault",
			title: "Wie viele und welche Schlüssel sind vorhanden (im Tresor)? Funktionieren alle?",
			required: true
		}),
		FormQuestionFactory.Upload({
			name: "cellarOrStoragePicture",
			title: "Keller bzw. Lagerraum vorhanden? Falls ja, bitte ein Bild für Orientierung aufnehmen und mit Tape markieren!",
			required: false
		}),
		FormQuestionFactory.SwitchWithTextInputField({
			name: "isMailBoxAccessible",
			title: "Ist der Briefkasten zugänglich und beschriftet (z.B. mit HHLG)?",
			values: ["Ja"],
			required: true
		}),
		FormQuestionFactory.Upload({
			name: "pictureOfApartmentLocation",
			title: "Bild von Wohnungs Location falls fehlt!",
			required: false
		}),
		FormQuestionFactory.SwitchWithTextInputField({
			name: "isItEasyToFindApartment",
			title: "Ist die Wohnung mit beschriftet bzw. einfach zu finden? ToDo: Bitte mit Tape markieren, falls Wohnung schwer zu finden. ",
			values: ["Ja"],
			required: false
		}),
		FormQuestionFactory.SwitchWithTextInputField({
			name: "isElectricityRunning",
			title: "Strom läuft (und ausgeschaltet)?",
			values: ["Ja"],
			required: true
		}),
		FormQuestionFactory.SwitchWithTextInputField({
			name: "isThereWaterMeterInApartment",
			title: "Ist ein Wasserzähler in der Wohnung vorhanden?",
			values: ["Ja"],
			required: true
		}),
		FormQuestionFactory.TextInput({
			name: "washingMachineFittingInformation",
			title: "Waschmaschine: In welches Zimmer kommt sie? Falls sie in die Küche kommt: müssen Vorbereitungen für den Einbau getroffen werden (Wanne ausbauen, spezielle Rohre, etc.)? Falls mehrere Anschlüsse: wo passt am besten? ",
			required: true
		}),
		FormQuestionFactory.SwitchWithTextInputField({
			name: "areDrawersAndShelvesFunctionalAndClean",
			title: "Alle Schubladen/Regale öffnen. Funktionstüchtig & sauber?",
			values: ["Ja"],
			required: true
		}),
		FormQuestionFactory.SwitchWithTextInputField({
			name: "isFridgeWorking",
			title: "Kühlschrank funktionstüchtig?",
			values: ["Ja"],
			required: true
		}),
		FormQuestionFactory.SwitchWithTextInputField({
			name: "isHeatingWorkingAndSwitchedOff",
			title: "Heizung funktionstüchtig (und ausgeschaltet)?",
			values: ["Ja"],
			required: true
		}),
		FormQuestionFactory.SwitchWithTextInputField({
			name: "isWaterRunning",
			title: "Wasser läuft (warm/kalt testen)?",
			values: ["Ja"],
			required: true
		}),
		FormQuestionFactory.TextInput({
			name: "inletAndOutletHoseInformation",
			title: "Wie lang muss der Zu-/Ablaufschlauch sein? Gibt es noch etwas zu beachten beim Aufstellen der Maschine? ",
			required: false
		}),
		FormQuestionFactory.SwitchWithTextInputField({
			name: "areWindowsWorking",
			title: "Fenster funktionstüchtig?",
			values: ["Ja"],
			required: true
		}),
		FormQuestionFactory.SwitchWithTextInputField({
			name: "isApartmentSweptClean",
			title: "Ist die Wohnung insgesamt besenrein? Falls nicht, was muss noch gemacht werden?",
			values: ["Ja"],
			required: true
		}),
		FormQuestionFactory.TextInput({
			name: "curtainOrRollerBlindFittingInformation",
			title: "Können Gardinen / Rollos ohne weiteres angebracht werden? Bei potentiell komplizierten Fenstern bitte Fotos + Gedanken machen!",
			required: true
		}),
		FormQuestionFactory.Upload({
			name: "curtainOrRollerBlindPicture",
			title: "Bilder Upload für Gardinen/Rollos (Falls nötig)",
			required: false
		}),
		FormQuestionFactory.TextInput({
			name: "internetSpeedWithVodafone",
			title: "Wieviel mb/s wurde mit Vodafone gemessen?",
			required: true
		}),
		FormQuestionFactory.Switch({
			name: "broadbandNetworkReceivedByVodafone",
			title: "Welches Breitband Netz wird von Vodafone empfangen? ",
			values: [
				"Keins",
				"E",
				"4G/LTE",
				"5G"
			],
			required: true
		}),
		FormQuestionFactory.TextInput({
			name: "internetSpeedWithTelekom",
			title: "Wieviel mb/s wurde mit Telekom gemessen?",
			required: true
		}),
		FormQuestionFactory.Switch({
			name: "broadbandNetworkReceivedByTelekom",
			title: "Welches Breitband Netz wird von Telekom empfangen? ",
			values: [
				"Keins",
				"E",
				"4G/LTE",
				"5G"
			],
			required: true
		}),
		FormQuestionFactory.SwitchWithTextInputField({
			name: "isBalconyCleanEmpty",
			title: "Ist der Balkon sauber/leer?",
			values: ["Ja"],
			required: true
		}),
		FormQuestionFactory.TextInput({
			name: "individualRequirement",
			title: "Hat die Wohnung individuelle Anforderungen, die für die Möblierung von Bedeutung sind (z.B. Dachschrägen, Stufen in der Wohnung, etc.)?",
			required: true
		}),
		FormQuestionFactory.Upload({
			name: "individialRequirementFile",
			title: "File Upload für individuelle Anforderungen",
			required: false
		}),
		FormQuestionFactory.TextInput({
			name: "obstaclesForDelivery",
			title: "Gibt es irgendwelche Behinderungen, die eine Anlieferung beeinträchtigen könnten (z.B. schmales Treppenhaus, Fahrstuhl kaputt, schmale Türen innerhalb der Wohnung, etc.)? ",
			required: true
		}),
		FormQuestionFactory.Upload({
			name: "eventualDisabilityFile",
			title: "File Upload für eventuelle Behinderungen",
			required: false
		}),
		FormQuestionFactory.Switch({
			name: "hasNische",
			title: "Ist eine Nische zum Lagern von Haushaltsgegenständen vorhanden?",
			values: ["Ja", "Nein"],
			required: true
		}),
		FormQuestionFactory.Upload({
			name: "videoClipOfHouseTour",
			title: "Bitte filme einen Wohnungsrundgang so, dass man jeden Winkel der Wohnung einmal gesehen hat!",
			required: false
		}),
		FormQuestionFactory.Switch({
			name: "isFireAlarmInstalled",
			title: "Sind die Feuermelder angebracht?",
			values: [
				"Ja",
				"Nein",
				"Nein, aber sie liegen bereits in der Wohnung"
			],
			required: true
		}),
		FormQuestionFactory.Upload({
			name: "pictureOfWaterMeterInstalled",
			title: "Ist ein Wasserzähler bereits installiert bzw. vorhanden? Bitte Zähler abfotografieren.",
			required: false
		}),
		FormQuestionFactory.TextInput({
			name: "otherInformation",
			title: "Gibt es weitere ToDos, Anmerkungen, Infos?",
			required: false
		}),
		FormQuestionFactory.SwitchWithTextInputField({
			name: "isKeyReturned",
			title: "Ist der Schlüssel zurückgebracht? ",
			values: ["Ja"],
			required: true
		}),
		FormQuestionFactory.Upload({
			name: "defectFile",
			title: "Upload Defekte",
			required: false
		}),
		FormQuestionFactory.Upload({
			name: "anotherDefectFile",
			title: "Upload weiteres",
			required: false
		})
	];
}));
//#endregion
//#region src/domains/condo-living/index.ts
var init_condo_living = __esmMin((() => {
	init_auth0();
	init_livings_common();
}));
//#endregion
//#region src/domains/condo-living/form.model.ts
var FormType, FormStatus;
var init_form_model = __esmMin((() => {
	FormType = /* @__PURE__ */ function(FormType) {
		FormType["LivingsCheck"] = "LivingsCheck";
		return FormType;
	}({});
	FormStatus = /* @__PURE__ */ function(FormStatus) {
		FormStatus["Draft"] = "Draft";
		FormStatus["Completed"] = "Completed";
		return FormStatus;
	}({});
}));
//#endregion
//#region src/domains/transaction/location-profile/location-profile.model.ts
var init_location_profile_model = __esmMin((() => {}));
//#endregion
//#region src/domains/transaction/location-profile/location-profile.helpers.ts
var locationProfileToDto;
var init_location_profile_helpers = __esmMin((() => {
	locationProfileToDto = (locationProfile) => {
		return pick(locationProfile, [
			"locationProfileId",
			"name",
			"author",
			"sellingRegionId",
			"titlePicture",
			"mapPicture",
			"attributes"
		]);
	};
}));
//#endregion
//#region src/domains/transaction/location-profile/index.ts
var init_location_profile = __esmMin((() => {
	init_location_profile_model();
	init_location_profile_helpers();
}));
//#endregion
//#region src/domains/purchasing/inspection/purchasing-inspection.opts.ts
var PurchasingInspectionEstatePositionCategory, PurchasingInspectionEstatePositionCategoryTranslation, PurchasingInspectionGuestToiletStorageRoomAfterRenovationOptions, PurchasingInspectionGuestToiletStorageRoomAfterRenovationOptionsTranslation, PurchsaingInspectionReplaceWindowsCostRegulation, PurchasingInspectionReplaceWindowsCostRegulationTranslation, PurchasingInspectionAmenityCondition, PurchasingInspectionAmenityConditionTranslation, PurchasingInspectionFloorType, PurchasingInspectionFloorTypeTranslation, PurchasingInspectionBeltWindersLocation, PurchasingInspectionBeltWindersLocationTranslation, PurchasingInspectionHeatingDeviceType, PurchasingInspectionHeatingDeviceTypeTranslation, PurchasingInspectionWaterHeatingDeviceType, PurchasingInspectionWaterHeatingDeviceTypeTranslation, PurchasingInspectionPublicTransportConnection, PurchasingInspectionPublicTransportConnectionTranslation, PurchasingInspectionBuildingOverallCondition, PurchasingInspectionBuildingOverallConditionTranslation, PurchasingInspectionBuildingOutsideFacadeCondition, PurchasingInspectionBuildingOutsideFacadeConditionTranslation, PurchasingInspectionBuildingOutsideFacadeType, PurchasingInspectionBuildingOutsideFacadeTypeTranslation, PurchasingInspectionBuildingRoofType, PurchasingInspectionBuildingRoofTypeTranslation, PurchasingInspectionCommonArea, PurchasingInspectionCommonAreaTranslation, PurchasingInspectionApartmentTypeTranslation, PurchasingInspectionFloor, PurchasingInspectionFloorMap, PurchasingInspectionFloorTranslation, PurchasingInspectionFloorLocationTranslation, PurchasingInspectionParkingSpaceTypeTranslation, PurchasingInspectionNotClearYesNoRadioOptions;
var init_purchasing_inspection_opts = __esmMin((() => {
	init_estates();
	PurchasingInspectionEstatePositionCategory = /* @__PURE__ */ function(PurchasingInspectionEstatePositionCategory) {
		PurchasingInspectionEstatePositionCategory["Easy"] = "Easy";
		PurchasingInspectionEstatePositionCategory["EasyToMedium"] = "Easy - Medium";
		PurchasingInspectionEstatePositionCategory["Medium"] = "Medium";
		PurchasingInspectionEstatePositionCategory["MediumToGood"] = "Medium - Good";
		PurchasingInspectionEstatePositionCategory["Good"] = "Good";
		return PurchasingInspectionEstatePositionCategory;
	}({});
	PurchasingInspectionEstatePositionCategoryTranslation = {
		["Easy"]: "Einfach",
		["Easy - Medium"]: "Einfach - Mittel",
		["Medium"]: "Mittel",
		["Medium - Good"]: "Mittel - Gute",
		["Good"]: "Gut"
	};
	PurchasingInspectionGuestToiletStorageRoomAfterRenovationOptions = /* @__PURE__ */ function(PurchasingInspectionGuestToiletStorageRoomAfterRenovationOptions) {
		PurchasingInspectionGuestToiletStorageRoomAfterRenovationOptions["GuestToilet"] = "GuestToilet";
		PurchasingInspectionGuestToiletStorageRoomAfterRenovationOptions["StorageRoom"] = "StorageRoom";
		PurchasingInspectionGuestToiletStorageRoomAfterRenovationOptions["None"] = "None";
		return PurchasingInspectionGuestToiletStorageRoomAfterRenovationOptions;
	}({});
	PurchasingInspectionGuestToiletStorageRoomAfterRenovationOptionsTranslation = {
		["GuestToilet"]: "Gäste WC",
		["StorageRoom"]: "Abstellraum",
		["None"]: "Nichts von Beidem"
	};
	PurchsaingInspectionReplaceWindowsCostRegulation = /* @__PURE__ */ function(PurchsaingInspectionReplaceWindowsCostRegulation) {
		PurchsaingInspectionReplaceWindowsCostRegulation["HomeOwnerAssociation"] = "HomeOwnerAssociation";
		PurchsaingInspectionReplaceWindowsCostRegulation["HomeOwner"] = "HomeOwner";
		return PurchsaingInspectionReplaceWindowsCostRegulation;
	}({});
	PurchasingInspectionReplaceWindowsCostRegulationTranslation = {
		["HomeOwnerAssociation"]: "WEG",
		["HomeOwner"]: "Eigentümer"
	};
	PurchasingInspectionAmenityCondition = /* @__PURE__ */ function(PurchasingInspectionAmenityCondition) {
		PurchasingInspectionAmenityCondition["Poor"] = "Poor";
		PurchasingInspectionAmenityCondition["Medium"] = "Medium";
		PurchasingInspectionAmenityCondition["Good"] = "Good";
		return PurchasingInspectionAmenityCondition;
	}({});
	PurchasingInspectionAmenityConditionTranslation = {
		["Poor"]: "Schlecht",
		["Medium"]: "Mittel",
		["Good"]: "Gut"
	};
	PurchasingInspectionFloorType = /* @__PURE__ */ function(PurchasingInspectionFloorType) {
		PurchasingInspectionFloorType["Laminate"] = "Laminate";
		PurchasingInspectionFloorType["Parquet"] = "Parquet";
		PurchasingInspectionFloorType["Tiles"] = "Tiles";
		PurchasingInspectionFloorType["PVC"] = "PVC";
		PurchasingInspectionFloorType["Carpet"] = "Carpet";
		PurchasingInspectionFloorType["CarpetOnOldFloor"] = "CarpetOnOldFloor";
		return PurchasingInspectionFloorType;
	}({});
	PurchasingInspectionFloorTypeTranslation = {
		["Laminate"]: "Laminat / Vinyl",
		["Parquet"]: "Dielen / Parkett",
		["Tiles"]: "Fliesen",
		["PVC"]: "PVC",
		["Carpet"]: "Teppich",
		["CarpetOnOldFloor"]: "Teppich auf Altboden"
	};
	PurchasingInspectionBeltWindersLocation = /* @__PURE__ */ function(PurchasingInspectionBeltWindersLocation) {
		PurchasingInspectionBeltWindersLocation["Internal"] = "Internal";
		PurchasingInspectionBeltWindersLocation["External"] = "External";
		return PurchasingInspectionBeltWindersLocation;
	}({});
	PurchasingInspectionBeltWindersLocationTranslation = {
		["Internal"]: "Innenliegend",
		["External"]: "Außenliegend"
	};
	PurchasingInspectionHeatingDeviceType = /* @__PURE__ */ function(PurchasingInspectionHeatingDeviceType) {
		PurchasingInspectionHeatingDeviceType["GasCombinationBoiler"] = "GasCombinationBoiler";
		PurchasingInspectionHeatingDeviceType["GasBoiler"] = "GasBoiler";
		PurchasingInspectionHeatingDeviceType["GasRadiator"] = "GasRadiator";
		PurchasingInspectionHeatingDeviceType["Oven"] = "Oven";
		PurchasingInspectionHeatingDeviceType["ElectricRadiator"] = "ElectricRadiator";
		PurchasingInspectionHeatingDeviceType["NightStorageHeater"] = "NightStorageHeater";
		return PurchasingInspectionHeatingDeviceType;
	}({});
	PurchasingInspectionHeatingDeviceTypeTranslation = {
		["GasCombinationBoiler"]: "Gas-Kombi-Therme",
		["GasBoiler"]: "Gastherme",
		["GasRadiator"]: "Gasheizkörper",
		["Oven"]: "Ofen",
		["ElectricRadiator"]: "Elektroheizkörper",
		["NightStorageHeater"]: "Nachtspeicherheizung"
	};
	PurchasingInspectionWaterHeatingDeviceType = /* @__PURE__ */ function(PurchasingInspectionWaterHeatingDeviceType) {
		PurchasingInspectionWaterHeatingDeviceType["ElectricInstantaneousWaterHeater"] = "ElectricInstantaneousWaterHeater";
		PurchasingInspectionWaterHeatingDeviceType["GasInstantaneousWaterHeater"] = "GasInstantaneousWaterHeater";
		PurchasingInspectionWaterHeatingDeviceType["Boiler"] = "Boiler";
		PurchasingInspectionWaterHeatingDeviceType["GasCombinationHeater"] = "GasCombinationHeater";
		return PurchasingInspectionWaterHeatingDeviceType;
	}({});
	PurchasingInspectionWaterHeatingDeviceTypeTranslation = {
		["ElectricInstantaneousWaterHeater"]: "Elektro-Durchlauferhitzer",
		["GasInstantaneousWaterHeater"]: "Gas-Durchlauferhitzer",
		["Boiler"]: "Boiler",
		["GasCombinationHeater"]: "Gas-Kombi-Therme"
	};
	PurchasingInspectionPublicTransportConnection = /* @__PURE__ */ function(PurchasingInspectionPublicTransportConnection) {
		PurchasingInspectionPublicTransportConnection["Bus"] = "Bus";
		PurchasingInspectionPublicTransportConnection["Subway"] = "Subway";
		PurchasingInspectionPublicTransportConnection["Sbahn"] = "Sbahn";
		PurchasingInspectionPublicTransportConnection["LongDistanceTraffic"] = "LongDistanceTraffic";
		PurchasingInspectionPublicTransportConnection["Tram"] = "Tram";
		PurchasingInspectionPublicTransportConnection["Ferry"] = "Ferry";
		return PurchasingInspectionPublicTransportConnection;
	}({});
	PurchasingInspectionPublicTransportConnectionTranslation = {
		["Bus"]: "Bus",
		["Subway"]: "U-Bahn",
		["Sbahn"]: "S-Bahn",
		["LongDistanceTraffic"]: "Fernverkehr",
		["Tram"]: "Straßenbahn",
		["Ferry"]: "Fähre"
	};
	PurchasingInspectionBuildingOverallCondition = /* @__PURE__ */ function(PurchasingInspectionBuildingOverallCondition) {
		PurchasingInspectionBuildingOverallCondition["VeryGood"] = "VeryGood";
		PurchasingInspectionBuildingOverallCondition["Good"] = "Good";
		PurchasingInspectionBuildingOverallCondition["Satisfactory"] = "Satisfactory";
		PurchasingInspectionBuildingOverallCondition["Unsatisfactory"] = "Unsatisfactory";
		return PurchasingInspectionBuildingOverallCondition;
	}({});
	PurchasingInspectionBuildingOverallConditionTranslation = {
		["VeryGood"]: "Sehr gut",
		["Good"]: "Gut",
		["Satisfactory"]: "Befriedigend",
		["Unsatisfactory"]: "Unbefriedigend"
	};
	PurchasingInspectionBuildingOutsideFacadeCondition = /* @__PURE__ */ function(PurchasingInspectionBuildingOutsideFacadeCondition) {
		PurchasingInspectionBuildingOutsideFacadeCondition["VeryGood"] = "VeryGood";
		PurchasingInspectionBuildingOutsideFacadeCondition["Good"] = "Good";
		PurchasingInspectionBuildingOutsideFacadeCondition["Satisfactory"] = "Satisfactory";
		PurchasingInspectionBuildingOutsideFacadeCondition["Unsatisfactory"] = "Unsatisfactory";
		return PurchasingInspectionBuildingOutsideFacadeCondition;
	}({});
	PurchasingInspectionBuildingOutsideFacadeConditionTranslation = {
		["VeryGood"]: "Sehr gut",
		["Good"]: "Gut",
		["Satisfactory"]: "Befriedigend",
		["Unsatisfactory"]: "Unbefriedigend"
	};
	PurchasingInspectionBuildingOutsideFacadeType = /* @__PURE__ */ function(PurchasingInspectionBuildingOutsideFacadeType) {
		PurchasingInspectionBuildingOutsideFacadeType["BrickFacade"] = "BrickFacade";
		PurchasingInspectionBuildingOutsideFacadeType["WoodFacade"] = "WoodFacade";
		PurchasingInspectionBuildingOutsideFacadeType["PlasterFacade"] = "PlasterFacade";
		PurchasingInspectionBuildingOutsideFacadeType["TimberFrame"] = "TimberFrame";
		PurchasingInspectionBuildingOutsideFacadeType["SolidFacade"] = "SolidFacade";
		PurchasingInspectionBuildingOutsideFacadeType["Cladding"] = "Cladding";
		PurchasingInspectionBuildingOutsideFacadeType["WDVS"] = "WDVS";
		return PurchasingInspectionBuildingOutsideFacadeType;
	}({});
	PurchasingInspectionBuildingOutsideFacadeTypeTranslation = {
		["BrickFacade"]: "Klinkerfassade",
		["WoodFacade"]: "Holzfassade",
		["PlasterFacade"]: "Putzfassade",
		["TimberFrame"]: "Fachwerk",
		["SolidFacade"]: "Massivfassade",
		["Cladding"]: "Verschalung",
		["WDVS"]: "WDVS"
	};
	PurchasingInspectionBuildingRoofType = /* @__PURE__ */ function(PurchasingInspectionBuildingRoofType) {
		PurchasingInspectionBuildingRoofType["FlatRoof"] = "FlatRoof";
		PurchasingInspectionBuildingRoofType["GableRoof"] = "GableRoof";
		PurchasingInspectionBuildingRoofType["HipRoof"] = "HipRoof";
		PurchasingInspectionBuildingRoofType["HalfHipRoof"] = "HalfHipRoof";
		PurchasingInspectionBuildingRoofType["ShedRoof"] = "ShedRoof";
		return PurchasingInspectionBuildingRoofType;
	}({});
	PurchasingInspectionBuildingRoofTypeTranslation = {
		["FlatRoof"]: "Flachdach",
		["GableRoof"]: "Satteldach",
		["HipRoof"]: "Walmdach",
		["HalfHipRoof"]: "Krüppelwalmdach",
		["ShedRoof"]: "Pultdach"
	};
	PurchasingInspectionCommonArea = /* @__PURE__ */ function(PurchasingInspectionCommonArea) {
		PurchasingInspectionCommonArea["BicycleRoom"] = "BicycleRoom";
		PurchasingInspectionCommonArea["DryRoom"] = "DryRoom";
		PurchasingInspectionCommonArea["LaundryRoom"] = "LaundryRoom";
		PurchasingInspectionCommonArea["SwimmingPool"] = "SwimmingPool";
		PurchasingInspectionCommonArea["Sauna"] = "Sauna";
		PurchasingInspectionCommonArea["FitnessRoom"] = "FitnessRoom";
		PurchasingInspectionCommonArea["PartyRoom"] = "PartyRoom";
		PurchasingInspectionCommonArea["Other"] = "Other";
		return PurchasingInspectionCommonArea;
	}({});
	PurchasingInspectionCommonAreaTranslation = {
		["BicycleRoom"]: "Fahrradraum",
		["DryRoom"]: "Trockenraum",
		["LaundryRoom"]: "Waschküche",
		["SwimmingPool"]: "Schwimmbad",
		["Sauna"]: "Sauna",
		["FitnessRoom"]: "Fitnessraum",
		["PartyRoom"]: "Partyraum",
		["Other"]: "Sonstiges"
	};
	PurchasingInspectionApartmentTypeTranslation = {
		["HalfBasement"]: "Souterrain",
		["GroundFloor"]: "Erdgeschoss",
		["RaisedGroundFloor"]: "Hochparterre",
		["Apartment"]: "Etagenwohnung",
		["Loft"]: "Loft",
		["Maisonette"]: "Maisonette",
		["TerracedFlat"]: "Terassenwohnung",
		["Penthouse"]: "Penthouse",
		["RoofStorey"]: "Dachgeschoss",
		["Other"]: "Sonstige"
	};
	PurchasingInspectionFloor = /* @__PURE__ */ function(PurchasingInspectionFloor) {
		PurchasingInspectionFloor["Basement"] = "Basement";
		PurchasingInspectionFloor["GroundFloor"] = "GroundFloor";
		PurchasingInspectionFloor["Mezzanine"] = "Mezzanine";
		return PurchasingInspectionFloor;
	}({});
	PurchasingInspectionFloorMap = {
		["Basement"]: -1,
		["GroundFloor"]: 0,
		["Mezzanine"]: 1
	};
	PurchasingInspectionFloorTranslation = {
		["Basement"]: "Souterrain",
		["GroundFloor"]: "Erdgeschoss",
		["Mezzanine"]: "Hochparterre"
	};
	PurchasingInspectionFloorLocationTranslation = {
		["R"]: "R",
		["MR"]: "MR",
		["M"]: "M",
		["ML"]: "ML",
		["L"]: "L",
		["TG"]: "TG",
		["HP"]: "HP",
		["Garage"]: "Garage",
		["OpenAir"]: "Außen"
	};
	PurchasingInspectionParkingSpaceTypeTranslation = {
		["UndergroundGarage"]: "Tiefgarage",
		["Garage"]: "Garage",
		["Carport"]: "Carport",
		["Outside"]: "Stellplatz",
		["Duplex"]: "Duplex",
		["CarPark"]: "Parkhaus",
		["StreetParking"]: "Straßenparkplatz",
		["NoInformation"]: "Keine Angabe",
		["NA"]: "Nicht vorhanden"
	};
	PurchasingInspectionNotClearYesNoRadioOptions = /* @__PURE__ */ function(PurchasingInspectionNotClearYesNoRadioOptions) {
		PurchasingInspectionNotClearYesNoRadioOptions["NotClear"] = "Not Clear";
		PurchasingInspectionNotClearYesNoRadioOptions["Yes"] = "Yes";
		PurchasingInspectionNotClearYesNoRadioOptions["No"] = "No";
		return PurchasingInspectionNotClearYesNoRadioOptions;
	}({});
}));
//#endregion
//#region src/domains/purchasing/inspection/purchasing-inspection.ts
var PurchasingChecklistQuestion, PurchasingInspectionQuestions;
var init_purchasing_inspection = __esmMin((() => {
	init_energy_efficiency();
	init_estates();
	init_form_question();
	init_purchasing_inspection_opts();
	PurchasingChecklistQuestion = /* @__PURE__ */ function(PurchasingChecklistQuestion) {
		PurchasingChecklistQuestion["EstatePositionCategory"] = "estatePositionCategory";
		PurchasingChecklistQuestion["EstateLocationRating"] = "estateLocationRating";
		PurchasingChecklistQuestion["IsSocialConservationArea"] = "isSocialConservationArea";
		PurchasingChecklistQuestion["SocialConservationArea"] = "socialConservationArea";
		PurchasingChecklistQuestion["IsHeritage"] = "isHeritage";
		PurchasingChecklistQuestion["Heritage"] = "heritage";
		PurchasingChecklistQuestion["IsRedevelopmentArea"] = "isRedevelopmentArea";
		PurchasingChecklistQuestion["RedevelopmentArea"] = "redevelopmentArea";
		PurchasingChecklistQuestion["PublicTransportConnections"] = "publicTransportConnections";
		PurchasingChecklistQuestion["BuildingOverallCondition"] = "buildingOverallCondition";
		PurchasingChecklistQuestion["BuildingOutsideFacadeCondition"] = "buildingOutsideFacadeCondition";
		PurchasingChecklistQuestion["BuildingOutsideFacadeType"] = "buildingOutsideFacadeType";
		PurchasingChecklistQuestion["BuildingRoofType"] = "buildingRoofType";
		PurchasingChecklistQuestion["IsNumberOfRoomsAfterRenovationDifferent"] = "isNumberOfRoomsAfterRenovationDifferent";
		PurchasingChecklistQuestion["RoomsAfterRenovation"] = "roomsAfterRenovation";
		PurchasingChecklistQuestion["Floor"] = "floor";
		PurchasingChecklistQuestion["FloorLocation"] = "floorLocation";
		PurchasingChecklistQuestion["IsLivingAreaUnrealistic"] = "isLivingAreaUnrealistic";
		PurchasingChecklistQuestion["LivingAreaChangeMessage"] = "livingAreaChangeMessage";
		PurchasingChecklistQuestion["NewLivingArea"] = "newLivingArea";
		PurchasingChecklistQuestion["ShouldRenovateAdditionalUsableArea"] = "shouldRenovateAdditionalUsableArea";
		PurchasingChecklistQuestion["AdditionalArea"] = "additionalArea";
		PurchasingChecklistQuestion["RenovationCostsPerSqM"] = "renovationCostsPerSqM";
		PurchasingChecklistQuestion["IncludesUnrecoverableDamage"] = "includesUnrecoverableDamage";
		PurchasingChecklistQuestion["RepairingUnrecoverableDamageCosts"] = "repairingUnrecoverableDamageCosts";
		PurchasingChecklistQuestion["HasResultingAdditionalCosts"] = "hasResultingAdditionalCosts";
		PurchasingChecklistQuestion["ResultingAdditionalCosts"] = "resultingAdditionalCosts";
		PurchasingChecklistQuestion["HasGuestToiletAfterRenovation"] = "hasGuestToiletAfterRenovation";
		PurchasingChecklistQuestion["GuestToiletAfterRenovation"] = "guestToiletAfterRenovation";
		PurchasingChecklistQuestion["HasStorageRoom"] = "hasStorageRoom";
		PurchasingChecklistQuestion["StorageRoomAfterRenovation"] = "storageRoomAfterRenovation";
		PurchasingChecklistQuestion["HasCellar"] = "hasCellar";
		PurchasingChecklistQuestion["CellarNumber"] = "cellarNumber";
		PurchasingChecklistQuestion["ShouldCleanCellar"] = "shouldCleanCellar";
		PurchasingChecklistQuestion["CellarCleaningCosts"] = "cellarCleaningCosts";
		PurchasingChecklistQuestion["CommonAreas"] = "commonAreas";
		PurchasingChecklistQuestion["HasAttic"] = "hasAttic";
		PurchasingChecklistQuestion["AtticNumber"] = "atticNumber";
		PurchasingChecklistQuestion["ShouldCleanAttic"] = "shouldCleanAttic";
		PurchasingChecklistQuestion["HasParkingSpace"] = "hasParkingSpace";
		PurchasingChecklistQuestion["ParkingSpaces"] = "parkingSpaces";
		PurchasingChecklistQuestion["ParkingSpaceType"] = "parkingSpaceType";
		PurchasingChecklistQuestion["ParkingSpaceNumber"] = "parkingSpaceNumber";
		PurchasingChecklistQuestion["IsParkingSpaceRegistered"] = "isParkingSpaceRegistered";
		PurchasingChecklistQuestion["ParkingSpaceRegisterPage"] = "parkingSpaceRegisterPage";
		PurchasingChecklistQuestion["ParkingSpaceRegisterBand"] = "parkingSpaceRegisterBand";
		PurchasingChecklistQuestion["ShouldCleanParkingSpace"] = "shouldCleanParkingSpace";
		PurchasingChecklistQuestion["HasGarden"] = "hasGarden";
		PurchasingChecklistQuestion["ShouldCleanGarden"] = "shouldCleanGarden";
		PurchasingChecklistQuestion["HasBuiltInKitchen"] = "hasBuiltInKitchen";
		PurchasingChecklistQuestion["BuiltInKitchenDisposalCosts"] = "builtInKitchenDisposalCosts";
		PurchasingChecklistQuestion["HasExtensiveCleaningCosts"] = "hasExtensiveCleaningCosts";
		PurchasingChecklistQuestion["ExtensiveCleaningCosts"] = "extensiveCleaningCosts";
		PurchasingChecklistQuestion["HasOtherUsages"] = "hasOtherUsages";
		PurchasingChecklistQuestion["OtherUsages"] = "otherUsages";
		PurchasingChecklistQuestion["HasLift"] = "hasLift";
		PurchasingChecklistQuestion["ParapetHeight"] = "parapetHeight";
		PurchasingChecklistQuestion["HasBalcony"] = "hasBalcony";
		PurchasingChecklistQuestion["HasTerrace"] = "hasTerrace";
		PurchasingChecklistQuestion["ShouldRefurbishBalconyParapet"] = "shouldRefurbishBalconyParapet";
		PurchasingChecklistQuestion["ShouldRefurbishBalconyFloor"] = "shouldRefurbishBalconyFloor";
		PurchasingChecklistQuestion["ShouldRefurbishBalconyWallAndCeiling"] = "shouldRefurbishBalconyWallAndCeiling";
		PurchasingChecklistQuestion["ShouldRefurbishTerraceParapet"] = "shouldRefurbishTerraceParapet";
		PurchasingChecklistQuestion["ShouldRefurbishTerraceFloor"] = "shouldRefurbishTerraceFloor";
		PurchasingChecklistQuestion["ShouldRefurbishTerraceWallAndCeiling"] = "shouldRefurbishTerraceWallAndCeiling";
		PurchasingChecklistQuestion["StairCaseCondition"] = "stairCaseCondition";
		PurchasingChecklistQuestion["BalconyCondition"] = "balconyCondition";
		PurchasingChecklistQuestion["EnteranceDoorCondition"] = "enteranceDoorCondition";
		PurchasingChecklistQuestion["DoorLabelCondition"] = "doorLabelCondition";
		PurchasingChecklistQuestion["OutdoorAreaCondition"] = "outdoorAreaCondition";
		PurchasingChecklistQuestion["PostBoxCondition"] = "postBoxCondition";
		PurchasingChecklistQuestion["CommunityPropertyCondition"] = "communityPropertyCondition";
		PurchasingChecklistQuestion["ApartmentTypeChangeMessage"] = "apartmentTypeChangeMessage";
		PurchasingChecklistQuestion["ApartmentType"] = "apartmentType";
		PurchasingChecklistQuestion["FloorType"] = "floorType";
		PurchasingChecklistQuestion["IsFloorWorthKeeping"] = "isFloorWorthKeeping";
		PurchasingChecklistQuestion["FloorSpace"] = "floorSpace";
		PurchasingChecklistQuestion["SecondaryFloorType"] = "secondaryFloorType";
		PurchasingChecklistQuestion["IsSecondaryFloorWorthKeeping"] = "isSecondaryFloorWorthKeeping";
		PurchasingChecklistQuestion["SecondaryFloorSpace"] = "secondaryFloorSpace";
		PurchasingChecklistQuestion["IsAsbestosSuspected"] = "isAsbestosSuspected";
		PurchasingChecklistQuestion["AsbestosArea"] = "asbestosArea";
		PurchasingChecklistQuestion["NumberOfWallsToBeMoved"] = "numberOfWallsToBeMoved";
		PurchasingChecklistQuestion["IsRoomCeilingHigherThan2_5Meters"] = "isRoomCeilingHigherThan2_5Meters";
		PurchasingChecklistQuestion["HollowPlasterArea"] = "hollowPlasterArea";
		PurchasingChecklistQuestion["HasVisibleCracksInCeiling"] = "hasVisibleCracksInCeiling";
		PurchasingChecklistQuestion["VisibleCracksInCeilingLength"] = "visibleCracksInCeilingLength";
		PurchasingChecklistQuestion["HasVisibleCracksInInteriorWalls"] = "hasVisibleCracksInInteriorWalls";
		PurchasingChecklistQuestion["VisibleCracksInInteriorWallsLength"] = "visibleCracksInInteriorWallsLength";
		PurchasingChecklistQuestion["HasVisibleCracksInExteriorWalls"] = "hasVisibleCracksInExteriorWalls";
		PurchasingChecklistQuestion["HasSevereCracksInExteriorWalls"] = "hasSevereCracksInExteriorWalls";
		PurchasingChecklistQuestion["VisibleCracksInExteriorWallsCosts"] = "visibleCracksInExteriorWallsCosts";
		PurchasingChecklistQuestion["HasStuccoAndNeedsRenovation"] = "hasStuccoAndNeedsRenovation";
		PurchasingChecklistQuestion["StuccoLengthWorthPreserving"] = "stuccoLengthWorthPreserving";
		PurchasingChecklistQuestion["HasVisibleMoistureInWallsAndCeilings"] = "hasVisibleMoistureInWallsAndCeilings";
		PurchasingChecklistQuestion["VisibleMoistureInWallsAndCeilingsArea"] = "visibleMoistureInWallsAndCeilingsArea";
		PurchasingChecklistQuestion["HasVisibleMoistureInWindows"] = "hasVisibleMoistureInWindows";
		PurchasingChecklistQuestion["VisibleMoistureInWindowsArea"] = "visibleMoistureInWindowsArea";
		PurchasingChecklistQuestion["HasStairsInLivingArea"] = "hasStairsInLivingArea";
		PurchasingChecklistQuestion["StairsInLivingAreaCosts"] = "stairsInLivingAreaCosts";
		PurchasingChecklistQuestion["ShouldReplaceRegularDoors"] = "shouldReplaceRegularDoors";
		PurchasingChecklistQuestion["ShouldReplaceWindows"] = "shouldReplaceWindows";
		PurchasingChecklistQuestion["ReplaceWindowsCostRegulation"] = "replaceWindowsCostRegulation";
		PurchasingChecklistQuestion["ToReplaceWindowsAtOurCosts"] = "toReplaceWindowsAtOurCosts";
		PurchasingChecklistQuestion["NumberOfRegularDoorsToReplace"] = "numberOfRegularDoorsToReplace";
		PurchasingChecklistQuestion["ShouldReplaceHistoricalDoors"] = "shouldReplaceHistoricalDoors";
		PurchasingChecklistQuestion["NumberOfHistoricalDoorsToReplace"] = "numberOfHistoricalDoorsToReplace";
		PurchasingChecklistQuestion["ShouldReplacePlasticWindows"] = "shouldReplacePlasticWindows";
		PurchasingChecklistQuestion["NumberOfPlasticWindowsToReplace"] = "numberOfPlasticWindowsToReplace";
		PurchasingChecklistQuestion["ShouldReplaceWoodenWindows"] = "shouldReplaceWoodenWindows";
		PurchasingChecklistQuestion["NumberOfWoodenWindowsToReplace"] = "numberOfWoodenWindowsToReplace";
		PurchasingChecklistQuestion["ShouldReplaceMetalWindows"] = "shouldReplaceMetalWindows";
		PurchasingChecklistQuestion["NumberOfMetalWindowsToReplace"] = "numberOfMetalWindowsToReplace";
		PurchasingChecklistQuestion["ShouldReplaceDoubleBoxWindows"] = "shouldReplaceDoubleBoxWindows";
		PurchasingChecklistQuestion["NumberOfDoubleBoxWindows"] = "numberOfDoubleBoxWindows";
		PurchasingChecklistQuestion["ShouldReplaceIsoWindows"] = "shouldReplaceIsoWindows";
		PurchasingChecklistQuestion["NumberOfIsoWindows"] = "numberOfIsoWindows";
		PurchasingChecklistQuestion["ShouldReplaceSingleGlazedWindows"] = "shouldReplaceSingleGlazedWindows";
		PurchasingChecklistQuestion["NumberOfSingleGlazedWindowsToReplace"] = "numberOfSingleGlazedWindowsToReplace";
		PurchasingChecklistQuestion["ConstructionYear"] = "constructionYear";
		PurchasingChecklistQuestion["HasBeltWinder"] = "hasBeltWinder";
		PurchasingChecklistQuestion["BeltWindersLocation"] = "beltWindersLocation";
		PurchasingChecklistQuestion["ShouldReplaceBeltWinder"] = "shouldReplaceBeltWinder";
		PurchasingChecklistQuestion["NumberOfBeltWindersToReplace"] = "numberOfBeltWindersToReplace";
		PurchasingChecklistQuestion["NumberOfBeltWindersThatCanBeClosed"] = "numberOfBeltWindersThatCanBeClosed";
		PurchasingChecklistQuestion["ShouldReplaceMeter"] = "shouldReplaceMeter";
		PurchasingChecklistQuestion["HasThreePhaseCurrentConnection"] = "hasNoThreePhaseCurrentConnection";
		PurchasingChecklistQuestion["ThreePhaseConnectionUpgradeCosts"] = "threePhaseConnectionUpgradeCosts";
		PurchasingChecklistQuestion["HasElectroSubDistributionBoard"] = "hasElectroSubDistributionBoard";
		PurchasingChecklistQuestion["IsHouseConnectionNotSufficient"] = "isHouseConnectionNotSufficient";
		PurchasingChecklistQuestion["EnergyConsumptionCategory"] = "energyConsumptionCategory";
		PurchasingChecklistQuestion["IsEnergyEfficiencyUpgradable"] = "isEnergyEfficiencyUpgradable";
		PurchasingChecklistQuestion["Handover"] = "handover";
		PurchasingChecklistQuestion["IssueDate"] = "issueDate";
		PurchasingChecklistQuestion["HasBadStrands"] = "hasBadStrands";
		PurchasingChecklistQuestion["LineHasBeenRenovated"] = "lineHasBeenRenovated";
		PurchasingChecklistQuestion["HasSuspectedLead"] = "hasSuspectedLead";
		PurchasingChecklistQuestion["HasWcWaterDirectlyThroughTheFloor"] = "hasWcWaterDirectlyThroughTheFloor";
		PurchasingChecklistQuestion["IsGasPipeRoutingVisibleOnTheCeiling"] = "isGasPipeRoutingVisibleOnTheCeiling";
		PurchasingChecklistQuestion["HasHeatingCablesLaidOnPlaster"] = "hasHeatingCablesLaidOnPlaster";
		PurchasingChecklistQuestion["IsCentralHeatingAvailable"] = "isCentralHeatingAvailable";
		PurchasingChecklistQuestion["CentralHeatingConstructionYear"] = "centralHeatingConstructionYear";
		PurchasingChecklistQuestion["CentralHeatingDeviceType"] = "centralHeatingDeviceType";
		PurchasingChecklistQuestion["DecentralisedHeatingDeviceType"] = "decentralisedHeatingDeviceType";
		PurchasingChecklistQuestion["IsDecentralisedHeatingDeviceWorthPreserving"] = "isDecentralisedHeatingDeviceWorthPreserving";
		PurchasingChecklistQuestion["IsCentralHotWaterAvailable"] = "isCentralHotWaterAvailable";
		PurchasingChecklistQuestion["DecentralisedWaterHeatingDeviceType"] = "decentralisedWaterHeatingDeviceType";
		PurchasingChecklistQuestion["IsDecentralisedWaterHeatingDeviceWorthPreserving"] = "isDecentralisedWaterHeatingDeviceWorthPreserving";
		return PurchasingChecklistQuestion;
	}({});
	PurchasingInspectionQuestions = [
		["Umgebung", [["Viertel/Lage", [
			FormQuestionFactory.SelectBox({
				title: "Lage",
				name: "estateLocationRating",
				required: true,
				values: Object.entries(locationRatingTransalations).map(([value, label]) => ({
					value,
					label
				})),
				hint: "Rentindex Klassifizierung der Lage"
			}),
			FormQuestionFactory.Toggle({
				title: "Soziales Erhaltungsgebiet?",
				name: "isSocialConservationArea",
				format: "three_state",
				defaultValue: null,
				required: true,
				hint: "Zusätzliche Renovierungs Kosten durch Soziales Erhaltungsgebiet"
			}),
			FormQuestionFactory.Number({
				title: "Soziales Erhaltungsgebiet",
				name: "socialConservationArea",
				format: "euro_per_meter_squared",
				min: 0,
				minimumFractionDigits: 0,
				maximumFractionDigits: 2,
				step: .1,
				required: true,
				guards: [{
					name: "isSocialConservationArea",
					value: true
				}],
				hint: "Zusätzliche Renovierungs Kosten durch Soziales Erhaltungsgebiet in Eur pro Quadratmeter"
			}),
			FormQuestionFactory.Toggle({
				title: "Denkmalschutz?",
				name: "isHeritage",
				format: "three_state",
				defaultValue: null,
				required: true,
				hintValueEntityField: {
					entity: "estate",
					attributePath: "attributes.isHeritageBuilding"
				},
				hintTemplate: "Denkmalschutz: {{value}} - Zusätzliche Renovierungs Kosten durch Denkmalschutz"
			}),
			FormQuestionFactory.Number({
				title: "Denkmalschutz",
				name: "heritage",
				format: "euro_per_meter_squared",
				min: 0,
				minimumFractionDigits: 0,
				maximumFractionDigits: 2,
				step: .1,
				required: true,
				guards: [{
					name: "isHeritage",
					value: true
				}],
				hint: "Zusätzliche Renovierungs Kosten durch Denkmalschutz in Eur pro Quadratmeter"
			}),
			FormQuestionFactory.Toggle({
				title: "Sanierungsgebiet?",
				name: "isRedevelopmentArea",
				format: "three_state",
				defaultValue: null,
				required: true,
				hintValueEntityField: {
					entity: "estate",
					attributePath: "attributes.isRedevelopmentArea"
				},
				hintTemplate: "Sanierungsgebiet: {{value}} - Zusätzliche Renovierungs Kosten durch Sanierungsgebiet"
			}),
			FormQuestionFactory.Number({
				title: "Sanierungsgebiet",
				name: "redevelopmentArea",
				format: "euro_per_meter_squared",
				min: 0,
				minimumFractionDigits: 0,
				maximumFractionDigits: 2,
				step: .1,
				required: true,
				guards: [{
					name: "isRedevelopmentArea",
					value: true
				}],
				hint: "Zusätzliche Renovierungs Kosten durch Sanierungsgebiet in Eur pro Quadratmeter"
			})
		]], ["Unmittelbare Umgebung", [FormQuestionFactory.MultiSelectBox({
			title: "ÖPNV-Verbindungen",
			name: "publicTransportConnections",
			values: Object.entries(PurchasingInspectionPublicTransportConnectionTranslation).map(([value, label]) => ({
				value,
				label
			})),
			hint: "Auswahl der nächstgelegenen öffentlichen Verkehrsverbindung"
		})]]]],
		["Gebäude", [
			["Allgemein", [FormQuestionFactory.Date({
				title: `Baujahr`,
				name: "constructionYear",
				format: "year_date",
				required: true,
				valueOnClear: null,
				hintValueEntityField: {
					entity: "estate",
					attributePath: "attributes.constructionYear"
				},
				hintTemplate: "Baujahr der Immobilie: {{value}}"
			}), FormQuestionFactory.SelectBox({
				title: "Gesamterscheinungsbild",
				name: "buildingOverallCondition",
				values: Object.entries(PurchasingInspectionBuildingOverallConditionTranslation).map(([value, label]) => ({
					value,
					label
				})),
				hint: "Bewerten Sie den Gesamteindruck des Gebäudes"
			})]],
			["Außen", [
				FormQuestionFactory.SelectBox({
					title: "Zustand Fassade",
					name: "buildingOutsideFacadeCondition",
					required: true,
					values: Object.entries(PurchasingInspectionBuildingOutsideFacadeConditionTranslation).map(([value, label]) => ({
						value,
						label
					})),
					hint: "Wie ist der Zustand der Fassade?"
				}),
				FormQuestionFactory.SelectBox({
					title: "Fassadenbeschaffenheit",
					name: "buildingOutsideFacadeType",
					required: true,
					values: Object.entries(PurchasingInspectionBuildingOutsideFacadeTypeTranslation).map(([value, label]) => ({
						value,
						label
					})),
					hintValueEntityField: {
						entity: "estate",
						attributePath: "attributes.facadeType"
					},
					hintTemplate: "Fassadenbeschaffenheit: {{value}}. Bitte wählen Sie die Fassadenbeschaffenheit."
				}),
				FormQuestionFactory.SelectBox({
					title: "Dachtyp",
					name: "buildingRoofType",
					required: true,
					values: Object.entries(PurchasingInspectionBuildingRoofTypeTranslation).map(([value, label]) => ({
						value,
						label
					})),
					hintValueEntityField: {
						entity: "estate",
						attributePath: "attributes.roofType"
					},
					hintTemplate: "Dachtyp: {{value}}. Bitte wählen Sie die Dachtyp."
				})
			]],
			["Innen", [FormQuestionFactory.Toggle({
				title: "Aufzug",
				name: "hasLift",
				format: "three_state",
				defaultValue: null,
				required: true,
				hintValueEntityField: {
					entity: "estate",
					attributePath: "attributes.lift"
				},
				hintTemplate: "Aufzug vorhanden: {{value}}. "
			})]],
			["Keller", [
				FormQuestionFactory.Toggle({
					title: "Keller vorhanden?",
					name: "hasCellar",
					format: "three_state",
					defaultValue: null,
					required: true,
					hintValueEntityField: {
						entity: "estate",
						attributePath: "attributes.cellar"
					},
					hintTemplate: "Keller vorhanden: {{value}}."
				}),
				FormQuestionFactory.Number({
					title: "Keller-Nr.",
					name: "cellarNumber",
					required: false,
					guards: [{
						name: "hasCellar",
						value: true
					}],
					hint: "Bitte tragen Sie die Kellernummer ein."
				}),
				FormQuestionFactory.Toggle({
					title: "Keller räumen?",
					name: "shouldCleanCellar",
					format: "three_state",
					defaultValue: null,
					required: true,
					guards: [{
						name: "hasCellar",
						value: true
					}],
					hint: "Zusätzliche Renovierungs Kosten durch Kellerräumung."
				}),
				FormQuestionFactory.Number({
					title: "Extrakosten Keller räumen",
					name: "cellarCleaningCosts",
					format: "currency",
					required: true,
					min: 0,
					minimumFractionDigits: 0,
					maximumFractionDigits: 2,
					step: .1,
					guards: [{
						name: "shouldCleanCellar",
						value: true
					}],
					hint: "Welche Kosten werden dadurch entstehen?"
				}),
				FormQuestionFactory.MultiSelectBox({
					title: "Gemeinschaftsräume",
					name: "commonAreas",
					values: Object.entries(PurchasingInspectionCommonAreaTranslation).map(([value, label]) => ({
						value,
						label
					})),
					hint: "Wählen Sie zutreffende Gemeinschaftsräume aus."
				})
			]],
			["Dachboden", [
				FormQuestionFactory.Toggle({
					title: "Dachboden vorhanden?",
					name: "hasAttic",
					format: "three_state",
					defaultValue: null,
					required: true
				}),
				FormQuestionFactory.Number({
					title: "Dachboden-Nr.",
					name: "atticNumber",
					required: false,
					guards: [{
						name: "hasAttic",
						value: true
					}],
					hint: "Bitte tragen Sie die Dachbodennummer ein."
				}),
				FormQuestionFactory.Toggle({
					title: "Dachboden räumen?",
					name: "shouldCleanAttic",
					format: "three_state",
					defaultValue: null,
					required: true,
					guards: [{
						name: "hasAttic",
						value: true
					}],
					hint: "Zusätzliche Renovierungs Kosten durch Dachbodenräumung."
				})
			]],
			["Rolläden", [
				FormQuestionFactory.Toggle({
					title: "Rollläden vorhanden?",
					name: "hasBeltWinder",
					format: "three_state",
					defaultValue: null,
					required: true
				}),
				FormQuestionFactory.SelectBox({
					title: "Lage der Rollläden",
					name: "beltWindersLocation",
					required: true,
					values: Object.entries(PurchasingInspectionBeltWindersLocationTranslation).map(([value, label]) => ({
						value,
						label
					})),
					guards: [{
						name: "hasBeltWinder",
						value: true
					}]
				}),
				FormQuestionFactory.Toggle({
					title: "Gurtwickler tauschen?",
					name: "shouldReplaceBeltWinder",
					format: "three_state",
					defaultValue: null,
					required: true,
					guards: [{
						name: "hasBeltWinder",
						value: true
					}]
				}),
				FormQuestionFactory.Number({
					title: "Anzahl zu tauschende Gurtwickler [Stück]",
					name: "numberOfBeltWindersToReplace",
					required: true,
					min: 0,
					guards: [{
						name: "hasBeltWinder",
						value: true
					}, {
						name: "shouldReplaceBeltWinder",
						value: true
					}],
					hint: "Zusätzliche Renovierungs Kosten für neue Gurtwickler."
				}),
				FormQuestionFactory.Number({
					title: "Anzahl gangbar zumachende Gurtwickler? [Stück]",
					name: "numberOfBeltWindersThatCanBeClosed",
					required: true,
					min: 0,
					guards: [{
						name: "hasBeltWinder",
						value: true
					}, {
						name: "shouldReplaceBeltWinder",
						value: true
					}],
					hint: "Zusätzliche Renovierungs Kosten für zu reparierende Gurtwickler."
				})
			]],
			["Heizung und Warmwasser", [
				FormQuestionFactory.Toggle({
					title: "Zentralheizung vorhanden?",
					name: "isCentralHeatingAvailable",
					format: "three_state",
					defaultValue: null,
					required: true
				}),
				FormQuestionFactory.Date({
					title: "Zentralheizung Baujahr",
					name: "centralHeatingConstructionYear",
					format: "year_date",
					required: true,
					valueOnClear: null,
					guards: [{
						name: "isCentralHeatingAvailable",
						value: true
					}],
					hint: "In welchem Jahr wurde die Zentralheizung installiert?"
				}),
				FormQuestionFactory.SelectBox({
					title: "Gerätetyp (falls zentrale Heizung)",
					name: "centralHeatingDeviceType",
					required: true,
					values: Object.entries(PurchasingInspectionHeatingDeviceTypeTranslation).map(([value, label]) => ({
						value,
						label
					})),
					guards: [{
						name: "isCentralHeatingAvailable",
						value: true
					}],
					hintValueEntityField: {
						entity: "estate",
						attributePath: "attributes.heatingType"
					},
					hintTemplate: "Zentralheizungstyp: {{value}}"
				}),
				FormQuestionFactory.SelectBox({
					title: "Gerätetyp (falls dezentrale Heizung)",
					name: "decentralisedHeatingDeviceType",
					required: true,
					values: Object.entries(PurchasingInspectionHeatingDeviceTypeTranslation).map(([value, label]) => ({
						value,
						label
					})),
					guards: [{
						name: "isCentralHeatingAvailable",
						value: false
					}],
					hintValueEntityField: {
						entity: "estate",
						attributePath: "attributes.heatingType"
					},
					hintTemplate: "{{value}}"
				}),
				FormQuestionFactory.Toggle({
					title: "Gerätetyp erhaltenswert?",
					name: "isDecentralisedHeatingDeviceWorthPreserving",
					format: "three_state",
					defaultValue: null,
					required: true,
					guards: [{
						name: "decentralisedHeatingDeviceType",
						value: ["GasCombinationBoiler", "GasBoiler"]
					}]
				}),
				FormQuestionFactory.Toggle({
					title: "Zentrale Warmwasserbereitung vorhanden?",
					name: "isCentralHotWaterAvailable",
					format: "three_state",
					defaultValue: null,
					required: true
				}),
				FormQuestionFactory.SelectBox({
					title: "Typ (falls dezentrale Warmwasserbereitung)",
					name: "decentralisedWaterHeatingDeviceType",
					required: true,
					values: Object.entries(PurchasingInspectionWaterHeatingDeviceTypeTranslation).map(([value, label]) => ({
						value,
						label
					})),
					guards: [{
						name: "isCentralHotWaterAvailable",
						value: false
					}],
					hintValueEntityField: {
						entity: "estate",
						attributePath: "attributes.heatingType"
					},
					hintTemplate: "{{value}}"
				}),
				FormQuestionFactory.Toggle({
					title: "Gerätetyp erhaltenswert?",
					name: "isDecentralisedWaterHeatingDeviceWorthPreserving",
					format: "three_state",
					defaultValue: null,
					required: true,
					guards: [{
						name: "decentralisedWaterHeatingDeviceType",
						value: "exists"
					}]
				})
			]],
			["Sonstiges", [
				FormQuestionFactory.SelectBox({
					title: "Treppenhaus",
					name: "stairCaseCondition",
					required: true,
					values: Object.entries(PurchasingInspectionAmenityConditionTranslation).map(([value, label]) => ({
						value,
						label
					})),
					hint: "Bewerten Sie den Zustand des Treppenhauses."
				}),
				FormQuestionFactory.SelectBox({
					title: "Haustür",
					name: "enteranceDoorCondition",
					required: true,
					values: Object.entries(PurchasingInspectionAmenityConditionTranslation).map(([value, label]) => ({
						value,
						label
					})),
					hint: "Bewerten Sie den Zustand der Haustür."
				}),
				FormQuestionFactory.SelectBox({
					title: "Klingelschild",
					name: "doorLabelCondition",
					required: true,
					values: Object.entries(PurchasingInspectionAmenityConditionTranslation).map(([value, label]) => ({
						value,
						label
					})),
					hint: "Bewerten Sie den Zustand des Klingelschildes."
				}),
				FormQuestionFactory.SelectBox({
					title: "Außenanlage",
					name: "outdoorAreaCondition",
					required: true,
					values: Object.entries(PurchasingInspectionAmenityConditionTranslation).map(([value, label]) => ({
						value,
						label
					})),
					hint: "Bewerten Sie den Zustand der Außenanlage."
				}),
				FormQuestionFactory.SelectBox({
					title: "Briefkasten",
					name: "postBoxCondition",
					required: true,
					values: Object.entries(PurchasingInspectionAmenityConditionTranslation).map(([value, label]) => ({
						value,
						label
					})),
					hint: "Bewerten Sie den Zustand des Briefkastens."
				}),
				FormQuestionFactory.SelectBox({
					title: "Allgemeiner Eindruck Gemeinschaftseigentum",
					name: "communityPropertyCondition",
					required: true,
					values: Object.entries(PurchasingInspectionAmenityConditionTranslation).map(([value, label]) => ({
						value,
						label
					})),
					hint: "Bewerten Sie den Zustand des Gemeinschaftseigentums."
				})
			]]
		]],
		["Wohnung", [
			["Allgemein", [
				FormQuestionFactory.SelectBox({
					title: "Wohnungstyp",
					name: "apartmentType",
					required: true,
					values: Object.entries(PurchasingInspectionApartmentTypeTranslation).map(([value, label]) => ({
						value,
						label
					})),
					hintValueEntityField: {
						entity: "estate",
						attributePath: "attributes.apartmentType"
					},
					hintTemplate: "Aktueller Wohnungstyp: {{value}}. Stellen Sie sicher, dass die Etage mit dem Wohnungstyp kompatibel ist"
				}),
				FormQuestionFactory.Banner("Bitte denke daran, nach dem Ändern des Wohnungstyps auf ‘Dachgeschoss’ die Predictions erneut durchzuführen, da dadurch zusätzliche Kosten entstehen.", "apartmentTypeChangeMessage", [{
					name: "apartmentType",
					value: "RoofStorey"
				}]),
				FormQuestionFactory.SelectBox({
					title: "Etage",
					name: "floor",
					required: true,
					values: [...Object.entries(PurchasingInspectionFloorTranslation).map(([value, label]) => ({
						value,
						label
					})), ...Array.from({ length: 25 }, (_, i) => ({
						value: (i + 1).toString(),
						label: `${(i + 1).toString()}. OG`
					}))],
					hintValueEntityField: {
						entity: "estate",
						attributePath: "attributes.floor"
					},
					hintTemplate: "Bitte überprüfen und ergänzen Sie die Etage. Aktuell gespeicherte Etage: {{value}}. Stellen Sie sicher, dass die Etage mit dem Wohnungstyp kompatibel ist."
				}),
				FormQuestionFactory.SelectBox({
					title: "Lage im Haus",
					name: "floorLocation",
					required: true,
					values: Object.entries(PurchasingInspectionFloorLocationTranslation).map(([value, label]) => ({
						value,
						label
					})),
					hintValueEntityField: {
						entity: "estate",
						attributePath: "attributes.floorLocation"
					},
					hintTemplate: "Lage im Haus: {{value}}"
				}),
				FormQuestionFactory.Toggle({
					title: "Unrealistisch Fläche?",
					name: "isLivingAreaUnrealistic",
					format: "three_state",
					defaultValue: null,
					required: true,
					hintValueEntityField: {
						entity: "estate",
						attributePath: "attributes.livingSpace"
					},
					hintTemplate: "Ist die angegebene Fläche unrealistisch? Aktuelle Fläche:{{value}} m²"
				}),
				FormQuestionFactory.Banner("Bitte denke daran, die Predictions erneut durchzuführen, falls die Wohnungsfläche sich verändert, da dadurch zusätzliche Kosten entstehen", "livingAreaChangeMessage", [{
					name: "isLivingAreaUnrealistic",
					value: true
				}]),
				FormQuestionFactory.Number({
					title: "Neue Fläche",
					name: "newLivingArea",
					format: "meter_squared",
					min: 0,
					minimumFractionDigits: 0,
					maximumFractionDigits: 2,
					step: .1,
					required: true,
					guards: [{
						name: "isLivingAreaUnrealistic",
						value: true
					}],
					hint: "Bitte tragen Sie die neue Fläche ein."
				}),
				FormQuestionFactory.Toggle({
					title: "Ist die Anzahl der Zimmer nach der Renovierung anders?",
					name: "isNumberOfRoomsAfterRenovationDifferent",
					format: "three_state",
					defaultValue: null,
					required: true,
					hintValueEntityField: {
						entity: "estate",
						attributePath: "attributes.rooms"
					},
					hintTemplate: "Ändert sich die Anzahl der Zimmer nach der Renovierung? Aktuelle Zimmeranzahl: {{value}}."
				}),
				FormQuestionFactory.Number({
					title: "Anzahl der Zimmer nach der Renovierung",
					name: "roomsAfterRenovation",
					min: 0,
					minimumFractionDigits: 0,
					maximumFractionDigits: 2,
					step: .1,
					required: true,
					guards: [{
						name: "isNumberOfRoomsAfterRenovationDifferent",
						value: true
					}],
					hint: "Bitte tragen Sie die neue Anzahl der Zimmer ein."
				}),
				FormQuestionFactory.Toggle({
					title: "Abstellraum vorhanden?",
					name: "hasStorageRoom",
					format: "three_state",
					defaultValue: null,
					required: true,
					hint: "Gibt es einen Abstellraum?"
				}),
				FormQuestionFactory.SelectBox({
					title: "Abstellraum Setup nach Renovierung",
					name: "storageRoomAfterRenovation",
					values: Object.entries(PurchasingInspectionGuestToiletStorageRoomAfterRenovationOptionsTranslation).map(([value, label]) => ({
						value,
						label
					})),
					required: true,
					guards: [{
						name: "hasStorageRoom",
						value: true
					}],
					hint: "Was ist die vorgesehene Nutzung des Abstellraumes nach der Renovierung?"
				})
			]],
			["Gesamtzustand", [
				FormQuestionFactory.Toggle({
					title: "Sanierung weiterer Nutzflächen nötig?",
					name: "shouldRenovateAdditionalUsableArea",
					format: "three_state",
					defaultValue: null,
					required: true,
					hint: "Müssen weitere Nutzflächen saniert werden?"
				}),
				FormQuestionFactory.Number({
					title: "Weitere Flächen",
					name: "additionalArea",
					format: "meter_squared",
					required: true,
					min: 0,
					minimumFractionDigits: 0,
					maximumFractionDigits: 2,
					step: .1,
					guards: [{
						name: "shouldRenovateAdditionalUsableArea",
						value: true
					}],
					hint: "Bitte geben Sie weitere relevante Flächen an."
				}),
				FormQuestionFactory.Number({
					title: "Renovierungskosten pro Quadratmeter",
					name: "renovationCostsPerSqM",
					format: "euro_per_meter_squared",
					required: true,
					min: 0,
					minimumFractionDigits: 0,
					maximumFractionDigits: 2,
					step: .1,
					guards: [{
						name: "shouldRenovateAdditionalUsableArea",
						value: true
					}],
					hint: "Bitte geben Sie die Renovierungskosten pro Quadratmeter an."
				}),
				FormQuestionFactory.Toggle({
					title: "Unbehobene Schäden?",
					name: "includesUnrecoverableDamage",
					format: "three_state",
					defaultValue: null,
					required: true,
					hint: "Gibt es unbehobene Schäden?"
				}),
				FormQuestionFactory.Number({
					title: "Extrakosten unbehobene Schäden reparieren",
					name: "repairingUnrecoverableDamageCosts",
					format: "currency",
					required: true,
					min: 0,
					minimumFractionDigits: 0,
					maximumFractionDigits: 2,
					step: .1,
					guards: [{
						name: "includesUnrecoverableDamage",
						value: true
					}],
					hint: "Welche Kosten werden dadurch entstehen?"
				}),
				FormQuestionFactory.Toggle({
					title: "Sonderumlagen geplant / beschlossen?",
					name: "hasResultingAdditionalCosts",
					format: "three_state",
					defaultValue: null,
					required: true,
					hint: "Sind Sonderumlagen geplant oder bereits beschlossen?"
				}),
				FormQuestionFactory.Number({
					title: "Dadurch entstehende Mehrkosten",
					name: "resultingAdditionalCosts",
					format: "currency",
					min: 0,
					minimumFractionDigits: 0,
					maximumFractionDigits: 2,
					step: .1,
					required: true,
					guards: [{
						name: "hasResultingAdditionalCosts",
						value: true
					}],
					hint: "Bitte geben Sie die dadurch entstehenden Mehrkosten an."
				})
			]],
			["Sonderthemen", [
				FormQuestionFactory.Toggle({
					title: "Garten vorhanden?",
					name: "hasGarden",
					format: "three_state",
					defaultValue: null,
					required: true,
					hintValueEntityField: {
						entity: "estate",
						attributePath: "attributes.garden"
					},
					hintTemplate: "Garten: {{value}}"
				}),
				FormQuestionFactory.Toggle({
					title: "Garten räumen/herrichten?",
					name: "shouldCleanGarden",
					format: "three_state",
					defaultValue: null,
					required: true,
					guards: [{
						name: "hasGarden",
						value: true
					}],
					hint: "Zusätzliche Renovierungskosten durch Gartenräumung/herrichten."
				}),
				FormQuestionFactory.Toggle({
					title: "Sehr umfangreiche Entrümpelung?",
					name: "hasExtensiveCleaningCosts",
					format: "three_state",
					defaultValue: null,
					required: true,
					hint: "Müssen Mehrkosten durch umfangreiche Entrümpelung berücksichtigt werden?"
				}),
				FormQuestionFactory.Number({
					title: "Kosten für sehr umfangreiche Entrümpelung",
					name: "extensiveCleaningCosts",
					format: "currency",
					min: 0,
					minimumFractionDigits: 0,
					maximumFractionDigits: 2,
					step: .1,
					required: true,
					guards: [{
						name: "hasExtensiveCleaningCosts",
						value: true
					}],
					hint: "Bitte geben Sie die Kosten für eine sehr umfangreiche Entrümpelung an."
				}),
				FormQuestionFactory.Toggle({
					title: "Gibt es weitere Sondernutzungsrechte?",
					name: "hasOtherUsages",
					format: "three_state",
					defaultValue: null,
					required: true
				}),
				FormQuestionFactory.Text({
					title: "Weitere Sondernutzungsrechte",
					name: "otherUsages",
					required: true,
					guards: [{
						name: "hasOtherUsages",
						value: true
					}]
				})
			]],
			["Boden", [
				FormQuestionFactory.SelectBox({
					title: "Typ",
					name: "floorType",
					required: true,
					values: Object.entries(PurchasingInspectionFloorTypeTranslation).map(([value, label]) => ({
						value,
						label
					})),
					hint: "Bitte wählen sie den Bodentyp aus."
				}),
				FormQuestionFactory.Toggle({
					title: "Erhaltenswert?",
					name: "isFloorWorthKeeping",
					format: "three_state",
					defaultValue: null,
					required: true,
					guards: [{
						name: "floorType",
						value: "exists"
					}],
					hint: "Ist der Bodentyp erhaltenswert?"
				}),
				FormQuestionFactory.Number({
					title: "Grundfläche",
					name: "floorSpace",
					format: "meter_squared",
					minimumFractionDigits: 0,
					maximumFractionDigits: 2,
					step: .1,
					required: true,
					min: 0,
					guards: [{
						name: "isFloorWorthKeeping",
						value: false
					}]
				}),
				FormQuestionFactory.SelectBox({
					title: "Weiterer Bodentyp?",
					name: "secondaryFloorType",
					values: Object.entries(PurchasingInspectionFloorTypeTranslation).map(([value, label]) => ({
						value,
						label
					})),
					hint: "Gibt es einen weiteren Bodentyp?"
				}),
				FormQuestionFactory.Toggle({
					title: "Erhaltenswert?",
					name: "isSecondaryFloorWorthKeeping",
					format: "three_state",
					defaultValue: null,
					required: true,
					guards: [{
						name: "secondaryFloorType",
						value: "exists"
					}],
					hint: "Ist der Bodentyp erhaltenswert?"
				}),
				FormQuestionFactory.Number({
					title: "Grundfläche",
					name: "secondaryFloorSpace",
					format: "meter_squared",
					minimumFractionDigits: 0,
					maximumFractionDigits: 2,
					step: .1,
					required: true,
					min: 0,
					guards: [{
						name: "isSecondaryFloorWorthKeeping",
						value: false
					}],
					hint: "Bitte geben sie die Grundfläche des nicht erhaltenwertenden Bodentyps an."
				}),
				FormQuestionFactory.Toggle({
					title: "Asbestverdacht?",
					name: "isAsbestosSuspected",
					format: "three_state",
					defaultValue: null,
					required: true,
					hint: "Besteht der Verdacht auf Asbest?"
				}),
				FormQuestionFactory.Number({
					title: "Asbestverdächtiges Gebiet",
					name: "asbestosArea",
					format: "meter_squared",
					minimumFractionDigits: 0,
					maximumFractionDigits: 2,
					step: .1,
					required: true,
					min: 0,
					guards: [{
						name: "isAsbestosSuspected",
						value: true
					}]
				})
			]],
			["Innenwände", [
				FormQuestionFactory.Number({
					title: "Wie viele Wände sollen versetzt werden?",
					name: "numberOfWallsToBeMoved",
					required: true,
					min: 0
				}),
				FormQuestionFactory.Toggle({
					title: "Raumhöhe über 2,50m?",
					name: "isRoomCeilingHigherThan2_5Meters",
					format: "three_state",
					defaultValue: null,
					required: true,
					hint: "Beträgt die Raumhöhe mehr als 2,50 m?"
				}),
				FormQuestionFactory.Number({
					title: "Hohler Putz?",
					name: "hollowPlasterArea",
					format: "meter_squared",
					minimumFractionDigits: 0,
					maximumFractionDigits: 2,
					step: .1,
					required: true,
					min: 0,
					hint: "Gibt es hohlen Putz?"
				}),
				FormQuestionFactory.Toggle({
					title: "Risse erkennbar -Decke-?",
					name: "hasVisibleCracksInCeiling",
					format: "three_state",
					defaultValue: null,
					required: true,
					hint: "Sind Risse an der Decke erkennbar?"
				}),
				FormQuestionFactory.Number({
					title: "Risse erkennbar -Decke-",
					name: "visibleCracksInCeilingLength",
					min: 0,
					required: true,
					format: "meter",
					minimumFractionDigits: 0,
					maximumFractionDigits: 2,
					step: .1,
					guards: [{
						name: "hasVisibleCracksInCeiling",
						value: true
					}],
					hint: "Wie lang sind die Risse in Meter?"
				}),
				FormQuestionFactory.Toggle({
					title: "Risse erkennbar -Innenwände-?",
					name: "hasVisibleCracksInInteriorWalls",
					format: "three_state",
					defaultValue: null,
					required: true,
					hint: "Sind Risse an den Innenwänden erkennbar?"
				}),
				FormQuestionFactory.Number({
					title: "Risse erkennbar -Innenwände-",
					name: "visibleCracksInInteriorWallsLength",
					min: 0,
					minimumFractionDigits: 0,
					maximumFractionDigits: 2,
					step: .1,
					required: true,
					format: "meter",
					guards: [{
						name: "hasVisibleCracksInInteriorWalls",
						value: true
					}],
					hint: "Wie lang sind die Risse in Meter?"
				}),
				FormQuestionFactory.Toggle({
					title: "Risse erkennbar -Außenwände-?",
					name: "hasVisibleCracksInExteriorWalls",
					format: "three_state",
					defaultValue: null,
					required: true,
					hint: "Sind Risse an den Außenwänden erkennbar?"
				}),
				FormQuestionFactory.Toggle({
					title: "Risse Ausschlusskriterium?",
					name: "hasSevereCracksInExteriorWalls",
					format: "three_state",
					defaultValue: null,
					required: true,
					hint: "Sollten die Risse zu stark sein werden diese zu einem Ausschlusskriterium.",
					guards: [{
						name: "hasVisibleCracksInExteriorWalls",
						value: true
					}]
				}),
				FormQuestionFactory.Number({
					title: "Risse Außenwände zusätzliche Kosten",
					name: "visibleCracksInExteriorWallsCosts",
					min: 0,
					minimumFractionDigits: 0,
					maximumFractionDigits: 2,
					step: .1,
					required: true,
					format: "currency",
					guards: [{
						name: "hasSevereCracksInExteriorWalls",
						value: false
					}],
					hint: "Sprechen Sie mit der Teamleitung für Schätzung der Kosten der Reparatur."
				}),
				FormQuestionFactory.Toggle({
					title: "Stuck / Hohlkehlen vorhanden und Aufarbeitung nötig?",
					name: "hasStuccoAndNeedsRenovation",
					format: "three_state",
					defaultValue: null,
					required: true,
					hint: "Stuck oder sind Hohlkehlen vorhanden, die aufgearbeitet werden müssen?"
				}),
				FormQuestionFactory.Number({
					title: "Erhaltenswerte Stucklänge [lfm]",
					name: "stuccoLengthWorthPreserving",
					min: 0,
					minimumFractionDigits: 0,
					maximumFractionDigits: 2,
					step: .1,
					required: true,
					guards: [{
						name: "hasStuccoAndNeedsRenovation",
						value: true
					}]
				}),
				FormQuestionFactory.Toggle({
					title: "Feuchtigkeit / Schimmel erkennbar -Wände & Decken-?",
					name: "hasVisibleMoistureInWallsAndCeilings",
					format: "three_state",
					defaultValue: null,
					required: true,
					hint: "Ist Feuchtigkeit oder Schimmel an Wänden und Decken erkennbar?"
				}),
				FormQuestionFactory.Number({
					title: "Feuchtigkeit / Schimmel erkennbar -Wände & Decken betroffene Fläche",
					name: "visibleMoistureInWallsAndCeilingsArea",
					min: 0,
					minimumFractionDigits: 0,
					maximumFractionDigits: 2,
					step: .1,
					required: true,
					format: "meter_squared",
					guards: [{
						name: "hasVisibleMoistureInWallsAndCeilings",
						value: true
					}],
					hint: "Geben Sie die komplette Wand/Deckenfläche der betroffenen Wand/Decke an"
				}),
				FormQuestionFactory.Toggle({
					title: "Feuchtigkeit / Schimmel erkennbar -Fenster-?",
					name: "hasVisibleMoistureInWindows",
					format: "three_state",
					defaultValue: null,
					required: true,
					hint: "Ist Feuchtigkeit oder Schimmel an den Fenstern erkennbar?"
				}),
				FormQuestionFactory.Number({
					title: "Feuchtigkeit / Schimmel erkennbar -Fenster betroffene Fläche",
					name: "visibleMoistureInWindowsArea",
					min: 0,
					minimumFractionDigits: 0,
					maximumFractionDigits: 2,
					step: .1,
					required: true,
					format: "meter_squared",
					guards: [{
						name: "hasVisibleMoistureInWindows",
						value: true
					}],
					hint: "Geben Sie die komplette Fensterfläche der betroffenen Fenster an"
				}),
				FormQuestionFactory.Toggle({
					title: "Treppe im Wohnbereich?",
					name: "hasStairsInLivingArea",
					format: "three_state",
					defaultValue: null,
					required: true,
					hint: "Gibt es eine Treppe im Wohnbereich?"
				}),
				FormQuestionFactory.Number({
					title: "Kosten für Treppe im Wohnbereich",
					name: "stairsInLivingAreaCosts",
					min: 0,
					minimumFractionDigits: 0,
					maximumFractionDigits: 2,
					step: .1,
					required: true,
					format: "currency",
					guards: [{
						name: "hasStairsInLivingArea",
						value: true
					}],
					hint: "Sprechen Sie mit der Teamleitung für die Schätzung der Kosten."
				})
			]],
			["Türen", [
				FormQuestionFactory.Switch({
					title: "Werden neue reguläre Türen benötigt?",
					name: "shouldReplaceRegularDoors",
					required: true,
					values: Object.values(PurchasingInspectionNotClearYesNoRadioOptions)
				}),
				FormQuestionFactory.Number({
					title: "Anzahl der zu ersetzenden regulären Türen",
					name: "numberOfRegularDoorsToReplace",
					required: true,
					min: 0,
					guards: [{
						name: "shouldReplaceRegularDoors",
						value: "Yes"
					}],
					hint: "Bitte geben Sie die Anzahl der zu ersetzenden regulären Türen an."
				}),
				FormQuestionFactory.Switch({
					title: "Nachfertigung Altbautür nötig?",
					name: "shouldReplaceHistoricalDoors",
					required: true,
					values: Object.values(PurchasingInspectionNotClearYesNoRadioOptions),
					hint: "Ist eine Nachfertigung einer Altbautür nötig?"
				}),
				FormQuestionFactory.Number({
					title: "Anzahl der zu ersetzenden historischen Türen",
					name: "numberOfHistoricalDoorsToReplace",
					required: true,
					min: 0,
					guards: [{
						name: "shouldReplaceHistoricalDoors",
						value: "Yes"
					}],
					hint: "Bitte geben Sie die Anzahl der zu ersetzenden historischen Türen an."
				})
			]],
			["Küche", [FormQuestionFactory.Toggle({
				title: "Einbauküche vorhanden?",
				name: "hasBuiltInKitchen",
				format: "three_state",
				defaultValue: null,
				required: true,
				hintValueEntityField: {
					entity: "estate",
					attributePath: "attributes.builtInKitchen"
				},
				hintTemplate: "Gibt es eine Einbauküche? {{value}}"
			}), FormQuestionFactory.Number({
				title: "Entsorgungskosten",
				name: "builtInKitchenDisposalCosts",
				format: "currency",
				required: true,
				min: 0,
				minimumFractionDigits: 0,
				maximumFractionDigits: 2,
				step: .1,
				guards: [{
					name: "hasBuiltInKitchen",
					value: true
				}],
				hint: "Bitte geben Sie die Entsorgungskosten der Einbauküche an."
			})]],
			["Bad/WC", [FormQuestionFactory.Toggle({
				title: "Gäste WC nach Renovierung?",
				name: "hasGuestToiletAfterRenovation",
				format: "three_state",
				defaultValue: null,
				required: true,
				hint: "Wird ein Gäste-WC nach der Renovierung vorhanden sein?"
			}), FormQuestionFactory.SelectBox({
				title: "Gäste WC nach Renovierung",
				name: "guestToiletAfterRenovation",
				values: Object.entries(PurchasingInspectionGuestToiletStorageRoomAfterRenovationOptionsTranslation).map(([value, label]) => ({
					value,
					label
				})),
				required: true,
				guards: [{
					name: "hasGuestToiletAfterRenovation",
					value: true
				}],
				hint: "Wählen Sie den Verwendungszweck des Gäste WCs nach der Reservierung aus."
			})]],
			["Fenster", [
				FormQuestionFactory.Toggle({
					title: "Müssen die Fenster ausgetauscht werden?",
					name: "shouldReplaceWindows",
					format: "three_state",
					defaultValue: null,
					required: true
				}),
				FormQuestionFactory.SelectBox({
					title: "Wie ist die Kostenregelung für die Fenster?",
					name: "replaceWindowsCostRegulation",
					guards: [{
						name: "shouldReplaceWindows",
						value: true
					}],
					values: Object.entries(PurchasingInspectionReplaceWindowsCostRegulationTranslation).map(([value, label]) => ({
						value,
						label
					})),
					required: true,
					hint: "Falls WEG und eine Erneuerung erforderlich ist, kontaktiere die WEG."
				}),
				FormQuestionFactory.Toggle({
					title: "Wollen wir die Fenster trotzdem auf eigene Kosten tauschen?",
					name: "toReplaceWindowsAtOurCosts",
					format: "three_state",
					defaultValue: null,
					required: true,
					guards: [{
						name: "replaceWindowsCostRegulation",
						value: "HomeOwnerAssociation"
					}]
				}),
				FormQuestionFactory.Toggle({
					title: "Austausch Kunststoff Fenster?",
					name: "shouldReplacePlasticWindows",
					format: "three_state",
					defaultValue: null,
					required: true,
					guards: [[{
						name: "replaceWindowsCostRegulation",
						value: "HomeOwner"
					}, {
						name: "toReplaceWindowsAtOurCosts",
						value: true
					}]],
					hint: "Sollen die Kunststofffenster ausgetauscht werden?"
				}),
				FormQuestionFactory.Number({
					title: "Anzahl auszutauschende Kunststoff-Fenster [Stück]",
					name: "numberOfPlasticWindowsToReplace",
					required: true,
					min: 0,
					guards: [{
						name: "shouldReplacePlasticWindows",
						value: true
					}],
					hint: "Wie viele Kunststofffenster sollen ausgetauscht werden?"
				}),
				FormQuestionFactory.Toggle({
					title: "Austausch Holz-Fenster?",
					name: "shouldReplaceWoodenWindows",
					format: "three_state",
					defaultValue: null,
					required: true,
					guards: [[{
						name: "replaceWindowsCostRegulation",
						value: "HomeOwner"
					}, {
						name: "toReplaceWindowsAtOurCosts",
						value: true
					}]],
					hint: "Sollen die Holzfenster ausgetauscht werden?"
				}),
				FormQuestionFactory.Number({
					title: "Anzahl auszutauschende Holz-Fenster [Stück]",
					name: "numberOfWoodenWindowsToReplace",
					required: true,
					min: 0,
					guards: [{
						name: "shouldReplaceWoodenWindows",
						value: true
					}],
					hint: "Wie viele Holzfenster sollen ausgetauscht werden?"
				}),
				FormQuestionFactory.Toggle({
					title: "Austausch Metall-Fenster?",
					name: "shouldReplaceMetalWindows",
					format: "three_state",
					defaultValue: null,
					required: true,
					guards: [[{
						name: "replaceWindowsCostRegulation",
						value: "HomeOwner"
					}, {
						name: "toReplaceWindowsAtOurCosts",
						value: true
					}]],
					hint: "Sollen die Metallfenster ausgetauscht werden?"
				}),
				FormQuestionFactory.Number({
					title: "Anzahl auszutauschende Metall-Fenster [Stück]",
					name: "numberOfMetalWindowsToReplace",
					required: true,
					min: 0,
					guards: [{
						name: "shouldReplaceMetalWindows",
						value: true
					}],
					hint: "Wie viele Metallfenster sollen ausgetauscht werden?"
				}),
				FormQuestionFactory.Toggle({
					title: "Austausch einfachverglaste Fenster?",
					name: "shouldReplaceSingleGlazedWindows",
					format: "three_state",
					defaultValue: null,
					required: true,
					guards: [[{
						name: "replaceWindowsCostRegulation",
						value: "HomeOwner"
					}, {
						name: "toReplaceWindowsAtOurCosts",
						value: true
					}]],
					hint: "Sollen die einfachverglasten Fenster ausgetauscht werden?"
				}),
				FormQuestionFactory.Number({
					title: "Anzahl einfachverglaste Fenster [Stück]",
					name: "numberOfSingleGlazedWindowsToReplace",
					required: true,
					min: 0,
					guards: [{
						name: "shouldReplaceSingleGlazedWindows",
						value: true
					}],
					hint: "Wie viele einfachverglaste Fenster sollen ausgetauscht werden?"
				}),
				FormQuestionFactory.Toggle({
					title: "Austausch doppelkasten Fenster?",
					name: "shouldReplaceDoubleBoxWindows",
					format: "three_state",
					defaultValue: null,
					required: true,
					guards: [[{
						name: "replaceWindowsCostRegulation",
						value: "HomeOwner"
					}, {
						name: "toReplaceWindowsAtOurCosts",
						value: true
					}]],
					hint: "Sollen die doppelkasten Fenster ausgetauscht werden?"
				}),
				FormQuestionFactory.Number({
					title: "Anzahl doppelkasten Fenster [Stück]",
					name: "numberOfDoubleBoxWindows",
					required: true,
					min: 0,
					guards: [{
						name: "shouldReplaceDoubleBoxWindows",
						value: true
					}],
					hint: "Wie viele doppelkasten Fenster sollen ausgetauscht werden?"
				}),
				FormQuestionFactory.Toggle({
					title: "Austausch Isolierfenster?",
					name: "shouldReplaceIsoWindows",
					format: "three_state",
					defaultValue: null,
					required: true,
					guards: [[{
						name: "replaceWindowsCostRegulation",
						value: "HomeOwner"
					}, {
						name: "toReplaceWindowsAtOurCosts",
						value: true
					}]],
					hint: "Sollen die Isolierfenster ausgetauscht werden?"
				}),
				FormQuestionFactory.Number({
					title: "Anzahl Isolierfenster [Stück]",
					min: 0,
					defaultValue: null,
					name: "numberOfIsoWindows",
					guards: [{
						name: "shouldReplaceIsoWindows",
						value: true
					}],
					required: true
				}),
				FormQuestionFactory.Number({
					title: "Brüstungshöhe",
					name: "parapetHeight",
					required: false,
					format: "meter",
					min: 0,
					minimumFractionDigits: 0,
					maximumFractionDigits: 2,
					step: .1,
					hint: "Wie hoch ist die Brüstungshöhe?"
				})
			]],
			["Stellplatz", [FormQuestionFactory.Toggle({
				title: "Stellplatz vorhanden?",
				name: "hasParkingSpace",
				format: "three_state",
				defaultValue: null,
				required: true,
				hint: "Bitte beachten Sie, dass Ihre Eingabe die bestehenden Angaben zu den Parkplätzen des Objekts überschreibt."
			}), FormQuestionFactory.MultipleAnswer({
				title: "Stellplätze",
				name: "parkingSpaces",
				required: true,
				questions: [
					FormQuestionFactory.SelectBox({
						title: "Stellplatz Typ",
						name: "parkingSpaceType",
						values: Object.entries(PurchasingInspectionParkingSpaceTypeTranslation).map(([value, label]) => ({
							value,
							label
						})),
						required: true
					}),
					FormQuestionFactory.Text({
						title: "Stellplatz-Nr.",
						name: "parkingSpaceNumber",
						required: false,
						hint: "Bitte tragen Sie die Stellplatz Nummer ein."
					}),
					FormQuestionFactory.Toggle({
						title: "Gibt es ein Grundbuch?",
						name: "isParkingSpaceRegistered",
						format: "three_state",
						defaultValue: null,
						required: true
					}),
					FormQuestionFactory.Number({
						title: "Eigenes Grundbuchblatt",
						name: "parkingSpaceRegisterPage",
						required: true,
						hint: "Bitte tragen Sie das eigene Grundbuchblatt ein.",
						guards: [{
							name: "isParkingSpaceRegistered",
							value: true
						}]
					}),
					FormQuestionFactory.Number({
						title: "Eigenes Grundbuchband",
						name: "parkingSpaceRegisterBand",
						required: true,
						hint: "Bitte tragen Sie das eigene Grundbuchband ein.",
						guards: [{
							name: "isParkingSpaceRegistered",
							value: true
						}]
					}),
					FormQuestionFactory.Toggle({
						title: "Stellplatz räumen?",
						name: "shouldCleanParkingSpace",
						format: "three_state",
						defaultValue: null,
						required: true
					})
				],
				guards: [{
					name: "hasParkingSpace",
					value: true
				}]
			})]],
			["Balkon/Terrasse", [
				FormQuestionFactory.Toggle({
					title: "Balkon vorhanden",
					name: "hasBalcony",
					format: "three_state",
					defaultValue: null,
					required: true,
					hintValueEntityField: {
						entity: "estate",
						attributePath: "attributes.balcony"
					},
					hintTemplate: "{{value}}"
				}),
				FormQuestionFactory.SelectBox({
					title: "Zustand des Balkons",
					name: "balconyCondition",
					required: true,
					values: Object.entries(PurchasingInspectionAmenityConditionTranslation).map(([value, label]) => ({
						value,
						label
					})),
					guards: [{
						name: "hasBalcony",
						value: true
					}]
				}),
				FormQuestionFactory.Toggle({
					title: "Aufarbeitung Brüstung nötig?",
					name: "shouldRefurbishBalconyParapet",
					format: "three_state",
					defaultValue: null,
					required: true,
					guards: [{
						name: "hasBalcony",
						value: true
					}],
					hint: "Muss die Balkonbrüstung aufgearbeitet werden?"
				}),
				FormQuestionFactory.Toggle({
					title: "Aufarbeitung Boden nötig?",
					name: "shouldRefurbishBalconyFloor",
					format: "three_state",
					defaultValue: null,
					required: true,
					guards: [{
						name: "hasBalcony",
						value: true
					}]
				}),
				FormQuestionFactory.Toggle({
					title: "Aufarbeitung Wand & Decke nötig?",
					name: "shouldRefurbishBalconyWallAndCeiling",
					format: "three_state",
					defaultValue: null,
					required: true,
					guards: [{
						name: "hasBalcony",
						value: true
					}],
					hint: "Müssen die Wand und Decke des Balkons aufgearbeitet werden?"
				}),
				FormQuestionFactory.Toggle({
					title: "Terrasse vorhanden",
					name: "hasTerrace",
					format: "three_state",
					defaultValue: null,
					required: true
				}),
				FormQuestionFactory.Toggle({
					title: "Aufarbeitung Brüstung nötig?",
					name: "shouldRefurbishTerraceParapet",
					format: "three_state",
					defaultValue: null,
					required: true,
					guards: [{
						name: "hasTerrace",
						value: true
					}],
					hint: "Muss die Terassenbrüstung aufgearbeitet werden?"
				}),
				FormQuestionFactory.Toggle({
					title: "Aufarbeitung Boden nötig?",
					name: "shouldRefurbishTerraceFloor",
					format: "three_state",
					defaultValue: null,
					required: true,
					guards: [{
						name: "hasTerrace",
						value: true
					}],
					hint: "Muss der Boden der Terasse aufgearbeitet werden?"
				}),
				FormQuestionFactory.Toggle({
					title: "Aufarbeitung Wand & Decke nötig?",
					name: "shouldRefurbishTerraceWallAndCeiling",
					format: "three_state",
					defaultValue: null,
					required: true,
					guards: [{
						name: "hasTerrace",
						value: true
					}],
					hint: "Müssen die Wand und Decke der Terasse aufgearbeitet werden?"
				})
			]]
		]],
		["Weiteres", [
			["Elektrik", [
				FormQuestionFactory.Toggle({
					title: "Zähler erneuern?",
					name: "shouldReplaceMeter",
					format: "three_state",
					defaultValue: null,
					required: true,
					hint: "Muss der Zähler erneuert werden?"
				}),
				FormQuestionFactory.Switch({
					title: "Drehstrom vorhanden?",
					name: "hasNoThreePhaseCurrentConnection",
					values: Object.values(PurchasingInspectionNotClearYesNoRadioOptions),
					required: true
				}),
				FormQuestionFactory.Number({
					title: "Zusätzliche Kosten für Umrüstung",
					name: "threePhaseConnectionUpgradeCosts",
					min: 0,
					minimumFractionDigits: 0,
					maximumFractionDigits: 2,
					step: .1,
					format: "currency",
					required: true,
					guards: [{
						name: "hasNoThreePhaseCurrentConnection",
						value: "No"
					}],
					hint: "Bitte sprechen Sie die zusätzlichen Kosten mit Ihrem Teamleiter ab."
				}),
				FormQuestionFactory.Toggle({
					title: "Unterverteilung im Treppenhaus?",
					name: "hasElectroSubDistributionBoard",
					format: "three_state",
					defaultValue: null,
					required: true,
					hint: "Gibt es eine Elektro-Unterverteilung im Treppenhaus?"
				}),
				FormQuestionFactory.Switch({
					title: "Ist der Hausanschluss nicht ausreichend?",
					name: "isHouseConnectionNotSufficient",
					values: Object.values(PurchasingInspectionNotClearYesNoRadioOptions),
					required: true,
					hint: "Ist der vorhandene Hausanschluss nicht ausreichend?"
				})
			]],
			["E-Ausweis", [
				FormQuestionFactory.Toggle({
					title: "Übergeben",
					name: "handover",
					format: "three_state",
					defaultValue: null,
					required: true,
					hint: "Übergabe des Energieausweises erfolgt?"
				}),
				FormQuestionFactory.SelectBox({
					title: "Energieeffizienzklasse",
					name: "energyConsumptionCategory",
					required: true,
					values: Object.entries(EnergyConsumptionCategory).map(([value, label]) => ({
						value,
						label
					})),
					guards: [{
						name: "handover",
						value: true
					}],
					hintValueEntityField: {
						entity: "estate",
						attributePath: "attributes.energyConsumptionCategory"
					},
					hintTemplate: `Energieeffizienzklasse: {{value}}`
				}),
				FormQuestionFactory.Toggle({
					title: "Ist eine Verbesserung der Energie Effizienz möglich?",
					name: "isEnergyEfficiencyUpgradable",
					format: "three_state",
					defaultValue: null,
					required: true,
					guards: [{
						name: "energyConsumptionCategory",
						value: [
							"E",
							"F",
							"G",
							"H"
						]
					}]
				}),
				FormQuestionFactory.Date({
					title: "Ausstellungsdatum",
					name: "issueDate",
					required: true,
					valueOnClear: null,
					guards: [{
						name: "handover",
						value: true
					}],
					hint: "Ausstellungsdatum des Energieausweises?"
				})
			]],
			["Sanitär", [
				FormQuestionFactory.Toggle({
					title: "Schlechter Zustand der Stränge?",
					name: "hasBadStrands",
					format: "three_state",
					defaultValue: null,
					required: true,
					hint: "Befinden sich die Sanitärstränge in einem schlechten Zustand?"
				}),
				FormQuestionFactory.Toggle({
					title: "Wurde der Strang saniert?",
					name: "lineHasBeenRenovated",
					format: "three_state",
					defaultValue: null,
					required: true,
					hint: "Wurde der Sanitärstrang bereits saniert?"
				}),
				FormQuestionFactory.Toggle({
					title: "Bleiverdacht?",
					name: "hasSuspectedLead",
					format: "three_state",
					defaultValue: null,
					required: true,
					hint: "Besteht Verdacht auf Bleirohre?"
				}),
				FormQuestionFactory.Toggle({
					title: "WC-Abwasser direkt durch den Boden?",
					name: "hasWcWaterDirectlyThroughTheFloor",
					format: "three_state",
					defaultValue: null,
					required: true,
					hint: "Wird das WC-Abwasser direkt durch den Boden geleitet?"
				}),
				FormQuestionFactory.Toggle({
					title: "Leitungsführung Gas an der Decke sichtbar / vorhanden?",
					name: "isGasPipeRoutingVisibleOnTheCeiling",
					format: "three_state",
					defaultValue: null,
					required: true,
					hint: "Ist eine Gasleitung an der Decke sichtbar oder vorhanden?"
				}),
				FormQuestionFactory.Toggle({
					title: "Heizleitungen auf Putz verlegt? Soll Unterputz gelegt werden?",
					name: "hasHeatingCablesLaidOnPlaster",
					format: "three_state",
					defaultValue: null,
					required: true,
					hint: "Sind Heizleitungen auf Putz verlegt? Soll eine Unterputzverlegung erfolgen?"
				})
			]]
		]]
	];
}));
//#endregion
//#region src/domains/purchasing/inspection/purchasing-inspection.helpers.ts
var answerTransformers, transformPurchasingInspectionQuestionAnswer;
var init_purchasing_inspection_helpers = __esmMin((() => {
	init_energy_efficiency();
	init_estates();
	init_form_question();
	init_purchasing_inspection();
	init_purchasing_inspection_opts();
	answerTransformers = {
		["estatePositionCategory"]: (value) => PurchasingInspectionEstatePositionCategoryTranslation[value],
		["estateLocationRating"]: (value) => locationRatingTransalations[value],
		["publicTransportConnections"]: (value) => value.map((c) => PurchasingInspectionPublicTransportConnectionTranslation[c]).join(", "),
		["buildingOverallCondition"]: (value) => PurchasingInspectionBuildingOverallConditionTranslation[value],
		["buildingOutsideFacadeCondition"]: (value) => PurchasingInspectionBuildingOutsideFacadeConditionTranslation[value],
		["buildingOutsideFacadeType"]: (value) => PurchasingInspectionBuildingOutsideFacadeTypeTranslation[value],
		["buildingRoofType"]: (value) => PurchasingInspectionBuildingRoofTypeTranslation[value],
		["commonAreas"]: (value) => value.map((c) => PurchasingInspectionCommonAreaTranslation[c]).join(", "),
		["beltWindersLocation"]: (value) => PurchasingInspectionBuildingRoofTypeTranslation[value],
		["centralHeatingDeviceType"]: (value) => PurchasingInspectionHeatingDeviceTypeTranslation[value],
		["decentralisedHeatingDeviceType"]: (value) => PurchasingInspectionHeatingDeviceTypeTranslation[value],
		["decentralisedWaterHeatingDeviceType"]: (value) => PurchasingInspectionWaterHeatingDeviceTypeTranslation[value],
		["stairCaseCondition"]: (value) => PurchasingInspectionAmenityConditionTranslation[value],
		["balconyCondition"]: (value) => PurchasingInspectionAmenityConditionTranslation[value],
		["enteranceDoorCondition"]: (value) => PurchasingInspectionAmenityConditionTranslation[value],
		["doorLabelCondition"]: (value) => PurchasingInspectionAmenityConditionTranslation[value],
		["outdoorAreaCondition"]: (value) => PurchasingInspectionAmenityConditionTranslation[value],
		["postBoxCondition"]: (value) => PurchasingInspectionAmenityConditionTranslation[value],
		["communityPropertyCondition"]: (value) => PurchasingInspectionAmenityConditionTranslation[value],
		["apartmentType"]: (value) => PurchasingInspectionApartmentTypeTranslation[value],
		["floor"]: (value) => PurchasingInspectionFloorTranslation[value],
		["floorLocation"]: (value) => PurchasingInspectionFloorLocationTranslation[value],
		["storageRoomAfterRenovation"]: (value) => PurchasingInspectionGuestToiletStorageRoomAfterRenovationOptionsTranslation[value],
		["floorType"]: (value) => PurchasingInspectionFloorTypeTranslation[value],
		["secondaryFloorType"]: (value) => PurchasingInspectionFloorTypeTranslation[value],
		["guestToiletAfterRenovation"]: (value) => PurchasingInspectionGuestToiletStorageRoomAfterRenovationOptionsTranslation[value],
		["energyConsumptionCategory"]: (value) => EnergyConsumptionCategory[value],
		["replaceWindowsCostRegulation"]: (value) => PurchasingInspectionReplaceWindowsCostRegulationTranslation[value],
		["parkingSpaceType"]: (value) => PurchasingInspectionParkingSpaceTypeTranslation[value]
	};
	transformPurchasingInspectionQuestionAnswer = (question, answer) => {
		let result = answer;
		const transformer = answerTransformers[question.name];
		if (transformer) result = transformer(answer) ?? answer;
		else if (question.type === "toggle") result = booleanGermanYesNoFormatter(answer);
		else if (question.type === "datepicker" && question.format !== "year_date") result = formatDate$1(answer, DateFormats.SimpleDate);
		return result;
	};
}));
//#endregion
//#region src/domains/purchasing/inspection/calculation/helpers.ts
var getLivingArea, getNumericFieldValue, getBooleanFieldValue, calculateCostByLivingArea, calculateConditionalFee, calculateScaledFee, getPurchasingInspectionConfigVal;
var init_helpers = __esmMin((() => {
	init_config_model();
	init_errors();
	init_purchasing_inspection();
	getLivingArea = (context) => context.formValues["newLivingArea"] ?? context.estate.attributes?.livingSpace ?? 0;
	getNumericFieldValue = (values, question, defaultValue = 0) => {
		const value = values[question] ?? defaultValue;
		if (typeof value !== "number" || isNaN(value)) throw new InvariantError(`${question} value is not a valid number`);
		return value;
	};
	getBooleanFieldValue = (values, question) => {
		const value = values[question];
		if (isNil(value)) return false;
		if (!isBoolean(value)) throw new InvariantError(`${question} value is not a boolean`);
		return value;
	};
	calculateCostByLivingArea = (context, question) => {
		return getNumericFieldValue(context.formValues, question) * getLivingArea(context);
	};
	calculateConditionalFee = ({ formValues }, question, feeCb = () => 0) => getBooleanFieldValue(formValues, question) ? feeCb() : 0;
	calculateScaledFee = ({ formValues }, question, feeMultiplierCb = () => 0) => {
		return getNumericFieldValue(formValues, question) * feeMultiplierCb();
	};
	getPurchasingInspectionConfigVal = (config, key, configSection = "PurchasingInspection", throwIfNotFound = true) => {
		const val = get(config, `${configSection}.${key}`);
		if (isNil(val) && throwIfNotFound) throw new InvariantError(`Error in calculation: ${toTitleCase(String(configSection))} - ${toTitleCase(String(key))} not found in config`);
		return val;
	};
}));
//#endregion
//#region src/domains/purchasing/inspection/calculation/renovation-extra-costs-formulas.ts
var calculateDecentralisedHeatingCost, calculateDecentralisedWaterHeatingCost, calculateRoomChangeCost, calculateApartmentTypeCost, calculateFloorTypeCost, calculateAsbestosSuspicionCost, calculateCeilingHeightCost, calculateParkingSpaceCleaningCost, RenovationExtraCostsFormulasMap;
var init_renovation_extra_costs_formulas = __esmMin((() => {
	init_config_model();
	init_estates();
	init_purchasing_inspection();
	init_purchasing_inspection_opts();
	init_helpers();
	calculateDecentralisedHeatingCost = ({ formValues, config }) => {
		const isWorthPreserving = formValues["isDecentralisedHeatingDeviceWorthPreserving"];
		const deviceType = formValues["decentralisedHeatingDeviceType"];
		return isWorthPreserving ? 0 : getPurchasingInspectionConfigVal(config, `lookupTables.noCentralHeatingUnpreservableDeviceCosts[${deviceType}]`);
	};
	calculateDecentralisedWaterHeatingCost = ({ formValues, config }) => {
		const isWorthPreserving = formValues["isDecentralisedWaterHeatingDeviceWorthPreserving"];
		const deviceType = formValues["decentralisedWaterHeatingDeviceType"];
		return isWorthPreserving ? 0 : getPurchasingInspectionConfigVal(config, `lookupTables.noCentralHotWaterUnpreservableDeviceCosts[${deviceType}]`);
	};
	calculateRoomChangeCost = ({ estate, formValues, config }) => {
		const roomDifference = (formValues["roomsAfterRenovation"] ?? 0) - (estate.attributes?.rooms ?? 0);
		const absRoomDifference = Math.abs(roomDifference);
		return absRoomDifference * (getPurchasingInspectionConfigVal(config, `roomChangeCosts[${absRoomDifference}]`, "LookupTable", false) ?? 0);
	};
	calculateApartmentTypeCost = ({ formValues, config }) => {
		if (formValues["apartmentType"] === "Maisonette") return getPurchasingInspectionConfigVal(config, "specialRenovationCosts.maisonetteAdditionPrice", "LookupTable");
		return 0;
	};
	calculateFloorTypeCost = ({ formValues, config }) => {
		if (formValues["floorType"] === "Parquet") return getPurchasingInspectionConfigVal(config, "assumptions.parquetRepairCost");
		return 0;
	};
	calculateAsbestosSuspicionCost = (context) => {
		const { formValues, config } = context;
		return (formValues["asbestosArea"] ?? 0) * getPurchasingInspectionConfigVal(config, "specialRenovationCosts.asbestosAdditionCoef", "LookupTable");
	};
	calculateCeilingHeightCost = (context) => {
		const { formValues, config } = context;
		const hasHighCeiling = formValues["isRoomCeilingHigherThan2_5Meters"];
		const livingArea = getLivingArea(context);
		const coefficient = getPurchasingInspectionConfigVal(config, "specialRenovationCosts.storeyHeightAdditionCoef", "LookupTable");
		return hasHighCeiling ? livingArea * coefficient : 0;
	};
	calculateParkingSpaceCleaningCost = (context) => {
		const { formValues, config } = context;
		const parkingSpaces = formValues["parkingSpaces"];
		if (!parkingSpaces?.length) return 0;
		return parkingSpaces.filter((space) => Boolean(space["shouldCleanParkingSpace"])).length * getPurchasingInspectionConfigVal(config, "assumptions.parkingSpaceCleaningCost");
	};
	RenovationExtraCostsFormulasMap = /* @__PURE__ */ new Map([
		["heritage", {
			fn: (context) => calculateCostByLivingArea(context, "heritage"),
			label: "Denkmalschutz"
		}],
		["socialConservationArea", {
			fn: (context) => calculateCostByLivingArea(context, "socialConservationArea"),
			label: "Soziales Erhaltungsgebiet"
		}],
		["redevelopmentArea", {
			fn: (context) => calculateCostByLivingArea(context, "redevelopmentArea"),
			label: "Sanierungsgebiet"
		}],
		["numberOfBeltWindersToReplace", {
			fn: (context) => calculateScaledFee(context, "numberOfBeltWindersToReplace", () => getPurchasingInspectionConfigVal(context.config, "assumptions.beltWinderReplacementCost")),
			label: "Kosten für neue Gurtwickler"
		}],
		["numberOfBeltWindersThatCanBeClosed", {
			fn: (context) => calculateScaledFee(context, "numberOfBeltWindersThatCanBeClosed", () => getPurchasingInspectionConfigVal(context.config, "assumptions.beltWinderFixingCost")),
			label: "Kosten für Reparatur Gurtwickler"
		}],
		["roomsAfterRenovation", {
			fn: calculateRoomChangeCost,
			label: "Kosten durch Raumanzahländerung"
		}],
		["apartmentType", {
			fn: calculateApartmentTypeCost,
			label: "Kosten durch Wohnungstyp"
		}],
		["shouldCleanAttic", {
			fn: (context) => calculateConditionalFee(context, "shouldCleanAttic", () => getPurchasingInspectionConfigVal(context.config, "assumptions.atticCleaningCost")),
			label: "Reinigung Dachboden"
		}],
		["cellarCleaningCosts", {
			fn: (context) => context.formValues["cellarCleaningCosts"] ?? 0,
			label: "Keller räumen"
		}],
		["shouldCleanCellar", {
			fn: (context) => !context.formValues["cellarCleaningCosts"] ? calculateConditionalFee(context, "shouldCleanCellar", () => getPurchasingInspectionConfigVal(context.config, "assumptions.cellarCleaningCost")) : 0,
			label: "Reinigung Keller"
		}],
		["shouldCleanGarden", {
			fn: (context) => calculateConditionalFee(context, "shouldCleanGarden", () => getPurchasingInspectionConfigVal(context.config, "assumptions.gardenCleaningCost")),
			label: "Reinigung Garten"
		}],
		["additionalArea", {
			fn: (context) => {
				const { formValues } = context;
				return calculateScaledFee(context, "additionalArea", () => formValues["renovationCostsPerSqM"]);
			},
			label: "Kosten zusätzliche Nutzfläche"
		}],
		["repairingUnrecoverableDamageCosts", {
			fn: (context) => context.formValues["repairingUnrecoverableDamageCosts"],
			label: "Unbehobene Schäden"
		}],
		["floorType", {
			fn: calculateFloorTypeCost,
			label: "Aufarbeitung Boden"
		}],
		["asbestosArea", {
			fn: calculateAsbestosSuspicionCost,
			label: "Asbest Reinigung"
		}],
		["numberOfWallsToBeMoved", {
			fn: (context) => calculateScaledFee(context, "numberOfWallsToBeMoved", () => getPurchasingInspectionConfigVal(context.config, "assumptions.wallDemolitionCost")),
			label: "Kosten für Wandversetzungen"
		}],
		["isRoomCeilingHigherThan2_5Meters", {
			fn: calculateCeilingHeightCost,
			label: "Zusatzkosten wegen hoher Decken"
		}],
		["hollowPlasterArea", {
			fn: (context) => calculateScaledFee(context, "hollowPlasterArea", () => getPurchasingInspectionConfigVal(context.config, "specialRenovationCosts.prefabricatedAdditionCoef", "LookupTable")),
			label: "Sanierung Hohlputzflächen"
		}],
		["visibleCracksInCeilingLength", {
			fn: (context) => calculateScaledFee(context, "visibleCracksInCeilingLength", () => getPurchasingInspectionConfigVal(context.config, "assumptions.visibleCracksInCeilingPerMCost")),
			label: "Kosten Risse in der Decke"
		}],
		["visibleCracksInInteriorWallsLength", {
			fn: (context) => calculateScaledFee(context, "visibleCracksInInteriorWallsLength", () => getPurchasingInspectionConfigVal(context.config, "assumptions.visibleCracksInInteriorWallsPerMCost")),
			label: "Kosten Risse in Innenwänden"
		}],
		["visibleCracksInExteriorWallsCosts", {
			fn: ({ formValues }) => getNumericFieldValue(formValues, "visibleCracksInExteriorWallsCosts"),
			label: "Kosten Risse in Außenwänden"
		}],
		["stuccoLengthWorthPreserving", {
			fn: (context) => calculateScaledFee(context, "stuccoLengthWorthPreserving", () => getPurchasingInspectionConfigVal(context.config, "assumptions.stuccoRefurbishCost")),
			label: "Aufarbeitung Stuck"
		}],
		["visibleMoistureInWallsAndCeilingsArea", {
			fn: (context) => calculateScaledFee(context, "visibleMoistureInWallsAndCeilingsArea", () => getPurchasingInspectionConfigVal(context.config, "assumptions.visibleMoistureInWallsAndCeilingsPerSqmCost")),
			label: "Entfernung Feuchtigkeit in Wänden/Decken"
		}],
		["visibleMoistureInWindowsArea", {
			fn: (context) => calculateScaledFee(context, "visibleMoistureInWindowsArea", () => getPurchasingInspectionConfigVal(context.config, "assumptions.visibleMoistureInWindowsPerSqmCost")),
			label: "Entfernung Feuchtigkeit an Fenstern"
		}],
		["stairsInLivingAreaCosts", {
			fn: ({ formValues }) => getNumericFieldValue(formValues, "stairsInLivingAreaCosts"),
			label: "Kosten für Treppen in Wohnbereich"
		}],
		["numberOfRegularDoorsToReplace", {
			fn: (context) => calculateScaledFee(context, "numberOfRegularDoorsToReplace", () => getPurchasingInspectionConfigVal(context.config, "assumptions.regularDoorReplacementCost")),
			label: "Kosten für Standardtüren"
		}],
		["numberOfHistoricalDoorsToReplace", {
			fn: (context) => calculateScaledFee(context, "numberOfHistoricalDoorsToReplace", () => getPurchasingInspectionConfigVal(context.config, "assumptions.historicalDoorReplacementCost")),
			label: "Kosten für historische Türen"
		}],
		["builtInKitchenDisposalCosts", {
			fn: (context) => context.formValues["builtInKitchenDisposalCosts"] ?? 0,
			label: "Entsorgung Einbauküche"
		}],
		["numberOfPlasticWindowsToReplace", {
			fn: (context) => calculateScaledFee(context, "numberOfPlasticWindowsToReplace", () => getPurchasingInspectionConfigVal(context.config, "assumptions.plasticWindowReplacementCost")),
			label: "Anzahl zu ersetzender Kunststofffenster"
		}],
		["numberOfWoodenWindowsToReplace", {
			fn: (context) => calculateScaledFee(context, "numberOfWoodenWindowsToReplace", () => getPurchasingInspectionConfigVal(context.config, "assumptions.woodenWindowReplacementCost")),
			label: "Anzahl zu ersetzender Holzfenster"
		}],
		["numberOfMetalWindowsToReplace", {
			fn: (context) => calculateScaledFee(context, "numberOfMetalWindowsToReplace", () => getPurchasingInspectionConfigVal(context.config, "assumptions.metalWindowReplacementCost")),
			label: "Anzahl zu ersetzender Metallfenster"
		}],
		["numberOfSingleGlazedWindowsToReplace", {
			fn: (context) => calculateScaledFee(context, "numberOfSingleGlazedWindowsToReplace", () => getPurchasingInspectionConfigVal(context.config, "assumptions.singleGlazedWindowCost")),
			label: "Kosten für Fenster mit Einfachverglasungen"
		}],
		["numberOfDoubleBoxWindows", {
			fn: (context) => calculateScaledFee(context, "numberOfDoubleBoxWindows", () => getPurchasingInspectionConfigVal(context.config, "assumptions.doubleBoxWindowCost")),
			label: "Kosten für Kasten-Doppelfenster"
		}],
		["numberOfIsoWindows", {
			fn: (context) => calculateScaledFee(context, "numberOfIsoWindows", () => getPurchasingInspectionConfigVal(context.config, "assumptions.isoWindowCost")),
			label: "Anzahl Isolierglasfenster"
		}],
		["parkingSpaces", {
			fn: calculateParkingSpaceCleaningCost,
			label: "Kosten Reinigung Stellplätze"
		}],
		["shouldReplaceMeter", {
			fn: (context) => calculateConditionalFee(context, "shouldReplaceMeter", () => getPurchasingInspectionConfigVal(context.config, "assumptions.replaceMeterCost")),
			label: "Neuer Zähler"
		}],
		["threePhaseConnectionUpgradeCosts", {
			fn: ({ formValues }) => getNumericFieldValue(formValues, "threePhaseConnectionUpgradeCosts"),
			label: "Ausbaukosten Drehstromanschluss"
		}],
		["hasElectroSubDistributionBoard", {
			fn: (context) => calculateConditionalFee(context, "hasElectroSubDistributionBoard", () => getPurchasingInspectionConfigVal(context.config, "assumptions.electricSubDistributionBoardCost")),
			label: "Unterverteilung Elektro Kosten"
		}],
		["hasWcWaterDirectlyThroughTheFloor", {
			fn: (context) => calculateConditionalFee(context, "hasWcWaterDirectlyThroughTheFloor", () => getPurchasingInspectionConfigVal(context.config, "assumptions.wcWaterDirectlyThroughTheFloorCost")),
			label: "WC-Anschluss über Boden (Mehraufwand)"
		}],
		["isGasPipeRoutingVisibleOnTheCeiling", {
			fn: (context) => calculateConditionalFee(context, "isGasPipeRoutingVisibleOnTheCeiling", () => getPurchasingInspectionConfigVal(context.config, "assumptions.gasPipeRoutingExtraCost")),
			label: "Sichtbare Gasleitungen an Decke (Mehraufwand)"
		}],
		["shouldRefurbishTerraceWallAndCeiling", {
			fn: (context) => calculateConditionalFee(context, "shouldRefurbishTerraceWallAndCeiling", () => getPurchasingInspectionConfigVal(context.config, "assumptions.terraceWallAndCeilingRefurbishmentCost")),
			label: "Sanierung Terrasse (Wand & Decke)"
		}],
		["shouldRefurbishTerraceFloor", {
			fn: (context) => calculateConditionalFee(context, "shouldRefurbishTerraceFloor", () => getPurchasingInspectionConfigVal(context.config, "assumptions.terraceFloorRefurbishmentCost")),
			label: "Sanierung Terrasse (Boden)"
		}],
		["shouldRefurbishTerraceParapet", {
			fn: (context) => calculateConditionalFee(context, "shouldRefurbishTerraceParapet", () => getPurchasingInspectionConfigVal(context.config, "assumptions.terraceParapetRefurbishmentCost")),
			label: "Sanierung Terrasse (Brüstung)"
		}],
		["shouldRefurbishBalconyWallAndCeiling", {
			fn: (context) => calculateConditionalFee(context, "shouldRefurbishBalconyWallAndCeiling", () => getPurchasingInspectionConfigVal(context.config, "assumptions.balconyWallAndCeilingRefurbishmentCost")),
			label: "Sanierung Balkon (Wand & Decke)"
		}],
		["shouldRefurbishBalconyFloor", {
			fn: (context) => calculateConditionalFee(context, "shouldRefurbishBalconyFloor", () => getPurchasingInspectionConfigVal(context.config, "assumptions.balconyFloorRefurbishmentCost")),
			label: "Sanierung Balkon (Boden)"
		}],
		["shouldRefurbishBalconyParapet", {
			fn: (context) => calculateConditionalFee(context, "shouldRefurbishBalconyParapet", () => getPurchasingInspectionConfigVal(context.config, "assumptions.balconyParapetRefurbishmentCost")),
			label: "Sanierung Balkon (Brüstung)"
		}],
		["extensiveCleaningCosts", {
			fn: ({ formValues }) => getNumericFieldValue(formValues, "extensiveCleaningCosts"),
			label: "Kosten für Extrareinigung"
		}],
		["decentralisedHeatingDeviceType", {
			fn: calculateDecentralisedHeatingCost,
			label: "Nicht erhaltbares Heizgerät (dezentral)"
		}],
		["decentralisedWaterHeatingDeviceType", {
			fn: calculateDecentralisedWaterHeatingCost,
			label: "Nicht erhaltbares Warmwassergerät (dezentral)"
		}],
		["hasHeatingCablesLaidOnPlaster", {
			fn: (context) => calculateConditionalFee(context, "hasHeatingCablesLaidOnPlaster", () => getPurchasingInspectionConfigVal(context.config, "assumptions.heatingCablesLaidOnPlaster")),
			label: "Heizkabel im Putz bündig verlegen (Mehraufwand)"
		}],
		["resultingAdditionalCosts", {
			fn: ({ formValues }) => getNumericFieldValue(formValues, "resultingAdditionalCosts"),
			label: "Sonderumlagen Mehrkosten"
		}]
	]);
}));
//#endregion
//#region src/domains/purchasing/inspection/calculation/renovation-extra-costs-calculator.ts
var RenovationExtraCostsCalculator;
var init_renovation_extra_costs_calculator = __esmMin((() => {
	init_errors();
	init_renovation_extra_costs_formulas();
	RenovationExtraCostsCalculator = class {
		formulas;
		constructor(formulas = RenovationExtraCostsFormulasMap) {
			this.formulas = formulas;
		}
		/**
		* Evaluates all formulas and returns a breakdown of computed costs.
		* Each formula execution is protected with error handling.
		*/
		calculateBreakdown(context) {
			const computed = {};
			if (!context.formValues || !Object.keys(context.formValues).length) return computed;
			for (const [key, { fn }] of this.formulas) if (key in context.formValues) try {
				computed[key] = fn(context);
			} catch (error) {
				throw new InvariantError(`Error calculating formula ${key}: ${error.message}`);
			}
			return computed;
		}
		/**
		* Calculates the total cost by summing up all the computed costs.
		*/
		calculate(context) {
			let breakdown = this.calculateBreakdown(context);
			breakdown = Object.fromEntries(Object.entries(breakdown).filter(([, value]) => value > 0));
			const total = safeSum(...Object.values(breakdown));
			return {
				breakdown,
				total
			};
		}
	};
}));
//#endregion
//#region src/domains/purchasing/inspection/calculation/index.ts
var init_calculation = __esmMin((() => {
	init_renovation_extra_costs_calculator();
	init_renovation_extra_costs_formulas();
}));
//#endregion
//#region src/domains/purchasing/inspection/exclusion/exclusion-criterion.ts
var PurchasingInspectionExclusionCriterionMap;
var init_exclusion_criterion = __esmMin((() => {
	init_estates();
	init_purchasing_inspection();
	init_purchasing_inspection_opts();
	PurchasingInspectionExclusionCriterionMap = /* @__PURE__ */ new Map([
		["hasSuspectedLead", (context) => context.formValues["hasSuspectedLead"]],
		["isHouseConnectionNotSufficient", (context) => context.formValues["isHouseConnectionNotSufficient"] === true || context.formValues["isHouseConnectionNotSufficient"] === "Yes"],
		["apartmentType", (context) => ["HalfBasement"].includes(context.formValues["apartmentType"])],
		["isEnergyEfficiencyUpgradable", ({ formValues }) => !formValues["isEnergyEfficiencyUpgradable"]],
		["hasSevereCracksInExteriorWalls", (context) => context.formValues["hasSevereCracksInExteriorWalls"]]
	]);
}));
//#endregion
//#region src/domains/purchasing/inspection/exclusion/exclusion-reducer.ts
var PurchasingChecklistExclusionReducer;
var init_exclusion_reducer = __esmMin((() => {
	init_errors();
	init_purchasing_inspection_helpers();
	init_exclusion_criterion();
	PurchasingChecklistExclusionReducer = class {
		questions;
		criterion;
		constructor(questions, criterion = PurchasingInspectionExclusionCriterionMap) {
			this.questions = questions;
			this.criterion = criterion;
		}
		/**
		* Reduces exclusion criterion applied to inspection
		*/
		reduce(context) {
			const exclusions = {};
			if (!context.formValues || !Object.keys(context.formValues).length) return exclusions;
			for (const [key, fn] of this.criterion) if (key in context.formValues) try {
				const shouldExclude = fn(context);
				const question = this.questions.find((q) => q.name === key);
				if (shouldExclude && question) exclusions[key] = transformPurchasingInspectionQuestionAnswer(question, context.formValues[key]);
			} catch (error) {
				throw new InvariantError(`Error accessing criterion ${key}: ${error.message}`);
			}
			return exclusions;
		}
	};
}));
//#endregion
//#region src/domains/purchasing/inspection/exclusion/index.ts
var init_exclusion = __esmMin((() => {
	init_exclusion_reducer();
	init_exclusion_criterion();
}));
//#endregion
//#region src/domains/purchasing/index.ts
var init_purchasing = __esmMin((() => {
	init_purchasing_inspection();
	init_purchasing_inspection_opts();
	init_purchasing_inspection_helpers();
	init_calculation();
	init_exclusion();
}));
//#endregion
//#region src/domains/portfolio-analyzer/pa-analysis.schema.ts
var PaAnalysisConfidence, PaAnalysisConfidenceSchema, PaLocationClass, PaLocationClassSchema, PaAnalysisSourceSchema, PaAnalysisDatapointSchema, baseSectionProps, PaAmenityCategory, PaAmenityCategorySchema, PaAmenityPoiSchema, PaAmenityGroupSchema, PaLocationAnalysisSchema, PaAssetMediaSchema, PaAssetAnalysisSchema, PaConstructionMeasureSchema, PaConstructionAnalysisSchema, PaSubsidyScope, PaSubsidyScopeSchema, PaSubsidyProgramSchema, PaSubsidyAnalysisSchema, PaRentalAnalysisSchema, PaExecutiveSummarySchema, PaAnalysisSectionsSchema, PaPartialAnalysisSectionsSchema, PaAnalysisResultSchema;
var init_pa_analysis_schema = __esmMin((() => {
	init_lib();
	PaAnalysisConfidence = /* @__PURE__ */ function(PaAnalysisConfidence) {
		PaAnalysisConfidence["High"] = "high";
		PaAnalysisConfidence["Medium"] = "medium";
		PaAnalysisConfidence["Low"] = "low";
		return PaAnalysisConfidence;
	}({});
	PaAnalysisConfidenceSchema = TEnum(PaAnalysisConfidence);
	PaLocationClass = /* @__PURE__ */ function(PaLocationClass) {
		PaLocationClass["A"] = "A";
		PaLocationClass["B"] = "B";
		PaLocationClass["C"] = "C";
		return PaLocationClass;
	}({});
	PaLocationClassSchema = TEnum(PaLocationClass);
	PaAnalysisSourceSchema = Type.Object({
		label: Type.String(),
		url: Type.Optional(Type.String()),
		datasetId: Type.Optional(Type.String())
	});
	PaAnalysisDatapointSchema = Type.Object({
		label: Type.String(),
		value: Type.String(),
		unit: Type.Optional(Type.String()),
		source: Type.Optional(Type.String()),
		confidence: Type.Optional(PaAnalysisConfidenceSchema),
		estimated: Type.Optional(Type.Boolean())
	});
	baseSectionProps = {
		title: Type.String(),
		/** Human-readable narrative / interpretation for the section. */
		interpretation: Type.String(),
		/** Bullet facts surfaced in the UI. */
		explicitFacts: Type.Array(Type.String()),
		datapoints: Type.Array(PaAnalysisDatapointSchema),
		/** True when the section relies on inferred/estimated values rather than hard data. */
		estimated: Type.Boolean(),
		sources: Type.Array(PaAnalysisSourceSchema)
	};
	PaAmenityCategory = /* @__PURE__ */ function(PaAmenityCategory) {
		/** Schools, Kitas, Kindergärten, family-friendliness. */
		PaAmenityCategory["Education"] = "education";
		/** Public transport, highways (Autobahn), Bundesstraßen. */
		PaAmenityCategory["Transport"] = "transport";
		/** Supermarkets, grocery, daily supply. */
		PaAmenityCategory["Supply"] = "supply";
		return PaAmenityCategory;
	}({});
	PaAmenityCategorySchema = TEnum(PaAmenityCategory);
	PaAmenityPoiSchema = Type.Object({
		name: Type.String(),
		/** Free-form type, e.g. "Grundschule", "S-Bahn", "Autobahn A100", "Supermarkt". */
		type: Type.Optional(Type.String()),
		/** Approximate distance or travel time, e.g. "350 m", "5 min walk", "2 km". */
		distance: Type.Optional(Type.String())
	});
	PaAmenityGroupSchema = Type.Object({
		category: PaAmenityCategorySchema,
		label: Type.String(),
		summary: Type.String(),
		pois: Type.Array(PaAmenityPoiSchema)
	});
	PaLocationAnalysisSchema = Type.Object({
		...baseSectionProps,
		aLocationClass: Type.Optional(PaLocationClassSchema),
		/** Neighbourhood amenities grouped by category (education/family, transport, supply). */
		amenities: Type.Optional(Type.Array(PaAmenityGroupSchema)),
		/** One-line qualitative read on family-friendliness of the micro-location. */
		familyFriendliness: Type.Optional(Type.String()),
		/** Achievable rent (€/m²) feeding the construction economic gate. */
		achievableRentPerSqm: Type.Optional(TNullable(Type.Number())),
		wohnlage: Type.Optional(Type.String()),
		quarter: Type.Optional(Type.String()),
		city: Type.Optional(Type.String()),
		coordinates: Type.Optional(Type.Object({
			lat: Type.Number(),
			lng: Type.Number()
		}))
	});
	PaAssetMediaSchema = Type.Object({
		/** Display URL (public/signed) the frontend can render directly. */
		url: Type.String(),
		mimeType: Type.Optional(Type.String()),
		/** 1-indexed source page in the originating exposé PDF. */
		sourcePage: Type.Optional(TNullable(Type.Number()))
	});
	PaAssetAnalysisSchema = Type.Object({
		...baseSectionProps,
		/** Extracted asset media (exposé photos) linked from the asset's media section. */
		media: Type.Optional(Type.Array(PaAssetMediaSchema))
	});
	PaConstructionMeasureSchema = Type.Object({
		name: Type.String(),
		included: Type.Boolean(),
		scenario: Type.Optional(Type.String()),
		rationale: Type.String(),
		estimatedCostPerSqm: Type.Optional(TNullable(Type.Number())),
		estimatedCost: Type.Optional(TNullable(Type.Number()))
	});
	PaConstructionAnalysisSchema = Type.Object({
		...baseSectionProps,
		recommendedMeasures: Type.Array(PaConstructionMeasureSchema),
		/** Economic gate inputs relayed from the Location section. */
		locationGate: Type.Optional(Type.Object({
			aLocationClass: Type.Optional(PaLocationClassSchema),
			achievableRentPerSqm: Type.Optional(TNullable(Type.Number())),
			scenario: Type.Optional(Type.String())
		})),
		d2gComparison: Type.Optional(Type.Object({
			d2gRenovationCost: Type.Optional(TNullable(Type.Number())),
			recommendedCost: Type.Optional(TNullable(Type.Number())),
			delta: Type.Optional(TNullable(Type.Number())),
			d2gRenovationCostPerSqm: Type.Optional(TNullable(Type.Number())),
			recommendedCostPerSqm: Type.Optional(TNullable(Type.Number())),
			deltaPerSqm: Type.Optional(TNullable(Type.Number())),
			inputPath: Type.Optional(Type.String()),
			renovationCostInputRecommendation: Type.Optional(Type.Object({
				inputPath: Type.String(),
				label: Type.String(),
				currentValue: TNullable(Type.Number()),
				recommendedValue: TNullable(Type.Number()),
				delta: TNullable(Type.Number()),
				materialMismatch: Type.Boolean(),
				scenario: Type.Optional(Type.String()),
				reason: Type.String()
			})),
			note: Type.Optional(Type.String())
		}))
	});
	PaSubsidyScope = /* @__PURE__ */ function(PaSubsidyScope) {
		PaSubsidyScope["Regional"] = "regional";
		PaSubsidyScope["State"] = "state";
		return PaSubsidyScope;
	}({});
	PaSubsidyScopeSchema = TEnum(PaSubsidyScope);
	PaSubsidyProgramSchema = Type.Object({
		name: Type.String(),
		scope: PaSubsidyScopeSchema,
		region: Type.Optional(Type.String()),
		eligible: Type.Boolean(),
		d2gSharePct: Type.Optional(TNullable(Type.Number())),
		rationale: Type.String()
	});
	PaSubsidyAnalysisSchema = Type.Object({
		...baseSectionProps,
		programs: Type.Array(PaSubsidyProgramSchema)
	});
	PaRentalAnalysisSchema = Type.Object({
		...baseSectionProps,
		percentiles: Type.Optional(Type.Object({
			minimum: Type.Optional(TNullable(Type.Number())),
			maximum: Type.Optional(TNullable(Type.Number())),
			average: Type.Optional(TNullable(Type.Number())),
			median: Type.Optional(TNullable(Type.Number())),
			firstQuartile: Type.Optional(TNullable(Type.Number())),
			thirdQuartile: Type.Optional(TNullable(Type.Number()))
		})),
		rentDevelopment: Type.Optional(Type.String()),
		milieuschutz: Type.Optional(Type.Object({
			isProtected: Type.Optional(TNullable(Type.Boolean())),
			note: Type.Optional(Type.String()),
			source: Type.Optional(Type.String())
		})),
		rentIndex: Type.Optional(Type.Object({
			available: Type.Boolean(),
			value: Type.Optional(TNullable(Type.Number())),
			note: Type.Optional(Type.String()),
			source: Type.Optional(Type.String())
		}))
	});
	PaExecutiveSummarySchema = Type.Object({
		text: Type.String(),
		comparisons: Type.Array(Type.Object({
			block: Type.String(),
			observation: Type.String()
		}))
	});
	PaAnalysisSectionsSchema = Type.Object({
		location: PaLocationAnalysisSchema,
		asset: PaAssetAnalysisSchema,
		construction: PaConstructionAnalysisSchema,
		subsidy: PaSubsidyAnalysisSchema,
		rental: PaRentalAnalysisSchema
	});
	PaPartialAnalysisSectionsSchema = Type.Partial(PaAnalysisSectionsSchema);
	PaAnalysisResultSchema = Type.Object({
		generatedAt: Type.String({ format: "date-time" }),
		...PaAnalysisSectionsSchema.properties,
		executiveSummary: Type.Optional(PaExecutiveSummarySchema)
	});
}));
//#endregion
//#region src/domains/portfolio-analyzer/pa-output.schema.ts
var PaFieldStatusSchema, PaConfidenceLevelSchema, PaFieldSourceSchema, PaFieldTrustProperties, PaStringFieldSchema, PaNumberFieldSchema, PaBooleanFieldSchema, PaStringArrayFieldSchema, PaArtifactSchema, PaOutputSummarySchema, PaOutputWarningSchema, PaIdentifiedInputSchema, PaAssetMediaItemSchema, PaAssetMediaFieldSchema, PaAssetLocationSchema, PaAssetDataAttributesSchema, PaAssetDataRealtorFormSchema, PaAssetDataSchema, PaD2gOverviewSchema, PaD2gBuildingTechnicalSchema, PaD2gRentSchema, PaD2gDataSchema, PaOutputAssetSchema, PaOutputSchema;
var init_pa_output_schema = __esmMin((() => {
	init_lib();
	PaFieldStatusSchema = Type.String({ enum: [
		"defaulted",
		"extracted",
		"conflict_resolved",
		"missing",
		"inferred"
	] });
	PaConfidenceLevelSchema = Type.String({ enum: ["high", "low"] });
	PaFieldSourceSchema = Type.Object({
		file_id: Type.Optional(TNullable(Type.String())),
		page: Type.Optional(TNullable(Type.Number())),
		sheet: Type.Optional(TNullable(Type.String())),
		derived_from: Type.Optional(Type.String())
	});
	PaFieldTrustProperties = {
		confidence_level: Type.Optional(PaConfidenceLevelSchema),
		source: Type.Optional(PaFieldSourceSchema)
	};
	PaStringFieldSchema = Type.Object({
		value: TNullable(Type.String()),
		status: PaFieldStatusSchema,
		...PaFieldTrustProperties
	});
	PaNumberFieldSchema = Type.Object({
		value: TNullable(Type.Number()),
		status: PaFieldStatusSchema,
		...PaFieldTrustProperties
	});
	PaBooleanFieldSchema = Type.Object({
		value: TNullable(Type.Boolean()),
		status: PaFieldStatusSchema,
		...PaFieldTrustProperties
	});
	PaStringArrayFieldSchema = Type.Object({
		value: TNullable(Type.Array(Type.String())),
		status: PaFieldStatusSchema,
		...PaFieldTrustProperties
	});
	PaArtifactSchema = Type.Object({
		uri: Type.String(),
		kind: Type.String(),
		mime_type: Type.String(),
		source_input_uri: Type.Optional(TNullable(Type.String()))
	});
	PaOutputSummarySchema = Type.Object({
		assets_extracted: Type.Number(),
		fields_extracted: Type.Number(),
		fields_missing: Type.Number(),
		fields_inferred: Type.Number(),
		fields_conflict_resolved: Type.Optional(Type.Number()),
		fields_defaulted: Type.Optional(Type.Number()),
		missing_mandatory_paths: Type.Array(Type.String())
	});
	PaOutputWarningSchema = Type.Object({
		code: Type.String(),
		message: Type.String(),
		field_path: Type.Optional(Type.String()),
		source_input_uri: Type.Optional(Type.String())
	});
	PaIdentifiedInputSchema = Type.Object({
		identified: Type.Array(Type.Object({
			type: Type.String(),
			file: Type.String()
		})),
		missed: Type.Array(Type.String())
	});
	PaAssetMediaItemSchema = Type.Object({
		uri: Type.String(),
		mime_type: Type.String(),
		source_page: Type.Number()
	});
	PaAssetMediaFieldSchema = Type.Object({
		value: Type.Array(PaAssetMediaItemSchema),
		status: PaFieldStatusSchema,
		...PaFieldTrustProperties
	});
	PaAssetLocationSchema = Type.Object({
		street: PaStringFieldSchema,
		houseNumber: PaStringFieldSchema,
		zipcode: PaStringFieldSchema,
		city: PaStringFieldSchema,
		country: PaStringFieldSchema,
		district: Type.Optional(PaStringFieldSchema),
		/** Demo / Basecamp alias. Live PA sends `district` only. */
		quarter: Type.Optional(PaStringFieldSchema),
		latitude: Type.Optional(Type.Number()),
		longitude: Type.Optional(Type.Number())
	});
	PaAssetDataAttributesSchema = Type.Object({
		splitStatus: PaStringFieldSchema,
		numberOfBuildings: PaNumberFieldSchema,
		estimatedNumberOfApartments: PaNumberFieldSchema,
		estimatedNumberOfCommercialUnits: PaNumberFieldSchema,
		estimatedLivingSpace: PaNumberFieldSchema,
		estimatedCommercialSpace: PaNumberFieldSchema,
		estimatedNumberOfParkingSpaces: PaNumberFieldSchema,
		constructionYear: PaNumberFieldSchema,
		restrictions: PaStringArrayFieldSchema,
		expansionPotential: PaStringFieldSchema,
		rentalIncomeActual: PaNumberFieldSchema,
		commercialRentalIncomeActual: PaNumberFieldSchema,
		rentalParkingSpaceIncome: PaNumberFieldSchema,
		residentialOccupancyRate: PaNumberFieldSchema,
		commercialOccupancyRate: PaNumberFieldSchema,
		parkingOccupancyRate: PaNumberFieldSchema,
		hasBrickFacade: PaBooleanFieldSchema,
		facadeInsulationRate: PaNumberFieldSchema,
		buildingEnergyRating: PaStringFieldSchema,
		/** Injected when PA puts the A–H letter on `buildingEnergyRating` or d2g `endEnergyConsumptionClass`. */
		energyCertificateClass: Type.Optional(PaStringFieldSchema),
		primaryHeatingType: PaStringFieldSchema,
		primaryEnergyDemand: PaNumberFieldSchema,
		endEnergyDemand: PaNumberFieldSchema
	});
	PaAssetDataRealtorFormSchema = Type.Object({
		firstName: PaStringFieldSchema,
		lastName: PaStringFieldSchema,
		email: PaStringFieldSchema,
		phoneNumber: PaStringFieldSchema,
		companyName: PaStringFieldSchema
	});
	PaAssetDataSchema = Type.Object({
		mandateType: PaStringFieldSchema,
		mfh: Type.Object({ title: PaStringFieldSchema }),
		price: Type.Object({
			purchasePriceNett: PaNumberFieldSchema,
			courtageMultiplierWithoutVat: PaNumberFieldSchema
		}),
		attributes: PaAssetDataAttributesSchema,
		media: PaAssetMediaFieldSchema,
		realtorForm: PaAssetDataRealtorFormSchema,
		locations: Type.Array(PaAssetLocationSchema)
	});
	PaD2gOverviewSchema = Type.Object({
		rentResidentialCurrent: PaNumberFieldSchema,
		resiSpaceSqm: PaNumberFieldSchema,
		resiUnits: PaNumberFieldSchema,
		commercialSpaceSqm: PaNumberFieldSchema,
		commercialUnits: PaNumberFieldSchema,
		parkingSpaces: PaNumberFieldSchema
	});
	PaD2gBuildingTechnicalSchema = Type.Object({
		brickFacadeSqm: PaNumberFieldSchema,
		endEnergyConsumptionClass: Type.Optional(PaStringFieldSchema)
	});
	PaD2gRentSchema = Type.Object({
		jnkmCommercialCurrent: PaNumberFieldSchema,
		jnkmParkingSpacesCurrent: PaNumberFieldSchema,
		resiOccupancyActual: PaNumberFieldSchema,
		commercialOccupancyActual: PaNumberFieldSchema,
		parkingOccupancyActual: PaNumberFieldSchema
	});
	PaD2gDataSchema = Type.Object({
		rentRollVersionId: Type.Optional(PaNumberFieldSchema),
		rentRollDate: Type.Optional(PaStringFieldSchema),
		overview: PaD2gOverviewSchema,
		buildingTechnical: PaD2gBuildingTechnicalSchema,
		rent: PaD2gRentSchema
	});
	PaOutputAssetSchema = Type.Object({
		asset_index: Type.Number(),
		asset_name: Type.String(),
		asset_data: PaAssetDataSchema,
		d2g_data: PaD2gDataSchema
	});
	PaOutputSchema = Type.Object({
		service_version: Type.String(),
		request_echo: Type.Object({
			request_id: Type.Union([Type.String(), Type.Number()]),
			portfolio_name: Type.String(),
			mandate_type: Type.String(),
			input_files: Type.Array(Type.String())
		}),
		artifacts: Type.Array(PaArtifactSchema),
		identified_input: Type.Optional(PaIdentifiedInputSchema),
		assets: Type.Array(PaOutputAssetSchema),
		summary: PaOutputSummarySchema,
		errors: Type.Array(Type.Unknown()),
		warnings: Type.Array(PaOutputWarningSchema)
	});
}));
//#endregion
//#region src/domains/portfolio-analyzer/pa-session.schema.ts
var PaSessionStatus, PaSessionState, PaSessionStatusSchema, PaSessionStateSchema, PaExtractionStep, PaExtractionStepSchema, PaReviewStatus, PaReviewSection, PaReviewSectionStatus, PaReviewStatusSchema, PaReviewSectionSchema, PaReviewSectionStatusSchema, PaExtractionProgressSchema, PaReviewProgressSchema, PaSessionSchema;
var init_pa_session_schema = __esmMin((() => {
	init_lib();
	init_mfh_attributes_base();
	init_pa_analysis_schema();
	init_pa_output_schema();
	PaSessionStatus = /* @__PURE__ */ function(PaSessionStatus) {
		PaSessionStatus["Created"] = "Created";
		PaSessionStatus["Completed"] = "Completed";
		PaSessionStatus["Rejected"] = "Rejected";
		return PaSessionStatus;
	}({});
	PaSessionState = /* @__PURE__ */ function(PaSessionState) {
		PaSessionState["Created"] = "Created";
		PaSessionState["FilesAttached"] = "FilesAttached";
		PaSessionState["Extracting"] = "Extracting";
		PaSessionState["Extracted"] = "Extracted";
		PaSessionState["DataConfirmed"] = "DataConfirmed";
		PaSessionState["PortfolioCreating"] = "PortfolioCreating";
		PaSessionState["PortfolioCreated"] = "PortfolioCreated";
		PaSessionState["ICCreated"] = "ICCreated";
		PaSessionState["ICMissingInputsSet"] = "ICMissingInputsSet";
		PaSessionState["ICCalculationPending"] = "ICCalculationPending";
		PaSessionState["ICCalculationCompleted"] = "ICCalculationCompleted";
		PaSessionState["Failed"] = "Failed";
		return PaSessionState;
	}({});
	PaSessionStatusSchema = TEnum(PaSessionStatus);
	PaSessionStateSchema = TEnum(PaSessionState);
	PaExtractionStep = /* @__PURE__ */ function(PaExtractionStep) {
		PaExtractionStep["Preparing"] = "preparing";
		PaExtractionStep["Classifying"] = "classifying";
		PaExtractionStep["Parsing"] = "parsing";
		PaExtractionStep["Extracting"] = "extracting";
		PaExtractionStep["Normalizing"] = "normalizing";
		PaExtractionStep["Finalizing"] = "finalizing";
		return PaExtractionStep;
	}({});
	PaExtractionStepSchema = TEnum(PaExtractionStep);
	PaReviewStatus = /* @__PURE__ */ function(PaReviewStatus) {
		PaReviewStatus["Running"] = "Running";
		PaReviewStatus["Completed"] = "Completed";
		PaReviewStatus["Failed"] = "Failed";
		return PaReviewStatus;
	}({});
	PaReviewSection = /* @__PURE__ */ function(PaReviewSection) {
		PaReviewSection["Location"] = "location";
		PaReviewSection["Asset"] = "asset";
		PaReviewSection["Construction"] = "construction";
		PaReviewSection["Subsidy"] = "subsidy";
		PaReviewSection["Rental"] = "rental";
		return PaReviewSection;
	}({});
	PaReviewSectionStatus = /* @__PURE__ */ function(PaReviewSectionStatus) {
		PaReviewSectionStatus["Pending"] = "pending";
		PaReviewSectionStatus["Active"] = "active";
		PaReviewSectionStatus["Done"] = "done";
		PaReviewSectionStatus["Failed"] = "failed";
		return PaReviewSectionStatus;
	}({});
	PaReviewStatusSchema = TEnum(PaReviewStatus);
	PaReviewSectionSchema = TEnum(PaReviewSection);
	PaReviewSectionStatusSchema = TEnum(PaReviewSectionStatus);
	PaExtractionProgressSchema = Type.Object({
		step: PaExtractionStepSchema,
		stepIndex: Type.Number(),
		totalSteps: Type.Number(),
		percent: Type.Number(),
		label: Type.String(),
		updatedAt: Type.String({ format: "date-time" })
	});
	PaReviewProgressSchema = Type.Object({
		status: PaReviewStatusSchema,
		runId: Type.Optional(Type.String()),
		sections: Type.Object({
			["location"]: PaReviewSectionStatusSchema,
			["asset"]: PaReviewSectionStatusSchema,
			["construction"]: PaReviewSectionStatusSchema,
			["subsidy"]: PaReviewSectionStatusSchema,
			["rental"]: PaReviewSectionStatusSchema
		}),
		/** Optional 0–100 completion percentage per section while it is active (sub-step granularity). */
		sectionProgress: Type.Optional(Type.Partial(Type.Object({
			["location"]: Type.Number(),
			["asset"]: Type.Number(),
			["construction"]: Type.Number(),
			["subsidy"]: Type.Number(),
			["rental"]: Type.Number()
		}))),
		label: Type.Optional(Type.String()),
		error: Type.Optional(Type.String()),
		updatedAt: Type.String({ format: "date-time" }),
		handoverPostedAt: Type.Optional(Type.String({ format: "date-time" })),
		summaryPostedAt: Type.Optional(Type.String({ format: "date-time" }))
	});
	PaSessionSchema = Type.Object({
		paSessionId: Type.Number(),
		title: Type.String(),
		status: PaSessionStatusSchema,
		state: PaSessionStateSchema,
		userId: Type.String(),
		mfhPortfolioId: Type.Optional(Type.Number()),
		mfhId: Type.Optional(Type.Number()),
		investmentCaseId: Type.Optional(Type.Number()),
		userTaskId: Type.Optional(Type.Number()),
		metadata: Type.Partial(Type.Object({
			extractedData: PaOutputSchema,
			analysisSections: PaPartialAnalysisSectionsSchema,
			analysisResult: PaAnalysisResultSchema,
			mandateType: TEnum(MandateType),
			progress: PaExtractionProgressSchema,
			reviewProgress: PaReviewProgressSchema,
			extractionError: Type.String(),
			uploadedFiles: Type.Array(Type.Object({
				filename: Type.String(),
				mimeType: Type.String(),
				byteLength: Type.Optional(Type.Number()),
				documentId: Type.Optional(Type.Number()),
				link: Type.Optional(Type.String()),
				path: Type.Optional(Type.String())
			}))
		})),
		createdAt: Type.String({ format: "date-time" }),
		updatedAt: Type.String({ format: "date-time" })
	});
}));
//#endregion
//#region src/domains/portfolio-analyzer/pa-backend-tools.mcp.ts
var PaBackendMCPTools;
var init_pa_backend_tools_mcp = __esmMin((() => {
	PaBackendMCPTools = /* @__PURE__ */ function(PaBackendMCPTools) {
		PaBackendMCPTools["GetSessionInfo"] = "get_session_info";
		PaBackendMCPTools["UpdateSessionState"] = "update_session_state";
		PaBackendMCPTools["GetExtractionSummary"] = "get_extraction_summary";
		return PaBackendMCPTools;
	}({});
}));
//#endregion
//#region src/domains/portfolio-analyzer/index.ts
var init_portfolio_analyzer = __esmMin((() => {
	init_pa_analysis_schema();
	init_pa_output_schema();
	init_pa_session_schema();
	init_pa_backend_tools_mcp();
}));
//#endregion
//#region src/domains/selling/selling.helpers.ts
var SellingChecklistDataPoints, sellingDataPoints, hasMediaFileVariantOrParentWithTag;
var init_selling_helpers = __esmMin((() => {
	init_document_model();
	init_media_file();
	init_finance();
	init_document_inspection_model();
	SellingChecklistDataPoints = /* @__PURE__ */ function(SellingChecklistDataPoints) {
		SellingChecklistDataPoints["InvestorCashflowOfTypeSalesPackage"] = "Investors Cashflow of Type Sales Package";
		SellingChecklistDataPoints["PostRenovationAttributes"] = "Post-Renovation Attributes";
		SellingChecklistDataPoints["Address"] = "Adresse";
		SellingChecklistDataPoints["AttributesConstructionYear"] = "Attributes - Baujahr";
		SellingChecklistDataPoints["AttributesFloor"] = "Attributes - Etage";
		SellingChecklistDataPoints["TotalMaintenanceReserve"] = "Total Maintenance Reserve";
		SellingChecklistDataPoints["EstateMaintenanceReserve"] = "Estate Maintenance Reserve";
		SellingChecklistDataPoints["HomeOwnersFee"] = "Home Owners' Fee";
		SellingChecklistDataPoints["HomeOwnersFeeTransferable"] = "Home Owners' Fee Transferable";
		SellingChecklistDataPoints["HomeOwnersFeeNonTransferable"] = "Home Owners' Fee Non-Transferable";
		SellingChecklistDataPoints["HomeOwnersFeeReserve"] = "Home Owners' Fee Reserve";
		SellingChecklistDataPoints["StandortprofilPDF"] = "Standortprofil PDF";
		SellingChecklistDataPoints["MediaTagFloorplan"] = "Media Tag - Floorplan";
		SellingChecklistDataPoints["MediaTagLivingRoom"] = "Media Tag - Living Room";
		SellingChecklistDataPoints["MediaTagKitchen"] = "Media Tag - Kitchen";
		SellingChecklistDataPoints["MediaTagBathroom"] = "Media Tag - Bathroom";
		SellingChecklistDataPoints["MediaTagRoom1"] = "Media Tag - Room 1";
		SellingChecklistDataPoints["MediaTagRoom2"] = "Media Tag - Room 2";
		SellingChecklistDataPoints["MediaTagRoom3"] = "Media Tag - Room 3";
		SellingChecklistDataPoints["TemplateExposeLivingRoom"] = "Template Expose - Living Room";
		SellingChecklistDataPoints["TemplateExposeKitchen"] = "Template Expose - Kitchen";
		SellingChecklistDataPoints["TemplateExposeBathroom"] = "Template Expose - Bathroom";
		SellingChecklistDataPoints["TemplateExposeRoom1"] = "Template Expose - Room 1";
		SellingChecklistDataPoints["TemplateExposeRoom2"] = "Template Expose - Room 2";
		SellingChecklistDataPoints["TemplateExposeRoom3"] = "Template Expose - Room 3";
		SellingChecklistDataPoints["DocumentTypeArchiveOfResolutions"] = "Beschlusssammlung";
		SellingChecklistDataPoints["FutureHomeOwnersFee"] = "Future Home Owners' Fee";
		SellingChecklistDataPoints["FutureHomeOwnersFeeTransferable"] = "Future Home Owners' Fee Transferable";
		SellingChecklistDataPoints["FutureHomeOwnersFeeNonTransferable"] = "Future Home Owners' Fee Non-Transferable";
		SellingChecklistDataPoints["FutureHomeOwnersFeeReserve"] = "Future Home Owners' Fee Reserve";
		SellingChecklistDataPoints["FutureHomeOwnersFeeStartDate"] = "Future Home Owners' Fee Start Date";
		return SellingChecklistDataPoints;
	}({});
	sellingDataPoints = [
		{
			title: "Investors Cashflow of Type Sales Package",
			resolve: (estate) => {
				return !!estate.investorCashflows?.find((ic) => ic.type === "SalesPackage");
			}
		},
		{
			title: "Post-Renovation Attributes",
			resolve: (estate) => {
				return !isNil(estate.postRenovationAttributes?.livingSpace) && !isNil(estate.postRenovationAttributes?.rooms);
			}
		},
		{
			title: "Adresse",
			resolve: (estate) => {
				return !isNil(estate.location?.street) && !isNil(estate.location?.houseNumber) && !isNil(estate.location?.latitude) && !isNil(estate.location?.longitude) && (!isNil(estate.location?.zipcode) || !isNil(estate.location?.city));
			}
		},
		{
			title: "Attributes - Baujahr",
			resolve: (estate) => {
				return !isNil(estate.attributes?.constructionYear);
			}
		},
		{
			title: "Attributes - Etage",
			resolve: (estate) => {
				return !isNil(estate.attributes?.floor);
			}
		},
		{
			title: "Total Maintenance Reserve",
			resolve: (estate) => {
				return !isNil(estate.price?.totalMaintenanceReserve);
			}
		},
		{
			title: "Estate Maintenance Reserve",
			resolve: (estate) => {
				return !isNil(estate.price?.estateMaintenanceReserve);
			}
		},
		{
			title: "Home Owners' Fee",
			resolve: (estate) => {
				return !isNil(estate.price?.houseGeld);
			}
		},
		{
			title: "Home Owners' Fee Transferable",
			resolve: (estate) => {
				return !isNil(estate.price?.houseGeldTransferable);
			}
		},
		{
			title: "Home Owners' Fee Non-Transferable",
			resolve: (estate) => {
				return !isNil(estate.price?.houseGeldNonTransferable);
			}
		},
		{
			title: "Home Owners' Fee Reserve",
			resolve: (estate) => {
				return !isNil(estate.price?.houseGeldReserve);
			}
		},
		{
			title: "Standortprofil PDF",
			resolve: (estate) => {
				return !!estate.documents?.some((doc) => doc?.documentType === "SellingExposeLocation");
			}
		},
		{
			title: "Media Tag - Floorplan",
			resolve: (estate) => {
				return !!estate.media?.some((md) => md.internalTags?.includes("floor-plan") && md.category === "PostRenovation" && md.tags?.includes("publish"));
			}
		},
		{
			title: "Media Tag - Living Room",
			resolve: (estate) => {
				return hasMediaFileVariantOrParentWithTag(estate.media, "expose-living-room");
			}
		},
		{
			title: "Media Tag - Kitchen",
			resolve: (estate) => {
				return hasMediaFileVariantOrParentWithTag(estate.media, "expose-kitchen");
			}
		},
		{
			title: "Media Tag - Bathroom",
			resolve: (estate) => {
				return hasMediaFileVariantOrParentWithTag(estate.media, "expose-bathroom");
			}
		},
		{
			title: "Media Tag - Room 1",
			resolve: (estate) => {
				return hasMediaFileVariantOrParentWithTag(estate.media, "expose-room-1");
			}
		},
		{
			title: "Media Tag - Room 2",
			resolve: (estate) => {
				return hasMediaFileVariantOrParentWithTag(estate.media, "expose-room-2");
			}
		},
		{
			title: "Media Tag - Room 3",
			resolve: (estate) => {
				return hasMediaFileVariantOrParentWithTag(estate.media, "expose-room-3");
			}
		},
		{
			title: "Template Expose - Living Room",
			resolve: (estate) => {
				return hasMediaFileVariantOrParentWithTag(estate.media, "template-expose-living-room");
			}
		},
		{
			title: "Template Expose - Kitchen",
			resolve: (estate) => {
				return hasMediaFileVariantOrParentWithTag(estate.media, "template-expose-kitchen");
			}
		},
		{
			title: "Template Expose - Bathroom",
			resolve: (estate) => {
				return hasMediaFileVariantOrParentWithTag(estate.media, "template-expose-bathroom");
			}
		},
		{
			title: "Template Expose - Room 1",
			resolve: (estate) => {
				return hasMediaFileVariantOrParentWithTag(estate.media, "template-expose-room-1");
			}
		},
		{
			title: "Template Expose - Room 2",
			resolve: (estate) => {
				return hasMediaFileVariantOrParentWithTag(estate.media, "template-expose-room-2");
			}
		},
		{
			title: "Template Expose - Room 3",
			resolve: (estate) => {
				return hasMediaFileVariantOrParentWithTag(estate.media, "template-expose-room-3");
			}
		},
		{
			title: "Beschlusssammlung",
			resolve: (estate) => {
				return !!estate?.documents?.find((doc) => {
					return doc?.documentInspection?.state === "Completed" && doc?.documentType === "ArchiveOfResolutions";
				});
			}
		},
		{
			title: "Future Home Owners' Fee",
			resolve: (estate) => {
				return !isNil(estate.price?.futureHouseGeld);
			}
		},
		{
			title: "Future Home Owners' Fee Transferable",
			resolve: (estate) => {
				return !isNil(estate.price?.futureHouseGeldTransferable);
			}
		},
		{
			title: "Future Home Owners' Fee Non-Transferable",
			resolve: (estate) => {
				return !isNil(estate.price?.futureHouseGeldNonTransferable);
			}
		},
		{
			title: "Future Home Owners' Fee Reserve",
			resolve: (estate) => {
				return !isNil(estate.price?.futureHouseGeldReserve);
			}
		},
		{
			title: "Future Home Owners' Fee Start Date",
			resolve: (estate) => {
				return !isNil(estate.price?.futureHouseGeldStartDate);
			}
		}
	];
	hasMediaFileVariantOrParentWithTag = (mediaFiles = [], tag) => {
		const mediaFile = mediaFiles.find((file) => file.tags?.includes(tag));
		return !isNil(mediaFile?.variants?.[0]?.path ?? mediaFile?.link);
	};
}));
//#endregion
//#region src/domains/selling/selling.request.ts
var init_selling_request = __esmMin((() => {}));
//#endregion
//#region src/domains/typesense/typesense.model.ts
var SearchableCollectionType, CollectionNames, TypesenseNoPermissionNeeded, typesenseCollectionToPermissionMap;
var init_typesense_model = __esmMin((() => {
	init_authz();
	SearchableCollectionType = /* @__PURE__ */ function(SearchableCollectionType) {
		SearchableCollectionType["estate"] = "estate";
		SearchableCollectionType["mfh"] = "mfh";
		SearchableCollectionType["recent_page_visit"] = "recent_page_visit";
		SearchableCollectionType["document"] = "document";
		SearchableCollectionType["invoice"] = "invoice";
		SearchableCollectionType["mfh_portfolio"] = "mfh_portfolio";
		return SearchableCollectionType;
	}({});
	CollectionNames = /* @__PURE__ */ function(CollectionNames) {
		CollectionNames["searchable"] = "searchable";
		return CollectionNames;
	}({});
	TypesenseNoPermissionNeeded = ["no-permission-needed"];
	typesenseCollectionToPermissionMap = {
		estate: [Permission.EstateEstateView],
		mfh: [Permission.MFHMFHView],
		recent_page_visit: TypesenseNoPermissionNeeded,
		document: [Permission.EstateDocumentView, Permission.MFHDocumentView],
		invoice: [Permission.FinanceInvoiceView],
		mfh_portfolio: TypesenseNoPermissionNeeded
	};
}));
//#endregion
//#region src/domains/typesense/analytics.ts
var VisitedPageType, VisitedPageDataSchema, RouteSchema, RecentlyVisitedPage;
var init_analytics = __esmMin((() => {
	init_lib();
	VisitedPageType = /* @__PURE__ */ function(VisitedPageType) {
		VisitedPageType["estate"] = "estate";
		VisitedPageType["mfh"] = "mfh";
		VisitedPageType["invoice"] = "invoice";
		VisitedPageType["general"] = "general";
		return VisitedPageType;
	}({});
	VisitedPageDataSchema = Type.Object({
		mfh: Type.Optional(Type.Object({
			mfhId: Type.Number(),
			condoUuid: Type.Optional(Type.String())
		})),
		estate: Type.Optional(Type.Object({
			estateId: Type.Number(),
			condoUuid: Type.Optional(Type.String())
		})),
		invoice: Type.Optional(Type.Object({ invoiceId: Type.Number() }))
	});
	RouteSchema = Type.Object({
		name: Type.String(),
		params: Type.Optional(Type.Record(Type.String(), Type.String())),
		query: Type.Optional(Type.Record(Type.String(), Type.Any()))
	});
	RecentlyVisitedPage = Type.Object({
		recentlyVisitedPageId: Type.Optional(Type.Number()),
		type: TEnum(VisitedPageType),
		route: RouteSchema,
		url: Type.String(),
		visitedMenus: Type.Array(Type.String()),
		data: Type.Optional(Type.Union([VisitedPageDataSchema, Type.Null()])),
		visitedAt: Type.Number()
	});
}));
//#endregion
//#region src/external/estarcore/index.ts
var parsedToRawPropName;
var init_estarcore = __esmMin((() => {
	parsedToRawPropName = {
		tenantNumber: "Mieternummer",
		tenantName: "Mietername",
		searchName: "Suchname",
		propertyId: "Liegenschaft",
		unitNumber: "Flächennummer",
		unitDescription: "Flächenbezeichnung",
		taxKey: "Steuerschlüssel",
		location: "Lage",
		plotNumber: "Grundstücksnummer",
		plotDescription: "Grundstücksbezeichnung",
		areaUsageType: "Flächennutzungsart",
		areaSubUsageType: "Flächenunternutzungsart",
		rentalContractNumber: "Mietvertragsnummer",
		rentalContractDescription: "Mietvertragsbezeichnung",
		contractType: "Vertragsart",
		contractStartDate: "Vertragsbeginn",
		contractEndDate: "Vertragsende",
		unitEndDate: "Flächenende",
		option: "Option",
		paymentCycle: "Vorauszahlungszyklus",
		areaInSquareMeters: "Fläche in qm",
		floor: "Geschossetage",
		parkingSpot: "Stellplatz",
		quantity: "Menge",
		netRent: "Miete Netto",
		annualNetRent: "Miete Netto jährlich",
		rentPerSquareMeter: "Miete Eur/qm",
		rentPerParkingSpot: "Miete Eur/Stellplatz",
		netServiceCharges: "NK Netto",
		serviceChargesPerSquareMeter: "NK Eur/qm",
		serviceChargesPerParkingSpot: "NK Eur/Stellplatz",
		vat: "MwSt",
		annualVat: "MwSt jährlich",
		vacancy: "Leerstand",
		depositType: "Art der Kaution",
		depositAmount: "Kautionsbetrag",
		depositCurrency: "Kautionswährung",
		depositBalance: "Kaution Stand",
		depositPayment: "Kaution Anzahlung",
		depositReceived: "Eingang Kaution",
		depositRefundDate: "Kaution Auszahlung am",
		depositText: "Kautionstext",
		contractExpirationDate: "Befristung bis (berechnet)",
		paymentCondition: "Zahlungskondition",
		paymentMethod: "Zahlungsart",
		paymentRhythm: "Zahlungsrhythmus",
		email: "Email",
		primaryEmail: "Haupt-Email",
		phone: "Telefon",
		mobile: "Mobil",
		primaryMobile: "Haupt-Mobile",
		street: "Strasse",
		postalCodeCity: "PLZ-Ort",
		iban: "IBAN",
		propertyDescription: "Liegenschaftsbeschreibung",
		salutation: "Anrede",
		specialAgreement: "Besondere Vereinbarung",
		noticePeriod: "Kündigungsfrist",
		terminationNoticeDate: "Kündigung vom",
		terminationDate: "Kündigung zum",
		terminationReason: "Kündigungsgrund",
		title: "Titel",
		name1: "Name1",
		name2: "Name2",
		name3: "Name3",
		fullLocation: "Flächenbezeichnung",
		floorLocation: "Lage",
		projectNumber: "Projekt-Nr.",
		projectDescription: "Bezeichnung Proj.",
		unitAbbreviation: "ME Kürzel",
		taxKeyDescription: "Bezeichnung St.-Schl.",
		collectiveBooking: "Sammelbuchung",
		socialInsuranceBooking: "SV-Buchung",
		netDate: "Nettodatum",
		openItemSettlementDate: "OP-Ausgleichsdatum",
		openItemRemainingAmount: "OP-Restbetrag",
		discount: "Skonto",
		writeOff: "Ausbuchung",
		writeOffReason: "Ausbuchungsgrund",
		tax: "Steuer",
		debit: "Soll",
		credit: "Haben",
		currency: "Währung",
		exchangeRate: "Kurs",
		openItemRemainingAmountCurrency: "OP-Restbetrag (Whrg.)",
		discountCurrency: "Skonto (Whrg.)",
		writeOffCurrency: "Ausbuchung (Whrg.)",
		taxCurrency: "Steuer (Whrg.)",
		debitCurrency: "Soll (Whrg.)",
		creditCurrency: "Haben (Whrg.)",
		balance: "Saldo",
		netBalance: "Saldo/Netto",
		balanceCurrency: "Saldo (Whrg.)",
		netBalanceCurrency: "Saldo/Netto (Whrg.)",
		recordedAt: "Erfasst am",
		recordedById: "Erfasst von (Id)",
		recordedBy: "Erfasst von"
	};
}));
//#endregion
//#region src/external/index.ts
var init_external = __esmMin((() => {
	init_estarcore();
}));
//#endregion
//#region src/domains/search-engine/mappers/searchable-estate.mapper.ts
var SearchableEstateMapper;
var init_searchable_estate_mapper = __esmMin((() => {
	init_typesense_model();
	SearchableEstateMapper = class SearchableEstateMapper {
		static toSearchEngineId(estateId) {
			return `estate-${estateId}`;
		}
		static toSearchEngineEntity(row) {
			return {
				id: SearchableEstateMapper.toSearchEngineId(row.estateId),
				collectionType: "estate",
				estate: {
					estateId: String(row.estateId),
					condoUuid: row.condoUuid,
					title: row.title,
					address: addressFormatter(row.location)
				}
			};
		}
		static toSearchEngineEntities(rows) {
			return rows.map((row) => SearchableEstateMapper.toSearchEngineEntity(row));
		}
		static hydrateFromDb(baseEstate, fullEstate) {
			return {
				...baseEstate,
				attributes: fullEstate.attributes,
				sourcing: fullEstate.sourcing ? {
					processId: fullEstate.sourcing.processId,
					processState: fullEstate.sourcing.processState?.state,
					createdAt: fullEstate.sourcing.createdAt ? new Date(fullEstate.sourcing.createdAt).getTime() : void 0,
					finishedAt: fullEstate.sourcing.finishedAt ? new Date(fullEstate.sourcing.finishedAt).getTime() : void 0
				} : void 0,
				purchasing: fullEstate.purchasing ? {
					processId: fullEstate.purchasing.processId,
					processState: fullEstate.purchasing.processState?.state,
					createdAt: fullEstate.purchasing.createdAt ? new Date(fullEstate.purchasing.createdAt).getTime() : void 0,
					finishedAt: fullEstate.purchasing.finishedAt ? new Date(fullEstate.purchasing.finishedAt).getTime() : void 0
				} : void 0,
				renovation: fullEstate.renovation ? {
					processId: fullEstate.renovation.processId,
					processState: fullEstate.renovation.processState?.state,
					createdAt: fullEstate.renovation.createdAt ? new Date(fullEstate.renovation.createdAt).getTime() : void 0,
					finishedAt: fullEstate.renovation.finishedAt ? new Date(fullEstate.renovation.finishedAt).getTime() : void 0
				} : void 0,
				rentableUnitProcess: fullEstate.rentableUnitProcess ? {
					processId: fullEstate.rentableUnitProcess.processId,
					processState: fullEstate.rentableUnitProcess.processState?.state,
					createdAt: fullEstate.rentableUnitProcess.createdAt ? new Date(fullEstate.rentableUnitProcess.createdAt).getTime() : void 0,
					finishedAt: fullEstate.rentableUnitProcess.finishedAt ? new Date(fullEstate.rentableUnitProcess.finishedAt).getTime() : void 0
				} : void 0,
				selling: fullEstate.selling ? {
					processId: fullEstate.selling.processId,
					processState: fullEstate.selling.processState?.state,
					createdAt: fullEstate.selling.createdAt ? new Date(fullEstate.selling.createdAt).getTime() : void 0,
					finishedAt: fullEstate.selling.finishedAt ? new Date(fullEstate.selling.finishedAt).getTime() : void 0
				} : void 0
			};
		}
	};
}));
//#endregion
//#region src/domains/search-engine/mappers/searchable-mfh.mapper.ts
var SearchableMfhMapper;
var init_searchable_mfh_mapper = __esmMin((() => {
	init_typesense_model();
	SearchableMfhMapper = class SearchableMfhMapper {
		static toSearchEngineId(mfhId) {
			return `mfh-${mfhId}`;
		}
		static toSearchEngineEntity(row) {
			return {
				id: SearchableMfhMapper.toSearchEngineId(row.mfhId),
				collectionType: "mfh",
				mfh: {
					mfhId: String(row.mfhId),
					condoUuid: row.condoUuid,
					title: row.title,
					address: addressFormatter(row.candidateLocation),
					candidateLocation: row.candidateLocation
				}
			};
		}
		static toSearchEngineEntities(rows) {
			return rows.map((row) => SearchableMfhMapper.toSearchEngineEntity(row));
		}
		static hydrateFromDb(baseMfh, fullMfh) {
			return {
				...baseMfh,
				sourcing: fullMfh.sourcing ? {
					processId: fullMfh.sourcing.processId,
					processState: fullMfh.sourcing.processState,
					createdAt: fullMfh.sourcing.createdAt ? new Date(fullMfh.sourcing.createdAt).getTime() : void 0,
					finishedAt: fullMfh.sourcing.finishedAt ? new Date(fullMfh.sourcing.finishedAt).getTime() : void 0
				} : void 0,
				subsidyFinancing: fullMfh.subsidyFinancing ? {
					processId: fullMfh.subsidyFinancing.processId,
					processState: fullMfh.subsidyFinancing.processState,
					createdAt: fullMfh.subsidyFinancing.createdAt ? new Date(fullMfh.subsidyFinancing.createdAt).getTime() : void 0,
					finishedAt: fullMfh.subsidyFinancing.finishedAt ? new Date(fullMfh.subsidyFinancing.finishedAt).getTime() : void 0
				} : void 0,
				estateManagement: fullMfh.estateManagement ? {
					processId: fullMfh.estateManagement.processId,
					processState: fullMfh.estateManagement.processState,
					createdAt: fullMfh.estateManagement.createdAt ? new Date(fullMfh.estateManagement.createdAt).getTime() : void 0,
					finishedAt: fullMfh.estateManagement.finishedAt ? new Date(fullMfh.estateManagement.finishedAt).getTime() : void 0
				} : void 0
			};
		}
	};
}));
//#endregion
//#region src/domains/search-engine/mappers/mfh-portfolio.mapper.ts
var MfhPortfolioMapper;
var init_mfh_portfolio_mapper = __esmMin((() => {
	init_typesense_model();
	MfhPortfolioMapper = class MfhPortfolioMapper {
		static toSearchEngineEntity(rows) {
			return rows.map((row) => {
				return {
					id: MfhPortfolioMapper.toSearchEngineId(row.mfhPortfolioId),
					collectionType: "mfh_portfolio",
					requiredPermission: typesenseCollectionToPermissionMap.mfh_portfolio,
					mfhPortfolio: {
						mfhPortfolioId: String(row.mfhPortfolioId),
						condoUuid: row.condoUuid,
						name: row.name,
						createdAt: dayjs(row.createdAt).unix()
					}
				};
			});
		}
		static toSearchEngineId(mfhPortfolioId) {
			return `mfh_portfolio-${mfhPortfolioId}`;
		}
	};
}));
//#endregion
//#region src/domains/search-engine/mappers/document.mapper.ts
var DocumentMapper;
var init_document_mapper = __esmMin((() => {
	init_typesense_model();
	DocumentMapper = class DocumentMapper {
		static toSearchEngineEntity(row) {
			return {
				id: DocumentMapper.toSearchEngineId(row.documentId),
				collectionType: "document",
				document: {
					documentId: row.documentId,
					uuid: row.uuid || "",
					documentCategory: row.documentCategory ? toTitleCase(row.documentCategory) : "",
					documentType: row.documentType ? toTitleCase(row.documentType) : "",
					filename: row.filename || "",
					mimeType: row.mimeType || "",
					path: row.path || "",
					link: row.link || "",
					estate: {
						estateId: row.documentRelation?.[0]?.estate?.estateId,
						condoUuid: row.documentRelation?.[0]?.estate?.condoUuid || ""
					},
					mfh: {
						mfhId: row.documentRelation?.[0]?.mfh?.mfhId,
						condoUuid: row.documentRelation?.[0]?.mfh?.condoUuid || ""
					}
				}
			};
		}
		static toSearchEngineEntities(rows) {
			return rows.map((row) => DocumentMapper.toSearchEngineEntity(row));
		}
		static toSearchEngineId(documentId) {
			return `document-${documentId}`;
		}
	};
}));
//#endregion
//#region src/domains/search-engine/mappers/invoice.mapper.ts
var InvoiceMapper;
var init_invoice_mapper = __esmMin((() => {
	init_typesense_model();
	InvoiceMapper = class InvoiceMapper {
		static toSearchEngineId(invoiceId) {
			return `invoice-${invoiceId}`;
		}
		static toSearchEngineEntity(row) {
			return {
				id: InvoiceMapper.toSearchEngineId(row.invoiceId),
				collectionType: "invoice",
				invoice: {
					invoiceId: String(row.invoiceId),
					invoiceNumber: String(row.invoiceNumber),
					state: toTitleCase(row.state),
					invoiceDate: row.invoiceDate ? dayjs(row.invoiceDate).unix() : void 0,
					creditor: row.creditorAccounting?.company?.name ?? row.creditorAccounting?.contact?.fullname
				}
			};
		}
		static toSearchEngineEntities(rows) {
			return rows.map((row) => InvoiceMapper.toSearchEngineEntity(row));
		}
		static hydrateFromDb(baseInvoice, fullInvoice) {
			return {
				...baseInvoice,
				creditor: fullInvoice.creditorAccounting?.company?.name ?? fullInvoice.creditorAccounting?.contact?.fullname,
				invoiceDate: fullInvoice.invoiceDate ? dayjs(fullInvoice.invoiceDate).unix() : void 0,
				invoiceNumber: String(fullInvoice.invoiceNumber)
			};
		}
	};
}));
//#endregion
//#region src/domains/search-engine/index.ts
var init_search_engine = __esmMin((() => {
	init_searchable_estate_mapper();
	init_searchable_mfh_mapper();
	init_mfh_portfolio_mapper();
	init_document_mapper();
	init_invoice_mapper();
}));
//#endregion
//#region src/index.ts
var init_src = __esmMin((() => {
	init_lib();
	init_base();
	init_pagination();
	init_cashflow_prediction();
	init_ccs_routes();
	init_document_export();
	init_document_strategy();
	init_document_inspection();
	init_external_data();
	init_finance();
	init_form_question();
	init_leads_management();
	init_legacy_events();
	init_mixed();
	init_reconciler_rule_factory();
	init_renovation();
	init_renting_listing_class();
	init_renting_listing_model();
	init_renting_model();
	init_renting();
	init_rentable_unit_class();
	init_requests$1();
	init_selling_model();
	init_selling_region_model();
	init_klippa();
	init_payment_notice_summary();
	init_payment_order();
	init_sales_portal();
	init_raas();
	init_condo_living();
	init_form_model();
	init_location_profile();
	init_purchasing();
	init_portfolio_analyzer();
	init_selling_helpers();
	init_selling_request();
	init_typesense_model();
	init_analytics();
	init_cross_cutting();
	init_external();
	init_search_engine();
}));
//#endregion
init_src();
export { ADDENDUM_ESTABLISHED_STATUS, ALLOWED_DOCUMENT_CLASSIFIER_PARENT_FOLDER_NAMES, ALLOWED_INVOICE_TYPES_FOR_UI, ALLOWED_INVOICE_VAT_CLASSES_FOR_UI, ALL_BOOKING_KEYS, ALL_DEFECT_PROPS, ALL_TEASER_AI_KEYS, AUDIT_LOG_DEFAULT_IGNORABLE_KEYS, AUTOMATIC_SUBSIDY_DEFAULT_EQUITY_PERCENT, AUTOMATIC_SUBSIDY_DISCOUNT_PERIOD_IN_YEARS, AcademicRank, AcceptanceType, AccountingPaymentTerm, AccountingPaymentTermTranslation, ActiveRentAmountsSchema, Addendum, AddendumEvent, AddendumReason, AddendumStatus, AddendumStatusTranslation, AdjoiningBuilding, AgentFeedbackModule, AgentFeedbackRating, AgentFeedbackStatus, AlignmentBalcony, AllKeys, AnnualServiceChargeStatement, AnnualServiceChargeStatementSchema, AnnualServiceChargeStatementStatementsSchema, AnnualServiceChargeStatementStatus, AnnualServiceChargeStatementStatusEnumSchema, ApartmentSize, ApartmentType, ApplicationError, ApprovalVerdictBodySchema, ApprovalVerdictParamsSchema, AssetLedger, AssetLedgerEntryType, AssetPartnerPlacementResponseStatus, AssetRentRollSchema, AttributesDTOSchema, AuthorizationMisconfiguredError, AuthorizationRoleBindingsMissingRequiredPermissionsError, AuthzPermissionResolutionError, AuthzPermissionsMissingError, BUY_BOX_CRITERION_DIRECTION, B_CITIES, BafaBegEmCalculationBreakdownSchema, BafaBegEmResidentialUnitCostCeilingBandSchema, BafaBegEmSubsidyConfigSchema, BafaBegEmSubsidyVariantSchema, BafaBegEmTechnicalRequirementsSchema, BafaBegEmVariantAssessmentSchema, BalanceInfoSchema, BalanceRecord, BalconyState, BankAccount, BankAccountLedger, BankAccountSecretSchema, BankAccountType, BankFeeRuleAmounts, BankJobSchema, BankOwnerAccountAction, BankOwnerAccountEvents, BankOwnerAccountSchema, BankOwnerAccountStates, BankTransaction, BankTransactionCategory, BankTransactionCategoryToTypeMapping, BankTransactionCategoryType, BankTransactionCategoryTypeTranslations, BankTransactionReferenceConflictingInfosError, BankTransactionSchema, BankTransactionSource, BankTransactionState, BankTransactionWarning, BarcodeTypeEnum, BaseAddendumSchema, BaseAnnualServiceChargeStatementSchema, BaseBankTransactionSchema, BaseClassAttributes, BaseCompanySchema, BaseContractSchema, BaseControllingViewColumn, BaseCreatedDeletedAttributesSchema, BaseDocumentApprovalSchema, BaseDocumentSchema, BaseDocumentSignatureSchema, BaseEntity, BaseEntityAttributesSchema, BaseExternalEnvelopeAccessSchema, BaseGeneralLedger, BaseHoaFeeSchema, BaseInvestorLedgerStatementSchema, BaseInvestorYearlyPayoutSchema, BaseInvoiceSchema, BaseMFHRenovationProjectBudgetSchema, BaseMFHRenovationProjectCostBreakdownSchema, BaseMFHRenovationProjectLotSchema, BaseMFHRenovationProjectPlanningModuleSchema, BaseMFHRenovationProjectPositionSchema, BaseMFHRenovationProjectSchema, BaseMfhConstructionPlanApprovalConfigSchema, BaseMfhConstructionPlanApprovalSchema, BaseMfhConstructionPlanSchema, BaseMfhConstructionPlanVersionSchema, BasePaymentEventSchema, BasePositionCostAllocationSchema, BaseProcessSchema, BaseRenovationScenarioConfigSchema, BaseRenovationScenarioSchema, BaseRentRollVersionSchema, BaseRentSchema, BaseRentTenancySchema, BaseRentableUnitSchema, BaseRentalContractSchema, BaseRentalContractUnitSchema, BaseRentingProcessExtraPropsSchema, BaseRentingProcessSchema, BaseReviewProcessSchema, BaseSignOffCommentSchema, BaseSignOffDocumentSchema, BaseSignOffEnvelopeSchema, BaseSignOffTemplateDocumentSchema, BaseSignOffTemplateSchema, BaseTenderingProcessOfferSchema, BaseTenderingProcessSchema, BaseTenderingProcessTendererSchema, BatchActions, BookingEvent, BookingKey, BudgetOrigin, BuildingEnergyRating, BuildingLocationType, BuildingLocationTypeDescription, BulkCreateMfhConstructionPlansBodySchema, BulkUserDataSetRecordActionFormActionEnum, BulkUserDataSetRecordResultActionEnum, BulkUserDataSetRecordResultResultEnum, BusinessLine, BuyBoxMatrixSchema, BuyPriceDTOSchema, CALC_KEY_PREFIX_TO_SHEET, CAPEX_BUDGET_BUCKET_ORDER, CCSRouteMap, CDCEventOp, CDCSchemaFetchFailedError, CF_ENGINE_SHEET_KEY, COMPUTED_MFH_ATTRS, CONFIG_RESOLUTION_ORDER, CalculationError, CalendarResponseStatus, CalendarStages, CalendarStagesUnsorted, CalendarType, CandidateAssetPartnerInCandidatePortfolioError, CashflowMilestone, CashflowPredictionDayRecordType, CashflowPredictionGroup, CashflowRequiredEntityMissingError, CatalogueItemType, CellarHeating, CollectionNames, CommercialApartmentTypes, CommitmentRateMode, CommonRoomTranslations, CommonRoomType, CompanyDepartment, CompanyEmploymentRelationSchema, CompanyFunction, CompanyOrContactRelation, CompanyRelationSchema, CompanyRole, CompanySchema, CompanySource, CompanyType, CompareMfhConstructionPlanVersionsBodySchema, CompareMfhConstructionPlanVersionsParamsSchema, CompressedTripleKind, ComputeMfhLocationRouteBodySchema, ComputeMfhLocationRouteParamsSchema, Condition, CondoEntity, CondoEventSource, CondoEvents, CondoFileSchema, CondoLivingError, CondoLivingUserState, CondoPaymentCode, CondoPaymentReference, CondoProcess, CondoSalesCondition, CondoSalesConditionEnumSchema, CondoUuidRegex, ConfigRecord, ConfigRecordType, ConfigSection, ConfigSerializerVersion, ConflictError, ConsentTextContent, ConstructionCase, ConstructionCraft, ConstructionPlan, ConstructionPlanClassification, ConstructionPlanDefaultNames, ConstructionPlanDocumentSchema, ConstructionPlanDurationsEnum, ConstructionPlanEvents, ConstructionPlanState, ConstructionPlanStructureType, ConstructionPlanTemplate, ConstructionPlanType, ConstructionPosition, ConstructionProgressStatus, ContactPersonSchema, ContactRelationSchema, ContactSchema, ContactSource, ContactType, ContentTooLargeError, ContractStatus, ContractorCompanyType, CopyMfhEnergyEfficiencyScenarioBodySchema, CopyMfhEnergyEfficiencyScenarioParamsSchema, CoreCashflowMilestones, CorporateForm, CorrespondenceAddressSchema, CostAmendmentOperationSchema, CostSplitItemSchema, CostSplitSchema, CostTypes, CostTypesSchema, CreateDocumentAnnotationBodySchema, CreateDocumentAnnotationParamsSchema, CreateMFHRenovationProjectPositionSchema, CreateMfhConstructionPlanBodySchema, CreateMfhConstructionPlanVersionBodySchema, CreateMfhEnergyEfficiencyScenarioBodySchema, CreateMfhEnergyEfficiencyScenarioParamsSchema, CreateMfhMeasureComponentCatalogueItemBodySchema, CreateUserDataSetFormTypeEnum, CreditLineICTDirection, Currency, CurrencySchema, CustomizedExposeExcludableDocumentTypes, D2GCalcEngineGlobalCalculationError, D2GCalcEngineUnsupportedVersionError, D2GCalculationNodeError, D2GCalculationServiceError, D2GDatapointWithoutConfigError, D2GFeatureSet, D2GMissingMappingsForVersionError, D2GMissingVersionError, D2GRentIndexCityEastWest, D2GRentIndexLookupAreaQuality, D2GSheetDatapointNotMappableError, D2GSheetMappingMalformedError, D2GSheetMissingDatapointError, D2GSheetMissingDatapointsError, D2GVersionDisabledError, D2G_SHEET_MAPPINGS, D2G_SHEET_MAPPING_LOOKUP, DCF_LEADING_CELL_COUNT, DCF_MAX_YEAR_COLUMNS, DDAnswerSuggestionCitationSchema, DDAnswerSuggestionConfidence, DDAnswerSuggestionStatus, DDFormType, DDPhase, DDPhaseTranslation, DDRisks, DDStage, DDStageTranslation, DDStatus, DDStatusTranslation, DDVersion, DDv2ActionPointParty, DDv2ActionPointPartyTranslation, DDv2ActionPointSchema, DDv2ActionPointTrack, DDv2ActionPointTrackTranslation, DDv2AiSourceSchema, DDv2AnswerDocumentSchema, DDv2AnswerStatus, DDv2AnswerStatusTranslation, DDv2BankabilityRelevance, DDv2BankabilityRelevanceTranslation, DDv2Category, DDv2CategoryTranslation, DDv2ChecklistStatus, DDv2ChecklistStatusTranslation, DDv2DocumentCategory, DDv2DocumentCategoryTranslation, DDv2Priority, DDv2PriorityTranslation, DDv2Risk, DDv2RiskTranslation, DDv2Subcategory, DDv2SubcategoryTranslation, DEFAULT_BUDGET_BUCKET_BY_COMPONENT, DEFAULT_KFW_261_APPLICABLE_OUTCOME_COMBINATION_COUNT, DEFAULT_LOCATION_ANALYSIS_RADIUS_METERS, DEFAULT_MEASURE_COMPONENTS, DEFAULT_MFH_ENERGY_EFFICIENCY_SUBSIDY_INPUTS, DEFAULT_REVIEWERS_NUMBER, DEFAULT_ROOF_FACTOR, DEFAULT_TEASER_SLIDES, DEFAULT_WINDOW_TO_FACADE_RATIO, DEFECT_COMPANY_PROPS, DEFECT_USER_PROPS, DETAILED_COMPANY_RELATIONS, DISABLED_MFH_IC_STATUS, DISCOUNTABLE_INPUTS, DISCOUNT_PERIOD_IN_YEARS, DebtAllocation, DebtAllocationSchema, Debtors, DebtorsPayingVAT, DefaultInvestorDocuments, DefaultNotificationRuleTemplate, DefectDescriptionType, DefectEvents, DefectFixVerifiers, DefectMainItem, DefectStatus, DefectSubItem, DefectTitleType, DefectType, DegreeDayItemSchema, DeleteDocumentAnnotationParamsSchema, DeleteMfhEnergyEfficiencyScenarioParamsSchema, DeleteMfhMeasureComponentCatalogueItemParamsSchema, DepositRetentionDataSchema, DepositRetentionReason, DirectDebitReasonCodes, DirectGrantBenefitSchema, DirectGrantComponentCode, DirectGrantComponentSchema, DiscovererAttributesDTOSchema, DiscovererEstateProviders, DiscovererEstateSchema, DistributionKeyItemSchema, DistributionType, DocumentAnnotationCoreSchema, DocumentAnnotationTransferItemSchema, DocumentApprovalStatus, DocumentApprovalStatusTranslation, DocumentCategoriesEstate, DocumentCategoriesMfh, DocumentCategory, DocumentCategorySchema, DocumentClassifierPayloadStatus, DocumentClassifierSource, DocumentCopyError, DocumentExportType, DocumentGenerationFailedError, DocumentGenerationInvalidParamsError, DocumentGenerationRequiredKeysMissingError, DocumentInspection, DocumentInspectionState, DocumentMapper, DocumentPDFTemplates, DocumentProcessEntity, DocumentProcessStatus, DocumentRequestStatus, DocumentSchema, DocumentSignatureStatus, DocumentSignatureStatusTranslation, DocumentSource, DocumentStrategy, DocumentStrategySuperFactory, DocumentType, DocumentTypeRentArrearRelated, DocumentTypeSchema, DocumentTypesAvailableForDocumentGenerationByPreview, DocumentUploadStatus, DocumentXLSTemplates, DocumentsForPreparedRenovationState, DocumentsOfMfhEstateForPreparedRenovationState, DocumentsOwnerPropertyManagement, DocumentsWithAllowedAnswerGroupAddition, DuplicateInvoiceError, DuplicationCategory, DurableJobSchema, DurableJobStatus, E2EScenarioName, E2EScenarioSanityCheckFailedError, E2EScenarioScenarioFailedError, EInvoiceBusinessReferencesSchema, EInvoiceItemSchema, EInvoiceMetadataExtensionsSchema, EInvoiceMetadataSchema, EInvoicePartyFromSchema, EInvoicePartyToSchema, EInvoicePayeeFinancialAccountSchema, EInvoicePaymentInformationSchema, EInvoicePaymentMeansSchema, EInvoiceRawDataSchema, EInvoiceSchema, EInvoiceTaxBreakdownSchema, ESTARCORE_DEBITOR_ACCOUNT_RANGE, ESTARCORE_KREDITOR_ACCOUNT_RANGE, ESTATE_PROPS_REQUIRING_CASHFLOW_RECALCULATION_AND_EXPOSE_REGENERATION_ON_CHANGE, ESTATE_PROPS_REQUIRING_FUTURE_HOUSE_GELD_PROCESSING, EXPORTABLE_INVOICE_FETCH_TYPES, EXPORTABLE_INVOICE_STATES, EXTERNAL_APP_EXCLUDED_INVOICE_STATES, EbicsOrder, EbicsOrderStatus, ElementRenovationStage, ElementRenovationStagesList, ElementTypeName, EligibleEstatePurchasingStates, EligibleInspectionDocumentTypes, EligibleMfhPortfolioPurchasingStatesForAddingAssets, EligibleMfhSourcingStates, EmploymentContractType, EnergyCertificateCreationDate, EnergyConsumptionCategory, EnergySource, EnrichableEvents, EntityIdSchema, EntityNotFoundError, EntityTableName, EntityType, EnvironmentName, ErrorCode, EstarCoreEstateSchema, EstarcoreImportFailedError, EstateCategory, EstateChannelName, EstateChannelType, EstateDTOSchema, EstateElementType, EstateInspectionQuestions, EstateLeadType, EstateManagementChecklistItems, EstateManagementEvents, EstateManagementStates, EstateMeterType, EstateRentRollSchema, EstateSource, EstateType, Euribor, EventV2PayloadType, ExclusiveOrHybridSalesPackageUpdatableStates, ExecutedInteriorQualities, ExitType, ExitTypeTranslation, ExpandOptsTooDeepError, ExpandOptsTooManyNestedRelationsError, ExpandSchema, ExpenseOnlyMilestones, ExportableDocumentInspectionsTypeMap, ExposeMediaTags, ExposeMediaTagsFallbackTemplates, ExternalBankAccountLedger, ExternalContactTypes, ExternalDDContactTypes, ExternalDataSource, ExternalDataTypes, ExternalIdType, ExternalLinkDTOSchema, ExternalLinkStatus, ExternalLinkType, ExternalMfhInPipelineSourcingStates, ExternalRequiredResourceMissingError, ExternalServiceFailedError, ExternalServiceSchemaFailedError, FALLBACK_BIC, FRIIncreaseAmountType, FeeType, FileCategory, FilterType, FilterableEventType, FinalPartialCheckInvoicesStatesList, FinancingPortfolio, FindMfhConstructionPlanListOrderBySchema, FindMfhConstructionPlansQuerySchema, FindMfhEnergyEfficiencyScenariosParamsSchema, FindMfhEnergyEfficiencyScenariosQuerySchema, FkgMunichCalculationBreakdownSchema, FkgMunichEligibleCostSource, FkgMunichModule, FkgMunichModuleAssessmentSchema, FkgMunichSubsidyConfigSchema, FkgMunichSubsidyVariantSchema, FloorLocation, Flooring, FormQuestion, FormQuestionFactory, FormQuestionGuard, FormQuestionType, FormSchema, FormSchemaTranslation, FormStatus, FormType, FreeFromCategory, FriIncreaseAmountTypeEnumSchema, GeneralLedger, GeneralLedgerType, GenerateMfhLocationAnalysisParamsSchema, GenerateMfhLocationAnalysisResultSchema, GeneratedDocumentTypesMapping, GenericEvents, GermanyStateCode, GetApprovalConfigParamsSchema, GetFieldSubtypeTypeEnum, GetFieldTypeEnum, GetMfhConstructionPlanParamsSchema, GetMfhConstructionPlanQuerySchema, GetMfhEnergyEfficiencyScenarioParamsSchema, GetMfhEnergyEfficiencyScenarioQuerySchema, GoogleSignedUrlConfigActions, GoogleSignedUrlConfigVersions, HEATING_TYPE_TO_SOURCE, HeatingCostItemCostType, HeatingCostItemCostTypeSchema, HeatingCostItemSchema, HeatingCostItemType, HeatingCostItemTypeSchema, HeatingCostMethod, HeatingCostMethodSchema, HeatingCostsDataSchema, HeatingSource, HeatingType, HoaFee, HouseholdCostItemSchema, IBANLookupFailedError, IBaseSEPAMandateSchema, IC_CHARTS_SHEET_KEY, IC_TEASER_CUSTOM_LOCATION_TYPE, IC_TEASER_DEFAULT_HIGHLIGHTED_LOCATIONS_PER_CATEGORY, IC_TEASER_EXECUTIVE_SUMMARY_ADDITIONAL_BOXES_MAX, IC_TEASER_EXECUTIVE_SUMMARY_AI_KEYS, IC_TEASER_EXECUTIVE_SUMMARY_CARD_TITLE_DEFAULTS, IC_TEASER_EXECUTIVE_SUMMARY_CARD_TITLE_KEYS, IC_TEASER_FINANCING_TABLE_SECTIONS, IC_TEASER_IMPRESSIONS_MAX, IC_TEASER_LOCATION_RESTRICTIONS_NOTE_DEFAULT, IC_TEASER_LOCATION_RESTRICTION_DEFINITIONS, IC_TEASER_MILESTONE_PROGRESS_STATUSES, IC_TEASER_MILESTONE_REPORT_GROUPS, IC_TEASER_MILESTONE_STATUSES, IC_TEASER_NUMBER_LOCALE, IC_TEASER_PRESENTATION_PATHS, IC_TEASER_PROJECT_TIMELINE_GATES, IC_TEASER_RENT_COMPARABLES_MAX, IC_TEASER_SLIDE_AI_KEYS, IC_TEASER_SLIDE_LIVE_SOURCE_SYNC_ENABLED, IC_TEASER_SLIDE_SOURCE_FIELDS, IC_TEASER_SLIDE_SUBTITLE_AI_KEY, IC_TEASER_SLIDE_SUBTITLE_AI_KEYS, IC_TEASER_SLIDE_SUBTITLE_EDITABLE, IC_TEASER_SLIDE_TITLE_AI_KEYS, IC_TEASER_TRANSFORMATION_CARD_DEFAULT_TITLES, IC_TEASER_TRANSFORMATION_CARD_KEYS, INVOICE_SUBSCRIPTION_SAME_FIELDS, ISEPAMandateSchema, IfbModernisationEfficiencyHouseStageConfigSchema, IfbModernisationFinalEnergyStageConfigSchema, IfbModernisationStage, IfbModernisationStageAssessmentSchema, IfbModernisationStageConfigSchema, IfbModernisationStageCriterion, IfbModernisierungACalculationBreakdownSchema, IfbModernisierungASubsidyConfigSchema, IfbModernisierungASubsidyVariantSchema, InfasVariableMapping, InspectionCategory, InspectionNotCompletedError, InspectionState, InterestCalculationBasis, InterestCalculationMode, InterestRateAdvantageBenefitSchema, InterestRateMode, IntergroupLoanAccount, InteriorQuality, InternalContactTag, InternalTag, InvalidEventError, InvalidParamsError, InvalidRuleError, InvalidStateError, InvalidStateTransitionError, InvariantError, InvestmentBasedControllingViewColumn, InvestmentCase, InvestmentCaseEvents, InvestmentCaseNotApprovedError, InvestmentCaseOriginFeature, InvestmentCasePickingReason, InvestmentCaseState, InvestmentCaseType, InvestmentRiskProfile, InvestmentStrategy, InvestorCashflow, InvestorCashflowType, InvestorInfo, InvestorLedger, InvestorLedgerStatement, InvestorLedgerStatementBalanceValuesSchema, InvestorLedgerStatementCashflowValuesSchema, InvestorLedgerStatementIncomeValuesSchema, InvestorLedgerStatementSchema, InvestorPortalDocuments, InvestorShareBreakdownLabels, InvestorShareOperationEnumKey, InvestorShareOperationEnumSchema, InvestorShareOperationNote, InvestorShareOperator, InvestorYearlyPayout, InvestorYearlyPayoutRentPartialSchema, InvestorYearlyPayoutSchema, InvestorYearlyPayoutStatus, InvestorYearlyPayoutStatusSchema, Invoice, InvoiceEvents, InvoiceFetchType, InvoiceMapper, InvoiceSchema, InvoiceSource, InvoiceSourceSchema, InvoiceSplitToleranceAmount, InvoiceStates, InvoiceStatesSchema, InvoiceType, InvoiceTypeSchema, InvoiceVATClass, InvoiceVATClassLabel, InvoiceVATClassValue, InvoicesBasedControllingViewColumn, JobMetaStatus, Kfw261CalculationBreakdownSchema, Kfw261SubsidyConfigSchema, Kfw261SubsidyVariantSchema, Kfw359CalculationBreakdownSchema, Kfw359SubsidyConfigSchema, Kfw359SubsidyVariantSchema, Kfw359VariantAssessmentSchema, Kfw459CalculationBreakdownSchema, Kfw459ResidentialUnitCostCeilingBandSchema, Kfw459SubsidyConfigSchema, Kfw459SubsidyVariantSchema, LATEST_MFH_INVESTMENT_CASE_CALC_ENGINE_KEYS, LOCATION_ANALYSIS_CATEGORY_KEYS, LOCATION_ANALYSIS_REVIEW_NOTICE, LeadImpression, LedgerAccountCodeLabel, LedgerAccountingCheck, LedgerAccountingFix, LedgerEntry, LedgerEntryAccountCode, LedgerEntryDrawdownType, LedgerEntryGroup, LedgerEntryGroupType, LedgerEntryPaymentType, LedgerEntryType, LedgerEventType, LedgerFactory, LedgerPropertyManagementType, ListMfhConstructionPlanComparisonReportsParamsSchema, ListMfhConstructionPlanComparisonReportsQuerySchema, ListingType, LoanAccount, LoanAccountFactory, LoanAccountState, LoanAccountType, LoanAllocationStructureType, LoanDrawdown, LoanDrawdownStatus, LoanDrawdownType, LoanLedger, LoanOffer, LoanOfferStatus, LoanOfferType, LoanRepaymentType, LoanWithRepaymentGrantBenefitSchema, LocationAnalysisAccessibilityCategorySchema, LocationAnalysisAccessibilityLocationSchema, LocationAnalysisAccessibilitySchema, LocationAnalysisCategorySchema, LocationAnalysisContextSchema, LocationAnalysisCoordinatesSchema, LocationAnalysisFailedAssessmentSchema, LocationAnalysisGeneratedAssessmentSchema, LocationAnalysisResponseSchema, LocationAnalysisRouteSchema, LocationAnalysisRoutingSchema, LocationAnalysisSourceSchema, LocationAnalysisSubjectSchema, LocationAssessmentBlockSchema, LocationAssessmentChipSchema, LocationDTOSchema, LocationMicroAssessmentBlockSchema, LocationNarrativeSchema, LocationRating, LocationTeir, LocationThreshold, LookerNoEmbedUrlGeneratedError, MAPPED_CODE_TO_STATE, MAX_LOCATION_ANALYSIS_RADIUS_METERS, METROPOLITAN_AREA_ZIP_CODES, MFHCalendarType, MFHD2GCashTrap, MFHD2GPromoteType, MFHD2GReLetScenario, MFHD2GRentIndexSelection, MFHD2GSettingBAFA, MFHD2GSettingBegEmSubsidies, MFHD2GSettingBegEmSubsidiesI18n, MFHD2GSettingCapex, MFHD2GSettingChurn, MFHD2GSettingEKDrawFirst, MFHD2GSettingEKDrawFirstExt, MFHD2GSettingExitApproach, MFHD2GSettingExpansion, MFHD2GSettingFinancing, MFHD2GSettingGradualSale, MFHD2GSettingIFBStandard, MFHD2GSettingIRRRange, MFHD2GSettingIRRType, MFHD2GSettingKfWStandard, MFHD2GSettingLTV, MFHD2GSettingMonumentProtection, MFHD2GSettingNetGross, MFHD2GSettingRentIncrease, MFHD2GSettingRentIncreaseAnnualOnly, MFHD2GSettingRentIncreaseDependentOnDataQuality, MFHD2GSettingRentRoll, MFHD2GSettingScenario, MFHD2GSettingVAT, MFHD2GStrategicVacancy, MFHD2GTaxEngineType, MFHDocumentTypes, MFHElementSheetImport, MFHElementType, MFHElementTypeTranslation, MFHErvBreakdownStatus, MFHErvConfigValidationCode, MFHErvExclusionReason, MFHEstateManagementState, MFHEvents, MFHExternalUnit, MFHExternalUnitSchema, MFHExternalUnitStatus, MFHExternalUnitStatusTranslation, MFHInputFieldVisible, MFHInvestmentCase, MFHInvestmentCaseInputOrigin, MFHInvestmentCaseOverlappingApprovedCasesError, MFHInvestmentCaseReadCopySyncStatus, MFHInvestmentCaseStatus, MFHInvestmentCaseType, MFHInvestmentCaseVersionStatus, MFHInvestmentCaseVersionTriggerType, MFHMarketChannel, MFHOutputErrorKind, MFHPlacementBuyBoxStatus, MFHPlacementICSchema, MFHPlacementSchema, MFHPlacementStatus, MFHPortfolioEvents, MFHPortfolioFinancingState, MFHPortfolioProcessState, MFHPortfolioProcessStateMapping, MFHPortfolioProcessType, MFHPortfolioPurchasingState, MFHPrecacheSliceFailureReason, MFHPrecacheSliceStatus, MFHProcessState, MFHProcessStateMapping, MFHProcessType, MFHRIWISLocation, MFHRenovationPositionCategoryCodeSchema, MFHRenovationPositionCategoryTranslations, MFHRenovationPositionCodeSchema, MFHRenovationPositionStatus, MFHRenovationPositionStatusOrder, MFHRenovationPositionStatusToCostColumnMap, MFHRenovationPositionStatusTranslations, MFHRenovationPositionTranslations, MFHRenovationProjectBudgetType, MFHRenovationProjectCategoryPositions, MFHRenovationProjectCostBreakdownEvent, MFHRenovationProjectCostBreakdownProcessStateMapping, MFHRenovationProjectCostBreakdownProcessType, MFHRenovationProjectCostBreakdownReviewState, MFHRenovationProjectCostBreakdownState, MFHRenovationProjectEvents, MFHRenovationProjectLotEvents, MFHRenovationProjectMeasuresPackage, MFHRenovationProjectMeasuresPackageTranslations, MFHRenovationProjectPlanningModuleEvents, MFHRenovationProjectPlanningModuleProcessStateMapping, MFHRenovationProjectPlanningModuleProcessType, MFHRenovationProjectPlanningModuleStatus, MFHRenovationProjectPlanningModuleStatusTranslations, MFHRenovationProjectPositionSheetColumnMappings, MFHRenovationProjectProcessStateMapping, MFHRenovationProjectProcessType, MFHRenovationProjectStateTranslations, MFHRentComparableCondition, MFHRentMarketListedSinceDays, MFHRentMarketRoutingStatus, MFHSheetEmbeddingMode, MFHSourcingState, MFHSubsidyFinancingState, MFHTaskCreationTrigger, MFHTaskMilestoneRecordStatus, MFH_ATTRIBUTES_RESTRICTION_SOURCE, MFH_AVERAGE_RESIDENTIAL_UNIT_AREA, MFH_COMPONENT_CORRECTION_FACTOR_COMPONENTS, MFH_CONSTRUCTION_PLAN_ARCHIVED_STATUSES, MFH_CONSTRUCTION_PLAN_SECTION_PLAN_TYPES, MFH_CONSTRUCTION_PLAN_STRUCTURAL_COMPONENTS, MFH_CONSTRUCTION_PLAN_VIEW_PLAN_TYPES, MFH_DEVELOPMENT_NET_FLOOR_AREA_FACTOR, MFH_ERV_ADJUSTMENT_MAX_DECIMALS, MFH_ERV_AREA_MAX_DECIMALS, MFH_ERV_MAX_FLOOR, MFH_ERV_MIN_FLOOR, MFH_ERV_PREMIUM_MAX_DECIMALS, MFH_FEE_TIER_LOWER_THRESHOLD, MFH_FEE_TIER_UPPER_THRESHOLD, MFH_GLOBAL_INVESTOR_ASSUMPTIONS_FIELDS, MFH_INVESTMENT_CASE_INPUT_ORIGINS_KEY, MFH_INVESTMENT_CASE_INPUT_ORIGIN_BY_ANALYZER_SOURCE, MFH_INVESTMENT_CASE_KPI_CALC_ENGINE_KEYS_V5_6_0, MFH_INVESTMENT_CASE_RENT_INDEX_INPUT_PATH, MFH_INVESTMENT_CASE_SCENARIO_ORIGINS, MFH_INVESTMENT_CASE_WORST_BASE_BEST_SUFFIX_PATTERN, MFH_MANDATE_CRITERION_IDS, MFH_MANDATE_RULE_SET_ID, MFH_MANUAL_CHANNEL_NAMES, MFH_MANUAL_CHANNEL_OPTIONS, MFH_MILIEUSCHUTZ_GEODATA_RESTRICTION, MFH_OPENKM_DROOM_CONFIG, MFH_PARTNER_PROFILE_ASSUMPTIONS_FIELDS, MFH_PLACEMENT_ALLOCATABLE_RESPONSE_STATUSES, MFH_PLACEMENT_ALLOCATED_SOURCING_STATES, MFH_PLACEMENT_BEST_FIT_KPI_CAPS, MFH_PLACEMENT_DEFAULT_APETITE_WINDOW_DAYS, MFH_PLACEMENT_DEFAULT_BEST_FIT_SUB_WEIGHT, MFH_PLACEMENT_DEFAULT_BEST_FIT_WEIGHT, MFH_PLACEMENT_DEFAULT_FAIRNESS_WEIGHT, MFH_PLACEMENT_DEFAULT_RENEO_FIT_WEIGHT, MFH_PORTFOLIO_DRIVE_NAMES, MFH_PORTFOLIO_VIEWER_VERSIONS, MFH_PROVIDER_CHANNEL_NAMES, MFH_REGULATORY_CRITERION_IDS, MFH_RENT_MARKET_LISTED_SINCE_DAYS, MFH_SCREENING_CRITERION_REJECTION_REASON, MFH_SCREENING_EDITABLE_MEASUREMENTS, MFH_SCREENING_FALLBACK_REJECTION_REASON, MFH_SCREENING_MIN_CONSTRUCTION_YEAR, MFH_SOURCING_CRITERION_OPERATORS, MODCatchUpAfterStaffel, MachineFailureError, MachineType, MandateType, ManualAdjustmentsRowSchema, ManualAdjustmentsSchema, ManualProcessRejectionReason, MappingType, MatchedSubsidyProgramSchema, MaxKwhPerEnergyConsumptionCategory, MediaFileCategory, MediaFileCategoryTranslations, MediaFileDTOSchema, MediaFileVariant, MergedDocumentInspections, MeterReadingType, MeterStatus, MeterType, MezzanineLoanAccount, MfhAttributesParseResultSchema, MfhBuildingClass, MfhBuildingType, MfhCapexBudgetBucket, MfhChannelName, MfhChannelNameAbbreviations, MfhChannelNameLabels, MfhColorPerEnergyConsumptionCategory, MfhConstructionPlanApprovalConfigurationSchema, MfhConstructionPlanApprovalStatus, MfhConstructionPlanApprovalType, MfhConstructionPlanBluePrint, MfhConstructionPlanChangeCategory, MfhConstructionPlanComponents, MfhConstructionPlanOrientation, MfhConstructionPlanPerformancePhase, MfhConstructionPlanScale, MfhConstructionPlanSectionPlane, MfhConstructionPlanType, MfhConstructionPlanVersionEvent, MfhConstructionPlanVersionStatus, MfhCostMarkupsSchema, MfhDDAnswerSchemas, MfhDocumentCheckBankNoteNecessaryStatus, MfhDocumentCheckStatus, MfhEnergyConsumptionCategoryLabelColor, MfhEnergyEfficiencyCalculationConfigSchema, MfhEnergyEfficiencyComponentInputSchema, MfhEnergyEfficiencyComponentSnapshotSchema, MfhEnergyEfficiencyInputsSchema, MfhEnergyEfficiencyOutputSchema, MfhEnergyEfficiencyScenarioComponentSchema, MfhEnergyEfficiencyScenarioPostComponentSchema, MfhEnergyEfficiencyScenarioSchema, MfhEnergyEfficiencyScenarioStatus, MfhEnergyEfficiencySubsidyConfigSchema, MfhEnergyEfficiencySubsidyInputsSchema, MfhEnergyEfficiencyWarningCode, MfhEnergyEfficiencyWarningSchema, MfhEnergyEfficiencyWarningType, MfhEnvelopeSurface, MfhExposeParseResultSchema, MfhFieldSource, MfhInPipelineSourcingStates, MfhLocationAnalysisCompletedStateSchema, MfhLocationAnalysisFailedStateSchema, MfhLocationAnalysisRunningStateSchema, MfhLocationAnalysisStateSchema, MfhManualProcessRejectionReason, MfhManualProcessRejectionReasonTranslation, MfhMeasureComponent, MfhMeasureComponentCatalogueItemSchema, MfhMeasureComponentEnergyModelType, MfhMeasureComponentEnergyParamsSchema, MfhMeasureComponentFlag, MfhMeasureComponentGroupId, MfhMeasureComponentGroupSchema, MfhMeasureComponentPrefillRule, MfhMeasureComponentPrefillSchema, MfhMeasureComponentUnit, MfhMediaPredfinedTags, MfhPortfolioMapper, MfhReferenceBuildingParamsSchema, MfhRenovationInvoicesBilledSchema, MfhRenovationProjectLotProcessStateMapping, MfhRenovationProjectLotProcessType, MfhRenovationProjectLotState, MfhRenovationProjectMeasuresPackageBudgetsSchema, MfhRenovationProjectPlanningSetup, MfhRenovationProjectPlanningSetupTranslations, MfhRenovationProjectState, MfhRentalContractParseResultSchema, MfhScenarioCatalogueDuplicateError, MfhScenarioCatalogueUnresolvedError, MfhScreeningRecommendation, MfhSourcingCriterionMeasurement, MfhSourcingCriterionOperator, MfhSourcingStatesForAssetsNotInPipeline, MfhSourcingStatesInAcquisitionIgnoredPhase, MfhSourcingStatesInAcquisitionPlanningPhase, MfhSourcingStatesInAcquisitionReservationPhase, MfhTags, MilestoneName, MonthlyInvestorShare, MonthlyInvestorShareExcludedReason, MonthlyInvestorShareExcludedReasonLabels, MonthlyInvestorShareStatus, MonthlyRentGuaranteeType, MultiError, NamedAccount, NetSuiteInvoiceExportFailedError, NetSuiteUUIDExportFailedError, NetsuiteSyncState, NonDownloadableDocument, NotImplementedError, NotRentableUnitProcessError, NotariatDocumentTypes, Note, NoteType, NotificationChannel, NotificationReconcilerRuleName, NotificationTemplate, NotificationTemplateMap, NotificationTemplateRenderer, ONELOGIN_COMPANY_UNIT_MAPPINGS, ONELOGIN_DEPARTMENT_MAPPINGS, OWNER_SPECIAL_DEAL_MAX_DURATION, OngoingRenovation, OpenQuestionPriority, OpenQuestionStatus, OpenQuestionTopic, OperatingCostItemSchema, OperatingCostsDataSchema, Operator, OrderSchema, OtherEnergyConsumptionCategory, OtherLedgerEntryType, OutBoxState, OverAllRenovationStatus, OvershootPermissions, OwnerManagementEvents, OwnerManagementStates, OwnershipSplittingSchema, PAID_INVOICE_STATES, PAYMENT_ADJUSTMENT_THRESHOLD, PG_INTEGER_MAX, PIPELINE_MFH_LEGACY_FLAT_IC_KEYS, PITCHED_FAMILY, PV_NO_BATTERY_CAP_FRACTION, PaAmenityCategory, PaAmenityCategorySchema, PaAmenityGroupSchema, PaAmenityPoiSchema, PaAnalysisConfidence, PaAnalysisConfidenceSchema, PaAnalysisDatapointSchema, PaAnalysisResultSchema, PaAnalysisSectionsSchema, PaAnalysisSourceSchema, PaArtifactSchema, PaAssetAnalysisSchema, PaAssetDataSchema, PaAssetMediaSchema, PaBackendMCPTools, PaConfidenceLevelSchema, PaConstructionAnalysisSchema, PaConstructionMeasureSchema, PaD2gDataSchema, PaExecutiveSummarySchema, PaExtractionProgressSchema, PaExtractionStep, PaExtractionStepSchema, PaFieldStatusSchema, PaIdentifiedInputSchema, PaLocationAnalysisSchema, PaLocationClass, PaLocationClassSchema, PaOutputAssetSchema, PaOutputSchema, PaOutputSummarySchema, PaOutputWarningSchema, PaPartialAnalysisSectionsSchema, PaRentalAnalysisSchema, PaReviewProgressSchema, PaReviewSection, PaReviewSectionSchema, PaReviewSectionStatus, PaReviewSectionStatusSchema, PaReviewStatus, PaReviewStatusSchema, PaSessionSchema, PaSessionState, PaSessionStateSchema, PaSessionStatus, PaSessionStatusSchema, PaSubsidyAnalysisSchema, PaSubsidyProgramSchema, PaSubsidyScope, PaSubsidyScopeSchema, Pagination, PaginationFieldsSchema, PaginationParamsSchema, ParkingApartmentTypes, ParkingSpaceCategory, ParkingSpaceType, ParsedSubtagSchema, PartnerName, PartnerSetup, PaymentEvent, PaymentNoticeSummary, PaymentNoticeSummaryState, PaymentOrder, PaymentOrderFileName, PaymentOrderType, PeaksideDebtors, Permission, PhotoProcessStatus, PipelineAuditEventReasonCode, PipelineAuditEventReasonDetail, PlacesRankPreference, Portfolio, PortfolioAmortizationType, PortfolioAnalyzerConsumer, PortfolioEstatePlan, PortfolioEstatePlanCollection, PortfolioEstateSummaryClass, PortfolioEvents, PortfolioLoanAccount, PortfolioStatus, PositionCostAllocation, PositionCostAllocationCalculations, PositionCostAllocationCostType, PositionCostAllocationCostTypeTranslations, PositionEditType, PositionLink, PreDefinedTag, PreconditionFailedError, PredictionBasedControllingViewColumn, PredictionResultClass, PredictionType, PriceDTOSchema, Priority, ProcessEventUnion, ProcessStateMapping, ProcessStateUnion, ProcessType, ProcessVersionEventBodySchema, ProcessVersionEventParamsSchema, ProfitabilityCalculationsClass, PromotionExposeGenerationFailedError, PropertyManagementEvents, PropertyManagementEventsGrouped, PropertyManagementGroup, PropertyManagementLedger, PropertyManagementStates, PurchasingChecklistExclusionReducer, PurchasingChecklistQuestion, PurchasingInspectionAmenityCondition, PurchasingInspectionAmenityConditionTranslation, PurchasingInspectionApartmentTypeTranslation, PurchasingInspectionBeltWindersLocation, PurchasingInspectionBeltWindersLocationTranslation, PurchasingInspectionBuildingOutsideFacadeCondition, PurchasingInspectionBuildingOutsideFacadeConditionTranslation, PurchasingInspectionBuildingOutsideFacadeType, PurchasingInspectionBuildingOutsideFacadeTypeTranslation, PurchasingInspectionBuildingOverallCondition, PurchasingInspectionBuildingOverallConditionTranslation, PurchasingInspectionBuildingRoofType, PurchasingInspectionBuildingRoofTypeTranslation, PurchasingInspectionCommonArea, PurchasingInspectionCommonAreaTranslation, PurchasingInspectionEstatePositionCategory, PurchasingInspectionEstatePositionCategoryTranslation, PurchasingInspectionExclusionCriterionMap, PurchasingInspectionFloor, PurchasingInspectionFloorLocationTranslation, PurchasingInspectionFloorMap, PurchasingInspectionFloorTranslation, PurchasingInspectionFloorType, PurchasingInspectionFloorTypeTranslation, PurchasingInspectionGuestToiletStorageRoomAfterRenovationOptions, PurchasingInspectionGuestToiletStorageRoomAfterRenovationOptionsTranslation, PurchasingInspectionHeatingDeviceType, PurchasingInspectionHeatingDeviceTypeTranslation, PurchasingInspectionNotClearYesNoRadioOptions, PurchasingInspectionParkingSpaceTypeTranslation, PurchasingInspectionPublicTransportConnection, PurchasingInspectionPublicTransportConnectionTranslation, PurchasingInspectionQuestions, PurchasingInspectionReplaceWindowsCostRegulationTranslation, PurchasingInspectionWaterHeatingDeviceType, PurchasingInspectionWaterHeatingDeviceTypeTranslation, PurchasingProcess, PurchasingState, PurchsaingInspectionReplaceWindowsCostRegulation, QuestionAnswers, RENOVATION_ON_HOLD_REASONS_FOR_RENTING, RENOVATION_PROJECT_DEFAULT_CONSTRUCTION_YEAR, RENOVATION_SCENARIO_DEFAULT_END_EXPANSION_LETTING, RENOVATION_SCENARIO_DEFAULT_START_EXPANSION_LETTING, RENOVATION_SCENARIO_EMPTY_MONTH, RENOVATION_SCENARIO_ROOF_FACTOR, RENT_ROLL_IMPORT_SHEET_TITLE_CANDIDATES, RENT_ROLL_SHEET_TITLE, REQUIRED_EFFICIENCY_HOUSE_STAGE_COUNT, REQUIRED_EFFICIENCY_HOUSE_STAGE_TRACK_PAIRS, REQUIRED_PERMANENT_INVOICE_FIELDS, RaasDocumentCategory, RaasDocumentType, RaasMediaCategory, RaasUserType, RawProviderDataSchema, ReceiptDocumentTypeEnum, ReceiptInvoiceTypeEnum, ReceiptPaymentmethodEnum, RecentlyVisitedPage, ReconcilerRuleFactory, ReconcilerRuleMissingDataError, ReconcilerRuleName, ReconcilerRuleOverlappingError, ReconciliationTags, RecoverPmLedgerAction, RelationNotPresentOnEntity, RemainingControllingViewColumn, RenderDocumentResultSchema, RenovationCostTrackingConstructionPlanTypes, RenovationCostTrackingConstructionPlansOrder, RenovationEnergeticMeasureType, RenovationEnergeticMeasureTypeSchema, RenovationExtraCostsCalculator, RenovationExtraCostsFormulasMap, RenovationInFixingStates, RenovationInPlanningStates, RenovationInRenovationStates, RenovationInspectionState, RenovationInspectionType, RenovationOnHoldReason, RenovationProject, RenovationProjectCalendarEventType, RenovationProjectChecklistQuestions, RenovationProjectEvents, RenovationProjectPositionCalculations, RenovationProjectPrediction, RenovationProjectPurpose, RenovationProjectSource, RenovationProjectStatus, RenovationScenario, RenovationScenarioConfigSchema, RenovationScenarioExpansionType, RenovationScenarioExpansionTypeSchema, RenovationScenarioGroupCode, RenovationScenarioGroupCodeSchema, RenovationScenarioSchema, RenovationScenarioSubsidyScheme, RenovationScenarioSubsidySchemeSchema, RenovationStandard, RenovationStates, Rent, RentApartmentCondition, RentApartmentConditionEnumSchema, RentCPI, RentCase, RentIncreaseFormula, RentIncreaseFormulaEnumSchema, RentIncreaseType, RentIncreaseTypeEnumSchema, RentIndexLookupStatus, RentIndexMissingInputCode, RentIndexPriceModel, RentPriceDTOSchema, RentRollColumnPathMapping, RentRollD2GMappings, RentRollD2GMappingsV540, RentRollImportResultSchema, RentRollSchema, RentRollStatus, RentRollVersionEvents, RentRollVersionReferencedByInvestmentCasesError, RentRollVersionStatus, RentSchema, RentTenancy, RentTenancyLedgerStatement, RentTenancyLedgerStatementBalanceValuesSchema, RentTenancyLedgerStatementCashflowValuesSchema, RentTenancyLedgerStatementExpectedValuesSchema, RentTenancyRentIncreaseTypeEnumSchema, RentableUnit, RentableUnitAllRentedOrNoRentingNeeded, RentableUnitAvailabilityStatus, RentableUnitCaseMismatchError, RentableUnitEvents, RentableUnitPausedStates, RentableUnitProcessEventsToStatesMap, RentableUnitSchema, RentableUnitStates, RentableUnitStatesTranslations, RentableUnitType, RentableUnitTypeEnumSchema, RentalContract, RentalContractRentIncreaseType, RentalContractSchema, RentalContractStatus, RentalContractStatusEnumSchema, RentalContractType, RentalContractTypeEnumSchema, RentalContractUnit, RentalContractUnitSchema, RentingAttributesSchema, RentingEvents, RentingLead, RentingLeadStatus, RentingListing, RentingListingHeatingType, RentingListingProvider, RentingListingState, RentingProcess, RentingProcessExtraPropsSchema, RentingProcessSchema, RentingStates, RentingStatesOrder, RepaymentPeriod, RepaymentType, RequestTimeoutError, RequiredDocumentsSeller, RequiredRentRollSchema, RequiredStringDateSchema, RequirementLevel, RequirementLevelTranslation, ResidentialApartmentTypes, ResourceNotSharedError, Restrictions, RestrictionsTranslation, ResyncMfhEnergyEfficiencyScenarioBodySchema, ResyncMfhEnergyEfficiencyScenarioParamsSchema, RetriesExceededError, RevenueEntryType, ReviewProcess, ReviewProcessEvents, ReviewProcessState, ReviewProcessType, ReviewRequest, ReviewRequestState, RoleBindingCombination, RoofOrientation, RoofShape, RoofUse, RoomEquipment, RoomOtherElementType, RoomStructureElements, RoomType, RoomTypesList, RoomTypesOrderedList, RouteMatrixEntryStatus, RouteTravelMode, RuleType, SALES_PORTAL_ALLOWED_DOCUMENT_TYPES, SALES_PORTAL_SALES_PACKAGE_ALLOWED_DOCUMENT_TYPES, SALES_PORTAL_SELLING_REGION_ALLOWED_DOCUMENT_TYPES, SEPADirectDebitSource, SEPADirectDebitStatus, SEPADirectDebitType, SEPAMandate, SHEET_ERROR_MAPPINGS, SPECIAL_DEAL_DISCOUNTS_FOR_FIRST_X_YEARS, SPECIAL_DEAL_DISCOUNTS_UPON_COMPLETION_OF_PURCHASE, SP_DOCUMENT_TYPES_WITH_MULTIPLE_DOCUMENT_ALLOWED, STATE_CODE_MAPPINGS, STATIC_MAP_SIZES, SYTE_ROOF_TYPE, SalesPackageDocumentChecklist, SalesPackageEligibleEstatePurchasingStates, SalesPackageEligibleEstateSellingStates, SalesPackageEstateSellingStatesGrouped, SalesPackageEvents, SalesPackageExludedEstatePurchasingStates, SalesPackageExport, SalesPackageExportFailedError, SalesPackageExportFolders, SalesPackageExportMode, SalesPackageRemoveEstateAllowedStates, SalesPackageState, SalesPortalDocumentType, SalesPortalPartner, SalesPortalUserRole, SalesPortalVisibleFeaturesMetadataOption, Salutation, ScenarioParamIssueCode, ScenarioParamsSchema, ScenarioParamsV1Checker, SchemaFailedError, SchemaMissingIdError, SchufaState, SearchableCollectionType, SearchableEstateMapper, SearchableMfhMapper, SellingAvailability, SellingChecklistDataPoints, SellingOfferAcceptedStates, SellingPaidStates, SellingPartner, SellingProcess, SellingStates, SellingStatesEstateAvailableForSelling, SellingStatesEstateReservedForSelling, SellingStatesEstateSold, ServiceChargeAdjustmentDataSchema, ServiceChargeDistributionKey, ServiceChargeDistributionKeysSchema, ServiceMisconfiguredError, ServiceUid, SideEffectNotAllowedError, SignOffDocumentApprovedStatuses, SignOffDocumentEvents, SignOffDocumentSignedStatuses, SignOffDocumentStatus, SignOffDocumentStatusTranslation, SignOffDocumentTerminalStatuses, SignOffEnvelopeActiveStatuses, SignOffEnvelopeDeletableStatuses, SignOffEnvelopeEvents, SignOffEnvelopeInactiveStatuses, SignOffEnvelopePendingStatuses, SignOffEnvelopePriority, SignOffEnvelopeRelationFieldKeys, SignOffEnvelopeRelationFieldSchema, SignOffEnvelopeStatus, SignOffEnvelopeStatusTranslation, SignOffEnvelopeSubEntityFieldSchema, SignOffEnvelopeType, SignOffTemplateRelationFieldKeys, SignOffTemplateRelationFieldSchema, SignOffTemplateType, SourcingEstateIgnoredUpdatePaths, SourcingEstateStatus, SourcingPriority, SourcingStates, SourcingTasksDDEvaluation, SpecialDeal, SpecialDealFlagNames, SpecialDealFlags, SpecialDealFlagsAndInputs, SpecialDealStandaloneFlags, SplitStatus, SpotlightAnswerType, SpreadsheetMatrixError, SpreadsheetVectorError, StateMachineEvents, StatementSchema, StoreRoomTranslations, StoreRoomType, Strict, StringDateSchema, SubCompany, SubscriptionFrequency, SubscriptionFrequencyType, SubscriptionPaymentType, SubscriptionState, SubsidyBenefitSchema, SubsidyCalculationBreakdownSchema, SubsidyConsideredMeasureSchema, SubsidyEfficiencyHouseStage, SubsidyEfficiencyHouseStageAssessmentSchema, SubsidyEfficiencyHouseStageConfigSchema, SubsidyEfficiencyHouseTrack, SubsidyEligibilityRuleCode, SubsidyEligibilityStatus, SubsidyFundingType, SubsidyHeatingSystem, SubsidyMissingInputCode, SubsidyProgramCode, SubsidyProgramMetadataSchema, SubsidyProgramResultSchema, SubsidyRegion, SubsidyRuleOutcome, SubsidyRuleOutcomeSchema, SubsidyRuleReasonCode, SubsidyRuleReasonSchema, SubsidyRuleValueSchema, SubsidyRuleValueUnit, SubsidyVariantAssessmentSchema, SubsidyVariantAssessmentStatus, SubsidyVariantSchema, SubsidyWarningCode, Subtag, SystemError, SyteExpansionAssessmentStatus, SyteExpansionAssessmentUnavailableReason, TAnyDict, TBuffer, TDate, TDecimal, TEASER_FIELD_PROMPTS, TECHNICAL_DD_EXTERNAL_MEDIA_CATEGORIES, TEnum, TNullable, TNullableObject, TOP_7_CITIES, TOneOfUnion, TPartialBy, TStringDate, TStringEnum, TaskCompletedStatuses, TaskExternalTouchpoints, TaskInternalTouchpoints, TaskMilestone, TaskMilestoneEnglish, TaskMilestoneGerman, TaskPendingStatuses, TaskProgressStatus, TaskProgressStatusTranslation, TaskRisk, TaskSource, TaskStatus, TaskStatusTranslation, TaskTemplateEntity, TechDDCategory, TechDDCategoryTranslation, TechnicalOnSiteDDStatus, TechnicalOnSiteDDStatusTranslation, TenancyType, TenancyTypeEnumSchema, TenantFaqCategory, TenantFaqQuestion, TenantManagementEvents, TenantManagementStates, TenantPortalDocuments, TenantSupportCategory, TenantSupportSubCategory, TenantSupportSubCategoryMap, TenderingProcessStatus, TenderingProcessTendererEvents, TenderingProcessTendererStatus, TerminationAlreadyScheduledError, TimeoutError, TransactionReconciliationType, TransactionRunSchema, TransactionRunState, TransactionSchema, TypesenseNoPermissionNeeded, UnauthorizedError, UnitName, UnitOverviewApartmentTypes, UnsupportedError, UpdateApprovalConfigBodySchema, UpdateApprovalConfigParamsSchema, UpdateDocumentAnnotationBodySchema, UpdateDocumentAnnotationParamsSchema, UpdateMfhConstructionPlanBodySchema, UpdateMfhConstructionPlanParamsSchema, UpdateMfhEnergyEfficiencyCalculationConfigBodySchema, UpdateMfhEnergyEfficiencyScenarioBodySchema, UpdateMfhEnergyEfficiencyScenarioParamsSchema, UpdateMfhEnergyEfficiencyScenarioStatusBodySchema, UpdateMfhEnergyEfficiencyScenarioStatusParamsSchema, UpdateMfhMeasureComponentCatalogueItemBodySchema, UpdateMfhMeasureComponentCatalogueItemParamsSchema, UpdateRenovationProjectPositionSchema, UserConfirmationRejectedOrTimeoutError, UserConfirmationStatus, UserConfirmationTask, UserNotCreatedError, UserRelationRoles, UserRoles, UserState, UserTaskStatus, UserTaskType, VAT, ValidationFailedError, VatClassSchema, VerificationRequestAction, ViewBankAccountType, VisitedPageDataSchema, VisitedPageType, WaterHeating, WildcardPermission, WindowGlazing, WorkflowDDStatus, WorkflowDDStatusTranslation, accountTypeMap, activeSnapshotIgnoredFields, addDuration, addICTeaserCustomLocation, addendumReasonTranslationMap, additionalDocumentTypesWhenFiltered, adjustmentToBreakdownMapping, agentReasoningEfforts, aggregateAllRequiredRuleOutcomes, aggregateAnyPassingRuleOutcomes, aggregateHeatingSystemEnergyMix, aggregateMfhCapexBudgetBuckets, aggregateReferenceFloorSpace, allowedDomainsForInvoiceAssignees, almostOrAlreadyRentedRentingStates, annualServiceChargeStatementSchemas, apartmentConditionToRentRoll, apartmentTypeToRentRoll, applyExpansionTypeRules, applyICTeaserEditorSlideFieldsToSlides, applyInvestorShareOperations, applyMFHInvestmentCaseInputOriginsFromSources, applyManualAdjustments, applyMfhMandateOverrides, applyMfhMilieuschutzGeodataToRestrictions, applyMfhRegulatoryAnswersToRestrictions, applyMfhRegulatoryAttestation, applyScenarioPatchToCaseInputs, areMfhConstructionPlanIdentityCriteriaEqual, asDayjs, asFiniteNumber, asMFHInvestmentCase, assertRentRollDateFieldsYearAtMost9999, assessmentDDStatusConfig, assetLedgerEntryAccountCodeMap, assignMFHErvSizeCluster, assignMFHInvestmentCaseInputOrigins, assignableRelationsForTaskTemplates, authzExternalContactEmploymentExpandOpts, automaticInvestmentCaseCalculationOutputDefinitions, automaticTaskProgressAssessment, badStatuses, bankTransactionSchemas, bankTransactionWarningDescription, bootstrapDataUserCompressor, boxConfig, buildAssetImpressionsSlideData, buildAssetOverviewSlideData, buildAssetPaymentSchedule, buildAttributePathFromParams, buildCashFlowSlideData, buildConstructionPlanAssetSegment, buildCoverSlideData, buildDcfTable, buildEditableSourceValues, buildEmbeddingPrecachePdfArtifactDownloadFilename, buildEmbeddingPrecachePdfArtifactGsUriFromHtmlGsUri, buildEmbeddingPrecachePdfArtifactObjectPathFromHtmlObjectPath, buildEmbeddingPrecachePngArtifactDownloadFilename, buildEmbeddingPrecachePngArtifactGsUriFromHtmlGsUri, buildEmbeddingPrecachePngArtifactObjectPathFromHtmlObjectPath, buildExecutiveSummarySlideData, buildICTeaserCompletenessInputFromDocument, buildICTeaserEditorValues, buildICTeaserFieldsPatch, buildICTeaserLocationRestrictions, buildICTeaserSourceData, buildICTeaserSourceDataPatch, buildICTeaserUpdatePatch, buildInvestmentCaseJsonTransferPayload, buildLeveredDcfSlideData, buildLocationRentComparablesSlideData, buildMFHInvestmentCaseInputOrigins, buildMFHInvestmentCaseSourceOriginLayers, buildMacroMicroLocationSlideData, buildMfhMandateRules, buildMfhRegulatoryCriteria, buildMfhScreeningCheck, buildMfhScreeningCheckRecord, buildMfhScreeningCheckSnapshot, buildOverriddenMFHInvestmentCaseInputOrigins, buildPaymentSchedule, buildProjectDeliverySlideData, buildRentalDevelopmentSlideData, buildReturnsSlideData, buildSourcesUsesFinancingSlideData, buildSubsidiesSlideData, buildTransformationSlideData, buildUnleveredDcfSlideData, calculateAmortizationPeriod, calculateAmortizationRatePurchasePrice, calculateAutomaticSubsidy, calculateBafaBegEmCostCeiling, calculateBaseReturnValues, calculateBaseValues, calculateCommonExpenses, calculateCostMarkups, calculateEstateRentingState, calculateFinancingCosts, calculateHotWaterHeatDemand, calculateHouseGeld, calculateHouseGeldNonTransferable, calculateHouseGeldReserve, calculateHouseGeldTransferable, calculateIncomeParams, calculateKfw459CostCeiling, calculateMFHErvBreakdown, calculateMarketPrice, calculateMfhEnergyEfficiency, calculateMfhEnergyEfficiencyScenarioTotal, calculateMfhEnergyEfficiencyStandaloneMeasures, calculateNotaryFees, calculateOtherCosts, calculateReferenceBuilding, calculateRenovationCosts, calculateReturnTargetProfitability, calculateSensitiveDistressedCaseValues, calculateSpecificTransmissionHeatLoss, calculateThresholds, calculateTimeOnBooks, calculateTransferableNonTransferableCosts, calculateV2, canApproveDDv2Question, canEditExternalApprovers, candidateMfhPortfoliosFromRelations, canonicalizeJson, carryOverCostValue, catalogueItemToSnapshot, checkIfFutureHouseGeldStartDateRequiresProcessing, checkIfSalesPackageIsUpdatable, checkPermissions, checklistV2DDStatusConfig, clampTeaserHtmlToPlainBudget, classifyMfhScenarioRenovationArchetype, clearMFHInvestmentCaseInputOrigins, coerceTakeoverValue, collectCrmCommentRateTriples, collectDcfCalcengineValues, collectMFHInvestmentCaseInputPaths, collectMFHInvestmentCaseInputPathsByOrigin, collectOverriddenMFHInvestmentCaseInputPaths, collectScenarioParamInvariantIssues, collectSheetCalcengineValues, commercialDDQuestions, compactCalcengineErrorMessage, compactICTeaserPrimaryHighlightedLocationKeys, companyFunctionDepartment, companyToContactTypeMapper, companyToEstateRelationName, companyTypeToCostTypeMapping, compareRooms, computeBuyBoxStatus, computeCommercialUnitShare, condoCompanyNameRegexMap, condoFileSlug, condoSalesConditionToRentRoll, condoUUIDCompressor, configLeafToBranch, configLeafToBranchByParent, configSerializers, configurableCostCenters, constructionCraftTranslationMap, constructionPlanDurations, constructionPlanThatCanHaveMultipleActivePlans, contactToRelationName, contactTypeToCompanyMapper, convertEnergyConsumptionToEnergyConsumptionCategory, costTypeDomainLabels, costTypeGroups, costTypeTranslations, costTypesGrouped, countICTeaserEditableDrifts, countKfw261ApplicableOutcomeCombinations, countResidentialUnitsInInclusiveBand, craftOrdered, createAbbreviation, createICTeaserDocument, createICTeaserPlaceholderSlide, createProgramResult, createRouteWithReturn, createRuleResult, createStaticGMapsCenteredLink, createStaticGMapsLink, dangerouslyMergeRuleAssignments, daysInPeriod, dcfCashflowRowSpec, dcfCommentRateKeys, ddStatusConfigs, ddV2ActionPointParties, ddV2DocumentCategoryToDocumentCategory, dealClosingDDQuestions, decodeReturnRoute, decodeVersion, defaultICTeaserHighlightedLocationKeys, defaultICTeaserSelectedListingIds, defaultICTeaserSlideSubtitle, defaultLogger, defectDescriptionTypeTranslationMap, defectMainItemTranslationMap, defectStatusTranslationMap, defectSubItemTranslationMap, defectTitleTypeTranslationMap, deletableRentingStates, departmentCompanyFunctions, departmentDefaultParentFolders, depositRetentionReasonLabels, deriveEligibilityStatus, deriveExpansionFacadeArea, deriveExpansionFloorCount, deriveMfhAverageResidentialUnitArea, deriveMfhCapexBudgetBucketAreas, deriveMfhDevelopmentApartmentCount, deriveMfhDevelopmentNetFloorArea, deriveMfhDevelopmentNewFloors, deriveMfhMandateScreeningStatus, deriveMfhMarkedUpCapexTotals, derivePreHeatDemand, derivePrimaryEnergyFromFactor, deriveReferenceFloorArea, deriveReferenceFloorSpaceFromEnergy, deriveRenovationScenarioExpansionGeometry, deriveRoofExpansionFloorArea, deriveScenarioGeometryInputs, deriveScenarioGroupCode, deriveSyteExpansion, detectValueType, determineApartmentSize, diffICTeaserEditorSnapshots, docsSectionsTranslation, documentCategoryMap, documentCategoryTranslationsMap, documentChecklistAnswerSchema, documentChecklistQuestions, documentProcessStatusMapping, documentSchemas, documentTranslationsMap, documentTypeToCategory, documentTypeToDescriptionMap, base_errors_exports as domainErrors, drawdownDeleteStatuses, durableJobIsCancellable, durableJobIsRetriggerable, editStatuses, editableDefectPropsForStatus, editableDefectStatuses, emptyDcfTable, emptyICTeaserAssetImpressionsSourceData, emptyICTeaserAssetOverviewSourceData, emptyICTeaserCashFlowSourceData, emptyICTeaserCoverSourceData, emptyICTeaserDcfSourceData, emptyICTeaserEditableProjectMilestone, emptyICTeaserExecutiveSummarySourceData, emptyICTeaserFinancingSourceData, emptyICTeaserLocationSourceData, emptyICTeaserPlaceholderSlideContent, emptyICTeaserProjectDeliverySourceData, emptyICTeaserRentAnalysisSourceData, emptyICTeaserRentDevelopmentSourceData, emptyICTeaserReturnsSourceData, emptyICTeaserSubsidiesSourceData, emptyICTeaserTransformationSourceData, encodeReturnRoute, endEnergySourceDrivesAnnual, energyPerSqmToKwhPerYear, enumOrderedValues, errorReasonCodes, estimateExpansionPotential, estimateFloorExpansionLevel, evaluateBafaBegEm, evaluateChildRule, evaluateFkgMunich, evaluateIfbModernisierungA, evaluateInvestmentCaseBuyBox, evaluateKfw261, evaluateKfw359, evaluateKfw459, evaluateMaximumThresholdOutcome, evaluateMfhMandateScreening, evaluateMfhScreeningVerdict, evaluateReconcilerRule, evaluateReconcilerRules, evaluateRule, evaluateSubsidyPrograms, externalInvoicesStates, extractCalcEngineNumber, extractCalcEngineRawVector, extractCalcEngineString, extractCalcEngineVector, extractCompanyOrContactRecordName, extractEventDate, extractHeatingSystemEntries, extractICTeaserInvestmentCaseKpis, extractInvestmentCaseEquityEuro, extractPlacementInvestmentCaseKpis, filterContractorsByConstructionPlanType, filterEfficiencyHouseStagesByTrack, filterMFHInvestmentCaseInputPatchByVersion, finalDefectStatuses, finalRentingStates, financingCostJuniorDebt, financingCostJuniorDebtDaily, financingCostSenior, financingCostSeniorDaily, findConfigLeafs, findContractorPrice, findFailingMfhSourcingCriteria, findMainPreRenovationPhoto, findPropInAnyRule, findPropInRuleGroup, fingerprintScenarioParams, firstInvoiceOrPermanentInvoice, flattenRuleAssignments, floorLocationToRentRoll, formSchemaToDDFormType, formatMFHErvClusterRange, formatMFHErvFloorLabel, formatMFHSheetsData, formatMFHSummaryCardData, formatMFHSummaryData, formatMFHSummaryTabularData, formatMfhChannelName, formatMfhSourcingCriterionThreshold, fromCalcEngineHelperOutputs, fromCalcEngineOutputs, fromCalcEngineOutputsToGroupedTriples, fromICOrMFHAttribute, fromParsedSpreadsheetOutputsToGroupedTriples, fromRenovationsToUIData, fromRoleBindingDtosToRoleBindings, fromRoleBindingsToRoleBindingDtos, fromTabularData, ganttDataToCsv, generateCondoUUID, generateConstructionPlanVersionName, generateDocumentFileName, generateEstateFolderName, generateMfhBuildingUuid, generateMfhEstateUuid, generateMfhPortfolioUuid, generateMfhUuid, generateRandomString, genericDDAnswerSchema, getActiveSubEntityEnvelope, getAddress, getAllInternalInvoiceStates, getAmortizationPeriodLabel, getAssetPartnerFeePercent, getAssetsOverlappingCandidateAssetPartners, getCalcEngineInputFieldPath, getCalcEngineInputFieldPaths, getCalcEngineInputKeysForPath, getCandidateLocationAddress, getCandidateLocationForMfh, getCanonicalEeEfficiencyHouseStages, getCompanyName, getCompanyShortName, getConsolidatedCostSplitNetTotal, getConstructionPlanConditionalFieldKind, getConstructionPlanLineageId, getContactDisplayName, getContactEmailGreeting, getContactShortName, getCostSplitGrossFromNet, getCreditLineICTDirection, getDDFormType, getDDStatusColor, getDDStatusConfig, getDDStatusTranslation, getDDStatusValues, getDDv2ChecklistStatus, getDDv2DocumentCategoryLabel, getDateRangeLabel, getDocumentAnnotationTransferItemId, getDocumentCategoriesForExternalContact, getDriftedICTeaserSlideKeys, getDriveId, getDurableJobMetaProgress, getDurableJobMetaProgressPercent, getEnergyConsumptionCategory, getEntityAddress, getEntityCondoUuid, getEntityDisplayId, getEntityDisplayName, getEntityLabel, getEnvelopeType, getExcludedDocumentTypesForExternalContact, getExpandSelectSchema, getExpectedMonthsOfRentPaid, getExpectedProgressStatus, getExternalAppAllowedInvoiceStates, getFieldValues, getFormattedValueFromInfasResponseKey, getFutureHouseGeldValuesFromEconomicPlanDocumentInspectionIfApplicable, getGermanyStateCode, getGoingInOutPreviewRowKeys, getHalfMonthRatio, getICTeaserLiveEditableValue, getICTeaserLiveSourceSyncExcludedRoots, getICTeaserSlideEditableSourceRoots, getICTeaserSlideFootnote, getICTeaserSlideId, getICTeaserSlideSubtitle, getICTeaserSlideSubtitleAiKey, getICTeaserTableRowCells, getICTeaserTableRowKind, getInfasExternalData, getInfasParamDetailFromResponseKey, getInvoiceNetAmountAfterVat, getJobCurrentJobStep, getJobProgress, getMFHErvCellAdjustmentPercent, getMFHHierarchy, getMFHHierarchySequenceRecords, getMFHInvestmentCaseEnumSource, getMFHInvestmentCaseInputConfigForPath, getMFHInvestmentCaseInputOrigin, getMFHInvestmentCaseValueByPath, getMFHPartnerProfileConfigKey, getMFHPartnerProfileInputPath, getMFHSummaryData, getMFHTaskMilestoneRecords, getMaxCreatedAt, getMeasurePackageBudgetComponents, getMergedMFHLocation, getMfhConstructionPlanActiveApprovalType, getMfhEnergyConsumptionCategoryColor, getMfhEnergyEfficiencyBadgeColors, getMfhRenovationProjectCostBreakdownBudget, getMissingICTeaserSlideKeys, getMultipleFieldValues, getNetDisposalProceedsPreviewRowKeys, getPartyDisplayName, getPartyShortName, getPeriodLabel, getPersonAvatarInitials, getPhotoProcessStatusStr, getPositionCategoryCode, getPreviousMilestoneType, getRatioForMonth, getRenovationProgressSummary, getRentIndexForPreAndPostRenovation, getRentIndexMetricsForArea, getRentRollD2GMappings, getRentRollFieldToCalcKeysForVersion, getRentalAreaPreviewRowKeys, getRentalIncomePreviewRowKeys, getReturnRoute, getReturnsPreviewRowKeys, getRoofFactorForShape, getSearchParams, getSepaRemittanceInfo, getShareOfCommercialNRI, getSignOffTemplates, getSourcesPreviewRowKeys, getStatementId, getStrippedCCSRoutes, getTableCellFormat, getTaskNameFromDDQuestion, getUserDefaultNotificationRules, getUsesPreviewRowKeys, getValueBridgePreviewRowKeys, getValueProportionLand, groupCalcEngineOutputTriples, groupCodeToClassification, groupDDv2QuestionsByDocumentType, hasCompleteEfficiencyHouseStageTrackMatrix, hasDuplicateKeys, hasMFHInvestmentCaseComputedInputOverride, hasMFHInvestmentCaseRentIndexRows, hasRelatedEntity, heatingCostMethodLabels, hierarchyToSequenceRecords, hoaFeeSchemas, houseGeldOrCalculated, icTeaserAverageRentPerSqm, icTeaserCardBodyHtmlSchemaMaxChars, icTeaserCardBodyMaxChars, icTeaserCardBodyMaxCharsCeiling, icTeaserCardCopyLayoutFromSource, icTeaserExecutiveSummaryBodyMaxChars, icTeaserJCurveCommentaryMaxChars, icTeaserListingHasPhoto, icTeaserLocationAssessmentChips, icTeaserLocationAssessmentMaxChars, icTeaserLocationAssessmentParagraphs, icTeaserLocationAssessmentWorstCaseParagraphMaxChars, icTeaserLocationParagraphMaxChars, icTeaserLocationPoiKey, icTeaserMilestoneMatchesTimelineGate, icTeaserNoiBridgeCommentaryMaxChars, icTeaserNumberFormatters, icTeaserRentAnalysisSourceLabel, icTeaserRentListingStreet, icTeaserRentalDevelopmentCommentaryMaxChars, icTeaserTargetRentWithinComparables, icTeaserTransformationCardMaxChars, immutableEntitiesRentingStates, infasAttributeMap, infasResponseToSheetKey, inferHeatingSource, inferStateFromEstate, interiorQualityToStandardMap, internalToExternalInvoiceStatesMap, investorLedgerStatementLabel, investorPortalDocumentTranslationsOverride, isActiveAtDate, isActiveDDv2Question, isActiveForMonth, isActiveForYear, isActivePeriod, isAddendumClass, isAdminOrInternalUser, isAdminUser, isAllocatablePlacementResponseStatus, isArchivedMfhConstructionPlanVersionStatus, isAsbestos, isBuyPriceDTO, isCommercialRentRoll, isCompleteGuard, isCompressedTriple, isCondominium, isConstructionPlanAddendum, isCostOvershooting, isD2GSheetId, isDDAnswerCompleted, isDDAnswerCritical, isDDv2AssessmentEmpty, isEmptyExpansionMonth, isEstarcoreDebitorAccountNumber, isEstarcoreKreditorAccountNumber, isEstateShowingOnSalesPortal, isExpansionScenario, isFiniteNumber, isGeneralEnergeticOrCapex, isICTeaserEditablePathLiveSourceSyncEnabled, isICTeaserEditableValueDrifted, isICTeaserExecutiveSummaryCardTitleKey, isICTeaserMedia, isICTeaserPlaceholderSlide, isICTeaserRequiredSlide, isICTeaserSlideLiveSourceSyncEnabled, isICTeaserSlideSubtitleAiKey, isICTeaserSlideSubtitleEditable, isICTeaserSlideTitleAiKey, isICTeaserSubsidyProgrammeVisible, isICTeaserTable, isICTeaserTableStructuredRow, isICTeaserValueMissing, isIfbEligibleCity, isInternalEmail, isMFH, isMFHErvBreakdownConfigValid, isMFHInvestmentCaseComputedInputPath, isMFHInvestmentCaseInputActiveForVersion, isMFHInvestmentCaseInputOriginPath, isMFHInvestmentCaseInputRequired, isMFHInvestmentCaseRentIndexMissingField, isMFHPartnerIdentityInputPath, isMFHPartnerProfileInputPath, isMFHProfileSpecificInputPath, isMFHRentMarketListedSinceDays, isMainPhotoPostRenovation, isMainPhotoPreRenovation, isManualMfhChannel, isMediaFile, isMfhAcquisitionBlockedForThisPartner, isMfhConstructionPlanChangeCategory, isMfhDevelopmentMeasureComponent, isMfhRegulatoryCriterionId, isMfhRegulatoryKnockout, isMfhRegulatorySourcingCriterion, isPrefabricated, isProtectedDocumentFolderPath, isProviderMfhChannel, isPurchasingProcess, isReadyForLetterSendout, isReadyForValidation, isRenovationProcess, isRentPriceDTO, isRentRollMatching, isRentableUnitProcess, isRootConfigRecord, isSalesPackageOpenWithNoPartners, isSellingProcess, isSignOffDocumentApproved, isSignOffDocumentSigned, isSourcingProcess, isSupportedEstarcoreStammkonto, isTaskCompleted, isTenantManagementProcess, isUserAssetPartnerEmployee, isValidSequentialTransition, isValidated, joinConstructionPlanSectionPlanes, juniorWacc, legalDDQuestions, listBuyBoxFailingCriteria, listedSinceDateFromDays, livingsCheckQuestions, locationCityFormatter, locationProfileToDto, locationRatingTransalations, locationRegionFormatter, locationStateFormatter, makeSEPAId, manualEntryGroup, mapBlockedRentingProcessToRentableUnitState, mapEstateChannelToMfhChannel, mapMFHAssetPartnerProfileConfigToCaseInputs, mapMedia, mapMfhEnergyEfficiencyScenarioToInvestmentCaseInputs, mapNodeEnvToShortEnvironmentName, mapPaRestrictionLabel, mapPaRestrictionLabels, mapRenovationScenarioInheritedInputs, mapRenovationScenarioToInvestmentCaseInputs, mapRoofShapeToSyteRoofType, mapSensitivityOutputsToCaseInputs, mapSyteHeatingSystemToHeatingType, mapSyteRoofTypeToRoofShape, markEditedMFHInvestmentCaseInputOrigins, matchModuleOrLot, matchToCondoCompanyName, maybeGetMFHProcessedFields, maybeMakeZeroCosts, mcalc, meetsEfficiencyHouseStage, mergeICTeaserLiveEditableSync, mergeICTeaserSourceData, mergeSavedICTeaserSlideFields, mfhAssetPartnerBuyBoxInputFields, mfhAssetPartnerBuyBoxInputsFormConfig, mfhAssetPartnerProfileFormConfig, mfhAttributesComputedProps, mfhAttributesSystemManagedProps, mfhBuildingStateToHuman, mfhBuildingStatesAlternativeNames, mfhComputedProps, mfhDDv2AnswerSchema, mfhDocumentCheckBankNoteNecessaryStatusTranslation, mfhDocumentCheckStatusTranslation, mfhFolderStructure, mfhInvestmentCaseAssetPartnerInputsFormConfig, mfhInvestmentCaseComputedFields, mfhInvestmentCaseFieldTranslations, mfhInvestmentCaseFieldTranslationsByPath, mfhInvestmentCaseInputsFormConfig, mfhMeasureComponentPrefillRuleNeedsValue, mfhPortfolioPersistedKeys, mfhPortfolioPurchasingMachineOrder, mfhPortfolioStateToHuman, mfhPortfolioStatesAlternativeNames, mfhPriceComputedProps, mfhRegulatoryAnswersFromScreening, mfhRenovationProjectCostBreakdownStateToHuman, mfhRenovationProjectCostBreakdownStatesAlternativeNames, mfhRenovationProjectLotStateToHuman, mfhRenovationProjectLotStatesAlternativeNames, mfhRenovationProjectPlanningModuleStateToHuman, mfhRenovationProjectPositionComputedProps, mfhRenovationProjectStateToHuman, mfhRenovationProjectStatesAlternativeNames, mfhRenovationProjectStatesPlanningModuleAlternativeNames, mfhSourcingMachineOrder, mfhStateToHuman, mfhStatesAlternativeNames, migrateICTeaserEnergyRangeFieldNames, moveICTeaserSelectedListing, multiCalc, normaliseFinalEnergyFromAsset, normalisePrimaryEnergyFromAsset, normalizeAgentReasoningDefaults, normalizeD2GVersionForCalcengine, normalizeDDv2Assessment, normalizeDocumentFolderPath, normalizeICTeaserSelectedListingIds, normalizeICTeaserVisibleCategories, normalizeMFHErvBreakdownConfig, normalizeMFHInvestmentCaseInputPath, normalizeMfhEnergyEfficiencySubsidyInputs, normalizeMfhMeasureComponentPrefill, normalizeMfhScreeningMeasurementsUpdate, normalizeMfhSourcingCriterionUpdates, noteTranslationsMap, objectExaminationDDQuestions, objectToRow, omittedSourcingStates, orderEfficiencyHouseStages, orderPaymentEventsForSchedule, orderedCashflowMilestonesForPredictions, overviewDDAnswerSchema, overviewDDQuestions, packScalarMapping, packTableMapping, parseCondoReference, parseConstructionPlanName, parseD2gVersionFromIcSpreadsheetTitle, parseFloorLocation, parseNumLike, parseRentRollNumericCell, parseRentRollTemplateDateCell, parseScenarioParams, parsedToRawPropName, partitionMFHInvestmentCaseInputs, pendingDefectStatuses, persistableICTeaserEditorSubtitle, pickCandidateMfhInvestmentCase, pickEnvelopeRelationFields, pickRenovationScenarioArchetype, pickTierFee, pmDocumentsColumnFields, portfolioFinancingTriggers, portfolioPurchasingTriggers, portfolioRequiredDocuments, prefillMfhDevelopmentComponentInput, prepareGMAPLink, prepareLocationGMAPLink, priceComputedProps, processStateToRejectionsMap, processStatesForEntity, processTypesForEntity, processTypesTranslation, projectMFHAssetPartnerProfileConfig, protectedDocumentFolderPaths, pruneMFHInvestmentCaseInputOrigins, purchasingDrawdownDocuments, purchasingRequiredDocuments, questionShouldBeEvaluated, raasDocumentTypeCategoryMap, readInvestmentCaseCalcEngineNumber, readInvestmentCaseCalcEngineRawVector, readInvestmentCaseCalcEngineString, readInvestmentCaseCalcEngineVector, readInvestmentCaseSubsidyRateAndGrant, readSyteExpansionComparator, readTotal, readYearly, readYearlyValues, recalculateProfitability, recomputeSyteExpansionAssessment, reconcileICTeaserPrimaryHighlightedLocationKeys, reconcileSalesPackageEventsOfEstate, regenerateICTeaserDocument, regularInvestorLedgerExpenses, removeICTeaserCustomLocation, renovationProjectTriggers, renovationScenarioSchemas, rentAnalysisParametersMatch, rentCaseMapToPlainText, rentDDQuestions, rentIncreaseFormulaExplanations, rentIncreaseFormulaReadableNames, rentIncreaseTypeExplanations, rentIncreaseTypeToRentRoll, rentRollRequiredValidator, rentRollStatusColorMap, rentRollStatusLabels, rentRollToApartmentCondition, rentRollToApartmentType, rentRollToBuildingLocationType, rentRollToCondoSalesCondition, rentRollToFloorLocation, rentRollToRentIncreaseType, rentRollToRentRollStatus, rentRollsFromInputRentRollBlockExtracted, rentSchemas, rentTenancyLedgerStatementLabel, rentableAreaFactorForExpansionType, rentableUnitSchemas, rentableUnitStateFromLatestRentingProcess, rentalContractSchemas, rentalTableColumnDateAt, rentalTableColumnDates, rentingPriorities, rentingProcessSchemas, replaceMFHPartnerProfileInputs, residentialUnitIsInInclusiveBand, resolveAgeAndFacadeWpbCriterion, resolveBaselinePrimaryEnergyConsumption, resolveBaselinePrimaryEnergyOnSourceChange, resolveCalcEngineInputKeyForPath, resolveCalcengineErrorMessageForPersistence, resolveComponentCorrectionFactor, resolveConstructionPlanConditionalByPlanType, resolveDcfGate, resolveDefaultPreCatalogIds, resolveEfficiencyHouseStage, resolveEndDate, resolveHeatingPreCatalogId, resolveICTeaserEditorSubtitle, resolveICTeaserExecutiveSummaryCardTitle, resolveICTeaserHighlightedLocationRows, resolveICTeaserLocationChips, resolveICTeaserLocationParagraphs, resolveICTeaserLocationPois, resolveICTeaserNeighborhoodLocationRows, resolveICTeaserSelectedListingIds, resolveICTeaserSelectedListings, resolveICTeaserTransformationCardTitle, resolveICTeaserVisibleCategories, resolveInvestmentCaseKpiCalcEngineKeys, resolveMFHErvClusterBounds, resolveMFHErvFloorRange, resolveMFHFeeTier, resolveMFHInvestmentCaseInputOriginFromSource, resolveMfhCapexBudgetBucket, resolveMfhCostMarkupFactor, resolvePolymorphicNoteAssociation, resolveRenovationScenarioIfbStandard, resolveRoutePath, resolveScenarioComponents, resolveScenarioHeatingFromAsset, resolveSyteApplyExpansionInputs, returnOrKeepCalculationValues, roundMfhCapexEuroPerM2, ruleValue, safeParseNumLike, salesPortalVisibleFeaturesMetadataOptionLabels, sameMonth, sanitizeICTeaserLocationChips, sanitizeInvestmentCaseJsonTransferPayload, sanityCheckRuleAssignment, selectICTeaserProjectTimelineMilestones, selectedRestrictionsFromICTeaserLocationRestrictions, sellingDataPoints, sellingDocumentsColumnFields, seniorWacc, sepaMandateSchemas, serializeAssignments, serializeRulegroup, serviceChargeDistributionKeyLabels, setICTeaserHighlightedLocationKeyForCategory, setICTeaserHighlightedLocationKeysForCategory, setICTeaserListingSelected, setICTeaserLocationCategoryVisible, setICTeaserLocationHighlightsForCategory, setICTeaserPrimaryLocationKeyForCategory, shortlistExcludedProcesses, shouldShareWithPartner, slideHasMissingICTeaserData, sortConstructionPlanComponentLettersForName, sortICTeaserRentListingsByPhotoThenDistance, sortObject, sortValuesBy, sourcingStatesEstateInsideOfTheOperationsTeamFunnel, sourcingStatesToReScore, sourcingTasksDDAnswerSchema, sourcingTasksDDEvaluationTranslation, sourcingTasksDDQuestions, specialDealHints, splitConstructionPlanSectionPlanes, splitLegacyScenarioComponents, stateToHuman, statesAlternativeNames, statusPath, suggestMfhRegulatoryAnswers, suggestMfhScreeningRejectionReason, sumResidentialUnitInclusiveCostBands, supplementalDataDefectEvents, syncMfhDevelopmentComponentInputQuantity, tableAnchorLink, tableCellFormatter, taskToMilestoneExpectedDate, taskToMilestoneStatus, taskTriggers, teaserHtmlPlainText, technicalDDQuestions, technicalOnSiteChecklistGroups, technicalOnSiteDDAnswerSchema, technicalOnSiteDDQuestions, templateMatchesMandate, tenantFaqCategoryIconMapper, tenantFaqQuestionMapper, tenantSupportCategoryTranslation, tenantSupportSubCategoryTranslation, tenderingProcessStateToHuman, tenderingProcessStatesAlternativeNames, toCalcEngineInputs, toCalcEngineInputsForTargets, toCalcEngineRequest, toCalcEngineRequestFromInvestmentCase, toEditableICTeaserMedia, toICTeaserEditablePath, toLegacySpreadsheetOutputs, toNestedMFHInvestmentCaseInputs, toRentMarketListedSinceQuery, toSpreadsheetInputsForTargets, totalNumberOfUnits, totalRentableSpace, transactionsMap, transformParsedSpreadsheetObjectToCompressedTriples, transformPurchasingInspectionQuestionAnswer, transformSourcingEstateToDiscovererEstate, transformValueObjectToCompressedTriples, translateCommonRooms, translateCraft, translateCraftToIndex, translateDocument, translateDocumentCategory, translateRentCase, translateStoreRooms, typesenseCollectionToPermissionMap, unpackMapping, updateICTeaserDocument, userConfirmationTranslations, vacantRentingStates, validateCreateMFHRenovationPositionsData, validateDocumentName, validateMFHErvBreakdownConfig, validateMfhPortfolioMfhCandidateAssetPartners, validateRuleAssignmentsNotOverlapping, validateScenarioParams, vicinityExaminationDDQuestions, waccTotal, withAttributePath, withPreviewOutputCellPaths, withStaticGMapsSize, withoutMFHInvestmentCaseScenarioOwnedOverrides, withoutStaleMFHPartnerProfileInputs, workflowDDStatusConfig };

//# sourceMappingURL=index.mjs.map